import * as React from 'react';
import React__default, { PureComponent, useLayoutEffect as useLayoutEffect$1, useEffect, useMemo, useContext, useDebugValue, useReducer, useRef, forwardRef, createContext, useState, Fragment, createRef, useCallback, isValidElement, cloneElement, createElement } from 'react';
import PropTypes from 'prop-types';
import ReactDOM, { unstable_batchedUpdates, createPortal, flushSync } from 'react-dom';

function _typeof$6(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$6 = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$6 = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof$6(obj);
}
function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$1(Constructor, staticProps);
  return Constructor;
}
function _possibleConstructorReturn$1(self, call) {
  if (call && (_typeof$6(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized$1(self);
}
function _getPrototypeOf$2(o) {
  _getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$2(o);
}
function _assertThisInitialized$1(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _inherits$1(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$3(subClass, superClass);
}
function _setPrototypeOf$3(o, p) {
  _setPrototypeOf$3 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf$3(o, p);
}
function _defineProperty$6(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var PersistGate = /*#__PURE__*/
function (_PureComponent) {
  _inherits$1(PersistGate, _PureComponent);
  function PersistGate() {
    var _getPrototypeOf2;
    var _this;
    _classCallCheck$1(this, PersistGate);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _possibleConstructorReturn$1(this, (_getPrototypeOf2 = _getPrototypeOf$2(PersistGate)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _defineProperty$6(_assertThisInitialized$1(_this), "state", {
      bootstrapped: false
    });
    _defineProperty$6(_assertThisInitialized$1(_this), "_unsubscribe", void 0);
    _defineProperty$6(_assertThisInitialized$1(_this), "handlePersistorState", function () {
      var persistor = _this.props.persistor;
      var _persistor$getState = persistor.getState(),
        bootstrapped = _persistor$getState.bootstrapped;
      if (bootstrapped) {
        if (_this.props.onBeforeLift) {
          Promise.resolve(_this.props.onBeforeLift()).finally(function () {
            return _this.setState({
              bootstrapped: true
            });
          });
        } else {
          _this.setState({
            bootstrapped: true
          });
        }
        _this._unsubscribe && _this._unsubscribe();
      }
    });
    return _this;
  }
  _createClass$1(PersistGate, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._unsubscribe = this.props.persistor.subscribe(this.handlePersistorState);
      this.handlePersistorState();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._unsubscribe && this._unsubscribe();
    }
  }, {
    key: "render",
    value: function render() {
      if (process.env.NODE_ENV !== 'production') {
        if (typeof this.props.children === 'function' && this.props.loading) console.error('redux-persist: PersistGate expects either a function child or loading prop, but not both. The loading prop will be ignored.');
      }
      if (typeof this.props.children === 'function') {
        return this.props.children(this.state.bootstrapped);
      }
      return this.state.bootstrapped ? this.props.children : this.props.loading;
    }
  }]);
  return PersistGate;
}(PureComponent);
_defineProperty$6(PersistGate, "defaultProps", {
  children: null,
  loading: null
});

var ReactReduxContext = /*#__PURE__*/React__default.createContext(null);
if (process.env.NODE_ENV !== 'production') {
  ReactReduxContext.displayName = 'ReactRedux';
}

// Default to a dummy "batch" implementation that just runs the callback
function defaultNoopBatch(callback) {
  callback();
}
var batch = defaultNoopBatch; // Allow injecting another batching function later

var setBatch = function setBatch(newBatch) {
  return batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings

var getBatch = function getBatch() {
  return batch;
};

// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

function createListenerCollection() {
  var batch = getBatch();
  var first = null;
  var last = null;
  return {
    clear: function clear() {
      first = null;
      last = null;
    },
    notify: function notify() {
      batch(function () {
        var listener = first;
        while (listener) {
          listener.callback();
          listener = listener.next;
        }
      });
    },
    get: function get() {
      var listeners = [];
      var listener = first;
      while (listener) {
        listeners.push(listener);
        listener = listener.next;
      }
      return listeners;
    },
    subscribe: function subscribe(callback) {
      var isSubscribed = true;
      var listener = last = {
        callback: callback,
        next: null,
        prev: last
      };
      if (listener.prev) {
        listener.prev.next = listener;
      } else {
        first = listener;
      }
      return function unsubscribe() {
        if (!isSubscribed || first === null) return;
        isSubscribed = false;
        if (listener.next) {
          listener.next.prev = listener.prev;
        } else {
          last = listener.prev;
        }
        if (listener.prev) {
          listener.prev.next = listener.next;
        } else {
          first = listener.next;
        }
      };
    }
  };
}
var nullListeners = {
  notify: function notify() {},
  get: function get() {
    return [];
  }
};
function createSubscription(store, parentSub) {
  var unsubscribe;
  var listeners = nullListeners;
  function addNestedSub(listener) {
    trySubscribe();
    return listeners.subscribe(listener);
  }
  function notifyNestedSubs() {
    listeners.notify();
  }
  function handleChangeWrapper() {
    if (subscription.onStateChange) {
      subscription.onStateChange();
    }
  }
  function isSubscribed() {
    return Boolean(unsubscribe);
  }
  function trySubscribe() {
    if (!unsubscribe) {
      unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
      listeners = createListenerCollection();
    }
  }
  function tryUnsubscribe() {
    if (unsubscribe) {
      unsubscribe();
      unsubscribe = undefined;
      listeners.clear();
      listeners = nullListeners;
    }
  }
  var subscription = {
    addNestedSub: addNestedSub,
    notifyNestedSubs: notifyNestedSubs,
    handleChangeWrapper: handleChangeWrapper,
    isSubscribed: isSubscribed,
    trySubscribe: trySubscribe,
    tryUnsubscribe: tryUnsubscribe,
    getListeners: function getListeners() {
      return listeners;
    }
  };
  return subscription;
}

// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser. We need useLayoutEffect to ensure the store
// subscription callback always has the selector from the latest render commit
// available, otherwise a store update may happen between render and the effect,
// which may cause missed updates; we also must ensure the store subscription
// is created synchronously, otherwise a store update may occur before the
// subscription is created and an inconsistent state may be observed

var useIsomorphicLayoutEffect$2 = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? useLayoutEffect$1 : useEffect;

function Provider(_ref) {
  var store = _ref.store,
    context = _ref.context,
    children = _ref.children;
  var contextValue = useMemo(function () {
    var subscription = createSubscription(store);
    return {
      store: store,
      subscription: subscription
    };
  }, [store]);
  var previousState = useMemo(function () {
    return store.getState();
  }, [store]);
  useIsomorphicLayoutEffect$2(function () {
    var subscription = contextValue.subscription;
    subscription.onStateChange = subscription.notifyNestedSubs;
    subscription.trySubscribe();
    if (previousState !== store.getState()) {
      subscription.notifyNestedSubs();
    }
    return function () {
      subscription.tryUnsubscribe();
      subscription.onStateChange = null;
    };
  }, [contextValue, previousState]);
  var Context = context || ReactReduxContext;
  return /*#__PURE__*/React__default.createElement(Context.Provider, {
    value: contextValue
  }, children);
}
if (process.env.NODE_ENV !== 'production') {
  Provider.propTypes = {
    store: PropTypes.shape({
      subscribe: PropTypes.func.isRequired,
      dispatch: PropTypes.func.isRequired,
      getState: PropTypes.func.isRequired
    }),
    context: PropTypes.object,
    children: PropTypes.any
  };
}

function _extends$8() {
  return _extends$8 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$8.apply(null, arguments);
}

var commonjsGlobal$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var reactIs$5 = {exports: {}};

var reactIs_production_min$3 = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min$1;

function requireReactIs_production_min$1 () {
	if (hasRequiredReactIs_production_min$1) return reactIs_production_min$3;
	hasRequiredReactIs_production_min$1 = 1;

	var b = "function" === typeof Symbol && Symbol.for,
	  c = b ? Symbol.for("react.element") : 60103,
	  d = b ? Symbol.for("react.portal") : 60106,
	  e = b ? Symbol.for("react.fragment") : 60107,
	  f = b ? Symbol.for("react.strict_mode") : 60108,
	  g = b ? Symbol.for("react.profiler") : 60114,
	  h = b ? Symbol.for("react.provider") : 60109,
	  k = b ? Symbol.for("react.context") : 60110,
	  l = b ? Symbol.for("react.async_mode") : 60111,
	  m = b ? Symbol.for("react.concurrent_mode") : 60111,
	  n = b ? Symbol.for("react.forward_ref") : 60112,
	  p = b ? Symbol.for("react.suspense") : 60113,
	  q = b ? Symbol.for("react.suspense_list") : 60120,
	  r = b ? Symbol.for("react.memo") : 60115,
	  t = b ? Symbol.for("react.lazy") : 60116,
	  v = b ? Symbol.for("react.block") : 60121,
	  w = b ? Symbol.for("react.fundamental") : 60117,
	  x = b ? Symbol.for("react.responder") : 60118,
	  y = b ? Symbol.for("react.scope") : 60119;
	function z(a) {
	  if ("object" === typeof a && null !== a) {
	    var u = a.$$typeof;
	    switch (u) {
	      case c:
	        switch (a = a.type, a) {
	          case l:
	          case m:
	          case e:
	          case g:
	          case f:
	          case p:
	            return a;
	          default:
	            switch (a = a && a.$$typeof, a) {
	              case k:
	              case n:
	              case t:
	              case r:
	              case h:
	                return a;
	              default:
	                return u;
	            }
	        }
	      case d:
	        return u;
	    }
	  }
	}
	function A(a) {
	  return z(a) === m;
	}
	reactIs_production_min$3.AsyncMode = l;
	reactIs_production_min$3.ConcurrentMode = m;
	reactIs_production_min$3.ContextConsumer = k;
	reactIs_production_min$3.ContextProvider = h;
	reactIs_production_min$3.Element = c;
	reactIs_production_min$3.ForwardRef = n;
	reactIs_production_min$3.Fragment = e;
	reactIs_production_min$3.Lazy = t;
	reactIs_production_min$3.Memo = r;
	reactIs_production_min$3.Portal = d;
	reactIs_production_min$3.Profiler = g;
	reactIs_production_min$3.StrictMode = f;
	reactIs_production_min$3.Suspense = p;
	reactIs_production_min$3.isAsyncMode = function (a) {
	  return A(a) || z(a) === l;
	};
	reactIs_production_min$3.isConcurrentMode = A;
	reactIs_production_min$3.isContextConsumer = function (a) {
	  return z(a) === k;
	};
	reactIs_production_min$3.isContextProvider = function (a) {
	  return z(a) === h;
	};
	reactIs_production_min$3.isElement = function (a) {
	  return "object" === typeof a && null !== a && a.$$typeof === c;
	};
	reactIs_production_min$3.isForwardRef = function (a) {
	  return z(a) === n;
	};
	reactIs_production_min$3.isFragment = function (a) {
	  return z(a) === e;
	};
	reactIs_production_min$3.isLazy = function (a) {
	  return z(a) === t;
	};
	reactIs_production_min$3.isMemo = function (a) {
	  return z(a) === r;
	};
	reactIs_production_min$3.isPortal = function (a) {
	  return z(a) === d;
	};
	reactIs_production_min$3.isProfiler = function (a) {
	  return z(a) === g;
	};
	reactIs_production_min$3.isStrictMode = function (a) {
	  return z(a) === f;
	};
	reactIs_production_min$3.isSuspense = function (a) {
	  return z(a) === p;
	};
	reactIs_production_min$3.isValidElementType = function (a) {
	  return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
	};
	reactIs_production_min$3.typeOf = z;
	return reactIs_production_min$3;
}

var reactIs_development$3 = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development$1;

function requireReactIs_development$1 () {
	if (hasRequiredReactIs_development$1) return reactIs_development$3;
	hasRequiredReactIs_development$1 = 1;

	if (process.env.NODE_ENV !== "production") {
	  (function () {

	    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
	    // nor polyfill, then a plain number is used for performance.
	    var hasSymbol = typeof Symbol === 'function' && Symbol.for;
	    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
	    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
	    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
	    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
	    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
	    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
	    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
	    // (unstable) APIs that have been removed. Can we remove the symbols?

	    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
	    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
	    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
	    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
	    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
	    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
	    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
	    var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
	    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
	    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
	    var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
	    function isValidElementType(type) {
	      return typeof type === 'string' || typeof type === 'function' ||
	      // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
	      type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
	    }
	    function typeOf(object) {
	      if (typeof object === 'object' && object !== null) {
	        var $$typeof = object.$$typeof;
	        switch ($$typeof) {
	          case REACT_ELEMENT_TYPE:
	            var type = object.type;
	            switch (type) {
	              case REACT_ASYNC_MODE_TYPE:
	              case REACT_CONCURRENT_MODE_TYPE:
	              case REACT_FRAGMENT_TYPE:
	              case REACT_PROFILER_TYPE:
	              case REACT_STRICT_MODE_TYPE:
	              case REACT_SUSPENSE_TYPE:
	                return type;
	              default:
	                var $$typeofType = type && type.$$typeof;
	                switch ($$typeofType) {
	                  case REACT_CONTEXT_TYPE:
	                  case REACT_FORWARD_REF_TYPE:
	                  case REACT_LAZY_TYPE:
	                  case REACT_MEMO_TYPE:
	                  case REACT_PROVIDER_TYPE:
	                    return $$typeofType;
	                  default:
	                    return $$typeof;
	                }
	            }
	          case REACT_PORTAL_TYPE:
	            return $$typeof;
	        }
	      }
	      return undefined;
	    } // AsyncMode is deprecated along with isAsyncMode

	    var AsyncMode = REACT_ASYNC_MODE_TYPE;
	    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
	    var ContextConsumer = REACT_CONTEXT_TYPE;
	    var ContextProvider = REACT_PROVIDER_TYPE;
	    var Element = REACT_ELEMENT_TYPE;
	    var ForwardRef = REACT_FORWARD_REF_TYPE;
	    var Fragment = REACT_FRAGMENT_TYPE;
	    var Lazy = REACT_LAZY_TYPE;
	    var Memo = REACT_MEMO_TYPE;
	    var Portal = REACT_PORTAL_TYPE;
	    var Profiler = REACT_PROFILER_TYPE;
	    var StrictMode = REACT_STRICT_MODE_TYPE;
	    var Suspense = REACT_SUSPENSE_TYPE;
	    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

	    function isAsyncMode(object) {
	      {
	        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	          hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

	          console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
	        }
	      }
	      return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
	    }
	    function isConcurrentMode(object) {
	      return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
	    }
	    function isContextConsumer(object) {
	      return typeOf(object) === REACT_CONTEXT_TYPE;
	    }
	    function isContextProvider(object) {
	      return typeOf(object) === REACT_PROVIDER_TYPE;
	    }
	    function isElement(object) {
	      return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	    }
	    function isForwardRef(object) {
	      return typeOf(object) === REACT_FORWARD_REF_TYPE;
	    }
	    function isFragment(object) {
	      return typeOf(object) === REACT_FRAGMENT_TYPE;
	    }
	    function isLazy(object) {
	      return typeOf(object) === REACT_LAZY_TYPE;
	    }
	    function isMemo(object) {
	      return typeOf(object) === REACT_MEMO_TYPE;
	    }
	    function isPortal(object) {
	      return typeOf(object) === REACT_PORTAL_TYPE;
	    }
	    function isProfiler(object) {
	      return typeOf(object) === REACT_PROFILER_TYPE;
	    }
	    function isStrictMode(object) {
	      return typeOf(object) === REACT_STRICT_MODE_TYPE;
	    }
	    function isSuspense(object) {
	      return typeOf(object) === REACT_SUSPENSE_TYPE;
	    }
	    reactIs_development$3.AsyncMode = AsyncMode;
	    reactIs_development$3.ConcurrentMode = ConcurrentMode;
	    reactIs_development$3.ContextConsumer = ContextConsumer;
	    reactIs_development$3.ContextProvider = ContextProvider;
	    reactIs_development$3.Element = Element;
	    reactIs_development$3.ForwardRef = ForwardRef;
	    reactIs_development$3.Fragment = Fragment;
	    reactIs_development$3.Lazy = Lazy;
	    reactIs_development$3.Memo = Memo;
	    reactIs_development$3.Portal = Portal;
	    reactIs_development$3.Profiler = Profiler;
	    reactIs_development$3.StrictMode = StrictMode;
	    reactIs_development$3.Suspense = Suspense;
	    reactIs_development$3.isAsyncMode = isAsyncMode;
	    reactIs_development$3.isConcurrentMode = isConcurrentMode;
	    reactIs_development$3.isContextConsumer = isContextConsumer;
	    reactIs_development$3.isContextProvider = isContextProvider;
	    reactIs_development$3.isElement = isElement;
	    reactIs_development$3.isForwardRef = isForwardRef;
	    reactIs_development$3.isFragment = isFragment;
	    reactIs_development$3.isLazy = isLazy;
	    reactIs_development$3.isMemo = isMemo;
	    reactIs_development$3.isPortal = isPortal;
	    reactIs_development$3.isProfiler = isProfiler;
	    reactIs_development$3.isStrictMode = isStrictMode;
	    reactIs_development$3.isSuspense = isSuspense;
	    reactIs_development$3.isValidElementType = isValidElementType;
	    reactIs_development$3.typeOf = typeOf;
	  })();
	}
	return reactIs_development$3;
}

(function (module) {

	if (process.env.NODE_ENV === 'production') {
	  module.exports = requireReactIs_production_min$1();
	} else {
	  module.exports = requireReactIs_development$1();
	}
} (reactIs$5));

var reactIs$4 = reactIs$5.exports;
var FORWARD_REF_STATICS$1 = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS$1 = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS$1 = {};
TYPE_STATICS$1[reactIs$4.ForwardRef] = FORWARD_REF_STATICS$1;
TYPE_STATICS$1[reactIs$4.Memo] = MEMO_STATICS$1;

var reactIs$3 = {exports: {}};

var reactIs_production_min$2 = {};

/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min;

function requireReactIs_production_min () {
	if (hasRequiredReactIs_production_min) return reactIs_production_min$2;
	hasRequiredReactIs_production_min = 1;

	var b = 60103,
	  c = 60106,
	  d = 60107,
	  e = 60108,
	  f = 60114,
	  g = 60109,
	  h = 60110,
	  k = 60112,
	  l = 60113,
	  m = 60120,
	  n = 60115,
	  p = 60116,
	  q = 60121,
	  r = 60122,
	  u = 60117,
	  v = 60129,
	  w = 60131;
	if ("function" === typeof Symbol && Symbol.for) {
	  var x = Symbol.for;
	  b = x("react.element");
	  c = x("react.portal");
	  d = x("react.fragment");
	  e = x("react.strict_mode");
	  f = x("react.profiler");
	  g = x("react.provider");
	  h = x("react.context");
	  k = x("react.forward_ref");
	  l = x("react.suspense");
	  m = x("react.suspense_list");
	  n = x("react.memo");
	  p = x("react.lazy");
	  q = x("react.block");
	  r = x("react.server.block");
	  u = x("react.fundamental");
	  v = x("react.debug_trace_mode");
	  w = x("react.legacy_hidden");
	}
	function y(a) {
	  if ("object" === typeof a && null !== a) {
	    var t = a.$$typeof;
	    switch (t) {
	      case b:
	        switch (a = a.type, a) {
	          case d:
	          case f:
	          case e:
	          case l:
	          case m:
	            return a;
	          default:
	            switch (a = a && a.$$typeof, a) {
	              case h:
	              case k:
	              case p:
	              case n:
	              case g:
	                return a;
	              default:
	                return t;
	            }
	        }
	      case c:
	        return t;
	    }
	  }
	}
	var z = g,
	  A = b,
	  B = k,
	  C = d,
	  D = p,
	  E = n,
	  F = c,
	  G = f,
	  H = e,
	  I = l;
	reactIs_production_min$2.ContextConsumer = h;
	reactIs_production_min$2.ContextProvider = z;
	reactIs_production_min$2.Element = A;
	reactIs_production_min$2.ForwardRef = B;
	reactIs_production_min$2.Fragment = C;
	reactIs_production_min$2.Lazy = D;
	reactIs_production_min$2.Memo = E;
	reactIs_production_min$2.Portal = F;
	reactIs_production_min$2.Profiler = G;
	reactIs_production_min$2.StrictMode = H;
	reactIs_production_min$2.Suspense = I;
	reactIs_production_min$2.isAsyncMode = function () {
	  return !1;
	};
	reactIs_production_min$2.isConcurrentMode = function () {
	  return !1;
	};
	reactIs_production_min$2.isContextConsumer = function (a) {
	  return y(a) === h;
	};
	reactIs_production_min$2.isContextProvider = function (a) {
	  return y(a) === g;
	};
	reactIs_production_min$2.isElement = function (a) {
	  return "object" === typeof a && null !== a && a.$$typeof === b;
	};
	reactIs_production_min$2.isForwardRef = function (a) {
	  return y(a) === k;
	};
	reactIs_production_min$2.isFragment = function (a) {
	  return y(a) === d;
	};
	reactIs_production_min$2.isLazy = function (a) {
	  return y(a) === p;
	};
	reactIs_production_min$2.isMemo = function (a) {
	  return y(a) === n;
	};
	reactIs_production_min$2.isPortal = function (a) {
	  return y(a) === c;
	};
	reactIs_production_min$2.isProfiler = function (a) {
	  return y(a) === f;
	};
	reactIs_production_min$2.isStrictMode = function (a) {
	  return y(a) === e;
	};
	reactIs_production_min$2.isSuspense = function (a) {
	  return y(a) === l;
	};
	reactIs_production_min$2.isValidElementType = function (a) {
	  return "string" === typeof a || "function" === typeof a || a === d || a === f || a === v || a === e || a === l || a === m || a === w || "object" === typeof a && null !== a && (a.$$typeof === p || a.$$typeof === n || a.$$typeof === g || a.$$typeof === h || a.$$typeof === k || a.$$typeof === u || a.$$typeof === q || a[0] === r) ? !0 : !1;
	};
	reactIs_production_min$2.typeOf = y;
	return reactIs_production_min$2;
}

var reactIs_development$2 = {};

/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development;

function requireReactIs_development () {
	if (hasRequiredReactIs_development) return reactIs_development$2;
	hasRequiredReactIs_development = 1;

	if (process.env.NODE_ENV !== "production") {
	  (function () {

	    // ATTENTION
	    // When adding new symbols to this file,
	    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
	    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
	    // nor polyfill, then a plain number is used for performance.
	    var REACT_ELEMENT_TYPE = 0xeac7;
	    var REACT_PORTAL_TYPE = 0xeaca;
	    var REACT_FRAGMENT_TYPE = 0xeacb;
	    var REACT_STRICT_MODE_TYPE = 0xeacc;
	    var REACT_PROFILER_TYPE = 0xead2;
	    var REACT_PROVIDER_TYPE = 0xeacd;
	    var REACT_CONTEXT_TYPE = 0xeace;
	    var REACT_FORWARD_REF_TYPE = 0xead0;
	    var REACT_SUSPENSE_TYPE = 0xead1;
	    var REACT_SUSPENSE_LIST_TYPE = 0xead8;
	    var REACT_MEMO_TYPE = 0xead3;
	    var REACT_LAZY_TYPE = 0xead4;
	    var REACT_BLOCK_TYPE = 0xead9;
	    var REACT_SERVER_BLOCK_TYPE = 0xeada;
	    var REACT_FUNDAMENTAL_TYPE = 0xead5;
	    var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
	    var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;
	    if (typeof Symbol === 'function' && Symbol.for) {
	      var symbolFor = Symbol.for;
	      REACT_ELEMENT_TYPE = symbolFor('react.element');
	      REACT_PORTAL_TYPE = symbolFor('react.portal');
	      REACT_FRAGMENT_TYPE = symbolFor('react.fragment');
	      REACT_STRICT_MODE_TYPE = symbolFor('react.strict_mode');
	      REACT_PROFILER_TYPE = symbolFor('react.profiler');
	      REACT_PROVIDER_TYPE = symbolFor('react.provider');
	      REACT_CONTEXT_TYPE = symbolFor('react.context');
	      REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
	      REACT_SUSPENSE_TYPE = symbolFor('react.suspense');
	      REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
	      REACT_MEMO_TYPE = symbolFor('react.memo');
	      REACT_LAZY_TYPE = symbolFor('react.lazy');
	      REACT_BLOCK_TYPE = symbolFor('react.block');
	      REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
	      REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
	      symbolFor('react.scope');
	      symbolFor('react.opaque.id');
	      REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
	      symbolFor('react.offscreen');
	      REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
	    }

	    // Filter certain DOM attributes (e.g. src, href) if their values are empty strings.

	    var enableScopeAPI = false; // Experimental Create Event Handle API.

	    function isValidElementType(type) {
	      if (typeof type === 'string' || typeof type === 'function') {
	        return true;
	      } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).

	      if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_DEBUG_TRACING_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI) {
	        return true;
	      }
	      if (typeof type === 'object' && type !== null) {
	        if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) {
	          return true;
	        }
	      }
	      return false;
	    }
	    function typeOf(object) {
	      if (typeof object === 'object' && object !== null) {
	        var $$typeof = object.$$typeof;
	        switch ($$typeof) {
	          case REACT_ELEMENT_TYPE:
	            var type = object.type;
	            switch (type) {
	              case REACT_FRAGMENT_TYPE:
	              case REACT_PROFILER_TYPE:
	              case REACT_STRICT_MODE_TYPE:
	              case REACT_SUSPENSE_TYPE:
	              case REACT_SUSPENSE_LIST_TYPE:
	                return type;
	              default:
	                var $$typeofType = type && type.$$typeof;
	                switch ($$typeofType) {
	                  case REACT_CONTEXT_TYPE:
	                  case REACT_FORWARD_REF_TYPE:
	                  case REACT_LAZY_TYPE:
	                  case REACT_MEMO_TYPE:
	                  case REACT_PROVIDER_TYPE:
	                    return $$typeofType;
	                  default:
	                    return $$typeof;
	                }
	            }
	          case REACT_PORTAL_TYPE:
	            return $$typeof;
	        }
	      }
	      return undefined;
	    }
	    var ContextConsumer = REACT_CONTEXT_TYPE;
	    var ContextProvider = REACT_PROVIDER_TYPE;
	    var Element = REACT_ELEMENT_TYPE;
	    var ForwardRef = REACT_FORWARD_REF_TYPE;
	    var Fragment = REACT_FRAGMENT_TYPE;
	    var Lazy = REACT_LAZY_TYPE;
	    var Memo = REACT_MEMO_TYPE;
	    var Portal = REACT_PORTAL_TYPE;
	    var Profiler = REACT_PROFILER_TYPE;
	    var StrictMode = REACT_STRICT_MODE_TYPE;
	    var Suspense = REACT_SUSPENSE_TYPE;
	    var hasWarnedAboutDeprecatedIsAsyncMode = false;
	    var hasWarnedAboutDeprecatedIsConcurrentMode = false; // AsyncMode should be deprecated

	    function isAsyncMode(object) {
	      {
	        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	          hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

	          console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
	        }
	      }
	      return false;
	    }
	    function isConcurrentMode(object) {
	      {
	        if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
	          hasWarnedAboutDeprecatedIsConcurrentMode = true; // Using console['warn'] to evade Babel and ESLint

	          console['warn']('The ReactIs.isConcurrentMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
	        }
	      }
	      return false;
	    }
	    function isContextConsumer(object) {
	      return typeOf(object) === REACT_CONTEXT_TYPE;
	    }
	    function isContextProvider(object) {
	      return typeOf(object) === REACT_PROVIDER_TYPE;
	    }
	    function isElement(object) {
	      return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	    }
	    function isForwardRef(object) {
	      return typeOf(object) === REACT_FORWARD_REF_TYPE;
	    }
	    function isFragment(object) {
	      return typeOf(object) === REACT_FRAGMENT_TYPE;
	    }
	    function isLazy(object) {
	      return typeOf(object) === REACT_LAZY_TYPE;
	    }
	    function isMemo(object) {
	      return typeOf(object) === REACT_MEMO_TYPE;
	    }
	    function isPortal(object) {
	      return typeOf(object) === REACT_PORTAL_TYPE;
	    }
	    function isProfiler(object) {
	      return typeOf(object) === REACT_PROFILER_TYPE;
	    }
	    function isStrictMode(object) {
	      return typeOf(object) === REACT_STRICT_MODE_TYPE;
	    }
	    function isSuspense(object) {
	      return typeOf(object) === REACT_SUSPENSE_TYPE;
	    }
	    reactIs_development$2.ContextConsumer = ContextConsumer;
	    reactIs_development$2.ContextProvider = ContextProvider;
	    reactIs_development$2.Element = Element;
	    reactIs_development$2.ForwardRef = ForwardRef;
	    reactIs_development$2.Fragment = Fragment;
	    reactIs_development$2.Lazy = Lazy;
	    reactIs_development$2.Memo = Memo;
	    reactIs_development$2.Portal = Portal;
	    reactIs_development$2.Profiler = Profiler;
	    reactIs_development$2.StrictMode = StrictMode;
	    reactIs_development$2.Suspense = Suspense;
	    reactIs_development$2.isAsyncMode = isAsyncMode;
	    reactIs_development$2.isConcurrentMode = isConcurrentMode;
	    reactIs_development$2.isContextConsumer = isContextConsumer;
	    reactIs_development$2.isContextProvider = isContextProvider;
	    reactIs_development$2.isElement = isElement;
	    reactIs_development$2.isForwardRef = isForwardRef;
	    reactIs_development$2.isFragment = isFragment;
	    reactIs_development$2.isLazy = isLazy;
	    reactIs_development$2.isMemo = isMemo;
	    reactIs_development$2.isPortal = isPortal;
	    reactIs_development$2.isProfiler = isProfiler;
	    reactIs_development$2.isStrictMode = isStrictMode;
	    reactIs_development$2.isSuspense = isSuspense;
	    reactIs_development$2.isValidElementType = isValidElementType;
	    reactIs_development$2.typeOf = typeOf;
	  })();
	}
	return reactIs_development$2;
}

(function (module) {

	if (process.env.NODE_ENV === 'production') {
	  module.exports = requireReactIs_production_min();
	} else {
	  module.exports = requireReactIs_development();
	}
} (reactIs$3));

/**
 * A hook to access the value of the `ReactReduxContext`. This is a low-level
 * hook that you should usually not need to call directly.
 *
 * @returns {any} the value of the `ReactReduxContext`
 *
 * @example
 *
 * import React from 'react'
 * import { useReduxContext } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const { store } = useReduxContext()
 *   return <div>{store.getState()}</div>
 * }
 */

function useReduxContext() {
  var contextValue = useContext(ReactReduxContext);
  if (process.env.NODE_ENV !== 'production' && !contextValue) {
    throw new Error('could not find react-redux context value; please ensure the component is wrapped in a <Provider>');
  }
  return contextValue;
}

/**
 * Hook factory, which creates a `useStore` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useStore` hook bound to the specified context.
 */

function createStoreHook(context) {
  if (context === void 0) {
    context = ReactReduxContext;
  }
  var useReduxContext$1 = context === ReactReduxContext ? useReduxContext : function () {
    return useContext(context);
  };
  return function useStore() {
    var _useReduxContext = useReduxContext$1(),
      store = _useReduxContext.store;
    return store;
  };
}
/**
 * A hook to access the redux store.
 *
 * @returns {any} the redux store
 *
 * @example
 *
 * import React from 'react'
 * import { useStore } from 'react-redux'
 *
 * export const ExampleComponent = () => {
 *   const store = useStore()
 *   return <div>{store.getState()}</div>
 * }
 */

var useStore = /*#__PURE__*/createStoreHook();

/**
 * Hook factory, which creates a `useDispatch` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useDispatch` hook bound to the specified context.
 */

function createDispatchHook(context) {
  if (context === void 0) {
    context = ReactReduxContext;
  }
  var useStore$1 = context === ReactReduxContext ? useStore : createStoreHook(context);
  return function useDispatch() {
    var store = useStore$1();
    return store.dispatch;
  };
}
/**
 * A hook to access the redux `dispatch` function.
 *
 * @returns {any|function} redux store's `dispatch` function
 *
 * @example
 *
 * import React, { useCallback } from 'react'
 * import { useDispatch } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const dispatch = useDispatch()
 *   const increaseCounter = useCallback(() => dispatch({ type: 'increase-counter' }), [])
 *   return (
 *     <div>
 *       <span>{value}</span>
 *       <button onClick={increaseCounter}>Increase counter</button>
 *     </div>
 *   )
 * }
 */

var useDispatch = /*#__PURE__*/createDispatchHook();

var refEquality = function refEquality(a, b) {
  return a === b;
};
function useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
  var _useReducer = useReducer(function (s) {
      return s + 1;
    }, 0),
    forceRender = _useReducer[1];
  var subscription = useMemo(function () {
    return createSubscription(store, contextSub);
  }, [store, contextSub]);
  var latestSubscriptionCallbackError = useRef();
  var latestSelector = useRef();
  var latestStoreState = useRef();
  var latestSelectedState = useRef();
  var storeState = store.getState();
  var selectedState;
  try {
    if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
      var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references

      if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) {
        selectedState = newSelectedState;
      } else {
        selectedState = latestSelectedState.current;
      }
    } else {
      selectedState = latestSelectedState.current;
    }
  } catch (err) {
    if (latestSubscriptionCallbackError.current) {
      err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
    }
    throw err;
  }
  useIsomorphicLayoutEffect$2(function () {
    latestSelector.current = selector;
    latestStoreState.current = storeState;
    latestSelectedState.current = selectedState;
    latestSubscriptionCallbackError.current = undefined;
  });
  useIsomorphicLayoutEffect$2(function () {
    function checkForUpdates() {
      try {
        var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed

        if (newStoreState === latestStoreState.current) {
          return;
        }
        var _newSelectedState = latestSelector.current(newStoreState);
        if (equalityFn(_newSelectedState, latestSelectedState.current)) {
          return;
        }
        latestSelectedState.current = _newSelectedState;
        latestStoreState.current = newStoreState;
      } catch (err) {
        // we ignore all errors here, since when the component
        // is re-rendered, the selectors are called again, and
        // will throw again, if neither props nor store state
        // changed
        latestSubscriptionCallbackError.current = err;
      }
      forceRender();
    }
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    return function () {
      return subscription.tryUnsubscribe();
    };
  }, [store, subscription]);
  return selectedState;
}
/**
 * Hook factory, which creates a `useSelector` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useSelector` hook bound to the specified context.
 */

function createSelectorHook(context) {
  if (context === void 0) {
    context = ReactReduxContext;
  }
  var useReduxContext$1 = context === ReactReduxContext ? useReduxContext : function () {
    return useContext(context);
  };
  return function useSelector(selector, equalityFn) {
    if (equalityFn === void 0) {
      equalityFn = refEquality;
    }
    if (process.env.NODE_ENV !== 'production') {
      if (!selector) {
        throw new Error("You must pass a selector to useSelector");
      }
      if (typeof selector !== 'function') {
        throw new Error("You must pass a function as a selector to useSelector");
      }
      if (typeof equalityFn !== 'function') {
        throw new Error("You must pass a function as an equality function to useSelector");
      }
    }
    var _useReduxContext = useReduxContext$1(),
      store = _useReduxContext.store,
      contextSub = _useReduxContext.subscription;
    var selectedState = useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
    useDebugValue(selectedState);
    return selectedState;
  };
}
/**
 * A hook to access the redux store's state. This hook takes a selector function
 * as an argument. The selector is called with the store state.
 *
 * This hook takes an optional equality comparison function as the second parameter
 * that allows you to customize the way the selected state is compared to determine
 * whether the component needs to be re-rendered.
 *
 * @param {Function} selector the selector function
 * @param {Function=} equalityFn the function that will be used to determine equality
 *
 * @returns {any} the selected state
 *
 * @example
 *
 * import React from 'react'
 * import { useSelector } from 'react-redux'
 *
 * export const CounterComponent = () => {
 *   const counter = useSelector(state => state.counter)
 *   return <div>{counter}</div>
 * }
 */

var useSelector = /*#__PURE__*/createSelectorHook();

// with standard React renderers (ReactDOM, React Native)

setBatch(unstable_batchedUpdates);

/**
 * @remix-run/router v1.18.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function _extends$7() {
  _extends$7 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$7.apply(this, arguments);
}

////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */
var Action;
(function (Action) {
  /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */
  Action["Pop"] = "POP";
  /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */
  Action["Push"] = "PUSH";
  /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */
  Action["Replace"] = "REPLACE";
})(Action || (Action = {}));
const PopStateEventType = "popstate";
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */
function createHashHistory(options) {
  if (options === void 0) {
    options = {};
  }
  function createHashLocation(window, globalHistory) {
    let {
      pathname = "/",
      search = "",
      hash = ""
    } = parsePath(window.location.hash.substr(1));
    // Hash URL should always have a leading / just like window.location.pathname
    // does, so if an app ends up at a route like /#something then we add a
    // leading slash so all of our path-matching behaves the same as if it would
    // in a browser router.  This is particularly important when there exists a
    // root splat route (<Route path="*">) since that matches internally against
    // "/*" and we'd expect /#something to 404 in a hash router app.
    if (!pathname.startsWith("/") && !pathname.startsWith(".")) {
      pathname = "/" + pathname;
    }
    return createLocation("", {
      pathname,
      search,
      hash
    },
    // state defaults to `null` because `window.history.state` does
    globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
  }
  function createHashHref(window, to) {
    let base = window.document.querySelector("base");
    let href = "";
    if (base && base.getAttribute("href")) {
      let url = window.location.href;
      let hashIndex = url.indexOf("#");
      href = hashIndex === -1 ? url : url.slice(0, hashIndex);
    }
    return href + "#" + (typeof to === "string" ? to : createPath(to));
  }
  function validateHashLocation(location, to) {
    warning$2(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
  }
  return getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function invariant$1(value, message) {
  if (value === false || value === null || typeof value === "undefined") {
    throw new Error(message);
  }
}
function warning$2(cond, message) {
  if (!cond) {
    // eslint-disable-next-line no-console
    if (typeof console !== "undefined") console.warn(message);
    try {
      // Welcome to debugging history!
      //
      // This error is thrown as a convenience, so you can more easily
      // find the source for a warning that appears in the console by
      // enabling "pause on exceptions" in your JavaScript debugger.
      throw new Error(message);
      // eslint-disable-next-line no-empty
    } catch (e) {}
  }
}
function createKey() {
  return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */
function getHistoryState(location, index) {
  return {
    usr: location.state,
    key: location.key,
    idx: index
  };
}
/**
 * Creates a Location object with a unique key from the given Path
 */
function createLocation(current, to, state, key) {
  if (state === void 0) {
    state = null;
  }
  let location = _extends$7({
    pathname: typeof current === "string" ? current : current.pathname,
    search: "",
    hash: ""
  }, typeof to === "string" ? parsePath(to) : to, {
    state,
    // TODO: This could be cleaned up.  push/replace should probably just take
    // full Locations now and avoid the need to run through this flow at all
    // But that's a pretty big refactor to the current test suite so going to
    // keep as is for the time being and just let any incoming keys take precedence
    key: to && to.key || key || createKey()
  });
  return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */
function createPath(_ref) {
  let {
    pathname = "/",
    search = "",
    hash = ""
  } = _ref;
  if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
  if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
  return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */
function parsePath(path) {
  let parsedPath = {};
  if (path) {
    let hashIndex = path.indexOf("#");
    if (hashIndex >= 0) {
      parsedPath.hash = path.substr(hashIndex);
      path = path.substr(0, hashIndex);
    }
    let searchIndex = path.indexOf("?");
    if (searchIndex >= 0) {
      parsedPath.search = path.substr(searchIndex);
      path = path.substr(0, searchIndex);
    }
    if (path) {
      parsedPath.pathname = path;
    }
  }
  return parsedPath;
}
function getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
  if (options === void 0) {
    options = {};
  }
  let {
    window = document.defaultView,
    v5Compat = false
  } = options;
  let globalHistory = window.history;
  let action = Action.Pop;
  let listener = null;
  let index = getIndex();
  // Index should only be null when we initialize. If not, it's because the
  // user called history.pushState or history.replaceState directly, in which
  // case we should log a warning as it will result in bugs.
  if (index == null) {
    index = 0;
    globalHistory.replaceState(_extends$7({}, globalHistory.state, {
      idx: index
    }), "");
  }
  function getIndex() {
    let state = globalHistory.state || {
      idx: null
    };
    return state.idx;
  }
  function handlePop() {
    action = Action.Pop;
    let nextIndex = getIndex();
    let delta = nextIndex == null ? null : nextIndex - index;
    index = nextIndex;
    if (listener) {
      listener({
        action,
        location: history.location,
        delta
      });
    }
  }
  function push(to, state) {
    action = Action.Push;
    let location = createLocation(history.location, to, state);
    if (validateLocation) validateLocation(location, to);
    index = getIndex() + 1;
    let historyState = getHistoryState(location, index);
    let url = history.createHref(location);
    // try...catch because iOS limits us to 100 pushState calls :/
    try {
      globalHistory.pushState(historyState, "", url);
    } catch (error) {
      // If the exception is because `state` can't be serialized, let that throw
      // outwards just like a replace call would so the dev knows the cause
      // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
      // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
      if (error instanceof DOMException && error.name === "DataCloneError") {
        throw error;
      }
      // They are going to lose state here, but there is no real
      // way to warn them about it since the page will refresh...
      window.location.assign(url);
    }
    if (v5Compat && listener) {
      listener({
        action,
        location: history.location,
        delta: 1
      });
    }
  }
  function replace(to, state) {
    action = Action.Replace;
    let location = createLocation(history.location, to, state);
    if (validateLocation) validateLocation(location, to);
    index = getIndex();
    let historyState = getHistoryState(location, index);
    let url = history.createHref(location);
    globalHistory.replaceState(historyState, "", url);
    if (v5Compat && listener) {
      listener({
        action,
        location: history.location,
        delta: 0
      });
    }
  }
  function createURL(to) {
    // window.location.origin is "null" (the literal string value) in Firefox
    // under certain conditions, notably when serving from a local HTML file
    // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
    let base = window.location.origin !== "null" ? window.location.origin : window.location.href;
    let href = typeof to === "string" ? to : createPath(to);
    // Treating this as a full URL will strip any trailing spaces so we need to
    // pre-encode them since they might be part of a matching splat param from
    // an ancestor route
    href = href.replace(/ $/, "%20");
    invariant$1(base, "No window.location.(origin|href) available to create URL for href: " + href);
    return new URL(href, base);
  }
  let history = {
    get action() {
      return action;
    },
    get location() {
      return getLocation(window, globalHistory);
    },
    listen(fn) {
      if (listener) {
        throw new Error("A history only accepts one active listener");
      }
      window.addEventListener(PopStateEventType, handlePop);
      listener = fn;
      return () => {
        window.removeEventListener(PopStateEventType, handlePop);
        listener = null;
      };
    },
    createHref(to) {
      return createHref(window, to);
    },
    createURL,
    encodeLocation(to) {
      // Encode a Location the same way window.location would
      let url = createURL(to);
      return {
        pathname: url.pathname,
        search: url.search,
        hash: url.hash
      };
    },
    push,
    replace,
    go(n) {
      return globalHistory.go(n);
    }
  };
  return history;
}
//#endregion

var ResultType;
(function (ResultType) {
  ResultType["data"] = "data";
  ResultType["deferred"] = "deferred";
  ResultType["redirect"] = "redirect";
  ResultType["error"] = "error";
})(ResultType || (ResultType = {}));
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */
function matchRoutes(routes, locationArg, basename) {
  if (basename === void 0) {
    basename = "/";
  }
  return matchRoutesImpl(routes, locationArg, basename, false);
}
function matchRoutesImpl(routes, locationArg, basename, allowPartial) {
  let location = typeof locationArg === "string" ? parsePath(locationArg) : locationArg;
  let pathname = stripBasename(location.pathname || "/", basename);
  if (pathname == null) {
    return null;
  }
  let branches = flattenRoutes(routes);
  rankRouteBranches(branches);
  let matches = null;
  for (let i = 0; matches == null && i < branches.length; ++i) {
    // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    let decoded = decodePath(pathname);
    matches = matchRouteBranch(branches[i], decoded, allowPartial);
  }
  return matches;
}
function flattenRoutes(routes, branches, parentsMeta, parentPath) {
  if (branches === void 0) {
    branches = [];
  }
  if (parentsMeta === void 0) {
    parentsMeta = [];
  }
  if (parentPath === void 0) {
    parentPath = "";
  }
  let flattenRoute = (route, index, relativePath) => {
    let meta = {
      relativePath: relativePath === undefined ? route.path || "" : relativePath,
      caseSensitive: route.caseSensitive === true,
      childrenIndex: index,
      route
    };
    if (meta.relativePath.startsWith("/")) {
      invariant$1(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
      meta.relativePath = meta.relativePath.slice(parentPath.length);
    }
    let path = joinPaths([parentPath, meta.relativePath]);
    let routesMeta = parentsMeta.concat(meta);
    // Add the children before adding this route to the array, so we traverse the
    // route tree depth-first and child routes appear before their parents in
    // the "flattened" version.
    if (route.children && route.children.length > 0) {
      invariant$1(
      // Our types know better, but runtime JS may not!
      // @ts-expect-error
      route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
      flattenRoutes(route.children, branches, routesMeta, path);
    }
    // Routes without a path shouldn't ever match by themselves unless they are
    // index routes, so don't add them to the list of possible branches.
    if (route.path == null && !route.index) {
      return;
    }
    branches.push({
      path,
      score: computeScore(path, route.index),
      routesMeta
    });
  };
  routes.forEach((route, index) => {
    var _route$path;
    // coarse-grain check for optional params
    if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) {
      flattenRoute(route, index);
    } else {
      for (let exploded of explodeOptionalSegments(route.path)) {
        flattenRoute(route, index, exploded);
      }
    }
  });
  return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */
function explodeOptionalSegments(path) {
  let segments = path.split("/");
  if (segments.length === 0) return [];
  let [first, ...rest] = segments;
  // Optional path segments are denoted by a trailing `?`
  let isOptional = first.endsWith("?");
  // Compute the corresponding required segment: `foo?` -> `foo`
  let required = first.replace(/\?$/, "");
  if (rest.length === 0) {
    // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [required, ""] : [required];
  }
  let restExploded = explodeOptionalSegments(rest.join("/"));
  let result = [];
  // All child paths with the prefix.  Do this for all children before the
  // optional version for all children, so we get consistent ordering where the
  // parent optional aspect is preferred as required.  Otherwise, we can get
  // child sections interspersed where deeper optional segments are higher than
  // parent optional segments, where for example, /:two would explode _earlier_
  // then /:one.  By always including the parent as required _for all children_
  // first, we avoid this issue
  result.push(...restExploded.map(subpath => subpath === "" ? required : [required, subpath].join("/")));
  // Then, if this is an optional value, add all child versions without
  if (isOptional) {
    result.push(...restExploded);
  }
  // for absolute paths, ensure `/` instead of empty segment
  return result.map(exploded => path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function rankRouteBranches(branches) {
  branches.sort((a, b) => a.score !== b.score ? b.score - a.score // Higher score first
  : compareIndexes(a.routesMeta.map(meta => meta.childrenIndex), b.routesMeta.map(meta => meta.childrenIndex)));
}
const paramRe = /^:[\w-]+$/;
const dynamicSegmentValue = 3;
const indexRouteValue = 2;
const emptySegmentValue = 1;
const staticSegmentValue = 10;
const splatPenalty = -2;
const isSplat = s => s === "*";
function computeScore(path, index) {
  let segments = path.split("/");
  let initialScore = segments.length;
  if (segments.some(isSplat)) {
    initialScore += splatPenalty;
  }
  if (index) {
    initialScore += indexRouteValue;
  }
  return segments.filter(s => !isSplat(s)).reduce((score, segment) => score + (paramRe.test(segment) ? dynamicSegmentValue : segment === "" ? emptySegmentValue : staticSegmentValue), initialScore);
}
function compareIndexes(a, b) {
  let siblings = a.length === b.length && a.slice(0, -1).every((n, i) => n === b[i]);
  return siblings ?
  // If two routes are siblings, we should try to match the earlier sibling
  // first. This allows people to have fine-grained control over the matching
  // behavior by simply putting routes with identical paths in the order they
  // want them tried.
  a[a.length - 1] - b[b.length - 1] :
  // Otherwise, it doesn't really make sense to rank non-siblings by index,
  // so they sort equally.
  0;
}
function matchRouteBranch(branch, pathname, allowPartial) {
  if (allowPartial === void 0) {
    allowPartial = false;
  }
  let {
    routesMeta
  } = branch;
  let matchedParams = {};
  let matchedPathname = "/";
  let matches = [];
  for (let i = 0; i < routesMeta.length; ++i) {
    let meta = routesMeta[i];
    let end = i === routesMeta.length - 1;
    let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
    let match = matchPath({
      path: meta.relativePath,
      caseSensitive: meta.caseSensitive,
      end
    }, remainingPathname);
    let route = meta.route;
    if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) {
      match = matchPath({
        path: meta.relativePath,
        caseSensitive: meta.caseSensitive,
        end: false
      }, remainingPathname);
    }
    if (!match) {
      return null;
    }
    Object.assign(matchedParams, match.params);
    matches.push({
      // TODO: Can this as be avoided?
      params: matchedParams,
      pathname: joinPaths([matchedPathname, match.pathname]),
      pathnameBase: normalizePathname(joinPaths([matchedPathname, match.pathnameBase])),
      route
    });
    if (match.pathnameBase !== "/") {
      matchedPathname = joinPaths([matchedPathname, match.pathnameBase]);
    }
  }
  return matches;
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */
function matchPath(pattern, pathname) {
  if (typeof pattern === "string") {
    pattern = {
      path: pattern,
      caseSensitive: false,
      end: true
    };
  }
  let [matcher, compiledParams] = compilePath(pattern.path, pattern.caseSensitive, pattern.end);
  let match = pathname.match(matcher);
  if (!match) return null;
  let matchedPathname = match[0];
  let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
  let captureGroups = match.slice(1);
  let params = compiledParams.reduce((memo, _ref, index) => {
    let {
      paramName,
      isOptional
    } = _ref;
    // We need to compute the pathnameBase here using the raw splat value
    // instead of using params["*"] later because it will be decoded then
    if (paramName === "*") {
      let splatValue = captureGroups[index] || "";
      pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
    }
    const value = captureGroups[index];
    if (isOptional && !value) {
      memo[paramName] = undefined;
    } else {
      memo[paramName] = (value || "").replace(/%2F/g, "/");
    }
    return memo;
  }, {});
  return {
    params,
    pathname: matchedPathname,
    pathnameBase,
    pattern
  };
}
function compilePath(path, caseSensitive, end) {
  if (caseSensitive === void 0) {
    caseSensitive = false;
  }
  if (end === void 0) {
    end = true;
  }
  warning$2(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
  let params = [];
  let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
  .replace(/^\/*/, "/") // Make sure it has a leading /
  .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
  .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional) => {
    params.push({
      paramName,
      isOptional: isOptional != null
    });
    return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
  });
  if (path.endsWith("*")) {
    params.push({
      paramName: "*"
    });
    regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
    : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
  } else if (end) {
    // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
  } else if (path !== "" && path !== "/") {
    // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
  } else ;
  let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
  return [matcher, params];
}
function decodePath(value) {
  try {
    return value.split("/").map(v => decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
  } catch (error) {
    warning$2(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
    return value;
  }
}
/**
 * @private
 */
function stripBasename(pathname, basename) {
  if (basename === "/") return pathname;
  if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) {
    return null;
  }
  // We want to leave trailing slash behavior in the user's control, so if they
  // specify a basename with a trailing slash, we should support it
  let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
  let nextChar = pathname.charAt(startIndex);
  if (nextChar && nextChar !== "/") {
    // pathname does not start with basename/
    return null;
  }
  return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */
function resolvePath(to, fromPathname) {
  if (fromPathname === void 0) {
    fromPathname = "/";
  }
  let {
    pathname: toPathname,
    search = "",
    hash = ""
  } = typeof to === "string" ? parsePath(to) : to;
  let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : resolvePathname(toPathname, fromPathname) : fromPathname;
  return {
    pathname,
    search: normalizeSearch(search),
    hash: normalizeHash(hash)
  };
}
function resolvePathname(relativePath, fromPathname) {
  let segments = fromPathname.replace(/\/+$/, "").split("/");
  let relativeSegments = relativePath.split("/");
  relativeSegments.forEach(segment => {
    if (segment === "..") {
      // Keep the root "" segment so the pathname starts at /
      if (segments.length > 1) segments.pop();
    } else if (segment !== ".") {
      segments.push(segment);
    }
  });
  return segments.length > 1 ? segments.join("/") : "/";
}
function getInvalidPathError(char, field, dest, path) {
  return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */
function getPathContributingMatches(matches) {
  return matches.filter((match, index) => index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function getResolveToMatches(matches, v7_relativeSplatPath) {
  let pathMatches = getPathContributingMatches(matches);
  // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
  // match so we include splat values for "." links.  See:
  // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
  if (v7_relativeSplatPath) {
    return pathMatches.map((match, idx) => idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
  }
  return pathMatches.map(match => match.pathnameBase);
}
/**
 * @private
 */
function resolveTo(toArg, routePathnames, locationPathname, isPathRelative) {
  if (isPathRelative === void 0) {
    isPathRelative = false;
  }
  let to;
  if (typeof toArg === "string") {
    to = parsePath(toArg);
  } else {
    to = _extends$7({}, toArg);
    invariant$1(!to.pathname || !to.pathname.includes("?"), getInvalidPathError("?", "pathname", "search", to));
    invariant$1(!to.pathname || !to.pathname.includes("#"), getInvalidPathError("#", "pathname", "hash", to));
    invariant$1(!to.search || !to.search.includes("#"), getInvalidPathError("#", "search", "hash", to));
  }
  let isEmptyPath = toArg === "" || to.pathname === "";
  let toPathname = isEmptyPath ? "/" : to.pathname;
  let from;
  // Routing is relative to the current pathname if explicitly requested.
  //
  // If a pathname is explicitly provided in `to`, it should be relative to the
  // route context. This is explained in `Note on `<Link to>` values` in our
  // migration guide from v5 as a means of disambiguation between `to` values
  // that begin with `/` and those that do not. However, this is problematic for
  // `to` values that do not provide a pathname. `to` can simply be a search or
  // hash string, in which case we should assume that the navigation is relative
  // to the current location's pathname and *not* the route pathname.
  if (toPathname == null) {
    from = locationPathname;
  } else {
    let routePathnameIndex = routePathnames.length - 1;
    // With relative="route" (the default), each leading .. segment means
    // "go up one route" instead of "go up one URL segment".  This is a key
    // difference from how <a href> works and a major reason we call this a
    // "to" value instead of a "href".
    if (!isPathRelative && toPathname.startsWith("..")) {
      let toSegments = toPathname.split("/");
      while (toSegments[0] === "..") {
        toSegments.shift();
        routePathnameIndex -= 1;
      }
      to.pathname = toSegments.join("/");
    }
    from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
  }
  let path = resolvePath(to, from);
  // Ensure the pathname has a trailing slash if the original "to" had one
  let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
  // Or if this was a link to the current path which has a trailing slash
  let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
  if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) {
    path.pathname += "/";
  }
  return path;
}
/**
 * @private
 */
const joinPaths = paths => paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */
const normalizePathname = pathname => pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */
const normalizeSearch = search => !search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */
const normalizeHash = hash => !hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */
function isRouteErrorResponse(error) {
  return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const validMutationMethodsArr = ["post", "put", "patch", "delete"];
["get", ...validMutationMethodsArr];

/**
 * React Router v6.25.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function _extends$6() {
  _extends$6 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$6.apply(this, arguments);
}

// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const DataRouterContext = /*#__PURE__*/React.createContext(null);
if (process.env.NODE_ENV !== "production") {
  DataRouterContext.displayName = "DataRouter";
}
const DataRouterStateContext = /*#__PURE__*/React.createContext(null);
if (process.env.NODE_ENV !== "production") {
  DataRouterStateContext.displayName = "DataRouterState";
}
const AwaitContext = /*#__PURE__*/React.createContext(null);
if (process.env.NODE_ENV !== "production") {
  AwaitContext.displayName = "Await";
}

/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */

const NavigationContext = /*#__PURE__*/React.createContext(null);
if (process.env.NODE_ENV !== "production") {
  NavigationContext.displayName = "Navigation";
}
const LocationContext = /*#__PURE__*/React.createContext(null);
if (process.env.NODE_ENV !== "production") {
  LocationContext.displayName = "Location";
}
const RouteContext = /*#__PURE__*/React.createContext({
  outlet: null,
  matches: [],
  isDataRoute: false
});
if (process.env.NODE_ENV !== "production") {
  RouteContext.displayName = "Route";
}
const RouteErrorContext = /*#__PURE__*/React.createContext(null);
if (process.env.NODE_ENV !== "production") {
  RouteErrorContext.displayName = "RouteError";
}

/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */
function useHref(to, _temp) {
  let {
    relative
  } = _temp === void 0 ? {} : _temp;
  !useInRouterContext() ? process.env.NODE_ENV !== "production" ? invariant$1(false,
  // TODO: This error is probably because they somehow have 2 versions of the
  // router loaded. We can help them understand how to avoid that.
  "useHref() may be used only in the context of a <Router> component.") : invariant$1(false) : void 0;
  let {
    basename,
    navigator
  } = React.useContext(NavigationContext);
  let {
    hash,
    pathname,
    search
  } = useResolvedPath(to, {
    relative
  });
  let joinedPathname = pathname;

  // If we're operating within a basename, prepend it to the pathname prior
  // to creating the href.  If this is a root navigation, then just use the raw
  // basename which allows the basename to have full control over the presence
  // of a trailing slash on root links
  if (basename !== "/") {
    joinedPathname = pathname === "/" ? basename : joinPaths([basename, pathname]);
  }
  return navigator.createHref({
    pathname: joinedPathname,
    search,
    hash
  });
}

/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */
function useInRouterContext() {
  return React.useContext(LocationContext) != null;
}

/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */
function useLocation() {
  !useInRouterContext() ? process.env.NODE_ENV !== "production" ? invariant$1(false,
  // TODO: This error is probably because they somehow have 2 versions of the
  // router loaded. We can help them understand how to avoid that.
  "useLocation() may be used only in the context of a <Router> component.") : invariant$1(false) : void 0;
  return React.useContext(LocationContext).location;
}

/**
 * The interface for the navigate() function returned from useNavigate().
 */

const navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when " + "your component is first rendered.";

// Mute warnings for calls to useNavigate in SSR environments
function useIsomorphicLayoutEffect$1(cb) {
  let isStatic = React.useContext(NavigationContext).static;
  if (!isStatic) {
    // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useLayoutEffect(cb);
  }
}

/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */
function useNavigate() {
  let {
    isDataRoute
  } = React.useContext(RouteContext);
  // Conditional usage is OK here because the usage of a data router is static
  // eslint-disable-next-line react-hooks/rules-of-hooks
  return isDataRoute ? useNavigateStable() : useNavigateUnstable();
}
function useNavigateUnstable() {
  !useInRouterContext() ? process.env.NODE_ENV !== "production" ? invariant$1(false,
  // TODO: This error is probably because they somehow have 2 versions of the
  // router loaded. We can help them understand how to avoid that.
  "useNavigate() may be used only in the context of a <Router> component.") : invariant$1(false) : void 0;
  let dataRouterContext = React.useContext(DataRouterContext);
  let {
    basename,
    future,
    navigator
  } = React.useContext(NavigationContext);
  let {
    matches
  } = React.useContext(RouteContext);
  let {
    pathname: locationPathname
  } = useLocation();
  let routePathnamesJson = JSON.stringify(getResolveToMatches(matches, future.v7_relativeSplatPath));
  let activeRef = React.useRef(false);
  useIsomorphicLayoutEffect$1(() => {
    activeRef.current = true;
  });
  let navigate = React.useCallback(function (to, options) {
    if (options === void 0) {
      options = {};
    }
    process.env.NODE_ENV !== "production" ? warning$2(activeRef.current, navigateEffectWarning) : void 0;

    // Short circuit here since if this happens on first render the navigate
    // is useless because we haven't wired up our history listener yet
    if (!activeRef.current) return;
    if (typeof to === "number") {
      navigator.go(to);
      return;
    }
    let path = resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");

    // If we're operating within a basename, prepend it to the pathname prior
    // to handing off to history (but only if we're not in a data router,
    // otherwise it'll prepend the basename inside of the router).
    // If this is a root navigation, then we navigate to the raw basename
    // which allows the basename to have full control over the presence of a
    // trailing slash on root links
    if (dataRouterContext == null && basename !== "/") {
      path.pathname = path.pathname === "/" ? basename : joinPaths([basename, path.pathname]);
    }
    (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
  }, [basename, navigator, routePathnamesJson, locationPathname, dataRouterContext]);
  return navigate;
}

/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */
function useParams() {
  let {
    matches
  } = React.useContext(RouteContext);
  let routeMatch = matches[matches.length - 1];
  return routeMatch ? routeMatch.params : {};
}

/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */
function useResolvedPath(to, _temp2) {
  let {
    relative
  } = _temp2 === void 0 ? {} : _temp2;
  let {
    future
  } = React.useContext(NavigationContext);
  let {
    matches
  } = React.useContext(RouteContext);
  let {
    pathname: locationPathname
  } = useLocation();
  let routePathnamesJson = JSON.stringify(getResolveToMatches(matches, future.v7_relativeSplatPath));
  return React.useMemo(() => resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [to, routePathnamesJson, locationPathname, relative]);
}

/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */
function useRoutes(routes, locationArg) {
  return useRoutesImpl(routes, locationArg);
}

// Internal implementation with accept optional param for RouterProvider usage
function useRoutesImpl(routes, locationArg, dataRouterState, future) {
  !useInRouterContext() ? process.env.NODE_ENV !== "production" ? invariant$1(false,
  // TODO: This error is probably because they somehow have 2 versions of the
  // router loaded. We can help them understand how to avoid that.
  "useRoutes() may be used only in the context of a <Router> component.") : invariant$1(false) : void 0;
  let {
    navigator
  } = React.useContext(NavigationContext);
  let {
    matches: parentMatches
  } = React.useContext(RouteContext);
  let routeMatch = parentMatches[parentMatches.length - 1];
  let parentParams = routeMatch ? routeMatch.params : {};
  let parentPathname = routeMatch ? routeMatch.pathname : "/";
  let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
  let parentRoute = routeMatch && routeMatch.route;
  if (process.env.NODE_ENV !== "production") {
    // You won't get a warning about 2 different <Routes> under a <Route>
    // without a trailing *, but this is a best-effort warning anyway since we
    // cannot even give the warning unless they land at the parent route.
    //
    // Example:
    //
    // <Routes>
    //   {/* This route path MUST end with /* because otherwise
    //       it will never match /blog/post/123 */}
    //   <Route path="blog" element={<Blog />} />
    //   <Route path="blog/feed" element={<BlogFeed />} />
    // </Routes>
    //
    // function Blog() {
    //   return (
    //     <Routes>
    //       <Route path="post/:id" element={<Post />} />
    //     </Routes>
    //   );
    // }
    let parentPath = parentRoute && parentRoute.path || "";
    warningOnce$1(parentPathname, !parentRoute || parentPath.endsWith("*"), "You rendered descendant <Routes> (or called `useRoutes()`) at " + ("\"" + parentPathname + "\" (under <Route path=\"" + parentPath + "\">) but the ") + "parent route path has no trailing \"*\". This means if you navigate " + "deeper, the parent won't match anymore and therefore the child " + "routes will never render.\n\n" + ("Please change the parent <Route path=\"" + parentPath + "\"> to <Route ") + ("path=\"" + (parentPath === "/" ? "*" : parentPath + "/*") + "\">."));
  }
  let locationFromContext = useLocation();
  let location;
  if (locationArg) {
    var _parsedLocationArg$pa;
    let parsedLocationArg = typeof locationArg === "string" ? parsePath(locationArg) : locationArg;
    !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) ? process.env.NODE_ENV !== "production" ? invariant$1(false, "When overriding the location using `<Routes location>` or `useRoutes(routes, location)`, " + "the location pathname must begin with the portion of the URL pathname that was " + ("matched by all parent routes. The current pathname base is \"" + parentPathnameBase + "\" ") + ("but pathname \"" + parsedLocationArg.pathname + "\" was given in the `location` prop.")) : invariant$1(false) : void 0;
    location = parsedLocationArg;
  } else {
    location = locationFromContext;
  }
  let pathname = location.pathname || "/";
  let remainingPathname = pathname;
  if (parentPathnameBase !== "/") {
    // Determine the remaining pathname by removing the # of URL segments the
    // parentPathnameBase has, instead of removing based on character count.
    // This is because we can't guarantee that incoming/outgoing encodings/
    // decodings will match exactly.
    // We decode paths before matching on a per-segment basis with
    // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
    // match what `window.location.pathname` would reflect.  Those don't 100%
    // align when it comes to encoded URI characters such as % and &.
    //
    // So we may end up with:
    //   pathname:           "/descendant/a%25b/match"
    //   parentPathnameBase: "/descendant/a%b"
    //
    // And the direct substring removal approach won't work :/
    let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
    let segments = pathname.replace(/^\//, "").split("/");
    remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
  }
  let matches = matchRoutes(routes, {
    pathname: remainingPathname
  });
  if (process.env.NODE_ENV !== "production") {
    process.env.NODE_ENV !== "production" ? warning$2(parentRoute || matches != null, "No routes matched location \"" + location.pathname + location.search + location.hash + "\" ") : void 0;
    process.env.NODE_ENV !== "production" ? warning$2(matches == null || matches[matches.length - 1].route.element !== undefined || matches[matches.length - 1].route.Component !== undefined || matches[matches.length - 1].route.lazy !== undefined, "Matched leaf route at location \"" + location.pathname + location.search + location.hash + "\" " + "does not have an element or Component. This means it will render an <Outlet /> with a " + "null value by default resulting in an \"empty\" page.") : void 0;
  }
  let renderedMatches = _renderMatches(matches && matches.map(match => Object.assign({}, match, {
    params: Object.assign({}, parentParams, match.params),
    pathname: joinPaths([parentPathnameBase,
    // Re-encode pathnames that were decoded inside matchRoutes
    navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname]),
    pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : joinPaths([parentPathnameBase,
    // Re-encode pathnames that were decoded inside matchRoutes
    navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase])
  })), parentMatches, dataRouterState, future);

  // When a user passes in a `locationArg`, the associated routes need to
  // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
  // to use the scoped location instead of the global location.
  if (locationArg && renderedMatches) {
    return /*#__PURE__*/React.createElement(LocationContext.Provider, {
      value: {
        location: _extends$6({
          pathname: "/",
          search: "",
          hash: "",
          state: null,
          key: "default"
        }, location),
        navigationType: Action.Pop
      }
    }, renderedMatches);
  }
  return renderedMatches;
}
function DefaultErrorComponent() {
  let error = useRouteError();
  let message = isRouteErrorResponse(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
  let stack = error instanceof Error ? error.stack : null;
  let lightgrey = "rgba(200,200,200, 0.5)";
  let preStyles = {
    padding: "0.5rem",
    backgroundColor: lightgrey
  };
  let codeStyles = {
    padding: "2px 4px",
    backgroundColor: lightgrey
  };
  let devInfo = null;
  if (process.env.NODE_ENV !== "production") {
    console.error("Error handled by React Router default ErrorBoundary:", error);
    devInfo = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /*#__PURE__*/React.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /*#__PURE__*/React.createElement("code", {
      style: codeStyles
    }, "ErrorBoundary"), " or", " ", /*#__PURE__*/React.createElement("code", {
      style: codeStyles
    }, "errorElement"), " prop on your route."));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/React.createElement("h3", {
    style: {
      fontStyle: "italic"
    }
  }, message), stack ? /*#__PURE__*/React.createElement("pre", {
    style: preStyles
  }, stack) : null, devInfo);
}
const defaultErrorElement = /*#__PURE__*/React.createElement(DefaultErrorComponent, null);
class RenderErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      location: props.location,
      revalidation: props.revalidation,
      error: props.error
    };
  }
  static getDerivedStateFromError(error) {
    return {
      error: error
    };
  }
  static getDerivedStateFromProps(props, state) {
    // When we get into an error state, the user will likely click "back" to the
    // previous page that didn't have an error. Because this wraps the entire
    // application, that will have no effect--the error page continues to display.
    // This gives us a mechanism to recover from the error when the location changes.
    //
    // Whether we're in an error state or not, we update the location in state
    // so that when we are in an error state, it gets reset when a new location
    // comes in and the user recovers from the error.
    if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") {
      return {
        error: props.error,
        location: props.location,
        revalidation: props.revalidation
      };
    }

    // If we're not changing locations, preserve the location but still surface
    // any new errors that may come through. We retain the existing error, we do
    // this because the error provided from the app state may be cleared without
    // the location changing.
    return {
      error: props.error !== undefined ? props.error : state.error,
      location: state.location,
      revalidation: props.revalidation || state.revalidation
    };
  }
  componentDidCatch(error, errorInfo) {
    console.error("React Router caught the following error during render", error, errorInfo);
  }
  render() {
    return this.state.error !== undefined ? /*#__PURE__*/React.createElement(RouteContext.Provider, {
      value: this.props.routeContext
    }, /*#__PURE__*/React.createElement(RouteErrorContext.Provider, {
      value: this.state.error,
      children: this.props.component
    })) : this.props.children;
  }
}
function RenderedRoute(_ref) {
  let {
    routeContext,
    match,
    children
  } = _ref;
  let dataRouterContext = React.useContext(DataRouterContext);

  // Track how deep we got in our render pass to emulate SSR componentDidCatch
  // in a DataStaticRouter
  if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) {
    dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
  }
  return /*#__PURE__*/React.createElement(RouteContext.Provider, {
    value: routeContext
  }, children);
}
function _renderMatches(matches, parentMatches, dataRouterState, future) {
  var _dataRouterState2;
  if (parentMatches === void 0) {
    parentMatches = [];
  }
  if (dataRouterState === void 0) {
    dataRouterState = null;
  }
  if (future === void 0) {
    future = null;
  }
  if (matches == null) {
    var _dataRouterState;
    if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) {
      // Don't bail if we have data router errors so we can render them in the
      // boundary.  Use the pre-matched (or shimmed) matches
      matches = dataRouterState.matches;
    } else {
      return null;
    }
  }
  let renderedMatches = matches;

  // If we have data errors, trim matches to the highest error boundary
  let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
  if (errors != null) {
    let errorIndex = renderedMatches.findIndex(m => m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
    !(errorIndex >= 0) ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Could not find a matching route for errors on route IDs: " + Object.keys(errors).join(",")) : invariant$1(false) : void 0;
    renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
  }

  // If we're in a partial hydration mode, detect if we need to render down to
  // a given HydrateFallback while we load the rest of the hydration data
  let renderFallback = false;
  let fallbackIndex = -1;
  if (dataRouterState && future && future.v7_partialHydration) {
    for (let i = 0; i < renderedMatches.length; i++) {
      let match = renderedMatches[i];
      // Track the deepest fallback up until the first route without data
      if (match.route.HydrateFallback || match.route.hydrateFallbackElement) {
        fallbackIndex = i;
      }
      if (match.route.id) {
        let {
          loaderData,
          errors
        } = dataRouterState;
        let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
        if (match.route.lazy || needsToRunLoader) {
          // We found the first route that's not ready to render (waiting on
          // lazy, or has a loader that hasn't run yet).  Flag that we need to
          // render a fallback and render up until the appropriate fallback
          renderFallback = true;
          if (fallbackIndex >= 0) {
            renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
          } else {
            renderedMatches = [renderedMatches[0]];
          }
          break;
        }
      }
    }
  }
  return renderedMatches.reduceRight((outlet, match, index) => {
    // Only data routers handle errors/fallbacks
    let error;
    let shouldRenderHydrateFallback = false;
    let errorElement = null;
    let hydrateFallbackElement = null;
    if (dataRouterState) {
      error = errors && match.route.id ? errors[match.route.id] : undefined;
      errorElement = match.route.errorElement || defaultErrorElement;
      if (renderFallback) {
        if (fallbackIndex < 0 && index === 0) {
          warningOnce$1("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
          shouldRenderHydrateFallback = true;
          hydrateFallbackElement = null;
        } else if (fallbackIndex === index) {
          shouldRenderHydrateFallback = true;
          hydrateFallbackElement = match.route.hydrateFallbackElement || null;
        }
      }
    }
    let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
    let getChildren = () => {
      let children;
      if (error) {
        children = errorElement;
      } else if (shouldRenderHydrateFallback) {
        children = hydrateFallbackElement;
      } else if (match.route.Component) {
        // Note: This is a de-optimized path since React won't re-use the
        // ReactElement since it's identity changes with each new
        // React.createElement call.  We keep this so folks can use
        // `<Route Component={...}>` in `<Routes>` but generally `Component`
        // usage is only advised in `RouterProvider` when we can convert it to
        // `element` ahead of time.
        children = /*#__PURE__*/React.createElement(match.route.Component, null);
      } else if (match.route.element) {
        children = match.route.element;
      } else {
        children = outlet;
      }
      return /*#__PURE__*/React.createElement(RenderedRoute, {
        match: match,
        routeContext: {
          outlet,
          matches,
          isDataRoute: dataRouterState != null
        },
        children: children
      });
    };
    // Only wrap in an error boundary within data router usages when we have an
    // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
    // an ancestor ErrorBoundary/errorElement
    return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/React.createElement(RenderErrorBoundary, {
      location: dataRouterState.location,
      revalidation: dataRouterState.revalidation,
      component: errorElement,
      error: error,
      children: getChildren(),
      routeContext: {
        outlet: null,
        matches,
        isDataRoute: true
      }
    }) : getChildren();
  }, null);
}
var DataRouterHook$1 = /*#__PURE__*/function (DataRouterHook) {
  DataRouterHook["UseBlocker"] = "useBlocker";
  DataRouterHook["UseRevalidator"] = "useRevalidator";
  DataRouterHook["UseNavigateStable"] = "useNavigate";
  return DataRouterHook;
}(DataRouterHook$1 || {});
var DataRouterStateHook$1 = /*#__PURE__*/function (DataRouterStateHook) {
  DataRouterStateHook["UseBlocker"] = "useBlocker";
  DataRouterStateHook["UseLoaderData"] = "useLoaderData";
  DataRouterStateHook["UseActionData"] = "useActionData";
  DataRouterStateHook["UseRouteError"] = "useRouteError";
  DataRouterStateHook["UseNavigation"] = "useNavigation";
  DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
  DataRouterStateHook["UseMatches"] = "useMatches";
  DataRouterStateHook["UseRevalidator"] = "useRevalidator";
  DataRouterStateHook["UseNavigateStable"] = "useNavigate";
  DataRouterStateHook["UseRouteId"] = "useRouteId";
  return DataRouterStateHook;
}(DataRouterStateHook$1 || {});
function getDataRouterConsoleError$1(hookName) {
  return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function useDataRouterContext$1(hookName) {
  let ctx = React.useContext(DataRouterContext);
  !ctx ? process.env.NODE_ENV !== "production" ? invariant$1(false, getDataRouterConsoleError$1(hookName)) : invariant$1(false) : void 0;
  return ctx;
}
function useDataRouterState(hookName) {
  let state = React.useContext(DataRouterStateContext);
  !state ? process.env.NODE_ENV !== "production" ? invariant$1(false, getDataRouterConsoleError$1(hookName)) : invariant$1(false) : void 0;
  return state;
}
function useRouteContext(hookName) {
  let route = React.useContext(RouteContext);
  !route ? process.env.NODE_ENV !== "production" ? invariant$1(false, getDataRouterConsoleError$1(hookName)) : invariant$1(false) : void 0;
  return route;
}

// Internal version with hookName-aware debugging
function useCurrentRouteId(hookName) {
  let route = useRouteContext(hookName);
  let thisRoute = route.matches[route.matches.length - 1];
  !thisRoute.route.id ? process.env.NODE_ENV !== "production" ? invariant$1(false, hookName + " can only be used on routes that contain a unique \"id\"") : invariant$1(false) : void 0;
  return thisRoute.route.id;
}

/**
 * Returns the ID for the nearest contextual route
 */
function useRouteId() {
  return useCurrentRouteId(DataRouterStateHook$1.UseRouteId);
}

/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */
function useRouteError() {
  var _state$errors;
  let error = React.useContext(RouteErrorContext);
  let state = useDataRouterState(DataRouterStateHook$1.UseRouteError);
  let routeId = useCurrentRouteId(DataRouterStateHook$1.UseRouteError);

  // If this was a render error, we put it in a RouteError context inside
  // of RenderErrorBoundary
  if (error !== undefined) {
    return error;
  }

  // Otherwise look for errors from our data router state
  return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}

/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */
function useNavigateStable() {
  let {
    router
  } = useDataRouterContext$1(DataRouterHook$1.UseNavigateStable);
  let id = useCurrentRouteId(DataRouterStateHook$1.UseNavigateStable);
  let activeRef = React.useRef(false);
  useIsomorphicLayoutEffect$1(() => {
    activeRef.current = true;
  });
  let navigate = React.useCallback(function (to, options) {
    if (options === void 0) {
      options = {};
    }
    process.env.NODE_ENV !== "production" ? warning$2(activeRef.current, navigateEffectWarning) : void 0;

    // Short circuit here since if this happens on first render the navigate
    // is useless because we haven't wired up our router subscriber yet
    if (!activeRef.current) return;
    if (typeof to === "number") {
      router.navigate(to);
    } else {
      router.navigate(to, _extends$6({
        fromRouteId: id
      }, options));
    }
  }, [router, id]);
  return navigate;
}
const alreadyWarned = {};
function warningOnce$1(key, cond, message) {
  if (!cond && !alreadyWarned[key]) {
    alreadyWarned[key] = true;
    process.env.NODE_ENV !== "production" ? warning$2(false, message) : void 0;
  }
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */
function Navigate(_ref4) {
  let {
    to,
    replace,
    state,
    relative
  } = _ref4;
  !useInRouterContext() ? process.env.NODE_ENV !== "production" ? invariant$1(false,
  // TODO: This error is probably because they somehow have 2 versions of
  // the router loaded. We can help them understand how to avoid that.
  "<Navigate> may be used only in the context of a <Router> component.") : invariant$1(false) : void 0;
  let {
    future,
    static: isStatic
  } = React.useContext(NavigationContext);
  process.env.NODE_ENV !== "production" ? warning$2(!isStatic, "<Navigate> must not be used on the initial render in a <StaticRouter>. " + "This is a no-op, but you should modify your code so the <Navigate> is " + "only ever rendered in response to some user interaction or state change.") : void 0;
  let {
    matches
  } = React.useContext(RouteContext);
  let {
    pathname: locationPathname
  } = useLocation();
  let navigate = useNavigate();

  // Resolve the path outside of the effect so that when effects run twice in
  // StrictMode they navigate to the same place
  let path = resolveTo(to, getResolveToMatches(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
  let jsonPath = JSON.stringify(path);
  React.useEffect(() => navigate(JSON.parse(jsonPath), {
    replace,
    state,
    relative
  }), [navigate, jsonPath, relative, replace, state]);
  return null;
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */
function Route(_props) {
  process.env.NODE_ENV !== "production" ? invariant$1(false, "A <Route> is only ever to be used as the child of <Routes> element, " + "never rendered directly. Please wrap your <Route> in a <Routes>.") : invariant$1(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */
function Router(_ref5) {
  let {
    basename: basenameProp = "/",
    children = null,
    location: locationProp,
    navigationType = Action.Pop,
    navigator,
    static: staticProp = false,
    future
  } = _ref5;
  !!useInRouterContext() ? process.env.NODE_ENV !== "production" ? invariant$1(false, "You cannot render a <Router> inside another <Router>." + " You should never have more than one in your app.") : invariant$1(false) : void 0;

  // Preserve trailing slashes on basename, so we can let the user control
  // the enforcement of trailing slashes throughout the app
  let basename = basenameProp.replace(/^\/*/, "/");
  let navigationContext = React.useMemo(() => ({
    basename,
    navigator,
    static: staticProp,
    future: _extends$6({
      v7_relativeSplatPath: false
    }, future)
  }), [basename, future, navigator, staticProp]);
  if (typeof locationProp === "string") {
    locationProp = parsePath(locationProp);
  }
  let {
    pathname = "/",
    search = "",
    hash = "",
    state = null,
    key = "default"
  } = locationProp;
  let locationContext = React.useMemo(() => {
    let trailingPathname = stripBasename(pathname, basename);
    if (trailingPathname == null) {
      return null;
    }
    return {
      location: {
        pathname: trailingPathname,
        search,
        hash,
        state,
        key
      },
      navigationType
    };
  }, [basename, pathname, search, hash, state, key, navigationType]);
  process.env.NODE_ENV !== "production" ? warning$2(locationContext != null, "<Router basename=\"" + basename + "\"> is not able to match the URL " + ("\"" + pathname + search + hash + "\" because it does not start with the ") + "basename, so the <Router> won't render anything.") : void 0;
  if (locationContext == null) {
    return null;
  }
  return /*#__PURE__*/React.createElement(NavigationContext.Provider, {
    value: navigationContext
  }, /*#__PURE__*/React.createElement(LocationContext.Provider, {
    children: children,
    value: locationContext
  }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */
function Routes(_ref6) {
  let {
    children,
    location
  } = _ref6;
  return useRoutes(createRoutesFromChildren(children), location);
}
new Promise(() => {});

///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////

/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */
function createRoutesFromChildren(children, parentPath) {
  if (parentPath === void 0) {
    parentPath = [];
  }
  let routes = [];
  React.Children.forEach(children, (element, index) => {
    if (! /*#__PURE__*/React.isValidElement(element)) {
      // Ignore non-elements. This allows people to more easily inline
      // conditionals in their route config.
      return;
    }
    let treePath = [...parentPath, index];
    if (element.type === React.Fragment) {
      // Transparently support React.Fragment and its children.
      routes.push.apply(routes, createRoutesFromChildren(element.props.children, treePath));
      return;
    }
    !(element.type === Route) ? process.env.NODE_ENV !== "production" ? invariant$1(false, "[" + (typeof element.type === "string" ? element.type : element.type.name) + "] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>") : invariant$1(false) : void 0;
    !(!element.props.index || !element.props.children) ? process.env.NODE_ENV !== "production" ? invariant$1(false, "An index route cannot have child routes.") : invariant$1(false) : void 0;
    let route = {
      id: element.props.id || treePath.join("-"),
      caseSensitive: element.props.caseSensitive,
      element: element.props.element,
      Component: element.props.Component,
      index: element.props.index,
      path: element.props.path,
      loader: element.props.loader,
      action: element.props.action,
      errorElement: element.props.errorElement,
      ErrorBoundary: element.props.ErrorBoundary,
      hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
      shouldRevalidate: element.props.shouldRevalidate,
      handle: element.props.handle,
      lazy: element.props.lazy
    };
    if (element.props.children) {
      route.children = createRoutesFromChildren(element.props.children, treePath);
    }
    routes.push(route);
  });
  return routes;
}

/**
 * React Router DOM v6.25.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function _extends$5() {
  _extends$5 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$5.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$3(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
const defaultMethod = "get";
const defaultEncType = "application/x-www-form-urlencoded";
function isHtmlElement(object) {
  return object != null && typeof object.tagName === "string";
}
function isButtonElement(object) {
  return isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function isFormElement(object) {
  return isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function isInputElement(object) {
  return isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function shouldProcessLinkClick(event, target) {
  return event.button === 0 && (
  // Ignore everything but left clicks
  !target || target === "_self") &&
  // Let browser handle "target=_blank" etc.
  !isModifiedEvent(event) // Ignore clicks with modifier keys
  ;
}
// One-time check for submitter support
let _formDataSupportsSubmitter = null;
function isFormDataSubmitterSupported() {
  if (_formDataSupportsSubmitter === null) {
    try {
      new FormData(document.createElement("form"),
      // @ts-expect-error if FormData supports the submitter parameter, this will throw
      0);
      _formDataSupportsSubmitter = false;
    } catch (e) {
      _formDataSupportsSubmitter = true;
    }
  }
  return _formDataSupportsSubmitter;
}
const supportedFormEncTypes = new Set(["application/x-www-form-urlencoded", "multipart/form-data", "text/plain"]);
function getFormEncType(encType) {
  if (encType != null && !supportedFormEncTypes.has(encType)) {
    process.env.NODE_ENV !== "production" ? warning$2(false, "\"" + encType + "\" is not a valid `encType` for `<Form>`/`<fetcher.Form>` " + ("and will default to \"" + defaultEncType + "\"")) : void 0;
    return null;
  }
  return encType;
}
function getFormSubmissionInfo(target, basename) {
  let method;
  let action;
  let encType;
  let formData;
  let body;
  if (isFormElement(target)) {
    // When grabbing the action from the element, it will have had the basename
    // prefixed to ensure non-JS scenarios work, so strip it since we'll
    // re-prefix in the router
    let attr = target.getAttribute("action");
    action = attr ? stripBasename(attr, basename) : null;
    method = target.getAttribute("method") || defaultMethod;
    encType = getFormEncType(target.getAttribute("enctype")) || defaultEncType;
    formData = new FormData(target);
  } else if (isButtonElement(target) || isInputElement(target) && (target.type === "submit" || target.type === "image")) {
    let form = target.form;
    if (form == null) {
      throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
    }
    // <button>/<input type="submit"> may override attributes of <form>
    // When grabbing the action from the element, it will have had the basename
    // prefixed to ensure non-JS scenarios work, so strip it since we'll
    // re-prefix in the router
    let attr = target.getAttribute("formaction") || form.getAttribute("action");
    action = attr ? stripBasename(attr, basename) : null;
    method = target.getAttribute("formmethod") || form.getAttribute("method") || defaultMethod;
    encType = getFormEncType(target.getAttribute("formenctype")) || getFormEncType(form.getAttribute("enctype")) || defaultEncType;
    // Build a FormData object populated from a form and submitter
    formData = new FormData(form, target);
    // If this browser doesn't support the `FormData(el, submitter)` format,
    // then tack on the submitter value at the end.  This is a lightweight
    // solution that is not 100% spec compliant.  For complete support in older
    // browsers, consider using the `formdata-submitter-polyfill` package
    if (!isFormDataSubmitterSupported()) {
      let {
        name,
        type,
        value
      } = target;
      if (type === "image") {
        let prefix = name ? name + "." : "";
        formData.append(prefix + "x", "0");
        formData.append(prefix + "y", "0");
      } else if (name) {
        formData.append(name, value);
      }
    }
  } else if (isHtmlElement(target)) {
    throw new Error("Cannot submit element that is not <form>, <button>, or " + "<input type=\"submit|image\">");
  } else {
    method = defaultMethod;
    action = null;
    encType = defaultEncType;
    body = target;
  }
  // Send body for <Form encType="text/plain" so we encode it into text
  if (formData && encType === "text/plain") {
    body = formData;
    formData = undefined;
  }
  return {
    action,
    method: method.toLowerCase(),
    encType,
    formData,
    body
  };
}
const _excluded$d = ["onClick", "relative", "reloadDocument", "replace", "state", "target", "to", "preventScrollReset", "unstable_viewTransition"],
  _excluded2$1 = ["aria-current", "caseSensitive", "className", "end", "style", "to", "unstable_viewTransition", "children"],
  _excluded3$1 = ["fetcherKey", "navigate", "reloadDocument", "replace", "state", "method", "action", "onSubmit", "relative", "preventScrollReset", "unstable_viewTransition"];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const REACT_ROUTER_VERSION = "6";
try {
  window.__reactRouterVersion = REACT_ROUTER_VERSION;
} catch (e) {
  // no-op
}
const ViewTransitionContext = /*#__PURE__*/React.createContext({
  isTransitioning: false
});
if (process.env.NODE_ENV !== "production") {
  ViewTransitionContext.displayName = "ViewTransition";
}
const FetchersContext = /*#__PURE__*/React.createContext(new Map());
if (process.env.NODE_ENV !== "production") {
  FetchersContext.displayName = "Fetchers";
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/
const START_TRANSITION = "startTransition";
const startTransitionImpl = React[START_TRANSITION];
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */
function HashRouter(_ref5) {
  let {
    basename,
    children,
    future,
    window
  } = _ref5;
  let historyRef = React.useRef();
  if (historyRef.current == null) {
    historyRef.current = createHashHistory({
      window,
      v5Compat: true
    });
  }
  let history = historyRef.current;
  let [state, setStateImpl] = React.useState({
    action: history.action,
    location: history.location
  });
  let {
    v7_startTransition
  } = future || {};
  let setState = React.useCallback(newState => {
    v7_startTransition && startTransitionImpl ? startTransitionImpl(() => setStateImpl(newState)) : setStateImpl(newState);
  }, [setStateImpl, v7_startTransition]);
  React.useLayoutEffect(() => history.listen(setState), [history, setState]);
  return /*#__PURE__*/React.createElement(Router, {
    basename: basename,
    children: children,
    location: state.location,
    navigationType: state.action,
    navigator: history,
    future: future
  });
}
if (process.env.NODE_ENV !== "production") ;
const isBrowser$9 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */
const Link = /*#__PURE__*/React.forwardRef(function LinkWithRef(_ref7, ref) {
  let {
      onClick,
      relative,
      reloadDocument,
      replace,
      state,
      target,
      to,
      preventScrollReset,
      unstable_viewTransition
    } = _ref7,
    rest = _objectWithoutPropertiesLoose$3(_ref7, _excluded$d);
  let {
    basename
  } = React.useContext(NavigationContext);
  // Rendered into <a href> for absolute URLs
  let absoluteHref;
  let isExternal = false;
  if (typeof to === "string" && ABSOLUTE_URL_REGEX.test(to)) {
    // Render the absolute href server- and client-side
    absoluteHref = to;
    // Only check for external origins client-side
    if (isBrowser$9) {
      try {
        let currentUrl = new URL(window.location.href);
        let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
        let path = stripBasename(targetUrl.pathname, basename);
        if (targetUrl.origin === currentUrl.origin && path != null) {
          // Strip the protocol/origin/basename for same-origin absolute URLs
          to = path + targetUrl.search + targetUrl.hash;
        } else {
          isExternal = true;
        }
      } catch (e) {
        // We can't do external URL detection without a valid URL
        process.env.NODE_ENV !== "production" ? warning$2(false, "<Link to=\"" + to + "\"> contains an invalid URL which will probably break " + "when clicked - please update to a valid URL path.") : void 0;
      }
    }
  }
  // Rendered into <a href> for relative URLs
  let href = useHref(to, {
    relative
  });
  let internalOnClick = useLinkClickHandler(to, {
    replace,
    state,
    target,
    preventScrollReset,
    relative,
    unstable_viewTransition
  });
  function handleClick(event) {
    if (onClick) onClick(event);
    if (!event.defaultPrevented) {
      internalOnClick(event);
    }
  }
  return /*#__PURE__*/(
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    React.createElement("a", _extends$5({}, rest, {
      href: absoluteHref || href,
      onClick: isExternal || reloadDocument ? onClick : handleClick,
      ref: ref,
      target: target
    }))
  );
});
if (process.env.NODE_ENV !== "production") {
  Link.displayName = "Link";
}
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */
const NavLink = /*#__PURE__*/React.forwardRef(function NavLinkWithRef(_ref8, ref) {
  let {
      "aria-current": ariaCurrentProp = "page",
      caseSensitive = false,
      className: classNameProp = "",
      end = false,
      style: styleProp,
      to,
      unstable_viewTransition,
      children
    } = _ref8,
    rest = _objectWithoutPropertiesLoose$3(_ref8, _excluded2$1);
  let path = useResolvedPath(to, {
    relative: rest.relative
  });
  let location = useLocation();
  let routerState = React.useContext(DataRouterStateContext);
  let {
    navigator,
    basename
  } = React.useContext(NavigationContext);
  let isTransitioning = routerState != null &&
  // Conditional usage is OK here because the usage of a data router is static
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useViewTransitionState(path) && unstable_viewTransition === true;
  let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
  let locationPathname = location.pathname;
  let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
  if (!caseSensitive) {
    locationPathname = locationPathname.toLowerCase();
    nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
    toPathname = toPathname.toLowerCase();
  }
  if (nextLocationPathname && basename) {
    nextLocationPathname = stripBasename(nextLocationPathname, basename) || nextLocationPathname;
  }
  // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
  // we're looking for a slash _after_ what's in `to`.  For example:
  //
  // <NavLink to="/users"> and <NavLink to="/users/">
  // both want to look for a / at index 6 to match URL `/users/matt`
  const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
  let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
  let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
  let renderProps = {
    isActive,
    isPending,
    isTransitioning
  };
  let ariaCurrent = isActive ? ariaCurrentProp : undefined;
  let className;
  if (typeof classNameProp === "function") {
    className = classNameProp(renderProps);
  } else {
    // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [classNameProp, isActive ? "active" : null, isPending ? "pending" : null, isTransitioning ? "transitioning" : null].filter(Boolean).join(" ");
  }
  let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
  return /*#__PURE__*/React.createElement(Link, _extends$5({}, rest, {
    "aria-current": ariaCurrent,
    className: className,
    ref: ref,
    style: style,
    to: to,
    unstable_viewTransition: unstable_viewTransition
  }), typeof children === "function" ? children(renderProps) : children);
});
if (process.env.NODE_ENV !== "production") {
  NavLink.displayName = "NavLink";
}
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */
const Form = /*#__PURE__*/React.forwardRef((_ref9, forwardedRef) => {
  let {
      fetcherKey,
      navigate,
      reloadDocument,
      replace,
      state,
      method = defaultMethod,
      action,
      onSubmit,
      relative,
      preventScrollReset,
      unstable_viewTransition
    } = _ref9,
    props = _objectWithoutPropertiesLoose$3(_ref9, _excluded3$1);
  let submit = useSubmit();
  let formAction = useFormAction(action, {
    relative
  });
  let formMethod = method.toLowerCase() === "get" ? "get" : "post";
  let submitHandler = event => {
    onSubmit && onSubmit(event);
    if (event.defaultPrevented) return;
    event.preventDefault();
    let submitter = event.nativeEvent.submitter;
    let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
    submit(submitter || event.currentTarget, {
      fetcherKey,
      method: submitMethod,
      navigate,
      replace,
      state,
      relative,
      preventScrollReset,
      unstable_viewTransition
    });
  };
  return /*#__PURE__*/React.createElement("form", _extends$5({
    ref: forwardedRef,
    method: formMethod,
    action: formAction,
    onSubmit: reloadDocument ? onSubmit : submitHandler
  }, props));
});
if (process.env.NODE_ENV !== "production") {
  Form.displayName = "Form";
}
if (process.env.NODE_ENV !== "production") ;
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var DataRouterHook;
(function (DataRouterHook) {
  DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
  DataRouterHook["UseSubmit"] = "useSubmit";
  DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
  DataRouterHook["UseFetcher"] = "useFetcher";
  DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})(DataRouterHook || (DataRouterHook = {}));
var DataRouterStateHook;
(function (DataRouterStateHook) {
  DataRouterStateHook["UseFetcher"] = "useFetcher";
  DataRouterStateHook["UseFetchers"] = "useFetchers";
  DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})(DataRouterStateHook || (DataRouterStateHook = {}));
// Internal hooks
function getDataRouterConsoleError(hookName) {
  return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function useDataRouterContext(hookName) {
  let ctx = React.useContext(DataRouterContext);
  !ctx ? process.env.NODE_ENV !== "production" ? invariant$1(false, getDataRouterConsoleError(hookName)) : invariant$1(false) : void 0;
  return ctx;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */
function useLinkClickHandler(to, _temp) {
  let {
    target,
    replace: replaceProp,
    state,
    preventScrollReset,
    relative,
    unstable_viewTransition
  } = _temp === void 0 ? {} : _temp;
  let navigate = useNavigate();
  let location = useLocation();
  let path = useResolvedPath(to, {
    relative
  });
  return React.useCallback(event => {
    if (shouldProcessLinkClick(event, target)) {
      event.preventDefault();
      // If the URL hasn't changed, a regular <a> will do a replace instead of
      // a push, so do the same here unless the replace prop is explicitly set
      let replace = replaceProp !== undefined ? replaceProp : createPath(location) === createPath(path);
      navigate(to, {
        replace,
        state,
        preventScrollReset,
        relative,
        unstable_viewTransition
      });
    }
  }, [location, navigate, path, replaceProp, state, target, to, preventScrollReset, relative, unstable_viewTransition]);
}
function validateClientSideSubmission() {
  if (typeof document === "undefined") {
    throw new Error("You are calling submit during the server render. " + "Try calling submit within a `useEffect` or callback instead.");
  }
}
let fetcherId = 0;
let getUniqueFetcherId = () => "__" + String(++fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */
function useSubmit() {
  let {
    router
  } = useDataRouterContext(DataRouterHook.UseSubmit);
  let {
    basename
  } = React.useContext(NavigationContext);
  let currentRouteId = useRouteId();
  return React.useCallback(function (target, options) {
    if (options === void 0) {
      options = {};
    }
    validateClientSideSubmission();
    let {
      action,
      method,
      encType,
      formData,
      body
    } = getFormSubmissionInfo(target, basename);
    if (options.navigate === false) {
      let key = options.fetcherKey || getUniqueFetcherId();
      router.fetch(key, currentRouteId, options.action || action, {
        preventScrollReset: options.preventScrollReset,
        formData,
        body,
        formMethod: options.method || method,
        formEncType: options.encType || encType,
        unstable_flushSync: options.unstable_flushSync
      });
    } else {
      router.navigate(options.action || action, {
        preventScrollReset: options.preventScrollReset,
        formData,
        body,
        formMethod: options.method || method,
        formEncType: options.encType || encType,
        replace: options.replace,
        state: options.state,
        fromRouteId: currentRouteId,
        unstable_flushSync: options.unstable_flushSync,
        unstable_viewTransition: options.unstable_viewTransition
      });
    }
  }, [router, basename, currentRouteId]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function useFormAction(action, _temp2) {
  let {
    relative
  } = _temp2 === void 0 ? {} : _temp2;
  let {
    basename
  } = React.useContext(NavigationContext);
  let routeContext = React.useContext(RouteContext);
  !routeContext ? process.env.NODE_ENV !== "production" ? invariant$1(false, "useFormAction must be used inside a RouteContext") : invariant$1(false) : void 0;
  let [match] = routeContext.matches.slice(-1);
  // Shallow clone path so we can modify it below, otherwise we modify the
  // object referenced by useMemo inside useResolvedPath
  let path = _extends$5({}, useResolvedPath(action ? action : ".", {
    relative
  }));
  // If no action was specified, browsers will persist current search params
  // when determining the path, so match that behavior
  // https://github.com/remix-run/remix/issues/927
  let location = useLocation();
  if (action == null) {
    // Safe to write to this directly here since if action was undefined, we
    // would have called useResolvedPath(".") which will never include a search
    path.search = location.search;
    // When grabbing search params from the URL, remove any included ?index param
    // since it might not apply to our contextual route.  We add it back based
    // on match.route.index below
    let params = new URLSearchParams(path.search);
    if (params.has("index") && params.get("index") === "") {
      params.delete("index");
      path.search = params.toString() ? "?" + params.toString() : "";
    }
  }
  if ((!action || action === ".") && match.route.index) {
    path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
  }
  // If we're operating within a basename, prepend it to the pathname prior
  // to creating the form action.  If this is a root navigation, then just use
  // the raw basename which allows the basename to have full control over the
  // presence of a trailing slash on root actions
  if (basename !== "/") {
    path.pathname = path.pathname === "/" ? basename : joinPaths([basename, path.pathname]);
  }
  return createPath(path);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */
function useViewTransitionState(to, opts) {
  if (opts === void 0) {
    opts = {};
  }
  let vtContext = React.useContext(ViewTransitionContext);
  !(vtContext != null) ? process.env.NODE_ENV !== "production" ? invariant$1(false, "`unstable_useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  " + "Did you accidentally import `RouterProvider` from `react-router`?") : invariant$1(false) : void 0;
  let {
    basename
  } = useDataRouterContext(DataRouterHook.useViewTransitionState);
  let path = useResolvedPath(to, {
    relative: opts.relative
  });
  if (!vtContext.isTransitioning) {
    return false;
  }
  let currentPath = stripBasename(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
  let nextPath = stripBasename(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
  // Transition is active if we're going to or coming from the indicated
  // destination.  This ensures that other PUSH navigations that reverse
  // an indicated transition apply.  I.e., on the list view you have:
  //
  //   <NavLink to="/details/1" unstable_viewTransition>
  //
  // If you click the breadcrumb back to the list view:
  //
  //   <NavLink to="/list" unstable_viewTransition>
  //
  // We should apply the transition because it's indicated as active going
  // from /list -> /details/1 and therefore should be active on the reverse
  // (even though this isn't strictly a POP reverse)
  return matchPath(path.pathname, nextPath) != null || matchPath(path.pathname, currentPath) != null;
}

// This optional code is used to register a service worker.
// register() is not called by default.

// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on subsequent visits to a page, after all the
// existing tabs open on the page have been closed, since previously cached
// resources are updated in the background.

// To learn more about the benefits of this model and instructions on how to
// opt-in, read https://cra.link/PWA

const isLocalhost = Boolean(window.location.hostname === 'localhost' ||
// [::1] is the IPv6 localhost address.
window.location.hostname === '[::1]' ||
// 127.0.0.0/8 are considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));
function register(config) {
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    // The URL constructor is available in all browsers that support SW.
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      // Our service worker won't work if PUBLIC_URL is on a different origin
      // from what our page is served on. This might happen if a CDN is used to
      // serve assets; see https://github.com/facebook/create-react-app/issues/2374
      return;
    }
    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
      if (isLocalhost) {
        // This is running on localhost. Let's check if a service worker still exists or not.
        checkValidServiceWorker(swUrl, config);

        // Add some additional logging to localhost, pointing developers to the
        // service worker/PWA documentation.
        navigator.serviceWorker.ready.then(() => {
          console.log('This web app is being served cache-first by a service ' + 'worker. To learn more, visit https://cra.link/PWA');
        });
      } else {
        // Is not localhost. Just register service worker
        registerValidSW(swUrl, config);
      }
    });
  }
}
function registerValidSW(swUrl, config) {
  navigator.serviceWorker.register(swUrl).then(registration => {
    registration.onupdatefound = () => {
      const installingWorker = registration.installing;
      if (installingWorker == null) {
        return;
      }
      installingWorker.onstatechange = () => {
        if (installingWorker.state === 'installed') {
          if (navigator.serviceWorker.controller) {
            // At this point, the updated precached content has been fetched,
            // but the previous service worker will still serve the older
            // content until all client tabs are closed.
            console.log('New content is available and will be used when all ' + 'tabs for this page are closed. See https://cra.link/PWA.');

            // Execute callback
            if (config && config.onUpdate) {
              config.onUpdate(registration);
            }
          } else {
            // At this point, everything has been precached.
            // It's the perfect time to display a
            // "Content is cached for offline use." message.
            console.log('Content is cached for offline use.');

            // Execute callback
            if (config && config.onSuccess) {
              config.onSuccess(registration);
            }
          }
        }
      };
    };
  }).catch(error => {
    console.error('Error during service worker registration:', error);
  });
}
function checkValidServiceWorker(swUrl, config) {
  // Check if the service worker can be found. If it can't reload the page.
  fetch(swUrl, {
    headers: {
      'Service-Worker': 'script'
    }
  }).then(response => {
    // Ensure service worker exists, and that we really are getting a JS file.
    const contentType = response.headers.get('content-type');
    if (response.status === 404 || contentType != null && contentType.indexOf('javascript') === -1) {
      // No service worker found. Probably a different app. Reload the page.
      navigator.serviceWorker.ready.then(registration => {
        registration.unregister().then(() => {
          window.location.reload();
        });
      });
    } else {
      // Service worker found. Proceed as normal.
      registerValidSW(swUrl, config);
    }
  }).catch(() => {
    console.log('No internet connection found. App is running in offline mode.');
  });
}

const reportWebVitals = onPerfEntry => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    Promise.resolve().then(function () { return webVitals_es5_min; }).then(({
      getCLS,
      getFID,
      getFCP,
      getLCP,
      getTTFB
    }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
};

function n$9(n) {
  for (var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++) t[e - 1] = arguments[e];
  if ("production" !== process.env.NODE_ENV) {
    var i = Y$4[n],
      o = i ? "function" == typeof i ? i.apply(null, t) : i : "unknown error nr: " + n;
    throw Error("[Immer] " + o);
  }
  throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function (n) {
    return "'" + n + "'";
  }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r$9(n) {
  return !!n && !!n[Q$3];
}
function t$c(n) {
  var r;
  return !!n && (function (n) {
    if (!n || "object" != typeof n) return !1;
    var r = Object.getPrototypeOf(n);
    if (null === r) return !0;
    var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
    return t === Object || "function" == typeof t && Function.toString.call(t) === Z$4;
  }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s$e(n) || v$9(n));
}
function i$b(n, r, t) {
  void 0 === t && (t = !1), 0 === o$b(n) ? (t ? Object.keys : nn)(n).forEach(function (e) {
    t && "symbol" == typeof e || r(e, n[e], n);
  }) : n.forEach(function (t, e) {
    return r(e, t, n);
  });
}
function o$b(n) {
  var r = n[Q$3];
  return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s$e(n) ? 2 : v$9(n) ? 3 : 0;
}
function u$b(n, r) {
  return 2 === o$b(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a$b(n, r) {
  return 2 === o$b(n) ? n.get(r) : n[r];
}
function f$d(n, r, t) {
  var e = o$b(n);
  2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c$9(n, r) {
  return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s$e(n) {
  return X$3 && n instanceof Map;
}
function v$9(n) {
  return q$6 && n instanceof Set;
}
function p$a(n) {
  return n.o || n.t;
}
function l$9(n) {
  if (Array.isArray(n)) return Array.prototype.slice.call(n);
  var r = rn(n);
  delete r[Q$3];
  for (var t = nn(r), e = 0; e < t.length; e++) {
    var i = t[e],
      o = r[i];
    !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
      configurable: !0,
      writable: !0,
      enumerable: o.enumerable,
      value: n[i]
    });
  }
  return Object.create(Object.getPrototypeOf(n), r);
}
function d$b(n, e) {
  return void 0 === e && (e = !1), y$6(n) || r$9(n) || !t$c(n) || (o$b(n) > 1 && (n.set = n.add = n.clear = n.delete = h$9), Object.freeze(n), e && i$b(n, function (n, r) {
    return d$b(r, !0);
  }, !0)), n;
}
function h$9() {
  n$9(2);
}
function y$6(n) {
  return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b$8(r) {
  var t = tn[r];
  return t || n$9(18, r), t;
}
function m$7(n, r) {
  tn[n] || (tn[n] = r);
}
function _$7() {
  return "production" === process.env.NODE_ENV || U$5 || n$9(0), U$5;
}
function j$4(n, r) {
  r && (b$8("Patches"), n.u = [], n.s = [], n.v = r);
}
function g$6(n) {
  O$3(n), n.p.forEach(S$8), n.p = null;
}
function O$3(n) {
  n === U$5 && (U$5 = n.l);
}
function w$8(n) {
  return U$5 = {
    p: [],
    l: U$5,
    h: n,
    m: !0,
    _: 0
  };
}
function S$8(n) {
  var r = n[Q$3];
  0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P$2(r, e) {
  e._ = e.p.length;
  var i = e.p[0],
    o = void 0 !== r && r !== i;
  return e.h.O || b$8("ES5").S(e, r, o), o ? (i[Q$3].P && (g$6(e), n$9(4)), t$c(r) && (r = M$5(e, r), e.l || x$4(e, r)), e.u && b$8("Patches").M(i[Q$3].t, r, e.u, e.s)) : r = M$5(e, i, []), g$6(e), e.u && e.v(e.u, e.s), r !== H$2 ? r : void 0;
}
function M$5(n, r, t) {
  if (y$6(r)) return r;
  var e = r[Q$3];
  if (!e) return i$b(r, function (i, o) {
    return A$3(n, e, r, i, o, t);
  }, !0), r;
  if (e.A !== n) return r;
  if (!e.P) return x$4(n, e.t, !0), e.t;
  if (!e.I) {
    e.I = !0, e.A._--;
    var o = 4 === e.i || 5 === e.i ? e.o = l$9(e.k) : e.o,
      u = o,
      a = !1;
    3 === e.i && (u = new Set(o), o.clear(), a = !0), i$b(u, function (r, i) {
      return A$3(n, e, o, r, i, t, a);
    }), x$4(n, o, !1), t && n.u && b$8("Patches").N(e, t, n.u, n.s);
  }
  return e.o;
}
function A$3(e, i, o, a, c, s, v) {
  if ("production" !== process.env.NODE_ENV && c === o && n$9(5), r$9(c)) {
    var p = M$5(e, c, s && i && 3 !== i.i && !u$b(i.R, a) ? s.concat(a) : void 0);
    if (f$d(o, a, p), !r$9(p)) return;
    e.m = !1;
  } else v && o.add(c);
  if (t$c(c) && !y$6(c)) {
    if (!e.h.D && e._ < 1) return;
    M$5(e, c), i && i.A.l || x$4(e, c);
  }
}
function x$4(n, r, t) {
  void 0 === t && (t = !1), !n.l && n.h.D && n.m && d$b(r, t);
}
function z$4(n, r) {
  var t = n[Q$3];
  return (t ? p$a(t) : n)[r];
}
function I$8(n, r) {
  if (r in n) for (var t = Object.getPrototypeOf(n); t;) {
    var e = Object.getOwnPropertyDescriptor(t, r);
    if (e) return e;
    t = Object.getPrototypeOf(t);
  }
}
function k$5(n) {
  n.P || (n.P = !0, n.l && k$5(n.l));
}
function E$2(n) {
  n.o || (n.o = l$9(n.t));
}
function N$4(n, r, t) {
  var e = s$e(r) ? b$8("MapSet").F(r, t) : v$9(r) ? b$8("MapSet").T(r, t) : n.O ? function (n, r) {
    var t = Array.isArray(n),
      e = {
        i: t ? 1 : 0,
        A: r ? r.A : _$7(),
        P: !1,
        I: !1,
        R: {},
        l: r,
        t: n,
        k: null,
        o: null,
        j: null,
        C: !1
      },
      i = e,
      o = en;
    t && (i = [e], o = on);
    var u = Proxy.revocable(i, o),
      a = u.revoke,
      f = u.proxy;
    return e.k = f, e.j = a, f;
  }(r, t) : b$8("ES5").J(r, t);
  return (t ? t.A : _$7()).p.push(e), e;
}
function R$2(e) {
  return r$9(e) || n$9(22, e), function n(r) {
    if (!t$c(r)) return r;
    var e,
      u = r[Q$3],
      c = o$b(r);
    if (u) {
      if (!u.P && (u.i < 4 || !b$8("ES5").K(u))) return u.t;
      u.I = !0, e = D$5(r, c), u.I = !1;
    } else e = D$5(r, c);
    return i$b(e, function (r, t) {
      u && a$b(u.t, r) === t || f$d(e, r, n(t));
    }), 3 === c ? new Set(e) : e;
  }(e);
}
function D$5(n, r) {
  switch (r) {
    case 2:
      return new Map(n);
    case 3:
      return Array.from(n);
  }
  return l$9(n);
}
function F$8() {
  function t(n, r) {
    var t = s[n];
    return t ? t.enumerable = r : s[n] = t = {
      configurable: !0,
      enumerable: r,
      get: function () {
        var r = this[Q$3];
        return "production" !== process.env.NODE_ENV && f(r), en.get(r, n);
      },
      set: function (r) {
        var t = this[Q$3];
        "production" !== process.env.NODE_ENV && f(t), en.set(t, n, r);
      }
    }, t;
  }
  function e(n) {
    for (var r = n.length - 1; r >= 0; r--) {
      var t = n[r][Q$3];
      if (!t.P) switch (t.i) {
        case 5:
          a(t) && k$5(t);
          break;
        case 4:
          o(t) && k$5(t);
      }
    }
  }
  function o(n) {
    for (var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--) {
      var o = e[i];
      if (o !== Q$3) {
        var a = r[o];
        if (void 0 === a && !u$b(r, o)) return !0;
        var f = t[o],
          s = f && f[Q$3];
        if (s ? s.t !== a : !c$9(f, a)) return !0;
      }
    }
    var v = !!r[Q$3];
    return e.length !== nn(r).length + (v ? 0 : 1);
  }
  function a(n) {
    var r = n.k;
    if (r.length !== n.t.length) return !0;
    var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
    if (t && !t.get) return !0;
    for (var e = 0; e < r.length; e++) if (!r.hasOwnProperty(e)) return !0;
    return !1;
  }
  function f(r) {
    r.g && n$9(3, JSON.stringify(p$a(r)));
  }
  var s = {};
  m$7("ES5", {
    J: function (n, r) {
      var e = Array.isArray(n),
        i = function (n, r) {
          if (n) {
            for (var e = Array(r.length), i = 0; i < r.length; i++) Object.defineProperty(e, "" + i, t(i, !0));
            return e;
          }
          var o = rn(r);
          delete o[Q$3];
          for (var u = nn(o), a = 0; a < u.length; a++) {
            var f = u[a];
            o[f] = t(f, n || !!o[f].enumerable);
          }
          return Object.create(Object.getPrototypeOf(r), o);
        }(e, n),
        o = {
          i: e ? 5 : 4,
          A: r ? r.A : _$7(),
          P: !1,
          I: !1,
          R: {},
          l: r,
          t: n,
          k: i,
          o: null,
          g: !1,
          C: !1
        };
      return Object.defineProperty(i, Q$3, {
        value: o,
        writable: !0
      }), i;
    },
    S: function (n, t, o) {
      o ? r$9(t) && t[Q$3].A === n && e(n.p) : (n.u && function n(r) {
        if (r && "object" == typeof r) {
          var t = r[Q$3];
          if (t) {
            var e = t.t,
              o = t.k,
              f = t.R,
              c = t.i;
            if (4 === c) i$b(o, function (r) {
              r !== Q$3 && (void 0 !== e[r] || u$b(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k$5(t)));
            }), i$b(e, function (n) {
              void 0 !== o[n] || u$b(o, n) || (f[n] = !1, k$5(t));
            });else if (5 === c) {
              if (a(t) && (k$5(t), f.length = !0), o.length < e.length) for (var s = o.length; s < e.length; s++) f[s] = !1;else for (var v = e.length; v < o.length; v++) f[v] = !0;
              for (var p = Math.min(o.length, e.length), l = 0; l < p; l++) o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
            }
          }
        }
      }(n.p[0]), e(n.p));
    },
    K: function (n) {
      return 4 === n.i ? o(n) : a(n);
    }
  });
}
var G$2,
  U$5,
  W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"),
  X$3 = "undefined" != typeof Map,
  q$6 = "undefined" != typeof Set,
  B$3 = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect,
  H$2 = W ? Symbol.for("immer-nothing") : ((G$2 = {})["immer-nothing"] = !0, G$2),
  L = W ? Symbol.for("immer-draftable") : "__$immer_draftable",
  Q$3 = W ? Symbol.for("immer-state") : "__$immer_state",
  Y$4 = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function (n) {
      return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function (n) {
      return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function (n) {
      return "Unsupported patch operation: " + n;
    },
    18: function (n) {
      return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function (n) {
      return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function (n) {
      return "'current' expects a draft, got: " + n;
    },
    23: function (n) {
      return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
  },
  Z$4 = "" + Object.prototype.constructor,
  nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function (n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
  } : Object.getOwnPropertyNames,
  rn = Object.getOwnPropertyDescriptors || function (n) {
    var r = {};
    return nn(n).forEach(function (t) {
      r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
  },
  tn = {},
  en = {
    get: function (n, r) {
      if (r === Q$3) return n;
      var e = p$a(n);
      if (!u$b(e, r)) return function (n, r, t) {
        var e,
          i = I$8(r, t);
        return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
      }(n, e, r);
      var i = e[r];
      return n.I || !t$c(i) ? i : i === z$4(n.t, r) ? (E$2(n), n.o[r] = N$4(n.A.h, i, n)) : i;
    },
    has: function (n, r) {
      return r in p$a(n);
    },
    ownKeys: function (n) {
      return Reflect.ownKeys(p$a(n));
    },
    set: function (n, r, t) {
      var e = I$8(p$a(n), r);
      if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
      if (!n.P) {
        var i = z$4(p$a(n), r),
          o = null == i ? void 0 : i[Q$3];
        if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
        if (c$9(t, i) && (void 0 !== t || u$b(n.t, r))) return !0;
        E$2(n), k$5(n);
      }
      return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function (n, r) {
      return void 0 !== z$4(n.t, r) || r in n.t ? (n.R[r] = !1, E$2(n), k$5(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function (n, r) {
      var t = p$a(n),
        e = Reflect.getOwnPropertyDescriptor(t, r);
      return e ? {
        writable: !0,
        configurable: 1 !== n.i || "length" !== r,
        enumerable: e.enumerable,
        value: t[r]
      } : e;
    },
    defineProperty: function () {
      n$9(11);
    },
    getPrototypeOf: function (n) {
      return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function () {
      n$9(12);
    }
  },
  on = {};
i$b(en, function (n, r) {
  on[n] = function () {
    return arguments[0] = arguments[0][0], r.apply(this, arguments);
  };
}), on.deleteProperty = function (r, t) {
  return "production" !== process.env.NODE_ENV && isNaN(parseInt(t)) && n$9(13), on.set.call(this, r, t, void 0);
}, on.set = function (r, t, e) {
  return "production" !== process.env.NODE_ENV && "length" !== t && isNaN(parseInt(t)) && n$9(14), en.set.call(this, r[0], t, e, r[0]);
};
var un = function () {
    function e(r) {
      var e = this;
      this.O = B$3, this.D = !0, this.produce = function (r, i, o) {
        if ("function" == typeof r && "function" != typeof i) {
          var u = i;
          i = r;
          var a = e;
          return function (n) {
            var r = this;
            void 0 === n && (n = u);
            for (var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++) e[o - 1] = arguments[o];
            return a.produce(n, function (n) {
              var t;
              return (t = i).call.apply(t, [r, n].concat(e));
            });
          };
        }
        var f;
        if ("function" != typeof i && n$9(6), void 0 !== o && "function" != typeof o && n$9(7), t$c(r)) {
          var c = w$8(e),
            s = N$4(e, r, void 0),
            v = !0;
          try {
            f = i(s), v = !1;
          } finally {
            v ? g$6(c) : O$3(c);
          }
          return "undefined" != typeof Promise && f instanceof Promise ? f.then(function (n) {
            return j$4(c, o), P$2(n, c);
          }, function (n) {
            throw g$6(c), n;
          }) : (j$4(c, o), P$2(f, c));
        }
        if (!r || "object" != typeof r) {
          if (void 0 === (f = i(r)) && (f = r), f === H$2 && (f = void 0), e.D && d$b(f, !0), o) {
            var p = [],
              l = [];
            b$8("Patches").M(r, f, p, l), o(p, l);
          }
          return f;
        }
        n$9(21, r);
      }, this.produceWithPatches = function (n, r) {
        if ("function" == typeof n) return function (r) {
          for (var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++) i[o - 1] = arguments[o];
          return e.produceWithPatches(r, function (r) {
            return n.apply(void 0, [r].concat(i));
          });
        };
        var t,
          i,
          o = e.produce(n, r, function (n, r) {
            t = n, i = r;
          });
        return "undefined" != typeof Promise && o instanceof Promise ? o.then(function (n) {
          return [n, t, i];
        }) : [o, t, i];
      }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function (e) {
      t$c(e) || n$9(8), r$9(e) && (e = R$2(e));
      var i = w$8(this),
        o = N$4(this, e, void 0);
      return o[Q$3].C = !0, O$3(i), o;
    }, i.finishDraft = function (r, t) {
      var e = r && r[Q$3];
      "production" !== process.env.NODE_ENV && (e && e.C || n$9(9), e.I && n$9(10));
      var i = e.A;
      return j$4(i, t), P$2(void 0, i);
    }, i.setAutoFreeze = function (n) {
      this.D = n;
    }, i.setUseProxies = function (r) {
      r && !B$3 && n$9(20), this.O = r;
    }, i.applyPatches = function (n, t) {
      var e;
      for (e = t.length - 1; e >= 0; e--) {
        var i = t[e];
        if (0 === i.path.length && "replace" === i.op) {
          n = i.value;
          break;
        }
      }
      e > -1 && (t = t.slice(e + 1));
      var o = b$8("Patches").$;
      return r$9(n) ? o(n, t) : this.produce(n, function (n) {
        return o(n, t);
      });
    }, e;
  }(),
  an = new un(),
  fn = an.produce;
  an.produceWithPatches.bind(an);
  an.setAutoFreeze.bind(an);
  an.setUseProxies.bind(an);
  an.applyPatches.bind(an);
  an.createDraft.bind(an);
  an.finishDraft.bind(an);

function _typeof$5(o) {
  "@babel/helpers - typeof";

  return _typeof$5 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof$5(o);
}

function toPrimitive$2(t, r) {
  if ("object" != _typeof$5(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof$5(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

function toPropertyKey$1(t) {
  var i = toPrimitive$2(t, "string");
  return "symbol" == _typeof$5(i) ? i : i + "";
}

function _defineProperty$5(e, r, t) {
  return (r = toPropertyKey$1(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}

function ownKeys$4(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2$2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$4(Object(t), !0).forEach(function (r) {
      _defineProperty$5(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$4(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}

/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */
function formatProdErrorMessage(code) {
  return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}

// Inlined version of the `symbol-observable` polyfill
var $$observable = function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();

/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};
var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject$2(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;
  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }
  return Object.getPrototypeOf(obj) === proto;
}

// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function miniKindOf(val) {
  if (val === void 0) return 'undefined';
  if (val === null) return 'null';
  var type = typeof val;
  switch (type) {
    case 'boolean':
    case 'string':
    case 'number':
    case 'symbol':
    case 'function':
      {
        return type;
      }
  }
  if (Array.isArray(val)) return 'array';
  if (isDate$1(val)) return 'date';
  if (isError$1(val)) return 'error';
  var constructorName = ctorName(val);
  switch (constructorName) {
    case 'Symbol':
    case 'Promise':
    case 'WeakMap':
    case 'WeakSet':
    case 'Map':
    case 'Set':
      return constructorName;
  } // other

  return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}
function ctorName(val) {
  return typeof val.constructor === 'function' ? val.constructor.name : null;
}
function isError$1(val) {
  return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}
function isDate$1(val) {
  if (val instanceof Date) return true;
  return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}
function kindOf(val) {
  var typeOfVal = typeof val;
  if (process.env.NODE_ENV !== 'production') {
    typeOfVal = miniKindOf(val);
  }
  return typeOfVal;
}

/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;
  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(0) : 'It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.');
  }
  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }
  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(1) : "Expected the enhancer to be a function. Instead, received: '" + kindOf(enhancer) + "'");
    }
    return enhancer(createStore)(reducer, preloadedState);
  }
  if (typeof reducer !== 'function') {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(2) : "Expected the root reducer to be a function. Instead, received: '" + kindOf(reducer) + "'");
  }
  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */

  function getState() {
    if (isDispatching) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(3) : 'You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }
    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */

  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(4) : "Expected the listener to be a function. Instead, received: '" + kindOf(listener) + "'");
    }
    if (isDispatching) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(5) : 'You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api/store#subscribelistener for more details.');
    }
    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }
      if (isDispatching) {
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(6) : 'You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api/store#subscribelistener for more details.');
      }
      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */

  function dispatch(action) {
    if (!isPlainObject$2(action)) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(7) : "Actions must be plain objects. Instead, the actual type was: '" + kindOf(action) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
    }
    if (typeof action.type === 'undefined') {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    }
    if (isDispatching) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(9) : 'Reducers may not dispatch actions.');
    }
    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }
    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }
    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */

  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(10) : "Expected the nextReducer to be a function. Instead, received: '" + kindOf(nextReducer));
    }
    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */

  function observable() {
    var _ref;
    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(11) : "Expected the observer to be an object. Instead, received: '" + kindOf(observer) + "'");
        }
        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }
        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[$$observable] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.

  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[$$observable] = observable, _ref2;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning$1(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */

  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty
}
function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }
  if (!isPlainObject$2(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }
  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;
  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}
function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });
    if (typeof initialState === 'undefined') {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(12) : "The slice reducer for key \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
    }
    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(13) : "The slice reducer for key \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle '" + ActionTypes.INIT + "' or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */

function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];
    if (process.env.NODE_ENV !== 'production') {
      if (typeof reducers[key] === 'undefined') {
        warning$1("No reducer provided for key \"" + key + "\"");
      }
    }
    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
  // keys multiple times.

  var unexpectedKeyCache;
  if (process.env.NODE_ENV !== 'production') {
    unexpectedKeyCache = {};
  }
  var shapeAssertionError;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }
  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }
    if (shapeAssertionError) {
      throw shapeAssertionError;
    }
    if (process.env.NODE_ENV !== 'production') {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning$1(warningMessage);
      }
    }
    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var actionType = action && action.type;
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(14) : "When called with an action of type " + (actionType ? "\"" + String(actionType) + "\"" : '(unknown type)') + ", the slice reducer for key \"" + _key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.");
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose$2() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }
  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }
  if (funcs.length === 1) {
    return funcs[0];
  }
  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }
  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);
      var _dispatch = function dispatch() {
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(15) : 'Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
      };
      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose$2.apply(void 0, chain)(store.dispatch);
      return _objectSpread2$2(_objectSpread2$2({}, store), {}, {
        dispatch: _dispatch
      });
    };
  };
}

/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */
function createThunkMiddleware(extraArgument) {
  // Standard Redux middleware definition pattern:
  // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
  var middleware = function middleware(_ref) {
    var dispatch = _ref.dispatch,
      getState = _ref.getState;
    return function (next) {
      return function (action) {
        // The thunk middleware looks for any functions that were passed to `store.dispatch`.
        // If this "action" is really a function, call it and return the result.
        if (typeof action === 'function') {
          // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
          return action(dispatch, getState, extraArgument);
        } // Otherwise, pass the action down the middleware chain as usual

        return next(action);
      };
    };
  };
  return middleware;
}
var thunk = createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks

thunk.withExtraArgument = createThunkMiddleware;

var __extends = undefined && undefined.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __generator = undefined && undefined.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __spreadArray = undefined && undefined.__spreadArray || function (to, from) {
  for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
  return to;
};
var __defProp$2 = Object.defineProperty;
var __defProps$1 = Object.defineProperties;
var __getOwnPropDescs$1 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = function (obj, key, value) {
  return key in obj ? __defProp$2(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2 = function (a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2.call(b, prop)) __defNormalProp$2(a, prop, b[prop]);
  if (__getOwnPropSymbols$2) for (var _i = 0, _c = __getOwnPropSymbols$2(b); _i < _c.length; _i++) {
    var prop = _c[_i];
    if (__propIsEnum$2.call(b, prop)) __defNormalProp$2(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps$1 = function (a, b) {
  return __defProps$1(a, __getOwnPropDescs$1(b));
};
var __async = function (__this, __arguments, generator) {
  return new Promise(function (resolve, reject) {
    var fulfilled = function (value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = function (value) {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = function (x) {
      return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    };
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
var composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function () {
  if (arguments.length === 0) return void 0;
  if (typeof arguments[0] === "object") return compose$2;
  return compose$2.apply(null, arguments);
};
// src/isPlainObject.ts
function isPlainObject$1(value) {
  if (typeof value !== "object" || value === null) return false;
  var proto = Object.getPrototypeOf(value);
  if (proto === null) return true;
  var baseProto = proto;
  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }
  return proto === baseProto;
}
// src/tsHelpers.ts
var hasMatchFunction = function (v) {
  return v && typeof v.match === "function";
};
// src/createAction.ts
function createAction(type, prepareAction) {
  function actionCreator() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    if (prepareAction) {
      var prepared = prepareAction.apply(void 0, args);
      if (!prepared) {
        throw new Error("prepareAction did not return an object");
      }
      return __spreadValues$2(__spreadValues$2({
        type: type,
        payload: prepared.payload
      }, "meta" in prepared && {
        meta: prepared.meta
      }), "error" in prepared && {
        error: prepared.error
      });
    }
    return {
      type: type,
      payload: args[0]
    };
  }
  actionCreator.toString = function () {
    return "" + type;
  };
  actionCreator.type = type;
  actionCreator.match = function (action) {
    return action.type === type;
  };
  return actionCreator;
}
function isActionCreator(action) {
  return typeof action === "function" && "type" in action && hasMatchFunction(action);
}
// src/actionCreatorInvariantMiddleware.ts
function getMessage(type) {
  var splitType = type ? ("" + type).split("/") : [];
  var actionName = splitType[splitType.length - 1] || "actionCreator";
  return "Detected an action creator with type \"" + (type || "unknown") + "\" being dispatched. \nMake sure you're calling the action creator before dispatching, i.e. `dispatch(" + actionName + "())` instead of `dispatch(" + actionName + ")`. This is necessary even if the action has no payload.";
}
function createActionCreatorInvariantMiddleware(options) {
  if (options === void 0) {
    options = {};
  }
  if (process.env.NODE_ENV === "production") {
    return function () {
      return function (next) {
        return function (action) {
          return next(action);
        };
      };
    };
  }
  var _c = options.isActionCreator,
    isActionCreator2 = _c === void 0 ? isActionCreator : _c;
  return function () {
    return function (next) {
      return function (action) {
        if (isActionCreator2(action)) {
          console.warn(getMessage(action.type));
        }
        return next(action);
      };
    };
  };
}
function getTimeMeasureUtils(maxDelay, fnName) {
  var elapsed = 0;
  return {
    measureTime: function (fn) {
      var started = Date.now();
      try {
        return fn();
      } finally {
        var finished = Date.now();
        elapsed += finished - started;
      }
    },
    warnIfExceeded: function () {
      if (elapsed > maxDelay) {
        console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
      }
    }
  };
}
var MiddlewareArray = /** @class */function (_super) {
  __extends(MiddlewareArray, _super);
  function MiddlewareArray() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    var _this = _super.apply(this, args) || this;
    Object.setPrototypeOf(_this, MiddlewareArray.prototype);
    return _this;
  }
  Object.defineProperty(MiddlewareArray, Symbol.species, {
    get: function () {
      return MiddlewareArray;
    },
    enumerable: false,
    configurable: true
  });
  MiddlewareArray.prototype.concat = function () {
    var arr = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      arr[_i] = arguments[_i];
    }
    return _super.prototype.concat.apply(this, arr);
  };
  MiddlewareArray.prototype.prepend = function () {
    var arr = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      arr[_i] = arguments[_i];
    }
    if (arr.length === 1 && Array.isArray(arr[0])) {
      return new (MiddlewareArray.bind.apply(MiddlewareArray, __spreadArray([void 0], arr[0].concat(this))))();
    }
    return new (MiddlewareArray.bind.apply(MiddlewareArray, __spreadArray([void 0], arr.concat(this))))();
  };
  return MiddlewareArray;
}(Array);
var EnhancerArray = /** @class */function (_super) {
  __extends(EnhancerArray, _super);
  function EnhancerArray() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    var _this = _super.apply(this, args) || this;
    Object.setPrototypeOf(_this, EnhancerArray.prototype);
    return _this;
  }
  Object.defineProperty(EnhancerArray, Symbol.species, {
    get: function () {
      return EnhancerArray;
    },
    enumerable: false,
    configurable: true
  });
  EnhancerArray.prototype.concat = function () {
    var arr = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      arr[_i] = arguments[_i];
    }
    return _super.prototype.concat.apply(this, arr);
  };
  EnhancerArray.prototype.prepend = function () {
    var arr = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      arr[_i] = arguments[_i];
    }
    if (arr.length === 1 && Array.isArray(arr[0])) {
      return new (EnhancerArray.bind.apply(EnhancerArray, __spreadArray([void 0], arr[0].concat(this))))();
    }
    return new (EnhancerArray.bind.apply(EnhancerArray, __spreadArray([void 0], arr.concat(this))))();
  };
  return EnhancerArray;
}(Array);
function freezeDraftable(val) {
  return t$c(val) ? fn(val, function () {}) : val;
}
// src/immutableStateInvariantMiddleware.ts
var isProduction = process.env.NODE_ENV === "production";
var prefix$2 = "Invariant failed";
function invariant(condition, message) {
  if (condition) {
    return;
  }
  if (isProduction) {
    throw new Error(prefix$2);
  }
  throw new Error(prefix$2 + ": " + (message || ""));
}
function stringify$3(obj, serializer, indent, decycler) {
  return JSON.stringify(obj, getSerialize(serializer, decycler), indent);
}
function getSerialize(serializer, decycler) {
  var stack = [],
    keys = [];
  if (!decycler) decycler = function (_, value) {
    if (stack[0] === value) return "[Circular ~]";
    return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
  };
  return function (key, value) {
    if (stack.length > 0) {
      var thisPos = stack.indexOf(this);
      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
      if (~stack.indexOf(value)) value = decycler.call(this, key, value);
    } else stack.push(value);
    return serializer == null ? value : serializer.call(this, key, value);
  };
}
function isImmutableDefault(value) {
  return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function trackForMutations(isImmutable, ignorePaths, obj) {
  var trackedProperties = trackProperties(isImmutable, ignorePaths, obj);
  return {
    detectMutations: function () {
      return detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
    }
  };
}
function trackProperties(isImmutable, ignorePaths, obj, path, checkedObjects) {
  if (ignorePaths === void 0) {
    ignorePaths = [];
  }
  if (path === void 0) {
    path = "";
  }
  if (checkedObjects === void 0) {
    checkedObjects = new Set();
  }
  var tracked = {
    value: obj
  };
  if (!isImmutable(obj) && !checkedObjects.has(obj)) {
    checkedObjects.add(obj);
    tracked.children = {};
    for (var key in obj) {
      var childPath = path ? path + "." + key : key;
      if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) {
        continue;
      }
      tracked.children[key] = trackProperties(isImmutable, ignorePaths, obj[key], childPath);
    }
  }
  return tracked;
}
function detectMutations(isImmutable, ignoredPaths, trackedProperty, obj, sameParentRef, path) {
  if (ignoredPaths === void 0) {
    ignoredPaths = [];
  }
  if (sameParentRef === void 0) {
    sameParentRef = false;
  }
  if (path === void 0) {
    path = "";
  }
  var prevObj = trackedProperty ? trackedProperty.value : void 0;
  var sameRef = prevObj === obj;
  if (sameParentRef && !sameRef && !Number.isNaN(obj)) {
    return {
      wasMutated: true,
      path: path
    };
  }
  if (isImmutable(prevObj) || isImmutable(obj)) {
    return {
      wasMutated: false
    };
  }
  var keysToDetect = {};
  for (var key in trackedProperty.children) {
    keysToDetect[key] = true;
  }
  for (var key in obj) {
    keysToDetect[key] = true;
  }
  var hasIgnoredPaths = ignoredPaths.length > 0;
  var _loop_1 = function (key) {
    var nestedPath = path ? path + "." + key : key;
    if (hasIgnoredPaths) {
      var hasMatches = ignoredPaths.some(function (ignored) {
        if (ignored instanceof RegExp) {
          return ignored.test(nestedPath);
        }
        return nestedPath === ignored;
      });
      if (hasMatches) {
        return "continue";
      }
    }
    var result = detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
    if (result.wasMutated) {
      return {
        value: result
      };
    }
  };
  for (var key in keysToDetect) {
    var state_1 = _loop_1(key);
    if (typeof state_1 === "object") return state_1.value;
  }
  return {
    wasMutated: false
  };
}
function createImmutableStateInvariantMiddleware(options) {
  if (options === void 0) {
    options = {};
  }
  if (process.env.NODE_ENV === "production") {
    return function () {
      return function (next) {
        return function (action) {
          return next(action);
        };
      };
    };
  }
  var _c = options.isImmutable,
    isImmutable = _c === void 0 ? isImmutableDefault : _c,
    ignoredPaths = options.ignoredPaths,
    _d = options.warnAfter,
    warnAfter = _d === void 0 ? 32 : _d,
    ignore = options.ignore;
  ignoredPaths = ignoredPaths || ignore;
  var track = trackForMutations.bind(null, isImmutable, ignoredPaths);
  return function (_c) {
    var getState = _c.getState;
    var state = getState();
    var tracker = track(state);
    var result;
    return function (next) {
      return function (action) {
        var measureUtils = getTimeMeasureUtils(warnAfter, "ImmutableStateInvariantMiddleware");
        measureUtils.measureTime(function () {
          state = getState();
          result = tracker.detectMutations();
          tracker = track(state);
          invariant(!result.wasMutated, "A state mutation was detected between dispatches, in the path '" + (result.path || "") + "'.  This may cause incorrect behavior. (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)");
        });
        var dispatchedAction = next(action);
        measureUtils.measureTime(function () {
          state = getState();
          result = tracker.detectMutations();
          tracker = track(state);
          result.wasMutated && invariant(!result.wasMutated, "A state mutation was detected inside a dispatch, in the path: " + (result.path || "") + ". Take a look at the reducer(s) handling the action " + stringify$3(action) + ". (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)");
        });
        measureUtils.warnIfExceeded();
        return dispatchedAction;
      };
    };
  };
}
// src/serializableStateInvariantMiddleware.ts
function isPlain(val) {
  var type = typeof val;
  return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || isPlainObject$1(val);
}
function findNonSerializableValue(value, path, isSerializable, getEntries, ignoredPaths, cache) {
  if (path === void 0) {
    path = "";
  }
  if (isSerializable === void 0) {
    isSerializable = isPlain;
  }
  if (ignoredPaths === void 0) {
    ignoredPaths = [];
  }
  var foundNestedSerializable;
  if (!isSerializable(value)) {
    return {
      keyPath: path || "<root>",
      value: value
    };
  }
  if (typeof value !== "object" || value === null) {
    return false;
  }
  if (cache == null ? void 0 : cache.has(value)) return false;
  var entries = getEntries != null ? getEntries(value) : Object.entries(value);
  var hasIgnoredPaths = ignoredPaths.length > 0;
  var _loop_2 = function (key, nestedValue) {
    var nestedPath = path ? path + "." + key : key;
    if (hasIgnoredPaths) {
      var hasMatches = ignoredPaths.some(function (ignored) {
        if (ignored instanceof RegExp) {
          return ignored.test(nestedPath);
        }
        return nestedPath === ignored;
      });
      if (hasMatches) {
        return "continue";
      }
    }
    if (!isSerializable(nestedValue)) {
      return {
        value: {
          keyPath: nestedPath,
          value: nestedValue
        }
      };
    }
    if (typeof nestedValue === "object") {
      foundNestedSerializable = findNonSerializableValue(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
      if (foundNestedSerializable) {
        return {
          value: foundNestedSerializable
        };
      }
    }
  };
  for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
    var _c = entries_1[_i],
      key = _c[0],
      nestedValue = _c[1];
    var state_2 = _loop_2(key, nestedValue);
    if (typeof state_2 === "object") return state_2.value;
  }
  if (cache && isNestedFrozen(value)) cache.add(value);
  return false;
}
function isNestedFrozen(value) {
  if (!Object.isFrozen(value)) return false;
  for (var _i = 0, _c = Object.values(value); _i < _c.length; _i++) {
    var nestedValue = _c[_i];
    if (typeof nestedValue !== "object" || nestedValue === null) continue;
    if (!isNestedFrozen(nestedValue)) return false;
  }
  return true;
}
function createSerializableStateInvariantMiddleware(options) {
  if (options === void 0) {
    options = {};
  }
  if (process.env.NODE_ENV === "production") {
    return function () {
      return function (next) {
        return function (action) {
          return next(action);
        };
      };
    };
  }
  var _c = options.isSerializable,
    isSerializable = _c === void 0 ? isPlain : _c,
    getEntries = options.getEntries,
    _d = options.ignoredActions,
    ignoredActions = _d === void 0 ? [] : _d,
    _e = options.ignoredActionPaths,
    ignoredActionPaths = _e === void 0 ? ["meta.arg", "meta.baseQueryMeta"] : _e,
    _f = options.ignoredPaths,
    ignoredPaths = _f === void 0 ? [] : _f,
    _g = options.warnAfter,
    warnAfter = _g === void 0 ? 32 : _g,
    _h = options.ignoreState,
    ignoreState = _h === void 0 ? false : _h,
    _j = options.ignoreActions,
    ignoreActions = _j === void 0 ? false : _j,
    _k = options.disableCache,
    disableCache = _k === void 0 ? false : _k;
  var cache = !disableCache && WeakSet ? new WeakSet() : void 0;
  return function (storeAPI) {
    return function (next) {
      return function (action) {
        var result = next(action);
        var measureUtils = getTimeMeasureUtils(warnAfter, "SerializableStateInvariantMiddleware");
        if (!ignoreActions && !(ignoredActions.length && ignoredActions.indexOf(action.type) !== -1)) {
          measureUtils.measureTime(function () {
            var foundActionNonSerializableValue = findNonSerializableValue(action, "", isSerializable, getEntries, ignoredActionPaths, cache);
            if (foundActionNonSerializableValue) {
              var keyPath = foundActionNonSerializableValue.keyPath,
                value = foundActionNonSerializableValue.value;
              console.error("A non-serializable value was detected in an action, in the path: `" + keyPath + "`. Value:", value, "\nTake a look at the logic that dispatched this action: ", action, "\n(See https://redux.js.org/faq/actions#why-should-type-be-a-string-or-at-least-serializable-why-should-my-action-types-be-constants)", "\n(To allow non-serializable values see: https://redux-toolkit.js.org/usage/usage-guide#working-with-non-serializable-data)");
            }
          });
        }
        if (!ignoreState) {
          measureUtils.measureTime(function () {
            var state = storeAPI.getState();
            var foundStateNonSerializableValue = findNonSerializableValue(state, "", isSerializable, getEntries, ignoredPaths, cache);
            if (foundStateNonSerializableValue) {
              var keyPath = foundStateNonSerializableValue.keyPath,
                value = foundStateNonSerializableValue.value;
              console.error("A non-serializable value was detected in the state, in the path: `" + keyPath + "`. Value:", value, "\nTake a look at the reducer(s) handling this action type: " + action.type + ".\n(See https://redux.js.org/faq/organizing-state#can-i-put-functions-promises-or-other-non-serializable-items-in-my-store-state)");
            }
          });
          measureUtils.warnIfExceeded();
        }
        return result;
      };
    };
  };
}
// src/getDefaultMiddleware.ts
function isBoolean$1(x) {
  return typeof x === "boolean";
}
function curryGetDefaultMiddleware() {
  return function curriedGetDefaultMiddleware(options) {
    return getDefaultMiddleware(options);
  };
}
function getDefaultMiddleware(options) {
  if (options === void 0) {
    options = {};
  }
  var _c = options.thunk,
    thunk$1 = _c === void 0 ? true : _c,
    _d = options.immutableCheck,
    immutableCheck = _d === void 0 ? true : _d,
    _e = options.serializableCheck,
    serializableCheck = _e === void 0 ? true : _e,
    _f = options.actionCreatorCheck,
    actionCreatorCheck = _f === void 0 ? true : _f;
  var middlewareArray = new MiddlewareArray();
  if (thunk$1) {
    if (isBoolean$1(thunk$1)) {
      middlewareArray.push(thunk);
    } else {
      middlewareArray.push(thunk.withExtraArgument(thunk$1.extraArgument));
    }
  }
  if (process.env.NODE_ENV !== "production") {
    if (immutableCheck) {
      var immutableOptions = {};
      if (!isBoolean$1(immutableCheck)) {
        immutableOptions = immutableCheck;
      }
      middlewareArray.unshift(createImmutableStateInvariantMiddleware(immutableOptions));
    }
    if (serializableCheck) {
      var serializableOptions = {};
      if (!isBoolean$1(serializableCheck)) {
        serializableOptions = serializableCheck;
      }
      middlewareArray.push(createSerializableStateInvariantMiddleware(serializableOptions));
    }
    if (actionCreatorCheck) {
      var actionCreatorOptions = {};
      if (!isBoolean$1(actionCreatorCheck)) {
        actionCreatorOptions = actionCreatorCheck;
      }
      middlewareArray.unshift(createActionCreatorInvariantMiddleware(actionCreatorOptions));
    }
  }
  return middlewareArray;
}
// src/configureStore.ts
var IS_PRODUCTION = process.env.NODE_ENV === "production";
function configureStore(options) {
  var curriedGetDefaultMiddleware = curryGetDefaultMiddleware();
  var _c = options || {},
    _d = _c.reducer,
    reducer = _d === void 0 ? void 0 : _d,
    _e = _c.middleware,
    middleware = _e === void 0 ? curriedGetDefaultMiddleware() : _e,
    _f = _c.devTools,
    devTools = _f === void 0 ? true : _f,
    _g = _c.preloadedState,
    preloadedState = _g === void 0 ? void 0 : _g,
    _h = _c.enhancers,
    enhancers = _h === void 0 ? void 0 : _h;
  var rootReducer;
  if (typeof reducer === "function") {
    rootReducer = reducer;
  } else if (isPlainObject$1(reducer)) {
    rootReducer = combineReducers(reducer);
  } else {
    throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
  }
  var finalMiddleware = middleware;
  if (typeof finalMiddleware === "function") {
    finalMiddleware = finalMiddleware(curriedGetDefaultMiddleware);
    if (!IS_PRODUCTION && !Array.isArray(finalMiddleware)) {
      throw new Error("when using a middleware builder function, an array of middleware must be returned");
    }
  }
  if (!IS_PRODUCTION && finalMiddleware.some(function (item) {
    return typeof item !== "function";
  })) {
    throw new Error("each middleware provided to configureStore must be a function");
  }
  var middlewareEnhancer = applyMiddleware.apply(void 0, finalMiddleware);
  var finalCompose = compose$2;
  if (devTools) {
    finalCompose = composeWithDevTools(__spreadValues$2({
      trace: !IS_PRODUCTION
    }, typeof devTools === "object" && devTools));
  }
  var defaultEnhancers = new EnhancerArray(middlewareEnhancer);
  var storeEnhancers = defaultEnhancers;
  if (Array.isArray(enhancers)) {
    storeEnhancers = __spreadArray([middlewareEnhancer], enhancers);
  } else if (typeof enhancers === "function") {
    storeEnhancers = enhancers(defaultEnhancers);
  }
  var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
  return createStore(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function executeReducerBuilderCallback(builderCallback) {
  var actionsMap = {};
  var actionMatchers = [];
  var defaultCaseReducer;
  var builder = {
    addCase: function (typeOrActionCreator, reducer) {
      if (process.env.NODE_ENV !== "production") {
        if (actionMatchers.length > 0) {
          throw new Error("`builder.addCase` should only be called before calling `builder.addMatcher`");
        }
        if (defaultCaseReducer) {
          throw new Error("`builder.addCase` should only be called before calling `builder.addDefaultCase`");
        }
      }
      var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
      if (!type) {
        throw new Error("`builder.addCase` cannot be called with an empty action type");
      }
      if (type in actionsMap) {
        throw new Error("`builder.addCase` cannot be called with two reducers for the same action type");
      }
      actionsMap[type] = reducer;
      return builder;
    },
    addMatcher: function (matcher, reducer) {
      if (process.env.NODE_ENV !== "production") {
        if (defaultCaseReducer) {
          throw new Error("`builder.addMatcher` should only be called before calling `builder.addDefaultCase`");
        }
      }
      actionMatchers.push({
        matcher: matcher,
        reducer: reducer
      });
      return builder;
    },
    addDefaultCase: function (reducer) {
      if (process.env.NODE_ENV !== "production") {
        if (defaultCaseReducer) {
          throw new Error("`builder.addDefaultCase` can only be called once");
        }
      }
      defaultCaseReducer = reducer;
      return builder;
    }
  };
  builderCallback(builder);
  return [actionsMap, actionMatchers, defaultCaseReducer];
}
// src/createReducer.ts
function isStateFunction(x) {
  return typeof x === "function";
}
var hasWarnedAboutObjectNotation = false;
function createReducer(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
  if (actionMatchers === void 0) {
    actionMatchers = [];
  }
  if (process.env.NODE_ENV !== "production") {
    if (typeof mapOrBuilderCallback === "object") {
      if (!hasWarnedAboutObjectNotation) {
        hasWarnedAboutObjectNotation = true;
        console.warn("The object notation for `createReducer` is deprecated, and will be removed in RTK 2.0. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createReducer");
      }
    }
  }
  var _c = typeof mapOrBuilderCallback === "function" ? executeReducerBuilderCallback(mapOrBuilderCallback) : [mapOrBuilderCallback, actionMatchers, defaultCaseReducer],
    actionsMap = _c[0],
    finalActionMatchers = _c[1],
    finalDefaultCaseReducer = _c[2];
  var getInitialState;
  if (isStateFunction(initialState)) {
    getInitialState = function () {
      return freezeDraftable(initialState());
    };
  } else {
    var frozenInitialState_1 = freezeDraftable(initialState);
    getInitialState = function () {
      return frozenInitialState_1;
    };
  }
  function reducer(state, action) {
    if (state === void 0) {
      state = getInitialState();
    }
    var caseReducers = __spreadArray([actionsMap[action.type]], finalActionMatchers.filter(function (_c) {
      var matcher = _c.matcher;
      return matcher(action);
    }).map(function (_c) {
      var reducer2 = _c.reducer;
      return reducer2;
    }));
    if (caseReducers.filter(function (cr) {
      return !!cr;
    }).length === 0) {
      caseReducers = [finalDefaultCaseReducer];
    }
    return caseReducers.reduce(function (previousState, caseReducer) {
      if (caseReducer) {
        if (r$9(previousState)) {
          var draft = previousState;
          var result = caseReducer(draft, action);
          if (result === void 0) {
            return previousState;
          }
          return result;
        } else if (!t$c(previousState)) {
          var result = caseReducer(previousState, action);
          if (result === void 0) {
            if (previousState === null) {
              return previousState;
            }
            throw Error("A case reducer on a non-draftable value must not return undefined");
          }
          return result;
        } else {
          return fn(previousState, function (draft) {
            return caseReducer(draft, action);
          });
        }
      }
      return previousState;
    }, state);
  }
  reducer.getInitialState = getInitialState;
  return reducer;
}
// src/createSlice.ts
var hasWarnedAboutObjectNotation2 = false;
function getType2(slice, actionKey) {
  return slice + "/" + actionKey;
}
function createSlice(options) {
  var name = options.name;
  if (!name) {
    throw new Error("`name` is a required option for createSlice");
  }
  if (typeof process !== "undefined" && process.env.NODE_ENV === "development") {
    if (options.initialState === void 0) {
      console.error("You must provide an `initialState` value that is not `undefined`. You may have misspelled `initialState`");
    }
  }
  var initialState = typeof options.initialState == "function" ? options.initialState : freezeDraftable(options.initialState);
  var reducers = options.reducers || {};
  var reducerNames = Object.keys(reducers);
  var sliceCaseReducersByName = {};
  var sliceCaseReducersByType = {};
  var actionCreators = {};
  reducerNames.forEach(function (reducerName) {
    var maybeReducerWithPrepare = reducers[reducerName];
    var type = getType2(name, reducerName);
    var caseReducer;
    var prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
      caseReducer = maybeReducerWithPrepare.reducer;
      prepareCallback = maybeReducerWithPrepare.prepare;
    } else {
      caseReducer = maybeReducerWithPrepare;
    }
    sliceCaseReducersByName[reducerName] = caseReducer;
    sliceCaseReducersByType[type] = caseReducer;
    actionCreators[reducerName] = prepareCallback ? createAction(type, prepareCallback) : createAction(type);
  });
  function buildReducer() {
    if (process.env.NODE_ENV !== "production") {
      if (typeof options.extraReducers === "object") {
        if (!hasWarnedAboutObjectNotation2) {
          hasWarnedAboutObjectNotation2 = true;
          console.warn("The object notation for `createSlice.extraReducers` is deprecated, and will be removed in RTK 2.0. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createSlice");
        }
      }
    }
    var _c = typeof options.extraReducers === "function" ? executeReducerBuilderCallback(options.extraReducers) : [options.extraReducers],
      _d = _c[0],
      extraReducers = _d === void 0 ? {} : _d,
      _e = _c[1],
      actionMatchers = _e === void 0 ? [] : _e,
      _f = _c[2],
      defaultCaseReducer = _f === void 0 ? void 0 : _f;
    var finalCaseReducers = __spreadValues$2(__spreadValues$2({}, extraReducers), sliceCaseReducersByType);
    return createReducer(initialState, function (builder) {
      for (var key in finalCaseReducers) {
        builder.addCase(key, finalCaseReducers[key]);
      }
      for (var _i = 0, actionMatchers_1 = actionMatchers; _i < actionMatchers_1.length; _i++) {
        var m = actionMatchers_1[_i];
        builder.addMatcher(m.matcher, m.reducer);
      }
      if (defaultCaseReducer) {
        builder.addDefaultCase(defaultCaseReducer);
      }
    });
  }
  var _reducer;
  return {
    name: name,
    reducer: function (state, action) {
      if (!_reducer) _reducer = buildReducer();
      return _reducer(state, action);
    },
    actions: actionCreators,
    caseReducers: sliceCaseReducersByName,
    getInitialState: function () {
      if (!_reducer) _reducer = buildReducer();
      return _reducer.getInitialState();
    }
  };
}
// src/nanoid.ts
var urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var nanoid = function (size) {
  if (size === void 0) {
    size = 21;
  }
  var id = "";
  var i = size;
  while (i--) {
    id += urlAlphabet[Math.random() * 64 | 0];
  }
  return id;
};
// src/createAsyncThunk.ts
var commonProperties = ["name", "message", "stack", "code"];
var RejectWithValue = /** @class */function () {
  function RejectWithValue(payload, meta) {
    this.payload = payload;
    this.meta = meta;
  }
  return RejectWithValue;
}();
var FulfillWithMeta = /** @class */function () {
  function FulfillWithMeta(payload, meta) {
    this.payload = payload;
    this.meta = meta;
  }
  return FulfillWithMeta;
}();
var miniSerializeError = function (value) {
  if (typeof value === "object" && value !== null) {
    var simpleError = {};
    for (var _i = 0, commonProperties_1 = commonProperties; _i < commonProperties_1.length; _i++) {
      var property = commonProperties_1[_i];
      if (typeof value[property] === "string") {
        simpleError[property] = value[property];
      }
    }
    return simpleError;
  }
  return {
    message: String(value)
  };
};
var createAsyncThunk = function () {
  function createAsyncThunk2(typePrefix, payloadCreator, options) {
    var fulfilled = createAction(typePrefix + "/fulfilled", function (payload, requestId, arg, meta) {
      return {
        payload: payload,
        meta: __spreadProps$1(__spreadValues$2({}, meta || {}), {
          arg: arg,
          requestId: requestId,
          requestStatus: "fulfilled"
        })
      };
    });
    var pending = createAction(typePrefix + "/pending", function (requestId, arg, meta) {
      return {
        payload: void 0,
        meta: __spreadProps$1(__spreadValues$2({}, meta || {}), {
          arg: arg,
          requestId: requestId,
          requestStatus: "pending"
        })
      };
    });
    var rejected = createAction(typePrefix + "/rejected", function (error, requestId, arg, payload, meta) {
      return {
        payload: payload,
        error: (options && options.serializeError || miniSerializeError)(error || "Rejected"),
        meta: __spreadProps$1(__spreadValues$2({}, meta || {}), {
          arg: arg,
          requestId: requestId,
          rejectedWithValue: !!payload,
          requestStatus: "rejected",
          aborted: (error == null ? void 0 : error.name) === "AbortError",
          condition: (error == null ? void 0 : error.name) === "ConditionError"
        })
      };
    });
    var displayedWarning = false;
    var AC = typeof AbortController !== "undefined" ? AbortController : ( /** @class */function () {
      function class_1() {
        this.signal = {
          aborted: false,
          addEventListener: function () {},
          dispatchEvent: function () {
            return false;
          },
          onabort: function () {},
          removeEventListener: function () {},
          reason: void 0,
          throwIfAborted: function () {}
        };
      }
      class_1.prototype.abort = function () {
        if (process.env.NODE_ENV !== "production") {
          if (!displayedWarning) {
            displayedWarning = true;
            console.info("This platform does not implement AbortController. \nIf you want to use the AbortController to react to `abort` events, please consider importing a polyfill like 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only'.");
          }
        }
      };
      return class_1;
    }());
    function actionCreator(arg) {
      return function (dispatch, getState, extra) {
        var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : nanoid();
        var abortController = new AC();
        var abortReason;
        function abort(reason) {
          abortReason = reason;
          abortController.abort();
        }
        var promise2 = function () {
          return __async(this, null, function () {
            var _a, _b, finalAction, conditionResult, abortedPromise, err_1, skipDispatch;
            return __generator(this, function (_c) {
              switch (_c.label) {
                case 0:
                  _c.trys.push([0, 4,, 5]);
                  conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                    getState: getState,
                    extra: extra
                  });
                  if (!isThenable(conditionResult)) return [3 /*break*/, 2];
                  return [4 /*yield*/, conditionResult];
                case 1:
                  conditionResult = _c.sent();
                  _c.label = 2;
                case 2:
                  if (conditionResult === false || abortController.signal.aborted) {
                    throw {
                      name: "ConditionError",
                      message: "Aborted due to condition callback returning false."
                    };
                  }
                  abortedPromise = new Promise(function (_, reject) {
                    return abortController.signal.addEventListener("abort", function () {
                      return reject({
                        name: "AbortError",
                        message: abortReason || "Aborted"
                      });
                    });
                  });
                  dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                    requestId: requestId,
                    arg: arg
                  }, {
                    getState: getState,
                    extra: extra
                  })));
                  return [4 /*yield*/, Promise.race([abortedPromise, Promise.resolve(payloadCreator(arg, {
                    dispatch: dispatch,
                    getState: getState,
                    extra: extra,
                    requestId: requestId,
                    signal: abortController.signal,
                    abort: abort,
                    rejectWithValue: function (value, meta) {
                      return new RejectWithValue(value, meta);
                    },
                    fulfillWithValue: function (value, meta) {
                      return new FulfillWithMeta(value, meta);
                    }
                  })).then(function (result) {
                    if (result instanceof RejectWithValue) {
                      throw result;
                    }
                    if (result instanceof FulfillWithMeta) {
                      return fulfilled(result.payload, requestId, arg, result.meta);
                    }
                    return fulfilled(result, requestId, arg);
                  })])];
                case 3:
                  finalAction = _c.sent();
                  return [3 /*break*/, 5];
                case 4:
                  err_1 = _c.sent();
                  finalAction = err_1 instanceof RejectWithValue ? rejected(null, requestId, arg, err_1.payload, err_1.meta) : rejected(err_1, requestId, arg);
                  return [3 /*break*/, 5];
                case 5:
                  skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                  if (!skipDispatch) {
                    dispatch(finalAction);
                  }
                  return [2 /*return*/, finalAction];
              }
            });
          });
        }();
        return Object.assign(promise2, {
          abort: abort,
          requestId: requestId,
          arg: arg,
          unwrap: function () {
            return promise2.then(unwrapResult);
          }
        });
      };
    }
    return Object.assign(actionCreator, {
      pending: pending,
      rejected: rejected,
      fulfilled: fulfilled,
      typePrefix: typePrefix
    });
  }
  createAsyncThunk2.withTypes = function () {
    return createAsyncThunk2;
  };
  return createAsyncThunk2;
}();
function unwrapResult(action) {
  if (action.meta && action.meta.rejectedWithValue) {
    throw action.payload;
  }
  if (action.error) {
    throw action.error;
  }
  return action.payload;
}
function isThenable(value) {
  return value !== null && typeof value === "object" && typeof value.then === "function";
}
var alm = "listenerMiddleware";
createAction(alm + "/add");
createAction(alm + "/removeAll");
createAction(alm + "/remove");
var promise;
typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : globalThis) : function (cb) {
  return (promise || (promise = Promise.resolve())).then(cb).catch(function (err) {
    return setTimeout(function () {
      throw err;
    }, 0);
  });
};
// src/index.ts
F$8();

// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var getRandomValues$1;
var rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues$1) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
    // find the complete implementation of crypto (msCrypto) on IE11.
    getRandomValues$1 = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);
    if (!getRandomValues$1) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }
  return getRandomValues$1(rnds8);
}

var REGEX = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

function validate(uuid) {
  return typeof uuid === 'string' && REGEX.test(uuid);
}

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

var byteToHex = [];
for (var i$a = 0; i$a < 256; ++i$a) {
  byteToHex.push((i$a + 0x100).toString(16).substr(1));
}
function stringify$2(arr) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }
  return uuid;
}

function parse$4(uuid) {
  if (!validate(uuid)) {
    throw TypeError('Invalid UUID');
  }
  var v;
  var arr = new Uint8Array(16); // Parse ########-....-....-....-............

  arr[0] = (v = parseInt(uuid.slice(0, 8), 16)) >>> 24;
  arr[1] = v >>> 16 & 0xff;
  arr[2] = v >>> 8 & 0xff;
  arr[3] = v & 0xff; // Parse ........-####-....-....-............

  arr[4] = (v = parseInt(uuid.slice(9, 13), 16)) >>> 8;
  arr[5] = v & 0xff; // Parse ........-....-####-....-............

  arr[6] = (v = parseInt(uuid.slice(14, 18), 16)) >>> 8;
  arr[7] = v & 0xff; // Parse ........-....-....-####-............

  arr[8] = (v = parseInt(uuid.slice(19, 23), 16)) >>> 8;
  arr[9] = v & 0xff; // Parse ........-....-....-....-############
  // (Use "/" to avoid 32-bit truncation when bit-shifting high-order bytes)

  arr[10] = (v = parseInt(uuid.slice(24, 36), 16)) / 0x10000000000 & 0xff;
  arr[11] = v / 0x100000000 & 0xff;
  arr[12] = v >>> 24 & 0xff;
  arr[13] = v >>> 16 & 0xff;
  arr[14] = v >>> 8 & 0xff;
  arr[15] = v & 0xff;
  return arr;
}

function stringToBytes(str) {
  str = unescape(encodeURIComponent(str)); // UTF8 escape

  var bytes = [];
  for (var i = 0; i < str.length; ++i) {
    bytes.push(str.charCodeAt(i));
  }
  return bytes;
}
var DNS = '6ba7b810-9dad-11d1-80b4-00c04fd430c8';
var URL$1 = '6ba7b811-9dad-11d1-80b4-00c04fd430c8';
function v35 (name, version, hashfunc) {
  function generateUUID(value, namespace, buf, offset) {
    if (typeof value === 'string') {
      value = stringToBytes(value);
    }
    if (typeof namespace === 'string') {
      namespace = parse$4(namespace);
    }
    if (namespace.length !== 16) {
      throw TypeError('Namespace must be array-like (16 iterable integer values, 0-255)');
    } // Compute hash of namespace and value, Per 4.3
    // Future: Use spread syntax when supported on all platforms, e.g. `bytes =
    // hashfunc([...namespace, ... value])`

    var bytes = new Uint8Array(16 + value.length);
    bytes.set(namespace);
    bytes.set(value, namespace.length);
    bytes = hashfunc(bytes);
    bytes[6] = bytes[6] & 0x0f | version;
    bytes[8] = bytes[8] & 0x3f | 0x80;
    if (buf) {
      offset = offset || 0;
      for (var i = 0; i < 16; ++i) {
        buf[offset + i] = bytes[i];
      }
      return buf;
    }
    return stringify$2(bytes);
  } // Function#name is not settable on some platforms (#270)

  try {
    generateUUID.name = name; // eslint-disable-next-line no-empty
  } catch (err) {} // For CommonJS default export support

  generateUUID.DNS = DNS;
  generateUUID.URL = URL$1;
  return generateUUID;
}

/*
 * Browser-compatible JavaScript MD5
 *
 * Modification of JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */
function md5(bytes) {
  if (typeof bytes === 'string') {
    var msg = unescape(encodeURIComponent(bytes)); // UTF8 escape

    bytes = new Uint8Array(msg.length);
    for (var i = 0; i < msg.length; ++i) {
      bytes[i] = msg.charCodeAt(i);
    }
  }
  return md5ToHexEncodedArray(wordsToMd5(bytesToWords(bytes), bytes.length * 8));
}
/*
 * Convert an array of little-endian words to an array of bytes
 */

function md5ToHexEncodedArray(input) {
  var output = [];
  var length32 = input.length * 32;
  var hexTab = '0123456789abcdef';
  for (var i = 0; i < length32; i += 8) {
    var x = input[i >> 5] >>> i % 32 & 0xff;
    var hex = parseInt(hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f), 16);
    output.push(hex);
  }
  return output;
}
/**
 * Calculate output length with padding and bit length
 */

function getOutputLength(inputLength8) {
  return (inputLength8 + 64 >>> 9 << 4) + 14 + 1;
}
/*
 * Calculate the MD5 of an array of little-endian words, and a bit length.
 */

function wordsToMd5(x, len) {
  /* append padding */
  x[len >> 5] |= 0x80 << len % 32;
  x[getOutputLength(len) - 1] = len;
  var a = 1732584193;
  var b = -271733879;
  var c = -1732584194;
  var d = 271733878;
  for (var i = 0; i < x.length; i += 16) {
    var olda = a;
    var oldb = b;
    var oldc = c;
    var oldd = d;
    a = md5ff(a, b, c, d, x[i], 7, -680876936);
    d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
    c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
    b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
    a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
    d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
    c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
    b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
    a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
    d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
    c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
    b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
    a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
    d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
    c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
    b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
    a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
    d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
    c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
    b = md5gg(b, c, d, a, x[i], 20, -373897302);
    a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
    d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
    c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
    b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
    a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
    d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
    c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
    b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
    a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
    d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
    c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
    b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
    a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
    d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
    c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
    b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
    a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
    d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
    c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
    b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
    a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
    d = md5hh(d, a, b, c, x[i], 11, -358537222);
    c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
    b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
    a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
    d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
    c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
    b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
    a = md5ii(a, b, c, d, x[i], 6, -198630844);
    d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
    c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
    b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
    a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
    d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
    c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
    b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
    a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
    d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
    c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
    b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
    a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
    d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
    c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
    b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
    a = safeAdd(a, olda);
    b = safeAdd(b, oldb);
    c = safeAdd(c, oldc);
    d = safeAdd(d, oldd);
  }
  return [a, b, c, d];
}
/*
 * Convert an array bytes to an array of little-endian words
 * Characters >255 have their high-byte silently ignored.
 */

function bytesToWords(input) {
  if (input.length === 0) {
    return [];
  }
  var length8 = input.length * 8;
  var output = new Uint32Array(getOutputLength(length8));
  for (var i = 0; i < length8; i += 8) {
    output[i >> 5] |= (input[i / 8] & 0xff) << i % 32;
  }
  return output;
}
/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */

function safeAdd(x, y) {
  var lsw = (x & 0xffff) + (y & 0xffff);
  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return msw << 16 | lsw & 0xffff;
}
/*
 * Bitwise rotate a 32-bit number to the left.
 */

function bitRotateLeft(num, cnt) {
  return num << cnt | num >>> 32 - cnt;
}
/*
 * These functions implement the four basic operations the algorithm uses.
 */

function md5cmn(q, a, b, x, s, t) {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
}
function md5ff(a, b, c, d, x, s, t) {
  return md5cmn(b & c | ~b & d, a, b, x, s, t);
}
function md5gg(a, b, c, d, x, s, t) {
  return md5cmn(b & d | c & ~d, a, b, x, s, t);
}
function md5hh(a, b, c, d, x, s, t) {
  return md5cmn(b ^ c ^ d, a, b, x, s, t);
}
function md5ii(a, b, c, d, x, s, t) {
  return md5cmn(c ^ (b | ~d), a, b, x, s, t);
}

v35('v3', 0x30, md5);

function v4(options, buf, offset) {
  options = options || {};
  var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;
    for (var i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }
    return buf;
  }
  return stringify$2(rnds);
}

// Adapted from Chris Veness' SHA1 code at
// http://www.movable-type.co.uk/scripts/sha1.html
function f$c(s, x, y, z) {
  switch (s) {
    case 0:
      return x & y ^ ~x & z;
    case 1:
      return x ^ y ^ z;
    case 2:
      return x & y ^ x & z ^ y & z;
    case 3:
      return x ^ y ^ z;
  }
}
function ROTL(x, n) {
  return x << n | x >>> 32 - n;
}
function sha1(bytes) {
  var K = [0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xca62c1d6];
  var H = [0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0];
  if (typeof bytes === 'string') {
    var msg = unescape(encodeURIComponent(bytes)); // UTF8 escape

    bytes = [];
    for (var i = 0; i < msg.length; ++i) {
      bytes.push(msg.charCodeAt(i));
    }
  } else if (!Array.isArray(bytes)) {
    // Convert Array-like to Array
    bytes = Array.prototype.slice.call(bytes);
  }
  bytes.push(0x80);
  var l = bytes.length / 4 + 2;
  var N = Math.ceil(l / 16);
  var M = new Array(N);
  for (var _i = 0; _i < N; ++_i) {
    var arr = new Uint32Array(16);
    for (var j = 0; j < 16; ++j) {
      arr[j] = bytes[_i * 64 + j * 4] << 24 | bytes[_i * 64 + j * 4 + 1] << 16 | bytes[_i * 64 + j * 4 + 2] << 8 | bytes[_i * 64 + j * 4 + 3];
    }
    M[_i] = arr;
  }
  M[N - 1][14] = (bytes.length - 1) * 8 / Math.pow(2, 32);
  M[N - 1][14] = Math.floor(M[N - 1][14]);
  M[N - 1][15] = (bytes.length - 1) * 8 & 0xffffffff;
  for (var _i2 = 0; _i2 < N; ++_i2) {
    var W = new Uint32Array(80);
    for (var t = 0; t < 16; ++t) {
      W[t] = M[_i2][t];
    }
    for (var _t = 16; _t < 80; ++_t) {
      W[_t] = ROTL(W[_t - 3] ^ W[_t - 8] ^ W[_t - 14] ^ W[_t - 16], 1);
    }
    var a = H[0];
    var b = H[1];
    var c = H[2];
    var d = H[3];
    var e = H[4];
    for (var _t2 = 0; _t2 < 80; ++_t2) {
      var s = Math.floor(_t2 / 20);
      var T = ROTL(a, 5) + f$c(s, b, c, d) + e + K[s] + W[_t2] >>> 0;
      e = d;
      d = c;
      c = ROTL(b, 30) >>> 0;
      b = a;
      a = T;
    }
    H[0] = H[0] + a >>> 0;
    H[1] = H[1] + b >>> 0;
    H[2] = H[2] + c >>> 0;
    H[3] = H[3] + d >>> 0;
    H[4] = H[4] + e >>> 0;
  }
  return [H[0] >> 24 & 0xff, H[0] >> 16 & 0xff, H[0] >> 8 & 0xff, H[0] & 0xff, H[1] >> 24 & 0xff, H[1] >> 16 & 0xff, H[1] >> 8 & 0xff, H[1] & 0xff, H[2] >> 24 & 0xff, H[2] >> 16 & 0xff, H[2] >> 8 & 0xff, H[2] & 0xff, H[3] >> 24 & 0xff, H[3] >> 16 & 0xff, H[3] >> 8 & 0xff, H[3] & 0xff, H[4] >> 24 & 0xff, H[4] >> 16 & 0xff, H[4] >> 8 & 0xff, H[4] & 0xff];
}

v35('v5', 0x50, sha1);

const initialState$b = {
  serviceWorkerInitialized: false,
  serviceWorkerUpdated: false,
  latestServiceWorkerLoaded: false,
  serviceWorkerRegistration: null
};

var dist$3 = {};

var ga4 = {};

var gtag = {};

(function (exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var gtag = function gtag() {
	  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	  if (typeof window !== "undefined") {
	    var _window;
	    if (typeof window.gtag === "undefined") {
	      window.dataLayer = window.dataLayer || [];
	      window.gtag = function gtag() {
	        window.dataLayer.push(arguments);
	      };
	    }
	    (_window = window).gtag.apply(_window, args);
	  }
	};
	var _default = gtag;
	exports["default"] = _default;
} (gtag));

var format = {};

(function (exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = format;
	var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
	function toTitleCase(string) {
	  return string.toString().trim().replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
	    if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ":" && (title.charAt(index + match.length) !== "-" || title.charAt(index - 1) === "-") && title.charAt(index - 1).search(/[^\s-]/) < 0) {
	      return match.toLowerCase();
	    }
	    if (match.substr(1).search(/[A-Z]|\../) > -1) {
	      return match;
	    }
	    return match.charAt(0).toUpperCase() + match.substr(1);
	  });
	} // See if s could be an email address. We don't want to send personal data like email.
	// https://support.google.com/analytics/answer/2795983?hl=en

	function mightBeEmail(s) {
	  // There's no point trying to validate rfc822 fully, just look for ...@...
	  return typeof s === "string" && s.indexOf("@") !== -1;
	}
	var redacted = "REDACTED (Potential Email Address)";
	function redactEmail(string) {
	  if (mightBeEmail(string)) {
	    console.warn("This arg looks like an email address, redacting.");
	    return redacted;
	  }
	  return string;
	}
	function format() {
	  var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
	  var titleCase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	  var redactingEmail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	  var _str = s || "";
	  if (titleCase) {
	    _str = toTitleCase(s);
	  }
	  if (redactingEmail) {
	    _str = redactEmail(_str);
	  }
	  return _str;
	}
} (format));

(function (exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.GA4 = void 0;
	var _gtag = _interopRequireDefault(gtag);
	var _format = _interopRequireDefault(format);
	var _excluded = ["eventCategory", "eventAction", "eventLabel", "eventValue", "hitType"],
	  _excluded2 = ["title", "location"],
	  _excluded3 = ["page", "hitType"],
	  _excluded4 = ["action", "category", "label", "value", "nonInteraction", "transport"];
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	function _objectWithoutProperties(source, excluded) {
	  if (source == null) return {};
	  var target = _objectWithoutPropertiesLoose(source, excluded);
	  var key, i;
	  if (Object.getOwnPropertySymbols) {
	    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
	    for (i = 0; i < sourceSymbolKeys.length; i++) {
	      key = sourceSymbolKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	      target[key] = source[key];
	    }
	  }
	  return target;
	}
	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	  return target;
	}
	function _typeof(obj) {
	  "@babel/helpers - typeof";

	  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj;
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	  }
	  return _typeof(obj);
	}
	function _toConsumableArray(arr) {
	  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
	}
	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
	}
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
	}
	function ownKeys(object, enumerableOnly) {
	  var keys = Object.keys(object);
	  if (Object.getOwnPropertySymbols) {
	    var symbols = Object.getOwnPropertySymbols(object);
	    if (enumerableOnly) {
	      symbols = symbols.filter(function (sym) {
	        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	      });
	    }
	    keys.push.apply(keys, symbols);
	  }
	  return keys;
	}
	function _objectSpread(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	    if (i % 2) {
	      ownKeys(Object(source), true).forEach(function (key) {
	        _defineProperty(target, key, source[key]);
	      });
	    } else if (Object.getOwnPropertyDescriptors) {
	      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
	    } else {
	      ownKeys(Object(source)).forEach(function (key) {
	        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	      });
	    }
	  }
	  return target;
	}
	function _slicedToArray(arr, i) {
	  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
	}
	function _nonIterableRest() {
	  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;
	  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
	  var n = Object.prototype.toString.call(o).slice(8, -1);
	  if (n === "Object" && o.constructor) n = o.constructor.name;
	  if (n === "Map" || n === "Set") return Array.from(o);
	  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;
	  for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }
	  return arr2;
	}
	function _iterableToArrayLimit(arr, i) {
	  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
	  if (_i == null) return;
	  var _arr = [];
	  var _n = true;
	  var _d = false;
	  var _s, _e;
	  try {
	    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
	      _arr.push(_s.value);
	      if (i && _arr.length === i) break;
	    }
	  } catch (err) {
	    _d = true;
	    _e = err;
	  } finally {
	    try {
	      if (!_n && _i["return"] != null) _i["return"]();
	    } finally {
	      if (_d) throw _e;
	    }
	  }
	  return _arr;
	}
	function _arrayWithHoles(arr) {
	  if (Array.isArray(arr)) return arr;
	}
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  return Constructor;
	}
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	  return obj;
	}

	/*
	Links
	https://developers.google.com/gtagjs/reference/api
	https://developers.google.com/tag-platform/gtagjs/reference
	*/

	/**
	 * @typedef GaOptions
	 * @type {Object}
	 * @property {boolean} [cookieUpdate=true]
	 * @property {number} [cookieExpires=63072000] Default two years
	 * @property {string} [cookieDomain="auto"]
	 * @property {string} [cookieFlags]
	 * @property {string} [userId]
	 * @property {string} [clientId]
	 * @property {boolean} [anonymizeIp]
	 * @property {string} [contentGroup1]
	 * @property {string} [contentGroup2]
	 * @property {string} [contentGroup3]
	 * @property {string} [contentGroup4]
	 * @property {string} [contentGroup5]
	 * @property {boolean} [allowAdFeatures=true]
	 * @property {boolean} [allowAdPersonalizationSignals]
	 * @property {boolean} [nonInteraction]
	 * @property {string} [page]
	 */

	/**
	 * @typedef UaEventOptions
	 * @type {Object}
	 * @property {string} action
	 * @property {string} category
	 * @property {string} [label]
	 * @property {number} [value]
	 * @property {boolean} [nonInteraction]
	 * @property {('beacon'|'xhr'|'image')} [transport]
	 */

	/**
	 * @typedef InitOptions
	 * @type {Object}
	 * @property {string} trackingId
	 * @property {GaOptions|any} [gaOptions]
	 * @property {Object} [gtagOptions] New parameter
	 */
	var GA4 = /*#__PURE__*/function () {
	  function GA4() {
	    var _this = this;
	    _classCallCheck(this, GA4);
	    _defineProperty(this, "reset", function () {
	      _this.isInitialized = false;
	      _this._testMode = false;
	      _this._currentMeasurementId;
	      _this._hasLoadedGA = false;
	      _this._isQueuing = false;
	      _this._queueGtag = [];
	    });
	    _defineProperty(this, "_gtag", function () {
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	      if (!_this._testMode) {
	        if (_this._isQueuing) {
	          _this._queueGtag.push(args);
	        } else {
	          _gtag["default"].apply(void 0, args);
	        }
	      } else {
	        _this._queueGtag.push(args);
	      }
	    });
	    _defineProperty(this, "_loadGA", function (GA_MEASUREMENT_ID, nonce) {
	      if (typeof window === "undefined" || typeof document === "undefined") {
	        return;
	      }
	      if (!_this._hasLoadedGA) {
	        // Global Site Tag (gtag.js) - Google Analytics
	        var script = document.createElement("script");
	        script.async = true;
	        script.src = "https://www.googletagmanager.com/gtag/js?id=".concat(GA_MEASUREMENT_ID);
	        if (nonce) {
	          script.setAttribute("nonce", nonce);
	        }
	        document.body.appendChild(script);
	        window.dataLayer = window.dataLayer || [];
	        window.gtag = function gtag() {
	          window.dataLayer.push(arguments);
	        };
	        _this._hasLoadedGA = true;
	      }
	    });
	    _defineProperty(this, "_toGtagOptions", function (gaOptions) {
	      if (!gaOptions) {
	        return;
	      }
	      var mapFields = {
	        // Old https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#cookieUpdate
	        // New https://developers.google.com/analytics/devguides/collection/gtagjs/cookies-user-id#cookie_update
	        cookieUpdate: "cookie_update",
	        cookieExpires: "cookie_expires",
	        cookieDomain: "cookie_domain",
	        cookieFlags: "cookie_flags",
	        // must be in set method?
	        userId: "user_id",
	        clientId: "client_id",
	        anonymizeIp: "anonymize_ip",
	        // https://support.google.com/analytics/answer/2853546?hl=en#zippy=%2Cin-this-article
	        contentGroup1: "content_group1",
	        contentGroup2: "content_group2",
	        contentGroup3: "content_group3",
	        contentGroup4: "content_group4",
	        contentGroup5: "content_group5",
	        // https://support.google.com/analytics/answer/9050852?hl=en
	        allowAdFeatures: "allow_google_signals",
	        allowAdPersonalizationSignals: "allow_ad_personalization_signals",
	        nonInteraction: "non_interaction",
	        page: "page_path",
	        hitCallback: "event_callback"
	      };
	      var gtagOptions = Object.entries(gaOptions).reduce(function (prev, _ref) {
	        var _ref2 = _slicedToArray(_ref, 2),
	          key = _ref2[0],
	          value = _ref2[1];
	        if (mapFields[key]) {
	          prev[mapFields[key]] = value;
	        } else {
	          prev[key] = value;
	        }
	        return prev;
	      }, {});
	      return gtagOptions;
	    });
	    _defineProperty(this, "initialize", function (GA_MEASUREMENT_ID) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      if (!GA_MEASUREMENT_ID) {
	        throw new Error("Require GA_MEASUREMENT_ID");
	      }
	      var initConfigs = typeof GA_MEASUREMENT_ID === "string" ? [{
	        trackingId: GA_MEASUREMENT_ID
	      }] : GA_MEASUREMENT_ID;
	      _this._currentMeasurementId = initConfigs[0].trackingId;
	      var gaOptions = options.gaOptions,
	        gtagOptions = options.gtagOptions,
	        _options$legacyDimens = options.legacyDimensionMetric,
	        legacyDimensionMetric = _options$legacyDimens === void 0 ? true : _options$legacyDimens,
	        nonce = options.nonce,
	        _options$testMode = options.testMode,
	        testMode = _options$testMode === void 0 ? false : _options$testMode;
	      _this._testMode = testMode;
	      if (!testMode) {
	        _this._loadGA(_this._currentMeasurementId, nonce);
	      }
	      if (!_this.isInitialized) {
	        _this._gtag("js", new Date());
	        initConfigs.forEach(function (config) {
	          var mergedGtagOptions = _this._appendCustomMap(_objectSpread(_objectSpread(_objectSpread({
	            // https://developers.google.com/analytics/devguides/collection/gtagjs/pages#disable_pageview_measurement
	            send_page_view: false
	          }, _this._toGtagOptions(_objectSpread(_objectSpread({}, gaOptions), config.gaOptions))), gtagOptions), config.gtagOptions), legacyDimensionMetric);
	          _this._gtag("config", config.trackingId, mergedGtagOptions);
	        });
	      }
	      _this.isInitialized = true;
	      if (!testMode) {
	        var queues = _toConsumableArray(_this._queueGtag);
	        _this._queueGtag = [];
	        _this._isQueuing = false;
	        while (queues.length) {
	          var queue = queues.shift();
	          _this._gtag.apply(_this, _toConsumableArray(queue));
	          if (queue[0] === "get") {
	            _this._isQueuing = true;
	          }
	        }
	      }
	    });
	    _defineProperty(this, "set", function (fieldsObject) {
	      if (!fieldsObject) {
	        console.warn("`fieldsObject` is required in .set()");
	        return;
	      }
	      if (_typeof(fieldsObject) !== "object") {
	        console.warn("Expected `fieldsObject` arg to be an Object");
	        return;
	      }
	      if (Object.keys(fieldsObject).length === 0) {
	        console.warn("empty `fieldsObject` given to .set()");
	      }
	      _this._gaCommand("set", fieldsObject);
	    });
	    _defineProperty(this, "_gaCommandSendEvent", function (eventCategory, eventAction, eventLabel, eventValue, fieldsObject) {
	      _this._gtag("event", eventAction, _objectSpread(_objectSpread({
	        event_category: eventCategory,
	        event_label: eventLabel,
	        value: eventValue
	      }, fieldsObject && {
	        non_interaction: fieldsObject.nonInteraction
	      }), _this._toGtagOptions(fieldsObject)));
	    });
	    _defineProperty(this, "_gaCommandSendEventParameters", function () {
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	      if (typeof args[0] === "string") {
	        _this._gaCommandSendEvent.apply(_this, _toConsumableArray(args.slice(1)));
	      } else {
	        var _args$ = args[0],
	          eventCategory = _args$.eventCategory,
	          eventAction = _args$.eventAction,
	          eventLabel = _args$.eventLabel,
	          eventValue = _args$.eventValue;
	          _args$.hitType;
	          var rest = _objectWithoutProperties(_args$, _excluded);
	        _this._gaCommandSendEvent(eventCategory, eventAction, eventLabel, eventValue, rest);
	      }
	    });
	    _defineProperty(this, "_gaCommandSendTiming", function (timingCategory, timingVar, timingValue, timingLabel) {
	      _this._gtag("event", "timing_complete", {
	        name: timingVar,
	        value: timingValue,
	        event_category: timingCategory,
	        event_label: timingLabel
	      });
	    });
	    _defineProperty(this, "_gaCommandSendPageview", function (page, fieldsObject) {
	      if (fieldsObject && Object.keys(fieldsObject).length) {
	        var _this$_toGtagOptions = _this._toGtagOptions(fieldsObject),
	          title = _this$_toGtagOptions.title,
	          location = _this$_toGtagOptions.location,
	          rest = _objectWithoutProperties(_this$_toGtagOptions, _excluded2);
	        _this._gtag("event", "page_view", _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, page && {
	          page_path: page
	        }), title && {
	          page_title: title
	        }), location && {
	          page_location: location
	        }), rest));
	      } else if (page) {
	        _this._gtag("event", "page_view", {
	          page_path: page
	        });
	      } else {
	        _this._gtag("event", "page_view");
	      }
	    });
	    _defineProperty(this, "_gaCommandSendPageviewParameters", function () {
	      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	        args[_key3] = arguments[_key3];
	      }
	      if (typeof args[0] === "string") {
	        _this._gaCommandSendPageview.apply(_this, _toConsumableArray(args.slice(1)));
	      } else {
	        var _args$2 = args[0],
	          page = _args$2.page;
	          _args$2.hitType;
	          var rest = _objectWithoutProperties(_args$2, _excluded3);
	        _this._gaCommandSendPageview(page, rest);
	      }
	    });
	    _defineProperty(this, "_gaCommandSend", function () {
	      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	        args[_key4] = arguments[_key4];
	      }
	      var hitType = typeof args[0] === "string" ? args[0] : args[0].hitType;
	      switch (hitType) {
	        case "event":
	          _this._gaCommandSendEventParameters.apply(_this, args);
	          break;
	        case "pageview":
	          _this._gaCommandSendPageviewParameters.apply(_this, args);
	          break;
	        case "timing":
	          _this._gaCommandSendTiming.apply(_this, _toConsumableArray(args.slice(1)));
	          break;
	        case "screenview":
	        case "transaction":
	        case "item":
	        case "social":
	        case "exception":
	          console.warn("Unsupported send command: ".concat(hitType));
	          break;
	        default:
	          console.warn("Send command doesn't exist: ".concat(hitType));
	      }
	    });
	    _defineProperty(this, "_gaCommandSet", function () {
	      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	        args[_key5] = arguments[_key5];
	      }
	      if (typeof args[0] === "string") {
	        args[0] = _defineProperty({}, args[0], args[1]);
	      }
	      _this._gtag("set", _this._toGtagOptions(args[0]));
	    });
	    _defineProperty(this, "_gaCommand", function (command) {
	      for (var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
	        args[_key6 - 1] = arguments[_key6];
	      }
	      switch (command) {
	        case "send":
	          _this._gaCommandSend.apply(_this, args);
	          break;
	        case "set":
	          _this._gaCommandSet.apply(_this, args);
	          break;
	        default:
	          console.warn("Command doesn't exist: ".concat(command));
	      }
	    });
	    _defineProperty(this, "ga", function () {
	      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
	        args[_key7] = arguments[_key7];
	      }
	      if (typeof args[0] === "string") {
	        _this._gaCommand.apply(_this, args);
	      } else {
	        var readyCallback = args[0];
	        _this._gtag("get", _this._currentMeasurementId, "client_id", function (clientId) {
	          _this._isQueuing = false;
	          var queues = _this._queueGtag;
	          readyCallback({
	            get: function get(property) {
	              return property === "clientId" ? clientId : property === "trackingId" ? _this._currentMeasurementId : property === "apiVersion" ? "1" : undefined;
	            }
	          });
	          while (queues.length) {
	            var queue = queues.shift();
	            _this._gtag.apply(_this, _toConsumableArray(queue));
	          }
	        });
	        _this._isQueuing = true;
	      }
	      return _this.ga;
	    });
	    _defineProperty(this, "event", function (optionsOrName, params) {
	      if (typeof optionsOrName === "string") {
	        _this._gtag("event", optionsOrName, _this._toGtagOptions(params));
	      } else {
	        var action = optionsOrName.action,
	          category = optionsOrName.category,
	          label = optionsOrName.label,
	          value = optionsOrName.value,
	          nonInteraction = optionsOrName.nonInteraction,
	          transport = optionsOrName.transport,
	          rest = _objectWithoutProperties(optionsOrName, _excluded4);
	        if (!category || !action) {
	          console.warn("args.category AND args.action are required in event()");
	          return;
	        } // Required Fields

	        var fieldObject = {
	          hitType: "event",
	          eventCategory: (0, _format["default"])(category),
	          eventAction: (0, _format["default"])(action)
	        }; // Optional Fields

	        if (label) {
	          fieldObject.eventLabel = (0, _format["default"])(label);
	        }
	        if (typeof value !== "undefined") {
	          if (typeof value !== "number") {
	            console.warn("Expected `args.value` arg to be a Number.");
	          } else {
	            fieldObject.eventValue = value;
	          }
	        }
	        if (typeof nonInteraction !== "undefined") {
	          if (typeof nonInteraction !== "boolean") {
	            console.warn("`args.nonInteraction` must be a boolean.");
	          } else {
	            fieldObject.nonInteraction = nonInteraction;
	          }
	        }
	        if (typeof transport !== "undefined") {
	          if (typeof transport !== "string") {
	            console.warn("`args.transport` must be a string.");
	          } else {
	            if (["beacon", "xhr", "image"].indexOf(transport) === -1) {
	              console.warn("`args.transport` must be either one of these values: `beacon`, `xhr` or `image`");
	            }
	            fieldObject.transport = transport;
	          }
	        }
	        Object.keys(rest).filter(function (key) {
	          return key.substr(0, "dimension".length) === "dimension";
	        }).forEach(function (key) {
	          fieldObject[key] = rest[key];
	        });
	        Object.keys(rest).filter(function (key) {
	          return key.substr(0, "metric".length) === "metric";
	        }).forEach(function (key) {
	          fieldObject[key] = rest[key];
	        });
	        _this._gaCommand("send", fieldObject);
	      }
	    });
	    _defineProperty(this, "send", function (fieldObject) {
	      _this._gaCommand("send", fieldObject);
	    });
	    _defineProperty(this, "pageview", function (path, _, title) {
	      var pathTrim = path === null || path === void 0 ? void 0 : path.trim();
	      if (pathTrim === "") {
	        console.warn("path cannot be an empty string in .pageview()");
	        return;
	      }
	      _this._gaCommand("send", "pageview", pathTrim, {
	        title: title
	      });
	    });
	    this.reset();
	  }
	  _createClass(GA4, [{
	    key: "gtag",
	    value: function gtag() {
	      this._gtag.apply(this, arguments);
	    }
	  }, {
	    key: "_appendCustomMap",
	    value: function _appendCustomMap(options) {
	      var legacyDimensionMetric = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	      if (!legacyDimensionMetric) {
	        return options;
	      }
	      if (!options.custom_map) {
	        options.custom_map = {};
	      }
	      for (var i = 1; i <= 200; i++) {
	        if (!options.custom_map["dimension".concat(i)]) {
	          options.custom_map["dimension".concat(i)] = "dimension".concat(i);
	        }
	        if (!options.custom_map["metric".concat(i)]) {
	          options.custom_map["metric".concat(i)] = "metric".concat(i);
	        }
	      }
	      return options;
	    }
	    /**
	     * @since v1.0.2
	     * @param {string} [path="location.href"]
	     * @param {string[]} [_] unsupported
	     * @param {string} [title="location.pathname"]
	     * @deprecated Use `.send("pageview")` instead
	     */
	  }, {
	    key: "outboundLink",
	    value:
	    /**
	     * @since v1.0.6
	     * @param {Object} options
	     * @param {string} options.label
	     * @param {function} hitCallback
	     * @deprecated Use `enhanced measurement` feature in Google Analytics.
	     */
	    function outboundLink(_ref3, hitCallback) {
	      var label = _ref3.label;
	      if (typeof hitCallback !== "function") {
	        console.warn("hitCallback function is required");
	        return;
	      }
	      if (!label) {
	        console.warn("args.label is required in outboundLink()");
	        return;
	      } // Required Fields

	      var fieldObject = {
	        hitType: "event",
	        eventCategory: "Outbound",
	        eventAction: "Click",
	        eventLabel: (0, _format["default"])(label)
	      };
	      var safetyCallbackCalled = false;
	      var safetyCallback = function safetyCallback() {
	        // This prevents a delayed response from GA
	        // causing hitCallback from being fired twice
	        safetyCallbackCalled = true;
	        hitCallback();
	      }; // Using a timeout to ensure the execution of critical application code
	      // in the case when the GA server might be down
	      // or an ad blocker prevents sending the data
	      // register safety net timeout:

	      var t = setTimeout(safetyCallback, 250);
	      var clearableCallbackForGA = function clearableCallbackForGA() {
	        clearTimeout(t);
	        if (!safetyCallbackCalled) {
	          hitCallback();
	        }
	      };
	      fieldObject.hitCallback = clearableCallbackForGA;
	      this._gaCommand("send", fieldObject);
	    }
	  }]);
	  return GA4;
	}();
	exports.GA4 = GA4;
	var _default = new GA4();
	exports["default"] = _default;
} (ga4));

(function (exports) {

	function _typeof(obj) {
	  "@babel/helpers - typeof";

	  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj;
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	  }
	  return _typeof(obj);
	}
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.ReactGAImplementation = void 0;
	var _ga = _interopRequireWildcard(ga4);
	function _getRequireWildcardCache(nodeInterop) {
	  if (typeof WeakMap !== "function") return null;
	  var cacheBabelInterop = new WeakMap();
	  var cacheNodeInterop = new WeakMap();
	  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
	    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
	  })(nodeInterop);
	}
	function _interopRequireWildcard(obj, nodeInterop) {
	  if (!nodeInterop && obj && obj.__esModule) {
	    return obj;
	  }
	  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return {
	      "default": obj
	    };
	  }
	  var cache = _getRequireWildcardCache(nodeInterop);
	  if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }
	  var newObj = {};
	  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
	  for (var key in obj) {
	    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
	      if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }
	  newObj["default"] = obj;
	  if (cache) {
	    cache.set(obj, newObj);
	  }
	  return newObj;
	}
	var ReactGAImplementation = _ga.GA4;
	exports.ReactGAImplementation = ReactGAImplementation;
	var _default = _ga["default"];
	exports["default"] = _default;
} (dist$3));

var ReactGA = /*@__PURE__*/getDefaultExportFromCjs(dist$3);

const offlineSlice = createSlice({
  name: 'offline',
  initialState: initialState$b,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setServiceWorkerInitialized: (state, action) => {
      state.serviceWorkerInitialized = true;
    },
    updateServiceWorker: (state, action) => {
      state.latestServiceWorkerLoaded = false;
      state.serviceWorkerUpdated = true;
      state.serviceWorkerRegistration = action.payload;
    },
    setLatestServiceWorkerLoaded: (state, action) => {
      state.latestServiceWorkerLoaded = action.payload;
    }
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: builder => {}
});
const {
  updateServiceWorker,
  setServiceWorkerInitialized,
  setLatestServiceWorkerLoaded
} = offlineSlice.actions;
const selectServiceWorkerUpdated = state => state.offline.serviceWorkerUpdated;
const selectServiceWorkerInitialized = state => state.offline.serviceWorkerInitialized;
const selectServiceWorkerRegistration = state => state.offline.serviceWorkerRegistration;
var offlineReducer = offlineSlice.reducer;

/*! js-cookie v3.0.5 | MIT */
/* eslint-disable no-var */
function assign$5(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target;
}
/* eslint-enable no-var */

/* eslint-disable no-var */
var defaultConverter = {
  read: function (value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function (value) {
    return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init(converter, defaultAttributes) {
  function set(name, value, attributes) {
    if (typeof document === 'undefined') {
      return;
    }
    attributes = assign$5({}, defaultAttributes, attributes);
    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }
    name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue;
      }
      stringifiedAttributes += '; ' + attributeName;
      if (attributes[attributeName] === true) {
        continue;
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }
    return document.cookie = name + '=' + converter.write(value, name) + stringifiedAttributes;
  }
  function get(name) {
    if (typeof document === 'undefined' || arguments.length && !name) {
      return;
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');
      try {
        var found = decodeURIComponent(parts[0]);
        jar[found] = converter.read(value, found);
        if (name === found) {
          break;
        }
      } catch (e) {}
    }
    return name ? jar[name] : jar;
  }
  return Object.create({
    set,
    get,
    remove: function (name, attributes) {
      set(name, '', assign$5({}, attributes, {
        expires: -1
      }));
    },
    withAttributes: function (attributes) {
      return init(this.converter, assign$5({}, this.attributes, attributes));
    },
    withConverter: function (converter) {
      return init(assign$5({}, this.converter, converter), this.attributes);
    }
  }, {
    attributes: {
      value: Object.freeze(defaultAttributes)
    },
    converter: {
      value: Object.freeze(converter)
    }
  });
}
var api = init(defaultConverter, {
  path: '/'
});

function styleInject$1(css,ref){if(ref===void 0)ref={};var insertAt=ref.insertAt;if(!css||typeof document==='undefined'){return;}var head=document.head||document.getElementsByTagName('head')[0];var style=document.createElement('style');style.type='text/css';if(insertAt==='top'){if(head.firstChild){head.insertBefore(style,head.firstChild);}else {head.appendChild(style);}}else {head.appendChild(style);}if(style.styleSheet){style.styleSheet.cssText=css;}else {style.appendChild(document.createTextNode(css));}}var css_248z$8$1="@import url(\"https://rsms.me/inter/inter.css\");\n\n/*! tailwindcss v3.4.1 | MIT License | https://tailwindcss.com*/*,:after,:before{border:0 solid #e5e7eb;box-sizing:border-box}:after,:before{--tw-content:\"\"}:host,html{-webkit-text-size-adjust:100%;font-feature-settings:normal;-webkit-tap-highlight-color:transparent;font-family:Inter var,ui-sans-serif,system-ui,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;font-variation-settings:normal;line-height:1.5;tab-size:4}body{line-height:inherit;margin:0}hr{border-top-width:1px;color:inherit;height:0}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,pre,samp{font-feature-settings:normal;font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-size:1em;font-variation-settings:normal}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:initial}sub{bottom:-.25em}sup{top:-.5em}table{border-collapse:collapse;border-color:inherit;text-indent:0}button,input,optgroup,select,textarea{font-feature-settings:inherit;color:inherit;font-family:inherit;font-size:100%;font-variation-settings:inherit;font-weight:inherit;line-height:inherit;margin:0;padding:0}button,select{text-transform:none}[type=button],[type=reset],[type=submit],button{-webkit-appearance:button;background-color:initial;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:initial}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dd,dl,figure,h1,h2,h3,h4,h5,h6,hr,p,pre{margin:0}fieldset{margin:0}fieldset,legend{padding:0}menu,ol,ul{list-style:none;margin:0;padding:0}dialog{padding:0}textarea{resize:vertical}input::placeholder,textarea::placeholder{color:#9ca3af;opacity:1}[role=button],button{cursor:pointer}:disabled{cursor:default}audio,canvas,embed,iframe,img,object,svg,video{display:block;vertical-align:middle}img,video{height:auto;max-width:100%}[hidden]{display:none}[multiple],[type=date],[type=datetime-local],[type=email],[type=month],[type=number],[type=password],[type=search],[type=tel],[type=text],[type=time],[type=url],[type=week],select,textarea{--tw-shadow:0 0 #0000;-webkit-appearance:none;appearance:none;background-color:#fff;border-color:#6b7280;border-radius:0;border-width:1px;font-size:1rem;line-height:1.5rem;padding:.5rem .75rem}[multiple]:focus,[type=date]:focus,[type=datetime-local]:focus,[type=email]:focus,[type=month]:focus,[type=number]:focus,[type=password]:focus,[type=search]:focus,[type=tel]:focus,[type=text]:focus,[type=time]:focus,[type=url]:focus,[type=week]:focus,select:focus,textarea:focus{--tw-ring-inset:var(--tw-empty,/*!*/ /*!*/);--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:#2563eb;--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);border-color:#2563eb;box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow);outline:2px solid #0000;outline-offset:2px}input::placeholder,textarea::placeholder{color:#6b7280;opacity:1}::-webkit-datetime-edit-fields-wrapper{padding:0}::-webkit-date-and-time-value{min-height:1.5em}::-webkit-datetime-edit,::-webkit-datetime-edit-day-field,::-webkit-datetime-edit-hour-field,::-webkit-datetime-edit-meridiem-field,::-webkit-datetime-edit-millisecond-field,::-webkit-datetime-edit-minute-field,::-webkit-datetime-edit-month-field,::-webkit-datetime-edit-second-field,::-webkit-datetime-edit-year-field{padding-bottom:0;padding-top:0}select{color-adjust:exact;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3E%3Cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3E%3C/svg%3E\");background-position:right .5rem center;background-repeat:no-repeat;background-size:1.5em 1.5em;padding-right:2.5rem;-webkit-print-color-adjust:exact}[multiple]{color-adjust:unset;background-image:none;background-position:0 0;background-repeat:unset;background-size:initial;padding-right:.75rem;-webkit-print-color-adjust:unset}[type=checkbox],[type=radio]{color-adjust:exact;--tw-shadow:0 0 #0000;-webkit-appearance:none;appearance:none;background-color:#fff;background-origin:border-box;border-color:#6b7280;border-width:1px;color:#2563eb;display:inline-block;flex-shrink:0;height:1rem;padding:0;-webkit-print-color-adjust:exact;-webkit-user-select:none;user-select:none;vertical-align:middle;width:1rem}[type=checkbox]{border-radius:0}[type=radio]{border-radius:100%}[type=checkbox]:focus,[type=radio]:focus{--tw-ring-inset:var(--tw-empty,/*!*/ /*!*/);--tw-ring-offset-width:2px;--tw-ring-offset-color:#fff;--tw-ring-color:#2563eb;--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow);outline:2px solid #0000;outline-offset:2px}[type=checkbox]:checked,[type=radio]:checked{background-color:currentColor;background-position:50%;background-repeat:no-repeat;background-size:100% 100%;border-color:#0000}[type=checkbox]:checked{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 16 16' fill='%23fff' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.207 4.793a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L6.5 9.086l4.293-4.293a1 1 0 0 1 1.414 0z'/%3E%3C/svg%3E\")}[type=radio]:checked{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 16 16' fill='%23fff' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='8' cy='8' r='3'/%3E%3C/svg%3E\")}[type=checkbox]:checked:focus,[type=checkbox]:checked:hover,[type=checkbox]:indeterminate,[type=radio]:checked:focus,[type=radio]:checked:hover{background-color:currentColor;border-color:#0000}[type=checkbox]:indeterminate{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 16 16'%3E%3Cpath stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M4 8h8'/%3E%3C/svg%3E\");background-position:50%;background-repeat:no-repeat;background-size:100% 100%}[type=checkbox]:indeterminate:focus,[type=checkbox]:indeterminate:hover{background-color:currentColor;border-color:#0000}[type=file]{background:unset;border-color:inherit;border-radius:0;border-width:0;font-size:unset;line-height:inherit;padding:0}[type=file]:focus{outline:1px auto -webkit-focus-ring-color}*,:after,:before{--tw-border-spacing-x:0;--tw-border-spacing-y:0;--tw-translate-x:0;--tw-translate-y:0;--tw-rotate:0;--tw-skew-x:0;--tw-skew-y:0;--tw-scale-x:1;--tw-scale-y:1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness:proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:#3b82f680;--tw-ring-offset-shadow:0 0 #0000;--tw-ring-shadow:0 0 #0000;--tw-shadow:0 0 #0000;--tw-shadow-colored:0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: }::backdrop{--tw-border-spacing-x:0;--tw-border-spacing-y:0;--tw-translate-x:0;--tw-translate-y:0;--tw-rotate:0;--tw-skew-x:0;--tw-skew-y:0;--tw-scale-x:1;--tw-scale-y:1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness:proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:#3b82f680;--tw-ring-offset-shadow:0 0 #0000;--tw-ring-shadow:0 0 #0000;--tw-shadow:0 0 #0000;--tw-shadow-colored:0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: }.prose{color:var(--tw-prose-body);max-width:65ch}.prose :where(p):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:1.25em;margin-top:1.25em}.prose :where([class~=lead]):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-lead);font-size:1.25em;line-height:1.6;margin-bottom:1.2em;margin-top:1.2em}.prose :where(a):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-links);font-weight:500;text-decoration:underline}.prose :where(strong):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-bold);font-weight:600}.prose :where(a strong):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit}.prose :where(blockquote strong):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit}.prose :where(thead th strong):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit}.prose :where(ol):not(:where([class~=not-prose],[class~=not-prose] *)){list-style-type:decimal;margin-bottom:1.25em;margin-top:1.25em;padding-left:1.625em}.prose :where(ol[type=A]):not(:where([class~=not-prose],[class~=not-prose] *)){list-style-type:upper-alpha}.prose :where(ol[type=a]):not(:where([class~=not-prose],[class~=not-prose] *)){list-style-type:lower-alpha}.prose :where(ol[type=A s]):not(:where([class~=not-prose],[class~=not-prose] *)){list-style-type:upper-alpha}.prose :where(ol[type=a s]):not(:where([class~=not-prose],[class~=not-prose] *)){list-style-type:lower-alpha}.prose :where(ol[type=I]):not(:where([class~=not-prose],[class~=not-prose] *)){list-style-type:upper-roman}.prose :where(ol[type=i]):not(:where([class~=not-prose],[class~=not-prose] *)){list-style-type:lower-roman}.prose :where(ol[type=I s]):not(:where([class~=not-prose],[class~=not-prose] *)){list-style-type:upper-roman}.prose :where(ol[type=i s]):not(:where([class~=not-prose],[class~=not-prose] *)){list-style-type:lower-roman}.prose :where(ol[type=\"1\"]):not(:where([class~=not-prose],[class~=not-prose] *)){list-style-type:decimal}.prose :where(ul):not(:where([class~=not-prose],[class~=not-prose] *)){list-style-type:disc;margin-bottom:1.25em;margin-top:1.25em;padding-left:1.625em}.prose :where(ol>li):not(:where([class~=not-prose],[class~=not-prose] *))::marker{color:var(--tw-prose-counters);font-weight:400}.prose :where(ul>li):not(:where([class~=not-prose],[class~=not-prose] *))::marker{color:var(--tw-prose-bullets)}.prose :where(dt):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-headings);font-weight:600;margin-top:1.25em}.prose :where(hr):not(:where([class~=not-prose],[class~=not-prose] *)){border-color:var(--tw-prose-hr);border-top-width:1px;margin-bottom:3em;margin-top:3em}.prose :where(blockquote):not(:where([class~=not-prose],[class~=not-prose] *)){border-left-color:var(--tw-prose-quote-borders);border-left-width:.25rem;color:var(--tw-prose-quotes);font-style:italic;font-weight:500;margin-bottom:1.6em;margin-top:1.6em;padding-left:1em;quotes:\"\\201C\"\"\\201D\"\"\\2018\"\"\\2019\"}.prose :where(blockquote p:first-of-type):not(:where([class~=not-prose],[class~=not-prose] *)):before{content:open-quote}.prose :where(blockquote p:last-of-type):not(:where([class~=not-prose],[class~=not-prose] *)):after{content:close-quote}.prose :where(h1):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-headings);font-size:2.25em;font-weight:800;line-height:1.1111111;margin-bottom:.8888889em;margin-top:0}.prose :where(h1 strong):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit;font-weight:900}.prose :where(h2):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-headings);font-size:1.5em;font-weight:700;line-height:1.3333333;margin-bottom:1em;margin-top:2em}.prose :where(h2 strong):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit;font-weight:800}.prose :where(h3):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-headings);font-size:1.25em;font-weight:600;line-height:1.6;margin-bottom:.6em;margin-top:1.6em}.prose :where(h3 strong):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit;font-weight:700}.prose :where(h4):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-headings);font-weight:600;line-height:1.5;margin-bottom:.5em;margin-top:1.5em}.prose :where(h4 strong):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit;font-weight:700}.prose :where(img):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:2em;margin-top:2em}.prose :where(picture):not(:where([class~=not-prose],[class~=not-prose] *)){display:block;margin-bottom:2em;margin-top:2em}.prose :where(kbd):not(:where([class~=not-prose],[class~=not-prose] *)){border-radius:.3125rem;box-shadow:0 0 0 1px rgb(var(--tw-prose-kbd-shadows)/10%),0 3px 0 rgb(var(--tw-prose-kbd-shadows)/10%);color:var(--tw-prose-kbd);font-family:inherit;font-size:.875em;font-weight:500;padding:.1875em .375em}.prose :where(code):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-code);font-size:.875em;font-weight:600}.prose :where(code):not(:where([class~=not-prose],[class~=not-prose] *)):before{content:\"`\"}.prose :where(code):not(:where([class~=not-prose],[class~=not-prose] *)):after{content:\"`\"}.prose :where(a code):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit}.prose :where(h1 code):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit}.prose :where(h2 code):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit;font-size:.875em}.prose :where(h3 code):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit;font-size:.9em}.prose :where(h4 code):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit}.prose :where(blockquote code):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit}.prose :where(thead th code):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit}.prose :where(pre):not(:where([class~=not-prose],[class~=not-prose] *)){background-color:var(--tw-prose-pre-bg);border-radius:.375rem;color:var(--tw-prose-pre-code);font-size:.875em;font-weight:400;line-height:1.7142857;margin-bottom:1.7142857em;margin-top:1.7142857em;overflow-x:auto;padding:.8571429em 1.1428571em}.prose :where(pre code):not(:where([class~=not-prose],[class~=not-prose] *)){background-color:initial;border-radius:0;border-width:0;color:inherit;font-family:inherit;font-size:inherit;font-weight:inherit;line-height:inherit;padding:0}.prose :where(pre code):not(:where([class~=not-prose],[class~=not-prose] *)):before{content:none}.prose :where(pre code):not(:where([class~=not-prose],[class~=not-prose] *)):after{content:none}.prose :where(table):not(:where([class~=not-prose],[class~=not-prose] *)){font-size:.875em;line-height:1.7142857;margin-bottom:2em;margin-top:2em;table-layout:auto;text-align:left;width:100%}.prose :where(thead):not(:where([class~=not-prose],[class~=not-prose] *)){border-bottom-color:var(--tw-prose-th-borders);border-bottom-width:1px}.prose :where(thead th):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-headings);font-weight:600;padding-bottom:.5714286em;padding-left:.5714286em;padding-right:.5714286em;vertical-align:bottom}.prose :where(tbody tr):not(:where([class~=not-prose],[class~=not-prose] *)){border-bottom-color:var(--tw-prose-td-borders);border-bottom-width:1px}.prose :where(tbody tr:last-child):not(:where([class~=not-prose],[class~=not-prose] *)){border-bottom-width:0}.prose :where(tbody td):not(:where([class~=not-prose],[class~=not-prose] *)){vertical-align:initial}.prose :where(tfoot):not(:where([class~=not-prose],[class~=not-prose] *)){border-top-color:var(--tw-prose-th-borders);border-top-width:1px}.prose :where(tfoot td):not(:where([class~=not-prose],[class~=not-prose] *)){vertical-align:top}.prose :where(figure>*):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:0;margin-top:0}.prose :where(figcaption):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-captions);font-size:.875em;line-height:1.4285714;margin-top:.8571429em}.prose{--tw-prose-body:#374151;--tw-prose-headings:#111827;--tw-prose-lead:#4b5563;--tw-prose-links:#111827;--tw-prose-bold:#111827;--tw-prose-counters:#6b7280;--tw-prose-bullets:#d1d5db;--tw-prose-hr:#e5e7eb;--tw-prose-quotes:#111827;--tw-prose-quote-borders:#e5e7eb;--tw-prose-captions:#6b7280;--tw-prose-kbd:#111827;--tw-prose-kbd-shadows:17 24 39;--tw-prose-code:#111827;--tw-prose-pre-code:#e5e7eb;--tw-prose-pre-bg:#1f2937;--tw-prose-th-borders:#d1d5db;--tw-prose-td-borders:#e5e7eb;--tw-prose-invert-body:#d1d5db;--tw-prose-invert-headings:#fff;--tw-prose-invert-lead:#9ca3af;--tw-prose-invert-links:#fff;--tw-prose-invert-bold:#fff;--tw-prose-invert-counters:#9ca3af;--tw-prose-invert-bullets:#4b5563;--tw-prose-invert-hr:#374151;--tw-prose-invert-quotes:#f3f4f6;--tw-prose-invert-quote-borders:#374151;--tw-prose-invert-captions:#9ca3af;--tw-prose-invert-kbd:#fff;--tw-prose-invert-kbd-shadows:255 255 255;--tw-prose-invert-code:#fff;--tw-prose-invert-pre-code:#d1d5db;--tw-prose-invert-pre-bg:#00000080;--tw-prose-invert-th-borders:#4b5563;--tw-prose-invert-td-borders:#374151;font-size:1rem;line-height:1.75}.prose :where(picture>img):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:0;margin-top:0}.prose :where(video):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:2em;margin-top:2em}.prose :where(li):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:.5em;margin-top:.5em}.prose :where(ol>li):not(:where([class~=not-prose],[class~=not-prose] *)){padding-left:.375em}.prose :where(ul>li):not(:where([class~=not-prose],[class~=not-prose] *)){padding-left:.375em}.prose :where(.prose>ul>li p):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:.75em;margin-top:.75em}.prose :where(.prose>ul>li>:first-child):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:1.25em}.prose :where(.prose>ul>li>:last-child):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:1.25em}.prose :where(.prose>ol>li>:first-child):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:1.25em}.prose :where(.prose>ol>li>:last-child):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:1.25em}.prose :where(ul ul,ul ol,ol ul,ol ol):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:.75em;margin-top:.75em}.prose :where(dl):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:1.25em;margin-top:1.25em}.prose :where(dd):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:.5em;padding-left:1.625em}.prose :where(hr+*):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:0}.prose :where(h2+*):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:0}.prose :where(h3+*):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:0}.prose :where(h4+*):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:0}.prose :where(thead th:first-child):not(:where([class~=not-prose],[class~=not-prose] *)){padding-left:0}.prose :where(thead th:last-child):not(:where([class~=not-prose],[class~=not-prose] *)){padding-right:0}.prose :where(tbody td,tfoot td):not(:where([class~=not-prose],[class~=not-prose] *)){padding:.5714286em}.prose :where(tbody td:first-child,tfoot td:first-child):not(:where([class~=not-prose],[class~=not-prose] *)){padding-left:0}.prose :where(tbody td:last-child,tfoot td:last-child):not(:where([class~=not-prose],[class~=not-prose] *)){padding-right:0}.prose :where(figure):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:2em;margin-top:2em}.prose :where(.prose>:first-child):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:0}.prose :where(.prose>:last-child):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:0}.prose-base{font-size:1rem;line-height:1.75}.prose-base :where(p):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:1.25em;margin-top:1.25em}.prose-base :where([class~=lead]):not(:where([class~=not-prose],[class~=not-prose] *)){font-size:1.25em;line-height:1.6;margin-bottom:1.2em;margin-top:1.2em}.prose-base :where(blockquote):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:1.6em;margin-top:1.6em;padding-left:1em}.prose-base :where(h1):not(:where([class~=not-prose],[class~=not-prose] *)){font-size:2.25em;line-height:1.1111111;margin-bottom:.8888889em;margin-top:0}.prose-base :where(h2):not(:where([class~=not-prose],[class~=not-prose] *)){font-size:1.5em;line-height:1.3333333;margin-bottom:1em;margin-top:2em}.prose-base :where(h3):not(:where([class~=not-prose],[class~=not-prose] *)){font-size:1.25em;line-height:1.6;margin-bottom:.6em;margin-top:1.6em}.prose-base :where(h4):not(:where([class~=not-prose],[class~=not-prose] *)){line-height:1.5;margin-bottom:.5em;margin-top:1.5em}.prose-base :where(img):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:2em;margin-top:2em}.prose-base :where(picture):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:2em;margin-top:2em}.prose-base :where(picture>img):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:0;margin-top:0}.prose-base :where(video):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:2em;margin-top:2em}.prose-base :where(kbd):not(:where([class~=not-prose],[class~=not-prose] *)){border-radius:.3125rem;font-size:.875em;padding:.1875em .375em}.prose-base :where(code):not(:where([class~=not-prose],[class~=not-prose] *)){font-size:.875em}.prose-base :where(h2 code):not(:where([class~=not-prose],[class~=not-prose] *)){font-size:.875em}.prose-base :where(h3 code):not(:where([class~=not-prose],[class~=not-prose] *)){font-size:.9em}.prose-base :where(pre):not(:where([class~=not-prose],[class~=not-prose] *)){border-radius:.375rem;font-size:.875em;line-height:1.7142857;margin-bottom:1.7142857em;margin-top:1.7142857em;padding:.8571429em 1.1428571em}.prose-base :where(ol):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:1.25em;margin-top:1.25em;padding-left:1.625em}.prose-base :where(ul):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:1.25em;margin-top:1.25em;padding-left:1.625em}.prose-base :where(li):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:.5em;margin-top:.5em}.prose-base :where(ol>li):not(:where([class~=not-prose],[class~=not-prose] *)){padding-left:.375em}.prose-base :where(ul>li):not(:where([class~=not-prose],[class~=not-prose] *)){padding-left:.375em}.prose-base :where(.prose-base>ul>li p):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:.75em;margin-top:.75em}.prose-base :where(.prose-base>ul>li>:first-child):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:1.25em}.prose-base :where(.prose-base>ul>li>:last-child):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:1.25em}.prose-base :where(.prose-base>ol>li>:first-child):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:1.25em}.prose-base :where(.prose-base>ol>li>:last-child):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:1.25em}.prose-base :where(ul ul,ul ol,ol ul,ol ol):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:.75em;margin-top:.75em}.prose-base :where(dl):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:1.25em;margin-top:1.25em}.prose-base :where(dt):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:1.25em}.prose-base :where(dd):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:.5em;padding-left:1.625em}.prose-base :where(hr):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:3em;margin-top:3em}.prose-base :where(hr+*):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:0}.prose-base :where(h2+*):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:0}.prose-base :where(h3+*):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:0}.prose-base :where(h4+*):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:0}.prose-base :where(table):not(:where([class~=not-prose],[class~=not-prose] *)){font-size:.875em;line-height:1.7142857}.prose-base :where(thead th):not(:where([class~=not-prose],[class~=not-prose] *)){padding-bottom:.5714286em;padding-left:.5714286em;padding-right:.5714286em}.prose-base :where(thead th:first-child):not(:where([class~=not-prose],[class~=not-prose] *)){padding-left:0}.prose-base :where(thead th:last-child):not(:where([class~=not-prose],[class~=not-prose] *)){padding-right:0}.prose-base :where(tbody td,tfoot td):not(:where([class~=not-prose],[class~=not-prose] *)){padding:.5714286em}.prose-base :where(tbody td:first-child,tfoot td:first-child):not(:where([class~=not-prose],[class~=not-prose] *)){padding-left:0}.prose-base :where(tbody td:last-child,tfoot td:last-child):not(:where([class~=not-prose],[class~=not-prose] *)){padding-right:0}.prose-base :where(figure):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:2em;margin-top:2em}.prose-base :where(figure>*):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:0;margin-top:0}.prose-base :where(figcaption):not(:where([class~=not-prose],[class~=not-prose] *)){font-size:.875em;line-height:1.4285714;margin-top:.8571429em}.prose-base :where(.prose-base>:first-child):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:0}.prose-base :where(.prose-base>:last-child):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:0}.prose-cyan{--tw-prose-links:#0891b2;--tw-prose-invert-links:#06b6d4}.aspect-h-7{--tw-aspect-h:7}.aspect-w-7{--tw-aspect-w:7;padding-bottom:calc(var(--tw-aspect-h)/var(--tw-aspect-w)*100%);position:relative}.aspect-w-7>*{bottom:0;height:100%;left:0;position:absolute;right:0;top:0;width:100%}.sr-only{clip:rect(0,0,0,0);border-width:0;height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;white-space:nowrap;width:1px}.pointer-events-none{pointer-events:none}.pointer-events-auto{pointer-events:auto}.static{position:static}.fixed{position:fixed}.absolute{position:absolute}.relative{position:relative}.sticky{position:-webkit-sticky;position:sticky}.inset-0{inset:0}.inset-y-0{bottom:0;top:0}.left-0{left:0}.right-0{right:0}.top-0{top:0}.z-0{z-index:0}.z-10{z-index:10}.z-20{z-index:20}.z-40{z-index:40}.col-span-1{grid-column:span 1/span 1}.col-start-1{grid-column-start:1}.row-start-1{grid-row-start:1}.m-0{margin:0}.m-1{margin:.25rem}.m-2{margin:.5rem}.-mx-1{margin-left:-.25rem;margin-right:-.25rem}.-mx-1\\.5{margin-left:-.375rem;margin-right:-.375rem}.-mx-2{margin-left:-.5rem;margin-right:-.5rem}.-my-1{margin-bottom:-.25rem;margin-top:-.25rem}.-my-1\\.5{margin-bottom:-.375rem;margin-top:-.375rem}.-my-3{margin-bottom:-.75rem;margin-top:-.75rem}.mx-2{margin-left:.5rem;margin-right:.5rem}.mx-4{margin-left:1rem;margin-right:1rem}.mx-6{margin-left:1.5rem;margin-right:1.5rem}.mx-auto{margin-left:auto;margin-right:auto}.my-3{margin-bottom:.75rem;margin-top:.75rem}.my-6{margin-bottom:1.5rem;margin-top:1.5rem}.-ml-px{margin-left:-1px}.-mr-12{margin-right:-3rem}.-mr-2{margin-right:-.5rem}.mb-1{margin-bottom:.25rem}.mb-2{margin-bottom:.5rem}.mb-3{margin-bottom:.75rem}.mb-4{margin-bottom:1rem}.ml-1{margin-left:.25rem}.ml-2{margin-left:.5rem}.ml-3{margin-left:.75rem}.ml-4{margin-left:1rem}.ml-6{margin-left:1.5rem}.ml-auto{margin-left:auto}.mr-1{margin-right:.25rem}.mr-2{margin-right:.5rem}.mr-3{margin-right:.75rem}.mr-4{margin-right:1rem}.mt-0{margin-top:0}.mt-1{margin-top:.25rem}.mt-2{margin-top:.5rem}.mt-3{margin-top:.75rem}.mt-4{margin-top:1rem}.mt-5{margin-top:1.25rem}.mt-6{margin-top:1.5rem}.mt-8{margin-top:2rem}.block{display:block}.inline-block{display:inline-block}.flex{display:flex}.inline-flex{display:inline-flex}.table{display:table}.flow-root{display:flow-root}.grid{display:grid}.contents{display:contents}.hidden{display:none}.h-0{height:0}.h-10{height:2.5rem}.h-12{height:3rem}.h-14{height:3.5rem}.h-16{height:4rem}.h-2\\/5{height:40%}.h-20{height:5rem}.h-3{height:.75rem}.h-32{height:8rem}.h-4{height:1rem}.h-5{height:1.25rem}.h-6{height:1.5rem}.h-60{height:15rem}.h-7{height:1.75rem}.h-8{height:2rem}.h-9{height:2.25rem}.h-96{height:24rem}.h-\\[30px\\]{height:30px}.h-full{height:100%}.h-screen{height:100vh}.max-h-56{max-height:14rem}.max-h-6{max-height:1.5rem}.max-h-full{max-height:100%}.min-h-0{min-height:0}.min-h-full{min-height:100%}.min-h-screen{min-height:100vh}.w-0{width:0}.w-10{width:2.5rem}.w-11{width:2.75rem}.w-12{width:3rem}.w-14{width:3.5rem}.w-2{width:.5rem}.w-20{width:5rem}.w-3{width:.75rem}.w-4{width:1rem}.w-40{width:10rem}.w-5{width:1.25rem}.w-52{width:13rem}.w-56{width:14rem}.w-6{width:1.5rem}.w-60{width:15rem}.w-64{width:16rem}.w-7{width:1.75rem}.w-8{width:2rem}.w-9{width:2.25rem}.w-\\[60px\\]{width:60px}.w-\\[8px\\]{width:8px}.w-auto{width:auto}.w-full{width:100%}.w-screen{width:100vw}.min-w-0{min-width:0}.min-w-full{min-width:100%}.max-w-6{max-width:1.5rem}.max-w-7xl{max-width:80rem}.max-w-\\[120px\\]{max-width:120px}.max-w-\\[200px\\]{max-width:200px}.max-w-\\[250px\\]{max-width:250px}.max-w-\\[50\\%\\]{max-width:50%}.max-w-md{max-width:28rem}.max-w-sm{max-width:24rem}.max-w-xs{max-width:20rem}.flex-1{flex:1 1 0%}.flex-none{flex:none}.flex-shrink-0{flex-shrink:0}.shrink{flex-shrink:1}.flex-grow,.grow{flex-grow:1}.origin-top-left{transform-origin:top left}.origin-top-right{transform-origin:top right}.-translate-x-full{--tw-translate-x:-100%}.-translate-x-full,.translate-x-0{transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.translate-x-0{--tw-translate-x:0px}.translate-x-5{--tw-translate-x:1.25rem}.translate-x-5,.translate-x-full{transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.translate-x-full{--tw-translate-x:100%}.translate-y-0{--tw-translate-y:0px}.translate-y-0,.translate-y-2{transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.translate-y-2{--tw-translate-y:0.5rem}.translate-y-4{--tw-translate-y:1rem}.scale-100,.translate-y-4{transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.scale-100{--tw-scale-x:1;--tw-scale-y:1}.scale-95{--tw-scale-x:.95;--tw-scale-y:.95}.scale-95,.transform{transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}@keyframes pulse{50%{opacity:.5}}.animate-pulse{animation:pulse 2s cubic-bezier(.4,0,.6,1) infinite}@keyframes spin{to{transform:rotate(1turn)}}.animate-spin{animation:spin 1s linear infinite}.cursor-default{cursor:default}.cursor-not-allowed{cursor:not-allowed}.cursor-pointer{cursor:pointer}.select-none{-webkit-user-select:none;user-select:none}.appearance-none{-webkit-appearance:none;appearance:none}.auto-rows-min{grid-auto-rows:-webkit-min-content;grid-auto-rows:min-content}.grid-cols-1{grid-template-columns:repeat(1,minmax(0,1fr))}.grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.flex-row{flex-direction:row}.flex-col{flex-direction:column}.items-start{align-items:flex-start}.items-end{align-items:flex-end}.items-center{align-items:center}.items-baseline{align-items:baseline}.justify-start{justify-content:flex-start}.justify-end{justify-content:flex-end}.justify-center{justify-content:center}.justify-between{justify-content:space-between}.justify-around{justify-content:space-around}.gap-2{gap:.5rem}.gap-4{gap:1rem}.gap-x-4{column-gap:1rem}.gap-y-10{row-gap:2.5rem}.gap-y-8{row-gap:2rem}.space-x-0>:not([hidden])~:not([hidden]){--tw-space-x-reverse:0;margin-left:calc(0px*(1 - var(--tw-space-x-reverse)));margin-right:calc(0px*var(--tw-space-x-reverse))}.space-x-0\\.5>:not([hidden])~:not([hidden]){--tw-space-x-reverse:0;margin-left:calc(.125rem*(1 - var(--tw-space-x-reverse)));margin-right:calc(.125rem*var(--tw-space-x-reverse))}.space-x-2>:not([hidden])~:not([hidden]){--tw-space-x-reverse:0;margin-left:calc(.5rem*(1 - var(--tw-space-x-reverse)));margin-right:calc(.5rem*var(--tw-space-x-reverse))}.space-x-3>:not([hidden])~:not([hidden]){--tw-space-x-reverse:0;margin-left:calc(.75rem*(1 - var(--tw-space-x-reverse)));margin-right:calc(.75rem*var(--tw-space-x-reverse))}.space-x-4>:not([hidden])~:not([hidden]){--tw-space-x-reverse:0;margin-left:calc(1rem*(1 - var(--tw-space-x-reverse)));margin-right:calc(1rem*var(--tw-space-x-reverse))}.space-x-6>:not([hidden])~:not([hidden]){--tw-space-x-reverse:0;margin-left:calc(1.5rem*(1 - var(--tw-space-x-reverse)));margin-right:calc(1.5rem*var(--tw-space-x-reverse))}.space-y-1>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-bottom:calc(.25rem*var(--tw-space-y-reverse));margin-top:calc(.25rem*(1 - var(--tw-space-y-reverse)))}.space-y-2>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-bottom:calc(.5rem*var(--tw-space-y-reverse));margin-top:calc(.5rem*(1 - var(--tw-space-y-reverse)))}.space-y-3>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-bottom:calc(.75rem*var(--tw-space-y-reverse));margin-top:calc(.75rem*(1 - var(--tw-space-y-reverse)))}.space-y-4>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-bottom:calc(1rem*var(--tw-space-y-reverse));margin-top:calc(1rem*(1 - var(--tw-space-y-reverse)))}.space-y-6>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-bottom:calc(1.5rem*var(--tw-space-y-reverse));margin-top:calc(1.5rem*(1 - var(--tw-space-y-reverse)))}.divide-x>:not([hidden])~:not([hidden]){--tw-divide-x-reverse:0;border-left-width:calc(1px*(1 - var(--tw-divide-x-reverse)));border-right-width:calc(1px*var(--tw-divide-x-reverse))}.divide-y>:not([hidden])~:not([hidden]){--tw-divide-y-reverse:0;border-bottom-width:calc(1px*var(--tw-divide-y-reverse));border-top-width:calc(1px*(1 - var(--tw-divide-y-reverse)))}.divide-gray-200>:not([hidden])~:not([hidden]){--tw-divide-opacity:1;border-color:rgb(229 231 235/var(--tw-divide-opacity))}.divide-secondary-200>:not([hidden])~:not([hidden]){--tw-divide-opacity:1;border-color:rgb(228 228 231/var(--tw-divide-opacity))}.divide-secondary-400>:not([hidden])~:not([hidden]){--tw-divide-opacity:1;border-color:rgb(161 161 170/var(--tw-divide-opacity))}.overflow-auto{overflow:auto}.overflow-hidden{overflow:hidden}.overflow-x-auto{overflow-x:auto}.overflow-y-auto{overflow-y:auto}.overflow-x-hidden{overflow-x:hidden}.truncate{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.rounded{border-radius:.25rem}.rounded-full{border-radius:9999px}.rounded-lg{border-radius:.5rem}.rounded-md{border-radius:.375rem}.rounded-l-md{border-bottom-left-radius:.375rem;border-top-left-radius:.375rem}.rounded-r-md{border-bottom-right-radius:.375rem;border-top-right-radius:.375rem}.border{border-width:1px}.border-0{border-width:0}.border-2{border-width:2px}.border-\\[1px\\]{border-width:1px}.border-\\[2px\\]{border-width:2px}.border-l{border-left-width:1px}.border-t{border-top-width:1px}.border-dashed{border-style:dashed}.border-black{--tw-border-opacity:1;border-color:rgb(0 0 0/var(--tw-border-opacity))}.border-gray-200{--tw-border-opacity:1;border-color:rgb(229 231 235/var(--tw-border-opacity))}.border-gray-300{--tw-border-opacity:1;border-color:rgb(209 213 219/var(--tw-border-opacity))}.border-green-500{--tw-border-opacity:1;border-color:rgb(34 197 94/var(--tw-border-opacity))}.border-primary{border-color:var(--theme-primary-color)}.border-red-500{--tw-border-opacity:1;border-color:rgb(239 68 68/var(--tw-border-opacity))}.border-secondary-300{--tw-border-opacity:1;border-color:rgb(212 212 216/var(--tw-border-opacity))}.border-secondary-600{--tw-border-opacity:1;border-color:rgb(82 82 91/var(--tw-border-opacity))}.border-secondary-700{--tw-border-opacity:1;border-color:rgb(63 63 70/var(--tw-border-opacity))}.border-secondary-800{--tw-border-opacity:1;border-color:rgb(39 39 42/var(--tw-border-opacity))}.border-transparent{border-color:#0000}.bg-black{--tw-bg-opacity:1;background-color:rgb(0 0 0/var(--tw-bg-opacity))}.bg-gray-100{--tw-bg-opacity:1;background-color:rgb(243 244 246/var(--tw-bg-opacity))}.bg-gray-200{--tw-bg-opacity:1;background-color:rgb(229 231 235/var(--tw-bg-opacity))}.bg-gray-600{--tw-bg-opacity:1;background-color:rgb(75 85 99/var(--tw-bg-opacity))}.bg-gray-900{--tw-bg-opacity:1;background-color:rgb(17 24 39/var(--tw-bg-opacity))}.bg-green-50{--tw-bg-opacity:1;background-color:rgb(240 253 244/var(--tw-bg-opacity))}.bg-mute-600{--tw-bg-opacity:1;background-color:rgb(37 99 235/var(--tw-bg-opacity))}.bg-primary{background-color:var(--theme-primary-color)}.bg-primaryAlt{background-color:var(--theme-primary-alt-color)}.bg-record-600{--tw-bg-opacity:1;background-color:rgb(220 38 38/var(--tw-bg-opacity))}.bg-red-50{--tw-bg-opacity:1;background-color:rgb(254 242 242/var(--tw-bg-opacity))}.bg-red-900{--tw-bg-opacity:1;background-color:rgb(127 29 29/var(--tw-bg-opacity))}.bg-secondary-100{--tw-bg-opacity:1;background-color:rgb(244 244 245/var(--tw-bg-opacity))}.bg-secondary-200{--tw-bg-opacity:1;background-color:rgb(228 228 231/var(--tw-bg-opacity))}.bg-secondary-50{--tw-bg-opacity:1;background-color:rgb(250 250 250/var(--tw-bg-opacity))}.bg-secondary-500{--tw-bg-opacity:1;background-color:rgb(113 113 122/var(--tw-bg-opacity))}.bg-secondary-800{--tw-bg-opacity:1;background-color:rgb(39 39 42/var(--tw-bg-opacity))}.bg-secondary-900{--tw-bg-opacity:1;background-color:rgb(24 24 27/var(--tw-bg-opacity))}.bg-solo-400{--tw-bg-opacity:1;background-color:rgb(250 204 21/var(--tw-bg-opacity))}.bg-white{--tw-bg-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity))}.bg-opacity-25{--tw-bg-opacity:0.25}.bg-opacity-75{--tw-bg-opacity:0.75}.bg-left-top{background-position:0 0}.bg-right{background-position:100%}.bg-no-repeat{background-repeat:no-repeat}.fill-white{fill:#fff}.object-cover{object-fit:cover}.object-right{object-position:right}.p-0{padding:0}.p-0\\.5{padding:.125rem}.p-1{padding:.25rem}.p-1\\.5{padding:.375rem}.p-2{padding:.5rem}.p-3{padding:.75rem}.p-4{padding:1rem}.p-8{padding:2rem}.px-1{padding-left:.25rem;padding-right:.25rem}.px-10{padding-left:2.5rem;padding-right:2.5rem}.px-2{padding-left:.5rem;padding-right:.5rem}.px-3{padding-left:.75rem;padding-right:.75rem}.px-4{padding-left:1rem;padding-right:1rem}.px-5{padding-left:1.25rem;padding-right:1.25rem}.px-6{padding-left:1.5rem;padding-right:1.5rem}.px-7{padding-left:1.75rem;padding-right:1.75rem}.py-0{padding-bottom:0;padding-top:0}.py-0\\.5{padding-bottom:.125rem;padding-top:.125rem}.py-1{padding-bottom:.25rem;padding-top:.25rem}.py-1\\.5{padding-bottom:.375rem;padding-top:.375rem}.py-10{padding-bottom:2.5rem;padding-top:2.5rem}.py-12{padding-bottom:3rem;padding-top:3rem}.py-2{padding-bottom:.5rem;padding-top:.5rem}.py-3{padding-bottom:.75rem;padding-top:.75rem}.py-4{padding-bottom:1rem;padding-top:1rem}.py-5{padding-bottom:1.25rem;padding-top:1.25rem}.py-6{padding-bottom:1.5rem;padding-top:1.5rem}.pb-0{padding-bottom:0}.pb-0\\.5{padding-bottom:.125rem}.pb-12{padding-bottom:3rem}.pb-4{padding-bottom:1rem}.pb-40{padding-bottom:10rem}.pl-3{padding-left:.75rem}.pl-4{padding-left:1rem}.pl-6{padding-left:1.5rem}.pr-10{padding-right:2.5rem}.pr-2{padding-right:.5rem}.pr-4{padding-right:1rem}.pr-9{padding-right:2.25rem}.pt-0{padding-top:0}.pt-0\\.5{padding-top:.125rem}.pt-1{padding-top:.25rem}.pt-2{padding-top:.5rem}.pt-4{padding-top:1rem}.pt-5{padding-top:1.25rem}.pt-6{padding-top:1.5rem}.pt-8{padding-top:2rem}.text-left{text-align:left}.text-center{text-align:center}.text-right{text-align:right}.align-bottom{vertical-align:bottom}.text-2xl{font-size:1.5rem;line-height:2rem}.text-3xl{font-size:1.875rem;line-height:2.25rem}.text-base{font-size:1rem;line-height:1.5rem}.text-lg{font-size:1.125rem;line-height:1.75rem}.text-sm{font-size:.875rem;line-height:1.25rem}.text-xl{font-size:1.25rem;line-height:1.75rem}.text-xs{font-size:.75rem;line-height:1rem}.font-bold{font-weight:700}.font-extrabold{font-weight:800}.font-medium{font-weight:500}.font-normal{font-weight:400}.font-semibold{font-weight:600}.uppercase{text-transform:uppercase}.leading-6{line-height:1.5rem}.tracking-tight{letter-spacing:-.025em}.text-error-500{--tw-text-opacity:1;color:rgb(239 68 68/var(--tw-text-opacity))}.text-gray-300{--tw-text-opacity:1;color:rgb(209 213 219/var(--tw-text-opacity))}.text-gray-400{--tw-text-opacity:1;color:rgb(156 163 175/var(--tw-text-opacity))}.text-gray-500{--tw-text-opacity:1;color:rgb(107 114 128/var(--tw-text-opacity))}.text-gray-600{--tw-text-opacity:1;color:rgb(75 85 99/var(--tw-text-opacity))}.text-gray-700{--tw-text-opacity:1;color:rgb(55 65 81/var(--tw-text-opacity))}.text-gray-800{--tw-text-opacity:1;color:rgb(31 41 55/var(--tw-text-opacity))}.text-gray-900{--tw-text-opacity:1;color:rgb(17 24 39/var(--tw-text-opacity))}.text-green-400{--tw-text-opacity:1;color:rgb(74 222 128/var(--tw-text-opacity))}.text-green-500{--tw-text-opacity:1;color:rgb(34 197 94/var(--tw-text-opacity))}.text-green-800{--tw-text-opacity:1;color:rgb(22 101 52/var(--tw-text-opacity))}.text-indigo-600{--tw-text-opacity:1;color:rgb(79 70 229/var(--tw-text-opacity))}.text-primary{color:var(--theme-primary-color)}.text-red-400{--tw-text-opacity:1;color:rgb(248 113 113/var(--tw-text-opacity))}.text-red-500{--tw-text-opacity:1;color:rgb(239 68 68/var(--tw-text-opacity))}.text-red-600{--tw-text-opacity:1;color:rgb(220 38 38/var(--tw-text-opacity))}.text-red-700{--tw-text-opacity:1;color:rgb(185 28 28/var(--tw-text-opacity))}.text-red-800{--tw-text-opacity:1;color:rgb(153 27 27/var(--tw-text-opacity))}.text-secondary-200{--tw-text-opacity:1;color:rgb(228 228 231/var(--tw-text-opacity))}.text-secondary-300{--tw-text-opacity:1;color:rgb(212 212 216/var(--tw-text-opacity))}.text-secondary-400{--tw-text-opacity:1;color:rgb(161 161 170/var(--tw-text-opacity))}.text-secondary-50{--tw-text-opacity:1;color:rgb(250 250 250/var(--tw-text-opacity))}.text-secondary-600{--tw-text-opacity:1;color:rgb(82 82 91/var(--tw-text-opacity))}.text-secondary-700{--tw-text-opacity:1;color:rgb(63 63 70/var(--tw-text-opacity))}.text-secondary-800{--tw-text-opacity:1;color:rgb(39 39 42/var(--tw-text-opacity))}.text-secondary-900{--tw-text-opacity:1;color:rgb(24 24 27/var(--tw-text-opacity))}.text-white{--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity))}.placeholder-secondary-400::placeholder{--tw-placeholder-opacity:1;color:rgb(161 161 170/var(--tw-placeholder-opacity))}.opacity-0{opacity:0}.opacity-100{opacity:1}.opacity-20{opacity:.2}.opacity-40{opacity:.4}.opacity-50{opacity:.5}.shadow{--tw-shadow:0 1px 3px 0 #0000001a,0 1px 2px -1px #0000001a;--tw-shadow-colored:0 1px 3px 0 var(--tw-shadow-color),0 1px 2px -1px var(--tw-shadow-color)}.shadow,.shadow-2xl{box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.shadow-2xl{--tw-shadow:0 25px 50px -12px #00000040;--tw-shadow-colored:0 25px 50px -12px var(--tw-shadow-color)}.shadow-lg{--tw-shadow:0 10px 15px -3px #0000001a,0 4px 6px -4px #0000001a;--tw-shadow-colored:0 10px 15px -3px var(--tw-shadow-color),0 4px 6px -4px var(--tw-shadow-color)}.shadow-lg,.shadow-sm{box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.shadow-sm{--tw-shadow:0 1px 2px 0 #0000000d;--tw-shadow-colored:0 1px 2px 0 var(--tw-shadow-color)}.shadow-xl{--tw-shadow:0 20px 25px -5px #0000001a,0 8px 10px -6px #0000001a;--tw-shadow-colored:0 20px 25px -5px var(--tw-shadow-color),0 8px 10px -6px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.outline{outline-style:solid}.ring-0{--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(var(--tw-ring-offset-width)) var(--tw-ring-color)}.ring-0,.ring-1{box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow,0 0 #0000)}.ring-1{--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color)}.ring-black{--tw-ring-opacity:1;--tw-ring-color:rgb(0 0 0/var(--tw-ring-opacity))}.ring-primary{--tw-ring-color:var(--theme-primary-color)}.ring-opacity-5{--tw-ring-opacity:0.05}.grayscale{--tw-grayscale:grayscale(100%)}.filter,.grayscale{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.transition{transition-duration:.15s;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,-webkit-backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter,-webkit-backdrop-filter;transition-timing-function:cubic-bezier(.4,0,.2,1)}.transition-all{transition-duration:.15s;transition-property:all;transition-timing-function:cubic-bezier(.4,0,.2,1)}.transition-colors{transition-duration:.15s;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke;transition-timing-function:cubic-bezier(.4,0,.2,1)}.transition-opacity{transition-duration:.15s;transition-property:opacity;transition-timing-function:cubic-bezier(.4,0,.2,1)}.duration-100{transition-duration:.1s}.duration-200{transition-duration:.2s}.duration-300{transition-duration:.3s}.duration-75{transition-duration:75ms}.ease-in{transition-timing-function:cubic-bezier(.4,0,1,1)}.ease-in-out{transition-timing-function:cubic-bezier(.4,0,.2,1)}.ease-linear{transition-timing-function:linear}.ease-out{transition-timing-function:cubic-bezier(0,0,.2,1)}:root{--theme-primary-color:red;--theme-primary-alt-color:#00f}html{-webkit-touch-callout:none;background:grey}.dark{background:#1b1b1b}.rc-slider-vertical{padding:0!important;width:32px!important}.rc-slider-handle-dragging{box-shadow:none!important}.hover\\:border-primary:hover{border-color:var(--theme-primary-color)}.hover\\:bg-gray-50:hover{--tw-bg-opacity:1;background-color:rgb(249 250 251/var(--tw-bg-opacity))}.hover\\:bg-gray-700:hover{--tw-bg-opacity:1;background-color:rgb(55 65 81/var(--tw-bg-opacity))}.hover\\:bg-green-100:hover{--tw-bg-opacity:1;background-color:rgb(220 252 231/var(--tw-bg-opacity))}.hover\\:bg-primary:hover{background-color:var(--theme-primary-color)}.hover\\:bg-red-100:hover{--tw-bg-opacity:1;background-color:rgb(254 226 226/var(--tw-bg-opacity))}.hover\\:bg-secondary-100:hover{--tw-bg-opacity:1;background-color:rgb(244 244 245/var(--tw-bg-opacity))}.hover\\:bg-secondary-200:hover{--tw-bg-opacity:1;background-color:rgb(228 228 231/var(--tw-bg-opacity))}.hover\\:bg-opacity-75:hover{--tw-bg-opacity:0.75}.hover\\:text-error-500:hover{--tw-text-opacity:1;color:rgb(239 68 68/var(--tw-text-opacity))}.hover\\:text-gray-500:hover{--tw-text-opacity:1;color:rgb(107 114 128/var(--tw-text-opacity))}.hover\\:text-primary:hover{color:var(--theme-primary-color)}.hover\\:text-secondary-500:hover{--tw-text-opacity:1;color:rgb(113 113 122/var(--tw-text-opacity))}.hover\\:text-secondary-600:hover{--tw-text-opacity:1;color:rgb(82 82 91/var(--tw-text-opacity))}.hover\\:text-white:hover{--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity))}.focus\\:border-primary:focus{border-color:var(--theme-primary-color)}.focus\\:bg-primary:focus{background-color:var(--theme-primary-color)}.focus\\:text-secondary-600:focus{--tw-text-opacity:1;color:rgb(82 82 91/var(--tw-text-opacity))}.focus\\:outline-none:focus{outline:2px solid #0000;outline-offset:2px}.focus\\:ring-2:focus{--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow,0 0 #0000)}.focus\\:ring-inset:focus{--tw-ring-inset:inset}.focus\\:ring-green-600:focus{--tw-ring-opacity:1;--tw-ring-color:rgb(22 163 74/var(--tw-ring-opacity))}.focus\\:ring-indigo-500:focus{--tw-ring-opacity:1;--tw-ring-color:rgb(99 102 241/var(--tw-ring-opacity))}.focus\\:ring-primary:focus{--tw-ring-color:var(--theme-primary-color)}.focus\\:ring-red-600:focus{--tw-ring-opacity:1;--tw-ring-color:rgb(220 38 38/var(--tw-ring-opacity))}.focus\\:ring-white:focus{--tw-ring-opacity:1;--tw-ring-color:rgb(255 255 255/var(--tw-ring-opacity))}.focus\\:ring-offset-2:focus{--tw-ring-offset-width:2px}.focus\\:ring-offset-green-50:focus{--tw-ring-offset-color:#f0fdf4}.focus\\:ring-offset-red-50:focus{--tw-ring-offset-color:#fef2f2}.focus\\:ring-offset-secondary-100:focus{--tw-ring-offset-color:#f4f4f5}.disabled\\:opacity-50:disabled{opacity:.5}.group:hover .group-hover\\:text-gray-200{--tw-text-opacity:1;color:rgb(229 231 235/var(--tw-text-opacity))}.group:hover .group-hover\\:text-gray-300{--tw-text-opacity:1;color:rgb(209 213 219/var(--tw-text-opacity))}.group:hover .group-hover\\:text-gray-500{--tw-text-opacity:1;color:rgb(107 114 128/var(--tw-text-opacity))}.group:hover .group-hover\\:opacity-75{opacity:.75}:is(.dark .dark\\:block){display:block}:is(.dark .dark\\:divide-secondary-700)>:not([hidden])~:not([hidden]){--tw-divide-opacity:1;border-color:rgb(63 63 70/var(--tw-divide-opacity))}:is(.dark .dark\\:border-0){border-width:0}:is(.dark .dark\\:border-secondary-600){--tw-border-opacity:1;border-color:rgb(82 82 91/var(--tw-border-opacity))}:is(.dark .dark\\:border-secondary-700){--tw-border-opacity:1;border-color:rgb(63 63 70/var(--tw-border-opacity))}:is(.dark .dark\\:bg-mute-600){--tw-bg-opacity:1;background-color:rgb(37 99 235/var(--tw-bg-opacity))}:is(.dark .dark\\:bg-mute-900){--tw-bg-opacity:1;background-color:rgb(30 58 138/var(--tw-bg-opacity))}:is(.dark .dark\\:bg-primary){background-color:var(--theme-primary-color)}:is(.dark .dark\\:bg-record-600){--tw-bg-opacity:1;background-color:rgb(220 38 38/var(--tw-bg-opacity))}:is(.dark .dark\\:bg-red-900){--tw-bg-opacity:1;background-color:rgb(127 29 29/var(--tw-bg-opacity))}:is(.dark .dark\\:bg-secondary-500){--tw-bg-opacity:1;background-color:rgb(113 113 122/var(--tw-bg-opacity))}:is(.dark .dark\\:bg-secondary-700){--tw-bg-opacity:1;background-color:rgb(63 63 70/var(--tw-bg-opacity))}:is(.dark .dark\\:bg-secondary-800){--tw-bg-opacity:1;background-color:rgb(39 39 42/var(--tw-bg-opacity))}:is(.dark .dark\\:bg-secondary-900){--tw-bg-opacity:1;background-color:rgb(24 24 27/var(--tw-bg-opacity))}:is(.dark .dark\\:bg-solo-400){--tw-bg-opacity:1;background-color:rgb(250 204 21/var(--tw-bg-opacity))}:is(.dark .dark\\:text-gray-100){--tw-text-opacity:1;color:rgb(243 244 246/var(--tw-text-opacity))}:is(.dark .dark\\:text-primary){color:var(--theme-primary-color)}:is(.dark .dark\\:text-secondary-100){--tw-text-opacity:1;color:rgb(244 244 245/var(--tw-text-opacity))}:is(.dark .dark\\:text-secondary-200){--tw-text-opacity:1;color:rgb(228 228 231/var(--tw-text-opacity))}:is(.dark .dark\\:text-secondary-300){--tw-text-opacity:1;color:rgb(212 212 216/var(--tw-text-opacity))}:is(.dark .dark\\:text-secondary-400){--tw-text-opacity:1;color:rgb(161 161 170/var(--tw-text-opacity))}:is(.dark .dark\\:text-secondary-50){--tw-text-opacity:1;color:rgb(250 250 250/var(--tw-text-opacity))}:is(.dark .dark\\:text-secondary-600){--tw-text-opacity:1;color:rgb(82 82 91/var(--tw-text-opacity))}:is(.dark .dark\\:text-secondary-900){--tw-text-opacity:1;color:rgb(24 24 27/var(--tw-text-opacity))}:is(.dark .dark\\:text-white){--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity))}:is(.dark .dark\\:hover\\:border-primary:hover){border-color:var(--theme-primary-color)}:is(.dark .dark\\:hover\\:bg-primary:hover){background-color:var(--theme-primary-color)}:is(.dark .dark\\:hover\\:bg-secondary-800:hover){--tw-bg-opacity:1;background-color:rgb(39 39 42/var(--tw-bg-opacity))}:is(.dark .dark\\:hover\\:bg-secondary-900:hover){--tw-bg-opacity:1;background-color:rgb(24 24 27/var(--tw-bg-opacity))}:is(.dark .hover\\:dark\\:bg-primary):hover{background-color:var(--theme-primary-color)}:is(.dark .dark\\:hover\\:text-primary:hover){color:var(--theme-primary-color)}:is(.dark .dark\\:hover\\:text-secondary-300:hover){--tw-text-opacity:1;color:rgb(212 212 216/var(--tw-text-opacity))}:is(.dark .dark\\:hover\\:text-secondary-400:hover){--tw-text-opacity:1;color:rgb(161 161 170/var(--tw-text-opacity))}:is(.dark .dark\\:hover\\:text-white:hover){--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity))}:is(.dark .dark\\:focus\\:text-secondary-400:focus){--tw-text-opacity:1;color:rgb(161 161 170/var(--tw-text-opacity))}:is(.dark .dark\\:focus\\:ring-offset-secondary-800:focus){--tw-ring-offset-color:#27272a}@media (min-width:640px){.sm\\:mx-0{margin-left:0;margin-right:0}.sm\\:my-5{margin-bottom:1.25rem;margin-top:1.25rem}.sm\\:my-8{margin-bottom:2rem;margin-top:2rem}.sm\\:ml-3{margin-left:.75rem}.sm\\:mt-0{margin-top:0}.sm\\:mt-4{margin-top:1rem}.sm\\:block{display:block}.sm\\:inline-block{display:inline-block}.sm\\:flex{display:flex}.sm\\:h-10{height:2.5rem}.sm\\:h-screen{height:100vh}.sm\\:w-10{width:2.5rem}.sm\\:w-auto{width:auto}.sm\\:w-full{width:100%}.sm\\:max-w-lg{max-width:32rem}.sm\\:max-w-sm{max-width:24rem}.sm\\:translate-x-0{--tw-translate-x:0px}.sm\\:translate-x-0,.sm\\:translate-x-2{transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.sm\\:translate-x-2{--tw-translate-x:0.5rem}.sm\\:translate-y-0{--tw-translate-y:0px}.sm\\:scale-100,.sm\\:translate-y-0{transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.sm\\:scale-100{--tw-scale-x:1;--tw-scale-y:1}.sm\\:scale-95{--tw-scale-x:.95;--tw-scale-y:.95;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.sm\\:grid-cols-1{grid-template-columns:repeat(1,minmax(0,1fr))}.sm\\:grid-cols-3{grid-template-columns:repeat(3,minmax(0,1fr))}.sm\\:flex-row-reverse{flex-direction:row-reverse}.sm\\:items-start{align-items:flex-start}.sm\\:items-end{align-items:flex-end}.sm\\:items-center{align-items:center}.sm\\:gap-x-6{column-gap:1.5rem}.sm\\:space-x-3>:not([hidden])~:not([hidden]){--tw-space-x-reverse:0;margin-left:calc(.75rem*(1 - var(--tw-space-x-reverse)));margin-right:calc(.75rem*var(--tw-space-x-reverse))}.sm\\:space-x-5>:not([hidden])~:not([hidden]){--tw-space-x-reverse:0;margin-left:calc(1.25rem*(1 - var(--tw-space-x-reverse)));margin-right:calc(1.25rem*var(--tw-space-x-reverse))}.sm\\:space-y-4>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-bottom:calc(1rem*var(--tw-space-y-reverse));margin-top:calc(1rem*(1 - var(--tw-space-y-reverse)))}.sm\\:rounded-lg{border-radius:.5rem}.sm\\:p-0{padding:0}.sm\\:p-6{padding:1.5rem}.sm\\:px-2{padding-left:.5rem;padding-right:.5rem}.sm\\:px-6{padding-left:1.5rem;padding-right:1.5rem}.sm\\:pt-1{padding-top:.25rem}.sm\\:pt-4{padding-top:1rem}.sm\\:text-left{text-align:left}.sm\\:align-middle{vertical-align:middle}.sm\\:text-2xl{font-size:1.5rem;line-height:2rem}.sm\\:text-4xl{font-size:2.25rem;line-height:2.5rem}.sm\\:text-base{font-size:1rem;line-height:1.5rem}.sm\\:text-sm{font-size:.875rem;line-height:1.25rem}.sm\\:text-xs{font-size:.75rem;line-height:1rem}}@media (min-width:768px){.md\\:h-10{height:2.5rem}.md\\:h-12{height:3rem}.md\\:w-10{width:2.5rem}.md\\:w-12{width:3rem}.md\\:grid-cols-3{grid-template-columns:repeat(3,minmax(0,1fr))}.md\\:gap-x-6{column-gap:1.5rem}.md\\:text-3xl{font-size:1.875rem;line-height:2.25rem}.md\\:text-4xl{font-size:2.25rem;line-height:2.5rem}}@media (min-width:1024px){.lg\\:fixed{position:fixed}.lg\\:inset-y-0{bottom:0;top:0}.lg\\:col-span-3{grid-column:span 3/span 3}.lg\\:col-span-4{grid-column:span 4/span 4}.lg\\:m-4{margin:1rem}.lg\\:mx-0{margin-left:0;margin-right:0}.lg\\:my-4{margin-bottom:1rem;margin-top:1rem}.lg\\:block{display:block}.lg\\:flex{display:flex}.lg\\:grid{display:grid}.lg\\:hidden{display:none}.lg\\:h-20{height:5rem}.lg\\:h-6{height:1.5rem}.lg\\:w-6{width:1.5rem}.lg\\:w-64{width:16rem}.lg\\:w-96{width:24rem}.lg\\:max-w-none{max-width:none}.lg\\:flex-none{flex:none}.lg\\:grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.lg\\:grid-cols-4{grid-template-columns:repeat(4,minmax(0,1fr))}.lg\\:grid-cols-6{grid-template-columns:repeat(6,minmax(0,1fr))}.lg\\:flex-row{flex-direction:row}.lg\\:flex-col{flex-direction:column}.lg\\:gap-16{gap:4rem}.lg\\:space-x-4>:not([hidden])~:not([hidden]){--tw-space-x-reverse:0;margin-left:calc(1rem*(1 - var(--tw-space-x-reverse)));margin-right:calc(1rem*var(--tw-space-x-reverse))}.lg\\:space-x-8>:not([hidden])~:not([hidden]){--tw-space-x-reverse:0;margin-left:calc(2rem*(1 - var(--tw-space-x-reverse)));margin-right:calc(2rem*var(--tw-space-x-reverse))}.lg\\:px-2{padding-left:.5rem;padding-right:.5rem}.lg\\:px-20{padding-left:5rem;padding-right:5rem}.lg\\:px-8{padding-left:2rem;padding-right:2rem}.lg\\:py-1{padding-bottom:.25rem;padding-top:.25rem}.lg\\:py-1\\.5{padding-bottom:.375rem;padding-top:.375rem}.lg\\:py-16{padding-bottom:4rem;padding-top:4rem}.lg\\:pl-64{padding-left:16rem}.lg\\:text-base{font-size:1rem;line-height:1.5rem}}@media (min-width:1280px){.xl\\:gap-x-8{column-gap:2rem}.xl\\:px-24{padding-left:6rem;padding-right:6rem}}";styleInject$1(css_248z$8$1,{"insertAt":"top"});function AdjustmentsHorizontalIcon({title,titleId,...props},svgRef){return/*#__PURE__*/React.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 24 24",fill:"currentColor","aria-hidden":"true","data-slot":"icon",ref:svgRef,"aria-labelledby":titleId},props),title?/*#__PURE__*/React.createElement("title",{id:titleId},title):null,/*#__PURE__*/React.createElement("path",{d:"M18.75 12.75h1.5a.75.75 0 0 0 0-1.5h-1.5a.75.75 0 0 0 0 1.5ZM12 6a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 12 6ZM12 18a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 12 18ZM3.75 6.75h1.5a.75.75 0 1 0 0-1.5h-1.5a.75.75 0 0 0 0 1.5ZM5.25 18.75h-1.5a.75.75 0 0 1 0-1.5h1.5a.75.75 0 0 1 0 1.5ZM3 12a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 3 12ZM9 3.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5ZM12.75 12a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0ZM9 15.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5Z"}));}const ForwardRef$v=/*#__PURE__*/React.forwardRef(AdjustmentsHorizontalIcon);var AdjustmentsHorizontalIcon$1=ForwardRef$v;function ArrowDownTrayIcon({title,titleId,...props},svgRef){return/*#__PURE__*/React.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 24 24",fill:"currentColor","aria-hidden":"true","data-slot":"icon",ref:svgRef,"aria-labelledby":titleId},props),title?/*#__PURE__*/React.createElement("title",{id:titleId},title):null,/*#__PURE__*/React.createElement("path",{fillRule:"evenodd",d:"M12 2.25a.75.75 0 0 1 .75.75v11.69l3.22-3.22a.75.75 0 1 1 1.06 1.06l-4.5 4.5a.75.75 0 0 1-1.06 0l-4.5-4.5a.75.75 0 1 1 1.06-1.06l3.22 3.22V3a.75.75 0 0 1 .75-.75Zm-9 13.5a.75.75 0 0 1 .75.75v2.25a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5V16.5a.75.75 0 0 1 1.5 0v2.25a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V16.5a.75.75 0 0 1 .75-.75Z",clipRule:"evenodd"}));}const ForwardRef$u=/*#__PURE__*/React.forwardRef(ArrowDownTrayIcon);var ArrowDownTrayIcon$1=ForwardRef$u;function ArrowPathIcon({title,titleId,...props},svgRef){return/*#__PURE__*/React.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 24 24",fill:"currentColor","aria-hidden":"true","data-slot":"icon",ref:svgRef,"aria-labelledby":titleId},props),title?/*#__PURE__*/React.createElement("title",{id:titleId},title):null,/*#__PURE__*/React.createElement("path",{fillRule:"evenodd",d:"M4.755 10.059a7.5 7.5 0 0 1 12.548-3.364l1.903 1.903h-3.183a.75.75 0 1 0 0 1.5h4.992a.75.75 0 0 0 .75-.75V4.356a.75.75 0 0 0-1.5 0v3.18l-1.9-1.9A9 9 0 0 0 3.306 9.67a.75.75 0 1 0 1.45.388Zm15.408 3.352a.75.75 0 0 0-.919.53 7.5 7.5 0 0 1-12.548 3.364l-1.902-1.903h3.183a.75.75 0 0 0 0-1.5H2.984a.75.75 0 0 0-.75.75v4.992a.75.75 0 0 0 1.5 0v-3.18l1.9 1.9a9 9 0 0 0 15.059-4.035.75.75 0 0 0-.53-.918Z",clipRule:"evenodd"}));}const ForwardRef$t=/*#__PURE__*/React.forwardRef(ArrowPathIcon);var ArrowPathIcon$1=ForwardRef$t;function ChatBubbleBottomCenterTextIcon$2({title,titleId,...props},svgRef){return/*#__PURE__*/React.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 24 24",fill:"currentColor","aria-hidden":"true","data-slot":"icon",ref:svgRef,"aria-labelledby":titleId},props),title?/*#__PURE__*/React.createElement("title",{id:titleId},title):null,/*#__PURE__*/React.createElement("path",{fillRule:"evenodd",d:"M4.848 2.771A49.144 49.144 0 0 1 12 2.25c2.43 0 4.817.178 7.152.52 1.978.292 3.348 2.024 3.348 3.97v6.02c0 1.946-1.37 3.678-3.348 3.97a48.901 48.901 0 0 1-3.476.383.39.39 0 0 0-.297.17l-2.755 4.133a.75.75 0 0 1-1.248 0l-2.755-4.133a.39.39 0 0 0-.297-.17 48.9 48.9 0 0 1-3.476-.384c-1.978-.29-3.348-2.024-3.348-3.97V6.741c0-1.946 1.37-3.68 3.348-3.97ZM6.75 8.25a.75.75 0 0 1 .75-.75h9a.75.75 0 0 1 0 1.5h-9a.75.75 0 0 1-.75-.75Zm.75 2.25a.75.75 0 0 0 0 1.5H12a.75.75 0 0 0 0-1.5H7.5Z",clipRule:"evenodd"}));}const ForwardRef$s=/*#__PURE__*/React.forwardRef(ChatBubbleBottomCenterTextIcon$2);var ChatBubbleBottomCenterTextIcon$3=ForwardRef$s;function CheckCircleIcon$2({title,titleId,...props},svgRef){return/*#__PURE__*/React.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 24 24",fill:"currentColor","aria-hidden":"true","data-slot":"icon",ref:svgRef,"aria-labelledby":titleId},props),title?/*#__PURE__*/React.createElement("title",{id:titleId},title):null,/*#__PURE__*/React.createElement("path",{fillRule:"evenodd",d:"M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z",clipRule:"evenodd"}));}const ForwardRef$r=/*#__PURE__*/React.forwardRef(CheckCircleIcon$2);var CheckCircleIcon$3=ForwardRef$r;function CheckIcon({title,titleId,...props},svgRef){return/*#__PURE__*/React.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 24 24",fill:"currentColor","aria-hidden":"true","data-slot":"icon",ref:svgRef,"aria-labelledby":titleId},props),title?/*#__PURE__*/React.createElement("title",{id:titleId},title):null,/*#__PURE__*/React.createElement("path",{fillRule:"evenodd",d:"M19.916 4.626a.75.75 0 0 1 .208 1.04l-9 13.5a.75.75 0 0 1-1.154.114l-6-6a.75.75 0 0 1 1.06-1.06l5.353 5.353 8.493-12.74a.75.75 0 0 1 1.04-.207Z",clipRule:"evenodd"}));}const ForwardRef$q=/*#__PURE__*/React.forwardRef(CheckIcon);var CheckIcon$1=ForwardRef$q;function ChevronUpDownIcon({title,titleId,...props},svgRef){return/*#__PURE__*/React.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 24 24",fill:"currentColor","aria-hidden":"true","data-slot":"icon",ref:svgRef,"aria-labelledby":titleId},props),title?/*#__PURE__*/React.createElement("title",{id:titleId},title):null,/*#__PURE__*/React.createElement("path",{fillRule:"evenodd",d:"M11.47 4.72a.75.75 0 0 1 1.06 0l3.75 3.75a.75.75 0 0 1-1.06 1.06L12 6.31 8.78 9.53a.75.75 0 0 1-1.06-1.06l3.75-3.75Zm-3.75 9.75a.75.75 0 0 1 1.06 0L12 17.69l3.22-3.22a.75.75 0 1 1 1.06 1.06l-3.75 3.75a.75.75 0 0 1-1.06 0l-3.75-3.75a.75.75 0 0 1 0-1.06Z",clipRule:"evenodd"}));}const ForwardRef$p=/*#__PURE__*/React.forwardRef(ChevronUpDownIcon);var ChevronUpDownIcon$1=ForwardRef$p;function ExclamationCircleIcon$2({title,titleId,...props},svgRef){return/*#__PURE__*/React.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 24 24",fill:"currentColor","aria-hidden":"true","data-slot":"icon",ref:svgRef,"aria-labelledby":titleId},props),title?/*#__PURE__*/React.createElement("title",{id:titleId},title):null,/*#__PURE__*/React.createElement("path",{fillRule:"evenodd",d:"M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12ZM12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Zm0 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",clipRule:"evenodd"}));}const ForwardRef$o=/*#__PURE__*/React.forwardRef(ExclamationCircleIcon$2);var ExclamationCircleIcon$3=ForwardRef$o;function FunnelIcon({title,titleId,...props},svgRef){return/*#__PURE__*/React.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 24 24",fill:"currentColor","aria-hidden":"true","data-slot":"icon",ref:svgRef,"aria-labelledby":titleId},props),title?/*#__PURE__*/React.createElement("title",{id:titleId},title):null,/*#__PURE__*/React.createElement("path",{fillRule:"evenodd",d:"M3.792 2.938A49.069 49.069 0 0 1 12 2.25c2.797 0 5.54.236 8.209.688a1.857 1.857 0 0 1 1.541 1.836v1.044a3 3 0 0 1-.879 2.121l-6.182 6.182a1.5 1.5 0 0 0-.439 1.061v2.927a3 3 0 0 1-1.658 2.684l-1.757.878A.75.75 0 0 1 9.75 21v-5.818a1.5 1.5 0 0 0-.44-1.06L3.13 7.938a3 3 0 0 1-.879-2.121V4.774c0-.897.64-1.683 1.542-1.836Z",clipRule:"evenodd"}));}const ForwardRef$n=/*#__PURE__*/React.forwardRef(FunnelIcon);var FunnelIcon$1=ForwardRef$n;function InformationCircleIcon$1({title,titleId,...props},svgRef){return/*#__PURE__*/React.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 24 24",fill:"currentColor","aria-hidden":"true","data-slot":"icon",ref:svgRef,"aria-labelledby":titleId},props),title?/*#__PURE__*/React.createElement("title",{id:titleId},title):null,/*#__PURE__*/React.createElement("path",{fillRule:"evenodd",d:"M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",clipRule:"evenodd"}));}const ForwardRef$m=/*#__PURE__*/React.forwardRef(InformationCircleIcon$1);var InformationCircleIcon$1$1=ForwardRef$m;function ListBulletIcon({title,titleId,...props},svgRef){return/*#__PURE__*/React.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 24 24",fill:"currentColor","aria-hidden":"true","data-slot":"icon",ref:svgRef,"aria-labelledby":titleId},props),title?/*#__PURE__*/React.createElement("title",{id:titleId},title):null,/*#__PURE__*/React.createElement("path",{fillRule:"evenodd",d:"M2.625 6.75a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Zm4.875 0A.75.75 0 0 1 8.25 6h12a.75.75 0 0 1 0 1.5h-12a.75.75 0 0 1-.75-.75ZM2.625 12a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0ZM7.5 12a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5h-12A.75.75 0 0 1 7.5 12Zm-4.875 5.25a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Zm4.875 0a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5h-12a.75.75 0 0 1-.75-.75Z",clipRule:"evenodd"}));}const ForwardRef$l=/*#__PURE__*/React.forwardRef(ListBulletIcon);var ListBulletIcon$1=ForwardRef$l;/** @deprecated */function MinusSmallIcon({title,titleId,...props},svgRef){return/*#__PURE__*/React.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 24 24",fill:"currentColor","aria-hidden":"true","data-slot":"icon",ref:svgRef,"aria-labelledby":titleId},props),title?/*#__PURE__*/React.createElement("title",{id:titleId},title):null,/*#__PURE__*/React.createElement("path",{fillRule:"evenodd",d:"M5.25 12a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75Z",clipRule:"evenodd"}));}const ForwardRef$k=/*#__PURE__*/React.forwardRef(MinusSmallIcon);var MinusSmallIcon$1=ForwardRef$k;function PauseIcon({title,titleId,...props},svgRef){return/*#__PURE__*/React.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 24 24",fill:"currentColor","aria-hidden":"true","data-slot":"icon",ref:svgRef,"aria-labelledby":titleId},props),title?/*#__PURE__*/React.createElement("title",{id:titleId},title):null,/*#__PURE__*/React.createElement("path",{fillRule:"evenodd",d:"M6.75 5.25a.75.75 0 0 1 .75-.75H9a.75.75 0 0 1 .75.75v13.5a.75.75 0 0 1-.75.75H7.5a.75.75 0 0 1-.75-.75V5.25Zm7.5 0A.75.75 0 0 1 15 4.5h1.5a.75.75 0 0 1 .75.75v13.5a.75.75 0 0 1-.75.75H15a.75.75 0 0 1-.75-.75V5.25Z",clipRule:"evenodd"}));}const ForwardRef$j=/*#__PURE__*/React.forwardRef(PauseIcon);var PauseIcon$1=ForwardRef$j;function PlayIcon({title,titleId,...props},svgRef){return/*#__PURE__*/React.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 24 24",fill:"currentColor","aria-hidden":"true","data-slot":"icon",ref:svgRef,"aria-labelledby":titleId},props),title?/*#__PURE__*/React.createElement("title",{id:titleId},title):null,/*#__PURE__*/React.createElement("path",{fillRule:"evenodd",d:"M4.5 5.653c0-1.427 1.529-2.33 2.779-1.643l11.54 6.347c1.295.712 1.295 2.573 0 3.286L7.28 19.99c-1.25.687-2.779-.217-2.779-1.643V5.653Z",clipRule:"evenodd"}));}const ForwardRef$i=/*#__PURE__*/React.forwardRef(PlayIcon);var PlayIcon$1=ForwardRef$i;function PlusCircleIcon({title,titleId,...props},svgRef){return/*#__PURE__*/React.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 24 24",fill:"currentColor","aria-hidden":"true","data-slot":"icon",ref:svgRef,"aria-labelledby":titleId},props),title?/*#__PURE__*/React.createElement("title",{id:titleId},title):null,/*#__PURE__*/React.createElement("path",{fillRule:"evenodd",d:"M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 9a.75.75 0 0 0-1.5 0v2.25H9a.75.75 0 0 0 0 1.5h2.25V15a.75.75 0 0 0 1.5 0v-2.25H15a.75.75 0 0 0 0-1.5h-2.25V9Z",clipRule:"evenodd"}));}const ForwardRef$h=/*#__PURE__*/React.forwardRef(PlusCircleIcon);var PlusCircleIcon$1=ForwardRef$h;/** @deprecated */function PlusSmallIcon({title,titleId,...props},svgRef){return/*#__PURE__*/React.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 24 24",fill:"currentColor","aria-hidden":"true","data-slot":"icon",ref:svgRef,"aria-labelledby":titleId},props),title?/*#__PURE__*/React.createElement("title",{id:titleId},title):null,/*#__PURE__*/React.createElement("path",{fillRule:"evenodd",d:"M12 5.25a.75.75 0 0 1 .75.75v5.25H18a.75.75 0 0 1 0 1.5h-5.25V18a.75.75 0 0 1-1.5 0v-5.25H6a.75.75 0 0 1 0-1.5h5.25V6a.75.75 0 0 1 .75-.75Z",clipRule:"evenodd"}));}const ForwardRef$g=/*#__PURE__*/React.forwardRef(PlusSmallIcon);var PlusSmallIcon$1=ForwardRef$g;function ShareIcon({title,titleId,...props},svgRef){return/*#__PURE__*/React.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 24 24",fill:"currentColor","aria-hidden":"true","data-slot":"icon",ref:svgRef,"aria-labelledby":titleId},props),title?/*#__PURE__*/React.createElement("title",{id:titleId},title):null,/*#__PURE__*/React.createElement("path",{fillRule:"evenodd",d:"M15.75 4.5a3 3 0 1 1 .825 2.066l-8.421 4.679a3.002 3.002 0 0 1 0 1.51l8.421 4.679a3 3 0 1 1-.729 1.31l-8.421-4.678a3 3 0 1 1 0-4.132l8.421-4.679a3 3 0 0 1-.096-.755Z",clipRule:"evenodd"}));}const ForwardRef$f$1=/*#__PURE__*/React.forwardRef(ShareIcon);var ShareIcon$1=ForwardRef$f$1;function SignalIcon({title,titleId,...props},svgRef){return/*#__PURE__*/React.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 24 24",fill:"currentColor","aria-hidden":"true","data-slot":"icon",ref:svgRef,"aria-labelledby":titleId},props),title?/*#__PURE__*/React.createElement("title",{id:titleId},title):null,/*#__PURE__*/React.createElement("path",{fillRule:"evenodd",d:"M5.636 4.575a.75.75 0 0 1 0 1.061 9 9 0 0 0 0 12.728.75.75 0 1 1-1.06 1.06c-4.101-4.1-4.101-10.748 0-14.849a.75.75 0 0 1 1.06 0Zm12.728 0a.75.75 0 0 1 1.06 0c4.101 4.1 4.101 10.75 0 14.85a.75.75 0 1 1-1.06-1.061 9 9 0 0 0 0-12.728.75.75 0 0 1 0-1.06ZM7.757 6.697a.75.75 0 0 1 0 1.06 6 6 0 0 0 0 8.486.75.75 0 0 1-1.06 1.06 7.5 7.5 0 0 1 0-10.606.75.75 0 0 1 1.06 0Zm8.486 0a.75.75 0 0 1 1.06 0 7.5 7.5 0 0 1 0 10.606.75.75 0 0 1-1.06-1.06 6 6 0 0 0 0-8.486.75.75 0 0 1 0-1.06ZM9.879 8.818a.75.75 0 0 1 0 1.06 3 3 0 0 0 0 4.243.75.75 0 1 1-1.061 1.061 4.5 4.5 0 0 1 0-6.364.75.75 0 0 1 1.06 0Zm4.242 0a.75.75 0 0 1 1.061 0 4.5 4.5 0 0 1 0 6.364.75.75 0 0 1-1.06-1.06 3 3 0 0 0 0-4.243.75.75 0 0 1 0-1.061ZM10.875 12a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Z",clipRule:"evenodd"}));}const ForwardRef$e$1=/*#__PURE__*/React.forwardRef(SignalIcon);var SignalIcon$1=ForwardRef$e$1;function SparklesIcon({title,titleId,...props},svgRef){return/*#__PURE__*/React.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 24 24",fill:"currentColor","aria-hidden":"true","data-slot":"icon",ref:svgRef,"aria-labelledby":titleId},props),title?/*#__PURE__*/React.createElement("title",{id:titleId},title):null,/*#__PURE__*/React.createElement("path",{fillRule:"evenodd",d:"M9 4.5a.75.75 0 0 1 .721.544l.813 2.846a3.75 3.75 0 0 0 2.576 2.576l2.846.813a.75.75 0 0 1 0 1.442l-2.846.813a3.75 3.75 0 0 0-2.576 2.576l-.813 2.846a.75.75 0 0 1-1.442 0l-.813-2.846a3.75 3.75 0 0 0-2.576-2.576l-2.846-.813a.75.75 0 0 1 0-1.442l2.846-.813A3.75 3.75 0 0 0 7.466 7.89l.813-2.846A.75.75 0 0 1 9 4.5ZM18 1.5a.75.75 0 0 1 .728.568l.258 1.036c.236.94.97 1.674 1.91 1.91l1.036.258a.75.75 0 0 1 0 1.456l-1.036.258c-.94.236-1.674.97-1.91 1.91l-.258 1.036a.75.75 0 0 1-1.456 0l-.258-1.036a2.625 2.625 0 0 0-1.91-1.91l-1.036-.258a.75.75 0 0 1 0-1.456l1.036-.258a2.625 2.625 0 0 0 1.91-1.91l.258-1.036A.75.75 0 0 1 18 1.5ZM16.5 15a.75.75 0 0 1 .712.513l.394 1.183c.15.447.5.799.948.948l1.183.395a.75.75 0 0 1 0 1.422l-1.183.395c-.447.15-.799.5-.948.948l-.395 1.183a.75.75 0 0 1-1.422 0l-.395-1.183a1.5 1.5 0 0 0-.948-.948l-1.183-.395a.75.75 0 0 1 0-1.422l1.183-.395c.447-.15.799-.5.948-.948l.395-1.183A.75.75 0 0 1 16.5 15Z",clipRule:"evenodd"}));}const ForwardRef$d$1=/*#__PURE__*/React.forwardRef(SparklesIcon);var SparklesIcon$1=ForwardRef$d$1;function SpeakerXMarkIcon({title,titleId,...props},svgRef){return/*#__PURE__*/React.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 24 24",fill:"currentColor","aria-hidden":"true","data-slot":"icon",ref:svgRef,"aria-labelledby":titleId},props),title?/*#__PURE__*/React.createElement("title",{id:titleId},title):null,/*#__PURE__*/React.createElement("path",{d:"M13.5 4.06c0-1.336-1.616-2.005-2.56-1.06l-4.5 4.5H4.508c-1.141 0-2.318.664-2.66 1.905A9.76 9.76 0 0 0 1.5 12c0 .898.121 1.768.35 2.595.341 1.24 1.518 1.905 2.659 1.905h1.93l4.5 4.5c.945.945 2.561.276 2.561-1.06V4.06ZM17.78 9.22a.75.75 0 1 0-1.06 1.06L18.44 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06l1.72-1.72 1.72 1.72a.75.75 0 1 0 1.06-1.06L20.56 12l1.72-1.72a.75.75 0 1 0-1.06-1.06l-1.72 1.72-1.72-1.72Z"}));}const ForwardRef$c$1=/*#__PURE__*/React.forwardRef(SpeakerXMarkIcon);var SpeakerXMarkIcon$1=ForwardRef$c$1;function StopIcon({title,titleId,...props},svgRef){return/*#__PURE__*/React.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 24 24",fill:"currentColor","aria-hidden":"true","data-slot":"icon",ref:svgRef,"aria-labelledby":titleId},props),title?/*#__PURE__*/React.createElement("title",{id:titleId},title):null,/*#__PURE__*/React.createElement("path",{fillRule:"evenodd",d:"M4.5 7.5a3 3 0 0 1 3-3h9a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3h-9a3 3 0 0 1-3-3v-9Z",clipRule:"evenodd"}));}const ForwardRef$b$1=/*#__PURE__*/React.forwardRef(StopIcon);var StopIcon$1=ForwardRef$b$1;function TrashIcon({title,titleId,...props},svgRef){return/*#__PURE__*/React.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 24 24",fill:"currentColor","aria-hidden":"true","data-slot":"icon",ref:svgRef,"aria-labelledby":titleId},props),title?/*#__PURE__*/React.createElement("title",{id:titleId},title):null,/*#__PURE__*/React.createElement("path",{fillRule:"evenodd",d:"M16.5 4.478v.227a48.816 48.816 0 0 1 3.878.512.75.75 0 1 1-.256 1.478l-.209-.035-1.005 13.07a3 3 0 0 1-2.991 2.77H8.084a3 3 0 0 1-2.991-2.77L4.087 6.66l-.209.035a.75.75 0 0 1-.256-1.478A48.567 48.567 0 0 1 7.5 4.705v-.227c0-1.564 1.213-2.9 2.816-2.951a52.662 52.662 0 0 1 3.369 0c1.603.051 2.815 1.387 2.815 2.951Zm-6.136-1.452a51.196 51.196 0 0 1 3.273 0C14.39 3.05 15 3.684 15 4.478v.113a49.488 49.488 0 0 0-6 0v-.113c0-.794.609-1.428 1.364-1.452Zm-.355 5.945a.75.75 0 1 0-1.5.058l.347 9a.75.75 0 1 0 1.499-.058l-.346-9Zm5.48.058a.75.75 0 1 0-1.498-.058l-.347 9a.75.75 0 0 0 1.5.058l.345-9Z",clipRule:"evenodd"}));}const ForwardRef$a$1=/*#__PURE__*/React.forwardRef(TrashIcon);var TrashIcon$1=ForwardRef$a$1;function UserCircleIcon({title,titleId,...props},svgRef){return/*#__PURE__*/React.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 24 24",fill:"currentColor","aria-hidden":"true","data-slot":"icon",ref:svgRef,"aria-labelledby":titleId},props),title?/*#__PURE__*/React.createElement("title",{id:titleId},title):null,/*#__PURE__*/React.createElement("path",{fillRule:"evenodd",d:"M18.685 19.097A9.723 9.723 0 0 0 21.75 12c0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12a9.723 9.723 0 0 0 3.065 7.097A9.716 9.716 0 0 0 12 21.75a9.716 9.716 0 0 0 6.685-2.653Zm-12.54-1.285A7.486 7.486 0 0 1 12 15a7.486 7.486 0 0 1 5.855 2.812A8.224 8.224 0 0 1 12 20.25a8.224 8.224 0 0 1-5.855-2.438ZM15.75 9a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z",clipRule:"evenodd"}));}const ForwardRef$9$1=/*#__PURE__*/React.forwardRef(UserCircleIcon);var UserCircleIcon$1=ForwardRef$9$1;function XMarkIcon$2({title,titleId,...props},svgRef){return/*#__PURE__*/React.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 24 24",fill:"currentColor","aria-hidden":"true","data-slot":"icon",ref:svgRef,"aria-labelledby":titleId},props),title?/*#__PURE__*/React.createElement("title",{id:titleId},title):null,/*#__PURE__*/React.createElement("path",{fillRule:"evenodd",d:"M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z",clipRule:"evenodd"}));}const ForwardRef$8$1=/*#__PURE__*/React.forwardRef(XMarkIcon$2);var XMarkIcon$3=ForwardRef$8$1;function Alert({alertType,dismissible,onDismiss,type,size,...props}){const icon=alertType==="positive"?/*#__PURE__*/React__default.createElement(CheckCircleIcon$3,{className:"h-5 w-5 text-green-400","aria-hidden":"true"}):alertType==="negative"?/*#__PURE__*/React__default.createElement(ExclamationCircleIcon$3,{className:"h-5 w-5 text-red-400","aria-hidden":"true"}):/*#__PURE__*/React__default.createElement(InformationCircleIcon$1$1,{className:"h-5 w-5 text-primary","aria-hidden":"true"});return/*#__PURE__*/React__default.createElement("div",{className:`rounded-md p-4 border ${alertType==="positive"?"bg-green-50 border-green-500 ":alertType==="negative"?"bg-red-50 border-red-500 ":"bg-white border-primary"}`},/*#__PURE__*/React__default.createElement("div",{className:"flex"},/*#__PURE__*/React__default.createElement("div",{className:"flex-shrink-0"},icon),/*#__PURE__*/React__default.createElement("div",{className:"ml-3"},/*#__PURE__*/React__default.createElement("p",{className:`text-sm font-medium ${alertType==="positive"?"text-green-800":alertType==="negative"?"text-red-800":"text-secondary-800"}`},props.children)),dismissible&&/*#__PURE__*/React__default.createElement("div",{className:"ml-auto pl-3"},/*#__PURE__*/React__default.createElement("div",{className:"-mx-1.5 -my-1.5"},/*#__PURE__*/React__default.createElement("button",{type:"button",className:`inline-flex rounded-md p-1.5  focus:outline-none focus:ring-2 focus:ring-offset-2
                ${alertType==="positive"?"bg-green-50 text-green-500 hover:bg-green-100 focus:ring-offset-green-50 focus:ring-green-600":"bg-red-50 text-red-500 hover:bg-red-100 focus:ring-offset-red-50 focus:ring-red-600"}`,onClick:onDismiss},/*#__PURE__*/React__default.createElement("span",{className:"sr-only"},"Dismiss"),/*#__PURE__*/React__default.createElement(XMarkIcon$3,{className:"h-5 w-5","aria-hidden":"true"}))))));}Alert.propTypes={alertType:PropTypes.oneOf(["positive","negative","info"]),// Would be better to use Object.keys but it won't work with Storybook currently'
onDismiss:PropTypes.func,type:PropTypes.oneOf(["default"]),// Would be better to use Object.keys but it won't work with Storybook currently
size:PropTypes.oneOf(["base"])};Alert.defaultProps={alertType:"positive",onDismiss:undefined,type:"default",size:"base",dismissible:true};function _extends$3(){_extends$3=Object.assign?Object.assign.bind():function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends$3.apply(this,arguments);}function classNames$2(...classes){return classes.filter(Boolean).join(" ");}const ButtonType={primary:`inline-flex items-center justify-center border 
            border-transparent font-medium rounded-md shadow-sm 
            text-secondary-50 bg-primary hover:bg-secondary
            `,primaryFull:`inline-flex items-center justify-center border 
                border-transparent font-medium rounded-md shadow-sm 
                text-secondary-50 bg-primary hover:bg-secondary
                 w-full`,secondary:`inline-flex items-center justify-center border border-secondary-300 dark:border-secondary-600
              shadow-sm font-medium rounded-md text-secondary-600 dark:text-secondary-300
              bg-secondary-50 dark:bg-secondary-800 hover:bg-secondary-100 dark:hover:bg-secondary-800  
              `,secondaryFull:`inline-flex items-center justify-center border border-secondary-300 dark:border-secondary-600
                  shadow-sm font-medium rounded-md text-secondary-600 dark:text-secondary-300
                  bg-secondary-50 dark:bg-secondary-800 hover:bg-secondary-200 dark:hover:bg-secondary-900 
                  w-full relative`,control:`flex-1 inline-flex items-center justify-center rounded-md
            text-secondary-900 dark:text-secondary-200  dark:hover:text-secondary-400
            focus:outline-none focus:bg-primary border dark:border-secondary-700 dark:bg-secondary-900`,controlButton:`flex-1 inline-flex items-center justify-center rounded-md
            text-secondary-900 dark:text-secondary-200  dark:hover:text-secondary-400
            focus:outline-none border dark:bg-secondary-900 dark:border-secondary-700 dark:bg-secondary-900`,soloControlButton:`flex-1 inline-flex items-center justify-center rounded-md
            text-secondary-900 dark:text-secondary-50 dark:hover:text-secondary-400
            focus:outline-none border dark:border-secondary-700 bg-white dark:bg-secondary-900`,muteControlButton:`flex-1 inline-flex items-center justify-center rounded-md
            text-secondary-900 dark:text-secondary-50  dark:hover:text-secondary-400
            focus:outline-none border dark:border-secondary-700 bg-white dark:bg-secondary-900 `,recordControlButton:`flex-1 inline-flex items-center justify-center rounded-md
            text-secondary-900 dark:text-secondary-50  dark:hover:text-secondary-400
            focus:outline-none border dark:border-secondary-700 bg-white dark:bg-secondary-900`,soloControlButtonOn:`bg-solo-400 text-secondary-50 dark:text-secondary-50`,muteControlButtonOn:`bg-mute-600 dark:text-secondary-50`,globalMuteControlButton:`flex-1 inline-flex items-center justify-center rounded-md
  text-secondary-900 dark:text-secondary-50  dark:hover:text-secondary-400
  focus:outline-none border dark:border-secondary-700 bg-white dark:bg-secondary-900`,globalPitchSpeedControlButton:`flex-1 inline-flex items-center justify-center rounded-md
  text-secondary-900 dark:text-secondary-50  dark:hover:text-secondary-400
  focus:outline-none border dark:border-secondary-700 bg-white dark:bg-secondary-900 py-1.5`,choirControl:`flex-1 inline-flex items-center justify-center rounded-md
  text-secondary-900 dark:text-secondary-50 dark:hover:text-secondary-400
  focus:outline-none dark:border-secondary-700 bg-white dark:bg-secondary-900 py-1.5`,choirControlOn:`flex-1 inline-flex items-center justify-center rounded-md
  text-white 
  focus:outline-none border-0 bg-primary py-1.5`,recordControlButtonOn:`bg-record-600 dark:text-secondary-50`,on:"bg-primary dark:bg-primary"};const ButtonSize={sm:"px-2 py-1 text-xs",base:"px-7 py-1.5 text-sm",lg:"px-10 py-1.5 text-base"};const ButtonHollow="bg-secondary-800 hover:border-primary border border-secondary-600";function Button({id,isOn,disabled,type,additionalClasses='',hollow,size,...props}){return/*#__PURE__*/React__default.createElement("button",_extends$3({id:id?id:'',type:"button",className:classNames$2(additionalClasses,ButtonType[type],ButtonSize[size],isOn?ButtonType[type+'On']||ButtonType.on:"",disabled?"opacity-40 cursor-not-allowed":"","focus:outline-none focus:ring-none",hollow?ButtonHollow:'')},props),props.children);}Button.propTypes={isOn:PropTypes.bool,disabled:PropTypes.bool,type:PropTypes.oneOf(["primary","primaryFull","secondary","secondaryFull","control","muteControlButton","soloControlButton","recordControlButton"]),// Would be better to use Object.keys but it won't work with Storybook currently
size:PropTypes.oneOf(["sm","base","lg"]),onClick:PropTypes.func,hollow:PropTypes.bool};Button.defaultProps={isOn:false,disabled:false,type:"primary",size:"base",onClick:undefined,hollow:false};function Bars4Icon({title,titleId,...props},svgRef){return/*#__PURE__*/React.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",fill:"none",viewBox:"0 0 24 24",strokeWidth:1.5,stroke:"currentColor","aria-hidden":"true","data-slot":"icon",ref:svgRef,"aria-labelledby":titleId},props),title?/*#__PURE__*/React.createElement("title",{id:titleId},title):null,/*#__PURE__*/React.createElement("path",{strokeLinecap:"round",strokeLinejoin:"round",d:"M3.75 5.25h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5"}));}const ForwardRef$7$1=/*#__PURE__*/React.forwardRef(Bars4Icon);var Bars4Icon$1=ForwardRef$7$1;function ChatBubbleBottomCenterTextIcon({title,titleId,...props},svgRef){return/*#__PURE__*/React.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",fill:"none",viewBox:"0 0 24 24",strokeWidth:1.5,stroke:"currentColor","aria-hidden":"true","data-slot":"icon",ref:svgRef,"aria-labelledby":titleId},props),title?/*#__PURE__*/React.createElement("title",{id:titleId},title):null,/*#__PURE__*/React.createElement("path",{strokeLinecap:"round",strokeLinejoin:"round",d:"M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 0 1 .865-.501 48.172 48.172 0 0 0 3.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"}));}const ForwardRef$6$1=/*#__PURE__*/React.forwardRef(ChatBubbleBottomCenterTextIcon);var ChatBubbleBottomCenterTextIcon$1=ForwardRef$6$1;function CheckCircleIcon({title,titleId,...props},svgRef){return/*#__PURE__*/React.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",fill:"none",viewBox:"0 0 24 24",strokeWidth:1.5,stroke:"currentColor","aria-hidden":"true","data-slot":"icon",ref:svgRef,"aria-labelledby":titleId},props),title?/*#__PURE__*/React.createElement("title",{id:titleId},title):null,/*#__PURE__*/React.createElement("path",{strokeLinecap:"round",strokeLinejoin:"round",d:"M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"}));}const ForwardRef$5$1=/*#__PURE__*/React.forwardRef(CheckCircleIcon);var CheckCircleIcon$1=ForwardRef$5$1;function EllipsisVerticalIcon({title,titleId,...props},svgRef){return/*#__PURE__*/React.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",fill:"none",viewBox:"0 0 24 24",strokeWidth:1.5,stroke:"currentColor","aria-hidden":"true","data-slot":"icon",ref:svgRef,"aria-labelledby":titleId},props),title?/*#__PURE__*/React.createElement("title",{id:titleId},title):null,/*#__PURE__*/React.createElement("path",{strokeLinecap:"round",strokeLinejoin:"round",d:"M12 6.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 12.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 18.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Z"}));}const ForwardRef$4$1=/*#__PURE__*/React.forwardRef(EllipsisVerticalIcon);var EllipsisVerticalIcon$1=ForwardRef$4$1;function ExclamationCircleIcon$1({title,titleId,...props},svgRef){return/*#__PURE__*/React.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",fill:"none",viewBox:"0 0 24 24",strokeWidth:1.5,stroke:"currentColor","aria-hidden":"true","data-slot":"icon",ref:svgRef,"aria-labelledby":titleId},props),title?/*#__PURE__*/React.createElement("title",{id:titleId},title):null,/*#__PURE__*/React.createElement("path",{strokeLinecap:"round",strokeLinejoin:"round",d:"M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"}));}const ForwardRef$3$1=/*#__PURE__*/React.forwardRef(ExclamationCircleIcon$1);var ExclamationCircleIcon$1$1=ForwardRef$3$1;function MagnifyingGlassIcon({title,titleId,...props},svgRef){return/*#__PURE__*/React.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",fill:"none",viewBox:"0 0 24 24",strokeWidth:1.5,stroke:"currentColor","aria-hidden":"true","data-slot":"icon",ref:svgRef,"aria-labelledby":titleId},props),title?/*#__PURE__*/React.createElement("title",{id:titleId},title):null,/*#__PURE__*/React.createElement("path",{strokeLinecap:"round",strokeLinejoin:"round",d:"m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"}));}const ForwardRef$2$1=/*#__PURE__*/React.forwardRef(MagnifyingGlassIcon);var MagnifyingGlassIcon$1=ForwardRef$2$1;function RectangleStackIcon({title,titleId,...props},svgRef){return/*#__PURE__*/React.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",fill:"none",viewBox:"0 0 24 24",strokeWidth:1.5,stroke:"currentColor","aria-hidden":"true","data-slot":"icon",ref:svgRef,"aria-labelledby":titleId},props),title?/*#__PURE__*/React.createElement("title",{id:titleId},title):null,/*#__PURE__*/React.createElement("path",{strokeLinecap:"round",strokeLinejoin:"round",d:"M6 6.878V6a2.25 2.25 0 0 1 2.25-2.25h7.5A2.25 2.25 0 0 1 18 6v.878m-12 0c.235-.083.487-.128.75-.128h10.5c.263 0 .515.045.75.128m-12 0A2.25 2.25 0 0 0 4.5 9v.878m13.5-3A2.25 2.25 0 0 1 19.5 9v.878m0 0a2.246 2.246 0 0 0-.75-.128H5.25c-.263 0-.515.045-.75.128m15 0A2.25 2.25 0 0 1 21 12v6a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 18v-6c0-.98.626-1.813 1.5-2.122"}));}const ForwardRef$1$1=/*#__PURE__*/React.forwardRef(RectangleStackIcon);var RectangleStackIcon$1=ForwardRef$1$1;function XMarkIcon({title,titleId,...props},svgRef){return/*#__PURE__*/React.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",fill:"none",viewBox:"0 0 24 24",strokeWidth:1.5,stroke:"currentColor","aria-hidden":"true","data-slot":"icon",ref:svgRef,"aria-labelledby":titleId},props),title?/*#__PURE__*/React.createElement("title",{id:titleId},title):null,/*#__PURE__*/React.createElement("path",{strokeLinecap:"round",strokeLinejoin:"round",d:"M6 18 18 6M6 6l12 12"}));}const ForwardRef$w=/*#__PURE__*/React.forwardRef(XMarkIcon);var XMarkIcon$1=ForwardRef$w;var i$6$1=Object.defineProperty;var d$8$1=(t,e,n)=>e in t?i$6$1(t,e,{enumerable:!0,configurable:!0,writable:!0,value:n}):t[e]=n;var r$7=(t,e,n)=>(d$8$1(t,typeof e!="symbol"?e+"":e,n),n);class o$8$1{constructor(){r$7(this,"current",this.detect());r$7(this,"handoffState","pending");r$7(this,"currentId",0);}set(e){this.current!==e&&(this.handoffState="pending",this.currentId=0,this.current=e);}reset(){this.set(this.detect());}nextId(){return ++this.currentId;}get isServer(){return this.current==="server";}get isClient(){return this.current==="client";}detect(){return typeof window=="undefined"||typeof document=="undefined"?"server":"client";}handoff(){this.handoffState==="pending"&&(this.handoffState="complete");}get isHandoffComplete(){return this.handoffState==="complete";}}let s$a$1=new o$8$1();let l$7$1=(e,f)=>{s$a$1.isServer?useEffect(e,f):useLayoutEffect$1(e,f);};function s$9$1(e){let r=useRef(e);return l$7$1(()=>{r.current=e;},[e]),r;}function i$5$1(e,o){let[u,t]=useState(e),r=s$9$1(e);return l$7$1(()=>t(r.current),[r,t,...o]),u;}let o$7$1=function(t){let e=s$9$1(t);return React__default.useCallback((...r)=>e.current(...r),[e]);};function T$3$1(l,r,c){let[i,s]=useState(c),e=l!==void 0,t=useRef(e),u=useRef(!1),d=useRef(!1);return e&&!t.current&&!u.current?(u.current=!0,t.current=e,console.error("A component is changing from uncontrolled to controlled. This may be caused by the value changing from undefined to a defined value, which should not happen.")):!e&&t.current&&!d.current&&(d.current=!0,t.current=e,console.error("A component is changing from controlled to uncontrolled. This may be caused by the value changing from a defined value to undefined, which should not happen.")),[e?l:i,o$7$1(n=>(e||s(n),r==null?void 0:r(n)))];}function t$a$1(e){typeof queueMicrotask=="function"?queueMicrotask(e):Promise.resolve().then(e).catch(o=>setTimeout(()=>{throw o;}));}function o$6$1(){let n=[],r={addEventListener(e,t,s,a){return e.addEventListener(t,s,a),r.add(()=>e.removeEventListener(t,s,a));},requestAnimationFrame(...e){let t=requestAnimationFrame(...e);return r.add(()=>cancelAnimationFrame(t));},nextFrame(...e){return r.requestAnimationFrame(()=>r.requestAnimationFrame(...e));},setTimeout(...e){let t=setTimeout(...e);return r.add(()=>clearTimeout(t));},microTask(...e){let t={current:!0};return t$a$1(()=>{t.current&&e[0]();}),r.add(()=>{t.current=!1;});},style(e,t,s){let a=e.style.getPropertyValue(t);return Object.assign(e.style,{[t]:s}),this.add(()=>{Object.assign(e.style,{[t]:a});});},group(e){let t=o$6$1();return e(t),this.add(()=>t.dispose());},add(e){return n.push(e),()=>{let t=n.indexOf(e);if(t>=0)for(let s of n.splice(t,1))s();};},dispose(){for(let e of n.splice(0))e();}};return r;}function p$8(){let[e]=useState(o$6$1);return useEffect(()=>()=>e.dispose(),[e]),e;}function s$8$1(){let r=typeof document=="undefined";return "useSyncExternalStore"in React?(o=>o.useSyncExternalStore)(React)(()=>()=>{},()=>!1,()=>!r):!1;}function l$6$1(){let r=s$8$1(),[e,n]=React.useState(s$a$1.isHandoffComplete);return e&&s$a$1.isHandoffComplete===!1&&n(!1),React.useEffect(()=>{e!==!0&&n(!0);},[e]),React.useEffect(()=>s$a$1.handoff(),[]),r?!1:e;}var o$5$1;let I$6$1=(o$5$1=React__default.useId)!=null?o$5$1:function(){let n=l$6$1(),[e,u]=React__default.useState(n?()=>s$a$1.nextId():null);return l$7$1(()=>{e===null&&u(s$a$1.nextId());},[e]),e!=null?""+e:void 0;};function u$9$1(r,n,...a){if(r in n){let e=n[r];return typeof e=="function"?e(...a):e;}let t=new Error(`Tried to handle "${r}" but there is no handler defined. Only defined handlers are: ${Object.keys(n).map(e=>`"${e}"`).join(", ")}.`);throw Error.captureStackTrace&&Error.captureStackTrace(t,u$9$1),t;}function o$4$1(r){return s$a$1.isServer?null:r instanceof Node?r.ownerDocument:r!=null&&r.hasOwnProperty("current")&&r.current instanceof Node?r.current.ownerDocument:document;}let c$7$1=["[contentEditable=true]","[tabindex]","a[href]","area[href]","button:not([disabled])","iframe","input:not([disabled])","select:not([disabled])","textarea:not([disabled])"].map(e=>`${e}:not([tabindex='-1'])`).join(",");var M$3$1=(n=>(n[n.First=1]="First",n[n.Previous=2]="Previous",n[n.Next=4]="Next",n[n.Last=8]="Last",n[n.WrapAround=16]="WrapAround",n[n.NoScroll=32]="NoScroll",n))(M$3$1||{}),N$2$1=(o=>(o[o.Error=0]="Error",o[o.Overflow=1]="Overflow",o[o.Success=2]="Success",o[o.Underflow=3]="Underflow",o))(N$2$1||{}),F$5$1=(t=>(t[t.Previous=-1]="Previous",t[t.Next=1]="Next",t))(F$5$1||{});function f$a(e=document.body){return e==null?[]:Array.from(e.querySelectorAll(c$7$1)).sort((r,t)=>Math.sign((r.tabIndex||Number.MAX_SAFE_INTEGER)-(t.tabIndex||Number.MAX_SAFE_INTEGER)));}var T$2$1=(t=>(t[t.Strict=0]="Strict",t[t.Loose=1]="Loose",t))(T$2$1||{});function h$6$1(e,r=0){var t;return e===((t=o$4$1(e))==null?void 0:t.body)?!1:u$9$1(r,{[0](){return e.matches(c$7$1);},[1](){let l=e;for(;l!==null;){if(l.matches(c$7$1))return !0;l=l.parentElement;}return !1;}});}function D$3$1(e){let r=o$4$1(e);o$6$1().nextFrame(()=>{r&&!h$6$1(r.activeElement,0)&&y$4$1(e);});}var w$4$1=(t=>(t[t.Keyboard=0]="Keyboard",t[t.Mouse=1]="Mouse",t))(w$4$1||{});typeof window!="undefined"&&typeof document!="undefined"&&(document.addEventListener("keydown",e=>{e.metaKey||e.altKey||e.ctrlKey||(document.documentElement.dataset.headlessuiFocusVisible="");},!0),document.addEventListener("click",e=>{e.detail===1?delete document.documentElement.dataset.headlessuiFocusVisible:e.detail===0&&(document.documentElement.dataset.headlessuiFocusVisible="");},!0));function y$4$1(e){e==null||e.focus({preventScroll:!0});}let S$5$1=["textarea","input"].join(",");function H$1(e){var r,t;return (t=(r=e==null?void 0:e.matches)==null?void 0:r.call(e,S$5$1))!=null?t:!1;}function I$5$1(e,r=t=>t){return e.slice().sort((t,l)=>{let o=r(t),i=r(l);if(o===null||i===null)return 0;let n=o.compareDocumentPosition(i);return n&Node.DOCUMENT_POSITION_FOLLOWING?-1:n&Node.DOCUMENT_POSITION_PRECEDING?1:0;});}function _$5(e,r){return O$1$1(f$a(),r,{relativeTo:e});}function O$1$1(e,r,{sorted:t=!0,relativeTo:l=null,skipElements:o=[]}={}){let i=Array.isArray(e)?e.length>0?e[0].ownerDocument:document:e.ownerDocument,n=Array.isArray(e)?t?I$5$1(e):e:f$a(e);o.length>0&&n.length>1&&(n=n.filter(s=>!o.includes(s))),l=l!=null?l:i.activeElement;let E=(()=>{if(r&5)return 1;if(r&10)return -1;throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");})(),x=(()=>{if(r&1)return 0;if(r&2)return Math.max(0,n.indexOf(l))-1;if(r&4)return Math.max(0,n.indexOf(l))+1;if(r&8)return n.length-1;throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");})(),p=r&32?{preventScroll:!0}:{},d=0,a=n.length,u;do{if(d>=a||d+a<=0)return 0;let s=x+d;if(r&16)s=(s+a)%a;else {if(s<0)return 3;if(s>=a)return 1;}u=n[s],u==null||u.focus(p),d+=E;}while(u!==i.activeElement);return r&6&&H$1(u)&&u.select(),2;}function t$9$1(){return /iPhone/gi.test(window.navigator.platform)||/Mac/gi.test(window.navigator.platform)&&window.navigator.maxTouchPoints>0;}function i$4$1(){return /Android/gi.test(window.navigator.userAgent);}function n$7(){return t$9$1()||i$4$1();}function d$7$1(e,r,n){let o=s$9$1(r);useEffect(()=>{function t(u){o.current(u);}return document.addEventListener(e,t,n),()=>document.removeEventListener(e,t,n);},[e,n]);}function s$7$1(e,r,n){let o=s$9$1(r);useEffect(()=>{function t(i){o.current(i);}return window.addEventListener(e,t,n),()=>window.removeEventListener(e,t,n);},[e,n]);}function y$3$1(s,m,a=!0){let i=useRef(!1);useEffect(()=>{requestAnimationFrame(()=>{i.current=a;});},[a]);function c(e,r){if(!i.current||e.defaultPrevented)return;let t=r(e);if(t===null||!t.getRootNode().contains(t)||!t.isConnected)return;let E=function u(n){return typeof n=="function"?u(n()):Array.isArray(n)||n instanceof Set?n:[n];}(s);for(let u of E){if(u===null)continue;let n=u instanceof HTMLElement?u:u.current;if(n!=null&&n.contains(t)||e.composed&&e.composedPath().includes(n))return;}return !h$6$1(t,T$2$1.Loose)&&t.tabIndex!==-1&&e.preventDefault(),m(e,t);}let o=useRef(null);d$7$1("pointerdown",e=>{var r,t;i.current&&(o.current=((t=(r=e.composedPath)==null?void 0:r.call(e))==null?void 0:t[0])||e.target);},!0),d$7$1("mousedown",e=>{var r,t;i.current&&(o.current=((t=(r=e.composedPath)==null?void 0:r.call(e))==null?void 0:t[0])||e.target);},!0),d$7$1("click",e=>{n$7()||o.current&&(c(e,()=>o.current),o.current=null);},!0),d$7$1("touchend",e=>c(e,()=>e.target instanceof HTMLElement?e.target:null),!0),s$7$1("blur",e=>c(e,()=>window.document.activeElement instanceof HTMLIFrameElement?window.document.activeElement:null),!0);}function n$6(...e){return useMemo(()=>o$4$1(...e),[...e]);}function i$3$1(t){var n;if(t.type)return t.type;let e=(n=t.as)!=null?n:"button";if(typeof e=="string"&&e.toLowerCase()==="button")return "button";}function T$1$1(t,e){let[n,u]=useState(()=>i$3$1(t));return l$7$1(()=>{u(i$3$1(t));},[t.type,t.as]),l$7$1(()=>{n||e.current&&e.current instanceof HTMLButtonElement&&!e.current.hasAttribute("type")&&u("button");},[n,e]),n;}let u$8$1=Symbol();function T$4(t,n=!0){return Object.assign(t,{[u$8$1]:n});}function y$2$1(...t){let n=useRef(t);useEffect(()=>{n.current=t;},[t]);let c=o$7$1(e=>{for(let o of n.current)o!=null&&(typeof o=="function"?o(e):o.current=e);});return t.every(e=>e==null||(e==null?void 0:e[u$8$1]))?void 0:c;}function t$8$1(e){return [e.screenX,e.screenY];}function u$7$1(){let e=useRef([-1,-1]);return {wasMoved(r){let n=t$8$1(r);return e.current[0]===n[0]&&e.current[1]===n[1]?!1:(e.current=n,!0);},update(r){e.current=t$8$1(r);}};}function F$4$1({container:e,accept:t,walk:r,enabled:c=!0}){let o=useRef(t),l=useRef(r);useEffect(()=>{o.current=t,l.current=r;},[t,r]),l$7$1(()=>{if(!e||!c)return;let n=o$4$1(e);if(!n)return;let f=o.current,p=l.current,d=Object.assign(i=>f(i),{acceptNode:f}),u=n.createTreeWalker(e,NodeFilter.SHOW_ELEMENT,d,!1);for(;u.nextNode();)p(u.currentNode);},[e,c,o,l]);}function m$5(u,t){let e=useRef([]),r=o$7$1(u);useEffect(()=>{let o=[...e.current];for(let[n,a]of t.entries())if(e.current[n]!==a){let l=r(t,o);return e.current=t,l;}},[r,...t]);}function t$7$1(...r){return Array.from(new Set(r.flatMap(n=>typeof n=="string"?n.split(" "):[]))).filter(Boolean).join(" ");}var O$2=(n=>(n[n.None=0]="None",n[n.RenderStrategy=1]="RenderStrategy",n[n.Static=2]="Static",n))(O$2||{}),v$5$1=(e=>(e[e.Unmount=0]="Unmount",e[e.Hidden=1]="Hidden",e))(v$5$1||{});function C$1$1({ourProps:r,theirProps:t,slot:e,defaultTag:n,features:o,visible:a=!0,name:f,mergeRefs:l}){l=l!=null?l:k$3;let s=R$1(t,r);if(a)return m$4(s,e,n,f,l);let y=o!=null?o:0;if(y&2){let{static:u=!1,...d}=s;if(u)return m$4(d,e,n,f,l);}if(y&1){let{unmount:u=!0,...d}=s;return u$9$1(u?0:1,{[0](){return null;},[1](){return m$4({...d,hidden:!0,style:{display:"none"}},e,n,f,l);}});}return m$4(s,e,n,f,l);}function m$4(r,t={},e,n,o){let{as:a=e,children:f,refName:l="ref",...s}=F$3$1(r,["unmount","static"]),y=r.ref!==void 0?{[l]:r.ref}:{},u=typeof f=="function"?f(t):f;"className"in s&&s.className&&typeof s.className=="function"&&(s.className=s.className(t));let d={};if(t){let i=!1,c=[];for(let[T,p]of Object.entries(t))typeof p=="boolean"&&(i=!0),p===!0&&c.push(T);i&&(d["data-headlessui-state"]=c.join(" "));}if(a===Fragment&&Object.keys(x$2(s)).length>0){if(!/*#__PURE__*/isValidElement(u)||Array.isArray(u)&&u.length>1)throw new Error(['Passing props on "Fragment"!',"",`The current component <${n} /> is rendering a "Fragment".`,"However we need to passthrough the following props:",Object.keys(s).map(p=>`  - ${p}`).join(`
`),"","You can apply a few solutions:",['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".',"Render a single element as the child so that we can forward the props onto that element."].map(p=>`  - ${p}`).join(`
`)].join(`
`));let i=u.props,c=typeof(i==null?void 0:i.className)=="function"?(...p)=>t$7$1(i==null?void 0:i.className(...p),s.className):t$7$1(i==null?void 0:i.className,s.className),T=c?{className:c}:{};return/*#__PURE__*/cloneElement(u,Object.assign({},R$1(u.props,x$2(F$3$1(s,["ref"]))),d,y,{ref:o(u.ref,y.ref)},T));}return/*#__PURE__*/createElement(a,Object.assign({},F$3$1(s,["ref"]),a!==Fragment&&y,a!==Fragment&&d),u);}function I$4$1(){let r=useRef([]),t=useCallback(e=>{for(let n of r.current)n!=null&&(typeof n=="function"?n(e):n.current=e);},[]);return (...e)=>{if(!e.every(n=>n==null))return r.current=e,t;};}function k$3(...r){return r.every(t=>t==null)?void 0:t=>{for(let e of r)e!=null&&(typeof e=="function"?e(t):e.current=t);};}function R$1(...r){if(r.length===0)return {};if(r.length===1)return r[0];let t={},e={};for(let o of r)for(let a in o)a.startsWith("on")&&typeof o[a]=="function"?(e[a]!=null||(e[a]=[]),e[a].push(o[a])):t[a]=o[a];if(t.disabled||t["aria-disabled"])return Object.assign(t,Object.fromEntries(Object.keys(e).map(o=>[o,void 0])));for(let o in e)Object.assign(t,{[o](a,...f){let l=e[o];for(let s of l){if((a instanceof Event||(a==null?void 0:a.nativeEvent)instanceof Event)&&a.defaultPrevented)return;s(a,...f);}}});return t;}function U$3$1(r){var t;return Object.assign(/*#__PURE__*/forwardRef(r),{displayName:(t=r.displayName)!=null?t:r.name});}function x$2(r){let t=Object.assign({},r);for(let e in t)t[e]===void 0&&delete t[e];return t;}function F$3$1(r,t=[]){let e=Object.assign({},r);for(let n of t)n in e&&delete e[n];return e;}let p$7="div";var s$6$1=(e=>(e[e.None=1]="None",e[e.Focusable=2]="Focusable",e[e.Hidden=4]="Hidden",e))(s$6$1||{});function l$5$1(d,o){var n;let{features:t=1,...e}=d,r={ref:o,"aria-hidden":(t&2)===2?!0:(n=e["aria-hidden"])!=null?n:void 0,style:{position:"fixed",top:1,left:1,width:1,height:0,padding:0,margin:-1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap",borderWidth:"0",...((t&4)===4&&(t&2)!==2&&{display:"none"})}};return C$1$1({ourProps:r,theirProps:e,slot:{},defaultTag:p$7,name:"Hidden"});}let f$9=U$3$1(l$5$1);let n$5$1=/*#__PURE__*/createContext(null);n$5$1.displayName="OpenClosedContext";var d$6$1=(e=>(e[e.Open=1]="Open",e[e.Closed=2]="Closed",e[e.Closing=4]="Closing",e[e.Opening=8]="Opening",e))(d$6$1||{});function u$6$1(){return useContext(n$5$1);}function s$5$1({value:o,children:r}){return/*#__PURE__*/React__default.createElement(n$5$1.Provider,{value:o},r);}function t$6$1(n){function e(){document.readyState!=="loading"&&(n(),document.removeEventListener("DOMContentLoaded",e));}typeof window!="undefined"&&typeof document!="undefined"&&(document.addEventListener("DOMContentLoaded",e),e());}let t$5$1=[];t$6$1(()=>{function e(n){n.target instanceof HTMLElement&&n.target!==document.body&&t$5$1[0]!==n.target&&(t$5$1.unshift(n.target),t$5$1=t$5$1.filter(r=>r!=null&&r.isConnected),t$5$1.splice(10));}window.addEventListener("click",e,{capture:!0}),window.addEventListener("mousedown",e,{capture:!0}),window.addEventListener("focus",e,{capture:!0}),document.body.addEventListener("click",e,{capture:!0}),document.body.addEventListener("mousedown",e,{capture:!0}),document.body.addEventListener("focus",e,{capture:!0});});function r$6(n){let e=n.parentElement,l=null;for(;e&&!(e instanceof HTMLFieldSetElement);)e instanceof HTMLLegendElement&&(l=e),e=e.parentElement;let t=(e==null?void 0:e.getAttribute("disabled"))==="";return t&&i$2$1(l)?!1:t;}function i$2$1(n){if(!n)return !1;let e=n.previousElementSibling;for(;e!==null;){if(e instanceof HTMLLegendElement)return !1;e=e.previousElementSibling;}return !0;}function u$5$1(l){throw new Error("Unexpected object: "+l);}var c$6$1=(i=>(i[i.First=0]="First",i[i.Previous=1]="Previous",i[i.Next=2]="Next",i[i.Last=3]="Last",i[i.Specific=4]="Specific",i[i.Nothing=5]="Nothing",i))(c$6$1||{});function f$8$1(l,n){let t=n.resolveItems();if(t.length<=0)return null;let r=n.resolveActiveIndex(),s=r!=null?r:-1;switch(l.focus){case 0:{for(let e=0;e<t.length;++e)if(!n.resolveDisabled(t[e],e,t))return e;return r;}case 1:{for(let e=s-1;e>=0;--e)if(!n.resolveDisabled(t[e],e,t))return e;return r;}case 2:{for(let e=s+1;e<t.length;++e)if(!n.resolveDisabled(t[e],e,t))return e;return r;}case 3:{for(let e=t.length-1;e>=0;--e)if(!n.resolveDisabled(t[e],e,t))return e;return r;}case 4:{for(let e=0;e<t.length;++e)if(n.resolveId(t[e],e,t)===l.id)return e;return r;}case 5:return null;default:u$5$1(l);}}function e$3$1(i={},s=null,t=[]){for(let[r,n]of Object.entries(i))o$3$1(t,f$7$1(s,r),n);return t;}function f$7$1(i,s){return i?i+"["+s+"]":s;}function o$3$1(i,s,t){if(Array.isArray(t))for(let[r,n]of t.entries())o$3$1(i,f$7$1(s,r.toString()),n);else t instanceof Date?i.push([s,t.toISOString()]):typeof t=="boolean"?i.push([s,t?"1":"0"]):typeof t=="string"?i.push([s,t]):typeof t=="number"?i.push([s,`${t}`]):t==null?i.push([s,""]):e$3$1(t,s,i);}function p$6(i){var t,r;let s=(t=i==null?void 0:i.form)!=null?t:i.closest("form");if(s){for(let n of s.elements)if(n!==i&&(n.tagName==="INPUT"&&n.type==="submit"||n.tagName==="BUTTON"&&n.type==="submit"||n.nodeName==="INPUT"&&n.type==="image")){n.click();return;}(r=s.requestSubmit)==null||r.call(s);}}var o$2$1=(r=>(r.Space=" ",r.Enter="Enter",r.Escape="Escape",r.Backspace="Backspace",r.Delete="Delete",r.ArrowLeft="ArrowLeft",r.ArrowUp="ArrowUp",r.ArrowRight="ArrowRight",r.ArrowDown="ArrowDown",r.Home="Home",r.End="End",r.PageUp="PageUp",r.PageDown="PageDown",r.Tab="Tab",r))(o$2$1||{});function E$1(n,e,a,t){let i=s$9$1(a);useEffect(()=>{n=n!=null?n:window;function r(o){i.current(o);}return n.addEventListener(e,r,t),()=>n.removeEventListener(e,r,t);},[n,e,t]);}function f$6$1(){let e=useRef(!1);return l$7$1(()=>(e.current=!0,()=>{e.current=!1;}),[]),e;}function c$5$1(t){let r=o$7$1(t),e=useRef(!1);useEffect(()=>(e.current=!1,()=>{e.current=!0,t$a$1(()=>{e.current&&r();});}),[r]);}var s$4$1=(r=>(r[r.Forwards=0]="Forwards",r[r.Backwards=1]="Backwards",r))(s$4$1||{});function n$4$1(){let e=useRef(0);return s$7$1("keydown",o=>{o.key==="Tab"&&(e.current=o.shiftKey?1:0);},!0),e;}function P$1(t){if(!t)return new Set();if(typeof t=="function")return new Set(t());let n=new Set();for(let e of t.current)e.current instanceof HTMLElement&&n.add(e.current);return n;}let X$2="div";var _$4=(r=>(r[r.None=1]="None",r[r.InitialFocus=2]="InitialFocus",r[r.TabLock=4]="TabLock",r[r.FocusLock=8]="FocusLock",r[r.RestoreFocus=16]="RestoreFocus",r[r.All=30]="All",r))(_$4||{});function z$2(t,n){let e=useRef(null),o=y$2$1(e,n),{initialFocus:l,containers:c,features:r=30,...s}=t;l$6$1()||(r=1);let i=n$6(e);Y$2({ownerDocument:i},Boolean(r&16));let u=Z$2({ownerDocument:i,container:e,initialFocus:l},Boolean(r&2));$$3({ownerDocument:i,container:e,containers:c,previousActiveElement:u},Boolean(r&8));let y=n$4$1(),R=o$7$1(a=>{let m=e.current;if(!m)return;(B=>B())(()=>{u$9$1(y.current,{[s$4$1.Forwards]:()=>{O$1$1(m,M$3$1.First,{skipElements:[a.relatedTarget]});},[s$4$1.Backwards]:()=>{O$1$1(m,M$3$1.Last,{skipElements:[a.relatedTarget]});}});});}),h=p$8(),H=useRef(!1),j={ref:o,onKeyDown(a){a.key=="Tab"&&(H.current=!0,h.requestAnimationFrame(()=>{H.current=!1;}));},onBlur(a){let m=P$1(c);e.current instanceof HTMLElement&&m.add(e.current);let T=a.relatedTarget;T instanceof HTMLElement&&T.dataset.headlessuiFocusGuard!=="true"&&(S$4$1(m,T)||(H.current?O$1$1(e.current,u$9$1(y.current,{[s$4$1.Forwards]:()=>M$3$1.Next,[s$4$1.Backwards]:()=>M$3$1.Previous})|M$3$1.WrapAround,{relativeTo:a.target}):a.target instanceof HTMLElement&&y$4$1(a.target)));}};return/*#__PURE__*/React__default.createElement(React__default.Fragment,null,Boolean(r&4)&&/*#__PURE__*/React__default.createElement(f$9,{as:"button",type:"button","data-headlessui-focus-guard":!0,onFocus:R,features:s$6$1.Focusable}),C$1$1({ourProps:j,theirProps:s,defaultTag:X$2,name:"FocusTrap"}),Boolean(r&4)&&/*#__PURE__*/React__default.createElement(f$9,{as:"button",type:"button","data-headlessui-focus-guard":!0,onFocus:R,features:s$6$1.Focusable}));}let D$2$1=U$3$1(z$2),de$1$1=Object.assign(D$2$1,{features:_$4});function Q$1$1(t=!0){let n=useRef(t$5$1.slice());return m$5(([e],[o])=>{o===!0&&e===!1&&t$a$1(()=>{n.current.splice(0);}),o===!1&&e===!0&&(n.current=t$5$1.slice());},[t,t$5$1,n]),o$7$1(()=>{var e;return (e=n.current.find(o=>o!=null&&o.isConnected))!=null?e:null;});}function Y$2({ownerDocument:t},n){let e=Q$1$1(n);m$5(()=>{n||(t==null?void 0:t.activeElement)===(t==null?void 0:t.body)&&y$4$1(e());},[n]),c$5$1(()=>{n&&y$4$1(e());});}function Z$2({ownerDocument:t,container:n,initialFocus:e},o){let l=useRef(null),c=f$6$1();return m$5(()=>{if(!o)return;let r=n.current;r&&t$a$1(()=>{if(!c.current)return;let s=t==null?void 0:t.activeElement;if(e!=null&&e.current){if((e==null?void 0:e.current)===s){l.current=s;return;}}else if(r.contains(s)){l.current=s;return;}e!=null&&e.current?y$4$1(e.current):O$1$1(r,M$3$1.First)===N$2$1.Error&&console.warn("There are no focusable elements inside the <FocusTrap />"),l.current=t==null?void 0:t.activeElement;});},[o]),l;}function $$3({ownerDocument:t,container:n,containers:e,previousActiveElement:o},l){let c=f$6$1();E$1(t==null?void 0:t.defaultView,"focus",r=>{if(!l||!c.current)return;let s=P$1(e);n.current instanceof HTMLElement&&s.add(n.current);let i=o.current;if(!i)return;let u=r.target;u&&u instanceof HTMLElement?S$4$1(s,u)?(o.current=u,y$4$1(u)):(r.preventDefault(),r.stopPropagation(),y$4$1(i)):y$4$1(o.current);},!0);}function S$4$1(t,n){for(let e of t)if(e.contains(n))return !0;return !1;}let e$2$1=/*#__PURE__*/createContext(!1);function a$7$1(){return useContext(e$2$1);}function l$4$1(o){return/*#__PURE__*/React__default.createElement(e$2$1.Provider,{value:o.force},o.children);}function F$2$1(p){let n=a$7$1(),l=useContext(_$3$1),e=n$6(p),[a,o]=useState(()=>{if(!n&&l!==null||s$a$1.isServer)return null;let t=e==null?void 0:e.getElementById("headlessui-portal-root");if(t)return t;if(e===null)return null;let r=e.createElement("div");return r.setAttribute("id","headlessui-portal-root"),e.body.appendChild(r);});return useEffect(()=>{a!==null&&(e!=null&&e.body.contains(a)||e==null||e.body.appendChild(a));},[a,e]),useEffect(()=>{n||l!==null&&o(l.current);},[l,o,n]),a;}let U$2$1=Fragment;function N$1$1(p,n){let l=p,e=useRef(null),a=y$2$1(T$4(u=>{e.current=u;}),n),o=n$6(e),t=F$2$1(e),[r]=useState(()=>{var u;return s$a$1.isServer?null:(u=o==null?void 0:o.createElement("div"))!=null?u:null;}),i=useContext(f$5$1),v=l$6$1();return l$7$1(()=>{!t||!r||t.contains(r)||(r.setAttribute("data-headlessui-portal",""),t.appendChild(r));},[t,r]),l$7$1(()=>{if(r&&i)return i.register(r);},[i,r]),c$5$1(()=>{var u;!t||!r||(r instanceof Node&&t.contains(r)&&t.removeChild(r),t.childNodes.length<=0&&((u=t.parentElement)==null||u.removeChild(t)));}),v?!t||!r?null:/*#__PURE__*/createPortal(C$1$1({ourProps:{ref:a},theirProps:l,defaultTag:U$2$1,name:"Portal"}),r):null;}let S$3$1=Fragment,_$3$1=/*#__PURE__*/createContext(null);function j$3(p,n){let{target:l,...e}=p,o={ref:y$2$1(n)};return/*#__PURE__*/React__default.createElement(_$3$1.Provider,{value:l},C$1$1({ourProps:o,theirProps:e,defaultTag:S$3$1,name:"Popover.Group"}));}let f$5$1=/*#__PURE__*/createContext(null);function ee$2$1(){let p=useContext(f$5$1),n=useRef([]),l=o$7$1(o=>(n.current.push(o),p&&p.register(o),()=>e(o))),e=o$7$1(o=>{let t=n.current.indexOf(o);t!==-1&&n.current.splice(t,1),p&&p.unregister(o);}),a=useMemo(()=>({register:l,unregister:e,portals:n}),[l,e,n]);return [n,useMemo(()=>function({children:t}){return/*#__PURE__*/React__default.createElement(f$5$1.Provider,{value:a},t);},[a])];}let D$1$1=U$3$1(N$1$1),I$3$1=U$3$1(j$3),te$2$1=Object.assign(D$1$1,{Group:I$3$1});function i$1$1(e,t){return e===t&&(e!==0||1/e===1/t)||e!==e&&t!==t;}const d$5$1=typeof Object.is=="function"?Object.is:i$1$1,{useState:u$4$1,useEffect:h$5$1,useLayoutEffect:f$4$1,useDebugValue:p$5$1}=React;function y$1$1(e,t,c){const a=t(),[{inst:n},o]=u$4$1({inst:{value:a,getSnapshot:t}});return f$4$1(()=>{n.value=a,n.getSnapshot=t,r$5$1(n)&&o({inst:n});},[e,a,t]),h$5$1(()=>(r$5$1(n)&&o({inst:n}),e(()=>{r$5$1(n)&&o({inst:n});})),[e]),p$5$1(a),a;}function r$5$1(e){const t=e.getSnapshot,c=e.value;try{const a=t();return !d$5$1(c,a);}catch{return !0;}}function t$4$1(r,e,n){return e();}const r$4$1=typeof window!="undefined"&&typeof window.document!="undefined"&&typeof window.document.createElement!="undefined",s$3$1=!r$4$1,c$4$1=s$3$1?t$4$1:y$1$1,a$6$1="useSyncExternalStore"in React?(n=>n.useSyncExternalStore)(React):c$4$1;function S$2$1(t){return a$6$1(t.subscribe,t.getSnapshot,t.getSnapshot);}function a$5$1(o,r){let t=o(),n=new Set();return {getSnapshot(){return t;},subscribe(e){return n.add(e),()=>n.delete(e);},dispatch(e,...s){let i=r[e].call(t,...s);i&&(t=i,n.forEach(c=>c()));}};}function c$3$1(){let o;return {before({doc:e}){var l;let n=e.documentElement;o=((l=e.defaultView)!=null?l:window).innerWidth-n.clientWidth;},after({doc:e,d:n}){let t=e.documentElement,l=t.clientWidth-t.offsetWidth,r=o-l;n.style(t,"paddingRight",`${r}px`);}};}function d$4$1(){return t$9$1()?{before({doc:r,d:l,meta:c}){function o(a){return c.containers.flatMap(n=>n()).some(n=>n.contains(a));}l.microTask(()=>{var s;if(window.getComputedStyle(r.documentElement).scrollBehavior!=="auto"){let t=o$6$1();t.style(r.documentElement,"scrollBehavior","auto"),l.add(()=>l.microTask(()=>t.dispose()));}let a=(s=window.scrollY)!=null?s:window.pageYOffset,n=null;l.addEventListener(r,"click",t=>{if(t.target instanceof HTMLElement)try{let e=t.target.closest("a");if(!e)return;let{hash:f}=new URL(e.href),i=r.querySelector(f);i&&!o(i)&&(n=i);}catch{}},!0),l.addEventListener(r,"touchstart",t=>{if(t.target instanceof HTMLElement)if(o(t.target)){let e=t.target;for(;e.parentElement&&o(e.parentElement);)e=e.parentElement;l.style(e,"overscrollBehavior","contain");}else l.style(t.target,"touchAction","none");}),l.addEventListener(r,"touchmove",t=>{if(t.target instanceof HTMLElement)if(o(t.target)){let e=t.target;for(;e.parentElement&&e.dataset.headlessuiPortal!==""&&!(e.scrollHeight>e.clientHeight||e.scrollWidth>e.clientWidth);)e=e.parentElement;e.dataset.headlessuiPortal===""&&t.preventDefault();}else t.preventDefault();},{passive:!1}),l.add(()=>{var e;let t=(e=window.scrollY)!=null?e:window.pageYOffset;a!==t&&window.scrollTo(0,a),n&&n.isConnected&&(n.scrollIntoView({block:"nearest"}),n=null);});});}}:{};}function l$3$1(){return {before({doc:e,d:o}){o.style(e.documentElement,"overflow","hidden");}};}function m$3$1(e){let n={};for(let t of e)Object.assign(n,t(n));return n;}let a$4$1=a$5$1(()=>new Map(),{PUSH(e,n){var o;let t=(o=this.get(e))!=null?o:{doc:e,count:0,d:o$6$1(),meta:new Set()};return t.count++,t.meta.add(n),this.set(e,t),this;},POP(e,n){let t=this.get(e);return t&&(t.count--,t.meta.delete(n)),this;},SCROLL_PREVENT({doc:e,d:n,meta:t}){let o={doc:e,d:n,meta:m$3$1(t)},c=[d$4$1(),c$3$1(),l$3$1()];c.forEach(({before:r})=>r==null?void 0:r(o)),c.forEach(({after:r})=>r==null?void 0:r(o));},SCROLL_ALLOW({d:e}){e.dispose();},TEARDOWN({doc:e}){this.delete(e);}});a$4$1.subscribe(()=>{let e=a$4$1.getSnapshot(),n=new Map();for(let[t]of e)n.set(t,t.documentElement.style.overflow);for(let t of e.values()){let o=n.get(t.doc)==="hidden",c=t.count!==0;(c&&!o||!c&&o)&&a$4$1.dispatch(t.count>0?"SCROLL_PREVENT":"SCROLL_ALLOW",t),t.count===0&&a$4$1.dispatch("TEARDOWN",t);}});function p$4$1(e,r,n){let f=S$2$1(a$4$1),o=e?f.get(e):void 0,i=o?o.count>0:!1;return l$7$1(()=>{if(!(!e||!r))return a$4$1.dispatch("PUSH",e,n),()=>a$4$1.dispatch("POP",e,n);},[r,e]),i;}let u$3$1=new Map(),t$3$1=new Map();function b$6(r,l=!0){l$7$1(()=>{var o;if(!l)return;let e=typeof r=="function"?r():r.current;if(!e)return;function a(){var d;if(!e)return;let i=(d=t$3$1.get(e))!=null?d:1;if(i===1?t$3$1.delete(e):t$3$1.set(e,i-1),i!==1)return;let n=u$3$1.get(e);n&&(n["aria-hidden"]===null?e.removeAttribute("aria-hidden"):e.setAttribute("aria-hidden",n["aria-hidden"]),e.inert=n.inert,u$3$1.delete(e));}let f=(o=t$3$1.get(e))!=null?o:0;return t$3$1.set(e,f+1),f!==0||(u$3$1.set(e,{"aria-hidden":e.getAttribute("aria-hidden"),inert:e.inert}),e.setAttribute("aria-hidden","true"),e.inert=!0),a;},[r,l]);}function N$3({defaultContainers:o=[],portals:r,mainTreeNodeRef:u}={}){var f;let t=useRef((f=u==null?void 0:u.current)!=null?f:null),l=n$6(t),c=o$7$1(()=>{var i,s,a;let n=[];for(let e of o)e!==null&&(e instanceof HTMLElement?n.push(e):"current"in e&&e.current instanceof HTMLElement&&n.push(e.current));if(r!=null&&r.current)for(let e of r.current)n.push(e);for(let e of (i=l==null?void 0:l.querySelectorAll("html > *, body > *"))!=null?i:[])e!==document.body&&e!==document.head&&e instanceof HTMLElement&&e.id!=="headlessui-portal-root"&&(e.contains(t.current)||e.contains((a=(s=t.current)==null?void 0:s.getRootNode())==null?void 0:a.host)||n.some(L=>e.contains(L))||n.push(e));return n;});return {resolveContainers:c,contains:o$7$1(n=>c().some(i=>i.contains(n))),mainTreeNodeRef:t,MainTreeNode:useMemo(()=>function(){return u!=null?null:/*#__PURE__*/React__default.createElement(f$9,{features:s$6$1.Hidden,ref:t});},[t,u])};}let a$3$1=/*#__PURE__*/createContext(()=>{});a$3$1.displayName="StackContext";var s$2$1=(e=>(e[e.Add=0]="Add",e[e.Remove=1]="Remove",e))(s$2$1||{});function x$1$1(){return useContext(a$3$1);}function b$5({children:i,onUpdate:r,type:e,element:n,enabled:u}){let l=x$1$1(),o=o$7$1((...t)=>{r==null||r(...t),l(...t);});return l$7$1(()=>{let t=u===void 0||u===!0;return t&&o(0,e,n),()=>{t&&o(1,e,n);};},[o,e,n,u]),/*#__PURE__*/React__default.createElement(a$3$1.Provider,{value:o},i);}let d$3$1=/*#__PURE__*/createContext(null);function f$3$1(){let r=useContext(d$3$1);if(r===null){let t=new Error("You used a <Description /> component, but it is not inside a relevant parent.");throw Error.captureStackTrace&&Error.captureStackTrace(t,f$3$1),t;}return r;}function w$3$1(){let[r,t]=useState([]);return [r.length>0?r.join(" "):void 0,useMemo(()=>function(e){let i=o$7$1(s=>(t(o=>[...o,s]),()=>t(o=>{let p=o.slice(),c=p.indexOf(s);return c!==-1&&p.splice(c,1),p;}))),n=useMemo(()=>({register:i,slot:e.slot,name:e.name,props:e.props}),[i,e.slot,e.name,e.props]);return/*#__PURE__*/React__default.createElement(d$3$1.Provider,{value:n},e.children);},[t])];}let I$2$1="p";function S$1$1(r,t){let a=I$6$1(),{id:e=`headlessui-description-${a}`,...i}=r,n=f$3$1(),s=y$2$1(t);l$7$1(()=>n.register(e),[e,n.register]);let o={ref:s,...n.props,id:e};return C$1$1({ourProps:o,theirProps:i,slot:n.slot||{},defaultTag:I$2$1,name:n.name||"Description"});}let h$4$1=U$3$1(S$1$1),G$1=Object.assign(h$4$1,{});var Me$1$1=(r=>(r[r.Open=0]="Open",r[r.Closed=1]="Closed",r))(Me$1$1||{}),we$1$1=(e=>(e[e.SetTitleId=0]="SetTitleId",e))(we$1$1||{});let He$2$1={[0](t,e){return t.titleId===e.id?t:{...t,titleId:e.id};}},I$1$1=/*#__PURE__*/createContext(null);I$1$1.displayName="DialogContext";function b$4$1(t){let e=useContext(I$1$1);if(e===null){let r=new Error(`<${t} /> is missing a parent <Dialog /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(r,b$4$1),r;}return e;}function Be$1$1(t,e,r=()=>[document.body]){p$4$1(t,e,i=>{var n;return {containers:[...((n=i.containers)!=null?n:[]),r]};});}function Ge$1$1(t,e){return u$9$1(e.type,He$2$1,t,e);}let Ne$2$1="div",Ue$2=O$2.RenderStrategy|O$2.Static;function We$1$1(t,e){let r=I$6$1(),{id:i=`headlessui-dialog-${r}`,open:n,onClose:l,initialFocus:s,role:a="dialog",__demoMode:T=!1,...m}=t,[M,f]=useState(0),U=useRef(!1);a=function(){return a==="dialog"||a==="alertdialog"?a:(U.current||(U.current=!0,console.warn(`Invalid role [${a}] passed to <Dialog />. Only \`dialog\` and and \`alertdialog\` are supported. Using \`dialog\` instead.`)),"dialog");}();let E$1$1=u$6$1();n===void 0&&E$1$1!==null&&(n=(E$1$1&d$6$1.Open)===d$6$1.Open);let D=useRef(null),ee=y$2$1(D,e),g=n$6(D),W=t.hasOwnProperty("open")||E$1$1!==null,$=t.hasOwnProperty("onClose");if(!W&&!$)throw new Error("You have to provide an `open` and an `onClose` prop to the `Dialog` component.");if(!W)throw new Error("You provided an `onClose` prop to the `Dialog`, but forgot an `open` prop.");if(!$)throw new Error("You provided an `open` prop to the `Dialog`, but forgot an `onClose` prop.");if(typeof n!="boolean")throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${n}`);if(typeof l!="function")throw new Error(`You provided an \`onClose\` prop to the \`Dialog\`, but the value is not a function. Received: ${l}`);let p=n?0:1,[h,te]=useReducer(Ge$1$1,{titleId:null,descriptionId:null,panelRef:/*#__PURE__*/createRef()}),P=o$7$1(()=>l(!1)),Y=o$7$1(o=>te({type:0,id:o})),S=l$6$1()?T?!1:p===0:!1,x=M>1,j=useContext(I$1$1)!==null,[oe,re]=ee$2$1(),ne={get current(){var o;return (o=h.panelRef.current)!=null?o:D.current;}},{resolveContainers:w,mainTreeNodeRef:L,MainTreeNode:le}=N$3({portals:oe,defaultContainers:[ne]}),ae=x?"parent":"leaf",J=E$1$1!==null?(E$1$1&d$6$1.Closing)===d$6$1.Closing:!1,ie=(()=>j||J?!1:S)(),se=useCallback(()=>{var o,c;return (c=Array.from((o=g==null?void 0:g.querySelectorAll("body > *"))!=null?o:[]).find(d=>d.id==="headlessui-portal-root"?!1:d.contains(L.current)&&d instanceof HTMLElement))!=null?c:null;},[L]);b$6(se,ie);let pe=(()=>x?!0:S)(),de=useCallback(()=>{var o,c;return (c=Array.from((o=g==null?void 0:g.querySelectorAll("[data-headlessui-portal]"))!=null?o:[]).find(d=>d.contains(L.current)&&d instanceof HTMLElement))!=null?c:null;},[L]);b$6(de,pe);let ue=(()=>!(!S||x))();y$3$1(w,P,ue);let fe=(()=>!(x||p!==0))();E$1(g==null?void 0:g.defaultView,"keydown",o=>{fe&&(o.defaultPrevented||o.key===o$2$1.Escape&&(o.preventDefault(),o.stopPropagation(),P()));});let ge=(()=>!(J||p!==0||j))();Be$1$1(g,ge,w),useEffect(()=>{if(p!==0||!D.current)return;let o=new ResizeObserver(c=>{for(let d of c){let F=d.target.getBoundingClientRect();F.x===0&&F.y===0&&F.width===0&&F.height===0&&P();}});return o.observe(D.current),()=>o.disconnect();},[p,D,P]);let[Te,ce]=w$3$1(),De=useMemo(()=>[{dialogState:p,close:P,setTitleId:Y},h],[p,h,P,Y]),X=useMemo(()=>({open:p===0}),[p]),me={ref:ee,id:i,role:a,"aria-modal":p===0?!0:void 0,"aria-labelledby":h.titleId,"aria-describedby":Te};return/*#__PURE__*/React__default.createElement(b$5,{type:"Dialog",enabled:p===0,element:D,onUpdate:o$7$1((o,c)=>{c==="Dialog"&&u$9$1(o,{[s$2$1.Add]:()=>f(d=>d+1),[s$2$1.Remove]:()=>f(d=>d-1)});})},/*#__PURE__*/React__default.createElement(l$4$1,{force:!0},/*#__PURE__*/React__default.createElement(te$2$1,null,/*#__PURE__*/React__default.createElement(I$1$1.Provider,{value:De},/*#__PURE__*/React__default.createElement(te$2$1.Group,{target:D},/*#__PURE__*/React__default.createElement(l$4$1,{force:!1},/*#__PURE__*/React__default.createElement(ce,{slot:X,name:"Dialog.Description"},/*#__PURE__*/React__default.createElement(de$1$1,{initialFocus:s,containers:w,features:S?u$9$1(ae,{parent:de$1$1.features.RestoreFocus,leaf:de$1$1.features.All&~de$1$1.features.FocusLock}):de$1$1.features.None},/*#__PURE__*/React__default.createElement(re,null,C$1$1({ourProps:me,theirProps:m,slot:X,defaultTag:Ne$2$1,features:Ue$2,visible:p===0,name:"Dialog"}))))))))),/*#__PURE__*/React__default.createElement(le,null));}let $e$1$1="div";function Ye$1$1(t,e){let r=I$6$1(),{id:i=`headlessui-dialog-overlay-${r}`,...n}=t,[{dialogState:l,close:s}]=b$4$1("Dialog.Overlay"),a=y$2$1(e),T=o$7$1(f=>{if(f.target===f.currentTarget){if(r$6(f.currentTarget))return f.preventDefault();f.preventDefault(),f.stopPropagation(),s();}}),m=useMemo(()=>({open:l===0}),[l]);return C$1$1({ourProps:{ref:a,id:i,"aria-hidden":!0,onClick:T},theirProps:n,slot:m,defaultTag:$e$1$1,name:"Dialog.Overlay"});}let je$1$1="div";function Je$1$1(t,e){let r=I$6$1(),{id:i=`headlessui-dialog-backdrop-${r}`,...n}=t,[{dialogState:l},s]=b$4$1("Dialog.Backdrop"),a=y$2$1(e);useEffect(()=>{if(s.panelRef.current===null)throw new Error("A <Dialog.Backdrop /> component is being used, but a <Dialog.Panel /> component is missing.");},[s.panelRef]);let T=useMemo(()=>({open:l===0}),[l]);return/*#__PURE__*/React__default.createElement(l$4$1,{force:!0},/*#__PURE__*/React__default.createElement(te$2$1,null,C$1$1({ourProps:{ref:a,id:i,"aria-hidden":!0},theirProps:n,slot:T,defaultTag:je$1$1,name:"Dialog.Backdrop"})));}let Xe$1$1="div";function Ke$1$1(t,e){let r=I$6$1(),{id:i=`headlessui-dialog-panel-${r}`,...n}=t,[{dialogState:l},s]=b$4$1("Dialog.Panel"),a=y$2$1(e,s.panelRef),T=useMemo(()=>({open:l===0}),[l]),m=o$7$1(f=>{f.stopPropagation();});return C$1$1({ourProps:{ref:a,id:i,onClick:m},theirProps:n,slot:T,defaultTag:Xe$1$1,name:"Dialog.Panel"});}let Ve$1$1="h2";function qe$3$1(t,e){let r=I$6$1(),{id:i=`headlessui-dialog-title-${r}`,...n}=t,[{dialogState:l,setTitleId:s}]=b$4$1("Dialog.Title"),a=y$2$1(e);useEffect(()=>(s(i),()=>s(null)),[i,s]);let T=useMemo(()=>({open:l===0}),[l]);return C$1$1({ourProps:{ref:a,id:i},theirProps:n,slot:T,defaultTag:Ve$1$1,name:"Dialog.Title"});}let ze$1$1=U$3$1(We$1$1),Qe$1$1=U$3$1(Je$1$1),Ze$1$1=U$3$1(Ke$1$1),et$1$1=U$3$1(Ye$1$1),tt$1$1=U$3$1(qe$3$1),_t=Object.assign(ze$1$1,{Backdrop:Qe$1$1,Panel:Ze$1$1,Overlay:et$1$1,Title:tt$1$1,Description:G$1});var t$2$1;let a$2$1=(t$2$1=React__default.startTransition)!=null?t$2$1:function(i){i();};var Q$2=(o=>(o[o.Open=0]="Open",o[o.Closed=1]="Closed",o))(Q$2||{}),V$1=(t=>(t[t.ToggleDisclosure=0]="ToggleDisclosure",t[t.CloseDisclosure=1]="CloseDisclosure",t[t.SetButtonId=2]="SetButtonId",t[t.SetPanelId=3]="SetPanelId",t[t.LinkPanel=4]="LinkPanel",t[t.UnlinkPanel=5]="UnlinkPanel",t))(V$1||{});let Y$1$1={[0]:e=>({...e,disclosureState:u$9$1(e.disclosureState,{[0]:1,[1]:0})}),[1]:e=>e.disclosureState===1?e:{...e,disclosureState:1},[4](e){return e.linkedPanel===!0?e:{...e,linkedPanel:!0};},[5](e){return e.linkedPanel===!1?e:{...e,linkedPanel:!1};},[2](e,n){return e.buttonId===n.buttonId?e:{...e,buttonId:n.buttonId};},[3](e,n){return e.panelId===n.panelId?e:{...e,panelId:n.panelId};}},M$2$1=/*#__PURE__*/createContext(null);M$2$1.displayName="DisclosureContext";function _$2$1(e){let n=useContext(M$2$1);if(n===null){let o=new Error(`<${e} /> is missing a parent <Disclosure /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(o,_$2$1),o;}return n;}let v$4$1=/*#__PURE__*/createContext(null);v$4$1.displayName="DisclosureAPIContext";function K$1(e){let n=useContext(v$4$1);if(n===null){let o=new Error(`<${e} /> is missing a parent <Disclosure /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(o,K$1),o;}return n;}let F$1$1=/*#__PURE__*/createContext(null);F$1$1.displayName="DisclosurePanelContext";function Z$1$1(){return useContext(F$1$1);}function ee$1$1(e,n){return u$9$1(n.type,Y$1$1,e,n);}let te$1$1=Fragment;function ne$1$1(e,n){let{defaultOpen:o=!1,...i}=e,f=useRef(null),l=y$2$1(n,T$4(u=>{f.current=u;},e.as===void 0||e.as===Fragment)),t=useRef(null),d=useRef(null),s=useReducer(ee$1$1,{disclosureState:o?0:1,linkedPanel:!1,buttonRef:d,panelRef:t,buttonId:null,panelId:null}),[{disclosureState:c,buttonId:a},D]=s,p=o$7$1(u=>{D({type:1});let y=o$4$1(f);if(!y||!a)return;let r=(()=>u?u instanceof HTMLElement?u:u.current instanceof HTMLElement?u.current:y.getElementById(a):y.getElementById(a))();r==null||r.focus();}),P=useMemo(()=>({close:p}),[p]),T$1=useMemo(()=>({open:c===0,close:p}),[c,p]),C={ref:l};return/*#__PURE__*/React__default.createElement(M$2$1.Provider,{value:s},/*#__PURE__*/React__default.createElement(v$4$1.Provider,{value:P},/*#__PURE__*/React__default.createElement(s$5$1,{value:u$9$1(c,{[0]:d$6$1.Open,[1]:d$6$1.Closed})},C$1$1({ourProps:C,theirProps:i,slot:T$1,defaultTag:te$1$1,name:"Disclosure"}))));}let le$1$1="button";function oe$4(e,n){let o=I$6$1(),{id:i=`headlessui-disclosure-button-${o}`,...f}=e,[l,t]=_$2$1("Disclosure.Button"),d=Z$1$1(),s=d===null?!1:d===l.panelId,c=useRef(null),a=y$2$1(c,n,s?null:l.buttonRef),D=I$4$1();useEffect(()=>{if(!s)return t({type:2,buttonId:i}),()=>{t({type:2,buttonId:null});};},[i,t,s]);let p=o$7$1(r=>{var m;if(s){if(l.disclosureState===1)return;switch(r.key){case o$2$1.Space:case o$2$1.Enter:r.preventDefault(),r.stopPropagation(),t({type:0}),(m=l.buttonRef.current)==null||m.focus();break;}}else switch(r.key){case o$2$1.Space:case o$2$1.Enter:r.preventDefault(),r.stopPropagation(),t({type:0});break;}}),P=o$7$1(r=>{switch(r.key){case o$2$1.Space:r.preventDefault();break;}}),T=o$7$1(r=>{var m;r$6(r.currentTarget)||e.disabled||(s?(t({type:0}),(m=l.buttonRef.current)==null||m.focus()):t({type:0}));}),C=useMemo(()=>({open:l.disclosureState===0}),[l]),u=T$1$1(e,c),y=s?{ref:a,type:u,onKeyDown:p,onClick:T}:{ref:a,id:i,type:u,"aria-expanded":l.disclosureState===0,"aria-controls":l.linkedPanel?l.panelId:void 0,onKeyDown:p,onKeyUp:P,onClick:T};return C$1$1({mergeRefs:D,ourProps:y,theirProps:f,slot:C,defaultTag:le$1$1,name:"Disclosure.Button"});}let re$1$1="div",se$1$1=O$2.RenderStrategy|O$2.Static;function ue$1$1(e,n){let o=I$6$1(),{id:i=`headlessui-disclosure-panel-${o}`,...f}=e,[l,t]=_$2$1("Disclosure.Panel"),{close:d}=K$1("Disclosure.Panel"),s=I$4$1(),c=y$2$1(n,l.panelRef,T=>{a$2$1(()=>t({type:T?4:5}));});useEffect(()=>(t({type:3,panelId:i}),()=>{t({type:3,panelId:null});}),[i,t]);let a=u$6$1(),D=(()=>a!==null?(a&d$6$1.Open)===d$6$1.Open:l.disclosureState===0)(),p=useMemo(()=>({open:l.disclosureState===0,close:d}),[l,d]),P={ref:c,id:i};return/*#__PURE__*/React__default.createElement(F$1$1.Provider,{value:l.panelId},C$1$1({mergeRefs:s,ourProps:P,theirProps:f,slot:p,defaultTag:re$1$1,features:se$1$1,visible:D,name:"Disclosure.Panel"}));}let ie$3=U$3$1(ne$1$1),ae$1$1=U$3$1(oe$4),pe$1=U$3$1(ue$1$1),Ae$1$1=Object.assign(ie$3,{Button:ae$1$1,Panel:pe$1});let a$1$1=/([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;function o$1$1(e){var r,i;let n=(r=e.innerText)!=null?r:"",t=e.cloneNode(!0);if(!(t instanceof HTMLElement))return n;let u=!1;for(let f of t.querySelectorAll('[hidden],[aria-hidden],[role="img"]'))f.remove(),u=!0;let l=u?(i=t.innerText)!=null?i:"":n;return a$1$1.test(l)&&(l=l.replace(a$1$1,"")),l;}function g$4(e){let n=e.getAttribute("aria-label");if(typeof n=="string")return n.trim();let t=e.getAttribute("aria-labelledby");if(t){let u=t.split(" ").map(l=>{let r=document.getElementById(l);if(r){let i=r.getAttribute("aria-label");return typeof i=="string"?i.trim():o$1$1(r).trim();}return null;}).filter(Boolean);if(u.length>0)return u.join(", ");}return o$1$1(e).trim();}function s$1$1(c){let t=useRef(""),r=useRef("");return o$7$1(()=>{let e=c.current;if(!e)return "";let u=e.innerText;if(t.current===u)return r.current;let n=g$4(e).trim().toLowerCase();return t.current=u,r.current=n,n;});}var Be$2=(n=>(n[n.Open=0]="Open",n[n.Closed=1]="Closed",n))(Be$2||{}),He$1$1=(n=>(n[n.Single=0]="Single",n[n.Multi=1]="Multi",n))(He$1$1||{}),Ge$4=(n=>(n[n.Pointer=0]="Pointer",n[n.Other=1]="Other",n))(Ge$4||{}),Ne$1$1=(i=>(i[i.OpenListbox=0]="OpenListbox",i[i.CloseListbox=1]="CloseListbox",i[i.GoToOption=2]="GoToOption",i[i.Search=3]="Search",i[i.ClearSearch=4]="ClearSearch",i[i.RegisterOption=5]="RegisterOption",i[i.UnregisterOption=6]="UnregisterOption",i[i.RegisterLabel=7]="RegisterLabel",i))(Ne$1$1||{});function z$1$1(e,a=n=>n){let n=e.activeOptionIndex!==null?e.options[e.activeOptionIndex]:null,r=I$5$1(a(e.options.slice()),t=>t.dataRef.current.domRef.current),l=n?r.indexOf(n):null;return l===-1&&(l=null),{options:r,activeOptionIndex:l};}let je$3={[1](e){return e.dataRef.current.disabled||e.listboxState===1?e:{...e,activeOptionIndex:null,listboxState:1};},[0](e){if(e.dataRef.current.disabled||e.listboxState===0)return e;let a=e.activeOptionIndex,{isSelected:n}=e.dataRef.current,r=e.options.findIndex(l=>n(l.dataRef.current.value));return r!==-1&&(a=r),{...e,listboxState:0,activeOptionIndex:a};},[2](e,a){var l;if(e.dataRef.current.disabled||e.listboxState===1)return e;let n=z$1$1(e),r=f$8$1(a,{resolveItems:()=>n.options,resolveActiveIndex:()=>n.activeOptionIndex,resolveId:t=>t.id,resolveDisabled:t=>t.dataRef.current.disabled});return {...e,...n,searchQuery:"",activeOptionIndex:r,activationTrigger:(l=a.trigger)!=null?l:1};},[3]:(e,a)=>{if(e.dataRef.current.disabled||e.listboxState===1)return e;let r=e.searchQuery!==""?0:1,l=e.searchQuery+a.value.toLowerCase(),p=(e.activeOptionIndex!==null?e.options.slice(e.activeOptionIndex+r).concat(e.options.slice(0,e.activeOptionIndex+r)):e.options).find(i=>{var b;return !i.dataRef.current.disabled&&((b=i.dataRef.current.textValue)==null?void 0:b.startsWith(l));}),u=p?e.options.indexOf(p):-1;return u===-1||u===e.activeOptionIndex?{...e,searchQuery:l}:{...e,searchQuery:l,activeOptionIndex:u,activationTrigger:1};},[4](e){return e.dataRef.current.disabled||e.listboxState===1||e.searchQuery===""?e:{...e,searchQuery:""};},[5]:(e,a)=>{let n={id:a.id,dataRef:a.dataRef},r=z$1$1(e,l=>[...l,n]);return e.activeOptionIndex===null&&e.dataRef.current.isSelected(a.dataRef.current.value)&&(r.activeOptionIndex=r.options.indexOf(n)),{...e,...r};},[6]:(e,a)=>{let n=z$1$1(e,r=>{let l=r.findIndex(t=>t.id===a.id);return l!==-1&&r.splice(l,1),r;});return {...e,...n,activationTrigger:1};},[7]:(e,a)=>({...e,labelId:a.id})},J$1=/*#__PURE__*/createContext(null);J$1.displayName="ListboxActionsContext";function k$2$1(e){let a=useContext(J$1);if(a===null){let n=new Error(`<${e} /> is missing a parent <Listbox /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(n,k$2$1),n;}return a;}let q$4=/*#__PURE__*/createContext(null);q$4.displayName="ListboxDataContext";function w$2$1(e){let a=useContext(q$4);if(a===null){let n=new Error(`<${e} /> is missing a parent <Listbox /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(n,w$2$1),n;}return a;}function Ve$3(e,a){return u$9$1(a.type,je$3,e,a);}let Ke$3=Fragment;function Qe$4(e,a){let{value:n,defaultValue:r,form:l,name:t,onChange:p,by:u=(s,c)=>s===c,disabled:i=!1,horizontal:b=!1,multiple:R=!1,...m}=e;const P=b?"horizontal":"vertical";let S=y$2$1(a),[g=R?[]:void 0,x]=T$3$1(n,p,r),[T,o]=useReducer(Ve$3,{dataRef:/*#__PURE__*/createRef(),listboxState:1,options:[],searchQuery:"",labelId:null,activeOptionIndex:null,activationTrigger:1}),L=useRef({static:!1,hold:!1}),U=useRef(null),B=useRef(null),W=useRef(null),I=o$7$1(typeof u=="string"?(s,c)=>{let O=u;return (s==null?void 0:s[O])===(c==null?void 0:c[O]);}:u),A=useCallback(s=>u$9$1(d.mode,{[1]:()=>g.some(c=>I(c,s)),[0]:()=>I(g,s)}),[g]),d=useMemo(()=>({...T,value:g,disabled:i,mode:R?1:0,orientation:P,compare:I,isSelected:A,optionsPropsRef:L,labelRef:U,buttonRef:B,optionsRef:W}),[g,i,R,T]);l$7$1(()=>{T.dataRef.current=d;},[d]),y$3$1([d.buttonRef,d.optionsRef],(s,c)=>{var O;o({type:1}),h$6$1(c,T$2$1.Loose)||(s.preventDefault(),(O=d.buttonRef.current)==null||O.focus());},d.listboxState===0);let H=useMemo(()=>({open:d.listboxState===0,disabled:i,value:g}),[d,i,g]),ie=o$7$1(s=>{let c=d.options.find(O=>O.id===s);c&&X(c.dataRef.current.value);}),re=o$7$1(()=>{if(d.activeOptionIndex!==null){let{dataRef:s,id:c}=d.options[d.activeOptionIndex];X(s.current.value),o({type:2,focus:c$6$1.Specific,id:c});}}),ae=o$7$1(()=>o({type:0})),le=o$7$1(()=>o({type:1})),se=o$7$1((s,c,O)=>s===c$6$1.Specific?o({type:2,focus:c$6$1.Specific,id:c,trigger:O}):o({type:2,focus:s,trigger:O})),pe=o$7$1((s,c)=>(o({type:5,id:s,dataRef:c}),()=>o({type:6,id:s}))),ue=o$7$1(s=>(o({type:7,id:s}),()=>o({type:7,id:null}))),X=o$7$1(s=>u$9$1(d.mode,{[0](){return x==null?void 0:x(s);},[1](){let c=d.value.slice(),O=c.findIndex(C=>I(C,s));return O===-1?c.push(s):c.splice(O,1),x==null?void 0:x(c);}})),de=o$7$1(s=>o({type:3,value:s})),ce=o$7$1(()=>o({type:4})),fe=useMemo(()=>({onChange:X,registerOption:pe,registerLabel:ue,goToOption:se,closeListbox:le,openListbox:ae,selectActiveOption:re,selectOption:ie,search:de,clearSearch:ce}),[]),Te={ref:S},G=useRef(null),be=p$8();return useEffect(()=>{G.current&&r!==void 0&&be.addEventListener(G.current,"reset",()=>{x==null||x(r);});},[G,x]),/*#__PURE__*/React__default.createElement(J$1.Provider,{value:fe},/*#__PURE__*/React__default.createElement(q$4.Provider,{value:d},/*#__PURE__*/React__default.createElement(s$5$1,{value:u$9$1(d.listboxState,{[0]:d$6$1.Open,[1]:d$6$1.Closed})},t!=null&&g!=null&&e$3$1({[t]:g}).map(([s,c],O)=>/*#__PURE__*/React__default.createElement(f$9,{features:s$6$1.Hidden,ref:O===0?C=>{var Y;G.current=(Y=C==null?void 0:C.closest("form"))!=null?Y:null;}:void 0,...x$2({key:s,as:"input",type:"hidden",hidden:!0,readOnly:!0,form:l,name:s,value:c})})),C$1$1({ourProps:Te,theirProps:m,slot:H,defaultTag:Ke$3,name:"Listbox"}))));}let We$3="button";function Xe$3(e,a){var x;let n=I$6$1(),{id:r=`headlessui-listbox-button-${n}`,...l}=e,t=w$2$1("Listbox.Button"),p=k$2$1("Listbox.Button"),u=y$2$1(t.buttonRef,a),i=p$8(),b=o$7$1(T=>{switch(T.key){case o$2$1.Space:case o$2$1.Enter:case o$2$1.ArrowDown:T.preventDefault(),p.openListbox(),i.nextFrame(()=>{t.value||p.goToOption(c$6$1.First);});break;case o$2$1.ArrowUp:T.preventDefault(),p.openListbox(),i.nextFrame(()=>{t.value||p.goToOption(c$6$1.Last);});break;}}),R=o$7$1(T=>{switch(T.key){case o$2$1.Space:T.preventDefault();break;}}),m=o$7$1(T=>{if(r$6(T.currentTarget))return T.preventDefault();t.listboxState===0?(p.closeListbox(),i.nextFrame(()=>{var o;return (o=t.buttonRef.current)==null?void 0:o.focus({preventScroll:!0});})):(T.preventDefault(),p.openListbox());}),P=i$5$1(()=>{if(t.labelId)return [t.labelId,r].join(" ");},[t.labelId,r]),S=useMemo(()=>({open:t.listboxState===0,disabled:t.disabled,value:t.value}),[t]),g={ref:u,id:r,type:T$1$1(e,t.buttonRef),"aria-haspopup":"listbox","aria-controls":(x=t.optionsRef.current)==null?void 0:x.id,"aria-expanded":t.listboxState===0,"aria-labelledby":P,disabled:t.disabled,onKeyDown:b,onKeyUp:R,onClick:m};return C$1$1({ourProps:g,theirProps:l,slot:S,defaultTag:We$3,name:"Listbox.Button"});}let $e$4="label";function ze$4(e,a){let n=I$6$1(),{id:r=`headlessui-listbox-label-${n}`,...l}=e,t=w$2$1("Listbox.Label"),p=k$2$1("Listbox.Label"),u=y$2$1(t.labelRef,a);l$7$1(()=>p.registerLabel(r),[r]);let i=o$7$1(()=>{var m;return (m=t.buttonRef.current)==null?void 0:m.focus({preventScroll:!0});}),b=useMemo(()=>({open:t.listboxState===0,disabled:t.disabled}),[t]);return C$1$1({ourProps:{ref:u,id:r,onClick:i},theirProps:l,slot:b,defaultTag:$e$4,name:"Listbox.Label"});}let Je$3="ul",qe$2$1=O$2.RenderStrategy|O$2.Static;function Ye$4(e,a){var T;let n=I$6$1(),{id:r=`headlessui-listbox-options-${n}`,...l}=e,t=w$2$1("Listbox.Options"),p=k$2$1("Listbox.Options"),u=y$2$1(t.optionsRef,a),i=p$8(),b=p$8(),R=u$6$1(),m=(()=>R!==null?(R&d$6$1.Open)===d$6$1.Open:t.listboxState===0)();useEffect(()=>{var L;let o=t.optionsRef.current;o&&t.listboxState===0&&o!==((L=o$4$1(o))==null?void 0:L.activeElement)&&o.focus({preventScroll:!0});},[t.listboxState,t.optionsRef]);let P=o$7$1(o=>{switch(b.dispose(),o.key){case o$2$1.Space:if(t.searchQuery!=="")return o.preventDefault(),o.stopPropagation(),p.search(o.key);case o$2$1.Enter:if(o.preventDefault(),o.stopPropagation(),t.activeOptionIndex!==null){let{dataRef:L}=t.options[t.activeOptionIndex];p.onChange(L.current.value);}t.mode===0&&(p.closeListbox(),o$6$1().nextFrame(()=>{var L;return (L=t.buttonRef.current)==null?void 0:L.focus({preventScroll:!0});}));break;case u$9$1(t.orientation,{vertical:o$2$1.ArrowDown,horizontal:o$2$1.ArrowRight}):return o.preventDefault(),o.stopPropagation(),p.goToOption(c$6$1.Next);case u$9$1(t.orientation,{vertical:o$2$1.ArrowUp,horizontal:o$2$1.ArrowLeft}):return o.preventDefault(),o.stopPropagation(),p.goToOption(c$6$1.Previous);case o$2$1.Home:case o$2$1.PageUp:return o.preventDefault(),o.stopPropagation(),p.goToOption(c$6$1.First);case o$2$1.End:case o$2$1.PageDown:return o.preventDefault(),o.stopPropagation(),p.goToOption(c$6$1.Last);case o$2$1.Escape:return o.preventDefault(),o.stopPropagation(),p.closeListbox(),i.nextFrame(()=>{var L;return (L=t.buttonRef.current)==null?void 0:L.focus({preventScroll:!0});});case o$2$1.Tab:o.preventDefault(),o.stopPropagation();break;default:o.key.length===1&&(p.search(o.key),b.setTimeout(()=>p.clearSearch(),350));break;}}),S=i$5$1(()=>{var o;return (o=t.buttonRef.current)==null?void 0:o.id;},[t.buttonRef.current]),g=useMemo(()=>({open:t.listboxState===0}),[t]),x={"aria-activedescendant":t.activeOptionIndex===null||(T=t.options[t.activeOptionIndex])==null?void 0:T.id,"aria-multiselectable":t.mode===1?!0:void 0,"aria-labelledby":S,"aria-orientation":t.orientation,id:r,onKeyDown:P,role:"listbox",tabIndex:0,ref:u};return C$1$1({ourProps:x,theirProps:l,slot:g,defaultTag:Je$3,features:qe$2$1,visible:m,name:"Listbox.Options"});}let Ze$4="li";function et$4(e,a){let n=I$6$1(),{id:r=`headlessui-listbox-option-${n}`,disabled:l=!1,value:t,...p}=e,u=w$2$1("Listbox.Option"),i=k$2$1("Listbox.Option"),b=u.activeOptionIndex!==null?u.options[u.activeOptionIndex].id===r:!1,R=u.isSelected(t),m=useRef(null),P=s$1$1(m),S=s$9$1({disabled:l,value:t,domRef:m,get textValue(){return P();}}),g=y$2$1(a,m);l$7$1(()=>{if(u.listboxState!==0||!b||u.activationTrigger===0)return;let A=o$6$1();return A.requestAnimationFrame(()=>{var d,H;(H=(d=m.current)==null?void 0:d.scrollIntoView)==null||H.call(d,{block:"nearest"});}),A.dispose;},[m,b,u.listboxState,u.activationTrigger,u.activeOptionIndex]),l$7$1(()=>i.registerOption(r,S),[S,r]);let x=o$7$1(A=>{if(l)return A.preventDefault();i.onChange(t),u.mode===0&&(i.closeListbox(),o$6$1().nextFrame(()=>{var d;return (d=u.buttonRef.current)==null?void 0:d.focus({preventScroll:!0});}));}),T=o$7$1(()=>{if(l)return i.goToOption(c$6$1.Nothing);i.goToOption(c$6$1.Specific,r);}),o=u$7$1(),L=o$7$1(A=>o.update(A)),U=o$7$1(A=>{o.wasMoved(A)&&(l||b||i.goToOption(c$6$1.Specific,r,0));}),B=o$7$1(A=>{o.wasMoved(A)&&(l||b&&i.goToOption(c$6$1.Nothing));}),W=useMemo(()=>({active:b,selected:R,disabled:l}),[b,R,l]);return C$1$1({ourProps:{id:r,ref:g,role:"option",tabIndex:l===!0?void 0:-1,"aria-disabled":l===!0?!0:void 0,"aria-selected":R,disabled:void 0,onClick:x,onFocus:T,onPointerEnter:L,onMouseEnter:L,onPointerMove:U,onMouseMove:U,onPointerLeave:B,onMouseLeave:B},theirProps:p,slot:W,defaultTag:Ze$4,name:"Listbox.Option"});}let tt$4=U$3$1(Qe$4),ot$3=U$3$1(Xe$3),nt$2=U$3$1(ze$4),it$2=U$3$1(Ye$4),rt$2=U$3$1(et$4),It=Object.assign(tt$4,{Button:ot$3,Label:nt$2,Options:it$2,Option:rt$2});var me$2=(r=>(r[r.Open=0]="Open",r[r.Closed=1]="Closed",r))(me$2||{}),de$4=(r=>(r[r.Pointer=0]="Pointer",r[r.Other=1]="Other",r))(de$4||{}),fe$3=(a=>(a[a.OpenMenu=0]="OpenMenu",a[a.CloseMenu=1]="CloseMenu",a[a.GoToItem=2]="GoToItem",a[a.Search=3]="Search",a[a.ClearSearch=4]="ClearSearch",a[a.RegisterItem=5]="RegisterItem",a[a.UnregisterItem=6]="UnregisterItem",a))(fe$3||{});function w$1$1(e,u=r=>r){let r=e.activeItemIndex!==null?e.items[e.activeItemIndex]:null,s=I$5$1(u(e.items.slice()),t=>t.dataRef.current.domRef.current),i=r?s.indexOf(r):null;return i===-1&&(i=null),{items:s,activeItemIndex:i};}let Te$2={[1](e){return e.menuState===1?e:{...e,activeItemIndex:null,menuState:1};},[0](e){return e.menuState===0?e:{...e,__demoMode:!1,menuState:0};},[2]:(e,u)=>{var i;let r=w$1$1(e),s=f$8$1(u,{resolveItems:()=>r.items,resolveActiveIndex:()=>r.activeItemIndex,resolveId:t=>t.id,resolveDisabled:t=>t.dataRef.current.disabled});return {...e,...r,searchQuery:"",activeItemIndex:s,activationTrigger:(i=u.trigger)!=null?i:1};},[3]:(e,u)=>{let s=e.searchQuery!==""?0:1,i=e.searchQuery+u.value.toLowerCase(),o=(e.activeItemIndex!==null?e.items.slice(e.activeItemIndex+s).concat(e.items.slice(0,e.activeItemIndex+s)):e.items).find(l=>{var m;return ((m=l.dataRef.current.textValue)==null?void 0:m.startsWith(i))&&!l.dataRef.current.disabled;}),a=o?e.items.indexOf(o):-1;return a===-1||a===e.activeItemIndex?{...e,searchQuery:i}:{...e,searchQuery:i,activeItemIndex:a,activationTrigger:1};},[4](e){return e.searchQuery===""?e:{...e,searchQuery:"",searchActiveItemIndex:null};},[5]:(e,u)=>{let r=w$1$1(e,s=>[...s,{id:u.id,dataRef:u.dataRef}]);return {...e,...r};},[6]:(e,u)=>{let r=w$1$1(e,s=>{let i=s.findIndex(t=>t.id===u.id);return i!==-1&&s.splice(i,1),s;});return {...e,...r,activationTrigger:1};}},U$1$1=/*#__PURE__*/createContext(null);U$1$1.displayName="MenuContext";function C$3(e){let u=useContext(U$1$1);if(u===null){let r=new Error(`<${e} /> is missing a parent <Menu /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(r,C$3),r;}return u;}function ye$1$1(e,u){return u$9$1(u.type,Te$2,e,u);}let Ie$3=Fragment;function Me$2(e,u){let{__demoMode:r=!1,...s}=e,i=useReducer(ye$1$1,{__demoMode:r,menuState:r?0:1,buttonRef:/*#__PURE__*/createRef(),itemsRef:/*#__PURE__*/createRef(),items:[],searchQuery:"",activeItemIndex:null,activationTrigger:1}),[{menuState:t,itemsRef:o,buttonRef:a},l]=i,m=y$2$1(u);y$3$1([a,o],(g,R)=>{var p;l({type:1}),h$6$1(R,T$2$1.Loose)||(g.preventDefault(),(p=a.current)==null||p.focus());},t===0);let I=o$7$1(()=>{l({type:1});}),A=useMemo(()=>({open:t===0,close:I}),[t,I]),f={ref:m};return/*#__PURE__*/React__default.createElement(U$1$1.Provider,{value:i},/*#__PURE__*/React__default.createElement(s$5$1,{value:u$9$1(t,{[0]:d$6$1.Open,[1]:d$6$1.Closed})},C$1$1({ourProps:f,theirProps:s,slot:A,defaultTag:Ie$3,name:"Menu"})));}let ge$2="button";function Re$1$1(e,u){var R;let r=I$6$1(),{id:s=`headlessui-menu-button-${r}`,...i}=e,[t,o]=C$3("Menu.Button"),a=y$2$1(t.buttonRef,u),l=p$8(),m=o$7$1(p=>{switch(p.key){case o$2$1.Space:case o$2$1.Enter:case o$2$1.ArrowDown:p.preventDefault(),p.stopPropagation(),o({type:0}),l.nextFrame(()=>o({type:2,focus:c$6$1.First}));break;case o$2$1.ArrowUp:p.preventDefault(),p.stopPropagation(),o({type:0}),l.nextFrame(()=>o({type:2,focus:c$6$1.Last}));break;}}),I=o$7$1(p=>{switch(p.key){case o$2$1.Space:p.preventDefault();break;}}),A=o$7$1(p=>{if(r$6(p.currentTarget))return p.preventDefault();e.disabled||(t.menuState===0?(o({type:1}),l.nextFrame(()=>{var M;return (M=t.buttonRef.current)==null?void 0:M.focus({preventScroll:!0});})):(p.preventDefault(),o({type:0})));}),f=useMemo(()=>({open:t.menuState===0}),[t]),g={ref:a,id:s,type:T$1$1(e,t.buttonRef),"aria-haspopup":"menu","aria-controls":(R=t.itemsRef.current)==null?void 0:R.id,"aria-expanded":t.menuState===0,onKeyDown:m,onKeyUp:I,onClick:A};return C$1$1({ourProps:g,theirProps:i,slot:f,defaultTag:ge$2,name:"Menu.Button"});}let Ae$2="div",be$3=O$2.RenderStrategy|O$2.Static;function Ee$3(e,u){var M,b;let r=I$6$1(),{id:s=`headlessui-menu-items-${r}`,...i}=e,[t,o]=C$3("Menu.Items"),a=y$2$1(t.itemsRef,u),l=n$6(t.itemsRef),m=p$8(),I=u$6$1(),A=(()=>I!==null?(I&d$6$1.Open)===d$6$1.Open:t.menuState===0)();useEffect(()=>{let n=t.itemsRef.current;n&&t.menuState===0&&n!==(l==null?void 0:l.activeElement)&&n.focus({preventScroll:!0});},[t.menuState,t.itemsRef,l]),F$4$1({container:t.itemsRef.current,enabled:t.menuState===0,accept(n){return n.getAttribute("role")==="menuitem"?NodeFilter.FILTER_REJECT:n.hasAttribute("role")?NodeFilter.FILTER_SKIP:NodeFilter.FILTER_ACCEPT;},walk(n){n.setAttribute("role","none");}});let f=o$7$1(n=>{var E,x;switch(m.dispose(),n.key){case o$2$1.Space:if(t.searchQuery!=="")return n.preventDefault(),n.stopPropagation(),o({type:3,value:n.key});case o$2$1.Enter:if(n.preventDefault(),n.stopPropagation(),o({type:1}),t.activeItemIndex!==null){let{dataRef:S}=t.items[t.activeItemIndex];(x=(E=S.current)==null?void 0:E.domRef.current)==null||x.click();}D$3$1(t.buttonRef.current);break;case o$2$1.ArrowDown:return n.preventDefault(),n.stopPropagation(),o({type:2,focus:c$6$1.Next});case o$2$1.ArrowUp:return n.preventDefault(),n.stopPropagation(),o({type:2,focus:c$6$1.Previous});case o$2$1.Home:case o$2$1.PageUp:return n.preventDefault(),n.stopPropagation(),o({type:2,focus:c$6$1.First});case o$2$1.End:case o$2$1.PageDown:return n.preventDefault(),n.stopPropagation(),o({type:2,focus:c$6$1.Last});case o$2$1.Escape:n.preventDefault(),n.stopPropagation(),o({type:1}),o$6$1().nextFrame(()=>{var S;return (S=t.buttonRef.current)==null?void 0:S.focus({preventScroll:!0});});break;case o$2$1.Tab:n.preventDefault(),n.stopPropagation(),o({type:1}),o$6$1().nextFrame(()=>{_$5(t.buttonRef.current,n.shiftKey?M$3$1.Previous:M$3$1.Next);});break;default:n.key.length===1&&(o({type:3,value:n.key}),m.setTimeout(()=>o({type:4}),350));break;}}),g=o$7$1(n=>{switch(n.key){case o$2$1.Space:n.preventDefault();break;}}),R=useMemo(()=>({open:t.menuState===0}),[t]),p={"aria-activedescendant":t.activeItemIndex===null||(M=t.items[t.activeItemIndex])==null?void 0:M.id,"aria-labelledby":(b=t.buttonRef.current)==null?void 0:b.id,id:s,onKeyDown:f,onKeyUp:g,role:"menu",tabIndex:0,ref:a};return C$1$1({ourProps:p,theirProps:i,slot:R,defaultTag:Ae$2,features:be$3,visible:A,name:"Menu.Items"});}let Se$1$1=Fragment;function xe$1$1(e,u){let r=I$6$1(),{id:s=`headlessui-menu-item-${r}`,disabled:i=!1,...t}=e,[o,a]=C$3("Menu.Item"),l=o.activeItemIndex!==null?o.items[o.activeItemIndex].id===s:!1,m=useRef(null),I=y$2$1(u,m);l$7$1(()=>{if(o.__demoMode||o.menuState!==0||!l||o.activationTrigger===0)return;let T=o$6$1();return T.requestAnimationFrame(()=>{var P,B;(B=(P=m.current)==null?void 0:P.scrollIntoView)==null||B.call(P,{block:"nearest"});}),T.dispose;},[o.__demoMode,m,l,o.menuState,o.activationTrigger,o.activeItemIndex]);let A=s$1$1(m),f=useRef({disabled:i,domRef:m,get textValue(){return A();}});l$7$1(()=>{f.current.disabled=i;},[f,i]),l$7$1(()=>(a({type:5,id:s,dataRef:f}),()=>a({type:6,id:s})),[f,s]);let g=o$7$1(()=>{a({type:1});}),R=o$7$1(T=>{if(i)return T.preventDefault();a({type:1}),D$3$1(o.buttonRef.current);}),p=o$7$1(()=>{if(i)return a({type:2,focus:c$6$1.Nothing});a({type:2,focus:c$6$1.Specific,id:s});}),M=u$7$1(),b=o$7$1(T=>M.update(T)),n=o$7$1(T=>{M.wasMoved(T)&&(i||l||a({type:2,focus:c$6$1.Specific,id:s,trigger:0}));}),E=o$7$1(T=>{M.wasMoved(T)&&(i||l&&a({type:2,focus:c$6$1.Nothing}));}),x=useMemo(()=>({active:l,disabled:i,close:g}),[l,i,g]);return C$1$1({ourProps:{id:s,ref:I,role:"menuitem",tabIndex:i===!0?void 0:-1,"aria-disabled":i===!0?!0:void 0,disabled:void 0,onClick:R,onFocus:p,onPointerEnter:b,onMouseEnter:b,onPointerMove:n,onMouseMove:n,onPointerLeave:E,onMouseLeave:E},theirProps:t,slot:x,defaultTag:Se$1$1,name:"Menu.Item"});}let Pe$1$1=U$3$1(Me$2),ve$1=U$3$1(Re$1$1),he$4=U$3$1(Ee$3),De$1$1=U$3$1(xe$1$1);Object.assign(Pe$1$1,{Button:ve$1,Items:he$4,Item:De$1$1});let d$2$1=/*#__PURE__*/createContext(null);function u$2$1(){let a=useContext(d$2$1);if(a===null){let t=new Error("You used a <Label /> component, but it is not inside a relevant parent.");throw Error.captureStackTrace&&Error.captureStackTrace(t,u$2$1),t;}return a;}function F$7(){let[a,t]=useState([]);return [a.length>0?a.join(" "):void 0,useMemo(()=>function(e){let s=o$7$1(r=>(t(l=>[...l,r]),()=>t(l=>{let n=l.slice(),p=n.indexOf(r);return p!==-1&&n.splice(p,1),n;}))),o=useMemo(()=>({register:s,slot:e.slot,name:e.name,props:e.props}),[s,e.slot,e.name,e.props]);return/*#__PURE__*/React__default.createElement(d$2$1.Provider,{value:o},e.children);},[t])];}let A$1="label";function h$3$1(a,t){let i=I$6$1(),{id:e=`headlessui-label-${i}`,passive:s=!1,...o}=a,r=u$2$1(),l=y$2$1(t);l$7$1(()=>r.register(e),[e,r.register]);let n={ref:l,...r.props,id:e};return s&&("onClick"in n&&(delete n.htmlFor,delete n.onClick),"onClick"in o&&delete o.onClick),C$1$1({ourProps:n,theirProps:o,slot:r.slot||{},defaultTag:A$1,name:r.name||"Label"});}let v$3$1=U$3$1(h$3$1),B$2=Object.assign(v$3$1,{});function c$2$1(a=0){let[l,r]=useState(a),t=f$6$1(),o=useCallback(e=>{t.current&&r(u=>u|e);},[l,t]),m=useCallback(e=>Boolean(l&e),[l]),s=useCallback(e=>{t.current&&r(u=>u&~e);},[r,t]),g=useCallback(e=>{t.current&&r(u=>u^e);},[r]);return {flags:l,addFlag:o,hasFlag:m,removeFlag:s,toggleFlag:g};}let b$3$1=/*#__PURE__*/createContext(null);b$3$1.displayName="GroupContext";let Y$3=Fragment;function Z$3(s){var d;let[n,p]=useState(null),[c,f]=F$7(),[r,h]=w$3$1(),l=useMemo(()=>({switch:n,setSwitch:p,labelledby:c,describedby:r}),[n,p,c,r]),T={},y=s;return/*#__PURE__*/React__default.createElement(h,{name:"Switch.Description"},/*#__PURE__*/React__default.createElement(f,{name:"Switch.Label",props:{htmlFor:(d=l.switch)==null?void 0:d.id,onClick(t){n&&(t.currentTarget.tagName==="LABEL"&&t.preventDefault(),n.click(),n.focus({preventScroll:!0}));}}},/*#__PURE__*/React__default.createElement(b$3$1.Provider,{value:l},C$1$1({ourProps:T,theirProps:y,defaultTag:Y$3,name:"Switch.Group"}))));}let ee$4="button";function te$3(s,n){let p=I$6$1(),{id:c=`headlessui-switch-${p}`,checked:f,defaultChecked:r=!1,onChange:h,name:l,value:T,form:y,...d}=s,t=useContext(b$3$1),u=useRef(null),g=y$2$1(u,n,t===null?null:t.setSwitch),[o,a]=T$3$1(f,h,r),S=o$7$1(()=>a==null?void 0:a(!o)),D=o$7$1(e=>{if(r$6(e.currentTarget))return e.preventDefault();e.preventDefault(),S();}),C=o$7$1(e=>{e.key===o$2$1.Space?(e.preventDefault(),S()):e.key===o$2$1.Enter&&p$6(e.currentTarget);}),L=o$7$1(e=>e.preventDefault()),x=useMemo(()=>({checked:o}),[o]),v={id:c,ref:g,role:"switch",type:T$1$1(s,u),tabIndex:0,"aria-checked":o,"aria-labelledby":t==null?void 0:t.labelledby,"aria-describedby":t==null?void 0:t.describedby,onClick:D,onKeyUp:C,onKeyPress:L},G=p$8();return useEffect(()=>{var w;let e=(w=u.current)==null?void 0:w.closest("form");e&&r!==void 0&&G.addEventListener(e,"reset",()=>{a(r);});},[u,a]),/*#__PURE__*/React__default.createElement(React__default.Fragment,null,l!=null&&o&&/*#__PURE__*/React__default.createElement(f$9,{features:s$6$1.Hidden,...x$2({as:"input",type:"checkbox",hidden:!0,readOnly:!0,form:y,checked:o,name:l,value:T})}),C$1$1({ourProps:v,theirProps:d,slot:x,defaultTag:ee$4,name:"Switch"}));}let ne$3=U$3$1(te$3),re$3=Z$3,we$3=Object.assign(ne$3,{Group:re$3,Label:B$2,Description:G$1});function l$2$1(r){let e={called:!1};return (...t)=>{if(!e.called)return e.called=!0,r(...t);};}function g$3(t,...e){t&&e.length>0&&t.classList.add(...e);}function v$2$1(t,...e){t&&e.length>0&&t.classList.remove(...e);}function b$2$1(t,e){let n=o$6$1();if(!t)return n.dispose;let{transitionDuration:m,transitionDelay:a}=getComputedStyle(t),[u,p]=[m,a].map(l=>{let[r=0]=l.split(",").filter(Boolean).map(i=>i.includes("ms")?parseFloat(i):parseFloat(i)*1e3).sort((i,T)=>T-i);return r;}),o=u+p;if(o!==0){n.group(r=>{r.setTimeout(()=>{e(),r.dispose();},o),r.addEventListener(t,"transitionrun",i=>{i.target===i.currentTarget&&r.dispose();});});let l=n.addEventListener(t,"transitionend",r=>{r.target===r.currentTarget&&(e(),l());});}else e();return n.add(()=>e()),n.dispose;}function M$1$1(t,e,n,m){let a=n?"enter":"leave",u=o$6$1(),p=m!==void 0?l$2$1(m):()=>{};a==="enter"&&(t.removeAttribute("hidden"),t.style.display="");let o=u$9$1(a,{enter:()=>e.enter,leave:()=>e.leave}),l=u$9$1(a,{enter:()=>e.enterTo,leave:()=>e.leaveTo}),r=u$9$1(a,{enter:()=>e.enterFrom,leave:()=>e.leaveFrom});return v$2$1(t,...e.base,...e.enter,...e.enterTo,...e.enterFrom,...e.leave,...e.leaveFrom,...e.leaveTo,...e.entered),g$3(t,...e.base,...o,...r),u.nextFrame(()=>{v$2$1(t,...e.base,...o,...r),g$3(t,...e.base,...o,...l),b$2$1(t,()=>(v$2$1(t,...e.base,...o),g$3(t,...e.base,...e.entered),p()));}),u.dispose;}function D$4({immediate:t,container:s,direction:n,classes:u,onStart:a,onStop:c}){let l=f$6$1(),d=p$8(),e=s$9$1(n);l$7$1(()=>{t&&(e.current="enter");},[t]),l$7$1(()=>{let r=o$6$1();d.add(r.dispose);let i=s.current;if(i&&e.current!=="idle"&&l.current)return r.dispose(),a.current(e.current),r.add(M$1$1(i,u.current,e.current==="enter",()=>{r.dispose(),c.current(e.current);})),r.dispose;},[n]);}function S$7(t=""){return t.split(/\s+/).filter(n=>n.length>1);}let I$7=/*#__PURE__*/createContext(null);I$7.displayName="TransitionContext";var Se$4=(r=>(r.Visible="visible",r.Hidden="hidden",r))(Se$4||{});function ye$3(){let t=useContext(I$7);if(t===null)throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");return t;}function xe$4(){let t=useContext(M$4);if(t===null)throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");return t;}let M$4=/*#__PURE__*/createContext(null);M$4.displayName="NestingContext";function U$4(t){return "children"in t?U$4(t.children):t.current.filter(({el:n})=>n.current!==null).filter(({state:n})=>n==="visible").length>0;}function se$2(t,n){let r=s$9$1(t),s=useRef([]),R=f$6$1(),D=p$8(),p=o$7$1((i,e=v$5$1.Hidden)=>{let a=s.current.findIndex(({el:o})=>o===i);a!==-1&&(u$9$1(e,{[v$5$1.Unmount](){s.current.splice(a,1);},[v$5$1.Hidden](){s.current[a].state="hidden";}}),D.microTask(()=>{var o;!U$4(s)&&R.current&&((o=r.current)==null||o.call(r));}));}),x=o$7$1(i=>{let e=s.current.find(({el:a})=>a===i);return e?e.state!=="visible"&&(e.state="visible"):s.current.push({el:i,state:"visible"}),()=>p(i,v$5$1.Unmount);}),h=useRef([]),v=useRef(Promise.resolve()),u=useRef({enter:[],leave:[],idle:[]}),g=o$7$1((i,e,a)=>{h.current.splice(0),n&&(n.chains.current[e]=n.chains.current[e].filter(([o])=>o!==i)),n==null||n.chains.current[e].push([i,new Promise(o=>{h.current.push(o);})]),n==null||n.chains.current[e].push([i,new Promise(o=>{Promise.all(u.current[e].map(([f,N])=>N)).then(()=>o());})]),e==="enter"?v.current=v.current.then(()=>n==null?void 0:n.wait.current).then(()=>a(e)):a(e);}),d=o$7$1((i,e,a)=>{Promise.all(u.current[e].splice(0).map(([o,f])=>f)).then(()=>{var o;(o=h.current.shift())==null||o();}).then(()=>a(e));});return useMemo(()=>({children:s,register:x,unregister:p,onStart:g,onStop:d,wait:v,chains:u}),[x,p,s,g,d,u,v]);}function Ne$4(){}let Pe$4=["beforeEnter","afterEnter","beforeLeave","afterLeave"];function ae$2(t){var r;let n={};for(let s of Pe$4)n[s]=(r=t[s])!=null?r:Ne$4;return n;}function Re$3(t){let n=useRef(ae$2(t));return useEffect(()=>{n.current=ae$2(t);},[t]),n;}let De$3="div",le$2=O$2.RenderStrategy;function He$4(t,n){var Q,Y;let{beforeEnter:r,afterEnter:s,beforeLeave:R,afterLeave:D$1,enter:p,enterFrom:x,enterTo:h,entered:v,leave:u,leaveFrom:g,leaveTo:d,...i}=t,e=useRef(null),a=y$2$1(e,n),o=(Q=i.unmount)==null||Q?v$5$1.Unmount:v$5$1.Hidden,{show:f,appear:N,initial:T}=ye$3(),[l,j]=useState(f?"visible":"hidden"),z=xe$4(),{register:L,unregister:O}=z;useEffect(()=>L(e),[L,e]),useEffect(()=>{if(o===v$5$1.Hidden&&e.current){if(f&&l!=="visible"){j("visible");return;}return u$9$1(l,{["hidden"]:()=>O(e),["visible"]:()=>L(e)});}},[l,e,L,O,f,o]);let k=s$9$1({base:S$7(i.className),enter:S$7(p),enterFrom:S$7(x),enterTo:S$7(h),entered:S$7(v),leave:S$7(u),leaveFrom:S$7(g),leaveTo:S$7(d)}),V=Re$3({beforeEnter:r,afterEnter:s,beforeLeave:R,afterLeave:D$1}),G=l$6$1();useEffect(()=>{if(G&&l==="visible"&&e.current===null)throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");},[e,l,G]);let Te=T&&!N,K=N&&f&&T,de=(()=>!G||Te?"idle":f?"enter":"leave")(),H=c$2$1(0),fe=o$7$1(C=>u$9$1(C,{enter:()=>{H.addFlag(d$6$1.Opening),V.current.beforeEnter();},leave:()=>{H.addFlag(d$6$1.Closing),V.current.beforeLeave();},idle:()=>{}})),me=o$7$1(C=>u$9$1(C,{enter:()=>{H.removeFlag(d$6$1.Opening),V.current.afterEnter();},leave:()=>{H.removeFlag(d$6$1.Closing),V.current.afterLeave();},idle:()=>{}})),w=se$2(()=>{j("hidden"),O(e);},z),B=useRef(!1);D$4({immediate:K,container:e,classes:k,direction:de,onStart:s$9$1(C=>{B.current=!0,w.onStart(e,C,fe);}),onStop:s$9$1(C=>{B.current=!1,w.onStop(e,C,me),C==="leave"&&!U$4(w)&&(j("hidden"),O(e));})});let P=i,ce={ref:a};return K?P={...P,className:t$7$1(i.className,...k.current.enter,...k.current.enterFrom)}:B.current&&(P.className=t$7$1(i.className,(Y=e.current)==null?void 0:Y.className),P.className===""&&delete P.className),/*#__PURE__*/React__default.createElement(M$4.Provider,{value:w},/*#__PURE__*/React__default.createElement(s$5$1,{value:u$9$1(l,{["visible"]:d$6$1.Open,["hidden"]:d$6$1.Closed})|H.flags},C$1$1({ourProps:ce,theirProps:P,defaultTag:De$3,features:le$2,visible:l==="visible",name:"Transition.Child"})));}function Fe$3(t,n){let{show:r,appear:s=!1,unmount:R=!0,...D}=t,p=useRef(null),x=y$2$1(p,n);l$6$1();let h=u$6$1();if(r===void 0&&h!==null&&(r=(h&d$6$1.Open)===d$6$1.Open),![!0,!1].includes(r))throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");let[v,u]=useState(r?"visible":"hidden"),g=se$2(()=>{u("hidden");}),[d,i]=useState(!0),e=useRef([r]);l$7$1(()=>{d!==!1&&e.current[e.current.length-1]!==r&&(e.current.push(r),i(!1));},[e,r]);let a=useMemo(()=>({show:r,appear:s,initial:d}),[r,s,d]);useEffect(()=>{if(r)u("visible");else if(!U$4(g))u("hidden");else {let T=p.current;if(!T)return;let l=T.getBoundingClientRect();l.x===0&&l.y===0&&l.width===0&&l.height===0&&u("hidden");}},[r,g]);let o={unmount:R},f=o$7$1(()=>{var T;d&&i(!1),(T=t.beforeEnter)==null||T.call(t);}),N=o$7$1(()=>{var T;d&&i(!1),(T=t.beforeLeave)==null||T.call(t);});return/*#__PURE__*/React__default.createElement(M$4.Provider,{value:g},/*#__PURE__*/React__default.createElement(I$7.Provider,{value:a},C$1$1({ourProps:{...o,as:Fragment,children:/*#__PURE__*/React__default.createElement(ue$4,{ref:x,...o,...D,beforeEnter:f,beforeLeave:N})},theirProps:{},defaultTag:Fragment,features:le$2,visible:v==="visible",name:"Transition"})));}function _e$3(t,n){let r=useContext(I$7)!==null,s=u$6$1()!==null;return/*#__PURE__*/React__default.createElement(React__default.Fragment,null,!r&&s?/*#__PURE__*/React__default.createElement(q$3,{ref:n,...t}):/*#__PURE__*/React__default.createElement(ue$4,{ref:n,...t}));}let q$3=U$3$1(Fe$3),ue$4=U$3$1(He$4),Le$3=U$3$1(_e$3),qe$4=Object.assign(q$3,{Child:Le$3,Root:q$3});function Modal({isOpen,icon,text,title,onClose,closeLabel,content,onConfirm,confirmLabel,confirmable,type,size,...props}){const cancelButtonRef=useRef(null);const confirmButtonRef=useRef(null);return/*#__PURE__*/React__default.createElement(qe$4.Root,{show:isOpen,as:Fragment},/*#__PURE__*/React__default.createElement(_t,{as:"div",initialFocus:confirmButtonRef,className:"fixed z-10 inset-0 overflow-y-auto",onClose:onClose},/*#__PURE__*/React__default.createElement("div",{className:"flex items-center justify-center min-h-screen pt-4 px-4 text-center sm:block sm:p-0"},/*#__PURE__*/React__default.createElement(qe$4.Child,{as:Fragment,enter:"ease-out duration-300",enterFrom:"opacity-0",enterTo:"opacity-100",leave:"",leaveFrom:"opacity-100",leaveTo:"opacity-0"},/*#__PURE__*/React__default.createElement(_t.Overlay,{className:"fixed inset-0 bg-secondary-500 bg-opacity-75 transition-opacity"})),/*#__PURE__*/React__default.createElement("span",{className:"hidden sm:inline-block sm:align-middle sm:h-screen","aria-hidden":"true"},"\u200B"),/*#__PURE__*/React__default.createElement(qe$4.Child,{as:Fragment,enter:"ease-out duration-300",enterFrom:"opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",enterTo:"opacity-100 translate-y-0 sm:scale-100",leave:"",leaveFrom:"opacity-100 translate-y-0 sm:scale-100",leaveTo:"opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"},/*#__PURE__*/React__default.createElement("div",{className:"relative inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6"},/*#__PURE__*/React__default.createElement("div",{className:"sm:flex sm:items-center justify-center flex-1"},icon&&/*#__PURE__*/React__default.createElement("div",{className:"mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full  sm:mx-0 sm:h-10 sm:w-10"},icon),/*#__PURE__*/React__default.createElement("div",{className:"grow mt-3 text-center sm:mt-0 sm:text-left fireModal"},title&&/*#__PURE__*/React__default.createElement(_t.Title,{as:"h3",className:"text-lg leading-6 font-medium text-gray-900 text-center "},title),text&&/*#__PURE__*/React__default.createElement("div",{className:"mt-2"},/*#__PURE__*/React__default.createElement("p",{className:"text-sm text-gray-500"},text)),content&&/*#__PURE__*/React__default.createElement("div",{className:"mt-2"},content))),(confirmLabel||closeLabel)&&/*#__PURE__*/React__default.createElement("div",{className:"mt-5 sm:mt-4 sm:flex sm:flex-row-reverse"},confirmLabel&&/*#__PURE__*/React__default.createElement("button",{type:"button",disabled:!confirmable,className:`w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary text-base font-medium text-white hover:bg-primary sm:ml-3 sm:w-auto sm:text-sm disabled:opacity-50`,onClick:onConfirm,ref:confirmButtonRef},confirmLabel),closeLabel&&/*#__PURE__*/React__default.createElement("button",{type:"button",className:"mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 sm:mt-0 sm:w-auto sm:text-sm",onClick:onClose,ref:cancelButtonRef},closeLabel)))))));}Modal.propTypes={isOpen:PropTypes.bool.isRequired,onClose:PropTypes.func,type:PropTypes.oneOf(["default"]),// Would be better to use Object.keys but it won't work with Storybook currently
size:PropTypes.oneOf(["base"])};Modal.defaultProps={onClose:undefined,type:"default",size:"base",confirmable:true};function Header$1({onSidebarOpen,currentSong,onShare,onAddStem,onDownload,onReset,type,size,showExtraMenu,showActionButton,actionButtonActive,onClickedActionButon,...props}){const[showSongMenu,setShowSongMenu]=useState(false);const song=!!currentSong?/*#__PURE__*/React__default.createElement("div",{className:"flex-1 flex flex-col justify-center text-secondary-600 dark:text-secondary-300 truncate"},/*#__PURE__*/React__default.createElement("div",{className:"text-center font-medium text-sm truncate"},currentSong.title),/*#__PURE__*/React__default.createElement("div",{className:"text-center text-xs truncate"},currentSong.artist)):undefined;return/*#__PURE__*/React__default.createElement(React__default.Fragment,null,/*#__PURE__*/React__default.createElement(Modal,{isOpen:showSongMenu,content:/*#__PURE__*/React__default.createElement("div",{className:"my-3 sm:my-5 flex justify-center flex-col items-center space-y-4 flex-1"},/*#__PURE__*/React__default.createElement(Button,{type:"primaryFull",onClick:()=>{setShowSongMenu(false);onAddStem();}},"Add track"),/*#__PURE__*/React__default.createElement(Button,{type:"primaryFull",onClick:()=>{setShowSongMenu(false);onDownload();}},"Download mix"),/*#__PURE__*/React__default.createElement(Button,{type:"primaryFull",onClick:()=>{setShowSongMenu(false);onShare();}},"Share mix"),/*#__PURE__*/React__default.createElement(Button,{type:"primaryFull",onClick:()=>{setShowSongMenu(false);onReset();}},"Reset mix")),title:"Session menu",onClose:()=>setShowSongMenu(false),closeLabel:"Close"}),/*#__PURE__*/React__default.createElement("header",{className:"sticky top-0 z-10 flex-shrink-0 flex h-16 bg-secondary-50 dark:bg-secondary-900 shadow"},/*#__PURE__*/React__default.createElement("button",{type:"button",className:"m-1 p-3 text-secondary-600 dark:text-secondary-300 rounded-md",onClick:onSidebarOpen},/*#__PURE__*/React__default.createElement("span",{className:"sr-only"},"Open sidebar"),/*#__PURE__*/React__default.createElement(Bars4Icon$1,{className:"h-6 w-6","aria-hidden":"true"})),song,showActionButton?/*#__PURE__*/React__default.createElement("button",{type:"button",className:`m-1 p-3  rounded-md ${actionButtonActive?'text-primary':'text-secondary-600 dark:text-secondary-300'}`,onClick:onClickedActionButon},/*#__PURE__*/React__default.createElement("span",{className:"sr-only"},"Lyrics"),/*#__PURE__*/React__default.createElement(ChatBubbleBottomCenterTextIcon$1,{className:"h-6 w-6","aria-hidden":"true"})):null,showExtraMenu?/*#__PURE__*/React__default.createElement("button",{type:"button",className:"m-1 p-3 text-secondary-600 dark:text-secondary-300 rounded-md",onClick:()=>setShowSongMenu(true)},/*#__PURE__*/React__default.createElement("span",{className:"sr-only"},"Song Menu"),/*#__PURE__*/React__default.createElement(EllipsisVerticalIcon$1,{className:"h-6 w-6","aria-hidden":"true"})):showActionButton?null:/*#__PURE__*/React__default.createElement("div",{className:"m-1 p-3 max-h-6 max-w-6"})));}Header$1.propTypes={currentSong:PropTypes.shape({title:PropTypes.string.isRequired,artist:PropTypes.string.isRequired}),onSidebarOpen:PropTypes.func,onShare:PropTypes.func,onAddStem:PropTypes.func,onDownload:PropTypes.func,onReset:PropTypes.func,type:PropTypes.oneOf(["default"]),// Would be better to use Object.keys but it won't work with Storybook currently
size:PropTypes.oneOf(["base"]),showExtraMenu:PropTypes.bool,showActionButton:PropTypes.bool,actionButtonActive:PropTypes.bool,onClickedActionButon:PropTypes.func};Header$1.defaultProps={currentSong:undefined,onSidebarOpen:undefined,onShare:undefined,onAddStem:undefined,onDownload:undefined,onReset:undefined,type:"default",size:"base",showExtraMenu:false,showActionButton:false,actionButtonActive:false,onClickedActionButon:undefined};({type:PropTypes.oneOf(["default"]),// Would be better to use Object.keys but it won't work with Storybook currently
size:PropTypes.oneOf(["base"])});const InputType={default:""};const InputSize={base:"flex-1 max-w-sm"};const InputFieldType={default:"shadow-sm block text-xs  border border-black dark:border-0 rounded-md dark:bg-secondary-800 dark:text-white"};const InputFieldSize={base:"sm:text-xs w-full"};function Input({label,inputType,type,size,...props}){return/*#__PURE__*/React__default.createElement("div",{className:classNames$2(InputType[type],InputSize[size])},/*#__PURE__*/React__default.createElement("label",{htmlFor:label,className:"sr-only"},label),/*#__PURE__*/React__default.createElement("input",_extends$3({type:inputType,name:label,id:label,className:classNames$2(InputFieldType[type],InputFieldSize[size])},props)));}Input.propTypes={label:PropTypes.string.isRequired,inputType:PropTypes.oneOf(["text","search","email","password"]).isRequired,type:PropTypes.oneOf(["default"]),// Would be better to use Object.keys but it won't work with Storybook currently
size:PropTypes.oneOf(["base"]),value:PropTypes.string,onChange:PropTypes.func,placeholder:PropTypes.string};Input.defaultProps={type:"default",size:"base",onChange:undefined,placeholder:""};({draw:PropTypes.func.isRequired,options:PropTypes.shape({context:PropTypes.oneOf(["2d","webgl","experimental-webgl","webgl2","bitmaprenderer"])}),onDragEvent:PropTypes.func,onTapEvent:PropTypes.func});({dark:PropTypes.bool,level:PropTypes.number.isRequired,step:PropTypes.number,onChange:PropTypes.func,type:PropTypes.oneOf(["default"]),// Would be better to use Object.keys but it won't work with Storybook currently
size:PropTypes.oneOf(["base"])});var commonjsGlobal=typeof globalThis!=='undefined'?globalThis:typeof window!=='undefined'?window:typeof global!=='undefined'?global:typeof self!=='undefined'?self:{};function getAugmentedNamespace(n){if(n.__esModule)return n;var a=Object.defineProperty({},'__esModule',{value:true});Object.keys(n).forEach(function(k){var d=Object.getOwnPropertyDescriptor(n,k);Object.defineProperty(a,k,d.get?d:{enumerable:true,get:function(){return n[k];}});});return a;}var commonjs={exports:{}};(function(module){module.exports=/******/function(modules){// webpackBootstrap
/******/ // The module cache
/******/var installedModules={};/******/ /******/ // The require function
/******/function __webpack_require__(moduleId){/******/ /******/ // Check if module is in cache
/******/if(installedModules[moduleId]){/******/return installedModules[moduleId].exports;/******/}/******/ // Create a new module (and put it into the cache)
/******/var module=installedModules[moduleId]={/******/i:moduleId,/******/l:false,/******/exports:{}/******/};/******/ /******/ // Execute the module function
/******/modules[moduleId].call(module.exports,module,module.exports,__webpack_require__);/******/ /******/ // Flag the module as loaded
/******/module.l=true;/******/ /******/ // Return the exports of the module
/******/return module.exports;/******/}/******/ /******/ /******/ // expose the modules object (__webpack_modules__)
/******/__webpack_require__.m=modules;/******/ /******/ // expose the module cache
/******/__webpack_require__.c=installedModules;/******/ /******/ // identity function for calling harmony imports with the correct context
/******/__webpack_require__.i=function(value){return value;};/******/ /******/ // define getter function for harmony exports
/******/__webpack_require__.d=function(exports,name,getter){/******/if(!__webpack_require__.o(exports,name)){/******/Object.defineProperty(exports,name,{/******/configurable:false,/******/enumerable:true,/******/get:getter/******/});/******/}/******/};/******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
/******/__webpack_require__.n=function(module){/******/var getter=module&&module.__esModule?/******/function getDefault(){return module['default'];}:/******/function getModuleExports(){return module;};/******/__webpack_require__.d(getter,'a',getter);/******/return getter;/******/};/******/ /******/ // Object.prototype.hasOwnProperty.call
/******/__webpack_require__.o=function(object,property){return Object.prototype.hasOwnProperty.call(object,property);};/******/ /******/ // __webpack_public_path__
/******/__webpack_require__.p="";/******/ /******/ // Load entry module and return exports
/******/return __webpack_require__(__webpack_require__.s=90);/******/}/************************************************************************/ /******/([(/* 0 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony export (immutable) */__webpack_exports__["a"]=newInterval;var t0=new Date(),t1=new Date();function newInterval(floori,offseti,count,field){function interval(date){return floori(date=arguments.length===0?new Date():new Date(+date)),date;}interval.floor=function(date){return floori(date=new Date(+date)),date;};interval.ceil=function(date){return floori(date=new Date(date-1)),offseti(date,1),floori(date),date;};interval.round=function(date){var d0=interval(date),d1=interval.ceil(date);return date-d0<d1-date?d0:d1;};interval.offset=function(date,step){return offseti(date=new Date(+date),step==null?1:Math.floor(step)),date;};interval.range=function(start,stop,step){var range=[],previous;start=interval.ceil(start);step=step==null?1:Math.floor(step);if(!(start<stop)||!(step>0))return range;// also handles Invalid Date
do range.push(previous=new Date(+start)),offseti(start,step),floori(start);while(previous<start&&start<stop);return range;};interval.filter=function(test){return newInterval(function(date){if(date>=date)while(floori(date),!test(date))date.setTime(date-1);},function(date,step){if(date>=date){if(step<0)while(++step<=0){while(offseti(date,-1),!test(date)){}// eslint-disable-line no-empty
}else while(--step>=0){while(offseti(date,+1),!test(date)){}// eslint-disable-line no-empty
}}});};if(count){interval.count=function(start,end){t0.setTime(+start),t1.setTime(+end);floori(t0),floori(t1);return Math.floor(count(t0,t1));};interval.every=function(step){step=Math.floor(step);return !isFinite(step)||!(step>0)?null:!(step>1)?interval:interval.filter(field?function(d){return field(d)%step===0;}:function(d){return interval.count(0,d)%step===0;});};}return interval;}/***/}),(/* 1 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony export (immutable) */__webpack_exports__["b"]=initRange;/* harmony export (immutable) */__webpack_exports__["a"]=initInterpolator;function initRange(domain,range){switch(arguments.length){case 0:break;case 1:this.range(domain);break;default:this.range(range).domain(domain);break;}return this;}function initInterpolator(domain,interpolator){switch(arguments.length){case 0:break;case 1:this.interpolator(domain);break;default:this.interpolator(interpolator).domain(domain);break;}return this;}/***/}),(/* 2 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony export (binding) */__webpack_require__.d(__webpack_exports__,"c",function(){return root;});/* harmony export (immutable) */__webpack_exports__["b"]=Selection;/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__select__=__webpack_require__(181);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__selectAll__=__webpack_require__(182);/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__filter__=__webpack_require__(169);/* harmony import */var __WEBPACK_IMPORTED_MODULE_3__data__=__webpack_require__(163);/* harmony import */var __WEBPACK_IMPORTED_MODULE_4__enter__=__webpack_require__(73);/* harmony import */var __WEBPACK_IMPORTED_MODULE_5__exit__=__webpack_require__(168);/* harmony import */var __WEBPACK_IMPORTED_MODULE_6__join__=__webpack_require__(172);/* harmony import */var __WEBPACK_IMPORTED_MODULE_7__merge__=__webpack_require__(174);/* harmony import */var __WEBPACK_IMPORTED_MODULE_8__order__=__webpack_require__(177);/* harmony import */var __WEBPACK_IMPORTED_MODULE_9__sort__=__webpack_require__(184);/* harmony import */var __WEBPACK_IMPORTED_MODULE_10__call__=__webpack_require__(160);/* harmony import */var __WEBPACK_IMPORTED_MODULE_11__nodes__=__webpack_require__(176);/* harmony import */var __WEBPACK_IMPORTED_MODULE_12__node__=__webpack_require__(175);/* harmony import */var __WEBPACK_IMPORTED_MODULE_13__size__=__webpack_require__(183);/* harmony import */var __WEBPACK_IMPORTED_MODULE_14__empty__=__webpack_require__(167);/* harmony import */var __WEBPACK_IMPORTED_MODULE_15__each__=__webpack_require__(166);/* harmony import */var __WEBPACK_IMPORTED_MODULE_16__attr__=__webpack_require__(159);/* harmony import */var __WEBPACK_IMPORTED_MODULE_17__style__=__webpack_require__(75);/* harmony import */var __WEBPACK_IMPORTED_MODULE_18__property__=__webpack_require__(178);/* harmony import */var __WEBPACK_IMPORTED_MODULE_19__classed__=__webpack_require__(161);/* harmony import */var __WEBPACK_IMPORTED_MODULE_20__text__=__webpack_require__(185);/* harmony import */var __WEBPACK_IMPORTED_MODULE_21__html__=__webpack_require__(170);/* harmony import */var __WEBPACK_IMPORTED_MODULE_22__raise__=__webpack_require__(179);/* harmony import */var __WEBPACK_IMPORTED_MODULE_23__lower__=__webpack_require__(173);/* harmony import */var __WEBPACK_IMPORTED_MODULE_24__append__=__webpack_require__(158);/* harmony import */var __WEBPACK_IMPORTED_MODULE_25__insert__=__webpack_require__(171);/* harmony import */var __WEBPACK_IMPORTED_MODULE_26__remove__=__webpack_require__(180);/* harmony import */var __WEBPACK_IMPORTED_MODULE_27__clone__=__webpack_require__(162);/* harmony import */var __WEBPACK_IMPORTED_MODULE_28__datum__=__webpack_require__(164);/* harmony import */var __WEBPACK_IMPORTED_MODULE_29__on__=__webpack_require__(31);/* harmony import */var __WEBPACK_IMPORTED_MODULE_30__dispatch__=__webpack_require__(165);var root=[null];function Selection(groups,parents){this._groups=groups;this._parents=parents;}function selection(){return new Selection([[document.documentElement]],root);}Selection.prototype=selection.prototype={constructor:Selection,select:__WEBPACK_IMPORTED_MODULE_0__select__["a"/* default */],selectAll:__WEBPACK_IMPORTED_MODULE_1__selectAll__["a"/* default */],filter:__WEBPACK_IMPORTED_MODULE_2__filter__["a"/* default */],data:__WEBPACK_IMPORTED_MODULE_3__data__["a"/* default */],enter:__WEBPACK_IMPORTED_MODULE_4__enter__["a"/* default */],exit:__WEBPACK_IMPORTED_MODULE_5__exit__["a"/* default */],join:__WEBPACK_IMPORTED_MODULE_6__join__["a"/* default */],merge:__WEBPACK_IMPORTED_MODULE_7__merge__["a"/* default */],order:__WEBPACK_IMPORTED_MODULE_8__order__["a"/* default */],sort:__WEBPACK_IMPORTED_MODULE_9__sort__["a"/* default */],call:__WEBPACK_IMPORTED_MODULE_10__call__["a"/* default */],nodes:__WEBPACK_IMPORTED_MODULE_11__nodes__["a"/* default */],node:__WEBPACK_IMPORTED_MODULE_12__node__["a"/* default */],size:__WEBPACK_IMPORTED_MODULE_13__size__["a"/* default */],empty:__WEBPACK_IMPORTED_MODULE_14__empty__["a"/* default */],each:__WEBPACK_IMPORTED_MODULE_15__each__["a"/* default */],attr:__WEBPACK_IMPORTED_MODULE_16__attr__["a"/* default */],style:__WEBPACK_IMPORTED_MODULE_17__style__["b"/* default */],property:__WEBPACK_IMPORTED_MODULE_18__property__["a"/* default */],classed:__WEBPACK_IMPORTED_MODULE_19__classed__["a"/* default */],text:__WEBPACK_IMPORTED_MODULE_20__text__["a"/* default */],html:__WEBPACK_IMPORTED_MODULE_21__html__["a"/* default */],raise:__WEBPACK_IMPORTED_MODULE_22__raise__["a"/* default */],lower:__WEBPACK_IMPORTED_MODULE_23__lower__["a"/* default */],append:__WEBPACK_IMPORTED_MODULE_24__append__["a"/* default */],insert:__WEBPACK_IMPORTED_MODULE_25__insert__["a"/* default */],remove:__WEBPACK_IMPORTED_MODULE_26__remove__["a"/* default */],clone:__WEBPACK_IMPORTED_MODULE_27__clone__["a"/* default */],datum:__WEBPACK_IMPORTED_MODULE_28__datum__["a"/* default */],on:__WEBPACK_IMPORTED_MODULE_29__on__["c"/* default */],dispatch:__WEBPACK_IMPORTED_MODULE_30__dispatch__["a"/* default */]};/* harmony default export */__webpack_exports__["a"]=selection;/***/}),(/* 3 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__bisect__=__webpack_require__(40);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"b",function(){return __WEBPACK_IMPORTED_MODULE_0__bisect__["a"];});/* unused harmony reexport bisectRight */ /* unused harmony reexport bisectLeft */ /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__ascending__=__webpack_require__(9);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"e",function(){return __WEBPACK_IMPORTED_MODULE_1__ascending__["a"];});/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__bisector__=__webpack_require__(41);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"f",function(){return __WEBPACK_IMPORTED_MODULE_2__bisector__["a"];});/* harmony import */__webpack_require__(92);/* unused harmony reexport cross */ /* harmony import */__webpack_require__(93);/* unused harmony reexport descending */ /* harmony import */__webpack_require__(42);/* unused harmony reexport deviation */ /* harmony import */__webpack_require__(43);/* unused harmony reexport extent */ /* harmony import */__webpack_require__(94);/* unused harmony reexport histogram */ /* harmony import */__webpack_require__(104);/* unused harmony reexport thresholdFreedmanDiaconis */ /* harmony import */__webpack_require__(105);/* unused harmony reexport thresholdScott */ /* harmony import */__webpack_require__(47);/* unused harmony reexport thresholdSturges */ /* harmony import */__webpack_require__(96);/* unused harmony reexport max */ /* harmony import */__webpack_require__(97);/* unused harmony reexport mean */ /* harmony import */__webpack_require__(98);/* unused harmony reexport median */ /* harmony import */__webpack_require__(99);/* unused harmony reexport merge */ /* harmony import */__webpack_require__(44);/* unused harmony reexport min */ /* harmony import */__webpack_require__(45);/* unused harmony reexport pairs */ /* harmony import */__webpack_require__(100);/* unused harmony reexport permute */ /* harmony import */var __WEBPACK_IMPORTED_MODULE_18__quantile__=__webpack_require__(19);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"g",function(){return __WEBPACK_IMPORTED_MODULE_18__quantile__["a"];});/* harmony import */var __WEBPACK_IMPORTED_MODULE_19__range__=__webpack_require__(46);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"h",function(){return __WEBPACK_IMPORTED_MODULE_19__range__["a"];});/* harmony import */__webpack_require__(101);/* unused harmony reexport scan */ /* harmony import */__webpack_require__(102);/* unused harmony reexport shuffle */ /* harmony import */__webpack_require__(103);/* unused harmony reexport sum */ /* harmony import */var __WEBPACK_IMPORTED_MODULE_23__ticks__=__webpack_require__(48);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"c",function(){return __WEBPACK_IMPORTED_MODULE_23__ticks__["b"];});/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"d",function(){return __WEBPACK_IMPORTED_MODULE_23__ticks__["c"];});/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"a",function(){return __WEBPACK_IMPORTED_MODULE_23__ticks__["a"];});/* harmony import */__webpack_require__(49);/* unused harmony reexport transpose */ /* harmony import */__webpack_require__(50);/* unused harmony reexport variance */ /* harmony import */__webpack_require__(106);/* unused harmony reexport zip */ /***/}),(/* 4 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony export (binding) */__webpack_require__.d(__webpack_exports__,"e",function(){return durationSecond;});/* harmony export (binding) */__webpack_require__.d(__webpack_exports__,"d",function(){return durationMinute;});/* harmony export (binding) */__webpack_require__.d(__webpack_exports__,"c",function(){return durationHour;});/* harmony export (binding) */__webpack_require__.d(__webpack_exports__,"b",function(){return durationDay;});/* harmony export (binding) */__webpack_require__.d(__webpack_exports__,"a",function(){return durationWeek;});var durationSecond=1e3;var durationMinute=6e4;var durationHour=36e5;var durationDay=864e5;var durationWeek=6048e5;/***/}),(/* 5 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony export (immutable) */__webpack_exports__["a"]=identity;/* harmony export (immutable) */__webpack_exports__["c"]=copy;/* harmony export (immutable) */__webpack_exports__["b"]=transformer;/* harmony export (immutable) */__webpack_exports__["d"]=continuous;/* harmony import */var __WEBPACK_IMPORTED_MODULE_0_d3_array__=__webpack_require__(3);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__=__webpack_require__(135);/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__array__=__webpack_require__(7);/* harmony import */var __WEBPACK_IMPORTED_MODULE_3__constant__=__webpack_require__(145);/* harmony import */var __WEBPACK_IMPORTED_MODULE_4__number__=__webpack_require__(66);var unit=[0,1];function identity(x){return x;}function normalize(a,b){return (b-=a=+a)?function(x){return (x-a)/b;}:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__constant__["a"/* default */])(isNaN(b)?NaN:0.5);}function clamper(domain){var a=domain[0],b=domain[domain.length-1],t;if(a>b)t=a,a=b,b=t;return function(x){return Math.max(a,Math.min(b,x));};}// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function bimap(domain,range,interpolate){var d0=domain[0],d1=domain[1],r0=range[0],r1=range[1];if(d1<d0)d0=normalize(d1,d0),r0=interpolate(r1,r0);else d0=normalize(d0,d1),r0=interpolate(r0,r1);return function(x){return r0(d0(x));};}function polymap(domain,range,interpolate){var j=Math.min(domain.length,range.length)-1,d=new Array(j),r=new Array(j),i=-1;// Reverse descending domains.
if(domain[j]<domain[0]){domain=domain.slice().reverse();range=range.slice().reverse();}while(++i<j){d[i]=normalize(domain[i],domain[i+1]);r[i]=interpolate(range[i],range[i+1]);}return function(x){var i=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b"/* bisect */])(domain,x,1,j)-1;return r[i](d[i](x));};}function copy(source,target){return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());}function transformer(){var domain=unit,range=unit,interpolate=__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["a"/* interpolate */],transform,untransform,unknown,clamp=identity,piecewise,output,input;function rescale(){piecewise=Math.min(domain.length,range.length)>2?polymap:bimap;output=input=null;return scale;}function scale(x){return isNaN(x=+x)?unknown:(output||(output=piecewise(domain.map(transform),range,interpolate)))(transform(clamp(x)));}scale.invert=function(y){return clamp(untransform((input||(input=piecewise(range,domain.map(transform),__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["b"/* interpolateNumber */])))(y)));};scale.domain=function(_){return arguments.length?(domain=__WEBPACK_IMPORTED_MODULE_2__array__["a"/* map */].call(_,__WEBPACK_IMPORTED_MODULE_4__number__["a"/* default */]),clamp===identity||(clamp=clamper(domain)),rescale()):domain.slice();};scale.range=function(_){return arguments.length?(range=__WEBPACK_IMPORTED_MODULE_2__array__["b"/* slice */].call(_),rescale()):range.slice();};scale.rangeRound=function(_){return range=__WEBPACK_IMPORTED_MODULE_2__array__["b"/* slice */].call(_),interpolate=__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["c"/* interpolateRound */],rescale();};scale.clamp=function(_){return arguments.length?(clamp=_?clamper(domain):identity,scale):clamp!==identity;};scale.interpolate=function(_){return arguments.length?(interpolate=_,rescale()):interpolate;};scale.unknown=function(_){return arguments.length?(unknown=_,scale):unknown;};return function(t,u){transform=t,untransform=u;return rescale();};}function continuous(transform,untransform){return transformer()(transform,untransform);}/***/}),(/* 6 */ /***/function(module,exports){module.exports=React__default;/***/}),(/* 7 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony export (binding) */__webpack_require__.d(__webpack_exports__,"a",function(){return map;});/* harmony export (binding) */__webpack_require__.d(__webpack_exports__,"b",function(){return slice;});var array=Array.prototype;var map=array.map;var slice=array.slice;/***/}),(/* 8 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony export (immutable) */__webpack_exports__["b"]=linearish;/* harmony export (immutable) */__webpack_exports__["a"]=linear;/* harmony import */var __WEBPACK_IMPORTED_MODULE_0_d3_array__=__webpack_require__(3);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__continuous__=__webpack_require__(5);/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__init__=__webpack_require__(1);/* harmony import */var __WEBPACK_IMPORTED_MODULE_3__tickFormat__=__webpack_require__(69);function linearish(scale){var domain=scale.domain;scale.ticks=function(count){var d=domain();return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["c"/* ticks */])(d[0],d[d.length-1],count==null?10:count);};scale.tickFormat=function(count,specifier){var d=domain();return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__tickFormat__["a"/* default */])(d[0],d[d.length-1],count==null?10:count,specifier);};scale.nice=function(count){if(count==null)count=10;var d=domain(),i0=0,i1=d.length-1,start=d[i0],stop=d[i1],step;if(stop<start){step=start,start=stop,stop=step;step=i0,i0=i1,i1=step;}step=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["d"/* tickIncrement */])(start,stop,count);if(step>0){start=Math.floor(start/step)*step;stop=Math.ceil(stop/step)*step;step=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["d"/* tickIncrement */])(start,stop,count);}else if(step<0){start=Math.ceil(start*step)/step;stop=Math.floor(stop*step)/step;step=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["d"/* tickIncrement */])(start,stop,count);}if(step>0){d[i0]=Math.floor(start/step)*step;d[i1]=Math.ceil(stop/step)*step;domain(d);}else if(step<0){d[i0]=Math.ceil(start*step)/step;d[i1]=Math.floor(stop*step)/step;domain(d);}return scale;};return scale;}function linear(){var scale=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__continuous__["d"/* default */])(__WEBPACK_IMPORTED_MODULE_1__continuous__["a"/* identity */],__WEBPACK_IMPORTED_MODULE_1__continuous__["a"/* identity */]);scale.copy=function(){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__continuous__["c"/* copy */])(scale,linear());};__WEBPACK_IMPORTED_MODULE_2__init__["b"/* initRange */].apply(scale,arguments);return linearish(scale);}/***/}),(/* 9 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony default export */__webpack_exports__["a"]=function(a,b){return a<b?-1:a>b?1:a>=b?0:NaN;};/***/}),(/* 10 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__color_js__=__webpack_require__(21);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"f",function(){return __WEBPACK_IMPORTED_MODULE_0__color_js__["h"];});/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"e",function(){return __WEBPACK_IMPORTED_MODULE_0__color_js__["g"];});/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"d",function(){return __WEBPACK_IMPORTED_MODULE_0__color_js__["f"];});/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__lab_js__=__webpack_require__(114);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"c",function(){return __WEBPACK_IMPORTED_MODULE_1__lab_js__["b"];});/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"b",function(){return __WEBPACK_IMPORTED_MODULE_1__lab_js__["a"];});/* unused harmony reexport lch */ /* unused harmony reexport gray */ /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__cubehelix_js__=__webpack_require__(113);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"a",function(){return __WEBPACK_IMPORTED_MODULE_2__cubehelix_js__["a"];});/***/}),(/* 11 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony export (immutable) */__webpack_exports__["b"]=hue;/* harmony export (immutable) */__webpack_exports__["c"]=gamma;/* harmony export (immutable) */__webpack_exports__["a"]=nogamma;/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__constant__=__webpack_require__(60);function linear(a,d){return function(t){return a+t*d;};}function exponential(a,b,y){return a=Math.pow(a,y),b=Math.pow(b,y)-a,y=1/y,function(t){return Math.pow(a+t*b,y);};}function hue(a,b){var d=b-a;return d?linear(a,d>180||d<-180?d-360*Math.round(d/360):d):__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a"/* default */])(isNaN(a)?b:a);}function gamma(y){return (y=+y)===1?nogamma:function(a,b){return b-a?exponential(a,b,y):__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a"/* default */])(isNaN(a)?b:a);};}function nogamma(a,b){var d=b-a;return d?linear(a,d):__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a"/* default */])(isNaN(a)?b:a);}/***/}),(/* 12 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony default export */__webpack_exports__["a"]=function(x){return x===null?NaN:+x;};/***/}),(/* 13 */ /***/function(module,exports){// shim for using process in browser
var process=module.exports={};// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var cachedSetTimeout;var cachedClearTimeout;function defaultSetTimout(){throw new Error('setTimeout has not been defined');}function defaultClearTimeout(){throw new Error('clearTimeout has not been defined');}(function(){try{if(typeof setTimeout==='function'){cachedSetTimeout=setTimeout;}else {cachedSetTimeout=defaultSetTimout;}}catch(e){cachedSetTimeout=defaultSetTimout;}try{if(typeof clearTimeout==='function'){cachedClearTimeout=clearTimeout;}else {cachedClearTimeout=defaultClearTimeout;}}catch(e){cachedClearTimeout=defaultClearTimeout;}})();function runTimeout(fun){if(cachedSetTimeout===setTimeout){//normal enviroments in sane situations
return setTimeout(fun,0);}// if setTimeout wasn't available but was latter defined
if((cachedSetTimeout===defaultSetTimout||!cachedSetTimeout)&&setTimeout){cachedSetTimeout=setTimeout;return setTimeout(fun,0);}try{// when when somebody has screwed with setTimeout but no I.E. maddness
return cachedSetTimeout(fun,0);}catch(e){try{// When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
return cachedSetTimeout.call(null,fun,0);}catch(e){// same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
return cachedSetTimeout.call(this,fun,0);}}}function runClearTimeout(marker){if(cachedClearTimeout===clearTimeout){//normal enviroments in sane situations
return clearTimeout(marker);}// if clearTimeout wasn't available but was latter defined
if((cachedClearTimeout===defaultClearTimeout||!cachedClearTimeout)&&clearTimeout){cachedClearTimeout=clearTimeout;return clearTimeout(marker);}try{// when when somebody has screwed with setTimeout but no I.E. maddness
return cachedClearTimeout(marker);}catch(e){try{// When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
return cachedClearTimeout.call(null,marker);}catch(e){// same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
// Some versions of I.E. have different rules for clearTimeout vs setTimeout
return cachedClearTimeout.call(this,marker);}}}var queue=[];var draining=false;var currentQueue;var queueIndex=-1;function cleanUpNextTick(){if(!draining||!currentQueue){return;}draining=false;if(currentQueue.length){queue=currentQueue.concat(queue);}else {queueIndex=-1;}if(queue.length){drainQueue();}}function drainQueue(){if(draining){return;}var timeout=runTimeout(cleanUpNextTick);draining=true;var len=queue.length;while(len){currentQueue=queue;queue=[];while(++queueIndex<len){if(currentQueue){currentQueue[queueIndex].run();}}queueIndex=-1;len=queue.length;}currentQueue=null;draining=false;runClearTimeout(timeout);}process.nextTick=function(fun){var args=new Array(arguments.length-1);if(arguments.length>1){for(var i=1;i<arguments.length;i++){args[i-1]=arguments[i];}}queue.push(new Item(fun,args));if(queue.length===1&&!draining){runTimeout(drainQueue);}};// v8 likes predictible objects
function Item(fun,array){this.fun=fun;this.array=array;}Item.prototype.run=function(){this.fun.apply(null,this.array);};process.title='browser';process.browser=true;process.env={};process.argv=[];process.version='';// empty string to avoid regexp issues
process.versions={};function noop(){}process.on=noop;process.addListener=noop;process.once=noop;process.off=noop;process.removeListener=noop;process.removeAllListeners=noop;process.emit=noop;process.prependListener=noop;process.prependOnceListener=noop;process.listeners=function(name){return [];};process.binding=function(name){throw new Error('process.binding is not supported');};process.cwd=function(){return '/';};process.chdir=function(dir){throw new Error('process.chdir is not supported');};process.umask=function(){return 0;};/***/}),(/* 14 */ /***/function(module,__webpack_exports__,__webpack_require__){Object.defineProperty(__webpack_exports__,"__esModule",{value:true});/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__create__=__webpack_require__(154);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"create",function(){return __WEBPACK_IMPORTED_MODULE_0__create__["a"];});/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__creator__=__webpack_require__(17);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"creator",function(){return __WEBPACK_IMPORTED_MODULE_1__creator__["a"];});/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__local__=__webpack_require__(155);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"local",function(){return __WEBPACK_IMPORTED_MODULE_2__local__["a"];});/* harmony import */var __WEBPACK_IMPORTED_MODULE_3__matcher__=__webpack_require__(71);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"matcher",function(){return __WEBPACK_IMPORTED_MODULE_3__matcher__["a"];});/* harmony import */var __WEBPACK_IMPORTED_MODULE_4__mouse__=__webpack_require__(156);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"mouse",function(){return __WEBPACK_IMPORTED_MODULE_4__mouse__["a"];});/* harmony import */var __WEBPACK_IMPORTED_MODULE_5__namespace__=__webpack_require__(29);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"namespace",function(){return __WEBPACK_IMPORTED_MODULE_5__namespace__["a"];});/* harmony import */var __WEBPACK_IMPORTED_MODULE_6__namespaces__=__webpack_require__(30);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"namespaces",function(){return __WEBPACK_IMPORTED_MODULE_6__namespaces__["a"];});/* harmony import */var __WEBPACK_IMPORTED_MODULE_7__point__=__webpack_require__(18);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"clientPoint",function(){return __WEBPACK_IMPORTED_MODULE_7__point__["a"];});/* harmony import */var __WEBPACK_IMPORTED_MODULE_8__select__=__webpack_require__(72);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"select",function(){return __WEBPACK_IMPORTED_MODULE_8__select__["a"];});/* harmony import */var __WEBPACK_IMPORTED_MODULE_9__selectAll__=__webpack_require__(157);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"selectAll",function(){return __WEBPACK_IMPORTED_MODULE_9__selectAll__["a"];});/* harmony import */var __WEBPACK_IMPORTED_MODULE_10__selection_index__=__webpack_require__(2);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"selection",function(){return __WEBPACK_IMPORTED_MODULE_10__selection_index__["a"];});/* harmony import */var __WEBPACK_IMPORTED_MODULE_11__selector__=__webpack_require__(32);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"selector",function(){return __WEBPACK_IMPORTED_MODULE_11__selector__["a"];});/* harmony import */var __WEBPACK_IMPORTED_MODULE_12__selectorAll__=__webpack_require__(76);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"selectorAll",function(){return __WEBPACK_IMPORTED_MODULE_12__selectorAll__["a"];});/* harmony import */var __WEBPACK_IMPORTED_MODULE_13__selection_style__=__webpack_require__(75);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"style",function(){return __WEBPACK_IMPORTED_MODULE_13__selection_style__["a"];});/* harmony import */var __WEBPACK_IMPORTED_MODULE_14__touch__=__webpack_require__(186);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"touch",function(){return __WEBPACK_IMPORTED_MODULE_14__touch__["a"];});/* harmony import */var __WEBPACK_IMPORTED_MODULE_15__touches__=__webpack_require__(187);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"touches",function(){return __WEBPACK_IMPORTED_MODULE_15__touches__["a"];});/* harmony import */var __WEBPACK_IMPORTED_MODULE_16__window__=__webpack_require__(34);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"window",function(){return __WEBPACK_IMPORTED_MODULE_16__window__["a"];});/* harmony import */var __WEBPACK_IMPORTED_MODULE_17__selection_on__=__webpack_require__(31);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"event",function(){return __WEBPACK_IMPORTED_MODULE_17__selection_on__["a"];});/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"customEvent",function(){return __WEBPACK_IMPORTED_MODULE_17__selection_on__["b"];});/***/}),(/* 15 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__formatDecimal_js__=__webpack_require__(23);/* harmony default export */__webpack_exports__["a"]=function(x){return x=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__formatDecimal_js__["a"/* default */])(Math.abs(x)),x?x[1]:NaN;};/***/}),(/* 16 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony default export */__webpack_exports__["a"]=function(a,b){return a=+a,b-=a,function(t){return a+b*t;};};/***/}),(/* 17 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__namespace__=__webpack_require__(29);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__namespaces__=__webpack_require__(30);function creatorInherit(name){return function(){var document=this.ownerDocument,uri=this.namespaceURI;return uri===__WEBPACK_IMPORTED_MODULE_1__namespaces__["b"/* xhtml */]&&document.documentElement.namespaceURI===__WEBPACK_IMPORTED_MODULE_1__namespaces__["b"/* xhtml */]?document.createElement(name):document.createElementNS(uri,name);};}function creatorFixed(fullname){return function(){return this.ownerDocument.createElementNS(fullname.space,fullname.local);};}/* harmony default export */__webpack_exports__["a"]=function(name){var fullname=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__namespace__["a"/* default */])(name);return (fullname.local?creatorFixed:creatorInherit)(fullname);};/***/}),(/* 18 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony default export */__webpack_exports__["a"]=function(node,event){var svg=node.ownerSVGElement||node;if(svg.createSVGPoint){var point=svg.createSVGPoint();point.x=event.clientX,point.y=event.clientY;point=point.matrixTransform(node.getScreenCTM().inverse());return [point.x,point.y];}var rect=node.getBoundingClientRect();return [event.clientX-rect.left-node.clientLeft,event.clientY-rect.top-node.clientTop];};/***/}),(/* 19 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__number__=__webpack_require__(12);/* harmony default export */__webpack_exports__["a"]=function(values,p,valueof){if(valueof==null)valueof=__WEBPACK_IMPORTED_MODULE_0__number__["a"/* default */];if(!(n=values.length))return;if((p=+p)<=0||n<2)return +valueof(values[0],0,values);if(p>=1)return +valueof(values[n-1],n-1,values);var n,i=(n-1)*p,i0=Math.floor(i),value0=+valueof(values[i0],i0,values),value1=+valueof(values[i0+1],i0+1,values);return value0+(value1-value0)*(i-i0);};/***/}),(/* 20 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony export (binding) */__webpack_require__.d(__webpack_exports__,"b",function(){return prefix;});var prefix="$";function Map(){}Map.prototype=map.prototype={constructor:Map,has:function(key){return prefix+key in this;},get:function(key){return this[prefix+key];},set:function(key,value){this[prefix+key]=value;return this;},remove:function(key){var property=prefix+key;return property in this&&delete this[property];},clear:function(){for(var property in this)if(property[0]===prefix)delete this[property];},keys:function(){var keys=[];for(var property in this)if(property[0]===prefix)keys.push(property.slice(1));return keys;},values:function(){var values=[];for(var property in this)if(property[0]===prefix)values.push(this[property]);return values;},entries:function(){var entries=[];for(var property in this)if(property[0]===prefix)entries.push({key:property.slice(1),value:this[property]});return entries;},size:function(){var size=0;for(var property in this)if(property[0]===prefix)++size;return size;},empty:function(){for(var property in this)if(property[0]===prefix)return false;return true;},each:function(f){for(var property in this)if(property[0]===prefix)f(this[property],property.slice(1),this);}};function map(object,f){var map=new Map();// Copy constructor.
if(object instanceof Map)object.each(function(value,key){map.set(key,value);});// Index array by numeric index or specified key function.
else if(Array.isArray(object)){var i=-1,n=object.length,o;if(f==null)while(++i<n)map.set(i,object[i]);else while(++i<n)map.set(f(o=object[i],i,object),o);}// Convert object to map.
else if(object)for(var key in object)map.set(key,object[key]);return map;}/* harmony default export */__webpack_exports__["a"]=map;/***/}),(/* 21 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony export (immutable) */__webpack_exports__["c"]=Color;/* harmony export (binding) */__webpack_require__.d(__webpack_exports__,"e",function(){return darker;});/* harmony export (binding) */__webpack_require__.d(__webpack_exports__,"d",function(){return brighter;});/* harmony export (immutable) */__webpack_exports__["h"]=color;/* harmony export (immutable) */__webpack_exports__["b"]=rgbConvert;/* harmony export (immutable) */__webpack_exports__["g"]=rgb;/* harmony export (immutable) */__webpack_exports__["a"]=Rgb;/* unused harmony export hslConvert */ /* harmony export (immutable) */__webpack_exports__["f"]=hsl;/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__define_js__=__webpack_require__(22);function Color(){}var darker=0.7;var brighter=1/darker;var reI="\\s*([+-]?\\d+)\\s*",reN="\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",reP="\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",reHex=/^#([0-9a-f]{3,8})$/,reRgbInteger=new RegExp("^rgb\\("+[reI,reI,reI]+"\\)$"),reRgbPercent=new RegExp("^rgb\\("+[reP,reP,reP]+"\\)$"),reRgbaInteger=new RegExp("^rgba\\("+[reI,reI,reI,reN]+"\\)$"),reRgbaPercent=new RegExp("^rgba\\("+[reP,reP,reP,reN]+"\\)$"),reHslPercent=new RegExp("^hsl\\("+[reN,reP,reP]+"\\)$"),reHslaPercent=new RegExp("^hsla\\("+[reN,reP,reP,reN]+"\\)$");var named={aliceblue:0xf0f8ff,antiquewhite:0xfaebd7,aqua:0x00ffff,aquamarine:0x7fffd4,azure:0xf0ffff,beige:0xf5f5dc,bisque:0xffe4c4,black:0x000000,blanchedalmond:0xffebcd,blue:0x0000ff,blueviolet:0x8a2be2,brown:0xa52a2a,burlywood:0xdeb887,cadetblue:0x5f9ea0,chartreuse:0x7fff00,chocolate:0xd2691e,coral:0xff7f50,cornflowerblue:0x6495ed,cornsilk:0xfff8dc,crimson:0xdc143c,cyan:0x00ffff,darkblue:0x00008b,darkcyan:0x008b8b,darkgoldenrod:0xb8860b,darkgray:0xa9a9a9,darkgreen:0x006400,darkgrey:0xa9a9a9,darkkhaki:0xbdb76b,darkmagenta:0x8b008b,darkolivegreen:0x556b2f,darkorange:0xff8c00,darkorchid:0x9932cc,darkred:0x8b0000,darksalmon:0xe9967a,darkseagreen:0x8fbc8f,darkslateblue:0x483d8b,darkslategray:0x2f4f4f,darkslategrey:0x2f4f4f,darkturquoise:0x00ced1,darkviolet:0x9400d3,deeppink:0xff1493,deepskyblue:0x00bfff,dimgray:0x696969,dimgrey:0x696969,dodgerblue:0x1e90ff,firebrick:0xb22222,floralwhite:0xfffaf0,forestgreen:0x228b22,fuchsia:0xff00ff,gainsboro:0xdcdcdc,ghostwhite:0xf8f8ff,gold:0xffd700,goldenrod:0xdaa520,gray:0x808080,green:0x008000,greenyellow:0xadff2f,grey:0x808080,honeydew:0xf0fff0,hotpink:0xff69b4,indianred:0xcd5c5c,indigo:0x4b0082,ivory:0xfffff0,khaki:0xf0e68c,lavender:0xe6e6fa,lavenderblush:0xfff0f5,lawngreen:0x7cfc00,lemonchiffon:0xfffacd,lightblue:0xadd8e6,lightcoral:0xf08080,lightcyan:0xe0ffff,lightgoldenrodyellow:0xfafad2,lightgray:0xd3d3d3,lightgreen:0x90ee90,lightgrey:0xd3d3d3,lightpink:0xffb6c1,lightsalmon:0xffa07a,lightseagreen:0x20b2aa,lightskyblue:0x87cefa,lightslategray:0x778899,lightslategrey:0x778899,lightsteelblue:0xb0c4de,lightyellow:0xffffe0,lime:0x00ff00,limegreen:0x32cd32,linen:0xfaf0e6,magenta:0xff00ff,maroon:0x800000,mediumaquamarine:0x66cdaa,mediumblue:0x0000cd,mediumorchid:0xba55d3,mediumpurple:0x9370db,mediumseagreen:0x3cb371,mediumslateblue:0x7b68ee,mediumspringgreen:0x00fa9a,mediumturquoise:0x48d1cc,mediumvioletred:0xc71585,midnightblue:0x191970,mintcream:0xf5fffa,mistyrose:0xffe4e1,moccasin:0xffe4b5,navajowhite:0xffdead,navy:0x000080,oldlace:0xfdf5e6,olive:0x808000,olivedrab:0x6b8e23,orange:0xffa500,orangered:0xff4500,orchid:0xda70d6,palegoldenrod:0xeee8aa,palegreen:0x98fb98,paleturquoise:0xafeeee,palevioletred:0xdb7093,papayawhip:0xffefd5,peachpuff:0xffdab9,peru:0xcd853f,pink:0xffc0cb,plum:0xdda0dd,powderblue:0xb0e0e6,purple:0x800080,rebeccapurple:0x663399,red:0xff0000,rosybrown:0xbc8f8f,royalblue:0x4169e1,saddlebrown:0x8b4513,salmon:0xfa8072,sandybrown:0xf4a460,seagreen:0x2e8b57,seashell:0xfff5ee,sienna:0xa0522d,silver:0xc0c0c0,skyblue:0x87ceeb,slateblue:0x6a5acd,slategray:0x708090,slategrey:0x708090,snow:0xfffafa,springgreen:0x00ff7f,steelblue:0x4682b4,tan:0xd2b48c,teal:0x008080,thistle:0xd8bfd8,tomato:0xff6347,turquoise:0x40e0d0,violet:0xee82ee,wheat:0xf5deb3,white:0xffffff,whitesmoke:0xf5f5f5,yellow:0xffff00,yellowgreen:0x9acd32};__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define_js__["a"/* default */])(Color,color,{copy:function(channels){return Object.assign(new this.constructor(),this,channels);},displayable:function(){return this.rgb().displayable();},hex:color_formatHex,// Deprecated! Use color.formatHex.
formatHex:color_formatHex,formatHsl:color_formatHsl,formatRgb:color_formatRgb,toString:color_formatRgb});function color_formatHex(){return this.rgb().formatHex();}function color_formatHsl(){return hslConvert(this).formatHsl();}function color_formatRgb(){return this.rgb().formatRgb();}function color(format){var m,l;format=(format+"").trim().toLowerCase();return (m=reHex.exec(format))?(l=m[1].length,m=parseInt(m[1],16),l===6?rgbn(m)// #ff0000
:l===3?new Rgb(m>>8&0xf|m>>4&0xf0,m>>4&0xf|m&0xf0,(m&0xf)<<4|m&0xf,1)// #f00
:l===8?new Rgb(m>>24&0xff,m>>16&0xff,m>>8&0xff,(m&0xff)/0xff)// #ff000000
:l===4?new Rgb(m>>12&0xf|m>>8&0xf0,m>>8&0xf|m>>4&0xf0,m>>4&0xf|m&0xf0,((m&0xf)<<4|m&0xf)/0xff)// #f000
:null// invalid hex
):(m=reRgbInteger.exec(format))?new Rgb(m[1],m[2],m[3],1)// rgb(255, 0, 0)
:(m=reRgbPercent.exec(format))?new Rgb(m[1]*255/100,m[2]*255/100,m[3]*255/100,1)// rgb(100%, 0%, 0%)
:(m=reRgbaInteger.exec(format))?rgba(m[1],m[2],m[3],m[4])// rgba(255, 0, 0, 1)
:(m=reRgbaPercent.exec(format))?rgba(m[1]*255/100,m[2]*255/100,m[3]*255/100,m[4])// rgb(100%, 0%, 0%, 1)
:(m=reHslPercent.exec(format))?hsla(m[1],m[2]/100,m[3]/100,1)// hsl(120, 50%, 50%)
:(m=reHslaPercent.exec(format))?hsla(m[1],m[2]/100,m[3]/100,m[4])// hsla(120, 50%, 50%, 1)
:named.hasOwnProperty(format)?rgbn(named[format])// eslint-disable-line no-prototype-builtins
:format==="transparent"?new Rgb(NaN,NaN,NaN,0):null;}function rgbn(n){return new Rgb(n>>16&0xff,n>>8&0xff,n&0xff,1);}function rgba(r,g,b,a){if(a<=0)r=g=b=NaN;return new Rgb(r,g,b,a);}function rgbConvert(o){if(!(o instanceof Color))o=color(o);if(!o)return new Rgb();o=o.rgb();return new Rgb(o.r,o.g,o.b,o.opacity);}function rgb(r,g,b,opacity){return arguments.length===1?rgbConvert(r):new Rgb(r,g,b,opacity==null?1:opacity);}function Rgb(r,g,b,opacity){this.r=+r;this.g=+g;this.b=+b;this.opacity=+opacity;}__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define_js__["a"/* default */])(Rgb,rgb,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define_js__["b"/* extend */])(Color,{brighter:function(k){k=k==null?brighter:Math.pow(brighter,k);return new Rgb(this.r*k,this.g*k,this.b*k,this.opacity);},darker:function(k){k=k==null?darker:Math.pow(darker,k);return new Rgb(this.r*k,this.g*k,this.b*k,this.opacity);},rgb:function(){return this;},displayable:function(){return -0.5<=this.r&&this.r<255.5&&-0.5<=this.g&&this.g<255.5&&-0.5<=this.b&&this.b<255.5&&0<=this.opacity&&this.opacity<=1;},hex:rgb_formatHex,// Deprecated! Use color.formatHex.
formatHex:rgb_formatHex,formatRgb:rgb_formatRgb,toString:rgb_formatRgb}));function rgb_formatHex(){return "#"+hex(this.r)+hex(this.g)+hex(this.b);}function rgb_formatRgb(){var a=this.opacity;a=isNaN(a)?1:Math.max(0,Math.min(1,a));return (a===1?"rgb(":"rgba(")+Math.max(0,Math.min(255,Math.round(this.r)||0))+", "+Math.max(0,Math.min(255,Math.round(this.g)||0))+", "+Math.max(0,Math.min(255,Math.round(this.b)||0))+(a===1?")":", "+a+")");}function hex(value){value=Math.max(0,Math.min(255,Math.round(value)||0));return (value<16?"0":"")+value.toString(16);}function hsla(h,s,l,a){if(a<=0)h=s=l=NaN;else if(l<=0||l>=1)h=s=NaN;else if(s<=0)h=NaN;return new Hsl(h,s,l,a);}function hslConvert(o){if(o instanceof Hsl)return new Hsl(o.h,o.s,o.l,o.opacity);if(!(o instanceof Color))o=color(o);if(!o)return new Hsl();if(o instanceof Hsl)return o;o=o.rgb();var r=o.r/255,g=o.g/255,b=o.b/255,min=Math.min(r,g,b),max=Math.max(r,g,b),h=NaN,s=max-min,l=(max+min)/2;if(s){if(r===max)h=(g-b)/s+(g<b)*6;else if(g===max)h=(b-r)/s+2;else h=(r-g)/s+4;s/=l<0.5?max+min:2-max-min;h*=60;}else {s=l>0&&l<1?0:h;}return new Hsl(h,s,l,o.opacity);}function hsl(h,s,l,opacity){return arguments.length===1?hslConvert(h):new Hsl(h,s,l,opacity==null?1:opacity);}function Hsl(h,s,l,opacity){this.h=+h;this.s=+s;this.l=+l;this.opacity=+opacity;}__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define_js__["a"/* default */])(Hsl,hsl,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define_js__["b"/* extend */])(Color,{brighter:function(k){k=k==null?brighter:Math.pow(brighter,k);return new Hsl(this.h,this.s,this.l*k,this.opacity);},darker:function(k){k=k==null?darker:Math.pow(darker,k);return new Hsl(this.h,this.s,this.l*k,this.opacity);},rgb:function(){var h=this.h%360+(this.h<0)*360,s=isNaN(h)||isNaN(this.s)?0:this.s,l=this.l,m2=l+(l<0.5?l:1-l)*s,m1=2*l-m2;return new Rgb(hsl2rgb(h>=240?h-240:h+120,m1,m2),hsl2rgb(h,m1,m2),hsl2rgb(h<120?h+240:h-120,m1,m2),this.opacity);},displayable:function(){return (0<=this.s&&this.s<=1||isNaN(this.s))&&0<=this.l&&this.l<=1&&0<=this.opacity&&this.opacity<=1;},formatHsl:function(){var a=this.opacity;a=isNaN(a)?1:Math.max(0,Math.min(1,a));return (a===1?"hsl(":"hsla(")+(this.h||0)+", "+(this.s||0)*100+"%, "+(this.l||0)*100+"%"+(a===1?")":", "+a+")");}}));/* From FvD 13.37, CSS Color Module Level 3 */function hsl2rgb(h,m1,m2){return (h<60?m1+(m2-m1)*h/60:h<180?m2:h<240?m1+(m2-m1)*(240-h)/60:m1)*255;}/***/}),(/* 22 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony export (immutable) */__webpack_exports__["b"]=extend;/* harmony default export */__webpack_exports__["a"]=function(constructor,factory,prototype){constructor.prototype=factory.prototype=prototype;prototype.constructor=constructor;};function extend(parent,definition){var prototype=Object.create(parent.prototype);for(var key in definition)prototype[key]=definition[key];return prototype;}/***/}),(/* 23 */ /***/function(module,__webpack_exports__,__webpack_require__){// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimal(1.23) returns ["123", 0].
/* harmony default export */__webpack_exports__["a"]=function(x,p){if((i=(x=p?x.toExponential(p-1):x.toExponential()).indexOf("e"))<0)return null;// NaN, ±Infinity
var i,coefficient=x.slice(0,i);// The string returned by toExponential either has the form \d\.\d+e[-+]\d+
// (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
return [coefficient.length>1?coefficient[0]+coefficient.slice(2):coefficient,+x.slice(i+1)];};/***/}),(/* 24 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony export (immutable) */__webpack_exports__["b"]=basis;function basis(t1,v0,v1,v2,v3){var t2=t1*t1,t3=t2*t1;return ((1-3*t1+3*t2-t3)*v0+(4-6*t2+3*t3)*v1+(1+3*t1+3*t2-3*t3)*v2+t3*v3)/6;}/* harmony default export */__webpack_exports__["a"]=function(values){var n=values.length-1;return function(t){var i=t<=0?t=0:t>=1?(t=1,n-1):Math.floor(t*n),v1=values[i],v2=values[i+1],v0=i>0?values[i-1]:2*v1-v2,v3=i<n-1?values[i+2]:2*v2-v1;return basis((t-i/n)*n,v0,v1,v2,v3);};};/***/}),(/* 25 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */var __WEBPACK_IMPORTED_MODULE_0_d3_color__=__webpack_require__(10);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__rgb__=__webpack_require__(63);/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__array__=__webpack_require__(58);/* harmony import */var __WEBPACK_IMPORTED_MODULE_3__date__=__webpack_require__(61);/* harmony import */var __WEBPACK_IMPORTED_MODULE_4__number__=__webpack_require__(16);/* harmony import */var __WEBPACK_IMPORTED_MODULE_5__object__=__webpack_require__(62);/* harmony import */var __WEBPACK_IMPORTED_MODULE_6__string__=__webpack_require__(64);/* harmony import */var __WEBPACK_IMPORTED_MODULE_7__constant__=__webpack_require__(60);/* harmony default export */__webpack_exports__["a"]=function(a,b){var t=typeof b,c;return b==null||t==="boolean"?__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__constant__["a"/* default */])(b):(t==="number"?__WEBPACK_IMPORTED_MODULE_4__number__["a"/* default */]:t==="string"?(c=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f"/* color */])(b))?(b=c,__WEBPACK_IMPORTED_MODULE_1__rgb__["a"/* default */]):__WEBPACK_IMPORTED_MODULE_6__string__["a"/* default */]:b instanceof __WEBPACK_IMPORTED_MODULE_0_d3_color__["f"/* color */]?__WEBPACK_IMPORTED_MODULE_1__rgb__["a"/* default */]:b instanceof Date?__WEBPACK_IMPORTED_MODULE_3__date__["a"/* default */]:Array.isArray(b)?__WEBPACK_IMPORTED_MODULE_2__array__["a"/* default */]:typeof b.valueOf!=="function"&&typeof b.toString!=="function"||isNaN(b)?__WEBPACK_IMPORTED_MODULE_5__object__["a"/* default */]:__WEBPACK_IMPORTED_MODULE_4__number__["a"/* default */])(a,b);};/***/}),(/* 26 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony export (immutable) */__webpack_exports__["b"]=loggish;/* harmony export (immutable) */__webpack_exports__["a"]=log;/* harmony import */var __WEBPACK_IMPORTED_MODULE_0_d3_array__=__webpack_require__(3);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1_d3_format__=__webpack_require__(56);/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__nice__=__webpack_require__(65);/* harmony import */var __WEBPACK_IMPORTED_MODULE_3__continuous__=__webpack_require__(5);/* harmony import */var __WEBPACK_IMPORTED_MODULE_4__init__=__webpack_require__(1);function transformLog(x){return Math.log(x);}function transformExp(x){return Math.exp(x);}function transformLogn(x){return -Math.log(-x);}function transformExpn(x){return -Math.exp(-x);}function pow10(x){return isFinite(x)?+("1e"+x):x<0?0:x;}function powp(base){return base===10?pow10:base===Math.E?Math.exp:function(x){return Math.pow(base,x);};}function logp(base){return base===Math.E?Math.log:base===10&&Math.log10||base===2&&Math.log2||(base=Math.log(base),function(x){return Math.log(x)/base;});}function reflect(f){return function(x){return -f(-x);};}function loggish(transform){var scale=transform(transformLog,transformExp),domain=scale.domain,base=10,logs,pows;function rescale(){logs=logp(base),pows=powp(base);if(domain()[0]<0){logs=reflect(logs),pows=reflect(pows);transform(transformLogn,transformExpn);}else {transform(transformLog,transformExp);}return scale;}scale.base=function(_){return arguments.length?(base=+_,rescale()):base;};scale.domain=function(_){return arguments.length?(domain(_),rescale()):domain();};scale.ticks=function(count){var d=domain(),u=d[0],v=d[d.length-1],r;if(r=v<u)i=u,u=v,v=i;var i=logs(u),j=logs(v),p,k,t,n=count==null?10:+count,z=[];if(!(base%1)&&j-i<n){i=Math.round(i)-1,j=Math.round(j)+1;if(u>0)for(;i<j;++i){for(k=1,p=pows(i);k<base;++k){t=p*k;if(t<u)continue;if(t>v)break;z.push(t);}}else for(;i<j;++i){for(k=base-1,p=pows(i);k>=1;--k){t=p*k;if(t<u)continue;if(t>v)break;z.push(t);}}}else {z=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["c"/* ticks */])(i,j,Math.min(j-i,n)).map(pows);}return r?z.reverse():z;};scale.tickFormat=function(count,specifier){if(specifier==null)specifier=base===10?".0e":",";if(typeof specifier!=="function")specifier=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["f"/* format */])(specifier);if(count===Infinity)return specifier;if(count==null)count=10;var k=Math.max(1,base*count/scale.ticks().length);// TODO fast estimate?
return function(d){var i=d/pows(Math.round(logs(d)));if(i*base<base-0.5)i*=base;return i<=k?specifier(d):"";};};scale.nice=function(){return domain(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__nice__["a"/* default */])(domain(),{floor:function(x){return pows(Math.floor(logs(x)));},ceil:function(x){return pows(Math.ceil(logs(x)));}}));};return scale;}function log(){var scale=loggish(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__continuous__["b"/* transformer */])()).domain([1,10]);scale.copy=function(){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__continuous__["c"/* copy */])(scale,log()).base(scale.base());};__WEBPACK_IMPORTED_MODULE_4__init__["b"/* initRange */].apply(scale,arguments);return scale;}/***/}),(/* 27 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony export (immutable) */__webpack_exports__["c"]=powish;/* harmony export (immutable) */__webpack_exports__["a"]=pow;/* harmony export (immutable) */__webpack_exports__["b"]=sqrt;/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__linear__=__webpack_require__(8);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__continuous__=__webpack_require__(5);/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__init__=__webpack_require__(1);function transformPow(exponent){return function(x){return x<0?-Math.pow(-x,exponent):Math.pow(x,exponent);};}function transformSqrt(x){return x<0?-Math.sqrt(-x):Math.sqrt(x);}function transformSquare(x){return x<0?-x*x:x*x;}function powish(transform){var scale=transform(__WEBPACK_IMPORTED_MODULE_1__continuous__["a"/* identity */],__WEBPACK_IMPORTED_MODULE_1__continuous__["a"/* identity */]),exponent=1;function rescale(){return exponent===1?transform(__WEBPACK_IMPORTED_MODULE_1__continuous__["a"/* identity */],__WEBPACK_IMPORTED_MODULE_1__continuous__["a"/* identity */]):exponent===0.5?transform(transformSqrt,transformSquare):transform(transformPow(exponent),transformPow(1/exponent));}scale.exponent=function(_){return arguments.length?(exponent=+_,rescale()):exponent;};return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__linear__["b"/* linearish */])(scale);}function pow(){var scale=powish(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__continuous__["b"/* transformer */])());scale.copy=function(){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__continuous__["c"/* copy */])(scale,pow()).exponent(scale.exponent());};__WEBPACK_IMPORTED_MODULE_2__init__["b"/* initRange */].apply(scale,arguments);return scale;}function sqrt(){return pow.apply(null,arguments).exponent(0.5);}/***/}),(/* 28 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony export (immutable) */__webpack_exports__["b"]=symlogish;/* harmony export (immutable) */__webpack_exports__["a"]=symlog;/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__linear__=__webpack_require__(8);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__continuous__=__webpack_require__(5);/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__init__=__webpack_require__(1);function transformSymlog(c){return function(x){return Math.sign(x)*Math.log1p(Math.abs(x/c));};}function transformSymexp(c){return function(x){return Math.sign(x)*Math.expm1(Math.abs(x))*c;};}function symlogish(transform){var c=1,scale=transform(transformSymlog(c),transformSymexp(c));scale.constant=function(_){return arguments.length?transform(transformSymlog(c=+_),transformSymexp(c)):c;};return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__linear__["b"/* linearish */])(scale);}function symlog(){var scale=symlogish(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__continuous__["b"/* transformer */])());scale.copy=function(){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__continuous__["c"/* copy */])(scale,symlog()).constant(scale.constant());};return __WEBPACK_IMPORTED_MODULE_2__init__["b"/* initRange */].apply(scale,arguments);}/***/}),(/* 29 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__namespaces__=__webpack_require__(30);/* harmony default export */__webpack_exports__["a"]=function(name){var prefix=name+="",i=prefix.indexOf(":");if(i>=0&&(prefix=name.slice(0,i))!=="xmlns")name=name.slice(i+1);return __WEBPACK_IMPORTED_MODULE_0__namespaces__["a"/* default */].hasOwnProperty(prefix)?{space:__WEBPACK_IMPORTED_MODULE_0__namespaces__["a"/* default */][prefix],local:name}:name;};/***/}),(/* 30 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony export (binding) */__webpack_require__.d(__webpack_exports__,"b",function(){return xhtml;});var xhtml="http://www.w3.org/1999/xhtml";/* harmony default export */__webpack_exports__["a"]={svg:"http://www.w3.org/2000/svg",xhtml:xhtml,xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace",xmlns:"http://www.w3.org/2000/xmlns/"};/***/}),(/* 31 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony export (binding) */__webpack_require__.d(__webpack_exports__,"a",function(){return event;});/* harmony export (immutable) */__webpack_exports__["b"]=customEvent;var filterEvents={};var event=null;if(typeof document!=="undefined"){var element=document.documentElement;if(!("onmouseenter"in element)){filterEvents={mouseenter:"mouseover",mouseleave:"mouseout"};}}function filterContextListener(listener,index,group){listener=contextListener(listener,index,group);return function(event){var related=event.relatedTarget;if(!related||related!==this&&!(related.compareDocumentPosition(this)&8)){listener.call(this,event);}};}function contextListener(listener,index,group){return function(event1){var event0=event;// Events can be reentrant (e.g., focus).
event=event1;try{listener.call(this,this.__data__,index,group);}finally{event=event0;}};}function parseTypenames(typenames){return typenames.trim().split(/^|\s+/).map(function(t){var name="",i=t.indexOf(".");if(i>=0)name=t.slice(i+1),t=t.slice(0,i);return {type:t,name:name};});}function onRemove(typename){return function(){var on=this.__on;if(!on)return;for(var j=0,i=-1,m=on.length,o;j<m;++j){if(o=on[j],(!typename.type||o.type===typename.type)&&o.name===typename.name){this.removeEventListener(o.type,o.listener,o.capture);}else {on[++i]=o;}}if(++i)on.length=i;else delete this.__on;};}function onAdd(typename,value,capture){var wrap=filterEvents.hasOwnProperty(typename.type)?filterContextListener:contextListener;return function(d,i,group){var on=this.__on,o,listener=wrap(value,i,group);if(on)for(var j=0,m=on.length;j<m;++j){if((o=on[j]).type===typename.type&&o.name===typename.name){this.removeEventListener(o.type,o.listener,o.capture);this.addEventListener(o.type,o.listener=listener,o.capture=capture);o.value=value;return;}}this.addEventListener(typename.type,listener,capture);o={type:typename.type,name:typename.name,value:value,listener:listener,capture:capture};if(!on)this.__on=[o];else on.push(o);};}/* harmony default export */__webpack_exports__["c"]=function(typename,value,capture){var typenames=parseTypenames(typename+""),i,n=typenames.length,t;if(arguments.length<2){var on=this.node().__on;if(on)for(var j=0,m=on.length,o;j<m;++j){for(i=0,o=on[j];i<n;++i){if((t=typenames[i]).type===o.type&&t.name===o.name){return o.value;}}}return;}on=value?onAdd:onRemove;if(capture==null)capture=false;for(i=0;i<n;++i)this.each(on(typenames[i],value,capture));return this;};function customEvent(event1,listener,that,args){var event0=event;event1.sourceEvent=event;event=event1;try{return listener.apply(that,args);}finally{event=event0;}}/***/}),(/* 32 */ /***/function(module,__webpack_exports__,__webpack_require__){function none(){}/* harmony default export */__webpack_exports__["a"]=function(selector){return selector==null?none:function(){return this.querySelector(selector);};};/***/}),(/* 33 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__selection_on__=__webpack_require__(31);/* harmony default export */__webpack_exports__["a"]=function(){var current=__WEBPACK_IMPORTED_MODULE_0__selection_on__["a"/* event */],source;while(source=current.sourceEvent)current=source;return current;};/***/}),(/* 34 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony default export */__webpack_exports__["a"]=function(node){return node.ownerDocument&&node.ownerDocument.defaultView// node is a Node
||node.document&&node// node is a Window
||node.defaultView;// node is a Document
};/***/}),(/* 35 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony export (binding) */__webpack_require__.d(__webpack_exports__,"c",function(){return timeFormat;});/* unused harmony export timeParse */ /* harmony export (binding) */__webpack_require__.d(__webpack_exports__,"a",function(){return utcFormat;});/* harmony export (binding) */__webpack_require__.d(__webpack_exports__,"b",function(){return utcParse;});/* unused harmony export default */ /* harmony import */var __WEBPACK_IMPORTED_MODULE_0__locale__=__webpack_require__(79);var locale;var timeFormat;var utcFormat;var utcParse;defaultLocale({dateTime:"%x, %X",date:"%-m/%-d/%Y",time:"%-I:%M:%S %p",periods:["AM","PM"],days:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],shortDays:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],months:["January","February","March","April","May","June","July","August","September","October","November","December"],shortMonths:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"]});function defaultLocale(definition){locale=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__locale__["a"/* default */])(definition);timeFormat=locale.format;locale.parse;utcFormat=locale.utcFormat;utcParse=locale.utcParse;return locale;}/***/}),(/* 36 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */__webpack_require__(0);/* unused harmony reexport timeInterval */ /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__millisecond_js__=__webpack_require__(191);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"v",function(){return __WEBPACK_IMPORTED_MODULE_1__millisecond_js__["a"];});/* unused harmony reexport timeMilliseconds */ /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"h",function(){return __WEBPACK_IMPORTED_MODULE_1__millisecond_js__["a"];});/* unused harmony reexport utcMilliseconds */ /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__second_js__=__webpack_require__(194);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"u",function(){return __WEBPACK_IMPORTED_MODULE_2__second_js__["a"];});/* unused harmony reexport timeSeconds */ /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"g",function(){return __WEBPACK_IMPORTED_MODULE_2__second_js__["a"];});/* unused harmony reexport utcSeconds */ /* harmony import */var __WEBPACK_IMPORTED_MODULE_3__minute_js__=__webpack_require__(192);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"t",function(){return __WEBPACK_IMPORTED_MODULE_3__minute_js__["a"];});/* unused harmony reexport timeMinutes */ /* harmony import */var __WEBPACK_IMPORTED_MODULE_4__hour_js__=__webpack_require__(190);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"s",function(){return __WEBPACK_IMPORTED_MODULE_4__hour_js__["a"];});/* unused harmony reexport timeHours */ /* harmony import */var __WEBPACK_IMPORTED_MODULE_5__day_js__=__webpack_require__(189);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"k",function(){return __WEBPACK_IMPORTED_MODULE_5__day_js__["a"];});/* unused harmony reexport timeDays */ /* harmony import */var __WEBPACK_IMPORTED_MODULE_6__week_js__=__webpack_require__(201);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"r",function(){return __WEBPACK_IMPORTED_MODULE_6__week_js__["a"];});/* unused harmony reexport timeWeeks */ /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"m",function(){return __WEBPACK_IMPORTED_MODULE_6__week_js__["a"];});/* unused harmony reexport timeSundays */ /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"j",function(){return __WEBPACK_IMPORTED_MODULE_6__week_js__["b"];});/* unused harmony reexport timeMondays */ /* unused harmony reexport timeTuesday */ /* unused harmony reexport timeTuesdays */ /* unused harmony reexport timeWednesday */ /* unused harmony reexport timeWednesdays */ /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"n",function(){return __WEBPACK_IMPORTED_MODULE_6__week_js__["c"];});/* unused harmony reexport timeThursdays */ /* unused harmony reexport timeFriday */ /* unused harmony reexport timeFridays */ /* unused harmony reexport timeSaturday */ /* unused harmony reexport timeSaturdays */ /* harmony import */var __WEBPACK_IMPORTED_MODULE_7__month_js__=__webpack_require__(193);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"q",function(){return __WEBPACK_IMPORTED_MODULE_7__month_js__["a"];});/* unused harmony reexport timeMonths */ /* harmony import */var __WEBPACK_IMPORTED_MODULE_8__year_js__=__webpack_require__(202);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"l",function(){return __WEBPACK_IMPORTED_MODULE_8__year_js__["a"];});/* unused harmony reexport timeYears */ /* harmony import */var __WEBPACK_IMPORTED_MODULE_9__utcMinute_js__=__webpack_require__(197);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"f",function(){return __WEBPACK_IMPORTED_MODULE_9__utcMinute_js__["a"];});/* unused harmony reexport utcMinutes */ /* harmony import */var __WEBPACK_IMPORTED_MODULE_10__utcHour_js__=__webpack_require__(196);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"e",function(){return __WEBPACK_IMPORTED_MODULE_10__utcHour_js__["a"];});/* unused harmony reexport utcHours */ /* harmony import */var __WEBPACK_IMPORTED_MODULE_11__utcDay_js__=__webpack_require__(195);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"d",function(){return __WEBPACK_IMPORTED_MODULE_11__utcDay_js__["a"];});/* unused harmony reexport utcDays */ /* harmony import */var __WEBPACK_IMPORTED_MODULE_12__utcWeek_js__=__webpack_require__(199);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"c",function(){return __WEBPACK_IMPORTED_MODULE_12__utcWeek_js__["a"];});/* unused harmony reexport utcWeeks */ /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"o",function(){return __WEBPACK_IMPORTED_MODULE_12__utcWeek_js__["a"];});/* unused harmony reexport utcSundays */ /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"i",function(){return __WEBPACK_IMPORTED_MODULE_12__utcWeek_js__["b"];});/* unused harmony reexport utcMondays */ /* unused harmony reexport utcTuesday */ /* unused harmony reexport utcTuesdays */ /* unused harmony reexport utcWednesday */ /* unused harmony reexport utcWednesdays */ /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"p",function(){return __WEBPACK_IMPORTED_MODULE_12__utcWeek_js__["c"];});/* unused harmony reexport utcThursdays */ /* unused harmony reexport utcFriday */ /* unused harmony reexport utcFridays */ /* unused harmony reexport utcSaturday */ /* unused harmony reexport utcSaturdays */ /* harmony import */var __WEBPACK_IMPORTED_MODULE_13__utcMonth_js__=__webpack_require__(198);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"b",function(){return __WEBPACK_IMPORTED_MODULE_13__utcMonth_js__["a"];});/* unused harmony reexport utcMonths */ /* harmony import */var __WEBPACK_IMPORTED_MODULE_14__utcYear_js__=__webpack_require__(200);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"a",function(){return __WEBPACK_IMPORTED_MODULE_14__utcYear_js__["a"];});/* unused harmony reexport utcYears */ /***/}),(/* 37 */ /***/function(module,exports,__webpack_require__){/**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */var ReactPropTypesSecret='SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';module.exports=ReactPropTypesSecret;/***/}),(/* 38 */ /***/function(module,exports,__webpack_require__){Object.defineProperty(exports,"__esModule",{value:true});/** Note on viewbox/width
   * This methods only work when the pixels match the svg units.
   * when the viewbox is changed, or width is set they won't return
   * the correct results
   */ /**
   * Returns the global coordinates of a position given
   * for a specific coordinate system
   * @param {*} svgdoc
   * @param {*} elem
   * @param {*} x
   * @param {*} y
   */function toGlobalCoordinates(svgdoc,elem,x,y){var offset=svgdoc.getBoundingClientRect();var matrix=elem.getScreenCTM();return {x:matrix.a*x+matrix.c*y+matrix.e-offset.left,y:matrix.b*x+matrix.d*y+matrix.f-offset.top};}/**
   * Converts a global position to a local one
   * @param {*} svgdoc
   * @param {*} elem
   * @param {*} x
   * @param {*} y
   */function toLocalCoordinates(svgdoc,elem,x,y){var offset=svgdoc.getBoundingClientRect();var matrix=elem.getScreenCTM().inverse();return {x:matrix.a*x+matrix.c*y+matrix.e-offset.left,y:matrix.b*x+matrix.d*y+matrix.f-offset.top};}function toRadians(angle){return angle*Math.PI/180;}function getQuadrant(x,y){if(x>=0&&y>=0)return 1;if(x<=0&&y>=0)return 2;if(x<=0&&y<=0)return 3;if(x>=0&&y<=0)return 4;return 1;}/**
   * Returns the angle (degrees) given a point.
   * Assumes 0,0 as the center of the circle
   * @param {number} x
   * @param {number} y
   */function getAngleForPoint(x,y){if(x==0&&y==0)return 0;var angle=Math.atan(x/y);var angleDeg=angle*180/Math.PI;//The final value depends on the quadrant
var quadrant=getQuadrant(x,y);if(quadrant===1){angleDeg=90-angleDeg;}if(quadrant===2){angleDeg=90-angleDeg;}if(quadrant===3){angleDeg=270-angleDeg;}if(quadrant===4){angleDeg=270-angleDeg;}return angleDeg;}/**
   * Transforms the top/left variables of the rectangle
   * returned by getBoundingClientRect to document based coordinates
   * without the scroll.
   * UPDATE
   * @param {Rect} box 
   */function transformBoundingClientRectToDocument(box){var t;var scrollX=(((t=document.documentElement)||(t=document.body.parentNode))&&typeof t.scrollLeft=="number"?t:document.body).scrollLeft;var scrollY=(((t=document.documentElement)||(t=document.body.parentNode))&&typeof t.scrollTop=="number"?t:document.body).scrollTop;//This assumes width == height
var ttop=box.top-scrollY;var tleft=box.left-scrollX;//info needed to draw line from center to mousepos
return {top:ttop,left:tleft,width:box.width,height:box.height};}exports.default={toGlobalCoordinates:toGlobalCoordinates,toLocalCoordinates:toLocalCoordinates,toRadians:toRadians,getQuadrant:getQuadrant,getAngleForPoint:getAngleForPoint,transformBoundingClientRectToDocument:transformBoundingClientRectToDocument};/***/}),(/* 39 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony export (binding) */__webpack_require__.d(__webpack_exports__,"b",function(){return slice;});/* harmony export (binding) */__webpack_require__.d(__webpack_exports__,"a",function(){return map;});var array=Array.prototype;var slice=array.slice;var map=array.map;/***/}),(/* 40 */ /***/function(module,__webpack_exports__,__webpack_require__){/* unused harmony export bisectRight */ /* unused harmony export bisectLeft */ /* harmony import */var __WEBPACK_IMPORTED_MODULE_0__ascending__=__webpack_require__(9);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__bisector__=__webpack_require__(41);var ascendingBisect=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__bisector__["a"/* default */])(__WEBPACK_IMPORTED_MODULE_0__ascending__["a"/* default */]);var bisectRight=ascendingBisect.right;ascendingBisect.left;/* harmony default export */__webpack_exports__["a"]=bisectRight;/***/}),(/* 41 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__ascending__=__webpack_require__(9);/* harmony default export */__webpack_exports__["a"]=function(compare){if(compare.length===1)compare=ascendingComparator(compare);return {left:function(a,x,lo,hi){if(lo==null)lo=0;if(hi==null)hi=a.length;while(lo<hi){var mid=lo+hi>>>1;if(compare(a[mid],x)<0)lo=mid+1;else hi=mid;}return lo;},right:function(a,x,lo,hi){if(lo==null)lo=0;if(hi==null)hi=a.length;while(lo<hi){var mid=lo+hi>>>1;if(compare(a[mid],x)>0)hi=mid;else lo=mid+1;}return lo;}};};function ascendingComparator(f){return function(d,x){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ascending__["a"/* default */])(f(d),x);};}/***/}),(/* 42 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__variance__=__webpack_require__(50);/* harmony default export */__webpack_exports__["a"]=function(array,f){var v=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__variance__["a"/* default */])(array,f);return v?Math.sqrt(v):v;};/***/}),(/* 43 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony default export */__webpack_exports__["a"]=function(values,valueof){var n=values.length,i=-1,value,min,max;if(valueof==null){while(++i<n){// Find the first comparable value.
if((value=values[i])!=null&&value>=value){min=max=value;while(++i<n){// Compare the remaining values.
if((value=values[i])!=null){if(min>value)min=value;if(max<value)max=value;}}}}}else {while(++i<n){// Find the first comparable value.
if((value=valueof(values[i],i,values))!=null&&value>=value){min=max=value;while(++i<n){// Compare the remaining values.
if((value=valueof(values[i],i,values))!=null){if(min>value)min=value;if(max<value)max=value;}}}}}return [min,max];};/***/}),(/* 44 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony default export */__webpack_exports__["a"]=function(values,valueof){var n=values.length,i=-1,value,min;if(valueof==null){while(++i<n){// Find the first comparable value.
if((value=values[i])!=null&&value>=value){min=value;while(++i<n){// Compare the remaining values.
if((value=values[i])!=null&&min>value){min=value;}}}}}else {while(++i<n){// Find the first comparable value.
if((value=valueof(values[i],i,values))!=null&&value>=value){min=value;while(++i<n){// Compare the remaining values.
if((value=valueof(values[i],i,values))!=null&&min>value){min=value;}}}}}return min;};/***/}),(/* 45 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony export (immutable) */__webpack_exports__["a"]=pair;function pair(a,b){return [a,b];}/***/}),(/* 46 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony default export */__webpack_exports__["a"]=function(start,stop,step){start=+start,stop=+stop,step=(n=arguments.length)<2?(stop=start,start=0,1):n<3?1:+step;var i=-1,n=Math.max(0,Math.ceil((stop-start)/step))|0,range=new Array(n);while(++i<n){range[i]=start+i*step;}return range;};/***/}),(/* 47 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony default export */__webpack_exports__["a"]=function(values){return Math.ceil(Math.log(values.length)/Math.LN2)+1;};/***/}),(/* 48 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony export (immutable) */__webpack_exports__["c"]=tickIncrement;/* harmony export (immutable) */__webpack_exports__["a"]=tickStep;var e10=Math.sqrt(50),e5=Math.sqrt(10),e2=Math.sqrt(2);/* harmony default export */__webpack_exports__["b"]=function(start,stop,count){var reverse,i=-1,n,ticks,step;stop=+stop,start=+start,count=+count;if(start===stop&&count>0)return [start];if(reverse=stop<start)n=start,start=stop,stop=n;if((step=tickIncrement(start,stop,count))===0||!isFinite(step))return [];if(step>0){start=Math.ceil(start/step);stop=Math.floor(stop/step);ticks=new Array(n=Math.ceil(stop-start+1));while(++i<n)ticks[i]=(start+i)*step;}else {start=Math.floor(start*step);stop=Math.ceil(stop*step);ticks=new Array(n=Math.ceil(start-stop+1));while(++i<n)ticks[i]=(start-i)/step;}if(reverse)ticks.reverse();return ticks;};function tickIncrement(start,stop,count){var step=(stop-start)/Math.max(0,count),power=Math.floor(Math.log(step)/Math.LN10),error=step/Math.pow(10,power);return power>=0?(error>=e10?10:error>=e5?5:error>=e2?2:1)*Math.pow(10,power):-Math.pow(10,-power)/(error>=e10?10:error>=e5?5:error>=e2?2:1);}function tickStep(start,stop,count){var step0=Math.abs(stop-start)/Math.max(0,count),step1=Math.pow(10,Math.floor(Math.log(step0)/Math.LN10)),error=step0/step1;if(error>=e10)step1*=10;else if(error>=e5)step1*=5;else if(error>=e2)step1*=2;return stop<start?-step1:step1;}/***/}),(/* 49 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__min__=__webpack_require__(44);/* harmony default export */__webpack_exports__["a"]=function(matrix){if(!(n=matrix.length))return [];for(var i=-1,m=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__min__["a"/* default */])(matrix,length),transpose=new Array(m);++i<m;){for(var j=-1,n,row=transpose[i]=new Array(n);++j<n;){row[j]=matrix[j][i];}}return transpose;};function length(d){return d.length;}/***/}),(/* 50 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__number__=__webpack_require__(12);/* harmony default export */__webpack_exports__["a"]=function(values,valueof){var n=values.length,m=0,i=-1,mean=0,value,delta,sum=0;if(valueof==null){while(++i<n){if(!isNaN(value=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a"/* default */])(values[i]))){delta=value-mean;mean+=delta/++m;sum+=delta*(value-mean);}}}else {while(++i<n){if(!isNaN(value=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a"/* default */])(valueof(values[i],i,values)))){delta=value-mean;mean+=delta/++m;sum+=delta*(value-mean);}}}if(m>1)return sum/(m-1);};/***/}),(/* 51 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony export (binding) */__webpack_require__.d(__webpack_exports__,"b",function(){return deg2rad;});/* harmony export (binding) */__webpack_require__.d(__webpack_exports__,"a",function(){return rad2deg;});var deg2rad=Math.PI/180;var rad2deg=180/Math.PI;/***/}),(/* 52 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony export (immutable) */__webpack_exports__["b"]=yesdrag;/* harmony import */var __WEBPACK_IMPORTED_MODULE_0_d3_selection__=__webpack_require__(14);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__noevent_js__=__webpack_require__(53);/* harmony default export */__webpack_exports__["a"]=function(view){var root=view.document.documentElement,selection=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["select"])(view).on("dragstart.drag",__WEBPACK_IMPORTED_MODULE_1__noevent_js__["a"/* default */],true);if("onselectstart"in root){selection.on("selectstart.drag",__WEBPACK_IMPORTED_MODULE_1__noevent_js__["a"/* default */],true);}else {root.__noselect=root.style.MozUserSelect;root.style.MozUserSelect="none";}};function yesdrag(view,noclick){var root=view.document.documentElement,selection=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["select"])(view).on("dragstart.drag",null);if(noclick){selection.on("click.drag",__WEBPACK_IMPORTED_MODULE_1__noevent_js__["a"/* default */],true);setTimeout(function(){selection.on("click.drag",null);},0);}if("onselectstart"in root){selection.on("selectstart.drag",null);}else {root.style.MozUserSelect=root.__noselect;delete root.__noselect;}}/***/}),(/* 53 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony export (immutable) */__webpack_exports__["b"]=nopropagation;/* harmony import */var __WEBPACK_IMPORTED_MODULE_0_d3_selection__=__webpack_require__(14);function nopropagation(){__WEBPACK_IMPORTED_MODULE_0_d3_selection__["event"].stopImmediatePropagation();}/* harmony default export */__webpack_exports__["a"]=function(){__WEBPACK_IMPORTED_MODULE_0_d3_selection__["event"].preventDefault();__WEBPACK_IMPORTED_MODULE_0_d3_selection__["event"].stopImmediatePropagation();};/***/}),(/* 54 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony export (binding) */__webpack_require__.d(__webpack_exports__,"a",function(){return prefixExponent;});/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__formatDecimal_js__=__webpack_require__(23);var prefixExponent;/* harmony default export */__webpack_exports__["b"]=function(x,p){var d=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__formatDecimal_js__["a"/* default */])(x,p);if(!d)return x+"";var coefficient=d[0],exponent=d[1],i=exponent-(prefixExponent=Math.max(-8,Math.min(8,Math.floor(exponent/3)))*3)+1,n=coefficient.length;return i===n?coefficient:i>n?coefficient+new Array(i-n+1).join("0"):i>0?coefficient.slice(0,i)+"."+coefficient.slice(i):"0."+new Array(1-i).join("0")+__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__formatDecimal_js__["a"/* default */])(x,Math.max(0,p+i-1))[0];// less than 1y!
};/***/}),(/* 55 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony export (immutable) */__webpack_exports__["a"]=formatSpecifier;/* unused harmony export FormatSpecifier */ // [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var re=/^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;function formatSpecifier(specifier){if(!(match=re.exec(specifier)))throw new Error("invalid format: "+specifier);var match;return new FormatSpecifier({fill:match[1],align:match[2],sign:match[3],symbol:match[4],zero:match[5],width:match[6],comma:match[7],precision:match[8]&&match[8].slice(1),trim:match[9],type:match[10]});}formatSpecifier.prototype=FormatSpecifier.prototype;// instanceof
function FormatSpecifier(specifier){this.fill=specifier.fill===undefined?" ":specifier.fill+"";this.align=specifier.align===undefined?">":specifier.align+"";this.sign=specifier.sign===undefined?"-":specifier.sign+"";this.symbol=specifier.symbol===undefined?"":specifier.symbol+"";this.zero=!!specifier.zero;this.width=specifier.width===undefined?undefined:+specifier.width;this.comma=!!specifier.comma;this.precision=specifier.precision===undefined?undefined:+specifier.precision;this.trim=!!specifier.trim;this.type=specifier.type===undefined?"":specifier.type+"";}FormatSpecifier.prototype.toString=function(){return this.fill+this.align+this.sign+this.symbol+(this.zero?"0":"")+(this.width===undefined?"":Math.max(1,this.width|0))+(this.comma?",":"")+(this.precision===undefined?"":"."+Math.max(0,this.precision|0))+(this.trim?"~":"")+this.type;};/***/}),(/* 56 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__defaultLocale_js__=__webpack_require__(120);/* unused harmony reexport formatDefaultLocale */ /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"f",function(){return __WEBPACK_IMPORTED_MODULE_0__defaultLocale_js__["a"];});/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"c",function(){return __WEBPACK_IMPORTED_MODULE_0__defaultLocale_js__["b"];});/* harmony import */__webpack_require__(57);/* unused harmony reexport formatLocale */ /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__formatSpecifier_js__=__webpack_require__(55);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"a",function(){return __WEBPACK_IMPORTED_MODULE_2__formatSpecifier_js__["a"];});/* unused harmony reexport FormatSpecifier */ /* harmony import */var __WEBPACK_IMPORTED_MODULE_3__precisionFixed_js__=__webpack_require__(127);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"e",function(){return __WEBPACK_IMPORTED_MODULE_3__precisionFixed_js__["a"];});/* harmony import */var __WEBPACK_IMPORTED_MODULE_4__precisionPrefix_js__=__webpack_require__(128);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"b",function(){return __WEBPACK_IMPORTED_MODULE_4__precisionPrefix_js__["a"];});/* harmony import */var __WEBPACK_IMPORTED_MODULE_5__precisionRound_js__=__webpack_require__(129);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"d",function(){return __WEBPACK_IMPORTED_MODULE_5__precisionRound_js__["a"];});/***/}),(/* 57 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__exponent_js__=__webpack_require__(15);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__formatGroup_js__=__webpack_require__(121);/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__formatNumerals_js__=__webpack_require__(122);/* harmony import */var __WEBPACK_IMPORTED_MODULE_3__formatSpecifier_js__=__webpack_require__(55);/* harmony import */var __WEBPACK_IMPORTED_MODULE_4__formatTrim_js__=__webpack_require__(124);/* harmony import */var __WEBPACK_IMPORTED_MODULE_5__formatTypes_js__=__webpack_require__(125);/* harmony import */var __WEBPACK_IMPORTED_MODULE_6__formatPrefixAuto_js__=__webpack_require__(54);/* harmony import */var __WEBPACK_IMPORTED_MODULE_7__identity_js__=__webpack_require__(126);var map=Array.prototype.map,prefixes=["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];/* harmony default export */__webpack_exports__["a"]=function(locale){var group=locale.grouping===undefined||locale.thousands===undefined?__WEBPACK_IMPORTED_MODULE_7__identity_js__["a"/* default */]:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__formatGroup_js__["a"/* default */])(map.call(locale.grouping,Number),locale.thousands+""),currencyPrefix=locale.currency===undefined?"":locale.currency[0]+"",currencySuffix=locale.currency===undefined?"":locale.currency[1]+"",decimal=locale.decimal===undefined?".":locale.decimal+"",numerals=locale.numerals===undefined?__WEBPACK_IMPORTED_MODULE_7__identity_js__["a"/* default */]:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__formatNumerals_js__["a"/* default */])(map.call(locale.numerals,String)),percent=locale.percent===undefined?"%":locale.percent+"",minus=locale.minus===undefined?"-":locale.minus+"",nan=locale.nan===undefined?"NaN":locale.nan+"";function newFormat(specifier){specifier=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__formatSpecifier_js__["a"/* default */])(specifier);var fill=specifier.fill,align=specifier.align,sign=specifier.sign,symbol=specifier.symbol,zero=specifier.zero,width=specifier.width,comma=specifier.comma,precision=specifier.precision,trim=specifier.trim,type=specifier.type;// The "n" type is an alias for ",g".
if(type==="n")comma=true,type="g";// The "" type, and any invalid type, is an alias for ".12~g".
else if(!__WEBPACK_IMPORTED_MODULE_5__formatTypes_js__["a"/* default */][type])precision===undefined&&(precision=12),trim=true,type="g";// If zero fill is specified, padding goes after sign and before digits.
if(zero||fill==="0"&&align==="=")zero=true,fill="0",align="=";// Compute the prefix and suffix.
// For SI-prefix, the suffix is lazily computed.
var prefix=symbol==="$"?currencyPrefix:symbol==="#"&&/[boxX]/.test(type)?"0"+type.toLowerCase():"",suffix=symbol==="$"?currencySuffix:/[%p]/.test(type)?percent:"";// What format function should we use?
// Is this an integer type?
// Can this type generate exponential notation?
var formatType=__WEBPACK_IMPORTED_MODULE_5__formatTypes_js__["a"/* default */][type],maybeSuffix=/[defgprs%]/.test(type);// Set the default precision if not specified,
// or clamp the specified precision to the supported range.
// For significant precision, it must be in [1, 21].
// For fixed precision, it must be in [0, 20].
precision=precision===undefined?6:/[gprs]/.test(type)?Math.max(1,Math.min(21,precision)):Math.max(0,Math.min(20,precision));function format(value){var valuePrefix=prefix,valueSuffix=suffix,i,n,c;if(type==="c"){valueSuffix=formatType(value)+valueSuffix;value="";}else {value=+value;// Perform the initial formatting.
var valueNegative=value<0;value=isNaN(value)?nan:formatType(Math.abs(value),precision);// Trim insignificant zeros.
if(trim)value=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__formatTrim_js__["a"/* default */])(value);// If a negative value rounds to zero during formatting, treat as positive.
if(valueNegative&&+value===0)valueNegative=false;// Compute the prefix and suffix.
valuePrefix=(valueNegative?sign==="("?sign:minus:sign==="-"||sign==="("?"":sign)+valuePrefix;valueSuffix=(type==="s"?prefixes[8+__WEBPACK_IMPORTED_MODULE_6__formatPrefixAuto_js__["a"/* prefixExponent */]/3]:"")+valueSuffix+(valueNegative&&sign==="("?")":"");// Break the formatted value into the integer “value” part that can be
// grouped, and fractional or exponential “suffix” part that is not.
if(maybeSuffix){i=-1,n=value.length;while(++i<n){if(c=value.charCodeAt(i),48>c||c>57){valueSuffix=(c===46?decimal+value.slice(i+1):value.slice(i))+valueSuffix;value=value.slice(0,i);break;}}}}// If the fill character is not "0", grouping is applied before padding.
if(comma&&!zero)value=group(value,Infinity);// Compute the padding.
var length=valuePrefix.length+value.length+valueSuffix.length,padding=length<width?new Array(width-length+1).join(fill):"";// If the fill character is "0", grouping is applied after padding.
if(comma&&zero)value=group(padding+value,padding.length?width-valueSuffix.length:Infinity),padding="";// Reconstruct the final output based on the desired alignment.
switch(align){case"<":value=valuePrefix+value+valueSuffix+padding;break;case"=":value=valuePrefix+padding+value+valueSuffix;break;case"^":value=padding.slice(0,length=padding.length>>1)+valuePrefix+value+valueSuffix+padding.slice(length);break;default:value=padding+valuePrefix+value+valueSuffix;break;}return numerals(value);}format.toString=function(){return specifier+"";};return format;}function formatPrefix(specifier,value){var f=newFormat((specifier=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__formatSpecifier_js__["a"/* default */])(specifier),specifier.type="f",specifier)),e=Math.max(-8,Math.min(8,Math.floor(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent_js__["a"/* default */])(value)/3)))*3,k=Math.pow(10,-e),prefix=prefixes[8+e/3];return function(value){return f(k*value)+prefix;};}return {format:newFormat,formatPrefix:formatPrefix};};/***/}),(/* 58 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__value__=__webpack_require__(25);/* harmony default export */__webpack_exports__["a"]=function(a,b){var nb=b?b.length:0,na=a?Math.min(nb,a.length):0,x=new Array(na),c=new Array(nb),i;for(i=0;i<na;++i)x[i]=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__value__["a"/* default */])(a[i],b[i]);for(;i<nb;++i)c[i]=b[i];return function(t){for(i=0;i<na;++i)c[i]=x[i](t);return c;};};/***/}),(/* 59 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__basis__=__webpack_require__(24);/* harmony default export */__webpack_exports__["a"]=function(values){var n=values.length;return function(t){var i=Math.floor(((t%=1)<0?++t:t)*n),v0=values[(i+n-1)%n],v1=values[i%n],v2=values[(i+1)%n],v3=values[(i+2)%n];return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__basis__["b"/* basis */])((t-i/n)*n,v0,v1,v2,v3);};};/***/}),(/* 60 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony default export */__webpack_exports__["a"]=function(x){return function(){return x;};};/***/}),(/* 61 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony default export */__webpack_exports__["a"]=function(a,b){var d=new Date();return a=+a,b-=a,function(t){return d.setTime(a+b*t),d;};};/***/}),(/* 62 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__value__=__webpack_require__(25);/* harmony default export */__webpack_exports__["a"]=function(a,b){var i={},c={},k;if(a===null||typeof a!=="object")a={};if(b===null||typeof b!=="object")b={};for(k in b){if(k in a){i[k]=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__value__["a"/* default */])(a[k],b[k]);}else {c[k]=b[k];}}return function(t){for(k in i)c[k]=i[k](t);return c;};};/***/}),(/* 63 */ /***/function(module,__webpack_exports__,__webpack_require__){/* unused harmony export rgbBasis */ /* unused harmony export rgbBasisClosed */ /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_d3_color__=__webpack_require__(10);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__basis__=__webpack_require__(24);/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__basisClosed__=__webpack_require__(59);/* harmony import */var __WEBPACK_IMPORTED_MODULE_3__color__=__webpack_require__(11);/* harmony default export */__webpack_exports__["a"]=function rgbGamma(y){var color=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__color__["c"/* gamma */])(y);function rgb(start,end){var r=color((start=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e"/* rgb */])(start)).r,(end=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e"/* rgb */])(end)).r),g=color(start.g,end.g),b=color(start.b,end.b),opacity=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__color__["a"/* default */])(start.opacity,end.opacity);return function(t){start.r=r(t);start.g=g(t);start.b=b(t);start.opacity=opacity(t);return start+"";};}rgb.gamma=rgbGamma;return rgb;}(1);function rgbSpline(spline){return function(colors){var n=colors.length,r=new Array(n),g=new Array(n),b=new Array(n),i,color;for(i=0;i<n;++i){color=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e"/* rgb */])(colors[i]);r[i]=color.r||0;g[i]=color.g||0;b[i]=color.b||0;}r=spline(r);g=spline(g);b=spline(b);color.opacity=1;return function(t){color.r=r(t);color.g=g(t);color.b=b(t);return color+"";};};}rgbSpline(__WEBPACK_IMPORTED_MODULE_1__basis__["a"/* default */]);rgbSpline(__WEBPACK_IMPORTED_MODULE_2__basisClosed__["a"/* default */]);/***/}),(/* 64 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__number__=__webpack_require__(16);var reA=/[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,reB=new RegExp(reA.source,"g");function zero(b){return function(){return b;};}function one(b){return function(t){return b(t)+"";};}/* harmony default export */__webpack_exports__["a"]=function(a,b){var bi=reA.lastIndex=reB.lastIndex=0,// scan index for next number in b
am,// current match in a
bm,// current match in b
bs,// string preceding current number in b, if any
i=-1,// index in s
s=[],// string constants and placeholders
q=[];// number interpolators
// Coerce inputs to strings.
a=a+"",b=b+"";// Interpolate pairs of numbers in a & b.
while((am=reA.exec(a))&&(bm=reB.exec(b))){if((bs=bm.index)>bi){// a string precedes the next number in b
bs=b.slice(bi,bs);if(s[i])s[i]+=bs;// coalesce with previous string
else s[++i]=bs;}if((am=am[0])===(bm=bm[0])){// numbers in a & b match
if(s[i])s[i]+=bm;// coalesce with previous string
else s[++i]=bm;}else {// interpolate non-matching numbers
s[++i]=null;q.push({i:i,x:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a"/* default */])(am,bm)});}bi=reB.lastIndex;}// Add remains of b.
if(bi<b.length){bs=b.slice(bi);if(s[i])s[i]+=bs;// coalesce with previous string
else s[++i]=bs;}// Special optimization for only a single match.
// Otherwise, interpolate each of the numbers and rejoin the string.
return s.length<2?q[0]?one(q[0].x):zero(b):(b=q.length,function(t){for(var i=0,o;i<b;++i)s[(o=q[i]).i]=o.x(t);return s.join("");});};/***/}),(/* 65 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony default export */__webpack_exports__["a"]=function(domain,interval){domain=domain.slice();var i0=0,i1=domain.length-1,x0=domain[i0],x1=domain[i1],t;if(x1<x0){t=i0,i0=i1,i1=t;t=x0,x0=x1,x1=t;}domain[i0]=interval.floor(x0);domain[i1]=interval.ceil(x1);return domain;};/***/}),(/* 66 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony default export */__webpack_exports__["a"]=function(x){return +x;};/***/}),(/* 67 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony export (binding) */__webpack_require__.d(__webpack_exports__,"b",function(){return implicit;});/* harmony export (immutable) */__webpack_exports__["a"]=ordinal;/* harmony import */var __WEBPACK_IMPORTED_MODULE_0_d3_collection__=__webpack_require__(108);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__array__=__webpack_require__(7);/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__init__=__webpack_require__(1);var implicit={name:"implicit"};function ordinal(){var index=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["a"/* map */])(),domain=[],range=[],unknown=implicit;function scale(d){var key=d+"",i=index.get(key);if(!i){if(unknown!==implicit)return unknown;index.set(key,i=domain.push(d));}return range[(i-1)%range.length];}scale.domain=function(_){if(!arguments.length)return domain.slice();domain=[],index=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["a"/* map */])();var i=-1,n=_.length,d,key;while(++i<n)if(!index.has(key=(d=_[i])+""))index.set(key,domain.push(d));return scale;};scale.range=function(_){return arguments.length?(range=__WEBPACK_IMPORTED_MODULE_1__array__["b"/* slice */].call(_),scale):range.slice();};scale.unknown=function(_){return arguments.length?(unknown=_,scale):unknown;};scale.copy=function(){return ordinal(domain,range).unknown(unknown);};__WEBPACK_IMPORTED_MODULE_2__init__["b"/* initRange */].apply(scale,arguments);return scale;}/***/}),(/* 68 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony export (immutable) */__webpack_exports__["f"]=copy;/* harmony export (immutable) */__webpack_exports__["a"]=sequential;/* harmony export (immutable) */__webpack_exports__["b"]=sequentialLog;/* harmony export (immutable) */__webpack_exports__["e"]=sequentialSymlog;/* harmony export (immutable) */__webpack_exports__["c"]=sequentialPow;/* harmony export (immutable) */__webpack_exports__["d"]=sequentialSqrt;/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__continuous__=__webpack_require__(5);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__init__=__webpack_require__(1);/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__linear__=__webpack_require__(8);/* harmony import */var __WEBPACK_IMPORTED_MODULE_3__log__=__webpack_require__(26);/* harmony import */var __WEBPACK_IMPORTED_MODULE_4__symlog__=__webpack_require__(28);/* harmony import */var __WEBPACK_IMPORTED_MODULE_5__pow__=__webpack_require__(27);function transformer(){var x0=0,x1=1,t0,t1,k10,transform,interpolator=__WEBPACK_IMPORTED_MODULE_0__continuous__["a"/* identity */],clamp=false,unknown;function scale(x){return isNaN(x=+x)?unknown:interpolator(k10===0?0.5:(x=(transform(x)-t0)*k10,clamp?Math.max(0,Math.min(1,x)):x));}scale.domain=function(_){return arguments.length?(t0=transform(x0=+_[0]),t1=transform(x1=+_[1]),k10=t0===t1?0:1/(t1-t0),scale):[x0,x1];};scale.clamp=function(_){return arguments.length?(clamp=!!_,scale):clamp;};scale.interpolator=function(_){return arguments.length?(interpolator=_,scale):interpolator;};scale.unknown=function(_){return arguments.length?(unknown=_,scale):unknown;};return function(t){transform=t,t0=t(x0),t1=t(x1),k10=t0===t1?0:1/(t1-t0);return scale;};}function copy(source,target){return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());}function sequential(){var scale=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__linear__["b"/* linearish */])(transformer()(__WEBPACK_IMPORTED_MODULE_0__continuous__["a"/* identity */]));scale.copy=function(){return copy(scale,sequential());};return __WEBPACK_IMPORTED_MODULE_1__init__["a"/* initInterpolator */].apply(scale,arguments);}function sequentialLog(){var scale=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__log__["b"/* loggish */])(transformer()).domain([1,10]);scale.copy=function(){return copy(scale,sequentialLog()).base(scale.base());};return __WEBPACK_IMPORTED_MODULE_1__init__["a"/* initInterpolator */].apply(scale,arguments);}function sequentialSymlog(){var scale=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__symlog__["b"/* symlogish */])(transformer());scale.copy=function(){return copy(scale,sequentialSymlog()).constant(scale.constant());};return __WEBPACK_IMPORTED_MODULE_1__init__["a"/* initInterpolator */].apply(scale,arguments);}function sequentialPow(){var scale=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__pow__["c"/* powish */])(transformer());scale.copy=function(){return copy(scale,sequentialPow()).exponent(scale.exponent());};return __WEBPACK_IMPORTED_MODULE_1__init__["a"/* initInterpolator */].apply(scale,arguments);}function sequentialSqrt(){return sequentialPow.apply(null,arguments).exponent(0.5);}/***/}),(/* 69 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */var __WEBPACK_IMPORTED_MODULE_0_d3_array__=__webpack_require__(3);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1_d3_format__=__webpack_require__(56);/* harmony default export */__webpack_exports__["a"]=function(start,stop,count,specifier){var step=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["a"/* tickStep */])(start,stop,count),precision;specifier=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["a"/* formatSpecifier */])(specifier==null?",f":specifier);switch(specifier.type){case"s":{var value=Math.max(Math.abs(start),Math.abs(stop));if(specifier.precision==null&&!isNaN(precision=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["b"/* precisionPrefix */])(step,value)))specifier.precision=precision;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["c"/* formatPrefix */])(specifier,value);}case"":case"e":case"g":case"p":case"r":{if(specifier.precision==null&&!isNaN(precision=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["d"/* precisionRound */])(step,Math.max(Math.abs(start),Math.abs(stop)))))specifier.precision=precision-(specifier.type==="e");break;}case"f":case"%":{if(specifier.precision==null&&!isNaN(precision=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["e"/* precisionFixed */])(step)))specifier.precision=precision-(specifier.type==="%")*2;break;}}return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["f"/* format */])(specifier);};/***/}),(/* 70 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony export (immutable) */__webpack_exports__["b"]=calendar;/* harmony import */var __WEBPACK_IMPORTED_MODULE_0_d3_array__=__webpack_require__(3);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1_d3_time__=__webpack_require__(36);/* harmony import */var __WEBPACK_IMPORTED_MODULE_2_d3_time_format__=__webpack_require__(77);/* harmony import */var __WEBPACK_IMPORTED_MODULE_3__array__=__webpack_require__(7);/* harmony import */var __WEBPACK_IMPORTED_MODULE_4__continuous__=__webpack_require__(5);/* harmony import */var __WEBPACK_IMPORTED_MODULE_5__init__=__webpack_require__(1);/* harmony import */var __WEBPACK_IMPORTED_MODULE_6__nice__=__webpack_require__(65);var durationSecond=1000,durationMinute=durationSecond*60,durationHour=durationMinute*60,durationDay=durationHour*24,durationWeek=durationDay*7,durationMonth=durationDay*30,durationYear=durationDay*365;function date(t){return new Date(t);}function number(t){return t instanceof Date?+t:+new Date(+t);}function calendar(year,month,week,day,hour,minute,second,millisecond,format){var scale=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__continuous__["d"/* default */])(__WEBPACK_IMPORTED_MODULE_4__continuous__["a"/* identity */],__WEBPACK_IMPORTED_MODULE_4__continuous__["a"/* identity */]),invert=scale.invert,domain=scale.domain;var formatMillisecond=format(".%L"),formatSecond=format(":%S"),formatMinute=format("%I:%M"),formatHour=format("%I %p"),formatDay=format("%a %d"),formatWeek=format("%b %d"),formatMonth=format("%B"),formatYear=format("%Y");var tickIntervals=[[second,1,durationSecond],[second,5,5*durationSecond],[second,15,15*durationSecond],[second,30,30*durationSecond],[minute,1,durationMinute],[minute,5,5*durationMinute],[minute,15,15*durationMinute],[minute,30,30*durationMinute],[hour,1,durationHour],[hour,3,3*durationHour],[hour,6,6*durationHour],[hour,12,12*durationHour],[day,1,durationDay],[day,2,2*durationDay],[week,1,durationWeek],[month,1,durationMonth],[month,3,3*durationMonth],[year,1,durationYear]];function tickFormat(date){return (second(date)<date?formatMillisecond:minute(date)<date?formatSecond:hour(date)<date?formatMinute:day(date)<date?formatHour:month(date)<date?week(date)<date?formatDay:formatWeek:year(date)<date?formatMonth:formatYear)(date);}function tickInterval(interval,start,stop,step){if(interval==null)interval=10;// If a desired tick count is specified, pick a reasonable tick interval
// based on the extent of the domain and a rough estimate of tick size.
// Otherwise, assume interval is already a time interval and use it.
if(typeof interval==="number"){var target=Math.abs(stop-start)/interval,i=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["f"/* bisector */])(function(i){return i[2];}).right(tickIntervals,target);if(i===tickIntervals.length){step=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["a"/* tickStep */])(start/durationYear,stop/durationYear,interval);interval=year;}else if(i){i=tickIntervals[target/tickIntervals[i-1][2]<tickIntervals[i][2]/target?i-1:i];step=i[1];interval=i[0];}else {step=Math.max(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["a"/* tickStep */])(start,stop,interval),1);interval=millisecond;}}return step==null?interval:interval.every(step);}scale.invert=function(y){return new Date(invert(y));};scale.domain=function(_){return arguments.length?domain(__WEBPACK_IMPORTED_MODULE_3__array__["a"/* map */].call(_,number)):domain().map(date);};scale.ticks=function(interval,step){var d=domain(),t0=d[0],t1=d[d.length-1],r=t1<t0,t;if(r)t=t0,t0=t1,t1=t;t=tickInterval(interval,t0,t1,step);t=t?t.range(t0,t1+1):[];// inclusive stop
return r?t.reverse():t;};scale.tickFormat=function(count,specifier){return specifier==null?tickFormat:format(specifier);};scale.nice=function(interval,step){var d=domain();return (interval=tickInterval(interval,d[0],d[d.length-1],step))?domain(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__nice__["a"/* default */])(d,interval)):scale;};scale.copy=function(){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__continuous__["c"/* copy */])(scale,calendar(year,month,week,day,hour,minute,second,millisecond,format));};return scale;}/* harmony default export */__webpack_exports__["a"]=function(){return __WEBPACK_IMPORTED_MODULE_5__init__["b"/* initRange */].apply(calendar(__WEBPACK_IMPORTED_MODULE_1_d3_time__["l"/* timeYear */],__WEBPACK_IMPORTED_MODULE_1_d3_time__["q"/* timeMonth */],__WEBPACK_IMPORTED_MODULE_1_d3_time__["r"/* timeWeek */],__WEBPACK_IMPORTED_MODULE_1_d3_time__["k"/* timeDay */],__WEBPACK_IMPORTED_MODULE_1_d3_time__["s"/* timeHour */],__WEBPACK_IMPORTED_MODULE_1_d3_time__["t"/* timeMinute */],__WEBPACK_IMPORTED_MODULE_1_d3_time__["u"/* timeSecond */],__WEBPACK_IMPORTED_MODULE_1_d3_time__["v"/* timeMillisecond */],__WEBPACK_IMPORTED_MODULE_2_d3_time_format__["b"/* timeFormat */]).domain([new Date(2000,0,1),new Date(2000,0,2)]),arguments);};/***/}),(/* 71 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony default export */__webpack_exports__["a"]=function(selector){return function(){return this.matches(selector);};};/***/}),(/* 72 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__selection_index__=__webpack_require__(2);/* harmony default export */__webpack_exports__["a"]=function(selector){return typeof selector==="string"?new __WEBPACK_IMPORTED_MODULE_0__selection_index__["b"/* Selection */]([[document.querySelector(selector)]],[document.documentElement]):new __WEBPACK_IMPORTED_MODULE_0__selection_index__["b"/* Selection */]([[selector]],__WEBPACK_IMPORTED_MODULE_0__selection_index__["c"/* root */]);};/***/}),(/* 73 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony export (immutable) */__webpack_exports__["b"]=EnterNode;/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__sparse__=__webpack_require__(74);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__index__=__webpack_require__(2);/* harmony default export */__webpack_exports__["a"]=function(){return new __WEBPACK_IMPORTED_MODULE_1__index__["b"/* Selection */](this._enter||this._groups.map(__WEBPACK_IMPORTED_MODULE_0__sparse__["a"/* default */]),this._parents);};function EnterNode(parent,datum){this.ownerDocument=parent.ownerDocument;this.namespaceURI=parent.namespaceURI;this._next=null;this._parent=parent;this.__data__=datum;}EnterNode.prototype={constructor:EnterNode,appendChild:function(child){return this._parent.insertBefore(child,this._next);},insertBefore:function(child,next){return this._parent.insertBefore(child,next);},querySelector:function(selector){return this._parent.querySelector(selector);},querySelectorAll:function(selector){return this._parent.querySelectorAll(selector);}};/***/}),(/* 74 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony default export */__webpack_exports__["a"]=function(update){return new Array(update.length);};/***/}),(/* 75 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony export (immutable) */__webpack_exports__["a"]=styleValue;/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__window__=__webpack_require__(34);function styleRemove(name){return function(){this.style.removeProperty(name);};}function styleConstant(name,value,priority){return function(){this.style.setProperty(name,value,priority);};}function styleFunction(name,value,priority){return function(){var v=value.apply(this,arguments);if(v==null)this.style.removeProperty(name);else this.style.setProperty(name,v,priority);};}/* harmony default export */__webpack_exports__["b"]=function(name,value,priority){return arguments.length>1?this.each((value==null?styleRemove:typeof value==="function"?styleFunction:styleConstant)(name,value,priority==null?"":priority)):styleValue(this.node(),name);};function styleValue(node,name){return node.style.getPropertyValue(name)||__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__window__["a"/* default */])(node).getComputedStyle(node,null).getPropertyValue(name);}/***/}),(/* 76 */ /***/function(module,__webpack_exports__,__webpack_require__){function empty(){return [];}/* harmony default export */__webpack_exports__["a"]=function(selector){return selector==null?empty:function(){return this.querySelectorAll(selector);};};/***/}),(/* 77 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__defaultLocale__=__webpack_require__(35);/* unused harmony reexport timeFormatDefaultLocale */ /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"b",function(){return __WEBPACK_IMPORTED_MODULE_0__defaultLocale__["c"];});/* unused harmony reexport timeParse */ /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"a",function(){return __WEBPACK_IMPORTED_MODULE_0__defaultLocale__["a"];});/* unused harmony reexport utcParse */ /* harmony import */__webpack_require__(79);/* unused harmony reexport timeFormatLocale */ /* harmony import */__webpack_require__(78);/* unused harmony reexport isoFormat */ /* harmony import */__webpack_require__(188);/* unused harmony reexport isoParse */ /***/}),(/* 78 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony export (binding) */__webpack_require__.d(__webpack_exports__,"a",function(){return isoSpecifier;});/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__defaultLocale__=__webpack_require__(35);var isoSpecifier="%Y-%m-%dT%H:%M:%S.%LZ";function formatIsoNative(date){return date.toISOString();}Date.prototype.toISOString?formatIsoNative:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__defaultLocale__["a"/* utcFormat */])(isoSpecifier);/***/}),(/* 79 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony export (immutable) */__webpack_exports__["a"]=formatLocale;/* harmony import */var __WEBPACK_IMPORTED_MODULE_0_d3_time__=__webpack_require__(36);function localDate(d){if(0<=d.y&&d.y<100){var date=new Date(-1,d.m,d.d,d.H,d.M,d.S,d.L);date.setFullYear(d.y);return date;}return new Date(d.y,d.m,d.d,d.H,d.M,d.S,d.L);}function utcDate(d){if(0<=d.y&&d.y<100){var date=new Date(Date.UTC(-1,d.m,d.d,d.H,d.M,d.S,d.L));date.setUTCFullYear(d.y);return date;}return new Date(Date.UTC(d.y,d.m,d.d,d.H,d.M,d.S,d.L));}function newYear(y){return {y:y,m:0,d:1,H:0,M:0,S:0,L:0};}function formatLocale(locale){var locale_dateTime=locale.dateTime,locale_date=locale.date,locale_time=locale.time,locale_periods=locale.periods,locale_weekdays=locale.days,locale_shortWeekdays=locale.shortDays,locale_months=locale.months,locale_shortMonths=locale.shortMonths;var periodRe=formatRe(locale_periods),periodLookup=formatLookup(locale_periods),weekdayRe=formatRe(locale_weekdays),weekdayLookup=formatLookup(locale_weekdays),shortWeekdayRe=formatRe(locale_shortWeekdays),shortWeekdayLookup=formatLookup(locale_shortWeekdays),monthRe=formatRe(locale_months),monthLookup=formatLookup(locale_months),shortMonthRe=formatRe(locale_shortMonths),shortMonthLookup=formatLookup(locale_shortMonths);var formats={"a":formatShortWeekday,"A":formatWeekday,"b":formatShortMonth,"B":formatMonth,"c":null,"d":formatDayOfMonth,"e":formatDayOfMonth,"f":formatMicroseconds,"H":formatHour24,"I":formatHour12,"j":formatDayOfYear,"L":formatMilliseconds,"m":formatMonthNumber,"M":formatMinutes,"p":formatPeriod,"Q":formatUnixTimestamp,"s":formatUnixTimestampSeconds,"S":formatSeconds,"u":formatWeekdayNumberMonday,"U":formatWeekNumberSunday,"V":formatWeekNumberISO,"w":formatWeekdayNumberSunday,"W":formatWeekNumberMonday,"x":null,"X":null,"y":formatYear,"Y":formatFullYear,"Z":formatZone,"%":formatLiteralPercent};var utcFormats={"a":formatUTCShortWeekday,"A":formatUTCWeekday,"b":formatUTCShortMonth,"B":formatUTCMonth,"c":null,"d":formatUTCDayOfMonth,"e":formatUTCDayOfMonth,"f":formatUTCMicroseconds,"H":formatUTCHour24,"I":formatUTCHour12,"j":formatUTCDayOfYear,"L":formatUTCMilliseconds,"m":formatUTCMonthNumber,"M":formatUTCMinutes,"p":formatUTCPeriod,"Q":formatUnixTimestamp,"s":formatUnixTimestampSeconds,"S":formatUTCSeconds,"u":formatUTCWeekdayNumberMonday,"U":formatUTCWeekNumberSunday,"V":formatUTCWeekNumberISO,"w":formatUTCWeekdayNumberSunday,"W":formatUTCWeekNumberMonday,"x":null,"X":null,"y":formatUTCYear,"Y":formatUTCFullYear,"Z":formatUTCZone,"%":formatLiteralPercent};var parses={"a":parseShortWeekday,"A":parseWeekday,"b":parseShortMonth,"B":parseMonth,"c":parseLocaleDateTime,"d":parseDayOfMonth,"e":parseDayOfMonth,"f":parseMicroseconds,"H":parseHour24,"I":parseHour24,"j":parseDayOfYear,"L":parseMilliseconds,"m":parseMonthNumber,"M":parseMinutes,"p":parsePeriod,"Q":parseUnixTimestamp,"s":parseUnixTimestampSeconds,"S":parseSeconds,"u":parseWeekdayNumberMonday,"U":parseWeekNumberSunday,"V":parseWeekNumberISO,"w":parseWeekdayNumberSunday,"W":parseWeekNumberMonday,"x":parseLocaleDate,"X":parseLocaleTime,"y":parseYear,"Y":parseFullYear,"Z":parseZone,"%":parseLiteralPercent};// These recursive directive definitions must be deferred.
formats.x=newFormat(locale_date,formats);formats.X=newFormat(locale_time,formats);formats.c=newFormat(locale_dateTime,formats);utcFormats.x=newFormat(locale_date,utcFormats);utcFormats.X=newFormat(locale_time,utcFormats);utcFormats.c=newFormat(locale_dateTime,utcFormats);function newFormat(specifier,formats){return function(date){var string=[],i=-1,j=0,n=specifier.length,c,pad,format;if(!(date instanceof Date))date=new Date(+date);while(++i<n){if(specifier.charCodeAt(i)===37){string.push(specifier.slice(j,i));if((pad=pads[c=specifier.charAt(++i)])!=null)c=specifier.charAt(++i);else pad=c==="e"?" ":"0";if(format=formats[c])c=format(date,pad);string.push(c);j=i+1;}}string.push(specifier.slice(j,i));return string.join("");};}function newParse(specifier,newDate){return function(string){var d=newYear(1900),i=parseSpecifier(d,specifier,string+="",0),week,day;if(i!=string.length)return null;// If a UNIX timestamp is specified, return it.
if("Q"in d)return new Date(d.Q);// The am-pm flag is 0 for AM, and 1 for PM.
if("p"in d)d.H=d.H%12+d.p*12;// Convert day-of-week and week-of-year to day-of-year.
if("V"in d){if(d.V<1||d.V>53)return null;if(!("w"in d))d.w=1;if("Z"in d){week=utcDate(newYear(d.y)),day=week.getUTCDay();week=day>4||day===0?__WEBPACK_IMPORTED_MODULE_0_d3_time__["i"/* utcMonday */].ceil(week):__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["i"/* utcMonday */])(week);week=__WEBPACK_IMPORTED_MODULE_0_d3_time__["d"/* utcDay */].offset(week,(d.V-1)*7);d.y=week.getUTCFullYear();d.m=week.getUTCMonth();d.d=week.getUTCDate()+(d.w+6)%7;}else {week=newDate(newYear(d.y)),day=week.getDay();week=day>4||day===0?__WEBPACK_IMPORTED_MODULE_0_d3_time__["j"/* timeMonday */].ceil(week):__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["j"/* timeMonday */])(week);week=__WEBPACK_IMPORTED_MODULE_0_d3_time__["k"/* timeDay */].offset(week,(d.V-1)*7);d.y=week.getFullYear();d.m=week.getMonth();d.d=week.getDate()+(d.w+6)%7;}}else if("W"in d||"U"in d){if(!("w"in d))d.w="u"in d?d.u%7:"W"in d?1:0;day="Z"in d?utcDate(newYear(d.y)).getUTCDay():newDate(newYear(d.y)).getDay();d.m=0;d.d="W"in d?(d.w+6)%7+d.W*7-(day+5)%7:d.w+d.U*7-(day+6)%7;}// If a time zone is specified, all fields are interpreted as UTC and then
// offset according to the specified time zone.
if("Z"in d){d.H+=d.Z/100|0;d.M+=d.Z%100;return utcDate(d);}// Otherwise, all fields are in local time.
return newDate(d);};}function parseSpecifier(d,specifier,string,j){var i=0,n=specifier.length,m=string.length,c,parse;while(i<n){if(j>=m)return -1;c=specifier.charCodeAt(i++);if(c===37){c=specifier.charAt(i++);parse=parses[c in pads?specifier.charAt(i++):c];if(!parse||(j=parse(d,string,j))<0)return -1;}else if(c!=string.charCodeAt(j++)){return -1;}}return j;}function parsePeriod(d,string,i){var n=periodRe.exec(string.slice(i));return n?(d.p=periodLookup[n[0].toLowerCase()],i+n[0].length):-1;}function parseShortWeekday(d,string,i){var n=shortWeekdayRe.exec(string.slice(i));return n?(d.w=shortWeekdayLookup[n[0].toLowerCase()],i+n[0].length):-1;}function parseWeekday(d,string,i){var n=weekdayRe.exec(string.slice(i));return n?(d.w=weekdayLookup[n[0].toLowerCase()],i+n[0].length):-1;}function parseShortMonth(d,string,i){var n=shortMonthRe.exec(string.slice(i));return n?(d.m=shortMonthLookup[n[0].toLowerCase()],i+n[0].length):-1;}function parseMonth(d,string,i){var n=monthRe.exec(string.slice(i));return n?(d.m=monthLookup[n[0].toLowerCase()],i+n[0].length):-1;}function parseLocaleDateTime(d,string,i){return parseSpecifier(d,locale_dateTime,string,i);}function parseLocaleDate(d,string,i){return parseSpecifier(d,locale_date,string,i);}function parseLocaleTime(d,string,i){return parseSpecifier(d,locale_time,string,i);}function formatShortWeekday(d){return locale_shortWeekdays[d.getDay()];}function formatWeekday(d){return locale_weekdays[d.getDay()];}function formatShortMonth(d){return locale_shortMonths[d.getMonth()];}function formatMonth(d){return locale_months[d.getMonth()];}function formatPeriod(d){return locale_periods[+(d.getHours()>=12)];}function formatUTCShortWeekday(d){return locale_shortWeekdays[d.getUTCDay()];}function formatUTCWeekday(d){return locale_weekdays[d.getUTCDay()];}function formatUTCShortMonth(d){return locale_shortMonths[d.getUTCMonth()];}function formatUTCMonth(d){return locale_months[d.getUTCMonth()];}function formatUTCPeriod(d){return locale_periods[+(d.getUTCHours()>=12)];}return {format:function(specifier){var f=newFormat(specifier+="",formats);f.toString=function(){return specifier;};return f;},parse:function(specifier){var p=newParse(specifier+="",localDate);p.toString=function(){return specifier;};return p;},utcFormat:function(specifier){var f=newFormat(specifier+="",utcFormats);f.toString=function(){return specifier;};return f;},utcParse:function(specifier){var p=newParse(specifier,utcDate);p.toString=function(){return specifier;};return p;}};}var pads={"-":"","_":" ","0":"0"},numberRe=/^\s*\d+/,// note: ignores next directive
percentRe=/^%/,requoteRe=/[\\^$*+?|[\]().{}]/g;function pad(value,fill,width){var sign=value<0?"-":"",string=(sign?-value:value)+"",length=string.length;return sign+(length<width?new Array(width-length+1).join(fill)+string:string);}function requote(s){return s.replace(requoteRe,"\\$&");}function formatRe(names){return new RegExp("^(?:"+names.map(requote).join("|")+")","i");}function formatLookup(names){var map={},i=-1,n=names.length;while(++i<n)map[names[i].toLowerCase()]=i;return map;}function parseWeekdayNumberSunday(d,string,i){var n=numberRe.exec(string.slice(i,i+1));return n?(d.w=+n[0],i+n[0].length):-1;}function parseWeekdayNumberMonday(d,string,i){var n=numberRe.exec(string.slice(i,i+1));return n?(d.u=+n[0],i+n[0].length):-1;}function parseWeekNumberSunday(d,string,i){var n=numberRe.exec(string.slice(i,i+2));return n?(d.U=+n[0],i+n[0].length):-1;}function parseWeekNumberISO(d,string,i){var n=numberRe.exec(string.slice(i,i+2));return n?(d.V=+n[0],i+n[0].length):-1;}function parseWeekNumberMonday(d,string,i){var n=numberRe.exec(string.slice(i,i+2));return n?(d.W=+n[0],i+n[0].length):-1;}function parseFullYear(d,string,i){var n=numberRe.exec(string.slice(i,i+4));return n?(d.y=+n[0],i+n[0].length):-1;}function parseYear(d,string,i){var n=numberRe.exec(string.slice(i,i+2));return n?(d.y=+n[0]+(+n[0]>68?1900:2000),i+n[0].length):-1;}function parseZone(d,string,i){var n=/^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i,i+6));return n?(d.Z=n[1]?0:-(n[2]+(n[3]||"00")),i+n[0].length):-1;}function parseMonthNumber(d,string,i){var n=numberRe.exec(string.slice(i,i+2));return n?(d.m=n[0]-1,i+n[0].length):-1;}function parseDayOfMonth(d,string,i){var n=numberRe.exec(string.slice(i,i+2));return n?(d.d=+n[0],i+n[0].length):-1;}function parseDayOfYear(d,string,i){var n=numberRe.exec(string.slice(i,i+3));return n?(d.m=0,d.d=+n[0],i+n[0].length):-1;}function parseHour24(d,string,i){var n=numberRe.exec(string.slice(i,i+2));return n?(d.H=+n[0],i+n[0].length):-1;}function parseMinutes(d,string,i){var n=numberRe.exec(string.slice(i,i+2));return n?(d.M=+n[0],i+n[0].length):-1;}function parseSeconds(d,string,i){var n=numberRe.exec(string.slice(i,i+2));return n?(d.S=+n[0],i+n[0].length):-1;}function parseMilliseconds(d,string,i){var n=numberRe.exec(string.slice(i,i+3));return n?(d.L=+n[0],i+n[0].length):-1;}function parseMicroseconds(d,string,i){var n=numberRe.exec(string.slice(i,i+6));return n?(d.L=Math.floor(n[0]/1000),i+n[0].length):-1;}function parseLiteralPercent(d,string,i){var n=percentRe.exec(string.slice(i,i+1));return n?i+n[0].length:-1;}function parseUnixTimestamp(d,string,i){var n=numberRe.exec(string.slice(i));return n?(d.Q=+n[0],i+n[0].length):-1;}function parseUnixTimestampSeconds(d,string,i){var n=numberRe.exec(string.slice(i));return n?(d.Q=+n[0]*1000,i+n[0].length):-1;}function formatDayOfMonth(d,p){return pad(d.getDate(),p,2);}function formatHour24(d,p){return pad(d.getHours(),p,2);}function formatHour12(d,p){return pad(d.getHours()%12||12,p,2);}function formatDayOfYear(d,p){return pad(1+__WEBPACK_IMPORTED_MODULE_0_d3_time__["k"/* timeDay */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["l"/* timeYear */])(d),d),p,3);}function formatMilliseconds(d,p){return pad(d.getMilliseconds(),p,3);}function formatMicroseconds(d,p){return formatMilliseconds(d,p)+"000";}function formatMonthNumber(d,p){return pad(d.getMonth()+1,p,2);}function formatMinutes(d,p){return pad(d.getMinutes(),p,2);}function formatSeconds(d,p){return pad(d.getSeconds(),p,2);}function formatWeekdayNumberMonday(d){var day=d.getDay();return day===0?7:day;}function formatWeekNumberSunday(d,p){return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["m"/* timeSunday */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["l"/* timeYear */])(d),d),p,2);}function formatWeekNumberISO(d,p){var day=d.getDay();d=day>=4||day===0?__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["n"/* timeThursday */])(d):__WEBPACK_IMPORTED_MODULE_0_d3_time__["n"/* timeThursday */].ceil(d);return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["n"/* timeThursday */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["l"/* timeYear */])(d),d)+(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["l"/* timeYear */])(d).getDay()===4),p,2);}function formatWeekdayNumberSunday(d){return d.getDay();}function formatWeekNumberMonday(d,p){return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["j"/* timeMonday */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["l"/* timeYear */])(d),d),p,2);}function formatYear(d,p){return pad(d.getFullYear()%100,p,2);}function formatFullYear(d,p){return pad(d.getFullYear()%10000,p,4);}function formatZone(d){var z=d.getTimezoneOffset();return (z>0?"-":(z*=-1,"+"))+pad(z/60|0,"0",2)+pad(z%60,"0",2);}function formatUTCDayOfMonth(d,p){return pad(d.getUTCDate(),p,2);}function formatUTCHour24(d,p){return pad(d.getUTCHours(),p,2);}function formatUTCHour12(d,p){return pad(d.getUTCHours()%12||12,p,2);}function formatUTCDayOfYear(d,p){return pad(1+__WEBPACK_IMPORTED_MODULE_0_d3_time__["d"/* utcDay */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["a"/* utcYear */])(d),d),p,3);}function formatUTCMilliseconds(d,p){return pad(d.getUTCMilliseconds(),p,3);}function formatUTCMicroseconds(d,p){return formatUTCMilliseconds(d,p)+"000";}function formatUTCMonthNumber(d,p){return pad(d.getUTCMonth()+1,p,2);}function formatUTCMinutes(d,p){return pad(d.getUTCMinutes(),p,2);}function formatUTCSeconds(d,p){return pad(d.getUTCSeconds(),p,2);}function formatUTCWeekdayNumberMonday(d){var dow=d.getUTCDay();return dow===0?7:dow;}function formatUTCWeekNumberSunday(d,p){return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["o"/* utcSunday */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["a"/* utcYear */])(d),d),p,2);}function formatUTCWeekNumberISO(d,p){var day=d.getUTCDay();d=day>=4||day===0?__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["p"/* utcThursday */])(d):__WEBPACK_IMPORTED_MODULE_0_d3_time__["p"/* utcThursday */].ceil(d);return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["p"/* utcThursday */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["a"/* utcYear */])(d),d)+(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["a"/* utcYear */])(d).getUTCDay()===4),p,2);}function formatUTCWeekdayNumberSunday(d){return d.getUTCDay();}function formatUTCWeekNumberMonday(d,p){return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["i"/* utcMonday */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["a"/* utcYear */])(d),d),p,2);}function formatUTCYear(d,p){return pad(d.getUTCFullYear()%100,p,2);}function formatUTCFullYear(d,p){return pad(d.getUTCFullYear()%10000,p,4);}function formatUTCZone(){return "+0000";}function formatLiteralPercent(){return "%";}function formatUnixTimestamp(d){return +d;}function formatUnixTimestampSeconds(d){return Math.floor(+d/1000);}/***/}),(/* 80 */ /***/function(module,exports,__webpack_require__){/* WEBPACK VAR INJECTION */(function(process){if(process.env.NODE_ENV==='production'){module.exports=__webpack_require__(209);}else {module.exports=__webpack_require__(208);}/* WEBPACK VAR INJECTION */}).call(exports,__webpack_require__(13));/***/}),(/* 81 */ /***/function(module,exports,__webpack_require__){Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(6);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var InternalInput=function(_React$Component){_inherits(InternalInput,_React$Component);function InternalInput(){_classCallCheck(this,InternalInput);return _possibleConstructorReturn(this,(InternalInput.__proto__||Object.getPrototypeOf(InternalInput)).apply(this,arguments));}_createClass(InternalInput,[{key:"render",value:function render(){var props=this.props;var hideStyle={};function onValChange(ev){props.onChange(Number(ev.target.value));}var value=props.value,min=props.min,max=props.max,step=props.step;props.onChange;var inputRef=props.inputRef,rest=_objectWithoutProperties(props,["value","min","max","step","onChange","inputRef"]);return _react2.default.createElement("input",_extends({ref:inputRef,value:value,step:step,onChange:onValChange,style:hideStyle,type:"range",min:min,max:max},rest));}}]);return InternalInput;}(_react2.default.Component);InternalInput.defaultProps={step:1};exports.default=InternalInput;/***/}),(/* 82 */ /***/function(module,exports,__webpack_require__){Object.defineProperty(exports,"__esModule",{value:true});exports.KnobVisualHelpers=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(6);var _react2=_interopRequireDefault(_react);var _HelpersOverlay=__webpack_require__(89);var _HelpersOverlay2=_interopRequireDefault(_HelpersOverlay);var _DrawCircle=__webpack_require__(87);var _DrawCircle2=_interopRequireDefault(_DrawCircle);var _DrawLine=__webpack_require__(88);var _DrawLine2=_interopRequireDefault(_DrawLine);var _utils=__webpack_require__(38);var _utils2=_interopRequireDefault(_utils);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/** Precision visual helpers */ /**
   * Precision mode visual helpers
   */var KnobVisualHelpers=function(_React$Component){_inherits(KnobVisualHelpers,_React$Component);function KnobVisualHelpers(){var _ref;var _temp,_this,_ret;_classCallCheck(this,KnobVisualHelpers);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=KnobVisualHelpers.__proto__||Object.getPrototypeOf(KnobVisualHelpers)).call.apply(_ref,[this].concat(args))),_this),_this.state={centerX:0,centerY:0,valueMarkerX:0,valueMarkerY:0},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(KnobVisualHelpers,[{key:"render",value:function render(){var markCircleColor=this.props.minimumDragDistance<=this.props.radius?"green":"grey";var fillColor=this.props.minimumDragDistance<=this.props.radius?"#88E22D":"#D8D8D8";var minDistanceCueVisible=this.props.minimumDragDistance>=this.props.radius;return _react2.default.createElement(_HelpersOverlay2.default,null,_react2.default.createElement("svg",{style:{position:"absolute",top:"0",left:"0"},width:"100%",height:"100%"},_react2.default.createElement("defs",null,_react2.default.createElement("marker",{id:"Triangle",viewBox:"0 0 10 10",refX:"1",refY:"5",markerWidth:"6",markerHeight:"6",orient:"auto"},_react2.default.createElement("path",{d:"M 0 0 L 10 5 L 0 10 z"}))),_react2.default.createElement(_DrawCircle2.default,{borderColor:markCircleColor,fillColor:fillColor,fillOpacity:0.02,r:this.props.radius,cx:this.state.centerX,cy:this.state.centerY}),minDistanceCueVisible&&_react2.default.createElement(_DrawCircle2.default,{borderColor:markCircleColor,fillColor:fillColor,fillOpacity:0,r:this.props.minimumDragDistance,cx:this.state.centerX,cy:this.state.centerY,strokeDasharray:"5, 5"}),_react2.default.createElement(_DrawLine2.default,{p1:{x:this.state.centerX,y:this.state.centerY},p2:{x:this.state.valueMarkerX+this.state.centerX,y:this.state.valueMarkerY+this.state.centerY},markerEnd:"url(#Triangle)"})));}}],[{key:"getDerivedStateFromProps",value:function getDerivedStateFromProps(props,state){//Calculate position
var vbox=props.svgRef.getBoundingClientRect();var halfWidth=vbox.width/2;//Calculate current angle segment end point
//Note: Not sure why we need to substract 90 here
var valueMarkerX=props.radius*Math.cos(_utils2.default.toRadians(props.valueAngle-90));var valueMarkerY=props.radius*Math.sin(_utils2.default.toRadians(props.valueAngle-90));return _extends({},state,{centerX:vbox.left+halfWidth,centerY:vbox.top+halfWidth,valueMarkerX:valueMarkerX,valueMarkerY:valueMarkerY});}}]);return KnobVisualHelpers;}(_react2.default.Component);exports.KnobVisualHelpers=KnobVisualHelpers;/***/}),(/* 83 */ /***/function(module,exports,__webpack_require__){Object.defineProperty(exports,"__esModule",{value:true});exports.default={knobX:71,knobY:71,svg:"\n\n<svg width=\"204px\" height=\"204px\" viewBox=\"0 0 204 204\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <!-- Generator: Sketch 47.1 (45422) - http://www.bohemiancoding.com/sketch -->\n    <desc>Created with Sketch.</desc>\n    <defs>\n        <linearGradient x1=\"50%\" y1=\"50%\" x2=\"50%\" y2=\"100%\" id=\"linearGradient-1\">\n            <stop stop-color=\"#444040\" stop-opacity=\"0.51098279\" offset=\"0%\"></stop>\n            <stop stop-color=\"#131111\" stop-opacity=\"0.893200861\" offset=\"100%\"></stop>\n        </linearGradient>\n        <circle id=\"path-2\" cx=\"98.0400009\" cy=\"98.0400009\" r=\"98.0400009\"></circle>\n        <filter x=\"-3.3%\" y=\"-3.3%\" width=\"106.6%\" height=\"106.6%\" filterUnits=\"objectBoundingBox\" id=\"filter-3\">\n            <feMorphology radius=\"0.5\" operator=\"dilate\" in=\"SourceAlpha\" result=\"shadowSpreadOuter1\"></feMorphology>\n            <feOffset dx=\"0\" dy=\"0\" in=\"shadowSpreadOuter1\" result=\"shadowOffsetOuter1\"></feOffset>\n            <feGaussianBlur stdDeviation=\"2\" in=\"shadowOffsetOuter1\" result=\"shadowBlurOuter1\"></feGaussianBlur>\n            <feComposite in=\"shadowBlurOuter1\" in2=\"SourceAlpha\" operator=\"out\" result=\"shadowBlurOuter1\"></feComposite>\n            <feColorMatrix values=\"0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0\" type=\"matrix\" in=\"shadowBlurOuter1\"></feColorMatrix>\n        </filter>\n        <linearGradient x1=\"50%\" y1=\"0%\" x2=\"50%\" y2=\"100%\" id=\"linearGradient-4\">\n            <stop stop-color=\"#FFFFFF\" stop-opacity=\"0.5\" offset=\"0%\"></stop>\n            <stop stop-color=\"#000000\" stop-opacity=\"0.5\" offset=\"100%\"></stop>\n        </linearGradient>\n        <circle id=\"path-5\" cx=\"98\" cy=\"98\" r=\"86\"></circle>\n        <filter x=\"-4.1%\" y=\"-3.5%\" width=\"108.1%\" height=\"108.1%\" filterUnits=\"objectBoundingBox\" id=\"filter-6\">\n            <feMorphology radius=\"0.5\" operator=\"dilate\" in=\"SourceAlpha\" result=\"shadowSpreadOuter1\"></feMorphology>\n            <feOffset dx=\"0\" dy=\"1\" in=\"shadowSpreadOuter1\" result=\"shadowOffsetOuter1\"></feOffset>\n            <feGaussianBlur stdDeviation=\"2\" in=\"shadowOffsetOuter1\" result=\"shadowBlurOuter1\"></feGaussianBlur>\n            <feComposite in=\"shadowBlurOuter1\" in2=\"SourceAlpha\" operator=\"out\" result=\"shadowBlurOuter1\"></feComposite>\n            <feColorMatrix values=\"0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0\" type=\"matrix\" in=\"shadowBlurOuter1\"></feColorMatrix>\n        </filter>\n    </defs>\n    <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"s13\" transform=\"translate(4.000000, 4.000000)\">\n            <g id=\"container\">\n                <g id=\"Oval-2\">\n                    <use fill=\"black\" fill-opacity=\"1\" filter=\"url(#filter-3)\" xlink:href=\"#path-2\"></use>\n                    <use stroke=\"#979797\" stroke-width=\"1\" fill=\"url(#linearGradient-1)\" fill-rule=\"evenodd\" xlink:href=\"#path-2\"></use>\n                </g>\n                <g id=\"Oval-2\">\n                    <use fill=\"black\" fill-opacity=\"1\" filter=\"url(#filter-6)\" xlink:href=\"#path-5\"></use>\n                    <use fill=\"\" fill-rule=\"evenodd\" xlink:href=\"#path-5\"></use>\n                    <use stroke=\"#4A4A4A\" stroke-width=\"1\" fill=\"url(#linearGradient-4)\" fill-rule=\"evenodd\" xlink:href=\"#path-5\"></use>\n                </g>\n                <g id=\"knob\" transform=\"translate(27.431373, 27.431373)\">\n                    <circle id=\"Oval-5\" fill=\"#322E2E\" cx=\"71\" cy=\"71\" r=\"71\"></circle>\n                    <path d=\"M70.0686275,4.17063061 L86.5686275,65.2689929 C81.3642501,66.811221 75.8642501,67.5735686 70.0686275,67.5560356 C64.2730048,67.5385027 58.7730048,66.7761551 53.5686275,65.2689929 L70.0686275,4.17063061 Z\" id=\"Rectangle-Copy\" fill=\"#E6D7D7\" transform=\"translate(70.068627, 35.863481) scale(1, -1) translate(-70.068627, -35.863481) \"></path>\n                </g>\n            </g>\n        </g>\n    </g>\n</svg>\n"};/***/}),(/* 84 */ /***/function(module,__webpack_exports__,__webpack_require__){Object.defineProperty(__webpack_exports__,"__esModule",{value:true});/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__drag_js__=__webpack_require__(118);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"drag",function(){return __WEBPACK_IMPORTED_MODULE_0__drag_js__["a"];});/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__nodrag_js__=__webpack_require__(52);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"dragDisable",function(){return __WEBPACK_IMPORTED_MODULE_1__nodrag_js__["a"];});/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"dragEnable",function(){return __WEBPACK_IMPORTED_MODULE_1__nodrag_js__["b"];});/***/}),(/* 85 */ /***/function(module,__webpack_exports__,__webpack_require__){Object.defineProperty(__webpack_exports__,"__esModule",{value:true});/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__band__=__webpack_require__(144);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"scaleBand",function(){return __WEBPACK_IMPORTED_MODULE_0__band__["a"];});/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"scalePoint",function(){return __WEBPACK_IMPORTED_MODULE_0__band__["b"];});/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__identity__=__webpack_require__(147);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"scaleIdentity",function(){return __WEBPACK_IMPORTED_MODULE_1__identity__["a"];});/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__linear__=__webpack_require__(8);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"scaleLinear",function(){return __WEBPACK_IMPORTED_MODULE_2__linear__["a"];});/* harmony import */var __WEBPACK_IMPORTED_MODULE_3__log__=__webpack_require__(26);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"scaleLog",function(){return __WEBPACK_IMPORTED_MODULE_3__log__["a"];});/* harmony import */var __WEBPACK_IMPORTED_MODULE_4__symlog__=__webpack_require__(28);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"scaleSymlog",function(){return __WEBPACK_IMPORTED_MODULE_4__symlog__["a"];});/* harmony import */var __WEBPACK_IMPORTED_MODULE_5__ordinal__=__webpack_require__(67);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"scaleOrdinal",function(){return __WEBPACK_IMPORTED_MODULE_5__ordinal__["a"];});/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"scaleImplicit",function(){return __WEBPACK_IMPORTED_MODULE_5__ordinal__["b"];});/* harmony import */var __WEBPACK_IMPORTED_MODULE_6__pow__=__webpack_require__(27);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"scalePow",function(){return __WEBPACK_IMPORTED_MODULE_6__pow__["a"];});/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"scaleSqrt",function(){return __WEBPACK_IMPORTED_MODULE_6__pow__["b"];});/* harmony import */var __WEBPACK_IMPORTED_MODULE_7__quantile__=__webpack_require__(148);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"scaleQuantile",function(){return __WEBPACK_IMPORTED_MODULE_7__quantile__["a"];});/* harmony import */var __WEBPACK_IMPORTED_MODULE_8__quantize__=__webpack_require__(149);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"scaleQuantize",function(){return __WEBPACK_IMPORTED_MODULE_8__quantize__["a"];});/* harmony import */var __WEBPACK_IMPORTED_MODULE_9__threshold__=__webpack_require__(151);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"scaleThreshold",function(){return __WEBPACK_IMPORTED_MODULE_9__threshold__["a"];});/* harmony import */var __WEBPACK_IMPORTED_MODULE_10__time__=__webpack_require__(70);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"scaleTime",function(){return __WEBPACK_IMPORTED_MODULE_10__time__["a"];});/* harmony import */var __WEBPACK_IMPORTED_MODULE_11__utcTime__=__webpack_require__(152);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"scaleUtc",function(){return __WEBPACK_IMPORTED_MODULE_11__utcTime__["a"];});/* harmony import */var __WEBPACK_IMPORTED_MODULE_12__sequential__=__webpack_require__(68);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"scaleSequential",function(){return __WEBPACK_IMPORTED_MODULE_12__sequential__["a"];});/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"scaleSequentialLog",function(){return __WEBPACK_IMPORTED_MODULE_12__sequential__["b"];});/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"scaleSequentialPow",function(){return __WEBPACK_IMPORTED_MODULE_12__sequential__["c"];});/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"scaleSequentialSqrt",function(){return __WEBPACK_IMPORTED_MODULE_12__sequential__["d"];});/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"scaleSequentialSymlog",function(){return __WEBPACK_IMPORTED_MODULE_12__sequential__["e"];});/* harmony import */var __WEBPACK_IMPORTED_MODULE_13__sequentialQuantile__=__webpack_require__(150);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"scaleSequentialQuantile",function(){return __WEBPACK_IMPORTED_MODULE_13__sequentialQuantile__["a"];});/* harmony import */var __WEBPACK_IMPORTED_MODULE_14__diverging__=__webpack_require__(146);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"scaleDiverging",function(){return __WEBPACK_IMPORTED_MODULE_14__diverging__["a"];});/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"scaleDivergingLog",function(){return __WEBPACK_IMPORTED_MODULE_14__diverging__["b"];});/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"scaleDivergingPow",function(){return __WEBPACK_IMPORTED_MODULE_14__diverging__["c"];});/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"scaleDivergingSqrt",function(){return __WEBPACK_IMPORTED_MODULE_14__diverging__["d"];});/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"scaleDivergingSymlog",function(){return __WEBPACK_IMPORTED_MODULE_14__diverging__["e"];});/* harmony import */var __WEBPACK_IMPORTED_MODULE_15__tickFormat__=__webpack_require__(69);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"tickFormat",function(){return __WEBPACK_IMPORTED_MODULE_15__tickFormat__["a"];});/***/}),(/* 86 */ /***/function(module,exports,__webpack_require__){module.exports=__webpack_require__(210);/***/}),(/* 87 */ /***/function(module,exports,__webpack_require__){Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(6);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
   * Draws a circle with radius = r
   * position must be handled by parent
   */var DrawCircle=function(_React$Component){_inherits(DrawCircle,_React$Component);function DrawCircle(){_classCallCheck(this,DrawCircle);return _possibleConstructorReturn(this,(DrawCircle.__proto__||Object.getPrototypeOf(DrawCircle)).apply(this,arguments));}_createClass(DrawCircle,[{key:"render",value:function render(){var _props=this.props;_props.r;_props.borderColor;_props.fillColor;_props.borderWidth;var rest=_objectWithoutProperties(_props,["r","borderColor","fillColor","borderWidth"]);this.props.r*2;return _react2.default.createElement("circle",_extends({stroke:this.props.borderColor,fill:this.props.fillColor,fillOpacity:this.props.fillOpacity,r:this.props.r,cx:this.props.cx,cy:this.props.cy},rest));}}]);return DrawCircle;}(_react2.default.Component);DrawCircle.defaultProps={borderColor:"black",fillColor:"transparent",borderWidth:2,fillOpacity:1};exports.default=DrawCircle;/***/}),(/* 88 */ /***/function(module,exports,__webpack_require__){Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(6);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
   * Draws a line from p1 to p2
   */var DrawLine=function(_React$Component){_inherits(DrawLine,_React$Component);function DrawLine(){_classCallCheck(this,DrawLine);return _possibleConstructorReturn(this,(DrawLine.__proto__||Object.getPrototypeOf(DrawLine)).apply(this,arguments));}_createClass(DrawLine,[{key:"render",value:function render(){var _props=this.props;_props.width;_props.color;var rest=_objectWithoutProperties(_props,["width","color"]);return _react2.default.createElement("line",_extends({x1:this.props.p1.x,y1:this.props.p1.y,x2:this.props.p2.x,y2:this.props.p2.y,stroke:this.props.color,strokeWidth:this.props.width},rest));}}]);return DrawLine;}(_react2.default.Component);DrawLine.defaultProps={width:2,color:"black"};exports.default=DrawLine;/***/}),(/* 89 */ /***/function(module,exports,__webpack_require__){Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(6);var _react2=_interopRequireDefault(_react);var _reactDom=__webpack_require__(211);var _reactDom2=_interopRequireDefault(_reactDom);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
   * Draws the overlay and the children
   */var HelpersOverlay=function(_React$Component){_inherits(HelpersOverlay,_React$Component);function HelpersOverlay(){_classCallCheck(this,HelpersOverlay);return _possibleConstructorReturn(this,(HelpersOverlay.__proto__||Object.getPrototypeOf(HelpersOverlay)).apply(this,arguments));}_createClass(HelpersOverlay,[{key:"render",value:function render(){var styles={overlay:Object.assign({width:"100%",height:"100vh",top:0,left:0,zIndex:2147483647,margin:"0",padding:"0",boxSizing:"border-box",position:"fixed"},this.props.overlayStyle)};var _props=this.props;_props.overlayStyle;var rest=_objectWithoutProperties(_props,["overlayStyle"]);return _reactDom2.default.createPortal(_react2.default.createElement("div",_extends({style:styles.overlay},rest),this.props.children),document.body);}}]);return HelpersOverlay;}(_react2.default.Component);exports.default=HelpersOverlay;/***/}),(/* 90 */ /***/function(module,exports,__webpack_require__){Object.defineProperty(exports,"__esModule",{value:true});exports.Knob=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();/**
   * Show the rotation circle and marker
   * dispatches drag events
   */var _react=__webpack_require__(6);var _react2=_interopRequireDefault(_react);var _utils=__webpack_require__(38);var _utils2=_interopRequireDefault(_utils);var _reactSvgmt=__webpack_require__(86);var _knobdefaultskin=__webpack_require__(83);var _knobdefaultskin2=_interopRequireDefault(_knobdefaultskin);var _KnobVisualHelpers=__webpack_require__(82);var _InternalInput=__webpack_require__(81);var _InternalInput2=_interopRequireDefault(_InternalInput);var _d3Selection=__webpack_require__(14);var _d3Drag=__webpack_require__(84);var _d3Scale=__webpack_require__(85);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
   * Generic knob component
   */var Knob=function(_Component){_inherits(Knob,_Component);function Knob(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Knob);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Knob.__proto__||Object.getPrototypeOf(Knob)).call.apply(_ref,[this].concat(args))),_this),_this.state={svgRef:null,dragging:false,dragDistance:0,mousePos:{x:0,y:0},valueAngle:0,uncontrolledValue:0},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Knob,[{key:"normalizeAngle",// returns angles between 0 and 360 for values lower 0 or greater 360
value:function normalizeAngle(angle){if(angle<0){//E.g -1 turns 359
return angle+360;}else if(angle>360){return angle-360;}return angle;}// converts a value to an angle for the knob respecting the additional rotateDegrees prop
},{key:"convertValueToAngle",value:function convertValueToAngle(value){var angle=(this.getScale()(value)+this.props.rotateDegrees)%360;return this.normalizeAngle(angle);}// converts an angle to a value for the knob respecting the additional rotateDegrees prop
},{key:"convertAngleToValue",value:function convertAngleToValue(angle){var angle2=angle-this.props.rotateDegrees;return this.getScale().invert(this.normalizeAngle(angle2));}},{key:"getScale",value:function getScale(){// Memoize scale so it's not recalculated everytime
if(!this.scaleProps||!(this.scaleProps.min===this.props.min&&this.scaleProps.max===this.props.max&&this.scaleProps.clampMin===this.props.clampMin&&this.scaleProps.clampMax===this.props.clampMax)){if(this.props.rotateDegrees<270&&this.props.rotateDegrees>90){this.scale=(0, _d3Scale.scaleLinear)().domain([this.props.min,this.props.max]).range([this.props.clampMin,this.props.clampMax]);}else {this.scale=(0, _d3Scale.scaleLinear)().domain([this.props.max,this.props.min]).range([this.props.clampMax,this.props.clampMin]);}this.scale.clamp(true);this.scaleProps={min:this.props.min,max:this.props.max,clampMin:this.props.clampMin,clampMax:this.props.clampMax};}return this.scale;}},{key:"componentDidMount",value:function componentDidMount(){if(this.props.value==null){/**
           * If the component is not controlled
           * then the state variable uncontrolledValue
           * will be used to store the current value
           */this.controlled=false;this.setState(_extends({},this.state,{uncontrolledValue:this.props.defaultValue}));}else {this.controlled=true;}this.setupDragging((0, _d3Selection.select)(this.container));}},{key:"saveRef",value:function saveRef(elem){if(!this.state.svgRef){this.setState(_extends({},this.state,{svgRef:elem}));}}},{key:"saveParentRef",value:function saveParentRef(container){this.container=container;}},{key:"onAngleChanged",value:function onAngleChanged(angle){//Calculate domain value
var domainValue=this.convertAngleToValue(angle);if(!this.controlled){/**
           * If the mode is 'uncontrolled' we need to update our local state
           */this.setState(function(st){return {uncontrolledValue:domainValue};});}this.props.onChange(domainValue);}/**
       * Returns the current value (depending on controlled/uncontrolled mode)
       */},{key:"getValue",value:function getValue(){return this.controlled===true?this.props.value:this.state.uncontrolledValue;}},{key:"setupDragging",value:function setupDragging(elem){if(elem==null){return;}// Add dragging behavior to selector element
var self=this;var vbox=elem.node().getBoundingClientRect();var cx=vbox.width/2;var cy=vbox.height/2;function started(){var value=self.getValue();var initialAngle=self.convertValueToAngle(value);vbox=elem.node().getBoundingClientRect();elem.classed("dragging",true);self.props.onStart();_d3Selection.event.on("drag",dragged).on("end",ended);//startPos = position relative to the box center
//Note: the d3 event container is the same element, so coordinates
//are relative to it.
var startPos={x:_d3Selection.event.x-cx,y:_d3Selection.event.y-cy};var startAngle=_utils2.default.getAngleForPoint(startPos.x,startPos.y);var lastPos=startPos;_utils2.default.getAngleForPoint(lastPos.x,lastPos.y);//in precise mode, we won't monitor angle change unless the distance > unlockDistance
var monitoring=false;self.setState(_extends({},self.state,{dragging:true,dragDistance:0,mousePos:{x:_d3Selection.event.sourceEvent.clientX,y:_d3Selection.event.sourceEvent.clientY}}));function dragged(){var currentPos={x:_d3Selection.event.x-cx,y:_d3Selection.event.y-cy};var distanceFromCenter=Math.sqrt(Math.pow(currentPos.x,2)+Math.pow(currentPos.y,2));if(self.props.preciseMode){if(!monitoring&&distanceFromCenter>=self.props.unlockDistance){//Start monitoring!
//Reset startPos y startAngle
startPos=currentPos;startAngle=_utils2.default.getAngleForPoint(currentPos.x,currentPos.y);monitoring=true;}}else {monitoring=true;}var currentAngle=_utils2.default.getAngleForPoint(currentPos.x,currentPos.y);var deltaAngle=currentAngle-startAngle;lastPos=currentPos;var finalAngle=initialAngle+deltaAngle;if(finalAngle<0){//E.g -1 turns 359
finalAngle+=360;}else if(finalAngle>360){finalAngle-=360;}// printDebugValues({
//   cx,
//   cy,
//   initialAngle,
//   startAngle,
//   startPos,
//   currentPos,
//   currentAngle,
//   deltaAngle,
//   finalAngle,
// })
if(monitoring){self.onAngleChanged(finalAngle);}self.setState(function(){return _extends({},self.state,{dragDistance:distanceFromCenter,mousePos:{x:_d3Selection.event.sourceEvent.clientX,y:_d3Selection.event.sourceEvent.clientY},valueAngle:monitoring?finalAngle:initialAngle});});}function ended(){elem.classed("dragging",false);self.setState(_extends({},self.state,{dragging:false}));self.props.onEnd();//focus input so it can be moved with arrows
self.inputRef.focus();}}var dragInstance=(0, _d3Drag.drag)();//Change the container to the element itself so the
//event.x and y are relative to the element , not its parent
dragInstance.container(function(){return elem.node();});elem.call(dragInstance.on("start",started));}},{key:"onFormControlChange",value:function onFormControlChange(newVal){if(!this.controlled){/**
           * If the mode is 'uncontrolled' we need to update our local state
           */this.setState(_extends({},this.state,{uncontrolledValue:newVal}));}this.props.onChange(newVal);}},{key:"render",value:function render(){var _this2=this;var _props=this.props;_props.value;_props.defaultValue;var min=_props.min,max=_props.max;_props.rotateDegrees;_props.clampMax;_props.clampMin;_props.onChange;_props.onStart;_props.onEnd;var skin=_props.skin,style=_props.style;_props.format;_props.preciseMode;_props.unlockDistance;var rest=_objectWithoutProperties(_props,["value","defaultValue","min","max","rotateDegrees","clampMax","clampMin","onChange","onStart","onEnd","skin","style","format","preciseMode","unlockDistance"]);var currentValue=this.getValue();var angle=this.convertValueToAngle(currentValue);var styles={container:Object.assign({},{width:"50px",height:"50px",overflow:"hidden",position:"relative"},style),input:{width:"50%",position:"absolute",top:"0",left:"-100%"}};//Get custom updates defined by the skin
//Transform the updateAttributes array into a SvgProxy array
var updateAttrs=skin.updateAttributes;var skinElemUpdates=updateAttrs&&updateAttrs.map(function(elemUpdate,ix){var elemContent=null;if(elemUpdate.content){elemContent=elemUpdate.content(_this2.props,currentValue);}var attributes={};//Call value function
//TODO: support string values
(elemUpdate.attrs||[]).forEach(function(attr){attributes[attr.name]=attr.value(_this2.props,currentValue);});return _react2.default.createElement(_reactSvgmt.SvgProxy,_extends({key:ix,selector:elemUpdate.element},attributes),elemContent);});return _react2.default.createElement(_react2.default.Fragment,null,_react2.default.createElement("div",_extends({ref:this.saveParentRef.bind(this),style:styles.container},rest),_react2.default.createElement(_InternalInput2.default,{inputRef:function inputRef(input){_this2.inputRef=input;},style:styles.input,value:currentValue,min:min,max:max,step:this.props.step,onChange:this.onFormControlChange.bind(this)}),_react2.default.createElement(_reactSvgmt.SvgLoader,{width:"100%",height:"100%",svgXML:skin.svg,onSVGReady:this.saveRef.bind(this)},_react2.default.createElement(_reactSvgmt.SvgProxy,{selector:"#knob",transform:"$ORIGINAL rotate("+angle+", "+skin.knobX+", "+skin.knobY+")"}),skinElemUpdates)),this.state.dragging&&this.props.preciseMode&&_react2.default.createElement(_KnobVisualHelpers.KnobVisualHelpers,{svgRef:this.state.svgRef,radius:this.state.dragDistance,mousePos:this.state.mousePos,minimumDragDistance:this.props.unlockDistance,valueAngle:this.state.valueAngle}));}}]);return Knob;}(_react.Component);Knob.defaultProps={min:0,max:100,clampMax:360,clampMin:0,rotateDegrees:0,onChange:function onChange(){},onStart:function onStart(){},onEnd:function onEnd(){},skin:_knobdefaultskin2.default,format:function format(val){return val.toFixed(0);},preciseMode:true,unlockDistance:100,defaultValue:0,step:1};exports.Knob=Knob;/***/}),(/* 91 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony default export */__webpack_exports__["a"]=function(x){return function(){return x;};};/***/}),(/* 92 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */__webpack_require__(45);/***/}),(/* 93 */ /***/function(module,__webpack_exports__,__webpack_require__){/***/}),(/* 94 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */__webpack_require__(39);/* harmony import */__webpack_require__(40);/* harmony import */__webpack_require__(91);/* harmony import */__webpack_require__(43);/* harmony import */__webpack_require__(95);/* harmony import */__webpack_require__(46);/* harmony import */__webpack_require__(48);/* harmony import */__webpack_require__(47);/***/}),(/* 95 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony default export */__webpack_exports__["a"]=function(x){return x;};/***/}),(/* 96 */ /***/function(module,__webpack_exports__,__webpack_require__){/***/}),(/* 97 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */__webpack_require__(12);/***/}),(/* 98 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */__webpack_require__(9);/* harmony import */__webpack_require__(12);/* harmony import */__webpack_require__(19);/***/}),(/* 99 */ /***/function(module,__webpack_exports__,__webpack_require__){/***/}),(/* 100 */ /***/function(module,__webpack_exports__,__webpack_require__){/***/}),(/* 101 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */__webpack_require__(9);/***/}),(/* 102 */ /***/function(module,__webpack_exports__,__webpack_require__){/***/}),(/* 103 */ /***/function(module,__webpack_exports__,__webpack_require__){/***/}),(/* 104 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */__webpack_require__(39);/* harmony import */__webpack_require__(9);/* harmony import */__webpack_require__(12);/* harmony import */__webpack_require__(19);/***/}),(/* 105 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */__webpack_require__(42);/***/}),(/* 106 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */__webpack_require__(49);/***/}),(/* 107 */ /***/function(module,__webpack_exports__,__webpack_require__){/***/}),(/* 108 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */__webpack_require__(110);/* unused harmony reexport nest */ /* harmony import */__webpack_require__(111);/* unused harmony reexport set */ /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__map__=__webpack_require__(20);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"a",function(){return __WEBPACK_IMPORTED_MODULE_2__map__["a"];});/* harmony import */__webpack_require__(109);/* unused harmony reexport keys */ /* harmony import */__webpack_require__(112);/* unused harmony reexport values */ /* harmony import */__webpack_require__(107);/* unused harmony reexport entries */ /***/}),(/* 109 */ /***/function(module,__webpack_exports__,__webpack_require__){/***/}),(/* 110 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */__webpack_require__(20);/***/}),(/* 111 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__map__=__webpack_require__(20);function Set(){}var proto=__WEBPACK_IMPORTED_MODULE_0__map__["a"/* default */].prototype;Set.prototype={constructor:Set,has:proto.has,add:function(value){value+="";this[__WEBPACK_IMPORTED_MODULE_0__map__["b"/* prefix */]+value]=value;return this;},remove:proto.remove,clear:proto.clear,values:proto.keys,size:proto.size,empty:proto.empty,each:proto.each};/***/}),(/* 112 */ /***/function(module,__webpack_exports__,__webpack_require__){/***/}),(/* 113 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony export (immutable) */__webpack_exports__["a"]=cubehelix;/* unused harmony export Cubehelix */ /* harmony import */var __WEBPACK_IMPORTED_MODULE_0__define_js__=__webpack_require__(22);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__color_js__=__webpack_require__(21);/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__math_js__=__webpack_require__(51);var A=-0.14861,B=+1.78277,C=-0.29227,D=-0.90649,E=+1.97294,ED=E*D,EB=E*B,BC_DA=B*C-D*A;function cubehelixConvert(o){if(o instanceof Cubehelix)return new Cubehelix(o.h,o.s,o.l,o.opacity);if(!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color_js__["a"/* Rgb */]))o=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color_js__["b"/* rgbConvert */])(o);var r=o.r/255,g=o.g/255,b=o.b/255,l=(BC_DA*b+ED*r-EB*g)/(BC_DA+ED-EB),bl=b-l,k=(E*(g-l)-C*bl)/D,s=Math.sqrt(k*k+bl*bl)/(E*l*(1-l)),// NaN if l=0 or l=1
h=s?Math.atan2(k,bl)*__WEBPACK_IMPORTED_MODULE_2__math_js__["a"/* rad2deg */]-120:NaN;return new Cubehelix(h<0?h+360:h,s,l,o.opacity);}function cubehelix(h,s,l,opacity){return arguments.length===1?cubehelixConvert(h):new Cubehelix(h,s,l,opacity==null?1:opacity);}function Cubehelix(h,s,l,opacity){this.h=+h;this.s=+s;this.l=+l;this.opacity=+opacity;}__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define_js__["a"/* default */])(Cubehelix,cubehelix,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define_js__["b"/* extend */])(__WEBPACK_IMPORTED_MODULE_1__color_js__["c"/* Color */],{brighter:function(k){k=k==null?__WEBPACK_IMPORTED_MODULE_1__color_js__["d"/* brighter */]:Math.pow(__WEBPACK_IMPORTED_MODULE_1__color_js__["d"/* brighter */],k);return new Cubehelix(this.h,this.s,this.l*k,this.opacity);},darker:function(k){k=k==null?__WEBPACK_IMPORTED_MODULE_1__color_js__["e"/* darker */]:Math.pow(__WEBPACK_IMPORTED_MODULE_1__color_js__["e"/* darker */],k);return new Cubehelix(this.h,this.s,this.l*k,this.opacity);},rgb:function(){var h=isNaN(this.h)?0:(this.h+120)*__WEBPACK_IMPORTED_MODULE_2__math_js__["b"/* deg2rad */],l=+this.l,a=isNaN(this.s)?0:this.s*l*(1-l),cosh=Math.cos(h),sinh=Math.sin(h);return new __WEBPACK_IMPORTED_MODULE_1__color_js__["a"/* Rgb */](255*(l+a*(A*cosh+B*sinh)),255*(l+a*(C*cosh+D*sinh)),255*(l+a*(E*cosh)),this.opacity);}}));/***/}),(/* 114 */ /***/function(module,__webpack_exports__,__webpack_require__){/* unused harmony export gray */ /* harmony export (immutable) */__webpack_exports__["b"]=lab;/* unused harmony export Lab */ /* unused harmony export lch */ /* harmony export (immutable) */__webpack_exports__["a"]=hcl;/* unused harmony export Hcl */ /* harmony import */var __WEBPACK_IMPORTED_MODULE_0__define_js__=__webpack_require__(22);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__color_js__=__webpack_require__(21);/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__math_js__=__webpack_require__(51);// https://observablehq.com/@mbostock/lab-and-rgb
var K=18,Xn=0.96422,Yn=1,Zn=0.82521,t0=4/29,t1=6/29,t2=3*t1*t1,t3=t1*t1*t1;function labConvert(o){if(o instanceof Lab)return new Lab(o.l,o.a,o.b,o.opacity);if(o instanceof Hcl)return hcl2lab(o);if(!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color_js__["a"/* Rgb */]))o=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color_js__["b"/* rgbConvert */])(o);var r=rgb2lrgb(o.r),g=rgb2lrgb(o.g),b=rgb2lrgb(o.b),y=xyz2lab((0.2225045*r+0.7168786*g+0.0606169*b)/Yn),x,z;if(r===g&&g===b)x=z=y;else {x=xyz2lab((0.4360747*r+0.3850649*g+0.1430804*b)/Xn);z=xyz2lab((0.0139322*r+0.0971045*g+0.7141733*b)/Zn);}return new Lab(116*y-16,500*(x-y),200*(y-z),o.opacity);}function lab(l,a,b,opacity){return arguments.length===1?labConvert(l):new Lab(l,a,b,opacity==null?1:opacity);}function Lab(l,a,b,opacity){this.l=+l;this.a=+a;this.b=+b;this.opacity=+opacity;}__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define_js__["a"/* default */])(Lab,lab,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define_js__["b"/* extend */])(__WEBPACK_IMPORTED_MODULE_1__color_js__["c"/* Color */],{brighter:function(k){return new Lab(this.l+K*(k==null?1:k),this.a,this.b,this.opacity);},darker:function(k){return new Lab(this.l-K*(k==null?1:k),this.a,this.b,this.opacity);},rgb:function(){var y=(this.l+16)/116,x=isNaN(this.a)?y:y+this.a/500,z=isNaN(this.b)?y:y-this.b/200;x=Xn*lab2xyz(x);y=Yn*lab2xyz(y);z=Zn*lab2xyz(z);return new __WEBPACK_IMPORTED_MODULE_1__color_js__["a"/* Rgb */](lrgb2rgb(3.1338561*x-1.6168667*y-0.4906146*z),lrgb2rgb(-0.9787684*x+1.9161415*y+0.0334540*z),lrgb2rgb(0.0719453*x-0.2289914*y+1.4052427*z),this.opacity);}}));function xyz2lab(t){return t>t3?Math.pow(t,1/3):t/t2+t0;}function lab2xyz(t){return t>t1?t*t*t:t2*(t-t0);}function lrgb2rgb(x){return 255*(x<=0.0031308?12.92*x:1.055*Math.pow(x,1/2.4)-0.055);}function rgb2lrgb(x){return (x/=255)<=0.04045?x/12.92:Math.pow((x+0.055)/1.055,2.4);}function hclConvert(o){if(o instanceof Hcl)return new Hcl(o.h,o.c,o.l,o.opacity);if(!(o instanceof Lab))o=labConvert(o);if(o.a===0&&o.b===0)return new Hcl(NaN,0<o.l&&o.l<100?0:NaN,o.l,o.opacity);var h=Math.atan2(o.b,o.a)*__WEBPACK_IMPORTED_MODULE_2__math_js__["a"/* rad2deg */];return new Hcl(h<0?h+360:h,Math.sqrt(o.a*o.a+o.b*o.b),o.l,o.opacity);}function hcl(h,c,l,opacity){return arguments.length===1?hclConvert(h):new Hcl(h,c,l,opacity==null?1:opacity);}function Hcl(h,c,l,opacity){this.h=+h;this.c=+c;this.l=+l;this.opacity=+opacity;}function hcl2lab(o){if(isNaN(o.h))return new Lab(o.l,0,0,o.opacity);var h=o.h*__WEBPACK_IMPORTED_MODULE_2__math_js__["b"/* deg2rad */];return new Lab(o.l,Math.cos(h)*o.c,Math.sin(h)*o.c,o.opacity);}__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define_js__["a"/* default */])(Hcl,hcl,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define_js__["b"/* extend */])(__WEBPACK_IMPORTED_MODULE_1__color_js__["c"/* Color */],{brighter:function(k){return new Hcl(this.h,this.c,this.l+K*(k==null?1:k),this.opacity);},darker:function(k){return new Hcl(this.h,this.c,this.l-K*(k==null?1:k),this.opacity);},rgb:function(){return hcl2lab(this).rgb();}}));/***/}),(/* 115 */ /***/function(module,__webpack_exports__,__webpack_require__){var noop={value:function(){}};function dispatch(){for(var i=0,n=arguments.length,_={},t;i<n;++i){if(!(t=arguments[i]+"")||t in _)throw new Error("illegal type: "+t);_[t]=[];}return new Dispatch(_);}function Dispatch(_){this._=_;}function parseTypenames(typenames,types){return typenames.trim().split(/^|\s+/).map(function(t){var name="",i=t.indexOf(".");if(i>=0)name=t.slice(i+1),t=t.slice(0,i);if(t&&!types.hasOwnProperty(t))throw new Error("unknown type: "+t);return {type:t,name:name};});}Dispatch.prototype=dispatch.prototype={constructor:Dispatch,on:function(typename,callback){var _=this._,T=parseTypenames(typename+"",_),t,i=-1,n=T.length;// If no callback was specified, return the callback of the given type and name.
if(arguments.length<2){while(++i<n)if((t=(typename=T[i]).type)&&(t=get(_[t],typename.name)))return t;return;}// If a type was specified, set the callback for the given type and name.
// Otherwise, if a null callback was specified, remove callbacks of the given name.
if(callback!=null&&typeof callback!=="function")throw new Error("invalid callback: "+callback);while(++i<n){if(t=(typename=T[i]).type)_[t]=set(_[t],typename.name,callback);else if(callback==null)for(t in _)_[t]=set(_[t],typename.name,null);}return this;},copy:function(){var copy={},_=this._;for(var t in _)copy[t]=_[t].slice();return new Dispatch(copy);},call:function(type,that){if((n=arguments.length-2)>0)for(var args=new Array(n),i=0,n,t;i<n;++i)args[i]=arguments[i+2];if(!this._.hasOwnProperty(type))throw new Error("unknown type: "+type);for(t=this._[type],i=0,n=t.length;i<n;++i)t[i].value.apply(that,args);},apply:function(type,that,args){if(!this._.hasOwnProperty(type))throw new Error("unknown type: "+type);for(var t=this._[type],i=0,n=t.length;i<n;++i)t[i].value.apply(that,args);}};function get(type,name){for(var i=0,n=type.length,c;i<n;++i){if((c=type[i]).name===name){return c.value;}}}function set(type,name,callback){for(var i=0,n=type.length;i<n;++i){if(type[i].name===name){type[i]=noop,type=type.slice(0,i).concat(type.slice(i+1));break;}}if(callback!=null)type.push({name:name,value:callback});return type;}/* harmony default export */__webpack_exports__["a"]=dispatch;/***/}),(/* 116 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__dispatch__=__webpack_require__(115);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"a",function(){return __WEBPACK_IMPORTED_MODULE_0__dispatch__["a"];});/***/}),(/* 117 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony default export */__webpack_exports__["a"]=function(x){return function(){return x;};};/***/}),(/* 118 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */var __WEBPACK_IMPORTED_MODULE_0_d3_dispatch__=__webpack_require__(116);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1_d3_selection__=__webpack_require__(14);/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__nodrag_js__=__webpack_require__(52);/* harmony import */var __WEBPACK_IMPORTED_MODULE_3__noevent_js__=__webpack_require__(53);/* harmony import */var __WEBPACK_IMPORTED_MODULE_4__constant_js__=__webpack_require__(117);/* harmony import */var __WEBPACK_IMPORTED_MODULE_5__event_js__=__webpack_require__(119);// Ignore right-click, since that should open the context menu.
function defaultFilter(){return !__WEBPACK_IMPORTED_MODULE_1_d3_selection__["event"].ctrlKey&&!__WEBPACK_IMPORTED_MODULE_1_d3_selection__["event"].button;}function defaultContainer(){return this.parentNode;}function defaultSubject(d){return d==null?{x:__WEBPACK_IMPORTED_MODULE_1_d3_selection__["event"].x,y:__WEBPACK_IMPORTED_MODULE_1_d3_selection__["event"].y}:d;}function defaultTouchable(){return navigator.maxTouchPoints||"ontouchstart"in this;}/* harmony default export */__webpack_exports__["a"]=function(){var filter=defaultFilter,container=defaultContainer,subject=defaultSubject,touchable=defaultTouchable,gestures={},listeners=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_dispatch__["a"/* dispatch */])("start","drag","end"),active=0,mousedownx,mousedowny,mousemoving,touchending,clickDistance2=0;function drag(selection){selection.on("mousedown.drag",mousedowned).filter(touchable).on("touchstart.drag",touchstarted).on("touchmove.drag",touchmoved).on("touchend.drag touchcancel.drag",touchended).style("touch-action","none").style("-webkit-tap-highlight-color","rgba(0,0,0,0)");}function mousedowned(){if(touchending||!filter.apply(this,arguments))return;var gesture=beforestart("mouse",container.apply(this,arguments),__WEBPACK_IMPORTED_MODULE_1_d3_selection__["mouse"],this,arguments);if(!gesture)return;__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["select"])(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["event"].view).on("mousemove.drag",mousemoved,true).on("mouseup.drag",mouseupped,true);__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__nodrag_js__["a"/* default */])(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["event"].view);__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__noevent_js__["b"/* nopropagation */])();mousemoving=false;mousedownx=__WEBPACK_IMPORTED_MODULE_1_d3_selection__["event"].clientX;mousedowny=__WEBPACK_IMPORTED_MODULE_1_d3_selection__["event"].clientY;gesture("start");}function mousemoved(){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__noevent_js__["a"/* default */])();if(!mousemoving){var dx=__WEBPACK_IMPORTED_MODULE_1_d3_selection__["event"].clientX-mousedownx,dy=__WEBPACK_IMPORTED_MODULE_1_d3_selection__["event"].clientY-mousedowny;mousemoving=dx*dx+dy*dy>clickDistance2;}gestures.mouse("drag");}function mouseupped(){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["select"])(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["event"].view).on("mousemove.drag mouseup.drag",null);__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__nodrag_js__["b"/* yesdrag */])(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["event"].view,mousemoving);__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__noevent_js__["a"/* default */])();gestures.mouse("end");}function touchstarted(){if(!filter.apply(this,arguments))return;var touches=__WEBPACK_IMPORTED_MODULE_1_d3_selection__["event"].changedTouches,c=container.apply(this,arguments),n=touches.length,i,gesture;for(i=0;i<n;++i){if(gesture=beforestart(touches[i].identifier,c,__WEBPACK_IMPORTED_MODULE_1_d3_selection__["touch"],this,arguments)){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__noevent_js__["b"/* nopropagation */])();gesture("start");}}}function touchmoved(){var touches=__WEBPACK_IMPORTED_MODULE_1_d3_selection__["event"].changedTouches,n=touches.length,i,gesture;for(i=0;i<n;++i){if(gesture=gestures[touches[i].identifier]){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__noevent_js__["a"/* default */])();gesture("drag");}}}function touchended(){var touches=__WEBPACK_IMPORTED_MODULE_1_d3_selection__["event"].changedTouches,n=touches.length,i,gesture;if(touchending)clearTimeout(touchending);touchending=setTimeout(function(){touchending=null;},500);// Ghost clicks are delayed!
for(i=0;i<n;++i){if(gesture=gestures[touches[i].identifier]){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__noevent_js__["b"/* nopropagation */])();gesture("end");}}}function beforestart(id,container,point,that,args){var p=point(container,id),s,dx,dy,sublisteners=listeners.copy();if(!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["customEvent"])(new __WEBPACK_IMPORTED_MODULE_5__event_js__["a"/* default */](drag,"beforestart",s,id,active,p[0],p[1],0,0,sublisteners),function(){if((__WEBPACK_IMPORTED_MODULE_1_d3_selection__["event"].subject=s=subject.apply(that,args))==null)return false;dx=s.x-p[0]||0;dy=s.y-p[1]||0;return true;}))return;return function gesture(type){var p0=p,n;switch(type){case"start":gestures[id]=gesture,n=active++;break;case"end":delete gestures[id],--active;// nobreak
case"drag":p=point(container,id),n=active;break;}__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["customEvent"])(new __WEBPACK_IMPORTED_MODULE_5__event_js__["a"/* default */](drag,type,s,id,n,p[0]+dx,p[1]+dy,p[0]-p0[0],p[1]-p0[1],sublisteners),sublisteners.apply,sublisteners,[type,that,args]);};}drag.filter=function(_){return arguments.length?(filter=typeof _==="function"?_:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__constant_js__["a"/* default */])(!!_),drag):filter;};drag.container=function(_){return arguments.length?(container=typeof _==="function"?_:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__constant_js__["a"/* default */])(_),drag):container;};drag.subject=function(_){return arguments.length?(subject=typeof _==="function"?_:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__constant_js__["a"/* default */])(_),drag):subject;};drag.touchable=function(_){return arguments.length?(touchable=typeof _==="function"?_:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__constant_js__["a"/* default */])(!!_),drag):touchable;};drag.on=function(){var value=listeners.on.apply(listeners,arguments);return value===listeners?drag:value;};drag.clickDistance=function(_){return arguments.length?(clickDistance2=(_=+_)*_,drag):Math.sqrt(clickDistance2);};return drag;};/***/}),(/* 119 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony export (immutable) */__webpack_exports__["a"]=DragEvent;function DragEvent(target,type,subject,id,active,x,y,dx,dy,dispatch){this.target=target;this.type=type;this.subject=subject;this.identifier=id;this.active=active;this.x=x;this.y=y;this.dx=dx;this.dy=dy;this._=dispatch;}DragEvent.prototype.on=function(){var value=this._.on.apply(this._,arguments);return value===this._?this:value;};/***/}),(/* 120 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony export (binding) */__webpack_require__.d(__webpack_exports__,"a",function(){return format;});/* harmony export (binding) */__webpack_require__.d(__webpack_exports__,"b",function(){return formatPrefix;});/* unused harmony export default */ /* harmony import */var __WEBPACK_IMPORTED_MODULE_0__locale_js__=__webpack_require__(57);var locale;var format;var formatPrefix;defaultLocale({decimal:".",thousands:",",grouping:[3],currency:["$",""],minus:"-"});function defaultLocale(definition){locale=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__locale_js__["a"/* default */])(definition);format=locale.format;formatPrefix=locale.formatPrefix;return locale;}/***/}),(/* 121 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony default export */__webpack_exports__["a"]=function(grouping,thousands){return function(value,width){var i=value.length,t=[],j=0,g=grouping[0],length=0;while(i>0&&g>0){if(length+g+1>width)g=Math.max(1,width-length);t.push(value.substring(i-=g,i+g));if((length+=g+1)>width)break;g=grouping[j=(j+1)%grouping.length];}return t.reverse().join(thousands);};};/***/}),(/* 122 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony default export */__webpack_exports__["a"]=function(numerals){return function(value){return value.replace(/[0-9]/g,function(i){return numerals[+i];});};};/***/}),(/* 123 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__formatDecimal_js__=__webpack_require__(23);/* harmony default export */__webpack_exports__["a"]=function(x,p){var d=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__formatDecimal_js__["a"/* default */])(x,p);if(!d)return x+"";var coefficient=d[0],exponent=d[1];return exponent<0?"0."+new Array(-exponent).join("0")+coefficient:coefficient.length>exponent+1?coefficient.slice(0,exponent+1)+"."+coefficient.slice(exponent+1):coefficient+new Array(exponent-coefficient.length+2).join("0");};/***/}),(/* 124 */ /***/function(module,__webpack_exports__,__webpack_require__){// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
/* harmony default export */__webpack_exports__["a"]=function(s){out:for(var n=s.length,i=1,i0=-1,i1;i<n;++i){switch(s[i]){case".":i0=i1=i;break;case"0":if(i0===0)i0=i;i1=i;break;default:if(i0>0){if(!+s[i])break out;i0=0;}break;}}return i0>0?s.slice(0,i0)+s.slice(i1+1):s;};/***/}),(/* 125 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__formatPrefixAuto_js__=__webpack_require__(54);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__formatRounded_js__=__webpack_require__(123);/* harmony default export */__webpack_exports__["a"]={"%":function(x,p){return (x*100).toFixed(p);},"b":function(x){return Math.round(x).toString(2);},"c":function(x){return x+"";},"d":function(x){return Math.round(x).toString(10);},"e":function(x,p){return x.toExponential(p);},"f":function(x,p){return x.toFixed(p);},"g":function(x,p){return x.toPrecision(p);},"o":function(x){return Math.round(x).toString(8);},"p":function(x,p){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__formatRounded_js__["a"/* default */])(x*100,p);},"r":__WEBPACK_IMPORTED_MODULE_1__formatRounded_js__["a"/* default */],"s":__WEBPACK_IMPORTED_MODULE_0__formatPrefixAuto_js__["b"/* default */],"X":function(x){return Math.round(x).toString(16).toUpperCase();},"x":function(x){return Math.round(x).toString(16);}};/***/}),(/* 126 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony default export */__webpack_exports__["a"]=function(x){return x;};/***/}),(/* 127 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__exponent_js__=__webpack_require__(15);/* harmony default export */__webpack_exports__["a"]=function(step){return Math.max(0,-__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent_js__["a"/* default */])(Math.abs(step)));};/***/}),(/* 128 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__exponent_js__=__webpack_require__(15);/* harmony default export */__webpack_exports__["a"]=function(step,value){return Math.max(0,Math.max(-8,Math.min(8,Math.floor(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent_js__["a"/* default */])(value)/3)))*3-__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent_js__["a"/* default */])(Math.abs(step)));};/***/}),(/* 129 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__exponent_js__=__webpack_require__(15);/* harmony default export */__webpack_exports__["a"]=function(step,max){step=Math.abs(step),max=Math.abs(max)-step;return Math.max(0,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent_js__["a"/* default */])(max)-__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent_js__["a"/* default */])(step))+1;};/***/}),(/* 130 */ /***/function(module,__webpack_exports__,__webpack_require__){/* unused harmony export cubehelixLong */ /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_d3_color__=__webpack_require__(10);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__color__=__webpack_require__(11);function cubehelix(hue){return function cubehelixGamma(y){y=+y;function cubehelix(start,end){var h=hue((start=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a"/* cubehelix */])(start)).h,(end=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a"/* cubehelix */])(end)).h),s=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a"/* default */])(start.s,end.s),l=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a"/* default */])(start.l,end.l),opacity=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a"/* default */])(start.opacity,end.opacity);return function(t){start.h=h(t);start.s=s(t);start.l=l(Math.pow(t,y));start.opacity=opacity(t);return start+"";};}cubehelix.gamma=cubehelixGamma;return cubehelix;}(1);}/* unused harmony default export */cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__["b"/* hue */]);cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__["a"/* default */]);/***/}),(/* 131 */ /***/function(module,__webpack_exports__,__webpack_require__){/***/}),(/* 132 */ /***/function(module,__webpack_exports__,__webpack_require__){/* unused harmony export hclLong */ /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_d3_color__=__webpack_require__(10);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__color__=__webpack_require__(11);function hcl(hue){return function(start,end){var h=hue((start=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b"/* hcl */])(start)).h,(end=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b"/* hcl */])(end)).h),c=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a"/* default */])(start.c,end.c),l=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a"/* default */])(start.l,end.l),opacity=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a"/* default */])(start.opacity,end.opacity);return function(t){start.h=h(t);start.c=c(t);start.l=l(t);start.opacity=opacity(t);return start+"";};};}/* unused harmony default export */hcl(__WEBPACK_IMPORTED_MODULE_1__color__["b"/* hue */]);hcl(__WEBPACK_IMPORTED_MODULE_1__color__["a"/* default */]);/***/}),(/* 133 */ /***/function(module,__webpack_exports__,__webpack_require__){/* unused harmony export hslLong */ /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_d3_color__=__webpack_require__(10);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__color__=__webpack_require__(11);function hsl(hue){return function(start,end){var h=hue((start=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["d"/* hsl */])(start)).h,(end=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["d"/* hsl */])(end)).h),s=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a"/* default */])(start.s,end.s),l=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a"/* default */])(start.l,end.l),opacity=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a"/* default */])(start.opacity,end.opacity);return function(t){start.h=h(t);start.s=s(t);start.l=l(t);start.opacity=opacity(t);return start+"";};};}/* unused harmony default export */hsl(__WEBPACK_IMPORTED_MODULE_1__color__["b"/* hue */]);hsl(__WEBPACK_IMPORTED_MODULE_1__color__["a"/* default */]);/***/}),(/* 134 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */__webpack_require__(11);/***/}),(/* 135 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__value__=__webpack_require__(25);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"a",function(){return __WEBPACK_IMPORTED_MODULE_0__value__["a"];});/* harmony import */__webpack_require__(58);/* unused harmony reexport interpolateArray */ /* harmony import */__webpack_require__(24);/* unused harmony reexport interpolateBasis */ /* harmony import */__webpack_require__(59);/* unused harmony reexport interpolateBasisClosed */ /* harmony import */__webpack_require__(61);/* unused harmony reexport interpolateDate */ /* harmony import */__webpack_require__(131);/* unused harmony reexport interpolateDiscrete */ /* harmony import */__webpack_require__(134);/* unused harmony reexport interpolateHue */ /* harmony import */var __WEBPACK_IMPORTED_MODULE_7__number__=__webpack_require__(16);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"b",function(){return __WEBPACK_IMPORTED_MODULE_7__number__["a"];});/* harmony import */__webpack_require__(62);/* unused harmony reexport interpolateObject */ /* harmony import */var __WEBPACK_IMPORTED_MODULE_9__round__=__webpack_require__(139);/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__,"c",function(){return __WEBPACK_IMPORTED_MODULE_9__round__["a"];});/* harmony import */__webpack_require__(64);/* unused harmony reexport interpolateString */ /* harmony import */__webpack_require__(141);/* unused harmony reexport interpolateTransformCss */ /* unused harmony reexport interpolateTransformSvg */ /* harmony import */__webpack_require__(143);/* unused harmony reexport interpolateZoom */ /* harmony import */__webpack_require__(63);/* unused harmony reexport interpolateRgb */ /* unused harmony reexport interpolateRgbBasis */ /* unused harmony reexport interpolateRgbBasisClosed */ /* harmony import */__webpack_require__(133);/* unused harmony reexport interpolateHsl */ /* unused harmony reexport interpolateHslLong */ /* harmony import */__webpack_require__(136);/* unused harmony reexport interpolateLab */ /* harmony import */__webpack_require__(132);/* unused harmony reexport interpolateHcl */ /* unused harmony reexport interpolateHclLong */ /* harmony import */__webpack_require__(130);/* unused harmony reexport interpolateCubehelix */ /* unused harmony reexport interpolateCubehelixLong */ /* harmony import */__webpack_require__(137);/* unused harmony reexport piecewise */ /* harmony import */__webpack_require__(138);/* unused harmony reexport quantize */ /***/}),(/* 136 */ /***/function(module,__webpack_exports__,__webpack_require__){/* unused harmony export default */ /* harmony import */__webpack_require__(10);/* harmony import */__webpack_require__(11);/***/}),(/* 137 */ /***/function(module,__webpack_exports__,__webpack_require__){/***/}),(/* 138 */ /***/function(module,__webpack_exports__,__webpack_require__){/***/}),(/* 139 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony default export */__webpack_exports__["a"]=function(a,b){return a=+a,b-=a,function(t){return Math.round(a+b*t);};};/***/}),(/* 140 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony export (binding) */__webpack_require__.d(__webpack_exports__,"a",function(){return identity;});var degrees=180/Math.PI;var identity={translateX:0,translateY:0,rotate:0,skewX:0,scaleX:1,scaleY:1};/* harmony default export */__webpack_exports__["b"]=function(a,b,c,d,e,f){var scaleX,scaleY,skewX;if(scaleX=Math.sqrt(a*a+b*b))a/=scaleX,b/=scaleX;if(skewX=a*c+b*d)c-=a*skewX,d-=b*skewX;if(scaleY=Math.sqrt(c*c+d*d))c/=scaleY,d/=scaleY,skewX/=scaleY;if(a*d<b*c)a=-a,b=-b,skewX=-skewX,scaleX=-scaleX;return {translateX:e,translateY:f,rotate:Math.atan2(b,a)*degrees,skewX:Math.atan(skewX)*degrees,scaleX:scaleX,scaleY:scaleY};};/***/}),(/* 141 */ /***/function(module,__webpack_exports__,__webpack_require__){/* unused harmony export interpolateTransformCss */ /* unused harmony export interpolateTransformSvg */ /* harmony import */var __WEBPACK_IMPORTED_MODULE_0__number__=__webpack_require__(16);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__parse__=__webpack_require__(142);function interpolateTransform(parse,pxComma,pxParen,degParen){function pop(s){return s.length?s.pop()+" ":"";}function translate(xa,ya,xb,yb,s,q){if(xa!==xb||ya!==yb){var i=s.push("translate(",null,pxComma,null,pxParen);q.push({i:i-4,x:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a"/* default */])(xa,xb)},{i:i-2,x:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a"/* default */])(ya,yb)});}else if(xb||yb){s.push("translate("+xb+pxComma+yb+pxParen);}}function rotate(a,b,s,q){if(a!==b){if(a-b>180)b+=360;else if(b-a>180)a+=360;// shortest path
q.push({i:s.push(pop(s)+"rotate(",null,degParen)-2,x:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a"/* default */])(a,b)});}else if(b){s.push(pop(s)+"rotate("+b+degParen);}}function skewX(a,b,s,q){if(a!==b){q.push({i:s.push(pop(s)+"skewX(",null,degParen)-2,x:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a"/* default */])(a,b)});}else if(b){s.push(pop(s)+"skewX("+b+degParen);}}function scale(xa,ya,xb,yb,s,q){if(xa!==xb||ya!==yb){var i=s.push(pop(s)+"scale(",null,",",null,")");q.push({i:i-4,x:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a"/* default */])(xa,xb)},{i:i-2,x:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a"/* default */])(ya,yb)});}else if(xb!==1||yb!==1){s.push(pop(s)+"scale("+xb+","+yb+")");}}return function(a,b){var s=[],// string constants and placeholders
q=[];// number interpolators
a=parse(a),b=parse(b);translate(a.translateX,a.translateY,b.translateX,b.translateY,s,q);rotate(a.rotate,b.rotate,s,q);skewX(a.skewX,b.skewX,s,q);scale(a.scaleX,a.scaleY,b.scaleX,b.scaleY,s,q);a=b=null;// gc
return function(t){var i=-1,n=q.length,o;while(++i<n)s[(o=q[i]).i]=o.x(t);return s.join("");};};}interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__["a"/* parseCss */],"px, ","px)","deg)");interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__["b"/* parseSvg */],", ",")",")");/***/}),(/* 142 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony export (immutable) */__webpack_exports__["a"]=parseCss;/* harmony export (immutable) */__webpack_exports__["b"]=parseSvg;/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__decompose__=__webpack_require__(140);var cssNode,cssRoot,cssView,svgNode;function parseCss(value){if(value==="none")return __WEBPACK_IMPORTED_MODULE_0__decompose__["a"/* identity */];if(!cssNode)cssNode=document.createElement("DIV"),cssRoot=document.documentElement,cssView=document.defaultView;cssNode.style.transform=value;value=cssView.getComputedStyle(cssRoot.appendChild(cssNode),null).getPropertyValue("transform");cssRoot.removeChild(cssNode);value=value.slice(7,-1).split(",");return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__decompose__["b"/* default */])(+value[0],+value[1],+value[2],+value[3],+value[4],+value[5]);}function parseSvg(value){if(value==null)return __WEBPACK_IMPORTED_MODULE_0__decompose__["a"/* identity */];if(!svgNode)svgNode=document.createElementNS("http://www.w3.org/2000/svg","g");svgNode.setAttribute("transform",value);if(!(value=svgNode.transform.baseVal.consolidate()))return __WEBPACK_IMPORTED_MODULE_0__decompose__["a"/* identity */];value=value.matrix;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__decompose__["b"/* default */])(value.a,value.b,value.c,value.d,value.e,value.f);}/***/}),(/* 143 */ /***/function(module,__webpack_exports__,__webpack_require__){/***/}),(/* 144 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony export (immutable) */__webpack_exports__["a"]=band;/* harmony export (immutable) */__webpack_exports__["b"]=point;/* harmony import */var __WEBPACK_IMPORTED_MODULE_0_d3_array__=__webpack_require__(3);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__init__=__webpack_require__(1);/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__ordinal__=__webpack_require__(67);function band(){var scale=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__ordinal__["a"/* default */])().unknown(undefined),domain=scale.domain,ordinalRange=scale.range,range=[0,1],step,bandwidth,round=false,paddingInner=0,paddingOuter=0,align=0.5;delete scale.unknown;function rescale(){var n=domain().length,reverse=range[1]<range[0],start=range[reverse-0],stop=range[1-reverse];step=(stop-start)/Math.max(1,n-paddingInner+paddingOuter*2);if(round)step=Math.floor(step);start+=(stop-start-step*(n-paddingInner))*align;bandwidth=step*(1-paddingInner);if(round)start=Math.round(start),bandwidth=Math.round(bandwidth);var values=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["h"/* range */])(n).map(function(i){return start+step*i;});return ordinalRange(reverse?values.reverse():values);}scale.domain=function(_){return arguments.length?(domain(_),rescale()):domain();};scale.range=function(_){return arguments.length?(range=[+_[0],+_[1]],rescale()):range.slice();};scale.rangeRound=function(_){return range=[+_[0],+_[1]],round=true,rescale();};scale.bandwidth=function(){return bandwidth;};scale.step=function(){return step;};scale.round=function(_){return arguments.length?(round=!!_,rescale()):round;};scale.padding=function(_){return arguments.length?(paddingInner=Math.min(1,paddingOuter=+_),rescale()):paddingInner;};scale.paddingInner=function(_){return arguments.length?(paddingInner=Math.min(1,_),rescale()):paddingInner;};scale.paddingOuter=function(_){return arguments.length?(paddingOuter=+_,rescale()):paddingOuter;};scale.align=function(_){return arguments.length?(align=Math.max(0,Math.min(1,_)),rescale()):align;};scale.copy=function(){return band(domain(),range).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);};return __WEBPACK_IMPORTED_MODULE_1__init__["b"/* initRange */].apply(rescale(),arguments);}function pointish(scale){var copy=scale.copy;scale.padding=scale.paddingOuter;delete scale.paddingInner;delete scale.paddingOuter;scale.copy=function(){return pointish(copy());};return scale;}function point(){return pointish(band.apply(null,arguments).paddingInner(1));}/***/}),(/* 145 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony default export */__webpack_exports__["a"]=function(x){return function(){return x;};};/***/}),(/* 146 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony export (immutable) */__webpack_exports__["a"]=diverging;/* harmony export (immutable) */__webpack_exports__["b"]=divergingLog;/* harmony export (immutable) */__webpack_exports__["e"]=divergingSymlog;/* harmony export (immutable) */__webpack_exports__["c"]=divergingPow;/* harmony export (immutable) */__webpack_exports__["d"]=divergingSqrt;/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__continuous__=__webpack_require__(5);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__init__=__webpack_require__(1);/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__linear__=__webpack_require__(8);/* harmony import */var __WEBPACK_IMPORTED_MODULE_3__log__=__webpack_require__(26);/* harmony import */var __WEBPACK_IMPORTED_MODULE_4__sequential__=__webpack_require__(68);/* harmony import */var __WEBPACK_IMPORTED_MODULE_5__symlog__=__webpack_require__(28);/* harmony import */var __WEBPACK_IMPORTED_MODULE_6__pow__=__webpack_require__(27);function transformer(){var x0=0,x1=0.5,x2=1,t0,t1,t2,k10,k21,interpolator=__WEBPACK_IMPORTED_MODULE_0__continuous__["a"/* identity */],transform,clamp=false,unknown;function scale(x){return isNaN(x=+x)?unknown:(x=0.5+((x=+transform(x))-t1)*(x<t1?k10:k21),interpolator(clamp?Math.max(0,Math.min(1,x)):x));}scale.domain=function(_){return arguments.length?(t0=transform(x0=+_[0]),t1=transform(x1=+_[1]),t2=transform(x2=+_[2]),k10=t0===t1?0:0.5/(t1-t0),k21=t1===t2?0:0.5/(t2-t1),scale):[x0,x1,x2];};scale.clamp=function(_){return arguments.length?(clamp=!!_,scale):clamp;};scale.interpolator=function(_){return arguments.length?(interpolator=_,scale):interpolator;};scale.unknown=function(_){return arguments.length?(unknown=_,scale):unknown;};return function(t){transform=t,t0=t(x0),t1=t(x1),t2=t(x2),k10=t0===t1?0:0.5/(t1-t0),k21=t1===t2?0:0.5/(t2-t1);return scale;};}function diverging(){var scale=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__linear__["b"/* linearish */])(transformer()(__WEBPACK_IMPORTED_MODULE_0__continuous__["a"/* identity */]));scale.copy=function(){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__sequential__["f"/* copy */])(scale,diverging());};return __WEBPACK_IMPORTED_MODULE_1__init__["a"/* initInterpolator */].apply(scale,arguments);}function divergingLog(){var scale=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__log__["b"/* loggish */])(transformer()).domain([0.1,1,10]);scale.copy=function(){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__sequential__["f"/* copy */])(scale,divergingLog()).base(scale.base());};return __WEBPACK_IMPORTED_MODULE_1__init__["a"/* initInterpolator */].apply(scale,arguments);}function divergingSymlog(){var scale=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__symlog__["b"/* symlogish */])(transformer());scale.copy=function(){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__sequential__["f"/* copy */])(scale,divergingSymlog()).constant(scale.constant());};return __WEBPACK_IMPORTED_MODULE_1__init__["a"/* initInterpolator */].apply(scale,arguments);}function divergingPow(){var scale=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__pow__["c"/* powish */])(transformer());scale.copy=function(){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__sequential__["f"/* copy */])(scale,divergingPow()).exponent(scale.exponent());};return __WEBPACK_IMPORTED_MODULE_1__init__["a"/* initInterpolator */].apply(scale,arguments);}function divergingSqrt(){return divergingPow.apply(null,arguments).exponent(0.5);}/***/}),(/* 147 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony export (immutable) */__webpack_exports__["a"]=identity;/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__array__=__webpack_require__(7);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__linear__=__webpack_require__(8);/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__number__=__webpack_require__(66);function identity(domain){var unknown;function scale(x){return isNaN(x=+x)?unknown:x;}scale.invert=scale;scale.domain=scale.range=function(_){return arguments.length?(domain=__WEBPACK_IMPORTED_MODULE_0__array__["a"/* map */].call(_,__WEBPACK_IMPORTED_MODULE_2__number__["a"/* default */]),scale):domain.slice();};scale.unknown=function(_){return arguments.length?(unknown=_,scale):unknown;};scale.copy=function(){return identity(domain).unknown(unknown);};domain=arguments.length?__WEBPACK_IMPORTED_MODULE_0__array__["a"/* map */].call(domain,__WEBPACK_IMPORTED_MODULE_2__number__["a"/* default */]):[0,1];return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__linear__["b"/* linearish */])(scale);}/***/}),(/* 148 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony export (immutable) */__webpack_exports__["a"]=quantile;/* harmony import */var __WEBPACK_IMPORTED_MODULE_0_d3_array__=__webpack_require__(3);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__array__=__webpack_require__(7);/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__init__=__webpack_require__(1);function quantile(){var domain=[],range=[],thresholds=[],unknown;function rescale(){var i=0,n=Math.max(1,range.length);thresholds=new Array(n-1);while(++i<n)thresholds[i-1]=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["g"/* quantile */])(domain,i/n);return scale;}function scale(x){return isNaN(x=+x)?unknown:range[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b"/* bisect */])(thresholds,x)];}scale.invertExtent=function(y){var i=range.indexOf(y);return i<0?[NaN,NaN]:[i>0?thresholds[i-1]:domain[0],i<thresholds.length?thresholds[i]:domain[domain.length-1]];};scale.domain=function(_){if(!arguments.length)return domain.slice();domain=[];for(var i=0,n=_.length,d;i<n;++i)if(d=_[i],d!=null&&!isNaN(d=+d))domain.push(d);domain.sort(__WEBPACK_IMPORTED_MODULE_0_d3_array__["e"/* ascending */]);return rescale();};scale.range=function(_){return arguments.length?(range=__WEBPACK_IMPORTED_MODULE_1__array__["b"/* slice */].call(_),rescale()):range.slice();};scale.unknown=function(_){return arguments.length?(unknown=_,scale):unknown;};scale.quantiles=function(){return thresholds.slice();};scale.copy=function(){return quantile().domain(domain).range(range).unknown(unknown);};return __WEBPACK_IMPORTED_MODULE_2__init__["b"/* initRange */].apply(scale,arguments);}/***/}),(/* 149 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony export (immutable) */__webpack_exports__["a"]=quantize;/* harmony import */var __WEBPACK_IMPORTED_MODULE_0_d3_array__=__webpack_require__(3);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__array__=__webpack_require__(7);/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__linear__=__webpack_require__(8);/* harmony import */var __WEBPACK_IMPORTED_MODULE_3__init__=__webpack_require__(1);function quantize(){var x0=0,x1=1,n=1,domain=[0.5],range=[0,1],unknown;function scale(x){return x<=x?range[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b"/* bisect */])(domain,x,0,n)]:unknown;}function rescale(){var i=-1;domain=new Array(n);while(++i<n)domain[i]=((i+1)*x1-(i-n)*x0)/(n+1);return scale;}scale.domain=function(_){return arguments.length?(x0=+_[0],x1=+_[1],rescale()):[x0,x1];};scale.range=function(_){return arguments.length?(n=(range=__WEBPACK_IMPORTED_MODULE_1__array__["b"/* slice */].call(_)).length-1,rescale()):range.slice();};scale.invertExtent=function(y){var i=range.indexOf(y);return i<0?[NaN,NaN]:i<1?[x0,domain[0]]:i>=n?[domain[n-1],x1]:[domain[i-1],domain[i]];};scale.unknown=function(_){return arguments.length?(unknown=_,scale):scale;};scale.thresholds=function(){return domain.slice();};scale.copy=function(){return quantize().domain([x0,x1]).range(range).unknown(unknown);};return __WEBPACK_IMPORTED_MODULE_3__init__["b"/* initRange */].apply(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__linear__["b"/* linearish */])(scale),arguments);}/***/}),(/* 150 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony export (immutable) */__webpack_exports__["a"]=sequentialQuantile;/* harmony import */var __WEBPACK_IMPORTED_MODULE_0_d3_array__=__webpack_require__(3);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__continuous__=__webpack_require__(5);/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__init__=__webpack_require__(1);function sequentialQuantile(){var domain=[],interpolator=__WEBPACK_IMPORTED_MODULE_1__continuous__["a"/* identity */];function scale(x){if(!isNaN(x=+x))return interpolator((__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b"/* bisect */])(domain,x)-1)/(domain.length-1));}scale.domain=function(_){if(!arguments.length)return domain.slice();domain=[];for(var i=0,n=_.length,d;i<n;++i)if(d=_[i],d!=null&&!isNaN(d=+d))domain.push(d);domain.sort(__WEBPACK_IMPORTED_MODULE_0_d3_array__["e"/* ascending */]);return scale;};scale.interpolator=function(_){return arguments.length?(interpolator=_,scale):interpolator;};scale.copy=function(){return sequentialQuantile(interpolator).domain(domain);};return __WEBPACK_IMPORTED_MODULE_2__init__["a"/* initInterpolator */].apply(scale,arguments);}/***/}),(/* 151 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony export (immutable) */__webpack_exports__["a"]=threshold;/* harmony import */var __WEBPACK_IMPORTED_MODULE_0_d3_array__=__webpack_require__(3);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__array__=__webpack_require__(7);/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__init__=__webpack_require__(1);function threshold(){var domain=[0.5],range=[0,1],unknown,n=1;function scale(x){return x<=x?range[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b"/* bisect */])(domain,x,0,n)]:unknown;}scale.domain=function(_){return arguments.length?(domain=__WEBPACK_IMPORTED_MODULE_1__array__["b"/* slice */].call(_),n=Math.min(domain.length,range.length-1),scale):domain.slice();};scale.range=function(_){return arguments.length?(range=__WEBPACK_IMPORTED_MODULE_1__array__["b"/* slice */].call(_),n=Math.min(domain.length,range.length-1),scale):range.slice();};scale.invertExtent=function(y){var i=range.indexOf(y);return [domain[i-1],domain[i]];};scale.unknown=function(_){return arguments.length?(unknown=_,scale):unknown;};scale.copy=function(){return threshold().domain(domain).range(range).unknown(unknown);};return __WEBPACK_IMPORTED_MODULE_2__init__["b"/* initRange */].apply(scale,arguments);}/***/}),(/* 152 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__time__=__webpack_require__(70);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1_d3_time_format__=__webpack_require__(77);/* harmony import */var __WEBPACK_IMPORTED_MODULE_2_d3_time__=__webpack_require__(36);/* harmony import */var __WEBPACK_IMPORTED_MODULE_3__init__=__webpack_require__(1);/* harmony default export */__webpack_exports__["a"]=function(){return __WEBPACK_IMPORTED_MODULE_3__init__["b"/* initRange */].apply(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__time__["b"/* calendar */])(__WEBPACK_IMPORTED_MODULE_2_d3_time__["a"/* utcYear */],__WEBPACK_IMPORTED_MODULE_2_d3_time__["b"/* utcMonth */],__WEBPACK_IMPORTED_MODULE_2_d3_time__["c"/* utcWeek */],__WEBPACK_IMPORTED_MODULE_2_d3_time__["d"/* utcDay */],__WEBPACK_IMPORTED_MODULE_2_d3_time__["e"/* utcHour */],__WEBPACK_IMPORTED_MODULE_2_d3_time__["f"/* utcMinute */],__WEBPACK_IMPORTED_MODULE_2_d3_time__["g"/* utcSecond */],__WEBPACK_IMPORTED_MODULE_2_d3_time__["h"/* utcMillisecond */],__WEBPACK_IMPORTED_MODULE_1_d3_time_format__["a"/* utcFormat */]).domain([Date.UTC(2000,0,1),Date.UTC(2000,0,2)]),arguments);};/***/}),(/* 153 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony default export */__webpack_exports__["a"]=function(x){return function(){return x;};};/***/}),(/* 154 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__creator__=__webpack_require__(17);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__select__=__webpack_require__(72);/* harmony default export */__webpack_exports__["a"]=function(name){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__select__["a"/* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__creator__["a"/* default */])(name).call(document.documentElement));};/***/}),(/* 155 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony export (immutable) */__webpack_exports__["a"]=local;var nextId=0;function local(){return new Local();}function Local(){this._="@"+(++nextId).toString(36);}Local.prototype=local.prototype={constructor:Local,get:function(node){var id=this._;while(!(id in node))if(!(node=node.parentNode))return;return node[id];},set:function(node,value){return node[this._]=value;},remove:function(node){return this._ in node&&delete node[this._];},toString:function(){return this._;}};/***/}),(/* 156 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__sourceEvent__=__webpack_require__(33);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__point__=__webpack_require__(18);/* harmony default export */__webpack_exports__["a"]=function(node){var event=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sourceEvent__["a"/* default */])();if(event.changedTouches)event=event.changedTouches[0];return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__point__["a"/* default */])(node,event);};/***/}),(/* 157 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__selection_index__=__webpack_require__(2);/* harmony default export */__webpack_exports__["a"]=function(selector){return typeof selector==="string"?new __WEBPACK_IMPORTED_MODULE_0__selection_index__["b"/* Selection */]([document.querySelectorAll(selector)],[document.documentElement]):new __WEBPACK_IMPORTED_MODULE_0__selection_index__["b"/* Selection */]([selector==null?[]:selector],__WEBPACK_IMPORTED_MODULE_0__selection_index__["c"/* root */]);};/***/}),(/* 158 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__creator__=__webpack_require__(17);/* harmony default export */__webpack_exports__["a"]=function(name){var create=typeof name==="function"?name:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__creator__["a"/* default */])(name);return this.select(function(){return this.appendChild(create.apply(this,arguments));});};/***/}),(/* 159 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__namespace__=__webpack_require__(29);function attrRemove(name){return function(){this.removeAttribute(name);};}function attrRemoveNS(fullname){return function(){this.removeAttributeNS(fullname.space,fullname.local);};}function attrConstant(name,value){return function(){this.setAttribute(name,value);};}function attrConstantNS(fullname,value){return function(){this.setAttributeNS(fullname.space,fullname.local,value);};}function attrFunction(name,value){return function(){var v=value.apply(this,arguments);if(v==null)this.removeAttribute(name);else this.setAttribute(name,v);};}function attrFunctionNS(fullname,value){return function(){var v=value.apply(this,arguments);if(v==null)this.removeAttributeNS(fullname.space,fullname.local);else this.setAttributeNS(fullname.space,fullname.local,v);};}/* harmony default export */__webpack_exports__["a"]=function(name,value){var fullname=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__namespace__["a"/* default */])(name);if(arguments.length<2){var node=this.node();return fullname.local?node.getAttributeNS(fullname.space,fullname.local):node.getAttribute(fullname);}return this.each((value==null?fullname.local?attrRemoveNS:attrRemove:typeof value==="function"?fullname.local?attrFunctionNS:attrFunction:fullname.local?attrConstantNS:attrConstant)(fullname,value));};/***/}),(/* 160 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony default export */__webpack_exports__["a"]=function(){var callback=arguments[0];arguments[0]=this;callback.apply(null,arguments);return this;};/***/}),(/* 161 */ /***/function(module,__webpack_exports__,__webpack_require__){function classArray(string){return string.trim().split(/^|\s+/);}function classList(node){return node.classList||new ClassList(node);}function ClassList(node){this._node=node;this._names=classArray(node.getAttribute("class")||"");}ClassList.prototype={add:function(name){var i=this._names.indexOf(name);if(i<0){this._names.push(name);this._node.setAttribute("class",this._names.join(" "));}},remove:function(name){var i=this._names.indexOf(name);if(i>=0){this._names.splice(i,1);this._node.setAttribute("class",this._names.join(" "));}},contains:function(name){return this._names.indexOf(name)>=0;}};function classedAdd(node,names){var list=classList(node),i=-1,n=names.length;while(++i<n)list.add(names[i]);}function classedRemove(node,names){var list=classList(node),i=-1,n=names.length;while(++i<n)list.remove(names[i]);}function classedTrue(names){return function(){classedAdd(this,names);};}function classedFalse(names){return function(){classedRemove(this,names);};}function classedFunction(names,value){return function(){(value.apply(this,arguments)?classedAdd:classedRemove)(this,names);};}/* harmony default export */__webpack_exports__["a"]=function(name,value){var names=classArray(name+"");if(arguments.length<2){var list=classList(this.node()),i=-1,n=names.length;while(++i<n)if(!list.contains(names[i]))return false;return true;}return this.each((typeof value==="function"?classedFunction:value?classedTrue:classedFalse)(names,value));};/***/}),(/* 162 */ /***/function(module,__webpack_exports__,__webpack_require__){function selection_cloneShallow(){return this.parentNode.insertBefore(this.cloneNode(false),this.nextSibling);}function selection_cloneDeep(){return this.parentNode.insertBefore(this.cloneNode(true),this.nextSibling);}/* harmony default export */__webpack_exports__["a"]=function(deep){return this.select(deep?selection_cloneDeep:selection_cloneShallow);};/***/}),(/* 163 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__index__=__webpack_require__(2);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__enter__=__webpack_require__(73);/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__constant__=__webpack_require__(153);var keyPrefix="$";// Protect against keys like “__proto__”.
function bindIndex(parent,group,enter,update,exit,data){var i=0,node,groupLength=group.length,dataLength=data.length;// Put any non-null nodes that fit into update.
// Put any null nodes into enter.
// Put any remaining data into enter.
for(;i<dataLength;++i){if(node=group[i]){node.__data__=data[i];update[i]=node;}else {enter[i]=new __WEBPACK_IMPORTED_MODULE_1__enter__["b"/* EnterNode */](parent,data[i]);}}// Put any non-null nodes that don’t fit into exit.
for(;i<groupLength;++i){if(node=group[i]){exit[i]=node;}}}function bindKey(parent,group,enter,update,exit,data,key){var i,node,nodeByKeyValue={},groupLength=group.length,dataLength=data.length,keyValues=new Array(groupLength),keyValue;// Compute the key for each node.
// If multiple nodes have the same key, the duplicates are added to exit.
for(i=0;i<groupLength;++i){if(node=group[i]){keyValues[i]=keyValue=keyPrefix+key.call(node,node.__data__,i,group);if(keyValue in nodeByKeyValue){exit[i]=node;}else {nodeByKeyValue[keyValue]=node;}}}// Compute the key for each datum.
// If there a node associated with this key, join and add it to update.
// If there is not (or the key is a duplicate), add it to enter.
for(i=0;i<dataLength;++i){keyValue=keyPrefix+key.call(parent,data[i],i,data);if(node=nodeByKeyValue[keyValue]){update[i]=node;node.__data__=data[i];nodeByKeyValue[keyValue]=null;}else {enter[i]=new __WEBPACK_IMPORTED_MODULE_1__enter__["b"/* EnterNode */](parent,data[i]);}}// Add any remaining nodes that were not bound to data to exit.
for(i=0;i<groupLength;++i){if((node=group[i])&&nodeByKeyValue[keyValues[i]]===node){exit[i]=node;}}}/* harmony default export */__webpack_exports__["a"]=function(value,key){if(!value){data=new Array(this.size()),j=-1;this.each(function(d){data[++j]=d;});return data;}var bind=key?bindKey:bindIndex,parents=this._parents,groups=this._groups;if(typeof value!=="function")value=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a"/* default */])(value);for(var m=groups.length,update=new Array(m),enter=new Array(m),exit=new Array(m),j=0;j<m;++j){var parent=parents[j],group=groups[j],groupLength=group.length,data=value.call(parent,parent&&parent.__data__,j,parents),dataLength=data.length,enterGroup=enter[j]=new Array(dataLength),updateGroup=update[j]=new Array(dataLength),exitGroup=exit[j]=new Array(groupLength);bind(parent,group,enterGroup,updateGroup,exitGroup,data,key);// Now connect the enter nodes to their following update node, such that
// appendChild can insert the materialized enter node before this node,
// rather than at the end of the parent node.
for(var i0=0,i1=0,previous,next;i0<dataLength;++i0){if(previous=enterGroup[i0]){if(i0>=i1)i1=i0+1;while(!(next=updateGroup[i1])&&++i1<dataLength);previous._next=next||null;}}}update=new __WEBPACK_IMPORTED_MODULE_0__index__["b"/* Selection */](update,parents);update._enter=enter;update._exit=exit;return update;};/***/}),(/* 164 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony default export */__webpack_exports__["a"]=function(value){return arguments.length?this.property("__data__",value):this.node().__data__;};/***/}),(/* 165 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__window__=__webpack_require__(34);function dispatchEvent(node,type,params){var window=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__window__["a"/* default */])(node),event=window.CustomEvent;if(typeof event==="function"){event=new event(type,params);}else {event=window.document.createEvent("Event");if(params)event.initEvent(type,params.bubbles,params.cancelable),event.detail=params.detail;else event.initEvent(type,false,false);}node.dispatchEvent(event);}function dispatchConstant(type,params){return function(){return dispatchEvent(this,type,params);};}function dispatchFunction(type,params){return function(){return dispatchEvent(this,type,params.apply(this,arguments));};}/* harmony default export */__webpack_exports__["a"]=function(type,params){return this.each((typeof params==="function"?dispatchFunction:dispatchConstant)(type,params));};/***/}),(/* 166 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony default export */__webpack_exports__["a"]=function(callback){for(var groups=this._groups,j=0,m=groups.length;j<m;++j){for(var group=groups[j],i=0,n=group.length,node;i<n;++i){if(node=group[i])callback.call(node,node.__data__,i,group);}}return this;};/***/}),(/* 167 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony default export */__webpack_exports__["a"]=function(){return !this.node();};/***/}),(/* 168 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__sparse__=__webpack_require__(74);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__index__=__webpack_require__(2);/* harmony default export */__webpack_exports__["a"]=function(){return new __WEBPACK_IMPORTED_MODULE_1__index__["b"/* Selection */](this._exit||this._groups.map(__WEBPACK_IMPORTED_MODULE_0__sparse__["a"/* default */]),this._parents);};/***/}),(/* 169 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__index__=__webpack_require__(2);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__matcher__=__webpack_require__(71);/* harmony default export */__webpack_exports__["a"]=function(match){if(typeof match!=="function")match=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__matcher__["a"/* default */])(match);for(var groups=this._groups,m=groups.length,subgroups=new Array(m),j=0;j<m;++j){for(var group=groups[j],n=group.length,subgroup=subgroups[j]=[],node,i=0;i<n;++i){if((node=group[i])&&match.call(node,node.__data__,i,group)){subgroup.push(node);}}}return new __WEBPACK_IMPORTED_MODULE_0__index__["b"/* Selection */](subgroups,this._parents);};/***/}),(/* 170 */ /***/function(module,__webpack_exports__,__webpack_require__){function htmlRemove(){this.innerHTML="";}function htmlConstant(value){return function(){this.innerHTML=value;};}function htmlFunction(value){return function(){var v=value.apply(this,arguments);this.innerHTML=v==null?"":v;};}/* harmony default export */__webpack_exports__["a"]=function(value){return arguments.length?this.each(value==null?htmlRemove:(typeof value==="function"?htmlFunction:htmlConstant)(value)):this.node().innerHTML;};/***/}),(/* 171 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__creator__=__webpack_require__(17);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__selector__=__webpack_require__(32);function constantNull(){return null;}/* harmony default export */__webpack_exports__["a"]=function(name,before){var create=typeof name==="function"?name:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__creator__["a"/* default */])(name),select=before==null?constantNull:typeof before==="function"?before:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__selector__["a"/* default */])(before);return this.select(function(){return this.insertBefore(create.apply(this,arguments),select.apply(this,arguments)||null);});};/***/}),(/* 172 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony default export */__webpack_exports__["a"]=function(onenter,onupdate,onexit){var enter=this.enter(),update=this,exit=this.exit();enter=typeof onenter==="function"?onenter(enter):enter.append(onenter+"");if(onupdate!=null)update=onupdate(update);if(onexit==null)exit.remove();else onexit(exit);return enter&&update?enter.merge(update).order():update;};/***/}),(/* 173 */ /***/function(module,__webpack_exports__,__webpack_require__){function lower(){if(this.previousSibling)this.parentNode.insertBefore(this,this.parentNode.firstChild);}/* harmony default export */__webpack_exports__["a"]=function(){return this.each(lower);};/***/}),(/* 174 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__index__=__webpack_require__(2);/* harmony default export */__webpack_exports__["a"]=function(selection){for(var groups0=this._groups,groups1=selection._groups,m0=groups0.length,m1=groups1.length,m=Math.min(m0,m1),merges=new Array(m0),j=0;j<m;++j){for(var group0=groups0[j],group1=groups1[j],n=group0.length,merge=merges[j]=new Array(n),node,i=0;i<n;++i){if(node=group0[i]||group1[i]){merge[i]=node;}}}for(;j<m0;++j){merges[j]=groups0[j];}return new __WEBPACK_IMPORTED_MODULE_0__index__["b"/* Selection */](merges,this._parents);};/***/}),(/* 175 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony default export */__webpack_exports__["a"]=function(){for(var groups=this._groups,j=0,m=groups.length;j<m;++j){for(var group=groups[j],i=0,n=group.length;i<n;++i){var node=group[i];if(node)return node;}}return null;};/***/}),(/* 176 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony default export */__webpack_exports__["a"]=function(){var nodes=new Array(this.size()),i=-1;this.each(function(){nodes[++i]=this;});return nodes;};/***/}),(/* 177 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony default export */__webpack_exports__["a"]=function(){for(var groups=this._groups,j=-1,m=groups.length;++j<m;){for(var group=groups[j],i=group.length-1,next=group[i],node;--i>=0;){if(node=group[i]){if(next&&node.compareDocumentPosition(next)^4)next.parentNode.insertBefore(node,next);next=node;}}}return this;};/***/}),(/* 178 */ /***/function(module,__webpack_exports__,__webpack_require__){function propertyRemove(name){return function(){delete this[name];};}function propertyConstant(name,value){return function(){this[name]=value;};}function propertyFunction(name,value){return function(){var v=value.apply(this,arguments);if(v==null)delete this[name];else this[name]=v;};}/* harmony default export */__webpack_exports__["a"]=function(name,value){return arguments.length>1?this.each((value==null?propertyRemove:typeof value==="function"?propertyFunction:propertyConstant)(name,value)):this.node()[name];};/***/}),(/* 179 */ /***/function(module,__webpack_exports__,__webpack_require__){function raise(){if(this.nextSibling)this.parentNode.appendChild(this);}/* harmony default export */__webpack_exports__["a"]=function(){return this.each(raise);};/***/}),(/* 180 */ /***/function(module,__webpack_exports__,__webpack_require__){function remove(){var parent=this.parentNode;if(parent)parent.removeChild(this);}/* harmony default export */__webpack_exports__["a"]=function(){return this.each(remove);};/***/}),(/* 181 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__index__=__webpack_require__(2);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__selector__=__webpack_require__(32);/* harmony default export */__webpack_exports__["a"]=function(select){if(typeof select!=="function")select=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__selector__["a"/* default */])(select);for(var groups=this._groups,m=groups.length,subgroups=new Array(m),j=0;j<m;++j){for(var group=groups[j],n=group.length,subgroup=subgroups[j]=new Array(n),node,subnode,i=0;i<n;++i){if((node=group[i])&&(subnode=select.call(node,node.__data__,i,group))){if("__data__"in node)subnode.__data__=node.__data__;subgroup[i]=subnode;}}}return new __WEBPACK_IMPORTED_MODULE_0__index__["b"/* Selection */](subgroups,this._parents);};/***/}),(/* 182 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__index__=__webpack_require__(2);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__selectorAll__=__webpack_require__(76);/* harmony default export */__webpack_exports__["a"]=function(select){if(typeof select!=="function")select=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__selectorAll__["a"/* default */])(select);for(var groups=this._groups,m=groups.length,subgroups=[],parents=[],j=0;j<m;++j){for(var group=groups[j],n=group.length,node,i=0;i<n;++i){if(node=group[i]){subgroups.push(select.call(node,node.__data__,i,group));parents.push(node);}}}return new __WEBPACK_IMPORTED_MODULE_0__index__["b"/* Selection */](subgroups,parents);};/***/}),(/* 183 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony default export */__webpack_exports__["a"]=function(){var size=0;this.each(function(){++size;});return size;};/***/}),(/* 184 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__index__=__webpack_require__(2);/* harmony default export */__webpack_exports__["a"]=function(compare){if(!compare)compare=ascending;function compareNode(a,b){return a&&b?compare(a.__data__,b.__data__):!a-!b;}for(var groups=this._groups,m=groups.length,sortgroups=new Array(m),j=0;j<m;++j){for(var group=groups[j],n=group.length,sortgroup=sortgroups[j]=new Array(n),node,i=0;i<n;++i){if(node=group[i]){sortgroup[i]=node;}}sortgroup.sort(compareNode);}return new __WEBPACK_IMPORTED_MODULE_0__index__["b"/* Selection */](sortgroups,this._parents).order();};function ascending(a,b){return a<b?-1:a>b?1:a>=b?0:NaN;}/***/}),(/* 185 */ /***/function(module,__webpack_exports__,__webpack_require__){function textRemove(){this.textContent="";}function textConstant(value){return function(){this.textContent=value;};}function textFunction(value){return function(){var v=value.apply(this,arguments);this.textContent=v==null?"":v;};}/* harmony default export */__webpack_exports__["a"]=function(value){return arguments.length?this.each(value==null?textRemove:(typeof value==="function"?textFunction:textConstant)(value)):this.node().textContent;};/***/}),(/* 186 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__sourceEvent__=__webpack_require__(33);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__point__=__webpack_require__(18);/* harmony default export */__webpack_exports__["a"]=function(node,touches,identifier){if(arguments.length<3)identifier=touches,touches=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sourceEvent__["a"/* default */])().changedTouches;for(var i=0,n=touches?touches.length:0,touch;i<n;++i){if((touch=touches[i]).identifier===identifier){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__point__["a"/* default */])(node,touch);}}return null;};/***/}),(/* 187 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__sourceEvent__=__webpack_require__(33);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__point__=__webpack_require__(18);/* harmony default export */__webpack_exports__["a"]=function(node,touches){if(touches==null)touches=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sourceEvent__["a"/* default */])().touches;for(var i=0,n=touches?touches.length:0,points=new Array(n);i<n;++i){points[i]=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__point__["a"/* default */])(node,touches[i]);}return points;};/***/}),(/* 188 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__isoFormat__=__webpack_require__(78);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__defaultLocale__=__webpack_require__(35);function parseIsoNative(string){var date=new Date(string);return isNaN(date)?null:date;}+new Date("2000-01-01T00:00:00.000Z")?parseIsoNative:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__defaultLocale__["b"/* utcParse */])(__WEBPACK_IMPORTED_MODULE_0__isoFormat__["a"/* isoSpecifier */]);/***/}),(/* 189 */ /***/function(module,__webpack_exports__,__webpack_require__){/* unused harmony export days */ /* harmony import */var __WEBPACK_IMPORTED_MODULE_0__interval_js__=__webpack_require__(0);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__duration_js__=__webpack_require__(4);var day=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a"/* default */])(function(date){date.setHours(0,0,0,0);},function(date,step){date.setDate(date.getDate()+step);},function(start,end){return (end-start-(end.getTimezoneOffset()-start.getTimezoneOffset())*__WEBPACK_IMPORTED_MODULE_1__duration_js__["d"/* durationMinute */])/__WEBPACK_IMPORTED_MODULE_1__duration_js__["b"/* durationDay */];},function(date){return date.getDate()-1;});/* harmony default export */__webpack_exports__["a"]=day;day.range;/***/}),(/* 190 */ /***/function(module,__webpack_exports__,__webpack_require__){/* unused harmony export hours */ /* harmony import */var __WEBPACK_IMPORTED_MODULE_0__interval_js__=__webpack_require__(0);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__duration_js__=__webpack_require__(4);var hour=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a"/* default */])(function(date){date.setTime(date-date.getMilliseconds()-date.getSeconds()*__WEBPACK_IMPORTED_MODULE_1__duration_js__["e"/* durationSecond */]-date.getMinutes()*__WEBPACK_IMPORTED_MODULE_1__duration_js__["d"/* durationMinute */]);},function(date,step){date.setTime(+date+step*__WEBPACK_IMPORTED_MODULE_1__duration_js__["c"/* durationHour */]);},function(start,end){return (end-start)/__WEBPACK_IMPORTED_MODULE_1__duration_js__["c"/* durationHour */];},function(date){return date.getHours();});/* harmony default export */__webpack_exports__["a"]=hour;hour.range;/***/}),(/* 191 */ /***/function(module,__webpack_exports__,__webpack_require__){/* unused harmony export milliseconds */ /* harmony import */var __WEBPACK_IMPORTED_MODULE_0__interval_js__=__webpack_require__(0);var millisecond=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a"/* default */])(function(){// noop
},function(date,step){date.setTime(+date+step);},function(start,end){return end-start;});// An optimized implementation for this simple case.
millisecond.every=function(k){k=Math.floor(k);if(!isFinite(k)||!(k>0))return null;if(!(k>1))return millisecond;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a"/* default */])(function(date){date.setTime(Math.floor(date/k)*k);},function(date,step){date.setTime(+date+step*k);},function(start,end){return (end-start)/k;});};/* harmony default export */__webpack_exports__["a"]=millisecond;millisecond.range;/***/}),(/* 192 */ /***/function(module,__webpack_exports__,__webpack_require__){/* unused harmony export minutes */ /* harmony import */var __WEBPACK_IMPORTED_MODULE_0__interval_js__=__webpack_require__(0);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__duration_js__=__webpack_require__(4);var minute=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a"/* default */])(function(date){date.setTime(date-date.getMilliseconds()-date.getSeconds()*__WEBPACK_IMPORTED_MODULE_1__duration_js__["e"/* durationSecond */]);},function(date,step){date.setTime(+date+step*__WEBPACK_IMPORTED_MODULE_1__duration_js__["d"/* durationMinute */]);},function(start,end){return (end-start)/__WEBPACK_IMPORTED_MODULE_1__duration_js__["d"/* durationMinute */];},function(date){return date.getMinutes();});/* harmony default export */__webpack_exports__["a"]=minute;minute.range;/***/}),(/* 193 */ /***/function(module,__webpack_exports__,__webpack_require__){/* unused harmony export months */ /* harmony import */var __WEBPACK_IMPORTED_MODULE_0__interval_js__=__webpack_require__(0);var month=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a"/* default */])(function(date){date.setDate(1);date.setHours(0,0,0,0);},function(date,step){date.setMonth(date.getMonth()+step);},function(start,end){return end.getMonth()-start.getMonth()+(end.getFullYear()-start.getFullYear())*12;},function(date){return date.getMonth();});/* harmony default export */__webpack_exports__["a"]=month;month.range;/***/}),(/* 194 */ /***/function(module,__webpack_exports__,__webpack_require__){/* unused harmony export seconds */ /* harmony import */var __WEBPACK_IMPORTED_MODULE_0__interval_js__=__webpack_require__(0);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__duration_js__=__webpack_require__(4);var second=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a"/* default */])(function(date){date.setTime(date-date.getMilliseconds());},function(date,step){date.setTime(+date+step*__WEBPACK_IMPORTED_MODULE_1__duration_js__["e"/* durationSecond */]);},function(start,end){return (end-start)/__WEBPACK_IMPORTED_MODULE_1__duration_js__["e"/* durationSecond */];},function(date){return date.getUTCSeconds();});/* harmony default export */__webpack_exports__["a"]=second;second.range;/***/}),(/* 195 */ /***/function(module,__webpack_exports__,__webpack_require__){/* unused harmony export utcDays */ /* harmony import */var __WEBPACK_IMPORTED_MODULE_0__interval_js__=__webpack_require__(0);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__duration_js__=__webpack_require__(4);var utcDay=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a"/* default */])(function(date){date.setUTCHours(0,0,0,0);},function(date,step){date.setUTCDate(date.getUTCDate()+step);},function(start,end){return (end-start)/__WEBPACK_IMPORTED_MODULE_1__duration_js__["b"/* durationDay */];},function(date){return date.getUTCDate()-1;});/* harmony default export */__webpack_exports__["a"]=utcDay;utcDay.range;/***/}),(/* 196 */ /***/function(module,__webpack_exports__,__webpack_require__){/* unused harmony export utcHours */ /* harmony import */var __WEBPACK_IMPORTED_MODULE_0__interval_js__=__webpack_require__(0);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__duration_js__=__webpack_require__(4);var utcHour=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a"/* default */])(function(date){date.setUTCMinutes(0,0,0);},function(date,step){date.setTime(+date+step*__WEBPACK_IMPORTED_MODULE_1__duration_js__["c"/* durationHour */]);},function(start,end){return (end-start)/__WEBPACK_IMPORTED_MODULE_1__duration_js__["c"/* durationHour */];},function(date){return date.getUTCHours();});/* harmony default export */__webpack_exports__["a"]=utcHour;utcHour.range;/***/}),(/* 197 */ /***/function(module,__webpack_exports__,__webpack_require__){/* unused harmony export utcMinutes */ /* harmony import */var __WEBPACK_IMPORTED_MODULE_0__interval_js__=__webpack_require__(0);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__duration_js__=__webpack_require__(4);var utcMinute=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a"/* default */])(function(date){date.setUTCSeconds(0,0);},function(date,step){date.setTime(+date+step*__WEBPACK_IMPORTED_MODULE_1__duration_js__["d"/* durationMinute */]);},function(start,end){return (end-start)/__WEBPACK_IMPORTED_MODULE_1__duration_js__["d"/* durationMinute */];},function(date){return date.getUTCMinutes();});/* harmony default export */__webpack_exports__["a"]=utcMinute;utcMinute.range;/***/}),(/* 198 */ /***/function(module,__webpack_exports__,__webpack_require__){/* unused harmony export utcMonths */ /* harmony import */var __WEBPACK_IMPORTED_MODULE_0__interval_js__=__webpack_require__(0);var utcMonth=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a"/* default */])(function(date){date.setUTCDate(1);date.setUTCHours(0,0,0,0);},function(date,step){date.setUTCMonth(date.getUTCMonth()+step);},function(start,end){return end.getUTCMonth()-start.getUTCMonth()+(end.getUTCFullYear()-start.getUTCFullYear())*12;},function(date){return date.getUTCMonth();});/* harmony default export */__webpack_exports__["a"]=utcMonth;utcMonth.range;/***/}),(/* 199 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony export (binding) */__webpack_require__.d(__webpack_exports__,"a",function(){return utcSunday;});/* harmony export (binding) */__webpack_require__.d(__webpack_exports__,"b",function(){return utcMonday;});/* unused harmony export utcTuesday */ /* unused harmony export utcWednesday */ /* harmony export (binding) */__webpack_require__.d(__webpack_exports__,"c",function(){return utcThursday;});/* unused harmony export utcFriday */ /* unused harmony export utcSaturday */ /* unused harmony export utcSundays */ /* unused harmony export utcMondays */ /* unused harmony export utcTuesdays */ /* unused harmony export utcWednesdays */ /* unused harmony export utcThursdays */ /* unused harmony export utcFridays */ /* unused harmony export utcSaturdays */ /* harmony import */var __WEBPACK_IMPORTED_MODULE_0__interval_js__=__webpack_require__(0);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__duration_js__=__webpack_require__(4);function utcWeekday(i){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a"/* default */])(function(date){date.setUTCDate(date.getUTCDate()-(date.getUTCDay()+7-i)%7);date.setUTCHours(0,0,0,0);},function(date,step){date.setUTCDate(date.getUTCDate()+step*7);},function(start,end){return (end-start)/__WEBPACK_IMPORTED_MODULE_1__duration_js__["a"/* durationWeek */];});}var utcSunday=utcWeekday(0);var utcMonday=utcWeekday(1);var utcTuesday=utcWeekday(2);var utcWednesday=utcWeekday(3);var utcThursday=utcWeekday(4);var utcFriday=utcWeekday(5);var utcSaturday=utcWeekday(6);utcSunday.range;utcMonday.range;utcTuesday.range;utcWednesday.range;utcThursday.range;utcFriday.range;utcSaturday.range;/***/}),(/* 200 */ /***/function(module,__webpack_exports__,__webpack_require__){/* unused harmony export utcYears */ /* harmony import */var __WEBPACK_IMPORTED_MODULE_0__interval_js__=__webpack_require__(0);var utcYear=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a"/* default */])(function(date){date.setUTCMonth(0,1);date.setUTCHours(0,0,0,0);},function(date,step){date.setUTCFullYear(date.getUTCFullYear()+step);},function(start,end){return end.getUTCFullYear()-start.getUTCFullYear();},function(date){return date.getUTCFullYear();});// An optimized implementation for this simple case.
utcYear.every=function(k){return !isFinite(k=Math.floor(k))||!(k>0)?null:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a"/* default */])(function(date){date.setUTCFullYear(Math.floor(date.getUTCFullYear()/k)*k);date.setUTCMonth(0,1);date.setUTCHours(0,0,0,0);},function(date,step){date.setUTCFullYear(date.getUTCFullYear()+step*k);});};/* harmony default export */__webpack_exports__["a"]=utcYear;utcYear.range;/***/}),(/* 201 */ /***/function(module,__webpack_exports__,__webpack_require__){/* harmony export (binding) */__webpack_require__.d(__webpack_exports__,"a",function(){return sunday;});/* harmony export (binding) */__webpack_require__.d(__webpack_exports__,"b",function(){return monday;});/* unused harmony export tuesday */ /* unused harmony export wednesday */ /* harmony export (binding) */__webpack_require__.d(__webpack_exports__,"c",function(){return thursday;});/* unused harmony export friday */ /* unused harmony export saturday */ /* unused harmony export sundays */ /* unused harmony export mondays */ /* unused harmony export tuesdays */ /* unused harmony export wednesdays */ /* unused harmony export thursdays */ /* unused harmony export fridays */ /* unused harmony export saturdays */ /* harmony import */var __WEBPACK_IMPORTED_MODULE_0__interval_js__=__webpack_require__(0);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__duration_js__=__webpack_require__(4);function weekday(i){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a"/* default */])(function(date){date.setDate(date.getDate()-(date.getDay()+7-i)%7);date.setHours(0,0,0,0);},function(date,step){date.setDate(date.getDate()+step*7);},function(start,end){return (end-start-(end.getTimezoneOffset()-start.getTimezoneOffset())*__WEBPACK_IMPORTED_MODULE_1__duration_js__["d"/* durationMinute */])/__WEBPACK_IMPORTED_MODULE_1__duration_js__["a"/* durationWeek */];});}var sunday=weekday(0);var monday=weekday(1);var tuesday=weekday(2);var wednesday=weekday(3);var thursday=weekday(4);var friday=weekday(5);var saturday=weekday(6);sunday.range;monday.range;tuesday.range;wednesday.range;thursday.range;friday.range;saturday.range;/***/}),(/* 202 */ /***/function(module,__webpack_exports__,__webpack_require__){/* unused harmony export years */ /* harmony import */var __WEBPACK_IMPORTED_MODULE_0__interval_js__=__webpack_require__(0);var year=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a"/* default */])(function(date){date.setMonth(0,1);date.setHours(0,0,0,0);},function(date,step){date.setFullYear(date.getFullYear()+step);},function(start,end){return end.getFullYear()-start.getFullYear();},function(date){return date.getFullYear();});// An optimized implementation for this simple case.
year.every=function(k){return !isFinite(k=Math.floor(k))||!(k>0)?null:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a"/* default */])(function(date){date.setFullYear(Math.floor(date.getFullYear()/k)*k);date.setMonth(0,1);date.setHours(0,0,0,0);},function(date,step){date.setFullYear(date.getFullYear()+step*k);});};/* harmony default export */__webpack_exports__["a"]=year;year.range;/***/}),(/* 203 */ /***/function(module,exports,__webpack_require__){/*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  */ /* eslint-disable no-unused-vars */var getOwnPropertySymbols=Object.getOwnPropertySymbols;var hasOwnProperty=Object.prototype.hasOwnProperty;var propIsEnumerable=Object.prototype.propertyIsEnumerable;function toObject(val){if(val===null||val===undefined){throw new TypeError('Object.assign cannot be called with null or undefined');}return Object(val);}function shouldUseNative(){try{if(!Object.assign){return false;}// Detect buggy property enumeration order in older V8 versions.
// https://bugs.chromium.org/p/v8/issues/detail?id=4118
var test1=new String('abc');// eslint-disable-line no-new-wrappers
test1[5]='de';if(Object.getOwnPropertyNames(test1)[0]==='5'){return false;}// https://bugs.chromium.org/p/v8/issues/detail?id=3056
var test2={};for(var i=0;i<10;i++){test2['_'+String.fromCharCode(i)]=i;}var order2=Object.getOwnPropertyNames(test2).map(function(n){return test2[n];});if(order2.join('')!=='0123456789'){return false;}// https://bugs.chromium.org/p/v8/issues/detail?id=3056
var test3={};'abcdefghijklmnopqrst'.split('').forEach(function(letter){test3[letter]=letter;});if(Object.keys(Object.assign({},test3)).join('')!=='abcdefghijklmnopqrst'){return false;}return true;}catch(err){// We don't expect any of the above to throw, but better to be safe.
return false;}}module.exports=shouldUseNative()?Object.assign:function(target,source){var from;var to=toObject(target);var symbols;for(var s=1;s<arguments.length;s++){from=Object(arguments[s]);for(var key in from){if(hasOwnProperty.call(from,key)){to[key]=from[key];}}if(getOwnPropertySymbols){symbols=getOwnPropertySymbols(from);for(var i=0;i<symbols.length;i++){if(propIsEnumerable.call(from,symbols[i])){to[symbols[i]]=from[symbols[i]];}}}}return to;};/***/}),(/* 204 */ /***/function(module,exports,__webpack_require__){/* WEBPACK VAR INJECTION */(function(process){/**
    * Copyright (c) 2013-present, Facebook, Inc.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE file in the root directory of this source tree.
    */var printWarning=function(){};if(process.env.NODE_ENV!=='production'){var ReactPropTypesSecret=__webpack_require__(37);var loggedTypeFailures={};var has=Function.call.bind(Object.prototype.hasOwnProperty);printWarning=function(text){var message='Warning: '+text;if(typeof console!=='undefined'){console.error(message);}try{// --- Welcome to debugging React ---
// This error was thrown as a convenience so that you can use this stack
// to find the callsite that caused this warning to fire.
throw new Error(message);}catch(x){}};}/**
     * Assert that the values match with the type specs.
     * Error messages are memorized and will only be shown once.
     *
     * @param {object} typeSpecs Map of name to a ReactPropType
     * @param {object} values Runtime values that need to be type-checked
     * @param {string} location e.g. "prop", "context", "child context"
     * @param {string} componentName Name of the component for error messages.
     * @param {?Function} getStack Returns the component stack.
     * @private
     */function checkPropTypes(typeSpecs,values,location,componentName,getStack){if(process.env.NODE_ENV!=='production'){for(var typeSpecName in typeSpecs){if(has(typeSpecs,typeSpecName)){var error;// Prop type validation may throw. In case they do, we don't want to
// fail the render phase where it didn't fail before. So we log it.
// After these have been cleaned up, we'll let them throw.
try{// This is intentionally an invariant that gets caught. It's the same
// behavior as without this statement except with a better message.
if(typeof typeSpecs[typeSpecName]!=='function'){var err=Error((componentName||'React class')+': '+location+' type `'+typeSpecName+'` is invalid; '+'it must be a function, usually from the `prop-types` package, but received `'+typeof typeSpecs[typeSpecName]+'`.');err.name='Invariant Violation';throw err;}error=typeSpecs[typeSpecName](values,typeSpecName,componentName,location,null,ReactPropTypesSecret);}catch(ex){error=ex;}if(error&&!(error instanceof Error)){printWarning((componentName||'React class')+': type specification of '+location+' `'+typeSpecName+'` is invalid; the type checker '+'function must return `null` or an `Error` but returned a '+typeof error+'. '+'You may have forgotten to pass an argument to the type checker '+'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and '+'shape all require an argument).');}if(error instanceof Error&&!(error.message in loggedTypeFailures)){// Only monitor this failure once because there tends to be a lot of the
// same error.
loggedTypeFailures[error.message]=true;var stack=getStack?getStack():'';printWarning('Failed '+location+' type: '+error.message+(stack!=null?stack:''));}}}}}/**
     * Resets warning cache when testing.
     *
     * @private
     */checkPropTypes.resetWarningCache=function(){if(process.env.NODE_ENV!=='production'){loggedTypeFailures={};}};module.exports=checkPropTypes;/* WEBPACK VAR INJECTION */}).call(exports,__webpack_require__(13));/***/}),(/* 205 */ /***/function(module,exports,__webpack_require__){/**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */var ReactPropTypesSecret=__webpack_require__(37);function emptyFunction(){}function emptyFunctionWithReset(){}emptyFunctionWithReset.resetWarningCache=emptyFunction;module.exports=function(){function shim(props,propName,componentName,location,propFullName,secret){if(secret===ReactPropTypesSecret){// It is still safe when called from React.
return;}var err=new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. '+'Use PropTypes.checkPropTypes() to call them. '+'Read more at http://fb.me/use-check-prop-types');err.name='Invariant Violation';throw err;}shim.isRequired=shim;function getShim(){return shim;}// Important!
// Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
var ReactPropTypes={array:shim,bool:shim,func:shim,number:shim,object:shim,string:shim,symbol:shim,any:shim,arrayOf:getShim,element:shim,elementType:shim,instanceOf:getShim,node:shim,objectOf:getShim,oneOf:getShim,oneOfType:getShim,shape:getShim,exact:getShim,checkPropTypes:emptyFunctionWithReset,resetWarningCache:emptyFunction};ReactPropTypes.PropTypes=ReactPropTypes;return ReactPropTypes;};/***/}),(/* 206 */ /***/function(module,exports,__webpack_require__){/* WEBPACK VAR INJECTION */(function(process){/**
    * Copyright (c) 2013-present, Facebook, Inc.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE file in the root directory of this source tree.
    */var ReactIs=__webpack_require__(80);var assign=__webpack_require__(203);var ReactPropTypesSecret=__webpack_require__(37);var checkPropTypes=__webpack_require__(204);var has=Function.call.bind(Object.prototype.hasOwnProperty);var printWarning=function(){};if(process.env.NODE_ENV!=='production'){printWarning=function(text){var message='Warning: '+text;if(typeof console!=='undefined'){console.error(message);}try{// --- Welcome to debugging React ---
// This error was thrown as a convenience so that you can use this stack
// to find the callsite that caused this warning to fire.
throw new Error(message);}catch(x){}};}function emptyFunctionThatReturnsNull(){return null;}module.exports=function(isValidElement,throwOnDirectAccess){/* global Symbol */var ITERATOR_SYMBOL=typeof Symbol==='function'&&Symbol.iterator;var FAUX_ITERATOR_SYMBOL='@@iterator';// Before Symbol spec.
/**
       * Returns the iterator method function contained on the iterable object.
       *
       * Be sure to invoke the function with the iterable as context:
       *
       *     var iteratorFn = getIteratorFn(myIterable);
       *     if (iteratorFn) {
       *       var iterator = iteratorFn.call(myIterable);
       *       ...
       *     }
       *
       * @param {?object} maybeIterable
       * @return {?function}
       */function getIteratorFn(maybeIterable){var iteratorFn=maybeIterable&&(ITERATOR_SYMBOL&&maybeIterable[ITERATOR_SYMBOL]||maybeIterable[FAUX_ITERATOR_SYMBOL]);if(typeof iteratorFn==='function'){return iteratorFn;}}/**
       * Collection of methods that allow declaration and validation of props that are
       * supplied to React components. Example usage:
       *
       *   var Props = require('ReactPropTypes');
       *   var MyArticle = React.createClass({
       *     propTypes: {
       *       // An optional string prop named "description".
       *       description: Props.string,
       *
       *       // A required enum prop named "category".
       *       category: Props.oneOf(['News','Photos']).isRequired,
       *
       *       // A prop named "dialog" that requires an instance of Dialog.
       *       dialog: Props.instanceOf(Dialog).isRequired
       *     },
       *     render: function() { ... }
       *   });
       *
       * A more formal specification of how these methods are used:
       *
       *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
       *   decl := ReactPropTypes.{type}(.isRequired)?
       *
       * Each and every declaration produces a function with the same signature. This
       * allows the creation of custom validation functions. For example:
       *
       *  var MyLink = React.createClass({
       *    propTypes: {
       *      // An optional string or URI prop named "href".
       *      href: function(props, propName, componentName) {
       *        var propValue = props[propName];
       *        if (propValue != null && typeof propValue !== 'string' &&
       *            !(propValue instanceof URI)) {
       *          return new Error(
       *            'Expected a string or an URI for ' + propName + ' in ' +
       *            componentName
       *          );
       *        }
       *      }
       *    },
       *    render: function() {...}
       *  });
       *
       * @internal
       */var ANONYMOUS='<<anonymous>>';// Important!
// Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
var ReactPropTypes={array:createPrimitiveTypeChecker('array'),bool:createPrimitiveTypeChecker('boolean'),func:createPrimitiveTypeChecker('function'),number:createPrimitiveTypeChecker('number'),object:createPrimitiveTypeChecker('object'),string:createPrimitiveTypeChecker('string'),symbol:createPrimitiveTypeChecker('symbol'),any:createAnyTypeChecker(),arrayOf:createArrayOfTypeChecker,element:createElementTypeChecker(),elementType:createElementTypeTypeChecker(),instanceOf:createInstanceTypeChecker,node:createNodeChecker(),objectOf:createObjectOfTypeChecker,oneOf:createEnumTypeChecker,oneOfType:createUnionTypeChecker,shape:createShapeTypeChecker,exact:createStrictShapeTypeChecker};/**
       * inlined Object.is polyfill to avoid requiring consumers ship their own
       * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
       */ /*eslint-disable no-self-compare*/function is(x,y){// SameValue algorithm
if(x===y){// Steps 1-5, 7-10
// Steps 6.b-6.e: +0 != -0
return x!==0||1/x===1/y;}else {// Step 6.a: NaN == NaN
return x!==x&&y!==y;}}/*eslint-enable no-self-compare*/ /**
       * We use an Error-like object for backward compatibility as people may call
       * PropTypes directly and inspect their output. However, we don't use real
       * Errors anymore. We don't inspect their stack anyway, and creating them
       * is prohibitively expensive if they are created too often, such as what
       * happens in oneOfType() for any type before the one that matched.
       */function PropTypeError(message){this.message=message;this.stack='';}// Make `instanceof Error` still work for returned errors.
PropTypeError.prototype=Error.prototype;function createChainableTypeChecker(validate){if(process.env.NODE_ENV!=='production'){var manualPropTypeCallCache={};var manualPropTypeWarningCount=0;}function checkType(isRequired,props,propName,componentName,location,propFullName,secret){componentName=componentName||ANONYMOUS;propFullName=propFullName||propName;if(secret!==ReactPropTypesSecret){if(throwOnDirectAccess){// New behavior only for users of `prop-types` package
var err=new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. '+'Use `PropTypes.checkPropTypes()` to call them. '+'Read more at http://fb.me/use-check-prop-types');err.name='Invariant Violation';throw err;}else if(process.env.NODE_ENV!=='production'&&typeof console!=='undefined'){// Old behavior for people using React.PropTypes
var cacheKey=componentName+':'+propName;if(!manualPropTypeCallCache[cacheKey]&&// Avoid spamming the console because they are often not actionable except for lib authors
manualPropTypeWarningCount<3){printWarning('You are manually calling a React.PropTypes validation '+'function for the `'+propFullName+'` prop on `'+componentName+'`. This is deprecated '+'and will throw in the standalone `prop-types` package. '+'You may be seeing this warning due to a third-party PropTypes '+'library. See https://fb.me/react-warning-dont-call-proptypes '+'for details.');manualPropTypeCallCache[cacheKey]=true;manualPropTypeWarningCount++;}}}if(props[propName]==null){if(isRequired){if(props[propName]===null){return new PropTypeError('The '+location+' `'+propFullName+'` is marked as required '+('in `'+componentName+'`, but its value is `null`.'));}return new PropTypeError('The '+location+' `'+propFullName+'` is marked as required in '+('`'+componentName+'`, but its value is `undefined`.'));}return null;}else {return validate(props,propName,componentName,location,propFullName);}}var chainedCheckType=checkType.bind(null,false);chainedCheckType.isRequired=checkType.bind(null,true);return chainedCheckType;}function createPrimitiveTypeChecker(expectedType){function validate(props,propName,componentName,location,propFullName,secret){var propValue=props[propName];var propType=getPropType(propValue);if(propType!==expectedType){// `propValue` being instance of, say, date/regexp, pass the 'object'
// check, but we can offer a more precise error message here rather than
// 'of type `object`'.
var preciseType=getPreciseType(propValue);return new PropTypeError('Invalid '+location+' `'+propFullName+'` of type '+('`'+preciseType+'` supplied to `'+componentName+'`, expected ')+('`'+expectedType+'`.'));}return null;}return createChainableTypeChecker(validate);}function createAnyTypeChecker(){return createChainableTypeChecker(emptyFunctionThatReturnsNull);}function createArrayOfTypeChecker(typeChecker){function validate(props,propName,componentName,location,propFullName){if(typeof typeChecker!=='function'){return new PropTypeError('Property `'+propFullName+'` of component `'+componentName+'` has invalid PropType notation inside arrayOf.');}var propValue=props[propName];if(!Array.isArray(propValue)){var propType=getPropType(propValue);return new PropTypeError('Invalid '+location+' `'+propFullName+'` of type '+('`'+propType+'` supplied to `'+componentName+'`, expected an array.'));}for(var i=0;i<propValue.length;i++){var error=typeChecker(propValue,i,componentName,location,propFullName+'['+i+']',ReactPropTypesSecret);if(error instanceof Error){return error;}}return null;}return createChainableTypeChecker(validate);}function createElementTypeChecker(){function validate(props,propName,componentName,location,propFullName){var propValue=props[propName];if(!isValidElement(propValue)){var propType=getPropType(propValue);return new PropTypeError('Invalid '+location+' `'+propFullName+'` of type '+('`'+propType+'` supplied to `'+componentName+'`, expected a single ReactElement.'));}return null;}return createChainableTypeChecker(validate);}function createElementTypeTypeChecker(){function validate(props,propName,componentName,location,propFullName){var propValue=props[propName];if(!ReactIs.isValidElementType(propValue)){var propType=getPropType(propValue);return new PropTypeError('Invalid '+location+' `'+propFullName+'` of type '+('`'+propType+'` supplied to `'+componentName+'`, expected a single ReactElement type.'));}return null;}return createChainableTypeChecker(validate);}function createInstanceTypeChecker(expectedClass){function validate(props,propName,componentName,location,propFullName){if(!(props[propName]instanceof expectedClass)){var expectedClassName=expectedClass.name||ANONYMOUS;var actualClassName=getClassName(props[propName]);return new PropTypeError('Invalid '+location+' `'+propFullName+'` of type '+('`'+actualClassName+'` supplied to `'+componentName+'`, expected ')+('instance of `'+expectedClassName+'`.'));}return null;}return createChainableTypeChecker(validate);}function createEnumTypeChecker(expectedValues){if(!Array.isArray(expectedValues)){if(process.env.NODE_ENV!=='production'){if(arguments.length>1){printWarning('Invalid arguments supplied to oneOf, expected an array, got '+arguments.length+' arguments. '+'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');}else {printWarning('Invalid argument supplied to oneOf, expected an array.');}}return emptyFunctionThatReturnsNull;}function validate(props,propName,componentName,location,propFullName){var propValue=props[propName];for(var i=0;i<expectedValues.length;i++){if(is(propValue,expectedValues[i])){return null;}}var valuesString=JSON.stringify(expectedValues,function replacer(key,value){var type=getPreciseType(value);if(type==='symbol'){return String(value);}return value;});return new PropTypeError('Invalid '+location+' `'+propFullName+'` of value `'+String(propValue)+'` '+('supplied to `'+componentName+'`, expected one of '+valuesString+'.'));}return createChainableTypeChecker(validate);}function createObjectOfTypeChecker(typeChecker){function validate(props,propName,componentName,location,propFullName){if(typeof typeChecker!=='function'){return new PropTypeError('Property `'+propFullName+'` of component `'+componentName+'` has invalid PropType notation inside objectOf.');}var propValue=props[propName];var propType=getPropType(propValue);if(propType!=='object'){return new PropTypeError('Invalid '+location+' `'+propFullName+'` of type '+('`'+propType+'` supplied to `'+componentName+'`, expected an object.'));}for(var key in propValue){if(has(propValue,key)){var error=typeChecker(propValue,key,componentName,location,propFullName+'.'+key,ReactPropTypesSecret);if(error instanceof Error){return error;}}}return null;}return createChainableTypeChecker(validate);}function createUnionTypeChecker(arrayOfTypeCheckers){if(!Array.isArray(arrayOfTypeCheckers)){process.env.NODE_ENV!=='production'?printWarning('Invalid argument supplied to oneOfType, expected an instance of array.'):void 0;return emptyFunctionThatReturnsNull;}for(var i=0;i<arrayOfTypeCheckers.length;i++){var checker=arrayOfTypeCheckers[i];if(typeof checker!=='function'){printWarning('Invalid argument supplied to oneOfType. Expected an array of check functions, but '+'received '+getPostfixForTypeWarning(checker)+' at index '+i+'.');return emptyFunctionThatReturnsNull;}}function validate(props,propName,componentName,location,propFullName){for(var i=0;i<arrayOfTypeCheckers.length;i++){var checker=arrayOfTypeCheckers[i];if(checker(props,propName,componentName,location,propFullName,ReactPropTypesSecret)==null){return null;}}return new PropTypeError('Invalid '+location+' `'+propFullName+'` supplied to '+('`'+componentName+'`.'));}return createChainableTypeChecker(validate);}function createNodeChecker(){function validate(props,propName,componentName,location,propFullName){if(!isNode(props[propName])){return new PropTypeError('Invalid '+location+' `'+propFullName+'` supplied to '+('`'+componentName+'`, expected a ReactNode.'));}return null;}return createChainableTypeChecker(validate);}function createShapeTypeChecker(shapeTypes){function validate(props,propName,componentName,location,propFullName){var propValue=props[propName];var propType=getPropType(propValue);if(propType!=='object'){return new PropTypeError('Invalid '+location+' `'+propFullName+'` of type `'+propType+'` '+('supplied to `'+componentName+'`, expected `object`.'));}for(var key in shapeTypes){var checker=shapeTypes[key];if(!checker){continue;}var error=checker(propValue,key,componentName,location,propFullName+'.'+key,ReactPropTypesSecret);if(error){return error;}}return null;}return createChainableTypeChecker(validate);}function createStrictShapeTypeChecker(shapeTypes){function validate(props,propName,componentName,location,propFullName){var propValue=props[propName];var propType=getPropType(propValue);if(propType!=='object'){return new PropTypeError('Invalid '+location+' `'+propFullName+'` of type `'+propType+'` '+('supplied to `'+componentName+'`, expected `object`.'));}// We need to check all keys in case some are required but missing from
// props.
var allKeys=assign({},props[propName],shapeTypes);for(var key in allKeys){var checker=shapeTypes[key];if(!checker){return new PropTypeError('Invalid '+location+' `'+propFullName+'` key `'+key+'` supplied to `'+componentName+'`.'+'\nBad object: '+JSON.stringify(props[propName],null,'  ')+'\nValid keys: '+JSON.stringify(Object.keys(shapeTypes),null,'  '));}var error=checker(propValue,key,componentName,location,propFullName+'.'+key,ReactPropTypesSecret);if(error){return error;}}return null;}return createChainableTypeChecker(validate);}function isNode(propValue){switch(typeof propValue){case'number':case'string':case'undefined':return true;case'boolean':return !propValue;case'object':if(Array.isArray(propValue)){return propValue.every(isNode);}if(propValue===null||isValidElement(propValue)){return true;}var iteratorFn=getIteratorFn(propValue);if(iteratorFn){var iterator=iteratorFn.call(propValue);var step;if(iteratorFn!==propValue.entries){while(!(step=iterator.next()).done){if(!isNode(step.value)){return false;}}}else {// Iterator will provide entry [k,v] tuples rather than values.
while(!(step=iterator.next()).done){var entry=step.value;if(entry){if(!isNode(entry[1])){return false;}}}}}else {return false;}return true;default:return false;}}function isSymbol(propType,propValue){// Native Symbol.
if(propType==='symbol'){return true;}// falsy value can't be a Symbol
if(!propValue){return false;}// 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
if(propValue['@@toStringTag']==='Symbol'){return true;}// Fallback for non-spec compliant Symbols which are polyfilled.
if(typeof Symbol==='function'&&propValue instanceof Symbol){return true;}return false;}// Equivalent of `typeof` but with special handling for array and regexp.
function getPropType(propValue){var propType=typeof propValue;if(Array.isArray(propValue)){return 'array';}if(propValue instanceof RegExp){// Old webkits (at least until Android 4.0) return 'function' rather than
// 'object' for typeof a RegExp. We'll normalize this here so that /bla/
// passes PropTypes.object.
return 'object';}if(isSymbol(propType,propValue)){return 'symbol';}return propType;}// This handles more types than `getPropType`. Only used for error messages.
// See `createPrimitiveTypeChecker`.
function getPreciseType(propValue){if(typeof propValue==='undefined'||propValue===null){return ''+propValue;}var propType=getPropType(propValue);if(propType==='object'){if(propValue instanceof Date){return 'date';}else if(propValue instanceof RegExp){return 'regexp';}}return propType;}// Returns a string that is postfixed to a warning about an invalid type.
// For example, "undefined" or "of type array"
function getPostfixForTypeWarning(value){var type=getPreciseType(value);switch(type){case'array':case'object':return 'an '+type;case'boolean':case'date':case'regexp':return 'a '+type;default:return type;}}// Returns class name of the object, if any.
function getClassName(propValue){if(!propValue.constructor||!propValue.constructor.name){return ANONYMOUS;}return propValue.constructor.name;}ReactPropTypes.checkPropTypes=checkPropTypes;ReactPropTypes.resetWarningCache=checkPropTypes.resetWarningCache;ReactPropTypes.PropTypes=ReactPropTypes;return ReactPropTypes;};/* WEBPACK VAR INJECTION */}).call(exports,__webpack_require__(13));/***/}),(/* 207 */ /***/function(module,exports,__webpack_require__){/* WEBPACK VAR INJECTION */(function(process){/**
    * Copyright (c) 2013-present, Facebook, Inc.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE file in the root directory of this source tree.
    */if(process.env.NODE_ENV!=='production'){var ReactIs=__webpack_require__(80);// By explicitly using `prop-types` you are opting into new development behavior.
// http://fb.me/prop-types-in-prod
var throwOnDirectAccess=true;module.exports=__webpack_require__(206)(ReactIs.isElement,throwOnDirectAccess);}else {// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports=__webpack_require__(205)();}/* WEBPACK VAR INJECTION */}).call(exports,__webpack_require__(13));/***/}),(/* 208 */ /***/function(module,exports,__webpack_require__){/* WEBPACK VAR INJECTION */(function(process){/** @license React v16.10.1
    * react-is.development.js
    *
    * Copyright (c) Facebook, Inc. and its affiliates.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE file in the root directory of this source tree.
    */if(process.env.NODE_ENV!=="production"){(function(){Object.defineProperty(exports,'__esModule',{value:true});// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol=typeof Symbol==='function'&&Symbol.for;var REACT_ELEMENT_TYPE=hasSymbol?Symbol.for('react.element'):0xeac7;var REACT_PORTAL_TYPE=hasSymbol?Symbol.for('react.portal'):0xeaca;var REACT_FRAGMENT_TYPE=hasSymbol?Symbol.for('react.fragment'):0xeacb;var REACT_STRICT_MODE_TYPE=hasSymbol?Symbol.for('react.strict_mode'):0xeacc;var REACT_PROFILER_TYPE=hasSymbol?Symbol.for('react.profiler'):0xead2;var REACT_PROVIDER_TYPE=hasSymbol?Symbol.for('react.provider'):0xeacd;var REACT_CONTEXT_TYPE=hasSymbol?Symbol.for('react.context'):0xeace;// TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?
var REACT_ASYNC_MODE_TYPE=hasSymbol?Symbol.for('react.async_mode'):0xeacf;var REACT_CONCURRENT_MODE_TYPE=hasSymbol?Symbol.for('react.concurrent_mode'):0xeacf;var REACT_FORWARD_REF_TYPE=hasSymbol?Symbol.for('react.forward_ref'):0xead0;var REACT_SUSPENSE_TYPE=hasSymbol?Symbol.for('react.suspense'):0xead1;var REACT_SUSPENSE_LIST_TYPE=hasSymbol?Symbol.for('react.suspense_list'):0xead8;var REACT_MEMO_TYPE=hasSymbol?Symbol.for('react.memo'):0xead3;var REACT_LAZY_TYPE=hasSymbol?Symbol.for('react.lazy'):0xead4;var REACT_FUNDAMENTAL_TYPE=hasSymbol?Symbol.for('react.fundamental'):0xead5;var REACT_RESPONDER_TYPE=hasSymbol?Symbol.for('react.responder'):0xead6;var REACT_SCOPE_TYPE=hasSymbol?Symbol.for('react.scope'):0xead7;function isValidElementType(type){return typeof type==='string'||typeof type==='function'||// Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
type===REACT_FRAGMENT_TYPE||type===REACT_CONCURRENT_MODE_TYPE||type===REACT_PROFILER_TYPE||type===REACT_STRICT_MODE_TYPE||type===REACT_SUSPENSE_TYPE||type===REACT_SUSPENSE_LIST_TYPE||typeof type==='object'&&type!==null&&(type.$$typeof===REACT_LAZY_TYPE||type.$$typeof===REACT_MEMO_TYPE||type.$$typeof===REACT_PROVIDER_TYPE||type.$$typeof===REACT_CONTEXT_TYPE||type.$$typeof===REACT_FORWARD_REF_TYPE||type.$$typeof===REACT_FUNDAMENTAL_TYPE||type.$$typeof===REACT_RESPONDER_TYPE||type.$$typeof===REACT_SCOPE_TYPE);}/**
         * Forked from fbjs/warning:
         * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
         *
         * Only change is we use console.warn instead of console.error,
         * and do nothing when 'console' is not supported.
         * This really simplifies the code.
         * ---
         * Similar to invariant but only logs a warning if the condition is not met.
         * This can be used to log issues in development environments in critical
         * paths. Removing the logging code for production environments will keep the
         * same logic and follow the same code paths.
         */var lowPriorityWarningWithoutStack=function(){};{var printWarning=function(format){for(var _len=arguments.length,args=new Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){args[_key-1]=arguments[_key];}var argIndex=0;var message='Warning: '+format.replace(/%s/g,function(){return args[argIndex++];});if(typeof console!=='undefined'){console.warn(message);}try{// --- Welcome to debugging React ---
// This error was thrown as a convenience so that you can use this stack
// to find the callsite that caused this warning to fire.
throw new Error(message);}catch(x){}};lowPriorityWarningWithoutStack=function(condition,format){if(format===undefined){throw new Error('`lowPriorityWarningWithoutStack(condition, format, ...args)` requires a warning '+'message argument');}if(!condition){for(var _len2=arguments.length,args=new Array(_len2>2?_len2-2:0),_key2=2;_key2<_len2;_key2++){args[_key2-2]=arguments[_key2];}printWarning.apply(void 0,[format].concat(args));}};}var lowPriorityWarningWithoutStack$1=lowPriorityWarningWithoutStack;function typeOf(object){if(typeof object==='object'&&object!==null){var $$typeof=object.$$typeof;switch($$typeof){case REACT_ELEMENT_TYPE:var type=object.type;switch(type){case REACT_ASYNC_MODE_TYPE:case REACT_CONCURRENT_MODE_TYPE:case REACT_FRAGMENT_TYPE:case REACT_PROFILER_TYPE:case REACT_STRICT_MODE_TYPE:case REACT_SUSPENSE_TYPE:return type;default:var $$typeofType=type&&type.$$typeof;switch($$typeofType){case REACT_CONTEXT_TYPE:case REACT_FORWARD_REF_TYPE:case REACT_PROVIDER_TYPE:return $$typeofType;default:return $$typeof;}}case REACT_LAZY_TYPE:case REACT_MEMO_TYPE:case REACT_PORTAL_TYPE:return $$typeof;}}return undefined;}// AsyncMode is deprecated along with isAsyncMode
var AsyncMode=REACT_ASYNC_MODE_TYPE;var ConcurrentMode=REACT_CONCURRENT_MODE_TYPE;var ContextConsumer=REACT_CONTEXT_TYPE;var ContextProvider=REACT_PROVIDER_TYPE;var Element=REACT_ELEMENT_TYPE;var ForwardRef=REACT_FORWARD_REF_TYPE;var Fragment=REACT_FRAGMENT_TYPE;var Lazy=REACT_LAZY_TYPE;var Memo=REACT_MEMO_TYPE;var Portal=REACT_PORTAL_TYPE;var Profiler=REACT_PROFILER_TYPE;var StrictMode=REACT_STRICT_MODE_TYPE;var Suspense=REACT_SUSPENSE_TYPE;var hasWarnedAboutDeprecatedIsAsyncMode=false;// AsyncMode should be deprecated
function isAsyncMode(object){{if(!hasWarnedAboutDeprecatedIsAsyncMode){hasWarnedAboutDeprecatedIsAsyncMode=true;lowPriorityWarningWithoutStack$1(false,'The ReactIs.isAsyncMode() alias has been deprecated, '+'and will be removed in React 17+. Update your code to use '+'ReactIs.isConcurrentMode() instead. It has the exact same API.');}}return isConcurrentMode(object)||typeOf(object)===REACT_ASYNC_MODE_TYPE;}function isConcurrentMode(object){return typeOf(object)===REACT_CONCURRENT_MODE_TYPE;}function isContextConsumer(object){return typeOf(object)===REACT_CONTEXT_TYPE;}function isContextProvider(object){return typeOf(object)===REACT_PROVIDER_TYPE;}function isElement(object){return typeof object==='object'&&object!==null&&object.$$typeof===REACT_ELEMENT_TYPE;}function isForwardRef(object){return typeOf(object)===REACT_FORWARD_REF_TYPE;}function isFragment(object){return typeOf(object)===REACT_FRAGMENT_TYPE;}function isLazy(object){return typeOf(object)===REACT_LAZY_TYPE;}function isMemo(object){return typeOf(object)===REACT_MEMO_TYPE;}function isPortal(object){return typeOf(object)===REACT_PORTAL_TYPE;}function isProfiler(object){return typeOf(object)===REACT_PROFILER_TYPE;}function isStrictMode(object){return typeOf(object)===REACT_STRICT_MODE_TYPE;}function isSuspense(object){return typeOf(object)===REACT_SUSPENSE_TYPE;}exports.typeOf=typeOf;exports.AsyncMode=AsyncMode;exports.ConcurrentMode=ConcurrentMode;exports.ContextConsumer=ContextConsumer;exports.ContextProvider=ContextProvider;exports.Element=Element;exports.ForwardRef=ForwardRef;exports.Fragment=Fragment;exports.Lazy=Lazy;exports.Memo=Memo;exports.Portal=Portal;exports.Profiler=Profiler;exports.StrictMode=StrictMode;exports.Suspense=Suspense;exports.isValidElementType=isValidElementType;exports.isAsyncMode=isAsyncMode;exports.isConcurrentMode=isConcurrentMode;exports.isContextConsumer=isContextConsumer;exports.isContextProvider=isContextProvider;exports.isElement=isElement;exports.isForwardRef=isForwardRef;exports.isFragment=isFragment;exports.isLazy=isLazy;exports.isMemo=isMemo;exports.isPortal=isPortal;exports.isProfiler=isProfiler;exports.isStrictMode=isStrictMode;exports.isSuspense=isSuspense;})();}/* WEBPACK VAR INJECTION */}).call(exports,__webpack_require__(13));/***/}),(/* 209 */ /***/function(module,exports,__webpack_require__){/** @license React v16.10.1
   * react-is.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */Object.defineProperty(exports,"__esModule",{value:!0});var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.fundamental"):60117,w=b?Symbol.for("react.responder"):60118,x=b?Symbol.for("react.scope"):60119;function y(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u;}}case t:case r:case d:return u;}}}function z(a){return y(a)===m;}exports.typeOf=y;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===v||a.$$typeof===w||a.$$typeof===x);};exports.isAsyncMode=function(a){return z(a)||y(a)===l;};exports.isConcurrentMode=z;exports.isContextConsumer=function(a){return y(a)===k;};exports.isContextProvider=function(a){return y(a)===h;};exports.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c;};exports.isForwardRef=function(a){return y(a)===n;};exports.isFragment=function(a){return y(a)===e;};exports.isLazy=function(a){return y(a)===t;};exports.isMemo=function(a){return y(a)===r;};exports.isPortal=function(a){return y(a)===d;};exports.isProfiler=function(a){return y(a)===g;};exports.isStrictMode=function(a){return y(a)===f;};exports.isSuspense=function(a){return y(a)===p;};/***/}),(/* 210 */ /***/function(module,exports,__webpack_require__){module.exports=/******/function(modules){// webpackBootstrap
/******/ // The module cache
/******/var installedModules={};/******/ /******/ // The require function
/******/function __webpack_require__(moduleId){/******/ /******/ // Check if module is in cache
/******/if(installedModules[moduleId]){/******/return installedModules[moduleId].exports;/******/}/******/ // Create a new module (and put it into the cache)
/******/var module=installedModules[moduleId]={/******/i:moduleId,/******/l:false,/******/exports:{}/******/};/******/ /******/ // Execute the module function
/******/modules[moduleId].call(module.exports,module,module.exports,__webpack_require__);/******/ /******/ // Flag the module as loaded
/******/module.l=true;/******/ /******/ // Return the exports of the module
/******/return module.exports;/******/}/******/ /******/ /******/ // expose the modules object (__webpack_modules__)
/******/__webpack_require__.m=modules;/******/ /******/ // expose the module cache
/******/__webpack_require__.c=installedModules;/******/ /******/ // define getter function for harmony exports
/******/__webpack_require__.d=function(exports,name,getter){/******/if(!__webpack_require__.o(exports,name)){/******/Object.defineProperty(exports,name,{/******/configurable:false,/******/enumerable:true,/******/get:getter/******/});/******/}/******/};/******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
/******/__webpack_require__.n=function(module){/******/var getter=module&&module.__esModule?/******/function getDefault(){return module['default'];}:/******/function getModuleExports(){return module;};/******/__webpack_require__.d(getter,'a',getter);/******/return getter;/******/};/******/ /******/ // Object.prototype.hasOwnProperty.call
/******/__webpack_require__.o=function(object,property){return Object.prototype.hasOwnProperty.call(object,property);};/******/ /******/ // __webpack_public_path__
/******/__webpack_require__.p="";/******/ /******/ // Load entry module and return exports
/******/return __webpack_require__(__webpack_require__.s=9);/******/}/************************************************************************/ /******/([(/* 0 */ /***/function(module,exports){module.exports=__webpack_require__(6);/***/}),(/* 1 */ /***/function(module,exports){module.exports=__webpack_require__(207);/***/}),(/* 2 */ /***/function(module,exports,__webpack_require__){// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}
exports.__esModule=true;exports['default']=stripStyle;function stripStyle(style){var ret={};for(var key in style){if(!Object.prototype.hasOwnProperty.call(style,key)){continue;}ret[key]=typeof style[key]==='number'?style[key]:style[key].val;}return ret;}module.exports=exports['default'];/***/}),(/* 3 */ /***/function(module,exports,__webpack_require__){// currently used to initiate the velocity style object to 0
exports.__esModule=true;exports['default']=mapToZero;function mapToZero(obj){var ret={};for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key)){ret[key]=0;}}return ret;}module.exports=exports['default'];/***/}),(/* 4 */ /***/function(module,exports,__webpack_require__){// stepper is used a lot. Saves allocation to return the same array wrapper.
// This is fine and danger-free against mutations because the callsite
// immediately destructures it and gets the numbers inside without passing the
exports.__esModule=true;exports["default"]=stepper;var reusedTuple=[0,0];function stepper(secondPerFrame,x,v,destX,k,b,precision){// Spring stiffness, in kg / s^2
// for animations, destX is really spring length (spring at rest). initial
// position is considered as the stretched/compressed position of a spring
var Fspring=-k*(x-destX);// Damping, in kg / s
var Fdamper=-b*v;// usually we put mass here, but for animation purposes, specifying mass is a
// bit redundant. you could simply adjust k and b accordingly
// let a = (Fspring + Fdamper) / mass;
var a=Fspring+Fdamper;var newV=v+a*secondPerFrame;var newX=x+newV*secondPerFrame;if(Math.abs(newV)<precision&&Math.abs(newX-destX)<precision){reusedTuple[0]=destX;reusedTuple[1]=0;return reusedTuple;}reusedTuple[0]=newX;reusedTuple[1]=newV;return reusedTuple;}module.exports=exports["default"];// array reference around.
/***/}),(/* 5 */ /***/function(module,exports,__webpack_require__){/* WEBPACK VAR INJECTION */(function(process){// Generated by CoffeeScript 1.7.1
(function(){var getNanoSeconds,hrtime,loadTime;if(typeof performance!=="undefined"&&performance!==null&&performance.now){module.exports=function(){return performance.now();};}else if(typeof process!=="undefined"&&process!==null&&process.hrtime){module.exports=function(){return (getNanoSeconds()-loadTime)/1e6;};hrtime=process.hrtime;getNanoSeconds=function(){var hr;hr=hrtime();return hr[0]*1e9+hr[1];};loadTime=getNanoSeconds();}else if(Date.now){module.exports=function(){return Date.now()-loadTime;};loadTime=Date.now();}else {module.exports=function(){return new Date().getTime()-loadTime;};loadTime=new Date().getTime();}}).call(this);/* WEBPACK VAR INJECTION */}).call(exports,__webpack_require__(6));/***/}),(/* 6 */ /***/function(module,exports){// shim for using process in browser
var process=module.exports={};// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var cachedSetTimeout;var cachedClearTimeout;function defaultSetTimout(){throw new Error('setTimeout has not been defined');}function defaultClearTimeout(){throw new Error('clearTimeout has not been defined');}(function(){try{if(typeof setTimeout==='function'){cachedSetTimeout=setTimeout;}else {cachedSetTimeout=defaultSetTimout;}}catch(e){cachedSetTimeout=defaultSetTimout;}try{if(typeof clearTimeout==='function'){cachedClearTimeout=clearTimeout;}else {cachedClearTimeout=defaultClearTimeout;}}catch(e){cachedClearTimeout=defaultClearTimeout;}})();function runTimeout(fun){if(cachedSetTimeout===setTimeout){//normal enviroments in sane situations
return setTimeout(fun,0);}// if setTimeout wasn't available but was latter defined
if((cachedSetTimeout===defaultSetTimout||!cachedSetTimeout)&&setTimeout){cachedSetTimeout=setTimeout;return setTimeout(fun,0);}try{// when when somebody has screwed with setTimeout but no I.E. maddness
return cachedSetTimeout(fun,0);}catch(e){try{// When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
return cachedSetTimeout.call(null,fun,0);}catch(e){// same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
return cachedSetTimeout.call(this,fun,0);}}}function runClearTimeout(marker){if(cachedClearTimeout===clearTimeout){//normal enviroments in sane situations
return clearTimeout(marker);}// if clearTimeout wasn't available but was latter defined
if((cachedClearTimeout===defaultClearTimeout||!cachedClearTimeout)&&clearTimeout){cachedClearTimeout=clearTimeout;return clearTimeout(marker);}try{// when when somebody has screwed with setTimeout but no I.E. maddness
return cachedClearTimeout(marker);}catch(e){try{// When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
return cachedClearTimeout.call(null,marker);}catch(e){// same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
// Some versions of I.E. have different rules for clearTimeout vs setTimeout
return cachedClearTimeout.call(this,marker);}}}var queue=[];var draining=false;var currentQueue;var queueIndex=-1;function cleanUpNextTick(){if(!draining||!currentQueue){return;}draining=false;if(currentQueue.length){queue=currentQueue.concat(queue);}else {queueIndex=-1;}if(queue.length){drainQueue();}}function drainQueue(){if(draining){return;}var timeout=runTimeout(cleanUpNextTick);draining=true;var len=queue.length;while(len){currentQueue=queue;queue=[];while(++queueIndex<len){if(currentQueue){currentQueue[queueIndex].run();}}queueIndex=-1;len=queue.length;}currentQueue=null;draining=false;runClearTimeout(timeout);}process.nextTick=function(fun){var args=new Array(arguments.length-1);if(arguments.length>1){for(var i=1;i<arguments.length;i++){args[i-1]=arguments[i];}}queue.push(new Item(fun,args));if(queue.length===1&&!draining){runTimeout(drainQueue);}};// v8 likes predictible objects
function Item(fun,array){this.fun=fun;this.array=array;}Item.prototype.run=function(){this.fun.apply(null,this.array);};process.title='browser';process.browser=true;process.env={};process.argv=[];process.version='';// empty string to avoid regexp issues
process.versions={};function noop(){}process.on=noop;process.addListener=noop;process.once=noop;process.off=noop;process.removeListener=noop;process.removeAllListeners=noop;process.emit=noop;process.prependListener=noop;process.prependOnceListener=noop;process.listeners=function(name){return [];};process.binding=function(name){throw new Error('process.binding is not supported');};process.cwd=function(){return '/';};process.chdir=function(dir){throw new Error('process.chdir is not supported');};process.umask=function(){return 0;};/***/}),(/* 7 */ /***/function(module,exports,__webpack_require__){/* WEBPACK VAR INJECTION */(function(global){var now=__webpack_require__(21),root=typeof window==='undefined'?global:window,vendors=['moz','webkit'],suffix='AnimationFrame',raf=root['request'+suffix],caf=root['cancel'+suffix]||root['cancelRequest'+suffix];for(var i=0;!raf&&i<vendors.length;i++){raf=root[vendors[i]+'Request'+suffix];caf=root[vendors[i]+'Cancel'+suffix]||root[vendors[i]+'CancelRequest'+suffix];}// Some versions of FF have rAF but not cAF
if(!raf||!caf){var last=0,id=0,queue=[],frameDuration=1000/60;raf=function(callback){if(queue.length===0){var _now=now(),next=Math.max(0,frameDuration-(_now-last));last=next+_now;setTimeout(function(){var cp=queue.slice(0);// Clear queue here to prevent
// callbacks from appending listeners
// to the current frame's queue
queue.length=0;for(var i=0;i<cp.length;i++){if(!cp[i].cancelled){try{cp[i].callback(last);}catch(e){setTimeout(function(){throw e;},0);}}}},Math.round(next));}queue.push({handle:++id,callback:callback,cancelled:false});return id;};caf=function(handle){for(var i=0;i<queue.length;i++){if(queue[i].handle===handle){queue[i].cancelled=true;}}};}module.exports=function(fn){// Wrap in a new function to prevent
// `cancel` potentially being assigned
// to the native rAF function
return raf.call(root,fn);};module.exports.cancel=function(){caf.apply(root,arguments);};module.exports.polyfill=function(object){if(!object){object=root;}object.requestAnimationFrame=raf;object.cancelAnimationFrame=caf;};/* WEBPACK VAR INJECTION */}).call(exports,__webpack_require__(20));/***/}),(/* 8 */ /***/function(module,exports,__webpack_require__){// usage assumption: currentStyle values have already been rendered but it says
// nothing of whether currentStyle is stale (see unreadPropStyle)
exports.__esModule=true;exports['default']=shouldStopAnimation;function shouldStopAnimation(currentStyle,style,currentVelocity){for(var key in style){if(!Object.prototype.hasOwnProperty.call(style,key)){continue;}if(currentVelocity[key]!==0){return false;}var styleValue=typeof style[key]==='number'?style[key]:style[key].val;// stepper will have already taken care of rounding precision errors, so
// won't have such thing as 0.9999 !=== 1
if(currentStyle[key]!==styleValue){return false;}}return true;}module.exports=exports['default'];/***/}),(/* 9 */ /***/function(module,exports,__webpack_require__){Object.defineProperty(exports,"__esModule",{value:true});exports.AttributeMotion=exports.TransformMotion=exports.SvgLoader=exports.SvgProxy=undefined;var _svgLoader=__webpack_require__(12);var _svgLoader2=_interopRequireDefault(_svgLoader);var _svgProxy=__webpack_require__(16);var _svgProxy2=_interopRequireDefault(_svgProxy);var _AnimatedProxy=__webpack_require__(17);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.SvgProxy=_svgProxy2.default;exports.SvgLoader=_svgLoader2.default;exports.TransformMotion=_AnimatedProxy.TransformMotion;exports.AttributeMotion=_AnimatedProxy.AttributeMotion;/***/}),(/* 10 */ /***/function(module,exports,__webpack_require__){Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var SVGContext=_react2.default.createContext(null);exports.default=SVGContext;/***/}),(/* 11 */ /***/function(module,exports,__webpack_require__){exports.__esModule=true;exports["default"]={noWobble:{stiffness:170,damping:26},// the default, if nothing provided
gentle:{stiffness:120,damping:14},wobbly:{stiffness:180,damping:12},stiff:{stiffness:210,damping:20}};module.exports=exports["default"];/***/}),(/* 12 */ /***/function(module,exports,__webpack_require__){Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(1);var _propTypes2=_interopRequireDefault(_propTypes);var _reactSvg=__webpack_require__(13);var _reactSvg2=_interopRequireDefault(_reactSvg);var _svgContext=__webpack_require__(10);var _svgContext2=_interopRequireDefault(_svgContext);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function noop(){}var SvgLoader=function(_React$Component){_inherits(SvgLoader,_React$Component);function SvgLoader(props){_classCallCheck(this,SvgLoader);var _this=_possibleConstructorReturn(this,(SvgLoader.__proto__||Object.getPrototypeOf(SvgLoader)).call(this,props));_this.mounted=false;_this.state={svg:null,svgCount:0// used to re apply updates when path change
};if(_react2.default.Fragment==null){throw new Error("This version of React doesn't support Fragments, please update it");}_this.onSVGReady=_this.onSVGReady.bind(_this);return _this;}_createClass(SvgLoader,[{key:"componentDidMount",value:function componentDidMount(){this.mounted=true;}},{key:"componentWillUnmount",value:function componentWillUnmount(){this.mounted=false;}},{key:"onSVGReady",value:function onSVGReady(svgNode){var _this2=this;// Run after component has mounted
setTimeout(function(){if(_this2.mounted){_this2.setState(_extends({},_this2.state,{svg:svgNode,svgCount:_this2.state.svgCount+1}));_this2.props.onSVGReady(svgNode);}},0);}},{key:"render",value:function render(){var _props=this.props,path=_props.path;_props.onSVGReady;_props.children;var svgXML=_props.svgXML,rest=_objectWithoutProperties(_props,["path","onSVGReady","children","svgXML"]);var renderProxies=this.state.svg!=null;var proxies=renderProxies?this.props.children:null;return _react2.default.createElement(_react2.default.Fragment,null,_react2.default.createElement(_reactSvg2.default,_extends({path:path,callback:this.onSVGReady,svgXML:svgXML},rest)),_react2.default.createElement(_svgContext2.default.Provider,{value:{path:path,svgCount:this.state.svgCount,svg:this.state.svg}},proxies));}}]);return SvgLoader;}(_react2.default.Component);exports.default=SvgLoader;SvgLoader.propTypes={path:_propTypes2.default.string,svgXML:_propTypes2.default.string,onSVGReady:_propTypes2.default.func,style:_propTypes2.default.object,// eslint-disable-line
children:_propTypes2.default.any// eslint-disable-line
};SvgLoader.defaultProps={path:null,svgXML:null,onSVGReady:noop,style:null};/***/}),(/* 13 */ /***/function(module,exports,__webpack_require__){Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _propTypes=__webpack_require__(1);var _propTypes2=_interopRequireDefault(_propTypes);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* Adapted from the react-svg module source code;
        - removes <divs>
        Original LiCENSE text:
        The MIT License (MIT)
      
        Copyright (c) 2014 Atomic
      
        Permission is hereby granted, free of charge, to any person obtaining a copy
        of this software and associated documentation files (the "Software"), to deal
        in the Software without restriction, including without limitation the rights
        to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
        copies of the Software, and to permit persons to whom the Software is
        furnished to do so, subject to the following conditions:
      
        The above copyright notice and this permission notice shall be included in all
        copies or substantial portions of the Software.
      
        THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
        IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
        FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
        AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
        LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
        OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
        SOFTWARE.
      */ // See: https://github.com/webpack/react-starter/issues/37
var isBrowser=typeof window!=='undefined';var SVGInjector=isBrowser?__webpack_require__(14):undefined;var ReactSVG=function(_React$Component){_inherits(ReactSVG,_React$Component);function ReactSVG(){_classCallCheck(this,ReactSVG);var _this=_possibleConstructorReturn(this,(ReactSVG.__proto__||Object.getPrototypeOf(ReactSVG)).call(this));_this.refCallback=_this.refCallback.bind(_this);return _this;}_createClass(ReactSVG,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(this.props.path!==prevProps.path||this.props.svgXML!==prevProps.svgXML){if(this.container){// destroy children
this.container.innerHTML='';}// the svg src attribute is already updated with the new path
// this will be used by svg injector to fetch the new svg
this.renderSVG(this.props);}}},{key:'refCallback',value:function refCallback(container){if(!container){return;}this.container=container;this.renderSVG();}},{key:'renderSVG',value:function renderSVG(){var _this2=this;var props=arguments.length>0&&arguments[0]!==undefined?arguments[0]:this.props;var svgNode=this.container;var callback=props.callback;props.path;var svgXML=props.svgXML;props.className;var htmlProps=_objectWithoutProperties(props,['callback','path','svgXML','className']);// Update SVG element
SVGInjector(svgNode,{each:function each(err){if(err){throw new Error(err);}// each is called when the svg was injected and is ready
callback(_this2.container);},svgXML:svgXML},function(){// SVGInjector will override the SVG attributes set by react props
// Re apply them (except the special `style` prop)
// by props. So we need to re apply them.
if(svgNode&&htmlProps){Object.keys(htmlProps).reduce(function(svgNode_,key){if(key!=='style'){svgNode_.setAttribute(key,htmlProps[key]);}return svgNode;},svgNode);}});}},{key:'render',value:function render(){var _props=this.props;_props.callback;_props.path;_props.svgXML;var props=_objectWithoutProperties(_props,['callback','path','svgXML']);return _react2.default.createElement('svg',_extends({ref:this.refCallback,'data-src':this.props.path},props));}}]);return ReactSVG;}(_react2.default.Component);exports.default=ReactSVG;ReactSVG.defaultProps={callback:function callback(){},path:null,svgXML:null};ReactSVG.propTypes={callback:_propTypes2.default.func,path:_propTypes2.default.string,svgXML:_propTypes2.default.string};/***/}),(/* 14 */ /***/function(module,exports,__webpack_require__){/* WEBPACK VAR INJECTION */(function(module){var __WEBPACK_AMD_DEFINE_RESULT__;var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};/* eslint-disable */ /**
       * Changes:
       * - Don't replace the node.  Justs its innerHTML
       * Adapted from:
       * Original Copyright notice ---------------------------
       * SVGInjector v1.1.3 - Fast, caching, dynamic inline SVG DOM injection library
       * https://github.com/iconic/SVGInjector
       *
       * Copyright (c) 2014-2015 Waybury <hello@waybury.com>
       * @license MIT
       *
       */(function(window,document){// Environment
var isLocal=window.location.protocol==='file:';document.implementation.hasFeature('http://www.w3.org/TR/SVG11/feature#BasicStructure','1.1');function uniqueClasses(list){list=list.split(' ');var hash={};var i=list.length;var out=[];while(i--){if(!hash.hasOwnProperty(list[i])){hash[list[i]]=1;out.unshift(list[i]);}}return out.join(' ');}/**
         * cache (or polyfill for <= IE8) Array.forEach()
         * source: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach
         */var forEach=Array.prototype.forEach||function(fn,scope){if(this===void 0||this===null||typeof fn!=='function'){throw new TypeError();}/* jshint bitwise: false */var i,len=this.length>>>0;/* jshint bitwise: true */for(i=0;i<len;++i){if(i in this){fn.call(scope,this[i],i,this);}}};// SVG Cache
var svgCache={};var injectCount=0;var injectedElements=[];// Request Queue
var requestQueue=[];var cloneSvg=function cloneSvg(sourceSvg){return sourceSvg.cloneNode(true);};var queueRequest=function queueRequest(url,callback){requestQueue[url]=requestQueue[url]||[];requestQueue[url].push(callback);};var processRequestQueue=function processRequestQueue(url){for(var i=0,len=requestQueue[url].length;i<len;i++){// Make these calls async so we avoid blocking the page/renderer
/* jshint loopfunc: true */(function(index){setTimeout(function(){requestQueue[url][index](cloneSvg(svgCache[url]));},0);})(i);/* jshint loopfunc: false */}};var loadSvg=function loadSvg(url,callback){if(svgCache[url]!==undefined){if(svgCache[url]instanceof SVGSVGElement){// We already have it in cache, so use it
callback(cloneSvg(svgCache[url]));}else {// We don't have it in cache yet, but we are loading it, so queue this request
queueRequest(url,callback);}}else {if(!window.XMLHttpRequest){callback('Browser does not support XMLHttpRequest');return false;}// Seed the cache to indicate we are loading this URL already
svgCache[url]={};queueRequest(url,callback);var httpRequest=new XMLHttpRequest();httpRequest.onreadystatechange=function(){// readyState 4 = complete
if(httpRequest.readyState===4){// Handle status
if(httpRequest.status===404||httpRequest.responseXML===null){callback('Unable to load SVG file: '+url);if(isLocal)callback('Note: SVG injection ajax calls do not work locally without adjusting security setting in your browser. Or consider using a local webserver.');callback();return false;}// 200 success from server, or 0 when using file:// protocol locally
if(httpRequest.status===200||isLocal&&httpRequest.status===0){/* globals Document */if(httpRequest.responseXML instanceof Document){// Cache it
svgCache[url]=httpRequest.responseXML.documentElement;}else if(DOMParser&&DOMParser instanceof Function){/* globals -Document */ // IE9 doesn't create a responseXML Document object from loaded SVG,
// and throws a "DOM Exception: HIERARCHY_REQUEST_ERR (3)" error when injected.
//
// So, we'll just create our own manually via the DOMParser using
// the the raw XML responseText.
//
// :NOTE: IE8 and older doesn't have DOMParser, but they can't do SVG either, so...
var xmlDoc;try{var parser=new DOMParser();xmlDoc=parser.parseFromString(httpRequest.responseText,'text/xml');}catch(e){xmlDoc=undefined;}if(!xmlDoc||xmlDoc.getElementsByTagName('parsererror').length){callback('Unable to parse SVG file: '+url);return false;}else {// Cache it
svgCache[url]=xmlDoc.documentElement;}}// We've loaded a new asset, so process any requests waiting for it
processRequestQueue(url);}else {callback('There was a problem injecting the SVG: '+httpRequest.status+' '+httpRequest.statusText);return false;}}};httpRequest.open('GET',url);// Treat and parse the response as XML, even if the
// server sends us a different mimetype
if(httpRequest.overrideMimeType)httpRequest.overrideMimeType('text/xml');httpRequest.send();}};/**
         * Process the loaded svg node and copies its contents
         * to the `el` element (also an SVG node)
         * @param {Node} el Existing (empty) SVG element
         * @param {Node} svg Loaded SVG element
         */var processSvg=function processSvg(el,svg){if(typeof svg==='undefined'||typeof svg==='string'){return false;}var imgId=el.getAttribute('id');if(imgId){svg.setAttribute('id',imgId);}var imgTitle=el.getAttribute('title');if(imgTitle){svg.setAttribute('title',imgTitle);}// Concat the SVG classes + 'injected-svg' + the img classes
var classMerge=[].concat(svg.getAttribute('class')||[],'injected-svg',el.getAttribute('class')||[]).join(' ');svg.setAttribute('class',uniqueClasses(classMerge));var imgStyle=el.getAttribute('style');if(imgStyle){svg.setAttribute('style',imgStyle);}// Copy all the data elements to the svg
var imgData=[].filter.call(el.attributes,function(at){return /^data-\w[\w\-]*$/.test(at.name);});forEach.call(imgData,function(dataAttr){if(dataAttr.name&&dataAttr.value){svg.setAttribute(dataAttr.name,dataAttr.value);}});// Make sure any internally referenced clipPath ids and their
// clip-path references are unique.
//
// This addresses the issue of having multiple instances of the
// same SVG on a page and only the first clipPath id is referenced.
//
// Browsers often shortcut the SVG Spec and don't use clipPaths
// contained in parent elements that are hidden, so if you hide the first
// SVG instance on the page, then all other instances lose their clipping.
// Reference: https://bugzilla.mozilla.org/show_bug.cgi?id=376027
// Handle all defs elements that have iri capable attributes as defined by w3c: http://www.w3.org/TR/SVG/linking.html#processingIRI
// Mapping IRI addressable elements to the properties that can reference them:
var iriElementsAndProperties={clipPath:['clip-path'],'color-profile':['color-profile'],cursor:['cursor'],filter:['filter'],linearGradient:['fill','stroke'],marker:['marker','marker-start','marker-mid','marker-end'],mask:['mask'],pattern:['fill','stroke'],radialGradient:['fill','stroke']};var element,elementDefs,properties,currentId,newId;Object.keys(iriElementsAndProperties).forEach(function(key){element=key;properties=iriElementsAndProperties[key];elementDefs=svg.querySelectorAll('defs '+element+'[id]');for(var i=0,elementsLen=elementDefs.length;i<elementsLen;i++){currentId=elementDefs[i].id;newId=currentId+'-'+injectCount;// All of the properties that can reference this element type
var referencingElements;forEach.call(properties,function(property){// :NOTE: using a substring match attr selector here to deal with IE "adding extra quotes in url() attrs"
referencingElements=svg.querySelectorAll('['+property+'*="'+currentId+'"]');for(var j=0,referencingElementLen=referencingElements.length;j<referencingElementLen;j++){referencingElements[j].setAttribute(property,'url(#'+newId+')');}});elementDefs[i].id=newId;}});// Remove any unwanted/invalid namespaces that might have been added by SVG editing tools
svg.removeAttribute('xmlns:a');// :WORKAROUND:
// IE doesn't evaluate <style> tags in SVGs that are dynamically added to the page.
// This trick will trigger IE to read and use any existing SVG <style> tags.
//
// Reference: https://github.com/iconic/SVGInjector/issues/23
var styleTags=svg.querySelectorAll('style');forEach.call(styleTags,function(styleTag){styleTag.textContent+='';});//--- Update for react-samy-svg ----//
// Before:el.parentNode.replaceChild(svg, el);
// To keep the element reference and avoid problems with react
// We replace innerHTML only
setSVGContent(el,svg);//copy original svg attributes to node
if(svg.hasAttributes()){var attrs=svg.attributes;var output='';for(var i=attrs.length-1;i>=0;i--){output+=attrs[i].name+'->'+attrs[i].value;el.setAttribute(attrs[i].name,attrs[i].value);}}// Now that we no longer need it, drop references
// to the original element so it can be GC'd
delete injectedElements[injectedElements.indexOf(el)];el=null;// Increment the injected count
injectCount++;};// innerHTML is not available on svg elements in IE
// this is a workaround to parse it anyway
var getSvgContent=function getSvgContent(svg){var serializer=new XMLSerializer();return Array.prototype.slice.call(svg.childNodes).map(function(node){return serializer.serializeToString(node);}).join('');};// setting the innerHTML of the injected SVG
// simply use innerHTML if possible
// fallback to create dummy element and insert children one by one
var setSVGContent=function setSVGContent(el,svg){el.innerHTML=svg.innerHTML||'';if(!el.innerHTML){// Create a dummy element
var tempElement=document.createElement('div');// Wrap the svg string to a svg object (string)
var svgfragment='<svg>'+getSvgContent(svg)+'</svg>';// Add all svg to the element
tempElement.innerHTML=''+svgfragment;// Splice the childs of the SVG inside the element to the SVG at the body
Array.prototype.slice.call(tempElement.childNodes[0].childNodes).forEach(function(element){el.appendChild(element);});}};// Inject a single element
//@svgXML: if not null then we don't fetch the file because we alredy
//have its contents
var injectElement=function injectElement(el,pngFallback,svgXML,callback){if(svgXML){//If the svgXML is passed then we don't need to fetch the svg
var xmlDoc;try{var parser=new DOMParser();xmlDoc=parser.parseFromString(svgXML,'text/xml');}catch(e){xmlDoc=undefined;}if(!xmlDoc||xmlDoc.getElementsByTagName('parsererror').length){callback('Unable to parse SVG file: '+xmlDoc.getElementsByTagName('parsererror')[0].innerHTML);return false;}else {// Cache it
//svgCache[url] = xmlDoc.documentElement;
processSvg(el,xmlDoc.documentElement);callback();}}else {// Grab the src or data-src attribute
var imgUrl=el.getAttribute('data-src')||el.getAttribute('src');//avoid loading the asset
el.setAttribute('src','');// Make sure we aren't already in the process of injecting this element to
// avoid a race condition if multiple injections for the same element are run.
// :NOTE: Using indexOf() only _after_ we check for SVG support and bail,
// so no need for IE8 indexOf() polyfill
if(injectedElements.indexOf(el)!==-1){return;}// Remember the request to inject this element, in case other injection
// calls are also trying to replace this element before we finish
injectedElements.push(el);// Load it up
loadSvg(imgUrl,function(svg){processSvg(el,svg);callback();});}};/**
         * SVGInjector
         *
         * Replace the given elements with their full inline SVG DOM elements.
         *
         * :NOTE: We are using get/setAttribute with SVG because the SVG DOM spec differs from HTML DOM and
         * can return other unexpected object types when trying to directly access svg properties.
         * ex: "className" returns a SVGAnimatedString with the class value found in the "baseVal" property,
         * instead of simple string like with HTML Elements.
         *
         * @param {mixes} Array of or single DOM element
         * @param {object} options
         * @param {function} callback
         * @return {object} Instance of SVGInjector
         */var SVGInjector=function SVGInjector(elements,options,done){// Options & defaults
options=options||{};// Location of fallback pngs, if desired
var pngFallback=options.pngFallback||false;// Callback to run during each SVG injection, returning the SVG injected
var eachCallback=options.each;var svgXML=options.svgXML;// Do the injection...
if(elements.length!==undefined){var elementsLoaded=0;forEach.call(elements,function(element){injectElement(element,pngFallback,svgXML,function(){if(eachCallback&&typeof eachCallback==='function')eachCallback();if(done&&elements.length===++elementsLoaded)done(elementsLoaded);});});}else {if(elements){injectElement(elements,pngFallback,svgXML,function(){if(eachCallback&&typeof eachCallback==='function')eachCallback();if(done)done(1);elements=null;});}else {if(done)done(0);}}};/* global module, exports: true, define */ // Node.js or CommonJS
if(_typeof(module)==='object'&&_typeof(module.exports)==='object'){module.exports=exports=SVGInjector;}else {// AMD support
!(__WEBPACK_AMD_DEFINE_RESULT__=function(){return SVGInjector;}.call(exports,__webpack_require__,exports,module),__WEBPACK_AMD_DEFINE_RESULT__!==undefined&&(module.exports=__WEBPACK_AMD_DEFINE_RESULT__));}/* global -module, -exports, -define */})(window,document);/* WEBPACK VAR INJECTION */}).call(exports,__webpack_require__(15)(module));/***/}),(/* 15 */ /***/function(module,exports){module.exports=function(module){if(!module.webpackPolyfill){module.deprecate=function(){};module.paths=[];// module.parent = undefined by default
if(!module.children)module.children=[];Object.defineProperty(module,"loaded",{enumerable:true,get:function(){return module.l;}});Object.defineProperty(module,"id",{enumerable:true,get:function(){return module.i;}});module.webpackPolyfill=1;}return module;};/***/}),(/* 16 */ /***/function(module,exports,__webpack_require__){Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(1);var _propTypes2=_interopRequireDefault(_propTypes);var _svgContext=__webpack_require__(10);var _svgContext2=_interopRequireDefault(_svgContext);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var hasNamespaceRegexp=/(\w+)_(\S+)/;var supportedNamespaces={xlink:"http://www.w3.org/1999/xlink"};/*
     * SvgProxy works as a virtual svg node.
     * @selector: The css selector of the element
     * @onElementSelected: callback in case the svg node is needed
     * @children : string supported (for text elements
     */var SvgProxy=function(_React$Component){_inherits(SvgProxy,_React$Component);function SvgProxy(props){_classCallCheck(this,SvgProxy);// DOM references to the selected nodes
var _this=_possibleConstructorReturn(this,(SvgProxy.__proto__||Object.getPrototypeOf(SvgProxy)).call(this,props));_this.elemRefs=[];_this.svgRef=null;_this.path=null;_this.originalValues={};_this.onSvgUpdated=_this.onSvgUpdated.bind(_this);_this.updateSvgElements=_this.updateSvgElements.bind(_this);return _this;}_createClass(SvgProxy,[{key:"componentDidMount",value:function componentDidMount(){this.updateSvgElements(this.props);}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps){// If the selector property changed, reset the selected references
if(this.props.selector!==prevProps.selector){this.elemRefs=[];}// If a prop has changed then update the element
this.updateSvgElements(this.props);}},{key:"onSvgUpdated",value:function onSvgUpdated(){// force to reapply updates
this.updateSvgElements(this.props,true);}},{key:"updateSvgElements",value:function updateSvgElements(nextProps,force){var svgRef=this.svgRef;if(svgRef&&(this.elemRefs.length===0||force)){// We don't have the svg element reference.
var nodes=[].slice.apply(svgRef.querySelectorAll(nextProps.selector));if(nodes.length===0&&["svg","root"].indexOf(nextProps.selector)!==-1){// If the selector equls 'svg' or 'root' use the svg node
nodes.push(svgRef);}// Call the onElementSelected callback with the element (or array)
if(nextProps.onElementSelected&&nodes.length){nextProps.onElementSelected(nodes.length===1?nodes[0]:nodes);}this.elemRefs=nodes;}if(this.elemRefs){var propkeys=Object.keys(nextProps);for(var i=0;i<propkeys.length;i+=1){var propName=propkeys[i];// Ignore component props
var ownprop=["selector","onElementSelected"].indexOf(propName)!==-1;if(!ownprop){var nsPrefix=null;var nsValue=null;var attrNameWithoutPrefix=propName;var attrNamePrefixed=null;// TODO: check performance implications (for animations) of testing everytime
var r=hasNamespaceRegexp.exec(propName);if(r&&r[1]){// eslint-disable-next-line
nsPrefix=r[1];nsValue=supportedNamespaces[nsPrefix];// eslint-disable-next-line
attrNameWithoutPrefix=r[2];attrNamePrefixed=nsPrefix+":"+attrNameWithoutPrefix;}else {attrNamePrefixed=propName;}// Apply attributes to node
for(var elemix=0;elemix<this.elemRefs.length;elemix+=1){var elem=this.elemRefs[elemix];if(typeof nextProps[propName]==="function"){elem[propName.toLowerCase()]=nextProps[propName];}else {// Discard non string props
// TODO: Support style conversion
if(typeof nextProps[propName]!=="string"){return;}// Save originalValue
if(this.originalValues[propName]==null){this.originalValues[propName]=elem.getAttributeNS(nsValue,attrNamePrefixed)||"";}// TODO: Optimization, avoid using replace everytime
var attrValue=nextProps[propName].replace("$ORIGINAL",this.originalValues[propName]);// https://developer.mozilla.org/en/docs/Web/SVG/Namespaces_Crash_Course
elem.setAttributeNS(nsValue,attrNamePrefixed,attrValue);// Set inner text
if(typeof nextProps.children==="string"&&nextProps.children.trim().length){elem.textContent=nextProps.children;}}}}}}}},{key:"render",value:function render(){var _this2=this;return _react2.default.createElement(_svgContext2.default.Consumer,null,function(obj){var path=obj.path,svg=obj.svg,svgCount=obj.svgCount;if(_this2.svgCount&&_this2.svgCount!==svgCount){// The svg was injected again
// this happens when the path changed
// ( when svgCount changes the new svg was injected )
_this2.onSvgUpdated();}else {_this2.svgRef=svg;_this2.path=path;_this2.svgCount=svgCount;}});}}]);return SvgProxy;}(_react2.default.Component);exports.default=SvgProxy;SvgProxy.propTypes={selector:_propTypes2.default.string.isRequired,onElementSelected:_propTypes2.default.func};SvgProxy.defaultProps={onElementSelected:function onElementSelected(){}};/***/}),(/* 17 */ /***/function(module,exports,__webpack_require__){Object.defineProperty(exports,"__esModule",{value:true});exports.TransformMotion=exports.AttributeMotion=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(1);var _propTypes2=_interopRequireDefault(_propTypes);var _reactMotion=__webpack_require__(18);var _=__webpack_require__(9);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
     * USAGE:
     * <AnimatedMotion selector="some css selector" start={{x:0, y:0}} target={{x:someValue, y:someValue}}
     */var TransformMotion=function TransformMotion(props){return _react2.default.createElement(_reactMotion.Motion,{defaultStyle:props.start,style:{x:(0, _reactMotion.spring)(props.target.x||0),y:(0, _reactMotion.spring)(props.target.y||0),angle:(0, _reactMotion.spring)(props.target.angle||0),rotateX:(0, _reactMotion.spring)(props.target.rotateX||0),rotateY:(0, _reactMotion.spring)(props.target.rotateY||0)}},function(value){var tr="$ORIGINAL translate("+value.x+","+value.y+") rotate("+value.angle+" "+value.rotateX+" "+value.rotateY+")";return _react2.default.createElement(_.SvgProxy,{selector:props.selector,transform:tr});});};var transformShape={x:_propTypes2.default.number,y:_propTypes2.default.number,angle:_propTypes2.default.number,rotateX:_propTypes2.default.number,rotateY:_propTypes2.default.number};TransformMotion.propTypes={start:_propTypes2.default.shape(transformShape),target:_propTypes2.default.shape(transformShape),selector:_propTypes2.default.string.isRequired};TransformMotion.defaultProps={start:{x:0,y:0,angle:0,rotateX:0,rotateY:0},target:{x:0,y:0,angle:0,rotateX:0,rotateY:0}};/**
     * Animates an attribute using react-motion.
     * React motion doesn't allow setting duration time
     * as it uses physics to interpolate, resulting in a natural motion.
     */var AttributeMotion=function AttributeMotion(props){var target={};Object.keys(props.target).forEach(function(key){target[key]=(0, _reactMotion.spring)(props.target[key]);});return _react2.default.createElement(_reactMotion.Motion,{defaultStyle:props.start,style:target},function(valObj){var attributes=_extends({},valObj);Object.keys(attributes).forEach(function(key){attributes[key]=props.formatValue(attributes[key]);});return _react2.default.createElement(_.SvgProxy,_extends({selector:props.selector},attributes));});};AttributeMotion.propTypes={selector:_propTypes2.default.string.isRequired,start:_propTypes2.default.object.isRequired,// eslint-disable-line
target:_propTypes2.default.object.isRequired,// eslint-disable-line
formatValue:_propTypes2.default.func};AttributeMotion.defaultProps={formatValue:function formatValue(val){return val.toString();}};exports.AttributeMotion=AttributeMotion;exports.TransformMotion=TransformMotion;/***/}),(/* 18 */ /***/function(module,exports,__webpack_require__){exports.__esModule=true;function _interopRequire(obj){return obj&&obj.__esModule?obj['default']:obj;}var _Motion=__webpack_require__(19);exports.Motion=_interopRequire(_Motion);var _StaggeredMotion=__webpack_require__(22);exports.StaggeredMotion=_interopRequire(_StaggeredMotion);var _TransitionMotion=__webpack_require__(23);exports.TransitionMotion=_interopRequire(_TransitionMotion);var _spring=__webpack_require__(25);exports.spring=_interopRequire(_spring);var _presets=__webpack_require__(11);exports.presets=_interopRequire(_presets);var _stripStyle=__webpack_require__(2);exports.stripStyle=_interopRequire(_stripStyle);// deprecated, dummy warning function
var _reorderKeys=__webpack_require__(26);exports.reorderKeys=_interopRequire(_reorderKeys);/***/}),(/* 19 */ /***/function(module,exports,__webpack_require__){exports.__esModule=true;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if('value'in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{'default':obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function');}}function _inherits(subClass,superClass){if(typeof superClass!=='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var _mapToZero=__webpack_require__(3);var _mapToZero2=_interopRequireDefault(_mapToZero);var _stripStyle=__webpack_require__(2);var _stripStyle2=_interopRequireDefault(_stripStyle);var _stepper3=__webpack_require__(4);var _stepper4=_interopRequireDefault(_stepper3);var _performanceNow=__webpack_require__(5);var _performanceNow2=_interopRequireDefault(_performanceNow);var _raf=__webpack_require__(7);var _raf2=_interopRequireDefault(_raf);var _shouldStopAnimation=__webpack_require__(8);var _shouldStopAnimation2=_interopRequireDefault(_shouldStopAnimation);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(1);var _propTypes2=_interopRequireDefault(_propTypes);var msPerFrame=1000/60;var Motion=function(_React$Component){_inherits(Motion,_React$Component);_createClass(Motion,null,[{key:'propTypes',value:{// TOOD: warn against putting a config in here
defaultStyle:_propTypes2['default'].objectOf(_propTypes2['default'].number),style:_propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number,_propTypes2['default'].object])).isRequired,children:_propTypes2['default'].func.isRequired,onRest:_propTypes2['default'].func},enumerable:true}]);function Motion(props){var _this=this;_classCallCheck(this,Motion);_React$Component.call(this,props);this.wasAnimating=false;this.animationID=null;this.prevTime=0;this.accumulatedTime=0;this.unreadPropStyle=null;this.clearUnreadPropStyle=function(destStyle){var dirty=false;var _state=_this.state;var currentStyle=_state.currentStyle;var currentVelocity=_state.currentVelocity;var lastIdealStyle=_state.lastIdealStyle;var lastIdealVelocity=_state.lastIdealVelocity;for(var key in destStyle){if(!Object.prototype.hasOwnProperty.call(destStyle,key)){continue;}var styleValue=destStyle[key];if(typeof styleValue==='number'){if(!dirty){dirty=true;currentStyle=_extends({},currentStyle);currentVelocity=_extends({},currentVelocity);lastIdealStyle=_extends({},lastIdealStyle);lastIdealVelocity=_extends({},lastIdealVelocity);}currentStyle[key]=styleValue;currentVelocity[key]=0;lastIdealStyle[key]=styleValue;lastIdealVelocity[key]=0;}}if(dirty){_this.setState({currentStyle:currentStyle,currentVelocity:currentVelocity,lastIdealStyle:lastIdealStyle,lastIdealVelocity:lastIdealVelocity});}};this.startAnimationIfNecessary=function(){// TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
// call cb? No, otherwise accidental parent rerender causes cb trigger
_this.animationID=_raf2['default'](function(timestamp){// check if we need to animate in the first place
var propsStyle=_this.props.style;if(_shouldStopAnimation2['default'](_this.state.currentStyle,propsStyle,_this.state.currentVelocity)){if(_this.wasAnimating&&_this.props.onRest){_this.props.onRest();}// no need to cancel animationID here; shouldn't have any in flight
_this.animationID=null;_this.wasAnimating=false;_this.accumulatedTime=0;return;}_this.wasAnimating=true;var currentTime=timestamp||_performanceNow2['default']();var timeDelta=currentTime-_this.prevTime;_this.prevTime=currentTime;_this.accumulatedTime=_this.accumulatedTime+timeDelta;// more than 10 frames? prolly switched browser tab. Restart
if(_this.accumulatedTime>msPerFrame*10){_this.accumulatedTime=0;}if(_this.accumulatedTime===0){// no need to cancel animationID here; shouldn't have any in flight
_this.animationID=null;_this.startAnimationIfNecessary();return;}var currentFrameCompletion=(_this.accumulatedTime-Math.floor(_this.accumulatedTime/msPerFrame)*msPerFrame)/msPerFrame;var framesToCatchUp=Math.floor(_this.accumulatedTime/msPerFrame);var newLastIdealStyle={};var newLastIdealVelocity={};var newCurrentStyle={};var newCurrentVelocity={};for(var key in propsStyle){if(!Object.prototype.hasOwnProperty.call(propsStyle,key)){continue;}var styleValue=propsStyle[key];if(typeof styleValue==='number'){newCurrentStyle[key]=styleValue;newCurrentVelocity[key]=0;newLastIdealStyle[key]=styleValue;newLastIdealVelocity[key]=0;}else {var newLastIdealStyleValue=_this.state.lastIdealStyle[key];var newLastIdealVelocityValue=_this.state.lastIdealVelocity[key];for(var i=0;i<framesToCatchUp;i++){var _stepper=_stepper4['default'](msPerFrame/1000,newLastIdealStyleValue,newLastIdealVelocityValue,styleValue.val,styleValue.stiffness,styleValue.damping,styleValue.precision);newLastIdealStyleValue=_stepper[0];newLastIdealVelocityValue=_stepper[1];}var _stepper2=_stepper4['default'](msPerFrame/1000,newLastIdealStyleValue,newLastIdealVelocityValue,styleValue.val,styleValue.stiffness,styleValue.damping,styleValue.precision);var nextIdealX=_stepper2[0];var nextIdealV=_stepper2[1];newCurrentStyle[key]=newLastIdealStyleValue+(nextIdealX-newLastIdealStyleValue)*currentFrameCompletion;newCurrentVelocity[key]=newLastIdealVelocityValue+(nextIdealV-newLastIdealVelocityValue)*currentFrameCompletion;newLastIdealStyle[key]=newLastIdealStyleValue;newLastIdealVelocity[key]=newLastIdealVelocityValue;}}_this.animationID=null;// the amount we're looped over above
_this.accumulatedTime-=framesToCatchUp*msPerFrame;_this.setState({currentStyle:newCurrentStyle,currentVelocity:newCurrentVelocity,lastIdealStyle:newLastIdealStyle,lastIdealVelocity:newLastIdealVelocity});_this.unreadPropStyle=null;_this.startAnimationIfNecessary();});};this.state=this.defaultState();}Motion.prototype.defaultState=function defaultState(){var _props=this.props;var defaultStyle=_props.defaultStyle;var style=_props.style;var currentStyle=defaultStyle||_stripStyle2['default'](style);var currentVelocity=_mapToZero2['default'](currentStyle);return {currentStyle:currentStyle,currentVelocity:currentVelocity,lastIdealStyle:currentStyle,lastIdealVelocity:currentVelocity};};// it's possible that currentStyle's value is stale: if props is immediately
// changed from 0 to 400 to spring(0) again, the async currentStyle is still
// at 0 (didn't have time to tick and interpolate even once). If we naively
// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
// In reality currentStyle should be 400
Motion.prototype.componentDidMount=function componentDidMount(){this.prevTime=_performanceNow2['default']();this.startAnimationIfNecessary();};Motion.prototype.componentWillReceiveProps=function componentWillReceiveProps(props){if(this.unreadPropStyle!=null){// previous props haven't had the chance to be set yet; set them here
this.clearUnreadPropStyle(this.unreadPropStyle);}this.unreadPropStyle=props.style;if(this.animationID==null){this.prevTime=_performanceNow2['default']();this.startAnimationIfNecessary();}};Motion.prototype.componentWillUnmount=function componentWillUnmount(){if(this.animationID!=null){_raf2['default'].cancel(this.animationID);this.animationID=null;}};Motion.prototype.render=function render(){var renderedChildren=this.props.children(this.state.currentStyle);return renderedChildren&&_react2['default'].Children.only(renderedChildren);};return Motion;}(_react2['default'].Component);exports['default']=Motion;module.exports=exports['default'];// after checking for unreadPropStyle != null, we manually go set the
// non-interpolating values (those that are a number, without a spring
// config)
/***/}),(/* 20 */ /***/function(module,exports){var g;// This works in non-strict mode
g=function(){return this;}();try{// This works if eval is allowed (see CSP)
g=g||Function("return this")()||(1,eval)("this");}catch(e){// This works if the window reference is available
if(typeof window==="object")g=window;}// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}
module.exports=g;/***/}),(/* 21 */ /***/function(module,exports,__webpack_require__){/* WEBPACK VAR INJECTION */(function(process){// Generated by CoffeeScript 1.12.2
(function(){var getNanoSeconds,hrtime,loadTime,moduleLoadTime,nodeLoadTime,upTime;if(typeof performance!=="undefined"&&performance!==null&&performance.now){module.exports=function(){return performance.now();};}else if(typeof process!=="undefined"&&process!==null&&process.hrtime){module.exports=function(){return (getNanoSeconds()-nodeLoadTime)/1e6;};hrtime=process.hrtime;getNanoSeconds=function(){var hr;hr=hrtime();return hr[0]*1e9+hr[1];};moduleLoadTime=getNanoSeconds();upTime=process.uptime()*1e9;nodeLoadTime=moduleLoadTime-upTime;}else if(Date.now){module.exports=function(){return Date.now()-loadTime;};loadTime=Date.now();}else {module.exports=function(){return new Date().getTime()-loadTime;};loadTime=new Date().getTime();}}).call(this);/* WEBPACK VAR INJECTION */}).call(exports,__webpack_require__(6));/***/}),(/* 22 */ /***/function(module,exports,__webpack_require__){exports.__esModule=true;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if('value'in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{'default':obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function');}}function _inherits(subClass,superClass){if(typeof superClass!=='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var _mapToZero=__webpack_require__(3);var _mapToZero2=_interopRequireDefault(_mapToZero);var _stripStyle=__webpack_require__(2);var _stripStyle2=_interopRequireDefault(_stripStyle);var _stepper3=__webpack_require__(4);var _stepper4=_interopRequireDefault(_stepper3);var _performanceNow=__webpack_require__(5);var _performanceNow2=_interopRequireDefault(_performanceNow);var _raf=__webpack_require__(7);var _raf2=_interopRequireDefault(_raf);var _shouldStopAnimation=__webpack_require__(8);var _shouldStopAnimation2=_interopRequireDefault(_shouldStopAnimation);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(1);var _propTypes2=_interopRequireDefault(_propTypes);var msPerFrame=1000/60;function shouldStopAnimationAll(currentStyles,styles,currentVelocities){for(var i=0;i<currentStyles.length;i++){if(!_shouldStopAnimation2['default'](currentStyles[i],styles[i],currentVelocities[i])){return false;}}return true;}var StaggeredMotion=function(_React$Component){_inherits(StaggeredMotion,_React$Component);_createClass(StaggeredMotion,null,[{key:'propTypes',value:{// TOOD: warn against putting a config in here
defaultStyles:_propTypes2['default'].arrayOf(_propTypes2['default'].objectOf(_propTypes2['default'].number)),styles:_propTypes2['default'].func.isRequired,children:_propTypes2['default'].func.isRequired},enumerable:true}]);function StaggeredMotion(props){var _this=this;_classCallCheck(this,StaggeredMotion);_React$Component.call(this,props);this.animationID=null;this.prevTime=0;this.accumulatedTime=0;this.unreadPropStyles=null;this.clearUnreadPropStyle=function(unreadPropStyles){var _state=_this.state;var currentStyles=_state.currentStyles;var currentVelocities=_state.currentVelocities;var lastIdealStyles=_state.lastIdealStyles;var lastIdealVelocities=_state.lastIdealVelocities;var someDirty=false;for(var i=0;i<unreadPropStyles.length;i++){var unreadPropStyle=unreadPropStyles[i];var dirty=false;for(var key in unreadPropStyle){if(!Object.prototype.hasOwnProperty.call(unreadPropStyle,key)){continue;}var styleValue=unreadPropStyle[key];if(typeof styleValue==='number'){if(!dirty){dirty=true;someDirty=true;currentStyles[i]=_extends({},currentStyles[i]);currentVelocities[i]=_extends({},currentVelocities[i]);lastIdealStyles[i]=_extends({},lastIdealStyles[i]);lastIdealVelocities[i]=_extends({},lastIdealVelocities[i]);}currentStyles[i][key]=styleValue;currentVelocities[i][key]=0;lastIdealStyles[i][key]=styleValue;lastIdealVelocities[i][key]=0;}}}if(someDirty){_this.setState({currentStyles:currentStyles,currentVelocities:currentVelocities,lastIdealStyles:lastIdealStyles,lastIdealVelocities:lastIdealVelocities});}};this.startAnimationIfNecessary=function(){// TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
// call cb? No, otherwise accidental parent rerender causes cb trigger
_this.animationID=_raf2['default'](function(timestamp){var destStyles=_this.props.styles(_this.state.lastIdealStyles);// check if we need to animate in the first place
if(shouldStopAnimationAll(_this.state.currentStyles,destStyles,_this.state.currentVelocities)){// no need to cancel animationID here; shouldn't have any in flight
_this.animationID=null;_this.accumulatedTime=0;return;}var currentTime=timestamp||_performanceNow2['default']();var timeDelta=currentTime-_this.prevTime;_this.prevTime=currentTime;_this.accumulatedTime=_this.accumulatedTime+timeDelta;// more than 10 frames? prolly switched browser tab. Restart
if(_this.accumulatedTime>msPerFrame*10){_this.accumulatedTime=0;}if(_this.accumulatedTime===0){// no need to cancel animationID here; shouldn't have any in flight
_this.animationID=null;_this.startAnimationIfNecessary();return;}var currentFrameCompletion=(_this.accumulatedTime-Math.floor(_this.accumulatedTime/msPerFrame)*msPerFrame)/msPerFrame;var framesToCatchUp=Math.floor(_this.accumulatedTime/msPerFrame);var newLastIdealStyles=[];var newLastIdealVelocities=[];var newCurrentStyles=[];var newCurrentVelocities=[];for(var i=0;i<destStyles.length;i++){var destStyle=destStyles[i];var newCurrentStyle={};var newCurrentVelocity={};var newLastIdealStyle={};var newLastIdealVelocity={};for(var key in destStyle){if(!Object.prototype.hasOwnProperty.call(destStyle,key)){continue;}var styleValue=destStyle[key];if(typeof styleValue==='number'){newCurrentStyle[key]=styleValue;newCurrentVelocity[key]=0;newLastIdealStyle[key]=styleValue;newLastIdealVelocity[key]=0;}else {var newLastIdealStyleValue=_this.state.lastIdealStyles[i][key];var newLastIdealVelocityValue=_this.state.lastIdealVelocities[i][key];for(var j=0;j<framesToCatchUp;j++){var _stepper=_stepper4['default'](msPerFrame/1000,newLastIdealStyleValue,newLastIdealVelocityValue,styleValue.val,styleValue.stiffness,styleValue.damping,styleValue.precision);newLastIdealStyleValue=_stepper[0];newLastIdealVelocityValue=_stepper[1];}var _stepper2=_stepper4['default'](msPerFrame/1000,newLastIdealStyleValue,newLastIdealVelocityValue,styleValue.val,styleValue.stiffness,styleValue.damping,styleValue.precision);var nextIdealX=_stepper2[0];var nextIdealV=_stepper2[1];newCurrentStyle[key]=newLastIdealStyleValue+(nextIdealX-newLastIdealStyleValue)*currentFrameCompletion;newCurrentVelocity[key]=newLastIdealVelocityValue+(nextIdealV-newLastIdealVelocityValue)*currentFrameCompletion;newLastIdealStyle[key]=newLastIdealStyleValue;newLastIdealVelocity[key]=newLastIdealVelocityValue;}}newCurrentStyles[i]=newCurrentStyle;newCurrentVelocities[i]=newCurrentVelocity;newLastIdealStyles[i]=newLastIdealStyle;newLastIdealVelocities[i]=newLastIdealVelocity;}_this.animationID=null;// the amount we're looped over above
_this.accumulatedTime-=framesToCatchUp*msPerFrame;_this.setState({currentStyles:newCurrentStyles,currentVelocities:newCurrentVelocities,lastIdealStyles:newLastIdealStyles,lastIdealVelocities:newLastIdealVelocities});_this.unreadPropStyles=null;_this.startAnimationIfNecessary();});};this.state=this.defaultState();}StaggeredMotion.prototype.defaultState=function defaultState(){var _props=this.props;var defaultStyles=_props.defaultStyles;var styles=_props.styles;var currentStyles=defaultStyles||styles().map(_stripStyle2['default']);var currentVelocities=currentStyles.map(function(currentStyle){return _mapToZero2['default'](currentStyle);});return {currentStyles:currentStyles,currentVelocities:currentVelocities,lastIdealStyles:currentStyles,lastIdealVelocities:currentVelocities};};StaggeredMotion.prototype.componentDidMount=function componentDidMount(){this.prevTime=_performanceNow2['default']();this.startAnimationIfNecessary();};StaggeredMotion.prototype.componentWillReceiveProps=function componentWillReceiveProps(props){if(this.unreadPropStyles!=null){// previous props haven't had the chance to be set yet; set them here
this.clearUnreadPropStyle(this.unreadPropStyles);}this.unreadPropStyles=props.styles(this.state.lastIdealStyles);if(this.animationID==null){this.prevTime=_performanceNow2['default']();this.startAnimationIfNecessary();}};StaggeredMotion.prototype.componentWillUnmount=function componentWillUnmount(){if(this.animationID!=null){_raf2['default'].cancel(this.animationID);this.animationID=null;}};StaggeredMotion.prototype.render=function render(){var renderedChildren=this.props.children(this.state.currentStyles);return renderedChildren&&_react2['default'].Children.only(renderedChildren);};return StaggeredMotion;}(_react2['default'].Component);exports['default']=StaggeredMotion;module.exports=exports['default'];// it's possible that currentStyle's value is stale: if props is immediately
// changed from 0 to 400 to spring(0) again, the async currentStyle is still
// at 0 (didn't have time to tick and interpolate even once). If we naively
// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
// In reality currentStyle should be 400
// after checking for unreadPropStyles != null, we manually go set the
// non-interpolating values (those that are a number, without a spring
// config)
/***/}),(/* 23 */ /***/function(module,exports,__webpack_require__){exports.__esModule=true;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if('value'in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{'default':obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function');}}function _inherits(subClass,superClass){if(typeof superClass!=='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var _mapToZero=__webpack_require__(3);var _mapToZero2=_interopRequireDefault(_mapToZero);var _stripStyle=__webpack_require__(2);var _stripStyle2=_interopRequireDefault(_stripStyle);var _stepper3=__webpack_require__(4);var _stepper4=_interopRequireDefault(_stepper3);var _mergeDiff=__webpack_require__(24);var _mergeDiff2=_interopRequireDefault(_mergeDiff);var _performanceNow=__webpack_require__(5);var _performanceNow2=_interopRequireDefault(_performanceNow);var _raf=__webpack_require__(7);var _raf2=_interopRequireDefault(_raf);var _shouldStopAnimation=__webpack_require__(8);var _shouldStopAnimation2=_interopRequireDefault(_shouldStopAnimation);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(1);var _propTypes2=_interopRequireDefault(_propTypes);var msPerFrame=1000/60;// the children function & (potential) styles function asks as param an
// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
// {key: string, data?: any, style: PlainStyle}. However, the way we keep
// internal states doesn't contain such a data structure (check the state and
// TransitionMotionState). So when children function and others ask for such
// data we need to generate them on the fly by combining mergedPropsStyles and
// currentStyles/lastIdealStyles
function rehydrateStyles(mergedPropsStyles,unreadPropStyles,plainStyles){// Copy the value to a `const` so that Flow understands that the const won't
// change and will be non-nullable in the callback below.
var cUnreadPropStyles=unreadPropStyles;if(cUnreadPropStyles==null){return mergedPropsStyles.map(function(mergedPropsStyle,i){return {key:mergedPropsStyle.key,data:mergedPropsStyle.data,style:plainStyles[i]};});}return mergedPropsStyles.map(function(mergedPropsStyle,i){for(var j=0;j<cUnreadPropStyles.length;j++){if(cUnreadPropStyles[j].key===mergedPropsStyle.key){return {key:cUnreadPropStyles[j].key,data:cUnreadPropStyles[j].data,style:plainStyles[i]};}}return {key:mergedPropsStyle.key,data:mergedPropsStyle.data,style:plainStyles[i]};});}function shouldStopAnimationAll(currentStyles,destStyles,currentVelocities,mergedPropsStyles){if(mergedPropsStyles.length!==destStyles.length){return false;}for(var i=0;i<mergedPropsStyles.length;i++){if(mergedPropsStyles[i].key!==destStyles[i].key){return false;}}// we have the invariant that mergedPropsStyles and
// currentStyles/currentVelocities/last* are synced in terms of cells, see
// mergeAndSync comment for more info
for(var i=0;i<mergedPropsStyles.length;i++){if(!_shouldStopAnimation2['default'](currentStyles[i],destStyles[i].style,currentVelocities[i])){return false;}}return true;}// core key merging logic
// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
// c}, previous current (interpolating) style is {a, b}
// **invariant**: current[i] corresponds to merged[i] in terms of key
// steps:
// turn merged style into {a?, b, c}
//    add c, value of c is destStyles.c
//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
// turn current (interpolating) style from {a, b} into {a?, b, c}
//    maybe remove a
//    certainly add c, value of c is willEnter(c)
// loop over merged and construct new current
// dest doesn't change, that's owner's
function mergeAndSync(willEnter,willLeave,didLeave,oldMergedPropsStyles,destStyles,oldCurrentStyles,oldCurrentVelocities,oldLastIdealStyles,oldLastIdealVelocities){var newMergedPropsStyles=_mergeDiff2['default'](oldMergedPropsStyles,destStyles,function(oldIndex,oldMergedPropsStyle){var leavingStyle=willLeave(oldMergedPropsStyle);if(leavingStyle==null){didLeave({key:oldMergedPropsStyle.key,data:oldMergedPropsStyle.data});return null;}if(_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex],leavingStyle,oldCurrentVelocities[oldIndex])){didLeave({key:oldMergedPropsStyle.key,data:oldMergedPropsStyle.data});return null;}return {key:oldMergedPropsStyle.key,data:oldMergedPropsStyle.data,style:leavingStyle};});var newCurrentStyles=[];var newCurrentVelocities=[];var newLastIdealStyles=[];var newLastIdealVelocities=[];for(var i=0;i<newMergedPropsStyles.length;i++){var newMergedPropsStyleCell=newMergedPropsStyles[i];var foundOldIndex=null;for(var j=0;j<oldMergedPropsStyles.length;j++){if(oldMergedPropsStyles[j].key===newMergedPropsStyleCell.key){foundOldIndex=j;break;}}// TODO: key search code
if(foundOldIndex==null){var plainStyle=willEnter(newMergedPropsStyleCell);newCurrentStyles[i]=plainStyle;newLastIdealStyles[i]=plainStyle;var velocity=_mapToZero2['default'](newMergedPropsStyleCell.style);newCurrentVelocities[i]=velocity;newLastIdealVelocities[i]=velocity;}else {newCurrentStyles[i]=oldCurrentStyles[foundOldIndex];newLastIdealStyles[i]=oldLastIdealStyles[foundOldIndex];newCurrentVelocities[i]=oldCurrentVelocities[foundOldIndex];newLastIdealVelocities[i]=oldLastIdealVelocities[foundOldIndex];}}return [newMergedPropsStyles,newCurrentStyles,newCurrentVelocities,newLastIdealStyles,newLastIdealVelocities];}var TransitionMotion=function(_React$Component){_inherits(TransitionMotion,_React$Component);_createClass(TransitionMotion,null,[{key:'propTypes',value:{defaultStyles:_propTypes2['default'].arrayOf(_propTypes2['default'].shape({key:_propTypes2['default'].string.isRequired,data:_propTypes2['default'].any,style:_propTypes2['default'].objectOf(_propTypes2['default'].number).isRequired})),styles:_propTypes2['default'].oneOfType([_propTypes2['default'].func,_propTypes2['default'].arrayOf(_propTypes2['default'].shape({key:_propTypes2['default'].string.isRequired,data:_propTypes2['default'].any,style:_propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number,_propTypes2['default'].object])).isRequired}))]).isRequired,children:_propTypes2['default'].func.isRequired,willEnter:_propTypes2['default'].func,willLeave:_propTypes2['default'].func,didLeave:_propTypes2['default'].func},enumerable:true},{key:'defaultProps',value:{willEnter:function willEnter(styleThatEntered){return _stripStyle2['default'](styleThatEntered.style);},// recall: returning null makes the current unmounting TransitionStyle
// disappear immediately
willLeave:function willLeave(){return null;},didLeave:function didLeave(){}},enumerable:true}]);function TransitionMotion(props){var _this=this;_classCallCheck(this,TransitionMotion);_React$Component.call(this,props);this.unmounting=false;this.animationID=null;this.prevTime=0;this.accumulatedTime=0;this.unreadPropStyles=null;this.clearUnreadPropStyle=function(unreadPropStyles){var _mergeAndSync=mergeAndSync(_this.props.willEnter,_this.props.willLeave,_this.props.didLeave,_this.state.mergedPropsStyles,unreadPropStyles,_this.state.currentStyles,_this.state.currentVelocities,_this.state.lastIdealStyles,_this.state.lastIdealVelocities);var mergedPropsStyles=_mergeAndSync[0];var currentStyles=_mergeAndSync[1];var currentVelocities=_mergeAndSync[2];var lastIdealStyles=_mergeAndSync[3];var lastIdealVelocities=_mergeAndSync[4];for(var i=0;i<unreadPropStyles.length;i++){var unreadPropStyle=unreadPropStyles[i].style;var dirty=false;for(var key in unreadPropStyle){if(!Object.prototype.hasOwnProperty.call(unreadPropStyle,key)){continue;}var styleValue=unreadPropStyle[key];if(typeof styleValue==='number'){if(!dirty){dirty=true;currentStyles[i]=_extends({},currentStyles[i]);currentVelocities[i]=_extends({},currentVelocities[i]);lastIdealStyles[i]=_extends({},lastIdealStyles[i]);lastIdealVelocities[i]=_extends({},lastIdealVelocities[i]);mergedPropsStyles[i]={key:mergedPropsStyles[i].key,data:mergedPropsStyles[i].data,style:_extends({},mergedPropsStyles[i].style)};}currentStyles[i][key]=styleValue;currentVelocities[i][key]=0;lastIdealStyles[i][key]=styleValue;lastIdealVelocities[i][key]=0;mergedPropsStyles[i].style[key]=styleValue;}}}// unlike the other 2 components, we can't detect staleness and optionally
// opt out of setState here. each style object's data might contain new
// stuff we're not/cannot compare
_this.setState({currentStyles:currentStyles,currentVelocities:currentVelocities,mergedPropsStyles:mergedPropsStyles,lastIdealStyles:lastIdealStyles,lastIdealVelocities:lastIdealVelocities});};this.startAnimationIfNecessary=function(){if(_this.unmounting){return;}// TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
// call cb? No, otherwise accidental parent rerender causes cb trigger
_this.animationID=_raf2['default'](function(timestamp){// https://github.com/chenglou/react-motion/pull/420
// > if execution passes the conditional if (this.unmounting), then
// executes async defaultRaf and after that component unmounts and after
// that the callback of defaultRaf is called, then setState will be called
// on unmounted component.
if(_this.unmounting){return;}var propStyles=_this.props.styles;var destStyles=typeof propStyles==='function'?propStyles(rehydrateStyles(_this.state.mergedPropsStyles,_this.unreadPropStyles,_this.state.lastIdealStyles)):propStyles;// check if we need to animate in the first place
if(shouldStopAnimationAll(_this.state.currentStyles,destStyles,_this.state.currentVelocities,_this.state.mergedPropsStyles)){// no need to cancel animationID here; shouldn't have any in flight
_this.animationID=null;_this.accumulatedTime=0;return;}var currentTime=timestamp||_performanceNow2['default']();var timeDelta=currentTime-_this.prevTime;_this.prevTime=currentTime;_this.accumulatedTime=_this.accumulatedTime+timeDelta;// more than 10 frames? prolly switched browser tab. Restart
if(_this.accumulatedTime>msPerFrame*10){_this.accumulatedTime=0;}if(_this.accumulatedTime===0){// no need to cancel animationID here; shouldn't have any in flight
_this.animationID=null;_this.startAnimationIfNecessary();return;}var currentFrameCompletion=(_this.accumulatedTime-Math.floor(_this.accumulatedTime/msPerFrame)*msPerFrame)/msPerFrame;var framesToCatchUp=Math.floor(_this.accumulatedTime/msPerFrame);var _mergeAndSync2=mergeAndSync(_this.props.willEnter,_this.props.willLeave,_this.props.didLeave,_this.state.mergedPropsStyles,destStyles,_this.state.currentStyles,_this.state.currentVelocities,_this.state.lastIdealStyles,_this.state.lastIdealVelocities);var newMergedPropsStyles=_mergeAndSync2[0];var newCurrentStyles=_mergeAndSync2[1];var newCurrentVelocities=_mergeAndSync2[2];var newLastIdealStyles=_mergeAndSync2[3];var newLastIdealVelocities=_mergeAndSync2[4];for(var i=0;i<newMergedPropsStyles.length;i++){var newMergedPropsStyle=newMergedPropsStyles[i].style;var newCurrentStyle={};var newCurrentVelocity={};var newLastIdealStyle={};var newLastIdealVelocity={};for(var key in newMergedPropsStyle){if(!Object.prototype.hasOwnProperty.call(newMergedPropsStyle,key)){continue;}var styleValue=newMergedPropsStyle[key];if(typeof styleValue==='number'){newCurrentStyle[key]=styleValue;newCurrentVelocity[key]=0;newLastIdealStyle[key]=styleValue;newLastIdealVelocity[key]=0;}else {var newLastIdealStyleValue=newLastIdealStyles[i][key];var newLastIdealVelocityValue=newLastIdealVelocities[i][key];for(var j=0;j<framesToCatchUp;j++){var _stepper=_stepper4['default'](msPerFrame/1000,newLastIdealStyleValue,newLastIdealVelocityValue,styleValue.val,styleValue.stiffness,styleValue.damping,styleValue.precision);newLastIdealStyleValue=_stepper[0];newLastIdealVelocityValue=_stepper[1];}var _stepper2=_stepper4['default'](msPerFrame/1000,newLastIdealStyleValue,newLastIdealVelocityValue,styleValue.val,styleValue.stiffness,styleValue.damping,styleValue.precision);var nextIdealX=_stepper2[0];var nextIdealV=_stepper2[1];newCurrentStyle[key]=newLastIdealStyleValue+(nextIdealX-newLastIdealStyleValue)*currentFrameCompletion;newCurrentVelocity[key]=newLastIdealVelocityValue+(nextIdealV-newLastIdealVelocityValue)*currentFrameCompletion;newLastIdealStyle[key]=newLastIdealStyleValue;newLastIdealVelocity[key]=newLastIdealVelocityValue;}}newLastIdealStyles[i]=newLastIdealStyle;newLastIdealVelocities[i]=newLastIdealVelocity;newCurrentStyles[i]=newCurrentStyle;newCurrentVelocities[i]=newCurrentVelocity;}_this.animationID=null;// the amount we're looped over above
_this.accumulatedTime-=framesToCatchUp*msPerFrame;_this.setState({currentStyles:newCurrentStyles,currentVelocities:newCurrentVelocities,lastIdealStyles:newLastIdealStyles,lastIdealVelocities:newLastIdealVelocities,mergedPropsStyles:newMergedPropsStyles});_this.unreadPropStyles=null;_this.startAnimationIfNecessary();});};this.state=this.defaultState();}TransitionMotion.prototype.defaultState=function defaultState(){var _props=this.props;var defaultStyles=_props.defaultStyles;var styles=_props.styles;var willEnter=_props.willEnter;var willLeave=_props.willLeave;var didLeave=_props.didLeave;var destStyles=typeof styles==='function'?styles(defaultStyles):styles;// this is special. for the first time around, we don't have a comparison
// between last (no last) and current merged props. we'll compute last so:
// say default is {a, b} and styles (dest style) is {b, c}, we'll
// fabricate last as {a, b}
var oldMergedPropsStyles=undefined;if(defaultStyles==null){oldMergedPropsStyles=destStyles;}else {oldMergedPropsStyles=defaultStyles.map(function(defaultStyleCell){// TODO: key search code
for(var i=0;i<destStyles.length;i++){if(destStyles[i].key===defaultStyleCell.key){return destStyles[i];}}return defaultStyleCell;});}var oldCurrentStyles=defaultStyles==null?destStyles.map(function(s){return _stripStyle2['default'](s.style);}):defaultStyles.map(function(s){return _stripStyle2['default'](s.style);});var oldCurrentVelocities=defaultStyles==null?destStyles.map(function(s){return _mapToZero2['default'](s.style);}):defaultStyles.map(function(s){return _mapToZero2['default'](s.style);});var _mergeAndSync3=mergeAndSync(// Because this is an old-style createReactClass component, Flow doesn't
// understand that the willEnter and willLeave props have default values
// and will always be present.
willEnter,willLeave,didLeave,oldMergedPropsStyles,destStyles,oldCurrentStyles,oldCurrentVelocities,oldCurrentStyles,// oldLastIdealStyles really
oldCurrentVelocities);var mergedPropsStyles=_mergeAndSync3[0];var currentStyles=_mergeAndSync3[1];var currentVelocities=_mergeAndSync3[2];var lastIdealStyles=_mergeAndSync3[3];var lastIdealVelocities=_mergeAndSync3[4];// oldLastIdealVelocities really
return {currentStyles:currentStyles,currentVelocities:currentVelocities,lastIdealStyles:lastIdealStyles,lastIdealVelocities:lastIdealVelocities,mergedPropsStyles:mergedPropsStyles};};// after checking for unreadPropStyles != null, we manually go set the
// non-interpolating values (those that are a number, without a spring
// config)
TransitionMotion.prototype.componentDidMount=function componentDidMount(){this.prevTime=_performanceNow2['default']();this.startAnimationIfNecessary();};TransitionMotion.prototype.componentWillReceiveProps=function componentWillReceiveProps(props){if(this.unreadPropStyles){// previous props haven't had the chance to be set yet; set them here
this.clearUnreadPropStyle(this.unreadPropStyles);}var styles=props.styles;if(typeof styles==='function'){this.unreadPropStyles=styles(rehydrateStyles(this.state.mergedPropsStyles,this.unreadPropStyles,this.state.lastIdealStyles));}else {this.unreadPropStyles=styles;}if(this.animationID==null){this.prevTime=_performanceNow2['default']();this.startAnimationIfNecessary();}};TransitionMotion.prototype.componentWillUnmount=function componentWillUnmount(){this.unmounting=true;if(this.animationID!=null){_raf2['default'].cancel(this.animationID);this.animationID=null;}};TransitionMotion.prototype.render=function render(){var hydratedStyles=rehydrateStyles(this.state.mergedPropsStyles,this.unreadPropStyles,this.state.currentStyles);var renderedChildren=this.props.children(hydratedStyles);return renderedChildren&&_react2['default'].Children.only(renderedChildren);};return TransitionMotion;}(_react2['default'].Component);exports['default']=TransitionMotion;module.exports=exports['default'];// list of styles, each containing interpolating values. Part of what's passed
// to children function. Notice that this is
// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
// contains the key & data info (so that we only have a single source of truth
// for these, and to save space). Check the comment for `rehydrateStyles` to
// see how we regenerate the entirety of what's passed to children function
// the array that keeps track of currently rendered stuff! Including stuff
// that you've unmounted but that's still animating. This is where it lives
// it's possible that currentStyle's value is stale: if props is immediately
// changed from 0 to 400 to spring(0) again, the async currentStyle is still
// at 0 (didn't have time to tick and interpolate even once). If we naively
// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
// In reality currentStyle should be 400
/***/}),(/* 24 */ /***/function(module,exports,__webpack_require__){// core keys merging algorithm. If previous render's keys are [a, b], and the
// next render's [c, b, d], what's the final merged keys and ordering?
// - c and a must both be before b
// - b before d
// - ordering between a and c ambiguous
// this reduces to merging two partially ordered lists (e.g. lists where not
// every item has a definite ordering, like comparing a and c above). For the
// ambiguous ordering we deterministically choose to place the next render's
// item after the previous'; so c after a
// this is called a topological sorting. Except the existing algorithms don't
// work well with js bc of the amount of allocation, and isn't optimized for our
// current use-case bc the runtime is linear in terms of edges (see wiki for
// meaning), which is huge when two lists have many common elements
exports.__esModule=true;exports['default']=mergeDiff;function mergeDiff(prev,next,onRemove){// bookkeeping for easier access of a key's index below. This is 2 allocations +
// potentially triggering chrome hash map mode for objs (so it might be faster
var prevKeyIndex={};for(var i=0;i<prev.length;i++){prevKeyIndex[prev[i].key]=i;}var nextKeyIndex={};for(var i=0;i<next.length;i++){nextKeyIndex[next[i].key]=i;}// first, an overly elaborate way of merging prev and next, eliminating
// duplicates (in terms of keys). If there's dupe, keep the item in next).
// This way of writing it saves allocations
var ret=[];for(var i=0;i<next.length;i++){ret[i]=next[i];}for(var i=0;i<prev.length;i++){if(!Object.prototype.hasOwnProperty.call(nextKeyIndex,prev[i].key)){// this is called my TM's `mergeAndSync`, which calls willLeave. We don't
// merge in keys that the user desires to kill
var fill=onRemove(i,prev[i]);if(fill!=null){ret.push(fill);}}}// now all the items all present. Core sorting logic to have the right order
return ret.sort(function(a,b){var nextOrderA=nextKeyIndex[a.key];var nextOrderB=nextKeyIndex[b.key];var prevOrderA=prevKeyIndex[a.key];var prevOrderB=prevKeyIndex[b.key];if(nextOrderA!=null&&nextOrderB!=null){// both keys in next
return nextKeyIndex[a.key]-nextKeyIndex[b.key];}else if(prevOrderA!=null&&prevOrderB!=null){// both keys in prev
return prevKeyIndex[a.key]-prevKeyIndex[b.key];}else if(nextOrderA!=null){// key a in next, key b in prev
// how to determine the order between a and b? We find a "pivot" (term
// abuse), a key present in both prev and next, that is sandwiched between
// a and b. In the context of our above example, if we're comparing a and
// d, b's (the only) pivot
for(var i=0;i<next.length;i++){var pivot=next[i].key;if(!Object.prototype.hasOwnProperty.call(prevKeyIndex,pivot)){continue;}if(nextOrderA<nextKeyIndex[pivot]&&prevOrderB>prevKeyIndex[pivot]){return -1;}else if(nextOrderA>nextKeyIndex[pivot]&&prevOrderB<prevKeyIndex[pivot]){return 1;}}// pluggable. default to: next bigger than prev
return 1;}// prevOrderA, nextOrderB
for(var i=0;i<next.length;i++){var pivot=next[i].key;if(!Object.prototype.hasOwnProperty.call(prevKeyIndex,pivot)){continue;}if(nextOrderB<nextKeyIndex[pivot]&&prevOrderA>prevKeyIndex[pivot]){return 1;}else if(nextOrderB>nextKeyIndex[pivot]&&prevOrderA<prevKeyIndex[pivot]){return -1;}}// pluggable. default to: next bigger than prev
return -1;});}module.exports=exports['default'];// to loop through and find a key's index each time), but I no longer care
/***/}),(/* 25 */ /***/function(module,exports,__webpack_require__){exports.__esModule=true;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};exports['default']=spring;function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{'default':obj};}var _presets=__webpack_require__(11);var _presets2=_interopRequireDefault(_presets);var defaultConfig=_extends({},_presets2['default'].noWobble,{precision:0.01});function spring(val,config){return _extends({},defaultConfig,config,{val:val});}module.exports=exports['default'];/***/}),(/* 26 */ /***/function(module,exports,__webpack_require__){/* WEBPACK VAR INJECTION */(function(process){exports.__esModule=true;exports['default']=reorderKeys;var hasWarned=false;function reorderKeys(){if(process.env.NODE_ENV==='development'){if(!hasWarned){hasWarned=true;console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');}}}module.exports=exports['default'];/* WEBPACK VAR INJECTION */}).call(exports,__webpack_require__(6));/***/}/******/)]);/***/}),(/* 211 */ /***/function(module,exports){module.exports=ReactDOM;/***/}/******/)]);})(commonjs);var s13={knobX:71,knobY:71,svg:`
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="204px" height="204px" viewBox="0 0 204 204" version="1.1">
    <!-- Generator: Sketch 47.1 (45422) - http://www.bohemiancoding.com/sketch -->
    <desc>Created with Sketch.</desc>
    <defs>
        <linearGradient x1="50%" y1="50%" x2="50%" y2="100%" id="f7066879-f57b-f7ab-0a62-b7e76659fc9a">
            <stop stop-color="#444040" stop-opacity="0.51098279" offset="0%"/>
            <stop stop-color="#131111" stop-opacity="0.893200861" offset="100%"/>
        </linearGradient>
        <circle id="969b1f52-759b-c83e-61ec-394ce88ab344" cx="98.0400009" cy="98.0400009" r="98.0400009"/>
        <filter x="-3.3%" y="-3.3%" width="106.6%" height="106.6%" filterUnits="objectBoundingBox" id="4400ad0d-4d36-0bc1-05b0-ba46e610ec97">
            <feMorphology radius="0.5" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"/>
            <feOffset dx="0" dy="0" in="shadowSpreadOuter1" result="shadowOffsetOuter1"/>
            <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
            <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1"/>
            <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0" type="matrix" in="shadowBlurOuter1"/>
        </filter>
        <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="666891d9-1c7d-33e0-6996-abfa6bc7e950">
            <stop stop-color="#FFFFFF" stop-opacity="0.5" offset="0%"/>
            <stop stop-color="#000000" stop-opacity="0.5" offset="100%"/>
        </linearGradient>
        <circle id="2ecb830f-8637-8aaf-9333-658361cb9f49" cx="98" cy="98" r="86"/>
        <filter x="-4.1%" y="-3.5%" width="108.1%" height="108.1%" filterUnits="objectBoundingBox" id="38812cc9-6961-10e7-6c57-df005b28946b">
            <feMorphology radius="0.5" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"/>
            <feOffset dx="0" dy="1" in="shadowSpreadOuter1" result="shadowOffsetOuter1"/>
            <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
            <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1"/>
            <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0" type="matrix" in="shadowBlurOuter1"/>
        </filter>
    </defs>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="s13" transform="translate(4.000000, 4.000000)">
            <g id="container">
                <g id="Oval-2">
                    <use fill="black" fill-opacity="1" filter="url(#4400ad0d-4d36-0bc1-05b0-ba46e610ec97)" xlink:href="#969b1f52-759b-c83e-61ec-394ce88ab344"/>
                    <use stroke="#979797" stroke-width="1" fill="url(#f7066879-f57b-f7ab-0a62-b7e76659fc9a)" fill-rule="evenodd" xlink:href="#969b1f52-759b-c83e-61ec-394ce88ab344"/>
                </g>
                <g id="Oval-2">
                    <use fill="black" fill-opacity="1" filter="url(#38812cc9-6961-10e7-6c57-df005b28946b)" xlink:href="#2ecb830f-8637-8aaf-9333-658361cb9f49"/>
                    <use fill="" fill-rule="evenodd" xlink:href="#2ecb830f-8637-8aaf-9333-658361cb9f49"/>
                    <use stroke="#4A4A4A" stroke-width="1" fill="url(#666891d9-1c7d-33e0-6996-abfa6bc7e950)" fill-rule="evenodd" xlink:href="#2ecb830f-8637-8aaf-9333-658361cb9f49"/>
                </g>
                <g id="knob" transform="translate(27.431373, 27.431373)">
                    <circle id="Oval-5" fill="#322E2E" cx="71" cy="71" r="71"/>
                    <path d="M70.0686275,4.17063061 L86.5686275,65.2689929 C81.3642501,66.811221 75.8642501,67.5735686 70.0686275,67.5560356 C64.2730048,67.5385027 58.7730048,66.7761551 53.5686275,65.2689929 L70.0686275,4.17063061 Z" id="Rectangle-Copy" fill="#E6D7D7" transform="translate(70.068627, 35.863481) scale(1, -1) translate(-70.068627, -35.863481) "/>
                </g>
            </g>
        </g>
    </g>
</svg>
`};// Current version.
var VERSION='1.13.6';// Establish the root object, `window` (`self`) in the browser, `global`
// on the server, or `this` in some virtual machines. We use `self`
// instead of `window` for `WebWorker` support.
var root=typeof self=='object'&&self.self===self&&self||typeof global=='object'&&global.global===global&&global||Function('return this')()||{};// Save bytes in the minified (but not gzipped) version:
var ArrayProto=Array.prototype,ObjProto=Object.prototype;var SymbolProto=typeof Symbol!=='undefined'?Symbol.prototype:null;// Create quick reference variables for speed access to core prototypes.
var push=ArrayProto.push,slice$1=ArrayProto.slice,toString$1=ObjProto.toString,hasOwnProperty$1=ObjProto.hasOwnProperty;// Modern feature detection.
var supportsArrayBuffer=typeof ArrayBuffer!=='undefined',supportsDataView=typeof DataView!=='undefined';// All **ECMAScript 5+** native function implementations that we hope to use
// are declared here.
var nativeIsArray=Array.isArray,nativeKeys=Object.keys,nativeCreate=Object.create,nativeIsView=supportsArrayBuffer&&ArrayBuffer.isView;// Create references to these builtin functions because we override them.
var _isNaN=isNaN,_isFinite=isFinite;// Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
var hasEnumBug=!{toString:null}.propertyIsEnumerable('toString');var nonEnumerableProps=['valueOf','isPrototypeOf','toString','propertyIsEnumerable','hasOwnProperty','toLocaleString'];// The largest integer that can be represented exactly.
var MAX_ARRAY_INDEX=Math.pow(2,53)-1;// Some functions take a variable number of arguments, or a few expected
// arguments at the beginning and then a variable number of values to operate
// on. This helper accumulates all remaining arguments past the function’s
// argument length (or an explicit `startIndex`), into an array that becomes
// the last argument. Similar to ES6’s "rest parameter".
function restArguments(func,startIndex){startIndex=startIndex==null?func.length-1:+startIndex;return function(){var length=Math.max(arguments.length-startIndex,0),rest=Array(length),index=0;for(;index<length;index++){rest[index]=arguments[index+startIndex];}switch(startIndex){case 0:return func.call(this,rest);case 1:return func.call(this,arguments[0],rest);case 2:return func.call(this,arguments[0],arguments[1],rest);}var args=Array(startIndex+1);for(index=0;index<startIndex;index++){args[index]=arguments[index];}args[startIndex]=rest;return func.apply(this,args);};}// Is a given variable an object?
function isObject$4(obj){var type=typeof obj;return type==='function'||type==='object'&&!!obj;}// Is a given value equal to null?
function isNull(obj){return obj===null;}// Is a given variable undefined?
function isUndefined(obj){return obj===void 0;}// Is a given value a boolean?
function isBoolean(obj){return obj===true||obj===false||toString$1.call(obj)==='[object Boolean]';}// Is a given value a DOM element?
function isElement(obj){return !!(obj&&obj.nodeType===1);}// Internal function for creating a `toString`-based type tester.
function tagTester(name){var tag='[object '+name+']';return function(obj){return toString$1.call(obj)===tag;};}var isString=tagTester('String');var isNumber=tagTester('Number');var isDate=tagTester('Date');var isRegExp=tagTester('RegExp');var isError=tagTester('Error');var isSymbol$1=tagTester('Symbol');var isArrayBuffer=tagTester('ArrayBuffer');var isFunction=tagTester('Function');// Optimize `isFunction` if appropriate. Work around some `typeof` bugs in old
// v8, IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
var nodelist=root.document&&root.document.childNodes;if(typeof /./!='function'&&typeof Int8Array!='object'&&typeof nodelist!='function'){isFunction=function(obj){return typeof obj=='function'||false;};}var isFunction$1=isFunction;var hasObjectTag=tagTester('Object');// In IE 10 - Edge 13, `DataView` has string tag `'[object Object]'`.
// In IE 11, the most common among them, this problem also applies to
// `Map`, `WeakMap` and `Set`.
var hasStringTagBug=supportsDataView&&hasObjectTag(new DataView(new ArrayBuffer(8))),isIE11=typeof Map!=='undefined'&&hasObjectTag(new Map());var isDataView=tagTester('DataView');// In IE 10 - Edge 13, we need a different heuristic
// to determine whether an object is a `DataView`.
function ie10IsDataView(obj){return obj!=null&&isFunction$1(obj.getInt8)&&isArrayBuffer(obj.buffer);}var isDataView$1=hasStringTagBug?ie10IsDataView:isDataView;// Is a given value an array?
// Delegates to ECMA5's native `Array.isArray`.
var isArray$1=nativeIsArray||tagTester('Array');// Internal function to check whether `key` is an own property name of `obj`.
function has$1$1(obj,key){return obj!=null&&hasOwnProperty$1.call(obj,key);}var isArguments=tagTester('Arguments');// Define a fallback version of the method in browsers (ahem, IE < 9), where
// there isn't any inspectable "Arguments" type.
(function(){if(!isArguments(arguments)){isArguments=function(obj){return has$1$1(obj,'callee');};}})();var isArguments$1=isArguments;// Is a given object a finite number?
function isFinite$1(obj){return !isSymbol$1(obj)&&_isFinite(obj)&&!isNaN(parseFloat(obj));}// Is the given value `NaN`?
function isNaN$1(obj){return isNumber(obj)&&_isNaN(obj);}// Predicate-generating function. Often useful outside of Underscore.
function constant(value){return function(){return value;};}// Common internal logic for `isArrayLike` and `isBufferLike`.
function createSizePropertyCheck(getSizeProperty){return function(collection){var sizeProperty=getSizeProperty(collection);return typeof sizeProperty=='number'&&sizeProperty>=0&&sizeProperty<=MAX_ARRAY_INDEX;};}// Internal helper to generate a function to obtain property `key` from `obj`.
function shallowProperty(key){return function(obj){return obj==null?void 0:obj[key];};}// Internal helper to obtain the `byteLength` property of an object.
var getByteLength=shallowProperty('byteLength');// Internal helper to determine whether we should spend extensive checks against
// `ArrayBuffer` et al.
var isBufferLike=createSizePropertyCheck(getByteLength);// Is a given value a typed array?
var typedArrayPattern=/\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/;function isTypedArray(obj){// `ArrayBuffer.isView` is the most future-proof, so use it when available.
// Otherwise, fall back on the above regular expression.
return nativeIsView?nativeIsView(obj)&&!isDataView$1(obj):isBufferLike(obj)&&typedArrayPattern.test(toString$1.call(obj));}var isTypedArray$1=supportsArrayBuffer?isTypedArray:constant(false);// Internal helper to obtain the `length` property of an object.
var getLength$1=shallowProperty('length');// Internal helper to create a simple lookup structure.
// `collectNonEnumProps` used to depend on `_.contains`, but this led to
// circular imports. `emulatedSet` is a one-off solution that only works for
// arrays of strings.
function emulatedSet(keys){var hash={};for(var l=keys.length,i=0;i<l;++i)hash[keys[i]]=true;return {contains:function(key){return hash[key]===true;},push:function(key){hash[key]=true;return keys.push(key);}};}// Internal helper. Checks `keys` for the presence of keys in IE < 9 that won't
// be iterated by `for key in ...` and thus missed. Extends `keys` in place if
// needed.
function collectNonEnumProps(obj,keys){keys=emulatedSet(keys);var nonEnumIdx=nonEnumerableProps.length;var constructor=obj.constructor;var proto=isFunction$1(constructor)&&constructor.prototype||ObjProto;// Constructor is a special case.
var prop='constructor';if(has$1$1(obj,prop)&&!keys.contains(prop))keys.push(prop);while(nonEnumIdx--){prop=nonEnumerableProps[nonEnumIdx];if(prop in obj&&obj[prop]!==proto[prop]&&!keys.contains(prop)){keys.push(prop);}}}// Retrieve the names of an object's own properties.
// Delegates to **ECMAScript 5**'s native `Object.keys`.
function keys(obj){if(!isObject$4(obj))return [];if(nativeKeys)return nativeKeys(obj);var keys=[];for(var key in obj)if(has$1$1(obj,key))keys.push(key);// Ahem, IE < 9.
if(hasEnumBug)collectNonEnumProps(obj,keys);return keys;}// Is a given array, string, or object empty?
// An "empty" object has no enumerable own-properties.
function isEmpty$2(obj){if(obj==null)return true;// Skip the more expensive `toString`-based type checks if `obj` has no
// `.length`.
var length=getLength$1(obj);if(typeof length=='number'&&(isArray$1(obj)||isString(obj)||isArguments$1(obj)))return length===0;return getLength$1(keys(obj))===0;}// Returns whether an object has a given set of `key:value` pairs.
function isMatch(object,attrs){var _keys=keys(attrs),length=_keys.length;if(object==null)return !length;var obj=Object(object);for(var i=0;i<length;i++){var key=_keys[i];if(attrs[key]!==obj[key]||!(key in obj))return false;}return true;}// If Underscore is called as a function, it returns a wrapped object that can
// be used OO-style. This wrapper holds altered versions of all functions added
// through `_.mixin`. Wrapped objects may be chained.
function _$1$1(obj){if(obj instanceof _$1$1)return obj;if(!(this instanceof _$1$1))return new _$1$1(obj);this._wrapped=obj;}_$1$1.VERSION=VERSION;// Extracts the result from a wrapped and chained object.
_$1$1.prototype.value=function(){return this._wrapped;};// Provide unwrapping proxies for some methods used in engine operations
// such as arithmetic and JSON stringification.
_$1$1.prototype.valueOf=_$1$1.prototype.toJSON=_$1$1.prototype.value;_$1$1.prototype.toString=function(){return String(this._wrapped);};// Internal function to wrap or shallow-copy an ArrayBuffer,
// typed array or DataView to a new view, reusing the buffer.
function toBufferView(bufferSource){return new Uint8Array(bufferSource.buffer||bufferSource,bufferSource.byteOffset||0,getByteLength(bufferSource));}// We use this string twice, so give it a name for minification.
var tagDataView='[object DataView]';// Internal recursive comparison function for `_.isEqual`.
function eq(a,b,aStack,bStack){// Identical objects are equal. `0 === -0`, but they aren't identical.
// See the [Harmony `egal` proposal](https://wiki.ecmascript.org/doku.php?id=harmony:egal).
if(a===b)return a!==0||1/a===1/b;// `null` or `undefined` only equal to itself (strict comparison).
if(a==null||b==null)return false;// `NaN`s are equivalent, but non-reflexive.
if(a!==a)return b!==b;// Exhaust primitive checks
var type=typeof a;if(type!=='function'&&type!=='object'&&typeof b!='object')return false;return deepEq(a,b,aStack,bStack);}// Internal recursive comparison function for `_.isEqual`.
function deepEq(a,b,aStack,bStack){// Unwrap any wrapped objects.
if(a instanceof _$1$1)a=a._wrapped;if(b instanceof _$1$1)b=b._wrapped;// Compare `[[Class]]` names.
var className=toString$1.call(a);if(className!==toString$1.call(b))return false;// Work around a bug in IE 10 - Edge 13.
if(hasStringTagBug&&className=='[object Object]'&&isDataView$1(a)){if(!isDataView$1(b))return false;className=tagDataView;}switch(className){// These types are compared by value.
case'[object RegExp]':// RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
case'[object String]':// Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
// equivalent to `new String("5")`.
return ''+a===''+b;case'[object Number]':// `NaN`s are equivalent, but non-reflexive.
// Object(NaN) is equivalent to NaN.
if(+a!==+a)return +b!==+b;// An `egal` comparison is performed for other numeric values.
return +a===0?1/+a===1/b:+a===+b;case'[object Date]':case'[object Boolean]':// Coerce dates and booleans to numeric primitive values. Dates are compared by their
// millisecond representations. Note that invalid dates with millisecond representations
// of `NaN` are not equivalent.
return +a===+b;case'[object Symbol]':return SymbolProto.valueOf.call(a)===SymbolProto.valueOf.call(b);case'[object ArrayBuffer]':case tagDataView:// Coerce to typed array so we can fall through.
return deepEq(toBufferView(a),toBufferView(b),aStack,bStack);}var areArrays=className==='[object Array]';if(!areArrays&&isTypedArray$1(a)){var byteLength=getByteLength(a);if(byteLength!==getByteLength(b))return false;if(a.buffer===b.buffer&&a.byteOffset===b.byteOffset)return true;areArrays=true;}if(!areArrays){if(typeof a!='object'||typeof b!='object')return false;// Objects with different constructors are not equivalent, but `Object`s or `Array`s
// from different frames are.
var aCtor=a.constructor,bCtor=b.constructor;if(aCtor!==bCtor&&!(isFunction$1(aCtor)&&aCtor instanceof aCtor&&isFunction$1(bCtor)&&bCtor instanceof bCtor)&&'constructor'in a&&'constructor'in b){return false;}}// Assume equality for cyclic structures. The algorithm for detecting cyclic
// structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
// Initializing stack of traversed objects.
// It's done here since we only need them for objects and arrays comparison.
aStack=aStack||[];bStack=bStack||[];var length=aStack.length;while(length--){// Linear search. Performance is inversely proportional to the number of
// unique nested structures.
if(aStack[length]===a)return bStack[length]===b;}// Add the first object to the stack of traversed objects.
aStack.push(a);bStack.push(b);// Recursively compare objects and arrays.
if(areArrays){// Compare array lengths to determine if a deep comparison is necessary.
length=a.length;if(length!==b.length)return false;// Deep compare the contents, ignoring non-numeric properties.
while(length--){if(!eq(a[length],b[length],aStack,bStack))return false;}}else {// Deep compare objects.
var _keys=keys(a),key;length=_keys.length;// Ensure that both objects contain the same number of properties before comparing deep equality.
if(keys(b).length!==length)return false;while(length--){// Deep compare each member
key=_keys[length];if(!(has$1$1(b,key)&&eq(a[key],b[key],aStack,bStack)))return false;}}// Remove the first object from the stack of traversed objects.
aStack.pop();bStack.pop();return true;}// Perform a deep comparison to check if two objects are equal.
function isEqual$1(a,b){return eq(a,b);}// Retrieve all the enumerable property names of an object.
function allKeys(obj){if(!isObject$4(obj))return [];var keys=[];for(var key in obj)keys.push(key);// Ahem, IE < 9.
if(hasEnumBug)collectNonEnumProps(obj,keys);return keys;}// Since the regular `Object.prototype.toString` type tests don't work for
// some types in IE 11, we use a fingerprinting heuristic instead, based
// on the methods. It's not great, but it's the best we got.
// The fingerprint method lists are defined below.
function ie11fingerprint(methods){var length=getLength$1(methods);return function(obj){if(obj==null)return false;// `Map`, `WeakMap` and `Set` have no enumerable keys.
var keys=allKeys(obj);if(getLength$1(keys))return false;for(var i=0;i<length;i++){if(!isFunction$1(obj[methods[i]]))return false;}// If we are testing against `WeakMap`, we need to ensure that
// `obj` doesn't have a `forEach` method in order to distinguish
// it from a regular `Map`.
return methods!==weakMapMethods||!isFunction$1(obj[forEachName]);};}// In the interest of compact minification, we write
// each string in the fingerprints only once.
var forEachName='forEach',hasName='has',commonInit=['clear','delete'],mapTail=['get',hasName,'set'];// `Map`, `WeakMap` and `Set` each have slightly different
// combinations of the above sublists.
var mapMethods=commonInit.concat(forEachName,mapTail),weakMapMethods=commonInit.concat(mapTail),setMethods=['add'].concat(commonInit,forEachName,hasName);var isMap=isIE11?ie11fingerprint(mapMethods):tagTester('Map');var isWeakMap=isIE11?ie11fingerprint(weakMapMethods):tagTester('WeakMap');var isSet=isIE11?ie11fingerprint(setMethods):tagTester('Set');var isWeakSet=tagTester('WeakSet');// Retrieve the values of an object's properties.
function values$1(obj){var _keys=keys(obj);var length=_keys.length;var values=Array(length);for(var i=0;i<length;i++){values[i]=obj[_keys[i]];}return values;}// Convert an object into a list of `[key, value]` pairs.
// The opposite of `_.object` with one argument.
function pairs(obj){var _keys=keys(obj);var length=_keys.length;var pairs=Array(length);for(var i=0;i<length;i++){pairs[i]=[_keys[i],obj[_keys[i]]];}return pairs;}// Invert the keys and values of an object. The values must be serializable.
function invert(obj){var result={};var _keys=keys(obj);for(var i=0,length=_keys.length;i<length;i++){result[obj[_keys[i]]]=_keys[i];}return result;}// Return a sorted list of the function names available on the object.
function functions(obj){var names=[];for(var key in obj){if(isFunction$1(obj[key]))names.push(key);}return names.sort();}// An internal function for creating assigner functions.
function createAssigner(keysFunc,defaults){return function(obj){var length=arguments.length;if(defaults)obj=Object(obj);if(length<2||obj==null)return obj;for(var index=1;index<length;index++){var source=arguments[index],keys=keysFunc(source),l=keys.length;for(var i=0;i<l;i++){var key=keys[i];if(!defaults||obj[key]===void 0)obj[key]=source[key];}}return obj;};}// Extend a given object with all the properties in passed-in object(s).
var extend=createAssigner(allKeys);// Assigns a given object with all the own properties in the passed-in
// object(s).
// (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
var extendOwn=createAssigner(keys);// Fill in a given object with default properties.
var defaults=createAssigner(allKeys,true);// Create a naked function reference for surrogate-prototype-swapping.
function ctor(){return function(){};}// An internal function for creating a new object that inherits from another.
function baseCreate(prototype){if(!isObject$4(prototype))return {};if(nativeCreate)return nativeCreate(prototype);var Ctor=ctor();Ctor.prototype=prototype;var result=new Ctor();Ctor.prototype=null;return result;}// Creates an object that inherits from the given prototype object.
// If additional properties are provided then they will be added to the
// created object.
function create$3(prototype,props){var result=baseCreate(prototype);if(props)extendOwn(result,props);return result;}// Create a (shallow-cloned) duplicate of an object.
function clone(obj){if(!isObject$4(obj))return obj;return isArray$1(obj)?obj.slice():extend({},obj);}// Invokes `interceptor` with the `obj` and then returns `obj`.
// The primary purpose of this method is to "tap into" a method chain, in
// order to perform operations on intermediate results within the chain.
function tap(obj,interceptor){interceptor(obj);return obj;}// Normalize a (deep) property `path` to array.
// Like `_.iteratee`, this function can be customized.
function toPath$1(path){return isArray$1(path)?path:[path];}_$1$1.toPath=toPath$1;// Internal wrapper for `_.toPath` to enable minification.
// Similar to `cb` for `_.iteratee`.
function toPath(path){return _$1$1.toPath(path);}// Internal function to obtain a nested property in `obj` along `path`.
function deepGet(obj,path){var length=path.length;for(var i=0;i<length;i++){if(obj==null)return void 0;obj=obj[path[i]];}return length?obj:void 0;}// Get the value of the (deep) property on `path` from `object`.
// If any property in `path` does not exist or if the value is
// `undefined`, return `defaultValue` instead.
// The `path` is normalized through `_.toPath`.
function get(object,path,defaultValue){var value=deepGet(object,toPath(path));return isUndefined(value)?defaultValue:value;}// Shortcut function for checking if an object has a given property directly on
// itself (in other words, not on a prototype). Unlike the internal `has`
// function, this public version can also traverse nested properties.
function has$5(obj,path){path=toPath(path);var length=path.length;for(var i=0;i<length;i++){var key=path[i];if(!has$1$1(obj,key))return false;obj=obj[key];}return !!length;}// Keep the identity function around for default iteratees.
function identity$1(value){return value;}// Returns a predicate for checking whether an object has a given set of
// `key:value` pairs.
function matcher(attrs){attrs=extendOwn({},attrs);return function(obj){return isMatch(obj,attrs);};}// Creates a function that, when passed an object, will traverse that object’s
// properties down the given `path`, specified as an array of keys or indices.
function property(path){path=toPath(path);return function(obj){return deepGet(obj,path);};}// Internal function that returns an efficient (for current engines) version
// of the passed-in callback, to be repeatedly applied in other Underscore
// functions.
function optimizeCb(func,context,argCount){if(context===void 0)return func;switch(argCount==null?3:argCount){case 1:return function(value){return func.call(context,value);};// The 2-argument case is omitted because we’re not using it.
case 3:return function(value,index,collection){return func.call(context,value,index,collection);};case 4:return function(accumulator,value,index,collection){return func.call(context,accumulator,value,index,collection);};}return function(){return func.apply(context,arguments);};}// An internal function to generate callbacks that can be applied to each
// element in a collection, returning the desired result — either `_.identity`,
// an arbitrary callback, a property matcher, or a property accessor.
function baseIteratee(value,context,argCount){if(value==null)return identity$1;if(isFunction$1(value))return optimizeCb(value,context,argCount);if(isObject$4(value)&&!isArray$1(value))return matcher(value);return property(value);}// External wrapper for our callback generator. Users may customize
// `_.iteratee` if they want additional predicate/iteratee shorthand styles.
// This abstraction hides the internal-only `argCount` argument.
function iteratee(value,context){return baseIteratee(value,context,Infinity);}_$1$1.iteratee=iteratee;// The function we call internally to generate a callback. It invokes
// `_.iteratee` if overridden, otherwise `baseIteratee`.
function cb(value,context,argCount){if(_$1$1.iteratee!==iteratee)return _$1$1.iteratee(value,context);return baseIteratee(value,context,argCount);}// Returns the results of applying the `iteratee` to each element of `obj`.
// In contrast to `_.map` it returns an object.
function mapObject(obj,iteratee,context){iteratee=cb(iteratee,context);var _keys=keys(obj),length=_keys.length,results={};for(var index=0;index<length;index++){var currentKey=_keys[index];results[currentKey]=iteratee(obj[currentKey],currentKey,obj);}return results;}// Predicate-generating function. Often useful outside of Underscore.
function noop$1(){}// Generates a function for a given object that returns a given property.
function propertyOf(obj){if(obj==null)return noop$1;return function(path){return get(obj,path);};}// Run a function **n** times.
function times(n,iteratee,context){var accum=Array(Math.max(0,n));iteratee=optimizeCb(iteratee,context,1);for(var i=0;i<n;i++)accum[i]=iteratee(i);return accum;}// Return a random integer between `min` and `max` (inclusive).
function random$1(min,max){if(max==null){max=min;min=0;}return min+Math.floor(Math.random()*(max-min+1));}// A (possibly faster) way to get the current timestamp as an integer.
var now=Date.now||function(){return new Date().getTime();};// Internal helper to generate functions for escaping and unescaping strings
// to/from HTML interpolation.
function createEscaper(map){var escaper=function(match){return map[match];};// Regexes for identifying a key that needs to be escaped.
var source='(?:'+keys(map).join('|')+')';var testRegexp=RegExp(source);var replaceRegexp=RegExp(source,'g');return function(string){string=string==null?'':''+string;return testRegexp.test(string)?string.replace(replaceRegexp,escaper):string;};}// Internal list of HTML entities for escaping.
var escapeMap={'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#x27;','`':'&#x60;'};// Function for escaping strings to HTML interpolation.
var escape$1=createEscaper(escapeMap);// Internal list of HTML entities for unescaping.
var unescapeMap=invert(escapeMap);// Function for unescaping strings from HTML interpolation.
var unescape$1=createEscaper(unescapeMap);// By default, Underscore uses ERB-style template delimiters. Change the
// following template settings to use alternative delimiters.
var templateSettings=_$1$1.templateSettings={evaluate:/<%([\s\S]+?)%>/g,interpolate:/<%=([\s\S]+?)%>/g,escape:/<%-([\s\S]+?)%>/g};// When customizing `_.templateSettings`, if you don't want to define an
// interpolation, evaluation or escaping regex, we need one that is
// guaranteed not to match.
var noMatch=/(.)^/;// Certain characters need to be escaped so that they can be put into a
// string literal.
var escapes={"'":"'",'\\':'\\','\r':'r','\n':'n','\u2028':'u2028','\u2029':'u2029'};var escapeRegExp=/\\|'|\r|\n|\u2028|\u2029/g;function escapeChar(match){return '\\'+escapes[match];}// In order to prevent third-party code injection through
// `_.templateSettings.variable`, we test it against the following regular
// expression. It is intentionally a bit more liberal than just matching valid
// identifiers, but still prevents possible loopholes through defaults or
// destructuring assignment.
var bareIdentifier=/^\s*(\w|\$)+\s*$/;// JavaScript micro-templating, similar to John Resig's implementation.
// Underscore templating handles arbitrary delimiters, preserves whitespace,
// and correctly escapes quotes within interpolated code.
// NB: `oldSettings` only exists for backwards compatibility.
function template(text,settings,oldSettings){if(!settings&&oldSettings)settings=oldSettings;settings=defaults({},settings,_$1$1.templateSettings);// Combine delimiters into one regular expression via alternation.
var matcher=RegExp([(settings.escape||noMatch).source,(settings.interpolate||noMatch).source,(settings.evaluate||noMatch).source].join('|')+'|$','g');// Compile the template source, escaping string literals appropriately.
var index=0;var source="__p+='";text.replace(matcher,function(match,escape,interpolate,evaluate,offset){source+=text.slice(index,offset).replace(escapeRegExp,escapeChar);index=offset+match.length;if(escape){source+="'+\n((__t=("+escape+"))==null?'':_.escape(__t))+\n'";}else if(interpolate){source+="'+\n((__t=("+interpolate+"))==null?'':__t)+\n'";}else if(evaluate){source+="';\n"+evaluate+"\n__p+='";}// Adobe VMs need the match returned to produce the correct offset.
return match;});source+="';\n";var argument=settings.variable;if(argument){// Insure against third-party code injection. (CVE-2021-23358)
if(!bareIdentifier.test(argument))throw new Error('variable is not a bare identifier: '+argument);}else {// If a variable is not specified, place data values in local scope.
source='with(obj||{}){\n'+source+'}\n';argument='obj';}source="var __t,__p='',__j=Array.prototype.join,"+"print=function(){__p+=__j.call(arguments,'');};\n"+source+'return __p;\n';var render;try{render=new Function(argument,'_',source);}catch(e){e.source=source;throw e;}var template=function(data){return render.call(this,data,_$1$1);};// Provide the compiled source as a convenience for precompilation.
template.source='function('+argument+'){\n'+source+'}';return template;}// Traverses the children of `obj` along `path`. If a child is a function, it
// is invoked with its parent as context. Returns the value of the final
// child, or `fallback` if any child is undefined.
function result(obj,path,fallback){path=toPath(path);var length=path.length;if(!length){return isFunction$1(fallback)?fallback.call(obj):fallback;}for(var i=0;i<length;i++){var prop=obj==null?void 0:obj[path[i]];if(prop===void 0){prop=fallback;i=length;// Ensure we don't continue iterating.
}obj=isFunction$1(prop)?prop.call(obj):prop;}return obj;}// Generate a unique integer id (unique within the entire client session).
// Useful for temporary DOM ids.
var idCounter=0;function uniqueId$1(prefix){var id=++idCounter+'';return prefix?prefix+id:id;}// Start chaining a wrapped Underscore object.
function chain$1(obj){var instance=_$1$1(obj);instance._chain=true;return instance;}// Internal function to execute `sourceFunc` bound to `context` with optional
// `args`. Determines whether to execute a function as a constructor or as a
// normal function.
function executeBound(sourceFunc,boundFunc,context,callingContext,args){if(!(callingContext instanceof boundFunc))return sourceFunc.apply(context,args);var self=baseCreate(sourceFunc.prototype);var result=sourceFunc.apply(self,args);if(isObject$4(result))return result;return self;}// Partially apply a function by creating a version that has had some of its
// arguments pre-filled, without changing its dynamic `this` context. `_` acts
// as a placeholder by default, allowing any combination of arguments to be
// pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
var partial=restArguments(function(func,boundArgs){var placeholder=partial.placeholder;var bound=function(){var position=0,length=boundArgs.length;var args=Array(length);for(var i=0;i<length;i++){args[i]=boundArgs[i]===placeholder?arguments[position++]:boundArgs[i];}while(position<arguments.length)args.push(arguments[position++]);return executeBound(func,bound,this,this,args);};return bound;});partial.placeholder=_$1$1;// Create a function bound to a given object (assigning `this`, and arguments,
// optionally).
var bind=restArguments(function(func,context,args){if(!isFunction$1(func))throw new TypeError('Bind must be called on a function');var bound=restArguments(function(callArgs){return executeBound(func,bound,context,this,args.concat(callArgs));});return bound;});// Internal helper for collection methods to determine whether a collection
// should be iterated as an array or as an object.
// Related: https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
// Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
var isArrayLike=createSizePropertyCheck(getLength$1);// Internal implementation of a recursive `flatten` function.
function flatten$1(input,depth,strict,output){output=output||[];if(!depth&&depth!==0){depth=Infinity;}else if(depth<=0){return output.concat(input);}var idx=output.length;for(var i=0,length=getLength$1(input);i<length;i++){var value=input[i];if(isArrayLike(value)&&(isArray$1(value)||isArguments$1(value))){// Flatten current level of array or arguments object.
if(depth>1){flatten$1(value,depth-1,strict,output);idx=output.length;}else {var j=0,len=value.length;while(j<len)output[idx++]=value[j++];}}else if(!strict){output[idx++]=value;}}return output;}// Bind a number of an object's methods to that object. Remaining arguments
// are the method names to be bound. Useful for ensuring that all callbacks
// defined on an object belong to it.
var bindAll=restArguments(function(obj,keys){keys=flatten$1(keys,false,false);var index=keys.length;if(index<1)throw new Error('bindAll must be passed function names');while(index--){var key=keys[index];obj[key]=bind(obj[key],obj);}return obj;});// Memoize an expensive function by storing its results.
function memoize$2(func,hasher){var memoize=function(key){var cache=memoize.cache;var address=''+(hasher?hasher.apply(this,arguments):key);if(!has$1$1(cache,address))cache[address]=func.apply(this,arguments);return cache[address];};memoize.cache={};return memoize;}// Delays a function for the given number of milliseconds, and then calls
// it with the arguments supplied.
var delay$1=restArguments(function(func,wait,args){return setTimeout(function(){return func.apply(null,args);},wait);});// Defers a function, scheduling it to run after the current call stack has
// cleared.
var defer=partial(delay$1,_$1$1,1);// Returns a function, that, when invoked, will only be triggered at most once
// during a given window of time. Normally, the throttled function will run
// as much as it can, without ever going more than once per `wait` duration;
// but if you'd like to disable the execution on the leading edge, pass
// `{leading: false}`. To disable execution on the trailing edge, ditto.
function throttle$1(func,wait,options){var timeout,context,args,result;var previous=0;if(!options)options={};var later=function(){previous=options.leading===false?0:now();timeout=null;result=func.apply(context,args);if(!timeout)context=args=null;};var throttled=function(){var _now=now();if(!previous&&options.leading===false)previous=_now;var remaining=wait-(_now-previous);context=this;args=arguments;if(remaining<=0||remaining>wait){if(timeout){clearTimeout(timeout);timeout=null;}previous=_now;result=func.apply(context,args);if(!timeout)context=args=null;}else if(!timeout&&options.trailing!==false){timeout=setTimeout(later,remaining);}return result;};throttled.cancel=function(){clearTimeout(timeout);previous=0;timeout=context=args=null;};return throttled;}// When a sequence of calls of the returned function ends, the argument
// function is triggered. The end of a sequence is defined by the `wait`
// parameter. If `immediate` is passed, the argument function will be
// triggered at the beginning of the sequence instead of at the end.
function debounce$1(func,wait,immediate){var timeout,previous,args,result,context;var later=function(){var passed=now()-previous;if(wait>passed){timeout=setTimeout(later,wait-passed);}else {timeout=null;if(!immediate)result=func.apply(context,args);// This check is needed because `func` can recursively invoke `debounced`.
if(!timeout)args=context=null;}};var debounced=restArguments(function(_args){context=this;args=_args;previous=now();if(!timeout){timeout=setTimeout(later,wait);if(immediate)result=func.apply(context,args);}return result;});debounced.cancel=function(){clearTimeout(timeout);timeout=args=context=null;};return debounced;}// Returns the first function passed as an argument to the second,
// allowing you to adjust arguments, run code before and after, and
// conditionally execute the original function.
function wrap$1(func,wrapper){return partial(wrapper,func);}// Returns a negated version of the passed-in predicate.
function negate(predicate){return function(){return !predicate.apply(this,arguments);};}// Returns a function that is the composition of a list of functions, each
// consuming the return value of the function that follows.
function compose$1(){var args=arguments;var start=args.length-1;return function(){var i=start;var result=args[start].apply(this,arguments);while(i--)result=args[i].call(this,result);return result;};}// Returns a function that will only be executed on and after the Nth call.
function after(times,func){return function(){if(--times<1){return func.apply(this,arguments);}};}// Returns a function that will only be executed up to (but not including) the
// Nth call.
function before(times,func){var memo;return function(){if(--times>0){memo=func.apply(this,arguments);}if(times<=1)func=null;return memo;};}// Returns a function that will be executed at most one time, no matter how
// often you call it. Useful for lazy initialization.
var once=partial(before,2);// Returns the first key on an object that passes a truth test.
function findKey$1(obj,predicate,context){predicate=cb(predicate,context);var _keys=keys(obj),key;for(var i=0,length=_keys.length;i<length;i++){key=_keys[i];if(predicate(obj[key],key,obj))return key;}}// Internal function to generate `_.findIndex` and `_.findLastIndex`.
function createPredicateIndexFinder(dir){return function(array,predicate,context){predicate=cb(predicate,context);var length=getLength$1(array);var index=dir>0?0:length-1;for(;index>=0&&index<length;index+=dir){if(predicate(array[index],index,array))return index;}return -1;};}// Returns the first index on an array-like that passes a truth test.
var findIndex$1=createPredicateIndexFinder(1);// Returns the last index on an array-like that passes a truth test.
var findLastIndex=createPredicateIndexFinder(-1);// Use a comparator function to figure out the smallest index at which
// an object should be inserted so as to maintain order. Uses binary search.
function sortedIndex(array,obj,iteratee,context){iteratee=cb(iteratee,context,1);var value=iteratee(obj);var low=0,high=getLength$1(array);while(low<high){var mid=Math.floor((low+high)/2);if(iteratee(array[mid])<value)low=mid+1;else high=mid;}return low;}// Internal function to generate the `_.indexOf` and `_.lastIndexOf` functions.
function createIndexFinder(dir,predicateFind,sortedIndex){return function(array,item,idx){var i=0,length=getLength$1(array);if(typeof idx=='number'){if(dir>0){i=idx>=0?idx:Math.max(idx+length,i);}else {length=idx>=0?Math.min(idx+1,length):idx+length+1;}}else if(sortedIndex&&idx&&length){idx=sortedIndex(array,item);return array[idx]===item?idx:-1;}if(item!==item){idx=predicateFind(slice$1.call(array,i,length),isNaN$1);return idx>=0?idx+i:-1;}for(idx=dir>0?i:length-1;idx>=0&&idx<length;idx+=dir){if(array[idx]===item)return idx;}return -1;};}// Return the position of the first occurrence of an item in an array,
// or -1 if the item is not included in the array.
// If the array is large and already in sort order, pass `true`
// for **isSorted** to use binary search.
var indexOf=createIndexFinder(1,findIndex$1,sortedIndex);// Return the position of the last occurrence of an item in an array,
// or -1 if the item is not included in the array.
var lastIndexOf=createIndexFinder(-1,findLastIndex);// Return the first value which passes a truth test.
function find(obj,predicate,context){var keyFinder=isArrayLike(obj)?findIndex$1:findKey$1;var key=keyFinder(obj,predicate,context);if(key!==void 0&&key!==-1)return obj[key];}// Convenience version of a common use case of `_.find`: getting the first
// object containing specific `key:value` pairs.
function findWhere(obj,attrs){return find(obj,matcher(attrs));}// The cornerstone for collection functions, an `each`
// implementation, aka `forEach`.
// Handles raw objects in addition to array-likes. Treats all
// sparse array-likes as if they were dense.
function each(obj,iteratee,context){iteratee=optimizeCb(iteratee,context);var i,length;if(isArrayLike(obj)){for(i=0,length=obj.length;i<length;i++){iteratee(obj[i],i,obj);}}else {var _keys=keys(obj);for(i=0,length=_keys.length;i<length;i++){iteratee(obj[_keys[i]],_keys[i],obj);}}return obj;}// Return the results of applying the iteratee to each element.
function map(obj,iteratee,context){iteratee=cb(iteratee,context);var _keys=!isArrayLike(obj)&&keys(obj),length=(_keys||obj).length,results=Array(length);for(var index=0;index<length;index++){var currentKey=_keys?_keys[index]:index;results[index]=iteratee(obj[currentKey],currentKey,obj);}return results;}// Internal helper to create a reducing function, iterating left or right.
function createReduce(dir){// Wrap code that reassigns argument variables in a separate function than
// the one that accesses `arguments.length` to avoid a perf hit. (#1991)
var reducer=function(obj,iteratee,memo,initial){var _keys=!isArrayLike(obj)&&keys(obj),length=(_keys||obj).length,index=dir>0?0:length-1;if(!initial){memo=obj[_keys?_keys[index]:index];index+=dir;}for(;index>=0&&index<length;index+=dir){var currentKey=_keys?_keys[index]:index;memo=iteratee(memo,obj[currentKey],currentKey,obj);}return memo;};return function(obj,iteratee,memo,context){var initial=arguments.length>=3;return reducer(obj,optimizeCb(iteratee,context,4),memo,initial);};}// **Reduce** builds up a single result from a list of values, aka `inject`,
// or `foldl`.
var reduce=createReduce(1);// The right-associative version of reduce, also known as `foldr`.
var reduceRight=createReduce(-1);// Return all the elements that pass a truth test.
function filter(obj,predicate,context){var results=[];predicate=cb(predicate,context);each(obj,function(value,index,list){if(predicate(value,index,list))results.push(value);});return results;}// Return all the elements for which a truth test fails.
function reject(obj,predicate,context){return filter(obj,negate(cb(predicate)),context);}// Determine whether all of the elements pass a truth test.
function every(obj,predicate,context){predicate=cb(predicate,context);var _keys=!isArrayLike(obj)&&keys(obj),length=(_keys||obj).length;for(var index=0;index<length;index++){var currentKey=_keys?_keys[index]:index;if(!predicate(obj[currentKey],currentKey,obj))return false;}return true;}// Determine if at least one element in the object passes a truth test.
function some(obj,predicate,context){predicate=cb(predicate,context);var _keys=!isArrayLike(obj)&&keys(obj),length=(_keys||obj).length;for(var index=0;index<length;index++){var currentKey=_keys?_keys[index]:index;if(predicate(obj[currentKey],currentKey,obj))return true;}return false;}// Determine if the array or object contains a given item (using `===`).
function contains(obj,item,fromIndex,guard){if(!isArrayLike(obj))obj=values$1(obj);if(typeof fromIndex!='number'||guard)fromIndex=0;return indexOf(obj,item,fromIndex)>=0;}// Invoke a method (with arguments) on every item in a collection.
var invoke=restArguments(function(obj,path,args){var contextPath,func;if(isFunction$1(path)){func=path;}else {path=toPath(path);contextPath=path.slice(0,-1);path=path[path.length-1];}return map(obj,function(context){var method=func;if(!method){if(contextPath&&contextPath.length){context=deepGet(context,contextPath);}if(context==null)return void 0;method=context[path];}return method==null?method:method.apply(context,args);});});// Convenience version of a common use case of `_.map`: fetching a property.
function pluck(obj,key){return map(obj,property(key));}// Convenience version of a common use case of `_.filter`: selecting only
// objects containing specific `key:value` pairs.
function where(obj,attrs){return filter(obj,matcher(attrs));}// Return the maximum element (or element-based computation).
function max(obj,iteratee,context){var result=-Infinity,lastComputed=-Infinity,value,computed;if(iteratee==null||typeof iteratee=='number'&&typeof obj[0]!='object'&&obj!=null){obj=isArrayLike(obj)?obj:values$1(obj);for(var i=0,length=obj.length;i<length;i++){value=obj[i];if(value!=null&&value>result){result=value;}}}else {iteratee=cb(iteratee,context);each(obj,function(v,index,list){computed=iteratee(v,index,list);if(computed>lastComputed||computed===-Infinity&&result===-Infinity){result=v;lastComputed=computed;}});}return result;}// Return the minimum element (or element-based computation).
function min(obj,iteratee,context){var result=Infinity,lastComputed=Infinity,value,computed;if(iteratee==null||typeof iteratee=='number'&&typeof obj[0]!='object'&&obj!=null){obj=isArrayLike(obj)?obj:values$1(obj);for(var i=0,length=obj.length;i<length;i++){value=obj[i];if(value!=null&&value<result){result=value;}}}else {iteratee=cb(iteratee,context);each(obj,function(v,index,list){computed=iteratee(v,index,list);if(computed<lastComputed||computed===Infinity&&result===Infinity){result=v;lastComputed=computed;}});}return result;}// Safely create a real, live array from anything iterable.
var reStrSymbol=/[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;function toArray(obj){if(!obj)return [];if(isArray$1(obj))return slice$1.call(obj);if(isString(obj)){// Keep surrogate pair characters together.
return obj.match(reStrSymbol);}if(isArrayLike(obj))return map(obj,identity$1);return values$1(obj);}// Sample **n** random values from a collection using the modern version of the
// [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
// If **n** is not specified, returns a single random element.
// The internal `guard` argument allows it to work with `_.map`.
function sample(obj,n,guard){if(n==null||guard){if(!isArrayLike(obj))obj=values$1(obj);return obj[random$1(obj.length-1)];}var sample=toArray(obj);var length=getLength$1(sample);n=Math.max(Math.min(n,length),0);var last=length-1;for(var index=0;index<n;index++){var rand=random$1(index,last);var temp=sample[index];sample[index]=sample[rand];sample[rand]=temp;}return sample.slice(0,n);}// Shuffle a collection.
function shuffle(obj){return sample(obj,Infinity);}// Sort the object's values by a criterion produced by an iteratee.
function sortBy(obj,iteratee,context){var index=0;iteratee=cb(iteratee,context);return pluck(map(obj,function(value,key,list){return {value:value,index:index++,criteria:iteratee(value,key,list)};}).sort(function(left,right){var a=left.criteria;var b=right.criteria;if(a!==b){if(a>b||a===void 0)return 1;if(a<b||b===void 0)return -1;}return left.index-right.index;}),'value');}// An internal function used for aggregate "group by" operations.
function group(behavior,partition){return function(obj,iteratee,context){var result=partition?[[],[]]:{};iteratee=cb(iteratee,context);each(obj,function(value,index){var key=iteratee(value,index,obj);behavior(result,value,key);});return result;};}// Groups the object's values by a criterion. Pass either a string attribute
// to group by, or a function that returns the criterion.
var groupBy=group(function(result,value,key){if(has$1$1(result,key))result[key].push(value);else result[key]=[value];});// Indexes the object's values by a criterion, similar to `_.groupBy`, but for
// when you know that your index values will be unique.
var indexBy=group(function(result,value,key){result[key]=value;});// Counts instances of an object that group by a certain criterion. Pass
// either a string attribute to count by, or a function that returns the
// criterion.
var countBy=group(function(result,value,key){if(has$1$1(result,key))result[key]++;else result[key]=1;});// Split a collection into two arrays: one whose elements all pass the given
// truth test, and one whose elements all do not pass the truth test.
var partition=group(function(result,value,pass){result[pass?0:1].push(value);},true);// Return the number of elements in a collection.
function size(obj){if(obj==null)return 0;return isArrayLike(obj)?obj.length:keys(obj).length;}// Internal `_.pick` helper function to determine whether `key` is an enumerable
// property name of `obj`.
function keyInObj(value,key,obj){return key in obj;}// Return a copy of the object only containing the allowed properties.
var pick=restArguments(function(obj,keys){var result={},iteratee=keys[0];if(obj==null)return result;if(isFunction$1(iteratee)){if(keys.length>1)iteratee=optimizeCb(iteratee,keys[1]);keys=allKeys(obj);}else {iteratee=keyInObj;keys=flatten$1(keys,false,false);obj=Object(obj);}for(var i=0,length=keys.length;i<length;i++){var key=keys[i];var value=obj[key];if(iteratee(value,key,obj))result[key]=value;}return result;});// Return a copy of the object without the disallowed properties.
var omit=restArguments(function(obj,keys){var iteratee=keys[0],context;if(isFunction$1(iteratee)){iteratee=negate(iteratee);if(keys.length>1)context=keys[1];}else {keys=map(flatten$1(keys,false,false),String);iteratee=function(value,key){return !contains(keys,key);};}return pick(obj,iteratee,context);});// Returns everything but the last entry of the array. Especially useful on
// the arguments object. Passing **n** will return all the values in
// the array, excluding the last N.
function initial(array,n,guard){return slice$1.call(array,0,Math.max(0,array.length-(n==null||guard?1:n)));}// Get the first element of an array. Passing **n** will return the first N
// values in the array. The **guard** check allows it to work with `_.map`.
function first(array,n,guard){if(array==null||array.length<1)return n==null||guard?void 0:[];if(n==null||guard)return array[0];return initial(array,array.length-n);}// Returns everything but the first entry of the `array`. Especially useful on
// the `arguments` object. Passing an **n** will return the rest N values in the
// `array`.
function rest(array,n,guard){return slice$1.call(array,n==null||guard?1:n);}// Get the last element of an array. Passing **n** will return the last N
// values in the array.
function last(array,n,guard){if(array==null||array.length<1)return n==null||guard?void 0:[];if(n==null||guard)return array[array.length-1];return rest(array,Math.max(0,array.length-n));}// Trim out all falsy values from an array.
function compact(array){return filter(array,Boolean);}// Flatten out an array, either recursively (by default), or up to `depth`.
// Passing `true` or `false` as `depth` means `1` or `Infinity`, respectively.
function flatten(array,depth){return flatten$1(array,depth,false);}// Take the difference between one array and a number of other arrays.
// Only the elements present in just the first array will remain.
var difference=restArguments(function(array,rest){rest=flatten$1(rest,true,true);return filter(array,function(value){return !contains(rest,value);});});// Return a version of the array that does not contain the specified value(s).
var without=restArguments(function(array,otherArrays){return difference(array,otherArrays);});// Produce a duplicate-free version of the array. If the array has already
// been sorted, you have the option of using a faster algorithm.
// The faster algorithm will not work with an iteratee if the iteratee
// is not a one-to-one function, so providing an iteratee will disable
// the faster algorithm.
function uniq(array,isSorted,iteratee,context){if(!isBoolean(isSorted)){context=iteratee;iteratee=isSorted;isSorted=false;}if(iteratee!=null)iteratee=cb(iteratee,context);var result=[];var seen=[];for(var i=0,length=getLength$1(array);i<length;i++){var value=array[i],computed=iteratee?iteratee(value,i,array):value;if(isSorted&&!iteratee){if(!i||seen!==computed)result.push(value);seen=computed;}else if(iteratee){if(!contains(seen,computed)){seen.push(computed);result.push(value);}}else if(!contains(result,value)){result.push(value);}}return result;}// Produce an array that contains the union: each distinct element from all of
// the passed-in arrays.
var union=restArguments(function(arrays){return uniq(flatten$1(arrays,true,true));});// Produce an array that contains every item shared between all the
// passed-in arrays.
function intersection(array){var result=[];var argsLength=arguments.length;for(var i=0,length=getLength$1(array);i<length;i++){var item=array[i];if(contains(result,item))continue;var j;for(j=1;j<argsLength;j++){if(!contains(arguments[j],item))break;}if(j===argsLength)result.push(item);}return result;}// Complement of zip. Unzip accepts an array of arrays and groups
// each array's elements on shared indices.
function unzip(array){var length=array&&max(array,getLength$1).length||0;var result=Array(length);for(var index=0;index<length;index++){result[index]=pluck(array,index);}return result;}// Zip together multiple lists into a single array -- elements that share
// an index go together.
var zip=restArguments(unzip);// Converts lists into objects. Pass either a single array of `[key, value]`
// pairs, or two parallel arrays of the same length -- one of keys, and one of
// the corresponding values. Passing by pairs is the reverse of `_.pairs`.
function object(list,values){var result={};for(var i=0,length=getLength$1(list);i<length;i++){if(values){result[list[i]]=values[i];}else {result[list[i][0]]=list[i][1];}}return result;}// Generate an integer Array containing an arithmetic progression. A port of
// the native Python `range()` function. See
// [the Python documentation](https://docs.python.org/library/functions.html#range).
function range(start,stop,step){if(stop==null){stop=start||0;start=0;}if(!step){step=stop<start?-1:1;}var length=Math.max(Math.ceil((stop-start)/step),0);var range=Array(length);for(var idx=0;idx<length;idx++,start+=step){range[idx]=start;}return range;}// Chunk a single array into multiple arrays, each containing `count` or fewer
// items.
function chunk(array,count){if(count==null||count<1)return [];var result=[];var i=0,length=array.length;while(i<length){result.push(slice$1.call(array,i,i+=count));}return result;}// Helper function to continue chaining intermediate results.
function chainResult(instance,obj){return instance._chain?_$1$1(obj).chain():obj;}// Add your own custom functions to the Underscore object.
function mixin(obj){each(functions(obj),function(name){var func=_$1$1[name]=obj[name];_$1$1.prototype[name]=function(){var args=[this._wrapped];push.apply(args,arguments);return chainResult(this,func.apply(_$1$1,args));};});return _$1$1;}// Add all mutator `Array` functions to the wrapper.
each(['pop','push','reverse','shift','sort','splice','unshift'],function(name){var method=ArrayProto[name];_$1$1.prototype[name]=function(){var obj=this._wrapped;if(obj!=null){method.apply(obj,arguments);if((name==='shift'||name==='splice')&&obj.length===0){delete obj[0];}}return chainResult(this,obj);};});// Add all accessor `Array` functions to the wrapper.
each(['concat','join','slice'],function(name){var method=ArrayProto[name];_$1$1.prototype[name]=function(){var obj=this._wrapped;if(obj!=null)obj=method.apply(obj,arguments);return chainResult(this,obj);};});// Named Exports
var allExports=/*#__PURE__*/Object.freeze({__proto__:null,VERSION:VERSION,restArguments:restArguments,isObject:isObject$4,isNull:isNull,isUndefined:isUndefined,isBoolean:isBoolean,isElement:isElement,isString:isString,isNumber:isNumber,isDate:isDate,isRegExp:isRegExp,isError:isError,isSymbol:isSymbol$1,isArrayBuffer:isArrayBuffer,isDataView:isDataView$1,isArray:isArray$1,isFunction:isFunction$1,isArguments:isArguments$1,isFinite:isFinite$1,isNaN:isNaN$1,isTypedArray:isTypedArray$1,isEmpty:isEmpty$2,isMatch:isMatch,isEqual:isEqual$1,isMap:isMap,isWeakMap:isWeakMap,isSet:isSet,isWeakSet:isWeakSet,keys:keys,allKeys:allKeys,values:values$1,pairs:pairs,invert:invert,functions:functions,methods:functions,extend:extend,extendOwn:extendOwn,assign:extendOwn,defaults:defaults,create:create$3,clone:clone,tap:tap,get:get,has:has$5,mapObject:mapObject,identity:identity$1,constant:constant,noop:noop$1,toPath:toPath$1,property:property,propertyOf:propertyOf,matcher:matcher,matches:matcher,times:times,random:random$1,now:now,escape:escape$1,unescape:unescape$1,templateSettings:templateSettings,template:template,result:result,uniqueId:uniqueId$1,chain:chain$1,iteratee:iteratee,partial:partial,bind:bind,bindAll:bindAll,memoize:memoize$2,delay:delay$1,defer:defer,throttle:throttle$1,debounce:debounce$1,wrap:wrap$1,negate:negate,compose:compose$1,after:after,before:before,once:once,findKey:findKey$1,findIndex:findIndex$1,findLastIndex:findLastIndex,sortedIndex:sortedIndex,indexOf:indexOf,lastIndexOf:lastIndexOf,find:find,detect:find,findWhere:findWhere,each:each,forEach:each,map:map,collect:map,reduce:reduce,foldl:reduce,inject:reduce,reduceRight:reduceRight,foldr:reduceRight,filter:filter,select:filter,reject:reject,every:every,all:every,some:some,any:some,contains:contains,includes:contains,include:contains,invoke:invoke,pluck:pluck,where:where,max:max,min:min,shuffle:shuffle,sample:sample,sortBy:sortBy,groupBy:groupBy,indexBy:indexBy,countBy:countBy,partition:partition,toArray:toArray,size:size,pick:pick,omit:omit,first:first,head:first,take:first,initial:initial,last:last,rest:rest,tail:rest,drop:rest,compact:compact,flatten:flatten,without:without,uniq:uniq,unique:uniq,union:union,intersection:intersection,difference:difference,unzip:unzip,transpose:unzip,zip:zip,object:object,range:range,chunk:chunk,mixin:mixin,'default':_$1$1});// Default Export
// Add all of the Underscore functions to the wrapper object.
var _$6=mixin(allExports);// Legacy Node.js API.
_$6._=_$6;({level:PropTypes.number.isRequired,step:PropTypes.number,onChange:PropTypes.func,type:PropTypes.oneOf(["default"]),// Would be better to use Object.keys but it won't work with Storybook currently
size:PropTypes.oneOf(["base","sm"])});function KnobWithLabels({leftLabel,rightLabel,level,step,onChange,type,size,...props}){const eventHandler=value=>{onChange(value/100);};const throttledEventHandler=useMemo(()=>throttle$1(eventHandler,150),[]);return/*#__PURE__*/React__default.createElement("div",{className:"flex flex-col justify-between items-center text-secondary-800 dark:text-secondary-300 h-14 w-14 text-xs"},/*#__PURE__*/React__default.createElement("div",{className:"flex-1"}),/*#__PURE__*/React__default.createElement("div",{className:"h-full flex items-start pt-1"},/*#__PURE__*/React__default.createElement(commonjs.exports.Knob,{skin:s13,min:0,rotateDegrees:230,clampMin:0,clampMax:260,style:{width:"35px",height:"35px",display:"inline-block"},max:100,unlockDistance:0,value:level*100,step:step,onChange:throttledEventHandler})),/*#__PURE__*/React__default.createElement("div",{className:"flex-1 mt-1 w-full flex justify-between"},/*#__PURE__*/React__default.createElement("span",null,leftLabel),/*#__PURE__*/React__default.createElement("span",null,rightLabel)));}KnobWithLabels.propTypes={leftLabel:PropTypes.string.isRequired,rightLabel:PropTypes.string.isRequired,level:PropTypes.number.isRequired,step:PropTypes.number,onChange:PropTypes.func,type:PropTypes.oneOf(["default"]),// Would be better to use Object.keys but it won't work with Storybook currently
size:PropTypes.oneOf(["base"])};KnobWithLabels.defaultProps={step:undefined,onChange:undefined,type:"default",size:"base"};var SongState=["NOT_IN_SETLIST","IN_SETLIST"];function SongItem({song,onAction,showNumbers,...props}){const button=song.state==="NOT_IN_SETLIST"?/*#__PURE__*/React__default.createElement(Button,{onClick:e=>{song.onAction(song.id);e.stopPropagation();},size:"sm"},song.actionLabel):/*#__PURE__*/React__default.createElement("span",{className:"text-xs dark:text-white"},song.actionLabel);const handleRemoveSong=e=>{e.stopPropagation();song.onRemoveAction(song.id);};return/*#__PURE__*/React__default.createElement("li",{onClick:()=>song.onSelected(song.songId)},/*#__PURE__*/React__default.createElement("div",{className:"block px-4 py-4 bg-secondary-50 dark:bg-secondary-900 hover:bg-secondary-100 dark:hover:bg-secondary-800 cursor-pointer"},/*#__PURE__*/React__default.createElement("span",{className:"flex items-center space-x-4"},showNumbers&&/*#__PURE__*/React__default.createElement("span",{className:"text-sm dark:text-secondary-300 "},song.trackIndex),/*#__PURE__*/React__default.createElement("span",{className:"flex-1 flex space-x-2 truncate text-sm items-center"},/*#__PURE__*/React__default.createElement("span",{className:"flex-1 flex flex-col space-y-1 dark:text-secondary-300 truncate"},/*#__PURE__*/React__default.createElement("span",{className:"font-semibold truncate"},song.title),/*#__PURE__*/React__default.createElement("span",{className:"truncate"},song.artist),/*#__PURE__*/React__default.createElement("span",{className:"flex space-x-2 text-xs text-secondary-50 items-center"},song.genre&&/*#__PURE__*/React__default.createElement(React__default.Fragment,null,/*#__PURE__*/React__default.createElement("span",{className:"text-secondary-900 dark:text-secondary-300"},"Genre:"),/*#__PURE__*/React__default.createElement("span",{className:"bg-primaryAlt rounded px-1 py-0.5"},song.genre)),song.decade&&/*#__PURE__*/React__default.createElement(React__default.Fragment,null,/*#__PURE__*/React__default.createElement("span",{className:"text-secondary-900 dark:text-secondary-300"},"Year: "),/*#__PURE__*/React__default.createElement("span",{className:"bg-primaryAlt rounded px-1 py-0.5"},song.decade)),song.key&&/*#__PURE__*/React__default.createElement(React__default.Fragment,null,/*#__PURE__*/React__default.createElement("span",{className:"text-secondary-900 dark:text-secondary-300"},"Key:"),/*#__PURE__*/React__default.createElement("span",{className:"bg-primaryAlt rounded px-1 py-0.5"},song.key)),song.level&&/*#__PURE__*/React__default.createElement(React__default.Fragment,null,/*#__PURE__*/React__default.createElement("span",null,"Level:"),/*#__PURE__*/React__default.createElement("span",{className:"bg-primaryAlt rounded px-1 py-0.5"},song.level))))),song.showActionButton&&button,song.showRemoveActionButton&&/*#__PURE__*/React__default.createElement(Button,{size:"sm",onClick:handleRemoveSong},song.removeLabel))));}SongItem.propTypes={showNumbers:PropTypes.bool,song:PropTypes.shape({id:PropTypes.string.isRequired,title:PropTypes.string.isRequired,artist:PropTypes.string.isRequired,genre:PropTypes.string.isRequired,decade:PropTypes.string.isRequired,key:PropTypes.string.isRequired,time:PropTypes.string.isRequired,state:PropTypes.oneOf(SongState).isRequired,onAction:PropTypes.func,onRemoveAction:PropTypes.func,onSelected:PropTypes.func,showActionButton:PropTypes.bool,showRemoveActionButton:PropTypes.bool,showTrackNumber:PropTypes.bool,removeLabel:PropTypes.string,trackIndex:PropTypes.number}).isRequired};SongItem.defaultProps={onSortClicked:undefined,showNumbers:true};const formFilters$1=(genres,keySignatures,decades)=>{return [{id:"genres",name:"Genres",options:genres?genres.map(v=>({value:v,label:v,checked:false})):[]},{id:"keySignatures",name:"Key Signatures",options:keySignatures?keySignatures.map(v=>({value:v,label:v,checked:false})):[]},{id:"decades",name:"Decades",options:decades?decades.map(v=>({value:v,label:v,checked:false})):[]}];};function NoResults(){return/*#__PURE__*/React__default.createElement("div",{className:"dark:text-secondary-300 py-2 flex flex-col items-center space-x-3 space-y-3"},/*#__PURE__*/React__default.createElement(MagnifyingGlassIcon$1,{className:"w10 h-10"}),/*#__PURE__*/React__default.createElement("h2",null,"No results..."));}function SongList({items,searchValue,sortedBy,onSortClicked,onSearchChanged,onFilterChanged,showNumbers,genres,keySignatures,decades,type,size,hideFilters,hideSearch,padBottom,...props}){const[mobileFiltersOpen,setMobileFiltersOpen]=useState(false);const[filters,setFilters]=useState(formFilters$1(genres,keySignatures,decades));const[activeFilters,setActiveFilters]=useState({genres:[],keySignatures:[],decades:[]});const searchInput=useRef(null);const mobileSearchInput=useRef(null);const handleSubmit=e=>{e.preventDefault();e.stopPropagation();};const setFilter=(type,value,checked)=>{// console.log(type, value, checked);
if(checked){setActiveFilters({...activeFilters,[type]:[...activeFilters[type],value]});}else {setActiveFilters({...activeFilters,[type]:activeFilters[type].filter(f=>f!==value)});}};useEffect(()=>{if(!hideFilters)onFilterChanged(activeFilters);},[onFilterChanged,activeFilters]);useEffect(()=>{if(!hideFilters)setFilters(formFilters$1(genres,keySignatures,decades));},[genres,keySignatures,decades]);const songItems=items.map((song,idx)=>{return/*#__PURE__*/React__default.createElement(SongItem,{showNumbers:showNumbers,trackIndex:idx+1,key:song.id,song:song,type:type,size:size});});return/*#__PURE__*/React__default.createElement("div",{className:"dark:bg-secondary-900"},!hideFilters&&/*#__PURE__*/React__default.createElement(qe$4.Root,{show:mobileFiltersOpen,as:Fragment},/*#__PURE__*/React__default.createElement(_t,{as:"div",className:"fixed inset-0 flex z-40 lg:hidden",onClose:setMobileFiltersOpen},/*#__PURE__*/React__default.createElement(qe$4.Child,{as:Fragment,enter:"transition-opacity ease-linear duration-300",enterFrom:"opacity-0",enterTo:"opacity-100",leave:"transition-opacity ease-linear duration-300",leaveFrom:"opacity-100",leaveTo:"opacity-0"},/*#__PURE__*/React__default.createElement(_t.Overlay,{className:"fixed inset-0 bg-black bg-opacity-25"})),/*#__PURE__*/React__default.createElement(qe$4.Child,{as:Fragment,enter:"transition ease-in-out duration-300 transform",enterFrom:"translate-x-full",enterTo:"translate-x-0",leave:"transition ease-in-out duration-300 transform",leaveFrom:"translate-x-0",leaveTo:"translate-x-full"},/*#__PURE__*/React__default.createElement("div",{className:"ml-auto relative max-w-xs w-full h-full bg-white shadow-xl py-4 pb-12 flex flex-col overflow-y-auto overflow-x-hidden"},/*#__PURE__*/React__default.createElement("div",{className:"px-4 flex items-center justify-between"},/*#__PURE__*/React__default.createElement("h2",{className:"text-lg font-medium text-gray-900"},"Filters"),/*#__PURE__*/React__default.createElement("button",{type:"button",className:"-mr-2 w-10 h-10 bg-white p-2 rounded-md flex items-center justify-center text-gray-400",onClick:()=>setMobileFiltersOpen(false)},/*#__PURE__*/React__default.createElement("span",{className:"sr-only"},"Close menu"),/*#__PURE__*/React__default.createElement(XMarkIcon$1,{className:"h-6 w-6","aria-hidden":"true"}))),/*#__PURE__*/React__default.createElement("form",{className:"mt-4 border-t border-gray-200",onSubmit:handleSubmit},filters.map(section=>/*#__PURE__*/React__default.createElement(Ae$1$1,{as:"div",key:section.id,className:"border-t border-gray-200 px-4 py-6"},({open})=>/*#__PURE__*/React__default.createElement(React__default.Fragment,null,/*#__PURE__*/React__default.createElement("h3",{className:"-mx-2 -my-3 flow-root"},/*#__PURE__*/React__default.createElement(Ae$1$1.Button,{className:"px-2 py-3 bg-white w-full flex items-center justify-between text-gray-400 hover:text-primary"},/*#__PURE__*/React__default.createElement("span",{className:"font-medium text-gray-900"},section.name))),/*#__PURE__*/React__default.createElement(Ae$1$1.Panel,{static:true,className:"pt-6"},/*#__PURE__*/React__default.createElement("div",{className:"space-y-6"},section.options.sort((a,b)=>{return a.label>b.label?1:a.label===b.label?0:-1;}).filter(option=>option.label).map((option,optionIdx)=>/*#__PURE__*/React__default.createElement("div",{key:option.value,className:"flex items-center"},/*#__PURE__*/React__default.createElement("input",{id:`filter-mobile-${section.id}-${optionIdx}`,name:`${section.id}[]`,defaultValue:option.value,type:"checkbox",checked:activeFilters[section.id].includes(option.value),onChange:e=>setFilter(section.id,e.target.value,e.target.checked),className:"h-4 w-4 border-gray-300 rounded text-indigo-600 focus:ring-indigo-500"}),/*#__PURE__*/React__default.createElement("label",{htmlFor:`filter-mobile-${section.id}-${optionIdx}`,className:"ml-3 min-w-0 flex-1 text-gray-500"},option.label))))))))))))),/*#__PURE__*/React__default.createElement("section",{className:"mx-auto"},!hideSearch&&/*#__PURE__*/React__default.createElement("div",{className:"relative z-10 flex items-baseline justify-between"},/*#__PURE__*/React__default.createElement("div",{className:"flex-1 flex items-center justify-start lg:hidden px-2 pt-4 pb-4"},/*#__PURE__*/React__default.createElement("div",{className:"flex flex-1 items-center"},/*#__PURE__*/React__default.createElement(MagnifyingGlassIcon$1,{className:"h-5 w-auto mr-2 dark:text-white"}),/*#__PURE__*/React__default.createElement(Input,{ref:mobileSearchInput,label:"search",inputType:"search",placeholder:"Search songs...",autocomplete:"off",value:searchValue,onChange:onSearchChanged})),/*#__PURE__*/React__default.createElement("button",{type:"button",className:"ml-4 text-gray-400 hover:text-gray-500 lg:hidden",onClick:()=>setMobileFiltersOpen(true)},/*#__PURE__*/React__default.createElement("span",{className:"sr-only"},"Filters"),/*#__PURE__*/React__default.createElement(FunnelIcon$1,{className:"w-5 h-5","aria-hidden":"true"})))),/*#__PURE__*/React__default.createElement("section",{"aria-labelledby":"songs-heading",className:"pb-4"},/*#__PURE__*/React__default.createElement("h2",{id:"songs-heading",className:"sr-only"},"Songs"),/*#__PURE__*/React__default.createElement("div",{className:"grid grid-cols-1 lg:grid-cols-4 gap-x-4 gap-y-10"},/*#__PURE__*/React__default.createElement("div",{className:hideFilters?'lg:col-span-4':'lg:col-span-3'},/*#__PURE__*/React__default.createElement("ul",{className:`divide-y divide-secondary-200 dark:divide-secondary-700 overflow-y-auto overflow-x-hidden ${padBottom?'pb-40':''}`},songItems,songItems&&songItems.length===0&&/*#__PURE__*/React__default.createElement(NoResults,null))),!hideFilters&&/*#__PURE__*/React__default.createElement("form",{className:"hidden lg:block mx-4",onSubmit:handleSubmit},/*#__PURE__*/React__default.createElement("div",{className:"flex-1 flex items-center justify-start lg:flex hidden  pt-4 pb-4"},/*#__PURE__*/React__default.createElement(MagnifyingGlassIcon$1,{className:"h-5 w-5 mr-2 dark:text-white"}),/*#__PURE__*/React__default.createElement(Input,{ref:searchInput,label:"search",inputType:"search",placeholder:"Start typing to search...",autocomplete:"off",value:searchValue,onChange:onSearchChanged})),filters.map(section=>/*#__PURE__*/React__default.createElement(Ae$1$1,{as:"div",key:section.id,className:"ml-6 dark:bg-secondary-800 mb-2 rounded-md px-2 py-4"},({open})=>/*#__PURE__*/React__default.createElement(React__default.Fragment,null,/*#__PURE__*/React__default.createElement("h3",{className:"-my-3 flow-root"},/*#__PURE__*/React__default.createElement(Ae$1$1.Button,{className:"py-3 w-full flex items-center justify-between text-sm dark:text-white text-gray-400 dark:hover:text-primary"},/*#__PURE__*/React__default.createElement("span",{className:"font-medium text-gray-900 dark:text-white text-left"},section.name),/*#__PURE__*/React__default.createElement("span",{className:"ml-6 flex items-center"},open?/*#__PURE__*/React__default.createElement(MinusSmallIcon$1,{className:"h-5 w-5","aria-hidden":"true"}):/*#__PURE__*/React__default.createElement(PlusSmallIcon$1,{className:"h-5 w-5","aria-hidden":"true"})))),/*#__PURE__*/React__default.createElement(Ae$1$1.Panel,{className:"pt-6"},/*#__PURE__*/React__default.createElement("div",{className:"space-y-4"},section.options.sort((a,b)=>{return a.label>b.label?1:a.label===b.label?0:-1;}).filter(option=>option.label).map((option,optionIdx)=>/*#__PURE__*/React__default.createElement("div",{key:option.value,className:"flex items-center"},/*#__PURE__*/React__default.createElement("input",{id:`filter-${section.id}-${optionIdx}`,name:`${section.id}[]`,defaultValue:option.value,type:"checkbox",checked:activeFilters[section.id].includes(option.value),onChange:e=>setFilter(section.id,e.target.value,e.target.checked),className:"h-4 w-4 border-gray-300 rounded text-indigo-600 focus:ring-indigo-500"}),/*#__PURE__*/React__default.createElement("label",{htmlFor:`filter-${section.id}-${optionIdx}`,className:"ml-3 text-sm text-gray-600 dark:text-white"},option.label)))))))))))));}SongList.propTypes={items:PropTypes.arrayOf(SongItem.propTypes.song).isRequired,genres:PropTypes.arrayOf(PropTypes.string),keySignatures:PropTypes.arrayOf(PropTypes.string),decades:PropTypes.arrayOf(PropTypes.string),sortedBy:PropTypes.shape({label:PropTypes.string.isRequired,dir:PropTypes.oneOf(["asc","desc"]).isRequired}),onSortClicked:PropTypes.func,onSearchChanged:PropTypes.func,onFilterhanged:PropTypes.func,search:PropTypes.string,type:PropTypes.oneOf(["default"]),// Would be better to use Object.keys but it won't work with Storybook currently
size:PropTypes.oneOf(["base"]),hideFilters:PropTypes.bool,hideSearch:PropTypes.bool,showNumbers:PropTypes.bool,padBottom:PropTypes.bool};SongList.defaultProps={search:"",onSearchChanged:undefined,sortedBy:undefined,onSortClicked:undefined,onFilterChanged:undefined,type:"default",size:"base",hideFilters:false,hideSearch:false,showNumbers:false,padBottom:true};function PromotionalItems({promotionalItems,promotionalTitle,promotionalText,promotionalLinkText,promotionalLinkUrl,promotionalLinkButtonText,promotionalImageUrl,...props}){return/*#__PURE__*/React__default.createElement(React__default.Fragment,null,/*#__PURE__*/React__default.createElement("div",{className:"p-4"},/*#__PURE__*/React__default.createElement("h2",{className:"text-3xl pb-4 font-bold\t dark:text-white"},promotionalTitle),/*#__PURE__*/React__default.createElement("p",{className:"mb-4 dark:text-white"},promotionalText)),/*#__PURE__*/React__default.createElement(SongList,{items:promotionalItems,hideFilters:true,hideSearch:true,padBottom:false,showNumbers:false}),/*#__PURE__*/React__default.createElement("div",{className:"p-4"},/*#__PURE__*/React__default.createElement("div",{style:{backgroundImage:`url('${promotionalImageUrl}')`},className:"bg-white bg-right dark:bg-secondary-800 rounded-md"},/*#__PURE__*/React__default.createElement("div",{className:"max-w-7xl mx-auto text-center py-12 px-4 sm:px-6 lg:py-16 lg:px-8"},/*#__PURE__*/React__default.createElement("h2",{className:"text-3xl font-extrabold tracking-tight text-white sm:text-4xl"},/*#__PURE__*/React__default.createElement("span",{className:"block"},promotionalLinkText)),/*#__PURE__*/React__default.createElement("div",{className:"mt-8 flex justify-center"},/*#__PURE__*/React__default.createElement("div",{className:"inline-flex rounded-md shadow"},/*#__PURE__*/React__default.createElement("a",{href:promotionalLinkUrl,rel:"noreferrer",target:"_blank",className:"inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary"},promotionalLinkButtonText))))),/*#__PURE__*/React__default.createElement("h3",{className:"mt-4 text-2xl font-bold\t dark:text-white"},"Music library preview")));}PromotionalItems.propTypes={promotionalItems:SongList.propTypes.items,promotionalTitle:PropTypes.string,promotionalText:PropTypes.string,promotionalLinkUrl:PropTypes.string,promotionalLinkButtonText:PropTypes.string,promotionalLinkText:PropTypes.string,promotionalImageUrl:PropTypes.string};PromotionalItems.defaultProps={};function Library({promotionalLinkText,promotionalLinkButtonText,promotionalImageUrl,promotionalLinkUrl,promotionalItems,promotionalTitle,promotionalText,promotionalLink,items,sortedBy,searchValue,onSearchChanged,onFilterChanged,genres,decades,keySignatures,type,size,padBottom,...props}){// console.log(promotionalItems);
return/*#__PURE__*/React__default.createElement(React__default.Fragment,null,promotionalItems.length>0&&/*#__PURE__*/React__default.createElement(PromotionalItems,{promotionalItems:promotionalItems,promotionalTitle:promotionalTitle,promotionalText:promotionalText,promotionalLink:promotionalLink,promotionalLinkText:promotionalLinkText,promotionalLinkButtonText:promotionalLinkButtonText,promotionalLinkUrl:promotionalLinkUrl,promotionalImageUrl:promotionalImageUrl}),/*#__PURE__*/React__default.createElement(SongList,{onFilterChanged:onFilterChanged,genres:genres,decades:decades,keySignatures:keySignatures,items:items,searchValue:searchValue,onSearchChanged:onSearchChanged,sortedBy:sortedBy,padBottom:padBottom,showNumbers:true}));}Library.propTypes={promotionalItems:SongList.propTypes.items,promotionalTitle:PropTypes.string,promotionalText:PropTypes.string,items:SongList.propTypes.items,sortedBy:SongList.propTypes.sortedBy,searchValue:SongList.propTypes.searchValue,onSearchChanged:SongList.propTypes.onSearchChanged,onFilterChanged:PropTypes.func,genres:PropTypes.arrayOf(PropTypes.string),decades:PropTypes.arrayOf(PropTypes.string),keySignatures:PropTypes.arrayOf(PropTypes.string),type:PropTypes.oneOf(["default"]),// Would be better to use Object.keys but it won't work with Storybook currently
size:PropTypes.oneOf(["base"]),padBottom:PropTypes.bool};Library.defaultProps={type:"default",size:"base",padBottom:true,promotionalItems:[],promotionalLink:"https://www.choirplayer.com",promotionalLinkUrl:"https://www.choirplayer.com",promotionalLinkButtonText:"Subscribe now",promotionalImageUrl:"/images/chgoir-player/login-splash.jpeg"};const Spinner=({size})=>{return/*#__PURE__*/React__default.createElement("svg",{role:"status",class:`w-${size} h-${size} text-primary animate-spin dark:text-secondary-600 fill-white`,viewBox:"0 0 100 101",fill:"none",xmlns:"http://www.w3.org/2000/svg"},/*#__PURE__*/React__default.createElement("path",{d:"M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",fill:"currentColor"}),/*#__PURE__*/React__default.createElement("path",{d:"M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",fill:"currentFill"}));};Spinner.propTypes={size:PropTypes.number};Spinner.defaultProps={size:5};function Login({user,password,onUserChange,onPasswordChange,onLogin,logoImageUrl,splashImageUrl,type,size,loggingIn,errorMessage,...props}){const handleSubmit=e=>{e.preventDefault();onLogin();};const handleUserChange=e=>{onUserChange(e.target.value);};const handlePasswordChange=e=>{onPasswordChange(e.target.value);};return/*#__PURE__*/React__default.createElement(React__default.Fragment,null,/*#__PURE__*/React__default.createElement("div",{className:"min-h-full flex bg-secondary-50 dark:bg-secondary-900"},/*#__PURE__*/React__default.createElement("div",{className:"flex-1 flex flex-col justify-center py-12 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24"},/*#__PURE__*/React__default.createElement("div",{className:"mx-auto w-full max-w-sm lg:w-96"},/*#__PURE__*/React__default.createElement("div",null,logoImageUrl&&/*#__PURE__*/React__default.createElement("img",{className:"h-12 w-auto",src:logoImageUrl,alt:"Logo"}),/*#__PURE__*/React__default.createElement("h2",{className:"mt-6 text-3xl font-extrabold text-secondary-900 dark:text-secondary-100"},"Sign in to your account")),/*#__PURE__*/React__default.createElement("div",{className:"mt-8"},/*#__PURE__*/React__default.createElement("div",{className:"mt-6"},/*#__PURE__*/React__default.createElement("form",{onSubmit:handleSubmit,className:"space-y-6"},/*#__PURE__*/React__default.createElement("div",null,/*#__PURE__*/React__default.createElement("label",{htmlFor:"email",className:"block text-sm font-medium text-secondary-700 dark:text-secondary-300"},"Email address"),/*#__PURE__*/React__default.createElement("div",{className:"mt-1"},/*#__PURE__*/React__default.createElement("input",{id:"email",name:"email",type:"text"// autoComplete="email"
,required:true,className:"appearance-none block w-full px-3 py-2 border border-secondary-300 rounded-md shadow-sm placeholder-secondary-400 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm",onChange:handleUserChange,value:user}))),/*#__PURE__*/React__default.createElement("div",{className:"space-y-1"},/*#__PURE__*/React__default.createElement("label",{htmlFor:"password",className:"block text-sm font-medium text-secondary-700 dark:text-secondary-300"},"Password"),/*#__PURE__*/React__default.createElement("div",{className:"mt-1"},/*#__PURE__*/React__default.createElement("input",{id:"password",name:"password",type:"password"// autoComplete="current-password"
,required:true,className:"appearance-none block w-full px-3 py-2 border border-secondary-300 rounded-md shadow-sm placeholder-secondary-400 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm",onChange:handlePasswordChange,value:password}))),/*#__PURE__*/React__default.createElement("div",null,/*#__PURE__*/React__default.createElement("button",{type:"submit",className:"w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary hover:bg-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"},loggingIn?/*#__PURE__*/React__default.createElement(Spinner,{size:5}):'Sign in')),errorMessage&&/*#__PURE__*/React__default.createElement("div",{className:"text-sm text-red-600"},/*#__PURE__*/React__default.createElement("span",null,errorMessage))))))),/*#__PURE__*/React__default.createElement("div",{className:"hidden lg:block relative w-0 flex-1"},/*#__PURE__*/React__default.createElement("img",{className:"absolute inset-0 h-full w-full object-cover object-right",src:splashImageUrl,alt:"Login splash"}))));}Login.propTypes={user:PropTypes.string.isRequired,password:PropTypes.string.isRequired,onUserChange:PropTypes.func,onPasswordChange:PropTypes.func,onLogin:PropTypes.func,logoImageUrl:PropTypes.string,splashImageUrl:PropTypes.string,type:PropTypes.oneOf(["default"]),// Would be better to use Object.keys but it won't work with Storybook currently
size:PropTypes.oneOf(["base"]),loggingIn:PropTypes.bool};Login.defaultProps={onUserChange:undefined,onPasswordChange:undefined,onLogin:undefined,splashImageUrl:"https://images.unsplash.com/photo-1505904267569-f02eaeb45a4c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1908&q=80",type:"default",size:"base",loggingIn:false};function MenuItem({active,onClick,type,size,...props}){return/*#__PURE__*/React__default.createElement("div",{className:classNames$2(active?'bg-primary text-secondary-50 dark:bg-primary dark:text-secondary-900':'text-secondary-600 hover:bg-primary dark:text-secondary-300 hover:bg-opacity-75','group flex items-center px-4 py-2 text-sm font-medium rounded-md'),onClick:onClick},props.children);}MenuItem.propTypes={active:PropTypes.bool,onClick:PropTypes.func,type:PropTypes.oneOf(["default"]),// Would be better to use Object.keys but it won't work with Storybook currently
size:PropTypes.oneOf(["base"])};MenuItem.defaultProps={active:false,onClick:undefined,type:"default",size:"base"};function Navigation$1({items,onMenuClick,type,size,...props}){const menuItems=items.map(item=>{return item.element?item.element:/*#__PURE__*/React__default.createElement(MenuItem,{key:item.label,active:item.active,onClick:()=>{onMenuClick(item.href);}},item.label);});return/*#__PURE__*/React__default.createElement("nav",{className:"mt-5 flex-1 px-2 space-y-1"},menuItems);}Navigation$1.propTypes={items:PropTypes.arrayOf(PropTypes.shape({label:PropTypes.string.isRequired,href:PropTypes.string.isRequired,active:PropTypes.bool.isRequired,element:PropTypes.element})).isRequired,onMenuClick:PropTypes.func,type:PropTypes.oneOf(["default"]),// Would be better to use Object.keys but it won't work with Storybook currently
size:PropTypes.oneOf(["base"])};Navigation$1.defaultProps={onMenuClick:undefined,type:"default",size:"base"};function Authentication({user,userAvatarUrl,onLoginLogout,loginLogoutLabel,type,size,...props}){const loggedInSection=!!user?/*#__PURE__*/React__default.createElement("div",{class:"flex items-center bg-secondary-900"},/*#__PURE__*/React__default.createElement("div",null,userAvatarUrl?/*#__PURE__*/React__default.createElement("img",{class:"inline-block h-9 w-9 rounded-full",src:userAvatarUrl,alt:""}):/*#__PURE__*/React__default.createElement(UserCircleIcon$1,{solid:true,className:"h-9 w-9 text-white"})),/*#__PURE__*/React__default.createElement("div",{class:"truncate ml-3"},/*#__PURE__*/React__default.createElement("p",{class:"truncate text-sm font-medium text-white group-hover:text-gray-200"},user.displayName||'Guest'))):undefined;return/*#__PURE__*/React__default.createElement("div",{className:"flex-shrink-0 flex flex-col dark:border-secondary-600 space-y-3 p-4"},loggedInSection,/*#__PURE__*/React__default.createElement(Button,{type:"secondary",onClick:onLoginLogout},loginLogoutLabel));}Authentication.propTypes={user:PropTypes.object,userAvatarUrl:PropTypes.string,onLoginLogout:PropTypes.func,type:PropTypes.oneOf(["default"]),// Would be better to use Object.keys but it won't work with Storybook currently
size:PropTypes.oneOf(["base"])};Authentication.defaultProps={user:null,onLoginLogout:undefined,type:"default",size:"base"};function Sidebar({items,user,onNavigation,onLoginLogout,sidebarOpen,onSidebarClose,loginLogoutLabel,type,size,logoUrl,logoLink,backgroundUrl,...props}){const handleNavigation=href=>{};return/*#__PURE__*/React__default.createElement(React__default.Fragment,null,/*#__PURE__*/React__default.createElement("div",null,/*#__PURE__*/React__default.createElement(qe$4.Root,{show:sidebarOpen,as:Fragment},/*#__PURE__*/React__default.createElement(_t,{as:"div",className:"fixed inset-0 flex z-40 lg:hidden",onClose:onSidebarClose},/*#__PURE__*/React__default.createElement(qe$4.Child,{as:Fragment,enter:"transition-opacity ease-linear duration-300",enterFrom:"opacity-0",enterTo:"opacity-100",leave:"transition-opacity ease-linear duration-300",leaveFrom:"opacity-100",leaveTo:"opacity-0"},/*#__PURE__*/React__default.createElement(_t.Overlay,{className:"fixed inset-0 bg-gray-600 bg-opacity-75"})),/*#__PURE__*/React__default.createElement(qe$4.Child,{as:Fragment,enter:"transition ease-in-out duration-300 transform",enterFrom:"-translate-x-full",enterTo:"translate-x-0",leave:"transition ease-in-out duration-300 transform",leaveFrom:"translate-x-0",leaveTo:"-translate-x-full"},/*#__PURE__*/React__default.createElement("div",{className:"relative flex-1 flex flex-col max-w-[250px] w-full bg-secondary-900"},/*#__PURE__*/React__default.createElement(qe$4.Child,{as:Fragment,enter:"ease-in-out duration-300",enterFrom:"opacity-0",enterTo:"opacity-100",leave:"ease-in-out duration-300",leaveFrom:"opacity-100",leaveTo:"opacity-0"},/*#__PURE__*/React__default.createElement("div",{className:"absolute top-0 right-0 -mr-12 pt-2"},/*#__PURE__*/React__default.createElement("button",{type:"button",className:"ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white",onClick:onSidebarClose},/*#__PURE__*/React__default.createElement("span",{className:"sr-only"},"Close sidebar"),/*#__PURE__*/React__default.createElement(XMarkIcon$1,{className:"h-6 w-6 text-white","aria-hidden":"true"})))),/*#__PURE__*/React__default.createElement("div",{className:"flex-1 h-0 pt-5 pb-4 overflow-y-auto",style:{backgroundImage:`url(${backgroundUrl})`}},/*#__PURE__*/React__default.createElement("div",{className:"flex-shrink-0 flex items-center px-4"},logoUrl?/*#__PURE__*/React__default.createElement("a",{href:logoLink},/*#__PURE__*/React__default.createElement("img",{alt:"Logo",src:logoUrl,className:"h-10"})):/*#__PURE__*/React__default.createElement("svg",{className:"h-8 w-full border border-gray-300 bg-white text-gray-300",preserveAspectRatio:"none",stroke:"currentColor",fill:"none",viewBox:"0 0 200 200","aria-hidden":"true"},/*#__PURE__*/React__default.createElement("path",{vectorEffect:"non-scaling-stroke",strokeWidth:1,d:"M0 0l200 200M0 200L200 0"}))),/*#__PURE__*/React__default.createElement(Navigation$1,{items:items,onMenuClick:handleNavigation})),/*#__PURE__*/React__default.createElement(Authentication,{loginLogoutLabel:loginLogoutLabel,user:user,onLoginLogout:onLoginLogout}))),/*#__PURE__*/React__default.createElement("div",{className:"flex-shrink-0 w-14","aria-hidden":"true"}))),/*#__PURE__*/React__default.createElement("div",{className:"hidden lg:flex lg:w-64 lg:flex-col lg:fixed lg:inset-y-0 bg-secondary-900 "},/*#__PURE__*/React__default.createElement("div",{className:"flex-1 flex flex-col min-h-0 bg-no-repeat bg-left-top",style:{backgroundImage:`url(${backgroundUrl})`}},/*#__PURE__*/React__default.createElement("div",{className:"flex-1 flex flex-col pt-5 pb-4 overflow-y-auto"},/*#__PURE__*/React__default.createElement("div",null),/*#__PURE__*/React__default.createElement("div",{className:"flex items-center flex-shrink-0 px-4"},logoUrl?/*#__PURE__*/React__default.createElement("a",{href:logoLink},/*#__PURE__*/React__default.createElement("img",{alt:"Logo",src:logoUrl,className:"h-10"})):/*#__PURE__*/React__default.createElement("svg",{className:"h-8 w-full border border-gray-300 bg-white text-gray-300",preserveAspectRatio:"none",stroke:"currentColor",fill:"none",viewBox:"0 0 200 200","aria-hidden":"true"},/*#__PURE__*/React__default.createElement("path",{vectorEffect:"non-scaling-stroke",strokeWidth:1,d:"M0 0l200 200M0 200L200 0"}))),/*#__PURE__*/React__default.createElement(Navigation$1,{items:items,onMenuClick:handleNavigation})),/*#__PURE__*/React__default.createElement(Authentication,{loginLogoutLabel:loginLogoutLabel,user:user,onLoginLogout:onLoginLogout})))));}Sidebar.propTypes={items:Navigation$1.propTypes.items,user:Authentication.propTypes.user,onNavigation:Navigation$1.propTypes.onMenuClick,onLoginLogout:Authentication.propTypes.onLoginLogout,sidebarOpen:PropTypes.bool,logoUrl:PropTypes.string,backgroundUrl:PropTypes.string,onSidebarClose:PropTypes.func,type:PropTypes.oneOf(["default"]),// Would be better to use Object.keys but it won't work with Storybook currently
size:PropTypes.oneOf(["base"])};Sidebar.defaultProps={sidebarOpen:false,onSidebarClose:undefined,type:"default",size:"base",logoUrl:null,backgroundUrl:null};function Main({logoUrl,logoLink,backgroundUrl,navigationItems,user,onNavigation,onLoginLogout,headerContext,loginLogoutLabel,type,size,sidebarOpen,onToggleSidebar,...props}){return/*#__PURE__*/React__default.createElement("div",{className:"h-full"},/*#__PURE__*/React__default.createElement(Sidebar,{logoUrl:logoUrl,logoLink:logoLink,backgroundUrl:backgroundUrl,items:navigationItems,user:user,onNavigation:onNavigation,onLoginLogout:onLoginLogout,sidebarOpen:sidebarOpen,loginLogoutLabel:loginLogoutLabel,onSidebarClose:()=>onToggleSidebar(false)}),/*#__PURE__*/React__default.createElement("div",{className:"lg:pl-64 flex flex-col h-full"},/*#__PURE__*/React__default.createElement("div",{className:"lg:hidden"},/*#__PURE__*/React__default.createElement(Header$1,_extends$3({},headerContext,{onSidebarOpen:()=>onToggleSidebar(true)}))),/*#__PURE__*/React__default.createElement("main",{className:"h-full"},props.children)));}Main.propTypes={logoUrl:PropTypes.string,backgroundUrl:PropTypes.string,navigation:Sidebar.propTypes.items,user:Sidebar.propTypes.user,onNavigation:Sidebar.propTypes.onNavigation,onLoginLogout:Sidebar.propTypes.onLoginLogout,headerContext:PropTypes.shape({currentSong:Header$1.propTypes.currentSong,onShare:Header$1.propTypes.onShare,onAddStem:Header$1.propTypes.onAddStem,onDownload:Header$1.propTypes.onDownload,onReset:Header$1.propTypes.onReset,showExtraMenu:Header$1.propTypes.showExtraMenu}).isRequired,type:PropTypes.oneOf(["default"]),// Would be better to use Object.keys but it won't work with Storybook currently
size:PropTypes.oneOf(["base"]),sidebarOpen:PropTypes.bool,onToggleSidebar:PropTypes.func};Main.defaultProps={type:"default",size:"base",sidebarOpen:false,onToggleSidebar:undefined};const getPixelRatio=context=>{let backingStore=context.backingStorePixelRatio||context.webkitBackingStorePixelRatio||context.mozBackingStorePixelRatio||context.msBackingStorePixelRatio||context.oBackingStorePixelRatio||context.backingStorePixelRatio||1;return (window.devicePixelRatio||1)/backingStore;};const Canvas=props=>{const{draw,options,onDragEvent,onTapEvent,...rest}=props;const canvasRef=useRef(null);useEffect(()=>{if(!canvasRef.current){return;}const canvas=canvasRef.current;const context=canvas.getContext(options.context||"2d");let frameCount=0;let animationFrameId;const render=()=>{frameCount++;updateCanvasSize(canvas,context);draw(context,frameCount);animationFrameId=window.requestAnimationFrame(render);};render();return ()=>{window.cancelAnimationFrame(animationFrameId);};},[draw]);const updateCanvasSize=(canvas,context)=>{const{width,height}=canvas.getBoundingClientRect();if(canvas.width!==width||canvas.height!==height){const ratio=getPixelRatio(context);canvas.width=width*ratio;canvas.height=height*ratio;context.scale(ratio,ratio);return true;}return false;};return/*#__PURE__*/React__default.createElement("canvas",_extends$3({style:{touchAction:'pan-y'},ref:canvasRef},rest));};Canvas.propTypes={draw:PropTypes.func.isRequired,options:PropTypes.shape({context:PropTypes.oneOf(["2d","webgl","experimental-webgl","webgl2","bitmaprenderer"])})};Canvas.defaultProps={options:{}};function _typeof$4(o){"@babel/helpers - typeof";return _typeof$4="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(o){return typeof o;}:function(o){return o&&"function"==typeof Symbol&&o.constructor===Symbol&&o!==Symbol.prototype?"symbol":typeof o;},_typeof$4(o);}function toPrimitive$1(t,r){if("object"!=_typeof$4(t)||!t)return t;var e=t[Symbol.toPrimitive];if(void 0!==e){var i=e.call(t,r||"default");if("object"!=_typeof$4(i))return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string"===r?String:Number)(t);}function toPropertyKey(t){var i=toPrimitive$1(t,"string");return "symbol"==_typeof$4(i)?i:String(i);}function _defineProperty$1$1(obj,key,value){key=toPropertyKey(key);if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else {obj[key]=value;}return obj;}function ownKeys$1$1(e,r){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(e);r&&(o=o.filter(function(r){return Object.getOwnPropertyDescriptor(e,r).enumerable;})),t.push.apply(t,o);}return t;}function _objectSpread2$1(e){for(var r=1;r<arguments.length;r++){var t=null!=arguments[r]?arguments[r]:{};r%2?ownKeys$1$1(Object(t),!0).forEach(function(r){_defineProperty$1$1(e,r,t[r]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):ownKeys$1$1(Object(t)).forEach(function(r){Object.defineProperty(e,r,Object.getOwnPropertyDescriptor(t,r));});}return e;}function _arrayLikeToArray(arr,len){if(len==null||len>arr.length)len=arr.length;for(var i=0,arr2=new Array(len);i<len;i++)arr2[i]=arr[i];return arr2;}function _arrayWithoutHoles$1(arr){if(Array.isArray(arr))return _arrayLikeToArray(arr);}function _iterableToArray$1(iter){if(typeof Symbol!=="undefined"&&iter[Symbol.iterator]!=null||iter["@@iterator"]!=null)return Array.from(iter);}function _unsupportedIterableToArray(o,minLen){if(!o)return;if(typeof o==="string")return _arrayLikeToArray(o,minLen);var n=Object.prototype.toString.call(o).slice(8,-1);if(n==="Object"&&o.constructor)n=o.constructor.name;if(n==="Map"||n==="Set")return Array.from(o);if(n==="Arguments"||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return _arrayLikeToArray(o,minLen);}function _nonIterableSpread$1(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}function _toConsumableArray$1(arr){return _arrayWithoutHoles$1(arr)||_iterableToArray$1(arr)||_unsupportedIterableToArray(arr)||_nonIterableSpread$1();}function _arrayWithHoles(arr){if(Array.isArray(arr))return arr;}function _iterableToArrayLimit(r,l){var t=null==r?null:"undefined"!=typeof Symbol&&r[Symbol.iterator]||r["@@iterator"];if(null!=t){var e,n,i,u,a=[],f=!0,o=!1;try{if(i=(t=t.call(r)).next,0===l){if(Object(t)!==t)return;f=!1;}else for(;!(f=(e=i.call(t)).done)&&(a.push(e.value),a.length!==l);f=!0);}catch(r){o=!0,n=r;}finally{try{if(!f&&null!=t["return"]&&(u=t["return"](),Object(u)!==u))return;}finally{if(o)throw n;}}return a;}}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}function _slicedToArray(arr,i){return _arrayWithHoles(arr)||_iterableToArrayLimit(arr,i)||_unsupportedIterableToArray(arr,i)||_nonIterableRest();}var classnames$1={exports:{}};/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/(function(module){/* global define */(function(){var hasOwn={}.hasOwnProperty;function classNames(){var classes='';for(var i=0;i<arguments.length;i++){var arg=arguments[i];if(arg){classes=appendClass(classes,parseValue(arg));}}return classes;}function parseValue(arg){if(typeof arg==='string'||typeof arg==='number'){return arg;}if(typeof arg!=='object'){return '';}if(Array.isArray(arg)){return classNames.apply(null,arg);}if(arg.toString!==Object.prototype.toString&&!arg.toString.toString().includes('[native code]')){return arg.toString();}var classes='';for(var key in arg){if(hasOwn.call(arg,key)&&arg[key]){classes=appendClass(classes,key);}}return classes;}function appendClass(value,newClass){if(!newClass){return value;}if(value){return value+' '+newClass;}return value+newClass;}if(module.exports){classNames.default=classNames;module.exports=classNames;}else {window.classNames=classNames;}})();})(classnames$1);var cls=classnames$1.exports;function useEvent(callback){var fnRef=React.useRef();fnRef.current=callback;var memoFn=React.useCallback(function(){var _fnRef$current;for(var _len=arguments.length,args=new Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return (_fnRef$current=fnRef.current)===null||_fnRef$current===void 0?void 0:_fnRef$current.call.apply(_fnRef$current,[fnRef].concat(args));},[]);return memoFn;}function canUseDom(){return !!(typeof window!=='undefined'&&window.document&&window.document.createElement);}/**
 * Wrap `React.useLayoutEffect` which will not throw warning message in test env
 */var useInternalLayoutEffect=process.env.NODE_ENV!=='test'&&canUseDom()?React.useLayoutEffect:React.useEffect;var useLayoutEffect=function useLayoutEffect(callback,deps){var firstMountRef=React.useRef(true);useInternalLayoutEffect(function(){return callback(firstMountRef.current);},deps);// We tell react that first mount has passed
useInternalLayoutEffect(function(){firstMountRef.current=false;return function(){firstMountRef.current=true;};},[]);};var useLayoutUpdateEffect=function useLayoutUpdateEffect(callback,deps){useLayoutEffect(function(firstMount){if(!firstMount){return callback();}},deps);};/**
 * Same as React.useState but `setState` accept `ignoreDestroy` param to not to setState after destroyed.
 * We do not make this auto is to avoid real memory leak.
 * Developer should confirm it's safe to ignore themselves.
 */function useSafeState(defaultValue){var destroyRef=React.useRef(false);var _React$useState=React.useState(defaultValue),_React$useState2=_slicedToArray(_React$useState,2),value=_React$useState2[0],setValue=_React$useState2[1];React.useEffect(function(){destroyRef.current=false;return function(){destroyRef.current=true;};},[]);function safeSetState(updater,ignoreDestroy){if(ignoreDestroy&&destroyRef.current){return;}setValue(updater);}return [value,safeSetState];}/** We only think `undefined` is empty */function hasValue(value){return value!==undefined;}/**
 * Similar to `useState` but will use props value if provided.
 * Note that internal use rc-util `useState` hook.
 */function useMergedState(defaultStateValue,option){var _ref=option||{},defaultValue=_ref.defaultValue,value=_ref.value,onChange=_ref.onChange,postState=_ref.postState;// ======================= Init =======================
var _useState=useSafeState(function(){if(hasValue(value)){return value;}else if(hasValue(defaultValue)){return typeof defaultValue==='function'?defaultValue():defaultValue;}else {return typeof defaultStateValue==='function'?defaultStateValue():defaultStateValue;}}),_useState2=_slicedToArray(_useState,2),innerValue=_useState2[0],setInnerValue=_useState2[1];var mergedValue=value!==undefined?value:innerValue;var postMergedValue=postState?postState(mergedValue):mergedValue;// ====================== Change ======================
var onChangeFn=useEvent(onChange);var _useState3=useSafeState([mergedValue]),_useState4=_slicedToArray(_useState3,2),prevValue=_useState4[0],setPrevValue=_useState4[1];useLayoutUpdateEffect(function(){var prev=prevValue[0];if(innerValue!==prev){onChangeFn(innerValue,prev);}},[prevValue]);// Sync value back to `undefined` when it from control to un-control
useLayoutUpdateEffect(function(){if(!hasValue(value)){setInnerValue(value);}},[value]);// ====================== Update ======================
var triggerChange=useEvent(function(updater,ignoreDestroy){setInnerValue(updater,ignoreDestroy);setPrevValue([mergedValue],ignoreDestroy);});return [postMergedValue,triggerChange];}/* eslint-disable no-console */var warned={};var preWarningFns=[];/**
 * Pre warning enable you to parse content before console.error.
 * Modify to null will prevent warning.
 */var preMessage=function preMessage(fn){preWarningFns.push(fn);};/**
 * Warning if condition not match.
 * @param valid Condition
 * @param message Warning message
 * @example
 * ```js
 * warning(false, 'some error'); // print some error
 * warning(true, 'some error'); // print nothing
 * warning(1 === 2, 'some error'); // print some error
 * ```
 */function warning(valid,message){if(process.env.NODE_ENV!=='production'&&!valid&&console!==undefined){var finalMessage=preWarningFns.reduce(function(msg,preMessageFn){return preMessageFn(msg!==null&&msg!==void 0?msg:'','warning');},message);if(finalMessage){console.error("Warning: ".concat(finalMessage));}}}/** @see Similar to {@link warning} */function note(valid,message){if(process.env.NODE_ENV!=='production'&&!valid&&console!==undefined){var finalMessage=preWarningFns.reduce(function(msg,preMessageFn){return preMessageFn(msg!==null&&msg!==void 0?msg:'','note');},message);if(finalMessage){console.warn("Note: ".concat(finalMessage));}}}function resetWarned(){warned={};}function call$1(method,valid,message){if(!valid&&!warned[message]){method(false,message);warned[message]=true;}}/** @see Same as {@link warning}, but only warn once for the same message */function warningOnce(valid,message){call$1(warning,valid,message);}/** @see Same as {@link warning}, but only warn once for the same message */function noteOnce(valid,message){call$1(note,valid,message);}warningOnce.preMessage=preMessage;warningOnce.resetWarned=resetWarned;warningOnce.noteOnce=noteOnce;/**
 * Deeply compares two object literals.
 * @param obj1 object 1
 * @param obj2 object 2
 * @param shallow shallow compare
 * @returns
 */function isEqual(obj1,obj2){var shallow=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;// https://github.com/mapbox/mapbox-gl-js/pull/5979/files#diff-fde7145050c47cc3a306856efd5f9c3016e86e859de9afbd02c879be5067e58f
var refSet=new Set();function deepEqual(a,b){var level=arguments.length>2&&arguments[2]!==undefined?arguments[2]:1;var circular=refSet.has(a);warningOnce(!circular,'Warning: There may be circular references');if(circular){return false;}if(a===b){return true;}if(shallow&&level>1){return false;}refSet.add(a);var newLevel=level+1;if(Array.isArray(a)){if(!Array.isArray(b)||a.length!==b.length){return false;}for(var i=0;i<a.length;i++){if(!deepEqual(a[i],b[i],newLevel)){return false;}}return true;}if(a&&b&&_typeof$4(a)==='object'&&_typeof$4(b)==='object'){var keys=Object.keys(a);if(keys.length!==Object.keys(b).length){return false;}return keys.every(function(key){return deepEqual(a[key],b[key],newLevel);});}// other
return false;}return deepEqual(obj1,obj2);}var SliderContext=/*#__PURE__*/React.createContext({min:0,max:0,direction:'ltr',step:1,includedStart:0,includedEnd:0,tabIndex:0,keyboard:true,styles:{},classNames:{}});function _extends$2(){_extends$2=Object.assign?Object.assign.bind():function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends$2.apply(this,arguments);}function _objectWithoutPropertiesLoose$1(source,excluded){if(source==null)return {};var target={};var sourceKeys=Object.keys(source);var key,i;for(i=0;i<sourceKeys.length;i++){key=sourceKeys[i];if(excluded.indexOf(key)>=0)continue;target[key]=source[key];}return target;}function _objectWithoutProperties$1(source,excluded){if(source==null)return {};var target=_objectWithoutPropertiesLoose$1(source,excluded);var key,i;if(Object.getOwnPropertySymbols){var sourceSymbolKeys=Object.getOwnPropertySymbols(source);for(i=0;i<sourceSymbolKeys.length;i++){key=sourceSymbolKeys[i];if(excluded.indexOf(key)>=0)continue;if(!Object.prototype.propertyIsEnumerable.call(source,key))continue;target[key]=source[key];}}return target;}/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */var KeyCode={/**
   * MAC_ENTER
   */MAC_ENTER:3,/**
   * BACKSPACE
   */BACKSPACE:8,/**
   * TAB
   */TAB:9,/**
   * NUMLOCK on FF/Safari Mac
   */NUM_CENTER:12,// NUMLOCK on FF/Safari Mac
/**
   * ENTER
   */ENTER:13,/**
   * SHIFT
   */SHIFT:16,/**
   * CTRL
   */CTRL:17,/**
   * ALT
   */ALT:18,/**
   * PAUSE
   */PAUSE:19,/**
   * CAPS_LOCK
   */CAPS_LOCK:20,/**
   * ESC
   */ESC:27,/**
   * SPACE
   */SPACE:32,/**
   * PAGE_UP
   */PAGE_UP:33,// also NUM_NORTH_EAST
/**
   * PAGE_DOWN
   */PAGE_DOWN:34,// also NUM_SOUTH_EAST
/**
   * END
   */END:35,// also NUM_SOUTH_WEST
/**
   * HOME
   */HOME:36,// also NUM_NORTH_WEST
/**
   * LEFT
   */LEFT:37,// also NUM_WEST
/**
   * UP
   */UP:38,// also NUM_NORTH
/**
   * RIGHT
   */RIGHT:39,// also NUM_EAST
/**
   * DOWN
   */DOWN:40,// also NUM_SOUTH
/**
   * PRINT_SCREEN
   */PRINT_SCREEN:44,/**
   * INSERT
   */INSERT:45,// also NUM_INSERT
/**
   * DELETE
   */DELETE:46,// also NUM_DELETE
/**
   * ZERO
   */ZERO:48,/**
   * ONE
   */ONE:49,/**
   * TWO
   */TWO:50,/**
   * THREE
   */THREE:51,/**
   * FOUR
   */FOUR:52,/**
   * FIVE
   */FIVE:53,/**
   * SIX
   */SIX:54,/**
   * SEVEN
   */SEVEN:55,/**
   * EIGHT
   */EIGHT:56,/**
   * NINE
   */NINE:57,/**
   * QUESTION_MARK
   */QUESTION_MARK:63,// needs localization
/**
   * A
   */A:65,/**
   * B
   */B:66,/**
   * C
   */C:67,/**
   * D
   */D:68,/**
   * E
   */E:69,/**
   * F
   */F:70,/**
   * G
   */G:71,/**
   * H
   */H:72,/**
   * I
   */I:73,/**
   * J
   */J:74,/**
   * K
   */K:75,/**
   * L
   */L:76,/**
   * M
   */M:77,/**
   * N
   */N:78,/**
   * O
   */O:79,/**
   * P
   */P:80,/**
   * Q
   */Q:81,/**
   * R
   */R:82,/**
   * S
   */S:83,/**
   * T
   */T:84,/**
   * U
   */U:85,/**
   * V
   */V:86,/**
   * W
   */W:87,/**
   * X
   */X:88,/**
   * Y
   */Y:89,/**
   * Z
   */Z:90,/**
   * META
   */META:91,// WIN_KEY_LEFT
/**
   * WIN_KEY_RIGHT
   */WIN_KEY_RIGHT:92,/**
   * CONTEXT_MENU
   */CONTEXT_MENU:93,/**
   * NUM_ZERO
   */NUM_ZERO:96,/**
   * NUM_ONE
   */NUM_ONE:97,/**
   * NUM_TWO
   */NUM_TWO:98,/**
   * NUM_THREE
   */NUM_THREE:99,/**
   * NUM_FOUR
   */NUM_FOUR:100,/**
   * NUM_FIVE
   */NUM_FIVE:101,/**
   * NUM_SIX
   */NUM_SIX:102,/**
   * NUM_SEVEN
   */NUM_SEVEN:103,/**
   * NUM_EIGHT
   */NUM_EIGHT:104,/**
   * NUM_NINE
   */NUM_NINE:105,/**
   * NUM_MULTIPLY
   */NUM_MULTIPLY:106,/**
   * NUM_PLUS
   */NUM_PLUS:107,/**
   * NUM_MINUS
   */NUM_MINUS:109,/**
   * NUM_PERIOD
   */NUM_PERIOD:110,/**
   * NUM_DIVISION
   */NUM_DIVISION:111,/**
   * F1
   */F1:112,/**
   * F2
   */F2:113,/**
   * F3
   */F3:114,/**
   * F4
   */F4:115,/**
   * F5
   */F5:116,/**
   * F6
   */F6:117,/**
   * F7
   */F7:118,/**
   * F8
   */F8:119,/**
   * F9
   */F9:120,/**
   * F10
   */F10:121,/**
   * F11
   */F11:122,/**
   * F12
   */F12:123,/**
   * NUMLOCK
   */NUMLOCK:144,/**
   * SEMICOLON
   */SEMICOLON:186,// needs localization
/**
   * DASH
   */DASH:189,// needs localization
/**
   * EQUALS
   */EQUALS:187,// needs localization
/**
   * COMMA
   */COMMA:188,// needs localization
/**
   * PERIOD
   */PERIOD:190,// needs localization
/**
   * SLASH
   */SLASH:191,// needs localization
/**
   * APOSTROPHE
   */APOSTROPHE:192,// needs localization
/**
   * SINGLE_QUOTE
   */SINGLE_QUOTE:222,// needs localization
/**
   * OPEN_SQUARE_BRACKET
   */OPEN_SQUARE_BRACKET:219,// needs localization
/**
   * BACKSLASH
   */BACKSLASH:220,// needs localization
/**
   * CLOSE_SQUARE_BRACKET
   */CLOSE_SQUARE_BRACKET:221,// needs localization
/**
   * WIN_KEY
   */WIN_KEY:224,/**
   * MAC_FF_META
   */MAC_FF_META:224,// Firefox (Gecko) fires this for the meta key instead of 91
/**
   * WIN_IME
   */WIN_IME:229,// ======================== Function ========================
/**
   * whether text and modified key is entered at the same time.
   */isTextModifyingKeyEvent:function isTextModifyingKeyEvent(e){var keyCode=e.keyCode;if(e.altKey&&!e.ctrlKey||e.metaKey||// Function keys don't generate text
keyCode>=KeyCode.F1&&keyCode<=KeyCode.F12){return false;}// The following keys are quite harmless, even in combination with
// CTRL, ALT or SHIFT.
switch(keyCode){case KeyCode.ALT:case KeyCode.CAPS_LOCK:case KeyCode.CONTEXT_MENU:case KeyCode.CTRL:case KeyCode.DOWN:case KeyCode.END:case KeyCode.ESC:case KeyCode.HOME:case KeyCode.INSERT:case KeyCode.LEFT:case KeyCode.MAC_FF_META:case KeyCode.META:case KeyCode.NUMLOCK:case KeyCode.NUM_CENTER:case KeyCode.PAGE_DOWN:case KeyCode.PAGE_UP:case KeyCode.PAUSE:case KeyCode.PRINT_SCREEN:case KeyCode.RIGHT:case KeyCode.SHIFT:case KeyCode.UP:case KeyCode.WIN_KEY:case KeyCode.WIN_KEY_RIGHT:return false;default:return true;}},/**
   * whether character is entered.
   */isCharacterKey:function isCharacterKey(keyCode){if(keyCode>=KeyCode.ZERO&&keyCode<=KeyCode.NINE){return true;}if(keyCode>=KeyCode.NUM_ZERO&&keyCode<=KeyCode.NUM_MULTIPLY){return true;}if(keyCode>=KeyCode.A&&keyCode<=KeyCode.Z){return true;}// Safari sends zero key code for non-latin characters.
if(window.navigator.userAgent.indexOf('WebKit')!==-1&&keyCode===0){return true;}switch(keyCode){case KeyCode.SPACE:case KeyCode.QUESTION_MARK:case KeyCode.NUM_PLUS:case KeyCode.NUM_MINUS:case KeyCode.NUM_PERIOD:case KeyCode.NUM_DIVISION:case KeyCode.SEMICOLON:case KeyCode.DASH:case KeyCode.EQUALS:case KeyCode.COMMA:case KeyCode.PERIOD:case KeyCode.SLASH:case KeyCode.APOSTROPHE:case KeyCode.SINGLE_QUOTE:case KeyCode.OPEN_SQUARE_BRACKET:case KeyCode.BACKSLASH:case KeyCode.CLOSE_SQUARE_BRACKET:return true;default:return false;}}};function getOffset(value,min,max){return (value-min)/(max-min);}function getDirectionStyle(direction,value,min,max){var offset=getOffset(value,min,max);var positionStyle={};switch(direction){case'rtl':positionStyle.right="".concat(offset*100,"%");positionStyle.transform='translateX(50%)';break;case'btt':positionStyle.bottom="".concat(offset*100,"%");positionStyle.transform='translateY(50%)';break;case'ttb':positionStyle.top="".concat(offset*100,"%");positionStyle.transform='translateY(-50%)';break;default:positionStyle.left="".concat(offset*100,"%");positionStyle.transform='translateX(-50%)';break;}return positionStyle;}/** Return index value if is list or return value directly */function getIndex(value,index){return Array.isArray(value)?value[index]:value;}var _excluded$c=["prefixCls","value","valueIndex","onStartMove","style","render","dragging","onOffsetChange","onChangeComplete"];var Handle=/*#__PURE__*/React.forwardRef(function(props,ref){var _cls,_getIndex;var prefixCls=props.prefixCls,value=props.value,valueIndex=props.valueIndex,onStartMove=props.onStartMove,style=props.style,render=props.render,dragging=props.dragging,onOffsetChange=props.onOffsetChange,onChangeComplete=props.onChangeComplete,restProps=_objectWithoutProperties$1(props,_excluded$c);var _React$useContext=React.useContext(SliderContext),min=_React$useContext.min,max=_React$useContext.max,direction=_React$useContext.direction,disabled=_React$useContext.disabled,keyboard=_React$useContext.keyboard,range=_React$useContext.range,tabIndex=_React$useContext.tabIndex,ariaLabelForHandle=_React$useContext.ariaLabelForHandle,ariaLabelledByForHandle=_React$useContext.ariaLabelledByForHandle,ariaValueTextFormatterForHandle=_React$useContext.ariaValueTextFormatterForHandle,styles=_React$useContext.styles,classNames=_React$useContext.classNames;var handlePrefixCls="".concat(prefixCls,"-handle");// ============================ Events ============================
var onInternalStartMove=function onInternalStartMove(e){if(!disabled){onStartMove(e,valueIndex);}};// =========================== Keyboard ===========================
var onKeyDown=function onKeyDown(e){if(!disabled&&keyboard){var offset=null;// Change the value
switch(e.which||e.keyCode){case KeyCode.LEFT:offset=direction==='ltr'||direction==='btt'?-1:1;break;case KeyCode.RIGHT:offset=direction==='ltr'||direction==='btt'?1:-1;break;// Up is plus
case KeyCode.UP:offset=direction!=='ttb'?1:-1;break;// Down is minus
case KeyCode.DOWN:offset=direction!=='ttb'?-1:1;break;case KeyCode.HOME:offset='min';break;case KeyCode.END:offset='max';break;case KeyCode.PAGE_UP:offset=2;break;case KeyCode.PAGE_DOWN:offset=-2;break;}if(offset!==null){e.preventDefault();onOffsetChange(offset,valueIndex);}}};var handleKeyUp=function handleKeyUp(e){switch(e.which||e.keyCode){case KeyCode.LEFT:case KeyCode.RIGHT:case KeyCode.UP:case KeyCode.DOWN:case KeyCode.HOME:case KeyCode.END:case KeyCode.PAGE_UP:case KeyCode.PAGE_DOWN:onChangeComplete===null||onChangeComplete===void 0||onChangeComplete();break;}};// ============================ Offset ============================
var positionStyle=getDirectionStyle(direction,value,min,max);// ============================ Render ============================
var handleNode=/*#__PURE__*/React.createElement("div",_extends$2({ref:ref,className:cls(handlePrefixCls,(_cls={},_defineProperty$1$1(_cls,"".concat(handlePrefixCls,"-").concat(valueIndex+1),range),_defineProperty$1$1(_cls,"".concat(handlePrefixCls,"-dragging"),dragging),_cls),classNames.handle),style:_objectSpread2$1(_objectSpread2$1(_objectSpread2$1({},positionStyle),style),styles.handle),onMouseDown:onInternalStartMove,onTouchStart:onInternalStartMove,onKeyDown:onKeyDown,onKeyUp:handleKeyUp,tabIndex:disabled?null:getIndex(tabIndex,valueIndex),role:"slider","aria-valuemin":min,"aria-valuemax":max,"aria-valuenow":value,"aria-disabled":disabled,"aria-label":getIndex(ariaLabelForHandle,valueIndex),"aria-labelledby":getIndex(ariaLabelledByForHandle,valueIndex),"aria-valuetext":(_getIndex=getIndex(ariaValueTextFormatterForHandle,valueIndex))===null||_getIndex===void 0?void 0:_getIndex(value),"aria-orientation":direction==='ltr'||direction==='rtl'?'horizontal':'vertical'},restProps));// Customize
if(render){handleNode=render(handleNode,{index:valueIndex,prefixCls:prefixCls,value:value,dragging:dragging});}return handleNode;});if(process.env.NODE_ENV!=='production'){Handle.displayName='Handle';}var _excluded$b=["prefixCls","style","onStartMove","onOffsetChange","values","handleRender","draggingIndex"];var Handles=/*#__PURE__*/React.forwardRef(function(props,ref){var prefixCls=props.prefixCls,style=props.style,onStartMove=props.onStartMove,onOffsetChange=props.onOffsetChange,values=props.values,handleRender=props.handleRender,draggingIndex=props.draggingIndex,restProps=_objectWithoutProperties$1(props,_excluded$b);var handlesRef=React.useRef({});React.useImperativeHandle(ref,function(){return {focus:function focus(index){var _handlesRef$current$i;(_handlesRef$current$i=handlesRef.current[index])===null||_handlesRef$current$i===void 0||_handlesRef$current$i.focus();}};});return/*#__PURE__*/React.createElement(React.Fragment,null,values.map(function(value,index){return/*#__PURE__*/React.createElement(Handle,_extends$2({ref:function ref(node){if(!node){delete handlesRef.current[index];}else {handlesRef.current[index]=node;}},dragging:draggingIndex===index,prefixCls:prefixCls,style:getIndex(style,index),key:index,value:value,valueIndex:index,onStartMove:onStartMove,onOffsetChange:onOffsetChange,render:handleRender},restProps));}));});if(process.env.NODE_ENV!=='production'){Handles.displayName='Handles';}function getPosition(e){var obj='touches'in e?e.touches[0]:e;return {pageX:obj.pageX,pageY:obj.pageY};}function useDrag$1(containerRef,direction,rawValues,min,max,formatValue,triggerChange,finishChange,offsetValues){var _React$useState=React.useState(null),_React$useState2=_slicedToArray(_React$useState,2),draggingValue=_React$useState2[0],setDraggingValue=_React$useState2[1];var _React$useState3=React.useState(-1),_React$useState4=_slicedToArray(_React$useState3,2),draggingIndex=_React$useState4[0],setDraggingIndex=_React$useState4[1];var _React$useState5=React.useState(rawValues),_React$useState6=_slicedToArray(_React$useState5,2),cacheValues=_React$useState6[0],setCacheValues=_React$useState6[1];var _React$useState7=React.useState(rawValues),_React$useState8=_slicedToArray(_React$useState7,2),originValues=_React$useState8[0],setOriginValues=_React$useState8[1];var mouseMoveEventRef=React.useRef(null);var mouseUpEventRef=React.useRef(null);React.useEffect(function(){if(draggingIndex===-1){setCacheValues(rawValues);}},[rawValues,draggingIndex]);// Clean up event
React.useEffect(function(){return function(){document.removeEventListener('mousemove',mouseMoveEventRef.current);document.removeEventListener('mouseup',mouseUpEventRef.current);document.removeEventListener('touchmove',mouseMoveEventRef.current);document.removeEventListener('touchend',mouseUpEventRef.current);};},[]);var flushValues=function flushValues(nextValues,nextValue){// Perf: Only update state when value changed
if(cacheValues.some(function(val,i){return val!==nextValues[i];})){if(nextValue!==undefined){setDraggingValue(nextValue);}setCacheValues(nextValues);triggerChange(nextValues);}};var updateCacheValue=function updateCacheValue(valueIndex,offsetPercent){// Basic point offset
if(valueIndex===-1){// >>>> Dragging on the track
var startValue=originValues[0];var endValue=originValues[originValues.length-1];var maxStartOffset=min-startValue;var maxEndOffset=max-endValue;// Get valid offset
var offset=offsetPercent*(max-min);offset=Math.max(offset,maxStartOffset);offset=Math.min(offset,maxEndOffset);// Use first value to revert back of valid offset (like steps marks)
var formatStartValue=formatValue(startValue+offset);offset=formatStartValue-startValue;var cloneCacheValues=originValues.map(function(val){return val+offset;});flushValues(cloneCacheValues);}else {// >>>> Dragging on the handle
var offsetDist=(max-min)*offsetPercent;// Always start with the valueIndex origin value
var cloneValues=_toConsumableArray$1(cacheValues);cloneValues[valueIndex]=originValues[valueIndex];var next=offsetValues(cloneValues,offsetDist,valueIndex,'dist');flushValues(next.values,next.value);}};// Resolve closure
var updateCacheValueRef=React.useRef(updateCacheValue);updateCacheValueRef.current=updateCacheValue;var onStartMove=function onStartMove(e,valueIndex,startValues){e.stopPropagation();// 如果是点击 track 触发的，需要传入变化后的初始值，而不能直接用 rawValues
var initialValues=startValues||rawValues;var originValue=initialValues[valueIndex];setDraggingIndex(valueIndex);setDraggingValue(originValue);setOriginValues(initialValues);var _getPosition=getPosition(e),startX=_getPosition.pageX,startY=_getPosition.pageY;// Moving
var onMouseMove=function onMouseMove(event){event.preventDefault();var _getPosition2=getPosition(event),moveX=_getPosition2.pageX,moveY=_getPosition2.pageY;var offsetX=moveX-startX;var offsetY=moveY-startY;var _containerRef$current=containerRef.current.getBoundingClientRect(),width=_containerRef$current.width,height=_containerRef$current.height;var offSetPercent;switch(direction){case'btt':offSetPercent=-offsetY/height;break;case'ttb':offSetPercent=offsetY/height;break;case'rtl':offSetPercent=-offsetX/width;break;default:offSetPercent=offsetX/width;}updateCacheValueRef.current(valueIndex,offSetPercent);};// End
var onMouseUp=function onMouseUp(event){event.preventDefault();document.removeEventListener('mouseup',onMouseUp);document.removeEventListener('mousemove',onMouseMove);document.removeEventListener('touchend',onMouseUp);document.removeEventListener('touchmove',onMouseMove);mouseMoveEventRef.current=null;mouseUpEventRef.current=null;setDraggingIndex(-1);finishChange();};document.addEventListener('mouseup',onMouseUp);document.addEventListener('mousemove',onMouseMove);document.addEventListener('touchend',onMouseUp);document.addEventListener('touchmove',onMouseMove);mouseMoveEventRef.current=onMouseMove;mouseUpEventRef.current=onMouseUp;};// Only return cache value when it mapping with rawValues
var returnValues=React.useMemo(function(){var sourceValues=_toConsumableArray$1(rawValues).sort(function(a,b){return a-b;});var targetValues=_toConsumableArray$1(cacheValues).sort(function(a,b){return a-b;});return sourceValues.every(function(val,index){return val===targetValues[index];})?cacheValues:rawValues;},[rawValues,cacheValues]);return [draggingIndex,draggingValue,returnValues,onStartMove];}/** Format the value in the range of [min, max] */ /** Format value align with step */ /** Format value align with step & marks */function useOffset(min,max,step,markList,allowCross,pushable){var formatRangeValue=React.useCallback(function(val){var formatNextValue=isFinite(val)?val:min;formatNextValue=Math.min(max,val);formatNextValue=Math.max(min,formatNextValue);return formatNextValue;},[min,max]);var formatStepValue=React.useCallback(function(val){if(step!==null){var stepValue=min+Math.round((formatRangeValue(val)-min)/step)*step;// Cut number in case to be like 0.30000000000000004
var getDecimal=function getDecimal(num){return (String(num).split('.')[1]||'').length;};var maxDecimal=Math.max(getDecimal(step),getDecimal(max),getDecimal(min));var fixedValue=Number(stepValue.toFixed(maxDecimal));return min<=fixedValue&&fixedValue<=max?fixedValue:null;}return null;},[step,min,max,formatRangeValue]);var formatValue=React.useCallback(function(val){var formatNextValue=formatRangeValue(val);// List align values
var alignValues=markList.map(function(mark){return mark.value;});if(step!==null){alignValues.push(formatStepValue(val));}// min & max
alignValues.push(min,max);// Align with marks
var closeValue=alignValues[0];var closeDist=max-min;alignValues.forEach(function(alignValue){var dist=Math.abs(formatNextValue-alignValue);if(dist<=closeDist){closeValue=alignValue;closeDist=dist;}});return closeValue;},[min,max,markList,step,formatRangeValue,formatStepValue]);// ========================== Offset ==========================
// Single Value
var offsetValue=function offsetValue(values,offset,valueIndex){var mode=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'unit';if(typeof offset==='number'){var nextValue;var originValue=values[valueIndex];// Only used for `dist` mode
var targetDistValue=originValue+offset;// Compare next step value & mark value which is best match
var potentialValues=[];markList.forEach(function(mark){potentialValues.push(mark.value);});// Min & Max
potentialValues.push(min,max);// In case origin value is align with mark but not with step
potentialValues.push(formatStepValue(originValue));// Put offset step value also
var sign=offset>0?1:-1;if(mode==='unit'){potentialValues.push(formatStepValue(originValue+sign*step));}else {potentialValues.push(formatStepValue(targetDistValue));}// Find close one
potentialValues=potentialValues.filter(function(val){return val!==null;})// Remove reverse value
.filter(function(val){return offset<0?val<=originValue:val>=originValue;});if(mode==='unit'){// `unit` mode can not contain itself
potentialValues=potentialValues.filter(function(val){return val!==originValue;});}var compareValue=mode==='unit'?originValue:targetDistValue;nextValue=potentialValues[0];var valueDist=Math.abs(nextValue-compareValue);potentialValues.forEach(function(potentialValue){var dist=Math.abs(potentialValue-compareValue);if(dist<valueDist){nextValue=potentialValue;valueDist=dist;}});// Out of range will back to range
if(nextValue===undefined){return offset<0?min:max;}// `dist` mode
if(mode==='dist'){return nextValue;}// `unit` mode may need another round
if(Math.abs(offset)>1){var cloneValues=_toConsumableArray$1(values);cloneValues[valueIndex]=nextValue;return offsetValue(cloneValues,offset-sign,valueIndex,mode);}return nextValue;}else if(offset==='min'){return min;}else if(offset==='max'){return max;}};/** Same as `offsetValue` but return `changed` mark to tell value changed */var offsetChangedValue=function offsetChangedValue(values,offset,valueIndex){var mode=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'unit';var originValue=values[valueIndex];var nextValue=offsetValue(values,offset,valueIndex,mode);return {value:nextValue,changed:nextValue!==originValue};};var needPush=function needPush(dist){return pushable===null&&dist===0||typeof pushable==='number'&&dist<pushable;};// Values
var offsetValues=function offsetValues(values,offset,valueIndex){var mode=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'unit';var nextValues=values.map(formatValue);var originValue=nextValues[valueIndex];var nextValue=offsetValue(nextValues,offset,valueIndex,mode);nextValues[valueIndex]=nextValue;if(allowCross===false){// >>>>> Allow Cross
var pushNum=pushable||0;// ============ AllowCross ===============
if(valueIndex>0&&nextValues[valueIndex-1]!==originValue){nextValues[valueIndex]=Math.max(nextValues[valueIndex],nextValues[valueIndex-1]+pushNum);}if(valueIndex<nextValues.length-1&&nextValues[valueIndex+1]!==originValue){nextValues[valueIndex]=Math.min(nextValues[valueIndex],nextValues[valueIndex+1]-pushNum);}}else if(typeof pushable==='number'||pushable===null){// >>>>> Pushable
// =============== Push ==================
// >>>>>> Basic push
// End values
for(var i=valueIndex+1;i<nextValues.length;i+=1){var changed=true;while(needPush(nextValues[i]-nextValues[i-1])&&changed){var _offsetChangedValue=offsetChangedValue(nextValues,1,i);nextValues[i]=_offsetChangedValue.value;changed=_offsetChangedValue.changed;}}// Start values
for(var _i=valueIndex;_i>0;_i-=1){var _changed=true;while(needPush(nextValues[_i]-nextValues[_i-1])&&_changed){var _offsetChangedValue2=offsetChangedValue(nextValues,-1,_i-1);nextValues[_i-1]=_offsetChangedValue2.value;_changed=_offsetChangedValue2.changed;}}// >>>>> Revert back to safe push range
// End to Start
for(var _i2=nextValues.length-1;_i2>0;_i2-=1){var _changed2=true;while(needPush(nextValues[_i2]-nextValues[_i2-1])&&_changed2){var _offsetChangedValue3=offsetChangedValue(nextValues,-1,_i2-1);nextValues[_i2-1]=_offsetChangedValue3.value;_changed2=_offsetChangedValue3.changed;}}// Start to End
for(var _i3=0;_i3<nextValues.length-1;_i3+=1){var _changed3=true;while(needPush(nextValues[_i3+1]-nextValues[_i3])&&_changed3){var _offsetChangedValue4=offsetChangedValue(nextValues,1,_i3+1);nextValues[_i3+1]=_offsetChangedValue4.value;_changed3=_offsetChangedValue4.changed;}}}return {value:nextValues[valueIndex],values:nextValues};};return [formatValue,offsetValues];}function Mark(props){var prefixCls=props.prefixCls,style=props.style,children=props.children,value=props.value,_onClick=props.onClick;var _React$useContext=React.useContext(SliderContext),min=_React$useContext.min,max=_React$useContext.max,direction=_React$useContext.direction,includedStart=_React$useContext.includedStart,includedEnd=_React$useContext.includedEnd,included=_React$useContext.included;var textCls="".concat(prefixCls,"-text");// ============================ Offset ============================
var positionStyle=getDirectionStyle(direction,value,min,max);return/*#__PURE__*/React.createElement("span",{className:cls(textCls,_defineProperty$1$1({},"".concat(textCls,"-active"),included&&includedStart<=value&&value<=includedEnd)),style:_objectSpread2$1(_objectSpread2$1({},positionStyle),style),onMouseDown:function onMouseDown(e){e.stopPropagation();},onClick:function onClick(){_onClick(value);}},children);}function Marks(props){var prefixCls=props.prefixCls,marks=props.marks,onClick=props.onClick;var markPrefixCls="".concat(prefixCls,"-mark");// Not render mark if empty
if(!marks.length){return null;}return/*#__PURE__*/React.createElement("div",{className:markPrefixCls},marks.map(function(_ref){var value=_ref.value,style=_ref.style,label=_ref.label;return/*#__PURE__*/React.createElement(Mark,{key:value,prefixCls:markPrefixCls,style:style,value:value,onClick:onClick},label);}));}function Dot(props){var prefixCls=props.prefixCls,value=props.value,style=props.style,activeStyle=props.activeStyle;var _React$useContext=React.useContext(SliderContext),min=_React$useContext.min,max=_React$useContext.max,direction=_React$useContext.direction,included=_React$useContext.included,includedStart=_React$useContext.includedStart,includedEnd=_React$useContext.includedEnd;var dotClassName="".concat(prefixCls,"-dot");var active=included&&includedStart<=value&&value<=includedEnd;// ============================ Offset ============================
var mergedStyle=_objectSpread2$1(_objectSpread2$1({},getDirectionStyle(direction,value,min,max)),typeof style==='function'?style(value):style);if(active){mergedStyle=_objectSpread2$1(_objectSpread2$1({},mergedStyle),typeof activeStyle==='function'?activeStyle(value):activeStyle);}return/*#__PURE__*/React.createElement("span",{className:cls(dotClassName,_defineProperty$1$1({},"".concat(dotClassName,"-active"),active)),style:mergedStyle});}function Steps(props){var prefixCls=props.prefixCls,marks=props.marks,dots=props.dots,style=props.style,activeStyle=props.activeStyle;var _React$useContext=React.useContext(SliderContext),min=_React$useContext.min,max=_React$useContext.max,step=_React$useContext.step;var stepDots=React.useMemo(function(){var dotSet=new Set();// Add marks
marks.forEach(function(mark){dotSet.add(mark.value);});// Fill dots
if(dots&&step!==null){var current=min;while(current<=max){dotSet.add(current);current+=step;}}return Array.from(dotSet);},[min,max,step,dots,marks]);return/*#__PURE__*/React.createElement("div",{className:"".concat(prefixCls,"-step")},stepDots.map(function(dotValue){return/*#__PURE__*/React.createElement(Dot,{prefixCls:prefixCls,key:dotValue,value:dotValue,style:style,activeStyle:activeStyle});}));}function Track$1(props){var _cls;var prefixCls=props.prefixCls,style=props.style,start=props.start,end=props.end,index=props.index,onStartMove=props.onStartMove,replaceCls=props.replaceCls;var _React$useContext=React.useContext(SliderContext),direction=_React$useContext.direction,min=_React$useContext.min,max=_React$useContext.max,disabled=_React$useContext.disabled,range=_React$useContext.range,classNames=_React$useContext.classNames;var trackPrefixCls="".concat(prefixCls,"-track");var offsetStart=getOffset(start,min,max);var offsetEnd=getOffset(end,min,max);// ============================ Events ============================
var onInternalStartMove=function onInternalStartMove(e){if(!disabled&&onStartMove){onStartMove(e,-1);}};// ============================ Render ============================
var positionStyle={};switch(direction){case'rtl':positionStyle.right="".concat(offsetStart*100,"%");positionStyle.width="".concat(offsetEnd*100-offsetStart*100,"%");break;case'btt':positionStyle.bottom="".concat(offsetStart*100,"%");positionStyle.height="".concat(offsetEnd*100-offsetStart*100,"%");break;case'ttb':positionStyle.top="".concat(offsetStart*100,"%");positionStyle.height="".concat(offsetEnd*100-offsetStart*100,"%");break;default:positionStyle.left="".concat(offsetStart*100,"%");positionStyle.width="".concat(offsetEnd*100-offsetStart*100,"%");}var className=replaceCls||cls(trackPrefixCls,(_cls={},_defineProperty$1$1(_cls,"".concat(trackPrefixCls,"-").concat(index+1),index!==null&&range),_defineProperty$1$1(_cls,"".concat(prefixCls,"-track-draggable"),onStartMove),_cls),classNames.track);return/*#__PURE__*/React.createElement("div",{className:className,style:_objectSpread2$1(_objectSpread2$1({},positionStyle),style),onMouseDown:onInternalStartMove,onTouchStart:onInternalStartMove});}function Tracks(props){var prefixCls=props.prefixCls,style=props.style,values=props.values,startPoint=props.startPoint,onStartMove=props.onStartMove;var _React$useContext=React.useContext(SliderContext),included=_React$useContext.included,range=_React$useContext.range,min=_React$useContext.min,styles=_React$useContext.styles,classNames=_React$useContext.classNames;// =========================== List ===========================
var trackList=React.useMemo(function(){if(!range){// null value do not have track
if(values.length===0){return [];}var startValue=startPoint!==null&&startPoint!==void 0?startPoint:min;var endValue=values[0];return [{start:Math.min(startValue,endValue),end:Math.max(startValue,endValue)}];}// Multiple
var list=[];for(var i=0;i<values.length-1;i+=1){list.push({start:values[i],end:values[i+1]});}return list;},[values,range,startPoint,min]);// ========================== Render ==========================
var tracksNode=null;if(classNames.tracks||styles.tracks){tracksNode=/*#__PURE__*/React.createElement(Track$1,{index:null,prefixCls:prefixCls,start:trackList[0].start,end:trackList[trackList.length-1].end,replaceCls:cls(classNames.tracks,"".concat(prefixCls,"-tracks")),style:styles.tracks});}return included?/*#__PURE__*/React.createElement(React.Fragment,null,tracksNode,trackList.map(function(_ref,index){var start=_ref.start,end=_ref.end;return/*#__PURE__*/React.createElement(Track$1,{index:index,prefixCls:prefixCls,style:_objectSpread2$1(_objectSpread2$1({},getIndex(style,index)),styles.track),start:start,end:end,key:index,onStartMove:onStartMove});})):null;}/**
 * New:
 * - click mark to update range value
 * - handleRender
 * - Fix handle with count not correct
 * - Fix pushable not work in some case
 * - No more FindDOMNode
 * - Move all position related style into inline style
 * - Key: up is plus, down is minus
 * - fix Key with step = null not align with marks
 * - Change range should not trigger onChange
 * - keyboard support pushable
 */var Slider$3=/*#__PURE__*/React.forwardRef(function(props,ref){var _cls;var _props$prefixCls=props.prefixCls,prefixCls=_props$prefixCls===void 0?'rc-slider':_props$prefixCls,className=props.className,style=props.style,classNames=props.classNames,styles=props.styles,_props$disabled=props.disabled,disabled=_props$disabled===void 0?false:_props$disabled,_props$keyboard=props.keyboard,keyboard=_props$keyboard===void 0?true:_props$keyboard,autoFocus=props.autoFocus,onFocus=props.onFocus,onBlur=props.onBlur,_props$min=props.min,min=_props$min===void 0?0:_props$min,_props$max=props.max,max=_props$max===void 0?100:_props$max,_props$step=props.step,step=_props$step===void 0?1:_props$step,value=props.value,defaultValue=props.defaultValue,range=props.range,count=props.count,onChange=props.onChange,onBeforeChange=props.onBeforeChange,onAfterChange=props.onAfterChange,onChangeComplete=props.onChangeComplete,_props$allowCross=props.allowCross,allowCross=_props$allowCross===void 0?true:_props$allowCross,_props$pushable=props.pushable,pushable=_props$pushable===void 0?false:_props$pushable,draggableTrack=props.draggableTrack,reverse=props.reverse,vertical=props.vertical,_props$included=props.included,included=_props$included===void 0?true:_props$included,startPoint=props.startPoint,trackStyle=props.trackStyle,handleStyle=props.handleStyle,railStyle=props.railStyle,dotStyle=props.dotStyle,activeDotStyle=props.activeDotStyle,marks=props.marks,dots=props.dots,handleRender=props.handleRender,_props$tabIndex=props.tabIndex,tabIndex=_props$tabIndex===void 0?0:_props$tabIndex,ariaLabelForHandle=props.ariaLabelForHandle,ariaLabelledByForHandle=props.ariaLabelledByForHandle,ariaValueTextFormatterForHandle=props.ariaValueTextFormatterForHandle;var handlesRef=React.useRef();var containerRef=React.useRef();var direction=React.useMemo(function(){if(vertical){return reverse?'ttb':'btt';}return reverse?'rtl':'ltr';},[reverse,vertical]);// ============================ Range =============================
var mergedMin=React.useMemo(function(){return isFinite(min)?min:0;},[min]);var mergedMax=React.useMemo(function(){return isFinite(max)?max:100;},[max]);// ============================= Step =============================
var mergedStep=React.useMemo(function(){return step!==null&&step<=0?1:step;},[step]);// ============================= Push =============================
var mergedPush=React.useMemo(function(){if(typeof pushable==='boolean'){return pushable?mergedStep:false;}return pushable>=0?pushable:false;},[pushable,mergedStep]);// ============================ Marks =============================
var markList=React.useMemo(function(){var keys=Object.keys(marks||{});return keys.map(function(key){var mark=marks[key];var markObj={value:Number(key)};if(mark&&_typeof$4(mark)==='object'&&!/*#__PURE__*/React.isValidElement(mark)&&('label'in mark||'style'in mark)){markObj.style=mark.style;markObj.label=mark.label;}else {markObj.label=mark;}return markObj;}).filter(function(_ref){var label=_ref.label;return label||typeof label==='number';}).sort(function(a,b){return a.value-b.value;});},[marks]);// ============================ Format ============================
var _useOffset=useOffset(mergedMin,mergedMax,mergedStep,markList,allowCross,mergedPush),_useOffset2=_slicedToArray(_useOffset,2),formatValue=_useOffset2[0],offsetValues=_useOffset2[1];// ============================ Values ============================
var _useMergedState=useMergedState(defaultValue,{value:value}),_useMergedState2=_slicedToArray(_useMergedState,2),mergedValue=_useMergedState2[0],setValue=_useMergedState2[1];var rawValues=React.useMemo(function(){var valueList=mergedValue===null||mergedValue===undefined?[]:Array.isArray(mergedValue)?mergedValue:[mergedValue];var _valueList=_slicedToArray(valueList,1),_valueList$=_valueList[0],val0=_valueList$===void 0?mergedMin:_valueList$;var returnValues=mergedValue===null?[]:[val0];// Format as range
if(range){returnValues=_toConsumableArray$1(valueList);// When count provided or value is `undefined`, we fill values
if(count||mergedValue===undefined){var pointCount=count>=0?count+1:2;returnValues=returnValues.slice(0,pointCount);// Fill with count
while(returnValues.length<pointCount){var _returnValues;returnValues.push((_returnValues=returnValues[returnValues.length-1])!==null&&_returnValues!==void 0?_returnValues:mergedMin);}}returnValues.sort(function(a,b){return a-b;});}// Align in range
returnValues.forEach(function(val,index){returnValues[index]=formatValue(val);});return returnValues;},[mergedValue,range,mergedMin,count,formatValue]);// =========================== onChange ===========================
var rawValuesRef=React.useRef(rawValues);rawValuesRef.current=rawValues;var getTriggerValue=function getTriggerValue(triggerValues){return range?triggerValues:triggerValues[0];};var triggerChange=function triggerChange(nextValues){// Order first
var cloneNextValues=_toConsumableArray$1(nextValues).sort(function(a,b){return a-b;});// Trigger event if needed
if(onChange&&!isEqual(cloneNextValues,rawValuesRef.current,true)){onChange(getTriggerValue(cloneNextValues));}// We set this later since it will re-render component immediately
setValue(cloneNextValues);};var finishChange=function finishChange(){onAfterChange===null||onAfterChange===void 0||onAfterChange(getTriggerValue(rawValuesRef.current));warningOnce(!onAfterChange,'[rc-slider] `onAfterChange` is deprecated. Please use `onChangeComplete` instead.');onChangeComplete===null||onChangeComplete===void 0||onChangeComplete(getTriggerValue(rawValuesRef.current));};var _useDrag=useDrag$1(containerRef,direction,rawValues,mergedMin,mergedMax,formatValue,triggerChange,finishChange,offsetValues),_useDrag2=_slicedToArray(_useDrag,4),draggingIndex=_useDrag2[0],draggingValue=_useDrag2[1],cacheValues=_useDrag2[2],onStartDrag=_useDrag2[3];var changeToCloseValue=function changeToCloseValue(newValue,e){if(!disabled){var valueIndex=0;var valueDist=mergedMax-mergedMin;rawValues.forEach(function(val,index){var dist=Math.abs(newValue-val);if(dist<=valueDist){valueDist=dist;valueIndex=index;}});// Create new values
var cloneNextValues=_toConsumableArray$1(rawValues);cloneNextValues[valueIndex]=newValue;// Fill value to match default 2
if(range&&!rawValues.length&&count===undefined){cloneNextValues.push(newValue);}onBeforeChange===null||onBeforeChange===void 0||onBeforeChange(getTriggerValue(cloneNextValues));triggerChange(cloneNextValues);if(e){onStartDrag(e,valueIndex,cloneNextValues);}}};// ============================ Click =============================
var onSliderMouseDown=function onSliderMouseDown(e){e.preventDefault();var _containerRef$current=containerRef.current.getBoundingClientRect(),width=_containerRef$current.width,height=_containerRef$current.height,left=_containerRef$current.left,top=_containerRef$current.top,bottom=_containerRef$current.bottom,right=_containerRef$current.right;var clientX=e.clientX,clientY=e.clientY;var percent;switch(direction){case'btt':percent=(bottom-clientY)/height;break;case'ttb':percent=(clientY-top)/height;break;case'rtl':percent=(right-clientX)/width;break;default:percent=(clientX-left)/width;}var nextValue=mergedMin+percent*(mergedMax-mergedMin);changeToCloseValue(formatValue(nextValue),e);};// =========================== Keyboard ===========================
var _React$useState=React.useState(null),_React$useState2=_slicedToArray(_React$useState,2),keyboardValue=_React$useState2[0],setKeyboardValue=_React$useState2[1];var onHandleOffsetChange=function onHandleOffsetChange(offset,valueIndex){if(!disabled){var next=offsetValues(rawValues,offset,valueIndex);onBeforeChange===null||onBeforeChange===void 0||onBeforeChange(getTriggerValue(rawValues));triggerChange(next.values);setKeyboardValue(next.value);}};React.useEffect(function(){if(keyboardValue!==null){var valueIndex=rawValues.indexOf(keyboardValue);if(valueIndex>=0){handlesRef.current.focus(valueIndex);}}setKeyboardValue(null);},[keyboardValue]);// ============================= Drag =============================
var mergedDraggableTrack=React.useMemo(function(){if(draggableTrack&&mergedStep===null){if(process.env.NODE_ENV!=='production'){warningOnce(false,'`draggableTrack` is not supported when `step` is `null`.');}return false;}return draggableTrack;},[draggableTrack,mergedStep]);var onStartMove=function onStartMove(e,valueIndex){onStartDrag(e,valueIndex);onBeforeChange===null||onBeforeChange===void 0||onBeforeChange(getTriggerValue(rawValuesRef.current));};// Auto focus for updated handle
var dragging=draggingIndex!==-1;React.useEffect(function(){if(!dragging){var valueIndex=rawValues.lastIndexOf(draggingValue);handlesRef.current.focus(valueIndex);}},[dragging]);// =========================== Included ===========================
var sortedCacheValues=React.useMemo(function(){return _toConsumableArray$1(cacheValues).sort(function(a,b){return a-b;});},[cacheValues]);// Provide a range values with included [min, max]
// Used for Track, Mark & Dot
var _React$useMemo=React.useMemo(function(){if(!range){return [mergedMin,sortedCacheValues[0]];}return [sortedCacheValues[0],sortedCacheValues[sortedCacheValues.length-1]];},[sortedCacheValues,range,mergedMin]),_React$useMemo2=_slicedToArray(_React$useMemo,2),includedStart=_React$useMemo2[0],includedEnd=_React$useMemo2[1];// ============================= Refs =============================
React.useImperativeHandle(ref,function(){return {focus:function focus(){handlesRef.current.focus(0);},blur:function blur(){var _document=document,activeElement=_document.activeElement;if(containerRef.current.contains(activeElement)){activeElement===null||activeElement===void 0||activeElement.blur();}}};});// ========================== Auto Focus ==========================
React.useEffect(function(){if(autoFocus){handlesRef.current.focus(0);}},[]);// =========================== Context ============================
var context=React.useMemo(function(){return {min:mergedMin,max:mergedMax,direction:direction,disabled:disabled,keyboard:keyboard,step:mergedStep,included:included,includedStart:includedStart,includedEnd:includedEnd,range:range,tabIndex:tabIndex,ariaLabelForHandle:ariaLabelForHandle,ariaLabelledByForHandle:ariaLabelledByForHandle,ariaValueTextFormatterForHandle:ariaValueTextFormatterForHandle,styles:styles||{},classNames:classNames||{}};},[mergedMin,mergedMax,direction,disabled,keyboard,mergedStep,included,includedStart,includedEnd,range,tabIndex,ariaLabelForHandle,ariaLabelledByForHandle,ariaValueTextFormatterForHandle,styles,classNames]);// ============================ Render ============================
return/*#__PURE__*/React.createElement(SliderContext.Provider,{value:context},/*#__PURE__*/React.createElement("div",{ref:containerRef,className:cls(prefixCls,className,(_cls={},_defineProperty$1$1(_cls,"".concat(prefixCls,"-disabled"),disabled),_defineProperty$1$1(_cls,"".concat(prefixCls,"-vertical"),vertical),_defineProperty$1$1(_cls,"".concat(prefixCls,"-horizontal"),!vertical),_defineProperty$1$1(_cls,"".concat(prefixCls,"-with-marks"),markList.length),_cls)),style:style,onMouseDown:onSliderMouseDown},/*#__PURE__*/React.createElement("div",{className:cls("".concat(prefixCls,"-rail"),classNames===null||classNames===void 0?void 0:classNames.rail),style:_objectSpread2$1(_objectSpread2$1({},railStyle),styles===null||styles===void 0?void 0:styles.rail)}),/*#__PURE__*/React.createElement(Tracks,{prefixCls:prefixCls,style:trackStyle,values:sortedCacheValues,startPoint:startPoint,onStartMove:mergedDraggableTrack?onStartMove:null}),/*#__PURE__*/React.createElement(Steps,{prefixCls:prefixCls,marks:markList,dots:dots,style:dotStyle,activeStyle:activeDotStyle}),/*#__PURE__*/React.createElement(Handles,{ref:handlesRef,prefixCls:prefixCls,style:handleStyle,values:cacheValues,draggingIndex:draggingIndex,onStartMove:onStartMove,onOffsetChange:onHandleOffsetChange,onFocus:onFocus,onBlur:onBlur,handleRender:handleRender,onChangeComplete:finishChange}),/*#__PURE__*/React.createElement(Marks,{prefixCls:prefixCls,marks:markList,onClick:changeToCloseValue})));});if(process.env.NODE_ENV!=='production'){Slider$3.displayName='Slider';}var css_248z$7$1=".rc-slider{border-radius:6px;height:14px;padding:5px 0;position:relative;touch-action:none;width:100%}.rc-slider,.rc-slider *{-webkit-tap-highlight-color:rgba(0,0,0,0);box-sizing:border-box}.rc-slider-rail{background-color:#e9e9e9;border-radius:6px;height:4px;position:absolute;width:100%}.rc-slider-track,.rc-slider-tracks{background-color:#abe2fb;border-radius:6px;height:4px;position:absolute}.rc-slider-track-draggable{background-clip:content-box;border-bottom:5px solid #0000;border-top:5px solid #0000;box-sizing:initial;transform:translateY(-5px);z-index:1}.rc-slider-handle{background-color:#fff;border:2px solid #96dbfa;border-radius:50%;cursor:pointer;cursor:grab;height:14px;margin-top:-5px;opacity:.8;position:absolute;touch-action:pan-x;width:14px;z-index:1}.rc-slider-handle-dragging.rc-slider-handle-dragging.rc-slider-handle-dragging{border-color:#57c5f7;box-shadow:0 0 0 5px #96dbfa}.rc-slider-handle:focus{box-shadow:none;outline:none}.rc-slider-handle:focus-visible{border-color:#2db7f5;box-shadow:0 0 0 3px #96dbfa}.rc-slider-handle-click-focused:focus{border-color:#96dbfa;box-shadow:unset}.rc-slider-handle:hover{border-color:#57c5f7}.rc-slider-handle:active{border-color:#57c5f7;box-shadow:0 0 5px #57c5f7;cursor:grabbing}.rc-slider-mark{font-size:12px;left:0;position:absolute;top:18px;width:100%}.rc-slider-mark-text{color:#999;cursor:pointer;display:inline-block;position:absolute;text-align:center;vertical-align:middle}.rc-slider-mark-text-active{color:#666}.rc-slider-step{background:#0000;height:4px;position:absolute;width:100%}.rc-slider-dot{background-color:#fff;border:2px solid #e9e9e9;border-radius:50%;bottom:-2px;cursor:pointer;height:8px;position:absolute;vertical-align:middle;width:8px}.rc-slider-dot-active{border-color:#96dbfa}.rc-slider-dot-reverse{margin-right:-4px}.rc-slider-disabled{background-color:#e9e9e9}.rc-slider-disabled .rc-slider-track{background-color:#ccc}.rc-slider-disabled .rc-slider-dot,.rc-slider-disabled .rc-slider-handle{background-color:#fff;border-color:#ccc;box-shadow:none;cursor:not-allowed}.rc-slider-disabled .rc-slider-dot,.rc-slider-disabled .rc-slider-mark-text{cursor:not-allowed!important}.rc-slider-vertical{height:100%;padding:0 5px;width:14px}.rc-slider-vertical .rc-slider-rail{height:100%;width:4px}.rc-slider-vertical .rc-slider-track{bottom:0;left:5px;width:4px}.rc-slider-vertical .rc-slider-track-draggable{border-bottom:0;border-left:5px solid #0000;border-right:5px solid #0000;border-top:0;transform:translateX(-5px)}.rc-slider-vertical .rc-slider-handle{margin-left:-5px;margin-top:0;position:absolute;touch-action:pan-y;z-index:1}.rc-slider-vertical .rc-slider-mark{height:100%;left:18px;top:0}.rc-slider-vertical .rc-slider-step{height:100%;width:4px}.rc-slider-vertical .rc-slider-dot{margin-left:-2px}.rc-slider-tooltip-zoom-down-appear,.rc-slider-tooltip-zoom-down-enter,.rc-slider-tooltip-zoom-down-leave{animation-duration:.3s;animation-fill-mode:both;animation-play-state:paused;display:block!important}.rc-slider-tooltip-zoom-down-appear.rc-slider-tooltip-zoom-down-appear-active,.rc-slider-tooltip-zoom-down-enter.rc-slider-tooltip-zoom-down-enter-active{animation-name:rcSliderTooltipZoomDownIn;animation-play-state:running}.rc-slider-tooltip-zoom-down-leave.rc-slider-tooltip-zoom-down-leave-active{animation-name:rcSliderTooltipZoomDownOut;animation-play-state:running}.rc-slider-tooltip-zoom-down-appear,.rc-slider-tooltip-zoom-down-enter{animation-timing-function:cubic-bezier(.23,1,.32,1);transform:scale(0)}.rc-slider-tooltip-zoom-down-leave{animation-timing-function:cubic-bezier(.755,.05,.855,.06)}@keyframes rcSliderTooltipZoomDownIn{0%{opacity:0;transform:scale(0);transform-origin:50% 100%}to{transform:scale(1);transform-origin:50% 100%}}@keyframes rcSliderTooltipZoomDownOut{0%{transform:scale(1);transform-origin:50% 100%}to{opacity:0;transform:scale(0);transform-origin:50% 100%}}.rc-slider-tooltip{left:-9999px;position:absolute;top:-9999px;visibility:visible}.rc-slider-tooltip,.rc-slider-tooltip *{-webkit-tap-highlight-color:rgba(0,0,0,0);box-sizing:border-box}.rc-slider-tooltip-hidden{display:none}.rc-slider-tooltip-placement-top{padding:4px 0 8px}.rc-slider-tooltip-inner{background-color:#6c6c6c;border-radius:6px;box-shadow:0 0 4px #d9d9d9;color:#fff;font-size:12px;height:24px;line-height:1;min-width:24px;padding:6px 2px;text-align:center;text-decoration:none}.rc-slider-tooltip-arrow{border-color:#0000;border-style:solid;height:0;position:absolute;width:0}.rc-slider-tooltip-placement-top .rc-slider-tooltip-arrow{border-top-color:#6c6c6c;border-width:4px 4px 0;bottom:4px;left:50%;margin-left:-4px}";styleInject$1(css_248z$7$1,{"insertAt":"top"});/**
 * Constructor
 * @param {Number} minValue
 * @param {Number} maxValue
 */class LogScale{constructor(minValue,maxValue){this.minValue=minValue;this.maxValue=maxValue;}/**
   * Gets the range between the min and max values
   * @returns {Number}
   */getRange(){return this.maxValue-this.minValue;}/** 
   * Maps linear 0-1 point to logarithmic scale between min and max
   * f(0) = minValue
   * f(1) = maxValue
   * f(x) = (range + 1)^x + minValue
   * @param linearValue {Number} from 0 to 1 in linear scale
   * @returns {Number} between min and max inclusive
   */linearToLogarithmic(linearValue){var value=Math.round(Math.pow(this.getRange()+1,linearValue)+this.minValue-1);if(value<this.minValue){value=this.minValue;}else if(value>this.maxValue){value=this.maxValue;}return value;}logarithmicToLinear(value){var normalizedValue=value-this.minValue+1;if(normalizedValue<=0){return 0;}else if(value>=this.maxValue){return 1;}else {return Math.log(normalizedValue)/Math.log(this.getRange()+1);}}}var LogScale_1=LogScale;var logScale=new LogScale_1(0,1);const CanvasItemSize$1={base:{handleWidth:0,handleHeight:0,handleOuterWidth:0,handleOuterHeight:0,handleRadius:6,trackEndRadius:3,trackWidth:6}};function Track({dark,level,index,getVuLevel,onChange,type,size,...props}){const runAnimation=useRef(null);const vuLevel=useRef(0);const requestVuLevelHandler=()=>{const newValue=logScale.logarithmicToLinear(getVuLevel(index));if(newValue>=vuLevel.current){vuLevel.current=newValue;}else {// decay rather unprecisely
vuLevel.current=vuLevel.current*0.98;}if(runAnimation.current)requestAnimationFrame(requestVuLevelHandler);};useEffect(()=>{// console.log('starting animation frames');
runAnimation.current=true;requestAnimationFrame(requestVuLevelHandler);return ()=>{runAnimation.current=false;};},[]);const draw=ctx=>{const ratio=getPixelRatio(ctx);const{width,height}=ctx.canvas;const normalWidth=width/ratio;const normalHeight=height/ratio;const handleHeight=CanvasItemSize$1[size].handleHeight;const verticalOffset=CanvasItemSize$1[size].handleOuterHeight/2;const radius=CanvasItemSize$1[size].trackEndRadius;const trackWidth=CanvasItemSize$1[size].trackWidth;const sliderPosition=(normalHeight-handleHeight)*(1-level)+verticalOffset;const vuPosition=(normalHeight-handleHeight)*(1-vuLevel.current)+verticalOffset;let topBarOffset=0;if(vuLevel.current!==0.0){topBarOffset=radius;}ctx.clearRect(0,0,width,height);ctx.fillStyle=dark?"#16181b":"#1e293b";ctx.strokeStyle=dark?"#16181b":"#1e293b";ctx.lineWidth=trackWidth;ctx.lineCap="round";ctx.beginPath();ctx.moveTo(normalWidth/2,radius+verticalOffset);ctx.lineTo(normalWidth/2,vuPosition-radius+topBarOffset);ctx.stroke();if(vuLevel.current!==0){const gradient=ctx.createLinearGradient(normalWidth/2,sliderPosition+radius,normalWidth/2,normalHeight-radius-verticalOffset);gradient.addColorStop(1,"#22c55e");gradient.addColorStop(0.75,"#84cc16");gradient.addColorStop(0.5,"#eab308");gradient.addColorStop(0.25,"#f59e0b");gradient.addColorStop(0,"#ef4444");ctx.strokeStyle=gradient;ctx.beginPath();ctx.moveTo(normalWidth/2,vuPosition+radius);ctx.lineTo(normalWidth/2,normalHeight-radius-verticalOffset);ctx.stroke();}};return/*#__PURE__*/React__default.createElement("div",{className:"w-8 h-full relative flex justify-center"},/*#__PURE__*/React__default.createElement(Canvas,{draw:draw,className:"w-[8px] rounded h-full absolute"}),/*#__PURE__*/React__default.createElement(Slider$3,{vertical:true,trackStyle:{backgroundColor:'transparent'},handleStyle:{borderColor:'#59595b',height:40,width:28,marginLeft:1,marginTop:-9,borderRadius:8,backgroundColor:'white',outline:'none',borderWidth:3,opacity:1},railStyle:{width:30,backgroundColor:'transparent'},min:0,max:1,step:0.01,onChange:onChange,value:level}));}Track.propTypes={dark:PropTypes.bool,level:PropTypes.number,getVuLevel:PropTypes.func,onChange:PropTypes.func,type:PropTypes.oneOf(["default"]),// Would be better to use Object.keys but it won't work with Storybook currently
size:PropTypes.oneOf(["base"])};Track.defaultProps={dark:false,level:0.5,getVuLevel:undefined,onChange:undefined,type:"default",size:"base"};({leftLabel:PropTypes.string.isRequired,rightLabel:PropTypes.string.isRequired,level:PropTypes.number.isRequired,onChange:PropTypes.func,type:PropTypes.oneOf(["default"]),// Would be better to use Object.keys but it won't work with Storybook currently
size:PropTypes.oneOf(["base","sm"])});({level:PropTypes.number.isRequired,onChange:PropTypes.func,type:PropTypes.oneOf(["default"]),// Would be better to use Object.keys but it won't work with Storybook currently
size:PropTypes.oneOf(["base","sm"])});function _setPrototypeOf$2(o,p){_setPrototypeOf$2=Object.setPrototypeOf?Object.setPrototypeOf.bind():function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf$2(o,p);}function _inheritsLoose(subClass,superClass){subClass.prototype=Object.create(superClass.prototype);subClass.prototype.constructor=subClass;_setPrototypeOf$2(subClass,superClass);}function s$d(e){return e&&e.stopPropagation&&e.stopPropagation(),e&&e.preventDefault&&e.preventDefault(),!1;}function n$3$1(e){return null==e?[]:Array.isArray(e)?e.slice():[e];}function i$9(e){return null!==e&&1===e.length?e[0]:e.slice();}function o$a(e){Object.keys(e).forEach(t=>{"undefined"!=typeof document&&document.addEventListener(t,e[t],!1);});}function r$3$1(e,t){return a$a(function(e,t){let s=e;s<=t.min&&(s=t.min);s>=t.max&&(s=t.max);return s;}(e,t),t);}function a$a(e,t){const s=(e-t.min)%t.step;let n=e-s;return 2*Math.abs(s)>=t.step&&(n+=s>0?t.step:-t.step),parseFloat(n.toFixed(5));}let p$3$1=function(p){function u(e){var a;(a=p.call(this,e)||this).onKeyUp=()=>{a.onEnd();},a.onMouseUp=()=>{a.onEnd(a.getMouseEventMap());},a.onTouchEnd=e=>{e.preventDefault(),a.onEnd(a.getTouchEventMap());},a.onBlur=()=>{a.setState({index:-1},a.onEnd(a.getKeyDownEventMap()));},a.onMouseMove=e=>{a.setState({pending:!0});const t=a.getMousePosition(e),s=a.getDiffPosition(t[0]),n=a.getValueFromPosition(s);a.move(n);},a.onTouchMove=e=>{if(e.touches.length>1)return;a.setState({pending:!0});const t=a.getTouchPosition(e);if(void 0===a.isScrolling){const e=t[0]-a.startPosition[0],s=t[1]-a.startPosition[1];a.isScrolling=Math.abs(s)>Math.abs(e);}if(a.isScrolling)return void a.setState({index:-1});const s=a.getDiffPosition(t[0]),n=a.getValueFromPosition(s);a.move(n);},a.onKeyDown=e=>{if(!(e.ctrlKey||e.shiftKey||e.altKey||e.metaKey))switch(a.setState({pending:!0}),e.key){case"ArrowLeft":case"ArrowDown":case"Left":case"Down":e.preventDefault(),a.moveDownByStep();break;case"ArrowRight":case"ArrowUp":case"Right":case"Up":e.preventDefault(),a.moveUpByStep();break;case"Home":e.preventDefault(),a.move(a.props.min);break;case"End":e.preventDefault(),a.move(a.props.max);break;case"PageDown":e.preventDefault(),a.moveDownByStep(a.props.pageFn(a.props.step));break;case"PageUp":e.preventDefault(),a.moveUpByStep(a.props.pageFn(a.props.step));}},a.onSliderMouseDown=e=>{if(!a.props.disabled&&2!==e.button){if(a.setState({pending:!0}),!a.props.snapDragDisabled){const t=a.getMousePosition(e);a.forceValueFromPosition(t[0],e=>{a.start(e,t[0]),o$a(a.getMouseEventMap());});}s$d(e);}},a.onSliderClick=e=>{if(!a.props.disabled&&a.props.onSliderClick&&!a.hasMoved){const t=a.getMousePosition(e),s=r$3$1(a.calcValue(a.calcOffsetFromPosition(t[0])),a.props);a.props.onSliderClick(s);}},a.createOnKeyDown=e=>t=>{a.props.disabled||(a.start(e),o$a(a.getKeyDownEventMap()),s$d(t));},a.createOnMouseDown=e=>t=>{if(a.props.disabled||2===t.button)return;a.setState({pending:!0});const n=a.getMousePosition(t);a.start(e,n[0]),o$a(a.getMouseEventMap()),s$d(t);},a.createOnTouchStart=e=>t=>{if(a.props.disabled||t.touches.length>1)return;a.setState({pending:!0});const s=a.getTouchPosition(t);a.startPosition=s,a.isScrolling=void 0,a.start(e,s[0]),o$a(a.getTouchEventMap()),function(e){e.stopPropagation&&e.stopPropagation();}(t);},a.handleResize=()=>{const e=window.setTimeout(()=>{a.pendingResizeTimeouts.shift(),a.resize();},0);a.pendingResizeTimeouts.push(e);},a.renderThumb=(e,t)=>{const s=a.props.thumbClassName+" "+a.props.thumbClassName+"-"+t+" "+(a.state.index===t?a.props.thumbActiveClassName:""),n={ref:e=>{a["thumb"+t]=e;},key:a.props.thumbClassName+"-"+t,className:s,style:e,onMouseDown:a.createOnMouseDown(t),onTouchStart:a.createOnTouchStart(t),onFocus:a.createOnKeyDown(t),tabIndex:0,role:"slider","aria-orientation":a.props.orientation,"aria-valuenow":a.state.value[t],"aria-valuemin":a.props.min,"aria-valuemax":a.props.max,"aria-label":Array.isArray(a.props.ariaLabel)?a.props.ariaLabel[t]:a.props.ariaLabel,"aria-labelledby":Array.isArray(a.props.ariaLabelledby)?a.props.ariaLabelledby[t]:a.props.ariaLabelledby,"aria-disabled":a.props.disabled},o={index:t,value:i$9(a.state.value),valueNow:a.state.value[t]};return a.props.ariaValuetext&&(n["aria-valuetext"]="string"==typeof a.props.ariaValuetext?a.props.ariaValuetext:a.props.ariaValuetext(o)),a.props.renderThumb(n,o);},a.renderTrack=(e,t,s)=>{const n={key:a.props.trackClassName+"-"+e,className:a.props.trackClassName+" "+a.props.trackClassName+"-"+e,style:a.buildTrackStyle(t,a.state.upperBound-s)},o={index:e,value:i$9(a.state.value)};return a.props.renderTrack(n,o);};let u=n$3$1(e.value);u.length||(u=n$3$1(e.defaultValue)),a.pendingResizeTimeouts=[];const h=[];for(let t=0;t<u.length;t+=1)u[t]=r$3$1(u[t],e),h.push(t);return a.resizeObserver=null,a.resizeElementRef=/*#__PURE__*/React__default.createRef(),a.state={index:-1,upperBound:0,sliderLength:0,value:u,zIndices:h},a;}_inheritsLoose(u,p);var h=u.prototype;return h.componentDidMount=function(){"undefined"!=typeof window&&(this.resizeObserver=new ResizeObserver(this.handleResize),this.resizeObserver.observe(this.resizeElementRef.current),this.resize());},u.getDerivedStateFromProps=function(e,t){const s=n$3$1(e.value);return s.length?t.pending?null:{value:s.map(t=>r$3$1(t,e))}:null;},h.componentDidUpdate=function(){0===this.state.upperBound&&this.resize();},h.componentWillUnmount=function(){this.clearPendingResizeTimeouts(),this.resizeObserver&&this.resizeObserver.disconnect();},h.onEnd=function(e){e&&function(e){Object.keys(e).forEach(t=>{"undefined"!=typeof document&&document.removeEventListener(t,e[t],!1);});}(e),this.hasMoved&&this.fireChangeEvent("onAfterChange"),this.setState({pending:!1}),this.hasMoved=!1;},h.getValue=function(){return i$9(this.state.value);},h.getClosestIndex=function(e){let t=Number.MAX_VALUE,s=-1;const{value:n}=this.state,i=n.length;for(let o=0;o<i;o+=1){const i=this.calcOffset(n[o]),r=Math.abs(e-i);r<t&&(t=r,s=o);}return s;},h.getMousePosition=function(e){return [e["page"+this.axisKey()],e["page"+this.orthogonalAxisKey()]];},h.getTouchPosition=function(e){const t=e.touches[0];return [t["page"+this.axisKey()],t["page"+this.orthogonalAxisKey()]];},h.getKeyDownEventMap=function(){return {keydown:this.onKeyDown,keyup:this.onKeyUp,focusout:this.onBlur};},h.getMouseEventMap=function(){return {mousemove:this.onMouseMove,mouseup:this.onMouseUp};},h.getTouchEventMap=function(){return {touchmove:this.onTouchMove,touchend:this.onTouchEnd};},h.getValueFromPosition=function(e){const t=e/(this.state.sliderLength-this.state.thumbSize)*(this.props.max-this.props.min);return r$3$1(this.state.startValue+t,this.props);},h.getDiffPosition=function(e){let t=e-this.state.startPosition;return this.props.invert&&(t*=-1),t;},h.resize=function(){const{slider:e,thumb0:t}=this;if(!e||!t)return;const s=this.sizeKey(),n=e.getBoundingClientRect(),i=e[s],o=n[this.posMaxKey()],r=n[this.posMinKey()],a=t.getBoundingClientRect()[s.replace("client","").toLowerCase()],p=i-a,u=Math.abs(o-r);this.state.upperBound===p&&this.state.sliderLength===u&&this.state.thumbSize===a||this.setState({upperBound:p,sliderLength:u,thumbSize:a});},h.calcOffset=function(e){const t=this.props.max-this.props.min;if(0===t)return 0;return (e-this.props.min)/t*this.state.upperBound;},h.calcValue=function(e){return e/this.state.upperBound*(this.props.max-this.props.min)+this.props.min;},h.calcOffsetFromPosition=function(e){const{slider:t}=this,s=t.getBoundingClientRect(),n=s[this.posMaxKey()],i=s[this.posMinKey()];let o=e-(window["page"+this.axisKey()+"Offset"]+(this.props.invert?n:i));return this.props.invert&&(o=this.state.sliderLength-o),o-=this.state.thumbSize/2,o;},h.forceValueFromPosition=function(e,t){const s=this.calcOffsetFromPosition(e),n=this.getClosestIndex(s),i=r$3$1(this.calcValue(s),this.props),o=this.state.value.slice();o[n]=i;for(let e=0;e<o.length-1;e+=1)if(o[e+1]-o[e]<this.props.minDistance)return;this.fireChangeEvent("onBeforeChange"),this.hasMoved=!0,this.setState({value:o},()=>{t(n),this.fireChangeEvent("onChange");});},h.clearPendingResizeTimeouts=function(){do{const e=this.pendingResizeTimeouts.shift();clearTimeout(e);}while(this.pendingResizeTimeouts.length);},h.start=function(e,t){const s=this["thumb"+e];s&&s.focus();const{zIndices:n}=this.state;n.splice(n.indexOf(e),1),n.push(e),this.setState(s=>({startValue:s.value[e],startPosition:void 0!==t?t:s.startPosition,index:e,zIndices:n}));},h.moveUpByStep=function(e){void 0===e&&(e=this.props.step);const t=this.state.value[this.state.index],s=r$3$1(this.props.invert&&"horizontal"===this.props.orientation?t-e:t+e,this.props);this.move(Math.min(s,this.props.max));},h.moveDownByStep=function(e){void 0===e&&(e=this.props.step);const t=this.state.value[this.state.index],s=r$3$1(this.props.invert&&"horizontal"===this.props.orientation?t+e:t-e,this.props);this.move(Math.max(s,this.props.min));},h.move=function(e){const t=this.state.value.slice(),{index:s}=this.state,{length:n}=t,i=t[s];if(e===i)return;this.hasMoved||this.fireChangeEvent("onBeforeChange"),this.hasMoved=!0;const{pearling:o,max:r,min:a,minDistance:p}=this.props;if(!o){if(s>0){const n=t[s-1];e<n+p&&(e=n+p);}if(s<n-1){const n=t[s+1];e>n-p&&(e=n-p);}}t[s]=e,o&&n>1&&(e>i?(this.pushSucceeding(t,p,s),function(e,t,s,n){for(let i=0;i<e;i+=1){const o=n-i*s;t[e-1-i]>o&&(t[e-1-i]=o);}}(n,t,p,r)):e<i&&(this.pushPreceding(t,p,s),function(e,t,s,n){for(let i=0;i<e;i+=1){const e=n+i*s;t[i]<e&&(t[i]=e);}}(n,t,p,a))),this.setState({value:t},this.fireChangeEvent.bind(this,"onChange"));},h.pushSucceeding=function(e,t,s){let n,i;for(n=s,i=e[n]+t;null!==e[n+1]&&i>e[n+1];n+=1,i=e[n]+t)e[n+1]=a$a(i,this.props);},h.pushPreceding=function(e,t,s){for(let n=s,i=e[n]-t;null!==e[n-1]&&i<e[n-1];n-=1,i=e[n]-t)e[n-1]=a$a(i,this.props);},h.axisKey=function(){return "vertical"===this.props.orientation?"Y":"X";},h.orthogonalAxisKey=function(){return "vertical"===this.props.orientation?"X":"Y";},h.posMinKey=function(){return "vertical"===this.props.orientation?this.props.invert?"bottom":"top":this.props.invert?"right":"left";},h.posMaxKey=function(){return "vertical"===this.props.orientation?this.props.invert?"top":"bottom":this.props.invert?"left":"right";},h.sizeKey=function(){return "vertical"===this.props.orientation?"clientHeight":"clientWidth";},h.fireChangeEvent=function(e){this.props[e]&&this.props[e](i$9(this.state.value),this.state.index);},h.buildThumbStyle=function(e,t){const s={position:"absolute",touchAction:"none",willChange:this.state.index>=0?this.posMinKey():void 0,zIndex:this.state.zIndices.indexOf(t)+1};return s[this.posMinKey()]=e+"px",s;},h.buildTrackStyle=function(e,t){const s={position:"absolute",willChange:this.state.index>=0?this.posMinKey()+","+this.posMaxKey():void 0};return s[this.posMinKey()]=e,s[this.posMaxKey()]=t,s;},h.buildMarkStyle=function(e){var t;return (t={position:"absolute"})[this.posMinKey()]=e,t;},h.renderThumbs=function(e){const{length:t}=e,s=[];for(let n=0;n<t;n+=1)s[n]=this.buildThumbStyle(e[n],n);const n=[];for(let e=0;e<t;e+=1)n[e]=this.renderThumb(s[e],e);return n;},h.renderTracks=function(e){const t=[],s=e.length-1;t.push(this.renderTrack(0,0,e[0]));for(let n=0;n<s;n+=1)t.push(this.renderTrack(n+1,e[n],e[n+1]));return t.push(this.renderTrack(s+1,e[s],this.state.upperBound)),t;},h.renderMarks=function(){let{marks:e}=this.props;const t=this.props.max-this.props.min+1;return "boolean"==typeof e?e=Array.from({length:t}).map((e,t)=>t):"number"==typeof e&&(e=Array.from({length:t}).map((e,t)=>t).filter(t=>t%e==0)),e.map(parseFloat).sort((e,t)=>e-t).map(e=>{const t=this.calcOffset(e),s={key:e,className:this.props.markClassName,style:this.buildMarkStyle(t)};return this.props.renderMark(s);});},h.render=function(){const e=[],{value:s}=this.state,n=s.length;for(let t=0;t<n;t+=1)e[t]=this.calcOffset(s[t],t);const i=this.props.withTracks?this.renderTracks(e):null,o=this.renderThumbs(e),r=this.props.marks?this.renderMarks():null;return/*#__PURE__*/React__default.createElement("div",{ref:e=>{this.slider=e,this.resizeElementRef.current=e;},style:{position:"relative"},className:this.props.className+(this.props.disabled?" disabled":""),onMouseDown:this.onSliderMouseDown,onClick:this.onSliderClick},i,o,r);},u;}(React__default.Component);p$3$1.displayName="ReactSlider",p$3$1.defaultProps={min:0,max:100,step:1,pageFn:e=>10*e,minDistance:0,defaultValue:0,orientation:"horizontal",className:"slider",thumbClassName:"thumb",thumbActiveClassName:"active",trackClassName:"track",markClassName:"mark",withTracks:!0,pearling:!1,disabled:!1,snapDragDisabled:!1,invert:!1,marks:[],renderThumb:e=>/*#__PURE__*/React__default.createElement("div",e),renderTrack:e=>/*#__PURE__*/React__default.createElement("div",e),renderMark:e=>/*#__PURE__*/React__default.createElement("span",e)};var u$1$1=p$3$1;var css_248z$6$1=".horizontal-slider{height:50px;margin:20px 0;max-width:500px;min-width:200px;width:100%}.example-track{background:#ddd;height:10px;position:relative;top:20px}.example-thumb{background-color:#7101ff;border:5px solid #7101ff;border-radius:50%;box-sizing:border-box;color:#fff;cursor:pointer;font-size:.9em;height:48px;line-height:38px;text-align:center;top:1px;width:50px}";styleInject$1(css_248z$6$1,{"insertAt":"top"});const Stem=function Stem({stem,getVuLevel,onTrackChange,onPanChange,onReverbChange,onMuteStem,onSoloStem,onArmStem,onDeleteStem,type,size,...props}){const[showControls,setShowControls]=useState(false);const resetPan=()=>{onPanChange(0.5);};return/*#__PURE__*/React__default.createElement(React__default.Fragment,null,/*#__PURE__*/React__default.createElement(Modal,{isOpen:showControls,title:`${stem.label} pan`,onClose:()=>setShowControls(false),content:/*#__PURE__*/React__default.createElement("div",{className:"flex flex-col w-100"},/*#__PURE__*/React__default.createElement(u$1$1,{value:stem.pan,min:0,max:1,step:0.1,className:"horizontal-slider",thumbClassName:"example-thumb",trackClassName:"example-track",onChange:v=>onPanChange(v),renderThumb:(props,state)=>/*#__PURE__*/React__default.createElement("div",props)}),/*#__PURE__*/React__default.createElement(Button,{onClick:resetPan,type:"primary"},"Reset")),closeLabel:"Close"}),/*#__PURE__*/React__default.createElement("div",{className:`stem max-w-[200px] flex-1 flex flex-col items-center bg-secondary-50 ${stem.armed?'dark:bg-red-900':`${stem.isGuideChannel?'dark:bg-mute-900':'dark:bg-secondary-800'}`} border-[1px] border-secondary-700 rounded-md max-w-xs h-full px-2 py-2 select-none`},/*#__PURE__*/React__default.createElement("p",{className:"truncate text-center text-secondary-600 dark:text-secondary-300 bg-secondary-100 dark:bg-secondary-700 text-xs w-full p-1 mb-1 rounded"},stem.label),/*#__PURE__*/React__default.createElement("div",{className:"pan-control hidden lg:flex justify-around w-full mt-1"},/*#__PURE__*/React__default.createElement(KnobWithLabels,{leftLabel:"L",rightLabel:"R",level:stem.pan,onChange:onPanChange,size:"sm"})),/*#__PURE__*/React__default.createElement("div",{className:"lg:hidden mt-1"},/*#__PURE__*/React__default.createElement(Button,{type:"control",size:"sm",onClick:()=>setShowControls(true)},"Pan")),/*#__PURE__*/React__default.createElement("div",{className:"flex-1 my-6 dark:block"},/*#__PURE__*/React__default.createElement(Track,{dark:true,level:stem.level,index:stem.index,getVuLevel:getVuLevel,onChange:onTrackChange})),/*#__PURE__*/React__default.createElement("button",{onClick:onDeleteStem},/*#__PURE__*/React__default.createElement(TrashIcon$1,{className:`h-5 w-5 mb-3 text-white  ${stem.isInputChannel?'hover:text-error-500':'cursor-not-allowed opacity-20'}`})),/*#__PURE__*/React__default.createElement("div",{className:"stem-buttons flex flex-col items-center mt-0 space-y-2"},/*#__PURE__*/React__default.createElement(Button,{isOn:stem.muted,type:"muteControlButton",size:"sm",onClick:onMuteStem},"Mute"),/*#__PURE__*/React__default.createElement(Button,{isOn:stem.soloed,type:"soloControlButton",size:"sm",onClick:onSoloStem},"Solo"),stem.isInputChannel?/*#__PURE__*/React__default.createElement(Button,{isOn:stem.armed,type:"recordControlButton",size:"sm",onClick:onArmStem},"Arm"):/*#__PURE__*/React__default.createElement("div",{className:"h-[30px]"}))));};Stem.propTypes={stem:PropTypes.shape({label:PropTypes.string.isRequired,level:PropTypes.number.isRequired,vuLevel:PropTypes.number.isRequired,pan:PropTypes.number.isRequired,reverb:PropTypes.shape({displayValue:PropTypes.string.isRequired,value:PropTypes.number.isRequired}).isRequired,isInputChannel:PropTypes.bool.isRequired,isGuideChannel:PropTypes.bool.isRequired,muted:PropTypes.bool.isRequired,soloed:PropTypes.bool.isRequired,armed:PropTypes.bool.isRequired}),getVuLevel:PropTypes.func,onTrackChange:PropTypes.func,onPanChange:PropTypes.func,onReverbChange:PropTypes.func,onMuteStem:PropTypes.func,onArmStem:PropTypes.func,onSoloStem:PropTypes.func,type:PropTypes.oneOf(["default"]),// Would be better to use Object.keys but it won't work with Storybook currently
size:PropTypes.oneOf(["base"])};Stem.defaultProps={onTrackChange:undefined,onPanChange:undefined,onReverbChange:undefined,isInputChannel:false,isGuideChannel:false,record:true,muted:false,onMuteStem:undefined,onArmStem:undefined,soloed:false,onSoloStem:undefined,type:"default",size:"base"};const Overlay="absolute h-full w-full transition-opacity dark:bg-secondary-900 py-1 dark:text-primary rounded-md flex justify-center items-center";const OVERLAY_TIMEOUT_MS=1500;function ChannelToggleButton({level,step,onChangeLevel,icon,label}){const[levelVisible,setLevelVisible]=useState(false);const overlayTimer=useRef(null);const handleChangeLevel=()=>{if(typeof level==="number"){if(overlayTimer.current){clearTimeout(overlayTimer.current);overlayTimer.current=null;}setLevelVisible(true);if(level<1){onChangeLevel(level+step);}else {onChangeLevel(0);}overlayTimer.current=setTimeout(()=>setLevelVisible(false),OVERLAY_TIMEOUT_MS);}};return/*#__PURE__*/React__default.createElement(Button,{type:"secondaryFull",size:"sm",onClick:handleChangeLevel,disabled:typeof level!=="number"//   className={classNames(
//     "dark:bg-secondary-500 flex-1 dark:text-secondary-300 focus:outline-none focus:ring-none relative rounded-md",
//     typeof level !== "number" ? "opacity-20 cursor-not-allowed" : ""
//   )}
},/*#__PURE__*/React__default.createElement("div",{className:classNames$2(Overlay,levelVisible?"opacity-100":"opacity-0")},level*100,"%"),/*#__PURE__*/React__default.createElement("div",{className:classNames$2("",level>0?"dark:text-primary":"")},label));}ChannelToggleButton.propTypes={onChangeLevel:PropTypes.func};ChannelToggleButton.defaultProps={onChangeLevel:undefined};function ChannelControlButtons({step,introLevel,click1Level,click2Level,cueLevel,onChangeIntroLevel,onChangeClick1Level,onChangeClick2Level,onChangeCueLevel,...props}){return/*#__PURE__*/React__default.createElement("div",_extends$3({className:"w-auto flex justify-between space-x-2 px-4 py-4 text-xs focus:outline-none focus:ring-none"},props),/*#__PURE__*/React__default.createElement(ChannelToggleButton,{onChangeLevel:onChangeIntroLevel,level:introLevel,step:step,label:"INTRO"}),/*#__PURE__*/React__default.createElement(ChannelToggleButton,{onChangeLevel:onChangeClick1Level,level:click1Level,step:step,label:"CLICK1"}),/*#__PURE__*/React__default.createElement(ChannelToggleButton,{onChangeLevel:onChangeClick2Level,level:click2Level,step:step,label:"CLICK2"}),/*#__PURE__*/React__default.createElement(ChannelToggleButton,{onChangeLevel:onChangeCueLevel,level:cueLevel,step:step,label:"CUE"}));}ChannelControlButtons.propTypes={onChangeIntroLevel:PropTypes.func,onChangeClick1Level:PropTypes.func,onChangeClick2Level:PropTypes.func,onChangeCueLevel:PropTypes.func,step:PropTypes.number,introLevel:PropTypes.number,click1Level:PropTypes.number,click2Level:PropTypes.number};ChannelControlButtons.defaultProps={onChangeIntroLevel:undefined,onChangeClick1Level:undefined,onChangeClick2Level:undefined,onChangeCueLevel:undefined,step:0.5,introLevel:0.5,click1Level:0,click2Level:0.5,cueLevel:null};function AddNewStemButton({onAddStem,...props}){return/*#__PURE__*/React__default.createElement(React__default.Fragment,null,/*#__PURE__*/React__default.createElement("button",{onClick:onAddStem,className:`max-w-[120px] flex-1 flex flex-col items-center bg-secondary-50 dark:bg-secondary-900 border-[2px] border-dashed dark:hover:text-white cursor-pointer dark:hover:border-primary dark:text-secondary-400 border-secondary-700 rounded-md h-full px-2 py-2 select-none justify-center text-center`},/*#__PURE__*/React__default.createElement("div",null,/*#__PURE__*/React__default.createElement(PlusCircleIcon$1,{className:"h-12 w-12 mb-4"})),/*#__PURE__*/React__default.createElement("span",{className:"text-sm"},"Add new track ")));}AddNewStemButton.propTypes={onClick:PropTypes.func};AddNewStemButton.defaultProps={onClick:undefined};// let level = 0.0046388134360313416;
let level$1=0;setInterval(()=>{if(level$1!==0.8){// level = level + 0.001;
level$1=0.8;}else {level$1=0;}},2000);function MixBoard({stems,getVuLevel,onFaderChange,onPanChange,onMuteStem,onSoloStem,onArmStem,onDeleteStem,onShare,onAddStem,onDownload,onReset,type,size,onChangeIntroLevel,onChangeClick1Level,onChangeClick2Level,onChangeCueLevel,levelStep,introLevel,click1Level,click2Level,cueLevel,showGuideChannelButtons,showMixControls,mixerTemplate,...props}){const stemComponents=stems.map(stem=>{return/*#__PURE__*/React__default.createElement(Stem,{stem:stem,getVuLevel:getVuLevel,onTrackChange:value=>onFaderChange(stem.id,value),onPanChange:value=>onPanChange(stem.id,value),onMuteStem:value=>onMuteStem(stem.id,value),onSoloStem:value=>onSoloStem(stem.id,value),onArmStem:value=>onArmStem(stem.id,value),onDeleteStem:value=>onDeleteStem(stem.id,value)});});const renderMixer=()=>{switch(mixerTemplate){case"band":return renderStudio();case"choir":return renderChoir();default:return/*#__PURE__*/React__default.createElement("div",null,"Not mixer template supplied");}};const renderStudio=()=>{return/*#__PURE__*/React__default.createElement("div",{style:{touchAction:"pan-y pan-x"},className:"h-full w-auto flex-1 flex flex-row overflow-x-auto space-x-2 lg:space-x-4 py-4 mx-4 mb-4"},stemComponents,/*#__PURE__*/React__default.createElement(AddNewStemButton,{id:"session-buttons-add-stem",onAddStem:onAddStem}));};const renderChoir=()=>{return/*#__PURE__*/React__default.createElement("div",null,"Choir mixer goes here");};return/*#__PURE__*/React__default.createElement(React__default.Fragment,null,showMixControls&&/*#__PURE__*/React__default.createElement("div",{className:"hidden lg:flex justify-end w-full px-4"},/*#__PURE__*/React__default.createElement("div",{id:"session-buttons",className:"flex flex-1 w-full justify-between space-x-4 lg:space-x-8 pt-4"},/*#__PURE__*/React__default.createElement(Button,{id:"session-buttons-add-track",type:"secondaryFull",size:"sm",onClick:onAddStem},/*#__PURE__*/React__default.createElement(PlusCircleIcon$1,{className:"w-4 h-4 mr-1"})," Add track"),/*#__PURE__*/React__default.createElement(Button,{id:"session-buttons-download-mix",type:"secondaryFull",size:"sm",onClick:onDownload},/*#__PURE__*/React__default.createElement(ArrowDownTrayIcon$1,{className:"w-4 h-4 mr-1"})," Download mix"),/*#__PURE__*/React__default.createElement(Button,{id:"session-buttons-share-mix",type:"secondaryFull",size:"sm",onClick:onShare},/*#__PURE__*/React__default.createElement(ShareIcon$1,{className:"w-4 h-4 mr-1"})," Share mix"),/*#__PURE__*/React__default.createElement(Button,{id:"session-buttons-reset-mix",type:"secondaryFull",size:"sm",onClick:onReset},/*#__PURE__*/React__default.createElement(ArrowPathIcon$1,{className:"w-4 h-4 mr-1"})," Reset mix"))),renderMixer(),showGuideChannelButtons&&/*#__PURE__*/React__default.createElement(ChannelControlButtons,{onChangeIntroLevel:onChangeIntroLevel,onChangeClick1Level:onChangeClick1Level,onChangeClick2Level:onChangeClick2Level,onChangeCueLevel:onChangeCueLevel,step:levelStep,introLevel:introLevel,click1Level:click1Level,click2Level:click2Level,cueLevel:cueLevel}));}MixBoard.propTypes={stems:PropTypes.arrayOf(PropTypes.shape({id:PropTypes.string.isRequired,label:PropTypes.string.isRequired,level:PropTypes.number.isRequired,vuLevel:PropTypes.number.isRequired,pan:PropTypes.number.isRequired,muted:PropTypes.bool.isRequired,soloed:PropTypes.bool.isRequired})).isRequired,getVuLevel:PropTypes.func,onFaderChange:PropTypes.func,onPanChange:PropTypes.func,onMuteStem:PropTypes.func,onSoloStem:PropTypes.func,onArmStem:PropTypes.func,onShare:PropTypes.func,onAddStem:PropTypes.func,onDownload:PropTypes.func,onReset:PropTypes.func,type:PropTypes.oneOf(["default"]),// Would be better to use Object.keys but it won't work with Storybook currently
size:PropTypes.oneOf(["base"]),showGuideChannelButtons:PropTypes.bool,showMixControls:PropTypes.bool,mixerTemplate:PropTypes.oneOf(["band","choir"])};MixBoard.defaultProps={getVuLevel:index=>level$1,onFaderChange:undefined,onPanChange:undefined,onMuteStem:undefined,onSoloStem:undefined,onArmStem:undefined,onShare:undefined,onAddStem:undefined,onDownload:undefined,onReset:undefined,type:"default",size:"base",onChangeIntroLevel:undefined,onChangeClick1Level:undefined,onChangeClick2Level:undefined,onChangeCueLeveled:undefined,levelStep:0.25,introLevel:0,click1Level:0,click2Level:0,cueLevel:null,showGuideChannelButtons:false,showMixControls:true,mixerTemplate:"band"};function Notification({title,text,type,size,...props}){return/*#__PURE__*/React__default.createElement(React__default.Fragment,null,/*#__PURE__*/React__default.createElement("div",{"aria-live":"assertive",className:"fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start z-20"},/*#__PURE__*/React__default.createElement("div",{className:"w-full flex flex-col items-center space-y-4 sm:items-end"},/*#__PURE__*/React__default.createElement(qe$4,{show:!!text,as:Fragment,enter:"transform ease-out duration-300 transition",enterFrom:"translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2",enterTo:"translate-y-0 opacity-100 sm:translate-x-0",leave:"transition ease-in duration-100",leaveFrom:"opacity-100",leaveTo:"opacity-0"},/*#__PURE__*/React__default.createElement("div",{className:"max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden"},/*#__PURE__*/React__default.createElement("div",{className:"p-4"},/*#__PURE__*/React__default.createElement("div",{className:"flex items-start"},/*#__PURE__*/React__default.createElement("div",{className:"flex-shrink-0"},type==='positive'&&/*#__PURE__*/React__default.createElement(CheckCircleIcon$1,{className:"h-6 w-6 text-green-400","aria-hidden":"true"}),type==='negative'&&/*#__PURE__*/React__default.createElement(ExclamationCircleIcon$1$1,{className:"h-6 w-6 text-red-400","aria-hidden":"true"})),/*#__PURE__*/React__default.createElement("div",{className:"ml-3 w-0 flex-1 pt-0.5"},title&&/*#__PURE__*/React__default.createElement("p",{className:"text-sm font-medium text-gray-900"},title),text&&/*#__PURE__*/React__default.createElement("p",{className:"mt-1 text-sm text-gray-500"},text)))))))));}Notification.propTypes={title:PropTypes.string,text:PropTypes.string,type:PropTypes.oneOf(["positive","negative"])};Notification.defaultProps={// alertType: "positive",
// onDismiss: undefined,
// type: "default",
// size: "base",
};({dark:PropTypes.bool,isLooping:PropTypes.bool,getCurrentPosition:PropTypes.func.isRequired,song:PropTypes.shape({length:PropTypes.number.isRequired,sections:PropTypes.arrayOf(PropTypes.shape({label:PropTypes.string.isRequired,start:PropTypes.number.isRequired,end:PropTypes.number.isRequired}))}),onSectionSelected:PropTypes.func,onPositionChange:PropTypes.func,type:PropTypes.oneOf(["default"]),// Would be better to use Object.keys but it won't work with Storybook currently
size:PropTypes.oneOf(["base"]),labelColour:PropTypes.string,progressColour:PropTypes.string,trackColour:PropTypes.string,activeSectionColour:PropTypes.string,loopSectionColour:PropTypes.string});/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */function formatMuiErrorMessage$1(code){// Apply babel-plugin-transform-template-literals in loose mode
// loose mode is safe if we're concatenating primitives
// see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
/* eslint-disable prefer-template */let url='https://mui.com/production-error/?code='+code;for(let i=1;i<arguments.length;i+=1){// rest params over-transpile for this case
// eslint-disable-next-line prefer-rest-params
url+='&args[]='+encodeURIComponent(arguments[i]);}return 'Minified MUI error #'+code+'; visit '+url+' for the full message.';/* eslint-enable prefer-template */}var formatMuiErrorMessage=/*#__PURE__*/Object.freeze({__proto__:null,'default':formatMuiErrorMessage$1});function memoize$1(fn){var cache=Object.create(null);return function(arg){if(cache[arg]===undefined)cache[arg]=fn(arg);return cache[arg];};}var reactPropsRegex$1=/^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/;// https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var isPropValid$1=/* #__PURE__ */memoize$1(function(prop){return reactPropsRegex$1.test(prop)||prop.charCodeAt(0)===111/* o */&&prop.charCodeAt(1)===110/* n */&&prop.charCodeAt(2)<91;}/* Z+1 */);/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function sheetForTag$1(tag){if(tag.sheet){// $FlowFixMe
return tag.sheet;}// this weirdness brought to you by firefox
/* istanbul ignore next */for(var i=0;i<document.styleSheets.length;i++){if(document.styleSheets[i].ownerNode===tag){// $FlowFixMe
return document.styleSheets[i];}}}function createStyleElement$1(options){var tag=document.createElement('style');tag.setAttribute('data-emotion',options.key);if(options.nonce!==undefined){tag.setAttribute('nonce',options.nonce);}tag.appendChild(document.createTextNode(''));tag.setAttribute('data-s','');return tag;}var StyleSheet$1=/*#__PURE__*/function(){// Using Node instead of HTMLElement since container may be a ShadowRoot
function StyleSheet(options){var _this=this;this._insertTag=function(tag){var before;if(_this.tags.length===0){if(_this.insertionPoint){before=_this.insertionPoint.nextSibling;}else if(_this.prepend){before=_this.container.firstChild;}else {before=_this.before;}}else {before=_this.tags[_this.tags.length-1].nextSibling;}_this.container.insertBefore(tag,before);_this.tags.push(tag);};this.isSpeedy=options.speedy===undefined?process.env.NODE_ENV==='production':options.speedy;this.tags=[];this.ctr=0;this.nonce=options.nonce;// key is the value of the data-emotion attribute, it's used to identify different sheets
this.key=options.key;this.container=options.container;this.prepend=options.prepend;this.insertionPoint=options.insertionPoint;this.before=null;}var _proto=StyleSheet.prototype;_proto.hydrate=function hydrate(nodes){nodes.forEach(this._insertTag);};_proto.insert=function insert(rule){// the max length is how many rules we have per style tag, it's 65000 in speedy mode
// it's 1 in dev because we insert source maps that map a single rule to a location
// and you can only have one source map per style tag
if(this.ctr%(this.isSpeedy?65000:1)===0){this._insertTag(createStyleElement$1(this));}var tag=this.tags[this.tags.length-1];if(process.env.NODE_ENV!=='production'){var isImportRule=rule.charCodeAt(0)===64&&rule.charCodeAt(1)===105;if(isImportRule&&this._alreadyInsertedOrderInsensitiveRule){// this would only cause problem in speedy mode
// but we don't want enabling speedy to affect the observable behavior
// so we report this error at all times
console.error("You're attempting to insert the following rule:\n"+rule+'\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules.');}this._alreadyInsertedOrderInsensitiveRule=this._alreadyInsertedOrderInsensitiveRule||!isImportRule;}if(this.isSpeedy){var sheet=sheetForTag$1(tag);try{// this is the ultrafast version, works across browsers
// the big drawback is that the css won't be editable in devtools
sheet.insertRule(rule,sheet.cssRules.length);}catch(e){if(process.env.NODE_ENV!=='production'&&!/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(rule)){console.error("There was a problem inserting the following rule: \""+rule+"\"",e);}}}else {tag.appendChild(document.createTextNode(rule));}this.ctr++;};_proto.flush=function flush(){// $FlowFixMe
this.tags.forEach(function(tag){return tag.parentNode&&tag.parentNode.removeChild(tag);});this.tags=[];this.ctr=0;if(process.env.NODE_ENV!=='production'){this._alreadyInsertedOrderInsensitiveRule=false;}};return StyleSheet;}();var MS$1='-ms-';var MOZ$1='-moz-';var WEBKIT$1='-webkit-';var COMMENT$1='comm';var RULESET$1='rule';var DECLARATION$1='decl';var IMPORT$1='@import';var KEYFRAMES$1='@keyframes';var LAYER$1='@layer';/**
 * @param {number}
 * @return {number}
 */var abs$1=Math.abs;/**
 * @param {number}
 * @return {string}
 */var from$1=String.fromCharCode;/**
 * @param {object}
 * @return {object}
 */var assign$4=Object.assign;/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */function hash$2(value,length){return charat$1(value,0)^45?(((length<<2^charat$1(value,0))<<2^charat$1(value,1))<<2^charat$1(value,2))<<2^charat$1(value,3):0;}/**
 * @param {string} value
 * @return {string}
 */function trim$1(value){return value.trim();}/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */function match$2(value,pattern){return (value=pattern.exec(value))?value[0]:value;}/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */function replace$1(value,pattern,replacement){return value.replace(pattern,replacement);}/**
 * @param {string} value
 * @param {string} search
 * @return {number}
 */function indexof$1(value,search){return value.indexOf(search);}/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */function charat$1(value,index){return value.charCodeAt(index)|0;}/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */function substr$1(value,begin,end){return value.slice(begin,end);}/**
 * @param {string} value
 * @return {number}
 */function strlen$1(value){return value.length;}/**
 * @param {any[]} value
 * @return {number}
 */function sizeof$1(value){return value.length;}/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */function append$2(value,array){return array.push(value),value;}/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */function combine$1(array,callback){return array.map(callback).join('');}var line$1=1;var column$1=1;var length$1=0;var position$1=0;var character$1=0;var characters$1='';/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {number} length
 */function node$1(value,root,parent,type,props,children,length){return {value:value,root:root,parent:parent,type:type,props:props,children:children,line:line$1,column:column$1,length:length,return:''};}/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */function copy$1(root,props){return assign$4(node$1('',null,null,'',null,null,0),root,{length:-root.length},props);}/**
 * @return {number}
 */function char$1(){return character$1;}/**
 * @return {number}
 */function prev$1(){character$1=position$1>0?charat$1(characters$1,--position$1):0;if(column$1--,character$1===10)column$1=1,line$1--;return character$1;}/**
 * @return {number}
 */function next$1(){character$1=position$1<length$1?charat$1(characters$1,position$1++):0;if(column$1++,character$1===10)column$1=1,line$1++;return character$1;}/**
 * @return {number}
 */function peek$1(){return charat$1(characters$1,position$1);}/**
 * @return {number}
 */function caret$1(){return position$1;}/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */function slice$2(begin,end){return substr$1(characters$1,begin,end);}/**
 * @param {number} type
 * @return {number}
 */function token$1(type){switch(type){// \0 \t \n \r \s whitespace token
case 0:case 9:case 10:case 13:case 32:return 5;// ! + , / > @ ~ isolate token
case 33:case 43:case 44:case 47:case 62:case 64:case 126:// ; { } breakpoint token
case 59:case 123:case 125:return 4;// : accompanied token
case 58:return 3;// " ' ( [ opening delimit token
case 34:case 39:case 40:case 91:return 2;// ) ] closing delimit token
case 41:case 93:return 1;}return 0;}/**
 * @param {string} value
 * @return {any[]}
 */function alloc$1(value){return line$1=column$1=1,length$1=strlen$1(characters$1=value),position$1=0,[];}/**
 * @param {any} value
 * @return {any}
 */function dealloc$1(value){return characters$1='',value;}/**
 * @param {number} type
 * @return {string}
 */function delimit$1(type){return trim$1(slice$2(position$1-1,delimiter$1(type===91?type+2:type===40?type+1:type)));}/**
 * @param {number} type
 * @return {string}
 */function whitespace$1(type){while(character$1=peek$1())if(character$1<33)next$1();else break;return token$1(type)>2||token$1(character$1)>3?'':' ';}/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */function escaping$1(index,count){while(--count&&next$1())// not 0-9 A-F a-f
if(character$1<48||character$1>102||character$1>57&&character$1<65||character$1>70&&character$1<97)break;return slice$2(index,caret$1()+(count<6&&peek$1()==32&&next$1()==32));}/**
 * @param {number} type
 * @return {number}
 */function delimiter$1(type){while(next$1())switch(character$1){// ] ) " '
case type:return position$1;// " '
case 34:case 39:if(type!==34&&type!==39)delimiter$1(character$1);break;// (
case 40:if(type===41)delimiter$1(type);break;// \
case 92:next$1();break;}return position$1;}/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */function commenter$1(type,index){while(next$1())// //
if(type+character$1===47+10)break;// /*
else if(type+character$1===42+42&&peek$1()===47)break;return '/*'+slice$2(index,position$1-1)+'*'+from$1(type===47?type:next$1());}/**
 * @param {number} index
 * @return {string}
 */function identifier$1(index){while(!token$1(peek$1()))next$1();return slice$2(index,position$1);}/**
 * @param {string} value
 * @return {object[]}
 */function compile$1(value){return dealloc$1(parse$2('',null,null,null,[''],value=alloc$1(value),0,[0],value));}/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */function parse$2(value,root,parent,rule,rules,rulesets,pseudo,points,declarations){var index=0;var offset=0;var length=pseudo;var atrule=0;var property=0;var previous=0;var variable=1;var scanning=1;var ampersand=1;var character=0;var type='';var props=rules;var children=rulesets;var reference=rule;var characters=type;while(scanning)switch(previous=character,character=next$1()){// (
case 40:if(previous!=108&&charat$1(characters,length-1)==58){if(indexof$1(characters+=replace$1(delimit$1(character),'&','&\f'),'&\f')!=-1)ampersand=-1;break;}// " ' [
case 34:case 39:case 91:characters+=delimit$1(character);break;// \t \n \r \s
case 9:case 10:case 13:case 32:characters+=whitespace$1(previous);break;// \
case 92:characters+=escaping$1(caret$1()-1,7);continue;// /
case 47:switch(peek$1()){case 42:case 47:append$2(comment$1(commenter$1(next$1(),caret$1()),root,parent),declarations);break;default:characters+='/';}break;// {
case 123*variable:points[index++]=strlen$1(characters)*ampersand;// } ; \0
case 125*variable:case 59:case 0:switch(character){// \0 }
case 0:case 125:scanning=0;// ;
case 59+offset:if(ampersand==-1)characters=replace$1(characters,/\f/g,'');if(property>0&&strlen$1(characters)-length)append$2(property>32?declaration$1(characters+';',rule,parent,length-1):declaration$1(replace$1(characters,' ','')+';',rule,parent,length-2),declarations);break;// @ ;
case 59:characters+=';';// { rule/at-rule
default:append$2(reference=ruleset$1(characters,root,parent,index,offset,rules,points,type,props=[],children=[],length),rulesets);if(character===123)if(offset===0)parse$2(characters,root,reference,reference,props,rulesets,length,points,children);else switch(atrule===99&&charat$1(characters,3)===110?100:atrule){// d l m s
case 100:case 108:case 109:case 115:parse$2(value,reference,reference,rule&&append$2(ruleset$1(value,reference,reference,0,0,rules,points,type,rules,props=[],length),children),rules,children,length,points,rule?props:children);break;default:parse$2(characters,reference,reference,reference,[''],children,0,points,children);}}index=offset=property=0,variable=ampersand=1,type=characters='',length=pseudo;break;// :
case 58:length=1+strlen$1(characters),property=previous;default:if(variable<1)if(character==123)--variable;else if(character==125&&variable++==0&&prev$1()==125)continue;switch(characters+=from$1(character),character*variable){// &
case 38:ampersand=offset>0?1:(characters+='\f',-1);break;// ,
case 44:points[index++]=(strlen$1(characters)-1)*ampersand,ampersand=1;break;// @
case 64:// -
if(peek$1()===45)characters+=delimit$1(next$1());atrule=peek$1(),offset=length=strlen$1(type=characters+=identifier$1(caret$1())),character++;break;// -
case 45:if(previous===45&&strlen$1(characters)==2)variable=0;}}return rulesets;}/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @return {object}
 */function ruleset$1(value,root,parent,index,offset,rules,points,type,props,children,length){var post=offset-1;var rule=offset===0?rules:[''];var size=sizeof$1(rule);for(var i=0,j=0,k=0;i<index;++i)for(var x=0,y=substr$1(value,post+1,post=abs$1(j=points[i])),z=value;x<size;++x)if(z=trim$1(j>0?rule[x]+' '+y:replace$1(y,/&\f/g,rule[x])))props[k++]=z;return node$1(value,root,parent,offset===0?RULESET$1:type,props,children,length);}/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @return {object}
 */function comment$1(value,root,parent){return node$1(value,root,parent,COMMENT$1,from$1(char$1()),substr$1(value,2,-2),0);}/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @return {object}
 */function declaration$1(value,root,parent,length){return node$1(value,root,parent,DECLARATION$1,substr$1(value,0,length),substr$1(value,length+1,-1),length);}/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */function serialize$1(children,callback){var output='';var length=sizeof$1(children);for(var i=0;i<length;i++)output+=callback(children[i],i,children,callback)||'';return output;}/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */function stringify$1(element,index,children,callback){switch(element.type){case LAYER$1:if(element.children.length)break;case IMPORT$1:case DECLARATION$1:return element.return=element.return||element.value;case COMMENT$1:return '';case KEYFRAMES$1:return element.return=element.value+'{'+serialize$1(element.children,callback)+'}';case RULESET$1:element.value=element.props.join(',');}return strlen$1(children=serialize$1(element.children,callback))?element.return=element.value+'{'+children+'}':'';}/**
 * @param {function[]} collection
 * @return {function}
 */function middleware$1(collection){var length=sizeof$1(collection);return function(element,index,children,callback){var output='';for(var i=0;i<length;i++)output+=collection[i](element,index,children,callback)||'';return output;};}/**
 * @param {function} callback
 * @return {function}
 */function rulesheet$1(callback){return function(element){if(!element.root)if(element=element.return)callback(element);};}var weakMemoize$1=function weakMemoize(func){// $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
var cache=new WeakMap();return function(arg){if(cache.has(arg)){// $FlowFixMe
return cache.get(arg);}var ret=func(arg);cache.set(arg,ret);return ret;};};var identifierWithPointTracking$1=function identifierWithPointTracking(begin,points,index){var previous=0;var character=0;while(true){previous=character;character=peek$1();// &\f
if(previous===38&&character===12){points[index]=1;}if(token$1(character)){break;}next$1();}return slice$2(begin,position$1);};var toRules$1=function toRules(parsed,points){// pretend we've started with a comma
var index=-1;var character=44;do{switch(token$1(character)){case 0:// &\f
if(character===38&&peek$1()===12){// this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
// stylis inserts \f after & to know when & where it should replace this sequence with the context selector
// and when it should just concatenate the outer and inner selectors
// it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
points[index]=1;}parsed[index]+=identifierWithPointTracking$1(position$1-1,points,index);break;case 2:parsed[index]+=delimit$1(character);break;case 4:// comma
if(character===44){// colon
parsed[++index]=peek$1()===58?'&\f':'';points[index]=parsed[index].length;break;}// fallthrough
default:parsed[index]+=from$1(character);}}while(character=next$1());return parsed;};var getRules$1=function getRules(value,points){return dealloc$1(toRules$1(alloc$1(value),points));};// WeakSet would be more appropriate, but only WeakMap is supported in IE11
var fixedElements$1=/* #__PURE__ */new WeakMap();var compat$1=function compat(element){if(element.type!=='rule'||!element.parent||// positive .length indicates that this rule contains pseudo
// negative .length indicates that this rule has been already prefixed
element.length<1){return;}var value=element.value,parent=element.parent;var isImplicitRule=element.column===parent.column&&element.line===parent.line;while(parent.type!=='rule'){parent=parent.parent;if(!parent)return;}// short-circuit for the simplest case
if(element.props.length===1&&value.charCodeAt(0)!==58/* colon */&&!fixedElements$1.get(parent)){return;}// if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
// then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
if(isImplicitRule){return;}fixedElements$1.set(element,true);var points=[];var rules=getRules$1(value,points);var parentRules=parent.props;for(var i=0,k=0;i<rules.length;i++){for(var j=0;j<parentRules.length;j++,k++){element.props[k]=points[i]?rules[i].replace(/&\f/g,parentRules[j]):parentRules[j]+" "+rules[i];}}};var removeLabel$1=function removeLabel(element){if(element.type==='decl'){var value=element.value;if(// charcode for l
value.charCodeAt(0)===108&&// charcode for b
value.charCodeAt(2)===98){// this ignores label
element["return"]='';element.value='';}}};var ignoreFlag='emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';var isIgnoringComment=function isIgnoringComment(element){return element.type==='comm'&&element.children.indexOf(ignoreFlag)>-1;};var createUnsafeSelectorsAlarm=function createUnsafeSelectorsAlarm(cache){return function(element,index,children){if(element.type!=='rule'||cache.compat)return;var unsafePseudoClasses=element.value.match(/(:first|:nth|:nth-last)-child/g);if(unsafePseudoClasses){var isNested=!!element.parent;// in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
//
// considering this input:
// .a {
//   .b /* comm */ {}
//   color: hotpink;
// }
// we get output corresponding to this:
// .a {
//   & {
//     /* comm */
//     color: hotpink;
//   }
//   .b {}
// }
var commentContainer=isNested?element.parent.children:// global rule at the root level
children;for(var i=commentContainer.length-1;i>=0;i--){var node=commentContainer[i];if(node.line<element.line){break;}// it is quite weird but comments are *usually* put at `column: element.column - 1`
// so we seek *from the end* for the node that is earlier than the rule's `element` and check that
// this will also match inputs like this:
// .a {
//   /* comm */
//   .b {}
// }
//
// but that is fine
//
// it would be the easiest to change the placement of the comment to be the first child of the rule:
// .a {
//   .b { /* comm */ }
// }
// with such inputs we wouldn't have to search for the comment at all
// TODO: consider changing this comment placement in the next major version
if(node.column<element.column){if(isIgnoringComment(node)){return;}break;}}unsafePseudoClasses.forEach(function(unsafePseudoClass){console.error("The pseudo class \""+unsafePseudoClass+"\" is potentially unsafe when doing server-side rendering. Try changing it to \""+unsafePseudoClass.split('-child')[0]+"-of-type\".");});}};};var isImportRule=function isImportRule(element){return element.type.charCodeAt(1)===105&&element.type.charCodeAt(0)===64;};var isPrependedWithRegularRules=function isPrependedWithRegularRules(index,children){for(var i=index-1;i>=0;i--){if(!isImportRule(children[i])){return true;}}return false;};// use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var nullifyElement=function nullifyElement(element){element.type='';element.value='';element["return"]='';element.children='';element.props='';};var incorrectImportAlarm=function incorrectImportAlarm(element,index,children){if(!isImportRule(element)){return;}if(element.parent){console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");nullifyElement(element);}else if(isPrependedWithRegularRules(index,children)){console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");nullifyElement(element);}};/* eslint-disable no-fallthrough */function prefix$1(value,length){switch(hash$2(value,length)){// color-adjust
case 5103:return WEBKIT$1+'print-'+value+value;// animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
case 5737:case 4201:case 3177:case 3433:case 1641:case 4457:case 2921:// text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
case 5572:case 6356:case 5844:case 3191:case 6645:case 3005:// mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
case 6391:case 5879:case 5623:case 6135:case 4599:case 4855:// background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
case 4215:case 6389:case 5109:case 5365:case 5621:case 3829:return WEBKIT$1+value+value;// appearance, user-select, transform, hyphens, text-size-adjust
case 5349:case 4246:case 4810:case 6968:case 2756:return WEBKIT$1+value+MOZ$1+value+MS$1+value+value;// flex, flex-direction
case 6828:case 4268:return WEBKIT$1+value+MS$1+value+value;// order
case 6165:return WEBKIT$1+value+MS$1+'flex-'+value+value;// align-items
case 5187:return WEBKIT$1+value+replace$1(value,/(\w+).+(:[^]+)/,WEBKIT$1+'box-$1$2'+MS$1+'flex-$1$2')+value;// align-self
case 5443:return WEBKIT$1+value+MS$1+'flex-item-'+replace$1(value,/flex-|-self/,'')+value;// align-content
case 4675:return WEBKIT$1+value+MS$1+'flex-line-pack'+replace$1(value,/align-content|flex-|-self/,'')+value;// flex-shrink
case 5548:return WEBKIT$1+value+MS$1+replace$1(value,'shrink','negative')+value;// flex-basis
case 5292:return WEBKIT$1+value+MS$1+replace$1(value,'basis','preferred-size')+value;// flex-grow
case 6060:return WEBKIT$1+'box-'+replace$1(value,'-grow','')+WEBKIT$1+value+MS$1+replace$1(value,'grow','positive')+value;// transition
case 4554:return WEBKIT$1+replace$1(value,/([^-])(transform)/g,'$1'+WEBKIT$1+'$2')+value;// cursor
case 6187:return replace$1(replace$1(replace$1(value,/(zoom-|grab)/,WEBKIT$1+'$1'),/(image-set)/,WEBKIT$1+'$1'),value,'')+value;// background, background-image
case 5495:case 3959:return replace$1(value,/(image-set\([^]*)/,WEBKIT$1+'$1'+'$`$1');// justify-content
case 4968:return replace$1(replace$1(value,/(.+:)(flex-)?(.*)/,WEBKIT$1+'box-pack:$3'+MS$1+'flex-pack:$3'),/s.+-b[^;]+/,'justify')+WEBKIT$1+value+value;// (margin|padding)-inline-(start|end)
case 4095:case 3583:case 4068:case 2532:return replace$1(value,/(.+)-inline(.+)/,WEBKIT$1+'$1$2')+value;// (min|max)?(width|height|inline-size|block-size)
case 8116:case 7059:case 5753:case 5535:case 5445:case 5701:case 4933:case 4677:case 5533:case 5789:case 5021:case 4765:// stretch, max-content, min-content, fill-available
if(strlen$1(value)-1-length>6)switch(charat$1(value,length+1)){// (m)ax-content, (m)in-content
case 109:// -
if(charat$1(value,length+4)!==45)break;// (f)ill-available, (f)it-content
case 102:return replace$1(value,/(.+:)(.+)-([^]+)/,'$1'+WEBKIT$1+'$2-$3'+'$1'+MOZ$1+(charat$1(value,length+3)==108?'$3':'$2-$3'))+value;// (s)tretch
case 115:return ~indexof$1(value,'stretch')?prefix$1(replace$1(value,'stretch','fill-available'),length)+value:value;}break;// position: sticky
case 4949:// (s)ticky?
if(charat$1(value,length+1)!==115)break;// display: (flex|inline-flex)
case 6444:switch(charat$1(value,strlen$1(value)-3-(~indexof$1(value,'!important')&&10))){// stic(k)y
case 107:return replace$1(value,':',':'+WEBKIT$1)+value;// (inline-)?fl(e)x
case 101:return replace$1(value,/(.+:)([^;!]+)(;|!.+)?/,'$1'+WEBKIT$1+(charat$1(value,14)===45?'inline-':'')+'box$3'+'$1'+WEBKIT$1+'$2$3'+'$1'+MS$1+'$2box$3')+value;}break;// writing-mode
case 5936:switch(charat$1(value,length+11)){// vertical-l(r)
case 114:return WEBKIT$1+value+MS$1+replace$1(value,/[svh]\w+-[tblr]{2}/,'tb')+value;// vertical-r(l)
case 108:return WEBKIT$1+value+MS$1+replace$1(value,/[svh]\w+-[tblr]{2}/,'tb-rl')+value;// horizontal(-)tb
case 45:return WEBKIT$1+value+MS$1+replace$1(value,/[svh]\w+-[tblr]{2}/,'lr')+value;}return WEBKIT$1+value+MS$1+value+value;}return value;}var prefixer$1=function prefixer(element,index,children,callback){if(element.length>-1)if(!element["return"])switch(element.type){case DECLARATION$1:element["return"]=prefix$1(element.value,element.length);break;case KEYFRAMES$1:return serialize$1([copy$1(element,{value:replace$1(element.value,'@','@'+WEBKIT$1)})],callback);case RULESET$1:if(element.length)return combine$1(element.props,function(value){switch(match$2(value,/(::plac\w+|:read-\w+)/)){// :read-(only|write)
case':read-only':case':read-write':return serialize$1([copy$1(element,{props:[replace$1(value,/:(read-\w+)/,':'+MOZ$1+'$1')]})],callback);// :placeholder
case'::placeholder':return serialize$1([copy$1(element,{props:[replace$1(value,/:(plac\w+)/,':'+WEBKIT$1+'input-$1')]}),copy$1(element,{props:[replace$1(value,/:(plac\w+)/,':'+MOZ$1+'$1')]}),copy$1(element,{props:[replace$1(value,/:(plac\w+)/,MS$1+'input-$1')]})],callback);}return '';});}};var isBrowser$7=typeof document!=='undefined';var getServerStylisCache$1=isBrowser$7?undefined:weakMemoize$1(function(){return memoize$1(function(){var cache={};return function(name){return cache[name];};});});var defaultStylisPlugins$1=[prefixer$1];var createCache$1=function createCache(options){var key=options.key;if(process.env.NODE_ENV!=='production'&&!key){throw new Error("You have to configure `key` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.\n"+"If multiple caches share the same key they might \"fight\" for each other's style elements.");}if(isBrowser$7&&key==='css'){var ssrStyles=document.querySelectorAll("style[data-emotion]:not([data-s])");// get SSRed styles out of the way of React's hydration
// document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
// note this very very intentionally targets all style elements regardless of the key to ensure
// that creating a cache works inside of render of a React component
Array.prototype.forEach.call(ssrStyles,function(node){// we want to only move elements which have a space in the data-emotion attribute value
// because that indicates that it is an Emotion 11 server-side rendered style elements
// while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
// Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
// so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
// will not result in the Emotion 10 styles being destroyed
var dataEmotionAttribute=node.getAttribute('data-emotion');if(dataEmotionAttribute.indexOf(' ')===-1){return;}document.head.appendChild(node);node.setAttribute('data-s','');});}var stylisPlugins=options.stylisPlugins||defaultStylisPlugins$1;if(process.env.NODE_ENV!=='production'){// $FlowFixMe
if(/[^a-z-]/.test(key)){throw new Error("Emotion key must only contain lower case alphabetical characters and - but \""+key+"\" was passed");}}var inserted={};var container;var nodesToHydrate=[];if(isBrowser$7){container=options.container||document.head;Array.prototype.forEach.call(// this means we will ignore elements which don't have a space in them which
// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
document.querySelectorAll("style[data-emotion^=\""+key+" \"]"),function(node){var attrib=node.getAttribute("data-emotion").split(' ');// $FlowFixMe
for(var i=1;i<attrib.length;i++){inserted[attrib[i]]=true;}nodesToHydrate.push(node);});}var _insert;var omnipresentPlugins=[compat$1,removeLabel$1];if(process.env.NODE_ENV!=='production'){omnipresentPlugins.push(createUnsafeSelectorsAlarm({get compat(){return cache.compat;}}),incorrectImportAlarm);}if(isBrowser$7){var currentSheet;var finalizingPlugins=[stringify$1,process.env.NODE_ENV!=='production'?function(element){if(!element.root){if(element["return"]){currentSheet.insert(element["return"]);}else if(element.value&&element.type!==COMMENT$1){// insert empty rule in non-production environments
// so @emotion/jest can grab `key` from the (JS)DOM for caches without any rules inserted yet
currentSheet.insert(element.value+"{}");}}}:rulesheet$1(function(rule){currentSheet.insert(rule);})];var serializer=middleware$1(omnipresentPlugins.concat(stylisPlugins,finalizingPlugins));var stylis=function stylis(styles){return serialize$1(compile$1(styles),serializer);};_insert=function insert(selector,serialized,sheet,shouldCache){currentSheet=sheet;if(process.env.NODE_ENV!=='production'&&serialized.map!==undefined){currentSheet={insert:function insert(rule){sheet.insert(rule+serialized.map);}};}stylis(selector?selector+"{"+serialized.styles+"}":serialized.styles);if(shouldCache){cache.inserted[serialized.name]=true;}};}else {var _finalizingPlugins=[stringify$1];var _serializer=middleware$1(omnipresentPlugins.concat(stylisPlugins,_finalizingPlugins));var _stylis=function _stylis(styles){return serialize$1(compile$1(styles),_serializer);};// $FlowFixMe
var serverStylisCache=getServerStylisCache$1(stylisPlugins)(key);var getRules=function getRules(selector,serialized){var name=serialized.name;if(serverStylisCache[name]===undefined){serverStylisCache[name]=_stylis(selector?selector+"{"+serialized.styles+"}":serialized.styles);}return serverStylisCache[name];};_insert=function _insert(selector,serialized,sheet,shouldCache){var name=serialized.name;var rules=getRules(selector,serialized);if(cache.compat===undefined){// in regular mode, we don't set the styles on the inserted cache
// since we don't need to and that would be wasting memory
// we return them so that they are rendered in a style tag
if(shouldCache){cache.inserted[name]=true;}if(// using === development instead of !== production
// because if people do ssr in tests, the source maps showing up would be annoying
process.env.NODE_ENV==='development'&&serialized.map!==undefined){return rules+serialized.map;}return rules;}else {// in compat mode, we put the styles on the inserted cache so
// that emotion-server can pull out the styles
// except when we don't want to cache it which was in Global but now
// is nowhere but we don't want to do a major right now
// and just in case we're going to leave the case here
// it's also not affecting client side bundle size
// so it's really not a big deal
if(shouldCache){cache.inserted[name]=rules;}else {return rules;}}};}var cache={key:key,sheet:new StyleSheet$1({key:key,container:container,nonce:options.nonce,speedy:options.speedy,prepend:options.prepend,insertionPoint:options.insertionPoint}),nonce:options.nonce,inserted:inserted,registered:{},insert:_insert};cache.sheet.hydrate(nodesToHydrate);return cache;};var reactIs$2={exports:{}};var reactIs_production_min$1={};/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */var b$1$1="function"===typeof Symbol&&Symbol.for,c$1$1=b$1$1?Symbol.for("react.element"):60103,d$1$1=b$1$1?Symbol.for("react.portal"):60106,e$1$1=b$1$1?Symbol.for("react.fragment"):60107,f$2$1=b$1$1?Symbol.for("react.strict_mode"):60108,g$2$1=b$1$1?Symbol.for("react.profiler"):60114,h$2$1=b$1$1?Symbol.for("react.provider"):60109,k$1$1=b$1$1?Symbol.for("react.context"):60110,l$1$1=b$1$1?Symbol.for("react.async_mode"):60111,m$2$1=b$1$1?Symbol.for("react.concurrent_mode"):60111,n$2$1=b$1$1?Symbol.for("react.forward_ref"):60112,p$2$1=b$1$1?Symbol.for("react.suspense"):60113,q$2$1=b$1$1?Symbol.for("react.suspense_list"):60120,r$2$1=b$1$1?Symbol.for("react.memo"):60115,t$1$1=b$1$1?Symbol.for("react.lazy"):60116,v$1$1=b$1$1?Symbol.for("react.block"):60121,w$7=b$1$1?Symbol.for("react.fundamental"):60117,x$3=b$1$1?Symbol.for("react.responder"):60118,y$5=b$1$1?Symbol.for("react.scope"):60119;function z$3(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c$1$1:switch(a=a.type,a){case l$1$1:case m$2$1:case e$1$1:case g$2$1:case f$2$1:case p$2$1:return a;default:switch(a=a&&a.$$typeof,a){case k$1$1:case n$2$1:case t$1$1:case r$2$1:case h$2$1:return a;default:return u;}}case d$1$1:return u;}}}function A$2(a){return z$3(a)===m$2$1;}reactIs_production_min$1.AsyncMode=l$1$1;reactIs_production_min$1.ConcurrentMode=m$2$1;reactIs_production_min$1.ContextConsumer=k$1$1;reactIs_production_min$1.ContextProvider=h$2$1;reactIs_production_min$1.Element=c$1$1;reactIs_production_min$1.ForwardRef=n$2$1;reactIs_production_min$1.Fragment=e$1$1;reactIs_production_min$1.Lazy=t$1$1;reactIs_production_min$1.Memo=r$2$1;reactIs_production_min$1.Portal=d$1$1;reactIs_production_min$1.Profiler=g$2$1;reactIs_production_min$1.StrictMode=f$2$1;reactIs_production_min$1.Suspense=p$2$1;reactIs_production_min$1.isAsyncMode=function(a){return A$2(a)||z$3(a)===l$1$1;};reactIs_production_min$1.isConcurrentMode=A$2;reactIs_production_min$1.isContextConsumer=function(a){return z$3(a)===k$1$1;};reactIs_production_min$1.isContextProvider=function(a){return z$3(a)===h$2$1;};reactIs_production_min$1.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c$1$1;};reactIs_production_min$1.isForwardRef=function(a){return z$3(a)===n$2$1;};reactIs_production_min$1.isFragment=function(a){return z$3(a)===e$1$1;};reactIs_production_min$1.isLazy=function(a){return z$3(a)===t$1$1;};reactIs_production_min$1.isMemo=function(a){return z$3(a)===r$2$1;};reactIs_production_min$1.isPortal=function(a){return z$3(a)===d$1$1;};reactIs_production_min$1.isProfiler=function(a){return z$3(a)===g$2$1;};reactIs_production_min$1.isStrictMode=function(a){return z$3(a)===f$2$1;};reactIs_production_min$1.isSuspense=function(a){return z$3(a)===p$2$1;};reactIs_production_min$1.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e$1$1||a===m$2$1||a===g$2$1||a===f$2$1||a===p$2$1||a===q$2$1||"object"===typeof a&&null!==a&&(a.$$typeof===t$1$1||a.$$typeof===r$2$1||a.$$typeof===h$2$1||a.$$typeof===k$1$1||a.$$typeof===n$2$1||a.$$typeof===w$7||a.$$typeof===x$3||a.$$typeof===y$5||a.$$typeof===v$1$1);};reactIs_production_min$1.typeOf=z$3;var reactIs_development$1={};/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */if(process.env.NODE_ENV!=="production"){(function(){// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol=typeof Symbol==='function'&&Symbol.for;var REACT_ELEMENT_TYPE=hasSymbol?Symbol.for('react.element'):0xeac7;var REACT_PORTAL_TYPE=hasSymbol?Symbol.for('react.portal'):0xeaca;var REACT_FRAGMENT_TYPE=hasSymbol?Symbol.for('react.fragment'):0xeacb;var REACT_STRICT_MODE_TYPE=hasSymbol?Symbol.for('react.strict_mode'):0xeacc;var REACT_PROFILER_TYPE=hasSymbol?Symbol.for('react.profiler'):0xead2;var REACT_PROVIDER_TYPE=hasSymbol?Symbol.for('react.provider'):0xeacd;var REACT_CONTEXT_TYPE=hasSymbol?Symbol.for('react.context'):0xeace;// TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?
var REACT_ASYNC_MODE_TYPE=hasSymbol?Symbol.for('react.async_mode'):0xeacf;var REACT_CONCURRENT_MODE_TYPE=hasSymbol?Symbol.for('react.concurrent_mode'):0xeacf;var REACT_FORWARD_REF_TYPE=hasSymbol?Symbol.for('react.forward_ref'):0xead0;var REACT_SUSPENSE_TYPE=hasSymbol?Symbol.for('react.suspense'):0xead1;var REACT_SUSPENSE_LIST_TYPE=hasSymbol?Symbol.for('react.suspense_list'):0xead8;var REACT_MEMO_TYPE=hasSymbol?Symbol.for('react.memo'):0xead3;var REACT_LAZY_TYPE=hasSymbol?Symbol.for('react.lazy'):0xead4;var REACT_BLOCK_TYPE=hasSymbol?Symbol.for('react.block'):0xead9;var REACT_FUNDAMENTAL_TYPE=hasSymbol?Symbol.for('react.fundamental'):0xead5;var REACT_RESPONDER_TYPE=hasSymbol?Symbol.for('react.responder'):0xead6;var REACT_SCOPE_TYPE=hasSymbol?Symbol.for('react.scope'):0xead7;function isValidElementType(type){return typeof type==='string'||typeof type==='function'||// Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
type===REACT_FRAGMENT_TYPE||type===REACT_CONCURRENT_MODE_TYPE||type===REACT_PROFILER_TYPE||type===REACT_STRICT_MODE_TYPE||type===REACT_SUSPENSE_TYPE||type===REACT_SUSPENSE_LIST_TYPE||typeof type==='object'&&type!==null&&(type.$$typeof===REACT_LAZY_TYPE||type.$$typeof===REACT_MEMO_TYPE||type.$$typeof===REACT_PROVIDER_TYPE||type.$$typeof===REACT_CONTEXT_TYPE||type.$$typeof===REACT_FORWARD_REF_TYPE||type.$$typeof===REACT_FUNDAMENTAL_TYPE||type.$$typeof===REACT_RESPONDER_TYPE||type.$$typeof===REACT_SCOPE_TYPE||type.$$typeof===REACT_BLOCK_TYPE);}function typeOf(object){if(typeof object==='object'&&object!==null){var $$typeof=object.$$typeof;switch($$typeof){case REACT_ELEMENT_TYPE:var type=object.type;switch(type){case REACT_ASYNC_MODE_TYPE:case REACT_CONCURRENT_MODE_TYPE:case REACT_FRAGMENT_TYPE:case REACT_PROFILER_TYPE:case REACT_STRICT_MODE_TYPE:case REACT_SUSPENSE_TYPE:return type;default:var $$typeofType=type&&type.$$typeof;switch($$typeofType){case REACT_CONTEXT_TYPE:case REACT_FORWARD_REF_TYPE:case REACT_LAZY_TYPE:case REACT_MEMO_TYPE:case REACT_PROVIDER_TYPE:return $$typeofType;default:return $$typeof;}}case REACT_PORTAL_TYPE:return $$typeof;}}return undefined;}// AsyncMode is deprecated along with isAsyncMode
var AsyncMode=REACT_ASYNC_MODE_TYPE;var ConcurrentMode=REACT_CONCURRENT_MODE_TYPE;var ContextConsumer=REACT_CONTEXT_TYPE;var ContextProvider=REACT_PROVIDER_TYPE;var Element=REACT_ELEMENT_TYPE;var ForwardRef=REACT_FORWARD_REF_TYPE;var Fragment=REACT_FRAGMENT_TYPE;var Lazy=REACT_LAZY_TYPE;var Memo=REACT_MEMO_TYPE;var Portal=REACT_PORTAL_TYPE;var Profiler=REACT_PROFILER_TYPE;var StrictMode=REACT_STRICT_MODE_TYPE;var Suspense=REACT_SUSPENSE_TYPE;var hasWarnedAboutDeprecatedIsAsyncMode=false;// AsyncMode should be deprecated
function isAsyncMode(object){{if(!hasWarnedAboutDeprecatedIsAsyncMode){hasWarnedAboutDeprecatedIsAsyncMode=true;// Using console['warn'] to evade Babel and ESLint
console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, '+'and will be removed in React 17+. Update your code to use '+'ReactIs.isConcurrentMode() instead. It has the exact same API.');}}return isConcurrentMode(object)||typeOf(object)===REACT_ASYNC_MODE_TYPE;}function isConcurrentMode(object){return typeOf(object)===REACT_CONCURRENT_MODE_TYPE;}function isContextConsumer(object){return typeOf(object)===REACT_CONTEXT_TYPE;}function isContextProvider(object){return typeOf(object)===REACT_PROVIDER_TYPE;}function isElement(object){return typeof object==='object'&&object!==null&&object.$$typeof===REACT_ELEMENT_TYPE;}function isForwardRef(object){return typeOf(object)===REACT_FORWARD_REF_TYPE;}function isFragment(object){return typeOf(object)===REACT_FRAGMENT_TYPE;}function isLazy(object){return typeOf(object)===REACT_LAZY_TYPE;}function isMemo(object){return typeOf(object)===REACT_MEMO_TYPE;}function isPortal(object){return typeOf(object)===REACT_PORTAL_TYPE;}function isProfiler(object){return typeOf(object)===REACT_PROFILER_TYPE;}function isStrictMode(object){return typeOf(object)===REACT_STRICT_MODE_TYPE;}function isSuspense(object){return typeOf(object)===REACT_SUSPENSE_TYPE;}reactIs_development$1.AsyncMode=AsyncMode;reactIs_development$1.ConcurrentMode=ConcurrentMode;reactIs_development$1.ContextConsumer=ContextConsumer;reactIs_development$1.ContextProvider=ContextProvider;reactIs_development$1.Element=Element;reactIs_development$1.ForwardRef=ForwardRef;reactIs_development$1.Fragment=Fragment;reactIs_development$1.Lazy=Lazy;reactIs_development$1.Memo=Memo;reactIs_development$1.Portal=Portal;reactIs_development$1.Profiler=Profiler;reactIs_development$1.StrictMode=StrictMode;reactIs_development$1.Suspense=Suspense;reactIs_development$1.isAsyncMode=isAsyncMode;reactIs_development$1.isConcurrentMode=isConcurrentMode;reactIs_development$1.isContextConsumer=isContextConsumer;reactIs_development$1.isContextProvider=isContextProvider;reactIs_development$1.isElement=isElement;reactIs_development$1.isForwardRef=isForwardRef;reactIs_development$1.isFragment=isFragment;reactIs_development$1.isLazy=isLazy;reactIs_development$1.isMemo=isMemo;reactIs_development$1.isPortal=isPortal;reactIs_development$1.isProfiler=isProfiler;reactIs_development$1.isStrictMode=isStrictMode;reactIs_development$1.isSuspense=isSuspense;reactIs_development$1.isValidElementType=isValidElementType;reactIs_development$1.typeOf=typeOf;})();}if(process.env.NODE_ENV==='production'){reactIs$2.exports=reactIs_production_min$1;}else {reactIs$2.exports=reactIs_development$1;}var reactIs$1=reactIs$2.exports;var FORWARD_REF_STATICS={'$$typeof':true,render:true,defaultProps:true,displayName:true,propTypes:true};var MEMO_STATICS={'$$typeof':true,compare:true,defaultProps:true,displayName:true,propTypes:true,type:true};var TYPE_STATICS={};TYPE_STATICS[reactIs$1.ForwardRef]=FORWARD_REF_STATICS;TYPE_STATICS[reactIs$1.Memo]=MEMO_STATICS;var isBrowser$6=typeof document!=='undefined';function getRegisteredStyles$1(registered,registeredStyles,classNames){var rawClassName='';classNames.split(' ').forEach(function(className){if(registered[className]!==undefined){registeredStyles.push(registered[className]+";");}else {rawClassName+=className+" ";}});return rawClassName;}var registerStyles$1=function registerStyles(cache,serialized,isStringTag){var className=cache.key+"-"+serialized.name;if(// we only need to add the styles to the registered cache if the
// class name could be used further down
// the tree but if it's a string tag, we know it won't
// so we don't have to add it to registered cache.
// this improves memory usage since we can avoid storing the whole style string
(isStringTag===false||// we need to always store it if we're in compat mode and
// in node since emotion-server relies on whether a style is in
// the registered cache to know whether a style is global or not
// also, note that this check will be dead code eliminated in the browser
isBrowser$6===false&&cache.compat!==undefined)&&cache.registered[className]===undefined){cache.registered[className]=serialized.styles;}};var insertStyles$1=function insertStyles(cache,serialized,isStringTag){registerStyles$1(cache,serialized,isStringTag);var className=cache.key+"-"+serialized.name;if(cache.inserted[serialized.name]===undefined){var stylesForSSR='';var current=serialized;do{var maybeStyles=cache.insert(serialized===current?"."+className:'',current,cache.sheet,true);if(!isBrowser$6&&maybeStyles!==undefined){stylesForSSR+=maybeStyles;}current=current.next;}while(current!==undefined);if(!isBrowser$6&&stylesForSSR.length!==0){return stylesForSSR;}}};/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2$1(str){// 'm' and 'r' are mixing constants generated offline.
// They're not really 'magic', they just happen to work well.
// const m = 0x5bd1e995;
// const r = 24;
// Initialize the hash
var h=0;// Mix 4 bytes at a time into the hash
var k,i=0,len=str.length;for(;len>=4;++i,len-=4){k=str.charCodeAt(i)&0xff|(str.charCodeAt(++i)&0xff)<<8|(str.charCodeAt(++i)&0xff)<<16|(str.charCodeAt(++i)&0xff)<<24;k=/* Math.imul(k, m): */(k&0xffff)*0x5bd1e995+((k>>>16)*0xe995<<16);k^=/* k >>> r: */k>>>24;h=/* Math.imul(k, m): */(k&0xffff)*0x5bd1e995+((k>>>16)*0xe995<<16)^/* Math.imul(h, m): */(h&0xffff)*0x5bd1e995+((h>>>16)*0xe995<<16);}// Handle the last few bytes of the input array
switch(len){case 3:h^=(str.charCodeAt(i+2)&0xff)<<16;case 2:h^=(str.charCodeAt(i+1)&0xff)<<8;case 1:h^=str.charCodeAt(i)&0xff;h=/* Math.imul(h, m): */(h&0xffff)*0x5bd1e995+((h>>>16)*0xe995<<16);}// Do a few final mixes of the hash to ensure the last few
// bytes are well-incorporated.
h^=h>>>13;h=/* Math.imul(h, m): */(h&0xffff)*0x5bd1e995+((h>>>16)*0xe995<<16);return ((h^h>>>15)>>>0).toString(36);}var unitlessKeys$1={animationIterationCount:1,aspectRatio:1,borderImageOutset:1,borderImageSlice:1,borderImageWidth:1,boxFlex:1,boxFlexGroup:1,boxOrdinalGroup:1,columnCount:1,columns:1,flex:1,flexGrow:1,flexPositive:1,flexShrink:1,flexNegative:1,flexOrder:1,gridRow:1,gridRowEnd:1,gridRowSpan:1,gridRowStart:1,gridColumn:1,gridColumnEnd:1,gridColumnSpan:1,gridColumnStart:1,msGridRow:1,msGridRowSpan:1,msGridColumn:1,msGridColumnSpan:1,fontWeight:1,lineHeight:1,opacity:1,order:1,orphans:1,tabSize:1,widows:1,zIndex:1,zoom:1,WebkitLineClamp:1,// SVG-related properties
fillOpacity:1,floodOpacity:1,stopOpacity:1,strokeDasharray:1,strokeDashoffset:1,strokeMiterlimit:1,strokeOpacity:1,strokeWidth:1};var ILLEGAL_ESCAPE_SEQUENCE_ERROR$2="You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";var UNDEFINED_AS_OBJECT_KEY_ERROR$1="You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";var hyphenateRegex$1=/[A-Z]|^ms/g;var animationRegex$1=/_EMO_([^_]+?)_([^]*?)_EMO_/g;var isCustomProperty$1=function isCustomProperty(property){return property.charCodeAt(1)===45;};var isProcessableValue$1=function isProcessableValue(value){return value!=null&&typeof value!=='boolean';};var processStyleName$1=/* #__PURE__ */memoize$1(function(styleName){return isCustomProperty$1(styleName)?styleName:styleName.replace(hyphenateRegex$1,'-$&').toLowerCase();});var processStyleValue$1=function processStyleValue(key,value){switch(key){case'animation':case'animationName':{if(typeof value==='string'){return value.replace(animationRegex$1,function(match,p1,p2){cursor$1={name:p1,styles:p2,next:cursor$1};return p1;});}}}if(unitlessKeys$1[key]!==1&&!isCustomProperty$1(key)&&typeof value==='number'&&value!==0){return value+'px';}return value;};if(process.env.NODE_ENV!=='production'){var contentValuePattern$1=/(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;var contentValues$1=['normal','none','initial','inherit','unset'];var oldProcessStyleValue$1=processStyleValue$1;var msPattern$1=/^-ms-/;var hyphenPattern$1=/-(.)/g;var hyphenatedCache$1={};processStyleValue$1=function processStyleValue(key,value){if(key==='content'){if(typeof value!=='string'||contentValues$1.indexOf(value)===-1&&!contentValuePattern$1.test(value)&&(value.charAt(0)!==value.charAt(value.length-1)||value.charAt(0)!=='"'&&value.charAt(0)!=="'")){throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\""+value+"\"'`");}}var processed=oldProcessStyleValue$1(key,value);if(processed!==''&&!isCustomProperty$1(key)&&key.indexOf('-')!==-1&&hyphenatedCache$1[key]===undefined){hyphenatedCache$1[key]=true;console.error("Using kebab-case for css properties in objects is not supported. Did you mean "+key.replace(msPattern$1,'ms-').replace(hyphenPattern$1,function(str,_char){return _char.toUpperCase();})+"?");}return processed;};}var noComponentSelectorMessage$1='Component selectors can only be used in conjunction with '+'@emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware '+'compiler transform.';function handleInterpolation$1(mergedProps,registered,interpolation){if(interpolation==null){return '';}if(interpolation.__emotion_styles!==undefined){if(process.env.NODE_ENV!=='production'&&interpolation.toString()==='NO_COMPONENT_SELECTOR'){throw new Error(noComponentSelectorMessage$1);}return interpolation;}switch(typeof interpolation){case'boolean':{return '';}case'object':{if(interpolation.anim===1){cursor$1={name:interpolation.name,styles:interpolation.styles,next:cursor$1};return interpolation.name;}if(interpolation.styles!==undefined){var next=interpolation.next;if(next!==undefined){// not the most efficient thing ever but this is a pretty rare case
// and there will be very few iterations of this generally
while(next!==undefined){cursor$1={name:next.name,styles:next.styles,next:cursor$1};next=next.next;}}var styles=interpolation.styles+";";if(process.env.NODE_ENV!=='production'&&interpolation.map!==undefined){styles+=interpolation.map;}return styles;}return createStringFromObject$1(mergedProps,registered,interpolation);}case'function':{if(mergedProps!==undefined){var previousCursor=cursor$1;var result=interpolation(mergedProps);cursor$1=previousCursor;return handleInterpolation$1(mergedProps,registered,result);}else if(process.env.NODE_ENV!=='production'){console.error('Functions that are interpolated in css calls will be stringified.\n'+'If you want to have a css call based on props, create a function that returns a css call like this\n'+'let dynamicStyle = (props) => css`color: ${props.color}`\n'+'It can be called directly with props or interpolated in a styled call like this\n'+"let SomeComponent = styled('div')`${dynamicStyle}`");}break;}case'string':if(process.env.NODE_ENV!=='production'){var matched=[];var replaced=interpolation.replace(animationRegex$1,function(match,p1,p2){var fakeVarName="animation"+matched.length;matched.push("const "+fakeVarName+" = keyframes`"+p2.replace(/^@keyframes animation-\w+/,'')+"`");return "${"+fakeVarName+"}";});if(matched.length){console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n'+'Instead of doing this:\n\n'+[].concat(matched,["`"+replaced+"`"]).join('\n')+'\n\nYou should wrap it with `css` like this:\n\n'+("css`"+replaced+"`"));}}break;}// finalize string values (regular strings and functions interpolated into css calls)
if(registered==null){return interpolation;}var cached=registered[interpolation];return cached!==undefined?cached:interpolation;}function createStringFromObject$1(mergedProps,registered,obj){var string='';if(Array.isArray(obj)){for(var i=0;i<obj.length;i++){string+=handleInterpolation$1(mergedProps,registered,obj[i])+";";}}else {for(var _key in obj){var value=obj[_key];if(typeof value!=='object'){if(registered!=null&&registered[value]!==undefined){string+=_key+"{"+registered[value]+"}";}else if(isProcessableValue$1(value)){string+=processStyleName$1(_key)+":"+processStyleValue$1(_key,value)+";";}}else {if(_key==='NO_COMPONENT_SELECTOR'&&process.env.NODE_ENV!=='production'){throw new Error(noComponentSelectorMessage$1);}if(Array.isArray(value)&&typeof value[0]==='string'&&(registered==null||registered[value[0]]===undefined)){for(var _i=0;_i<value.length;_i++){if(isProcessableValue$1(value[_i])){string+=processStyleName$1(_key)+":"+processStyleValue$1(_key,value[_i])+";";}}}else {var interpolated=handleInterpolation$1(mergedProps,registered,value);switch(_key){case'animation':case'animationName':{string+=processStyleName$1(_key)+":"+interpolated+";";break;}default:{if(process.env.NODE_ENV!=='production'&&_key==='undefined'){console.error(UNDEFINED_AS_OBJECT_KEY_ERROR$1);}string+=_key+"{"+interpolated+"}";}}}}}}return string;}var labelPattern$1=/label:\s*([^\s;\n{]+)\s*(;|$)/g;var sourceMapPattern$1;if(process.env.NODE_ENV!=='production'){sourceMapPattern$1=/\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;}// this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var cursor$1;var serializeStyles$1=function serializeStyles(args,registered,mergedProps){if(args.length===1&&typeof args[0]==='object'&&args[0]!==null&&args[0].styles!==undefined){return args[0];}var stringMode=true;var styles='';cursor$1=undefined;var strings=args[0];if(strings==null||strings.raw===undefined){stringMode=false;styles+=handleInterpolation$1(mergedProps,registered,strings);}else {if(process.env.NODE_ENV!=='production'&&strings[0]===undefined){console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR$2);}styles+=strings[0];}// we start at 1 since we've already handled the first arg
for(var i=1;i<args.length;i++){styles+=handleInterpolation$1(mergedProps,registered,args[i]);if(stringMode){if(process.env.NODE_ENV!=='production'&&strings[i]===undefined){console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR$2);}styles+=strings[i];}}var sourceMap;if(process.env.NODE_ENV!=='production'){styles=styles.replace(sourceMapPattern$1,function(match){sourceMap=match;return '';});}// using a global regex with .exec is stateful so lastIndex has to be reset each time
labelPattern$1.lastIndex=0;var identifierName='';var match;// https://esbench.com/bench/5b809c2cf2949800a0f61fb5
while((match=labelPattern$1.exec(styles))!==null){identifierName+='-'+// $FlowFixMe we know it's not null
match[1];}var name=murmur2$1(styles)+identifierName;if(process.env.NODE_ENV!=='production'){// $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
return {name:name,styles:styles,map:sourceMap,next:cursor$1,toString:function toString(){return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";}};}return {name:name,styles:styles,next:cursor$1};};var isBrowser$5$1=typeof document!=='undefined';var syncFallback$1=function syncFallback(create){return create();};var useInsertionEffect$1=React['useInsertion'+'Effect']?React['useInsertion'+'Effect']:false;var useInsertionEffectAlwaysWithSyncFallback$1=!isBrowser$5$1?syncFallback$1:useInsertionEffect$1||syncFallback$1;var useInsertionEffectWithLayoutFallback=useInsertionEffect$1||React.useLayoutEffect;var isBrowser$4$1=typeof document!=='undefined';var hasOwn={}.hasOwnProperty;var EmotionCacheContext$1=/* #__PURE__ */React.createContext(// we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement!=='undefined'?/* #__PURE__ */createCache$1({key:'css'}):null);if(process.env.NODE_ENV!=='production'){EmotionCacheContext$1.displayName='EmotionCacheContext';}var CacheProvider=EmotionCacheContext$1.Provider;var withEmotionCache$1=function withEmotionCache(func){// $FlowFixMe
return/*#__PURE__*/forwardRef(function(props,ref){// the cache will never be null in the browser
var cache=useContext(EmotionCacheContext$1);return func(props,cache,ref);});};if(!isBrowser$4$1){withEmotionCache$1=function withEmotionCache(func){return function(props){var cache=useContext(EmotionCacheContext$1);if(cache===null){// yes, we're potentially creating this on every render
// it doesn't actually matter though since it's only on the server
// so there will only every be a single render
// that could change in the future because of suspense and etc. but for now,
// this works and i don't want to optimise for a future thing that we aren't sure about
cache=createCache$1({key:'css'});return/*#__PURE__*/React.createElement(EmotionCacheContext$1.Provider,{value:cache},func(props,cache));}else {return func(props,cache);}};};}var ThemeContext$1=/* #__PURE__ */React.createContext({});if(process.env.NODE_ENV!=='production'){ThemeContext$1.displayName='EmotionThemeContext';}var typePropName='__EMOTION_TYPE_PLEASE_DO_NOT_USE__';var labelPropName='__EMOTION_LABEL_PLEASE_DO_NOT_USE__';var Insertion$2=function Insertion(_ref){var cache=_ref.cache,serialized=_ref.serialized,isStringTag=_ref.isStringTag;registerStyles$1(cache,serialized,isStringTag);var rules=useInsertionEffectAlwaysWithSyncFallback$1(function(){return insertStyles$1(cache,serialized,isStringTag);});if(!isBrowser$4$1&&rules!==undefined){var _ref2;var serializedNames=serialized.name;var next=serialized.next;while(next!==undefined){serializedNames+=' '+next.name;next=next.next;}return/*#__PURE__*/React.createElement("style",(_ref2={},_ref2["data-emotion"]=cache.key+" "+serializedNames,_ref2.dangerouslySetInnerHTML={__html:rules},_ref2.nonce=cache.sheet.nonce,_ref2));}return null;};var Emotion=/* #__PURE__ */withEmotionCache$1(function(props,cache,ref){var cssProp=props.css;// so that using `css` from `emotion` and passing the result to the css prop works
// not passing the registered cache to serializeStyles because it would
// make certain babel optimisations not possible
if(typeof cssProp==='string'&&cache.registered[cssProp]!==undefined){cssProp=cache.registered[cssProp];}var WrappedComponent=props[typePropName];var registeredStyles=[cssProp];var className='';if(typeof props.className==='string'){className=getRegisteredStyles$1(cache.registered,registeredStyles,props.className);}else if(props.className!=null){className=props.className+" ";}var serialized=serializeStyles$1(registeredStyles,undefined,React.useContext(ThemeContext$1));if(process.env.NODE_ENV!=='production'&&serialized.name.indexOf('-')===-1){var labelFromStack=props[labelPropName];if(labelFromStack){serialized=serializeStyles$1([serialized,'label:'+labelFromStack+';']);}}className+=cache.key+"-"+serialized.name;var newProps={};for(var key in props){if(hasOwn.call(props,key)&&key!=='css'&&key!==typePropName&&(process.env.NODE_ENV==='production'||key!==labelPropName)){newProps[key]=props[key];}}newProps.ref=ref;newProps.className=className;return/*#__PURE__*/React.createElement(React.Fragment,null,/*#__PURE__*/React.createElement(Insertion$2,{cache:cache,serialized:serialized,isStringTag:typeof WrappedComponent==='string'}),/*#__PURE__*/React.createElement(WrappedComponent,newProps));});if(process.env.NODE_ENV!=='production'){Emotion.displayName='EmotionCssPropInternal';}var pkg={name:"@emotion/react",version:"11.11.4",main:"dist/emotion-react.cjs.js",module:"dist/emotion-react.esm.js",browser:{"./dist/emotion-react.esm.js":"./dist/emotion-react.browser.esm.js"},exports:{".":{module:{worker:"./dist/emotion-react.worker.esm.js",browser:"./dist/emotion-react.browser.esm.js","default":"./dist/emotion-react.esm.js"},"import":"./dist/emotion-react.cjs.mjs","default":"./dist/emotion-react.cjs.js"},"./jsx-runtime":{module:{worker:"./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",browser:"./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js","default":"./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"},"import":"./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs","default":"./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"},"./_isolated-hnrs":{module:{worker:"./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",browser:"./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js","default":"./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"},"import":"./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs","default":"./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"},"./jsx-dev-runtime":{module:{worker:"./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",browser:"./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js","default":"./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"},"import":"./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs","default":"./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"},"./package.json":"./package.json","./types/css-prop":"./types/css-prop.d.ts","./macro":{types:{"import":"./macro.d.mts","default":"./macro.d.ts"},"default":"./macro.js"}},types:"types/index.d.ts",files:["src","dist","jsx-runtime","jsx-dev-runtime","_isolated-hnrs","types/*.d.ts","macro.*"],sideEffects:false,author:"Emotion Contributors",license:"MIT",scripts:{"test:typescript":"dtslint types"},dependencies:{"@babel/runtime":"^7.18.3","@emotion/babel-plugin":"^11.11.0","@emotion/cache":"^11.11.0","@emotion/serialize":"^1.1.3","@emotion/use-insertion-effect-with-fallbacks":"^1.0.1","@emotion/utils":"^1.2.1","@emotion/weak-memoize":"^0.3.1","hoist-non-react-statics":"^3.3.1"},peerDependencies:{react:">=16.8.0"},peerDependenciesMeta:{"@types/react":{optional:true}},devDependencies:{"@definitelytyped/dtslint":"0.0.112","@emotion/css":"11.11.2","@emotion/css-prettifier":"1.1.3","@emotion/server":"11.11.0","@emotion/styled":"11.11.0","html-tag-names":"^1.1.2",react:"16.14.0","svg-tag-names":"^1.1.1",typescript:"^4.5.5"},repository:"https://github.com/emotion-js/emotion/tree/main/packages/react",publishConfig:{access:"public"},"umd:main":"dist/emotion-react.umd.min.js",preconstruct:{entrypoints:["./index.js","./jsx-runtime.js","./jsx-dev-runtime.js","./_isolated-hnrs.js"],umdName:"emotionReact",exports:{envConditions:["browser","worker"],extra:{"./types/css-prop":"./types/css-prop.d.ts","./macro":{types:{"import":"./macro.d.mts","default":"./macro.d.ts"},"default":"./macro.js"}}}}};var warnedAboutCssPropForGlobal=false;// maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var Global=/* #__PURE__ */withEmotionCache$1(function(props,cache){if(process.env.NODE_ENV!=='production'&&!warnedAboutCssPropForGlobal&&(// check for className as well since the user is
// probably using the custom createElement which
// means it will be turned into a className prop
// $FlowFixMe I don't really want to add it to the type since it shouldn't be used
props.className||props.css)){console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?");warnedAboutCssPropForGlobal=true;}var styles=props.styles;var serialized=serializeStyles$1([styles],undefined,React.useContext(ThemeContext$1));if(!isBrowser$4$1){var _ref;var serializedNames=serialized.name;var serializedStyles=serialized.styles;var next=serialized.next;while(next!==undefined){serializedNames+=' '+next.name;serializedStyles+=next.styles;next=next.next;}var shouldCache=cache.compat===true;var rules=cache.insert("",{name:serializedNames,styles:serializedStyles},cache.sheet,shouldCache);if(shouldCache){return null;}return/*#__PURE__*/React.createElement("style",(_ref={},_ref["data-emotion"]=cache.key+"-global "+serializedNames,_ref.dangerouslySetInnerHTML={__html:rules},_ref.nonce=cache.sheet.nonce,_ref));}// yes, i know these hooks are used conditionally
// but it is based on a constant that will never change at runtime
// it's effectively like having two implementations and switching them out
// so it's not actually breaking anything
var sheetRef=React.useRef();useInsertionEffectWithLayoutFallback(function(){var key=cache.key+"-global";// use case of https://github.com/emotion-js/emotion/issues/2675
var sheet=new cache.sheet.constructor({key:key,nonce:cache.sheet.nonce,container:cache.sheet.container,speedy:cache.sheet.isSpeedy});var rehydrating=false;// $FlowFixMe
var node=document.querySelector("style[data-emotion=\""+key+" "+serialized.name+"\"]");if(cache.sheet.tags.length){sheet.before=cache.sheet.tags[0];}if(node!==null){rehydrating=true;// clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
node.setAttribute('data-emotion',key);sheet.hydrate([node]);}sheetRef.current=[sheet,rehydrating];return function(){sheet.flush();};},[cache]);useInsertionEffectWithLayoutFallback(function(){var sheetRefCurrent=sheetRef.current;var sheet=sheetRefCurrent[0],rehydrating=sheetRefCurrent[1];if(rehydrating){sheetRefCurrent[1]=false;return;}if(serialized.next!==undefined){// insert keyframes
insertStyles$1(cache,serialized.next,true);}if(sheet.tags.length){// if this doesn't exist then it will be null so the style element will be appended
var element=sheet.tags[sheet.tags.length-1].nextElementSibling;sheet.before=element;sheet.flush();}cache.insert("",serialized,sheet,false);},[cache,serialized.name]);return null;});if(process.env.NODE_ENV!=='production'){Global.displayName='EmotionGlobal';}function css(){for(var _len=arguments.length,args=new Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return serializeStyles$1(args);}var keyframes=function keyframes(){var insertable=css.apply(void 0,arguments);var name="animation-"+insertable.name;// $FlowFixMe
return {name:name,styles:"@keyframes "+name+"{"+insertable.styles+"}",anim:1,toString:function toString(){return "_EMO_"+this.name+"_"+this.styles+"_EMO_";}};};var classnames=function classnames(args){var len=args.length;var i=0;var cls='';for(;i<len;i++){var arg=args[i];if(arg==null)continue;var toAdd=void 0;switch(typeof arg){case'boolean':break;case'object':{if(Array.isArray(arg)){toAdd=classnames(arg);}else {if(process.env.NODE_ENV!=='production'&&arg.styles!==undefined&&arg.name!==undefined){console.error('You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n'+'`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component.');}toAdd='';for(var k in arg){if(arg[k]&&k){toAdd&&(toAdd+=' ');toAdd+=k;}}}break;}default:{toAdd=arg;}}if(toAdd){cls&&(cls+=' ');cls+=toAdd;}}return cls;};function merge$1(registered,css,className){var registeredStyles=[];var rawClassName=getRegisteredStyles$1(registered,registeredStyles,className);if(registeredStyles.length<2){return className;}return rawClassName+css(registeredStyles);}var Insertion$1=function Insertion(_ref){var cache=_ref.cache,serializedArr=_ref.serializedArr;var rules=useInsertionEffectAlwaysWithSyncFallback$1(function(){var rules='';for(var i=0;i<serializedArr.length;i++){var res=insertStyles$1(cache,serializedArr[i],false);if(!isBrowser$4$1&&res!==undefined){rules+=res;}}if(!isBrowser$4$1){return rules;}});if(!isBrowser$4$1&&rules.length!==0){var _ref2;return/*#__PURE__*/React.createElement("style",(_ref2={},_ref2["data-emotion"]=cache.key+" "+serializedArr.map(function(serialized){return serialized.name;}).join(' '),_ref2.dangerouslySetInnerHTML={__html:rules},_ref2.nonce=cache.sheet.nonce,_ref2));}return null;};var ClassNames=/* #__PURE__ */withEmotionCache$1(function(props,cache){var hasRendered=false;var serializedArr=[];var css=function css(){if(hasRendered&&process.env.NODE_ENV!=='production'){throw new Error('css can only be used during render');}for(var _len=arguments.length,args=new Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}var serialized=serializeStyles$1(args,cache.registered);serializedArr.push(serialized);// registration has to happen here as the result of this might get consumed by `cx`
registerStyles$1(cache,serialized,false);return cache.key+"-"+serialized.name;};var cx=function cx(){if(hasRendered&&process.env.NODE_ENV!=='production'){throw new Error('cx can only be used during render');}for(var _len2=arguments.length,args=new Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return merge$1(cache.registered,css,classnames(args));};var content={css:css,cx:cx,theme:React.useContext(ThemeContext$1)};var ele=props.children(content);hasRendered=true;return/*#__PURE__*/React.createElement(React.Fragment,null,/*#__PURE__*/React.createElement(Insertion$1,{cache:cache,serializedArr:serializedArr}),ele);});if(process.env.NODE_ENV!=='production'){ClassNames.displayName='EmotionClassNames';}if(process.env.NODE_ENV!=='production'){var isBrowser$3$1=typeof document!=='undefined';// #1727, #2905 for some reason Jest and Vitest evaluate modules twice if some consuming module gets mocked
var isTestEnv=typeof jest!=='undefined'||typeof vi!=='undefined';if(isBrowser$3$1&&!isTestEnv){// globalThis has wide browser support - https://caniuse.com/?search=globalThis, Node.js 12 and later
var globalContext=// $FlowIgnore
typeof globalThis!=='undefined'?globalThis// eslint-disable-line no-undef
:isBrowser$3$1?window:global;var globalKey="__EMOTION_REACT_"+pkg.version.split('.')[0]+"__";if(globalContext[globalKey]){console.warn('You are loading @emotion/react when it is already loaded. Running '+'multiple instances may cause problems. This can happen if multiple '+'versions are used, or if multiple builds of the same version are '+'used.');}globalContext[globalKey]=true;}}var isBrowser$2$1=typeof document!=='undefined';function getRegisteredStyles$2(registered,registeredStyles,classNames){var rawClassName='';classNames.split(' ').forEach(function(className){if(registered[className]!==undefined){registeredStyles.push(registered[className]+";");}else {rawClassName+=className+" ";}});return rawClassName;}var registerStyles$2=function registerStyles(cache,serialized,isStringTag){var className=cache.key+"-"+serialized.name;if(// we only need to add the styles to the registered cache if the
// class name could be used further down
// the tree but if it's a string tag, we know it won't
// so we don't have to add it to registered cache.
// this improves memory usage since we can avoid storing the whole style string
(isStringTag===false||// we need to always store it if we're in compat mode and
// in node since emotion-server relies on whether a style is in
// the registered cache to know whether a style is global or not
// also, note that this check will be dead code eliminated in the browser
isBrowser$2$1===false&&cache.compat!==undefined)&&cache.registered[className]===undefined){cache.registered[className]=serialized.styles;}};var insertStyles$2=function insertStyles(cache,serialized,isStringTag){registerStyles$2(cache,serialized,isStringTag);var className=cache.key+"-"+serialized.name;if(cache.inserted[serialized.name]===undefined){var stylesForSSR='';var current=serialized;do{var maybeStyles=cache.insert(serialized===current?"."+className:'',current,cache.sheet,true);if(!isBrowser$2$1&&maybeStyles!==undefined){stylesForSSR+=maybeStyles;}current=current.next;}while(current!==undefined);if(!isBrowser$2$1&&stylesForSSR.length!==0){return stylesForSSR;}}};/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2$2(str){// 'm' and 'r' are mixing constants generated offline.
// They're not really 'magic', they just happen to work well.
// const m = 0x5bd1e995;
// const r = 24;
// Initialize the hash
var h=0;// Mix 4 bytes at a time into the hash
var k,i=0,len=str.length;for(;len>=4;++i,len-=4){k=str.charCodeAt(i)&0xff|(str.charCodeAt(++i)&0xff)<<8|(str.charCodeAt(++i)&0xff)<<16|(str.charCodeAt(++i)&0xff)<<24;k=/* Math.imul(k, m): */(k&0xffff)*0x5bd1e995+((k>>>16)*0xe995<<16);k^=/* k >>> r: */k>>>24;h=/* Math.imul(k, m): */(k&0xffff)*0x5bd1e995+((k>>>16)*0xe995<<16)^/* Math.imul(h, m): */(h&0xffff)*0x5bd1e995+((h>>>16)*0xe995<<16);}// Handle the last few bytes of the input array
switch(len){case 3:h^=(str.charCodeAt(i+2)&0xff)<<16;case 2:h^=(str.charCodeAt(i+1)&0xff)<<8;case 1:h^=str.charCodeAt(i)&0xff;h=/* Math.imul(h, m): */(h&0xffff)*0x5bd1e995+((h>>>16)*0xe995<<16);}// Do a few final mixes of the hash to ensure the last few
// bytes are well-incorporated.
h^=h>>>13;h=/* Math.imul(h, m): */(h&0xffff)*0x5bd1e995+((h>>>16)*0xe995<<16);return ((h^h>>>15)>>>0).toString(36);}var unitlessKeys$2={animationIterationCount:1,aspectRatio:1,borderImageOutset:1,borderImageSlice:1,borderImageWidth:1,boxFlex:1,boxFlexGroup:1,boxOrdinalGroup:1,columnCount:1,columns:1,flex:1,flexGrow:1,flexPositive:1,flexShrink:1,flexNegative:1,flexOrder:1,gridRow:1,gridRowEnd:1,gridRowSpan:1,gridRowStart:1,gridColumn:1,gridColumnEnd:1,gridColumnSpan:1,gridColumnStart:1,msGridRow:1,msGridRowSpan:1,msGridColumn:1,msGridColumnSpan:1,fontWeight:1,lineHeight:1,opacity:1,order:1,orphans:1,tabSize:1,widows:1,zIndex:1,zoom:1,WebkitLineClamp:1,// SVG-related properties
fillOpacity:1,floodOpacity:1,stopOpacity:1,strokeDasharray:1,strokeDashoffset:1,strokeMiterlimit:1,strokeOpacity:1,strokeWidth:1};var ILLEGAL_ESCAPE_SEQUENCE_ERROR$1="You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";var UNDEFINED_AS_OBJECT_KEY_ERROR="You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";var hyphenateRegex$2=/[A-Z]|^ms/g;var animationRegex$2=/_EMO_([^_]+?)_([^]*?)_EMO_/g;var isCustomProperty$2=function isCustomProperty(property){return property.charCodeAt(1)===45;};var isProcessableValue$2=function isProcessableValue(value){return value!=null&&typeof value!=='boolean';};var processStyleName$2=/* #__PURE__ */memoize$1(function(styleName){return isCustomProperty$2(styleName)?styleName:styleName.replace(hyphenateRegex$2,'-$&').toLowerCase();});var processStyleValue$2=function processStyleValue(key,value){switch(key){case'animation':case'animationName':{if(typeof value==='string'){return value.replace(animationRegex$2,function(match,p1,p2){cursor$2={name:p1,styles:p2,next:cursor$2};return p1;});}}}if(unitlessKeys$2[key]!==1&&!isCustomProperty$2(key)&&typeof value==='number'&&value!==0){return value+'px';}return value;};if(process.env.NODE_ENV!=='production'){var contentValuePattern=/(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;var contentValues=['normal','none','initial','inherit','unset'];var oldProcessStyleValue=processStyleValue$2;var msPattern=/^-ms-/;var hyphenPattern=/-(.)/g;var hyphenatedCache={};processStyleValue$2=function processStyleValue(key,value){if(key==='content'){if(typeof value!=='string'||contentValues.indexOf(value)===-1&&!contentValuePattern.test(value)&&(value.charAt(0)!==value.charAt(value.length-1)||value.charAt(0)!=='"'&&value.charAt(0)!=="'")){throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\""+value+"\"'`");}}var processed=oldProcessStyleValue(key,value);if(processed!==''&&!isCustomProperty$2(key)&&key.indexOf('-')!==-1&&hyphenatedCache[key]===undefined){hyphenatedCache[key]=true;console.error("Using kebab-case for css properties in objects is not supported. Did you mean "+key.replace(msPattern,'ms-').replace(hyphenPattern,function(str,_char){return _char.toUpperCase();})+"?");}return processed;};}var noComponentSelectorMessage$2='Component selectors can only be used in conjunction with '+'@emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware '+'compiler transform.';function handleInterpolation$2(mergedProps,registered,interpolation){if(interpolation==null){return '';}if(interpolation.__emotion_styles!==undefined){if(process.env.NODE_ENV!=='production'&&interpolation.toString()==='NO_COMPONENT_SELECTOR'){throw new Error(noComponentSelectorMessage$2);}return interpolation;}switch(typeof interpolation){case'boolean':{return '';}case'object':{if(interpolation.anim===1){cursor$2={name:interpolation.name,styles:interpolation.styles,next:cursor$2};return interpolation.name;}if(interpolation.styles!==undefined){var next=interpolation.next;if(next!==undefined){// not the most efficient thing ever but this is a pretty rare case
// and there will be very few iterations of this generally
while(next!==undefined){cursor$2={name:next.name,styles:next.styles,next:cursor$2};next=next.next;}}var styles=interpolation.styles+";";if(process.env.NODE_ENV!=='production'&&interpolation.map!==undefined){styles+=interpolation.map;}return styles;}return createStringFromObject$2(mergedProps,registered,interpolation);}case'function':{if(mergedProps!==undefined){var previousCursor=cursor$2;var result=interpolation(mergedProps);cursor$2=previousCursor;return handleInterpolation$2(mergedProps,registered,result);}else if(process.env.NODE_ENV!=='production'){console.error('Functions that are interpolated in css calls will be stringified.\n'+'If you want to have a css call based on props, create a function that returns a css call like this\n'+'let dynamicStyle = (props) => css`color: ${props.color}`\n'+'It can be called directly with props or interpolated in a styled call like this\n'+"let SomeComponent = styled('div')`${dynamicStyle}`");}break;}case'string':if(process.env.NODE_ENV!=='production'){var matched=[];var replaced=interpolation.replace(animationRegex$2,function(match,p1,p2){var fakeVarName="animation"+matched.length;matched.push("const "+fakeVarName+" = keyframes`"+p2.replace(/^@keyframes animation-\w+/,'')+"`");return "${"+fakeVarName+"}";});if(matched.length){console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n'+'Instead of doing this:\n\n'+[].concat(matched,["`"+replaced+"`"]).join('\n')+'\n\nYou should wrap it with `css` like this:\n\n'+("css`"+replaced+"`"));}}break;}// finalize string values (regular strings and functions interpolated into css calls)
if(registered==null){return interpolation;}var cached=registered[interpolation];return cached!==undefined?cached:interpolation;}function createStringFromObject$2(mergedProps,registered,obj){var string='';if(Array.isArray(obj)){for(var i=0;i<obj.length;i++){string+=handleInterpolation$2(mergedProps,registered,obj[i])+";";}}else {for(var _key in obj){var value=obj[_key];if(typeof value!=='object'){if(registered!=null&&registered[value]!==undefined){string+=_key+"{"+registered[value]+"}";}else if(isProcessableValue$2(value)){string+=processStyleName$2(_key)+":"+processStyleValue$2(_key,value)+";";}}else {if(_key==='NO_COMPONENT_SELECTOR'&&process.env.NODE_ENV!=='production'){throw new Error(noComponentSelectorMessage$2);}if(Array.isArray(value)&&typeof value[0]==='string'&&(registered==null||registered[value[0]]===undefined)){for(var _i=0;_i<value.length;_i++){if(isProcessableValue$2(value[_i])){string+=processStyleName$2(_key)+":"+processStyleValue$2(_key,value[_i])+";";}}}else {var interpolated=handleInterpolation$2(mergedProps,registered,value);switch(_key){case'animation':case'animationName':{string+=processStyleName$2(_key)+":"+interpolated+";";break;}default:{if(process.env.NODE_ENV!=='production'&&_key==='undefined'){console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);}string+=_key+"{"+interpolated+"}";}}}}}}return string;}var labelPattern$2=/label:\s*([^\s;\n{]+)\s*(;|$)/g;var sourceMapPattern;if(process.env.NODE_ENV!=='production'){sourceMapPattern=/\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;}// this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var cursor$2;var serializeStyles$2=function serializeStyles(args,registered,mergedProps){if(args.length===1&&typeof args[0]==='object'&&args[0]!==null&&args[0].styles!==undefined){return args[0];}var stringMode=true;var styles='';cursor$2=undefined;var strings=args[0];if(strings==null||strings.raw===undefined){stringMode=false;styles+=handleInterpolation$2(mergedProps,registered,strings);}else {if(process.env.NODE_ENV!=='production'&&strings[0]===undefined){console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR$1);}styles+=strings[0];}// we start at 1 since we've already handled the first arg
for(var i=1;i<args.length;i++){styles+=handleInterpolation$2(mergedProps,registered,args[i]);if(stringMode){if(process.env.NODE_ENV!=='production'&&strings[i]===undefined){console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR$1);}styles+=strings[i];}}var sourceMap;if(process.env.NODE_ENV!=='production'){styles=styles.replace(sourceMapPattern,function(match){sourceMap=match;return '';});}// using a global regex with .exec is stateful so lastIndex has to be reset each time
labelPattern$2.lastIndex=0;var identifierName='';var match;// https://esbench.com/bench/5b809c2cf2949800a0f61fb5
while((match=labelPattern$2.exec(styles))!==null){identifierName+='-'+// $FlowFixMe we know it's not null
match[1];}var name=murmur2$2(styles)+identifierName;if(process.env.NODE_ENV!=='production'){// $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
return {name:name,styles:styles,map:sourceMap,next:cursor$2,toString:function toString(){return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";}};}return {name:name,styles:styles,next:cursor$2};};var testOmitPropsOnStringTag$1=isPropValid$1;var testOmitPropsOnComponent$1=function testOmitPropsOnComponent(key){return key!=='theme';};var getDefaultShouldForwardProp$1=function getDefaultShouldForwardProp(tag){return typeof tag==='string'&&// 96 is one less than the char code
// for "a" so this is checking that
// it's a lowercase character
tag.charCodeAt(0)>96?testOmitPropsOnStringTag$1:testOmitPropsOnComponent$1;};var composeShouldForwardProps$1=function composeShouldForwardProps(tag,options,isReal){var shouldForwardProp;if(options){var optionsShouldForwardProp=options.shouldForwardProp;shouldForwardProp=tag.__emotion_forwardProp&&optionsShouldForwardProp?function(propName){return tag.__emotion_forwardProp(propName)&&optionsShouldForwardProp(propName);}:optionsShouldForwardProp;}if(typeof shouldForwardProp!=='function'&&isReal){shouldForwardProp=tag.__emotion_forwardProp;}return shouldForwardProp;};var ILLEGAL_ESCAPE_SEQUENCE_ERROR="You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";var isBrowser$1$1=typeof document!=='undefined';var Insertion$3=function Insertion(_ref){var cache=_ref.cache,serialized=_ref.serialized,isStringTag=_ref.isStringTag;registerStyles$2(cache,serialized,isStringTag);var rules=useInsertionEffectAlwaysWithSyncFallback$1(function(){return insertStyles$2(cache,serialized,isStringTag);});if(!isBrowser$1$1&&rules!==undefined){var _ref2;var serializedNames=serialized.name;var next=serialized.next;while(next!==undefined){serializedNames+=' '+next.name;next=next.next;}return/*#__PURE__*/React.createElement("style",(_ref2={},_ref2["data-emotion"]=cache.key+" "+serializedNames,_ref2.dangerouslySetInnerHTML={__html:rules},_ref2.nonce=cache.sheet.nonce,_ref2));}return null;};var createStyled$2=function createStyled(tag,options){if(process.env.NODE_ENV!=='production'){if(tag===undefined){throw new Error('You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.');}}var isReal=tag.__emotion_real===tag;var baseTag=isReal&&tag.__emotion_base||tag;var identifierName;var targetClassName;if(options!==undefined){identifierName=options.label;targetClassName=options.target;}var shouldForwardProp=composeShouldForwardProps$1(tag,options,isReal);var defaultShouldForwardProp=shouldForwardProp||getDefaultShouldForwardProp$1(baseTag);var shouldUseAs=!defaultShouldForwardProp('as');return function(){var args=arguments;var styles=isReal&&tag.__emotion_styles!==undefined?tag.__emotion_styles.slice(0):[];if(identifierName!==undefined){styles.push("label:"+identifierName+";");}if(args[0]==null||args[0].raw===undefined){styles.push.apply(styles,args);}else {if(process.env.NODE_ENV!=='production'&&args[0][0]===undefined){console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);}styles.push(args[0][0]);var len=args.length;var i=1;for(;i<len;i++){if(process.env.NODE_ENV!=='production'&&args[0][i]===undefined){console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);}styles.push(args[i],args[0][i]);}}// $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
var Styled=withEmotionCache$1(function(props,cache,ref){var FinalTag=shouldUseAs&&props.as||baseTag;var className='';var classInterpolations=[];var mergedProps=props;if(props.theme==null){mergedProps={};for(var key in props){mergedProps[key]=props[key];}mergedProps.theme=React.useContext(ThemeContext$1);}if(typeof props.className==='string'){className=getRegisteredStyles$2(cache.registered,classInterpolations,props.className);}else if(props.className!=null){className=props.className+" ";}var serialized=serializeStyles$2(styles.concat(classInterpolations),cache.registered,mergedProps);className+=cache.key+"-"+serialized.name;if(targetClassName!==undefined){className+=" "+targetClassName;}var finalShouldForwardProp=shouldUseAs&&shouldForwardProp===undefined?getDefaultShouldForwardProp$1(FinalTag):defaultShouldForwardProp;var newProps={};for(var _key in props){if(shouldUseAs&&_key==='as')continue;if(// $FlowFixMe
finalShouldForwardProp(_key)){newProps[_key]=props[_key];}}newProps.className=className;newProps.ref=ref;return/*#__PURE__*/React.createElement(React.Fragment,null,/*#__PURE__*/React.createElement(Insertion$3,{cache:cache,serialized:serialized,isStringTag:typeof FinalTag==='string'}),/*#__PURE__*/React.createElement(FinalTag,newProps));});Styled.displayName=identifierName!==undefined?identifierName:"Styled("+(typeof baseTag==='string'?baseTag:baseTag.displayName||baseTag.name||'Component')+")";Styled.defaultProps=tag.defaultProps;Styled.__emotion_real=Styled;Styled.__emotion_base=baseTag;Styled.__emotion_styles=styles;Styled.__emotion_forwardProp=shouldForwardProp;Object.defineProperty(Styled,'toString',{value:function value(){if(targetClassName===undefined&&process.env.NODE_ENV!=='production'){return 'NO_COMPONENT_SELECTOR';}// $FlowFixMe: coerce undefined to string
return "."+targetClassName;}});Styled.withComponent=function(nextTag,nextOptions){return createStyled(nextTag,_extends$2({},options,nextOptions,{shouldForwardProp:composeShouldForwardProps$1(Styled,nextOptions,true)})).apply(void 0,styles);};return Styled;};};var tags$1=['a','abbr','address','area','article','aside','audio','b','base','bdi','bdo','big','blockquote','body','br','button','canvas','caption','cite','code','col','colgroup','data','datalist','dd','del','details','dfn','dialog','div','dl','dt','em','embed','fieldset','figcaption','figure','footer','form','h1','h2','h3','h4','h5','h6','head','header','hgroup','hr','html','i','iframe','img','input','ins','kbd','keygen','label','legend','li','link','main','map','mark','marquee','menu','menuitem','meta','meter','nav','noscript','object','ol','optgroup','option','output','p','param','picture','pre','progress','q','rp','rt','ruby','s','samp','script','section','select','small','source','span','strong','style','sub','summary','sup','table','tbody','td','textarea','tfoot','th','thead','time','title','tr','track','u','ul','var','video','wbr',// SVG
'circle','clipPath','defs','ellipse','foreignObject','g','image','line','linearGradient','mask','path','pattern','polygon','polyline','radialGradient','rect','stop','svg','text','tspan'];var newStyled$1=createStyled$2.bind();tags$1.forEach(function(tagName){// $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
newStyled$1[tagName]=newStyled$1(tagName);});var jsxRuntime$1={exports:{}};var reactJsxRuntime_production_min$1={};/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ /* eslint-disable no-unused-vars */var getOwnPropertySymbols=Object.getOwnPropertySymbols;var hasOwnProperty$2=Object.prototype.hasOwnProperty;var propIsEnumerable=Object.prototype.propertyIsEnumerable;function toObject$3(val){if(val===null||val===undefined){throw new TypeError('Object.assign cannot be called with null or undefined');}return Object(val);}function shouldUseNative(){try{if(!Object.assign){return false;}// Detect buggy property enumeration order in older V8 versions.
// https://bugs.chromium.org/p/v8/issues/detail?id=4118
var test1=new String('abc');// eslint-disable-line no-new-wrappers
test1[5]='de';if(Object.getOwnPropertyNames(test1)[0]==='5'){return false;}// https://bugs.chromium.org/p/v8/issues/detail?id=3056
var test2={};for(var i=0;i<10;i++){test2['_'+String.fromCharCode(i)]=i;}var order2=Object.getOwnPropertyNames(test2).map(function(n){return test2[n];});if(order2.join('')!=='0123456789'){return false;}// https://bugs.chromium.org/p/v8/issues/detail?id=3056
var test3={};'abcdefghijklmnopqrst'.split('').forEach(function(letter){test3[letter]=letter;});if(Object.keys(Object.assign({},test3)).join('')!=='abcdefghijklmnopqrst'){return false;}return true;}catch(err){// We don't expect any of the above to throw, but better to be safe.
return false;}}var objectAssign$1=shouldUseNative()?Object.assign:function(target,source){var from;var to=toObject$3(target);var symbols;for(var s=1;s<arguments.length;s++){from=Object(arguments[s]);for(var key in from){if(hasOwnProperty$2.call(from,key)){to[key]=from[key];}}if(getOwnPropertySymbols){symbols=getOwnPropertySymbols(from);for(var i=0;i<symbols.length;i++){if(propIsEnumerable.call(from,symbols[i])){to[symbols[i]]=from[symbols[i]];}}}}return to;};/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */var f$1$1=React__default,g$1$1=60103;reactJsxRuntime_production_min$1.Fragment=60107;if("function"===typeof Symbol&&Symbol.for){var h$1$1=Symbol.for;g$1$1=h$1$1("react.element");reactJsxRuntime_production_min$1.Fragment=h$1$1("react.fragment");}var m$1$1=f$1$1.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,n$1$1=Object.prototype.hasOwnProperty,p$1$1={key:!0,ref:!0,__self:!0,__source:!0};function q$1$1(c,a,k){var b,d={},e=null,l=null;void 0!==k&&(e=""+k);void 0!==a.key&&(e=""+a.key);void 0!==a.ref&&(l=a.ref);for(b in a)n$1$1.call(a,b)&&!p$1$1.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a)void 0===d[b]&&(d[b]=a[b]);return {$$typeof:g$1$1,type:c,key:e,ref:l,props:d,_owner:m$1$1.current};}reactJsxRuntime_production_min$1.jsx=q$1$1;reactJsxRuntime_production_min$1.jsxs=q$1$1;var reactJsxRuntime_development$1={};/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */(function(exports){if(process.env.NODE_ENV!=="production"){(function(){var React=React__default;var _assign=objectAssign$1;// ATTENTION
// When adding new symbols to this file,
// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var REACT_ELEMENT_TYPE=0xeac7;var REACT_PORTAL_TYPE=0xeaca;exports.Fragment=0xeacb;var REACT_STRICT_MODE_TYPE=0xeacc;var REACT_PROFILER_TYPE=0xead2;var REACT_PROVIDER_TYPE=0xeacd;var REACT_CONTEXT_TYPE=0xeace;var REACT_FORWARD_REF_TYPE=0xead0;var REACT_SUSPENSE_TYPE=0xead1;var REACT_SUSPENSE_LIST_TYPE=0xead8;var REACT_MEMO_TYPE=0xead3;var REACT_LAZY_TYPE=0xead4;var REACT_BLOCK_TYPE=0xead9;var REACT_SERVER_BLOCK_TYPE=0xeada;var REACT_FUNDAMENTAL_TYPE=0xead5;var REACT_DEBUG_TRACING_MODE_TYPE=0xeae1;var REACT_LEGACY_HIDDEN_TYPE=0xeae3;if(typeof Symbol==='function'&&Symbol.for){var symbolFor=Symbol.for;REACT_ELEMENT_TYPE=symbolFor('react.element');REACT_PORTAL_TYPE=symbolFor('react.portal');exports.Fragment=symbolFor('react.fragment');REACT_STRICT_MODE_TYPE=symbolFor('react.strict_mode');REACT_PROFILER_TYPE=symbolFor('react.profiler');REACT_PROVIDER_TYPE=symbolFor('react.provider');REACT_CONTEXT_TYPE=symbolFor('react.context');REACT_FORWARD_REF_TYPE=symbolFor('react.forward_ref');REACT_SUSPENSE_TYPE=symbolFor('react.suspense');REACT_SUSPENSE_LIST_TYPE=symbolFor('react.suspense_list');REACT_MEMO_TYPE=symbolFor('react.memo');REACT_LAZY_TYPE=symbolFor('react.lazy');REACT_BLOCK_TYPE=symbolFor('react.block');REACT_SERVER_BLOCK_TYPE=symbolFor('react.server.block');REACT_FUNDAMENTAL_TYPE=symbolFor('react.fundamental');symbolFor('react.scope');symbolFor('react.opaque.id');REACT_DEBUG_TRACING_MODE_TYPE=symbolFor('react.debug_trace_mode');symbolFor('react.offscreen');REACT_LEGACY_HIDDEN_TYPE=symbolFor('react.legacy_hidden');}var MAYBE_ITERATOR_SYMBOL=typeof Symbol==='function'&&Symbol.iterator;var FAUX_ITERATOR_SYMBOL='@@iterator';function getIteratorFn(maybeIterable){if(maybeIterable===null||typeof maybeIterable!=='object'){return null;}var maybeIterator=MAYBE_ITERATOR_SYMBOL&&maybeIterable[MAYBE_ITERATOR_SYMBOL]||maybeIterable[FAUX_ITERATOR_SYMBOL];if(typeof maybeIterator==='function'){return maybeIterator;}return null;}var ReactSharedInternals=React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;function error(format){{for(var _len2=arguments.length,args=new Array(_len2>1?_len2-1:0),_key2=1;_key2<_len2;_key2++){args[_key2-1]=arguments[_key2];}printWarning('error',format,args);}}function printWarning(level,format,args){// When changing this logic, you might want to also
// update consoleWithStackDev.www.js as well.
{var ReactDebugCurrentFrame=ReactSharedInternals.ReactDebugCurrentFrame;var stack=ReactDebugCurrentFrame.getStackAddendum();if(stack!==''){format+='%s';args=args.concat([stack]);}var argsWithFormat=args.map(function(item){return ''+item;});// Careful: RN currently depends on this prefix
argsWithFormat.unshift('Warning: '+format);// We intentionally don't use spread (or .apply) directly because it
// breaks IE9: https://github.com/facebook/react/issues/13610
// eslint-disable-next-line react-internal/no-production-logging
Function.prototype.apply.call(console[level],console,argsWithFormat);}}// Filter certain DOM attributes (e.g. src, href) if their values are empty strings.
var enableScopeAPI=false;// Experimental Create Event Handle API.
function isValidElementType(type){if(typeof type==='string'||typeof type==='function'){return true;}// Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).
if(type===exports.Fragment||type===REACT_PROFILER_TYPE||type===REACT_DEBUG_TRACING_MODE_TYPE||type===REACT_STRICT_MODE_TYPE||type===REACT_SUSPENSE_TYPE||type===REACT_SUSPENSE_LIST_TYPE||type===REACT_LEGACY_HIDDEN_TYPE||enableScopeAPI){return true;}if(typeof type==='object'&&type!==null){if(type.$$typeof===REACT_LAZY_TYPE||type.$$typeof===REACT_MEMO_TYPE||type.$$typeof===REACT_PROVIDER_TYPE||type.$$typeof===REACT_CONTEXT_TYPE||type.$$typeof===REACT_FORWARD_REF_TYPE||type.$$typeof===REACT_FUNDAMENTAL_TYPE||type.$$typeof===REACT_BLOCK_TYPE||type[0]===REACT_SERVER_BLOCK_TYPE){return true;}}return false;}function getWrappedName(outerType,innerType,wrapperName){var functionName=innerType.displayName||innerType.name||'';return outerType.displayName||(functionName!==''?wrapperName+"("+functionName+")":wrapperName);}function getContextName(type){return type.displayName||'Context';}function getComponentName(type){if(type==null){// Host root, text node or just invalid type.
return null;}{if(typeof type.tag==='number'){error('Received an unexpected object in getComponentName(). '+'This is likely a bug in React. Please file an issue.');}}if(typeof type==='function'){return type.displayName||type.name||null;}if(typeof type==='string'){return type;}switch(type){case exports.Fragment:return 'Fragment';case REACT_PORTAL_TYPE:return 'Portal';case REACT_PROFILER_TYPE:return 'Profiler';case REACT_STRICT_MODE_TYPE:return 'StrictMode';case REACT_SUSPENSE_TYPE:return 'Suspense';case REACT_SUSPENSE_LIST_TYPE:return 'SuspenseList';}if(typeof type==='object'){switch(type.$$typeof){case REACT_CONTEXT_TYPE:var context=type;return getContextName(context)+'.Consumer';case REACT_PROVIDER_TYPE:var provider=type;return getContextName(provider._context)+'.Provider';case REACT_FORWARD_REF_TYPE:return getWrappedName(type,type.render,'ForwardRef');case REACT_MEMO_TYPE:return getComponentName(type.type);case REACT_BLOCK_TYPE:return getComponentName(type._render);case REACT_LAZY_TYPE:{var lazyComponent=type;var payload=lazyComponent._payload;var init=lazyComponent._init;try{return getComponentName(init(payload));}catch(x){return null;}}}}return null;}// Helpers to patch console.logs to avoid logging during side-effect free
// replaying on render function. This currently only patches the object
// lazily which won't cover if the log function was extracted eagerly.
// We could also eagerly patch the method.
var disabledDepth=0;var prevLog;var prevInfo;var prevWarn;var prevError;var prevGroup;var prevGroupCollapsed;var prevGroupEnd;function disabledLog(){}disabledLog.__reactDisabledLog=true;function disableLogs(){{if(disabledDepth===0){/* eslint-disable react-internal/no-production-logging */prevLog=console.log;prevInfo=console.info;prevWarn=console.warn;prevError=console.error;prevGroup=console.group;prevGroupCollapsed=console.groupCollapsed;prevGroupEnd=console.groupEnd;// https://github.com/facebook/react/issues/19099
var props={configurable:true,enumerable:true,value:disabledLog,writable:true};// $FlowFixMe Flow thinks console is immutable.
Object.defineProperties(console,{info:props,log:props,warn:props,error:props,group:props,groupCollapsed:props,groupEnd:props});/* eslint-enable react-internal/no-production-logging */}disabledDepth++;}}function reenableLogs(){{disabledDepth--;if(disabledDepth===0){/* eslint-disable react-internal/no-production-logging */var props={configurable:true,enumerable:true,writable:true};// $FlowFixMe Flow thinks console is immutable.
Object.defineProperties(console,{log:_assign({},props,{value:prevLog}),info:_assign({},props,{value:prevInfo}),warn:_assign({},props,{value:prevWarn}),error:_assign({},props,{value:prevError}),group:_assign({},props,{value:prevGroup}),groupCollapsed:_assign({},props,{value:prevGroupCollapsed}),groupEnd:_assign({},props,{value:prevGroupEnd})});/* eslint-enable react-internal/no-production-logging */}if(disabledDepth<0){error('disabledDepth fell below zero. '+'This is a bug in React. Please file an issue.');}}}var ReactCurrentDispatcher=ReactSharedInternals.ReactCurrentDispatcher;var prefix;function describeBuiltInComponentFrame(name,source,ownerFn){{if(prefix===undefined){// Extract the VM specific prefix used by each line.
try{throw Error();}catch(x){var match=x.stack.trim().match(/\n( *(at )?)/);prefix=match&&match[1]||'';}}// We use the prefix to ensure our stacks line up with native stack frames.
return '\n'+prefix+name;}}var reentry=false;var componentFrameCache;{var PossiblyWeakMap=typeof WeakMap==='function'?WeakMap:Map;componentFrameCache=new PossiblyWeakMap();}function describeNativeComponentFrame(fn,construct){// If something asked for a stack inside a fake render, it should get ignored.
if(!fn||reentry){return '';}{var frame=componentFrameCache.get(fn);if(frame!==undefined){return frame;}}var control;reentry=true;var previousPrepareStackTrace=Error.prepareStackTrace;// $FlowFixMe It does accept undefined.
Error.prepareStackTrace=undefined;var previousDispatcher;{previousDispatcher=ReactCurrentDispatcher.current;// Set the dispatcher in DEV because this might be call in the render function
// for warnings.
ReactCurrentDispatcher.current=null;disableLogs();}try{// This should throw.
if(construct){// Something should be setting the props in the constructor.
var Fake=function(){throw Error();};// $FlowFixMe
Object.defineProperty(Fake.prototype,'props',{set:function(){// We use a throwing setter instead of frozen or non-writable props
// because that won't throw in a non-strict mode function.
throw Error();}});if(typeof Reflect==='object'&&Reflect.construct){// We construct a different control for this case to include any extra
// frames added by the construct call.
try{Reflect.construct(Fake,[]);}catch(x){control=x;}Reflect.construct(fn,[],Fake);}else {try{Fake.call();}catch(x){control=x;}fn.call(Fake.prototype);}}else {try{throw Error();}catch(x){control=x;}fn();}}catch(sample){// This is inlined manually because closure doesn't do it for us.
if(sample&&control&&typeof sample.stack==='string'){// This extracts the first frame from the sample that isn't also in the control.
// Skipping one frame that we assume is the frame that calls the two.
var sampleLines=sample.stack.split('\n');var controlLines=control.stack.split('\n');var s=sampleLines.length-1;var c=controlLines.length-1;while(s>=1&&c>=0&&sampleLines[s]!==controlLines[c]){// We expect at least one stack frame to be shared.
// Typically this will be the root most one. However, stack frames may be
// cut off due to maximum stack limits. In this case, one maybe cut off
// earlier than the other. We assume that the sample is longer or the same
// and there for cut off earlier. So we should find the root most frame in
// the sample somewhere in the control.
c--;}for(;s>=1&&c>=0;s--,c--){// Next we find the first one that isn't the same which should be the
// frame that called our sample function and the control.
if(sampleLines[s]!==controlLines[c]){// In V8, the first line is describing the message but other VMs don't.
// If we're about to return the first line, and the control is also on the same
// line, that's a pretty good indicator that our sample threw at same line as
// the control. I.e. before we entered the sample frame. So we ignore this result.
// This can happen if you passed a class to function component, or non-function.
if(s!==1||c!==1){do{s--;c--;// We may still have similar intermediate frames from the construct call.
// The next one that isn't the same should be our match though.
if(c<0||sampleLines[s]!==controlLines[c]){// V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
var _frame='\n'+sampleLines[s].replace(' at new ',' at ');{if(typeof fn==='function'){componentFrameCache.set(fn,_frame);}}// Return the line we found.
return _frame;}}while(s>=1&&c>=0);}break;}}}}finally{reentry=false;{ReactCurrentDispatcher.current=previousDispatcher;reenableLogs();}Error.prepareStackTrace=previousPrepareStackTrace;}// Fallback to just using the name if we couldn't make it throw.
var name=fn?fn.displayName||fn.name:'';var syntheticFrame=name?describeBuiltInComponentFrame(name):'';{if(typeof fn==='function'){componentFrameCache.set(fn,syntheticFrame);}}return syntheticFrame;}function describeFunctionComponentFrame(fn,source,ownerFn){{return describeNativeComponentFrame(fn,false);}}function shouldConstruct(Component){var prototype=Component.prototype;return !!(prototype&&prototype.isReactComponent);}function describeUnknownElementTypeFrameInDEV(type,source,ownerFn){if(type==null){return '';}if(typeof type==='function'){{return describeNativeComponentFrame(type,shouldConstruct(type));}}if(typeof type==='string'){return describeBuiltInComponentFrame(type);}switch(type){case REACT_SUSPENSE_TYPE:return describeBuiltInComponentFrame('Suspense');case REACT_SUSPENSE_LIST_TYPE:return describeBuiltInComponentFrame('SuspenseList');}if(typeof type==='object'){switch(type.$$typeof){case REACT_FORWARD_REF_TYPE:return describeFunctionComponentFrame(type.render);case REACT_MEMO_TYPE:// Memo may contain any component type so we recursively resolve it.
return describeUnknownElementTypeFrameInDEV(type.type,source,ownerFn);case REACT_BLOCK_TYPE:return describeFunctionComponentFrame(type._render);case REACT_LAZY_TYPE:{var lazyComponent=type;var payload=lazyComponent._payload;var init=lazyComponent._init;try{// Lazy may contain any component type so we recursively resolve it.
return describeUnknownElementTypeFrameInDEV(init(payload),source,ownerFn);}catch(x){}}}}return '';}var loggedTypeFailures={};var ReactDebugCurrentFrame=ReactSharedInternals.ReactDebugCurrentFrame;function setCurrentlyValidatingElement(element){{if(element){var owner=element._owner;var stack=describeUnknownElementTypeFrameInDEV(element.type,element._source,owner?owner.type:null);ReactDebugCurrentFrame.setExtraStackFrame(stack);}else {ReactDebugCurrentFrame.setExtraStackFrame(null);}}}function checkPropTypes(typeSpecs,values,location,componentName,element){{// $FlowFixMe This is okay but Flow doesn't know it.
var has=Function.call.bind(Object.prototype.hasOwnProperty);for(var typeSpecName in typeSpecs){if(has(typeSpecs,typeSpecName)){var error$1=void 0;// Prop type validation may throw. In case they do, we don't want to
// fail the render phase where it didn't fail before. So we log it.
// After these have been cleaned up, we'll let them throw.
try{// This is intentionally an invariant that gets caught. It's the same
// behavior as without this statement except with a better message.
if(typeof typeSpecs[typeSpecName]!=='function'){var err=Error((componentName||'React class')+': '+location+' type `'+typeSpecName+'` is invalid; '+'it must be a function, usually from the `prop-types` package, but received `'+typeof typeSpecs[typeSpecName]+'`.'+'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');err.name='Invariant Violation';throw err;}error$1=typeSpecs[typeSpecName](values,typeSpecName,componentName,location,null,'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');}catch(ex){error$1=ex;}if(error$1&&!(error$1 instanceof Error)){setCurrentlyValidatingElement(element);error('%s: type specification of %s'+' `%s` is invalid; the type checker '+'function must return `null` or an `Error` but returned a %s. '+'You may have forgotten to pass an argument to the type checker '+'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and '+'shape all require an argument).',componentName||'React class',location,typeSpecName,typeof error$1);setCurrentlyValidatingElement(null);}if(error$1 instanceof Error&&!(error$1.message in loggedTypeFailures)){// Only monitor this failure once because there tends to be a lot of the
// same error.
loggedTypeFailures[error$1.message]=true;setCurrentlyValidatingElement(element);error('Failed %s type: %s',location,error$1.message);setCurrentlyValidatingElement(null);}}}}}var ReactCurrentOwner=ReactSharedInternals.ReactCurrentOwner;var hasOwnProperty=Object.prototype.hasOwnProperty;var RESERVED_PROPS={key:true,ref:true,__self:true,__source:true};var specialPropKeyWarningShown;var specialPropRefWarningShown;var didWarnAboutStringRefs;{didWarnAboutStringRefs={};}function hasValidRef(config){{if(hasOwnProperty.call(config,'ref')){var getter=Object.getOwnPropertyDescriptor(config,'ref').get;if(getter&&getter.isReactWarning){return false;}}}return config.ref!==undefined;}function hasValidKey(config){{if(hasOwnProperty.call(config,'key')){var getter=Object.getOwnPropertyDescriptor(config,'key').get;if(getter&&getter.isReactWarning){return false;}}}return config.key!==undefined;}function warnIfStringRefCannotBeAutoConverted(config,self){{if(typeof config.ref==='string'&&ReactCurrentOwner.current&&self&&ReactCurrentOwner.current.stateNode!==self){var componentName=getComponentName(ReactCurrentOwner.current.type);if(!didWarnAboutStringRefs[componentName]){error('Component "%s" contains the string ref "%s". '+'Support for string refs will be removed in a future major release. '+'This case cannot be automatically converted to an arrow function. '+'We ask you to manually fix this case by using useRef() or createRef() instead. '+'Learn more about using refs safely here: '+'https://reactjs.org/link/strict-mode-string-ref',getComponentName(ReactCurrentOwner.current.type),config.ref);didWarnAboutStringRefs[componentName]=true;}}}}function defineKeyPropWarningGetter(props,displayName){{var warnAboutAccessingKey=function(){if(!specialPropKeyWarningShown){specialPropKeyWarningShown=true;error('%s: `key` is not a prop. Trying to access it will result '+'in `undefined` being returned. If you need to access the same '+'value within the child component, you should pass it as a different '+'prop. (https://reactjs.org/link/special-props)',displayName);}};warnAboutAccessingKey.isReactWarning=true;Object.defineProperty(props,'key',{get:warnAboutAccessingKey,configurable:true});}}function defineRefPropWarningGetter(props,displayName){{var warnAboutAccessingRef=function(){if(!specialPropRefWarningShown){specialPropRefWarningShown=true;error('%s: `ref` is not a prop. Trying to access it will result '+'in `undefined` being returned. If you need to access the same '+'value within the child component, you should pass it as a different '+'prop. (https://reactjs.org/link/special-props)',displayName);}};warnAboutAccessingRef.isReactWarning=true;Object.defineProperty(props,'ref',{get:warnAboutAccessingRef,configurable:true});}}/**
     * Factory method to create a new React element. This no longer adheres to
     * the class pattern, so do not use new to call it. Also, instanceof check
     * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
     * if something is a React Element.
     *
     * @param {*} type
     * @param {*} props
     * @param {*} key
     * @param {string|object} ref
     * @param {*} owner
     * @param {*} self A *temporary* helper to detect places where `this` is
     * different from the `owner` when React.createElement is called, so that we
     * can warn. We want to get rid of owner and replace string `ref`s with arrow
     * functions, and as long as `this` and owner are the same, there will be no
     * change in behavior.
     * @param {*} source An annotation object (added by a transpiler or otherwise)
     * indicating filename, line number, and/or other information.
     * @internal
     */var ReactElement=function(type,key,ref,self,source,owner,props){var element={// This tag allows us to uniquely identify this as a React Element
$$typeof:REACT_ELEMENT_TYPE,// Built-in properties that belong on the element
type:type,key:key,ref:ref,props:props,// Record the component responsible for creating this element.
_owner:owner};{// The validation flag is currently mutative. We put it on
// an external backing store so that we can freeze the whole object.
// This can be replaced with a WeakMap once they are implemented in
// commonly used development environments.
element._store={};// To make comparing ReactElements easier for testing purposes, we make
// the validation flag non-enumerable (where possible, which should
// include every environment we run tests in), so the test framework
// ignores it.
Object.defineProperty(element._store,'validated',{configurable:false,enumerable:false,writable:true,value:false});// self and source are DEV only properties.
Object.defineProperty(element,'_self',{configurable:false,enumerable:false,writable:false,value:self});// Two elements created in two different places should be considered
// equal for testing purposes and therefore we hide it from enumeration.
Object.defineProperty(element,'_source',{configurable:false,enumerable:false,writable:false,value:source});if(Object.freeze){Object.freeze(element.props);Object.freeze(element);}}return element;};/**
     * https://github.com/reactjs/rfcs/pull/107
     * @param {*} type
     * @param {object} props
     * @param {string} key
     */function jsxDEV(type,config,maybeKey,source,self){{var propName;// Reserved names are extracted
var props={};var key=null;var ref=null;// Currently, key can be spread in as a prop. This causes a potential
// issue if key is also explicitly declared (ie. <div {...props} key="Hi" />
// or <div key="Hi" {...props} /> ). We want to deprecate key spread,
// but as an intermediary step, we will use jsxDEV for everything except
// <div {...props} key="Hi" />, because we aren't currently able to tell if
// key is explicitly declared to be undefined or not.
if(maybeKey!==undefined){key=''+maybeKey;}if(hasValidKey(config)){key=''+config.key;}if(hasValidRef(config)){ref=config.ref;warnIfStringRefCannotBeAutoConverted(config,self);}// Remaining properties are added to a new props object
for(propName in config){if(hasOwnProperty.call(config,propName)&&!RESERVED_PROPS.hasOwnProperty(propName)){props[propName]=config[propName];}}// Resolve default props
if(type&&type.defaultProps){var defaultProps=type.defaultProps;for(propName in defaultProps){if(props[propName]===undefined){props[propName]=defaultProps[propName];}}}if(key||ref){var displayName=typeof type==='function'?type.displayName||type.name||'Unknown':type;if(key){defineKeyPropWarningGetter(props,displayName);}if(ref){defineRefPropWarningGetter(props,displayName);}}return ReactElement(type,key,ref,self,source,ReactCurrentOwner.current,props);}}var ReactCurrentOwner$1=ReactSharedInternals.ReactCurrentOwner;var ReactDebugCurrentFrame$1=ReactSharedInternals.ReactDebugCurrentFrame;function setCurrentlyValidatingElement$1(element){{if(element){var owner=element._owner;var stack=describeUnknownElementTypeFrameInDEV(element.type,element._source,owner?owner.type:null);ReactDebugCurrentFrame$1.setExtraStackFrame(stack);}else {ReactDebugCurrentFrame$1.setExtraStackFrame(null);}}}var propTypesMisspellWarningShown;{propTypesMisspellWarningShown=false;}/**
     * Verifies the object is a ReactElement.
     * See https://reactjs.org/docs/react-api.html#isvalidelement
     * @param {?object} object
     * @return {boolean} True if `object` is a ReactElement.
     * @final
     */function isValidElement(object){{return typeof object==='object'&&object!==null&&object.$$typeof===REACT_ELEMENT_TYPE;}}function getDeclarationErrorAddendum(){{if(ReactCurrentOwner$1.current){var name=getComponentName(ReactCurrentOwner$1.current.type);if(name){return '\n\nCheck the render method of `'+name+'`.';}}return '';}}function getSourceInfoErrorAddendum(source){{if(source!==undefined){var fileName=source.fileName.replace(/^.*[\\\/]/,'');var lineNumber=source.lineNumber;return '\n\nCheck your code at '+fileName+':'+lineNumber+'.';}return '';}}/**
     * Warn if there's no key explicitly set on dynamic arrays of children or
     * object keys are not valid. This allows us to keep track of children between
     * updates.
     */var ownerHasKeyUseWarning={};function getCurrentComponentErrorInfo(parentType){{var info=getDeclarationErrorAddendum();if(!info){var parentName=typeof parentType==='string'?parentType:parentType.displayName||parentType.name;if(parentName){info="\n\nCheck the top-level render call using <"+parentName+">.";}}return info;}}/**
     * Warn if the element doesn't have an explicit key assigned to it.
     * This element is in an array. The array could grow and shrink or be
     * reordered. All children that haven't already been validated are required to
     * have a "key" property assigned to it. Error statuses are cached so a warning
     * will only be shown once.
     *
     * @internal
     * @param {ReactElement} element Element that requires a key.
     * @param {*} parentType element's parent's type.
     */function validateExplicitKey(element,parentType){{if(!element._store||element._store.validated||element.key!=null){return;}element._store.validated=true;var currentComponentErrorInfo=getCurrentComponentErrorInfo(parentType);if(ownerHasKeyUseWarning[currentComponentErrorInfo]){return;}ownerHasKeyUseWarning[currentComponentErrorInfo]=true;// Usually the current owner is the offender, but if it accepts children as a
// property, it may be the creator of the child that's responsible for
// assigning it a key.
var childOwner='';if(element&&element._owner&&element._owner!==ReactCurrentOwner$1.current){// Give the component that originally created this child.
childOwner=" It was passed a child from "+getComponentName(element._owner.type)+".";}setCurrentlyValidatingElement$1(element);error('Each child in a list should have a unique "key" prop.'+'%s%s See https://reactjs.org/link/warning-keys for more information.',currentComponentErrorInfo,childOwner);setCurrentlyValidatingElement$1(null);}}/**
     * Ensure that every element either is passed in a static location, in an
     * array with an explicit keys property defined, or in an object literal
     * with valid key property.
     *
     * @internal
     * @param {ReactNode} node Statically passed child of any type.
     * @param {*} parentType node's parent's type.
     */function validateChildKeys(node,parentType){{if(typeof node!=='object'){return;}if(Array.isArray(node)){for(var i=0;i<node.length;i++){var child=node[i];if(isValidElement(child)){validateExplicitKey(child,parentType);}}}else if(isValidElement(node)){// This element was passed in a valid location.
if(node._store){node._store.validated=true;}}else if(node){var iteratorFn=getIteratorFn(node);if(typeof iteratorFn==='function'){// Entry iterators used to provide implicit keys,
// but now we print a separate warning for them later.
if(iteratorFn!==node.entries){var iterator=iteratorFn.call(node);var step;while(!(step=iterator.next()).done){if(isValidElement(step.value)){validateExplicitKey(step.value,parentType);}}}}}}}/**
     * Given an element, validate that its props follow the propTypes definition,
     * provided by the type.
     *
     * @param {ReactElement} element
     */function validatePropTypes(element){{var type=element.type;if(type===null||type===undefined||typeof type==='string'){return;}var propTypes;if(typeof type==='function'){propTypes=type.propTypes;}else if(typeof type==='object'&&(type.$$typeof===REACT_FORWARD_REF_TYPE||// Note: Memo only checks outer props here.
// Inner props are checked in the reconciler.
type.$$typeof===REACT_MEMO_TYPE)){propTypes=type.propTypes;}else {return;}if(propTypes){// Intentionally inside to avoid triggering lazy initializers:
var name=getComponentName(type);checkPropTypes(propTypes,element.props,'prop',name,element);}else if(type.PropTypes!==undefined&&!propTypesMisspellWarningShown){propTypesMisspellWarningShown=true;// Intentionally inside to avoid triggering lazy initializers:
var _name=getComponentName(type);error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?',_name||'Unknown');}if(typeof type.getDefaultProps==='function'&&!type.getDefaultProps.isReactClassApproved){error('getDefaultProps is only used on classic React.createClass '+'definitions. Use a static property named `defaultProps` instead.');}}}/**
     * Given a fragment, validate that it can only be provided with fragment props
     * @param {ReactElement} fragment
     */function validateFragmentProps(fragment){{var keys=Object.keys(fragment.props);for(var i=0;i<keys.length;i++){var key=keys[i];if(key!=='children'&&key!=='key'){setCurrentlyValidatingElement$1(fragment);error('Invalid prop `%s` supplied to `React.Fragment`. '+'React.Fragment can only have `key` and `children` props.',key);setCurrentlyValidatingElement$1(null);break;}}if(fragment.ref!==null){setCurrentlyValidatingElement$1(fragment);error('Invalid attribute `ref` supplied to `React.Fragment`.');setCurrentlyValidatingElement$1(null);}}}function jsxWithValidation(type,props,key,isStaticChildren,source,self){{var validType=isValidElementType(type);// We warn in this case but don't throw. We expect the element creation to
// succeed and there will likely be errors in render.
if(!validType){var info='';if(type===undefined||typeof type==='object'&&type!==null&&Object.keys(type).length===0){info+=' You likely forgot to export your component from the file '+"it's defined in, or you might have mixed up default and named imports.";}var sourceInfo=getSourceInfoErrorAddendum(source);if(sourceInfo){info+=sourceInfo;}else {info+=getDeclarationErrorAddendum();}var typeString;if(type===null){typeString='null';}else if(Array.isArray(type)){typeString='array';}else if(type!==undefined&&type.$$typeof===REACT_ELEMENT_TYPE){typeString="<"+(getComponentName(type.type)||'Unknown')+" />";info=' Did you accidentally export a JSX literal instead of a component?';}else {typeString=typeof type;}error('React.jsx: type is invalid -- expected a string (for '+'built-in components) or a class/function (for composite '+'components) but got: %s.%s',typeString,info);}var element=jsxDEV(type,props,key,source,self);// The result can be nullish if a mock or a custom function is used.
// TODO: Drop this when these are no longer allowed as the type argument.
if(element==null){return element;}// Skip key warning if the type isn't valid since our key validation logic
// doesn't expect a non-string/function type and can throw confusing errors.
// We don't want exception behavior to differ between dev and prod.
// (Rendering will throw with a helpful message and as soon as the type is
// fixed, the key warnings will appear.)
if(validType){var children=props.children;if(children!==undefined){if(isStaticChildren){if(Array.isArray(children)){for(var i=0;i<children.length;i++){validateChildKeys(children[i],type);}if(Object.freeze){Object.freeze(children);}}else {error('React.jsx: Static children should always be an array. '+'You are likely explicitly calling React.jsxs or React.jsxDEV. '+'Use the Babel transform instead.');}}else {validateChildKeys(children,type);}}}if(type===exports.Fragment){validateFragmentProps(element);}else {validatePropTypes(element);}return element;}}// These two functions exist to still get child warnings in dev
// even with the prod transform. This means that jsxDEV is purely
// opt-in behavior for better messages but that we won't stop
// giving you warnings if you use production apis.
function jsxWithValidationStatic(type,props,key){{return jsxWithValidation(type,props,key,true);}}function jsxWithValidationDynamic(type,props,key){{return jsxWithValidation(type,props,key,false);}}var jsx=jsxWithValidationDynamic;// we may want to special case jsxs internally to take advantage of static children.
// for now we can ship identical prod functions
var jsxs=jsxWithValidationStatic;exports.jsx=jsx;exports.jsxs=jsxs;})();}})(reactJsxRuntime_development$1);if(process.env.NODE_ENV==='production'){jsxRuntime$1.exports=reactJsxRuntime_production_min$1;}else {jsxRuntime$1.exports=reactJsxRuntime_development$1;}let cache;if(typeof document==='object'){cache=createCache$1({key:'css',prepend:true});}function StyledEngineProvider(props){const{injectFirst,children}=props;return injectFirst&&cache?/*#__PURE__*/jsxRuntime$1.exports.jsx(CacheProvider,{value:cache,children:children}):children;}process.env.NODE_ENV!=="production"?StyledEngineProvider.propTypes={/**
   * Your component tree.
   */children:PropTypes.node,/**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override MUI's styles, set this prop.
   */injectFirst:PropTypes.bool}:void 0;function isEmpty$1(obj){return obj===undefined||obj===null||Object.keys(obj).length===0;}function GlobalStyles(props){const{styles,defaultTheme={}}=props;const globalStyles=typeof styles==='function'?themeInput=>styles(isEmpty$1(themeInput)?defaultTheme:themeInput):styles;return/*#__PURE__*/jsxRuntime$1.exports.jsx(Global,{styles:globalStyles});}process.env.NODE_ENV!=="production"?GlobalStyles.propTypes={defaultTheme:PropTypes.object,styles:PropTypes.oneOfType([PropTypes.array,PropTypes.string,PropTypes.object,PropTypes.func])}:void 0;/**
 * @mui/styled-engine v5.15.11
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */function styled$2(tag,options){const stylesFactory=newStyled$1(tag,options);if(process.env.NODE_ENV!=='production'){return (...styles)=>{const component=typeof tag==='string'?`"${tag}"`:'component';if(styles.length===0){console.error([`MUI: Seems like you called \`styled(${component})()\` without a \`style\` argument.`,'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join('\n'));}else if(styles.some(style=>style===undefined)){console.error(`MUI: the styled(${component})(...args) API requires all its args to be defined.`);}return stylesFactory(...styles);};}return stylesFactory;}// eslint-disable-next-line @typescript-eslint/naming-convention
const internal_processStyles=(tag,processor)=>{// Emotion attaches all the styles as `__emotion_styles`.
// Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
if(Array.isArray(tag.__emotion_styles)){tag.__emotion_styles=processor(tag.__emotion_styles);}};var styledEngine=/*#__PURE__*/Object.freeze({__proto__:null,'default':styled$2,internal_processStyles:internal_processStyles,ThemeContext:ThemeContext$1,keyframes:keyframes,css:css,StyledEngineProvider:StyledEngineProvider,GlobalStyles:GlobalStyles});// https://github.com/sindresorhus/is-plain-obj/blob/main/index.js
function isPlainObject(item){if(typeof item!=='object'||item===null){return false;}const prototype=Object.getPrototypeOf(item);return (prototype===null||prototype===Object.prototype||Object.getPrototypeOf(prototype)===null)&&!(Symbol.toStringTag in item)&&!(Symbol.iterator in item);}function deepClone(source){if(!isPlainObject(source)){return source;}const output={};Object.keys(source).forEach(key=>{output[key]=deepClone(source[key]);});return output;}function deepmerge$1(target,source,options={clone:true}){const output=options.clone?_extends$2({},target):target;if(isPlainObject(target)&&isPlainObject(source)){Object.keys(source).forEach(key=>{// Avoid prototype pollution
if(key==='__proto__'){return;}if(isPlainObject(source[key])&&key in target&&isPlainObject(target[key])){// Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
output[key]=deepmerge$1(target[key],source[key],options);}else if(options.clone){output[key]=isPlainObject(source[key])?deepClone(source[key]):source[key];}else {output[key]=source[key];}});}return output;}var deepmerge=/*#__PURE__*/Object.freeze({__proto__:null,'default':deepmerge$1,isPlainObject:isPlainObject});const _excluded$a=["values","unit","step"];const sortBreakpointsValues=values=>{const breakpointsAsArray=Object.keys(values).map(key=>({key,val:values[key]}))||[];// Sort in ascending order
breakpointsAsArray.sort((breakpoint1,breakpoint2)=>breakpoint1.val-breakpoint2.val);return breakpointsAsArray.reduce((acc,obj)=>{return _extends$2({},acc,{[obj.key]:obj.val});},{});};// Keep in mind that @media is inclusive by the CSS specification.
function createBreakpoints(breakpoints){const{// The breakpoint **start** at this value.
// For instance with the first breakpoint xs: [xs, sm).
values={xs:0,// phone
sm:600,// tablet
md:900,// small laptop
lg:1200,// desktop
xl:1536// large screen
},unit='px',step=5}=breakpoints,other=_objectWithoutPropertiesLoose$1(breakpoints,_excluded$a);const sortedValues=sortBreakpointsValues(values);const keys=Object.keys(sortedValues);function up(key){const value=typeof values[key]==='number'?values[key]:key;return `@media (min-width:${value}${unit})`;}function down(key){const value=typeof values[key]==='number'?values[key]:key;return `@media (max-width:${value-step/100}${unit})`;}function between(start,end){const endIndex=keys.indexOf(end);return `@media (min-width:${typeof values[start]==='number'?values[start]:start}${unit}) and `+`(max-width:${(endIndex!==-1&&typeof values[keys[endIndex]]==='number'?values[keys[endIndex]]:end)-step/100}${unit})`;}function only(key){if(keys.indexOf(key)+1<keys.length){return between(key,keys[keys.indexOf(key)+1]);}return up(key);}function not(key){// handle first and last key separately, for better readability
const keyIndex=keys.indexOf(key);if(keyIndex===0){return up(keys[1]);}if(keyIndex===keys.length-1){return down(keys[keyIndex]);}return between(key,keys[keys.indexOf(key)+1]).replace('@media','@media not all and');}return _extends$2({keys,values:sortedValues,up,down,between,only,not,unit},other);}const shape={borderRadius:4};var shape$1=shape;const responsivePropType=process.env.NODE_ENV!=='production'?PropTypes.oneOfType([PropTypes.number,PropTypes.string,PropTypes.object,PropTypes.array]):{};var responsivePropType$1=responsivePropType;function merge(acc,item){if(!item){return acc;}return deepmerge$1(acc,item,{clone:false// No need to clone deep, it's way faster.
});}// The breakpoint **start** at this value.
// For instance with the first breakpoint xs: [xs, sm[.
const values={xs:0,// phone
sm:600,// tablet
md:900,// small laptop
lg:1200,// desktop
xl:1536// large screen
};const defaultBreakpoints={// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
keys:['xs','sm','md','lg','xl'],up:key=>`@media (min-width:${values[key]}px)`};function handleBreakpoints(props,propValue,styleFromPropValue){const theme=props.theme||{};if(Array.isArray(propValue)){const themeBreakpoints=theme.breakpoints||defaultBreakpoints;return propValue.reduce((acc,item,index)=>{acc[themeBreakpoints.up(themeBreakpoints.keys[index])]=styleFromPropValue(propValue[index]);return acc;},{});}if(typeof propValue==='object'){const themeBreakpoints=theme.breakpoints||defaultBreakpoints;return Object.keys(propValue).reduce((acc,breakpoint)=>{// key is breakpoint
if(Object.keys(themeBreakpoints.values||values).indexOf(breakpoint)!==-1){const mediaKey=themeBreakpoints.up(breakpoint);acc[mediaKey]=styleFromPropValue(propValue[breakpoint],breakpoint);}else {const cssKey=breakpoint;acc[cssKey]=propValue[cssKey];}return acc;},{});}const output=styleFromPropValue(propValue);return output;}function createEmptyBreakpointObject(breakpointsInput={}){var _breakpointsInput$key;const breakpointsInOrder=(_breakpointsInput$key=breakpointsInput.keys)==null?void 0:_breakpointsInput$key.reduce((acc,key)=>{const breakpointStyleKey=breakpointsInput.up(key);acc[breakpointStyleKey]={};return acc;},{});return breakpointsInOrder||{};}function removeUnusedBreakpoints(breakpointKeys,style){return breakpointKeys.reduce((acc,key)=>{const breakpointOutput=acc[key];const isBreakpointUnused=!breakpointOutput||Object.keys(breakpointOutput).length===0;if(isBreakpointUnused){delete acc[key];}return acc;},style);}// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word in the sentence.
// We only handle the first word.
function capitalize$2(string){if(typeof string!=='string'){throw new Error(process.env.NODE_ENV!=="production"?`MUI: \`capitalize(string)\` expects a string argument.`:formatMuiErrorMessage$1(7));}return string.charAt(0).toUpperCase()+string.slice(1);}var capitalize$1=/*#__PURE__*/Object.freeze({__proto__:null,'default':capitalize$2});function getPath(obj,path,checkVars=true){if(!path||typeof path!=='string'){return null;}// Check if CSS variables are used
if(obj&&obj.vars&&checkVars){const val=`vars.${path}`.split('.').reduce((acc,item)=>acc&&acc[item]?acc[item]:null,obj);if(val!=null){return val;}}return path.split('.').reduce((acc,item)=>{if(acc&&acc[item]!=null){return acc[item];}return null;},obj);}function getStyleValue(themeMapping,transform,propValueFinal,userValue=propValueFinal){let value;if(typeof themeMapping==='function'){value=themeMapping(propValueFinal);}else if(Array.isArray(themeMapping)){value=themeMapping[propValueFinal]||userValue;}else {value=getPath(themeMapping,propValueFinal)||userValue;}if(transform){value=transform(value,userValue,themeMapping);}return value;}function style$2(options){const{prop,cssProperty=options.prop,themeKey,transform}=options;// false positive
// eslint-disable-next-line react/function-component-definition
const fn=props=>{if(props[prop]==null){return null;}const propValue=props[prop];const theme=props.theme;const themeMapping=getPath(theme,themeKey)||{};const styleFromPropValue=propValueFinal=>{let value=getStyleValue(themeMapping,transform,propValueFinal);if(propValueFinal===value&&typeof propValueFinal==='string'){// Haven't found value
value=getStyleValue(themeMapping,transform,`${prop}${propValueFinal==='default'?'':capitalize$2(propValueFinal)}`,propValueFinal);}if(cssProperty===false){return value;}return {[cssProperty]:value};};return handleBreakpoints(props,propValue,styleFromPropValue);};fn.propTypes=process.env.NODE_ENV!=='production'?{[prop]:responsivePropType$1}:{};fn.filterProps=[prop];return fn;}function memoize$3(fn){const cache={};return arg=>{if(cache[arg]===undefined){cache[arg]=fn(arg);}return cache[arg];};}const properties={m:'margin',p:'padding'};const directions={t:'Top',r:'Right',b:'Bottom',l:'Left',x:['Left','Right'],y:['Top','Bottom']};const aliases={marginX:'mx',marginY:'my',paddingX:'px',paddingY:'py'};// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const getCssProperties=memoize$3(prop=>{// It's not a shorthand notation.
if(prop.length>2){if(aliases[prop]){prop=aliases[prop];}else {return [prop];}}const[a,b]=prop.split('');const property=properties[a];const direction=directions[b]||'';return Array.isArray(direction)?direction.map(dir=>property+dir):[property+direction];});const marginKeys=['m','mt','mr','mb','ml','mx','my','margin','marginTop','marginRight','marginBottom','marginLeft','marginX','marginY','marginInline','marginInlineStart','marginInlineEnd','marginBlock','marginBlockStart','marginBlockEnd'];const paddingKeys=['p','pt','pr','pb','pl','px','py','padding','paddingTop','paddingRight','paddingBottom','paddingLeft','paddingX','paddingY','paddingInline','paddingInlineStart','paddingInlineEnd','paddingBlock','paddingBlockStart','paddingBlockEnd'];const spacingKeys=[...marginKeys,...paddingKeys];function createUnaryUnit(theme,themeKey,defaultValue,propName){var _getPath;const themeSpacing=(_getPath=getPath(theme,themeKey,false))!=null?_getPath:defaultValue;if(typeof themeSpacing==='number'){return abs=>{if(typeof abs==='string'){return abs;}if(process.env.NODE_ENV!=='production'){if(typeof abs!=='number'){console.error(`MUI: Expected ${propName} argument to be a number or a string, got ${abs}.`);}}return themeSpacing*abs;};}if(Array.isArray(themeSpacing)){return abs=>{if(typeof abs==='string'){return abs;}if(process.env.NODE_ENV!=='production'){if(!Number.isInteger(abs)){console.error([`MUI: The \`theme.${themeKey}\` array type cannot be combined with non integer values.`+`You should either use an integer value that can be used as index, or define the \`theme.${themeKey}\` as a number.`].join('\n'));}else if(abs>themeSpacing.length-1){console.error([`MUI: The value provided (${abs}) overflows.`,`The supported values are: ${JSON.stringify(themeSpacing)}.`,`${abs} > ${themeSpacing.length-1}, you need to add the missing values.`].join('\n'));}}return themeSpacing[abs];};}if(typeof themeSpacing==='function'){return themeSpacing;}if(process.env.NODE_ENV!=='production'){console.error([`MUI: The \`theme.${themeKey}\` value (${themeSpacing}) is invalid.`,'It should be a number, an array or a function.'].join('\n'));}return ()=>undefined;}function createUnarySpacing(theme){return createUnaryUnit(theme,'spacing',8,'spacing');}function getValue(transformer,propValue){if(typeof propValue==='string'||propValue==null){return propValue;}const abs=Math.abs(propValue);const transformed=transformer(abs);if(propValue>=0){return transformed;}if(typeof transformed==='number'){return -transformed;}return `-${transformed}`;}function getStyleFromPropValue(cssProperties,transformer){return propValue=>cssProperties.reduce((acc,cssProperty)=>{acc[cssProperty]=getValue(transformer,propValue);return acc;},{});}function resolveCssProperty(props,keys,prop,transformer){// Using a hash computation over an array iteration could be faster, but with only 28 items,
// it's doesn't worth the bundle size.
if(keys.indexOf(prop)===-1){return null;}const cssProperties=getCssProperties(prop);const styleFromPropValue=getStyleFromPropValue(cssProperties,transformer);const propValue=props[prop];return handleBreakpoints(props,propValue,styleFromPropValue);}function style$1(props,keys){const transformer=createUnarySpacing(props.theme);return Object.keys(props).map(prop=>resolveCssProperty(props,keys,prop,transformer)).reduce(merge,{});}function margin(props){return style$1(props,marginKeys);}margin.propTypes=process.env.NODE_ENV!=='production'?marginKeys.reduce((obj,key)=>{obj[key]=responsivePropType$1;return obj;},{}):{};margin.filterProps=marginKeys;function padding(props){return style$1(props,paddingKeys);}padding.propTypes=process.env.NODE_ENV!=='production'?paddingKeys.reduce((obj,key)=>{obj[key]=responsivePropType$1;return obj;},{}):{};padding.filterProps=paddingKeys;process.env.NODE_ENV!=='production'?spacingKeys.reduce((obj,key)=>{obj[key]=responsivePropType$1;return obj;},{}):{};// The different signatures imply different meaning for their arguments that can't be expressed structurally.
// We express the difference with variable names.
function createSpacing(spacingInput=8){// Already transformed.
if(spacingInput.mui){return spacingInput;}// Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
// Smaller components, such as icons, can align to a 4dp grid.
// https://m2.material.io/design/layout/understanding-layout.html
const transform=createUnarySpacing({spacing:spacingInput});const spacing=(...argsInput)=>{if(process.env.NODE_ENV!=='production'){if(!(argsInput.length<=4)){console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${argsInput.length}`);}}const args=argsInput.length===0?[1]:argsInput;return args.map(argument=>{const output=transform(argument);return typeof output==='number'?`${output}px`:output;}).join(' ');};spacing.mui=true;return spacing;}function compose(...styles){const handlers=styles.reduce((acc,style)=>{style.filterProps.forEach(prop=>{acc[prop]=style;});return acc;},{});// false positive
// eslint-disable-next-line react/function-component-definition
const fn=props=>{return Object.keys(props).reduce((acc,prop)=>{if(handlers[prop]){return merge(acc,handlers[prop](props));}return acc;},{});};fn.propTypes=process.env.NODE_ENV!=='production'?styles.reduce((acc,style)=>Object.assign(acc,style.propTypes),{}):{};fn.filterProps=styles.reduce((acc,style)=>acc.concat(style.filterProps),[]);return fn;}function borderTransform(value){if(typeof value!=='number'){return value;}return `${value}px solid`;}function createBorderStyle(prop,transform){return style$2({prop,themeKey:'borders',transform});}const border$1=createBorderStyle('border',borderTransform);const borderTop=createBorderStyle('borderTop',borderTransform);const borderRight=createBorderStyle('borderRight',borderTransform);const borderBottom=createBorderStyle('borderBottom',borderTransform);const borderLeft=createBorderStyle('borderLeft',borderTransform);const borderColor=createBorderStyle('borderColor');const borderTopColor=createBorderStyle('borderTopColor');const borderRightColor=createBorderStyle('borderRightColor');const borderBottomColor=createBorderStyle('borderBottomColor');const borderLeftColor=createBorderStyle('borderLeftColor');const outline=createBorderStyle('outline',borderTransform);const outlineColor=createBorderStyle('outlineColor');// false positive
// eslint-disable-next-line react/function-component-definition
const borderRadius=props=>{if(props.borderRadius!==undefined&&props.borderRadius!==null){const transformer=createUnaryUnit(props.theme,'shape.borderRadius',4,'borderRadius');const styleFromPropValue=propValue=>({borderRadius:getValue(transformer,propValue)});return handleBreakpoints(props,props.borderRadius,styleFromPropValue);}return null;};borderRadius.propTypes=process.env.NODE_ENV!=='production'?{borderRadius:responsivePropType$1}:{};borderRadius.filterProps=['borderRadius'];compose(border$1,borderTop,borderRight,borderBottom,borderLeft,borderColor,borderTopColor,borderRightColor,borderBottomColor,borderLeftColor,borderRadius,outline,outlineColor);// false positive
// eslint-disable-next-line react/function-component-definition
const gap=props=>{if(props.gap!==undefined&&props.gap!==null){const transformer=createUnaryUnit(props.theme,'spacing',8,'gap');const styleFromPropValue=propValue=>({gap:getValue(transformer,propValue)});return handleBreakpoints(props,props.gap,styleFromPropValue);}return null;};gap.propTypes=process.env.NODE_ENV!=='production'?{gap:responsivePropType$1}:{};gap.filterProps=['gap'];// false positive
// eslint-disable-next-line react/function-component-definition
const columnGap=props=>{if(props.columnGap!==undefined&&props.columnGap!==null){const transformer=createUnaryUnit(props.theme,'spacing',8,'columnGap');const styleFromPropValue=propValue=>({columnGap:getValue(transformer,propValue)});return handleBreakpoints(props,props.columnGap,styleFromPropValue);}return null;};columnGap.propTypes=process.env.NODE_ENV!=='production'?{columnGap:responsivePropType$1}:{};columnGap.filterProps=['columnGap'];// false positive
// eslint-disable-next-line react/function-component-definition
const rowGap=props=>{if(props.rowGap!==undefined&&props.rowGap!==null){const transformer=createUnaryUnit(props.theme,'spacing',8,'rowGap');const styleFromPropValue=propValue=>({rowGap:getValue(transformer,propValue)});return handleBreakpoints(props,props.rowGap,styleFromPropValue);}return null;};rowGap.propTypes=process.env.NODE_ENV!=='production'?{rowGap:responsivePropType$1}:{};rowGap.filterProps=['rowGap'];const gridColumn=style$2({prop:'gridColumn'});const gridRow=style$2({prop:'gridRow'});const gridAutoFlow=style$2({prop:'gridAutoFlow'});const gridAutoColumns=style$2({prop:'gridAutoColumns'});const gridAutoRows=style$2({prop:'gridAutoRows'});const gridTemplateColumns=style$2({prop:'gridTemplateColumns'});const gridTemplateRows=style$2({prop:'gridTemplateRows'});const gridTemplateAreas=style$2({prop:'gridTemplateAreas'});const gridArea=style$2({prop:'gridArea'});compose(gap,columnGap,rowGap,gridColumn,gridRow,gridAutoFlow,gridAutoColumns,gridAutoRows,gridTemplateColumns,gridTemplateRows,gridTemplateAreas,gridArea);function paletteTransform(value,userValue){if(userValue==='grey'){return userValue;}return value;}const color=style$2({prop:'color',themeKey:'palette',transform:paletteTransform});const bgcolor=style$2({prop:'bgcolor',cssProperty:'backgroundColor',themeKey:'palette',transform:paletteTransform});const backgroundColor=style$2({prop:'backgroundColor',themeKey:'palette',transform:paletteTransform});compose(color,bgcolor,backgroundColor);function sizingTransform(value){return value<=1&&value!==0?`${value*100}%`:value;}const width=style$2({prop:'width',transform:sizingTransform});const maxWidth=props=>{if(props.maxWidth!==undefined&&props.maxWidth!==null){const styleFromPropValue=propValue=>{var _props$theme,_props$theme2;const breakpoint=((_props$theme=props.theme)==null||(_props$theme=_props$theme.breakpoints)==null||(_props$theme=_props$theme.values)==null?void 0:_props$theme[propValue])||values[propValue];if(!breakpoint){return {maxWidth:sizingTransform(propValue)};}if(((_props$theme2=props.theme)==null||(_props$theme2=_props$theme2.breakpoints)==null?void 0:_props$theme2.unit)!=='px'){return {maxWidth:`${breakpoint}${props.theme.breakpoints.unit}`};}return {maxWidth:breakpoint};};return handleBreakpoints(props,props.maxWidth,styleFromPropValue);}return null;};maxWidth.filterProps=['maxWidth'];const minWidth=style$2({prop:'minWidth',transform:sizingTransform});const height=style$2({prop:'height',transform:sizingTransform});const maxHeight=style$2({prop:'maxHeight',transform:sizingTransform});const minHeight=style$2({prop:'minHeight',transform:sizingTransform});style$2({prop:'size',cssProperty:'width',transform:sizingTransform});style$2({prop:'size',cssProperty:'height',transform:sizingTransform});const boxSizing=style$2({prop:'boxSizing'});compose(width,maxWidth,minWidth,height,maxHeight,minHeight,boxSizing);const defaultSxConfig={// borders
border:{themeKey:'borders',transform:borderTransform},borderTop:{themeKey:'borders',transform:borderTransform},borderRight:{themeKey:'borders',transform:borderTransform},borderBottom:{themeKey:'borders',transform:borderTransform},borderLeft:{themeKey:'borders',transform:borderTransform},borderColor:{themeKey:'palette'},borderTopColor:{themeKey:'palette'},borderRightColor:{themeKey:'palette'},borderBottomColor:{themeKey:'palette'},borderLeftColor:{themeKey:'palette'},outline:{themeKey:'borders',transform:borderTransform},outlineColor:{themeKey:'palette'},borderRadius:{themeKey:'shape.borderRadius',style:borderRadius},// palette
color:{themeKey:'palette',transform:paletteTransform},bgcolor:{themeKey:'palette',cssProperty:'backgroundColor',transform:paletteTransform},backgroundColor:{themeKey:'palette',transform:paletteTransform},// spacing
p:{style:padding},pt:{style:padding},pr:{style:padding},pb:{style:padding},pl:{style:padding},px:{style:padding},py:{style:padding},padding:{style:padding},paddingTop:{style:padding},paddingRight:{style:padding},paddingBottom:{style:padding},paddingLeft:{style:padding},paddingX:{style:padding},paddingY:{style:padding},paddingInline:{style:padding},paddingInlineStart:{style:padding},paddingInlineEnd:{style:padding},paddingBlock:{style:padding},paddingBlockStart:{style:padding},paddingBlockEnd:{style:padding},m:{style:margin},mt:{style:margin},mr:{style:margin},mb:{style:margin},ml:{style:margin},mx:{style:margin},my:{style:margin},margin:{style:margin},marginTop:{style:margin},marginRight:{style:margin},marginBottom:{style:margin},marginLeft:{style:margin},marginX:{style:margin},marginY:{style:margin},marginInline:{style:margin},marginInlineStart:{style:margin},marginInlineEnd:{style:margin},marginBlock:{style:margin},marginBlockStart:{style:margin},marginBlockEnd:{style:margin},// display
displayPrint:{cssProperty:false,transform:value=>({'@media print':{display:value}})},display:{},overflow:{},textOverflow:{},visibility:{},whiteSpace:{},// flexbox
flexBasis:{},flexDirection:{},flexWrap:{},justifyContent:{},alignItems:{},alignContent:{},order:{},flex:{},flexGrow:{},flexShrink:{},alignSelf:{},justifyItems:{},justifySelf:{},// grid
gap:{style:gap},rowGap:{style:rowGap},columnGap:{style:columnGap},gridColumn:{},gridRow:{},gridAutoFlow:{},gridAutoColumns:{},gridAutoRows:{},gridTemplateColumns:{},gridTemplateRows:{},gridTemplateAreas:{},gridArea:{},// positions
position:{},zIndex:{themeKey:'zIndex'},top:{},right:{},bottom:{},left:{},// shadows
boxShadow:{themeKey:'shadows'},// sizing
width:{transform:sizingTransform},maxWidth:{style:maxWidth},minWidth:{transform:sizingTransform},height:{transform:sizingTransform},maxHeight:{transform:sizingTransform},minHeight:{transform:sizingTransform},boxSizing:{},// typography
fontFamily:{themeKey:'typography'},fontSize:{themeKey:'typography'},fontStyle:{themeKey:'typography'},fontWeight:{themeKey:'typography'},letterSpacing:{},textTransform:{},lineHeight:{},textAlign:{},typography:{cssProperty:false,themeKey:'typography'}};var defaultSxConfig$1=defaultSxConfig;function objectsHaveSameKeys(...objects){const allKeys=objects.reduce((keys,object)=>keys.concat(Object.keys(object)),[]);const union=new Set(allKeys);return objects.every(object=>union.size===Object.keys(object).length);}function callIfFn(maybeFn,arg){return typeof maybeFn==='function'?maybeFn(arg):maybeFn;}// eslint-disable-next-line @typescript-eslint/naming-convention
function unstable_createStyleFunctionSx(){function getThemeValue(prop,val,theme,config){const props={[prop]:val,theme};const options=config[prop];if(!options){return {[prop]:val};}const{cssProperty=prop,themeKey,transform,style}=options;if(val==null){return null;}// TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
if(themeKey==='typography'&&val==='inherit'){return {[prop]:val};}const themeMapping=getPath(theme,themeKey)||{};if(style){return style(props);}const styleFromPropValue=propValueFinal=>{let value=getStyleValue(themeMapping,transform,propValueFinal);if(propValueFinal===value&&typeof propValueFinal==='string'){// Haven't found value
value=getStyleValue(themeMapping,transform,`${prop}${propValueFinal==='default'?'':capitalize$2(propValueFinal)}`,propValueFinal);}if(cssProperty===false){return value;}return {[cssProperty]:value};};return handleBreakpoints(props,val,styleFromPropValue);}function styleFunctionSx(props){var _theme$unstable_sxCon;const{sx,theme={}}=props||{};if(!sx){return null;// Emotion & styled-components will neglect null
}const config=(_theme$unstable_sxCon=theme.unstable_sxConfig)!=null?_theme$unstable_sxCon:defaultSxConfig$1;/*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */function traverse(sxInput){let sxObject=sxInput;if(typeof sxInput==='function'){sxObject=sxInput(theme);}else if(typeof sxInput!=='object'){// value
return sxInput;}if(!sxObject){return null;}const emptyBreakpoints=createEmptyBreakpointObject(theme.breakpoints);const breakpointsKeys=Object.keys(emptyBreakpoints);let css=emptyBreakpoints;Object.keys(sxObject).forEach(styleKey=>{const value=callIfFn(sxObject[styleKey],theme);if(value!==null&&value!==undefined){if(typeof value==='object'){if(config[styleKey]){css=merge(css,getThemeValue(styleKey,value,theme,config));}else {const breakpointsValues=handleBreakpoints({theme},value,x=>({[styleKey]:x}));if(objectsHaveSameKeys(breakpointsValues,value)){css[styleKey]=styleFunctionSx({sx:value,theme});}else {css=merge(css,breakpointsValues);}}}else {css=merge(css,getThemeValue(styleKey,value,theme,config));}}});return removeUnusedBreakpoints(breakpointsKeys,css);}return Array.isArray(sx)?sx.map(traverse):traverse(sx);}return styleFunctionSx;}const styleFunctionSx$1=unstable_createStyleFunctionSx();styleFunctionSx$1.filterProps=['sx'];var styleFunctionSx$2=styleFunctionSx$1;/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */function applyStyles(key,styles){// @ts-expect-error this is 'any' type
const theme=this;if(theme.vars&&typeof theme.getColorSchemeSelector==='function'){// If CssVarsProvider is used as a provider,
// returns '* :where([data-mui-color-scheme="light|dark"]) &'
const selector=theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/,'*:where($1)');return {[selector]:styles};}if(theme.palette.mode===key){return styles;}return {};}const _excluded$9=["breakpoints","palette","spacing","shape"];function createTheme$2(options={},...args){const{breakpoints:breakpointsInput={},palette:paletteInput={},spacing:spacingInput,shape:shapeInput={}}=options,other=_objectWithoutPropertiesLoose$1(options,_excluded$9);const breakpoints=createBreakpoints(breakpointsInput);const spacing=createSpacing(spacingInput);let muiTheme=deepmerge$1({breakpoints,direction:'ltr',components:{},// Inject component definitions.
palette:_extends$2({mode:'light'},paletteInput),spacing,shape:_extends$2({},shape$1,shapeInput)},other);muiTheme.applyStyles=applyStyles;muiTheme=args.reduce((acc,argument)=>deepmerge$1(acc,argument),muiTheme);muiTheme.unstable_sxConfig=_extends$2({},defaultSxConfig$1,other==null?void 0:other.unstable_sxConfig);muiTheme.unstable_sx=function sx(props){return styleFunctionSx$2({sx:props,theme:this});};return muiTheme;}var createTheme$1=/*#__PURE__*/Object.freeze({__proto__:null,'default':createTheme$2,private_createBreakpoints:createBreakpoints,unstable_applyStyles:applyStyles});function isObjectEmpty(obj){return Object.keys(obj).length===0;}function useTheme$2(defaultTheme=null){const contextTheme=React.useContext(ThemeContext$1);return !contextTheme||isObjectEmpty(contextTheme)?defaultTheme:contextTheme;}const systemDefaultTheme$1=createTheme$2();function useTheme$1(defaultTheme=systemDefaultTheme$1){return useTheme$2(defaultTheme);}const _excluded$8=["sx"];const splitProps=props=>{var _props$theme$unstable,_props$theme;const result={systemProps:{},otherProps:{}};const config=(_props$theme$unstable=props==null||(_props$theme=props.theme)==null?void 0:_props$theme.unstable_sxConfig)!=null?_props$theme$unstable:defaultSxConfig$1;Object.keys(props).forEach(prop=>{if(config[prop]){result.systemProps[prop]=props[prop];}else {result.otherProps[prop]=props[prop];}});return result;};function extendSxProp(props){const{sx:inSx}=props,other=_objectWithoutPropertiesLoose$1(props,_excluded$8);const{systemProps,otherProps}=splitProps(other);let finalSx;if(Array.isArray(inSx)){finalSx=[systemProps,...inSx];}else if(typeof inSx==='function'){finalSx=(...args)=>{const result=inSx(...args);if(!isPlainObject(result)){return systemProps;}return _extends$2({},systemProps,result);};}else {finalSx=_extends$2({},systemProps,inSx);}return _extends$2({},otherProps,{sx:finalSx});}var styleFunctionSx=/*#__PURE__*/Object.freeze({__proto__:null,'default':styleFunctionSx$2,unstable_createStyleFunctionSx:unstable_createStyleFunctionSx,extendSxProp:extendSxProp,unstable_defaultSxConfig:defaultSxConfig$1});const defaultGenerator=componentName=>componentName;const createClassNameGenerator=()=>{let generate=defaultGenerator;return {configure(generator){generate=generator;},generate(componentName){return generate(componentName);},reset(){generate=defaultGenerator;}};};const ClassNameGenerator=createClassNameGenerator();var ClassNameGenerator$1=ClassNameGenerator;const globalStateClasses={active:'active',checked:'checked',completed:'completed',disabled:'disabled',error:'error',expanded:'expanded',focused:'focused',focusVisible:'focusVisible',open:'open',readOnly:'readOnly',required:'required',selected:'selected'};function generateUtilityClass(componentName,slot,globalStatePrefix='Mui'){const globalStateClass=globalStateClasses[slot];return globalStateClass?`${globalStatePrefix}-${globalStateClass}`:`${ClassNameGenerator$1.generate(componentName)}-${slot}`;}function generateUtilityClasses(componentName,slots,globalStatePrefix='Mui'){const result={};slots.forEach(slot=>{result[slot]=generateUtilityClass(componentName,slot,globalStatePrefix);});return result;}var reactIs={exports:{}};var reactIs_production_min={};/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */var b$7=Symbol.for("react.element"),c$8=Symbol.for("react.portal"),d$a=Symbol.for("react.fragment"),e$5=Symbol.for("react.strict_mode"),f$b=Symbol.for("react.profiler"),g$5=Symbol.for("react.provider"),h$8=Symbol.for("react.context"),k$4=Symbol.for("react.server_context"),l$8=Symbol.for("react.forward_ref"),m$6=Symbol.for("react.suspense"),n$8=Symbol.for("react.suspense_list"),p$9=Symbol.for("react.memo"),q$5=Symbol.for("react.lazy"),t$b=Symbol.for("react.offscreen"),u$a;u$a=Symbol.for("react.module.reference");function v$8(a){if("object"===typeof a&&null!==a){var r=a.$$typeof;switch(r){case b$7:switch(a=a.type,a){case d$a:case f$b:case e$5:case m$6:case n$8:return a;default:switch(a=a&&a.$$typeof,a){case k$4:case h$8:case l$8:case q$5:case p$9:case g$5:return a;default:return r;}}case c$8:return r;}}}reactIs_production_min.ContextConsumer=h$8;reactIs_production_min.ContextProvider=g$5;reactIs_production_min.Element=b$7;reactIs_production_min.ForwardRef=l$8;reactIs_production_min.Fragment=d$a;reactIs_production_min.Lazy=q$5;reactIs_production_min.Memo=p$9;reactIs_production_min.Portal=c$8;reactIs_production_min.Profiler=f$b;reactIs_production_min.StrictMode=e$5;reactIs_production_min.Suspense=m$6;reactIs_production_min.SuspenseList=n$8;reactIs_production_min.isAsyncMode=function(){return !1;};reactIs_production_min.isConcurrentMode=function(){return !1;};reactIs_production_min.isContextConsumer=function(a){return v$8(a)===h$8;};reactIs_production_min.isContextProvider=function(a){return v$8(a)===g$5;};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===b$7;};reactIs_production_min.isForwardRef=function(a){return v$8(a)===l$8;};reactIs_production_min.isFragment=function(a){return v$8(a)===d$a;};reactIs_production_min.isLazy=function(a){return v$8(a)===q$5;};reactIs_production_min.isMemo=function(a){return v$8(a)===p$9;};reactIs_production_min.isPortal=function(a){return v$8(a)===c$8;};reactIs_production_min.isProfiler=function(a){return v$8(a)===f$b;};reactIs_production_min.isStrictMode=function(a){return v$8(a)===e$5;};reactIs_production_min.isSuspense=function(a){return v$8(a)===m$6;};reactIs_production_min.isSuspenseList=function(a){return v$8(a)===n$8;};reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===d$a||a===f$b||a===e$5||a===m$6||a===n$8||a===t$b||"object"===typeof a&&null!==a&&(a.$$typeof===q$5||a.$$typeof===p$9||a.$$typeof===g$5||a.$$typeof===h$8||a.$$typeof===l$8||a.$$typeof===u$a||void 0!==a.getModuleId)?!0:!1;};reactIs_production_min.typeOf=v$8;var reactIs_development={};/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */if(process.env.NODE_ENV!=="production"){(function(){// ATTENTION
// When adding new symbols to this file,
// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
// The Symbol used to tag the ReactElement-like types.
var REACT_ELEMENT_TYPE=Symbol.for('react.element');var REACT_PORTAL_TYPE=Symbol.for('react.portal');var REACT_FRAGMENT_TYPE=Symbol.for('react.fragment');var REACT_STRICT_MODE_TYPE=Symbol.for('react.strict_mode');var REACT_PROFILER_TYPE=Symbol.for('react.profiler');var REACT_PROVIDER_TYPE=Symbol.for('react.provider');var REACT_CONTEXT_TYPE=Symbol.for('react.context');var REACT_SERVER_CONTEXT_TYPE=Symbol.for('react.server_context');var REACT_FORWARD_REF_TYPE=Symbol.for('react.forward_ref');var REACT_SUSPENSE_TYPE=Symbol.for('react.suspense');var REACT_SUSPENSE_LIST_TYPE=Symbol.for('react.suspense_list');var REACT_MEMO_TYPE=Symbol.for('react.memo');var REACT_LAZY_TYPE=Symbol.for('react.lazy');var REACT_OFFSCREEN_TYPE=Symbol.for('react.offscreen');// -----------------------------------------------------------------------------
var enableScopeAPI=false;// Experimental Create Event Handle API.
var enableCacheElement=false;var enableTransitionTracing=false;// No known bugs, but needs performance testing
var enableLegacyHidden=false;// Enables unstable_avoidThisFallback feature in Fiber
// stuff. Intended to enable React core members to more easily debug scheduling
// issues in DEV builds.
var enableDebugTracing=false;// Track which Fiber(s) schedule render work.
var REACT_MODULE_REFERENCE;{REACT_MODULE_REFERENCE=Symbol.for('react.module.reference');}function isValidElementType(type){if(typeof type==='string'||typeof type==='function'){return true;}// Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).
if(type===REACT_FRAGMENT_TYPE||type===REACT_PROFILER_TYPE||enableDebugTracing||type===REACT_STRICT_MODE_TYPE||type===REACT_SUSPENSE_TYPE||type===REACT_SUSPENSE_LIST_TYPE||enableLegacyHidden||type===REACT_OFFSCREEN_TYPE||enableScopeAPI||enableCacheElement||enableTransitionTracing){return true;}if(typeof type==='object'&&type!==null){if(type.$$typeof===REACT_LAZY_TYPE||type.$$typeof===REACT_MEMO_TYPE||type.$$typeof===REACT_PROVIDER_TYPE||type.$$typeof===REACT_CONTEXT_TYPE||type.$$typeof===REACT_FORWARD_REF_TYPE||// This needs to include all possible module reference object
// types supported by any Flight configuration anywhere since
// we don't know which Flight build this will end up being used
// with.
type.$$typeof===REACT_MODULE_REFERENCE||type.getModuleId!==undefined){return true;}}return false;}function typeOf(object){if(typeof object==='object'&&object!==null){var $$typeof=object.$$typeof;switch($$typeof){case REACT_ELEMENT_TYPE:var type=object.type;switch(type){case REACT_FRAGMENT_TYPE:case REACT_PROFILER_TYPE:case REACT_STRICT_MODE_TYPE:case REACT_SUSPENSE_TYPE:case REACT_SUSPENSE_LIST_TYPE:return type;default:var $$typeofType=type&&type.$$typeof;switch($$typeofType){case REACT_SERVER_CONTEXT_TYPE:case REACT_CONTEXT_TYPE:case REACT_FORWARD_REF_TYPE:case REACT_LAZY_TYPE:case REACT_MEMO_TYPE:case REACT_PROVIDER_TYPE:return $$typeofType;default:return $$typeof;}}case REACT_PORTAL_TYPE:return $$typeof;}}return undefined;}var ContextConsumer=REACT_CONTEXT_TYPE;var ContextProvider=REACT_PROVIDER_TYPE;var Element=REACT_ELEMENT_TYPE;var ForwardRef=REACT_FORWARD_REF_TYPE;var Fragment=REACT_FRAGMENT_TYPE;var Lazy=REACT_LAZY_TYPE;var Memo=REACT_MEMO_TYPE;var Portal=REACT_PORTAL_TYPE;var Profiler=REACT_PROFILER_TYPE;var StrictMode=REACT_STRICT_MODE_TYPE;var Suspense=REACT_SUSPENSE_TYPE;var SuspenseList=REACT_SUSPENSE_LIST_TYPE;var hasWarnedAboutDeprecatedIsAsyncMode=false;var hasWarnedAboutDeprecatedIsConcurrentMode=false;// AsyncMode should be deprecated
function isAsyncMode(object){{if(!hasWarnedAboutDeprecatedIsAsyncMode){hasWarnedAboutDeprecatedIsAsyncMode=true;// Using console['warn'] to evade Babel and ESLint
console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, '+'and will be removed in React 18+.');}}return false;}function isConcurrentMode(object){{if(!hasWarnedAboutDeprecatedIsConcurrentMode){hasWarnedAboutDeprecatedIsConcurrentMode=true;// Using console['warn'] to evade Babel and ESLint
console['warn']('The ReactIs.isConcurrentMode() alias has been deprecated, '+'and will be removed in React 18+.');}}return false;}function isContextConsumer(object){return typeOf(object)===REACT_CONTEXT_TYPE;}function isContextProvider(object){return typeOf(object)===REACT_PROVIDER_TYPE;}function isElement(object){return typeof object==='object'&&object!==null&&object.$$typeof===REACT_ELEMENT_TYPE;}function isForwardRef(object){return typeOf(object)===REACT_FORWARD_REF_TYPE;}function isFragment(object){return typeOf(object)===REACT_FRAGMENT_TYPE;}function isLazy(object){return typeOf(object)===REACT_LAZY_TYPE;}function isMemo(object){return typeOf(object)===REACT_MEMO_TYPE;}function isPortal(object){return typeOf(object)===REACT_PORTAL_TYPE;}function isProfiler(object){return typeOf(object)===REACT_PROFILER_TYPE;}function isStrictMode(object){return typeOf(object)===REACT_STRICT_MODE_TYPE;}function isSuspense(object){return typeOf(object)===REACT_SUSPENSE_TYPE;}function isSuspenseList(object){return typeOf(object)===REACT_SUSPENSE_LIST_TYPE;}reactIs_development.ContextConsumer=ContextConsumer;reactIs_development.ContextProvider=ContextProvider;reactIs_development.Element=Element;reactIs_development.ForwardRef=ForwardRef;reactIs_development.Fragment=Fragment;reactIs_development.Lazy=Lazy;reactIs_development.Memo=Memo;reactIs_development.Portal=Portal;reactIs_development.Profiler=Profiler;reactIs_development.StrictMode=StrictMode;reactIs_development.Suspense=Suspense;reactIs_development.SuspenseList=SuspenseList;reactIs_development.isAsyncMode=isAsyncMode;reactIs_development.isConcurrentMode=isConcurrentMode;reactIs_development.isContextConsumer=isContextConsumer;reactIs_development.isContextProvider=isContextProvider;reactIs_development.isElement=isElement;reactIs_development.isForwardRef=isForwardRef;reactIs_development.isFragment=isFragment;reactIs_development.isLazy=isLazy;reactIs_development.isMemo=isMemo;reactIs_development.isPortal=isPortal;reactIs_development.isProfiler=isProfiler;reactIs_development.isStrictMode=isStrictMode;reactIs_development.isSuspense=isSuspense;reactIs_development.isSuspenseList=isSuspenseList;reactIs_development.isValidElementType=isValidElementType;reactIs_development.typeOf=typeOf;})();}if(process.env.NODE_ENV==='production'){reactIs.exports=reactIs_production_min;}else {reactIs.exports=reactIs_development;}// Simplified polyfill for IE11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
const fnNameMatchRegex=/^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;function getFunctionName(fn){const match=`${fn}`.match(fnNameMatchRegex);const name=match&&match[1];return name||'';}function getFunctionComponentName(Component,fallback=''){return Component.displayName||Component.name||getFunctionName(Component)||fallback;}function getWrappedName(outerType,innerType,wrapperName){const functionName=getFunctionComponentName(innerType);return outerType.displayName||(functionName!==''?`${wrapperName}(${functionName})`:wrapperName);}/**
 * cherry-pick from
 * https://github.com/facebook/react/blob/769b1f270e1251d9dbdce0fcbd9e92e502d059b8/packages/shared/getComponentName.js
 * originally forked from recompose/getDisplayName with added IE11 support
 */function getDisplayName$1(Component){if(Component==null){return undefined;}if(typeof Component==='string'){return Component;}if(typeof Component==='function'){return getFunctionComponentName(Component,'Component');}// TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
if(typeof Component==='object'){switch(Component.$$typeof){case reactIs.exports.ForwardRef:return getWrappedName(Component,Component.render,'ForwardRef');case reactIs.exports.Memo:return getWrappedName(Component,Component.type,'memo');default:return undefined;}}return undefined;}var getDisplayName=/*#__PURE__*/Object.freeze({__proto__:null,'default':getDisplayName$1,getFunctionName:getFunctionName});/**
 * Add keys, values of `defaultProps` that does not exist in `props`
 * @param {object} defaultProps
 * @param {object} props
 * @returns {object} resolved props
 */function resolveProps(defaultProps,props){const output=_extends$2({},props);Object.keys(defaultProps).forEach(propName=>{if(propName.toString().match(/^(components|slots)$/)){output[propName]=_extends$2({},defaultProps[propName],output[propName]);}else if(propName.toString().match(/^(componentsProps|slotProps)$/)){const defaultSlotProps=defaultProps[propName]||{};const slotProps=props[propName];output[propName]={};if(!slotProps||!Object.keys(slotProps)){// Reduce the iteration if the slot props is empty
output[propName]=defaultSlotProps;}else if(!defaultSlotProps||!Object.keys(defaultSlotProps)){// Reduce the iteration if the default slot props is empty
output[propName]=slotProps;}else {output[propName]=_extends$2({},slotProps);Object.keys(defaultSlotProps).forEach(slotPropName=>{output[propName][slotPropName]=resolveProps(defaultSlotProps[slotPropName],slotProps[slotPropName]);});}}else if(output[propName]===undefined){output[propName]=defaultProps[propName];}});return output;}function getThemeProps(params){const{theme,name,props}=params;if(!theme||!theme.components||!theme.components[name]||!theme.components[name].defaultProps){return props;}return resolveProps(theme.components[name].defaultProps,props);}function useThemeProps$1({props,name,defaultTheme,themeId}){let theme=useTheme$1(defaultTheme);if(themeId){theme=theme[themeId]||theme;}const mergedProps=getThemeProps({theme,name,props});return mergedProps;}/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */const useEnhancedEffect=typeof window!=='undefined'?React.useLayoutEffect:React.useEffect;var useEnhancedEffect$1=useEnhancedEffect;function clamp$2(val,min=Number.MIN_SAFE_INTEGER,max=Number.MAX_SAFE_INTEGER){return Math.max(min,Math.min(val,max));}var clamp$1=/*#__PURE__*/Object.freeze({__proto__:null,'default':clamp$2});function chainPropTypes(propType1,propType2){if(process.env.NODE_ENV==='production'){return ()=>null;}return function validate(...args){return propType1(...args)||propType2(...args);};}function ownerDocument(node){return node&&node.ownerDocument||document;}/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */function setRef(ref,value){if(typeof ref==='function'){ref(value);}else if(ref){ref.current=value;}}function useControlled({controlled,default:defaultProp,name,state='value'}){// isControlled is ignored in the hook dependency lists as it should never change.
const{current:isControlled}=React.useRef(controlled!==undefined);const[valueState,setValue]=React.useState(defaultProp);const value=isControlled?controlled:valueState;if(process.env.NODE_ENV!=='production'){React.useEffect(()=>{if(isControlled!==(controlled!==undefined)){console.error([`MUI: A component is changing the ${isControlled?'':'un'}controlled ${state} state of ${name} to be ${isControlled?'un':''}controlled.`,'Elements should not switch from uncontrolled to controlled (or vice versa).',`Decide between using a controlled or uncontrolled ${name} `+'element for the lifetime of the component.',"The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.",'More info: https://fb.me/react-controlled-components'].join('\n'));}},[state,name,controlled]);const{current:defaultValue}=React.useRef(defaultProp);React.useEffect(()=>{if(!isControlled&&defaultValue!==defaultProp){console.error([`MUI: A component is changing the default ${state} state of an uncontrolled ${name} after being initialized. `+`To suppress this warning opt to use a controlled ${name}.`].join('\n'));}},[JSON.stringify(defaultProp)]);}const setValueIfUncontrolled=React.useCallback(newValue=>{if(!isControlled){setValue(newValue);}},[]);return [value,setValueIfUncontrolled];}/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */function useEventCallback(fn){const ref=React.useRef(fn);useEnhancedEffect$1(()=>{ref.current=fn;});return React.useRef((...args)=>// @ts-expect-error hide `this`
(0, ref.current)(...args)).current;}function useForkRef(...refs){/**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */return React.useMemo(()=>{if(refs.every(ref=>ref==null)){return null;}return instance=>{refs.forEach(ref=>{setRef(ref,instance);});};// eslint-disable-next-line react-hooks/exhaustive-deps
},refs);}class Timeout{constructor(){this.currentId=0;this.clear=()=>{if(this.currentId!==0){clearTimeout(this.currentId);this.currentId=0;}};this.disposeEffect=()=>{return this.clear;};}static create(){return new Timeout();}/**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */start(delay,fn){this.clear();this.currentId=setTimeout(()=>{this.currentId=0;fn();},delay);}}let hadKeyboardEvent=true;let hadFocusVisibleRecently=false;const hadFocusVisibleRecentlyTimeout=new Timeout();const inputTypesWhitelist={text:true,search:true,url:true,tel:true,email:true,password:true,number:true,date:true,month:true,week:true,time:true,datetime:true,'datetime-local':true};/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */function focusTriggersKeyboardModality(node){const{type,tagName}=node;if(tagName==='INPUT'&&inputTypesWhitelist[type]&&!node.readOnly){return true;}if(tagName==='TEXTAREA'&&!node.readOnly){return true;}if(node.isContentEditable){return true;}return false;}/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */function handleKeyDown(event){if(event.metaKey||event.altKey||event.ctrlKey){return;}hadKeyboardEvent=true;}/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */function handlePointerDown(){hadKeyboardEvent=false;}function handleVisibilityChange(){if(this.visibilityState==='hidden'){// If the tab becomes active again, the browser will handle calling focus
// on the element (Safari actually calls it twice).
// If this tab change caused a blur on an element with focus-visible,
// re-apply the class when the user switches back to the tab.
if(hadFocusVisibleRecently){hadKeyboardEvent=true;}}}function prepare(doc){doc.addEventListener('keydown',handleKeyDown,true);doc.addEventListener('mousedown',handlePointerDown,true);doc.addEventListener('pointerdown',handlePointerDown,true);doc.addEventListener('touchstart',handlePointerDown,true);doc.addEventListener('visibilitychange',handleVisibilityChange,true);}function isFocusVisible(event){const{target}=event;try{return target.matches(':focus-visible');}catch(error){// Browsers not implementing :focus-visible will throw a SyntaxError.
// We use our own heuristic for those browsers.
// Rethrow might be better if it's not the expected error but do we really
// want to crash if focus-visible malfunctioned?
}// No need for validFocusTarget check. The user does that by attaching it to
// focusable events only.
return hadKeyboardEvent||focusTriggersKeyboardModality(target);}function useIsFocusVisible(){const ref=React.useCallback(node=>{if(node!=null){prepare(node.ownerDocument);}},[]);const isFocusVisibleRef=React.useRef(false);/**
   * Should be called if a blur event is fired
   */function handleBlurVisible(){// checking against potential state variable does not suffice if we focus and blur synchronously.
// React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
// Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
// This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
// TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
if(isFocusVisibleRef.current){// To detect a tab/window switch, we look for a blur event followed
// rapidly by a visibility change.
// If we don't see a visibility change within 100ms, it's probably a
// regular focus change.
hadFocusVisibleRecently=true;hadFocusVisibleRecentlyTimeout.start(100,()=>{hadFocusVisibleRecently=false;});isFocusVisibleRef.current=false;return true;}return false;}/**
   * Should be called if a blur event is fired
   */function handleFocusVisible(event){if(isFocusVisible(event)){isFocusVisibleRef.current=true;return true;}return false;}return {isFocusVisibleRef,onFocus:handleFocusVisible,onBlur:handleBlurVisible,ref};}const visuallyHidden={border:0,clip:'rect(0 0 0 0)',height:'1px',margin:-1,overflow:'hidden',padding:0,position:'absolute',whiteSpace:'nowrap',width:'1px'};var visuallyHidden$1=visuallyHidden;function composeClasses(slots,getUtilityClass,classes=undefined){const output={};Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
// @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
slot=>{output[slot]=slots[slot].reduce((acc,key)=>{if(key){const utilityClass=getUtilityClass(key);if(utilityClass!==''){acc.push(utilityClass);}if(classes&&classes[key]){acc.push(classes[key]);}}return acc;},[]).join(' ');});return output;}function r$1$1(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e)){var o=e.length;for(t=0;t<o;t++)e[t]&&(f=r$1$1(e[t]))&&(n&&(n+=" "),n+=f);}else for(f in e)e[f]&&(n&&(n+=" "),n+=f);return n;}function clsx$1(){for(var e,t,f=0,n="",o=arguments.length;f<o;f++)(e=arguments[f])&&(t=r$1$1(e))&&(n&&(n+=" "),n+=t);return n;}/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */function isHostComponent(element){return typeof element==='string';}/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */function appendOwnerState(elementType,otherProps,ownerState){if(elementType===undefined||isHostComponent(elementType)){return otherProps;}return _extends$2({},otherProps,{ownerState:_extends$2({},otherProps.ownerState,ownerState)});}function areArraysEqual(array1,array2,itemComparer=(a,b)=>a===b){return array1.length===array2.length&&array1.every((value,index)=>itemComparer(value,array2[index]));}/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */function extractEventHandlers(object,excludeKeys=[]){if(object===undefined){return {};}const result={};Object.keys(object).filter(prop=>prop.match(/^on[A-Z]/)&&typeof object[prop]==='function'&&!excludeKeys.includes(prop)).forEach(prop=>{result[prop]=object[prop];});return result;}/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */function resolveComponentProps(componentProps,ownerState,slotState){if(typeof componentProps==='function'){return componentProps(ownerState,slotState);}return componentProps;}function r$8(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e)){var o=e.length;for(t=0;t<o;t++)e[t]&&(f=r$8(e[t]))&&(n&&(n+=" "),n+=f);}else for(f in e)e[f]&&(n&&(n+=" "),n+=f);return n;}function clsx(){for(var e,t,f=0,n="",o=arguments.length;f<o;f++)(e=arguments[f])&&(t=r$8(e))&&(n&&(n+=" "),n+=t);return n;}/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */function omitEventHandlers(object){if(object===undefined){return {};}const result={};Object.keys(object).filter(prop=>!(prop.match(/^on[A-Z]/)&&typeof object[prop]==='function')).forEach(prop=>{result[prop]=object[prop];});return result;}/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */function mergeSlotProps(parameters){const{getSlotProps,additionalProps,externalSlotProps,externalForwardedProps,className}=parameters;if(!getSlotProps){// The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
// so we can simply merge all the props without having to worry about extracting event handlers.
const joinedClasses=clsx(additionalProps==null?void 0:additionalProps.className,className,externalForwardedProps==null?void 0:externalForwardedProps.className,externalSlotProps==null?void 0:externalSlotProps.className);const mergedStyle=_extends$2({},additionalProps==null?void 0:additionalProps.style,externalForwardedProps==null?void 0:externalForwardedProps.style,externalSlotProps==null?void 0:externalSlotProps.style);const props=_extends$2({},additionalProps,externalForwardedProps,externalSlotProps);if(joinedClasses.length>0){props.className=joinedClasses;}if(Object.keys(mergedStyle).length>0){props.style=mergedStyle;}return {props,internalRef:undefined};}// In this case, getSlotProps is responsible for calling the external event handlers.
// We don't need to include them in the merged props because of this.
const eventHandlers=extractEventHandlers(_extends$2({},externalForwardedProps,externalSlotProps));const componentsPropsWithoutEventHandlers=omitEventHandlers(externalSlotProps);const otherPropsWithoutEventHandlers=omitEventHandlers(externalForwardedProps);const internalSlotProps=getSlotProps(eventHandlers);// The order of classes is important here.
// Emotion (that we use in libraries consuming Base UI) depends on this order
// to properly override style. It requires the most important classes to be last
// (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
const joinedClasses=clsx(internalSlotProps==null?void 0:internalSlotProps.className,additionalProps==null?void 0:additionalProps.className,className,externalForwardedProps==null?void 0:externalForwardedProps.className,externalSlotProps==null?void 0:externalSlotProps.className);const mergedStyle=_extends$2({},internalSlotProps==null?void 0:internalSlotProps.style,additionalProps==null?void 0:additionalProps.style,externalForwardedProps==null?void 0:externalForwardedProps.style,externalSlotProps==null?void 0:externalSlotProps.style);const props=_extends$2({},internalSlotProps,additionalProps,otherPropsWithoutEventHandlers,componentsPropsWithoutEventHandlers);if(joinedClasses.length>0){props.className=joinedClasses;}if(Object.keys(mergedStyle).length>0){props.style=mergedStyle;}return {props,internalRef:internalSlotProps.ref};}const _excluded$7=["elementType","externalSlotProps","ownerState","skipResolvingSlotProps"];/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */function useSlotProps(parameters){var _parameters$additiona;const{elementType,externalSlotProps,ownerState,skipResolvingSlotProps=false}=parameters,rest=_objectWithoutPropertiesLoose$1(parameters,_excluded$7);const resolvedComponentsProps=skipResolvingSlotProps?{}:resolveComponentProps(externalSlotProps,ownerState);const{props:mergedProps,internalRef}=mergeSlotProps(_extends$2({},rest,{externalSlotProps:resolvedComponentsProps}));const ref=useForkRef(internalRef,resolvedComponentsProps==null?void 0:resolvedComponentsProps.ref,(_parameters$additiona=parameters.additionalProps)==null?void 0:_parameters$additiona.ref);const props=appendOwnerState(elementType,_extends$2({},mergedProps,{ref}),ownerState);return props;}const INTENTIONAL_DRAG_COUNT_THRESHOLD=2;function asc(a,b){return a-b;}function findClosest(values,currentValue){var _values$reduce;const{index:closestIndex}=(_values$reduce=values.reduce((acc,value,index)=>{const distance=Math.abs(currentValue-value);if(acc===null||distance<acc.distance||distance===acc.distance){return {distance,index};}return acc;},null))!=null?_values$reduce:{};return closestIndex;}function trackFinger(event,touchId){// The event is TouchEvent
if(touchId.current!==undefined&&event.changedTouches){const touchEvent=event;for(let i=0;i<touchEvent.changedTouches.length;i+=1){const touch=touchEvent.changedTouches[i];if(touch.identifier===touchId.current){return {x:touch.clientX,y:touch.clientY};}}return false;}// The event is MouseEvent
return {x:event.clientX,y:event.clientY};}function valueToPercent(value,min,max){return (value-min)*100/(max-min);}function percentToValue(percent,min,max){return (max-min)*percent+min;}function getDecimalPrecision(num){// This handles the case when num is very small (0.00000001), js will turn this into 1e-8.
// When num is bigger than 1 or less than -1 it won't get converted to this notation so it's fine.
if(Math.abs(num)<1){const parts=num.toExponential().split('e-');const matissaDecimalPart=parts[0].split('.')[1];return (matissaDecimalPart?matissaDecimalPart.length:0)+parseInt(parts[1],10);}const decimalPart=num.toString().split('.')[1];return decimalPart?decimalPart.length:0;}function roundValueToStep(value,step,min){const nearest=Math.round((value-min)/step)*step+min;return Number(nearest.toFixed(getDecimalPrecision(step)));}function setValueIndex({values,newValue,index}){const output=values.slice();output[index]=newValue;return output.sort(asc);}function focusThumb({sliderRef,activeIndex,setActive}){var _sliderRef$current,_doc$activeElement;const doc=ownerDocument(sliderRef.current);if(!((_sliderRef$current=sliderRef.current)!=null&&_sliderRef$current.contains(doc.activeElement))||Number(doc==null||(_doc$activeElement=doc.activeElement)==null?void 0:_doc$activeElement.getAttribute('data-index'))!==activeIndex){var _sliderRef$current2;(_sliderRef$current2=sliderRef.current)==null||_sliderRef$current2.querySelector(`[type="range"][data-index="${activeIndex}"]`).focus();}if(setActive){setActive(activeIndex);}}function areValuesEqual(newValue,oldValue){if(typeof newValue==='number'&&typeof oldValue==='number'){return newValue===oldValue;}if(typeof newValue==='object'&&typeof oldValue==='object'){return areArraysEqual(newValue,oldValue);}return false;}const axisProps={horizontal:{offset:percent=>({left:`${percent}%`}),leap:percent=>({width:`${percent}%`})},'horizontal-reverse':{offset:percent=>({right:`${percent}%`}),leap:percent=>({width:`${percent}%`})},vertical:{offset:percent=>({bottom:`${percent}%`}),leap:percent=>({height:`${percent}%`})}};const Identity$1=x=>x;// TODO: remove support for Safari < 13.
// https://caniuse.com/#search=touch-action
//
// Safari, on iOS, supports touch action since v13.
// Over 80% of the iOS phones are compatible
// in August 2020.
// Utilizing the CSS.supports method to check if touch-action is supported.
// Since CSS.supports is supported on all but Edge@12 and IE and touch-action
// is supported on both Edge@12 and IE if CSS.supports is not available that means that
// touch-action will be supported
let cachedSupportsTouchActionNone;function doesSupportTouchActionNone(){if(cachedSupportsTouchActionNone===undefined){if(typeof CSS!=='undefined'&&typeof CSS.supports==='function'){cachedSupportsTouchActionNone=CSS.supports('touch-action','none');}else {cachedSupportsTouchActionNone=true;}}return cachedSupportsTouchActionNone;}/**
 *
 * Demos:
 *
 * - [Slider](https://mui.com/base-ui/react-slider/#hook)
 *
 * API:
 *
 * - [useSlider API](https://mui.com/base-ui/react-slider/hooks-api/#use-slider)
 */function useSlider(parameters){const{'aria-labelledby':ariaLabelledby,defaultValue,disabled=false,disableSwap=false,isRtl=false,marks:marksProp=false,max=100,min=0,name,onChange,onChangeCommitted,orientation='horizontal',rootRef:ref,scale=Identity$1,step=1,shiftStep=10,tabIndex,value:valueProp}=parameters;const touchId=React.useRef();// We can't use the :active browser pseudo-classes.
// - The active state isn't triggered when clicking on the rail.
// - The active state isn't transferred when inversing a range slider.
const[active,setActive]=React.useState(-1);const[open,setOpen]=React.useState(-1);const[dragging,setDragging]=React.useState(false);const moveCount=React.useRef(0);const[valueDerived,setValueState]=useControlled({controlled:valueProp,default:defaultValue!=null?defaultValue:min,name:'Slider'});const handleChange=onChange&&((event,value,thumbIndex)=>{// Redefine target to allow name and value to be read.
// This allows seamless integration with the most popular form libraries.
// https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
// Clone the event to not override `target` of the original event.
const nativeEvent=event.nativeEvent||event;// @ts-ignore The nativeEvent is function, not object
const clonedEvent=new nativeEvent.constructor(nativeEvent.type,nativeEvent);Object.defineProperty(clonedEvent,'target',{writable:true,value:{value,name}});onChange(clonedEvent,value,thumbIndex);});const range=Array.isArray(valueDerived);let values=range?valueDerived.slice().sort(asc):[valueDerived];values=values.map(value=>value==null?min:clamp$2(value,min,max));const marks=marksProp===true&&step!==null?[...Array(Math.floor((max-min)/step)+1)].map((_,index)=>({value:min+step*index})):marksProp||[];const marksValues=marks.map(mark=>mark.value);const{isFocusVisibleRef,onBlur:handleBlurVisible,onFocus:handleFocusVisible,ref:focusVisibleRef}=useIsFocusVisible();const[focusedThumbIndex,setFocusedThumbIndex]=React.useState(-1);const sliderRef=React.useRef();const handleFocusRef=useForkRef(focusVisibleRef,sliderRef);const handleRef=useForkRef(ref,handleFocusRef);const createHandleHiddenInputFocus=otherHandlers=>event=>{var _otherHandlers$onFocu;const index=Number(event.currentTarget.getAttribute('data-index'));handleFocusVisible(event);if(isFocusVisibleRef.current===true){setFocusedThumbIndex(index);}setOpen(index);otherHandlers==null||(_otherHandlers$onFocu=otherHandlers.onFocus)==null||_otherHandlers$onFocu.call(otherHandlers,event);};const createHandleHiddenInputBlur=otherHandlers=>event=>{var _otherHandlers$onBlur;handleBlurVisible(event);if(isFocusVisibleRef.current===false){setFocusedThumbIndex(-1);}setOpen(-1);otherHandlers==null||(_otherHandlers$onBlur=otherHandlers.onBlur)==null||_otherHandlers$onBlur.call(otherHandlers,event);};const changeValue=(event,valueInput)=>{const index=Number(event.currentTarget.getAttribute('data-index'));const value=values[index];const marksIndex=marksValues.indexOf(value);let newValue=valueInput;if(marks&&step==null){const maxMarksValue=marksValues[marksValues.length-1];if(newValue>maxMarksValue){newValue=maxMarksValue;}else if(newValue<marksValues[0]){newValue=marksValues[0];}else {newValue=newValue<value?marksValues[marksIndex-1]:marksValues[marksIndex+1];}}newValue=clamp$2(newValue,min,max);if(range){// Bound the new value to the thumb's neighbours.
if(disableSwap){newValue=clamp$2(newValue,values[index-1]||-Infinity,values[index+1]||Infinity);}const previousValue=newValue;newValue=setValueIndex({values,newValue,index});let activeIndex=index;// Potentially swap the index if needed.
if(!disableSwap){activeIndex=newValue.indexOf(previousValue);}focusThumb({sliderRef,activeIndex});}setValueState(newValue);setFocusedThumbIndex(index);if(handleChange&&!areValuesEqual(newValue,valueDerived)){handleChange(event,newValue,index);}if(onChangeCommitted){onChangeCommitted(event,newValue);}};const createHandleHiddenInputKeyDown=otherHandlers=>event=>{var _otherHandlers$onKeyD;// The Shift + Up/Down keyboard shortcuts for moving the slider makes sense to be supported
// only if the step is defined. If the step is null, this means tha the marks are used for specifying the valid values.
if(step!==null){const index=Number(event.currentTarget.getAttribute('data-index'));const value=values[index];let newValue=null;if((event.key==='ArrowLeft'||event.key==='ArrowDown')&&event.shiftKey||event.key==='PageDown'){newValue=Math.max(value-shiftStep,min);}else if((event.key==='ArrowRight'||event.key==='ArrowUp')&&event.shiftKey||event.key==='PageUp'){newValue=Math.min(value+shiftStep,max);}if(newValue!==null){changeValue(event,newValue);event.preventDefault();}}otherHandlers==null||(_otherHandlers$onKeyD=otherHandlers.onKeyDown)==null||_otherHandlers$onKeyD.call(otherHandlers,event);};useEnhancedEffect$1(()=>{if(disabled&&sliderRef.current.contains(document.activeElement)){var _document$activeEleme;// This is necessary because Firefox and Safari will keep focus
// on a disabled element:
// https://codesandbox.io/p/sandbox/mui-pr-22247-forked-h151h?file=/src/App.js
// @ts-ignore
(_document$activeEleme=document.activeElement)==null||_document$activeEleme.blur();}},[disabled]);if(disabled&&active!==-1){setActive(-1);}if(disabled&&focusedThumbIndex!==-1){setFocusedThumbIndex(-1);}const createHandleHiddenInputChange=otherHandlers=>event=>{var _otherHandlers$onChan;(_otherHandlers$onChan=otherHandlers.onChange)==null||_otherHandlers$onChan.call(otherHandlers,event);// @ts-ignore
changeValue(event,event.target.valueAsNumber);};const previousIndex=React.useRef();let axis=orientation;if(isRtl&&orientation==='horizontal'){axis+='-reverse';}const getFingerNewValue=({finger,move=false})=>{const{current:slider}=sliderRef;const{width,height,bottom,left}=slider.getBoundingClientRect();let percent;if(axis.indexOf('vertical')===0){percent=(bottom-finger.y)/height;}else {percent=(finger.x-left)/width;}if(axis.indexOf('-reverse')!==-1){percent=1-percent;}let newValue;newValue=percentToValue(percent,min,max);if(step){newValue=roundValueToStep(newValue,step,min);}else {const closestIndex=findClosest(marksValues,newValue);newValue=marksValues[closestIndex];}newValue=clamp$2(newValue,min,max);let activeIndex=0;if(range){if(!move){activeIndex=findClosest(values,newValue);}else {activeIndex=previousIndex.current;}// Bound the new value to the thumb's neighbours.
if(disableSwap){newValue=clamp$2(newValue,values[activeIndex-1]||-Infinity,values[activeIndex+1]||Infinity);}const previousValue=newValue;newValue=setValueIndex({values,newValue,index:activeIndex});// Potentially swap the index if needed.
if(!(disableSwap&&move)){activeIndex=newValue.indexOf(previousValue);previousIndex.current=activeIndex;}}return {newValue,activeIndex};};const handleTouchMove=useEventCallback(nativeEvent=>{const finger=trackFinger(nativeEvent,touchId);if(!finger){return;}moveCount.current+=1;// Cancel move in case some other element consumed a mouseup event and it was not fired.
// @ts-ignore buttons doesn't not exists on touch event
if(nativeEvent.type==='mousemove'&&nativeEvent.buttons===0){// eslint-disable-next-line @typescript-eslint/no-use-before-define
handleTouchEnd(nativeEvent);return;}const{newValue,activeIndex}=getFingerNewValue({finger,move:true});focusThumb({sliderRef,activeIndex,setActive});setValueState(newValue);if(!dragging&&moveCount.current>INTENTIONAL_DRAG_COUNT_THRESHOLD){setDragging(true);}if(handleChange&&!areValuesEqual(newValue,valueDerived)){handleChange(nativeEvent,newValue,activeIndex);}});const handleTouchEnd=useEventCallback(nativeEvent=>{const finger=trackFinger(nativeEvent,touchId);setDragging(false);if(!finger){return;}const{newValue}=getFingerNewValue({finger,move:true});setActive(-1);if(nativeEvent.type==='touchend'){setOpen(-1);}if(onChangeCommitted){onChangeCommitted(nativeEvent,newValue);}touchId.current=undefined;// eslint-disable-next-line @typescript-eslint/no-use-before-define
stopListening();});const handleTouchStart=useEventCallback(nativeEvent=>{if(disabled){return;}// If touch-action: none; is not supported we need to prevent the scroll manually.
if(!doesSupportTouchActionNone()){nativeEvent.preventDefault();}const touch=nativeEvent.changedTouches[0];if(touch!=null){// A number that uniquely identifies the current finger in the touch session.
touchId.current=touch.identifier;}const finger=trackFinger(nativeEvent,touchId);if(finger!==false){const{newValue,activeIndex}=getFingerNewValue({finger});focusThumb({sliderRef,activeIndex,setActive});setValueState(newValue);if(handleChange&&!areValuesEqual(newValue,valueDerived)){handleChange(nativeEvent,newValue,activeIndex);}}moveCount.current=0;const doc=ownerDocument(sliderRef.current);doc.addEventListener('touchmove',handleTouchMove,{passive:true});doc.addEventListener('touchend',handleTouchEnd,{passive:true});});const stopListening=React.useCallback(()=>{const doc=ownerDocument(sliderRef.current);doc.removeEventListener('mousemove',handleTouchMove);doc.removeEventListener('mouseup',handleTouchEnd);doc.removeEventListener('touchmove',handleTouchMove);doc.removeEventListener('touchend',handleTouchEnd);},[handleTouchEnd,handleTouchMove]);React.useEffect(()=>{const{current:slider}=sliderRef;slider.addEventListener('touchstart',handleTouchStart,{passive:doesSupportTouchActionNone()});return ()=>{slider.removeEventListener('touchstart',handleTouchStart);stopListening();};},[stopListening,handleTouchStart]);React.useEffect(()=>{if(disabled){stopListening();}},[disabled,stopListening]);const createHandleMouseDown=otherHandlers=>event=>{var _otherHandlers$onMous;(_otherHandlers$onMous=otherHandlers.onMouseDown)==null||_otherHandlers$onMous.call(otherHandlers,event);if(disabled){return;}if(event.defaultPrevented){return;}// Only handle left clicks
if(event.button!==0){return;}// Avoid text selection
event.preventDefault();const finger=trackFinger(event,touchId);if(finger!==false){const{newValue,activeIndex}=getFingerNewValue({finger});focusThumb({sliderRef,activeIndex,setActive});setValueState(newValue);if(handleChange&&!areValuesEqual(newValue,valueDerived)){handleChange(event,newValue,activeIndex);}}moveCount.current=0;const doc=ownerDocument(sliderRef.current);doc.addEventListener('mousemove',handleTouchMove,{passive:true});doc.addEventListener('mouseup',handleTouchEnd);};const trackOffset=valueToPercent(range?values[0]:min,min,max);const trackLeap=valueToPercent(values[values.length-1],min,max)-trackOffset;const getRootProps=(externalProps={})=>{const externalHandlers=extractEventHandlers(externalProps);const ownEventHandlers={onMouseDown:createHandleMouseDown(externalHandlers||{})};const mergedEventHandlers=_extends$2({},externalHandlers,ownEventHandlers);return _extends$2({},externalProps,{ref:handleRef},mergedEventHandlers);};const createHandleMouseOver=otherHandlers=>event=>{var _otherHandlers$onMous2;(_otherHandlers$onMous2=otherHandlers.onMouseOver)==null||_otherHandlers$onMous2.call(otherHandlers,event);const index=Number(event.currentTarget.getAttribute('data-index'));setOpen(index);};const createHandleMouseLeave=otherHandlers=>event=>{var _otherHandlers$onMous3;(_otherHandlers$onMous3=otherHandlers.onMouseLeave)==null||_otherHandlers$onMous3.call(otherHandlers,event);setOpen(-1);};const getThumbProps=(externalProps={})=>{const externalHandlers=extractEventHandlers(externalProps);const ownEventHandlers={onMouseOver:createHandleMouseOver(externalHandlers||{}),onMouseLeave:createHandleMouseLeave(externalHandlers||{})};return _extends$2({},externalProps,externalHandlers,ownEventHandlers);};const getThumbStyle=index=>{return {// So the non active thumb doesn't show its label on hover.
pointerEvents:active!==-1&&active!==index?'none':undefined};};const getHiddenInputProps=(externalProps={})=>{var _parameters$step;const externalHandlers=extractEventHandlers(externalProps);const ownEventHandlers={onChange:createHandleHiddenInputChange(externalHandlers||{}),onFocus:createHandleHiddenInputFocus(externalHandlers||{}),onBlur:createHandleHiddenInputBlur(externalHandlers||{}),onKeyDown:createHandleHiddenInputKeyDown(externalHandlers||{})};const mergedEventHandlers=_extends$2({},externalHandlers,ownEventHandlers);return _extends$2({tabIndex,'aria-labelledby':ariaLabelledby,'aria-orientation':orientation,'aria-valuemax':scale(max),'aria-valuemin':scale(min),name,type:'range',min:parameters.min,max:parameters.max,step:parameters.step===null&&parameters.marks?'any':(_parameters$step=parameters.step)!=null?_parameters$step:undefined,disabled},externalProps,mergedEventHandlers,{style:_extends$2({},visuallyHidden$1,{direction:isRtl?'rtl':'ltr',// So that VoiceOver's focus indicator matches the thumb's dimensions
width:'100%',height:'100%'})});};return {active,axis:axis,axisProps,dragging,focusedThumbIndex,getHiddenInputProps,getRootProps,getThumbProps,marks:marks,open,range,rootRef:handleRef,trackLeap,trackOffset,values,getThumbStyle};}var colorManipulator={};var interopRequireDefault={exports:{}};(function(module){function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{"default":obj};}module.exports=_interopRequireDefault,module.exports.__esModule=true,module.exports["default"]=module.exports;})(interopRequireDefault);var require$$1=/*@__PURE__*/getAugmentedNamespace(formatMuiErrorMessage);var require$$2=/*@__PURE__*/getAugmentedNamespace(clamp$1);var _interopRequireDefault$1$1=interopRequireDefault.exports;Object.defineProperty(colorManipulator,"__esModule",{value:true});var alpha_1=colorManipulator.alpha=alpha;colorManipulator.blend=blend;colorManipulator.colorChannel=void 0;var darken_1=colorManipulator.darken=darken;colorManipulator.decomposeColor=decomposeColor;colorManipulator.emphasize=emphasize;var getContrastRatio_1=colorManipulator.getContrastRatio=getContrastRatio;colorManipulator.getLuminance=getLuminance;colorManipulator.hexToRgb=hexToRgb;colorManipulator.hslToRgb=hslToRgb;var lighten_1=colorManipulator.lighten=lighten;colorManipulator.private_safeAlpha=private_safeAlpha;colorManipulator.private_safeColorChannel=void 0;colorManipulator.private_safeDarken=private_safeDarken;colorManipulator.private_safeEmphasize=private_safeEmphasize;colorManipulator.private_safeLighten=private_safeLighten;colorManipulator.recomposeColor=recomposeColor;colorManipulator.rgbToHex=rgbToHex;var _formatMuiErrorMessage2=_interopRequireDefault$1$1(require$$1);var _clamp=_interopRequireDefault$1$1(require$$2);/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */function clampWrapper(value,min=0,max=1){if(process.env.NODE_ENV!=='production'){if(value<min||value>max){console.error(`MUI: The value provided ${value} is out of range [${min}, ${max}].`);}}return (0, _clamp.default)(value,min,max);}/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */function hexToRgb(color){color=color.slice(1);const re=new RegExp(`.{1,${color.length>=6?2:1}}`,'g');let colors=color.match(re);if(colors&&colors[0].length===1){colors=colors.map(n=>n+n);}return colors?`rgb${colors.length===4?'a':''}(${colors.map((n,index)=>{return index<3?parseInt(n,16):Math.round(parseInt(n,16)/255*1000)/1000;}).join(', ')})`:'';}function intToHex(int){const hex=int.toString(16);return hex.length===1?`0${hex}`:hex;}/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */function decomposeColor(color){// Idempotent
if(color.type){return color;}if(color.charAt(0)==='#'){return decomposeColor(hexToRgb(color));}const marker=color.indexOf('(');const type=color.substring(0,marker);if(['rgb','rgba','hsl','hsla','color'].indexOf(type)===-1){throw new Error(process.env.NODE_ENV!=="production"?`MUI: Unsupported \`${color}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().`:(0, _formatMuiErrorMessage2.default)(9,color));}let values=color.substring(marker+1,color.length-1);let colorSpace;if(type==='color'){values=values.split(' ');colorSpace=values.shift();if(values.length===4&&values[3].charAt(0)==='/'){values[3]=values[3].slice(1);}if(['srgb','display-p3','a98-rgb','prophoto-rgb','rec-2020'].indexOf(colorSpace)===-1){throw new Error(process.env.NODE_ENV!=="production"?`MUI: unsupported \`${colorSpace}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.`:(0, _formatMuiErrorMessage2.default)(10,colorSpace));}}else {values=values.split(',');}values=values.map(value=>parseFloat(value));return {type,values,colorSpace};}/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */const colorChannel=color=>{const decomposedColor=decomposeColor(color);return decomposedColor.values.slice(0,3).map((val,idx)=>decomposedColor.type.indexOf('hsl')!==-1&&idx!==0?`${val}%`:val).join(' ');};colorManipulator.colorChannel=colorChannel;const private_safeColorChannel=(color,warning)=>{try{return colorChannel(color);}catch(error){if(warning&&process.env.NODE_ENV!=='production'){console.warn(warning);}return color;}};/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */colorManipulator.private_safeColorChannel=private_safeColorChannel;function recomposeColor(color){const{type,colorSpace}=color;let{values}=color;if(type.indexOf('rgb')!==-1){// Only convert the first 3 values to int (i.e. not alpha)
values=values.map((n,i)=>i<3?parseInt(n,10):n);}else if(type.indexOf('hsl')!==-1){values[1]=`${values[1]}%`;values[2]=`${values[2]}%`;}if(type.indexOf('color')!==-1){values=`${colorSpace} ${values.join(' ')}`;}else {values=`${values.join(', ')}`;}return `${type}(${values})`;}/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */function rgbToHex(color){// Idempotent
if(color.indexOf('#')===0){return color;}const{values}=decomposeColor(color);return `#${values.map((n,i)=>intToHex(i===3?Math.round(255*n):n)).join('')}`;}/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */function hslToRgb(color){color=decomposeColor(color);const{values}=color;const h=values[0];const s=values[1]/100;const l=values[2]/100;const a=s*Math.min(l,1-l);const f=(n,k=(n+h/30)%12)=>l-a*Math.max(Math.min(k-3,9-k,1),-1);let type='rgb';const rgb=[Math.round(f(0)*255),Math.round(f(8)*255),Math.round(f(4)*255)];if(color.type==='hsla'){type+='a';rgb.push(values[3]);}return recomposeColor({type,values:rgb});}/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */function getLuminance(color){color=decomposeColor(color);let rgb=color.type==='hsl'||color.type==='hsla'?decomposeColor(hslToRgb(color)).values:color.values;rgb=rgb.map(val=>{if(color.type!=='color'){val/=255;// normalized
}return val<=0.03928?val/12.92:((val+0.055)/1.055)**2.4;});// Truncate at 3 digits
return Number((0.2126*rgb[0]+0.7152*rgb[1]+0.0722*rgb[2]).toFixed(3));}/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */function getContrastRatio(foreground,background){const lumA=getLuminance(foreground);const lumB=getLuminance(background);return (Math.max(lumA,lumB)+0.05)/(Math.min(lumA,lumB)+0.05);}/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */function alpha(color,value){color=decomposeColor(color);value=clampWrapper(value);if(color.type==='rgb'||color.type==='hsl'){color.type+='a';}if(color.type==='color'){color.values[3]=`/${value}`;}else {color.values[3]=value;}return recomposeColor(color);}function private_safeAlpha(color,value,warning){try{return alpha(color,value);}catch(error){if(warning&&process.env.NODE_ENV!=='production'){console.warn(warning);}return color;}}/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */function darken(color,coefficient){color=decomposeColor(color);coefficient=clampWrapper(coefficient);if(color.type.indexOf('hsl')!==-1){color.values[2]*=1-coefficient;}else if(color.type.indexOf('rgb')!==-1||color.type.indexOf('color')!==-1){for(let i=0;i<3;i+=1){color.values[i]*=1-coefficient;}}return recomposeColor(color);}function private_safeDarken(color,coefficient,warning){try{return darken(color,coefficient);}catch(error){if(warning&&process.env.NODE_ENV!=='production'){console.warn(warning);}return color;}}/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */function lighten(color,coefficient){color=decomposeColor(color);coefficient=clampWrapper(coefficient);if(color.type.indexOf('hsl')!==-1){color.values[2]+=(100-color.values[2])*coefficient;}else if(color.type.indexOf('rgb')!==-1){for(let i=0;i<3;i+=1){color.values[i]+=(255-color.values[i])*coefficient;}}else if(color.type.indexOf('color')!==-1){for(let i=0;i<3;i+=1){color.values[i]+=(1-color.values[i])*coefficient;}}return recomposeColor(color);}function private_safeLighten(color,coefficient,warning){try{return lighten(color,coefficient);}catch(error){if(warning&&process.env.NODE_ENV!=='production'){console.warn(warning);}return color;}}/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */function emphasize(color,coefficient=0.15){return getLuminance(color)>0.5?darken(color,coefficient):lighten(color,coefficient);}function private_safeEmphasize(color,coefficient,warning){try{return private_safeEmphasize(color,coefficient);}catch(error){if(warning&&process.env.NODE_ENV!=='production'){console.warn(warning);}return color;}}/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */function blend(background,overlay,opacity,gamma=1.0){const blendChannel=(b,o)=>Math.round((b**(1/gamma)*(1-opacity)+o**(1/gamma)*opacity)**gamma);const backgroundColor=decomposeColor(background);const overlayColor=decomposeColor(overlay);const rgb=[blendChannel(backgroundColor.values[0],overlayColor.values[0]),blendChannel(backgroundColor.values[1],overlayColor.values[1]),blendChannel(backgroundColor.values[2],overlayColor.values[2])];return recomposeColor({type:'rgb',values:rgb});}function createMixins(breakpoints,mixins){return _extends$2({toolbar:{minHeight:56,[breakpoints.up('xs')]:{'@media (orientation: landscape)':{minHeight:48}},[breakpoints.up('sm')]:{minHeight:64}}},mixins);}const common$c={black:'#000',white:'#fff'};var common$1$1=common$c;const grey={50:'#fafafa',100:'#f5f5f5',200:'#eeeeee',300:'#e0e0e0',400:'#bdbdbd',500:'#9e9e9e',600:'#757575',700:'#616161',800:'#424242',900:'#212121',A100:'#f5f5f5',A200:'#eeeeee',A400:'#bdbdbd',A700:'#616161'};var grey$1=grey;const purple={50:'#f3e5f5',100:'#e1bee7',200:'#ce93d8',300:'#ba68c8',400:'#ab47bc',500:'#9c27b0',600:'#8e24aa',700:'#7b1fa2',800:'#6a1b9a',900:'#4a148c',A100:'#ea80fc',A200:'#e040fb',A400:'#d500f9',A700:'#aa00ff'};var purple$1=purple;const red={50:'#ffebee',100:'#ffcdd2',200:'#ef9a9a',300:'#e57373',400:'#ef5350',500:'#f44336',600:'#e53935',700:'#d32f2f',800:'#c62828',900:'#b71c1c',A100:'#ff8a80',A200:'#ff5252',A400:'#ff1744',A700:'#d50000'};var red$1=red;const orange={50:'#fff3e0',100:'#ffe0b2',200:'#ffcc80',300:'#ffb74d',400:'#ffa726',500:'#ff9800',600:'#fb8c00',700:'#f57c00',800:'#ef6c00',900:'#e65100',A100:'#ffd180',A200:'#ffab40',A400:'#ff9100',A700:'#ff6d00'};var orange$1=orange;const blue={50:'#e3f2fd',100:'#bbdefb',200:'#90caf9',300:'#64b5f6',400:'#42a5f5',500:'#2196f3',600:'#1e88e5',700:'#1976d2',800:'#1565c0',900:'#0d47a1',A100:'#82b1ff',A200:'#448aff',A400:'#2979ff',A700:'#2962ff'};var blue$1=blue;const lightBlue={50:'#e1f5fe',100:'#b3e5fc',200:'#81d4fa',300:'#4fc3f7',400:'#29b6f6',500:'#03a9f4',600:'#039be5',700:'#0288d1',800:'#0277bd',900:'#01579b',A100:'#80d8ff',A200:'#40c4ff',A400:'#00b0ff',A700:'#0091ea'};var lightBlue$1=lightBlue;const green={50:'#e8f5e9',100:'#c8e6c9',200:'#a5d6a7',300:'#81c784',400:'#66bb6a',500:'#4caf50',600:'#43a047',700:'#388e3c',800:'#2e7d32',900:'#1b5e20',A100:'#b9f6ca',A200:'#69f0ae',A400:'#00e676',A700:'#00c853'};var green$1=green;const _excluded$6=["mode","contrastThreshold","tonalOffset"];const light={// The colors used to style the text.
text:{// The most important text.
primary:'rgba(0, 0, 0, 0.87)',// Secondary text.
secondary:'rgba(0, 0, 0, 0.6)',// Disabled text have even lower visual prominence.
disabled:'rgba(0, 0, 0, 0.38)'},// The color used to divide different elements.
divider:'rgba(0, 0, 0, 0.12)',// The background colors used to style the surfaces.
// Consistency between these values is important.
background:{paper:common$1$1.white,default:common$1$1.white},// The colors used to style the action elements.
action:{// The color of an active action like an icon button.
active:'rgba(0, 0, 0, 0.54)',// The color of an hovered action.
hover:'rgba(0, 0, 0, 0.04)',hoverOpacity:0.04,// The color of a selected action.
selected:'rgba(0, 0, 0, 0.08)',selectedOpacity:0.08,// The color of a disabled action.
disabled:'rgba(0, 0, 0, 0.26)',// The background color of a disabled action.
disabledBackground:'rgba(0, 0, 0, 0.12)',disabledOpacity:0.38,focus:'rgba(0, 0, 0, 0.12)',focusOpacity:0.12,activatedOpacity:0.12}};const dark={text:{primary:common$1$1.white,secondary:'rgba(255, 255, 255, 0.7)',disabled:'rgba(255, 255, 255, 0.5)',icon:'rgba(255, 255, 255, 0.5)'},divider:'rgba(255, 255, 255, 0.12)',background:{paper:'#121212',default:'#121212'},action:{active:common$1$1.white,hover:'rgba(255, 255, 255, 0.08)',hoverOpacity:0.08,selected:'rgba(255, 255, 255, 0.16)',selectedOpacity:0.16,disabled:'rgba(255, 255, 255, 0.3)',disabledBackground:'rgba(255, 255, 255, 0.12)',disabledOpacity:0.38,focus:'rgba(255, 255, 255, 0.12)',focusOpacity:0.12,activatedOpacity:0.24}};function addLightOrDark(intent,direction,shade,tonalOffset){const tonalOffsetLight=tonalOffset.light||tonalOffset;const tonalOffsetDark=tonalOffset.dark||tonalOffset*1.5;if(!intent[direction]){if(intent.hasOwnProperty(shade)){intent[direction]=intent[shade];}else if(direction==='light'){intent.light=lighten_1(intent.main,tonalOffsetLight);}else if(direction==='dark'){intent.dark=darken_1(intent.main,tonalOffsetDark);}}}function getDefaultPrimary(mode='light'){if(mode==='dark'){return {main:blue$1[200],light:blue$1[50],dark:blue$1[400]};}return {main:blue$1[700],light:blue$1[400],dark:blue$1[800]};}function getDefaultSecondary(mode='light'){if(mode==='dark'){return {main:purple$1[200],light:purple$1[50],dark:purple$1[400]};}return {main:purple$1[500],light:purple$1[300],dark:purple$1[700]};}function getDefaultError(mode='light'){if(mode==='dark'){return {main:red$1[500],light:red$1[300],dark:red$1[700]};}return {main:red$1[700],light:red$1[400],dark:red$1[800]};}function getDefaultInfo(mode='light'){if(mode==='dark'){return {main:lightBlue$1[400],light:lightBlue$1[300],dark:lightBlue$1[700]};}return {main:lightBlue$1[700],light:lightBlue$1[500],dark:lightBlue$1[900]};}function getDefaultSuccess(mode='light'){if(mode==='dark'){return {main:green$1[400],light:green$1[300],dark:green$1[700]};}return {main:green$1[800],light:green$1[500],dark:green$1[900]};}function getDefaultWarning(mode='light'){if(mode==='dark'){return {main:orange$1[400],light:orange$1[300],dark:orange$1[700]};}return {main:'#ed6c02',// closest to orange[800] that pass 3:1.
light:orange$1[500],dark:orange$1[900]};}function createPalette(palette){const{mode='light',contrastThreshold=3,tonalOffset=0.2}=palette,other=_objectWithoutPropertiesLoose$1(palette,_excluded$6);const primary=palette.primary||getDefaultPrimary(mode);const secondary=palette.secondary||getDefaultSecondary(mode);const error=palette.error||getDefaultError(mode);const info=palette.info||getDefaultInfo(mode);const success=palette.success||getDefaultSuccess(mode);const warning=palette.warning||getDefaultWarning(mode);// Use the same logic as
// Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
// and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
function getContrastText(background){const contrastText=getContrastRatio_1(background,dark.text.primary)>=contrastThreshold?dark.text.primary:light.text.primary;if(process.env.NODE_ENV!=='production'){const contrast=getContrastRatio_1(background,contrastText);if(contrast<3){console.error([`MUI: The contrast ratio of ${contrast}:1 for ${contrastText} on ${background}`,'falls below the WCAG recommended absolute minimum contrast ratio of 3:1.','https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast'].join('\n'));}}return contrastText;}const augmentColor=({color,name,mainShade=500,lightShade=300,darkShade=700})=>{color=_extends$2({},color);if(!color.main&&color[mainShade]){color.main=color[mainShade];}if(!color.hasOwnProperty('main')){throw new Error(process.env.NODE_ENV!=="production"?`MUI: The color${name?` (${name})`:''} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${mainShade}\` property.`:formatMuiErrorMessage$1(11,name?` (${name})`:'',mainShade));}if(typeof color.main!=='string'){throw new Error(process.env.NODE_ENV!=="production"?`MUI: The color${name?` (${name})`:''} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(color.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });`:formatMuiErrorMessage$1(12,name?` (${name})`:'',JSON.stringify(color.main)));}addLightOrDark(color,'light',lightShade,tonalOffset);addLightOrDark(color,'dark',darkShade,tonalOffset);if(!color.contrastText){color.contrastText=getContrastText(color.main);}return color;};const modes={dark,light};if(process.env.NODE_ENV!=='production'){if(!modes[mode]){console.error(`MUI: The palette mode \`${mode}\` is not supported.`);}}const paletteOutput=deepmerge$1(_extends$2({// A collection of common colors.
common:_extends$2({},common$1$1),// prevent mutable object.
// The palette mode, can be light or dark.
mode,// The colors used to represent primary interface elements for a user.
primary:augmentColor({color:primary,name:'primary'}),// The colors used to represent secondary interface elements for a user.
secondary:augmentColor({color:secondary,name:'secondary',mainShade:'A400',lightShade:'A200',darkShade:'A700'}),// The colors used to represent interface elements that the user should be made aware of.
error:augmentColor({color:error,name:'error'}),// The colors used to represent potentially dangerous actions or important messages.
warning:augmentColor({color:warning,name:'warning'}),// The colors used to present information to the user that is neutral and not necessarily important.
info:augmentColor({color:info,name:'info'}),// The colors used to indicate the successful completion of an action that user triggered.
success:augmentColor({color:success,name:'success'}),// The grey colors.
grey:grey$1,// Used by `getContrastText()` to maximize the contrast between
// the background and the text.
contrastThreshold,// Takes a background color and returns the text color that maximizes the contrast.
getContrastText,// Generate a rich color object.
augmentColor,// Used by the functions below to shift a color's luminance by approximately
// two indexes within its tonal palette.
// E.g., shift from Red 500 to Red 300 or Red 700.
tonalOffset},modes[mode]),other);return paletteOutput;}const _excluded$5=["fontFamily","fontSize","fontWeightLight","fontWeightRegular","fontWeightMedium","fontWeightBold","htmlFontSize","allVariants","pxToRem"];function round(value){return Math.round(value*1e5)/1e5;}const caseAllCaps={textTransform:'uppercase'};const defaultFontFamily='"Roboto", "Helvetica", "Arial", sans-serif';/**
 * @see @link{https://m2.material.io/design/typography/the-type-system.html}
 * @see @link{https://m2.material.io/design/typography/understanding-typography.html}
 */function createTypography(palette,typography){const _ref=typeof typography==='function'?typography(palette):typography,{fontFamily=defaultFontFamily,// The default font size of the Material Specification.
fontSize=14,// px
fontWeightLight=300,fontWeightRegular=400,fontWeightMedium=500,fontWeightBold=700,// Tell MUI what's the font-size on the html element.
// 16px is the default font-size used by browsers.
htmlFontSize=16,// Apply the CSS properties to all the variants.
allVariants,pxToRem:pxToRem2}=_ref,other=_objectWithoutPropertiesLoose$1(_ref,_excluded$5);if(process.env.NODE_ENV!=='production'){if(typeof fontSize!=='number'){console.error('MUI: `fontSize` is required to be a number.');}if(typeof htmlFontSize!=='number'){console.error('MUI: `htmlFontSize` is required to be a number.');}}const coef=fontSize/14;const pxToRem=pxToRem2||(size=>`${size/htmlFontSize*coef}rem`);const buildVariant=(fontWeight,size,lineHeight,letterSpacing,casing)=>_extends$2({fontFamily,fontWeight,fontSize:pxToRem(size),// Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
lineHeight},fontFamily===defaultFontFamily?{letterSpacing:`${round(letterSpacing/size)}em`}:{},casing,allVariants);const variants={h1:buildVariant(fontWeightLight,96,1.167,-1.5),h2:buildVariant(fontWeightLight,60,1.2,-0.5),h3:buildVariant(fontWeightRegular,48,1.167,0),h4:buildVariant(fontWeightRegular,34,1.235,0.25),h5:buildVariant(fontWeightRegular,24,1.334,0),h6:buildVariant(fontWeightMedium,20,1.6,0.15),subtitle1:buildVariant(fontWeightRegular,16,1.75,0.15),subtitle2:buildVariant(fontWeightMedium,14,1.57,0.1),body1:buildVariant(fontWeightRegular,16,1.5,0.15),body2:buildVariant(fontWeightRegular,14,1.43,0.15),button:buildVariant(fontWeightMedium,14,1.75,0.4,caseAllCaps),caption:buildVariant(fontWeightRegular,12,1.66,0.4),overline:buildVariant(fontWeightRegular,12,2.66,1,caseAllCaps),// TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
inherit:{fontFamily:'inherit',fontWeight:'inherit',fontSize:'inherit',lineHeight:'inherit',letterSpacing:'inherit'}};return deepmerge$1(_extends$2({htmlFontSize,pxToRem,fontFamily,fontSize,fontWeightLight,fontWeightRegular,fontWeightMedium,fontWeightBold},variants),other,{clone:false// No need to clone deep
});}const shadowKeyUmbraOpacity=0.2;const shadowKeyPenumbraOpacity=0.14;const shadowAmbientShadowOpacity=0.12;function createShadow(...px){return [`${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${shadowKeyUmbraOpacity})`,`${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${shadowKeyPenumbraOpacity})`,`${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${shadowAmbientShadowOpacity})`].join(',');}// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const shadows=['none',createShadow(0,2,1,-1,0,1,1,0,0,1,3,0),createShadow(0,3,1,-2,0,2,2,0,0,1,5,0),createShadow(0,3,3,-2,0,3,4,0,0,1,8,0),createShadow(0,2,4,-1,0,4,5,0,0,1,10,0),createShadow(0,3,5,-1,0,5,8,0,0,1,14,0),createShadow(0,3,5,-1,0,6,10,0,0,1,18,0),createShadow(0,4,5,-2,0,7,10,1,0,2,16,1),createShadow(0,5,5,-3,0,8,10,1,0,3,14,2),createShadow(0,5,6,-3,0,9,12,1,0,3,16,2),createShadow(0,6,6,-3,0,10,14,1,0,4,18,3),createShadow(0,6,7,-4,0,11,15,1,0,4,20,3),createShadow(0,7,8,-4,0,12,17,2,0,5,22,4),createShadow(0,7,8,-4,0,13,19,2,0,5,24,4),createShadow(0,7,9,-4,0,14,21,2,0,5,26,4),createShadow(0,8,9,-5,0,15,22,2,0,6,28,5),createShadow(0,8,10,-5,0,16,24,2,0,6,30,5),createShadow(0,8,11,-5,0,17,26,2,0,6,32,5),createShadow(0,9,11,-5,0,18,28,2,0,7,34,6),createShadow(0,9,12,-6,0,19,29,2,0,7,36,6),createShadow(0,10,13,-6,0,20,31,3,0,8,38,7),createShadow(0,10,13,-6,0,21,33,3,0,8,40,7),createShadow(0,10,14,-6,0,22,35,3,0,8,42,7),createShadow(0,11,14,-7,0,23,36,3,0,9,44,8),createShadow(0,11,15,-7,0,24,38,3,0,9,46,8)];var shadows$1=shadows;const _excluded$4=["duration","easing","delay"];// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
const easing={// This is the most common easing curve.
easeInOut:'cubic-bezier(0.4, 0, 0.2, 1)',// Objects enter the screen at full velocity from off-screen and
// slowly decelerate to a resting point.
easeOut:'cubic-bezier(0.0, 0, 0.2, 1)',// Objects leave the screen at full velocity. They do not decelerate when off-screen.
easeIn:'cubic-bezier(0.4, 0, 1, 1)',// The sharp curve is used by objects that may return to the screen at any time.
sharp:'cubic-bezier(0.4, 0, 0.6, 1)'};// Follow https://m2.material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing
const duration={shortest:150,shorter:200,short:250,// most basic recommended timing
standard:300,// this is to be used in complex animations
complex:375,// recommended when something is entering screen
enteringScreen:225,// recommended when something is leaving screen
leavingScreen:195};function formatMs(milliseconds){return `${Math.round(milliseconds)}ms`;}function getAutoHeightDuration(height){if(!height){return 0;}const constant=height/36;// https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
return Math.round((4+15*constant**0.25+constant/5)*10);}function createTransitions(inputTransitions){const mergedEasing=_extends$2({},easing,inputTransitions.easing);const mergedDuration=_extends$2({},duration,inputTransitions.duration);const create=(props=['all'],options={})=>{const{duration:durationOption=mergedDuration.standard,easing:easingOption=mergedEasing.easeInOut,delay=0}=options,other=_objectWithoutPropertiesLoose$1(options,_excluded$4);if(process.env.NODE_ENV!=='production'){const isString=value=>typeof value==='string';// IE11 support, replace with Number.isNaN
// eslint-disable-next-line no-restricted-globals
const isNumber=value=>!isNaN(parseFloat(value));if(!isString(props)&&!Array.isArray(props)){console.error('MUI: Argument "props" must be a string or Array.');}if(!isNumber(durationOption)&&!isString(durationOption)){console.error(`MUI: Argument "duration" must be a number or a string but found ${durationOption}.`);}if(!isString(easingOption)){console.error('MUI: Argument "easing" must be a string.');}if(!isNumber(delay)&&!isString(delay)){console.error('MUI: Argument "delay" must be a number or a string.');}if(typeof options!=='object'){console.error(['MUI: Secong argument of transition.create must be an object.',"Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join('\n'));}if(Object.keys(other).length!==0){console.error(`MUI: Unrecognized argument(s) [${Object.keys(other).join(',')}].`);}}return (Array.isArray(props)?props:[props]).map(animatedProp=>`${animatedProp} ${typeof durationOption==='string'?durationOption:formatMs(durationOption)} ${easingOption} ${typeof delay==='string'?delay:formatMs(delay)}`).join(',');};return _extends$2({getAutoHeightDuration,create},inputTransitions,{easing:mergedEasing,duration:mergedDuration});}// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const zIndex={mobileStepper:1000,fab:1050,speedDial:1050,appBar:1100,drawer:1200,modal:1300,snackbar:1400,tooltip:1500};var zIndex$1=zIndex;const _excluded$3=["breakpoints","mixins","spacing","palette","transitions","typography","shape"];function createTheme(options={},...args){const{mixins:mixinsInput={},palette:paletteInput={},transitions:transitionsInput={},typography:typographyInput={}}=options,other=_objectWithoutPropertiesLoose$1(options,_excluded$3);if(options.vars){throw new Error(process.env.NODE_ENV!=="production"?`MUI: \`vars\` is a private field used for CSS variables support.
Please use another name.`:formatMuiErrorMessage$1(18));}const palette=createPalette(paletteInput);const systemTheme=createTheme$2(options);let muiTheme=deepmerge$1(systemTheme,{mixins:createMixins(systemTheme.breakpoints,mixinsInput),palette,// Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
shadows:shadows$1.slice(),typography:createTypography(palette,typographyInput),transitions:createTransitions(transitionsInput),zIndex:_extends$2({},zIndex$1)});muiTheme=deepmerge$1(muiTheme,other);muiTheme=args.reduce((acc,argument)=>deepmerge$1(acc,argument),muiTheme);if(process.env.NODE_ENV!=='production'){// TODO v6: Refactor to use globalStateClassesMapping from @mui/utils once `readOnly` state class is used in Rating component.
const stateClasses=['active','checked','completed','disabled','error','expanded','focused','focusVisible','required','selected'];const traverse=(node,component)=>{let key;// eslint-disable-next-line guard-for-in, no-restricted-syntax
for(key in node){const child=node[key];if(stateClasses.indexOf(key)!==-1&&Object.keys(child).length>0){if(process.env.NODE_ENV!=='production'){const stateClass=generateUtilityClass('',key);console.error([`MUI: The \`${component}\` component increases `+`the CSS specificity of the \`${key}\` internal state.`,'You can not override it like this: ',JSON.stringify(node,null,2),'',`Instead, you need to use the '&.${stateClass}' syntax:`,JSON.stringify({root:{[`&.${stateClass}`]:child}},null,2),'','https://mui.com/r/state-classes-guide'].join('\n'));}// Remove the style to prevent global conflicts.
node[key]={};}}};Object.keys(muiTheme.components).forEach(component=>{const styleOverrides=muiTheme.components[component].styleOverrides;if(styleOverrides&&component.indexOf('Mui')===0){traverse(styleOverrides,component);}});}muiTheme.unstable_sxConfig=_extends$2({},defaultSxConfig$1,other==null?void 0:other.unstable_sxConfig);muiTheme.unstable_sx=function sx(props){return styleFunctionSx$2({sx:props,theme:this});};return muiTheme;}const defaultTheme=createTheme();var defaultTheme$1=defaultTheme;var THEME_ID='$$material';function useThemeProps({props,name}){return useThemeProps$1({props,name,defaultTheme:defaultTheme$1,themeId:THEME_ID});}var createStyled$1={};var _extends$1$1={exports:{}};(function(module){function _extends(){module.exports=_extends=Object.assign?Object.assign.bind():function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;},module.exports.__esModule=true,module.exports["default"]=module.exports;return _extends.apply(this,arguments);}module.exports=_extends,module.exports.__esModule=true,module.exports["default"]=module.exports;})(_extends$1$1);var objectWithoutPropertiesLoose={exports:{}};(function(module){function _objectWithoutPropertiesLoose(source,excluded){if(source==null)return {};var target={};var sourceKeys=Object.keys(source);var key,i;for(i=0;i<sourceKeys.length;i++){key=sourceKeys[i];if(excluded.indexOf(key)>=0)continue;target[key]=source[key];}return target;}module.exports=_objectWithoutPropertiesLoose,module.exports.__esModule=true,module.exports["default"]=module.exports;})(objectWithoutPropertiesLoose);var require$$3=/*@__PURE__*/getAugmentedNamespace(styledEngine);var require$$4=/*@__PURE__*/getAugmentedNamespace(deepmerge);var require$$5=/*@__PURE__*/getAugmentedNamespace(capitalize$1);var require$$6=/*@__PURE__*/getAugmentedNamespace(getDisplayName);var require$$7=/*@__PURE__*/getAugmentedNamespace(createTheme$1);var require$$8=/*@__PURE__*/getAugmentedNamespace(styleFunctionSx);var _interopRequireDefault$8=interopRequireDefault.exports;Object.defineProperty(createStyled$1,"__esModule",{value:true});var _default$2=createStyled$1.default=createStyled$3;var shouldForwardProp_1=createStyled$1.shouldForwardProp=shouldForwardProp;createStyled$1.systemDefaultTheme=void 0;var _extends2$1=_interopRequireDefault$8(_extends$1$1.exports);var _objectWithoutPropertiesLoose2=_interopRequireDefault$8(objectWithoutPropertiesLoose.exports);var _styledEngine=_interopRequireWildcard(require$$3);var _deepmerge=require$$4;var _capitalize=_interopRequireDefault$8(require$$5);var _getDisplayName=_interopRequireDefault$8(require$$6);var _createTheme=_interopRequireDefault$8(require$$7);var _styleFunctionSx=_interopRequireDefault$8(require$$8);const _excluded$2=["ownerState"],_excluded2=["variants"],_excluded3=["name","slot","skipVariantsResolver","skipSx","overridesResolver"];/* eslint-disable no-underscore-dangle */function _getRequireWildcardCache(e){if("function"!=typeof WeakMap)return null;var r=new WeakMap(),t=new WeakMap();return (_getRequireWildcardCache=function(e){return e?t:r;})(e);}function _interopRequireWildcard(e,r){if(!r&&e&&e.__esModule)return e;if(null===e||"object"!=typeof e&&"function"!=typeof e)return {default:e};var t=_getRequireWildcardCache(r);if(t&&t.has(e))return t.get(e);var n={__proto__:null},a=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var u in e)if("default"!==u&&Object.prototype.hasOwnProperty.call(e,u)){var i=a?Object.getOwnPropertyDescriptor(e,u):null;i&&(i.get||i.set)?Object.defineProperty(n,u,i):n[u]=e[u];}return n.default=e,t&&t.set(e,n),n;}function isEmpty(obj){return Object.keys(obj).length===0;}// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function isStringTag(tag){return typeof tag==='string'&&// 96 is one less than the char code
// for "a" so this is checking that
// it's a lowercase character
tag.charCodeAt(0)>96;}// Update /system/styled/#api in case if this changes
function shouldForwardProp(prop){return prop!=='ownerState'&&prop!=='theme'&&prop!=='sx'&&prop!=='as';}const systemDefaultTheme=createStyled$1.systemDefaultTheme=(0, _createTheme.default)();const lowercaseFirstLetter=string=>{if(!string){return string;}return string.charAt(0).toLowerCase()+string.slice(1);};function resolveTheme({defaultTheme,theme,themeId}){return isEmpty(theme)?defaultTheme:theme[themeId]||theme;}function defaultOverridesResolver(slot){if(!slot){return null;}return (props,styles)=>styles[slot];}function processStyleArg(callableStyle,_ref){let{ownerState}=_ref,props=(0, _objectWithoutPropertiesLoose2.default)(_ref,_excluded$2);const resolvedStylesArg=typeof callableStyle==='function'?callableStyle((0, _extends2$1.default)({ownerState},props)):callableStyle;if(Array.isArray(resolvedStylesArg)){return resolvedStylesArg.flatMap(resolvedStyle=>processStyleArg(resolvedStyle,(0, _extends2$1.default)({ownerState},props)));}if(!!resolvedStylesArg&&typeof resolvedStylesArg==='object'&&Array.isArray(resolvedStylesArg.variants)){const{variants=[]}=resolvedStylesArg,otherStyles=(0, _objectWithoutPropertiesLoose2.default)(resolvedStylesArg,_excluded2);let result=otherStyles;variants.forEach(variant=>{let isMatch=true;if(typeof variant.props==='function'){isMatch=variant.props((0, _extends2$1.default)({ownerState},props,ownerState));}else {Object.keys(variant.props).forEach(key=>{if((ownerState==null?void 0:ownerState[key])!==variant.props[key]&&props[key]!==variant.props[key]){isMatch=false;}});}if(isMatch){if(!Array.isArray(result)){result=[result];}result.push(typeof variant.style==='function'?variant.style((0, _extends2$1.default)({ownerState},props,ownerState)):variant.style);}});return result;}return resolvedStylesArg;}function createStyled$3(input={}){const{themeId,defaultTheme=systemDefaultTheme,rootShouldForwardProp=shouldForwardProp,slotShouldForwardProp=shouldForwardProp}=input;const systemSx=props=>{return (0, _styleFunctionSx.default)((0, _extends2$1.default)({},props,{theme:resolveTheme((0, _extends2$1.default)({},props,{defaultTheme,themeId}))}));};systemSx.__mui_systemSx=true;return (tag,inputOptions={})=>{// Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
(0, _styledEngine.internal_processStyles)(tag,styles=>styles.filter(style=>!(style!=null&&style.__mui_systemSx)));const{name:componentName,slot:componentSlot,skipVariantsResolver:inputSkipVariantsResolver,skipSx:inputSkipSx,// TODO v6: remove `lowercaseFirstLetter()` in the next major release
// For more details: https://github.com/mui/material-ui/pull/37908
overridesResolver=defaultOverridesResolver(lowercaseFirstLetter(componentSlot))}=inputOptions,options=(0, _objectWithoutPropertiesLoose2.default)(inputOptions,_excluded3);// if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
const skipVariantsResolver=inputSkipVariantsResolver!==undefined?inputSkipVariantsResolver:// TODO v6: remove `Root` in the next major release
// For more details: https://github.com/mui/material-ui/pull/37908
componentSlot&&componentSlot!=='Root'&&componentSlot!=='root'||false;const skipSx=inputSkipSx||false;let label;if(process.env.NODE_ENV!=='production'){if(componentName){// TODO v6: remove `lowercaseFirstLetter()` in the next major release
// For more details: https://github.com/mui/material-ui/pull/37908
label=`${componentName}-${lowercaseFirstLetter(componentSlot||'Root')}`;}}let shouldForwardPropOption=shouldForwardProp;// TODO v6: remove `Root` in the next major release
// For more details: https://github.com/mui/material-ui/pull/37908
if(componentSlot==='Root'||componentSlot==='root'){shouldForwardPropOption=rootShouldForwardProp;}else if(componentSlot){// any other slot specified
shouldForwardPropOption=slotShouldForwardProp;}else if(isStringTag(tag)){// for string (html) tag, preserve the behavior in emotion & styled-components.
shouldForwardPropOption=undefined;}const defaultStyledResolver=(0, _styledEngine.default)(tag,(0, _extends2$1.default)({shouldForwardProp:shouldForwardPropOption,label},options));const transformStyleArg=stylesArg=>{// On the server Emotion doesn't use React.forwardRef for creating components, so the created
// component stays as a function. This condition makes sure that we do not interpolate functions
// which are basically components used as a selectors.
if(typeof stylesArg==='function'&&stylesArg.__emotion_real!==stylesArg||(0, _deepmerge.isPlainObject)(stylesArg)){return props=>processStyleArg(stylesArg,(0, _extends2$1.default)({},props,{theme:resolveTheme({theme:props.theme,defaultTheme,themeId})}));}return stylesArg;};const muiStyledResolver=(styleArg,...expressions)=>{let transformedStyleArg=transformStyleArg(styleArg);const expressionsWithDefaultTheme=expressions?expressions.map(transformStyleArg):[];if(componentName&&overridesResolver){expressionsWithDefaultTheme.push(props=>{const theme=resolveTheme((0, _extends2$1.default)({},props,{defaultTheme,themeId}));if(!theme.components||!theme.components[componentName]||!theme.components[componentName].styleOverrides){return null;}const styleOverrides=theme.components[componentName].styleOverrides;const resolvedStyleOverrides={};// TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
Object.entries(styleOverrides).forEach(([slotKey,slotStyle])=>{resolvedStyleOverrides[slotKey]=processStyleArg(slotStyle,(0, _extends2$1.default)({},props,{theme}));});return overridesResolver(props,resolvedStyleOverrides);});}if(componentName&&!skipVariantsResolver){expressionsWithDefaultTheme.push(props=>{var _theme$components;const theme=resolveTheme((0, _extends2$1.default)({},props,{defaultTheme,themeId}));const themeVariants=theme==null||(_theme$components=theme.components)==null||(_theme$components=_theme$components[componentName])==null?void 0:_theme$components.variants;return processStyleArg({variants:themeVariants},(0, _extends2$1.default)({},props,{theme}));});}if(!skipSx){expressionsWithDefaultTheme.push(systemSx);}const numOfCustomFnsApplied=expressionsWithDefaultTheme.length-expressions.length;if(Array.isArray(styleArg)&&numOfCustomFnsApplied>0){const placeholders=new Array(numOfCustomFnsApplied).fill('');// If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
transformedStyleArg=[...styleArg,...placeholders];transformedStyleArg.raw=[...styleArg.raw,...placeholders];}const Component=defaultStyledResolver(transformedStyleArg,...expressionsWithDefaultTheme);if(process.env.NODE_ENV!=='production'){let displayName;if(componentName){displayName=`${componentName}${(0, _capitalize.default)(componentSlot||'')}`;}if(displayName===undefined){displayName=`Styled(${(0, _getDisplayName.default)(tag)})`;}Component.displayName=displayName;}if(tag.muiName){Component.muiName=tag.muiName;}return Component;};if(defaultStyledResolver.withConfig){muiStyledResolver.withConfig=defaultStyledResolver.withConfig;}return muiStyledResolver;};}const rootShouldForwardProp=prop=>shouldForwardProp_1(prop)&&prop!=='classes';const slotShouldForwardProp=shouldForwardProp_1;const styled=_default$2({themeId:THEME_ID,defaultTheme:defaultTheme$1,rootShouldForwardProp});var styled$1=styled;function useTheme(){const theme=useTheme$1(defaultTheme$1);if(process.env.NODE_ENV!=='production'){// eslint-disable-next-line react-hooks/rules-of-hooks
React.useDebugValue(theme);}return theme[THEME_ID]||theme;}const shouldSpreadAdditionalProps=Slot=>{return !Slot||!isHostComponent(Slot);};var shouldSpreadAdditionalProps$1=shouldSpreadAdditionalProps;function getSliderUtilityClass(slot){return generateUtilityClass('MuiSlider',slot);}const sliderClasses=generateUtilityClasses('MuiSlider',['root','active','colorPrimary','colorSecondary','colorError','colorInfo','colorSuccess','colorWarning','disabled','dragging','focusVisible','mark','markActive','marked','markLabel','markLabelActive','rail','sizeSmall','thumb','thumbColorPrimary','thumbColorSecondary','thumbColorError','thumbColorSuccess','thumbColorInfo','thumbColorWarning','track','trackInverted','trackFalse','thumbSizeSmall','valueLabel','valueLabelOpen','valueLabelCircle','valueLabelLabel','vertical']);var sliderClasses$1=sliderClasses;const useValueLabelClasses=props=>{const{open}=props;const utilityClasses={offset:clsx$1(open&&sliderClasses$1.valueLabelOpen),circle:sliderClasses$1.valueLabelCircle,label:sliderClasses$1.valueLabelLabel};return utilityClasses;};/**
 * @ignore - internal component.
 */function SliderValueLabel$1(props){const{children,className,value}=props;const classes=useValueLabelClasses(props);if(!children){return null;}return/*#__PURE__*/React.cloneElement(children,{className:clsx$1(children.props.className)},/*#__PURE__*/jsxRuntime$1.exports.jsxs(React.Fragment,{children:[children.props.children,/*#__PURE__*/jsxRuntime$1.exports.jsx("span",{className:clsx$1(classes.offset,className),"aria-hidden":true,children:/*#__PURE__*/jsxRuntime$1.exports.jsx("span",{className:classes.circle,children:/*#__PURE__*/jsxRuntime$1.exports.jsx("span",{className:classes.label,children:value})})})]}));}process.env.NODE_ENV!=="production"?SliderValueLabel$1.propTypes={children:PropTypes.element.isRequired,className:PropTypes.string,value:PropTypes.node}:void 0;const _excluded$1=["aria-label","aria-valuetext","aria-labelledby","component","components","componentsProps","color","classes","className","disableSwap","disabled","getAriaLabel","getAriaValueText","marks","max","min","name","onChange","onChangeCommitted","orientation","shiftStep","size","step","scale","slotProps","slots","tabIndex","track","value","valueLabelDisplay","valueLabelFormat"];function Identity(x){return x;}const SliderRoot=styled$1('span',{name:'MuiSlider',slot:'Root',overridesResolver:(props,styles)=>{const{ownerState}=props;return [styles.root,styles[`color${capitalize$2(ownerState.color)}`],ownerState.size!=='medium'&&styles[`size${capitalize$2(ownerState.size)}`],ownerState.marked&&styles.marked,ownerState.orientation==='vertical'&&styles.vertical,ownerState.track==='inverted'&&styles.trackInverted,ownerState.track===false&&styles.trackFalse];}})(({theme,ownerState})=>_extends$2({borderRadius:12,boxSizing:'content-box',display:'inline-block',position:'relative',cursor:'pointer',touchAction:'none',color:(theme.vars||theme).palette[ownerState.color].main,WebkitTapHighlightColor:'transparent'},ownerState.orientation==='horizontal'&&_extends$2({height:4,width:'100%',padding:'13px 0',// The primary input mechanism of the device includes a pointing device of limited accuracy.
'@media (pointer: coarse)':{// Reach 42px touch target, about ~8mm on screen.
padding:'20px 0'}},ownerState.size==='small'&&{height:2},ownerState.marked&&{marginBottom:20}),ownerState.orientation==='vertical'&&_extends$2({height:'100%',width:4,padding:'0 13px',// The primary input mechanism of the device includes a pointing device of limited accuracy.
'@media (pointer: coarse)':{// Reach 42px touch target, about ~8mm on screen.
padding:'0 20px'}},ownerState.size==='small'&&{width:2},ownerState.marked&&{marginRight:44}),{'@media print':{colorAdjust:'exact'},[`&.${sliderClasses$1.disabled}`]:{pointerEvents:'none',cursor:'default',color:(theme.vars||theme).palette.grey[400]},[`&.${sliderClasses$1.dragging}`]:{[`& .${sliderClasses$1.thumb}, & .${sliderClasses$1.track}`]:{transition:'none'}}}));const SliderRail=styled$1('span',{name:'MuiSlider',slot:'Rail',overridesResolver:(props,styles)=>styles.rail})(({ownerState})=>_extends$2({display:'block',position:'absolute',borderRadius:'inherit',backgroundColor:'currentColor',opacity:0.38},ownerState.orientation==='horizontal'&&{width:'100%',height:'inherit',top:'50%',transform:'translateY(-50%)'},ownerState.orientation==='vertical'&&{height:'100%',width:'inherit',left:'50%',transform:'translateX(-50%)'},ownerState.track==='inverted'&&{opacity:1}));const SliderTrack=styled$1('span',{name:'MuiSlider',slot:'Track',overridesResolver:(props,styles)=>styles.track})(({theme,ownerState})=>{const color=// Same logic as the LinearProgress track color
theme.palette.mode==='light'?lighten_1(theme.palette[ownerState.color].main,0.62):darken_1(theme.palette[ownerState.color].main,0.5);return _extends$2({display:'block',position:'absolute',borderRadius:'inherit',border:'1px solid currentColor',backgroundColor:'currentColor',transition:theme.transitions.create(['left','width','bottom','height'],{duration:theme.transitions.duration.shortest})},ownerState.size==='small'&&{border:'none'},ownerState.orientation==='horizontal'&&{height:'inherit',top:'50%',transform:'translateY(-50%)'},ownerState.orientation==='vertical'&&{width:'inherit',left:'50%',transform:'translateX(-50%)'},ownerState.track===false&&{display:'none'},ownerState.track==='inverted'&&{backgroundColor:theme.vars?theme.vars.palette.Slider[`${ownerState.color}Track`]:color,borderColor:theme.vars?theme.vars.palette.Slider[`${ownerState.color}Track`]:color});});const SliderThumb=styled$1('span',{name:'MuiSlider',slot:'Thumb',overridesResolver:(props,styles)=>{const{ownerState}=props;return [styles.thumb,styles[`thumbColor${capitalize$2(ownerState.color)}`],ownerState.size!=='medium'&&styles[`thumbSize${capitalize$2(ownerState.size)}`]];}})(({theme,ownerState})=>_extends$2({position:'absolute',width:20,height:20,boxSizing:'border-box',borderRadius:'50%',outline:0,backgroundColor:'currentColor',display:'flex',alignItems:'center',justifyContent:'center',transition:theme.transitions.create(['box-shadow','left','bottom'],{duration:theme.transitions.duration.shortest})},ownerState.size==='small'&&{width:12,height:12},ownerState.orientation==='horizontal'&&{top:'50%',transform:'translate(-50%, -50%)'},ownerState.orientation==='vertical'&&{left:'50%',transform:'translate(-50%, 50%)'},{'&::before':_extends$2({position:'absolute',content:'""',borderRadius:'inherit',width:'100%',height:'100%',boxShadow:(theme.vars||theme).shadows[2]},ownerState.size==='small'&&{boxShadow:'none'}),'&::after':{position:'absolute',content:'""',borderRadius:'50%',// 42px is the hit target
width:42,height:42,top:'50%',left:'50%',transform:'translate(-50%, -50%)'},[`&:hover, &.${sliderClasses$1.focusVisible}`]:{boxShadow:`0px 0px 0px 8px ${theme.vars?`rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.16)`:alpha_1(theme.palette[ownerState.color].main,0.16)}`,'@media (hover: none)':{boxShadow:'none'}},[`&.${sliderClasses$1.active}`]:{boxShadow:`0px 0px 0px 14px ${theme.vars?`rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.16)`:alpha_1(theme.palette[ownerState.color].main,0.16)}`},[`&.${sliderClasses$1.disabled}`]:{'&:hover':{boxShadow:'none'}}}));const SliderValueLabel=styled$1(SliderValueLabel$1,{name:'MuiSlider',slot:'ValueLabel',overridesResolver:(props,styles)=>styles.valueLabel})(({theme,ownerState})=>_extends$2({[`&.${sliderClasses$1.valueLabelOpen}`]:{transform:`${ownerState.orientation==='vertical'?'translateY(-50%)':'translateY(-100%)'} scale(1)`},zIndex:1,whiteSpace:'nowrap'},theme.typography.body2,{fontWeight:500,transition:theme.transitions.create(['transform'],{duration:theme.transitions.duration.shortest}),transform:`${ownerState.orientation==='vertical'?'translateY(-50%)':'translateY(-100%)'} scale(0)`,position:'absolute',backgroundColor:(theme.vars||theme).palette.grey[600],borderRadius:2,color:(theme.vars||theme).palette.common.white,display:'flex',alignItems:'center',justifyContent:'center',padding:'0.25rem 0.75rem'},ownerState.orientation==='horizontal'&&{top:'-10px',transformOrigin:'bottom center','&::before':{position:'absolute',content:'""',width:8,height:8,transform:'translate(-50%, 50%) rotate(45deg)',backgroundColor:'inherit',bottom:0,left:'50%'}},ownerState.orientation==='vertical'&&{right:ownerState.size==='small'?'20px':'30px',top:'50%',transformOrigin:'right center','&::before':{position:'absolute',content:'""',width:8,height:8,transform:'translate(-50%, -50%) rotate(45deg)',backgroundColor:'inherit',right:-8,top:'50%'}},ownerState.size==='small'&&{fontSize:theme.typography.pxToRem(12),padding:'0.25rem 0.5rem'}));const SliderMark=styled$1('span',{name:'MuiSlider',slot:'Mark',shouldForwardProp:prop=>slotShouldForwardProp(prop)&&prop!=='markActive',overridesResolver:(props,styles)=>{const{markActive}=props;return [styles.mark,markActive&&styles.markActive];}})(({theme,ownerState,markActive})=>_extends$2({position:'absolute',width:2,height:2,borderRadius:1,backgroundColor:'currentColor'},ownerState.orientation==='horizontal'&&{top:'50%',transform:'translate(-1px, -50%)'},ownerState.orientation==='vertical'&&{left:'50%',transform:'translate(-50%, 1px)'},markActive&&{backgroundColor:(theme.vars||theme).palette.background.paper,opacity:0.8}));const SliderMarkLabel=styled$1('span',{name:'MuiSlider',slot:'MarkLabel',shouldForwardProp:prop=>slotShouldForwardProp(prop)&&prop!=='markLabelActive',overridesResolver:(props,styles)=>styles.markLabel})(({theme,ownerState,markLabelActive})=>_extends$2({},theme.typography.body2,{color:(theme.vars||theme).palette.text.secondary,position:'absolute',whiteSpace:'nowrap'},ownerState.orientation==='horizontal'&&{top:30,transform:'translateX(-50%)','@media (pointer: coarse)':{top:40}},ownerState.orientation==='vertical'&&{left:36,transform:'translateY(50%)','@media (pointer: coarse)':{left:44}},markLabelActive&&{color:(theme.vars||theme).palette.text.primary}));const useUtilityClasses=ownerState=>{const{disabled,dragging,marked,orientation,track,classes,color,size}=ownerState;const slots={root:['root',disabled&&'disabled',dragging&&'dragging',marked&&'marked',orientation==='vertical'&&'vertical',track==='inverted'&&'trackInverted',track===false&&'trackFalse',color&&`color${capitalize$2(color)}`,size&&`size${capitalize$2(size)}`],rail:['rail'],track:['track'],mark:['mark'],markActive:['markActive'],markLabel:['markLabel'],markLabelActive:['markLabelActive'],valueLabel:['valueLabel'],thumb:['thumb',disabled&&'disabled',size&&`thumbSize${capitalize$2(size)}`,color&&`thumbColor${capitalize$2(color)}`],active:['active'],disabled:['disabled'],focusVisible:['focusVisible']};return composeClasses(slots,getSliderUtilityClass,classes);};const Forward=({children})=>children;const Slider$1=/*#__PURE__*/React.forwardRef(function Slider(inputProps,ref){var _ref,_slots$root,_ref2,_slots$rail,_ref3,_slots$track,_ref4,_slots$thumb,_ref5,_slots$valueLabel,_ref6,_slots$mark,_ref7,_slots$markLabel,_ref8,_slots$input,_slotProps$root,_slotProps$rail,_slotProps$track,_slotProps$thumb,_slotProps$valueLabel,_slotProps$mark,_slotProps$markLabel,_slotProps$input;const props=useThemeProps({props:inputProps,name:'MuiSlider'});const theme=useTheme();const isRtl=theme.direction==='rtl';const{'aria-label':ariaLabel,'aria-valuetext':ariaValuetext,'aria-labelledby':ariaLabelledby,// eslint-disable-next-line react/prop-types
component='span',components={},componentsProps={},color='primary',classes:classesProp,className,disableSwap=false,disabled=false,getAriaLabel,getAriaValueText,marks:marksProp=false,max=100,min=0,orientation='horizontal',shiftStep=10,size='medium',step=1,scale=Identity,slotProps,slots,track='normal',valueLabelDisplay='off',valueLabelFormat=Identity}=props,other=_objectWithoutPropertiesLoose$1(props,_excluded$1);const ownerState=_extends$2({},props,{isRtl,max,min,classes:classesProp,disabled,disableSwap,orientation,marks:marksProp,color,size,step,shiftStep,scale,track,valueLabelDisplay,valueLabelFormat});const{axisProps,getRootProps,getHiddenInputProps,getThumbProps,open,active,axis,focusedThumbIndex,range,dragging,marks,values,trackOffset,trackLeap,getThumbStyle}=useSlider(_extends$2({},ownerState,{rootRef:ref}));ownerState.marked=marks.length>0&&marks.some(mark=>mark.label);ownerState.dragging=dragging;ownerState.focusedThumbIndex=focusedThumbIndex;const classes=useUtilityClasses(ownerState);// support both `slots` and `components` for backward compatibility
const RootSlot=(_ref=(_slots$root=slots==null?void 0:slots.root)!=null?_slots$root:components.Root)!=null?_ref:SliderRoot;const RailSlot=(_ref2=(_slots$rail=slots==null?void 0:slots.rail)!=null?_slots$rail:components.Rail)!=null?_ref2:SliderRail;const TrackSlot=(_ref3=(_slots$track=slots==null?void 0:slots.track)!=null?_slots$track:components.Track)!=null?_ref3:SliderTrack;const ThumbSlot=(_ref4=(_slots$thumb=slots==null?void 0:slots.thumb)!=null?_slots$thumb:components.Thumb)!=null?_ref4:SliderThumb;const ValueLabelSlot=(_ref5=(_slots$valueLabel=slots==null?void 0:slots.valueLabel)!=null?_slots$valueLabel:components.ValueLabel)!=null?_ref5:SliderValueLabel;const MarkSlot=(_ref6=(_slots$mark=slots==null?void 0:slots.mark)!=null?_slots$mark:components.Mark)!=null?_ref6:SliderMark;const MarkLabelSlot=(_ref7=(_slots$markLabel=slots==null?void 0:slots.markLabel)!=null?_slots$markLabel:components.MarkLabel)!=null?_ref7:SliderMarkLabel;const InputSlot=(_ref8=(_slots$input=slots==null?void 0:slots.input)!=null?_slots$input:components.Input)!=null?_ref8:'input';const rootSlotProps=(_slotProps$root=slotProps==null?void 0:slotProps.root)!=null?_slotProps$root:componentsProps.root;const railSlotProps=(_slotProps$rail=slotProps==null?void 0:slotProps.rail)!=null?_slotProps$rail:componentsProps.rail;const trackSlotProps=(_slotProps$track=slotProps==null?void 0:slotProps.track)!=null?_slotProps$track:componentsProps.track;const thumbSlotProps=(_slotProps$thumb=slotProps==null?void 0:slotProps.thumb)!=null?_slotProps$thumb:componentsProps.thumb;const valueLabelSlotProps=(_slotProps$valueLabel=slotProps==null?void 0:slotProps.valueLabel)!=null?_slotProps$valueLabel:componentsProps.valueLabel;const markSlotProps=(_slotProps$mark=slotProps==null?void 0:slotProps.mark)!=null?_slotProps$mark:componentsProps.mark;const markLabelSlotProps=(_slotProps$markLabel=slotProps==null?void 0:slotProps.markLabel)!=null?_slotProps$markLabel:componentsProps.markLabel;const inputSlotProps=(_slotProps$input=slotProps==null?void 0:slotProps.input)!=null?_slotProps$input:componentsProps.input;const rootProps=useSlotProps({elementType:RootSlot,getSlotProps:getRootProps,externalSlotProps:rootSlotProps,externalForwardedProps:other,additionalProps:_extends$2({},shouldSpreadAdditionalProps$1(RootSlot)&&{as:component}),ownerState:_extends$2({},ownerState,rootSlotProps==null?void 0:rootSlotProps.ownerState),className:[classes.root,className]});const railProps=useSlotProps({elementType:RailSlot,externalSlotProps:railSlotProps,ownerState,className:classes.rail});const trackProps=useSlotProps({elementType:TrackSlot,externalSlotProps:trackSlotProps,additionalProps:{style:_extends$2({},axisProps[axis].offset(trackOffset),axisProps[axis].leap(trackLeap))},ownerState:_extends$2({},ownerState,trackSlotProps==null?void 0:trackSlotProps.ownerState),className:classes.track});const thumbProps=useSlotProps({elementType:ThumbSlot,getSlotProps:getThumbProps,externalSlotProps:thumbSlotProps,ownerState:_extends$2({},ownerState,thumbSlotProps==null?void 0:thumbSlotProps.ownerState),className:classes.thumb});const valueLabelProps=useSlotProps({elementType:ValueLabelSlot,externalSlotProps:valueLabelSlotProps,ownerState:_extends$2({},ownerState,valueLabelSlotProps==null?void 0:valueLabelSlotProps.ownerState),className:classes.valueLabel});const markProps=useSlotProps({elementType:MarkSlot,externalSlotProps:markSlotProps,ownerState,className:classes.mark});const markLabelProps=useSlotProps({elementType:MarkLabelSlot,externalSlotProps:markLabelSlotProps,ownerState,className:classes.markLabel});const inputSliderProps=useSlotProps({elementType:InputSlot,getSlotProps:getHiddenInputProps,externalSlotProps:inputSlotProps,ownerState});return/*#__PURE__*/jsxRuntime$1.exports.jsxs(RootSlot,_extends$2({},rootProps,{children:[/*#__PURE__*/jsxRuntime$1.exports.jsx(RailSlot,_extends$2({},railProps)),/*#__PURE__*/jsxRuntime$1.exports.jsx(TrackSlot,_extends$2({},trackProps)),marks.filter(mark=>mark.value>=min&&mark.value<=max).map((mark,index)=>{const percent=valueToPercent(mark.value,min,max);const style=axisProps[axis].offset(percent);let markActive;if(track===false){markActive=values.indexOf(mark.value)!==-1;}else {markActive=track==='normal'&&(range?mark.value>=values[0]&&mark.value<=values[values.length-1]:mark.value<=values[0])||track==='inverted'&&(range?mark.value<=values[0]||mark.value>=values[values.length-1]:mark.value>=values[0]);}return/*#__PURE__*/jsxRuntime$1.exports.jsxs(React.Fragment,{children:[/*#__PURE__*/jsxRuntime$1.exports.jsx(MarkSlot,_extends$2({"data-index":index},markProps,!isHostComponent(MarkSlot)&&{markActive},{style:_extends$2({},style,markProps.style),className:clsx$1(markProps.className,markActive&&classes.markActive)})),mark.label!=null?/*#__PURE__*/jsxRuntime$1.exports.jsx(MarkLabelSlot,_extends$2({"aria-hidden":true,"data-index":index},markLabelProps,!isHostComponent(MarkLabelSlot)&&{markLabelActive:markActive},{style:_extends$2({},style,markLabelProps.style),className:clsx$1(classes.markLabel,markLabelProps.className,markActive&&classes.markLabelActive),children:mark.label})):null]},index);}),values.map((value,index)=>{const percent=valueToPercent(value,min,max);const style=axisProps[axis].offset(percent);const ValueLabelComponent=valueLabelDisplay==='off'?Forward:ValueLabelSlot;return/*#__PURE__*/ /* TODO v6: Change component structure. It will help in avoiding the complicated React.cloneElement API added in SliderValueLabel component. Should be: Thumb -> Input, ValueLabel. Follow Joy UI's Slider structure. */jsxRuntime$1.exports.jsx(ValueLabelComponent,_extends$2({},!isHostComponent(ValueLabelComponent)&&{valueLabelFormat,valueLabelDisplay,value:typeof valueLabelFormat==='function'?valueLabelFormat(scale(value),index):valueLabelFormat,index,open:open===index||active===index||valueLabelDisplay==='on',disabled},valueLabelProps,{children:/*#__PURE__*/jsxRuntime$1.exports.jsx(ThumbSlot,_extends$2({"data-index":index},thumbProps,{className:clsx$1(classes.thumb,thumbProps.className,active===index&&classes.active,focusedThumbIndex===index&&classes.focusVisible),style:_extends$2({},style,getThumbStyle(index),thumbProps.style),children:/*#__PURE__*/jsxRuntime$1.exports.jsx(InputSlot,_extends$2({"data-index":index,"aria-label":getAriaLabel?getAriaLabel(index):ariaLabel,"aria-valuenow":scale(value),"aria-labelledby":ariaLabelledby,"aria-valuetext":getAriaValueText?getAriaValueText(scale(value),index):ariaValuetext,value:values[index]},inputSliderProps))}))}),index);})]}));});process.env.NODE_ENV!=="production"?Slider$1.propTypes/* remove-proptypes */={// ┌────────────────────────────── Warning ──────────────────────────────┐
// │ These PropTypes are generated from the TypeScript type definitions. │
// │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
// └─────────────────────────────────────────────────────────────────────┘
/**
   * The label of the slider.
   */'aria-label':chainPropTypes(PropTypes.string,props=>{const range=Array.isArray(props.value||props.defaultValue);if(range&&props['aria-label']!=null){return new Error('MUI: You need to use the `getAriaLabel` prop instead of `aria-label` when using a range slider.');}return null;}),/**
   * The id of the element containing a label for the slider.
   */'aria-labelledby':PropTypes.string,/**
   * A string value that provides a user-friendly name for the current value of the slider.
   */'aria-valuetext':chainPropTypes(PropTypes.string,props=>{const range=Array.isArray(props.value||props.defaultValue);if(range&&props['aria-valuetext']!=null){return new Error('MUI: You need to use the `getAriaValueText` prop instead of `aria-valuetext` when using a range slider.');}return null;}),/**
   * @ignore
   */children:PropTypes.node,/**
   * Override or extend the styles applied to the component.
   */classes:PropTypes.object,/**
   * @ignore
   */className:PropTypes.string,/**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */color:PropTypes/* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['primary','secondary','error','info','success','warning']),PropTypes.string]),/**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */components:PropTypes.shape({Input:PropTypes.elementType,Mark:PropTypes.elementType,MarkLabel:PropTypes.elementType,Rail:PropTypes.elementType,Root:PropTypes.elementType,Thumb:PropTypes.elementType,Track:PropTypes.elementType,ValueLabel:PropTypes.elementType}),/**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */componentsProps:PropTypes.shape({input:PropTypes.oneOfType([PropTypes.func,PropTypes.object]),mark:PropTypes.oneOfType([PropTypes.func,PropTypes.object]),markLabel:PropTypes.oneOfType([PropTypes.func,PropTypes.object]),rail:PropTypes.oneOfType([PropTypes.func,PropTypes.object]),root:PropTypes.oneOfType([PropTypes.func,PropTypes.object]),thumb:PropTypes.oneOfType([PropTypes.func,PropTypes.object]),track:PropTypes.oneOfType([PropTypes.func,PropTypes.object]),valueLabel:PropTypes.oneOfType([PropTypes.func,PropTypes.shape({children:PropTypes.element,className:PropTypes.string,open:PropTypes.bool,style:PropTypes.object,value:PropTypes.number,valueLabelDisplay:PropTypes.oneOf(['auto','off','on'])})])}),/**
   * The default value. Use when the component is not controlled.
   */defaultValue:PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.number),PropTypes.number]),/**
   * If `true`, the component is disabled.
   * @default false
   */disabled:PropTypes.bool,/**
   * If `true`, the active thumb doesn't swap when moving pointer over a thumb while dragging another thumb.
   * @default false
   */disableSwap:PropTypes.bool,/**
   * Accepts a function which returns a string value that provides a user-friendly name for the thumb labels of the slider.
   * This is important for screen reader users.
   * @param {number} index The thumb label's index to format.
   * @returns {string}
   */getAriaLabel:PropTypes.func,/**
   * Accepts a function which returns a string value that provides a user-friendly name for the current value of the slider.
   * This is important for screen reader users.
   * @param {number} value The thumb label's value to format.
   * @param {number} index The thumb label's index to format.
   * @returns {string}
   */getAriaValueText:PropTypes.func,/**
   * Marks indicate predetermined values to which the user can move the slider.
   * If `true` the marks are spaced according the value of the `step` prop.
   * If an array, it should contain objects with `value` and an optional `label` keys.
   * @default false
   */marks:PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({label:PropTypes.node,value:PropTypes.number.isRequired})),PropTypes.bool]),/**
   * The maximum allowed value of the slider.
   * Should not be equal to min.
   * @default 100
   */max:PropTypes.number,/**
   * The minimum allowed value of the slider.
   * Should not be equal to max.
   * @default 0
   */min:PropTypes.number,/**
   * Name attribute of the hidden `input` element.
   */name:PropTypes.string,/**
   * Callback function that is fired when the slider's value changed.
   *
   * @param {Event} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event not a change event.
   * @param {number | number[]} value The new value.
   * @param {number} activeThumb Index of the currently moved thumb.
   */onChange:PropTypes.func,/**
   * Callback function that is fired when the `mouseup` is triggered.
   *
   * @param {React.SyntheticEvent | Event} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {number | number[]} value The new value.
   */onChangeCommitted:PropTypes.func,/**
   * The component orientation.
   * @default 'horizontal'
   */orientation:PropTypes.oneOf(['horizontal','vertical']),/**
   * A transformation function, to change the scale of the slider.
   * @param {any} x
   * @returns {any}
   * @default function Identity(x) {
   *   return x;
   * }
   */scale:PropTypes.func,/**
   * The granularity with which the slider can step through values when using Page Up/Page Down or Shift + Arrow Up/Arrow Down.
   * @default 10
   */shiftStep:PropTypes.number,/**
   * The size of the slider.
   * @default 'medium'
   */size:PropTypes/* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['small','medium']),PropTypes.string]),/**
   * The props used for each slot inside the Slider.
   * @default {}
   */slotProps:PropTypes.shape({input:PropTypes.oneOfType([PropTypes.func,PropTypes.object]),mark:PropTypes.oneOfType([PropTypes.func,PropTypes.object]),markLabel:PropTypes.oneOfType([PropTypes.func,PropTypes.object]),rail:PropTypes.oneOfType([PropTypes.func,PropTypes.object]),root:PropTypes.oneOfType([PropTypes.func,PropTypes.object]),thumb:PropTypes.oneOfType([PropTypes.func,PropTypes.object]),track:PropTypes.oneOfType([PropTypes.func,PropTypes.object]),valueLabel:PropTypes.oneOfType([PropTypes.func,PropTypes.shape({children:PropTypes.element,className:PropTypes.string,open:PropTypes.bool,style:PropTypes.object,value:PropTypes.number,valueLabelDisplay:PropTypes.oneOf(['auto','off','on'])})])}),/**
   * The components used for each slot inside the Slider.
   * Either a string to use a HTML element or a component.
   * @default {}
   */slots:PropTypes.shape({input:PropTypes.elementType,mark:PropTypes.elementType,markLabel:PropTypes.elementType,rail:PropTypes.elementType,root:PropTypes.elementType,thumb:PropTypes.elementType,track:PropTypes.elementType,valueLabel:PropTypes.elementType}),/**
   * The granularity with which the slider can step through values. (A "discrete" slider.)
   * The `min` prop serves as the origin for the valid values.
   * We recommend (max - min) to be evenly divisible by the step.
   *
   * When step is `null`, the thumb can only be slid onto marks provided with the `marks` prop.
   * @default 1
   */step:PropTypes.number,/**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */sx:PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func,PropTypes.object,PropTypes.bool])),PropTypes.func,PropTypes.object]),/**
   * Tab index attribute of the hidden `input` element.
   */tabIndex:PropTypes.number,/**
   * The track presentation:
   *
   * - `normal` the track will render a bar representing the slider value.
   * - `inverted` the track will render a bar representing the remaining slider value.
   * - `false` the track will render without a bar.
   * @default 'normal'
   */track:PropTypes.oneOf(['inverted','normal',false]),/**
   * The value of the slider.
   * For ranged sliders, provide an array with two values.
   */value:PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.number),PropTypes.number]),/**
   * Controls when the value label is displayed:
   *
   * - `auto` the value label will display when the thumb is hovered or focused.
   * - `on` will display persistently.
   * - `off` will never display.
   * @default 'off'
   */valueLabelDisplay:PropTypes.oneOf(['auto','off','on']),/**
   * The format function the value label's value.
   *
   * When a function is provided, it should have the following signature:
   *
   * - {number} value The value label's value to format
   * - {number} index The value label's index to format
   * @param {any} x
   * @returns {any}
   * @default function Identity(x) {
   *   return x;
   * }
   */valueLabelFormat:PropTypes.oneOfType([PropTypes.func,PropTypes.string])}:void 0;var Slider$2=Slider$1;var css_248z$5$1=".themedContainer{display:flex}.themedContainer .MuiSlider-marked .MuiSlider-markLabel{z-index:10}.themedContainer .MuiSlider-marked .MuiSlider-markLabel:hover{z-index:20}.themedContainer .MuiSlider-colorPrimary{color:var(--theme-primary-color)!important}.themedContainer .MuiSlider-mark{background-color:var(--theme-primary-color)!important;height:20px!important}";styleInject$1(css_248z$5$1,{"insertAt":"top"});const stringTimeFromNumber=time=>{const minute=String(parseInt(time/60));const seconds=String(parseInt(time%60));return `${minute.padStart(2,"0")}:${seconds.padStart(2,"0")}`;};function SmartTimeline({song,isLooping,loopStart,loopEnd,getCurrentPosition,onPositionChange}){const[seek,setSeek]=useState(null);const[selectingSection,setSelectingSection]=useState(false);const getValue=()=>{if(isLooping){return [loopStart,loopEnd];}else {return time;}};const[time,setTime]=useState(0);const[currentSection,setCurrentSection]=useState(song.sections[0]);const timeInterval=useRef(null);useEffect(()=>{timeInterval.current=setInterval(()=>{const time=getCurrentPosition();setTime(time);let foundSection=song.sections[0];for(let index=0;index<song.sections.length;index++){const section=song.sections[index];if(time>=section.start)foundSection=section;}setCurrentSection(foundSection);},100);return ()=>{clearInterval(timeInterval.current);};},[]);const formMarksFromSong=song=>{return song.sections.map(section=>({value:section.start// label: formLabel(section.label, ()=> onPositionChange(section.start)),
}));};const positionChanged=(e,value)=>{// if (!blocking.current) {
onPositionChange(value);setSeek(null);// }
};const renderSectionButtons=()=>{return/*#__PURE__*/React__default.createElement("ul",{className:"flex flex-col justify-center gap-2 "},song.sections.map(section=>/*#__PURE__*/React__default.createElement("li",{className:"flex justify-center",key:section.start},/*#__PURE__*/React__default.createElement(Button,{additionalClasses:"grow",onClick:()=>{positionChanged(null,section.start);setSelectingSection(false);}},section.label))));};return/*#__PURE__*/React__default.createElement("div",{className:`themedContainer flex  ${isLooping?"looping":""} lg:mx-0 mx-2`},/*#__PURE__*/React__default.createElement("div",{className:"w-[60px] mr-4 mb-4 text-secondary-300"},stringTimeFromNumber(time)),/*#__PURE__*/React__default.createElement("div",{className:"flex-1"},/*#__PURE__*/React__default.createElement(Slider$2,{onChangeCommitted:positionChanged,"aria-label":"Song Timeline",defaultValue:0,valueLabelFormat:stringTimeFromNumber,max:song.length,value:getValue(),valueLabelDisplay:"auto",marks:formMarksFromSong(song),markLabel:label=>/*#__PURE__*/React__default.createElement("div",{className:"text-secondary-900 dark:text-secondary-300"},label)}),/*#__PURE__*/React__default.createElement("div",{className:"flex justify-center mt-1"},/*#__PURE__*/React__default.createElement(Button,{id:"section-button",onClick:()=>setSelectingSection(true),size:"sm"},/*#__PURE__*/React__default.createElement(ListBulletIcon$1,{className:"h-6 w-6 mr-2 ","aria-hidden":"true"}),currentSection.label)),/*#__PURE__*/React__default.createElement(Modal,{isOpen:selectingSection,title:"Jump to section",content:renderSectionButtons(),onClose:()=>setSelectingSection(false),closeLabel:"Close",confirmable:true})),/*#__PURE__*/React__default.createElement("div",{className:"w-[60px] text-right ml-4 mb-4 text-secondary-300"},stringTimeFromNumber(song.length)));}SmartTimeline.propTypes={isLooping:PropTypes.bool,loopStart:PropTypes.number,loopEnd:PropTypes.number,getCurrentPosition:PropTypes.func.isRequired,song:PropTypes.shape({length:PropTypes.number.isRequired,sections:PropTypes.arrayOf(PropTypes.shape({label:PropTypes.string.isRequired,start:PropTypes.number.isRequired,end:PropTypes.number.isRequired}))}),onSectionSelected:PropTypes.func,onPositionChange:PropTypes.func,type:PropTypes.oneOf(["default"]),// Would be better to use Object.keys but it won't work with Storybook currently
size:PropTypes.oneOf(["base"]),labelColour:PropTypes.string,progressColour:PropTypes.string,trackColour:PropTypes.string,activeSectionColour:PropTypes.string,loopSectionColour:PropTypes.string};function PlayerBottomControl({getCurrentPosition,song,onSectionSelected,onPositionChange,isLooping,loopStart,loopEnd,onLoop,type,size,onChangeIntroLevel,onChangeClick1Level,onChangeClick2Level,onChangeCueLevel,levelStep,introLevel,click1Level,click2Level,cueLevel,...props}){return/*#__PURE__*/React__default.createElement("div",null,/*#__PURE__*/React__default.createElement("div",{className:"flex items-center justify-between bg-secondary-800 h-32 lg:h-20 w-full px-1 sm:px-2"},/*#__PURE__*/React__default.createElement("div",{className:"hidden lg:flex flex-col w-52 text-secondary-200"},/*#__PURE__*/React__default.createElement("div",{className:"font-semibold truncate text-base"},song.title),/*#__PURE__*/React__default.createElement("div",{className:"text-xs"},song.artist)),/*#__PURE__*/React__default.createElement("div",{className:"flex-1 flex flex-col lg:flex-row"},/*#__PURE__*/React__default.createElement("div",{className:"flex-1 dark:block mb-3 "},/*#__PURE__*/React__default.createElement(SmartTimeline,{getCurrentPosition:getCurrentPosition,song:song,onSectionSelected:onSectionSelected,onPositionChange:onPositionChange,isLooping:isLooping,loopStart:loopStart,loopEnd:loopEnd})))));}PlayerBottomControl.propTypes={currentPosition:PropTypes.func,song:PropTypes.shape({title:PropTypes.string.isRequired,artist:PropTypes.string.isRequired,length:PropTypes.number.isRequired,sections:PropTypes.arrayOf(PropTypes.shape({label:PropTypes.string.isRequired,start:PropTypes.number.isRequired,end:PropTypes.number.isRequired}))}),onSectionSelected:PropTypes.func,onPositionChange:PropTypes.func,isLooping:PropTypes.bool,loopStart:PropTypes.number,loopEnd:PropTypes.number,onLoop:PropTypes.func,type:PropTypes.oneOf(["default"]),// Would be better to use Object.keys but it won't work with Storybook currently
size:PropTypes.oneOf(["base"])};PlayerBottomControl.defaultProps={onSectionSelected:undefined,onPositionChange:undefined,looping:false,onLoop:undefined,type:"default",size:"base"};function clamp(v,min,max){return Math.max(min,Math.min(v,max));}const V$2={toVector(v,fallback){if(v===undefined)v=fallback;return Array.isArray(v)?v:[v,v];},add(v1,v2){return [v1[0]+v2[0],v1[1]+v2[1]];},sub(v1,v2){return [v1[0]-v2[0],v1[1]-v2[1]];},addTo(v1,v2){v1[0]+=v2[0];v1[1]+=v2[1];},subTo(v1,v2){v1[0]-=v2[0];v1[1]-=v2[1];}};function rubberband(distance,dimension,constant){if(dimension===0||Math.abs(dimension)===Infinity)return Math.pow(distance,constant*5);return distance*dimension*constant/(dimension+constant*distance);}function rubberbandIfOutOfBounds(position,min,max,constant=0.15){if(constant===0)return clamp(position,min,max);if(position<min)return -rubberband(min-position,max-min,constant)+min;if(position>max)return +rubberband(position-max,max-min,constant)+max;return position;}function computeRubberband(bounds,[Vx,Vy],[Rx,Ry]){const[[X0,X1],[Y0,Y1]]=bounds;return [rubberbandIfOutOfBounds(Vx,X0,X1,Rx),rubberbandIfOutOfBounds(Vy,Y0,Y1,Ry)];}function _toPrimitive$1(input,hint){if(typeof input!=="object"||input===null)return input;var prim=input[Symbol.toPrimitive];if(prim!==undefined){var res=prim.call(input,hint||"default");if(typeof res!=="object")return res;throw new TypeError("@@toPrimitive must return a primitive value.");}return (hint==="string"?String:Number)(input);}function _toPropertyKey(arg){var key=_toPrimitive$1(arg,"string");return typeof key==="symbol"?key:String(key);}function _defineProperty$4(obj,key,value){key=_toPropertyKey(key);if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else {obj[key]=value;}return obj;}function ownKeys$3(e,r){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(e);r&&(o=o.filter(function(r){return Object.getOwnPropertyDescriptor(e,r).enumerable;})),t.push.apply(t,o);}return t;}function _objectSpread2(e){for(var r=1;r<arguments.length;r++){var t=null!=arguments[r]?arguments[r]:{};r%2?ownKeys$3(Object(t),!0).forEach(function(r){_defineProperty$4(e,r,t[r]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):ownKeys$3(Object(t)).forEach(function(r){Object.defineProperty(e,r,Object.getOwnPropertyDescriptor(t,r));});}return e;}const EVENT_TYPE_MAP={pointer:{start:'down',change:'move',end:'up'},mouse:{start:'down',change:'move',end:'up'},touch:{start:'start',change:'move',end:'end'},gesture:{start:'start',change:'change',end:'end'}};function capitalize(string){if(!string)return '';return string[0].toUpperCase()+string.slice(1);}const actionsWithoutCaptureSupported=['enter','leave'];function hasCapture(capture=false,actionKey){return capture&&!actionsWithoutCaptureSupported.includes(actionKey);}function toHandlerProp(device,action='',capture=false){const deviceProps=EVENT_TYPE_MAP[device];const actionKey=deviceProps?deviceProps[action]||action:action;return 'on'+capitalize(device)+capitalize(actionKey)+(hasCapture(capture,actionKey)?'Capture':'');}const pointerCaptureEvents=['gotpointercapture','lostpointercapture'];function parseProp(prop){let eventKey=prop.substring(2).toLowerCase();const passive=!!~eventKey.indexOf('passive');if(passive)eventKey=eventKey.replace('passive','');const captureKey=pointerCaptureEvents.includes(eventKey)?'capturecapture':'capture';const capture=!!~eventKey.indexOf(captureKey);if(capture)eventKey=eventKey.replace('capture','');return {device:eventKey,capture,passive};}function toDomEventType(device,action=''){const deviceProps=EVENT_TYPE_MAP[device];const actionKey=deviceProps?deviceProps[action]||action:action;return device+actionKey;}function isTouch(event){return 'touches'in event;}function getPointerType(event){if(isTouch(event))return 'touch';if('pointerType'in event)return event.pointerType;return 'mouse';}function getCurrentTargetTouchList(event){return Array.from(event.touches).filter(e=>{var _event$currentTarget,_event$currentTarget$;return e.target===event.currentTarget||((_event$currentTarget=event.currentTarget)===null||_event$currentTarget===void 0||(_event$currentTarget$=_event$currentTarget.contains)===null||_event$currentTarget$===void 0?void 0:_event$currentTarget$.call(_event$currentTarget,e.target));});}function getTouchList(event){return event.type==='touchend'||event.type==='touchcancel'?event.changedTouches:event.targetTouches;}function getValueEvent(event){return isTouch(event)?getTouchList(event)[0]:event;}function touchIds(event){return getCurrentTargetTouchList(event).map(touch=>touch.identifier);}function pointerId(event){const valueEvent=getValueEvent(event);return isTouch(event)?valueEvent.identifier:valueEvent.pointerId;}function pointerValues(event){const valueEvent=getValueEvent(event);return [valueEvent.clientX,valueEvent.clientY];}function getEventDetails(event){const payload={};if('buttons'in event)payload.buttons=event.buttons;if('shiftKey'in event){const{shiftKey,altKey,metaKey,ctrlKey}=event;Object.assign(payload,{shiftKey,altKey,metaKey,ctrlKey});}return payload;}function call(v,...args){if(typeof v==='function'){return v(...args);}else {return v;}}function noop$2(){}function chain(...fns){if(fns.length===0)return noop$2;if(fns.length===1)return fns[0];return function(){let result;for(const fn of fns){result=fn.apply(this,arguments)||result;}return result;};}function assignDefault(value,fallback){return Object.assign({},fallback,value||{});}const BEFORE_LAST_KINEMATICS_DELAY=32;class Engine{constructor(ctrl,args,key){this.ctrl=ctrl;this.args=args;this.key=key;if(!this.state){this.state={};this.computeValues([0,0]);this.computeInitial();if(this.init)this.init();this.reset();}}get state(){return this.ctrl.state[this.key];}set state(state){this.ctrl.state[this.key]=state;}get shared(){return this.ctrl.state.shared;}get eventStore(){return this.ctrl.gestureEventStores[this.key];}get timeoutStore(){return this.ctrl.gestureTimeoutStores[this.key];}get config(){return this.ctrl.config[this.key];}get sharedConfig(){return this.ctrl.config.shared;}get handler(){return this.ctrl.handlers[this.key];}reset(){const{state,shared,ingKey,args}=this;shared[ingKey]=state._active=state.active=state._blocked=state._force=false;state._step=[false,false];state.intentional=false;state._movement=[0,0];state._distance=[0,0];state._direction=[0,0];state._delta=[0,0];state._bounds=[[-Infinity,Infinity],[-Infinity,Infinity]];state.args=args;state.axis=undefined;state.memo=undefined;state.elapsedTime=state.timeDelta=0;state.direction=[0,0];state.distance=[0,0];state.overflow=[0,0];state._movementBound=[false,false];state.velocity=[0,0];state.movement=[0,0];state.delta=[0,0];state.timeStamp=0;}start(event){const state=this.state;const config=this.config;if(!state._active){this.reset();this.computeInitial();state._active=true;state.target=event.target;state.currentTarget=event.currentTarget;state.lastOffset=config.from?call(config.from,state):state.offset;state.offset=state.lastOffset;state.startTime=state.timeStamp=event.timeStamp;}}computeValues(values){const state=this.state;state._values=values;state.values=this.config.transform(values);}computeInitial(){const state=this.state;state._initial=state._values;state.initial=state.values;}compute(event){const{state,config,shared}=this;state.args=this.args;let dt=0;if(event){state.event=event;if(config.preventDefault&&event.cancelable)state.event.preventDefault();state.type=event.type;shared.touches=this.ctrl.pointerIds.size||this.ctrl.touchIds.size;shared.locked=!!document.pointerLockElement;Object.assign(shared,getEventDetails(event));shared.down=shared.pressed=shared.buttons%2===1||shared.touches>0;dt=event.timeStamp-state.timeStamp;state.timeStamp=event.timeStamp;state.elapsedTime=state.timeStamp-state.startTime;}if(state._active){const _absoluteDelta=state._delta.map(Math.abs);V$2.addTo(state._distance,_absoluteDelta);}if(this.axisIntent)this.axisIntent(event);const[_m0,_m1]=state._movement;const[t0,t1]=config.threshold;const{_step,values}=state;if(config.hasCustomTransform){if(_step[0]===false)_step[0]=Math.abs(_m0)>=t0&&values[0];if(_step[1]===false)_step[1]=Math.abs(_m1)>=t1&&values[1];}else {if(_step[0]===false)_step[0]=Math.abs(_m0)>=t0&&Math.sign(_m0)*t0;if(_step[1]===false)_step[1]=Math.abs(_m1)>=t1&&Math.sign(_m1)*t1;}state.intentional=_step[0]!==false||_step[1]!==false;if(!state.intentional)return;const movement=[0,0];if(config.hasCustomTransform){const[v0,v1]=values;movement[0]=_step[0]!==false?v0-_step[0]:0;movement[1]=_step[1]!==false?v1-_step[1]:0;}else {movement[0]=_step[0]!==false?_m0-_step[0]:0;movement[1]=_step[1]!==false?_m1-_step[1]:0;}if(this.restrictToAxis&&!state._blocked)this.restrictToAxis(movement);const previousOffset=state.offset;const gestureIsActive=state._active&&!state._blocked||state.active;if(gestureIsActive){state.first=state._active&&!state.active;state.last=!state._active&&state.active;state.active=shared[this.ingKey]=state._active;if(event){if(state.first){if('bounds'in config)state._bounds=call(config.bounds,state);if(this.setup)this.setup();}state.movement=movement;this.computeOffset();}}const[ox,oy]=state.offset;const[[x0,x1],[y0,y1]]=state._bounds;state.overflow=[ox<x0?-1:ox>x1?1:0,oy<y0?-1:oy>y1?1:0];state._movementBound[0]=state.overflow[0]?state._movementBound[0]===false?state._movement[0]:state._movementBound[0]:false;state._movementBound[1]=state.overflow[1]?state._movementBound[1]===false?state._movement[1]:state._movementBound[1]:false;const rubberband=state._active?config.rubberband||[0,0]:[0,0];state.offset=computeRubberband(state._bounds,state.offset,rubberband);state.delta=V$2.sub(state.offset,previousOffset);this.computeMovement();if(gestureIsActive&&(!state.last||dt>BEFORE_LAST_KINEMATICS_DELAY)){state.delta=V$2.sub(state.offset,previousOffset);const absoluteDelta=state.delta.map(Math.abs);V$2.addTo(state.distance,absoluteDelta);state.direction=state.delta.map(Math.sign);state._direction=state._delta.map(Math.sign);if(!state.first&&dt>0){state.velocity=[absoluteDelta[0]/dt,absoluteDelta[1]/dt];state.timeDelta=dt;}}}emit(){const state=this.state;const shared=this.shared;const config=this.config;if(!state._active)this.clean();if((state._blocked||!state.intentional)&&!state._force&&!config.triggerAllEvents)return;const memo=this.handler(_objectSpread2(_objectSpread2(_objectSpread2({},shared),state),{},{[this.aliasKey]:state.values}));if(memo!==undefined)state.memo=memo;}clean(){this.eventStore.clean();this.timeoutStore.clean();}}function selectAxis([dx,dy],threshold){const absDx=Math.abs(dx);const absDy=Math.abs(dy);if(absDx>absDy&&absDx>threshold){return 'x';}if(absDy>absDx&&absDy>threshold){return 'y';}return undefined;}class CoordinatesEngine extends Engine{constructor(...args){super(...args);_defineProperty$4(this,"aliasKey",'xy');}reset(){super.reset();this.state.axis=undefined;}init(){this.state.offset=[0,0];this.state.lastOffset=[0,0];}computeOffset(){this.state.offset=V$2.add(this.state.lastOffset,this.state.movement);}computeMovement(){this.state.movement=V$2.sub(this.state.offset,this.state.lastOffset);}axisIntent(event){const state=this.state;const config=this.config;if(!state.axis&&event){const threshold=typeof config.axisThreshold==='object'?config.axisThreshold[getPointerType(event)]:config.axisThreshold;state.axis=selectAxis(state._movement,threshold);}state._blocked=(config.lockDirection||!!config.axis)&&!state.axis||!!config.axis&&config.axis!==state.axis;}restrictToAxis(v){if(this.config.axis||this.config.lockDirection){switch(this.state.axis){case'x':v[1]=0;break;case'y':v[0]=0;break;}}}}const identity=v=>v;const DEFAULT_RUBBERBAND=0.15;const commonConfigResolver={enabled(value=true){return value;},eventOptions(value,_k,config){return _objectSpread2(_objectSpread2({},config.shared.eventOptions),value);},preventDefault(value=false){return value;},triggerAllEvents(value=false){return value;},rubberband(value=0){switch(value){case true:return [DEFAULT_RUBBERBAND,DEFAULT_RUBBERBAND];case false:return [0,0];default:return V$2.toVector(value);}},from(value){if(typeof value==='function')return value;if(value!=null)return V$2.toVector(value);},transform(value,_k,config){const transform=value||config.shared.transform;this.hasCustomTransform=!!transform;if(process.env.NODE_ENV==='development'){const originalTransform=transform||identity;return v=>{const r=originalTransform(v);if(!isFinite(r[0])||!isFinite(r[1])){console.warn(`[@use-gesture]: config.transform() must produce a valid result, but it was: [${r[0]},${[1]}]`);}return r;};}return transform||identity;},threshold(value){return V$2.toVector(value,0);}};if(process.env.NODE_ENV==='development'){Object.assign(commonConfigResolver,{domTarget(value){if(value!==undefined){throw Error(`[@use-gesture]: \`domTarget\` option has been renamed to \`target\`.`);}return NaN;},lockDirection(value){if(value!==undefined){throw Error(`[@use-gesture]: \`lockDirection\` option has been merged with \`axis\`. Use it as in \`{ axis: 'lock' }\``);}return NaN;},initial(value){if(value!==undefined){throw Error(`[@use-gesture]: \`initial\` option has been renamed to \`from\`.`);}return NaN;}});}const DEFAULT_AXIS_THRESHOLD=0;const coordinatesConfigResolver=_objectSpread2(_objectSpread2({},commonConfigResolver),{},{axis(_v,_k,{axis}){this.lockDirection=axis==='lock';if(!this.lockDirection)return axis;},axisThreshold(value=DEFAULT_AXIS_THRESHOLD){return value;},bounds(value={}){if(typeof value==='function'){return state=>coordinatesConfigResolver.bounds(value(state));}if('current'in value){return ()=>value.current;}if(typeof HTMLElement==='function'&&value instanceof HTMLElement){return value;}const{left=-Infinity,right=Infinity,top=-Infinity,bottom=Infinity}=value;return [[left,right],[top,bottom]];}});const KEYS_DELTA_MAP={ArrowRight:(displacement,factor=1)=>[displacement*factor,0],ArrowLeft:(displacement,factor=1)=>[-1*displacement*factor,0],ArrowUp:(displacement,factor=1)=>[0,-1*displacement*factor],ArrowDown:(displacement,factor=1)=>[0,displacement*factor]};class DragEngine extends CoordinatesEngine{constructor(...args){super(...args);_defineProperty$4(this,"ingKey",'dragging');}reset(){super.reset();const state=this.state;state._pointerId=undefined;state._pointerActive=false;state._keyboardActive=false;state._preventScroll=false;state._delayed=false;state.swipe=[0,0];state.tap=false;state.canceled=false;state.cancel=this.cancel.bind(this);}setup(){const state=this.state;if(state._bounds instanceof HTMLElement){const boundRect=state._bounds.getBoundingClientRect();const targetRect=state.currentTarget.getBoundingClientRect();const _bounds={left:boundRect.left-targetRect.left+state.offset[0],right:boundRect.right-targetRect.right+state.offset[0],top:boundRect.top-targetRect.top+state.offset[1],bottom:boundRect.bottom-targetRect.bottom+state.offset[1]};state._bounds=coordinatesConfigResolver.bounds(_bounds);}}cancel(){const state=this.state;if(state.canceled)return;state.canceled=true;state._active=false;setTimeout(()=>{this.compute();this.emit();},0);}setActive(){this.state._active=this.state._pointerActive||this.state._keyboardActive;}clean(){this.pointerClean();this.state._pointerActive=false;this.state._keyboardActive=false;super.clean();}pointerDown(event){const config=this.config;const state=this.state;if(event.buttons!=null&&(Array.isArray(config.pointerButtons)?!config.pointerButtons.includes(event.buttons):config.pointerButtons!==-1&&config.pointerButtons!==event.buttons))return;const ctrlIds=this.ctrl.setEventIds(event);if(config.pointerCapture){event.target.setPointerCapture(event.pointerId);}if(ctrlIds&&ctrlIds.size>1&&state._pointerActive)return;this.start(event);this.setupPointer(event);state._pointerId=pointerId(event);state._pointerActive=true;this.computeValues(pointerValues(event));this.computeInitial();if(config.preventScrollAxis&&getPointerType(event)!=='mouse'){state._active=false;this.setupScrollPrevention(event);}else if(config.delay>0){this.setupDelayTrigger(event);if(config.triggerAllEvents){this.compute(event);this.emit();}}else {this.startPointerDrag(event);}}startPointerDrag(event){const state=this.state;state._active=true;state._preventScroll=true;state._delayed=false;this.compute(event);this.emit();}pointerMove(event){const state=this.state;const config=this.config;if(!state._pointerActive)return;const id=pointerId(event);if(state._pointerId!==undefined&&id!==state._pointerId)return;const _values=pointerValues(event);if(document.pointerLockElement===event.target){state._delta=[event.movementX,event.movementY];}else {state._delta=V$2.sub(_values,state._values);this.computeValues(_values);}V$2.addTo(state._movement,state._delta);this.compute(event);if(state._delayed&&state.intentional){this.timeoutStore.remove('dragDelay');state.active=false;this.startPointerDrag(event);return;}if(config.preventScrollAxis&&!state._preventScroll){if(state.axis){if(state.axis===config.preventScrollAxis||config.preventScrollAxis==='xy'){state._active=false;this.clean();return;}else {this.timeoutStore.remove('startPointerDrag');this.startPointerDrag(event);return;}}else {return;}}this.emit();}pointerUp(event){this.ctrl.setEventIds(event);try{if(this.config.pointerCapture&&event.target.hasPointerCapture(event.pointerId)){;event.target.releasePointerCapture(event.pointerId);}}catch(_unused){if(process.env.NODE_ENV==='development'){console.warn(`[@use-gesture]: If you see this message, it's likely that you're using an outdated version of \`@react-three/fiber\`. \n\nPlease upgrade to the latest version.`);}}const state=this.state;const config=this.config;if(!state._active||!state._pointerActive)return;const id=pointerId(event);if(state._pointerId!==undefined&&id!==state._pointerId)return;this.state._pointerActive=false;this.setActive();this.compute(event);const[dx,dy]=state._distance;state.tap=dx<=config.tapsThreshold&&dy<=config.tapsThreshold;if(state.tap&&config.filterTaps){state._force=true;}else {const[_dx,_dy]=state._delta;const[_mx,_my]=state._movement;const[svx,svy]=config.swipe.velocity;const[sx,sy]=config.swipe.distance;const sdt=config.swipe.duration;if(state.elapsedTime<sdt){const _vx=Math.abs(_dx/state.timeDelta);const _vy=Math.abs(_dy/state.timeDelta);if(_vx>svx&&Math.abs(_mx)>sx)state.swipe[0]=Math.sign(_dx);if(_vy>svy&&Math.abs(_my)>sy)state.swipe[1]=Math.sign(_dy);}}this.emit();}pointerClick(event){if(!this.state.tap&&event.detail>0){event.preventDefault();event.stopPropagation();}}setupPointer(event){const config=this.config;const device=config.device;if(process.env.NODE_ENV==='development'){try{if(device==='pointer'&&config.preventScrollDelay===undefined){const currentTarget='uv'in event?event.sourceEvent.currentTarget:event.currentTarget;const style=window.getComputedStyle(currentTarget);if(style.touchAction==='auto'){console.warn(`[@use-gesture]: The drag target has its \`touch-action\` style property set to \`auto\`. It is recommended to add \`touch-action: 'none'\` so that the drag gesture behaves correctly on touch-enabled devices. For more information read this: https://use-gesture.netlify.app/docs/extras/#touch-action.\n\nThis message will only show in development mode. It won't appear in production. If this is intended, you can ignore it.`,currentTarget);}}}catch(_unused2){}}if(config.pointerLock){event.currentTarget.requestPointerLock();}if(!config.pointerCapture){this.eventStore.add(this.sharedConfig.window,device,'change',this.pointerMove.bind(this));this.eventStore.add(this.sharedConfig.window,device,'end',this.pointerUp.bind(this));this.eventStore.add(this.sharedConfig.window,device,'cancel',this.pointerUp.bind(this));}}pointerClean(){if(this.config.pointerLock&&document.pointerLockElement===this.state.currentTarget){document.exitPointerLock();}}preventScroll(event){if(this.state._preventScroll&&event.cancelable){event.preventDefault();}}setupScrollPrevention(event){this.state._preventScroll=false;persistEvent(event);const remove=this.eventStore.add(this.sharedConfig.window,'touch','change',this.preventScroll.bind(this),{passive:false});this.eventStore.add(this.sharedConfig.window,'touch','end',remove);this.eventStore.add(this.sharedConfig.window,'touch','cancel',remove);this.timeoutStore.add('startPointerDrag',this.startPointerDrag.bind(this),this.config.preventScrollDelay,event);}setupDelayTrigger(event){this.state._delayed=true;this.timeoutStore.add('dragDelay',()=>{this.state._step=[0,0];this.startPointerDrag(event);},this.config.delay);}keyDown(event){const deltaFn=KEYS_DELTA_MAP[event.key];if(deltaFn){const state=this.state;const factor=event.shiftKey?10:event.altKey?0.1:1;this.start(event);state._delta=deltaFn(this.config.keyboardDisplacement,factor);state._keyboardActive=true;V$2.addTo(state._movement,state._delta);this.compute(event);this.emit();}}keyUp(event){if(!(event.key in KEYS_DELTA_MAP))return;this.state._keyboardActive=false;this.setActive();this.compute(event);this.emit();}bind(bindFunction){const device=this.config.device;bindFunction(device,'start',this.pointerDown.bind(this));if(this.config.pointerCapture){bindFunction(device,'change',this.pointerMove.bind(this));bindFunction(device,'end',this.pointerUp.bind(this));bindFunction(device,'cancel',this.pointerUp.bind(this));bindFunction('lostPointerCapture','',this.pointerUp.bind(this));}if(this.config.keys){bindFunction('key','down',this.keyDown.bind(this));bindFunction('key','up',this.keyUp.bind(this));}if(this.config.filterTaps){bindFunction('click','',this.pointerClick.bind(this),{capture:true,passive:false});}}}function persistEvent(event){'persist'in event&&typeof event.persist==='function'&&event.persist();}const isBrowser$8=typeof window!=='undefined'&&window.document&&window.document.createElement;function supportsTouchEvents(){return isBrowser$8&&'ontouchstart'in window;}function isTouchScreen(){return supportsTouchEvents()||isBrowser$8&&window.navigator.maxTouchPoints>1;}function supportsPointerEvents(){return isBrowser$8&&'onpointerdown'in window;}function supportsPointerLock(){return isBrowser$8&&'exitPointerLock'in window.document;}function supportsGestureEvents(){try{return 'constructor'in GestureEvent;}catch(e){return false;}}const SUPPORT={isBrowser: isBrowser$8,gesture:supportsGestureEvents(),touch:supportsTouchEvents(),touchscreen:isTouchScreen(),pointer:supportsPointerEvents(),pointerLock:supportsPointerLock()};const DEFAULT_PREVENT_SCROLL_DELAY=250;const DEFAULT_DRAG_DELAY=180;const DEFAULT_SWIPE_VELOCITY=0.5;const DEFAULT_SWIPE_DISTANCE=50;const DEFAULT_SWIPE_DURATION=250;const DEFAULT_KEYBOARD_DISPLACEMENT=10;const DEFAULT_DRAG_AXIS_THRESHOLD={mouse:0,touch:0,pen:8};const dragConfigResolver=_objectSpread2(_objectSpread2({},coordinatesConfigResolver),{},{device(_v,_k,{pointer:{touch=false,lock=false,mouse=false}={}}){this.pointerLock=lock&&SUPPORT.pointerLock;if(SUPPORT.touch&&touch)return 'touch';if(this.pointerLock)return 'mouse';if(SUPPORT.pointer&&!mouse)return 'pointer';if(SUPPORT.touch)return 'touch';return 'mouse';},preventScrollAxis(value,_k,{preventScroll}){this.preventScrollDelay=typeof preventScroll==='number'?preventScroll:preventScroll||preventScroll===undefined&&value?DEFAULT_PREVENT_SCROLL_DELAY:undefined;if(!SUPPORT.touchscreen||preventScroll===false)return undefined;return value?value:preventScroll!==undefined?'y':undefined;},pointerCapture(_v,_k,{pointer:{capture=true,buttons=1,keys=true}={}}){this.pointerButtons=buttons;this.keys=keys;return !this.pointerLock&&this.device==='pointer'&&capture;},threshold(value,_k,{filterTaps=false,tapsThreshold=3,axis=undefined}){const threshold=V$2.toVector(value,filterTaps?tapsThreshold:axis?1:0);this.filterTaps=filterTaps;this.tapsThreshold=tapsThreshold;return threshold;},swipe({velocity=DEFAULT_SWIPE_VELOCITY,distance=DEFAULT_SWIPE_DISTANCE,duration=DEFAULT_SWIPE_DURATION}={}){return {velocity:this.transform(V$2.toVector(velocity)),distance:this.transform(V$2.toVector(distance)),duration};},delay(value=0){switch(value){case true:return DEFAULT_DRAG_DELAY;case false:return 0;default:return value;}},axisThreshold(value){if(!value)return DEFAULT_DRAG_AXIS_THRESHOLD;return _objectSpread2(_objectSpread2({},DEFAULT_DRAG_AXIS_THRESHOLD),value);},keyboardDisplacement(value=DEFAULT_KEYBOARD_DISPLACEMENT){return value;}});if(process.env.NODE_ENV==='development'){Object.assign(dragConfigResolver,{useTouch(value){if(value!==undefined){throw Error(`[@use-gesture]: \`useTouch\` option has been renamed to \`pointer.touch\`. Use it as in \`{ pointer: { touch: true } }\`.`);}return NaN;},experimental_preventWindowScrollY(value){if(value!==undefined){throw Error(`[@use-gesture]: \`experimental_preventWindowScrollY\` option has been renamed to \`preventScroll\`.`);}return NaN;},swipeVelocity(value){if(value!==undefined){throw Error(`[@use-gesture]: \`swipeVelocity\` option has been renamed to \`swipe.velocity\`. Use it as in \`{ swipe: { velocity: 0.5 } }\`.`);}return NaN;},swipeDistance(value){if(value!==undefined){throw Error(`[@use-gesture]: \`swipeDistance\` option has been renamed to \`swipe.distance\`. Use it as in \`{ swipe: { distance: 50 } }\`.`);}return NaN;},swipeDuration(value){if(value!==undefined){throw Error(`[@use-gesture]: \`swipeDuration\` option has been renamed to \`swipe.duration\`. Use it as in \`{ swipe: { duration: 250 } }\`.`);}return NaN;}});}_objectSpread2(_objectSpread2({},commonConfigResolver),{},{device(_v,_k,{shared,pointer:{touch=false}={}}){const sharedConfig=shared;if(sharedConfig.target&&!SUPPORT.touch&&SUPPORT.gesture)return 'gesture';if(SUPPORT.touch&&touch)return 'touch';if(SUPPORT.touchscreen){if(SUPPORT.pointer)return 'pointer';if(SUPPORT.touch)return 'touch';}},bounds(_v,_k,{scaleBounds={},angleBounds={}}){const _scaleBounds=state=>{const D=assignDefault(call(scaleBounds,state),{min:-Infinity,max:Infinity});return [D.min,D.max];};const _angleBounds=state=>{const A=assignDefault(call(angleBounds,state),{min:-Infinity,max:Infinity});return [A.min,A.max];};if(typeof scaleBounds!=='function'&&typeof angleBounds!=='function')return [_scaleBounds(),_angleBounds()];return state=>[_scaleBounds(state),_angleBounds(state)];},threshold(value,_k,config){this.lockDirection=config.axis==='lock';const threshold=V$2.toVector(value,this.lockDirection?[0.1,3]:0);return threshold;},modifierKey(value){if(value===undefined)return 'ctrlKey';return value;},pinchOnWheel(value=true){return value;}});_objectSpread2(_objectSpread2({},coordinatesConfigResolver),{},{mouseOnly:(value=true)=>value});_objectSpread2(_objectSpread2({},coordinatesConfigResolver),{},{mouseOnly:(value=true)=>value});const EngineMap=new Map();const ConfigResolverMap=new Map();function registerAction(action){EngineMap.set(action.key,action.engine);ConfigResolverMap.set(action.key,action.resolver);}const dragAction={key:'drag',engine:DragEngine,resolver:dragConfigResolver};function _objectWithoutPropertiesLoose$2(source,excluded){if(source==null)return {};var target={};var sourceKeys=Object.keys(source);var key,i;for(i=0;i<sourceKeys.length;i++){key=sourceKeys[i];if(excluded.indexOf(key)>=0)continue;target[key]=source[key];}return target;}function _objectWithoutProperties$2(source,excluded){if(source==null)return {};var target=_objectWithoutPropertiesLoose$2(source,excluded);var key,i;if(Object.getOwnPropertySymbols){var sourceSymbolKeys=Object.getOwnPropertySymbols(source);for(i=0;i<sourceSymbolKeys.length;i++){key=sourceSymbolKeys[i];if(excluded.indexOf(key)>=0)continue;if(!Object.prototype.propertyIsEnumerable.call(source,key))continue;target[key]=source[key];}}return target;}const sharedConfigResolver={target(value){if(value){return ()=>'current'in value?value.current:value;}return undefined;},enabled(value=true){return value;},window(value=SUPPORT.isBrowser?window:undefined){return value;},eventOptions({passive=true,capture=false}={}){return {passive,capture};},transform(value){return value;}};const _excluded=["target","eventOptions","window","enabled","transform"];function resolveWith(config={},resolvers){const result={};for(const[key,resolver]of Object.entries(resolvers)){switch(typeof resolver){case'function':if(process.env.NODE_ENV==='development'){const r=resolver.call(result,config[key],key,config);if(!Number.isNaN(r))result[key]=r;}else {result[key]=resolver.call(result,config[key],key,config);}break;case'object':result[key]=resolveWith(config[key],resolver);break;case'boolean':if(resolver)result[key]=config[key];break;}}return result;}function parse$1(newConfig,gestureKey,_config={}){const _ref=newConfig,{target,eventOptions,window,enabled,transform}=_ref,rest=_objectWithoutProperties$2(_ref,_excluded);_config.shared=resolveWith({target,eventOptions,window,enabled,transform},sharedConfigResolver);if(gestureKey){const resolver=ConfigResolverMap.get(gestureKey);_config[gestureKey]=resolveWith(_objectSpread2({shared:_config.shared},rest),resolver);}else {for(const key in rest){const resolver=ConfigResolverMap.get(key);if(resolver){_config[key]=resolveWith(_objectSpread2({shared:_config.shared},rest[key]),resolver);}else if(process.env.NODE_ENV==='development'){if(!['drag','pinch','scroll','wheel','move','hover'].includes(key)){if(key==='domTarget'){throw Error(`[@use-gesture]: \`domTarget\` option has been renamed to \`target\`.`);}console.warn(`[@use-gesture]: Unknown config key \`${key}\` was used. Please read the documentation for further information.`);}}}}return _config;}class EventStore{constructor(ctrl,gestureKey){_defineProperty$4(this,"_listeners",new Set());this._ctrl=ctrl;this._gestureKey=gestureKey;}add(element,device,action,handler,options){const listeners=this._listeners;const type=toDomEventType(device,action);const _options=this._gestureKey?this._ctrl.config[this._gestureKey].eventOptions:{};const eventOptions=_objectSpread2(_objectSpread2({},_options),options);element.addEventListener(type,handler,eventOptions);const remove=()=>{element.removeEventListener(type,handler,eventOptions);listeners.delete(remove);};listeners.add(remove);return remove;}clean(){this._listeners.forEach(remove=>remove());this._listeners.clear();}}class TimeoutStore{constructor(){_defineProperty$4(this,"_timeouts",new Map());}add(key,callback,ms=140,...args){this.remove(key);this._timeouts.set(key,window.setTimeout(callback,ms,...args));}remove(key){const timeout=this._timeouts.get(key);if(timeout)window.clearTimeout(timeout);}clean(){this._timeouts.forEach(timeout=>void window.clearTimeout(timeout));this._timeouts.clear();}}class Controller{constructor(handlers){_defineProperty$4(this,"gestures",new Set());_defineProperty$4(this,"_targetEventStore",new EventStore(this));_defineProperty$4(this,"gestureEventStores",{});_defineProperty$4(this,"gestureTimeoutStores",{});_defineProperty$4(this,"handlers",{});_defineProperty$4(this,"config",{});_defineProperty$4(this,"pointerIds",new Set());_defineProperty$4(this,"touchIds",new Set());_defineProperty$4(this,"state",{shared:{shiftKey:false,metaKey:false,ctrlKey:false,altKey:false}});resolveGestures(this,handlers);}setEventIds(event){if(isTouch(event)){this.touchIds=new Set(touchIds(event));return this.touchIds;}else if('pointerId'in event){if(event.type==='pointerup'||event.type==='pointercancel')this.pointerIds.delete(event.pointerId);else if(event.type==='pointerdown')this.pointerIds.add(event.pointerId);return this.pointerIds;}}applyHandlers(handlers,nativeHandlers){this.handlers=handlers;this.nativeHandlers=nativeHandlers;}applyConfig(config,gestureKey){this.config=parse$1(config,gestureKey,this.config);}clean(){this._targetEventStore.clean();for(const key of this.gestures){this.gestureEventStores[key].clean();this.gestureTimeoutStores[key].clean();}}effect(){if(this.config.shared.target)this.bind();return ()=>this._targetEventStore.clean();}bind(...args){const sharedConfig=this.config.shared;const props={};let target;if(sharedConfig.target){target=sharedConfig.target();if(!target)return;}if(sharedConfig.enabled){for(const gestureKey of this.gestures){const gestureConfig=this.config[gestureKey];const bindFunction=bindToProps(props,gestureConfig.eventOptions,!!target);if(gestureConfig.enabled){const Engine=EngineMap.get(gestureKey);new Engine(this,args,gestureKey).bind(bindFunction);}}const nativeBindFunction=bindToProps(props,sharedConfig.eventOptions,!!target);for(const eventKey in this.nativeHandlers){nativeBindFunction(eventKey,'',event=>this.nativeHandlers[eventKey](_objectSpread2(_objectSpread2({},this.state.shared),{},{event,args})),undefined,true);}}for(const handlerProp in props){props[handlerProp]=chain(...props[handlerProp]);}if(!target)return props;for(const handlerProp in props){const{device,capture,passive}=parseProp(handlerProp);this._targetEventStore.add(target,device,'',props[handlerProp],{capture,passive});}}}function setupGesture(ctrl,gestureKey){ctrl.gestures.add(gestureKey);ctrl.gestureEventStores[gestureKey]=new EventStore(ctrl,gestureKey);ctrl.gestureTimeoutStores[gestureKey]=new TimeoutStore();}function resolveGestures(ctrl,internalHandlers){if(internalHandlers.drag)setupGesture(ctrl,'drag');if(internalHandlers.wheel)setupGesture(ctrl,'wheel');if(internalHandlers.scroll)setupGesture(ctrl,'scroll');if(internalHandlers.move)setupGesture(ctrl,'move');if(internalHandlers.pinch)setupGesture(ctrl,'pinch');if(internalHandlers.hover)setupGesture(ctrl,'hover');}const bindToProps=(props,eventOptions,withPassiveOption)=>(device,action,handler,options={},isNative=false)=>{var _options$capture,_options$passive;const capture=(_options$capture=options.capture)!==null&&_options$capture!==void 0?_options$capture:eventOptions.capture;const passive=(_options$passive=options.passive)!==null&&_options$passive!==void 0?_options$passive:eventOptions.passive;let handlerProp=isNative?device:toHandlerProp(device,action,capture);if(withPassiveOption&&passive)handlerProp+='Passive';props[handlerProp]=props[handlerProp]||[];props[handlerProp].push(handler);};function useRecognizers(handlers,config={},gestureKey,nativeHandlers){const ctrl=React__default.useMemo(()=>new Controller(handlers),[]);ctrl.applyHandlers(handlers,nativeHandlers);ctrl.applyConfig(config,gestureKey);React__default.useEffect(ctrl.effect.bind(ctrl));React__default.useEffect(()=>{return ctrl.clean.bind(ctrl);},[]);if(config.target===undefined){return ctrl.bind.bind(ctrl);}return undefined;}function useDrag(handler,config){registerAction(dragAction);return useRecognizers({drag:handler},config||{},'drag');}var css_248z$4$1=".volContainer{border:1px solid #000;border-radius:8px;margin:0 0 4px}.volValue{border-radius:8px;height:10px}";styleInject$1(css_248z$4$1,{"insertAt":"top"});function VolumeBar({width,percentage,colour}){return/*#__PURE__*/React__default.createElement("div",{className:`volContainer m-2 text-xs mb-1`,style:{borderColor:colour,width:50}},/*#__PURE__*/React__default.createElement("div",{className:"volValue",style:{width:`${percentage}%`,backgroundColor:colour}}));}VolumeBar.propTypes={width:PropTypes.number,percentage:PropTypes.number,colour:PropTypes.string};VolumeBar.defaultProps={width:100,percentage:30,colour:'#00ff00'};var ChoirBass='data:image/svg+xml;base64,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';var ChoirTenor='data:image/svg+xml;base64,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';var ChoirAlto='data:image/svg+xml;base64,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';var ChoirSoprano='data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCAzMjggNjcxLjUzIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJnIj4KPHBhdGggZD0ibTAgMGgyNDZ2NTAzLjY1aC0yNDZ6Ii8+CjwvY2xpcFBhdGg+CjxjbGlwUGF0aCBpZD0iYiI+CjxwYXRoIGQ9Im0tMC4wMDExMTM5IDUwMy42NWgyNDZ2LTE3MC4zMWgtMjQ2eiIvPgo8L2NsaXBQYXRoPgo8Y2xpcFBhdGggaWQ9ImEiPgo8cGF0aCBkPSJtMCAzMzMuMzRoMjQ2djE3MC4zMWgtMjQ2eiIvPgo8L2NsaXBQYXRoPgo8Y2xpcFBhdGggaWQ9ImYiPgo8cGF0aCBkPSJtMC43NDU1NiA0NDUuNDZoMjM4LjYxdi0xOTcuNDJoLTIzOC42MXoiLz4KPC9jbGlwUGF0aD4KPGNsaXBQYXRoIGlkPSJlIj4KPHBhdGggZD0ibTAuNzQ2IDI0OC4wNGgyMzguNjF2MTk3LjQyaC0yMzguNjF6Ii8+CjwvY2xpcFBhdGg+CjxjbGlwUGF0aCBpZD0iZCI+CjxwYXRoIGQ9Im0xLjMxMiAzODEuNTRoMjI2LjUydi0yNTkuNzZoLTIyNi41MnoiLz4KPC9jbGlwUGF0aD4KPGNsaXBQYXRoIGlkPSJjIj4KPHBhdGggZD0ibTEuMzEzIDEyMS43OWgyMjYuNTJ2MjU5Ljc1aC0yMjYuNTJ6Ii8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPGcgdHJhbnNmb3JtPSJtYXRyaXgoMS4zMzMzIDAgMCAtMS4zMzMzIDAgNjcxLjUzKSI+CjxnIGNsaXAtcGF0aD0idXJsKCNnKSI+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIzMi4xMiAzNDMuNDcpIj4KPHBhdGggZD0ibTAgMGMyLjEwMy0zLjA0MiA0Ljg1MS00LjUyMSA1LjI2Mi03LjEzNyAwLjIwNC0xLjI4NyAwLjA2Ni0yLjMxLTEuMTk0LTIuNDY2LTUuNDI3LTAuNjcyLTYuMDMgMS41MjQtNy45NjIgMi4wNjQtMy4zNDIgMC45MzktNC4wMjMgMi45NzYtMi42NzMgNy41MzkgMS4zNTMgNC41NjMgNC44NzggMi44NDQgNi41NjcgMCIgZmlsbD0iI2ZiZDliZCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjM1LjI5IDQwMS4yOSkiPgo8cGF0aCBkPSJtMCAwaC0yNC44MjVsMy4xNjUtNTcuODIyaDYuNTdsMS4zMzUgNDMuOThjMC4xMDUgMy40ODYgMi41NzQgMy41MDcgMi42ODIgMGwxLjMzOC00My45OGg2LjU2NHoiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIzMy40NSA0MzguNzcpIj4KPHBhdGggZD0ibTAgMCA0LjQwMS0yNC40NTZjMC41MzQtMi45NjQgNi40MDItMC4xMTEgNi4zMjEgMS40MDdsLTEuMjgxIDIyLjMxNGMtMC40MDggNy4xNjQtMTAuNjQ3IDcuNDM3LTkuNDQxIDAuNzM1IiBmaWxsPSIjZGQyNDg5IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMDUuOTkgNDY3LjM4KSI+CjxwYXRoIGQ9Im0wIDBjNS4xMzMgMS4yMzktMy41NDktNS45MzQgMy4zODQtMTMuNjE0IDYuOTM5LTcuNjg2IDIuMjk1LTE3LjU4My00LjQ3LTE4Ljk3Mi0yLjg0Ny0wLjU4OCA2LjMyNyA1LjctMS44NzggMTIuOTQyLTUuMjM4IDQuNjIzLTUuOTcgMTcuNDc1IDIuOTY0IDE5LjY0NCIgZmlsbD0iI2NiN2M1NCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjA4LjEgNDQzLjYyKSI+CjxwYXRoIGQ9Im0wIDAgMi4zNjQtNDIuMzMzaDI0LjgyOGwyLjM2NCA0Mi4zMzN6IiBmaWxsPSIjZGQyNDg5IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMzYuODMgMzk3Ljg4KSI+CjxwYXRoIGQ9Im0wIDBjLTAuMjQgMC4xNjItMC41NC0wLjE2Mi0wLjU2MS0wLjQ0NGwtMC4zMTUtNC4xOTFjLTAuMDIxLTAuMjg1IDAuMjUyLTAuNDI2IDAuNDkyLTAuNTg1IDAuMjQtMC4xNjIgMC41MzcgMC4xNTkgMC41NjEgMC40NDRsMC4zMTUgNC4xOTFjMC4wMjEgMC4yODUtMC4yMDQgMC41NDYtMC40OTIgMC41ODUiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIzNi4yNSAzOTYuMDkpIj4KPHBhdGggZD0ibTAgMCAwLjEzNSAxLjggNS45NTgtMC44NTUtMC4xMzgtMS44Yy0wLjU3Ni01LjQyNy02LjYzLTUuNzMzLTUuOTU1IDAuODU1IiBmaWxsPSIjZmJkOWJkIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMzYuMzMgMzk3LjM2KSI+CjxwYXRoIGQ9Im0wIDAgMS4yODQgMTcuMzA3YzEuMTEzIDQuNTg3IDYuMzE4IDUuMTM2IDYuNTYxIDEuMDU5bC0xLjk0NC0xOS4xOTd6IiBmaWxsPSIjZmJkOWJkIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMzUuMjkgNDAxLjI5KSI+CjxwYXRoIGQ9Im0wIDAtMC45MjEtMTYuNzc2aC0yMi45MmwtMC45ODQgMTYuNzc2IDExLjU1MyAzNS41MzhjMC41MjgtMC4wNTEgMS4wNjItMC4wNjMgMS41OTYtMC4wMTV6IiBmaWxsPSIjY2MxYjc0IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMTMuNjIgMzQzLjQ3KSI+CjxwYXRoIGQ9Im0wIDBjLTIuMTAzLTMuMDQyLTUuMDQ5LTQuODIxLTUuNDIxLTcuMjEyLTAuMjAxLTEuMjg3IDAuMzI0LTIuMzYxIDEuNTgxLTIuNTE3IDUuNDI3LTAuNjY5IDUuODY4IDEuOTc3IDcuNzk3IDIuNTE3IDMuMzQ1IDAuOTM5IDMuOTYgMi42NDkgMi42MTMgNy4yMTItMS4zNTMgNC41NjMtNC44ODEgMi44NDQtNi41NyAwIiBmaWxsPSIjZmJkOWJkIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMzUuOTYgMzM5LjExKSI+CjxwYXRoIGQ9Im0wIDBjMC44MTYtMC44ODIgMS40NzMtMS43MTYgMS43NjQtMi42MzEgMS4wMjMtMy4yMS0xLjgzOS0zLjI5NC00LjE3LTIuOTkxLTMuMTExIDAuNDAyLTQuNDA3IDIuMTM2LTUuOTI1IDIuNTU5LTMgMC44NDMtMy4zNzUgMi40NzgtMi40MzkgNi4xMDggMC4xMjYtMy4xNjggMy4wOS00LjAyOSA2LjM4MS01LjU4OSAzLjI4NS0xLjU2IDUuOTM3LTAuMDEyIDQuMzg5IDIuNTQ0IiBmaWxsPSIjY2MxYjc0IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMDkuNzggMzM5LjExKSI+CjxwYXRoIGQ9Im0wIDBjLTAuODE2LTAuODgyLTEuNDczLTEuNzE2LTEuNzYxLTIuNjMxLTEuMTczLTMuNjcyIDIuOTk3LTMuMzk2IDUuMzU1LTIuNzU3IDIuMjg2IDAuNjIxIDMuNDMyIDEuOTU5IDQuNzM3IDIuMzI1IDMgMC44NDMgMy4zNzUgMi40NzggMi40MzkgNi4xMDgtMC4xMjYtMy4xNjgtMy4wOS00LjAyOS02LjM3OC01LjU4OXMtNS45NC0wLjAxMi00LjM5MiAyLjU0NCIgZmlsbD0iI2NjMWI3NCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjQ0LjE3IDQxNS43MikiPgo8cGF0aCBkPSJtMCAwLTYuNTU4LTEuMDU2LTAuNTMxIDQuODYzIDYuNzM4IDEuMTkxeiIgZmlsbD0iI2JjMWI3MyIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjEyLjExIDQzOC43NykiPgo8cGF0aCBkPSJtMCAwLTQuNDAxLTI0LjQ1NmMtMC41MzctMi45NjQtNi40MDgtMC4xMTEtNi4zMjEgMS40MDdsMS4yNzUgMjIuMzE0YzAuNDE0IDcuMTY0IDEwLjY1MyA3LjQzNyA5LjQ0NyAwLjczNSIgZmlsbD0iI2RkMjQ4OSIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjA4LjczIDM5Ny44OCkiPgo8cGF0aCBkPSJtMCAwYzAuMjQgMC4xNjIgMC41NC0wLjE2MiAwLjU2MS0wLjQ0NGwwLjMxMi00LjE5MWMwLjAyNC0wLjI4NS0wLjI0OS0wLjQyNi0wLjQ5Mi0wLjU4NS0wLjIzNy0wLjE2Mi0wLjU0IDAuMTU5LTAuNTU4IDAuNDQ0bC0wLjMxNSA0LjE5MWMtMC4wMTggMC4yODUgMC4yMDQgMC41NDYgMC40OTIgMC41ODUiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIwOS4zMSAzOTYuMDkpIj4KPHBhdGggZD0ibTAgMC0wLjEzOCAxLjgtNS45NTItMC44NTUgMC4xMzgtMS44YzAuNTc2LTUuNDI3IDYuNjI3LTUuNzMzIDUuOTUyIDAuODU1IiBmaWxsPSIjZmJkOWJkIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMDkuMjMgMzk3LjM2KSI+CjxwYXRoIGQ9Im0wIDAtMS4yODQgMTcuMzA3Yy0xLjExMyA0LjU4Ny02LjMyMSA1LjEzNi02LjU2NCAxLjA1OWwxLjk0Ny0xOS4xOTd6IiBmaWxsPSIjZmJkOWJkIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMDEuMzkgNDE1LjcyKSI+CjxwYXRoIGQ9Im0wIDAgNi41NTgtMS4wNTYgMC41MjggNC44NjMtNi43MzUgMS4xOTF6IiBmaWxsPSIjYmMxYjczIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMDcuMTggNDgwLjgxKSI+CjxwYXRoIGQ9Im0wIDBjMi4wMzEgNC4zMTEgNi4wMDYgNy4wMTEgMTEuNTQ3IDUuOTkxIDQuNDM0IDUuNDI0IDE2LjE5NCAwLjUxOSAxOC41OTctNC4yMzkgOS4yNzMtMTguMzY2LTcuMTA0LTI4LjY3NC0xNC44NDQtMjguNjc0LTYuOTQ4LTNlLTMgLTIyLjQxOSAxMS44MzUtMTUuMyAyNi45MjIiIGZpbGw9IiNjYjdjNTQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIyOC42MSA0NjAuOTgpIj4KPHBhdGggZD0ibTAgMHYtMjEuMjdjLTMuMTUzLTQuMTQzLTguMzEtNC4wMDItMTEuNDYzIDB2MjEuMjdjMCA3LjU4MSAxMS40NjMgNy41ODEgMTEuNDYzIDAiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIyOC42MSA0NTguMDkpIj4KPHBhdGggZD0ibTAgMHYtOS40MDJjLTIuMTY5LTEuNjk4LTQuMjYtMi42NDYtNS43MzMtMi42NDYtMS40NyAwLTMuNTYxIDAuOTQ4LTUuNzMgMi42NDZ2OS40MDJjMCA3LjU4NCAxMS40NjMgNy41ODQgMTEuNDYzIDAiIGZpbGw9IiNlY2MyYTAiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIzOS4xNyA0NjcuMzgpIj4KPHBhdGggZD0ibTAgMGM4LjkzNC0yLjE2OSA4LjIwMi0xNS4wMjEgMi45NjQtMTkuNjQ0LTguMjA1LTcuMjQyIDAuOTY5LTEzLjUzLTEuODc4LTEyLjk0Mi02Ljc2NSAxLjM4OS0xMS40MDkgMTEuMjg2LTQuNDcgMTguOTcyIDYuOTMzIDcuNjgtMS43NDkgMTQuODUzIDMuMzg0IDEzLjYxNCIgZmlsbD0iI2NiN2M1NCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjM3Ljg2IDQ2OC4wNykiPgo8cGF0aCBkPSJtMCAwYzEuODMgMS4yNzggMy43MiAxLjcyOCA0LjIyNCAxLjAwMiAwLjUwNy0wLjcyMy0wLjU3LTIuMzQtMi40LTMuNjE1LTEuODI0LTEuMjc1LTMuNzE3LTEuNzI4LTQuMjIxLTEuMDAyLTAuNTA0IDAuNzIgMC41NyAyLjM0IDIuMzk3IDMuNjE1IiBmaWxsPSIjMjgyODI4IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMDguMTIgNDY4LjA3KSI+CjxwYXRoIGQ9Im0wIDBjMS44My0xLjI3NSAyLjkwNC0yLjg5OCAyLjQtMy42MTgtMC41MDQtMC43MjMtMi4zOTctMC4yNzMtNC4yMjQgMS4wMDItMS44MyAxLjI3NS0yLjkwMSAyLjg5OC0yLjM5NyAzLjYxOCAwLjUwNCAwLjcyMyAyLjM5MSAwLjI3MyA0LjIyMS0xLjAwMiIgZmlsbD0iIzI4MjgyOCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjIyLjg4IDQ0OC4zNykiPgo8cGF0aCBkPSJNIDAsMCBDIC0zLjczMiwwIC0xMS42MTksNS44NjggLTE0LjA1MiwxNC4yNzQgLTE2LjUxNSwyMi43NjEgLTExLjg4LDM0LjkzMiAwLDM0LjkzMiAxMS44ODMsMzQuOTMyIDE2LjUxOCwyMi43NjEgMTQuMDUyLDE0LjI3NCAxMS42MTYsNS44NjggMy43MzIsMCAwLDAiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIxNi45MyA0NTguMzkpIj4KPHBhdGggZD0ibTAgMGMyLjUxNCAxLjgzOSA1LjE0MiAwLjc1IDYuMDE4IDAuNzUgMC44NzkgMCAzLjM2IDEuMDkyIDUuODgtMC43NS0xLjI1NC01LjA2NC0xMC4wMDItNS4xOTMtMTEuODk4IDAiIGZpbGw9IiNmZjM4NmEiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIxNyA0NTguNDIpIj4KPHBhdGggZD0ibTAgMGMyLjMzNyAwLjgyMiA0LjQwNC0wLjc4OSA1Ljg3MS0wLjc4OSAxLjQ3MyAwIDMuNTQzIDIuMTY2IDUuODggMC43MDgtMi43MzktMi43OTMtOC45OTQtMi42MzctMTEuNzUxIDAuMDgxIiBmaWxsPSIjYTIxZjQwIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMTYuOTMgNDU4LjQyKSI+CjxwYXRoIGQ9Im0wIDBjMi41MTQgMS4wMzggNC4zNjggMC4yODIgNS44MzUgMC4yODIgMS40NzMgMCAzLjU0OSAwLjc1NiA2LjA2My0wLjI4Mi0yLjczNi0xLjU2Ni05LjE0NC0xLjUxNS0xMS44OTggMCIgZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjE2Ljk0IDQ1OC40MSkiPgo8cGF0aCBkPSJtMCAwYzIuNTA1IDEuODE4IDQuNjU2IDAuNTU4IDYuMTIzIDAuNTU4IDEuNDcgMCAzLjIzNyAxLjI2NiA1Ljc1NC0wLjU3LTllLTMgLTAuMDMtMC4wMjEtMC4wNTQtMC4wMy0wLjA3OC0zLjIxIDAuMDU0LTguNDU3IDAuMDktMTEuODQ3IDAuMDkiIGZpbGw9IiNmZjM4NmEiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIzOC44OSA0NjcuNzcpIj4KPHBhdGggZD0ibTAgMGMxLjE5Ny0wLjUxNiAxLjQ0OS0yLjYxNiAwLjU1OC00LjY5Mi0wLjg5MS0yLjA3My0yLjU4Ni0zLjMzOS0zLjc4OS0yLjgyMy0xLjIgMC41MTMtMS40NDkgMi42MTMtMC41NjEgNC42OTIgMC44OTQgMi4wNzYgMi41ODkgMy4zNDIgMy43OTIgMi44MjMiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIwNi4yOCA0NjcuNzcpIj4KPHBhdGggZD0ibTAgMGMxLjIwMyAwLjUxOSAyLjg5OC0wLjc0NyAzLjc5Mi0yLjgyMyAwLjg4OC0yLjA3OSAwLjYzOS00LjE3OS0wLjU2MS00LjY5Mi0xLjIwMy0wLjUxNi0yLjg5OCAwLjc1LTMuNzg5IDIuODIzLTAuODkxIDIuMDc2LTAuNjM5IDQuMTc2IDAuNTU4IDQuNjkyIiBmaWxsPSIjZmJkOWJkIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMzYuNzIgNDY0Ljk2KSI+CjxwYXRoIGQ9Im0wIDBjNy4wMDIgMTkuNzE5LTYuNTEgMjAuOTczLTE0LjQ1NyAyMC45NzMtOC45NDYgMC0xOS4zOTItNC41NjMtMTMuNjE0LTIxLjIwMSA4LjUzMiAwLjQyIDE2LjAyNiA1LjE3NSAyMy41NjIgMTUuMTY1IDEuMjg0LTUuMDc5IDIuMTUxLTExLjY3MyA0LjUwOS0xNC45MzciIGZpbGw9IiNjYjdjNTQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE1Ny4wOCA0NDIuNzYpIj4KPHBhdGggZD0ibTAgMGMtNS4wMzEgMjEuMTIzLTcuNzA0IDUyLjUyMSAxNC4wNTUgNTIuNTIxIDIxLjc1NiAwIDIwLjU5OC0zMS4wODMgMTUuMzY2LTUzLjE4Ny0xMC4xODItNS45NjctMjAuNjM0LTQuMzItMjkuNDIxIDAuNjY2IiBmaWxsPSIjZDU2YzJiIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNTguMDIgNDA0LjMzKSI+CjxwYXRoIGQ9Im0wIDAtMS41NDIgMTguMjdjLTEuMTI1IDQuNjQ0LTYuOSAzLjM0Mi02LjAyMS0yLjQxNWwxLjU5LTE2LjY5NXoiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE4NS4xMyA0MDQuMzMpIj4KPHBhdGggZD0ibTAgMCAxLjU1NyAxOS40NzNjMS4xMjUgNC42NDEgNi45NTEgMi41ODkgNi4wNjktMy4xNjhsLTEuNjUzLTE3LjE0NXoiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE4My4wNCA0NDYuMjQpIj4KPHBhdGggZD0ibTAgMCAzLjYzOS0yNC43NDFjMC40NDQtMy4wMTUgNi4yMjUtMi4zMzQgNi4xNjUgMC40NTZsLTAuMjQ2IDIzLjUzOGMtMC4xNTMgNy4yNjYtMTAuNTYgNy41NjYtOS41NTggMC43NDciIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE4Ni41OSA0NTEuMTcpIj4KPHBhdGggZD0ibTAgMC01LjczMy00Mi44NjFoLTE5LjIwOWwtNC45OCA0Mi44NjF6IiBmaWxsPSIjZmJkOWJkIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNjIuMjcgMzQ5Ljc3KSI+CjxwYXRoIGQ9Im0wIDBjLTIuMTI3LTMuMDc4LTQuNzkxLTQuNDA3LTUuNDcyLTcuMzE3LTAuMy0xLjI4MSAwLjA0OC0xLjg4MSAxLjMyMy0yLjA0MyA1LjQ5Ni0wLjY3NSA2LjI5NCAxLjQ2MSA4LjI0NyAyLjAwNyAzLjM4MSAwLjk1MSAzLjkxOCAyLjczNiAyLjU1IDcuMzUzLTEuMzcxIDQuNjE3LTQuOTM4IDIuODgzLTYuNjQ4IDAiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE1OS4wNiA0MDguMzEpIj4KPHBhdGggZD0ibTAgMGgyNS4xMzRsLTMuMjA3LTU4LjUzNmgtNi42NDhsLTEuMzUzIDQ0LjUyM2MtMC4xMDggMy41MjgtMi42MDcgMy41NDktMi43MTUgMGwtMS4zNTMtNDQuNTIzaC02LjY0OHoiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE4NS42NCA0MDQuODYpIj4KPHBhdGggZD0ibTAgMGMtMC4yNDMgMC4xNjUtMC41NDYtMC4xNjItMC41NjctMC40NWwtMC4zMTgtNC4yNDJjLTAuMDE4LTAuMjg4IDAuMjU1LTAuNDI5IDAuNDk4LTAuNTk0IDAuMjQzLTAuMTYyIDAuNTQ2IDAuMTY1IDAuNTY3IDAuNDVsMC4zMTggNC4yNDJjMC4wMjEgMC4yODgtMC4yMDcgMC41NTgtMC40OTggMC41OTQiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE4NS4wNiA0MDMuMDQpIj4KPHBhdGggZD0iTSAwLDAgMC4xMzgsMS44MjcgNi4xNjUsMC45NTcgNi4wMjcsLTAuODY0IEMgNS40NDUsLTYuMzYgLTAuNjg0LC02LjY2OSAwLDAiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE1Ny41MSA0MDQuODYpIj4KPHBhdGggZD0ibTAgMGMwLjI0MyAwLjE2NSAwLjU0Ni0wLjE2MiAwLjU2Ny0wLjQ1bDAuMzE4LTQuMjQyYzAuMDI0LTAuMjg4LTAuMjU1LTAuNDI5LTAuNDk1LTAuNTk0LTAuMjQ2LTAuMTYyLTAuNTQ2IDAuMTY1LTAuNTY3IDAuNDVsLTAuMzIxIDQuMjQyYy0wLjAyMSAwLjI4OCAwLjIwNyAwLjU1OCAwLjQ5OCAwLjU5NCIgZmlsbD0iI2ZiZDliZCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTU4LjA5IDQwMy4wNCkiPgo8cGF0aCBkPSJtMCAwLTAuMTM1IDEuODI3LTYuMDMtMC44NyAwLjEzOC0xLjgyMWMwLjU4NS01LjQ5NiA2LjcxNC01LjgwNSA2LjAyNyAwLjg2NCIgZmlsbD0iI2ZiZDliZCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTgxIDM0OS43NykiPgo8cGF0aCBkPSJtMCAwYzIuMTI3LTMuMDc4IDUuMDc5LTQuNzQzIDUuNTM1LTcuNDY3IDAuMjE2LTEuMjk5LTAuMjAxLTIuMTQ4LTEuNDc2LTIuMzA3LTUuNDk2LTAuNjc4LTYuMjU1IDEuOTUtOC4yMTEgMi40OTYtMy4zODQgMC45NTEtMy44NjQgMi42NjEtMi40OTkgNy4yNzggMS4zNzEgNC42MTcgNC45MzggMi44ODMgNi42NTEgMCIgZmlsbD0iI2ZiZDliZCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTU4LjM4IDM0NS4zNykiPgo8cGF0aCBkPSJtMCAwYy0wLjgyNS0wLjg5Ny0xLjQ4OC0xLjc0My0xLjc4Mi0yLjY2Ny0xLjAzOC0zLjI0NiAxLjg1Ny0zLjMzMyA0LjIxOC0zLjAyNyAzLjE1IDAuNDA1IDQuNDY0IDIuMTYgNiAyLjU4OSAzLjAzNiAwLjg1MiAzLjQxNCAyLjUwOCAyLjQ2OSA2LjE4My0wLjEyOS0zLjIwMS0zLjEyOS00LjA3NC02LjQ1OS01LjY1Mi0zLjMyNy0xLjU4NC02LjAxMi0wLjAxOC00LjQ0NiAyLjU3NCIgZmlsbD0iI2NjMWI3NCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTg0Ljg5IDM0NS4zNykiPgo8cGF0aCBkPSJtMCAwYzAuODI1LTAuODk3IDEuNDg4LTEuNzQzIDEuNzg1LTIuNjY3IDEuMTgyLTMuNzE3LTMuMDM2LTMuNDM4LTUuNDI0LTIuNzktMi4zMTMgMC42MjctMy40NzQgMS45ODYtNC43OTcgMi4zNTItMy4wMzkgMC44NTItMy40MTQgMi41MDgtMi40NjkgNi4xODMgMC4xMjktMy4yMDEgMy4xMjktNC4wNzQgNi40NTYtNS42NTIgMy4zMy0xLjU4NCA2LjAxNS0wLjAxOCA0LjQ0OSAyLjU3NCIgZmlsbD0iI2NjMWI3NCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTYwLjExIDQ0Ni4yNCkiPgo8cGF0aCBkPSJtMCAwLTMuNjM2LTI0Ljc0MWMtMC40NDctMy4wMTUtNi40NTYtMS4zNjUtNi4zOTkgMS40MjVsMC40NzQgMjIuNTY5YzAuMTUzIDcuMjY2IDEwLjU2MyA3LjU2NiA5LjU2MSAwLjc0NyIgZmlsbD0iI2NjMWI3NCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTc5Ljg1IDQzNi42NSkiPgo8cGF0aCBkPSJtMCAwIDYuMDQ4IDIuMDc5LTEuNjk4LTMwLjQyM2gtMjUuMTM3bC0xLjY3MSAyOS45NzMtNi45MzkgMi40ODQgMC4wOTkgNC43MzRjMTIuMjkxLTMuNzQ0IDEyLjU4NS0xNi40MjUgMjkuMjk4LTguODQ3IiBmaWxsPSIjY2MxYjc0IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNTYuNjcgNDUxLjE3KSI+CjxwYXRoIGQ9Im0wIDBjNi4wOS0wLjgwNyAxNy44MDUtMTEuMDQ2IDM1LjkyOC01LjY3My0yLjQ2Ni02LjUyNS0zOS41MzctMzAuNjMtMzUuOTI4IDUuNjczIiBmaWxsPSIjY2MxYjc0IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxODMuOTUgNDQwLjAyKSI+CjxwYXRoIGQ9Im0wIDAgMi42MDEtMTcuNzQ1czYuMjg1LTIuMTI3IDYuMzI3LTEuNjM1LTAuMjg1IDI0Ljg2MS0wLjI4NSAyNC44NjF6IiBmaWxsPSIjY2MxYjc0IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNTguNjIgNDE2LjE3KSI+CjxwYXRoIGQ9Im0wIDAgMS41Ni0zNS45MDRoMjMuMjA1bDEuMjQ4IDM1LjkwNHoiIGZpbGw9IiNjYzFiNzQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE1Ny4yNCA0MTQuNzcpIj4KPHBhdGggZD0ibTAgMC0wLjk4MSAxMC4wNDRjLTEuMTI4IDQuNjQ0LTYuOTcyIDIuODUzLTYuMDkzLTIuOTA0bDAuNi03LjYyM3oiIGZpbGw9IiNjYzFiNzQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE4NS44OCA0MTQuNzcpIj4KPHBhdGggZD0ibTAgMCAwLjg2NCA5LjcwNWMxLjEyNSA0LjY0MSA3LjAxNCAxLjkxNyA2LjEzNS0zLjg0bC0wLjUyOC02LjM0OHoiIGZpbGw9IiNjYzFiNzQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE3Ny40MyA0NjYuMzcpIj4KPHBhdGggZD0ibTAgMHYtMTcuMjc0Yy0zLjE5Mi00LjE5NC04LjQxNS00LjA1LTExLjYwNyAwdjE3LjI3NGMwIDcuNjggMTEuNjA3IDcuNjc3IDExLjYwNyAwIiBmaWxsPSIjZmJkOWJkIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNzcuNDMgNDYzLjQ0KSI+CjxwYXRoIGQ9Im0wIDB2LTkuNTE2Yy0yLjE5Ni0xLjcxNi00LjMxNC0yLjY4Mi01LjgwMi0yLjY4Mi0xLjQ5MSAwLTMuNjA5IDAuOTY2LTUuODA1IDIuNjgydjkuNTE2YzAgNy42OCAxMS42MDcgNy42OCAxMS42MDcgMCIgZmlsbD0iI2VjYzJhMCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTcxLjYzIDQ1My42MSkiPgo8cGF0aCBkPSJtMCAwYy0zLjc3NyAwLTExLjc1NyA1Ljk0LTE0LjIyNiAxNC40NDgtMi40OTYgOC41ODkgMi4xOTkgMjAuOTEzIDE0LjIyNiAyMC45MTNzMTYuNzIyLTEyLjMyNCAxNC4yMjYtMjAuOTEzYy0yLjQ2My04LjUxMS0xMC40NDktMTQuNDQ4LTE0LjIyNi0xNC40NDgiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE2NS42MSA0NjMuNzUpIj4KPHBhdGggZD0ibTAgMGMyLjU0NyAxLjg2MyA1LjIwOCAwLjc2MiA2LjA5NiAwLjc2MiAwLjg5MSAwIDMuNDAyIDEuMTA0IDUuOTQ5LTAuNzYyLTEuMjY2LTUuMTI0LTEwLjEyNS01LjI1My0xMi4wNDUgMCIgZmlsbD0iI2ZmMzg2YSIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTY1LjY4IDQ2My43OCkiPgo8cGF0aCBkPSJtIDAsMCBjIDIuMzY0LDAuODM0IDQuNDU4LC0wLjgwMSA1Ljk0MywtMC44MDEgMS40OTEsMCAzLjU4OCwyLjE5NiA1Ljk1MiwwLjcxNyBDIDkuMTIzLC0yLjkwNyAyLjc5LC0yLjc1NyAwLDAiIGZpbGw9IiNhMjFmNDAiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE2NS42MSA0NjMuNzgpIj4KPHBhdGggZD0ibTAgMGMyLjU0NyAxLjA1IDQuNDI1IDAuMjg4IDUuOTEzIDAuMjg4czMuNTg1IDAuNzYyIDYuMTMyLTAuMjg4Yy0yLjc2OS0xLjU4NC05LjI1Mi0xLjUzMy0xMi4wNDUgMCIgZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTY1LjYyIDQ2My43NykiPgo8cGF0aCBkPSJtMCAwYzIuNTM1IDEuODQyIDQuNzE2IDAuNTY0IDYuMjAxIDAuNTY0czMuMjczIDEuMjgxIDUuODIzLTAuNTgyYy05ZS0zIC0wLjAyNy0wLjAyMS0wLjA1NC0wLjAzLTAuMDc4LTMuMjQ2IDAuMDYtOC41NjIgMC4wOTMtMTEuOTk0IDAuMDk2IiBmaWxsPSIjZmYzODZhIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNTQuMyA0NzMuMjQpIj4KPHBhdGggZD0ibTAgMGMxLjIxMiAwLjUyMiAyLjkzMS0wLjc1OSAzLjgzNC0yLjg1OSAwLjktMi4xIDAuNjUxLTQuMjI3LTAuNTY3LTQuNzQ5LTEuMjEyLTAuNTIyLTIuOTMxIDAuNzU2LTMuODM0IDIuODU5LTAuOSAyLjEtMC42NTEgNC4yMjcgMC41NjcgNC43NDkiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE4Ny44NCA0NzMuMjQpIj4KPHBhdGggZD0ibTAgMGMxLjIxOC0wLjUyMiAxLjQ3My0yLjY0OSAwLjU2Ny00Ljc0OS0wLjktMi4xLTIuNjIyLTMuMzgxLTMuODM0LTIuODU5LTEuMjE4IDAuNTIyLTEuNDczIDIuNjQ5LTAuNTY3IDQuNzQ5IDAuOSAyLjEwMyAyLjYyMiAzLjM4NCAzLjgzNCAyLjg1OSIgZmlsbD0iI2ZiZDliZCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTg1LjY0IDQ3MC4zOSkiPgo8cGF0aCBkPSJtMCAwYzcuMDg5IDE5Ljk2OC02LjU5MSAyMS4yMzctMTQuNjMxIDIxLjIzNy05LjA2IDAtMTkuNjM4LTQuNjIzLTEzLjc4NS0yMS40NjggOC42MzQgMC40MjYgMTYuMjI0IDUuMjQxIDIzLjg1MyAxNS4zNTQgMS4yOTktNS4xMzkgMi4xNzUtMTEuODE3IDQuNTYzLTE1LjEyMyIgZmlsbD0iI2Q1NmMyYiIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTIwLjgxIDQ0OC4yMikiPgo8cGF0aCBkPSJtMCAwYy05LjMxNS0wLjEzNS0xMC43MjIgMTYuOC0xNC45NDkgMjguODU0LTYuMjczIDE3Ljg4NiAxNC41NjUgMjcuOTkzIDIxLjU3IDIxLjQ5NSA3LjQ1MiAwIDEyLjU1Mi0xNC4yODMgOC4yMTctMjQuNjMtNS40NTctMTMuMDItNy44NjMtMjYuNjY3LTE0LjgzOC0yNS43MTkgMCAwIDQuMTIyIDAuMTc0IDAgMCIgZmlsbD0iI2ExNDAwZiIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTExLjExIDM1NS41MikiPgo8cGF0aCBkPSJtMCAwYy0yLjEyMS0zLjA3Mi00Ljk0NC00LjgzNi01LjY0OS03LjA1My0wLjM5OS0xLjI1MS0wLjEwMi0xLjkyOSAxLjE3LTIuMDg1IDUuNDc1LTAuNjc4IDcuMDYyIDEuMTA3IDkuMDE1IDEuNjU2IDMuMzY2IDAuOTQyIDMuNDU2IDIuODggMi4wOTEgNy40ODItMS4zNjUgNC41OTktNC45MiAyLjg3MS02LjYyNyAwIiBmaWxsPSIjZTVhNzc1IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMDcuOTEgNDEzLjg1KSI+CjxwYXRoIGQ9Im0wIDBoMjUuMDQ3bC0zLjE5NS01OC4zMzJoLTYuNjI3bC0xLjM0NyA0NC4zNjdjLTAuMTExIDMuNTE2LTIuNTk4IDMuNTM3LTIuNzA5IDBsLTEuMzQ3LTQ0LjM2N2gtNi42Mjd6IiBmaWxsPSIjZTVhNzc1IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMzUuMzQgNDU2LjU3KSI+CjxwYXRoIGQ9Im0wIDAtMi4zODUtNDIuNzE0aC0yNS4wNDdsLTIuMzg4IDQyLjcxNHoiIGZpbGw9IiNlNWE3NzUiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzMS42OCA0NTEuNjUpIj4KPHBhdGggZD0ibTAgMCAzLjYyNC0yNC42NTFjMC40NDEtMy4wMDkgNi40MzItMS4zNjIgNi4zNzUgMS40MTZsLTAuNDcxIDIyLjQ5N2MtMC4xNTMgNy4yMzMtMTAuNTI3IDcuNTM2LTkuNTI4IDAuNzM4IiBmaWxsPSIjZTVhNzc1IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMzQuMjcgNDEwLjQxKSI+CjxwYXRoIGQ9Im0wIDBjLTAuMjQgMC4xNjItMC41NDYtMC4xNjUtMC41NjctMC40NTNsLTAuMzEyLTQuMjI3Yy0wLjAyMS0wLjI4NSAwLjI1Mi0wLjQyNiAwLjQ5NS0wLjU5MSAwLjIzNy0wLjE2MiAwLjU0MyAwLjE2OCAwLjU2NCAwLjQ1M2wwLjMxNSA0LjIyN2MwLjAyMSAwLjI4OC0wLjIwMSAwLjU1Mi0wLjQ5NSAwLjU5MSIgZmlsbD0iI2U1YTc3NSIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTMzLjY5IDQwOC42MSkiPgo8cGF0aCBkPSJNIDAsMCAwLjEzOCwxLjgyMSA2LjE0NCwwLjk1NyA2LjAwNiwtMC44NjEgQyA1LjQyNywtNi4zMzkgLTAuNjgxLC02LjY0NSAwLDAiIGZpbGw9IiNlNWE3NzUiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzMy43NiA0MDkuODkpIj4KPHBhdGggZD0ibTAgMCAxLjI5OSAxNy40NjNjMS4xMjIgNC42MjYgNy41NTEgNC41MjEgNi42NzUtMS4yMThsLTIuMDIyLTE3LjA4NXoiIGZpbGw9IiNlNWE3NzUiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEwOC45NSA0NTEuNjUpIj4KPHBhdGggZD0ibTAgMC0zLjYyNy0yNC42NTFjLTAuNDQxLTMuMDA5LTYuNDMyLTEuMzYyLTYuMzcyIDEuNDE2bDAuNDc0IDIyLjQ5N2MwLjE1IDcuMjMzIDEwLjUyMSA3LjUzNiA5LjUyNSAwLjczOCIgZmlsbD0iI2U1YTc3NSIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTA2LjM2IDQxMC40MSkiPgo8cGF0aCBkPSJtMCAwYzAuMjQzIDAuMTYyIDAuNTQzLTAuMTY1IDAuNTY3LTAuNDUzbDAuMzE1LTQuMjI3YzAuMDE4LTAuMjg1LTAuMjUyLTAuNDI2LTAuNDk4LTAuNTkxLTAuMjQtMC4xNjItMC41NDMgMC4xNjgtMC41NjQgMC40NTNsLTAuMzE1IDQuMjI3Yy0wLjAyMSAwLjI4OCAwLjIwNCAwLjU1MiAwLjQ5NSAwLjU5MSIgZmlsbD0iI2U1YTc3NSIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTA2Ljk0IDQwOC42MSkiPgo8cGF0aCBkPSJtMCAwLTAuMTM4IDEuODIxLTYuMDA2LTAuODY0IDAuMTM4LTEuODE4YzAuNTg1LTUuNDc4IDYuNjg3LTUuNzg0IDYuMDA2IDAuODYxIiBmaWxsPSIjZTVhNzc1IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMDYuODcgNDA5Ljg5KSI+CjxwYXRoIGQ9Im0wIDAtMS4yOTYgMTcuNDYzYy0xLjEyNSA0LjYyNi03LjU1NCA0LjUyMS02LjY3OC0xLjIxOGwyLjAyMi0xNy4wODV6IiBmaWxsPSIjZTVhNzc1IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMDcuOTEgNDEzLjg1KSI+CjxwYXRoIGQ9Im0wIDAgMC45MjctMzUuMDIyaDIzLjEyN2wwLjk5MyAzNS4wMjItMTIuNjc1IDE1Ljg3NnoiIGZpbGw9IiNjYzFiNzQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyOS43OCAzNTUuNTIpIj4KPHBhdGggZD0ibTAgMGMyLjExOC0zLjA3MiA0Ljk0MS00LjgzNiA1LjY0OS03LjA1MyAwLjM5OS0xLjI1MSAwLjEwMi0xLjkyOS0xLjE3LTIuMDg1LTUuNDc1LTAuNjc4LTcuMDY4IDEuMTA3LTkuMDE1IDEuNjU2LTMuMzY5IDAuOTQyLTMuNDU2IDIuODgtMi4wOTEgNy40ODIgMS4zNjIgNC41OTkgNC45MiAyLjg3MSA2LjYyNyAwIiBmaWxsPSIjZTVhNzc1IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMDcuMjQgMzUxLjEzKSI+CjxwYXRoIGQ9Im0wIDBjLTAuODI1LTAuODkxLTEuNDg1LTEuNzM3LTEuNzc5LTIuNjU4LTEuMDMyLTMuMjM0IDEuODUxLTMuMzIxIDQuMjA2LTMuMDE1IDMuMTQxIDAuNDA1IDQuNDQ5IDIuMTUxIDUuOTc5IDIuNTgzIDMuMDI0IDAuODQ5IDMuNDAyIDIuNDk5IDIuNDYgNi4xNjItMC4xMzItMy4xOTUtMy4xMTctNC4wNjUtNi40MzgtNS42MzctMy4zMTUtMS41NzUtNS45OTEtMC4wMTgtNC40MjggMi41NjUiIGZpbGw9IiNjYzFiNzQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzMy42NSAzNTEuMTMpIj4KPHBhdGggZD0ibTAgMGMwLjgyMi0wLjg5MSAxLjQ4NS0xLjczNyAxLjc3OS0yLjY1OCAxLjE3OS0zLjcwMi0zLjAyNy0zLjQyMy01LjQwMy0yLjc3OC0yLjMwNyAwLjYyNC0zLjQ2MiAxLjk3Ny00Ljc4MiAyLjM0Ni0zLjAyNyAwLjg0OS0zLjQwNSAyLjQ5OS0yLjQ2IDYuMTYyIDAuMTI2LTMuMTk1IDMuMTE3LTQuMDY1IDYuNDM4LTUuNjM3IDMuMzE4LTEuNTc1IDUuOTkxLTAuMDE4IDQuNDI4IDIuNTY1IiBmaWxsPSIjY2MxYjc0IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMjAuNCA0MTMuODUpIj4KPHBhdGggZD0ibTAgMGgtMTIuNDkybC0yLjA0MyAzMC4wMTUgOC43NTQgMTIuNjk5aDExLjU2NWw4LjU4LTEyLjY5OS0xLjg3NS0zMC4wMTV6IiBmaWxsPSIjY2MxYjc0IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMjYuMTggNDcxLjU2KSI+CjxwYXRoIGQ9Im0wIDB2LTE1YzAtOS4zOTYtMTEuNTY1LTkuMjEtMTEuNTY1IDB2MTVjMCA3LjY1IDExLjU2NSA3LjY1IDExLjU2NSAwIiBmaWxsPSIjZTVhNzc1IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMjYuMTggNDcxLjU2KSI+CjxwYXRoIGQ9Im0wIDB2LTkuNDg5Yy0yLjE4Ny0xLjcxLTQuMjk5LTIuNjY3LTUuNzg0LTIuNjY3LTEuNDgyIDAtMy41OTQgMC45NTctNS43ODEgMi42Njd2OS40ODljMCA3LjY1IDExLjU2NSA3LjY1IDExLjU2NSAwIiBmaWxsPSIjZDM5NzZlIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMjAuNCA0NjEuNzYpIj4KPHBhdGggZD0ibTAgMGMtMy43NjggMC0xMS43MjEgNS45MjItMTQuMTgxIDE0LjQtMi40ODEgOC41NjIgMi4xOTYgMjAuODQxIDE0LjE4MSAyMC44NDFzMTYuNjU5LTEyLjI3OSAxNC4xNzgtMjAuODQxYy0yLjQ2LTguNDc4LTEwLjQxMy0xNC40LTE0LjE3OC0xNC40IiBmaWxsPSIjZTVhNzc1IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMTUuODYgNDcwLjMpIj4KPHBhdGggZD0iTSAwLDAgQyAxLjkyLDEuODU3IDMuNDE3LDAuNDY4IDQuNTM5LDAuNDY4IDUuNjU4LDAuNDY4IDcuMTU1LDEuODYgOS4wNzUsMCA4LjA0LC00Ljg5OSAxLjM2OCwtNS4wNTIgMCwwIiBmaWxsPSIjZmYzODZhIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMTYuNDUgNDcwLjA0KSI+CjxwYXRoIGQ9Ik0gMCwwIEMgMS4wNSwwLjI3IDYuMzksMC4zMjEgNy44OTMsMC4wNiA2LjY1NCwtMi4yMjMgMS4wNSwtMi4wOTQgMCwwIiBmaWxsPSIjZmZmIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMTUuODYgNDcwLjMpIj4KPHBhdGggZD0ibTAgMGMxLjkyIDEuODU3IDMuNDE3IDAuNDY4IDQuNTM5IDAuNDY4IDEuMTE5IDAgMi42MTYgMS4zOTIgNC41MzYtMC40NjgtMi45MzQtMS40NDYtNy4xMDEtMC43NzEtOS4wNzUgMCIgZmlsbD0iI2ZmMzg2YSIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTAzLjg1IDQ4MS4zMykiPgo8cGF0aCBkPSJtMCAwYzEuMjEyIDAuNTE5IDIuOTI1LTAuNzU2IDMuODI1LTIuODUgMC44OTctMi4wOTQgMC42NDgtNC4yMTUtMC41NjctNC43MzctMS4yMTItMC41MTktMi45MjIgMC43NTktMy44MTkgMi44NTMtMC45MDMgMi4wOTQtMC42NDggNC4yMTUgMC41NjEgNC43MzQiIGZpbGw9IiNlNWE3NzUiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzNy4yOCA0ODEuMzMpIj4KPHBhdGggZD0ibTAgMGMxLjIxMi0wLjUxOSAxLjQ2NC0yLjYzNyAwLjU2Ny00LjczNC0wLjkwMy0yLjA5NC0yLjYxMy0zLjM3Mi0zLjgyOC0yLjg0Ny0xLjIwNiAwLjUxOS0xLjQ2MSAyLjY0LTAuNTY0IDQuNzMxIDAuOSAyLjA5NyAyLjYxMyAzLjM3MiAzLjgyNSAyLjg1IiBmaWxsPSIjZTVhNzc1IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMzUuNzMgNDc2LjMxKSI+CjxwYXRoIGQ9Im0wIDBjNC41NDggMTkuNTA5LTkuMTg2IDIyLjgyNy0xNy4yMDIgMjIuODI3LTkuMDI3IDAtMTMuODI3LTEwLjUwNi0xMi4zMDMtMjIuOTggNC44MTUgMi45MDQgNy4wNSA4LjQyNyAxNy41NzcgMTcuNzgxLTEuNTMtMi43NDgtNC41MTItNy43MzctMTQuNjYxLTE2Ljc5MSA1LjQ2LTAuOSAxNS42MyA1Ljk4MiAyMS4wNTQgMTMuMTgyIDEuMjkzLTUuMTE4IDMuMTU2LTEwLjcyNSA1LjUzNS0xNC4wMTkiIGZpbGw9IiNhMTQwMGYiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDgwLjk2IDM1Mi45NykiPgo8cGF0aCBkPSJtMCAwYzIuMTc1LTMuMTQ0IDUuMDE2LTQuNjc3IDUuNDQyLTcuMzggMC4yMS0xLjMzMiAwLjA2OS0yLjM4OC0xLjIzNi0yLjU1LTUuNjEzLTAuNjkzLTYuMjM0IDEuNTc1LTguMjMyIDIuMTMzLTMuNDU2IDAuOTcyLTQuMTYxIDMuMDgxLTIuNzYzIDcuNzk3czUuMDQzIDIuOTQzIDYuNzg5IDAiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDg0LjIzOCA0MTIuNzYpIj4KPHBhdGggZD0ibTAgMGgtMjUuNjcxbDMuMjc2LTU5Ljc4N2g2Ljc5MmwxLjM4IDQ1LjQ3NGMwLjEwOCAzLjYwMyAyLjY2MSAzLjYyNCAyLjc3MiAwbDEuMzgzLTQ1LjQ3NGg2Ljc4OXoiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDgyLjMzMyA0NTEuNTIpIj4KPHBhdGggZD0ibTAgMCA0LjU1MS0yNS4yODdjMC41NTItMy4wNjYgNi42MjEtMC4xMTcgNi41MzQgMS40NTVsLTEuMzIzIDIzLjA3Yy0wLjQyMyA3LjQxLTExLjAwNyA3LjY5Mi05Ljc2MiAwLjc2MiIgZmlsbD0iI2RkMjQ4OSIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNTMuOTQ0IDQ4MS4xMSkiPgo8cGF0aCBkPSJtMCAwYzUuMzA3IDEuMjg0LTMuNjY5LTYuMTM4IDMuNTAxLTE0LjA3OSA3LjE3My03Ljk0NCAyLjM3My0xOC4xOC00LjYyMy0xOS42MTctMi45NDYtMC42MDYgNi41NDMgNS44OTUtMS45NDEgMTMuMzgzLTUuNDE4IDQuNzgyLTYuMTc0IDE4LjA2OSAzLjA2MyAyMC4zMTMiIGZpbGw9IiNjYjdjNTQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDU2LjEyMiA0NTYuNTMpIj4KPHBhdGggZD0ibTAgMCAyLjQ0NS00My43NzZoMjUuNjcxbDIuNDQ1IDQzLjc3NnoiIGZpbGw9IiNkZDI0ODkiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDg1LjgyNSA0MDkuMjMpIj4KPHBhdGggZD0ibTAgMGMtMC4yNDkgMC4xNjUtMC41NTgtMC4xNjgtMC41NzktMC40NTlsLTAuMzI3LTQuMzM1Yy0wLjAyMS0wLjI5NCAwLjI2MS0wLjQzOCAwLjUwNy0wLjYwNiAwLjI1Mi0wLjE2NSAwLjU1OCAwLjE2OCAwLjU4MiAwLjQ2MmwwLjMyNCA0LjMzMmMwLjAyNCAwLjI5NC0wLjIxIDAuNTY3LTAuNTA3IDAuNjA2IiBmaWxsPSIjZmJkOWJkIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg4NS4yMzEgNDA3LjM4KSI+CjxwYXRoIGQ9Ik0gMCwwIDAuMTQxLDEuODYgNi4zLDAuOTc4IDYuMTU5LC0wLjg4NSBDIDUuNTYyLC02LjQ5NSAtMC42OTksLTYuODEgMCwwIiBmaWxsPSIjZmJkOWJkIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg4NS4zMDcgNDA4LjcpIj4KPHBhdGggZD0ibTAgMCAxLjMyOSAxNy44OThjMS4xNDkgNC43NCA2LjUzMSA1LjMxIDYuNzgzIDEuMDkybC0yLjAxLTE5Ljg0OHoiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDg0LjIzOCA0MTIuNzYpIj4KPHBhdGggZD0ibTAgMC0wLjk1MS0xNy4zNDZoLTIzLjcwM2wtMS4wMTcgMTcuMzQ2IDExLjk0OSAzNi43NDdjMC41NDYtMC4wNTEgMS4wOTgtMC4wNjYgMS42NDctMC4wMTV6IiBmaWxsPSIjY2MxYjc0IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg2MS44MjcgMzUyLjk3KSI+CjxwYXRoIGQ9Im0wIDBjLTIuMTc1LTMuMTQ0LTUuMjItNC45ODYtNS42MDctNy40NTgtMC4yMDctMS4zMjkgMC4zMzYtMi40MzkgMS42MzgtMi42MDQgNS42MS0wLjY5IDYuMDY2IDIuMDQ2IDguMDYxIDIuNjA0IDMuNDU5IDAuOTcyIDQuMDk1IDIuNzQyIDIuNyA3LjQ1OC0xLjM5OCA0LjcxNi01LjA0NiAyLjk0My02Ljc5MiAwIiBmaWxsPSIjZmJkOWJkIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg4NC45MyAzNDguNDcpIj4KPHBhdGggZD0ibTAgMGMwLjg0Ni0wLjkxMiAxLjUyMS0xLjc3NiAxLjgyMS0yLjcyMSAxLjA1OS0zLjMxOC0xLjg5Ni0zLjQwNS00LjMwOC0zLjA5My0zLjIxOSAwLjQxNy00LjU2IDIuMjExLTYuMTI5IDIuNjQ5LTMuMDk5IDAuODctMy40ODYgMi41NTktMi41MiA2LjMxNSAwLjEyOS0zLjI3NiAzLjE5NS00LjE2NyA2LjU5Ny01Ljc4MSAzLjM5OS0xLjYxMSA2LjE0MS0wLjAxMiA0LjUzOSAyLjYzMSIgZmlsbD0iI2NjMWI3NCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNTcuODU3IDM0OC40NykiPgo8cGF0aCBkPSJtMCAwYy0wLjg0My0wLjkxMi0xLjUyMS0xLjc3Ni0xLjgyMS0yLjcyMS0xLjIxMi0zLjc5NSAzLjA5OS0zLjUxIDUuNTM4LTIuODUgMi4zNjEgMC42NDIgMy41NDYgMi4wMjUgNC44OTkgMi40MDYgMy4wOTkgMC44NyAzLjQ4OSAyLjU1OSAyLjUyIDYuMzE1LTAuMTI5LTMuMjc2LTMuMTk1LTQuMTY3LTYuNTk0LTUuNzgxLTMuNDAyLTEuNjExLTYuMTQ0LTAuMDEyLTQuNTQyIDIuNjMxIiBmaWxsPSIjY2MxYjc0IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg5My40MTkgNDI3LjY5KSI+CjxwYXRoIGQ9Im0wIDAtNi43ODMtMS4wOTItMC41NDYgNS4wMzEgNi45NjYgMS4yMjd6IiBmaWxsPSIjYmMxYjczIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg2MC4yNyA0NTEuNTIpIj4KPHBhdGggZD0ibTAgMC00LjU1MS0yNS4yODdjLTAuNTU1LTMuMDY2LTYuNjI3LTAuMTE3LTYuNTM3IDEuNDU1bDEuMzIgMjMuMDdjMC40MjkgNy40MSAxMS4wMTMgNy42OTIgOS43NjggMC43NjIiIGZpbGw9IiNkZDI0ODkiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDU2Ljc3NyA0MDkuMjMpIj4KPHBhdGggZD0ibTAgMGMwLjI0OSAwLjE2NSAwLjU1OC0wLjE2OCAwLjU3OS0wLjQ1OWwwLjMyNC00LjMzNWMwLjAyNC0wLjI5NC0wLjI1OC0wLjQzOC0wLjUwNy0wLjYwNi0wLjI0OS0wLjE2NS0wLjU1OCAwLjE2OC0wLjU4MiAwLjQ2MmwtMC4zMjEgNC4zMzJjLTAuMDIxIDAuMjk0IDAuMjEgMC41NjcgMC41MDcgMC42MDYiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDU3LjM2OCA0MDcuMzgpIj4KPHBhdGggZD0ibTAgMC0wLjE0MSAxLjg2LTYuMTU2LTAuODgyIDAuMTQxLTEuODYzYzAuNTk3LTUuNjEgNi44NTUtNS45MjUgNi4xNTYgMC44ODUiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDU3LjI5NSA0MDguNykiPgo8cGF0aCBkPSJtMCAwLTEuMzI5IDE3Ljg5OGMtMS4xNDkgNC43NC02LjUzNyA1LjMxLTYuNzg2IDEuMDkybDIuMDEzLTE5Ljg0OHoiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQ5LjE4MyA0MjcuNjkpIj4KPHBhdGggZD0ibTAgMCA2Ljc4My0xLjA5MiAwLjU0MyA1LjAzMS02Ljk2MyAxLjIyN3oiIGZpbGw9IiNiYzFiNzMiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDU1LjE2OSA0OTQuOTkpIj4KPHBhdGggZD0ibTAgMGMyLjEgNC40NTggNi4yMSA3LjI0OCAxMS45NCA2LjE5NSA0LjU4NCA1LjYwNyAxNi43NDYgMC41MzQgMTkuMjMtNC4zODMgOS41ODgtMTguOTkzLTcuMzQ3LTI5LjY0OS0xNS4zNTEtMjkuNjQ5LTcuMTgyLTZlLTMgLTIzLjE4MSAxMi4yMzctMTUuODE5IDI3LjgzNyIgZmlsbD0iI2NiN2M1NCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNzcuMzMgNDc0LjQ5KSI+CjxwYXRoIGQ9Im0wIDB2LTIxLjk5M2MtMy4yNjEtNC4yODQtOC41OTUtNC4xNC0xMS44NTMgMHYyMS45OTNjMCA3LjgzOSAxMS44NTMgNy44MzkgMTEuODUzIDAiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDc3LjMzIDQ3MS41KSI+CjxwYXRoIGQ9Im0wIDB2LTkuNzJjLTIuMjQ0LTEuNzU4LTQuNDA0LTIuNzM5LTUuOTI4LTIuNzM5LTEuNTIxIDAtMy42ODQgMC45ODEtNS45MjUgMi43Mzl2OS43MmMwIDcuODQyIDExLjg1MyA3Ljg0MiAxMS44NTMgMCIgZmlsbD0iI2VjYzJhMCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoODguMjQ5IDQ4MS4xMSkiPgo8cGF0aCBkPSJtMCAwYzkuMjM3LTIuMjQ0IDguNDgxLTE1LjUzMSAzLjA2My0yMC4zMTMtOC40ODQtNy40ODggMS4wMDUtMTMuOTg5LTEuOTQxLTEzLjM4My02Ljk5NiAxLjQzNy0xMS43OTYgMTEuNjczLTQuNjIzIDE5LjYxNyA3LjE3IDcuOTQxLTEuODA2IDE1LjM2MyAzLjUwMSAxNC4wNzkiIGZpbGw9IiNjYjdjNTQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDg2Ljg5NCA0ODEuODIpIj4KPHBhdGggZD0iTSAwLDAgQyAxLjg5LDEuMzIzIDMuODQ2LDEuNzg1IDQuMzY4LDEuMDM1IDQuODksMC4yODggMy43NzcsLTEuMzg2IDEuODg3LC0yLjcwMyAwLC00LjAyIC0xLjk1NiwtNC40ODggLTIuNDc4LC0zLjczOCAtMywtMi45OTQgLTEuODg3LC0xLjMyIDAsMCIgZmlsbD0iIzI4MjgyOCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNTYuMTQ2IDQ4MS44MikiPgo8cGF0aCBkPSJtMCAwYzEuODktMS4zMTcgMy4wMDMtMi45OTcgMi40ODEtMy43NDEtMC41MTktMC43NDctMi40NzgtMC4yODItNC4zNjggMS4wMzUtMS44OSAxLjMyLTMgMi45OTctMi40NzggMy43NDQgMC41MjIgMC43NDQgMi40NzUgMC4yODIgNC4zNjUtMS4wMzgiIGZpbGw9IiMyODI4MjgiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDcxLjQwMiA0NjEuNDUpIj4KPHBhdGggZD0ibTAgMGMtMy44NTggMC0xMi4wMTIgNi4wNjktMTQuNTMyIDE0Ljc2LTIuNTQ3IDguNzc1IDIuMjQ3IDIxLjM2IDE0LjUzMiAyMS4zNnMxNy4wNzktMTIuNTg1IDE0LjUzMi0yMS4zNmMtMi41MjMtOC42OTEtMTAuNjc0LTE0Ljc2LTE0LjUzMi0xNC43NiIgZmlsbD0iI2ZiZDliZCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNjUuMjUxIDQ3MS44MSkiPgo8cGF0aCBkPSJtMCAwYzIuNjAxIDEuOTAyIDUuMzE5IDAuNzc0IDYuMjI1IDAuNzc0IDAuOTA5IDAgMy40NzQgMS4xMzEgNi4wNzgtMC43NzQtMS4yOTYtNS4yMzUtMTAuMzQ0LTUuMzctMTIuMzAzIDAiIGZpbGw9IiNmZjM4NmEiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDY1LjMyNyA0NzEuODMpIj4KPHBhdGggZD0ibTAgMGMyLjQxNSAwLjg1MiA0LjU1NC0wLjgxNiA2LjA3Mi0wLjgxNiAxLjUyMSAwIDMuNjYzIDIuMjQxIDYuMDc4IDAuNzMyLTIuODMyLTIuODg2LTkuMy0yLjcyNy0xMi4xNSAwLjA4NCIgZmlsbD0iI2EyMWY0MCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNjUuMjUxIDQ3MS44NCkiPgo8cGF0aCBkPSJtMCAwYzIuNjAxIDEuMDcxIDQuNTE4IDAuMjk0IDYuMDM2IDAuMjk0IDEuNTIxIDAgMy42NjYgMC43NzcgNi4yNjctMC4yOTQtMi44MjktMS42Mi05LjQ1Ni0xLjU2Ni0xMi4zMDMgMCIgZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNjUuMjYxIDQ3MS44MikiPgo8cGF0aCBkPSJtMCAwYzIuNTg5IDEuODgxIDQuODE1IDAuNTc2IDYuMzMzIDAuNTc2czMuMzQ1IDEuMzExIDUuOTQ5LTAuNTkxYy0wLjAxMi0wLjAzLTAuMDIxLTAuMDU0LTAuMDMzLTAuMDc4LTMuMzE4IDAuMDU3LTguNzQ1IDAuMDkzLTEyLjI0OSAwLjA5MyIgZmlsbD0iI2ZmMzg2YSIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoODcuOTU5IDQ4MS41MSkiPgo8cGF0aCBkPSJtMCAwYzEuMjM5LTAuNTM0IDEuNS0yLjcwMyAwLjU3Ni00Ljg1MS0wLjkyMS0yLjE0NS0yLjY3My0zLjQ1My0zLjkxOC0yLjkxOS0xLjI0MiAwLjUzMS0xLjQ5NyAyLjcwMy0wLjU3OSA0Ljg0OCAwLjkyNCAyLjE1MSAyLjY3OSAzLjQ1OSAzLjkyMSAyLjkyMiIgZmlsbD0iI2ZiZDliZCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNTQuMjM1IDQ4MS41MSkiPgo8cGF0aCBkPSJtMCAwYzEuMjQyIDAuNTM3IDIuOTk3LTAuNzcxIDMuOTIxLTIuOTIyIDAuOTE4LTIuMTQ1IDAuNjYzLTQuMzE3LTAuNTc5LTQuODQ4LTEuMjQ1LTAuNTM0LTIuOTk3IDAuNzc0LTMuOTE4IDIuOTE5LTAuOTI0IDIuMTQ4LTAuNjYzIDQuMzE3IDAuNTc2IDQuODUxIiBmaWxsPSIjZmJkOWJkIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg4NS43MTYgNDc4LjYpIj4KPHBhdGggZD0ibTAgMGM3LjIzOSAyMC4zODgtNi43MzIgMjEuNjg3LTE0Ljk0OSAyMS42ODctOS4yNTIgMC0yMC4wNTItNC43MTktMTQuMDc2LTIxLjkyNCA4LjgyIDAuNDM1IDE2LjU2OSA1LjM1MiAyNC4zNjMgMTUuNjgxIDEuMzI5LTUuMjUgMi4yMjMtMTIuMDY5IDQuNjYyLTE1LjQ0NCIgZmlsbD0iI2NiN2M1NCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjEuNDIxIDQ1MS4yMikiPgo8cGF0aCBkPSJtMCAwYy0xNi45NS0wLjMzNi0xOC44NDYgMTkuNjYyLTE4LjIzNCAyOS41MzggMS4xNDYgMTguNDE3IDE3Ljg1OSAyNS44MDMgMjQuNjgxIDE5LjQ3NiA3LjI1MSAwIDEwLjY1My05LjAwMyAxMS40NzItMTkuMjk2IDEuMDg5LTEzLjcwMS0zLjk1Ny0yOS40MzYtMTcuOTE5LTI5LjcxOCIgZmlsbD0iI2ExNDAwZiIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTEuOTY4IDM2MC45OCkiPgo8cGF0aCBkPSJtMCAwYy0yLjA2NC0yLjk5MS00LjgxNS00LjcwNy01LjQ5OS02Ljg2NC0wLjM5LTEuMjE4LTAuMDk5LTEuODc4IDEuMTQtMi4wMzEgNS4zMzEtMC42NiA2Ljg3MyAxLjA3NyA4Ljc3NSAxLjYxMSAzLjI3OSAwLjkxOCAzLjM2MyAyLjgwNSAyLjAzNyA3LjI4NC0xLjMyOSA0LjQ3Ni00Ljc5MSAyLjc5My02LjQ1MyAwIiBmaWxsPSIjZmJkOWJkIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg4Ljg1ODEgNDE3Ljc2KSI+CjxwYXRoIGQ9Im0wIDBoMjQuMzg0bC0zLjExMS01Ni43ODRoLTYuNDUzbC0xLjMxMSA0My4xODhjLTAuMTA1IDMuNDIzLTIuNTI5IDMuNDQ0LTIuNjM3IDBsLTEuMzExLTQzLjE4OGgtNi40NXoiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDM1LjU2NCA0NTkuMzQpIj4KPHBhdGggZD0ibTAgMC0yLjc2LTQxLjU4M2gtMjMuNjQ5bC0yLjYxOSA0MS41ODN6IiBmaWxsPSIjZmJkOWJkIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzMS45OTkgNDU0LjU2KSI+CjxwYXRoIGQ9Im0wIDAgMy41MjgtMjRjMC40MjktMi45MjggNi4yNjQtMS4zMjMgNi4yMDcgMS4zOGwtMC40NjIgMjEuOWMtMC4xNDcgNy4wNDQtMTAuMjQ1IDcuMzM4LTkuMjczIDAuNzIiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDM0LjUxOSA0MTQuNDIpIj4KPHBhdGggZD0ibTAgMGMtMC4yMzQgMC4xNTktMC41MzEtMC4xNjItMC41NTItMC40NDFsLTAuMzA2LTQuMTE2Yy0wLjAxOC0wLjI3NiAwLjI0OS0wLjQxNCAwLjQ4My0wLjU3M3MwLjUyOCAwLjE2MiAwLjU0OSAwLjQ0MWwwLjMwNiA0LjExNmMwLjAyMSAwLjI3Ni0wLjE5NSAwLjUzNC0wLjQ4IDAuNTczIiBmaWxsPSIjZmJkOWJkIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzMy45NTcgNDEyLjY2KSI+CjxwYXRoIGQ9Im0wIDAgMC4xMzUgMS43NzMgNS44NDctMC44NC0wLjEzNS0xLjc3M2MtMC41NjQtNS4zMzEtNi41MS01LjYyOC01Ljg0NyAwLjg0IiBmaWxsPSIjZmJkOWJkIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzNC4wMjYgNDEzLjkxKSI+CjxwYXRoIGQ9Im0wIDAgMS4yNjYgMTYuOTk4YzEuMDkyIDQuNTA2IDcuMzUgNC40MDEgNi40OTgtMS4xODJsLTEuOTY4LTE2LjYzNXoiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDkuODczIDQ1NC41NikiPgo8cGF0aCBkPSJtMCAwLTMuNTMxLTI0Yy0wLjQyOS0yLjkyOC02LjI2MS0xLjMyMy02LjIwNCAxLjM4bDAuNDYyIDIxLjljMC4xNDcgNy4wNDQgMTAuMjQ1IDcuMzM4IDkuMjczIDAuNzIiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDcuMzUwOSA0MTQuNDIpIj4KPHBhdGggZD0ibTAgMGMwLjIzNyAwLjE1OSAwLjUyOC0wLjE2MiAwLjU1Mi0wLjQ0MWwwLjMwOS00LjExNmMwLjAxNS0wLjI3Ni0wLjI0OS0wLjQxNC0wLjQ4Ni0wLjU3My0wLjIzNC0wLjE1OS0wLjUzMSAwLjE2Mi0wLjU0OSAwLjQ0MWwtMC4zMDkgNC4xMTZjLTAuMDIxIDAuMjc2IDAuMjAxIDAuNTM0IDAuNDgzIDAuNTczIiBmaWxsPSIjZmJkOWJkIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3LjkxMSA0MTIuNjYpIj4KPHBhdGggZD0ibTAgMC0wLjEzNSAxLjc3My01Ljg0Ny0wLjg0IDAuMTM1LTEuNzczYzAuNTY3LTUuMzMxIDYuNTEtNS42MjggNS44NDcgMC44NCIgZmlsbD0iI2ZiZDliZCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNy44NDIzIDQxMy45MSkiPgo8cGF0aCBkPSJtMCAwLTEuMjYzIDE2Ljk5OGMtMS4wOTIgNC41MDYtNy4zNTMgNC40MDEtNi41MDEtMS4xODJsMS45NjgtMTYuNjM1eiIgZmlsbD0iI2ZiZDliZCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOC44NTgxIDQxNy43NikiPgo8cGF0aCBkPSJtMCAwIDAuOS0zNC4wOTVoMjIuNTE4bDAuOTY2IDM0LjA5NS0xMi4zMzkgMTUuNDUzeiIgZmlsbD0iI2NjMWI3NCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzAuMTQ1IDM2MC45OCkiPgo8cGF0aCBkPSJtMCAwYzIuMDYxLTIuOTkxIDQuODEyLTQuNzA3IDUuNDk5LTYuODY0IDAuMzg3LTEuMjE4IDAuMDk5LTEuODc4LTEuMTQtMi4wMzEtNS4zMzEtMC42Ni02Ljg3OSAxLjA3Ny04Ljc3NSAxLjYxMS0zLjI3OSAwLjkxOC0zLjM2MyAyLjgwNS0yLjAzNyA3LjI4NCAxLjMyOSA0LjQ3NiA0Ljc5MSAyLjc5MyA2LjQ1MyAwIiBmaWxsPSIjZmJkOWJkIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg4LjIwMDggMzU2LjcpIj4KPHBhdGggZD0ibTAgMGMtMC44MDQtMC44NjctMS40NDYtMS42ODktMS43MzEtMi41ODktMS4wMDUtMy4xNDcgMS44LTMuMjMxIDQuMDk1LTIuOTM0IDMuMDU0IDAuMzk2IDQuMzI5IDIuMDk0IDUuODIgMi41MTcgMi45NDMgMC44MjUgMy4zMTIgMi40MyAyLjM5NCA1Ljk5Ny0wLjEyOS0zLjExMS0zLjAzNi0zLjk1Ny02LjI2Ny01LjQ5LTMuMjI4LTEuNTMtNS44MzItMC4wMTgtNC4zMTEgMi40OTkiIGZpbGw9IiNjYzFiNzQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMzLjkxMyAzNTYuNykiPgo8cGF0aCBkPSJtMCAwYzAuODAxLTAuODY3IDEuNDQ2LTEuNjg5IDEuNzMxLTIuNTg5IDEuMTQ5LTMuNjAzLTIuOTQ2LTMuMzMtNS4yNTktMi43MDMtMi4yNDcgMC42MDktMy4zNzIgMS45MjMtNC42NTYgMi4yODYtMi45NDYgMC44MjUtMy4zMTIgMi40My0yLjM5NCA1Ljk5NyAwLjEyMy0zLjExMSAzLjAzNi0zLjk1NyA2LjI2Ny01LjQ5IDMuMjMxLTEuNTMgNS44MzItMC4wMTggNC4zMTEgMi40OTkiIGZpbGw9IiNjYzFiNzQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIxLjAxOCA0MTcuNzYpIj4KPHBhdGggZD0ibTAgMGgtMTIuMTU5bC0xLjk5MiAyOS4yOTUgOC41MjMgMTIuMjg4aDExLjI1OWw4LjIxMS0xMi4yODgtMS42ODMtMjkuMjk1eiIgZmlsbD0iI2NjMWI3NCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjYuNjQ4IDQ3My45NSkiPgo8cGF0aCBkPSJtMCAwdi0xNC42MDFjMC05LjE1LTExLjI1OS04Ljk2Ny0xMS4yNTkgMHYxNC42MDFjMCA3LjQ0NiAxMS4yNTkgNy40NDYgMTEuMjU5IDAiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI2LjY0OCA0NzMuOTUpIj4KPHBhdGggZD0ibTAgMHYtOS4yMzdjLTIuMTMtMS42NjUtNC4xODUtMi41OTgtNS42MzEtMi41OTgtMS40NDMgMC0zLjQ5OCAwLjkzMy01LjYyOCAyLjU5OHY5LjIzN2MwIDcuNDQ2IDExLjI1OSA3LjQ0NiAxMS4yNTkgMCIgZmlsbD0iI2VjYzJhMCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjEuMDE4IDQ2NC40KSI+CjxwYXRoIGQ9Ik0gMCwwIEMgLTMuNjY5LDAgLTExLjQxMiw1Ljc2MyAtMTMuODA2LDE0LjAxOSAtMTYuMjIxLDIyLjM1MyAtMTEuNjcsMzQuMzA4IDAsMzQuMzA4IDExLjY2NywzNC4zMDggMTYuMjE4LDIyLjM1MyAxMy44MDMsMTQuMDE5IDExLjQwOSw1Ljc2MyAzLjY2NiwwIDAsMCIgZmlsbD0iI2ZiZDliZCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTYuNiA0NzIuNzEpIj4KPHBhdGggZD0ibTAgMGMxLjg2OSAxLjgwNiAzLjMyNyAwLjQ1NiA0LjQxOSAwLjQ1NiAxLjA4OSAwIDIuNTQ3IDEuMzUzIDQuNDEzLTAuNDU2LTEuMDA1LTQuNzctNy41LTQuOTE3LTguODMyIDAiIGZpbGw9IiNmZjM4NmEiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE3LjE3NSA0NzIuNDcpIj4KPHBhdGggZD0iTSAwLDAgQyAxLjAyMywwLjI2MSA2LjIyMiwwLjMxMiA3LjY4MywwLjA1NyA2LjQ3NywtMi4xNjMgMS4wMjMsLTIuMDM3IDAsMCIgZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTYuNiA0NzIuNzEpIj4KPHBhdGggZD0ibTAgMGMxLjg2OSAxLjgwNiAzLjMyNyAwLjQ1NiA0LjQxOSAwLjQ1NiAxLjA4OSAwIDIuNTQ3IDEuMzUzIDQuNDEzLTAuNDU2LTIuODU2LTEuNDA3LTYuOTA5LTAuNzUtOC44MzIgMCIgZmlsbD0iI2ZmMzg2YSIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNC45MDcxIDQ4My40NSkiPgo8cGF0aCBkPSJtMCAwYzEuMTc5IDAuNTA3IDIuODQ3LTAuNzM1IDMuNzIzLTIuNzc1czAuNjMtNC4xMDQtMC41NDktNC42MTFjLTEuMTgyLTAuNTA0LTIuODQ3IDAuNzM4LTMuNzIgMi43NzgtMC44NzkgMi4wMzctMC42MyA0LjEwMSAwLjU0NiA0LjYwOCIgZmlsbD0iI2ZiZDliZCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzcuNDUgNDgzLjQ1KSI+CjxwYXRoIGQ9Im0wIDBjMS4xNzktMC41MDcgMS40MjUtMi41NjggMC41NTItNC42MDgtMC44NzktMi4wNC0yLjU0NC0zLjI4Mi0zLjcyNi0yLjc3Mi0xLjE3NiAwLjUwNC0xLjQyNSAyLjU2OC0wLjU0OSA0LjYwNSAwLjg3NiAyLjA0MyAyLjU0NCAzLjI4NSAzLjcyMyAyLjc3NSIgZmlsbD0iI2ZiZDliZCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzUuOTM2IDQ3OC41NykiPgo8cGF0aCBkPSJtMCAwYzQuNDI4IDE4Ljk5LTguOTQzIDIyLjIyMS0xNi43NDYgMjIuMjIxLTguNzg3IDAtMTUuNDExLTEwLjQyOC0xMy45MjktMjIuNTcyIDQuNjg5IDIuODI2IDguODE3IDguNDA2IDE5LjA2NSAxNy41MTEtMS40OTEtMi42NzMtNC4zOTUtNy41MzMtMTQuMjc0LTE2LjM0NCA1LjMxNi0wLjg3OSAxNS4yMTYgNS44MjMgMjAuNDk2IDEyLjgzMSAxLjI1Ny00Ljk4MyAzLjA3Mi0xMC40NCA1LjM4OC0xMy42NDciIGZpbGw9IiNhMTQwMGYiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIGNsaXAtcGF0aD0idXJsKCNiKSIgb3BhY2l0eT0iLjYwMDAxIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2EpIj4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjMyLjEyIDM0My40NykiPgo8cGF0aCBkPSJtMCAwYzIuMTAzLTMuMDQyIDQuODUxLTQuNTIxIDUuMjYyLTcuMTM3IDAuMjA0LTEuMjg3IDAuMDY2LTIuMzEtMS4xOTQtMi40NjYtNS40MjctMC42NzItNi4wMyAxLjUyNC03Ljk2MiAyLjA2NC0zLjM0MiAwLjkzOS00LjAyMyAyLjk3Ni0yLjY3MyA3LjUzOSAxLjM1MyA0LjU2MyA0Ljg3OCAyLjg0NCA2LjU2NyAwIiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjM1LjI5IDQwMS4yOSkiPgo8cGF0aCBkPSJtMCAwaC0yNC44MjVsMy4xNjUtNTcuODIyaDYuNTdsMS4zMzUgNDMuOThjMC4xMDUgMy40ODYgMi41NzQgMy41MDcgMi42ODIgMGwxLjMzOC00My45OGg2LjU2NHoiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMzMuNDUgNDM4Ljc3KSI+CjxwYXRoIGQ9Im0wIDAgNC40MDEtMjQuNDU2YzAuNTM0LTIuOTY0IDYuNDAyLTAuMTExIDYuMzIxIDEuNDA3bC0xLjI4MSAyMi4zMTRjLTAuNDA4IDcuMTY0LTEwLjY0NyA3LjQzNy05LjQ0MSAwLjczNSIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIwNS45OSA0NjcuMzgpIj4KPHBhdGggZD0ibTAgMGM1LjEzMyAxLjIzOS0zLjU0OS01LjkzNCAzLjM4NC0xMy42MTQgNi45MzktNy42ODYgMi4yOTUtMTcuNTgzLTQuNDctMTguOTcyLTIuODQ3LTAuNTg4IDYuMzI3IDUuNy0xLjg3OCAxMi45NDItNS4yMzggNC42MjMtNS45NyAxNy40NzUgMi45NjQgMTkuNjQ0IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjA4LjEgNDQzLjYyKSI+CjxwYXRoIGQ9Im0wIDAgMi4zNjQtNDIuMzMzaDI0LjgyOGwyLjM2NCA0Mi4zMzN6IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjM2LjgzIDM5Ny44OCkiPgo8cGF0aCBkPSJtMCAwYy0wLjI0IDAuMTYyLTAuNTQtMC4xNjItMC41NjEtMC40NDRsLTAuMzE1LTQuMTkxYy0wLjAyMS0wLjI4NSAwLjI1Mi0wLjQyNiAwLjQ5Mi0wLjU4NSAwLjI0LTAuMTYyIDAuNTM3IDAuMTU5IDAuNTYxIDAuNDQ0bDAuMzE1IDQuMTkxYzAuMDIxIDAuMjg1LTAuMjA0IDAuNTQ2LTAuNDkyIDAuNTg1IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjM2LjI1IDM5Ni4wOSkiPgo8cGF0aCBkPSJtMCAwIDAuMTM1IDEuOCA1Ljk1OC0wLjg1NS0wLjEzOC0xLjhjLTAuNTc2LTUuNDI3LTYuNjMtNS43MzMtNS45NTUgMC44NTUiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMzYuMzMgMzk3LjM2KSI+CjxwYXRoIGQ9Im0wIDAgMS4yODQgMTcuMzA3YzEuMTEzIDQuNTg3IDYuMzE4IDUuMTM2IDYuNTYxIDEuMDU5bC0xLjk0NC0xOS4xOTd6IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjM1LjI5IDQwMS4yOSkiPgo8cGF0aCBkPSJtMCAwLTAuOTIxLTE2Ljc3NmgtMjIuOTJsLTAuOTg0IDE2Ljc3NiAxMS41NTMgMzUuNTM4YzAuNTI4LTAuMDUxIDEuMDYyLTAuMDYzIDEuNTk2LTAuMDE1eiIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIxMy42MiAzNDMuNDcpIj4KPHBhdGggZD0ibTAgMGMtMi4xMDMtMy4wNDItNS4wNDktNC44MjEtNS40MjEtNy4yMTItMC4yMDEtMS4yODcgMC4zMjQtMi4zNjEgMS41ODEtMi41MTcgNS40MjctMC42NjkgNS44NjggMS45NzcgNy43OTcgMi41MTcgMy4zNDUgMC45MzkgMy45NiAyLjY0OSAyLjYxMyA3LjIxMi0xLjM1MyA0LjU2My00Ljg4MSAyLjg0NC02LjU3IDAiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMzUuOTYgMzM5LjExKSI+CjxwYXRoIGQ9Im0wIDBjMC44MTYtMC44ODIgMS40NzMtMS43MTYgMS43NjQtMi42MzEgMS4wMjMtMy4yMS0xLjgzOS0zLjI5NC00LjE3LTIuOTkxLTMuMTExIDAuNDAyLTQuNDA3IDIuMTM2LTUuOTI1IDIuNTU5LTMgMC44NDMtMy4zNzUgMi40NzgtMi40MzkgNi4xMDggMC4xMjYtMy4xNjggMy4wOS00LjAyOSA2LjM4MS01LjU4OSAzLjI4NS0xLjU2IDUuOTM3LTAuMDEyIDQuMzg5IDIuNTQ0IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjA5Ljc4IDMzOS4xMSkiPgo8cGF0aCBkPSJtMCAwYy0wLjgxNi0wLjg4Mi0xLjQ3My0xLjcxNi0xLjc2MS0yLjYzMS0xLjE3My0zLjY3MiAyLjk5Ny0zLjM5NiA1LjM1NS0yLjc1NyAyLjI4NiAwLjYyMSAzLjQzMiAxLjk1OSA0LjczNyAyLjMyNSAzIDAuODQzIDMuMzc1IDIuNDc4IDIuNDM5IDYuMTA4LTAuMTI2LTMuMTY4LTMuMDktNC4wMjktNi4zNzgtNS41ODlzLTUuOTQtMC4wMTItNC4zOTIgMi41NDQiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNDQuMTcgNDE1LjcyKSI+CjxwYXRoIGQ9Im0wIDAtNi41NTgtMS4wNTYtMC41MzEgNC44NjMgNi43MzggMS4xOTF6IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjEyLjExIDQzOC43NykiPgo8cGF0aCBkPSJtMCAwLTQuNDAxLTI0LjQ1NmMtMC41MzctMi45NjQtNi40MDgtMC4xMTEtNi4zMjEgMS40MDdsMS4yNzUgMjIuMzE0YzAuNDE0IDcuMTY0IDEwLjY1MyA3LjQzNyA5LjQ0NyAwLjczNSIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIwOC43MyAzOTcuODgpIj4KPHBhdGggZD0ibTAgMGMwLjI0IDAuMTYyIDAuNTQtMC4xNjIgMC41NjEtMC40NDRsMC4zMTItNC4xOTFjMC4wMjQtMC4yODUtMC4yNDktMC40MjYtMC40OTItMC41ODUtMC4yMzctMC4xNjItMC41NCAwLjE1OS0wLjU1OCAwLjQ0NGwtMC4zMTUgNC4xOTFjLTAuMDE4IDAuMjg1IDAuMjA0IDAuNTQ2IDAuNDkyIDAuNTg1IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjA5LjMxIDM5Ni4wOSkiPgo8cGF0aCBkPSJtMCAwLTAuMTM4IDEuOC01Ljk1Mi0wLjg1NSAwLjEzOC0xLjhjMC41NzYtNS40MjcgNi42MjctNS43MzMgNS45NTIgMC44NTUiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMDkuMjMgMzk3LjM2KSI+CjxwYXRoIGQ9Im0wIDAtMS4yODQgMTcuMzA3Yy0xLjExMyA0LjU4Ny02LjMyMSA1LjEzNi02LjU2NCAxLjA1OWwxLjk0Ny0xOS4xOTd6IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjAxLjM5IDQxNS43MikiPgo8cGF0aCBkPSJtMCAwIDYuNTU4LTEuMDU2IDAuNTI4IDQuODYzLTYuNzM1IDEuMTkxeiIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIwNy4xOCA0ODAuODEpIj4KPHBhdGggZD0ibTAgMGMyLjAzMSA0LjMxMSA2LjAwNiA3LjAxMSAxMS41NDcgNS45OTEgNC40MzQgNS40MjQgMTYuMTk0IDAuNTE5IDE4LjU5Ny00LjIzOSA5LjI3My0xOC4zNjYtNy4xMDQtMjguNjc0LTE0Ljg0NC0yOC42NzQtNi45NDgtM2UtMyAtMjIuNDE5IDExLjgzNS0xNS4zIDI2LjkyMiIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIyOC42MSA0NjAuOTgpIj4KPHBhdGggZD0ibTAgMHYtMjEuMjdjLTMuMTUzLTQuMTQzLTguMzEtNC4wMDItMTEuNDYzIDB2MjEuMjdjMCA3LjU4MSAxMS40NjMgNy41ODEgMTEuNDYzIDAiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMjguNjEgNDU4LjA5KSI+CjxwYXRoIGQ9Im0wIDB2LTkuNDAyYy0yLjE2OS0xLjY5OC00LjI2LTIuNjQ2LTUuNzMzLTIuNjQ2LTEuNDcgMC0zLjU2MSAwLjk0OC01LjczIDIuNjQ2djkuNDAyYzAgNy41ODQgMTEuNDYzIDcuNTg0IDExLjQ2MyAwIiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjM5LjE3IDQ2Ny4zOCkiPgo8cGF0aCBkPSJtMCAwYzguOTM0LTIuMTY5IDguMjAyLTE1LjAyMSAyLjk2NC0xOS42NDQtOC4yMDUtNy4yNDIgMC45NjktMTMuNTMtMS44NzgtMTIuOTQyLTYuNzY1IDEuMzg5LTExLjQwOSAxMS4yODYtNC40NyAxOC45NzIgNi45MzMgNy42OC0xLjc0OSAxNC44NTMgMy4zODQgMTMuNjE0IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjM3Ljg2IDQ2OC4wNykiPgo8cGF0aCBkPSJtMCAwYzEuODMgMS4yNzggMy43MiAxLjcyOCA0LjIyNCAxLjAwMiAwLjUwNy0wLjcyMy0wLjU3LTIuMzQtMi40LTMuNjE1LTEuODI0LTEuMjc1LTMuNzE3LTEuNzI4LTQuMjIxLTEuMDAyLTAuNTA0IDAuNzIgMC41NyAyLjM0IDIuMzk3IDMuNjE1IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjA4LjEyIDQ2OC4wNykiPgo8cGF0aCBkPSJtMCAwYzEuODMtMS4yNzUgMi45MDQtMi44OTggMi40LTMuNjE4LTAuNTA0LTAuNzIzLTIuMzk3LTAuMjczLTQuMjI0IDEuMDAyLTEuODMgMS4yNzUtMi45MDEgMi44OTgtMi4zOTcgMy42MTggMC41MDQgMC43MjMgMi4zOTEgMC4yNzMgNC4yMjEtMS4wMDIiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMjIuODggNDQ4LjM3KSI+CjxwYXRoIGQ9Ik0gMCwwIEMgLTMuNzMyLDAgLTExLjYxOSw1Ljg2OCAtMTQuMDUyLDE0LjI3NCAtMTYuNTE1LDIyLjc2MSAtMTEuODgsMzQuOTMyIDAsMzQuOTMyIDExLjg4MywzNC45MzIgMTYuNTE4LDIyLjc2MSAxNC4wNTIsMTQuMjc0IDExLjYxNiw1Ljg2OCAzLjczMiwwIDAsMCIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIxNi45MyA0NTguMzkpIj4KPHBhdGggZD0ibTAgMGMyLjUxNCAxLjgzOSA1LjE0MiAwLjc1IDYuMDE4IDAuNzUgMC44NzkgMCAzLjM2IDEuMDkyIDUuODgtMC43NS0xLjI1NC01LjA2NC0xMC4wMDItNS4xOTMtMTEuODk4IDAiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMTcgNDU4LjQyKSI+CjxwYXRoIGQ9Im0wIDBjMi4zMzcgMC44MjIgNC40MDQtMC43ODkgNS44NzEtMC43ODkgMS40NzMgMCAzLjU0MyAyLjE2NiA1Ljg4IDAuNzA4LTIuNzM5LTIuNzkzLTguOTk0LTIuNjM3LTExLjc1MSAwLjA4MSIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIxNi45MyA0NTguNDIpIj4KPHBhdGggZD0ibTAgMGMyLjUxNCAxLjAzOCA0LjM2OCAwLjI4MiA1LjgzNSAwLjI4MiAxLjQ3MyAwIDMuNTQ5IDAuNzU2IDYuMDYzLTAuMjgyLTIuNzM2LTEuNTY2LTkuMTQ0LTEuNTE1LTExLjg5OCAwIiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjE2Ljk0IDQ1OC40MSkiPgo8cGF0aCBkPSJtMCAwYzIuNTA1IDEuODE4IDQuNjU2IDAuNTU4IDYuMTIzIDAuNTU4IDEuNDcgMCAzLjIzNyAxLjI2NiA1Ljc1NC0wLjU3LTllLTMgLTAuMDMtMC4wMjEtMC4wNTQtMC4wMy0wLjA3OC0zLjIxIDAuMDU0LTguNDU3IDAuMDktMTEuODQ3IDAuMDkiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMzguODkgNDY3Ljc3KSI+CjxwYXRoIGQ9Im0wIDBjMS4xOTctMC41MTYgMS40NDktMi42MTYgMC41NTgtNC42OTItMC44OTEtMi4wNzMtMi41ODYtMy4zMzktMy43ODktMi44MjMtMS4yIDAuNTEzLTEuNDQ5IDIuNjEzLTAuNTYxIDQuNjkyIDAuODk0IDIuMDc2IDIuNTg5IDMuMzQyIDMuNzkyIDIuODIzIiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjA2LjI4IDQ2Ny43NykiPgo8cGF0aCBkPSJtMCAwYzEuMjAzIDAuNTE5IDIuODk4LTAuNzQ3IDMuNzkyLTIuODIzIDAuODg4LTIuMDc5IDAuNjM5LTQuMTc5LTAuNTYxLTQuNjkyLTEuMjAzLTAuNTE2LTIuODk4IDAuNzUtMy43ODkgMi44MjMtMC44OTEgMi4wNzYtMC42MzkgNC4xNzYgMC41NTggNC42OTIiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMzYuNzIgNDY0Ljk2KSI+CjxwYXRoIGQ9Im0wIDBjNy4wMDIgMTkuNzE5LTYuNTEgMjAuOTczLTE0LjQ1NyAyMC45NzMtOC45NDYgMC0xOS4zOTItNC41NjMtMTMuNjE0LTIxLjIwMSA4LjUzMiAwLjQyIDE2LjAyNiA1LjE3NSAyMy41NjIgMTUuMTY1IDEuMjg0LTUuMDc5IDIuMTUxLTExLjY3MyA0LjUwOS0xNC45MzciIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNTcuMDggNDQyLjc2KSI+CjxwYXRoIGQ9Im0wIDBjLTUuMDMxIDIxLjEyMy03LjcwNCA1Mi41MjEgMTQuMDU1IDUyLjUyMSAyMS43NTYgMCAyMC41OTgtMzEuMDgzIDE1LjM2Ni01My4xODctMTAuMTgyLTUuOTY3LTIwLjYzNC00LjMyLTI5LjQyMSAwLjY2NiIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE1OC4wMiA0MDQuMzMpIj4KPHBhdGggZD0ibTAgMC0xLjU0MiAxOC4yN2MtMS4xMjUgNC42NDQtNi45IDMuMzQyLTYuMDIxLTIuNDE1bDEuNTktMTYuNjk1eiIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE4NS4xMyA0MDQuMzMpIj4KPHBhdGggZD0ibTAgMCAxLjU1NyAxOS40NzNjMS4xMjUgNC42NDEgNi45NTEgMi41ODkgNi4wNjktMy4xNjhsLTEuNjUzLTE3LjE0NXoiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxODMuMDQgNDQ2LjI0KSI+CjxwYXRoIGQ9Im0wIDAgMy42MzktMjQuNzQxYzAuNDQ0LTMuMDE1IDYuMjI1LTIuMzM0IDYuMTY1IDAuNDU2bC0wLjI0NiAyMy41MzhjLTAuMTUzIDcuMjY2LTEwLjU2IDcuNTY2LTkuNTU4IDAuNzQ3IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTg2LjU5IDQ1MS4xNykiPgo8cGF0aCBkPSJtMCAwLTUuNzMzLTQyLjg2MWgtMTkuMjA5bC00Ljk4IDQyLjg2MXoiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNjIuMjcgMzQ5Ljc3KSI+CjxwYXRoIGQ9Im0wIDBjLTIuMTI3LTMuMDc4LTQuNzkxLTQuNDA3LTUuNDcyLTcuMzE3LTAuMy0xLjI4MSAwLjA0OC0xLjg4MSAxLjMyMy0yLjA0MyA1LjQ5Ni0wLjY3NSA2LjI5NCAxLjQ2MSA4LjI0NyAyLjAwNyAzLjM4MSAwLjk1MSAzLjkxOCAyLjczNiAyLjU1IDcuMzUzLTEuMzcxIDQuNjE3LTQuOTM4IDIuODgzLTYuNjQ4IDAiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNTkuMDYgNDA4LjMxKSI+CjxwYXRoIGQ9Im0wIDBoMjUuMTM0bC0zLjIwNy01OC41MzZoLTYuNjQ4bC0xLjM1MyA0NC41MjNjLTAuMTA4IDMuNTI4LTIuNjA3IDMuNTQ5LTIuNzE1IDBsLTEuMzUzLTQ0LjUyM2gtNi42NDh6IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTg1LjY0IDQwNC44NikiPgo8cGF0aCBkPSJtMCAwYy0wLjI0MyAwLjE2NS0wLjU0Ni0wLjE2Mi0wLjU2Ny0wLjQ1bC0wLjMxOC00LjI0MmMtMC4wMTgtMC4yODggMC4yNTUtMC40MjkgMC40OTgtMC41OTQgMC4yNDMtMC4xNjIgMC41NDYgMC4xNjUgMC41NjcgMC40NWwwLjMxOCA0LjI0MmMwLjAyMSAwLjI4OC0wLjIwNyAwLjU1OC0wLjQ5OCAwLjU5NCIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE4NS4wNiA0MDMuMDQpIj4KPHBhdGggZD0iTSAwLDAgMC4xMzgsMS44MjcgNi4xNjUsMC45NTcgNi4wMjcsLTAuODY0IEMgNS40NDUsLTYuMzYgLTAuNjg0LC02LjY2OSAwLDAiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNTcuNTEgNDA0Ljg2KSI+CjxwYXRoIGQ9Im0wIDBjMC4yNDMgMC4xNjUgMC41NDYtMC4xNjIgMC41NjctMC40NWwwLjMxOC00LjI0MmMwLjAyNC0wLjI4OC0wLjI1NS0wLjQyOS0wLjQ5NS0wLjU5NC0wLjI0Ni0wLjE2Mi0wLjU0NiAwLjE2NS0wLjU2NyAwLjQ1bC0wLjMyMSA0LjI0MmMtMC4wMjEgMC4yODggMC4yMDcgMC41NTggMC40OTggMC41OTQiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNTguMDkgNDAzLjA0KSI+CjxwYXRoIGQ9Im0wIDAtMC4xMzUgMS44MjctNi4wMy0wLjg3IDAuMTM4LTEuODIxYzAuNTg1LTUuNDk2IDYuNzE0LTUuODA1IDYuMDI3IDAuODY0IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTgxIDM0OS43NykiPgo8cGF0aCBkPSJtMCAwYzIuMTI3LTMuMDc4IDUuMDc5LTQuNzQzIDUuNTM1LTcuNDY3IDAuMjE2LTEuMjk5LTAuMjAxLTIuMTQ4LTEuNDc2LTIuMzA3LTUuNDk2LTAuNjc4LTYuMjU1IDEuOTUtOC4yMTEgMi40OTYtMy4zODQgMC45NTEtMy44NjQgMi42NjEtMi40OTkgNy4yNzggMS4zNzEgNC42MTcgNC45MzggMi44ODMgNi42NTEgMCIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE1OC4zOCAzNDUuMzcpIj4KPHBhdGggZD0ibTAgMGMtMC44MjUtMC44OTctMS40ODgtMS43NDMtMS43ODItMi42NjctMS4wMzgtMy4yNDYgMS44NTctMy4zMzMgNC4yMTgtMy4wMjcgMy4xNSAwLjQwNSA0LjQ2NCAyLjE2IDYgMi41ODkgMy4wMzYgMC44NTIgMy40MTQgMi41MDggMi40NjkgNi4xODMtMC4xMjktMy4yMDEtMy4xMjktNC4wNzQtNi40NTktNS42NTItMy4zMjctMS41ODQtNi4wMTItMC4wMTgtNC40NDYgMi41NzQiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxODQuODkgMzQ1LjM3KSI+CjxwYXRoIGQ9Im0wIDBjMC44MjUtMC44OTcgMS40ODgtMS43NDMgMS43ODUtMi42NjcgMS4xODItMy43MTctMy4wMzYtMy40MzgtNS40MjQtMi43OS0yLjMxMyAwLjYyNy0zLjQ3NCAxLjk4Ni00Ljc5NyAyLjM1Mi0zLjAzOSAwLjg1Mi0zLjQxNCAyLjUwOC0yLjQ2OSA2LjE4MyAwLjEyOS0zLjIwMSAzLjEyOS00LjA3NCA2LjQ1Ni01LjY1MiAzLjMzLTEuNTg0IDYuMDE1LTAuMDE4IDQuNDQ5IDIuNTc0IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTYwLjExIDQ0Ni4yNCkiPgo8cGF0aCBkPSJtMCAwLTMuNjM2LTI0Ljc0MWMtMC40NDctMy4wMTUtNi40NTYtMS4zNjUtNi4zOTkgMS40MjVsMC40NzQgMjIuNTY5YzAuMTUzIDcuMjY2IDEwLjU2MyA3LjU2NiA5LjU2MSAwLjc0NyIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE3OS44NSA0MzYuNjUpIj4KPHBhdGggZD0ibTAgMCA2LjA0OCAyLjA3OS0xLjY5OC0zMC40MjNoLTI1LjEzN2wtMS42NzEgMjkuOTczLTYuOTM5IDIuNDg0IDAuMDk5IDQuNzM0YzEyLjI5MS0zLjc0NCAxMi41ODUtMTYuNDI1IDI5LjI5OC04Ljg0NyIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE1Ni42NyA0NTEuMTcpIj4KPHBhdGggZD0ibTAgMGM2LjA5LTAuODA3IDE3LjgwNS0xMS4wNDYgMzUuOTI4LTUuNjczLTIuNDY2LTYuNTI1LTM5LjUzNy0zMC42My0zNS45MjggNS42NzMiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxODMuOTUgNDQwLjAyKSI+CjxwYXRoIGQ9Im0wIDAgMi42MDEtMTcuNzQ1czYuMjg1LTIuMTI3IDYuMzI3LTEuNjM1LTAuMjg1IDI0Ljg2MS0wLjI4NSAyNC44NjF6IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTU4LjYyIDQxNi4xNykiPgo8cGF0aCBkPSJtMCAwIDEuNTYtMzUuOTA0aDIzLjIwNWwxLjI0OCAzNS45MDR6IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTU3LjI0IDQxNC43NykiPgo8cGF0aCBkPSJtMCAwLTAuOTgxIDEwLjA0NGMtMS4xMjggNC42NDQtNi45NzIgMi44NTMtNi4wOTMtMi45MDRsMC42LTcuNjIzeiIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE4NS44OCA0MTQuNzcpIj4KPHBhdGggZD0ibTAgMCAwLjg2NCA5LjcwNWMxLjEyNSA0LjY0MSA3LjAxNCAxLjkxNyA2LjEzNS0zLjg0bC0wLjUyOC02LjM0OHoiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNzcuNDMgNDY2LjM3KSI+CjxwYXRoIGQ9Im0wIDB2LTE3LjI3NGMtMy4xOTItNC4xOTQtOC40MTUtNC4wNS0xMS42MDcgMHYxNy4yNzRjMCA3LjY4IDExLjYwNyA3LjY3NyAxMS42MDcgMCIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE3Ny40MyA0NjMuNDQpIj4KPHBhdGggZD0ibTAgMHYtOS41MTZjLTIuMTk2LTEuNzE2LTQuMzE0LTIuNjgyLTUuODAyLTIuNjgyLTEuNDkxIDAtMy42MDkgMC45NjYtNS44MDUgMi42ODJ2OS41MTZjMCA3LjY4IDExLjYwNyA3LjY4IDExLjYwNyAwIiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTcxLjYzIDQ1My42MSkiPgo8cGF0aCBkPSJtMCAwYy0zLjc3NyAwLTExLjc1NyA1Ljk0LTE0LjIyNiAxNC40NDgtMi40OTYgOC41ODkgMi4xOTkgMjAuOTEzIDE0LjIyNiAyMC45MTNzMTYuNzIyLTEyLjMyNCAxNC4yMjYtMjAuOTEzYy0yLjQ2My04LjUxMS0xMC40NDktMTQuNDQ4LTE0LjIyNi0xNC40NDgiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNjUuNjEgNDYzLjc1KSI+CjxwYXRoIGQ9Im0wIDBjMi41NDcgMS44NjMgNS4yMDggMC43NjIgNi4wOTYgMC43NjIgMC44OTEgMCAzLjQwMiAxLjEwNCA1Ljk0OS0wLjc2Mi0xLjI2Ni01LjEyNC0xMC4xMjUtNS4yNTMtMTIuMDQ1IDAiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNjUuNjggNDYzLjc4KSI+CjxwYXRoIGQ9Im0gMCwwIGMgMi4zNjQsMC44MzQgNC40NTgsLTAuODAxIDUuOTQzLC0wLjgwMSAxLjQ5MSwwIDMuNTg4LDIuMTk2IDUuOTUyLDAuNzE3IEMgOS4xMjMsLTIuOTA3IDIuNzksLTIuNzU3IDAsMCIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE2NS42MSA0NjMuNzgpIj4KPHBhdGggZD0ibTAgMGMyLjU0NyAxLjA1IDQuNDI1IDAuMjg4IDUuOTEzIDAuMjg4czMuNTg1IDAuNzYyIDYuMTMyLTAuMjg4Yy0yLjc2OS0xLjU4NC05LjI1Mi0xLjUzMy0xMi4wNDUgMCIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE2NS42MiA0NjMuNzcpIj4KPHBhdGggZD0ibTAgMGMyLjUzNSAxLjg0MiA0LjcxNiAwLjU2NCA2LjIwMSAwLjU2NHMzLjI3MyAxLjI4MSA1LjgyMy0wLjU4MmMtOWUtMyAtMC4wMjctMC4wMjEtMC4wNTQtMC4wMy0wLjA3OC0zLjI0NiAwLjA2LTguNTYyIDAuMDkzLTExLjk5NCAwLjA5NiIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE1NC4zIDQ3My4yNCkiPgo8cGF0aCBkPSJtMCAwYzEuMjEyIDAuNTIyIDIuOTMxLTAuNzU5IDMuODM0LTIuODU5IDAuOS0yLjEgMC42NTEtNC4yMjctMC41NjctNC43NDktMS4yMTItMC41MjItMi45MzEgMC43NTYtMy44MzQgMi44NTktMC45IDIuMS0wLjY1MSA0LjIyNyAwLjU2NyA0Ljc0OSIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE4Ny44NCA0NzMuMjQpIj4KPHBhdGggZD0ibTAgMGMxLjIxOC0wLjUyMiAxLjQ3My0yLjY0OSAwLjU2Ny00Ljc0OS0wLjktMi4xLTIuNjIyLTMuMzgxLTMuODM0LTIuODU5LTEuMjE4IDAuNTIyLTEuNDczIDIuNjQ5LTAuNTY3IDQuNzQ5IDAuOSAyLjEwMyAyLjYyMiAzLjM4NCAzLjgzNCAyLjg1OSIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE4NS42NCA0NzAuMzkpIj4KPHBhdGggZD0ibTAgMGM3LjA4OSAxOS45NjgtNi41OTEgMjEuMjM3LTE0LjYzMSAyMS4yMzctOS4wNiAwLTE5LjYzOC00LjYyMy0xMy43ODUtMjEuNDY4IDguNjM0IDAuNDI2IDE2LjIyNCA1LjI0MSAyMy44NTMgMTUuMzU0IDEuMjk5LTUuMTM5IDIuMTc1LTExLjgxNyA0LjU2My0xNS4xMjMiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMjAuODEgNDQ4LjIyKSI+CjxwYXRoIGQ9Im0wIDBjLTkuMzE1LTAuMTM1LTEwLjcyMiAxNi44LTE0Ljk0OSAyOC44NTQtNi4yNzMgMTcuODg2IDE0LjU2NSAyNy45OTMgMjEuNTcgMjEuNDk1IDcuNDUyIDAgMTIuNTUyLTE0LjI4MyA4LjIxNy0yNC42My01LjQ1Ny0xMy4wMi03Ljg2My0yNi42NjctMTQuODM4LTI1LjcxOSAwIDAgNC4xMjIgMC4xNzQgMCAwIiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTExLjExIDM1NS41MikiPgo8cGF0aCBkPSJtMCAwYy0yLjEyMS0zLjA3Mi00Ljk0NC00LjgzNi01LjY0OS03LjA1My0wLjM5OS0xLjI1MS0wLjEwMi0xLjkyOSAxLjE3LTIuMDg1IDUuNDc1LTAuNjc4IDcuMDYyIDEuMTA3IDkuMDE1IDEuNjU2IDMuMzY2IDAuOTQyIDMuNDU2IDIuODggMi4wOTEgNy40ODItMS4zNjUgNC41OTktNC45MiAyLjg3MS02LjYyNyAwIiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTA3LjkxIDQxMy44NSkiPgo8cGF0aCBkPSJtMCAwaDI1LjA0N2wtMy4xOTUtNTguMzMyaC02LjYyN2wtMS4zNDcgNDQuMzY3Yy0wLjExMSAzLjUxNi0yLjU5OCAzLjUzNy0yLjcwOSAwbC0xLjM0Ny00NC4zNjdoLTYuNjI3eiIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzNS4zNCA0NTYuNTcpIj4KPHBhdGggZD0ibTAgMC0yLjM4NS00Mi43MTRoLTI1LjA0N2wtMi4zODggNDIuNzE0eiIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzMS42OCA0NTEuNjUpIj4KPHBhdGggZD0ibTAgMCAzLjYyNC0yNC42NTFjMC40NDEtMy4wMDkgNi40MzItMS4zNjIgNi4zNzUgMS40MTZsLTAuNDcxIDIyLjQ5N2MtMC4xNTMgNy4yMzMtMTAuNTI3IDcuNTM2LTkuNTI4IDAuNzM4IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTM0LjI3IDQxMC40MSkiPgo8cGF0aCBkPSJtMCAwYy0wLjI0IDAuMTYyLTAuNTQ2LTAuMTY1LTAuNTY3LTAuNDUzbC0wLjMxMi00LjIyN2MtMC4wMjEtMC4yODUgMC4yNTItMC40MjYgMC40OTUtMC41OTEgMC4yMzctMC4xNjIgMC41NDMgMC4xNjggMC41NjQgMC40NTNsMC4zMTUgNC4yMjdjMC4wMjEgMC4yODgtMC4yMDEgMC41NTItMC40OTUgMC41OTEiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMzMuNjkgNDA4LjYxKSI+CjxwYXRoIGQ9Ik0gMCwwIDAuMTM4LDEuODIxIDYuMTQ0LDAuOTU3IDYuMDA2LC0wLjg2MSBDIDUuNDI3LC02LjMzOSAtMC42ODEsLTYuNjQ1IDAsMCIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzMy43NiA0MDkuODkpIj4KPHBhdGggZD0ibTAgMCAxLjI5OSAxNy40NjNjMS4xMjIgNC42MjYgNy41NTEgNC41MjEgNi42NzUtMS4yMThsLTIuMDIyLTE3LjA4NXoiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMDguOTUgNDUxLjY1KSI+CjxwYXRoIGQ9Im0wIDAtMy42MjctMjQuNjUxYy0wLjQ0MS0zLjAwOS02LjQzMi0xLjM2Mi02LjM3MiAxLjQxNmwwLjQ3NCAyMi40OTdjMC4xNSA3LjIzMyAxMC41MjEgNy41MzYgOS41MjUgMC43MzgiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMDYuMzYgNDEwLjQxKSI+CjxwYXRoIGQ9Im0wIDBjMC4yNDMgMC4xNjIgMC41NDMtMC4xNjUgMC41NjctMC40NTNsMC4zMTUtNC4yMjdjMC4wMTgtMC4yODUtMC4yNTItMC40MjYtMC40OTgtMC41OTEtMC4yNC0wLjE2Mi0wLjU0MyAwLjE2OC0wLjU2NCAwLjQ1M2wtMC4zMTUgNC4yMjdjLTAuMDIxIDAuMjg4IDAuMjA0IDAuNTUyIDAuNDk1IDAuNTkxIiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTA2Ljk0IDQwOC42MSkiPgo8cGF0aCBkPSJtMCAwLTAuMTM4IDEuODIxLTYuMDA2LTAuODY0IDAuMTM4LTEuODE4YzAuNTg1LTUuNDc4IDYuNjg3LTUuNzg0IDYuMDA2IDAuODYxIiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTA2Ljg3IDQwOS44OSkiPgo8cGF0aCBkPSJtMCAwLTEuMjk2IDE3LjQ2M2MtMS4xMjUgNC42MjYtNy41NTQgNC41MjEtNi42NzgtMS4yMThsMi4wMjItMTcuMDg1eiIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEwNy45MSA0MTMuODUpIj4KPHBhdGggZD0ibTAgMCAwLjkyNy0zNS4wMjJoMjMuMTI3bDAuOTkzIDM1LjAyMi0xMi42NzUgMTUuODc2eiIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyOS43OCAzNTUuNTIpIj4KPHBhdGggZD0ibTAgMGMyLjExOC0zLjA3MiA0Ljk0MS00LjgzNiA1LjY0OS03LjA1MyAwLjM5OS0xLjI1MSAwLjEwMi0xLjkyOS0xLjE3LTIuMDg1LTUuNDc1LTAuNjc4LTcuMDY4IDEuMTA3LTkuMDE1IDEuNjU2LTMuMzY5IDAuOTQyLTMuNDU2IDIuODgtMi4wOTEgNy40ODIgMS4zNjIgNC41OTkgNC45MiAyLjg3MSA2LjYyNyAwIiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTA3LjI0IDM1MS4xMykiPgo8cGF0aCBkPSJtMCAwYy0wLjgyNS0wLjg5MS0xLjQ4NS0xLjczNy0xLjc3OS0yLjY1OC0xLjAzMi0zLjIzNCAxLjg1MS0zLjMyMSA0LjIwNi0zLjAxNSAzLjE0MSAwLjQwNSA0LjQ0OSAyLjE1MSA1Ljk3OSAyLjU4MyAzLjAyNCAwLjg0OSAzLjQwMiAyLjQ5OSAyLjQ2IDYuMTYyLTAuMTMyLTMuMTk1LTMuMTE3LTQuMDY1LTYuNDM4LTUuNjM3LTMuMzE1LTEuNTc1LTUuOTkxLTAuMDE4LTQuNDI4IDIuNTY1IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTMzLjY1IDM1MS4xMykiPgo8cGF0aCBkPSJtMCAwYzAuODIyLTAuODkxIDEuNDg1LTEuNzM3IDEuNzc5LTIuNjU4IDEuMTc5LTMuNzAyLTMuMDI3LTMuNDIzLTUuNDAzLTIuNzc4LTIuMzA3IDAuNjI0LTMuNDYyIDEuOTc3LTQuNzgyIDIuMzQ2LTMuMDI3IDAuODQ5LTMuNDA1IDIuNDk5LTIuNDYgNi4xNjIgMC4xMjYtMy4xOTUgMy4xMTctNC4wNjUgNi40MzgtNS42MzcgMy4zMTgtMS41NzUgNS45OTEtMC4wMTggNC40MjggMi41NjUiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMjAuNCA0MTMuODUpIj4KPHBhdGggZD0ibTAgMGgtMTIuNDkybC0yLjA0MyAzMC4wMTUgOC43NTQgMTIuNjk5aDExLjU2NWw4LjU4LTEyLjY5OS0xLjg3NS0zMC4wMTV6IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTI2LjE4IDQ3MS41NikiPgo8cGF0aCBkPSJtMCAwdi0xNWMwLTkuMzk2LTExLjU2NS05LjIxLTExLjU2NSAwdjE1YzAgNy42NSAxMS41NjUgNy42NSAxMS41NjUgMCIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyNi4xOCA0NzEuNTYpIj4KPHBhdGggZD0ibTAgMHYtOS40ODljLTIuMTg3LTEuNzEtNC4yOTktMi42NjctNS43ODQtMi42NjctMS40ODIgMC0zLjU5NCAwLjk1Ny01Ljc4MSAyLjY2N3Y5LjQ4OWMwIDcuNjUgMTEuNTY1IDcuNjUgMTEuNTY1IDAiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMjAuNCA0NjEuNzYpIj4KPHBhdGggZD0ibTAgMGMtMy43NjggMC0xMS43MjEgNS45MjItMTQuMTgxIDE0LjQtMi40ODEgOC41NjIgMi4xOTYgMjAuODQxIDE0LjE4MSAyMC44NDFzMTYuNjU5LTEyLjI3OSAxNC4xNzgtMjAuODQxYy0yLjQ2LTguNDc4LTEwLjQxMy0xNC40LTE0LjE3OC0xNC40IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTE1Ljg2IDQ3MC4zKSI+CjxwYXRoIGQ9Ik0gMCwwIEMgMS45MiwxLjg1NyAzLjQxNywwLjQ2OCA0LjUzOSwwLjQ2OCA1LjY1OCwwLjQ2OCA3LjE1NSwxLjg2IDkuMDc1LDAgOC4wNCwtNC44OTkgMS4zNjgsLTUuMDUyIDAsMCIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDExNi40NSA0NzAuMDQpIj4KPHBhdGggZD0iTSAwLDAgQyAxLjA1LDAuMjcgNi4zOSwwLjMyMSA3Ljg5MywwLjA2IDYuNjU0LC0yLjIyMyAxLjA1LC0yLjA5NCAwLDAiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMTUuODYgNDcwLjMpIj4KPHBhdGggZD0ibTAgMGMxLjkyIDEuODU3IDMuNDE3IDAuNDY4IDQuNTM5IDAuNDY4IDEuMTE5IDAgMi42MTYgMS4zOTIgNC41MzYtMC40NjgtMi45MzQtMS40NDYtNy4xMDEtMC43NzEtOS4wNzUgMCIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEwMy44NSA0ODEuMzMpIj4KPHBhdGggZD0ibTAgMGMxLjIxMiAwLjUxOSAyLjkyNS0wLjc1NiAzLjgyNS0yLjg1IDAuODk3LTIuMDk0IDAuNjQ4LTQuMjE1LTAuNTY3LTQuNzM3LTEuMjEyLTAuNTE5LTIuOTIyIDAuNzU5LTMuODE5IDIuODUzLTAuOTAzIDIuMDk0LTAuNjQ4IDQuMjE1IDAuNTYxIDQuNzM0IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTM3LjI4IDQ4MS4zMykiPgo8cGF0aCBkPSJtMCAwYzEuMjEyLTAuNTE5IDEuNDY0LTIuNjM3IDAuNTY3LTQuNzM0LTAuOTAzLTIuMDk0LTIuNjEzLTMuMzcyLTMuODI4LTIuODQ3LTEuMjA2IDAuNTE5LTEuNDYxIDIuNjQtMC41NjQgNC43MzEgMC45IDIuMDk3IDIuNjEzIDMuMzcyIDMuODI1IDIuODUiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMzUuNzMgNDc2LjMxKSI+CjxwYXRoIGQ9Im0wIDBjNC41NDggMTkuNTA5LTkuMTg2IDIyLjgyNy0xNy4yMDIgMjIuODI3LTkuMDI3IDAtMTMuODI3LTEwLjUwNi0xMi4zMDMtMjIuOTggNC44MTUgMi45MDQgNy4wNSA4LjQyNyAxNy41NzcgMTcuNzgxLTEuNTMtMi43NDgtNC41MTItNy43MzctMTQuNjYxLTE2Ljc5MSA1LjQ2LTAuOSAxNS42MyA1Ljk4MiAyMS4wNTQgMTMuMTgyIDEuMjkzLTUuMTE4IDMuMTU2LTEwLjcyNSA1LjUzNS0xNC4wMTkiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg4MC45NiAzNTIuOTcpIj4KPHBhdGggZD0ibTAgMGMyLjE3NS0zLjE0NCA1LjAxNi00LjY3NyA1LjQ0Mi03LjM4IDAuMjEtMS4zMzIgMC4wNjktMi4zODgtMS4yMzYtMi41NS01LjYxMy0wLjY5My02LjIzNCAxLjU3NS04LjIzMiAyLjEzMy0zLjQ1NiAwLjk3Mi00LjE2MSAzLjA4MS0yLjc2MyA3Ljc5N3M1LjA0MyAyLjk0MyA2Ljc4OSAwIiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoODQuMjM4IDQxMi43NikiPgo8cGF0aCBkPSJtMCAwaC0yNS42NzFsMy4yNzYtNTkuNzg3aDYuNzkybDEuMzggNDUuNDc0YzAuMTA4IDMuNjAzIDIuNjYxIDMuNjI0IDIuNzcyIDBsMS4zODMtNDUuNDc0aDYuNzg5eiIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDgyLjMzMyA0NTEuNTIpIj4KPHBhdGggZD0ibTAgMCA0LjU1MS0yNS4yODdjMC41NTItMy4wNjYgNi42MjEtMC4xMTcgNi41MzQgMS40NTVsLTEuMzIzIDIzLjA3Yy0wLjQyMyA3LjQxLTExLjAwNyA3LjY5Mi05Ljc2MiAwLjc2MiIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDUzLjk0NCA0ODEuMTEpIj4KPHBhdGggZD0ibTAgMGM1LjMwNyAxLjI4NC0zLjY2OS02LjEzOCAzLjUwMS0xNC4wNzkgNy4xNzMtNy45NDQgMi4zNzMtMTguMTgtNC42MjMtMTkuNjE3LTIuOTQ2LTAuNjA2IDYuNTQzIDUuODk1LTEuOTQxIDEzLjM4My01LjQxOCA0Ljc4Mi02LjE3NCAxOC4wNjkgMy4wNjMgMjAuMzEzIiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNTYuMTIyIDQ1Ni41MykiPgo8cGF0aCBkPSJtMCAwIDIuNDQ1LTQzLjc3NmgyNS42NzFsMi40NDUgNDMuNzc2eiIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDg1LjgyNSA0MDkuMjMpIj4KPHBhdGggZD0ibTAgMGMtMC4yNDkgMC4xNjUtMC41NTgtMC4xNjgtMC41NzktMC40NTlsLTAuMzI3LTQuMzM1Yy0wLjAyMS0wLjI5NCAwLjI2MS0wLjQzOCAwLjUwNy0wLjYwNiAwLjI1Mi0wLjE2NSAwLjU1OCAwLjE2OCAwLjU4MiAwLjQ2MmwwLjMyNCA0LjMzMmMwLjAyNCAwLjI5NC0wLjIxIDAuNTY3LTAuNTA3IDAuNjA2IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoODUuMjMxIDQwNy4zOCkiPgo8cGF0aCBkPSJNIDAsMCAwLjE0MSwxLjg2IDYuMywwLjk3OCA2LjE1OSwtMC44ODUgQyA1LjU2MiwtNi40OTUgLTAuNjk5LC02LjgxIDAsMCIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDg1LjMwNyA0MDguNykiPgo8cGF0aCBkPSJtMCAwIDEuMzI5IDE3Ljg5OGMxLjE0OSA0Ljc0IDYuNTMxIDUuMzEgNi43ODMgMS4wOTJsLTIuMDEtMTkuODQ4eiIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDg0LjIzOCA0MTIuNzYpIj4KPHBhdGggZD0ibTAgMC0wLjk1MS0xNy4zNDZoLTIzLjcwM2wtMS4wMTcgMTcuMzQ2IDExLjk0OSAzNi43NDdjMC41NDYtMC4wNTEgMS4wOTgtMC4wNjYgMS42NDctMC4wMTV6IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNjEuODI3IDM1Mi45NykiPgo8cGF0aCBkPSJtMCAwYy0yLjE3NS0zLjE0NC01LjIyLTQuOTg2LTUuNjA3LTcuNDU4LTAuMjA3LTEuMzI5IDAuMzM2LTIuNDM5IDEuNjM4LTIuNjA0IDUuNjEtMC42OSA2LjA2NiAyLjA0NiA4LjA2MSAyLjYwNCAzLjQ1OSAwLjk3MiA0LjA5NSAyLjc0MiAyLjcgNy40NTgtMS4zOTggNC43MTYtNS4wNDYgMi45NDMtNi43OTIgMCIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDg0LjkzIDM0OC40NykiPgo8cGF0aCBkPSJtMCAwYzAuODQ2LTAuOTEyIDEuNTIxLTEuNzc2IDEuODIxLTIuNzIxIDEuMDU5LTMuMzE4LTEuODk2LTMuNDA1LTQuMzA4LTMuMDkzLTMuMjE5IDAuNDE3LTQuNTYgMi4yMTEtNi4xMjkgMi42NDktMy4wOTkgMC44Ny0zLjQ4NiAyLjU1OS0yLjUyIDYuMzE1IDAuMTI5LTMuMjc2IDMuMTk1LTQuMTY3IDYuNTk3LTUuNzgxIDMuMzk5LTEuNjExIDYuMTQxLTAuMDEyIDQuNTM5IDIuNjMxIiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNTcuODU3IDM0OC40NykiPgo8cGF0aCBkPSJtMCAwYy0wLjg0My0wLjkxMi0xLjUyMS0xLjc3Ni0xLjgyMS0yLjcyMS0xLjIxMi0zLjc5NSAzLjA5OS0zLjUxIDUuNTM4LTIuODUgMi4zNjEgMC42NDIgMy41NDYgMi4wMjUgNC44OTkgMi40MDYgMy4wOTkgMC44NyAzLjQ4OSAyLjU1OSAyLjUyIDYuMzE1LTAuMTI5LTMuMjc2LTMuMTk1LTQuMTY3LTYuNTk0LTUuNzgxLTMuNDAyLTEuNjExLTYuMTQ0LTAuMDEyLTQuNTQyIDIuNjMxIiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOTMuNDE5IDQyNy42OSkiPgo8cGF0aCBkPSJtMCAwLTYuNzgzLTEuMDkyLTAuNTQ2IDUuMDMxIDYuOTY2IDEuMjI3eiIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDYwLjI3IDQ1MS41MikiPgo8cGF0aCBkPSJtMCAwLTQuNTUxLTI1LjI4N2MtMC41NTUtMy4wNjYtNi42MjctMC4xMTctNi41MzcgMS40NTVsMS4zMiAyMy4wN2MwLjQyOSA3LjQxIDExLjAxMyA3LjY5MiA5Ljc2OCAwLjc2MiIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDU2Ljc3NyA0MDkuMjMpIj4KPHBhdGggZD0ibTAgMGMwLjI0OSAwLjE2NSAwLjU1OC0wLjE2OCAwLjU3OS0wLjQ1OWwwLjMyNC00LjMzNWMwLjAyNC0wLjI5NC0wLjI1OC0wLjQzOC0wLjUwNy0wLjYwNi0wLjI0OS0wLjE2NS0wLjU1OCAwLjE2OC0wLjU4MiAwLjQ2MmwtMC4zMjEgNC4zMzJjLTAuMDIxIDAuMjk0IDAuMjEgMC41NjcgMC41MDcgMC42MDYiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg1Ny4zNjggNDA3LjM4KSI+CjxwYXRoIGQ9Im0wIDAtMC4xNDEgMS44Ni02LjE1Ni0wLjg4MiAwLjE0MS0xLjg2M2MwLjU5Ny01LjYxIDYuODU1LTUuOTI1IDYuMTU2IDAuODg1IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNTcuMjk1IDQwOC43KSI+CjxwYXRoIGQ9Im0wIDAtMS4zMjkgMTcuODk4Yy0xLjE0OSA0Ljc0LTYuNTM3IDUuMzEtNi43ODYgMS4wOTJsMi4wMTMtMTkuODQ4eiIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQ5LjE4MyA0MjcuNjkpIj4KPHBhdGggZD0ibTAgMCA2Ljc4My0xLjA5MiAwLjU0MyA1LjAzMS02Ljk2MyAxLjIyN3oiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg1NS4xNjkgNDk0Ljk5KSI+CjxwYXRoIGQ9Im0wIDBjMi4xIDQuNDU4IDYuMjEgNy4yNDggMTEuOTQgNi4xOTUgNC41ODQgNS42MDcgMTYuNzQ2IDAuNTM0IDE5LjIzLTQuMzgzIDkuNTg4LTE4Ljk5My03LjM0Ny0yOS42NDktMTUuMzUxLTI5LjY0OS03LjE4Mi02ZS0zIC0yMy4xODEgMTIuMjM3LTE1LjgxOSAyNy44MzciIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3Ny4zMyA0NzQuNDkpIj4KPHBhdGggZD0ibTAgMHYtMjEuOTkzYy0zLjI2MS00LjI4NC04LjU5NS00LjE0LTExLjg1MyAwdjIxLjk5M2MwIDcuODM5IDExLjg1MyA3LjgzOSAxMS44NTMgMCIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDc3LjMzIDQ3MS41KSI+CjxwYXRoIGQ9Im0wIDB2LTkuNzJjLTIuMjQ0LTEuNzU4LTQuNDA0LTIuNzM5LTUuOTI4LTIuNzM5LTEuNTIxIDAtMy42ODQgMC45ODEtNS45MjUgMi43Mzl2OS43MmMwIDcuODQyIDExLjg1MyA3Ljg0MiAxMS44NTMgMCIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDg4LjI0OSA0ODEuMTEpIj4KPHBhdGggZD0ibTAgMGM5LjIzNy0yLjI0NCA4LjQ4MS0xNS41MzEgMy4wNjMtMjAuMzEzLTguNDg0LTcuNDg4IDEuMDA1LTEzLjk4OS0xLjk0MS0xMy4zODMtNi45OTYgMS40MzctMTEuNzk2IDExLjY3My00LjYyMyAxOS42MTcgNy4xNyA3Ljk0MS0xLjgwNiAxNS4zNjMgMy41MDEgMTQuMDc5IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoODYuODk0IDQ4MS44MikiPgo8cGF0aCBkPSJNIDAsMCBDIDEuODksMS4zMjMgMy44NDYsMS43ODUgNC4zNjgsMS4wMzUgNC44OSwwLjI4OCAzLjc3NywtMS4zODYgMS44ODcsLTIuNzAzIDAsLTQuMDIgLTEuOTU2LC00LjQ4OCAtMi40NzgsLTMuNzM4IC0zLC0yLjk5NCAtMS44ODcsLTEuMzIgMCwwIiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNTYuMTQ2IDQ4MS44MikiPgo8cGF0aCBkPSJtMCAwYzEuODktMS4zMTcgMy4wMDMtMi45OTcgMi40ODEtMy43NDEtMC41MTktMC43NDctMi40NzgtMC4yODItNC4zNjggMS4wMzUtMS44OSAxLjMyLTMgMi45OTctMi40NzggMy43NDQgMC41MjIgMC43NDQgMi40NzUgMC4yODIgNC4zNjUtMS4wMzgiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3MS40MDIgNDYxLjQ1KSI+CjxwYXRoIGQ9Im0wIDBjLTMuODU4IDAtMTIuMDEyIDYuMDY5LTE0LjUzMiAxNC43Ni0yLjU0NyA4Ljc3NSAyLjI0NyAyMS4zNiAxNC41MzIgMjEuMzZzMTcuMDc5LTEyLjU4NSAxNC41MzItMjEuMzZjLTIuNTIzLTguNjkxLTEwLjY3NC0xNC43Ni0xNC41MzItMTQuNzYiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg2NS4yNTEgNDcxLjgxKSI+CjxwYXRoIGQ9Im0wIDBjMi42MDEgMS45MDIgNS4zMTkgMC43NzQgNi4yMjUgMC43NzQgMC45MDkgMCAzLjQ3NCAxLjEzMSA2LjA3OC0wLjc3NC0xLjI5Ni01LjIzNS0xMC4zNDQtNS4zNy0xMi4zMDMgMCIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDY1LjMyNyA0NzEuODMpIj4KPHBhdGggZD0ibTAgMGMyLjQxNSAwLjg1MiA0LjU1NC0wLjgxNiA2LjA3Mi0wLjgxNiAxLjUyMSAwIDMuNjYzIDIuMjQxIDYuMDc4IDAuNzMyLTIuODMyLTIuODg2LTkuMy0yLjcyNy0xMi4xNSAwLjA4NCIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDY1LjI1MSA0NzEuODQpIj4KPHBhdGggZD0ibTAgMGMyLjYwMSAxLjA3MSA0LjUxOCAwLjI5NCA2LjAzNiAwLjI5NCAxLjUyMSAwIDMuNjY2IDAuNzc3IDYuMjY3LTAuMjk0LTIuODI5LTEuNjItOS40NTYtMS41NjYtMTIuMzAzIDAiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg2NS4yNjEgNDcxLjgyKSI+CjxwYXRoIGQ9Im0wIDBjMi41ODkgMS44ODEgNC44MTUgMC41NzYgNi4zMzMgMC41NzZzMy4zNDUgMS4zMTEgNS45NDktMC41OTFjLTAuMDEyLTAuMDMtMC4wMjEtMC4wNTQtMC4wMzMtMC4wNzgtMy4zMTggMC4wNTctOC43NDUgMC4wOTMtMTIuMjQ5IDAuMDkzIiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoODcuOTU5IDQ4MS41MSkiPgo8cGF0aCBkPSJtMCAwYzEuMjM5LTAuNTM0IDEuNS0yLjcwMyAwLjU3Ni00Ljg1MS0wLjkyMS0yLjE0NS0yLjY3My0zLjQ1My0zLjkxOC0yLjkxOS0xLjI0MiAwLjUzMS0xLjQ5NyAyLjcwMy0wLjU3OSA0Ljg0OCAwLjkyNCAyLjE1MSAyLjY3OSAzLjQ1OSAzLjkyMSAyLjkyMiIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDU0LjIzNSA0ODEuNTEpIj4KPHBhdGggZD0ibTAgMGMxLjI0MiAwLjUzNyAyLjk5Ny0wLjc3MSAzLjkyMS0yLjkyMiAwLjkxOC0yLjE0NSAwLjY2My00LjMxNy0wLjU3OS00Ljg0OC0xLjI0NS0wLjUzNC0yLjk5NyAwLjc3NC0zLjkxOCAyLjkxOS0wLjkyNCAyLjE0OC0wLjY2MyA0LjMxNyAwLjU3NiA0Ljg1MSIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDg1LjcxNiA0NzguNikiPgo8cGF0aCBkPSJtMCAwYzcuMjM5IDIwLjM4OC02LjczMiAyMS42ODctMTQuOTQ5IDIxLjY4Ny05LjI1MiAwLTIwLjA1Mi00LjcxOS0xNC4wNzYtMjEuOTI0IDguODIgMC40MzUgMTYuNTY5IDUuMzUyIDI0LjM2MyAxNS42ODEgMS4zMjktNS4yNSAyLjIyMy0xMi4wNjkgNC42NjItMTUuNDQ0IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjEuNDIxIDQ1MS4yMikiPgo8cGF0aCBkPSJtMCAwYy0xNi45NS0wLjMzNi0xOC44NDYgMTkuNjYyLTE4LjIzNCAyOS41MzggMS4xNDYgMTguNDE3IDE3Ljg1OSAyNS44MDMgMjQuNjgxIDE5LjQ3NiA3LjI1MSAwIDEwLjY1My05LjAwMyAxMS40NzItMTkuMjk2IDEuMDg5LTEzLjcwMS0zLjk1Ny0yOS40MzYtMTcuOTE5LTI5LjcxOCIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDExLjk2OCAzNjAuOTgpIj4KPHBhdGggZD0ibTAgMGMtMi4wNjQtMi45OTEtNC44MTUtNC43MDctNS40OTktNi44NjQtMC4zOS0xLjIxOC0wLjA5OS0xLjg3OCAxLjE0LTIuMDMxIDUuMzMxLTAuNjYgNi44NzMgMS4wNzcgOC43NzUgMS42MTEgMy4yNzkgMC45MTggMy4zNjMgMi44MDUgMi4wMzcgNy4yODQtMS4zMjkgNC40NzYtNC43OTEgMi43OTMtNi40NTMgMCIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDguODU4MSA0MTcuNzYpIj4KPHBhdGggZD0ibTAgMGgyNC4zODRsLTMuMTExLTU2Ljc4NGgtNi40NTNsLTEuMzExIDQzLjE4OGMtMC4xMDUgMy40MjMtMi41MjkgMy40NDQtMi42MzcgMGwtMS4zMTEtNDMuMTg4aC02LjQ1eiIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDM1LjU2NCA0NTkuMzQpIj4KPHBhdGggZD0ibTAgMC0yLjc2LTQxLjU4M2gtMjMuNjQ5bC0yLjYxOSA0MS41ODN6IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzEuOTk5IDQ1NC41NikiPgo8cGF0aCBkPSJtMCAwIDMuNTI4LTI0YzAuNDI5LTIuOTI4IDYuMjY0LTEuMzIzIDYuMjA3IDEuMzhsLTAuNDYyIDIxLjljLTAuMTQ3IDcuMDQ0LTEwLjI0NSA3LjMzOC05LjI3MyAwLjcyIiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzQuNTE5IDQxNC40MikiPgo8cGF0aCBkPSJtMCAwYy0wLjIzNCAwLjE1OS0wLjUzMS0wLjE2Mi0wLjU1Mi0wLjQ0MWwtMC4zMDYtNC4xMTZjLTAuMDE4LTAuMjc2IDAuMjQ5LTAuNDE0IDAuNDgzLTAuNTczczAuNTI4IDAuMTYyIDAuNTQ5IDAuNDQxbDAuMzA2IDQuMTE2YzAuMDIxIDAuMjc2LTAuMTk1IDAuNTM0LTAuNDggMC41NzMiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzMy45NTcgNDEyLjY2KSI+CjxwYXRoIGQ9Im0wIDAgMC4xMzUgMS43NzMgNS44NDctMC44NC0wLjEzNS0xLjc3M2MtMC41NjQtNS4zMzEtNi41MS01LjYyOC01Ljg0NyAwLjg0IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzQuMDI2IDQxMy45MSkiPgo8cGF0aCBkPSJtMCAwIDEuMjY2IDE2Ljk5OGMxLjA5MiA0LjUwNiA3LjM1IDQuNDAxIDYuNDk4LTEuMTgybC0xLjk2OC0xNi42MzV6IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOS44NzMgNDU0LjU2KSI+CjxwYXRoIGQ9Im0wIDAtMy41MzEtMjRjLTAuNDI5LTIuOTI4LTYuMjYxLTEuMzIzLTYuMjA0IDEuMzhsMC40NjIgMjEuOWMwLjE0NyA3LjA0NCAxMC4yNDUgNy4zMzggOS4yNzMgMC43MiIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDcuMzUwOSA0MTQuNDIpIj4KPHBhdGggZD0ibTAgMGMwLjIzNyAwLjE1OSAwLjUyOC0wLjE2MiAwLjU1Mi0wLjQ0MWwwLjMwOS00LjExNmMwLjAxNS0wLjI3Ni0wLjI0OS0wLjQxNC0wLjQ4Ni0wLjU3My0wLjIzNC0wLjE1OS0wLjUzMSAwLjE2Mi0wLjU0OSAwLjQ0MWwtMC4zMDkgNC4xMTZjLTAuMDIxIDAuMjc2IDAuMjAxIDAuNTM0IDAuNDgzIDAuNTczIiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNy45MTEgNDEyLjY2KSI+CjxwYXRoIGQ9Im0wIDAtMC4xMzUgMS43NzMtNS44NDctMC44NCAwLjEzNS0xLjc3M2MwLjU2Ny01LjMzMSA2LjUxLTUuNjI4IDUuODQ3IDAuODQiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3Ljg0MjMgNDEzLjkxKSI+CjxwYXRoIGQ9Im0wIDAtMS4yNjMgMTYuOTk4Yy0xLjA5MiA0LjUwNi03LjM1MyA0LjQwMS02LjUwMS0xLjE4MmwxLjk2OC0xNi42MzV6IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOC44NTgxIDQxNy43NikiPgo8cGF0aCBkPSJtMCAwIDAuOS0zNC4wOTVoMjIuNTE4bDAuOTY2IDM0LjA5NS0xMi4zMzkgMTUuNDUzeiIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMwLjE0NSAzNjAuOTgpIj4KPHBhdGggZD0ibTAgMGMyLjA2MS0yLjk5MSA0LjgxMi00LjcwNyA1LjQ5OS02Ljg2NCAwLjM4Ny0xLjIxOCAwLjA5OS0xLjg3OC0xLjE0LTIuMDMxLTUuMzMxLTAuNjYtNi44NzkgMS4wNzctOC43NzUgMS42MTEtMy4yNzkgMC45MTgtMy4zNjMgMi44MDUtMi4wMzcgNy4yODQgMS4zMjkgNC40NzYgNC43OTEgMi43OTMgNi40NTMgMCIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDguMjAwOCAzNTYuNykiPgo8cGF0aCBkPSJtMCAwYy0wLjgwNC0wLjg2Ny0xLjQ0Ni0xLjY4OS0xLjczMS0yLjU4OS0xLjAwNS0zLjE0NyAxLjgtMy4yMzEgNC4wOTUtMi45MzQgMy4wNTQgMC4zOTYgNC4zMjkgMi4wOTQgNS44MiAyLjUxNyAyLjk0MyAwLjgyNSAzLjMxMiAyLjQzIDIuMzk0IDUuOTk3LTAuMTI5LTMuMTExLTMuMDM2LTMuOTU3LTYuMjY3LTUuNDktMy4yMjgtMS41My01LjgzMi0wLjAxOC00LjMxMSAyLjQ5OSIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMzLjkxMyAzNTYuNykiPgo8cGF0aCBkPSJtMCAwYzAuODAxLTAuODY3IDEuNDQ2LTEuNjg5IDEuNzMxLTIuNTg5IDEuMTQ5LTMuNjAzLTIuOTQ2LTMuMzMtNS4yNTktMi43MDMtMi4yNDcgMC42MDktMy4zNzIgMS45MjMtNC42NTYgMi4yODYtMi45NDYgMC44MjUtMy4zMTIgMi40My0yLjM5NCA1Ljk5NyAwLjEyMy0zLjExMSAzLjAzNi0zLjk1NyA2LjI2Ny01LjQ5IDMuMjMxLTEuNTMgNS44MzItMC4wMTggNC4zMTEgMi40OTkiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMS4wMTggNDE3Ljc2KSI+CjxwYXRoIGQ9Im0wIDBoLTEyLjE1OWwtMS45OTIgMjkuMjk1IDguNTIzIDEyLjI4OGgxMS4yNTlsOC4yMTEtMTIuMjg4LTEuNjgzLTI5LjI5NXoiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNi42NDggNDczLjk1KSI+CjxwYXRoIGQ9Im0wIDB2LTE0LjYwMWMwLTkuMTUtMTEuMjU5LTguOTY3LTExLjI1OSAwdjE0LjYwMWMwIDcuNDQ2IDExLjI1OSA3LjQ0NiAxMS4yNTkgMCIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI2LjY0OCA0NzMuOTUpIj4KPHBhdGggZD0ibTAgMHYtOS4yMzdjLTIuMTMtMS42NjUtNC4xODUtMi41OTgtNS42MzEtMi41OTgtMS40NDMgMC0zLjQ5OCAwLjkzMy01LjYyOCAyLjU5OHY5LjIzN2MwIDcuNDQ2IDExLjI1OSA3LjQ0NiAxMS4yNTkgMCIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIxLjAxOCA0NjQuNCkiPgo8cGF0aCBkPSJNIDAsMCBDIC0zLjY2OSwwIC0xMS40MTIsNS43NjMgLTEzLjgwNiwxNC4wMTkgLTE2LjIyMSwyMi4zNTMgLTExLjY3LDM0LjMwOCAwLDM0LjMwOCAxMS42NjcsMzQuMzA4IDE2LjIxOCwyMi4zNTMgMTMuODAzLDE0LjAxOSAxMS40MDksNS43NjMgMy42NjYsMCAwLDAiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNi42IDQ3Mi43MSkiPgo8cGF0aCBkPSJtMCAwYzEuODY5IDEuODA2IDMuMzI3IDAuNDU2IDQuNDE5IDAuNDU2IDEuMDg5IDAgMi41NDcgMS4zNTMgNC40MTMtMC40NTYtMS4wMDUtNC43Ny03LjUtNC45MTctOC44MzIgMCIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE3LjE3NSA0NzIuNDcpIj4KPHBhdGggZD0iTSAwLDAgQyAxLjAyMywwLjI2MSA2LjIyMiwwLjMxMiA3LjY4MywwLjA1NyA2LjQ3NywtMi4xNjMgMS4wMjMsLTIuMDM3IDAsMCIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE2LjYgNDcyLjcxKSI+CjxwYXRoIGQ9Im0wIDBjMS44NjkgMS44MDYgMy4zMjcgMC40NTYgNC40MTkgMC40NTYgMS4wODkgMCAyLjU0NyAxLjM1MyA0LjQxMy0wLjQ1Ni0yLjg1Ni0xLjQwNy02LjkwOS0wLjc1LTguODMyIDAiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0LjkwNzEgNDgzLjQ1KSI+CjxwYXRoIGQ9Im0wIDBjMS4xNzkgMC41MDcgMi44NDctMC43MzUgMy43MjMtMi43NzVzMC42My00LjEwNC0wLjU0OS00LjYxMWMtMS4xODItMC41MDQtMi44NDcgMC43MzgtMy43MiAyLjc3OC0wLjg3OSAyLjAzNy0wLjYzIDQuMTAxIDAuNTQ2IDQuNjA4IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzcuNDUgNDgzLjQ1KSI+CjxwYXRoIGQ9Im0wIDBjMS4xNzktMC41MDcgMS40MjUtMi41NjggMC41NTItNC42MDgtMC44NzktMi4wNC0yLjU0NC0zLjI4Mi0zLjcyNi0yLjc3Mi0xLjE3NiAwLjUwNC0xLjQyNSAyLjU2OC0wLjU0OSA0LjYwNSAwLjg3NiAyLjA0MyAyLjU0NCAzLjI4NSAzLjcyMyAyLjc3NSIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDM1LjkzNiA0NzguNTcpIj4KPHBhdGggZD0ibTAgMGM0LjQyOCAxOC45OS04Ljk0MyAyMi4yMjEtMTYuNzQ2IDIyLjIyMS04Ljc4NyAwLTE1LjQxMS0xMC40MjgtMTMuOTI5LTIyLjU3MiA0LjY4OSAyLjgyNiA4LjgxNyA4LjQwNiAxOS4wNjUgMTcuNTExLTEuNDkxLTIuNjczLTQuMzk1LTcuNTMzLTE0LjI3NC0xNi4zNDQgNS4zMTYtMC44NzkgMTUuMjE2IDUuODIzIDIwLjQ5NiAxMi44MzEgMS4yNTctNC45ODMgMy4wNzItMTAuNDQgNS4zODgtMTMuNjQ3IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPC9nPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIxNC41MyAzNzEuOTUpIj4KPHBhdGggZD0ibTAgMGMtMjAuNTc0LTAuNDExLTIyLjg3OCAyMy44NjgtMjIuMTM0IDM1Ljg1NiAxLjM5MiAyMi4zNTMgMjEuNjgxIDMxLjMxNyAyOS45NTggMjMuNjQgOC44MDUgMCAxMi45MzMtMTAuOTMyIDEzLjkyNi0yMy40MjQgMS4zMjMtMTYuNjI5LTQuODAzLTM1LjczLTIxLjc1LTM2LjA3MiIgZmlsbD0iI2ExNDAwZiIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjAzLjA2IDI2Mi40MikiPgo8cGF0aCBkPSJtMCAwYy0yLjUwNS0zLjYzLTUuODQ0LTUuNzEyLTYuNjc1LTguMzM0LTAuNDcxLTEuNDc2LTAuMTItMi4yOCAxLjM4My0yLjQ2MyA2LjQ3MS0wLjgwMSA4LjM0NiAxLjMwOCAxMC42NSAxLjk1NiAzLjk4MSAxLjExMyA0LjA4NiAzLjQwMiAyLjQ3NSA4Ljg0MS0xLjYxNCA1LjQzMy01LjgxNCAzLjM5My03LjgzMyAwIiBmaWxsPSIjZmJkOWJkIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxOTkuMjggMzMxLjM0KSI+CjxwYXRoIGQ9Im0wIDBoMjkuNTk4bC0zLjc3Ny02OC45MjhoLTcuODNsLTEuNTkzIDUyLjQyNWMtMC4xMjkgNC4xNTUtMy4wNjkgNC4xODItMy4yMDEgMGwtMS41OS01Mi40MjVoLTcuODN6IiBmaWxsPSIjZmJkOWJkIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMzEuNyAzODEuODIpIj4KPHBhdGggZD0ibTAgMC0zLjM1MS01MC40NzVoLTI4LjcwN2wtMy4xOCA1MC40NzV6IiBmaWxsPSIjZmJkOWJkIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMjcuMzcgMzc2LjAxKSI+CjxwYXRoIGQ9Im0wIDAgNC4yODEtMjkuMTNjMC41MjItMy41NTUgNy42MDItMS42MDggNy41MzYgMS42NzRsLTAuNTU4IDI2LjU4M2MtMC4xOCA4LjU1LTEyLjQ0MSA4LjkwNC0xMS4yNTkgMC44NzMiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIzMC40MyAzMjcuMjgpIj4KPHBhdGggZD0ibTAgMGMtMC4yODUgMC4xOTItMC42NDUtMC4xOTUtMC42NjktMC41MzRsLTAuMzcyLTQuOTk1Yy0wLjAyNC0wLjMzOSAwLjMtMC41MDcgMC41ODUtMC42OTlzMC42NDIgMC4xOTggMC42NjkgMC41MzRsMC4zNzIgNC45OThjMC4wMjQgMC4zMzYtMC4yNCAwLjY1MS0wLjU4NSAwLjY5NiIgZmlsbD0iI2ZiZDliZCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjI5Ljc1IDMyNS4xNCkiPgo8cGF0aCBkPSJNIDAsMCAwLjE2MiwyLjE1MSA3LjI2LDEuMTMxIDcuMDk4LC0xLjAyIEMgNi40MTEsLTcuNDg4IC0wLjgwNywtNy44NTEgMCwwIiBmaWxsPSIjZmJkOWJkIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMjkuODMgMzI2LjY3KSI+CjxwYXRoIGQ9Im0wIDAgMS41MzYgMjAuNjM0YzEuMzI2IDUuNDY5IDguOTIyIDUuMzQzIDcuODg3LTEuNDM3bC0yLjM4OC0yMC4xOXoiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIwMC41MSAzNzYuMDEpIj4KPHBhdGggZD0ibTAgMC00LjI4Ny0yOS4xM2MtMC41MjItMy41NTUtNy41OTktMS42MDgtNy41MyAxLjY3NGwwLjU2MSAyNi41ODNjMC4xOCA4LjU1IDEyLjQzNSA4LjkwNCAxMS4yNTYgMC44NzMiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE5Ny40NSAzMjcuMjgpIj4KPHBhdGggZD0ibTAgMGMwLjI4OCAwLjE5MiAwLjY0Mi0wLjE5NSAwLjY2OS0wLjUzNGwwLjM3NS00Ljk5NWMwLjAyMS0wLjMzOS0wLjMtMC41MDctMC41ODgtMC42OTktMC4yODUtMC4xOTItMC42NDUgMC4xOTgtMC42NjkgMC41MzRsLTAuMzcyIDQuOTk4Yy0wLjAyNyAwLjMzNiAwLjI0MyAwLjY1MSAwLjU4NSAwLjY5NiIgZmlsbD0iI2ZiZDliZCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTk4LjEzIDMyNS4xNCkiPgo8cGF0aCBkPSJtMCAwLTAuMTYyIDIuMTUxLTcuMDk4LTEuMDIgMC4xNjUtMi4xNTFjMC42ODctNi40NjggNy45MDItNi44MzEgNy4wOTUgMS4wMiIgZmlsbD0iI2ZiZDliZCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTk4LjA1IDMyNi42NykiPgo8cGF0aCBkPSJtMCAwLTEuNTMzIDIwLjYzNGMtMS4zMjYgNS40NjktOC45MjUgNS4zNDMtNy44OS0xLjQzN2wyLjM4OC0yMC4xOXoiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE5OS4yOCAzMzEuMzQpIj4KPHBhdGggZD0ibTAgMCAxLjA5NS00MS4zODVoMjcuMzNsMS4xNzMgNDEuMzg1LTE0Ljk3OSAxOC43NTl6IiBmaWxsPSIjY2MxYjc0IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMjUuMTIgMjYyLjQyKSI+CjxwYXRoIGQ9Im0wIDBjMi41MDItMy42MyA1LjgzOC01LjcxMiA2LjY3NS04LjMzNCAwLjQ3MS0xLjQ3NiAwLjEyLTIuMjgtMS4zODMtMi40NjMtNi40NzEtMC44MDEtOC4zNDkgMS4zMDgtMTAuNjUgMS45NTYtMy45ODEgMS4xMTMtNC4wODYgMy40MDItMi40NzUgOC44NDEgMS42MTQgNS40MzMgNS44MTQgMy4zOTMgNy44MzMgMCIgZmlsbD0iI2ZiZDliZCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTk4LjQ4IDI1Ny4yMikiPgo8cGF0aCBkPSJtMCAwYy0wLjk3NS0xLjA1My0xLjc1NS0yLjA1Mi0yLjEtMy4xNDEtMS4yMjEtMy44MjIgMi4xODQtMy45MjQgNC45NjgtMy41NjQgMy43MTEgMC40ODMgNS4yNTYgMi41NDQgNy4wNjUgMy4wNTQgMy41NzMgMS4wMDIgNC4wMiAyLjk1MiAyLjkwNyA3LjI4MS0wLjE1Ni0zLjc3Ny0zLjY4NC00LjgwMy03LjYwOC02LjY2My0zLjkxOC0xLjg1Ny03LjA4LTAuMDIxLTUuMjMyIDMuMDMzIiBmaWxsPSIjY2MxYjc0IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMjkuNjkgMjU3LjIyKSI+CjxwYXRoIGQ9Im0wIDBjMC45NzItMS4wNTMgMS43NTUtMi4wNTIgMi4xLTMuMTQxIDEuMzk4LTQuMzc0LTMuNTc2LTQuMDQ0LTYuMzgxLTMuMjgyLTIuNzI3IDAuNzM4LTQuMDk1IDIuMzM0LTUuNjUyIDIuNzcyLTMuNTc2IDEuMDAyLTQuMDIzIDIuOTUyLTIuOTA3IDcuMjgxIDAuMTUtMy43NzcgMy42ODQtNC44MDMgNy42MDgtNi42NjMgMy45MjEtMS44NTcgNy4wOC0wLjAyMSA1LjIzMiAzLjAzMyIgZmlsbD0iI2NjMWI3NCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjE0LjA0IDMzMS4zNCkiPgo8cGF0aCBkPSJtMCAwaC0xNC43NmwtMi40MTggMzUuNTU5IDEwLjM0NCAxNC45MTZoMTMuNjY4bDkuOTY2LTE0LjkxNi0yLjA0My0zNS41NTl6IiBmaWxsPSIjY2MxYjc0IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMjAuODggMzk5LjU0KSI+CjxwYXRoIGQ9Im0wIDB2LTE3LjcyNGMwLTExLjEwNi0xMy42NjgtMTAuODg0LTEzLjY2OCAwdjE3LjcyNGMwIDkuMDM5IDEzLjY2OCA5LjAzOSAxMy42NjggMCIgZmlsbD0iI2ZiZDliZCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjIwLjg4IDM5OS41NCkiPgo8cGF0aCBkPSJtMCAwdi0xMS4yMTFjLTIuNTg2LTIuMDIyLTUuMDc5LTMuMTUzLTYuODM0LTMuMTUzcy00LjI0OCAxLjEzMS02LjgzNCAzLjE1M3YxMS4yMTFjMCA5LjAzOSAxMy42NjggOS4wMzkgMTMuNjY4IDAiIGZpbGw9IiNlY2MyYTAiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIxNC4wNCAzODcuOTYpIj4KPHBhdGggZD0iTSAwLDAgQyAtNC40NTIsMCAtMTMuODUxLDYuOTk2IC0xNi43NTgsMTcuMDE2IC0xOS42ODksMjcuMTMyIC0xNC4xNjMsNDEuNjQzIDAsNDEuNjQzIDE0LjE2LDQxLjY0MyAxOS42ODYsMjcuMTMyIDE2Ljc1NSwxNy4wMTYgMTMuODQ4LDYuOTk2IDQuNDQ5LDAgMCwwIiBmaWxsPSIjZmJkOWJkIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMDguNjggMzk4LjA1KSI+CjxwYXRoIGQ9Im0wIDBjMi4yNjggMi4xOTMgNC4wMzggMC41NTIgNS4zNjQgMC41NTIgMS4zMjMgMCAzLjA5IDEuNjQ0IDUuMzU4LTAuNTUyLTEuMjIxLTUuNzktOS4xMDUtNS45Ny0xMC43MjIgMCIgZmlsbD0iI2ZmMzg2YSIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjA5LjM4IDM5Ny43NCkiPgo8cGF0aCBkPSJNIDAsMCBDIDEuMjM5LDAuMzE4IDcuNTUxLDAuMzgxIDkuMzI3LDAuMDcyIDcuODYsLTIuNjI4IDEuMjM5LC0yLjQ3MiAwLDAiIGZpbGw9IiNmZmYiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIwOC42OCAzOTguMDUpIj4KPHBhdGggZD0ibTAgMGMyLjI2OCAyLjE5MyA0LjAzOCAwLjU1MiA1LjM2NCAwLjU1MiAxLjMyMyAwIDMuMDkgMS42NDQgNS4zNTgtMC41NTItMy40NjgtMS43MS04LjM4OC0wLjkwOS0xMC43MjIgMCIgZmlsbD0iI2ZmMzg2YSIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTk0LjQ5IDQxMS4wOCkiPgo8cGF0aCBkPSJtMCAwYzEuNDM0IDAuNjE1IDMuNDU2LTAuODk0IDQuNTIxLTMuMzY2IDEuMDU5LTIuNDc4IDAuNzYyLTQuOTgzLTAuNjY5LTUuNTk4LTEuNDM0LTAuNjE1LTMuNDU2IDAuODk0LTQuNTE1IDMuMzY5LTEuMDY1IDIuNDc1LTAuNzY1IDQuOTggMC42NjMgNS41OTUiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIzMy45OSA0MTEuMDgpIj4KPHBhdGggZD0ibTAgMGMxLjQzNC0wLjYxNSAxLjcyOC0zLjExNyAwLjY2OS01LjU5NS0xLjA2NS0yLjQ3NS0zLjA4Ny0zLjk4NC00LjUyMS0zLjM2Ni0xLjQyOCAwLjYxNS0xLjcyOCAzLjEyMy0wLjY2OSA1LjU5NSAxLjA2NSAyLjQ3NSAzLjA4NyAzLjk4NCA0LjUyMSAzLjM2NiIgZmlsbD0iI2ZiZDliZCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjMyLjE1IDQwNS4xNSkiPgo8cGF0aCBkPSJtMCAwYzUuMzc2IDIzLjA1Mi0xMC44NTcgMjYuOTczLTIwLjMyNSAyNi45NzMtMTAuNjY4IDAtMTguNzA4LTEyLjY2LTE2LjkwOC0yNy4zOTkgNS42ODggMy40MjkgMTAuNzAxIDEwLjIwMyAyMy4xMzkgMjEuMjU1LTEuODA5LTMuMjQzLTUuMzM0LTkuMTQ0LTE3LjMyNS0xOS44MzkgNi40NTMtMS4wNjUgMTguNDcxIDcuMDY4IDI0Ljg3OSAxNS41NzYgMS41MjctNi4wNDggMy43MjktMTIuNjc1IDYuNTQtMTYuNTY2IiBmaWxsPSIjYTE0MDBmIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNjUuNjcgNDMzLjQ3KSI+CjxwYXRoIGQ9Im0wIDBjMi40MzYgMS4xMzcgOS4xNzEtNi4xNzQgNi45ODctMTYuNTcyLTkuMzk2LTQ0LjctMTIuOTY2LTQwLjI3OC0yMS4zNTctNDAuMjc4LTcuOTA4IDAtMTAuMDUtMS4yNTctMjAuMzk0IDM4LjY0OS0yLjI3NyA4Ljc3NSAyLjQzMyAxNy4yMjMgOS43NDQgMjEuMjg4IDcuMzExIDQuMDU5IDE3LjU0NyA1LjE5IDI1LjAyLTMuMDg3IiBmaWxsPSIjYTE0MDBmIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMzkuNzkgMjYwLjc5KSI+CjxwYXRoIGQ9Im0wIDBjLTIuNjUyLTMuODQzLTYuMzY2LTYuMDUxLTYuNzkyLTguOTI4LTAuMjQtMS42MjkgMC4xMDgtMi45MTkgMS42OTgtMy4xMTQgNi44NDYtMC44NDkgNy43NTIgMi4wOTcgMTAuMTg4IDIuNzg0IDQuMjE1IDEuMTc5IDQuOTA1IDMuNTAxIDMuMTk4IDkuMjU4LTEuNzA3IDUuNzU0LTYuMTU2IDMuNTkxLTguMjkyIDAiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzNS43OSAzMzMuNzYpIj4KPHBhdGggZD0ibTAgMGgzMS4zMzJsLTMuOTk2LTcyLjk3MmgtOC4yOTJsLTEuNjgzIDU1LjQ5N2MtMC4xMzggNC40MDEtMy4yNTIgNC40MzEtMy4zODcgMGwtMS42ODYtNTUuNDk3aC04LjI4OXoiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE2Mi4yIDM3OS4yMSkiPgo8cGF0aCBkPSJtMCAwIDguNC0zMC45MzNjMS4wMTEtMy42OTkgOC44MDUtMC4wNTQgOC4yMjYgMy4zOTNsLTUuMDc5IDMwLjI2N2MtMS45MzggOC45MS0xMy44MTUgNS42MzEtMTEuNTQ3LTIuNzI3IiBmaWxsPSIjZmJkOWJkIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNzQuMjUgMzgxLjM4KSI+CjxwYXRoIGQ9Im0wIDBjLTAuNjYgNy4yMTItNi4yNjEgNi41NTItOC45MjggMy43MDVsMi41NjUtMTIuNjg3eiIgZmlsbD0iI2I3MWE3MCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTQwLjIgMzc5LjIxKSI+CjxwYXRoIGQ9Im0wIDAtOC40LTMwLjkzM2MtMS4wMTEtMy42OTktOC44MDUtMC4wNTQtOC4yMjYgMy4zOTNsNS4wODIgMzAuMjY3YzEuOTM1IDguOTEgMTMuODEyIDUuNjMxIDExLjU0NC0yLjcyNyIgZmlsbD0iI2ZiZDliZCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTI4LjE1IDM4MS4zOCkiPgo8cGF0aCBkPSJtMCAwYzAuNjU0IDcuMjEyIDYuMjYxIDYuNTUyIDguOTIyIDMuNzA1bC0yLjU1OS0xMi42ODd6IiBmaWxsPSIjYjcxYTcwIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMzIuODIgMzI5LjQ2KSI+CjxwYXRoIGQ9Im0wIDBjMC4zMDYgMC4yMDQgMC42ODEtMC4yMDcgMC43MDgtMC41NjFsMC4zOTktNS4yOTJjMC4wMjQtMC4zNTQtMC4zMTgtMC41MzctMC42MjEtMC43NDEtMC4zMDYtMC4yMDEtMC42ODEgMC4yMS0wLjcwOCAwLjU2N2wtMC4zOTYgNS4yODljLTAuMDI3IDAuMzU3IDAuMjU1IDAuNjkgMC42MTggMC43MzgiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzMy41NCAzMjcuMikiPgo8cGF0aCBkPSJtMCAwLTAuMTcxIDIuMjc0LTcuNTE1LTEuMDgzIDAuMTc0LTIuMjc0YzAuNzI5LTYuODQ5IDguMzY3LTcuMjMzIDcuNTEyIDEuMDgzIiBmaWxsPSIjZmJkOWJkIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMzMuNDUgMzI4LjgpIj4KPHBhdGggZD0ibTAgMC0xLjYyMyAyMS44NDljLTEuNDA3IDUuNzg3LTcuODE4IDQuODk5LTguMTE4LTAuMjQ5bDIuMjk1LTIyLjY0N3oiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE3MC4xMSAzODcuMTkpIj4KPHBhdGggZD0ibTAgMC0yLjk4NS01My40MjdoLTMxLjMzMmwtMi45ODUgNTMuNDI3eiIgZmlsbD0iI2NjMWI3NCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTQyLjA5IDM4Ny4xOSkiPgo8cGF0aCBkPSJtMCAwaDE4LjU3NmMwLjk0Mi0xLjEyMiAxLjUwNi0yLjU2OCAxLjUwNi00LjE0NiAwLTMuNTctMi44OTItNi40NjUtNi40NTktNi40NjUtMS42NjggMC0zLjE4NiAwLjYzMy00LjMzMiAxLjY3NC0xLjE1Mi0xLjAzOC0yLjY2Ny0xLjY3NC00LjMzOC0xLjY3NC0zLjU3IDAtNi40NjIgMi44OTUtNi40NjIgNi40NjUgMCAxLjU3OCAwLjU2NyAzLjAyNCAxLjUwOSA0LjE0NiIgZmlsbD0iI2I3MWE3MCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTM1LjEzIDM0NS42NSkiPgo8cGF0aCBkPSJtMCAwIDEuMDc3LTMzLjA2aDMwLjYxMmwwLjk2NiAzMi45OTF6IiBmaWxsPSIjMjgyODI4IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNjMuMTUgMjYwLjc5KSI+CjxwYXRoIGQ9Im0wIDBjMi42NTItMy44NDMgNi41MDEtNi4wMDYgNi42NDItOS4xNjUgMC4wNzUtMS42NDQgMC4wMzYtMi45NjQtMS41NTQtMy4xNTktNi44NDYtMC44NDktNy4wMjkgMi44MDItOS40NzEgMy40ODktNC4yMTIgMS4xODItNS42MSAzLjA3OC0zLjkwOSA4LjgzNSAxLjcwNyA1Ljc1NCA2LjE1NiAzLjU5MSA4LjI5MiAwIiBmaWxsPSIjZmJkOWJkIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMzQuOTUgMjU1LjMpIj4KPHBhdGggZD0ibTAgMGMtMS4wMjktMS4xMTktMS44NTctMi4xNzItMi4yMjMtMy4zMjEtMS4yNTEtMy45MjcgMi4wNDMtNC4xMTMgNC45NS0zLjgxMyA0LjE1MiAwLjQzMiA1LjgyNiAyLjcxOCA3Ljc4OCAzLjI3IDMuNzg2IDEuMDU5IDQuMjU3IDMuMTI2IDMuMDc4IDcuNzA3LTAuMTU5LTMuOTk5LTYuNDcxLTYuNTc2LTguMDUyLTcuMDUzLTEuNTc4LTAuNDc3LTUuMjQ0IDEuNjUzLTUuNTQxIDMuMjEiIGZpbGw9IiNjYzFiNzQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE2Ny45OSAyNTUuMykiPgo8cGF0aCBkPSJtMCAwYzEuMDI5LTEuMTE5IDEuODU3LTIuMTcyIDIuMjIzLTMuMzIxIDEuMzM1LTQuMTg4LTIuNjQzLTQuMi01LjYxOS0zLjcyMy0zLjY3MiAwLjU4OC01LjI2OCAyLjY1OC03LjExOSAzLjE4LTMuNzg2IDEuMDU5LTQuMjU3IDMuMTI2LTMuMDc4IDcuNzA3IDAuMTU5LTMuOTk5IDYuNDk1LTYuOTMzIDguMTQ1LTcuMDUzIDEuNjQ0LTAuMTE3IDUuOTg4IDIuNzI0IDUuNDQ4IDMuMjEiIGZpbGw9IiNjYzFiNzQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE0Mi40IDI1Mi42OSkiPgo8cGF0aCBkPSJtMCAwYy0wLjAyMSAwLjEyLTAuMDY2IDAuMjYxLTAuMTMyIDAuNDExLTAuMzg0IDAuODczLTEuMzggMS44NDgtMi41NjIgMi41ODMtMS4xMzQgMC43MDItMi42NDMgMS4xNDktMy42NTEgMS4wMTcgMC41MjIgMC41NCAxLjA2NSAxLjEwNCAxLjYwNSAxLjcxIDAuOTYtMC4yMDcgMi4xNzItMC42MzMgMy4wNTctMS4xNzkgMS40NzktMC45MTUgMi43NDgtMi4yMDIgMy4yNzktMy40MTQgMC4xMjYtMC4yNzkgMC4yMTMtMC41NjEgMC4yNTgtMC44NDZ6IiBmaWxsPSIjY2MxYjc0Ii8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTYwLjYzIDI1Mi42OSkiPgo8cGF0aCBkPSJtMCAwYzAuMDE4IDAuMTIgMC4wNiAwLjI2MSAwLjEyOSAwLjQxMSAwLjM4NCAwLjg3MyAxLjM4IDEuODQ4IDIuNTU5IDIuNTgzIDEuMTM3IDAuNzAyIDIuNjQ2IDEuMTQ5IDMuNjU3IDEuMDE3LTAuNTI4IDAuNTQtMS4wNjUgMS4xMDQtMS42MTEgMS43MS0wLjk1Ny0wLjIwNy0yLjE2OS0wLjYzMy0zLjA1NC0xLjE3OS0xLjQ4Mi0wLjkxNS0yLjc1MS0yLjIwMi0zLjI4Mi0zLjQxNC0wLjEyMy0wLjI3OS0wLjIxLTAuNTYxLTAuMjYxLTAuODQ2eiIgZmlsbD0iI2NjMWI3NCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE2OS41OCAzMjkuNDYpIj4KPHBhdGggZD0ibTAgMGMtMC4zMDYgMC4yMDQtMC42ODEtMC4yMDctMC43MDgtMC41NjFsLTAuMzk5LTUuMjkyYy0wLjAyNC0wLjM1NCAwLjMyMS0wLjUzNyAwLjYyMS0wLjc0MSAwLjMwNi0wLjIwMSAwLjY4MSAwLjIxIDAuNzA4IDAuNTY3bDAuMzk2IDUuMjg5YzAuMDI3IDAuMzU3LTAuMjU1IDAuNjktMC42MTggMC43MzgiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE2OC44NiAzMjcuMikiPgo8cGF0aCBkPSJNIDAsMCAwLjE3NywyLjI3NCA3LjY4OSwxLjE5MSA3LjUxOCwtMS4wODMgQyA2Ljc4NiwtNy45MzIgLTAuODQ5LC04LjMxNiAwLDAiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE2OC45NSAzMjguOCkiPgo8cGF0aCBkPSJtMCAwIDEuNjIzIDIxLjg0OWMxLjQwMSA1Ljc4NyA3Ljk0NyA1LjM5MSA4LjI1IDAuMjQzbC0yLjQyNy0yMy4xMzl6IiBmaWxsPSIjZmJkOWJkIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNTguNjEgNDA0LjE3KSI+CjxwYXRoIGQ9Im0wIDB2LTE3LjcyMWMtMy45NzUtNS4yMzItMTAuNDg4LTUuMDUyLTE0LjQ2OSAwdjE3LjcyMWMwIDkuNTczIDE0LjQ2OSA5LjU3MyAxNC40NjkgMCIgZmlsbD0iI2ZiZDliZCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTU4LjYxIDQwNS40NSkiPgo8cGF0aCBkPSJtMCAwdi0xMS44NjhjLTIuNzM2LTIuMTM5LTUuMzczLTMuMzM5LTcuMjMtMy4zMzktMS44NjMgMC00LjUwMyAxLjItNy4yMzkgMy4zMzl2MTEuODY4YzAgOS41NjcgMTQuNDY5IDkuNTY3IDE0LjQ2OSAwIiBmaWxsPSIjZWNjMmEwIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNTEuMzggMzkzLjE5KSI+CjxwYXRoIGQ9Im0gMCwwIGMgLTQuNzEzLDAgLTE0LjY2MSw3LjQwNyAtMTcuNzM5LDE4LjAxNSAtMy4xMDUsMTAuNzEgMi43NDUsMjYuMDcgMTcuNzM5LDI2LjA3IDYuMDgxLDAgMTAuNjU2LC0yLjUyOSAxMy43NDMsLTYuMjQ5IDQuNTE4LC01LjQ1MSA1LjgzOCwtMTMuNDU4IDMuOTkzLC0xOS44MjEgQyAxNC42NTgsNy40MDcgNC43MSwwIDAsMCIgZmlsbD0iI2ZiZDliZCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTM1LjY1IDQxNi4zMikiPgo8cGF0aCBkPSJtMCAwYzAuNDY4IDAuMTc3IDIuOTc5IDEuMDIgNy41NzIgMC43MDh2LTAuNDM4Yy0yLjI3MSAwLjExMS00LjU0Mi0wLjA2My01LjE5Ni0wLjY2OS0xLjI0NS0xLjE1Mi0xLjA4LTMuNjMgMC42MDktNC43OTcgMC44MzQtMC41NzYgMi43NTQtMC45MDMgNC41ODctMC45ODd2LTAuNDI5Yy0yLjI0NCAwLjExMS00Ljc5NCAwLjUyOC01LjUyMyAxLjUwOS0xLjEzNCAxLjUyNy0xLjUyNyAyLjc0NS0yLjAxIDMuMDUxLTAuNDc3IDAuMzA2LTAuNjA5IDEuODM5LTAuMDM5IDIuMDUybTcuNTcyIDAuNzA4IDAuMTg5LTAuMDE1YzQuNzEtMC4zNDUgNS43MTItMS4yNjMgNi4xOTUtMS4yMTggMC41NTggMC4wNTEgMS4xNjcgMC4xMjYgMS43MzcgMC4xMjYgMC41NzYgMCAxLjIyMS0wLjA3NSAxLjgwMy0wLjEyNiAwLjQ4My0wLjA0NSAxLjQ4OCAwLjg3MyA2LjE5NSAxLjIxOGwwLjE5MiAwLjAxNXYtMC40MzhoLTAuMDI0Yy0yLjI3Ny0wLjExMS01LjI0NC0wLjYzNi01LjgyNi0xLjk0MS0wLjU4NS0xLjMwNSAwLjUyNS0zLjYzNiAyLjEzNi00LjIxOCAwLjczMi0wLjI2NyAyLjE5My0wLjM2MyAzLjcxNC0wLjI5NHYtMC40MjljLTEuMjQ1LTAuMDYtMi4zOTQtMC4wMy0zLjA3NSAwLjA1NC0xLjkxNyAwLjIzMS0zLjM1NCAyLjU0NC0zLjYxNSAzLjI0LTAuNTg4IDEuNTcyLTIuMzQ2IDEuNTcyLTIuOTMxIDAtMC4yNjQtMC42OTYtMS42OTgtMy4wMDktMy42MTgtMy4yNC0wLjY4MS0wLjA4NC0xLjgzMy0wLjExNC0zLjA3Mi0wLjA1NHYwLjQyOWMxLjUyMS0wLjA2OSAyLjk3OSAwLjAyNyAzLjcxNCAwLjI5NCAxLjYwNSAwLjU4MiAyLjcxOCAyLjkxMyAyLjEzNiA0LjIxOC0wLjU4NSAxLjI5OS0zLjU1MiAxLjgzLTUuODI5IDEuOTQxaC0wLjAyMXptMTYuMzExIDBjNC41OSAwLjMxMiA3LjEwMS0wLjUzMSA3LjU2OS0wLjcwOCAwLjU2Ny0wLjIxMyAwLjQzOC0xLjc0Ni0wLjAzOS0yLjA1Mi0wLjQ4My0wLjMwNi0wLjg3Ni0xLjUyNC0yLjAwNy0zLjA1MS0wLjczMi0wLjk4MS0zLjI4Mi0xLjM5OC01LjUyMy0xLjUwOXYwLjQyOWMxLjgzIDAuMDg0IDMuNzQ3IDAuNDExIDQuNTgxIDAuOTg3IDEuNjkyIDEuMTY3IDEuODU3IDMuNjQ1IDAuNjA5IDQuNzk3LTAuNjQ4IDAuNjA2LTIuOTIyIDAuNzgtNS4xOSAwLjY2OXoiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzOC4wMyA0MTUuOTIpIj4KPHBhdGggZD0ibTAgMGMwLjY1NCAwLjYwOSAyLjk0NiAwLjc4IDUuMjE3IDAuNjY5IDIuMjc3LTAuMTExIDUuMjQ0LTAuNjM2IDUuODI5LTEuOTQxIDAuNTgyLTEuMzA1LTAuNTMxLTMuNjM2LTIuMTM2LTQuMjE4LTEuNjExLTAuNTg1LTYuNzY4LTAuMzYtOC4zMDEgMC42OTMtMS42ODkgMS4xNjEtMS44NTEgMy42NDUtMC42MDkgNC43OTciIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE2NC43MiA0MTUuOTIpIj4KPHBhdGggZD0ibTAgMGMtMC42NTQgMC42MDktMi45NCAwLjc4LTUuMjE0IDAuNjY5LTIuMjc3LTAuMTExLTUuMjQ0LTAuNjM2LTUuODI2LTEuOTQxLTAuNTg1LTEuMzA1IDAuNTI1LTMuNjM2IDIuMTM2LTQuMjE4IDEuNjA4LTAuNTg1IDYuNzY4LTAuMzYgOC4yOTUgMC42OTMgMS42OTIgMS4xNjEgMS44NTQgMy42NDUgMC42MDkgNC43OTciIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE0NS43IDQwMy44NykiPgo8cGF0aCBkPSJtMCAwYzIuNCAyLjMyMiA0LjI3MiAwLjU3OSA1LjY3OSAwLjU3OSAxLjQwMSAwIDMuMjcgMS43NDMgNS42NzMtMC41NzktMS4yOTMtNi4xMjktOS42NDItNi4zMTgtMTEuMzUyIDAiIGZpbGw9IiNmZjM4NmEiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE0NS43IDQwMy44NykiPgo8cGF0aCBkPSJtMCAwYzIuNCAyLjMyMiA0LjI3MiAwLjU3OSA1LjY3OSAwLjU3OSAxLjM5NSAwIDMuMjcgMS43NDMgNS42NzMtMC41NzktMy42NzItMS44MDktOC44OC0wLjk2My0xMS4zNTIgMCIgZmlsbD0iI2M4MjA0YSIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTMwLjMxIDQxNS4zNikiPgo8cGF0aCBkPSJtMCAwYzEuNTE1IDAuNjU0IDMuNjU3LTAuOTQyIDQuNzc5LTMuNTY0IDEuMTI4LTIuNjE5IDAuODEtNS4yNzEtMC43MDItNS45MjItMS41MTgtMC42NDgtMy42NTcgMC45NDgtNC43ODIgMy41NjctMS4xMjggMi42MTktMC44MDcgNS4yNjggMC43MDUgNS45MTkiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE3Mi4xMiA0MTUuMzgpIj4KPHBhdGggZD0ibTAgMGMxLjUxOC0wLjY1MSAxLjgzNi0zLjMwMyAwLjcwOC01LjkyNS0xLjEyMi0yLjYxOS0zLjI2NC00LjIxNS00Ljc4Mi0zLjU2NC0xLjUxNSAwLjY0OC0xLjgzIDMuMzAzLTAuNzA1IDUuOTIyIDEuMTI4IDIuNjIyIDMuMjY3IDQuMjE4IDQuNzc5IDMuNTY3IiBmaWxsPSIjZmJkOWJkIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNjguNSA0MDkuNDYpIj4KPHBhdGggZD0ibTAgMHMtMC40NDcgMTAuNjcxLTMuMzg0IDE0LjcxMmMtNS4zMjgtMTEuNzE4LTI0Ljc2NSAwLjM5Ni0yOS44NjgtMTcuMDYxLTQuNjg2IDguMTYtMi43MDMgMTcuOTg1IDAuNTI4IDIyLjYzMiA2LjIzNyA4Ljk2NyAxOS41OTkgMTAuOTU2IDI4LjcyMiAyLjc5OSA2LjMzMy01LjY2MSA3Ljc5MS0xNS4zMjEgNC4wMDItMjMuMDgyIiBmaWxsPSIjYTE0MDBmIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3NC4wNjkgMzMzLjQ5KSI+CjxwYXRoIGQ9Im0wIDAtMS42MjYgMjEuODc2Yy0xLjQwNCA1Ljc5Ni04LjkxMyA1LjEwMy03LjgxNS0yLjA4MmwxLjk4My0yMC44NDR6IiBmaWxsPSIjODk2NDRjIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMDcuOTIgMzMzLjQ5KSI+CjxwYXRoIGQ9Im0wIDAgMS42MjkgMjEuODc2YzEuNDA0IDUuNzk2IDguOTkxIDUuNjY3IDcuODkzLTEuNTIxbC0yLjA2NC0yMS40MDV6IiBmaWxsPSIjODk2NDRjIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMDUuMyAzODUuOCkiPgo8cGF0aCBkPSJtMCAwIDQuNTQyLTMwLjg4NWMwLjU1NS0zLjc2NSA4LjA2MS0xLjcwNCA3Ljk4NiAxLjc3OWwtMC41OTQgMjguMTc2Yy0wLjE5MiA5LjA2OS0xMy4xODIgOS40NDEtMTEuOTM0IDAuOTMiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEwOS43NCAzOTEuOTYpIj4KPHBhdGggZD0ibTAgMC03LjE1NS01My41MDVoLTIzLjk4MmwtNi4yMTkgNTMuNTA1eiIgZmlsbD0iIzg5NjQ0YyIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNzkuMzg0IDI2NS4zOCkiPgo8cGF0aCBkPSJtMCAwYy0yLjY1OC0zLjg0My02LjE5NS02LjA1Ny03LjA4LTguODMyLTAuNTAxLTEuNTY2LTAuMTI5LTMuNTQ5IDEuNDY0LTMuNzQ3IDYuODU4LTAuODQ2IDguODUzIDIuNTIzIDExLjI5MiAzLjIwNCA0LjIyMSAxLjE4OCA0LjMzMiAzLjYxMiAyLjYyMiA5LjM3NXMtNi4xNjUgMy42LTguMjk4IDAiIGZpbGw9IiM4OTY0NGMiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEwOC41NSAzMzQuMTQpIj4KPHBhdGggZD0ibTAgMGMtMC4zMDYgMC4yMDctMC42ODEtMC4yMDQtMC43MDgtMC41NjRsLTAuMzk5LTUuMjk1Yy0wLjAyMS0wLjM2IDAuMzE4LTAuNTM0IDAuNjI0LTAuNzQxIDAuMzAzLTAuMjAxIDAuNjgxIDAuMjA3IDAuNzA4IDAuNTY0bDAuMzk2IDUuMjk1YzAuMDI0IDAuMzYtMC4yNTggMC42OTYtMC42MjEgMC43NDEiIGZpbGw9IiM4OTY0NGMiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEwNy44MyAzMzEuODgpIj4KPHBhdGggZD0iTSAwLDAgMC4xNzQsMi4yOCA3LjY5NSwxLjE5NyA3LjUyNCwtMS4wOCBDIDYuNzk4LC03LjkzOCAtMC44NTUsLTguMzI1IDAsMCIgZmlsbD0iIzg5NjQ0YyIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNzMuNDM3IDMzNC4xNCkiPgo8cGF0aCBkPSJtMCAwYzAuMzA2IDAuMjA3IDAuNjgxLTAuMjA0IDAuNzA4LTAuNTY0bDAuMzk5LTUuMjk1YzAuMDI3LTAuMzYtMC4zMTgtMC41MzQtMC42MjEtMC43NDEtMC4zMDYtMC4yMDEtMC42ODEgMC4yMDctMC43MDggMC41NjRsLTAuMzk5IDUuMjk1Yy0wLjAyNyAwLjM2IDAuMjU4IDAuNjk2IDAuNjIxIDAuNzQxIiBmaWxsPSIjODk2NDRjIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3NC4xNTggMzMxLjg4KSI+CjxwYXRoIGQ9Im0wIDAtMC4xNjggMi4yOC03LjUyNy0xLjA4MyAwLjE3NC0yLjI3N2MwLjcyOS02Ljg1OCA4LjM3OS03LjI0NSA3LjUyMSAxLjA4IiBmaWxsPSIjODk2NDRjIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg5OC4zMDggNDEwLjk0KSI+CjxwYXRoIGQ9Im0wIDB2LTIxLjU2NGMtMy45ODctNS4yMzUtMTAuNTAzLTUuMDU4LTE0LjQ4NyAwdjIxLjU2NGMwIDkuNTg4IDE0LjQ4NyA5LjU4MiAxNC40ODcgMCIgZmlsbD0iIzg5NjQ0YyIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTAzLjA0IDI2NS4zOCkiPgo8cGF0aCBkPSJtMCAwYzIuNjU4LTMuODQzIDYuMTk1LTYuMDU3IDcuMDc3LTguODMyIDAuNTAxLTEuNTY2IDAuMTMyLTMuNTQ5LTEuNDYxLTMuNzQ3LTYuODYxLTAuODQ2LTguODUzIDIuNTIzLTExLjI5MiAzLjIwNC00LjIyNCAxLjE4OC00LjMzMiAzLjYxMi0yLjYyNSA5LjM3NXM2LjE2MiAzLjYgOC4zMDEgMCIgZmlsbD0iIzg5NjQ0YyIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNzQuNTMgMjU5Ljg4KSI+CjxwYXRoIGQ9Im0wIDBjLTEuMDMyLTEuMTE5LTEuODYtMi4xNzUtMi4yMjYtMy4zMy0xLjI5My00LjA1MyAyLjMxOS00LjE1OCA1LjI2OC0zLjc3NyAzLjkzMyAwLjUwNCA1LjU3MSAyLjY5NyA3LjQ4OCAzLjIzMSAzLjc4OSAxLjA2NSA0LjI2MyAzLjEzMiAzLjA4MSA3LjcxOS0wLjE1OS0zLjk5OS0zLjkwMy01LjA4OC04LjA2MS03LjA1OS00LjE1NS0xLjk3NC03LjUwNi0wLjAyMS01LjU1IDMuMjE2IiBmaWxsPSIjY2MxYjc0IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMDcuOSAyNTkuODgpIj4KPHBhdGggZD0ibTAgMGMxLjAzMi0xLjExOSAxLjg2LTIuMTc1IDIuMjI2LTMuMzMgMS40NzktNC42NDEtMy43ODktNC4yOS02Ljc2OC0zLjQ4LTIuODg5IDAuNzgtNC4zMzUgMi40NzUtNS45ODggMi45MzQtMy43OTUgMS4wNjUtNC4yNjMgMy4xMzItMy4wODEgNy43MTkgMC4xNTktMy45OTkgMy45MDMtNS4wODggOC4wNTgtNy4wNTkgNC4xNTgtMS45NzQgNy41MDktMC4wMjEgNS41NTMgMy4yMTYiIGZpbGw9IiNjYzFiNzQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDczLjEgMzQ2LjUyKSI+CjxwYXRoIGQ9Im0wIDAtMS4yMjcgMTIuNTRjLTEuNDA0IDUuNzk2LTguNyAzLjU2MS03LjYwMi0zLjYyN2wwLjc0Ny05LjUxNnoiIGZpbGw9IiNjYzFiNzQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDc2LjY4MiAzODUuOCkiPgo8cGF0aCBkPSJtMCAwLTQuNTM5LTMwLjg4NWMtMC41NTgtMy43NjUtOC4wNTgtMS43MDQtNy45ODkgMS43NzlsMC41OTQgMjguMTc2YzAuMTg5IDkuMDY5IDEzLjE4OCA5LjQ0MSAxMS45MzQgMC45MyIgZmlsbD0iI2NjMWI3NCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTA1LjMxIDM4NS44KSI+CjxwYXRoIGQ9Im0wIDBjLTEuMjU0IDguNTExIDExLjc0NSA4LjEzOSAxMS45MzQtMC45M2wwLjU5NC0yOC4xNzZjMC4wNjktMy40ODMtNy40MzEtNS41NDQtNy45ODktMS43Nzl6IiBmaWxsPSIjY2MxYjc0IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMDguNTcgMzkwLjc2KSI+CjxwYXRoIGQ9Im0wIDAgMC4zMDMtMTQuMzMxLTIuMTIxLTM3Ljk4aC0zMS4zNzdsLTIuMDg4IDM3LjQxOS04LjY2NCAzLjA5OSAwLjEyNiA1LjkxYzExLjA4OCAxMi43OCAxOC44NDYtNy45ODYgMzUuNTQxIDIuOTk3eiIgZmlsbD0iI2NjMWI3NCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNzIuMzg3IDM5MS45NikiPgo8cGF0aCBkPSJtMCAwYzIxLjU4OC0xMi4yNDYgMjguMjktMi41NSAzNy4zNTYgMC02LjExNC0xLjcxOS0xNy40OTMtMTkuODUxLTM3LjM1NiAwIiBmaWxsPSIjY2MxYjc0IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMDYuNDUgMzc4LjA0KSI+CjxwYXRoIGQ9Im0wIDAgMy4yNDYtMjIuMTUyczcuODQ1LTIuNjU1IDcuODk5LTIuMDQzYzAuMDU0IDAuNjE1LTAuMzU0IDMxLjAzNS0wLjM1NCAzMS4wMzV6IiBmaWxsPSIjY2MxYjc0IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMDguODYgMzQ2LjUyKSI+CjxwYXRoIGQ9Im0wIDAgMS4wOCAxMi4xMTRjMS40MDQgNS43OTYgOC43NTQgMi4zOTcgNy42NTYtNC43OTFsLTAuNjYtNy45MjZ6IiBmaWxsPSIjY2MxYjc0IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg5OC4zMDggNDA3LjI4KSI+CjxwYXRoIGQ9Im0wIDB2LTExLjg4Yy0yLjc0Mi0yLjE0Mi01LjM4NS0zLjM0OC03LjI0NS0zLjM0OHMtNC41MDMgMS4yMDYtNy4yNDIgMy4zNDh2MTEuODhjMCA5LjU4OCAxNC40ODcgOS41ODggMTQuNDg3IDAiIGZpbGw9IiM3NTU1NDMiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDkxLjA2NCAzOTUuMDEpIj4KPHBhdGggZD0ibTAgMGMtNC43MTYgMC0xNC42NzkgNy40MTYtMTcuNzYgMTguMDM2LTMuMTE0IDEwLjcyNSAyLjc0NSAyNi4xMDYgMTcuNzYgMjYuMTA2czIwLjg3NC0xNS4zODEgMTcuNzYtMjYuMTA2Yy0zLjA3OC0xMC42MjMtMTMuMDQ0LTE4LjAzNi0xNy43Ni0xOC4wMzYiIGZpbGw9IiM4OTY0NGMiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDY5LjQzMyA0MTkuNTEpIj4KPHBhdGggZD0ibTAgMGMxLjUxNSAwLjY1MSAzLjY1Ny0wLjk0OCA0Ljc4OC0zLjU2NyAxLjEyNS0yLjYyMiAwLjgxLTUuMjgtMC43MDgtNS45MzEtMS41MTUtMC42NTEtMy42NiAwLjk0Mi00Ljc4OCAzLjU3LTEuMTI1IDIuNjE5LTAuODEgNS4yNzcgMC43MDggNS45MjgiIGZpbGw9IiM4OTY0NGMiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDExMS4zIDQxOS41MSkiPgo8cGF0aCBkPSJtMCAwYzEuNTE4LTAuNjUxIDEuODM5LTMuMzA5IDAuNzA4LTUuOTI4LTEuMTI1LTIuNjIyLTMuMjczLTQuMjIxLTQuNzg4LTMuNTctMS41MTggMC42NTEtMS44MzYgMy4zMDktMC43MDggNS45MzEgMS4xMjUgMi42MjUgMy4yNzMgNC4yMjEgNC43ODggMy41NjciIGZpbGw9IiM4OTY0NGMiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDczLjQ0OSA0MTUuOTYpIj4KPHBhdGggZD0iTSAwLDAgQyAyLjk3OSw0LjEyOCA1LjExMiw2LjY5OSA2LjczNSwxMy4xMSAxNi4yNiwwLjQ4NiAyNC42OTYsMC4yNDMgMzUuNDcyLC0wLjI4OCA0Mi43OCwyMC43NDIgMjkuNTc0LDI2LjUxMSAxOC4yNjQsMjYuNTExIDguMjI2LDI2LjUxMSAtOC44NSwyNC45MjcgMCwwIiBmaWxsPSIjM2YxZjBkIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMDIuOTMgMjY1LjYxKSI+CjxwYXRoIGQ9Im0wIDAgMy44MTkgNzMuMDQxaC0zMS4yOTNsMy43NDQtNzJoOC43MjdsMy4zMzMgNTguMDY4IDMuMzk2LTU4LjY5OHoiIGZpbGw9IiMyODI4MjgiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg4NS40MjMgNDA0Ljk5KSI+CjxwYXRoIGQ9Im0wIDBjMi40MDMgMi4zMjUgNC4yNzggMC41NzkgNS42ODUgMC41NzkgMS40MDQgMCAzLjI3NiAxLjc0NiA1LjY4Mi0wLjU3OS0xLjI5My02LjEzOC05LjY1NC02LjMyNy0xMS4zNjcgMCIgZmlsbD0iI2ZmMzg2YSIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoODUuNDIzIDQwNC45OSkiPgo8cGF0aCBkPSJtMCAwYzIuNDAzIDIuMzI1IDQuMjc4IDAuNTc5IDUuNjg1IDAuNTc5IDEuNDAxIDAgMy4yNzYgMS43NDYgNS42ODItMC41NzktMy42NzUtMS44MTItOC44OTItMC45NjYtMTEuMzY3IDAiIGZpbGw9IiNjODIwNGEiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEwLjUwNSAzMzguMTgpIj4KPHBhdGggZD0ibTAgMC0xLjg0MiAyMS40NjhjLTEuMzggNS43MDYtOC41MzIgNS4wODgtNy40NDktMS45ODZsMS45NS0yMC41MTR6IiBmaWxsPSIjZmJkOWJkIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0My44MjIgMzM4LjE4KSI+CjxwYXRoIGQ9Im0wIDAgMS43OTcgMjEuNzhjMS4zOCA1LjcwOSA4LjY1NSA1LjMzMSA3LjU3NS0xLjc0M2wtMi4wMzEtMjEuMDY5eiIgZmlsbD0iI2ZiZDliZCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDEuMjUxIDM4OS42OCkiPgo8cGF0aCBkPSJtIDAsMCA0LjQ3MywtMzAuNDAyIGMgMC41NDMsLTMuNzA1IDcuOTMyLC0xLjY3NyA3Ljg1NywxLjc1MiBMIDExLjc0NSwtMC45MTUgQyAxMS41NTksOC4wMSAtMS4yMyw4LjM3OSAwLDAiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQ1LjYxOCAzOTUuNzQpIj4KPHBhdGggZD0ibTAgMC03LjA0NC01Mi42NjVoLTIzLjYwN2wtNi4xMTcgNTIuNjY1eiIgZmlsbD0iI2ZiZDliZCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTUuNzM2IDI3MS4xNCkiPgo8cGF0aCBkPSJtMCAwYy0yLjYxNi0zLjc4My02LjE0MS01LjczNi02Ljg4NS05LjEyOS0wLjM0NS0xLjU4MSAwLjAxMi0yLjc3OCAxLjU4MS0yLjk3NiA2Ljc1My0wLjgzMSA3Ljc4MiAyLjQ5IDEwLjE4MiAzLjE2MiA0LjE1NSAxLjE2NyA0Ljk3MSAzLjI3IDMuMjkxIDguOTQzLTEuNjgzIDUuNjczLTYuMDY5IDMuNTQzLTguMTY5IDAiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyLjA0OSAzNDMuNDIpIj4KPHBhdGggZD0ibTAgMCAzMC4zMjctMC4zNDgtMy42MzktNzEuOTMxaC03Ljg4N2wtMS45NDcgNTQuNzExYy0wLjEzMiA0LjMzNS0zLjIwNCA0LjM2Mi0zLjMzMyAwbC0xLjY2NS01NC43MTFoLTguMTY5eiIgZmlsbD0iI2ZiZDliZCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDQuNDQ2IDMzOC44MykiPgo8cGF0aCBkPSJtMCAwYy0wLjMgMC4yMDQtMC42NzItMC4yMDEtMC42OTYtMC41NTVsLTAuMzkzLTUuMjExYy0wLjAyMS0wLjM1NCAwLjMxNS0wLjUyOCAwLjYxNS0wLjcyOSAwLjI5NC0wLjIwMSAwLjY2OSAwLjIwMSAwLjY5NiAwLjU1MmwwLjM4NyA1LjIxNGMwLjAyNyAwLjM1NC0wLjI1MiAwLjY4Ny0wLjYwOSAwLjcyOSIgZmlsbD0iI2ZiZDliZCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDMuNzM1IDMzNi42KSI+CjxwYXRoIGQ9Ik0gMCwwIDAuMTcxLDIuMjQ0IDcuNTc1LDEuMTc2IDcuNDA3LC0xLjA2MiBDIDYuNjksLTcuODE1IC0wLjg0LC04LjE5MyAwLDAiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDkuODgyMyAzMzguODMpIj4KPHBhdGggZD0ibTAgMGMwLjMgMC4yMDQgMC42NzItMC4yMDEgMC42OTYtMC41NTVsMC4zOTMtNS4yMTFjMC4wMjctMC4zNTQtMC4zMTUtMC41MjgtMC42MDktMC43MjktMC4zLTAuMjAxLTAuNjcyIDAuMjAxLTAuNjk5IDAuNTUybC0wLjM5IDUuMjE0Yy0wLjAyNyAwLjM1NCAwLjI1MiAwLjY4NyAwLjYwOSAwLjcyOSIgZmlsbD0iI2ZiZDliZCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTAuNTkyIDMzNi42KSI+CjxwYXRoIGQ9Im0wIDAtMC4xNjUgMi4yNDQtNy40MS0xLjA2OCAwLjE3MS0yLjIzOGMwLjcxNy02Ljc1MyA4LjI1LTcuMTMxIDcuNDA0IDEuMDYyIiBmaWxsPSIjZmJkOWJkIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzNC4zNjQgNDE0LjQyKSI+CjxwYXRoIGQ9Im0wIDB2LTIxLjIyOGMtMy45MjQtNS4xNTEtMTAuMzM4LTQuOTc3LTE0LjI2MiAwdjIxLjIyOGMwIDkuNDM1IDE0LjI2MiA5LjQzMiAxNC4yNjIgMCIgZmlsbD0iI2ZiZDliZCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzkuMDIzIDI3MS4xNCkiPgo8cGF0aCBkPSJtMCAwYzIuNjE2LTMuNzgzIDYuNDM1LTUuOTIyIDYuMjMxLTguODA1LTAuMTExLTEuNjE0IDAuMTE3LTIuOTY0LTEuNDUyLTMuMTU5LTYuNzUzLTAuODM0LTcuMjU3IDIuMzAxLTkuNjU3IDIuOTczLTQuMTYxIDEuMTctNC45NzEgMy4zMTgtMy4yOTQgOC45OTEgMS42ODMgNS42NzMgNi4wNjkgMy41NDMgOC4xNzIgMCIgZmlsbD0iI2ZiZDliZCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTAuOTU4IDI2NS43MykiPgo8cGF0aCBkPSJtMCAwYy0xLjAxNC0xLjEwMS0xLjgzLTIuMTM5LTIuMTktMy4yNzktMS4yNzUtMy45ODcgMi4yODMtNC4wOTIgNS4xODQtMy43MTcgMy44NzMgMC40OTggNS40ODQgMi42NTUgNy4zNzEgMy4xODMgMy43MzIgMS4wNDQgNC4xOTcgMy4wODEgMy4wMzMgNy41OTYtMC4xNTYtMy45MzYtMy44NDMtNS4wMDctNy45MzUtNi45NDgtNC4wODktMS45NDQtNy4zODktMC4wMjEtNS40NjMgMy4xNjUiIGZpbGw9IiNjYzFiNzQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQzLjgwMSAyNjUuNzMpIj4KPHBhdGggZD0ibTAgMGMxLjAxNC0xLjEwMSAxLjgzLTIuMTM5IDIuMTkzLTMuMjc5IDEuNDU1LTQuNTY2LTMuNzMyLTQuMjI0LTYuNjY2LTMuNDI2LTIuODQxIDAuNzY4LTQuMjY2IDIuNDM5LTUuODkyIDIuODkyLTMuNzM1IDEuMDQ0LTQuMTk3IDMuMDgxLTMuMDMzIDcuNTk2IDAuMTU2LTMuOTM2IDMuODQzLTUuMDA3IDcuOTMyLTYuOTQ4IDQuMDkyLTEuOTQ0IDcuMzkyLTAuMDIxIDUuNDY2IDMuMTY1IiBmaWxsPSIjY2MxYjc0IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMy4wNzcgMzg5LjY4KSI+CjxwYXRoIGQ9Im0wIDAtNC40NjctMzAuNDAyYy0wLjU0OS0zLjcwNS03LjkzMi0xLjY3Ny03Ljg2MyAxLjc1MmwwLjU4MiAyNy43MzVjMC4xODkgOC45MjUgMTIuOTgxIDkuMjk0IDExLjc0OCAwLjkxNSIgZmlsbD0iI2NjMWI3NCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDEuMjUxIDM4OS42OCkiPgo8cGF0aCBkPSJtMCAwYy0xLjIzMyA4LjM3OSAxMS41NTkgOC4wMSAxMS43NDgtMC45MTVsMC41ODItMjcuNzM1YzAuMDY5LTMuNDI5LTcuMzE0LTUuNDU3LTcuODYzLTEuNzUyeiIgZmlsbD0iI2NjMWI3NCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDQuNDY1IDM5NC41NikiPgo8cGF0aCBkPSJtMCAwIDAuMjk3LTE0LjEwNi0yLjA4NS0zNy4zODNoLTMwLjg4OGwtMi4wNTUgMzYuODMxLTguNTI2IDMuMDUxIDAuMTIgNS44MTdjMTAuOTE3IDEyLjU3OSAxOC40MjYtNy43MTYgMzQuODYgMy4wOTN6IiBmaWxsPSIjY2MxYjc0IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg4Ljg0OTEgMzk1Ljc0KSI+CjxwYXRoIGQ9Im0wIDBjOS42MjctMC44MDQgMjcuNzI5LTEuNDc2IDM3LjQwNy0wLjAxNS02LjE4My0wLjkzMy0xNy44NTMtMTkuNTI3LTM3LjQwNyAwLjAxNSIgZmlsbD0iI2NjMWI3NCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDIuMzc2IDM4Mi4wNCkiPgo8cGF0aCBkPSJtMCAwIDMuMTk1LTIxLjgwN3M3LjcyMi0yLjYxIDcuNzc2LTIuMDFjMC4wNTEgMC42MDYtMC4zNTEgMzAuNTUyLTAuMzUxIDMwLjU1MnoiIGZpbGw9IiNjYzFiNzQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDkuNTUwOCAzNTEuMDEpIj4KPHBhdGggZD0ibTAgMC0xLjIwNiAxMi4zNDJjLTEuMzgzIDUuNzA2LTguNTY1IDMuNTA3LTcuNDg1LTMuNTY3bDAuNzM1LTkuMzY5eiIgZmlsbD0iI2NjMWI3NCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDQuNzQ3IDM1MS4wMSkiPgo8cGF0aCBkPSJtMCAwIDEuMDYyIDExLjkyNWMxLjM4MyA1LjcwNiA4LjYxOSAyLjM1OCA3LjUzOS00LjcxNmwtMC42NTEtNy44MDN6IiBmaWxsPSIjY2MxYjc0IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzNC4zNjQgNDEwLjgyKSI+CjxwYXRoIGQ9Im0wIDB2LTExLjY5NGMtMi42OTctMi4xMDktNS4zMDEtMy4yOTQtNy4xMzEtMy4yOTRzLTQuNDMxIDEuMTg1LTcuMTMxIDMuMjk0djExLjY5NGMwIDkuNDM1IDE0LjI2MiA5LjQzNSAxNC4yNjIgMCIgZmlsbD0iI2VjYzJhMCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjcuMjMzIDM5OC43NCkiPgo8cGF0aCBkPSJtMCAwYy00LjY0MSAwLTE0LjQ0OCA3LjMwMi0xNy40ODEgMTcuNzUxLTMuMDY2IDEwLjU1NyAyLjcgMjUuNzAxIDE3LjQ4MSAyNS43MDFzMjAuNTQ3LTE1LjE0NCAxNy40ODEtMjUuNzAxYy0zLjAyNy0xMC40NTUtMTIuODQtMTcuNzUxLTE3LjQ4MS0xNy43NTEiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIxLjQxMSA0MTIuNTcpIj4KPHBhdGggZD0ibTAgMGMxLjUyNC0xLjE5NCAxMC4xMjItMS4xMzEgMTEuNjQ2IDAtMS4zMjYtNi4yODgtOS44OTEtNi40OC0xMS42NDYgMCIgZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNS45NDEyIDQyMi44NikiPgo8cGF0aCBkPSJtMCAwYzEuNDkxIDAuNjQyIDMuNi0wLjkzMyA0LjcxMy0zLjUxMyAxLjEwNy0yLjU4IDAuNzk4LTUuMTk2LTAuNjk5LTUuODM1LTEuNDkxLTAuNjQyLTMuNiAwLjkyNy00LjcxIDMuNTEzLTEuMTA3IDIuNTgtMC43OTggNS4xOTMgMC42OTYgNS44MzUiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQ3LjE1MiA0MjIuODUpIj4KPHBhdGggZD0ibTAgMGMxLjQ5NC0wLjYzOSAxLjgwOS0zLjI1NSAwLjY5Ni01LjgzNS0xLjEwNC0yLjU4My0zLjIxOS00LjE1NS00LjcxLTMuNTEzLTEuNDk3IDAuNjM5LTEuODA5IDMuMjU1LTAuNjk5IDUuODM1IDEuMTA3IDIuNTg2IDMuMjIyIDQuMTU4IDQuNzEzIDMuNTEzIiBmaWxsPSIjZmJkOWJkIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0NC40NTUgNDE5LjM2KSI+CjxwYXRoIGQ9Im0wIDBjOC43MTIgMjQuNTM0LTguMSAyNi4wOTQtMTcuOTc5IDI2LjA5NC0xMS4xMzMgMC0yNC4xMjktNS42NzktMTYuOTM4LTI2LjM3NiAxMC42MDggMC41MjIgMTkuOTM1IDYuNDM4IDI5LjMxIDE4Ljg2NCAxLjU5Ni02LjMxMiAyLjY3My0xNC41MiA1LjYwNy0xOC41ODIiIGZpbGw9IiNkNTZjMmIiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDM4LjkxNyAyNzEuNjIpIj4KPHBhdGggZD0ibTAgMCAzLjc1OSA3MS40NTEtMzAuODg1IDEuMjI3IDMuNzY4LTcxLjY0Nmg4LjU4OWwzLjI4MiA1Ny4wMjcgMy4zNDItNTcuNzE0eiIgZmlsbD0iIzI4MjgyOCIvPgo8L2c+CjxnIGNsaXAtcGF0aD0idXJsKCNmKSIgb3BhY2l0eT0iLjM5OTk5Ij4KPGcgY2xpcC1wYXRoPSJ1cmwoI2UpIj4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjE0LjUzIDM3MS45NSkiPgo8cGF0aCBkPSJtMCAwYy0yMC41NzQtMC40MTEtMjIuODc4IDIzLjg2OC0yMi4xMzQgMzUuODU2IDEuMzkyIDIyLjM1MyAyMS42ODEgMzEuMzE3IDI5Ljk1OCAyMy42NCA4LjgwNSAwIDEyLjkzMy0xMC45MzIgMTMuOTI2LTIzLjQyNCAxLjMyMy0xNi42MjktNC44MDMtMzUuNzMtMjEuNzUtMzYuMDcyIiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjAzLjA2IDI2Mi40MikiPgo8cGF0aCBkPSJtMCAwYy0yLjUwNS0zLjYzLTUuODQ0LTUuNzEyLTYuNjc1LTguMzM0LTAuNDcxLTEuNDc2LTAuMTItMi4yOCAxLjM4My0yLjQ2MyA2LjQ3MS0wLjgwMSA4LjM0NiAxLjMwOCAxMC42NSAxLjk1NiAzLjk4MSAxLjExMyA0LjA4NiAzLjQwMiAyLjQ3NSA4Ljg0MS0xLjYxNCA1LjQzMy01LjgxNCAzLjM5My03LjgzMyAwIiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTk5LjI4IDMzMS4zNCkiPgo8cGF0aCBkPSJtMCAwaDI5LjU5OGwtMy43NzctNjguOTI4aC03LjgzbC0xLjU5MyA1Mi40MjVjLTAuMTI5IDQuMTU1LTMuMDY5IDQuMTgyLTMuMjAxIDBsLTEuNTktNTIuNDI1aC03LjgzeiIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIzMS43IDM4MS44MikiPgo8cGF0aCBkPSJtMCAwLTMuMzUxLTUwLjQ3NWgtMjguNzA3bC0zLjE4IDUwLjQ3NXoiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMjcuMzcgMzc2LjAxKSI+CjxwYXRoIGQ9Im0wIDAgNC4yODEtMjkuMTNjMC41MjItMy41NTUgNy42MDItMS42MDggNy41MzYgMS42NzRsLTAuNTU4IDI2LjU4M2MtMC4xOCA4LjU1LTEyLjQ0MSA4LjkwNC0xMS4yNTkgMC44NzMiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMzAuNDMgMzI3LjI4KSI+CjxwYXRoIGQ9Im0wIDBjLTAuMjg1IDAuMTkyLTAuNjQ1LTAuMTk1LTAuNjY5LTAuNTM0bC0wLjM3Mi00Ljk5NWMtMC4wMjQtMC4zMzkgMC4zLTAuNTA3IDAuNTg1LTAuNjk5czAuNjQyIDAuMTk4IDAuNjY5IDAuNTM0bDAuMzcyIDQuOTk4YzAuMDI0IDAuMzM2LTAuMjQgMC42NTEtMC41ODUgMC42OTYiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMjkuNzUgMzI1LjE0KSI+CjxwYXRoIGQ9Ik0gMCwwIDAuMTYyLDIuMTUxIDcuMjYsMS4xMzEgNy4wOTgsLTEuMDIgQyA2LjQxMSwtNy40ODggLTAuODA3LC03Ljg1MSAwLDAiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMjkuODMgMzI2LjY3KSI+CjxwYXRoIGQ9Im0wIDAgMS41MzYgMjAuNjM0YzEuMzI2IDUuNDY5IDguOTIyIDUuMzQzIDcuODg3LTEuNDM3bC0yLjM4OC0yMC4xOXoiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMDAuNTEgMzc2LjAxKSI+CjxwYXRoIGQ9Im0wIDAtNC4yODctMjkuMTNjLTAuNTIyLTMuNTU1LTcuNTk5LTEuNjA4LTcuNTMgMS42NzRsMC41NjEgMjYuNTgzYzAuMTggOC41NSAxMi40MzUgOC45MDQgMTEuMjU2IDAuODczIiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTk3LjQ1IDMyNy4yOCkiPgo8cGF0aCBkPSJtMCAwYzAuMjg4IDAuMTkyIDAuNjQyLTAuMTk1IDAuNjY5LTAuNTM0bDAuMzc1LTQuOTk1YzAuMDIxLTAuMzM5LTAuMy0wLjUwNy0wLjU4OC0wLjY5OS0wLjI4NS0wLjE5Mi0wLjY0NSAwLjE5OC0wLjY2OSAwLjUzNGwtMC4zNzIgNC45OThjLTAuMDI3IDAuMzM2IDAuMjQzIDAuNjUxIDAuNTg1IDAuNjk2IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTk4LjEzIDMyNS4xNCkiPgo8cGF0aCBkPSJtMCAwLTAuMTYyIDIuMTUxLTcuMDk4LTEuMDIgMC4xNjUtMi4xNTFjMC42ODctNi40NjggNy45MDItNi44MzEgNy4wOTUgMS4wMiIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE5OC4wNSAzMjYuNjcpIj4KPHBhdGggZD0ibTAgMC0xLjUzMyAyMC42MzRjLTEuMzI2IDUuNDY5LTguOTI1IDUuMzQzLTcuODktMS40MzdsMi4zODgtMjAuMTl6IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTk5LjI4IDMzMS4zNCkiPgo8cGF0aCBkPSJtMCAwIDEuMDk1LTQxLjM4NWgyNy4zM2wxLjE3MyA0MS4zODUtMTQuOTc5IDE4Ljc1OXoiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMjUuMTIgMjYyLjQyKSI+CjxwYXRoIGQ9Im0wIDBjMi41MDItMy42MyA1LjgzOC01LjcxMiA2LjY3NS04LjMzNCAwLjQ3MS0xLjQ3NiAwLjEyLTIuMjgtMS4zODMtMi40NjMtNi40NzEtMC44MDEtOC4zNDkgMS4zMDgtMTAuNjUgMS45NTYtMy45ODEgMS4xMTMtNC4wODYgMy40MDItMi40NzUgOC44NDEgMS42MTQgNS40MzMgNS44MTQgMy4zOTMgNy44MzMgMCIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE5OC40OCAyNTcuMjIpIj4KPHBhdGggZD0ibTAgMGMtMC45NzUtMS4wNTMtMS43NTUtMi4wNTItMi4xLTMuMTQxLTEuMjIxLTMuODIyIDIuMTg0LTMuOTI0IDQuOTY4LTMuNTY0IDMuNzExIDAuNDgzIDUuMjU2IDIuNTQ0IDcuMDY1IDMuMDU0IDMuNTczIDEuMDAyIDQuMDIgMi45NTIgMi45MDcgNy4yODEtMC4xNTYtMy43NzctMy42ODQtNC44MDMtNy42MDgtNi42NjMtMy45MTgtMS44NTctNy4wOC0wLjAyMS01LjIzMiAzLjAzMyIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIyOS42OSAyNTcuMjIpIj4KPHBhdGggZD0ibTAgMGMwLjk3Mi0xLjA1MyAxLjc1NS0yLjA1MiAyLjEtMy4xNDEgMS4zOTgtNC4zNzQtMy41NzYtNC4wNDQtNi4zODEtMy4yODItMi43MjcgMC43MzgtNC4wOTUgMi4zMzQtNS42NTIgMi43NzItMy41NzYgMS4wMDItNC4wMjMgMi45NTItMi45MDcgNy4yODEgMC4xNS0zLjc3NyAzLjY4NC00LjgwMyA3LjYwOC02LjY2MyAzLjkyMS0xLjg1NyA3LjA4LTAuMDIxIDUuMjMyIDMuMDMzIiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjE0LjA0IDMzMS4zNCkiPgo8cGF0aCBkPSJtMCAwaC0xNC43NmwtMi40MTggMzUuNTU5IDEwLjM0NCAxNC45MTZoMTMuNjY4bDkuOTY2LTE0LjkxNi0yLjA0My0zNS41NTl6IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjIwLjg4IDM5OS41NCkiPgo8cGF0aCBkPSJtMCAwdi0xNy43MjRjMC0xMS4xMDYtMTMuNjY4LTEwLjg4NC0xMy42NjggMHYxNy43MjRjMCA5LjAzOSAxMy42NjggOS4wMzkgMTMuNjY4IDAiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMjAuODggMzk5LjU0KSI+CjxwYXRoIGQ9Im0wIDB2LTExLjIxMWMtMi41ODYtMi4wMjItNS4wNzktMy4xNTMtNi44MzQtMy4xNTNzLTQuMjQ4IDEuMTMxLTYuODM0IDMuMTUzdjExLjIxMWMwIDkuMDM5IDEzLjY2OCA5LjAzOSAxMy42NjggMCIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIxNC4wNCAzODcuOTYpIj4KPHBhdGggZD0iTSAwLDAgQyAtNC40NTIsMCAtMTMuODUxLDYuOTk2IC0xNi43NTgsMTcuMDE2IC0xOS42ODksMjcuMTMyIC0xNC4xNjMsNDEuNjQzIDAsNDEuNjQzIDE0LjE2LDQxLjY0MyAxOS42ODYsMjcuMTMyIDE2Ljc1NSwxNy4wMTYgMTMuODQ4LDYuOTk2IDQuNDQ5LDAgMCwwIiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjA4LjY4IDM5OC4wNSkiPgo8cGF0aCBkPSJtMCAwYzIuMjY4IDIuMTkzIDQuMDM4IDAuNTUyIDUuMzY0IDAuNTUyIDEuMzIzIDAgMy4wOSAxLjY0NCA1LjM1OC0wLjU1Mi0xLjIyMS01Ljc5LTkuMTA1LTUuOTctMTAuNzIyIDAiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMDkuMzggMzk3Ljc0KSI+CjxwYXRoIGQ9Ik0gMCwwIEMgMS4yMzksMC4zMTggNy41NTEsMC4zODEgOS4zMjcsMC4wNzIgNy44NiwtMi42MjggMS4yMzksLTIuNDcyIDAsMCIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIwOC42OCAzOTguMDUpIj4KPHBhdGggZD0ibTAgMGMyLjI2OCAyLjE5MyA0LjAzOCAwLjU1MiA1LjM2NCAwLjU1MiAxLjMyMyAwIDMuMDkgMS42NDQgNS4zNTgtMC41NTItMy40NjgtMS43MS04LjM4OC0wLjkwOS0xMC43MjIgMCIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE5NC40OSA0MTEuMDgpIj4KPHBhdGggZD0ibTAgMGMxLjQzNCAwLjYxNSAzLjQ1Ni0wLjg5NCA0LjUyMS0zLjM2NiAxLjA1OS0yLjQ3OCAwLjc2Mi00Ljk4My0wLjY2OS01LjU5OC0xLjQzNC0wLjYxNS0zLjQ1NiAwLjg5NC00LjUxNSAzLjM2OS0xLjA2NSAyLjQ3NS0wLjc2NSA0Ljk4IDAuNjYzIDUuNTk1IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjMzLjk5IDQxMS4wOCkiPgo8cGF0aCBkPSJtMCAwYzEuNDM0LTAuNjE1IDEuNzI4LTMuMTE3IDAuNjY5LTUuNTk1LTEuMDY1LTIuNDc1LTMuMDg3LTMuOTg0LTQuNTIxLTMuMzY2LTEuNDI4IDAuNjE1LTEuNzI4IDMuMTIzLTAuNjY5IDUuNTk1IDEuMDY1IDIuNDc1IDMuMDg3IDMuOTg0IDQuNTIxIDMuMzY2IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjMyLjE1IDQwNS4xNSkiPgo8cGF0aCBkPSJtMCAwYzUuMzc2IDIzLjA1Mi0xMC44NTcgMjYuOTczLTIwLjMyNSAyNi45NzMtMTAuNjY4IDAtMTguNzA4LTEyLjY2LTE2LjkwOC0yNy4zOTkgNS42ODggMy40MjkgMTAuNzAxIDEwLjIwMyAyMy4xMzkgMjEuMjU1LTEuODA5LTMuMjQzLTUuMzM0LTkuMTQ0LTE3LjMyNS0xOS44MzkgNi40NTMtMS4wNjUgMTguNDcxIDcuMDY4IDI0Ljg3OSAxNS41NzYgMS41MjctNi4wNDggMy43MjktMTIuNjc1IDYuNTQtMTYuNTY2IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTY1LjY3IDQzMy40NykiPgo8cGF0aCBkPSJtMCAwYzIuNDM2IDEuMTM3IDkuMTcxLTYuMTc0IDYuOTg3LTE2LjU3Mi05LjM5Ni00NC43LTEyLjk2Ni00MC4yNzgtMjEuMzU3LTQwLjI3OC03LjkwOCAwLTEwLjA1LTEuMjU3LTIwLjM5NCAzOC42NDktMi4yNzcgOC43NzUgMi40MzMgMTcuMjIzIDkuNzQ0IDIxLjI4OCA3LjMxMSA0LjA1OSAxNy41NDcgNS4xOSAyNS4wMi0zLjA4NyIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzOS43OSAyNjAuNzkpIj4KPHBhdGggZD0ibTAgMGMtMi42NTItMy44NDMtNi4zNjYtNi4wNTEtNi43OTItOC45MjgtMC4yNC0xLjYyOSAwLjEwOC0yLjkxOSAxLjY5OC0zLjExNCA2Ljg0Ni0wLjg0OSA3Ljc1MiAyLjA5NyAxMC4xODggMi43ODQgNC4yMTUgMS4xNzkgNC45MDUgMy41MDEgMy4xOTggOS4yNTgtMS43MDcgNS43NTQtNi4xNTYgMy41OTEtOC4yOTIgMCIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzNS43OSAzMzMuNzYpIj4KPHBhdGggZD0ibTAgMGgzMS4zMzJsLTMuOTk2LTcyLjk3MmgtOC4yOTJsLTEuNjgzIDU1LjQ5N2MtMC4xMzggNC40MDEtMy4yNTIgNC40MzEtMy4zODcgMGwtMS42ODYtNTUuNDk3aC04LjI4OXoiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNjIuMiAzNzkuMjEpIj4KPHBhdGggZD0ibTAgMCA4LjQtMzAuOTMzYzEuMDExLTMuNjk5IDguODA1LTAuMDU0IDguMjI2IDMuMzkzbC01LjA3OSAzMC4yNjdjLTEuOTM4IDguOTEtMTMuODE1IDUuNjMxLTExLjU0Ny0yLjcyNyIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE3NC4yNSAzODEuMzgpIj4KPHBhdGggZD0ibTAgMGMtMC42NiA3LjIxMi02LjI2MSA2LjU1Mi04LjkyOCAzLjcwNWwyLjU2NS0xMi42ODd6IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTc0LjI1IDM4MS4zOCkiPgo8cGF0aCBkPSJtMCAwYy0wLjY2IDcuMjEyLTYuMjYxIDYuNTUyLTguOTI4IDMuNzA1bDIuNTY1LTEyLjY4N3oiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNDAuMiAzNzkuMjEpIj4KPHBhdGggZD0ibTAgMC04LjQtMzAuOTMzYy0xLjAxMS0zLjY5OS04LjgwNS0wLjA1NC04LjIyNiAzLjM5M2w1LjA4MiAzMC4yNjdjMS45MzUgOC45MSAxMy44MTIgNS42MzEgMTEuNTQ0LTIuNzI3IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTI4LjE1IDM4MS4zOCkiPgo8cGF0aCBkPSJtMCAwYzAuNjU0IDcuMjEyIDYuMjYxIDYuNTUyIDguOTIyIDMuNzA1bC0yLjU1OS0xMi42ODd6IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTI4LjE1IDM4MS4zOCkiPgo8cGF0aCBkPSJtMCAwYzAuNjU0IDcuMjEyIDYuMjYxIDYuNTUyIDguOTIyIDMuNzA1bC0yLjU1OS0xMi42ODd6IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTMyLjgyIDMyOS40NikiPgo8cGF0aCBkPSJtMCAwYzAuMzA2IDAuMjA0IDAuNjgxLTAuMjA3IDAuNzA4LTAuNTYxbDAuMzk5LTUuMjkyYzAuMDI0LTAuMzU0LTAuMzE4LTAuNTM3LTAuNjIxLTAuNzQxLTAuMzA2LTAuMjAxLTAuNjgxIDAuMjEtMC43MDggMC41NjdsLTAuMzk2IDUuMjg5Yy0wLjAyNyAwLjM1NyAwLjI1NSAwLjY5IDAuNjE4IDAuNzM4IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTMzLjU0IDMyNy4yKSI+CjxwYXRoIGQ9Im0wIDAtMC4xNzEgMi4yNzQtNy41MTUtMS4wODMgMC4xNzQtMi4yNzRjMC43MjktNi44NDkgOC4zNjctNy4yMzMgNy41MTIgMS4wODMiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMzMuNDUgMzI4LjgpIj4KPHBhdGggZD0ibTAgMC0xLjYyMyAyMS44NDljLTEuNDA3IDUuNzg3LTcuODE4IDQuODk5LTguMTE4LTAuMjQ5bDIuMjk1LTIyLjY0N3oiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNzAuMTEgMzg3LjE5KSI+CjxwYXRoIGQ9Im0wIDAtMi45ODUtNTMuNDI3aC0zMS4zMzJsLTIuOTg1IDUzLjQyN3oiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNDIuMDkgMzg3LjE5KSI+CjxwYXRoIGQ9Im0wIDBoMTguNTc2YzAuOTQyLTEuMTIyIDEuNTA2LTIuNTY4IDEuNTA2LTQuMTQ2IDAtMy41Ny0yLjg5Mi02LjQ2NS02LjQ1OS02LjQ2NS0xLjY2OCAwLTMuMTg2IDAuNjMzLTQuMzMyIDEuNjc0LTEuMTUyLTEuMDM4LTIuNjY3LTEuNjc0LTQuMzM4LTEuNjc0LTMuNTcgMC02LjQ2MiAyLjg5NS02LjQ2MiA2LjQ2NSAwIDEuNTc4IDAuNTY3IDMuMDI0IDEuNTA5IDQuMTQ2IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTQyLjA5IDM4Ny4xOSkiPgo8cGF0aCBkPSJtMCAwaDE4LjU3NmMwLjk0Mi0xLjEyMiAxLjUwNi0yLjU2OCAxLjUwNi00LjE0NiAwLTMuNTctMi44OTItNi40NjUtNi40NTktNi40NjUtMS42NjggMC0zLjE4NiAwLjYzMy00LjMzMiAxLjY3NC0xLjE1Mi0xLjAzOC0yLjY2Ny0xLjY3NC00LjMzOC0xLjY3NC0zLjU3IDAtNi40NjIgMi44OTUtNi40NjIgNi40NjUgMCAxLjU3OCAwLjU2NyAzLjAyNCAxLjUwOSA0LjE0NiIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzNS4xMyAzNDUuNjUpIj4KPHBhdGggZD0ibTAgMCAxLjA3Ny0zMy4wNmgzMC42MTJsMC45NjYgMzIuOTkxeiIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE2My4xNSAyNjAuNzkpIj4KPHBhdGggZD0ibTAgMGMyLjY1Mi0zLjg0MyA2LjUwMS02LjAwNiA2LjY0Mi05LjE2NSAwLjA3NS0xLjY0NCAwLjAzNi0yLjk2NC0xLjU1NC0zLjE1OS02Ljg0Ni0wLjg0OS03LjAyOSAyLjgwMi05LjQ3MSAzLjQ4OS00LjIxMiAxLjE4Mi01LjYxIDMuMDc4LTMuOTA5IDguODM1IDEuNzA3IDUuNzU0IDYuMTU2IDMuNTkxIDguMjkyIDAiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMzQuOTUgMjU1LjMpIj4KPHBhdGggZD0ibTAgMGMtMS4wMjktMS4xMTktMS44NTctMi4xNzItMi4yMjMtMy4zMjEtMS4yNTEtMy45MjcgMi4wNDMtNC4xMTMgNC45NS0zLjgxMyA0LjE1MiAwLjQzMiA1LjgyNiAyLjcxOCA3Ljc4OCAzLjI3IDMuNzg2IDEuMDU5IDQuMjU3IDMuMTI2IDMuMDc4IDcuNzA3LTAuMTU5LTMuOTk5LTYuNDcxLTYuNTc2LTguMDUyLTcuMDUzLTEuNTc4LTAuNDc3LTUuMjQ0IDEuNjUzLTUuNTQxIDMuMjEiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNjcuOTkgMjU1LjMpIj4KPHBhdGggZD0ibTAgMGMxLjAyOS0xLjExOSAxLjg1Ny0yLjE3MiAyLjIyMy0zLjMyMSAxLjMzNS00LjE4OC0yLjY0My00LjItNS42MTktMy43MjMtMy42NzIgMC41ODgtNS4yNjggMi42NTgtNy4xMTkgMy4xOC0zLjc4NiAxLjA1OS00LjI1NyAzLjEyNi0zLjA3OCA3LjcwNyAwLjE1OS0zLjk5OSA2LjQ5NS02LjkzMyA4LjE0NS03LjA1MyAxLjY0NC0wLjExNyA1Ljk4OCAyLjcyNCA1LjQ0OCAzLjIxIiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTQyLjQgMjUyLjY5KSI+CjxwYXRoIGQ9Im0wIDBjLTAuMDIxIDAuMTItMC4wNjYgMC4yNjEtMC4xMzIgMC40MTEtMC4zODQgMC44NzMtMS4zOCAxLjg0OC0yLjU2MiAyLjU4My0xLjEzNCAwLjcwMi0yLjY0MyAxLjE0OS0zLjY1MSAxLjAxNyAwLjUyMiAwLjU0IDEuMDY1IDEuMTA0IDEuNjA1IDEuNzEgMC45Ni0wLjIwNyAyLjE3Mi0wLjYzMyAzLjA1Ny0xLjE3OSAxLjQ3OS0wLjkxNSAyLjc0OC0yLjIwMiAzLjI3OS0zLjQxNCAwLjEyNi0wLjI3OSAwLjIxMy0wLjU2MSAwLjI1OC0wLjg0NnoiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNjAuNjMgMjUyLjY5KSI+CjxwYXRoIGQ9Im0wIDBjMC4wMTggMC4xMiAwLjA2IDAuMjYxIDAuMTI5IDAuNDExIDAuMzg0IDAuODczIDEuMzggMS44NDggMi41NTkgMi41ODMgMS4xMzcgMC43MDIgMi42NDYgMS4xNDkgMy42NTcgMS4wMTctMC41MjggMC41NC0xLjA2NSAxLjEwNC0xLjYxMSAxLjcxLTAuOTU3LTAuMjA3LTIuMTY5LTAuNjMzLTMuMDU0LTEuMTc5LTEuNDgyLTAuOTE1LTIuNzUxLTIuMjAyLTMuMjgyLTMuNDE0LTAuMTIzLTAuMjc5LTAuMjEtMC41NjEtMC4yNjEtMC44NDZ6IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTY5LjU4IDMyOS40NikiPgo8cGF0aCBkPSJtMCAwYy0wLjMwNiAwLjIwNC0wLjY4MS0wLjIwNy0wLjcwOC0wLjU2MWwtMC4zOTktNS4yOTJjLTAuMDI0LTAuMzU0IDAuMzIxLTAuNTM3IDAuNjIxLTAuNzQxIDAuMzA2LTAuMjAxIDAuNjgxIDAuMjEgMC43MDggMC41NjdsMC4zOTYgNS4yODljMC4wMjcgMC4zNTctMC4yNTUgMC42OS0wLjYxOCAwLjczOCIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE2OC44NiAzMjcuMikiPgo8cGF0aCBkPSJNIDAsMCAwLjE3NywyLjI3NCA3LjY4OSwxLjE5MSA3LjUxOCwtMS4wODMgQyA2Ljc4NiwtNy45MzIgLTAuODQ5LC04LjMxNiAwLDAiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNjguOTUgMzI4LjgpIj4KPHBhdGggZD0ibTAgMCAxLjYyMyAyMS44NDljMS40MDEgNS43ODcgNy45NDcgNS4zOTEgOC4yNSAwLjI0M2wtMi40MjctMjMuMTM5eiIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE1OC42MSA0MDQuMTcpIj4KPHBhdGggZD0ibTAgMHYtMTcuNzIxYy0zLjk3NS01LjIzMi0xMC40ODgtNS4wNTItMTQuNDY5IDB2MTcuNzIxYzAgOS41NzMgMTQuNDY5IDkuNTczIDE0LjQ2OSAwIiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTU4LjYxIDQwNS40NSkiPgo8cGF0aCBkPSJtMCAwdi0xMS44NjhjLTIuNzM2LTIuMTM5LTUuMzczLTMuMzM5LTcuMjMtMy4zMzktMS44NjMgMC00LjUwMyAxLjItNy4yMzkgMy4zMzl2MTEuODY4YzAgOS41NjcgMTQuNDY5IDkuNTY3IDE0LjQ2OSAwIiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTUxLjM4IDM5My4xOSkiPgo8cGF0aCBkPSJtIDAsMCBjIC00LjcxMywwIC0xNC42NjEsNy40MDcgLTE3LjczOSwxOC4wMTUgLTMuMTA1LDEwLjcxIDIuNzQ1LDI2LjA3IDE3LjczOSwyNi4wNyA2LjA4MSwwIDEwLjY1NiwtMi41MjkgMTMuNzQzLC02LjI0OSA0LjUxOCwtNS40NTEgNS44MzgsLTEzLjQ1OCAzLjk5MywtMTkuODIxIEMgMTQuNjU4LDcuNDA3IDQuNzEsMCAwLDAiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMzUuNjUgNDE2LjMyKSI+CjxwYXRoIGQ9Im0wIDBjMC40NjggMC4xNzcgMi45NzkgMS4wMiA3LjU3MiAwLjcwOHYtMC40MzhjLTIuMjcxIDAuMTExLTQuNTQyLTAuMDYzLTUuMTk2LTAuNjY5LTEuMjQ1LTEuMTUyLTEuMDgtMy42MyAwLjYwOS00Ljc5NyAwLjgzNC0wLjU3NiAyLjc1NC0wLjkwMyA0LjU4Ny0wLjk4N3YtMC40MjljLTIuMjQ0IDAuMTExLTQuNzk0IDAuNTI4LTUuNTIzIDEuNTA5LTEuMTM0IDEuNTI3LTEuNTI3IDIuNzQ1LTIuMDEgMy4wNTEtMC40NzcgMC4zMDYtMC42MDkgMS44MzktMC4wMzkgMi4wNTJtNy41NzIgMC43MDggMC4xODktMC4wMTVjNC43MS0wLjM0NSA1LjcxMi0xLjI2MyA2LjE5NS0xLjIxOCAwLjU1OCAwLjA1MSAxLjE2NyAwLjEyNiAxLjczNyAwLjEyNiAwLjU3NiAwIDEuMjIxLTAuMDc1IDEuODAzLTAuMTI2IDAuNDgzLTAuMDQ1IDEuNDg4IDAuODczIDYuMTk1IDEuMjE4bDAuMTkyIDAuMDE1di0wLjQzOGgtMC4wMjRjLTIuMjc3LTAuMTExLTUuMjQ0LTAuNjM2LTUuODI2LTEuOTQxLTAuNTg1LTEuMzA1IDAuNTI1LTMuNjM2IDIuMTM2LTQuMjE4IDAuNzMyLTAuMjY3IDIuMTkzLTAuMzYzIDMuNzE0LTAuMjk0di0wLjQyOWMtMS4yNDUtMC4wNi0yLjM5NC0wLjAzLTMuMDc1IDAuMDU0LTEuOTE3IDAuMjMxLTMuMzU0IDIuNTQ0LTMuNjE1IDMuMjQtMC41ODggMS41NzItMi4zNDYgMS41NzItMi45MzEgMC0wLjI2NC0wLjY5Ni0xLjY5OC0zLjAwOS0zLjYxOC0zLjI0LTAuNjgxLTAuMDg0LTEuODMzLTAuMTE0LTMuMDcyLTAuMDU0djAuNDI5YzEuNTIxLTAuMDY5IDIuOTc5IDAuMDI3IDMuNzE0IDAuMjk0IDEuNjA1IDAuNTgyIDIuNzE4IDIuOTEzIDIuMTM2IDQuMjE4LTAuNTg1IDEuMjk5LTMuNTUyIDEuODMtNS44MjkgMS45NDFoLTAuMDIxem0xNi4zMTEgMGM0LjU5IDAuMzEyIDcuMTAxLTAuNTMxIDcuNTY5LTAuNzA4IDAuNTY3LTAuMjEzIDAuNDM4LTEuNzQ2LTAuMDM5LTIuMDUyLTAuNDgzLTAuMzA2LTAuODc2LTEuNTI0LTIuMDA3LTMuMDUxLTAuNzMyLTAuOTgxLTMuMjgyLTEuMzk4LTUuNTIzLTEuNTA5djAuNDI5YzEuODMgMC4wODQgMy43NDcgMC40MTEgNC41ODEgMC45ODcgMS42OTIgMS4xNjcgMS44NTcgMy42NDUgMC42MDkgNC43OTctMC42NDggMC42MDYtMi45MjIgMC43OC01LjE5IDAuNjY5eiIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzOC4wMyA0MTUuOTIpIj4KPHBhdGggZD0ibTAgMGMwLjY1NCAwLjYwOSAyLjk0NiAwLjc4IDUuMjE3IDAuNjY5IDIuMjc3LTAuMTExIDUuMjQ0LTAuNjM2IDUuODI5LTEuOTQxIDAuNTgyLTEuMzA1LTAuNTMxLTMuNjM2LTIuMTM2LTQuMjE4LTEuNjExLTAuNTg1LTYuNzY4LTAuMzYtOC4zMDEgMC42OTMtMS42ODkgMS4xNjEtMS44NTEgMy42NDUtMC42MDkgNC43OTciIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNjQuNzIgNDE1LjkyKSI+CjxwYXRoIGQ9Im0wIDBjLTAuNjU0IDAuNjA5LTIuOTQgMC43OC01LjIxNCAwLjY2OS0yLjI3Ny0wLjExMS01LjI0NC0wLjYzNi01LjgyNi0xLjk0MS0wLjU4NS0xLjMwNSAwLjUyNS0zLjYzNiAyLjEzNi00LjIxOCAxLjYwOC0wLjU4NSA2Ljc2OC0wLjM2IDguMjk1IDAuNjkzIDEuNjkyIDEuMTYxIDEuODU0IDMuNjQ1IDAuNjA5IDQuNzk3IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTQ1LjcgNDAzLjg3KSI+CjxwYXRoIGQ9Im0wIDBjMi40IDIuMzIyIDQuMjcyIDAuNTc5IDUuNjc5IDAuNTc5IDEuNDAxIDAgMy4yNyAxLjc0MyA1LjY3My0wLjU3OS0xLjI5My02LjEyOS05LjY0Mi02LjMxOC0xMS4zNTIgMCIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE0NS43IDQwMy44NykiPgo8cGF0aCBkPSJtMCAwYzIuNCAyLjMyMiA0LjI3MiAwLjU3OSA1LjY3OSAwLjU3OSAxLjM5NSAwIDMuMjcgMS43NDMgNS42NzMtMC41NzktMy42NzItMS44MDktOC44OC0wLjk2My0xMS4zNTIgMCIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzMC4zMSA0MTUuMzYpIj4KPHBhdGggZD0ibTAgMGMxLjUxNSAwLjY1NCAzLjY1Ny0wLjk0MiA0Ljc3OS0zLjU2NCAxLjEyOC0yLjYxOSAwLjgxLTUuMjcxLTAuNzAyLTUuOTIyLTEuNTE4LTAuNjQ4LTMuNjU3IDAuOTQ4LTQuNzgyIDMuNTY3LTEuMTI4IDIuNjE5LTAuODA3IDUuMjY4IDAuNzA1IDUuOTE5IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTcyLjEyIDQxNS4zOCkiPgo8cGF0aCBkPSJtMCAwYzEuNTE4LTAuNjUxIDEuODM2LTMuMzAzIDAuNzA4LTUuOTI1LTEuMTIyLTIuNjE5LTMuMjY0LTQuMjE1LTQuNzgyLTMuNTY0LTEuNTE1IDAuNjQ4LTEuODMgMy4zMDMtMC43MDUgNS45MjIgMS4xMjggMi42MjIgMy4yNjcgNC4yMTggNC43NzkgMy41NjciIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNjguNSA0MDkuNDYpIj4KPHBhdGggZD0ibTAgMHMtMC40NDcgMTAuNjcxLTMuMzg0IDE0LjcxMmMtNS4zMjgtMTEuNzE4LTI0Ljc2NSAwLjM5Ni0yOS44NjgtMTcuMDYxLTQuNjg2IDguMTYtMi43MDMgMTcuOTg1IDAuNTI4IDIyLjYzMiA2LjIzNyA4Ljk2NyAxOS41OTkgMTAuOTU2IDI4LjcyMiAyLjc5OSA2LjMzMy01LjY2MSA3Ljc5MS0xNS4zMjEgNC4wMDItMjMuMDgyIiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNzQuMDY5IDMzMy40OSkiPgo8cGF0aCBkPSJtMCAwLTEuNjI2IDIxLjg3NmMtMS40MDQgNS43OTYtOC45MTMgNS4xMDMtNy44MTUtMi4wODJsMS45ODMtMjAuODQ0eiIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEwNy45MiAzMzMuNDkpIj4KPHBhdGggZD0ibTAgMCAxLjYyOSAyMS44NzZjMS40MDQgNS43OTYgOC45OTEgNS42NjcgNy44OTMtMS41MjFsLTIuMDY0LTIxLjQwNXoiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMDUuMyAzODUuOCkiPgo8cGF0aCBkPSJtMCAwIDQuNTQyLTMwLjg4NWMwLjU1NS0zLjc2NSA4LjA2MS0xLjcwNCA3Ljk4NiAxLjc3OWwtMC41OTQgMjguMTc2Yy0wLjE5MiA5LjA2OS0xMy4xODIgOS40NDEtMTEuOTM0IDAuOTMiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMDkuNzQgMzkxLjk2KSI+CjxwYXRoIGQ9Im0wIDAtNy4xNTUtNTMuNTA1aC0yMy45ODJsLTYuMjE5IDUzLjUwNXoiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3OS4zODQgMjY1LjM4KSI+CjxwYXRoIGQ9Im0wIDBjLTIuNjU4LTMuODQzLTYuMTk1LTYuMDU3LTcuMDgtOC44MzItMC41MDEtMS41NjYtMC4xMjktMy41NDkgMS40NjQtMy43NDcgNi44NTgtMC44NDYgOC44NTMgMi41MjMgMTEuMjkyIDMuMjA0IDQuMjIxIDEuMTg4IDQuMzMyIDMuNjEyIDIuNjIyIDkuMzc1cy02LjE2NSAzLjYtOC4yOTggMCIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEwOC41NSAzMzQuMTQpIj4KPHBhdGggZD0ibTAgMGMtMC4zMDYgMC4yMDctMC42ODEtMC4yMDQtMC43MDgtMC41NjRsLTAuMzk5LTUuMjk1Yy0wLjAyMS0wLjM2IDAuMzE4LTAuNTM0IDAuNjI0LTAuNzQxIDAuMzAzLTAuMjAxIDAuNjgxIDAuMjA3IDAuNzA4IDAuNTY0bDAuMzk2IDUuMjk1YzAuMDI0IDAuMzYtMC4yNTggMC42OTYtMC42MjEgMC43NDEiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMDcuODMgMzMxLjg4KSI+CjxwYXRoIGQ9Ik0gMCwwIDAuMTc0LDIuMjggNy42OTUsMS4xOTcgNy41MjQsLTEuMDggQyA2Ljc5OCwtNy45MzggLTAuODU1LC04LjMyNSAwLDAiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3My40MzcgMzM0LjE0KSI+CjxwYXRoIGQ9Im0wIDBjMC4zMDYgMC4yMDcgMC42ODEtMC4yMDQgMC43MDgtMC41NjRsMC4zOTktNS4yOTVjMC4wMjctMC4zNi0wLjMxOC0wLjUzNC0wLjYyMS0wLjc0MS0wLjMwNi0wLjIwMS0wLjY4MSAwLjIwNy0wLjcwOCAwLjU2NGwtMC4zOTkgNS4yOTVjLTAuMDI3IDAuMzYgMC4yNTggMC42OTYgMC42MjEgMC43NDEiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3NC4xNTggMzMxLjg4KSI+CjxwYXRoIGQ9Im0wIDAtMC4xNjggMi4yOC03LjUyNy0xLjA4MyAwLjE3NC0yLjI3N2MwLjcyOS02Ljg1OCA4LjM3OS03LjI0NSA3LjUyMSAxLjA4IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOTguMzA4IDQxMC45NCkiPgo8cGF0aCBkPSJtMCAwdi0yMS41NjRjLTMuOTg3LTUuMjM1LTEwLjUwMy01LjA1OC0xNC40ODcgMHYyMS41NjRjMCA5LjU4OCAxNC40ODcgOS41ODIgMTQuNDg3IDAiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMDMuMDQgMjY1LjM4KSI+CjxwYXRoIGQ9Im0wIDBjMi42NTgtMy44NDMgNi4xOTUtNi4wNTcgNy4wNzctOC44MzIgMC41MDEtMS41NjYgMC4xMzItMy41NDktMS40NjEtMy43NDctNi44NjEtMC44NDYtOC44NTMgMi41MjMtMTEuMjkyIDMuMjA0LTQuMjI0IDEuMTg4LTQuMzMyIDMuNjEyLTIuNjI1IDkuMzc1czYuMTYyIDMuNiA4LjMwMSAwIiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNzQuNTMgMjU5Ljg4KSI+CjxwYXRoIGQ9Im0wIDBjLTEuMDMyLTEuMTE5LTEuODYtMi4xNzUtMi4yMjYtMy4zMy0xLjI5My00LjA1MyAyLjMxOS00LjE1OCA1LjI2OC0zLjc3NyAzLjkzMyAwLjUwNCA1LjU3MSAyLjY5NyA3LjQ4OCAzLjIzMSAzLjc4OSAxLjA2NSA0LjI2MyAzLjEzMiAzLjA4MSA3LjcxOS0wLjE1OS0zLjk5OS0zLjkwMy01LjA4OC04LjA2MS03LjA1OS00LjE1NS0xLjk3NC03LjUwNi0wLjAyMS01LjU1IDMuMjE2IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTA3LjkgMjU5Ljg4KSI+CjxwYXRoIGQ9Im0wIDBjMS4wMzItMS4xMTkgMS44Ni0yLjE3NSAyLjIyNi0zLjMzIDEuNDc5LTQuNjQxLTMuNzg5LTQuMjktNi43NjgtMy40OC0yLjg4OSAwLjc4LTQuMzM1IDIuNDc1LTUuOTg4IDIuOTM0LTMuNzk1IDEuMDY1LTQuMjYzIDMuMTMyLTMuMDgxIDcuNzE5IDAuMTU5LTMuOTk5IDMuOTAzLTUuMDg4IDguMDU4LTcuMDU5IDQuMTU4LTEuOTc0IDcuNTA5LTAuMDIxIDUuNTUzIDMuMjE2IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNzMuMSAzNDYuNTIpIj4KPHBhdGggZD0ibTAgMC0xLjIyNyAxMi41NGMtMS40MDQgNS43OTYtOC43IDMuNTYxLTcuNjAyLTMuNjI3bDAuNzQ3LTkuNTE2eiIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDc2LjY4MiAzODUuOCkiPgo8cGF0aCBkPSJtMCAwLTQuNTM5LTMwLjg4NWMtMC41NTgtMy43NjUtOC4wNTgtMS43MDQtNy45ODkgMS43NzlsMC41OTQgMjguMTc2YzAuMTg5IDkuMDY5IDEzLjE4OCA5LjQ0MSAxMS45MzQgMC45MyIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEwNS4zMSAzODUuOCkiPgo8cGF0aCBkPSJtMCAwYy0xLjI1NCA4LjUxMSAxMS43NDUgOC4xMzkgMTEuOTM0LTAuOTNsMC41OTQtMjguMTc2YzAuMDY5LTMuNDgzLTcuNDMxLTUuNTQ0LTcuOTg5LTEuNzc5eiIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEwOC41NyAzOTAuNzYpIj4KPHBhdGggZD0ibTAgMCAwLjMwMy0xNC4zMzEtMi4xMjEtMzcuOThoLTMxLjM3N2wtMi4wODggMzcuNDE5LTguNjY0IDMuMDk5IDAuMTI2IDUuOTFjMTEuMDg4IDEyLjc4IDE4Ljg0Ni03Ljk4NiAzNS41NDEgMi45OTd6IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNzIuMzg3IDM5MS45NikiPgo8cGF0aCBkPSJtMCAwYzIxLjU4OC0xMi4yNDYgMjguMjktMi41NSAzNy4zNTYgMC02LjExNC0xLjcxOS0xNy40OTMtMTkuODUxLTM3LjM1NiAwIiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTA2LjQ1IDM3OC4wNCkiPgo8cGF0aCBkPSJtMCAwIDMuMjQ2LTIyLjE1MnM3Ljg0NS0yLjY1NSA3Ljg5OS0yLjA0M2MwLjA1NCAwLjYxNS0wLjM1NCAzMS4wMzUtMC4zNTQgMzEuMDM1eiIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEwOC44NiAzNDYuNTIpIj4KPHBhdGggZD0ibTAgMCAxLjA4IDEyLjExNGMxLjQwNCA1Ljc5NiA4Ljc1NCAyLjM5NyA3LjY1Ni00Ljc5MWwtMC42Ni03LjkyNnoiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg5OC4zMDggNDA3LjI4KSI+CjxwYXRoIGQ9Im0wIDB2LTExLjg4Yy0yLjc0Mi0yLjE0Mi01LjM4NS0zLjM0OC03LjI0NS0zLjM0OHMtNC41MDMgMS4yMDYtNy4yNDIgMy4zNDh2MTEuODhjMCA5LjU4OCAxNC40ODcgOS41ODggMTQuNDg3IDAiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg5MS4wNjQgMzk1LjAxKSI+CjxwYXRoIGQ9Im0wIDBjLTQuNzE2IDAtMTQuNjc5IDcuNDE2LTE3Ljc2IDE4LjAzNi0zLjExNCAxMC43MjUgMi43NDUgMjYuMTA2IDE3Ljc2IDI2LjEwNnMyMC44NzQtMTUuMzgxIDE3Ljc2LTI2LjEwNmMtMy4wNzgtMTAuNjIzLTEzLjA0NC0xOC4wMzYtMTcuNzYtMTguMDM2IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNjkuNDMzIDQxOS41MSkiPgo8cGF0aCBkPSJtMCAwYzEuNTE1IDAuNjUxIDMuNjU3LTAuOTQ4IDQuNzg4LTMuNTY3IDEuMTI1LTIuNjIyIDAuODEtNS4yOC0wLjcwOC01LjkzMS0xLjUxNS0wLjY1MS0zLjY2IDAuOTQyLTQuNzg4IDMuNTctMS4xMjUgMi42MTktMC44MSA1LjI3NyAwLjcwOCA1LjkyOCIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDExMS4zIDQxOS41MSkiPgo8cGF0aCBkPSJtMCAwYzEuNTE4LTAuNjUxIDEuODM5LTMuMzA5IDAuNzA4LTUuOTI4LTEuMTI1LTIuNjIyLTMuMjczLTQuMjIxLTQuNzg4LTMuNTctMS41MTggMC42NTEtMS44MzYgMy4zMDktMC43MDggNS45MzEgMS4xMjUgMi42MjUgMy4yNzMgNC4yMjEgNC43ODggMy41NjciIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3My40NDkgNDE1Ljk2KSI+CjxwYXRoIGQ9Ik0gMCwwIEMgMi45NzksNC4xMjggNS4xMTIsNi42OTkgNi43MzUsMTMuMTEgMTYuMjYsMC40ODYgMjQuNjk2LDAuMjQzIDM1LjQ3MiwtMC4yODggNDIuNzgsMjAuNzQyIDI5LjU3NCwyNi41MTEgMTguMjY0LDI2LjUxMSA4LjIyNiwyNi41MTEgLTguODUsMjQuOTI3IDAsMCIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEwMi45MyAyNjUuNjEpIj4KPHBhdGggZD0ibTAgMCAzLjgxOSA3My4wNDFoLTMxLjI5M2wzLjc0NC03Mmg4LjcyN2wzLjMzMyA1OC4wNjggMy4zOTYtNTguNjk4eiIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDg1LjQyMyA0MDQuOTkpIj4KPHBhdGggZD0ibTAgMGMyLjQwMyAyLjMyNSA0LjI3OCAwLjU3OSA1LjY4NSAwLjU3OSAxLjQwNCAwIDMuMjc2IDEuNzQ2IDUuNjgyLTAuNTc5LTEuMjkzLTYuMTM4LTkuNjU0LTYuMzI3LTExLjM2NyAwIiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoODUuNDIzIDQwNC45OSkiPgo8cGF0aCBkPSJtMCAwYzIuNDAzIDIuMzI1IDQuMjc4IDAuNTc5IDUuNjg1IDAuNTc5IDEuNDAxIDAgMy4yNzYgMS43NDYgNS42ODItMC41NzktMy42NzUtMS44MTItOC44OTItMC45NjYtMTEuMzY3IDAiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMC41MDUgMzM4LjE4KSI+CjxwYXRoIGQ9Im0wIDAtMS44NDIgMjEuNDY4Yy0xLjM4IDUuNzA2LTguNTMyIDUuMDg4LTcuNDQ5LTEuOTg2bDEuOTUtMjAuNTE0eiIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQzLjgyMiAzMzguMTgpIj4KPHBhdGggZD0ibTAgMCAxLjc5NyAyMS43OGMxLjM4IDUuNzA5IDguNjU1IDUuMzMxIDcuNTc1LTEuNzQzbC0yLjAzMS0yMS4wNjl6IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDEuMjUxIDM4OS42OCkiPgo8cGF0aCBkPSJtIDAsMCA0LjQ3MywtMzAuNDAyIGMgMC41NDMsLTMuNzA1IDcuOTMyLC0xLjY3NyA3Ljg1NywxLjc1MiBMIDExLjc0NSwtMC45MTUgQyAxMS41NTksOC4wMSAtMS4yMyw4LjM3OSAwLDAiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0NS42MTggMzk1Ljc0KSI+CjxwYXRoIGQ9Im0wIDAtNy4wNDQtNTIuNjY1aC0yMy42MDdsLTYuMTE3IDUyLjY2NXoiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNS43MzYgMjcxLjE0KSI+CjxwYXRoIGQ9Im0wIDBjLTIuNjE2LTMuNzgzLTYuMTQxLTUuNzM2LTYuODg1LTkuMTI5LTAuMzQ1LTEuNTgxIDAuMDEyLTIuNzc4IDEuNTgxLTIuOTc2IDYuNzUzLTAuODMxIDcuNzgyIDIuNDkgMTAuMTgyIDMuMTYyIDQuMTU1IDEuMTY3IDQuOTcxIDMuMjcgMy4yOTEgOC45NDMtMS42ODMgNS42NzMtNi4wNjkgMy41NDMtOC4xNjkgMCIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyLjA0OSAzNDMuNDIpIj4KPHBhdGggZD0ibTAgMCAzMC4zMjctMC4zNDgtMy42MzktNzEuOTMxaC03Ljg4N2wtMS45NDcgNTQuNzExYy0wLjEzMiA0LjMzNS0zLjIwNCA0LjM2Mi0zLjMzMyAwbC0xLjY2NS01NC43MTFoLTguMTY5eiIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQ0LjQ0NiAzMzguODMpIj4KPHBhdGggZD0ibTAgMGMtMC4zIDAuMjA0LTAuNjcyLTAuMjAxLTAuNjk2LTAuNTU1bC0wLjM5My01LjIxMWMtMC4wMjEtMC4zNTQgMC4zMTUtMC41MjggMC42MTUtMC43MjkgMC4yOTQtMC4yMDEgMC42NjkgMC4yMDEgMC42OTYgMC41NTJsMC4zODcgNS4yMTRjMC4wMjcgMC4zNTQtMC4yNTIgMC42ODctMC42MDkgMC43MjkiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0My43MzUgMzM2LjYpIj4KPHBhdGggZD0iTSAwLDAgMC4xNzEsMi4yNDQgNy41NzUsMS4xNzYgNy40MDcsLTEuMDYyIEMgNi42OSwtNy44MTUgLTAuODQsLTguMTkzIDAsMCIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDkuODgyMyAzMzguODMpIj4KPHBhdGggZD0ibTAgMGMwLjMgMC4yMDQgMC42NzItMC4yMDEgMC42OTYtMC41NTVsMC4zOTMtNS4yMTFjMC4wMjctMC4zNTQtMC4zMTUtMC41MjgtMC42MDktMC43MjktMC4zLTAuMjAxLTAuNjcyIDAuMjAxLTAuNjk5IDAuNTUybC0wLjM5IDUuMjE0Yy0wLjAyNyAwLjM1NCAwLjI1MiAwLjY4NyAwLjYwOSAwLjcyOSIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEwLjU5MiAzMzYuNikiPgo8cGF0aCBkPSJtMCAwLTAuMTY1IDIuMjQ0LTcuNDEtMS4wNjggMC4xNzEtMi4yMzhjMC43MTctNi43NTMgOC4yNS03LjEzMSA3LjQwNCAxLjA2MiIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDM0LjM2NCA0MTQuNDIpIj4KPHBhdGggZD0ibTAgMHYtMjEuMjI4Yy0zLjkyNC01LjE1MS0xMC4zMzgtNC45NzctMTQuMjYyIDB2MjEuMjI4YzAgOS40MzUgMTQuMjYyIDkuNDMyIDE0LjI2MiAwIiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzkuMDIzIDI3MS4xNCkiPgo8cGF0aCBkPSJtMCAwYzIuNjE2LTMuNzgzIDYuNDM1LTUuOTIyIDYuMjMxLTguODA1LTAuMTExLTEuNjE0IDAuMTE3LTIuOTY0LTEuNDUyLTMuMTU5LTYuNzUzLTAuODM0LTcuMjU3IDIuMzAxLTkuNjU3IDIuOTczLTQuMTYxIDEuMTctNC45NzEgMy4zMTgtMy4yOTQgOC45OTEgMS42ODMgNS42NzMgNi4wNjkgMy41NDMgOC4xNzIgMCIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEwLjk1OCAyNjUuNzMpIj4KPHBhdGggZD0ibTAgMGMtMS4wMTQtMS4xMDEtMS44My0yLjEzOS0yLjE5LTMuMjc5LTEuMjc1LTMuOTg3IDIuMjgzLTQuMDkyIDUuMTg0LTMuNzE3IDMuODczIDAuNDk4IDUuNDg0IDIuNjU1IDcuMzcxIDMuMTgzIDMuNzMyIDEuMDQ0IDQuMTk3IDMuMDgxIDMuMDMzIDcuNTk2LTAuMTU2LTMuOTM2LTMuODQzLTUuMDA3LTcuOTM1LTYuOTQ4LTQuMDg5LTEuOTQ0LTcuMzg5LTAuMDIxLTUuNDYzIDMuMTY1IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDMuODAxIDI2NS43MykiPgo8cGF0aCBkPSJtMCAwYzEuMDE0LTEuMTAxIDEuODMtMi4xMzkgMi4xOTMtMy4yNzkgMS40NTUtNC41NjYtMy43MzItNC4yMjQtNi42NjYtMy40MjYtMi44NDEgMC43NjgtNC4yNjYgMi40MzktNS44OTIgMi44OTItMy43MzUgMS4wNDQtNC4xOTcgMy4wODEtMy4wMzMgNy41OTYgMC4xNTYtMy45MzYgMy44NDMtNS4wMDcgNy45MzItNi45NDggNC4wOTItMS45NDQgNy4zOTItMC4wMjEgNS40NjYgMy4xNjUiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMy4wNzcgMzg5LjY4KSI+CjxwYXRoIGQ9Im0wIDAtNC40NjctMzAuNDAyYy0wLjU0OS0zLjcwNS03LjkzMi0xLjY3Ny03Ljg2MyAxLjc1MmwwLjU4MiAyNy43MzVjMC4xODkgOC45MjUgMTIuOTgxIDkuMjk0IDExLjc0OCAwLjkxNSIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQxLjI1MSAzODkuNjgpIj4KPHBhdGggZD0ibTAgMGMtMS4yMzMgOC4zNzkgMTEuNTU5IDguMDEgMTEuNzQ4LTAuOTE1bDAuNTgyLTI3LjczNWMwLjA2OS0zLjQyOS03LjMxNC01LjQ1Ny03Ljg2My0xLjc1MnoiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0NC40NjUgMzk0LjU2KSI+CjxwYXRoIGQ9Im0wIDAgMC4yOTctMTQuMTA2LTIuMDg1LTM3LjM4M2gtMzAuODg4bC0yLjA1NSAzNi44MzEtOC41MjYgMy4wNTEgMC4xMiA1LjgxN2MxMC45MTcgMTIuNTc5IDE4LjQyNi03LjcxNiAzNC44NiAzLjA5M3oiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg4Ljg0OTEgMzk1Ljc0KSI+CjxwYXRoIGQ9Im0wIDBjOS42MjctMC44MDQgMjcuNzI5LTEuNDc2IDM3LjQwNy0wLjAxNS02LjE4My0wLjkzMy0xNy44NTMtMTkuNTI3LTM3LjQwNyAwLjAxNSIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQyLjM3NiAzODIuMDQpIj4KPHBhdGggZD0ibTAgMCAzLjE5NS0yMS44MDdzNy43MjItMi42MSA3Ljc3Ni0yLjAxYzAuMDUxIDAuNjA2LTAuMzUxIDMwLjU1Mi0wLjM1MSAzMC41NTJ6IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOS41NTA4IDM1MS4wMSkiPgo8cGF0aCBkPSJtMCAwLTEuMjA2IDEyLjM0MmMtMS4zODMgNS43MDYtOC41NjUgMy41MDctNy40ODUtMy41NjdsMC43MzUtOS4zNjl6IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDQuNzQ3IDM1MS4wMSkiPgo8cGF0aCBkPSJtMCAwIDEuMDYyIDExLjkyNWMxLjM4MyA1LjcwNiA4LjYxOSAyLjM1OCA3LjUzOS00LjcxNmwtMC42NTEtNy44MDN6IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzQuMzY0IDQxMC44MikiPgo8cGF0aCBkPSJtMCAwdi0xMS42OTRjLTIuNjk3LTIuMTA5LTUuMzAxLTMuMjk0LTcuMTMxLTMuMjk0cy00LjQzMSAxLjE4NS03LjEzMSAzLjI5NHYxMS42OTRjMCA5LjQzNSAxNC4yNjIgOS40MzUgMTQuMjYyIDAiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNy4yMzMgMzk4Ljc0KSI+CjxwYXRoIGQ9Im0wIDBjLTQuNjQxIDAtMTQuNDQ4IDcuMzAyLTE3LjQ4MSAxNy43NTEtMy4wNjYgMTAuNTU3IDIuNyAyNS43MDEgMTcuNDgxIDI1LjcwMXMyMC41NDctMTUuMTQ0IDE3LjQ4MS0yNS43MDFjLTMuMDI3LTEwLjQ1NS0xMi44NC0xNy43NTEtMTcuNDgxLTE3Ljc1MSIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIxLjQxMSA0MTIuNTcpIj4KPHBhdGggZD0ibTAgMGMxLjUyNC0xLjE5NCAxMC4xMjItMS4xMzEgMTEuNjQ2IDAtMS4zMjYtNi4yODgtOS44OTEtNi40OC0xMS42NDYgMCIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDUuOTQxMiA0MjIuODYpIj4KPHBhdGggZD0ibTAgMGMxLjQ5MSAwLjY0MiAzLjYtMC45MzMgNC43MTMtMy41MTMgMS4xMDctMi41OCAwLjc5OC01LjE5Ni0wLjY5OS01LjgzNS0xLjQ5MS0wLjY0Mi0zLjYgMC45MjctNC43MSAzLjUxMy0xLjEwNyAyLjU4LTAuNzk4IDUuMTkzIDAuNjk2IDUuODM1IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDcuMTUyIDQyMi44NSkiPgo8cGF0aCBkPSJtMCAwYzEuNDk0LTAuNjM5IDEuODA5LTMuMjU1IDAuNjk2LTUuODM1LTEuMTA0LTIuNTgzLTMuMjE5LTQuMTU1LTQuNzEtMy41MTMtMS40OTcgMC42MzktMS44MDkgMy4yNTUtMC42OTkgNS44MzUgMS4xMDcgMi41ODYgMy4yMjIgNC4xNTggNC43MTMgMy41MTMiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0NC40NTUgNDE5LjM2KSI+CjxwYXRoIGQ9Im0wIDBjOC43MTIgMjQuNTM0LTguMSAyNi4wOTQtMTcuOTc5IDI2LjA5NC0xMS4xMzMgMC0yNC4xMjktNS42NzktMTYuOTM4LTI2LjM3NiAxMC42MDggMC41MjIgMTkuOTM1IDYuNDM4IDI5LjMxIDE4Ljg2NCAxLjU5Ni02LjMxMiAyLjY3My0xNC41MiA1LjYwNy0xOC41ODIiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzOC45MTcgMjcxLjYyKSI+CjxwYXRoIGQ9Im0wIDAgMy43NTkgNzEuNDUxLTMwLjg4NSAxLjIyNyAzLjc2OC03MS42NDZoOC41ODlsMy4yODIgNTcuMDI3IDMuMzQyLTU3LjcxNHoiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8L2c+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTcxLjA0IDI4NS4xNSkiPgo8cGF0aCBkPSJtMCAwYy03Ljk1OSAzMy40MjYtMTIuMTkyIDgzLjEwOSAyMi4yMzkgODMuMTA5IDM0LjQyOCAwIDMyLjU5OC00OS4xODUgMjQuMzE4LTg0LjE2NS0xNi4xMTMtOS40NDEtMzIuNjU1LTYuODM0LTQ2LjU1NyAxLjA1NiIgZmlsbD0iI2Q1NmMyYiIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTcyLjUyIDIyNC4zNSkiPgo8cGF0aCBkPSJtMCAwLTIuNDM5IDI4LjkxMWMtMS43NzkgNy4zNDctMTAuOTIgNS4yODktOS41MjgtMy44MjJsMi41MTQtMjYuNDE4eiIgZmlsbD0iI2ZiZDliZCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjE1LjQzIDIyNC4zNSkiPgo8cGF0aCBkPSJtMCAwIDIuNDY2IDMwLjgxM2MxLjc3OSA3LjM0NyAxMC45OTUgNC4wOTggOS42MDMtNS4wMWwtMi42MTYtMjcuMTMyeiIgZmlsbD0iI2ZiZDliZCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjEyLjEyIDI5MC42NikiPgo8cGF0aCBkPSJtMCAwIDUuNzYtMzkuMTVjMC42OTktNC43NzMgOS44NDYtMy42OTYgOS43NTMgMC43MjNsLTAuMzg3IDM3LjI0OGMtMC4yNCAxMS40OTYtMTYuNzEgMTEuOTY3LTE1LjEyNiAxLjE3OSIgZmlsbD0iI2ZiZDliZCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjE3Ljc0IDI5OC40NikiPgo8cGF0aCBkPSJtMCAwLTkuMDcyLTY3LjgyMWgtMzAuMzk5bC03Ljg3OCA2Ny44MjF6IiBmaWxsPSIjZmJkOWJkIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNzkuMjYgMTM4LjAxKSI+CjxwYXRoIGQ9Im0wIDBjLTMuMzY5LTQuODcyLTcuNTg0LTYuOTcyLTguNjYxLTExLjU3Ny0wLjQ3NC0yLjAzMSAwLjA3NS0yLjk3OSAyLjA5Ny0zLjIzNCA4LjY5NC0xLjA3MSA5Ljk2IDIuMzEgMTMuMDUgMy4xNzQgNS4zNDkgMS41MDYgNi4xOTggNC4zMzIgNC4wMzIgMTEuNjM3LTIuMTY2IDcuMzA4LTcuODE1IDQuNTYzLTEwLjUxOCAwIiBmaWxsPSIjZmJkOWJkIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNzQuMTggMjMwLjY0KSI+CjxwYXRoIGQ9Im0wIDBoMzkuNzc0bC01LjA3My05Mi42MjhoLTEwLjUyNGwtMi4xNDIgNzAuNDUyYy0wLjE2OCA1LjU4My00LjEyNSA1LjYxOS00LjI5MyAwbC0yLjE0Mi03MC40NTJoLTEwLjUxOHoiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIxNi4yMyAyMjUuMTgpIj4KPHBhdGggZD0ibTAgMGMtMC4zODcgMC4yNjQtMC44NjQtMC4yNTgtMC44OTctMC43MTRsLTAuNTA0LTYuNzExYy0wLjAzLTAuNDU2IDAuNDAyLTAuNjgxIDAuNzg5LTAuOTM5IDAuMzgxLTAuMjU4IDAuODY0IDAuMjU4IDAuODk3IDAuNzE0bDAuNTAxIDYuNzExYzAuMDMzIDAuNDU2LTAuMzI3IDAuODgyLTAuNzg2IDAuOTM5IiBmaWxsPSIjZmJkOWJkIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMTUuMzIgMjIyLjMxKSI+CjxwYXRoIGQ9Im0wIDAgMC4yMTkgMi44OTIgOS41MzctMS4zNzctMC4yMTktMi44ODNjLTAuOTIxLTguNjk0LTEwLjYyLTkuMTgzLTkuNTM3IDEuMzY4IiBmaWxsPSIjZmJkOWJkIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNzEuNzIgMjI1LjE4KSI+CjxwYXRoIGQ9Im0wIDBjMC4zODcgMC4yNjQgMC44NjQtMC4yNTggMC44OTctMC43MTRsMC41MDQtNi43MTFjMC4wMzYtMC40NTYtMC40MDItMC42ODEtMC43ODYtMC45MzlzLTAuODYxIDAuMjU4LTAuODk3IDAuNzE0bC0wLjUwNCA2LjcxMWMtMC4wMzMgMC40NTYgMC4zMjQgMC44ODIgMC43ODYgMC45MzkiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE3Mi42NCAyMjIuMzEpIj4KPHBhdGggZD0ibTAgMC0wLjIxMyAyLjg5Mi05LjU0My0xLjM3NyAwLjIyMi0yLjg4M2MwLjkyNC04LjY5NCAxMC42MjMtOS4xODMgOS41MzQgMS4zNjgiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIwOC45IDEzOC4wMSkiPgo8cGF0aCBkPSJtMCAwYzMuMzY5LTQuODcyIDguMDQtNy41MDYgOC43NTctMTEuODE3IDAuMzQyLTIuMDU1LTAuMzE1LTMuMzk5LTIuMzM0LTMuNjUxLTguNjk0LTEuMDcxLTkuOSAzLjA4Ny0xMi45OTMgMy45NTEtNS4zNTUgMS41MDMtNi4xMTQgNC4yMTItMy45NTQgMTEuNTE3IDIuMTY2IDcuMzA4IDcuODE1IDQuNTYzIDEwLjUyNCAwIiBmaWxsPSIjZmJkOWJkIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNzMuMTEgMTMxLjA0KSI+CjxwYXRoIGQ9Im0wIDBjLTEuMzA4LTEuNDE5LTIuMzU1LTIuNzU3LTIuODIzLTQuMjIxLTEuNjM4LTUuMTM2IDIuOTQtNS4yNzEgNi42ODEtNC43ODggNC45ODMgMC42NDIgNy4wNTkgMy40MTcgOS40ODkgNC4wOTggNC44MDYgMS4zNDcgNS40MDYgMy45NjkgMy45MDYgOS43ODMtMC4yMDEtNS4wNy00Ljk1LTYuNDUtMTAuMjE4LTguOTQ2LTUuMjY1LTIuNTA1LTkuNTE2LTAuMDMtNy4wMzUgNC4wNzQiIGZpbGw9IiNjYzFiNzQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIxNS4wNSAxMzEuMDQpIj4KPHBhdGggZD0ibTAgMGMxLjMwOC0xLjQxOSAyLjM1OC0yLjc1NyAyLjgyMy00LjIyMSAxLjg3NS01Ljg4My00LjgwMy01LjQzOS04LjU4My00LjQxMy0zLjY2IDAuOTktNS40OTMgMy4xMzgtNy41ODcgMy43MjMtNC44MTIgMS4zNDctNS40MDYgMy45NjktMy45MDYgOS43ODMgMC4yMDEtNS4wNyA0Ljk1LTYuNDUgMTAuMjE1LTguOTQ2IDUuMjY4LTIuNTA1IDkuNTE5LTAuMDMgNy4wMzggNC4wNzQiIGZpbGw9IiNjYzFiNzQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE3NS44NCAyOTAuNjYpIj4KPHBhdGggZD0ibTAgMC01Ljc1NC0zOS4xNWMtMC43MDUtNC43NzMtMTAuMjE1LTIuMTYtMTAuMTI1IDIuMjU2bDAuNzUgMzUuNzE1YzAuMjQzIDExLjQ5NiAxNi43MTYgMTEuOTY3IDE1LjEyOSAxLjE3OSIgZmlsbD0iI2NjMWI3NCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjA3LjA3IDI3NS40OSkiPgo8cGF0aCBkPSJtMCAwIDkuNTcgMy4yODgtMi42ODgtNDguMTQxaC0zOS43NzRsLTIuNjQ5IDQ3LjQzLTEwLjk4IDMuOTMgMC4xNTkgNy40OTFjMTkuNDQ5LTUuOTIyIDE5LjkxNC0yNS45ODYgNDYuMzYyLTEzLjk5OCIgZmlsbD0iI2NjMWI3NCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTcwLjM5IDI5OC40NikiPgo8cGF0aCBkPSJNIDAsMCBDIDkuNjM5LC0xLjI3NSAyOC4xNzYsLTE3LjQ3OCA1Ni44NTMsLTguOTc2IDUyLjk1LC0xOS4zMDIgLTUuNzA5LC01Ny40NSAwLDAiIGZpbGw9IiNjYzFiNzQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIxMy41NyAyODAuODIpIj4KPHBhdGggZD0ibTAgMCA0LjExMy0yOC4wOHM5Ljk0OC0zLjM2MyAxMC4wMTQtMi41ODljMC4wNjkgMC43OC0wLjQ1IDM5LjM0Mi0wLjQ1IDM5LjM0MnoiIGZpbGw9IiNjYzFiNzQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE3My40OCAyNDMuMDgpIj4KPHBhdGggZD0ibTAgMCAyLjQ2OS01Ni44MTRoMzYuNzJsMS45NzQgNTYuODE0eiIgZmlsbD0iI2NjMWI3NCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTcxLjI5IDI0MC44NykiPgo8cGF0aCBkPSJtMCAwLTEuNTU0IDE1Ljg5NGMtMS43ODIgNy4zNDctMTEuMDMxIDQuNTE1LTkuNjM5LTQuNTk2bDAuOTQ4LTEyLjA2M3oiIGZpbGw9IiNjYzFiNzQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIxNi42MiAyNDAuODcpIj4KPHBhdGggZD0ibTAgMCAxLjM2OCAxNS4zNTdjMS43NzkgNy4zNDcgMTEuMDk3IDMuMDM2IDkuNzA1LTYuMDc1bC0wLjgzNC0xMC4wNDd6IiBmaWxsPSIjY2MxYjc0IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMDMuMjUgMzIyLjUyKSI+CjxwYXRoIGQ9Im0wIDB2LTI3LjMzNmMtNS4wNTItNi42MzMtMTMuMzE0LTYuNDExLTE4LjM2NiAwdjI3LjMzNmMwIDEyLjE1MyAxOC4zNjYgMTIuMTQ3IDE4LjM2NiAwIiBmaWxsPSIjZmJkOWJkIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMDMuMjUgMzE3Ljg5KSI+CjxwYXRoIGQ9Im0wIDB2LTE1LjA2Yy0zLjQ3NC0yLjcxNS02LjgyNS00LjI0Mi05LjE4My00LjI0MnMtNS43MDkgMS41MjctOS4xODMgNC4yNDJ2MTUuMDZjMCAxMi4xNTMgMTguMzY2IDEyLjE1MyAxOC4zNjYgMCIgZmlsbD0iI2VjYzJhMCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTk0LjA3IDMwMi4zMykiPgo8cGF0aCBkPSJtMCAwYy01Ljk3OSAwLTE4LjYwNiA5LjQwMi0yMi41MTIgMjIuODYtMy45NDggMTMuNTk2IDMuNDggMzMuMDkzIDIyLjUxMiAzMy4wOTNzMjYuNDYtMTkuNDk3IDIyLjUxMi0zMy4wOTNjLTMuOS0xMy40NjQtMTYuNTMzLTIyLjg2LTIyLjUxMi0yMi44NiIgZmlsbD0iI2ZiZDliZCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTg0LjUzIDMxOC4zNykiPgo8cGF0aCBkPSJtMCAwYzQuMDI5IDIuOTQ2IDguMjQxIDEuMjA2IDkuNjQ4IDEuMjA2IDEuNDEgMCA1LjM4MiAxLjc0NiA5LjQxNC0xLjIwNi0yLjAwNC04LjEwOS0xNi4wMjMtOC4zMTMtMTkuMDYyIDAiIGZpbGw9IiNmZjM4NmEiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE4NC42NSAzMTguNDEpIj4KPHBhdGggZD0ibTAgMGMzLjc0NCAxLjMyIDcuMDU2LTEuMjY5IDkuNDA1LTEuMjY5IDIuMzU4IDAgNS42NzYgMy40NzQgOS40MiAxLjEzNC00LjM4OS00LjQ2Ny0xNC40MDktNC4yMjctMTguODI1IDAuMTM1IiBmaWxsPSIjYTIxZjQwIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxODQuNTMgMzE4LjQxKSI+CjxwYXRoIGQ9Im0wIDBjNC4wMjkgMS42NjIgNy4wMDIgMC40NTYgOS4zNTcgMC40NTYgMi4zNTIgMCA1LjY3MyAxLjIwNiA5LjcwNS0wLjQ1Ni00LjM4My0yLjUwOC0xNC42NDMtMi40MjQtMTkuMDYyIDAiIGZpbGw9IiNmZmYiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE4NC41NSAzMTguNCkiPgo8cGF0aCBkPSJtMCAwYzQuMDE0IDIuOTEzIDcuNDYxIDAuODkxIDkuODEgMC44OTEgMi4zNTIgMCA1LjE4NCAyLjAyOCA5LjIxNi0wLjkyMS0wLjAxNS0wLjA0Mi0wLjAzMy0wLjA4NC0wLjA0OC0wLjEyMy01LjEzNiAwLjA5Ni0xMy41NDggMC4xNDctMTguOTc4IDAuMTUzIiBmaWxsPSIjZmYzODZhIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNjYuNjUgMzMzLjM5KSI+CjxwYXRoIGQ9Im0wIDBjMS45MiAwLjgyNSA0LjYzOC0xLjIgNi4wNjktNC41MjQgMS40MjUtMy4zMjQgMS4wMjYtNi42OS0wLjktNy41MTUtMS45Mi0wLjgyNS00LjYzNSAxLjE5NC02LjA2NiA0LjUyNC0xLjQyOCAzLjMyMS0xLjAyOSA2LjY5IDAuODk3IDcuNTE1IiBmaWxsPSIjZmJkOWJkIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMTkuNzIgMzMzLjM4KSI+CjxwYXRoIGQ9Im0wIDBjMS45MjYtMC44MjUgMi4zMjgtNC4xOTQgMC44OTctNy41MTUtMS40MjUtMy4zMjQtNC4xNDYtNS4zNDktNi4wNjYtNC41MjQtMS45MjYgMC44MjUtMi4zMzEgNC4xOTEtMC45IDcuNTE1IDEuNDI1IDMuMzMgNC4xNDkgNS4zNTUgNi4wNjkgNC41MjQiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIxNi4yNCAzMjguODkpIj4KPHBhdGggZD0ibTAgMGMxMS4yMiAzMS41OTYtMTAuNDI4IDMzLjYwNi0yMy4xNTQgMzMuNjA2LTE0LjMzNCAwLTMxLjA3MS03LjMxNC0yMS44MS0zMy45NzIgMTMuNjYyIDAuNjc1IDI1LjY3MSA4LjI5MiAzNy43NDYgMjQuMjk0IDIuMDU1LTguMTI3IDMuNDQxLTE4LjY5NiA3LjIxOC0yMy45MjgiIGZpbGw9IiNkNTZjMmIiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyOS40NyAxNDYuOSkiPgo8cGF0aCBkPSJtMCAwYzMuMzA2LTQuNzgyIDcuNjI5LTcuMTEgOC4yNzQtMTEuMjIzIDAuMzE4LTIuMDIyIDAuMTA1LTMuNjI3LTEuODgxLTMuODc2LTguNTMyLTEuMDUzLTkuNDc3IDIuMzk3LTEyLjUxMyAzLjI0Ni01LjI1NiAxLjQ3Ni02LjMyNyA0LjY4LTQuMjAzIDExLjg1MyAyLjEyNyA3LjE3MyA3LjY2OCA0LjQ3MyAxMC4zMjMgMCIgZmlsbD0iI2ZiZDliZCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTM0LjQ2IDIzNy44KSI+CjxwYXRoIGQ9Im0wIDBoLTM5LjAzbDQuOTgtOTAuOTAzaDEwLjMyNmwyLjEgNjkuMTQxYzAuMTY1IDUuNDgxIDQuMDQ3IDUuNTExIDQuMjE1IDBsMi4xMDMtNjkuMTQxaDEwLjMyeiIgZmlsbD0iI2ZiZDliZCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTMxLjU2IDI5Ni43MykiPgo8cGF0aCBkPSJtMCAwIDYuOTE4LTM4LjQ0OGMwLjg0My00LjY1OSAxMC4wNjgtMC4xNzcgOS45MzYgMi4yMTRsLTIuMDEgMzUuMDc2Yy0wLjY0NSAxMS4yNjUtMTYuNzQgMTEuNjk0LTE0Ljg0NCAxLjE1OCIgZmlsbD0iI2RkMjg4YyIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoODguNCAzNDEuNzIpIj4KPHBhdGggZD0ibTAgMGM4LjA3IDEuOTUtNS41OC05LjMzIDUuMzIyLTIxLjQwNSAxMC45MDUtMTIuMDc4IDMuNjA5LTI3LjYzOS03LjAyOS0yOS44MjYtNC40NzktMC45MjEgOS45NDggOC45NjEtMi45NTIgMjAuMzQ2LTguMjM1IDcuMjcyLTkuMzg3IDI3LjQ3NCA0LjY1OSAzMC44ODUiIGZpbGw9IiNjYjdjNTQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDkxLjcxIDMwNC4zNikiPgo8cGF0aCBkPSJtMCAwIDMuNzE3LTY2LjU1NWgzOS4wM2wzLjcyIDY2LjU1NXoiIGZpbGw9IiNkZDI4OGMiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzNi44NyAyMzIuNDQpIj4KPHBhdGggZD0ibTAgMGMtMC4zNzggMC4yNTItMC44NDYtMC4yNTUtMC44ODItMC42OTlsLTAuNDk1LTYuNTg4Yy0wLjAzMy0wLjQ0NyAwLjM5Ni0wLjY2NiAwLjc3MS0wLjkyMSAwLjM4MS0wLjI1MiAwLjg0OSAwLjI1NSAwLjg4MiAwLjcwMmwwLjQ5NSA2LjU4NWMwLjAzMyAwLjQ0Ny0wLjMxOCAwLjg2MS0wLjc3MSAwLjkyMSIgZmlsbD0iI2ZiZDliZCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTM1Ljk3IDIyOS42MykiPgo8cGF0aCBkPSJNIDAsMCAwLjIxMywyLjgyOSA5LjU3OSwxLjQ4NSA5LjM2MywtMS4zNDQgQyA4LjQ1NCwtOS44NzYgLTEuMDYyLC0xMC4zNTYgMCwwIiBmaWxsPSIjZmJkOWJkIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMzYuMDggMjMxLjYzKSI+CjxwYXRoIGQ9Im0wIDAgMi4wMjIgMjcuMjFjMS43NDYgNy4yMDkgOS45MyA4LjA3NiAxMC4zMTEgMS42NjJsLTMuMDU3LTMwLjE3N3oiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzNC40NiAyMzcuOCkiPgo8cGF0aCBkPSJtMCAwLTEuNDQ5LTI2LjM3M2gtMzYuMDMzbC0xLjU0OCAyNi4zNzMgMTguMTY1IDU1Ljg2OWMwLjgzMS0wLjA3OCAxLjY2OC0wLjA5OSAyLjUwOC0wLjAyMXoiIGZpbGw9IiNjYzFiNzQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEwMC4zOCAxNDYuOSkiPgo8cGF0aCBkPSJtMCAwYy0zLjMwNi00Ljc4Mi03LjkzOC03LjU3OC04LjUyMy0xMS4zNC0wLjMxOC0yLjAyMiAwLjUxLTMuNzA4IDIuNDg3LTMuOTU3IDguNTMyLTEuMDUzIDkuMjI1IDMuMTExIDEyLjI1OCAzLjk1NyA1LjI1NiAxLjQ3NiA2LjIyNSA0LjE2NyA0LjEwNCAxMS4zNC0yLjEyNCA3LjE3My03LjY3MSA0LjQ3My0xMC4zMjYgMCIgZmlsbD0iI2ZiZDliZCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTM1LjUxIDE0MC4wNSkiPgo8cGF0aCBkPSJtMCAwYzEuMjg0LTEuMzg5IDIuMzEzLTIuNyAyLjc3Mi00LjEzNyAxLjYwOC01LjA0My0yLjg4OS01LjE3OC02LjU1NS00LjcwNC00Ljg5MyAwLjYzMy02LjkzIDMuMzYtOS4zMTUgNC4wMjYtNC43MTMgMS4zMjMtNS4zMDQgMy44OTctMy44MzQgOS42MDMgMC4xOTgtNC45OCA0Ljg2LTYuMzM2IDEwLjAzMi04Ljc4NyA1LjE2Ni0yLjQ1MSA5LjMzNi0wLjAyMSA2LjkgMy45OTkiIGZpbGw9IiNjYzFiNzQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDk0LjM0OCAxNDAuMDUpIj4KPHBhdGggZD0ibTAgMGMtMS4yODQtMS4zODktMi4zMTMtMi43LTIuNzcyLTQuMTM3LTEuODM5LTUuNzcyIDQuNzE2LTUuMzM3IDguNDI0LTQuMzM1IDMuNTkxIDAuOTc1IDUuMzkxIDMuMDgxIDcuNDQ2IDMuNjU3IDQuNzE2IDEuMzIzIDUuMzA0IDMuODk3IDMuODM0IDkuNjAzLTAuMTk4LTQuOTgtNC44Ni02LjMzNi0xMC4wMjYtOC43ODctNS4xNzItMi40NTEtOS4zNDItMC4wMjEtNi45MDYgMy45OTkiIGZpbGw9IiNjYzFiNzQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE0OC40MiAyNjAuNSkiPgo8cGF0aCBkPSJtMCAwLTEwLjMxMS0xLjY2Mi0wLjgzNCA3LjY1IDEwLjU5MyAxLjg2OXoiIGZpbGw9IiNiNTFhNmYiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDk4LjAxNyAyOTYuNzMpIj4KPHBhdGggZD0ibTAgMC02LjkxOC0zOC40NDhjLTAuODQzLTQuNjU5LTEwLjA3NC0wLjE3Ny05LjkzOSAyLjIxNGwyLjAwNyAzNS4wNzZjMC42NDggMTEuMjY1IDE2Ljc0MyAxMS42OTQgMTQuODUgMS4xNTgiIGZpbGw9IiNkZDI4OGMiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDkyLjcwNyAyMzIuNDQpIj4KPHBhdGggZD0ibTAgMGMwLjM3OCAwLjI1MiAwLjg0OS0wLjI1NSAwLjg4Mi0wLjY5OWwwLjQ4OS02LjU4OGMwLjAzOS0wLjQ0Ny0wLjM5LTAuNjY2LTAuNzcxLTAuOTIxLTAuMzc1LTAuMjUyLTAuODQ5IDAuMjU1LTAuODgyIDAuNzAybC0wLjQ4OSA2LjU4NWMtMC4wMzMgMC40NDcgMC4zMjEgMC44NjEgMC43NzEgMC45MjEiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDkzLjYwNSAyMjkuNjMpIj4KPHBhdGggZD0ibTAgMC0wLjIxNiAyLjgyOS05LjM1Ny0xLjM0NCAwLjIxMy0yLjgyOWMwLjkwOS04LjUzMiAxMC40MjItOS4wMTIgOS4zNiAxLjM0NCIgZmlsbD0iI2ZiZDliZCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOTMuNDkzIDIzMS42MykiPgo8cGF0aCBkPSJtMCAwLTIuMDIyIDI3LjIxYy0xLjc0MyA3LjIwOS05LjkzNiA4LjA3Ni0xMC4zMTcgMS42NjJsMy4wNjMtMzAuMTc3eiIgZmlsbD0iI2ZiZDliZCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoODEuMTYxIDI2MC41KSI+CjxwYXRoIGQ9Im0wIDAgMTAuMzExLTEuNjYyIDAuODI4IDcuNjUtMTAuNTg3IDEuODY5eiIgZmlsbD0iI2I1MWE2ZiIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOTAuMjYxIDM2Mi44MykiPgo8cGF0aCBkPSJtMCAwYzMuMTk1IDYuNzggOS40NDEgMTEuMDIyIDE4LjE1NiA5LjQxNyA2Ljk2NiA4LjUyOSAyNS40NTggMC44MTYgMjkuMjM1LTYuNjYzIDE0LjU3NC0yOC44NzUtMTEuMTY5LTQ1LjA3OC0yMy4zMzctNDUuMDc4LTEwLjkyMy02ZS0zIC0zNS4yNDcgMTguNjA2LTI0LjA1NCA0Mi4zMjQiIGZpbGw9IiNjYjdjNTQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyMy45NSAzMzEuNjYpIj4KPHBhdGggZD0ibTAgMHYtMzMuNDQxYy00Ljk1OS02LjUxLTEzLjA2NS02LjI5MS0xOC4wMjEgMHYzMy40NDFjMCAxMS45MTkgMTguMDIxIDExLjkxOSAxOC4wMjEgMCIgZmlsbD0iI2ZiZDliZCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTIzLjk1IDMyNy4xMSkiPgo8cGF0aCBkPSJtMCAwdi0xNC43NzhjLTMuNDExLTIuNjczLTYuNjk5LTQuMTY0LTkuMDEyLTQuMTY0cy01LjYwMSAxLjQ5MS05LjAwOSA0LjE2NHYxNC43NzhjMCAxMS45MjUgMTguMDIxIDExLjkyNSAxOC4wMjEgMCIgZmlsbD0iI2VjYzJhMCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTQwLjU2IDM0MS43MikiPgo8cGF0aCBkPSJtMCAwYzE0LjA0Ni0zLjQxMSAxMi44OTQtMjMuNjEzIDQuNjU5LTMwLjg4NS0xMi45LTExLjM4NSAxLjUyNy0yMS4yNjctMi45NTItMjAuMzQ2LTEwLjYzOCAyLjE4Ny0xNy45MzQgMTcuNzQ4LTcuMDI5IDI5LjgyNiAxMC45MDIgMTIuMDc1LTIuNzQ4IDIzLjM1NSA1LjMyMiAyMS40MDUiIGZpbGw9IiNjYjdjNTQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzOC41IDM0Mi43OSkiPgo8cGF0aCBkPSJtMCAwYzIuODc0IDIuMDEgNS44NSAyLjcxNSA2LjY0MiAxLjU3NSAwLjc5Mi0xLjEzNC0wLjg5Ny0zLjY4MS0zLjc3MS01LjY4NS0yLjg3MS0yLjAwNC01Ljg0Ny0yLjcxNS02LjYzOS0xLjU3NS0wLjc5NSAxLjEzNCAwLjg5NyAzLjY4MSAzLjc2OCA1LjY4NSIgZmlsbD0iIzI4MjgyOCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOTEuNzQ4IDM0Mi44KSI+CjxwYXRoIGQ9Im0wIDBjMi44NzQtMi4wMDQgNC41NjYtNC41NTQgMy43NzQtNS42OTEtMC43OTItMS4xMzEtMy43NjgtMC40MjYtNi42NDUgMS41NzgtMi44NzQgMi4wMDQtNC41NiA0LjU1NC0zLjc2NSA1LjY5MSAwLjc5MiAxLjEzMSAzLjc2MiAwLjQyNiA2LjYzNi0xLjU3OCIgZmlsbD0iIzI4MjgyOCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTE0Ljk0IDMxMS44MykiPgo8cGF0aCBkPSJNIDAsMCBDIC01Ljg2NSwwIC0xOC4yNjQsOS4yMjUgLTIyLjA5MiwyMi40NCAtMjUuOTY1LDM1Ljc4MSAtMTguNjc4LDU0LjkxNSAwLDU0LjkxNSAxOC42ODEsNTQuOTE1IDI1Ljk2OCwzNS43ODEgMjIuMDkyLDIyLjQ0IDE4LjI2MSw5LjIyNSA1Ljg2OCwwIDAsMCIgZmlsbD0iI2ZiZDliZCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTA1LjU5IDMyNy41OCkiPgo8cGF0aCBkPSJtMCAwYzMuOTU0IDIuODkyIDguMDg1IDEuMTc2IDkuNDYyIDEuMTc2IDEuMzgzIDAgNS4yODMgMS43MTkgOS4yNDMtMS4xNzYtMS45NzEtNy45NTktMTUuNzI2LTguMTYzLTE4LjcwNSAwIiBmaWxsPSIjZmYzODZhIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMDUuNzEgMzI3LjYyKSI+CjxwYXRoIGQ9Im0wIDBjMy42NzIgMS4yOTMgNi45MjQtMS4yMzkgOS4yMzEtMS4yMzkgMi4zMTMgMCA1LjU2OCAzLjQwMiA5LjI0MyAxLjExMy00LjMwOC00LjM5Mi0xNC4xMzktNC4xNDktMTguNDc0IDAuMTI2IiBmaWxsPSIjYTIxZjQwIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMDUuNTkgMzI3LjYyKSI+CjxwYXRoIGQ9Im0wIDBjMy45NTQgMS42MjkgNi44NyAwLjQ0NyA5LjE3NCAwLjQ0NyAyLjMxNiAwIDUuNTc3IDEuMTgyIDkuNTMxLTAuNDQ3LTQuMzAyLTIuNDYzLTE0LjM3Ni0yLjM3OS0xOC43MDUgMCIgZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTA1LjYxIDMyNy42KSI+CjxwYXRoIGQ9Im0wIDBjMy45MzkgMi44NTkgNy4zMiAwLjg3NiA5LjYyNyAwLjg3NiAyLjMxIDAgNS4wODUgMS45OTUgOS4wNDgtMC44OTctMC4wMTgtMC4wNDUtMC4wMzYtMC4wODQtMC4wNTEtMC4xMi01LjA0NiAwLjA4Ny0xMy4yOTYgMC4xNDEtMTguNjI0IDAuMTQxIiBmaWxsPSIjZmYzODZhIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNDAuMTIgMzQyLjMzKSI+CjxwYXRoIGQ9Im0wIDBjMS44ODQtMC44MSAyLjI4LTQuMTEgMC44NzYtNy4zNzctMS4zOTgtMy4yNTgtNC4wNjUtNS4yNS01Ljk1NS00LjQzNy0xLjg4NyAwLjgwNy0yLjI4IDQuMTA3LTAuODgyIDcuMzc0IDEuNDA3IDMuMjY3IDQuMDcxIDUuMjU2IDUuOTYxIDQuNDQiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDg4Ljg0MSAzNDIuMzMpIj4KPHBhdGggZD0ibTAgMGMxLjg5IDAuODE2IDQuNTU0LTEuMTczIDUuOTYxLTQuNDQgMS4zOTgtMy4yNjcgMS4wMDUtNi41NjctMC44ODItNy4zNzQtMS44OS0wLjgxMy00LjU1NyAxLjE3OS01Ljk1NSA0LjQzNy0xLjQwNCAzLjI2Ny0xLjAwOCA2LjU2NyAwLjg3NiA3LjM3NyIgZmlsbD0iI2ZiZDliZCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTM2LjcxIDMzNy45KSI+CjxwYXRoIGQ9Im0wIDBjMTEuMDA3IDMwLjk5OS0xMC4yMzMgMzIuOTczLTIyLjcyNSAzMi45NzMtMTQuMDcgMC0zMC40ODktNy4xNzMtMjEuNDA4LTMzLjMzIDEzLjQxMyAwLjY2IDI1LjE5NCA4LjEzMyAzNy4wNDQgMjMuODM4IDIuMDIyLTcuOTggMy4zODEtMTguMzQ4IDcuMDg5LTIzLjQ4MSIgZmlsbD0iI2NiN2M1NCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzUuNzMxIDI5OS42OSkiPgo8cGF0aCBkPSJtMCAwYy0xNC41NjgtMC4yMS0xNi43NyAyNi4yNzctMjMuMzg1IDQ1LjEzMi05LjgxMyAyNy45NzggMjIuNzgyIDQzLjc4NSAzMy43NDEgMzMuNjIxIDExLjY1NSAwIDE5LjYzMi0yMi4zNDEgMTIuODUyLTM4LjUyMy04LjUzNS0yMC4zNjQtMTIuMy00MS43MTItMjMuMjA4LTQwLjIzIDAgMCA2LjQ0NyAwLjI3MyAwIDAiIGZpbGw9IiNhMTQwMGYiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIwLjU0NCAxNTQuNykiPgo8cGF0aCBkPSJtMCAwYy0zLjMxOC00LjgwMy03LjczNC03LjU2My04LjgzNS0xMS4wMzEtMC42MjctMS45NTYtMC4xNjItMy4wMTggMS44My0zLjI2MSA4LjU2NS0xLjA2MiAxMS4wNDYgMS43MzEgMTQuMSAyLjU4OSA1LjI2OCAxLjQ3NiA1LjQwNiA0LjUwMyAzLjI3MyAxMS43MDMtMi4xMzYgNy4xOTQtNy42OTggNC40OTEtMTAuMzY4IDAiIGZpbGw9IiNlNWE3NzUiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE1LjU0NiAyNDUuOTQpIj4KPHBhdGggZD0ibTAgMGgzOS4xNzdsLTQuOTk4LTkxLjIzOWgtMTAuMzY1bC0yLjEwNiA2OS4zOTZjLTAuMTcxIDUuNDk5LTQuMDY1IDUuNTMyLTQuMjM2IDBsLTIuMTA5LTY5LjM5NmgtMTAuMzY1eiIgZmlsbD0iI2U1YTc3NSIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNTguNDU2IDMxMi43NSkiPgo8cGF0aCBkPSJtMCAwLTMuNzMyLTY2LjgxM2gtMzkuMTc3bC0zLjczMiA2Ni44MTN6IiBmaWxsPSIjZTVhNzc1IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg1Mi43MjggMzA1LjA2KSI+CjxwYXRoIGQ9Im0wIDAgNS42NjctMzguNTU5YzAuNjktNC43MDcgMTAuMDY1LTIuMTMgOS45NzUgMi4yMTdsLTAuNzQxIDM1LjE4N2MtMC4yMzcgMTEuMzE2LTE2LjQ2NCAxMS43ODctMTQuOTAxIDEuMTU1IiBmaWxsPSIjZTVhNzc1IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg1Ni43NzYgMjQwLjU2KSI+CjxwYXRoIGQ9Im0wIDBjLTAuMzc1IDAuMjU1LTAuODUyLTAuMjU4LTAuODg1LTAuNzA4bC0wLjQ5Mi02LjYxMmMtMC4wMzMtMC40NDcgMC4zOTktMC42NjkgMC43NzQtMC45MjRzMC44NTIgMC4yNjEgMC44ODUgMC43MDhsMC40OTIgNi42MTJjMC4wMzMgMC40NDctMC4zMTUgMC44NjQtMC43NzQgMC45MjQiIGZpbGw9IiNlNWE3NzUiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDU1Ljg3NCAyMzcuNzMpIj4KPHBhdGggZD0iTSAwLDAgMC4yMTYsMi44NDcgOS42MDksMS41IDkuMzkzLC0xLjM1IEMgOC40ODcsLTkuOTE1IC0xLjA2OCwtMTAuMzkyIDAsMCIgZmlsbD0iI2U1YTc3NSIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNTUuOTg0IDIzOS43NCkiPgo8cGF0aCBkPSJtMCAwIDIuMDM0IDI3LjMxMmMxLjc1NSA3LjIzOSAxMS44MTEgNy4wNzQgMTAuNDQtMS45MDJsLTMuMTYyLTI2LjcyNHoiIGZpbGw9IiNlNWE3NzUiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE3LjE3NiAzMDUuMDYpIj4KPHBhdGggZD0ibTAgMC01LjY3My0zOC41NTljLTAuNjktNC43MDctMTAuMDYyLTIuMTMtOS45NjkgMi4yMTdsMC43NDEgMzUuMTg3YzAuMjQgMTEuMzE2IDE2LjQ2MSAxMS43ODcgMTQuOTAxIDEuMTU1IiBmaWxsPSIjZTVhNzc1IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMy4xMjQgMjQwLjU2KSI+CjxwYXRoIGQ9Im0wIDBjMC4zODEgMC4yNTUgMC44NTItMC4yNTggMC44ODUtMC43MDhsMC40OTUtNi42MTJjMC4wMy0wLjQ0Ny0wLjM5Ni0wLjY2OS0wLjc3Ny0wLjkyNC0wLjM3NS0wLjI1NS0wLjg1MiAwLjI2MS0wLjg4NSAwLjcwOGwtMC40OTIgNi42MTJjLTAuMDMzIDAuNDQ3IDAuMzIxIDAuODY0IDAuNzc0IDAuOTI0IiBmaWxsPSIjZTVhNzc1IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNC4wMjQgMjM3LjczKSI+CjxwYXRoIGQ9Im0wIDAtMC4yMTYgMi44NDctOS4zOTMtMS4zNDcgMC4yMTYtMi44NWMwLjkxMi04LjU2NSAxMC40NjEtOS4wNDIgOS4zOTMgMS4zNSIgZmlsbD0iI2U1YTc3NSIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTMuOTE0IDIzOS43NCkiPgo8cGF0aCBkPSJtMCAwLTIuMDI4IDI3LjMxMmMtMS43NTggNy4yMzktMTEuODE3IDcuMDc0LTEwLjQ0Ni0xLjkwMmwzLjE2Mi0yNi43MjR6IiBmaWxsPSIjZTVhNzc1IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNS41NDYgMjQ1Ljk0KSI+CjxwYXRoIGQ9Im0wIDAgMS40NDktNTQuNzhoMzYuMTc3bDEuNTUxIDU0Ljc4LTE5LjgyNCAyNC44MzF6IiBmaWxsPSIjY2MxYjc0IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0OS43NDggMTU0LjcpIj4KPHBhdGggZD0ibTAgMGMzLjMxMi00LjgwMyA3LjczMS03LjU2MyA4LjgzNS0xMS4wMzEgMC42MjQtMS45NTYgMC4xNTktMy4wMTgtMS44My0zLjI2MS04LjU2NS0xLjA2Mi0xMS4wNTIgMS43MzEtMTQuMSAyLjU4OS01LjI2OCAxLjQ3Ni01LjQwNiA0LjUwMy0zLjI3MyAxMS43MDMgMi4xMzYgNy4xOTQgNy42OTggNC40OTEgMTAuMzY4IDAiIGZpbGw9IiNlNWE3NzUiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE0LjQ5IDE0Ny44MykiPgo8cGF0aCBkPSJtMCAwYy0xLjI5LTEuMzk1LTIuMzIyLTIuNzE1LTIuNzgxLTQuMTU4LTEuNjE0LTUuMDU4IDIuODkyLTUuMTkzIDYuNTc5LTQuNzE2IDQuOTExIDAuNjM2IDYuOTU0IDMuMzY2IDkuMzUxIDQuMDQxIDQuNzMxIDEuMzI2IDUuMzIyIDMuOTA5IDMuODQ2IDkuNjM2LTAuMjA0LTQuOTk4LTQuODc1LTYuMzU3LTEwLjA2OC04LjgxNy01LjE4Ny0yLjQ2LTkuMzcyLTAuMDI3LTYuOTI3IDQuMDE0IiBmaWxsPSIjY2MxYjc0IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg1NS44MDIgMTQ3LjgzKSI+CjxwYXRoIGQ9Im0wIDBjMS4yODctMS4zOTUgMi4zMjItMi43MTUgMi43ODEtNC4xNTggMS44NDgtNS43OS00LjczNC01LjM1Mi04LjQ0OC00LjM0Ny0zLjYxMiAwLjk3OC01LjQxOCAzLjA5My03LjQ4MiAzLjY3Mi00LjczMSAxLjMyNi01LjMyNSAzLjkwOS0zLjg0NiA5LjYzNiAwLjE5OC00Ljk5OCA0Ljg3NS02LjM1NyAxMC4wNjgtOC44MTdzOS4zNzItMC4wMjcgNi45MjcgNC4wMTQiIGZpbGw9IiNjYzFiNzQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDM1LjA4NCAyNDUuOTQpIj4KPHBhdGggZD0ibTAgMGgtMTkuNTM5bC0zLjE5OCA0Ni45NSAxMy42OTIgMTkuODYzaDE4LjA5bDEzLjQyMi0xOS44NjMtMi45MzQtNDYuOTV6IiBmaWxsPSIjY2MxYjc0IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0NC4xMyAzMzYuMjEpIj4KPHBhdGggZD0ibTAgMHYtMjMuNDZjMC0xNC43LTE4LjA5LTE0LjQwOS0xOC4wOSAwdjIzLjQ2YzAgMTEuOTY0IDE4LjA5IDExLjk2NCAxOC4wOSAwIiBmaWxsPSIjZTVhNzc1IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0NC4xMyAzMzYuMjEpIj4KPHBhdGggZD0ibTAgMHYtMTQuODQxYy0zLjQyMy0yLjY3Ni02LjcyMy00LjE3My05LjA0NS00LjE3M3MtNS42MjIgMS40OTctOS4wNDUgNC4xNzN2MTQuODQxYzAgMTEuOTY0IDE4LjA5IDExLjk2NCAxOC4wOSAwIiBmaWxsPSIjZDM5NzZlIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzNS4wODQgMzIwLjg4KSI+CjxwYXRoIGQ9Ik0gMCwwIEMgLTUuODk1LDAgLTE4LjMzMyw5LjI2MSAtMjIuMTgyLDIyLjUyNCAtMjYuMDY0LDM1LjkxNiAtMTguNzUsNTUuMTI1IDAsNTUuMTI1IDE4Ljc0NCw1NS4xMjUgMjYuMDU4LDM1LjkxNiAyMi4xNzYsMjIuNTI0IDE4LjMzLDkuMjYxIDUuODg5LDAgMCwwIiBmaWxsPSIjZTVhNzc1IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNy45ODYgMzM0LjIzKSI+CjxwYXRoIGQ9Im0wIDBjMy4wMDMgMi45MDQgNS4zNDYgMC43MjkgNy4wOTggMC43MjkgMS43NTUgMCA0LjA5MiAyLjE4MSA3LjA5NS0wLjcyOS0xLjYxNy03LjY2Mi0xMi4wNTQtNy45MDItMTQuMTkzIDAiIGZpbGw9IiNmZjM4NmEiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI4LjkwOSAzMzMuODMpIj4KPHBhdGggZD0iTSAwLDAgQyAxLjY0MSwwLjQyIDkuOTk2LDAuNTAxIDEyLjM0OCwwLjA5MyAxMC40MDcsLTMuNDc3IDEuNjQxLC0zLjI3MyAwLDAiIGZpbGw9IiNmZmYiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI3Ljk4NiAzMzQuMjMpIj4KPHBhdGggZD0iTSAwLDAgQyAzLjAwMywyLjkwNCA1LjM0NiwwLjcyOSA3LjA5OCwwLjcyOSA4Ljg1MywwLjcyOSAxMS4xOSwyLjkxIDE0LjE5MywwIDkuNjAzLC0yLjI2MiAzLjA5LC0xLjIwNiAwLDAiIGZpbGw9IiNmZjM4NmEiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDkuMTk3NyAzNTEuNDgpIj4KPHBhdGggZD0ibTAgMGMxLjg5NiAwLjgxMyA0LjU3Mi0xLjE4MiA1Ljk4Mi00LjQ1OCAxLjQwNC0zLjI3NiAxLjAxNC02LjU5NC0wLjg4NS03LjQwNy0xLjg5Ni0wLjgxMy00LjU3MiAxLjE4Mi01Ljk3NiA0LjQ2MS0xLjQxIDMuMjczLTEuMDExIDYuNTkxIDAuODc5IDcuNDA0IiBmaWxsPSIjZTVhNzc1IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg2MS40ODYgMzUxLjQ5KSI+CjxwYXRoIGQ9Im0wIDBjMS44OTYtMC44MTMgMi4yODktNC4xMjUgMC44ODUtNy40MDQtMS40MS0zLjI3OS00LjA4Ni01LjI3NC01Ljk4Mi00LjQ1NS0xLjg5MyAwLjgxMy0yLjI4OSA0LjEyOC0wLjg4NSA3LjQwMSAxLjQxIDMuMjc5IDQuMDg2IDUuMjc3IDUuOTgyIDQuNDU4IiBmaWxsPSIjZTVhNzc1IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg1OS4wNTMgMzQzLjY0KSI+CjxwYXRoIGQ9Im0wIDBjNy4xMTYgMzAuNTEzLTE0LjM3IDM1LjcwNi0yNi45MDQgMzUuNzA2LTE0LjEyMSAwLTIxLjYzLTE2LjQzMS0xOS4yNDUtMzUuOTQzIDcuNTMgNC41MzkgMTEuMDI4IDEzLjE3OSAyNy40OTUgMjcuODEtMi4zOTQtNC4yOTYtNy4wNjItMTIuMTA1LTIyLjkzNS0yNi4yNjUgOC41NDEtMS40MDcgMjQuNDUgOS4zNTcgMzIuOTMxIDIwLjYxOSAyLjAyMi04LjAwNCA0LjkzOC0xNi43NzYgOC42NTgtMjEuOTI3IiBmaWxsPSIjYTE0MDBmIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyBjbGlwLXBhdGg9InVybCgjZCkiIG9wYWNpdHk9Ii4yIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2MpIj4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTcxLjA0IDI4NS4xNSkiPgo8cGF0aCBkPSJtMCAwYy03Ljk1OSAzMy40MjYtMTIuMTkyIDgzLjEwOSAyMi4yMzkgODMuMTA5IDM0LjQyOCAwIDMyLjU5OC00OS4xODUgMjQuMzE4LTg0LjE2NS0xNi4xMTMtOS40NDEtMzIuNjU1LTYuODM0LTQ2LjU1NyAxLjA1NiIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE3Mi41MiAyMjQuMzUpIj4KPHBhdGggZD0ibTAgMC0yLjQzOSAyOC45MTFjLTEuNzc5IDcuMzQ3LTEwLjkyIDUuMjg5LTkuNTI4LTMuODIybDIuNTE0LTI2LjQxOHoiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMTUuNDMgMjI0LjM1KSI+CjxwYXRoIGQ9Im0wIDAgMi40NjYgMzAuODEzYzEuNzc5IDcuMzQ3IDEwLjk5NSA0LjA5OCA5LjYwMy01LjAxbC0yLjYxNi0yNy4xMzJ6IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjEyLjEyIDI5MC42NikiPgo8cGF0aCBkPSJtMCAwIDUuNzYtMzkuMTVjMC42OTktNC43NzMgOS44NDYtMy42OTYgOS43NTMgMC43MjNsLTAuMzg3IDM3LjI0OGMtMC4yNCAxMS40OTYtMTYuNzEgMTEuOTY3LTE1LjEyNiAxLjE3OSIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIxNy43NCAyOTguNDYpIj4KPHBhdGggZD0ibTAgMC05LjA3Mi02Ny44MjFoLTMwLjM5OWwtNy44NzggNjcuODIxeiIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE3OS4yNiAxMzguMDEpIj4KPHBhdGggZD0ibTAgMGMtMy4zNjktNC44NzItNy41ODQtNi45NzItOC42NjEtMTEuNTc3LTAuNDc0LTIuMDMxIDAuMDc1LTIuOTc5IDIuMDk3LTMuMjM0IDguNjk0LTEuMDcxIDkuOTYgMi4zMSAxMy4wNSAzLjE3NCA1LjM0OSAxLjUwNiA2LjE5OCA0LjMzMiA0LjAzMiAxMS42MzctMi4xNjYgNy4zMDgtNy44MTUgNC41NjMtMTAuNTE4IDAiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNzQuMTggMjMwLjY0KSI+CjxwYXRoIGQ9Im0wIDBoMzkuNzc0bC01LjA3My05Mi42MjhoLTEwLjUyNGwtMi4xNDIgNzAuNDUyYy0wLjE2OCA1LjU4My00LjEyNSA1LjYxOS00LjI5MyAwbC0yLjE0Mi03MC40NTJoLTEwLjUxOHoiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMTYuMjMgMjI1LjE4KSI+CjxwYXRoIGQ9Im0wIDBjLTAuMzg3IDAuMjY0LTAuODY0LTAuMjU4LTAuODk3LTAuNzE0bC0wLjUwNC02LjcxMWMtMC4wMy0wLjQ1NiAwLjQwMi0wLjY4MSAwLjc4OS0wLjkzOSAwLjM4MS0wLjI1OCAwLjg2NCAwLjI1OCAwLjg5NyAwLjcxNGwwLjUwMSA2LjcxMWMwLjAzMyAwLjQ1Ni0wLjMyNyAwLjg4Mi0wLjc4NiAwLjkzOSIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIxNS4zMiAyMjIuMzEpIj4KPHBhdGggZD0ibTAgMCAwLjIxOSAyLjg5MiA5LjUzNy0xLjM3Ny0wLjIxOS0yLjg4M2MtMC45MjEtOC42OTQtMTAuNjItOS4xODMtOS41MzcgMS4zNjgiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNzEuNzIgMjI1LjE4KSI+CjxwYXRoIGQ9Im0wIDBjMC4zODcgMC4yNjQgMC44NjQtMC4yNTggMC44OTctMC43MTRsMC41MDQtNi43MTFjMC4wMzYtMC40NTYtMC40MDItMC42ODEtMC43ODYtMC45MzlzLTAuODYxIDAuMjU4LTAuODk3IDAuNzE0bC0wLjUwNCA2LjcxMWMtMC4wMzMgMC40NTYgMC4zMjQgMC44ODIgMC43ODYgMC45MzkiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNzIuNjQgMjIyLjMxKSI+CjxwYXRoIGQ9Im0wIDAtMC4yMTMgMi44OTItOS41NDMtMS4zNzcgMC4yMjItMi44ODNjMC45MjQtOC42OTQgMTAuNjIzLTkuMTgzIDkuNTM0IDEuMzY4IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjA4LjkgMTM4LjAxKSI+CjxwYXRoIGQ9Im0wIDBjMy4zNjktNC44NzIgOC4wNC03LjUwNiA4Ljc1Ny0xMS44MTcgMC4zNDItMi4wNTUtMC4zMTUtMy4zOTktMi4zMzQtMy42NTEtOC42OTQtMS4wNzEtOS45IDMuMDg3LTEyLjk5MyAzLjk1MS01LjM1NSAxLjUwMy02LjExNCA0LjIxMi0zLjk1NCAxMS41MTcgMi4xNjYgNy4zMDggNy44MTUgNC41NjMgMTAuNTI0IDAiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNzMuMTEgMTMxLjA0KSI+CjxwYXRoIGQ9Im0wIDBjLTEuMzA4LTEuNDE5LTIuMzU1LTIuNzU3LTIuODIzLTQuMjIxLTEuNjM4LTUuMTM2IDIuOTQtNS4yNzEgNi42ODEtNC43ODggNC45ODMgMC42NDIgNy4wNTkgMy40MTcgOS40ODkgNC4wOTggNC44MDYgMS4zNDcgNS40MDYgMy45NjkgMy45MDYgOS43ODMtMC4yMDEtNS4wNy00Ljk1LTYuNDUtMTAuMjE4LTguOTQ2LTUuMjY1LTIuNTA1LTkuNTE2LTAuMDMtNy4wMzUgNC4wNzQiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMTUuMDUgMTMxLjA0KSI+CjxwYXRoIGQ9Im0wIDBjMS4zMDgtMS40MTkgMi4zNTgtMi43NTcgMi44MjMtNC4yMjEgMS44NzUtNS44ODMtNC44MDMtNS40MzktOC41ODMtNC40MTMtMy42NiAwLjk5LTUuNDkzIDMuMTM4LTcuNTg3IDMuNzIzLTQuODEyIDEuMzQ3LTUuNDA2IDMuOTY5LTMuOTA2IDkuNzgzIDAuMjAxLTUuMDcgNC45NS02LjQ1IDEwLjIxNS04Ljk0NiA1LjI2OC0yLjUwNSA5LjUxOS0wLjAzIDcuMDM4IDQuMDc0IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTc1Ljg0IDI5MC42NikiPgo8cGF0aCBkPSJtMCAwLTUuNzU0LTM5LjE1Yy0wLjcwNS00Ljc3My0xMC4yMTUtMi4xNi0xMC4xMjUgMi4yNTZsMC43NSAzNS43MTVjMC4yNDMgMTEuNDk2IDE2LjcxNiAxMS45NjcgMTUuMTI5IDEuMTc5IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjA3LjA3IDI3NS40OSkiPgo8cGF0aCBkPSJtMCAwIDkuNTcgMy4yODgtMi42ODgtNDguMTQxaC0zOS43NzRsLTIuNjQ5IDQ3LjQzLTEwLjk4IDMuOTMgMC4xNTkgNy40OTFjMTkuNDQ5LTUuOTIyIDE5LjkxNC0yNS45ODYgNDYuMzYyLTEzLjk5OCIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE3MC4zOSAyOTguNDYpIj4KPHBhdGggZD0iTSAwLDAgQyA5LjYzOSwtMS4yNzUgMjguMTc2LC0xNy40NzggNTYuODUzLC04Ljk3NiA1Mi45NSwtMTkuMzAyIC01LjcwOSwtNTcuNDUgMCwwIiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjEzLjU3IDI4MC44MikiPgo8cGF0aCBkPSJtMCAwIDQuMTEzLTI4LjA4czkuOTQ4LTMuMzYzIDEwLjAxNC0yLjU4OWMwLjA2OSAwLjc4LTAuNDUgMzkuMzQyLTAuNDUgMzkuMzQyeiIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE3My40OCAyNDMuMDgpIj4KPHBhdGggZD0ibTAgMCAyLjQ2OS01Ni44MTRoMzYuNzJsMS45NzQgNTYuODE0eiIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE3MS4yOSAyNDAuODcpIj4KPHBhdGggZD0ibTAgMC0xLjU1NCAxNS44OTRjLTEuNzgyIDcuMzQ3LTExLjAzMSA0LjUxNS05LjYzOS00LjU5NmwwLjk0OC0xMi4wNjN6IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjE2LjYyIDI0MC44NykiPgo8cGF0aCBkPSJtMCAwIDEuMzY4IDE1LjM1N2MxLjc3OSA3LjM0NyAxMS4wOTcgMy4wMzYgOS43MDUtNi4wNzVsLTAuODM0LTEwLjA0N3oiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMDMuMjUgMzIyLjUyKSI+CjxwYXRoIGQ9Im0wIDB2LTI3LjMzNmMtNS4wNTItNi42MzMtMTMuMzE0LTYuNDExLTE4LjM2NiAwdjI3LjMzNmMwIDEyLjE1MyAxOC4zNjYgMTIuMTQ3IDE4LjM2NiAwIiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjAzLjI1IDMxNy44OSkiPgo8cGF0aCBkPSJtMCAwdi0xNS4wNmMtMy40NzQtMi43MTUtNi44MjUtNC4yNDItOS4xODMtNC4yNDJzLTUuNzA5IDEuNTI3LTkuMTgzIDQuMjQydjE1LjA2YzAgMTIuMTUzIDE4LjM2NiAxMi4xNTMgMTguMzY2IDAiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxOTQuMDcgMzAyLjMzKSI+CjxwYXRoIGQ9Im0wIDBjLTUuOTc5IDAtMTguNjA2IDkuNDAyLTIyLjUxMiAyMi44Ni0zLjk0OCAxMy41OTYgMy40OCAzMy4wOTMgMjIuNTEyIDMzLjA5M3MyNi40Ni0xOS40OTcgMjIuNTEyLTMzLjA5M2MtMy45LTEzLjQ2NC0xNi41MzMtMjIuODYtMjIuNTEyLTIyLjg2IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTg0LjUzIDMxOC4zNykiPgo8cGF0aCBkPSJtMCAwYzQuMDI5IDIuOTQ2IDguMjQxIDEuMjA2IDkuNjQ4IDEuMjA2IDEuNDEgMCA1LjM4MiAxLjc0NiA5LjQxNC0xLjIwNi0yLjAwNC04LjEwOS0xNi4wMjMtOC4zMTMtMTkuMDYyIDAiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxODQuNjUgMzE4LjQxKSI+CjxwYXRoIGQ9Im0wIDBjMy43NDQgMS4zMiA3LjA1Ni0xLjI2OSA5LjQwNS0xLjI2OSAyLjM1OCAwIDUuNjc2IDMuNDc0IDkuNDIgMS4xMzQtNC4zODktNC40NjctMTQuNDA5LTQuMjI3LTE4LjgyNSAwLjEzNSIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE4NC41MyAzMTguNDEpIj4KPHBhdGggZD0ibTAgMGM0LjAyOSAxLjY2MiA3LjAwMiAwLjQ1NiA5LjM1NyAwLjQ1NiAyLjM1MiAwIDUuNjczIDEuMjA2IDkuNzA1LTAuNDU2LTQuMzgzLTIuNTA4LTE0LjY0My0yLjQyNC0xOS4wNjIgMCIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE4NC41NSAzMTguNCkiPgo8cGF0aCBkPSJtMCAwYzQuMDE0IDIuOTEzIDcuNDYxIDAuODkxIDkuODEgMC44OTEgMi4zNTIgMCA1LjE4NCAyLjAyOCA5LjIxNi0wLjkyMS0wLjAxNS0wLjA0Mi0wLjAzMy0wLjA4NC0wLjA0OC0wLjEyMy01LjEzNiAwLjA5Ni0xMy41NDggMC4xNDctMTguOTc4IDAuMTUzIiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTY2LjY1IDMzMy4zOSkiPgo8cGF0aCBkPSJtMCAwYzEuOTIgMC44MjUgNC42MzgtMS4yIDYuMDY5LTQuNTI0IDEuNDI1LTMuMzI0IDEuMDI2LTYuNjktMC45LTcuNTE1LTEuOTItMC44MjUtNC42MzUgMS4xOTQtNi4wNjYgNC41MjQtMS40MjggMy4zMjEtMS4wMjkgNi42OSAwLjg5NyA3LjUxNSIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIxOS43MiAzMzMuMzgpIj4KPHBhdGggZD0ibTAgMGMxLjkyNi0wLjgyNSAyLjMyOC00LjE5NCAwLjg5Ny03LjUxNS0xLjQyNS0zLjMyNC00LjE0Ni01LjM0OS02LjA2Ni00LjUyNC0xLjkyNiAwLjgyNS0yLjMzMSA0LjE5MS0wLjkgNy41MTUgMS40MjUgMy4zMyA0LjE0OSA1LjM1NSA2LjA2OSA0LjUyNCIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIxNi4yNCAzMjguODkpIj4KPHBhdGggZD0ibTAgMGMxMS4yMiAzMS41OTYtMTAuNDI4IDMzLjYwNi0yMy4xNTQgMzMuNjA2LTE0LjMzNCAwLTMxLjA3MS03LjMxNC0yMS44MS0zMy45NzIgMTMuNjYyIDAuNjc1IDI1LjY3MSA4LjI5MiAzNy43NDYgMjQuMjk0IDIuMDU1LTguMTI3IDMuNDQxLTE4LjY5NiA3LjIxOC0yMy45MjgiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMjkuNDcgMTQ2LjkpIj4KPHBhdGggZD0ibTAgMGMzLjMwNi00Ljc4MiA3LjYyOS03LjExIDguMjc0LTExLjIyMyAwLjMxOC0yLjAyMiAwLjEwNS0zLjYyNy0xLjg4MS0zLjg3Ni04LjUzMi0xLjA1My05LjQ3NyAyLjM5Ny0xMi41MTMgMy4yNDYtNS4yNTYgMS40NzYtNi4zMjcgNC42OC00LjIwMyAxMS44NTMgMi4xMjcgNy4xNzMgNy42NjggNC40NzMgMTAuMzIzIDAiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMzQuNDYgMjM3LjgpIj4KPHBhdGggZD0ibTAgMGgtMzkuMDNsNC45OC05MC45MDNoMTAuMzI2bDIuMSA2OS4xNDFjMC4xNjUgNS40ODEgNC4wNDcgNS41MTEgNC4yMTUgMGwyLjEwMy02OS4xNDFoMTAuMzJ6IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTMxLjU2IDI5Ni43MykiPgo8cGF0aCBkPSJtMCAwIDYuOTE4LTM4LjQ0OGMwLjg0My00LjY1OSAxMC4wNjgtMC4xNzcgOS45MzYgMi4yMTRsLTIuMDEgMzUuMDc2Yy0wLjY0NSAxMS4yNjUtMTYuNzQgMTEuNjk0LTE0Ljg0NCAxLjE1OCIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDg4LjQgMzQxLjcyKSI+CjxwYXRoIGQ9Im0wIDBjOC4wNyAxLjk1LTUuNTgtOS4zMyA1LjMyMi0yMS40MDUgMTAuOTA1LTEyLjA3OCAzLjYwOS0yNy42MzktNy4wMjktMjkuODI2LTQuNDc5LTAuOTIxIDkuOTQ4IDguOTYxLTIuOTUyIDIwLjM0Ni04LjIzNSA3LjI3Mi05LjM4NyAyNy40NzQgNC42NTkgMzAuODg1IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOTEuNzEgMzA0LjM2KSI+CjxwYXRoIGQ9Im0wIDAgMy43MTctNjYuNTU1aDM5LjAzbDMuNzIgNjYuNTU1eiIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzNi44NyAyMzIuNDQpIj4KPHBhdGggZD0ibTAgMGMtMC4zNzggMC4yNTItMC44NDYtMC4yNTUtMC44ODItMC42OTlsLTAuNDk1LTYuNTg4Yy0wLjAzMy0wLjQ0NyAwLjM5Ni0wLjY2NiAwLjc3MS0wLjkyMSAwLjM4MS0wLjI1MiAwLjg0OSAwLjI1NSAwLjg4MiAwLjcwMmwwLjQ5NSA2LjU4NWMwLjAzMyAwLjQ0Ny0wLjMxOCAwLjg2MS0wLjc3MSAwLjkyMSIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzNS45NyAyMjkuNjMpIj4KPHBhdGggZD0iTSAwLDAgMC4yMTMsMi44MjkgOS41NzksMS40ODUgOS4zNjMsLTEuMzQ0IEMgOC40NTQsLTkuODc2IC0xLjA2MiwtMTAuMzU2IDAsMCIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzNi4wOCAyMzEuNjMpIj4KPHBhdGggZD0ibTAgMCAyLjAyMiAyNy4yMWMxLjc0NiA3LjIwOSA5LjkzIDguMDc2IDEwLjMxMSAxLjY2MmwtMy4wNTctMzAuMTc3eiIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzNC40NiAyMzcuOCkiPgo8cGF0aCBkPSJtMCAwLTEuNDQ5LTI2LjM3M2gtMzYuMDMzbC0xLjU0OCAyNi4zNzMgMTguMTY1IDU1Ljg2OWMwLjgzMS0wLjA3OCAxLjY2OC0wLjA5OSAyLjUwOC0wLjAyMXoiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMDAuMzggMTQ2LjkpIj4KPHBhdGggZD0ibTAgMGMtMy4zMDYtNC43ODItNy45MzgtNy41NzgtOC41MjMtMTEuMzQtMC4zMTgtMi4wMjIgMC41MS0zLjcwOCAyLjQ4Ny0zLjk1NyA4LjUzMi0xLjA1MyA5LjIyNSAzLjExMSAxMi4yNTggMy45NTcgNS4yNTYgMS40NzYgNi4yMjUgNC4xNjcgNC4xMDQgMTEuMzQtMi4xMjQgNy4xNzMtNy42NzEgNC40NzMtMTAuMzI2IDAiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMzUuNTEgMTQwLjA1KSI+CjxwYXRoIGQ9Im0wIDBjMS4yODQtMS4zODkgMi4zMTMtMi43IDIuNzcyLTQuMTM3IDEuNjA4LTUuMDQzLTIuODg5LTUuMTc4LTYuNTU1LTQuNzA0LTQuODkzIDAuNjMzLTYuOTMgMy4zNi05LjMxNSA0LjAyNi00LjcxMyAxLjMyMy01LjMwNCAzLjg5Ny0zLjgzNCA5LjYwMyAwLjE5OC00Ljk4IDQuODYtNi4zMzYgMTAuMDMyLTguNzg3IDUuMTY2LTIuNDUxIDkuMzM2LTAuMDIxIDYuOSAzLjk5OSIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDk0LjM0OCAxNDAuMDUpIj4KPHBhdGggZD0ibTAgMGMtMS4yODQtMS4zODktMi4zMTMtMi43LTIuNzcyLTQuMTM3LTEuODM5LTUuNzcyIDQuNzE2LTUuMzM3IDguNDI0LTQuMzM1IDMuNTkxIDAuOTc1IDUuMzkxIDMuMDgxIDcuNDQ2IDMuNjU3IDQuNzE2IDEuMzIzIDUuMzA0IDMuODk3IDMuODM0IDkuNjAzLTAuMTk4LTQuOTgtNC44Ni02LjMzNi0xMC4wMjYtOC43ODctNS4xNzItMi40NTEtOS4zNDItMC4wMjEtNi45MDYgMy45OTkiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNDguNDIgMjYwLjUpIj4KPHBhdGggZD0ibTAgMC0xMC4zMTEtMS42NjItMC44MzQgNy42NSAxMC41OTMgMS44Njl6IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOTguMDE3IDI5Ni43MykiPgo8cGF0aCBkPSJtMCAwLTYuOTE4LTM4LjQ0OGMtMC44NDMtNC42NTktMTAuMDc0LTAuMTc3LTkuOTM5IDIuMjE0bDIuMDA3IDM1LjA3NmMwLjY0OCAxMS4yNjUgMTYuNzQzIDExLjY5NCAxNC44NSAxLjE1OCIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDkyLjcwNyAyMzIuNDQpIj4KPHBhdGggZD0ibTAgMGMwLjM3OCAwLjI1MiAwLjg0OS0wLjI1NSAwLjg4Mi0wLjY5OWwwLjQ4OS02LjU4OGMwLjAzOS0wLjQ0Ny0wLjM5LTAuNjY2LTAuNzcxLTAuOTIxLTAuMzc1LTAuMjUyLTAuODQ5IDAuMjU1LTAuODgyIDAuNzAybC0wLjQ4OSA2LjU4NWMtMC4wMzMgMC40NDcgMC4zMjEgMC44NjEgMC43NzEgMC45MjEiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg5My42MDUgMjI5LjYzKSI+CjxwYXRoIGQ9Im0wIDAtMC4yMTYgMi44MjktOS4zNTctMS4zNDQgMC4yMTMtMi44MjljMC45MDktOC41MzIgMTAuNDIyLTkuMDEyIDkuMzYgMS4zNDQiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg5My40OTMgMjMxLjYzKSI+CjxwYXRoIGQ9Im0wIDAtMi4wMjIgMjcuMjFjLTEuNzQzIDcuMjA5LTkuOTM2IDguMDc2LTEwLjMxNyAxLjY2MmwzLjA2My0zMC4xNzd6IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoODEuMTYxIDI2MC41KSI+CjxwYXRoIGQ9Im0wIDAgMTAuMzExLTEuNjYyIDAuODI4IDcuNjUtMTAuNTg3IDEuODY5eiIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDkwLjI2MSAzNjIuODMpIj4KPHBhdGggZD0ibTAgMGMzLjE5NSA2Ljc4IDkuNDQxIDExLjAyMiAxOC4xNTYgOS40MTcgNi45NjYgOC41MjkgMjUuNDU4IDAuODE2IDI5LjIzNS02LjY2MyAxNC41NzQtMjguODc1LTExLjE2OS00NS4wNzgtMjMuMzM3LTQ1LjA3OC0xMC45MjMtNmUtMyAtMzUuMjQ3IDE4LjYwNi0yNC4wNTQgNDIuMzI0IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTIzLjk1IDMzMS42NikiPgo8cGF0aCBkPSJtMCAwdi0zMy40NDFjLTQuOTU5LTYuNTEtMTMuMDY1LTYuMjkxLTE4LjAyMSAwdjMzLjQ0MWMwIDExLjkxOSAxOC4wMjEgMTEuOTE5IDE4LjAyMSAwIiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTIzLjk1IDMyNy4xMSkiPgo8cGF0aCBkPSJtMCAwdi0xNC43NzhjLTMuNDExLTIuNjczLTYuNjk5LTQuMTY0LTkuMDEyLTQuMTY0cy01LjYwMSAxLjQ5MS05LjAwOSA0LjE2NHYxNC43NzhjMCAxMS45MjUgMTguMDIxIDExLjkyNSAxOC4wMjEgMCIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE0MC41NiAzNDEuNzIpIj4KPHBhdGggZD0ibTAgMGMxNC4wNDYtMy40MTEgMTIuODk0LTIzLjYxMyA0LjY1OS0zMC44ODUtMTIuOS0xMS4zODUgMS41MjctMjEuMjY3LTIuOTUyLTIwLjM0Ni0xMC42MzggMi4xODctMTcuOTM0IDE3Ljc0OC03LjAyOSAyOS44MjYgMTAuOTAyIDEyLjA3NS0yLjc0OCAyMy4zNTUgNS4zMjIgMjEuNDA1IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTM4LjUgMzQyLjc5KSI+CjxwYXRoIGQ9Im0wIDBjMi44NzQgMi4wMSA1Ljg1IDIuNzE1IDYuNjQyIDEuNTc1IDAuNzkyLTEuMTM0LTAuODk3LTMuNjgxLTMuNzcxLTUuNjg1LTIuODcxLTIuMDA0LTUuODQ3LTIuNzE1LTYuNjM5LTEuNTc1LTAuNzk1IDEuMTM0IDAuODk3IDMuNjgxIDMuNzY4IDUuNjg1IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOTEuNzQ4IDM0Mi44KSI+CjxwYXRoIGQ9Im0wIDBjMi44NzQtMi4wMDQgNC41NjYtNC41NTQgMy43NzQtNS42OTEtMC43OTItMS4xMzEtMy43NjgtMC40MjYtNi42NDUgMS41NzgtMi44NzQgMi4wMDQtNC41NiA0LjU1NC0zLjc2NSA1LjY5MSAwLjc5MiAxLjEzMSAzLjc2MiAwLjQyNiA2LjYzNi0xLjU3OCIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDExNC45NCAzMTEuODMpIj4KPHBhdGggZD0iTSAwLDAgQyAtNS44NjUsMCAtMTguMjY0LDkuMjI1IC0yMi4wOTIsMjIuNDQgLTI1Ljk2NSwzNS43ODEgLTE4LjY3OCw1NC45MTUgMCw1NC45MTUgMTguNjgxLDU0LjkxNSAyNS45NjgsMzUuNzgxIDIyLjA5MiwyMi40NCAxOC4yNjEsOS4yMjUgNS44NjgsMCAwLDAiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMDUuNTkgMzI3LjU4KSI+CjxwYXRoIGQ9Im0wIDBjMy45NTQgMi44OTIgOC4wODUgMS4xNzYgOS40NjIgMS4xNzYgMS4zODMgMCA1LjI4MyAxLjcxOSA5LjI0My0xLjE3Ni0xLjk3MS03Ljk1OS0xNS43MjYtOC4xNjMtMTguNzA1IDAiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMDUuNzEgMzI3LjYyKSI+CjxwYXRoIGQ9Im0wIDBjMy42NzIgMS4yOTMgNi45MjQtMS4yMzkgOS4yMzEtMS4yMzkgMi4zMTMgMCA1LjU2OCAzLjQwMiA5LjI0MyAxLjExMy00LjMwOC00LjM5Mi0xNC4xMzktNC4xNDktMTguNDc0IDAuMTI2IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTA1LjU5IDMyNy42MikiPgo8cGF0aCBkPSJtMCAwYzMuOTU0IDEuNjI5IDYuODcgMC40NDcgOS4xNzQgMC40NDcgMi4zMTYgMCA1LjU3NyAxLjE4MiA5LjUzMS0wLjQ0Ny00LjMwMi0yLjQ2My0xNC4zNzYtMi4zNzktMTguNzA1IDAiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMDUuNjEgMzI3LjYpIj4KPHBhdGggZD0ibTAgMGMzLjkzOSAyLjg1OSA3LjMyIDAuODc2IDkuNjI3IDAuODc2IDIuMzEgMCA1LjA4NSAxLjk5NSA5LjA0OC0wLjg5Ny0wLjAxOC0wLjA0NS0wLjAzNi0wLjA4NC0wLjA1MS0wLjEyLTUuMDQ2IDAuMDg3LTEzLjI5NiAwLjE0MS0xOC42MjQgMC4xNDEiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNDAuMTIgMzQyLjMzKSI+CjxwYXRoIGQ9Im0wIDBjMS44ODQtMC44MSAyLjI4LTQuMTEgMC44NzYtNy4zNzctMS4zOTgtMy4yNTgtNC4wNjUtNS4yNS01Ljk1NS00LjQzNy0xLjg4NyAwLjgwNy0yLjI4IDQuMTA3LTAuODgyIDcuMzc0IDEuNDA3IDMuMjY3IDQuMDcxIDUuMjU2IDUuOTYxIDQuNDQiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg4OC44NDEgMzQyLjMzKSI+CjxwYXRoIGQ9Im0wIDBjMS44OSAwLjgxNiA0LjU1NC0xLjE3MyA1Ljk2MS00LjQ0IDEuMzk4LTMuMjY3IDEuMDA1LTYuNTY3LTAuODgyLTcuMzc0LTEuODktMC44MTMtNC41NTcgMS4xNzktNS45NTUgNC40MzctMS40MDQgMy4yNjctMS4wMDggNi41NjcgMC44NzYgNy4zNzciIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMzYuNzEgMzM3LjkpIj4KPHBhdGggZD0ibTAgMGMxMS4wMDcgMzAuOTk5LTEwLjIzMyAzMi45NzMtMjIuNzI1IDMyLjk3My0xNC4wNyAwLTMwLjQ4OS03LjE3My0yMS40MDgtMzMuMzMgMTMuNDEzIDAuNjYgMjUuMTk0IDguMTMzIDM3LjA0NCAyMy44MzggMi4wMjItNy45OCAzLjM4MS0xOC4zNDggNy4wODktMjMuNDgxIiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzUuNzMxIDI5OS42OSkiPgo8cGF0aCBkPSJtMCAwYy0xNC41NjgtMC4yMS0xNi43NyAyNi4yNzctMjMuMzg1IDQ1LjEzMi05LjgxMyAyNy45NzggMjIuNzgyIDQzLjc4NSAzMy43NDEgMzMuNjIxIDExLjY1NSAwIDE5LjYzMi0yMi4zNDEgMTIuODUyLTM4LjUyMy04LjUzNS0yMC4zNjQtMTIuMy00MS43MTItMjMuMjA4LTQwLjIzIDAgMCA2LjQ0NyAwLjI3MyAwIDAiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMC41NDQgMTU0LjcpIj4KPHBhdGggZD0ibTAgMGMtMy4zMTgtNC44MDMtNy43MzQtNy41NjMtOC44MzUtMTEuMDMxLTAuNjI3LTEuOTU2LTAuMTYyLTMuMDE4IDEuODMtMy4yNjEgOC41NjUtMS4wNjIgMTEuMDQ2IDEuNzMxIDE0LjEgMi41ODkgNS4yNjggMS40NzYgNS40MDYgNC41MDMgMy4yNzMgMTEuNzAzLTIuMTM2IDcuMTk0LTcuNjk4IDQuNDkxLTEwLjM2OCAwIiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTUuNTQ2IDI0NS45NCkiPgo8cGF0aCBkPSJtMCAwaDM5LjE3N2wtNC45OTgtOTEuMjM5aC0xMC4zNjVsLTIuMTA2IDY5LjM5NmMtMC4xNzEgNS40OTktNC4wNjUgNS41MzItNC4yMzYgMGwtMi4xMDktNjkuMzk2aC0xMC4zNjV6IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNTguNDU2IDMxMi43NSkiPgo8cGF0aCBkPSJtMCAwLTMuNzMyLTY2LjgxM2gtMzkuMTc3bC0zLjczMiA2Ni44MTN6IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNTIuNzI4IDMwNS4wNikiPgo8cGF0aCBkPSJtMCAwIDUuNjY3LTM4LjU1OWMwLjY5LTQuNzA3IDEwLjA2NS0yLjEzIDkuOTc1IDIuMjE3bC0wLjc0MSAzNS4xODdjLTAuMjM3IDExLjMxNi0xNi40NjQgMTEuNzg3LTE0LjkwMSAxLjE1NSIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDU2Ljc3NiAyNDAuNTYpIj4KPHBhdGggZD0ibTAgMGMtMC4zNzUgMC4yNTUtMC44NTItMC4yNTgtMC44ODUtMC43MDhsLTAuNDkyLTYuNjEyYy0wLjAzMy0wLjQ0NyAwLjM5OS0wLjY2OSAwLjc3NC0wLjkyNHMwLjg1MiAwLjI2MSAwLjg4NSAwLjcwOGwwLjQ5MiA2LjYxMmMwLjAzMyAwLjQ0Ny0wLjMxNSAwLjg2NC0wLjc3NCAwLjkyNCIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDU1Ljg3NCAyMzcuNzMpIj4KPHBhdGggZD0iTSAwLDAgMC4yMTYsMi44NDcgOS42MDksMS41IDkuMzkzLC0xLjM1IEMgOC40ODcsLTkuOTE1IC0xLjA2OCwtMTAuMzkyIDAsMCIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDU1Ljk4NCAyMzkuNzQpIj4KPHBhdGggZD0ibTAgMCAyLjAzNCAyNy4zMTJjMS43NTUgNy4yMzkgMTEuODExIDcuMDc0IDEwLjQ0LTEuOTAybC0zLjE2Mi0yNi43MjR6IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTcuMTc2IDMwNS4wNikiPgo8cGF0aCBkPSJtMCAwLTUuNjczLTM4LjU1OWMtMC42OS00LjcwNy0xMC4wNjItMi4xMy05Ljk2OSAyLjIxN2wwLjc0MSAzNS4xODdjMC4yNCAxMS4zMTYgMTYuNDYxIDExLjc4NyAxNC45MDEgMS4xNTUiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMy4xMjQgMjQwLjU2KSI+CjxwYXRoIGQ9Im0wIDBjMC4zODEgMC4yNTUgMC44NTItMC4yNTggMC44ODUtMC43MDhsMC40OTUtNi42MTJjMC4wMy0wLjQ0Ny0wLjM5Ni0wLjY2OS0wLjc3Ny0wLjkyNC0wLjM3NS0wLjI1NS0wLjg1MiAwLjI2MS0wLjg4NSAwLjcwOGwtMC40OTIgNi42MTJjLTAuMDMzIDAuNDQ3IDAuMzIxIDAuODY0IDAuNzc0IDAuOTI0IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTQuMDI0IDIzNy43MykiPgo8cGF0aCBkPSJtMCAwLTAuMjE2IDIuODQ3LTkuMzkzLTEuMzQ3IDAuMjE2LTIuODVjMC45MTItOC41NjUgMTAuNDYxLTkuMDQyIDkuMzkzIDEuMzUiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMy45MTQgMjM5Ljc0KSI+CjxwYXRoIGQ9Im0wIDAtMi4wMjggMjcuMzEyYy0xLjc1OCA3LjIzOS0xMS44MTcgNy4wNzQtMTAuNDQ2LTEuOTAybDMuMTYyLTI2LjcyNHoiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNS41NDYgMjQ1Ljk0KSI+CjxwYXRoIGQ9Im0wIDAgMS40NDktNTQuNzhoMzYuMTc3bDEuNTUxIDU0Ljc4LTE5LjgyNCAyNC44MzF6IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDkuNzQ4IDE1NC43KSI+CjxwYXRoIGQ9Im0wIDBjMy4zMTItNC44MDMgNy43MzEtNy41NjMgOC44MzUtMTEuMDMxIDAuNjI0LTEuOTU2IDAuMTU5LTMuMDE4LTEuODMtMy4yNjEtOC41NjUtMS4wNjItMTEuMDUyIDEuNzMxLTE0LjEgMi41ODktNS4yNjggMS40NzYtNS40MDYgNC41MDMtMy4yNzMgMTEuNzAzIDIuMTM2IDcuMTk0IDcuNjk4IDQuNDkxIDEwLjM2OCAwIiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTQuNDkgMTQ3LjgzKSI+CjxwYXRoIGQ9Im0wIDBjLTEuMjktMS4zOTUtMi4zMjItMi43MTUtMi43ODEtNC4xNTgtMS42MTQtNS4wNTggMi44OTItNS4xOTMgNi41NzktNC43MTYgNC45MTEgMC42MzYgNi45NTQgMy4zNjYgOS4zNTEgNC4wNDEgNC43MzEgMS4zMjYgNS4zMjIgMy45MDkgMy44NDYgOS42MzYtMC4yMDQtNC45OTgtNC44NzUtNi4zNTctMTAuMDY4LTguODE3LTUuMTg3LTIuNDYtOS4zNzItMC4wMjctNi45MjcgNC4wMTQiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg1NS44MDIgMTQ3LjgzKSI+CjxwYXRoIGQ9Im0wIDBjMS4yODctMS4zOTUgMi4zMjItMi43MTUgMi43ODEtNC4xNTggMS44NDgtNS43OS00LjczNC01LjM1Mi04LjQ0OC00LjM0Ny0zLjYxMiAwLjk3OC01LjQxOCAzLjA5My03LjQ4MiAzLjY3Mi00LjczMSAxLjMyNi01LjMyNSAzLjkwOS0zLjg0NiA5LjYzNiAwLjE5OC00Ljk5OCA0Ljg3NS02LjM1NyAxMC4wNjgtOC44MTdzOS4zNzItMC4wMjcgNi45MjcgNC4wMTQiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzNS4wODQgMjQ1Ljk0KSI+CjxwYXRoIGQ9Im0wIDBoLTE5LjUzOWwtMy4xOTggNDYuOTUgMTMuNjkyIDE5Ljg2M2gxOC4wOWwxMy40MjItMTkuODYzLTIuOTM0LTQ2Ljk1eiIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQ0LjEzIDMzNi4yMSkiPgo8cGF0aCBkPSJtMCAwdi0yMy40NmMwLTE0LjctMTguMDktMTQuNDA5LTE4LjA5IDB2MjMuNDZjMCAxMS45NjQgMTguMDkgMTEuOTY0IDE4LjA5IDAiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0NC4xMyAzMzYuMjEpIj4KPHBhdGggZD0ibTAgMHYtMTQuODQxYy0zLjQyMy0yLjY3Ni02LjcyMy00LjE3My05LjA0NS00LjE3M3MtNS42MjIgMS40OTctOS4wNDUgNC4xNzN2MTQuODQxYzAgMTEuOTY0IDE4LjA5IDExLjk2NCAxOC4wOSAwIiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzUuMDg0IDMyMC44OCkiPgo8cGF0aCBkPSJNIDAsMCBDIC01Ljg5NSwwIC0xOC4zMzMsOS4yNjEgLTIyLjE4MiwyMi41MjQgLTI2LjA2NCwzNS45MTYgLTE4Ljc1LDU1LjEyNSAwLDU1LjEyNSAxOC43NDQsNTUuMTI1IDI2LjA1OCwzNS45MTYgMjIuMTc2LDIyLjUyNCAxOC4zMyw5LjI2MSA1Ljg4OSwwIDAsMCIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI3Ljk4NiAzMzQuMjMpIj4KPHBhdGggZD0ibTAgMGMzLjAwMyAyLjkwNCA1LjM0NiAwLjcyOSA3LjA5OCAwLjcyOSAxLjc1NSAwIDQuMDkyIDIuMTgxIDcuMDk1LTAuNzI5LTEuNjE3LTcuNjYyLTEyLjA1NC03LjkwMi0xNC4xOTMgMCIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI4LjkwOSAzMzMuODMpIj4KPHBhdGggZD0iTSAwLDAgQyAxLjY0MSwwLjQyIDkuOTk2LDAuNTAxIDEyLjM0OCwwLjA5MyAxMC40MDcsLTMuNDc3IDEuNjQxLC0zLjI3MyAwLDAiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNy45ODYgMzM0LjIzKSI+CjxwYXRoIGQ9Ik0gMCwwIEMgMy4wMDMsMi45MDQgNS4zNDYsMC43MjkgNy4wOTgsMC43MjkgOC44NTMsMC43MjkgMTEuMTksMi45MSAxNC4xOTMsMCA5LjYwMywtMi4yNjIgMy4wOSwtMS4yMDYgMCwwIiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOS4xOTc3IDM1MS40OCkiPgo8cGF0aCBkPSJtMCAwYzEuODk2IDAuODEzIDQuNTcyLTEuMTgyIDUuOTgyLTQuNDU4IDEuNDA0LTMuMjc2IDEuMDE0LTYuNTk0LTAuODg1LTcuNDA3LTEuODk2LTAuODEzLTQuNTcyIDEuMTgyLTUuOTc2IDQuNDYxLTEuNDEgMy4yNzMtMS4wMTEgNi41OTEgMC44NzkgNy40MDQiIGZpbGw9IiMyMzFmMjAiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg2MS40ODYgMzUxLjQ5KSI+CjxwYXRoIGQ9Im0wIDBjMS44OTYtMC44MTMgMi4yODktNC4xMjUgMC44ODUtNy40MDQtMS40MS0zLjI3OS00LjA4Ni01LjI3NC01Ljk4Mi00LjQ1NS0xLjg5MyAwLjgxMy0yLjI4OSA0LjEyOC0wLjg4NSA3LjQwMSAxLjQxIDMuMjc5IDQuMDg2IDUuMjc3IDUuOTgyIDQuNDU4IiBmaWxsPSIjMjMxZjIwIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNTkuMDUzIDM0My42NCkiPgo8cGF0aCBkPSJtMCAwYzcuMTE2IDMwLjUxMy0xNC4zNyAzNS43MDYtMjYuOTA0IDM1LjcwNi0xNC4xMjEgMC0yMS42My0xNi40MzEtMTkuMjQ1LTM1Ljk0MyA3LjUzIDQuNTM5IDExLjAyOCAxMy4xNzkgMjcuNDk1IDI3LjgxLTIuMzk0LTQuMjk2LTcuMDYyLTEyLjEwNS0yMi45MzUtMjYuMjY1IDguNTQxLTEuNDA3IDI0LjQ1IDkuMzU3IDMyLjkzMSAyMC42MTkgMi4wMjItOC4wMDQgNC45MzgtMTYuNzc2IDguNjU4LTIxLjkyNyIgZmlsbD0iIzIzMWYyMCIvPgo8L2c+CjwvZz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMzEuNSAxMjguMDUpIj4KPHBhdGggZD0ibTAgMC0yLjU3NCAzNC42MTdjLTIuMjIgOS4xNzctMTQuMTAzIDguMDgyLTEyLjM2Ni0zLjI5NGwzLjEzOC0zMi45ODJ6IiBmaWxsPSIjODk2NDRjIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxODUuMDcgMTI4LjA1KSI+CjxwYXRoIGQ9Im0wIDAgMi41OCAzNC42MTdjMi4yMiA5LjE3NyAxNC4yMjYgOC45NyAxMi40ODktMi40MDNsLTMuMjY3LTMzLjg3M3oiIGZpbGw9IiM4OTY0NGMiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE4Ny45NiAyMjAuNTgpIj4KPHBhdGggZD0ibTAgMC0xMS4zMjUtODQuNjc1aC0zNy45NTNsLTkuODQgODQuNjc1eiIgZmlsbD0iIzg5NjQ0YyIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTM5LjkxIDIwLjI1NykiPgo8cGF0aCBkPSJtMCAwYy00LjIwNi02LjA4NC05LjgwNC05LjU4OC0xMS4yMDUtMTMuOTc0LTAuNzkyLTIuNDgxLTAuMjA0LTUuNjE5IDIuMzE5LTUuOTM3IDEwLjg1NC0xLjMzOCAxNC4wMDcgMy45OTYgMTcuODY4IDUuMDc2IDYuNjc4IDEuODc4IDYuODU1IDUuNzE1IDQuMTQ5IDE0LjgzNS0yLjcwMyA5LjEyMy05Ljc1NiA1LjY5Ny0xMy4xMzEgMCIgZmlsbD0iIzg5NjQ0YyIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTg2LjA3IDEyOS4wOSkiPgo8cGF0aCBkPSJtMCAwYy0wLjQ4MyAwLjMyNy0xLjA4LTAuMzI0LTEuMTIyLTAuODkxbC0wLjYzLTguMzc5Yy0wLjAzNi0wLjU3IDAuNTA0LTAuODQ5IDAuOTg3LTEuMTczIDAuNDc3LTAuMzIxIDEuMDggMC4zMjQgMS4xMjIgMC44OTFsMC42MjQgOC4zODJjMC4wNDIgMC41NjctMC40MDggMS4xMDEtMC45ODEgMS4xNyIgZmlsbD0iIzg5NjQ0YyIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTg0LjkzIDEyNS41KSI+CjxwYXRoIGQ9Ik0gMCwwIDAuMjc2LDMuNjA5IDEyLjE4LDEuODkzIDExLjkwNywtMS43MSBDIDEwLjc1OCwtMTIuNTY0IC0xLjM1MywtMTMuMTczIDAsMCIgZmlsbD0iIzg5NjQ0YyIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTMwLjUgMTI5LjA5KSI+CjxwYXRoIGQ9Im0wIDBjMC40ODMgMC4zMjcgMS4wNzctMC4zMjQgMS4xMTktMC44OTFsMC42MzMtOC4zNzljMC4wNDItMC41Ny0wLjUwNC0wLjg0OS0wLjk4MS0xLjE3My0wLjQ4My0wLjMyMS0xLjA4IDAuMzI0LTEuMTIyIDAuODkxbC0wLjYzIDguMzgyYy0wLjA0MiAwLjU2NyAwLjQwNSAxLjEwMSAwLjk4MSAxLjE3IiBmaWxsPSIjODk2NDRjIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMzEuNjQgMTI1LjUpIj4KPHBhdGggZD0ibTAgMC0wLjI2NyAzLjYwOS0xMS45MTMtMS43MTYgMC4yNzYtMy42MDNjMS4xNTUtMTAuODU0IDEzLjI2My0xMS40NjMgMTEuOTA0IDEuNzEiIGZpbGw9IiM4OTY0NGMiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE2OS44NiAyNTAuNjIpIj4KPHBhdGggZD0ibTAgMHYtMzQuMTI4Yy02LjMwOS04LjI4My0xNi42MjMtOC4wMDQtMjIuOTI5IDB2MzQuMTI4YzAgMTUuMTcxIDIyLjkyOSAxNS4xNjUgMjIuOTI5IDAiIGZpbGw9IiM4OTY0NGMiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE3Ny4zNSAyMC4yNTcpIj4KPHBhdGggZD0ibTAgMGM0LjIwNi02LjA4NCA5LjgwNC05LjU4OCAxMS4xOTktMTMuOTc0IDAuNzkyLTIuNDgxIDAuMjEtNS42MTktMi4zMTMtNS45MzctMTAuODU0LTEuMzM4LTE0LjAwNyAzLjk5Ni0xNy44NjggNS4wNzYtNi42ODcgMS44NzgtNi44NTUgNS43MTUtNC4xNTggMTQuODM1IDIuNzA2IDkuMTIzIDkuNzU2IDUuNjk3IDEzLjE0IDAiIGZpbGw9IiM4OTY0NGMiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzMi4yMyAxMS41NTIpIj4KPHBhdGggZD0ibTAgMGMtMS42MzItMS43NzMtMi45NDMtMy40NDEtMy41MjItNS4yNzEtMi4wNDktNi40MTEgMy42NjktNi41NzkgOC4zMzctNS45NzYgNi4yMjIgMC43OTggOC44MTcgNC4yNjYgMTEuODUgNS4xMTUgNS45OTcgMS42OCA2Ljc0NyA0Ljk1NiA0Ljg3OCAxMi4yMTYtMC4yNTItNi4zMy02LjE4LTguMDU1LTEyLjc2Mi0xMS4xNzItNi41NzMtMy4xMjYtMTEuODc3LTAuMDM2LTguNzgxIDUuMDg4IiBmaWxsPSIjY2MxYjc0IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxODUuMDMgMTEuNTUyKSI+CjxwYXRoIGQ9Im0wIDBjMS42MzItMS43NzMgMi45NDMtMy40NDEgMy41MjUtNS4yNzEgMi4zNC03LjM0MS02LTYuNzg5LTEwLjcxNi01LjUwOC00LjU2OSAxLjIzNi02Ljg1OCAzLjkxOC05LjQ3NCA0LjY0Ny02LjAwNiAxLjY4LTYuNzQ3IDQuOTU2LTQuODc4IDEyLjIxNiAwLjI1NS02LjMzIDYuMTgtOC4wNTUgMTIuNzUzLTExLjE3MiA2LjU4Mi0zLjEyNiAxMS44ODYtMC4wMzYgOC43OSA1LjA4OCIgZmlsbD0iI2NjMWI3NCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTI5Ljk3IDE0OC42NykiPgo8cGF0aCBkPSJtMCAwLTEuOTQxIDE5Ljg0NWMtMi4yMjMgOS4xNzQtMTMuNzcgNS42MzQtMTIuMDMzLTUuNzM5bDEuMTg1LTE1LjA2eiIgZmlsbD0iI2NjMWI3NCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTM1LjY0IDIxMC44NCkiPgo8cGF0aCBkPSJtMCAwLTcuMTgyLTQ4Ljg3OWMtMC44ODUtNS45NTgtMTIuNzUzLTIuNjk3LTEyLjY0MiAyLjgxN2wwLjkzNiA0NC41ODljMC4zMDMgMTQuMzUyIDIwLjg3MSAxNC45NDMgMTguODg4IDEuNDczIiBmaWxsPSIjY2MxYjc0IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxODAuOTQgMjEwLjg0KSI+CjxwYXRoIGQ9Im0wIDBjLTEuOTgzIDEzLjQ3IDE4LjU4NSAxMi44NzkgMTguODg4LTEuNDczbDAuOTM2LTQ0LjU4OWMwLjExMS01LjUxNC0xMS43NTctOC43NzUtMTIuNjQyLTIuODE3eiIgZmlsbD0iI2NjMWI3NCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTg2LjEgMjE4LjY5KSI+CjxwYXRoIGQ9Im0wIDAgMC40OC0yMi42OC0zLjM1Ny02MC4xMDVoLTQ5LjY1NmwtMy4zMDYgNTkuMjE3LTEzLjcxIDQuOTA1IDAuMTk4IDkuMzU0YzE3LjU1IDIwLjIyMyAyOS44MjMtMTIuNjM5IDU2LjI0NyA0Ljc0eiIgZmlsbD0iI2NjMWI3NCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTI4Ljg0IDIyMC41OCkiPgo8cGF0aCBkPSJtMCAwYzM0LjE2NC0xOS4zODMgNDQuNzY5LTQuMDM1IDU5LjExOCAwLTkuNjc4LTIuNzIxLTI3LjY4MS0zMS40MTYtNTkuMTE4IDAiIGZpbGw9IiNjYzFiNzQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE4Mi43NCAxOTguNTUpIj4KPHBhdGggZD0ibTAgMCA1LjEzNi0zNS4wNjFzMTIuNDE3LTQuMTk3IDEyLjUwMS0zLjIzMWMwLjA4NyAwLjk3NS0wLjU2MSA0OS4xMTktMC41NjEgNDkuMTE5eiIgZmlsbD0iI2NjMWI3NCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTg2LjU2IDE0OC42NykiPgo8cGF0aCBkPSJtMCAwIDEuNzEgMTkuMTczYzIuMjIgOS4xNzEgMTMuODU0IDMuNzg5IDEyLjExNy03LjU4NGwtMS4wNDQtMTIuNTQzeiIgZmlsbD0iI2NjMWI3NCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTY5Ljg2IDI0NC44MykiPgo8cGF0aCBkPSJtMCAwdi0xOC44MDFjLTQuMzM4LTMuMzkzLTguNTItNS4yOTgtMTEuNDY2LTUuMjk4LTIuOTQgMC03LjEyNSAxLjkwNS0xMS40NjMgNS4yOTh2MTguODAxYzAgMTUuMTcxIDIyLjkyOSAxNS4xNzEgMjIuOTI5IDAiIGZpbGw9IiM3NTU1NDMiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE1OC40IDIyNS40MSkiPgo8cGF0aCBkPSJtMCAwYy03LjQ2NCAwLTIzLjIyOSAxMS43MzktMjguMTA3IDI4LjU0Mi00LjkyNiAxNi45NzQgNC4zNDQgNDEuMzE2IDI4LjEwNyA0MS4zMTZzMzMuMDMzLTI0LjM0MiAyOC4xMDctNDEuMzE2Yy00Ljg2OS0xNi44MTItMjAuNjQzLTI4LjU0Mi0yOC4xMDctMjguNTQyIiBmaWxsPSIjODk2NDRjIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMjQuMTYgMjY0LjE5KSI+CjxwYXRoIGQ9Im0wIDBjMi4zOTcgMS4wMjkgNS43OS0xLjUgNy41NzUtNS42NDYgMS43NzktNC4xNTIgMS4yODQtOC4zNTUtMS4xMTktOS4zODctMi4zOTctMS4wMjktNS43OSAxLjQ5NC03LjU3OCA1LjY1Mi0xLjc3OSA0LjE0Ni0xLjI4MSA4LjM1MiAxLjEyMiA5LjM4MSIgZmlsbD0iIzg5NjQ0YyIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTkwLjQyIDI2NC4xOCkiPgo8cGF0aCBkPSJtMCAwYzIuNDAzLTEuMDI5IDIuOTA3LTUuMjM1IDEuMTIyLTkuMzgxLTEuNzc5LTQuMTUyLTUuMTgxLTYuNjgxLTcuNTc4LTUuNjUyLTIuNDAzIDEuMDMyLTIuOTA3IDUuMjM1LTEuMTE5IDkuMzg3IDEuNzc5IDQuMTUyIDUuMTc4IDYuNjg0IDcuNTc1IDUuNjQ2IiBmaWxsPSIjODk2NDRjIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMzAuNTIgMjU4LjU3KSI+CjxwYXRoIGQ9Im0wIDBjNC43MTYgNi41MzEgOC4wOTEgMTAuNjAyIDEwLjY1OSAyMC43NTEgMTUuMDcyLTE5Ljk4IDI4LjQyMi0yMC4zNjQgNDUuNDgtMjEuMjA3IDExLjU2MiAzMy4yNzktOS4zMzMgNDIuNDExLTI3LjIzNCA0Mi40MTEtMTUuODg1IDAtNDIuOTEyLTIuNTA4LTI4LjkwNS00MS45NTUiIGZpbGw9IiMzZjFmMGQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE3Ny4xOCAyMS4zMzcpIj4KPHBhdGggZD0ibTAgMCA2LjA0MiAxMTYuMzFoLTQ5LjUyMWw1LjkyNS0xMTdoMTMuODA5bDUuMjc3IDkyLjcwNiA1LjM3My05Mi4xMjd6IiBmaWxsPSIjMjgyODI4Ii8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTQ5LjQ3IDI0MS4yMSkiPgo8cGF0aCBkPSJtMCAwYzMuODA0IDMuNjgxIDYuNzcxIDAuOTE4IDkgMC45MTggMi4yMiAwIDUuMTg0IDIuNzYzIDguOTkxLTAuOTE4LTIuMDQ5LTkuNzE0LTE1LjI3OS0xMC4wMTQtMTcuOTkxIDAiIGZpbGw9IiNmZjM4NmEiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE0OS40NyAyNDEuMjEpIj4KPHBhdGggZD0ibTAgMGMzLjgwNCAzLjY4MSA2Ljc3MSAwLjkxOCA5IDAuOTE4IDIuMjExIDAgNS4xODQgMi43NjMgOC45OTEtMC45MTgtNS44Mi0yLjg2OC0xNC4wNzMtMS41MjctMTcuOTkxIDAiIGZpbGw9IiNjODIwNGEiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDc0LjUxNiAyOTQuMTgpIj4KPHBhdGggZD0ibTAgMGMzLjc2OCAxLjc1OCAxNC4xOS05LjU1MiAxMC44MDktMjUuNjQxLTE0LjUzOC02OS4xNjgtMjAuMDU4LTYyLjMyNS0zMy4wNDUtNjIuMzI1LTEyLjIzNCAwLTE1LjU1Mi0xLjk0NC0zMS41NTQgNTkuODA1LTMuNTI1IDEzLjU3NSAzLjc2MiAyNi42NDkgMTUuMDc4IDMyLjkzNyAxMS4zMSA2LjI4MiAyNy4xNSA4LjAzNCAzOC43MTItNC43NzYiIGZpbGw9IiNhMTQwMGYiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDM0LjQ3MiAyNi45ODMpIj4KPHBhdGggZD0ibTAgMGMtNC4xMDctNS45NDYtOS44NTItOS4zNjMtMTAuNTA5LTEzLjgxNS0wLjM3Mi0yLjUyIDAuMTY1LTQuNTE4IDIuNjI4LTQuODE4IDEwLjU5My0xLjMxNCAxMS45OTQgMy4yNDYgMTUuNzY1IDQuMzA1IDYuNTE5IDEuODI3IDcuNTg0IDUuNDIxIDQuOTQ0IDE0LjMyOC0yLjY0IDguOTAxLTkuNTI1IDUuNTU2LTEyLjgyOCAwIiBmaWxsPSIjZmJkOWJkIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyOC4yODUgMTM5Ljg5KSI+CjxwYXRoIGQ9Im0wIDBoNDguNDgzbC02LjE4Ni0xMTIuOTFoLTEyLjgyOGwtMi42MDcgODUuODcyYy0wLjIxMyA2LjgwNy01LjAyOCA2Ljg1NS01LjI0MSAwbC0yLjYwNy04NS44NzJoLTEyLjgyOHoiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDY5LjE1MiAyMTAuMjEpIj4KPHBhdGggZD0ibTAgMCAxMi45OTktNDcuODY1YzEuNTYtNS43MjEgMTMuNjIzLTAuMDg0IDEyLjcyNiA1LjI1M2wtNy44NiA0Ni44MzNjLTIuOTk3IDEzLjc4NS0yMS4zNzUgOC43MDktMTcuODY1LTQuMjIxIiBmaWxsPSIjZmJkOWJkIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg4Ny43OTYgMjEzLjU3KSI+CjxwYXRoIGQ9Im0wIDBjLTEuMDIgMTEuMTYtOS42ODcgMTAuMTQtMTMuODE1IDUuNzMzbDMuOTY5LTE5LjYyOXoiIGZpbGw9IiNiNzFhNzAiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDM1LjEwNyAyMTAuMjEpIj4KPHBhdGggZD0ibTAgMC0xMi45OTktNDcuODY1Yy0xLjU2LTUuNzIxLTEzLjYyMy0wLjA4NC0xMi43MjYgNS4yNTNsNy44NiA0Ni44MzNjMi45OTcgMTMuNzg1IDIxLjM3NSA4LjcwOSAxNy44NjUtNC4yMjEiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE2LjQ2MiAyMTMuNTcpIj4KPHBhdGggZD0ibTAgMGMxLjAxMSAxMS4xNiA5LjY5IDEwLjE0IDEzLjgwNiA1LjczM2wtMy45Ni0xOS42Mjl6IiBmaWxsPSIjYjcxYTcwIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMy42ODcgMTMzLjI0KSI+CjxwYXRoIGQ9Im0wIDBjMC40NzQgMC4zMTUgMS4wNTMtMC4zMjEgMS4wOTUtMC44N2wwLjYxNS04LjE4N2MwLjA0Mi0wLjU0OS0wLjQ5Mi0wLjgyOC0wLjk1Ny0xLjE0My0wLjQ3NC0wLjMxNS0xLjA1MyAwLjMyMS0xLjA5NSAwLjg3NmwtMC42MTUgOC4xODFjLTAuMDQyIDAuNTU1IDAuMzk2IDEuMDY4IDAuOTU3IDEuMTQzIiBmaWxsPSIjZmJkOWJkIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNC44MDMgMTI5Ljc0KSI+CjxwYXRoIGQ9Im0wIDAtMC4yNjcgMy41MTYtMTEuNjI1LTEuNjc0IDAuMjY3LTMuNTE5YzEuMTMxLTEwLjU5NiAxMi45NDUtMTEuMTkgMTEuNjI1IDEuNjc3IiBmaWxsPSIjZmJkOWJkIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNC42NjYgMTMyLjIyKSI+CjxwYXRoIGQ9Im0wIDAtMi41MTEgMzMuODA3Yy0yLjE3NSA4Ljk1NS0xMi4wOTYgNy41ODEtMTIuNTYxLTAuMzg0bDMuNTUyLTM1LjA0M3oiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDgxLjM4NiAyMjIuNTYpIj4KPHBhdGggZD0ibTAgMC00LjYyLTgyLjY3MWgtNDguNDhsLTQuNjE3IDgyLjY3MXoiIGZpbGw9IiNjYzFiNzQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDM4LjAyOSAyMjIuNTYpIj4KPHBhdGggZD0ibTAgMGgyOC43NDNjMS40NTgtMS43MzcgMi4zMzEtMy45NzUgMi4zMzEtNi40MTcgMC01LjUyLTQuNDczLTEwLjAwMi05Ljk5My0xMC4wMDItMi41OCAwLTQuOTM1IDAuOTc4LTYuNzA1IDIuNTkyLTEuNzgyLTEuNjA4LTQuMTI4LTIuNTkyLTYuNzE0LTIuNTkyLTUuNTIzIDAtOS45OTYgNC40ODItOS45OTYgMTAuMDAyIDAgMi40NDIgMC44NzYgNC42OCAyLjMzNCA2LjQxNyIgZmlsbD0iI2I3MWE3MCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjcuMjU5IDE1OC4yOSkiPgo8cGF0aCBkPSJtMCAwIDEuNjY4LTUxLjE1Nmg0Ny4zNjRsMS40OTcgNTEuMDQ4eiIgZmlsbD0iIzI4MjgyOCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNzAuNjA5IDI2Ljk4MykiPgo8cGF0aCBkPSJtMCAwYzQuMTA3LTUuOTQ2IDEwLjA1OS05LjI5MSAxMC4yNzgtMTQuMTgxIDAuMTE0LTIuNTQ0IDAuMDU0LTQuNTg3LTIuNDA2LTQuODktMTAuNTkzLTEuMzE0LTEwLjg3NSA0LjMzOC0xNC42NTIgNS40LTYuNTIyIDEuODI3LTguNjgyIDQuNzY0LTYuMDQ4IDEzLjY3MSAyLjY0IDguOTAxIDkuNTI1IDUuNTU2IDEyLjgyOCAwIiBmaWxsPSIjZmJkOWJkIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNi45NzggMTguNDgpIj4KPHBhdGggZD0ibTAgMGMtMS41OTMtMS43MzEtMi44NzEtMy4zNi0zLjQ0MS01LjEzOS0xLjkzNS02LjA3NSAzLjE2Mi02LjM2MyA3LjY2Mi01Ljg5OCA2LjQyNiAwLjY2NiA5LjAxMiA0LjIwMyAxMi4wNDggNS4wNTggNS44NTkgMS42NDEgNi41OTEgNC44MzYgNC43NjQgMTEuOTI1LTAuMjQ5LTYuMTg2LTEwLjAxMS0xMC4xNzMtMTIuNDU5LTEwLjkxNC0yLjQ0NS0wLjczOC04LjExNSAyLjU1OS04LjU3NCA0Ljk2OCIgZmlsbD0iI2NjMWI3NCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNzguMTA5IDE4LjQ4KSI+CjxwYXRoIGQ9Im0wIDBjMS41OTMtMS43MzEgMi44NzQtMy4zNiAzLjQ0MS01LjEzOSAyLjA2Ny02LjQ4LTQuMDkyLTYuNTAxLTguNjk3LTUuNzYtNS42NzkgMC45MDktOC4xNDggNC4xMTMtMTEuMDEzIDQuOTItNS44NTkgMS42NDEtNi41OTEgNC44MzYtNC43NjQgMTEuOTI1IDAuMjQ2LTYuMTg2IDEwLjA1LTEwLjcyOCAxMi42MDMtMTAuOTE0IDIuNTQ0LTAuMTc3IDkuMjY0IDQuMjE1IDguNDMgNC45NjgiIGZpbGw9IiNjYzFiNzQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDM4LjUxNCAxNC40NSkiPgo8cGF0aCBkPSJtMCAwYy0wLjAzMyAwLjE4Ni0wLjEwMiAwLjQwNS0wLjIwNCAwLjYzNi0wLjU5NyAxLjM0Ny0yLjEzNiAyLjg1OS0zLjk2MyAzLjk5Ni0xLjc1OCAxLjA4OS00LjA5MiAxLjc3OS01LjY0OSAxLjU3NSAwLjgwNyAwLjgzNCAxLjY0NyAxLjcxIDIuNDgxIDIuNjQ2IDEuNDg1LTAuMzIxIDMuMzYtMC45NzggNC43MjgtMS44MjcgMi4yOTItMS40MTYgNC4yNTctMy40MDUgNS4wNzYtNS4yODMgMC4xOTItMC40MjkgMC4zMy0wLjg2NyAwLjM5OS0xLjMwNXoiIGZpbGw9IiNjYzFiNzQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg2Ni43MSAxNC40NSkiPgo8cGF0aCBkPSJtMCAwYzAuMDI3IDAuMTg2IDAuMDk2IDAuNDA1IDAuMTk4IDAuNjM2IDAuNTk0IDEuMzQ3IDIuMTM2IDIuODU5IDMuOTYzIDMuOTk2IDEuNzU4IDEuMDg5IDQuMDg5IDEuNzc5IDUuNjU1IDEuNTc1LTAuODEzIDAuODM0LTEuNjQ3IDEuNzEtMi40OSAyLjY0Ni0xLjQ4Mi0wLjMyMS0zLjM2LTAuOTc4LTQuNzI4LTEuODI3LTIuMjg5LTEuNDE2LTQuMjU0LTMuNDA1LTUuMDc2LTUuMjgzLTAuMTkyLTAuNDI5LTAuMzI3LTAuODY3LTAuNDAyLTEuMzA1eiIgZmlsbD0iI2NjMWI3NCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDgwLjU3MSAxMzMuMjQpIj4KPHBhdGggZD0ibTAgMGMtMC40NzQgMC4zMTUtMS4wNTMtMC4zMjEtMS4wOTUtMC44N2wtMC42MTUtOC4xODdjLTAuMDQyLTAuNTQ5IDAuNDkyLTAuODI4IDAuOTU3LTEuMTQzIDAuNDc0LTAuMzE1IDEuMDUzIDAuMzIxIDEuMDk1IDAuODc2bDAuNjE1IDguMTgxYzAuMDQyIDAuNTU1LTAuMzk2IDEuMDY4LTAuOTU3IDEuMTQzIiBmaWxsPSIjZmJkOWJkIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3OS40NDggMTI5Ljc0KSI+CjxwYXRoIGQ9Ik0gMCwwIDAuMjc2LDMuNTE2IDExLjg5OCwxLjg0MiAxMS42MzEsLTEuNjc3IEMgMTAuNTAzLC0xMi4yNzMgLTEuMzE0LC0xMi44NjcgMCwwIiBmaWxsPSIjZmJkOWJkIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3OS41OTIgMTMyLjIyKSI+CjxwYXRoIGQ9Im0wIDAgMi41MTEgMzMuODA3YzIuMTY5IDguOTU1IDEyLjI5NCA4LjM0IDEyLjc2OCAwLjM3NWwtMy43NTktMzUuODAyeiIgZmlsbD0iI2ZiZDliZCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNjMuNTkgMjQ4Ljg0KSI+CjxwYXRoIGQ9Im0wIDB2LTI3LjQyM2MtNi4xNS04LjA5NC0xNi4yMy03LjgxMi0yMi4zODkgMHYyNy40MjNjMCAxNC44MTEgMjIuMzg5IDE0LjgxMSAyMi4zODkgMCIgZmlsbD0iI2ZiZDliZCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNjMuNTkgMjUwLjgyKSI+CjxwYXRoIGQ9Im0wIDB2LTE4LjM2M2MtNC4yMzYtMy4zMTItOC4zMTMtNS4xNjYtMTEuMTg3LTUuMTY2LTIuODggMC02Ljk2NiAxLjg1NC0xMS4yMDIgNS4xNjZ2MTguMzYzYzAgMTQuODA1IDIyLjM4OSAxNC44MDUgMjIuMzg5IDAiIGZpbGw9IiNlY2MyYTAiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDUyLjQwMyAyMzEuODUpIj4KPHBhdGggZD0ibSAwLDAgYyAtNy4yOTMsMCAtMjIuNjg2LDExLjQ2IC0yNy40NSwyNy44NzMgLTQuODAzLDE2LjU3MiA0LjI0OCw0MC4zNDEgMjcuNDUsNDAuMzQxIDkuNDA4LDAgMTYuNDg4LC0zLjkxNSAyMS4yNjQsLTkuNjY5IDYuOTkzLC04LjQzMyA5LjAzMywtMjAuODI2IDYuMTgsLTMwLjY3MiBDIDIyLjY4LDExLjQ2IDcuMjg3LDAgMCwwIiBmaWxsPSIjZmJkOWJkIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyOC4wNjYgMjY3LjY0KSI+CjxwYXRoIGQ9Im0wIDBjMC43MjYgMC4yNzMgNC42MTEgMS41ODEgMTEuNzE1IDEuMDk1di0wLjY3OGMtMy41MSAwLjE3MS03LjAyOS0wLjA5Ni04LjA0LTEuMDM1LTEuOTIzLTEuNzgyLTEuNjY4LTUuNjE2IDAuOTQ1LTcuNDIyIDEuMjktMC44ODggNC4yNjMtMS4zOTUgNy4wOTUtMS41MjR2LTAuNjY2Yy0zLjQ3MSAwLjE3NC03LjQxOSAwLjgxNi04LjU0NyAyLjMzNC0xLjc1MiAyLjM2MS0yLjM2MSA0LjI0OC0zLjEwOCA0LjcxOS0wLjczNSAwLjQ3NC0wLjk0MiAyLjg0Ny0wLjA2IDMuMTc3bTExLjcxNSAxLjA5NSAwLjI5NC0wLjAyMWM3LjI4Ny0wLjUzNCA4LjgzOC0xLjk1NiA5LjU4NS0xLjg4NyAwLjg2MSAwLjA4MSAxLjgwNiAwLjE5NSAyLjY4OCAwLjE5NSAwLjg4OCAwIDEuODktMC4xMTQgMi43OS0wLjE5NSAwLjc0Ny0wLjA2OSAyLjMwMSAxLjM1MyA5LjU4OCAxLjg4N2wwLjI5NCAwLjAyMXYtMC42NzhoLTAuMDM2Yy0zLjUyMi0wLjE3MS04LjExMi0wLjk4NC05LjAxNS0zLjAwMy0wLjkwNi0yLjAxOSAwLjgxMy01LjYyNSAzLjMwMy02LjUyOCAxLjEzNy0wLjQxMSAzLjM5My0wLjU2MSA1Ljc0OC0wLjQ1di0wLjY2NmMtMS45MjMtMC4wOTYtMy43MDItMC4wNDUtNC43NTUgMC4wODQtMi45NyAwLjM1NC01LjE5MyAzLjkzMy01LjU5OCA1LjAxMy0wLjkwOSAyLjQzLTMuNjI3IDIuNDMtNC41MzYgMC0wLjQwNS0xLjA4LTIuNjI4LTQuNjU5LTUuNTk1LTUuMDEzLTEuMDU2LTAuMTI5LTIuODM1LTAuMTgtNC43NTUtMC4wODR2MC42NjZjMi4zNTItMC4xMTEgNC42MTEgMC4wMzkgNS43NDUgMC40NSAyLjQ4NCAwLjkwMyA0LjIwOSA0LjUwOSAzLjMwNiA2LjUyOC0wLjkwMyAyLjAxMy01LjQ5NiAyLjgzMi05LjAxOCAzLjAwM2gtMC4wMzN6bTI1LjIzOSAwYzcuMTAxIDAuNDg2IDEwLjk4Ni0wLjgyMiAxMS43MTItMS4wOTUgMC44NzYtMC4zMyAwLjY3OC0yLjcwMy0wLjA2My0zLjE3Ny0wLjc0NC0wLjQ3MS0xLjM1My0yLjM1OC0zLjEwNS00LjcxOS0xLjEyOC0xLjUxOC01LjA3Ni0yLjE2LTguNTQ0LTIuMzM0djAuNjY2YzIuODMyIDAuMTI5IDUuNzk5IDAuNjM2IDcuMDg5IDEuNTI0IDIuNjE5IDEuODA2IDIuODcxIDUuNjQgMC45NDIgNy40MjItMS4wMDUgMC45MzktNC41MjEgMS4yMDYtOC4wMzEgMS4wMzV6IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzMS43NDEgMjY3LjAyKSI+CjxwYXRoIGQ9Im0wIDBjMS4wMTEgMC45NDUgNC41NTcgMS4yMDYgOC4wNzMgMS4wMzIgMy41MjUtMC4xNzEgOC4xMTUtMC45ODQgOS4wMTgtMy4wMDMgMC45MDMtMi4wMTYtMC44MjItNS42MjUtMy4zMDYtNi41MjUtMi40OS0wLjkwMy0xMC40NzMtMC41NTUtMTIuODQgMS4wNzQtMi42MTMgMS43OTctMi44NjggNS42MzctMC45NDUgNy40MjIiIGZpbGw9IiNmYmQ5YmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDczLjA1MiAyNjcuMDIpIj4KPHBhdGggZD0ibTAgMGMtMS4wMTEgMC45NDUtNC41NTEgMS4yMDYtOC4wNjcgMS4wMzItMy41MjItMC4xNzEtOC4xMTItMC45ODQtOS4wMTgtMy4wMDMtMC45MDMtMi4wMTYgMC44MTYtNS42MjUgMy4zMDYtNi41MjUgMi40OS0wLjkwMyAxMC40NzMtMC41NTUgMTIuODM0IDEuMDc0IDIuNjIyIDEuNzk3IDIuODc0IDUuNjM3IDAuOTQ1IDcuNDIyIiBmaWxsPSIjZmJkOWJkIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0My42MTggMjQ4LjM3KSI+CjxwYXRoIGQ9Im0wIDBjMy43MTQgMy41OTEgNi42MDkgMC44OTcgOC43ODcgMC44OTcgMi4xNjYgMCA1LjA2MSAyLjY5NCA4Ljc3OC0wLjg5Ny0xLjk5OC05LjQ4My0xNC45MTYtOS43NzctMTcuNTY1IDAiIGZpbGw9IiNmZjM4NmEiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQzLjYxOCAyNDguMzcpIj4KPHBhdGggZD0ibTAgMGMzLjcxNCAzLjU5MSA2LjYwOSAwLjg5NyA4Ljc4NyAwLjg5NyAyLjE2IDAgNS4wNjEgMi42OTQgOC43NzgtMC44OTctNS42ODItMi43OTktMTMuNzQtMS40OTEtMTcuNTY1IDAiIGZpbGw9IiNjODIwNGEiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L2c+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE5LjgwMiAyNjYuMTUpIj4KPHBhdGggZD0ibTAgMGMyLjM0NiAxLjAxMSA1LjY1OC0xLjQ1OCA3LjM5NS01LjUxNCAxLjc0My00LjA1IDEuMjUxLTguMTU3LTEuMDg5LTkuMTYyLTIuMzQ2LTEuMDA1LTUuNjU1IDEuNDY0LTcuMzk1IDUuNTE3LTEuNzQ2IDQuMDU2LTEuMjUxIDguMTU0IDEuMDg5IDkuMTU5IiBmaWxsPSIjZmJkOWJkIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg4NC40OTEgMjY2LjE4KSI+CjxwYXRoIGQ9Im0wIDBjMi4zNDYtMS4wMDUgMi44MzgtNS4xMTIgMS4wOTUtOS4xNjgtMS43MzctNC4wNS01LjA0OS02LjUxOS03LjM5OC01LjUxNC0yLjM0MyAxLjAwNS0yLjgzMiA1LjEwOS0xLjA5MiA5LjE2MiAxLjc0NiA0LjA1NiA1LjA1NSA2LjUyNSA3LjM5NSA1LjUyIiBmaWxsPSIjZmJkOWJkIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9nPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3OC45MDIgMjU3LjAyKSI+CjxwYXRoIGQ9Im0wIDBzLTAuNjkzIDE2LjUwOS01LjIzNSAyMi43NjRjLTguMjQ0LTE4LjEzMi0zOC4zMTkgMC42MTUtNDYuMjE1LTI2LjM5Ny03LjI1NCAxMi42MjQtNC4xODIgMjcuODI4IDAuODEzIDM1LjAxNiA5LjY1NCAxMy44NzUgMzAuMzMgMTYuOTU2IDQ0LjQ0NSA0LjMzMiA5Ljc5OC04Ljc1NyAxMi4wNTQtMjMuNzA2IDYuMTkyLTM1LjcxNSIgZmlsbD0iI2ExNDAwZiIgZmlsbC1ydWxlPSJldmVub2RkIi8+CjwvZz4KPC9nPgo8L2c+Cjwvc3ZnPg==';var css_248z$3$1=".baritone,.bass{color:#379fd2!important}.alto,.lead{color:#acdb36!important}.soprano{color:#cb1b74!important}.tenor{color:#9920b7!important}.stem{color:#acdb36;font-weight:700;touch-action:none}.soloButton{align-items:center;display:flex;height:80%;justify-content:center;position:absolute;width:100%}.sectionHolder:hover{background:radial-gradient(var(--theme-primary-alt-color) 0,#111 50%)}.choirPeople{height:100%;position:absolute;width:100%}.backgrounds{position:relative}.backgrounds img,.choirPeople img{height:100%;position:absolute;width:100%}.bass .volValue{background-color:#379fd2}.bass .volContainer{border-color:#379fd2}.alto .volValue{background-color:#acdb36}.alto .volContainer{border-color:#acdb36}.soprano .volValue{background-color:#cb1b74}.soprano .volContainer{border-color:#cb1b74}.tenor .volValue{background-color:#9920b7}.tenor .volContainer{border-color:#9920b7}";styleInject$1(css_248z$3$1,{"insertAt":"top"});const normalizeBetweenTwoRanges=(val,minVal,maxVal,newMin,newMax)=>{return newMin+(val-minVal)*(newMax-newMin)/(maxVal-minVal);};const ChoirSectionStem=function Stem({stem,getVuLevel,onTrackChange,onPanChange,onReverbChange,onMuteStem,onSoloStem,soloMode,onArmStem,onDeleteStem,type,size,...props}){const dragging=useRef(false);const ignoreNextLevelChange=useRef(false);const bind=useDrag(({down,movement:[mx,my]})=>{if(down&&!dragging.current){dragging.current=true;// emit level to 0.5 to start
// onTrackChange(0.5);
}if(!down){dragging.current=false;}//send out level change from mouse movments
if(my<=100&&my>=-100){const rawDiff=my/-100*10;const rounded=Math.round(rawDiff);const level=rounded/10;//scale 1 and -1 to 1 and 0 them emit event
const normalised=normalizeBetweenTwoRanges(level,-1,1,0,1);if(my)onTrackChange(normalised);}else if(my<-100){onTrackChange(1);}else if(my>100){onTrackChange(0);}ignoreNextLevelChange.current=true;},{delay:500,threshold:500});const handleSectionClick=()=>{if(soloMode){onSoloStem();return;}console.log(stem.level,ignoreNextLevelChange.current);if(!dragging.current&&!ignoreNextLevelChange.current){if(stem.level>0.5){onTrackChange(0.5);}else if(stem.level>0&&stem.level<=0.5){onTrackChange(0);}else if(stem.level===0){onTrackChange(1);}}ignoreNextLevelChange.current=false;};// const getStageBackground = () => {
//   switch (stem.label.toUpperCase()) {
//     case 'BASS':
//       return <img alt="Bass section volume control" className="initial lg:hidden" src={StageBass} /> 
//     case 'TENOR':
//         return <img alt="Tenor section volume control" className="initial lg:hidden" src={StageTenor} /> 
//     case 'ALTO':
//       return <img alt="Alto section volume control"  className="initial lg:hidden" src={StageAlto} /> 
//     case 'SOPRANO':
//       return <img alt="Soprano section volume control" className="initial lg:hidden" src={StageSoprano} /> 
//     default:
//       return null;
//   }
// }
const getStageChoir=()=>{if(stem.label.includes('BASS')||stem.label.includes('BARITONE')){return/*#__PURE__*/React__default.createElement("img",{draggable:"false",alt:"Bass section volume control",src:ChoirBass});}else if(stem.label.includes('TENOR')){return/*#__PURE__*/React__default.createElement("img",{draggable:"false",alt:"Tenor section volume control",src:ChoirTenor});}else if(stem.label.includes('ALTO')||stem.label.includes('LEAD')){return/*#__PURE__*/React__default.createElement("img",{draggable:"false",alt:"Alto section volume control",src:ChoirAlto});}else if(stem.label.includes('SOPRANO')){return/*#__PURE__*/React__default.createElement("img",{draggable:"false",alt:"Soprano secion volume control",src:ChoirSoprano});}return/*#__PURE__*/React__default.createElement("img",{draggable:"false",alt:`${stem.label} section volume control`,src:ChoirAlto});};const getColour=label=>{if(label.includes('BASS')||label.includes('BARITONE')){return "#379fd2";}else if(label.includes('TENOR')){return "#9920b7";}else if(label.includes('ALTO')||label.includes('LEAD')){return "#acdb36";}else if(label.includes('SOPRANO')){return "#cb1b74";}return '#acdb36';};return/*#__PURE__*/React__default.createElement(React__default.Fragment,null,/*#__PURE__*/React__default.createElement("div",_extends$3({},bind(),{className:`stem flex-1 flex flex-col items-center ${stem.label.toLowerCase()} select-none cursor-pointer`,onClick:handleSectionClick}),/*#__PURE__*/React__default.createElement("span",{className:"truncate text-center text text-xs w-full p-1 rounded"},stem.label),/*#__PURE__*/React__default.createElement(VolumeBar,{colour:getColour(stem.label),width:50,percentage:stem.level*100}),/*#__PURE__*/React__default.createElement("div",{className:"sectionHolder grow flex flex-col w-full"},/*#__PURE__*/React__default.createElement("div",{className:"backgrounds grow "},soloMode&&/*#__PURE__*/React__default.createElement("div",{className:"soloButton"},/*#__PURE__*/React__default.createElement(Button,{style:{border:'3px solid #111',background:getColour(stem.label)},size:"sm"},"SOLO")),/*#__PURE__*/React__default.createElement("div",{style:{opacity:stem.level?stem.level:0.5},className:`choirPeople w-full ${stem.level?'':'grayscale'}`},getStageChoir())))));};ChoirSectionStem.propTypes={stem:PropTypes.shape({label:PropTypes.string.isRequired,level:PropTypes.number.isRequired,vuLevel:PropTypes.number.isRequired,pan:PropTypes.number.isRequired,reverb:PropTypes.shape({displayValue:PropTypes.string.isRequired,value:PropTypes.number.isRequired}).isRequired,isInputChannel:PropTypes.bool.isRequired,isGuideChannel:PropTypes.bool.isRequired,muted:PropTypes.bool.isRequired,soloed:PropTypes.bool.isRequired,armed:PropTypes.bool.isRequired}),getVuLevel:PropTypes.func,onTrackChange:PropTypes.func,onPanChange:PropTypes.func,onReverbChange:PropTypes.func,onMuteStem:PropTypes.func,onArmStem:PropTypes.func,onSoloStem:PropTypes.func,soloMode:PropTypes.bool,type:PropTypes.oneOf(["default"]),// Would be better to use Object.keys but it won't work with Storybook currently
size:PropTypes.oneOf(["base"])};ChoirSectionStem.defaultProps={onTrackChange:undefined,onPanChange:undefined,onReverbChange:undefined,isInputChannel:false,isGuideChannel:false,record:true,muted:false,onMuteStem:undefined,onArmStem:undefined,soloed:false,onSoloStem:undefined,soloMode:true,type:"default",size:"base"};var Band='data:image/svg+xml;base64,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';var css_248z$2$1=".bandArea{touch-action:none}.bandSection{color:#ff9200;cursor:pointer;font-weight:700;position:relative;text-align:center}.bandSection,.soloButton{display:flex;justify-content:center}.soloButton{align-items:center;height:80%;position:absolute;width:100%;z-index:2}.bandSection:hover{background:radial-gradient(var(--theme-primary-alt-color) 0,#111 50%)}.bandSection img{max-height:140px;width:100%}";styleInject$1(css_248z$2$1,{"insertAt":"top"});const BtSectionStem=function Stem({stem,getVuLevel,onTrackChange,onPanChange,onReverbChange,onMuteStem,onSoloStem,onArmStem,onDeleteStem,soloMode,type,size,opacity,lyricsActive,...props}){const dragging=useRef(false);const ignoreNextLevelChange=useRef(false);const bind=useDrag(({down,movement:[mx,my]})=>{if(down&&!dragging.current){dragging.current=true;// emit level to 0.5 to start
// onTrackChange(0.5);
}if(!down){dragging.current=false;}//send out level change from mouse movments
if(my<=100&&my>=-100){const rawDiff=my/-100*10;const rounded=Math.round(rawDiff);const level=rounded/10;//scale 1 and -1 to 1 and 0 them emit event
const normalised=normalizeBetweenTwoRanges(level,-1,1,0,1);if(my)onTrackChange(normalised);}else if(my<-100){onTrackChange(1);}else if(my>100){onTrackChange(0);}ignoreNextLevelChange.current=true;},{delay:500,threshold:500});const handleSectionClick=()=>{if(soloMode){onSoloStem();return;}console.log(stem.level,ignoreNextLevelChange.current);if(!dragging.current&&!ignoreNextLevelChange.current){if(stem.level>0.5){onTrackChange(0.5);}else if(stem.level>0&&stem.level<=0.5){onTrackChange(0);}else if(stem.level===0){onTrackChange(1);}}ignoreNextLevelChange.current=false;};return/*#__PURE__*/React__default.createElement(React__default.Fragment,null,/*#__PURE__*/React__default.createElement("div",_extends$3({className:`h-2/5 flex flex-col justify-end items-center bandArea ${stem.label.toLowerCase()} select-none opacity-${opacity} ${lyricsActive?'hidden lg:flex':''}`,onClick:handleSectionClick},bind()),/*#__PURE__*/React__default.createElement("div",{className:"flex flex-col w-full align-center shrink bandSection"},soloMode&&/*#__PURE__*/React__default.createElement("div",{className:"soloButton"},/*#__PURE__*/React__default.createElement(Button,{style:{border:'3px solid #111',background:'#ff9200'},size:"sm"},"SOLO")),/*#__PURE__*/React__default.createElement("img",{draggable:"false",alt:"Band volume control",className:`${stem.level?'':'grayscale'}`,style:{opacity:stem.level?stem.level:0.5},src:Band}),/*#__PURE__*/React__default.createElement("p",{className:"truncate text-center text-xs w-full p-1 rounded"},"BAND"),/*#__PURE__*/React__default.createElement("div",{className:"flex justify-center"},/*#__PURE__*/React__default.createElement(VolumeBar,{colour:"#ff9200",width:50,percentage:stem.level*100})))));};BtSectionStem.propTypes={stem:PropTypes.shape({label:PropTypes.string.isRequired,level:PropTypes.number.isRequired,vuLevel:PropTypes.number.isRequired,pan:PropTypes.number.isRequired,reverb:PropTypes.shape({displayValue:PropTypes.string.isRequired,value:PropTypes.number.isRequired}).isRequired,isInputChannel:PropTypes.bool.isRequired,isGuideChannel:PropTypes.bool.isRequired,muted:PropTypes.bool.isRequired,soloed:PropTypes.bool.isRequired,armed:PropTypes.bool.isRequired}),getVuLevel:PropTypes.func,onTrackChange:PropTypes.func,onPanChange:PropTypes.func,onReverbChange:PropTypes.func,onMuteStem:PropTypes.func,onArmStem:PropTypes.func,onSoloStem:PropTypes.func,soloMode:PropTypes.bool,type:PropTypes.oneOf(["default"]),// Would be better to use Object.keys but it won't work with Storybook currently
size:PropTypes.oneOf(["base"])};BtSectionStem.defaultProps={onTrackChange:undefined,onPanChange:undefined,onReverbChange:undefined,isInputChannel:false,isGuideChannel:false,record:true,muted:false,onMuteStem:undefined,onArmStem:undefined,soloed:false,soloMode:true,onSoloStem:undefined,type:"default",size:"base"};var ChoirLeader='data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjxzdmcKICAKICAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogICBpZD0ic3ZnOTUwIgogICB2aWV3Qm94PSIwIDAgMzM3Ljg4IDU1NiIKICAgdmVyc2lvbj0iMS4xIj4KICAKICA8ZGVmcwogICAgIGlkPSJkZWZzODcwIj4KICAgIDxjbGlwUGF0aAogICAgICAgaWQ9ImgiPgogICAgICA8cGF0aAogICAgICAgICBpZD0icGF0aDgzMyIKICAgICAgICAgZD0ibTAgMGgyNTMuNDF2NDE3aC0yNTMuNDF6IiAvPgogICAgPC9jbGlwUGF0aD4KICAgIDxjbGlwUGF0aAogICAgICAgaWQ9ImYiPgogICAgICA8cGF0aAogICAgICAgICBpZD0icGF0aDgzNiIKICAgICAgICAgZD0ibTk0LjQ1NSAwaDIwLjc5bDcuOTQ0IDE0MC4wNiA4LjA4OC0xMzguNzEgMTkuNzE5IDAuMTcxIDkuMDk5IDE3Mi45Ni03NC43NjYgMC45Njl6IiAvPgogICAgPC9jbGlwUGF0aD4KICAgIDxjbGlwUGF0aAogICAgICAgaWQ9ImUiPgogICAgICA8cGF0aAogICAgICAgICBpZD0icGF0aDgzOSIKICAgICAgICAgZD0ibTg1LjMyOSAxNzUuNDRoNzQuNzY2di0xNzUuNDRoLTc0Ljc2NnoiIC8+CiAgICA8L2NsaXBQYXRoPgogICAgPGNsaXBQYXRoCiAgICAgICBpZD0iZCI+CiAgICAgIDxwYXRoCiAgICAgICAgIGlkPSJwYXRoODQyIgogICAgICAgICBkPSJtODUuMzI5IDE3NS40NGg3NC43NjZ2LTE3NS40NGgtNzQuNzY2eiIgLz4KICAgIDwvY2xpcFBhdGg+CiAgICA8bGluZWFyR3JhZGllbnQKICAgICAgIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIgogICAgICAgZ3JhZGllbnRUcmFuc2Zvcm09Im1hdHJpeCgwIDE3NS40NCAtMTc1LjQ0IDAgMTIyLjcxIDApIgogICAgICAgeDI9IjEiCiAgICAgICBpZD0iYyI+CiAgICAgIDxzdG9wCiAgICAgICAgIGlkPSJzdG9wODQ1IgogICAgICAgICBvZmZzZXQ9IjAiCiAgICAgICAgIHN0b3AtY29sb3I9IiMyMzFmMjAiIC8+CiAgICAgIDxzdG9wCiAgICAgICAgIGlkPSJzdG9wODQ3IgogICAgICAgICBvZmZzZXQ9IjEiCiAgICAgICAgIHN0b3AtY29sb3I9IiNmZmYiIC8+CiAgICA8L2xpbmVhckdyYWRpZW50PgogICAgPG1hc2sKICAgICAgIG1hc2tVbml0cz0idXNlclNwYWNlT25Vc2UiCiAgICAgICBoZWlnaHQ9IjEiCiAgICAgICB3aWR0aD0iMSIKICAgICAgIHk9IjAiCiAgICAgICB4PSIwIgogICAgICAgaWQ9ImEiPgogICAgICA8ZwogICAgICAgICBpZD0iZzg1NiIKICAgICAgICAgY2xpcC1wYXRoPSJ1cmwoI2UpIj4KICAgICAgICA8cGF0aAogICAgICAgICAgIGlkPSJwYXRoODUwIgogICAgICAgICAgIGQ9Im04NS4zMjkgMTc1LjQ0aDc0Ljc2NnYtMTc1LjQ0aC03NC43NjZ6IiAvPgogICAgICAgIDxnCiAgICAgICAgICAgaWQ9Imc4NTQiCiAgICAgICAgICAgY2xpcC1wYXRoPSJ1cmwoI2QpIj4KICAgICAgICAgIDxwYXRoCiAgICAgICAgICAgICBpZD0icGF0aDg1MiIKICAgICAgICAgICAgIGZpbGw9InVybCgjYykiCiAgICAgICAgICAgICBkPSJtODUuMzI5IDE3NS40NGg3NC43NjZ2LTE3NS40NGgtNzQuNzY2eiIgLz4KICAgICAgICA8L2c+CiAgICAgIDwvZz4KICAgIDwvbWFzaz4KICAgIDxjbGlwUGF0aAogICAgICAgaWQ9ImkiPgogICAgICA8cGF0aAogICAgICAgICBpZD0icGF0aDg1OSIKICAgICAgICAgZD0ibTg1LjMyOSAxNzUuNDRoNzQuNzY2di0xNzUuNDRoLTc0Ljc2NnoiIC8+CiAgICA8L2NsaXBQYXRoPgogICAgPGxpbmVhckdyYWRpZW50CiAgICAgICBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIKICAgICAgIGdyYWRpZW50VHJhbnNmb3JtPSJtYXRyaXgoMCAxNzUuNDQgLTE3NS40NCAwIDEyMi43MSAwKSIKICAgICAgIHgyPSIxIgogICAgICAgaWQ9ImIiPgogICAgICA8c3RvcAogICAgICAgICBpZD0ic3RvcDg2MiIKICAgICAgICAgb2Zmc2V0PSIwIgogICAgICAgICBzdG9wLWNvbG9yPSIjMjgyODI4IiAvPgogICAgICA8c3RvcAogICAgICAgICBpZD0ic3RvcDg2NCIKICAgICAgICAgb2Zmc2V0PSIxIgogICAgICAgICBzdG9wLWNvbG9yPSIjMjgyODI4IiAvPgogICAgPC9saW5lYXJHcmFkaWVudD4KICAgIDxjbGlwUGF0aAogICAgICAgaWQ9ImciPgogICAgICA8cGF0aAogICAgICAgICBpZD0icGF0aDg2NyIKICAgICAgICAgZD0ibTAgMGgyNTMuNDF2NDE3aC0yNTMuNDF6IiAvPgogICAgPC9jbGlwUGF0aD4KICA8L2RlZnM+CiAgPGcKICAgICBpZD0iZzk0OCIKICAgICB0cmFuc2Zvcm09Im1hdHJpeCgxLjMzMzMgMCAwIC0xLjMzMzMgMCA1NTYpIj4KICAgIDxnCiAgICAgICBpZD0iZzkzMiIKICAgICAgIGNsaXAtcGF0aD0idXJsKCNoKSI+CiAgICAgIDxnCiAgICAgICAgIGlkPSJnODc0IgogICAgICAgICB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMzMuOTcgMzY5LjQ3KSI+CiAgICAgICAgPHBhdGgKICAgICAgICAgICBpZD0icGF0aDg3MiIKICAgICAgICAgICBmaWxsLXJ1bGU9ImV2ZW5vZGQiCiAgICAgICAgICAgZmlsbD0iI2ZiZDliZCIKICAgICAgICAgICBkPSJtMCAwLTEzLjY2OC01MC4zMzRjLTEuNjA1LTE0LjEyMSAxNS4xNjUtMTguNjY5IDE4LjU5MS0xLjY4NmwxMi42MjEgNDguMjYxeiIgLz4KICAgICAgPC9nPgogICAgICA8ZwogICAgICAgICBpZD0iZzg3OCIKICAgICAgICAgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTkuMTQ2IDM3NC4zNykiPgogICAgICAgIDxwYXRoCiAgICAgICAgICAgaWQ9InBhdGg4NzYiCiAgICAgICAgICAgZmlsbC1ydWxlPSJldmVub2RkIgogICAgICAgICAgIGZpbGw9IiNmYmQ5YmQiCiAgICAgICAgICAgZD0ibTAgMCAxMC43NTUtNTEuODAxYzAuNzAyLTE0LjE5Ni0xNi40NDYtMTguMzA2LTE4Ljc4My0xLjE0bC05LjcyMyA1MC4zMDd6IiAvPgogICAgICA8L2c+CiAgICAgIDxnCiAgICAgICAgIGlkPSJnODgyIgogICAgICAgICB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNjcuMjIgMjk5LjkpIj4KICAgICAgICA8cGF0aAogICAgICAgICAgIGlkPSJwYXRoODgwIgogICAgICAgICAgIGZpbGwtcnVsZT0iZXZlbm9kZCIKICAgICAgICAgICBmaWxsPSIjZmJkOWJkIgogICAgICAgICAgIGQ9Im0wIDAtMTcuMDUyLTEyNS40M2gtNTcuMTQ0bC0xNC44MTEgMTI1LjQzeiIgLz4KICAgICAgPC9nPgogICAgICA8ZwogICAgICAgICBpZD0iZzg4NiIKICAgICAgICAgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTguMTQgMzcyLjQ0KSI+CiAgICAgICAgPHBhdGgKICAgICAgICAgICBpZD0icGF0aDg4NCIKICAgICAgICAgICBmaWxsLXJ1bGU9ImV2ZW5vZGQiCiAgICAgICAgICAgZmlsbD0iI2ZiZDliZCIKICAgICAgICAgICBkPSJtMCAwYzAuNzY4LTAuNDI5IDEuNTc4IDAuNjI3IDEuNTYzIDEuNDg4bC0wLjE3NCAxMi42NTFjLTAuMDIxIDAuODU1LTAuODY3IDEuMjAzLTEuNjM1IDEuNjIzLTAuNzU5IDAuNDItMS41NzgtMC42MjctMS41NjMtMS40ODJsMC4xOC0xMi42NTRjMC4wMTUtMC44NTggMC43NTktMS41OTkgMS42MjktMS42MjYiIC8+CiAgICAgIDwvZz4KICAgICAgPGcKICAgICAgICAgaWQ9Imc4OTAiCiAgICAgICAgIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE4LjI2NCAzNzguMSkiPgogICAgICAgIDxwYXRoCiAgICAgICAgICAgaWQ9InBhdGg4ODgiCiAgICAgICAgICAgZmlsbC1ydWxlPSJldmVub2RkIgogICAgICAgICAgIGZpbGw9IiNmYmQ5YmQiCiAgICAgICAgICAgZD0ibSAwLDAgMS4xNDMsLTUuMzI4IC0xNy45MjUsLTIuNTk1IC0xLjE0LDUuMzE2IEMgLTIwLjg4OSwxMy41NTcgLTMuNjYsMTkuNTk5IDAsMCIgLz4KICAgICAgPC9nPgogICAgICA8ZwogICAgICAgICBpZD0iZzg5NCIKICAgICAgICAgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjM0Ljg0IDM2Ny40OCkiPgogICAgICAgIDxwYXRoCiAgICAgICAgICAgaWQ9InBhdGg4OTIiCiAgICAgICAgICAgZmlsbC1ydWxlPSJldmVub2RkIgogICAgICAgICAgIGZpbGw9IiNmYmQ5YmQiCiAgICAgICAgICAgZD0ibTAgMGMtMC43ODYtMC4zOS0xLjU0MiAwLjcwMi0xLjQ4OCAxLjU1N2wwLjc2MiAxMi42M2MwLjA1NCAwLjg1OCAwLjkyNyAxLjE2NCAxLjcwNCAxLjU0OCAwLjc4NiAwLjM4MSAxLjU0Mi0wLjcwMiAxLjQ5MS0xLjU1NGwtMC43NjgtMTIuNjMzYy0wLjA1MS0wLjg1OC0wLjgyOC0xLjU2LTEuNzAxLTEuNTQ4IiAvPgogICAgICA8L2c+CiAgICAgIDxnCiAgICAgICAgIGlkPSJnODk4IgogICAgICAgICB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMzUuMDggMzczLjEzKSI+CiAgICAgICAgPHBhdGgKICAgICAgICAgICBpZD0icGF0aDg5NiIKICAgICAgICAgICBmaWxsLXJ1bGU9ImV2ZW5vZGQiCiAgICAgICAgICAgZmlsbD0iI2ZiZDliZCIKICAgICAgICAgICBkPSJtIDAsMCAtMS40OTEsLTUuMjQxIDE3LjczMywtMy43MzUgMS40NzYsNS4yMzUgQyAyMS42OTksMTIuMjA0IDQuODksMTkuMzI5IDAsMCIgLz4KICAgICAgPC9nPgogICAgICA8ZwogICAgICAgICBpZD0iZzkwMiIKICAgICAgICAgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTM5Ljk3IDM0Ny4yKSI+CiAgICAgICAgPHBhdGgKICAgICAgICAgICBpZD0icGF0aDkwMCIKICAgICAgICAgICBmaWxsLXJ1bGU9ImV2ZW5vZGQiCiAgICAgICAgICAgZmlsbD0iI2ZiZDliZCIKICAgICAgICAgICBkPSJtMCAwdi01MS4zODRjLTkuNDk4LTEyLjQ3MS0yNS4wMjktMTIuMDUxLTM0LjUyMSAwdjUxLjM4NGMwIDIyLjg0MiAzNC41MjEgMjIuODMzIDM0LjUyMSAwIiAvPgogICAgICA8L2c+CiAgICAgIDxnCiAgICAgICAgIGlkPSJnOTA2IgogICAgICAgICB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNTUuNTggMjk5LjE1KSI+CiAgICAgICAgPHBhdGgKICAgICAgICAgICBpZD0icGF0aDkwNCIKICAgICAgICAgICBmaWxsLXJ1bGU9ImV2ZW5vZGQiCiAgICAgICAgICAgZmlsbD0iI2FkYWRhZCIKICAgICAgICAgICBkPSJtMCAwIDcxLjI4MyAyMS4yNDljOC42OTQgMi41OCAxMC41NzItMTUuODQ2IDIuOTczLTE5LjE5N2wtNjAuMjQ2LTI2Ljg5OGMtMTkuNzgyLTguNzA2LTMzLjY1NCAxOC45OTMtMTQuMDEgMjQuODQ2IiAvPgogICAgICA8L2c+CiAgICAgIDxnCiAgICAgICAgIGlkPSJnOTEwIgogICAgICAgICB0cmFuc2Zvcm09InRyYW5zbGF0ZSg4OS44MiAzMDAuNzcpIj4KICAgICAgICA8cGF0aAogICAgICAgICAgIGlkPSJwYXRoOTA4IgogICAgICAgICAgIGZpbGwtcnVsZT0iZXZlbm9kZCIKICAgICAgICAgICBmaWxsPSIjYWRhZGFkIgogICAgICAgICAgIGQ9Im0wIDBjMTguOTYtNy43OTEgMi4zODItMzMuOTYtMTYuNDI4LTIzLjMxNmwtNTQuNjM5IDMxLjI1MWMtNy4yMjQgNC4wOTUtNi4xMiAyMy43ODcgMi4yNzEgMjAuMzQ5eiIgLz4KICAgICAgPC9nPgogICAgICA8ZwogICAgICAgICBpZD0iZzkxNCIKICAgICAgICAgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTY4Ljc2IDMwMS45MykiPgogICAgICAgIDxwYXRoCiAgICAgICAgICAgaWQ9InBhdGg5MTIiCiAgICAgICAgICAgZmlsbC1ydWxlPSJldmVub2RkIgogICAgICAgICAgIGZpbGw9IiNhZGFkYWQiCiAgICAgICAgICAgZD0ibTAgMGMtMjMuNDMtMy41MzQtNjcuMjQ1LTEuOTExLTkwLjU1MiAwLjAzNiAwLjI1NS04LjA0OSAwLTIxLjM3OCAwLTIxLjM3OGw3LjEyMi0xMDYuNTloNzQuNzYzbDYuODY3IDEwNi44M3MtMC43OTUgMjAuNzA2IDEuOCAyMS4wOTYiIC8+CiAgICAgIDwvZz4KICAgICAgPGcKICAgICAgICAgaWQ9Imc5MTgiCiAgICAgICAgIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIyNS40NyAzMzkuNTEpIj4KICAgICAgICA8cGF0aAogICAgICAgICAgIGlkPSJwYXRoOTE2IgogICAgICAgICAgIGZpbGwtcnVsZT0iZXZlbm9kZCIKICAgICAgICAgICBmaWxsPSIjYWRhZGFkIgogICAgICAgICAgIGQ9Im0wIDAtNy41MjEtMjkuMDY0Yy0xLjYwMi0xNC4xMjEgMTYuNDk3LTEzLjgwNiAxOS45ODMgMS44OWw2LjExNCAyMS45MDl6IiAvPgogICAgICA8L2c+CiAgICAgIDxnCiAgICAgICAgIGlkPSJnOTIyIgogICAgICAgICB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNS43ODkgMzQzLjk1KSI+CiAgICAgICAgPHBhdGgKICAgICAgICAgICBpZD0icGF0aDkyMCIKICAgICAgICAgICBmaWxsLXJ1bGU9ImV2ZW5vZGQiCiAgICAgICAgICAgZmlsbD0iI2FkYWRhZCIKICAgICAgICAgICBkPSJtMCAwIDUuNzAzLTI4LjQxM2MwLjcwMi0xNC4xOTMtMTguNjM2LTkuODAxLTIwLjczIDUuNzg0bC0zLjgzNyAxOC41NTh6IiAvPgogICAgICA8L2c+CiAgICAgIDxnCiAgICAgICAgIGlkPSJnOTI2IgogICAgICAgICB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMzkuOTcgMzM4LjQ4KSI+CiAgICAgICAgPHBhdGgKICAgICAgICAgICBpZD0icGF0aDkyNCIKICAgICAgICAgICBmaWxsLXJ1bGU9ImV2ZW5vZGQiCiAgICAgICAgICAgZmlsbD0iI2VjYzJhMCIKICAgICAgICAgICBkPSJtMCAwdi0yOC4zMDhjLTYuNTMxLTUuMTA2LTEyLjgzMS03Ljk3NC0xNy4yNjItNy45NzRzLTEwLjcyOCAyLjg2OC0xNy4yNTkgNy45NzR2MjguMzA4YzAgMjIuODQyIDM0LjUyMSAyMi44NDIgMzQuNTIxIDAiIC8+CiAgICAgIDwvZz4KICAgICAgPGcKICAgICAgICAgaWQ9Imc5MzAiCiAgICAgICAgIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyMi43MSAzMDkuMjMpIj4KICAgICAgICA8cGF0aAogICAgICAgICAgIGlkPSJwYXRoOTI4IgogICAgICAgICAgIGZpbGwtcnVsZT0iZXZlbm9kZCIKICAgICAgICAgICBmaWxsPSIjZmJkOWJkIgogICAgICAgICAgIGQ9Im0wIDBjLTExLjIzNSAwLTM0Ljk3NyAxNy42NzMtNDIuMzIxIDQyLjk3NS03LjQxNiAyNS41NTQgNi41NDMgNjIuMjA4IDQyLjMyMSA2Mi4yMDhzNDkuNzM3LTM2LjY1NCA0Mi4zMjEtNjIuMjA4Yy03LjMzNS0yNS4zMTQtMzEuMDg2LTQyLjk3NS00Mi4zMjEtNDIuOTc1IiAvPgogICAgICA8L2c+CiAgICA8L2c+CiAgICA8ZwogICAgICAgaWQ9Imc5NDAiCiAgICAgICBjbGlwLXBhdGg9InVybCgjZikiIC8+CiAgICA8ZwogICAgICAgaWQ9Imc5NDYiCiAgICAgICBjbGlwLXBhdGg9InVybCgjZykiPgogICAgICA8ZwogICAgICAgICBpZD0iZzk0NCIKICAgICAgICAgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNzkuODAyIDM0OS44NykiPgogICAgICAgIDxwYXRoCiAgICAgICAgICAgaWQ9InBhdGg5NDIiCiAgICAgICAgICAgZmlsbC1ydWxlPSJldmVub2RkIgogICAgICAgICAgIGZpbGw9IiNiMjI1MTIiCiAgICAgICAgICAgZD0ibTAgMGMtMTUuNjUxIDUwLjIzNSAzNi43NjIgNzkuNjI2IDYxLjE3OSA2MS45NzcgMjMuOTIyLTMuNzgzIDMzLjQxNC0zOS4wOTMgMjIuODA2LTY4LjM3LTguNTYyLTIzLjYyNS0xMC45MzItODAuOTQzLTEyLjAyNC05My43MjYtMC4yMDEtMi4zNDYtNTcuNDk1IDAuNzQ3LTU4Ljg5NiAyLjY4NS0yLjAyNSAyLjgwOC0wLjY5IDU3LjcyLTEzLjA2NSA5Ny40MzQiIC8+CiAgICAgIDwvZz4KICAgIDwvZz4KICAgIDxwYXRoCiAgICAgICBpZD0icGF0aDEyNzYiCiAgICAgICBkPSJNIDg1LjMzMDAwMSwxNzMuOTk4IDkzLjcxNDEzMywwLjU2NDc2NjkzIDExNS4zNDA0OCwwLjU2NDc2NDc5IDEyMy4xMDM3OCwxMzQuMjA0NDYgMTM1Ljg1Nzc3LC0wLjU0NDI3NjExIDE1NC4xNTY5OCwtMS4wOTg3OTcyIDE2MC4wOTMsMTczLjk5OCBaIgogICAgICAgc3R5bGU9ImZpbGw6IzY2NjY2NjtzdHJva2U6bm9uZTtzdHJva2Utd2lkdGg6MC43NTAwMTg5OTk5OTk5OTk5OXB4O3N0cm9rZS1saW5lY2FwOmJ1dHQ7c3Ryb2tlLWxpbmVqb2luOm1pdGVyO3N0cm9rZS1vcGFjaXR5OjE7ZmlsbC1vcGFjaXR5OjEiIC8+CiAgPC9nPgo8L3N2Zz4=';var css_248z$1$1=".choirScreen{position:relative}.choirScreen,.sideLyrics,.slimLyrics{background:#111}.slimLyrics{z-index:100}.leader{flex-grow:0;justify-content:center;left:0;margin-bottom:20px;max-height:180px;pointer-events:none;position:absolute;right:0;top:30%}.leader svg{height:100%;width:100%}";styleInject$1(css_248z$1$1,{"insertAt":"top"});var build={};var lrc$1={};var lrc={};var dist$2={};var parse$3={};var constants$1={};constants$1.__esModule=true;constants$1.DEFAULT_OPTIONS=void 0;constants$1.DEFAULT_OPTIONS={sortByStartTime:false,trimStart:true,trimEnd:false};(function(exports){exports.__esModule=true;var constants_1=constants$1;/**
 * allow multiple time tag
 * [time][time]content
 */var LYRIC_LINE=/^((?:\[\d+:\d+(?:\.\d+)?\])+)(.*)$/;var METADATA_LINE=/^\[(.+?):(.*?)\]$/;// [key:value]
var LYRIC_TIME=/^(\d+):(\d+)(?:\.(\d+))?$/;// 00:00.00 or 00:00
var SPACE_START=/^\s+/;var SPACE_END=/\s+$/;/**
 * parse lrc string
 * @author mebtte<hi@mebtte.com>
 */function parse(lrc,_a){var _b=_a===void 0?{}:_a,_c=_b.sortByStartTime,sortByStartTime=_c===void 0?constants_1.DEFAULT_OPTIONS.sortByStartTime:_c,_d=_b.trimStart,trimStart=_d===void 0?constants_1.DEFAULT_OPTIONS.trimStart:_d,_e=_b.trimEnd,trimEnd=_e===void 0?constants_1.DEFAULT_OPTIONS.trimEnd:_e;var metadatas=[];// @ts-ignore
var metadata={};var lyrics=[];var invalidLines=[];var lines=lrc.split('\n');for(var i=0,length=lines.length;i<length;i+=1){var raw=lines[i];var line=raw;if(trimStart){line=line.replace(SPACE_START,'');}if(trimEnd){line=line.replace(SPACE_END,'');}/** lyric */var lyricMatch=line.match(LYRIC_LINE);if(lyricMatch){var timesPart=lyricMatch[1];// [time][time]content --> [time][time]
var times=timesPart.split('][');// [time1][time2] --> [time1 | time2]
for(var _i=0,times_1=times;_i<times_1.length;_i++){var time=times_1[_i];var timeMatch=time.replace(/(\[|\])/g,'').match(LYRIC_TIME);var minute=timeMatch[1];var second=timeMatch[2];var centisecond=timeMatch[3]||'00';// compatible with [00:00]
var centisecondNumber=centisecond.length===3?+centisecond:+centisecond*10;// // compatible with [00:00.000]
lyrics.push({lineNumber:i,startMillisecond:+minute*60*1000+ +second*1000+centisecondNumber,content:lyricMatch[2],raw:raw});}continue;}/** metadata */var metadataMatch=line.match(METADATA_LINE);if(metadataMatch){var key=metadataMatch[1];var value=metadataMatch[2];metadatas.push({lineNumber:i,key:key,value:value,raw:raw});// @ts-ignore
metadata[key]=value;continue;}/** invalid line */invalidLines.push({lineNumber:i,raw:raw});}if(sortByStartTime){lyrics=lyrics.sort(function(a,b){return a.startMillisecond-b.startMillisecond;});}return {metadatas:metadatas,metadata:metadata,lyrics:lyrics,invalidLines:invalidLines};}exports["default"]=parse;})(parse$3);var __importDefault$1=commonjsGlobal&&commonjsGlobal.__importDefault||function(mod){return mod&&mod.__esModule?mod:{"default":mod};};dist$2.__esModule=true;dist$2.parse=void 0;var parse_1=__importDefault$1(parse$3);dist$2.parse=parse_1["default"];var constants={};var get_random_string={};(function(exports){exports.__esModule=true;/**
 * get random string
 * @author mebtte<hi@mebtte.com>
 */function getRandomString(){return Math.random().toString(36).substring(2,8);}exports["default"]=getRandomString;})(get_random_string);var __importDefault=commonjsGlobal&&commonjsGlobal.__importDefault||function(mod){return mod&&mod.__esModule?mod:{"default":mod};};constants.__esModule=true;constants.LRC_LINE_COMPONENT_CLASS_NAME_PREFIX=constants.LRC_LINE_COMPONENT_COMMON_CLASS_NAME=constants.LRC_COMPONENT_CLASS_NAME_PREFIX=constants.LRC_COMPONENT_COMMON_CLASS_NAME=void 0;var get_random_string_1=__importDefault(get_random_string);constants.LRC_COMPONENT_COMMON_CLASS_NAME="react_lrc_".concat((0, get_random_string_1["default"])());constants.LRC_COMPONENT_CLASS_NAME_PREFIX='react_lrc_';constants.LRC_LINE_COMPONENT_COMMON_CLASS_NAME="react_lrc_line_".concat((0, get_random_string_1["default"])());constants.LRC_LINE_COMPONENT_CLASS_NAME_PREFIX='react_lrc_line_';var constants_1=constants;var style=document.createElement('style');style.innerHTML="\n  .".concat(constants_1.LRC_COMPONENT_COMMON_CLASS_NAME," {\n    outline: none;\n    overflow: auto;\n    scroll-behavior: smooth;\n  }\n\n  .").concat(constants_1.LRC_COMPONENT_COMMON_CLASS_NAME," > .blank {\n    height: 50%;\n  }\n\n  .").concat(constants_1.LRC_LINE_COMPONENT_COMMON_CLASS_NAME," {\n    display: inline-block;\n    width: 100%;\n    box-sizing: border-box;\n  }\n");document.head.appendChild(style);var use_current_lyric_index={};(function(exports){exports.__esModule=true;function useCurrentLyricIndex(lyrics,currentMillisecond){var index=0;for(var length_1=lyrics.length;index<=length_1;index+=1){var lyric=lyrics[index];if(!lyric||lyric.startMillisecond>currentMillisecond){break;}}return index-1;}exports["default"]=useCurrentLyricIndex;})(use_current_lyric_index);var use_id_ref={};(function(exports){var __importDefault=commonjsGlobal&&commonjsGlobal.__importDefault||function(mod){return mod&&mod.__esModule?mod:{"default":mod};};exports.__esModule=true;var react_1=React__default;var get_random_string_1=__importDefault(get_random_string);/**
 * prevent to call getRandomString every render
 * even id never change
 */exports["default"]=function(){var idRef=(0, react_1.useRef)('');if(!idRef.current){idRef.current=(0, get_random_string_1["default"])();}return idRef;};})(use_id_ref);var use_local_auto_scroll={};var eventemitter$1={};var eventemitter={};(function(exports){var __spreadArray=commonjsGlobal&&commonjsGlobal.__spreadArray||function(to,from,pack){if(pack||arguments.length===2)for(var i=0,l=from.length,ar;i<l;i++){if(ar||!(i in from)){if(!ar)ar=Array.prototype.slice.call(from,0,i);ar[i]=from[i];}}return to.concat(ar||Array.prototype.slice.call(from));};exports.__esModule=true;var Eventemitter=/** @class */function(){function Eventemitter(){this.eventTypeMapListeners=new Map();}Eventemitter.prototype.listen=function(eventType,listener){this.eventTypeMapListeners.set(eventType,__spreadArray(__spreadArray([],this.eventTypeMapListeners.get(eventType)||[],true),[listener],false));};Eventemitter.prototype.unlisten=function(eventType,listener){this.eventTypeMapListeners.set(eventType,__spreadArray([],this.eventTypeMapListeners.get(eventType)||[],true).filter(function(l){return l!==listener;}));};Eventemitter.prototype.trigger=function(eventType,data){var eventTypeListeners=this.eventTypeMapListeners.get(eventType);if(!eventTypeListeners||!eventTypeListeners.length){return;}return eventTypeListeners.forEach(function(listener){return listener(data);});};return Eventemitter;}();exports["default"]=Eventemitter;})(eventemitter);(function(exports){var __importDefault=commonjsGlobal&&commonjsGlobal.__importDefault||function(mod){return mod&&mod.__esModule?mod:{"default":mod};};exports.__esModule=true;exports.EventType=void 0;var eventemitter_1=__importDefault(eventemitter);(function(EventType){EventType["SCROLL_TO_CURRENT_LINE"]="scroll_to_current_line";})(exports.EventType||(exports.EventType={}));exports["default"]=new eventemitter_1["default"]();})(eventemitter$1);var throttle$2={};(function(exports){exports.__esModule=true;function throttle(f,_a){var _b=_a===void 0?{}:_a,_c=_b.wait,wait=_c===void 0?100:_c;var lastEmitTimestamp=0;return function(){var params=[];for(var _i=0;_i<arguments.length;_i++){params[_i]=arguments[_i];}var now=Date.now();if(now-lastEmitTimestamp>wait){lastEmitTimestamp=now;return f.apply(void 0,params);}};}exports["default"]=throttle;})(throttle$2);(function(exports){var __createBinding=commonjsGlobal&&commonjsGlobal.__createBinding||(Object.create?function(o,m,k,k2){if(k2===undefined)k2=k;var desc=Object.getOwnPropertyDescriptor(m,k);if(!desc||("get"in desc?!m.__esModule:desc.writable||desc.configurable)){desc={enumerable:true,get:function(){return m[k];}};}Object.defineProperty(o,k2,desc);}:function(o,m,k,k2){if(k2===undefined)k2=k;o[k2]=m[k];});var __setModuleDefault=commonjsGlobal&&commonjsGlobal.__setModuleDefault||(Object.create?function(o,v){Object.defineProperty(o,"default",{enumerable:true,value:v});}:function(o,v){o["default"]=v;});var __importStar=commonjsGlobal&&commonjsGlobal.__importStar||function(mod){if(mod&&mod.__esModule)return mod;var result={};if(mod!=null)for(var k in mod)if(k!=="default"&&Object.prototype.hasOwnProperty.call(mod,k))__createBinding(result,mod,k);__setModuleDefault(result,mod);return result;};var __importDefault=commonjsGlobal&&commonjsGlobal.__importDefault||function(mod){return mod&&mod.__esModule?mod:{"default":mod};};exports.__esModule=true;var react_1=React__default;var constants_1=constants;var eventemitter_1=__importStar(eventemitter$1);var throttle_1=__importDefault(throttle$2);var SCROLLABLE_KEYS=[' ','ArrowUp','ArrowDown'];exports["default"]=function(_a){var id=_a.id,autoScroll=_a.autoScroll,intervalOfRecoveringAutoScrollAfterUserScroll=_a.intervalOfRecoveringAutoScrollAfterUserScroll;var _b=(0, react_1.useState)(autoScroll),localAutoScroll=_b[0],setLocalAutoScoll=_b[1];(0, react_1.useLayoutEffect)(function(){if(autoScroll){setLocalAutoScoll(true);var lrcNode_1=document.querySelector(".".concat(constants_1.LRC_COMPONENT_CLASS_NAME_PREFIX).concat(id));var keyboardTimer_1;var mouseTimer_1;var wheelTimer_1;var shieldLocalAutoScroll_1=function(){setLocalAutoScoll(false);window.clearTimeout(keyboardTimer_1);window.clearTimeout(mouseTimer_1);window.clearTimeout(wheelTimer_1);return window.setTimeout(function(){return setLocalAutoScoll(true);},intervalOfRecoveringAutoScrollAfterUserScroll);};/** detect user scroll by keyboard, space/arrow_up/arrow_down */var onKeyDown_1=(0, throttle_1["default"])(function(event){var key=event.key;if(SCROLLABLE_KEYS.indexOf(key)>=0){keyboardTimer_1=shieldLocalAutoScroll_1();}});/** detect user scroll by scrollbar drag */var mouseDown_1=false;var onMouseDown_1=function(){mouseDown_1=true;};var onMouseUp_1=function(){mouseDown_1=false;};var onMouseMove_1=(0, throttle_1["default"])(function(){if(mouseDown_1){mouseTimer_1=shieldLocalAutoScroll_1();}});/** detect user scroll by wheel */var onWheel_1=(0, throttle_1["default"])(function(){wheelTimer_1=shieldLocalAutoScroll_1();});lrcNode_1.addEventListener('keydown',onKeyDown_1);lrcNode_1.addEventListener('mousedown',onMouseDown_1);lrcNode_1.addEventListener('mouseup',onMouseUp_1);lrcNode_1.addEventListener('mousemove',onMouseMove_1);lrcNode_1.addEventListener('wheel',onWheel_1);return function(){window.clearTimeout(keyboardTimer_1);window.clearTimeout(mouseTimer_1);window.clearTimeout(wheelTimer_1);lrcNode_1.removeEventListener('keydown',onKeyDown_1);lrcNode_1.removeEventListener('mousedown',onMouseDown_1);lrcNode_1.removeEventListener('mouseup',onMouseUp_1);lrcNode_1.removeEventListener('mousemove',onMouseMove_1);lrcNode_1.removeEventListener('wheel',onWheel_1);};}},[autoScroll,intervalOfRecoveringAutoScrollAfterUserScroll]);(0, react_1.useEffect)(function(){if(autoScroll){var onRecoverAutoScroll_1=function(){return setLocalAutoScoll(true);};eventemitter_1["default"].listen(eventemitter_1.EventType.SCROLL_TO_CURRENT_LINE,onRecoverAutoScroll_1);return function(){return void eventemitter_1["default"].unlisten(eventemitter_1.EventType.SCROLL_TO_CURRENT_LINE,onRecoverAutoScroll_1);};}setLocalAutoScoll(false);},[autoScroll]);return localAutoScroll;};})(use_local_auto_scroll);var use_auto_scroll_action={};var debounce$2={};(function(exports){exports.__esModule=true;function debounce(f,_a){var _b=_a===void 0?{}:_a,_c=_b.wait,wait=_c===void 0?300:_c;var timer;return function(){var params=[];for(var _i=0;_i<arguments.length;_i++){params[_i]=arguments[_i];}window.clearTimeout(timer);timer=window.setTimeout(function(){return f(params);},wait);};}exports["default"]=debounce;})(debounce$2);(function(exports){var __createBinding=commonjsGlobal&&commonjsGlobal.__createBinding||(Object.create?function(o,m,k,k2){if(k2===undefined)k2=k;var desc=Object.getOwnPropertyDescriptor(m,k);if(!desc||("get"in desc?!m.__esModule:desc.writable||desc.configurable)){desc={enumerable:true,get:function(){return m[k];}};}Object.defineProperty(o,k2,desc);}:function(o,m,k,k2){if(k2===undefined)k2=k;o[k2]=m[k];});var __setModuleDefault=commonjsGlobal&&commonjsGlobal.__setModuleDefault||(Object.create?function(o,v){Object.defineProperty(o,"default",{enumerable:true,value:v});}:function(o,v){o["default"]=v;});var __importStar=commonjsGlobal&&commonjsGlobal.__importStar||function(mod){if(mod&&mod.__esModule)return mod;var result={};if(mod!=null)for(var k in mod)if(k!=="default"&&Object.prototype.hasOwnProperty.call(mod,k))__createBinding(result,mod,k);__setModuleDefault(result,mod);return result;};var __importDefault=commonjsGlobal&&commonjsGlobal.__importDefault||function(mod){return mod&&mod.__esModule?mod:{"default":mod};};exports.__esModule=true;var react_1=React__default;var constants_1=constants;var debounce_1=__importDefault(debounce$2);var eventemitter_1=__importStar(eventemitter$1);exports["default"]=function(_a){var id=_a.id,localAutoScoll=_a.localAutoScoll,currentLyricIndex=_a.currentLyricIndex,lyrics=_a.lyrics,topBlank=_a.topBlank;var indexMapRef=(0, react_1.useRef)(new Map());var lrcNodeRef=(0, react_1.useRef)();var scrollToCurrentLine=(0, react_1.useCallback)(function(){var indexMap=indexMapRef.current.get(currentLyricIndex);if(indexMap){lrcNodeRef.current.scrollTop=indexMap.offsetTop-lrcNodeRef.current.clientHeight*0.45+indexMap.height/2;}else {lrcNodeRef.current.scrollTop=0;}},[currentLyricIndex]);(0, react_1.useLayoutEffect)(function(){lrcNodeRef.current=document.querySelector(".".concat(constants_1.LRC_COMPONENT_CLASS_NAME_PREFIX).concat(id));var caculateIndexMap=function(){var indexMap=new Map();var lrcLineNodeList=document.querySelectorAll(".".concat(constants_1.LRC_LINE_COMPONENT_CLASS_NAME_PREFIX).concat(id));for(var i=0,length_1=lrcLineNodeList.length;i<length_1;i+=1){var lrcLineNode=lrcLineNodeList[i];indexMap.set(i,{height:lrcLineNode.clientHeight,offsetTop:lrcLineNode.offsetTop});}indexMapRef.current=indexMap;};caculateIndexMap();var resizeDetector=new window.ResizeObserver((0, debounce_1["default"])(caculateIndexMap));resizeDetector.observe(lrcNodeRef.current);return function(){lrcNodeRef.current=null;resizeDetector.disconnect();};},[lyrics,topBlank]);(0, react_1.useLayoutEffect)(function(){if(localAutoScoll){scrollToCurrentLine();}},[localAutoScoll,scrollToCurrentLine,lyrics,topBlank]);(0, react_1.useLayoutEffect)(function(){var onScrollToCurrentLine=function(){return scrollToCurrentLine();};eventemitter_1["default"].listen(eventemitter_1.EventType.SCROLL_TO_CURRENT_LINE,onScrollToCurrentLine);return function(){return eventemitter_1["default"].unlisten(eventemitter_1.EventType.SCROLL_TO_CURRENT_LINE,onScrollToCurrentLine);};},[scrollToCurrentLine]);};})(use_auto_scroll_action);(function(exports){var __assign=commonjsGlobal&&commonjsGlobal.__assign||function(){__assign=Object.assign||function(t){for(var s,i=1,n=arguments.length;i<n;i++){s=arguments[i];for(var p in s)if(Object.prototype.hasOwnProperty.call(s,p))t[p]=s[p];}return t;};return __assign.apply(this,arguments);};var __createBinding=commonjsGlobal&&commonjsGlobal.__createBinding||(Object.create?function(o,m,k,k2){if(k2===undefined)k2=k;var desc=Object.getOwnPropertyDescriptor(m,k);if(!desc||("get"in desc?!m.__esModule:desc.writable||desc.configurable)){desc={enumerable:true,get:function(){return m[k];}};}Object.defineProperty(o,k2,desc);}:function(o,m,k,k2){if(k2===undefined)k2=k;o[k2]=m[k];});var __setModuleDefault=commonjsGlobal&&commonjsGlobal.__setModuleDefault||(Object.create?function(o,v){Object.defineProperty(o,"default",{enumerable:true,value:v});}:function(o,v){o["default"]=v;});var __importStar=commonjsGlobal&&commonjsGlobal.__importStar||function(mod){if(mod&&mod.__esModule)return mod;var result={};if(mod!=null)for(var k in mod)if(k!=="default"&&Object.prototype.hasOwnProperty.call(mod,k))__createBinding(result,mod,k);__setModuleDefault(result,mod);return result;};var __rest=commonjsGlobal&&commonjsGlobal.__rest||function(s,e){var t={};for(var p in s)if(Object.prototype.hasOwnProperty.call(s,p)&&e.indexOf(p)<0)t[p]=s[p];if(s!=null&&typeof Object.getOwnPropertySymbols==="function")for(var i=0,p=Object.getOwnPropertySymbols(s);i<p.length;i++){if(e.indexOf(p[i])<0&&Object.prototype.propertyIsEnumerable.call(s,p[i]))t[p[i]]=s[p[i]];}return t;};var __importDefault=commonjsGlobal&&commonjsGlobal.__importDefault||function(mod){return mod&&mod.__esModule?mod:{"default":mod};};exports.__esModule=true;var react_1=__importStar(React__default);var clrc_1=dist$2;var constants_1=constants;var use_current_lyric_index_1=__importDefault(use_current_lyric_index);var use_id_ref_1=__importDefault(use_id_ref);var use_local_auto_scroll_1=__importDefault(use_local_auto_scroll);var use_auto_scroll_action_1=__importDefault(use_auto_scroll_action);var eventemitter_1=__importStar(eventemitter$1);var scrollToCurrentLine=function(){return eventemitter_1["default"].trigger(eventemitter_1.EventType.SCROLL_TO_CURRENT_LINE);};/**
 * Lrc component
 * @author mebtte<hi@mebtte.com>
 */var Lrc=(0, react_1.forwardRef)(function(props,ref){var lrc=props.lrc,lineRenderer=props.lineRenderer,_a=props.currentMillisecond,currentMillisecond=_a===void 0?0:_a,_b=props.autoScroll,autoScroll=_b===void 0?true:_b,_c=props.intervalOfRecoveringAutoScrollAfterUserScroll,intervalOfRecoveringAutoScrollAfterUserScroll=_c===void 0?5000:_c,_d=props.topBlank,topBlank=_d===void 0?false:_d,_e=props.bottomBlank,bottomBlank=_e===void 0?false:_e,onLineChange=props.onLineChange,_f=props.className,className=_f===void 0?'':_f,otherProps=__rest(props,["lrc","lineRenderer","currentMillisecond","autoScroll","intervalOfRecoveringAutoScrollAfterUserScroll","topBlank","bottomBlank","onLineChange","className"]);var idRef=(0, use_id_ref_1["default"])();var rootRef=(0, react_1.useRef)();var lyrics=(0, react_1.useMemo)(function(){return (0, clrc_1.parse)(lrc,{sortByStartTime:true,trimStart:true});},[lrc]).lyrics;var currentLyricIndex=(0, use_current_lyric_index_1["default"])(lyrics,currentMillisecond);var localAutoScoll=(0, use_local_auto_scroll_1["default"])({id:idRef.current,autoScroll:autoScroll,intervalOfRecoveringAutoScrollAfterUserScroll:intervalOfRecoveringAutoScrollAfterUserScroll});(0, use_auto_scroll_action_1["default"])({id:idRef.current,localAutoScoll:localAutoScoll,currentLyricIndex:currentLyricIndex,lyrics:lyrics,topBlank:topBlank});(0, react_1.useEffect)(function(){if(onLineChange){onLineChange({index:currentLyricIndex,line:lyrics[currentLyricIndex]||null});}},[onLineChange,currentLyricIndex,lyrics]);(0, react_1.useImperativeHandle)(ref,function(){return {dom:rootRef.current,getCurrentLine:function(){return {index:currentLyricIndex,line:lyrics[currentLyricIndex]||null};},scrollToCurrentLine:scrollToCurrentLine};});var lyricNodeList=(0, react_1.useMemo)(function(){return lyrics.map(function(lyric,index){return react_1["default"].createElement("div",{// eslint-disable-next-line react/no-array-index-key
key:index,className:"".concat(constants_1.LRC_LINE_COMPONENT_COMMON_CLASS_NAME," ").concat(constants_1.LRC_LINE_COMPONENT_CLASS_NAME_PREFIX).concat(idRef.current)},lineRenderer({index:index,active:currentLyricIndex===index,line:lyric}));});},[lineRenderer,lyrics,currentLyricIndex]);return react_1["default"].createElement("div",__assign({/** tabIndex make focusable and enable to add keyboard listener */tabIndex:-1},otherProps,{className:"".concat(constants_1.LRC_COMPONENT_COMMON_CLASS_NAME," ").concat(constants_1.LRC_COMPONENT_CLASS_NAME_PREFIX).concat(idRef.current," ").concat(className),ref:rootRef}),topBlank&&react_1["default"].createElement("div",{className:"blank"}),lyricNodeList,bottomBlank&&react_1["default"].createElement("div",{className:"blank"}));});exports["default"]=Lrc;})(lrc);(function(exports){var __importDefault=commonjsGlobal&&commonjsGlobal.__importDefault||function(mod){return mod&&mod.__esModule?mod:{"default":mod};};exports.__esModule=true;var lrc_1=__importDefault(lrc);exports["default"]=lrc_1["default"];})(lrc$1);(function(exports){var __createBinding=commonjsGlobal&&commonjsGlobal.__createBinding||(Object.create?function(o,m,k,k2){if(k2===undefined)k2=k;var desc=Object.getOwnPropertyDescriptor(m,k);if(!desc||("get"in desc?!m.__esModule:desc.writable||desc.configurable)){desc={enumerable:true,get:function(){return m[k];}};}Object.defineProperty(o,k2,desc);}:function(o,m,k,k2){if(k2===undefined)k2=k;o[k2]=m[k];});var __exportStar=commonjsGlobal&&commonjsGlobal.__exportStar||function(m,exports){for(var p in m)if(p!=="default"&&!Object.prototype.hasOwnProperty.call(exports,p))__createBinding(exports,m,p);};var __importDefault=commonjsGlobal&&commonjsGlobal.__importDefault||function(mod){return mod&&mod.__esModule?mod:{"default":mod};};exports.__esModule=true;exports.Lrc=void 0;var lrc_1=__importDefault(lrc$1);exports.Lrc=lrc_1["default"];__exportStar(dist$2,exports);})(build);const lyric="text-white text-center font-bold transition-colors";var css_248z$c=".fadeOut{-webkit-mask-image:linear-gradient(180deg,#000 30%,#0000);mask-image:linear-gradient(180deg,#000 30%,#0000)}.lyricActive{color:var(--theme-primary-color)!important}";styleInject$1(css_248z$c,{"insertAt":"top"});function SyncedLyrics({lyrics,currentTime,...props}){return/*#__PURE__*/React__default.createElement("div",{className:"h-full fadeOut"},/*#__PURE__*/React__default.createElement(build.Lrc,{style:{height:'100%'},lrc:lyrics,lineRenderer:({index,line,active})=>/*#__PURE__*/React__default.createElement("p",{className:classNames$2(lyric,active?'lyricActive':'','select-none')},`${line.content}`),currentMillisecond:currentTime,bottomBlank:true,height:200,intervalOfRecoveringAutoScrollAfterUserScroll:2500}));}SyncedLyrics.propTypes={lyrics:PropTypes.string,getCurrentTime:PropTypes.func};SyncedLyrics.defaultProps={lyrics:'',getCurrentTime:()=>0};// let level = 0.0046388134360313416;
let level=0;setInterval(()=>{if(level!==0.8){// level = level + 0.001;
level=0.8;}else {level=0;}},2000);function ChoirConductor({stems,getVuLevel,onFaderChange,onPanChange,onMuteStem,onSoloStem,onArmStem,onDeleteStem,onShare,onAddStem,onDownload,onReset,type,size,onChangeIntroLevel,onChangeClick1Level,onChangeClick2Level,onChangeCueLevel,levelStep,introLevel,click1Level,click2Level,cueLevel,showGuideChannelButtons,showMixControls,mixerTemplate,showLyricsButton,onClickLyricsButton,lyricsActive,lyrics,currentTimeMilliseconds,soloMode,...props}){const choirStemComponents=stems.filter(s=>{return !s.label.toLowerCase().includes("bt")&&!s.label.toLowerCase().includes("band");}).map(stem=>{return/*#__PURE__*/React__default.createElement(ChoirSectionStem,{soloMode:soloMode,stem:stem,getVuLevel:getVuLevel,onTrackChange:value=>onFaderChange(stem.id,value),onPanChange:value=>onPanChange(stem.id,value),onMuteStem:value=>onMuteStem(stem.id,value),onSoloStem:value=>onSoloStem(stem.id,value),onArmStem:value=>onArmStem(stem.id,value),onDeleteStem:value=>onDeleteStem(stem.id,value)});});const btStemComponent=stems.filter(s=>{return s.label.toLowerCase().includes("bt")||s.label.toLowerCase().includes("band");}).map(stem=>{return/*#__PURE__*/React__default.createElement(BtSectionStem,{lyricsActive:lyricsActive,soloMode:soloMode,opacity:1,stem:stem,getVuLevel:getVuLevel,onTrackChange:value=>onFaderChange(stem.id,value),onPanChange:value=>onPanChange(stem.id,value),onMuteStem:value=>onMuteStem(stem.id,value),onSoloStem:value=>onSoloStem(stem.id,value),onArmStem:value=>onArmStem(stem.id,value),onDeleteStem:value=>onDeleteStem(stem.id,value)});});return/*#__PURE__*/React__default.createElement("div",{className:"flex flex-row h-full"},/*#__PURE__*/React__default.createElement("div",{className:"flex grow flex-col justify-between h-full choirScreen"},/*#__PURE__*/React__default.createElement("div",{className:"hidden text-center lg:block m-0 lg:m-4"},/*#__PURE__*/React__default.createElement(Button,{id:"lyrics-button",onClick:onClickLyricsButton,size:"lg",type:"primary"},/*#__PURE__*/React__default.createElement(ChatBubbleBottomCenterTextIcon$3,{className:"h-6 w-6 mr-2"}),lyricsActive?'Hide':'Show'," lyrics")),lyricsActive&&/*#__PURE__*/React__default.createElement("div",{className:"text-center mt-4 h-full lg:hidden slimLyrics"},/*#__PURE__*/React__default.createElement(SyncedLyrics,{lyrics:lyrics,currentTime:currentTimeMilliseconds})),/*#__PURE__*/React__default.createElement("div",{style:{touchAction:"pan-y pan-x"},className:`w-full h-2/5 flex flex-row flex ${lyricsActive?'hidden lg:flex':''}`},choirStemComponents),/*#__PURE__*/React__default.createElement("div",{className:`leader flex ${lyricsActive?'hidden lg:flex':''}`},/*#__PURE__*/React__default.createElement("img",{draggable:"false",src:ChoirLeader,alt:"Choir Leader image"})),btStemComponent,showGuideChannelButtons&&/*#__PURE__*/React__default.createElement(ChannelControlButtons,{onChangeIntroLevel:onChangeIntroLevel,onChangeClick1Level:onChangeClick1Level,onChangeClick2Level:onChangeClick2Level,onChangeCueLevel:onChangeCueLevel,step:levelStep,introLevel:introLevel,click1Level:click1Level,click2Level:click2Level,cueLevel:cueLevel})),lyricsActive&&/*#__PURE__*/React__default.createElement("div",{className:"pt-8 hidden lg:flex max-w-[50%] h-full border-l sideLyrics border-secondary-800"},/*#__PURE__*/React__default.createElement(SyncedLyrics,{lyrics:lyrics,currentTime:currentTimeMilliseconds})));}ChoirConductor.propTypes={stems:PropTypes.arrayOf(PropTypes.shape({id:PropTypes.string.isRequired,label:PropTypes.string.isRequired,level:PropTypes.number.isRequired,vuLevel:PropTypes.number.isRequired,pan:PropTypes.number.isRequired,muted:PropTypes.bool.isRequired,soloed:PropTypes.bool.isRequired})).isRequired,getVuLevel:PropTypes.func,onFaderChange:PropTypes.func,onPanChange:PropTypes.func,onMuteStem:PropTypes.func,onSoloStem:PropTypes.func,onArmStem:PropTypes.func,onShare:PropTypes.func,onAddStem:PropTypes.func,onDownload:PropTypes.func,onReset:PropTypes.func,type:PropTypes.oneOf(["default"]),// Would be better to use Object.keys but it won't work with Storybook currently
size:PropTypes.oneOf(["base"]),showGuideChannelButtons:PropTypes.bool,showMixControls:PropTypes.bool,mixerTemplate:PropTypes.oneOf(["band","choir"]),currentTimeMilliseconds:PropTypes.number,soloMode:PropTypes.bool};ChoirConductor.defaultProps={getVuLevel:index=>level,onFaderChange:undefined,onPanChange:undefined,onMuteStem:undefined,onSoloStem:undefined,onArmStem:undefined,onShare:undefined,onAddStem:undefined,onDownload:undefined,onReset:undefined,type:"default",size:"base",onChangeIntroLevel:undefined,onChangeClick1Level:undefined,onChangeClick2Level:undefined,onChangeCueLeveled:undefined,levelStep:0.25,introLevel:0,click1Level:0,click2Level:0,cueLevel:null,showGuideChannelButtons:false,showMixControls:true,mixerTemplate:"band",showLyricsButton:false,onClickLyricsButton:undefined,lyricsActive:false,lyrics:[],currentTimeMilliseconds:0,soloMode:false};function PlayerControl({isPlaying,isRecording,isLooping,onPrevious,onNext,onStop,onPlayPause,onRecord,onLoop,type,size,showMixRecord,...props}){const buttonStyle=" flex inline-flex items-center justify-center rounded-md text-primary dark:text-secondary-200 dark:hover:text-secondary-400 focus:outline-none overflow-hidden text-md sm:text-sm lg:text-base";return/*#__PURE__*/React__default.createElement("div",{id:"transport",className:"flex items-center justify-between max-w-xs rounded-lg"},showMixRecord&&/*#__PURE__*/React__default.createElement("button",{type:"button",className:buttonStyle,onClick:onRecord},/*#__PURE__*/React__default.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 20 20",fill:"currentColor","aria-hidden":"true",className:`h- w-7 md:h-10 md:w-10 text-red-700 ${isRecording?'animate-pulse':''}`},/*#__PURE__*/React__default.createElement("path",{"fill-rule":"fill",d:"M10 18a8 8 0 100-16 8 8 0 000 16zM8 7a1 1 0 00-1 1v4a1 1 0 001 1h4a1 1 0 001-1V8a1 1 0 00-1-1H8z","clip-rule":"evenodd"}))),/*#__PURE__*/React__default.createElement("button",{type:"button",className:buttonStyle,onClick:onPlayPause},isPlaying?/*#__PURE__*/React__default.createElement(PauseIcon$1,{className:"h-7 w-7 md:h-12 md:w-12"}):/*#__PURE__*/React__default.createElement(PlayIcon$1,{className:"h-7 w-7 md:h-12 md:w-12"})),/*#__PURE__*/React__default.createElement("button",{type:"button",className:buttonStyle,onClick:onStop},/*#__PURE__*/React__default.createElement(StopIcon$1,{className:`${isPlaying?'':'opacity-40'} h-7 w-7 md:h-12 md:w-12`})),/*#__PURE__*/React__default.createElement("button",{type:"button",className:buttonStyle,onClick:onLoop},/*#__PURE__*/React__default.createElement(ArrowPathIcon$1,{style:{color:isLooping?'#22c55e':''},className:"ml-2 mr-1 h-7 w-7 md:h-10 md:w-10"}),/*#__PURE__*/React__default.createElement("span",{className:"lg:flex hidden"},"LOOP SECTION")));}PlayerControl.propTypes={isPlaying:PropTypes.bool,isLooping:PropTypes.bool,isRecording:PropTypes.bool,onPrevious:PropTypes.func,onNext:PropTypes.func,onStop:PropTypes.func,onRecord:PropTypes.func,onPlayPause:PropTypes.func,type:PropTypes.oneOf(["default"]),// Would be better to use Object.keys but it won't work with Storybook currently
size:PropTypes.oneOf(["sm","base"]),showMixRecord:PropTypes.bool};PlayerControl.defaultProps={isPlaying:false,isRecording:false,isLooping:false,onPrevious:undefined,onNext:undefined,onStop:undefined,onRecord:undefined,onLoop:undefined,onPlayPause:undefined,type:"default",size:"base",showMixRecord:true};const Size={sm:"px-2 py-0.5 text-xs",lg:"text-base px-4 py-2"};function PlusMinusButton({size,label,onMinus,onPlus,value}){return/*#__PURE__*/React__default.createElement("div",null,/*#__PURE__*/React__default.createElement("div",{className:"flex flex-col justify-center items-center"},/*#__PURE__*/React__default.createElement("span",{className:"pb-0.5 text-xs dark:text-secondary-100"},label),/*#__PURE__*/React__default.createElement("span",{className:"relative z-0 inline-flex shadow-sm rounded-md"},/*#__PURE__*/React__default.createElement("button",{onClick:onMinus,type:"button",className:`relative inline-flex items-center rounded-l-md border border-gray-300 dark:border-secondary-700 bg-white dark:bg-secondary-900 text-sm font-medium  dark:hover:bg-primary text-gray-800 dark:text-secondary-100 focus:outline-none ${Size[size]}`},"-"),/*#__PURE__*/React__default.createElement("span",{className:`-ml-px justify-center relative inline-flex items-center border border-gray-300 dark:border-secondary-700 bg-white dark:bg-secondary-900 text-sm font-medium text-gray-800 dark:text-secondary-100 hover:bg-gray-50 focus:outline-none ${Size[size]} w-12`},value),/*#__PURE__*/React__default.createElement("button",{onClick:onPlus,type:"button",className:`-ml-px relative inline-flex items-center rounded-r-md border border-gray-300 dark:border-secondary-700 bg-white dark:bg-secondary-900 dark:hover:bg-primary text-sm font-medium text-gray-800 dark:text-secondary-100 focus:outline-none  ${Size[size]}`},"+"))));}PlusMinusButton.propTypes={size:PropTypes.oneOf(["sm","lg"]),onMinus:PropTypes.func,onPlus:PropTypes.func,value:PropTypes.string};PlusMinusButton.defaultProps={size:"sm",label:'Label',onMinus:console.log,onPlus:console.log,value:'0'};function PlayerTopControl({showPitchSpeedControls,showMixRecord,showMuteControl,showSoloControl,showResetLevels,pitch,speed,isPlaying,isRecording,isLooping,isMuted,isSoloed,soloMode,onPitchChange,onPitchMinus,onPitchPlus,onSpeedChange,onSpeedPlus,onSpeedMinus,onPrevious,onNext,onStop,onRecord,onPlayPause,onMute,onSoloModeToggle,onLoop,onReset,type,size,...props}){const[showControls,setShowControls]=useState(false);return/*#__PURE__*/React__default.createElement(React__default.Fragment,null,/*#__PURE__*/React__default.createElement(Modal,{isOpen:showControls,onClose:()=>setShowControls(false),closeLabel:"Close",title:"Speed/Pitch",content:/*#__PURE__*/React__default.createElement(React__default.Fragment,null,/*#__PURE__*/React__default.createElement("p",{className:"mb-3"},"Control the global pitch and speed of the session playback."),/*#__PURE__*/React__default.createElement(PlusMinusButton,{size:"lg",label:"Speed",onMinus:onSpeedMinus,onPlus:onSpeedPlus,value:speed.displayValue}),/*#__PURE__*/React__default.createElement("div",{className:"h-5"}),/*#__PURE__*/React__default.createElement(PlusMinusButton,{size:"lg",label:"Pitch",onMinus:onPitchMinus,onPlus:onPitchPlus,value:pitch.displayValue}))}),/*#__PURE__*/React__default.createElement("div",{className:"flex items-center bg-secondary-800 justify-between h-12 lg:h-18 w-full px-2 lg:px-2"},/*#__PURE__*/React__default.createElement("div",{className:"flex"},/*#__PURE__*/React__default.createElement(Button,{id:"pitch-speed-button",type:"choirControl",size:"sm",isOn:speed.value!==1||pitch.value!==0,onClick:()=>setShowControls(true)},/*#__PURE__*/React__default.createElement(AdjustmentsHorizontalIcon$1,{className:"lg:flex hidden w-4 h-4 mr-1"}),"Speed/Pitch"),showMuteControl&&/*#__PURE__*/React__default.createElement(Button,{id:"mute-button",type:"choirControl",additionalClasses:"ml-1",onClick:onMute,isOn:isMuted},/*#__PURE__*/React__default.createElement("span",{className:"text-xs flex flex-1"},/*#__PURE__*/React__default.createElement(SpeakerXMarkIcon$1,{className:"lg:flex hidden w-4 h-4 mr-1"})," ",isMuted?"Unmute":"Mute")),showSoloControl&&/*#__PURE__*/React__default.createElement(Button,{id:"solo-button",type:"choirControl",size:"sm",additionalClasses:"ml-1",onClick:onSoloModeToggle,isOn:soloMode},/*#__PURE__*/React__default.createElement("span",{className:" text-xs flex flex-1"},/*#__PURE__*/React__default.createElement(SignalIcon$1,{className:"lg:flex hidden w-4 h-4 mr-1"})," Solo")),showResetLevels&&/*#__PURE__*/React__default.createElement(Button,{id:"reset-button",type:"choirControl",size:"sm",additionalClasses:"ml-1",onClick:onReset},/*#__PURE__*/React__default.createElement("span",{className:"text-xs flex flex-1"},/*#__PURE__*/React__default.createElement(SparklesIcon$1,{className:"lg:flex hidden w-4 h-4 mr-1"})," Reset"))),/*#__PURE__*/React__default.createElement("div",{className:"flex"},/*#__PURE__*/React__default.createElement("span",null)),/*#__PURE__*/React__default.createElement(PlayerControl,{isPlaying:isPlaying,isRecording:isRecording,isLooping:isLooping,onPrevious:onPrevious,onNext:onNext,onStop:onStop,onLoop:onLoop,onRecord:onRecord,onPlayPause:onPlayPause,showMixRecord:showMixRecord})));}PlayerTopControl.propTypes={showPitchSpeedControls:PropTypes.bool,showMixRecord:PropTypes.bool,showMuteControl:PropTypes.bool,showSoloControl:PropTypes.bool,soloMode:PropTypes.bool,pitch:PropTypes.shape({displayValue:PropTypes.string.isRequired,value:PropTypes.number.isRequired,step:PropTypes.number.isRequired}),speed:PropTypes.shape({displayValue:PropTypes.string.isRequired,value:PropTypes.number.isRequired}),isPlaying:PropTypes.bool.isRequired,isRecording:PropTypes.bool.isRequired,isMuted:PropTypes.bool.isRequired,onPitchChange:PropTypes.func,onPitchMinus:PropTypes.func,onPitchPlus:PropTypes.func,onSpeedChange:PropTypes.func,onSpeedMinus:PropTypes.func,onSpeedPlus:PropTypes.func,onPrevious:PropTypes.func,onNext:PropTypes.func,onStop:PropTypes.func,onReset:PropTypes.func,onSoloModeToggle:PropTypes.func,onRecord:PropTypes.func,onPlayPause:PropTypes.func,onMute:PropTypes.func,type:PropTypes.oneOf(["default"]),// Would be better to use Object.keys but it won't work with Storybook currently
size:PropTypes.oneOf(["base"])};PlayerTopControl.defaultProps={showMixRecord:true,showPitchSpeedControls:true,showResetLevels:true,showMuteControl:false,showSoloControl:true,isPlaying:false,isRecording:false,isMuted:false,onPitchChange:undefined,onSpeedChange:undefined,onSoloModeToggle:undefined,onPrevious:undefined,onNext:undefined,onStop:undefined,onRestet:undefined,onRecord:undefined,onPlayPause:undefined,onMute:undefined,soloMode:false,type:"default",size:"base"};function PlayerContainer({volume,pitch,speed,isPlaying,isRecording,isMuted,onChangePitch,onPitchMinus,onPitchPlus,onChangeSpeed,onSpeedMinus,onSpeedPlus,onPlayPrevious,onPlayNext,onRecord,onStop,onPlayPause,onMute,getCurrentPosition,song,onSelectSection,onChangePosition,isLooping,soloMode,onLoop,loopStart,loopEnd,type,size,onChangeIntroLevel,onChangeClick1Level,onChangeClick2Level,onChangeCueLevel,onSoloModeToggle,onReset,levelStep,introLevel,click1Level,click2Level,cueLevel,showTransportControls,showPitchSpeedControls,showMixRecord,showMixDownload,showMixShare,showMixReset,showCueControls,mixerTemplate,showLyrics,children}){return/*#__PURE__*/React__default.createElement("div",{className:"h-full flex flex-col"},/*#__PURE__*/React__default.createElement("div",{className:"flex-1 flex-basis-0 min-h-0 max-h-full flex flex-col overflow-auto"},children),showTransportControls&&/*#__PURE__*/React__default.createElement("div",null,/*#__PURE__*/React__default.createElement(PlayerTopControl,{pitch:pitch,speed:speed,isPlaying:isPlaying,isRecording:isRecording,isMuted:isMuted,isLooping:isLooping,loopStart:loopStart,loopEnd:loopEnd,onPitchChange:onChangePitch,onPitchMinus:onPitchMinus,onPitchPlus:onPitchPlus,onSpeedChange:onChangeSpeed,onSpeedMinus:onSpeedMinus,onSpeedPlus:onSpeedPlus,onPrevious:onPlayPrevious,onNext:onPlayNext,onStop:onStop,onReset:onReset,onPlayPause:onPlayPause,onRecord:onRecord,onMute:onMute,onLoop:onLoop,onSoloModeToggle:onSoloModeToggle,soloMode:soloMode,showPitchSpeedControls:showPitchSpeedControls,showMixRecord:showMixRecord})),showTransportControls&&/*#__PURE__*/React__default.createElement("div",null,/*#__PURE__*/React__default.createElement(PlayerBottomControl,{getCurrentPosition:getCurrentPosition,song:song,onSectionSelected:onSelectSection,onPositionChange:onChangePosition,isLooping:isLooping,loopStart:loopStart,loopEnd:loopEnd,onLoop:onLoop,onChangeIntroLevel:onChangeIntroLevel,onChangeClick1Level:onChangeClick1Level,onChangeClick2Level:onChangeClick2Level,onChangeCueLevel:onChangeCueLevel,step:levelStep,introLevel:introLevel,click1Level:click1Level,click2Level:click2Level,cueLevel:cueLevel})));}PlayerContainer.propTypes={pitch:PlayerTopControl.propTypes.pitch,speed:PlayerTopControl.propTypes.speed,isPlaying:PlayerTopControl.propTypes.isPlaying,isRecording:PlayerTopControl.propTypes.isRecording,isMuted:PlayerTopControl.propTypes.isMuted,onChangePitch:PlayerTopControl.propTypes.onPitchChange,onPitchMinus:PlayerTopControl.propTypes.onPitchMinus,onPitchPlus:PlayerTopControl.propTypes.onPitchPlus,onChangeSpeed:PlayerTopControl.propTypes.onSpeedChange,onSpeedMinus:PlayerTopControl.propTypes.onSpeedMinus,onSpeedPlus:PlayerTopControl.propTypes.onSpeedPlus,onPlayPrevious:PlayerTopControl.propTypes.onPrevious,onPlayNext:PlayerTopControl.propTypes.onNext,onStop:PlayerTopControl.propTypes.onStop,onPlayPause:PlayerTopControl.propTypes.onPlayPause,onRecord:PlayerTopControl.propTypes.onRecord,onMute:PlayerTopControl.propTypes.onMute,onSoloModeToggle:PropTypes.func,onReset:PropTypes.func,getCurrentPosition:PropTypes.func,song:PlayerBottomControl.propTypes.song,onSelectSection:PlayerBottomControl.propTypes.onSectionSelected,onChangePosition:PlayerBottomControl.propTypes.onPositionChange,isLooping:PlayerBottomControl.propTypes.looping,onLoop:PlayerBottomControl.propTypes.onLoop,loopStart:PlayerBottomControl.propTypes.loopStart,loopEnd:PlayerBottomControl.propTypes.loopEnd,type:PropTypes.oneOf(["default"]),// Would be better to use Object.keys but it won't work with Storybook currently
size:PropTypes.oneOf(["base"]),showTransportControls:PropTypes.bool,showPitchSpeedControls:PropTypes.bool,showMixRecord:PropTypes.bool,showMixDownload:PropTypes.bool,showMixShare:PropTypes.bool,showMixReset:PropTypes.bool,showCueControls:PropTypes.bool,mixerTemplate:PropTypes.bool,showLyrics:PropTypes.bool,soloMode:PropTypes.bool};PlayerContainer.defaultProps={type:"default",size:"base",onChangeIntroLevel:undefined,onChangeClick1Level:v=>console.log(v),onChangeClick2Level:undefined,onChangeCueLeveled:undefined,onSoloModeToggle:undefined,onReset:undefined,onLoop:undefined,levelStep:0.5,introLevel:null,click1Level:0.5,click2Level:null,cueLevel:null,showTransportControls:false,showPitchSpeedControls:true,showMixRecord:true,showMixDownload:true,showMixShare:true,showMixReset:true,showCueControls:true,mixerTemplate:true,showLyrics:true,soloMode:false};function asyncGeneratorStep$1(gen,resolve,reject,_next,_throw,key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else {Promise.resolve(value).then(_next,_throw);}}function _asyncToGenerator$1(fn){return function(){var self=this,args=arguments;return new Promise(function(resolve,reject){var gen=fn.apply(self,args);function _next(value){asyncGeneratorStep$1(gen,resolve,reject,_next,_throw,"next",value);}function _throw(err){asyncGeneratorStep$1(gen,resolve,reject,_next,_throw,"throw",err);}_next(undefined);});};}function _extends$4(){_extends$4=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends$4.apply(this,arguments);}function createCommonjsModule$1(fn,module){return module={exports:{}},fn(module,module.exports),module.exports;}var runtime_1$1=createCommonjsModule$1(function(module){/**
   * Copyright (c) 2014-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */var runtime=function(exports){var Op=Object.prototype;var hasOwn=Op.hasOwnProperty;var undefined$1;// More compressible than void 0.
var $Symbol=typeof Symbol==="function"?Symbol:{};var iteratorSymbol=$Symbol.iterator||"@@iterator";var asyncIteratorSymbol=$Symbol.asyncIterator||"@@asyncIterator";var toStringTagSymbol=$Symbol.toStringTag||"@@toStringTag";function define(obj,key,value){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});return obj[key];}try{// IE 8 has a broken Object.defineProperty that only works on DOM objects.
define({},"");}catch(err){define=function(obj,key,value){return obj[key]=value;};}function wrap(innerFn,outerFn,self,tryLocsList){// If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
var protoGenerator=outerFn&&outerFn.prototype instanceof Generator?outerFn:Generator;var generator=Object.create(protoGenerator.prototype);var context=new Context(tryLocsList||[]);// The ._invoke method unifies the implementations of the .next,
// .throw, and .return methods.
generator._invoke=makeInvokeMethod(innerFn,self,context);return generator;}exports.wrap=wrap;// Try/catch helper to minimize deoptimizations. Returns a completion
// record like context.tryEntries[i].completion. This interface could
// have been (and was previously) designed to take a closure to be
// invoked without arguments, but in all the cases we care about we
// already have an existing method we want to call, so there's no need
// to create a new function object. We can even get away with assuming
// the method takes exactly one argument, since that happens to be true
// in every case, so we don't have to touch the arguments object. The
// only additional allocation required is the completion record, which
// has a stable shape and so hopefully should be cheap to allocate.
function tryCatch(fn,obj,arg){try{return {type:"normal",arg:fn.call(obj,arg)};}catch(err){return {type:"throw",arg:err};}}var GenStateSuspendedStart="suspendedStart";var GenStateSuspendedYield="suspendedYield";var GenStateExecuting="executing";var GenStateCompleted="completed";// Returning this object from the innerFn has the same effect as
// breaking out of the dispatch switch statement.
var ContinueSentinel={};// Dummy constructor functions that we use as the .constructor and
// .constructor.prototype properties for functions that return Generator
// objects. For full spec compliance, you may wish to configure your
// minifier not to mangle the names of these two functions.
function Generator(){}function GeneratorFunction(){}function GeneratorFunctionPrototype(){}// This is a polyfill for %IteratorPrototype% for environments that
// don't natively support it.
var IteratorPrototype={};IteratorPrototype[iteratorSymbol]=function(){return this;};var getProto=Object.getPrototypeOf;var NativeIteratorPrototype=getProto&&getProto(getProto(values([])));if(NativeIteratorPrototype&&NativeIteratorPrototype!==Op&&hasOwn.call(NativeIteratorPrototype,iteratorSymbol)){// This environment has a native %IteratorPrototype%; use it instead
// of the polyfill.
IteratorPrototype=NativeIteratorPrototype;}var Gp=GeneratorFunctionPrototype.prototype=Generator.prototype=Object.create(IteratorPrototype);GeneratorFunction.prototype=Gp.constructor=GeneratorFunctionPrototype;GeneratorFunctionPrototype.constructor=GeneratorFunction;GeneratorFunction.displayName=define(GeneratorFunctionPrototype,toStringTagSymbol,"GeneratorFunction");// Helper for defining the .next, .throw, and .return methods of the
// Iterator interface in terms of a single ._invoke method.
function defineIteratorMethods(prototype){["next","throw","return"].forEach(function(method){define(prototype,method,function(arg){return this._invoke(method,arg);});});}exports.isGeneratorFunction=function(genFun){var ctor=typeof genFun==="function"&&genFun.constructor;return ctor?ctor===GeneratorFunction||// For the native GeneratorFunction constructor, the best we can
// do is to check its .name property.
(ctor.displayName||ctor.name)==="GeneratorFunction":false;};exports.mark=function(genFun){if(Object.setPrototypeOf){Object.setPrototypeOf(genFun,GeneratorFunctionPrototype);}else {genFun.__proto__=GeneratorFunctionPrototype;define(genFun,toStringTagSymbol,"GeneratorFunction");}genFun.prototype=Object.create(Gp);return genFun;};// Within the body of any async function, `await x` is transformed to
// `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
// `hasOwn.call(value, "__await")` to determine if the yielded value is
// meant to be awaited.
exports.awrap=function(arg){return {__await:arg};};function AsyncIterator(generator,PromiseImpl){function invoke(method,arg,resolve,reject){var record=tryCatch(generator[method],generator,arg);if(record.type==="throw"){reject(record.arg);}else {var result=record.arg;var value=result.value;if(value&&typeof value==="object"&&hasOwn.call(value,"__await")){return PromiseImpl.resolve(value.__await).then(function(value){invoke("next",value,resolve,reject);},function(err){invoke("throw",err,resolve,reject);});}return PromiseImpl.resolve(value).then(function(unwrapped){// When a yielded Promise is resolved, its final value becomes
// the .value of the Promise<{value,done}> result for the
// current iteration.
result.value=unwrapped;resolve(result);},function(error){// If a rejected Promise was yielded, throw the rejection back
// into the async generator function so it can be handled there.
return invoke("throw",error,resolve,reject);});}}var previousPromise;function enqueue(method,arg){function callInvokeWithMethodAndArg(){return new PromiseImpl(function(resolve,reject){invoke(method,arg,resolve,reject);});}return previousPromise=// If enqueue has been called before, then we want to wait until
// all previous Promises have been resolved before calling invoke,
// so that results are always delivered in the correct order. If
// enqueue has not been called before, then it is important to
// call invoke immediately, without waiting on a callback to fire,
// so that the async generator function has the opportunity to do
// any necessary setup in a predictable way. This predictability
// is why the Promise constructor synchronously invokes its
// executor callback, and why async functions synchronously
// execute code before the first await. Since we implement simple
// async functions in terms of async generators, it is especially
// important to get this right, even though it requires care.
previousPromise?previousPromise.then(callInvokeWithMethodAndArg,// Avoid propagating failures to Promises returned by later
// invocations of the iterator.
callInvokeWithMethodAndArg):callInvokeWithMethodAndArg();}// Define the unified helper method that is used to implement .next,
// .throw, and .return (see defineIteratorMethods).
this._invoke=enqueue;}defineIteratorMethods(AsyncIterator.prototype);AsyncIterator.prototype[asyncIteratorSymbol]=function(){return this;};exports.AsyncIterator=AsyncIterator;// Note that simple async functions are implemented on top of
// AsyncIterator objects; they just return a Promise for the value of
// the final result produced by the iterator.
exports.async=function(innerFn,outerFn,self,tryLocsList,PromiseImpl){if(PromiseImpl===void 0)PromiseImpl=Promise;var iter=new AsyncIterator(wrap(innerFn,outerFn,self,tryLocsList),PromiseImpl);return exports.isGeneratorFunction(outerFn)?iter// If outerFn is a generator, return the full iterator.
:iter.next().then(function(result){return result.done?result.value:iter.next();});};function makeInvokeMethod(innerFn,self,context){var state=GenStateSuspendedStart;return function invoke(method,arg){if(state===GenStateExecuting){throw new Error("Generator is already running");}if(state===GenStateCompleted){if(method==="throw"){throw arg;}// Be forgiving, per 25.3.3.3.3 of the spec:
// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
return doneResult();}context.method=method;context.arg=arg;while(true){var delegate=context.delegate;if(delegate){var delegateResult=maybeInvokeDelegate(delegate,context);if(delegateResult){if(delegateResult===ContinueSentinel)continue;return delegateResult;}}if(context.method==="next"){// Setting context._sent for legacy support of Babel's
// function.sent implementation.
context.sent=context._sent=context.arg;}else if(context.method==="throw"){if(state===GenStateSuspendedStart){state=GenStateCompleted;throw context.arg;}context.dispatchException(context.arg);}else if(context.method==="return"){context.abrupt("return",context.arg);}state=GenStateExecuting;var record=tryCatch(innerFn,self,context);if(record.type==="normal"){// If an exception is thrown from innerFn, we leave state ===
// GenStateExecuting and loop back for another invocation.
state=context.done?GenStateCompleted:GenStateSuspendedYield;if(record.arg===ContinueSentinel){continue;}return {value:record.arg,done:context.done};}else if(record.type==="throw"){state=GenStateCompleted;// Dispatch the exception by looping back around to the
// context.dispatchException(context.arg) call above.
context.method="throw";context.arg=record.arg;}}};}// Call delegate.iterator[context.method](context.arg) and handle the
// result, either by returning a { value, done } result from the
// delegate iterator, or by modifying context.method and context.arg,
// setting context.delegate to null, and returning the ContinueSentinel.
function maybeInvokeDelegate(delegate,context){var method=delegate.iterator[context.method];if(method===undefined$1){// A .throw or .return when the delegate iterator has no .throw
// method always terminates the yield* loop.
context.delegate=null;if(context.method==="throw"){// Note: ["return"] must be used for ES3 parsing compatibility.
if(delegate.iterator["return"]){// If the delegate iterator has a return method, give it a
// chance to clean up.
context.method="return";context.arg=undefined$1;maybeInvokeDelegate(delegate,context);if(context.method==="throw"){// If maybeInvokeDelegate(context) changed context.method from
// "return" to "throw", let that override the TypeError below.
return ContinueSentinel;}}context.method="throw";context.arg=new TypeError("The iterator does not provide a 'throw' method");}return ContinueSentinel;}var record=tryCatch(method,delegate.iterator,context.arg);if(record.type==="throw"){context.method="throw";context.arg=record.arg;context.delegate=null;return ContinueSentinel;}var info=record.arg;if(!info){context.method="throw";context.arg=new TypeError("iterator result is not an object");context.delegate=null;return ContinueSentinel;}if(info.done){// Assign the result of the finished delegate to the temporary
// variable specified by delegate.resultName (see delegateYield).
context[delegate.resultName]=info.value;// Resume execution at the desired location (see delegateYield).
context.next=delegate.nextLoc;// If context.method was "throw" but the delegate handled the
// exception, let the outer generator proceed normally. If
// context.method was "next", forget context.arg since it has been
// "consumed" by the delegate iterator. If context.method was
// "return", allow the original .return call to continue in the
// outer generator.
if(context.method!=="return"){context.method="next";context.arg=undefined$1;}}else {// Re-yield the result returned by the delegate method.
return info;}// The delegate iterator is finished, so forget it and continue with
// the outer generator.
context.delegate=null;return ContinueSentinel;}// Define Generator.prototype.{next,throw,return} in terms of the
// unified ._invoke helper method.
defineIteratorMethods(Gp);define(Gp,toStringTagSymbol,"Generator");// A Generator should always return itself as the iterator object when the
// @@iterator function is called on it. Some browsers' implementations of the
// iterator prototype chain incorrectly implement this, causing the Generator
// object to not be returned from this call. This ensures that doesn't happen.
// See https://github.com/facebook/regenerator/issues/274 for more details.
Gp[iteratorSymbol]=function(){return this;};Gp.toString=function(){return "[object Generator]";};function pushTryEntry(locs){var entry={tryLoc:locs[0]};if(1 in locs){entry.catchLoc=locs[1];}if(2 in locs){entry.finallyLoc=locs[2];entry.afterLoc=locs[3];}this.tryEntries.push(entry);}function resetTryEntry(entry){var record=entry.completion||{};record.type="normal";delete record.arg;entry.completion=record;}function Context(tryLocsList){// The root entry object (effectively a try statement without a catch
// or a finally block) gives us a place to store values thrown from
// locations where there is no enclosing try statement.
this.tryEntries=[{tryLoc:"root"}];tryLocsList.forEach(pushTryEntry,this);this.reset(true);}exports.keys=function(object){var keys=[];for(var key in object){keys.push(key);}keys.reverse();// Rather than returning an object with a next method, we keep
// things simple and return the next function itself.
return function next(){while(keys.length){var key=keys.pop();if(key in object){next.value=key;next.done=false;return next;}}// To avoid creating an additional object, we just hang the .value
// and .done properties off the next function object itself. This
// also ensures that the minifier will not anonymize the function.
next.done=true;return next;};};function values(iterable){if(iterable){var iteratorMethod=iterable[iteratorSymbol];if(iteratorMethod){return iteratorMethod.call(iterable);}if(typeof iterable.next==="function"){return iterable;}if(!isNaN(iterable.length)){var i=-1,next=function next(){while(++i<iterable.length){if(hasOwn.call(iterable,i)){next.value=iterable[i];next.done=false;return next;}}next.value=undefined$1;next.done=true;return next;};return next.next=next;}}// Return an iterator with no values.
return {next:doneResult};}exports.values=values;function doneResult(){return {value:undefined$1,done:true};}Context.prototype={constructor:Context,reset:function(skipTempReset){this.prev=0;this.next=0;// Resetting context._sent for legacy support of Babel's
// function.sent implementation.
this.sent=this._sent=undefined$1;this.done=false;this.delegate=null;this.method="next";this.arg=undefined$1;this.tryEntries.forEach(resetTryEntry);if(!skipTempReset){for(var name in this){// Not sure about the optimal order of these conditions:
if(name.charAt(0)==="t"&&hasOwn.call(this,name)&&!isNaN(+name.slice(1))){this[name]=undefined$1;}}}},stop:function(){this.done=true;var rootEntry=this.tryEntries[0];var rootRecord=rootEntry.completion;if(rootRecord.type==="throw"){throw rootRecord.arg;}return this.rval;},dispatchException:function(exception){if(this.done){throw exception;}var context=this;function handle(loc,caught){record.type="throw";record.arg=exception;context.next=loc;if(caught){// If the dispatched exception was caught by a catch block,
// then let that catch block handle the exception normally.
context.method="next";context.arg=undefined$1;}return !!caught;}for(var i=this.tryEntries.length-1;i>=0;--i){var entry=this.tryEntries[i];var record=entry.completion;if(entry.tryLoc==="root"){// Exception thrown outside of any try block that could handle
// it, so set the completion value of the entire function to
// throw the exception.
return handle("end");}if(entry.tryLoc<=this.prev){var hasCatch=hasOwn.call(entry,"catchLoc");var hasFinally=hasOwn.call(entry,"finallyLoc");if(hasCatch&&hasFinally){if(this.prev<entry.catchLoc){return handle(entry.catchLoc,true);}else if(this.prev<entry.finallyLoc){return handle(entry.finallyLoc);}}else if(hasCatch){if(this.prev<entry.catchLoc){return handle(entry.catchLoc,true);}}else if(hasFinally){if(this.prev<entry.finallyLoc){return handle(entry.finallyLoc);}}else {throw new Error("try statement without catch or finally");}}}},abrupt:function(type,arg){for(var i=this.tryEntries.length-1;i>=0;--i){var entry=this.tryEntries[i];if(entry.tryLoc<=this.prev&&hasOwn.call(entry,"finallyLoc")&&this.prev<entry.finallyLoc){var finallyEntry=entry;break;}}if(finallyEntry&&(type==="break"||type==="continue")&&finallyEntry.tryLoc<=arg&&arg<=finallyEntry.finallyLoc){// Ignore the finally entry if control is not jumping to a
// location outside the try/catch block.
finallyEntry=null;}var record=finallyEntry?finallyEntry.completion:{};record.type=type;record.arg=arg;if(finallyEntry){this.method="next";this.next=finallyEntry.finallyLoc;return ContinueSentinel;}return this.complete(record);},complete:function(record,afterLoc){if(record.type==="throw"){throw record.arg;}if(record.type==="break"||record.type==="continue"){this.next=record.arg;}else if(record.type==="return"){this.rval=this.arg=record.arg;this.method="return";this.next="end";}else if(record.type==="normal"&&afterLoc){this.next=afterLoc;}return ContinueSentinel;},finish:function(finallyLoc){for(var i=this.tryEntries.length-1;i>=0;--i){var entry=this.tryEntries[i];if(entry.finallyLoc===finallyLoc){this.complete(entry.completion,entry.afterLoc);resetTryEntry(entry);return ContinueSentinel;}}},"catch":function(tryLoc){for(var i=this.tryEntries.length-1;i>=0;--i){var entry=this.tryEntries[i];if(entry.tryLoc===tryLoc){var record=entry.completion;if(record.type==="throw"){var thrown=record.arg;resetTryEntry(entry);}return thrown;}}// The context.catch method must only be called with a location
// argument that corresponds to a known catch block.
throw new Error("illegal catch attempt");},delegateYield:function(iterable,resultName,nextLoc){this.delegate={iterator:values(iterable),resultName:resultName,nextLoc:nextLoc};if(this.method==="next"){// Deliberately forget the last sent value so that we don't
// accidentally pass it on to the delegate.
this.arg=undefined$1;}return ContinueSentinel;}};// Regardless of whether this script is executing as a CommonJS module
// or not, return the runtime object so that we can declare the variable
// regeneratorRuntime in the outer scope, which allows this module to be
// injected easily by `bin/regenerator --include-runtime script.js`.
return exports;}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
module.exports);try{regeneratorRuntime=runtime;}catch(accidentalStrictMode){// This module should not be running in strict mode, so the above
// assignment should always work unless something is misconfigured. Just
// in case runtime.js accidentally runs in strict mode, we can escape
// strict mode using a global Function call. This could conceivably fail
// if a Content Security Policy forbids using Function, but in that case
// the proper solution is to fix the accidental strict mode problem. If
// you've misconfigured your bundler to force strict mode and applied a
// CSP to forbid Function, and you're not willing to fix either of those
// problems, please detail your unique predicament in a GitHub issue.
Function("r","regeneratorRuntime = r")(runtime);}});var BackdropContainerStyle$1={position:"fixed",left:0,top:0,width:"100%",height:"100%",background:"rgba(0, 0, 0, 0.4)",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"flex-end",zIndex:1400};var inEffect$1=".web-share-fade{animation:simpleFade 0.5s;animation-fill-mode:both }@keyframes simpleFade{0%{opacity:0 }100%{opacity:1 }}.web-share-fade-in-up{animation:fadeInUp 0.5s;animation-fill-mode:both }@keyframes fadeInUp{0%{opacity:0;transform:translateY(20px) }100%{opacity:1;transform:translateY(0) }}";function Backdrop$1(_ref){var children=_ref.children,onClose=_ref.onClose;var handleOnClose=function handleOnClose(e){if(e.target===e.currentTarget){onClose(e);}};return/*#__PURE__*/React__default.createElement("div",{onClick:handleOnClose,className:"web-share-fade",style:BackdropContainerStyle$1},/*#__PURE__*/React__default.createElement("style",{children:inEffect$1}),children);}var externalOpen$1=function externalOpen(URL){return window.open(URL,"_blank","noopener");};var iconList$1={facebook:{path:/*#__PURE__*/React__default.createElement("path",{d:"M24 12a12 12 0 10-13.9 11.9v-8.4h-3V12h3V9.4c0-3 1.8-4.7 4.6-4.7l2.6.2v3h-1.5c-1.5 0-2 .9-2 1.8V12h3.4l-.5 3.5h-2.8v8.4A12 12 0 0024 12z"}),color:"#0076FB",e:function e(l){return externalOpen$1("https://www.facebook.com/sharer/sharer.php?u="+l);}},twitter:{path:/*#__PURE__*/React__default.createElement("path",{d:"M24 4.6a10 10 0 01-2.9.7 5 5 0 002.2-2.7c-1 .6-2 1-3.1 1.2a5 5 0 00-8.4 4.5A14 14 0 011.6 3.2 4.8 4.8 0 001 5.6a5 5 0 002.2 4.1 4.9 4.9 0 01-2.3-.6A5 5 0 005 14a5 5 0 01-2.2 0 5 5 0 004.6 3.5 9.9 9.9 0 01-6.1 2.1H0a14 14 0 007.6 2.2c9 0 14-7.5 14-14V7A10 10 0 0024 4.6z"}),color:"#1DA1F2",e:function e(l,t){return externalOpen$1("https://twitter.com/intent/tweet?text="+t+"&url="+l);}},whatsapp:{path:/*#__PURE__*/React__default.createElement("path",{d:"M17.5 14.4l-2-1c-.3 0-.5-.1-.7.2l-1 1.1c-.1.2-.3.3-.6.1s-1.3-.5-2.4-1.5a9 9 0 01-1.7-2c-.1-.3 0-.5.2-.6l.4-.6c.2-.1.2-.3.3-.5v-.5L9 7c-.2-.6-.4-.5-.6-.5h-.6c-.2 0-.5 0-.8.4-.2.3-1 1-1 2.5s1 2.8 1.2 3c.2.2 2.1 3.2 5.1 4.5l1.7.6a4 4 0 001.9.2c.5-.1 1.7-.8 2-1.5.2-.6.2-1.2.1-1.4l-.5-.3M12 21.8a9.9 9.9 0 01-5-1.4l-.4-.2-3.7 1 1-3.7-.2-.3a9.9 9.9 0 01-1.5-5.3 9.9 9.9 0 0116.8-7 9.8 9.8 0 013 7 9.9 9.9 0 01-10 9.9m8.4-18.3A11.8 11.8 0 0012.1 0 12 12 0 001.8 17.8L0 24l6.4-1.6a11.9 11.9 0 005.6 1.4 12 12 0 0012-11.9 11.8 11.8 0 00-3.5-8.4z"}),color:"#25D366",e:function e(l,t){return externalOpen$1("https://api.whatsapp.com/send?text="+t+" "+l);}},reddit:{path:/*#__PURE__*/React__default.createElement("path",{d:"M12 0A12 12 0 000 12a12 12 0 0012 12 12 12 0 0012-12A12 12 0 0012 0zm5.01 4.74c.69 0 1.25.56 1.25 1.25a1.25 1.25 0 01-2.5.06l-2.6-.55-.8 3.75c1.83.07 3.48.63 4.68 1.49.3-.31.73-.5 1.2-.5.97 0 1.76.8 1.76 1.76 0 .72-.43 1.33-1.01 1.61a3.11 3.11 0 01.04.52c0 2.7-3.13 4.87-7 4.87-3.88 0-7-2.17-7-4.87 0-.18 0-.36.04-.53A1.75 1.75 0 014.03 12a1.75 1.75 0 012.96-1.26 8.52 8.52 0 014.74-1.5l.89-4.17a.34.34 0 01.14-.2.35.35 0 01.24-.04l2.9.62a1.21 1.21 0 011.11-.7zM9.25 12a1.25 1.25 0 101.25 1.25c0-.69-.56-1.25-1.25-1.25zm5.5 0a1.25 1.25 0 000 2.5 1.25 1.25 0 000-2.5zm-5.47 3.99a.33.33 0 00-.23.1.33.33 0 000 .46c.84.84 2.49.91 2.96.91.48 0 2.1-.06 2.96-.91a.36.36 0 00.03-.47.33.33 0 00-.46 0c-.55.54-1.68.73-2.51.73-.83 0-1.98-.2-2.51-.73a.33.33 0 00-.24-.1z"}),color:"#FF4500",e:function e(l,t){return externalOpen$1("https://www.reddit.com/submit?url="+l+"&title="+t);}},telegram:{path:/*#__PURE__*/React__default.createElement("path",{d:"M23.91 3.79L20.3 20.84c-.25 1.21-.98 1.5-2 .94l-5.5-4.07-2.66 2.57c-.3.3-.55.56-1.1.56-.72 0-.6-.27-.84-.95L6.3 13.7.85 12c-1.18-.35-1.19-1.16.26-1.75l21.26-8.2c.97-.43 1.9.24 1.53 1.73z"}),color:"#0088CC",e:function e(l,t){return externalOpen$1("https://telegram.me/share/msg?url="+l+"&text="+t);}},linkedin:{path:/*#__PURE__*/React__default.createElement("path",{d:"M6.5 21.5h-5v-13h5v13zM4 6.5C2.5 6.5 1.5 5.3 1.5 4s1-2.4 2.5-2.4c1.6 0 2.5 1 2.6 2.5 0 1.4-1 2.5-2.6 2.5zm11.5 6c-1 0-2 1-2 2v7h-5v-13h5V10s1.6-1.5 4-1.5c3 0 5 2.2 5 6.3v6.7h-5v-7c0-1-1-2-2-2z"}),color:"#0073b1",e:function e(l,t,ti){return externalOpen$1("https://www.linkedin.com/shareArticle?mini=true&url="+l+"&title="+ti+"&summary="+t);}},mail:{path:/*#__PURE__*/React__default.createElement("path",{d:"M20 4H4a2 2 0 00-2 2v12c0 1.1.9 2 2 2h16a2 2 0 002-2V6a2 2 0 00-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"}),color:"#E53E3E",e:function e(l,t){return externalOpen$1("mailto:?body="+l+"&subject="+t);}},copy:{path:/*#__PURE__*/React__default.createElement("path",{d:"M16 1H4a2 2 0 00-2 2v14h2V3h12V1zm3 4H8a2 2 0 00-2 2v14c0 1.1.9 2 2 2h11a2 2 0 002-2V7a2 2 0 00-2-2zm0 16H8V7h11v14z"}),color:"#718096",e:function e(l){return navigator.clipboard.writeText(decodeURIComponent(l));}},vk:{path:/*#__PURE__*/React__default.createElement("path",{d:"M22.7 6.24c.16-.52 0-.9-.73-.9H19.5c-.62 0-.91.32-1.06.69 0 0-1.25 3.04-3.02 5.02-.57.57-.83.75-1.15.75-.15 0-.39-.18-.39-.7V6.24c0-.63-.17-.9-.69-.9H9.34c-.39 0-.62.29-.62.56 0 .59.88.72.97 2.4v3.6c0 .8-.14.95-.45.95-.84 0-2.86-3.06-4.06-6.56-.24-.68-.48-.96-1.1-.96H1.61c-.7 0-.85.33-.85.7 0 .65.84 3.88 3.88 8.14 2.03 2.92 4.9 4.5 7.5 4.5 1.55 0 1.75-.35 1.75-.96 0-2.78-.15-3.04.64-3.04.36 0 .99.18 2.44 1.58 1.67 1.67 1.95 2.42 2.88 2.42h2.45c.7 0 1.06-.35.85-1.05-.46-1.45-3.62-4.44-3.76-4.64-.36-.47-.26-.68 0-1.1 0 0 3-4.21 3.3-5.64Z"}),color:"#07f",e:function e(l,t,ti){return externalOpen$1("http://vk.com/share.php?url="+l+"&title="+ti+"&comment="+t);}},okru:{path:/*#__PURE__*/React__default.createElement("path",{d:"M13.6 16.4c1-.3 2-.7 2.8-1.2a1.5 1.5 0 0 0-1.5-2.5 6.3 6.3 0 0 1-6.7 0 1.5 1.5 0 1 0-1.5 2.5c.9.5 1.8 1 2.9 1.2L6.8 19a1.4 1.4 0 1 0 2 2l2.8-2.6 2.7 2.7a1.5 1.5 0 1 0 2-2l-2.7-2.8Zm-2-11.1a2 2 0 1 1 0 4.1 2 2 0 0 1 0-4.1Zm0 7a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z"}),color:"#e27e35",e:function e(l){return externalOpen$1("https://connect.ok.ru/dk?st.cmd=WidgetSharePreview&st.shareUrl="+l);}}};var PortalComponent$1=function PortalComponent(_ref){var children=_ref.children;var el=document.createElement("div");React__default.useEffect(function(){document.body.appendChild(el);return function(){document.body.removeChild(el);};},[el]);return/*#__PURE__*/createPortal(children,el);};var CloseStyle$1={background:"#edf2f7",cursor:"pointer",padding:"0.75rem",display:"block",width:"100%",border:0,fontSize:"1rem"};function CloseButton$1(_ref){var onClose=_ref.onClose,closeText=_ref.closeText;return/*#__PURE__*/React__default.createElement("button",{style:CloseStyle$1,"aria-label":"Close",type:"button",onClick:onClose},closeText||"Close");}var ShareHeader$1={padding:"1rem 1.25rem",fontSize:"1.25rem",fontWeight:600,paddingBottom:0};function Header$2(_ref){var title=_ref.title;return/*#__PURE__*/React__default.createElement("header",{style:ShareHeader$1},title);}var SocialIconStyle$1={width:"100%",height:"auto",cursor:"pointer",border:0,background:"#1A78F6",padding:"0.75rem",borderRadius:"0.5rem",fontSize:0};function Icon$1(_ref){var name=_ref.name,data=_ref.data,onClose=_ref.onClose,onClick=_ref.onClick;var _iconList$name=iconList$1[name],path=_iconList$name.path,_iconList$name$viewBo=_iconList$name.viewBox,viewBox=_iconList$name$viewBo===void 0?"0 0 24 24":_iconList$name$viewBo,color=_iconList$name.color,e=_iconList$name.e;var handleOnButtonClicked=function handleOnButtonClicked(){onClick&&onClick();// callback
e(encodeURIComponent(data.url),data.text,data.title);onClose();};return/*#__PURE__*/React__default.createElement("button",{onClick:handleOnButtonClicked,"aria-label":name,style:_extends$4({},SocialIconStyle$1,{background:color})},/*#__PURE__*/React__default.createElement("svg",{fill:"white",viewBox:viewBox},path));}var IconsContainer$1={maxWidth:"24rem",width:"90%",backgroundColor:"white",borderRadius:"0.5rem",borderBottomLeftRadius:0,borderBottomRightRadius:0};var IconsLisStyle$1={padding:"1.25rem",display:"grid",gridTemplateColumns:"repeat(4, 1fr)",gridGap:"1.25rem"};function SocialIcons$1(_ref){var onClose=_ref.onClose,sites=_ref.sites,data=_ref.data,closeText=_ref.closeText,onClick=_ref.onClick;return/*#__PURE__*/React__default.createElement("section",{role:"dialog","aria-modal":"true",className:"web-share-fade-in-up",style:IconsContainer$1},/*#__PURE__*/React__default.createElement(Header$2,{title:data.title}),/*#__PURE__*/React__default.createElement("div",{style:IconsLisStyle$1},sites.map(function(name){return/*#__PURE__*/React__default.createElement(Icon$1,{name:name,key:name,data:data,onClose:onClose,onClick:onClick});})),/*#__PURE__*/React__default.createElement(CloseButton$1,{onClose:onClose,closeText:closeText}));}function useDisclosure$1(isOpenDefault){if(isOpenDefault===void 0){isOpenDefault=false;}var _useState=useState(isOpenDefault),isOpen=_useState[0],setIsOpen=_useState[1];var onOpen=useCallback(function(){return setIsOpen(true);},[]);var onClose=useCallback(function(){return setIsOpen(false);},[]);var onToggle=useCallback(function(){return setIsOpen(function(state){return !state;});},[]);return {isOpen:isOpen,onOpen:onOpen,onClose:onClose,onToggle:onToggle};}var defaultSites$1=/*#__PURE__*/Object.keys(iconList$1).slice(0,8);var RWebShare$1=function RWebShare(_ref){var children=_ref.children,closeText=_ref.closeText,data=_ref.data,onClick=_ref.onClick,_ref$sites=_ref.sites,sites=_ref$sites===void 0?defaultSites$1:_ref$sites;var _useDisclosure=useDisclosure$1(),onOpen=_useDisclosure.onOpen,onClose=_useDisclosure.onClose,isOpen=_useDisclosure.isOpen;var shareData=useMemo(function(){return _extends$4({},data,{title:data.title||"share",text:data.text||"",url:data.url||typeof window!=="undefined"&&window.location.href||""});},[data]);var handleOnClick=/*#__PURE__*/function(){var _ref2=_asyncToGenerator$1(/*#__PURE__*/runtime_1$1.mark(function _callee(){return runtime_1$1.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!window.navigator.share){_context.next=12;break;}_context.prev=1;_context.next=4;return window.navigator.share(shareData);case 4:onClick();_context.next=10;break;case 7:_context.prev=7;_context.t0=_context["catch"](1);console.warn(_context.t0);case 10:_context.next=13;break;case 12:onOpen();case 13:case"end":return _context.stop();}}},_callee,null,[[1,7]]);}));return function handleOnClick(){return _ref2.apply(this,arguments);};}();return/*#__PURE__*/React__default.createElement(React__default.Fragment,null,/*#__PURE__*/cloneElement(children,_extends$4({},children==null?void 0:children.props,{onClick:handleOnClick})),isOpen&&/*#__PURE__*/React__default.createElement(PortalComponent$1,null,/*#__PURE__*/React__default.createElement(Backdrop$1,{onClose:onClose},/*#__PURE__*/React__default.createElement(SocialIcons$1,{onClose:onClose,sites:sites,data:shareData,closeText:closeText,onClick:onClick}))));};function classNames$1(...classes){return classes.filter(Boolean).join(" ");}function Setlist({items,imageUrl,title,subTitle,sortedBy,cached,cacheProgress,onNewSession,onUpload,onShareSetlist,showShare,generateShareUrlCallback,onDownloadSetlist,onDeleteSetlist,onGoToLibrary,showDownloadButton,emptyLinkComponent,showRenameSession,showStats,type,size,showHeader,...props}){const[generatedShareUrl,setGeneratedShareUrl]=useState(null);useEffect(()=>{if(generatedShareUrl)setTimeout(()=>{const shareTrigger=document.getElementById('trigger-share');shareTrigger.click();},500);},[generatedShareUrl]);const requestShareUrl=async()=>{try{const generatedUrl=await generateShareUrlCallback();setGeneratedShareUrl(generatedUrl);}catch(e){console.error(e);}};const handleSetlistShared=()=>{setGeneratedShareUrl(null);onShareSetlist();};return/*#__PURE__*/React__default.createElement("div",{className:"h-full"},showHeader&&/*#__PURE__*/React__default.createElement("div",{className:"overflow-hidden mt-4 mb-4"},/*#__PURE__*/React__default.createElement("h2",{className:"sr-only",id:"profile-overview-title"},"Setlist"),/*#__PURE__*/React__default.createElement("div",{className:"pl-4 pr-4"},/*#__PURE__*/React__default.createElement("div",{className:"sm:flex sm:items-start justify-between"},/*#__PURE__*/React__default.createElement("div",{className:"sm:flex sm:space-x-5"},/*#__PURE__*/React__default.createElement("div",{className:"flex-shrink-0"},/*#__PURE__*/React__default.createElement("img",{className:"object-cover mx-auto h-60 w-60 rounded-md",src:imageUrl,alt:""})),/*#__PURE__*/React__default.createElement("div",{className:"mt-4 text-center sm:mt-0 sm:pt-1 sm:text-left"},/*#__PURE__*/React__default.createElement("h2",{className:"font-bold text-secondary-900 dark:text-white text-2xl sm:text-2xl md:text-4xl"},title),/*#__PURE__*/React__default.createElement("h3",{className:"text-xl sm:text-2xl md:text-3xl font-medium text-secondary-900 dark:text-white"},subTitle),!cached&&cacheProgress!==null&&/*#__PURE__*/React__default.createElement("div",{className:"mt-4"},/*#__PURE__*/React__default.createElement(VolumeBar,{colour:"var(--theme-primary-color)",percentage:cacheProgress*100}),/*#__PURE__*/React__default.createElement("p",{className:"text-sm font-medium text-secondary-900 dark:text-white"},(cacheProgress*100).toFixed(0),"% downloaded...")))),/*#__PURE__*/React__default.createElement("div",{className:"mt-5 flex flex-col space-y-4 flex-start sm:mt-0"},generatedShareUrl&&showShare&&/*#__PURE__*/React__default.createElement(RWebShare$1,{data:{text:`Listen to my ChoirPlayer ${title} setlist`,url:generatedShareUrl,title:`Share your ${title} setlist`},onClick:handleSetlistShared},/*#__PURE__*/React__default.createElement(Button,{id:"trigger-share",size:"sm",type:"primary"},"Share setlist")),!generatedShareUrl&&showShare&&/*#__PURE__*/React__default.createElement(Button,{onClick:requestShareUrl,size:"sm",type:"primary"},"Share setlist"),/*#__PURE__*/React__default.createElement(Button,{size:"sm",type:"primary",onClick:onDeleteSetlist},"Delete setlist"),/*#__PURE__*/React__default.createElement(we$3.Group,{as:"div",className:`flex items-center justify-between ${items.length?'':'opacity-40 pointer-events-none'}`},/*#__PURE__*/React__default.createElement("span",{className:"flex-grow flex flex-col"},/*#__PURE__*/React__default.createElement(we$3.Label,{as:"span",className:"text-sm font-medium text-secondary-900 dark:text-white mr-2",passive:true},"Available offline")),/*#__PURE__*/React__default.createElement(we$3,{checked:cached,onChange:onDownloadSetlist,className:classNames$1(cached?"bg-primary":"bg-gray-200","relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200")},/*#__PURE__*/React__default.createElement("span",{className:"sr-only"},"Download setlist"),/*#__PURE__*/React__default.createElement("span",{className:classNames$1(cached?"translate-x-5":"translate-x-0","pointer-events-none relative inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200")},/*#__PURE__*/React__default.createElement("span",{className:classNames$1(cached?"opacity-0 ease-out duration-100":"opacity-100 ease-in duration-200","absolute inset-0 h-full w-full flex items-center justify-center transition-opacity"),"aria-hidden":"true"},/*#__PURE__*/React__default.createElement("svg",{className:"h-3 w-3 text-gray-400",fill:"none",viewBox:"0 0 12 12"},/*#__PURE__*/React__default.createElement("path",{d:"M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2",stroke:"currentColor",strokeWidth:2,strokeLinecap:"round",strokeLinejoin:"round"}))),/*#__PURE__*/React__default.createElement("span",{className:classNames$1(cached?"opacity-100 ease-in duration-200":"opacity-0 ease-out duration-100","absolute inset-0 h-full w-full flex items-center justify-center transition-opacity"),"aria-hidden":"true"},/*#__PURE__*/React__default.createElement("svg",{className:"h-3 w-3 text-primary",fill:"currentColor",viewBox:"0 0 12 12"},/*#__PURE__*/React__default.createElement("path",{d:"M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z"})))))))))),items.length===0&&/*#__PURE__*/React__default.createElement("div",{className:"grid grid-cols-1 gap-4 px-2 py-2 sm:grid-cols-1"},/*#__PURE__*/React__default.createElement("div",{className:"dark:text-secondary-300 px-6 py-5 flex flex-col items-center space-x-3 space-y-3"},/*#__PURE__*/React__default.createElement(RectangleStackIcon$1,{className:"w-20 h-20"}),/*#__PURE__*/React__default.createElement("h2",null,"You have not added any songs to this setlist yet."),emptyLinkComponent)),items.length>0&&/*#__PURE__*/React__default.createElement(SongList,{items:items,hideSearch:true,hideFilters:true}));}Setlist.propTypes={items:SongList.propTypes.items,title:PropTypes.string,subTitle:PropTypes.string,imageUrl:PropTypes.string,sortedBy:SongList.propTypes.sortedBy,type:PropTypes.oneOf(["default"]),// Would be better to use Object.keys but it won't work with Storybook currently
size:PropTypes.oneOf(["base"]),onUpload:PropTypes.func,onDownloadSetlist:PropTypes.func,onDeleteSetlist:PropTypes.func,onShareSetlist:PropTypes.func,generateShareUrlCallback:PropTypes.func,showDownloadButton:PropTypes.bool,showTrackNumbers:PropTypes.bool,showRenameSession:PropTypes.bool,showStats:PropTypes.bool,showShare:PropTypes.bool,showHeader:PropTypes.bool,cached:PropTypes.bool,cacheProgress:PropTypes.number};Setlist.defaultProps={imageUrl:"https://images.unsplash.com/photo-1582053433976-25c00369fc93?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=512&h=512&q=80",title:"Title",subTitle:"Subtitle",type:"default",size:"base",showDownloadButton:false,onShareSetlist:undefined,generateShareUrlCallback:()=>{return new Promise((resolve,reject)=>{setTimeout(()=>resolve("default prop generated for url"),200);});},onDownloadSetlist:undefined,onDeleteSetlist:undefined,showRenameSession:true,showStats:true,showShare:false,showHeader:false,cacheProgress:null};var AddNewhumbnail='data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMzAwbW0iIGhlaWdodD0iMzAwbW0iIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwIDMwMCAzMDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHg9Ii0xMi44NTEiIHk9Ii0xNy43NjUiIHdpZHRoPSIzMjIuMDQiIGhlaWdodD0iMzIyLjc5IiBmaWxsPSIjNGQ0ZDRkIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0b3AtY29sb3I9IiMwMDAwMDAiIHN0cm9rZS13aWR0aD0iLjMzNjM4IiBzdHlsZT0iZm9udC12YXJpYXRpb24tc2V0dGluZ3M6bm9ybWFsIi8+CjxnIHRyYW5zZm9ybT0ibWF0cml4KC41NTU0MSAwIDAgLjU1NTQxIDE0Ny4wMyAxNDYuMjgpIiBmaWxsPSIjYjNiM2IzIj4KPGcgdHJhbnNmb3JtPSJtYXRyaXgoMy44OSwwLDAsMy44OSwtMTc1LjA1LC0xNzUuMDUpIiBmaWxsPSIjYjNiM2IzIiBzdHJva2UtbGluZWNhcD0icm91bmQiPgo8cGF0aCBkPSJtNTguOTIxIDkwaC0yNy44NDJjLTEuMTU1IDAtMi4wOTItMC45MzYtMi4wOTItMi4wOTJ2LTg1LjgxNmMxZS0zIC0xLjE1NiAwLjkzNy0yLjA5MiAyLjA5Mi0yLjA5MmgyNy44NDFjMS4xNTUgMCAyLjA5MiAwLjkzNiAyLjA5MiAyLjA5MnY4NS44MTdjMCAxLjE1NS0wLjkzNiAyLjA5MS0yLjA5MSAyLjA5MXoiLz4KPHBhdGggZD0ibTkwIDMxLjA3OXYyNy44NDFjMCAxLjE1NS0wLjkzNiAyLjA5Mi0yLjA5MiAyLjA5MmgtODUuODE2Yy0xLjE1NiAwLTIuMDkyLTAuOTM2LTIuMDkyLTIuMDkxdi0yNy44NDJjMC0xLjE1NSAwLjkzNi0yLjA5MiAyLjA5Mi0yLjA5Mmg4NS44MTdjMS4xNTUgMWUtMyAyLjA5MSAwLjkzNyAyLjA5MSAyLjA5MnoiLz4KPC9nPgo8L2c+Cjwvc3ZnPg==';function SetlistItem({title,subTitle,imageUrl,onAction,type,size,...props}){return/*#__PURE__*/React__default.createElement("li",{key:title,className:"relative",onClick:onAction},/*#__PURE__*/React__default.createElement("div",{className:"group block w-full aspect-w-7 aspect-h-7 rounded-lg bg-gray-100 overflow-hidden"},/*#__PURE__*/React__default.createElement("img",{src:imageUrl,alt:`${title} thumbnail`,className:"object-cover pointer-events-none group-hover:opacity-75"}),/*#__PURE__*/React__default.createElement("button",{type:"button",className:"absolute inset-0 focus:outline-none"},/*#__PURE__*/React__default.createElement("span",{className:"sr-only"},"Open ",title))),/*#__PURE__*/React__default.createElement("p",{className:"mt-2 block text-sm font-medium text-secondary dark:text-white truncate pointer-events-none"},title),/*#__PURE__*/React__default.createElement("p",{className:"block text-sm font-medium text-secondary dark:text-white pointer-events-none"},subTitle));}SetlistItem.propTypes={title:PropTypes.string,subTitle:PropTypes.string,imageUrl:PropTypes.string,onAction:PropTypes.func};SetlistItem.defaultProps={title:"",subTitle:"",imageUrl:"https://s3.eu-west-1.amazonaws.com/uploads.choirplayer.com/images/45d42654-2662-4c43-b39e-09fd83409e34-283166014_1172442506849533_3585767394209259127_n.jpeg",onAction:undefined};function Setlists({items,sortedBy,onNewSession,onUpload,onDownloadSetlist,onCreateNewSetlist,onGoToLibrary,onSelectSetlist,showDownloadButton,emptyLinkComponent,showRenameSession,showStats,type,size,...props}){// Create a reference to the hidden file input element
useRef(null);useState(false);useState("");const handleCreateNewPlaylist=()=>{onCreateNewSetlist();};return/*#__PURE__*/React__default.createElement("div",{className:"h-full"},/*#__PURE__*/React__default.createElement("ul",{role:"list",className:"mt-2 grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 sm:gap-x-6 lg:grid-cols-6 xl:gap-x-8"},/*#__PURE__*/React__default.createElement(SetlistItem,{title:"Create new setlist",imageUrl:AddNewhumbnail,subTitle:"",onAction:handleCreateNewPlaylist}),items.map(setlist=>/*#__PURE__*/React__default.createElement(SetlistItem,{title:setlist.title,imageUrl:setlist.imageUrl,subTitle:"",onAction:()=>onSelectSetlist(setlist.id)}))));}Setlists.propTypes={items:SetlistItem.propTypes.items,onUpload:PropTypes.func,onDownloadSetlist:PropTypes.func,onSelectSetlist:PropTypes.func,showDownloadButton:PropTypes.bool,showRenameSession:PropTypes.bool,onCreateNewSetlist:PropTypes.func,showStats:PropTypes.bool};Setlists.defaultProps={type:"default",size:"base",onSelectSetlist:undefined,onCreateNewSetlist:undefined,showDownloadButton:false,showRenameSession:true,showStats:true,showTopLibraryLink:true};function classNames(...classes){return classes.filter(Boolean).join(' ');}const SelectionInput=({items,itemSelected,promptText,onChange})=>{return/*#__PURE__*/React__default.createElement(It,{value:itemSelected,onChange:onChange},({open})=>/*#__PURE__*/React__default.createElement(React__default.Fragment,null,/*#__PURE__*/React__default.createElement(It.Label,{className:"block text-sm font-medium text-gray-700"}),/*#__PURE__*/React__default.createElement("div",{className:"mt-1 relative"},/*#__PURE__*/React__default.createElement(It.Button,{className:"relative w-full bg-white border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default sm:text-sm"},itemSelected&&/*#__PURE__*/React__default.createElement("span",{className:"flex items-center"},/*#__PURE__*/React__default.createElement("img",{src:itemSelected.avatar,alt:"",className:"flex-shrink-0 h-6 w-6 rounded-md"}),/*#__PURE__*/React__default.createElement("span",{className:"ml-3 block truncate"},itemSelected.name)),!itemSelected&&/*#__PURE__*/React__default.createElement("span",{className:"flex items-center h-6"},/*#__PURE__*/React__default.createElement("span",{className:"text-gray-400"},promptText)),/*#__PURE__*/React__default.createElement("span",{className:"flex items-center"}),/*#__PURE__*/React__default.createElement("span",{className:"ml-3 absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none"},/*#__PURE__*/React__default.createElement(ChevronUpDownIcon$1,{className:"h-5 w-5 text-gray-400","aria-hidden":"true"}))),/*#__PURE__*/React__default.createElement(qe$4,{show:open,as:Fragment,leave:"transition ease-in duration-100",leaveFrom:"opacity-100",leaveTo:"opacity-0"},/*#__PURE__*/React__default.createElement(It.Options,{className:"absolute z-10 mt-1 w-full bg-white shadow-lg max-h-56 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm"},items.map(item=>/*#__PURE__*/React__default.createElement(It.Option,{key:item.id,className:({active})=>classNames(active?'text-white bg-primary':'text-gray-900','cursor-default select-none relative py-2 pl-3 pr-9 w-full'),value:item},({selected,active})=>/*#__PURE__*/React__default.createElement(React__default.Fragment,null,/*#__PURE__*/React__default.createElement("div",{className:"flex items-center"},/*#__PURE__*/React__default.createElement("img",{src:item.avatar,alt:"",className:"flex-shrink-0 h-9 w-9 rounded-md"}),/*#__PURE__*/React__default.createElement("span",{className:classNames(selected?'font-semibold':'font-normal','ml-3 block truncate')},item.name)),selected?/*#__PURE__*/React__default.createElement("span",{className:classNames(active?'text-white':'text-primary','absolute inset-y-0 right-0 flex items-center pr-4')},/*#__PURE__*/React__default.createElement(CheckIcon$1,{className:"h-5 w-5","aria-hidden":"true"})):null))))))));};SelectionInput.propTypes={onClick:PropTypes.func,items:PropTypes.array,itemSelected:PropTypes.object,promptText:PropTypes.string};SelectionInput.defaultProps={onClick:undefined,promptText:"Make selection..."};({dark:PropTypes.bool,level:PropTypes.number.isRequired,step:PropTypes.number,vertical:PropTypes.bool,onChange:PropTypes.func,type:PropTypes.oneOf(["default"]),// Would be better to use Object.keys but it won't work with Storybook currently
size:PropTypes.oneOf(["base","sm"])});({genres:PropTypes.arrayOf(PropTypes.string),keySignatures:PropTypes.arrayOf(PropTypes.string),decades:PropTypes.arrayOf(PropTypes.string),onClick:PropTypes.func,onFilter:PropTypes.func,searchValue:Input.propTypes.value,onSearch:Input.propTypes.onChange,type:PropTypes.oneOf(["default"]),// Would be better to use Object.keys but it won't work with Storybook currently
size:PropTypes.oneOf(["base"])});

async function loginUser(endpoint, username, password) {
  if (username && password) {
    const loginParams = {
      username64: encodeURIComponent(btoa(username)),
      password64: encodeURIComponent(btoa(password))
    };
    const urlParams = new URLSearchParams(loginParams);
    const requestString = `${endpoint}?${urlParams.toString()}`;
    const response = await fetch(requestString);
    const result = await response.json();
    if (response.status === 200) {
      if (result.status === 'ok') {
        return {
          data: result.user.data
        };
      } else if (result.status === 'error') {
        throw new Error(result.error);
      }
    } else {
      throw new Error('Login error occurred');
    }
  } else {
    if (!username) throw new Error('Please provide a username');
    if (!password) throw new Error('Please provide a password to login');
  }
}
async function checkSubscription(endpoint, session_id) {
  const response = await fetch(`${endpoint}${session_id}`);
  const result = await response.json();
  if (response.status === 200) {
    return {
      userName: result.user_email,
      subscribed: result.user_role === "1" ? true : false
    };
  } else {
    throw new Error("Error fetching subscription");
  }
}

const initialState$a = {
  user: null,
  credentials: null,
  status: 'initial',
  errorMessage: null
};

// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched. Thunks are
// typically used to make async requests.
const loginUserAsync = createAsyncThunk('auth/loginUser', async (creds, thunkAPI) => {
  const endpoint = thunkAPI.getState().ui.clientConfig.features.auth.endpoint;
  const response = await loginUser(endpoint, creds.username, creds.password);
  // The value we return becomes the `fulfilled` action payload
  return {
    user: response.data,
    credentials: creds
  };
});
const setSubscribedAsync = createAsyncThunk('auth/checkSubscription', async (payload, thunkAPI) => {
  const endpoint = thunkAPI.getState().ui.clientConfig.features.auth.domainCookie.userInfoUrl;
  const response = await checkSubscription(endpoint, payload);
  // The value we return becomes the `fulfilled` action payload
  return response;
});

// config.INITIAL_AUTH_STATE ? config.INITIAL_AUTH_STATE : 

const authSlice = createSlice({
  name: 'auth',
  initialState: initialState$a,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    logout: (state, action) => {
      if (action.payload?.user) {
        state.user = action.payload.user;
      } else {
        state.user = null;
      }
      state.credentials = null;
      state.errorMessage = null;
      state.status = 'fulfilled';
    },
    setAuth: (state, action) => {
      state.status = action.payload.status;
      state.errorMessage = action.payload.errorMessage;
      state.credentials = action.payload.credentials;
      state.user = action.payload.user;
    }
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: builder => {
    builder.addCase(loginUserAsync.pending, state => {
      state.status = 'pending';
      state.errorMessage = null;
    }).addCase(loginUserAsync.rejected, (state, action) => {
      state.status = 'rejected';
      state.errorMessage = action.error.message;
      state.user = null;
    }).addCase(loginUserAsync.fulfilled, (state, action) => {
      state.status = 'fulfilled';
      state.errorMessage = null;
      state.credentials = action.payload.credentials;
      state.user = action.payload.user;
    }).addCase(setSubscribedAsync.pending, state => {
      state.status = 'pending';
      state.errorMessage = null;
    }).addCase(setSubscribedAsync.rejected, (state, action) => {
      console.log(action);
      state.status = 'rejected';
      // state.errorMessage = action.error.message;
      // state.user = null;
    }).addCase(setSubscribedAsync.fulfilled, (state, action) => {
      console.log(action.payload);
      state.status = 'fulfilled';
      if (!state.user) state.user = {};
      state.user.subscribed = action.payload.subscribed ? true : false;
      state.user.displayName = action.payload.userName;
      state.user.guest = false;
      console.log('subscibed call fulfilled', action);
    });
  }
});
const {
  logout,
  setAuth
} = authSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
const selectUser = (state, thunkAPI) => {
  return state.auth.user;
};
const selectStatus$1 = state => state.auth.status;
const selectErrorMessage = state => state.auth.errorMessage;

// // We can also write thunks by hand, which may contain both sync and async logic.
// // Here's an example of conditionally dispatching actions based on current state.
// export const incrementIfOdd = (amount) => (dispatch, getState) => {
//   const currentValue = selectCount(getState());
//   if (currentValue % 2 === 1) {
//     dispatch(incrementByAmount(amount));
//   }
// };

var authReducer = authSlice.reducer;

/*
 Copyright (c) 2022 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright 
 notice, this list of conditions and the following disclaimer in 
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */

/*
 * This program is based on JZlib 1.0.2 ymnk, JCraft,Inc.
 * JZlib is based on zlib-1.1.3, so all credit should go authors
 * Jean-loup Gailly(jloup@gzip.org) and Mark Adler(madler@alumni.caltech.edu)
 * and contributors of zlib.
 */

// deno-lint-ignore-file no-this-alias prefer-const

// Global

const MAX_BITS$1 = 15;
const D_CODES = 30;
const BL_CODES = 19;
const LENGTH_CODES = 29;
const LITERALS = 256;
const L_CODES = LITERALS + 1 + LENGTH_CODES;
const HEAP_SIZE = 2 * L_CODES + 1;
const END_BLOCK = 256;

// Bit length codes must not exceed MAX_BL_BITS bits
const MAX_BL_BITS = 7;

// repeat previous bit length 3-6 times (2 bits of repeat count)
const REP_3_6 = 16;

// repeat a zero length 3-10 times (3 bits of repeat count)
const REPZ_3_10 = 17;

// repeat a zero length 11-138 times (7 bits of repeat count)
const REPZ_11_138 = 18;

// The lengths of the bit length codes are sent in order of decreasing
// probability, to avoid transmitting the lengths for unused bit
// length codes.

const Buf_size = 8 * 2;

// JZlib version : "1.0.2"
const Z_DEFAULT_COMPRESSION = -1;

// compression strategy
const Z_FILTERED = 1;
const Z_HUFFMAN_ONLY = 2;
const Z_DEFAULT_STRATEGY = 0;
const Z_NO_FLUSH$1 = 0;
const Z_PARTIAL_FLUSH = 1;
const Z_FULL_FLUSH = 3;
const Z_FINISH$1 = 4;
const Z_OK$1 = 0;
const Z_STREAM_END$1 = 1;
const Z_NEED_DICT$1 = 2;
const Z_STREAM_ERROR$1 = -2;
const Z_DATA_ERROR$1 = -3;
const Z_BUF_ERROR$1 = -5;

// Tree

function extractArray(array) {
  return flatArray(array.map(([length, value]) => new Array(length).fill(value, 0, length)));
}
function flatArray(array) {
  return array.reduce((a, b) => a.concat(Array.isArray(b) ? flatArray(b) : b), []);
}

// see definition of array dist_code below
const _dist_code = [0, 1, 2, 3].concat(...extractArray([[2, 4], [2, 5], [4, 6], [4, 7], [8, 8], [8, 9], [16, 10], [16, 11], [32, 12], [32, 13], [64, 14], [64, 15], [2, 0], [1, 16], [1, 17], [2, 18], [2, 19], [4, 20], [4, 21], [8, 22], [8, 23], [16, 24], [16, 25], [32, 26], [32, 27], [64, 28], [64, 29]]));
function Tree() {
  const that = this;

  // dyn_tree; // the dynamic tree
  // max_code; // largest code with non zero frequency
  // stat_desc; // the corresponding static tree

  // Compute the optimal bit lengths for a tree and update the total bit
  // length
  // for the current block.
  // IN assertion: the fields freq and dad are set, heap[heap_max] and
  // above are the tree nodes sorted by increasing frequency.
  // OUT assertions: the field len is set to the optimal bit length, the
  // array bl_count contains the frequencies for each bit length.
  // The length opt_len is updated; static_len is also updated if stree is
  // not null.
  function gen_bitlen(s) {
    const tree = that.dyn_tree;
    const stree = that.stat_desc.static_tree;
    const extra = that.stat_desc.extra_bits;
    const base = that.stat_desc.extra_base;
    const max_length = that.stat_desc.max_length;
    let h; // heap index
    let n, m; // iterate over the tree elements
    let bits; // bit length
    let xbits; // extra bits
    let f; // frequency
    let overflow = 0; // number of elements with bit length too large

    for (bits = 0; bits <= MAX_BITS$1; bits++) s.bl_count[bits] = 0;

    // In a first pass, compute the optimal bit lengths (which may
    // overflow in the case of the bit length tree).
    tree[s.heap[s.heap_max] * 2 + 1] = 0; // root of the heap

    for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
      n = s.heap[h];
      bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
      if (bits > max_length) {
        bits = max_length;
        overflow++;
      }
      tree[n * 2 + 1] = bits;
      // We overwrite tree[n*2+1] which is no longer needed

      if (n > that.max_code) continue; // not a leaf node

      s.bl_count[bits]++;
      xbits = 0;
      if (n >= base) xbits = extra[n - base];
      f = tree[n * 2];
      s.opt_len += f * (bits + xbits);
      if (stree) s.static_len += f * (stree[n * 2 + 1] + xbits);
    }
    if (overflow === 0) return;

    // This happens for example on obj2 and pic of the Calgary corpus
    // Find the first bit length which could increase:
    do {
      bits = max_length - 1;
      while (s.bl_count[bits] === 0) bits--;
      s.bl_count[bits]--; // move one leaf down the tree
      s.bl_count[bits + 1] += 2; // move one overflow item as its brother
      s.bl_count[max_length]--;
      // The brother of the overflow item also moves one step up,
      // but this does not affect bl_count[max_length]
      overflow -= 2;
    } while (overflow > 0);
    for (bits = max_length; bits !== 0; bits--) {
      n = s.bl_count[bits];
      while (n !== 0) {
        m = s.heap[--h];
        if (m > that.max_code) continue;
        if (tree[m * 2 + 1] != bits) {
          s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2];
          tree[m * 2 + 1] = bits;
        }
        n--;
      }
    }
  }

  // Reverse the first len bits of a code, using straightforward code (a
  // faster
  // method would use a table)
  // IN assertion: 1 <= len <= 15
  function bi_reverse(code,
  // the value to invert
  len // its bit length
  ) {
    let res = 0;
    do {
      res |= code & 1;
      code >>>= 1;
      res <<= 1;
    } while (--len > 0);
    return res >>> 1;
  }

  // Generate the codes for a given tree and bit counts (which need not be
  // optimal).
  // IN assertion: the array bl_count contains the bit length statistics for
  // the given tree and the field len is set for all tree elements.
  // OUT assertion: the field code is set for all tree elements of non
  // zero code length.
  function gen_codes(tree,
  // the tree to decorate
  max_code,
  // largest code with non zero frequency
  bl_count // number of codes at each bit length
  ) {
    const next_code = []; // next code value for each
    // bit length
    let code = 0; // running code value
    let bits; // bit index
    let n; // code index
    let len;

    // The distribution counts are first used to generate the code values
    // without bit reversal.
    for (bits = 1; bits <= MAX_BITS$1; bits++) {
      next_code[bits] = code = code + bl_count[bits - 1] << 1;
    }

    // Check that the bit counts in bl_count are consistent. The last code
    // must be all ones.
    // Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
    // "inconsistent bit counts");
    // Tracev((stderr,"gen_codes: max_code %d ", max_code));

    for (n = 0; n <= max_code; n++) {
      len = tree[n * 2 + 1];
      if (len === 0) continue;
      // Now reverse the bits
      tree[n * 2] = bi_reverse(next_code[len]++, len);
    }
  }

  // Construct one Huffman tree and assigns the code bit strings and lengths.
  // Update the total bit length for the current block.
  // IN assertion: the field freq is set for all tree elements.
  // OUT assertions: the fields len and code are set to the optimal bit length
  // and corresponding code. The length opt_len is updated; static_len is
  // also updated if stree is not null. The field max_code is set.
  that.build_tree = function (s) {
    const tree = that.dyn_tree;
    const stree = that.stat_desc.static_tree;
    const elems = that.stat_desc.elems;
    let n, m; // iterate over heap elements
    let max_code = -1; // largest code with non zero frequency
    let node; // new node being created

    // Construct the initial heap, with least frequent element in
    // heap[1]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
    // heap[0] is not used.
    s.heap_len = 0;
    s.heap_max = HEAP_SIZE;
    for (n = 0; n < elems; n++) {
      if (tree[n * 2] !== 0) {
        s.heap[++s.heap_len] = max_code = n;
        s.depth[n] = 0;
      } else {
        tree[n * 2 + 1] = 0;
      }
    }

    // The pkzip format requires that at least one distance code exists,
    // and that at least one bit should be sent even if there is only one
    // possible code. So to avoid special checks later on we force at least
    // two codes of non zero frequency.
    while (s.heap_len < 2) {
      node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
      tree[node * 2] = 1;
      s.depth[node] = 0;
      s.opt_len--;
      if (stree) s.static_len -= stree[node * 2 + 1];
      // node is 0 or 1 so it does not have extra bits
    }
    that.max_code = max_code;

    // The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
    // establish sub-heaps of increasing lengths:

    for (n = Math.floor(s.heap_len / 2); n >= 1; n--) s.pqdownheap(tree, n);

    // Construct the Huffman tree by repeatedly combining the least two
    // frequent nodes.

    node = elems; // next internal node of the tree
    do {
      // n = node of least frequency
      n = s.heap[1];
      s.heap[1] = s.heap[s.heap_len--];
      s.pqdownheap(tree, 1);
      m = s.heap[1]; // m = node of next least frequency

      s.heap[--s.heap_max] = n; // keep the nodes sorted by frequency
      s.heap[--s.heap_max] = m;

      // Create a new node father of n and m
      tree[node * 2] = tree[n * 2] + tree[m * 2];
      s.depth[node] = Math.max(s.depth[n], s.depth[m]) + 1;
      tree[n * 2 + 1] = tree[m * 2 + 1] = node;

      // and insert the new node in the heap
      s.heap[1] = node++;
      s.pqdownheap(tree, 1);
    } while (s.heap_len >= 2);
    s.heap[--s.heap_max] = s.heap[1];

    // At this point, the fields freq and dad are set. We can now
    // generate the bit lengths.

    gen_bitlen(s);

    // The field len is now set, we can generate the bit codes
    gen_codes(tree, that.max_code, s.bl_count);
  };
}
Tree._length_code = [0, 1, 2, 3, 4, 5, 6, 7].concat(...extractArray([[2, 8], [2, 9], [2, 10], [2, 11], [4, 12], [4, 13], [4, 14], [4, 15], [8, 16], [8, 17], [8, 18], [8, 19], [16, 20], [16, 21], [16, 22], [16, 23], [32, 24], [32, 25], [32, 26], [31, 27], [1, 28]]));
Tree.base_length = [0, 1, 2, 3, 4, 5, 6, 7, 8, 10, 12, 14, 16, 20, 24, 28, 32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 0];
Tree.base_dist = [0, 1, 2, 3, 4, 6, 8, 12, 16, 24, 32, 48, 64, 96, 128, 192, 256, 384, 512, 768, 1024, 1536, 2048, 3072, 4096, 6144, 8192, 12288, 16384, 24576];

// Mapping from a distance to a distance code. dist is the distance - 1 and
// must not have side effects. _dist_code[256] and _dist_code[257] are never
// used.
Tree.d_code = function (dist) {
  return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
};

// extra bits for each length code
Tree.extra_lbits = [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0];

// extra bits for each distance code
Tree.extra_dbits = [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13];

// extra bits for each bit length code
Tree.extra_blbits = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7];
Tree.bl_order = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];

// StaticTree

function StaticTree(static_tree, extra_bits, extra_base, elems, max_length) {
  const that = this;
  that.static_tree = static_tree;
  that.extra_bits = extra_bits;
  that.extra_base = extra_base;
  that.elems = elems;
  that.max_length = max_length;
}
const static_ltree2_first_part = [12, 140, 76, 204, 44, 172, 108, 236, 28, 156, 92, 220, 60, 188, 124, 252, 2, 130, 66, 194, 34, 162, 98, 226, 18, 146, 82, 210, 50, 178, 114, 242, 10, 138, 74, 202, 42, 170, 106, 234, 26, 154, 90, 218, 58, 186, 122, 250, 6, 134, 70, 198, 38, 166, 102, 230, 22, 150, 86, 214, 54, 182, 118, 246, 14, 142, 78, 206, 46, 174, 110, 238, 30, 158, 94, 222, 62, 190, 126, 254, 1, 129, 65, 193, 33, 161, 97, 225, 17, 145, 81, 209, 49, 177, 113, 241, 9, 137, 73, 201, 41, 169, 105, 233, 25, 153, 89, 217, 57, 185, 121, 249, 5, 133, 69, 197, 37, 165, 101, 229, 21, 149, 85, 213, 53, 181, 117, 245, 13, 141, 77, 205, 45, 173, 109, 237, 29, 157, 93, 221, 61, 189, 125, 253, 19, 275, 147, 403, 83, 339, 211, 467, 51, 307, 179, 435, 115, 371, 243, 499, 11, 267, 139, 395, 75, 331, 203, 459, 43, 299, 171, 427, 107, 363, 235, 491, 27, 283, 155, 411, 91, 347, 219, 475, 59, 315, 187, 443, 123, 379, 251, 507, 7, 263, 135, 391, 71, 327, 199, 455, 39, 295, 167, 423, 103, 359, 231, 487, 23, 279, 151, 407, 87, 343, 215, 471, 55, 311, 183, 439, 119, 375, 247, 503, 15, 271, 143, 399, 79, 335, 207, 463, 47, 303, 175, 431, 111, 367, 239, 495, 31, 287, 159, 415, 95, 351, 223, 479, 63, 319, 191, 447, 127, 383, 255, 511, 0, 64, 32, 96, 16, 80, 48, 112, 8, 72, 40, 104, 24, 88, 56, 120, 4, 68, 36, 100, 20, 84, 52, 116, 3, 131, 67, 195, 35, 163, 99, 227];
const static_ltree2_second_part = extractArray([[144, 8], [112, 9], [24, 7], [8, 8]]);
StaticTree.static_ltree = flatArray(static_ltree2_first_part.map((value, index) => [value, static_ltree2_second_part[index]]));
const static_dtree_first_part = [0, 16, 8, 24, 4, 20, 12, 28, 2, 18, 10, 26, 6, 22, 14, 30, 1, 17, 9, 25, 5, 21, 13, 29, 3, 19, 11, 27, 7, 23];
const static_dtree_second_part = extractArray([[30, 5]]);
StaticTree.static_dtree = flatArray(static_dtree_first_part.map((value, index) => [value, static_dtree_second_part[index]]));
StaticTree.static_l_desc = new StaticTree(StaticTree.static_ltree, Tree.extra_lbits, LITERALS + 1, L_CODES, MAX_BITS$1);
StaticTree.static_d_desc = new StaticTree(StaticTree.static_dtree, Tree.extra_dbits, 0, D_CODES, MAX_BITS$1);
StaticTree.static_bl_desc = new StaticTree(null, Tree.extra_blbits, 0, BL_CODES, MAX_BL_BITS);

// Deflate

const MAX_MEM_LEVEL = 9;
const DEF_MEM_LEVEL = 8;
function Config(good_length, max_lazy, nice_length, max_chain, func) {
  const that = this;
  that.good_length = good_length;
  that.max_lazy = max_lazy;
  that.nice_length = nice_length;
  that.max_chain = max_chain;
  that.func = func;
}
const STORED$1 = 0;
const FAST = 1;
const SLOW = 2;
const config_table = [new Config(0, 0, 0, 0, STORED$1), new Config(4, 4, 8, 4, FAST), new Config(4, 5, 16, 8, FAST), new Config(4, 6, 32, 32, FAST), new Config(4, 4, 16, 16, SLOW), new Config(8, 16, 32, 32, SLOW), new Config(8, 16, 128, 128, SLOW), new Config(8, 32, 128, 256, SLOW), new Config(32, 128, 258, 1024, SLOW), new Config(32, 258, 258, 4096, SLOW)];
const z_errmsg = ["need dictionary",
// Z_NEED_DICT
// 2
"stream end",
// Z_STREAM_END 1
"",
// Z_OK 0
"",
// Z_ERRNO (-1)
"stream error",
// Z_STREAM_ERROR (-2)
"data error",
// Z_DATA_ERROR (-3)
"",
// Z_MEM_ERROR (-4)
"buffer error",
// Z_BUF_ERROR (-5)
"",
// Z_VERSION_ERROR (-6)
""];

// block not completed, need more input or more output
const NeedMore = 0;

// block flush performed
const BlockDone = 1;

// finish started, need only more output at next deflate
const FinishStarted = 2;

// finish done, accept no more input or output
const FinishDone = 3;

// preset dictionary flag in zlib header
const PRESET_DICT$1 = 0x20;
const INIT_STATE = 42;
const BUSY_STATE = 113;
const FINISH_STATE = 666;

// The deflate compression method
const Z_DEFLATED$1 = 8;
const STORED_BLOCK = 0;
const STATIC_TREES = 1;
const DYN_TREES = 2;
const MIN_MATCH = 3;
const MAX_MATCH = 258;
const MIN_LOOKAHEAD = MAX_MATCH + MIN_MATCH + 1;
function smaller(tree, n, m, depth) {
  const tn2 = tree[n * 2];
  const tm2 = tree[m * 2];
  return tn2 < tm2 || tn2 == tm2 && depth[n] <= depth[m];
}
function Deflate() {
  const that = this;
  let strm; // pointer back to this zlib stream
  let status; // as the name implies
  // pending_buf; // output still pending
  let pending_buf_size; // size of pending_buf
  // pending_out; // next pending byte to output to the stream
  // pending; // nb of bytes in the pending buffer

  // dist_buf; // buffer for distances
  // lc_buf; // buffer for literals or lengths
  // To simplify the code, dist_buf and lc_buf have the same number of elements.
  // To use different lengths, an extra flag array would be necessary.

  let last_flush; // value of flush param for previous deflate call

  let w_size; // LZ77 win size (32K by default)
  let w_bits; // log2(w_size) (8..16)
  let w_mask; // w_size - 1

  let win;
  // Sliding win. Input bytes are read into the second half of the win,
  // and move to the first half later to keep a dictionary of at least wSize
  // bytes. With this organization, matches are limited to a distance of
  // wSize-MAX_MATCH bytes, but this ensures that IO is always
  // performed with a length multiple of the block size. Also, it limits
  // the win size to 64K, which is quite useful on MSDOS.
  // To do: use the user input buffer as sliding win.

  let window_size;
  // Actual size of win: 2*wSize, except when the user input buffer
  // is directly used as sliding win.

  let prev;
  // Link to older string with same hash index. To limit the size of this
  // array to 64K, this link is maintained only for the last 32K strings.
  // An index in this array is thus a win index modulo 32K.

  let head; // Heads of the hash chains or NIL.

  let ins_h; // hash index of string to be inserted
  let hash_size; // number of elements in hash table
  let hash_bits; // log2(hash_size)
  let hash_mask; // hash_size-1

  // Number of bits by which ins_h must be shifted at each input
  // step. It must be such that after MIN_MATCH steps, the oldest
  // byte no longer takes part in the hash key, that is:
  // hash_shift * MIN_MATCH >= hash_bits
  let hash_shift;

  // Window position at the beginning of the current output block. Gets
  // negative when the win is moved backwards.

  let block_start;
  let match_length; // length of best match
  let prev_match; // previous match
  let match_available; // set if previous match exists
  let strstart; // start of string to insert
  let match_start; // start of matching string
  let lookahead; // number of valid bytes ahead in win

  // Length of the best match at previous step. Matches not greater than this
  // are discarded. This is used in the lazy match evaluation.
  let prev_length;

  // To speed up deflation, hash chains are never searched beyond this
  // length. A higher limit improves compression ratio but degrades the speed.
  let max_chain_length;

  // Attempt to find a better match only when the current match is strictly
  // smaller than this value. This mechanism is used only for compression
  // levels >= 4.
  let max_lazy_match;

  // Insert new strings in the hash table only if the match length is not
  // greater than this length. This saves time but degrades compression.
  // max_insert_length is used only for compression levels <= 3.

  let level; // compression level (1..9)
  let strategy; // favor or force Huffman coding

  // Use a faster search when the previous match is longer than this
  let good_match;

  // Stop searching when current match exceeds this
  let nice_match;
  let dyn_ltree; // literal and length tree
  let dyn_dtree; // distance tree
  let bl_tree; // Huffman tree for bit lengths

  const l_desc = new Tree(); // desc for literal tree
  const d_desc = new Tree(); // desc for distance tree
  const bl_desc = new Tree(); // desc for bit length tree

  // that.heap_len; // number of elements in the heap
  // that.heap_max; // element of largest frequency
  // The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
  // The same heap array is used to build all trees.

  // Depth of each subtree used as tie breaker for trees of equal frequency
  that.depth = [];

  // Size of match buffer for literals/lengths. There are 4 reasons for
  // limiting lit_bufsize to 64K:
  // - frequencies can be kept in 16 bit counters
  // - if compression is not successful for the first block, all input
  // data is still in the win so we can still emit a stored block even
  // when input comes from standard input. (This can also be done for
  // all blocks if lit_bufsize is not greater than 32K.)
  // - if compression is not successful for a file smaller than 64K, we can
  // even emit a stored file instead of a stored block (saving 5 bytes).
  // This is applicable only for zip (not gzip or zlib).
  // - creating new Huffman trees less frequently may not provide fast
  // adaptation to changes in the input data statistics. (Take for
  // example a binary file with poorly compressible code followed by
  // a highly compressible string table.) Smaller buffer sizes give
  // fast adaptation but have of course the overhead of transmitting
  // trees more frequently.
  // - I can't count above 4
  let lit_bufsize;
  let last_lit; // running index in dist_buf and lc_buf

  // that.opt_len; // bit length of current block with optimal trees
  // that.static_len; // bit length of current block with static trees
  let matches; // number of string matches in current block
  let last_eob_len; // bit length of EOB code for last block

  // Output buffer. bits are inserted starting at the bottom (least
  // significant bits).
  let bi_buf;

  // Number of valid bits in bi_buf. All bits above the last valid bit
  // are always zero.
  let bi_valid;

  // number of codes at each bit length for an optimal tree
  that.bl_count = [];

  // heap used to build the Huffman trees
  that.heap = [];
  dyn_ltree = [];
  dyn_dtree = [];
  bl_tree = [];
  function lm_init() {
    window_size = 2 * w_size;
    head[hash_size - 1] = 0;
    for (let i = 0; i < hash_size - 1; i++) {
      head[i] = 0;
    }

    // Set the default configuration parameters:
    max_lazy_match = config_table[level].max_lazy;
    good_match = config_table[level].good_length;
    nice_match = config_table[level].nice_length;
    max_chain_length = config_table[level].max_chain;
    strstart = 0;
    block_start = 0;
    lookahead = 0;
    match_length = prev_length = MIN_MATCH - 1;
    match_available = 0;
    ins_h = 0;
  }
  function init_block() {
    let i;
    // Initialize the trees.
    for (i = 0; i < L_CODES; i++) dyn_ltree[i * 2] = 0;
    for (i = 0; i < D_CODES; i++) dyn_dtree[i * 2] = 0;
    for (i = 0; i < BL_CODES; i++) bl_tree[i * 2] = 0;
    dyn_ltree[END_BLOCK * 2] = 1;
    that.opt_len = that.static_len = 0;
    last_lit = matches = 0;
  }

  // Initialize the tree data structures for a new zlib stream.
  function tr_init() {
    l_desc.dyn_tree = dyn_ltree;
    l_desc.stat_desc = StaticTree.static_l_desc;
    d_desc.dyn_tree = dyn_dtree;
    d_desc.stat_desc = StaticTree.static_d_desc;
    bl_desc.dyn_tree = bl_tree;
    bl_desc.stat_desc = StaticTree.static_bl_desc;
    bi_buf = 0;
    bi_valid = 0;
    last_eob_len = 8; // enough lookahead for inflate

    // Initialize the first block of the first file:
    init_block();
  }

  // Restore the heap property by moving down the tree starting at node k,
  // exchanging a node with the smallest of its two sons if necessary,
  // stopping
  // when the heap property is re-established (each father smaller than its
  // two sons).
  that.pqdownheap = function (tree,
  // the tree to restore
  k // node to move down
  ) {
    const heap = that.heap;
    const v = heap[k];
    let j = k << 1; // left son of k
    while (j <= that.heap_len) {
      // Set j to the smallest of the two sons:
      if (j < that.heap_len && smaller(tree, heap[j + 1], heap[j], that.depth)) {
        j++;
      }
      // Exit if v is smaller than both sons
      if (smaller(tree, v, heap[j], that.depth)) break;

      // Exchange v with the smallest son
      heap[k] = heap[j];
      k = j;
      // And continue down the tree, setting j to the left son of k
      j <<= 1;
    }
    heap[k] = v;
  };

  // Scan a literal or distance tree to determine the frequencies of the codes
  // in the bit length tree.
  function scan_tree(tree,
  // the tree to be scanned
  max_code // and its largest code of non zero frequency
  ) {
    let prevlen = -1; // last emitted length
    let curlen; // length of current code
    let nextlen = tree[0 * 2 + 1]; // length of next code
    let count = 0; // repeat count of the current code
    let max_count = 7; // max repeat count
    let min_count = 4; // min repeat count

    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;
    }
    tree[(max_code + 1) * 2 + 1] = 0xffff; // guard

    for (let n = 0; n <= max_code; n++) {
      curlen = nextlen;
      nextlen = tree[(n + 1) * 2 + 1];
      if (++count < max_count && curlen == nextlen) {
        continue;
      } else if (count < min_count) {
        bl_tree[curlen * 2] += count;
      } else if (curlen !== 0) {
        if (curlen != prevlen) bl_tree[curlen * 2]++;
        bl_tree[REP_3_6 * 2]++;
      } else if (count <= 10) {
        bl_tree[REPZ_3_10 * 2]++;
      } else {
        bl_tree[REPZ_11_138 * 2]++;
      }
      count = 0;
      prevlen = curlen;
      if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
      } else if (curlen == nextlen) {
        max_count = 6;
        min_count = 3;
      } else {
        max_count = 7;
        min_count = 4;
      }
    }
  }

  // Construct the Huffman tree for the bit lengths and return the index in
  // bl_order of the last bit length code to send.
  function build_bl_tree() {
    let max_blindex; // index of last bit length code of non zero freq

    // Determine the bit length frequencies for literal and distance trees
    scan_tree(dyn_ltree, l_desc.max_code);
    scan_tree(dyn_dtree, d_desc.max_code);

    // Build the bit length tree:
    bl_desc.build_tree(that);
    // opt_len now includes the length of the tree representations, except
    // the lengths of the bit lengths codes and the 5+5+4 bits for the
    // counts.

    // Determine the number of bit length codes to send. The pkzip format
    // requires that at least 4 bit length codes be sent. (appnote.txt says
    // 3 but the actual value used is 4.)
    for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
      if (bl_tree[Tree.bl_order[max_blindex] * 2 + 1] !== 0) break;
    }
    // Update opt_len to include the bit length tree and counts
    that.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
    return max_blindex;
  }

  // Output a byte on the stream.
  // IN assertion: there is enough room in pending_buf.
  function put_byte(p) {
    that.pending_buf[that.pending++] = p;
  }
  function put_short(w) {
    put_byte(w & 0xff);
    put_byte(w >>> 8 & 0xff);
  }
  function putShortMSB(b) {
    put_byte(b >> 8 & 0xff);
    put_byte(b & 0xff & 0xff);
  }
  function send_bits(value, length) {
    let val;
    const len = length;
    if (bi_valid > Buf_size - len) {
      val = value;
      // bi_buf |= (val << bi_valid);
      bi_buf |= val << bi_valid & 0xffff;
      put_short(bi_buf);
      bi_buf = val >>> Buf_size - bi_valid;
      bi_valid += len - Buf_size;
    } else {
      // bi_buf |= (value) << bi_valid;
      bi_buf |= value << bi_valid & 0xffff;
      bi_valid += len;
    }
  }
  function send_code(c, tree) {
    const c2 = c * 2;
    send_bits(tree[c2] & 0xffff, tree[c2 + 1] & 0xffff);
  }

  // Send a literal or distance tree in compressed form, using the codes in
  // bl_tree.
  function send_tree(tree,
  // the tree to be sent
  max_code // and its largest code of non zero frequency
  ) {
    let n; // iterates over all tree elements
    let prevlen = -1; // last emitted length
    let curlen; // length of current code
    let nextlen = tree[0 * 2 + 1]; // length of next code
    let count = 0; // repeat count of the current code
    let max_count = 7; // max repeat count
    let min_count = 4; // min repeat count

    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;
    }
    for (n = 0; n <= max_code; n++) {
      curlen = nextlen;
      nextlen = tree[(n + 1) * 2 + 1];
      if (++count < max_count && curlen == nextlen) {
        continue;
      } else if (count < min_count) {
        do {
          send_code(curlen, bl_tree);
        } while (--count !== 0);
      } else if (curlen !== 0) {
        if (curlen != prevlen) {
          send_code(curlen, bl_tree);
          count--;
        }
        send_code(REP_3_6, bl_tree);
        send_bits(count - 3, 2);
      } else if (count <= 10) {
        send_code(REPZ_3_10, bl_tree);
        send_bits(count - 3, 3);
      } else {
        send_code(REPZ_11_138, bl_tree);
        send_bits(count - 11, 7);
      }
      count = 0;
      prevlen = curlen;
      if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
      } else if (curlen == nextlen) {
        max_count = 6;
        min_count = 3;
      } else {
        max_count = 7;
        min_count = 4;
      }
    }
  }

  // Send the header for a block using dynamic Huffman trees: the counts, the
  // lengths of the bit length codes, the literal tree and the distance tree.
  // IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
  function send_all_trees(lcodes, dcodes, blcodes) {
    let rank; // index in bl_order

    send_bits(lcodes - 257, 5); // not +255 as stated in appnote.txt
    send_bits(dcodes - 1, 5);
    send_bits(blcodes - 4, 4); // not -3 as stated in appnote.txt
    for (rank = 0; rank < blcodes; rank++) {
      send_bits(bl_tree[Tree.bl_order[rank] * 2 + 1], 3);
    }
    send_tree(dyn_ltree, lcodes - 1); // literal tree
    send_tree(dyn_dtree, dcodes - 1); // distance tree
  }

  // Flush the bit buffer, keeping at most 7 bits in it.
  function bi_flush() {
    if (bi_valid == 16) {
      put_short(bi_buf);
      bi_buf = 0;
      bi_valid = 0;
    } else if (bi_valid >= 8) {
      put_byte(bi_buf & 0xff);
      bi_buf >>>= 8;
      bi_valid -= 8;
    }
  }

  // Send one empty static block to give enough lookahead for inflate.
  // This takes 10 bits, of which 7 may remain in the bit buffer.
  // The current inflate code requires 9 bits of lookahead. If the
  // last two codes for the previous block (real code plus EOB) were coded
  // on 5 bits or less, inflate may have only 5+3 bits of lookahead to decode
  // the last real code. In this case we send two empty static blocks instead
  // of one. (There are no problems if the previous block is stored or fixed.)
  // To simplify the code, we assume the worst case of last real code encoded
  // on one bit only.
  function _tr_align() {
    send_bits(STATIC_TREES << 1, 3);
    send_code(END_BLOCK, StaticTree.static_ltree);
    bi_flush();

    // Of the 10 bits for the empty block, we have already sent
    // (10 - bi_valid) bits. The lookahead for the last real code (before
    // the EOB of the previous block) was thus at least one plus the length
    // of the EOB plus what we have just sent of the empty static block.
    if (1 + last_eob_len + 10 - bi_valid < 9) {
      send_bits(STATIC_TREES << 1, 3);
      send_code(END_BLOCK, StaticTree.static_ltree);
      bi_flush();
    }
    last_eob_len = 7;
  }

  // Save the match info and tally the frequency counts. Return true if
  // the current block must be flushed.
  function _tr_tally(dist,
  // distance of matched string
  lc // match length-MIN_MATCH or unmatched char (if dist==0)
  ) {
    let out_length, in_length, dcode;
    that.dist_buf[last_lit] = dist;
    that.lc_buf[last_lit] = lc & 0xff;
    last_lit++;
    if (dist === 0) {
      // lc is the unmatched char
      dyn_ltree[lc * 2]++;
    } else {
      matches++;
      // Here, lc is the match length - MIN_MATCH
      dist--; // dist = match distance - 1
      dyn_ltree[(Tree._length_code[lc] + LITERALS + 1) * 2]++;
      dyn_dtree[Tree.d_code(dist) * 2]++;
    }
    if ((last_lit & 0x1fff) === 0 && level > 2) {
      // Compute an upper bound for the compressed length
      out_length = last_lit * 8;
      in_length = strstart - block_start;
      for (dcode = 0; dcode < D_CODES; dcode++) {
        out_length += dyn_dtree[dcode * 2] * (5 + Tree.extra_dbits[dcode]);
      }
      out_length >>>= 3;
      if (matches < Math.floor(last_lit / 2) && out_length < Math.floor(in_length / 2)) return true;
    }
    return last_lit == lit_bufsize - 1;
    // We avoid equality with lit_bufsize because of wraparound at 64K
    // on 16 bit machines and because stored blocks are restricted to
    // 64K-1 bytes.
  }

  // Send the block data compressed using the given Huffman trees
  function compress_block(ltree, dtree) {
    let dist; // distance of matched string
    let lc; // match length or unmatched char (if dist === 0)
    let lx = 0; // running index in dist_buf and lc_buf
    let code; // the code to send
    let extra; // number of extra bits to send

    if (last_lit !== 0) {
      do {
        dist = that.dist_buf[lx];
        lc = that.lc_buf[lx];
        lx++;
        if (dist === 0) {
          send_code(lc, ltree); // send a literal byte
        } else {
          // Here, lc is the match length - MIN_MATCH
          code = Tree._length_code[lc];
          send_code(code + LITERALS + 1, ltree); // send the length
          // code
          extra = Tree.extra_lbits[code];
          if (extra !== 0) {
            lc -= Tree.base_length[code];
            send_bits(lc, extra); // send the extra length bits
          }
          dist--; // dist is now the match distance - 1
          code = Tree.d_code(dist);
          send_code(code, dtree); // send the distance code
          extra = Tree.extra_dbits[code];
          if (extra !== 0) {
            dist -= Tree.base_dist[code];
            send_bits(dist, extra); // send the extra distance bits
          }
        } // literal or match pair ?
      } while (lx < last_lit);
    }
    send_code(END_BLOCK, ltree);
    last_eob_len = ltree[END_BLOCK * 2 + 1];
  }

  // Flush the bit buffer and align the output on a byte boundary
  function bi_windup() {
    if (bi_valid > 8) {
      put_short(bi_buf);
    } else if (bi_valid > 0) {
      put_byte(bi_buf & 0xff);
    }
    bi_buf = 0;
    bi_valid = 0;
  }

  // Copy a stored block, storing first the length and its
  // one's complement if requested.
  function copy_block(buf,
  // the input data
  len,
  // its length
  header // true if block header must be written
  ) {
    bi_windup(); // align on byte boundary
    last_eob_len = 8; // enough lookahead for inflate

    if (header) {
      put_short(len);
      put_short(~len);
    }
    that.pending_buf.set(win.subarray(buf, buf + len), that.pending);
    that.pending += len;
  }

  // Send a stored block
  function _tr_stored_block(buf,
  // input block
  stored_len,
  // length of input block
  eof // true if this is the last block for a file
  ) {
    send_bits((STORED_BLOCK << 1) + (eof ? 1 : 0), 3); // send block type
    copy_block(buf, stored_len, true); // with header
  }

  // Determine the best encoding for the current block: dynamic trees, static
  // trees or store, and output the encoded block to the zip file.
  function _tr_flush_block(buf,
  // input block, or NULL if too old
  stored_len,
  // length of input block
  eof // true if this is the last block for a file
  ) {
    let opt_lenb, static_lenb; // opt_len and static_len in bytes
    let max_blindex = 0; // index of last bit length code of non zero freq

    // Build the Huffman trees unless a stored block is forced
    if (level > 0) {
      // Construct the literal and distance trees
      l_desc.build_tree(that);
      d_desc.build_tree(that);

      // At this point, opt_len and static_len are the total bit lengths
      // of
      // the compressed block data, excluding the tree representations.

      // Build the bit length tree for the above two trees, and get the
      // index
      // in bl_order of the last bit length code to send.
      max_blindex = build_bl_tree();

      // Determine the best encoding. Compute first the block length in
      // bytes
      opt_lenb = that.opt_len + 3 + 7 >>> 3;
      static_lenb = that.static_len + 3 + 7 >>> 3;
      if (static_lenb <= opt_lenb) opt_lenb = static_lenb;
    } else {
      opt_lenb = static_lenb = stored_len + 5; // force a stored block
    }
    if (stored_len + 4 <= opt_lenb && buf != -1) {
      // 4: two words for the lengths
      // The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
      // Otherwise we can't have processed more than WSIZE input bytes
      // since
      // the last block flush, because compression would have been
      // successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
      // transform a block into a stored block.
      _tr_stored_block(buf, stored_len, eof);
    } else if (static_lenb == opt_lenb) {
      send_bits((STATIC_TREES << 1) + (eof ? 1 : 0), 3);
      compress_block(StaticTree.static_ltree, StaticTree.static_dtree);
    } else {
      send_bits((DYN_TREES << 1) + (eof ? 1 : 0), 3);
      send_all_trees(l_desc.max_code + 1, d_desc.max_code + 1, max_blindex + 1);
      compress_block(dyn_ltree, dyn_dtree);
    }

    // The above check is made mod 2^32, for files larger than 512 MB
    // and uLong implemented on 32 bits.

    init_block();
    if (eof) {
      bi_windup();
    }
  }
  function flush_block_only(eof) {
    _tr_flush_block(block_start >= 0 ? block_start : -1, strstart - block_start, eof);
    block_start = strstart;
    strm.flush_pending();
  }

  // Fill the win when the lookahead becomes insufficient.
  // Updates strstart and lookahead.
  //
  // IN assertion: lookahead < MIN_LOOKAHEAD
  // OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
  // At least one byte has been read, or avail_in === 0; reads are
  // performed for at least two bytes (required for the zip translate_eol
  // option -- not supported here).
  function fill_window() {
    let n, m;
    let p;
    let more; // Amount of free space at the end of the win.

    do {
      more = window_size - lookahead - strstart;

      // Deal with !@#$% 64K limit:
      if (more === 0 && strstart === 0 && lookahead === 0) {
        more = w_size;
      } else if (more == -1) {
        // Very unlikely, but possible on 16 bit machine if strstart ==
        // 0
        // and lookahead == 1 (input done one byte at time)
        more--;

        // If the win is almost full and there is insufficient
        // lookahead,
        // move the upper half to the lower one to make room in the
        // upper half.
      } else if (strstart >= w_size + w_size - MIN_LOOKAHEAD) {
        win.set(win.subarray(w_size, w_size + w_size), 0);
        match_start -= w_size;
        strstart -= w_size; // we now have strstart >= MAX_DIST
        block_start -= w_size;

        // Slide the hash table (could be avoided with 32 bit values
        // at the expense of memory usage). We slide even when level ==
        // 0
        // to keep the hash table consistent if we switch back to level
        // > 0
        // later. (Using level 0 permanently is not an optimal usage of
        // zlib, so we don't care about this pathological case.)

        n = hash_size;
        p = n;
        do {
          m = head[--p] & 0xffff;
          head[p] = m >= w_size ? m - w_size : 0;
        } while (--n !== 0);
        n = w_size;
        p = n;
        do {
          m = prev[--p] & 0xffff;
          prev[p] = m >= w_size ? m - w_size : 0;
          // If n is not on any hash chain, prev[n] is garbage but
          // its value will never be used.
        } while (--n !== 0);
        more += w_size;
      }
      if (strm.avail_in === 0) return;

      // If there was no sliding:
      // strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
      // more == window_size - lookahead - strstart
      // => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
      // => more >= window_size - 2*WSIZE + 2
      // In the BIG_MEM or MMAP case (not yet supported),
      // window_size == input_size + MIN_LOOKAHEAD &&
      // strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
      // Otherwise, window_size == 2*WSIZE so more >= 2.
      // If there was sliding, more >= WSIZE. So in all cases, more >= 2.

      n = strm.read_buf(win, strstart + lookahead, more);
      lookahead += n;

      // Initialize the hash value now that we have some input:
      if (lookahead >= MIN_MATCH) {
        ins_h = win[strstart] & 0xff;
        ins_h = (ins_h << hash_shift ^ win[strstart + 1] & 0xff) & hash_mask;
      }
      // If the whole input has less than MIN_MATCH bytes, ins_h is
      // garbage,
      // but this is not important since only literal bytes will be
      // emitted.
    } while (lookahead < MIN_LOOKAHEAD && strm.avail_in !== 0);
  }

  // Copy without compression as much as possible from the input stream,
  // return
  // the current block state.
  // This function does not insert new strings in the dictionary since
  // uncompressible data is probably not useful. This function is used
  // only for the level=0 compression option.
  // NOTE: this function should be optimized to avoid extra copying from
  // win to pending_buf.
  function deflate_stored(flush) {
    // Stored blocks are limited to 0xffff bytes, pending_buf is limited
    // to pending_buf_size, and each stored block has a 5 byte header:

    let max_block_size = 0xffff;
    let max_start;
    if (max_block_size > pending_buf_size - 5) {
      max_block_size = pending_buf_size - 5;
    }

    // Copy as much as possible from input to output:
    // eslint-disable-next-line no-constant-condition
    while (true) {
      // Fill the win as much as possible:
      if (lookahead <= 1) {
        fill_window();
        if (lookahead === 0 && flush == Z_NO_FLUSH$1) return NeedMore;
        if (lookahead === 0) break; // flush the current block
      }
      strstart += lookahead;
      lookahead = 0;

      // Emit a stored block if pending_buf will be full:
      max_start = block_start + max_block_size;
      if (strstart === 0 || strstart >= max_start) {
        // strstart === 0 is possible when wraparound on 16-bit machine
        lookahead = strstart - max_start;
        strstart = max_start;
        flush_block_only(false);
        if (strm.avail_out === 0) return NeedMore;
      }

      // Flush if we may have to slide, otherwise block_start may become
      // negative and the data will be gone:
      if (strstart - block_start >= w_size - MIN_LOOKAHEAD) {
        flush_block_only(false);
        if (strm.avail_out === 0) return NeedMore;
      }
    }
    flush_block_only(flush == Z_FINISH$1);
    if (strm.avail_out === 0) return flush == Z_FINISH$1 ? FinishStarted : NeedMore;
    return flush == Z_FINISH$1 ? FinishDone : BlockDone;
  }
  function longest_match(cur_match) {
    let chain_length = max_chain_length; // max hash chain length
    let scan = strstart; // current string
    let match; // matched string
    let len; // length of current match
    let best_len = prev_length; // best match length so far
    const limit = strstart > w_size - MIN_LOOKAHEAD ? strstart - (w_size - MIN_LOOKAHEAD) : 0;
    let _nice_match = nice_match;

    // Stop when cur_match becomes <= limit. To simplify the code,
    // we prevent matches with the string of win index 0.

    const wmask = w_mask;
    const strend = strstart + MAX_MATCH;
    let scan_end1 = win[scan + best_len - 1];
    let scan_end = win[scan + best_len];

    // The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of
    // 16.
    // It is easy to get rid of this optimization if necessary.

    // Do not waste too much time if we already have a good match:
    if (prev_length >= good_match) {
      chain_length >>= 2;
    }

    // Do not look for matches beyond the end of the input. This is
    // necessary
    // to make deflate deterministic.
    if (_nice_match > lookahead) _nice_match = lookahead;
    do {
      match = cur_match;

      // Skip to next match if the match length cannot increase
      // or if the match length is less than 2:
      if (win[match + best_len] != scan_end || win[match + best_len - 1] != scan_end1 || win[match] != win[scan] || win[++match] != win[scan + 1]) continue;

      // The check at best_len-1 can be removed because it will be made
      // again later. (This heuristic is not always a win.)
      // It is not necessary to compare scan[2] and match[2] since they
      // are always equal when the other bytes match, given that
      // the hash keys are equal and that HASH_BITS >= 8.
      scan += 2;
      match++;

      // We check for insufficient lookahead only every 8th comparison;
      // the 256th check will be made at strstart+258.
      // eslint-disable-next-line no-empty
      do {
        // empty block
      } while (win[++scan] == win[++match] && win[++scan] == win[++match] && win[++scan] == win[++match] && win[++scan] == win[++match] && win[++scan] == win[++match] && win[++scan] == win[++match] && win[++scan] == win[++match] && win[++scan] == win[++match] && scan < strend);
      len = MAX_MATCH - (strend - scan);
      scan = strend - MAX_MATCH;
      if (len > best_len) {
        match_start = cur_match;
        best_len = len;
        if (len >= _nice_match) break;
        scan_end1 = win[scan + best_len - 1];
        scan_end = win[scan + best_len];
      }
    } while ((cur_match = prev[cur_match & wmask] & 0xffff) > limit && --chain_length !== 0);
    if (best_len <= lookahead) return best_len;
    return lookahead;
  }

  // Compress as much as possible from the input stream, return the current
  // block state.
  // This function does not perform lazy evaluation of matches and inserts
  // new strings in the dictionary only for unmatched strings or for short
  // matches. It is used only for the fast compression options.
  function deflate_fast(flush) {
    // short hash_head = 0; // head of the hash chain
    let hash_head = 0; // head of the hash chain
    let bflush; // set if current block must be flushed

    // eslint-disable-next-line no-constant-condition
    while (true) {
      // Make sure that we always have enough lookahead, except
      // at the end of the input file. We need MAX_MATCH bytes
      // for the next match, plus MIN_MATCH bytes to insert the
      // string following the next match.
      if (lookahead < MIN_LOOKAHEAD) {
        fill_window();
        if (lookahead < MIN_LOOKAHEAD && flush == Z_NO_FLUSH$1) {
          return NeedMore;
        }
        if (lookahead === 0) break; // flush the current block
      }

      // Insert the string win[strstart .. strstart+2] in the
      // dictionary, and set hash_head to the head of the hash chain:
      if (lookahead >= MIN_MATCH) {
        ins_h = (ins_h << hash_shift ^ win[strstart + (MIN_MATCH - 1)] & 0xff) & hash_mask;

        // prev[strstart&w_mask]=hash_head=head[ins_h];
        hash_head = head[ins_h] & 0xffff;
        prev[strstart & w_mask] = head[ins_h];
        head[ins_h] = strstart;
      }

      // Find the longest match, discarding those <= prev_length.
      // At this point we have always match_length < MIN_MATCH

      if (hash_head !== 0 && (strstart - hash_head & 0xffff) <= w_size - MIN_LOOKAHEAD) {
        // To simplify the code, we prevent matches with the string
        // of win index 0 (in particular we have to avoid a match
        // of the string with itself at the start of the input file).
        if (strategy != Z_HUFFMAN_ONLY) {
          match_length = longest_match(hash_head);
        }
        // longest_match() sets match_start
      }
      if (match_length >= MIN_MATCH) {
        // check_match(strstart, match_start, match_length);

        bflush = _tr_tally(strstart - match_start, match_length - MIN_MATCH);
        lookahead -= match_length;

        // Insert new strings in the hash table only if the match length
        // is not too large. This saves time but degrades compression.
        if (match_length <= max_lazy_match && lookahead >= MIN_MATCH) {
          match_length--; // string at strstart already in hash table
          do {
            strstart++;
            ins_h = (ins_h << hash_shift ^ win[strstart + (MIN_MATCH - 1)] & 0xff) & hash_mask;
            // prev[strstart&w_mask]=hash_head=head[ins_h];
            hash_head = head[ins_h] & 0xffff;
            prev[strstart & w_mask] = head[ins_h];
            head[ins_h] = strstart;

            // strstart never exceeds WSIZE-MAX_MATCH, so there are
            // always MIN_MATCH bytes ahead.
          } while (--match_length !== 0);
          strstart++;
        } else {
          strstart += match_length;
          match_length = 0;
          ins_h = win[strstart] & 0xff;
          ins_h = (ins_h << hash_shift ^ win[strstart + 1] & 0xff) & hash_mask;
          // If lookahead < MIN_MATCH, ins_h is garbage, but it does
          // not
          // matter since it will be recomputed at next deflate call.
        }
      } else {
        // No match, output a literal byte

        bflush = _tr_tally(0, win[strstart] & 0xff);
        lookahead--;
        strstart++;
      }
      if (bflush) {
        flush_block_only(false);
        if (strm.avail_out === 0) return NeedMore;
      }
    }
    flush_block_only(flush == Z_FINISH$1);
    if (strm.avail_out === 0) {
      if (flush == Z_FINISH$1) return FinishStarted;else return NeedMore;
    }
    return flush == Z_FINISH$1 ? FinishDone : BlockDone;
  }

  // Same as above, but achieves better compression. We use a lazy
  // evaluation for matches: a match is finally adopted only if there is
  // no better match at the next win position.
  function deflate_slow(flush) {
    // short hash_head = 0; // head of hash chain
    let hash_head = 0; // head of hash chain
    let bflush; // set if current block must be flushed
    let max_insert;

    // Process the input block.
    // eslint-disable-next-line no-constant-condition
    while (true) {
      // Make sure that we always have enough lookahead, except
      // at the end of the input file. We need MAX_MATCH bytes
      // for the next match, plus MIN_MATCH bytes to insert the
      // string following the next match.

      if (lookahead < MIN_LOOKAHEAD) {
        fill_window();
        if (lookahead < MIN_LOOKAHEAD && flush == Z_NO_FLUSH$1) {
          return NeedMore;
        }
        if (lookahead === 0) break; // flush the current block
      }

      // Insert the string win[strstart .. strstart+2] in the
      // dictionary, and set hash_head to the head of the hash chain:

      if (lookahead >= MIN_MATCH) {
        ins_h = (ins_h << hash_shift ^ win[strstart + (MIN_MATCH - 1)] & 0xff) & hash_mask;
        // prev[strstart&w_mask]=hash_head=head[ins_h];
        hash_head = head[ins_h] & 0xffff;
        prev[strstart & w_mask] = head[ins_h];
        head[ins_h] = strstart;
      }

      // Find the longest match, discarding those <= prev_length.
      prev_length = match_length;
      prev_match = match_start;
      match_length = MIN_MATCH - 1;
      if (hash_head !== 0 && prev_length < max_lazy_match && (strstart - hash_head & 0xffff) <= w_size - MIN_LOOKAHEAD) {
        // To simplify the code, we prevent matches with the string
        // of win index 0 (in particular we have to avoid a match
        // of the string with itself at the start of the input file).

        if (strategy != Z_HUFFMAN_ONLY) {
          match_length = longest_match(hash_head);
        }
        // longest_match() sets match_start

        if (match_length <= 5 && (strategy == Z_FILTERED || match_length == MIN_MATCH && strstart - match_start > 4096)) {
          // If prev_match is also MIN_MATCH, match_start is garbage
          // but we will ignore the current match anyway.
          match_length = MIN_MATCH - 1;
        }
      }

      // If there was a match at the previous step and the current
      // match is not better, output the previous match:
      if (prev_length >= MIN_MATCH && match_length <= prev_length) {
        max_insert = strstart + lookahead - MIN_MATCH;
        // Do not insert strings in hash table beyond this.

        // check_match(strstart-1, prev_match, prev_length);

        bflush = _tr_tally(strstart - 1 - prev_match, prev_length - MIN_MATCH);

        // Insert in hash table all strings up to the end of the match.
        // strstart-1 and strstart are already inserted. If there is not
        // enough lookahead, the last two strings are not inserted in
        // the hash table.
        lookahead -= prev_length - 1;
        prev_length -= 2;
        do {
          if (++strstart <= max_insert) {
            ins_h = (ins_h << hash_shift ^ win[strstart + (MIN_MATCH - 1)] & 0xff) & hash_mask;
            // prev[strstart&w_mask]=hash_head=head[ins_h];
            hash_head = head[ins_h] & 0xffff;
            prev[strstart & w_mask] = head[ins_h];
            head[ins_h] = strstart;
          }
        } while (--prev_length !== 0);
        match_available = 0;
        match_length = MIN_MATCH - 1;
        strstart++;
        if (bflush) {
          flush_block_only(false);
          if (strm.avail_out === 0) return NeedMore;
        }
      } else if (match_available !== 0) {
        // If there was no match at the previous position, output a
        // single literal. If there was a match but the current match
        // is longer, truncate the previous match to a single literal.

        bflush = _tr_tally(0, win[strstart - 1] & 0xff);
        if (bflush) {
          flush_block_only(false);
        }
        strstart++;
        lookahead--;
        if (strm.avail_out === 0) return NeedMore;
      } else {
        // There is no previous match to compare with, wait for
        // the next step to decide.

        match_available = 1;
        strstart++;
        lookahead--;
      }
    }
    if (match_available !== 0) {
      bflush = _tr_tally(0, win[strstart - 1] & 0xff);
      match_available = 0;
    }
    flush_block_only(flush == Z_FINISH$1);
    if (strm.avail_out === 0) {
      if (flush == Z_FINISH$1) return FinishStarted;else return NeedMore;
    }
    return flush == Z_FINISH$1 ? FinishDone : BlockDone;
  }
  function deflateReset(strm) {
    strm.total_in = strm.total_out = 0;
    strm.msg = null; //

    that.pending = 0;
    that.pending_out = 0;
    status = BUSY_STATE;
    last_flush = Z_NO_FLUSH$1;
    tr_init();
    lm_init();
    return Z_OK$1;
  }
  that.deflateInit = function (strm, _level, bits, _method, memLevel, _strategy) {
    if (!_method) _method = Z_DEFLATED$1;
    if (!memLevel) memLevel = DEF_MEM_LEVEL;
    if (!_strategy) _strategy = Z_DEFAULT_STRATEGY;

    // byte[] my_version=ZLIB_VERSION;

    //
    // if (!version || version[0] != my_version[0]
    // || stream_size != sizeof(z_stream)) {
    // return Z_VERSION_ERROR;
    // }

    strm.msg = null;
    if (_level == Z_DEFAULT_COMPRESSION) _level = 6;
    if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || _method != Z_DEFLATED$1 || bits < 9 || bits > 15 || _level < 0 || _level > 9 || _strategy < 0 || _strategy > Z_HUFFMAN_ONLY) {
      return Z_STREAM_ERROR$1;
    }
    strm.dstate = that;
    w_bits = bits;
    w_size = 1 << w_bits;
    w_mask = w_size - 1;
    hash_bits = memLevel + 7;
    hash_size = 1 << hash_bits;
    hash_mask = hash_size - 1;
    hash_shift = Math.floor((hash_bits + MIN_MATCH - 1) / MIN_MATCH);
    win = new Uint8Array(w_size * 2);
    prev = [];
    head = [];
    lit_bufsize = 1 << memLevel + 6; // 16K elements by default

    that.pending_buf = new Uint8Array(lit_bufsize * 4);
    pending_buf_size = lit_bufsize * 4;
    that.dist_buf = new Uint16Array(lit_bufsize);
    that.lc_buf = new Uint8Array(lit_bufsize);
    level = _level;
    strategy = _strategy;
    return deflateReset(strm);
  };
  that.deflateEnd = function () {
    if (status != INIT_STATE && status != BUSY_STATE && status != FINISH_STATE) {
      return Z_STREAM_ERROR$1;
    }
    // Deallocate in reverse order of allocations:
    that.lc_buf = null;
    that.dist_buf = null;
    that.pending_buf = null;
    head = null;
    prev = null;
    win = null;
    // free
    that.dstate = null;
    return status == BUSY_STATE ? Z_DATA_ERROR$1 : Z_OK$1;
  };
  that.deflateParams = function (strm, _level, _strategy) {
    let err = Z_OK$1;
    if (_level == Z_DEFAULT_COMPRESSION) {
      _level = 6;
    }
    if (_level < 0 || _level > 9 || _strategy < 0 || _strategy > Z_HUFFMAN_ONLY) {
      return Z_STREAM_ERROR$1;
    }
    if (config_table[level].func != config_table[_level].func && strm.total_in !== 0) {
      // Flush the last buffer:
      err = strm.deflate(Z_PARTIAL_FLUSH);
    }
    if (level != _level) {
      level = _level;
      max_lazy_match = config_table[level].max_lazy;
      good_match = config_table[level].good_length;
      nice_match = config_table[level].nice_length;
      max_chain_length = config_table[level].max_chain;
    }
    strategy = _strategy;
    return err;
  };
  that.deflateSetDictionary = function (_strm, dictionary, dictLength) {
    let length = dictLength;
    let n,
      index = 0;
    if (!dictionary || status != INIT_STATE) return Z_STREAM_ERROR$1;
    if (length < MIN_MATCH) return Z_OK$1;
    if (length > w_size - MIN_LOOKAHEAD) {
      length = w_size - MIN_LOOKAHEAD;
      index = dictLength - length; // use the tail of the dictionary
    }
    win.set(dictionary.subarray(index, index + length), 0);
    strstart = length;
    block_start = length;

    // Insert all strings in the hash table (except for the last two bytes).
    // s->lookahead stays null, so s->ins_h will be recomputed at the next
    // call of fill_window.

    ins_h = win[0] & 0xff;
    ins_h = (ins_h << hash_shift ^ win[1] & 0xff) & hash_mask;
    for (n = 0; n <= length - MIN_MATCH; n++) {
      ins_h = (ins_h << hash_shift ^ win[n + (MIN_MATCH - 1)] & 0xff) & hash_mask;
      prev[n & w_mask] = head[ins_h];
      head[ins_h] = n;
    }
    return Z_OK$1;
  };
  that.deflate = function (_strm, flush) {
    let i, header, level_flags, old_flush, bstate;
    if (flush > Z_FINISH$1 || flush < 0) {
      return Z_STREAM_ERROR$1;
    }
    if (!_strm.next_out || !_strm.next_in && _strm.avail_in !== 0 || status == FINISH_STATE && flush != Z_FINISH$1) {
      _strm.msg = z_errmsg[Z_NEED_DICT$1 - Z_STREAM_ERROR$1];
      return Z_STREAM_ERROR$1;
    }
    if (_strm.avail_out === 0) {
      _strm.msg = z_errmsg[Z_NEED_DICT$1 - Z_BUF_ERROR$1];
      return Z_BUF_ERROR$1;
    }
    strm = _strm; // just in case
    old_flush = last_flush;
    last_flush = flush;

    // Write the zlib header
    if (status == INIT_STATE) {
      header = Z_DEFLATED$1 + (w_bits - 8 << 4) << 8;
      level_flags = (level - 1 & 0xff) >> 1;
      if (level_flags > 3) level_flags = 3;
      header |= level_flags << 6;
      if (strstart !== 0) header |= PRESET_DICT$1;
      header += 31 - header % 31;
      status = BUSY_STATE;
      putShortMSB(header);
    }

    // Flush as much pending output as possible
    if (that.pending !== 0) {
      strm.flush_pending();
      if (strm.avail_out === 0) {
        // console.log(" avail_out==0");
        // Since avail_out is 0, deflate will be called again with
        // more output space, but possibly with both pending and
        // avail_in equal to zero. There won't be anything to do,
        // but this is not an error situation so make sure we
        // return OK instead of BUF_ERROR at next call of deflate:
        last_flush = -1;
        return Z_OK$1;
      }

      // Make sure there is something to do and avoid duplicate
      // consecutive
      // flushes. For repeated and useless calls with Z_FINISH, we keep
      // returning Z_STREAM_END instead of Z_BUFF_ERROR.
    } else if (strm.avail_in === 0 && flush <= old_flush && flush != Z_FINISH$1) {
      strm.msg = z_errmsg[Z_NEED_DICT$1 - Z_BUF_ERROR$1];
      return Z_BUF_ERROR$1;
    }

    // User must not provide more input after the first FINISH:
    if (status == FINISH_STATE && strm.avail_in !== 0) {
      _strm.msg = z_errmsg[Z_NEED_DICT$1 - Z_BUF_ERROR$1];
      return Z_BUF_ERROR$1;
    }

    // Start a new block or continue the current one.
    if (strm.avail_in !== 0 || lookahead !== 0 || flush != Z_NO_FLUSH$1 && status != FINISH_STATE) {
      bstate = -1;
      switch (config_table[level].func) {
        case STORED$1:
          bstate = deflate_stored(flush);
          break;
        case FAST:
          bstate = deflate_fast(flush);
          break;
        case SLOW:
          bstate = deflate_slow(flush);
          break;
      }
      if (bstate == FinishStarted || bstate == FinishDone) {
        status = FINISH_STATE;
      }
      if (bstate == NeedMore || bstate == FinishStarted) {
        if (strm.avail_out === 0) {
          last_flush = -1; // avoid BUF_ERROR next call, see above
        }
        return Z_OK$1;
        // If flush != Z_NO_FLUSH && avail_out === 0, the next call
        // of deflate should use the same flush parameter to make sure
        // that the flush is complete. So we don't have to output an
        // empty block here, this will be done at next call. This also
        // ensures that for a very small output buffer, we emit at most
        // one empty block.
      }
      if (bstate == BlockDone) {
        if (flush == Z_PARTIAL_FLUSH) {
          _tr_align();
        } else {
          // FULL_FLUSH or SYNC_FLUSH
          _tr_stored_block(0, 0, false);
          // For a full flush, this empty block will be recognized
          // as a special marker by inflate_sync().
          if (flush == Z_FULL_FLUSH) {
            // state.head[s.hash_size-1]=0;
            for (i = 0; i < hash_size /*-1*/; i++)
            // forget history
            head[i] = 0;
          }
        }
        strm.flush_pending();
        if (strm.avail_out === 0) {
          last_flush = -1; // avoid BUF_ERROR at next call, see above
          return Z_OK$1;
        }
      }
    }
    if (flush != Z_FINISH$1) return Z_OK$1;
    return Z_STREAM_END$1;
  };
}

// ZStream

function ZStream$1() {
  const that = this;
  that.next_in_index = 0;
  that.next_out_index = 0;
  // that.next_in; // next input byte
  that.avail_in = 0; // number of bytes available at next_in
  that.total_in = 0; // total nb of input bytes read so far
  // that.next_out; // next output byte should be put there
  that.avail_out = 0; // remaining free space at next_out
  that.total_out = 0; // total nb of bytes output so far
  // that.msg;
  // that.dstate;
}
ZStream$1.prototype = {
  deflateInit(level, bits) {
    const that = this;
    that.dstate = new Deflate();
    if (!bits) bits = MAX_BITS$1;
    return that.dstate.deflateInit(that, level, bits);
  },
  deflate(flush) {
    const that = this;
    if (!that.dstate) {
      return Z_STREAM_ERROR$1;
    }
    return that.dstate.deflate(that, flush);
  },
  deflateEnd() {
    const that = this;
    if (!that.dstate) return Z_STREAM_ERROR$1;
    const ret = that.dstate.deflateEnd();
    that.dstate = null;
    return ret;
  },
  deflateParams(level, strategy) {
    const that = this;
    if (!that.dstate) return Z_STREAM_ERROR$1;
    return that.dstate.deflateParams(that, level, strategy);
  },
  deflateSetDictionary(dictionary, dictLength) {
    const that = this;
    if (!that.dstate) return Z_STREAM_ERROR$1;
    return that.dstate.deflateSetDictionary(that, dictionary, dictLength);
  },
  // Read a new buffer from the current input stream, update the
  // total number of bytes read. All deflate() input goes through
  // this function so some applications may wish to modify it to avoid
  // allocating a large strm->next_in buffer and copying from it.
  // (See also flush_pending()).
  read_buf(buf, start, size) {
    const that = this;
    let len = that.avail_in;
    if (len > size) len = size;
    if (len === 0) return 0;
    that.avail_in -= len;
    buf.set(that.next_in.subarray(that.next_in_index, that.next_in_index + len), start);
    that.next_in_index += len;
    that.total_in += len;
    return len;
  },
  // Flush as much pending output as possible. All deflate() output goes
  // through this function so some applications may wish to modify it
  // to avoid allocating a large strm->next_out buffer and copying into it.
  // (See also read_buf()).
  flush_pending() {
    const that = this;
    let len = that.dstate.pending;
    if (len > that.avail_out) len = that.avail_out;
    if (len === 0) return;

    // if (that.dstate.pending_buf.length <= that.dstate.pending_out || that.next_out.length <= that.next_out_index
    // || that.dstate.pending_buf.length < (that.dstate.pending_out + len) || that.next_out.length < (that.next_out_index +
    // len)) {
    // console.log(that.dstate.pending_buf.length + ", " + that.dstate.pending_out + ", " + that.next_out.length + ", " +
    // that.next_out_index + ", " + len);
    // console.log("avail_out=" + that.avail_out);
    // }

    that.next_out.set(that.dstate.pending_buf.subarray(that.dstate.pending_out, that.dstate.pending_out + len), that.next_out_index);
    that.next_out_index += len;
    that.dstate.pending_out += len;
    that.total_out += len;
    that.avail_out -= len;
    that.dstate.pending -= len;
    if (that.dstate.pending === 0) {
      that.dstate.pending_out = 0;
    }
  }
};

// Deflate

function ZipDeflate(options) {
  const that = this;
  const z = new ZStream$1();
  const bufsize = getMaximumCompressedSize$1(options && options.chunkSize ? options.chunkSize : 64 * 1024);
  const flush = Z_NO_FLUSH$1;
  const buf = new Uint8Array(bufsize);
  let level = options ? options.level : Z_DEFAULT_COMPRESSION;
  if (typeof level == "undefined") level = Z_DEFAULT_COMPRESSION;
  z.deflateInit(level);
  z.next_out = buf;
  that.append = function (data, onprogress) {
    let err,
      array,
      lastIndex = 0,
      bufferIndex = 0,
      bufferSize = 0;
    const buffers = [];
    if (!data.length) return;
    z.next_in_index = 0;
    z.next_in = data;
    z.avail_in = data.length;
    do {
      z.next_out_index = 0;
      z.avail_out = bufsize;
      err = z.deflate(flush);
      if (err != Z_OK$1) throw new Error("deflating: " + z.msg);
      if (z.next_out_index) if (z.next_out_index == bufsize) buffers.push(new Uint8Array(buf));else buffers.push(buf.subarray(0, z.next_out_index));
      bufferSize += z.next_out_index;
      if (onprogress && z.next_in_index > 0 && z.next_in_index != lastIndex) {
        onprogress(z.next_in_index);
        lastIndex = z.next_in_index;
      }
    } while (z.avail_in > 0 || z.avail_out === 0);
    if (buffers.length > 1) {
      array = new Uint8Array(bufferSize);
      buffers.forEach(function (chunk) {
        array.set(chunk, bufferIndex);
        bufferIndex += chunk.length;
      });
    } else {
      array = buffers[0] ? new Uint8Array(buffers[0]) : new Uint8Array();
    }
    return array;
  };
  that.flush = function () {
    let err,
      array,
      bufferIndex = 0,
      bufferSize = 0;
    const buffers = [];
    do {
      z.next_out_index = 0;
      z.avail_out = bufsize;
      err = z.deflate(Z_FINISH$1);
      if (err != Z_STREAM_END$1 && err != Z_OK$1) throw new Error("deflating: " + z.msg);
      if (bufsize - z.avail_out > 0) buffers.push(buf.slice(0, z.next_out_index));
      bufferSize += z.next_out_index;
    } while (z.avail_in > 0 || z.avail_out === 0);
    z.deflateEnd();
    array = new Uint8Array(bufferSize);
    buffers.forEach(function (chunk) {
      array.set(chunk, bufferIndex);
      bufferIndex += chunk.length;
    });
    return array;
  };
}
function getMaximumCompressedSize$1(uncompressedSize) {
  return uncompressedSize + 5 * (Math.floor(uncompressedSize / 16383) + 1);
}

/*
 Copyright (c) 2022 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright 
 notice, this list of conditions and the following disclaimer in 
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */

/*
 * This program is based on JZlib 1.0.2 ymnk, JCraft,Inc.
 * JZlib is based on zlib-1.1.3, so all credit should go authors
 * Jean-loup Gailly(jloup@gzip.org) and Mark Adler(madler@alumni.caltech.edu)
 * and contributors of zlib.
 */

// deno-lint-ignore-file no-this-alias prefer-const

// Global

const MAX_BITS = 15;
const Z_OK = 0;
const Z_STREAM_END = 1;
const Z_NEED_DICT = 2;
const Z_STREAM_ERROR = -2;
const Z_DATA_ERROR = -3;
const Z_MEM_ERROR = -4;
const Z_BUF_ERROR = -5;
const inflate_mask = [0x00000000, 0x00000001, 0x00000003, 0x00000007, 0x0000000f, 0x0000001f, 0x0000003f, 0x0000007f, 0x000000ff, 0x000001ff, 0x000003ff, 0x000007ff, 0x00000fff, 0x00001fff, 0x00003fff, 0x00007fff, 0x0000ffff];
const MANY = 1440;

// JZlib version : "1.0.2"
const Z_NO_FLUSH = 0;
const Z_FINISH = 4;

// InfTree
const fixed_bl = 9;
const fixed_bd = 5;
const fixed_tl = [96, 7, 256, 0, 8, 80, 0, 8, 16, 84, 8, 115, 82, 7, 31, 0, 8, 112, 0, 8, 48, 0, 9, 192, 80, 7, 10, 0, 8, 96, 0, 8, 32, 0, 9, 160, 0, 8, 0, 0, 8, 128, 0, 8, 64, 0, 9, 224, 80, 7, 6, 0, 8, 88, 0, 8, 24, 0, 9, 144, 83, 7, 59, 0, 8, 120, 0, 8, 56, 0, 9, 208, 81, 7, 17, 0, 8, 104, 0, 8, 40, 0, 9, 176, 0, 8, 8, 0, 8, 136, 0, 8, 72, 0, 9, 240, 80, 7, 4, 0, 8, 84, 0, 8, 20, 85, 8, 227, 83, 7, 43, 0, 8, 116, 0, 8, 52, 0, 9, 200, 81, 7, 13, 0, 8, 100, 0, 8, 36, 0, 9, 168, 0, 8, 4, 0, 8, 132, 0, 8, 68, 0, 9, 232, 80, 7, 8, 0, 8, 92, 0, 8, 28, 0, 9, 152, 84, 7, 83, 0, 8, 124, 0, 8, 60, 0, 9, 216, 82, 7, 23, 0, 8, 108, 0, 8, 44, 0, 9, 184, 0, 8, 12, 0, 8, 140, 0, 8, 76, 0, 9, 248, 80, 7, 3, 0, 8, 82, 0, 8, 18, 85, 8, 163, 83, 7, 35, 0, 8, 114, 0, 8, 50, 0, 9, 196, 81, 7, 11, 0, 8, 98, 0, 8, 34, 0, 9, 164, 0, 8, 2, 0, 8, 130, 0, 8, 66, 0, 9, 228, 80, 7, 7, 0, 8, 90, 0, 8, 26, 0, 9, 148, 84, 7, 67, 0, 8, 122, 0, 8, 58, 0, 9, 212, 82, 7, 19, 0, 8, 106, 0, 8, 42, 0, 9, 180, 0, 8, 10, 0, 8, 138, 0, 8, 74, 0, 9, 244, 80, 7, 5, 0, 8, 86, 0, 8, 22, 192, 8, 0, 83, 7, 51, 0, 8, 118, 0, 8, 54, 0, 9, 204, 81, 7, 15, 0, 8, 102, 0, 8, 38, 0, 9, 172, 0, 8, 6, 0, 8, 134, 0, 8, 70, 0, 9, 236, 80, 7, 9, 0, 8, 94, 0, 8, 30, 0, 9, 156, 84, 7, 99, 0, 8, 126, 0, 8, 62, 0, 9, 220, 82, 7, 27, 0, 8, 110, 0, 8, 46, 0, 9, 188, 0, 8, 14, 0, 8, 142, 0, 8, 78, 0, 9, 252, 96, 7, 256, 0, 8, 81, 0, 8, 17, 85, 8, 131, 82, 7, 31, 0, 8, 113, 0, 8, 49, 0, 9, 194, 80, 7, 10, 0, 8, 97, 0, 8, 33, 0, 9, 162, 0, 8, 1, 0, 8, 129, 0, 8, 65, 0, 9, 226, 80, 7, 6, 0, 8, 89, 0, 8, 25, 0, 9, 146, 83, 7, 59, 0, 8, 121, 0, 8, 57, 0, 9, 210, 81, 7, 17, 0, 8, 105, 0, 8, 41, 0, 9, 178, 0, 8, 9, 0, 8, 137, 0, 8, 73, 0, 9, 242, 80, 7, 4, 0, 8, 85, 0, 8, 21, 80, 8, 258, 83, 7, 43, 0, 8, 117, 0, 8, 53, 0, 9, 202, 81, 7, 13, 0, 8, 101, 0, 8, 37, 0, 9, 170, 0, 8, 5, 0, 8, 133, 0, 8, 69, 0, 9, 234, 80, 7, 8, 0, 8, 93, 0, 8, 29, 0, 9, 154, 84, 7, 83, 0, 8, 125, 0, 8, 61, 0, 9, 218, 82, 7, 23, 0, 8, 109, 0, 8, 45, 0, 9, 186, 0, 8, 13, 0, 8, 141, 0, 8, 77, 0, 9, 250, 80, 7, 3, 0, 8, 83, 0, 8, 19, 85, 8, 195, 83, 7, 35, 0, 8, 115, 0, 8, 51, 0, 9, 198, 81, 7, 11, 0, 8, 99, 0, 8, 35, 0, 9, 166, 0, 8, 3, 0, 8, 131, 0, 8, 67, 0, 9, 230, 80, 7, 7, 0, 8, 91, 0, 8, 27, 0, 9, 150, 84, 7, 67, 0, 8, 123, 0, 8, 59, 0, 9, 214, 82, 7, 19, 0, 8, 107, 0, 8, 43, 0, 9, 182, 0, 8, 11, 0, 8, 139, 0, 8, 75, 0, 9, 246, 80, 7, 5, 0, 8, 87, 0, 8, 23, 192, 8, 0, 83, 7, 51, 0, 8, 119, 0, 8, 55, 0, 9, 206, 81, 7, 15, 0, 8, 103, 0, 8, 39, 0, 9, 174, 0, 8, 7, 0, 8, 135, 0, 8, 71, 0, 9, 238, 80, 7, 9, 0, 8, 95, 0, 8, 31, 0, 9, 158, 84, 7, 99, 0, 8, 127, 0, 8, 63, 0, 9, 222, 82, 7, 27, 0, 8, 111, 0, 8, 47, 0, 9, 190, 0, 8, 15, 0, 8, 143, 0, 8, 79, 0, 9, 254, 96, 7, 256, 0, 8, 80, 0, 8, 16, 84, 8, 115, 82, 7, 31, 0, 8, 112, 0, 8, 48, 0, 9, 193, 80, 7, 10, 0, 8, 96, 0, 8, 32, 0, 9, 161, 0, 8, 0, 0, 8, 128, 0, 8, 64, 0, 9, 225, 80, 7, 6, 0, 8, 88, 0, 8, 24, 0, 9, 145, 83, 7, 59, 0, 8, 120, 0, 8, 56, 0, 9, 209, 81, 7, 17, 0, 8, 104, 0, 8, 40, 0, 9, 177, 0, 8, 8, 0, 8, 136, 0, 8, 72, 0, 9, 241, 80, 7, 4, 0, 8, 84, 0, 8, 20, 85, 8, 227, 83, 7, 43, 0, 8, 116, 0, 8, 52, 0, 9, 201, 81, 7, 13, 0, 8, 100, 0, 8, 36, 0, 9, 169, 0, 8, 4, 0, 8, 132, 0, 8, 68, 0, 9, 233, 80, 7, 8, 0, 8, 92, 0, 8, 28, 0, 9, 153, 84, 7, 83, 0, 8, 124, 0, 8, 60, 0, 9, 217, 82, 7, 23, 0, 8, 108, 0, 8, 44, 0, 9, 185, 0, 8, 12, 0, 8, 140, 0, 8, 76, 0, 9, 249, 80, 7, 3, 0, 8, 82, 0, 8, 18, 85, 8, 163, 83, 7, 35, 0, 8, 114, 0, 8, 50, 0, 9, 197, 81, 7, 11, 0, 8, 98, 0, 8, 34, 0, 9, 165, 0, 8, 2, 0, 8, 130, 0, 8, 66, 0, 9, 229, 80, 7, 7, 0, 8, 90, 0, 8, 26, 0, 9, 149, 84, 7, 67, 0, 8, 122, 0, 8, 58, 0, 9, 213, 82, 7, 19, 0, 8, 106, 0, 8, 42, 0, 9, 181, 0, 8, 10, 0, 8, 138, 0, 8, 74, 0, 9, 245, 80, 7, 5, 0, 8, 86, 0, 8, 22, 192, 8, 0, 83, 7, 51, 0, 8, 118, 0, 8, 54, 0, 9, 205, 81, 7, 15, 0, 8, 102, 0, 8, 38, 0, 9, 173, 0, 8, 6, 0, 8, 134, 0, 8, 70, 0, 9, 237, 80, 7, 9, 0, 8, 94, 0, 8, 30, 0, 9, 157, 84, 7, 99, 0, 8, 126, 0, 8, 62, 0, 9, 221, 82, 7, 27, 0, 8, 110, 0, 8, 46, 0, 9, 189, 0, 8, 14, 0, 8, 142, 0, 8, 78, 0, 9, 253, 96, 7, 256, 0, 8, 81, 0, 8, 17, 85, 8, 131, 82, 7, 31, 0, 8, 113, 0, 8, 49, 0, 9, 195, 80, 7, 10, 0, 8, 97, 0, 8, 33, 0, 9, 163, 0, 8, 1, 0, 8, 129, 0, 8, 65, 0, 9, 227, 80, 7, 6, 0, 8, 89, 0, 8, 25, 0, 9, 147, 83, 7, 59, 0, 8, 121, 0, 8, 57, 0, 9, 211, 81, 7, 17, 0, 8, 105, 0, 8, 41, 0, 9, 179, 0, 8, 9, 0, 8, 137, 0, 8, 73, 0, 9, 243, 80, 7, 4, 0, 8, 85, 0, 8, 21, 80, 8, 258, 83, 7, 43, 0, 8, 117, 0, 8, 53, 0, 9, 203, 81, 7, 13, 0, 8, 101, 0, 8, 37, 0, 9, 171, 0, 8, 5, 0, 8, 133, 0, 8, 69, 0, 9, 235, 80, 7, 8, 0, 8, 93, 0, 8, 29, 0, 9, 155, 84, 7, 83, 0, 8, 125, 0, 8, 61, 0, 9, 219, 82, 7, 23, 0, 8, 109, 0, 8, 45, 0, 9, 187, 0, 8, 13, 0, 8, 141, 0, 8, 77, 0, 9, 251, 80, 7, 3, 0, 8, 83, 0, 8, 19, 85, 8, 195, 83, 7, 35, 0, 8, 115, 0, 8, 51, 0, 9, 199, 81, 7, 11, 0, 8, 99, 0, 8, 35, 0, 9, 167, 0, 8, 3, 0, 8, 131, 0, 8, 67, 0, 9, 231, 80, 7, 7, 0, 8, 91, 0, 8, 27, 0, 9, 151, 84, 7, 67, 0, 8, 123, 0, 8, 59, 0, 9, 215, 82, 7, 19, 0, 8, 107, 0, 8, 43, 0, 9, 183, 0, 8, 11, 0, 8, 139, 0, 8, 75, 0, 9, 247, 80, 7, 5, 0, 8, 87, 0, 8, 23, 192, 8, 0, 83, 7, 51, 0, 8, 119, 0, 8, 55, 0, 9, 207, 81, 7, 15, 0, 8, 103, 0, 8, 39, 0, 9, 175, 0, 8, 7, 0, 8, 135, 0, 8, 71, 0, 9, 239, 80, 7, 9, 0, 8, 95, 0, 8, 31, 0, 9, 159, 84, 7, 99, 0, 8, 127, 0, 8, 63, 0, 9, 223, 82, 7, 27, 0, 8, 111, 0, 8, 47, 0, 9, 191, 0, 8, 15, 0, 8, 143, 0, 8, 79, 0, 9, 255];
const fixed_td = [80, 5, 1, 87, 5, 257, 83, 5, 17, 91, 5, 4097, 81, 5, 5, 89, 5, 1025, 85, 5, 65, 93, 5, 16385, 80, 5, 3, 88, 5, 513, 84, 5, 33, 92, 5, 8193, 82, 5, 9, 90, 5, 2049, 86, 5, 129, 192, 5, 24577, 80, 5, 2, 87, 5, 385, 83, 5, 25, 91, 5, 6145, 81, 5, 7, 89, 5, 1537, 85, 5, 97, 93, 5, 24577, 80, 5, 4, 88, 5, 769, 84, 5, 49, 92, 5, 12289, 82, 5, 13, 90, 5, 3073, 86, 5, 193, 192, 5, 24577];

// Tables for deflate from PKZIP's appnote.txt.
const cplens = [
// Copy lengths for literal codes 257..285
3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0];

// see note #13 above about 258
const cplext = [
// Extra bits for literal codes 257..285
0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, 112, 112 // 112==invalid
];
const cpdist = [
// Copy offsets for distance codes 0..29
1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577];
const cpdext = [
// Extra bits for distance codes
0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13];

// If BMAX needs to be larger than 16, then h and x[] should be uLong.
const BMAX = 15; // maximum bit length of any code

function InfTree() {
  const that = this;
  let hn; // hufts used in space
  let v; // work area for huft_build
  let c; // bit length count table
  let r; // table entry for structure assignment
  let u; // table stack
  let x; // bit offsets, then code stack

  function huft_build(b,
  // code lengths in bits (all assumed <=
  // BMAX)
  bindex, n,
  // number of codes (assumed <= 288)
  s,
  // number of simple-valued codes (0..s-1)
  d,
  // list of base values for non-simple codes
  e,
  // list of extra bits for non-simple codes
  t,
  // result: starting table
  m,
  // maximum lookup bits, returns actual
  hp,
  // space for trees
  hn,
  // hufts used in space
  v // working area: values in order of bit length
  ) {
    // Given a list of code lengths and a maximum table size, make a set of
    // tables to decode that set of codes. Return Z_OK on success,
    // Z_BUF_ERROR
    // if the given code set is incomplete (the tables are still built in
    // this
    // case), Z_DATA_ERROR if the input is invalid (an over-subscribed set
    // of
    // lengths), or Z_MEM_ERROR if not enough memory.

    let a; // counter for codes of length k
    let f; // i repeats in table every f entries
    let g; // maximum code length
    let h; // table level
    let i; // counter, current code
    let j; // counter
    let k; // number of bits in current code
    let l; // bits per table (returned in m)
    let mask; // (1 << w) - 1, to avoid cc -O bug on HP
    let p; // pointer into c[], b[], or v[]
    let q; // points to current table
    let w; // bits before this table == (l * h)
    let xp; // pointer into x
    let y; // number of dummy codes added
    let z; // number of entries in current table

    // Generate counts for each bit length

    p = 0;
    i = n;
    do {
      c[b[bindex + p]]++;
      p++;
      i--; // assume all entries <= BMAX
    } while (i !== 0);
    if (c[0] == n) {
      // null input--all zero length codes
      t[0] = -1;
      m[0] = 0;
      return Z_OK;
    }

    // Find minimum and maximum length, bound *m by those
    l = m[0];
    for (j = 1; j <= BMAX; j++) if (c[j] !== 0) break;
    k = j; // minimum code length
    if (l < j) {
      l = j;
    }
    for (i = BMAX; i !== 0; i--) {
      if (c[i] !== 0) break;
    }
    g = i; // maximum code length
    if (l > i) {
      l = i;
    }
    m[0] = l;

    // Adjust last length count to fill out codes, if needed
    for (y = 1 << j; j < i; j++, y <<= 1) {
      if ((y -= c[j]) < 0) {
        return Z_DATA_ERROR;
      }
    }
    if ((y -= c[i]) < 0) {
      return Z_DATA_ERROR;
    }
    c[i] += y;

    // Generate starting offsets into the value table for each length
    x[1] = j = 0;
    p = 1;
    xp = 2;
    while (--i !== 0) {
      // note that i == g from above
      x[xp] = j += c[p];
      xp++;
      p++;
    }

    // Make a table of values in order of bit lengths
    i = 0;
    p = 0;
    do {
      if ((j = b[bindex + p]) !== 0) {
        v[x[j]++] = i;
      }
      p++;
    } while (++i < n);
    n = x[g]; // set n to length of v

    // Generate the Huffman codes and for each, make the table entries
    x[0] = i = 0; // first Huffman code is zero
    p = 0; // grab values in bit order
    h = -1; // no tables yet--level -1
    w = -l; // bits decoded == (l * h)
    u[0] = 0; // just to keep compilers happy
    q = 0; // ditto
    z = 0; // ditto

    // go through the bit lengths (k already is bits in shortest code)
    for (; k <= g; k++) {
      a = c[k];
      while (a-- !== 0) {
        // here i is the Huffman code of length k bits for value *p
        // make tables up to required level
        while (k > w + l) {
          h++;
          w += l; // previous table always l bits
          // compute minimum size table less than or equal to l bits
          z = g - w;
          z = z > l ? l : z; // table size upper limit
          if ((f = 1 << (j = k - w)) > a + 1) {
            // try a k-w bit table
            // too few codes for
            // k-w bit table
            f -= a + 1; // deduct codes from patterns left
            xp = k;
            if (j < z) {
              while (++j < z) {
                // try smaller tables up to z bits
                if ((f <<= 1) <= c[++xp]) break; // enough codes to use up j bits
                f -= c[xp]; // else deduct codes from patterns
              }
            }
          }
          z = 1 << j; // table entries for j-bit table

          // allocate new table
          if (hn[0] + z > MANY) {
            // (note: doesn't matter for fixed)
            return Z_DATA_ERROR; // overflow of MANY
          }
          u[h] = q = /* hp+ */hn[0]; // DEBUG
          hn[0] += z;

          // connect to last table, if there is one
          if (h !== 0) {
            x[h] = i; // save pattern for backing up
            r[0] = /* (byte) */j; // bits in this table
            r[1] = /* (byte) */l; // bits to dump before this table
            j = i >>> w - l;
            r[2] = /* (int) */q - u[h - 1] - j; // offset to this table
            hp.set(r, (u[h - 1] + j) * 3);
            // to
            // last
            // table
          } else {
            t[0] = q; // first table is returned result
          }
        }

        // set up table entry in r
        r[1] = /* (byte) */k - w;
        if (p >= n) {
          r[0] = 128 + 64; // out of values--invalid code
        } else if (v[p] < s) {
          r[0] = /* (byte) */v[p] < 256 ? 0 : 32 + 64; // 256 is
          // end-of-block
          r[2] = v[p++]; // simple code is just the value
        } else {
          r[0] = /* (byte) */e[v[p] - s] + 16 + 64; // non-simple--look
          // up in lists
          r[2] = d[v[p++] - s];
        }

        // fill code-like entries with r
        f = 1 << k - w;
        for (j = i >>> w; j < z; j += f) {
          hp.set(r, (q + j) * 3);
        }

        // backwards increment the k-bit code i
        for (j = 1 << k - 1; (i & j) !== 0; j >>>= 1) {
          i ^= j;
        }
        i ^= j;

        // backup over finished tables
        mask = (1 << w) - 1; // needed on HP, cc -O bug
        while ((i & mask) != x[h]) {
          h--; // don't need to update q
          w -= l;
          mask = (1 << w) - 1;
        }
      }
    }
    // Return Z_BUF_ERROR if we were given an incomplete table
    return y !== 0 && g != 1 ? Z_BUF_ERROR : Z_OK;
  }
  function initWorkArea(vsize) {
    let i;
    if (!hn) {
      hn = []; // []; //new Array(1);
      v = []; // new Array(vsize);
      c = new Int32Array(BMAX + 1); // new Array(BMAX + 1);
      r = []; // new Array(3);
      u = new Int32Array(BMAX); // new Array(BMAX);
      x = new Int32Array(BMAX + 1); // new Array(BMAX + 1);
    }
    if (v.length < vsize) {
      v = []; // new Array(vsize);
    }
    for (i = 0; i < vsize; i++) {
      v[i] = 0;
    }
    for (i = 0; i < BMAX + 1; i++) {
      c[i] = 0;
    }
    for (i = 0; i < 3; i++) {
      r[i] = 0;
    }
    // for(int i=0; i<BMAX; i++){u[i]=0;}
    u.set(c.subarray(0, BMAX), 0);
    // for(int i=0; i<BMAX+1; i++){x[i]=0;}
    x.set(c.subarray(0, BMAX + 1), 0);
  }
  that.inflate_trees_bits = function (c,
  // 19 code lengths
  bb,
  // bits tree desired/actual depth
  tb,
  // bits tree result
  hp,
  // space for trees
  z // for messages
  ) {
    let result;
    initWorkArea(19);
    hn[0] = 0;
    result = huft_build(c, 0, 19, 19, null, null, tb, bb, hp, hn, v);
    if (result == Z_DATA_ERROR) {
      z.msg = "oversubscribed dynamic bit lengths tree";
    } else if (result == Z_BUF_ERROR || bb[0] === 0) {
      z.msg = "incomplete dynamic bit lengths tree";
      result = Z_DATA_ERROR;
    }
    return result;
  };
  that.inflate_trees_dynamic = function (nl,
  // number of literal/length codes
  nd,
  // number of distance codes
  c,
  // that many (total) code lengths
  bl,
  // literal desired/actual bit depth
  bd,
  // distance desired/actual bit depth
  tl,
  // literal/length tree result
  td,
  // distance tree result
  hp,
  // space for trees
  z // for messages
  ) {
    let result;

    // build literal/length tree
    initWorkArea(288);
    hn[0] = 0;
    result = huft_build(c, 0, nl, 257, cplens, cplext, tl, bl, hp, hn, v);
    if (result != Z_OK || bl[0] === 0) {
      if (result == Z_DATA_ERROR) {
        z.msg = "oversubscribed literal/length tree";
      } else if (result != Z_MEM_ERROR) {
        z.msg = "incomplete literal/length tree";
        result = Z_DATA_ERROR;
      }
      return result;
    }

    // build distance tree
    initWorkArea(288);
    result = huft_build(c, nl, nd, 0, cpdist, cpdext, td, bd, hp, hn, v);
    if (result != Z_OK || bd[0] === 0 && nl > 257) {
      if (result == Z_DATA_ERROR) {
        z.msg = "oversubscribed distance tree";
      } else if (result == Z_BUF_ERROR) {
        z.msg = "incomplete distance tree";
        result = Z_DATA_ERROR;
      } else if (result != Z_MEM_ERROR) {
        z.msg = "empty distance tree with lengths";
        result = Z_DATA_ERROR;
      }
      return result;
    }
    return Z_OK;
  };
}
InfTree.inflate_trees_fixed = function (bl,
// literal desired/actual bit depth
bd,
// distance desired/actual bit depth
tl,
// literal/length tree result
td // distance tree result
) {
  bl[0] = fixed_bl;
  bd[0] = fixed_bd;
  tl[0] = fixed_tl;
  td[0] = fixed_td;
  return Z_OK;
};

// InfCodes

// waiting for "i:"=input,
// "o:"=output,
// "x:"=nothing
const START = 0; // x: set up for LEN
const LEN = 1; // i: get length/literal/eob next
const LENEXT = 2; // i: getting length extra (have base)
const DIST = 3; // i: get distance next
const DISTEXT = 4; // i: getting distance extra
const COPY = 5; // o: copying bytes in win, waiting
// for space
const LIT = 6; // o: got literal, waiting for output
// space
const WASH = 7; // o: got eob, possibly still output
// waiting
const END = 8; // x: got eob and all data flushed
const BADCODE = 9; // x: got error

function InfCodes() {
  const that = this;
  let mode; // current inflate_codes mode

  // mode dependent information
  let len = 0;
  let tree; // pointer into tree
  let tree_index = 0;
  let need = 0; // bits needed

  let lit = 0;

  // if EXT or COPY, where and how much
  let get = 0; // bits to get for extra
  let dist = 0; // distance back to copy from

  let lbits = 0; // ltree bits decoded per branch
  let dbits = 0; // dtree bits decoder per branch
  let ltree; // literal/length/eob tree
  let ltree_index = 0; // literal/length/eob tree
  let dtree; // distance tree
  let dtree_index = 0; // distance tree

  // Called with number of bytes left to write in win at least 258
  // (the maximum string length) and number of input bytes available
  // at least ten. The ten bytes are six bytes for the longest length/
  // distance pair plus four bytes for overloading the bit buffer.

  function inflate_fast(bl, bd, tl, tl_index, td, td_index, s, z) {
    let t; // temporary pointer
    let tp; // temporary pointer
    let tp_index; // temporary pointer
    let e; // extra bits or operation
    let b; // bit buffer
    let k; // bits in bit buffer
    let p; // input data pointer
    let n; // bytes available there
    let q; // output win write pointer
    let m; // bytes to end of win or read pointer
    let ml; // mask for literal/length tree
    let md; // mask for distance tree
    let c; // bytes to copy
    let d; // distance back to copy from
    let r; // copy source pointer

    let tp_index_t_3; // (tp_index+t)*3

    // load input, output, bit values
    p = z.next_in_index;
    n = z.avail_in;
    b = s.bitb;
    k = s.bitk;
    q = s.write;
    m = q < s.read ? s.read - q - 1 : s.end - q;

    // initialize masks
    ml = inflate_mask[bl];
    md = inflate_mask[bd];

    // do until not enough input or output space for fast loop
    do {
      // assume called with m >= 258 && n >= 10
      // get literal/length code
      while (k < 20) {
        // max bits for literal/length code
        n--;
        b |= (z.read_byte(p++) & 0xff) << k;
        k += 8;
      }
      t = b & ml;
      tp = tl;
      tp_index = tl_index;
      tp_index_t_3 = (tp_index + t) * 3;
      if ((e = tp[tp_index_t_3]) === 0) {
        b >>= tp[tp_index_t_3 + 1];
        k -= tp[tp_index_t_3 + 1];
        s.win[q++] = /* (byte) */tp[tp_index_t_3 + 2];
        m--;
        continue;
      }
      do {
        b >>= tp[tp_index_t_3 + 1];
        k -= tp[tp_index_t_3 + 1];
        if ((e & 16) !== 0) {
          e &= 15;
          c = tp[tp_index_t_3 + 2] + ( /* (int) */b & inflate_mask[e]);
          b >>= e;
          k -= e;

          // decode distance base of block to copy
          while (k < 15) {
            // max bits for distance code
            n--;
            b |= (z.read_byte(p++) & 0xff) << k;
            k += 8;
          }
          t = b & md;
          tp = td;
          tp_index = td_index;
          tp_index_t_3 = (tp_index + t) * 3;
          e = tp[tp_index_t_3];
          do {
            b >>= tp[tp_index_t_3 + 1];
            k -= tp[tp_index_t_3 + 1];
            if ((e & 16) !== 0) {
              // get extra bits to add to distance base
              e &= 15;
              while (k < e) {
                // get extra bits (up to 13)
                n--;
                b |= (z.read_byte(p++) & 0xff) << k;
                k += 8;
              }
              d = tp[tp_index_t_3 + 2] + (b & inflate_mask[e]);
              b >>= e;
              k -= e;

              // do the copy
              m -= c;
              if (q >= d) {
                // offset before dest
                // just copy
                r = q - d;
                if (q - r > 0 && 2 > q - r) {
                  s.win[q++] = s.win[r++]; // minimum
                  // count is
                  // three,
                  s.win[q++] = s.win[r++]; // so unroll
                  // loop a
                  // little
                  c -= 2;
                } else {
                  s.win.set(s.win.subarray(r, r + 2), q);
                  q += 2;
                  r += 2;
                  c -= 2;
                }
              } else {
                // else offset after destination
                r = q - d;
                do {
                  r += s.end; // force pointer in win
                } while (r < 0); // covers invalid distances
                e = s.end - r;
                if (c > e) {
                  // if source crosses,
                  c -= e; // wrapped copy
                  if (q - r > 0 && e > q - r) {
                    do {
                      s.win[q++] = s.win[r++];
                    } while (--e !== 0);
                  } else {
                    s.win.set(s.win.subarray(r, r + e), q);
                    q += e;
                    r += e;
                    e = 0;
                  }
                  r = 0; // copy rest from start of win
                }
              }

              // copy all or what's left
              if (q - r > 0 && c > q - r) {
                do {
                  s.win[q++] = s.win[r++];
                } while (--c !== 0);
              } else {
                s.win.set(s.win.subarray(r, r + c), q);
                q += c;
                r += c;
                c = 0;
              }
              break;
            } else if ((e & 64) === 0) {
              t += tp[tp_index_t_3 + 2];
              t += b & inflate_mask[e];
              tp_index_t_3 = (tp_index + t) * 3;
              e = tp[tp_index_t_3];
            } else {
              z.msg = "invalid distance code";
              c = z.avail_in - n;
              c = k >> 3 < c ? k >> 3 : c;
              n += c;
              p -= c;
              k -= c << 3;
              s.bitb = b;
              s.bitk = k;
              z.avail_in = n;
              z.total_in += p - z.next_in_index;
              z.next_in_index = p;
              s.write = q;
              return Z_DATA_ERROR;
            }
            // eslint-disable-next-line no-constant-condition
          } while (true);
          break;
        }
        if ((e & 64) === 0) {
          t += tp[tp_index_t_3 + 2];
          t += b & inflate_mask[e];
          tp_index_t_3 = (tp_index + t) * 3;
          if ((e = tp[tp_index_t_3]) === 0) {
            b >>= tp[tp_index_t_3 + 1];
            k -= tp[tp_index_t_3 + 1];
            s.win[q++] = /* (byte) */tp[tp_index_t_3 + 2];
            m--;
            break;
          }
        } else if ((e & 32) !== 0) {
          c = z.avail_in - n;
          c = k >> 3 < c ? k >> 3 : c;
          n += c;
          p -= c;
          k -= c << 3;
          s.bitb = b;
          s.bitk = k;
          z.avail_in = n;
          z.total_in += p - z.next_in_index;
          z.next_in_index = p;
          s.write = q;
          return Z_STREAM_END;
        } else {
          z.msg = "invalid literal/length code";
          c = z.avail_in - n;
          c = k >> 3 < c ? k >> 3 : c;
          n += c;
          p -= c;
          k -= c << 3;
          s.bitb = b;
          s.bitk = k;
          z.avail_in = n;
          z.total_in += p - z.next_in_index;
          z.next_in_index = p;
          s.write = q;
          return Z_DATA_ERROR;
        }
        // eslint-disable-next-line no-constant-condition
      } while (true);
    } while (m >= 258 && n >= 10);

    // not enough input or output--restore pointers and return
    c = z.avail_in - n;
    c = k >> 3 < c ? k >> 3 : c;
    n += c;
    p -= c;
    k -= c << 3;
    s.bitb = b;
    s.bitk = k;
    z.avail_in = n;
    z.total_in += p - z.next_in_index;
    z.next_in_index = p;
    s.write = q;
    return Z_OK;
  }
  that.init = function (bl, bd, tl, tl_index, td, td_index) {
    mode = START;
    lbits = /* (byte) */bl;
    dbits = /* (byte) */bd;
    ltree = tl;
    ltree_index = tl_index;
    dtree = td;
    dtree_index = td_index;
    tree = null;
  };
  that.proc = function (s, z, r) {
    let j; // temporary storage
    let tindex; // temporary pointer
    let e; // extra bits or operation
    let b = 0; // bit buffer
    let k = 0; // bits in bit buffer
    let p = 0; // input data pointer
    let n; // bytes available there
    let q; // output win write pointer
    let m; // bytes to end of win or read pointer
    let f; // pointer to copy strings from

    // copy input/output information to locals (UPDATE macro restores)
    p = z.next_in_index;
    n = z.avail_in;
    b = s.bitb;
    k = s.bitk;
    q = s.write;
    m = q < s.read ? s.read - q - 1 : s.end - q;

    // process input and output based on current state
    // eslint-disable-next-line no-constant-condition
    while (true) {
      switch (mode) {
        // waiting for "i:"=input, "o:"=output, "x:"=nothing
        case START:
          // x: set up for LEN
          if (m >= 258 && n >= 10) {
            s.bitb = b;
            s.bitk = k;
            z.avail_in = n;
            z.total_in += p - z.next_in_index;
            z.next_in_index = p;
            s.write = q;
            r = inflate_fast(lbits, dbits, ltree, ltree_index, dtree, dtree_index, s, z);
            p = z.next_in_index;
            n = z.avail_in;
            b = s.bitb;
            k = s.bitk;
            q = s.write;
            m = q < s.read ? s.read - q - 1 : s.end - q;
            if (r != Z_OK) {
              mode = r == Z_STREAM_END ? WASH : BADCODE;
              break;
            }
          }
          need = lbits;
          tree = ltree;
          tree_index = ltree_index;
          mode = LEN;
        /* falls through */
        case LEN:
          // i: get length/literal/eob next
          j = need;
          while (k < j) {
            if (n !== 0) r = Z_OK;else {
              s.bitb = b;
              s.bitk = k;
              z.avail_in = n;
              z.total_in += p - z.next_in_index;
              z.next_in_index = p;
              s.write = q;
              return s.inflate_flush(z, r);
            }
            n--;
            b |= (z.read_byte(p++) & 0xff) << k;
            k += 8;
          }
          tindex = (tree_index + (b & inflate_mask[j])) * 3;
          b >>>= tree[tindex + 1];
          k -= tree[tindex + 1];
          e = tree[tindex];
          if (e === 0) {
            // literal
            lit = tree[tindex + 2];
            mode = LIT;
            break;
          }
          if ((e & 16) !== 0) {
            // length
            get = e & 15;
            len = tree[tindex + 2];
            mode = LENEXT;
            break;
          }
          if ((e & 64) === 0) {
            // next table
            need = e;
            tree_index = tindex / 3 + tree[tindex + 2];
            break;
          }
          if ((e & 32) !== 0) {
            // end of block
            mode = WASH;
            break;
          }
          mode = BADCODE; // invalid code
          z.msg = "invalid literal/length code";
          r = Z_DATA_ERROR;
          s.bitb = b;
          s.bitk = k;
          z.avail_in = n;
          z.total_in += p - z.next_in_index;
          z.next_in_index = p;
          s.write = q;
          return s.inflate_flush(z, r);
        case LENEXT:
          // i: getting length extra (have base)
          j = get;
          while (k < j) {
            if (n !== 0) r = Z_OK;else {
              s.bitb = b;
              s.bitk = k;
              z.avail_in = n;
              z.total_in += p - z.next_in_index;
              z.next_in_index = p;
              s.write = q;
              return s.inflate_flush(z, r);
            }
            n--;
            b |= (z.read_byte(p++) & 0xff) << k;
            k += 8;
          }
          len += b & inflate_mask[j];
          b >>= j;
          k -= j;
          need = dbits;
          tree = dtree;
          tree_index = dtree_index;
          mode = DIST;
        /* falls through */
        case DIST:
          // i: get distance next
          j = need;
          while (k < j) {
            if (n !== 0) r = Z_OK;else {
              s.bitb = b;
              s.bitk = k;
              z.avail_in = n;
              z.total_in += p - z.next_in_index;
              z.next_in_index = p;
              s.write = q;
              return s.inflate_flush(z, r);
            }
            n--;
            b |= (z.read_byte(p++) & 0xff) << k;
            k += 8;
          }
          tindex = (tree_index + (b & inflate_mask[j])) * 3;
          b >>= tree[tindex + 1];
          k -= tree[tindex + 1];
          e = tree[tindex];
          if ((e & 16) !== 0) {
            // distance
            get = e & 15;
            dist = tree[tindex + 2];
            mode = DISTEXT;
            break;
          }
          if ((e & 64) === 0) {
            // next table
            need = e;
            tree_index = tindex / 3 + tree[tindex + 2];
            break;
          }
          mode = BADCODE; // invalid code
          z.msg = "invalid distance code";
          r = Z_DATA_ERROR;
          s.bitb = b;
          s.bitk = k;
          z.avail_in = n;
          z.total_in += p - z.next_in_index;
          z.next_in_index = p;
          s.write = q;
          return s.inflate_flush(z, r);
        case DISTEXT:
          // i: getting distance extra
          j = get;
          while (k < j) {
            if (n !== 0) r = Z_OK;else {
              s.bitb = b;
              s.bitk = k;
              z.avail_in = n;
              z.total_in += p - z.next_in_index;
              z.next_in_index = p;
              s.write = q;
              return s.inflate_flush(z, r);
            }
            n--;
            b |= (z.read_byte(p++) & 0xff) << k;
            k += 8;
          }
          dist += b & inflate_mask[j];
          b >>= j;
          k -= j;
          mode = COPY;
        /* falls through */
        case COPY:
          // o: copying bytes in win, waiting for space
          f = q - dist;
          while (f < 0) {
            // modulo win size-"while" instead
            f += s.end; // of "if" handles invalid distances
          }
          while (len !== 0) {
            if (m === 0) {
              if (q == s.end && s.read !== 0) {
                q = 0;
                m = q < s.read ? s.read - q - 1 : s.end - q;
              }
              if (m === 0) {
                s.write = q;
                r = s.inflate_flush(z, r);
                q = s.write;
                m = q < s.read ? s.read - q - 1 : s.end - q;
                if (q == s.end && s.read !== 0) {
                  q = 0;
                  m = q < s.read ? s.read - q - 1 : s.end - q;
                }
                if (m === 0) {
                  s.bitb = b;
                  s.bitk = k;
                  z.avail_in = n;
                  z.total_in += p - z.next_in_index;
                  z.next_in_index = p;
                  s.write = q;
                  return s.inflate_flush(z, r);
                }
              }
            }
            s.win[q++] = s.win[f++];
            m--;
            if (f == s.end) f = 0;
            len--;
          }
          mode = START;
          break;
        case LIT:
          // o: got literal, waiting for output space
          if (m === 0) {
            if (q == s.end && s.read !== 0) {
              q = 0;
              m = q < s.read ? s.read - q - 1 : s.end - q;
            }
            if (m === 0) {
              s.write = q;
              r = s.inflate_flush(z, r);
              q = s.write;
              m = q < s.read ? s.read - q - 1 : s.end - q;
              if (q == s.end && s.read !== 0) {
                q = 0;
                m = q < s.read ? s.read - q - 1 : s.end - q;
              }
              if (m === 0) {
                s.bitb = b;
                s.bitk = k;
                z.avail_in = n;
                z.total_in += p - z.next_in_index;
                z.next_in_index = p;
                s.write = q;
                return s.inflate_flush(z, r);
              }
            }
          }
          r = Z_OK;
          s.win[q++] = /* (byte) */lit;
          m--;
          mode = START;
          break;
        case WASH:
          // o: got eob, possibly more output
          if (k > 7) {
            // return unused byte, if any
            k -= 8;
            n++;
            p--; // can always return one
          }
          s.write = q;
          r = s.inflate_flush(z, r);
          q = s.write;
          m = q < s.read ? s.read - q - 1 : s.end - q;
          if (s.read != s.write) {
            s.bitb = b;
            s.bitk = k;
            z.avail_in = n;
            z.total_in += p - z.next_in_index;
            z.next_in_index = p;
            s.write = q;
            return s.inflate_flush(z, r);
          }
          mode = END;
        /* falls through */
        case END:
          r = Z_STREAM_END;
          s.bitb = b;
          s.bitk = k;
          z.avail_in = n;
          z.total_in += p - z.next_in_index;
          z.next_in_index = p;
          s.write = q;
          return s.inflate_flush(z, r);
        case BADCODE:
          // x: got error

          r = Z_DATA_ERROR;
          s.bitb = b;
          s.bitk = k;
          z.avail_in = n;
          z.total_in += p - z.next_in_index;
          z.next_in_index = p;
          s.write = q;
          return s.inflate_flush(z, r);
        default:
          r = Z_STREAM_ERROR;
          s.bitb = b;
          s.bitk = k;
          z.avail_in = n;
          z.total_in += p - z.next_in_index;
          z.next_in_index = p;
          s.write = q;
          return s.inflate_flush(z, r);
      }
    }
  };
  that.free = function () {
    // ZFREE(z, c);
  };
}

// InfBlocks

// Table for deflate from PKZIP's appnote.txt.
const border = [
// Order of the bit length code lengths
16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];
const TYPE = 0; // get type bits (3, including end bit)
const LENS = 1; // get lengths for stored
const STORED = 2; // processing stored block
const TABLE = 3; // get table lengths
const BTREE = 4; // get bit lengths tree for a dynamic
// block
const DTREE = 5; // get length, distance trees for a
// dynamic block
const CODES = 6; // processing fixed or dynamic block
const DRY = 7; // output remaining win bytes
const DONELOCKS = 8; // finished last block, done
const BADBLOCKS = 9; // ot a data error--stuck here

function InfBlocks(z, w) {
  const that = this;
  let mode = TYPE; // current inflate_block mode

  let left = 0; // if STORED, bytes left to copy

  let table = 0; // table lengths (14 bits)
  let index = 0; // index into blens (or border)
  let blens; // bit lengths of codes
  const bb = [0]; // bit length tree depth
  const tb = [0]; // bit length decoding tree

  const codes = new InfCodes(); // if CODES, current state

  let last = 0; // true if this block is the last block

  let hufts = new Int32Array(MANY * 3); // single malloc for tree space
  const check = 0; // check on output
  const inftree = new InfTree();
  that.bitk = 0; // bits in bit buffer
  that.bitb = 0; // bit buffer
  that.win = new Uint8Array(w); // sliding win
  that.end = w; // one byte after sliding win
  that.read = 0; // win read pointer
  that.write = 0; // win write pointer

  that.reset = function (z, c) {
    if (c) c[0] = check;
    // if (mode == BTREE || mode == DTREE) {
    // }
    if (mode == CODES) {
      codes.free(z);
    }
    mode = TYPE;
    that.bitk = 0;
    that.bitb = 0;
    that.read = that.write = 0;
  };
  that.reset(z, null);

  // copy as much as possible from the sliding win to the output area
  that.inflate_flush = function (z, r) {
    let n;
    let p;
    let q;

    // local copies of source and destination pointers
    p = z.next_out_index;
    q = that.read;

    // compute number of bytes to copy as far as end of win
    n = /* (int) */(q <= that.write ? that.write : that.end) - q;
    if (n > z.avail_out) n = z.avail_out;
    if (n !== 0 && r == Z_BUF_ERROR) r = Z_OK;

    // update counters
    z.avail_out -= n;
    z.total_out += n;

    // copy as far as end of win
    z.next_out.set(that.win.subarray(q, q + n), p);
    p += n;
    q += n;

    // see if more to copy at beginning of win
    if (q == that.end) {
      // wrap pointers
      q = 0;
      if (that.write == that.end) that.write = 0;

      // compute bytes to copy
      n = that.write - q;
      if (n > z.avail_out) n = z.avail_out;
      if (n !== 0 && r == Z_BUF_ERROR) r = Z_OK;

      // update counters
      z.avail_out -= n;
      z.total_out += n;

      // copy
      z.next_out.set(that.win.subarray(q, q + n), p);
      p += n;
      q += n;
    }

    // update pointers
    z.next_out_index = p;
    that.read = q;

    // done
    return r;
  };
  that.proc = function (z, r) {
    let t; // temporary storage
    let b; // bit buffer
    let k; // bits in bit buffer
    let p; // input data pointer
    let n; // bytes available there
    let q; // output win write pointer
    let m; // bytes to end of win or read pointer

    let i;

    // copy input/output information to locals (UPDATE macro restores)
    // {
    p = z.next_in_index;
    n = z.avail_in;
    b = that.bitb;
    k = that.bitk;
    // }
    // {
    q = that.write;
    m = /* (int) */q < that.read ? that.read - q - 1 : that.end - q;
    // }

    // process input based on current state
    // DEBUG dtree
    // eslint-disable-next-line no-constant-condition
    while (true) {
      let bl, bd, tl, td, bl_, bd_, tl_, td_;
      switch (mode) {
        case TYPE:
          while (k < 3) {
            if (n !== 0) {
              r = Z_OK;
            } else {
              that.bitb = b;
              that.bitk = k;
              z.avail_in = n;
              z.total_in += p - z.next_in_index;
              z.next_in_index = p;
              that.write = q;
              return that.inflate_flush(z, r);
            }
            n--;
            b |= (z.read_byte(p++) & 0xff) << k;
            k += 8;
          }
          t = /* (int) */b & 7;
          last = t & 1;
          switch (t >>> 1) {
            case 0:
              // stored
              // {
              b >>>= 3;
              k -= 3;
              // }
              t = k & 7; // go to byte boundary

              // {
              b >>>= t;
              k -= t;
              // }
              mode = LENS; // get length of stored block
              break;
            case 1:
              // fixed
              // {
              bl = []; // new Array(1);
              bd = []; // new Array(1);
              tl = [[]]; // new Array(1);
              td = [[]]; // new Array(1);

              InfTree.inflate_trees_fixed(bl, bd, tl, td);
              codes.init(bl[0], bd[0], tl[0], 0, td[0], 0);
              // }

              // {
              b >>>= 3;
              k -= 3;
              // }

              mode = CODES;
              break;
            case 2:
              // dynamic

              // {
              b >>>= 3;
              k -= 3;
              // }

              mode = TABLE;
              break;
            case 3:
              // illegal

              // {
              b >>>= 3;
              k -= 3;
              // }
              mode = BADBLOCKS;
              z.msg = "invalid block type";
              r = Z_DATA_ERROR;
              that.bitb = b;
              that.bitk = k;
              z.avail_in = n;
              z.total_in += p - z.next_in_index;
              z.next_in_index = p;
              that.write = q;
              return that.inflate_flush(z, r);
          }
          break;
        case LENS:
          while (k < 32) {
            if (n !== 0) {
              r = Z_OK;
            } else {
              that.bitb = b;
              that.bitk = k;
              z.avail_in = n;
              z.total_in += p - z.next_in_index;
              z.next_in_index = p;
              that.write = q;
              return that.inflate_flush(z, r);
            }
            n--;
            b |= (z.read_byte(p++) & 0xff) << k;
            k += 8;
          }
          if ((~b >>> 16 & 0xffff) != (b & 0xffff)) {
            mode = BADBLOCKS;
            z.msg = "invalid stored block lengths";
            r = Z_DATA_ERROR;
            that.bitb = b;
            that.bitk = k;
            z.avail_in = n;
            z.total_in += p - z.next_in_index;
            z.next_in_index = p;
            that.write = q;
            return that.inflate_flush(z, r);
          }
          left = b & 0xffff;
          b = k = 0; // dump bits
          mode = left !== 0 ? STORED : last !== 0 ? DRY : TYPE;
          break;
        case STORED:
          if (n === 0) {
            that.bitb = b;
            that.bitk = k;
            z.avail_in = n;
            z.total_in += p - z.next_in_index;
            z.next_in_index = p;
            that.write = q;
            return that.inflate_flush(z, r);
          }
          if (m === 0) {
            if (q == that.end && that.read !== 0) {
              q = 0;
              m = /* (int) */q < that.read ? that.read - q - 1 : that.end - q;
            }
            if (m === 0) {
              that.write = q;
              r = that.inflate_flush(z, r);
              q = that.write;
              m = /* (int) */q < that.read ? that.read - q - 1 : that.end - q;
              if (q == that.end && that.read !== 0) {
                q = 0;
                m = /* (int) */q < that.read ? that.read - q - 1 : that.end - q;
              }
              if (m === 0) {
                that.bitb = b;
                that.bitk = k;
                z.avail_in = n;
                z.total_in += p - z.next_in_index;
                z.next_in_index = p;
                that.write = q;
                return that.inflate_flush(z, r);
              }
            }
          }
          r = Z_OK;
          t = left;
          if (t > n) t = n;
          if (t > m) t = m;
          that.win.set(z.read_buf(p, t), q);
          p += t;
          n -= t;
          q += t;
          m -= t;
          if ((left -= t) !== 0) break;
          mode = last !== 0 ? DRY : TYPE;
          break;
        case TABLE:
          while (k < 14) {
            if (n !== 0) {
              r = Z_OK;
            } else {
              that.bitb = b;
              that.bitk = k;
              z.avail_in = n;
              z.total_in += p - z.next_in_index;
              z.next_in_index = p;
              that.write = q;
              return that.inflate_flush(z, r);
            }
            n--;
            b |= (z.read_byte(p++) & 0xff) << k;
            k += 8;
          }
          table = t = b & 0x3fff;
          if ((t & 0x1f) > 29 || (t >> 5 & 0x1f) > 29) {
            mode = BADBLOCKS;
            z.msg = "too many length or distance symbols";
            r = Z_DATA_ERROR;
            that.bitb = b;
            that.bitk = k;
            z.avail_in = n;
            z.total_in += p - z.next_in_index;
            z.next_in_index = p;
            that.write = q;
            return that.inflate_flush(z, r);
          }
          t = 258 + (t & 0x1f) + (t >> 5 & 0x1f);
          if (!blens || blens.length < t) {
            blens = []; // new Array(t);
          } else {
            for (i = 0; i < t; i++) {
              blens[i] = 0;
            }
          }

          // {
          b >>>= 14;
          k -= 14;
          // }

          index = 0;
          mode = BTREE;
        /* falls through */
        case BTREE:
          while (index < 4 + (table >>> 10)) {
            while (k < 3) {
              if (n !== 0) {
                r = Z_OK;
              } else {
                that.bitb = b;
                that.bitk = k;
                z.avail_in = n;
                z.total_in += p - z.next_in_index;
                z.next_in_index = p;
                that.write = q;
                return that.inflate_flush(z, r);
              }
              n--;
              b |= (z.read_byte(p++) & 0xff) << k;
              k += 8;
            }
            blens[border[index++]] = b & 7;

            // {
            b >>>= 3;
            k -= 3;
            // }
          }
          while (index < 19) {
            blens[border[index++]] = 0;
          }
          bb[0] = 7;
          t = inftree.inflate_trees_bits(blens, bb, tb, hufts, z);
          if (t != Z_OK) {
            r = t;
            if (r == Z_DATA_ERROR) {
              blens = null;
              mode = BADBLOCKS;
            }
            that.bitb = b;
            that.bitk = k;
            z.avail_in = n;
            z.total_in += p - z.next_in_index;
            z.next_in_index = p;
            that.write = q;
            return that.inflate_flush(z, r);
          }
          index = 0;
          mode = DTREE;
        /* falls through */
        case DTREE:
          // eslint-disable-next-line no-constant-condition
          while (true) {
            t = table;
            if (index >= 258 + (t & 0x1f) + (t >> 5 & 0x1f)) {
              break;
            }
            let j, c;
            t = bb[0];
            while (k < t) {
              if (n !== 0) {
                r = Z_OK;
              } else {
                that.bitb = b;
                that.bitk = k;
                z.avail_in = n;
                z.total_in += p - z.next_in_index;
                z.next_in_index = p;
                that.write = q;
                return that.inflate_flush(z, r);
              }
              n--;
              b |= (z.read_byte(p++) & 0xff) << k;
              k += 8;
            }

            // if (tb[0] == -1) {
            // System.err.println("null...");
            // }

            t = hufts[(tb[0] + (b & inflate_mask[t])) * 3 + 1];
            c = hufts[(tb[0] + (b & inflate_mask[t])) * 3 + 2];
            if (c < 16) {
              b >>>= t;
              k -= t;
              blens[index++] = c;
            } else {
              // c == 16..18
              i = c == 18 ? 7 : c - 14;
              j = c == 18 ? 11 : 3;
              while (k < t + i) {
                if (n !== 0) {
                  r = Z_OK;
                } else {
                  that.bitb = b;
                  that.bitk = k;
                  z.avail_in = n;
                  z.total_in += p - z.next_in_index;
                  z.next_in_index = p;
                  that.write = q;
                  return that.inflate_flush(z, r);
                }
                n--;
                b |= (z.read_byte(p++) & 0xff) << k;
                k += 8;
              }
              b >>>= t;
              k -= t;
              j += b & inflate_mask[i];
              b >>>= i;
              k -= i;
              i = index;
              t = table;
              if (i + j > 258 + (t & 0x1f) + (t >> 5 & 0x1f) || c == 16 && i < 1) {
                blens = null;
                mode = BADBLOCKS;
                z.msg = "invalid bit length repeat";
                r = Z_DATA_ERROR;
                that.bitb = b;
                that.bitk = k;
                z.avail_in = n;
                z.total_in += p - z.next_in_index;
                z.next_in_index = p;
                that.write = q;
                return that.inflate_flush(z, r);
              }
              c = c == 16 ? blens[i - 1] : 0;
              do {
                blens[i++] = c;
              } while (--j !== 0);
              index = i;
            }
          }
          tb[0] = -1;
          // {
          bl_ = []; // new Array(1);
          bd_ = []; // new Array(1);
          tl_ = []; // new Array(1);
          td_ = []; // new Array(1);
          bl_[0] = 9; // must be <= 9 for lookahead assumptions
          bd_[0] = 6; // must be <= 9 for lookahead assumptions

          t = table;
          t = inftree.inflate_trees_dynamic(257 + (t & 0x1f), 1 + (t >> 5 & 0x1f), blens, bl_, bd_, tl_, td_, hufts, z);
          if (t != Z_OK) {
            if (t == Z_DATA_ERROR) {
              blens = null;
              mode = BADBLOCKS;
            }
            r = t;
            that.bitb = b;
            that.bitk = k;
            z.avail_in = n;
            z.total_in += p - z.next_in_index;
            z.next_in_index = p;
            that.write = q;
            return that.inflate_flush(z, r);
          }
          codes.init(bl_[0], bd_[0], hufts, tl_[0], hufts, td_[0]);
          // }
          mode = CODES;
        /* falls through */
        case CODES:
          that.bitb = b;
          that.bitk = k;
          z.avail_in = n;
          z.total_in += p - z.next_in_index;
          z.next_in_index = p;
          that.write = q;
          if ((r = codes.proc(that, z, r)) != Z_STREAM_END) {
            return that.inflate_flush(z, r);
          }
          r = Z_OK;
          codes.free(z);
          p = z.next_in_index;
          n = z.avail_in;
          b = that.bitb;
          k = that.bitk;
          q = that.write;
          m = /* (int) */q < that.read ? that.read - q - 1 : that.end - q;
          if (last === 0) {
            mode = TYPE;
            break;
          }
          mode = DRY;
        /* falls through */
        case DRY:
          that.write = q;
          r = that.inflate_flush(z, r);
          q = that.write;
          m = /* (int) */q < that.read ? that.read - q - 1 : that.end - q;
          if (that.read != that.write) {
            that.bitb = b;
            that.bitk = k;
            z.avail_in = n;
            z.total_in += p - z.next_in_index;
            z.next_in_index = p;
            that.write = q;
            return that.inflate_flush(z, r);
          }
          mode = DONELOCKS;
        /* falls through */
        case DONELOCKS:
          r = Z_STREAM_END;
          that.bitb = b;
          that.bitk = k;
          z.avail_in = n;
          z.total_in += p - z.next_in_index;
          z.next_in_index = p;
          that.write = q;
          return that.inflate_flush(z, r);
        case BADBLOCKS:
          r = Z_DATA_ERROR;
          that.bitb = b;
          that.bitk = k;
          z.avail_in = n;
          z.total_in += p - z.next_in_index;
          z.next_in_index = p;
          that.write = q;
          return that.inflate_flush(z, r);
        default:
          r = Z_STREAM_ERROR;
          that.bitb = b;
          that.bitk = k;
          z.avail_in = n;
          z.total_in += p - z.next_in_index;
          z.next_in_index = p;
          that.write = q;
          return that.inflate_flush(z, r);
      }
    }
  };
  that.free = function (z) {
    that.reset(z, null);
    that.win = null;
    hufts = null;
    // ZFREE(z, s);
  };
  that.set_dictionary = function (d, start, n) {
    that.win.set(d.subarray(start, start + n), 0);
    that.read = that.write = n;
  };

  // Returns true if inflate is currently at the end of a block generated
  // by Z_SYNC_FLUSH or Z_FULL_FLUSH.
  that.sync_point = function () {
    return mode == LENS ? 1 : 0;
  };
}

// Inflate

// preset dictionary flag in zlib header
const PRESET_DICT = 0x20;
const Z_DEFLATED = 8;
const METHOD = 0; // waiting for method byte
const FLAG = 1; // waiting for flag byte
const DICT4 = 2; // four dictionary check bytes to go
const DICT3 = 3; // three dictionary check bytes to go
const DICT2 = 4; // two dictionary check bytes to go
const DICT1 = 5; // one dictionary check byte to go
const DICT0 = 6; // waiting for inflateSetDictionary
const BLOCKS = 7; // decompressing blocks
const DONE = 12; // finished check, done
const BAD = 13; // got an error--stay here

const mark = [0, 0, 0xff, 0xff];
function Inflate() {
  const that = this;
  that.mode = 0; // current inflate mode

  // mode dependent information
  that.method = 0; // if FLAGS, method byte

  // if CHECK, check values to compare
  that.was = [0]; // new Array(1); // computed check value
  that.need = 0; // stream check value

  // if BAD, inflateSync's marker bytes count
  that.marker = 0;

  // mode independent information
  that.wbits = 0; // log2(win size) (8..15, defaults to 15)

  // this.blocks; // current inflate_blocks state

  function inflateReset(z) {
    if (!z || !z.istate) return Z_STREAM_ERROR;
    z.total_in = z.total_out = 0;
    z.msg = null;
    z.istate.mode = BLOCKS;
    z.istate.blocks.reset(z, null);
    return Z_OK;
  }
  that.inflateEnd = function (z) {
    if (that.blocks) that.blocks.free(z);
    that.blocks = null;
    // ZFREE(z, z->state);
    return Z_OK;
  };
  that.inflateInit = function (z, w) {
    z.msg = null;
    that.blocks = null;

    // set win size
    if (w < 8 || w > 15) {
      that.inflateEnd(z);
      return Z_STREAM_ERROR;
    }
    that.wbits = w;
    z.istate.blocks = new InfBlocks(z, 1 << w);

    // reset state
    inflateReset(z);
    return Z_OK;
  };
  that.inflate = function (z, f) {
    let r;
    let b;
    if (!z || !z.istate || !z.next_in) return Z_STREAM_ERROR;
    const istate = z.istate;
    f = f == Z_FINISH ? Z_BUF_ERROR : Z_OK;
    r = Z_BUF_ERROR;
    // eslint-disable-next-line no-constant-condition
    while (true) {
      switch (istate.mode) {
        case METHOD:
          if (z.avail_in === 0) return r;
          r = f;
          z.avail_in--;
          z.total_in++;
          if (((istate.method = z.read_byte(z.next_in_index++)) & 0xf) != Z_DEFLATED) {
            istate.mode = BAD;
            z.msg = "unknown compression method";
            istate.marker = 5; // can't try inflateSync
            break;
          }
          if ((istate.method >> 4) + 8 > istate.wbits) {
            istate.mode = BAD;
            z.msg = "invalid win size";
            istate.marker = 5; // can't try inflateSync
            break;
          }
          istate.mode = FLAG;
        /* falls through */
        case FLAG:
          if (z.avail_in === 0) return r;
          r = f;
          z.avail_in--;
          z.total_in++;
          b = z.read_byte(z.next_in_index++) & 0xff;
          if (((istate.method << 8) + b) % 31 !== 0) {
            istate.mode = BAD;
            z.msg = "incorrect header check";
            istate.marker = 5; // can't try inflateSync
            break;
          }
          if ((b & PRESET_DICT) === 0) {
            istate.mode = BLOCKS;
            break;
          }
          istate.mode = DICT4;
        /* falls through */
        case DICT4:
          if (z.avail_in === 0) return r;
          r = f;
          z.avail_in--;
          z.total_in++;
          istate.need = (z.read_byte(z.next_in_index++) & 0xff) << 24 & 0xff000000;
          istate.mode = DICT3;
        /* falls through */
        case DICT3:
          if (z.avail_in === 0) return r;
          r = f;
          z.avail_in--;
          z.total_in++;
          istate.need += (z.read_byte(z.next_in_index++) & 0xff) << 16 & 0xff0000;
          istate.mode = DICT2;
        /* falls through */
        case DICT2:
          if (z.avail_in === 0) return r;
          r = f;
          z.avail_in--;
          z.total_in++;
          istate.need += (z.read_byte(z.next_in_index++) & 0xff) << 8 & 0xff00;
          istate.mode = DICT1;
        /* falls through */
        case DICT1:
          if (z.avail_in === 0) return r;
          r = f;
          z.avail_in--;
          z.total_in++;
          istate.need += z.read_byte(z.next_in_index++) & 0xff;
          istate.mode = DICT0;
          return Z_NEED_DICT;
        case DICT0:
          istate.mode = BAD;
          z.msg = "need dictionary";
          istate.marker = 0; // can try inflateSync
          return Z_STREAM_ERROR;
        case BLOCKS:
          r = istate.blocks.proc(z, r);
          if (r == Z_DATA_ERROR) {
            istate.mode = BAD;
            istate.marker = 0; // can try inflateSync
            break;
          }
          if (r == Z_OK) {
            r = f;
          }
          if (r != Z_STREAM_END) {
            return r;
          }
          r = f;
          istate.blocks.reset(z, istate.was);
          istate.mode = DONE;
        /* falls through */
        case DONE:
          z.avail_in = 0;
          return Z_STREAM_END;
        case BAD:
          return Z_DATA_ERROR;
        default:
          return Z_STREAM_ERROR;
      }
    }
  };
  that.inflateSetDictionary = function (z, dictionary, dictLength) {
    let index = 0,
      length = dictLength;
    if (!z || !z.istate || z.istate.mode != DICT0) return Z_STREAM_ERROR;
    const istate = z.istate;
    if (length >= 1 << istate.wbits) {
      length = (1 << istate.wbits) - 1;
      index = dictLength - length;
    }
    istate.blocks.set_dictionary(dictionary, index, length);
    istate.mode = BLOCKS;
    return Z_OK;
  };
  that.inflateSync = function (z) {
    let n; // number of bytes to look at
    let p; // pointer to bytes
    let m; // number of marker bytes found in a row
    let r, w; // temporaries to save total_in and total_out

    // set up
    if (!z || !z.istate) return Z_STREAM_ERROR;
    const istate = z.istate;
    if (istate.mode != BAD) {
      istate.mode = BAD;
      istate.marker = 0;
    }
    if ((n = z.avail_in) === 0) return Z_BUF_ERROR;
    p = z.next_in_index;
    m = istate.marker;

    // search
    while (n !== 0 && m < 4) {
      if (z.read_byte(p) == mark[m]) {
        m++;
      } else if (z.read_byte(p) !== 0) {
        m = 0;
      } else {
        m = 4 - m;
      }
      p++;
      n--;
    }

    // restore
    z.total_in += p - z.next_in_index;
    z.next_in_index = p;
    z.avail_in = n;
    istate.marker = m;

    // return no joy or set up to restart on a new block
    if (m != 4) {
      return Z_DATA_ERROR;
    }
    r = z.total_in;
    w = z.total_out;
    inflateReset(z);
    z.total_in = r;
    z.total_out = w;
    istate.mode = BLOCKS;
    return Z_OK;
  };

  // Returns true if inflate is currently at the end of a block generated
  // by Z_SYNC_FLUSH or Z_FULL_FLUSH. This function is used by one PPP
  // implementation to provide an additional safety check. PPP uses
  // Z_SYNC_FLUSH
  // but removes the length bytes of the resulting empty stored block. When
  // decompressing, PPP checks that at the end of input packet, inflate is
  // waiting for these length bytes.
  that.inflateSyncPoint = function (z) {
    if (!z || !z.istate || !z.istate.blocks) return Z_STREAM_ERROR;
    return z.istate.blocks.sync_point();
  };
}

// ZStream

function ZStream() {}
ZStream.prototype = {
  inflateInit(bits) {
    const that = this;
    that.istate = new Inflate();
    if (!bits) bits = MAX_BITS;
    return that.istate.inflateInit(that, bits);
  },
  inflate(f) {
    const that = this;
    if (!that.istate) return Z_STREAM_ERROR;
    return that.istate.inflate(that, f);
  },
  inflateEnd() {
    const that = this;
    if (!that.istate) return Z_STREAM_ERROR;
    const ret = that.istate.inflateEnd(that);
    that.istate = null;
    return ret;
  },
  inflateSync() {
    const that = this;
    if (!that.istate) return Z_STREAM_ERROR;
    return that.istate.inflateSync(that);
  },
  inflateSetDictionary(dictionary, dictLength) {
    const that = this;
    if (!that.istate) return Z_STREAM_ERROR;
    return that.istate.inflateSetDictionary(that, dictionary, dictLength);
  },
  read_byte(start) {
    const that = this;
    return that.next_in[start];
  },
  read_buf(start, size) {
    const that = this;
    return that.next_in.subarray(start, start + size);
  }
};

// Inflater

function ZipInflate(options) {
  const that = this;
  const z = new ZStream();
  const bufsize = options && options.chunkSize ? Math.floor(options.chunkSize * 2) : 128 * 1024;
  const flush = Z_NO_FLUSH;
  const buf = new Uint8Array(bufsize);
  let nomoreinput = false;
  z.inflateInit();
  z.next_out = buf;
  that.append = function (data, onprogress) {
    const buffers = [];
    let err,
      array,
      lastIndex = 0,
      bufferIndex = 0,
      bufferSize = 0;
    if (data.length === 0) return;
    z.next_in_index = 0;
    z.next_in = data;
    z.avail_in = data.length;
    do {
      z.next_out_index = 0;
      z.avail_out = bufsize;
      if (z.avail_in === 0 && !nomoreinput) {
        // if buffer is empty and more input is available, refill it
        z.next_in_index = 0;
        nomoreinput = true;
      }
      err = z.inflate(flush);
      if (nomoreinput && err === Z_BUF_ERROR) {
        if (z.avail_in !== 0) throw new Error("inflating: bad input");
      } else if (err !== Z_OK && err !== Z_STREAM_END) throw new Error("inflating: " + z.msg);
      if ((nomoreinput || err === Z_STREAM_END) && z.avail_in === data.length) throw new Error("inflating: bad input");
      if (z.next_out_index) if (z.next_out_index === bufsize) buffers.push(new Uint8Array(buf));else buffers.push(buf.subarray(0, z.next_out_index));
      bufferSize += z.next_out_index;
      if (onprogress && z.next_in_index > 0 && z.next_in_index != lastIndex) {
        onprogress(z.next_in_index);
        lastIndex = z.next_in_index;
      }
    } while (z.avail_in > 0 || z.avail_out === 0);
    if (buffers.length > 1) {
      array = new Uint8Array(bufferSize);
      buffers.forEach(function (chunk) {
        array.set(chunk, bufferIndex);
        bufferIndex += chunk.length;
      });
    } else {
      array = buffers[0] ? new Uint8Array(buffers[0]) : new Uint8Array();
    }
    return array;
  };
  that.flush = function () {
    z.inflateEnd();
  };
}

/*
 Copyright (c) 2022 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright 
 notice, this list of conditions and the following disclaimer in 
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */

const MAX_32_BITS = 0xffffffff;
const MAX_16_BITS = 0xffff;
const COMPRESSION_METHOD_DEFLATE = 0x08;
const COMPRESSION_METHOD_STORE = 0x00;
const COMPRESSION_METHOD_AES = 0x63;
const LOCAL_FILE_HEADER_SIGNATURE = 0x04034b50;
const SPLIT_ZIP_FILE_SIGNATURE = 0x08074b50;
const DATA_DESCRIPTOR_RECORD_SIGNATURE = SPLIT_ZIP_FILE_SIGNATURE;
const CENTRAL_FILE_HEADER_SIGNATURE = 0x02014b50;
const END_OF_CENTRAL_DIR_SIGNATURE = 0x06054b50;
const ZIP64_END_OF_CENTRAL_DIR_SIGNATURE = 0x06064b50;
const ZIP64_END_OF_CENTRAL_DIR_LOCATOR_SIGNATURE = 0x07064b50;
const END_OF_CENTRAL_DIR_LENGTH = 22;
const ZIP64_END_OF_CENTRAL_DIR_LOCATOR_LENGTH = 20;
const ZIP64_END_OF_CENTRAL_DIR_LENGTH = 56;
const ZIP64_END_OF_CENTRAL_DIR_TOTAL_LENGTH = END_OF_CENTRAL_DIR_LENGTH + ZIP64_END_OF_CENTRAL_DIR_LOCATOR_LENGTH + ZIP64_END_OF_CENTRAL_DIR_LENGTH;
const EXTRAFIELD_TYPE_ZIP64 = 0x0001;
const EXTRAFIELD_TYPE_AES = 0x9901;
const EXTRAFIELD_TYPE_NTFS = 0x000a;
const EXTRAFIELD_TYPE_NTFS_TAG1 = 0x0001;
const EXTRAFIELD_TYPE_EXTENDED_TIMESTAMP = 0x5455;
const EXTRAFIELD_TYPE_UNICODE_PATH = 0x7075;
const EXTRAFIELD_TYPE_UNICODE_COMMENT = 0x6375;
const EXTRAFIELD_TYPE_USDZ = 0x1986;
const BITFLAG_ENCRYPTED = 0x01;
const BITFLAG_LEVEL = 0x06;
const BITFLAG_DATA_DESCRIPTOR = 0x0008;
const BITFLAG_LANG_ENCODING_FLAG = 0x0800;
const FILE_ATTR_MSDOS_DIR_MASK = 0x10;
const VERSION_DEFLATE = 0x14;
const VERSION_ZIP64 = 0x2D;
const VERSION_AES = 0x33;
const DIRECTORY_SIGNATURE = "/";
const MAX_DATE = new Date(2107, 11, 31);
const MIN_DATE = new Date(1980, 0, 1);
const UNDEFINED_VALUE = undefined;
const UNDEFINED_TYPE = "undefined";
const FUNCTION_TYPE = "function";

/*
 Copyright (c) 2022 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright 
 notice, this list of conditions and the following disclaimer in 
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
class StreamAdapter {
  constructor(Codec) {
    return class extends TransformStream {
      constructor(_format, options) {
        const codec = new Codec(options);
        super({
          transform(chunk, controller) {
            controller.enqueue(codec.append(chunk));
          },
          flush(controller) {
            const chunk = codec.flush();
            if (chunk) {
              controller.enqueue(chunk);
            }
          }
        });
      }
    };
  }
}

/*
 Copyright (c) 2022 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright 
 notice, this list of conditions and the following disclaimer in 
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
const MINIMUM_CHUNK_SIZE = 64;
let maxWorkers = 2;
try {
  if (typeof navigator != UNDEFINED_TYPE && navigator.hardwareConcurrency) {
    maxWorkers = navigator.hardwareConcurrency;
  }
} catch (_error) {
  // ignored
}
const DEFAULT_CONFIGURATION = {
  chunkSize: 512 * 1024,
  maxWorkers,
  terminateWorkerTimeout: 5000,
  useWebWorkers: true,
  useCompressionStream: true,
  workerScripts: UNDEFINED_VALUE,
  CompressionStreamNative: typeof CompressionStream != UNDEFINED_TYPE && CompressionStream,
  DecompressionStreamNative: typeof DecompressionStream != UNDEFINED_TYPE && DecompressionStream
};
const config$1 = Object.assign({}, DEFAULT_CONFIGURATION);
function getConfiguration() {
  return config$1;
}
function getChunkSize(config) {
  return Math.max(config.chunkSize, MINIMUM_CHUNK_SIZE);
}
function configure(configuration) {
  const {
    baseURL,
    chunkSize,
    maxWorkers,
    terminateWorkerTimeout,
    useCompressionStream,
    useWebWorkers,
    Deflate,
    Inflate,
    CompressionStream,
    DecompressionStream,
    workerScripts
  } = configuration;
  setIfDefined("baseURL", baseURL);
  setIfDefined("chunkSize", chunkSize);
  setIfDefined("maxWorkers", maxWorkers);
  setIfDefined("terminateWorkerTimeout", terminateWorkerTimeout);
  setIfDefined("useCompressionStream", useCompressionStream);
  setIfDefined("useWebWorkers", useWebWorkers);
  if (Deflate) {
    config$1.CompressionStream = new StreamAdapter(Deflate);
  }
  if (Inflate) {
    config$1.DecompressionStream = new StreamAdapter(Inflate);
  }
  setIfDefined("CompressionStream", CompressionStream);
  setIfDefined("DecompressionStream", DecompressionStream);
  if (workerScripts !== UNDEFINED_VALUE) {
    const {
      deflate,
      inflate
    } = workerScripts;
    if (deflate || inflate) {
      if (!config$1.workerScripts) {
        config$1.workerScripts = {};
      }
    }
    if (deflate) {
      if (!Array.isArray(deflate)) {
        throw new Error("workerScripts.deflate must be an array");
      }
      config$1.workerScripts.deflate = deflate;
    }
    if (inflate) {
      if (!Array.isArray(inflate)) {
        throw new Error("workerScripts.inflate must be an array");
      }
      config$1.workerScripts.inflate = inflate;
    }
  }
}
function setIfDefined(propertyName, propertyValue) {
  if (propertyValue !== UNDEFINED_VALUE) {
    config$1[propertyName] = propertyValue;
  }
}

/*
 Copyright (c) 2022 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright 
 notice, this list of conditions and the following disclaimer in 
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
const table$1 = {
  "application": {
    "andrew-inset": "ez",
    "annodex": "anx",
    "atom+xml": "atom",
    "atomcat+xml": "atomcat",
    "atomserv+xml": "atomsrv",
    "bbolin": "lin",
    "cu-seeme": "cu",
    "davmount+xml": "davmount",
    "dsptype": "tsp",
    "ecmascript": ["es", "ecma"],
    "futuresplash": "spl",
    "hta": "hta",
    "java-archive": "jar",
    "java-serialized-object": "ser",
    "java-vm": "class",
    "m3g": "m3g",
    "mac-binhex40": "hqx",
    "mathematica": ["nb", "ma", "mb"],
    "msaccess": "mdb",
    "msword": ["doc", "dot", "wiz"],
    "mxf": "mxf",
    "oda": "oda",
    "ogg": "ogx",
    "pdf": "pdf",
    "pgp-keys": "key",
    "pgp-signature": ["asc", "sig"],
    "pics-rules": "prf",
    "postscript": ["ps", "ai", "eps", "epsi", "epsf", "eps2", "eps3"],
    "rar": "rar",
    "rdf+xml": "rdf",
    "rss+xml": "rss",
    "rtf": "rtf",
    "xhtml+xml": ["xhtml", "xht"],
    "xml": ["xml", "xsl", "xsd", "xpdl"],
    "xspf+xml": "xspf",
    "zip": "zip",
    "vnd.android.package-archive": "apk",
    "vnd.cinderella": "cdy",
    "vnd.google-earth.kml+xml": "kml",
    "vnd.google-earth.kmz": "kmz",
    "vnd.mozilla.xul+xml": "xul",
    "vnd.ms-excel": ["xls", "xlb", "xlt", "xlm", "xla", "xlc", "xlw"],
    "vnd.ms-pki.seccat": "cat",
    "vnd.ms-pki.stl": "stl",
    "vnd.ms-powerpoint": ["ppt", "pps", "pot", "ppa", "pwz"],
    "vnd.oasis.opendocument.chart": "odc",
    "vnd.oasis.opendocument.database": "odb",
    "vnd.oasis.opendocument.formula": "odf",
    "vnd.oasis.opendocument.graphics": "odg",
    "vnd.oasis.opendocument.graphics-template": "otg",
    "vnd.oasis.opendocument.image": "odi",
    "vnd.oasis.opendocument.presentation": "odp",
    "vnd.oasis.opendocument.presentation-template": "otp",
    "vnd.oasis.opendocument.spreadsheet": "ods",
    "vnd.oasis.opendocument.spreadsheet-template": "ots",
    "vnd.oasis.opendocument.text": "odt",
    "vnd.oasis.opendocument.text-master": ["odm", "otm"],
    "vnd.oasis.opendocument.text-template": "ott",
    "vnd.oasis.opendocument.text-web": "oth",
    "vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
    "vnd.openxmlformats-officedocument.spreadsheetml.template": "xltx",
    "vnd.openxmlformats-officedocument.presentationml.presentation": "pptx",
    "vnd.openxmlformats-officedocument.presentationml.slideshow": "ppsx",
    "vnd.openxmlformats-officedocument.presentationml.template": "potx",
    "vnd.openxmlformats-officedocument.wordprocessingml.document": "docx",
    "vnd.openxmlformats-officedocument.wordprocessingml.template": "dotx",
    "vnd.smaf": "mmf",
    "vnd.stardivision.calc": "sdc",
    "vnd.stardivision.chart": "sds",
    "vnd.stardivision.draw": "sda",
    "vnd.stardivision.impress": "sdd",
    "vnd.stardivision.math": ["sdf", "smf"],
    "vnd.stardivision.writer": ["sdw", "vor"],
    "vnd.stardivision.writer-global": "sgl",
    "vnd.sun.xml.calc": "sxc",
    "vnd.sun.xml.calc.template": "stc",
    "vnd.sun.xml.draw": "sxd",
    "vnd.sun.xml.draw.template": "std",
    "vnd.sun.xml.impress": "sxi",
    "vnd.sun.xml.impress.template": "sti",
    "vnd.sun.xml.math": "sxm",
    "vnd.sun.xml.writer": "sxw",
    "vnd.sun.xml.writer.global": "sxg",
    "vnd.sun.xml.writer.template": "stw",
    "vnd.symbian.install": ["sis", "sisx"],
    "vnd.visio": ["vsd", "vst", "vss", "vsw", "vsdx", "vssx", "vstx", "vssm", "vstm"],
    "vnd.wap.wbxml": "wbxml",
    "vnd.wap.wmlc": "wmlc",
    "vnd.wap.wmlscriptc": "wmlsc",
    "vnd.wordperfect": "wpd",
    "vnd.wordperfect5.1": "wp5",
    "x-123": "wk",
    "x-7z-compressed": "7z",
    "x-abiword": "abw",
    "x-apple-diskimage": "dmg",
    "x-bcpio": "bcpio",
    "x-bittorrent": "torrent",
    "x-cbr": ["cbr", "cba", "cbt", "cb7"],
    "x-cbz": "cbz",
    "x-cdf": ["cdf", "cda"],
    "x-cdlink": "vcd",
    "x-chess-pgn": "pgn",
    "x-cpio": "cpio",
    "x-csh": "csh",
    "x-director": ["dir", "dxr", "cst", "cct", "cxt", "w3d", "fgd", "swa"],
    "x-dms": "dms",
    "x-doom": "wad",
    "x-dvi": "dvi",
    "x-httpd-eruby": "rhtml",
    "x-font": "pcf.Z",
    "x-freemind": "mm",
    "x-gnumeric": "gnumeric",
    "x-go-sgf": "sgf",
    "x-graphing-calculator": "gcf",
    "x-gtar": ["gtar", "taz"],
    "x-hdf": "hdf",
    "x-httpd-php": ["phtml", "pht", "php"],
    "x-httpd-php-source": "phps",
    "x-httpd-php3": "php3",
    "x-httpd-php3-preprocessed": "php3p",
    "x-httpd-php4": "php4",
    "x-httpd-php5": "php5",
    "x-ica": "ica",
    "x-info": "info",
    "x-internet-signup": ["ins", "isp"],
    "x-iphone": "iii",
    "x-iso9660-image": "iso",
    "x-java-jnlp-file": "jnlp",
    "x-jmol": "jmz",
    "x-killustrator": "kil",
    "x-latex": "latex",
    "x-lyx": "lyx",
    "x-lzx": "lzx",
    "x-maker": ["frm", "fb", "fbdoc"],
    "x-ms-wmd": "wmd",
    "x-msdos-program": ["com", "exe", "bat", "dll"],
    "x-netcdf": ["nc"],
    "x-ns-proxy-autoconfig": ["pac", "dat"],
    "x-nwc": "nwc",
    "x-object": "o",
    "x-oz-application": "oza",
    "x-pkcs7-certreqresp": "p7r",
    "x-python-code": ["pyc", "pyo"],
    "x-qgis": ["qgs", "shp", "shx"],
    "x-quicktimeplayer": "qtl",
    "x-redhat-package-manager": ["rpm", "rpa"],
    "x-ruby": "rb",
    "x-sh": "sh",
    "x-shar": "shar",
    "x-shockwave-flash": ["swf", "swfl"],
    "x-silverlight": "scr",
    "x-stuffit": "sit",
    "x-sv4cpio": "sv4cpio",
    "x-sv4crc": "sv4crc",
    "x-tar": "tar",
    "x-tex-gf": "gf",
    "x-tex-pk": "pk",
    "x-texinfo": ["texinfo", "texi"],
    "x-trash": ["~", "%", "bak", "old", "sik"],
    "x-ustar": "ustar",
    "x-wais-source": "src",
    "x-wingz": "wz",
    "x-x509-ca-cert": ["crt", "der", "cer"],
    "x-xcf": "xcf",
    "x-xfig": "fig",
    "x-xpinstall": "xpi",
    "applixware": "aw",
    "atomsvc+xml": "atomsvc",
    "ccxml+xml": "ccxml",
    "cdmi-capability": "cdmia",
    "cdmi-container": "cdmic",
    "cdmi-domain": "cdmid",
    "cdmi-object": "cdmio",
    "cdmi-queue": "cdmiq",
    "docbook+xml": "dbk",
    "dssc+der": "dssc",
    "dssc+xml": "xdssc",
    "emma+xml": "emma",
    "epub+zip": "epub",
    "exi": "exi",
    "font-tdpfr": "pfr",
    "gml+xml": "gml",
    "gpx+xml": "gpx",
    "gxf": "gxf",
    "hyperstudio": "stk",
    "inkml+xml": ["ink", "inkml"],
    "ipfix": "ipfix",
    "jsonml+json": "jsonml",
    "lost+xml": "lostxml",
    "mads+xml": "mads",
    "marc": "mrc",
    "marcxml+xml": "mrcx",
    "mathml+xml": ["mathml", "mml"],
    "mbox": "mbox",
    "mediaservercontrol+xml": "mscml",
    "metalink+xml": "metalink",
    "metalink4+xml": "meta4",
    "mets+xml": "mets",
    "mods+xml": "mods",
    "mp21": ["m21", "mp21"],
    "mp4": "mp4s",
    "oebps-package+xml": "opf",
    "omdoc+xml": "omdoc",
    "onenote": ["onetoc", "onetoc2", "onetmp", "onepkg"],
    "oxps": "oxps",
    "patch-ops-error+xml": "xer",
    "pgp-encrypted": "pgp",
    "pkcs10": "p10",
    "pkcs7-mime": ["p7m", "p7c"],
    "pkcs7-signature": "p7s",
    "pkcs8": "p8",
    "pkix-attr-cert": "ac",
    "pkix-crl": "crl",
    "pkix-pkipath": "pkipath",
    "pkixcmp": "pki",
    "pls+xml": "pls",
    "prs.cww": "cww",
    "pskc+xml": "pskcxml",
    "reginfo+xml": "rif",
    "relax-ng-compact-syntax": "rnc",
    "resource-lists+xml": "rl",
    "resource-lists-diff+xml": "rld",
    "rls-services+xml": "rs",
    "rpki-ghostbusters": "gbr",
    "rpki-manifest": "mft",
    "rpki-roa": "roa",
    "rsd+xml": "rsd",
    "sbml+xml": "sbml",
    "scvp-cv-request": "scq",
    "scvp-cv-response": "scs",
    "scvp-vp-request": "spq",
    "scvp-vp-response": "spp",
    "sdp": "sdp",
    "set-payment-initiation": "setpay",
    "set-registration-initiation": "setreg",
    "shf+xml": "shf",
    "sparql-query": "rq",
    "sparql-results+xml": "srx",
    "srgs": "gram",
    "srgs+xml": "grxml",
    "sru+xml": "sru",
    "ssdl+xml": "ssdl",
    "ssml+xml": "ssml",
    "tei+xml": ["tei", "teicorpus"],
    "thraud+xml": "tfi",
    "timestamped-data": "tsd",
    "vnd.3gpp.pic-bw-large": "plb",
    "vnd.3gpp.pic-bw-small": "psb",
    "vnd.3gpp.pic-bw-var": "pvb",
    "vnd.3gpp2.tcap": "tcap",
    "vnd.3m.post-it-notes": "pwn",
    "vnd.accpac.simply.aso": "aso",
    "vnd.accpac.simply.imp": "imp",
    "vnd.acucobol": "acu",
    "vnd.acucorp": ["atc", "acutc"],
    "vnd.adobe.air-application-installer-package+zip": "air",
    "vnd.adobe.formscentral.fcdt": "fcdt",
    "vnd.adobe.fxp": ["fxp", "fxpl"],
    "vnd.adobe.xdp+xml": "xdp",
    "vnd.adobe.xfdf": "xfdf",
    "vnd.ahead.space": "ahead",
    "vnd.airzip.filesecure.azf": "azf",
    "vnd.airzip.filesecure.azs": "azs",
    "vnd.amazon.ebook": "azw",
    "vnd.americandynamics.acc": "acc",
    "vnd.amiga.ami": "ami",
    "vnd.anser-web-certificate-issue-initiation": "cii",
    "vnd.anser-web-funds-transfer-initiation": "fti",
    "vnd.antix.game-component": "atx",
    "vnd.apple.installer+xml": "mpkg",
    "vnd.apple.mpegurl": "m3u8",
    "vnd.aristanetworks.swi": "swi",
    "vnd.astraea-software.iota": "iota",
    "vnd.audiograph": "aep",
    "vnd.blueice.multipass": "mpm",
    "vnd.bmi": "bmi",
    "vnd.businessobjects": "rep",
    "vnd.chemdraw+xml": "cdxml",
    "vnd.chipnuts.karaoke-mmd": "mmd",
    "vnd.claymore": "cla",
    "vnd.cloanto.rp9": "rp9",
    "vnd.clonk.c4group": ["c4g", "c4d", "c4f", "c4p", "c4u"],
    "vnd.cluetrust.cartomobile-config": "c11amc",
    "vnd.cluetrust.cartomobile-config-pkg": "c11amz",
    "vnd.commonspace": "csp",
    "vnd.contact.cmsg": "cdbcmsg",
    "vnd.cosmocaller": "cmc",
    "vnd.crick.clicker": "clkx",
    "vnd.crick.clicker.keyboard": "clkk",
    "vnd.crick.clicker.palette": "clkp",
    "vnd.crick.clicker.template": "clkt",
    "vnd.crick.clicker.wordbank": "clkw",
    "vnd.criticaltools.wbs+xml": "wbs",
    "vnd.ctc-posml": "pml",
    "vnd.cups-ppd": "ppd",
    "vnd.curl.car": "car",
    "vnd.curl.pcurl": "pcurl",
    "vnd.dart": "dart",
    "vnd.data-vision.rdz": "rdz",
    "vnd.dece.data": ["uvf", "uvvf", "uvd", "uvvd"],
    "vnd.dece.ttml+xml": ["uvt", "uvvt"],
    "vnd.dece.unspecified": ["uvx", "uvvx"],
    "vnd.dece.zip": ["uvz", "uvvz"],
    "vnd.denovo.fcselayout-link": "fe_launch",
    "vnd.dna": "dna",
    "vnd.dolby.mlp": "mlp",
    "vnd.dpgraph": "dpg",
    "vnd.dreamfactory": "dfac",
    "vnd.ds-keypoint": "kpxx",
    "vnd.dvb.ait": "ait",
    "vnd.dvb.service": "svc",
    "vnd.dynageo": "geo",
    "vnd.ecowin.chart": "mag",
    "vnd.enliven": "nml",
    "vnd.epson.esf": "esf",
    "vnd.epson.msf": "msf",
    "vnd.epson.quickanime": "qam",
    "vnd.epson.salt": "slt",
    "vnd.epson.ssf": "ssf",
    "vnd.eszigno3+xml": ["es3", "et3"],
    "vnd.ezpix-album": "ez2",
    "vnd.ezpix-package": "ez3",
    "vnd.fdf": "fdf",
    "vnd.fdsn.mseed": "mseed",
    "vnd.fdsn.seed": ["seed", "dataless"],
    "vnd.flographit": "gph",
    "vnd.fluxtime.clip": "ftc",
    "vnd.framemaker": ["fm", "frame", "maker", "book"],
    "vnd.frogans.fnc": "fnc",
    "vnd.frogans.ltf": "ltf",
    "vnd.fsc.weblaunch": "fsc",
    "vnd.fujitsu.oasys": "oas",
    "vnd.fujitsu.oasys2": "oa2",
    "vnd.fujitsu.oasys3": "oa3",
    "vnd.fujitsu.oasysgp": "fg5",
    "vnd.fujitsu.oasysprs": "bh2",
    "vnd.fujixerox.ddd": "ddd",
    "vnd.fujixerox.docuworks": "xdw",
    "vnd.fujixerox.docuworks.binder": "xbd",
    "vnd.fuzzysheet": "fzs",
    "vnd.genomatix.tuxedo": "txd",
    "vnd.geogebra.file": "ggb",
    "vnd.geogebra.tool": "ggt",
    "vnd.geometry-explorer": ["gex", "gre"],
    "vnd.geonext": "gxt",
    "vnd.geoplan": "g2w",
    "vnd.geospace": "g3w",
    "vnd.gmx": "gmx",
    "vnd.grafeq": ["gqf", "gqs"],
    "vnd.groove-account": "gac",
    "vnd.groove-help": "ghf",
    "vnd.groove-identity-message": "gim",
    "vnd.groove-injector": "grv",
    "vnd.groove-tool-message": "gtm",
    "vnd.groove-tool-template": "tpl",
    "vnd.groove-vcard": "vcg",
    "vnd.hal+xml": "hal",
    "vnd.handheld-entertainment+xml": "zmm",
    "vnd.hbci": "hbci",
    "vnd.hhe.lesson-player": "les",
    "vnd.hp-hpgl": "hpgl",
    "vnd.hp-hpid": "hpid",
    "vnd.hp-hps": "hps",
    "vnd.hp-jlyt": "jlt",
    "vnd.hp-pcl": "pcl",
    "vnd.hp-pclxl": "pclxl",
    "vnd.hydrostatix.sof-data": "sfd-hdstx",
    "vnd.ibm.minipay": "mpy",
    "vnd.ibm.modcap": ["afp", "listafp", "list3820"],
    "vnd.ibm.rights-management": "irm",
    "vnd.ibm.secure-container": "sc",
    "vnd.iccprofile": ["icc", "icm"],
    "vnd.igloader": "igl",
    "vnd.immervision-ivp": "ivp",
    "vnd.immervision-ivu": "ivu",
    "vnd.insors.igm": "igm",
    "vnd.intercon.formnet": ["xpw", "xpx"],
    "vnd.intergeo": "i2g",
    "vnd.intu.qbo": "qbo",
    "vnd.intu.qfx": "qfx",
    "vnd.ipunplugged.rcprofile": "rcprofile",
    "vnd.irepository.package+xml": "irp",
    "vnd.is-xpr": "xpr",
    "vnd.isac.fcs": "fcs",
    "vnd.jam": "jam",
    "vnd.jcp.javame.midlet-rms": "rms",
    "vnd.jisp": "jisp",
    "vnd.joost.joda-archive": "joda",
    "vnd.kahootz": ["ktz", "ktr"],
    "vnd.kde.karbon": "karbon",
    "vnd.kde.kchart": "chrt",
    "vnd.kde.kformula": "kfo",
    "vnd.kde.kivio": "flw",
    "vnd.kde.kontour": "kon",
    "vnd.kde.kpresenter": ["kpr", "kpt"],
    "vnd.kde.kspread": "ksp",
    "vnd.kde.kword": ["kwd", "kwt"],
    "vnd.kenameaapp": "htke",
    "vnd.kidspiration": "kia",
    "vnd.kinar": ["kne", "knp"],
    "vnd.koan": ["skp", "skd", "skt", "skm"],
    "vnd.kodak-descriptor": "sse",
    "vnd.las.las+xml": "lasxml",
    "vnd.llamagraphics.life-balance.desktop": "lbd",
    "vnd.llamagraphics.life-balance.exchange+xml": "lbe",
    "vnd.lotus-1-2-3": "123",
    "vnd.lotus-approach": "apr",
    "vnd.lotus-freelance": "pre",
    "vnd.lotus-notes": "nsf",
    "vnd.lotus-organizer": "org",
    "vnd.lotus-screencam": "scm",
    "vnd.lotus-wordpro": "lwp",
    "vnd.macports.portpkg": "portpkg",
    "vnd.mcd": "mcd",
    "vnd.medcalcdata": "mc1",
    "vnd.mediastation.cdkey": "cdkey",
    "vnd.mfer": "mwf",
    "vnd.mfmp": "mfm",
    "vnd.micrografx.flo": "flo",
    "vnd.micrografx.igx": "igx",
    "vnd.mif": "mif",
    "vnd.mobius.daf": "daf",
    "vnd.mobius.dis": "dis",
    "vnd.mobius.mbk": "mbk",
    "vnd.mobius.mqy": "mqy",
    "vnd.mobius.msl": "msl",
    "vnd.mobius.plc": "plc",
    "vnd.mobius.txf": "txf",
    "vnd.mophun.application": "mpn",
    "vnd.mophun.certificate": "mpc",
    "vnd.ms-artgalry": "cil",
    "vnd.ms-cab-compressed": "cab",
    "vnd.ms-excel.addin.macroenabled.12": "xlam",
    "vnd.ms-excel.sheet.binary.macroenabled.12": "xlsb",
    "vnd.ms-excel.sheet.macroenabled.12": "xlsm",
    "vnd.ms-excel.template.macroenabled.12": "xltm",
    "vnd.ms-fontobject": "eot",
    "vnd.ms-htmlhelp": "chm",
    "vnd.ms-ims": "ims",
    "vnd.ms-lrm": "lrm",
    "vnd.ms-officetheme": "thmx",
    "vnd.ms-powerpoint.addin.macroenabled.12": "ppam",
    "vnd.ms-powerpoint.presentation.macroenabled.12": "pptm",
    "vnd.ms-powerpoint.slide.macroenabled.12": "sldm",
    "vnd.ms-powerpoint.slideshow.macroenabled.12": "ppsm",
    "vnd.ms-powerpoint.template.macroenabled.12": "potm",
    "vnd.ms-project": ["mpp", "mpt"],
    "vnd.ms-word.document.macroenabled.12": "docm",
    "vnd.ms-word.template.macroenabled.12": "dotm",
    "vnd.ms-works": ["wps", "wks", "wcm", "wdb"],
    "vnd.ms-wpl": "wpl",
    "vnd.ms-xpsdocument": "xps",
    "vnd.mseq": "mseq",
    "vnd.musician": "mus",
    "vnd.muvee.style": "msty",
    "vnd.mynfc": "taglet",
    "vnd.neurolanguage.nlu": "nlu",
    "vnd.nitf": ["ntf", "nitf"],
    "vnd.noblenet-directory": "nnd",
    "vnd.noblenet-sealer": "nns",
    "vnd.noblenet-web": "nnw",
    "vnd.nokia.n-gage.data": "ngdat",
    "vnd.nokia.n-gage.symbian.install": "n-gage",
    "vnd.nokia.radio-preset": "rpst",
    "vnd.nokia.radio-presets": "rpss",
    "vnd.novadigm.edm": "edm",
    "vnd.novadigm.edx": "edx",
    "vnd.novadigm.ext": "ext",
    "vnd.oasis.opendocument.chart-template": "otc",
    "vnd.oasis.opendocument.formula-template": "odft",
    "vnd.oasis.opendocument.image-template": "oti",
    "vnd.olpc-sugar": "xo",
    "vnd.oma.dd2+xml": "dd2",
    "vnd.openofficeorg.extension": "oxt",
    "vnd.openxmlformats-officedocument.presentationml.slide": "sldx",
    "vnd.osgeo.mapguide.package": "mgp",
    "vnd.osgi.dp": "dp",
    "vnd.osgi.subsystem": "esa",
    "vnd.palm": ["pdb", "pqa", "oprc"],
    "vnd.pawaafile": "paw",
    "vnd.pg.format": "str",
    "vnd.pg.osasli": "ei6",
    "vnd.picsel": "efif",
    "vnd.pmi.widget": "wg",
    "vnd.pocketlearn": "plf",
    "vnd.powerbuilder6": "pbd",
    "vnd.previewsystems.box": "box",
    "vnd.proteus.magazine": "mgz",
    "vnd.publishare-delta-tree": "qps",
    "vnd.pvi.ptid1": "ptid",
    "vnd.quark.quarkxpress": ["qxd", "qxt", "qwd", "qwt", "qxl", "qxb"],
    "vnd.realvnc.bed": "bed",
    "vnd.recordare.musicxml": "mxl",
    "vnd.recordare.musicxml+xml": "musicxml",
    "vnd.rig.cryptonote": "cryptonote",
    "vnd.rn-realmedia": "rm",
    "vnd.rn-realmedia-vbr": "rmvb",
    "vnd.route66.link66+xml": "link66",
    "vnd.sailingtracker.track": "st",
    "vnd.seemail": "see",
    "vnd.sema": "sema",
    "vnd.semd": "semd",
    "vnd.semf": "semf",
    "vnd.shana.informed.formdata": "ifm",
    "vnd.shana.informed.formtemplate": "itp",
    "vnd.shana.informed.interchange": "iif",
    "vnd.shana.informed.package": "ipk",
    "vnd.simtech-mindmapper": ["twd", "twds"],
    "vnd.smart.teacher": "teacher",
    "vnd.solent.sdkm+xml": ["sdkm", "sdkd"],
    "vnd.spotfire.dxp": "dxp",
    "vnd.spotfire.sfs": "sfs",
    "vnd.stepmania.package": "smzip",
    "vnd.stepmania.stepchart": "sm",
    "vnd.sus-calendar": ["sus", "susp"],
    "vnd.svd": "svd",
    "vnd.syncml+xml": "xsm",
    "vnd.syncml.dm+wbxml": "bdm",
    "vnd.syncml.dm+xml": "xdm",
    "vnd.tao.intent-module-archive": "tao",
    "vnd.tcpdump.pcap": ["pcap", "cap", "dmp"],
    "vnd.tmobile-livetv": "tmo",
    "vnd.trid.tpt": "tpt",
    "vnd.triscape.mxs": "mxs",
    "vnd.trueapp": "tra",
    "vnd.ufdl": ["ufd", "ufdl"],
    "vnd.uiq.theme": "utz",
    "vnd.umajin": "umj",
    "vnd.unity": "unityweb",
    "vnd.uoml+xml": "uoml",
    "vnd.vcx": "vcx",
    "vnd.visionary": "vis",
    "vnd.vsf": "vsf",
    "vnd.webturbo": "wtb",
    "vnd.wolfram.player": "nbp",
    "vnd.wqd": "wqd",
    "vnd.wt.stf": "stf",
    "vnd.xara": "xar",
    "vnd.xfdl": "xfdl",
    "vnd.yamaha.hv-dic": "hvd",
    "vnd.yamaha.hv-script": "hvs",
    "vnd.yamaha.hv-voice": "hvp",
    "vnd.yamaha.openscoreformat": "osf",
    "vnd.yamaha.openscoreformat.osfpvg+xml": "osfpvg",
    "vnd.yamaha.smaf-audio": "saf",
    "vnd.yamaha.smaf-phrase": "spf",
    "vnd.yellowriver-custom-menu": "cmp",
    "vnd.zul": ["zir", "zirz"],
    "vnd.zzazz.deck+xml": "zaz",
    "voicexml+xml": "vxml",
    "widget": "wgt",
    "winhlp": "hlp",
    "wsdl+xml": "wsdl",
    "wspolicy+xml": "wspolicy",
    "x-ace-compressed": "ace",
    "x-authorware-bin": ["aab", "x32", "u32", "vox"],
    "x-authorware-map": "aam",
    "x-authorware-seg": "aas",
    "x-blorb": ["blb", "blorb"],
    "x-bzip": "bz",
    "x-bzip2": ["bz2", "boz"],
    "x-cfs-compressed": "cfs",
    "x-chat": "chat",
    "x-conference": "nsc",
    "x-dgc-compressed": "dgc",
    "x-dtbncx+xml": "ncx",
    "x-dtbook+xml": "dtb",
    "x-dtbresource+xml": "res",
    "x-eva": "eva",
    "x-font-bdf": "bdf",
    "x-font-ghostscript": "gsf",
    "x-font-linux-psf": "psf",
    "x-font-pcf": "pcf",
    "x-font-snf": "snf",
    "x-font-ttf": ["ttf", "ttc"],
    "x-font-type1": ["pfa", "pfb", "pfm", "afm"],
    "x-freearc": "arc",
    "x-gca-compressed": "gca",
    "x-glulx": "ulx",
    "x-gramps-xml": "gramps",
    "x-install-instructions": "install",
    "x-lzh-compressed": ["lzh", "lha"],
    "x-mie": "mie",
    "x-mobipocket-ebook": ["prc", "mobi"],
    "x-ms-application": "application",
    "x-ms-shortcut": "lnk",
    "x-ms-xbap": "xbap",
    "x-msbinder": "obd",
    "x-mscardfile": "crd",
    "x-msclip": "clp",
    "application/x-ms-installer": "msi",
    "x-msmediaview": ["mvb", "m13", "m14"],
    "x-msmetafile": ["wmf", "wmz", "emf", "emz"],
    "x-msmoney": "mny",
    "x-mspublisher": "pub",
    "x-msschedule": "scd",
    "x-msterminal": "trm",
    "x-mswrite": "wri",
    "x-nzb": "nzb",
    "x-pkcs12": ["p12", "pfx"],
    "x-pkcs7-certificates": ["p7b", "spc"],
    "x-research-info-systems": "ris",
    "x-silverlight-app": "xap",
    "x-sql": "sql",
    "x-stuffitx": "sitx",
    "x-subrip": "srt",
    "x-t3vm-image": "t3",
    "x-tex-tfm": "tfm",
    "x-tgif": "obj",
    "x-xliff+xml": "xlf",
    "x-xz": "xz",
    "x-zmachine": ["z1", "z2", "z3", "z4", "z5", "z6", "z7", "z8"],
    "xaml+xml": "xaml",
    "xcap-diff+xml": "xdf",
    "xenc+xml": "xenc",
    "xml-dtd": "dtd",
    "xop+xml": "xop",
    "xproc+xml": "xpl",
    "xslt+xml": "xslt",
    "xv+xml": ["mxml", "xhvml", "xvml", "xvm"],
    "yang": "yang",
    "yin+xml": "yin",
    "envoy": "evy",
    "fractals": "fif",
    "internet-property-stream": "acx",
    "olescript": "axs",
    "vnd.ms-outlook": "msg",
    "vnd.ms-pkicertstore": "sst",
    "x-compress": "z",
    "x-perfmon": ["pma", "pmc", "pmr", "pmw"],
    "ynd.ms-pkipko": "pko",
    "gzip": ["gz", "tgz"],
    "smil+xml": ["smi", "smil"],
    "vnd.debian.binary-package": ["deb", "udeb"],
    "vnd.hzn-3d-crossword": "x3d",
    "vnd.sqlite3": ["db", "sqlite", "sqlite3", "db-wal", "sqlite-wal", "db-shm", "sqlite-shm"],
    "vnd.wap.sic": "sic",
    "vnd.wap.slc": "slc",
    "x-krita": ["kra", "krz"],
    "x-perl": ["pm", "pl"],
    "yaml": ["yaml", "yml"]
  },
  "audio": {
    "amr": "amr",
    "amr-wb": "awb",
    "annodex": "axa",
    "basic": ["au", "snd"],
    "flac": "flac",
    "midi": ["mid", "midi", "kar", "rmi"],
    "mpeg": ["mpga", "mpega", "mp3", "m4a", "mp2a", "m2a", "m3a"],
    "mpegurl": "m3u",
    "ogg": ["oga", "ogg", "spx"],
    "prs.sid": "sid",
    "x-aiff": "aifc",
    "x-gsm": "gsm",
    "x-ms-wma": "wma",
    "x-ms-wax": "wax",
    "x-pn-realaudio": "ram",
    "x-realaudio": "ra",
    "x-sd2": "sd2",
    "adpcm": "adp",
    "mp4": "mp4a",
    "s3m": "s3m",
    "silk": "sil",
    "vnd.dece.audio": ["uva", "uvva"],
    "vnd.digital-winds": "eol",
    "vnd.dra": "dra",
    "vnd.dts": "dts",
    "vnd.dts.hd": "dtshd",
    "vnd.lucent.voice": "lvp",
    "vnd.ms-playready.media.pya": "pya",
    "vnd.nuera.ecelp4800": "ecelp4800",
    "vnd.nuera.ecelp7470": "ecelp7470",
    "vnd.nuera.ecelp9600": "ecelp9600",
    "vnd.rip": "rip",
    "webm": "weba",
    "x-caf": "caf",
    "x-matroska": "mka",
    "x-pn-realaudio-plugin": "rmp",
    "xm": "xm",
    "aac": "aac",
    "aiff": ["aiff", "aif", "aff"],
    "opus": "opus",
    "wav": "wav"
  },
  "chemical": {
    "x-alchemy": "alc",
    "x-cache": ["cac", "cache"],
    "x-cache-csf": "csf",
    "x-cactvs-binary": ["cbin", "cascii", "ctab"],
    "x-cdx": "cdx",
    "x-chem3d": "c3d",
    "x-cif": "cif",
    "x-cmdf": "cmdf",
    "x-cml": "cml",
    "x-compass": "cpa",
    "x-crossfire": "bsd",
    "x-csml": ["csml", "csm"],
    "x-ctx": "ctx",
    "x-cxf": ["cxf", "cef"],
    "x-embl-dl-nucleotide": ["emb", "embl"],
    "x-gamess-input": ["inp", "gam", "gamin"],
    "x-gaussian-checkpoint": ["fch", "fchk"],
    "x-gaussian-cube": "cub",
    "x-gaussian-input": ["gau", "gjc", "gjf"],
    "x-gaussian-log": "gal",
    "x-gcg8-sequence": "gcg",
    "x-genbank": "gen",
    "x-hin": "hin",
    "x-isostar": ["istr", "ist"],
    "x-jcamp-dx": ["jdx", "dx"],
    "x-kinemage": "kin",
    "x-macmolecule": "mcm",
    "x-macromodel-input": "mmod",
    "x-mdl-molfile": "mol",
    "x-mdl-rdfile": "rd",
    "x-mdl-rxnfile": "rxn",
    "x-mdl-sdfile": "sd",
    "x-mdl-tgf": "tgf",
    "x-mmcif": "mcif",
    "x-mol2": "mol2",
    "x-molconn-Z": "b",
    "x-mopac-graph": "gpt",
    "x-mopac-input": ["mop", "mopcrt", "zmt"],
    "x-mopac-out": "moo",
    "x-ncbi-asn1": "asn",
    "x-ncbi-asn1-ascii": ["prt", "ent"],
    "x-ncbi-asn1-binary": "val",
    "x-rosdal": "ros",
    "x-swissprot": "sw",
    "x-vamas-iso14976": "vms",
    "x-vmd": "vmd",
    "x-xtel": "xtel",
    "x-xyz": "xyz"
  },
  "font": {
    "otf": "otf",
    "woff": "woff",
    "woff2": "woff2"
  },
  "image": {
    "gif": "gif",
    "ief": "ief",
    "jpeg": ["jpeg", "jpg", "jpe", "jfif", "jfif-tbnl", "jif"],
    "pcx": "pcx",
    "png": "png",
    "svg+xml": ["svg", "svgz"],
    "tiff": ["tiff", "tif"],
    "vnd.djvu": ["djvu", "djv"],
    "vnd.wap.wbmp": "wbmp",
    "x-canon-cr2": "cr2",
    "x-canon-crw": "crw",
    "x-cmu-raster": "ras",
    "x-coreldraw": "cdr",
    "x-coreldrawpattern": "pat",
    "x-coreldrawtemplate": "cdt",
    "x-corelphotopaint": "cpt",
    "x-epson-erf": "erf",
    "x-icon": "ico",
    "x-jg": "art",
    "x-jng": "jng",
    "x-nikon-nef": "nef",
    "x-olympus-orf": "orf",
    "x-portable-anymap": "pnm",
    "x-portable-bitmap": "pbm",
    "x-portable-graymap": "pgm",
    "x-portable-pixmap": "ppm",
    "x-rgb": "rgb",
    "x-xbitmap": "xbm",
    "x-xpixmap": "xpm",
    "x-xwindowdump": "xwd",
    "bmp": "bmp",
    "cgm": "cgm",
    "g3fax": "g3",
    "ktx": "ktx",
    "prs.btif": "btif",
    "sgi": "sgi",
    "vnd.dece.graphic": ["uvi", "uvvi", "uvg", "uvvg"],
    "vnd.dwg": "dwg",
    "vnd.dxf": "dxf",
    "vnd.fastbidsheet": "fbs",
    "vnd.fpx": "fpx",
    "vnd.fst": "fst",
    "vnd.fujixerox.edmics-mmr": "mmr",
    "vnd.fujixerox.edmics-rlc": "rlc",
    "vnd.ms-modi": "mdi",
    "vnd.ms-photo": "wdp",
    "vnd.net-fpx": "npx",
    "vnd.xiff": "xif",
    "webp": "webp",
    "x-3ds": "3ds",
    "x-cmx": "cmx",
    "x-freehand": ["fh", "fhc", "fh4", "fh5", "fh7"],
    "x-pict": ["pic", "pct"],
    "x-tga": "tga",
    "cis-cod": "cod",
    "avif": "avifs",
    "heic": ["heif", "heic"],
    "pjpeg": ["pjpg"],
    "vnd.adobe.photoshop": "psd",
    "x-adobe-dng": "dng",
    "x-fuji-raf": "raf",
    "x-icns": "icns",
    "x-kodak-dcr": "dcr",
    "x-kodak-k25": "k25",
    "x-kodak-kdc": "kdc",
    "x-minolta-mrw": "mrw",
    "x-panasonic-raw": ["raw", "rw2", "rwl"],
    "x-pentax-pef": ["pef", "ptx"],
    "x-sigma-x3f": "x3f",
    "x-sony-arw": "arw",
    "x-sony-sr2": "sr2",
    "x-sony-srf": "srf"
  },
  "message": {
    "rfc822": ["eml", "mime", "mht", "mhtml", "nws"]
  },
  "model": {
    "iges": ["igs", "iges"],
    "mesh": ["msh", "mesh", "silo"],
    "vrml": ["wrl", "vrml"],
    "x3d+vrml": ["x3dv", "x3dvz"],
    "x3d+xml": "x3dz",
    "x3d+binary": ["x3db", "x3dbz"],
    "vnd.collada+xml": "dae",
    "vnd.dwf": "dwf",
    "vnd.gdl": "gdl",
    "vnd.gtw": "gtw",
    "vnd.mts": "mts",
    "vnd.usdz+zip": "usdz",
    "vnd.vtu": "vtu"
  },
  "text": {
    "cache-manifest": ["manifest", "appcache"],
    "calendar": ["ics", "icz", "ifb"],
    "css": "css",
    "csv": "csv",
    "h323": "323",
    "html": ["html", "htm", "shtml", "stm"],
    "iuls": "uls",
    "plain": ["txt", "text", "brf", "conf", "def", "list", "log", "in", "bas", "diff", "ksh"],
    "richtext": "rtx",
    "scriptlet": ["sct", "wsc"],
    "texmacs": "tm",
    "tab-separated-values": "tsv",
    "vnd.sun.j2me.app-descriptor": "jad",
    "vnd.wap.wml": "wml",
    "vnd.wap.wmlscript": "wmls",
    "x-bibtex": "bib",
    "x-boo": "boo",
    "x-c++hdr": ["h++", "hpp", "hxx", "hh"],
    "x-c++src": ["c++", "cpp", "cxx", "cc"],
    "x-component": "htc",
    "x-dsrc": "d",
    "x-diff": "patch",
    "x-haskell": "hs",
    "x-java": "java",
    "x-literate-haskell": "lhs",
    "x-moc": "moc",
    "x-pascal": ["p", "pas", "pp", "inc"],
    "x-pcs-gcd": "gcd",
    "x-python": "py",
    "x-scala": "scala",
    "x-setext": "etx",
    "x-tcl": ["tcl", "tk"],
    "x-tex": ["tex", "ltx", "sty", "cls"],
    "x-vcalendar": "vcs",
    "x-vcard": "vcf",
    "n3": "n3",
    "prs.lines.tag": "dsc",
    "sgml": ["sgml", "sgm"],
    "troff": ["t", "tr", "roff", "man", "me", "ms"],
    "turtle": "ttl",
    "uri-list": ["uri", "uris", "urls"],
    "vcard": "vcard",
    "vnd.curl": "curl",
    "vnd.curl.dcurl": "dcurl",
    "vnd.curl.scurl": "scurl",
    "vnd.curl.mcurl": "mcurl",
    "vnd.dvb.subtitle": "sub",
    "vnd.fly": "fly",
    "vnd.fmi.flexstor": "flx",
    "vnd.graphviz": "gv",
    "vnd.in3d.3dml": "3dml",
    "vnd.in3d.spot": "spot",
    "x-asm": ["s", "asm"],
    "x-c": ["c", "h", "dic"],
    "x-fortran": ["f", "for", "f77", "f90"],
    "x-opml": "opml",
    "x-nfo": "nfo",
    "x-sfv": "sfv",
    "x-uuencode": "uu",
    "webviewhtml": "htt",
    "javascript": "js",
    "json": "json",
    "markdown": ["md", "markdown", "mdown", "markdn"],
    "vnd.wap.si": "si",
    "vnd.wap.sl": "sl"
  },
  "video": {
    "avif": "avif",
    "3gpp": "3gp",
    "annodex": "axv",
    "dl": "dl",
    "dv": ["dif", "dv"],
    "fli": "fli",
    "gl": "gl",
    "mpeg": ["mpeg", "mpg", "mpe", "m1v", "m2v", "mp2", "mpa", "mpv2"],
    "mp4": ["mp4", "mp4v", "mpg4"],
    "quicktime": ["qt", "mov"],
    "ogg": "ogv",
    "vnd.mpegurl": ["mxu", "m4u"],
    "x-flv": "flv",
    "x-la-asf": ["lsf", "lsx"],
    "x-mng": "mng",
    "x-ms-asf": ["asf", "asx", "asr"],
    "x-ms-wm": "wm",
    "x-ms-wmv": "wmv",
    "x-ms-wmx": "wmx",
    "x-ms-wvx": "wvx",
    "x-msvideo": "avi",
    "x-sgi-movie": "movie",
    "x-matroska": ["mpv", "mkv", "mk3d", "mks"],
    "3gpp2": "3g2",
    "h261": "h261",
    "h263": "h263",
    "h264": "h264",
    "jpeg": "jpgv",
    "jpm": ["jpm", "jpgm"],
    "mj2": ["mj2", "mjp2"],
    "vnd.dece.hd": ["uvh", "uvvh"],
    "vnd.dece.mobile": ["uvm", "uvvm"],
    "vnd.dece.pd": ["uvp", "uvvp"],
    "vnd.dece.sd": ["uvs", "uvvs"],
    "vnd.dece.video": ["uvv", "uvvv"],
    "vnd.dvb.file": "dvb",
    "vnd.fvt": "fvt",
    "vnd.ms-playready.media.pyv": "pyv",
    "vnd.uvvu.mp4": ["uvu", "uvvu"],
    "vnd.vivo": "viv",
    "webm": "webm",
    "x-f4v": "f4v",
    "x-m4v": "m4v",
    "x-ms-vob": "vob",
    "x-smv": "smv",
    "mp2t": "ts"
  },
  "x-conference": {
    "x-cooltalk": "ice"
  },
  "x-world": {
    "x-vrml": ["vrm", "flr", "wrz", "xaf", "xof"]
  }
};
(() => {
  const mimeTypes = {};
  for (const type of Object.keys(table$1)) {
    for (const subtype of Object.keys(table$1[type])) {
      const value = table$1[type][subtype];
      if (typeof value == "string") {
        mimeTypes[value] = type + "/" + subtype;
      } else {
        for (let indexMimeType = 0; indexMimeType < value.length; indexMimeType++) {
          mimeTypes[value[indexMimeType]] = type + "/" + subtype;
        }
      }
    }
  }
  return mimeTypes;
})();

/*
 Copyright (c) 2022 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright 
 notice, this list of conditions and the following disclaimer in 
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */

const table = [];
for (let i = 0; i < 256; i++) {
  let t = i;
  for (let j = 0; j < 8; j++) {
    if (t & 1) {
      t = t >>> 1 ^ 0xEDB88320;
    } else {
      t = t >>> 1;
    }
  }
  table[i] = t;
}
class Crc32 {
  constructor(crc) {
    this.crc = crc || -1;
  }
  append(data) {
    let crc = this.crc | 0;
    for (let offset = 0, length = data.length | 0; offset < length; offset++) {
      crc = crc >>> 8 ^ table[(crc ^ data[offset]) & 0xFF];
    }
    this.crc = crc;
  }
  get() {
    return ~this.crc;
  }
}

/*
 Copyright (c) 2022 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright 
 notice, this list of conditions and the following disclaimer in 
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
class Crc32Stream extends TransformStream {
  constructor() {
    let stream;
    const crc32 = new Crc32();
    super({
      transform(chunk, controller) {
        crc32.append(chunk);
        controller.enqueue(chunk);
      },
      flush() {
        const value = new Uint8Array(4);
        const dataView = new DataView(value.buffer);
        dataView.setUint32(0, crc32.get());
        stream.value = value;
      }
    });
    stream = this;
  }
}

/*
 Copyright (c) 2022 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright 
 notice, this list of conditions and the following disclaimer in 
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
function encodeText(value) {
  if (typeof TextEncoder == UNDEFINED_TYPE) {
    value = unescape(encodeURIComponent(value));
    const result = new Uint8Array(value.length);
    for (let i = 0; i < result.length; i++) {
      result[i] = value.charCodeAt(i);
    }
    return result;
  } else {
    return new TextEncoder().encode(value);
  }
}

// Derived from https://github.com/xqdoo00o/jszip/blob/master/lib/sjcl.js and https://github.com/bitwiseshiftleft/sjcl

// deno-lint-ignore-file no-this-alias

/*
 * SJCL is open. You can use, modify and redistribute it under a BSD
 * license or under the GNU GPL, version 2.0.
 */

/** @fileOverview Javascript cryptography implementation.
 *
 * Crush to remove comments, shorten variable names and
 * generally reduce transmission size.
 *
 * @author Emily Stark
 * @author Mike Hamburg
 * @author Dan Boneh
 */

/*jslint indent: 2, bitwise: false, nomen: false, plusplus: false, white: false, regexp: false */

/** @fileOverview Arrays of bits, encoded as arrays of Numbers.
 *
 * @author Emily Stark
 * @author Mike Hamburg
 * @author Dan Boneh
 */

/**
 * Arrays of bits, encoded as arrays of Numbers.
 * @namespace
 * @description
 * <p>
 * These objects are the currency accepted by SJCL's crypto functions.
 * </p>
 *
 * <p>
 * Most of our crypto primitives operate on arrays of 4-byte words internally,
 * but many of them can take arguments that are not a multiple of 4 bytes.
 * This library encodes arrays of bits (whose size need not be a multiple of 8
 * bits) as arrays of 32-bit words.  The bits are packed, big-endian, into an
 * array of words, 32 bits at a time.  Since the words are double-precision
 * floating point numbers, they fit some extra data.  We use this (in a private,
 * possibly-changing manner) to encode the number of bits actually  present
 * in the last word of the array.
 * </p>
 *
 * <p>
 * Because bitwise ops clear this out-of-band data, these arrays can be passed
 * to ciphers like AES which want arrays of words.
 * </p>
 */
const bitArray = {
  /**
   * Concatenate two bit arrays.
   * @param {bitArray} a1 The first array.
   * @param {bitArray} a2 The second array.
   * @return {bitArray} The concatenation of a1 and a2.
   */
  concat(a1, a2) {
    if (a1.length === 0 || a2.length === 0) {
      return a1.concat(a2);
    }
    const last = a1[a1.length - 1],
      shift = bitArray.getPartial(last);
    if (shift === 32) {
      return a1.concat(a2);
    } else {
      return bitArray._shiftRight(a2, shift, last | 0, a1.slice(0, a1.length - 1));
    }
  },
  /**
   * Find the length of an array of bits.
   * @param {bitArray} a The array.
   * @return {Number} The length of a, in bits.
   */
  bitLength(a) {
    const l = a.length;
    if (l === 0) {
      return 0;
    }
    const x = a[l - 1];
    return (l - 1) * 32 + bitArray.getPartial(x);
  },
  /**
   * Truncate an array.
   * @param {bitArray} a The array.
   * @param {Number} len The length to truncate to, in bits.
   * @return {bitArray} A new array, truncated to len bits.
   */
  clamp(a, len) {
    if (a.length * 32 < len) {
      return a;
    }
    a = a.slice(0, Math.ceil(len / 32));
    const l = a.length;
    len = len & 31;
    if (l > 0 && len) {
      a[l - 1] = bitArray.partial(len, a[l - 1] & 0x80000000 >> len - 1, 1);
    }
    return a;
  },
  /**
   * Make a partial word for a bit array.
   * @param {Number} len The number of bits in the word.
   * @param {Number} x The bits.
   * @param {Number} [_end=0] Pass 1 if x has already been shifted to the high side.
   * @return {Number} The partial word.
   */
  partial(len, x, _end) {
    if (len === 32) {
      return x;
    }
    return (_end ? x | 0 : x << 32 - len) + len * 0x10000000000;
  },
  /**
   * Get the number of bits used by a partial word.
   * @param {Number} x The partial word.
   * @return {Number} The number of bits used by the partial word.
   */
  getPartial(x) {
    return Math.round(x / 0x10000000000) || 32;
  },
  /** Shift an array right.
   * @param {bitArray} a The array to shift.
   * @param {Number} shift The number of bits to shift.
   * @param {Number} [carry=0] A byte to carry in
   * @param {bitArray} [out=[]] An array to prepend to the output.
   * @private
   */
  _shiftRight(a, shift, carry, out) {
    if (out === undefined) {
      out = [];
    }
    for (; shift >= 32; shift -= 32) {
      out.push(carry);
      carry = 0;
    }
    if (shift === 0) {
      return out.concat(a);
    }
    for (let i = 0; i < a.length; i++) {
      out.push(carry | a[i] >>> shift);
      carry = a[i] << 32 - shift;
    }
    const last2 = a.length ? a[a.length - 1] : 0;
    const shift2 = bitArray.getPartial(last2);
    out.push(bitArray.partial(shift + shift2 & 31, shift + shift2 > 32 ? carry : out.pop(), 1));
    return out;
  }
};

/** @fileOverview Bit array codec implementations.
 *
 * @author Emily Stark
 * @author Mike Hamburg
 * @author Dan Boneh
 */

/**
 * Arrays of bytes
 * @namespace
 */
const codec = {
  bytes: {
    /** Convert from a bitArray to an array of bytes. */
    fromBits(arr) {
      const bl = bitArray.bitLength(arr);
      const byteLength = bl / 8;
      const out = new Uint8Array(byteLength);
      let tmp;
      for (let i = 0; i < byteLength; i++) {
        if ((i & 3) === 0) {
          tmp = arr[i / 4];
        }
        out[i] = tmp >>> 24;
        tmp <<= 8;
      }
      return out;
    },
    /** Convert from an array of bytes to a bitArray. */
    toBits(bytes) {
      const out = [];
      let i;
      let tmp = 0;
      for (i = 0; i < bytes.length; i++) {
        tmp = tmp << 8 | bytes[i];
        if ((i & 3) === 3) {
          out.push(tmp);
          tmp = 0;
        }
      }
      if (i & 3) {
        out.push(bitArray.partial(8 * (i & 3), tmp));
      }
      return out;
    }
  }
};
const hash$1 = {};

/**
 * Context for a SHA-1 operation in progress.
 * @constructor
 */
hash$1.sha1 = class {
  constructor(hash) {
    const sha1 = this;
    /**
     * The hash's block size, in bits.
     * @constant
     */
    sha1.blockSize = 512;
    /**
     * The SHA-1 initialization vector.
     * @private
     */
    sha1._init = [0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0];
    /**
     * The SHA-1 hash key.
     * @private
     */
    sha1._key = [0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xCA62C1D6];
    if (hash) {
      sha1._h = hash._h.slice(0);
      sha1._buffer = hash._buffer.slice(0);
      sha1._length = hash._length;
    } else {
      sha1.reset();
    }
  }

  /**
   * Reset the hash state.
   * @return this
   */
  reset() {
    const sha1 = this;
    sha1._h = sha1._init.slice(0);
    sha1._buffer = [];
    sha1._length = 0;
    return sha1;
  }

  /**
   * Input several words to the hash.
   * @param {bitArray|String} data the data to hash.
   * @return this
   */
  update(data) {
    const sha1 = this;
    if (typeof data === "string") {
      data = codec.utf8String.toBits(data);
    }
    const b = sha1._buffer = bitArray.concat(sha1._buffer, data);
    const ol = sha1._length;
    const nl = sha1._length = ol + bitArray.bitLength(data);
    if (nl > 9007199254740991) {
      throw new Error("Cannot hash more than 2^53 - 1 bits");
    }
    const c = new Uint32Array(b);
    let j = 0;
    for (let i = sha1.blockSize + ol - (sha1.blockSize + ol & sha1.blockSize - 1); i <= nl; i += sha1.blockSize) {
      sha1._block(c.subarray(16 * j, 16 * (j + 1)));
      j += 1;
    }
    b.splice(0, 16 * j);
    return sha1;
  }

  /**
   * Complete hashing and output the hash value.
   * @return {bitArray} The hash value, an array of 5 big-endian words. TODO
   */
  finalize() {
    const sha1 = this;
    let b = sha1._buffer;
    const h = sha1._h;

    // Round out and push the buffer
    b = bitArray.concat(b, [bitArray.partial(1, 1)]);
    // Round out the buffer to a multiple of 16 words, less the 2 length words.
    for (let i = b.length + 2; i & 15; i++) {
      b.push(0);
    }

    // append the length
    b.push(Math.floor(sha1._length / 0x100000000));
    b.push(sha1._length | 0);
    while (b.length) {
      sha1._block(b.splice(0, 16));
    }
    sha1.reset();
    return h;
  }

  /**
   * The SHA-1 logical functions f(0), f(1), ..., f(79).
   * @private
   */
  _f(t, b, c, d) {
    if (t <= 19) {
      return b & c | ~b & d;
    } else if (t <= 39) {
      return b ^ c ^ d;
    } else if (t <= 59) {
      return b & c | b & d | c & d;
    } else if (t <= 79) {
      return b ^ c ^ d;
    }
  }

  /**
   * Circular left-shift operator.
   * @private
   */
  _S(n, x) {
    return x << n | x >>> 32 - n;
  }

  /**
   * Perform one cycle of SHA-1.
   * @param {Uint32Array|bitArray} words one block of words.
   * @private
   */
  _block(words) {
    const sha1 = this;
    const h = sha1._h;
    // When words is passed to _block, it has 16 elements. SHA1 _block
    // function extends words with new elements (at the end there are 80 elements). 
    // The problem is that if we use Uint32Array instead of Array, 
    // the length of Uint32Array cannot be changed. Thus, we replace words with a 
    // normal Array here.
    const w = Array(80); // do not use Uint32Array here as the instantiation is slower
    for (let j = 0; j < 16; j++) {
      w[j] = words[j];
    }
    let a = h[0];
    let b = h[1];
    let c = h[2];
    let d = h[3];
    let e = h[4];
    for (let t = 0; t <= 79; t++) {
      if (t >= 16) {
        w[t] = sha1._S(1, w[t - 3] ^ w[t - 8] ^ w[t - 14] ^ w[t - 16]);
      }
      const tmp = sha1._S(5, a) + sha1._f(t, b, c, d) + e + w[t] + sha1._key[Math.floor(t / 20)] | 0;
      e = d;
      d = c;
      c = sha1._S(30, b);
      b = a;
      a = tmp;
    }
    h[0] = h[0] + a | 0;
    h[1] = h[1] + b | 0;
    h[2] = h[2] + c | 0;
    h[3] = h[3] + d | 0;
    h[4] = h[4] + e | 0;
  }
};

/** @fileOverview Low-level AES implementation.
 *
 * This file contains a low-level implementation of AES, optimized for
 * size and for efficiency on several browsers.  It is based on
 * OpenSSL's aes_core.c, a public-domain implementation by Vincent
 * Rijmen, Antoon Bosselaers and Paulo Barreto.
 *
 * An older version of this implementation is available in the public
 * domain, but this one is (c) Emily Stark, Mike Hamburg, Dan Boneh,
 * Stanford University 2008-2010 and BSD-licensed for liability
 * reasons.
 *
 * @author Emily Stark
 * @author Mike Hamburg
 * @author Dan Boneh
 */

const cipher = {};

/**
 * Schedule out an AES key for both encryption and decryption.  This
 * is a low-level class.  Use a cipher mode to do bulk encryption.
 *
 * @constructor
 * @param {Array} key The key as an array of 4, 6 or 8 words.
 */
cipher.aes = class {
  constructor(key) {
    /**
     * The expanded S-box and inverse S-box tables.  These will be computed
     * on the client so that we don't have to send them down the wire.
     *
     * There are two tables, _tables[0] is for encryption and
     * _tables[1] is for decryption.
     *
     * The first 4 sub-tables are the expanded S-box with MixColumns.  The
     * last (_tables[01][4]) is the S-box itself.
     *
     * @private
     */
    const aes = this;
    aes._tables = [[[], [], [], [], []], [[], [], [], [], []]];
    if (!aes._tables[0][0][0]) {
      aes._precompute();
    }
    const sbox = aes._tables[0][4];
    const decTable = aes._tables[1];
    const keyLen = key.length;
    let i,
      encKey,
      decKey,
      rcon = 1;
    if (keyLen !== 4 && keyLen !== 6 && keyLen !== 8) {
      throw new Error("invalid aes key size");
    }
    aes._key = [encKey = key.slice(0), decKey = []];

    // schedule encryption keys
    for (i = keyLen; i < 4 * keyLen + 28; i++) {
      let tmp = encKey[i - 1];

      // apply sbox
      if (i % keyLen === 0 || keyLen === 8 && i % keyLen === 4) {
        tmp = sbox[tmp >>> 24] << 24 ^ sbox[tmp >> 16 & 255] << 16 ^ sbox[tmp >> 8 & 255] << 8 ^ sbox[tmp & 255];

        // shift rows and add rcon
        if (i % keyLen === 0) {
          tmp = tmp << 8 ^ tmp >>> 24 ^ rcon << 24;
          rcon = rcon << 1 ^ (rcon >> 7) * 283;
        }
      }
      encKey[i] = encKey[i - keyLen] ^ tmp;
    }

    // schedule decryption keys
    for (let j = 0; i; j++, i--) {
      const tmp = encKey[j & 3 ? i : i - 4];
      if (i <= 4 || j < 4) {
        decKey[j] = tmp;
      } else {
        decKey[j] = decTable[0][sbox[tmp >>> 24]] ^ decTable[1][sbox[tmp >> 16 & 255]] ^ decTable[2][sbox[tmp >> 8 & 255]] ^ decTable[3][sbox[tmp & 255]];
      }
    }
  }
  // public
  /* Something like this might appear here eventually
  name: "AES",
  blockSize: 4,
  keySizes: [4,6,8],
  */

  /**
   * Encrypt an array of 4 big-endian words.
   * @param {Array} data The plaintext.
   * @return {Array} The ciphertext.
   */
  encrypt(data) {
    return this._crypt(data, 0);
  }

  /**
   * Decrypt an array of 4 big-endian words.
   * @param {Array} data The ciphertext.
   * @return {Array} The plaintext.
   */
  decrypt(data) {
    return this._crypt(data, 1);
  }

  /**
   * Expand the S-box tables.
   *
   * @private
   */
  _precompute() {
    const encTable = this._tables[0];
    const decTable = this._tables[1];
    const sbox = encTable[4];
    const sboxInv = decTable[4];
    const d = [];
    const th = [];
    let xInv, x2, x4, x8;

    // Compute double and third tables
    for (let i = 0; i < 256; i++) {
      th[(d[i] = i << 1 ^ (i >> 7) * 283) ^ i] = i;
    }
    for (let x = xInv = 0; !sbox[x]; x ^= x2 || 1, xInv = th[xInv] || 1) {
      // Compute sbox
      let s = xInv ^ xInv << 1 ^ xInv << 2 ^ xInv << 3 ^ xInv << 4;
      s = s >> 8 ^ s & 255 ^ 99;
      sbox[x] = s;
      sboxInv[s] = x;

      // Compute MixColumns
      x8 = d[x4 = d[x2 = d[x]]];
      let tDec = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
      let tEnc = d[s] * 0x101 ^ s * 0x1010100;
      for (let i = 0; i < 4; i++) {
        encTable[i][x] = tEnc = tEnc << 24 ^ tEnc >>> 8;
        decTable[i][s] = tDec = tDec << 24 ^ tDec >>> 8;
      }
    }

    // Compactify.  Considerable speedup on Firefox.
    for (let i = 0; i < 5; i++) {
      encTable[i] = encTable[i].slice(0);
      decTable[i] = decTable[i].slice(0);
    }
  }

  /**
   * Encryption and decryption core.
   * @param {Array} input Four words to be encrypted or decrypted.
   * @param dir The direction, 0 for encrypt and 1 for decrypt.
   * @return {Array} The four encrypted or decrypted words.
   * @private
   */
  _crypt(input, dir) {
    if (input.length !== 4) {
      throw new Error("invalid aes block size");
    }
    const key = this._key[dir];
    const nInnerRounds = key.length / 4 - 2;
    const out = [0, 0, 0, 0];
    const table = this._tables[dir];

    // load up the tables
    const t0 = table[0];
    const t1 = table[1];
    const t2 = table[2];
    const t3 = table[3];
    const sbox = table[4];

    // state variables a,b,c,d are loaded with pre-whitened data
    let a = input[0] ^ key[0];
    let b = input[dir ? 3 : 1] ^ key[1];
    let c = input[2] ^ key[2];
    let d = input[dir ? 1 : 3] ^ key[3];
    let kIndex = 4;
    let a2, b2, c2;

    // Inner rounds.  Cribbed from OpenSSL.
    for (let i = 0; i < nInnerRounds; i++) {
      a2 = t0[a >>> 24] ^ t1[b >> 16 & 255] ^ t2[c >> 8 & 255] ^ t3[d & 255] ^ key[kIndex];
      b2 = t0[b >>> 24] ^ t1[c >> 16 & 255] ^ t2[d >> 8 & 255] ^ t3[a & 255] ^ key[kIndex + 1];
      c2 = t0[c >>> 24] ^ t1[d >> 16 & 255] ^ t2[a >> 8 & 255] ^ t3[b & 255] ^ key[kIndex + 2];
      d = t0[d >>> 24] ^ t1[a >> 16 & 255] ^ t2[b >> 8 & 255] ^ t3[c & 255] ^ key[kIndex + 3];
      kIndex += 4;
      a = a2;
      b = b2;
      c = c2;
    }

    // Last round.
    for (let i = 0; i < 4; i++) {
      out[dir ? 3 & -i : i] = sbox[a >>> 24] << 24 ^ sbox[b >> 16 & 255] << 16 ^ sbox[c >> 8 & 255] << 8 ^ sbox[d & 255] ^ key[kIndex++];
      a2 = a;
      a = b;
      b = c;
      c = d;
      d = a2;
    }
    return out;
  }
};

/**
 * Random values
 * @namespace
 */
const random = {
  /** 
   * Generate random words with pure js, cryptographically not as strong & safe as native implementation.
   * @param {TypedArray} typedArray The array to fill.
   * @return {TypedArray} The random values.
   */
  getRandomValues(typedArray) {
    const words = new Uint32Array(typedArray.buffer);
    const r = m_w => {
      let m_z = 0x3ade68b1;
      const mask = 0xffffffff;
      return function () {
        m_z = 0x9069 * (m_z & 0xFFFF) + (m_z >> 0x10) & mask;
        m_w = 0x4650 * (m_w & 0xFFFF) + (m_w >> 0x10) & mask;
        const result = ((m_z << 0x10) + m_w & mask) / 0x100000000 + .5;
        return result * (Math.random() > .5 ? 1 : -1);
      };
    };
    for (let i = 0, rcache; i < typedArray.length; i += 4) {
      const _r = r((rcache || Math.random()) * 0x100000000);
      rcache = _r() * 0x3ade67b7;
      words[i / 4] = _r() * 0x100000000 | 0;
    }
    return typedArray;
  }
};

/** @fileOverview CTR mode implementation.
 *
 * Special thanks to Roy Nicholson for pointing out a bug in our
 * implementation.
 *
 * @author Emily Stark
 * @author Mike Hamburg
 * @author Dan Boneh
 */

/** Brian Gladman's CTR Mode.
* @constructor
* @param {Object} _prf The aes instance to generate key.
* @param {bitArray} _iv The iv for ctr mode, it must be 128 bits.
*/

const mode = {};

/**
 * Brian Gladman's CTR Mode.
 * @namespace
 */
mode.ctrGladman = class {
  constructor(prf, iv) {
    this._prf = prf;
    this._initIv = iv;
    this._iv = iv;
  }
  reset() {
    this._iv = this._initIv;
  }

  /** Input some data to calculate.
   * @param {bitArray} data the data to process, it must be intergral multiple of 128 bits unless it's the last.
   */
  update(data) {
    return this.calculate(this._prf, data, this._iv);
  }
  incWord(word) {
    if ((word >> 24 & 0xff) === 0xff) {
      //overflow
      let b1 = word >> 16 & 0xff;
      let b2 = word >> 8 & 0xff;
      let b3 = word & 0xff;
      if (b1 === 0xff) {
        // overflow b1   
        b1 = 0;
        if (b2 === 0xff) {
          b2 = 0;
          if (b3 === 0xff) {
            b3 = 0;
          } else {
            ++b3;
          }
        } else {
          ++b2;
        }
      } else {
        ++b1;
      }
      word = 0;
      word += b1 << 16;
      word += b2 << 8;
      word += b3;
    } else {
      word += 0x01 << 24;
    }
    return word;
  }
  incCounter(counter) {
    if ((counter[0] = this.incWord(counter[0])) === 0) {
      // encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
      counter[1] = this.incWord(counter[1]);
    }
  }
  calculate(prf, data, iv) {
    let l;
    if (!(l = data.length)) {
      return [];
    }
    const bl = bitArray.bitLength(data);
    for (let i = 0; i < l; i += 4) {
      this.incCounter(iv);
      const e = prf.encrypt(iv);
      data[i] ^= e[0];
      data[i + 1] ^= e[1];
      data[i + 2] ^= e[2];
      data[i + 3] ^= e[3];
    }
    return bitArray.clamp(data, bl);
  }
};
const misc = {
  importKey(password) {
    return new misc.hmacSha1(codec.bytes.toBits(password));
  },
  pbkdf2(prf, salt, count, length) {
    count = count || 10000;
    if (length < 0 || count < 0) {
      throw new Error("invalid params to pbkdf2");
    }
    const byteLength = (length >> 5) + 1 << 2;
    let u, ui, i, j, k;
    const arrayBuffer = new ArrayBuffer(byteLength);
    const out = new DataView(arrayBuffer);
    let outLength = 0;
    const b = bitArray;
    salt = codec.bytes.toBits(salt);
    for (k = 1; outLength < (byteLength || 1); k++) {
      u = ui = prf.encrypt(b.concat(salt, [k]));
      for (i = 1; i < count; i++) {
        ui = prf.encrypt(ui);
        for (j = 0; j < ui.length; j++) {
          u[j] ^= ui[j];
        }
      }
      for (i = 0; outLength < (byteLength || 1) && i < u.length; i++) {
        out.setInt32(outLength, u[i]);
        outLength += 4;
      }
    }
    return arrayBuffer.slice(0, length / 8);
  }
};

/** @fileOverview HMAC implementation.
 *
 * @author Emily Stark
 * @author Mike Hamburg
 * @author Dan Boneh
 */

/** HMAC with the specified hash function.
 * @constructor
 * @param {bitArray} key the key for HMAC.
 * @param {Object} [Hash=hash.sha1] The hash function to use.
 */
misc.hmacSha1 = class {
  constructor(key) {
    const hmac = this;
    const Hash = hmac._hash = hash$1.sha1;
    const exKey = [[], []];
    hmac._baseHash = [new Hash(), new Hash()];
    const bs = hmac._baseHash[0].blockSize / 32;
    if (key.length > bs) {
      key = new Hash().update(key).finalize();
    }
    for (let i = 0; i < bs; i++) {
      exKey[0][i] = key[i] ^ 0x36363636;
      exKey[1][i] = key[i] ^ 0x5C5C5C5C;
    }
    hmac._baseHash[0].update(exKey[0]);
    hmac._baseHash[1].update(exKey[1]);
    hmac._resultHash = new Hash(hmac._baseHash[0]);
  }
  reset() {
    const hmac = this;
    hmac._resultHash = new hmac._hash(hmac._baseHash[0]);
    hmac._updated = false;
  }
  update(data) {
    const hmac = this;
    hmac._updated = true;
    hmac._resultHash.update(data);
  }
  digest() {
    const hmac = this;
    const w = hmac._resultHash.finalize();
    const result = new hmac._hash(hmac._baseHash[1]).update(w).finalize();
    hmac.reset();
    return result;
  }
  encrypt(data) {
    if (!this._updated) {
      this.update(data);
      return this.digest(data);
    } else {
      throw new Error("encrypt on already updated hmac called!");
    }
  }
};

/*
 Copyright (c) 2022 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright 
 notice, this list of conditions and the following disclaimer in 
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
const GET_RANDOM_VALUES_SUPPORTED = typeof crypto != UNDEFINED_TYPE && typeof crypto.getRandomValues == FUNCTION_TYPE;
const ERR_INVALID_PASSWORD = "Invalid password";
const ERR_INVALID_SIGNATURE = "Invalid signature";
const ERR_ABORT_CHECK_PASSWORD = "zipjs-abort-check-password";
function getRandomValues(array) {
  if (GET_RANDOM_VALUES_SUPPORTED) {
    return crypto.getRandomValues(array);
  } else {
    return random.getRandomValues(array);
  }
}

/*
 Copyright (c) 2022 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright 
 notice, this list of conditions and the following disclaimer in 
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
const BLOCK_LENGTH = 16;
const RAW_FORMAT = "raw";
const PBKDF2_ALGORITHM = {
  name: "PBKDF2"
};
const HASH_ALGORITHM = {
  name: "HMAC"
};
const HASH_FUNCTION = "SHA-1";
const BASE_KEY_ALGORITHM = Object.assign({
  hash: HASH_ALGORITHM
}, PBKDF2_ALGORITHM);
const DERIVED_BITS_ALGORITHM = Object.assign({
  iterations: 1000,
  hash: {
    name: HASH_FUNCTION
  }
}, PBKDF2_ALGORITHM);
const DERIVED_BITS_USAGE = ["deriveBits"];
const SALT_LENGTH = [8, 12, 16];
const KEY_LENGTH = [16, 24, 32];
const SIGNATURE_LENGTH = 10;
const COUNTER_DEFAULT_VALUE = [0, 0, 0, 0];
// deno-lint-ignore valid-typeof
const CRYPTO_API_SUPPORTED = typeof crypto != UNDEFINED_TYPE;
const subtle = CRYPTO_API_SUPPORTED && crypto.subtle;
const SUBTLE_API_SUPPORTED = CRYPTO_API_SUPPORTED && typeof subtle != UNDEFINED_TYPE;
const codecBytes = codec.bytes;
const Aes = cipher.aes;
const CtrGladman = mode.ctrGladman;
const HmacSha1 = misc.hmacSha1;
let IMPORT_KEY_SUPPORTED = CRYPTO_API_SUPPORTED && SUBTLE_API_SUPPORTED && typeof subtle.importKey == FUNCTION_TYPE;
let DERIVE_BITS_SUPPORTED = CRYPTO_API_SUPPORTED && SUBTLE_API_SUPPORTED && typeof subtle.deriveBits == FUNCTION_TYPE;
class AESDecryptionStream extends TransformStream {
  constructor({
    password,
    rawPassword,
    signed,
    encryptionStrength,
    checkPasswordOnly
  }) {
    super({
      start() {
        Object.assign(this, {
          ready: new Promise(resolve => this.resolveReady = resolve),
          password: encodePassword(password, rawPassword),
          signed,
          strength: encryptionStrength - 1,
          pending: new Uint8Array()
        });
      },
      async transform(chunk, controller) {
        const aesCrypto = this;
        const {
          password,
          strength,
          resolveReady,
          ready
        } = aesCrypto;
        if (password) {
          await createDecryptionKeys(aesCrypto, strength, password, subarray(chunk, 0, SALT_LENGTH[strength] + 2));
          chunk = subarray(chunk, SALT_LENGTH[strength] + 2);
          if (checkPasswordOnly) {
            controller.error(new Error(ERR_ABORT_CHECK_PASSWORD));
          } else {
            resolveReady();
          }
        } else {
          await ready;
        }
        const output = new Uint8Array(chunk.length - SIGNATURE_LENGTH - (chunk.length - SIGNATURE_LENGTH) % BLOCK_LENGTH);
        controller.enqueue(append$1(aesCrypto, chunk, output, 0, SIGNATURE_LENGTH, true));
      },
      async flush(controller) {
        const {
          signed,
          ctr,
          hmac,
          pending,
          ready
        } = this;
        if (hmac && ctr) {
          await ready;
          const chunkToDecrypt = subarray(pending, 0, pending.length - SIGNATURE_LENGTH);
          const originalSignature = subarray(pending, pending.length - SIGNATURE_LENGTH);
          let decryptedChunkArray = new Uint8Array();
          if (chunkToDecrypt.length) {
            const encryptedChunk = toBits(codecBytes, chunkToDecrypt);
            hmac.update(encryptedChunk);
            const decryptedChunk = ctr.update(encryptedChunk);
            decryptedChunkArray = fromBits(codecBytes, decryptedChunk);
          }
          if (signed) {
            const signature = subarray(fromBits(codecBytes, hmac.digest()), 0, SIGNATURE_LENGTH);
            for (let indexSignature = 0; indexSignature < SIGNATURE_LENGTH; indexSignature++) {
              if (signature[indexSignature] != originalSignature[indexSignature]) {
                throw new Error(ERR_INVALID_SIGNATURE);
              }
            }
          }
          controller.enqueue(decryptedChunkArray);
        }
      }
    });
  }
}
class AESEncryptionStream extends TransformStream {
  constructor({
    password,
    rawPassword,
    encryptionStrength
  }) {
    // deno-lint-ignore prefer-const
    let stream;
    super({
      start() {
        Object.assign(this, {
          ready: new Promise(resolve => this.resolveReady = resolve),
          password: encodePassword(password, rawPassword),
          strength: encryptionStrength - 1,
          pending: new Uint8Array()
        });
      },
      async transform(chunk, controller) {
        const aesCrypto = this;
        const {
          password,
          strength,
          resolveReady,
          ready
        } = aesCrypto;
        let preamble = new Uint8Array();
        if (password) {
          preamble = await createEncryptionKeys(aesCrypto, strength, password);
          resolveReady();
        } else {
          await ready;
        }
        const output = new Uint8Array(preamble.length + chunk.length - chunk.length % BLOCK_LENGTH);
        output.set(preamble, 0);
        controller.enqueue(append$1(aesCrypto, chunk, output, preamble.length, 0));
      },
      async flush(controller) {
        const {
          ctr,
          hmac,
          pending,
          ready
        } = this;
        if (hmac && ctr) {
          await ready;
          let encryptedChunkArray = new Uint8Array();
          if (pending.length) {
            const encryptedChunk = ctr.update(toBits(codecBytes, pending));
            hmac.update(encryptedChunk);
            encryptedChunkArray = fromBits(codecBytes, encryptedChunk);
          }
          stream.signature = fromBits(codecBytes, hmac.digest()).slice(0, SIGNATURE_LENGTH);
          controller.enqueue(concat(encryptedChunkArray, stream.signature));
        }
      }
    });
    stream = this;
  }
}
function append$1(aesCrypto, input, output, paddingStart, paddingEnd, verifySignature) {
  const {
    ctr,
    hmac,
    pending
  } = aesCrypto;
  const inputLength = input.length - paddingEnd;
  if (pending.length) {
    input = concat(pending, input);
    output = expand(output, inputLength - inputLength % BLOCK_LENGTH);
  }
  let offset;
  for (offset = 0; offset <= inputLength - BLOCK_LENGTH; offset += BLOCK_LENGTH) {
    const inputChunk = toBits(codecBytes, subarray(input, offset, offset + BLOCK_LENGTH));
    if (verifySignature) {
      hmac.update(inputChunk);
    }
    const outputChunk = ctr.update(inputChunk);
    if (!verifySignature) {
      hmac.update(outputChunk);
    }
    output.set(fromBits(codecBytes, outputChunk), offset + paddingStart);
  }
  aesCrypto.pending = subarray(input, offset);
  return output;
}
async function createDecryptionKeys(decrypt, strength, password, preamble) {
  const passwordVerificationKey = await createKeys$1(decrypt, strength, password, subarray(preamble, 0, SALT_LENGTH[strength]));
  const passwordVerification = subarray(preamble, SALT_LENGTH[strength]);
  if (passwordVerificationKey[0] != passwordVerification[0] || passwordVerificationKey[1] != passwordVerification[1]) {
    throw new Error(ERR_INVALID_PASSWORD);
  }
}
async function createEncryptionKeys(encrypt, strength, password) {
  const salt = getRandomValues(new Uint8Array(SALT_LENGTH[strength]));
  const passwordVerification = await createKeys$1(encrypt, strength, password, salt);
  return concat(salt, passwordVerification);
}
async function createKeys$1(aesCrypto, strength, password, salt) {
  aesCrypto.password = null;
  const baseKey = await importKey(RAW_FORMAT, password, BASE_KEY_ALGORITHM, false, DERIVED_BITS_USAGE);
  const derivedBits = await deriveBits(Object.assign({
    salt
  }, DERIVED_BITS_ALGORITHM), baseKey, 8 * (KEY_LENGTH[strength] * 2 + 2));
  const compositeKey = new Uint8Array(derivedBits);
  const key = toBits(codecBytes, subarray(compositeKey, 0, KEY_LENGTH[strength]));
  const authentication = toBits(codecBytes, subarray(compositeKey, KEY_LENGTH[strength], KEY_LENGTH[strength] * 2));
  const passwordVerification = subarray(compositeKey, KEY_LENGTH[strength] * 2);
  Object.assign(aesCrypto, {
    keys: {
      key,
      authentication,
      passwordVerification
    },
    ctr: new CtrGladman(new Aes(key), Array.from(COUNTER_DEFAULT_VALUE)),
    hmac: new HmacSha1(authentication)
  });
  return passwordVerification;
}
async function importKey(format, password, algorithm, extractable, keyUsages) {
  if (IMPORT_KEY_SUPPORTED) {
    try {
      return await subtle.importKey(format, password, algorithm, extractable, keyUsages);
    } catch (_error) {
      IMPORT_KEY_SUPPORTED = false;
      return misc.importKey(password);
    }
  } else {
    return misc.importKey(password);
  }
}
async function deriveBits(algorithm, baseKey, length) {
  if (DERIVE_BITS_SUPPORTED) {
    try {
      return await subtle.deriveBits(algorithm, baseKey, length);
    } catch (_error) {
      DERIVE_BITS_SUPPORTED = false;
      return misc.pbkdf2(baseKey, algorithm.salt, DERIVED_BITS_ALGORITHM.iterations, length);
    }
  } else {
    return misc.pbkdf2(baseKey, algorithm.salt, DERIVED_BITS_ALGORITHM.iterations, length);
  }
}
function encodePassword(password, rawPassword) {
  if (rawPassword === UNDEFINED_VALUE) {
    return encodeText(password);
  } else {
    return rawPassword;
  }
}
function concat(leftArray, rightArray) {
  let array = leftArray;
  if (leftArray.length + rightArray.length) {
    array = new Uint8Array(leftArray.length + rightArray.length);
    array.set(leftArray, 0);
    array.set(rightArray, leftArray.length);
  }
  return array;
}
function expand(inputArray, length) {
  if (length && length > inputArray.length) {
    const array = inputArray;
    inputArray = new Uint8Array(length);
    inputArray.set(array, 0);
  }
  return inputArray;
}
function subarray(array, begin, end) {
  return array.subarray(begin, end);
}
function fromBits(codecBytes, chunk) {
  return codecBytes.fromBits(chunk);
}
function toBits(codecBytes, chunk) {
  return codecBytes.toBits(chunk);
}

/*
 Copyright (c) 2022 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright 
 notice, this list of conditions and the following disclaimer in 
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
const HEADER_LENGTH = 12;
class ZipCryptoDecryptionStream extends TransformStream {
  constructor({
    password,
    passwordVerification,
    checkPasswordOnly
  }) {
    super({
      start() {
        Object.assign(this, {
          password,
          passwordVerification
        });
        createKeys(this, password);
      },
      transform(chunk, controller) {
        const zipCrypto = this;
        if (zipCrypto.password) {
          const decryptedHeader = decrypt(zipCrypto, chunk.subarray(0, HEADER_LENGTH));
          zipCrypto.password = null;
          if (decryptedHeader[HEADER_LENGTH - 1] != zipCrypto.passwordVerification) {
            throw new Error(ERR_INVALID_PASSWORD);
          }
          chunk = chunk.subarray(HEADER_LENGTH);
        }
        if (checkPasswordOnly) {
          controller.error(new Error(ERR_ABORT_CHECK_PASSWORD));
        } else {
          controller.enqueue(decrypt(zipCrypto, chunk));
        }
      }
    });
  }
}
class ZipCryptoEncryptionStream extends TransformStream {
  constructor({
    password,
    passwordVerification
  }) {
    super({
      start() {
        Object.assign(this, {
          password,
          passwordVerification
        });
        createKeys(this, password);
      },
      transform(chunk, controller) {
        const zipCrypto = this;
        let output;
        let offset;
        if (zipCrypto.password) {
          zipCrypto.password = null;
          const header = getRandomValues(new Uint8Array(HEADER_LENGTH));
          header[HEADER_LENGTH - 1] = zipCrypto.passwordVerification;
          output = new Uint8Array(chunk.length + header.length);
          output.set(encrypt(zipCrypto, header), 0);
          offset = HEADER_LENGTH;
        } else {
          output = new Uint8Array(chunk.length);
          offset = 0;
        }
        output.set(encrypt(zipCrypto, chunk), offset);
        controller.enqueue(output);
      }
    });
  }
}
function decrypt(target, input) {
  const output = new Uint8Array(input.length);
  for (let index = 0; index < input.length; index++) {
    output[index] = getByte(target) ^ input[index];
    updateKeys(target, output[index]);
  }
  return output;
}
function encrypt(target, input) {
  const output = new Uint8Array(input.length);
  for (let index = 0; index < input.length; index++) {
    output[index] = getByte(target) ^ input[index];
    updateKeys(target, input[index]);
  }
  return output;
}
function createKeys(target, password) {
  const keys = [0x12345678, 0x23456789, 0x34567890];
  Object.assign(target, {
    keys,
    crcKey0: new Crc32(keys[0]),
    crcKey2: new Crc32(keys[2])
  });
  for (let index = 0; index < password.length; index++) {
    updateKeys(target, password.charCodeAt(index));
  }
}
function updateKeys(target, byte) {
  let [key0, key1, key2] = target.keys;
  target.crcKey0.append([byte]);
  key0 = ~target.crcKey0.get();
  key1 = getInt32(Math.imul(getInt32(key1 + getInt8(key0)), 134775813) + 1);
  target.crcKey2.append([key1 >>> 24]);
  key2 = ~target.crcKey2.get();
  target.keys = [key0, key1, key2];
}
function getByte(target) {
  const temp = target.keys[2] | 2;
  return getInt8(Math.imul(temp, temp ^ 1) >>> 8);
}
function getInt8(number) {
  return number & 0xFF;
}
function getInt32(number) {
  return number & 0xFFFFFFFF;
}

/*
 Copyright (c) 2022 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright 
 notice, this list of conditions and the following disclaimer in 
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
const COMPRESSION_FORMAT = "deflate-raw";
class DeflateStream extends TransformStream {
  constructor(options, {
    chunkSize,
    CompressionStream,
    CompressionStreamNative
  }) {
    super({});
    const {
      compressed,
      encrypted,
      useCompressionStream,
      zipCrypto,
      signed,
      level
    } = options;
    const stream = this;
    let crc32Stream, encryptionStream;
    let readable = filterEmptyChunks(super.readable);
    if ((!encrypted || zipCrypto) && signed) {
      crc32Stream = new Crc32Stream();
      readable = pipeThrough(readable, crc32Stream);
    }
    if (compressed) {
      readable = pipeThroughCommpressionStream(readable, useCompressionStream, {
        level,
        chunkSize
      }, CompressionStreamNative, CompressionStream);
    }
    if (encrypted) {
      if (zipCrypto) {
        readable = pipeThrough(readable, new ZipCryptoEncryptionStream(options));
      } else {
        encryptionStream = new AESEncryptionStream(options);
        readable = pipeThrough(readable, encryptionStream);
      }
    }
    setReadable(stream, readable, () => {
      let signature;
      if (encrypted && !zipCrypto) {
        signature = encryptionStream.signature;
      }
      if ((!encrypted || zipCrypto) && signed) {
        signature = new DataView(crc32Stream.value.buffer).getUint32(0);
      }
      stream.signature = signature;
    });
  }
}
class InflateStream extends TransformStream {
  constructor(options, {
    chunkSize,
    DecompressionStream,
    DecompressionStreamNative
  }) {
    super({});
    const {
      zipCrypto,
      encrypted,
      signed,
      signature,
      compressed,
      useCompressionStream
    } = options;
    let crc32Stream, decryptionStream;
    let readable = filterEmptyChunks(super.readable);
    if (encrypted) {
      if (zipCrypto) {
        readable = pipeThrough(readable, new ZipCryptoDecryptionStream(options));
      } else {
        decryptionStream = new AESDecryptionStream(options);
        readable = pipeThrough(readable, decryptionStream);
      }
    }
    if (compressed) {
      readable = pipeThroughCommpressionStream(readable, useCompressionStream, {
        chunkSize
      }, DecompressionStreamNative, DecompressionStream);
    }
    if ((!encrypted || zipCrypto) && signed) {
      crc32Stream = new Crc32Stream();
      readable = pipeThrough(readable, crc32Stream);
    }
    setReadable(this, readable, () => {
      if ((!encrypted || zipCrypto) && signed) {
        const dataViewSignature = new DataView(crc32Stream.value.buffer);
        if (signature != dataViewSignature.getUint32(0, false)) {
          throw new Error(ERR_INVALID_SIGNATURE);
        }
      }
    });
  }
}
function filterEmptyChunks(readable) {
  return pipeThrough(readable, new TransformStream({
    transform(chunk, controller) {
      if (chunk && chunk.length) {
        controller.enqueue(chunk);
      }
    }
  }));
}
function setReadable(stream, readable, flush) {
  readable = pipeThrough(readable, new TransformStream({
    flush
  }));
  Object.defineProperty(stream, "readable", {
    get() {
      return readable;
    }
  });
}
function pipeThroughCommpressionStream(readable, useCompressionStream, options, CodecStreamNative, CodecStream) {
  try {
    const CompressionStream = useCompressionStream && CodecStreamNative ? CodecStreamNative : CodecStream;
    readable = pipeThrough(readable, new CompressionStream(COMPRESSION_FORMAT, options));
  } catch (error) {
    if (useCompressionStream) {
      try {
        readable = pipeThrough(readable, new CodecStream(COMPRESSION_FORMAT, options));
      } catch (error) {
        return readable;
      }
    } else {
      return readable;
    }
  }
  return readable;
}
function pipeThrough(readable, transformStream) {
  return readable.pipeThrough(transformStream);
}

/*
 Copyright (c) 2022 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright 
 notice, this list of conditions and the following disclaimer in 
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
const MESSAGE_EVENT_TYPE = "message";
const MESSAGE_START = "start";
const MESSAGE_PULL = "pull";
const MESSAGE_DATA = "data";
const MESSAGE_ACK_DATA = "ack";
const MESSAGE_CLOSE = "close";
const CODEC_DEFLATE = "deflate";
const CODEC_INFLATE = "inflate";
class CodecStream extends TransformStream {
  constructor(options, config) {
    super({});
    const codec = this;
    const {
      codecType
    } = options;
    let Stream;
    if (codecType.startsWith(CODEC_DEFLATE)) {
      Stream = DeflateStream;
    } else if (codecType.startsWith(CODEC_INFLATE)) {
      Stream = InflateStream;
    }
    let outputSize = 0;
    let inputSize = 0;
    const stream = new Stream(options, config);
    const readable = super.readable;
    const inputSizeStream = new TransformStream({
      transform(chunk, controller) {
        if (chunk && chunk.length) {
          inputSize += chunk.length;
          controller.enqueue(chunk);
        }
      },
      flush() {
        Object.assign(codec, {
          inputSize
        });
      }
    });
    const outputSizeStream = new TransformStream({
      transform(chunk, controller) {
        if (chunk && chunk.length) {
          outputSize += chunk.length;
          controller.enqueue(chunk);
        }
      },
      flush() {
        const {
          signature
        } = stream;
        Object.assign(codec, {
          signature,
          outputSize,
          inputSize
        });
      }
    });
    Object.defineProperty(codec, "readable", {
      get() {
        return readable.pipeThrough(inputSizeStream).pipeThrough(stream).pipeThrough(outputSizeStream);
      }
    });
  }
}
class ChunkStream extends TransformStream {
  constructor(chunkSize) {
    let pendingChunk;
    super({
      transform,
      flush(controller) {
        if (pendingChunk && pendingChunk.length) {
          controller.enqueue(pendingChunk);
        }
      }
    });
    function transform(chunk, controller) {
      if (pendingChunk) {
        const newChunk = new Uint8Array(pendingChunk.length + chunk.length);
        newChunk.set(pendingChunk);
        newChunk.set(chunk, pendingChunk.length);
        chunk = newChunk;
        pendingChunk = null;
      }
      if (chunk.length > chunkSize) {
        controller.enqueue(chunk.slice(0, chunkSize));
        transform(chunk.slice(chunkSize), controller);
      } else {
        pendingChunk = chunk;
      }
    }
  }
}

/*
 Copyright (c) 2022 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright 
 notice, this list of conditions and the following disclaimer in 
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */

// deno-lint-ignore valid-typeof
let WEB_WORKERS_SUPPORTED = typeof Worker != UNDEFINED_TYPE;
class CodecWorker {
  constructor(workerData, {
    readable,
    writable
  }, {
    options,
    config,
    streamOptions,
    useWebWorkers,
    transferStreams,
    scripts
  }, onTaskFinished) {
    const {
      signal
    } = streamOptions;
    Object.assign(workerData, {
      busy: true,
      readable: readable.pipeThrough(new ChunkStream(config.chunkSize)).pipeThrough(new ProgressWatcherStream(readable, streamOptions), {
        signal
      }),
      writable,
      options: Object.assign({}, options),
      scripts,
      transferStreams,
      terminate() {
        return new Promise(resolve => {
          const {
            worker,
            busy
          } = workerData;
          if (worker) {
            if (busy) {
              workerData.resolveTerminated = resolve;
            } else {
              worker.terminate();
              resolve();
            }
            workerData.interface = null;
          } else {
            resolve();
          }
        });
      },
      onTaskFinished() {
        const {
          resolveTerminated
        } = workerData;
        if (resolveTerminated) {
          workerData.resolveTerminated = null;
          workerData.terminated = true;
          workerData.worker.terminate();
          resolveTerminated();
        }
        workerData.busy = false;
        onTaskFinished(workerData);
      }
    });
    return (useWebWorkers && WEB_WORKERS_SUPPORTED ? createWebWorkerInterface : createWorkerInterface)(workerData, config);
  }
}
class ProgressWatcherStream extends TransformStream {
  constructor(readableSource, {
    onstart,
    onprogress,
    size,
    onend
  }) {
    let chunkOffset = 0;
    super({
      async start() {
        if (onstart) {
          await callHandler(onstart, size);
        }
      },
      async transform(chunk, controller) {
        chunkOffset += chunk.length;
        if (onprogress) {
          await callHandler(onprogress, chunkOffset, size);
        }
        controller.enqueue(chunk);
      },
      async flush() {
        readableSource.size = chunkOffset;
        if (onend) {
          await callHandler(onend, chunkOffset);
        }
      }
    });
  }
}
async function callHandler(handler, ...parameters) {
  try {
    await handler(...parameters);
  } catch (_error) {
    // ignored
  }
}
function createWorkerInterface(workerData, config) {
  return {
    run: () => runWorker$1(workerData, config)
  };
}
function createWebWorkerInterface(workerData, config) {
  const {
    baseURL,
    chunkSize
  } = config;
  if (!workerData.interface) {
    let worker;
    try {
      worker = getWebWorker(workerData.scripts[0], baseURL, workerData);
    } catch (error) {
      WEB_WORKERS_SUPPORTED = false;
      return createWorkerInterface(workerData, config);
    }
    Object.assign(workerData, {
      worker,
      interface: {
        run: () => runWebWorker(workerData, {
          chunkSize
        })
      }
    });
  }
  return workerData.interface;
}
async function runWorker$1({
  options,
  readable,
  writable,
  onTaskFinished
}, config) {
  try {
    const codecStream = new CodecStream(options, config);
    await readable.pipeThrough(codecStream).pipeTo(writable, {
      preventClose: true,
      preventAbort: true
    });
    const {
      signature,
      inputSize,
      outputSize
    } = codecStream;
    return {
      signature,
      inputSize,
      outputSize
    };
  } finally {
    onTaskFinished();
  }
}
async function runWebWorker(workerData, config) {
  let resolveResult, rejectResult;
  const result = new Promise((resolve, reject) => {
    resolveResult = resolve;
    rejectResult = reject;
  });
  Object.assign(workerData, {
    reader: null,
    writer: null,
    resolveResult,
    rejectResult,
    result
  });
  const {
    readable,
    options,
    scripts
  } = workerData;
  const {
    writable,
    closed
  } = watchClosedStream(workerData.writable);
  const streamsTransferred = sendMessage({
    type: MESSAGE_START,
    scripts: scripts.slice(1),
    options,
    config,
    readable,
    writable
  }, workerData);
  if (!streamsTransferred) {
    Object.assign(workerData, {
      reader: readable.getReader(),
      writer: writable.getWriter()
    });
  }
  const resultValue = await result;
  if (!streamsTransferred) {
    await writable.getWriter().close();
  }
  await closed;
  return resultValue;
}
function watchClosedStream(writableSource) {
  let resolveStreamClosed;
  const closed = new Promise(resolve => resolveStreamClosed = resolve);
  const writable = new WritableStream({
    async write(chunk) {
      const writer = writableSource.getWriter();
      await writer.ready;
      await writer.write(chunk);
      writer.releaseLock();
    },
    close() {
      resolveStreamClosed();
    },
    abort(reason) {
      const writer = writableSource.getWriter();
      return writer.abort(reason);
    }
  });
  return {
    writable,
    closed
  };
}
let classicWorkersSupported = true;
let transferStreamsSupported = true;
function getWebWorker(url, baseURL, workerData) {
  const workerOptions = {
    type: "module"
  };
  let scriptUrl, worker;
  // deno-lint-ignore valid-typeof
  if (typeof url == FUNCTION_TYPE) {
    url = url();
  }
  try {
    scriptUrl = new URL(url, baseURL);
  } catch (_error) {
    scriptUrl = url;
  }
  if (classicWorkersSupported) {
    try {
      worker = new Worker(scriptUrl);
    } catch (_error) {
      classicWorkersSupported = false;
      worker = new Worker(scriptUrl, workerOptions);
    }
  } else {
    worker = new Worker(scriptUrl, workerOptions);
  }
  worker.addEventListener(MESSAGE_EVENT_TYPE, event => onMessage(event, workerData));
  return worker;
}
function sendMessage(message, {
  worker,
  writer,
  onTaskFinished,
  transferStreams
}) {
  try {
    let {
      value,
      readable,
      writable
    } = message;
    const transferables = [];
    if (value) {
      if (value.byteLength < value.buffer.byteLength) {
        message.value = value.buffer.slice(0, value.byteLength);
      } else {
        message.value = value.buffer;
      }
      transferables.push(message.value);
    }
    if (transferStreams && transferStreamsSupported) {
      if (readable) {
        transferables.push(readable);
      }
      if (writable) {
        transferables.push(writable);
      }
    } else {
      message.readable = message.writable = null;
    }
    if (transferables.length) {
      try {
        worker.postMessage(message, transferables);
        return true;
      } catch (_error) {
        transferStreamsSupported = false;
        message.readable = message.writable = null;
        worker.postMessage(message);
      }
    } else {
      worker.postMessage(message);
    }
  } catch (error) {
    if (writer) {
      writer.releaseLock();
    }
    onTaskFinished();
    throw error;
  }
}
async function onMessage({
  data
}, workerData) {
  const {
    type,
    value,
    messageId,
    result,
    error
  } = data;
  const {
    reader,
    writer,
    resolveResult,
    rejectResult,
    onTaskFinished
  } = workerData;
  try {
    if (error) {
      const {
        message,
        stack,
        code,
        name
      } = error;
      const responseError = new Error(message);
      Object.assign(responseError, {
        stack,
        code,
        name
      });
      close(responseError);
    } else {
      if (type == MESSAGE_PULL) {
        const {
          value,
          done
        } = await reader.read();
        sendMessage({
          type: MESSAGE_DATA,
          value,
          done,
          messageId
        }, workerData);
      }
      if (type == MESSAGE_DATA) {
        await writer.ready;
        await writer.write(new Uint8Array(value));
        sendMessage({
          type: MESSAGE_ACK_DATA,
          messageId
        }, workerData);
      }
      if (type == MESSAGE_CLOSE) {
        close(null, result);
      }
    }
  } catch (error) {
    sendMessage({
      type: MESSAGE_CLOSE,
      messageId
    }, workerData);
    close(error);
  }
  function close(error, result) {
    if (error) {
      rejectResult(error);
    } else {
      resolveResult(result);
    }
    if (writer) {
      writer.releaseLock();
    }
    onTaskFinished();
  }
}

/*
 Copyright (c) 2022 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright 
 notice, this list of conditions and the following disclaimer in 
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
let pool = [];
const pendingRequests = [];
let indexWorker = 0;
async function runWorker(stream, workerOptions) {
  const {
    options,
    config
  } = workerOptions;
  const {
    transferStreams,
    useWebWorkers,
    useCompressionStream,
    codecType,
    compressed,
    signed,
    encrypted
  } = options;
  const {
    workerScripts,
    maxWorkers
  } = config;
  workerOptions.transferStreams = transferStreams || transferStreams === UNDEFINED_VALUE;
  const streamCopy = !compressed && !signed && !encrypted && !workerOptions.transferStreams;
  workerOptions.useWebWorkers = !streamCopy && (useWebWorkers || useWebWorkers === UNDEFINED_VALUE && config.useWebWorkers);
  workerOptions.scripts = workerOptions.useWebWorkers && workerScripts ? workerScripts[codecType] : [];
  options.useCompressionStream = useCompressionStream || useCompressionStream === UNDEFINED_VALUE && config.useCompressionStream;
  return (await getWorker()).run();
  async function getWorker() {
    const workerData = pool.find(workerData => !workerData.busy);
    if (workerData) {
      clearTerminateTimeout(workerData);
      return new CodecWorker(workerData, stream, workerOptions, onTaskFinished);
    } else if (pool.length < maxWorkers) {
      const workerData = {
        indexWorker
      };
      indexWorker++;
      pool.push(workerData);
      return new CodecWorker(workerData, stream, workerOptions, onTaskFinished);
    } else {
      return new Promise(resolve => pendingRequests.push({
        resolve,
        stream,
        workerOptions
      }));
    }
  }
  function onTaskFinished(workerData) {
    if (pendingRequests.length) {
      const [{
        resolve,
        stream,
        workerOptions
      }] = pendingRequests.splice(0, 1);
      resolve(new CodecWorker(workerData, stream, workerOptions, onTaskFinished));
    } else if (workerData.worker) {
      clearTerminateTimeout(workerData);
      terminateWorker(workerData, workerOptions);
    } else {
      pool = pool.filter(data => data != workerData);
    }
  }
}
function terminateWorker(workerData, workerOptions) {
  const {
    config
  } = workerOptions;
  const {
    terminateWorkerTimeout
  } = config;
  if (Number.isFinite(terminateWorkerTimeout) && terminateWorkerTimeout >= 0) {
    if (workerData.terminated) {
      workerData.terminated = false;
    } else {
      workerData.terminateTimeout = setTimeout(async () => {
        pool = pool.filter(data => data != workerData);
        try {
          await workerData.terminate();
        } catch (_error) {
          // ignored
        }
      }, terminateWorkerTimeout);
    }
  }
}
function clearTerminateTimeout(workerData) {
  const {
    terminateTimeout
  } = workerData;
  if (terminateTimeout) {
    clearTimeout(terminateTimeout);
    workerData.terminateTimeout = null;
  }
}

function e$4(e, t = {}) {
  const n = 'const{Array:e,Object:t,Number:n,Math:r,Error:s,Uint8Array:i,Uint16Array:o,Uint32Array:c,Int32Array:f,Map:a,DataView:l,Promise:u,TextEncoder:w,crypto:h,postMessage:d,TransformStream:p,ReadableStream:y,WritableStream:m,CompressionStream:b,DecompressionStream:g}=self,k=void 0,v="undefined",S="function";class z{constructor(e){return class extends p{constructor(t,n){const r=new e(n);super({transform(e,t){t.enqueue(r.append(e))},flush(e){const t=r.flush();t&&e.enqueue(t)}})}}}}const C=[];for(let e=0;256>e;e++){let t=e;for(let e=0;8>e;e++)1&t?t=t>>>1^3988292384:t>>>=1;C[e]=t}class x{constructor(e){this.t=e||-1}append(e){let t=0|this.t;for(let n=0,r=0|e.length;r>n;n++)t=t>>>8^C[255&(t^e[n])];this.t=t}get(){return~this.t}}class A extends p{constructor(){let e;const t=new x;super({transform(e,n){t.append(e),n.enqueue(e)},flush(){const n=new i(4);new l(n.buffer).setUint32(0,t.get()),e.value=n}}),e=this}}const _={concat(e,t){if(0===e.length||0===t.length)return e.concat(t);const n=e[e.length-1],r=_.i(n);return 32===r?e.concat(t):_.o(t,r,0|n,e.slice(0,e.length-1))},l(e){const t=e.length;if(0===t)return 0;const n=e[t-1];return 32*(t-1)+_.i(n)},u(e,t){if(32*e.length<t)return e;const n=(e=e.slice(0,r.ceil(t/32))).length;return t&=31,n>0&&t&&(e[n-1]=_.h(t,e[n-1]&2147483648>>t-1,1)),e},h:(e,t,n)=>32===e?t:(n?0|t:t<<32-e)+1099511627776*e,i:e=>r.round(e/1099511627776)||32,o(e,t,n,r){for(void 0===r&&(r=[]);t>=32;t-=32)r.push(n),n=0;if(0===t)return r.concat(e);for(let s=0;s<e.length;s++)r.push(n|e[s]>>>t),n=e[s]<<32-t;const s=e.length?e[e.length-1]:0,i=_.i(s);return r.push(_.h(t+i&31,t+i>32?n:r.pop(),1)),r}},I={p:{m(e){const t=_.l(e)/8,n=new i(t);let r;for(let s=0;t>s;s++)3&s||(r=e[s/4]),n[s]=r>>>24,r<<=8;return n},k(e){const t=[];let n,r=0;for(n=0;n<e.length;n++)r=r<<8|e[n],3&~n||(t.push(r),r=0);return 3&n&&t.push(_.h(8*(3&n),r)),t}}},P=class{constructor(e){const t=this;t.blockSize=512,t.v=[1732584193,4023233417,2562383102,271733878,3285377520],t.S=[1518500249,1859775393,2400959708,3395469782],e?(t.C=e.C.slice(0),t.A=e.A.slice(0),t._=e._):t.reset()}reset(){const e=this;return e.C=e.v.slice(0),e.A=[],e._=0,e}update(e){const t=this;"string"==typeof e&&(e=I.I.k(e));const n=t.A=_.concat(t.A,e),r=t._,i=t._=r+_.l(e);if(i>9007199254740991)throw new s("Cannot hash more than 2^53 - 1 bits");const o=new c(n);let f=0;for(let e=t.blockSize+r-(t.blockSize+r&t.blockSize-1);i>=e;e+=t.blockSize)t.P(o.subarray(16*f,16*(f+1))),f+=1;return n.splice(0,16*f),t}D(){const e=this;let t=e.A;const n=e.C;t=_.concat(t,[_.h(1,1)]);for(let e=t.length+2;15&e;e++)t.push(0);for(t.push(r.floor(e._/4294967296)),t.push(0|e._);t.length;)e.P(t.splice(0,16));return e.reset(),n}V(e,t,n,r){return e>19?e>39?e>59?e>79?void 0:t^n^r:t&n|t&r|n&r:t^n^r:t&n|~t&r}R(e,t){return t<<e|t>>>32-e}P(t){const n=this,s=n.C,i=e(80);for(let e=0;16>e;e++)i[e]=t[e];let o=s[0],c=s[1],f=s[2],a=s[3],l=s[4];for(let e=0;79>=e;e++){16>e||(i[e]=n.R(1,i[e-3]^i[e-8]^i[e-14]^i[e-16]));const t=n.R(5,o)+n.V(e,c,f,a)+l+i[e]+n.S[r.floor(e/20)]|0;l=a,a=f,f=n.R(30,c),c=o,o=t}s[0]=s[0]+o|0,s[1]=s[1]+c|0,s[2]=s[2]+f|0,s[3]=s[3]+a|0,s[4]=s[4]+l|0}},D={getRandomValues(e){const t=new c(e.buffer),n=e=>{let t=987654321;const n=4294967295;return()=>(t=36969*(65535&t)+(t>>16)&n,(((t<<16)+(e=18e3*(65535&e)+(e>>16)&n)&n)/4294967296+.5)*(r.random()>.5?1:-1))};for(let s,i=0;i<e.length;i+=4){const e=n(4294967296*(s||r.random()));s=987654071*e(),t[i/4]=4294967296*e()|0}return e}},V={importKey:e=>new V.B(I.p.k(e)),M(e,t,n,r){if(n=n||1e4,0>r||0>n)throw new s("invalid params to pbkdf2");const i=1+(r>>5)<<2;let o,c,f,a,u;const w=new ArrayBuffer(i),h=new l(w);let d=0;const p=_;for(t=I.p.k(t),u=1;(i||1)>d;u++){for(o=c=e.encrypt(p.concat(t,[u])),f=1;n>f;f++)for(c=e.encrypt(c),a=0;a<c.length;a++)o[a]^=c[a];for(f=0;(i||1)>d&&f<o.length;f++)h.setInt32(d,o[f]),d+=4}return w.slice(0,r/8)},B:class{constructor(e){const t=this,n=t.U=P,r=[[],[]];t.K=[new n,new n];const s=t.K[0].blockSize/32;e.length>s&&(e=(new n).update(e).D());for(let t=0;s>t;t++)r[0][t]=909522486^e[t],r[1][t]=1549556828^e[t];t.K[0].update(r[0]),t.K[1].update(r[1]),t.N=new n(t.K[0])}reset(){const e=this;e.N=new e.U(e.K[0]),e.O=!1}update(e){this.O=!0,this.N.update(e)}digest(){const e=this,t=e.N.D(),n=new e.U(e.K[1]).update(t).D();return e.reset(),n}encrypt(e){if(this.O)throw new s("encrypt on already updated hmac called!");return this.update(e),this.digest(e)}}},R=typeof h!=v&&typeof h.getRandomValues==S,B="Invalid password",E="Invalid signature",M="zipjs-abort-check-password";function U(e){return R?h.getRandomValues(e):D.getRandomValues(e)}const K=16,N={name:"PBKDF2"},O=t.assign({hash:{name:"HMAC"}},N),T=t.assign({iterations:1e3,hash:{name:"SHA-1"}},N),W=["deriveBits"],j=[8,12,16],H=[16,24,32],L=10,F=[0,0,0,0],q=typeof h!=v,G=q&&h.subtle,J=q&&typeof G!=v,Q=I.p,X=class{constructor(e){const t=this;t.T=[[[],[],[],[],[]],[[],[],[],[],[]]],t.T[0][0][0]||t.W();const n=t.T[0][4],r=t.T[1],i=e.length;let o,c,f,a=1;if(4!==i&&6!==i&&8!==i)throw new s("invalid aes key size");for(t.S=[c=e.slice(0),f=[]],o=i;4*i+28>o;o++){let e=c[o-1];(o%i==0||8===i&&o%i==4)&&(e=n[e>>>24]<<24^n[e>>16&255]<<16^n[e>>8&255]<<8^n[255&e],o%i==0&&(e=e<<8^e>>>24^a<<24,a=a<<1^283*(a>>7))),c[o]=c[o-i]^e}for(let e=0;o;e++,o--){const t=c[3&e?o:o-4];f[e]=4>=o||4>e?t:r[0][n[t>>>24]]^r[1][n[t>>16&255]]^r[2][n[t>>8&255]]^r[3][n[255&t]]}}encrypt(e){return this.j(e,0)}decrypt(e){return this.j(e,1)}W(){const e=this.T[0],t=this.T[1],n=e[4],r=t[4],s=[],i=[];let o,c,f,a;for(let e=0;256>e;e++)i[(s[e]=e<<1^283*(e>>7))^e]=e;for(let l=o=0;!n[l];l^=c||1,o=i[o]||1){let i=o^o<<1^o<<2^o<<3^o<<4;i=i>>8^255&i^99,n[l]=i,r[i]=l,a=s[f=s[c=s[l]]];let u=16843009*a^65537*f^257*c^16843008*l,w=257*s[i]^16843008*i;for(let n=0;4>n;n++)e[n][l]=w=w<<24^w>>>8,t[n][i]=u=u<<24^u>>>8}for(let n=0;5>n;n++)e[n]=e[n].slice(0),t[n]=t[n].slice(0)}j(e,t){if(4!==e.length)throw new s("invalid aes block size");const n=this.S[t],r=n.length/4-2,i=[0,0,0,0],o=this.T[t],c=o[0],f=o[1],a=o[2],l=o[3],u=o[4];let w,h,d,p=e[0]^n[0],y=e[t?3:1]^n[1],m=e[2]^n[2],b=e[t?1:3]^n[3],g=4;for(let e=0;r>e;e++)w=c[p>>>24]^f[y>>16&255]^a[m>>8&255]^l[255&b]^n[g],h=c[y>>>24]^f[m>>16&255]^a[b>>8&255]^l[255&p]^n[g+1],d=c[m>>>24]^f[b>>16&255]^a[p>>8&255]^l[255&y]^n[g+2],b=c[b>>>24]^f[p>>16&255]^a[y>>8&255]^l[255&m]^n[g+3],g+=4,p=w,y=h,m=d;for(let e=0;4>e;e++)i[t?3&-e:e]=u[p>>>24]<<24^u[y>>16&255]<<16^u[m>>8&255]<<8^u[255&b]^n[g++],w=p,p=y,y=m,m=b,b=w;return i}},Y=class{constructor(e,t){this.H=e,this.L=t,this.F=t}reset(){this.F=this.L}update(e){return this.q(this.H,e,this.F)}G(e){if(255&~(e>>24))e+=1<<24;else{let t=e>>16&255,n=e>>8&255,r=255&e;255===t?(t=0,255===n?(n=0,255===r?r=0:++r):++n):++t,e=0,e+=t<<16,e+=n<<8,e+=r}return e}J(e){0===(e[0]=this.G(e[0]))&&(e[1]=this.G(e[1]))}q(e,t,n){let r;if(!(r=t.length))return[];const s=_.l(t);for(let s=0;r>s;s+=4){this.J(n);const r=e.encrypt(n);t[s]^=r[0],t[s+1]^=r[1],t[s+2]^=r[2],t[s+3]^=r[3]}return _.u(t,s)}},Z=V.B;let $=q&&J&&typeof G.importKey==S,ee=q&&J&&typeof G.deriveBits==S;class te extends p{constructor({password:e,rawPassword:n,signed:r,encryptionStrength:o,checkPasswordOnly:c}){super({start(){t.assign(this,{ready:new u((e=>this.X=e)),password:ie(e,n),signed:r,Y:o-1,pending:new i})},async transform(e,t){const n=this,{password:r,Y:o,X:f,ready:a}=n;r?(await(async(e,t,n,r)=>{const i=await se(e,t,n,ce(r,0,j[t])),o=ce(r,j[t]);if(i[0]!=o[0]||i[1]!=o[1])throw new s(B)})(n,o,r,ce(e,0,j[o]+2)),e=ce(e,j[o]+2),c?t.error(new s(M)):f()):await a;const l=new i(e.length-L-(e.length-L)%K);t.enqueue(re(n,e,l,0,L,!0))},async flush(e){const{signed:t,Z:n,$:r,pending:o,ready:c}=this;if(r&&n){await c;const f=ce(o,0,o.length-L),a=ce(o,o.length-L);let l=new i;if(f.length){const e=ae(Q,f);r.update(e);const t=n.update(e);l=fe(Q,t)}if(t){const e=ce(fe(Q,r.digest()),0,L);for(let t=0;L>t;t++)if(e[t]!=a[t])throw new s(E)}e.enqueue(l)}}})}}class ne extends p{constructor({password:e,rawPassword:n,encryptionStrength:r}){let s;super({start(){t.assign(this,{ready:new u((e=>this.X=e)),password:ie(e,n),Y:r-1,pending:new i})},async transform(e,t){const n=this,{password:r,Y:s,X:o,ready:c}=n;let f=new i;r?(f=await(async(e,t,n)=>{const r=U(new i(j[t]));return oe(r,await se(e,t,n,r))})(n,s,r),o()):await c;const a=new i(f.length+e.length-e.length%K);a.set(f,0),t.enqueue(re(n,e,a,f.length,0))},async flush(e){const{Z:t,$:n,pending:r,ready:o}=this;if(n&&t){await o;let c=new i;if(r.length){const e=t.update(ae(Q,r));n.update(e),c=fe(Q,e)}s.signature=fe(Q,n.digest()).slice(0,L),e.enqueue(oe(c,s.signature))}}}),s=this}}function re(e,t,n,r,s,o){const{Z:c,$:f,pending:a}=e,l=t.length-s;let u;for(a.length&&(t=oe(a,t),n=((e,t)=>{if(t&&t>e.length){const n=e;(e=new i(t)).set(n,0)}return e})(n,l-l%K)),u=0;l-K>=u;u+=K){const e=ae(Q,ce(t,u,u+K));o&&f.update(e);const s=c.update(e);o||f.update(s),n.set(fe(Q,s),u+r)}return e.pending=ce(t,u),n}async function se(n,r,s,o){n.password=null;const c=await(async(e,t,n,r,s)=>{if(!$)return V.importKey(t);try{return await G.importKey("raw",t,n,!1,s)}catch(e){return $=!1,V.importKey(t)}})(0,s,O,0,W),f=await(async(e,t,n)=>{if(!ee)return V.M(t,e.salt,T.iterations,n);try{return await G.deriveBits(e,t,n)}catch(r){return ee=!1,V.M(t,e.salt,T.iterations,n)}})(t.assign({salt:o},T),c,8*(2*H[r]+2)),a=new i(f),l=ae(Q,ce(a,0,H[r])),u=ae(Q,ce(a,H[r],2*H[r])),w=ce(a,2*H[r]);return t.assign(n,{keys:{key:l,ee:u,passwordVerification:w},Z:new Y(new X(l),e.from(F)),$:new Z(u)}),w}function ie(e,t){return t===k?(e=>{if(typeof w==v){const t=new i((e=unescape(encodeURIComponent(e))).length);for(let n=0;n<t.length;n++)t[n]=e.charCodeAt(n);return t}return(new w).encode(e)})(e):t}function oe(e,t){let n=e;return e.length+t.length&&(n=new i(e.length+t.length),n.set(e,0),n.set(t,e.length)),n}function ce(e,t,n){return e.subarray(t,n)}function fe(e,t){return e.m(t)}function ae(e,t){return e.k(t)}class le extends p{constructor({password:e,passwordVerification:n,checkPasswordOnly:r}){super({start(){t.assign(this,{password:e,passwordVerification:n}),de(this,e)},transform(e,t){const n=this;if(n.password){const t=we(n,e.subarray(0,12));if(n.password=null,t[11]!=n.passwordVerification)throw new s(B);e=e.subarray(12)}r?t.error(new s(M)):t.enqueue(we(n,e))}})}}class ue extends p{constructor({password:e,passwordVerification:n}){super({start(){t.assign(this,{password:e,passwordVerification:n}),de(this,e)},transform(e,t){const n=this;let r,s;if(n.password){n.password=null;const t=U(new i(12));t[11]=n.passwordVerification,r=new i(e.length+t.length),r.set(he(n,t),0),s=12}else r=new i(e.length),s=0;r.set(he(n,e),s),t.enqueue(r)}})}}function we(e,t){const n=new i(t.length);for(let r=0;r<t.length;r++)n[r]=ye(e)^t[r],pe(e,n[r]);return n}function he(e,t){const n=new i(t.length);for(let r=0;r<t.length;r++)n[r]=ye(e)^t[r],pe(e,t[r]);return n}function de(e,n){const r=[305419896,591751049,878082192];t.assign(e,{keys:r,te:new x(r[0]),ne:new x(r[2])});for(let t=0;t<n.length;t++)pe(e,n.charCodeAt(t))}function pe(e,t){let[n,s,i]=e.keys;e.te.append([t]),n=~e.te.get(),s=be(r.imul(be(s+me(n)),134775813)+1),e.ne.append([s>>>24]),i=~e.ne.get(),e.keys=[n,s,i]}function ye(e){const t=2|e.keys[2];return me(r.imul(t,1^t)>>>8)}function me(e){return 255&e}function be(e){return 4294967295&e}const ge="deflate-raw";class ke extends p{constructor(e,{chunkSize:t,CompressionStream:n,CompressionStreamNative:r}){super({});const{compressed:s,encrypted:i,useCompressionStream:o,zipCrypto:c,signed:f,level:a}=e,u=this;let w,h,d=Se(super.readable);i&&!c||!f||(w=new A,d=xe(d,w)),s&&(d=Ce(d,o,{level:a,chunkSize:t},r,n)),i&&(c?d=xe(d,new ue(e)):(h=new ne(e),d=xe(d,h))),ze(u,d,(()=>{let e;i&&!c&&(e=h.signature),i&&!c||!f||(e=new l(w.value.buffer).getUint32(0)),u.signature=e}))}}class ve extends p{constructor(e,{chunkSize:t,DecompressionStream:n,DecompressionStreamNative:r}){super({});const{zipCrypto:i,encrypted:o,signed:c,signature:f,compressed:a,useCompressionStream:u}=e;let w,h,d=Se(super.readable);o&&(i?d=xe(d,new le(e)):(h=new te(e),d=xe(d,h))),a&&(d=Ce(d,u,{chunkSize:t},r,n)),o&&!i||!c||(w=new A,d=xe(d,w)),ze(this,d,(()=>{if((!o||i)&&c){const e=new l(w.value.buffer);if(f!=e.getUint32(0,!1))throw new s(E)}}))}}function Se(e){return xe(e,new p({transform(e,t){e&&e.length&&t.enqueue(e)}}))}function ze(e,n,r){n=xe(n,new p({flush:r})),t.defineProperty(e,"readable",{get:()=>n})}function Ce(e,t,n,r,s){try{e=xe(e,new(t&&r?r:s)(ge,n))}catch(r){if(!t)return e;try{e=xe(e,new s(ge,n))}catch(t){return e}}return e}function xe(e,t){return e.pipeThrough(t)}const Ae="data",_e="close";class Ie extends p{constructor(e,n){super({});const r=this,{codecType:s}=e;let i;s.startsWith("deflate")?i=ke:s.startsWith("inflate")&&(i=ve);let o=0,c=0;const f=new i(e,n),a=super.readable,l=new p({transform(e,t){e&&e.length&&(c+=e.length,t.enqueue(e))},flush(){t.assign(r,{inputSize:c})}}),u=new p({transform(e,t){e&&e.length&&(o+=e.length,t.enqueue(e))},flush(){const{signature:e}=f;t.assign(r,{signature:e,outputSize:o,inputSize:c})}});t.defineProperty(r,"readable",{get:()=>a.pipeThrough(l).pipeThrough(f).pipeThrough(u)})}}class Pe extends p{constructor(e){let t;super({transform:function n(r,s){if(t){const e=new i(t.length+r.length);e.set(t),e.set(r,t.length),r=e,t=null}r.length>e?(s.enqueue(r.slice(0,e)),n(r.slice(e),s)):t=r},flush(e){t&&t.length&&e.enqueue(t)}})}}const De=new a,Ve=new a;let Re,Be=0,Ee=!0;async function Me(e){try{const{options:t,scripts:r,config:s}=e;if(r&&r.length)try{Ee?importScripts.apply(k,r):await Ue(r)}catch(e){Ee=!1,await Ue(r)}self.initCodec&&self.initCodec(),s.CompressionStreamNative=self.CompressionStream,s.DecompressionStreamNative=self.DecompressionStream,self.Deflate&&(s.CompressionStream=new z(self.Deflate)),self.Inflate&&(s.DecompressionStream=new z(self.Inflate));const i={highWaterMark:1},o=e.readable||new y({async pull(e){const t=new u((e=>De.set(Be,e)));Ke({type:"pull",messageId:Be}),Be=(Be+1)%n.MAX_SAFE_INTEGER;const{value:r,done:s}=await t;e.enqueue(r),s&&e.close()}},i),c=e.writable||new m({async write(e){let t;const r=new u((e=>t=e));Ve.set(Be,t),Ke({type:Ae,value:e,messageId:Be}),Be=(Be+1)%n.MAX_SAFE_INTEGER,await r}},i),f=new Ie(t,s);Re=new AbortController;const{signal:a}=Re;await o.pipeThrough(f).pipeThrough(new Pe(s.chunkSize)).pipeTo(c,{signal:a,preventClose:!0,preventAbort:!0}),await c.getWriter().close();const{signature:l,inputSize:w,outputSize:h}=f;Ke({type:_e,result:{signature:l,inputSize:w,outputSize:h}})}catch(e){Ne(e)}}async function Ue(e){for(const t of e)await import(t)}function Ke(e){let{value:t}=e;if(t)if(t.length)try{t=new i(t),e.value=t.buffer,d(e,[e.value])}catch(t){d(e)}else d(e);else d(e)}function Ne(e=new s("Unknown error")){const{message:t,stack:n,code:r,name:i}=e;d({error:{message:t,stack:n,code:r,name:i}})}addEventListener("message",(({data:e})=>{const{type:t,messageId:n,value:r,done:s}=e;try{if("start"==t&&Me(e),t==Ae){const e=De.get(n);De.delete(n),e({value:new i(r),done:s})}if("ack"==t){const e=Ve.get(n);Ve.delete(n),e()}t==_e&&Re.abort()}catch(e){Ne(e)}}));const Oe=15,Te=573,We=-2;function je(t){return He(t.map((([t,n])=>new e(t).fill(n,0,t))))}function He(t){return t.reduce(((t,n)=>t.concat(e.isArray(n)?He(n):n)),[])}const Le=[0,1,2,3].concat(...je([[2,4],[2,5],[4,6],[4,7],[8,8],[8,9],[16,10],[16,11],[32,12],[32,13],[64,14],[64,15],[2,0],[1,16],[1,17],[2,18],[2,19],[4,20],[4,21],[8,22],[8,23],[16,24],[16,25],[32,26],[32,27],[64,28],[64,29]]));function Fe(){const e=this;function t(e,t){let n=0;do{n|=1&e,e>>>=1,n<<=1}while(--t>0);return n>>>1}e.re=n=>{const s=e.se,i=e.oe.ie,o=e.oe.ce;let c,f,a,l=-1;for(n.fe=0,n.ae=Te,c=0;o>c;c++)0!==s[2*c]?(n.le[++n.fe]=l=c,n.ue[c]=0):s[2*c+1]=0;for(;2>n.fe;)a=n.le[++n.fe]=2>l?++l:0,s[2*a]=1,n.ue[a]=0,n.we--,i&&(n.he-=i[2*a+1]);for(e.de=l,c=r.floor(n.fe/2);c>=1;c--)n.pe(s,c);a=o;do{c=n.le[1],n.le[1]=n.le[n.fe--],n.pe(s,1),f=n.le[1],n.le[--n.ae]=c,n.le[--n.ae]=f,s[2*a]=s[2*c]+s[2*f],n.ue[a]=r.max(n.ue[c],n.ue[f])+1,s[2*c+1]=s[2*f+1]=a,n.le[1]=a++,n.pe(s,1)}while(n.fe>=2);n.le[--n.ae]=n.le[1],(t=>{const n=e.se,r=e.oe.ie,s=e.oe.ye,i=e.oe.me,o=e.oe.be;let c,f,a,l,u,w,h=0;for(l=0;Oe>=l;l++)t.ge[l]=0;for(n[2*t.le[t.ae]+1]=0,c=t.ae+1;Te>c;c++)f=t.le[c],l=n[2*n[2*f+1]+1]+1,l>o&&(l=o,h++),n[2*f+1]=l,f>e.de||(t.ge[l]++,u=0,i>f||(u=s[f-i]),w=n[2*f],t.we+=w*(l+u),r&&(t.he+=w*(r[2*f+1]+u)));if(0!==h){do{for(l=o-1;0===t.ge[l];)l--;t.ge[l]--,t.ge[l+1]+=2,t.ge[o]--,h-=2}while(h>0);for(l=o;0!==l;l--)for(f=t.ge[l];0!==f;)a=t.le[--c],a>e.de||(n[2*a+1]!=l&&(t.we+=(l-n[2*a+1])*n[2*a],n[2*a+1]=l),f--)}})(n),((e,n,r)=>{const s=[];let i,o,c,f=0;for(i=1;Oe>=i;i++)s[i]=f=f+r[i-1]<<1;for(o=0;n>=o;o++)c=e[2*o+1],0!==c&&(e[2*o]=t(s[c]++,c))})(s,e.de,n.ge)}}function qe(e,t,n,r,s){const i=this;i.ie=e,i.ye=t,i.me=n,i.ce=r,i.be=s}Fe.ke=[0,1,2,3,4,5,6,7].concat(...je([[2,8],[2,9],[2,10],[2,11],[4,12],[4,13],[4,14],[4,15],[8,16],[8,17],[8,18],[8,19],[16,20],[16,21],[16,22],[16,23],[32,24],[32,25],[32,26],[31,27],[1,28]])),Fe.ve=[0,1,2,3,4,5,6,7,8,10,12,14,16,20,24,28,32,40,48,56,64,80,96,112,128,160,192,224,0],Fe.Se=[0,1,2,3,4,6,8,12,16,24,32,48,64,96,128,192,256,384,512,768,1024,1536,2048,3072,4096,6144,8192,12288,16384,24576],Fe.ze=e=>256>e?Le[e]:Le[256+(e>>>7)],Fe.Ce=[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0],Fe.xe=[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13],Fe.Ae=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7],Fe._e=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];const Ge=je([[144,8],[112,9],[24,7],[8,8]]);qe.Ie=He([12,140,76,204,44,172,108,236,28,156,92,220,60,188,124,252,2,130,66,194,34,162,98,226,18,146,82,210,50,178,114,242,10,138,74,202,42,170,106,234,26,154,90,218,58,186,122,250,6,134,70,198,38,166,102,230,22,150,86,214,54,182,118,246,14,142,78,206,46,174,110,238,30,158,94,222,62,190,126,254,1,129,65,193,33,161,97,225,17,145,81,209,49,177,113,241,9,137,73,201,41,169,105,233,25,153,89,217,57,185,121,249,5,133,69,197,37,165,101,229,21,149,85,213,53,181,117,245,13,141,77,205,45,173,109,237,29,157,93,221,61,189,125,253,19,275,147,403,83,339,211,467,51,307,179,435,115,371,243,499,11,267,139,395,75,331,203,459,43,299,171,427,107,363,235,491,27,283,155,411,91,347,219,475,59,315,187,443,123,379,251,507,7,263,135,391,71,327,199,455,39,295,167,423,103,359,231,487,23,279,151,407,87,343,215,471,55,311,183,439,119,375,247,503,15,271,143,399,79,335,207,463,47,303,175,431,111,367,239,495,31,287,159,415,95,351,223,479,63,319,191,447,127,383,255,511,0,64,32,96,16,80,48,112,8,72,40,104,24,88,56,120,4,68,36,100,20,84,52,116,3,131,67,195,35,163,99,227].map(((e,t)=>[e,Ge[t]])));const Je=je([[30,5]]);function Qe(e,t,n,r,s){const i=this;i.Pe=e,i.De=t,i.Ve=n,i.Re=r,i.Be=s}qe.Ee=He([0,16,8,24,4,20,12,28,2,18,10,26,6,22,14,30,1,17,9,25,5,21,13,29,3,19,11,27,7,23].map(((e,t)=>[e,Je[t]]))),qe.Me=new qe(qe.Ie,Fe.Ce,257,286,Oe),qe.Ue=new qe(qe.Ee,Fe.xe,0,30,Oe),qe.Ke=new qe(null,Fe.Ae,0,19,7);const Xe=[new Qe(0,0,0,0,0),new Qe(4,4,8,4,1),new Qe(4,5,16,8,1),new Qe(4,6,32,32,1),new Qe(4,4,16,16,2),new Qe(8,16,32,32,2),new Qe(8,16,128,128,2),new Qe(8,32,128,256,2),new Qe(32,128,258,1024,2),new Qe(32,258,258,4096,2)],Ye=["need dictionary","stream end","","","stream error","data error","","buffer error","",""],Ze=113,$e=666,et=262;function tt(e,t,n,r){const s=e[2*t],i=e[2*n];return i>s||s==i&&r[t]<=r[n]}function nt(){const e=this;let t,n,s,c,f,a,l,u,w,h,d,p,y,m,b,g,k,v,S,z,C,x,A,_,I,P,D,V,R,B,E,M,U;const K=new Fe,N=new Fe,O=new Fe;let T,W,j,H,L,F;function q(){let t;for(t=0;286>t;t++)E[2*t]=0;for(t=0;30>t;t++)M[2*t]=0;for(t=0;19>t;t++)U[2*t]=0;E[512]=1,e.we=e.he=0,W=j=0}function G(e,t){let n,r=-1,s=e[1],i=0,o=7,c=4;0===s&&(o=138,c=3),e[2*(t+1)+1]=65535;for(let f=0;t>=f;f++)n=s,s=e[2*(f+1)+1],++i<o&&n==s||(c>i?U[2*n]+=i:0!==n?(n!=r&&U[2*n]++,U[32]++):i>10?U[36]++:U[34]++,i=0,r=n,0===s?(o=138,c=3):n==s?(o=6,c=3):(o=7,c=4))}function J(t){e.Ne[e.pending++]=t}function Q(e){J(255&e),J(e>>>8&255)}function X(e,t){let n;const r=t;F>16-r?(n=e,L|=n<<F&65535,Q(L),L=n>>>16-F,F+=r-16):(L|=e<<F&65535,F+=r)}function Y(e,t){const n=2*e;X(65535&t[n],65535&t[n+1])}function Z(e,t){let n,r,s=-1,i=e[1],o=0,c=7,f=4;for(0===i&&(c=138,f=3),n=0;t>=n;n++)if(r=i,i=e[2*(n+1)+1],++o>=c||r!=i){if(f>o)do{Y(r,U)}while(0!=--o);else 0!==r?(r!=s&&(Y(r,U),o--),Y(16,U),X(o-3,2)):o>10?(Y(18,U),X(o-11,7)):(Y(17,U),X(o-3,3));o=0,s=r,0===i?(c=138,f=3):r==i?(c=6,f=3):(c=7,f=4)}}function $(){16==F?(Q(L),L=0,F=0):8>F||(J(255&L),L>>>=8,F-=8)}function ee(t,n){let s,i,o;if(e.Oe[W]=t,e.Te[W]=255&n,W++,0===t?E[2*n]++:(j++,t--,E[2*(Fe.ke[n]+256+1)]++,M[2*Fe.ze(t)]++),!(8191&W)&&D>2){for(s=8*W,i=C-k,o=0;30>o;o++)s+=M[2*o]*(5+Fe.xe[o]);if(s>>>=3,j<r.floor(W/2)&&s<r.floor(i/2))return!0}return W==T-1}function te(t,n){let r,s,i,o,c=0;if(0!==W)do{r=e.Oe[c],s=e.Te[c],c++,0===r?Y(s,t):(i=Fe.ke[s],Y(i+256+1,t),o=Fe.Ce[i],0!==o&&(s-=Fe.ve[i],X(s,o)),r--,i=Fe.ze(r),Y(i,n),o=Fe.xe[i],0!==o&&(r-=Fe.Se[i],X(r,o)))}while(W>c);Y(256,t),H=t[513]}function ne(){F>8?Q(L):F>0&&J(255&L),L=0,F=0}function re(t,n,r){X(0+(r?1:0),3),((t,n)=>{ne(),H=8,Q(n),Q(~n),e.Ne.set(u.subarray(t,t+n),e.pending),e.pending+=n})(t,n)}function se(n){((t,n,r)=>{let s,i,o=0;D>0?(K.re(e),N.re(e),o=(()=>{let t;for(G(E,K.de),G(M,N.de),O.re(e),t=18;t>=3&&0===U[2*Fe._e[t]+1];t--);return e.we+=14+3*(t+1),t})(),s=e.we+3+7>>>3,i=e.he+3+7>>>3,i>s||(s=i)):s=i=n+5,n+4>s||-1==t?i==s?(X(2+(r?1:0),3),te(qe.Ie,qe.Ee)):(X(4+(r?1:0),3),((e,t,n)=>{let r;for(X(e-257,5),X(t-1,5),X(n-4,4),r=0;n>r;r++)X(U[2*Fe._e[r]+1],3);Z(E,e-1),Z(M,t-1)})(K.de+1,N.de+1,o+1),te(E,M)):re(t,n,r),q(),r&&ne()})(0>k?-1:k,C-k,n),k=C,t.We()}function ie(){let e,n,r,s;do{if(s=w-A-C,0===s&&0===C&&0===A)s=f;else if(-1==s)s--;else if(C>=f+f-et){u.set(u.subarray(f,f+f),0),x-=f,C-=f,k-=f,e=y,r=e;do{n=65535&d[--r],d[r]=f>n?0:n-f}while(0!=--e);e=f,r=e;do{n=65535&h[--r],h[r]=f>n?0:n-f}while(0!=--e);s+=f}if(0===t.je)return;e=t.He(u,C+A,s),A+=e,3>A||(p=255&u[C],p=(p<<g^255&u[C+1])&b)}while(et>A&&0!==t.je)}function oe(e){let t,n,r=I,s=C,i=_;const o=C>f-et?C-(f-et):0;let c=B;const a=l,w=C+258;let d=u[s+i-1],p=u[s+i];R>_||(r>>=2),c>A&&(c=A);do{if(t=e,u[t+i]==p&&u[t+i-1]==d&&u[t]==u[s]&&u[++t]==u[s+1]){s+=2,t++;do{}while(u[++s]==u[++t]&&u[++s]==u[++t]&&u[++s]==u[++t]&&u[++s]==u[++t]&&u[++s]==u[++t]&&u[++s]==u[++t]&&u[++s]==u[++t]&&u[++s]==u[++t]&&w>s);if(n=258-(w-s),s=w-258,n>i){if(x=e,i=n,n>=c)break;d=u[s+i-1],p=u[s+i]}}}while((e=65535&h[e&a])>o&&0!=--r);return i>A?A:i}e.ue=[],e.ge=[],e.le=[],E=[],M=[],U=[],e.pe=(t,n)=>{const r=e.le,s=r[n];let i=n<<1;for(;i<=e.fe&&(i<e.fe&&tt(t,r[i+1],r[i],e.ue)&&i++,!tt(t,s,r[i],e.ue));)r[n]=r[i],n=i,i<<=1;r[n]=s},e.Le=(t,S,x,W,j,G)=>(W||(W=8),j||(j=8),G||(G=0),t.Fe=null,-1==S&&(S=6),1>j||j>9||8!=W||9>x||x>15||0>S||S>9||0>G||G>2?We:(t.qe=e,a=x,f=1<<a,l=f-1,m=j+7,y=1<<m,b=y-1,g=r.floor((m+3-1)/3),u=new i(2*f),h=[],d=[],T=1<<j+6,e.Ne=new i(4*T),s=4*T,e.Oe=new o(T),e.Te=new i(T),D=S,V=G,(t=>(t.Ge=t.Je=0,t.Fe=null,e.pending=0,e.Qe=0,n=Ze,c=0,K.se=E,K.oe=qe.Me,N.se=M,N.oe=qe.Ue,O.se=U,O.oe=qe.Ke,L=0,F=0,H=8,q(),(()=>{w=2*f,d[y-1]=0;for(let e=0;y-1>e;e++)d[e]=0;P=Xe[D].De,R=Xe[D].Pe,B=Xe[D].Ve,I=Xe[D].Re,C=0,k=0,A=0,v=_=2,z=0,p=0})(),0))(t))),e.Xe=()=>42!=n&&n!=Ze&&n!=$e?We:(e.Te=null,e.Oe=null,e.Ne=null,d=null,h=null,u=null,e.qe=null,n==Ze?-3:0),e.Ye=(e,t,n)=>{let r=0;return-1==t&&(t=6),0>t||t>9||0>n||n>2?We:(Xe[D].Be!=Xe[t].Be&&0!==e.Ge&&(r=e.Ze(1)),D!=t&&(D=t,P=Xe[D].De,R=Xe[D].Pe,B=Xe[D].Ve,I=Xe[D].Re),V=n,r)},e.$e=(e,t,r)=>{let s,i=r,o=0;if(!t||42!=n)return We;if(3>i)return 0;for(i>f-et&&(i=f-et,o=r-i),u.set(t.subarray(o,o+i),0),C=i,k=i,p=255&u[0],p=(p<<g^255&u[1])&b,s=0;i-3>=s;s++)p=(p<<g^255&u[s+2])&b,h[s&l]=d[p],d[p]=s;return 0},e.Ze=(r,i)=>{let o,w,m,I,R;if(i>4||0>i)return We;if(!r.et||!r.tt&&0!==r.je||n==$e&&4!=i)return r.Fe=Ye[4],We;if(0===r.nt)return r.Fe=Ye[7],-5;var B;if(t=r,I=c,c=i,42==n&&(w=8+(a-8<<4)<<8,m=(D-1&255)>>1,m>3&&(m=3),w|=m<<6,0!==C&&(w|=32),w+=31-w%31,n=Ze,J((B=w)>>8&255),J(255&B)),0!==e.pending){if(t.We(),0===t.nt)return c=-1,0}else if(0===t.je&&I>=i&&4!=i)return t.Fe=Ye[7],-5;if(n==$e&&0!==t.je)return r.Fe=Ye[7],-5;if(0!==t.je||0!==A||0!=i&&n!=$e){switch(R=-1,Xe[D].Be){case 0:R=(e=>{let n,r=65535;for(r>s-5&&(r=s-5);;){if(1>=A){if(ie(),0===A&&0==e)return 0;if(0===A)break}if(C+=A,A=0,n=k+r,(0===C||C>=n)&&(A=C-n,C=n,se(!1),0===t.nt))return 0;if(C-k>=f-et&&(se(!1),0===t.nt))return 0}return se(4==e),0===t.nt?4==e?2:0:4==e?3:1})(i);break;case 1:R=(e=>{let n,r=0;for(;;){if(et>A){if(ie(),et>A&&0==e)return 0;if(0===A)break}if(3>A||(p=(p<<g^255&u[C+2])&b,r=65535&d[p],h[C&l]=d[p],d[p]=C),0===r||(C-r&65535)>f-et||2!=V&&(v=oe(r)),3>v)n=ee(0,255&u[C]),A--,C++;else if(n=ee(C-x,v-3),A-=v,v>P||3>A)C+=v,v=0,p=255&u[C],p=(p<<g^255&u[C+1])&b;else{v--;do{C++,p=(p<<g^255&u[C+2])&b,r=65535&d[p],h[C&l]=d[p],d[p]=C}while(0!=--v);C++}if(n&&(se(!1),0===t.nt))return 0}return se(4==e),0===t.nt?4==e?2:0:4==e?3:1})(i);break;case 2:R=(e=>{let n,r,s=0;for(;;){if(et>A){if(ie(),et>A&&0==e)return 0;if(0===A)break}if(3>A||(p=(p<<g^255&u[C+2])&b,s=65535&d[p],h[C&l]=d[p],d[p]=C),_=v,S=x,v=2,0!==s&&P>_&&f-et>=(C-s&65535)&&(2!=V&&(v=oe(s)),5>=v&&(1==V||3==v&&C-x>4096)&&(v=2)),3>_||v>_)if(0!==z){if(n=ee(0,255&u[C-1]),n&&se(!1),C++,A--,0===t.nt)return 0}else z=1,C++,A--;else{r=C+A-3,n=ee(C-1-S,_-3),A-=_-1,_-=2;do{++C>r||(p=(p<<g^255&u[C+2])&b,s=65535&d[p],h[C&l]=d[p],d[p]=C)}while(0!=--_);if(z=0,v=2,C++,n&&(se(!1),0===t.nt))return 0}}return 0!==z&&(n=ee(0,255&u[C-1]),z=0),se(4==e),0===t.nt?4==e?2:0:4==e?3:1})(i)}if(2!=R&&3!=R||(n=$e),0==R||2==R)return 0===t.nt&&(c=-1),0;if(1==R){if(1==i)X(2,3),Y(256,qe.Ie),$(),9>1+H+10-F&&(X(2,3),Y(256,qe.Ie),$()),H=7;else if(re(0,0,!1),3==i)for(o=0;y>o;o++)d[o]=0;if(t.We(),0===t.nt)return c=-1,0}}return 4!=i?0:1}}function rt(){const e=this;e.rt=0,e.st=0,e.je=0,e.Ge=0,e.nt=0,e.Je=0}function st(e){const t=new rt,n=(o=e&&e.chunkSize?e.chunkSize:65536)+5*(r.floor(o/16383)+1);var o;const c=new i(n);let f=e?e.level:-1;void 0===f&&(f=-1),t.Le(f),t.et=c,this.append=(e,r)=>{let o,f,a=0,l=0,u=0;const w=[];if(e.length){t.rt=0,t.tt=e,t.je=e.length;do{if(t.st=0,t.nt=n,o=t.Ze(0),0!=o)throw new s("deflating: "+t.Fe);t.st&&(t.st==n?w.push(new i(c)):w.push(c.subarray(0,t.st))),u+=t.st,r&&t.rt>0&&t.rt!=a&&(r(t.rt),a=t.rt)}while(t.je>0||0===t.nt);return w.length>1?(f=new i(u),w.forEach((e=>{f.set(e,l),l+=e.length}))):f=w[0]?new i(w[0]):new i,f}},this.flush=()=>{let e,r,o=0,f=0;const a=[];do{if(t.st=0,t.nt=n,e=t.Ze(4),1!=e&&0!=e)throw new s("deflating: "+t.Fe);n-t.nt>0&&a.push(c.slice(0,t.st)),f+=t.st}while(t.je>0||0===t.nt);return t.Xe(),r=new i(f),a.forEach((e=>{r.set(e,o),o+=e.length})),r}}rt.prototype={Le(e,t){const n=this;return n.qe=new nt,t||(t=Oe),n.qe.Le(n,e,t)},Ze(e){const t=this;return t.qe?t.qe.Ze(t,e):We},Xe(){const e=this;if(!e.qe)return We;const t=e.qe.Xe();return e.qe=null,t},Ye(e,t){const n=this;return n.qe?n.qe.Ye(n,e,t):We},$e(e,t){const n=this;return n.qe?n.qe.$e(n,e,t):We},He(e,t,n){const r=this;let s=r.je;return s>n&&(s=n),0===s?0:(r.je-=s,e.set(r.tt.subarray(r.rt,r.rt+s),t),r.rt+=s,r.Ge+=s,s)},We(){const e=this;let t=e.qe.pending;t>e.nt&&(t=e.nt),0!==t&&(e.et.set(e.qe.Ne.subarray(e.qe.Qe,e.qe.Qe+t),e.st),e.st+=t,e.qe.Qe+=t,e.Je+=t,e.nt-=t,e.qe.pending-=t,0===e.qe.pending&&(e.qe.Qe=0))}};const it=0,ot=1,ct=-2,ft=-3,at=-4,lt=-5,ut=[0,1,3,7,15,31,63,127,255,511,1023,2047,4095,8191,16383,32767,65535],wt=1440,ht=[96,7,256,0,8,80,0,8,16,84,8,115,82,7,31,0,8,112,0,8,48,0,9,192,80,7,10,0,8,96,0,8,32,0,9,160,0,8,0,0,8,128,0,8,64,0,9,224,80,7,6,0,8,88,0,8,24,0,9,144,83,7,59,0,8,120,0,8,56,0,9,208,81,7,17,0,8,104,0,8,40,0,9,176,0,8,8,0,8,136,0,8,72,0,9,240,80,7,4,0,8,84,0,8,20,85,8,227,83,7,43,0,8,116,0,8,52,0,9,200,81,7,13,0,8,100,0,8,36,0,9,168,0,8,4,0,8,132,0,8,68,0,9,232,80,7,8,0,8,92,0,8,28,0,9,152,84,7,83,0,8,124,0,8,60,0,9,216,82,7,23,0,8,108,0,8,44,0,9,184,0,8,12,0,8,140,0,8,76,0,9,248,80,7,3,0,8,82,0,8,18,85,8,163,83,7,35,0,8,114,0,8,50,0,9,196,81,7,11,0,8,98,0,8,34,0,9,164,0,8,2,0,8,130,0,8,66,0,9,228,80,7,7,0,8,90,0,8,26,0,9,148,84,7,67,0,8,122,0,8,58,0,9,212,82,7,19,0,8,106,0,8,42,0,9,180,0,8,10,0,8,138,0,8,74,0,9,244,80,7,5,0,8,86,0,8,22,192,8,0,83,7,51,0,8,118,0,8,54,0,9,204,81,7,15,0,8,102,0,8,38,0,9,172,0,8,6,0,8,134,0,8,70,0,9,236,80,7,9,0,8,94,0,8,30,0,9,156,84,7,99,0,8,126,0,8,62,0,9,220,82,7,27,0,8,110,0,8,46,0,9,188,0,8,14,0,8,142,0,8,78,0,9,252,96,7,256,0,8,81,0,8,17,85,8,131,82,7,31,0,8,113,0,8,49,0,9,194,80,7,10,0,8,97,0,8,33,0,9,162,0,8,1,0,8,129,0,8,65,0,9,226,80,7,6,0,8,89,0,8,25,0,9,146,83,7,59,0,8,121,0,8,57,0,9,210,81,7,17,0,8,105,0,8,41,0,9,178,0,8,9,0,8,137,0,8,73,0,9,242,80,7,4,0,8,85,0,8,21,80,8,258,83,7,43,0,8,117,0,8,53,0,9,202,81,7,13,0,8,101,0,8,37,0,9,170,0,8,5,0,8,133,0,8,69,0,9,234,80,7,8,0,8,93,0,8,29,0,9,154,84,7,83,0,8,125,0,8,61,0,9,218,82,7,23,0,8,109,0,8,45,0,9,186,0,8,13,0,8,141,0,8,77,0,9,250,80,7,3,0,8,83,0,8,19,85,8,195,83,7,35,0,8,115,0,8,51,0,9,198,81,7,11,0,8,99,0,8,35,0,9,166,0,8,3,0,8,131,0,8,67,0,9,230,80,7,7,0,8,91,0,8,27,0,9,150,84,7,67,0,8,123,0,8,59,0,9,214,82,7,19,0,8,107,0,8,43,0,9,182,0,8,11,0,8,139,0,8,75,0,9,246,80,7,5,0,8,87,0,8,23,192,8,0,83,7,51,0,8,119,0,8,55,0,9,206,81,7,15,0,8,103,0,8,39,0,9,174,0,8,7,0,8,135,0,8,71,0,9,238,80,7,9,0,8,95,0,8,31,0,9,158,84,7,99,0,8,127,0,8,63,0,9,222,82,7,27,0,8,111,0,8,47,0,9,190,0,8,15,0,8,143,0,8,79,0,9,254,96,7,256,0,8,80,0,8,16,84,8,115,82,7,31,0,8,112,0,8,48,0,9,193,80,7,10,0,8,96,0,8,32,0,9,161,0,8,0,0,8,128,0,8,64,0,9,225,80,7,6,0,8,88,0,8,24,0,9,145,83,7,59,0,8,120,0,8,56,0,9,209,81,7,17,0,8,104,0,8,40,0,9,177,0,8,8,0,8,136,0,8,72,0,9,241,80,7,4,0,8,84,0,8,20,85,8,227,83,7,43,0,8,116,0,8,52,0,9,201,81,7,13,0,8,100,0,8,36,0,9,169,0,8,4,0,8,132,0,8,68,0,9,233,80,7,8,0,8,92,0,8,28,0,9,153,84,7,83,0,8,124,0,8,60,0,9,217,82,7,23,0,8,108,0,8,44,0,9,185,0,8,12,0,8,140,0,8,76,0,9,249,80,7,3,0,8,82,0,8,18,85,8,163,83,7,35,0,8,114,0,8,50,0,9,197,81,7,11,0,8,98,0,8,34,0,9,165,0,8,2,0,8,130,0,8,66,0,9,229,80,7,7,0,8,90,0,8,26,0,9,149,84,7,67,0,8,122,0,8,58,0,9,213,82,7,19,0,8,106,0,8,42,0,9,181,0,8,10,0,8,138,0,8,74,0,9,245,80,7,5,0,8,86,0,8,22,192,8,0,83,7,51,0,8,118,0,8,54,0,9,205,81,7,15,0,8,102,0,8,38,0,9,173,0,8,6,0,8,134,0,8,70,0,9,237,80,7,9,0,8,94,0,8,30,0,9,157,84,7,99,0,8,126,0,8,62,0,9,221,82,7,27,0,8,110,0,8,46,0,9,189,0,8,14,0,8,142,0,8,78,0,9,253,96,7,256,0,8,81,0,8,17,85,8,131,82,7,31,0,8,113,0,8,49,0,9,195,80,7,10,0,8,97,0,8,33,0,9,163,0,8,1,0,8,129,0,8,65,0,9,227,80,7,6,0,8,89,0,8,25,0,9,147,83,7,59,0,8,121,0,8,57,0,9,211,81,7,17,0,8,105,0,8,41,0,9,179,0,8,9,0,8,137,0,8,73,0,9,243,80,7,4,0,8,85,0,8,21,80,8,258,83,7,43,0,8,117,0,8,53,0,9,203,81,7,13,0,8,101,0,8,37,0,9,171,0,8,5,0,8,133,0,8,69,0,9,235,80,7,8,0,8,93,0,8,29,0,9,155,84,7,83,0,8,125,0,8,61,0,9,219,82,7,23,0,8,109,0,8,45,0,9,187,0,8,13,0,8,141,0,8,77,0,9,251,80,7,3,0,8,83,0,8,19,85,8,195,83,7,35,0,8,115,0,8,51,0,9,199,81,7,11,0,8,99,0,8,35,0,9,167,0,8,3,0,8,131,0,8,67,0,9,231,80,7,7,0,8,91,0,8,27,0,9,151,84,7,67,0,8,123,0,8,59,0,9,215,82,7,19,0,8,107,0,8,43,0,9,183,0,8,11,0,8,139,0,8,75,0,9,247,80,7,5,0,8,87,0,8,23,192,8,0,83,7,51,0,8,119,0,8,55,0,9,207,81,7,15,0,8,103,0,8,39,0,9,175,0,8,7,0,8,135,0,8,71,0,9,239,80,7,9,0,8,95,0,8,31,0,9,159,84,7,99,0,8,127,0,8,63,0,9,223,82,7,27,0,8,111,0,8,47,0,9,191,0,8,15,0,8,143,0,8,79,0,9,255],dt=[80,5,1,87,5,257,83,5,17,91,5,4097,81,5,5,89,5,1025,85,5,65,93,5,16385,80,5,3,88,5,513,84,5,33,92,5,8193,82,5,9,90,5,2049,86,5,129,192,5,24577,80,5,2,87,5,385,83,5,25,91,5,6145,81,5,7,89,5,1537,85,5,97,93,5,24577,80,5,4,88,5,769,84,5,49,92,5,12289,82,5,13,90,5,3073,86,5,193,192,5,24577],pt=[3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258,0,0],yt=[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,112,112],mt=[1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577],bt=[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13],gt=15;function kt(){let e,t,n,r,s,i;function o(e,t,o,c,f,a,l,u,w,h,d){let p,y,m,b,g,k,v,S,z,C,x,A,_,I,P;C=0,g=o;do{n[e[t+C]]++,C++,g--}while(0!==g);if(n[0]==o)return l[0]=-1,u[0]=0,it;for(S=u[0],k=1;gt>=k&&0===n[k];k++);for(v=k,k>S&&(S=k),g=gt;0!==g&&0===n[g];g--);for(m=g,S>g&&(S=g),u[0]=S,I=1<<k;g>k;k++,I<<=1)if(0>(I-=n[k]))return ft;if(0>(I-=n[g]))return ft;for(n[g]+=I,i[1]=k=0,C=1,_=2;0!=--g;)i[_]=k+=n[C],_++,C++;g=0,C=0;do{0!==(k=e[t+C])&&(d[i[k]++]=g),C++}while(++g<o);for(o=i[m],i[0]=g=0,C=0,b=-1,A=-S,s[0]=0,x=0,P=0;m>=v;v++)for(p=n[v];0!=p--;){for(;v>A+S;){if(b++,A+=S,P=m-A,P=P>S?S:P,(y=1<<(k=v-A))>p+1&&(y-=p+1,_=v,P>k))for(;++k<P&&(y<<=1)>n[++_];)y-=n[_];if(P=1<<k,h[0]+P>wt)return ft;s[b]=x=h[0],h[0]+=P,0!==b?(i[b]=g,r[0]=k,r[1]=S,k=g>>>A-S,r[2]=x-s[b-1]-k,w.set(r,3*(s[b-1]+k))):l[0]=x}for(r[1]=v-A,o>C?d[C]<c?(r[0]=256>d[C]?0:96,r[2]=d[C++]):(r[0]=a[d[C]-c]+16+64,r[2]=f[d[C++]-c]):r[0]=192,y=1<<v-A,k=g>>>A;P>k;k+=y)w.set(r,3*(x+k));for(k=1<<v-1;g&k;k>>>=1)g^=k;for(g^=k,z=(1<<A)-1;(g&z)!=i[b];)b--,A-=S,z=(1<<A)-1}return 0!==I&&1!=m?lt:it}function c(o){let c;for(e||(e=[],t=[],n=new f(gt+1),r=[],s=new f(gt),i=new f(gt+1)),t.length<o&&(t=[]),c=0;o>c;c++)t[c]=0;for(c=0;gt+1>c;c++)n[c]=0;for(c=0;3>c;c++)r[c]=0;s.set(n.subarray(0,gt),0),i.set(n.subarray(0,gt+1),0)}this.it=(n,r,s,i,f)=>{let a;return c(19),e[0]=0,a=o(n,0,19,19,null,null,s,r,i,e,t),a==ft?f.Fe="oversubscribed dynamic bit lengths tree":a!=lt&&0!==r[0]||(f.Fe="incomplete dynamic bit lengths tree",a=ft),a},this.ot=(n,r,s,i,f,a,l,u,w)=>{let h;return c(288),e[0]=0,h=o(s,0,n,257,pt,yt,a,i,u,e,t),h!=it||0===i[0]?(h==ft?w.Fe="oversubscribed literal/length tree":h!=at&&(w.Fe="incomplete literal/length tree",h=ft),h):(c(288),h=o(s,n,r,0,mt,bt,l,f,u,e,t),h!=it||0===f[0]&&n>257?(h==ft?w.Fe="oversubscribed distance tree":h==lt?(w.Fe="incomplete distance tree",h=ft):h!=at&&(w.Fe="empty distance tree with lengths",h=ft),h):it)}}kt.ct=(e,t,n,r)=>(e[0]=9,t[0]=5,n[0]=ht,r[0]=dt,it);const vt=0,St=1,zt=2,Ct=3,xt=4,At=5,_t=6,It=7,Pt=8,Dt=9;function Vt(){const e=this;let t,n,r,s,i=0,o=0,c=0,f=0,a=0,l=0,u=0,w=0,h=0,d=0;function p(e,t,n,r,s,i,o,c){let f,a,l,u,w,h,d,p,y,m,b,g,k,v,S,z;d=c.rt,p=c.je,w=o.ft,h=o.lt,y=o.write,m=y<o.read?o.read-y-1:o.end-y,b=ut[e],g=ut[t];do{for(;20>h;)p--,w|=(255&c.ut(d++))<<h,h+=8;if(f=w&b,a=n,l=r,z=3*(l+f),0!==(u=a[z]))for(;;){if(w>>=a[z+1],h-=a[z+1],16&u){for(u&=15,k=a[z+2]+(w&ut[u]),w>>=u,h-=u;15>h;)p--,w|=(255&c.ut(d++))<<h,h+=8;for(f=w&g,a=s,l=i,z=3*(l+f),u=a[z];;){if(w>>=a[z+1],h-=a[z+1],16&u){for(u&=15;u>h;)p--,w|=(255&c.ut(d++))<<h,h+=8;if(v=a[z+2]+(w&ut[u]),w>>=u,h-=u,m-=k,v>y){S=y-v;do{S+=o.end}while(0>S);if(u=o.end-S,k>u){if(k-=u,y-S>0&&u>y-S)do{o.wt[y++]=o.wt[S++]}while(0!=--u);else o.wt.set(o.wt.subarray(S,S+u),y),y+=u,S+=u,u=0;S=0}}else S=y-v,y-S>0&&2>y-S?(o.wt[y++]=o.wt[S++],o.wt[y++]=o.wt[S++],k-=2):(o.wt.set(o.wt.subarray(S,S+2),y),y+=2,S+=2,k-=2);if(y-S>0&&k>y-S)do{o.wt[y++]=o.wt[S++]}while(0!=--k);else o.wt.set(o.wt.subarray(S,S+k),y),y+=k,S+=k,k=0;break}if(64&u)return c.Fe="invalid distance code",k=c.je-p,k=k>h>>3?h>>3:k,p+=k,d-=k,h-=k<<3,o.ft=w,o.lt=h,c.je=p,c.Ge+=d-c.rt,c.rt=d,o.write=y,ft;f+=a[z+2],f+=w&ut[u],z=3*(l+f),u=a[z]}break}if(64&u)return 32&u?(k=c.je-p,k=k>h>>3?h>>3:k,p+=k,d-=k,h-=k<<3,o.ft=w,o.lt=h,c.je=p,c.Ge+=d-c.rt,c.rt=d,o.write=y,ot):(c.Fe="invalid literal/length code",k=c.je-p,k=k>h>>3?h>>3:k,p+=k,d-=k,h-=k<<3,o.ft=w,o.lt=h,c.je=p,c.Ge+=d-c.rt,c.rt=d,o.write=y,ft);if(f+=a[z+2],f+=w&ut[u],z=3*(l+f),0===(u=a[z])){w>>=a[z+1],h-=a[z+1],o.wt[y++]=a[z+2],m--;break}}else w>>=a[z+1],h-=a[z+1],o.wt[y++]=a[z+2],m--}while(m>=258&&p>=10);return k=c.je-p,k=k>h>>3?h>>3:k,p+=k,d-=k,h-=k<<3,o.ft=w,o.lt=h,c.je=p,c.Ge+=d-c.rt,c.rt=d,o.write=y,it}e.init=(e,i,o,c,f,a)=>{t=vt,u=e,w=i,r=o,h=c,s=f,d=a,n=null},e.ht=(e,y,m)=>{let b,g,k,v,S,z,C,x=0,A=0,_=0;for(_=y.rt,v=y.je,x=e.ft,A=e.lt,S=e.write,z=S<e.read?e.read-S-1:e.end-S;;)switch(t){case vt:if(z>=258&&v>=10&&(e.ft=x,e.lt=A,y.je=v,y.Ge+=_-y.rt,y.rt=_,e.write=S,m=p(u,w,r,h,s,d,e,y),_=y.rt,v=y.je,x=e.ft,A=e.lt,S=e.write,z=S<e.read?e.read-S-1:e.end-S,m!=it)){t=m==ot?It:Dt;break}c=u,n=r,o=h,t=St;case St:for(b=c;b>A;){if(0===v)return e.ft=x,e.lt=A,y.je=v,y.Ge+=_-y.rt,y.rt=_,e.write=S,e.dt(y,m);m=it,v--,x|=(255&y.ut(_++))<<A,A+=8}if(g=3*(o+(x&ut[b])),x>>>=n[g+1],A-=n[g+1],k=n[g],0===k){f=n[g+2],t=_t;break}if(16&k){a=15&k,i=n[g+2],t=zt;break}if(!(64&k)){c=k,o=g/3+n[g+2];break}if(32&k){t=It;break}return t=Dt,y.Fe="invalid literal/length code",m=ft,e.ft=x,e.lt=A,y.je=v,y.Ge+=_-y.rt,y.rt=_,e.write=S,e.dt(y,m);case zt:for(b=a;b>A;){if(0===v)return e.ft=x,e.lt=A,y.je=v,y.Ge+=_-y.rt,y.rt=_,e.write=S,e.dt(y,m);m=it,v--,x|=(255&y.ut(_++))<<A,A+=8}i+=x&ut[b],x>>=b,A-=b,c=w,n=s,o=d,t=Ct;case Ct:for(b=c;b>A;){if(0===v)return e.ft=x,e.lt=A,y.je=v,y.Ge+=_-y.rt,y.rt=_,e.write=S,e.dt(y,m);m=it,v--,x|=(255&y.ut(_++))<<A,A+=8}if(g=3*(o+(x&ut[b])),x>>=n[g+1],A-=n[g+1],k=n[g],16&k){a=15&k,l=n[g+2],t=xt;break}if(!(64&k)){c=k,o=g/3+n[g+2];break}return t=Dt,y.Fe="invalid distance code",m=ft,e.ft=x,e.lt=A,y.je=v,y.Ge+=_-y.rt,y.rt=_,e.write=S,e.dt(y,m);case xt:for(b=a;b>A;){if(0===v)return e.ft=x,e.lt=A,y.je=v,y.Ge+=_-y.rt,y.rt=_,e.write=S,e.dt(y,m);m=it,v--,x|=(255&y.ut(_++))<<A,A+=8}l+=x&ut[b],x>>=b,A-=b,t=At;case At:for(C=S-l;0>C;)C+=e.end;for(;0!==i;){if(0===z&&(S==e.end&&0!==e.read&&(S=0,z=S<e.read?e.read-S-1:e.end-S),0===z&&(e.write=S,m=e.dt(y,m),S=e.write,z=S<e.read?e.read-S-1:e.end-S,S==e.end&&0!==e.read&&(S=0,z=S<e.read?e.read-S-1:e.end-S),0===z)))return e.ft=x,e.lt=A,y.je=v,y.Ge+=_-y.rt,y.rt=_,e.write=S,e.dt(y,m);e.wt[S++]=e.wt[C++],z--,C==e.end&&(C=0),i--}t=vt;break;case _t:if(0===z&&(S==e.end&&0!==e.read&&(S=0,z=S<e.read?e.read-S-1:e.end-S),0===z&&(e.write=S,m=e.dt(y,m),S=e.write,z=S<e.read?e.read-S-1:e.end-S,S==e.end&&0!==e.read&&(S=0,z=S<e.read?e.read-S-1:e.end-S),0===z)))return e.ft=x,e.lt=A,y.je=v,y.Ge+=_-y.rt,y.rt=_,e.write=S,e.dt(y,m);m=it,e.wt[S++]=f,z--,t=vt;break;case It:if(A>7&&(A-=8,v++,_--),e.write=S,m=e.dt(y,m),S=e.write,z=S<e.read?e.read-S-1:e.end-S,e.read!=e.write)return e.ft=x,e.lt=A,y.je=v,y.Ge+=_-y.rt,y.rt=_,e.write=S,e.dt(y,m);t=Pt;case Pt:return m=ot,e.ft=x,e.lt=A,y.je=v,y.Ge+=_-y.rt,y.rt=_,e.write=S,e.dt(y,m);case Dt:return m=ft,e.ft=x,e.lt=A,y.je=v,y.Ge+=_-y.rt,y.rt=_,e.write=S,e.dt(y,m);default:return m=ct,e.ft=x,e.lt=A,y.je=v,y.Ge+=_-y.rt,y.rt=_,e.write=S,e.dt(y,m)}},e.yt=()=>{}}const Rt=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15],Bt=0,Et=1,Mt=2,Ut=3,Kt=4,Nt=5,Ot=6,Tt=7,Wt=8,jt=9;function Ht(e,t){const n=this;let r,s=Bt,o=0,c=0,a=0;const l=[0],u=[0],w=new Vt;let h=0,d=new f(3*wt);const p=new kt;n.lt=0,n.ft=0,n.wt=new i(t),n.end=t,n.read=0,n.write=0,n.reset=(e,t)=>{t&&(t[0]=0),s==Ot&&w.yt(e),s=Bt,n.lt=0,n.ft=0,n.read=n.write=0},n.reset(e,null),n.dt=(e,t)=>{let r,s,i;return s=e.st,i=n.read,r=(i>n.write?n.end:n.write)-i,r>e.nt&&(r=e.nt),0!==r&&t==lt&&(t=it),e.nt-=r,e.Je+=r,e.et.set(n.wt.subarray(i,i+r),s),s+=r,i+=r,i==n.end&&(i=0,n.write==n.end&&(n.write=0),r=n.write-i,r>e.nt&&(r=e.nt),0!==r&&t==lt&&(t=it),e.nt-=r,e.Je+=r,e.et.set(n.wt.subarray(i,i+r),s),s+=r,i+=r),e.st=s,n.read=i,t},n.ht=(e,t)=>{let i,f,y,m,b,g,k,v;for(m=e.rt,b=e.je,f=n.ft,y=n.lt,g=n.write,k=g<n.read?n.read-g-1:n.end-g;;){let S,z,C,x,A,_,I,P;switch(s){case Bt:for(;3>y;){if(0===b)return n.ft=f,n.lt=y,e.je=b,e.Ge+=m-e.rt,e.rt=m,n.write=g,n.dt(e,t);t=it,b--,f|=(255&e.ut(m++))<<y,y+=8}switch(i=7&f,h=1&i,i>>>1){case 0:f>>>=3,y-=3,i=7&y,f>>>=i,y-=i,s=Et;break;case 1:S=[],z=[],C=[[]],x=[[]],kt.ct(S,z,C,x),w.init(S[0],z[0],C[0],0,x[0],0),f>>>=3,y-=3,s=Ot;break;case 2:f>>>=3,y-=3,s=Ut;break;case 3:return f>>>=3,y-=3,s=jt,e.Fe="invalid block type",t=ft,n.ft=f,n.lt=y,e.je=b,e.Ge+=m-e.rt,e.rt=m,n.write=g,n.dt(e,t)}break;case Et:for(;32>y;){if(0===b)return n.ft=f,n.lt=y,e.je=b,e.Ge+=m-e.rt,e.rt=m,n.write=g,n.dt(e,t);t=it,b--,f|=(255&e.ut(m++))<<y,y+=8}if((~f>>>16&65535)!=(65535&f))return s=jt,e.Fe="invalid stored block lengths",t=ft,n.ft=f,n.lt=y,e.je=b,e.Ge+=m-e.rt,e.rt=m,n.write=g,n.dt(e,t);o=65535&f,f=y=0,s=0!==o?Mt:0!==h?Tt:Bt;break;case Mt:if(0===b)return n.ft=f,n.lt=y,e.je=b,e.Ge+=m-e.rt,e.rt=m,n.write=g,n.dt(e,t);if(0===k&&(g==n.end&&0!==n.read&&(g=0,k=g<n.read?n.read-g-1:n.end-g),0===k&&(n.write=g,t=n.dt(e,t),g=n.write,k=g<n.read?n.read-g-1:n.end-g,g==n.end&&0!==n.read&&(g=0,k=g<n.read?n.read-g-1:n.end-g),0===k)))return n.ft=f,n.lt=y,e.je=b,e.Ge+=m-e.rt,e.rt=m,n.write=g,n.dt(e,t);if(t=it,i=o,i>b&&(i=b),i>k&&(i=k),n.wt.set(e.He(m,i),g),m+=i,b-=i,g+=i,k-=i,0!=(o-=i))break;s=0!==h?Tt:Bt;break;case Ut:for(;14>y;){if(0===b)return n.ft=f,n.lt=y,e.je=b,e.Ge+=m-e.rt,e.rt=m,n.write=g,n.dt(e,t);t=it,b--,f|=(255&e.ut(m++))<<y,y+=8}if(c=i=16383&f,(31&i)>29||(i>>5&31)>29)return s=jt,e.Fe="too many length or distance symbols",t=ft,n.ft=f,n.lt=y,e.je=b,e.Ge+=m-e.rt,e.rt=m,n.write=g,n.dt(e,t);if(i=258+(31&i)+(i>>5&31),!r||r.length<i)r=[];else for(v=0;i>v;v++)r[v]=0;f>>>=14,y-=14,a=0,s=Kt;case Kt:for(;4+(c>>>10)>a;){for(;3>y;){if(0===b)return n.ft=f,n.lt=y,e.je=b,e.Ge+=m-e.rt,e.rt=m,n.write=g,n.dt(e,t);t=it,b--,f|=(255&e.ut(m++))<<y,y+=8}r[Rt[a++]]=7&f,f>>>=3,y-=3}for(;19>a;)r[Rt[a++]]=0;if(l[0]=7,i=p.it(r,l,u,d,e),i!=it)return(t=i)==ft&&(r=null,s=jt),n.ft=f,n.lt=y,e.je=b,e.Ge+=m-e.rt,e.rt=m,n.write=g,n.dt(e,t);a=0,s=Nt;case Nt:for(;i=c,258+(31&i)+(i>>5&31)>a;){let o,w;for(i=l[0];i>y;){if(0===b)return n.ft=f,n.lt=y,e.je=b,e.Ge+=m-e.rt,e.rt=m,n.write=g,n.dt(e,t);t=it,b--,f|=(255&e.ut(m++))<<y,y+=8}if(i=d[3*(u[0]+(f&ut[i]))+1],w=d[3*(u[0]+(f&ut[i]))+2],16>w)f>>>=i,y-=i,r[a++]=w;else{for(v=18==w?7:w-14,o=18==w?11:3;i+v>y;){if(0===b)return n.ft=f,n.lt=y,e.je=b,e.Ge+=m-e.rt,e.rt=m,n.write=g,n.dt(e,t);t=it,b--,f|=(255&e.ut(m++))<<y,y+=8}if(f>>>=i,y-=i,o+=f&ut[v],f>>>=v,y-=v,v=a,i=c,v+o>258+(31&i)+(i>>5&31)||16==w&&1>v)return r=null,s=jt,e.Fe="invalid bit length repeat",t=ft,n.ft=f,n.lt=y,e.je=b,e.Ge+=m-e.rt,e.rt=m,n.write=g,n.dt(e,t);w=16==w?r[v-1]:0;do{r[v++]=w}while(0!=--o);a=v}}if(u[0]=-1,A=[],_=[],I=[],P=[],A[0]=9,_[0]=6,i=c,i=p.ot(257+(31&i),1+(i>>5&31),r,A,_,I,P,d,e),i!=it)return i==ft&&(r=null,s=jt),t=i,n.ft=f,n.lt=y,e.je=b,e.Ge+=m-e.rt,e.rt=m,n.write=g,n.dt(e,t);w.init(A[0],_[0],d,I[0],d,P[0]),s=Ot;case Ot:if(n.ft=f,n.lt=y,e.je=b,e.Ge+=m-e.rt,e.rt=m,n.write=g,(t=w.ht(n,e,t))!=ot)return n.dt(e,t);if(t=it,w.yt(e),m=e.rt,b=e.je,f=n.ft,y=n.lt,g=n.write,k=g<n.read?n.read-g-1:n.end-g,0===h){s=Bt;break}s=Tt;case Tt:if(n.write=g,t=n.dt(e,t),g=n.write,k=g<n.read?n.read-g-1:n.end-g,n.read!=n.write)return n.ft=f,n.lt=y,e.je=b,e.Ge+=m-e.rt,e.rt=m,n.write=g,n.dt(e,t);s=Wt;case Wt:return t=ot,n.ft=f,n.lt=y,e.je=b,e.Ge+=m-e.rt,e.rt=m,n.write=g,n.dt(e,t);case jt:return t=ft,n.ft=f,n.lt=y,e.je=b,e.Ge+=m-e.rt,e.rt=m,n.write=g,n.dt(e,t);default:return t=ct,n.ft=f,n.lt=y,e.je=b,e.Ge+=m-e.rt,e.rt=m,n.write=g,n.dt(e,t)}}},n.yt=e=>{n.reset(e,null),n.wt=null,d=null},n.bt=(e,t,r)=>{n.wt.set(e.subarray(t,t+r),0),n.read=n.write=r},n.gt=()=>s==Et?1:0}const Lt=13,Ft=[0,0,255,255];function qt(){const e=this;function t(e){return e&&e.kt?(e.Ge=e.Je=0,e.Fe=null,e.kt.mode=7,e.kt.vt.reset(e,null),it):ct}e.mode=0,e.method=0,e.St=[0],e.zt=0,e.marker=0,e.Ct=0,e.xt=t=>(e.vt&&e.vt.yt(t),e.vt=null,it),e.At=(n,r)=>(n.Fe=null,e.vt=null,8>r||r>15?(e.xt(n),ct):(e.Ct=r,n.kt.vt=new Ht(n,1<<r),t(n),it)),e._t=(e,t)=>{let n,r;if(!e||!e.kt||!e.tt)return ct;const s=e.kt;for(t=4==t?lt:it,n=lt;;)switch(s.mode){case 0:if(0===e.je)return n;if(n=t,e.je--,e.Ge++,8!=(15&(s.method=e.ut(e.rt++)))){s.mode=Lt,e.Fe="unknown compression method",s.marker=5;break}if(8+(s.method>>4)>s.Ct){s.mode=Lt,e.Fe="invalid win size",s.marker=5;break}s.mode=1;case 1:if(0===e.je)return n;if(n=t,e.je--,e.Ge++,r=255&e.ut(e.rt++),((s.method<<8)+r)%31!=0){s.mode=Lt,e.Fe="incorrect header check",s.marker=5;break}if(!(32&r)){s.mode=7;break}s.mode=2;case 2:if(0===e.je)return n;n=t,e.je--,e.Ge++,s.zt=(255&e.ut(e.rt++))<<24&4278190080,s.mode=3;case 3:if(0===e.je)return n;n=t,e.je--,e.Ge++,s.zt+=(255&e.ut(e.rt++))<<16&16711680,s.mode=4;case 4:if(0===e.je)return n;n=t,e.je--,e.Ge++,s.zt+=(255&e.ut(e.rt++))<<8&65280,s.mode=5;case 5:return 0===e.je?n:(n=t,e.je--,e.Ge++,s.zt+=255&e.ut(e.rt++),s.mode=6,2);case 6:return s.mode=Lt,e.Fe="need dictionary",s.marker=0,ct;case 7:if(n=s.vt.ht(e,n),n==ft){s.mode=Lt,s.marker=0;break}if(n==it&&(n=t),n!=ot)return n;n=t,s.vt.reset(e,s.St),s.mode=12;case 12:return e.je=0,ot;case Lt:return ft;default:return ct}},e.It=(e,t,n)=>{let r=0,s=n;if(!e||!e.kt||6!=e.kt.mode)return ct;const i=e.kt;return s<1<<i.Ct||(s=(1<<i.Ct)-1,r=n-s),i.vt.bt(t,r,s),i.mode=7,it},e.Pt=e=>{let n,r,s,i,o;if(!e||!e.kt)return ct;const c=e.kt;if(c.mode!=Lt&&(c.mode=Lt,c.marker=0),0===(n=e.je))return lt;for(r=e.rt,s=c.marker;0!==n&&4>s;)e.ut(r)==Ft[s]?s++:s=0!==e.ut(r)?0:4-s,r++,n--;return e.Ge+=r-e.rt,e.rt=r,e.je=n,c.marker=s,4!=s?ft:(i=e.Ge,o=e.Je,t(e),e.Ge=i,e.Je=o,c.mode=7,it)},e.Dt=e=>e&&e.kt&&e.kt.vt?e.kt.vt.gt():ct}function Gt(){}function Jt(e){const t=new Gt,n=e&&e.chunkSize?r.floor(2*e.chunkSize):131072,o=new i(n);let c=!1;t.At(),t.et=o,this.append=(e,r)=>{const f=[];let a,l,u=0,w=0,h=0;if(0!==e.length){t.rt=0,t.tt=e,t.je=e.length;do{if(t.st=0,t.nt=n,0!==t.je||c||(t.rt=0,c=!0),a=t._t(0),c&&a===lt){if(0!==t.je)throw new s("inflating: bad input")}else if(a!==it&&a!==ot)throw new s("inflating: "+t.Fe);if((c||a===ot)&&t.je===e.length)throw new s("inflating: bad input");t.st&&(t.st===n?f.push(new i(o)):f.push(o.subarray(0,t.st))),h+=t.st,r&&t.rt>0&&t.rt!=u&&(r(t.rt),u=t.rt)}while(t.je>0||0===t.nt);return f.length>1?(l=new i(h),f.forEach((e=>{l.set(e,w),w+=e.length}))):l=f[0]?new i(f[0]):new i,l}},this.flush=()=>{t.xt()}}Gt.prototype={At(e){const t=this;return t.kt=new qt,e||(e=15),t.kt.At(t,e)},_t(e){const t=this;return t.kt?t.kt._t(t,e):ct},xt(){const e=this;if(!e.kt)return ct;const t=e.kt.xt(e);return e.kt=null,t},Pt(){const e=this;return e.kt?e.kt.Pt(e):ct},It(e,t){const n=this;return n.kt?n.kt.It(n,e,t):ct},ut(e){return this.tt[e]},He(e,t){return this.tt.subarray(e,e+t)}},self.initCodec=()=>{self.Deflate=st,self.Inflate=Jt};\n',
    r = () => t.useDataURI ? "data:text/javascript," + encodeURIComponent(n) : URL.createObjectURL(new Blob([n], {
      type: "text/javascript"
    }));
  e({
    workerScripts: {
      inflate: [r],
      deflate: [r]
    }
  });
}

/*
 Copyright (c) 2022 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright 
 notice, this list of conditions and the following disclaimer in 
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
const ERR_ITERATOR_COMPLETED_TOO_SOON = "Writer iterator completed too soon";
const CONTENT_TYPE_TEXT_PLAIN = "text/plain";
const HTTP_HEADER_CONTENT_TYPE = "Content-Type";
const DEFAULT_CHUNK_SIZE = 64 * 1024;
const PROPERTY_NAME_WRITABLE = "writable";
class Stream {
  constructor() {
    this.size = 0;
  }
  init() {
    this.initialized = true;
  }
}
class Reader extends Stream {
  get readable() {
    const reader = this;
    const {
      chunkSize = DEFAULT_CHUNK_SIZE
    } = reader;
    const readable = new ReadableStream({
      start() {
        this.chunkOffset = 0;
      },
      async pull(controller) {
        const {
          offset = 0,
          size,
          diskNumberStart
        } = readable;
        const {
          chunkOffset
        } = this;
        controller.enqueue(await readUint8Array(reader, offset + chunkOffset, Math.min(chunkSize, size - chunkOffset), diskNumberStart));
        if (chunkOffset + chunkSize > size) {
          controller.close();
        } else {
          this.chunkOffset += chunkSize;
        }
      }
    });
    return readable;
  }
}
class BlobReader extends Reader {
  constructor(blob) {
    super();
    Object.assign(this, {
      blob,
      size: blob.size
    });
  }
  async readUint8Array(offset, length) {
    const reader = this;
    const offsetEnd = offset + length;
    const blob = offset || offsetEnd < reader.size ? reader.blob.slice(offset, offsetEnd) : reader.blob;
    let arrayBuffer = await blob.arrayBuffer();
    if (arrayBuffer.byteLength > length) {
      arrayBuffer = arrayBuffer.slice(offset, offsetEnd);
    }
    return new Uint8Array(arrayBuffer);
  }
}
class BlobWriter extends Stream {
  constructor(contentType) {
    super();
    const writer = this;
    const transformStream = new TransformStream();
    const headers = [];
    if (contentType) {
      headers.push([HTTP_HEADER_CONTENT_TYPE, contentType]);
    }
    Object.defineProperty(writer, PROPERTY_NAME_WRITABLE, {
      get() {
        return transformStream.writable;
      }
    });
    writer.blob = new Response(transformStream.readable, {
      headers
    }).blob();
  }
  getData() {
    return this.blob;
  }
}
class TextReader extends BlobReader {
  constructor(text) {
    super(new Blob([text], {
      type: CONTENT_TYPE_TEXT_PLAIN
    }));
  }
}
class Uint8ArrayReader extends Reader {
  constructor(array) {
    super();
    Object.assign(this, {
      array,
      size: array.length
    });
  }
  readUint8Array(index, length) {
    return this.array.slice(index, index + length);
  }
}
class SplitDataReader extends Reader {
  constructor(readers) {
    super();
    this.readers = readers;
  }
  async init() {
    const reader = this;
    const {
      readers
    } = reader;
    reader.lastDiskNumber = 0;
    reader.lastDiskOffset = 0;
    await Promise.all(readers.map(async (diskReader, indexDiskReader) => {
      await diskReader.init();
      if (indexDiskReader != readers.length - 1) {
        reader.lastDiskOffset += diskReader.size;
      }
      reader.size += diskReader.size;
    }));
    super.init();
  }
  async readUint8Array(offset, length, diskNumber = 0) {
    const reader = this;
    const {
      readers
    } = this;
    let result;
    let currentDiskNumber = diskNumber;
    if (currentDiskNumber == -1) {
      currentDiskNumber = readers.length - 1;
    }
    let currentReaderOffset = offset;
    while (currentReaderOffset >= readers[currentDiskNumber].size) {
      currentReaderOffset -= readers[currentDiskNumber].size;
      currentDiskNumber++;
    }
    const currentReader = readers[currentDiskNumber];
    const currentReaderSize = currentReader.size;
    if (currentReaderOffset + length <= currentReaderSize) {
      result = await readUint8Array(currentReader, currentReaderOffset, length);
    } else {
      const chunkLength = currentReaderSize - currentReaderOffset;
      result = new Uint8Array(length);
      result.set(await readUint8Array(currentReader, currentReaderOffset, chunkLength));
      result.set(await reader.readUint8Array(offset + chunkLength, length - chunkLength, diskNumber), chunkLength);
    }
    reader.lastDiskNumber = Math.max(currentDiskNumber, reader.lastDiskNumber);
    return result;
  }
}
class SplitDataWriter extends Stream {
  constructor(writerGenerator, maxSize = 4294967295) {
    super();
    const writer = this;
    Object.assign(writer, {
      diskNumber: 0,
      diskOffset: 0,
      size: 0,
      maxSize,
      availableSize: maxSize
    });
    let diskSourceWriter, diskWritable, diskWriter;
    const writable = new WritableStream({
      async write(chunk) {
        const {
          availableSize
        } = writer;
        if (!diskWriter) {
          const {
            value,
            done
          } = await writerGenerator.next();
          if (done && !value) {
            throw new Error(ERR_ITERATOR_COMPLETED_TOO_SOON);
          } else {
            diskSourceWriter = value;
            diskSourceWriter.size = 0;
            if (diskSourceWriter.maxSize) {
              writer.maxSize = diskSourceWriter.maxSize;
            }
            writer.availableSize = writer.maxSize;
            await initStream(diskSourceWriter);
            diskWritable = value.writable;
            diskWriter = diskWritable.getWriter();
          }
          await this.write(chunk);
        } else if (chunk.length >= availableSize) {
          await writeChunk(chunk.slice(0, availableSize));
          await closeDisk();
          writer.diskOffset += diskSourceWriter.size;
          writer.diskNumber++;
          diskWriter = null;
          await this.write(chunk.slice(availableSize));
        } else {
          await writeChunk(chunk);
        }
      },
      async close() {
        await diskWriter.ready;
        await closeDisk();
      }
    });
    Object.defineProperty(writer, PROPERTY_NAME_WRITABLE, {
      get() {
        return writable;
      }
    });
    async function writeChunk(chunk) {
      const chunkLength = chunk.length;
      if (chunkLength) {
        await diskWriter.ready;
        await diskWriter.write(chunk);
        diskSourceWriter.size += chunkLength;
        writer.size += chunkLength;
        writer.availableSize -= chunkLength;
      }
    }
    async function closeDisk() {
      diskWritable.size = diskSourceWriter.size;
      await diskWriter.close();
    }
  }
}
async function initStream(stream, initSize) {
  if (stream.init && !stream.initialized) {
    await stream.init(initSize);
  } else {
    return Promise.resolve();
  }
}
function initReader(reader) {
  if (Array.isArray(reader)) {
    reader = new SplitDataReader(reader);
  }
  if (reader instanceof ReadableStream) {
    reader = {
      readable: reader
    };
  }
  return reader;
}
function initWriter(writer) {
  if (writer.writable === UNDEFINED_VALUE && typeof writer.next == FUNCTION_TYPE) {
    writer = new SplitDataWriter(writer);
  }
  if (writer instanceof WritableStream) {
    writer = {
      writable: writer
    };
  }
  const {
    writable
  } = writer;
  if (writable.size === UNDEFINED_VALUE) {
    writable.size = 0;
  }
  if (!(writer instanceof SplitDataWriter)) {
    Object.assign(writer, {
      diskNumber: 0,
      diskOffset: 0,
      availableSize: Infinity,
      maxSize: Infinity
    });
  }
  return writer;
}
function readUint8Array(reader, offset, size, diskNumber) {
  return reader.readUint8Array(offset, size, diskNumber);
}

/*
 Copyright (c) 2022 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright 
 notice, this list of conditions and the following disclaimer in 
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */

/* global TextDecoder */

const CP437 = "\0☺☻♥♦♣♠•◘○◙♂♀♪♫☼►◄↕‼¶§▬↨↑↓→←∟↔▲▼ !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~⌂ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜ¢£¥₧ƒáíóúñÑªº¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ".split("");
const VALID_CP437 = CP437.length == 256;
function decodeCP437(stringValue) {
  if (VALID_CP437) {
    let result = "";
    for (let indexCharacter = 0; indexCharacter < stringValue.length; indexCharacter++) {
      result += CP437[stringValue[indexCharacter]];
    }
    return result;
  } else {
    return new TextDecoder().decode(stringValue);
  }
}

/*
 Copyright (c) 2022 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright 
 notice, this list of conditions and the following disclaimer in 
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
function decodeText(value, encoding) {
  if (encoding && encoding.trim().toLowerCase() == "cp437") {
    return decodeCP437(value);
  } else {
    return new TextDecoder(encoding).decode(value);
  }
}

/*
 Copyright (c) 2022 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright 
 notice, this list of conditions and the following disclaimer in 
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */

const PROPERTY_NAME_FILENAME = "filename";
const PROPERTY_NAME_RAW_FILENAME = "rawFilename";
const PROPERTY_NAME_COMMENT = "comment";
const PROPERTY_NAME_RAW_COMMENT = "rawComment";
const PROPERTY_NAME_UNCOMPPRESSED_SIZE = "uncompressedSize";
const PROPERTY_NAME_COMPPRESSED_SIZE = "compressedSize";
const PROPERTY_NAME_OFFSET = "offset";
const PROPERTY_NAME_DISK_NUMBER_START = "diskNumberStart";
const PROPERTY_NAME_LAST_MODIFICATION_DATE = "lastModDate";
const PROPERTY_NAME_RAW_LAST_MODIFICATION_DATE = "rawLastModDate";
const PROPERTY_NAME_LAST_ACCESS_DATE = "lastAccessDate";
const PROPERTY_NAME_RAW_LAST_ACCESS_DATE = "rawLastAccessDate";
const PROPERTY_NAME_CREATION_DATE = "creationDate";
const PROPERTY_NAME_RAW_CREATION_DATE = "rawCreationDate";
const PROPERTY_NAME_INTERNAL_FILE_ATTRIBUTE = "internalFileAttribute";
const PROPERTY_NAME_EXTERNAL_FILE_ATTRIBUTE = "externalFileAttribute";
const PROPERTY_NAME_MS_DOS_COMPATIBLE = "msDosCompatible";
const PROPERTY_NAME_ZIP64 = "zip64";
const PROPERTY_NAMES = [PROPERTY_NAME_FILENAME, PROPERTY_NAME_RAW_FILENAME, PROPERTY_NAME_COMPPRESSED_SIZE, PROPERTY_NAME_UNCOMPPRESSED_SIZE, PROPERTY_NAME_LAST_MODIFICATION_DATE, PROPERTY_NAME_RAW_LAST_MODIFICATION_DATE, PROPERTY_NAME_COMMENT, PROPERTY_NAME_RAW_COMMENT, PROPERTY_NAME_LAST_ACCESS_DATE, PROPERTY_NAME_CREATION_DATE, PROPERTY_NAME_OFFSET, PROPERTY_NAME_DISK_NUMBER_START, PROPERTY_NAME_DISK_NUMBER_START, PROPERTY_NAME_INTERNAL_FILE_ATTRIBUTE, PROPERTY_NAME_EXTERNAL_FILE_ATTRIBUTE, PROPERTY_NAME_MS_DOS_COMPATIBLE, PROPERTY_NAME_ZIP64, "directory", "bitFlag", "encrypted", "signature", "filenameUTF8", "commentUTF8", "compressionMethod", "version", "versionMadeBy", "extraField", "rawExtraField", "extraFieldZip64", "extraFieldUnicodePath", "extraFieldUnicodeComment", "extraFieldAES", "extraFieldNTFS", "extraFieldExtendedTimestamp"];
class Entry {
  constructor(data) {
    PROPERTY_NAMES.forEach(name => this[name] = data[name]);
  }
}

/*
 Copyright (c) 2022 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright
 notice, this list of conditions and the following disclaimer in
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
const ERR_BAD_FORMAT = "File format is not recognized";
const ERR_EOCDR_NOT_FOUND = "End of central directory not found";
const ERR_EOCDR_LOCATOR_ZIP64_NOT_FOUND = "End of Zip64 central directory locator not found";
const ERR_CENTRAL_DIRECTORY_NOT_FOUND = "Central directory header not found";
const ERR_LOCAL_FILE_HEADER_NOT_FOUND = "Local file header not found";
const ERR_EXTRAFIELD_ZIP64_NOT_FOUND = "Zip64 extra field not found";
const ERR_ENCRYPTED = "File contains encrypted entry";
const ERR_UNSUPPORTED_ENCRYPTION = "Encryption method not supported";
const ERR_UNSUPPORTED_COMPRESSION = "Compression method not supported";
const ERR_SPLIT_ZIP_FILE = "Split zip file";
const CHARSET_UTF8 = "utf-8";
const CHARSET_CP437 = "cp437";
const ZIP64_PROPERTIES = [[PROPERTY_NAME_UNCOMPPRESSED_SIZE, MAX_32_BITS], [PROPERTY_NAME_COMPPRESSED_SIZE, MAX_32_BITS], [PROPERTY_NAME_OFFSET, MAX_32_BITS], [PROPERTY_NAME_DISK_NUMBER_START, MAX_16_BITS]];
const ZIP64_EXTRACTION = {
  [MAX_16_BITS]: {
    getValue: getUint32,
    bytes: 4
  },
  [MAX_32_BITS]: {
    getValue: getBigUint64,
    bytes: 8
  }
};
class ZipReader {
  constructor(reader, options = {}) {
    Object.assign(this, {
      reader: initReader(reader),
      options,
      config: getConfiguration()
    });
  }
  async *getEntriesGenerator(options = {}) {
    const zipReader = this;
    let {
      reader
    } = zipReader;
    const {
      config
    } = zipReader;
    await initStream(reader);
    if (reader.size === UNDEFINED_VALUE || !reader.readUint8Array) {
      reader = new BlobReader(await new Response(reader.readable).blob());
      await initStream(reader);
    }
    if (reader.size < END_OF_CENTRAL_DIR_LENGTH) {
      throw new Error(ERR_BAD_FORMAT);
    }
    reader.chunkSize = getChunkSize(config);
    const endOfDirectoryInfo = await seekSignature(reader, END_OF_CENTRAL_DIR_SIGNATURE, reader.size, END_OF_CENTRAL_DIR_LENGTH, MAX_16_BITS * 16);
    if (!endOfDirectoryInfo) {
      const signatureArray = await readUint8Array(reader, 0, 4);
      const signatureView = getDataView$1(signatureArray);
      if (getUint32(signatureView) == SPLIT_ZIP_FILE_SIGNATURE) {
        throw new Error(ERR_SPLIT_ZIP_FILE);
      } else {
        throw new Error(ERR_EOCDR_NOT_FOUND);
      }
    }
    const endOfDirectoryView = getDataView$1(endOfDirectoryInfo);
    let directoryDataLength = getUint32(endOfDirectoryView, 12);
    let directoryDataOffset = getUint32(endOfDirectoryView, 16);
    const commentOffset = endOfDirectoryInfo.offset;
    const commentLength = getUint16(endOfDirectoryView, 20);
    const appendedDataOffset = commentOffset + END_OF_CENTRAL_DIR_LENGTH + commentLength;
    let lastDiskNumber = getUint16(endOfDirectoryView, 4);
    const expectedLastDiskNumber = reader.lastDiskNumber || 0;
    let diskNumber = getUint16(endOfDirectoryView, 6);
    let filesLength = getUint16(endOfDirectoryView, 8);
    let prependedDataLength = 0;
    let startOffset = 0;
    if (directoryDataOffset == MAX_32_BITS || directoryDataLength == MAX_32_BITS || filesLength == MAX_16_BITS || diskNumber == MAX_16_BITS) {
      const endOfDirectoryLocatorArray = await readUint8Array(reader, endOfDirectoryInfo.offset - ZIP64_END_OF_CENTRAL_DIR_LOCATOR_LENGTH, ZIP64_END_OF_CENTRAL_DIR_LOCATOR_LENGTH);
      const endOfDirectoryLocatorView = getDataView$1(endOfDirectoryLocatorArray);
      if (getUint32(endOfDirectoryLocatorView, 0) == ZIP64_END_OF_CENTRAL_DIR_LOCATOR_SIGNATURE) {
        directoryDataOffset = getBigUint64(endOfDirectoryLocatorView, 8);
        let endOfDirectoryArray = await readUint8Array(reader, directoryDataOffset, ZIP64_END_OF_CENTRAL_DIR_LENGTH, -1);
        let endOfDirectoryView = getDataView$1(endOfDirectoryArray);
        const expectedDirectoryDataOffset = endOfDirectoryInfo.offset - ZIP64_END_OF_CENTRAL_DIR_LOCATOR_LENGTH - ZIP64_END_OF_CENTRAL_DIR_LENGTH;
        if (getUint32(endOfDirectoryView, 0) != ZIP64_END_OF_CENTRAL_DIR_SIGNATURE && directoryDataOffset != expectedDirectoryDataOffset) {
          const originalDirectoryDataOffset = directoryDataOffset;
          directoryDataOffset = expectedDirectoryDataOffset;
          prependedDataLength = directoryDataOffset - originalDirectoryDataOffset;
          endOfDirectoryArray = await readUint8Array(reader, directoryDataOffset, ZIP64_END_OF_CENTRAL_DIR_LENGTH, -1);
          endOfDirectoryView = getDataView$1(endOfDirectoryArray);
        }
        if (getUint32(endOfDirectoryView, 0) != ZIP64_END_OF_CENTRAL_DIR_SIGNATURE) {
          throw new Error(ERR_EOCDR_LOCATOR_ZIP64_NOT_FOUND);
        }
        if (lastDiskNumber == MAX_16_BITS) {
          lastDiskNumber = getUint32(endOfDirectoryView, 16);
        }
        if (diskNumber == MAX_16_BITS) {
          diskNumber = getUint32(endOfDirectoryView, 20);
        }
        if (filesLength == MAX_16_BITS) {
          filesLength = getBigUint64(endOfDirectoryView, 32);
        }
        if (directoryDataLength == MAX_32_BITS) {
          directoryDataLength = getBigUint64(endOfDirectoryView, 40);
        }
        directoryDataOffset -= directoryDataLength;
      }
    }
    if (directoryDataOffset >= reader.size) {
      prependedDataLength = reader.size - directoryDataOffset - directoryDataLength - END_OF_CENTRAL_DIR_LENGTH;
      directoryDataOffset = reader.size - directoryDataLength - END_OF_CENTRAL_DIR_LENGTH;
    }
    if (expectedLastDiskNumber != lastDiskNumber) {
      throw new Error(ERR_SPLIT_ZIP_FILE);
    }
    if (directoryDataOffset < 0) {
      throw new Error(ERR_BAD_FORMAT);
    }
    let offset = 0;
    let directoryArray = await readUint8Array(reader, directoryDataOffset, directoryDataLength, diskNumber);
    let directoryView = getDataView$1(directoryArray);
    if (directoryDataLength) {
      const expectedDirectoryDataOffset = endOfDirectoryInfo.offset - directoryDataLength;
      if (getUint32(directoryView, offset) != CENTRAL_FILE_HEADER_SIGNATURE && directoryDataOffset != expectedDirectoryDataOffset) {
        const originalDirectoryDataOffset = directoryDataOffset;
        directoryDataOffset = expectedDirectoryDataOffset;
        prependedDataLength += directoryDataOffset - originalDirectoryDataOffset;
        directoryArray = await readUint8Array(reader, directoryDataOffset, directoryDataLength, diskNumber);
        directoryView = getDataView$1(directoryArray);
      }
    }
    const expectedDirectoryDataLength = endOfDirectoryInfo.offset - directoryDataOffset - (reader.lastDiskOffset || 0);
    if (directoryDataLength != expectedDirectoryDataLength && expectedDirectoryDataLength >= 0) {
      directoryDataLength = expectedDirectoryDataLength;
      directoryArray = await readUint8Array(reader, directoryDataOffset, directoryDataLength, diskNumber);
      directoryView = getDataView$1(directoryArray);
    }
    if (directoryDataOffset < 0 || directoryDataOffset >= reader.size) {
      throw new Error(ERR_BAD_FORMAT);
    }
    const filenameEncoding = getOptionValue$1(zipReader, options, "filenameEncoding");
    const commentEncoding = getOptionValue$1(zipReader, options, "commentEncoding");
    for (let indexFile = 0; indexFile < filesLength; indexFile++) {
      const fileEntry = new ZipEntry(reader, config, zipReader.options);
      if (getUint32(directoryView, offset) != CENTRAL_FILE_HEADER_SIGNATURE) {
        throw new Error(ERR_CENTRAL_DIRECTORY_NOT_FOUND);
      }
      readCommonHeader(fileEntry, directoryView, offset + 6);
      const languageEncodingFlag = Boolean(fileEntry.bitFlag.languageEncodingFlag);
      const filenameOffset = offset + 46;
      const extraFieldOffset = filenameOffset + fileEntry.filenameLength;
      const commentOffset = extraFieldOffset + fileEntry.extraFieldLength;
      const versionMadeBy = getUint16(directoryView, offset + 4);
      const msDosCompatible = (versionMadeBy & 0) == 0;
      const rawFilename = directoryArray.subarray(filenameOffset, extraFieldOffset);
      const commentLength = getUint16(directoryView, offset + 32);
      const endOffset = commentOffset + commentLength;
      const rawComment = directoryArray.subarray(commentOffset, endOffset);
      const filenameUTF8 = languageEncodingFlag;
      const commentUTF8 = languageEncodingFlag;
      const directory = msDosCompatible && (getUint8(directoryView, offset + 38) & FILE_ATTR_MSDOS_DIR_MASK) == FILE_ATTR_MSDOS_DIR_MASK;
      const offsetFileEntry = getUint32(directoryView, offset + 42) + prependedDataLength;
      Object.assign(fileEntry, {
        versionMadeBy,
        msDosCompatible,
        compressedSize: 0,
        uncompressedSize: 0,
        commentLength,
        directory,
        offset: offsetFileEntry,
        diskNumberStart: getUint16(directoryView, offset + 34),
        internalFileAttribute: getUint16(directoryView, offset + 36),
        externalFileAttribute: getUint32(directoryView, offset + 38),
        rawFilename,
        filenameUTF8,
        commentUTF8,
        rawExtraField: directoryArray.subarray(extraFieldOffset, commentOffset)
      });
      const decode = getOptionValue$1(zipReader, options, "decodeText") || decodeText;
      const rawFilenameEncoding = filenameUTF8 ? CHARSET_UTF8 : filenameEncoding || CHARSET_CP437;
      const rawCommentEncoding = commentUTF8 ? CHARSET_UTF8 : commentEncoding || CHARSET_CP437;
      let filename = decode(rawFilename, rawFilenameEncoding);
      if (filename === UNDEFINED_VALUE) {
        filename = decodeText(rawFilename, rawFilenameEncoding);
      }
      let comment = decode(rawComment, rawCommentEncoding);
      if (comment === UNDEFINED_VALUE) {
        comment = decodeText(rawComment, rawCommentEncoding);
      }
      Object.assign(fileEntry, {
        rawComment,
        filename,
        comment,
        directory: directory || filename.endsWith(DIRECTORY_SIGNATURE)
      });
      startOffset = Math.max(offsetFileEntry, startOffset);
      await readCommonFooter(fileEntry, fileEntry, directoryView, offset + 6);
      const entry = new Entry(fileEntry);
      entry.getData = (writer, options) => fileEntry.getData(writer, entry, options);
      offset = endOffset;
      const {
        onprogress
      } = options;
      if (onprogress) {
        try {
          await onprogress(indexFile + 1, filesLength, new Entry(fileEntry));
        } catch (_error) {
          // ignored
        }
      }
      yield entry;
    }
    const extractPrependedData = getOptionValue$1(zipReader, options, "extractPrependedData");
    const extractAppendedData = getOptionValue$1(zipReader, options, "extractAppendedData");
    if (extractPrependedData) {
      zipReader.prependedData = startOffset > 0 ? await readUint8Array(reader, 0, startOffset) : new Uint8Array();
    }
    zipReader.comment = commentLength ? await readUint8Array(reader, commentOffset + END_OF_CENTRAL_DIR_LENGTH, commentLength) : new Uint8Array();
    if (extractAppendedData) {
      zipReader.appendedData = appendedDataOffset < reader.size ? await readUint8Array(reader, appendedDataOffset, reader.size - appendedDataOffset) : new Uint8Array();
    }
    return true;
  }
  async getEntries(options = {}) {
    const entries = [];
    for await (const entry of this.getEntriesGenerator(options)) {
      entries.push(entry);
    }
    return entries;
  }
  async close() {}
}
class ZipEntry {
  constructor(reader, config, options) {
    Object.assign(this, {
      reader,
      config,
      options
    });
  }
  async getData(writer, fileEntry, options = {}) {
    const zipEntry = this;
    const {
      reader,
      offset,
      diskNumberStart,
      extraFieldAES,
      compressionMethod,
      config,
      bitFlag,
      signature,
      rawLastModDate,
      uncompressedSize,
      compressedSize
    } = zipEntry;
    const localDirectory = fileEntry.localDirectory = {};
    const dataArray = await readUint8Array(reader, offset, 30, diskNumberStart);
    const dataView = getDataView$1(dataArray);
    let password = getOptionValue$1(zipEntry, options, "password");
    let rawPassword = getOptionValue$1(zipEntry, options, "rawPassword");
    password = password && password.length && password;
    rawPassword = rawPassword && rawPassword.length && rawPassword;
    if (extraFieldAES) {
      if (extraFieldAES.originalCompressionMethod != COMPRESSION_METHOD_AES) {
        throw new Error(ERR_UNSUPPORTED_COMPRESSION);
      }
    }
    if (compressionMethod != COMPRESSION_METHOD_STORE && compressionMethod != COMPRESSION_METHOD_DEFLATE) {
      throw new Error(ERR_UNSUPPORTED_COMPRESSION);
    }
    if (getUint32(dataView, 0) != LOCAL_FILE_HEADER_SIGNATURE) {
      throw new Error(ERR_LOCAL_FILE_HEADER_NOT_FOUND);
    }
    readCommonHeader(localDirectory, dataView, 4);
    localDirectory.rawExtraField = localDirectory.extraFieldLength ? await readUint8Array(reader, offset + 30 + localDirectory.filenameLength, localDirectory.extraFieldLength, diskNumberStart) : new Uint8Array();
    await readCommonFooter(zipEntry, localDirectory, dataView, 4, true);
    Object.assign(fileEntry, {
      lastAccessDate: localDirectory.lastAccessDate,
      creationDate: localDirectory.creationDate
    });
    const encrypted = zipEntry.encrypted && localDirectory.encrypted;
    const zipCrypto = encrypted && !extraFieldAES;
    if (encrypted) {
      if (!zipCrypto && extraFieldAES.strength === UNDEFINED_VALUE) {
        throw new Error(ERR_UNSUPPORTED_ENCRYPTION);
      } else if (!password && !rawPassword) {
        throw new Error(ERR_ENCRYPTED);
      }
    }
    const dataOffset = offset + 30 + localDirectory.filenameLength + localDirectory.extraFieldLength;
    const size = compressedSize;
    const readable = reader.readable;
    Object.assign(readable, {
      diskNumberStart,
      offset: dataOffset,
      size
    });
    const signal = getOptionValue$1(zipEntry, options, "signal");
    const checkPasswordOnly = getOptionValue$1(zipEntry, options, "checkPasswordOnly");
    if (checkPasswordOnly) {
      writer = new WritableStream();
    }
    writer = initWriter(writer);
    await initStream(writer, uncompressedSize);
    const {
      writable
    } = writer;
    const {
      onstart,
      onprogress,
      onend
    } = options;
    const workerOptions = {
      options: {
        codecType: CODEC_INFLATE,
        password,
        rawPassword,
        zipCrypto,
        encryptionStrength: extraFieldAES && extraFieldAES.strength,
        signed: getOptionValue$1(zipEntry, options, "checkSignature"),
        passwordVerification: zipCrypto && (bitFlag.dataDescriptor ? rawLastModDate >>> 8 & 0xFF : signature >>> 24 & 0xFF),
        signature,
        compressed: compressionMethod != 0,
        encrypted,
        useWebWorkers: getOptionValue$1(zipEntry, options, "useWebWorkers"),
        useCompressionStream: getOptionValue$1(zipEntry, options, "useCompressionStream"),
        transferStreams: getOptionValue$1(zipEntry, options, "transferStreams"),
        checkPasswordOnly
      },
      config,
      streamOptions: {
        signal,
        size,
        onstart,
        onprogress,
        onend
      }
    };
    let outputSize = 0;
    try {
      ({
        outputSize
      } = await runWorker({
        readable,
        writable
      }, workerOptions));
    } catch (error) {
      if (!checkPasswordOnly || error.message != ERR_ABORT_CHECK_PASSWORD) {
        throw error;
      }
    } finally {
      const preventClose = getOptionValue$1(zipEntry, options, "preventClose");
      writable.size += outputSize;
      if (!preventClose && !writable.locked) {
        await writable.getWriter().close();
      }
    }
    return checkPasswordOnly ? UNDEFINED_VALUE : writer.getData ? writer.getData() : writable;
  }
}
function readCommonHeader(directory, dataView, offset) {
  const rawBitFlag = directory.rawBitFlag = getUint16(dataView, offset + 2);
  const encrypted = (rawBitFlag & BITFLAG_ENCRYPTED) == BITFLAG_ENCRYPTED;
  const rawLastModDate = getUint32(dataView, offset + 6);
  Object.assign(directory, {
    encrypted,
    version: getUint16(dataView, offset),
    bitFlag: {
      level: (rawBitFlag & BITFLAG_LEVEL) >> 1,
      dataDescriptor: (rawBitFlag & BITFLAG_DATA_DESCRIPTOR) == BITFLAG_DATA_DESCRIPTOR,
      languageEncodingFlag: (rawBitFlag & BITFLAG_LANG_ENCODING_FLAG) == BITFLAG_LANG_ENCODING_FLAG
    },
    rawLastModDate,
    lastModDate: getDate(rawLastModDate),
    filenameLength: getUint16(dataView, offset + 22),
    extraFieldLength: getUint16(dataView, offset + 24)
  });
}
async function readCommonFooter(fileEntry, directory, dataView, offset, localDirectory) {
  const {
    rawExtraField
  } = directory;
  const extraField = directory.extraField = new Map();
  const rawExtraFieldView = getDataView$1(new Uint8Array(rawExtraField));
  let offsetExtraField = 0;
  try {
    while (offsetExtraField < rawExtraField.length) {
      const type = getUint16(rawExtraFieldView, offsetExtraField);
      const size = getUint16(rawExtraFieldView, offsetExtraField + 2);
      extraField.set(type, {
        type,
        data: rawExtraField.slice(offsetExtraField + 4, offsetExtraField + 4 + size)
      });
      offsetExtraField += 4 + size;
    }
  } catch (_error) {
    // ignored
  }
  const compressionMethod = getUint16(dataView, offset + 4);
  Object.assign(directory, {
    signature: getUint32(dataView, offset + 10),
    uncompressedSize: getUint32(dataView, offset + 18),
    compressedSize: getUint32(dataView, offset + 14)
  });
  const extraFieldZip64 = extraField.get(EXTRAFIELD_TYPE_ZIP64);
  if (extraFieldZip64) {
    readExtraFieldZip64(extraFieldZip64, directory);
    directory.extraFieldZip64 = extraFieldZip64;
  }
  const extraFieldUnicodePath = extraField.get(EXTRAFIELD_TYPE_UNICODE_PATH);
  if (extraFieldUnicodePath) {
    await readExtraFieldUnicode(extraFieldUnicodePath, PROPERTY_NAME_FILENAME, PROPERTY_NAME_RAW_FILENAME, directory, fileEntry);
    directory.extraFieldUnicodePath = extraFieldUnicodePath;
  }
  const extraFieldUnicodeComment = extraField.get(EXTRAFIELD_TYPE_UNICODE_COMMENT);
  if (extraFieldUnicodeComment) {
    await readExtraFieldUnicode(extraFieldUnicodeComment, PROPERTY_NAME_COMMENT, PROPERTY_NAME_RAW_COMMENT, directory, fileEntry);
    directory.extraFieldUnicodeComment = extraFieldUnicodeComment;
  }
  const extraFieldAES = extraField.get(EXTRAFIELD_TYPE_AES);
  if (extraFieldAES) {
    readExtraFieldAES(extraFieldAES, directory, compressionMethod);
    directory.extraFieldAES = extraFieldAES;
  } else {
    directory.compressionMethod = compressionMethod;
  }
  const extraFieldNTFS = extraField.get(EXTRAFIELD_TYPE_NTFS);
  if (extraFieldNTFS) {
    readExtraFieldNTFS(extraFieldNTFS, directory);
    directory.extraFieldNTFS = extraFieldNTFS;
  }
  const extraFieldExtendedTimestamp = extraField.get(EXTRAFIELD_TYPE_EXTENDED_TIMESTAMP);
  if (extraFieldExtendedTimestamp) {
    readExtraFieldExtendedTimestamp(extraFieldExtendedTimestamp, directory, localDirectory);
    directory.extraFieldExtendedTimestamp = extraFieldExtendedTimestamp;
  }
  const extraFieldUSDZ = extraField.get(EXTRAFIELD_TYPE_USDZ);
  if (extraFieldUSDZ) {
    directory.extraFieldUSDZ = extraFieldUSDZ;
  }
}
function readExtraFieldZip64(extraFieldZip64, directory) {
  directory.zip64 = true;
  const extraFieldView = getDataView$1(extraFieldZip64.data);
  const missingProperties = ZIP64_PROPERTIES.filter(([propertyName, max]) => directory[propertyName] == max);
  for (let indexMissingProperty = 0, offset = 0; indexMissingProperty < missingProperties.length; indexMissingProperty++) {
    const [propertyName, max] = missingProperties[indexMissingProperty];
    if (directory[propertyName] == max) {
      const extraction = ZIP64_EXTRACTION[max];
      directory[propertyName] = extraFieldZip64[propertyName] = extraction.getValue(extraFieldView, offset);
      offset += extraction.bytes;
    } else if (extraFieldZip64[propertyName]) {
      throw new Error(ERR_EXTRAFIELD_ZIP64_NOT_FOUND);
    }
  }
}
async function readExtraFieldUnicode(extraFieldUnicode, propertyName, rawPropertyName, directory, fileEntry) {
  const extraFieldView = getDataView$1(extraFieldUnicode.data);
  const crc32 = new Crc32();
  crc32.append(fileEntry[rawPropertyName]);
  const dataViewSignature = getDataView$1(new Uint8Array(4));
  dataViewSignature.setUint32(0, crc32.get(), true);
  const signature = getUint32(extraFieldView, 1);
  Object.assign(extraFieldUnicode, {
    version: getUint8(extraFieldView, 0),
    [propertyName]: decodeText(extraFieldUnicode.data.subarray(5)),
    valid: !fileEntry.bitFlag.languageEncodingFlag && signature == getUint32(dataViewSignature, 0)
  });
  if (extraFieldUnicode.valid) {
    directory[propertyName] = extraFieldUnicode[propertyName];
    directory[propertyName + "UTF8"] = true;
  }
}
function readExtraFieldAES(extraFieldAES, directory, compressionMethod) {
  const extraFieldView = getDataView$1(extraFieldAES.data);
  const strength = getUint8(extraFieldView, 4);
  Object.assign(extraFieldAES, {
    vendorVersion: getUint8(extraFieldView, 0),
    vendorId: getUint8(extraFieldView, 2),
    strength,
    originalCompressionMethod: compressionMethod,
    compressionMethod: getUint16(extraFieldView, 5)
  });
  directory.compressionMethod = extraFieldAES.compressionMethod;
}
function readExtraFieldNTFS(extraFieldNTFS, directory) {
  const extraFieldView = getDataView$1(extraFieldNTFS.data);
  let offsetExtraField = 4;
  let tag1Data;
  try {
    while (offsetExtraField < extraFieldNTFS.data.length && !tag1Data) {
      const tagValue = getUint16(extraFieldView, offsetExtraField);
      const attributeSize = getUint16(extraFieldView, offsetExtraField + 2);
      if (tagValue == EXTRAFIELD_TYPE_NTFS_TAG1) {
        tag1Data = extraFieldNTFS.data.slice(offsetExtraField + 4, offsetExtraField + 4 + attributeSize);
      }
      offsetExtraField += 4 + attributeSize;
    }
  } catch (_error) {
    // ignored
  }
  try {
    if (tag1Data && tag1Data.length == 24) {
      const tag1View = getDataView$1(tag1Data);
      const rawLastModDate = tag1View.getBigUint64(0, true);
      const rawLastAccessDate = tag1View.getBigUint64(8, true);
      const rawCreationDate = tag1View.getBigUint64(16, true);
      Object.assign(extraFieldNTFS, {
        rawLastModDate,
        rawLastAccessDate,
        rawCreationDate
      });
      const lastModDate = getDateNTFS(rawLastModDate);
      const lastAccessDate = getDateNTFS(rawLastAccessDate);
      const creationDate = getDateNTFS(rawCreationDate);
      const extraFieldData = {
        lastModDate,
        lastAccessDate,
        creationDate
      };
      Object.assign(extraFieldNTFS, extraFieldData);
      Object.assign(directory, extraFieldData);
    }
  } catch (_error) {
    // ignored
  }
}
function readExtraFieldExtendedTimestamp(extraFieldExtendedTimestamp, directory, localDirectory) {
  const extraFieldView = getDataView$1(extraFieldExtendedTimestamp.data);
  const flags = getUint8(extraFieldView, 0);
  const timeProperties = [];
  const timeRawProperties = [];
  if (localDirectory) {
    if ((flags & 0x1) == 0x1) {
      timeProperties.push(PROPERTY_NAME_LAST_MODIFICATION_DATE);
      timeRawProperties.push(PROPERTY_NAME_RAW_LAST_MODIFICATION_DATE);
    }
    if ((flags & 0x2) == 0x2) {
      timeProperties.push(PROPERTY_NAME_LAST_ACCESS_DATE);
      timeRawProperties.push(PROPERTY_NAME_RAW_LAST_ACCESS_DATE);
    }
    if ((flags & 0x4) == 0x4) {
      timeProperties.push(PROPERTY_NAME_CREATION_DATE);
      timeRawProperties.push(PROPERTY_NAME_RAW_CREATION_DATE);
    }
  } else if (extraFieldExtendedTimestamp.data.length >= 5) {
    timeProperties.push(PROPERTY_NAME_LAST_MODIFICATION_DATE);
    timeRawProperties.push(PROPERTY_NAME_RAW_LAST_MODIFICATION_DATE);
  }
  let offset = 1;
  timeProperties.forEach((propertyName, indexProperty) => {
    if (extraFieldExtendedTimestamp.data.length >= offset + 4) {
      const time = getUint32(extraFieldView, offset);
      directory[propertyName] = extraFieldExtendedTimestamp[propertyName] = new Date(time * 1000);
      const rawPropertyName = timeRawProperties[indexProperty];
      extraFieldExtendedTimestamp[rawPropertyName] = time;
    }
    offset += 4;
  });
}
async function seekSignature(reader, signature, startOffset, minimumBytes, maximumLength) {
  const signatureArray = new Uint8Array(4);
  const signatureView = getDataView$1(signatureArray);
  setUint32$1(signatureView, 0, signature);
  const maximumBytes = minimumBytes + maximumLength;
  return (await seek(minimumBytes)) || (await seek(Math.min(maximumBytes, startOffset)));
  async function seek(length) {
    const offset = startOffset - length;
    const bytes = await readUint8Array(reader, offset, length);
    for (let indexByte = bytes.length - minimumBytes; indexByte >= 0; indexByte--) {
      if (bytes[indexByte] == signatureArray[0] && bytes[indexByte + 1] == signatureArray[1] && bytes[indexByte + 2] == signatureArray[2] && bytes[indexByte + 3] == signatureArray[3]) {
        return {
          offset: offset + indexByte,
          buffer: bytes.slice(indexByte, indexByte + minimumBytes).buffer
        };
      }
    }
  }
}
function getOptionValue$1(zipReader, options, name) {
  return options[name] === UNDEFINED_VALUE ? zipReader.options[name] : options[name];
}
function getDate(timeRaw) {
  const date = (timeRaw & 0xffff0000) >> 16,
    time = timeRaw & 0x0000ffff;
  try {
    return new Date(1980 + ((date & 0xFE00) >> 9), ((date & 0x01E0) >> 5) - 1, date & 0x001F, (time & 0xF800) >> 11, (time & 0x07E0) >> 5, (time & 0x001F) * 2, 0);
  } catch (_error) {
    // ignored
  }
}
function getDateNTFS(timeRaw) {
  return new Date(Number(timeRaw / BigInt(10000) - BigInt(11644473600000)));
}
function getUint8(view, offset) {
  return view.getUint8(offset);
}
function getUint16(view, offset) {
  return view.getUint16(offset, true);
}
function getUint32(view, offset) {
  return view.getUint32(offset, true);
}
function getBigUint64(view, offset) {
  return Number(view.getBigUint64(offset, true));
}
function setUint32$1(view, offset, value) {
  view.setUint32(offset, value, true);
}
function getDataView$1(array) {
  return new DataView(array.buffer);
}

/*
 Copyright (c) 2022 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright
 notice, this list of conditions and the following disclaimer in
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
const ERR_DUPLICATED_NAME = "File already exists";
const ERR_INVALID_COMMENT = "Zip file comment exceeds 64KB";
const ERR_INVALID_ENTRY_COMMENT = "File entry comment exceeds 64KB";
const ERR_INVALID_ENTRY_NAME = "File entry name exceeds 64KB";
const ERR_INVALID_VERSION = "Version exceeds 65535";
const ERR_INVALID_ENCRYPTION_STRENGTH = "The strength must equal 1, 2, or 3";
const ERR_INVALID_EXTRAFIELD_TYPE = "Extra field type exceeds 65535";
const ERR_INVALID_EXTRAFIELD_DATA = "Extra field data exceeds 64KB";
const ERR_UNSUPPORTED_FORMAT = "Zip64 is not supported (make sure 'keepOrder' is set to 'true')";
const EXTRAFIELD_DATA_AES = new Uint8Array([0x07, 0x00, 0x02, 0x00, 0x41, 0x45, 0x03, 0x00, 0x00]);
let workers = 0;
const pendingEntries = [];
class ZipWriter {
  constructor(writer, options = {}) {
    writer = initWriter(writer);
    const addSplitZipSignature = writer.availableSize !== UNDEFINED_VALUE && writer.availableSize > 0 && writer.availableSize !== Infinity && writer.maxSize !== UNDEFINED_VALUE && writer.maxSize > 0 && writer.maxSize !== Infinity;
    Object.assign(this, {
      writer,
      addSplitZipSignature,
      options,
      config: getConfiguration(),
      files: new Map(),
      filenames: new Set(),
      offset: writer.writable.size,
      pendingEntriesSize: 0,
      pendingAddFileCalls: new Set(),
      bufferedWrites: 0
    });
  }
  async add(name = "", reader, options = {}) {
    const zipWriter = this;
    const {
      pendingAddFileCalls,
      config
    } = zipWriter;
    if (workers < config.maxWorkers) {
      workers++;
    } else {
      await new Promise(resolve => pendingEntries.push(resolve));
    }
    let promiseAddFile;
    try {
      name = name.trim();
      if (zipWriter.filenames.has(name)) {
        throw new Error(ERR_DUPLICATED_NAME);
      }
      zipWriter.filenames.add(name);
      promiseAddFile = addFile(zipWriter, name, reader, options);
      pendingAddFileCalls.add(promiseAddFile);
      return await promiseAddFile;
    } catch (error) {
      zipWriter.filenames.delete(name);
      throw error;
    } finally {
      pendingAddFileCalls.delete(promiseAddFile);
      const pendingEntry = pendingEntries.shift();
      if (pendingEntry) {
        pendingEntry();
      } else {
        workers--;
      }
    }
  }
  async close(comment = new Uint8Array(), options = {}) {
    const zipWriter = this;
    const {
      pendingAddFileCalls,
      writer
    } = this;
    const {
      writable
    } = writer;
    while (pendingAddFileCalls.size) {
      await Promise.allSettled(Array.from(pendingAddFileCalls));
    }
    await closeFile(this, comment, options);
    const preventClose = getOptionValue(zipWriter, options, "preventClose");
    if (!preventClose) {
      await writable.getWriter().close();
    }
    return writer.getData ? writer.getData() : writable;
  }
}
async function addFile(zipWriter, name, reader, options) {
  name = name.trim();
  if (options.directory && !name.endsWith(DIRECTORY_SIGNATURE)) {
    name += DIRECTORY_SIGNATURE;
  } else {
    options.directory = name.endsWith(DIRECTORY_SIGNATURE);
  }
  const encode = getOptionValue(zipWriter, options, "encodeText", encodeText);
  let rawFilename = encode(name);
  if (rawFilename === UNDEFINED_VALUE) {
    rawFilename = encodeText(name);
  }
  if (getLength(rawFilename) > MAX_16_BITS) {
    throw new Error(ERR_INVALID_ENTRY_NAME);
  }
  const comment = options.comment || "";
  let rawComment = encode(comment);
  if (rawComment === UNDEFINED_VALUE) {
    rawComment = encodeText(comment);
  }
  if (getLength(rawComment) > MAX_16_BITS) {
    throw new Error(ERR_INVALID_ENTRY_COMMENT);
  }
  const version = getOptionValue(zipWriter, options, "version", VERSION_DEFLATE);
  if (version > MAX_16_BITS) {
    throw new Error(ERR_INVALID_VERSION);
  }
  const versionMadeBy = getOptionValue(zipWriter, options, "versionMadeBy", 20);
  if (versionMadeBy > MAX_16_BITS) {
    throw new Error(ERR_INVALID_VERSION);
  }
  const lastModDate = getOptionValue(zipWriter, options, PROPERTY_NAME_LAST_MODIFICATION_DATE, new Date());
  const lastAccessDate = getOptionValue(zipWriter, options, PROPERTY_NAME_LAST_ACCESS_DATE);
  const creationDate = getOptionValue(zipWriter, options, PROPERTY_NAME_CREATION_DATE);
  const msDosCompatible = getOptionValue(zipWriter, options, PROPERTY_NAME_MS_DOS_COMPATIBLE, true);
  const internalFileAttribute = getOptionValue(zipWriter, options, PROPERTY_NAME_INTERNAL_FILE_ATTRIBUTE, 0);
  const externalFileAttribute = getOptionValue(zipWriter, options, PROPERTY_NAME_EXTERNAL_FILE_ATTRIBUTE, 0);
  const password = getOptionValue(zipWriter, options, "password");
  const rawPassword = getOptionValue(zipWriter, options, "rawPassword");
  const encryptionStrength = getOptionValue(zipWriter, options, "encryptionStrength", 3);
  const zipCrypto = getOptionValue(zipWriter, options, "zipCrypto");
  const extendedTimestamp = getOptionValue(zipWriter, options, "extendedTimestamp", true);
  const keepOrder = getOptionValue(zipWriter, options, "keepOrder", true);
  const level = getOptionValue(zipWriter, options, "level");
  const useWebWorkers = getOptionValue(zipWriter, options, "useWebWorkers");
  const bufferedWrite = getOptionValue(zipWriter, options, "bufferedWrite");
  const dataDescriptorSignature = getOptionValue(zipWriter, options, "dataDescriptorSignature", false);
  const signal = getOptionValue(zipWriter, options, "signal");
  const useCompressionStream = getOptionValue(zipWriter, options, "useCompressionStream");
  let dataDescriptor = getOptionValue(zipWriter, options, "dataDescriptor", true);
  let zip64 = getOptionValue(zipWriter, options, PROPERTY_NAME_ZIP64);
  if (password !== UNDEFINED_VALUE && encryptionStrength !== UNDEFINED_VALUE && (encryptionStrength < 1 || encryptionStrength > 3)) {
    throw new Error(ERR_INVALID_ENCRYPTION_STRENGTH);
  }
  let rawExtraField = new Uint8Array();
  const {
    extraField
  } = options;
  if (extraField) {
    let extraFieldSize = 0;
    let offset = 0;
    extraField.forEach(data => extraFieldSize += 4 + getLength(data));
    rawExtraField = new Uint8Array(extraFieldSize);
    extraField.forEach((data, type) => {
      if (type > MAX_16_BITS) {
        throw new Error(ERR_INVALID_EXTRAFIELD_TYPE);
      }
      if (getLength(data) > MAX_16_BITS) {
        throw new Error(ERR_INVALID_EXTRAFIELD_DATA);
      }
      arraySet(rawExtraField, new Uint16Array([type]), offset);
      arraySet(rawExtraField, new Uint16Array([getLength(data)]), offset + 2);
      arraySet(rawExtraField, data, offset + 4);
      offset += 4 + getLength(data);
    });
  }
  let maximumCompressedSize = 0;
  let maximumEntrySize = 0;
  let uncompressedSize = 0;
  const zip64Enabled = zip64 === true;
  if (reader) {
    reader = initReader(reader);
    await initStream(reader);
    if (reader.size === UNDEFINED_VALUE) {
      dataDescriptor = true;
      if (zip64 || zip64 === UNDEFINED_VALUE) {
        zip64 = true;
        uncompressedSize = maximumCompressedSize = MAX_32_BITS + 1;
      }
    } else {
      uncompressedSize = reader.size;
      maximumCompressedSize = getMaximumCompressedSize(uncompressedSize);
    }
  }
  const {
    diskOffset,
    diskNumber,
    maxSize
  } = zipWriter.writer;
  const zip64UncompressedSize = zip64Enabled || uncompressedSize > MAX_32_BITS;
  const zip64CompressedSize = zip64Enabled || maximumCompressedSize > MAX_32_BITS;
  const zip64Offset = zip64Enabled || zipWriter.offset + zipWriter.pendingEntriesSize - diskOffset > MAX_32_BITS;
  const supportZip64SplitFile = getOptionValue(zipWriter, options, "supportZip64SplitFile", true);
  const zip64DiskNumberStart = supportZip64SplitFile && zip64Enabled || diskNumber + Math.ceil(zipWriter.pendingEntriesSize / maxSize) > MAX_16_BITS;
  if (zip64Offset || zip64UncompressedSize || zip64CompressedSize || zip64DiskNumberStart) {
    if (zip64 === false || !keepOrder) {
      throw new Error(ERR_UNSUPPORTED_FORMAT);
    } else {
      zip64 = true;
    }
  }
  zip64 = zip64 || false;
  options = Object.assign({}, options, {
    rawFilename,
    rawComment,
    version,
    versionMadeBy,
    lastModDate,
    lastAccessDate,
    creationDate,
    rawExtraField,
    zip64,
    zip64UncompressedSize,
    zip64CompressedSize,
    zip64Offset,
    zip64DiskNumberStart,
    password,
    rawPassword,
    level: !useCompressionStream && zipWriter.config.CompressionStream === UNDEFINED_VALUE && zipWriter.config.CompressionStreamNative === UNDEFINED_VALUE ? 0 : level,
    useWebWorkers,
    encryptionStrength,
    extendedTimestamp,
    zipCrypto,
    bufferedWrite,
    keepOrder,
    dataDescriptor,
    dataDescriptorSignature,
    signal,
    msDosCompatible,
    internalFileAttribute,
    externalFileAttribute,
    useCompressionStream
  });
  const headerInfo = getHeaderInfo(options);
  const dataDescriptorInfo = getDataDescriptorInfo(options);
  const metadataSize = getLength(headerInfo.localHeaderArray, dataDescriptorInfo.dataDescriptorArray);
  maximumEntrySize = metadataSize + maximumCompressedSize;
  if (zipWriter.options.usdz) {
    maximumEntrySize += maximumEntrySize + 64;
  }
  zipWriter.pendingEntriesSize += maximumEntrySize;
  let fileEntry;
  try {
    fileEntry = await getFileEntry(zipWriter, name, reader, {
      headerInfo,
      dataDescriptorInfo,
      metadataSize
    }, options);
  } finally {
    zipWriter.pendingEntriesSize -= maximumEntrySize;
  }
  Object.assign(fileEntry, {
    name,
    comment,
    extraField
  });
  return new Entry(fileEntry);
}
async function getFileEntry(zipWriter, name, reader, entryInfo, options) {
  const {
    files,
    writer
  } = zipWriter;
  const {
    keepOrder,
    dataDescriptor,
    signal
  } = options;
  const {
    headerInfo
  } = entryInfo;
  const {
    usdz
  } = zipWriter.options;
  const previousFileEntry = Array.from(files.values()).pop();
  let fileEntry = {};
  let bufferedWrite;
  let releaseLockWriter;
  let releaseLockCurrentFileEntry;
  let writingBufferedEntryData;
  let writingEntryData;
  let fileWriter;
  let blobPromise;
  files.set(name, fileEntry);
  try {
    let lockPreviousFileEntry;
    if (keepOrder) {
      lockPreviousFileEntry = previousFileEntry && previousFileEntry.lock;
      requestLockCurrentFileEntry();
    }
    if ((options.bufferedWrite || zipWriter.writerLocked || zipWriter.bufferedWrites && keepOrder || !dataDescriptor) && !usdz) {
      fileWriter = new TransformStream();
      blobPromise = new Response(fileWriter.readable).blob();
      fileWriter.writable.size = 0;
      bufferedWrite = true;
      zipWriter.bufferedWrites++;
      await initStream(writer);
    } else {
      fileWriter = writer;
      await requestLockWriter();
    }
    await initStream(fileWriter);
    const {
      writable
    } = writer;
    let {
      diskOffset
    } = writer;
    if (zipWriter.addSplitZipSignature) {
      delete zipWriter.addSplitZipSignature;
      const signatureArray = new Uint8Array(4);
      const signatureArrayView = getDataView(signatureArray);
      setUint32(signatureArrayView, 0, SPLIT_ZIP_FILE_SIGNATURE);
      await writeData(writable, signatureArray);
      zipWriter.offset += 4;
    }
    if (usdz) {
      appendExtraFieldUSDZ(entryInfo, zipWriter.offset - diskOffset);
    }
    if (!bufferedWrite) {
      await lockPreviousFileEntry;
      await skipDiskIfNeeded(writable);
    }
    const {
      diskNumber
    } = writer;
    writingEntryData = true;
    fileEntry.diskNumberStart = diskNumber;
    fileEntry = await createFileEntry(reader, fileWriter, fileEntry, entryInfo, zipWriter.config, options);
    writingEntryData = false;
    files.set(name, fileEntry);
    fileEntry.filename = name;
    if (bufferedWrite) {
      await fileWriter.writable.getWriter().close();
      let blob = await blobPromise;
      await lockPreviousFileEntry;
      await requestLockWriter();
      writingBufferedEntryData = true;
      if (!dataDescriptor) {
        blob = await writeExtraHeaderInfo(fileEntry, blob, writable, options);
      }
      await skipDiskIfNeeded(writable);
      fileEntry.diskNumberStart = writer.diskNumber;
      diskOffset = writer.diskOffset;
      await blob.stream().pipeTo(writable, {
        preventClose: true,
        preventAbort: true,
        signal
      });
      writable.size += blob.size;
      writingBufferedEntryData = false;
    }
    fileEntry.offset = zipWriter.offset - diskOffset;
    if (fileEntry.zip64) {
      setZip64ExtraInfo(fileEntry, options);
    } else if (fileEntry.offset > MAX_32_BITS) {
      throw new Error(ERR_UNSUPPORTED_FORMAT);
    }
    zipWriter.offset += fileEntry.size;
    return fileEntry;
  } catch (error) {
    if (bufferedWrite && writingBufferedEntryData || !bufferedWrite && writingEntryData) {
      zipWriter.hasCorruptedEntries = true;
      if (error) {
        try {
          error.corruptedEntry = true;
        } catch (_error) {
          // ignored
        }
      }
      if (bufferedWrite) {
        zipWriter.offset += fileWriter.writable.size;
      } else {
        zipWriter.offset = fileWriter.writable.size;
      }
    }
    files.delete(name);
    throw error;
  } finally {
    if (bufferedWrite) {
      zipWriter.bufferedWrites--;
    }
    if (releaseLockCurrentFileEntry) {
      releaseLockCurrentFileEntry();
    }
    if (releaseLockWriter) {
      releaseLockWriter();
    }
  }
  function requestLockCurrentFileEntry() {
    fileEntry.lock = new Promise(resolve => releaseLockCurrentFileEntry = resolve);
  }
  async function requestLockWriter() {
    zipWriter.writerLocked = true;
    const {
      lockWriter
    } = zipWriter;
    zipWriter.lockWriter = new Promise(resolve => releaseLockWriter = () => {
      zipWriter.writerLocked = false;
      resolve();
    });
    await lockWriter;
  }
  async function skipDiskIfNeeded(writable) {
    if (getLength(headerInfo.localHeaderArray) > writer.availableSize) {
      writer.availableSize = 0;
      await writeData(writable, new Uint8Array());
    }
  }
}
async function createFileEntry(reader, writer, {
  diskNumberStart,
  lock
}, entryInfo, config, options) {
  const {
    headerInfo,
    dataDescriptorInfo,
    metadataSize
  } = entryInfo;
  const {
    localHeaderArray,
    headerArray,
    lastModDate,
    rawLastModDate,
    encrypted,
    compressed,
    version,
    compressionMethod,
    rawExtraFieldExtendedTimestamp,
    extraFieldExtendedTimestampFlag,
    rawExtraFieldNTFS,
    rawExtraFieldAES
  } = headerInfo;
  const {
    dataDescriptorArray
  } = dataDescriptorInfo;
  const {
    rawFilename,
    lastAccessDate,
    creationDate,
    password,
    rawPassword,
    level,
    zip64,
    zip64UncompressedSize,
    zip64CompressedSize,
    zip64Offset,
    zip64DiskNumberStart,
    zipCrypto,
    dataDescriptor,
    directory,
    versionMadeBy,
    rawComment,
    rawExtraField,
    useWebWorkers,
    onstart,
    onprogress,
    onend,
    signal,
    encryptionStrength,
    extendedTimestamp,
    msDosCompatible,
    internalFileAttribute,
    externalFileAttribute,
    useCompressionStream
  } = options;
  const fileEntry = {
    lock,
    versionMadeBy,
    zip64,
    directory: Boolean(directory),
    filenameUTF8: true,
    rawFilename,
    commentUTF8: true,
    rawComment,
    rawExtraFieldExtendedTimestamp,
    rawExtraFieldNTFS,
    rawExtraFieldAES,
    rawExtraField,
    extendedTimestamp,
    msDosCompatible,
    internalFileAttribute,
    externalFileAttribute,
    diskNumberStart
  };
  let compressedSize = 0;
  let uncompressedSize = 0;
  let signature;
  const {
    writable
  } = writer;
  if (reader) {
    reader.chunkSize = getChunkSize(config);
    await writeData(writable, localHeaderArray);
    const readable = reader.readable;
    const size = readable.size = reader.size;
    const workerOptions = {
      options: {
        codecType: CODEC_DEFLATE,
        level,
        rawPassword,
        password,
        encryptionStrength,
        zipCrypto: encrypted && zipCrypto,
        passwordVerification: encrypted && zipCrypto && rawLastModDate >> 8 & 0xFF,
        signed: true,
        compressed,
        encrypted,
        useWebWorkers,
        useCompressionStream,
        transferStreams: false
      },
      config,
      streamOptions: {
        signal,
        size,
        onstart,
        onprogress,
        onend
      }
    };
    const result = await runWorker({
      readable,
      writable
    }, workerOptions);
    uncompressedSize = result.inputSize;
    compressedSize = result.outputSize;
    signature = result.signature;
    writable.size += uncompressedSize;
  } else {
    await writeData(writable, localHeaderArray);
  }
  let rawExtraFieldZip64;
  if (zip64) {
    let rawExtraFieldZip64Length = 4;
    if (zip64UncompressedSize) {
      rawExtraFieldZip64Length += 8;
    }
    if (zip64CompressedSize) {
      rawExtraFieldZip64Length += 8;
    }
    if (zip64Offset) {
      rawExtraFieldZip64Length += 8;
    }
    if (zip64DiskNumberStart) {
      rawExtraFieldZip64Length += 4;
    }
    rawExtraFieldZip64 = new Uint8Array(rawExtraFieldZip64Length);
  } else {
    rawExtraFieldZip64 = new Uint8Array();
  }
  setEntryInfo({
    signature,
    rawExtraFieldZip64,
    compressedSize,
    uncompressedSize,
    headerInfo,
    dataDescriptorInfo
  }, options);
  if (dataDescriptor) {
    await writeData(writable, dataDescriptorArray);
  }
  Object.assign(fileEntry, {
    uncompressedSize,
    compressedSize,
    lastModDate,
    rawLastModDate,
    creationDate,
    lastAccessDate,
    encrypted,
    size: metadataSize + compressedSize,
    compressionMethod,
    version,
    headerArray,
    signature,
    rawExtraFieldZip64,
    extraFieldExtendedTimestampFlag,
    zip64UncompressedSize,
    zip64CompressedSize,
    zip64Offset,
    zip64DiskNumberStart
  });
  return fileEntry;
}
function getHeaderInfo(options) {
  const {
    rawFilename,
    lastModDate,
    lastAccessDate,
    creationDate,
    rawPassword,
    password,
    level,
    zip64,
    zipCrypto,
    dataDescriptor,
    directory,
    rawExtraField,
    encryptionStrength,
    extendedTimestamp
  } = options;
  const compressed = level !== 0 && !directory;
  const encrypted = Boolean(password && getLength(password) || rawPassword && getLength(rawPassword));
  let version = options.version;
  let rawExtraFieldAES;
  if (encrypted && !zipCrypto) {
    rawExtraFieldAES = new Uint8Array(getLength(EXTRAFIELD_DATA_AES) + 2);
    const extraFieldAESView = getDataView(rawExtraFieldAES);
    setUint16(extraFieldAESView, 0, EXTRAFIELD_TYPE_AES);
    arraySet(rawExtraFieldAES, EXTRAFIELD_DATA_AES, 2);
    setUint8(extraFieldAESView, 8, encryptionStrength);
  } else {
    rawExtraFieldAES = new Uint8Array();
  }
  let rawExtraFieldNTFS;
  let rawExtraFieldExtendedTimestamp;
  let extraFieldExtendedTimestampFlag;
  if (extendedTimestamp) {
    rawExtraFieldExtendedTimestamp = new Uint8Array(9 + (lastAccessDate ? 4 : 0) + (creationDate ? 4 : 0));
    const extraFieldExtendedTimestampView = getDataView(rawExtraFieldExtendedTimestamp);
    setUint16(extraFieldExtendedTimestampView, 0, EXTRAFIELD_TYPE_EXTENDED_TIMESTAMP);
    setUint16(extraFieldExtendedTimestampView, 2, getLength(rawExtraFieldExtendedTimestamp) - 4);
    extraFieldExtendedTimestampFlag = 0x1 + (lastAccessDate ? 0x2 : 0) + (creationDate ? 0x4 : 0);
    setUint8(extraFieldExtendedTimestampView, 4, extraFieldExtendedTimestampFlag);
    let offset = 5;
    setUint32(extraFieldExtendedTimestampView, offset, Math.floor(lastModDate.getTime() / 1000));
    offset += 4;
    if (lastAccessDate) {
      setUint32(extraFieldExtendedTimestampView, offset, Math.floor(lastAccessDate.getTime() / 1000));
      offset += 4;
    }
    if (creationDate) {
      setUint32(extraFieldExtendedTimestampView, offset, Math.floor(creationDate.getTime() / 1000));
    }
    try {
      rawExtraFieldNTFS = new Uint8Array(36);
      const extraFieldNTFSView = getDataView(rawExtraFieldNTFS);
      const lastModTimeNTFS = getTimeNTFS(lastModDate);
      setUint16(extraFieldNTFSView, 0, EXTRAFIELD_TYPE_NTFS);
      setUint16(extraFieldNTFSView, 2, 32);
      setUint16(extraFieldNTFSView, 8, EXTRAFIELD_TYPE_NTFS_TAG1);
      setUint16(extraFieldNTFSView, 10, 24);
      setBigUint64(extraFieldNTFSView, 12, lastModTimeNTFS);
      setBigUint64(extraFieldNTFSView, 20, getTimeNTFS(lastAccessDate) || lastModTimeNTFS);
      setBigUint64(extraFieldNTFSView, 28, getTimeNTFS(creationDate) || lastModTimeNTFS);
    } catch (_error) {
      rawExtraFieldNTFS = new Uint8Array();
    }
  } else {
    rawExtraFieldNTFS = rawExtraFieldExtendedTimestamp = new Uint8Array();
  }
  let bitFlag = BITFLAG_LANG_ENCODING_FLAG;
  if (dataDescriptor) {
    bitFlag = bitFlag | BITFLAG_DATA_DESCRIPTOR;
  }
  let compressionMethod = COMPRESSION_METHOD_STORE;
  if (compressed) {
    compressionMethod = COMPRESSION_METHOD_DEFLATE;
  }
  if (zip64) {
    version = version > VERSION_ZIP64 ? version : VERSION_ZIP64;
  }
  if (encrypted) {
    bitFlag = bitFlag | BITFLAG_ENCRYPTED;
    if (!zipCrypto) {
      version = version > VERSION_AES ? version : VERSION_AES;
      compressionMethod = COMPRESSION_METHOD_AES;
      if (compressed) {
        rawExtraFieldAES[9] = COMPRESSION_METHOD_DEFLATE;
      }
    }
  }
  const headerArray = new Uint8Array(26);
  const headerView = getDataView(headerArray);
  setUint16(headerView, 0, version);
  setUint16(headerView, 2, bitFlag);
  setUint16(headerView, 4, compressionMethod);
  const dateArray = new Uint32Array(1);
  const dateView = getDataView(dateArray);
  let lastModDateMsDos;
  if (lastModDate < MIN_DATE) {
    lastModDateMsDos = MIN_DATE;
  } else if (lastModDate > MAX_DATE) {
    lastModDateMsDos = MAX_DATE;
  } else {
    lastModDateMsDos = lastModDate;
  }
  setUint16(dateView, 0, (lastModDateMsDos.getHours() << 6 | lastModDateMsDos.getMinutes()) << 5 | lastModDateMsDos.getSeconds() / 2);
  setUint16(dateView, 2, (lastModDateMsDos.getFullYear() - 1980 << 4 | lastModDateMsDos.getMonth() + 1) << 5 | lastModDateMsDos.getDate());
  const rawLastModDate = dateArray[0];
  setUint32(headerView, 6, rawLastModDate);
  setUint16(headerView, 22, getLength(rawFilename));
  const extraFieldLength = getLength(rawExtraFieldAES, rawExtraFieldExtendedTimestamp, rawExtraFieldNTFS, rawExtraField);
  setUint16(headerView, 24, extraFieldLength);
  const localHeaderArray = new Uint8Array(30 + getLength(rawFilename) + extraFieldLength);
  const localHeaderView = getDataView(localHeaderArray);
  setUint32(localHeaderView, 0, LOCAL_FILE_HEADER_SIGNATURE);
  arraySet(localHeaderArray, headerArray, 4);
  arraySet(localHeaderArray, rawFilename, 30);
  arraySet(localHeaderArray, rawExtraFieldAES, 30 + getLength(rawFilename));
  arraySet(localHeaderArray, rawExtraFieldExtendedTimestamp, 30 + getLength(rawFilename, rawExtraFieldAES));
  arraySet(localHeaderArray, rawExtraFieldNTFS, 30 + getLength(rawFilename, rawExtraFieldAES, rawExtraFieldExtendedTimestamp));
  arraySet(localHeaderArray, rawExtraField, 30 + getLength(rawFilename, rawExtraFieldAES, rawExtraFieldExtendedTimestamp, rawExtraFieldNTFS));
  return {
    localHeaderArray,
    headerArray,
    headerView,
    lastModDate,
    rawLastModDate,
    encrypted,
    compressed,
    version,
    compressionMethod,
    extraFieldExtendedTimestampFlag,
    rawExtraFieldExtendedTimestamp,
    rawExtraFieldNTFS,
    rawExtraFieldAES,
    extraFieldLength
  };
}
function appendExtraFieldUSDZ(entryInfo, zipWriterOffset) {
  const {
    headerInfo
  } = entryInfo;
  let {
    localHeaderArray,
    extraFieldLength
  } = headerInfo;
  let localHeaderArrayView = getDataView(localHeaderArray);
  let extraBytesLength = 64 - (zipWriterOffset + getLength(localHeaderArray)) % 64;
  if (extraBytesLength < 4) {
    extraBytesLength += 64;
  }
  const rawExtraFieldUSDZ = new Uint8Array(extraBytesLength);
  const extraFieldUSDZView = getDataView(rawExtraFieldUSDZ);
  setUint16(extraFieldUSDZView, 0, EXTRAFIELD_TYPE_USDZ);
  setUint16(extraFieldUSDZView, 2, extraBytesLength - 2);
  const previousLocalHeaderArray = localHeaderArray;
  headerInfo.localHeaderArray = localHeaderArray = new Uint8Array(getLength(previousLocalHeaderArray) + extraBytesLength);
  arraySet(localHeaderArray, previousLocalHeaderArray);
  arraySet(localHeaderArray, rawExtraFieldUSDZ, getLength(previousLocalHeaderArray));
  localHeaderArrayView = getDataView(localHeaderArray);
  setUint16(localHeaderArrayView, 28, extraFieldLength + extraBytesLength);
  entryInfo.metadataSize += extraBytesLength;
}
function getDataDescriptorInfo(options) {
  const {
    zip64,
    dataDescriptor,
    dataDescriptorSignature
  } = options;
  let dataDescriptorArray = new Uint8Array();
  let dataDescriptorView,
    dataDescriptorOffset = 0;
  if (dataDescriptor) {
    dataDescriptorArray = new Uint8Array(zip64 ? dataDescriptorSignature ? 24 : 20 : dataDescriptorSignature ? 16 : 12);
    dataDescriptorView = getDataView(dataDescriptorArray);
    if (dataDescriptorSignature) {
      dataDescriptorOffset = 4;
      setUint32(dataDescriptorView, 0, DATA_DESCRIPTOR_RECORD_SIGNATURE);
    }
  }
  return {
    dataDescriptorArray,
    dataDescriptorView,
    dataDescriptorOffset
  };
}
function setEntryInfo(entryInfo, options) {
  const {
    signature,
    rawExtraFieldZip64,
    compressedSize,
    uncompressedSize,
    headerInfo,
    dataDescriptorInfo
  } = entryInfo;
  const {
    headerView,
    encrypted
  } = headerInfo;
  const {
    dataDescriptorView,
    dataDescriptorOffset
  } = dataDescriptorInfo;
  const {
    zip64,
    zip64UncompressedSize,
    zip64CompressedSize,
    zipCrypto,
    dataDescriptor
  } = options;
  if ((!encrypted || zipCrypto) && signature !== UNDEFINED_VALUE) {
    setUint32(headerView, 10, signature);
    if (dataDescriptor) {
      setUint32(dataDescriptorView, dataDescriptorOffset, signature);
    }
  }
  if (zip64) {
    const rawExtraFieldZip64View = getDataView(rawExtraFieldZip64);
    setUint16(rawExtraFieldZip64View, 0, EXTRAFIELD_TYPE_ZIP64);
    setUint16(rawExtraFieldZip64View, 2, getLength(rawExtraFieldZip64) - 4);
    let rawExtraFieldZip64Offset = 4;
    if (zip64UncompressedSize) {
      setUint32(headerView, 18, MAX_32_BITS);
      setBigUint64(rawExtraFieldZip64View, rawExtraFieldZip64Offset, BigInt(uncompressedSize));
      rawExtraFieldZip64Offset += 8;
    }
    if (zip64CompressedSize) {
      setUint32(headerView, 14, MAX_32_BITS);
      setBigUint64(rawExtraFieldZip64View, rawExtraFieldZip64Offset, BigInt(compressedSize));
    }
    if (dataDescriptor) {
      setBigUint64(dataDescriptorView, dataDescriptorOffset + 4, BigInt(compressedSize));
      setBigUint64(dataDescriptorView, dataDescriptorOffset + 12, BigInt(uncompressedSize));
    }
  } else {
    setUint32(headerView, 14, compressedSize);
    setUint32(headerView, 18, uncompressedSize);
    if (dataDescriptor) {
      setUint32(dataDescriptorView, dataDescriptorOffset + 4, compressedSize);
      setUint32(dataDescriptorView, dataDescriptorOffset + 8, uncompressedSize);
    }
  }
}
async function writeExtraHeaderInfo(fileEntry, entryData, writable, {
  zipCrypto
}) {
  let arrayBuffer;
  arrayBuffer = await entryData.slice(0, 26).arrayBuffer();
  if (arrayBuffer.byteLength != 26) {
    arrayBuffer = arrayBuffer.slice(0, 26);
  }
  const arrayBufferView = new DataView(arrayBuffer);
  if (!fileEntry.encrypted || zipCrypto) {
    setUint32(arrayBufferView, 14, fileEntry.signature);
  }
  if (fileEntry.zip64) {
    setUint32(arrayBufferView, 18, MAX_32_BITS);
    setUint32(arrayBufferView, 22, MAX_32_BITS);
  } else {
    setUint32(arrayBufferView, 18, fileEntry.compressedSize);
    setUint32(arrayBufferView, 22, fileEntry.uncompressedSize);
  }
  await writeData(writable, new Uint8Array(arrayBuffer));
  return entryData.slice(arrayBuffer.byteLength);
}
function setZip64ExtraInfo(fileEntry, options) {
  const {
    rawExtraFieldZip64,
    offset,
    diskNumberStart
  } = fileEntry;
  const {
    zip64UncompressedSize,
    zip64CompressedSize,
    zip64Offset,
    zip64DiskNumberStart
  } = options;
  const rawExtraFieldZip64View = getDataView(rawExtraFieldZip64);
  let rawExtraFieldZip64Offset = 4;
  if (zip64UncompressedSize) {
    rawExtraFieldZip64Offset += 8;
  }
  if (zip64CompressedSize) {
    rawExtraFieldZip64Offset += 8;
  }
  if (zip64Offset) {
    setBigUint64(rawExtraFieldZip64View, rawExtraFieldZip64Offset, BigInt(offset));
    rawExtraFieldZip64Offset += 8;
  }
  if (zip64DiskNumberStart) {
    setUint32(rawExtraFieldZip64View, rawExtraFieldZip64Offset, diskNumberStart);
  }
}
async function closeFile(zipWriter, comment, options) {
  const {
    files,
    writer
  } = zipWriter;
  const {
    diskOffset,
    writable
  } = writer;
  let {
    diskNumber
  } = writer;
  let offset = 0;
  let directoryDataLength = 0;
  let directoryOffset = zipWriter.offset - diskOffset;
  let filesLength = files.size;
  for (const [, fileEntry] of files) {
    const {
      rawFilename,
      rawExtraFieldZip64,
      rawExtraFieldAES,
      rawComment,
      rawExtraFieldNTFS,
      rawExtraField,
      extendedTimestamp,
      extraFieldExtendedTimestampFlag,
      lastModDate
    } = fileEntry;
    let rawExtraFieldTimestamp;
    if (extendedTimestamp) {
      rawExtraFieldTimestamp = new Uint8Array(9);
      const extraFieldExtendedTimestampView = getDataView(rawExtraFieldTimestamp);
      setUint16(extraFieldExtendedTimestampView, 0, EXTRAFIELD_TYPE_EXTENDED_TIMESTAMP);
      setUint16(extraFieldExtendedTimestampView, 2, 5);
      setUint8(extraFieldExtendedTimestampView, 4, extraFieldExtendedTimestampFlag);
      setUint32(extraFieldExtendedTimestampView, 5, Math.floor(lastModDate.getTime() / 1000));
    } else {
      rawExtraFieldTimestamp = new Uint8Array();
    }
    fileEntry.rawExtraFieldCDExtendedTimestamp = rawExtraFieldTimestamp;
    directoryDataLength += 46 + getLength(rawFilename, rawComment, rawExtraFieldZip64, rawExtraFieldAES, rawExtraFieldNTFS, rawExtraFieldTimestamp, rawExtraField);
  }
  const directoryArray = new Uint8Array(directoryDataLength);
  const directoryView = getDataView(directoryArray);
  await initStream(writer);
  let directoryDiskOffset = 0;
  for (const [indexFileEntry, fileEntry] of Array.from(files.values()).entries()) {
    const {
      offset: fileEntryOffset,
      rawFilename,
      rawExtraFieldZip64,
      rawExtraFieldAES,
      rawExtraFieldCDExtendedTimestamp,
      rawExtraFieldNTFS,
      rawExtraField,
      rawComment,
      versionMadeBy,
      headerArray,
      directory,
      zip64,
      zip64UncompressedSize,
      zip64CompressedSize,
      zip64DiskNumberStart,
      zip64Offset,
      msDosCompatible,
      internalFileAttribute,
      externalFileAttribute,
      diskNumberStart,
      uncompressedSize,
      compressedSize
    } = fileEntry;
    const extraFieldLength = getLength(rawExtraFieldZip64, rawExtraFieldAES, rawExtraFieldCDExtendedTimestamp, rawExtraFieldNTFS, rawExtraField);
    setUint32(directoryView, offset, CENTRAL_FILE_HEADER_SIGNATURE);
    setUint16(directoryView, offset + 4, versionMadeBy);
    const headerView = getDataView(headerArray);
    if (!zip64UncompressedSize) {
      setUint32(headerView, 18, uncompressedSize);
    }
    if (!zip64CompressedSize) {
      setUint32(headerView, 14, compressedSize);
    }
    arraySet(directoryArray, headerArray, offset + 6);
    setUint16(directoryView, offset + 30, extraFieldLength);
    setUint16(directoryView, offset + 32, getLength(rawComment));
    setUint16(directoryView, offset + 34, zip64 && zip64DiskNumberStart ? MAX_16_BITS : diskNumberStart);
    setUint16(directoryView, offset + 36, internalFileAttribute);
    if (externalFileAttribute) {
      setUint32(directoryView, offset + 38, externalFileAttribute);
    } else if (directory && msDosCompatible) {
      setUint8(directoryView, offset + 38, FILE_ATTR_MSDOS_DIR_MASK);
    }
    setUint32(directoryView, offset + 42, zip64 && zip64Offset ? MAX_32_BITS : fileEntryOffset);
    arraySet(directoryArray, rawFilename, offset + 46);
    arraySet(directoryArray, rawExtraFieldZip64, offset + 46 + getLength(rawFilename));
    arraySet(directoryArray, rawExtraFieldAES, offset + 46 + getLength(rawFilename, rawExtraFieldZip64));
    arraySet(directoryArray, rawExtraFieldCDExtendedTimestamp, offset + 46 + getLength(rawFilename, rawExtraFieldZip64, rawExtraFieldAES));
    arraySet(directoryArray, rawExtraFieldNTFS, offset + 46 + getLength(rawFilename, rawExtraFieldZip64, rawExtraFieldAES, rawExtraFieldCDExtendedTimestamp));
    arraySet(directoryArray, rawExtraField, offset + 46 + getLength(rawFilename, rawExtraFieldZip64, rawExtraFieldAES, rawExtraFieldCDExtendedTimestamp, rawExtraFieldNTFS));
    arraySet(directoryArray, rawComment, offset + 46 + getLength(rawFilename) + extraFieldLength);
    const directoryEntryLength = 46 + getLength(rawFilename, rawComment) + extraFieldLength;
    if (offset - directoryDiskOffset > writer.availableSize) {
      writer.availableSize = 0;
      await writeData(writable, directoryArray.slice(directoryDiskOffset, offset));
      directoryDiskOffset = offset;
    }
    offset += directoryEntryLength;
    if (options.onprogress) {
      try {
        await options.onprogress(indexFileEntry + 1, files.size, new Entry(fileEntry));
      } catch (_error) {
        // ignored
      }
    }
  }
  await writeData(writable, directoryDiskOffset ? directoryArray.slice(directoryDiskOffset) : directoryArray);
  let lastDiskNumber = writer.diskNumber;
  const {
    availableSize
  } = writer;
  if (availableSize < END_OF_CENTRAL_DIR_LENGTH) {
    lastDiskNumber++;
  }
  let zip64 = getOptionValue(zipWriter, options, "zip64");
  if (directoryOffset > MAX_32_BITS || directoryDataLength > MAX_32_BITS || filesLength > MAX_16_BITS || lastDiskNumber > MAX_16_BITS) {
    if (zip64 === false) {
      throw new Error(ERR_UNSUPPORTED_FORMAT);
    } else {
      zip64 = true;
    }
  }
  const endOfdirectoryArray = new Uint8Array(zip64 ? ZIP64_END_OF_CENTRAL_DIR_TOTAL_LENGTH : END_OF_CENTRAL_DIR_LENGTH);
  const endOfdirectoryView = getDataView(endOfdirectoryArray);
  offset = 0;
  if (zip64) {
    setUint32(endOfdirectoryView, 0, ZIP64_END_OF_CENTRAL_DIR_SIGNATURE);
    setBigUint64(endOfdirectoryView, 4, BigInt(44));
    setUint16(endOfdirectoryView, 12, 45);
    setUint16(endOfdirectoryView, 14, 45);
    setUint32(endOfdirectoryView, 16, lastDiskNumber);
    setUint32(endOfdirectoryView, 20, diskNumber);
    setBigUint64(endOfdirectoryView, 24, BigInt(filesLength));
    setBigUint64(endOfdirectoryView, 32, BigInt(filesLength));
    setBigUint64(endOfdirectoryView, 40, BigInt(directoryDataLength));
    setBigUint64(endOfdirectoryView, 48, BigInt(directoryOffset));
    setUint32(endOfdirectoryView, 56, ZIP64_END_OF_CENTRAL_DIR_LOCATOR_SIGNATURE);
    setBigUint64(endOfdirectoryView, 64, BigInt(directoryOffset) + BigInt(directoryDataLength));
    setUint32(endOfdirectoryView, 72, lastDiskNumber + 1);
    const supportZip64SplitFile = getOptionValue(zipWriter, options, "supportZip64SplitFile", true);
    if (supportZip64SplitFile) {
      lastDiskNumber = MAX_16_BITS;
      diskNumber = MAX_16_BITS;
    }
    filesLength = MAX_16_BITS;
    directoryOffset = MAX_32_BITS;
    directoryDataLength = MAX_32_BITS;
    offset += ZIP64_END_OF_CENTRAL_DIR_LENGTH + ZIP64_END_OF_CENTRAL_DIR_LOCATOR_LENGTH;
  }
  setUint32(endOfdirectoryView, offset, END_OF_CENTRAL_DIR_SIGNATURE);
  setUint16(endOfdirectoryView, offset + 4, lastDiskNumber);
  setUint16(endOfdirectoryView, offset + 6, diskNumber);
  setUint16(endOfdirectoryView, offset + 8, filesLength);
  setUint16(endOfdirectoryView, offset + 10, filesLength);
  setUint32(endOfdirectoryView, offset + 12, directoryDataLength);
  setUint32(endOfdirectoryView, offset + 16, directoryOffset);
  const commentLength = getLength(comment);
  if (commentLength) {
    if (commentLength <= MAX_16_BITS) {
      setUint16(endOfdirectoryView, offset + 20, commentLength);
    } else {
      throw new Error(ERR_INVALID_COMMENT);
    }
  }
  await writeData(writable, endOfdirectoryArray);
  if (commentLength) {
    await writeData(writable, comment);
  }
}
async function writeData(writable, array) {
  const streamWriter = writable.getWriter();
  try {
    await streamWriter.ready;
    writable.size += getLength(array);
    await streamWriter.write(array);
  } finally {
    streamWriter.releaseLock();
  }
}
function getTimeNTFS(date) {
  if (date) {
    return (BigInt(date.getTime()) + BigInt(11644473600000)) * BigInt(10000);
  }
}
function getOptionValue(zipWriter, options, name, defaultValue) {
  const result = options[name] === UNDEFINED_VALUE ? zipWriter.options[name] : options[name];
  return result === UNDEFINED_VALUE ? defaultValue : result;
}
function getMaximumCompressedSize(uncompressedSize) {
  return uncompressedSize + 5 * (Math.floor(uncompressedSize / 16383) + 1);
}
function setUint8(view, offset, value) {
  view.setUint8(offset, value);
}
function setUint16(view, offset, value) {
  view.setUint16(offset, value, true);
}
function setUint32(view, offset, value) {
  view.setUint32(offset, value, true);
}
function setBigUint64(view, offset, value) {
  view.setBigUint64(offset, value, true);
}
function arraySet(array, typedArray, offset) {
  array.set(typedArray, offset);
}
function getDataView(array) {
  return new DataView(array.buffer);
}
function getLength(...arrayLikes) {
  let result = 0;
  arrayLikes.forEach(arrayLike => arrayLike && (result += arrayLike.length));
  return result;
}

/*
 Copyright (c) 2022 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright
 notice, this list of conditions and the following disclaimer in
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
let baseURL;
try {
  baseURL = import.meta.url;
} catch (_error) {
  // ignored
}
configure({
  baseURL
});
e$4(configure);

/// <reference types="./index.d.ts" />
configure({
  Deflate: ZipDeflate,
  Inflate: ZipInflate
});

const unzipArrayBuffer = async (zipFileArrayBuffer, onProgress) => {
  const zipReader = new ZipReader(new Uint8ArrayReader(new Uint8Array(zipFileArrayBuffer)));
  const entries = await zipReader.getEntries({
    onprogress: function (index, max) {
      // console.log('opening zip', index/max);
    }
  });
  const audioFileObject = {};
  await Promise.all(entries.filter(entry => !entry.filename.includes('__MACOSX')).map(async (entry, index) => {
    // console.log(entry.filename);
    const unzippedBlob = await entry.getData(new BlobWriter(), {
      onprogress: onProgress
    });
    audioFileObject[entry.filename.split('.')[0]] = unzippedBlob;
  }));
  await zipReader.close();
  return audioFileObject;
};
const createSessionZip = async (sessionJSON, userAudioObjects) => {
  const blobWriter = new BlobWriter("application/zip");
  const zipWriter = new ZipWriter(blobWriter);
  await zipWriter.add(`${sessionJSON.id}.json`, new TextReader(JSON.stringify(sessionJSON)));
  for (const audioFileArrayBuffer of userAudioObjects) {
    await zipWriter.add(audioFileArrayBuffer.fileName, new Uint8ArrayReader(new Uint8Array(audioFileArrayBuffer.arrayBuffer)));
  }
  await zipWriter.close();

  // get the zip file as a Blob
  const blob = blobWriter.getData();
  return blob;
};
const createSetlistZip = async sessionZips => {
  const blobWriter = new BlobWriter("application/zip");
  const zipWriter = new ZipWriter(blobWriter);
  for (const sessionId of Object.keys(sessionZips)) {
    await zipWriter.add(`${sessionId}.session`, new BlobReader(sessionZips[sessionId]));
  }
  await zipWriter.close();

  // get the zip file as a Blob
  const blob = blobWriter.getData();
  return blob;
};
const openSessionZip = async sessionZipBlob => {
  const zipReader = new ZipReader(new Uint8ArrayReader(new Uint8Array(sessionZipBlob)));
  const entries = await zipReader.getEntries();
  let session = {};
  let audioAssets = {};
  await Promise.all(entries.filter(entry => !entry.filename.includes('__MACOSX')).map(async (entry, index) => {
    if (entry.filename.includes('.json')) {
      const sessionBlob = await entry.getData(new BlobWriter("text/plain"));
      session = JSON.parse(await sessionBlob.text());
    } else {
      const audioAsset = await entry.getData(new BlobWriter("audio/wav"));
      audioAssets[entry.filename] = await audioAsset.arrayBuffer();
    }
  }));
  return {
    session,
    audioAssets
  };
};
const openSetlistZip = async setlistZipBlob => {
  // console.log(setlistZipBlob);

  const zipReader = new ZipReader(new Uint8ArrayReader(new Uint8Array(setlistZipBlob)));
  const entries = await zipReader.getEntries();
  let sessionsObject = {};
  await Promise.all(entries.filter(entry => !entry.filename.includes('__MACOSX')).map(async (entry, index) => {
    if (entry.filename.includes('.session')) {
      const sessionAsset = await entry.getData(new BlobWriter("application/zip"));
      sessionsObject[entry.filename] = await sessionAsset.arrayBuffer();
    }
  }));
  return sessionsObject;
};

class SuperpoweredGlue {
  niceSize(bytes) {
    if (bytes == 0) return '0 byte';else if (bytes == 1) return '1 byte';
    const postfix = [' bytes', ' kb', ' mb', ' gb', ' tb'];
    let n = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, n), 2) + postfix[n];
  }
  createFloatArray(length) {
    return this.createViewFromType(9, this.malloc(length * 4), length);
  }
  static async fetch(url) {
    let obj = new SuperpoweredGlue();
    await fetch(url).then(response => response.arrayBuffer()).then(bytes => obj.loadFromArrayBuffer(bytes));
    return obj;
  }
  constructor() {
    this.id = Math.floor(Math.random() * Date.now());
    this.linearMemory = null;
    this.__lastObject__ = null;
    this.__classUnderConstruction__ = null;
    this.__functions__ = {};
    this.__classes__ = {};
    this.__exportsToWasm__ = {};
    this.__views__ = new Set();
    let glue = this;
    this.Uint8Buffer = class {
      constructor(length) {
        return glue.createViewFromType(1, glue.malloc(length), length);
      }
    };
    this.Int8Buffer = class {
      constructor(length) {
        return glue.createViewFromType(2, glue.malloc(length), length);
      }
    };
    this.Uint16Buffer = class {
      constructor(length) {
        return glue.createViewFromType(3, glue.malloc(length * 2), length);
      }
    };
    this.Int16Buffer = class {
      constructor(length) {
        return glue.createViewFromType(4, glue.malloc(length * 2), length);
      }
    };
    this.Uint32Buffer = class {
      constructor(length) {
        return glue.createViewFromType(5, glue.malloc(length * 4), length);
      }
    };
    this.Int32Buffer = class {
      constructor(length) {
        return glue.createViewFromType(6, glue.malloc(length * 4), length);
      }
    };
    this.BigUint64Buffer = class {
      constructor(length) {
        return glue.createViewFromType(7, glue.malloc(length * 8), length);
      }
    };
    this.BigInt64Buffer = class {
      constructor(length) {
        return glue.createViewFromType(8, glue.malloc(length * 8), length);
      }
    };
    this.Float32Buffer = class {
      constructor(length) {
        return glue.createViewFromType(9, glue.malloc(length * 4), length);
      }
    };
    this.Float64Buffer = class {
      constructor(length) {
        return glue.createViewFromType(10, glue.malloc(length * 8), length);
      }
    };
    this.__exportsToWasm__.consolelog = this.consolelog.bind(this);
    this.__exportsToWasm__.emscripten_notify_memory_growth = this.onMemoryGrowth.bind(this);
    this.__exportsToWasm__.__createClass__ = this.createClass.bind(this);
    this.__exportsToWasm__.__createStaticProperty__ = this.createStaticProperty.bind(this);
    this.__exportsToWasm__.__createStaticMethod__ = this.createStaticMethod.bind(this);
    this.__exportsToWasm__.__createConstructor__ = this.createConstructor.bind(this);
    this.__exportsToWasm__.__createDestructor__ = this.createDestructor.bind(this);
    this.__exportsToWasm__.__createProperty__ = this.createProperty.bind(this);
    this.__exportsToWasm__.__createMethod__ = this.createMethod.bind(this);
    this.__exportsToWasm__.__createFunction__ = this.createFunction.bind(this);
    this.__exportsToWasm__.__createClassConstant__ = this.createClassConstant.bind(this);
    this.__exportsToWasm__.__createConstant__ = this.createConstant.bind(this);
    this.__exportsToWasm__.__runjs__ = function (pointer) {
      return eval(this.toString(pointer));
    }.bind(this);
    this.__exportsToWasm__.abs = function (value) {
      return Math.abs(value);
    };
    this.__exportsToWasm__.round = function (value) {
      return Math.round(value);
    };
    this.__exportsToWasm__.roundf = function (value) {
      return Math.fround(value);
    };
    this.wasi = {
      proc_exit: function () {
        console.log('abort');
      }
    };
  }
  updateBuffer(buffer, arraybuffer) {
    buffer.__arraybuffer__ = arraybuffer;
    switch (buffer.__type__) {
      case 1:
        buffer.array = new Uint8Array(buffer.__arraybuffer__, buffer.pointer, buffer.length < 0 ? buffer.__arraybuffer__.byteLength - buffer.pointer : buffer.length);
        break;
      case 2:
        buffer.array = new Int8Array(buffer.__arraybuffer__, buffer.pointer, buffer.length < 0 ? buffer.__arraybuffer__.byteLength - buffer.pointer : buffer.length);
        break;
      case 3:
        buffer.array = new Uint16Array(buffer.__arraybuffer__, buffer.pointer, buffer.length < 0 ? (buffer.__arraybuffer__.byteLength - buffer.pointer) / 2 : buffer.length);
        break;
      case 4:
        buffer.array = new Int16Array(buffer.__arraybuffer__, buffer.pointer, buffer.length < 0 ? (buffer.__arraybuffer__.byteLength - buffer.pointer) / 2 : buffer.length);
        break;
      case 5:
        buffer.array = new Uint32Array(buffer.__arraybuffer__, buffer.pointer, buffer.length < 0 ? (buffer.__arraybuffer__.byteLength - buffer.pointer) / 4 : buffer.length);
        break;
      case 6:
        buffer.array = new Int32Array(buffer.__arraybuffer__, buffer.pointer, buffer.length < 0 ? (buffer.__arraybuffer__.byteLength - buffer.pointer) / 4 : buffer.length);
        break;
      case 7:
        buffer.array = new BigUint64Array(buffer.__arraybuffer__, buffer.pointer, buffer.length < 0 ? (buffer.__arraybuffer__.byteLength - buffer.pointer) / 8 : buffer.length);
        break;
      case 8:
        buffer.array = new BigInt64Array(buffer.__arraybuffer__, buffer.pointer, buffer.length < 0 ? (buffer.__arraybuffer__.byteLength - buffer.pointer) / 8 : buffer.length);
        break;
      case 9:
        buffer.array = new Float32Array(buffer.__arraybuffer__, buffer.pointer, buffer.length < 0 ? (buffer.__arraybuffer__.byteLength - buffer.pointer) / 4 : buffer.length);
        break;
      case 10:
        buffer.array = new Float64Array(buffer.__arraybuffer__, buffer.pointer, buffer.length < 0 ? (buffer.__arraybuffer__.byteLength - buffer.pointer) / 8 : buffer.length);
        break;
    }
  }
  createViewFromType(type, pointer, length) {
    let buffer = {
      pointer: pointer,
      length: length,
      __arraybuffer__: this.linearMemory,
      __type__: type,
      __glue__: this,
      free() {
        this.__glue__.free(this.pointer);
        let obj = this;
        Object.getOwnPropertyNames(obj).forEach(function (property) {
          delete obj[property];
        });
        Object.setPrototypeOf(obj, null);
      }
    };
    this.updateBuffer(buffer, this.linearMemory);
    this.__views__.add(buffer);
    return buffer;
  }
  returnPointerToView(r, type) {
    if (type > 0 && typeof r !== undefined) {
      let length = this.__functions__.__lastarraylength__();
      r = this.createViewFromType(type, r, length > 0 ? length : -1);
    }
    return r;
  }
  invokeMethod() {
    if (arguments.length == 2 && typeof arguments[1] == 'object') {
      let obj = arguments[1],
        n = 1;
      for (let m in obj) arguments[n++] = obj[m];
      arguments.length = n;
    }
    let strings = [];
    for (let index = arguments.length - 1; index > 0; index--) {
      if (arguments[index].array != undefined) arguments[index] = arguments[index].array.byteOffset;else if (arguments[index].__pointer__ != undefined) arguments[index] = arguments[index].__pointer__;else if (typeof arguments[index] == 'string') {
        arguments[index] = this.__glue__.toWASMString(arguments[index]);
        strings.push(arguments[index]);
      }
    }
    let info = arguments[0];
    arguments[0] = this.__pointer__;
    let r = info.function.apply(this, arguments);
    for (let string of strings) this.__glue__.free(string);
    r = this.__glue__.returnPointerToView(r, info.returnPointerType);
    return r;
  }
  invokeFunction() {
    if (arguments.length == 1 && typeof arguments[0] == 'object') {
      let obj = arguments[0],
        n = 0;
      for (let m in obj) arguments[n++] = obj[m];
      arguments.length = n;
    }
    let strings = [];
    for (let index = arguments.length - 1; index >= 0; index--) {
      if (arguments[index].array != undefined) arguments[index] = arguments[index].array.byteOffset;else if (arguments[index].__pointer__ != undefined) arguments[index] = arguments[index].__pointer__;else if (typeof arguments[index] == 'string') {
        arguments[index] = this.glue.toWASMString(arguments[index]);
        strings.push(arguments[index]);
      }
    }
    let r = this.apply(this, arguments);
    for (let string of strings) this.glue.free(string);
    r = this.glue.returnPointerToView(r, this.returnPointerType);
    return r;
  }
  invokeExportedFunction() {
    let r = this.apply(this, arguments);
    if (typeof r.array !== undefined) r = r.array.byteOffset;
    return r;
  }
  createClass(classnamePointer, classnameLen, sizeofClass) {
    let glue = this;
    let classname = glue.toString(classnamePointer, classnameLen);
    let WASM = class {
      constructor() {
        let meta = Object.getPrototypeOf(this).constructor.__meta__;
        if (!meta.hasConstructor) throw meta.name + ' has no constructor';
        this.__class__ = meta.name;
        this.__prev__ = glue.__lastObject__;
        if (glue.__lastObject__ != null) glue.__lastObject__.__next__ = this;
        this.__next__ = null;
        this.__glue__ = glue;
        glue.__lastObject__ = this;
        let args = [].slice.call(arguments);
        args.unshift(glue.malloc(meta.size));
        this.__pointer__ = glue[meta.name + '::' + meta.name].apply(null, args);
        for (let property of meta.properties) glue.createPropertyFromDescriptor(this, property);
        for (let method of meta.methods) this[method.name] = glue.invokeMethod.bind(this, {
          function: glue[method.wasmFunction],
          returnPointerType: method.returnPointerType
        });
      }
      destruct() {
        let meta = Object.getPrototypeOf(this).constructor.__meta__;
        if (meta.hasDestructor) glue[meta.name + '::~' + meta.name](this.__pointer__);
        glue.free(this.__pointer__);
        if (this.__prev__ != null) this.__prev__.__next__ = this.__next__;
        if (this.__next__ != null) this.__next__.__prev__ = this.__prev__;
        let obj = this;
        Object.getOwnPropertyNames(obj).forEach(function (property) {
          delete obj[property];
        });
        Object.setPrototypeOf(obj, null);
      }
    };
    glue.__classUnderConstruction__ = glue.__classes__[classname] = glue[classname] = WASM;
    glue.__classUnderConstruction__.__meta__ = {
      name: classname,
      size: sizeofClass,
      hasConstructor: false,
      hasDestructor: false,
      properties: [],
      methods: [],
      staticProperties: []
    };
    delete glue.__functionsWithNamespace__[classname];
  }
  createConstructor() {
    this.__classUnderConstruction__.__meta__.hasConstructor = true;
  }
  createDestructor() {
    this.__classUnderConstruction__.__meta__.hasDestructor = this.__classUnderConstruction__.__meta__.hasConstructor;
  }
  createClassConstant(nameptr, namelen, value) {
    let name = this.toString(nameptr, namelen);
    this.__classUnderConstruction__[name] = value;
  }
  createConstant(nameptr, namelen, value) {
    let name = this.toString(nameptr, namelen);
    this[name] = value;
  }
  createPropertyFromDescriptor(object, descriptor) {
    let buffer = this.createViewFromType(descriptor.viewType, object.__pointer__ + descriptor.offset, descriptor.viewLength);
    if (descriptor.viewLength > 1) Object.defineProperty(object, descriptor.name, {
      get: function () {
        return buffer.array;
      },
      set: function (value) {
        buffer.array[index] = value;
      },
      configurable: true,
      enumerable: true
    });else Object.defineProperty(object, descriptor.name, {
      get: function () {
        return buffer.array[0];
      },
      set: function (value) {
        buffer.array[0] = value;
      },
      configurable: true,
      enumerable: true
    });
  }
  createProperty(propertynamePointer, propertynameLen, offset, viewType, viewLength) {
    let propertyname = this.toString(propertynamePointer, propertynameLen);
    let descriptor = {
      name: propertyname,
      offset: offset,
      viewType: viewType,
      viewLength: viewLength
    };
    this.__classUnderConstruction__.__meta__.properties.push(descriptor);
  }
  createStaticPropertyFromDescriptor(wasmClass, descriptor) {
    let buffer = this.createViewFromType(descriptor.viewType, descriptor.pointer, descriptor.viewLength);
    if (descriptor.viewLength > 1) Object.defineProperty(wasmClass, descriptor.name, {
      get: function () {
        return buffer.array;
      },
      set: function (value) {
        buffer.array[index] = value;
      },
      configurable: true,
      enumerable: true
    });else Object.defineProperty(wasmClass, descriptor.name, {
      get: function () {
        return buffer.array[0];
      },
      set: function (value) {
        buffer.array[0] = value;
      },
      configurable: true,
      enumerable: true
    });
  }
  createStaticProperty(propertynamePointer, propertynameLen, pointer, viewType, viewLength) {
    let propertyname = this.toString(propertynamePointer, propertynameLen);
    let descriptor = {
      name: propertyname,
      pointer: pointer,
      viewType: viewType,
      viewLength: viewLength
    };
    this.__classUnderConstruction__.__meta__.staticProperties.push(descriptor);
    this.createStaticPropertyFromDescriptor(this.__classUnderConstruction__, descriptor);
  }
  createMethod(methodnamePointer, methodnameLen, returnPointerType) {
    let methodname = this.toString(methodnamePointer, methodnameLen);
    let wasmMethodname = this.__classUnderConstruction__.__meta__.name + '::' + methodname;
    this.__classUnderConstruction__.__meta__.methods.push({
      name: methodname,
      wasmFunction: wasmMethodname,
      returnPointerType: returnPointerType
    });
  }
  createStaticMethod(methodnamePointer, methodnameLen, returnPointerType) {
    let methodname = this.toString(methodnamePointer, methodnameLen);
    let wasmMethodname = this.__classUnderConstruction__.__meta__.name + '::' + methodname;
    this[wasmMethodname].returnPointerType = returnPointerType;
    this[wasmMethodname].glue = this;
    this.__classUnderConstruction__[methodname] = this.invokeFunction.bind(this[wasmMethodname]);
  }
  createFunction(methodnamePointer, methodnameLen, returnPointerType) {
    let methodname = this.toString(methodnamePointer, methodnameLen);
    if (!this[methodname]) {
      // maybe this function is in a namespace
      for (let namespace in this.__functionsWithNamespace__) {
        if (this.__functionsWithNamespace__[namespace][methodname]) {
          this[methodname] = this.__functionsWithNamespace__[namespace][methodname];
          delete this.__functionsWithNamespace__[namespace][methodname];
          break;
        }
      }
      if (!this[methodname]) return;
    }
    this[methodname].returnPointerType = returnPointerType;
    this[methodname].glue = this;
    this[methodname] = this.invokeFunction.bind(this[methodname]);
  }
  exportToWasm(functionName, f) {
    this.__exportsToWasm__[functionName] = this.invokeExportedFunction.bind(f);
  }
  onMemoryGrowth(n) {
    this.linearMemory = this.wasmInstance.exports.memory.buffer;
    if (this.__memorygrowview__.buffer.byteLength < 1) this.updateMemoryViews();
    this.logMemory();
  }
  consolelog(pointer, strlen) {
    console.log(this.toString(pointer, strlen));
  }
  async loadFromArrayBuffer(wasmCode, afterWASMLoaded = null) {
    this.wasmCode = wasmCode;
    await WebAssembly.instantiate(wasmCode, {
      wasi_snapshot_preview1: this.wasi,
      env: this.__exportsToWasm__
    }).then(_module => {
      this.wasmInstance = _module.instance;
      this.wasmInstance.exports._initialize();
      this.__functions__ = this.wasmInstance.exports;
      this.linearMemory = this.wasmInstance.exports.memory.buffer;
      this.__memorygrowpointer__ = this.__functions__.__malloc__(16);
      this.__memorygrowview__ = new Uint8Array(this.linearMemory, this.__memorygrowpointer__, 16);
      this.__functionsWithNamespace__ = {};
      let outputBuffer = this.__functions__.__malloc__(1024);
      let stringview = new Uint8Array(this.linearMemory, this.__functions__.__malloc__(1024), 1024);
      for (let f in this.__functions__) {
        if (f != '__demangle__') {
          let length = this.__functions__.__demangle__(this.toWASMString(f, stringview), outputBuffer);
          if (length > 0) {
            let name = this.toString(outputBuffer, length);
            let par = name.indexOf('(');
            if (par > 0) name = name.substring(0, par);
            let namespace = name.lastIndexOf('::');
            if (namespace > 0) {
              namespace = name.lastIndexOf('::', namespace - 1);
              if (namespace > 0) name = name.substr(namespace + 2);
            }

            // class members have namespaces removed from this point, but functions not
            let split = name.split('::', 2);
            if (split.length == 2) {
              if (!this.__functionsWithNamespace__[split[0]]) this.__functionsWithNamespace__[split[0]] = {};
              this.__functionsWithNamespace__[split[0]][split[1]] = this.__functions__[f];
            }
            this[name] = this.__functions__[f];
          } else this[f] = this.__functions__[f];
        }
      }
      this.free(outputBuffer);
      this.free(stringview.byteOffset);
      this.__functions__.__initialize__();
      delete this.__functionsWithNamespace__;
      this.logMemory();
      this.__classUnderConstruction__ = null;
      if (afterWASMLoaded != null) afterWASMLoaded.afterWASMLoaded();
    });
  }
  toString(pointer, strlen = 0) {
    let view = null;
    if (strlen < 1) {
      let viewLength = this.linearMemory.byteLength - pointer;
      if (viewLength > 16384) viewLength = 16384;
      view = new Uint8Array(this.linearMemory, pointer, viewLength);
      for (strlen = 0; strlen < viewLength; strlen++) if (view[strlen] == 0) break;
    } else view = new Uint8Array(this.linearMemory, pointer, strlen);
    let str = '',
      i = 0,
      octet,
      bytesNeeded,
      codePoint,
      k;
    while (i < strlen) {
      octet = view[i];
      bytesNeeded = codePoint = 0;
      if (octet <= 0x7f) {
        bytesNeeded = 0;
        codePoint = octet & 0xff;
      } else if (octet <= 0xdf) {
        bytesNeeded = 1;
        codePoint = octet & 0x1f;
      } else if (octet <= 0xef) {
        bytesNeeded = 2;
        codePoint = octet & 0x0f;
      } else if (octet <= 0xf4) {
        bytesNeeded = 3;
        codePoint = octet & 0x07;
      }
      if (strlen - i - bytesNeeded > 0) {
        k = 0;
        while (k < bytesNeeded) {
          octet = view[i + k + 1];
          codePoint = codePoint << 6 | octet & 0x3f;
          k += 1;
        }
      } else {
        codePoint = 0xfffd;
        bytesNeeded = strlen - i;
      }
      str += String.fromCodePoint(codePoint);
      i += bytesNeeded + 1;
    }
    return str;
  }
  toWASMString(str, view = null) {
    let length = str.length,
      i = 0,
      codePoint,
      c,
      bits,
      destination = 0,
      maxBytes = length * 4 + 1;
    if (view == null) view = new Uint8Array(this.linearMemory, this.malloc(maxBytes), maxBytes);
    while (i < length) {
      codePoint = str.codePointAt(i);
      c = bits = 0;
      if (codePoint <= 0x0000007f) {
        c = 0;
        bits = 0x00;
      } else if (codePoint <= 0x000007ff) {
        c = 6;
        bits = 0xc0;
      } else if (codePoint <= 0x0000ffff) {
        c = 12;
        bits = 0xe0;
      } else if (codePoint <= 0x001fffff) {
        c = 18;
        bits = 0xf0;
      }
      view[destination++] = bits | codePoint >> c;
      c -= 6;
      while (c >= 0) {
        view[destination++] = 0x80 | codePoint >> c & 0x3f;
        c -= 6;
      }
      i += codePoint >= 0x10000 ? 2 : 1;
    }
    view[destination] = 0;
    return view.byteOffset;
  }
  logMemory() {
    console.log('WASM memory ' + this.id + ': ' + this.niceSize(this.__functions__.__stacksize__()) + ' stack, ' + this.niceSize(this.linearMemory.byteLength - this.__functions__.__heapbase__()) + ' heap, ' + this.niceSize(this.linearMemory.byteLength) + ' total.');
  }
  malloc(bytes) {
    let pointer = this.__functions__.__malloc__(bytes);
    if (this.__memorygrowview__.buffer.byteLength < 1) this.updateMemoryViews();
    return pointer;
  }
  updateMemoryViews() {
    for (let buffer of this.__views__) this.updateBuffer(buffer, this.linearMemory);
    this.__memorygrowview__ = new Uint8Array(this.linearMemory, this.__memorygrowpointer__, 16);
  }
  free(pointer) {
    this.__functions__.__free__(pointer);
  }
  setInt64(pointer, index, value) {
    this.__functions__.__setint64__(pointer, index, value);
  }
  bufferToWASM(buffer, input) {
    let inBufferL = null;
    let inBufferR = null;
    if (typeof input.getChannelData === 'function') {
      inBufferL = input.getChannelData(0);
      inBufferR = input.getChannelData(1);
    } else {
      inBufferL = input[0][0];
      inBufferR = input[0][1];
    }
    for (let n = 0, i = 0; n < buffer.array.length; n++, i++) {
      buffer.array[n++] = inBufferL[i];
      buffer.array[n] = inBufferR[i];
    }
  }
  bufferToJS(buffer, output) {
    let outBufferL = null;
    let outBufferR = null;
    if (typeof output.getChannelData === 'function') {
      outBufferL = output.getChannelData(0);
      outBufferR = output.getChannelData(1);
    } else {
      outBufferL = output[0][0];
      outBufferR = output[0][1];
    }
    for (let n = 0, i = 0; n < buffer.array.length; n++, i++) {
      outBufferL[i] = buffer.array[n++];
      outBufferR[i] = buffer.array[n];
    }
  }
  arrayBufferToWASM(arrayBuffer, offset = 0) {
    let pointer = this.malloc(arrayBuffer.byteLength + offset);
    new Uint8Array(this.linearMemory).set(new Uint8Array(arrayBuffer, 0, arrayBuffer.byteLength), pointer + offset);
    return pointer;
  }
  copyWASMToArrayBuffer(pointer, lengthBytes) {
    let arrayBuffer = new ArrayBuffer(lengthBytes);
    new Uint8Array(arrayBuffer, 0, lengthBytes).set(new Uint8Array(this.linearMemory, pointer, lengthBytes));
    return arrayBuffer;
  }
  moveWASMToArrayBuffer(pointer, lengthBytes) {
    let arrayBuffer = this.copyWASMToArrayBuffer(pointer, lengthBytes);
    this.free(pointer);
    return arrayBuffer;
  }
}
if (typeof exports === 'object' && typeof module === 'object') module.exports = SuperpoweredGlue;else if (typeof define === 'function' && define['amd']) define([], function () {
  return SuperpoweredGlue;
});else if (typeof exports === 'object') exports["SuperpoweredGlue"] = SuperpoweredGlue;

class SuperpoweredTrackLoader {
  constructor(receiver) {
    this.receiver = typeof receiver.port !== 'undefined' ? receiver.port : receiver;
    if (typeof receiver.terminate !== 'undefined') receiver.addEventListener('message', this.onmessage); // Worker
  }
  onmessage(message) {
    if (typeof message.data.SuperpoweredLoad !== 'string') return false;
    this.load(message.data.SuperpoweredLoad);
    return true;
  }
  load(url) {
    let trackLoaderWorker = new Worker('./lib/superpowered/SuperpoweredTrackLoaderWorker.js');
    trackLoaderWorker.__url__ = url;
    trackLoaderWorker.ontransfer = function (message) {
      this.transfer(message.transfer, trackLoaderWorker);
    }.bind(this);
    trackLoaderWorker.onmessage = function (message) {
      this.transfer(message.data.__transfer__, trackLoaderWorker);
    }.bind(this);
    trackLoaderWorker.postMessage({
      load: trackLoaderWorker.__url__
    });
  }
  transfer(arrayBuffer, trackLoaderWorker) {
    if (typeof this.receiver.postMessage === 'function') this.receiver.postMessage({
      SuperpoweredLoaded: {
        buffer: arrayBuffer,
        url: trackLoaderWorker.__url__
      }
    }, [arrayBuffer]);else this.receiver({
      SuperpoweredLoaded: {
        buffer: arrayBuffer,
        url: trackLoaderWorker.__url__
      }
    });
    trackLoaderWorker.terminate();
  }
  static downloadAndDecode(url, obj) {
    if (typeof obj.onMessageFromMainScope === 'function' && typeof obj.sendMessageToMainScope === 'function') obj.sendMessageToMainScope({
      SuperpoweredLoad: url
    });else new SuperpoweredTrackLoader(obj).load(url);
  }
}
if (typeof exports === 'object' && typeof module === 'object') module.exports = {
  SuperpoweredTrackLoader
};else if (typeof define === 'function' && define['amd']) define([], function () {
  return {
    SuperpoweredTrackLoader
  };
});else if (typeof exports === 'object') exports["SuperpoweredTrackLoader"] = {
  SuperpoweredTrackLoader
};

var AudioWorkletHasBrokenModuleImplementation = false;
class SuperpoweredWebAudio {
  constructor(minimumSamplerate, superpowered, offlineRenderingOptions = null) {
    // pgw testing 13-may-2024
    console.log('SuperpoweredWebAudio ctor p1');
    //alert('SuperpoweredWebAudio ctor p1')

    AudioWorkletHasBrokenModuleImplementation = navigator.userAgent.indexOf('AppleWebKit') > -1 || navigator.userAgent.indexOf('Firefox') > -1;
    if (AudioWorkletHasBrokenModuleImplementation && navigator.userAgent.indexOf('Chrome') > -1) AudioWorkletHasBrokenModuleImplementation = false;
    this.Superpowered = superpowered;
    this.audioContext = null;
    let AudioContext = window.AudioContext || window.webkitAudioContext || false;
    let c = offlineRenderingOptions ? new window.OfflineAudioContext({
      numberOfChannels: 2,
      length: offlineRenderingOptions.length * minimumSamplerate,
      sampleRate: minimumSamplerate
    }) : new AudioContext();
    if (c.sampleRate < minimumSamplerate) {
      c.close();
      c = new AudioContext({
        sampleRate: minimumSamplerate
      });
    }
    this.audioContext = c;
  }
  getUserMediaForAudio(constraints, onPermissionGranted, onPermissionDenied) {
    let finalConstraints = {};
    if (navigator.mediaDevices) {
      let supportedConstraints = navigator.mediaDevices.getSupportedConstraints();
      for (let constraint in supportedConstraints) {
        if (supportedConstraints.hasOwnProperty(constraint) && constraints[constraint] !== undefined) {
          finalConstraints[constraint] = constraints[constraint];
        }
      }
    }
    finalConstraints.audio = true;
    finalConstraints.video = false;
    navigator.fastAndTransparentAudio = constraints.hasOwnProperty('fastAndTransparentAudio') && constraints.fastAndTransparentAudio === true;
    if (navigator.fastAndTransparentAudio) {
      finalConstraints.echoCancellation = false;
      finalConstraints.disableLocalEcho = false;
      finalConstraints.autoGainControl = false;
      finalConstraints.audio = {
        mandatory: {
          googAutoGainControl: false,
          googAutoGainControl2: false,
          googEchoCancellation: false,
          googNoiseSuppression: false,
          googHighpassFilter: false,
          googEchoCancellation2: false,
          googNoiseSuppression2: false,
          googDAEchoCancellation: false,
          googNoiseReduction: false
        }
      };
    }
    navigator.getUserMediaMethod = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
    if (navigator.getUserMediaMethod) navigator.getUserMediaMethod(finalConstraints, onPermissionGranted, onPermissionDenied);else {
      let userMedia = null;
      let userMediaError = false;
      try {
        userMedia = navigator.mediaDevices.getUserMedia;
      } catch (error) {
        if (location.protocol.toLowerCase() != 'https' && location.hostname.toLowerCase() != 'localhost') onPermissionDenied("Web Audio requires a secure context (HTTPS or localhost).");else onPermissionDenied(error);
        userMediaError = true;
      }
      if (!userMediaError) {
        if (userMedia) navigator.mediaDevices.getUserMedia(finalConstraints).then(onPermissionGranted).catch(onPermissionDenied);else onPermissionDenied("Can't access getUserMedia.");
      }
    }
  }
  async getUserMediaForAudioAsync(constraints) {
    return new Promise((resolve, reject) => {
      this.getUserMediaForAudio(constraints, function (stream) {
        if (navigator.fastAndTransparentAudio) {
          let audioTracks = stream.getAudioTracks();
          for (let audioTrack of audioTracks) audioTrack.applyConstraints({
            autoGainControl: false,
            echoCancellation: false,
            noiseSuppression: false
          });
        }
        resolve(stream);
      }, reject);
    });
  }
  async createAudioNodeAsync(url, className, onMessageFromAudioScope) {
    return new Promise((resolve, reject) => {
      this.createAudioNode(url, className, resolve, onMessageFromAudioScope);
    });
  }
  createAudioNode(url, className, callback, onMessageFromAudioScope) {
    if (!AudioWorkletHasBrokenModuleImplementation && typeof AudioWorkletNode === 'function') {
      console.log('using AudioWorklet');
      this.audioContext.audioWorklet.addModule( /* webpackIgnore: true */url).then(() => {
        class SuperpoweredNode extends AudioWorkletNode {
          constructor(glue, name) {
            super(glue.audioContext, name, {
              'processorOptions': {
                'wasmCode': glue.Superpowered.wasmCode,
                'samplerate': glue.audioContext.sampleRate,
                'maxChannels': glue.Superpowered.__maxChannels__
              },
              'outputChannelCount': [2]
            });
          }
          sendMessageToAudioScope(message, transfer = []) {
            this.port.postMessage(message, transfer);
          }
          destruct() {
            this.port.postMessage('___superpowered___destruct___');
          }
        }
        let node = new SuperpoweredNode(this, className);
        node.loader = new SuperpoweredTrackLoader(node);
        node.onReadyCallback = callback;
        node.onMessageFromAudioScope = onMessageFromAudioScope;
        node.port.onmessage = function (event) {
          if (node.loader.onmessage(event)) return;
          if (event.data == '___superpowered___onready___') node.onReadyCallback(node);else node.onMessageFromAudioScope(event.data);
        }.bind(node);
      });
    } else {
      console.log('using ScriptProcessor');
      import( /* webpackIgnore: true */url).then(processorModule => {
        let node = this.audioContext.createScriptProcessor(1024, 2, 2);
        node.samplerate = this.audioContext.sampleRate;
        node.inputBuffer = this.Superpowered.createFloatArray(1024 * 2);
        node.outputBuffer = this.Superpowered.createFloatArray(1024 * 2);
        node.processor = new processorModule.default(this.Superpowered, onMessageFromAudioScope, node.samplerate);
        node.sendMessageToAudioScope = function (message, transfer = 0) {
          node.processor.onMessageFromMainScope(message);
        };
        node.destruct = function () {
          node.processor.onDestruct();
        };
        node.onaudioprocess = function (e) {
          node.processor.Superpowered.bufferToWASM(node.inputBuffer, e.inputBuffer);
          node.processor.processAudio(node.inputBuffer, node.outputBuffer, node.inputBuffer.array.length / 2);
          node.processor.Superpowered.bufferToJS(node.outputBuffer, e.outputBuffer);
        };
        callback(node);
      });
    }
  }
}
if (!AudioWorkletHasBrokenModuleImplementation && typeof AudioWorkletProcessor === 'function') {
  class SuperpoweredAudioWorkletProcessor extends AudioWorkletProcessor {
    constructor(options) {
      super();
      SuperpoweredGlue.__uint_max__sp__ = options.processorOptions.maxChannels;
      this.state = 0;
      this.port.onmessage = event => {
        if (event.data == '___superpowered___destruct___') {
          this.state = -1;
          this.onDestruct();
        } else this.onMessageFromMainScope(event.data);
      };
      this.samplerate = options.processorOptions.samplerate;
      this.Superpowered = new SuperpoweredGlue();
      this.Superpowered.loadFromArrayBuffer(options.processorOptions.wasmCode, this);
    }
    afterWASMLoaded() {
      this.Superpowered.Initialize();
      this.inputBuffer = this.Superpowered.createFloatArray(128 * 2);
      this.outputBuffer = this.Superpowered.createFloatArray(128 * 2);
      this.onReady();
      this.port.postMessage('___superpowered___onready___');
      this.state = 1;
    }
    onReady() {}
    onDestruct() {}
    onMessageFromMainScope(message) {}
    sendMessageToMainScope(message) {
      this.port.postMessage(message);
    }
    processAudio(buffer, parameters) {}
    process(inputs, outputs, parameters) {
      if (this.state < 0) return false;
      if (this.state == 1) {
        if (inputs[0].length > 1) this.Superpowered.bufferToWASM(this.inputBuffer, inputs);
        this.processAudio(this.inputBuffer, this.outputBuffer, this.inputBuffer.array.length / 2, parameters);
        if (outputs[0].length > 1) this.Superpowered.bufferToJS(this.outputBuffer, outputs);
      }
      return true;
    }
  }
  SuperpoweredWebAudio.AudioWorkletProcessor = SuperpoweredAudioWorkletProcessor;
} else {
  class SuperpoweredAudioWorkletProcessor {
    constructor(sp, oma, sr) {
      this.loader = new SuperpoweredTrackLoader(this);
      this.Superpowered = sp;
      this.samplerate = sr;
      this.onMessageFromAudioScope = oma;
      this.onReady();
    }
    onMessageFromAudioScope = null;
    onReady() {}
    onDestruct() {}
    onMessageFromMainScope(message) {}
    sendMessageToMainScope(message) {
      if (!this.loader.onmessage({
        data: message
      })) this.onMessageFromAudioScope(message);
    }
    postMessage(message, transfer = []) {
      this.onMessageFromMainScope(message);
    }
    processAudio(buffer, parameters) {}
  }
  SuperpoweredWebAudio.AudioWorkletProcessor = SuperpoweredAudioWorkletProcessor;
}
if (typeof exports === 'object' && typeof module === 'object') module.exports = {
  SuperpoweredGlue,
  SuperpoweredWebAudio,
  SuperpoweredTrackLoader
};else if (typeof define === 'function' && define['amd']) define([], function () {
  return {
    SuperpoweredGlue,
    SuperpoweredWebAudio,
    SuperpoweredTrackLoader
  };
});else if (typeof exports === 'object') exports["SuperpoweredModule"] = {
  SuperpoweredGlue,
  SuperpoweredWebAudio,
  SuperpoweredTrackLoader
};

function new_byte$1(count) {
  return new Int8Array(count);
}
function new_short(count) {
  return new Int16Array(count);
}
function new_int$8(count) {
  return new Int32Array(count);
}
function new_float$8(count) {
  return new Float32Array(count);
}
function new_double$1(count) {
  return new Float64Array(count);
}
function new_float_n$3(args) {
  if (args.length == 1) {
    return new_float$8(args[0]);
  }
  var sz = args[0];
  args = args.slice(1);
  var A = [];
  for (var i = 0; i < sz; i++) {
    A.push(new_float_n$3(args));
  }
  return A;
}
function new_int_n$1(args) {
  if (args.length == 1) {
    return new_int$8(args[0]);
  }
  var sz = args[0];
  args = args.slice(1);
  var A = [];
  for (var i = 0; i < sz; i++) {
    A.push(new_int_n$1(args));
  }
  return A;
}
function new_short_n(args) {
  if (args.length == 1) {
    return new_short(args[0]);
  }
  var sz = args[0];
  args = args.slice(1);
  var A = [];
  for (var i = 0; i < sz; i++) {
    A.push(new_short_n(args));
  }
  return A;
}
function new_array_n(args) {
  if (args.length == 1) {
    return new Array(args[0]);
  }
  var sz = args[0];
  args = args.slice(1);
  var A = [];
  for (var i = 0; i < sz; i++) {
    A.push(new_array_n(args));
  }
  return A;
}
var Arrays$2 = {};
Arrays$2.fill = function (a, fromIndex, toIndex, val) {
  if (arguments.length == 2) {
    for (var i = 0; i < a.length; i++) {
      a[i] = arguments[1];
    }
  } else {
    for (var i = fromIndex; i < toIndex; i++) {
      a[i] = val;
    }
  }
};
var System$2 = {};
System$2.arraycopy = function (src, srcPos, dest, destPos, length) {
  var srcEnd = srcPos + length;
  while (srcPos < srcEnd) dest[destPos++] = src[srcPos++];
};
System$2.out = {};
System$2.out.println = function (message) {
  console.log(message);
};
System$2.out.printf = function () {
  console.log.apply(console, arguments);
};
var Util$2 = {};
Util$2.SQRT2 = 1.41421356237309504880;
Util$2.FAST_LOG10 = function (x) {
  return Math.log10(x);
};
Util$2.FAST_LOG10_X = function (x, y) {
  return Math.log10(x) * y;
};
function ShortBlock$1(ordinal) {
  this.ordinal = ordinal;
}
/**
 * LAME may use them, even different block types for L/R.
 */
ShortBlock$1.short_block_allowed = new ShortBlock$1(0);
/**
 * LAME may use them, but always same block types in L/R.
 */
ShortBlock$1.short_block_coupled = new ShortBlock$1(1);
/**
 * LAME will not use short blocks, long blocks only.
 */
ShortBlock$1.short_block_dispensed = new ShortBlock$1(2);
/**
 * LAME will not use long blocks, short blocks only.
 */
ShortBlock$1.short_block_forced = new ShortBlock$1(3);
var Float$1 = {};
Float$1.MAX_VALUE = 3.4028235e+38;
function VbrMode$1(ordinal) {
  this.ordinal = ordinal;
}
VbrMode$1.vbr_off = new VbrMode$1(0);
VbrMode$1.vbr_mt = new VbrMode$1(1);
VbrMode$1.vbr_rh = new VbrMode$1(2);
VbrMode$1.vbr_abr = new VbrMode$1(3);
VbrMode$1.vbr_mtrh = new VbrMode$1(4);
VbrMode$1.vbr_default = VbrMode$1.vbr_mtrh;
var assert$2 = function (x) {
  //console.assert(x);
};
var common$b = {
  "System": System$2,
  "VbrMode": VbrMode$1,
  "Float": Float$1,
  "ShortBlock": ShortBlock$1,
  "Util": Util$2,
  "Arrays": Arrays$2,
  "new_array_n": new_array_n,
  "new_byte": new_byte$1,
  "new_double": new_double$1,
  "new_float": new_float$8,
  "new_float_n": new_float_n$3,
  "new_int": new_int$8,
  "new_int_n": new_int_n$1,
  "new_short": new_short,
  "new_short_n": new_short_n,
  "assert": assert$2
};

/*
 *      MP3 window subband -> subband filtering -> mdct routine
 *
 *      Copyright (c) 1999-2000 Takehiro Tominaga
 *
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Library General Public License for more details.
 *
 * You should have received a copy of the GNU Library General Public
 * License along with this library; if not, write to the
 * Free Software Foundation, Inc., 59 Temple Place - Suite 330,
 * Boston, MA 02111-1307, USA.
 */

var NewMDCT_1;
var hasRequiredNewMDCT;

function requireNewMDCT () {
	if (hasRequiredNewMDCT) return NewMDCT_1;
	hasRequiredNewMDCT = 1;
	/*
	 *         Special Thanks to Patrick De Smet for your advices.
	 */

	/* $Id: NewMDCT.java,v 1.11 2011/05/24 20:48:06 kenchis Exp $ */

	//package mp3;

	//import java.util.Arrays;
	var common = common$b;
	var System = common.System;
	var Util = common.Util;
	var Arrays = common.Arrays;
	var new_float = common.new_float;
	var Encoder = requireEncoder();
	function NewMDCT() {
	  var enwindow = [-4.77e-07 * 0.740951125354959 / 2.384e-06, 1.03951e-04 * 0.740951125354959 / 2.384e-06, 9.53674e-04 * 0.740951125354959 / 2.384e-06, 2.841473e-03 * 0.740951125354959 / 2.384e-06, 3.5758972e-02 * 0.740951125354959 / 2.384e-06, 3.401756e-03 * 0.740951125354959 / 2.384e-06, 9.83715e-04 * 0.740951125354959 / 2.384e-06, 9.9182e-05 * 0.740951125354959 / 2.384e-06, /* 15 */
	  1.2398e-05 * 0.740951125354959 / 2.384e-06, 1.91212e-04 * 0.740951125354959 / 2.384e-06, 2.283096e-03 * 0.740951125354959 / 2.384e-06, 1.6994476e-02 * 0.740951125354959 / 2.384e-06, -1.8756866e-02 * 0.740951125354959 / 2.384e-06, -2.630711e-03 * 0.740951125354959 / 2.384e-06, -2.47478e-04 * 0.740951125354959 / 2.384e-06, -1.4782e-05 * 0.740951125354959 / 2.384e-06, 9.063471690191471e-01, 1.960342806591213e-01, -4.77e-07 * 0.773010453362737 / 2.384e-06, 1.05858e-04 * 0.773010453362737 / 2.384e-06, 9.30786e-04 * 0.773010453362737 / 2.384e-06, 2.521515e-03 * 0.773010453362737 / 2.384e-06, 3.5694122e-02 * 0.773010453362737 / 2.384e-06, 3.643036e-03 * 0.773010453362737 / 2.384e-06, 9.91821e-04 * 0.773010453362737 / 2.384e-06, 9.6321e-05 * 0.773010453362737 / 2.384e-06, /* 14 */
	  1.1444e-05 * 0.773010453362737 / 2.384e-06, 1.65462e-04 * 0.773010453362737 / 2.384e-06, 2.110004e-03 * 0.773010453362737 / 2.384e-06, 1.6112804e-02 * 0.773010453362737 / 2.384e-06, -1.9634247e-02 * 0.773010453362737 / 2.384e-06, -2.803326e-03 * 0.773010453362737 / 2.384e-06, -2.77042e-04 * 0.773010453362737 / 2.384e-06, -1.6689e-05 * 0.773010453362737 / 2.384e-06, 8.206787908286602e-01, 3.901806440322567e-01, -4.77e-07 * 0.803207531480645 / 2.384e-06, 1.07288e-04 * 0.803207531480645 / 2.384e-06, 9.02653e-04 * 0.803207531480645 / 2.384e-06, 2.174854e-03 * 0.803207531480645 / 2.384e-06, 3.5586357e-02 * 0.803207531480645 / 2.384e-06, 3.858566e-03 * 0.803207531480645 / 2.384e-06, 9.95159e-04 * 0.803207531480645 / 2.384e-06, 9.3460e-05 * 0.803207531480645 / 2.384e-06, /* 13 */
	  1.0014e-05 * 0.803207531480645 / 2.384e-06, 1.40190e-04 * 0.803207531480645 / 2.384e-06, 1.937389e-03 * 0.803207531480645 / 2.384e-06, 1.5233517e-02 * 0.803207531480645 / 2.384e-06, -2.0506859e-02 * 0.803207531480645 / 2.384e-06, -2.974033e-03 * 0.803207531480645 / 2.384e-06, -3.07560e-04 * 0.803207531480645 / 2.384e-06, -1.8120e-05 * 0.803207531480645 / 2.384e-06, 7.416505462720353e-01, 5.805693545089249e-01, -4.77e-07 * 0.831469612302545 / 2.384e-06, 1.08242e-04 * 0.831469612302545 / 2.384e-06, 8.68797e-04 * 0.831469612302545 / 2.384e-06, 1.800537e-03 * 0.831469612302545 / 2.384e-06, 3.5435200e-02 * 0.831469612302545 / 2.384e-06, 4.049301e-03 * 0.831469612302545 / 2.384e-06, 9.94205e-04 * 0.831469612302545 / 2.384e-06, 9.0599e-05 * 0.831469612302545 / 2.384e-06, /* 12 */
	  9.060e-06 * 0.831469612302545 / 2.384e-06, 1.16348e-04 * 0.831469612302545 / 2.384e-06, 1.766682e-03 * 0.831469612302545 / 2.384e-06, 1.4358521e-02 * 0.831469612302545 / 2.384e-06, -2.1372318e-02 * 0.831469612302545 / 2.384e-06, -3.14188e-03 * 0.831469612302545 / 2.384e-06, -3.39031e-04 * 0.831469612302545 / 2.384e-06, -1.9550e-05 * 0.831469612302545 / 2.384e-06, 6.681786379192989e-01, 7.653668647301797e-01, -4.77e-07 * 0.857728610000272 / 2.384e-06, 1.08719e-04 * 0.857728610000272 / 2.384e-06, 8.29220e-04 * 0.857728610000272 / 2.384e-06, 1.399517e-03 * 0.857728610000272 / 2.384e-06, 3.5242081e-02 * 0.857728610000272 / 2.384e-06, 4.215240e-03 * 0.857728610000272 / 2.384e-06, 9.89437e-04 * 0.857728610000272 / 2.384e-06, 8.7261e-05 * 0.857728610000272 / 2.384e-06, /* 11 */
	  8.106e-06 * 0.857728610000272 / 2.384e-06, 9.3937e-05 * 0.857728610000272 / 2.384e-06, 1.597881e-03 * 0.857728610000272 / 2.384e-06, 1.3489246e-02 * 0.857728610000272 / 2.384e-06, -2.2228718e-02 * 0.857728610000272 / 2.384e-06, -3.306866e-03 * 0.857728610000272 / 2.384e-06, -3.71456e-04 * 0.857728610000272 / 2.384e-06, -2.1458e-05 * 0.857728610000272 / 2.384e-06, 5.993769336819237e-01, 9.427934736519954e-01, -4.77e-07 * 0.881921264348355 / 2.384e-06, 1.08719e-04 * 0.881921264348355 / 2.384e-06, 7.8392e-04 * 0.881921264348355 / 2.384e-06, 9.71317e-04 * 0.881921264348355 / 2.384e-06, 3.5007000e-02 * 0.881921264348355 / 2.384e-06, 4.357815e-03 * 0.881921264348355 / 2.384e-06, 9.80854e-04 * 0.881921264348355 / 2.384e-06, 8.3923e-05 * 0.881921264348355 / 2.384e-06, /* 10 */
	  7.629e-06 * 0.881921264348355 / 2.384e-06, 7.2956e-05 * 0.881921264348355 / 2.384e-06, 1.432419e-03 * 0.881921264348355 / 2.384e-06, 1.2627602e-02 * 0.881921264348355 / 2.384e-06, -2.3074150e-02 * 0.881921264348355 / 2.384e-06, -3.467083e-03 * 0.881921264348355 / 2.384e-06, -4.04358e-04 * 0.881921264348355 / 2.384e-06, -2.3365e-05 * 0.881921264348355 / 2.384e-06, 5.345111359507916e-01, 1.111140466039205e+00, -9.54e-07 * 0.903989293123443 / 2.384e-06, 1.08242e-04 * 0.903989293123443 / 2.384e-06, 7.31945e-04 * 0.903989293123443 / 2.384e-06, 5.15938e-04 * 0.903989293123443 / 2.384e-06, 3.4730434e-02 * 0.903989293123443 / 2.384e-06, 4.477024e-03 * 0.903989293123443 / 2.384e-06, 9.68933e-04 * 0.903989293123443 / 2.384e-06, 8.0585e-05 * 0.903989293123443 / 2.384e-06, /* 9 */
	  6.676e-06 * 0.903989293123443 / 2.384e-06, 5.2929e-05 * 0.903989293123443 / 2.384e-06, 1.269817e-03 * 0.903989293123443 / 2.384e-06, 1.1775017e-02 * 0.903989293123443 / 2.384e-06, -2.3907185e-02 * 0.903989293123443 / 2.384e-06, -3.622532e-03 * 0.903989293123443 / 2.384e-06, -4.38213e-04 * 0.903989293123443 / 2.384e-06, -2.5272e-05 * 0.903989293123443 / 2.384e-06, 4.729647758913199e-01, 1.268786568327291e+00, -9.54e-07 * 0.92387953251128675613 / 2.384e-06, 1.06812e-04 * 0.92387953251128675613 / 2.384e-06, 6.74248e-04 * 0.92387953251128675613 / 2.384e-06, 3.3379e-05 * 0.92387953251128675613 / 2.384e-06, 3.4412861e-02 * 0.92387953251128675613 / 2.384e-06, 4.573822e-03 * 0.92387953251128675613 / 2.384e-06, 9.54151e-04 * 0.92387953251128675613 / 2.384e-06, 7.6771e-05 * 0.92387953251128675613 / 2.384e-06, 6.199e-06 * 0.92387953251128675613 / 2.384e-06, 3.4332e-05 * 0.92387953251128675613 / 2.384e-06, 1.111031e-03 * 0.92387953251128675613 / 2.384e-06, 1.0933399e-02 * 0.92387953251128675613 / 2.384e-06, -2.4725437e-02 * 0.92387953251128675613 / 2.384e-06, -3.771782e-03 * 0.92387953251128675613 / 2.384e-06, -4.72546e-04 * 0.92387953251128675613 / 2.384e-06, -2.7657e-05 * 0.92387953251128675613 / 2.384e-06, 4.1421356237309504879e-01, /* tan(PI/8) */
	  1.414213562373095e+00, -9.54e-07 * 0.941544065183021 / 2.384e-06, 1.05381e-04 * 0.941544065183021 / 2.384e-06, 6.10352e-04 * 0.941544065183021 / 2.384e-06, -4.75883e-04 * 0.941544065183021 / 2.384e-06, 3.4055710e-02 * 0.941544065183021 / 2.384e-06, 4.649162e-03 * 0.941544065183021 / 2.384e-06, 9.35555e-04 * 0.941544065183021 / 2.384e-06, 7.3433e-05 * 0.941544065183021 / 2.384e-06, /* 7 */
	  5.245e-06 * 0.941544065183021 / 2.384e-06, 1.7166e-05 * 0.941544065183021 / 2.384e-06, 9.56535e-04 * 0.941544065183021 / 2.384e-06, 1.0103703e-02 * 0.941544065183021 / 2.384e-06, -2.5527000e-02 * 0.941544065183021 / 2.384e-06, -3.914356e-03 * 0.941544065183021 / 2.384e-06, -5.07355e-04 * 0.941544065183021 / 2.384e-06, -3.0041e-05 * 0.941544065183021 / 2.384e-06, 3.578057213145241e-01, 1.546020906725474e+00, -9.54e-07 * 0.956940335732209 / 2.384e-06, 1.02520e-04 * 0.956940335732209 / 2.384e-06, 5.39303e-04 * 0.956940335732209 / 2.384e-06, -1.011848e-03 * 0.956940335732209 / 2.384e-06, 3.3659935e-02 * 0.956940335732209 / 2.384e-06, 4.703045e-03 * 0.956940335732209 / 2.384e-06, 9.15051e-04 * 0.956940335732209 / 2.384e-06, 7.0095e-05 * 0.956940335732209 / 2.384e-06, /* 6 */
	  4.768e-06 * 0.956940335732209 / 2.384e-06, 9.54e-07 * 0.956940335732209 / 2.384e-06, 8.06808e-04 * 0.956940335732209 / 2.384e-06, 9.287834e-03 * 0.956940335732209 / 2.384e-06, -2.6310921e-02 * 0.956940335732209 / 2.384e-06, -4.048824e-03 * 0.956940335732209 / 2.384e-06, -5.42164e-04 * 0.956940335732209 / 2.384e-06, -3.2425e-05 * 0.956940335732209 / 2.384e-06, 3.033466836073424e-01, 1.662939224605090e+00, -1.431e-06 * 0.970031253194544 / 2.384e-06, 9.9182e-05 * 0.970031253194544 / 2.384e-06, 4.62532e-04 * 0.970031253194544 / 2.384e-06, -1.573563e-03 * 0.970031253194544 / 2.384e-06, 3.3225536e-02 * 0.970031253194544 / 2.384e-06, 4.737377e-03 * 0.970031253194544 / 2.384e-06, 8.91685e-04 * 0.970031253194544 / 2.384e-06, 6.6280e-05 * 0.970031253194544 / 2.384e-06, /* 5 */
	  4.292e-06 * 0.970031253194544 / 2.384e-06, -1.3828e-05 * 0.970031253194544 / 2.384e-06, 6.61850e-04 * 0.970031253194544 / 2.384e-06, 8.487225e-03 * 0.970031253194544 / 2.384e-06, -2.7073860e-02 * 0.970031253194544 / 2.384e-06, -4.174709e-03 * 0.970031253194544 / 2.384e-06, -5.76973e-04 * 0.970031253194544 / 2.384e-06, -3.4809e-05 * 0.970031253194544 / 2.384e-06, 2.504869601913055e-01, 1.763842528696710e+00, -1.431e-06 * 0.98078528040323 / 2.384e-06, 9.5367e-05 * 0.98078528040323 / 2.384e-06, 3.78609e-04 * 0.98078528040323 / 2.384e-06, -2.161503e-03 * 0.98078528040323 / 2.384e-06, 3.2754898e-02 * 0.98078528040323 / 2.384e-06, 4.752159e-03 * 0.98078528040323 / 2.384e-06, 8.66413e-04 * 0.98078528040323 / 2.384e-06, 6.2943e-05 * 0.98078528040323 / 2.384e-06, /* 4 */
	  3.815e-06 * 0.98078528040323 / 2.384e-06, -2.718e-05 * 0.98078528040323 / 2.384e-06, 5.22137e-04 * 0.98078528040323 / 2.384e-06, 7.703304e-03 * 0.98078528040323 / 2.384e-06, -2.7815342e-02 * 0.98078528040323 / 2.384e-06, -4.290581e-03 * 0.98078528040323 / 2.384e-06, -6.11782e-04 * 0.98078528040323 / 2.384e-06, -3.7670e-05 * 0.98078528040323 / 2.384e-06, 1.989123673796580e-01, 1.847759065022573e+00, -1.907e-06 * 0.989176509964781 / 2.384e-06, 9.0122e-05 * 0.989176509964781 / 2.384e-06, 2.88486e-04 * 0.989176509964781 / 2.384e-06, -2.774239e-03 * 0.989176509964781 / 2.384e-06, 3.2248020e-02 * 0.989176509964781 / 2.384e-06, 4.748821e-03 * 0.989176509964781 / 2.384e-06, 8.38757e-04 * 0.989176509964781 / 2.384e-06, 5.9605e-05 * 0.989176509964781 / 2.384e-06, /* 3 */
	  3.338e-06 * 0.989176509964781 / 2.384e-06, -3.9577e-05 * 0.989176509964781 / 2.384e-06, 3.88145e-04 * 0.989176509964781 / 2.384e-06, 6.937027e-03 * 0.989176509964781 / 2.384e-06, -2.8532982e-02 * 0.989176509964781 / 2.384e-06, -4.395962e-03 * 0.989176509964781 / 2.384e-06, -6.46591e-04 * 0.989176509964781 / 2.384e-06, -4.0531e-05 * 0.989176509964781 / 2.384e-06, 1.483359875383474e-01, 1.913880671464418e+00, -1.907e-06 * 0.995184726672197 / 2.384e-06, 8.4400e-05 * 0.995184726672197 / 2.384e-06, 1.91689e-04 * 0.995184726672197 / 2.384e-06, -3.411293e-03 * 0.995184726672197 / 2.384e-06, 3.1706810e-02 * 0.995184726672197 / 2.384e-06, 4.728317e-03 * 0.995184726672197 / 2.384e-06, 8.09669e-04 * 0.995184726672197 / 2.384e-06, 5.579e-05 * 0.995184726672197 / 2.384e-06, 3.338e-06 * 0.995184726672197 / 2.384e-06, -5.0545e-05 * 0.995184726672197 / 2.384e-06, 2.59876e-04 * 0.995184726672197 / 2.384e-06, 6.189346e-03 * 0.995184726672197 / 2.384e-06, -2.9224873e-02 * 0.995184726672197 / 2.384e-06, -4.489899e-03 * 0.995184726672197 / 2.384e-06, -6.80923e-04 * 0.995184726672197 / 2.384e-06, -4.3392e-05 * 0.995184726672197 / 2.384e-06, 9.849140335716425e-02, 1.961570560806461e+00, -2.384e-06 * 0.998795456205172 / 2.384e-06, 7.7724e-05 * 0.998795456205172 / 2.384e-06, 8.8215e-05 * 0.998795456205172 / 2.384e-06, -4.072189e-03 * 0.998795456205172 / 2.384e-06, 3.1132698e-02 * 0.998795456205172 / 2.384e-06, 4.691124e-03 * 0.998795456205172 / 2.384e-06, 7.79152e-04 * 0.998795456205172 / 2.384e-06, 5.2929e-05 * 0.998795456205172 / 2.384e-06, 2.861e-06 * 0.998795456205172 / 2.384e-06, -6.0558e-05 * 0.998795456205172 / 2.384e-06, 1.37329e-04 * 0.998795456205172 / 2.384e-06, 5.462170e-03 * 0.998795456205172 / 2.384e-06, -2.9890060e-02 * 0.998795456205172 / 2.384e-06, -4.570484e-03 * 0.998795456205172 / 2.384e-06, -7.14302e-04 * 0.998795456205172 / 2.384e-06, -4.6253e-05 * 0.998795456205172 / 2.384e-06, 4.912684976946725e-02, 1.990369453344394e+00, 3.5780907e-02 * Util.SQRT2 * 0.5 / 2.384e-06, 1.7876148e-02 * Util.SQRT2 * 0.5 / 2.384e-06, 3.134727e-03 * Util.SQRT2 * 0.5 / 2.384e-06, 2.457142e-03 * Util.SQRT2 * 0.5 / 2.384e-06, 9.71317e-04 * Util.SQRT2 * 0.5 / 2.384e-06, 2.18868e-04 * Util.SQRT2 * 0.5 / 2.384e-06, 1.01566e-04 * Util.SQRT2 * 0.5 / 2.384e-06, 1.3828e-05 * Util.SQRT2 * 0.5 / 2.384e-06, 3.0526638e-02 / 2.384e-06, 4.638195e-03 / 2.384e-06, 7.47204e-04 / 2.384e-06, 4.9591e-05 / 2.384e-06, 4.756451e-03 / 2.384e-06, 2.1458e-05 / 2.384e-06, -6.9618e-05 / 2.384e-06 /* 2.384e-06/2.384e-06 */];
	  var NS = 12;
	  var NL = 36;
	  var win = [[2.382191739347913e-13, 6.423305872147834e-13, 9.400849094049688e-13, 1.122435026096556e-12, 1.183840321267481e-12, 1.122435026096556e-12, 9.400849094049690e-13, 6.423305872147839e-13, 2.382191739347918e-13, 5.456116108943412e-12, 4.878985199565852e-12, 4.240448995017367e-12, 3.559909094758252e-12, 2.858043359288075e-12, 2.156177623817898e-12, 1.475637723558783e-12, 8.371015190102974e-13, 2.599706096327376e-13, -5.456116108943412e-12, -4.878985199565852e-12, -4.240448995017367e-12, -3.559909094758252e-12, -2.858043359288076e-12, -2.156177623817898e-12, -1.475637723558783e-12, -8.371015190102975e-13, -2.599706096327376e-13, -2.382191739347923e-13, -6.423305872147843e-13, -9.400849094049696e-13, -1.122435026096556e-12, -1.183840321267481e-12, -1.122435026096556e-12, -9.400849094049694e-13, -6.423305872147840e-13, -2.382191739347918e-13], [2.382191739347913e-13, 6.423305872147834e-13, 9.400849094049688e-13, 1.122435026096556e-12, 1.183840321267481e-12, 1.122435026096556e-12, 9.400849094049688e-13, 6.423305872147841e-13, 2.382191739347918e-13, 5.456116108943413e-12, 4.878985199565852e-12, 4.240448995017367e-12, 3.559909094758253e-12, 2.858043359288075e-12, 2.156177623817898e-12, 1.475637723558782e-12, 8.371015190102975e-13, 2.599706096327376e-13, -5.461314069809755e-12, -4.921085770524055e-12, -4.343405037091838e-12, -3.732668368707687e-12, -3.093523840190885e-12, -2.430835727329465e-12, -1.734679010007751e-12, -9.748253656609281e-13, -2.797435120168326e-13, 0.000000000000000e+00, 0.000000000000000e+00, 0.000000000000000e+00, 0.000000000000000e+00, 0.000000000000000e+00, 0.000000000000000e+00, -2.283748241799531e-13, -4.037858874020686e-13, -2.146547464825323e-13], [1.316524975873958e-01, /* win[SHORT_TYPE] */
	  4.142135623730950e-01, 7.673269879789602e-01, 1.091308501069271e+00, /* tantab_l */
	  1.303225372841206e+00, 1.569685577117490e+00, 1.920982126971166e+00, 2.414213562373094e+00, 3.171594802363212e+00, 4.510708503662055e+00, 7.595754112725146e+00, 2.290376554843115e+01, 0.98480775301220802032, /* cx */
	  0.64278760968653936292, 0.34202014332566882393, 0.93969262078590842791, -0.17364817766693030343, -0.76604444311897790243, 0.86602540378443870761, 0.500000000000000e+00, -5.144957554275265e-01, /* ca */
	  -4.717319685649723e-01, -3.133774542039019e-01, -1.819131996109812e-01, -9.457419252642064e-02, -4.096558288530405e-02, -1.419856857247115e-02, -3.699974673760037e-03, 8.574929257125442e-01, /* cs */
	  8.817419973177052e-01, 9.496286491027329e-01, 9.833145924917901e-01, 9.955178160675857e-01, 9.991605581781475e-01, 9.998991952444470e-01, 9.999931550702802e-01], [0.000000000000000e+00, 0.000000000000000e+00, 0.000000000000000e+00, 0.000000000000000e+00, 0.000000000000000e+00, 0.000000000000000e+00, 2.283748241799531e-13, 4.037858874020686e-13, 2.146547464825323e-13, 5.461314069809755e-12, 4.921085770524055e-12, 4.343405037091838e-12, 3.732668368707687e-12, 3.093523840190885e-12, 2.430835727329466e-12, 1.734679010007751e-12, 9.748253656609281e-13, 2.797435120168326e-13, -5.456116108943413e-12, -4.878985199565852e-12, -4.240448995017367e-12, -3.559909094758253e-12, -2.858043359288075e-12, -2.156177623817898e-12, -1.475637723558782e-12, -8.371015190102975e-13, -2.599706096327376e-13, -2.382191739347913e-13, -6.423305872147834e-13, -9.400849094049688e-13, -1.122435026096556e-12, -1.183840321267481e-12, -1.122435026096556e-12, -9.400849094049688e-13, -6.423305872147841e-13, -2.382191739347918e-13]];
	  var tantab_l = win[Encoder.SHORT_TYPE];
	  var cx = win[Encoder.SHORT_TYPE];
	  var ca = win[Encoder.SHORT_TYPE];
	  var cs = win[Encoder.SHORT_TYPE];

	  /**
	   * new IDCT routine written by Takehiro TOMINAGA
	   *
	   * PURPOSE: Overlapping window on PCM samples<BR>
	   *
	   * SEMANTICS:<BR>
	   * 32 16-bit pcm samples are scaled to fractional 2's complement and
	   * concatenated to the end of the window buffer #x#. The updated window
	   * buffer #x# is then windowed by the analysis window #c# to produce the
	   * windowed sample #z#
	   */
	  var order = [0, 1, 16, 17, 8, 9, 24, 25, 4, 5, 20, 21, 12, 13, 28, 29, 2, 3, 18, 19, 10, 11, 26, 27, 6, 7, 22, 23, 14, 15, 30, 31];

	  /**
	   * returns sum_j=0^31 a[j]*cos(PI*j*(k+1/2)/32), 0<=k<32
	   */
	  function window_subband(x1, x1Pos, a) {
	    var wp = 10;
	    var x2 = x1Pos + 238 - 14 - 286;
	    for (var i = -15; i < 0; i++) {
	      var w, s, t;
	      w = enwindow[wp + -10];
	      s = x1[x2 + -224] * w;
	      t = x1[x1Pos + 224] * w;
	      w = enwindow[wp + -9];
	      s += x1[x2 + -160] * w;
	      t += x1[x1Pos + 160] * w;
	      w = enwindow[wp + -8];
	      s += x1[x2 + -96] * w;
	      t += x1[x1Pos + 96] * w;
	      w = enwindow[wp + -7];
	      s += x1[x2 + -32] * w;
	      t += x1[x1Pos + 32] * w;
	      w = enwindow[wp + -6];
	      s += x1[x2 + 32] * w;
	      t += x1[x1Pos + -32] * w;
	      w = enwindow[wp + -5];
	      s += x1[x2 + 96] * w;
	      t += x1[x1Pos + -96] * w;
	      w = enwindow[wp + -4];
	      s += x1[x2 + 160] * w;
	      t += x1[x1Pos + -160] * w;
	      w = enwindow[wp + -3];
	      s += x1[x2 + 224] * w;
	      t += x1[x1Pos + -224] * w;
	      w = enwindow[wp + -2];
	      s += x1[x1Pos + -256] * w;
	      t -= x1[x2 + 256] * w;
	      w = enwindow[wp + -1];
	      s += x1[x1Pos + -192] * w;
	      t -= x1[x2 + 192] * w;
	      w = enwindow[wp + 0];
	      s += x1[x1Pos + -128] * w;
	      t -= x1[x2 + 128] * w;
	      w = enwindow[wp + 1];
	      s += x1[x1Pos + -64] * w;
	      t -= x1[x2 + 64] * w;
	      w = enwindow[wp + 2];
	      s += x1[x1Pos + 0] * w;
	      t -= x1[x2 + 0] * w;
	      w = enwindow[wp + 3];
	      s += x1[x1Pos + 64] * w;
	      t -= x1[x2 + -64] * w;
	      w = enwindow[wp + 4];
	      s += x1[x1Pos + 128] * w;
	      t -= x1[x2 + -128] * w;
	      w = enwindow[wp + 5];
	      s += x1[x1Pos + 192] * w;
	      t -= x1[x2 + -192] * w;

	      /*
	       * this multiplyer could be removed, but it needs more 256 FLOAT
	       * data. thinking about the data cache performance, I think we
	       * should not use such a huge table. tt 2000/Oct/25
	       */
	      s *= enwindow[wp + 6];
	      w = t - s;
	      a[30 + i * 2] = t + s;
	      a[31 + i * 2] = enwindow[wp + 7] * w;
	      wp += 18;
	      x1Pos--;
	      x2++;
	    }
	    {
	      var s, t, u, v;
	      t = x1[x1Pos + -16] * enwindow[wp + -10];
	      s = x1[x1Pos + -32] * enwindow[wp + -2];
	      t += (x1[x1Pos + -48] - x1[x1Pos + 16]) * enwindow[wp + -9];
	      s += x1[x1Pos + -96] * enwindow[wp + -1];
	      t += (x1[x1Pos + -80] + x1[x1Pos + 48]) * enwindow[wp + -8];
	      s += x1[x1Pos + -160] * enwindow[wp + 0];
	      t += (x1[x1Pos + -112] - x1[x1Pos + 80]) * enwindow[wp + -7];
	      s += x1[x1Pos + -224] * enwindow[wp + 1];
	      t += (x1[x1Pos + -144] + x1[x1Pos + 112]) * enwindow[wp + -6];
	      s -= x1[x1Pos + 32] * enwindow[wp + 2];
	      t += (x1[x1Pos + -176] - x1[x1Pos + 144]) * enwindow[wp + -5];
	      s -= x1[x1Pos + 96] * enwindow[wp + 3];
	      t += (x1[x1Pos + -208] + x1[x1Pos + 176]) * enwindow[wp + -4];
	      s -= x1[x1Pos + 160] * enwindow[wp + 4];
	      t += (x1[x1Pos + -240] - x1[x1Pos + 208]) * enwindow[wp + -3];
	      s -= x1[x1Pos + 224];
	      u = s - t;
	      v = s + t;
	      t = a[14];
	      s = a[15] - t;
	      a[31] = v + t; /* A0 */
	      a[30] = u + s; /* A1 */
	      a[15] = u - s; /* A2 */
	      a[14] = v - t; /* A3 */
	    }
	    {
	      var xr;
	      xr = a[28] - a[0];
	      a[0] += a[28];
	      a[28] = xr * enwindow[wp + -2 * 18 + 7];
	      xr = a[29] - a[1];
	      a[1] += a[29];
	      a[29] = xr * enwindow[wp + -2 * 18 + 7];
	      xr = a[26] - a[2];
	      a[2] += a[26];
	      a[26] = xr * enwindow[wp + -4 * 18 + 7];
	      xr = a[27] - a[3];
	      a[3] += a[27];
	      a[27] = xr * enwindow[wp + -4 * 18 + 7];
	      xr = a[24] - a[4];
	      a[4] += a[24];
	      a[24] = xr * enwindow[wp + -6 * 18 + 7];
	      xr = a[25] - a[5];
	      a[5] += a[25];
	      a[25] = xr * enwindow[wp + -6 * 18 + 7];
	      xr = a[22] - a[6];
	      a[6] += a[22];
	      a[22] = xr * Util.SQRT2;
	      xr = a[23] - a[7];
	      a[7] += a[23];
	      a[23] = xr * Util.SQRT2 - a[7];
	      a[7] -= a[6];
	      a[22] -= a[7];
	      a[23] -= a[22];
	      xr = a[6];
	      a[6] = a[31] - xr;
	      a[31] = a[31] + xr;
	      xr = a[7];
	      a[7] = a[30] - xr;
	      a[30] = a[30] + xr;
	      xr = a[22];
	      a[22] = a[15] - xr;
	      a[15] = a[15] + xr;
	      xr = a[23];
	      a[23] = a[14] - xr;
	      a[14] = a[14] + xr;
	      xr = a[20] - a[8];
	      a[8] += a[20];
	      a[20] = xr * enwindow[wp + -10 * 18 + 7];
	      xr = a[21] - a[9];
	      a[9] += a[21];
	      a[21] = xr * enwindow[wp + -10 * 18 + 7];
	      xr = a[18] - a[10];
	      a[10] += a[18];
	      a[18] = xr * enwindow[wp + -12 * 18 + 7];
	      xr = a[19] - a[11];
	      a[11] += a[19];
	      a[19] = xr * enwindow[wp + -12 * 18 + 7];
	      xr = a[16] - a[12];
	      a[12] += a[16];
	      a[16] = xr * enwindow[wp + -14 * 18 + 7];
	      xr = a[17] - a[13];
	      a[13] += a[17];
	      a[17] = xr * enwindow[wp + -14 * 18 + 7];
	      xr = -a[20] + a[24];
	      a[20] += a[24];
	      a[24] = xr * enwindow[wp + -12 * 18 + 7];
	      xr = -a[21] + a[25];
	      a[21] += a[25];
	      a[25] = xr * enwindow[wp + -12 * 18 + 7];
	      xr = a[4] - a[8];
	      a[4] += a[8];
	      a[8] = xr * enwindow[wp + -12 * 18 + 7];
	      xr = a[5] - a[9];
	      a[5] += a[9];
	      a[9] = xr * enwindow[wp + -12 * 18 + 7];
	      xr = a[0] - a[12];
	      a[0] += a[12];
	      a[12] = xr * enwindow[wp + -4 * 18 + 7];
	      xr = a[1] - a[13];
	      a[1] += a[13];
	      a[13] = xr * enwindow[wp + -4 * 18 + 7];
	      xr = a[16] - a[28];
	      a[16] += a[28];
	      a[28] = xr * enwindow[wp + -4 * 18 + 7];
	      xr = -a[17] + a[29];
	      a[17] += a[29];
	      a[29] = xr * enwindow[wp + -4 * 18 + 7];
	      xr = Util.SQRT2 * (a[2] - a[10]);
	      a[2] += a[10];
	      a[10] = xr;
	      xr = Util.SQRT2 * (a[3] - a[11]);
	      a[3] += a[11];
	      a[11] = xr;
	      xr = Util.SQRT2 * (-a[18] + a[26]);
	      a[18] += a[26];
	      a[26] = xr - a[18];
	      xr = Util.SQRT2 * (-a[19] + a[27]);
	      a[19] += a[27];
	      a[27] = xr - a[19];
	      xr = a[2];
	      a[19] -= a[3];
	      a[3] -= xr;
	      a[2] = a[31] - xr;
	      a[31] += xr;
	      xr = a[3];
	      a[11] -= a[19];
	      a[18] -= xr;
	      a[3] = a[30] - xr;
	      a[30] += xr;
	      xr = a[18];
	      a[27] -= a[11];
	      a[19] -= xr;
	      a[18] = a[15] - xr;
	      a[15] += xr;
	      xr = a[19];
	      a[10] -= xr;
	      a[19] = a[14] - xr;
	      a[14] += xr;
	      xr = a[10];
	      a[11] -= xr;
	      a[10] = a[23] - xr;
	      a[23] += xr;
	      xr = a[11];
	      a[26] -= xr;
	      a[11] = a[22] - xr;
	      a[22] += xr;
	      xr = a[26];
	      a[27] -= xr;
	      a[26] = a[7] - xr;
	      a[7] += xr;
	      xr = a[27];
	      a[27] = a[6] - xr;
	      a[6] += xr;
	      xr = Util.SQRT2 * (a[0] - a[4]);
	      a[0] += a[4];
	      a[4] = xr;
	      xr = Util.SQRT2 * (a[1] - a[5]);
	      a[1] += a[5];
	      a[5] = xr;
	      xr = Util.SQRT2 * (a[16] - a[20]);
	      a[16] += a[20];
	      a[20] = xr;
	      xr = Util.SQRT2 * (a[17] - a[21]);
	      a[17] += a[21];
	      a[21] = xr;
	      xr = -Util.SQRT2 * (a[8] - a[12]);
	      a[8] += a[12];
	      a[12] = xr - a[8];
	      xr = -Util.SQRT2 * (a[9] - a[13]);
	      a[9] += a[13];
	      a[13] = xr - a[9];
	      xr = -Util.SQRT2 * (a[25] - a[29]);
	      a[25] += a[29];
	      a[29] = xr - a[25];
	      xr = -Util.SQRT2 * (a[24] + a[28]);
	      a[24] -= a[28];
	      a[28] = xr - a[24];
	      xr = a[24] - a[16];
	      a[24] = xr;
	      xr = a[20] - xr;
	      a[20] = xr;
	      xr = a[28] - xr;
	      a[28] = xr;
	      xr = a[25] - a[17];
	      a[25] = xr;
	      xr = a[21] - xr;
	      a[21] = xr;
	      xr = a[29] - xr;
	      a[29] = xr;
	      xr = a[17] - a[1];
	      a[17] = xr;
	      xr = a[9] - xr;
	      a[9] = xr;
	      xr = a[25] - xr;
	      a[25] = xr;
	      xr = a[5] - xr;
	      a[5] = xr;
	      xr = a[21] - xr;
	      a[21] = xr;
	      xr = a[13] - xr;
	      a[13] = xr;
	      xr = a[29] - xr;
	      a[29] = xr;
	      xr = a[1] - a[0];
	      a[1] = xr;
	      xr = a[16] - xr;
	      a[16] = xr;
	      xr = a[17] - xr;
	      a[17] = xr;
	      xr = a[8] - xr;
	      a[8] = xr;
	      xr = a[9] - xr;
	      a[9] = xr;
	      xr = a[24] - xr;
	      a[24] = xr;
	      xr = a[25] - xr;
	      a[25] = xr;
	      xr = a[4] - xr;
	      a[4] = xr;
	      xr = a[5] - xr;
	      a[5] = xr;
	      xr = a[20] - xr;
	      a[20] = xr;
	      xr = a[21] - xr;
	      a[21] = xr;
	      xr = a[12] - xr;
	      a[12] = xr;
	      xr = a[13] - xr;
	      a[13] = xr;
	      xr = a[28] - xr;
	      a[28] = xr;
	      xr = a[29] - xr;
	      a[29] = xr;
	      xr = a[0];
	      a[0] += a[31];
	      a[31] -= xr;
	      xr = a[1];
	      a[1] += a[30];
	      a[30] -= xr;
	      xr = a[16];
	      a[16] += a[15];
	      a[15] -= xr;
	      xr = a[17];
	      a[17] += a[14];
	      a[14] -= xr;
	      xr = a[8];
	      a[8] += a[23];
	      a[23] -= xr;
	      xr = a[9];
	      a[9] += a[22];
	      a[22] -= xr;
	      xr = a[24];
	      a[24] += a[7];
	      a[7] -= xr;
	      xr = a[25];
	      a[25] += a[6];
	      a[6] -= xr;
	      xr = a[4];
	      a[4] += a[27];
	      a[27] -= xr;
	      xr = a[5];
	      a[5] += a[26];
	      a[26] -= xr;
	      xr = a[20];
	      a[20] += a[11];
	      a[11] -= xr;
	      xr = a[21];
	      a[21] += a[10];
	      a[10] -= xr;
	      xr = a[12];
	      a[12] += a[19];
	      a[19] -= xr;
	      xr = a[13];
	      a[13] += a[18];
	      a[18] -= xr;
	      xr = a[28];
	      a[28] += a[3];
	      a[3] -= xr;
	      xr = a[29];
	      a[29] += a[2];
	      a[2] -= xr;
	    }
	  }

	  /**
	   * Function: Calculation of the MDCT In the case of long blocks (type 0,1,3)
	   * there are 36 coefficents in the time domain and 18 in the frequency
	   * domain.<BR>
	   * In the case of short blocks (type 2) there are 3 transformations with
	   * short length. This leads to 12 coefficents in the time and 6 in the
	   * frequency domain. In this case the results are stored side by side in the
	   * vector out[].
	   *
	   * New layer3
	   */
	  function mdct_short(inout, inoutPos) {
	    for (var l = 0; l < 3; l++) {
	      var tc0, tc1, tc2, ts0, ts1, ts2;
	      ts0 = inout[inoutPos + 2 * 3] * win[Encoder.SHORT_TYPE][0] - inout[inoutPos + 5 * 3];
	      tc0 = inout[inoutPos + 0 * 3] * win[Encoder.SHORT_TYPE][2] - inout[inoutPos + 3 * 3];
	      tc1 = ts0 + tc0;
	      tc2 = ts0 - tc0;
	      ts0 = inout[inoutPos + 5 * 3] * win[Encoder.SHORT_TYPE][0] + inout[inoutPos + 2 * 3];
	      tc0 = inout[inoutPos + 3 * 3] * win[Encoder.SHORT_TYPE][2] + inout[inoutPos + 0 * 3];
	      ts1 = ts0 + tc0;
	      ts2 = -ts0 + tc0;
	      tc0 = (inout[inoutPos + 1 * 3] * win[Encoder.SHORT_TYPE][1] - inout[inoutPos + 4 * 3]) * 2.069978111953089e-11;
	      /*
	       * tritab_s [ 1 ]
	       */
	      ts0 = (inout[inoutPos + 4 * 3] * win[Encoder.SHORT_TYPE][1] + inout[inoutPos + 1 * 3]) * 2.069978111953089e-11;
	      /*
	       * tritab_s [ 1 ]
	       */
	      inout[inoutPos + 3 * 0] = tc1 * 1.907525191737280e-11 + tc0;
	      /*
	       * tritab_s[ 2 ]
	       */
	      inout[inoutPos + 3 * 5] = -ts1 * 1.907525191737280e-11 + ts0;
	      /*
	       * tritab_s[0 ]
	       */
	      tc2 = tc2 * 0.86602540378443870761 * 1.907525191737281e-11;
	      /*
	       * tritab_s[ 2]
	       */
	      ts1 = ts1 * 0.5 * 1.907525191737281e-11 + ts0;
	      inout[inoutPos + 3 * 1] = tc2 - ts1;
	      inout[inoutPos + 3 * 2] = tc2 + ts1;
	      tc1 = tc1 * 0.5 * 1.907525191737281e-11 - tc0;
	      ts2 = ts2 * 0.86602540378443870761 * 1.907525191737281e-11;
	      /*
	       * tritab_s[ 0]
	       */
	      inout[inoutPos + 3 * 3] = tc1 + ts2;
	      inout[inoutPos + 3 * 4] = tc1 - ts2;
	      inoutPos++;
	    }
	  }
	  function mdct_long(out, outPos, _in) {
	    var ct, st;
	    {
	      var tc1, tc2, tc3, tc4, ts5, ts6, ts7, ts8;
	      /* 1,2, 5,6, 9,10, 13,14, 17 */
	      tc1 = _in[17] - _in[9];
	      tc3 = _in[15] - _in[11];
	      tc4 = _in[14] - _in[12];
	      ts5 = _in[0] + _in[8];
	      ts6 = _in[1] + _in[7];
	      ts7 = _in[2] + _in[6];
	      ts8 = _in[3] + _in[5];
	      out[outPos + 17] = ts5 + ts7 - ts8 - (ts6 - _in[4]);
	      st = (ts5 + ts7 - ts8) * cx[12 + 7] + (ts6 - _in[4]);
	      ct = (tc1 - tc3 - tc4) * cx[12 + 6];
	      out[outPos + 5] = ct + st;
	      out[outPos + 6] = ct - st;
	      tc2 = (_in[16] - _in[10]) * cx[12 + 6];
	      ts6 = ts6 * cx[12 + 7] + _in[4];
	      ct = tc1 * cx[12 + 0] + tc2 + tc3 * cx[12 + 1] + tc4 * cx[12 + 2];
	      st = -ts5 * cx[12 + 4] + ts6 - ts7 * cx[12 + 5] + ts8 * cx[12 + 3];
	      out[outPos + 1] = ct + st;
	      out[outPos + 2] = ct - st;
	      ct = tc1 * cx[12 + 1] - tc2 - tc3 * cx[12 + 2] + tc4 * cx[12 + 0];
	      st = -ts5 * cx[12 + 5] + ts6 - ts7 * cx[12 + 3] + ts8 * cx[12 + 4];
	      out[outPos + 9] = ct + st;
	      out[outPos + 10] = ct - st;
	      ct = tc1 * cx[12 + 2] - tc2 + tc3 * cx[12 + 0] - tc4 * cx[12 + 1];
	      st = ts5 * cx[12 + 3] - ts6 + ts7 * cx[12 + 4] - ts8 * cx[12 + 5];
	      out[outPos + 13] = ct + st;
	      out[outPos + 14] = ct - st;
	    }
	    {
	      var ts1, ts2, ts3, ts4, tc5, tc6, tc7, tc8;
	      ts1 = _in[8] - _in[0];
	      ts3 = _in[6] - _in[2];
	      ts4 = _in[5] - _in[3];
	      tc5 = _in[17] + _in[9];
	      tc6 = _in[16] + _in[10];
	      tc7 = _in[15] + _in[11];
	      tc8 = _in[14] + _in[12];
	      out[outPos + 0] = tc5 + tc7 + tc8 + (tc6 + _in[13]);
	      ct = (tc5 + tc7 + tc8) * cx[12 + 7] - (tc6 + _in[13]);
	      st = (ts1 - ts3 + ts4) * cx[12 + 6];
	      out[outPos + 11] = ct + st;
	      out[outPos + 12] = ct - st;
	      ts2 = (_in[7] - _in[1]) * cx[12 + 6];
	      tc6 = _in[13] - tc6 * cx[12 + 7];
	      ct = tc5 * cx[12 + 3] - tc6 + tc7 * cx[12 + 4] + tc8 * cx[12 + 5];
	      st = ts1 * cx[12 + 2] + ts2 + ts3 * cx[12 + 0] + ts4 * cx[12 + 1];
	      out[outPos + 3] = ct + st;
	      out[outPos + 4] = ct - st;
	      ct = -tc5 * cx[12 + 5] + tc6 - tc7 * cx[12 + 3] - tc8 * cx[12 + 4];
	      st = ts1 * cx[12 + 1] + ts2 - ts3 * cx[12 + 2] - ts4 * cx[12 + 0];
	      out[outPos + 7] = ct + st;
	      out[outPos + 8] = ct - st;
	      ct = -tc5 * cx[12 + 4] + tc6 - tc7 * cx[12 + 5] - tc8 * cx[12 + 3];
	      st = ts1 * cx[12 + 0] - ts2 + ts3 * cx[12 + 1] - ts4 * cx[12 + 2];
	      out[outPos + 15] = ct + st;
	      out[outPos + 16] = ct - st;
	    }
	  }
	  this.mdct_sub48 = function (gfc, w0, w1) {
	    var wk = w0;
	    var wkPos = 286;
	    /* thinking cache performance, ch->gr loop is better than gr->ch loop */
	    for (var ch = 0; ch < gfc.channels_out; ch++) {
	      for (var gr = 0; gr < gfc.mode_gr; gr++) {
	        var band;
	        var gi = gfc.l3_side.tt[gr][ch];
	        var mdct_enc = gi.xr;
	        var mdct_encPos = 0;
	        var samp = gfc.sb_sample[ch][1 - gr];
	        var sampPos = 0;
	        for (var k = 0; k < 18 / 2; k++) {
	          window_subband(wk, wkPos, samp[sampPos]);
	          window_subband(wk, wkPos + 32, samp[sampPos + 1]);
	          sampPos += 2;
	          wkPos += 64;
	          /*
	           * Compensate for inversion in the analysis filter
	           */
	          for (band = 1; band < 32; band += 2) {
	            samp[sampPos - 1][band] *= -1;
	          }
	        }

	        /*
	         * Perform imdct of 18 previous subband samples + 18 current
	         * subband samples
	         */
	        for (band = 0; band < 32; band++, mdct_encPos += 18) {
	          var type = gi.block_type;
	          var band0 = gfc.sb_sample[ch][gr];
	          var band1 = gfc.sb_sample[ch][1 - gr];
	          if (gi.mixed_block_flag != 0 && band < 2) type = 0;
	          if (gfc.amp_filter[band] < 1e-12) {
	            Arrays.fill(mdct_enc, mdct_encPos + 0, mdct_encPos + 18, 0);
	          } else {
	            if (gfc.amp_filter[band] < 1.0) {
	              for (var k = 0; k < 18; k++) band1[k][order[band]] *= gfc.amp_filter[band];
	            }
	            if (type == Encoder.SHORT_TYPE) {
	              for (var k = -NS / 4; k < 0; k++) {
	                var w = win[Encoder.SHORT_TYPE][k + 3];
	                mdct_enc[mdct_encPos + k * 3 + 9] = band0[9 + k][order[band]] * w - band0[8 - k][order[band]];
	                mdct_enc[mdct_encPos + k * 3 + 18] = band0[14 - k][order[band]] * w + band0[15 + k][order[band]];
	                mdct_enc[mdct_encPos + k * 3 + 10] = band0[15 + k][order[band]] * w - band0[14 - k][order[band]];
	                mdct_enc[mdct_encPos + k * 3 + 19] = band1[2 - k][order[band]] * w + band1[3 + k][order[band]];
	                mdct_enc[mdct_encPos + k * 3 + 11] = band1[3 + k][order[band]] * w - band1[2 - k][order[band]];
	                mdct_enc[mdct_encPos + k * 3 + 20] = band1[8 - k][order[band]] * w + band1[9 + k][order[band]];
	              }
	              mdct_short(mdct_enc, mdct_encPos);
	            } else {
	              var work = new_float(18);
	              for (var k = -NL / 4; k < 0; k++) {
	                var a, b;
	                a = win[type][k + 27] * band1[k + 9][order[band]] + win[type][k + 36] * band1[8 - k][order[band]];
	                b = win[type][k + 9] * band0[k + 9][order[band]] - win[type][k + 18] * band0[8 - k][order[band]];
	                work[k + 9] = a - b * tantab_l[3 + k + 9];
	                work[k + 18] = a * tantab_l[3 + k + 9] + b;
	              }
	              mdct_long(mdct_enc, mdct_encPos, work);
	            }
	          }
	          /*
	           * Perform aliasing reduction butterfly
	           */
	          if (type != Encoder.SHORT_TYPE && band != 0) {
	            for (var k = 7; k >= 0; --k) {
	              var bu, bd;
	              bu = mdct_enc[mdct_encPos + k] * ca[20 + k] + mdct_enc[mdct_encPos + -1 - k] * cs[28 + k];
	              bd = mdct_enc[mdct_encPos + k] * cs[28 + k] - mdct_enc[mdct_encPos + -1 - k] * ca[20 + k];
	              mdct_enc[mdct_encPos + -1 - k] = bu;
	              mdct_enc[mdct_encPos + k] = bd;
	            }
	          }
	        }
	      }
	      wk = w1;
	      wkPos = 286;
	      if (gfc.mode_gr == 1) {
	        for (var i = 0; i < 18; i++) {
	          System.arraycopy(gfc.sb_sample[ch][1][i], 0, gfc.sb_sample[ch][0][i], 0, 32);
	        }
	      }
	    }
	  };
	}
	NewMDCT_1 = NewMDCT;
	return NewMDCT_1;
}

var III_psy_xmin_1;
var hasRequiredIII_psy_xmin;

function requireIII_psy_xmin () {
	if (hasRequiredIII_psy_xmin) return III_psy_xmin_1;
	hasRequiredIII_psy_xmin = 1;
	var Encoder = requireEncoder();
	var common = common$b;
	var System = common.System;
	var new_float = common.new_float;
	var new_float_n = common.new_float_n;
	function III_psy_xmin() {
	  this.l = new_float(Encoder.SBMAX_l);
	  this.s = new_float_n([Encoder.SBMAX_s, 3]);
	  var self = this;
	  this.assign = function (iii_psy_xmin) {
	    System.arraycopy(iii_psy_xmin.l, 0, self.l, 0, Encoder.SBMAX_l);
	    for (var i = 0; i < Encoder.SBMAX_s; i++) {
	      for (var j = 0; j < 3; j++) {
	        self.s[i][j] = iii_psy_xmin.s[i][j];
	      }
	    }
	  };
	}
	III_psy_xmin_1 = III_psy_xmin;
	return III_psy_xmin_1;
}

var III_psy_ratio_1;
var hasRequiredIII_psy_ratio;

function requireIII_psy_ratio () {
	if (hasRequiredIII_psy_ratio) return III_psy_ratio_1;
	hasRequiredIII_psy_ratio = 1;
	//package mp3;

	var III_psy_xmin = requireIII_psy_xmin();
	function III_psy_ratio() {
	  this.thm = new III_psy_xmin();
	  this.en = new III_psy_xmin();
	}
	III_psy_ratio_1 = III_psy_ratio;
	return III_psy_ratio_1;
}

//package mp3;

/* MPEG modes */
function MPEGMode$1(ordinal) {
  var _ordinal = ordinal;
  this.ordinal = function () {
    return _ordinal;
  };
}
MPEGMode$1.STEREO = new MPEGMode$1(0);
MPEGMode$1.JOINT_STEREO = new MPEGMode$1(1);
MPEGMode$1.DUAL_CHANNEL = new MPEGMode$1(2);
MPEGMode$1.MONO = new MPEGMode$1(3);
MPEGMode$1.NOT_SET = new MPEGMode$1(4);
var MPEGMode_1 = MPEGMode$1;

var Encoder_1;
var hasRequiredEncoder;

function requireEncoder () {
	if (hasRequiredEncoder) return Encoder_1;
	hasRequiredEncoder = 1;
	var common = common$b;
	var System = common.System;
	var VbrMode = common.VbrMode;
	var new_array_n = common.new_array_n;
	var new_float = common.new_float;
	var new_float_n = common.new_float_n;
	var new_int = common.new_int;
	var assert = common.assert;

	/**
	 * ENCDELAY The encoder delay.
	 *
	 * Minimum allowed is MDCTDELAY (see below)
	 *
	 * The first 96 samples will be attenuated, so using a value less than 96
	 * will result in corrupt data for the first 96-ENCDELAY samples.
	 *
	 * suggested: 576 set to 1160 to sync with FhG.
	 */
	Encoder.ENCDELAY = 576;
	/**
	 * make sure there is at least one complete frame after the last frame
	 * containing real data
	 *
	 * Using a value of 288 would be sufficient for a a very sophisticated
	 * decoder that can decode granule-by-granule instead of frame by frame. But
	 * lets not assume this, and assume the decoder will not decode frame N
	 * unless it also has data for frame N+1
	 */
	Encoder.POSTDELAY = 1152;

	/**
	 * delay of the MDCT used in mdct.c original ISO routines had a delay of
	 * 528! Takehiro's routines:
	 */
	Encoder.MDCTDELAY = 48;
	Encoder.FFTOFFSET = 224 + Encoder.MDCTDELAY;

	/**
	 * Most decoders, including the one we use, have a delay of 528 samples.
	 */
	Encoder.DECDELAY = 528;

	/**
	 * number of subbands
	 */
	Encoder.SBLIMIT = 32;

	/**
	 * parition bands bands
	 */
	Encoder.CBANDS = 64;

	/**
	 * number of critical bands/scale factor bands where masking is computed
	 */
	Encoder.SBPSY_l = 21;
	Encoder.SBPSY_s = 12;

	/**
	 * total number of scalefactor bands encoded
	 */
	Encoder.SBMAX_l = 22;
	Encoder.SBMAX_s = 13;
	Encoder.PSFB21 = 6;
	Encoder.PSFB12 = 6;

	/**
	 * FFT sizes
	 */
	Encoder.BLKSIZE = 1024;
	Encoder.HBLKSIZE = Encoder.BLKSIZE / 2 + 1;
	Encoder.BLKSIZE_s = 256;
	Encoder.HBLKSIZE_s = Encoder.BLKSIZE_s / 2 + 1;
	Encoder.NORM_TYPE = 0;
	Encoder.START_TYPE = 1;
	Encoder.SHORT_TYPE = 2;
	Encoder.STOP_TYPE = 3;

	/**
	 * <PRE>
	 * Mode Extention:
	 * When we are in stereo mode, there are 4 possible methods to store these
	 * two channels. The stereo modes -m? are using a subset of them.
	 *
	 *  -ms: MPG_MD_LR_LR
	 *  -mj: MPG_MD_LR_LR and MPG_MD_MS_LR
	 *  -mf: MPG_MD_MS_LR
	 *  -mi: all
	 * </PRE>
	 */
	Encoder.MPG_MD_LR_LR = 0;
	Encoder.MPG_MD_LR_I = 1;
	Encoder.MPG_MD_MS_LR = 2;
	Encoder.MPG_MD_MS_I = 3;
	Encoder.fircoef = [-0.0207887 * 5, -0.0378413 * 5, -0.0432472 * 5, -0.031183 * 5, 7.79609e-18 * 5, 0.0467745 * 5, 0.10091 * 5, 0.151365 * 5, 0.187098 * 5];
	function Encoder() {
	  var NewMDCT = requireNewMDCT();
	  var III_psy_ratio = requireIII_psy_ratio();
	  var MPEGMode = MPEGMode_1;
	  var FFTOFFSET = Encoder.FFTOFFSET;
	  var MPG_MD_MS_LR = Encoder.MPG_MD_MS_LR;
	  //BitStream bs;
	  //PsyModel psy;
	  //VBRTag vbr;
	  //QuantizePVT qupvt;
	  var bs = null;
	  this.psy = null;
	  var psy = null;
	  var vbr = null;
	  var qupvt = null;

	  //public final void setModules(BitStream bs, PsyModel psy, QuantizePVT qupvt,
	  //    VBRTag vbr) {
	  this.setModules = function (_bs, _psy, _qupvt, _vbr) {
	    bs = _bs;
	    this.psy = _psy;
	    psy = _psy;
	    vbr = _vbr;
	    qupvt = _qupvt;
	  };
	  var newMDCT = new NewMDCT();

	  /***********************************************************************
	   *
	   * encoder and decoder delays
	   *
	   ***********************************************************************/

	  /**
	   * <PRE>
	   * layer III enc->dec delay:  1056 (1057?)   (observed)
	   * layer  II enc->dec delay:   480  (481?)   (observed)
	   *
	   * polyphase 256-16             (dec or enc)        = 240
	   * mdct      256+32  (9*32)     (dec or enc)        = 288
	   * total:    512+16
	   *
	   * My guess is that delay of polyphase filterbank is actualy 240.5
	   * (there are technical reasons for this, see postings in mp3encoder).
	   * So total Encode+Decode delay = ENCDELAY + 528 + 1
	   * </PRE>
	   */

	  /**
	   * auto-adjust of ATH, useful for low volume Gabriel Bouvigne 3 feb 2001
	   *
	   * modifies some values in gfp.internal_flags.ATH (gfc.ATH)
	   */
	  //private void adjust_ATH(final LameInternalFlags gfc) {
	  function adjust_ATH(gfc) {
	    var gr2_max, max_pow;
	    if (gfc.ATH.useAdjust == 0) {
	      gfc.ATH.adjust = 1.0;
	      /* no adjustment */
	      return;
	    }

	    /* jd - 2001 mar 12, 27, jun 30 */
	    /* loudness based on equal loudness curve; */
	    /* use granule with maximum combined loudness */
	    max_pow = gfc.loudness_sq[0][0];
	    gr2_max = gfc.loudness_sq[1][0];
	    if (gfc.channels_out == 2) {
	      max_pow += gfc.loudness_sq[0][1];
	      gr2_max += gfc.loudness_sq[1][1];
	    } else {
	      max_pow += max_pow;
	      gr2_max += gr2_max;
	    }
	    if (gfc.mode_gr == 2) {
	      max_pow = Math.max(max_pow, gr2_max);
	    }
	    max_pow *= 0.5;
	    /* max_pow approaches 1.0 for full band noise */

	    /* jd - 2001 mar 31, jun 30 */
	    /* user tuning of ATH adjustment region */
	    max_pow *= gfc.ATH.aaSensitivityP;

	    /*
	     * adjust ATH depending on range of maximum value
	     */

	    /* jd - 2001 feb27, mar12,20, jun30, jul22 */
	    /* continuous curves based on approximation */
	    /* to GB's original values. */
	    /* For an increase in approximate loudness, */
	    /* set ATH adjust to adjust_limit immediately */
	    /* after a delay of one frame. */
	    /* For a loudness decrease, reduce ATH adjust */
	    /* towards adjust_limit gradually. */
	    /* max_pow is a loudness squared or a power. */
	    if (max_pow > 0.03125) {
	      /* ((1 - 0.000625)/ 31.98) from curve below */
	      if (gfc.ATH.adjust >= 1.0) {
	        gfc.ATH.adjust = 1.0;
	      } else {
	        /* preceding frame has lower ATH adjust; */
	        /* ascend only to the preceding adjust_limit */
	        /* in case there is leading low volume */
	        if (gfc.ATH.adjust < gfc.ATH.adjustLimit) {
	          gfc.ATH.adjust = gfc.ATH.adjustLimit;
	        }
	      }
	      gfc.ATH.adjustLimit = 1.0;
	    } else {
	      /* adjustment curve */
	      /* about 32 dB maximum adjust (0.000625) */
	      var adj_lim_new = 31.98 * max_pow + 0.000625;
	      if (gfc.ATH.adjust >= adj_lim_new) {
	        /* descend gradually */
	        gfc.ATH.adjust *= adj_lim_new * 0.075 + 0.925;
	        if (gfc.ATH.adjust < adj_lim_new) {
	          /* stop descent */
	          gfc.ATH.adjust = adj_lim_new;
	        }
	      } else {
	        /* ascend */
	        if (gfc.ATH.adjustLimit >= adj_lim_new) {
	          gfc.ATH.adjust = adj_lim_new;
	        } else {
	          /* preceding frame has lower ATH adjust; */
	          /* ascend only to the preceding adjust_limit */
	          if (gfc.ATH.adjust < gfc.ATH.adjustLimit) {
	            gfc.ATH.adjust = gfc.ATH.adjustLimit;
	          }
	        }
	      }
	      gfc.ATH.adjustLimit = adj_lim_new;
	    }
	  }

	  /**
	   * <PRE>
	   *  some simple statistics
	   *
	   *  bitrate index 0: free bitrate . not allowed in VBR mode
	   *  : bitrates, kbps depending on MPEG version
	   *  bitrate index 15: forbidden
	   *
	   *  mode_ext:
	   *  0:  LR
	   *  1:  LR-i
	   *  2:  MS
	   *  3:  MS-i
	   * </PRE>
	   */
	  function updateStats(gfc) {
	    var gr, ch;
	    assert(0 <= gfc.bitrate_index && gfc.bitrate_index < 16);
	    assert(0 <= gfc.mode_ext && gfc.mode_ext < 4);

	    /* count bitrate indices */
	    gfc.bitrate_stereoMode_Hist[gfc.bitrate_index][4]++;
	    gfc.bitrate_stereoMode_Hist[15][4]++;

	    /* count 'em for every mode extension in case of 2 channel encoding */
	    if (gfc.channels_out == 2) {
	      gfc.bitrate_stereoMode_Hist[gfc.bitrate_index][gfc.mode_ext]++;
	      gfc.bitrate_stereoMode_Hist[15][gfc.mode_ext]++;
	    }
	    for (gr = 0; gr < gfc.mode_gr; ++gr) {
	      for (ch = 0; ch < gfc.channels_out; ++ch) {
	        var bt = gfc.l3_side.tt[gr][ch].block_type | 0;
	        if (gfc.l3_side.tt[gr][ch].mixed_block_flag != 0) bt = 4;
	        gfc.bitrate_blockType_Hist[gfc.bitrate_index][bt]++;
	        gfc.bitrate_blockType_Hist[gfc.bitrate_index][5]++;
	        gfc.bitrate_blockType_Hist[15][bt]++;
	        gfc.bitrate_blockType_Hist[15][5]++;
	      }
	    }
	  }
	  function lame_encode_frame_init(gfp, inbuf) {
	    var gfc = gfp.internal_flags;
	    var ch, gr;
	    if (gfc.lame_encode_frame_init == 0) {
	      /* prime the MDCT/polyphase filterbank with a short block */
	      var i, j;
	      var primebuff0 = new_float(286 + 1152 + 576);
	      var primebuff1 = new_float(286 + 1152 + 576);
	      gfc.lame_encode_frame_init = 1;
	      for (i = 0, j = 0; i < 286 + 576 * (1 + gfc.mode_gr); ++i) {
	        if (i < 576 * gfc.mode_gr) {
	          primebuff0[i] = 0;
	          if (gfc.channels_out == 2) primebuff1[i] = 0;
	        } else {
	          primebuff0[i] = inbuf[0][j];
	          if (gfc.channels_out == 2) primebuff1[i] = inbuf[1][j];
	          ++j;
	        }
	      }
	      /* polyphase filtering / mdct */
	      for (gr = 0; gr < gfc.mode_gr; gr++) {
	        for (ch = 0; ch < gfc.channels_out; ch++) {
	          gfc.l3_side.tt[gr][ch].block_type = Encoder.SHORT_TYPE;
	        }
	      }
	      newMDCT.mdct_sub48(gfc, primebuff0, primebuff1);

	      /* check FFT will not use a negative starting offset */
	      assert(576 >= Encoder.FFTOFFSET);
	      /* check if we have enough data for FFT */
	      assert(gfc.mf_size >= Encoder.BLKSIZE + gfp.framesize - Encoder.FFTOFFSET);
	      /* check if we have enough data for polyphase filterbank */
	      assert(gfc.mf_size >= 512 + gfp.framesize - 32);
	    }
	  }

	  /**
	   * <PRE>
	   * encodeframe()           Layer 3
	   *
	   * encode a single frame
	   *
	   *
	   *    lame_encode_frame()
	   *
	   *
	   *                           gr 0            gr 1
	   *    inbuf:           |--------------|--------------|--------------|
	   *
	   *
	   *    Polyphase (18 windows, each shifted 32)
	   *    gr 0:
	   *    window1          <----512---.
	   *    window18                 <----512---.
	   *
	   *    gr 1:
	   *    window1                         <----512---.
	   *    window18                                <----512---.
	   *
	   *
	   *
	   *    MDCT output:  |--------------|--------------|--------------|
	   *
	   *    FFT's                    <---------1024---------.
	   *                                             <---------1024-------.
	   *
	   *
	   *
	   *        inbuf = buffer of PCM data size=MP3 framesize
	   *        encoder acts on inbuf[ch][0], but output is delayed by MDCTDELAY
	   *        so the MDCT coefficints are from inbuf[ch][-MDCTDELAY]
	   *
	   *        psy-model FFT has a 1 granule delay, so we feed it data for the
	   *        next granule.
	   *        FFT is centered over granule:  224+576+224
	   *        So FFT starts at:   576-224-MDCTDELAY
	   *
	   *        MPEG2:  FFT ends at:  BLKSIZE+576-224-MDCTDELAY      (1328)
	   *        MPEG1:  FFT ends at:  BLKSIZE+2*576-224-MDCTDELAY    (1904)
	   *
	   *        MPEG2:  polyphase first window:  [0..511]
	   *                          18th window:   [544..1055]          (1056)
	   *        MPEG1:            36th window:   [1120..1631]         (1632)
	   *                data needed:  512+framesize-32
	   *
	   *        A close look newmdct.c shows that the polyphase filterbank
	   *        only uses data from [0..510] for each window.  Perhaps because the window
	   *        used by the filterbank is zero for the last point, so Takehiro's
	   *        code doesn't bother to compute with it.
	   *
	   *        FFT starts at 576-224-MDCTDELAY (304)  = 576-FFTOFFSET
	   *
	   * </PRE>
	   */

	  this.lame_encode_mp3_frame = function (gfp, inbuf_l, inbuf_r, mp3buf, mp3bufPos, mp3buf_size) {
	    var mp3count;
	    var masking_LR = new_array_n([2, 2]);
	    /*
	     * LR masking &
	     * energy
	     */
	    masking_LR[0][0] = new III_psy_ratio();
	    masking_LR[0][1] = new III_psy_ratio();
	    masking_LR[1][0] = new III_psy_ratio();
	    masking_LR[1][1] = new III_psy_ratio();
	    var masking_MS = new_array_n([2, 2]);
	    /* MS masking & energy */
	    masking_MS[0][0] = new III_psy_ratio();
	    masking_MS[0][1] = new III_psy_ratio();
	    masking_MS[1][0] = new III_psy_ratio();
	    masking_MS[1][1] = new III_psy_ratio();
	    //III_psy_ratio masking[][];
	    var masking;
	    /* pointer to selected maskings */
	    var inbuf = [null, null];
	    var gfc = gfp.internal_flags;
	    var tot_ener = new_float_n([2, 4]);
	    var ms_ener_ratio = [.5, .5];
	    var pe = [[0., 0.], [0., 0.]];
	    var pe_MS = [[0., 0.], [0., 0.]];

	    //float[][] pe_use;
	    var pe_use;
	    var ch, gr;
	    inbuf[0] = inbuf_l;
	    inbuf[1] = inbuf_r;
	    if (gfc.lame_encode_frame_init == 0) {
	      /* first run? */
	      lame_encode_frame_init(gfp, inbuf);
	    }

	    /********************** padding *****************************/
	    /**
	     * <PRE>
	     * padding method as described in
	     * "MPEG-Layer3 / Bitstream Syntax and Decoding"
	     * by Martin Sieler, Ralph Sperschneider
	     *
	     * note: there is no padding for the very first frame
	     *
	     * Robert Hegemann 2000-06-22
	     * </PRE>
	     */
	    gfc.padding = 0;
	    if ((gfc.slot_lag -= gfc.frac_SpF) < 0) {
	      gfc.slot_lag += gfp.out_samplerate;
	      gfc.padding = 1;
	    }

	    /****************************************
	     * Stage 1: psychoacoustic model *
	     ****************************************/

	    if (gfc.psymodel != 0) {
	      /*
	       * psychoacoustic model psy model has a 1 granule (576) delay that
	       * we must compensate for (mt 6/99).
	       */
	      var ret;
	      var bufp = [null, null];
	      /* address of beginning of left & right granule */
	      var bufpPos = 0;
	      /* address of beginning of left & right granule */
	      var blocktype = new_int(2);
	      for (gr = 0; gr < gfc.mode_gr; gr++) {
	        for (ch = 0; ch < gfc.channels_out; ch++) {
	          bufp[ch] = inbuf[ch];
	          bufpPos = 576 + gr * 576 - Encoder.FFTOFFSET;
	        }
	        if (gfp.VBR == VbrMode.vbr_mtrh || gfp.VBR == VbrMode.vbr_mt) {
	          ret = psy.L3psycho_anal_vbr(gfp, bufp, bufpPos, gr, masking_LR, masking_MS, pe[gr], pe_MS[gr], tot_ener[gr], blocktype);
	        } else {
	          ret = psy.L3psycho_anal_ns(gfp, bufp, bufpPos, gr, masking_LR, masking_MS, pe[gr], pe_MS[gr], tot_ener[gr], blocktype);
	        }
	        if (ret != 0) return -4;
	        if (gfp.mode == MPEGMode.JOINT_STEREO) {
	          ms_ener_ratio[gr] = tot_ener[gr][2] + tot_ener[gr][3];
	          if (ms_ener_ratio[gr] > 0) ms_ener_ratio[gr] = tot_ener[gr][3] / ms_ener_ratio[gr];
	        }

	        /* block type flags */
	        for (ch = 0; ch < gfc.channels_out; ch++) {
	          var cod_info = gfc.l3_side.tt[gr][ch];
	          cod_info.block_type = blocktype[ch];
	          cod_info.mixed_block_flag = 0;
	        }
	      }
	    } else {
	      /* no psy model */
	      for (gr = 0; gr < gfc.mode_gr; gr++) for (ch = 0; ch < gfc.channels_out; ch++) {
	        gfc.l3_side.tt[gr][ch].block_type = Encoder.NORM_TYPE;
	        gfc.l3_side.tt[gr][ch].mixed_block_flag = 0;
	        pe_MS[gr][ch] = pe[gr][ch] = 700;
	      }
	    }

	    /* auto-adjust of ATH, useful for low volume */
	    adjust_ATH(gfc);

	    /****************************************
	     * Stage 2: MDCT *
	     ****************************************/

	    /* polyphase filtering / mdct */
	    newMDCT.mdct_sub48(gfc, inbuf[0], inbuf[1]);

	    /****************************************
	     * Stage 3: MS/LR decision *
	     ****************************************/

	    /* Here will be selected MS or LR coding of the 2 stereo channels */
	    gfc.mode_ext = Encoder.MPG_MD_LR_LR;
	    if (gfp.force_ms) {
	      gfc.mode_ext = Encoder.MPG_MD_MS_LR;
	    } else if (gfp.mode == MPEGMode.JOINT_STEREO) {
	      /*
	       * ms_ratio = is scaled, for historical reasons, to look like a
	       * ratio of side_channel / total. 0 = signal is 100% mono .5 = L & R
	       * uncorrelated
	       */

	      /**
	       * <PRE>
	       * [0] and [1] are the results for the two granules in MPEG-1,
	       * in MPEG-2 it's only a faked averaging of the same value
	       * _prev is the value of the last granule of the previous frame
	       * _next is the value of the first granule of the next frame
	       * </PRE>
	       */

	      var sum_pe_MS = 0.;
	      var sum_pe_LR = 0.;
	      for (gr = 0; gr < gfc.mode_gr; gr++) {
	        for (ch = 0; ch < gfc.channels_out; ch++) {
	          sum_pe_MS += pe_MS[gr][ch];
	          sum_pe_LR += pe[gr][ch];
	        }
	      }

	      /* based on PE: M/S coding would not use much more bits than L/R */
	      if (sum_pe_MS <= 1.00 * sum_pe_LR) {
	        var gi0 = gfc.l3_side.tt[0];
	        var gi1 = gfc.l3_side.tt[gfc.mode_gr - 1];
	        if (gi0[0].block_type == gi0[1].block_type && gi1[0].block_type == gi1[1].block_type) {
	          gfc.mode_ext = Encoder.MPG_MD_MS_LR;
	        }
	      }
	    }

	    /* bit and noise allocation */
	    if (gfc.mode_ext == MPG_MD_MS_LR) {
	      masking = masking_MS;
	      /* use MS masking */
	      pe_use = pe_MS;
	    } else {
	      masking = masking_LR;
	      /* use LR masking */
	      pe_use = pe;
	    }

	    /* copy data for MP3 frame analyzer */
	    if (gfp.analysis && gfc.pinfo != null) {
	      for (gr = 0; gr < gfc.mode_gr; gr++) {
	        for (ch = 0; ch < gfc.channels_out; ch++) {
	          gfc.pinfo.ms_ratio[gr] = gfc.ms_ratio[gr];
	          gfc.pinfo.ms_ener_ratio[gr] = ms_ener_ratio[gr];
	          gfc.pinfo.blocktype[gr][ch] = gfc.l3_side.tt[gr][ch].block_type;
	          gfc.pinfo.pe[gr][ch] = pe_use[gr][ch];
	          System.arraycopy(gfc.l3_side.tt[gr][ch].xr, 0, gfc.pinfo.xr[gr][ch], 0, 576);
	          /*
	           * in psymodel, LR and MS data was stored in pinfo. switch
	           * to MS data:
	           */
	          if (gfc.mode_ext == MPG_MD_MS_LR) {
	            gfc.pinfo.ers[gr][ch] = gfc.pinfo.ers[gr][ch + 2];
	            System.arraycopy(gfc.pinfo.energy[gr][ch + 2], 0, gfc.pinfo.energy[gr][ch], 0, gfc.pinfo.energy[gr][ch].length);
	          }
	        }
	      }
	    }

	    /****************************************
	     * Stage 4: quantization loop *
	     ****************************************/

	    if (gfp.VBR == VbrMode.vbr_off || gfp.VBR == VbrMode.vbr_abr) {
	      var i;
	      var f;
	      for (i = 0; i < 18; i++) gfc.nsPsy.pefirbuf[i] = gfc.nsPsy.pefirbuf[i + 1];
	      f = 0.0;
	      for (gr = 0; gr < gfc.mode_gr; gr++) for (ch = 0; ch < gfc.channels_out; ch++) f += pe_use[gr][ch];
	      gfc.nsPsy.pefirbuf[18] = f;
	      f = gfc.nsPsy.pefirbuf[9];
	      for (i = 0; i < 9; i++) f += (gfc.nsPsy.pefirbuf[i] + gfc.nsPsy.pefirbuf[18 - i]) * Encoder.fircoef[i];
	      f = 670 * 5 * gfc.mode_gr * gfc.channels_out / f;
	      for (gr = 0; gr < gfc.mode_gr; gr++) {
	        for (ch = 0; ch < gfc.channels_out; ch++) {
	          pe_use[gr][ch] *= f;
	        }
	      }
	    }
	    gfc.iteration_loop.iteration_loop(gfp, pe_use, ms_ener_ratio, masking);

	    /****************************************
	     * Stage 5: bitstream formatting *
	     ****************************************/

	    /* write the frame to the bitstream */
	    bs.format_bitstream(gfp);

	    /* copy mp3 bit buffer into array */
	    mp3count = bs.copy_buffer(gfc, mp3buf, mp3bufPos, mp3buf_size, 1);
	    if (gfp.bWriteVbrTag) vbr.addVbrFrame(gfp);
	    if (gfp.analysis && gfc.pinfo != null) {
	      for (ch = 0; ch < gfc.channels_out; ch++) {
	        var j;
	        for (j = 0; j < FFTOFFSET; j++) gfc.pinfo.pcmdata[ch][j] = gfc.pinfo.pcmdata[ch][j + gfp.framesize];
	        for (j = FFTOFFSET; j < 1600; j++) {
	          gfc.pinfo.pcmdata[ch][j] = inbuf[ch][j - FFTOFFSET];
	        }
	      }
	      qupvt.set_frame_pinfo(gfp, masking);
	    }
	    updateStats(gfc);
	    return mp3count;
	  };
	}
	Encoder_1 = Encoder;
	return Encoder_1;
}

var common$a = common$b;
var Util$1 = common$a.Util;
var new_float$7 = common$a.new_float;
var Encoder$7 = requireEncoder();
function FFT$1() {
  var window = new_float$7(Encoder$7.BLKSIZE);
  var window_s = new_float$7(Encoder$7.BLKSIZE_s / 2);
  var costab = [9.238795325112867e-01, 3.826834323650898e-01, 9.951847266721969e-01, 9.801714032956060e-02, 9.996988186962042e-01, 2.454122852291229e-02, 9.999811752826011e-01, 6.135884649154475e-03];
  function fht(fz, fzPos, n) {
    var tri = 0;
    var k4;
    var fi;
    var gi;
    n <<= 1;
    /* to get BLKSIZE, because of 3DNow! ASM routine */
    var fn = fzPos + n;
    k4 = 4;
    do {
      var s1, c1;
      var i, k1, k2, k3, kx;
      kx = k4 >> 1;
      k1 = k4;
      k2 = k4 << 1;
      k3 = k2 + k1;
      k4 = k2 << 1;
      fi = fzPos;
      gi = fi + kx;
      do {
        var f0, f1, f2, f3;
        f1 = fz[fi + 0] - fz[fi + k1];
        f0 = fz[fi + 0] + fz[fi + k1];
        f3 = fz[fi + k2] - fz[fi + k3];
        f2 = fz[fi + k2] + fz[fi + k3];
        fz[fi + k2] = f0 - f2;
        fz[fi + 0] = f0 + f2;
        fz[fi + k3] = f1 - f3;
        fz[fi + k1] = f1 + f3;
        f1 = fz[gi + 0] - fz[gi + k1];
        f0 = fz[gi + 0] + fz[gi + k1];
        f3 = Util$1.SQRT2 * fz[gi + k3];
        f2 = Util$1.SQRT2 * fz[gi + k2];
        fz[gi + k2] = f0 - f2;
        fz[gi + 0] = f0 + f2;
        fz[gi + k3] = f1 - f3;
        fz[gi + k1] = f1 + f3;
        gi += k4;
        fi += k4;
      } while (fi < fn);
      c1 = costab[tri + 0];
      s1 = costab[tri + 1];
      for (i = 1; i < kx; i++) {
        var c2, s2;
        c2 = 1 - 2 * s1 * s1;
        s2 = 2 * s1 * c1;
        fi = fzPos + i;
        gi = fzPos + k1 - i;
        do {
          var a, b, g0, f0, f1, g1, f2, g2, f3, g3;
          b = s2 * fz[fi + k1] - c2 * fz[gi + k1];
          a = c2 * fz[fi + k1] + s2 * fz[gi + k1];
          f1 = fz[fi + 0] - a;
          f0 = fz[fi + 0] + a;
          g1 = fz[gi + 0] - b;
          g0 = fz[gi + 0] + b;
          b = s2 * fz[fi + k3] - c2 * fz[gi + k3];
          a = c2 * fz[fi + k3] + s2 * fz[gi + k3];
          f3 = fz[fi + k2] - a;
          f2 = fz[fi + k2] + a;
          g3 = fz[gi + k2] - b;
          g2 = fz[gi + k2] + b;
          b = s1 * f2 - c1 * g3;
          a = c1 * f2 + s1 * g3;
          fz[fi + k2] = f0 - a;
          fz[fi + 0] = f0 + a;
          fz[gi + k3] = g1 - b;
          fz[gi + k1] = g1 + b;
          b = c1 * g2 - s1 * f3;
          a = s1 * g2 + c1 * f3;
          fz[gi + k2] = g0 - a;
          fz[gi + 0] = g0 + a;
          fz[fi + k3] = f1 - b;
          fz[fi + k1] = f1 + b;
          gi += k4;
          fi += k4;
        } while (fi < fn);
        c2 = c1;
        c1 = c2 * costab[tri + 0] - s1 * costab[tri + 1];
        s1 = c2 * costab[tri + 1] + s1 * costab[tri + 0];
      }
      tri += 2;
    } while (k4 < n);
  }
  var rv_tbl = [0x00, 0x80, 0x40, 0xc0, 0x20, 0xa0, 0x60, 0xe0, 0x10, 0x90, 0x50, 0xd0, 0x30, 0xb0, 0x70, 0xf0, 0x08, 0x88, 0x48, 0xc8, 0x28, 0xa8, 0x68, 0xe8, 0x18, 0x98, 0x58, 0xd8, 0x38, 0xb8, 0x78, 0xf8, 0x04, 0x84, 0x44, 0xc4, 0x24, 0xa4, 0x64, 0xe4, 0x14, 0x94, 0x54, 0xd4, 0x34, 0xb4, 0x74, 0xf4, 0x0c, 0x8c, 0x4c, 0xcc, 0x2c, 0xac, 0x6c, 0xec, 0x1c, 0x9c, 0x5c, 0xdc, 0x3c, 0xbc, 0x7c, 0xfc, 0x02, 0x82, 0x42, 0xc2, 0x22, 0xa2, 0x62, 0xe2, 0x12, 0x92, 0x52, 0xd2, 0x32, 0xb2, 0x72, 0xf2, 0x0a, 0x8a, 0x4a, 0xca, 0x2a, 0xaa, 0x6a, 0xea, 0x1a, 0x9a, 0x5a, 0xda, 0x3a, 0xba, 0x7a, 0xfa, 0x06, 0x86, 0x46, 0xc6, 0x26, 0xa6, 0x66, 0xe6, 0x16, 0x96, 0x56, 0xd6, 0x36, 0xb6, 0x76, 0xf6, 0x0e, 0x8e, 0x4e, 0xce, 0x2e, 0xae, 0x6e, 0xee, 0x1e, 0x9e, 0x5e, 0xde, 0x3e, 0xbe, 0x7e, 0xfe];
  this.fft_short = function (gfc, x_real, chn, buffer, bufPos) {
    for (var b = 0; b < 3; b++) {
      var x = Encoder$7.BLKSIZE_s / 2;
      var k = 0xffff & 576 / 3 * (b + 1);
      var j = Encoder$7.BLKSIZE_s / 8 - 1;
      do {
        var f0, f1, f2, f3, w;
        var i = rv_tbl[j << 2] & 0xff;
        f0 = window_s[i] * buffer[chn][bufPos + i + k];
        w = window_s[0x7f - i] * buffer[chn][bufPos + i + k + 0x80];
        f1 = f0 - w;
        f0 = f0 + w;
        f2 = window_s[i + 0x40] * buffer[chn][bufPos + i + k + 0x40];
        w = window_s[0x3f - i] * buffer[chn][bufPos + i + k + 0xc0];
        f3 = f2 - w;
        f2 = f2 + w;
        x -= 4;
        x_real[b][x + 0] = f0 + f2;
        x_real[b][x + 2] = f0 - f2;
        x_real[b][x + 1] = f1 + f3;
        x_real[b][x + 3] = f1 - f3;
        f0 = window_s[i + 0x01] * buffer[chn][bufPos + i + k + 0x01];
        w = window_s[0x7e - i] * buffer[chn][bufPos + i + k + 0x81];
        f1 = f0 - w;
        f0 = f0 + w;
        f2 = window_s[i + 0x41] * buffer[chn][bufPos + i + k + 0x41];
        w = window_s[0x3e - i] * buffer[chn][bufPos + i + k + 0xc1];
        f3 = f2 - w;
        f2 = f2 + w;
        x_real[b][x + Encoder$7.BLKSIZE_s / 2 + 0] = f0 + f2;
        x_real[b][x + Encoder$7.BLKSIZE_s / 2 + 2] = f0 - f2;
        x_real[b][x + Encoder$7.BLKSIZE_s / 2 + 1] = f1 + f3;
        x_real[b][x + Encoder$7.BLKSIZE_s / 2 + 3] = f1 - f3;
      } while (--j >= 0);
      fht(x_real[b], x, Encoder$7.BLKSIZE_s / 2);
      /* BLKSIZE_s/2 because of 3DNow! ASM routine */
      /* BLKSIZE/2 because of 3DNow! ASM routine */
    }
  };
  this.fft_long = function (gfc, y, chn, buffer, bufPos) {
    var jj = Encoder$7.BLKSIZE / 8 - 1;
    var x = Encoder$7.BLKSIZE / 2;
    do {
      var f0, f1, f2, f3, w;
      var i = rv_tbl[jj] & 0xff;
      f0 = window[i] * buffer[chn][bufPos + i];
      w = window[i + 0x200] * buffer[chn][bufPos + i + 0x200];
      f1 = f0 - w;
      f0 = f0 + w;
      f2 = window[i + 0x100] * buffer[chn][bufPos + i + 0x100];
      w = window[i + 0x300] * buffer[chn][bufPos + i + 0x300];
      f3 = f2 - w;
      f2 = f2 + w;
      x -= 4;
      y[x + 0] = f0 + f2;
      y[x + 2] = f0 - f2;
      y[x + 1] = f1 + f3;
      y[x + 3] = f1 - f3;
      f0 = window[i + 0x001] * buffer[chn][bufPos + i + 0x001];
      w = window[i + 0x201] * buffer[chn][bufPos + i + 0x201];
      f1 = f0 - w;
      f0 = f0 + w;
      f2 = window[i + 0x101] * buffer[chn][bufPos + i + 0x101];
      w = window[i + 0x301] * buffer[chn][bufPos + i + 0x301];
      f3 = f2 - w;
      f2 = f2 + w;
      y[x + Encoder$7.BLKSIZE / 2 + 0] = f0 + f2;
      y[x + Encoder$7.BLKSIZE / 2 + 2] = f0 - f2;
      y[x + Encoder$7.BLKSIZE / 2 + 1] = f1 + f3;
      y[x + Encoder$7.BLKSIZE / 2 + 3] = f1 - f3;
    } while (--jj >= 0);
    fht(y, x, Encoder$7.BLKSIZE / 2);
    /* BLKSIZE/2 because of 3DNow! ASM routine */
  };
  this.init_fft = function (gfc) {
    /* The type of window used here will make no real difference, but */
    /*
     * in the interest of merging nspsytune stuff - switch to blackman
     * window
     */
    for (var i = 0; i < Encoder$7.BLKSIZE; i++) /* blackman window */
    window[i] = 0.42 - 0.5 * Math.cos(2 * Math.PI * (i + .5) / Encoder$7.BLKSIZE) + 0.08 * Math.cos(4 * Math.PI * (i + .5) / Encoder$7.BLKSIZE);
    for (var i = 0; i < Encoder$7.BLKSIZE_s / 2; i++) window_s[i] = 0.5 * (1.0 - Math.cos(2.0 * Math.PI * (i + 0.5) / Encoder$7.BLKSIZE_s));
  };
}
var FFT_1 = FFT$1;

/*
 *      psymodel.c
 *
 *      Copyright (c) 1999-2000 Mark Taylor
 *      Copyright (c) 2001-2002 Naoki Shibata
 *      Copyright (c) 2000-2003 Takehiro Tominaga
 *      Copyright (c) 2000-2008 Robert Hegemann
 *      Copyright (c) 2000-2005 Gabriel Bouvigne
 *      Copyright (c) 2000-2005 Alexander Leidinger
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Library General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public
 * License along with this library; if not, write to the
 * Free Software Foundation, Inc., 59 Temple Place - Suite 330,
 * Boston, MA 02111-1307, USA.
 */

/* $Id: PsyModel.java,v 1.27 2011/05/24 20:48:06 kenchis Exp $ */

/*
 PSYCHO ACOUSTICS


 This routine computes the psycho acoustics, delayed by one granule.

 Input: buffer of PCM data (1024 samples).

 This window should be centered over the 576 sample granule window.
 The routine will compute the psycho acoustics for
 this granule, but return the psycho acoustics computed
 for the *previous* granule.  This is because the block
 type of the previous granule can only be determined
 after we have computed the psycho acoustics for the following
 granule.

 Output:  maskings and energies for each scalefactor band.
 block type, PE, and some correlation measures.
 The PE is used by CBR modes to determine if extra bits
 from the bit reservoir should be used.  The correlation
 measures are used to determine mid/side or regular stereo.
 */
/*
 Notation:

 barks:  a non-linear frequency scale.  Mapping from frequency to
 barks is given by freq2bark()

 scalefactor bands: The spectrum (frequencies) are broken into
 SBMAX "scalefactor bands".  Thes bands
 are determined by the MPEG ISO spec.  In
 the noise shaping/quantization code, we allocate
 bits among the partition bands to achieve the
 best possible quality

 partition bands:   The spectrum is also broken into about
 64 "partition bands".  Each partition
 band is about .34 barks wide.  There are about 2-5
 partition bands for each scalefactor band.

 LAME computes all psycho acoustic information for each partition
 band.  Then at the end of the computations, this information
 is mapped to scalefactor bands.  The energy in each scalefactor
 band is taken as the sum of the energy in all partition bands
 which overlap the scalefactor band.  The maskings can be computed
 in the same way (and thus represent the average masking in that band)
 or by taking the minmum value multiplied by the number of
 partition bands used (which represents a minimum masking in that band).
 */
/*
 The general outline is as follows:

 1. compute the energy in each partition band
 2. compute the tonality in each partition band
 3. compute the strength of each partion band "masker"
 4. compute the masking (via the spreading function applied to each masker)
 5. Modifications for mid/side masking.

 Each partition band is considiered a "masker".  The strength
 of the i'th masker in band j is given by:

 s3(bark(i)-bark(j))*strength(i)

 The strength of the masker is a function of the energy and tonality.
 The more tonal, the less masking.  LAME uses a simple linear formula
 (controlled by NMT and TMN) which says the strength is given by the
 energy divided by a linear function of the tonality.
 */
/*
 s3() is the "spreading function".  It is given by a formula
 determined via listening tests.

 The total masking in the j'th partition band is the sum over
 all maskings i.  It is thus given by the convolution of
 the strength with s3(), the "spreading function."

 masking(j) = sum_over_i  s3(i-j)*strength(i)  = s3 o strength

 where "o" = convolution operator.  s3 is given by a formula determined
 via listening tests.  It is normalized so that s3 o 1 = 1.

 Note: instead of a simple convolution, LAME also has the
 option of using "additive masking"

 The most critical part is step 2, computing the tonality of each
 partition band.  LAME has two tonality estimators.  The first
 is based on the ISO spec, and measures how predictiable the
 signal is over time.  The more predictable, the more tonal.
 The second measure is based on looking at the spectrum of
 a single granule.  The more peaky the spectrum, the more
 tonal.  By most indications, the latter approach is better.

 Finally, in step 5, the maskings for the mid and side
 channel are possibly increased.  Under certain circumstances,
 noise in the mid & side channels is assumed to also
 be masked by strong maskers in the L or R channels.


 Other data computed by the psy-model:

 ms_ratio        side-channel / mid-channel masking ratio (for previous granule)
 ms_ratio_next   side-channel / mid-channel masking ratio for this granule

 percep_entropy[2]     L and R values (prev granule) of PE - A measure of how
 much pre-echo is in the previous granule
 percep_entropy_MS[2]  mid and side channel values (prev granule) of percep_entropy
 energy[4]             L,R,M,S energy in each channel, prev granule
 blocktype_d[2]        block type to use for previous granule
 */
//package mp3;

//import java.util.Arrays;
var common$9 = common$b;
var VbrMode = common$9.VbrMode;
var Float = common$9.Float;
var ShortBlock = common$9.ShortBlock;
var Util = common$9.Util;
var Arrays$1 = common$9.Arrays;
var new_float$6 = common$9.new_float;
var new_float_n$2 = common$9.new_float_n;
var new_int$7 = common$9.new_int;
var assert$1 = common$9.assert;
var FFT = FFT_1;
var Encoder$6 = requireEncoder();
function PsyModel() {
  var MPEGMode = MPEGMode_1;
  var fft = new FFT();
  var LOG10 = 2.30258509299404568402;
  var rpelev = 2;
  var rpelev2 = 16;
  var rpelev_s = 2;
  var rpelev2_s = 16;

  /* size of each partition band, in barks: */
  var DELBARK = .34;

  /* tuned for output level (sensitive to energy scale) */
  var VO_SCALE = 1. / (14752 * 14752) / (Encoder$6.BLKSIZE / 2);
  var temporalmask_sustain_sec = 0.01;
  var NS_PREECHO_ATT0 = 0.8;
  var NS_PREECHO_ATT1 = 0.6;
  var NS_PREECHO_ATT2 = 0.3;
  var NS_MSFIX = 3.5;
  var NSFIRLEN = 21;

  /* size of each partition band, in barks: */
  var LN_TO_LOG10 = 0.2302585093;
  function NON_LINEAR_SCALE_ENERGY(x) {
    return x;
  }

  /**
   * <PRE>
   *       L3psycho_anal.  Compute psycho acoustics.
   *
   *       Data returned to the calling program must be delayed by one
   *       granule.
   *
   *       This is done in two places.
   *       If we do not need to know the blocktype, the copying
   *       can be done here at the top of the program: we copy the data for
   *       the last granule (computed during the last call) before it is
   *       overwritten with the new data.  It looks like this:
   *
   *       0. static psymodel_data
   *       1. calling_program_data = psymodel_data
   *       2. compute psymodel_data
   *
   *       For data which needs to know the blocktype, the copying must be
   *       done at the end of this loop, and the old values must be saved:
   *
   *       0. static psymodel_data_old
   *       1. compute psymodel_data
   *       2. compute possible block type of this granule
   *       3. compute final block type of previous granule based on #2.
   *       4. calling_program_data = psymodel_data_old
   *       5. psymodel_data_old = psymodel_data
   *     psycho_loudness_approx
   *       jd - 2001 mar 12
   *    in:  energy   - BLKSIZE/2 elements of frequency magnitudes ^ 2
   *         gfp      - uses out_samplerate, ATHtype (also needed for ATHformula)
   *    returns: loudness^2 approximation, a positive value roughly tuned for a value
   *             of 1.0 for signals near clipping.
   *    notes:   When calibrated, feeding this function binary white noise at sample
   *             values +32767 or -32768 should return values that approach 3.
   *             ATHformula is used to approximate an equal loudness curve.
   *    future:  Data indicates that the shape of the equal loudness curve varies
   *             with intensity.  This function might be improved by using an equal
   *             loudness curve shaped for typical playback levels (instead of the
   *             ATH, that is shaped for the threshold).  A flexible realization might
   *             simply bend the existing ATH curve to achieve the desired shape.
   *             However, the potential gain may not be enough to justify an effort.
   * </PRE>
   */
  function psycho_loudness_approx(energy, gfc) {
    var loudness_power = 0.0;
    /* apply weights to power in freq. bands */
    for (var i = 0; i < Encoder$6.BLKSIZE / 2; ++i) loudness_power += energy[i] * gfc.ATH.eql_w[i];
    loudness_power *= VO_SCALE;
    return loudness_power;
  }
  function compute_ffts(gfp, fftenergy, fftenergy_s, wsamp_l, wsamp_lPos, wsamp_s, wsamp_sPos, gr_out, chn, buffer, bufPos) {
    var gfc = gfp.internal_flags;
    if (chn < 2) {
      fft.fft_long(gfc, wsamp_l[wsamp_lPos], chn, buffer, bufPos);
      fft.fft_short(gfc, wsamp_s[wsamp_sPos], chn, buffer, bufPos);
    }
    /* FFT data for mid and side channel is derived from L & R */else if (chn == 2) {
      for (var j = Encoder$6.BLKSIZE - 1; j >= 0; --j) {
        var l = wsamp_l[wsamp_lPos + 0][j];
        var r = wsamp_l[wsamp_lPos + 1][j];
        wsamp_l[wsamp_lPos + 0][j] = (l + r) * Util.SQRT2 * 0.5;
        wsamp_l[wsamp_lPos + 1][j] = (l - r) * Util.SQRT2 * 0.5;
      }
      for (var b = 2; b >= 0; --b) {
        for (var j = Encoder$6.BLKSIZE_s - 1; j >= 0; --j) {
          var l = wsamp_s[wsamp_sPos + 0][b][j];
          var r = wsamp_s[wsamp_sPos + 1][b][j];
          wsamp_s[wsamp_sPos + 0][b][j] = (l + r) * Util.SQRT2 * 0.5;
          wsamp_s[wsamp_sPos + 1][b][j] = (l - r) * Util.SQRT2 * 0.5;
        }
      }
    }

    /*********************************************************************
     * compute energies
     *********************************************************************/
    fftenergy[0] = NON_LINEAR_SCALE_ENERGY(wsamp_l[wsamp_lPos + 0][0]);
    fftenergy[0] *= fftenergy[0];
    for (var j = Encoder$6.BLKSIZE / 2 - 1; j >= 0; --j) {
      var re = wsamp_l[wsamp_lPos + 0][Encoder$6.BLKSIZE / 2 - j];
      var im = wsamp_l[wsamp_lPos + 0][Encoder$6.BLKSIZE / 2 + j];
      fftenergy[Encoder$6.BLKSIZE / 2 - j] = NON_LINEAR_SCALE_ENERGY((re * re + im * im) * 0.5);
    }
    for (var b = 2; b >= 0; --b) {
      fftenergy_s[b][0] = wsamp_s[wsamp_sPos + 0][b][0];
      fftenergy_s[b][0] *= fftenergy_s[b][0];
      for (var j = Encoder$6.BLKSIZE_s / 2 - 1; j >= 0; --j) {
        var re = wsamp_s[wsamp_sPos + 0][b][Encoder$6.BLKSIZE_s / 2 - j];
        var im = wsamp_s[wsamp_sPos + 0][b][Encoder$6.BLKSIZE_s / 2 + j];
        fftenergy_s[b][Encoder$6.BLKSIZE_s / 2 - j] = NON_LINEAR_SCALE_ENERGY((re * re + im * im) * 0.5);
      }
    }
    /* total energy */
    {
      var totalenergy = 0.0;
      for (var j = 11; j < Encoder$6.HBLKSIZE; j++) totalenergy += fftenergy[j];
      gfc.tot_ener[chn] = totalenergy;
    }
    if (gfp.analysis) {
      for (var j = 0; j < Encoder$6.HBLKSIZE; j++) {
        gfc.pinfo.energy[gr_out][chn][j] = gfc.pinfo.energy_save[chn][j];
        gfc.pinfo.energy_save[chn][j] = fftenergy[j];
      }
      gfc.pinfo.pe[gr_out][chn] = gfc.pe[chn];
    }

    /*********************************************************************
     * compute loudness approximation (used for ATH auto-level adjustment)
     *********************************************************************/
    if (gfp.athaa_loudapprox == 2 && chn < 2) {
      // no loudness for mid/side ch
      gfc.loudness_sq[gr_out][chn] = gfc.loudness_sq_save[chn];
      gfc.loudness_sq_save[chn] = psycho_loudness_approx(fftenergy, gfc);
    }
  }

  /* mask_add optimization */
  /* init the limit values used to avoid computing log in mask_add when it is not necessary */

  /**
   * <PRE>
   *  For example, with i = 10*log10(m2/m1)/10*16         (= log10(m2/m1)*16)
   *
   * abs(i)>8 is equivalent (as i is an integer) to
   * abs(i)>=9
   * i>=9 || i<=-9
   * equivalent to (as i is the biggest integer smaller than log10(m2/m1)*16
   * or the smallest integer bigger than log10(m2/m1)*16 depending on the sign of log10(m2/m1)*16)
   * log10(m2/m1)>=9/16 || log10(m2/m1)<=-9/16
   * exp10 is strictly increasing thus this is equivalent to
   * m2/m1 >= 10^(9/16) || m2/m1<=10^(-9/16) which are comparisons to constants
   * </PRE>
   */

  /**
   * as in if(i>8)
   */
  var I1LIMIT = 8;
  /**
   * as in if(i>24) . changed 23
   */
  var I2LIMIT = 23;
  /**
   * as in if(m<15)
   */
  var MLIMIT = 15;
  var ma_max_i1;
  var ma_max_i2;
  var ma_max_m;

  /**
   * This is the masking table:<BR>
   * According to tonality, values are going from 0dB (TMN) to 9.3dB (NMT).<BR>
   * After additive masking computation, 8dB are added, so final values are
   * going from 8dB to 17.3dB
   *
   * pow(10, -0.0..-0.6)
   */
  var tab = [1.0, 0.79433, 0.63096, 0.63096, 0.63096, 0.63096, 0.63096, 0.25119, 0.11749];
  function init_mask_add_max_values() {
    ma_max_i1 = Math.pow(10, (I1LIMIT + 1) / 16.0);
    ma_max_i2 = Math.pow(10, (I2LIMIT + 1) / 16.0);
    ma_max_m = Math.pow(10, MLIMIT / 10.0);
  }
  var table1 = [3.3246 * 3.3246, 3.23837 * 3.23837, 3.15437 * 3.15437, 3.00412 * 3.00412, 2.86103 * 2.86103, 2.65407 * 2.65407, 2.46209 * 2.46209, 2.284 * 2.284, 2.11879 * 2.11879, 1.96552 * 1.96552, 1.82335 * 1.82335, 1.69146 * 1.69146, 1.56911 * 1.56911, 1.46658 * 1.46658, 1.37074 * 1.37074, 1.31036 * 1.31036, 1.25264 * 1.25264, 1.20648 * 1.20648, 1.16203 * 1.16203, 1.12765 * 1.12765, 1.09428 * 1.09428, 1.0659 * 1.0659, 1.03826 * 1.03826, 1.01895 * 1.01895, 1];
  var table2 = [1.33352 * 1.33352, 1.35879 * 1.35879, 1.38454 * 1.38454, 1.39497 * 1.39497, 1.40548 * 1.40548, 1.3537 * 1.3537, 1.30382 * 1.30382, 1.22321 * 1.22321, 1.14758 * 1.14758, 1];
  var table3 = [2.35364 * 2.35364, 2.29259 * 2.29259, 2.23313 * 2.23313, 2.12675 * 2.12675, 2.02545 * 2.02545, 1.87894 * 1.87894, 1.74303 * 1.74303, 1.61695 * 1.61695, 1.49999 * 1.49999, 1.39148 * 1.39148, 1.29083 * 1.29083, 1.19746 * 1.19746, 1.11084 * 1.11084, 1.03826 * 1.03826];

  /**
   * addition of simultaneous masking Naoki Shibata 2000/7
   */
  function mask_add(m1, m2, kk, b, gfc, shortblock) {
    var ratio;
    if (m2 > m1) {
      if (m2 < m1 * ma_max_i2) ratio = m2 / m1;else return m1 + m2;
    } else {
      if (m1 >= m2 * ma_max_i2) return m1 + m2;
      ratio = m1 / m2;
    }
    m1 += m2;
    //if (((long)(b + 3) & 0xffffffff) <= 3 + 3) {
    if (b + 3 <= 3 + 3) {
      /* approximately, 1 bark = 3 partitions */
      /* 65% of the cases */
      /* originally 'if(i > 8)' */
      if (ratio >= ma_max_i1) {
        /* 43% of the total */
        return m1;
      }

      /* 22% of the total */
      var i = 0 | Util.FAST_LOG10_X(ratio, 16.0);
      return m1 * table2[i];
    }

    /**
     * <PRE>
     * m<15 equ log10((m1+m2)/gfc.ATH.cb[k])<1.5
     * equ (m1+m2)/gfc.ATH.cb[k]<10^1.5
     * equ (m1+m2)<10^1.5 * gfc.ATH.cb[k]
     * </PRE>
     */
    var i = 0 | Util.FAST_LOG10_X(ratio, 16.0);
    if (shortblock != 0) {
      m2 = gfc.ATH.cb_s[kk] * gfc.ATH.adjust;
    } else {
      m2 = gfc.ATH.cb_l[kk] * gfc.ATH.adjust;
    }
    if (m1 < ma_max_m * m2) {
      /* 3% of the total */
      /* Originally if (m > 0) { */
      if (m1 > m2) {
        var f, r;
        f = 1.0;
        if (i <= 13) f = table3[i];
        r = Util.FAST_LOG10_X(m1 / m2, 10.0 / 15.0);
        return m1 * ((table1[i] - f) * r + f);
      }
      if (i > 13) return m1;
      return m1 * table3[i];
    }

    /* 10% of total */
    return m1 * table1[i];
  }
  var table2_ = [1.33352 * 1.33352, 1.35879 * 1.35879, 1.38454 * 1.38454, 1.39497 * 1.39497, 1.40548 * 1.40548, 1.3537 * 1.3537, 1.30382 * 1.30382, 1.22321 * 1.22321, 1.14758 * 1.14758, 1];

  /**
   * addition of simultaneous masking Naoki Shibata 2000/7
   */
  function vbrpsy_mask_add(m1, m2, b) {
    var ratio;
    if (m1 < 0) {
      m1 = 0;
    }
    if (m2 < 0) {
      m2 = 0;
    }
    if (m1 <= 0) {
      return m2;
    }
    if (m2 <= 0) {
      return m1;
    }
    if (m2 > m1) {
      ratio = m2 / m1;
    } else {
      ratio = m1 / m2;
    }
    if (-2 <= b && b <= 2) {
      /* approximately, 1 bark = 3 partitions */
      /* originally 'if(i > 8)' */
      if (ratio >= ma_max_i1) {
        return m1 + m2;
      } else {
        var i = 0 | Util.FAST_LOG10_X(ratio, 16.0);
        return (m1 + m2) * table2_[i];
      }
    }
    if (ratio < ma_max_i2) {
      return m1 + m2;
    }
    if (m1 < m2) {
      m1 = m2;
    }
    return m1;
  }

  /**
   * compute interchannel masking effects
   */
  function calc_interchannel_masking(gfp, ratio) {
    var gfc = gfp.internal_flags;
    if (gfc.channels_out > 1) {
      for (var sb = 0; sb < Encoder$6.SBMAX_l; sb++) {
        var l = gfc.thm[0].l[sb];
        var r = gfc.thm[1].l[sb];
        gfc.thm[0].l[sb] += r * ratio;
        gfc.thm[1].l[sb] += l * ratio;
      }
      for (var sb = 0; sb < Encoder$6.SBMAX_s; sb++) {
        for (var sblock = 0; sblock < 3; sblock++) {
          var l = gfc.thm[0].s[sb][sblock];
          var r = gfc.thm[1].s[sb][sblock];
          gfc.thm[0].s[sb][sblock] += r * ratio;
          gfc.thm[1].s[sb][sblock] += l * ratio;
        }
      }
    }
  }

  /**
   * compute M/S thresholds from Johnston & Ferreira 1992 ICASSP paper
   */
  function msfix1(gfc) {
    for (var sb = 0; sb < Encoder$6.SBMAX_l; sb++) {
      /* use this fix if L & R masking differs by 2db or less */
      /* if db = 10*log10(x2/x1) < 2 */
      /* if (x2 < 1.58*x1) { */
      if (gfc.thm[0].l[sb] > 1.58 * gfc.thm[1].l[sb] || gfc.thm[1].l[sb] > 1.58 * gfc.thm[0].l[sb]) continue;
      var mld = gfc.mld_l[sb] * gfc.en[3].l[sb];
      var rmid = Math.max(gfc.thm[2].l[sb], Math.min(gfc.thm[3].l[sb], mld));
      mld = gfc.mld_l[sb] * gfc.en[2].l[sb];
      var rside = Math.max(gfc.thm[3].l[sb], Math.min(gfc.thm[2].l[sb], mld));
      gfc.thm[2].l[sb] = rmid;
      gfc.thm[3].l[sb] = rside;
    }
    for (var sb = 0; sb < Encoder$6.SBMAX_s; sb++) {
      for (var sblock = 0; sblock < 3; sblock++) {
        if (gfc.thm[0].s[sb][sblock] > 1.58 * gfc.thm[1].s[sb][sblock] || gfc.thm[1].s[sb][sblock] > 1.58 * gfc.thm[0].s[sb][sblock]) continue;
        var mld = gfc.mld_s[sb] * gfc.en[3].s[sb][sblock];
        var rmid = Math.max(gfc.thm[2].s[sb][sblock], Math.min(gfc.thm[3].s[sb][sblock], mld));
        mld = gfc.mld_s[sb] * gfc.en[2].s[sb][sblock];
        var rside = Math.max(gfc.thm[3].s[sb][sblock], Math.min(gfc.thm[2].s[sb][sblock], mld));
        gfc.thm[2].s[sb][sblock] = rmid;
        gfc.thm[3].s[sb][sblock] = rside;
      }
    }
  }

  /**
   * Adjust M/S maskings if user set "msfix"
   *
   * Naoki Shibata 2000
   */
  function ns_msfix(gfc, msfix, athadjust) {
    var msfix2 = msfix;
    var athlower = Math.pow(10, athadjust);
    msfix *= 2.0;
    msfix2 *= 2.0;
    for (var sb = 0; sb < Encoder$6.SBMAX_l; sb++) {
      var thmLR, thmM, thmS, ath;
      ath = gfc.ATH.cb_l[gfc.bm_l[sb]] * athlower;
      thmLR = Math.min(Math.max(gfc.thm[0].l[sb], ath), Math.max(gfc.thm[1].l[sb], ath));
      thmM = Math.max(gfc.thm[2].l[sb], ath);
      thmS = Math.max(gfc.thm[3].l[sb], ath);
      if (thmLR * msfix < thmM + thmS) {
        var f = thmLR * msfix2 / (thmM + thmS);
        thmM *= f;
        thmS *= f;
      }
      gfc.thm[2].l[sb] = Math.min(thmM, gfc.thm[2].l[sb]);
      gfc.thm[3].l[sb] = Math.min(thmS, gfc.thm[3].l[sb]);
    }
    athlower *= Encoder$6.BLKSIZE_s / Encoder$6.BLKSIZE;
    for (var sb = 0; sb < Encoder$6.SBMAX_s; sb++) {
      for (var sblock = 0; sblock < 3; sblock++) {
        var thmLR, thmM, thmS, ath;
        ath = gfc.ATH.cb_s[gfc.bm_s[sb]] * athlower;
        thmLR = Math.min(Math.max(gfc.thm[0].s[sb][sblock], ath), Math.max(gfc.thm[1].s[sb][sblock], ath));
        thmM = Math.max(gfc.thm[2].s[sb][sblock], ath);
        thmS = Math.max(gfc.thm[3].s[sb][sblock], ath);
        if (thmLR * msfix < thmM + thmS) {
          var f = thmLR * msfix / (thmM + thmS);
          thmM *= f;
          thmS *= f;
        }
        gfc.thm[2].s[sb][sblock] = Math.min(gfc.thm[2].s[sb][sblock], thmM);
        gfc.thm[3].s[sb][sblock] = Math.min(gfc.thm[3].s[sb][sblock], thmS);
      }
    }
  }

  /**
   * short block threshold calculation (part 2)
   *
   * partition band bo_s[sfb] is at the transition from scalefactor band sfb
   * to the next one sfb+1; enn and thmm have to be split between them
   */
  function convert_partition2scalefac_s(gfc, eb, thr, chn, sblock) {
    var sb, b;
    var enn = 0.0;
    var thmm = 0.0;
    for (sb = b = 0; sb < Encoder$6.SBMAX_s; ++b, ++sb) {
      var bo_s_sb = gfc.bo_s[sb];
      var npart_s = gfc.npart_s;
      var b_lim = bo_s_sb < npart_s ? bo_s_sb : npart_s;
      while (b < b_lim) {
        assert$1(eb[b] >= 0);
        // iff failed, it may indicate some index error elsewhere
        assert$1(thr[b] >= 0);
        enn += eb[b];
        thmm += thr[b];
        b++;
      }
      gfc.en[chn].s[sb][sblock] = enn;
      gfc.thm[chn].s[sb][sblock] = thmm;
      if (b >= npart_s) {
        ++sb;
        break;
      }
      assert$1(eb[b] >= 0);
      // iff failed, it may indicate some index error elsewhere
      assert$1(thr[b] >= 0);
      {
        /* at transition sfb . sfb+1 */
        var w_curr = gfc.PSY.bo_s_weight[sb];
        var w_next = 1.0 - w_curr;
        enn = w_curr * eb[b];
        thmm = w_curr * thr[b];
        gfc.en[chn].s[sb][sblock] += enn;
        gfc.thm[chn].s[sb][sblock] += thmm;
        enn = w_next * eb[b];
        thmm = w_next * thr[b];
      }
    }
    /* zero initialize the rest */
    for (; sb < Encoder$6.SBMAX_s; ++sb) {
      gfc.en[chn].s[sb][sblock] = 0;
      gfc.thm[chn].s[sb][sblock] = 0;
    }
  }

  /**
   * longblock threshold calculation (part 2)
   */
  function convert_partition2scalefac_l(gfc, eb, thr, chn) {
    var sb, b;
    var enn = 0.0;
    var thmm = 0.0;
    for (sb = b = 0; sb < Encoder$6.SBMAX_l; ++b, ++sb) {
      var bo_l_sb = gfc.bo_l[sb];
      var npart_l = gfc.npart_l;
      var b_lim = bo_l_sb < npart_l ? bo_l_sb : npart_l;
      while (b < b_lim) {
        assert$1(eb[b] >= 0);
        // iff failed, it may indicate some index error elsewhere
        assert$1(thr[b] >= 0);
        enn += eb[b];
        thmm += thr[b];
        b++;
      }
      gfc.en[chn].l[sb] = enn;
      gfc.thm[chn].l[sb] = thmm;
      if (b >= npart_l) {
        ++sb;
        break;
      }
      assert$1(eb[b] >= 0);
      assert$1(thr[b] >= 0);
      {
        /* at transition sfb . sfb+1 */
        var w_curr = gfc.PSY.bo_l_weight[sb];
        var w_next = 1.0 - w_curr;
        enn = w_curr * eb[b];
        thmm = w_curr * thr[b];
        gfc.en[chn].l[sb] += enn;
        gfc.thm[chn].l[sb] += thmm;
        enn = w_next * eb[b];
        thmm = w_next * thr[b];
      }
    }
    /* zero initialize the rest */
    for (; sb < Encoder$6.SBMAX_l; ++sb) {
      gfc.en[chn].l[sb] = 0;
      gfc.thm[chn].l[sb] = 0;
    }
  }
  function compute_masking_s(gfp, fftenergy_s, eb, thr, chn, sblock) {
    var gfc = gfp.internal_flags;
    var j, b;
    for (b = j = 0; b < gfc.npart_s; ++b) {
      var ebb = 0;
      var n = gfc.numlines_s[b];
      for (var i = 0; i < n; ++i, ++j) {
        var el = fftenergy_s[sblock][j];
        ebb += el;
      }
      eb[b] = ebb;
    }
    assert$1(b == gfc.npart_s);
    for (j = b = 0; b < gfc.npart_s; b++) {
      var kk = gfc.s3ind_s[b][0];
      var ecb = gfc.s3_ss[j++] * eb[kk];
      ++kk;
      while (kk <= gfc.s3ind_s[b][1]) {
        ecb += gfc.s3_ss[j] * eb[kk];
        ++j;
        ++kk;
      }
      {
        /* limit calculated threshold by previous granule */
        var x = rpelev_s * gfc.nb_s1[chn][b];
        thr[b] = Math.min(ecb, x);
      }
      if (gfc.blocktype_old[chn & 1] == Encoder$6.SHORT_TYPE) {
        /* limit calculated threshold by even older granule */
        var x = rpelev2_s * gfc.nb_s2[chn][b];
        var y = thr[b];
        thr[b] = Math.min(x, y);
      }
      gfc.nb_s2[chn][b] = gfc.nb_s1[chn][b];
      gfc.nb_s1[chn][b] = ecb;
      assert$1(thr[b] >= 0);
    }
    for (; b <= Encoder$6.CBANDS; ++b) {
      eb[b] = 0;
      thr[b] = 0;
    }
  }
  function block_type_set(gfp, uselongblock, blocktype_d, blocktype) {
    var gfc = gfp.internal_flags;
    if (gfp.short_blocks == ShortBlock.short_block_coupled
    /* force both channels to use the same block type */
    /* this is necessary if the frame is to be encoded in ms_stereo. */
    /* But even without ms_stereo, FhG does this */ && !(uselongblock[0] != 0 && uselongblock[1] != 0)) uselongblock[0] = uselongblock[1] = 0;

    /*
     * update the blocktype of the previous granule, since it depends on
     * what happend in this granule
     */
    for (var chn = 0; chn < gfc.channels_out; chn++) {
      blocktype[chn] = Encoder$6.NORM_TYPE;
      /* disable short blocks */
      if (gfp.short_blocks == ShortBlock.short_block_dispensed) uselongblock[chn] = 1;
      if (gfp.short_blocks == ShortBlock.short_block_forced) uselongblock[chn] = 0;
      if (uselongblock[chn] != 0) {
        /* no attack : use long blocks */
        assert$1(gfc.blocktype_old[chn] != Encoder$6.START_TYPE);
        if (gfc.blocktype_old[chn] == Encoder$6.SHORT_TYPE) blocktype[chn] = Encoder$6.STOP_TYPE;
      } else {
        /* attack : use short blocks */
        blocktype[chn] = Encoder$6.SHORT_TYPE;
        if (gfc.blocktype_old[chn] == Encoder$6.NORM_TYPE) {
          gfc.blocktype_old[chn] = Encoder$6.START_TYPE;
        }
        if (gfc.blocktype_old[chn] == Encoder$6.STOP_TYPE) gfc.blocktype_old[chn] = Encoder$6.SHORT_TYPE;
      }
      blocktype_d[chn] = gfc.blocktype_old[chn];
      // value returned to calling program
      gfc.blocktype_old[chn] = blocktype[chn];
      // save for next call to l3psy_anal
    }
  }
  function NS_INTERP(x, y, r) {
    /* was pow((x),(r))*pow((y),1-(r)) */
    if (r >= 1.0) {
      /* 99.7% of the time */
      return x;
    }
    if (r <= 0.0) return y;
    if (y > 0.0) {
      /* rest of the time */
      return Math.pow(x / y, r) * y;
    }
    /* never happens */
    return 0.0;
  }

  /**
   * these values are tuned only for 44.1kHz...
   */
  var regcoef_s = [11.8, 13.6, 17.2, 32, 46.5, 51.3, 57.5, 67.1, 71.5, 84.6, 97.6, 130
  /* 255.8 */];
  function pecalc_s(mr, masking_lower) {
    var pe_s = 1236.28 / 4;
    for (var sb = 0; sb < Encoder$6.SBMAX_s - 1; sb++) {
      for (var sblock = 0; sblock < 3; sblock++) {
        var thm = mr.thm.s[sb][sblock];
        if (thm > 0.0) {
          var x = thm * masking_lower;
          var en = mr.en.s[sb][sblock];
          if (en > x) {
            if (en > x * 1e10) {
              pe_s += regcoef_s[sb] * (10.0 * LOG10);
            } else {
              pe_s += regcoef_s[sb] * Util.FAST_LOG10(en / x);
            }
          }
        }
      }
    }
    return pe_s;
  }

  /**
   * these values are tuned only for 44.1kHz...
   */
  var regcoef_l = [6.8, 5.8, 5.8, 6.4, 6.5, 9.9, 12.1, 14.4, 15, 18.9, 21.6, 26.9, 34.2, 40.2, 46.8, 56.5, 60.7, 73.9, 85.7, 93.4, 126.1
  /* 241.3 */];
  function pecalc_l(mr, masking_lower) {
    var pe_l = 1124.23 / 4;
    for (var sb = 0; sb < Encoder$6.SBMAX_l - 1; sb++) {
      var thm = mr.thm.l[sb];
      if (thm > 0.0) {
        var x = thm * masking_lower;
        var en = mr.en.l[sb];
        if (en > x) {
          if (en > x * 1e10) {
            pe_l += regcoef_l[sb] * (10.0 * LOG10);
          } else {
            pe_l += regcoef_l[sb] * Util.FAST_LOG10(en / x);
          }
        }
      }
    }
    return pe_l;
  }
  function calc_energy(gfc, fftenergy, eb, max, avg) {
    var b, j;
    for (b = j = 0; b < gfc.npart_l; ++b) {
      var ebb = 0,
        m = 0;
      var i;
      for (i = 0; i < gfc.numlines_l[b]; ++i, ++j) {
        var el = fftenergy[j];
        ebb += el;
        if (m < el) m = el;
      }
      eb[b] = ebb;
      max[b] = m;
      avg[b] = ebb * gfc.rnumlines_l[b];
      assert$1(gfc.rnumlines_l[b] >= 0);
      assert$1(eb[b] >= 0);
      assert$1(max[b] >= 0);
      assert$1(avg[b] >= 0);
    }
  }
  function calc_mask_index_l(gfc, max, avg, mask_idx) {
    var last_tab_entry = tab.length - 1;
    var b = 0;
    var a = avg[b] + avg[b + 1];
    if (a > 0.0) {
      var m = max[b];
      if (m < max[b + 1]) m = max[b + 1];
      assert$1(gfc.numlines_l[b] + gfc.numlines_l[b + 1] - 1 > 0);
      a = 20.0 * (m * 2.0 - a) / (a * (gfc.numlines_l[b] + gfc.numlines_l[b + 1] - 1));
      var k = 0 | a;
      if (k > last_tab_entry) k = last_tab_entry;
      mask_idx[b] = k;
    } else {
      mask_idx[b] = 0;
    }
    for (b = 1; b < gfc.npart_l - 1; b++) {
      a = avg[b - 1] + avg[b] + avg[b + 1];
      if (a > 0.0) {
        var m = max[b - 1];
        if (m < max[b]) m = max[b];
        if (m < max[b + 1]) m = max[b + 1];
        assert$1(gfc.numlines_l[b - 1] + gfc.numlines_l[b] + gfc.numlines_l[b + 1] - 1 > 0);
        a = 20.0 * (m * 3.0 - a) / (a * (gfc.numlines_l[b - 1] + gfc.numlines_l[b] + gfc.numlines_l[b + 1] - 1));
        var k = 0 | a;
        if (k > last_tab_entry) k = last_tab_entry;
        mask_idx[b] = k;
      } else {
        mask_idx[b] = 0;
      }
    }
    assert$1(b == gfc.npart_l - 1);
    a = avg[b - 1] + avg[b];
    if (a > 0.0) {
      var m = max[b - 1];
      if (m < max[b]) m = max[b];
      assert$1(gfc.numlines_l[b - 1] + gfc.numlines_l[b] - 1 > 0);
      a = 20.0 * (m * 2.0 - a) / (a * (gfc.numlines_l[b - 1] + gfc.numlines_l[b] - 1));
      var k = 0 | a;
      if (k > last_tab_entry) k = last_tab_entry;
      mask_idx[b] = k;
    } else {
      mask_idx[b] = 0;
    }
    assert$1(b == gfc.npart_l - 1);
  }
  var fircoef = [-8.65163e-18 * 2, -0.00851586 * 2, -6.74764e-18 * 2, 0.0209036 * 2, -3.36639e-17 * 2, -0.0438162 * 2, -1.54175e-17 * 2, 0.0931738 * 2, -5.52212e-17 * 2, -0.313819 * 2];
  this.L3psycho_anal_ns = function (gfp, buffer, bufPos, gr_out, masking_ratio, masking_MS_ratio, percep_entropy, percep_MS_entropy, energy, blocktype_d) {
    /*
     * to get a good cache performance, one has to think about the sequence,
     * in which the variables are used.
     */
    var gfc = gfp.internal_flags;

    /* fft and energy calculation */
    var wsamp_L = new_float_n$2([2, Encoder$6.BLKSIZE]);
    var wsamp_S = new_float_n$2([2, 3, Encoder$6.BLKSIZE_s]);

    /* convolution */
    var eb_l = new_float$6(Encoder$6.CBANDS + 1);
    var eb_s = new_float$6(Encoder$6.CBANDS + 1);
    var thr = new_float$6(Encoder$6.CBANDS + 2);

    /* block type */
    var blocktype = new_int$7(2),
      uselongblock = new_int$7(2);

    /* usual variables like loop indices, etc.. */
    var numchn, chn;
    var b, i, j, k;
    var sb, sblock;

    /* variables used for --nspsytune */
    var ns_hpfsmpl = new_float_n$2([2, 576]);
    var pcfact;
    var mask_idx_l = new_int$7(Encoder$6.CBANDS + 2),
      mask_idx_s = new_int$7(Encoder$6.CBANDS + 2);
    Arrays$1.fill(mask_idx_s, 0);
    numchn = gfc.channels_out;
    /* chn=2 and 3 = Mid and Side channels */
    if (gfp.mode == MPEGMode.JOINT_STEREO) numchn = 4;
    if (gfp.VBR == VbrMode.vbr_off) pcfact = gfc.ResvMax == 0 ? 0 : gfc.ResvSize / gfc.ResvMax * 0.5;else if (gfp.VBR == VbrMode.vbr_rh || gfp.VBR == VbrMode.vbr_mtrh || gfp.VBR == VbrMode.vbr_mt) {
      pcfact = 0.6;
    } else pcfact = 1.0;

    /**********************************************************************
     * Apply HPF of fs/4 to the input signal. This is used for attack
     * detection / handling.
     **********************************************************************/
    /* Don't copy the input buffer into a temporary buffer */
    /* unroll the loop 2 times */
    for (chn = 0; chn < gfc.channels_out; chn++) {
      /* apply high pass filter of fs/4 */
      var firbuf = buffer[chn];
      var firbufPos = bufPos + 576 - 350 - NSFIRLEN + 192;
      for (i = 0; i < 576; i++) {
        var sum1, sum2;
        sum1 = firbuf[firbufPos + i + 10];
        sum2 = 0.0;
        for (j = 0; j < (NSFIRLEN - 1) / 2 - 1; j += 2) {
          sum1 += fircoef[j] * (firbuf[firbufPos + i + j] + firbuf[firbufPos + i + NSFIRLEN - j]);
          sum2 += fircoef[j + 1] * (firbuf[firbufPos + i + j + 1] + firbuf[firbufPos + i + NSFIRLEN - j - 1]);
        }
        ns_hpfsmpl[chn][i] = sum1 + sum2;
      }
      masking_ratio[gr_out][chn].en.assign(gfc.en[chn]);
      masking_ratio[gr_out][chn].thm.assign(gfc.thm[chn]);
      if (numchn > 2) {
        /* MS maskings */
        /* percep_MS_entropy [chn-2] = gfc . pe [chn]; */
        masking_MS_ratio[gr_out][chn].en.assign(gfc.en[chn + 2]);
        masking_MS_ratio[gr_out][chn].thm.assign(gfc.thm[chn + 2]);
      }
    }
    for (chn = 0; chn < numchn; chn++) {
      var wsamp_l;
      var wsamp_s;
      var en_subshort = new_float$6(12);
      var en_short = [0, 0, 0, 0];
      var attack_intensity = new_float$6(12);
      var ns_uselongblock = 1;
      var attackThreshold;
      var max = new_float$6(Encoder$6.CBANDS),
        avg = new_float$6(Encoder$6.CBANDS);
      var ns_attacks = [0, 0, 0, 0];
      var fftenergy = new_float$6(Encoder$6.HBLKSIZE);
      var fftenergy_s = new_float_n$2([3, Encoder$6.HBLKSIZE_s]);

      /*
       * rh 20040301: the following loops do access one off the limits so
       * I increase the array dimensions by one and initialize the
       * accessed values to zero
       */
      assert$1(gfc.npart_s <= Encoder$6.CBANDS);
      assert$1(gfc.npart_l <= Encoder$6.CBANDS);

      /***************************************************************
       * determine the block type (window type)
       ***************************************************************/
      /* calculate energies of each sub-shortblocks */
      for (i = 0; i < 3; i++) {
        en_subshort[i] = gfc.nsPsy.last_en_subshort[chn][i + 6];
        assert$1(gfc.nsPsy.last_en_subshort[chn][i + 4] > 0);
        attack_intensity[i] = en_subshort[i] / gfc.nsPsy.last_en_subshort[chn][i + 4];
        en_short[0] += en_subshort[i];
      }
      if (chn == 2) {
        for (i = 0; i < 576; i++) {
          var l, r;
          l = ns_hpfsmpl[0][i];
          r = ns_hpfsmpl[1][i];
          ns_hpfsmpl[0][i] = l + r;
          ns_hpfsmpl[1][i] = l - r;
        }
      }
      {
        var pf = ns_hpfsmpl[chn & 1];
        var pfPos = 0;
        for (i = 0; i < 9; i++) {
          var pfe = pfPos + 576 / 9;
          var p = 1.;
          for (; pfPos < pfe; pfPos++) if (p < Math.abs(pf[pfPos])) p = Math.abs(pf[pfPos]);
          gfc.nsPsy.last_en_subshort[chn][i] = en_subshort[i + 3] = p;
          en_short[1 + i / 3] += p;
          if (p > en_subshort[i + 3 - 2]) {
            assert$1(en_subshort[i + 3 - 2] > 0);
            p = p / en_subshort[i + 3 - 2];
          } else if (en_subshort[i + 3 - 2] > p * 10.0) {
            p = en_subshort[i + 3 - 2] / (p * 10.0);
          } else p = 0.0;
          attack_intensity[i + 3] = p;
        }
      }
      if (gfp.analysis) {
        var x = attack_intensity[0];
        for (i = 1; i < 12; i++) if (x < attack_intensity[i]) x = attack_intensity[i];
        gfc.pinfo.ers[gr_out][chn] = gfc.pinfo.ers_save[chn];
        gfc.pinfo.ers_save[chn] = x;
      }

      /* compare energies between sub-shortblocks */
      attackThreshold = chn == 3 ? gfc.nsPsy.attackthre_s : gfc.nsPsy.attackthre;
      for (i = 0; i < 12; i++) if (0 == ns_attacks[i / 3] && attack_intensity[i] > attackThreshold) ns_attacks[i / 3] = i % 3 + 1;

      /*
       * should have energy change between short blocks, in order to avoid
       * periodic signals
       */
      for (i = 1; i < 4; i++) {
        var ratio;
        if (en_short[i - 1] > en_short[i]) {
          assert$1(en_short[i] > 0);
          ratio = en_short[i - 1] / en_short[i];
        } else {
          assert$1(en_short[i - 1] > 0);
          ratio = en_short[i] / en_short[i - 1];
        }
        if (ratio < 1.7) {
          ns_attacks[i] = 0;
          if (i == 1) ns_attacks[0] = 0;
        }
      }
      if (ns_attacks[0] != 0 && gfc.nsPsy.lastAttacks[chn] != 0) ns_attacks[0] = 0;
      if (gfc.nsPsy.lastAttacks[chn] == 3 || ns_attacks[0] + ns_attacks[1] + ns_attacks[2] + ns_attacks[3] != 0) {
        ns_uselongblock = 0;
        if (ns_attacks[1] != 0 && ns_attacks[0] != 0) ns_attacks[1] = 0;
        if (ns_attacks[2] != 0 && ns_attacks[1] != 0) ns_attacks[2] = 0;
        if (ns_attacks[3] != 0 && ns_attacks[2] != 0) ns_attacks[3] = 0;
      }
      if (chn < 2) {
        uselongblock[chn] = ns_uselongblock;
      } else {
        if (ns_uselongblock == 0) {
          uselongblock[0] = uselongblock[1] = 0;
        }
      }

      /*
       * there is a one granule delay. Copy maskings computed last call
       * into masking_ratio to return to calling program.
       */
      energy[chn] = gfc.tot_ener[chn];

      /*********************************************************************
       * compute FFTs
       *********************************************************************/
      wsamp_s = wsamp_S;
      wsamp_l = wsamp_L;
      compute_ffts(gfp, fftenergy, fftenergy_s, wsamp_l, chn & 1, wsamp_s, chn & 1, gr_out, chn, buffer, bufPos);

      /*********************************************************************
       * Calculate the energy and the tonality of each partition.
       *********************************************************************/
      calc_energy(gfc, fftenergy, eb_l, max, avg);
      calc_mask_index_l(gfc, max, avg, mask_idx_l);
      /* compute masking thresholds for short blocks */
      for (sblock = 0; sblock < 3; sblock++) {
        var enn, thmm;
        compute_masking_s(gfp, fftenergy_s, eb_s, thr, chn, sblock);
        convert_partition2scalefac_s(gfc, eb_s, thr, chn, sblock);
        /**** short block pre-echo control ****/
        for (sb = 0; sb < Encoder$6.SBMAX_s; sb++) {
          thmm = gfc.thm[chn].s[sb][sblock];
          thmm *= NS_PREECHO_ATT0;
          if (ns_attacks[sblock] >= 2 || ns_attacks[sblock + 1] == 1) {
            var idx = sblock != 0 ? sblock - 1 : 2;
            var p = NS_INTERP(gfc.thm[chn].s[sb][idx], thmm, NS_PREECHO_ATT1 * pcfact);
            thmm = Math.min(thmm, p);
          }
          if (ns_attacks[sblock] == 1) {
            var idx = sblock != 0 ? sblock - 1 : 2;
            var p = NS_INTERP(gfc.thm[chn].s[sb][idx], thmm, NS_PREECHO_ATT2 * pcfact);
            thmm = Math.min(thmm, p);
          } else if (sblock != 0 && ns_attacks[sblock - 1] == 3 || sblock == 0 && gfc.nsPsy.lastAttacks[chn] == 3) {
            var idx = sblock != 2 ? sblock + 1 : 0;
            var p = NS_INTERP(gfc.thm[chn].s[sb][idx], thmm, NS_PREECHO_ATT2 * pcfact);
            thmm = Math.min(thmm, p);
          }

          /* pulse like signal detection for fatboy.wav and so on */
          enn = en_subshort[sblock * 3 + 3] + en_subshort[sblock * 3 + 4] + en_subshort[sblock * 3 + 5];
          if (en_subshort[sblock * 3 + 5] * 6 < enn) {
            thmm *= 0.5;
            if (en_subshort[sblock * 3 + 4] * 6 < enn) thmm *= 0.5;
          }
          gfc.thm[chn].s[sb][sblock] = thmm;
        }
      }
      gfc.nsPsy.lastAttacks[chn] = ns_attacks[2];

      /*********************************************************************
       * convolve the partitioned energy and unpredictability with the
       * spreading function, s3_l[b][k]
       ********************************************************************/
      k = 0;
      {
        for (b = 0; b < gfc.npart_l; b++) {
          /*
           * convolve the partitioned energy with the spreading
           * function
           */
          var kk = gfc.s3ind[b][0];
          var eb2 = eb_l[kk] * tab[mask_idx_l[kk]];
          var ecb = gfc.s3_ll[k++] * eb2;
          while (++kk <= gfc.s3ind[b][1]) {
            eb2 = eb_l[kk] * tab[mask_idx_l[kk]];
            ecb = mask_add(ecb, gfc.s3_ll[k++] * eb2, kk, kk - b, gfc, 0);
          }
          ecb *= 0.158489319246111;
          /* pow(10,-0.8) */

          /**** long block pre-echo control ****/
          /**
           * <PRE>
           * dont use long block pre-echo control if previous granule was
           * a short block.  This is to avoid the situation:
           * frame0:  quiet (very low masking)
           * frame1:  surge  (triggers short blocks)
           * frame2:  regular frame.  looks like pre-echo when compared to
           *          frame0, but all pre-echo was in frame1.
           * </PRE>
           */
          /*
           * chn=0,1 L and R channels
           *
           * chn=2,3 S and M channels.
           */

          if (gfc.blocktype_old[chn & 1] == Encoder$6.SHORT_TYPE) thr[b] = ecb;else thr[b] = NS_INTERP(Math.min(ecb, Math.min(rpelev * gfc.nb_1[chn][b], rpelev2 * gfc.nb_2[chn][b])), ecb, pcfact);
          gfc.nb_2[chn][b] = gfc.nb_1[chn][b];
          gfc.nb_1[chn][b] = ecb;
        }
      }
      for (; b <= Encoder$6.CBANDS; ++b) {
        eb_l[b] = 0;
        thr[b] = 0;
      }
      /* compute masking thresholds for long blocks */
      convert_partition2scalefac_l(gfc, eb_l, thr, chn);
    }
    /* end loop over chn */

    if (gfp.mode == MPEGMode.STEREO || gfp.mode == MPEGMode.JOINT_STEREO) {
      if (gfp.interChRatio > 0.0) {
        calc_interchannel_masking(gfp, gfp.interChRatio);
      }
    }
    if (gfp.mode == MPEGMode.JOINT_STEREO) {
      var msfix;
      msfix1(gfc);
      msfix = gfp.msfix;
      if (Math.abs(msfix) > 0.0) ns_msfix(gfc, msfix, gfp.ATHlower * gfc.ATH.adjust);
    }

    /***************************************************************
     * determine final block type
     ***************************************************************/
    block_type_set(gfp, uselongblock, blocktype_d, blocktype);

    /*********************************************************************
     * compute the value of PE to return ... no delay and advance
     *********************************************************************/
    for (chn = 0; chn < numchn; chn++) {
      var ppe;
      var ppePos = 0;
      var type;
      var mr;
      if (chn > 1) {
        ppe = percep_MS_entropy;
        ppePos = -2;
        type = Encoder$6.NORM_TYPE;
        if (blocktype_d[0] == Encoder$6.SHORT_TYPE || blocktype_d[1] == Encoder$6.SHORT_TYPE) type = Encoder$6.SHORT_TYPE;
        mr = masking_MS_ratio[gr_out][chn - 2];
      } else {
        ppe = percep_entropy;
        ppePos = 0;
        type = blocktype_d[chn];
        mr = masking_ratio[gr_out][chn];
      }
      if (type == Encoder$6.SHORT_TYPE) ppe[ppePos + chn] = pecalc_s(mr, gfc.masking_lower);else ppe[ppePos + chn] = pecalc_l(mr, gfc.masking_lower);
      if (gfp.analysis) gfc.pinfo.pe[gr_out][chn] = ppe[ppePos + chn];
    }
    return 0;
  };
  function vbrpsy_compute_fft_l(gfp, buffer, bufPos, chn, gr_out, fftenergy, wsamp_l, wsamp_lPos) {
    var gfc = gfp.internal_flags;
    if (chn < 2) {
      fft.fft_long(gfc, wsamp_l[wsamp_lPos], chn, buffer, bufPos);
    } else if (chn == 2) {
      /* FFT data for mid and side channel is derived from L & R */
      for (var j = Encoder$6.BLKSIZE - 1; j >= 0; --j) {
        var l = wsamp_l[wsamp_lPos + 0][j];
        var r = wsamp_l[wsamp_lPos + 1][j];
        wsamp_l[wsamp_lPos + 0][j] = (l + r) * Util.SQRT2 * 0.5;
        wsamp_l[wsamp_lPos + 1][j] = (l - r) * Util.SQRT2 * 0.5;
      }
    }

    /*********************************************************************
     * compute energies
     *********************************************************************/
    fftenergy[0] = NON_LINEAR_SCALE_ENERGY(wsamp_l[wsamp_lPos + 0][0]);
    fftenergy[0] *= fftenergy[0];
    for (var j = Encoder$6.BLKSIZE / 2 - 1; j >= 0; --j) {
      var re = wsamp_l[wsamp_lPos + 0][Encoder$6.BLKSIZE / 2 - j];
      var im = wsamp_l[wsamp_lPos + 0][Encoder$6.BLKSIZE / 2 + j];
      fftenergy[Encoder$6.BLKSIZE / 2 - j] = NON_LINEAR_SCALE_ENERGY((re * re + im * im) * 0.5);
    }
    /* total energy */
    {
      var totalenergy = 0.0;
      for (var j = 11; j < Encoder$6.HBLKSIZE; j++) totalenergy += fftenergy[j];
      gfc.tot_ener[chn] = totalenergy;
    }
    if (gfp.analysis) {
      for (var j = 0; j < Encoder$6.HBLKSIZE; j++) {
        gfc.pinfo.energy[gr_out][chn][j] = gfc.pinfo.energy_save[chn][j];
        gfc.pinfo.energy_save[chn][j] = fftenergy[j];
      }
      gfc.pinfo.pe[gr_out][chn] = gfc.pe[chn];
    }
  }
  function vbrpsy_compute_fft_s(gfp, buffer, bufPos, chn, sblock, fftenergy_s, wsamp_s, wsamp_sPos) {
    var gfc = gfp.internal_flags;
    if (sblock == 0 && chn < 2) {
      fft.fft_short(gfc, wsamp_s[wsamp_sPos], chn, buffer, bufPos);
    }
    if (chn == 2) {
      /* FFT data for mid and side channel is derived from L & R */
      for (var j = Encoder$6.BLKSIZE_s - 1; j >= 0; --j) {
        var l = wsamp_s[wsamp_sPos + 0][sblock][j];
        var r = wsamp_s[wsamp_sPos + 1][sblock][j];
        wsamp_s[wsamp_sPos + 0][sblock][j] = (l + r) * Util.SQRT2 * 0.5;
        wsamp_s[wsamp_sPos + 1][sblock][j] = (l - r) * Util.SQRT2 * 0.5;
      }
    }

    /*********************************************************************
     * compute energies
     *********************************************************************/
    fftenergy_s[sblock][0] = wsamp_s[wsamp_sPos + 0][sblock][0];
    fftenergy_s[sblock][0] *= fftenergy_s[sblock][0];
    for (var j = Encoder$6.BLKSIZE_s / 2 - 1; j >= 0; --j) {
      var re = wsamp_s[wsamp_sPos + 0][sblock][Encoder$6.BLKSIZE_s / 2 - j];
      var im = wsamp_s[wsamp_sPos + 0][sblock][Encoder$6.BLKSIZE_s / 2 + j];
      fftenergy_s[sblock][Encoder$6.BLKSIZE_s / 2 - j] = NON_LINEAR_SCALE_ENERGY((re * re + im * im) * 0.5);
    }
  }

  /**
   * compute loudness approximation (used for ATH auto-level adjustment)
   */
  function vbrpsy_compute_loudness_approximation_l(gfp, gr_out, chn, fftenergy) {
    var gfc = gfp.internal_flags;
    if (gfp.athaa_loudapprox == 2 && chn < 2) {
      // no loudness for mid/side ch
      gfc.loudness_sq[gr_out][chn] = gfc.loudness_sq_save[chn];
      gfc.loudness_sq_save[chn] = psycho_loudness_approx(fftenergy, gfc);
    }
  }
  var fircoef_ = [-8.65163e-18 * 2, -0.00851586 * 2, -6.74764e-18 * 2, 0.0209036 * 2, -3.36639e-17 * 2, -0.0438162 * 2, -1.54175e-17 * 2, 0.0931738 * 2, -5.52212e-17 * 2, -0.313819 * 2];

  /**
   * Apply HPF of fs/4 to the input signal. This is used for attack detection
   * / handling.
   */
  function vbrpsy_attack_detection(gfp, buffer, bufPos, gr_out, masking_ratio, masking_MS_ratio, energy, sub_short_factor, ns_attacks, uselongblock) {
    var ns_hpfsmpl = new_float_n$2([2, 576]);
    var gfc = gfp.internal_flags;
    var n_chn_out = gfc.channels_out;
    /* chn=2 and 3 = Mid and Side channels */
    var n_chn_psy = gfp.mode == MPEGMode.JOINT_STEREO ? 4 : n_chn_out;
    /* Don't copy the input buffer into a temporary buffer */
    /* unroll the loop 2 times */
    for (var chn = 0; chn < n_chn_out; chn++) {
      /* apply high pass filter of fs/4 */
      firbuf = buffer[chn];
      var firbufPos = bufPos + 576 - 350 - NSFIRLEN + 192;
      for (var i = 0; i < 576; i++) {
        var sum1, sum2;
        sum1 = firbuf[firbufPos + i + 10];
        sum2 = 0.0;
        for (var j = 0; j < (NSFIRLEN - 1) / 2 - 1; j += 2) {
          sum1 += fircoef_[j] * (firbuf[firbufPos + i + j] + firbuf[firbufPos + i + NSFIRLEN - j]);
          sum2 += fircoef_[j + 1] * (firbuf[firbufPos + i + j + 1] + firbuf[firbufPos + i + NSFIRLEN - j - 1]);
        }
        ns_hpfsmpl[chn][i] = sum1 + sum2;
      }
      masking_ratio[gr_out][chn].en.assign(gfc.en[chn]);
      masking_ratio[gr_out][chn].thm.assign(gfc.thm[chn]);
      if (n_chn_psy > 2) {
        /* MS maskings */
        /* percep_MS_entropy [chn-2] = gfc . pe [chn]; */
        masking_MS_ratio[gr_out][chn].en.assign(gfc.en[chn + 2]);
        masking_MS_ratio[gr_out][chn].thm.assign(gfc.thm[chn + 2]);
      }
    }
    for (var chn = 0; chn < n_chn_psy; chn++) {
      var attack_intensity = new_float$6(12);
      var en_subshort = new_float$6(12);
      var en_short = [0, 0, 0, 0];
      var pf = ns_hpfsmpl[chn & 1];
      var pfPos = 0;
      var attackThreshold = chn == 3 ? gfc.nsPsy.attackthre_s : gfc.nsPsy.attackthre;
      var ns_uselongblock = 1;
      if (chn == 2) {
        for (var i = 0, j = 576; j > 0; ++i, --j) {
          var l = ns_hpfsmpl[0][i];
          var r = ns_hpfsmpl[1][i];
          ns_hpfsmpl[0][i] = l + r;
          ns_hpfsmpl[1][i] = l - r;
        }
      }
      /***************************************************************
       * determine the block type (window type)
       ***************************************************************/
      /* calculate energies of each sub-shortblocks */
      for (var i = 0; i < 3; i++) {
        en_subshort[i] = gfc.nsPsy.last_en_subshort[chn][i + 6];
        assert$1(gfc.nsPsy.last_en_subshort[chn][i + 4] > 0);
        attack_intensity[i] = en_subshort[i] / gfc.nsPsy.last_en_subshort[chn][i + 4];
        en_short[0] += en_subshort[i];
      }
      for (var i = 0; i < 9; i++) {
        var pfe = pfPos + 576 / 9;
        var p = 1.;
        for (; pfPos < pfe; pfPos++) if (p < Math.abs(pf[pfPos])) p = Math.abs(pf[pfPos]);
        gfc.nsPsy.last_en_subshort[chn][i] = en_subshort[i + 3] = p;
        en_short[1 + i / 3] += p;
        if (p > en_subshort[i + 3 - 2]) {
          assert$1(en_subshort[i + 3 - 2] > 0);
          p = p / en_subshort[i + 3 - 2];
        } else if (en_subshort[i + 3 - 2] > p * 10.0) {
          p = en_subshort[i + 3 - 2] / (p * 10.0);
        } else {
          p = 0.0;
        }
        attack_intensity[i + 3] = p;
      }
      /* pulse like signal detection for fatboy.wav and so on */
      for (var i = 0; i < 3; ++i) {
        var enn = en_subshort[i * 3 + 3] + en_subshort[i * 3 + 4] + en_subshort[i * 3 + 5];
        var factor = 1.;
        if (en_subshort[i * 3 + 5] * 6 < enn) {
          factor *= 0.5;
          if (en_subshort[i * 3 + 4] * 6 < enn) {
            factor *= 0.5;
          }
        }
        sub_short_factor[chn][i] = factor;
      }
      if (gfp.analysis) {
        var x = attack_intensity[0];
        for (var i = 1; i < 12; i++) {
          if (x < attack_intensity[i]) {
            x = attack_intensity[i];
          }
        }
        gfc.pinfo.ers[gr_out][chn] = gfc.pinfo.ers_save[chn];
        gfc.pinfo.ers_save[chn] = x;
      }

      /* compare energies between sub-shortblocks */
      for (var i = 0; i < 12; i++) {
        if (0 == ns_attacks[chn][i / 3] && attack_intensity[i] > attackThreshold) {
          ns_attacks[chn][i / 3] = i % 3 + 1;
        }
      }

      /*
       * should have energy change between short blocks, in order to avoid
       * periodic signals
       */
      /* Good samples to show the effect are Trumpet test songs */
      /*
       * GB: tuned (1) to avoid too many short blocks for test sample
       * TRUMPET
       */
      /*
       * RH: tuned (2) to let enough short blocks through for test sample
       * FSOL and SNAPS
       */
      for (var i = 1; i < 4; i++) {
        var u = en_short[i - 1];
        var v = en_short[i];
        var m = Math.max(u, v);
        if (m < 40000) {
          /* (2) */
          if (u < 1.7 * v && v < 1.7 * u) {
            /* (1) */
            if (i == 1 && ns_attacks[chn][0] <= ns_attacks[chn][i]) {
              ns_attacks[chn][0] = 0;
            }
            ns_attacks[chn][i] = 0;
          }
        }
      }
      if (ns_attacks[chn][0] <= gfc.nsPsy.lastAttacks[chn]) {
        ns_attacks[chn][0] = 0;
      }
      if (gfc.nsPsy.lastAttacks[chn] == 3 || ns_attacks[chn][0] + ns_attacks[chn][1] + ns_attacks[chn][2] + ns_attacks[chn][3] != 0) {
        ns_uselongblock = 0;
        if (ns_attacks[chn][1] != 0 && ns_attacks[chn][0] != 0) {
          ns_attacks[chn][1] = 0;
        }
        if (ns_attacks[chn][2] != 0 && ns_attacks[chn][1] != 0) {
          ns_attacks[chn][2] = 0;
        }
        if (ns_attacks[chn][3] != 0 && ns_attacks[chn][2] != 0) {
          ns_attacks[chn][3] = 0;
        }
      }
      if (chn < 2) {
        uselongblock[chn] = ns_uselongblock;
      } else {
        if (ns_uselongblock == 0) {
          uselongblock[0] = uselongblock[1] = 0;
        }
      }

      /*
       * there is a one granule delay. Copy maskings computed last call
       * into masking_ratio to return to calling program.
       */
      energy[chn] = gfc.tot_ener[chn];
    }
  }
  function vbrpsy_skip_masking_s(gfc, chn, sblock) {
    if (sblock == 0) {
      for (var b = 0; b < gfc.npart_s; b++) {
        gfc.nb_s2[chn][b] = gfc.nb_s1[chn][b];
        gfc.nb_s1[chn][b] = 0;
      }
    }
  }
  function vbrpsy_skip_masking_l(gfc, chn) {
    for (var b = 0; b < gfc.npart_l; b++) {
      gfc.nb_2[chn][b] = gfc.nb_1[chn][b];
      gfc.nb_1[chn][b] = 0;
    }
  }
  function psyvbr_calc_mask_index_s(gfc, max, avg, mask_idx) {
    var last_tab_entry = tab.length - 1;
    var b = 0;
    var a = avg[b] + avg[b + 1];
    if (a > 0.0) {
      var m = max[b];
      if (m < max[b + 1]) m = max[b + 1];
      assert$1(gfc.numlines_s[b] + gfc.numlines_s[b + 1] - 1 > 0);
      a = 20.0 * (m * 2.0 - a) / (a * (gfc.numlines_s[b] + gfc.numlines_s[b + 1] - 1));
      var k = 0 | a;
      if (k > last_tab_entry) k = last_tab_entry;
      mask_idx[b] = k;
    } else {
      mask_idx[b] = 0;
    }
    for (b = 1; b < gfc.npart_s - 1; b++) {
      a = avg[b - 1] + avg[b] + avg[b + 1];
      assert$1(b + 1 < gfc.npart_s);
      if (a > 0.0) {
        var m = max[b - 1];
        if (m < max[b]) m = max[b];
        if (m < max[b + 1]) m = max[b + 1];
        assert$1(gfc.numlines_s[b - 1] + gfc.numlines_s[b] + gfc.numlines_s[b + 1] - 1 > 0);
        a = 20.0 * (m * 3.0 - a) / (a * (gfc.numlines_s[b - 1] + gfc.numlines_s[b] + gfc.numlines_s[b + 1] - 1));
        var k = 0 | a;
        if (k > last_tab_entry) k = last_tab_entry;
        mask_idx[b] = k;
      } else {
        mask_idx[b] = 0;
      }
    }
    assert$1(b == gfc.npart_s - 1);
    a = avg[b - 1] + avg[b];
    if (a > 0.0) {
      var m = max[b - 1];
      if (m < max[b]) m = max[b];
      assert$1(gfc.numlines_s[b - 1] + gfc.numlines_s[b] - 1 > 0);
      a = 20.0 * (m * 2.0 - a) / (a * (gfc.numlines_s[b - 1] + gfc.numlines_s[b] - 1));
      var k = 0 | a;
      if (k > last_tab_entry) k = last_tab_entry;
      mask_idx[b] = k;
    } else {
      mask_idx[b] = 0;
    }
    assert$1(b == gfc.npart_s - 1);
  }
  function vbrpsy_compute_masking_s(gfp, fftenergy_s, eb, thr, chn, sblock) {
    var gfc = gfp.internal_flags;
    var max = new float[Encoder$6.CBANDS](),
      avg = new_float$6(Encoder$6.CBANDS);
    var i, j, b;
    var mask_idx_s = new int[Encoder$6.CBANDS]();
    for (b = j = 0; b < gfc.npart_s; ++b) {
      var ebb = 0,
        m = 0;
      var n = gfc.numlines_s[b];
      for (i = 0; i < n; ++i, ++j) {
        var el = fftenergy_s[sblock][j];
        ebb += el;
        if (m < el) m = el;
      }
      eb[b] = ebb;
      max[b] = m;
      avg[b] = ebb / n;
      assert$1(avg[b] >= 0);
    }
    assert$1(b == gfc.npart_s);
    for (; b < Encoder$6.CBANDS; ++b) {
      max[b] = 0;
      avg[b] = 0;
    }
    psyvbr_calc_mask_index_s(gfc, max, avg, mask_idx_s);
    for (j = b = 0; b < gfc.npart_s; b++) {
      var kk = gfc.s3ind_s[b][0];
      var last = gfc.s3ind_s[b][1];
      var dd, dd_n;
      var x, ecb, avg_mask;
      dd = mask_idx_s[kk];
      dd_n = 1;
      ecb = gfc.s3_ss[j] * eb[kk] * tab[mask_idx_s[kk]];
      ++j;
      ++kk;
      while (kk <= last) {
        dd += mask_idx_s[kk];
        dd_n += 1;
        x = gfc.s3_ss[j] * eb[kk] * tab[mask_idx_s[kk]];
        ecb = vbrpsy_mask_add(ecb, x, kk - b);
        ++j;
        ++kk;
      }
      dd = (1 + 2 * dd) / (2 * dd_n);
      avg_mask = tab[dd] * 0.5;
      ecb *= avg_mask;
      thr[b] = ecb;
      gfc.nb_s2[chn][b] = gfc.nb_s1[chn][b];
      gfc.nb_s1[chn][b] = ecb;
      {
        /*
         * if THR exceeds EB, the quantization routines will take the
         * difference from other bands. in case of strong tonal samples
         * (tonaltest.wav) this leads to heavy distortions. that's why
         * we limit THR here.
         */
        x = max[b];
        x *= gfc.minval_s[b];
        x *= avg_mask;
        if (thr[b] > x) {
          thr[b] = x;
        }
      }
      if (gfc.masking_lower > 1) {
        thr[b] *= gfc.masking_lower;
      }
      if (thr[b] > eb[b]) {
        thr[b] = eb[b];
      }
      if (gfc.masking_lower < 1) {
        thr[b] *= gfc.masking_lower;
      }
      assert$1(thr[b] >= 0);
    }
    for (; b < Encoder$6.CBANDS; ++b) {
      eb[b] = 0;
      thr[b] = 0;
    }
  }
  function vbrpsy_compute_masking_l(gfc, fftenergy, eb_l, thr, chn) {
    var max = new_float$6(Encoder$6.CBANDS),
      avg = new_float$6(Encoder$6.CBANDS);
    var mask_idx_l = new_int$7(Encoder$6.CBANDS + 2);
    var b;

    /*********************************************************************
     * Calculate the energy and the tonality of each partition.
     *********************************************************************/
    calc_energy(gfc, fftenergy, eb_l, max, avg);
    calc_mask_index_l(gfc, max, avg, mask_idx_l);

    /*********************************************************************
     * convolve the partitioned energy and unpredictability with the
     * spreading function, s3_l[b][k]
     ********************************************************************/
    var k = 0;
    for (b = 0; b < gfc.npart_l; b++) {
      var x, ecb, avg_mask, t;
      /* convolve the partitioned energy with the spreading function */
      var kk = gfc.s3ind[b][0];
      var last = gfc.s3ind[b][1];
      var dd = 0,
        dd_n = 0;
      dd = mask_idx_l[kk];
      dd_n += 1;
      ecb = gfc.s3_ll[k] * eb_l[kk] * tab[mask_idx_l[kk]];
      ++k;
      ++kk;
      while (kk <= last) {
        dd += mask_idx_l[kk];
        dd_n += 1;
        x = gfc.s3_ll[k] * eb_l[kk] * tab[mask_idx_l[kk]];
        t = vbrpsy_mask_add(ecb, x, kk - b);
        ecb = t;
        ++k;
        ++kk;
      }
      dd = (1 + 2 * dd) / (2 * dd_n);
      avg_mask = tab[dd] * 0.5;
      ecb *= avg_mask;

      /**** long block pre-echo control ****/
      /**
       * <PRE>
       * dont use long block pre-echo control if previous granule was
       * a short block.  This is to avoid the situation:
       * frame0:  quiet (very low masking)
       * frame1:  surge  (triggers short blocks)
       * frame2:  regular frame.  looks like pre-echo when compared to
       *          frame0, but all pre-echo was in frame1.
       * </PRE>
       */
      /*
       * chn=0,1 L and R channels chn=2,3 S and M channels.
       */
      if (gfc.blocktype_old[chn & 0x01] == Encoder$6.SHORT_TYPE) {
        var ecb_limit = rpelev * gfc.nb_1[chn][b];
        if (ecb_limit > 0) {
          thr[b] = Math.min(ecb, ecb_limit);
        } else {
          /**
           * <PRE>
           * Robert 071209:
           * Because we don't calculate long block psy when we know a granule
           * should be of short blocks, we don't have any clue how the granule
           * before would have looked like as a long block. So we have to guess
           * a little bit for this END_TYPE block.
           * Most of the time we get away with this sloppyness. (fingers crossed :)
           * The speed increase is worth it.
           * </PRE>
           */
          thr[b] = Math.min(ecb, eb_l[b] * NS_PREECHO_ATT2);
        }
      } else {
        var ecb_limit_2 = rpelev2 * gfc.nb_2[chn][b];
        var ecb_limit_1 = rpelev * gfc.nb_1[chn][b];
        var ecb_limit;
        if (ecb_limit_2 <= 0) {
          ecb_limit_2 = ecb;
        }
        if (ecb_limit_1 <= 0) {
          ecb_limit_1 = ecb;
        }
        if (gfc.blocktype_old[chn & 0x01] == Encoder$6.NORM_TYPE) {
          ecb_limit = Math.min(ecb_limit_1, ecb_limit_2);
        } else {
          ecb_limit = ecb_limit_1;
        }
        thr[b] = Math.min(ecb, ecb_limit);
      }
      gfc.nb_2[chn][b] = gfc.nb_1[chn][b];
      gfc.nb_1[chn][b] = ecb;
      {
        /*
         * if THR exceeds EB, the quantization routines will take the
         * difference from other bands. in case of strong tonal samples
         * (tonaltest.wav) this leads to heavy distortions. that's why
         * we limit THR here.
         */
        x = max[b];
        x *= gfc.minval_l[b];
        x *= avg_mask;
        if (thr[b] > x) {
          thr[b] = x;
        }
      }
      if (gfc.masking_lower > 1) {
        thr[b] *= gfc.masking_lower;
      }
      if (thr[b] > eb_l[b]) {
        thr[b] = eb_l[b];
      }
      if (gfc.masking_lower < 1) {
        thr[b] *= gfc.masking_lower;
      }
      assert$1(thr[b] >= 0);
    }
    for (; b < Encoder$6.CBANDS; ++b) {
      eb_l[b] = 0;
      thr[b] = 0;
    }
  }
  function vbrpsy_compute_block_type(gfp, uselongblock) {
    var gfc = gfp.internal_flags;
    if (gfp.short_blocks == ShortBlock.short_block_coupled
    /* force both channels to use the same block type */
    /* this is necessary if the frame is to be encoded in ms_stereo. */
    /* But even without ms_stereo, FhG does this */ && !(uselongblock[0] != 0 && uselongblock[1] != 0)) uselongblock[0] = uselongblock[1] = 0;
    for (var chn = 0; chn < gfc.channels_out; chn++) {
      /* disable short blocks */
      if (gfp.short_blocks == ShortBlock.short_block_dispensed) {
        uselongblock[chn] = 1;
      }
      if (gfp.short_blocks == ShortBlock.short_block_forced) {
        uselongblock[chn] = 0;
      }
    }
  }
  function vbrpsy_apply_block_type(gfp, uselongblock, blocktype_d) {
    var gfc = gfp.internal_flags;

    /*
     * update the blocktype of the previous granule, since it depends on
     * what happend in this granule
     */
    for (var chn = 0; chn < gfc.channels_out; chn++) {
      var blocktype = Encoder$6.NORM_TYPE;
      /* disable short blocks */

      if (uselongblock[chn] != 0) {
        /* no attack : use long blocks */
        assert$1(gfc.blocktype_old[chn] != Encoder$6.START_TYPE);
        if (gfc.blocktype_old[chn] == Encoder$6.SHORT_TYPE) blocktype = Encoder$6.STOP_TYPE;
      } else {
        /* attack : use short blocks */
        blocktype = Encoder$6.SHORT_TYPE;
        if (gfc.blocktype_old[chn] == Encoder$6.NORM_TYPE) {
          gfc.blocktype_old[chn] = Encoder$6.START_TYPE;
        }
        if (gfc.blocktype_old[chn] == Encoder$6.STOP_TYPE) gfc.blocktype_old[chn] = Encoder$6.SHORT_TYPE;
      }
      blocktype_d[chn] = gfc.blocktype_old[chn];
      // value returned to calling program
      gfc.blocktype_old[chn] = blocktype;
      // save for next call to l3psy_anal
    }
  }

  /**
   * compute M/S thresholds from Johnston & Ferreira 1992 ICASSP paper
   */
  function vbrpsy_compute_MS_thresholds(eb, thr, cb_mld, ath_cb, athadjust, msfix, n) {
    var msfix2 = msfix * 2;
    var athlower = msfix > 0 ? Math.pow(10, athadjust) : 1;
    var rside, rmid;
    for (var b = 0; b < n; ++b) {
      var ebM = eb[2][b];
      var ebS = eb[3][b];
      var thmL = thr[0][b];
      var thmR = thr[1][b];
      var thmM = thr[2][b];
      var thmS = thr[3][b];

      /* use this fix if L & R masking differs by 2db or less */
      if (thmL <= 1.58 * thmR && thmR <= 1.58 * thmL) {
        var mld_m = cb_mld[b] * ebS;
        var mld_s = cb_mld[b] * ebM;
        rmid = Math.max(thmM, Math.min(thmS, mld_m));
        rside = Math.max(thmS, Math.min(thmM, mld_s));
      } else {
        rmid = thmM;
        rside = thmS;
      }
      if (msfix > 0) {
        /***************************************************************/
        /* Adjust M/S maskings if user set "msfix" */
        /***************************************************************/
        /* Naoki Shibata 2000 */
        var thmLR, thmMS;
        var ath = ath_cb[b] * athlower;
        thmLR = Math.min(Math.max(thmL, ath), Math.max(thmR, ath));
        thmM = Math.max(rmid, ath);
        thmS = Math.max(rside, ath);
        thmMS = thmM + thmS;
        if (thmMS > 0 && thmLR * msfix2 < thmMS) {
          var f = thmLR * msfix2 / thmMS;
          thmM *= f;
          thmS *= f;
        }
        rmid = Math.min(thmM, rmid);
        rside = Math.min(thmS, rside);
      }
      if (rmid > ebM) {
        rmid = ebM;
      }
      if (rside > ebS) {
        rside = ebS;
      }
      thr[2][b] = rmid;
      thr[3][b] = rside;
    }
  }
  this.L3psycho_anal_vbr = function (gfp, buffer, bufPos, gr_out, masking_ratio, masking_MS_ratio, percep_entropy, percep_MS_entropy, energy, blocktype_d) {
    var gfc = gfp.internal_flags;

    /* fft and energy calculation */
    var wsamp_l;
    var wsamp_s;
    var fftenergy = new_float$6(Encoder$6.HBLKSIZE);
    var fftenergy_s = new_float_n$2([3, Encoder$6.HBLKSIZE_s]);
    var wsamp_L = new_float_n$2([2, Encoder$6.BLKSIZE]);
    var wsamp_S = new_float_n$2([2, 3, Encoder$6.BLKSIZE_s]);
    var eb = new_float_n$2([4, Encoder$6.CBANDS]),
      thr = new_float_n$2([4, Encoder$6.CBANDS]);
    var sub_short_factor = new_float_n$2([4, 3]);
    var pcfact = 0.6;

    /* block type */
    var ns_attacks = [[0, 0, 0, 0], [0, 0, 0, 0], [0, 0, 0, 0], [0, 0, 0, 0]];
    var uselongblock = new_int$7(2);

    /* usual variables like loop indices, etc.. */

    /* chn=2 and 3 = Mid and Side channels */
    var n_chn_psy = gfp.mode == MPEGMode.JOINT_STEREO ? 4 : gfc.channels_out;
    vbrpsy_attack_detection(gfp, buffer, bufPos, gr_out, masking_ratio, masking_MS_ratio, energy, sub_short_factor, ns_attacks, uselongblock);
    vbrpsy_compute_block_type(gfp, uselongblock);

    /* LONG BLOCK CASE */
    {
      for (var chn = 0; chn < n_chn_psy; chn++) {
        var ch01 = chn & 0x01;
        wsamp_l = wsamp_L;
        vbrpsy_compute_fft_l(gfp, buffer, bufPos, chn, gr_out, fftenergy, wsamp_l, ch01);
        vbrpsy_compute_loudness_approximation_l(gfp, gr_out, chn, fftenergy);
        if (uselongblock[ch01] != 0) {
          vbrpsy_compute_masking_l(gfc, fftenergy, eb[chn], thr[chn], chn);
        } else {
          vbrpsy_skip_masking_l(gfc, chn);
        }
      }
      if (uselongblock[0] + uselongblock[1] == 2) {
        /* M/S channel */
        if (gfp.mode == MPEGMode.JOINT_STEREO) {
          vbrpsy_compute_MS_thresholds(eb, thr, gfc.mld_cb_l, gfc.ATH.cb_l, gfp.ATHlower * gfc.ATH.adjust, gfp.msfix, gfc.npart_l);
        }
      }
      /* TODO: apply adaptive ATH masking here ?? */
      for (var chn = 0; chn < n_chn_psy; chn++) {
        var ch01 = chn & 0x01;
        if (uselongblock[ch01] != 0) {
          convert_partition2scalefac_l(gfc, eb[chn], thr[chn], chn);
        }
      }
    }

    /* SHORT BLOCKS CASE */
    {
      for (var sblock = 0; sblock < 3; sblock++) {
        for (var chn = 0; chn < n_chn_psy; ++chn) {
          var ch01 = chn & 0x01;
          if (uselongblock[ch01] != 0) {
            vbrpsy_skip_masking_s(gfc, chn, sblock);
          } else {
            /* compute masking thresholds for short blocks */
            wsamp_s = wsamp_S;
            vbrpsy_compute_fft_s(gfp, buffer, bufPos, chn, sblock, fftenergy_s, wsamp_s, ch01);
            vbrpsy_compute_masking_s(gfp, fftenergy_s, eb[chn], thr[chn], chn, sblock);
          }
        }
        if (uselongblock[0] + uselongblock[1] == 0) {
          /* M/S channel */
          if (gfp.mode == MPEGMode.JOINT_STEREO) {
            vbrpsy_compute_MS_thresholds(eb, thr, gfc.mld_cb_s, gfc.ATH.cb_s, gfp.ATHlower * gfc.ATH.adjust, gfp.msfix, gfc.npart_s);
          }
          /* L/R channel */
        }
        /* TODO: apply adaptive ATH masking here ?? */
        for (var chn = 0; chn < n_chn_psy; ++chn) {
          var ch01 = chn & 0x01;
          if (0 == uselongblock[ch01]) {
            convert_partition2scalefac_s(gfc, eb[chn], thr[chn], chn, sblock);
          }
        }
      }

      /**** short block pre-echo control ****/
      for (var chn = 0; chn < n_chn_psy; chn++) {
        var ch01 = chn & 0x01;
        if (uselongblock[ch01] != 0) {
          continue;
        }
        for (var sb = 0; sb < Encoder$6.SBMAX_s; sb++) {
          var new_thmm = new_float$6(3);
          for (var sblock = 0; sblock < 3; sblock++) {
            var thmm = gfc.thm[chn].s[sb][sblock];
            thmm *= NS_PREECHO_ATT0;
            if (ns_attacks[chn][sblock] >= 2 || ns_attacks[chn][sblock + 1] == 1) {
              var idx = sblock != 0 ? sblock - 1 : 2;
              var p = NS_INTERP(gfc.thm[chn].s[sb][idx], thmm, NS_PREECHO_ATT1 * pcfact);
              thmm = Math.min(thmm, p);
            } else if (ns_attacks[chn][sblock] == 1) {
              var idx = sblock != 0 ? sblock - 1 : 2;
              var p = NS_INTERP(gfc.thm[chn].s[sb][idx], thmm, NS_PREECHO_ATT2 * pcfact);
              thmm = Math.min(thmm, p);
            } else if (sblock != 0 && ns_attacks[chn][sblock - 1] == 3 || sblock == 0 && gfc.nsPsy.lastAttacks[chn] == 3) {
              var idx = sblock != 2 ? sblock + 1 : 0;
              var p = NS_INTERP(gfc.thm[chn].s[sb][idx], thmm, NS_PREECHO_ATT2 * pcfact);
              thmm = Math.min(thmm, p);
            }

            /* pulse like signal detection for fatboy.wav and so on */
            thmm *= sub_short_factor[chn][sblock];
            new_thmm[sblock] = thmm;
          }
          for (var sblock = 0; sblock < 3; sblock++) {
            gfc.thm[chn].s[sb][sblock] = new_thmm[sblock];
          }
        }
      }
    }
    for (var chn = 0; chn < n_chn_psy; chn++) {
      gfc.nsPsy.lastAttacks[chn] = ns_attacks[chn][2];
    }

    /***************************************************************
     * determine final block type
     ***************************************************************/
    vbrpsy_apply_block_type(gfp, uselongblock, blocktype_d);

    /*********************************************************************
     * compute the value of PE to return ... no delay and advance
     *********************************************************************/
    for (var chn = 0; chn < n_chn_psy; chn++) {
      var ppe;
      var ppePos;
      var type;
      var mr;
      if (chn > 1) {
        ppe = percep_MS_entropy;
        ppePos = -2;
        type = Encoder$6.NORM_TYPE;
        if (blocktype_d[0] == Encoder$6.SHORT_TYPE || blocktype_d[1] == Encoder$6.SHORT_TYPE) type = Encoder$6.SHORT_TYPE;
        mr = masking_MS_ratio[gr_out][chn - 2];
      } else {
        ppe = percep_entropy;
        ppePos = 0;
        type = blocktype_d[chn];
        mr = masking_ratio[gr_out][chn];
      }
      if (type == Encoder$6.SHORT_TYPE) {
        ppe[ppePos + chn] = pecalc_s(mr, gfc.masking_lower);
      } else {
        ppe[ppePos + chn] = pecalc_l(mr, gfc.masking_lower);
      }
      if (gfp.analysis) {
        gfc.pinfo.pe[gr_out][chn] = ppe[ppePos + chn];
      }
    }
    return 0;
  };
  function s3_func_x(bark, hf_slope) {
    var tempx = bark,
      tempy;
    if (tempx >= 0) {
      tempy = -tempx * 27;
    } else {
      tempy = tempx * hf_slope;
    }
    if (tempy <= -72.0) {
      return 0;
    }
    return Math.exp(tempy * LN_TO_LOG10);
  }
  function norm_s3_func_x(hf_slope) {
    var lim_a = 0,
      lim_b = 0;
    {
      var x = 0,
        l,
        h;
      for (x = 0; s3_func_x(x, hf_slope) > 1e-20; x -= 1);
      l = x;
      h = 0;
      while (Math.abs(h - l) > 1e-12) {
        x = (h + l) / 2;
        if (s3_func_x(x, hf_slope) > 0) {
          h = x;
        } else {
          l = x;
        }
      }
      lim_a = l;
    }
    {
      var x = 0,
        l,
        h;
      for (x = 0; s3_func_x(x, hf_slope) > 1e-20; x += 1);
      l = 0;
      h = x;
      while (Math.abs(h - l) > 1e-12) {
        x = (h + l) / 2;
        if (s3_func_x(x, hf_slope) > 0) {
          l = x;
        } else {
          h = x;
        }
      }
      lim_b = h;
    }
    {
      var sum = 0;
      var m = 1000;
      var i;
      for (i = 0; i <= m; ++i) {
        var x = lim_a + i * (lim_b - lim_a) / m;
        var y = s3_func_x(x, hf_slope);
        sum += y;
      }
      {
        var norm = (m + 1) / (sum * (lim_b - lim_a));
        /* printf( "norm = %lf\n",norm); */
        return norm;
      }
    }
  }

  /**
   *   The spreading function.  Values returned in units of energy
   */
  function s3_func(bark) {
    var tempx, x, tempy, temp;
    tempx = bark;
    if (tempx >= 0) tempx *= 3;else tempx *= 1.5;
    if (tempx >= 0.5 && tempx <= 2.5) {
      temp = tempx - 0.5;
      x = 8.0 * (temp * temp - 2.0 * temp);
    } else x = 0.0;
    tempx += 0.474;
    tempy = 15.811389 + 7.5 * tempx - 17.5 * Math.sqrt(1.0 + tempx * tempx);
    if (tempy <= -60.0) return 0.0;
    tempx = Math.exp((x + tempy) * LN_TO_LOG10);

    /**
     * <PRE>
     * Normalization.  The spreading function should be normalized so that:
     * +inf
     * /
     * |  s3 [ bark ]  d(bark)   =  1
     * /
     * -inf
     * </PRE>
     */
    tempx /= .6609193;
    return tempx;
  }

  /**
   * see for example "Zwicker: Psychoakustik, 1982; ISBN 3-540-11401-7
   */
  function freq2bark(freq) {
    /* input: freq in hz output: barks */
    if (freq < 0) freq = 0;
    freq = freq * 0.001;
    return 13.0 * Math.atan(.76 * freq) + 3.5 * Math.atan(freq * freq / (7.5 * 7.5));
  }
  function init_numline(numlines, bo, bm, bval, bval_width, mld, bo_w, sfreq, blksize, scalepos, deltafreq, sbmax) {
    var b_frq = new_float$6(Encoder$6.CBANDS + 1);
    var sample_freq_frac = sfreq / (sbmax > 15 ? 2 * 576 : 2 * 192);
    var partition = new_int$7(Encoder$6.HBLKSIZE);
    var i;
    sfreq /= blksize;
    var j = 0;
    var ni = 0;
    /* compute numlines, the number of spectral lines in each partition band */
    /* each partition band should be about DELBARK wide. */
    for (i = 0; i < Encoder$6.CBANDS; i++) {
      var bark1;
      var j2;
      bark1 = freq2bark(sfreq * j);
      b_frq[i] = sfreq * j;
      for (j2 = j; freq2bark(sfreq * j2) - bark1 < DELBARK && j2 <= blksize / 2; j2++);
      numlines[i] = j2 - j;
      ni = i + 1;
      while (j < j2) {
        assert$1(j < Encoder$6.HBLKSIZE);
        partition[j++] = i;
      }
      if (j > blksize / 2) {
        j = blksize / 2;
        ++i;
        break;
      }
    }
    assert$1(i < Encoder$6.CBANDS);
    b_frq[i] = sfreq * j;
    for (var sfb = 0; sfb < sbmax; sfb++) {
      var i1, i2, start, end;
      var arg;
      start = scalepos[sfb];
      end = scalepos[sfb + 1];
      i1 = 0 | Math.floor(.5 + deltafreq * (start - .5));
      if (i1 < 0) i1 = 0;
      i2 = 0 | Math.floor(.5 + deltafreq * (end - .5));
      if (i2 > blksize / 2) i2 = blksize / 2;
      bm[sfb] = (partition[i1] + partition[i2]) / 2;
      bo[sfb] = partition[i2];
      var f_tmp = sample_freq_frac * end;
      /*
       * calculate how much of this band belongs to current scalefactor
       * band
       */
      bo_w[sfb] = (f_tmp - b_frq[bo[sfb]]) / (b_frq[bo[sfb] + 1] - b_frq[bo[sfb]]);
      if (bo_w[sfb] < 0) {
        bo_w[sfb] = 0;
      } else {
        if (bo_w[sfb] > 1) {
          bo_w[sfb] = 1;
        }
      }
      /* setup stereo demasking thresholds */
      /* formula reverse enginerred from plot in paper */
      arg = freq2bark(sfreq * scalepos[sfb] * deltafreq);
      arg = Math.min(arg, 15.5) / 15.5;
      mld[sfb] = Math.pow(10.0, 1.25 * (1 - Math.cos(Math.PI * arg)) - 2.5);
    }

    /* compute bark values of each critical band */
    j = 0;
    for (var k = 0; k < ni; k++) {
      var w = numlines[k];
      var bark1, bark2;
      bark1 = freq2bark(sfreq * j);
      bark2 = freq2bark(sfreq * (j + w - 1));
      bval[k] = .5 * (bark1 + bark2);
      bark1 = freq2bark(sfreq * (j - .5));
      bark2 = freq2bark(sfreq * (j + w - .5));
      bval_width[k] = bark2 - bark1;
      j += w;
    }
    return ni;
  }
  function init_s3_values(s3ind, npart, bval, bval_width, norm, use_old_s3) {
    var s3 = new_float_n$2([Encoder$6.CBANDS, Encoder$6.CBANDS]);
    /*
     * The s3 array is not linear in the bark scale.
     *
     * bval[x] should be used to get the bark value.
     */
    var j;
    var numberOfNoneZero = 0;

    /**
     * <PRE>
     * s[i][j], the value of the spreading function,
     * centered at band j (masker), for band i (maskee)
     *
     * i.e.: sum over j to spread into signal barkval=i
     * NOTE: i and j are used opposite as in the ISO docs
     * </PRE>
     */
    if (use_old_s3) {
      for (var i = 0; i < npart; i++) {
        for (j = 0; j < npart; j++) {
          var v = s3_func(bval[i] - bval[j]) * bval_width[j];
          s3[i][j] = v * norm[i];
        }
      }
    } else {
      for (j = 0; j < npart; j++) {
        var hf_slope = 15 + Math.min(21 / bval[j], 12);
        var s3_x_norm = norm_s3_func_x(hf_slope);
        for (var i = 0; i < npart; i++) {
          var v = s3_x_norm * s3_func_x(bval[i] - bval[j], hf_slope) * bval_width[j];
          s3[i][j] = v * norm[i];
        }
      }
    }
    for (var i = 0; i < npart; i++) {
      for (j = 0; j < npart; j++) {
        if (s3[i][j] > 0.0) break;
      }
      s3ind[i][0] = j;
      for (j = npart - 1; j > 0; j--) {
        if (s3[i][j] > 0.0) break;
      }
      s3ind[i][1] = j;
      numberOfNoneZero += s3ind[i][1] - s3ind[i][0] + 1;
    }
    var p = new_float$6(numberOfNoneZero);
    var k = 0;
    for (var i = 0; i < npart; i++) for (j = s3ind[i][0]; j <= s3ind[i][1]; j++) p[k++] = s3[i][j];
    return p;
  }
  function stereo_demask(f) {
    /* setup stereo demasking thresholds */
    /* formula reverse enginerred from plot in paper */
    var arg = freq2bark(f);
    arg = Math.min(arg, 15.5) / 15.5;
    return Math.pow(10.0, 1.25 * (1 - Math.cos(Math.PI * arg)) - 2.5);
  }

  /**
   * NOTE: the bitrate reduction from the inter-channel masking effect is low
   * compared to the chance of getting annyoing artefacts. L3psycho_anal_vbr
   * does not use this feature. (Robert 071216)
   */
  this.psymodel_init = function (gfp) {
    var gfc = gfp.internal_flags;
    var i;
    var useOldS3 = true;
    var bvl_a = 13,
      bvl_b = 24;
    var snr_l_a = 0,
      snr_l_b = 0;
    var snr_s_a = -8.25,
      snr_s_b = -4.5;
    var bval = new_float$6(Encoder$6.CBANDS);
    var bval_width = new_float$6(Encoder$6.CBANDS);
    var norm = new_float$6(Encoder$6.CBANDS);
    var sfreq = gfp.out_samplerate;
    switch (gfp.experimentalZ) {
      default:
      case 0:
        useOldS3 = true;
        break;
      case 1:
        useOldS3 = gfp.VBR == VbrMode.vbr_mtrh || gfp.VBR == VbrMode.vbr_mt ? false : true;
        break;
      case 2:
        useOldS3 = false;
        break;
      case 3:
        bvl_a = 8;
        snr_l_a = -1.75;
        snr_l_b = -0.0125;
        snr_s_a = -8.25;
        snr_s_b = -2.25;
        break;
    }
    gfc.ms_ener_ratio_old = .25;
    gfc.blocktype_old[0] = gfc.blocktype_old[1] = Encoder$6.NORM_TYPE;
    // the vbr header is long blocks

    for (i = 0; i < 4; ++i) {
      for (var j = 0; j < Encoder$6.CBANDS; ++j) {
        gfc.nb_1[i][j] = 1e20;
        gfc.nb_2[i][j] = 1e20;
        gfc.nb_s1[i][j] = gfc.nb_s2[i][j] = 1.0;
      }
      for (var sb = 0; sb < Encoder$6.SBMAX_l; sb++) {
        gfc.en[i].l[sb] = 1e20;
        gfc.thm[i].l[sb] = 1e20;
      }
      for (var j = 0; j < 3; ++j) {
        for (var sb = 0; sb < Encoder$6.SBMAX_s; sb++) {
          gfc.en[i].s[sb][j] = 1e20;
          gfc.thm[i].s[sb][j] = 1e20;
        }
        gfc.nsPsy.lastAttacks[i] = 0;
      }
      for (var j = 0; j < 9; j++) gfc.nsPsy.last_en_subshort[i][j] = 10.;
    }

    /* init. for loudness approx. -jd 2001 mar 27 */
    gfc.loudness_sq_save[0] = gfc.loudness_sq_save[1] = 0.0;

    /*************************************************************************
     * now compute the psychoacoustic model specific constants
     ************************************************************************/
    /* compute numlines, bo, bm, bval, bval_width, mld */

    gfc.npart_l = init_numline(gfc.numlines_l, gfc.bo_l, gfc.bm_l, bval, bval_width, gfc.mld_l, gfc.PSY.bo_l_weight, sfreq, Encoder$6.BLKSIZE, gfc.scalefac_band.l, Encoder$6.BLKSIZE / (2.0 * 576), Encoder$6.SBMAX_l);
    assert$1(gfc.npart_l < Encoder$6.CBANDS);
    /* compute the spreading function */
    for (i = 0; i < gfc.npart_l; i++) {
      var snr = snr_l_a;
      if (bval[i] >= bvl_a) {
        snr = snr_l_b * (bval[i] - bvl_a) / (bvl_b - bvl_a) + snr_l_a * (bvl_b - bval[i]) / (bvl_b - bvl_a);
      }
      norm[i] = Math.pow(10.0, snr / 10.0);
      if (gfc.numlines_l[i] > 0) {
        gfc.rnumlines_l[i] = 1.0 / gfc.numlines_l[i];
      } else {
        gfc.rnumlines_l[i] = 0;
      }
    }
    gfc.s3_ll = init_s3_values(gfc.s3ind, gfc.npart_l, bval, bval_width, norm, useOldS3);

    /* compute long block specific values, ATH and MINVAL */
    var j = 0;
    for (i = 0; i < gfc.npart_l; i++) {
      var x;

      /* ATH */
      x = Float.MAX_VALUE;
      for (var k = 0; k < gfc.numlines_l[i]; k++, j++) {
        var freq = sfreq * j / (1000.0 * Encoder$6.BLKSIZE);
        var level;
        /*
         * ATH below 100 Hz constant, not further climbing
         */
        level = this.ATHformula(freq * 1000, gfp) - 20;
        // scale to FFT units; returned value is in dB
        level = Math.pow(10., 0.1 * level);
        // convert from dB . energy
        level *= gfc.numlines_l[i];
        if (x > level) x = level;
      }
      gfc.ATH.cb_l[i] = x;

      /*
       * MINVAL. For low freq, the strength of the masking is limited by
       * minval this is an ISO MPEG1 thing, dont know if it is really
       * needed
       */
      /*
       * FIXME: it does work to reduce low-freq problems in S53-Wind-Sax
       * and lead-voice samples, but introduces some 3 kbps bit bloat too.
       * TODO: Further refinement of the shape of this hack.
       */
      x = -20 + bval[i] * 20 / 10;
      if (x > 6) {
        x = 100;
      }
      if (x < -15) {
        x = -15;
      }
      x -= 8.;
      gfc.minval_l[i] = Math.pow(10.0, x / 10.) * gfc.numlines_l[i];
    }

    /************************************************************************
     * do the same things for short blocks
     ************************************************************************/
    gfc.npart_s = init_numline(gfc.numlines_s, gfc.bo_s, gfc.bm_s, bval, bval_width, gfc.mld_s, gfc.PSY.bo_s_weight, sfreq, Encoder$6.BLKSIZE_s, gfc.scalefac_band.s, Encoder$6.BLKSIZE_s / (2.0 * 192), Encoder$6.SBMAX_s);
    assert$1(gfc.npart_s < Encoder$6.CBANDS);

    /* SNR formula. short block is normalized by SNR. is it still right ? */
    j = 0;
    for (i = 0; i < gfc.npart_s; i++) {
      var x;
      var snr = snr_s_a;
      if (bval[i] >= bvl_a) {
        snr = snr_s_b * (bval[i] - bvl_a) / (bvl_b - bvl_a) + snr_s_a * (bvl_b - bval[i]) / (bvl_b - bvl_a);
      }
      norm[i] = Math.pow(10.0, snr / 10.0);

      /* ATH */
      x = Float.MAX_VALUE;
      for (var k = 0; k < gfc.numlines_s[i]; k++, j++) {
        var freq = sfreq * j / (1000.0 * Encoder$6.BLKSIZE_s);
        var level;
        /* freq = Min(.1,freq); */
        /*
         * ATH below 100 Hz constant, not
         * further climbing
         */
        level = this.ATHformula(freq * 1000, gfp) - 20;
        // scale to FFT units; returned value is in dB
        level = Math.pow(10., 0.1 * level);
        // convert from dB . energy
        level *= gfc.numlines_s[i];
        if (x > level) x = level;
      }
      gfc.ATH.cb_s[i] = x;

      /*
       * MINVAL. For low freq, the strength of the masking is limited by
       * minval this is an ISO MPEG1 thing, dont know if it is really
       * needed
       */
      x = -7.0 + bval[i] * 7.0 / 12.0;
      if (bval[i] > 12) {
        x *= 1 + Math.log(1 + x) * 3.1;
      }
      if (bval[i] < 12) {
        x *= 1 + Math.log(1 - x) * 2.3;
      }
      if (x < -15) {
        x = -15;
      }
      x -= 8;
      gfc.minval_s[i] = Math.pow(10.0, x / 10) * gfc.numlines_s[i];
    }
    gfc.s3_ss = init_s3_values(gfc.s3ind_s, gfc.npart_s, bval, bval_width, norm, useOldS3);
    init_mask_add_max_values();
    fft.init_fft(gfc);

    /* setup temporal masking */
    gfc.decay = Math.exp(-1.0 * LOG10 / (temporalmask_sustain_sec * sfreq / 192.0));
    {
      var msfix;
      msfix = NS_MSFIX;
      if ((gfp.exp_nspsytune & 2) != 0) msfix = 1.0;
      if (Math.abs(gfp.msfix) > 0.0) msfix = gfp.msfix;
      gfp.msfix = msfix;

      /*
       * spread only from npart_l bands. Normally, we use the spreading
       * function to convolve from npart_l down to npart_l bands
       */
      for (var b = 0; b < gfc.npart_l; b++) if (gfc.s3ind[b][1] > gfc.npart_l - 1) gfc.s3ind[b][1] = gfc.npart_l - 1;
    }

    /*
     * prepare for ATH auto adjustment: we want to decrease the ATH by 12 dB
     * per second
     */
    var frame_duration = 576. * gfc.mode_gr / sfreq;
    gfc.ATH.decay = Math.pow(10., -12. / 10. * frame_duration);
    gfc.ATH.adjust = 0.01;
    /* minimum, for leading low loudness */
    gfc.ATH.adjustLimit = 1.0;
    /* on lead, allow adjust up to maximum */

    assert$1(gfc.bo_l[Encoder$6.SBMAX_l - 1] <= gfc.npart_l);
    assert$1(gfc.bo_s[Encoder$6.SBMAX_s - 1] <= gfc.npart_s);
    if (gfp.ATHtype != -1) {
      /* compute equal loudness weights (eql_w) */
      var freq;
      var freq_inc = gfp.out_samplerate / Encoder$6.BLKSIZE;
      var eql_balance = 0.0;
      freq = 0.0;
      for (i = 0; i < Encoder$6.BLKSIZE / 2; ++i) {
        /* convert ATH dB to relative power (not dB) */
        /* to determine eql_w */
        freq += freq_inc;
        gfc.ATH.eql_w[i] = 1. / Math.pow(10, this.ATHformula(freq, gfp) / 10);
        eql_balance += gfc.ATH.eql_w[i];
      }
      eql_balance = 1.0 / eql_balance;
      for (i = Encoder$6.BLKSIZE / 2; --i >= 0;) {
        /* scale weights */
        gfc.ATH.eql_w[i] *= eql_balance;
      }
    }
    {
      for (var b = j = 0; b < gfc.npart_s; ++b) {
        for (i = 0; i < gfc.numlines_s[b]; ++i) {
          ++j;
        }
      }
      for (var b = j = 0; b < gfc.npart_l; ++b) {
        for (i = 0; i < gfc.numlines_l[b]; ++i) {
          ++j;
        }
      }
    }
    j = 0;
    for (i = 0; i < gfc.npart_l; i++) {
      var freq = sfreq * (j + gfc.numlines_l[i] / 2) / (1.0 * Encoder$6.BLKSIZE);
      gfc.mld_cb_l[i] = stereo_demask(freq);
      j += gfc.numlines_l[i];
    }
    for (; i < Encoder$6.CBANDS; ++i) {
      gfc.mld_cb_l[i] = 1;
    }
    j = 0;
    for (i = 0; i < gfc.npart_s; i++) {
      var freq = sfreq * (j + gfc.numlines_s[i] / 2) / (1.0 * Encoder$6.BLKSIZE_s);
      gfc.mld_cb_s[i] = stereo_demask(freq);
      j += gfc.numlines_s[i];
    }
    for (; i < Encoder$6.CBANDS; ++i) {
      gfc.mld_cb_s[i] = 1;
    }
    return 0;
  };

  /**
   * Those ATH formulas are returning their minimum value for input = -1
   */
  function ATHformula_GB(f, value) {
    /**
     * <PRE>
     *  from Painter & Spanias
     *           modified by Gabriel Bouvigne to better fit the reality
     *           ath =    3.640 * pow(f,-0.8)
     *           - 6.800 * exp(-0.6*pow(f-3.4,2.0))
     *           + 6.000 * exp(-0.15*pow(f-8.7,2.0))
     *           + 0.6* 0.001 * pow(f,4.0);
     *
     *
     *           In the past LAME was using the Painter &Spanias formula.
     *           But we had some recurrent problems with HF content.
     *           We measured real ATH values, and found the older formula
     *           to be inaccurate in the higher part. So we made this new
     *           formula and this solved most of HF problematic test cases.
     *           The tradeoff is that in VBR mode it increases a lot the
     *           bitrate.
     * </PRE>
     */

    /*
     * This curve can be adjusted according to the VBR scale: it adjusts
     * from something close to Painter & Spanias on V9 up to Bouvigne's
     * formula for V0. This way the VBR bitrate is more balanced according
     * to the -V value.
     */

    // the following Hack allows to ask for the lowest value
    if (f < -.3) f = 3410;

    // convert to khz
    f /= 1000;
    f = Math.max(0.1, f);
    var ath = 3.640 * Math.pow(f, -0.8) - 6.800 * Math.exp(-0.6 * Math.pow(f - 3.4, 2.0)) + 6.000 * Math.exp(-0.15 * Math.pow(f - 8.7, 2.0)) + (0.6 + 0.04 * value) * 0.001 * Math.pow(f, 4.0);
    return ath;
  }
  this.ATHformula = function (f, gfp) {
    var ath;
    switch (gfp.ATHtype) {
      case 0:
        ath = ATHformula_GB(f, 9);
        break;
      case 1:
        // over sensitive, should probably be removed
        ath = ATHformula_GB(f, -1);
        break;
      case 2:
        ath = ATHformula_GB(f, 0);
        break;
      case 3:
        // modification of GB formula by Roel
        ath = ATHformula_GB(f, 1) + 6;
        break;
      case 4:
        ath = ATHformula_GB(f, gfp.ATHcurve);
        break;
      default:
        ath = ATHformula_GB(f, 0);
        break;
    }
    return ath;
  };
}
var PsyModel_1 = PsyModel;

var MPEGMode = MPEGMode_1;
function LameGlobalFlags() {
  this.class_id = 0;

  /* input description */

  /**
   * number of samples. default=-1
   */
  this.num_samples = 0;
  /**
   * input number of channels. default=2
   */
  this.num_channels = 0;
  /**
   * input_samp_rate in Hz. default=44.1 kHz
   */
  this.in_samplerate = 0;
  /**
   * output_samp_rate. default: LAME picks best value at least not used for
   * MP3 decoding: Remember 44.1 kHz MP3s and AC97
   */
  this.out_samplerate = 0;
  /**
   * scale input by this amount before encoding at least not used for MP3
   * decoding
   */
  this.scale = 0.;
  /**
   * scale input of channel 0 (left) by this amount before encoding
   */
  this.scale_left = 0.;
  /**
   * scale input of channel 1 (right) by this amount before encoding
   */
  this.scale_right = 0.;

  /* general control params */
  /**
   * collect data for a MP3 frame analyzer?
   */
  this.analysis = false;
  /**
   * add Xing VBR tag?
   */
  this.bWriteVbrTag = false;

  /**
   * use lame/mpglib to convert mp3 to wav
   */
  this.decode_only = false;
  /**
   * quality setting 0=best, 9=worst default=5
   */
  this.quality = 0;
  /**
   * see enum default = LAME picks best value
   */
  this.mode = MPEGMode.STEREO;
  /**
   * force M/S mode. requires mode=1
   */
  this.force_ms = false;
  /**
   * use free format? default=0
   */
  this.free_format = false;
  /**
   * find the RG value? default=0
   */
  this.findReplayGain = false;
  /**
   * decode on the fly? default=0
   */
  this.decode_on_the_fly = false;
  /**
   * 1 (default) writes ID3 tags, 0 not
   */
  this.write_id3tag_automatic = false;

  /*
   * set either brate>0 or compression_ratio>0, LAME will compute the value of
   * the variable not set. Default is compression_ratio = 11.025
   */
  /**
   * bitrate
   */
  this.brate = 0;
  /**
   * sizeof(wav file)/sizeof(mp3 file)
   */
  this.compression_ratio = 0.;

  /* frame params */
  /**
   * mark as copyright. default=0
   */
  this.copyright = 0;
  /**
   * mark as original. default=1
   */
  this.original = 0;
  /**
   * the MP3 'private extension' bit. Meaningless
   */
  this.extension = 0;
  /**
   * Input PCM is emphased PCM (for instance from one of the rarely emphased
   * CDs), it is STRONGLY not recommended to use this, because psycho does not
   * take it into account, and last but not least many decoders don't care
   * about these bits
   */
  this.emphasis = 0;
  /**
   * use 2 bytes per frame for a CRC checksum. default=0
   */
  this.error_protection = 0;
  /**
   * enforce ISO spec as much as possible
   */
  this.strict_ISO = false;

  /**
   * use bit reservoir?
   */
  this.disable_reservoir = false;

  /* quantization/noise shaping */
  this.quant_comp = 0;
  this.quant_comp_short = 0;
  this.experimentalY = false;
  this.experimentalZ = 0;
  this.exp_nspsytune = 0;
  this.preset = 0;

  /* VBR control */
  this.VBR = null;
  /**
   * Range [0,...,1[
   */
  this.VBR_q_frac = 0.;
  /**
   * Range [0,...,9]
   */
  this.VBR_q = 0;
  this.VBR_mean_bitrate_kbps = 0;
  this.VBR_min_bitrate_kbps = 0;
  this.VBR_max_bitrate_kbps = 0;
  /**
   * strictly enforce VBR_min_bitrate normaly, it will be violated for analog
   * silence
   */
  this.VBR_hard_min = 0;

  /* resampling and filtering */

  /**
   * freq in Hz. 0=lame choses. -1=no filter
   */
  this.lowpassfreq = 0;
  /**
   * freq in Hz. 0=lame choses. -1=no filter
   */
  this.highpassfreq = 0;
  /**
   * freq width of filter, in Hz (default=15%)
   */
  this.lowpasswidth = 0;
  /**
   * freq width of filter, in Hz (default=15%)
   */
  this.highpasswidth = 0;

  /*
   * psycho acoustics and other arguments which you should not change unless
   * you know what you are doing
   */

  this.maskingadjust = 0.;
  this.maskingadjust_short = 0.;
  /**
   * only use ATH
   */
  this.ATHonly = false;
  /**
   * only use ATH for short blocks
   */
  this.ATHshort = false;
  /**
   * disable ATH
   */
  this.noATH = false;
  /**
   * select ATH formula
   */
  this.ATHtype = 0;
  /**
   * change ATH formula 4 shape
   */
  this.ATHcurve = 0.;
  /**
   * lower ATH by this many db
   */
  this.ATHlower = 0.;
  /**
   * select ATH auto-adjust scheme
   */
  this.athaa_type = 0;
  /**
   * select ATH auto-adjust loudness calc
   */
  this.athaa_loudapprox = 0;
  /**
   * dB, tune active region of auto-level
   */
  this.athaa_sensitivity = 0.;
  this.short_blocks = null;
  /**
   * use temporal masking effect
   */
  this.useTemporal = false;
  this.interChRatio = 0.;
  /**
   * Naoki's adjustment of Mid/Side maskings
   */
  this.msfix = 0.;

  /**
   * 0 off, 1 on
   */
  this.tune = false;
  /**
   * used to pass values for debugging and stuff
   */
  this.tune_value_a = 0.;

  /************************************************************************/
  /* internal variables, do not set... */
  /* provided because they may be of use to calling application */
  /************************************************************************/

  /**
   * 0=MPEG-2/2.5 1=MPEG-1
   */
  this.version = 0;
  this.encoder_delay = 0;
  /**
   * number of samples of padding appended to input
   */
  this.encoder_padding = 0;
  this.framesize = 0;
  /**
   * number of frames encoded
   */
  this.frameNum = 0;
  /**
   * is this struct owned by calling program or lame?
   */
  this.lame_allocated_gfp = 0;
  /**************************************************************************/
  /* more internal variables are stored in this structure: */
  /**************************************************************************/
  this.internal_flags = null;
}
var LameGlobalFlags_1 = LameGlobalFlags;

var Encoder$5 = requireEncoder();
var L3Side$4 = {};

/**
 * max scalefactor band, max(SBMAX_l, SBMAX_s*3, (SBMAX_s-3)*3+8)
 */
L3Side$4.SFBMAX = Encoder$5.SBMAX_s * 3;
var L3Side_1 = L3Side$4;

//package mp3;
var common$8 = common$b;
var new_float$5 = common$8.new_float;
var new_int$6 = common$8.new_int;
var L3Side$3 = L3Side_1;
function GrInfo$1() {
  //float xr[] = new float[576];
  this.xr = new_float$5(576);
  //int l3_enc[] = new int[576];
  this.l3_enc = new_int$6(576);
  //int scalefac[] = new int[L3Side.SFBMAX];
  this.scalefac = new_int$6(L3Side$3.SFBMAX);
  this.xrpow_max = 0.;
  this.part2_3_length = 0;
  this.big_values = 0;
  this.count1 = 0;
  this.global_gain = 0;
  this.scalefac_compress = 0;
  this.block_type = 0;
  this.mixed_block_flag = 0;
  this.table_select = new_int$6(3);
  this.subblock_gain = new_int$6(3 + 1);
  this.region0_count = 0;
  this.region1_count = 0;
  this.preflag = 0;
  this.scalefac_scale = 0;
  this.count1table_select = 0;
  this.part2_length = 0;
  this.sfb_lmax = 0;
  this.sfb_smin = 0;
  this.psy_lmax = 0;
  this.sfbmax = 0;
  this.psymax = 0;
  this.sfbdivide = 0;
  this.width = new_int$6(L3Side$3.SFBMAX);
  this.window = new_int$6(L3Side$3.SFBMAX);
  this.count1bits = 0;
  /**
   * added for LSF
   */
  this.sfb_partition_table = null;
  this.slen = new_int$6(4);
  this.max_nonzero_coeff = 0;
  var self = this;
  function clone_int(array) {
    return new Int32Array(array);
  }
  function clone_float(array) {
    return new Float32Array(array);
  }
  this.assign = function (other) {
    self.xr = clone_float(other.xr); //.slice(0); //clone();
    self.l3_enc = clone_int(other.l3_enc); //.slice(0); //clone();
    self.scalefac = clone_int(other.scalefac); //.slice(0); //clone();
    self.xrpow_max = other.xrpow_max;
    self.part2_3_length = other.part2_3_length;
    self.big_values = other.big_values;
    self.count1 = other.count1;
    self.global_gain = other.global_gain;
    self.scalefac_compress = other.scalefac_compress;
    self.block_type = other.block_type;
    self.mixed_block_flag = other.mixed_block_flag;
    self.table_select = clone_int(other.table_select); //.slice(0); //clone();
    self.subblock_gain = clone_int(other.subblock_gain); //.slice(0); //.clone();
    self.region0_count = other.region0_count;
    self.region1_count = other.region1_count;
    self.preflag = other.preflag;
    self.scalefac_scale = other.scalefac_scale;
    self.count1table_select = other.count1table_select;
    self.part2_length = other.part2_length;
    self.sfb_lmax = other.sfb_lmax;
    self.sfb_smin = other.sfb_smin;
    self.psy_lmax = other.psy_lmax;
    self.sfbmax = other.sfbmax;
    self.psymax = other.psymax;
    self.sfbdivide = other.sfbdivide;
    self.width = clone_int(other.width); //.slice(0); //.clone();
    self.window = clone_int(other.window); //.slice(0); //.clone();
    self.count1bits = other.count1bits;
    self.sfb_partition_table = other.sfb_partition_table.slice(0); //.clone();
    self.slen = clone_int(other.slen); //.slice(0); //.clone();
    self.max_nonzero_coeff = other.max_nonzero_coeff;
  };
}
var GrInfo_1 = GrInfo$1;

var common$7 = common$b;
var new_int$5 = common$7.new_int;
var GrInfo = GrInfo_1;
function IIISideInfo$1() {
  this.tt = [[null, null], [null, null]];
  this.main_data_begin = 0;
  this.private_bits = 0;
  this.resvDrain_pre = 0;
  this.resvDrain_post = 0;
  this.scfsi = [new_int$5(4), new_int$5(4)];
  for (var gr = 0; gr < 2; gr++) {
    for (var ch = 0; ch < 2; ch++) {
      this.tt[gr][ch] = new GrInfo();
    }
  }
}
var IIISideInfo_1 = IIISideInfo$1;

//package mp3;

/**
 * Layer III side information.
 *
 * @author Ken
 *
 */

var common$6 = common$b;
var System$1 = common$6.System;
var new_int$4 = common$6.new_int;
var Encoder$4 = requireEncoder();
function ScaleFac$1(arrL, arrS, arr21, arr12) {
  this.l = new_int$4(1 + Encoder$4.SBMAX_l);
  this.s = new_int$4(1 + Encoder$4.SBMAX_s);
  this.psfb21 = new_int$4(1 + Encoder$4.PSFB21);
  this.psfb12 = new_int$4(1 + Encoder$4.PSFB12);
  var l = this.l;
  var s = this.s;
  if (arguments.length == 4) {
    //public ScaleFac(final int[] arrL, final int[] arrS, final int[] arr21,
    //    final int[] arr12) {
    this.arrL = arguments[0];
    this.arrS = arguments[1];
    this.arr21 = arguments[2];
    this.arr12 = arguments[3];
    System$1.arraycopy(this.arrL, 0, l, 0, Math.min(this.arrL.length, this.l.length));
    System$1.arraycopy(this.arrS, 0, s, 0, Math.min(this.arrS.length, this.s.length));
    System$1.arraycopy(this.arr21, 0, this.psfb21, 0, Math.min(this.arr21.length, this.psfb21.length));
    System$1.arraycopy(this.arr12, 0, this.psfb12, 0, Math.min(this.arr12.length, this.psfb12.length));
  }
}
var ScaleFac_1 = ScaleFac$1;

var common$5 = common$b;
var new_float$4 = common$5.new_float;
var new_float_n$1 = common$5.new_float_n;
var new_int$3 = common$5.new_int;
var Encoder$3 = requireEncoder();

//package mp3;

/**
 * Variables used for --nspsytune
 *
 * @author Ken
 *
 */
function NsPsy$1() {
  this.last_en_subshort = new_float_n$1([4, 9]);
  this.lastAttacks = new_int$3(4);
  this.pefirbuf = new_float$4(19);
  this.longfact = new_float$4(Encoder$3.SBMAX_l);
  this.shortfact = new_float$4(Encoder$3.SBMAX_s);

  /**
   * short block tuning
   */
  this.attackthre = 0.;
  this.attackthre_s = 0.;
}
var NsPsy_1 = NsPsy$1;

//package mp3;

function VBRSeekInfo$1() {
  /**
   * What we have seen so far.
   */
  this.sum = 0;
  /**
   * How many frames we have seen in this chunk.
   */
  this.seen = 0;
  /**
   * How many frames we want to collect into one chunk.
   */
  this.want = 0;
  /**
   * Actual position in our bag.
   */
  this.pos = 0;
  /**
   * Size of our bag.
   */
  this.size = 0;
  /**
   * Pointer to our bag.
   */
  this.bag = null;
  this.nVbrNumFrames = 0;
  this.nBytesWritten = 0;
  /* VBR tag data */
  this.TotalFrameSize = 0;
}
var VBRSeekInfo_1 = VBRSeekInfo$1;

var common$4 = common$b;
var new_byte = common$4.new_byte;
var new_double = common$4.new_double;
var new_float$3 = common$4.new_float;
var new_float_n = common$4.new_float_n;
var new_int$2 = common$4.new_int;
var new_int_n = common$4.new_int_n;
var IIISideInfo = IIISideInfo_1;
var ScaleFac = ScaleFac_1;
var NsPsy = NsPsy_1;
var VBRSeekInfo = VBRSeekInfo_1;
var III_psy_xmin = requireIII_psy_xmin();
var Encoder$2 = requireEncoder();
var L3Side$2 = L3Side_1;
LameInternalFlags$1.MFSIZE = 3 * 1152 + Encoder$2.ENCDELAY - Encoder$2.MDCTDELAY;
LameInternalFlags$1.MAX_HEADER_BUF = 256;
LameInternalFlags$1.MAX_BITS_PER_CHANNEL = 4095;
LameInternalFlags$1.MAX_BITS_PER_GRANULE = 7680;
LameInternalFlags$1.BPC = 320;
function LameInternalFlags$1() {
  var MAX_HEADER_LEN = 40;

  /********************************************************************
   * internal variables NOT set by calling program, and should not be *
   * modified by the calling program *
   ********************************************************************/

  /**
   * Some remarks to the Class_ID field: The Class ID is an Identifier for a
   * pointer to this struct. It is very unlikely that a pointer to
   * lame_global_flags has the same 32 bits in it's structure (large and other
   * special properties, for instance prime).
   *
   * To test that the structure is right and initialized, use: if ( gfc .
   * Class_ID == LAME_ID ) ... Other remark: If you set a flag to 0 for uninit
   * data and 1 for init data, the right test should be "if (flag == 1)" and
   * NOT "if (flag)". Unintended modification of this element will be
   * otherwise misinterpreted as an init.
   */
  this.Class_ID = 0;
  this.lame_encode_frame_init = 0;
  this.iteration_init_init = 0;
  this.fill_buffer_resample_init = 0;

  //public float mfbuf[][] = new float[2][MFSIZE];
  this.mfbuf = new_float_n([2, LameInternalFlags$1.MFSIZE]);

  /**
   * granules per frame
   */
  this.mode_gr = 0;
  /**
   * number of channels in the input data stream (PCM or decoded PCM)
   */
  this.channels_in = 0;
  /**
   * number of channels in the output data stream (not used for decoding)
   */
  this.channels_out = 0;
  /**
   * input_samp_rate/output_samp_rate
   */
  //public double resample_ratio;
  this.resample_ratio = 0.;
  this.mf_samples_to_encode = 0;
  this.mf_size = 0;
  /**
   * min bitrate index
   */
  this.VBR_min_bitrate = 0;
  /**
   * max bitrate index
   */
  this.VBR_max_bitrate = 0;
  this.bitrate_index = 0;
  this.samplerate_index = 0;
  this.mode_ext = 0;

  /* lowpass and highpass filter control */
  /**
   * normalized frequency bounds of passband
   */
  this.lowpass1 = 0.;
  this.lowpass2 = 0.;
  /**
   * normalized frequency bounds of passband
   */
  this.highpass1 = 0.;
  this.highpass2 = 0.;

  /**
   * 0 = none 1 = ISO AAC model 2 = allow scalefac_select=1
   */
  this.noise_shaping = 0;

  /**
   * 0 = ISO model: amplify all distorted bands<BR>
   * 1 = amplify within 50% of max (on db scale)<BR>
   * 2 = amplify only most distorted band<BR>
   * 3 = method 1 and refine with method 2<BR>
   */
  this.noise_shaping_amp = 0;
  /**
   * 0 = no substep<BR>
   * 1 = use substep shaping at last step(VBR only)<BR>
   * (not implemented yet)<BR>
   * 2 = use substep inside loop<BR>
   * 3 = use substep inside loop and last step<BR>
   */
  this.substep_shaping = 0;

  /**
   * 1 = gpsycho. 0 = none
   */
  this.psymodel = 0;
  /**
   * 0 = stop at over=0, all scalefacs amplified or<BR>
   * a scalefac has reached max value<BR>
   * 1 = stop when all scalefacs amplified or a scalefac has reached max value<BR>
   * 2 = stop when all scalefacs amplified
   */
  this.noise_shaping_stop = 0;

  /**
   * 0 = no, 1 = yes
   */
  this.subblock_gain = 0;
  /**
   * 0 = no. 1=outside loop 2=inside loop(slow)
   */
  this.use_best_huffman = 0;

  /**
   * 0 = stop early after 0 distortion found. 1 = full search
   */
  this.full_outer_loop = 0;

  //public IIISideInfo l3_side = new IIISideInfo();
  this.l3_side = new IIISideInfo();
  this.ms_ratio = new_float$3(2);

  /* used for padding */
  /**
   * padding for the current frame?
   */
  this.padding = 0;
  this.frac_SpF = 0;
  this.slot_lag = 0;

  /**
   * optional ID3 tags
   */
  //public ID3TagSpec tag_spec;
  this.tag_spec = null;
  this.nMusicCRC = 0;

  /* variables used by Quantize */
  //public int OldValue[] = new int[2];
  this.OldValue = new_int$2(2);
  //public int CurrentStep[] = new int[2];
  this.CurrentStep = new_int$2(2);
  this.masking_lower = 0.;
  //public int bv_scf[] = new int[576];
  this.bv_scf = new_int$2(576);
  //public int pseudohalf[] = new int[L3Side.SFBMAX];
  this.pseudohalf = new_int$2(L3Side$2.SFBMAX);

  /**
   * will be set in lame_init_params
   */
  this.sfb21_extra = false;

  /* BPC = maximum number of filter convolution windows to precompute */
  //public float[][] inbuf_old = new float[2][];
  this.inbuf_old = new Array(2);
  //public float[][] blackfilt = new float[2 * BPC + 1][];
  this.blackfilt = new Array(2 * LameInternalFlags$1.BPC + 1);
  //public double itime[] = new double[2];
  this.itime = new_double(2);
  this.sideinfo_len = 0;

  /* variables for newmdct.c */
  //public float sb_sample[][][][] = new float[2][2][18][Encoder.SBLIMIT];
  this.sb_sample = new_float_n([2, 2, 18, Encoder$2.SBLIMIT]);
  this.amp_filter = new_float$3(32);

  /* variables for BitStream */

  /**
   * <PRE>
   * mpeg1: buffer=511 bytes  smallest frame: 96-38(sideinfo)=58
   * max number of frames in reservoir:  8
   * mpeg2: buffer=255 bytes.  smallest frame: 24-23bytes=1
   * with VBR, if you are encoding all silence, it is possible to
   * have 8kbs/24khz frames with 1byte of data each, which means we need
   * to buffer up to 255 headers!
   * </PRE>
   */
  /**
   * also, max_header_buf has to be a power of two
   */
  /**
   * max size of header is 38
   */

  function Header() {
    this.write_timing = 0;
    this.ptr = 0;
    //public byte buf[] = new byte[MAX_HEADER_LEN];
    this.buf = new_byte(MAX_HEADER_LEN);
  }
  this.header = new Array(LameInternalFlags$1.MAX_HEADER_BUF);
  this.h_ptr = 0;
  this.w_ptr = 0;
  this.ancillary_flag = 0;

  /* variables for Reservoir */
  /**
   * in bits
   */
  this.ResvSize = 0;
  /**
   * in bits
   */
  this.ResvMax = 0;

  //public ScaleFac scalefac_band = new ScaleFac();
  this.scalefac_band = new ScaleFac();

  /* daa from PsyModel */
  /* The static variables "r", "phi_sav", "new", "old" and "oldest" have */
  /* to be remembered for the unpredictability measure. For "r" and */
  /* "phi_sav", the first index from the left is the channel select and */
  /* the second index is the "age" of the data. */
  this.minval_l = new_float$3(Encoder$2.CBANDS);
  this.minval_s = new_float$3(Encoder$2.CBANDS);
  this.nb_1 = new_float_n([4, Encoder$2.CBANDS]);
  this.nb_2 = new_float_n([4, Encoder$2.CBANDS]);
  this.nb_s1 = new_float_n([4, Encoder$2.CBANDS]);
  this.nb_s2 = new_float_n([4, Encoder$2.CBANDS]);
  this.s3_ss = null;
  this.s3_ll = null;
  this.decay = 0.;

  //public III_psy_xmin[] thm = new III_psy_xmin[4];
  //public III_psy_xmin[] en = new III_psy_xmin[4];
  this.thm = new Array(4);
  this.en = new Array(4);

  /**
   * fft and energy calculation
   */
  this.tot_ener = new_float$3(4);

  /* loudness calculation (for adaptive threshold of hearing) */
  /**
   * loudness^2 approx. per granule and channel
   */
  this.loudness_sq = new_float_n([2, 2]);
  /**
   * account for granule delay of L3psycho_anal
   */
  this.loudness_sq_save = new_float$3(2);

  /**
   * Scale Factor Bands
   */
  this.mld_l = new_float$3(Encoder$2.SBMAX_l);
  this.mld_s = new_float$3(Encoder$2.SBMAX_s);
  this.bm_l = new_int$2(Encoder$2.SBMAX_l);
  this.bo_l = new_int$2(Encoder$2.SBMAX_l);
  this.bm_s = new_int$2(Encoder$2.SBMAX_s);
  this.bo_s = new_int$2(Encoder$2.SBMAX_s);
  this.npart_l = 0;
  this.npart_s = 0;
  this.s3ind = new_int_n([Encoder$2.CBANDS, 2]);
  this.s3ind_s = new_int_n([Encoder$2.CBANDS, 2]);
  this.numlines_s = new_int$2(Encoder$2.CBANDS);
  this.numlines_l = new_int$2(Encoder$2.CBANDS);
  this.rnumlines_l = new_float$3(Encoder$2.CBANDS);
  this.mld_cb_l = new_float$3(Encoder$2.CBANDS);
  this.mld_cb_s = new_float$3(Encoder$2.CBANDS);
  this.numlines_s_num1 = 0;
  this.numlines_l_num1 = 0;

  /* ratios */
  this.pe = new_float$3(4);
  this.ms_ratio_s_old = 0.;
  this.ms_ratio_l_old = 0.;
  this.ms_ener_ratio_old = 0.;

  /**
   * block type
   */
  this.blocktype_old = new_int$2(2);

  /**
   * variables used for --nspsytune
   */
  this.nsPsy = new NsPsy();

  /**
   * used for Xing VBR header
   */
  this.VBR_seek_table = new VBRSeekInfo();

  /**
   * all ATH related stuff
   */
  //public ATH ATH;
  this.ATH = null;
  this.PSY = null;
  this.nogap_total = 0;
  this.nogap_current = 0;

  /* ReplayGain */
  this.decode_on_the_fly = true;
  this.findReplayGain = true;
  this.findPeakSample = true;
  this.PeakSample = 0.;
  this.RadioGain = 0;
  this.AudiophileGain = 0;
  //public ReplayGain rgdata;
  this.rgdata = null;

  /**
   * gain change required for preventing clipping
   */
  this.noclipGainChange = 0;
  /**
   * user-specified scale factor required for preventing clipping
   */
  this.noclipScale = 0.;

  /* simple statistics */
  this.bitrate_stereoMode_Hist = new_int_n([16, 4 + 1]);
  /**
   * norm/start/short/stop/mixed(short)/sum
   */
  this.bitrate_blockType_Hist = new_int_n([16, 4 + 1 + 1]);

  //public PlottingData pinfo;
  //public MPGLib.mpstr_tag hip;
  this.pinfo = null;
  this.hip = null;
  this.in_buffer_nsamples = 0;
  //public float[] in_buffer_0;
  //public float[] in_buffer_1;
  this.in_buffer_0 = null;
  this.in_buffer_1 = null;

  //public IIterationLoop iteration_loop;
  this.iteration_loop = null;
  for (var i = 0; i < this.en.length; i++) {
    this.en[i] = new III_psy_xmin();
  }
  for (var i = 0; i < this.thm.length; i++) {
    this.thm[i] = new III_psy_xmin();
  }
  for (var i = 0; i < this.header.length; i++) {
    this.header[i] = new Header();
  }
}
var LameInternalFlags_1 = LameInternalFlags$1;

var common$3 = common$b;
var new_float$2 = common$3.new_float;
var Encoder$1 = requireEncoder();

/**
 * ATH related stuff, if something new ATH related has to be added, please plug
 * it here into the ATH.
 */
function ATH() {
  /**
   * Method for the auto adjustment.
   */
  this.useAdjust = 0;
  /**
   * factor for tuning the (sample power) point below which adaptive threshold
   * of hearing adjustment occurs
   */
  this.aaSensitivityP = 0.;
  /**
   * Lowering based on peak volume, 1 = no lowering.
   */
  this.adjust = 0.;
  /**
   * Limit for dynamic ATH adjust.
   */
  this.adjustLimit = 0.;
  /**
   * Determined to lower x dB each second.
   */
  this.decay = 0.;
  /**
   * Lowest ATH value.
   */
  this.floor = 0.;
  /**
   * ATH for sfbs in long blocks.
   */
  this.l = new_float$2(Encoder$1.SBMAX_l);
  /**
   * ATH for sfbs in short blocks.
   */
  this.s = new_float$2(Encoder$1.SBMAX_s);
  /**
   * ATH for partitioned sfb21 in long blocks.
   */
  this.psfb21 = new_float$2(Encoder$1.PSFB21);
  /**
   * ATH for partitioned sfb12 in short blocks.
   */
  this.psfb12 = new_float$2(Encoder$1.PSFB12);
  /**
   * ATH for long block convolution bands.
   */
  this.cb_l = new_float$2(Encoder$1.CBANDS);
  /**
   * ATH for short block convolution bands.
   */
  this.cb_s = new_float$2(Encoder$1.CBANDS);
  /**
   * Equal loudness weights (based on ATH).
   */
  this.eql_w = new_float$2(Encoder$1.BLKSIZE / 2);
}
var ATH_1 = ATH;

/*
 *  ReplayGainAnalysis - analyzes input samples and give the recommended dB change
 *  Copyright (C) 2001 David Robinson and Glen Sawyer
 *  Improvements and optimizations added by Frank Klemm, and by Marcel Muller 
 *
 *  This library is free software; you can redistribute it and/or
 *  modify it under the terms of the GNU Lesser General Public
 *  License as published by the Free Software Foundation; either
 *  version 2.1 of the License, or (at your option) any later version.
 *
 *  This library is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 *  Lesser General Public License for more details.
 *
 *  You should have received a copy of the GNU Lesser General Public
 *  License along with this library; if not, write to the Free Software
 *  Foundation, Inc., 59 Temple Place, Suite 330, Boston, MA  02111-1307  USA
 *
 *  concept and filter values by David Robinson (David@Robinson.org)
 *    -- blame him if you think the idea is flawed
 *  original coding by Glen Sawyer (mp3gain@hotmail.com)
 *    -- blame him if you think this runs too slowly, or the coding is otherwise flawed
 *
 *  lots of code improvements by Frank Klemm ( http://www.uni-jena.de/~pfk/mpp/ )
 *    -- credit him for all the _good_ programming ;)
 *
 *
 *  For an explanation of the concepts and the basic algorithms involved, go to:
 *    http://www.replaygain.org/
 */

/*
 *  Here's the deal. Call
 *
 *    InitGainAnalysis ( long samplefreq );
 *
 *  to initialize everything. Call
 *
 *    AnalyzeSamples ( var Float_t*  left_samples,
 *                     var Float_t*  right_samples,
 *                     size_t          num_samples,
 *                     int             num_channels );
 *
 *  as many times as you want, with as many or as few samples as you want.
 *  If mono, pass the sample buffer in through left_samples, leave
 *  right_samples NULL, and make sure num_channels = 1.
 *
 *    GetTitleGain()
 *
 *  will return the recommended dB level change for all samples analyzed
 *  SINCE THE LAST TIME you called GetTitleGain() OR InitGainAnalysis().
 *
 *    GetAlbumGain()
 *
 *  will return the recommended dB level change for all samples analyzed
 *  since InitGainAnalysis() was called and finalized with GetTitleGain().
 *
 *  Pseudo-code to process an album:
 *
 *    Float_t       l_samples [4096];
 *    Float_t       r_samples [4096];
 *    size_t        num_samples;
 *    unsigned int  num_songs;
 *    unsigned int  i;
 *
 *    InitGainAnalysis ( 44100 );
 *    for ( i = 1; i <= num_songs; i++ ) {
 *        while ( ( num_samples = getSongSamples ( song[i], left_samples, right_samples ) ) > 0 )
 *            AnalyzeSamples ( left_samples, right_samples, num_samples, 2 );
 *        fprintf ("Recommended dB change for song %2d: %+6.2 dB\n", i, GetTitleGain() );
 *    }
 *    fprintf ("Recommended dB change for whole album: %+6.2 dB\n", GetAlbumGain() );
 */

/*
 *  So here's the main source of potential code confusion:
 *
 *  The filters applied to the incoming samples are IIR filters,
 *  meaning they rely on up to <filter order> number of previous samples
 *  AND up to <filter order> number of previous filtered samples.
 *
 *  I set up the AnalyzeSamples routine to minimize memory usage and interface
 *  complexity. The speed isn't compromised too much (I don't think), but the
 *  internal complexity is higher than it should be for such a relatively
 *  simple routine.
 *
 *  Optimization/clarity suggestions are welcome.
 */
var common$2 = common$b;
var System = common$2.System;
var Arrays = common$2.Arrays;

/**
 * Table entries per dB
 */
GainAnalysis$2.STEPS_per_dB = 100.;
/**
 * Table entries for 0...MAX_dB (normal max. values are 70...80 dB)
 */
GainAnalysis$2.MAX_dB = 120.;
GainAnalysis$2.GAIN_NOT_ENOUGH_SAMPLES = -24601;
GainAnalysis$2.GAIN_ANALYSIS_ERROR = 0;
GainAnalysis$2.GAIN_ANALYSIS_OK = 1;
GainAnalysis$2.INIT_GAIN_ANALYSIS_ERROR = 0;
GainAnalysis$2.INIT_GAIN_ANALYSIS_OK = 1;
GainAnalysis$2.YULE_ORDER = 10;
GainAnalysis$2.MAX_ORDER = GainAnalysis$2.YULE_ORDER;
GainAnalysis$2.MAX_SAMP_FREQ = 48000;
GainAnalysis$2.RMS_WINDOW_TIME_NUMERATOR = 1;
GainAnalysis$2.RMS_WINDOW_TIME_DENOMINATOR = 20;
GainAnalysis$2.MAX_SAMPLES_PER_WINDOW = GainAnalysis$2.MAX_SAMP_FREQ * GainAnalysis$2.RMS_WINDOW_TIME_NUMERATOR / GainAnalysis$2.RMS_WINDOW_TIME_DENOMINATOR + 1;
function GainAnalysis$2() {
  /**
   * calibration value for 89dB
   */
  var PINK_REF = 64.82;
  /**
   * percentile which is louder than the proposed level
   */
  var RMS_PERCENTILE = 0.95;
  var RMS_WINDOW_TIME_NUMERATOR = GainAnalysis$2.RMS_WINDOW_TIME_NUMERATOR;
  /**
   * numerator / denominator = time slice size [s]
   */
  var RMS_WINDOW_TIME_DENOMINATOR = GainAnalysis$2.RMS_WINDOW_TIME_DENOMINATOR;
  var ABYule = [[0.03857599435200, -3.84664617118067, -0.02160367184185, 7.81501653005538, -0.00123395316851, -11.34170355132042, -0.00009291677959, 13.05504219327545, -0.01655260341619, -12.28759895145294, 0.02161526843274, 9.48293806319790, -0.02074045215285, -5.87257861775999, 0.00594298065125, 2.75465861874613, 0.00306428023191, -0.86984376593551, 0.00012025322027, 0.13919314567432, 0.00288463683916], [0.05418656406430, -3.47845948550071, -0.02911007808948, 6.36317777566148, -0.00848709379851, -8.54751527471874, -0.00851165645469, 9.47693607801280, -0.00834990904936, -8.81498681370155, 0.02245293253339, 6.85401540936998, -0.02596338512915, -4.39470996079559, 0.01624864962975, 2.19611684890774, -0.00240879051584, -0.75104302451432, 0.00674613682247, 0.13149317958808, -0.00187763777362], [0.15457299681924, -2.37898834973084, -0.09331049056315, 2.84868151156327, -0.06247880153653, -2.64577170229825, 0.02163541888798, 2.23697657451713, -0.05588393329856, -1.67148153367602, 0.04781476674921, 1.00595954808547, 0.00222312597743, -0.45953458054983, 0.03174092540049, 0.16378164858596, -0.01390589421898, -0.05032077717131, 0.00651420667831, 0.02347897407020, -0.00881362733839], [0.30296907319327, -1.61273165137247, -0.22613988682123, 1.07977492259970, -0.08587323730772, -0.25656257754070, 0.03282930172664, -0.16276719120440, -0.00915702933434, -0.22638893773906, -0.02364141202522, 0.39120800788284, -0.00584456039913, -0.22138138954925, 0.06276101321749, 0.04500235387352, -0.00000828086748, 0.02005851806501, 0.00205861885564, 0.00302439095741, -0.02950134983287], [0.33642304856132, -1.49858979367799, -0.25572241425570, 0.87350271418188, -0.11828570177555, 0.12205022308084, 0.11921148675203, -0.80774944671438, -0.07834489609479, 0.47854794562326, -0.00469977914380, -0.12453458140019, -0.00589500224440, -0.04067510197014, 0.05724228140351, 0.08333755284107, 0.00832043980773, -0.04237348025746, -0.01635381384540, 0.02977207319925, -0.01760176568150], [0.44915256608450, -0.62820619233671, -0.14351757464547, 0.29661783706366, -0.22784394429749, -0.37256372942400, -0.01419140100551, 0.00213767857124, 0.04078262797139, -0.42029820170918, -0.12398163381748, 0.22199650564824, 0.04097565135648, 0.00613424350682, 0.10478503600251, 0.06747620744683, -0.01863887810927, 0.05784820375801, -0.03193428438915, 0.03222754072173, 0.00541907748707], [0.56619470757641, -1.04800335126349, -0.75464456939302, 0.29156311971249, 0.16242137742230, -0.26806001042947, 0.16744243493672, 0.00819999645858, -0.18901604199609, 0.45054734505008, 0.30931782841830, -0.33032403314006, -0.27562961986224, 0.06739368333110, 0.00647310677246, -0.04784254229033, 0.08647503780351, 0.01639907836189, -0.03788984554840, 0.01807364323573, -0.00588215443421], [0.58100494960553, -0.51035327095184, -0.53174909058578, -0.31863563325245, -0.14289799034253, -0.20256413484477, 0.17520704835522, 0.14728154134330, 0.02377945217615, 0.38952639978999, 0.15558449135573, -0.23313271880868, -0.25344790059353, -0.05246019024463, 0.01628462406333, -0.02505961724053, 0.06920467763959, 0.02442357316099, -0.03721611395801, 0.01818801111503, -0.00749618797172], [0.53648789255105, -0.25049871956020, -0.42163034350696, -0.43193942311114, -0.00275953611929, -0.03424681017675, 0.04267842219415, -0.04678328784242, -0.10214864179676, 0.26408300200955, 0.14590772289388, 0.15113130533216, -0.02459864859345, -0.17556493366449, -0.11202315195388, -0.18823009262115, -0.04060034127000, 0.05477720428674, 0.04788665548180, 0.04704409688120, -0.02217936801134]];
  var ABButter = [[0.98621192462708, -1.97223372919527, -1.97242384925416, 0.97261396931306, 0.98621192462708], [0.98500175787242, -1.96977855582618, -1.97000351574484, 0.97022847566350, 0.98500175787242], [0.97938932735214, -1.95835380975398, -1.95877865470428, 0.95920349965459, 0.97938932735214], [0.97531843204928, -1.95002759149878, -1.95063686409857, 0.95124613669835, 0.97531843204928], [0.97316523498161, -1.94561023566527, -1.94633046996323, 0.94705070426118, 0.97316523498161], [0.96454515552826, -1.92783286977036, -1.92909031105652, 0.93034775234268, 0.96454515552826], [0.96009142950541, -1.91858953033784, -1.92018285901082, 0.92177618768381, 0.96009142950541], [0.95856916599601, -1.91542108074780, -1.91713833199203, 0.91885558323625, 0.95856916599601], [0.94597685600279, -1.88903307939452, -1.89195371200558, 0.89487434461664, 0.94597685600279]];

  /**
   * When calling this procedure, make sure that ip[-order] and op[-order]
   * point to real data
   */
  //private void filterYule(final float[] input, int inputPos, float[] output,
  //int outputPos, int nSamples, final float[] kernel) {
  function filterYule(input, inputPos, output, outputPos, nSamples, kernel) {
    while (nSamples-- != 0) {
      /* 1e-10 is a hack to avoid slowdown because of denormals */
      output[outputPos] = 1e-10 + input[inputPos + 0] * kernel[0] - output[outputPos - 1] * kernel[1] + input[inputPos - 1] * kernel[2] - output[outputPos - 2] * kernel[3] + input[inputPos - 2] * kernel[4] - output[outputPos - 3] * kernel[5] + input[inputPos - 3] * kernel[6] - output[outputPos - 4] * kernel[7] + input[inputPos - 4] * kernel[8] - output[outputPos - 5] * kernel[9] + input[inputPos - 5] * kernel[10] - output[outputPos - 6] * kernel[11] + input[inputPos - 6] * kernel[12] - output[outputPos - 7] * kernel[13] + input[inputPos - 7] * kernel[14] - output[outputPos - 8] * kernel[15] + input[inputPos - 8] * kernel[16] - output[outputPos - 9] * kernel[17] + input[inputPos - 9] * kernel[18] - output[outputPos - 10] * kernel[19] + input[inputPos - 10] * kernel[20];
      ++outputPos;
      ++inputPos;
    }
  }

  //private void filterButter(final float[] input, int inputPos,
  //    float[] output, int outputPos, int nSamples, final float[] kernel) {
  function filterButter(input, inputPos, output, outputPos, nSamples, kernel) {
    while (nSamples-- != 0) {
      output[outputPos] = input[inputPos + 0] * kernel[0] - output[outputPos - 1] * kernel[1] + input[inputPos - 1] * kernel[2] - output[outputPos - 2] * kernel[3] + input[inputPos - 2] * kernel[4];
      ++outputPos;
      ++inputPos;
    }
  }

  /**
   * @return INIT_GAIN_ANALYSIS_OK if successful, INIT_GAIN_ANALYSIS_ERROR if
   *         not
   */
  function ResetSampleFrequency(rgData, samplefreq) {
    /* zero out initial values */
    for (var i = 0; i < MAX_ORDER; i++) rgData.linprebuf[i] = rgData.lstepbuf[i] = rgData.loutbuf[i] = rgData.rinprebuf[i] = rgData.rstepbuf[i] = rgData.routbuf[i] = 0.;
    switch (0 | samplefreq) {
      case 48000:
        rgData.reqindex = 0;
        break;
      case 44100:
        rgData.reqindex = 1;
        break;
      case 32000:
        rgData.reqindex = 2;
        break;
      case 24000:
        rgData.reqindex = 3;
        break;
      case 22050:
        rgData.reqindex = 4;
        break;
      case 16000:
        rgData.reqindex = 5;
        break;
      case 12000:
        rgData.reqindex = 6;
        break;
      case 11025:
        rgData.reqindex = 7;
        break;
      case 8000:
        rgData.reqindex = 8;
        break;
      default:
        return INIT_GAIN_ANALYSIS_ERROR;
    }
    rgData.sampleWindow = 0 | (samplefreq * RMS_WINDOW_TIME_NUMERATOR + RMS_WINDOW_TIME_DENOMINATOR - 1) / RMS_WINDOW_TIME_DENOMINATOR;
    rgData.lsum = 0.;
    rgData.rsum = 0.;
    rgData.totsamp = 0;
    Arrays.ill(rgData.A, 0);
    return INIT_GAIN_ANALYSIS_OK;
  }
  this.InitGainAnalysis = function (rgData, samplefreq) {
    if (ResetSampleFrequency(rgData, samplefreq) != INIT_GAIN_ANALYSIS_OK) {
      return INIT_GAIN_ANALYSIS_ERROR;
    }
    rgData.linpre = MAX_ORDER;
    rgData.rinpre = MAX_ORDER;
    rgData.lstep = MAX_ORDER;
    rgData.rstep = MAX_ORDER;
    rgData.lout = MAX_ORDER;
    rgData.rout = MAX_ORDER;
    Arrays.fill(rgData.B, 0);
    return INIT_GAIN_ANALYSIS_OK;
  };

  /**
   * square
   */
  function fsqr(d) {
    return d * d;
  }
  this.AnalyzeSamples = function (rgData, left_samples, left_samplesPos, right_samples, right_samplesPos, num_samples, num_channels) {
    var curleft;
    var curleftBase;
    var curright;
    var currightBase;
    var batchsamples;
    var cursamples;
    var cursamplepos;
    if (num_samples == 0) return GAIN_ANALYSIS_OK;
    cursamplepos = 0;
    batchsamples = num_samples;
    switch (num_channels) {
      case 1:
        right_samples = left_samples;
        right_samplesPos = left_samplesPos;
        break;
      case 2:
        break;
      default:
        return GAIN_ANALYSIS_ERROR;
    }
    if (num_samples < MAX_ORDER) {
      System.arraycopy(left_samples, left_samplesPos, rgData.linprebuf, MAX_ORDER, num_samples);
      System.arraycopy(right_samples, right_samplesPos, rgData.rinprebuf, MAX_ORDER, num_samples);
    } else {
      System.arraycopy(left_samples, left_samplesPos, rgData.linprebuf, MAX_ORDER, MAX_ORDER);
      System.arraycopy(right_samples, right_samplesPos, rgData.rinprebuf, MAX_ORDER, MAX_ORDER);
    }
    while (batchsamples > 0) {
      cursamples = batchsamples > rgData.sampleWindow - rgData.totsamp ? rgData.sampleWindow - rgData.totsamp : batchsamples;
      if (cursamplepos < MAX_ORDER) {
        curleft = rgData.linpre + cursamplepos;
        curleftBase = rgData.linprebuf;
        curright = rgData.rinpre + cursamplepos;
        currightBase = rgData.rinprebuf;
        if (cursamples > MAX_ORDER - cursamplepos) cursamples = MAX_ORDER - cursamplepos;
      } else {
        curleft = left_samplesPos + cursamplepos;
        curleftBase = left_samples;
        curright = right_samplesPos + cursamplepos;
        currightBase = right_samples;
      }
      filterYule(curleftBase, curleft, rgData.lstepbuf, rgData.lstep + rgData.totsamp, cursamples, ABYule[rgData.reqindex]);
      filterYule(currightBase, curright, rgData.rstepbuf, rgData.rstep + rgData.totsamp, cursamples, ABYule[rgData.reqindex]);
      filterButter(rgData.lstepbuf, rgData.lstep + rgData.totsamp, rgData.loutbuf, rgData.lout + rgData.totsamp, cursamples, ABButter[rgData.reqindex]);
      filterButter(rgData.rstepbuf, rgData.rstep + rgData.totsamp, rgData.routbuf, rgData.rout + rgData.totsamp, cursamples, ABButter[rgData.reqindex]);
      curleft = rgData.lout + rgData.totsamp;
      /* Get the squared values */
      curleftBase = rgData.loutbuf;
      curright = rgData.rout + rgData.totsamp;
      currightBase = rgData.routbuf;
      var i = cursamples % 8;
      while (i-- != 0) {
        rgData.lsum += fsqr(curleftBase[curleft++]);
        rgData.rsum += fsqr(currightBase[curright++]);
      }
      i = cursamples / 8;
      while (i-- != 0) {
        rgData.lsum += fsqr(curleftBase[curleft + 0]) + fsqr(curleftBase[curleft + 1]) + fsqr(curleftBase[curleft + 2]) + fsqr(curleftBase[curleft + 3]) + fsqr(curleftBase[curleft + 4]) + fsqr(curleftBase[curleft + 5]) + fsqr(curleftBase[curleft + 6]) + fsqr(curleftBase[curleft + 7]);
        curleft += 8;
        rgData.rsum += fsqr(currightBase[curright + 0]) + fsqr(currightBase[curright + 1]) + fsqr(currightBase[curright + 2]) + fsqr(currightBase[curright + 3]) + fsqr(currightBase[curright + 4]) + fsqr(currightBase[curright + 5]) + fsqr(currightBase[curright + 6]) + fsqr(currightBase[curright + 7]);
        curright += 8;
      }
      batchsamples -= cursamples;
      cursamplepos += cursamples;
      rgData.totsamp += cursamples;
      if (rgData.totsamp == rgData.sampleWindow) {
        /* Get the Root Mean Square (RMS) for this set of samples */
        var val = GainAnalysis$2.STEPS_per_dB * 10. * Math.log10((rgData.lsum + rgData.rsum) / rgData.totsamp * 0.5 + 1.e-37);
        var ival = val <= 0 ? 0 : 0 | val;
        if (ival >= rgData.A.length) ival = rgData.A.length - 1;
        rgData.A[ival]++;
        rgData.lsum = rgData.rsum = 0.;
        System.arraycopy(rgData.loutbuf, rgData.totsamp, rgData.loutbuf, 0, MAX_ORDER);
        System.arraycopy(rgData.routbuf, rgData.totsamp, rgData.routbuf, 0, MAX_ORDER);
        System.arraycopy(rgData.lstepbuf, rgData.totsamp, rgData.lstepbuf, 0, MAX_ORDER);
        System.arraycopy(rgData.rstepbuf, rgData.totsamp, rgData.rstepbuf, 0, MAX_ORDER);
        rgData.totsamp = 0;
      }
      if (rgData.totsamp > rgData.sampleWindow) {
        /*
         * somehow I really screwed up: Error in programming! Contact
         * author about totsamp > sampleWindow
         */
        return GAIN_ANALYSIS_ERROR;
      }
    }
    if (num_samples < MAX_ORDER) {
      System.arraycopy(rgData.linprebuf, num_samples, rgData.linprebuf, 0, MAX_ORDER - num_samples);
      System.arraycopy(rgData.rinprebuf, num_samples, rgData.rinprebuf, 0, MAX_ORDER - num_samples);
      System.arraycopy(left_samples, left_samplesPos, rgData.linprebuf, MAX_ORDER - num_samples, num_samples);
      System.arraycopy(right_samples, right_samplesPos, rgData.rinprebuf, MAX_ORDER - num_samples, num_samples);
    } else {
      System.arraycopy(left_samples, left_samplesPos + num_samples - MAX_ORDER, rgData.linprebuf, 0, MAX_ORDER);
      System.arraycopy(right_samples, right_samplesPos + num_samples - MAX_ORDER, rgData.rinprebuf, 0, MAX_ORDER);
    }
    return GAIN_ANALYSIS_OK;
  };
  function analyzeResult(Array, len) {
    var i;
    var elems = 0;
    for (i = 0; i < len; i++) elems += Array[i];
    if (elems == 0) return GAIN_NOT_ENOUGH_SAMPLES;
    var upper = 0 | Math.ceil(elems * (1. - RMS_PERCENTILE));
    for (i = len; i-- > 0;) {
      if ((upper -= Array[i]) <= 0) break;
    }

    //return (float) ((float) PINK_REF - (float) i / (float) STEPS_per_dB);
    return PINK_REF - i / GainAnalysis$2.STEPS_per_dB;
  }
  this.GetTitleGain = function (rgData) {
    var retval = analyzeResult(rgData.A, rgData.A.length);
    for (var i = 0; i < rgData.A.length; i++) {
      rgData.B[i] += rgData.A[i];
      rgData.A[i] = 0;
    }
    for (var i = 0; i < MAX_ORDER; i++) rgData.linprebuf[i] = rgData.lstepbuf[i] = rgData.loutbuf[i] = rgData.rinprebuf[i] = rgData.rstepbuf[i] = rgData.routbuf[i] = 0.;
    rgData.totsamp = 0;
    rgData.lsum = rgData.rsum = 0.;
    return retval;
  };
}
var GainAnalysis_1 = GainAnalysis$2;

var common$1 = common$b;
var new_float$1 = common$1.new_float;
var new_int$1 = common$1.new_int;
var GainAnalysis$1 = GainAnalysis_1;
function ReplayGain() {
  this.linprebuf = new_float$1(GainAnalysis$1.MAX_ORDER * 2);
  /**
   * left input samples, with pre-buffer
   */
  this.linpre = 0;
  this.lstepbuf = new_float$1(GainAnalysis$1.MAX_SAMPLES_PER_WINDOW + GainAnalysis$1.MAX_ORDER);
  /**
   * left "first step" (i.e. post first filter) samples
   */
  this.lstep = 0;
  this.loutbuf = new_float$1(GainAnalysis$1.MAX_SAMPLES_PER_WINDOW + GainAnalysis$1.MAX_ORDER);
  /**
   * left "out" (i.e. post second filter) samples
   */
  this.lout = 0;
  this.rinprebuf = new_float$1(GainAnalysis$1.MAX_ORDER * 2);
  /**
   * right input samples ...
   */
  this.rinpre = 0;
  this.rstepbuf = new_float$1(GainAnalysis$1.MAX_SAMPLES_PER_WINDOW + GainAnalysis$1.MAX_ORDER);
  this.rstep = 0;
  this.routbuf = new_float$1(GainAnalysis$1.MAX_SAMPLES_PER_WINDOW + GainAnalysis$1.MAX_ORDER);
  this.rout = 0;
  /**
   * number of samples required to reach number of milliseconds required
   * for RMS window
   */
  this.sampleWindow = 0;
  this.totsamp = 0;
  this.lsum = 0.;
  this.rsum = 0.;
  this.freqindex = 0;
  this.first = 0;
  this.A = new_int$1(0 | GainAnalysis$1.STEPS_per_dB * GainAnalysis$1.MAX_dB);
  this.B = new_int$1(0 | GainAnalysis$1.STEPS_per_dB * GainAnalysis$1.MAX_dB);
}
var ReplayGain_1 = ReplayGain;

function MeanBits$1(meanBits) {
  this.bits = meanBits;
}
var MeanBits_1 = MeanBits$1;

var common = common$b;
var new_float = common.new_float;
var new_int = common.new_int;
var assert = common.assert;
var MeanBits = MeanBits_1;
var Encoder = requireEncoder();
var L3Side$1 = L3Side_1;
var LameInternalFlags = LameInternalFlags_1;
function CBRNewIterationLoop(_quantize) {
  var quantize = _quantize;
  this.quantize = quantize;
  this.iteration_loop = function (gfp, pe, ms_ener_ratio, ratio) {
    var gfc = gfp.internal_flags;
    var l3_xmin = new_float(L3Side$1.SFBMAX);
    var xrpow = new_float(576);
    var targ_bits = new_int(2);
    var mean_bits = 0,
      max_bits;
    var l3_side = gfc.l3_side;
    var mb = new MeanBits(mean_bits);
    this.quantize.rv.ResvFrameBegin(gfp, mb);
    mean_bits = mb.bits;

    /* quantize! */
    for (var gr = 0; gr < gfc.mode_gr; gr++) {
      /*
       * calculate needed bits
       */
      max_bits = this.quantize.qupvt.on_pe(gfp, pe, targ_bits, mean_bits, gr, gr);
      if (gfc.mode_ext == Encoder.MPG_MD_MS_LR) {
        this.quantize.ms_convert(gfc.l3_side, gr);
        this.quantize.qupvt.reduce_side(targ_bits, ms_ener_ratio[gr], mean_bits, max_bits);
      }
      for (var ch = 0; ch < gfc.channels_out; ch++) {
        var adjust, masking_lower_db;
        var cod_info = l3_side.tt[gr][ch];
        if (cod_info.block_type != Encoder.SHORT_TYPE) {
          // NORM, START or STOP type
          adjust = 0;
          masking_lower_db = gfc.PSY.mask_adjust - adjust;
        } else {
          adjust = 0;
          masking_lower_db = gfc.PSY.mask_adjust_short - adjust;
        }
        gfc.masking_lower = Math.pow(10.0, masking_lower_db * 0.1);

        /*
         * init_outer_loop sets up cod_info, scalefac and xrpow
         */
        this.quantize.init_outer_loop(gfc, cod_info);
        if (this.quantize.init_xrpow(gfc, cod_info, xrpow)) {
          /*
           * xr contains energy we will have to encode calculate the
           * masking abilities find some good quantization in
           * outer_loop
           */
          this.quantize.qupvt.calc_xmin(gfp, ratio[gr][ch], cod_info, l3_xmin);
          this.quantize.outer_loop(gfp, cod_info, l3_xmin, xrpow, ch, targ_bits[ch]);
        }
        this.quantize.iteration_finish_one(gfc, gr, ch);
        assert(cod_info.part2_3_length <= LameInternalFlags.MAX_BITS_PER_CHANNEL);
        assert(cod_info.part2_3_length <= targ_bits[ch]);
      } /* for ch */
    } /* for gr */

    this.quantize.rv.ResvFrameEnd(gfc, mean_bits);
  };
}
var CBRNewIterationLoop_1 = CBRNewIterationLoop;

function HuffCodeTab(len, max, tab, hl) {
  this.xlen = len;
  this.linmax = max;
  this.table = tab;
  this.hlen = hl;
}
var Tables = {};
Tables.t1HB = [1, 1, 1, 0];
Tables.t2HB = [1, 2, 1, 3, 1, 1, 3, 2, 0];
Tables.t3HB = [3, 2, 1, 1, 1, 1, 3, 2, 0];
Tables.t5HB = [1, 2, 6, 5, 3, 1, 4, 4, 7, 5, 7, 1, 6, 1, 1, 0];
Tables.t6HB = [7, 3, 5, 1, 6, 2, 3, 2, 5, 4, 4, 1, 3, 3, 2, 0];
Tables.t7HB = [1, 2, 10, 19, 16, 10, 3, 3, 7, 10, 5, 3, 11, 4, 13, 17, 8, 4, 12, 11, 18, 15, 11, 2, 7, 6, 9, 14, 3, 1, 6, 4, 5, 3, 2, 0];
Tables.t8HB = [3, 4, 6, 18, 12, 5, 5, 1, 2, 16, 9, 3, 7, 3, 5, 14, 7, 3, 19, 17, 15, 13, 10, 4, 13, 5, 8, 11, 5, 1, 12, 4, 4, 1, 1, 0];
Tables.t9HB = [7, 5, 9, 14, 15, 7, 6, 4, 5, 5, 6, 7, 7, 6, 8, 8, 8, 5, 15, 6, 9, 10, 5, 1, 11, 7, 9, 6, 4, 1, 14, 4, 6, 2, 6, 0];
Tables.t10HB = [1, 2, 10, 23, 35, 30, 12, 17, 3, 3, 8, 12, 18, 21, 12, 7, 11, 9, 15, 21, 32, 40, 19, 6, 14, 13, 22, 34, 46, 23, 18, 7, 20, 19, 33, 47, 27, 22, 9, 3, 31, 22, 41, 26, 21, 20, 5, 3, 14, 13, 10, 11, 16, 6, 5, 1, 9, 8, 7, 8, 4, 4, 2, 0];
Tables.t11HB = [3, 4, 10, 24, 34, 33, 21, 15, 5, 3, 4, 10, 32, 17, 11, 10, 11, 7, 13, 18, 30, 31, 20, 5, 25, 11, 19, 59, 27, 18, 12, 5, 35, 33, 31, 58, 30, 16, 7, 5, 28, 26, 32, 19, 17, 15, 8, 14, 14, 12, 9, 13, 14, 9, 4, 1, 11, 4, 6, 6, 6, 3, 2, 0];
Tables.t12HB = [9, 6, 16, 33, 41, 39, 38, 26, 7, 5, 6, 9, 23, 16, 26, 11, 17, 7, 11, 14, 21, 30, 10, 7, 17, 10, 15, 12, 18, 28, 14, 5, 32, 13, 22, 19, 18, 16, 9, 5, 40, 17, 31, 29, 17, 13, 4, 2, 27, 12, 11, 15, 10, 7, 4, 1, 27, 12, 8, 12, 6, 3, 1, 0];
Tables.t13HB = [1, 5, 14, 21, 34, 51, 46, 71, 42, 52, 68, 52, 67, 44, 43, 19, 3, 4, 12, 19, 31, 26, 44, 33, 31, 24, 32, 24, 31, 35, 22, 14, 15, 13, 23, 36, 59, 49, 77, 65, 29, 40, 30, 40, 27, 33, 42, 16, 22, 20, 37, 61, 56, 79, 73, 64, 43, 76, 56, 37, 26, 31, 25, 14, 35, 16, 60, 57, 97, 75, 114, 91, 54, 73, 55, 41, 48, 53, 23, 24, 58, 27, 50, 96, 76, 70, 93, 84, 77, 58, 79, 29, 74, 49, 41, 17, 47, 45, 78, 74, 115, 94, 90, 79, 69, 83, 71, 50, 59, 38, 36, 15, 72, 34, 56, 95, 92, 85, 91, 90, 86, 73, 77, 65, 51, 44, 43, 42, 43, 20, 30, 44, 55, 78, 72, 87, 78, 61, 46, 54, 37, 30, 20, 16, 53, 25, 41, 37, 44, 59, 54, 81, 66, 76, 57, 54, 37, 18, 39, 11, 35, 33, 31, 57, 42, 82, 72, 80, 47, 58, 55, 21, 22, 26, 38, 22, 53, 25, 23, 38, 70, 60, 51, 36, 55, 26, 34, 23, 27, 14, 9, 7, 34, 32, 28, 39, 49, 75, 30, 52, 48, 40, 52, 28, 18, 17, 9, 5, 45, 21, 34, 64, 56, 50, 49, 45, 31, 19, 12, 15, 10, 7, 6, 3, 48, 23, 20, 39, 36, 35, 53, 21, 16, 23, 13, 10, 6, 1, 4, 2, 16, 15, 17, 27, 25, 20, 29, 11, 17, 12, 16, 8, 1, 1, 0, 1];
Tables.t15HB = [7, 12, 18, 53, 47, 76, 124, 108, 89, 123, 108, 119, 107, 81, 122, 63, 13, 5, 16, 27, 46, 36, 61, 51, 42, 70, 52, 83, 65, 41, 59, 36, 19, 17, 15, 24, 41, 34, 59, 48, 40, 64, 50, 78, 62, 80, 56, 33, 29, 28, 25, 43, 39, 63, 55, 93, 76, 59, 93, 72, 54, 75, 50, 29, 52, 22, 42, 40, 67, 57, 95, 79, 72, 57, 89, 69, 49, 66, 46, 27, 77, 37, 35, 66, 58, 52, 91, 74, 62, 48, 79, 63, 90, 62, 40, 38, 125, 32, 60, 56, 50, 92, 78, 65, 55, 87, 71, 51, 73, 51, 70, 30, 109, 53, 49, 94, 88, 75, 66, 122, 91, 73, 56, 42, 64, 44, 21, 25, 90, 43, 41, 77, 73, 63, 56, 92, 77, 66, 47, 67, 48, 53, 36, 20, 71, 34, 67, 60, 58, 49, 88, 76, 67, 106, 71, 54, 38, 39, 23, 15, 109, 53, 51, 47, 90, 82, 58, 57, 48, 72, 57, 41, 23, 27, 62, 9, 86, 42, 40, 37, 70, 64, 52, 43, 70, 55, 42, 25, 29, 18, 11, 11, 118, 68, 30, 55, 50, 46, 74, 65, 49, 39, 24, 16, 22, 13, 14, 7, 91, 44, 39, 38, 34, 63, 52, 45, 31, 52, 28, 19, 14, 8, 9, 3, 123, 60, 58, 53, 47, 43, 32, 22, 37, 24, 17, 12, 15, 10, 2, 1, 71, 37, 34, 30, 28, 20, 17, 26, 21, 16, 10, 6, 8, 6, 2, 0];
Tables.t16HB = [1, 5, 14, 44, 74, 63, 110, 93, 172, 149, 138, 242, 225, 195, 376, 17, 3, 4, 12, 20, 35, 62, 53, 47, 83, 75, 68, 119, 201, 107, 207, 9, 15, 13, 23, 38, 67, 58, 103, 90, 161, 72, 127, 117, 110, 209, 206, 16, 45, 21, 39, 69, 64, 114, 99, 87, 158, 140, 252, 212, 199, 387, 365, 26, 75, 36, 68, 65, 115, 101, 179, 164, 155, 264, 246, 226, 395, 382, 362, 9, 66, 30, 59, 56, 102, 185, 173, 265, 142, 253, 232, 400, 388, 378, 445, 16, 111, 54, 52, 100, 184, 178, 160, 133, 257, 244, 228, 217, 385, 366, 715, 10, 98, 48, 91, 88, 165, 157, 148, 261, 248, 407, 397, 372, 380, 889, 884, 8, 85, 84, 81, 159, 156, 143, 260, 249, 427, 401, 392, 383, 727, 713, 708, 7, 154, 76, 73, 141, 131, 256, 245, 426, 406, 394, 384, 735, 359, 710, 352, 11, 139, 129, 67, 125, 247, 233, 229, 219, 393, 743, 737, 720, 885, 882, 439, 4, 243, 120, 118, 115, 227, 223, 396, 746, 742, 736, 721, 712, 706, 223, 436, 6, 202, 224, 222, 218, 216, 389, 386, 381, 364, 888, 443, 707, 440, 437, 1728, 4, 747, 211, 210, 208, 370, 379, 734, 723, 714, 1735, 883, 877, 876, 3459, 865, 2, 377, 369, 102, 187, 726, 722, 358, 711, 709, 866, 1734, 871, 3458, 870, 434, 0, 12, 10, 7, 11, 10, 17, 11, 9, 13, 12, 10, 7, 5, 3, 1, 3];
Tables.t24HB = [15, 13, 46, 80, 146, 262, 248, 434, 426, 669, 653, 649, 621, 517, 1032, 88, 14, 12, 21, 38, 71, 130, 122, 216, 209, 198, 327, 345, 319, 297, 279, 42, 47, 22, 41, 74, 68, 128, 120, 221, 207, 194, 182, 340, 315, 295, 541, 18, 81, 39, 75, 70, 134, 125, 116, 220, 204, 190, 178, 325, 311, 293, 271, 16, 147, 72, 69, 135, 127, 118, 112, 210, 200, 188, 352, 323, 306, 285, 540, 14, 263, 66, 129, 126, 119, 114, 214, 202, 192, 180, 341, 317, 301, 281, 262, 12, 249, 123, 121, 117, 113, 215, 206, 195, 185, 347, 330, 308, 291, 272, 520, 10, 435, 115, 111, 109, 211, 203, 196, 187, 353, 332, 313, 298, 283, 531, 381, 17, 427, 212, 208, 205, 201, 193, 186, 177, 169, 320, 303, 286, 268, 514, 377, 16, 335, 199, 197, 191, 189, 181, 174, 333, 321, 305, 289, 275, 521, 379, 371, 11, 668, 184, 183, 179, 175, 344, 331, 314, 304, 290, 277, 530, 383, 373, 366, 10, 652, 346, 171, 168, 164, 318, 309, 299, 287, 276, 263, 513, 375, 368, 362, 6, 648, 322, 316, 312, 307, 302, 292, 284, 269, 261, 512, 376, 370, 364, 359, 4, 620, 300, 296, 294, 288, 282, 273, 266, 515, 380, 374, 369, 365, 361, 357, 2, 1033, 280, 278, 274, 267, 264, 259, 382, 378, 372, 367, 363, 360, 358, 356, 0, 43, 20, 19, 17, 15, 13, 11, 9, 7, 6, 4, 7, 5, 3, 1, 3];
Tables.t32HB = [1 << 0, 5 << 1, 4 << 1, 5 << 2, 6 << 1, 5 << 2, 4 << 2, 4 << 3, 7 << 1, 3 << 2, 6 << 2, 0 << 3, 7 << 2, 2 << 3, 3 << 3, 1 << 4];
Tables.t33HB = [15 << 0, 14 << 1, 13 << 1, 12 << 2, 11 << 1, 10 << 2, 9 << 2, 8 << 3, 7 << 1, 6 << 2, 5 << 2, 4 << 3, 3 << 2, 2 << 3, 1 << 3, 0 << 4];
Tables.t1l = [1, 4, 3, 5];
Tables.t2l = [1, 4, 7, 4, 5, 7, 6, 7, 8];
Tables.t3l = [2, 3, 7, 4, 4, 7, 6, 7, 8];
Tables.t5l = [1, 4, 7, 8, 4, 5, 8, 9, 7, 8, 9, 10, 8, 8, 9, 10];
Tables.t6l = [3, 4, 6, 8, 4, 4, 6, 7, 5, 6, 7, 8, 7, 7, 8, 9];
Tables.t7l = [1, 4, 7, 9, 9, 10, 4, 6, 8, 9, 9, 10, 7, 7, 9, 10, 10, 11, 8, 9, 10, 11, 11, 11, 8, 9, 10, 11, 11, 12, 9, 10, 11, 12, 12, 12];
Tables.t8l = [2, 4, 7, 9, 9, 10, 4, 4, 6, 10, 10, 10, 7, 6, 8, 10, 10, 11, 9, 10, 10, 11, 11, 12, 9, 9, 10, 11, 12, 12, 10, 10, 11, 11, 13, 13];
Tables.t9l = [3, 4, 6, 7, 9, 10, 4, 5, 6, 7, 8, 10, 5, 6, 7, 8, 9, 10, 7, 7, 8, 9, 9, 10, 8, 8, 9, 9, 10, 11, 9, 9, 10, 10, 11, 11];
Tables.t10l = [1, 4, 7, 9, 10, 10, 10, 11, 4, 6, 8, 9, 10, 11, 10, 10, 7, 8, 9, 10, 11, 12, 11, 11, 8, 9, 10, 11, 12, 12, 11, 12, 9, 10, 11, 12, 12, 12, 12, 12, 10, 11, 12, 12, 13, 13, 12, 13, 9, 10, 11, 12, 12, 12, 13, 13, 10, 10, 11, 12, 12, 13, 13, 13];
Tables.t11l = [2, 4, 6, 8, 9, 10, 9, 10, 4, 5, 6, 8, 10, 10, 9, 10, 6, 7, 8, 9, 10, 11, 10, 10, 8, 8, 9, 11, 10, 12, 10, 11, 9, 10, 10, 11, 11, 12, 11, 12, 9, 10, 11, 12, 12, 13, 12, 13, 9, 9, 9, 10, 11, 12, 12, 12, 9, 9, 10, 11, 12, 12, 12, 12];
Tables.t12l = [4, 4, 6, 8, 9, 10, 10, 10, 4, 5, 6, 7, 9, 9, 10, 10, 6, 6, 7, 8, 9, 10, 9, 10, 7, 7, 8, 8, 9, 10, 10, 10, 8, 8, 9, 9, 10, 10, 10, 11, 9, 9, 10, 10, 10, 11, 10, 11, 9, 9, 9, 10, 10, 11, 11, 12, 10, 10, 10, 11, 11, 11, 11, 12];
Tables.t13l = [1, 5, 7, 8, 9, 10, 10, 11, 10, 11, 12, 12, 13, 13, 14, 14, 4, 6, 8, 9, 10, 10, 11, 11, 11, 11, 12, 12, 13, 14, 14, 14, 7, 8, 9, 10, 11, 11, 12, 12, 11, 12, 12, 13, 13, 14, 15, 15, 8, 9, 10, 11, 11, 12, 12, 12, 12, 13, 13, 13, 13, 14, 15, 15, 9, 9, 11, 11, 12, 12, 13, 13, 12, 13, 13, 14, 14, 15, 15, 16, 10, 10, 11, 12, 12, 12, 13, 13, 13, 13, 14, 13, 15, 15, 16, 16, 10, 11, 12, 12, 13, 13, 13, 13, 13, 14, 14, 14, 15, 15, 16, 16, 11, 11, 12, 13, 13, 13, 14, 14, 14, 14, 15, 15, 15, 16, 18, 18, 10, 10, 11, 12, 12, 13, 13, 14, 14, 14, 14, 15, 15, 16, 17, 17, 11, 11, 12, 12, 13, 13, 13, 15, 14, 15, 15, 16, 16, 16, 18, 17, 11, 12, 12, 13, 13, 14, 14, 15, 14, 15, 16, 15, 16, 17, 18, 19, 12, 12, 12, 13, 14, 14, 14, 14, 15, 15, 15, 16, 17, 17, 17, 18, 12, 13, 13, 14, 14, 15, 14, 15, 16, 16, 17, 17, 17, 18, 18, 18, 13, 13, 14, 15, 15, 15, 16, 16, 16, 16, 16, 17, 18, 17, 18, 18, 14, 14, 14, 15, 15, 15, 17, 16, 16, 19, 17, 17, 17, 19, 18, 18, 13, 14, 15, 16, 16, 16, 17, 16, 17, 17, 18, 18, 21, 20, 21, 18];
Tables.t15l = [3, 5, 6, 8, 8, 9, 10, 10, 10, 11, 11, 12, 12, 12, 13, 14, 5, 5, 7, 8, 9, 9, 10, 10, 10, 11, 11, 12, 12, 12, 13, 13, 6, 7, 7, 8, 9, 9, 10, 10, 10, 11, 11, 12, 12, 13, 13, 13, 7, 8, 8, 9, 9, 10, 10, 11, 11, 11, 12, 12, 12, 13, 13, 13, 8, 8, 9, 9, 10, 10, 11, 11, 11, 11, 12, 12, 12, 13, 13, 13, 9, 9, 9, 10, 10, 10, 11, 11, 11, 11, 12, 12, 13, 13, 13, 14, 10, 9, 10, 10, 10, 11, 11, 11, 11, 12, 12, 12, 13, 13, 14, 14, 10, 10, 10, 11, 11, 11, 11, 12, 12, 12, 12, 12, 13, 13, 13, 14, 10, 10, 10, 11, 11, 11, 11, 12, 12, 12, 12, 13, 13, 14, 14, 14, 10, 10, 11, 11, 11, 11, 12, 12, 12, 13, 13, 13, 13, 14, 14, 14, 11, 11, 11, 11, 12, 12, 12, 12, 12, 13, 13, 13, 13, 14, 15, 14, 11, 11, 11, 11, 12, 12, 12, 12, 13, 13, 13, 13, 14, 14, 14, 15, 12, 12, 11, 12, 12, 12, 13, 13, 13, 13, 13, 13, 14, 14, 15, 15, 12, 12, 12, 12, 12, 13, 13, 13, 13, 14, 14, 14, 14, 14, 15, 15, 13, 13, 13, 13, 13, 13, 13, 13, 14, 14, 14, 14, 15, 15, 14, 15, 13, 13, 13, 13, 13, 13, 13, 14, 14, 14, 14, 14, 15, 15, 15, 15];
Tables.t16_5l = [1, 5, 7, 9, 10, 10, 11, 11, 12, 12, 12, 13, 13, 13, 14, 11, 4, 6, 8, 9, 10, 11, 11, 11, 12, 12, 12, 13, 14, 13, 14, 11, 7, 8, 9, 10, 11, 11, 12, 12, 13, 12, 13, 13, 13, 14, 14, 12, 9, 9, 10, 11, 11, 12, 12, 12, 13, 13, 14, 14, 14, 15, 15, 13, 10, 10, 11, 11, 12, 12, 13, 13, 13, 14, 14, 14, 15, 15, 15, 12, 10, 10, 11, 11, 12, 13, 13, 14, 13, 14, 14, 15, 15, 15, 16, 13, 11, 11, 11, 12, 13, 13, 13, 13, 14, 14, 14, 14, 15, 15, 16, 13, 11, 11, 12, 12, 13, 13, 13, 14, 14, 15, 15, 15, 15, 17, 17, 13, 11, 12, 12, 13, 13, 13, 14, 14, 15, 15, 15, 15, 16, 16, 16, 13, 12, 12, 12, 13, 13, 14, 14, 15, 15, 15, 15, 16, 15, 16, 15, 14, 12, 13, 12, 13, 14, 14, 14, 14, 15, 16, 16, 16, 17, 17, 16, 13, 13, 13, 13, 13, 14, 14, 15, 16, 16, 16, 16, 16, 16, 15, 16, 14, 13, 14, 14, 14, 14, 15, 15, 15, 15, 17, 16, 16, 16, 16, 18, 14, 15, 14, 14, 14, 15, 15, 16, 16, 16, 18, 17, 17, 17, 19, 17, 14, 14, 15, 13, 14, 16, 16, 15, 16, 16, 17, 18, 17, 19, 17, 16, 14, 11, 11, 11, 12, 12, 13, 13, 13, 14, 14, 14, 14, 14, 14, 14, 12];
Tables.t16l = [1, 5, 7, 9, 10, 10, 11, 11, 12, 12, 12, 13, 13, 13, 14, 10, 4, 6, 8, 9, 10, 11, 11, 11, 12, 12, 12, 13, 14, 13, 14, 10, 7, 8, 9, 10, 11, 11, 12, 12, 13, 12, 13, 13, 13, 14, 14, 11, 9, 9, 10, 11, 11, 12, 12, 12, 13, 13, 14, 14, 14, 15, 15, 12, 10, 10, 11, 11, 12, 12, 13, 13, 13, 14, 14, 14, 15, 15, 15, 11, 10, 10, 11, 11, 12, 13, 13, 14, 13, 14, 14, 15, 15, 15, 16, 12, 11, 11, 11, 12, 13, 13, 13, 13, 14, 14, 14, 14, 15, 15, 16, 12, 11, 11, 12, 12, 13, 13, 13, 14, 14, 15, 15, 15, 15, 17, 17, 12, 11, 12, 12, 13, 13, 13, 14, 14, 15, 15, 15, 15, 16, 16, 16, 12, 12, 12, 12, 13, 13, 14, 14, 15, 15, 15, 15, 16, 15, 16, 15, 13, 12, 13, 12, 13, 14, 14, 14, 14, 15, 16, 16, 16, 17, 17, 16, 12, 13, 13, 13, 13, 14, 14, 15, 16, 16, 16, 16, 16, 16, 15, 16, 13, 13, 14, 14, 14, 14, 15, 15, 15, 15, 17, 16, 16, 16, 16, 18, 13, 15, 14, 14, 14, 15, 15, 16, 16, 16, 18, 17, 17, 17, 19, 17, 13, 14, 15, 13, 14, 16, 16, 15, 16, 16, 17, 18, 17, 19, 17, 16, 13, 10, 10, 10, 11, 11, 12, 12, 12, 13, 13, 13, 13, 13, 13, 13, 10];
Tables.t24l = [4, 5, 7, 8, 9, 10, 10, 11, 11, 12, 12, 12, 12, 12, 13, 10, 5, 6, 7, 8, 9, 10, 10, 11, 11, 11, 12, 12, 12, 12, 12, 10, 7, 7, 8, 9, 9, 10, 10, 11, 11, 11, 11, 12, 12, 12, 13, 9, 8, 8, 9, 9, 10, 10, 10, 11, 11, 11, 11, 12, 12, 12, 12, 9, 9, 9, 9, 10, 10, 10, 10, 11, 11, 11, 12, 12, 12, 12, 13, 9, 10, 9, 10, 10, 10, 10, 11, 11, 11, 11, 12, 12, 12, 12, 12, 9, 10, 10, 10, 10, 10, 11, 11, 11, 11, 12, 12, 12, 12, 12, 13, 9, 11, 10, 10, 10, 11, 11, 11, 11, 12, 12, 12, 12, 12, 13, 13, 10, 11, 11, 11, 11, 11, 11, 11, 11, 11, 12, 12, 12, 12, 13, 13, 10, 11, 11, 11, 11, 11, 11, 11, 12, 12, 12, 12, 12, 13, 13, 13, 10, 12, 11, 11, 11, 11, 12, 12, 12, 12, 12, 12, 13, 13, 13, 13, 10, 12, 12, 11, 11, 11, 12, 12, 12, 12, 12, 12, 13, 13, 13, 13, 10, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 13, 13, 13, 13, 13, 10, 12, 12, 12, 12, 12, 12, 12, 12, 13, 13, 13, 13, 13, 13, 13, 10, 13, 12, 12, 12, 12, 12, 12, 13, 13, 13, 13, 13, 13, 13, 13, 10, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 10, 10, 10, 10, 6];
Tables.t32l = [1 + 0, 4 + 1, 4 + 1, 5 + 2, 4 + 1, 6 + 2, 5 + 2, 6 + 3, 4 + 1, 5 + 2, 5 + 2, 6 + 3, 5 + 2, 6 + 3, 6 + 3, 6 + 4];
Tables.t33l = [4 + 0, 4 + 1, 4 + 1, 4 + 2, 4 + 1, 4 + 2, 4 + 2, 4 + 3, 4 + 1, 4 + 2, 4 + 2, 4 + 3, 4 + 2, 4 + 3, 4 + 3, 4 + 4];
Tables.ht = [/* xlen, linmax, table, hlen */
new HuffCodeTab(0, 0, null, null), new HuffCodeTab(2, 0, Tables.t1HB, Tables.t1l), new HuffCodeTab(3, 0, Tables.t2HB, Tables.t2l), new HuffCodeTab(3, 0, Tables.t3HB, Tables.t3l), new HuffCodeTab(0, 0, null, null), /* Apparently not used */
new HuffCodeTab(4, 0, Tables.t5HB, Tables.t5l), new HuffCodeTab(4, 0, Tables.t6HB, Tables.t6l), new HuffCodeTab(6, 0, Tables.t7HB, Tables.t7l), new HuffCodeTab(6, 0, Tables.t8HB, Tables.t8l), new HuffCodeTab(6, 0, Tables.t9HB, Tables.t9l), new HuffCodeTab(8, 0, Tables.t10HB, Tables.t10l), new HuffCodeTab(8, 0, Tables.t11HB, Tables.t11l), new HuffCodeTab(8, 0, Tables.t12HB, Tables.t12l), new HuffCodeTab(16, 0, Tables.t13HB, Tables.t13l), new HuffCodeTab(0, 0, null, Tables.t16_5l), /* Apparently not used */
new HuffCodeTab(16, 0, Tables.t15HB, Tables.t15l), new HuffCodeTab(1, 1, Tables.t16HB, Tables.t16l), new HuffCodeTab(2, 3, Tables.t16HB, Tables.t16l), new HuffCodeTab(3, 7, Tables.t16HB, Tables.t16l), new HuffCodeTab(4, 15, Tables.t16HB, Tables.t16l), new HuffCodeTab(6, 63, Tables.t16HB, Tables.t16l), new HuffCodeTab(8, 255, Tables.t16HB, Tables.t16l), new HuffCodeTab(10, 1023, Tables.t16HB, Tables.t16l), new HuffCodeTab(13, 8191, Tables.t16HB, Tables.t16l), new HuffCodeTab(4, 15, Tables.t24HB, Tables.t24l), new HuffCodeTab(5, 31, Tables.t24HB, Tables.t24l), new HuffCodeTab(6, 63, Tables.t24HB, Tables.t24l), new HuffCodeTab(7, 127, Tables.t24HB, Tables.t24l), new HuffCodeTab(8, 255, Tables.t24HB, Tables.t24l), new HuffCodeTab(9, 511, Tables.t24HB, Tables.t24l), new HuffCodeTab(11, 2047, Tables.t24HB, Tables.t24l), new HuffCodeTab(13, 8191, Tables.t24HB, Tables.t24l), new HuffCodeTab(0, 0, Tables.t32HB, Tables.t32l), new HuffCodeTab(0, 0, Tables.t33HB, Tables.t33l)];

/**
 * <CODE>
 *  for (i = 0; i < 16*16; i++) [
 *      largetbl[i] = ((ht[16].hlen[i]) << 16) + ht[24].hlen[i];
 *  ]
 * </CODE>
 *
 */
Tables.largetbl = [0x010004, 0x050005, 0x070007, 0x090008, 0x0a0009, 0x0a000a, 0x0b000a, 0x0b000b, 0x0c000b, 0x0c000c, 0x0c000c, 0x0d000c, 0x0d000c, 0x0d000c, 0x0e000d, 0x0a000a, 0x040005, 0x060006, 0x080007, 0x090008, 0x0a0009, 0x0b000a, 0x0b000a, 0x0b000b, 0x0c000b, 0x0c000b, 0x0c000c, 0x0d000c, 0x0e000c, 0x0d000c, 0x0e000c, 0x0a000a, 0x070007, 0x080007, 0x090008, 0x0a0009, 0x0b0009, 0x0b000a, 0x0c000a, 0x0c000b, 0x0d000b, 0x0c000b, 0x0d000b, 0x0d000c, 0x0d000c, 0x0e000c, 0x0e000d, 0x0b0009, 0x090008, 0x090008, 0x0a0009, 0x0b0009, 0x0b000a, 0x0c000a, 0x0c000a, 0x0c000b, 0x0d000b, 0x0d000b, 0x0e000b, 0x0e000c, 0x0e000c, 0x0f000c, 0x0f000c, 0x0c0009, 0x0a0009, 0x0a0009, 0x0b0009, 0x0b000a, 0x0c000a, 0x0c000a, 0x0d000a, 0x0d000b, 0x0d000b, 0x0e000b, 0x0e000c, 0x0e000c, 0x0f000c, 0x0f000c, 0x0f000d, 0x0b0009, 0x0a000a, 0x0a0009, 0x0b000a, 0x0b000a, 0x0c000a, 0x0d000a, 0x0d000b, 0x0e000b, 0x0d000b, 0x0e000b, 0x0e000c, 0x0f000c, 0x0f000c, 0x0f000c, 0x10000c, 0x0c0009, 0x0b000a, 0x0b000a, 0x0b000a, 0x0c000a, 0x0d000a, 0x0d000b, 0x0d000b, 0x0d000b, 0x0e000b, 0x0e000c, 0x0e000c, 0x0e000c, 0x0f000c, 0x0f000c, 0x10000d, 0x0c0009, 0x0b000b, 0x0b000a, 0x0c000a, 0x0c000a, 0x0d000b, 0x0d000b, 0x0d000b, 0x0e000b, 0x0e000c, 0x0f000c, 0x0f000c, 0x0f000c, 0x0f000c, 0x11000d, 0x11000d, 0x0c000a, 0x0b000b, 0x0c000b, 0x0c000b, 0x0d000b, 0x0d000b, 0x0d000b, 0x0e000b, 0x0e000b, 0x0f000b, 0x0f000c, 0x0f000c, 0x0f000c, 0x10000c, 0x10000d, 0x10000d, 0x0c000a, 0x0c000b, 0x0c000b, 0x0c000b, 0x0d000b, 0x0d000b, 0x0e000b, 0x0e000b, 0x0f000c, 0x0f000c, 0x0f000c, 0x0f000c, 0x10000c, 0x0f000d, 0x10000d, 0x0f000d, 0x0d000a, 0x0c000c, 0x0d000b, 0x0c000b, 0x0d000b, 0x0e000b, 0x0e000c, 0x0e000c, 0x0e000c, 0x0f000c, 0x10000c, 0x10000c, 0x10000d, 0x11000d, 0x11000d, 0x10000d, 0x0c000a, 0x0d000c, 0x0d000c, 0x0d000b, 0x0d000b, 0x0e000b, 0x0e000c, 0x0f000c, 0x10000c, 0x10000c, 0x10000c, 0x10000c, 0x10000d, 0x10000d, 0x0f000d, 0x10000d, 0x0d000a, 0x0d000c, 0x0e000c, 0x0e000c, 0x0e000c, 0x0e000c, 0x0f000c, 0x0f000c, 0x0f000c, 0x0f000c, 0x11000c, 0x10000d, 0x10000d, 0x10000d, 0x10000d, 0x12000d, 0x0d000a, 0x0f000c, 0x0e000c, 0x0e000c, 0x0e000c, 0x0f000c, 0x0f000c, 0x10000c, 0x10000c, 0x10000d, 0x12000d, 0x11000d, 0x11000d, 0x11000d, 0x13000d, 0x11000d, 0x0d000a, 0x0e000d, 0x0f000c, 0x0d000c, 0x0e000c, 0x10000c, 0x10000c, 0x0f000c, 0x10000d, 0x10000d, 0x11000d, 0x12000d, 0x11000d, 0x13000d, 0x11000d, 0x10000d, 0x0d000a, 0x0a0009, 0x0a0009, 0x0a0009, 0x0b0009, 0x0b0009, 0x0c0009, 0x0c0009, 0x0c0009, 0x0d0009, 0x0d0009, 0x0d0009, 0x0d000a, 0x0d000a, 0x0d000a, 0x0d000a, 0x0a0006];
/**
 * <CODE>
 *  for (i = 0; i < 3*3; i++) [
 *      table23[i] = ((ht[2].hlen[i]) << 16) + ht[3].hlen[i];
 *  ]
 * </CODE>
 *
 */
Tables.table23 = [0x010002, 0x040003, 0x070007, 0x040004, 0x050004, 0x070007, 0x060006, 0x070007, 0x080008];

/**
 * <CODE>
 *  for (i = 0; i < 4*4; i++) [
 *       table56[i] = ((ht[5].hlen[i]) << 16) + ht[6].hlen[i];
 *   ]
 * </CODE>
 *
 */
Tables.table56 = [0x010003, 0x040004, 0x070006, 0x080008, 0x040004, 0x050004, 0x080006, 0x090007, 0x070005, 0x080006, 0x090007, 0x0a0008, 0x080007, 0x080007, 0x090008, 0x0a0009];
Tables.bitrate_table = [[0, 8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160, -1], /* MPEG 2 */
[0, 32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, -1], /* MPEG 1 */
[0, 8, 16, 24, 32, 40, 48, 56, 64, -1, -1, -1, -1, -1, -1, -1] /* MPEG 2.5 */];

/**
 * MPEG 2, MPEG 1, MPEG 2.5.
 */
Tables.samplerate_table = [[22050, 24000, 16000, -1], [44100, 48000, 32000, -1], [11025, 12000, 8000, -1]];

/**
 * This is the scfsi_band table from 2.4.2.7 of the IS.
 */
Tables.scfsi_band = [0, 6, 11, 16, 21];
var Tables_1 = Tables;

/*
 *      quantize_pvt source file
 *
 *      Copyright (c) 1999-2002 Takehiro Tominaga
 *      Copyright (c) 2000-2002 Robert Hegemann
 *      Copyright (c) 2001 Naoki Shibata
 *      Copyright (c) 2002-2005 Gabriel Bouvigne
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Library General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public
 * License along with this library; if not, write to the
 * Free Software Foundation, Inc., 59 Temple Place - Suite 330,
 * Boston, MA 02111-1307, USA.
 */

var QuantizePVT_1;
var hasRequiredQuantizePVT;

function requireQuantizePVT () {
	if (hasRequiredQuantizePVT) return QuantizePVT_1;
	hasRequiredQuantizePVT = 1;
	/* $Id: QuantizePVT.java,v 1.24 2011/05/24 20:48:06 kenchis Exp $ */
	var ScaleFac = ScaleFac_1;
	var common = common$b;
	var VbrMode = common.VbrMode;
	var Float = common.Float;
	var Util = common.Util;
	var new_float = common.new_float;
	var new_int = common.new_int;
	var assert = common.assert;
	var Encoder = requireEncoder();
	var MeanBits = MeanBits_1;
	var LameInternalFlags = LameInternalFlags_1;
	QuantizePVT.Q_MAX = 256 + 1;
	QuantizePVT.Q_MAX2 = 116;
	QuantizePVT.LARGE_BITS = 100000;
	QuantizePVT.IXMAX_VAL = 8206;
	function QuantizePVT() {
	  var BitStream = requireBitStream();
	  var tak = null;
	  var rv = null;
	  var psy = null;
	  this.setModules = function (_tk, _rv, _psy) {
	    tak = _tk;
	    rv = _rv;
	    psy = _psy;
	  };
	  function POW20(x) {
	    assert(0 <= x + QuantizePVT.Q_MAX2 && x < QuantizePVT.Q_MAX);
	    return pow20[x + QuantizePVT.Q_MAX2];
	  }
	  this.IPOW20 = function (x) {
	    assert(0 <= x && x < QuantizePVT.Q_MAX);
	    return ipow20[x];
	  };

	  /**
	   * smallest such that 1.0+DBL_EPSILON != 1.0
	   */
	  var DBL_EPSILON = 2.2204460492503131e-016;

	  /**
	   * ix always <= 8191+15. see count_bits()
	   */
	  var IXMAX_VAL = QuantizePVT.IXMAX_VAL;
	  var PRECALC_SIZE = IXMAX_VAL + 2;
	  var Q_MAX = QuantizePVT.Q_MAX;

	  /**
	   * <CODE>
	   * minimum possible number of
	   * -cod_info.global_gain + ((scalefac[] + (cod_info.preflag ? pretab[sfb] : 0))
	   * << (cod_info.scalefac_scale + 1)) + cod_info.subblock_gain[cod_info.window[sfb]] * 8;
	   *
	   * for long block, 0+((15+3)<<2) = 18*4 = 72
	   * for short block, 0+(15<<2)+7*8 = 15*4+56 = 116
	   * </CODE>
	   */
	  var Q_MAX2 = QuantizePVT.Q_MAX2;
	  QuantizePVT.LARGE_BITS;

	  /**
	   * Assuming dynamic range=96dB, this value should be 92
	   */
	  var NSATHSCALE = 100;

	  /**
	   * The following table is used to implement the scalefactor partitioning for
	   * MPEG2 as described in section 2.4.3.2 of the IS. The indexing corresponds
	   * to the way the tables are presented in the IS:
	   *
	   * [table_number][row_in_table][column of nr_of_sfb]
	   */
	  this.nr_of_sfb_block = [[[6, 5, 5, 5], [9, 9, 9, 9], [6, 9, 9, 9]], [[6, 5, 7, 3], [9, 9, 12, 6], [6, 9, 12, 6]], [[11, 10, 0, 0], [18, 18, 0, 0], [15, 18, 0, 0]], [[7, 7, 7, 0], [12, 12, 12, 0], [6, 15, 12, 0]], [[6, 6, 6, 3], [12, 9, 9, 6], [6, 12, 9, 6]], [[8, 8, 5, 0], [15, 12, 9, 0], [6, 18, 9, 0]]];

	  /**
	   * Table B.6: layer3 preemphasis
	   */
	  var pretab = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 3, 3, 3, 2, 0];
	  this.pretab = pretab;

	  /**
	   * Here are MPEG1 Table B.8 and MPEG2 Table B.1 -- Layer III scalefactor
	   * bands. <BR>
	   * Index into this using a method such as:<BR>
	   * idx = fr_ps.header.sampling_frequency + (fr_ps.header.version * 3)
	   */
	  this.sfBandIndex = [
	  // Table B.2.b: 22.05 kHz
	  new ScaleFac([0, 6, 12, 18, 24, 30, 36, 44, 54, 66, 80, 96, 116, 140, 168, 200, 238, 284, 336, 396, 464, 522, 576], [0, 4, 8, 12, 18, 24, 32, 42, 56, 74, 100, 132, 174, 192], [0, 0, 0, 0, 0, 0, 0] //  sfb21 pseudo sub bands
	  , [0, 0, 0, 0, 0, 0, 0] //  sfb12 pseudo sub bands
	  ), /* Table B.2.c: 24 kHz */ /* docs: 332. mpg123(broken): 330 */
	  new ScaleFac([0, 6, 12, 18, 24, 30, 36, 44, 54, 66, 80, 96, 114, 136, 162, 194, 232, 278, 332, 394, 464, 540, 576], [0, 4, 8, 12, 18, 26, 36, 48, 62, 80, 104, 136, 180, 192], [0, 0, 0, 0, 0, 0, 0] /*  sfb21 pseudo sub bands */, [0, 0, 0, 0, 0, 0, 0] /*  sfb12 pseudo sub bands */), /* Table B.2.a: 16 kHz */
	  new ScaleFac([0, 6, 12, 18, 24, 30, 36, 44, 54, 66, 80, 96, 116, 140, 168, 200, 238, 284, 336, 396, 464, 522, 576], [0, 4, 8, 12, 18, 26, 36, 48, 62, 80, 104, 134, 174, 192], [0, 0, 0, 0, 0, 0, 0] /*  sfb21 pseudo sub bands */, [0, 0, 0, 0, 0, 0, 0] /*  sfb12 pseudo sub bands */), /* Table B.8.b: 44.1 kHz */
	  new ScaleFac([0, 4, 8, 12, 16, 20, 24, 30, 36, 44, 52, 62, 74, 90, 110, 134, 162, 196, 238, 288, 342, 418, 576], [0, 4, 8, 12, 16, 22, 30, 40, 52, 66, 84, 106, 136, 192], [0, 0, 0, 0, 0, 0, 0] /*  sfb21 pseudo sub bands */, [0, 0, 0, 0, 0, 0, 0] /*  sfb12 pseudo sub bands */), /* Table B.8.c: 48 kHz */
	  new ScaleFac([0, 4, 8, 12, 16, 20, 24, 30, 36, 42, 50, 60, 72, 88, 106, 128, 156, 190, 230, 276, 330, 384, 576], [0, 4, 8, 12, 16, 22, 28, 38, 50, 64, 80, 100, 126, 192], [0, 0, 0, 0, 0, 0, 0] /*  sfb21 pseudo sub bands */, [0, 0, 0, 0, 0, 0, 0] /*  sfb12 pseudo sub bands */), /* Table B.8.a: 32 kHz */
	  new ScaleFac([0, 4, 8, 12, 16, 20, 24, 30, 36, 44, 54, 66, 82, 102, 126, 156, 194, 240, 296, 364, 448, 550, 576], [0, 4, 8, 12, 16, 22, 30, 42, 58, 78, 104, 138, 180, 192], [0, 0, 0, 0, 0, 0, 0] /*  sfb21 pseudo sub bands */, [0, 0, 0, 0, 0, 0, 0] /*  sfb12 pseudo sub bands */), /* MPEG-2.5 11.025 kHz */
	  new ScaleFac([0, 6, 12, 18, 24, 30, 36, 44, 54, 66, 80, 96, 116, 140, 168, 200, 238, 284, 336, 396, 464, 522, 576], [0 / 3, 12 / 3, 24 / 3, 36 / 3, 54 / 3, 78 / 3, 108 / 3, 144 / 3, 186 / 3, 240 / 3, 312 / 3, 402 / 3, 522 / 3, 576 / 3], [0, 0, 0, 0, 0, 0, 0] /*  sfb21 pseudo sub bands */, [0, 0, 0, 0, 0, 0, 0] /*  sfb12 pseudo sub bands */), /* MPEG-2.5 12 kHz */
	  new ScaleFac([0, 6, 12, 18, 24, 30, 36, 44, 54, 66, 80, 96, 116, 140, 168, 200, 238, 284, 336, 396, 464, 522, 576], [0 / 3, 12 / 3, 24 / 3, 36 / 3, 54 / 3, 78 / 3, 108 / 3, 144 / 3, 186 / 3, 240 / 3, 312 / 3, 402 / 3, 522 / 3, 576 / 3], [0, 0, 0, 0, 0, 0, 0] /*  sfb21 pseudo sub bands */, [0, 0, 0, 0, 0, 0, 0] /*  sfb12 pseudo sub bands */), /* MPEG-2.5 8 kHz */
	  new ScaleFac([0, 12, 24, 36, 48, 60, 72, 88, 108, 132, 160, 192, 232, 280, 336, 400, 476, 566, 568, 570, 572, 574, 576], [0 / 3, 24 / 3, 48 / 3, 72 / 3, 108 / 3, 156 / 3, 216 / 3, 288 / 3, 372 / 3, 480 / 3, 486 / 3, 492 / 3, 498 / 3, 576 / 3], [0, 0, 0, 0, 0, 0, 0] /*  sfb21 pseudo sub bands */, [0, 0, 0, 0, 0, 0, 0] /*  sfb12 pseudo sub bands */)];
	  var pow20 = new_float(Q_MAX + Q_MAX2 + 1);
	  var ipow20 = new_float(Q_MAX);
	  var pow43 = new_float(PRECALC_SIZE);
	  var adj43 = new_float(PRECALC_SIZE);
	  this.adj43 = adj43;

	  /**
	   * <PRE>
	   * compute the ATH for each scalefactor band cd range: 0..96db
	   *
	   * Input: 3.3kHz signal 32767 amplitude (3.3kHz is where ATH is smallest =
	   * -5db) longblocks: sfb=12 en0/bw=-11db max_en0 = 1.3db shortblocks: sfb=5
	   * -9db 0db
	   *
	   * Input: 1 1 1 1 1 1 1 -1 -1 -1 -1 -1 -1 -1 (repeated) longblocks: amp=1
	   * sfb=12 en0/bw=-103 db max_en0 = -92db amp=32767 sfb=12 -12 db -1.4db
	   *
	   * Input: 1 1 1 1 1 1 1 -1 -1 -1 -1 -1 -1 -1 (repeated) shortblocks: amp=1
	   * sfb=5 en0/bw= -99 -86 amp=32767 sfb=5 -9 db 4db
	   *
	   *
	   * MAX energy of largest wave at 3.3kHz = 1db AVE energy of largest wave at
	   * 3.3kHz = -11db Let's take AVE: -11db = maximum signal in sfb=12. Dynamic
	   * range of CD: 96db. Therefor energy of smallest audible wave in sfb=12 =
	   * -11 - 96 = -107db = ATH at 3.3kHz.
	   *
	   * ATH formula for this wave: -5db. To adjust to LAME scaling, we need ATH =
	   * ATH_formula - 103 (db) ATH = ATH * 2.5e-10 (ener)
	   * </PRE>
	   */
	  function ATHmdct(gfp, f) {
	    var ath = psy.ATHformula(f, gfp);
	    ath -= NSATHSCALE;

	    /* modify the MDCT scaling for the ATH and convert to energy */
	    ath = Math.pow(10.0, ath / 10.0 + gfp.ATHlower);
	    return ath;
	  }
	  function compute_ath(gfp) {
	    var ATH_l = gfp.internal_flags.ATH.l;
	    var ATH_psfb21 = gfp.internal_flags.ATH.psfb21;
	    var ATH_s = gfp.internal_flags.ATH.s;
	    var ATH_psfb12 = gfp.internal_flags.ATH.psfb12;
	    var gfc = gfp.internal_flags;
	    var samp_freq = gfp.out_samplerate;
	    for (var sfb = 0; sfb < Encoder.SBMAX_l; sfb++) {
	      var start = gfc.scalefac_band.l[sfb];
	      var end = gfc.scalefac_band.l[sfb + 1];
	      ATH_l[sfb] = Float.MAX_VALUE;
	      for (var i = start; i < end; i++) {
	        var freq = i * samp_freq / (2 * 576);
	        var ATH_f = ATHmdct(gfp, freq);
	        /* freq in kHz */
	        ATH_l[sfb] = Math.min(ATH_l[sfb], ATH_f);
	      }
	    }
	    for (var sfb = 0; sfb < Encoder.PSFB21; sfb++) {
	      var start = gfc.scalefac_band.psfb21[sfb];
	      var end = gfc.scalefac_band.psfb21[sfb + 1];
	      ATH_psfb21[sfb] = Float.MAX_VALUE;
	      for (var i = start; i < end; i++) {
	        var freq = i * samp_freq / (2 * 576);
	        var ATH_f = ATHmdct(gfp, freq);
	        /* freq in kHz */
	        ATH_psfb21[sfb] = Math.min(ATH_psfb21[sfb], ATH_f);
	      }
	    }
	    for (var sfb = 0; sfb < Encoder.SBMAX_s; sfb++) {
	      var start = gfc.scalefac_band.s[sfb];
	      var end = gfc.scalefac_band.s[sfb + 1];
	      ATH_s[sfb] = Float.MAX_VALUE;
	      for (var i = start; i < end; i++) {
	        var freq = i * samp_freq / (2 * 192);
	        var ATH_f = ATHmdct(gfp, freq);
	        /* freq in kHz */
	        ATH_s[sfb] = Math.min(ATH_s[sfb], ATH_f);
	      }
	      ATH_s[sfb] *= gfc.scalefac_band.s[sfb + 1] - gfc.scalefac_band.s[sfb];
	    }
	    for (var sfb = 0; sfb < Encoder.PSFB12; sfb++) {
	      var start = gfc.scalefac_band.psfb12[sfb];
	      var end = gfc.scalefac_band.psfb12[sfb + 1];
	      ATH_psfb12[sfb] = Float.MAX_VALUE;
	      for (var i = start; i < end; i++) {
	        var freq = i * samp_freq / (2 * 192);
	        var ATH_f = ATHmdct(gfp, freq);
	        /* freq in kHz */
	        ATH_psfb12[sfb] = Math.min(ATH_psfb12[sfb], ATH_f);
	      }
	      /* not sure about the following */
	      ATH_psfb12[sfb] *= gfc.scalefac_band.s[13] - gfc.scalefac_band.s[12];
	    }

	    /*
	     * no-ATH mode: reduce ATH to -200 dB
	     */
	    if (gfp.noATH) {
	      for (var sfb = 0; sfb < Encoder.SBMAX_l; sfb++) {
	        ATH_l[sfb] = 1E-20;
	      }
	      for (var sfb = 0; sfb < Encoder.PSFB21; sfb++) {
	        ATH_psfb21[sfb] = 1E-20;
	      }
	      for (var sfb = 0; sfb < Encoder.SBMAX_s; sfb++) {
	        ATH_s[sfb] = 1E-20;
	      }
	      for (var sfb = 0; sfb < Encoder.PSFB12; sfb++) {
	        ATH_psfb12[sfb] = 1E-20;
	      }
	    }

	    /*
	     * work in progress, don't rely on it too much
	     */
	    gfc.ATH.floor = 10. * Math.log10(ATHmdct(gfp, -1.));
	  }

	  /**
	   * initialization for iteration_loop
	   */
	  this.iteration_init = function (gfp) {
	    var gfc = gfp.internal_flags;
	    var l3_side = gfc.l3_side;
	    var i;
	    if (gfc.iteration_init_init == 0) {
	      gfc.iteration_init_init = 1;
	      l3_side.main_data_begin = 0;
	      compute_ath(gfp);
	      pow43[0] = 0.0;
	      for (i = 1; i < PRECALC_SIZE; i++) pow43[i] = Math.pow(i, 4.0 / 3.0);
	      for (i = 0; i < PRECALC_SIZE - 1; i++) adj43[i] = i + 1 - Math.pow(0.5 * (pow43[i] + pow43[i + 1]), 0.75);
	      adj43[i] = 0.5;
	      for (i = 0; i < Q_MAX; i++) ipow20[i] = Math.pow(2.0, (i - 210) * -0.1875);
	      for (i = 0; i <= Q_MAX + Q_MAX2; i++) pow20[i] = Math.pow(2.0, (i - 210 - Q_MAX2) * 0.25);
	      tak.huffman_init(gfc);
	      {
	        var bass, alto, treble, sfb21;
	        i = gfp.exp_nspsytune >> 2 & 63;
	        if (i >= 32) i -= 64;
	        bass = Math.pow(10, i / 4.0 / 10.0);
	        i = gfp.exp_nspsytune >> 8 & 63;
	        if (i >= 32) i -= 64;
	        alto = Math.pow(10, i / 4.0 / 10.0);
	        i = gfp.exp_nspsytune >> 14 & 63;
	        if (i >= 32) i -= 64;
	        treble = Math.pow(10, i / 4.0 / 10.0);

	        /*
	         * to be compatible with Naoki's original code, the next 6 bits
	         * define only the amount of changing treble for sfb21
	         */
	        i = gfp.exp_nspsytune >> 20 & 63;
	        if (i >= 32) i -= 64;
	        sfb21 = treble * Math.pow(10, i / 4.0 / 10.0);
	        for (i = 0; i < Encoder.SBMAX_l; i++) {
	          var f;
	          if (i <= 6) f = bass;else if (i <= 13) f = alto;else if (i <= 20) f = treble;else f = sfb21;
	          gfc.nsPsy.longfact[i] = f;
	        }
	        for (i = 0; i < Encoder.SBMAX_s; i++) {
	          var f;
	          if (i <= 5) f = bass;else if (i <= 10) f = alto;else if (i <= 11) f = treble;else f = sfb21;
	          gfc.nsPsy.shortfact[i] = f;
	        }
	      }
	    }
	  };

	  /**
	   * allocate bits among 2 channels based on PE<BR>
	   * mt 6/99<BR>
	   * bugfixes rh 8/01: often allocated more than the allowed 4095 bits
	   */
	  this.on_pe = function (gfp, pe, targ_bits, mean_bits, gr, cbr) {
	    var gfc = gfp.internal_flags;
	    var tbits = 0,
	      bits;
	    var add_bits = new_int(2);
	    var ch;

	    /* allocate targ_bits for granule */
	    var mb = new MeanBits(tbits);
	    var extra_bits = rv.ResvMaxBits(gfp, mean_bits, mb, cbr);
	    tbits = mb.bits;
	    /* maximum allowed bits for this granule */
	    var max_bits = tbits + extra_bits;
	    if (max_bits > LameInternalFlags.MAX_BITS_PER_GRANULE) {
	      // hard limit per granule
	      max_bits = LameInternalFlags.MAX_BITS_PER_GRANULE;
	    }
	    for (bits = 0, ch = 0; ch < gfc.channels_out; ++ch) {
	      /******************************************************************
	       * allocate bits for each channel
	       ******************************************************************/
	      targ_bits[ch] = Math.min(LameInternalFlags.MAX_BITS_PER_CHANNEL, tbits / gfc.channels_out);
	      add_bits[ch] = 0 | targ_bits[ch] * pe[gr][ch] / 700.0 - targ_bits[ch];

	      /* at most increase bits by 1.5*average */
	      if (add_bits[ch] > mean_bits * 3 / 4) add_bits[ch] = mean_bits * 3 / 4;
	      if (add_bits[ch] < 0) add_bits[ch] = 0;
	      if (add_bits[ch] + targ_bits[ch] > LameInternalFlags.MAX_BITS_PER_CHANNEL) add_bits[ch] = Math.max(0, LameInternalFlags.MAX_BITS_PER_CHANNEL - targ_bits[ch]);
	      bits += add_bits[ch];
	    }
	    if (bits > extra_bits) {
	      for (ch = 0; ch < gfc.channels_out; ++ch) {
	        add_bits[ch] = extra_bits * add_bits[ch] / bits;
	      }
	    }
	    for (ch = 0; ch < gfc.channels_out; ++ch) {
	      targ_bits[ch] += add_bits[ch];
	      extra_bits -= add_bits[ch];
	    }
	    for (bits = 0, ch = 0; ch < gfc.channels_out; ++ch) {
	      bits += targ_bits[ch];
	    }
	    if (bits > LameInternalFlags.MAX_BITS_PER_GRANULE) {
	      var sum = 0;
	      for (ch = 0; ch < gfc.channels_out; ++ch) {
	        targ_bits[ch] *= LameInternalFlags.MAX_BITS_PER_GRANULE;
	        targ_bits[ch] /= bits;
	        sum += targ_bits[ch];
	      }
	    }
	    return max_bits;
	  };
	  this.reduce_side = function (targ_bits, ms_ener_ratio, mean_bits, max_bits) {
	    assert(targ_bits[0] + targ_bits[1] <= LameInternalFlags.MAX_BITS_PER_GRANULE);

	    /*
	     * ms_ener_ratio = 0: allocate 66/33 mid/side fac=.33 ms_ener_ratio =.5:
	     * allocate 50/50 mid/side fac= 0
	     */
	    /* 75/25 split is fac=.5 */
	    var fac = .33 * (.5 - ms_ener_ratio) / .5;
	    if (fac < 0) fac = 0;
	    if (fac > .5) fac = .5;

	    /* number of bits to move from side channel to mid channel */
	    /* move_bits = fac*targ_bits[1]; */
	    var move_bits = 0 | fac * .5 * (targ_bits[0] + targ_bits[1]);
	    if (move_bits > LameInternalFlags.MAX_BITS_PER_CHANNEL - targ_bits[0]) {
	      move_bits = LameInternalFlags.MAX_BITS_PER_CHANNEL - targ_bits[0];
	    }
	    if (move_bits < 0) move_bits = 0;
	    if (targ_bits[1] >= 125) {
	      /* dont reduce side channel below 125 bits */
	      if (targ_bits[1] - move_bits > 125) {
	        /* if mid channel already has 2x more than average, dont bother */
	        /* mean_bits = bits per granule (for both channels) */
	        if (targ_bits[0] < mean_bits) targ_bits[0] += move_bits;
	        targ_bits[1] -= move_bits;
	      } else {
	        targ_bits[0] += targ_bits[1] - 125;
	        targ_bits[1] = 125;
	      }
	    }
	    move_bits = targ_bits[0] + targ_bits[1];
	    if (move_bits > max_bits) {
	      targ_bits[0] = max_bits * targ_bits[0] / move_bits;
	      targ_bits[1] = max_bits * targ_bits[1] / move_bits;
	    }
	    assert(targ_bits[0] <= LameInternalFlags.MAX_BITS_PER_CHANNEL);
	    assert(targ_bits[1] <= LameInternalFlags.MAX_BITS_PER_CHANNEL);
	    assert(targ_bits[0] + targ_bits[1] <= LameInternalFlags.MAX_BITS_PER_GRANULE);
	  };

	  /**
	   *  Robert Hegemann 2001-04-27:
	   *  this adjusts the ATH, keeping the original noise floor
	   *  affects the higher frequencies more than the lower ones
	   */
	  this.athAdjust = function (a, x, athFloor) {
	    /*
	     * work in progress
	     */
	    var o = 90.30873362;
	    var p = 94.82444863;
	    var u = Util.FAST_LOG10_X(x, 10.0);
	    var v = a * a;
	    var w = 0.0;
	    u -= athFloor;
	    /* undo scaling */
	    if (v > 1E-20) w = 1. + Util.FAST_LOG10_X(v, 10.0 / o);
	    if (w < 0) w = 0.;
	    u *= w;
	    u += athFloor + o - p;
	    /* redo scaling */

	    return Math.pow(10., 0.1 * u);
	  };

	  /**
	   * Calculate the allowed distortion for each scalefactor band, as determined
	   * by the psychoacoustic model. xmin(sb) = ratio(sb) * en(sb) / bw(sb)
	   *
	   * returns number of sfb's with energy > ATH
	   */
	  this.calc_xmin = function (gfp, ratio, cod_info, pxmin) {
	    var pxminPos = 0;
	    var gfc = gfp.internal_flags;
	    var gsfb,
	      j = 0,
	      ath_over = 0;
	    var ATH = gfc.ATH;
	    var xr = cod_info.xr;
	    var enable_athaa_fix = gfp.VBR == VbrMode.vbr_mtrh ? 1 : 0;
	    var masking_lower = gfc.masking_lower;
	    if (gfp.VBR == VbrMode.vbr_mtrh || gfp.VBR == VbrMode.vbr_mt) {
	      /* was already done in PSY-Model */
	      masking_lower = 1.0;
	    }
	    for (gsfb = 0; gsfb < cod_info.psy_lmax; gsfb++) {
	      var en0, xmin;
	      var rh1, rh2;
	      var width, l;
	      if (gfp.VBR == VbrMode.vbr_rh || gfp.VBR == VbrMode.vbr_mtrh) xmin = athAdjust(ATH.adjust, ATH.l[gsfb], ATH.floor);else xmin = ATH.adjust * ATH.l[gsfb];
	      width = cod_info.width[gsfb];
	      rh1 = xmin / width;
	      rh2 = DBL_EPSILON;
	      l = width >> 1;
	      en0 = 0.0;
	      do {
	        var xa, xb;
	        xa = xr[j] * xr[j];
	        en0 += xa;
	        rh2 += xa < rh1 ? xa : rh1;
	        j++;
	        xb = xr[j] * xr[j];
	        en0 += xb;
	        rh2 += xb < rh1 ? xb : rh1;
	        j++;
	      } while (--l > 0);
	      if (en0 > xmin) ath_over++;
	      if (gsfb == Encoder.SBPSY_l) {
	        var x = xmin * gfc.nsPsy.longfact[gsfb];
	        if (rh2 < x) {
	          rh2 = x;
	        }
	      }
	      if (enable_athaa_fix != 0) {
	        xmin = rh2;
	      }
	      if (!gfp.ATHonly) {
	        var e = ratio.en.l[gsfb];
	        if (e > 0.0) {
	          var x;
	          x = en0 * ratio.thm.l[gsfb] * masking_lower / e;
	          if (enable_athaa_fix != 0) x *= gfc.nsPsy.longfact[gsfb];
	          if (xmin < x) xmin = x;
	        }
	      }
	      if (enable_athaa_fix != 0) pxmin[pxminPos++] = xmin;else pxmin[pxminPos++] = xmin * gfc.nsPsy.longfact[gsfb];
	    }
	    /* end of long block loop */

	    /* use this function to determine the highest non-zero coeff */
	    var max_nonzero = 575;
	    if (cod_info.block_type != Encoder.SHORT_TYPE) {
	      // NORM, START or STOP type, but not SHORT
	      var k = 576;
	      while (k-- != 0 && BitStream.EQ(xr[k], 0)) {
	        max_nonzero = k;
	      }
	    }
	    cod_info.max_nonzero_coeff = max_nonzero;
	    for (var sfb = cod_info.sfb_smin; gsfb < cod_info.psymax; sfb++, gsfb += 3) {
	      var width, b;
	      var tmpATH;
	      if (gfp.VBR == VbrMode.vbr_rh || gfp.VBR == VbrMode.vbr_mtrh) tmpATH = athAdjust(ATH.adjust, ATH.s[sfb], ATH.floor);else tmpATH = ATH.adjust * ATH.s[sfb];
	      width = cod_info.width[gsfb];
	      for (b = 0; b < 3; b++) {
	        var en0 = 0.0,
	          xmin;
	        var rh1, rh2;
	        var l = width >> 1;
	        rh1 = tmpATH / width;
	        rh2 = DBL_EPSILON;
	        do {
	          var xa, xb;
	          xa = xr[j] * xr[j];
	          en0 += xa;
	          rh2 += xa < rh1 ? xa : rh1;
	          j++;
	          xb = xr[j] * xr[j];
	          en0 += xb;
	          rh2 += xb < rh1 ? xb : rh1;
	          j++;
	        } while (--l > 0);
	        if (en0 > tmpATH) ath_over++;
	        if (sfb == Encoder.SBPSY_s) {
	          var x = tmpATH * gfc.nsPsy.shortfact[sfb];
	          if (rh2 < x) {
	            rh2 = x;
	          }
	        }
	        if (enable_athaa_fix != 0) xmin = rh2;else xmin = tmpATH;
	        if (!gfp.ATHonly && !gfp.ATHshort) {
	          var e = ratio.en.s[sfb][b];
	          if (e > 0.0) {
	            var x;
	            x = en0 * ratio.thm.s[sfb][b] * masking_lower / e;
	            if (enable_athaa_fix != 0) x *= gfc.nsPsy.shortfact[sfb];
	            if (xmin < x) xmin = x;
	          }
	        }
	        if (enable_athaa_fix != 0) pxmin[pxminPos++] = xmin;else pxmin[pxminPos++] = xmin * gfc.nsPsy.shortfact[sfb];
	      }
	      /* b */
	      if (gfp.useTemporal) {
	        if (pxmin[pxminPos - 3] > pxmin[pxminPos - 3 + 1]) pxmin[pxminPos - 3 + 1] += (pxmin[pxminPos - 3] - pxmin[pxminPos - 3 + 1]) * gfc.decay;
	        if (pxmin[pxminPos - 3 + 1] > pxmin[pxminPos - 3 + 2]) pxmin[pxminPos - 3 + 2] += (pxmin[pxminPos - 3 + 1] - pxmin[pxminPos - 3 + 2]) * gfc.decay;
	      }
	    }
	    /* end of short block sfb loop */

	    return ath_over;
	  };
	  function StartLine(j) {
	    this.s = j;
	  }
	  this.calc_noise_core = function (cod_info, startline, l, step) {
	    var noise = 0;
	    var j = startline.s;
	    var ix = cod_info.l3_enc;
	    if (j > cod_info.count1) {
	      while (l-- != 0) {
	        var temp;
	        temp = cod_info.xr[j];
	        j++;
	        noise += temp * temp;
	        temp = cod_info.xr[j];
	        j++;
	        noise += temp * temp;
	      }
	    } else if (j > cod_info.big_values) {
	      var ix01 = new_float(2);
	      ix01[0] = 0;
	      ix01[1] = step;
	      while (l-- != 0) {
	        var temp;
	        temp = Math.abs(cod_info.xr[j]) - ix01[ix[j]];
	        j++;
	        noise += temp * temp;
	        temp = Math.abs(cod_info.xr[j]) - ix01[ix[j]];
	        j++;
	        noise += temp * temp;
	      }
	    } else {
	      while (l-- != 0) {
	        var temp;
	        temp = Math.abs(cod_info.xr[j]) - pow43[ix[j]] * step;
	        j++;
	        noise += temp * temp;
	        temp = Math.abs(cod_info.xr[j]) - pow43[ix[j]] * step;
	        j++;
	        noise += temp * temp;
	      }
	    }
	    startline.s = j;
	    return noise;
	  };

	  /**
	   * <PRE>
	   * -oo dB  =>  -1.00
	   * - 6 dB  =>  -0.97
	   * - 3 dB  =>  -0.80
	   * - 2 dB  =>  -0.64
	   * - 1 dB  =>  -0.38
	   *   0 dB  =>   0.00
	   * + 1 dB  =>  +0.49
	   * + 2 dB  =>  +1.06
	   * + 3 dB  =>  +1.68
	   * + 6 dB  =>  +3.69
	   * +10 dB  =>  +6.45
	   * </PRE>
	   */
	  this.calc_noise = function (cod_info, l3_xmin, distort, res, prev_noise) {
	    var distortPos = 0;
	    var l3_xminPos = 0;
	    var sfb,
	      l,
	      over = 0;
	    var over_noise_db = 0;
	    /* 0 dB relative to masking */
	    var tot_noise_db = 0;
	    /* -200 dB relative to masking */
	    var max_noise = -20.0;
	    var j = 0;
	    var scalefac = cod_info.scalefac;
	    var scalefacPos = 0;
	    res.over_SSD = 0;
	    for (sfb = 0; sfb < cod_info.psymax; sfb++) {
	      var s = cod_info.global_gain - (scalefac[scalefacPos++] + (cod_info.preflag != 0 ? pretab[sfb] : 0) << cod_info.scalefac_scale + 1) - cod_info.subblock_gain[cod_info.window[sfb]] * 8;
	      var noise = 0.0;
	      if (prev_noise != null && prev_noise.step[sfb] == s) {
	        /* use previously computed values */
	        noise = prev_noise.noise[sfb];
	        j += cod_info.width[sfb];
	        distort[distortPos++] = noise / l3_xmin[l3_xminPos++];
	        noise = prev_noise.noise_log[sfb];
	      } else {
	        var step = POW20(s);
	        l = cod_info.width[sfb] >> 1;
	        if (j + cod_info.width[sfb] > cod_info.max_nonzero_coeff) {
	          var usefullsize;
	          usefullsize = cod_info.max_nonzero_coeff - j + 1;
	          if (usefullsize > 0) l = usefullsize >> 1;else l = 0;
	        }
	        var sl = new StartLine(j);
	        noise = this.calc_noise_core(cod_info, sl, l, step);
	        j = sl.s;
	        if (prev_noise != null) {
	          /* save noise values */
	          prev_noise.step[sfb] = s;
	          prev_noise.noise[sfb] = noise;
	        }
	        noise = distort[distortPos++] = noise / l3_xmin[l3_xminPos++];

	        /* multiplying here is adding in dB, but can overflow */
	        noise = Util.FAST_LOG10(Math.max(noise, 1E-20));
	        if (prev_noise != null) {
	          /* save noise values */
	          prev_noise.noise_log[sfb] = noise;
	        }
	      }
	      if (prev_noise != null) {
	        /* save noise values */
	        prev_noise.global_gain = cod_info.global_gain;
	      }
	      tot_noise_db += noise;
	      if (noise > 0.0) {
	        var tmp;
	        tmp = Math.max(0 | noise * 10 + .5, 1);
	        res.over_SSD += tmp * tmp;
	        over++;
	        /* multiplying here is adding in dB -but can overflow */
	        /* over_noise *= noise; */
	        over_noise_db += noise;
	      }
	      max_noise = Math.max(max_noise, noise);
	    }
	    res.over_count = over;
	    res.tot_noise = tot_noise_db;
	    res.over_noise = over_noise_db;
	    res.max_noise = max_noise;
	    return over;
	  };

	  /**
	   * updates plotting data
	   *
	   * Mark Taylor 2000-??-??
	   *
	   * Robert Hegemann: moved noise/distortion calc into it
	   */
	  this.set_pinfo = function (gfp, cod_info, ratio, gr, ch) {
	    var gfc = gfp.internal_flags;
	    var sfb, sfb2;
	    var l;
	    var en0, en1;
	    var ifqstep = cod_info.scalefac_scale == 0 ? .5 : 1.0;
	    var scalefac = cod_info.scalefac;
	    var l3_xmin = new_float(L3Side.SFBMAX);
	    var xfsf = new_float(L3Side.SFBMAX);
	    var noise = new CalcNoiseResult();
	    calc_xmin(gfp, ratio, cod_info, l3_xmin);
	    calc_noise(cod_info, l3_xmin, xfsf, noise, null);
	    var j = 0;
	    sfb2 = cod_info.sfb_lmax;
	    if (cod_info.block_type != Encoder.SHORT_TYPE && 0 == cod_info.mixed_block_flag) sfb2 = 22;
	    for (sfb = 0; sfb < sfb2; sfb++) {
	      var start = gfc.scalefac_band.l[sfb];
	      var end = gfc.scalefac_band.l[sfb + 1];
	      var bw = end - start;
	      for (en0 = 0.0; j < end; j++) en0 += cod_info.xr[j] * cod_info.xr[j];
	      en0 /= bw;
	      /* convert to MDCT units */
	      /* scaling so it shows up on FFT plot */
	      en1 = 1e15;
	      gfc.pinfo.en[gr][ch][sfb] = en1 * en0;
	      gfc.pinfo.xfsf[gr][ch][sfb] = en1 * l3_xmin[sfb] * xfsf[sfb] / bw;
	      if (ratio.en.l[sfb] > 0 && !gfp.ATHonly) en0 = en0 / ratio.en.l[sfb];else en0 = 0.0;
	      gfc.pinfo.thr[gr][ch][sfb] = en1 * Math.max(en0 * ratio.thm.l[sfb], gfc.ATH.l[sfb]);

	      /* there is no scalefactor bands >= SBPSY_l */
	      gfc.pinfo.LAMEsfb[gr][ch][sfb] = 0;
	      if (cod_info.preflag != 0 && sfb >= 11) gfc.pinfo.LAMEsfb[gr][ch][sfb] = -ifqstep * pretab[sfb];
	      if (sfb < Encoder.SBPSY_l) {
	        /* scfsi should be decoded by caller side */
	        assert(scalefac[sfb] >= 0);
	        gfc.pinfo.LAMEsfb[gr][ch][sfb] -= ifqstep * scalefac[sfb];
	      }
	    }
	    /* for sfb */

	    if (cod_info.block_type == Encoder.SHORT_TYPE) {
	      sfb2 = sfb;
	      for (sfb = cod_info.sfb_smin; sfb < Encoder.SBMAX_s; sfb++) {
	        var start = gfc.scalefac_band.s[sfb];
	        var end = gfc.scalefac_band.s[sfb + 1];
	        var bw = end - start;
	        for (var i = 0; i < 3; i++) {
	          for (en0 = 0.0, l = start; l < end; l++) {
	            en0 += cod_info.xr[j] * cod_info.xr[j];
	            j++;
	          }
	          en0 = Math.max(en0 / bw, 1e-20);
	          /* convert to MDCT units */
	          /* scaling so it shows up on FFT plot */
	          en1 = 1e15;
	          gfc.pinfo.en_s[gr][ch][3 * sfb + i] = en1 * en0;
	          gfc.pinfo.xfsf_s[gr][ch][3 * sfb + i] = en1 * l3_xmin[sfb2] * xfsf[sfb2] / bw;
	          if (ratio.en.s[sfb][i] > 0) en0 = en0 / ratio.en.s[sfb][i];else en0 = 0.0;
	          if (gfp.ATHonly || gfp.ATHshort) en0 = 0;
	          gfc.pinfo.thr_s[gr][ch][3 * sfb + i] = en1 * Math.max(en0 * ratio.thm.s[sfb][i], gfc.ATH.s[sfb]);

	          /* there is no scalefactor bands >= SBPSY_s */
	          gfc.pinfo.LAMEsfb_s[gr][ch][3 * sfb + i] = -2.0 * cod_info.subblock_gain[i];
	          if (sfb < Encoder.SBPSY_s) {
	            gfc.pinfo.LAMEsfb_s[gr][ch][3 * sfb + i] -= ifqstep * scalefac[sfb2];
	          }
	          sfb2++;
	        }
	      }
	    }
	    /* block type short */
	    gfc.pinfo.LAMEqss[gr][ch] = cod_info.global_gain;
	    gfc.pinfo.LAMEmainbits[gr][ch] = cod_info.part2_3_length + cod_info.part2_length;
	    gfc.pinfo.LAMEsfbits[gr][ch] = cod_info.part2_length;
	    gfc.pinfo.over[gr][ch] = noise.over_count;
	    gfc.pinfo.max_noise[gr][ch] = noise.max_noise * 10.0;
	    gfc.pinfo.over_noise[gr][ch] = noise.over_noise * 10.0;
	    gfc.pinfo.tot_noise[gr][ch] = noise.tot_noise * 10.0;
	    gfc.pinfo.over_SSD[gr][ch] = noise.over_SSD;
	  };
	}
	QuantizePVT_1 = QuantizePVT;
	return QuantizePVT_1;
}

/*
 *	MP3 huffman table selecting and bit counting
 *
 *	Copyright (c) 1999-2005 Takehiro TOMINAGA
 *	Copyright (c) 2002-2005 Gabriel Bouvigne
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.	 See the GNU
 * Library General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public
 * License along with this library; if not, write to the
 * Free Software Foundation, Inc., 59 Temple Place - Suite 330,
 * Boston, MA 02111-1307, USA.
 */

var Takehiro_1;
var hasRequiredTakehiro;

function requireTakehiro () {
	if (hasRequiredTakehiro) return Takehiro_1;
	hasRequiredTakehiro = 1;
	/* $Id: Takehiro.java,v 1.26 2011/05/24 20:48:06 kenchis Exp $ */

	//package mp3;

	//import java.util.Arrays;
	var common = common$b;
	var System = common.System;
	var Arrays = common.Arrays;
	var new_int = common.new_int;
	var assert = common.assert;
	var Encoder = requireEncoder();
	var Tables = Tables_1;
	var GrInfo = GrInfo_1;
	var QuantizePVT = requireQuantizePVT();
	function Takehiro() {
	  var qupvt = null;
	  this.qupvt = null;
	  this.setModules = function (_qupvt) {
	    this.qupvt = _qupvt;
	    qupvt = _qupvt;
	  };
	  function Bits(b) {
	    this.bits = 0 | b;
	  }
	  var subdv_table = [[0, 0], /* 0 bands */
	  [0, 0], /* 1 bands */
	  [0, 0], /* 2 bands */
	  [0, 0], /* 3 bands */
	  [0, 0], /* 4 bands */
	  [0, 1], /* 5 bands */
	  [1, 1], /* 6 bands */
	  [1, 1], /* 7 bands */
	  [1, 2], /* 8 bands */
	  [2, 2], /* 9 bands */
	  [2, 3], /* 10 bands */
	  [2, 3], /* 11 bands */
	  [3, 4], /* 12 bands */
	  [3, 4], /* 13 bands */
	  [3, 4], /* 14 bands */
	  [4, 5], /* 15 bands */
	  [4, 5], /* 16 bands */
	  [4, 6], /* 17 bands */
	  [5, 6], /* 18 bands */
	  [5, 6], /* 19 bands */
	  [5, 7], /* 20 bands */
	  [6, 7], /* 21 bands */
	  [6, 7] /* 22 bands */];

	  /**
	   * nonlinear quantization of xr More accurate formula than the ISO formula.
	   * Takes into account the fact that we are quantizing xr . ix, but we want
	   * ix^4/3 to be as close as possible to x^4/3. (taking the nearest int would
	   * mean ix is as close as possible to xr, which is different.)
	   *
	   * From Segher Boessenkool <segher@eastsite.nl> 11/1999
	   *
	   * 09/2000: ASM code removed in favor of IEEE754 hack by Takehiro Tominaga.
	   * If you need the ASM code, check CVS circa Aug 2000.
	   *
	   * 01/2004: Optimizations by Gabriel Bouvigne
	   */
	  function quantize_lines_xrpow_01(l, istep, xr, xrPos, ix, ixPos) {
	    var compareval0 = (1.0 - 0.4054) / istep;
	    l = l >> 1;
	    while (l-- != 0) {
	      ix[ixPos++] = compareval0 > xr[xrPos++] ? 0 : 1;
	      ix[ixPos++] = compareval0 > xr[xrPos++] ? 0 : 1;
	    }
	  }

	  /**
	   * XRPOW_FTOI is a macro to convert floats to ints.<BR>
	   * if XRPOW_FTOI(x) = nearest_int(x), then QUANTFAC(x)=adj43asm[x]<BR>
	   * ROUNDFAC= -0.0946<BR>
	   *
	   * if XRPOW_FTOI(x) = floor(x), then QUANTFAC(x)=asj43[x]<BR>
	   * ROUNDFAC=0.4054<BR>
	   *
	   * Note: using floor() or 0| is extremely slow. On machines where the
	   * TAKEHIRO_IEEE754_HACK code above does not work, it is worthwile to write
	   * some ASM for XRPOW_FTOI().
	   */
	  function quantize_lines_xrpow(l, istep, xr, xrPos, ix, ixPos) {
	    l = l >> 1;
	    var remaining = l % 2;
	    l = l >> 1;
	    while (l-- != 0) {
	      var x0, x1, x2, x3;
	      var rx0, rx1, rx2, rx3;
	      x0 = xr[xrPos++] * istep;
	      x1 = xr[xrPos++] * istep;
	      rx0 = 0 | x0;
	      x2 = xr[xrPos++] * istep;
	      rx1 = 0 | x1;
	      x3 = xr[xrPos++] * istep;
	      rx2 = 0 | x2;
	      x0 += qupvt.adj43[rx0];
	      rx3 = 0 | x3;
	      x1 += qupvt.adj43[rx1];
	      ix[ixPos++] = 0 | x0;
	      x2 += qupvt.adj43[rx2];
	      ix[ixPos++] = 0 | x1;
	      x3 += qupvt.adj43[rx3];
	      ix[ixPos++] = 0 | x2;
	      ix[ixPos++] = 0 | x3;
	    }
	    if (remaining != 0) {
	      var x0, x1;
	      var rx0, rx1;
	      x0 = xr[xrPos++] * istep;
	      x1 = xr[xrPos++] * istep;
	      rx0 = 0 | x0;
	      rx1 = 0 | x1;
	      x0 += qupvt.adj43[rx0];
	      x1 += qupvt.adj43[rx1];
	      ix[ixPos++] = 0 | x0;
	      ix[ixPos++] = 0 | x1;
	    }
	  }

	  /**
	   * Quantization function This function will select which lines to quantize
	   * and call the proper quantization function
	   */
	  function quantize_xrpow(xp, pi, istep, codInfo, prevNoise) {
	    /* quantize on xr^(3/4) instead of xr */
	    var sfb;
	    var sfbmax;
	    var j = 0;
	    var prev_data_use;
	    var accumulate = 0;
	    var accumulate01 = 0;
	    var xpPos = 0;
	    var iData = pi;
	    var iDataPos = 0;
	    var acc_iData = iData;
	    var acc_iDataPos = 0;
	    var acc_xp = xp;
	    var acc_xpPos = 0;

	    /*
	     * Reusing previously computed data does not seems to work if global
	     * gain is changed. Finding why it behaves this way would allow to use a
	     * cache of previously computed values (let's 10 cached values per sfb)
	     * that would probably provide a noticeable speedup
	     */
	    prev_data_use = prevNoise != null && codInfo.global_gain == prevNoise.global_gain;
	    if (codInfo.block_type == Encoder.SHORT_TYPE) sfbmax = 38;else sfbmax = 21;
	    for (sfb = 0; sfb <= sfbmax; sfb++) {
	      var step = -1;
	      if (prev_data_use || codInfo.block_type == Encoder.NORM_TYPE) {
	        step = codInfo.global_gain - (codInfo.scalefac[sfb] + (codInfo.preflag != 0 ? qupvt.pretab[sfb] : 0) << codInfo.scalefac_scale + 1) - codInfo.subblock_gain[codInfo.window[sfb]] * 8;
	      }
	      assert(codInfo.width[sfb] >= 0);
	      if (prev_data_use && prevNoise.step[sfb] == step) {
	        /*
	         * do not recompute this part, but compute accumulated lines
	         */
	        if (accumulate != 0) {
	          quantize_lines_xrpow(accumulate, istep, acc_xp, acc_xpPos, acc_iData, acc_iDataPos);
	          accumulate = 0;
	        }
	        if (accumulate01 != 0) {
	          quantize_lines_xrpow_01(accumulate01, istep, acc_xp, acc_xpPos, acc_iData, acc_iDataPos);
	          accumulate01 = 0;
	        }
	      } else {
	        /* should compute this part */
	        var l = codInfo.width[sfb];
	        if (j + codInfo.width[sfb] > codInfo.max_nonzero_coeff) {
	          /* do not compute upper zero part */
	          var usefullsize;
	          usefullsize = codInfo.max_nonzero_coeff - j + 1;
	          Arrays.fill(pi, codInfo.max_nonzero_coeff, 576, 0);
	          l = usefullsize;
	          if (l < 0) {
	            l = 0;
	          }

	          /* no need to compute higher sfb values */
	          sfb = sfbmax + 1;
	        }

	        /* accumulate lines to quantize */
	        if (0 == accumulate && 0 == accumulate01) {
	          acc_iData = iData;
	          acc_iDataPos = iDataPos;
	          acc_xp = xp;
	          acc_xpPos = xpPos;
	        }
	        if (prevNoise != null && prevNoise.sfb_count1 > 0 && sfb >= prevNoise.sfb_count1 && prevNoise.step[sfb] > 0 && step >= prevNoise.step[sfb]) {
	          if (accumulate != 0) {
	            quantize_lines_xrpow(accumulate, istep, acc_xp, acc_xpPos, acc_iData, acc_iDataPos);
	            accumulate = 0;
	            acc_iData = iData;
	            acc_iDataPos = iDataPos;
	            acc_xp = xp;
	            acc_xpPos = xpPos;
	          }
	          accumulate01 += l;
	        } else {
	          if (accumulate01 != 0) {
	            quantize_lines_xrpow_01(accumulate01, istep, acc_xp, acc_xpPos, acc_iData, acc_iDataPos);
	            accumulate01 = 0;
	            acc_iData = iData;
	            acc_iDataPos = iDataPos;
	            acc_xp = xp;
	            acc_xpPos = xpPos;
	          }
	          accumulate += l;
	        }
	        if (l <= 0) {
	          /*
	           * rh: 20040215 may happen due to "prev_data_use"
	           * optimization
	           */
	          if (accumulate01 != 0) {
	            quantize_lines_xrpow_01(accumulate01, istep, acc_xp, acc_xpPos, acc_iData, acc_iDataPos);
	            accumulate01 = 0;
	          }
	          if (accumulate != 0) {
	            quantize_lines_xrpow(accumulate, istep, acc_xp, acc_xpPos, acc_iData, acc_iDataPos);
	            accumulate = 0;
	          }
	          break;
	          /* ends for-loop */
	        }
	      }
	      if (sfb <= sfbmax) {
	        iDataPos += codInfo.width[sfb];
	        xpPos += codInfo.width[sfb];
	        j += codInfo.width[sfb];
	      }
	    }
	    if (accumulate != 0) {
	      /* last data part */
	      quantize_lines_xrpow(accumulate, istep, acc_xp, acc_xpPos, acc_iData, acc_iDataPos);
	      accumulate = 0;
	    }
	    if (accumulate01 != 0) {
	      /* last data part */
	      quantize_lines_xrpow_01(accumulate01, istep, acc_xp, acc_xpPos, acc_iData, acc_iDataPos);
	      accumulate01 = 0;
	    }
	  }

	  /**
	   * ix_max
	   */
	  function ix_max(ix, ixPos, endPos) {
	    var max1 = 0,
	      max2 = 0;
	    do {
	      var x1 = ix[ixPos++];
	      var x2 = ix[ixPos++];
	      if (max1 < x1) max1 = x1;
	      if (max2 < x2) max2 = x2;
	    } while (ixPos < endPos);
	    if (max1 < max2) max1 = max2;
	    return max1;
	  }
	  function count_bit_ESC(ix, ixPos, end, t1, t2, s) {
	    /* ESC-table is used */
	    var linbits = Tables.ht[t1].xlen * 65536 + Tables.ht[t2].xlen;
	    var sum = 0,
	      sum2;
	    do {
	      var x = ix[ixPos++];
	      var y = ix[ixPos++];
	      if (x != 0) {
	        if (x > 14) {
	          x = 15;
	          sum += linbits;
	        }
	        x *= 16;
	      }
	      if (y != 0) {
	        if (y > 14) {
	          y = 15;
	          sum += linbits;
	        }
	        x += y;
	      }
	      sum += Tables.largetbl[x];
	    } while (ixPos < end);
	    sum2 = sum & 0xffff;
	    sum >>= 16;
	    if (sum > sum2) {
	      sum = sum2;
	      t1 = t2;
	    }
	    s.bits += sum;
	    return t1;
	  }
	  function count_bit_noESC(ix, ixPos, end, s) {
	    /* No ESC-words */
	    var sum1 = 0;
	    var hlen1 = Tables.ht[1].hlen;
	    do {
	      var x = ix[ixPos + 0] * 2 + ix[ixPos + 1];
	      ixPos += 2;
	      sum1 += hlen1[x];
	    } while (ixPos < end);
	    s.bits += sum1;
	    return 1;
	  }
	  function count_bit_noESC_from2(ix, ixPos, end, t1, s) {
	    /* No ESC-words */
	    var sum = 0,
	      sum2;
	    var xlen = Tables.ht[t1].xlen;
	    var hlen;
	    if (t1 == 2) hlen = Tables.table23;else hlen = Tables.table56;
	    do {
	      var x = ix[ixPos + 0] * xlen + ix[ixPos + 1];
	      ixPos += 2;
	      sum += hlen[x];
	    } while (ixPos < end);
	    sum2 = sum & 0xffff;
	    sum >>= 16;
	    if (sum > sum2) {
	      sum = sum2;
	      t1++;
	    }
	    s.bits += sum;
	    return t1;
	  }
	  function count_bit_noESC_from3(ix, ixPos, end, t1, s) {
	    /* No ESC-words */
	    var sum1 = 0;
	    var sum2 = 0;
	    var sum3 = 0;
	    var xlen = Tables.ht[t1].xlen;
	    var hlen1 = Tables.ht[t1].hlen;
	    var hlen2 = Tables.ht[t1 + 1].hlen;
	    var hlen3 = Tables.ht[t1 + 2].hlen;
	    do {
	      var x = ix[ixPos + 0] * xlen + ix[ixPos + 1];
	      ixPos += 2;
	      sum1 += hlen1[x];
	      sum2 += hlen2[x];
	      sum3 += hlen3[x];
	    } while (ixPos < end);
	    var t = t1;
	    if (sum1 > sum2) {
	      sum1 = sum2;
	      t++;
	    }
	    if (sum1 > sum3) {
	      sum1 = sum3;
	      t = t1 + 2;
	    }
	    s.bits += sum1;
	    return t;
	  }

	  /*************************************************************************/
	  /* choose table */
	  /*************************************************************************/

	  var huf_tbl_noESC = [1, 2, 5, 7, 7, 10, 10, 13, 13, 13, 13, 13, 13, 13, 13];

	  /**
	   * Choose the Huffman table that will encode ix[begin..end] with the fewest
	   * bits.
	   *
	   * Note: This code contains knowledge about the sizes and characteristics of
	   * the Huffman tables as defined in the IS (Table B.7), and will not work
	   * with any arbitrary tables.
	   */
	  function choose_table(ix, ixPos, endPos, s) {
	    var max = ix_max(ix, ixPos, endPos);
	    switch (max) {
	      case 0:
	        return max;
	      case 1:
	        return count_bit_noESC(ix, ixPos, endPos, s);
	      case 2:
	      case 3:
	        return count_bit_noESC_from2(ix, ixPos, endPos, huf_tbl_noESC[max - 1], s);
	      case 4:
	      case 5:
	      case 6:
	      case 7:
	      case 8:
	      case 9:
	      case 10:
	      case 11:
	      case 12:
	      case 13:
	      case 14:
	      case 15:
	        return count_bit_noESC_from3(ix, ixPos, endPos, huf_tbl_noESC[max - 1], s);
	      default:
	        /* try tables with linbits */
	        if (max > QuantizePVT.IXMAX_VAL) {
	          s.bits = QuantizePVT.LARGE_BITS;
	          return -1;
	        }
	        max -= 15;
	        var choice2;
	        for (choice2 = 24; choice2 < 32; choice2++) {
	          if (Tables.ht[choice2].linmax >= max) {
	            break;
	          }
	        }
	        var choice;
	        for (choice = choice2 - 8; choice < 24; choice++) {
	          if (Tables.ht[choice].linmax >= max) {
	            break;
	          }
	        }
	        return count_bit_ESC(ix, ixPos, endPos, choice, choice2, s);
	    }
	  }

	  /**
	   * count_bit
	   */
	  this.noquant_count_bits = function (gfc, gi, prev_noise) {
	    var ix = gi.l3_enc;
	    var i = Math.min(576, gi.max_nonzero_coeff + 2 >> 1 << 1);
	    if (prev_noise != null) prev_noise.sfb_count1 = 0;

	    /* Determine count1 region */
	    for (; i > 1; i -= 2) if ((ix[i - 1] | ix[i - 2]) != 0) break;
	    gi.count1 = i;

	    /* Determines the number of bits to encode the quadruples. */
	    var a1 = 0;
	    var a2 = 0;
	    for (; i > 3; i -= 4) {
	      var p;
	      /* hack to check if all values <= 1 */
	      //throw "TODO: HACK         if ((((long) ix[i - 1] | (long) ix[i - 2] | (long) ix[i - 3] | (long) ix[i - 4]) & 0xffffffffL) > 1L        "
	      //if (true) {
	      if (((ix[i - 1] | ix[i - 2] | ix[i - 3] | ix[i - 4]) & 0x7fffffff) > 1) {
	        break;
	      }
	      p = ((ix[i - 4] * 2 + ix[i - 3]) * 2 + ix[i - 2]) * 2 + ix[i - 1];
	      a1 += Tables.t32l[p];
	      a2 += Tables.t33l[p];
	    }
	    var bits = a1;
	    gi.count1table_select = 0;
	    if (a1 > a2) {
	      bits = a2;
	      gi.count1table_select = 1;
	    }
	    gi.count1bits = bits;
	    gi.big_values = i;
	    if (i == 0) return bits;
	    if (gi.block_type == Encoder.SHORT_TYPE) {
	      a1 = 3 * gfc.scalefac_band.s[3];
	      if (a1 > gi.big_values) a1 = gi.big_values;
	      a2 = gi.big_values;
	    } else if (gi.block_type == Encoder.NORM_TYPE) {
	      /* bv_scf has 576 entries (0..575) */
	      a1 = gi.region0_count = gfc.bv_scf[i - 2];
	      a2 = gi.region1_count = gfc.bv_scf[i - 1];
	      assert(a1 + a2 + 2 < Encoder.SBPSY_l);
	      a2 = gfc.scalefac_band.l[a1 + a2 + 2];
	      a1 = gfc.scalefac_band.l[a1 + 1];
	      if (a2 < i) {
	        var bi = new Bits(bits);
	        gi.table_select[2] = choose_table(ix, a2, i, bi);
	        bits = bi.bits;
	      }
	    } else {
	      gi.region0_count = 7;
	      /* gi.region1_count = SBPSY_l - 7 - 1; */
	      gi.region1_count = Encoder.SBMAX_l - 1 - 7 - 1;
	      a1 = gfc.scalefac_band.l[7 + 1];
	      a2 = i;
	      if (a1 > a2) {
	        a1 = a2;
	      }
	    }

	    /* have to allow for the case when bigvalues < region0 < region1 */
	    /* (and region0, region1 are ignored) */
	    a1 = Math.min(a1, i);
	    a2 = Math.min(a2, i);

	    /* Count the number of bits necessary to code the bigvalues region. */
	    if (0 < a1) {
	      var bi = new Bits(bits);
	      gi.table_select[0] = choose_table(ix, 0, a1, bi);
	      bits = bi.bits;
	    }
	    if (a1 < a2) {
	      var bi = new Bits(bits);
	      gi.table_select[1] = choose_table(ix, a1, a2, bi);
	      bits = bi.bits;
	    }
	    if (gfc.use_best_huffman == 2) {
	      gi.part2_3_length = bits;
	      best_huffman_divide(gfc, gi);
	      bits = gi.part2_3_length;
	    }
	    if (prev_noise != null) {
	      if (gi.block_type == Encoder.NORM_TYPE) {
	        var sfb = 0;
	        while (gfc.scalefac_band.l[sfb] < gi.big_values) {
	          sfb++;
	        }
	        prev_noise.sfb_count1 = sfb;
	      }
	    }
	    return bits;
	  };
	  this.count_bits = function (gfc, xr, gi, prev_noise) {
	    var ix = gi.l3_enc;

	    /* since quantize_xrpow uses table lookup, we need to check this first: */
	    var w = QuantizePVT.IXMAX_VAL / qupvt.IPOW20(gi.global_gain);
	    if (gi.xrpow_max > w) return QuantizePVT.LARGE_BITS;
	    quantize_xrpow(xr, ix, qupvt.IPOW20(gi.global_gain), gi, prev_noise);
	    if ((gfc.substep_shaping & 2) != 0) {
	      var j = 0;
	      /* 0.634521682242439 = 0.5946*2**(.5*0.1875) */
	      var gain = gi.global_gain + gi.scalefac_scale;
	      var roundfac = 0.634521682242439 / qupvt.IPOW20(gain);
	      for (var sfb = 0; sfb < gi.sfbmax; sfb++) {
	        var width = gi.width[sfb];
	        if (0 == gfc.pseudohalf[sfb]) {
	          j += width;
	        } else {
	          var k;
	          for (k = j, j += width; k < j; ++k) {
	            ix[k] = xr[k] >= roundfac ? ix[k] : 0;
	          }
	        }
	      }
	    }
	    return this.noquant_count_bits(gfc, gi, prev_noise);
	  };

	  /**
	   * re-calculate the best scalefac_compress using scfsi the saved bits are
	   * kept in the bit reservoir.
	   */
	  function recalc_divide_init(gfc, cod_info, ix, r01_bits, r01_div, r0_tbl, r1_tbl) {
	    var bigv = cod_info.big_values;
	    for (var r0 = 0; r0 <= 7 + 15; r0++) {
	      r01_bits[r0] = QuantizePVT.LARGE_BITS;
	    }
	    for (var r0 = 0; r0 < 16; r0++) {
	      var a1 = gfc.scalefac_band.l[r0 + 1];
	      if (a1 >= bigv) break;
	      var r0bits = 0;
	      var bi = new Bits(r0bits);
	      var r0t = choose_table(ix, 0, a1, bi);
	      r0bits = bi.bits;
	      for (var r1 = 0; r1 < 8; r1++) {
	        var a2 = gfc.scalefac_band.l[r0 + r1 + 2];
	        if (a2 >= bigv) break;
	        var bits = r0bits;
	        bi = new Bits(bits);
	        var r1t = choose_table(ix, a1, a2, bi);
	        bits = bi.bits;
	        if (r01_bits[r0 + r1] > bits) {
	          r01_bits[r0 + r1] = bits;
	          r01_div[r0 + r1] = r0;
	          r0_tbl[r0 + r1] = r0t;
	          r1_tbl[r0 + r1] = r1t;
	        }
	      }
	    }
	  }
	  function recalc_divide_sub(gfc, cod_info2, gi, ix, r01_bits, r01_div, r0_tbl, r1_tbl) {
	    var bigv = cod_info2.big_values;
	    for (var r2 = 2; r2 < Encoder.SBMAX_l + 1; r2++) {
	      var a2 = gfc.scalefac_band.l[r2];
	      if (a2 >= bigv) break;
	      var bits = r01_bits[r2 - 2] + cod_info2.count1bits;
	      if (gi.part2_3_length <= bits) break;
	      var bi = new Bits(bits);
	      var r2t = choose_table(ix, a2, bigv, bi);
	      bits = bi.bits;
	      if (gi.part2_3_length <= bits) continue;
	      gi.assign(cod_info2);
	      gi.part2_3_length = bits;
	      gi.region0_count = r01_div[r2 - 2];
	      gi.region1_count = r2 - 2 - r01_div[r2 - 2];
	      gi.table_select[0] = r0_tbl[r2 - 2];
	      gi.table_select[1] = r1_tbl[r2 - 2];
	      gi.table_select[2] = r2t;
	    }
	  }
	  this.best_huffman_divide = function (gfc, gi) {
	    var cod_info2 = new GrInfo();
	    var ix = gi.l3_enc;
	    var r01_bits = new_int(7 + 15 + 1);
	    var r01_div = new_int(7 + 15 + 1);
	    var r0_tbl = new_int(7 + 15 + 1);
	    var r1_tbl = new_int(7 + 15 + 1);

	    /* SHORT BLOCK stuff fails for MPEG2 */
	    if (gi.block_type == Encoder.SHORT_TYPE && gfc.mode_gr == 1) return;
	    cod_info2.assign(gi);
	    if (gi.block_type == Encoder.NORM_TYPE) {
	      recalc_divide_init(gfc, gi, ix, r01_bits, r01_div, r0_tbl, r1_tbl);
	      recalc_divide_sub(gfc, cod_info2, gi, ix, r01_bits, r01_div, r0_tbl, r1_tbl);
	    }
	    var i = cod_info2.big_values;
	    if (i == 0 || (ix[i - 2] | ix[i - 1]) > 1) return;
	    i = gi.count1 + 2;
	    if (i > 576) return;

	    /* Determines the number of bits to encode the quadruples. */
	    cod_info2.assign(gi);
	    cod_info2.count1 = i;
	    var a1 = 0;
	    var a2 = 0;
	    for (; i > cod_info2.big_values; i -= 4) {
	      var p = ((ix[i - 4] * 2 + ix[i - 3]) * 2 + ix[i - 2]) * 2 + ix[i - 1];
	      a1 += Tables.t32l[p];
	      a2 += Tables.t33l[p];
	    }
	    cod_info2.big_values = i;
	    cod_info2.count1table_select = 0;
	    if (a1 > a2) {
	      a1 = a2;
	      cod_info2.count1table_select = 1;
	    }
	    cod_info2.count1bits = a1;
	    if (cod_info2.block_type == Encoder.NORM_TYPE) recalc_divide_sub(gfc, cod_info2, gi, ix, r01_bits, r01_div, r0_tbl, r1_tbl);else {
	      /* Count the number of bits necessary to code the bigvalues region. */
	      cod_info2.part2_3_length = a1;
	      a1 = gfc.scalefac_band.l[7 + 1];
	      if (a1 > i) {
	        a1 = i;
	      }
	      if (a1 > 0) {
	        var bi = new Bits(cod_info2.part2_3_length);
	        cod_info2.table_select[0] = choose_table(ix, 0, a1, bi);
	        cod_info2.part2_3_length = bi.bits;
	      }
	      if (i > a1) {
	        var bi = new Bits(cod_info2.part2_3_length);
	        cod_info2.table_select[1] = choose_table(ix, a1, i, bi);
	        cod_info2.part2_3_length = bi.bits;
	      }
	      if (gi.part2_3_length > cod_info2.part2_3_length) gi.assign(cod_info2);
	    }
	  };
	  var slen1_n = [1, 1, 1, 1, 8, 2, 2, 2, 4, 4, 4, 8, 8, 8, 16, 16];
	  var slen2_n = [1, 2, 4, 8, 1, 2, 4, 8, 2, 4, 8, 2, 4, 8, 4, 8];
	  var slen1_tab = [0, 0, 0, 0, 3, 1, 1, 1, 2, 2, 2, 3, 3, 3, 4, 4];
	  var slen2_tab = [0, 1, 2, 3, 0, 1, 2, 3, 1, 2, 3, 1, 2, 3, 2, 3];
	  Takehiro.slen1_tab = slen1_tab;
	  Takehiro.slen2_tab = slen2_tab;
	  function scfsi_calc(ch, l3_side) {
	    var sfb;
	    var gi = l3_side.tt[1][ch];
	    var g0 = l3_side.tt[0][ch];
	    for (var i = 0; i < Tables.scfsi_band.length - 1; i++) {
	      for (sfb = Tables.scfsi_band[i]; sfb < Tables.scfsi_band[i + 1]; sfb++) {
	        if (g0.scalefac[sfb] != gi.scalefac[sfb] && gi.scalefac[sfb] >= 0) break;
	      }
	      if (sfb == Tables.scfsi_band[i + 1]) {
	        for (sfb = Tables.scfsi_band[i]; sfb < Tables.scfsi_band[i + 1]; sfb++) {
	          gi.scalefac[sfb] = -1;
	        }
	        l3_side.scfsi[ch][i] = 1;
	      }
	    }
	    var s1 = 0;
	    var c1 = 0;
	    for (sfb = 0; sfb < 11; sfb++) {
	      if (gi.scalefac[sfb] == -1) continue;
	      c1++;
	      if (s1 < gi.scalefac[sfb]) s1 = gi.scalefac[sfb];
	    }
	    var s2 = 0;
	    var c2 = 0;
	    for (; sfb < Encoder.SBPSY_l; sfb++) {
	      if (gi.scalefac[sfb] == -1) continue;
	      c2++;
	      if (s2 < gi.scalefac[sfb]) s2 = gi.scalefac[sfb];
	    }
	    for (var i = 0; i < 16; i++) {
	      if (s1 < slen1_n[i] && s2 < slen2_n[i]) {
	        var c = slen1_tab[i] * c1 + slen2_tab[i] * c2;
	        if (gi.part2_length > c) {
	          gi.part2_length = c;
	          gi.scalefac_compress = i;
	        }
	      }
	    }
	  }

	  /**
	   * Find the optimal way to store the scalefactors. Only call this routine
	   * after final scalefactors have been chosen and the channel/granule will
	   * not be re-encoded.
	   */
	  this.best_scalefac_store = function (gfc, gr, ch, l3_side) {
	    /* use scalefac_scale if we can */
	    var gi = l3_side.tt[gr][ch];
	    var sfb, i, j, l;
	    var recalc = 0;

	    /*
	     * remove scalefacs from bands with ix=0. This idea comes from the AAC
	     * ISO docs. added mt 3/00
	     */
	    /* check if l3_enc=0 */
	    j = 0;
	    for (sfb = 0; sfb < gi.sfbmax; sfb++) {
	      var width = gi.width[sfb];
	      j += width;
	      for (l = -width; l < 0; l++) {
	        if (gi.l3_enc[l + j] != 0) break;
	      }
	      if (l == 0) gi.scalefac[sfb] = recalc = -2;
	      /* anything goes. */
	      /*
	       * only best_scalefac_store and calc_scfsi know--and only they
	       * should know--about the magic number -2.
	       */
	    }
	    if (0 == gi.scalefac_scale && 0 == gi.preflag) {
	      var s = 0;
	      for (sfb = 0; sfb < gi.sfbmax; sfb++) if (gi.scalefac[sfb] > 0) s |= gi.scalefac[sfb];
	      if (0 == (s & 1) && s != 0) {
	        for (sfb = 0; sfb < gi.sfbmax; sfb++) if (gi.scalefac[sfb] > 0) gi.scalefac[sfb] >>= 1;
	        gi.scalefac_scale = recalc = 1;
	      }
	    }
	    if (0 == gi.preflag && gi.block_type != Encoder.SHORT_TYPE && gfc.mode_gr == 2) {
	      for (sfb = 11; sfb < Encoder.SBPSY_l; sfb++) if (gi.scalefac[sfb] < qupvt.pretab[sfb] && gi.scalefac[sfb] != -2) break;
	      if (sfb == Encoder.SBPSY_l) {
	        for (sfb = 11; sfb < Encoder.SBPSY_l; sfb++) if (gi.scalefac[sfb] > 0) gi.scalefac[sfb] -= qupvt.pretab[sfb];
	        gi.preflag = recalc = 1;
	      }
	    }
	    for (i = 0; i < 4; i++) l3_side.scfsi[ch][i] = 0;
	    if (gfc.mode_gr == 2 && gr == 1 && l3_side.tt[0][ch].block_type != Encoder.SHORT_TYPE && l3_side.tt[1][ch].block_type != Encoder.SHORT_TYPE) {
	      scfsi_calc(ch, l3_side);
	      recalc = 0;
	    }
	    for (sfb = 0; sfb < gi.sfbmax; sfb++) {
	      if (gi.scalefac[sfb] == -2) {
	        gi.scalefac[sfb] = 0;
	        /* if anything goes, then 0 is a good choice */
	      }
	    }
	    if (recalc != 0) {
	      if (gfc.mode_gr == 2) {
	        this.scale_bitcount(gi);
	      } else {
	        this.scale_bitcount_lsf(gfc, gi);
	      }
	    }
	  };
	  function all_scalefactors_not_negative(scalefac, n) {
	    for (var i = 0; i < n; ++i) {
	      if (scalefac[i] < 0) return false;
	    }
	    return true;
	  }

	  /**
	   * number of bits used to encode scalefacs.
	   *
	   * 18*slen1_tab[i] + 18*slen2_tab[i]
	   */
	  var scale_short = [0, 18, 36, 54, 54, 36, 54, 72, 54, 72, 90, 72, 90, 108, 108, 126];

	  /**
	   * number of bits used to encode scalefacs.
	   *
	   * 17*slen1_tab[i] + 18*slen2_tab[i]
	   */
	  var scale_mixed = [0, 18, 36, 54, 51, 35, 53, 71, 52, 70, 88, 69, 87, 105, 104, 122];

	  /**
	   * number of bits used to encode scalefacs.
	   *
	   * 11*slen1_tab[i] + 10*slen2_tab[i]
	   */
	  var scale_long = [0, 10, 20, 30, 33, 21, 31, 41, 32, 42, 52, 43, 53, 63, 64, 74];

	  /**
	   * Also calculates the number of bits necessary to code the scalefactors.
	   */
	  this.scale_bitcount = function (cod_info) {
	    var k,
	      sfb,
	      max_slen1 = 0,
	      max_slen2 = 0;

	    /* maximum values */
	    var tab;
	    var scalefac = cod_info.scalefac;
	    assert(all_scalefactors_not_negative(scalefac, cod_info.sfbmax));
	    if (cod_info.block_type == Encoder.SHORT_TYPE) {
	      tab = scale_short;
	      if (cod_info.mixed_block_flag != 0) tab = scale_mixed;
	    } else {
	      /* block_type == 1,2,or 3 */
	      tab = scale_long;
	      if (0 == cod_info.preflag) {
	        for (sfb = 11; sfb < Encoder.SBPSY_l; sfb++) if (scalefac[sfb] < qupvt.pretab[sfb]) break;
	        if (sfb == Encoder.SBPSY_l) {
	          cod_info.preflag = 1;
	          for (sfb = 11; sfb < Encoder.SBPSY_l; sfb++) scalefac[sfb] -= qupvt.pretab[sfb];
	        }
	      }
	    }
	    for (sfb = 0; sfb < cod_info.sfbdivide; sfb++) if (max_slen1 < scalefac[sfb]) max_slen1 = scalefac[sfb];
	    for (; sfb < cod_info.sfbmax; sfb++) if (max_slen2 < scalefac[sfb]) max_slen2 = scalefac[sfb];

	    /*
	     * from Takehiro TOMINAGA <tominaga@isoternet.org> 10/99 loop over *all*
	     * posible values of scalefac_compress to find the one which uses the
	     * smallest number of bits. ISO would stop at first valid index
	     */
	    cod_info.part2_length = QuantizePVT.LARGE_BITS;
	    for (k = 0; k < 16; k++) {
	      if (max_slen1 < slen1_n[k] && max_slen2 < slen2_n[k] && cod_info.part2_length > tab[k]) {
	        cod_info.part2_length = tab[k];
	        cod_info.scalefac_compress = k;
	      }
	    }
	    return cod_info.part2_length == QuantizePVT.LARGE_BITS;
	  };

	  /**
	   * table of largest scalefactor values for MPEG2
	   */
	  var max_range_sfac_tab = [[15, 15, 7, 7], [15, 15, 7, 0], [7, 3, 0, 0], [15, 31, 31, 0], [7, 7, 7, 0], [3, 3, 0, 0]];

	  /**
	   * Also counts the number of bits to encode the scalefacs but for MPEG 2
	   * Lower sampling frequencies (24, 22.05 and 16 kHz.)
	   *
	   * This is reverse-engineered from section 2.4.3.2 of the MPEG2 IS,
	   * "Audio Decoding Layer III"
	   */
	  this.scale_bitcount_lsf = function (gfc, cod_info) {
	    var table_number, row_in_table, partition, nr_sfb, window;
	    var over;
	    var i, sfb;
	    var max_sfac = new_int(4);
	    //var partition_table;
	    var scalefac = cod_info.scalefac;

	    /*
	     * Set partition table. Note that should try to use table one, but do
	     * not yet...
	     */
	    if (cod_info.preflag != 0) table_number = 2;else table_number = 0;
	    for (i = 0; i < 4; i++) max_sfac[i] = 0;
	    if (cod_info.block_type == Encoder.SHORT_TYPE) {
	      row_in_table = 1;
	      var partition_table = qupvt.nr_of_sfb_block[table_number][row_in_table];
	      for (sfb = 0, partition = 0; partition < 4; partition++) {
	        nr_sfb = partition_table[partition] / 3;
	        for (i = 0; i < nr_sfb; i++, sfb++) for (window = 0; window < 3; window++) if (scalefac[sfb * 3 + window] > max_sfac[partition]) max_sfac[partition] = scalefac[sfb * 3 + window];
	      }
	    } else {
	      row_in_table = 0;
	      var partition_table = qupvt.nr_of_sfb_block[table_number][row_in_table];
	      for (sfb = 0, partition = 0; partition < 4; partition++) {
	        nr_sfb = partition_table[partition];
	        for (i = 0; i < nr_sfb; i++, sfb++) if (scalefac[sfb] > max_sfac[partition]) max_sfac[partition] = scalefac[sfb];
	      }
	    }
	    for (over = false, partition = 0; partition < 4; partition++) {
	      if (max_sfac[partition] > max_range_sfac_tab[table_number][partition]) over = true;
	    }
	    if (!over) {
	      var slen1, slen2, slen3, slen4;
	      cod_info.sfb_partition_table = qupvt.nr_of_sfb_block[table_number][row_in_table];
	      for (partition = 0; partition < 4; partition++) cod_info.slen[partition] = log2tab[max_sfac[partition]];

	      /* set scalefac_compress */
	      slen1 = cod_info.slen[0];
	      slen2 = cod_info.slen[1];
	      slen3 = cod_info.slen[2];
	      slen4 = cod_info.slen[3];
	      switch (table_number) {
	        case 0:
	          cod_info.scalefac_compress = (slen1 * 5 + slen2 << 4) + (slen3 << 2) + slen4;
	          break;
	        case 1:
	          cod_info.scalefac_compress = 400 + (slen1 * 5 + slen2 << 2) + slen3;
	          break;
	        case 2:
	          cod_info.scalefac_compress = 500 + slen1 * 3 + slen2;
	          break;
	        default:
	          System.err.printf("intensity stereo not implemented yet\n");
	          break;
	      }
	    }
	    if (!over) {
	      assert(cod_info.sfb_partition_table != null);
	      cod_info.part2_length = 0;
	      for (partition = 0; partition < 4; partition++) cod_info.part2_length += cod_info.slen[partition] * cod_info.sfb_partition_table[partition];
	    }
	    return over;
	  };

	  /*
	   * Since no bands have been over-amplified, we can set scalefac_compress and
	   * slen[] for the formatter
	   */
	  var log2tab = [0, 1, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 4, 4, 4, 4];
	  this.huffman_init = function (gfc) {
	    for (var i = 2; i <= 576; i += 2) {
	      var scfb_anz = 0,
	        bv_index;
	      while (gfc.scalefac_band.l[++scfb_anz] < i);
	      bv_index = subdv_table[scfb_anz][0]; // .region0_count
	      while (gfc.scalefac_band.l[bv_index + 1] > i) bv_index--;
	      if (bv_index < 0) {
	        /*
	         * this is an indication that everything is going to be encoded
	         * as region0: bigvalues < region0 < region1 so lets set
	         * region0, region1 to some value larger than bigvalues
	         */
	        bv_index = subdv_table[scfb_anz][0]; // .region0_count
	      }
	      gfc.bv_scf[i - 2] = bv_index;
	      bv_index = subdv_table[scfb_anz][1]; // .region1_count
	      while (gfc.scalefac_band.l[bv_index + gfc.bv_scf[i - 2] + 2] > i) bv_index--;
	      if (bv_index < 0) {
	        bv_index = subdv_table[scfb_anz][1]; // .region1_count
	      }
	      gfc.bv_scf[i - 1] = bv_index;
	    }
	  };
	}
	Takehiro_1 = Takehiro;
	return Takehiro_1;
}

var BitStream_1;
var hasRequiredBitStream;

function requireBitStream () {
	if (hasRequiredBitStream) return BitStream_1;
	hasRequiredBitStream = 1;
	var common = common$b;
	var System = common.System;
	var Arrays = common.Arrays;
	var new_byte = common.new_byte;
	var new_float_n = common.new_float_n;
	var new_int = common.new_int;
	var assert = common.assert;
	var Takehiro = requireTakehiro();
	var Tables = Tables_1;
	var Encoder = requireEncoder();
	var LameInternalFlags = LameInternalFlags_1;
	BitStream.EQ = function (a, b) {
	  return Math.abs(a) > Math.abs(b) ? Math.abs(a - b) <= Math.abs(a) * 1e-6 : Math.abs(a - b) <= Math.abs(b) * 1e-6;
	};
	BitStream.NEQ = function (a, b) {
	  return !BitStream.EQ(a, b);
	};
	function BitStream() {
	  var Lame = requireLame();
	  var self = this;
	  var CRC16_POLYNOMIAL = 0x8005;

	  //GainAnalysis ga;
	  //MPGLib mpg;
	  //Version ver;
	  //VBRTag vbr;
	  var ga = null;
	  var mpg = null;
	  var ver = null;
	  var vbr = null;

	  //public final void setModules(GainAnalysis ga, MPGLib mpg, Version ver,
	  //	VBRTag vbr) {

	  this.setModules = function (_ga, _mpg, _ver, _vbr) {
	    ga = _ga;
	    mpg = _mpg;
	    ver = _ver;
	    vbr = _vbr;
	  };

	  /**
	   * Bit stream buffer.
	   */
	  //private byte[] buf;
	  var buf = null;
	  /**
	   * Bit counter of bit stream.
	   */
	  var totbit = 0;
	  /**
	   * Pointer to top byte in buffer.
	   */
	  var bufByteIdx = 0;
	  /**
	   * Pointer to top bit of top byte in buffer.
	   */
	  var bufBitIdx = 0;

	  /**
	   * compute bitsperframe and mean_bits for a layer III frame
	   */
	  this.getframebits = function (gfp) {
	    var gfc = gfp.internal_flags;
	    var bit_rate;

	    /* get bitrate in kbps [?] */
	    if (gfc.bitrate_index != 0) bit_rate = Tables.bitrate_table[gfp.version][gfc.bitrate_index];else bit_rate = gfp.brate;

	    /* main encoding routine toggles padding on and off */
	    /* one Layer3 Slot consists of 8 bits */
	    var bytes = 0 | (gfp.version + 1) * 72000 * bit_rate / gfp.out_samplerate + gfc.padding;
	    return 8 * bytes;
	  };
	  function putheader_bits(gfc) {
	    System.arraycopy(gfc.header[gfc.w_ptr].buf, 0, buf, bufByteIdx, gfc.sideinfo_len);
	    bufByteIdx += gfc.sideinfo_len;
	    totbit += gfc.sideinfo_len * 8;
	    gfc.w_ptr = gfc.w_ptr + 1 & LameInternalFlags.MAX_HEADER_BUF - 1;
	  }

	  /**
	   * write j bits into the bit stream
	   */
	  function putbits2(gfc, val, j) {
	    while (j > 0) {
	      var k;
	      if (bufBitIdx == 0) {
	        bufBitIdx = 8;
	        bufByteIdx++;
	        assert(bufByteIdx < Lame.LAME_MAXMP3BUFFER);
	        assert(gfc.header[gfc.w_ptr].write_timing >= totbit);
	        if (gfc.header[gfc.w_ptr].write_timing == totbit) {
	          putheader_bits(gfc);
	        }
	        buf[bufByteIdx] = 0;
	      }
	      k = Math.min(j, bufBitIdx);
	      j -= k;
	      bufBitIdx -= k;
	      buf[bufByteIdx] |= val >> j << bufBitIdx;
	      totbit += k;
	    }
	  }

	  /**
	   * write j bits into the bit stream, ignoring frame headers
	   */
	  function putbits_noheaders(gfc, val, j) {
	    while (j > 0) {
	      var k;
	      if (bufBitIdx == 0) {
	        bufBitIdx = 8;
	        bufByteIdx++;
	        assert(bufByteIdx < Lame.LAME_MAXMP3BUFFER);
	        buf[bufByteIdx] = 0;
	      }
	      k = Math.min(j, bufBitIdx);
	      j -= k;
	      bufBitIdx -= k;
	      buf[bufByteIdx] |= val >> j << bufBitIdx;
	      totbit += k;
	    }
	  }

	  /**
	   * Some combinations of bitrate, Fs, and stereo make it impossible to stuff
	   * out a frame using just main_data, due to the limited number of bits to
	   * indicate main_data_length. In these situations, we put stuffing bits into
	   * the ancillary data...
	   */
	  function drain_into_ancillary(gfp, remainingBits) {
	    var gfc = gfp.internal_flags;
	    var i;
	    if (remainingBits >= 8) {
	      putbits2(gfc, 0x4c, 8);
	      remainingBits -= 8;
	    }
	    if (remainingBits >= 8) {
	      putbits2(gfc, 0x41, 8);
	      remainingBits -= 8;
	    }
	    if (remainingBits >= 8) {
	      putbits2(gfc, 0x4d, 8);
	      remainingBits -= 8;
	    }
	    if (remainingBits >= 8) {
	      putbits2(gfc, 0x45, 8);
	      remainingBits -= 8;
	    }
	    if (remainingBits >= 32) {
	      var version = ver.getLameShortVersion();
	      if (remainingBits >= 32) for (i = 0; i < version.length && remainingBits >= 8; ++i) {
	        remainingBits -= 8;
	        putbits2(gfc, version.charAt(i), 8);
	      }
	    }
	    for (; remainingBits >= 1; remainingBits -= 1) {
	      putbits2(gfc, gfc.ancillary_flag, 1);
	      gfc.ancillary_flag ^= !gfp.disable_reservoir ? 1 : 0;
	    }
	  }

	  /**
	   * write N bits into the header
	   */
	  function writeheader(gfc, val, j) {
	    var ptr = gfc.header[gfc.h_ptr].ptr;
	    while (j > 0) {
	      var k = Math.min(j, 8 - (ptr & 7));
	      j -= k;
	      /* >> 32 too large for 32 bit machines */

	      gfc.header[gfc.h_ptr].buf[ptr >> 3] |= val >> j << 8 - (ptr & 7) - k;
	      ptr += k;
	    }
	    gfc.header[gfc.h_ptr].ptr = ptr;
	  }
	  function CRC_update(value, crc) {
	    value <<= 8;
	    for (var i = 0; i < 8; i++) {
	      value <<= 1;
	      crc <<= 1;
	      if (((crc ^ value) & 0x10000) != 0) crc ^= CRC16_POLYNOMIAL;
	    }
	    return crc;
	  }
	  this.CRC_writeheader = function (gfc, header) {
	    var crc = 0xffff;
	    /* (jo) init crc16 for error_protection */

	    crc = CRC_update(header[2] & 0xff, crc);
	    crc = CRC_update(header[3] & 0xff, crc);
	    for (var i = 6; i < gfc.sideinfo_len; i++) {
	      crc = CRC_update(header[i] & 0xff, crc);
	    }
	    header[4] = byte(crc >> 8);
	    header[5] = byte(crc & 255);
	  };
	  function encodeSideInfo2(gfp, bitsPerFrame) {
	    var gfc = gfp.internal_flags;
	    var l3_side;
	    var gr, ch;
	    l3_side = gfc.l3_side;
	    gfc.header[gfc.h_ptr].ptr = 0;
	    Arrays.fill(gfc.header[gfc.h_ptr].buf, 0, gfc.sideinfo_len, 0);
	    if (gfp.out_samplerate < 16000) writeheader(gfc, 0xffe, 12);else writeheader(gfc, 0xfff, 12);
	    writeheader(gfc, gfp.version, 1);
	    writeheader(gfc, 4 - 3, 2);
	    writeheader(gfc, !gfp.error_protection ? 1 : 0, 1);
	    writeheader(gfc, gfc.bitrate_index, 4);
	    writeheader(gfc, gfc.samplerate_index, 2);
	    writeheader(gfc, gfc.padding, 1);
	    writeheader(gfc, gfp.extension, 1);
	    writeheader(gfc, gfp.mode.ordinal(), 2);
	    writeheader(gfc, gfc.mode_ext, 2);
	    writeheader(gfc, gfp.copyright, 1);
	    writeheader(gfc, gfp.original, 1);
	    writeheader(gfc, gfp.emphasis, 2);
	    if (gfp.error_protection) {
	      writeheader(gfc, 0, 16);
	      /* dummy */
	    }
	    if (gfp.version == 1) {
	      /* MPEG1 */
	      assert(l3_side.main_data_begin >= 0);
	      writeheader(gfc, l3_side.main_data_begin, 9);
	      if (gfc.channels_out == 2) writeheader(gfc, l3_side.private_bits, 3);else writeheader(gfc, l3_side.private_bits, 5);
	      for (ch = 0; ch < gfc.channels_out; ch++) {
	        var band;
	        for (band = 0; band < 4; band++) {
	          writeheader(gfc, l3_side.scfsi[ch][band], 1);
	        }
	      }
	      for (gr = 0; gr < 2; gr++) {
	        for (ch = 0; ch < gfc.channels_out; ch++) {
	          var gi = l3_side.tt[gr][ch];
	          writeheader(gfc, gi.part2_3_length + gi.part2_length, 12);
	          writeheader(gfc, gi.big_values / 2, 9);
	          writeheader(gfc, gi.global_gain, 8);
	          writeheader(gfc, gi.scalefac_compress, 4);
	          if (gi.block_type != Encoder.NORM_TYPE) {
	            writeheader(gfc, 1, 1);
	            /* window_switching_flag */
	            writeheader(gfc, gi.block_type, 2);
	            writeheader(gfc, gi.mixed_block_flag, 1);
	            if (gi.table_select[0] == 14) gi.table_select[0] = 16;
	            writeheader(gfc, gi.table_select[0], 5);
	            if (gi.table_select[1] == 14) gi.table_select[1] = 16;
	            writeheader(gfc, gi.table_select[1], 5);
	            writeheader(gfc, gi.subblock_gain[0], 3);
	            writeheader(gfc, gi.subblock_gain[1], 3);
	            writeheader(gfc, gi.subblock_gain[2], 3);
	          } else {
	            writeheader(gfc, 0, 1);
	            /* window_switching_flag */
	            if (gi.table_select[0] == 14) gi.table_select[0] = 16;
	            writeheader(gfc, gi.table_select[0], 5);
	            if (gi.table_select[1] == 14) gi.table_select[1] = 16;
	            writeheader(gfc, gi.table_select[1], 5);
	            if (gi.table_select[2] == 14) gi.table_select[2] = 16;
	            writeheader(gfc, gi.table_select[2], 5);
	            assert(0 <= gi.region0_count && gi.region0_count < 16);
	            assert(0 <= gi.region1_count && gi.region1_count < 8);
	            writeheader(gfc, gi.region0_count, 4);
	            writeheader(gfc, gi.region1_count, 3);
	          }
	          writeheader(gfc, gi.preflag, 1);
	          writeheader(gfc, gi.scalefac_scale, 1);
	          writeheader(gfc, gi.count1table_select, 1);
	        }
	      }
	    } else {
	      /* MPEG2 */
	      assert(l3_side.main_data_begin >= 0);
	      writeheader(gfc, l3_side.main_data_begin, 8);
	      writeheader(gfc, l3_side.private_bits, gfc.channels_out);
	      gr = 0;
	      for (ch = 0; ch < gfc.channels_out; ch++) {
	        var gi = l3_side.tt[gr][ch];
	        writeheader(gfc, gi.part2_3_length + gi.part2_length, 12);
	        writeheader(gfc, gi.big_values / 2, 9);
	        writeheader(gfc, gi.global_gain, 8);
	        writeheader(gfc, gi.scalefac_compress, 9);
	        if (gi.block_type != Encoder.NORM_TYPE) {
	          writeheader(gfc, 1, 1);
	          /* window_switching_flag */
	          writeheader(gfc, gi.block_type, 2);
	          writeheader(gfc, gi.mixed_block_flag, 1);
	          if (gi.table_select[0] == 14) gi.table_select[0] = 16;
	          writeheader(gfc, gi.table_select[0], 5);
	          if (gi.table_select[1] == 14) gi.table_select[1] = 16;
	          writeheader(gfc, gi.table_select[1], 5);
	          writeheader(gfc, gi.subblock_gain[0], 3);
	          writeheader(gfc, gi.subblock_gain[1], 3);
	          writeheader(gfc, gi.subblock_gain[2], 3);
	        } else {
	          writeheader(gfc, 0, 1);
	          /* window_switching_flag */
	          if (gi.table_select[0] == 14) gi.table_select[0] = 16;
	          writeheader(gfc, gi.table_select[0], 5);
	          if (gi.table_select[1] == 14) gi.table_select[1] = 16;
	          writeheader(gfc, gi.table_select[1], 5);
	          if (gi.table_select[2] == 14) gi.table_select[2] = 16;
	          writeheader(gfc, gi.table_select[2], 5);
	          assert(0 <= gi.region0_count && gi.region0_count < 16);
	          assert(0 <= gi.region1_count && gi.region1_count < 8);
	          writeheader(gfc, gi.region0_count, 4);
	          writeheader(gfc, gi.region1_count, 3);
	        }
	        writeheader(gfc, gi.scalefac_scale, 1);
	        writeheader(gfc, gi.count1table_select, 1);
	      }
	    }
	    if (gfp.error_protection) {
	      /* (jo) error_protection: add crc16 information to header */
	      CRC_writeheader(gfc, gfc.header[gfc.h_ptr].buf);
	    }
	    {
	      var old = gfc.h_ptr;
	      assert(gfc.header[old].ptr == gfc.sideinfo_len * 8);
	      gfc.h_ptr = old + 1 & LameInternalFlags.MAX_HEADER_BUF - 1;
	      gfc.header[gfc.h_ptr].write_timing = gfc.header[old].write_timing + bitsPerFrame;
	      if (gfc.h_ptr == gfc.w_ptr) {
	        /* yikes! we are out of header buffer space */
	        System.err.println("Error: MAX_HEADER_BUF too small in bitstream.c \n");
	      }
	    }
	  }
	  function huffman_coder_count1(gfc, gi) {
	    /* Write count1 area */
	    var h = Tables.ht[gi.count1table_select + 32];
	    var i,
	      bits = 0;
	    var ix = gi.big_values;
	    var xr = gi.big_values;
	    assert(gi.count1table_select < 2);
	    for (i = (gi.count1 - gi.big_values) / 4; i > 0; --i) {
	      var huffbits = 0;
	      var p = 0,
	        v;
	      v = gi.l3_enc[ix + 0];
	      if (v != 0) {
	        p += 8;
	        if (gi.xr[xr + 0] < 0) huffbits++;
	      }
	      v = gi.l3_enc[ix + 1];
	      if (v != 0) {
	        p += 4;
	        huffbits *= 2;
	        if (gi.xr[xr + 1] < 0) huffbits++;
	      }
	      v = gi.l3_enc[ix + 2];
	      if (v != 0) {
	        p += 2;
	        huffbits *= 2;
	        if (gi.xr[xr + 2] < 0) huffbits++;
	      }
	      v = gi.l3_enc[ix + 3];
	      if (v != 0) {
	        p++;
	        huffbits *= 2;
	        if (gi.xr[xr + 3] < 0) huffbits++;
	      }
	      ix += 4;
	      xr += 4;
	      putbits2(gfc, huffbits + h.table[p], h.hlen[p]);
	      bits += h.hlen[p];
	    }
	    return bits;
	  }

	  /**
	   * Implements the pseudocode of page 98 of the IS
	   */
	  function Huffmancode(gfc, tableindex, start, end, gi) {
	    var h = Tables.ht[tableindex];
	    var bits = 0;
	    if (0 == tableindex) return bits;
	    for (var i = start; i < end; i += 2) {
	      var cbits = 0;
	      var xbits = 0;
	      var linbits = h.xlen;
	      var xlen = h.xlen;
	      var ext = 0;
	      var x1 = gi.l3_enc[i];
	      var x2 = gi.l3_enc[i + 1];
	      if (x1 != 0) {
	        if (gi.xr[i] < 0) ext++;
	        cbits--;
	      }
	      if (tableindex > 15) {
	        /* use ESC-words */
	        if (x1 > 14) {
	          var linbits_x1 = x1 - 15;
	          assert(linbits_x1 <= h.linmax);
	          ext |= linbits_x1 << 1;
	          xbits = linbits;
	          x1 = 15;
	        }
	        if (x2 > 14) {
	          var linbits_x2 = x2 - 15;
	          assert(linbits_x2 <= h.linmax);
	          ext <<= linbits;
	          ext |= linbits_x2;
	          xbits += linbits;
	          x2 = 15;
	        }
	        xlen = 16;
	      }
	      if (x2 != 0) {
	        ext <<= 1;
	        if (gi.xr[i + 1] < 0) ext++;
	        cbits--;
	      }
	      x1 = x1 * xlen + x2;
	      xbits -= cbits;
	      cbits += h.hlen[x1];
	      putbits2(gfc, h.table[x1], cbits);
	      putbits2(gfc, ext, xbits);
	      bits += cbits + xbits;
	    }
	    return bits;
	  }

	  /**
	   * Note the discussion of huffmancodebits() on pages 28 and 29 of the IS, as
	   * well as the definitions of the side information on pages 26 and 27.
	   */
	  function ShortHuffmancodebits(gfc, gi) {
	    var region1Start = 3 * gfc.scalefac_band.s[3];
	    if (region1Start > gi.big_values) region1Start = gi.big_values;

	    /* short blocks do not have a region2 */
	    var bits = Huffmancode(gfc, gi.table_select[0], 0, region1Start, gi);
	    bits += Huffmancode(gfc, gi.table_select[1], region1Start, gi.big_values, gi);
	    return bits;
	  }
	  function LongHuffmancodebits(gfc, gi) {
	    var bigvalues, bits;
	    var region1Start, region2Start;
	    bigvalues = gi.big_values;
	    var i = gi.region0_count + 1;
	    assert(i < gfc.scalefac_band.l.length);
	    region1Start = gfc.scalefac_band.l[i];
	    i += gi.region1_count + 1;
	    assert(i < gfc.scalefac_band.l.length);
	    region2Start = gfc.scalefac_band.l[i];
	    if (region1Start > bigvalues) region1Start = bigvalues;
	    if (region2Start > bigvalues) region2Start = bigvalues;
	    bits = Huffmancode(gfc, gi.table_select[0], 0, region1Start, gi);
	    bits += Huffmancode(gfc, gi.table_select[1], region1Start, region2Start, gi);
	    bits += Huffmancode(gfc, gi.table_select[2], region2Start, bigvalues, gi);
	    return bits;
	  }
	  function writeMainData(gfp) {
	    var gr,
	      ch,
	      sfb,
	      data_bits,
	      tot_bits = 0;
	    var gfc = gfp.internal_flags;
	    var l3_side = gfc.l3_side;
	    if (gfp.version == 1) {
	      /* MPEG 1 */
	      for (gr = 0; gr < 2; gr++) {
	        for (ch = 0; ch < gfc.channels_out; ch++) {
	          var gi = l3_side.tt[gr][ch];
	          var slen1 = Takehiro.slen1_tab[gi.scalefac_compress];
	          var slen2 = Takehiro.slen2_tab[gi.scalefac_compress];
	          data_bits = 0;
	          for (sfb = 0; sfb < gi.sfbdivide; sfb++) {
	            if (gi.scalefac[sfb] == -1) continue;
	            /* scfsi is used */
	            putbits2(gfc, gi.scalefac[sfb], slen1);
	            data_bits += slen1;
	          }
	          for (; sfb < gi.sfbmax; sfb++) {
	            if (gi.scalefac[sfb] == -1) continue;
	            /* scfsi is used */
	            putbits2(gfc, gi.scalefac[sfb], slen2);
	            data_bits += slen2;
	          }
	          assert(data_bits == gi.part2_length);
	          if (gi.block_type == Encoder.SHORT_TYPE) {
	            data_bits += ShortHuffmancodebits(gfc, gi);
	          } else {
	            data_bits += LongHuffmancodebits(gfc, gi);
	          }
	          data_bits += huffman_coder_count1(gfc, gi);
	          /* does bitcount in quantize.c agree with actual bit count? */
	          assert(data_bits == gi.part2_3_length + gi.part2_length);
	          tot_bits += data_bits;
	        }
	        /* for ch */
	      }
	      /* for gr */
	    } else {
	      /* MPEG 2 */
	      gr = 0;
	      for (ch = 0; ch < gfc.channels_out; ch++) {
	        var gi = l3_side.tt[gr][ch];
	        var i,
	          sfb_partition,
	          scale_bits = 0;
	        assert(gi.sfb_partition_table != null);
	        data_bits = 0;
	        sfb = 0;
	        sfb_partition = 0;
	        if (gi.block_type == Encoder.SHORT_TYPE) {
	          for (; sfb_partition < 4; sfb_partition++) {
	            var sfbs = gi.sfb_partition_table[sfb_partition] / 3;
	            var slen = gi.slen[sfb_partition];
	            for (i = 0; i < sfbs; i++, sfb++) {
	              putbits2(gfc, Math.max(gi.scalefac[sfb * 3 + 0], 0), slen);
	              putbits2(gfc, Math.max(gi.scalefac[sfb * 3 + 1], 0), slen);
	              putbits2(gfc, Math.max(gi.scalefac[sfb * 3 + 2], 0), slen);
	              scale_bits += 3 * slen;
	            }
	          }
	          data_bits += ShortHuffmancodebits(gfc, gi);
	        } else {
	          for (; sfb_partition < 4; sfb_partition++) {
	            var sfbs = gi.sfb_partition_table[sfb_partition];
	            var slen = gi.slen[sfb_partition];
	            for (i = 0; i < sfbs; i++, sfb++) {
	              putbits2(gfc, Math.max(gi.scalefac[sfb], 0), slen);
	              scale_bits += slen;
	            }
	          }
	          data_bits += LongHuffmancodebits(gfc, gi);
	        }
	        data_bits += huffman_coder_count1(gfc, gi);
	        /* does bitcount in quantize.c agree with actual bit count? */
	        assert(data_bits == gi.part2_3_length);
	        assert(scale_bits == gi.part2_length);
	        tot_bits += scale_bits + data_bits;
	      }
	      /* for ch */
	    }
	    /* for gf */
	    return tot_bits;
	  }

	  /* main_data */

	  function TotalBytes() {
	    this.total = 0;
	  }

	  /*
	   * compute the number of bits required to flush all mp3 frames currently in
	   * the buffer. This should be the same as the reservoir size. Only call this
	   * routine between frames - i.e. only after all headers and data have been
	   * added to the buffer by format_bitstream().
	   *
	   * Also compute total_bits_output = size of mp3 buffer (including frame
	   * headers which may not have yet been send to the mp3 buffer) + number of
	   * bits needed to flush all mp3 frames.
	   *
	   * total_bytes_output is the size of the mp3 output buffer if
	   * lame_encode_flush_nogap() was called right now.
	   */
	  function compute_flushbits(gfp, total_bytes_output) {
	    var gfc = gfp.internal_flags;
	    var flushbits, remaining_headers;
	    var bitsPerFrame;
	    var last_ptr, first_ptr;
	    first_ptr = gfc.w_ptr;
	    /* first header to add to bitstream */
	    last_ptr = gfc.h_ptr - 1;
	    /* last header to add to bitstream */
	    if (last_ptr == -1) last_ptr = LameInternalFlags.MAX_HEADER_BUF - 1;

	    /* add this many bits to bitstream so we can flush all headers */
	    flushbits = gfc.header[last_ptr].write_timing - totbit;
	    total_bytes_output.total = flushbits;
	    if (flushbits >= 0) {
	      /* if flushbits >= 0, some headers have not yet been written */
	      /* reduce flushbits by the size of the headers */
	      remaining_headers = 1 + last_ptr - first_ptr;
	      if (last_ptr < first_ptr) remaining_headers = 1 + last_ptr - first_ptr + LameInternalFlags.MAX_HEADER_BUF;
	      flushbits -= remaining_headers * 8 * gfc.sideinfo_len;
	    }

	    /*
	     * finally, add some bits so that the last frame is complete these bits
	     * are not necessary to decode the last frame, but some decoders will
	     * ignore last frame if these bits are missing
	     */
	    bitsPerFrame = self.getframebits(gfp);
	    flushbits += bitsPerFrame;
	    total_bytes_output.total += bitsPerFrame;
	    /* round up: */
	    if (total_bytes_output.total % 8 != 0) total_bytes_output.total = 1 + total_bytes_output.total / 8;else total_bytes_output.total = total_bytes_output.total / 8;
	    total_bytes_output.total += bufByteIdx + 1;
	    if (flushbits < 0) {
	      System.err.println("strange error flushing buffer ... \n");
	    }
	    return flushbits;
	  }
	  this.flush_bitstream = function (gfp) {
	    var gfc = gfp.internal_flags;
	    var l3_side;
	    var flushbits;
	    var last_ptr = gfc.h_ptr - 1;
	    /* last header to add to bitstream */
	    if (last_ptr == -1) last_ptr = LameInternalFlags.MAX_HEADER_BUF - 1;
	    l3_side = gfc.l3_side;
	    if ((flushbits = compute_flushbits(gfp, new TotalBytes())) < 0) return;
	    drain_into_ancillary(gfp, flushbits);

	    /* check that the 100% of the last frame has been written to bitstream */
	    assert(gfc.header[last_ptr].write_timing + this.getframebits(gfp) == totbit);

	    /*
	     * we have padded out all frames with ancillary data, which is the same
	     * as filling the bitreservoir with ancillary data, so :
	     */
	    gfc.ResvSize = 0;
	    l3_side.main_data_begin = 0;

	    /* save the ReplayGain value */
	    if (gfc.findReplayGain) {
	      var RadioGain = ga.GetTitleGain(gfc.rgdata);
	      assert(NEQ(RadioGain, GainAnalysis.GAIN_NOT_ENOUGH_SAMPLES));
	      gfc.RadioGain = Math.floor(RadioGain * 10.0 + 0.5) | 0;
	      /* round to nearest */
	    }

	    /* find the gain and scale change required for no clipping */
	    if (gfc.findPeakSample) {
	      gfc.noclipGainChange = Math.ceil(Math.log10(gfc.PeakSample / 32767.0) * 20.0 * 10.0) | 0;
	      /* round up */

	      if (gfc.noclipGainChange > 0) {
	        /* clipping occurs */
	        if (EQ(gfp.scale, 1.0) || EQ(gfp.scale, 0.0)) gfc.noclipScale = Math.floor(32767.0 / gfc.PeakSample * 100.0) / 100.0;
	        /* round down */else {
	          /*
	           * the user specified his own scaling factor. We could
	           * suggest the scaling factor of
	           * (32767.0/gfp.PeakSample)*(gfp.scale) but it's usually
	           * very inaccurate. So we'd rather not advice him on the
	           * scaling factor.
	           */
	          gfc.noclipScale = -1;
	        }
	      } else /* no clipping */
	        gfc.noclipScale = -1;
	    }
	  };
	  this.add_dummy_byte = function (gfp, val, n) {
	    var gfc = gfp.internal_flags;
	    var i;
	    while (n-- > 0) {
	      putbits_noheaders(gfc, val, 8);
	      for (i = 0; i < LameInternalFlags.MAX_HEADER_BUF; ++i) gfc.header[i].write_timing += 8;
	    }
	  };

	  /**
	   * This is called after a frame of audio has been quantized and coded. It
	   * will write the encoded audio to the bitstream. Note that from a layer3
	   * encoder's perspective the bit stream is primarily a series of main_data()
	   * blocks, with header and side information inserted at the proper locations
	   * to maintain framing. (See Figure A.7 in the IS).
	   */
	  this.format_bitstream = function (gfp) {
	    var gfc = gfp.internal_flags;
	    var l3_side;
	    l3_side = gfc.l3_side;
	    var bitsPerFrame = this.getframebits(gfp);
	    drain_into_ancillary(gfp, l3_side.resvDrain_pre);
	    encodeSideInfo2(gfp, bitsPerFrame);
	    var bits = 8 * gfc.sideinfo_len;
	    bits += writeMainData(gfp);
	    drain_into_ancillary(gfp, l3_side.resvDrain_post);
	    bits += l3_side.resvDrain_post;
	    l3_side.main_data_begin += (bitsPerFrame - bits) / 8;

	    /*
	     * compare number of bits needed to clear all buffered mp3 frames with
	     * what we think the resvsize is:
	     */
	    if (compute_flushbits(gfp, new TotalBytes()) != gfc.ResvSize) {
	      System.err.println("Internal buffer inconsistency. flushbits <> ResvSize");
	    }

	    /*
	     * compare main_data_begin for the next frame with what we think the
	     * resvsize is:
	     */
	    if (l3_side.main_data_begin * 8 != gfc.ResvSize) {
	      System.err.printf("bit reservoir error: \n" + "l3_side.main_data_begin: %d \n" + "Resvoir size:             %d \n" + "resv drain (post)         %d \n" + "resv drain (pre)          %d \n" + "header and sideinfo:      %d \n" + "data bits:                %d \n" + "total bits:               %d (remainder: %d) \n" + "bitsperframe:             %d \n", 8 * l3_side.main_data_begin, gfc.ResvSize, l3_side.resvDrain_post, l3_side.resvDrain_pre, 8 * gfc.sideinfo_len, bits - l3_side.resvDrain_post - 8 * gfc.sideinfo_len, bits, bits % 8, bitsPerFrame);
	      System.err.println("This is a fatal error.  It has several possible causes:");
	      System.err.println("90%%  LAME compiled with buggy version of gcc using advanced optimizations");
	      System.err.println(" 9%%  Your system is overclocked");
	      System.err.println(" 1%%  bug in LAME encoding library");
	      gfc.ResvSize = l3_side.main_data_begin * 8;
	    }
	    if (totbit > 1000000000) {
	      /*
	       * to avoid totbit overflow, (at 8h encoding at 128kbs) lets reset
	       * bit counter
	       */
	      var i;
	      for (i = 0; i < LameInternalFlags.MAX_HEADER_BUF; ++i) gfc.header[i].write_timing -= totbit;
	      totbit = 0;
	    }
	    return 0;
	  };

	  /**
	   * <PRE>
	   * copy data out of the internal MP3 bit buffer into a user supplied
	   *       unsigned char buffer.
	   *
	   *       mp3data=0      indicates data in buffer is an id3tags and VBR tags
	   *       mp3data=1      data is real mp3 frame data.
	   * </PRE>
	   */
	  this.copy_buffer = function (gfc, buffer, bufferPos, size, mp3data) {
	    var minimum = bufByteIdx + 1;
	    if (minimum <= 0) return 0;
	    if (size != 0 && minimum > size) {
	      /* buffer is too small */
	      return -1;
	    }
	    System.arraycopy(buf, 0, buffer, bufferPos, minimum);
	    bufByteIdx = -1;
	    bufBitIdx = 0;
	    if (mp3data != 0) {
	      var crc = new_int(1);
	      crc[0] = gfc.nMusicCRC;
	      vbr.updateMusicCRC(crc, buffer, bufferPos, minimum);
	      gfc.nMusicCRC = crc[0];

	      /**
	       * sum number of bytes belonging to the mp3 stream this info will be
	       * written into the Xing/LAME header for seeking
	       */
	      if (minimum > 0) {
	        gfc.VBR_seek_table.nBytesWritten += minimum;
	      }
	      if (gfc.decode_on_the_fly) {
	        /* decode the frame */
	        var pcm_buf = new_float_n([2, 1152]);
	        var mp3_in = minimum;
	        var samples_out = -1;
	        var i;

	        /* re-synthesis to pcm. Repeat until we get a samples_out=0 */
	        while (samples_out != 0) {
	          samples_out = mpg.hip_decode1_unclipped(gfc.hip, buffer, bufferPos, mp3_in, pcm_buf[0], pcm_buf[1]);
	          /*
	           * samples_out = 0: need more data to decode samples_out =
	           * -1: error. Lets assume 0 pcm output samples_out = number
	           * of samples output
	           */

	          /*
	           * set the lenght of the mp3 input buffer to zero, so that
	           * in the next iteration of the loop we will be querying
	           * mpglib about buffered data
	           */
	          mp3_in = 0;
	          if (samples_out == -1) {
	            /*
	             * error decoding. Not fatal, but might screw up the
	             * ReplayGain tag. What should we do? Ignore for now
	             */
	            samples_out = 0;
	          }
	          if (samples_out > 0) {
	            if (gfc.findPeakSample) {
	              for (i = 0; i < samples_out; i++) {
	                if (pcm_buf[0][i] > gfc.PeakSample) gfc.PeakSample = pcm_buf[0][i];else if (-pcm_buf[0][i] > gfc.PeakSample) gfc.PeakSample = -pcm_buf[0][i];
	              }
	              if (gfc.channels_out > 1) for (i = 0; i < samples_out; i++) {
	                if (pcm_buf[1][i] > gfc.PeakSample) gfc.PeakSample = pcm_buf[1][i];else if (-pcm_buf[1][i] > gfc.PeakSample) gfc.PeakSample = -pcm_buf[1][i];
	              }
	            }
	            if (gfc.findReplayGain) if (ga.AnalyzeSamples(gfc.rgdata, pcm_buf[0], 0, pcm_buf[1], 0, samples_out, gfc.channels_out) == GainAnalysis.GAIN_ANALYSIS_ERROR) return -6;
	          }
	          /* if (samples_out>0) */
	        }
	        /* while (samples_out!=0) */
	      }
	      /* if (gfc.decode_on_the_fly) */
	    }
	    /* if (mp3data) */
	    return minimum;
	  };
	  this.init_bit_stream_w = function (gfc) {
	    buf = new_byte(Lame.LAME_MAXMP3BUFFER);
	    gfc.h_ptr = gfc.w_ptr = 0;
	    gfc.header[gfc.h_ptr].write_timing = 0;
	    bufByteIdx = -1;
	    bufBitIdx = 0;
	    totbit = 0;
	  };

	  // From machine.h
	}
	BitStream_1 = BitStream;
	return BitStream_1;
}

var Lame_1;
var hasRequiredLame;

function requireLame () {
	if (hasRequiredLame) return Lame_1;
	hasRequiredLame = 1;
	var common = common$b;
	var System = common.System;
	var VbrMode = common.VbrMode;
	var ShortBlock = common.ShortBlock;
	var new_float = common.new_float;
	var new_int_n = common.new_int_n;
	var new_short_n = common.new_short_n;
	var assert = common.assert;
	var PsyModel = PsyModel_1;
	var LameGlobalFlags = LameGlobalFlags_1;
	var LameInternalFlags = LameInternalFlags_1;
	var ATH = ATH_1;
	var ReplayGain = ReplayGain_1;
	var CBRNewIterationLoop = CBRNewIterationLoop_1;
	var BitStream = requireBitStream();
	var Tables = Tables_1;
	var Encoder = requireEncoder();
	function Lame() {
	  var MPEGMode = MPEGMode_1;
	  var self = this;
	  var LAME_MAXALBUMART = 128 * 1024;
	  Lame.V9 = 410;
	  Lame.V8 = 420;
	  Lame.V7 = 430;
	  Lame.V6 = 440;
	  Lame.V5 = 450;
	  Lame.V4 = 460;
	  Lame.V3 = 470;
	  Lame.V2 = 480;
	  Lame.V1 = 490;
	  Lame.V0 = 500;

	  /* still there for compatibility */

	  Lame.R3MIX = 1000;
	  Lame.STANDARD = 1001;
	  Lame.EXTREME = 1002;
	  Lame.INSANE = 1003;
	  Lame.STANDARD_FAST = 1004;
	  Lame.EXTREME_FAST = 1005;
	  Lame.MEDIUM = 1006;
	  Lame.MEDIUM_FAST = 1007;

	  /**
	   * maximum size of mp3buffer needed if you encode at most 1152 samples for
	   * each call to lame_encode_buffer. see lame_encode_buffer() below
	   * (LAME_MAXMP3BUFFER is now obsolete)
	   */
	  var LAME_MAXMP3BUFFER = 16384 + LAME_MAXALBUMART;
	  Lame.LAME_MAXMP3BUFFER = LAME_MAXMP3BUFFER;
	  var ga;
	  var bs;
	  var p;
	  var qupvt;
	  var qu;
	  var psy = new PsyModel();
	  var vbr;
	  var id3;
	  var mpglib;
	  this.enc = new Encoder();
	  this.setModules = function (_ga, _bs, _p, _qupvt, _qu, _vbr, _ver, _id3, _mpglib) {
	    ga = _ga;
	    bs = _bs;
	    p = _p;
	    qupvt = _qupvt;
	    qu = _qu;
	    vbr = _vbr;
	    id3 = _id3;
	    mpglib = _mpglib;
	    this.enc.setModules(bs, psy, qupvt, vbr);
	  };

	  /**
	   * PSY Model related stuff
	   */
	  function PSY() {
	    /**
	     * The dbQ stuff.
	     */
	    this.mask_adjust = 0.;
	    /**
	     * The dbQ stuff.
	     */
	    this.mask_adjust_short = 0.;
	    /* at transition from one scalefactor band to next */
	    /**
	     * Band weight long scalefactor bands.
	     */
	    this.bo_l_weight = new_float(Encoder.SBMAX_l);
	    /**
	     * Band weight short scalefactor bands.
	     */
	    this.bo_s_weight = new_float(Encoder.SBMAX_s);
	  }
	  function LowPassHighPass() {
	    this.lowerlimit = 0.;
	  }
	  function BandPass(bitrate, lPass) {
	    this.lowpass = lPass;
	  }
	  var LAME_ID = 0xFFF88E3B;
	  function lame_init_old(gfp) {
	    var gfc;
	    gfp.class_id = LAME_ID;
	    gfc = gfp.internal_flags = new LameInternalFlags();

	    /* Global flags. set defaults here for non-zero values */
	    /* see lame.h for description */
	    /*
	     * set integer values to -1 to mean that LAME will compute the best
	     * value, UNLESS the calling program as set it (and the value is no
	     * longer -1)
	     */

	    gfp.mode = MPEGMode.NOT_SET;
	    gfp.original = 1;
	    gfp.in_samplerate = 44100;
	    gfp.num_channels = 2;
	    gfp.num_samples = -1;
	    gfp.bWriteVbrTag = true;
	    gfp.quality = -1;
	    gfp.short_blocks = null;
	    gfc.subblock_gain = -1;
	    gfp.lowpassfreq = 0;
	    gfp.highpassfreq = 0;
	    gfp.lowpasswidth = -1;
	    gfp.highpasswidth = -1;
	    gfp.VBR = VbrMode.vbr_off;
	    gfp.VBR_q = 4;
	    gfp.ATHcurve = -1;
	    gfp.VBR_mean_bitrate_kbps = 128;
	    gfp.VBR_min_bitrate_kbps = 0;
	    gfp.VBR_max_bitrate_kbps = 0;
	    gfp.VBR_hard_min = 0;
	    gfc.VBR_min_bitrate = 1;
	    /* not 0 ????? */
	    gfc.VBR_max_bitrate = 13;
	    /* not 14 ????? */

	    gfp.quant_comp = -1;
	    gfp.quant_comp_short = -1;
	    gfp.msfix = -1;
	    gfc.resample_ratio = 1;
	    gfc.OldValue[0] = 180;
	    gfc.OldValue[1] = 180;
	    gfc.CurrentStep[0] = 4;
	    gfc.CurrentStep[1] = 4;
	    gfc.masking_lower = 1;
	    gfc.nsPsy.attackthre = -1;
	    gfc.nsPsy.attackthre_s = -1;
	    gfp.scale = -1;
	    gfp.athaa_type = -1;
	    gfp.ATHtype = -1;
	    /* default = -1 = set in lame_init_params */
	    gfp.athaa_loudapprox = -1;
	    /* 1 = flat loudness approx. (total energy) */
	    /* 2 = equal loudness curve */
	    gfp.athaa_sensitivity = 0.0;
	    /* no offset */
	    gfp.useTemporal = null;
	    gfp.interChRatio = -1;

	    /*
	     * The reason for int mf_samples_to_encode = ENCDELAY + POSTDELAY;
	     * ENCDELAY = internal encoder delay. And then we have to add
	     * POSTDELAY=288 because of the 50% MDCT overlap. A 576 MDCT granule
	     * decodes to 1152 samples. To synthesize the 576 samples centered under
	     * this granule we need the previous granule for the first 288 samples
	     * (no problem), and the next granule for the next 288 samples (not
	     * possible if this is last granule). So we need to pad with 288 samples
	     * to make sure we can encode the 576 samples we are interested in.
	     */
	    gfc.mf_samples_to_encode = Encoder.ENCDELAY + Encoder.POSTDELAY;
	    gfp.encoder_padding = 0;
	    gfc.mf_size = Encoder.ENCDELAY - Encoder.MDCTDELAY;
	    /*
	     * we pad input with this many 0's
	     */

	    gfp.findReplayGain = false;
	    gfp.decode_on_the_fly = false;
	    gfc.decode_on_the_fly = false;
	    gfc.findReplayGain = false;
	    gfc.findPeakSample = false;
	    gfc.RadioGain = 0;
	    gfc.AudiophileGain = 0;
	    gfc.noclipGainChange = 0;
	    gfc.noclipScale = -1.0;
	    gfp.preset = 0;
	    gfp.write_id3tag_automatic = true;
	    return 0;
	  }
	  this.lame_init = function () {
	    var gfp = new LameGlobalFlags();
	    lame_init_old(gfp);
	    gfp.lame_allocated_gfp = 1;
	    return gfp;
	  };
	  function filter_coef(x) {
	    if (x > 1.0) return 0.0;
	    if (x <= 0.0) return 1.0;
	    return Math.cos(Math.PI / 2 * x);
	  }
	  this.nearestBitrateFullIndex = function (bitrate) {
	    /* borrowed from DM abr presets */

	    var full_bitrate_table = [8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320];
	    var lower_range = 0,
	      lower_range_kbps = 0,
	      upper_range = 0,
	      upper_range_kbps = 0;

	    /* We assume specified bitrate will be 320kbps */
	    upper_range_kbps = full_bitrate_table[16];
	    upper_range = 16;
	    lower_range_kbps = full_bitrate_table[16];
	    lower_range = 16;

	    /*
	     * Determine which significant bitrates the value specified falls
	     * between, if loop ends without breaking then we were correct above
	     * that the value was 320
	     */
	    for (var b = 0; b < 16; b++) {
	      if (Math.max(bitrate, full_bitrate_table[b + 1]) != bitrate) {
	        upper_range_kbps = full_bitrate_table[b + 1];
	        upper_range = b + 1;
	        lower_range_kbps = full_bitrate_table[b];
	        lower_range = b;
	        break;
	        /* We found upper range */
	      }
	    }

	    /* Determine which range the value specified is closer to */
	    if (upper_range_kbps - bitrate > bitrate - lower_range_kbps) {
	      return lower_range;
	    }
	    return upper_range;
	  };
	  function optimum_samplefreq(lowpassfreq, input_samplefreq) {
	    /*
	     * Rules:
	     *
	     * - if possible, sfb21 should NOT be used
	     */
	    var suggested_samplefreq = 44100;
	    if (input_samplefreq >= 48000) suggested_samplefreq = 48000;else if (input_samplefreq >= 44100) suggested_samplefreq = 44100;else if (input_samplefreq >= 32000) suggested_samplefreq = 32000;else if (input_samplefreq >= 24000) suggested_samplefreq = 24000;else if (input_samplefreq >= 22050) suggested_samplefreq = 22050;else if (input_samplefreq >= 16000) suggested_samplefreq = 16000;else if (input_samplefreq >= 12000) suggested_samplefreq = 12000;else if (input_samplefreq >= 11025) suggested_samplefreq = 11025;else if (input_samplefreq >= 8000) suggested_samplefreq = 8000;
	    if (lowpassfreq == -1) return suggested_samplefreq;
	    if (lowpassfreq <= 15960) suggested_samplefreq = 44100;
	    if (lowpassfreq <= 15250) suggested_samplefreq = 32000;
	    if (lowpassfreq <= 11220) suggested_samplefreq = 24000;
	    if (lowpassfreq <= 9970) suggested_samplefreq = 22050;
	    if (lowpassfreq <= 7230) suggested_samplefreq = 16000;
	    if (lowpassfreq <= 5420) suggested_samplefreq = 12000;
	    if (lowpassfreq <= 4510) suggested_samplefreq = 11025;
	    if (lowpassfreq <= 3970) suggested_samplefreq = 8000;
	    if (input_samplefreq < suggested_samplefreq) {
	      /*
	       * choose a valid MPEG sample frequency above the input sample
	       * frequency to avoid SFB21/12 bitrate bloat rh 061115
	       */
	      if (input_samplefreq > 44100) {
	        return 48000;
	      }
	      if (input_samplefreq > 32000) {
	        return 44100;
	      }
	      if (input_samplefreq > 24000) {
	        return 32000;
	      }
	      if (input_samplefreq > 22050) {
	        return 24000;
	      }
	      if (input_samplefreq > 16000) {
	        return 22050;
	      }
	      if (input_samplefreq > 12000) {
	        return 16000;
	      }
	      if (input_samplefreq > 11025) {
	        return 12000;
	      }
	      if (input_samplefreq > 8000) {
	        return 11025;
	      }
	      return 8000;
	    }
	    return suggested_samplefreq;
	  }

	  /**
	   * convert samp freq in Hz to index
	   */
	  function SmpFrqIndex(sample_freq, gpf) {
	    switch (sample_freq) {
	      case 44100:
	        gpf.version = 1;
	        return 0;
	      case 48000:
	        gpf.version = 1;
	        return 1;
	      case 32000:
	        gpf.version = 1;
	        return 2;
	      case 22050:
	        gpf.version = 0;
	        return 0;
	      case 24000:
	        gpf.version = 0;
	        return 1;
	      case 16000:
	        gpf.version = 0;
	        return 2;
	      case 11025:
	        gpf.version = 0;
	        return 0;
	      case 12000:
	        gpf.version = 0;
	        return 1;
	      case 8000:
	        gpf.version = 0;
	        return 2;
	      default:
	        gpf.version = 0;
	        return -1;
	    }
	  }

	  /**
	   * @param bRate
	   *            legal rates from 8 to 320
	   */
	  function FindNearestBitrate(bRate, version, samplerate) {
	    /* MPEG-1 or MPEG-2 LSF */
	    if (samplerate < 16000) version = 2;
	    var bitrate = Tables.bitrate_table[version][1];
	    for (var i = 2; i <= 14; i++) {
	      if (Tables.bitrate_table[version][i] > 0) {
	        if (Math.abs(Tables.bitrate_table[version][i] - bRate) < Math.abs(bitrate - bRate)) bitrate = Tables.bitrate_table[version][i];
	      }
	    }
	    return bitrate;
	  }

	  /**
	   * @param bRate
	   *            legal rates from 32 to 448 kbps
	   * @param version
	   *            MPEG-1 or MPEG-2/2.5 LSF
	   */
	  function BitrateIndex(bRate, version, samplerate) {
	    /* convert bitrate in kbps to index */
	    if (samplerate < 16000) version = 2;
	    for (var i = 0; i <= 14; i++) {
	      if (Tables.bitrate_table[version][i] > 0) {
	        if (Tables.bitrate_table[version][i] == bRate) {
	          return i;
	        }
	      }
	    }
	    return -1;
	  }
	  function optimum_bandwidth(lh, bitrate) {
	    /**
	     * <PRE>
	     *  Input:
	     *      bitrate     total bitrate in kbps
	     *
	     *   Output:
	     *      lowerlimit: best lowpass frequency limit for input filter in Hz
	     *      upperlimit: best highpass frequency limit for input filter in Hz
	     * </PRE>
	     */
	    var freq_map = [new BandPass(8, 2000), new BandPass(16, 3700), new BandPass(24, 3900), new BandPass(32, 5500), new BandPass(40, 7000), new BandPass(48, 7500), new BandPass(56, 10000), new BandPass(64, 11000), new BandPass(80, 13500), new BandPass(96, 15100), new BandPass(112, 15600), new BandPass(128, 17000), new BandPass(160, 17500), new BandPass(192, 18600), new BandPass(224, 19400), new BandPass(256, 19700), new BandPass(320, 20500)];
	    var table_index = self.nearestBitrateFullIndex(bitrate);
	    lh.lowerlimit = freq_map[table_index].lowpass;
	  }
	  function lame_init_params_ppflt(gfp) {
	    var gfc = gfp.internal_flags;
	    /***************************************************************/
	    /* compute info needed for polyphase filter (filter type==0, default) */
	    /***************************************************************/

	    var lowpass_band = 32;
	    var highpass_band = -1;
	    if (gfc.lowpass1 > 0) {
	      var minband = 999;
	      for (var band = 0; band <= 31; band++) {
	        var freq = band / 31.0;
	        /* this band and above will be zeroed: */
	        if (freq >= gfc.lowpass2) {
	          lowpass_band = Math.min(lowpass_band, band);
	        }
	        if (gfc.lowpass1 < freq && freq < gfc.lowpass2) {
	          minband = Math.min(minband, band);
	        }
	      }

	      /*
	       * compute the *actual* transition band implemented by the polyphase
	       * filter
	       */
	      if (minband == 999) {
	        gfc.lowpass1 = (lowpass_band - .75) / 31.0;
	      } else {
	        gfc.lowpass1 = (minband - .75) / 31.0;
	      }
	      gfc.lowpass2 = lowpass_band / 31.0;
	    }

	    /*
	     * make sure highpass filter is within 90% of what the effective
	     * highpass frequency will be
	     */
	    if (gfc.highpass2 > 0) {
	      if (gfc.highpass2 < .9 * (.75 / 31.0)) {
	        gfc.highpass1 = 0;
	        gfc.highpass2 = 0;
	        System.err.println("Warning: highpass filter disabled.  " + "highpass frequency too small\n");
	      }
	    }
	    if (gfc.highpass2 > 0) {
	      var maxband = -1;
	      for (var band = 0; band <= 31; band++) {
	        var freq = band / 31.0;
	        /* this band and below will be zereod */
	        if (freq <= gfc.highpass1) {
	          highpass_band = Math.max(highpass_band, band);
	        }
	        if (gfc.highpass1 < freq && freq < gfc.highpass2) {
	          maxband = Math.max(maxband, band);
	        }
	      }
	      /*
	       * compute the *actual* transition band implemented by the polyphase
	       * filter
	       */
	      gfc.highpass1 = highpass_band / 31.0;
	      if (maxband == -1) {
	        gfc.highpass2 = (highpass_band + .75) / 31.0;
	      } else {
	        gfc.highpass2 = (maxband + .75) / 31.0;
	      }
	    }
	    for (var band = 0; band < 32; band++) {
	      var fc1, fc2;
	      var freq = band / 31.0;
	      if (gfc.highpass2 > gfc.highpass1) {
	        fc1 = filter_coef((gfc.highpass2 - freq) / (gfc.highpass2 - gfc.highpass1 + 1e-20));
	      } else {
	        fc1 = 1.0;
	      }
	      if (gfc.lowpass2 > gfc.lowpass1) {
	        fc2 = filter_coef((freq - gfc.lowpass1) / (gfc.lowpass2 - gfc.lowpass1 + 1e-20));
	      } else {
	        fc2 = 1.0;
	      }
	      gfc.amp_filter[band] = fc1 * fc2;
	    }
	  }
	  function lame_init_qval(gfp) {
	    var gfc = gfp.internal_flags;
	    switch (gfp.quality) {
	      default:
	      case 9:
	        /* no psymodel, no noise shaping */
	        gfc.psymodel = 0;
	        gfc.noise_shaping = 0;
	        gfc.noise_shaping_amp = 0;
	        gfc.noise_shaping_stop = 0;
	        gfc.use_best_huffman = 0;
	        gfc.full_outer_loop = 0;
	        break;
	      case 8:
	        gfp.quality = 7;
	      //$FALL-THROUGH$
	      case 7:
	        /*
	         * use psymodel (for short block and m/s switching), but no noise
	         * shapping
	         */
	        gfc.psymodel = 1;
	        gfc.noise_shaping = 0;
	        gfc.noise_shaping_amp = 0;
	        gfc.noise_shaping_stop = 0;
	        gfc.use_best_huffman = 0;
	        gfc.full_outer_loop = 0;
	        break;
	      case 6:
	        gfc.psymodel = 1;
	        if (gfc.noise_shaping == 0) gfc.noise_shaping = 1;
	        gfc.noise_shaping_amp = 0;
	        gfc.noise_shaping_stop = 0;
	        if (gfc.subblock_gain == -1) gfc.subblock_gain = 1;
	        gfc.use_best_huffman = 0;
	        gfc.full_outer_loop = 0;
	        break;
	      case 5:
	        gfc.psymodel = 1;
	        if (gfc.noise_shaping == 0) gfc.noise_shaping = 1;
	        gfc.noise_shaping_amp = 0;
	        gfc.noise_shaping_stop = 0;
	        if (gfc.subblock_gain == -1) gfc.subblock_gain = 1;
	        gfc.use_best_huffman = 0;
	        gfc.full_outer_loop = 0;
	        break;
	      case 4:
	        gfc.psymodel = 1;
	        if (gfc.noise_shaping == 0) gfc.noise_shaping = 1;
	        gfc.noise_shaping_amp = 0;
	        gfc.noise_shaping_stop = 0;
	        if (gfc.subblock_gain == -1) gfc.subblock_gain = 1;
	        gfc.use_best_huffman = 1;
	        gfc.full_outer_loop = 0;
	        break;
	      case 3:
	        gfc.psymodel = 1;
	        if (gfc.noise_shaping == 0) gfc.noise_shaping = 1;
	        gfc.noise_shaping_amp = 1;
	        gfc.noise_shaping_stop = 1;
	        if (gfc.subblock_gain == -1) gfc.subblock_gain = 1;
	        gfc.use_best_huffman = 1;
	        gfc.full_outer_loop = 0;
	        break;
	      case 2:
	        gfc.psymodel = 1;
	        if (gfc.noise_shaping == 0) gfc.noise_shaping = 1;
	        if (gfc.substep_shaping == 0) gfc.substep_shaping = 2;
	        gfc.noise_shaping_amp = 1;
	        gfc.noise_shaping_stop = 1;
	        if (gfc.subblock_gain == -1) gfc.subblock_gain = 1;
	        gfc.use_best_huffman = 1;
	        /* inner loop */
	        gfc.full_outer_loop = 0;
	        break;
	      case 1:
	        gfc.psymodel = 1;
	        if (gfc.noise_shaping == 0) gfc.noise_shaping = 1;
	        if (gfc.substep_shaping == 0) gfc.substep_shaping = 2;
	        gfc.noise_shaping_amp = 2;
	        gfc.noise_shaping_stop = 1;
	        if (gfc.subblock_gain == -1) gfc.subblock_gain = 1;
	        gfc.use_best_huffman = 1;
	        gfc.full_outer_loop = 0;
	        break;
	      case 0:
	        gfc.psymodel = 1;
	        if (gfc.noise_shaping == 0) gfc.noise_shaping = 1;
	        if (gfc.substep_shaping == 0) gfc.substep_shaping = 2;
	        gfc.noise_shaping_amp = 2;
	        gfc.noise_shaping_stop = 1;
	        if (gfc.subblock_gain == -1) gfc.subblock_gain = 1;
	        gfc.use_best_huffman = 1;
	        /*
	         * type 2 disabled because of it slowness, in favor of full outer
	         * loop search
	         */
	        gfc.full_outer_loop = 0;
	        /*
	         * full outer loop search disabled because of audible distortions it
	         * may generate rh 060629
	         */
	        break;
	    }
	  }
	  function lame_init_bitstream(gfp) {
	    var gfc = gfp.internal_flags;
	    gfp.frameNum = 0;
	    if (gfp.write_id3tag_automatic) {
	      id3.id3tag_write_v2(gfp);
	    }
	    /* initialize histogram data optionally used by frontend */

	    gfc.bitrate_stereoMode_Hist = new_int_n([16, 4 + 1]);
	    gfc.bitrate_blockType_Hist = new_int_n([16, 4 + 1 + 1]);
	    gfc.PeakSample = 0.0;

	    /* Write initial VBR Header to bitstream and init VBR data */
	    if (gfp.bWriteVbrTag) vbr.InitVbrTag(gfp);
	  }

	  /********************************************************************
	   * initialize internal params based on data in gf (globalflags struct filled
	   * in by calling program)
	   *
	   * OUTLINE:
	   *
	   * We first have some complex code to determine bitrate, output samplerate
	   * and mode. It is complicated by the fact that we allow the user to set
	   * some or all of these parameters, and need to determine best possible
	   * values for the rest of them:
	   *
	   * 1. set some CPU related flags 2. check if we are mono.mono, stereo.mono
	   * or stereo.stereo 3. compute bitrate and output samplerate: user may have
	   * set compression ratio user may have set a bitrate user may have set a
	   * output samplerate 4. set some options which depend on output samplerate
	   * 5. compute the actual compression ratio 6. set mode based on compression
	   * ratio
	   *
	   * The remaining code is much simpler - it just sets options based on the
	   * mode & compression ratio:
	   *
	   * set allow_diff_short based on mode select lowpass filter based on
	   * compression ratio & mode set the bitrate index, and min/max bitrates for
	   * VBR modes disable VBR tag if it is not appropriate initialize the
	   * bitstream initialize scalefac_band data set sideinfo_len (based on
	   * channels, CRC, out_samplerate) write an id3v2 tag into the bitstream
	   * write VBR tag into the bitstream set mpeg1/2 flag estimate the number of
	   * frames (based on a lot of data)
	   *
	   * now we set more flags: nspsytune: see code VBR modes see code CBR/ABR see
	   * code
	   *
	   * Finally, we set the algorithm flags based on the gfp.quality value
	   * lame_init_qval(gfp);
	   *
	   ********************************************************************/
	  this.lame_init_params = function (gfp) {
	    var gfc = gfp.internal_flags;
	    gfc.Class_ID = 0;
	    if (gfc.ATH == null) gfc.ATH = new ATH();
	    if (gfc.PSY == null) gfc.PSY = new PSY();
	    if (gfc.rgdata == null) gfc.rgdata = new ReplayGain();
	    gfc.channels_in = gfp.num_channels;
	    if (gfc.channels_in == 1) gfp.mode = MPEGMode.MONO;
	    gfc.channels_out = gfp.mode == MPEGMode.MONO ? 1 : 2;
	    gfc.mode_ext = Encoder.MPG_MD_MS_LR;
	    if (gfp.mode == MPEGMode.MONO) gfp.force_ms = false;
	    /*
	     * don't allow forced mid/side stereo for mono output
	     */

	    if (gfp.VBR == VbrMode.vbr_off && gfp.VBR_mean_bitrate_kbps != 128 && gfp.brate == 0) gfp.brate = gfp.VBR_mean_bitrate_kbps;
	    if (gfp.VBR == VbrMode.vbr_off || gfp.VBR == VbrMode.vbr_mtrh || gfp.VBR == VbrMode.vbr_mt) ; else {
	      gfp.free_format = false;
	      /* mode can't be mixed with free format */
	    }
	    if (gfp.VBR == VbrMode.vbr_off && gfp.brate == 0) {
	      /* no bitrate or compression ratio specified, use 11.025 */
	      if (BitStream.EQ(gfp.compression_ratio, 0)) gfp.compression_ratio = 11.025;
	      /*
	       * rate to compress a CD down to exactly 128000 bps
	       */
	    }

	    /* find bitrate if user specify a compression ratio */
	    if (gfp.VBR == VbrMode.vbr_off && gfp.compression_ratio > 0) {
	      if (gfp.out_samplerate == 0) gfp.out_samplerate = map2MP3Frequency(int(0.97 * gfp.in_samplerate));
	      /*
	       * round up with a margin of 3 %
	       */

	      /*
	       * choose a bitrate for the output samplerate which achieves
	       * specified compression ratio
	       */
	      gfp.brate = 0 | gfp.out_samplerate * 16 * gfc.channels_out / (1.e3 * gfp.compression_ratio);

	      /* we need the version for the bitrate table look up */
	      gfc.samplerate_index = SmpFrqIndex(gfp.out_samplerate, gfp);
	      if (!gfp.free_format)
	        /*
	        * for non Free Format find the nearest allowed
	        * bitrate
	        */
	        gfp.brate = FindNearestBitrate(gfp.brate, gfp.version, gfp.out_samplerate);
	    }
	    if (gfp.out_samplerate != 0) {
	      if (gfp.out_samplerate < 16000) {
	        gfp.VBR_mean_bitrate_kbps = Math.max(gfp.VBR_mean_bitrate_kbps, 8);
	        gfp.VBR_mean_bitrate_kbps = Math.min(gfp.VBR_mean_bitrate_kbps, 64);
	      } else if (gfp.out_samplerate < 32000) {
	        gfp.VBR_mean_bitrate_kbps = Math.max(gfp.VBR_mean_bitrate_kbps, 8);
	        gfp.VBR_mean_bitrate_kbps = Math.min(gfp.VBR_mean_bitrate_kbps, 160);
	      } else {
	        gfp.VBR_mean_bitrate_kbps = Math.max(gfp.VBR_mean_bitrate_kbps, 32);
	        gfp.VBR_mean_bitrate_kbps = Math.min(gfp.VBR_mean_bitrate_kbps, 320);
	      }
	    }

	    /****************************************************************/
	    /* if a filter has not been enabled, see if we should add one: */
	    /****************************************************************/
	    if (gfp.lowpassfreq == 0) {
	      var lowpass = 16000.;
	      switch (gfp.VBR) {
	        case VbrMode.vbr_off:
	          {
	            var lh = new LowPassHighPass();
	            optimum_bandwidth(lh, gfp.brate);
	            lowpass = lh.lowerlimit;
	            break;
	          }
	        case VbrMode.vbr_abr:
	          {
	            var lh = new LowPassHighPass();
	            optimum_bandwidth(lh, gfp.VBR_mean_bitrate_kbps);
	            lowpass = lh.lowerlimit;
	            break;
	          }
	        case VbrMode.vbr_rh:
	          {
	            var x = [19500, 19000, 18600, 18000, 17500, 16000, 15600, 14900, 12500, 10000, 3950];
	            if (0 <= gfp.VBR_q && gfp.VBR_q <= 9) {
	              var a = x[gfp.VBR_q],
	                b = x[gfp.VBR_q + 1],
	                m = gfp.VBR_q_frac;
	              lowpass = linear_int(a, b, m);
	            } else {
	              lowpass = 19500;
	            }
	            break;
	          }
	        default:
	          {
	            var x = [19500, 19000, 18500, 18000, 17500, 16500, 15500, 14500, 12500, 9500, 3950];
	            if (0 <= gfp.VBR_q && gfp.VBR_q <= 9) {
	              var a = x[gfp.VBR_q],
	                b = x[gfp.VBR_q + 1],
	                m = gfp.VBR_q_frac;
	              lowpass = linear_int(a, b, m);
	            } else {
	              lowpass = 19500;
	            }
	          }
	      }
	      if (gfp.mode == MPEGMode.MONO && (gfp.VBR == VbrMode.vbr_off || gfp.VBR == VbrMode.vbr_abr)) lowpass *= 1.5;
	      gfp.lowpassfreq = lowpass | 0;
	    }
	    if (gfp.out_samplerate == 0) {
	      if (2 * gfp.lowpassfreq > gfp.in_samplerate) {
	        gfp.lowpassfreq = gfp.in_samplerate / 2;
	      }
	      gfp.out_samplerate = optimum_samplefreq(gfp.lowpassfreq | 0, gfp.in_samplerate);
	    }
	    gfp.lowpassfreq = Math.min(20500, gfp.lowpassfreq);
	    gfp.lowpassfreq = Math.min(gfp.out_samplerate / 2, gfp.lowpassfreq);
	    if (gfp.VBR == VbrMode.vbr_off) {
	      gfp.compression_ratio = gfp.out_samplerate * 16 * gfc.channels_out / (1.e3 * gfp.brate);
	    }
	    if (gfp.VBR == VbrMode.vbr_abr) {
	      gfp.compression_ratio = gfp.out_samplerate * 16 * gfc.channels_out / (1.e3 * gfp.VBR_mean_bitrate_kbps);
	    }

	    /*
	     * do not compute ReplayGain values and do not find the peak sample if
	     * we can't store them
	     */
	    if (!gfp.bWriteVbrTag) {
	      gfp.findReplayGain = false;
	      gfp.decode_on_the_fly = false;
	      gfc.findPeakSample = false;
	    }
	    gfc.findReplayGain = gfp.findReplayGain;
	    gfc.decode_on_the_fly = gfp.decode_on_the_fly;
	    if (gfc.decode_on_the_fly) gfc.findPeakSample = true;
	    if (gfc.findReplayGain) {
	      if (ga.InitGainAnalysis(gfc.rgdata, gfp.out_samplerate) == GainAnalysis.INIT_GAIN_ANALYSIS_ERROR) {
	        gfp.internal_flags = null;
	        return -6;
	      }
	    }
	    if (gfc.decode_on_the_fly && !gfp.decode_only) {
	      if (gfc.hip != null) {
	        mpglib.hip_decode_exit(gfc.hip);
	      }
	      gfc.hip = mpglib.hip_decode_init();
	    }
	    gfc.mode_gr = gfp.out_samplerate <= 24000 ? 1 : 2;
	    /*
	     * Number of granules per frame
	     */
	    gfp.framesize = 576 * gfc.mode_gr;
	    gfp.encoder_delay = Encoder.ENCDELAY;
	    gfc.resample_ratio = gfp.in_samplerate / gfp.out_samplerate;

	    /**
	     * <PRE>
	     *  sample freq       bitrate     compression ratio
	     *     [kHz]      [kbps/channel]   for 16 bit input
	     *     44.1            56               12.6
	     *     44.1            64               11.025
	     *     44.1            80                8.82
	     *     22.05           24               14.7
	     *     22.05           32               11.025
	     *     22.05           40                8.82
	     *     16              16               16.0
	     *     16              24               10.667
	     * </PRE>
	     */
	    /**
	     * <PRE>
	     *  For VBR, take a guess at the compression_ratio.
	     *  For example:
	     *
	     *    VBR_q    compression     like
	     *     -        4.4         320 kbps/44 kHz
	     *   0...1      5.5         256 kbps/44 kHz
	     *     2        7.3         192 kbps/44 kHz
	     *     4        8.8         160 kbps/44 kHz
	     *     6       11           128 kbps/44 kHz
	     *     9       14.7          96 kbps
	     *
	     *  for lower bitrates, downsample with --resample
	     * </PRE>
	     */
	    switch (gfp.VBR) {
	      case VbrMode.vbr_mt:
	      case VbrMode.vbr_rh:
	      case VbrMode.vbr_mtrh:
	        {
	          /* numbers are a bit strange, but they determine the lowpass value */
	          var cmp = [5.7, 6.5, 7.3, 8.2, 10, 11.9, 13, 14, 15, 16.5];
	          gfp.compression_ratio = cmp[gfp.VBR_q];
	        }
	        break;
	      case VbrMode.vbr_abr:
	        gfp.compression_ratio = gfp.out_samplerate * 16 * gfc.channels_out / (1.e3 * gfp.VBR_mean_bitrate_kbps);
	        break;
	      default:
	        gfp.compression_ratio = gfp.out_samplerate * 16 * gfc.channels_out / (1.e3 * gfp.brate);
	        break;
	    }

	    /*
	     * mode = -1 (not set by user) or mode = MONO (because of only 1 input
	     * channel). If mode has not been set, then select J-STEREO
	     */
	    if (gfp.mode == MPEGMode.NOT_SET) {
	      gfp.mode = MPEGMode.JOINT_STEREO;
	    }

	    /* apply user driven high pass filter */
	    if (gfp.highpassfreq > 0) {
	      gfc.highpass1 = 2. * gfp.highpassfreq;
	      if (gfp.highpasswidth >= 0) gfc.highpass2 = 2. * (gfp.highpassfreq + gfp.highpasswidth);else /* 0% above on default */
	        gfc.highpass2 = (1 + 0.00) * 2. * gfp.highpassfreq;
	      gfc.highpass1 /= gfp.out_samplerate;
	      gfc.highpass2 /= gfp.out_samplerate;
	    } else {
	      gfc.highpass1 = 0;
	      gfc.highpass2 = 0;
	    }
	    /* apply user driven low pass filter */
	    if (gfp.lowpassfreq > 0) {
	      gfc.lowpass2 = 2. * gfp.lowpassfreq;
	      if (gfp.lowpasswidth >= 0) {
	        gfc.lowpass1 = 2. * (gfp.lowpassfreq - gfp.lowpasswidth);
	        if (gfc.lowpass1 < 0) /* has to be >= 0 */
	          gfc.lowpass1 = 0;
	      } else {
	        /* 0% below on default */
	        gfc.lowpass1 = (1 - 0.00) * 2. * gfp.lowpassfreq;
	      }
	      gfc.lowpass1 /= gfp.out_samplerate;
	      gfc.lowpass2 /= gfp.out_samplerate;
	    } else {
	      gfc.lowpass1 = 0;
	      gfc.lowpass2 = 0;
	    }

	    /**********************************************************************/
	    /* compute info needed for polyphase filter (filter type==0, default) */
	    /**********************************************************************/
	    lame_init_params_ppflt(gfp);
	    /*******************************************************
	     * samplerate and bitrate index
	     *******************************************************/
	    gfc.samplerate_index = SmpFrqIndex(gfp.out_samplerate, gfp);
	    if (gfc.samplerate_index < 0) {
	      gfp.internal_flags = null;
	      return -1;
	    }
	    if (gfp.VBR == VbrMode.vbr_off) {
	      if (gfp.free_format) {
	        gfc.bitrate_index = 0;
	      } else {
	        gfp.brate = FindNearestBitrate(gfp.brate, gfp.version, gfp.out_samplerate);
	        gfc.bitrate_index = BitrateIndex(gfp.brate, gfp.version, gfp.out_samplerate);
	        if (gfc.bitrate_index <= 0) {
	          gfp.internal_flags = null;
	          return -1;
	        }
	      }
	    } else {
	      gfc.bitrate_index = 1;
	    }

	    /* for CBR, we will write an "info" tag. */

	    if (gfp.analysis) gfp.bWriteVbrTag = false;

	    /* some file options not allowed if output is: not specified or stdout */
	    if (gfc.pinfo != null) gfp.bWriteVbrTag = false;
	    /* disable Xing VBR tag */

	    bs.init_bit_stream_w(gfc);
	    var j = gfc.samplerate_index + 3 * gfp.version + 6 * (gfp.out_samplerate < 16000 ? 1 : 0);
	    for (var i = 0; i < Encoder.SBMAX_l + 1; i++) gfc.scalefac_band.l[i] = qupvt.sfBandIndex[j].l[i];
	    for (var i = 0; i < Encoder.PSFB21 + 1; i++) {
	      var size = (gfc.scalefac_band.l[22] - gfc.scalefac_band.l[21]) / Encoder.PSFB21;
	      var start = gfc.scalefac_band.l[21] + i * size;
	      gfc.scalefac_band.psfb21[i] = start;
	    }
	    gfc.scalefac_band.psfb21[Encoder.PSFB21] = 576;
	    for (var i = 0; i < Encoder.SBMAX_s + 1; i++) gfc.scalefac_band.s[i] = qupvt.sfBandIndex[j].s[i];
	    for (var i = 0; i < Encoder.PSFB12 + 1; i++) {
	      var size = (gfc.scalefac_band.s[13] - gfc.scalefac_band.s[12]) / Encoder.PSFB12;
	      var start = gfc.scalefac_band.s[12] + i * size;
	      gfc.scalefac_band.psfb12[i] = start;
	    }
	    gfc.scalefac_band.psfb12[Encoder.PSFB12] = 192;
	    /* determine the mean bitrate for main data */
	    if (gfp.version == 1) /* MPEG 1 */
	      gfc.sideinfo_len = gfc.channels_out == 1 ? 4 + 17 : 4 + 32;else /* MPEG 2 */
	      gfc.sideinfo_len = gfc.channels_out == 1 ? 4 + 9 : 4 + 17;
	    if (gfp.error_protection) gfc.sideinfo_len += 2;
	    lame_init_bitstream(gfp);
	    gfc.Class_ID = LAME_ID;
	    {
	      var k;
	      for (k = 0; k < 19; k++) gfc.nsPsy.pefirbuf[k] = 700 * gfc.mode_gr * gfc.channels_out;
	      if (gfp.ATHtype == -1) gfp.ATHtype = 4;
	    }
	    assert(gfp.VBR_q <= 9);
	    assert(gfp.VBR_q >= 0);
	    switch (gfp.VBR) {
	      case VbrMode.vbr_mt:
	        gfp.VBR = VbrMode.vbr_mtrh;
	      //$FALL-THROUGH$
	      case VbrMode.vbr_mtrh:
	        {
	          if (gfp.useTemporal == null) {
	            gfp.useTemporal = false;
	            /* off by default for this VBR mode */
	          }
	          p.apply_preset(gfp, 500 - gfp.VBR_q * 10, 0);
	          /**
	           * <PRE>
	           *   The newer VBR code supports only a limited
	           *     subset of quality levels:
	           *     9-5=5 are the same, uses x^3/4 quantization
	           *   4-0=0 are the same  5 plus best huffman divide code
	           * </PRE>
	           */
	          if (gfp.quality < 0) gfp.quality = LAME_DEFAULT_QUALITY;
	          if (gfp.quality < 5) gfp.quality = 0;
	          if (gfp.quality > 5) gfp.quality = 5;
	          gfc.PSY.mask_adjust = gfp.maskingadjust;
	          gfc.PSY.mask_adjust_short = gfp.maskingadjust_short;

	          /*
	           * sfb21 extra only with MPEG-1 at higher sampling rates
	           */
	          if (gfp.experimentalY) gfc.sfb21_extra = false;else gfc.sfb21_extra = gfp.out_samplerate > 44000;
	          gfc.iteration_loop = new VBRNewIterationLoop(qu);
	          break;
	        }
	      case VbrMode.vbr_rh:
	        {
	          p.apply_preset(gfp, 500 - gfp.VBR_q * 10, 0);
	          gfc.PSY.mask_adjust = gfp.maskingadjust;
	          gfc.PSY.mask_adjust_short = gfp.maskingadjust_short;

	          /*
	           * sfb21 extra only with MPEG-1 at higher sampling rates
	           */
	          if (gfp.experimentalY) gfc.sfb21_extra = false;else gfc.sfb21_extra = gfp.out_samplerate > 44000;

	          /*
	           * VBR needs at least the output of GPSYCHO, so we have to garantee
	           * that by setting a minimum quality level, actually level 6 does
	           * it. down to level 6
	           */
	          if (gfp.quality > 6) gfp.quality = 6;
	          if (gfp.quality < 0) gfp.quality = LAME_DEFAULT_QUALITY;
	          gfc.iteration_loop = new VBROldIterationLoop(qu);
	          break;
	        }
	      default:
	        /* cbr/abr */
	        {
	          var vbrmode;

	          /*
	           * no sfb21 extra with CBR code
	           */
	          gfc.sfb21_extra = false;
	          if (gfp.quality < 0) gfp.quality = LAME_DEFAULT_QUALITY;
	          vbrmode = gfp.VBR;
	          if (vbrmode == VbrMode.vbr_off) gfp.VBR_mean_bitrate_kbps = gfp.brate;
	          /* second, set parameters depending on bitrate */
	          p.apply_preset(gfp, gfp.VBR_mean_bitrate_kbps, 0);
	          gfp.VBR = vbrmode;
	          gfc.PSY.mask_adjust = gfp.maskingadjust;
	          gfc.PSY.mask_adjust_short = gfp.maskingadjust_short;
	          if (vbrmode == VbrMode.vbr_off) {
	            gfc.iteration_loop = new CBRNewIterationLoop(qu);
	          } else {
	            gfc.iteration_loop = new ABRIterationLoop(qu);
	          }
	          break;
	        }
	    }
	    assert(gfp.scale >= 0);
	    /* initialize default values common for all modes */

	    if (gfp.VBR != VbrMode.vbr_off) {
	      /* choose a min/max bitrate for VBR */
	      /* if the user didn't specify VBR_max_bitrate: */
	      gfc.VBR_min_bitrate = 1;
	      /*
	       * default: allow 8 kbps (MPEG-2) or 32 kbps (MPEG-1)
	       */
	      gfc.VBR_max_bitrate = 14;
	      /*
	       * default: allow 160 kbps (MPEG-2) or 320 kbps (MPEG-1)
	       */
	      if (gfp.out_samplerate < 16000) gfc.VBR_max_bitrate = 8;
	      /* default: allow 64 kbps (MPEG-2.5) */
	      if (gfp.VBR_min_bitrate_kbps != 0) {
	        gfp.VBR_min_bitrate_kbps = FindNearestBitrate(gfp.VBR_min_bitrate_kbps, gfp.version, gfp.out_samplerate);
	        gfc.VBR_min_bitrate = BitrateIndex(gfp.VBR_min_bitrate_kbps, gfp.version, gfp.out_samplerate);
	        if (gfc.VBR_min_bitrate < 0) return -1;
	      }
	      if (gfp.VBR_max_bitrate_kbps != 0) {
	        gfp.VBR_max_bitrate_kbps = FindNearestBitrate(gfp.VBR_max_bitrate_kbps, gfp.version, gfp.out_samplerate);
	        gfc.VBR_max_bitrate = BitrateIndex(gfp.VBR_max_bitrate_kbps, gfp.version, gfp.out_samplerate);
	        if (gfc.VBR_max_bitrate < 0) return -1;
	      }
	      gfp.VBR_min_bitrate_kbps = Tables.bitrate_table[gfp.version][gfc.VBR_min_bitrate];
	      gfp.VBR_max_bitrate_kbps = Tables.bitrate_table[gfp.version][gfc.VBR_max_bitrate];
	      gfp.VBR_mean_bitrate_kbps = Math.min(Tables.bitrate_table[gfp.version][gfc.VBR_max_bitrate], gfp.VBR_mean_bitrate_kbps);
	      gfp.VBR_mean_bitrate_kbps = Math.max(Tables.bitrate_table[gfp.version][gfc.VBR_min_bitrate], gfp.VBR_mean_bitrate_kbps);
	    }

	    /* just another daily changing developer switch */
	    if (gfp.tune) {
	      gfc.PSY.mask_adjust += gfp.tune_value_a;
	      gfc.PSY.mask_adjust_short += gfp.tune_value_a;
	    }

	    /* initialize internal qval settings */
	    lame_init_qval(gfp);
	    assert(gfp.scale >= 0);
	    /*
	     * automatic ATH adjustment on
	     */
	    if (gfp.athaa_type < 0) gfc.ATH.useAdjust = 3;else gfc.ATH.useAdjust = gfp.athaa_type;

	    /* initialize internal adaptive ATH settings -jd */
	    gfc.ATH.aaSensitivityP = Math.pow(10.0, gfp.athaa_sensitivity / -10.0);
	    if (gfp.short_blocks == null) {
	      gfp.short_blocks = ShortBlock.short_block_allowed;
	    }

	    /*
	     * Note Jan/2003: Many hardware decoders cannot handle short blocks in
	     * regular stereo mode unless they are coupled (same type in both
	     * channels) it is a rare event (1 frame per min. or so) that LAME would
	     * use uncoupled short blocks, so lets turn them off until we decide how
	     * to handle this. No other encoders allow uncoupled short blocks, even
	     * though it is in the standard.
	     */
	    /*
	     * rh 20040217: coupling makes no sense for mono and dual-mono streams
	     */
	    if (gfp.short_blocks == ShortBlock.short_block_allowed && (gfp.mode == MPEGMode.JOINT_STEREO || gfp.mode == MPEGMode.STEREO)) {
	      gfp.short_blocks = ShortBlock.short_block_coupled;
	    }
	    if (gfp.quant_comp < 0) gfp.quant_comp = 1;
	    if (gfp.quant_comp_short < 0) gfp.quant_comp_short = 0;
	    if (gfp.msfix < 0) gfp.msfix = 0;

	    /* select psychoacoustic model */
	    gfp.exp_nspsytune = gfp.exp_nspsytune | 1;
	    if (gfp.internal_flags.nsPsy.attackthre < 0) gfp.internal_flags.nsPsy.attackthre = PsyModel.NSATTACKTHRE;
	    if (gfp.internal_flags.nsPsy.attackthre_s < 0) gfp.internal_flags.nsPsy.attackthre_s = PsyModel.NSATTACKTHRE_S;
	    assert(gfp.scale >= 0);
	    if (gfp.scale < 0) gfp.scale = 1;
	    if (gfp.ATHtype < 0) gfp.ATHtype = 4;
	    if (gfp.ATHcurve < 0) gfp.ATHcurve = 4;
	    if (gfp.athaa_loudapprox < 0) gfp.athaa_loudapprox = 2;
	    if (gfp.interChRatio < 0) gfp.interChRatio = 0;
	    if (gfp.useTemporal == null) gfp.useTemporal = true;
	    /* on by default */

	    /*
	     * padding method as described in
	     * "MPEG-Layer3 / Bitstream Syntax and Decoding" by Martin Sieler, Ralph
	     * Sperschneider
	     *
	     * note: there is no padding for the very first frame
	     *
	     * Robert Hegemann 2000-06-22
	     */
	    gfc.slot_lag = gfc.frac_SpF = 0;
	    if (gfp.VBR == VbrMode.vbr_off) gfc.slot_lag = gfc.frac_SpF = (gfp.version + 1) * 72000 * gfp.brate % gfp.out_samplerate | 0;
	    qupvt.iteration_init(gfp);
	    psy.psymodel_init(gfp);
	    assert(gfp.scale >= 0);
	    return 0;
	  };
	  function update_inbuffer_size(gfc, nsamples) {
	    if (gfc.in_buffer_0 == null || gfc.in_buffer_nsamples < nsamples) {
	      gfc.in_buffer_0 = new_float(nsamples);
	      gfc.in_buffer_1 = new_float(nsamples);
	      gfc.in_buffer_nsamples = nsamples;
	    }
	  }
	  this.lame_encode_flush = function (gfp, mp3buffer, mp3bufferPos, mp3buffer_size) {
	    var gfc = gfp.internal_flags;
	    var buffer = new_short_n([2, 1152]);
	    var imp3 = 0,
	      mp3count,
	      mp3buffer_size_remaining;

	    /*
	     * we always add POSTDELAY=288 padding to make sure granule with real
	     * data can be complety decoded (because of 50% overlap with next
	     * granule
	     */
	    var end_padding;
	    var frames_left;
	    var samples_to_encode = gfc.mf_samples_to_encode - Encoder.POSTDELAY;
	    var mf_needed = calcNeeded(gfp);

	    /* Was flush already called? */
	    if (gfc.mf_samples_to_encode < 1) {
	      return 0;
	    }
	    mp3count = 0;
	    if (gfp.in_samplerate != gfp.out_samplerate) {
	      /*
	       * delay due to resampling; needs to be fixed, if resampling code
	       * gets changed
	       */
	      samples_to_encode += 16. * gfp.out_samplerate / gfp.in_samplerate;
	    }
	    end_padding = gfp.framesize - samples_to_encode % gfp.framesize;
	    if (end_padding < 576) end_padding += gfp.framesize;
	    gfp.encoder_padding = end_padding;
	    frames_left = (samples_to_encode + end_padding) / gfp.framesize;

	    /*
	     * send in a frame of 0 padding until all internal sample buffers are
	     * flushed
	     */
	    while (frames_left > 0 && imp3 >= 0) {
	      var bunch = mf_needed - gfc.mf_size;
	      var frame_num = gfp.frameNum;
	      bunch *= gfp.in_samplerate;
	      bunch /= gfp.out_samplerate;
	      if (bunch > 1152) bunch = 1152;
	      if (bunch < 1) bunch = 1;
	      mp3buffer_size_remaining = mp3buffer_size - mp3count;

	      /* if user specifed buffer size = 0, dont check size */
	      if (mp3buffer_size == 0) mp3buffer_size_remaining = 0;
	      imp3 = this.lame_encode_buffer(gfp, buffer[0], buffer[1], bunch, mp3buffer, mp3bufferPos, mp3buffer_size_remaining);
	      mp3bufferPos += imp3;
	      mp3count += imp3;
	      frames_left -= frame_num != gfp.frameNum ? 1 : 0;
	    }
	    /*
	     * Set gfc.mf_samples_to_encode to 0, so we may detect and break loops
	     * calling it more than once in a row.
	     */
	    gfc.mf_samples_to_encode = 0;
	    if (imp3 < 0) {
	      /* some type of fatal error */
	      return imp3;
	    }
	    mp3buffer_size_remaining = mp3buffer_size - mp3count;
	    /* if user specifed buffer size = 0, dont check size */
	    if (mp3buffer_size == 0) mp3buffer_size_remaining = 0;

	    /* mp3 related stuff. bit buffer might still contain some mp3 data */
	    bs.flush_bitstream(gfp);
	    imp3 = bs.copy_buffer(gfc, mp3buffer, mp3bufferPos, mp3buffer_size_remaining, 1);
	    if (imp3 < 0) {
	      /* some type of fatal error */
	      return imp3;
	    }
	    mp3bufferPos += imp3;
	    mp3count += imp3;
	    mp3buffer_size_remaining = mp3buffer_size - mp3count;
	    /* if user specifed buffer size = 0, dont check size */
	    if (mp3buffer_size == 0) mp3buffer_size_remaining = 0;
	    if (gfp.write_id3tag_automatic) {
	      /* write a id3 tag to the bitstream */
	      id3.id3tag_write_v1(gfp);
	      imp3 = bs.copy_buffer(gfc, mp3buffer, mp3bufferPos, mp3buffer_size_remaining, 0);
	      if (imp3 < 0) {
	        return imp3;
	      }
	      mp3count += imp3;
	    }
	    return mp3count;
	  };
	  this.lame_encode_buffer = function (gfp, buffer_l, buffer_r, nsamples, mp3buf, mp3bufPos, mp3buf_size) {
	    var gfc = gfp.internal_flags;
	    var in_buffer = [null, null];
	    if (gfc.Class_ID != LAME_ID) return -3;
	    if (nsamples == 0) return 0;
	    update_inbuffer_size(gfc, nsamples);
	    in_buffer[0] = gfc.in_buffer_0;
	    in_buffer[1] = gfc.in_buffer_1;

	    /* make a copy of input buffer, changing type to sample_t */
	    for (var i = 0; i < nsamples; i++) {
	      in_buffer[0][i] = buffer_l[i];
	      if (gfc.channels_in > 1) in_buffer[1][i] = buffer_r[i];
	    }
	    return lame_encode_buffer_sample(gfp, in_buffer[0], in_buffer[1], nsamples, mp3buf, mp3bufPos, mp3buf_size);
	  };
	  function calcNeeded(gfp) {
	    var mf_needed = Encoder.BLKSIZE + gfp.framesize - Encoder.FFTOFFSET;
	    /*
	     * amount needed for FFT
	     */
	    mf_needed = Math.max(mf_needed, 512 + gfp.framesize - 32);
	    return mf_needed;
	  }
	  function lame_encode_buffer_sample(gfp, buffer_l, buffer_r, nsamples, mp3buf, mp3bufPos, mp3buf_size) {
	    var gfc = gfp.internal_flags;
	    var mp3size = 0,
	      ret,
	      i,
	      ch,
	      mf_needed;
	    var mp3out;
	    var mfbuf = [null, null];
	    var in_buffer = [null, null];
	    if (gfc.Class_ID != LAME_ID) return -3;
	    if (nsamples == 0) return 0;

	    /* copy out any tags that may have been written into bitstream */
	    mp3out = bs.copy_buffer(gfc, mp3buf, mp3bufPos, mp3buf_size, 0);
	    if (mp3out < 0) return mp3out;
	    /* not enough buffer space */
	    mp3bufPos += mp3out;
	    mp3size += mp3out;
	    in_buffer[0] = buffer_l;
	    in_buffer[1] = buffer_r;

	    /* Apply user defined re-scaling */

	    /* user selected scaling of the samples */
	    if (BitStream.NEQ(gfp.scale, 0) && BitStream.NEQ(gfp.scale, 1.0)) {
	      for (i = 0; i < nsamples; ++i) {
	        in_buffer[0][i] *= gfp.scale;
	        if (gfc.channels_out == 2) in_buffer[1][i] *= gfp.scale;
	      }
	    }

	    /* user selected scaling of the channel 0 (left) samples */
	    if (BitStream.NEQ(gfp.scale_left, 0) && BitStream.NEQ(gfp.scale_left, 1.0)) {
	      for (i = 0; i < nsamples; ++i) {
	        in_buffer[0][i] *= gfp.scale_left;
	      }
	    }

	    /* user selected scaling of the channel 1 (right) samples */
	    if (BitStream.NEQ(gfp.scale_right, 0) && BitStream.NEQ(gfp.scale_right, 1.0)) {
	      for (i = 0; i < nsamples; ++i) {
	        in_buffer[1][i] *= gfp.scale_right;
	      }
	    }

	    /* Downsample to Mono if 2 channels in and 1 channel out */
	    if (gfp.num_channels == 2 && gfc.channels_out == 1) {
	      for (i = 0; i < nsamples; ++i) {
	        in_buffer[0][i] = 0.5 * (in_buffer[0][i] + in_buffer[1][i]);
	        in_buffer[1][i] = 0.0;
	      }
	    }
	    mf_needed = calcNeeded(gfp);
	    mfbuf[0] = gfc.mfbuf[0];
	    mfbuf[1] = gfc.mfbuf[1];
	    var in_bufferPos = 0;
	    while (nsamples > 0) {
	      var in_buffer_ptr = [null, null];
	      var n_in = 0;
	      /* number of input samples processed with fill_buffer */
	      var n_out = 0;
	      /* number of samples output with fill_buffer */
	      /* n_in <> n_out if we are resampling */

	      in_buffer_ptr[0] = in_buffer[0];
	      in_buffer_ptr[1] = in_buffer[1];
	      /* copy in new samples into mfbuf, with resampling */
	      var inOut = new InOut();
	      fill_buffer(gfp, mfbuf, in_buffer_ptr, in_bufferPos, nsamples, inOut);
	      n_in = inOut.n_in;
	      n_out = inOut.n_out;

	      /* compute ReplayGain of resampled input if requested */
	      if (gfc.findReplayGain && !gfc.decode_on_the_fly) if (ga.AnalyzeSamples(gfc.rgdata, mfbuf[0], gfc.mf_size, mfbuf[1], gfc.mf_size, n_out, gfc.channels_out) == GainAnalysis.GAIN_ANALYSIS_ERROR) return -6;

	      /* update in_buffer counters */
	      nsamples -= n_in;
	      in_bufferPos += n_in;
	      if (gfc.channels_out == 2) ; // in_bufferPos += n_in;

	      /* update mfbuf[] counters */
	      gfc.mf_size += n_out;
	      assert(gfc.mf_size <= LameInternalFlags.MFSIZE);

	      /*
	       * lame_encode_flush may have set gfc.mf_sample_to_encode to 0 so we
	       * have to reinitialize it here when that happened.
	       */
	      if (gfc.mf_samples_to_encode < 1) {
	        gfc.mf_samples_to_encode = Encoder.ENCDELAY + Encoder.POSTDELAY;
	      }
	      gfc.mf_samples_to_encode += n_out;
	      if (gfc.mf_size >= mf_needed) {
	        /* encode the frame. */
	        /* mp3buf = pointer to current location in buffer */
	        /* mp3buf_size = size of original mp3 output buffer */
	        /* = 0 if we should not worry about the */
	        /* buffer size because calling program is */
	        /* to lazy to compute it */
	        /* mp3size = size of data written to buffer so far */
	        /* mp3buf_size-mp3size = amount of space avalable */

	        var buf_size = mp3buf_size - mp3size;
	        if (mp3buf_size == 0) buf_size = 0;
	        ret = lame_encode_frame(gfp, mfbuf[0], mfbuf[1], mp3buf, mp3bufPos, buf_size);
	        if (ret < 0) return ret;
	        mp3bufPos += ret;
	        mp3size += ret;

	        /* shift out old samples */
	        gfc.mf_size -= gfp.framesize;
	        gfc.mf_samples_to_encode -= gfp.framesize;
	        for (ch = 0; ch < gfc.channels_out; ch++) for (i = 0; i < gfc.mf_size; i++) mfbuf[ch][i] = mfbuf[ch][i + gfp.framesize];
	      }
	    }
	    return mp3size;
	  }
	  function lame_encode_frame(gfp, inbuf_l, inbuf_r, mp3buf, mp3bufPos, mp3buf_size) {
	    var ret = self.enc.lame_encode_mp3_frame(gfp, inbuf_l, inbuf_r, mp3buf, mp3bufPos, mp3buf_size);
	    gfp.frameNum++;
	    return ret;
	  }
	  function InOut() {
	    this.n_in = 0;
	    this.n_out = 0;
	  }
	  function NumUsed() {
	    this.num_used = 0;
	  }

	  /**
	   * Greatest common divisor.
	   * <p>
	   * Joint work of Euclid and M. Hendry
	   */
	  function gcd(i, j) {
	    return j != 0 ? gcd(j, i % j) : i;
	  }

	  /**
	   * Resampling via FIR filter, blackman window.
	   */
	  function blackman(x, fcn, l) {
	    /*
	     * This algorithm from: SIGNAL PROCESSING ALGORITHMS IN FORTRAN AND C
	     * S.D. Stearns and R.A. David, Prentice-Hall, 1992
	     */
	    var wcn = Math.PI * fcn;
	    x /= l;
	    if (x < 0) x = 0;
	    if (x > 1) x = 1;
	    var x2 = x - .5;
	    var bkwn = 0.42 - 0.5 * Math.cos(2 * x * Math.PI) + 0.08 * Math.cos(4 * x * Math.PI);
	    if (Math.abs(x2) < 1e-9) return wcn / Math.PI;else return bkwn * Math.sin(l * wcn * x2) / (Math.PI * l * x2);
	  }
	  function fill_buffer_resample(gfp, outbuf, outbufPos, desired_len, inbuf, in_bufferPos, len, num_used, ch) {
	    var gfc = gfp.internal_flags;
	    var i,
	      j = 0,
	      k;
	    /* number of convolution functions to pre-compute */
	    var bpc = gfp.out_samplerate / gcd(gfp.out_samplerate, gfp.in_samplerate);
	    if (bpc > LameInternalFlags.BPC) bpc = LameInternalFlags.BPC;
	    var intratio = Math.abs(gfc.resample_ratio - Math.floor(.5 + gfc.resample_ratio)) < .0001 ? 1 : 0;
	    var fcn = 1.00 / gfc.resample_ratio;
	    if (fcn > 1.00) fcn = 1.00;
	    var filter_l = 31;
	    if (0 == filter_l % 2) --filter_l;
	    /* must be odd */
	    filter_l += intratio;
	    /* unless resample_ratio=int, it must be even */

	    var BLACKSIZE = filter_l + 1;
	    /* size of data needed for FIR */

	    if (gfc.fill_buffer_resample_init == 0) {
	      gfc.inbuf_old[0] = new_float(BLACKSIZE);
	      gfc.inbuf_old[1] = new_float(BLACKSIZE);
	      for (i = 0; i <= 2 * bpc; ++i) gfc.blackfilt[i] = new_float(BLACKSIZE);
	      gfc.itime[0] = 0;
	      gfc.itime[1] = 0;

	      /* precompute blackman filter coefficients */
	      for (j = 0; j <= 2 * bpc; j++) {
	        var sum = 0.;
	        var offset = (j - bpc) / (2. * bpc);
	        for (i = 0; i <= filter_l; i++) sum += gfc.blackfilt[j][i] = blackman(i - offset, fcn, filter_l);
	        for (i = 0; i <= filter_l; i++) gfc.blackfilt[j][i] /= sum;
	      }
	      gfc.fill_buffer_resample_init = 1;
	    }
	    var inbuf_old = gfc.inbuf_old[ch];

	    /* time of j'th element in inbuf = itime + j/ifreq; */
	    /* time of k'th element in outbuf = j/ofreq */
	    for (k = 0; k < desired_len; k++) {
	      var time0;
	      var joff;
	      time0 = k * gfc.resample_ratio;
	      /* time of k'th output sample */
	      j = 0 | Math.floor(time0 - gfc.itime[ch]);

	      /* check if we need more input data */
	      if (filter_l + j - filter_l / 2 >= len) break;

	      /* blackman filter. by default, window centered at j+.5(filter_l%2) */
	      /* but we want a window centered at time0. */
	      var offset = time0 - gfc.itime[ch] - (j + .5 * (filter_l % 2));

	      /* find the closest precomputed window for this offset: */
	      joff = 0 | Math.floor(offset * 2 * bpc + bpc + .5);
	      var xvalue = 0.;
	      for (i = 0; i <= filter_l; ++i) {
	        /* force integer index */
	        var j2 = 0 | i + j - filter_l / 2;
	        var y;
	        y = j2 < 0 ? inbuf_old[BLACKSIZE + j2] : inbuf[in_bufferPos + j2];
	        xvalue += y * gfc.blackfilt[joff][i];
	      }
	      outbuf[outbufPos + k] = xvalue;
	    }

	    /* k = number of samples added to outbuf */
	    /* last k sample used data from [j-filter_l/2,j+filter_l-filter_l/2] */

	    /* how many samples of input data were used: */
	    num_used.num_used = Math.min(len, filter_l + j - filter_l / 2);

	    /*
	     * adjust our input time counter. Incriment by the number of samples
	     * used, then normalize so that next output sample is at time 0, next
	     * input buffer is at time itime[ch]
	     */
	    gfc.itime[ch] += num_used.num_used - k * gfc.resample_ratio;

	    /* save the last BLACKSIZE samples into the inbuf_old buffer */
	    if (num_used.num_used >= BLACKSIZE) {
	      for (i = 0; i < BLACKSIZE; i++) inbuf_old[i] = inbuf[in_bufferPos + num_used.num_used + i - BLACKSIZE];
	    } else {
	      /* shift in num_used.num_used samples into inbuf_old */
	      var n_shift = BLACKSIZE - num_used.num_used;
	      /*
	       * number of samples to
	       * shift
	       */

	      /*
	       * shift n_shift samples by num_used.num_used, to make room for the
	       * num_used new samples
	       */
	      for (i = 0; i < n_shift; ++i) inbuf_old[i] = inbuf_old[i + num_used.num_used];

	      /* shift in the num_used.num_used samples */
	      for (j = 0; i < BLACKSIZE; ++i, ++j) inbuf_old[i] = inbuf[in_bufferPos + j];
	      assert(j == num_used.num_used);
	    }
	    return k;
	    /* return the number samples created at the new samplerate */
	  }
	  function fill_buffer(gfp, mfbuf, in_buffer, in_bufferPos, nsamples, io) {
	    var gfc = gfp.internal_flags;

	    /* copy in new samples into mfbuf, with resampling if necessary */
	    if (gfc.resample_ratio < .9999 || gfc.resample_ratio > 1.0001) {
	      for (var ch = 0; ch < gfc.channels_out; ch++) {
	        var numUsed = new NumUsed();
	        io.n_out = fill_buffer_resample(gfp, mfbuf[ch], gfc.mf_size, gfp.framesize, in_buffer[ch], in_bufferPos, nsamples, numUsed, ch);
	        io.n_in = numUsed.num_used;
	      }
	    } else {
	      io.n_out = Math.min(gfp.framesize, nsamples);
	      io.n_in = io.n_out;
	      for (var i = 0; i < io.n_out; ++i) {
	        mfbuf[0][gfc.mf_size + i] = in_buffer[0][in_bufferPos + i];
	        if (gfc.channels_out == 2) mfbuf[1][gfc.mf_size + i] = in_buffer[1][in_bufferPos + i];
	      }
	    }
	  }
	}
	Lame_1 = Lame;
	return Lame_1;
}

/*
 * MP3 quantization
 *
 *      Copyright (c) 1999-2000 Mark Taylor
 *      Copyright (c) 1999-2003 Takehiro Tominaga
 *      Copyright (c) 2000-2007 Robert Hegemann
 *      Copyright (c) 2001-2005 Gabriel Bouvigne
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.     See the GNU
 * Library General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public
 * License along with this library; if not, write to the
 * Free Software Foundation, Inc., 59 Temple Place - Suite 330,
 * Boston, MA 02111-1307, USA.
 */
requireEncoder();

requireLame();
requireQuantizePVT();
requireTakehiro();
requireBitStream();
requireEncoder();
function WavHeader() {
  this.dataOffset = 0;
  this.dataLen = 0;
  this.channels = 0;
  this.sampleRate = 0;
}
function fourccToInt(fourcc) {
  return fourcc.charCodeAt(0) << 24 | fourcc.charCodeAt(1) << 16 | fourcc.charCodeAt(2) << 8 | fourcc.charCodeAt(3);
}
WavHeader.RIFF = fourccToInt("RIFF");
WavHeader.WAVE = fourccToInt("WAVE");
WavHeader.fmt_ = fourccToInt("fmt ");
WavHeader.data = fourccToInt("data");
WavHeader.readHeader = function (dataView) {
  var w = new WavHeader();
  var header = dataView.getUint32(0, false);
  if (WavHeader.RIFF != header) {
    return;
  }
  dataView.getUint32(4, true);
  if (WavHeader.WAVE != dataView.getUint32(8, false)) {
    return;
  }
  if (WavHeader.fmt_ != dataView.getUint32(12, false)) {
    return;
  }
  var fmtLen = dataView.getUint32(16, true);
  var pos = 16 + 4;
  switch (fmtLen) {
    case 16:
    case 18:
      w.channels = dataView.getUint16(pos + 2, true);
      w.sampleRate = dataView.getUint32(pos + 4, true);
      break;
    default:
      throw 'extended fmt chunk not implemented';
  }
  pos += fmtLen;
  var data = WavHeader.data;
  var len = 0;
  while (data != header) {
    header = dataView.getUint32(pos, false);
    len = dataView.getUint32(pos + 4, true);
    if (data == header) {
      break;
    }
    pos += len + 8;
  }
  w.dataLen = len;
  w.dataOffset = pos + 8;
  return w;
};

// Returns Uint8Array of WAV bytes
function getWavBytes(buffer, options) {
  const type = options.isFloat ? Float32Array : Uint16Array;
  const numFrames = buffer.byteLength / type.BYTES_PER_ELEMENT;
  const headerBytes = getWavHeader(Object.assign({}, options, {
    numFrames
  }));
  const wavBytes = new Uint8Array(headerBytes.length + buffer.byteLength);

  // prepend header, then add pcmBytes
  wavBytes.set(headerBytes, 0);
  wavBytes.set(new Uint8Array(buffer), headerBytes.length);
  return wavBytes;
}

// adapted from https://gist.github.com/also/900023
// returns Uint8Array of WAV header bytes
function getWavHeader(options) {
  const numFrames = options.numFrames;
  const numChannels = options.numChannels || 2;
  const sampleRate = options.sampleRate || 44100;
  const bytesPerSample = options.isFloat ? 4 : 2;
  const format = options.isFloat ? 3 : 1;
  const blockAlign = numChannels * bytesPerSample;
  const byteRate = sampleRate * blockAlign;
  const dataSize = numFrames * blockAlign;
  const buffer = new ArrayBuffer(44);
  const dv = new DataView(buffer);
  let p = 0;
  function writeString(s) {
    for (let i = 0; i < s.length; i++) {
      dv.setUint8(p + i, s.charCodeAt(i));
    }
    p += s.length;
  }
  function writeUint32(d) {
    dv.setUint32(p, d, true);
    p += 4;
  }
  function writeUint16(d) {
    dv.setUint16(p, d, true);
    p += 2;
  }
  writeString("RIFF"); // ChunkID
  writeUint32(dataSize + 36); // ChunkSize
  writeString("WAVE"); // Format
  writeString("fmt "); // Subchunk1ID
  writeUint32(16); // Subchunk1Size
  writeUint16(format); // AudioFormat
  writeUint16(numChannels); // NumChannels
  writeUint32(sampleRate); // SampleRate
  writeUint32(byteRate); // ByteRate
  writeUint16(blockAlign); // BlockAlign
  writeUint16(bytesPerSample * 8); // BitsPerSample
  writeString("data"); // Subchunk2ID
  writeUint32(dataSize); // Subchunk2Size

  return new Uint8Array(buffer);
}

function commonjsRequire(path) {
	throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}

var localforage$1 = {exports: {}};

/*!
    localForage -- Offline Storage, Improved
    Version 1.10.0
    https://localforage.github.io/localForage
    (c) 2013-2017 Mozilla, Apache License 2.0
*/

(function (module, exports) {
	(function (f) {
	  {
	    module.exports = f();
	  }
	})(function () {
	  return function e(t, n, r) {
	    function s(o, u) {
	      if (!n[o]) {
	        if (!t[o]) {
	          var a = typeof commonjsRequire == "function" && commonjsRequire;
	          if (!u && a) return a(o, !0);
	          if (i) return i(o, !0);
	          var f = new Error("Cannot find module '" + o + "'");
	          throw f.code = "MODULE_NOT_FOUND", f;
	        }
	        var l = n[o] = {
	          exports: {}
	        };
	        t[o][0].call(l.exports, function (e) {
	          var n = t[o][1][e];
	          return s(n ? n : e);
	        }, l, l.exports, e, t, n, r);
	      }
	      return n[o].exports;
	    }
	    var i = typeof commonjsRequire == "function" && commonjsRequire;
	    for (var o = 0; o < r.length; o++) s(r[o]);
	    return s;
	  }({
	    1: [function (_dereq_, module, exports) {
	      (function (global) {

	        var Mutation = global.MutationObserver || global.WebKitMutationObserver;
	        var scheduleDrain;
	        {
	          if (Mutation) {
	            var called = 0;
	            var observer = new Mutation(nextTick);
	            var element = global.document.createTextNode('');
	            observer.observe(element, {
	              characterData: true
	            });
	            scheduleDrain = function () {
	              element.data = called = ++called % 2;
	            };
	          } else if (!global.setImmediate && typeof global.MessageChannel !== 'undefined') {
	            var channel = new global.MessageChannel();
	            channel.port1.onmessage = nextTick;
	            scheduleDrain = function () {
	              channel.port2.postMessage(0);
	            };
	          } else if ('document' in global && 'onreadystatechange' in global.document.createElement('script')) {
	            scheduleDrain = function () {
	              // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	              // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	              var scriptEl = global.document.createElement('script');
	              scriptEl.onreadystatechange = function () {
	                nextTick();
	                scriptEl.onreadystatechange = null;
	                scriptEl.parentNode.removeChild(scriptEl);
	                scriptEl = null;
	              };
	              global.document.documentElement.appendChild(scriptEl);
	            };
	          } else {
	            scheduleDrain = function () {
	              setTimeout(nextTick, 0);
	            };
	          }
	        }
	        var draining;
	        var queue = [];
	        //named nextTick for less confusing stack traces
	        function nextTick() {
	          draining = true;
	          var i, oldQueue;
	          var len = queue.length;
	          while (len) {
	            oldQueue = queue;
	            queue = [];
	            i = -1;
	            while (++i < len) {
	              oldQueue[i]();
	            }
	            len = queue.length;
	          }
	          draining = false;
	        }
	        module.exports = immediate;
	        function immediate(task) {
	          if (queue.push(task) === 1 && !draining) {
	            scheduleDrain();
	          }
	        }
	      }).call(this, typeof commonjsGlobal$1 !== "undefined" ? commonjsGlobal$1 : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
	    }, {}],
	    2: [function (_dereq_, module, exports) {

	      var immediate = _dereq_(1);

	      /* istanbul ignore next */
	      function INTERNAL() {}
	      var handlers = {};
	      var REJECTED = ['REJECTED'];
	      var FULFILLED = ['FULFILLED'];
	      var PENDING = ['PENDING'];
	      module.exports = Promise;
	      function Promise(resolver) {
	        if (typeof resolver !== 'function') {
	          throw new TypeError('resolver must be a function');
	        }
	        this.state = PENDING;
	        this.queue = [];
	        this.outcome = void 0;
	        if (resolver !== INTERNAL) {
	          safelyResolveThenable(this, resolver);
	        }
	      }
	      Promise.prototype["catch"] = function (onRejected) {
	        return this.then(null, onRejected);
	      };
	      Promise.prototype.then = function (onFulfilled, onRejected) {
	        if (typeof onFulfilled !== 'function' && this.state === FULFILLED || typeof onRejected !== 'function' && this.state === REJECTED) {
	          return this;
	        }
	        var promise = new this.constructor(INTERNAL);
	        if (this.state !== PENDING) {
	          var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
	          unwrap(promise, resolver, this.outcome);
	        } else {
	          this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
	        }
	        return promise;
	      };
	      function QueueItem(promise, onFulfilled, onRejected) {
	        this.promise = promise;
	        if (typeof onFulfilled === 'function') {
	          this.onFulfilled = onFulfilled;
	          this.callFulfilled = this.otherCallFulfilled;
	        }
	        if (typeof onRejected === 'function') {
	          this.onRejected = onRejected;
	          this.callRejected = this.otherCallRejected;
	        }
	      }
	      QueueItem.prototype.callFulfilled = function (value) {
	        handlers.resolve(this.promise, value);
	      };
	      QueueItem.prototype.otherCallFulfilled = function (value) {
	        unwrap(this.promise, this.onFulfilled, value);
	      };
	      QueueItem.prototype.callRejected = function (value) {
	        handlers.reject(this.promise, value);
	      };
	      QueueItem.prototype.otherCallRejected = function (value) {
	        unwrap(this.promise, this.onRejected, value);
	      };
	      function unwrap(promise, func, value) {
	        immediate(function () {
	          var returnValue;
	          try {
	            returnValue = func(value);
	          } catch (e) {
	            return handlers.reject(promise, e);
	          }
	          if (returnValue === promise) {
	            handlers.reject(promise, new TypeError('Cannot resolve promise with itself'));
	          } else {
	            handlers.resolve(promise, returnValue);
	          }
	        });
	      }
	      handlers.resolve = function (self, value) {
	        var result = tryCatch(getThen, value);
	        if (result.status === 'error') {
	          return handlers.reject(self, result.value);
	        }
	        var thenable = result.value;
	        if (thenable) {
	          safelyResolveThenable(self, thenable);
	        } else {
	          self.state = FULFILLED;
	          self.outcome = value;
	          var i = -1;
	          var len = self.queue.length;
	          while (++i < len) {
	            self.queue[i].callFulfilled(value);
	          }
	        }
	        return self;
	      };
	      handlers.reject = function (self, error) {
	        self.state = REJECTED;
	        self.outcome = error;
	        var i = -1;
	        var len = self.queue.length;
	        while (++i < len) {
	          self.queue[i].callRejected(error);
	        }
	        return self;
	      };
	      function getThen(obj) {
	        // Make sure we only access the accessor once as required by the spec
	        var then = obj && obj.then;
	        if (obj && (typeof obj === 'object' || typeof obj === 'function') && typeof then === 'function') {
	          return function appyThen() {
	            then.apply(obj, arguments);
	          };
	        }
	      }
	      function safelyResolveThenable(self, thenable) {
	        // Either fulfill, reject or reject with error
	        var called = false;
	        function onError(value) {
	          if (called) {
	            return;
	          }
	          called = true;
	          handlers.reject(self, value);
	        }
	        function onSuccess(value) {
	          if (called) {
	            return;
	          }
	          called = true;
	          handlers.resolve(self, value);
	        }
	        function tryToUnwrap() {
	          thenable(onSuccess, onError);
	        }
	        var result = tryCatch(tryToUnwrap);
	        if (result.status === 'error') {
	          onError(result.value);
	        }
	      }
	      function tryCatch(func, value) {
	        var out = {};
	        try {
	          out.value = func(value);
	          out.status = 'success';
	        } catch (e) {
	          out.status = 'error';
	          out.value = e;
	        }
	        return out;
	      }
	      Promise.resolve = resolve;
	      function resolve(value) {
	        if (value instanceof this) {
	          return value;
	        }
	        return handlers.resolve(new this(INTERNAL), value);
	      }
	      Promise.reject = reject;
	      function reject(reason) {
	        var promise = new this(INTERNAL);
	        return handlers.reject(promise, reason);
	      }
	      Promise.all = all;
	      function all(iterable) {
	        var self = this;
	        if (Object.prototype.toString.call(iterable) !== '[object Array]') {
	          return this.reject(new TypeError('must be an array'));
	        }
	        var len = iterable.length;
	        var called = false;
	        if (!len) {
	          return this.resolve([]);
	        }
	        var values = new Array(len);
	        var resolved = 0;
	        var i = -1;
	        var promise = new this(INTERNAL);
	        while (++i < len) {
	          allResolver(iterable[i], i);
	        }
	        return promise;
	        function allResolver(value, i) {
	          self.resolve(value).then(resolveFromAll, function (error) {
	            if (!called) {
	              called = true;
	              handlers.reject(promise, error);
	            }
	          });
	          function resolveFromAll(outValue) {
	            values[i] = outValue;
	            if (++resolved === len && !called) {
	              called = true;
	              handlers.resolve(promise, values);
	            }
	          }
	        }
	      }
	      Promise.race = race;
	      function race(iterable) {
	        var self = this;
	        if (Object.prototype.toString.call(iterable) !== '[object Array]') {
	          return this.reject(new TypeError('must be an array'));
	        }
	        var len = iterable.length;
	        var called = false;
	        if (!len) {
	          return this.resolve([]);
	        }
	        var i = -1;
	        var promise = new this(INTERNAL);
	        while (++i < len) {
	          resolver(iterable[i]);
	        }
	        return promise;
	        function resolver(value) {
	          self.resolve(value).then(function (response) {
	            if (!called) {
	              called = true;
	              handlers.resolve(promise, response);
	            }
	          }, function (error) {
	            if (!called) {
	              called = true;
	              handlers.reject(promise, error);
	            }
	          });
	        }
	      }
	    }, {
	      "1": 1
	    }],
	    3: [function (_dereq_, module, exports) {
	      (function (global) {

	        if (typeof global.Promise !== 'function') {
	          global.Promise = _dereq_(2);
	        }
	      }).call(this, typeof commonjsGlobal$1 !== "undefined" ? commonjsGlobal$1 : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
	    }, {
	      "2": 2
	    }],
	    4: [function (_dereq_, module, exports) {

	      var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	        return typeof obj;
	      } : function (obj) {
	        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	      };
	      function _classCallCheck(instance, Constructor) {
	        if (!(instance instanceof Constructor)) {
	          throw new TypeError("Cannot call a class as a function");
	        }
	      }
	      function getIDB() {
	        /* global indexedDB,webkitIndexedDB,mozIndexedDB,OIndexedDB,msIndexedDB */
	        try {
	          if (typeof indexedDB !== 'undefined') {
	            return indexedDB;
	          }
	          if (typeof webkitIndexedDB !== 'undefined') {
	            return webkitIndexedDB;
	          }
	          if (typeof mozIndexedDB !== 'undefined') {
	            return mozIndexedDB;
	          }
	          if (typeof OIndexedDB !== 'undefined') {
	            return OIndexedDB;
	          }
	          if (typeof msIndexedDB !== 'undefined') {
	            return msIndexedDB;
	          }
	        } catch (e) {
	          return;
	        }
	      }
	      var idb = getIDB();
	      function isIndexedDBValid() {
	        try {
	          // Initialize IndexedDB; fall back to vendor-prefixed versions
	          // if needed.
	          if (!idb || !idb.open) {
	            return false;
	          }
	          // We mimic PouchDB here;
	          //
	          // We test for openDatabase because IE Mobile identifies itself
	          // as Safari. Oh the lulz...
	          var isSafari = typeof openDatabase !== 'undefined' && /(Safari|iPhone|iPad|iPod)/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !/BlackBerry/.test(navigator.platform);
	          var hasFetch = typeof fetch === 'function' && fetch.toString().indexOf('[native code') !== -1;

	          // Safari <10.1 does not meet our requirements for IDB support
	          // (see: https://github.com/pouchdb/pouchdb/issues/5572).
	          // Safari 10.1 shipped with fetch, we can use that to detect it.
	          // Note: this creates issues with `window.fetch` polyfills and
	          // overrides; see:
	          // https://github.com/localForage/localForage/issues/856
	          return (!isSafari || hasFetch) && typeof indexedDB !== 'undefined' &&
	          // some outdated implementations of IDB that appear on Samsung
	          // and HTC Android devices <4.4 are missing IDBKeyRange
	          // See: https://github.com/mozilla/localForage/issues/128
	          // See: https://github.com/mozilla/localForage/issues/272
	          typeof IDBKeyRange !== 'undefined';
	        } catch (e) {
	          return false;
	        }
	      }

	      // Abstracts constructing a Blob object, so it also works in older
	      // browsers that don't support the native Blob constructor. (i.e.
	      // old QtWebKit versions, at least).
	      // Abstracts constructing a Blob object, so it also works in older
	      // browsers that don't support the native Blob constructor. (i.e.
	      // old QtWebKit versions, at least).
	      function createBlob(parts, properties) {
	        /* global BlobBuilder,MSBlobBuilder,MozBlobBuilder,WebKitBlobBuilder */
	        parts = parts || [];
	        properties = properties || {};
	        try {
	          return new Blob(parts, properties);
	        } catch (e) {
	          if (e.name !== 'TypeError') {
	            throw e;
	          }
	          var Builder = typeof BlobBuilder !== 'undefined' ? BlobBuilder : typeof MSBlobBuilder !== 'undefined' ? MSBlobBuilder : typeof MozBlobBuilder !== 'undefined' ? MozBlobBuilder : WebKitBlobBuilder;
	          var builder = new Builder();
	          for (var i = 0; i < parts.length; i += 1) {
	            builder.append(parts[i]);
	          }
	          return builder.getBlob(properties.type);
	        }
	      }

	      // This is CommonJS because lie is an external dependency, so Rollup
	      // can just ignore it.
	      if (typeof Promise === 'undefined') {
	        // In the "nopromises" build this will just throw if you don't have
	        // a global promise object, but it would throw anyway later.
	        _dereq_(3);
	      }
	      var Promise$1 = Promise;
	      function executeCallback(promise, callback) {
	        if (callback) {
	          promise.then(function (result) {
	            callback(null, result);
	          }, function (error) {
	            callback(error);
	          });
	        }
	      }
	      function executeTwoCallbacks(promise, callback, errorCallback) {
	        if (typeof callback === 'function') {
	          promise.then(callback);
	        }
	        if (typeof errorCallback === 'function') {
	          promise["catch"](errorCallback);
	        }
	      }
	      function normalizeKey(key) {
	        // Cast the key to a string, as that's all we can set as a key.
	        if (typeof key !== 'string') {
	          console.warn(key + ' used as a key, but it is not a string.');
	          key = String(key);
	        }
	        return key;
	      }
	      function getCallback() {
	        if (arguments.length && typeof arguments[arguments.length - 1] === 'function') {
	          return arguments[arguments.length - 1];
	        }
	      }

	      // Some code originally from async_storage.js in
	      // [Gaia](https://github.com/mozilla-b2g/gaia).

	      var DETECT_BLOB_SUPPORT_STORE = 'local-forage-detect-blob-support';
	      var supportsBlobs = void 0;
	      var dbContexts = {};
	      var toString = Object.prototype.toString;

	      // Transaction Modes
	      var READ_ONLY = 'readonly';
	      var READ_WRITE = 'readwrite';

	      // Transform a binary string to an array buffer, because otherwise
	      // weird stuff happens when you try to work with the binary string directly.
	      // It is known.
	      // From http://stackoverflow.com/questions/14967647/ (continues on next line)
	      // encode-decode-image-with-base64-breaks-image (2013-04-21)
	      function _binStringToArrayBuffer(bin) {
	        var length = bin.length;
	        var buf = new ArrayBuffer(length);
	        var arr = new Uint8Array(buf);
	        for (var i = 0; i < length; i++) {
	          arr[i] = bin.charCodeAt(i);
	        }
	        return buf;
	      }

	      //
	      // Blobs are not supported in all versions of IndexedDB, notably
	      // Chrome <37 and Android <5. In those versions, storing a blob will throw.
	      //
	      // Various other blob bugs exist in Chrome v37-42 (inclusive).
	      // Detecting them is expensive and confusing to users, and Chrome 37-42
	      // is at very low usage worldwide, so we do a hacky userAgent check instead.
	      //
	      // content-type bug: https://code.google.com/p/chromium/issues/detail?id=408120
	      // 404 bug: https://code.google.com/p/chromium/issues/detail?id=447916
	      // FileReader bug: https://code.google.com/p/chromium/issues/detail?id=447836
	      //
	      // Code borrowed from PouchDB. See:
	      // https://github.com/pouchdb/pouchdb/blob/master/packages/node_modules/pouchdb-adapter-idb/src/blobSupport.js
	      //
	      function _checkBlobSupportWithoutCaching(idb) {
	        return new Promise$1(function (resolve) {
	          var txn = idb.transaction(DETECT_BLOB_SUPPORT_STORE, READ_WRITE);
	          var blob = createBlob(['']);
	          txn.objectStore(DETECT_BLOB_SUPPORT_STORE).put(blob, 'key');
	          txn.onabort = function (e) {
	            // If the transaction aborts now its due to not being able to
	            // write to the database, likely due to the disk being full
	            e.preventDefault();
	            e.stopPropagation();
	            resolve(false);
	          };
	          txn.oncomplete = function () {
	            var matchedChrome = navigator.userAgent.match(/Chrome\/(\d+)/);
	            var matchedEdge = navigator.userAgent.match(/Edge\//);
	            // MS Edge pretends to be Chrome 42:
	            // https://msdn.microsoft.com/en-us/library/hh869301%28v=vs.85%29.aspx
	            resolve(matchedEdge || !matchedChrome || parseInt(matchedChrome[1], 10) >= 43);
	          };
	        })["catch"](function () {
	          return false; // error, so assume unsupported
	        });
	      }
	      function _checkBlobSupport(idb) {
	        if (typeof supportsBlobs === 'boolean') {
	          return Promise$1.resolve(supportsBlobs);
	        }
	        return _checkBlobSupportWithoutCaching(idb).then(function (value) {
	          supportsBlobs = value;
	          return supportsBlobs;
	        });
	      }
	      function _deferReadiness(dbInfo) {
	        var dbContext = dbContexts[dbInfo.name];

	        // Create a deferred object representing the current database operation.
	        var deferredOperation = {};
	        deferredOperation.promise = new Promise$1(function (resolve, reject) {
	          deferredOperation.resolve = resolve;
	          deferredOperation.reject = reject;
	        });

	        // Enqueue the deferred operation.
	        dbContext.deferredOperations.push(deferredOperation);

	        // Chain its promise to the database readiness.
	        if (!dbContext.dbReady) {
	          dbContext.dbReady = deferredOperation.promise;
	        } else {
	          dbContext.dbReady = dbContext.dbReady.then(function () {
	            return deferredOperation.promise;
	          });
	        }
	      }
	      function _advanceReadiness(dbInfo) {
	        var dbContext = dbContexts[dbInfo.name];

	        // Dequeue a deferred operation.
	        var deferredOperation = dbContext.deferredOperations.pop();

	        // Resolve its promise (which is part of the database readiness
	        // chain of promises).
	        if (deferredOperation) {
	          deferredOperation.resolve();
	          return deferredOperation.promise;
	        }
	      }
	      function _rejectReadiness(dbInfo, err) {
	        var dbContext = dbContexts[dbInfo.name];

	        // Dequeue a deferred operation.
	        var deferredOperation = dbContext.deferredOperations.pop();

	        // Reject its promise (which is part of the database readiness
	        // chain of promises).
	        if (deferredOperation) {
	          deferredOperation.reject(err);
	          return deferredOperation.promise;
	        }
	      }
	      function _getConnection(dbInfo, upgradeNeeded) {
	        return new Promise$1(function (resolve, reject) {
	          dbContexts[dbInfo.name] = dbContexts[dbInfo.name] || createDbContext();
	          if (dbInfo.db) {
	            if (upgradeNeeded) {
	              _deferReadiness(dbInfo);
	              dbInfo.db.close();
	            } else {
	              return resolve(dbInfo.db);
	            }
	          }
	          var dbArgs = [dbInfo.name];
	          if (upgradeNeeded) {
	            dbArgs.push(dbInfo.version);
	          }
	          var openreq = idb.open.apply(idb, dbArgs);
	          if (upgradeNeeded) {
	            openreq.onupgradeneeded = function (e) {
	              var db = openreq.result;
	              try {
	                db.createObjectStore(dbInfo.storeName);
	                if (e.oldVersion <= 1) {
	                  // Added when support for blob shims was added
	                  db.createObjectStore(DETECT_BLOB_SUPPORT_STORE);
	                }
	              } catch (ex) {
	                if (ex.name === 'ConstraintError') {
	                  console.warn('The database "' + dbInfo.name + '"' + ' has been upgraded from version ' + e.oldVersion + ' to version ' + e.newVersion + ', but the storage "' + dbInfo.storeName + '" already exists.');
	                } else {
	                  throw ex;
	                }
	              }
	            };
	          }
	          openreq.onerror = function (e) {
	            e.preventDefault();
	            reject(openreq.error);
	          };
	          openreq.onsuccess = function () {
	            var db = openreq.result;
	            db.onversionchange = function (e) {
	              // Triggered when the database is modified (e.g. adding an objectStore) or
	              // deleted (even when initiated by other sessions in different tabs).
	              // Closing the connection here prevents those operations from being blocked.
	              // If the database is accessed again later by this instance, the connection
	              // will be reopened or the database recreated as needed.
	              e.target.close();
	            };
	            resolve(db);
	            _advanceReadiness(dbInfo);
	          };
	        });
	      }
	      function _getOriginalConnection(dbInfo) {
	        return _getConnection(dbInfo, false);
	      }
	      function _getUpgradedConnection(dbInfo) {
	        return _getConnection(dbInfo, true);
	      }
	      function _isUpgradeNeeded(dbInfo, defaultVersion) {
	        if (!dbInfo.db) {
	          return true;
	        }
	        var isNewStore = !dbInfo.db.objectStoreNames.contains(dbInfo.storeName);
	        var isDowngrade = dbInfo.version < dbInfo.db.version;
	        var isUpgrade = dbInfo.version > dbInfo.db.version;
	        if (isDowngrade) {
	          // If the version is not the default one
	          // then warn for impossible downgrade.
	          if (dbInfo.version !== defaultVersion) {
	            console.warn('The database "' + dbInfo.name + '"' + " can't be downgraded from version " + dbInfo.db.version + ' to version ' + dbInfo.version + '.');
	          }
	          // Align the versions to prevent errors.
	          dbInfo.version = dbInfo.db.version;
	        }
	        if (isUpgrade || isNewStore) {
	          // If the store is new then increment the version (if needed).
	          // This will trigger an "upgradeneeded" event which is required
	          // for creating a store.
	          if (isNewStore) {
	            var incVersion = dbInfo.db.version + 1;
	            if (incVersion > dbInfo.version) {
	              dbInfo.version = incVersion;
	            }
	          }
	          return true;
	        }
	        return false;
	      }

	      // encode a blob for indexeddb engines that don't support blobs
	      function _encodeBlob(blob) {
	        return new Promise$1(function (resolve, reject) {
	          var reader = new FileReader();
	          reader.onerror = reject;
	          reader.onloadend = function (e) {
	            var base64 = btoa(e.target.result || '');
	            resolve({
	              __local_forage_encoded_blob: true,
	              data: base64,
	              type: blob.type
	            });
	          };
	          reader.readAsBinaryString(blob);
	        });
	      }

	      // decode an encoded blob
	      function _decodeBlob(encodedBlob) {
	        var arrayBuff = _binStringToArrayBuffer(atob(encodedBlob.data));
	        return createBlob([arrayBuff], {
	          type: encodedBlob.type
	        });
	      }

	      // is this one of our fancy encoded blobs?
	      function _isEncodedBlob(value) {
	        return value && value.__local_forage_encoded_blob;
	      }

	      // Specialize the default `ready()` function by making it dependent
	      // on the current database operations. Thus, the driver will be actually
	      // ready when it's been initialized (default) *and* there are no pending
	      // operations on the database (initiated by some other instances).
	      function _fullyReady(callback) {
	        var self = this;
	        var promise = self._initReady().then(function () {
	          var dbContext = dbContexts[self._dbInfo.name];
	          if (dbContext && dbContext.dbReady) {
	            return dbContext.dbReady;
	          }
	        });
	        executeTwoCallbacks(promise, callback, callback);
	        return promise;
	      }

	      // Try to establish a new db connection to replace the
	      // current one which is broken (i.e. experiencing
	      // InvalidStateError while creating a transaction).
	      function _tryReconnect(dbInfo) {
	        _deferReadiness(dbInfo);
	        var dbContext = dbContexts[dbInfo.name];
	        var forages = dbContext.forages;
	        for (var i = 0; i < forages.length; i++) {
	          var forage = forages[i];
	          if (forage._dbInfo.db) {
	            forage._dbInfo.db.close();
	            forage._dbInfo.db = null;
	          }
	        }
	        dbInfo.db = null;
	        return _getOriginalConnection(dbInfo).then(function (db) {
	          dbInfo.db = db;
	          if (_isUpgradeNeeded(dbInfo)) {
	            // Reopen the database for upgrading.
	            return _getUpgradedConnection(dbInfo);
	          }
	          return db;
	        }).then(function (db) {
	          // store the latest db reference
	          // in case the db was upgraded
	          dbInfo.db = dbContext.db = db;
	          for (var i = 0; i < forages.length; i++) {
	            forages[i]._dbInfo.db = db;
	          }
	        })["catch"](function (err) {
	          _rejectReadiness(dbInfo, err);
	          throw err;
	        });
	      }

	      // FF doesn't like Promises (micro-tasks) and IDDB store operations,
	      // so we have to do it with callbacks
	      function createTransaction(dbInfo, mode, callback, retries) {
	        if (retries === undefined) {
	          retries = 1;
	        }
	        try {
	          var tx = dbInfo.db.transaction(dbInfo.storeName, mode);
	          callback(null, tx);
	        } catch (err) {
	          if (retries > 0 && (!dbInfo.db || err.name === 'InvalidStateError' || err.name === 'NotFoundError')) {
	            return Promise$1.resolve().then(function () {
	              if (!dbInfo.db || err.name === 'NotFoundError' && !dbInfo.db.objectStoreNames.contains(dbInfo.storeName) && dbInfo.version <= dbInfo.db.version) {
	                // increase the db version, to create the new ObjectStore
	                if (dbInfo.db) {
	                  dbInfo.version = dbInfo.db.version + 1;
	                }
	                // Reopen the database for upgrading.
	                return _getUpgradedConnection(dbInfo);
	              }
	            }).then(function () {
	              return _tryReconnect(dbInfo).then(function () {
	                createTransaction(dbInfo, mode, callback, retries - 1);
	              });
	            })["catch"](callback);
	          }
	          callback(err);
	        }
	      }
	      function createDbContext() {
	        return {
	          // Running localForages sharing a database.
	          forages: [],
	          // Shared database.
	          db: null,
	          // Database readiness (promise).
	          dbReady: null,
	          // Deferred operations on the database.
	          deferredOperations: []
	        };
	      }

	      // Open the IndexedDB database (automatically creates one if one didn't
	      // previously exist), using any options set in the config.
	      function _initStorage(options) {
	        var self = this;
	        var dbInfo = {
	          db: null
	        };
	        if (options) {
	          for (var i in options) {
	            dbInfo[i] = options[i];
	          }
	        }

	        // Get the current context of the database;
	        var dbContext = dbContexts[dbInfo.name];

	        // ...or create a new context.
	        if (!dbContext) {
	          dbContext = createDbContext();
	          // Register the new context in the global container.
	          dbContexts[dbInfo.name] = dbContext;
	        }

	        // Register itself as a running localForage in the current context.
	        dbContext.forages.push(self);

	        // Replace the default `ready()` function with the specialized one.
	        if (!self._initReady) {
	          self._initReady = self.ready;
	          self.ready = _fullyReady;
	        }

	        // Create an array of initialization states of the related localForages.
	        var initPromises = [];
	        function ignoreErrors() {
	          // Don't handle errors here,
	          // just makes sure related localForages aren't pending.
	          return Promise$1.resolve();
	        }
	        for (var j = 0; j < dbContext.forages.length; j++) {
	          var forage = dbContext.forages[j];
	          if (forage !== self) {
	            // Don't wait for itself...
	            initPromises.push(forage._initReady()["catch"](ignoreErrors));
	          }
	        }

	        // Take a snapshot of the related localForages.
	        var forages = dbContext.forages.slice(0);

	        // Initialize the connection process only when
	        // all the related localForages aren't pending.
	        return Promise$1.all(initPromises).then(function () {
	          dbInfo.db = dbContext.db;
	          // Get the connection or open a new one without upgrade.
	          return _getOriginalConnection(dbInfo);
	        }).then(function (db) {
	          dbInfo.db = db;
	          if (_isUpgradeNeeded(dbInfo, self._defaultConfig.version)) {
	            // Reopen the database for upgrading.
	            return _getUpgradedConnection(dbInfo);
	          }
	          return db;
	        }).then(function (db) {
	          dbInfo.db = dbContext.db = db;
	          self._dbInfo = dbInfo;
	          // Share the final connection amongst related localForages.
	          for (var k = 0; k < forages.length; k++) {
	            var forage = forages[k];
	            if (forage !== self) {
	              // Self is already up-to-date.
	              forage._dbInfo.db = dbInfo.db;
	              forage._dbInfo.version = dbInfo.version;
	            }
	          }
	        });
	      }
	      function getItem(key, callback) {
	        var self = this;
	        key = normalizeKey(key);
	        var promise = new Promise$1(function (resolve, reject) {
	          self.ready().then(function () {
	            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
	              if (err) {
	                return reject(err);
	              }
	              try {
	                var store = transaction.objectStore(self._dbInfo.storeName);
	                var req = store.get(key);
	                req.onsuccess = function () {
	                  var value = req.result;
	                  if (value === undefined) {
	                    value = null;
	                  }
	                  if (_isEncodedBlob(value)) {
	                    value = _decodeBlob(value);
	                  }
	                  resolve(value);
	                };
	                req.onerror = function () {
	                  reject(req.error);
	                };
	              } catch (e) {
	                reject(e);
	              }
	            });
	          })["catch"](reject);
	        });
	        executeCallback(promise, callback);
	        return promise;
	      }

	      // Iterate over all items stored in database.
	      function iterate(iterator, callback) {
	        var self = this;
	        var promise = new Promise$1(function (resolve, reject) {
	          self.ready().then(function () {
	            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
	              if (err) {
	                return reject(err);
	              }
	              try {
	                var store = transaction.objectStore(self._dbInfo.storeName);
	                var req = store.openCursor();
	                var iterationNumber = 1;
	                req.onsuccess = function () {
	                  var cursor = req.result;
	                  if (cursor) {
	                    var value = cursor.value;
	                    if (_isEncodedBlob(value)) {
	                      value = _decodeBlob(value);
	                    }
	                    var result = iterator(value, cursor.key, iterationNumber++);

	                    // when the iterator callback returns any
	                    // (non-`undefined`) value, then we stop
	                    // the iteration immediately
	                    if (result !== void 0) {
	                      resolve(result);
	                    } else {
	                      cursor["continue"]();
	                    }
	                  } else {
	                    resolve();
	                  }
	                };
	                req.onerror = function () {
	                  reject(req.error);
	                };
	              } catch (e) {
	                reject(e);
	              }
	            });
	          })["catch"](reject);
	        });
	        executeCallback(promise, callback);
	        return promise;
	      }
	      function setItem(key, value, callback) {
	        var self = this;
	        key = normalizeKey(key);
	        var promise = new Promise$1(function (resolve, reject) {
	          var dbInfo;
	          self.ready().then(function () {
	            dbInfo = self._dbInfo;
	            if (toString.call(value) === '[object Blob]') {
	              return _checkBlobSupport(dbInfo.db).then(function (blobSupport) {
	                if (blobSupport) {
	                  return value;
	                }
	                return _encodeBlob(value);
	              });
	            }
	            return value;
	          }).then(function (value) {
	            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
	              if (err) {
	                return reject(err);
	              }
	              try {
	                var store = transaction.objectStore(self._dbInfo.storeName);

	                // The reason we don't _save_ null is because IE 10 does
	                // not support saving the `null` type in IndexedDB. How
	                // ironic, given the bug below!
	                // See: https://github.com/mozilla/localForage/issues/161
	                if (value === null) {
	                  value = undefined;
	                }
	                var req = store.put(value, key);
	                transaction.oncomplete = function () {
	                  // Cast to undefined so the value passed to
	                  // callback/promise is the same as what one would get out
	                  // of `getItem()` later. This leads to some weirdness
	                  // (setItem('foo', undefined) will return `null`), but
	                  // it's not my fault localStorage is our baseline and that
	                  // it's weird.
	                  if (value === undefined) {
	                    value = null;
	                  }
	                  resolve(value);
	                };
	                transaction.onabort = transaction.onerror = function () {
	                  var err = req.error ? req.error : req.transaction.error;
	                  reject(err);
	                };
	              } catch (e) {
	                reject(e);
	              }
	            });
	          })["catch"](reject);
	        });
	        executeCallback(promise, callback);
	        return promise;
	      }
	      function removeItem(key, callback) {
	        var self = this;
	        key = normalizeKey(key);
	        var promise = new Promise$1(function (resolve, reject) {
	          self.ready().then(function () {
	            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
	              if (err) {
	                return reject(err);
	              }
	              try {
	                var store = transaction.objectStore(self._dbInfo.storeName);
	                // We use a Grunt task to make this safe for IE and some
	                // versions of Android (including those used by Cordova).
	                // Normally IE won't like `.delete()` and will insist on
	                // using `['delete']()`, but we have a build step that
	                // fixes this for us now.
	                var req = store["delete"](key);
	                transaction.oncomplete = function () {
	                  resolve();
	                };
	                transaction.onerror = function () {
	                  reject(req.error);
	                };

	                // The request will be also be aborted if we've exceeded our storage
	                // space.
	                transaction.onabort = function () {
	                  var err = req.error ? req.error : req.transaction.error;
	                  reject(err);
	                };
	              } catch (e) {
	                reject(e);
	              }
	            });
	          })["catch"](reject);
	        });
	        executeCallback(promise, callback);
	        return promise;
	      }
	      function clear(callback) {
	        var self = this;
	        var promise = new Promise$1(function (resolve, reject) {
	          self.ready().then(function () {
	            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
	              if (err) {
	                return reject(err);
	              }
	              try {
	                var store = transaction.objectStore(self._dbInfo.storeName);
	                var req = store.clear();
	                transaction.oncomplete = function () {
	                  resolve();
	                };
	                transaction.onabort = transaction.onerror = function () {
	                  var err = req.error ? req.error : req.transaction.error;
	                  reject(err);
	                };
	              } catch (e) {
	                reject(e);
	              }
	            });
	          })["catch"](reject);
	        });
	        executeCallback(promise, callback);
	        return promise;
	      }
	      function length(callback) {
	        var self = this;
	        var promise = new Promise$1(function (resolve, reject) {
	          self.ready().then(function () {
	            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
	              if (err) {
	                return reject(err);
	              }
	              try {
	                var store = transaction.objectStore(self._dbInfo.storeName);
	                var req = store.count();
	                req.onsuccess = function () {
	                  resolve(req.result);
	                };
	                req.onerror = function () {
	                  reject(req.error);
	                };
	              } catch (e) {
	                reject(e);
	              }
	            });
	          })["catch"](reject);
	        });
	        executeCallback(promise, callback);
	        return promise;
	      }
	      function key(n, callback) {
	        var self = this;
	        var promise = new Promise$1(function (resolve, reject) {
	          if (n < 0) {
	            resolve(null);
	            return;
	          }
	          self.ready().then(function () {
	            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
	              if (err) {
	                return reject(err);
	              }
	              try {
	                var store = transaction.objectStore(self._dbInfo.storeName);
	                var advanced = false;
	                var req = store.openKeyCursor();
	                req.onsuccess = function () {
	                  var cursor = req.result;
	                  if (!cursor) {
	                    // this means there weren't enough keys
	                    resolve(null);
	                    return;
	                  }
	                  if (n === 0) {
	                    // We have the first key, return it if that's what they
	                    // wanted.
	                    resolve(cursor.key);
	                  } else {
	                    if (!advanced) {
	                      // Otherwise, ask the cursor to skip ahead n
	                      // records.
	                      advanced = true;
	                      cursor.advance(n);
	                    } else {
	                      // When we get here, we've got the nth key.
	                      resolve(cursor.key);
	                    }
	                  }
	                };
	                req.onerror = function () {
	                  reject(req.error);
	                };
	              } catch (e) {
	                reject(e);
	              }
	            });
	          })["catch"](reject);
	        });
	        executeCallback(promise, callback);
	        return promise;
	      }
	      function keys(callback) {
	        var self = this;
	        var promise = new Promise$1(function (resolve, reject) {
	          self.ready().then(function () {
	            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
	              if (err) {
	                return reject(err);
	              }
	              try {
	                var store = transaction.objectStore(self._dbInfo.storeName);
	                var req = store.openKeyCursor();
	                var keys = [];
	                req.onsuccess = function () {
	                  var cursor = req.result;
	                  if (!cursor) {
	                    resolve(keys);
	                    return;
	                  }
	                  keys.push(cursor.key);
	                  cursor["continue"]();
	                };
	                req.onerror = function () {
	                  reject(req.error);
	                };
	              } catch (e) {
	                reject(e);
	              }
	            });
	          })["catch"](reject);
	        });
	        executeCallback(promise, callback);
	        return promise;
	      }
	      function dropInstance(options, callback) {
	        callback = getCallback.apply(this, arguments);
	        var currentConfig = this.config();
	        options = typeof options !== 'function' && options || {};
	        if (!options.name) {
	          options.name = options.name || currentConfig.name;
	          options.storeName = options.storeName || currentConfig.storeName;
	        }
	        var self = this;
	        var promise;
	        if (!options.name) {
	          promise = Promise$1.reject('Invalid arguments');
	        } else {
	          var isCurrentDb = options.name === currentConfig.name && self._dbInfo.db;
	          var dbPromise = isCurrentDb ? Promise$1.resolve(self._dbInfo.db) : _getOriginalConnection(options).then(function (db) {
	            var dbContext = dbContexts[options.name];
	            var forages = dbContext.forages;
	            dbContext.db = db;
	            for (var i = 0; i < forages.length; i++) {
	              forages[i]._dbInfo.db = db;
	            }
	            return db;
	          });
	          if (!options.storeName) {
	            promise = dbPromise.then(function (db) {
	              _deferReadiness(options);
	              var dbContext = dbContexts[options.name];
	              var forages = dbContext.forages;
	              db.close();
	              for (var i = 0; i < forages.length; i++) {
	                var forage = forages[i];
	                forage._dbInfo.db = null;
	              }
	              var dropDBPromise = new Promise$1(function (resolve, reject) {
	                var req = idb.deleteDatabase(options.name);
	                req.onerror = function () {
	                  var db = req.result;
	                  if (db) {
	                    db.close();
	                  }
	                  reject(req.error);
	                };
	                req.onblocked = function () {
	                  // Closing all open connections in onversionchange handler should prevent this situation, but if
	                  // we do get here, it just means the request remains pending - eventually it will succeed or error
	                  console.warn('dropInstance blocked for database "' + options.name + '" until all open connections are closed');
	                };
	                req.onsuccess = function () {
	                  var db = req.result;
	                  if (db) {
	                    db.close();
	                  }
	                  resolve(db);
	                };
	              });
	              return dropDBPromise.then(function (db) {
	                dbContext.db = db;
	                for (var i = 0; i < forages.length; i++) {
	                  var _forage = forages[i];
	                  _advanceReadiness(_forage._dbInfo);
	                }
	              })["catch"](function (err) {
	                (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function () {});
	                throw err;
	              });
	            });
	          } else {
	            promise = dbPromise.then(function (db) {
	              if (!db.objectStoreNames.contains(options.storeName)) {
	                return;
	              }
	              var newVersion = db.version + 1;
	              _deferReadiness(options);
	              var dbContext = dbContexts[options.name];
	              var forages = dbContext.forages;
	              db.close();
	              for (var i = 0; i < forages.length; i++) {
	                var forage = forages[i];
	                forage._dbInfo.db = null;
	                forage._dbInfo.version = newVersion;
	              }
	              var dropObjectPromise = new Promise$1(function (resolve, reject) {
	                var req = idb.open(options.name, newVersion);
	                req.onerror = function (err) {
	                  var db = req.result;
	                  db.close();
	                  reject(err);
	                };
	                req.onupgradeneeded = function () {
	                  var db = req.result;
	                  db.deleteObjectStore(options.storeName);
	                };
	                req.onsuccess = function () {
	                  var db = req.result;
	                  db.close();
	                  resolve(db);
	                };
	              });
	              return dropObjectPromise.then(function (db) {
	                dbContext.db = db;
	                for (var j = 0; j < forages.length; j++) {
	                  var _forage2 = forages[j];
	                  _forage2._dbInfo.db = db;
	                  _advanceReadiness(_forage2._dbInfo);
	                }
	              })["catch"](function (err) {
	                (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function () {});
	                throw err;
	              });
	            });
	          }
	        }
	        executeCallback(promise, callback);
	        return promise;
	      }
	      var asyncStorage = {
	        _driver: 'asyncStorage',
	        _initStorage: _initStorage,
	        _support: isIndexedDBValid(),
	        iterate: iterate,
	        getItem: getItem,
	        setItem: setItem,
	        removeItem: removeItem,
	        clear: clear,
	        length: length,
	        key: key,
	        keys: keys,
	        dropInstance: dropInstance
	      };
	      function isWebSQLValid() {
	        return typeof openDatabase === 'function';
	      }

	      // Sadly, the best way to save binary data in WebSQL/localStorage is serializing
	      // it to Base64, so this is how we store it to prevent very strange errors with less
	      // verbose ways of binary <-> string data storage.
	      var BASE_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	      var BLOB_TYPE_PREFIX = '~~local_forage_type~';
	      var BLOB_TYPE_PREFIX_REGEX = /^~~local_forage_type~([^~]+)~/;
	      var SERIALIZED_MARKER = '__lfsc__:';
	      var SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER.length;

	      // OMG the serializations!
	      var TYPE_ARRAYBUFFER = 'arbf';
	      var TYPE_BLOB = 'blob';
	      var TYPE_INT8ARRAY = 'si08';
	      var TYPE_UINT8ARRAY = 'ui08';
	      var TYPE_UINT8CLAMPEDARRAY = 'uic8';
	      var TYPE_INT16ARRAY = 'si16';
	      var TYPE_INT32ARRAY = 'si32';
	      var TYPE_UINT16ARRAY = 'ur16';
	      var TYPE_UINT32ARRAY = 'ui32';
	      var TYPE_FLOAT32ARRAY = 'fl32';
	      var TYPE_FLOAT64ARRAY = 'fl64';
	      var TYPE_SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER_LENGTH + TYPE_ARRAYBUFFER.length;
	      var toString$1 = Object.prototype.toString;
	      function stringToBuffer(serializedString) {
	        // Fill the string into a ArrayBuffer.
	        var bufferLength = serializedString.length * 0.75;
	        var len = serializedString.length;
	        var i;
	        var p = 0;
	        var encoded1, encoded2, encoded3, encoded4;
	        if (serializedString[serializedString.length - 1] === '=') {
	          bufferLength--;
	          if (serializedString[serializedString.length - 2] === '=') {
	            bufferLength--;
	          }
	        }
	        var buffer = new ArrayBuffer(bufferLength);
	        var bytes = new Uint8Array(buffer);
	        for (i = 0; i < len; i += 4) {
	          encoded1 = BASE_CHARS.indexOf(serializedString[i]);
	          encoded2 = BASE_CHARS.indexOf(serializedString[i + 1]);
	          encoded3 = BASE_CHARS.indexOf(serializedString[i + 2]);
	          encoded4 = BASE_CHARS.indexOf(serializedString[i + 3]);

	          /*jslint bitwise: true */
	          bytes[p++] = encoded1 << 2 | encoded2 >> 4;
	          bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
	          bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
	        }
	        return buffer;
	      }

	      // Converts a buffer to a string to store, serialized, in the backend
	      // storage library.
	      function bufferToString(buffer) {
	        // base64-arraybuffer
	        var bytes = new Uint8Array(buffer);
	        var base64String = '';
	        var i;
	        for (i = 0; i < bytes.length; i += 3) {
	          /*jslint bitwise: true */
	          base64String += BASE_CHARS[bytes[i] >> 2];
	          base64String += BASE_CHARS[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
	          base64String += BASE_CHARS[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
	          base64String += BASE_CHARS[bytes[i + 2] & 63];
	        }
	        if (bytes.length % 3 === 2) {
	          base64String = base64String.substring(0, base64String.length - 1) + '=';
	        } else if (bytes.length % 3 === 1) {
	          base64String = base64String.substring(0, base64String.length - 2) + '==';
	        }
	        return base64String;
	      }

	      // Serialize a value, afterwards executing a callback (which usually
	      // instructs the `setItem()` callback/promise to be executed). This is how
	      // we store binary data with localStorage.
	      function serialize(value, callback) {
	        var valueType = '';
	        if (value) {
	          valueType = toString$1.call(value);
	        }

	        // Cannot use `value instanceof ArrayBuffer` or such here, as these
	        // checks fail when running the tests using casper.js...
	        //
	        // TODO: See why those tests fail and use a better solution.
	        if (value && (valueType === '[object ArrayBuffer]' || value.buffer && toString$1.call(value.buffer) === '[object ArrayBuffer]')) {
	          // Convert binary arrays to a string and prefix the string with
	          // a special marker.
	          var buffer;
	          var marker = SERIALIZED_MARKER;
	          if (value instanceof ArrayBuffer) {
	            buffer = value;
	            marker += TYPE_ARRAYBUFFER;
	          } else {
	            buffer = value.buffer;
	            if (valueType === '[object Int8Array]') {
	              marker += TYPE_INT8ARRAY;
	            } else if (valueType === '[object Uint8Array]') {
	              marker += TYPE_UINT8ARRAY;
	            } else if (valueType === '[object Uint8ClampedArray]') {
	              marker += TYPE_UINT8CLAMPEDARRAY;
	            } else if (valueType === '[object Int16Array]') {
	              marker += TYPE_INT16ARRAY;
	            } else if (valueType === '[object Uint16Array]') {
	              marker += TYPE_UINT16ARRAY;
	            } else if (valueType === '[object Int32Array]') {
	              marker += TYPE_INT32ARRAY;
	            } else if (valueType === '[object Uint32Array]') {
	              marker += TYPE_UINT32ARRAY;
	            } else if (valueType === '[object Float32Array]') {
	              marker += TYPE_FLOAT32ARRAY;
	            } else if (valueType === '[object Float64Array]') {
	              marker += TYPE_FLOAT64ARRAY;
	            } else {
	              callback(new Error('Failed to get type for BinaryArray'));
	            }
	          }
	          callback(marker + bufferToString(buffer));
	        } else if (valueType === '[object Blob]') {
	          // Conver the blob to a binaryArray and then to a string.
	          var fileReader = new FileReader();
	          fileReader.onload = function () {
	            // Backwards-compatible prefix for the blob type.
	            var str = BLOB_TYPE_PREFIX + value.type + '~' + bufferToString(this.result);
	            callback(SERIALIZED_MARKER + TYPE_BLOB + str);
	          };
	          fileReader.readAsArrayBuffer(value);
	        } else {
	          try {
	            callback(JSON.stringify(value));
	          } catch (e) {
	            console.error("Couldn't convert value into a JSON string: ", value);
	            callback(null, e);
	          }
	        }
	      }

	      // Deserialize data we've inserted into a value column/field. We place
	      // special markers into our strings to mark them as encoded; this isn't
	      // as nice as a meta field, but it's the only sane thing we can do whilst
	      // keeping localStorage support intact.
	      //
	      // Oftentimes this will just deserialize JSON content, but if we have a
	      // special marker (SERIALIZED_MARKER, defined above), we will extract
	      // some kind of arraybuffer/binary data/typed array out of the string.
	      function deserialize(value) {
	        // If we haven't marked this string as being specially serialized (i.e.
	        // something other than serialized JSON), we can just return it and be
	        // done with it.
	        if (value.substring(0, SERIALIZED_MARKER_LENGTH) !== SERIALIZED_MARKER) {
	          return JSON.parse(value);
	        }

	        // The following code deals with deserializing some kind of Blob or
	        // TypedArray. First we separate out the type of data we're dealing
	        // with from the data itself.
	        var serializedString = value.substring(TYPE_SERIALIZED_MARKER_LENGTH);
	        var type = value.substring(SERIALIZED_MARKER_LENGTH, TYPE_SERIALIZED_MARKER_LENGTH);
	        var blobType;
	        // Backwards-compatible blob type serialization strategy.
	        // DBs created with older versions of localForage will simply not have the blob type.
	        if (type === TYPE_BLOB && BLOB_TYPE_PREFIX_REGEX.test(serializedString)) {
	          var matcher = serializedString.match(BLOB_TYPE_PREFIX_REGEX);
	          blobType = matcher[1];
	          serializedString = serializedString.substring(matcher[0].length);
	        }
	        var buffer = stringToBuffer(serializedString);

	        // Return the right type based on the code/type set during
	        // serialization.
	        switch (type) {
	          case TYPE_ARRAYBUFFER:
	            return buffer;
	          case TYPE_BLOB:
	            return createBlob([buffer], {
	              type: blobType
	            });
	          case TYPE_INT8ARRAY:
	            return new Int8Array(buffer);
	          case TYPE_UINT8ARRAY:
	            return new Uint8Array(buffer);
	          case TYPE_UINT8CLAMPEDARRAY:
	            return new Uint8ClampedArray(buffer);
	          case TYPE_INT16ARRAY:
	            return new Int16Array(buffer);
	          case TYPE_UINT16ARRAY:
	            return new Uint16Array(buffer);
	          case TYPE_INT32ARRAY:
	            return new Int32Array(buffer);
	          case TYPE_UINT32ARRAY:
	            return new Uint32Array(buffer);
	          case TYPE_FLOAT32ARRAY:
	            return new Float32Array(buffer);
	          case TYPE_FLOAT64ARRAY:
	            return new Float64Array(buffer);
	          default:
	            throw new Error('Unkown type: ' + type);
	        }
	      }
	      var localforageSerializer = {
	        serialize: serialize,
	        deserialize: deserialize,
	        stringToBuffer: stringToBuffer,
	        bufferToString: bufferToString
	      };

	      /*
	       * Includes code from:
	       *
	       * base64-arraybuffer
	       * https://github.com/niklasvh/base64-arraybuffer
	       *
	       * Copyright (c) 2012 Niklas von Hertzen
	       * Licensed under the MIT license.
	       */

	      function createDbTable(t, dbInfo, callback, errorCallback) {
	        t.executeSql('CREATE TABLE IF NOT EXISTS ' + dbInfo.storeName + ' ' + '(id INTEGER PRIMARY KEY, key unique, value)', [], callback, errorCallback);
	      }

	      // Open the WebSQL database (automatically creates one if one didn't
	      // previously exist), using any options set in the config.
	      function _initStorage$1(options) {
	        var self = this;
	        var dbInfo = {
	          db: null
	        };
	        if (options) {
	          for (var i in options) {
	            dbInfo[i] = typeof options[i] !== 'string' ? options[i].toString() : options[i];
	          }
	        }
	        var dbInfoPromise = new Promise$1(function (resolve, reject) {
	          // Open the database; the openDatabase API will automatically
	          // create it for us if it doesn't exist.
	          try {
	            dbInfo.db = openDatabase(dbInfo.name, String(dbInfo.version), dbInfo.description, dbInfo.size);
	          } catch (e) {
	            return reject(e);
	          }

	          // Create our key/value table if it doesn't exist.
	          dbInfo.db.transaction(function (t) {
	            createDbTable(t, dbInfo, function () {
	              self._dbInfo = dbInfo;
	              resolve();
	            }, function (t, error) {
	              reject(error);
	            });
	          }, reject);
	        });
	        dbInfo.serializer = localforageSerializer;
	        return dbInfoPromise;
	      }
	      function tryExecuteSql(t, dbInfo, sqlStatement, args, callback, errorCallback) {
	        t.executeSql(sqlStatement, args, callback, function (t, error) {
	          if (error.code === error.SYNTAX_ERR) {
	            t.executeSql('SELECT name FROM sqlite_master ' + "WHERE type='table' AND name = ?", [dbInfo.storeName], function (t, results) {
	              if (!results.rows.length) {
	                // if the table is missing (was deleted)
	                // re-create it table and retry
	                createDbTable(t, dbInfo, function () {
	                  t.executeSql(sqlStatement, args, callback, errorCallback);
	                }, errorCallback);
	              } else {
	                errorCallback(t, error);
	              }
	            }, errorCallback);
	          } else {
	            errorCallback(t, error);
	          }
	        }, errorCallback);
	      }
	      function getItem$1(key, callback) {
	        var self = this;
	        key = normalizeKey(key);
	        var promise = new Promise$1(function (resolve, reject) {
	          self.ready().then(function () {
	            var dbInfo = self._dbInfo;
	            dbInfo.db.transaction(function (t) {
	              tryExecuteSql(t, dbInfo, 'SELECT * FROM ' + dbInfo.storeName + ' WHERE key = ? LIMIT 1', [key], function (t, results) {
	                var result = results.rows.length ? results.rows.item(0).value : null;

	                // Check to see if this is serialized content we need to
	                // unpack.
	                if (result) {
	                  result = dbInfo.serializer.deserialize(result);
	                }
	                resolve(result);
	              }, function (t, error) {
	                reject(error);
	              });
	            });
	          })["catch"](reject);
	        });
	        executeCallback(promise, callback);
	        return promise;
	      }
	      function iterate$1(iterator, callback) {
	        var self = this;
	        var promise = new Promise$1(function (resolve, reject) {
	          self.ready().then(function () {
	            var dbInfo = self._dbInfo;
	            dbInfo.db.transaction(function (t) {
	              tryExecuteSql(t, dbInfo, 'SELECT * FROM ' + dbInfo.storeName, [], function (t, results) {
	                var rows = results.rows;
	                var length = rows.length;
	                for (var i = 0; i < length; i++) {
	                  var item = rows.item(i);
	                  var result = item.value;

	                  // Check to see if this is serialized content
	                  // we need to unpack.
	                  if (result) {
	                    result = dbInfo.serializer.deserialize(result);
	                  }
	                  result = iterator(result, item.key, i + 1);

	                  // void(0) prevents problems with redefinition
	                  // of `undefined`.
	                  if (result !== void 0) {
	                    resolve(result);
	                    return;
	                  }
	                }
	                resolve();
	              }, function (t, error) {
	                reject(error);
	              });
	            });
	          })["catch"](reject);
	        });
	        executeCallback(promise, callback);
	        return promise;
	      }
	      function _setItem(key, value, callback, retriesLeft) {
	        var self = this;
	        key = normalizeKey(key);
	        var promise = new Promise$1(function (resolve, reject) {
	          self.ready().then(function () {
	            // The localStorage API doesn't return undefined values in an
	            // "expected" way, so undefined is always cast to null in all
	            // drivers. See: https://github.com/mozilla/localForage/pull/42
	            if (value === undefined) {
	              value = null;
	            }

	            // Save the original value to pass to the callback.
	            var originalValue = value;
	            var dbInfo = self._dbInfo;
	            dbInfo.serializer.serialize(value, function (value, error) {
	              if (error) {
	                reject(error);
	              } else {
	                dbInfo.db.transaction(function (t) {
	                  tryExecuteSql(t, dbInfo, 'INSERT OR REPLACE INTO ' + dbInfo.storeName + ' ' + '(key, value) VALUES (?, ?)', [key, value], function () {
	                    resolve(originalValue);
	                  }, function (t, error) {
	                    reject(error);
	                  });
	                }, function (sqlError) {
	                  // The transaction failed; check
	                  // to see if it's a quota error.
	                  if (sqlError.code === sqlError.QUOTA_ERR) {
	                    // We reject the callback outright for now, but
	                    // it's worth trying to re-run the transaction.
	                    // Even if the user accepts the prompt to use
	                    // more storage on Safari, this error will
	                    // be called.
	                    //
	                    // Try to re-run the transaction.
	                    if (retriesLeft > 0) {
	                      resolve(_setItem.apply(self, [key, originalValue, callback, retriesLeft - 1]));
	                      return;
	                    }
	                    reject(sqlError);
	                  }
	                });
	              }
	            });
	          })["catch"](reject);
	        });
	        executeCallback(promise, callback);
	        return promise;
	      }
	      function setItem$1(key, value, callback) {
	        return _setItem.apply(this, [key, value, callback, 1]);
	      }
	      function removeItem$1(key, callback) {
	        var self = this;
	        key = normalizeKey(key);
	        var promise = new Promise$1(function (resolve, reject) {
	          self.ready().then(function () {
	            var dbInfo = self._dbInfo;
	            dbInfo.db.transaction(function (t) {
	              tryExecuteSql(t, dbInfo, 'DELETE FROM ' + dbInfo.storeName + ' WHERE key = ?', [key], function () {
	                resolve();
	              }, function (t, error) {
	                reject(error);
	              });
	            });
	          })["catch"](reject);
	        });
	        executeCallback(promise, callback);
	        return promise;
	      }

	      // Deletes every item in the table.
	      // TODO: Find out if this resets the AUTO_INCREMENT number.
	      function clear$1(callback) {
	        var self = this;
	        var promise = new Promise$1(function (resolve, reject) {
	          self.ready().then(function () {
	            var dbInfo = self._dbInfo;
	            dbInfo.db.transaction(function (t) {
	              tryExecuteSql(t, dbInfo, 'DELETE FROM ' + dbInfo.storeName, [], function () {
	                resolve();
	              }, function (t, error) {
	                reject(error);
	              });
	            });
	          })["catch"](reject);
	        });
	        executeCallback(promise, callback);
	        return promise;
	      }

	      // Does a simple `COUNT(key)` to get the number of items stored in
	      // localForage.
	      function length$1(callback) {
	        var self = this;
	        var promise = new Promise$1(function (resolve, reject) {
	          self.ready().then(function () {
	            var dbInfo = self._dbInfo;
	            dbInfo.db.transaction(function (t) {
	              // Ahhh, SQL makes this one soooooo easy.
	              tryExecuteSql(t, dbInfo, 'SELECT COUNT(key) as c FROM ' + dbInfo.storeName, [], function (t, results) {
	                var result = results.rows.item(0).c;
	                resolve(result);
	              }, function (t, error) {
	                reject(error);
	              });
	            });
	          })["catch"](reject);
	        });
	        executeCallback(promise, callback);
	        return promise;
	      }

	      // Return the key located at key index X; essentially gets the key from a
	      // `WHERE id = ?`. This is the most efficient way I can think to implement
	      // this rarely-used (in my experience) part of the API, but it can seem
	      // inconsistent, because we do `INSERT OR REPLACE INTO` on `setItem()`, so
	      // the ID of each key will change every time it's updated. Perhaps a stored
	      // procedure for the `setItem()` SQL would solve this problem?
	      // TODO: Don't change ID on `setItem()`.
	      function key$1(n, callback) {
	        var self = this;
	        var promise = new Promise$1(function (resolve, reject) {
	          self.ready().then(function () {
	            var dbInfo = self._dbInfo;
	            dbInfo.db.transaction(function (t) {
	              tryExecuteSql(t, dbInfo, 'SELECT key FROM ' + dbInfo.storeName + ' WHERE id = ? LIMIT 1', [n + 1], function (t, results) {
	                var result = results.rows.length ? results.rows.item(0).key : null;
	                resolve(result);
	              }, function (t, error) {
	                reject(error);
	              });
	            });
	          })["catch"](reject);
	        });
	        executeCallback(promise, callback);
	        return promise;
	      }
	      function keys$1(callback) {
	        var self = this;
	        var promise = new Promise$1(function (resolve, reject) {
	          self.ready().then(function () {
	            var dbInfo = self._dbInfo;
	            dbInfo.db.transaction(function (t) {
	              tryExecuteSql(t, dbInfo, 'SELECT key FROM ' + dbInfo.storeName, [], function (t, results) {
	                var keys = [];
	                for (var i = 0; i < results.rows.length; i++) {
	                  keys.push(results.rows.item(i).key);
	                }
	                resolve(keys);
	              }, function (t, error) {
	                reject(error);
	              });
	            });
	          })["catch"](reject);
	        });
	        executeCallback(promise, callback);
	        return promise;
	      }

	      // https://www.w3.org/TR/webdatabase/#databases
	      // > There is no way to enumerate or delete the databases available for an origin from this API.
	      function getAllStoreNames(db) {
	        return new Promise$1(function (resolve, reject) {
	          db.transaction(function (t) {
	            t.executeSql('SELECT name FROM sqlite_master ' + "WHERE type='table' AND name <> '__WebKitDatabaseInfoTable__'", [], function (t, results) {
	              var storeNames = [];
	              for (var i = 0; i < results.rows.length; i++) {
	                storeNames.push(results.rows.item(i).name);
	              }
	              resolve({
	                db: db,
	                storeNames: storeNames
	              });
	            }, function (t, error) {
	              reject(error);
	            });
	          }, function (sqlError) {
	            reject(sqlError);
	          });
	        });
	      }
	      function dropInstance$1(options, callback) {
	        callback = getCallback.apply(this, arguments);
	        var currentConfig = this.config();
	        options = typeof options !== 'function' && options || {};
	        if (!options.name) {
	          options.name = options.name || currentConfig.name;
	          options.storeName = options.storeName || currentConfig.storeName;
	        }
	        var self = this;
	        var promise;
	        if (!options.name) {
	          promise = Promise$1.reject('Invalid arguments');
	        } else {
	          promise = new Promise$1(function (resolve) {
	            var db;
	            if (options.name === currentConfig.name) {
	              // use the db reference of the current instance
	              db = self._dbInfo.db;
	            } else {
	              db = openDatabase(options.name, '', '', 0);
	            }
	            if (!options.storeName) {
	              // drop all database tables
	              resolve(getAllStoreNames(db));
	            } else {
	              resolve({
	                db: db,
	                storeNames: [options.storeName]
	              });
	            }
	          }).then(function (operationInfo) {
	            return new Promise$1(function (resolve, reject) {
	              operationInfo.db.transaction(function (t) {
	                function dropTable(storeName) {
	                  return new Promise$1(function (resolve, reject) {
	                    t.executeSql('DROP TABLE IF EXISTS ' + storeName, [], function () {
	                      resolve();
	                    }, function (t, error) {
	                      reject(error);
	                    });
	                  });
	                }
	                var operations = [];
	                for (var i = 0, len = operationInfo.storeNames.length; i < len; i++) {
	                  operations.push(dropTable(operationInfo.storeNames[i]));
	                }
	                Promise$1.all(operations).then(function () {
	                  resolve();
	                })["catch"](function (e) {
	                  reject(e);
	                });
	              }, function (sqlError) {
	                reject(sqlError);
	              });
	            });
	          });
	        }
	        executeCallback(promise, callback);
	        return promise;
	      }
	      var webSQLStorage = {
	        _driver: 'webSQLStorage',
	        _initStorage: _initStorage$1,
	        _support: isWebSQLValid(),
	        iterate: iterate$1,
	        getItem: getItem$1,
	        setItem: setItem$1,
	        removeItem: removeItem$1,
	        clear: clear$1,
	        length: length$1,
	        key: key$1,
	        keys: keys$1,
	        dropInstance: dropInstance$1
	      };
	      function isLocalStorageValid() {
	        try {
	          return typeof localStorage !== 'undefined' && 'setItem' in localStorage &&
	          // in IE8 typeof localStorage.setItem === 'object'
	          !!localStorage.setItem;
	        } catch (e) {
	          return false;
	        }
	      }
	      function _getKeyPrefix(options, defaultConfig) {
	        var keyPrefix = options.name + '/';
	        if (options.storeName !== defaultConfig.storeName) {
	          keyPrefix += options.storeName + '/';
	        }
	        return keyPrefix;
	      }

	      // Check if localStorage throws when saving an item
	      function checkIfLocalStorageThrows() {
	        var localStorageTestKey = '_localforage_support_test';
	        try {
	          localStorage.setItem(localStorageTestKey, true);
	          localStorage.removeItem(localStorageTestKey);
	          return false;
	        } catch (e) {
	          return true;
	        }
	      }

	      // Check if localStorage is usable and allows to save an item
	      // This method checks if localStorage is usable in Safari Private Browsing
	      // mode, or in any other case where the available quota for localStorage
	      // is 0 and there wasn't any saved items yet.
	      function _isLocalStorageUsable() {
	        return !checkIfLocalStorageThrows() || localStorage.length > 0;
	      }

	      // Config the localStorage backend, using options set in the config.
	      function _initStorage$2(options) {
	        var self = this;
	        var dbInfo = {};
	        if (options) {
	          for (var i in options) {
	            dbInfo[i] = options[i];
	          }
	        }
	        dbInfo.keyPrefix = _getKeyPrefix(options, self._defaultConfig);
	        if (!_isLocalStorageUsable()) {
	          return Promise$1.reject();
	        }
	        self._dbInfo = dbInfo;
	        dbInfo.serializer = localforageSerializer;
	        return Promise$1.resolve();
	      }

	      // Remove all keys from the datastore, effectively destroying all data in
	      // the app's key/value store!
	      function clear$2(callback) {
	        var self = this;
	        var promise = self.ready().then(function () {
	          var keyPrefix = self._dbInfo.keyPrefix;
	          for (var i = localStorage.length - 1; i >= 0; i--) {
	            var key = localStorage.key(i);
	            if (key.indexOf(keyPrefix) === 0) {
	              localStorage.removeItem(key);
	            }
	          }
	        });
	        executeCallback(promise, callback);
	        return promise;
	      }

	      // Retrieve an item from the store. Unlike the original async_storage
	      // library in Gaia, we don't modify return values at all. If a key's value
	      // is `undefined`, we pass that value to the callback function.
	      function getItem$2(key, callback) {
	        var self = this;
	        key = normalizeKey(key);
	        var promise = self.ready().then(function () {
	          var dbInfo = self._dbInfo;
	          var result = localStorage.getItem(dbInfo.keyPrefix + key);

	          // If a result was found, parse it from the serialized
	          // string into a JS object. If result isn't truthy, the key
	          // is likely undefined and we'll pass it straight to the
	          // callback.
	          if (result) {
	            result = dbInfo.serializer.deserialize(result);
	          }
	          return result;
	        });
	        executeCallback(promise, callback);
	        return promise;
	      }

	      // Iterate over all items in the store.
	      function iterate$2(iterator, callback) {
	        var self = this;
	        var promise = self.ready().then(function () {
	          var dbInfo = self._dbInfo;
	          var keyPrefix = dbInfo.keyPrefix;
	          var keyPrefixLength = keyPrefix.length;
	          var length = localStorage.length;

	          // We use a dedicated iterator instead of the `i` variable below
	          // so other keys we fetch in localStorage aren't counted in
	          // the `iterationNumber` argument passed to the `iterate()`
	          // callback.
	          //
	          // See: github.com/mozilla/localForage/pull/435#discussion_r38061530
	          var iterationNumber = 1;
	          for (var i = 0; i < length; i++) {
	            var key = localStorage.key(i);
	            if (key.indexOf(keyPrefix) !== 0) {
	              continue;
	            }
	            var value = localStorage.getItem(key);

	            // If a result was found, parse it from the serialized
	            // string into a JS object. If result isn't truthy, the
	            // key is likely undefined and we'll pass it straight
	            // to the iterator.
	            if (value) {
	              value = dbInfo.serializer.deserialize(value);
	            }
	            value = iterator(value, key.substring(keyPrefixLength), iterationNumber++);
	            if (value !== void 0) {
	              return value;
	            }
	          }
	        });
	        executeCallback(promise, callback);
	        return promise;
	      }

	      // Same as localStorage's key() method, except takes a callback.
	      function key$2(n, callback) {
	        var self = this;
	        var promise = self.ready().then(function () {
	          var dbInfo = self._dbInfo;
	          var result;
	          try {
	            result = localStorage.key(n);
	          } catch (error) {
	            result = null;
	          }

	          // Remove the prefix from the key, if a key is found.
	          if (result) {
	            result = result.substring(dbInfo.keyPrefix.length);
	          }
	          return result;
	        });
	        executeCallback(promise, callback);
	        return promise;
	      }
	      function keys$2(callback) {
	        var self = this;
	        var promise = self.ready().then(function () {
	          var dbInfo = self._dbInfo;
	          var length = localStorage.length;
	          var keys = [];
	          for (var i = 0; i < length; i++) {
	            var itemKey = localStorage.key(i);
	            if (itemKey.indexOf(dbInfo.keyPrefix) === 0) {
	              keys.push(itemKey.substring(dbInfo.keyPrefix.length));
	            }
	          }
	          return keys;
	        });
	        executeCallback(promise, callback);
	        return promise;
	      }

	      // Supply the number of keys in the datastore to the callback function.
	      function length$2(callback) {
	        var self = this;
	        var promise = self.keys().then(function (keys) {
	          return keys.length;
	        });
	        executeCallback(promise, callback);
	        return promise;
	      }

	      // Remove an item from the store, nice and simple.
	      function removeItem$2(key, callback) {
	        var self = this;
	        key = normalizeKey(key);
	        var promise = self.ready().then(function () {
	          var dbInfo = self._dbInfo;
	          localStorage.removeItem(dbInfo.keyPrefix + key);
	        });
	        executeCallback(promise, callback);
	        return promise;
	      }

	      // Set a key's value and run an optional callback once the value is set.
	      // Unlike Gaia's implementation, the callback function is passed the value,
	      // in case you want to operate on that value only after you're sure it
	      // saved, or something like that.
	      function setItem$2(key, value, callback) {
	        var self = this;
	        key = normalizeKey(key);
	        var promise = self.ready().then(function () {
	          // Convert undefined values to null.
	          // https://github.com/mozilla/localForage/pull/42
	          if (value === undefined) {
	            value = null;
	          }

	          // Save the original value to pass to the callback.
	          var originalValue = value;
	          return new Promise$1(function (resolve, reject) {
	            var dbInfo = self._dbInfo;
	            dbInfo.serializer.serialize(value, function (value, error) {
	              if (error) {
	                reject(error);
	              } else {
	                try {
	                  localStorage.setItem(dbInfo.keyPrefix + key, value);
	                  resolve(originalValue);
	                } catch (e) {
	                  // localStorage capacity exceeded.
	                  // TODO: Make this a specific error/event.
	                  if (e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
	                    reject(e);
	                  }
	                  reject(e);
	                }
	              }
	            });
	          });
	        });
	        executeCallback(promise, callback);
	        return promise;
	      }
	      function dropInstance$2(options, callback) {
	        callback = getCallback.apply(this, arguments);
	        options = typeof options !== 'function' && options || {};
	        if (!options.name) {
	          var currentConfig = this.config();
	          options.name = options.name || currentConfig.name;
	          options.storeName = options.storeName || currentConfig.storeName;
	        }
	        var self = this;
	        var promise;
	        if (!options.name) {
	          promise = Promise$1.reject('Invalid arguments');
	        } else {
	          promise = new Promise$1(function (resolve) {
	            if (!options.storeName) {
	              resolve(options.name + '/');
	            } else {
	              resolve(_getKeyPrefix(options, self._defaultConfig));
	            }
	          }).then(function (keyPrefix) {
	            for (var i = localStorage.length - 1; i >= 0; i--) {
	              var key = localStorage.key(i);
	              if (key.indexOf(keyPrefix) === 0) {
	                localStorage.removeItem(key);
	              }
	            }
	          });
	        }
	        executeCallback(promise, callback);
	        return promise;
	      }
	      var localStorageWrapper = {
	        _driver: 'localStorageWrapper',
	        _initStorage: _initStorage$2,
	        _support: isLocalStorageValid(),
	        iterate: iterate$2,
	        getItem: getItem$2,
	        setItem: setItem$2,
	        removeItem: removeItem$2,
	        clear: clear$2,
	        length: length$2,
	        key: key$2,
	        keys: keys$2,
	        dropInstance: dropInstance$2
	      };
	      var sameValue = function sameValue(x, y) {
	        return x === y || typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y);
	      };
	      var includes = function includes(array, searchElement) {
	        var len = array.length;
	        var i = 0;
	        while (i < len) {
	          if (sameValue(array[i], searchElement)) {
	            return true;
	          }
	          i++;
	        }
	        return false;
	      };
	      var isArray = Array.isArray || function (arg) {
	        return Object.prototype.toString.call(arg) === '[object Array]';
	      };

	      // Drivers are stored here when `defineDriver()` is called.
	      // They are shared across all instances of localForage.
	      var DefinedDrivers = {};
	      var DriverSupport = {};
	      var DefaultDrivers = {
	        INDEXEDDB: asyncStorage,
	        WEBSQL: webSQLStorage,
	        LOCALSTORAGE: localStorageWrapper
	      };
	      var DefaultDriverOrder = [DefaultDrivers.INDEXEDDB._driver, DefaultDrivers.WEBSQL._driver, DefaultDrivers.LOCALSTORAGE._driver];
	      var OptionalDriverMethods = ['dropInstance'];
	      var LibraryMethods = ['clear', 'getItem', 'iterate', 'key', 'keys', 'length', 'removeItem', 'setItem'].concat(OptionalDriverMethods);
	      var DefaultConfig = {
	        description: '',
	        driver: DefaultDriverOrder.slice(),
	        name: 'localforage',
	        // Default DB size is _JUST UNDER_ 5MB, as it's the highest size
	        // we can use without a prompt.
	        size: 4980736,
	        storeName: 'keyvaluepairs',
	        version: 1.0
	      };
	      function callWhenReady(localForageInstance, libraryMethod) {
	        localForageInstance[libraryMethod] = function () {
	          var _args = arguments;
	          return localForageInstance.ready().then(function () {
	            return localForageInstance[libraryMethod].apply(localForageInstance, _args);
	          });
	        };
	      }
	      function extend() {
	        for (var i = 1; i < arguments.length; i++) {
	          var arg = arguments[i];
	          if (arg) {
	            for (var _key in arg) {
	              if (arg.hasOwnProperty(_key)) {
	                if (isArray(arg[_key])) {
	                  arguments[0][_key] = arg[_key].slice();
	                } else {
	                  arguments[0][_key] = arg[_key];
	                }
	              }
	            }
	          }
	        }
	        return arguments[0];
	      }
	      var LocalForage = function () {
	        function LocalForage(options) {
	          _classCallCheck(this, LocalForage);
	          for (var driverTypeKey in DefaultDrivers) {
	            if (DefaultDrivers.hasOwnProperty(driverTypeKey)) {
	              var driver = DefaultDrivers[driverTypeKey];
	              var driverName = driver._driver;
	              this[driverTypeKey] = driverName;
	              if (!DefinedDrivers[driverName]) {
	                // we don't need to wait for the promise,
	                // since the default drivers can be defined
	                // in a blocking manner
	                this.defineDriver(driver);
	              }
	            }
	          }
	          this._defaultConfig = extend({}, DefaultConfig);
	          this._config = extend({}, this._defaultConfig, options);
	          this._driverSet = null;
	          this._initDriver = null;
	          this._ready = false;
	          this._dbInfo = null;
	          this._wrapLibraryMethodsWithReady();
	          this.setDriver(this._config.driver)["catch"](function () {});
	        }

	        // Set any config values for localForage; can be called anytime before
	        // the first API call (e.g. `getItem`, `setItem`).
	        // We loop through options so we don't overwrite existing config
	        // values.

	        LocalForage.prototype.config = function config(options) {
	          // If the options argument is an object, we use it to set values.
	          // Otherwise, we return either a specified config value or all
	          // config values.
	          if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
	            // If localforage is ready and fully initialized, we can't set
	            // any new configuration values. Instead, we return an error.
	            if (this._ready) {
	              return new Error("Can't call config() after localforage " + 'has been used.');
	            }
	            for (var i in options) {
	              if (i === 'storeName') {
	                options[i] = options[i].replace(/\W/g, '_');
	              }
	              if (i === 'version' && typeof options[i] !== 'number') {
	                return new Error('Database version must be a number.');
	              }
	              this._config[i] = options[i];
	            }

	            // after all config options are set and
	            // the driver option is used, try setting it
	            if ('driver' in options && options.driver) {
	              return this.setDriver(this._config.driver);
	            }
	            return true;
	          } else if (typeof options === 'string') {
	            return this._config[options];
	          } else {
	            return this._config;
	          }
	        };

	        // Used to define a custom driver, shared across all instances of
	        // localForage.

	        LocalForage.prototype.defineDriver = function defineDriver(driverObject, callback, errorCallback) {
	          var promise = new Promise$1(function (resolve, reject) {
	            try {
	              var driverName = driverObject._driver;
	              var complianceError = new Error('Custom driver not compliant; see ' + 'https://mozilla.github.io/localForage/#definedriver');

	              // A driver name should be defined and not overlap with the
	              // library-defined, default drivers.
	              if (!driverObject._driver) {
	                reject(complianceError);
	                return;
	              }
	              var driverMethods = LibraryMethods.concat('_initStorage');
	              for (var i = 0, len = driverMethods.length; i < len; i++) {
	                var driverMethodName = driverMethods[i];

	                // when the property is there,
	                // it should be a method even when optional
	                var isRequired = !includes(OptionalDriverMethods, driverMethodName);
	                if ((isRequired || driverObject[driverMethodName]) && typeof driverObject[driverMethodName] !== 'function') {
	                  reject(complianceError);
	                  return;
	                }
	              }
	              var configureMissingMethods = function configureMissingMethods() {
	                var methodNotImplementedFactory = function methodNotImplementedFactory(methodName) {
	                  return function () {
	                    var error = new Error('Method ' + methodName + ' is not implemented by the current driver');
	                    var promise = Promise$1.reject(error);
	                    executeCallback(promise, arguments[arguments.length - 1]);
	                    return promise;
	                  };
	                };
	                for (var _i = 0, _len = OptionalDriverMethods.length; _i < _len; _i++) {
	                  var optionalDriverMethod = OptionalDriverMethods[_i];
	                  if (!driverObject[optionalDriverMethod]) {
	                    driverObject[optionalDriverMethod] = methodNotImplementedFactory(optionalDriverMethod);
	                  }
	                }
	              };
	              configureMissingMethods();
	              var setDriverSupport = function setDriverSupport(support) {
	                if (DefinedDrivers[driverName]) {
	                  console.info('Redefining LocalForage driver: ' + driverName);
	                }
	                DefinedDrivers[driverName] = driverObject;
	                DriverSupport[driverName] = support;
	                // don't use a then, so that we can define
	                // drivers that have simple _support methods
	                // in a blocking manner
	                resolve();
	              };
	              if ('_support' in driverObject) {
	                if (driverObject._support && typeof driverObject._support === 'function') {
	                  driverObject._support().then(setDriverSupport, reject);
	                } else {
	                  setDriverSupport(!!driverObject._support);
	                }
	              } else {
	                setDriverSupport(true);
	              }
	            } catch (e) {
	              reject(e);
	            }
	          });
	          executeTwoCallbacks(promise, callback, errorCallback);
	          return promise;
	        };
	        LocalForage.prototype.driver = function driver() {
	          return this._driver || null;
	        };
	        LocalForage.prototype.getDriver = function getDriver(driverName, callback, errorCallback) {
	          var getDriverPromise = DefinedDrivers[driverName] ? Promise$1.resolve(DefinedDrivers[driverName]) : Promise$1.reject(new Error('Driver not found.'));
	          executeTwoCallbacks(getDriverPromise, callback, errorCallback);
	          return getDriverPromise;
	        };
	        LocalForage.prototype.getSerializer = function getSerializer(callback) {
	          var serializerPromise = Promise$1.resolve(localforageSerializer);
	          executeTwoCallbacks(serializerPromise, callback);
	          return serializerPromise;
	        };
	        LocalForage.prototype.ready = function ready(callback) {
	          var self = this;
	          var promise = self._driverSet.then(function () {
	            if (self._ready === null) {
	              self._ready = self._initDriver();
	            }
	            return self._ready;
	          });
	          executeTwoCallbacks(promise, callback, callback);
	          return promise;
	        };
	        LocalForage.prototype.setDriver = function setDriver(drivers, callback, errorCallback) {
	          var self = this;
	          if (!isArray(drivers)) {
	            drivers = [drivers];
	          }
	          var supportedDrivers = this._getSupportedDrivers(drivers);
	          function setDriverToConfig() {
	            self._config.driver = self.driver();
	          }
	          function extendSelfWithDriver(driver) {
	            self._extend(driver);
	            setDriverToConfig();
	            self._ready = self._initStorage(self._config);
	            return self._ready;
	          }
	          function initDriver(supportedDrivers) {
	            return function () {
	              var currentDriverIndex = 0;
	              function driverPromiseLoop() {
	                while (currentDriverIndex < supportedDrivers.length) {
	                  var driverName = supportedDrivers[currentDriverIndex];
	                  currentDriverIndex++;
	                  self._dbInfo = null;
	                  self._ready = null;
	                  return self.getDriver(driverName).then(extendSelfWithDriver)["catch"](driverPromiseLoop);
	                }
	                setDriverToConfig();
	                var error = new Error('No available storage method found.');
	                self._driverSet = Promise$1.reject(error);
	                return self._driverSet;
	              }
	              return driverPromiseLoop();
	            };
	          }

	          // There might be a driver initialization in progress
	          // so wait for it to finish in order to avoid a possible
	          // race condition to set _dbInfo
	          var oldDriverSetDone = this._driverSet !== null ? this._driverSet["catch"](function () {
	            return Promise$1.resolve();
	          }) : Promise$1.resolve();
	          this._driverSet = oldDriverSetDone.then(function () {
	            var driverName = supportedDrivers[0];
	            self._dbInfo = null;
	            self._ready = null;
	            return self.getDriver(driverName).then(function (driver) {
	              self._driver = driver._driver;
	              setDriverToConfig();
	              self._wrapLibraryMethodsWithReady();
	              self._initDriver = initDriver(supportedDrivers);
	            });
	          })["catch"](function () {
	            setDriverToConfig();
	            var error = new Error('No available storage method found.');
	            self._driverSet = Promise$1.reject(error);
	            return self._driverSet;
	          });
	          executeTwoCallbacks(this._driverSet, callback, errorCallback);
	          return this._driverSet;
	        };
	        LocalForage.prototype.supports = function supports(driverName) {
	          return !!DriverSupport[driverName];
	        };
	        LocalForage.prototype._extend = function _extend(libraryMethodsAndProperties) {
	          extend(this, libraryMethodsAndProperties);
	        };
	        LocalForage.prototype._getSupportedDrivers = function _getSupportedDrivers(drivers) {
	          var supportedDrivers = [];
	          for (var i = 0, len = drivers.length; i < len; i++) {
	            var driverName = drivers[i];
	            if (this.supports(driverName)) {
	              supportedDrivers.push(driverName);
	            }
	          }
	          return supportedDrivers;
	        };
	        LocalForage.prototype._wrapLibraryMethodsWithReady = function _wrapLibraryMethodsWithReady() {
	          // Add a stub for each driver API method that delays the call to the
	          // corresponding driver method until localForage is ready. These stubs
	          // will be replaced by the driver methods as soon as the driver is
	          // loaded, so there is no performance impact.
	          for (var i = 0, len = LibraryMethods.length; i < len; i++) {
	            callWhenReady(this, LibraryMethods[i]);
	          }
	        };
	        LocalForage.prototype.createInstance = function createInstance(options) {
	          return new LocalForage(options);
	        };
	        return LocalForage;
	      }();

	      // The actual localForage object that we expose as a module or via a
	      // global. It's extended by pulling in one of our other libraries.

	      var localforage_js = new LocalForage();
	      module.exports = localforage_js;
	    }, {
	      "3": 3
	    }]
	  }, {}, [4])(4);
	});
} (localforage$1));

var localforage = localforage$1.exports;

// eslint-lint-disable-next-line @typescript-eslint/naming-convention
class HTTPError extends Error {
  constructor(response, request, options) {
    const code = response.status || response.status === 0 ? response.status : '';
    const title = response.statusText || '';
    const status = `${code} ${title}`.trim();
    const reason = status ? `status code ${status}` : 'an unknown error';
    super(`Request failed with ${reason}`);
    Object.defineProperty(this, "response", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "request", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "options", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    this.name = 'HTTPError';
    this.response = response;
    this.request = request;
    this.options = options;
  }
}

class TimeoutError extends Error {
  constructor(request) {
    super('Request timed out');
    Object.defineProperty(this, "request", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    this.name = 'TimeoutError';
    this.request = request;
  }
}

// eslint-disable-next-line @typescript-eslint/ban-types
const isObject$3 = value => value !== null && typeof value === 'object';

const validateAndMerge = (...sources) => {
  for (const source of sources) {
    if ((!isObject$3(source) || Array.isArray(source)) && typeof source !== 'undefined') {
      throw new TypeError('The `options` argument must be an object');
    }
  }
  return deepMerge({}, ...sources);
};
const mergeHeaders = (source1 = {}, source2 = {}) => {
  const result = new globalThis.Headers(source1);
  const isHeadersInstance = source2 instanceof globalThis.Headers;
  const source = new globalThis.Headers(source2);
  for (const [key, value] of source.entries()) {
    if (isHeadersInstance && value === 'undefined' || value === undefined) {
      result.delete(key);
    } else {
      result.set(key, value);
    }
  }
  return result;
};
// TODO: Make this strongly-typed (no `any`).
const deepMerge = (...sources) => {
  let returnValue = {};
  let headers = {};
  for (const source of sources) {
    if (Array.isArray(source)) {
      if (!Array.isArray(returnValue)) {
        returnValue = [];
      }
      returnValue = [...returnValue, ...source];
    } else if (isObject$3(source)) {
      for (let [key, value] of Object.entries(source)) {
        if (isObject$3(value) && key in returnValue) {
          value = deepMerge(returnValue[key], value);
        }
        returnValue = {
          ...returnValue,
          [key]: value
        };
      }
      if (isObject$3(source.headers)) {
        headers = mergeHeaders(headers, source.headers);
        returnValue.headers = headers;
      }
    }
  }
  return returnValue;
};

const supportsAbortController = typeof globalThis.AbortController === 'function';
const supportsStreams = typeof globalThis.ReadableStream === 'function';
const supportsFormData = typeof globalThis.FormData === 'function';
const requestMethods = ['get', 'post', 'put', 'patch', 'head', 'delete'];
const responseTypes = {
  json: 'application/json',
  text: 'text/*',
  formData: 'multipart/form-data',
  arrayBuffer: '*/*',
  blob: '*/*'
};
// The maximum value of a 32bit int (see issue #117)
const maxSafeTimeout = 2147483647;
const stop = Symbol('stop');

const normalizeRequestMethod = input => requestMethods.includes(input) ? input.toUpperCase() : input;
const retryMethods = ['get', 'put', 'head', 'delete', 'options', 'trace'];
const retryStatusCodes = [408, 413, 429, 500, 502, 503, 504];
const retryAfterStatusCodes = [413, 429, 503];
const defaultRetryOptions = {
  limit: 2,
  methods: retryMethods,
  statusCodes: retryStatusCodes,
  afterStatusCodes: retryAfterStatusCodes,
  maxRetryAfter: Number.POSITIVE_INFINITY
};
const normalizeRetryOptions = (retry = {}) => {
  if (typeof retry === 'number') {
    return {
      ...defaultRetryOptions,
      limit: retry
    };
  }
  if (retry.methods && !Array.isArray(retry.methods)) {
    throw new Error('retry.methods must be an array');
  }
  if (retry.statusCodes && !Array.isArray(retry.statusCodes)) {
    throw new Error('retry.statusCodes must be an array');
  }
  return {
    ...defaultRetryOptions,
    ...retry,
    afterStatusCodes: retryAfterStatusCodes
  };
};

// `Promise.race()` workaround (#91)
const timeout = async (request, abortController, options) => new Promise((resolve, reject) => {
  const timeoutId = setTimeout(() => {
    if (abortController) {
      abortController.abort();
    }
    reject(new TimeoutError(request));
  }, options.timeout);
  void options.fetch(request).then(resolve).catch(reject).then(() => {
    clearTimeout(timeoutId);
  });
});
const delay = async ms => new Promise(resolve => {
  setTimeout(resolve, ms);
});

class Ky {
  // eslint-disable-next-line complexity
  constructor(input, options = {}) {
    Object.defineProperty(this, "request", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "abortController", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_retryCount", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "_input", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_options", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    this._input = input;
    this._options = {
      // TODO: credentials can be removed when the spec change is implemented in all browsers. Context: https://www.chromestatus.com/feature/4539473312350208
      credentials: this._input.credentials || 'same-origin',
      ...options,
      headers: mergeHeaders(this._input.headers, options.headers),
      hooks: deepMerge({
        beforeRequest: [],
        beforeRetry: [],
        beforeError: [],
        afterResponse: []
      }, options.hooks),
      method: normalizeRequestMethod(options.method ?? this._input.method),
      // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
      prefixUrl: String(options.prefixUrl || ''),
      retry: normalizeRetryOptions(options.retry),
      throwHttpErrors: options.throwHttpErrors !== false,
      timeout: typeof options.timeout === 'undefined' ? 10000 : options.timeout,
      fetch: options.fetch ?? globalThis.fetch.bind(globalThis)
    };
    if (typeof this._input !== 'string' && !(this._input instanceof URL || this._input instanceof globalThis.Request)) {
      throw new TypeError('`input` must be a string, URL, or Request');
    }
    if (this._options.prefixUrl && typeof this._input === 'string') {
      if (this._input.startsWith('/')) {
        throw new Error('`input` must not begin with a slash when using `prefixUrl`');
      }
      if (!this._options.prefixUrl.endsWith('/')) {
        this._options.prefixUrl += '/';
      }
      this._input = this._options.prefixUrl + this._input;
    }
    if (supportsAbortController) {
      this.abortController = new globalThis.AbortController();
      if (this._options.signal) {
        this._options.signal.addEventListener('abort', () => {
          this.abortController.abort();
        });
      }
      this._options.signal = this.abortController.signal;
    }
    this.request = new globalThis.Request(this._input, this._options);
    if (this._options.searchParams) {
      // eslint-disable-next-line unicorn/prevent-abbreviations
      const textSearchParams = typeof this._options.searchParams === 'string' ? this._options.searchParams.replace(/^\?/, '') : new URLSearchParams(this._options.searchParams).toString();
      // eslint-disable-next-line unicorn/prevent-abbreviations
      const searchParams = '?' + textSearchParams;
      const url = this.request.url.replace(/(?:\?.*?)?(?=#|$)/, searchParams);
      // To provide correct form boundary, Content-Type header should be deleted each time when new Request instantiated from another one
      if ((supportsFormData && this._options.body instanceof globalThis.FormData || this._options.body instanceof URLSearchParams) && !(this._options.headers && this._options.headers['content-type'])) {
        this.request.headers.delete('content-type');
      }
      this.request = new globalThis.Request(new globalThis.Request(url, this.request), this._options);
    }
    if (this._options.json !== undefined) {
      this._options.body = JSON.stringify(this._options.json);
      this.request.headers.set('content-type', this._options.headers.get('content-type') ?? 'application/json');
      this.request = new globalThis.Request(this.request, {
        body: this._options.body
      });
    }
  }
  // eslint-disable-next-line @typescript-eslint/promise-function-async
  static create(input, options) {
    const ky = new Ky(input, options);
    const fn = async () => {
      if (ky._options.timeout > maxSafeTimeout) {
        throw new RangeError(`The \`timeout\` option cannot be greater than ${maxSafeTimeout}`);
      }
      // Delay the fetch so that body method shortcuts can set the Accept header
      await Promise.resolve();
      let response = await ky._fetch();
      for (const hook of ky._options.hooks.afterResponse) {
        // eslint-disable-next-line no-await-in-loop
        const modifiedResponse = await hook(ky.request, ky._options, ky._decorateResponse(response.clone()));
        if (modifiedResponse instanceof globalThis.Response) {
          response = modifiedResponse;
        }
      }
      ky._decorateResponse(response);
      if (!response.ok && ky._options.throwHttpErrors) {
        let error = new HTTPError(response, ky.request, ky._options);
        for (const hook of ky._options.hooks.beforeError) {
          // eslint-disable-next-line no-await-in-loop
          error = await hook(error);
        }
        throw error;
      }
      // If `onDownloadProgress` is passed, it uses the stream API internally
      /* istanbul ignore next */
      if (ky._options.onDownloadProgress) {
        if (typeof ky._options.onDownloadProgress !== 'function') {
          throw new TypeError('The `onDownloadProgress` option must be a function');
        }
        if (!supportsStreams) {
          throw new Error('Streams are not supported in your environment. `ReadableStream` is missing.');
        }
        return ky._stream(response.clone(), ky._options.onDownloadProgress);
      }
      return response;
    };
    const isRetriableMethod = ky._options.retry.methods.includes(ky.request.method.toLowerCase());
    const result = isRetriableMethod ? ky._retry(fn) : fn();
    for (const [type, mimeType] of Object.entries(responseTypes)) {
      result[type] = async () => {
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        ky.request.headers.set('accept', ky.request.headers.get('accept') || mimeType);
        const awaitedResult = await result;
        const response = awaitedResult.clone();
        if (type === 'json') {
          if (response.status === 204) {
            return '';
          }
          if (options.parseJson) {
            return options.parseJson(await response.text());
          }
        }
        return response[type]();
      };
    }
    return result;
  }
  _calculateRetryDelay(error) {
    this._retryCount++;
    if (this._retryCount < this._options.retry.limit && !(error instanceof TimeoutError)) {
      if (error instanceof HTTPError) {
        if (!this._options.retry.statusCodes.includes(error.response.status)) {
          return 0;
        }
        const retryAfter = error.response.headers.get('Retry-After');
        if (retryAfter && this._options.retry.afterStatusCodes.includes(error.response.status)) {
          let after = Number(retryAfter);
          if (Number.isNaN(after)) {
            after = Date.parse(retryAfter) - Date.now();
          } else {
            after *= 1000;
          }
          if (typeof this._options.retry.maxRetryAfter !== 'undefined' && after > this._options.retry.maxRetryAfter) {
            return 0;
          }
          return after;
        }
        if (error.response.status === 413) {
          return 0;
        }
      }
      const BACKOFF_FACTOR = 0.3;
      return BACKOFF_FACTOR * 2 ** (this._retryCount - 1) * 1000;
    }
    return 0;
  }
  _decorateResponse(response) {
    if (this._options.parseJson) {
      response.json = async () => this._options.parseJson(await response.text());
    }
    return response;
  }
  async _retry(fn) {
    try {
      return await fn();
      // eslint-disable-next-line @typescript-eslint/no-implicit-any-catch
    } catch (error) {
      const ms = Math.min(this._calculateRetryDelay(error), maxSafeTimeout);
      if (ms !== 0 && this._retryCount > 0) {
        await delay(ms);
        for (const hook of this._options.hooks.beforeRetry) {
          // eslint-disable-next-line no-await-in-loop
          const hookResult = await hook({
            request: this.request,
            options: this._options,
            error: error,
            retryCount: this._retryCount
          });
          // If `stop` is returned from the hook, the retry process is stopped
          if (hookResult === stop) {
            return;
          }
        }
        return this._retry(fn);
      }
      throw error;
    }
  }
  async _fetch() {
    for (const hook of this._options.hooks.beforeRequest) {
      // eslint-disable-next-line no-await-in-loop
      const result = await hook(this.request, this._options);
      if (result instanceof Request) {
        this.request = result;
        break;
      }
      if (result instanceof Response) {
        return result;
      }
    }
    if (this._options.timeout === false) {
      return this._options.fetch(this.request.clone());
    }
    return timeout(this.request.clone(), this.abortController, this._options);
  }
  /* istanbul ignore next */
  _stream(response, onDownloadProgress) {
    const totalBytes = Number(response.headers.get('content-length')) || 0;
    let transferredBytes = 0;
    if (response.status === 204) {
      if (onDownloadProgress) {
        onDownloadProgress({
          percent: 1,
          totalBytes,
          transferredBytes
        }, new Uint8Array());
      }
      return new globalThis.Response(null, {
        status: response.status,
        statusText: response.statusText,
        headers: response.headers
      });
    }
    return new globalThis.Response(new globalThis.ReadableStream({
      async start(controller) {
        const reader = response.body.getReader();
        if (onDownloadProgress) {
          onDownloadProgress({
            percent: 0,
            transferredBytes: 0,
            totalBytes
          }, new Uint8Array());
        }
        async function read() {
          const {
            done,
            value
          } = await reader.read();
          if (done) {
            controller.close();
            return;
          }
          if (onDownloadProgress) {
            transferredBytes += value.byteLength;
            const percent = totalBytes === 0 ? 0 : transferredBytes / totalBytes;
            onDownloadProgress({
              percent,
              transferredBytes,
              totalBytes
            }, value);
          }
          controller.enqueue(value);
          await read();
        }
        await read();
      }
    }), {
      status: response.status,
      statusText: response.statusText,
      headers: response.headers
    });
  }
}

/*! MIT License © Sindre Sorhus */
const createInstance = defaults => {
  // eslint-disable-next-line @typescript-eslint/promise-function-async
  const ky = (input, options) => Ky.create(input, validateAndMerge(defaults, options));
  for (const method of requestMethods) {
    // eslint-disable-next-line @typescript-eslint/promise-function-async
    ky[method] = (input, options) => Ky.create(input, validateAndMerge(defaults, options, {
      method
    }));
  }
  ky.create = newDefaults => createInstance(validateAndMerge(newDefaults));
  ky.extend = newDefaults => createInstance(validateAndMerge(defaults, newDefaults));
  ky.stop = stop;
  return ky;
};
const ky = createInstance();

const fetchRemoteAsset = async (url, onProgress) => {
  const progressHandler = progress => {
    // const progressPercentage = ((progress.loaded/progress.total) * 100).toFixed(0);
    onProgress(progress.percent * 100);
  };

  // pgw 20-apr-2023
  // Set timeout to 60 seconds (rather than default, which is 10 seconds)
  const response = {
    data: await ky.get(url, {
      onDownloadProgress: progressHandler,
      timeout: 60000
    }).arrayBuffer()
  };
  return response;
};

localforage.config({
  name: 'multitrackPlayer',
  version: 1.0,
  storeName: 'audio_assets_store',
  // Should be alphanumeric, with underscores.
  description: 'Asset storage for the multitrackPlayer application'
});
const getAssetItem = localforage.getItem;
const setAssetItem = localforage.setItem;
const getAsset = async (url, cache = true, onFetchProgress) => {
  //fetches and returns array buffer of asset
  onFetchProgress(0);
  const cachedAsset = await getAssetItem(url);
  if (cachedAsset) {
    onFetchProgress(100);
    return cachedAsset;
  } else {
    // go and fetch asset over http
    const remoteResponse = await fetchRemoteAsset(url, onFetchProgress);
    const arrayBuffer = remoteResponse.data;
    if (cache) await setAssetItem(url, arrayBuffer);
    return arrayBuffer;
  }
};
const removeAssetFromCache = async assetId => {
  return await localforage.removeItem(assetId);
};
const clearAudioStorage = async () => await localforage.clear();

class AudioEngine {
  processorNode;
  webaudioManager;
  playing = false;
  superpowered = null;
  currentPositonPollingInterval = null;
  currentPosition = 0;
  peaks = {
    channels: []
  };
  constructor() {
    this.boot();
    this.sendPlayCommand = this.sendPlayCommand.bind(this);
    this.sendRecordCommand = this.sendRecordCommand.bind(this);
    this.loadChannelBuffers = this.loadChannelBuffers.bind(this);
    this.onMessageProcessorAudioScope = this.onMessageProcessorAudioScope.bind(this);
    this.sendRequestCurrentEngineStateCommand = this.sendRequestCurrentEngineStateCommand.bind(this);
    this.sendMasterMuteCommand = this.sendMasterMuteCommand.bind(this);
    this.getChannelPeak = this.getChannelPeak.bind(this);
    window.ramUsage = '0 mb';
    this.stateInterval = null;
  }
  async boot() {
    // await this.loadSP();
  }
  getChannelPeak(index) {
    if (this.peaks && this.peaks.channels.length) {
      // if (index === 9) console.log(this.peaks.channels[index]);
      return this.peaks.channels[index];
    } else {
      return 0;
    }
  }
  async loadSP(offlineRenderingOptions = null) {
    // pgw 22-jul-2024
    // Bug fix from Tom 
    // this.webaudioManager = new SuperpoweredWebAudio(48000, this.superpowered, offlineRenderingOptions);
    this.webaudioManager = new SuperpoweredWebAudio(44100, this.superpowered, offlineRenderingOptions);
    this.testTone = this.webaudioManager.audioContext.createOscillator();
    this.stereoInputNode = this.webaudioManager.audioContext.createPanner();
    this.testTone.channelInterpretation = 'speakers';
    this.testTone.start();
    this.superpoweredLoaded = true;
  }
  async unloadSp() {
    if (this.superpowered) {
      this.testTone = null;
      this.webaudioManager = null;
      this.superpowered = null;
    }
  }
  startCurrentEngineStatePolling() {
    // console.log('starting currentPositionPolling');
    if (this.processorNode) {
      this.stateInterval = setInterval(() => {
        if (this.processorNode) {
          this.sendRequestCurrentEngineStateCommand();
        } else {
          clearInterval(this.stateInterval);
        }
      }, 30);
    }
  }
  async onMessageProcessorAudioScope(message) {
    // console.log(message);
    if (message.event === "channelBuffersLoaded") {
      this.startCurrentEngineStatePolling();
      this.loadMultipleBuffersCallback();
      // this.encodedBuffers = null;
    }
    if (message.event === "singleChannelBufferLoaded") {
      if (this.loadSingleBufferCallback) this.loadSingleBufferCallback();
    }
    if (message.event === "bufferRecorded") {
      // get WAV file bytes and audio params of your audio source
      const wavBytes = getWavBytes(message.data.buffer, {
        isFloat: true,
        // floating point or 16-bit integer
        numChannels: 2,
        sampleRate: 48000
      });
      // console.log(wavBytes);
      const wav = new Blob([wavBytes], {
        type: "audio/wav"
      });

      // // create download link and append to Dom
      // const downloadLink = document.createElement("a");
      // downloadLink.href = URL.createObjectURL(wav);
      // downloadLink.innerText = "Download";
      // downloadLink.style.float = 'right';
      // downloadLink.setAttribute("download", "my-audio.wav"); // name file
      // document.getElementById("root").appendChild(downloadLink);

      // encode to mp3 and store in indexdb
      const arrayBufferWav = await wav.arrayBuffer();
      setAssetItem(message.data.id, arrayBufferWav);

      // const mp3URL = await endodeArrayBufferToMp3( `user${message.data.index}.mp3`, wavBytes,);
      // console.log(mp3URL);
      // // create download link and append to Dom
      // const downloadLink = document.createElement("a");
      // downloadLink.href = mp3URL;
      // downloadLink.innerText = "Download";
      // downloadLink.style.float = 'right';
      // downloadLink.setAttribute("download", "my-audio.mp3"); // name file
      // document.getElementById("root").appendChild(downloadLink);
      this.loadChannelEncodedBuffer(arrayBufferWav, message.data.index);
    }
    if (message.event === 'data-transfer-current-engine-state') {
      // console.log(message.value);
      this.currentPosition = message.value.currentPosition;
      this.peaks = message.value.peaks;
    }
    if (message.event === 'data-transfer-punch-in-point') ;
    if (message.event === 'data-transfer-punch-out-point') ;
    if (message.event === 'worklet-log') {
      // console.log(message);
      // this.currentPosition = message.value;

      if (message.payload.includes('WASM memory')) {
        let ramUsage = message.payload.split(',')[2].replace(' total.', '').trim();
        window.ramUsage = ramUsage;
        // const ramElement = document.getElementById('ram-display');
        // if (ramElement) ramElement.innerHTML = window.ramUsage;
      }
    }
    if (message.event === 'error') {
      alert(message.message);
    }
  }
  sendRequestCurrentEngineStateCommand() {
    if (this.processorNode) {
      this.processorNode.sendMessageToAudioScope({
        type: "command",
        payload: {
          id: "requestCurrentEngineState"
        }
      });
    }
  }
  sendSeekCommand(value) {
    if (this.processorNode) this.processorNode.sendMessageToAudioScope({
      type: "command",
      payload: {
        id: "seek",
        value
      }
    });
  }
  sendRequestPunchInPointCommand() {
    if (this.processorNode) this.processorNode.sendMessageToAudioScope({
      type: "command",
      payload: {
        id: "setAndRequestPunchInPoint"
      }
    });
  }
  sendRequestPunchOutPointCommand() {
    if (this.processorNode) this.processorNode.sendMessageToAudioScope({
      type: "command",
      payload: {
        id: "setAndRequestPunchOutPoint"
      }
    });
  }
  sendPlayCommand(offlineContext = false) {
    if (!offlineContext) this.webaudioManager.audioContext.resume();
    if (this.processorNode) this.processorNode.sendMessageToAudioScope({
      type: "command",
      payload: {
        id: "startPlayback"
      }
    });
    this.playing = true;
  }
  sendLoopCommand(startMs, endMs) {
    this.webaudioManager.audioContext.resume();
    if (this.processorNode) this.processorNode.sendMessageToAudioScope({
      type: "command",
      payload: {
        id: "setLoop",
        times: {
          startMs,
          endMs
        }
      }
    });
    if (!startMs && !endMs) {
      this.isLooping = false;
    } else {
      this.isLooping = true;
    }
  }
  sendPauseCommand() {
    if (this.processorNode) this.processorNode.sendMessageToAudioScope({
      type: "command",
      payload: {
        id: "pausePlayback"
      }
    });
    this.playing = false;
  }
  sendStopCommand() {
    if (this.processorNode) this.processorNode.sendMessageToAudioScope({
      type: "command",
      payload: {
        id: "stopPlayback"
      }
    });
    this.playing = false;
  }
  sendStopRecordCommand() {
    if (this.processorNode) this.processorNode.sendMessageToAudioScope({
      type: "command",
      payload: {
        id: "stopRecording"
      }
    });
    this.recording = false;
    this.playing = false;
  }
  sendRecordCommand() {
    this.webaudioManager.audioContext.resume();
    if (this.processorNode) this.processorNode.sendMessageToAudioScope({
      type: "command",
      payload: {
        id: "startRecording"
      }
    });
    this.recording = true;
  }
  sendMasterMuteCommand(value) {
    // console.log(this);
    if (this.processorNode) this.processorNode.sendMessageToAudioScope({
      type: "command",
      payload: {
        id: "setMasterMute",
        value
      }
    });
  }
  loadSamplerBuffer(buffer) {
    this.webaudioManager.audioContext.resume();
    if (this.processorNode) this.processorNode.sendMessageToAudioScope({
      type: "command",
      payload: {
        id: "loadSamplerBuffer",
        buffer: buffer
      }
    });
  }
  async createAudioWorklet(channelCount, offline = false) {
    // console.log(this.webaudioManager);
    await this.webaudioManager.audioContext.audioWorklet.addModule( /* webpackIgnore: true */
    `${process.env.PUBLIC_URL}/processorScripts/mixer-processor.js`);
    const getWasmResponse = await fetch(`${process.env.PUBLIC_URL}/lib/superpowered/superpowered.wasm`, {
      mode: "cors",
      redirect: "follow"
    });
    let WASMBytes = await getWasmResponse.arrayBuffer();
    this.processorNode = new AudioWorkletNode(this.webaudioManager.audioContext, "mixer-processor", {
      processorOptions: {
        moduleBytes: WASMBytes,
        samplerate: this.webaudioManager.audioContext.sampleRate,
        channelCount
      },
      numberOfInputs: 1,
      numberOfOutputs: 1,
      outputChannelCount: [2]
    });
    // WASMBytes = null;

    // Setup worklet ports and handlers
    this.processorNode.onprocessorerror = event => {
      console.error(event);
    };
    this.processorNode.port.onmessage = e => this.onMessageProcessorAudioScope(e.data);
    this.processorNode.sendMessageToAudioScope = data => this.processorNode.port.postMessage(data);
    if (!offline) this.webaudioManager.audioContext.suspend();
    this.processorNode.connect(this.webaudioManager.audioContext.destination);
    // this.splitter = this.webaudioManager.audioContext.createChannelSplitter(2);

    // this.testTone.connect(this.stereoNode);
    this.stereoInputNode.connect(this.processorNode);
    // this.splitter.connect(this.processorNode, 0, 0);
    // this.splitter.connect(this.processorNode, 1, 0);
    // this.testTone.connect(this.webaudioManager.audioContext.destination);
    if (!offline) this.webaudioManager.audioContext.resume();
  }
  async requestUserMicrophone() {
    if (!this.userGrantedInput) {
      this.userInputStream = await this.webaudioManager.getUserMediaForAudioAsync({
        'fastAndTransparentAudio': true
      });
      if (!this.userInputStream) throw Error('Could no access user microphone');
      this.userInputStreamSourceNode = this.webaudioManager.audioContext.createMediaStreamSource(this.userInputStream);
      this.userInputStreamSourceNode.connect(this.stereoInputNode);
      this.userGrantedInput = true;
    }
    return this.userGrantedInput;
  }
  async removeChannel(index) {
    if (this.processorNode) this.processorNode.sendMessageToAudioScope({
      type: "command",
      payload: {
        id: "removeChannel",
        index
      }
    });
    return true;
  }
  make_download(abuffer, total_samples) {
    var new_file = URL.createObjectURL(bufferToWave(abuffer, total_samples));
    var download_link = document.getElementById("download_link");
    download_link.href = new_file;
    var name = generateFileName();
    download_link.download = name;
  }
  async getAudioContextRender(fileName) {
    this.sendPlayCommand(true);
    const renderedBuffer = await this.webaudioManager.audioContext.startRendering();
    // console.log('Rendering completed successfully', renderedBuffer);

    const downloadLink = document.createElement("a");
    var renderUrl = URL.createObjectURL(bufferToWave(renderedBuffer, renderedBuffer.length));
    var name = generateFileName();
    downloadLink.href = renderUrl;
    downloadLink.download = name;
    downloadLink.style.display = 'none';
    downloadLink.setAttribute("download", `${fileName}.wav`); // name file
    document.getElementById("root").appendChild(downloadLink);
    downloadLink.click();
  }
  async destroyAudioWorklet() {
    if (this.processorNode) {
      this.stereoInputNode.disconnect(this.processorNode);
      this.processorNode.disconnect(this.webaudioManager.audioContext.destination);
      this.processorNode.sendMessageToAudioScope({
        type: 'destruct'
      });
      // this.processorNode.destruct();
      this.processorNode = null;
    }
  }
  destructProcessorMixerEngine(newChannelCount) {
    // console.log('destructProcessorMixerEngine in audioEngine')
    if (this.processorNode) this.processorNode.sendMessageToAudioScope({
      type: 'destruct-mixer-engine',
      payload: {
        newChannelCount
      }
    });
  }
  loadChannelBuffers(buffers) {
    // console.log('loadChannelBuffers');
    this.webaudioManager.audioContext.resume();
    if (this.processorNode) this.processorNode.sendMessageToAudioScope({
      type: "command",
      payload: {
        id: "loadChannelBuffers",
        buffers: buffers
      }
    });
  }
  loadChannelEncodedBuffer(encodedBuffer, index) {
    // console.log('loadChannelEncodedBuffer')
    return new Promise((resolve, reject) => {
      this.loadSingleBufferCallback = resolve;
      if (this.processorNode) this.processorNode.sendMessageToAudioScope({
        type: "command",
        payload: {
          id: "loadChannelEncodedBuffer",
          encodedBuffer,
          index
        }
      });
      // null for garbage collection on main thread;
      encodedBuffer = null;
    });
  }
  loadChannelEncodedBuffers(encodedBuffers) {
    // console.log('loadChannelEncodedBuffers ae');
    return new Promise((resolve, reject) => {
      this.loadMultipleBuffersCallback = resolve;
      if (this.processorNode) this.processorNode.sendMessageToAudioScope({
        type: "command",
        payload: {
          id: "loadChannelEncodedBuffers",
          encodedBuffers
        }
      });
      // null for garbage collection on main thread;
      encodedBuffers = null;
    });
  }
  loadAssets(assets) {
    if (this.processorNode) this.processorNode.sendMessageToAudioScope({
      type: "command",
      payload: {
        id: "loadPlayerAssets",
        assets: assets
      }
    });
  }
  addInputChannel(name, duration, channelId) {
    this.webaudioManager.audioContext.resume();
    if (this.processorNode) this.processorNode.sendMessageToAudioScope({
      type: "command",
      payload: {
        id: "addNewChannel",
        name,
        duration,
        channelId: channelId
      }
    });
  }
  sendChannelParamChange(channelIndex, paramName, value) {
    // console.log(channelIndex, paramName, value);
    // this.webaudioManager.audioContext.resume();
    if (this.processorNode) this.processorNode.sendMessageToAudioScope({
      type: "parameterChange",
      data: {
        scope: "channel",
        paramName: paramName,
        channelIndex: channelIndex,
        value: value
      }
    });
  }
  sendGlobalParamChange(paramName, value) {
    // this.webaudioManager.audioContext.resume();
    if (this.processorNode) this.processorNode.sendMessageToAudioScope({
      type: "parameterChange",
      data: {
        scope: "global",
        paramName: paramName,
        channelIndex: null,
        value: value
      }
    });
  }
}
function generateFileName() {
  var origin_name = 'offlineRender.wav';
  var pos = origin_name.lastIndexOf('.');
  var no_ext = origin_name.slice(0, pos);
  return no_ext + ".wav";
}

// Convert an AudioBuffer to a Blob using WAVE representation
function bufferToWave(abuffer, len) {
  var numOfChan = abuffer.numberOfChannels,
    length = len * numOfChan * 2 + 44,
    buffer = new ArrayBuffer(length),
    view = new DataView(buffer),
    channels = [],
    i,
    sample,
    offset = 0,
    pos = 0;

  // write WAVE header
  setUint32(0x46464952); // "RIFF"
  setUint32(length - 8); // file length - 8
  setUint32(0x45564157); // "WAVE"

  setUint32(0x20746d66); // "fmt " chunk
  setUint32(16); // length = 16
  setUint16(1); // PCM (uncompressed)
  setUint16(numOfChan);
  setUint32(abuffer.sampleRate);
  setUint32(abuffer.sampleRate * 2 * numOfChan); // avg. bytes/sec
  setUint16(numOfChan * 2); // block-align
  setUint16(16); // 16-bit (hardcoded in this demo)

  setUint32(0x61746164); // "data" - chunk
  setUint32(length - pos - 4); // chunk length

  // write interleaved data
  for (i = 0; i < abuffer.numberOfChannels; i++) channels.push(abuffer.getChannelData(i));
  while (pos < length) {
    for (i = 0; i < numOfChan; i++) {
      // interleave channels
      sample = Math.max(-1, Math.min(1, channels[i][offset])); // clamp
      sample = (0.5 + sample < 0 ? sample * 32768 : sample * 32767) | 0; // scale to 16-bit signed int
      view.setInt16(pos, sample, true); // write 16-bit sample
      pos += 2;
    }
    offset++; // next source sample
  }

  // create Blob
  return new Blob([buffer], {
    type: "audio/wav"
  });
  function setUint16(data) {
    view.setUint16(pos, data, true);
    pos += 2;
  }
  function setUint32(data) {
    view.setUint32(pos, data, true);
    pos += 4;
  }
}
const audioEngine = new AudioEngine();

const syncHeight = () => {
  document.documentElement.style.setProperty('--window-inner-height', `${window.innerHeight}px`);
};
const triggerBlobDownload = (blob, fileName) => {
  const downloadLink = document.createElement("a");
  downloadLink.href = URL.createObjectURL(blob);
  downloadLink.innerText = "Download ZIP";
  downloadLink.style.float = 'right';
  downloadLink.style.display = "none";
  downloadLink.setAttribute("download", fileName); // name file
  document.getElementById("root").appendChild(downloadLink);
  downloadLink.click();
  document.getElementById("root").removeChild(downloadLink);
};
const extraStemTitleProcessor = (title, otherTracksInSong) => {
  const allStemNames = otherTracksInSong.map(track => track.name);

  // remove common labelling
  title = title.replace(longest_common_starting_substring(allStemNames), '');

  // remove bracketed numbers - should be a regex really but there are only (1) and (2) in the json currently. Easier.
  title = title.replace('(1)', '').replace('(2)', '');

  // replace underscores with spaces
  title = title.replace('_', ' ');

  // convert to uppercase
  title = title.toUpperCase();

  // remove the words empty - regardless of where it positioned, we dont want it.
  title = title.replace('EMPTY', '');

  // trim any remaining space from either end
  title = title.trim();
  return title;
};
const longest_common_starting_substring = arr1 => {
  const arr = arr1.concat().sort();
  const a1 = arr[0];
  const a2 = arr[arr.length - 1];
  const L = a1.length;
  let i = 0;
  while (i < L && a1.charAt(i) === a2.charAt(i)) i++;
  return a1.substring(0, i);
};

const mountSessionInAudioEngine = async (session, offline = false, onProgress, clientConfig, cache) => {
  const updatedSession = {
    ...session
  };
  onProgress({
    step: 1,
    downloadPercentage: 0
  });
  let encodedAudioBuffers = [];
  if (session.song.pathzip) {
    let sessionSongZipFileResponse = await getAsset(session.song.pathzip, cache, downloadPercentage => onProgress({
      step: 1,
      downloadPercentage
    })); // needs to fetch from cache if available, otherwise fetch remotely, throw error if it fails to download (no internet connection)
    let unzippedSongObject = await unzipArrayBuffer(sessionSongZipFileResponse, (index, pro) => {});
    onProgress({
      step: 2,
      downloadPercentage: 100
    });
    const audioAssetFilenames = Object.getOwnPropertyNames(unzippedSongObject);
    // check number of tracks matches audioAssestFilenames length
    if (updatedSession.song.tracks.length !== audioAssetFilenames.length) throw new Error('Zip contains a different amount of stems to the number of stems defined in the song JSON');
    for (let index = 0; index < updatedSession.song.tracks.length; index++) {
      const trackName = `${updatedSession.song.tracks[index].name.replace(' ', '_')}`;
      encodedAudioBuffers[index] = await unzippedSongObject[trackName].arrayBuffer();
    }
  }
  onProgress({
    step: 3,
    downloadPercentage: 100
  });
  // console.log(audioEngine.processorNode);
  if (!audioEngine.processorNode || offline) {
    await audioEngine.createAudioWorklet(encodedAudioBuffers.length, offline);
  } else {
    await audioEngine.destructProcessorMixerEngine(encodedAudioBuffers.length);
  }

  // load buffers into audio engine
  // audioEngine.loadChannelBuffers.call(audioEngine, decodedAudioBuffers);
  await audioEngine.loadChannelEncodedBuffers.call(audioEngine, encodedAudioBuffers);
  onProgress({
    step: 5,
    downloadPercentage: 100
  });
  // return status

  let populatedStems = [];
  for (let index = 0; index < updatedSession.song.tracks.length; index++) {
    const trackLabel = clientConfig.logic.applyExtraLogicToStemTitles ? extraStemTitleProcessor(updatedSession.song.tracks[index].name, updatedSession.song.tracks) : clientConfig.logic.trimStemTitles ? updatedSession.song.tracks[index].name.split('_').pop() : updatedSession.song.tracks[index].name;
    const existingStemObject = updatedSession.stems.find(s => s.index === index);
    const stem = {
      index: index,
      id: trackLabel,
      label: trackLabel,
      level: existingStemObject ? existingStemObject.level : specialCaseChannels(clientConfig).includes(trackLabel) && !clientConfig.features.session.introChannelNames.includes(trackLabel) ? 0 : clientConfig.features.session.initialStemLevel,
      pan: existingStemObject ? existingStemObject.pan : 0.5,
      reverb: existingStemObject ? existingStemObject.reverb : {
        displayValue: "0",
        value: 0
      },
      muted: existingStemObject ? existingStemObject.muted : false,
      soloed: existingStemObject ? existingStemObject.soloed : false,
      isGuideChannel: specialCaseChannels(clientConfig).includes(trackLabel)
    };
    populatedStems.push(stem);
  }
  // console.log(JSON.stringify(populatedStems));
  populatedStems = populatedStems.sort((a, b) => Number(a.isGuideChannel) - Number(b.isGuideChannel));

  // addUserAudio (if any) to channel by pointer
  const populatedUserStems = [];
  for (const userStem of updatedSession.userStems) {
    const updatedUserStem = {
      ...userStem
    };
    updatedUserStem.armed = false; // mounted sessions alwasys set teh input channels to unarmed
    audioEngine.addInputChannel(updatedUserStem.label, session.song.len + 1, updatedUserStem.id);
    // fetch the audio from the cache
    const fetchedAsset = await getAssetItem(updatedUserStem.id);
    if (fetchedAsset) {
      await audioEngine.loadChannelEncodedBuffer(fetchedAsset, updatedUserStem.index);
    }
    populatedUserStems.push(updatedUserStem);
  }
  updatedSession.stems = populatedStems;
  updatedSession.userStems = populatedUserStems;
  return {
    ...updatedSession,
    sections: transformSections(updatedSession.song.chapters, updatedSession.song.len)
  };
};
const destructProcessorMixerEngine = async newChannelCount => {
  // desruct MixerEngine and channel, freeing up memory allocations in the WASM heap.
  await audioEngine.destructProcessorMixerEngine(newChannelCount);
  return true;
};
const syncAudioEngineChannelSettings = async (session, onProgress) => {
  const channelsToSync = session.stems.concat(session.userStems);
  const sessionHasAMutedChannel = channelsToSync.find(c => c.soloed);
  for (const channel of channelsToSync) {
    audioEngine.sendChannelParamChange(channel.index, 'channelGain', channel.level);
    audioEngine.sendChannelParamChange(channel.index, 'mute', sessionHasAMutedChannel ? !channel.soloed : channel.muted);
    audioEngine.sendChannelParamChange(channel.index, 'pan', channel.pan);
    if (channel.isInputChannel) audioEngine.sendChannelParamChange(channel.index, 'arm', channel.armed);
  }
  audioEngine.sendGlobalParamChange("playbackRate", session.speed.value);
  audioEngine.sendGlobalParamChange("pitchShiftCents", session.pitch.value);
  return true;
};
const resetAudioEngineChannelSettings = async (session, clientConfig) => {
  const channelsToSync = session.stems.concat(session.userStems).filter(c => !specialCaseChannels(clientConfig).includes(c.id));
  for (const channel of channelsToSync) {
    audioEngine.sendChannelParamChange(channel.index, 'channelGain', 1);
    audioEngine.sendChannelParamChange(channel.index, 'mute', false);
    audioEngine.sendChannelParamChange(channel.index, 'pan', 0.5);
    if (channel.isInputChannel) audioEngine.sendChannelParamChange(channel.index, 'arm', false);
  }
  audioEngine.sendGlobalParamChange("playbackRate", 1);
  audioEngine.sendGlobalParamChange("pitchShiftCents", 0);
};
const startAudioEngine = async (offlineRenderingOptions = null) => {
  await audioEngine.loadSP(offlineRenderingOptions);
};
const renderSession = async fileName => {
  await audioEngine.getAudioContextRender(fileName);
};
const unpackSetlist = async setlistZipBlob => {
  let setlistBlobs = await openSetlistZip(setlistZipBlob);
  return setlistBlobs;
};
const unpackSession = async sessionZipBlob => {
  let unzippedSession = await openSessionZip(sessionZipBlob);
  for (const audioAssetName of Object.getOwnPropertyNames(unzippedSession.audioAssets)) {
    await setAssetItem(audioAssetName, unzippedSession.audioAssets[audioAssetName]);
  }
  return unzippedSession.session;
};
const packSession = async session => {
  // Cretae new zip file
  const userAudioObjects = [];
  for (const userStem of session.userStems) {
    const fetchedAsset = await getAssetItem(userStem.id);
    if (fetchedAsset) {
      userAudioObjects.push({
        fileName: `${userStem.id}`,
        arrayBuffer: fetchedAsset
      });
    }
  }
  const zipBlob = await createSessionZip(session, userAudioObjects);
  return zipBlob;
};
const transformSections = (chapters, duration) => {
  const convertedDuration = Number(duration);
  return chapters.map((chapter, index) => ({
    label: chapter.name,
    start: chapter.time,
    end: chapters[index + 1]?.time || convertedDuration
  }));
};

const initialState$9 = {
  id: null,
  name: null,
  song: null,
  stems: [],
  // populated by the loadedSong
  userStems: [],
  // associated assets either in indexdb or contained in zip
  pitch: {
    displayValue: "0",
    value: 0
  },
  speed: {
    displayValue: "100%",
    value: 1
  },
  masterMute: false,
  currentPosition: 0,
  sections: [],
  playbackState: "stopped",
  isLooping: false,
  loopStartMs: null,
  loopEndMs: null,
  status: "empty",
  loadingProgress: 0,
  isSafari: navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1,
  isFirefox: navigator.userAgent.toLowerCase().indexOf('firefox') !== -1,
  duration: 0,
  createdAt: null,
  lastExportedAt: null,
  lastUpdatedAt: null,
  mediaSessionStarted: false,
  error: null
};

const specialCaseChannels = clientConfig => clientConfig.features.session.introChannelNames.concat(clientConfig.features.session.click1ChannelNames).concat(clientConfig.features.session.click2ChannelNames).concat(clientConfig.features.session.cueChannelNames);
const mountSessionAsync = createAsyncThunk("session/mount", async (payload, thunkAPI) => {
  thunkAPI.dispatch(stopSong());
  const loadedSession = thunkAPI.getState().session;
  const clientConfig = thunkAPI.getState().ui.clientConfig;

  // await thunkAPI.dispatch(unmountSessionAsync());

  thunkAPI.dispatch(updateStatus('loading'));
  if (!audioEngine.superpoweredLoaded) {
    await startAudioEngine();
    audioEngine.webaudioManager.audioContext.resume();
  } else {
    await destructProcessorMixerEngine(loadedSession.song.numStems);
  }
  const updatedSession = await mountSessionInAudioEngine(loadedSession, false, progressObject => thunkAPI.dispatch(updateProgress(progressObject)), clientConfig, payload.cache);
  await syncAudioEngineChannelSettings(updatedSession);
  return updatedSession;
});
const mountSessionAndRenderOfflineAsync = createAsyncThunk("session/mountAndRender", async (payload, thunkAPI) => {
  thunkAPI.dispatch(stopSong());
  const loadedSession = thunkAPI.getState().session;
  const clientConfig = thunkAPI.getState().ui.clientConfig;
  // await destructProcessorMixerEngine(loadedSession.song.len);

  thunkAPI.dispatch(updateStatus('loading'));
  await destructProcessorMixerEngine(loadedSession.song.tracks.length);
  // change the length of the render based on session speed
  await startAudioEngine({
    length: loadedSession.song.len * (1 / loadedSession.speed.value)
  });
  if (audioEngine.processorNode) audioEngine.processorNode.disconnect();
  audioEngine.processorNode = null;
  thunkAPI.dispatch(updateProgress({
    step: 7,
    downloadPercentage: 100
  }));
  const updatedSession = await mountSessionInAudioEngine(loadedSession, true, value => thunkAPI.dispatch(updateProgress(value)), clientConfig, payload.cache);
  await syncAudioEngineChannelSettings(updatedSession);
  thunkAPI.dispatch(updateProgress({
    step: 8,
    downloadPercentage: 100
  }));
  const dateNow = new Date();
  await renderSession(`mix_${dateNow.toLocaleDateString().replaceAll('/', '')}_${dateNow.toLocaleTimeString().replaceAll(':', '')}`);
  thunkAPI.dispatch(updateProgress({
    step: 9,
    downloadPercentage: 100
  }));

  //remount the online audiocontext session
  // await thunkAPI.dispatch(unmountSessionAsync());
  // await thunkAPI.dispatch(openSession(loadedSession));
  // await thunkAPI.dispatch(mountSessionAsync());
  await thunkAPI.dispatch(updateStatus('loading'));
  return updatedSession;
});
const resetSessionMixerSettings = createAsyncThunk("session/reset", async (payload, thunkAPI) => {
  const loadedSession = thunkAPI.getState().session;
  const clientConfig = thunkAPI.getState().ui.clientConfig;
  await resetAudioEngineChannelSettings(loadedSession, clientConfig);
});
const unmountSessionAsync = createAsyncThunk("session/unmount", async (payload, thunkAPI) => {
  // await unmountSessionInAudioEngine();

  return initialState$9;
});
const packSessionAsync = createAsyncThunk("session/pack", async (payload, thunkAPI) => {
  const loadedSession = thunkAPI.getState().session;
  const sessionBlob = await packSession(loadedSession);
  triggerBlobDownload(sessionBlob);
  return true;
});
const findChannel = (state, index, userStem) => {
  return state[userStem ? "userStems" : "stems"].find(s => s.index === index);
};
const attachUserMicrophoneAsync = createAsyncThunk("session/attachUserInput", async thunkAPI => {
  return await audioEngine.requestUserMicrophone();
});
const removeChannelAsync = createAsyncThunk("session/removeChannel", async (payload, thunkAPI) => {
  await audioEngine.removeChannel(payload.index);
  await removeAssetFromCache(payload.id);
  return payload;
});

//todo - the whole state[action.payload.userStem ? "userStems" : "stems"] thing is really messy, replace with one function.

const sessionSlice = createSlice({
  name: "session",
  initialState: initialState$9,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    updateProgress: (state, action) => {
      state.loadingProgress = action.payload;
    },
    openSession: (state, action) => {
      Object.getOwnPropertyNames(action.payload).forEach(propertyName => {
        state[propertyName] = action.payload[propertyName];
      });
      state.status = "unmounted";
    },
    resetLoadedStatus: state => {
      // state.status = "empty";
      // state.loadingProgress = 0;
      // state.loadedSong = null;
    },
    changeGlobalPlaybackRate: (state, action) => {
      const denormalised = (action.payload + 1.5) / 2.0;
      state.speed.displayValue = String((denormalised * 100).toFixed(0) + "%");
      state.speed.value = action.payload;
      audioEngine.sendGlobalParamChange("playbackRate", denormalised);
    },
    decreaseGlobalPlaybackRate: state => {
      if (state.speed.value > 0.5) {
        state.speed.value = Number((state.speed.value - 0.1).toFixed(1));
        state.speed.displayValue = `${(state.speed.value * 100).toFixed()}%`;
        audioEngine.sendGlobalParamChange("playbackRate", state.speed.value);
      }
    },
    increaseGlobalPlaybackRate: state => {
      if (state.speed.value < 1.5) {
        state.speed.value = Number((state.speed.value + 0.1).toFixed(1));
        state.speed.displayValue = `${(state.speed.value * 100).toFixed()}%`;
        audioEngine.sendGlobalParamChange("playbackRate", state.speed.value);
      }
    },
    changeGlobalPitch: (state, action) => {
      const scale = action.payload / 1;
      const denormalised = (500 - -500) * scale + -500;
      state.pitch.displayValue = String(denormalised.toFixed(0));
      state.pitch.value = action.payload;
      audioEngine.sendGlobalParamChange("pitchShiftCents", denormalised);
    },
    decreaseGlobalPitchRate: state => {
      if (state.pitch.value > -500) {
        state.pitch.value = state.pitch.value - 100;
        state.pitch.displayValue = `${state.pitch.value > 0 ? '+' : ''}${state.pitch.value / 100}${state.pitch.value !== 0 ? 'st' : ''}`;
        audioEngine.sendGlobalParamChange("pitchShiftCents", state.pitch.value);
      }
    },
    increaseGlobalPitchRate: state => {
      if (state.pitch.value < 500) {
        state.pitch.value = state.pitch.value + 100;
        state.pitch.displayValue = `${state.pitch.value > 0 ? '+' : ''}${state.pitch.value / 100}${state.pitch.value !== 0 ? 'st' : ''}`;
        audioEngine.sendGlobalParamChange("pitchShiftCents", state.pitch.value);
      }
    },
    changeChannelGain: (state, action) => {
      findChannel(state);
      state[action.payload.userStem ? "userStems" : "stems"].find(s => s.index === action.payload.index).level = action.payload.value;
      audioEngine.sendChannelParamChange(action.payload.index, "channelGain", action.payload.value);
    },
    muteChannel: (state, action) => {
      state[action.payload.userStem ? "userStems" : "stems"].find(s => s.index === action.payload.index).muted = true;
      audioEngine.sendChannelParamChange(action.payload.index, "mute", true);
    },
    unmuteChannel: (state, action) => {
      state[action.payload.userStem ? "userStems" : "stems"].find(s => s.index === action.payload.index).muted = false;
      audioEngine.sendChannelParamChange(action.payload.index, "mute", false);
    },
    soloChannel: (state, action) => {
      if (state[action.payload.userStem ? "userStems" : "stems"].find(s => s.index === action.payload.index).muted) state[action.payload.userStem ? "userStems" : "stems"].find(s => s.index === action.payload.index).muted = false;
      state[action.payload.userStem ? "userStems" : "stems"].find(s => s.index === action.payload.index).soloed = true;
      audioEngine.sendChannelParamChange(action.payload.index, "mute", false);
      for (let index = 0; index < state.stems.concat(state.userStems).length; index++) {
        // console.log(index,state.stems.concat(state.userStems) );
        const stem = state.stems.concat(state.userStems)[index];
        if (!stem.soloed) audioEngine.sendChannelParamChange(stem.index, "mute", true);
      }
    },
    armChannel: (state, action) => {
      state[action.payload.userStem ? "userStems" : "stems"].find(s => s.index === action.payload.index).muted = true;
      state[action.payload.userStem ? "userStems" : "stems"].find(s => s.index === action.payload.index).armed = true;
      audioEngine.sendChannelParamChange(action.payload.index, "arm", true);
      audioEngine.sendChannelParamChange(action.payload.index, "mute", true);
    },
    disarmChannel: (state, action) => {
      state[action.payload.userStem ? "userStems" : "stems"].find(s => s.index === action.payload.index).armed = false;
      audioEngine.sendChannelParamChange(action.payload.index, "arm", false);
    },
    unsoloChannel: (state, action) => {
      state[action.payload.userStem ? "userStems" : "stems"].find(s => s.index === action.payload.index).soloed = false;
      audioEngine.sendChannelParamChange(action.payload.index, "mute", true);
      if (!state[action.payload.userStem ? "userStems" : "stems"].find(s => s.soloed)) {
        for (let index = 0; index < state.stems.concat(state.userStems).length; index++) {
          const stem = state.stems.concat(state.userStems)[index];
          if (!stem.muted) audioEngine.sendChannelParamChange(index, "mute", false);
        }
      }
    },
    changeChannelPan: (state, action) => {
      state[action.payload.userStem ? "userStems" : "stems"].find(s => s.index === action.payload.index).pan = action.payload.value;
      audioEngine.sendChannelParamChange(action.payload.index, "pan", action.payload.value);
    },
    playSong: state => {
      state.playbackState = "playing";
      audioEngine.sendPlayCommand();
    },
    recordSong: state => {
      audioEngine.sendLoopCommand(null, null);
      state.isLooping = false;
      state.playbackState = "recording";
      audioEngine.sendRecordCommand();
    },
    pauseSong: state => {
      state.playbackState = "paused";
      audioEngine.sendPauseCommand();

      //show feedback modal if not shown before
    },
    seek: (state, action) => {
      audioEngine.sendLoopCommand(null, null);
      audioEngine.sendSeekCommand(action.payload);
      state.isLooping = false;
    },
    stopSong: state => {
      try {
        if (audioEngine) {
          audioEngine.sendLoopCommand(null, null);
          state.isLooping = false;
          if (state.playbackState === "recording") {
            audioEngine.sendStopRecordCommand();
          } else {
            audioEngine.sendStopCommand();
          }
        }
      } catch (e) {
        console.log(e);
      }
      state.playbackState = "stopped";
    },
    addNewStem: (state, action) => {
      // unarm existing channels
      for (const userStem of state.userStems) {
        userStem.armed = false;
        audioEngine.sendChannelParamChange(userStem.index, "arm", false);
      }
      const newStem = {
        index: state.stems.length + state.userStems.length,
        id: `user-audio-${state.id}-${v4().slice(0, 8)}`,
        label: action.payload.name,
        level: 0.8,
        pan: 0.5,
        reverb: {
          displayValue: "0",
          value: 0
        },
        isInputChannel: true,
        muted: true,
        soloed: false,
        armed: true
      };
      state.userStems = [...state.userStems, newStem];
      audioEngine.addInputChannel(action.payload.name, state.song.len, newStem.id);
    },
    toggleMasterMute: state => {
      state.masterMute = state.masterMute ? false : true;
      audioEngine.sendMasterMuteCommand(state.masterMute);
    },
    updateStatus: (state, action) => {
      state.status = action.payload;
    },
    setIntroLevel: (state, action) => {
      const foundChannel = state.stems.find(s => state.ui.clientConfig.features.session.introChannelNames.includes(s.id));
      if (foundChannel) {
        foundChannel.level = action.payload;
        audioEngine.sendChannelParamChange(foundChannel.index, "channelGain", action.payload);
      }
    },
    setClick1Level: (state, action) => {
      const foundChannel = state.stems.find(s => state.ui.clientConfig.features.session.click1ChannelNames.includes(s.id));
      if (foundChannel) {
        foundChannel.level = action.payload;
        audioEngine.sendChannelParamChange(foundChannel.index, "channelGain", action.payload);
      }
    },
    setClick2Level: (state, action) => {
      const foundChannel = state.stems.find(s => state.ui.clientConfig.features.session.click2ChannelNames.includes(s.id));
      if (foundChannel) {
        foundChannel.level = action.payload;
        audioEngine.sendChannelParamChange(foundChannel.index, "channelGain", action.payload);
      }
    },
    setCueLevel: (state, action) => {
      const foundChannel = state.stems.find(s => state.ui.clientConfig.features.session.cueChannelNames.includes(s.id));
      if (foundChannel) {
        foundChannel.level = action.payload;
        audioEngine.sendChannelParamChange(foundChannel.index, "channelGain", action.payload);
      }
    },
    setIsLooping: (state, action) => {
      if (action.payload.endMs) {
        state.loopStartMs = action.payload.startMs;
        state.loopEndMs = action.payload.endMs;
        state.isLooping = true;
      } else {
        state.loopStart = null;
        state.loopEnd = null;
        state.isLooping = false;
      }
      audioEngine.sendLoopCommand(action.payload.startMs, action.payload.endMs);
    },
    setMediaSessionStarted: (state, action) => {
      state.mediaSessionStarted = action.payload;
    }
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: builder => {
    builder.addCase(mountSessionAsync.pending, state => {
      state.status = "loading";
    }).addCase(mountSessionAsync.rejected, (state, action) => {
      state.status = "error";
      state.error = action.error.message;
      console.error(action);
    }).addCase(mountSessionAsync.fulfilled, (state, action) => {
      Object.getOwnPropertyNames(action.payload).forEach(propertyName => {
        state[propertyName] = action.payload[propertyName];
      });
      state.status = "ready";
    }).addCase(mountSessionAndRenderOfflineAsync.pending, state => {
      state.status = "rendering";
    }).addCase(mountSessionAndRenderOfflineAsync.rejected, (state, action) => {
      state.status = "error";
      console.error(action);
    }).addCase(mountSessionAndRenderOfflineAsync.fulfilled, (state, action) => {
      window.location.reload();
      state.status = "ready";
    }).addCase(unmountSessionAsync.pending, state => {
      Object.getOwnPropertyNames(initialState$9).forEach(propertyName => {
        state[propertyName] = initialState$9[propertyName];
      });
    }).addCase(unmountSessionAsync.rejected, (state, action) => {
      state.status = "error";
      console.error(action);
    }).addCase(unmountSessionAsync.fulfilled, (state, action) => {
      Object.getOwnPropertyNames(initialState$9).forEach(propertyName => {
        state[propertyName] = action.payload[propertyName];
      });
    }).addCase(attachUserMicrophoneAsync.pending, state => {
      state.userAudio = "pending";
    }).addCase(attachUserMicrophoneAsync.fulfilled, (state, action) => {
      state.userAudio = "granted";
    }).addCase(packSessionAsync.pending, (state, action) => {
      state.status = "packing";
      state.loadingProgress = {
        step: 6,
        downloadPercentage: 100
      };
    }).addCase(packSessionAsync.rejected, (state, action) => {
      state.status = "error";
      console.error(action);
    }).addCase(packSessionAsync.fulfilled, (state, action) => {
      state.status = "ready";
      state.loadingProgress = {
        step: 10,
        downloadPercentage: 100
      };
    }).addCase(resetSessionMixerSettings.rejected, (state, action) => {
      state.status = "error";
      console.error(action);
    }).addCase(resetSessionMixerSettings.fulfilled, (state, action) => {
      // let stemsToReset = state.stems.filter(c => !specialCaseChannels(state.ui.clientConfig).includes(c.id));
      let stemsToReset = state.stems;
      let userStems = state.userStems;
      for (let index = 0; index < stemsToReset.length; index++) {
        stemsToReset[index].level = 1;
        stemsToReset[index].pan = 0.5;
        stemsToReset[index].muted = false;
        stemsToReset[index].soloed = false;
      }
      for (let index = 0; index < userStems.length; index++) {
        userStems[index].level = 1;
        userStems[index].pan = 0.5;
        userStems[index].muted = false;
        userStems[index].soloed = false;
      }
      state.speed.value = 1;
      state.speed.displayValue = '100%';
      state.pitch.value = 0;
      state.pitch.displayValue = '0';
    }).addCase(removeChannelAsync.fulfilled, (state, action) => {
      state.userStems = [...state.userStems.filter(s => s.id !== action.payload.id)];
      for (const userStem of state.userStems) {
        if (userStem.index > action.payload.index) userStem.index = userStem.index - 1;
      }
    });
  }
});
const {
  changeChannelGain,
  changeGlobalPlaybackRate,
  decreaseGlobalPlaybackRate,
  increaseGlobalPlaybackRate,
  changeGlobalPitch,
  decreaseGlobalPitchRate,
  increaseGlobalPitchRate,
  muteChannel,
  unmuteChannel,
  soloChannel,
  unsoloChannel,
  changeChannelPan,
  updateProgress,
  resetLoadedStatus,
  playSong,
  pauseSong,
  stopSong,
  recordSong,
  addNewStem,
  armChannel,
  disarmChannel,
  toggleMasterMute,
  openSession,
  updateStatus,
  setIntroLevel,
  setClick1Level,
  setClick2Level,
  setCueLevel,
  setIsLooping,
  setMediaSessionStarted,
  seek
} = sessionSlice.actions;
const selectStatus = state => state.session.status;
const selectIsLooping = state => state.session.isLooping;
const selectLoopStart = state => state.session.loopStartMs;
const selectLoopEnd = state => state.session.loopEndMs;
const selectSession = state => state.session;
const selectSections = state => state.session.sections;
const selectTitle = state => state.session.title;
const selectArtist = state => state.session.artist;
const selectDuration = state => state.session.song?.len || 0;
const selectUserStems = state => state.session.userStems;
const selectSpeed = state => state.session.speed;
const selectPitch = state => state.session.pitch;
const selectLoadingProgress = state => state.session.loadingProgress;
const selectIsMasterMuted = state => state.session.masterMute;
const selectPlaybackState = state => state.session.playbackState;
const selectMediaSessionStarted = state => state.session.mediaSessionStarted;
const selectError$1 = state => state.session.error;
const selectIntroLevel = state => {
  const foundChannel = state.session?.stems?.find(s => state.ui.clientConfig.features.session.introChannelNames.includes(s.id));
  return foundChannel && state.session?.song ? foundChannel.level : null;
};
const selectClick1Level = state => {
  const foundChannel = state.session?.stems?.find(s => state.ui.clientConfig.features.session.click1ChannelNames.includes(s.id));
  return foundChannel && state.session?.song ? foundChannel.level : null;
};
const selectClick2Level = state => {
  const foundChannel = state.session?.stems?.find(s => state.ui.clientConfig.features.session.click2ChannelNames.includes(s.id));
  return foundChannel && state.session?.song ? foundChannel.level : null;
};
const selectCueLevel = state => {
  const foundChannel = state.session?.stems?.find(s => state.ui.clientConfig.features.session.cueChannelNames.includes(s.id));
  return foundChannel && state.session?.song ? foundChannel.level : null;
};
const selectStems = state => {
  return state.session.stems;
};
var sessionReducer = sessionSlice.reducer;

const packSetlist$1 = async sessions => {
  // create a zip of each session
  const sessionZips = {};
  for (const session of sessions) {
    sessionZips[session.id] = await packSession(session);
  }

  // Cretae new zip file
  const setListZip = await createSetlistZip(sessionZips);
  return setListZip;
};
async function generateShortLink(endpoint, long_url) {
  const response = await fetch(endpoint, {
    method: 'POST',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      long_url
    })
  });
  if (response.status === 200) {
    const result = await response.json();
    return result.link;
  } else {
    throw new Error("Error fetching short link");
  }
}

const initialState$8 = {
  sessions: [],
  status: "idle",
  lastCreatedSession: null
};

const initialState$7 = {
  sidebarOpen: false,
  notifications: [],
  error: {},
  newTrackModalVisible: false,
  feedbackModalVisible: false,
  offlineModalVisible: false,
  iOSModalVisible: false,
  userInputtingText: false,
  dismissedOfflineNotification: false,
  wasmMemoryUsage: 0,
  clientConfig: null,
  showLyrics: false,
  soloMode: false,
  showDeveloperTools: false,
  parentVersion: null,
  appStarted: false
};

const addNotificationAsync = createAsyncThunk("ui/addNotification", async (payload, thunkAPI) => {
  const id = v4().slice(0, 8);
  const notificationTimeout = thunkAPI.getState().ui.clientConfig.features.notifications.timeout;
  setTimeout(() => {
    thunkAPI.dispatch(removeNotification(id));
  }, notificationTimeout);
  return {
    ...payload,
    id
  };
});
const uiSlice = createSlice({
  name: 'ui',
  initialState: initialState$7,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    toggleSidebar: (state, action) => {
      state.sidebarOpen = action.payload;
    },
    setShowLyrics: (state, action) => {
      state.showLyrics = action.payload;
    },
    setNewTrackModalVisible: (state, action) => {
      state.newTrackModalVisible = action.payload;
    },
    setDismissedOfflineNotification: (state, action) => {
      state.dismissedOfflineNotification = action.payload;
    },
    setFeedbackModalVisible: (state, action) => {
      if (action.payload) {
        if (!localStorage.getItem("feedbackSubmittedA")) {
          state.feedbackModalVisible = true;
        }
      } else {
        state.feedbackModalVisible = false;
        localStorage.setItem("feedbackSubmittedA", true);
      }
    },
    setIOSModalVisible: (state, action) => {
      state.iOSModalVisible = action.payload;
    },
    setWasmMemoryUsage: (state, action) => {
      state.wasmMemoryUsage = action.payload;
    },
    setClientConfig: (state, action) => {
      state.clientConfig = action.payload;
    },
    removeNotification: (state, action) => {
      state.notifications = [...state.notifications.filter(n => n.id !== action.payload)];
    },
    resetNotifications: (state, action) => {
      state.notifications = [];
    },
    submitFeedback: (state, action) => {
      ReactGA.event('user_feedback', action.payload);
      localStorage.setItem("feedbackSubmittedA", true);
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setUserInputtingText: (state, action) => {
      state.userInputtingText = action.payload;
    },
    setSoloMode: (state, action) => {
      state.soloMode = action.payload;
    },
    setShowDeveloperTools: (state, action) => {
      state.showDeveloperTools = action.payload;
    },
    setParentVersion: (state, action) => {
      state.parentVersion = action.payload;
    },
    setOfflineModalVisible: (state, action) => {
      state.offlineModalVisible = action.payload;
    },
    setAppStarted: (state, action) => {
      state.appStarted = action.payload;
    }
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: builder => {
    builder.addCase(addNotificationAsync.fulfilled, (state, action) => {
      state.notifications = [...state.notifications, action.payload];
    });
  }
});
const {
  setSoloMode,
  setError,
  toggleSidebar,
  removeNotification,
  resetNotifications,
  setWasmMemoryUsage,
  setNewTrackModalVisible,
  setIOSModalVisible,
  setFeedbackModalVisible,
  submitFeedback,
  setDismissedOfflineNotification,
  setClientConfig,
  setShowLyrics,
  setUserInputtingText,
  setShowDeveloperTools,
  setParentVersion,
  setOfflineModalVisible,
  setAppStarted
} = uiSlice.actions;
const selectSidebarOpen = state => state.ui.sidebarOpen;
const selectNotifications = state => state.ui.notifications;
const selectNewTrackModalVisible = state => state.ui.newTrackModalVisible;
const selectFeedbackModalVisible = state => state.ui.feedbackModalVisible;
const selectDismissedOfflineNotification = state => state.ui.dismissedOfflineNotification;
const selectiOSModalVisible = state => state.ui.iOSModalVisible;
const selectClientConfig = state => state.ui.clientConfig;
const selectShowLyrics = state => state.ui.showLyrics;
const selectUserInputtingText = state => state.ui.userInputtingText;
const selectSoloMode = state => state.ui.soloMode;
const selectError = state => state.ui.error;
const selectShowDeveloperTools = state => state.ui.showDeveloperTools;
const selectParentVersion = state => state.ui.parentVersion;
const selectOfflineModalVisible = state => state.ui.offlineModalVisible;
const selectAppStarted = state => state.ui.appStarted;
var uiReducer = uiSlice.reducer;

const unpackSessionAsync$1 = createAsyncThunk("session/unpack", async (payload, thunkAPI) => {
  const sessionObject = await unpackSession(payload);
  return sessionObject;
});
const unpackSetlistAsync$1 = createAsyncThunk("session/unpackSetlist", async (payload, thunkAPI) => {
  const setlistObject = await unpackSetlist(payload);
  const setlistSessions = [];
  for (const setlistKey of Object.getOwnPropertyNames(setlistObject)) {
    const sessionBlob = setlistObject[setlistKey];
    const sessionObject = await unpackSession(sessionBlob);
    setlistSessions.push(sessionObject);
  }
  return setlistSessions;
});
const packSetlistAsync$1 = createAsyncThunk("session/packSetlist", async (payload, thunkAPI) => {
  // get setlist session from state
  // filter out all containing userAudio stems
  const sessions = thunkAPI.getState().setlist.sessions.filter(s => s.userStems.length === 0);

  // add all session zips into one master .setlist zip file
  const setListBlob = await packSetlist$1(sessions);

  // prompt download in browser 👍
  const dateNow = new Date();
  const setlistFilename = `mySetlist-${dateNow.toLocaleDateString().replaceAll('/', '')}_${dateNow.toLocaleTimeString().replaceAll(':', '')}.setlist`;
  triggerBlobDownload(setListBlob, setlistFilename);
  thunkAPI.dispatch(addNotificationAsync({
    title: 'Setlist saved',
    text: `${setlistFilename} was downloaded`,
    type: 'positive'
  }));
  return true;
});
const removeSessionFromSetlistAsync$1 = createAsyncThunk("setlsit/remove", async (payload, thunkAPI) => {
  // remove associated items from cache
  const session = thunkAPI.getState().setlist.sessions.find(s => s.id == payload);
  for (const userStem of session.userStems) {
    await removeAssetFromCache(userStem.id);
  }
  //remove associated song zip
  await removeAssetFromCache(session.song.pathzip);
  return payload;
});
const setlistSlice = createSlice({
  name: 'setlist',
  initialState: initialState$8,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    createEmptySession: (state, action) => {
      const newSession = {
        ...initialState$9,
        id: v4().slice(0, 8),
        title: action.payload.title,
        createdAt: new Date().toISOString(),
        song: {
          mix: action.payload.title,
          artist: '',
          len: 360,
          stems: [],
          userStems: []
        }
      };
      state.sessions.push(newSession);
    },
    createSessionFromSong: (state, action) => {
      const newSession = {
        ...initialState$9,
        id: v4().slice(0, 8),
        title: action.payload.title,
        song: action.payload.song,
        createdAt: new Date().toISOString(),
        lastUpdatedAt: new Date().toISOString()
      };
      state.lastCreatedSession = newSession.id;
      state.sessions.push(newSession);
    },
    resetLastCreated: state => {
      state.lastCreatedSession = null;
    },
    addSongToMySetlist: (state, action) => {
      state.sessions.push(action.payload);
    },
    saveExistingSession: (state, action) => {
      state.sessions = state.sessions.filter(s => s.id !== action.payload.id);
      state.sessions = [...state.sessions, {
        ...action.payload,
        lastUpdatedAt: new Date().toISOString()
      }];
    }
    // // Use the PayloadAction type to declare the contents of `action.payload`
    // incrementByAmount: (state, action) => {
    //   state.value += action.payload;
    // },
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: builder => {
    builder.addCase(removeSessionFromSetlistAsync$1.fulfilled, (state, action) => {
      state.sessions = state.sessions.filter(s => s.id !== action.payload);
    }).addCase(packSetlistAsync$1.pending, (state, action) => {}).addCase(packSetlistAsync$1.rejected, (state, action) => {
      state.status = "error";
      console.error(action);
    }).addCase(packSetlistAsync$1.fulfilled, (state, action) => {}).addCase(unpackSessionAsync$1.pending, (state, action) => {
      state.status = "unpacking";
      state.loadingProgress = 7;
    }).addCase(unpackSessionAsync$1.rejected, (state, action) => {
      state.status = "error";
      console.error(action);
    }).addCase(unpackSessionAsync$1.fulfilled, (state, action) => {
      Object.getOwnPropertyNames(action.payload).forEach(propertyName => {
        state[propertyName] = action.payload[propertyName];
      });
      const newSession = {
        ...action.payload,
        id: v4().slice(0, 8),
        imported: true,
        importedAt: new Date().toISOString()
      };
      state.sessions.push(newSession);
      state.status = "ready";
      state.loadingProgress = 10;
    }).addCase(unpackSetlistAsync$1.fulfilled, (state, action) => {
      const sessionPack = [];
      for (const session of action.payload) {
        const importedSession = {};
        Object.getOwnPropertyNames(session).forEach(propertyName => {
          importedSession[propertyName] = session[propertyName];
        });
        const newSession = {
          ...importedSession,
          id: v4().slice(0, 8),
          imported: true,
          importedAt: new Date().toISOString()
        };
        sessionPack.push(newSession);
      }
      state.sessions = [...state.sessions, ...sessionPack];
    });
  }
});
const {
  addSongToMySetlist,
  createEmptySession,
  createSessionFromSong,
  saveExistingSession,
  resetLastCreated
} = setlistSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
const selectSetlistSessions = state => state.setlist.sessions;
const selectLastCreatedSession = state => state.setlist.lastCreatedSession;
// // We can also write thunks by hand, which may contain both sync and async logic.
// // Here's an example of conditionally dispatching actions based on current state.
// export const incrementIfOdd = (amount) => (dispatch, getState) => {
//   const currentValue = selectCount(getState());
//   if (currentValue % 2 === 1) {
//     dispatch(incrementByAmount(amount));
//   }
// };

var setlistReducer = setlistSlice.reducer;

const LoginPage = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const loginStatus = useSelector(selectStatus$1);
  const loginErrorMessage = useSelector(selectErrorMessage);
  useSelector(selectSession);
  const setlistSessions = useSelector(selectSetlistSessions);
  const clientConfiguration = useSelector(selectClientConfig);
  const [password, setPassword] = useState('Blesssing432%');
  const [username, setUsername] = useState('peter');

  // const [password, setPassword] = useState('');
  // const [username, setUsername] = useState('');

  const getRedirectionRoute = () => {
    // if (session?.id) return '/session'; // if user has a session loaded
    if (clientConfiguration.features.setlist.enabled && setlistSessions?.length > 0) return '/setlist'; // if user has any songs in their setlist
    return '/library'; // else go straight to library
  };
  useEffect(() => {
    // setPassword('');
    // dispatch(logout());
  }, []);
  return loginStatus === 'fulfilled' ? /*#__PURE__*/React__default.createElement(Navigate, {
    to: getRedirectionRoute(),
    state: {
      from: location
    },
    replace: true
  }) : /*#__PURE__*/React__default.createElement(Login, {
    onLogin: (a, b) => {
      dispatch(loginUserAsync({
        username,
        password
      }));
    },
    logoImageUrl: `${process.env.PUBLIC_URL}${clientConfiguration.images.loginLogo}`,
    splashImageUrl: `${process.env.PUBLIC_URL}${clientConfiguration.images.loginSplash}`,
    user: username,
    password: password,
    onPasswordChange: setPassword,
    onUserChange: setUsername,
    errorMessage: loginErrorMessage,
    loggingIn: loginStatus === 'pending'
  });
};

function AdjustmentsIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5 4a1 1 0 00-2 0v7.268a2 2 0 000 3.464V16a1 1 0 102 0v-1.268a2 2 0 000-3.464V4zM11 4a1 1 0 10-2 0v1.268a2 2 0 000 3.464V16a1 1 0 102 0V8.732a2 2 0 000-3.464V4zM16 3a1 1 0 011 1v7.268a2 2 0 010 3.464V16a1 1 0 11-2 0v-1.268a2 2 0 010-3.464V4a1 1 0 011-1z"
  }));
}
const ForwardRef$f = /*#__PURE__*/React.forwardRef(AdjustmentsIcon);

function AnnotationIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18 13V5a2 2 0 00-2-2H4a2 2 0 00-2 2v8a2 2 0 002 2h3l3 3 3-3h3a2 2 0 002-2zM5 7a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1zm1 3a1 1 0 100 2h3a1 1 0 100-2H6z",
    clipRule: "evenodd"
  }));
}
const ForwardRef$e = /*#__PURE__*/React.forwardRef(AnnotationIcon);

function CogIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z",
    clipRule: "evenodd"
  }));
}
const ForwardRef$d = /*#__PURE__*/React.forwardRef(CogIcon);

function CollectionIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7 3a1 1 0 000 2h6a1 1 0 100-2H7zM4 7a1 1 0 011-1h10a1 1 0 110 2H5a1 1 0 01-1-1zM2 11a2 2 0 012-2h12a2 2 0 012 2v4a2 2 0 01-2 2H4a2 2 0 01-2-2v-4z"
  }));
}
const ForwardRef$c = /*#__PURE__*/React.forwardRef(CollectionIcon);

function DocumentTextIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z",
    clipRule: "evenodd"
  }));
}
const ForwardRef$b = /*#__PURE__*/React.forwardRef(DocumentTextIcon);

function DownloadIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z",
    clipRule: "evenodd"
  }));
}
const ForwardRef$a = /*#__PURE__*/React.forwardRef(DownloadIcon);

function ExclamationCircleIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z",
    clipRule: "evenodd"
  }));
}
const ForwardRef$9 = /*#__PURE__*/React.forwardRef(ExclamationCircleIcon);

function ExclamationIcon$1(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z",
    clipRule: "evenodd"
  }));
}
const ForwardRef$8 = /*#__PURE__*/React.forwardRef(ExclamationIcon$1);

function InformationCircleIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
    clipRule: "evenodd"
  }));
}
const ForwardRef$7 = /*#__PURE__*/React.forwardRef(InformationCircleIcon);

function MusicNoteIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18 3a1 1 0 00-1.196-.98l-10 2A1 1 0 006 5v9.114A4.369 4.369 0 005 14c-1.657 0-3 .895-3 2s1.343 2 3 2 3-.895 3-2V7.82l8-1.6v5.894A4.37 4.37 0 0015 12c-1.657 0-3 .895-3 2s1.343 2 3 2 3-.895 3-2V3z"
  }));
}
const ForwardRef$6 = /*#__PURE__*/React.forwardRef(MusicNoteIcon);

function PlusIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z",
    clipRule: "evenodd"
  }));
}
const ForwardRef$5 = /*#__PURE__*/React.forwardRef(PlusIcon);

function QuestionMarkCircleIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z",
    clipRule: "evenodd"
  }));
}
const ForwardRef$4 = /*#__PURE__*/React.forwardRef(QuestionMarkCircleIcon);

function StatusOfflineIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3.707 2.293a1 1 0 00-1.414 1.414l6.921 6.922c.05.062.105.118.168.167l6.91 6.911a1 1 0 001.415-1.414l-.675-.675a9.001 9.001 0 00-.668-11.982A1 1 0 1014.95 5.05a7.002 7.002 0 01.657 9.143l-1.435-1.435a5.002 5.002 0 00-.636-6.294A1 1 0 0012.12 7.88c.924.923 1.12 2.3.587 3.415l-1.992-1.992a.922.922 0 00-.018-.018l-6.99-6.991zM3.238 8.187a1 1 0 00-1.933-.516c-.8 3-.025 6.336 2.331 8.693a1 1 0 001.414-1.415 6.997 6.997 0 01-1.812-6.762zM7.4 11.5a1 1 0 10-1.73 1c.214.371.48.72.795 1.035a1 1 0 001.414-1.414c-.191-.191-.35-.4-.478-.622z"
  }));
}
const ForwardRef$3 = /*#__PURE__*/React.forwardRef(StatusOfflineIcon);

var platform$1 = {exports: {}};

/*!
 * Platform.js v1.3.6
 * Copyright 2014-2020 Benjamin Tan
 * Copyright 2011-2013 John-David Dalton
 * Available under MIT license
 */

(function (module, exports) {
	(function () {

	  /** Used to determine if values are of the language type `Object`. */
	  var objectTypes = {
	    'function': true,
	    'object': true
	  };

	  /** Used as a reference to the global object. */
	  var root = objectTypes[typeof window] && window || this;

	  /** Detect free variable `exports`. */
	  var freeExports = exports;

	  /** Detect free variable `module`. */
	  var freeModule = module && !module.nodeType && module;

	  /** Detect free variable `global` from Node.js or Browserified code and use it as `root`. */
	  var freeGlobal = freeExports && freeModule && typeof commonjsGlobal$1 == 'object' && commonjsGlobal$1;
	  if (freeGlobal && (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal)) {
	    root = freeGlobal;
	  }

	  /**
	   * Used as the maximum length of an array-like object.
	   * See the [ES6 spec](http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength)
	   * for more details.
	   */
	  var maxSafeInteger = Math.pow(2, 53) - 1;

	  /** Regular expression to detect Opera. */
	  var reOpera = /\bOpera/;

	  /** Used for native method references. */
	  var objectProto = Object.prototype;

	  /** Used to check for own properties of an object. */
	  var hasOwnProperty = objectProto.hasOwnProperty;

	  /** Used to resolve the internal `[[Class]]` of values. */
	  var toString = objectProto.toString;

	  /*--------------------------------------------------------------------------*/

	  /**
	   * Capitalizes a string value.
	   *
	   * @private
	   * @param {string} string The string to capitalize.
	   * @returns {string} The capitalized string.
	   */
	  function capitalize(string) {
	    string = String(string);
	    return string.charAt(0).toUpperCase() + string.slice(1);
	  }

	  /**
	   * A utility function to clean up the OS name.
	   *
	   * @private
	   * @param {string} os The OS name to clean up.
	   * @param {string} [pattern] A `RegExp` pattern matching the OS name.
	   * @param {string} [label] A label for the OS.
	   */
	  function cleanupOS(os, pattern, label) {
	    // Platform tokens are defined at:
	    // http://msdn.microsoft.com/en-us/library/ms537503(VS.85).aspx
	    // http://web.archive.org/web/20081122053950/http://msdn.microsoft.com/en-us/library/ms537503(VS.85).aspx
	    var data = {
	      '10.0': '10',
	      '6.4': '10 Technical Preview',
	      '6.3': '8.1',
	      '6.2': '8',
	      '6.1': 'Server 2008 R2 / 7',
	      '6.0': 'Server 2008 / Vista',
	      '5.2': 'Server 2003 / XP 64-bit',
	      '5.1': 'XP',
	      '5.01': '2000 SP1',
	      '5.0': '2000',
	      '4.0': 'NT',
	      '4.90': 'ME'
	    };
	    // Detect Windows version from platform tokens.
	    if (pattern && label && /^Win/i.test(os) && !/^Windows Phone /i.test(os) && (data = data[/[\d.]+$/.exec(os)])) {
	      os = 'Windows ' + data;
	    }
	    // Correct character case and cleanup string.
	    os = String(os);
	    if (pattern && label) {
	      os = os.replace(RegExp(pattern, 'i'), label);
	    }
	    os = format(os.replace(/ ce$/i, ' CE').replace(/\bhpw/i, 'web').replace(/\bMacintosh\b/, 'Mac OS').replace(/_PowerPC\b/i, ' OS').replace(/\b(OS X) [^ \d]+/i, '$1').replace(/\bMac (OS X)\b/, '$1').replace(/\/(\d)/, ' $1').replace(/_/g, '.').replace(/(?: BePC|[ .]*fc[ \d.]+)$/i, '').replace(/\bx86\.64\b/gi, 'x86_64').replace(/\b(Windows Phone) OS\b/, '$1').replace(/\b(Chrome OS \w+) [\d.]+\b/, '$1').split(' on ')[0]);
	    return os;
	  }

	  /**
	   * An iteration utility for arrays and objects.
	   *
	   * @private
	   * @param {Array|Object} object The object to iterate over.
	   * @param {Function} callback The function called per iteration.
	   */
	  function each(object, callback) {
	    var index = -1,
	      length = object ? object.length : 0;
	    if (typeof length == 'number' && length > -1 && length <= maxSafeInteger) {
	      while (++index < length) {
	        callback(object[index], index, object);
	      }
	    } else {
	      forOwn(object, callback);
	    }
	  }

	  /**
	   * Trim and conditionally capitalize string values.
	   *
	   * @private
	   * @param {string} string The string to format.
	   * @returns {string} The formatted string.
	   */
	  function format(string) {
	    string = trim(string);
	    return /^(?:webOS|i(?:OS|P))/.test(string) ? string : capitalize(string);
	  }

	  /**
	   * Iterates over an object's own properties, executing the `callback` for each.
	   *
	   * @private
	   * @param {Object} object The object to iterate over.
	   * @param {Function} callback The function executed per own property.
	   */
	  function forOwn(object, callback) {
	    for (var key in object) {
	      if (hasOwnProperty.call(object, key)) {
	        callback(object[key], key, object);
	      }
	    }
	  }

	  /**
	   * Gets the internal `[[Class]]` of a value.
	   *
	   * @private
	   * @param {*} value The value.
	   * @returns {string} The `[[Class]]`.
	   */
	  function getClassOf(value) {
	    return value == null ? capitalize(value) : toString.call(value).slice(8, -1);
	  }

	  /**
	   * Host objects can return type values that are different from their actual
	   * data type. The objects we are concerned with usually return non-primitive
	   * types of "object", "function", or "unknown".
	   *
	   * @private
	   * @param {*} object The owner of the property.
	   * @param {string} property The property to check.
	   * @returns {boolean} Returns `true` if the property value is a non-primitive, else `false`.
	   */
	  function isHostType(object, property) {
	    var type = object != null ? typeof object[property] : 'number';
	    return !/^(?:boolean|number|string|undefined)$/.test(type) && (type == 'object' ? !!object[property] : true);
	  }

	  /**
	   * Prepares a string for use in a `RegExp` by making hyphens and spaces optional.
	   *
	   * @private
	   * @param {string} string The string to qualify.
	   * @returns {string} The qualified string.
	   */
	  function qualify(string) {
	    return String(string).replace(/([ -])(?!$)/g, '$1?');
	  }

	  /**
	   * A bare-bones `Array#reduce` like utility function.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} callback The function called per iteration.
	   * @returns {*} The accumulated result.
	   */
	  function reduce(array, callback) {
	    var accumulator = null;
	    each(array, function (value, index) {
	      accumulator = callback(accumulator, value, index, array);
	    });
	    return accumulator;
	  }

	  /**
	   * Removes leading and trailing whitespace from a string.
	   *
	   * @private
	   * @param {string} string The string to trim.
	   * @returns {string} The trimmed string.
	   */
	  function trim(string) {
	    return String(string).replace(/^ +| +$/g, '');
	  }

	  /*--------------------------------------------------------------------------*/

	  /**
	   * Creates a new platform object.
	   *
	   * @memberOf platform
	   * @param {Object|string} [ua=navigator.userAgent] The user agent string or
	   *  context object.
	   * @returns {Object} A platform object.
	   */
	  function parse(ua) {
	    /** The environment context object. */
	    var context = root;

	    /** Used to flag when a custom context is provided. */
	    var isCustomContext = ua && typeof ua == 'object' && getClassOf(ua) != 'String';

	    // Juggle arguments.
	    if (isCustomContext) {
	      context = ua;
	      ua = null;
	    }

	    /** Browser navigator object. */
	    var nav = context.navigator || {};

	    /** Browser user agent string. */
	    var userAgent = nav.userAgent || '';
	    ua || (ua = userAgent);

	    /** Used to detect if browser is like Chrome. */
	    var likeChrome = isCustomContext ? !!nav.likeChrome : /\bChrome\b/.test(ua) && !/internal|\n/i.test(toString.toString());

	    /** Internal `[[Class]]` value shortcuts. */
	    var objectClass = 'Object',
	      airRuntimeClass = isCustomContext ? objectClass : 'ScriptBridgingProxyObject',
	      enviroClass = isCustomContext ? objectClass : 'Environment',
	      javaClass = isCustomContext && context.java ? 'JavaPackage' : getClassOf(context.java),
	      phantomClass = isCustomContext ? objectClass : 'RuntimeObject';

	    /** Detect Java environments. */
	    var java = /\bJava/.test(javaClass) && context.java;

	    /** Detect Rhino. */
	    var rhino = java && getClassOf(context.environment) == enviroClass;

	    /** A character to represent alpha. */
	    var alpha = java ? 'a' : '\u03b1';

	    /** A character to represent beta. */
	    var beta = java ? 'b' : '\u03b2';

	    /** Browser document object. */
	    var doc = context.document || {};

	    /**
	     * Detect Opera browser (Presto-based).
	     * http://www.howtocreate.co.uk/operaStuff/operaObject.html
	     * http://dev.opera.com/articles/view/opera-mini-web-content-authoring-guidelines/#operamini
	     */
	    var opera = context.operamini || context.opera;

	    /** Opera `[[Class]]`. */
	    var operaClass = reOpera.test(operaClass = isCustomContext && opera ? opera['[[Class]]'] : getClassOf(opera)) ? operaClass : opera = null;

	    /*------------------------------------------------------------------------*/

	    /** Temporary variable used over the script's lifetime. */
	    var data;

	    /** The CPU architecture. */
	    var arch = ua;

	    /** Platform description array. */
	    var description = [];

	    /** Platform alpha/beta indicator. */
	    var prerelease = null;

	    /** A flag to indicate that environment features should be used to resolve the platform. */
	    var useFeatures = ua == userAgent;

	    /** The browser/environment version. */
	    var version = useFeatures && opera && typeof opera.version == 'function' && opera.version();

	    /** A flag to indicate if the OS ends with "/ Version" */
	    var isSpecialCasedOS;

	    /* Detectable layout engines (order is important). */
	    var layout = getLayout([{
	      'label': 'EdgeHTML',
	      'pattern': 'Edge'
	    }, 'Trident', {
	      'label': 'WebKit',
	      'pattern': 'AppleWebKit'
	    }, 'iCab', 'Presto', 'NetFront', 'Tasman', 'KHTML', 'Gecko']);

	    /* Detectable browser names (order is important). */
	    var name = getName(['Adobe AIR', 'Arora', 'Avant Browser', 'Breach', 'Camino', 'Electron', 'Epiphany', 'Fennec', 'Flock', 'Galeon', 'GreenBrowser', 'iCab', 'Iceweasel', 'K-Meleon', 'Konqueror', 'Lunascape', 'Maxthon', {
	      'label': 'Microsoft Edge',
	      'pattern': '(?:Edge|Edg|EdgA|EdgiOS)'
	    }, 'Midori', 'Nook Browser', 'PaleMoon', 'PhantomJS', 'Raven', 'Rekonq', 'RockMelt', {
	      'label': 'Samsung Internet',
	      'pattern': 'SamsungBrowser'
	    }, 'SeaMonkey', {
	      'label': 'Silk',
	      'pattern': '(?:Cloud9|Silk-Accelerated)'
	    }, 'Sleipnir', 'SlimBrowser', {
	      'label': 'SRWare Iron',
	      'pattern': 'Iron'
	    }, 'Sunrise', 'Swiftfox', 'Vivaldi', 'Waterfox', 'WebPositive', {
	      'label': 'Yandex Browser',
	      'pattern': 'YaBrowser'
	    }, {
	      'label': 'UC Browser',
	      'pattern': 'UCBrowser'
	    }, 'Opera Mini', {
	      'label': 'Opera Mini',
	      'pattern': 'OPiOS'
	    }, 'Opera', {
	      'label': 'Opera',
	      'pattern': 'OPR'
	    }, 'Chromium', 'Chrome', {
	      'label': 'Chrome',
	      'pattern': '(?:HeadlessChrome)'
	    }, {
	      'label': 'Chrome Mobile',
	      'pattern': '(?:CriOS|CrMo)'
	    }, {
	      'label': 'Firefox',
	      'pattern': '(?:Firefox|Minefield)'
	    }, {
	      'label': 'Firefox for iOS',
	      'pattern': 'FxiOS'
	    }, {
	      'label': 'IE',
	      'pattern': 'IEMobile'
	    }, {
	      'label': 'IE',
	      'pattern': 'MSIE'
	    }, 'Safari']);

	    /* Detectable products (order is important). */
	    var product = getProduct([{
	      'label': 'BlackBerry',
	      'pattern': 'BB10'
	    }, 'BlackBerry', {
	      'label': 'Galaxy S',
	      'pattern': 'GT-I9000'
	    }, {
	      'label': 'Galaxy S2',
	      'pattern': 'GT-I9100'
	    }, {
	      'label': 'Galaxy S3',
	      'pattern': 'GT-I9300'
	    }, {
	      'label': 'Galaxy S4',
	      'pattern': 'GT-I9500'
	    }, {
	      'label': 'Galaxy S5',
	      'pattern': 'SM-G900'
	    }, {
	      'label': 'Galaxy S6',
	      'pattern': 'SM-G920'
	    }, {
	      'label': 'Galaxy S6 Edge',
	      'pattern': 'SM-G925'
	    }, {
	      'label': 'Galaxy S7',
	      'pattern': 'SM-G930'
	    }, {
	      'label': 'Galaxy S7 Edge',
	      'pattern': 'SM-G935'
	    }, 'Google TV', 'Lumia', 'iPad', 'iPod', 'iPhone', 'Kindle', {
	      'label': 'Kindle Fire',
	      'pattern': '(?:Cloud9|Silk-Accelerated)'
	    }, 'Nexus', 'Nook', 'PlayBook', 'PlayStation Vita', 'PlayStation', 'TouchPad', 'Transformer', {
	      'label': 'Wii U',
	      'pattern': 'WiiU'
	    }, 'Wii', 'Xbox One', {
	      'label': 'Xbox 360',
	      'pattern': 'Xbox'
	    }, 'Xoom']);

	    /* Detectable manufacturers. */
	    var manufacturer = getManufacturer({
	      'Apple': {
	        'iPad': 1,
	        'iPhone': 1,
	        'iPod': 1
	      },
	      'Alcatel': {},
	      'Archos': {},
	      'Amazon': {
	        'Kindle': 1,
	        'Kindle Fire': 1
	      },
	      'Asus': {
	        'Transformer': 1
	      },
	      'Barnes & Noble': {
	        'Nook': 1
	      },
	      'BlackBerry': {
	        'PlayBook': 1
	      },
	      'Google': {
	        'Google TV': 1,
	        'Nexus': 1
	      },
	      'HP': {
	        'TouchPad': 1
	      },
	      'HTC': {},
	      'Huawei': {},
	      'Lenovo': {},
	      'LG': {},
	      'Microsoft': {
	        'Xbox': 1,
	        'Xbox One': 1
	      },
	      'Motorola': {
	        'Xoom': 1
	      },
	      'Nintendo': {
	        'Wii U': 1,
	        'Wii': 1
	      },
	      'Nokia': {
	        'Lumia': 1
	      },
	      'Oppo': {},
	      'Samsung': {
	        'Galaxy S': 1,
	        'Galaxy S2': 1,
	        'Galaxy S3': 1,
	        'Galaxy S4': 1
	      },
	      'Sony': {
	        'PlayStation': 1,
	        'PlayStation Vita': 1
	      },
	      'Xiaomi': {
	        'Mi': 1,
	        'Redmi': 1
	      }
	    });

	    /* Detectable operating systems (order is important). */
	    var os = getOS(['Windows Phone', 'KaiOS', 'Android', 'CentOS', {
	      'label': 'Chrome OS',
	      'pattern': 'CrOS'
	    }, 'Debian', {
	      'label': 'DragonFly BSD',
	      'pattern': 'DragonFly'
	    }, 'Fedora', 'FreeBSD', 'Gentoo', 'Haiku', 'Kubuntu', 'Linux Mint', 'OpenBSD', 'Red Hat', 'SuSE', 'Ubuntu', 'Xubuntu', 'Cygwin', 'Symbian OS', 'hpwOS', 'webOS ', 'webOS', 'Tablet OS', 'Tizen', 'Linux', 'Mac OS X', 'Macintosh', 'Mac', 'Windows 98;', 'Windows ']);

	    /*------------------------------------------------------------------------*/

	    /**
	     * Picks the layout engine from an array of guesses.
	     *
	     * @private
	     * @param {Array} guesses An array of guesses.
	     * @returns {null|string} The detected layout engine.
	     */
	    function getLayout(guesses) {
	      return reduce(guesses, function (result, guess) {
	        return result || RegExp('\\b' + (guess.pattern || qualify(guess)) + '\\b', 'i').exec(ua) && (guess.label || guess);
	      });
	    }

	    /**
	     * Picks the manufacturer from an array of guesses.
	     *
	     * @private
	     * @param {Array} guesses An object of guesses.
	     * @returns {null|string} The detected manufacturer.
	     */
	    function getManufacturer(guesses) {
	      return reduce(guesses, function (result, value, key) {
	        // Lookup the manufacturer by product or scan the UA for the manufacturer.
	        return result || (value[product] || value[/^[a-z]+(?: +[a-z]+\b)*/i.exec(product)] || RegExp('\\b' + qualify(key) + '(?:\\b|\\w*\\d)', 'i').exec(ua)) && key;
	      });
	    }

	    /**
	     * Picks the browser name from an array of guesses.
	     *
	     * @private
	     * @param {Array} guesses An array of guesses.
	     * @returns {null|string} The detected browser name.
	     */
	    function getName(guesses) {
	      return reduce(guesses, function (result, guess) {
	        return result || RegExp('\\b' + (guess.pattern || qualify(guess)) + '\\b', 'i').exec(ua) && (guess.label || guess);
	      });
	    }

	    /**
	     * Picks the OS name from an array of guesses.
	     *
	     * @private
	     * @param {Array} guesses An array of guesses.
	     * @returns {null|string} The detected OS name.
	     */
	    function getOS(guesses) {
	      return reduce(guesses, function (result, guess) {
	        var pattern = guess.pattern || qualify(guess);
	        if (!result && (result = RegExp('\\b' + pattern + '(?:/[\\d.]+|[ \\w.]*)', 'i').exec(ua))) {
	          result = cleanupOS(result, pattern, guess.label || guess);
	        }
	        return result;
	      });
	    }

	    /**
	     * Picks the product name from an array of guesses.
	     *
	     * @private
	     * @param {Array} guesses An array of guesses.
	     * @returns {null|string} The detected product name.
	     */
	    function getProduct(guesses) {
	      return reduce(guesses, function (result, guess) {
	        var pattern = guess.pattern || qualify(guess);
	        if (!result && (result = RegExp('\\b' + pattern + ' *\\d+[.\\w_]*', 'i').exec(ua) || RegExp('\\b' + pattern + ' *\\w+-[\\w]*', 'i').exec(ua) || RegExp('\\b' + pattern + '(?:; *(?:[a-z]+[_-])?[a-z]+\\d+|[^ ();-]*)', 'i').exec(ua))) {
	          // Split by forward slash and append product version if needed.
	          if ((result = String(guess.label && !RegExp(pattern, 'i').test(guess.label) ? guess.label : result).split('/'))[1] && !/[\d.]+/.test(result[0])) {
	            result[0] += ' ' + result[1];
	          }
	          // Correct character case and cleanup string.
	          guess = guess.label || guess;
	          result = format(result[0].replace(RegExp(pattern, 'i'), guess).replace(RegExp('; *(?:' + guess + '[_-])?', 'i'), ' ').replace(RegExp('(' + guess + ')[-_.]?(\\w)', 'i'), '$1 $2'));
	        }
	        return result;
	      });
	    }

	    /**
	     * Resolves the version using an array of UA patterns.
	     *
	     * @private
	     * @param {Array} patterns An array of UA patterns.
	     * @returns {null|string} The detected version.
	     */
	    function getVersion(patterns) {
	      return reduce(patterns, function (result, pattern) {
	        return result || (RegExp(pattern + '(?:-[\\d.]+/|(?: for [\\w-]+)?[ /-])([\\d.]+[^ ();/_-]*)', 'i').exec(ua) || 0)[1] || null;
	      });
	    }

	    /**
	     * Returns `platform.description` when the platform object is coerced to a string.
	     *
	     * @name toString
	     * @memberOf platform
	     * @returns {string} Returns `platform.description` if available, else an empty string.
	     */
	    function toStringPlatform() {
	      return this.description || '';
	    }

	    /*------------------------------------------------------------------------*/

	    // Convert layout to an array so we can add extra details.
	    layout && (layout = [layout]);

	    // Detect Android products.
	    // Browsers on Android devices typically provide their product IDS after "Android;"
	    // up to "Build" or ") AppleWebKit".
	    // Example:
	    // "Mozilla/5.0 (Linux; Android 8.1.0; Moto G (5) Plus) AppleWebKit/537.36
	    // (KHTML, like Gecko) Chrome/70.0.3538.80 Mobile Safari/537.36"
	    if (/\bAndroid\b/.test(os) && !product && (data = /\bAndroid[^;]*;(.*?)(?:Build|\) AppleWebKit)\b/i.exec(ua))) {
	      product = trim(data[1])
	      // Replace any language codes (eg. "en-US").
	      .replace(/^[a-z]{2}-[a-z]{2};\s*/i, '') || null;
	    }
	    // Detect product names that contain their manufacturer's name.
	    if (manufacturer && !product) {
	      product = getProduct([manufacturer]);
	    } else if (manufacturer && product) {
	      product = product.replace(RegExp('^(' + qualify(manufacturer) + ')[-_.\\s]', 'i'), manufacturer + ' ').replace(RegExp('^(' + qualify(manufacturer) + ')[-_.]?(\\w)', 'i'), manufacturer + ' $2');
	    }
	    // Clean up Google TV.
	    if (data = /\bGoogle TV\b/.exec(product)) {
	      product = data[0];
	    }
	    // Detect simulators.
	    if (/\bSimulator\b/i.test(ua)) {
	      product = (product ? product + ' ' : '') + 'Simulator';
	    }
	    // Detect Opera Mini 8+ running in Turbo/Uncompressed mode on iOS.
	    if (name == 'Opera Mini' && /\bOPiOS\b/.test(ua)) {
	      description.push('running in Turbo/Uncompressed mode');
	    }
	    // Detect IE Mobile 11.
	    if (name == 'IE' && /\blike iPhone OS\b/.test(ua)) {
	      data = parse(ua.replace(/like iPhone OS/, ''));
	      manufacturer = data.manufacturer;
	      product = data.product;
	    }
	    // Detect iOS.
	    else if (/^iP/.test(product)) {
	      name || (name = 'Safari');
	      os = 'iOS' + ((data = / OS ([\d_]+)/i.exec(ua)) ? ' ' + data[1].replace(/_/g, '.') : '');
	    }
	    // Detect Kubuntu.
	    else if (name == 'Konqueror' && /^Linux\b/i.test(os)) {
	      os = 'Kubuntu';
	    }
	    // Detect Android browsers.
	    else if (manufacturer && manufacturer != 'Google' && (/Chrome/.test(name) && !/\bMobile Safari\b/i.test(ua) || /\bVita\b/.test(product)) || /\bAndroid\b/.test(os) && /^Chrome/.test(name) && /\bVersion\//i.test(ua)) {
	      name = 'Android Browser';
	      os = /\bAndroid\b/.test(os) ? os : 'Android';
	    }
	    // Detect Silk desktop/accelerated modes.
	    else if (name == 'Silk') {
	      if (!/\bMobi/i.test(ua)) {
	        os = 'Android';
	        description.unshift('desktop mode');
	      }
	      if (/Accelerated *= *true/i.test(ua)) {
	        description.unshift('accelerated');
	      }
	    }
	    // Detect UC Browser speed mode.
	    else if (name == 'UC Browser' && /\bUCWEB\b/.test(ua)) {
	      description.push('speed mode');
	    }
	    // Detect PaleMoon identifying as Firefox.
	    else if (name == 'PaleMoon' && (data = /\bFirefox\/([\d.]+)\b/.exec(ua))) {
	      description.push('identifying as Firefox ' + data[1]);
	    }
	    // Detect Firefox OS and products running Firefox.
	    else if (name == 'Firefox' && (data = /\b(Mobile|Tablet|TV)\b/i.exec(ua))) {
	      os || (os = 'Firefox OS');
	      product || (product = data[1]);
	    }
	    // Detect false positives for Firefox/Safari.
	    else if (!name || (data = !/\bMinefield\b/i.test(ua) && /\b(?:Firefox|Safari)\b/.exec(name))) {
	      // Escape the `/` for Firefox 1.
	      if (name && !product && /[\/,]|^[^(]+?\)/.test(ua.slice(ua.indexOf(data + '/') + 8))) {
	        // Clear name of false positives.
	        name = null;
	      }
	      // Reassign a generic name.
	      if ((data = product || manufacturer || os) && (product || manufacturer || /\b(?:Android|Symbian OS|Tablet OS|webOS)\b/.test(os))) {
	        name = /[a-z]+(?: Hat)?/i.exec(/\bAndroid\b/.test(os) ? os : data) + ' Browser';
	      }
	    }
	    // Add Chrome version to description for Electron.
	    else if (name == 'Electron' && (data = (/\bChrome\/([\d.]+)\b/.exec(ua) || 0)[1])) {
	      description.push('Chromium ' + data);
	    }
	    // Detect non-Opera (Presto-based) versions (order is important).
	    if (!version) {
	      version = getVersion(['(?:Cloud9|CriOS|CrMo|Edge|Edg|EdgA|EdgiOS|FxiOS|HeadlessChrome|IEMobile|Iron|Opera ?Mini|OPiOS|OPR|Raven|SamsungBrowser|Silk(?!/[\\d.]+$)|UCBrowser|YaBrowser)', 'Version', qualify(name), '(?:Firefox|Minefield|NetFront)']);
	    }
	    // Detect stubborn layout engines.
	    if (data = layout == 'iCab' && parseFloat(version) > 3 && 'WebKit' || /\bOpera\b/.test(name) && (/\bOPR\b/.test(ua) ? 'Blink' : 'Presto') || /\b(?:Midori|Nook|Safari)\b/i.test(ua) && !/^(?:Trident|EdgeHTML)$/.test(layout) && 'WebKit' || !layout && /\bMSIE\b/i.test(ua) && (os == 'Mac OS' ? 'Tasman' : 'Trident') || layout == 'WebKit' && /\bPlayStation\b(?! Vita\b)/i.test(name) && 'NetFront') {
	      layout = [data];
	    }
	    // Detect Windows Phone 7 desktop mode.
	    if (name == 'IE' && (data = (/; *(?:XBLWP|ZuneWP)(\d+)/i.exec(ua) || 0)[1])) {
	      name += ' Mobile';
	      os = 'Windows Phone ' + (/\+$/.test(data) ? data : data + '.x');
	      description.unshift('desktop mode');
	    }
	    // Detect Windows Phone 8.x desktop mode.
	    else if (/\bWPDesktop\b/i.test(ua)) {
	      name = 'IE Mobile';
	      os = 'Windows Phone 8.x';
	      description.unshift('desktop mode');
	      version || (version = (/\brv:([\d.]+)/.exec(ua) || 0)[1]);
	    }
	    // Detect IE 11 identifying as other browsers.
	    else if (name != 'IE' && layout == 'Trident' && (data = /\brv:([\d.]+)/.exec(ua))) {
	      if (name) {
	        description.push('identifying as ' + name + (version ? ' ' + version : ''));
	      }
	      name = 'IE';
	      version = data[1];
	    }
	    // Leverage environment features.
	    if (useFeatures) {
	      // Detect server-side environments.
	      // Rhino has a global function while others have a global object.
	      if (isHostType(context, 'global')) {
	        if (java) {
	          data = java.lang.System;
	          arch = data.getProperty('os.arch');
	          os = os || data.getProperty('os.name') + ' ' + data.getProperty('os.version');
	        }
	        if (rhino) {
	          try {
	            version = context.require('ringo/engine').version.join('.');
	            name = 'RingoJS';
	          } catch (e) {
	            if ((data = context.system) && data.global.system == context.system) {
	              name = 'Narwhal';
	              os || (os = data[0].os || null);
	            }
	          }
	          if (!name) {
	            name = 'Rhino';
	          }
	        } else if (typeof context.process == 'object' && !context.process.browser && (data = context.process)) {
	          if (typeof data.versions == 'object') {
	            if (typeof data.versions.electron == 'string') {
	              description.push('Node ' + data.versions.node);
	              name = 'Electron';
	              version = data.versions.electron;
	            } else if (typeof data.versions.nw == 'string') {
	              description.push('Chromium ' + version, 'Node ' + data.versions.node);
	              name = 'NW.js';
	              version = data.versions.nw;
	            }
	          }
	          if (!name) {
	            name = 'Node.js';
	            arch = data.arch;
	            os = data.platform;
	            version = /[\d.]+/.exec(data.version);
	            version = version ? version[0] : null;
	          }
	        }
	      }
	      // Detect Adobe AIR.
	      else if (getClassOf(data = context.runtime) == airRuntimeClass) {
	        name = 'Adobe AIR';
	        os = data.flash.system.Capabilities.os;
	      }
	      // Detect PhantomJS.
	      else if (getClassOf(data = context.phantom) == phantomClass) {
	        name = 'PhantomJS';
	        version = (data = data.version || null) && data.major + '.' + data.minor + '.' + data.patch;
	      }
	      // Detect IE compatibility modes.
	      else if (typeof doc.documentMode == 'number' && (data = /\bTrident\/(\d+)/i.exec(ua))) {
	        // We're in compatibility mode when the Trident version + 4 doesn't
	        // equal the document mode.
	        version = [version, doc.documentMode];
	        if ((data = +data[1] + 4) != version[1]) {
	          description.push('IE ' + version[1] + ' mode');
	          layout && (layout[1] = '');
	          version[1] = data;
	        }
	        version = name == 'IE' ? String(version[1].toFixed(1)) : version[0];
	      }
	      // Detect IE 11 masking as other browsers.
	      else if (typeof doc.documentMode == 'number' && /^(?:Chrome|Firefox)\b/.test(name)) {
	        description.push('masking as ' + name + ' ' + version);
	        name = 'IE';
	        version = '11.0';
	        layout = ['Trident'];
	        os = 'Windows';
	      }
	      os = os && format(os);
	    }
	    // Detect prerelease phases.
	    if (version && (data = /(?:[ab]|dp|pre|[ab]\d+pre)(?:\d+\+?)?$/i.exec(version) || /(?:alpha|beta)(?: ?\d)?/i.exec(ua + ';' + (useFeatures && nav.appMinorVersion)) || /\bMinefield\b/i.test(ua) && 'a')) {
	      prerelease = /b/i.test(data) ? 'beta' : 'alpha';
	      version = version.replace(RegExp(data + '\\+?$'), '') + (prerelease == 'beta' ? beta : alpha) + (/\d+\+?/.exec(data) || '');
	    }
	    // Detect Firefox Mobile.
	    if (name == 'Fennec' || name == 'Firefox' && /\b(?:Android|Firefox OS|KaiOS)\b/.test(os)) {
	      name = 'Firefox Mobile';
	    }
	    // Obscure Maxthon's unreliable version.
	    else if (name == 'Maxthon' && version) {
	      version = version.replace(/\.[\d.]+/, '.x');
	    }
	    // Detect Xbox 360 and Xbox One.
	    else if (/\bXbox\b/i.test(product)) {
	      if (product == 'Xbox 360') {
	        os = null;
	      }
	      if (product == 'Xbox 360' && /\bIEMobile\b/.test(ua)) {
	        description.unshift('mobile mode');
	      }
	    }
	    // Add mobile postfix.
	    else if ((/^(?:Chrome|IE|Opera)$/.test(name) || name && !product && !/Browser|Mobi/.test(name)) && (os == 'Windows CE' || /Mobi/i.test(ua))) {
	      name += ' Mobile';
	    }
	    // Detect IE platform preview.
	    else if (name == 'IE' && useFeatures) {
	      try {
	        if (context.external === null) {
	          description.unshift('platform preview');
	        }
	      } catch (e) {
	        description.unshift('embedded');
	      }
	    }
	    // Detect BlackBerry OS version.
	    // http://docs.blackberry.com/en/developers/deliverables/18169/HTTP_headers_sent_by_BB_Browser_1234911_11.jsp
	    else if ((/\bBlackBerry\b/.test(product) || /\bBB10\b/.test(ua)) && (data = (RegExp(product.replace(/ +/g, ' *') + '/([.\\d]+)', 'i').exec(ua) || 0)[1] || version)) {
	      data = [data, /BB10/.test(ua)];
	      os = (data[1] ? (product = null, manufacturer = 'BlackBerry') : 'Device Software') + ' ' + data[0];
	      version = null;
	    }
	    // Detect Opera identifying/masking itself as another browser.
	    // http://www.opera.com/support/kb/view/843/
	    else if (this != forOwn && product != 'Wii' && (useFeatures && opera || /Opera/.test(name) && /\b(?:MSIE|Firefox)\b/i.test(ua) || name == 'Firefox' && /\bOS X (?:\d+\.){2,}/.test(os) || name == 'IE' && (os && !/^Win/.test(os) && version > 5.5 || /\bWindows XP\b/.test(os) && version > 8 || version == 8 && !/\bTrident\b/.test(ua))) && !reOpera.test(data = parse.call(forOwn, ua.replace(reOpera, '') + ';')) && data.name) {
	      // When "identifying", the UA contains both Opera and the other browser's name.
	      data = 'ing as ' + data.name + ((data = data.version) ? ' ' + data : '');
	      if (reOpera.test(name)) {
	        if (/\bIE\b/.test(data) && os == 'Mac OS') {
	          os = null;
	        }
	        data = 'identify' + data;
	      }
	      // When "masking", the UA contains only the other browser's name.
	      else {
	        data = 'mask' + data;
	        if (operaClass) {
	          name = format(operaClass.replace(/([a-z])([A-Z])/g, '$1 $2'));
	        } else {
	          name = 'Opera';
	        }
	        if (/\bIE\b/.test(data)) {
	          os = null;
	        }
	        if (!useFeatures) {
	          version = null;
	        }
	      }
	      layout = ['Presto'];
	      description.push(data);
	    }
	    // Detect WebKit Nightly and approximate Chrome/Safari versions.
	    if (data = (/\bAppleWebKit\/([\d.]+\+?)/i.exec(ua) || 0)[1]) {
	      // Correct build number for numeric comparison.
	      // (e.g. "532.5" becomes "532.05")
	      data = [parseFloat(data.replace(/\.(\d)$/, '.0$1')), data];
	      // Nightly builds are postfixed with a "+".
	      if (name == 'Safari' && data[1].slice(-1) == '+') {
	        name = 'WebKit Nightly';
	        prerelease = 'alpha';
	        version = data[1].slice(0, -1);
	      }
	      // Clear incorrect browser versions.
	      else if (version == data[1] || version == (data[2] = (/\bSafari\/([\d.]+\+?)/i.exec(ua) || 0)[1])) {
	        version = null;
	      }
	      // Use the full Chrome version when available.
	      data[1] = (/\b(?:Headless)?Chrome\/([\d.]+)/i.exec(ua) || 0)[1];
	      // Detect Blink layout engine.
	      if (data[0] == 537.36 && data[2] == 537.36 && parseFloat(data[1]) >= 28 && layout == 'WebKit') {
	        layout = ['Blink'];
	      }
	      // Detect JavaScriptCore.
	      // http://stackoverflow.com/questions/6768474/how-can-i-detect-which-javascript-engine-v8-or-jsc-is-used-at-runtime-in-androi
	      if (!useFeatures || !likeChrome && !data[1]) {
	        layout && (layout[1] = 'like Safari');
	        data = (data = data[0], data < 400 ? 1 : data < 500 ? 2 : data < 526 ? 3 : data < 533 ? 4 : data < 534 ? '4+' : data < 535 ? 5 : data < 537 ? 6 : data < 538 ? 7 : data < 601 ? 8 : data < 602 ? 9 : data < 604 ? 10 : data < 606 ? 11 : data < 608 ? 12 : '12');
	      } else {
	        layout && (layout[1] = 'like Chrome');
	        data = data[1] || (data = data[0], data < 530 ? 1 : data < 532 ? 2 : data < 532.05 ? 3 : data < 533 ? 4 : data < 534.03 ? 5 : data < 534.07 ? 6 : data < 534.10 ? 7 : data < 534.13 ? 8 : data < 534.16 ? 9 : data < 534.24 ? 10 : data < 534.30 ? 11 : data < 535.01 ? 12 : data < 535.02 ? '13+' : data < 535.07 ? 15 : data < 535.11 ? 16 : data < 535.19 ? 17 : data < 536.05 ? 18 : data < 536.10 ? 19 : data < 537.01 ? 20 : data < 537.11 ? '21+' : data < 537.13 ? 23 : data < 537.18 ? 24 : data < 537.24 ? 25 : data < 537.36 ? 26 : layout != 'Blink' ? '27' : '28');
	      }
	      // Add the postfix of ".x" or "+" for approximate versions.
	      layout && (layout[1] += ' ' + (data += typeof data == 'number' ? '.x' : /[.+]/.test(data) ? '' : '+'));
	      // Obscure version for some Safari 1-2 releases.
	      if (name == 'Safari' && (!version || parseInt(version) > 45)) {
	        version = data;
	      } else if (name == 'Chrome' && /\bHeadlessChrome/i.test(ua)) {
	        description.unshift('headless');
	      }
	    }
	    // Detect Opera desktop modes.
	    if (name == 'Opera' && (data = /\bzbov|zvav$/.exec(os))) {
	      name += ' ';
	      description.unshift('desktop mode');
	      if (data == 'zvav') {
	        name += 'Mini';
	        version = null;
	      } else {
	        name += 'Mobile';
	      }
	      os = os.replace(RegExp(' *' + data + '$'), '');
	    }
	    // Detect Chrome desktop mode.
	    else if (name == 'Safari' && /\bChrome\b/.exec(layout && layout[1])) {
	      description.unshift('desktop mode');
	      name = 'Chrome Mobile';
	      version = null;
	      if (/\bOS X\b/.test(os)) {
	        manufacturer = 'Apple';
	        os = 'iOS 4.3+';
	      } else {
	        os = null;
	      }
	    }
	    // Newer versions of SRWare Iron uses the Chrome tag to indicate its version number.
	    else if (/\bSRWare Iron\b/.test(name) && !version) {
	      version = getVersion('Chrome');
	    }
	    // Strip incorrect OS versions.
	    if (version && version.indexOf(data = /[\d.]+$/.exec(os)) == 0 && ua.indexOf('/' + data + '-') > -1) {
	      os = trim(os.replace(data, ''));
	    }
	    // Ensure OS does not include the browser name.
	    if (os && os.indexOf(name) != -1 && !RegExp(name + ' OS').test(os)) {
	      os = os.replace(RegExp(' *' + qualify(name) + ' *'), '');
	    }
	    // Add layout engine.
	    if (layout && !/\b(?:Avant|Nook)\b/.test(name) && (/Browser|Lunascape|Maxthon/.test(name) || name != 'Safari' && /^iOS/.test(os) && /\bSafari\b/.test(layout[1]) || /^(?:Adobe|Arora|Breach|Midori|Opera|Phantom|Rekonq|Rock|Samsung Internet|Sleipnir|SRWare Iron|Vivaldi|Web)/.test(name) && layout[1])) {
	      // Don't add layout details to description if they are falsey.
	      (data = layout[layout.length - 1]) && description.push(data);
	    }
	    // Combine contextual information.
	    if (description.length) {
	      description = ['(' + description.join('; ') + ')'];
	    }
	    // Append manufacturer to description.
	    if (manufacturer && product && product.indexOf(manufacturer) < 0) {
	      description.push('on ' + manufacturer);
	    }
	    // Append product to description.
	    if (product) {
	      description.push((/^on /.test(description[description.length - 1]) ? '' : 'on ') + product);
	    }
	    // Parse the OS into an object.
	    if (os) {
	      data = / ([\d.+]+)$/.exec(os);
	      isSpecialCasedOS = data && os.charAt(os.length - data[0].length - 1) == '/';
	      os = {
	        'architecture': 32,
	        'family': data && !isSpecialCasedOS ? os.replace(data[0], '') : os,
	        'version': data ? data[1] : null,
	        'toString': function () {
	          var version = this.version;
	          return this.family + (version && !isSpecialCasedOS ? ' ' + version : '') + (this.architecture == 64 ? ' 64-bit' : '');
	        }
	      };
	    }
	    // Add browser/OS architecture.
	    if ((data = /\b(?:AMD|IA|Win|WOW|x86_|x)64\b/i.exec(arch)) && !/\bi686\b/i.test(arch)) {
	      if (os) {
	        os.architecture = 64;
	        os.family = os.family.replace(RegExp(' *' + data), '');
	      }
	      if (name && (/\bWOW64\b/i.test(ua) || useFeatures && /\w(?:86|32)$/.test(nav.cpuClass || nav.platform) && !/\bWin64; x64\b/i.test(ua))) {
	        description.unshift('32-bit');
	      }
	    }
	    // Chrome 39 and above on OS X is always 64-bit.
	    else if (os && /^OS X/.test(os.family) && name == 'Chrome' && parseFloat(version) >= 39) {
	      os.architecture = 64;
	    }
	    ua || (ua = null);

	    /*------------------------------------------------------------------------*/

	    /**
	     * The platform object.
	     *
	     * @name platform
	     * @type Object
	     */
	    var platform = {};

	    /**
	     * The platform description.
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.description = ua;

	    /**
	     * The name of the browser's layout engine.
	     *
	     * The list of common layout engines include:
	     * "Blink", "EdgeHTML", "Gecko", "Trident" and "WebKit"
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.layout = layout && layout[0];

	    /**
	     * The name of the product's manufacturer.
	     *
	     * The list of manufacturers include:
	     * "Apple", "Archos", "Amazon", "Asus", "Barnes & Noble", "BlackBerry",
	     * "Google", "HP", "HTC", "LG", "Microsoft", "Motorola", "Nintendo",
	     * "Nokia", "Samsung" and "Sony"
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.manufacturer = manufacturer;

	    /**
	     * The name of the browser/environment.
	     *
	     * The list of common browser names include:
	     * "Chrome", "Electron", "Firefox", "Firefox for iOS", "IE",
	     * "Microsoft Edge", "PhantomJS", "Safari", "SeaMonkey", "Silk",
	     * "Opera Mini" and "Opera"
	     *
	     * Mobile versions of some browsers have "Mobile" appended to their name:
	     * eg. "Chrome Mobile", "Firefox Mobile", "IE Mobile" and "Opera Mobile"
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.name = name;

	    /**
	     * The alpha/beta release indicator.
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.prerelease = prerelease;

	    /**
	     * The name of the product hosting the browser.
	     *
	     * The list of common products include:
	     *
	     * "BlackBerry", "Galaxy S4", "Lumia", "iPad", "iPod", "iPhone", "Kindle",
	     * "Kindle Fire", "Nexus", "Nook", "PlayBook", "TouchPad" and "Transformer"
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.product = product;

	    /**
	     * The browser's user agent string.
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.ua = ua;

	    /**
	     * The browser/environment version.
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.version = name && version;

	    /**
	     * The name of the operating system.
	     *
	     * @memberOf platform
	     * @type Object
	     */
	    platform.os = os || {
	      /**
	       * The CPU architecture the OS is built for.
	       *
	       * @memberOf platform.os
	       * @type number|null
	       */
	      'architecture': null,
	      /**
	       * The family of the OS.
	       *
	       * Common values include:
	       * "Windows", "Windows Server 2008 R2 / 7", "Windows Server 2008 / Vista",
	       * "Windows XP", "OS X", "Linux", "Ubuntu", "Debian", "Fedora", "Red Hat",
	       * "SuSE", "Android", "iOS" and "Windows Phone"
	       *
	       * @memberOf platform.os
	       * @type string|null
	       */
	      'family': null,
	      /**
	       * The version of the OS.
	       *
	       * @memberOf platform.os
	       * @type string|null
	       */
	      'version': null,
	      /**
	       * Returns the OS string.
	       *
	       * @memberOf platform.os
	       * @returns {string} The OS string.
	       */
	      'toString': function () {
	        return 'null';
	      }
	    };
	    platform.parse = parse;
	    platform.toString = toStringPlatform;
	    if (platform.version) {
	      description.unshift(version);
	    }
	    if (platform.name) {
	      description.unshift(name);
	    }
	    if (os && name && !(os == String(os).split(' ')[0] && (os == name.split(' ')[0] || product))) {
	      description.push(product ? '(' + os + ')' : 'on ' + os);
	    }
	    if (description.length) {
	      platform.description = description.join(' ');
	    }
	    return platform;
	  }

	  /*--------------------------------------------------------------------------*/

	  // Export platform.
	  var platform = parse();

	  // Some AMD build optimizers, like r.js, check for condition patterns like the following:
	  if (freeExports && freeModule) {
	    // Export for CommonJS support.
	    forOwn(platform, function (value, key) {
	      freeExports[key] = value;
	    });
	  } else {
	    // Export to the global object.
	    root.platform = platform;
	  }
	}).call(commonjsGlobal$1);
} (platform$1, platform$1.exports));

var platform = platform$1.exports;

function toInteger$1(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number = Number(dirtyNumber);
  if (isNaN(number)) {
    return number;
  }
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument);

  // Clone the date
  if (argument instanceof Date || _typeof$5(argument) === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
      // eslint-disable-next-line no-console
      console.warn(new Error().stack);
    }
    return new Date(NaN);
  }
}

var defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

/**
 * @name compareAsc
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * @param {Date|Number} dateLeft - the first date to compare
 * @param {Date|Number} dateRight - the second date to compare
 * @returns {Number} the result of the comparison
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * const result = compareAsc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */
function compareAsc(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var diff = dateLeft.getTime() - dateRight.getTime();
  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1;
    // Return 0 if diff is 0; return NaN if diff is NaN
  } else {
    return diff;
  }
}

/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */

/**
 * Milliseconds in 1 minute
 *
 * @name millisecondsInMinute
 * @constant
 * @type {number}
 * @default
 */
var millisecondsInMinute = 60000;

/**
 * Milliseconds in 1 hour
 *
 * @name millisecondsInHour
 * @constant
 * @type {number}
 * @default
 */
var millisecondsInHour = 3600000;

/**
 * Milliseconds in 1 second
 *
 * @name millisecondsInSecond
 * @constant
 * @type {number}
 * @default
 */
var millisecondsInSecond = 1000;

/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar months
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */
function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
  return yearDiff * 12 + monthDiff;
}

/**
 * @name differenceInMilliseconds
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of milliseconds
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * const result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */
function differenceInMilliseconds(dateLeft, dateRight) {
  requiredArgs(2, arguments);
  return toDate(dateLeft).getTime() - toDate(dateRight).getTime();
}

var roundingMap = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function trunc(value) {
    return value < 0 ? Math.ceil(value) : Math.floor(value);
  } // Math.trunc is not supported by IE
};
var defaultRoundingMethod = 'trunc';
function getRoundingMethod(method) {
  return method ? roundingMap[method] : roundingMap[defaultRoundingMethod];
}

/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */
function endOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(23, 59, 59, 999);
  return date;
}

/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */
function endOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var month = date.getMonth();
  date.setFullYear(date.getFullYear(), month + 1, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}

/**
 * @name isLastDayOfMonth
 * @category Month Helpers
 * @summary Is the given date the last day of a month?
 *
 * @description
 * Is the given date the last day of a month?
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is the last day of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Is 28 February 2014 the last day of a month?
 * const result = isLastDayOfMonth(new Date(2014, 1, 28))
 * //=> true
 */
function isLastDayOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  return endOfDay(date).getTime() === endOfMonth(date).getTime();
}

/**
 * @name differenceInMonths
 * @category Month Helpers
 * @summary Get the number of full months between the given dates.
 *
 * @description
 * Get the number of full months between the given dates using trunc as a default rounding method.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of full months
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInMonths(new Date(2014, 8, 1), new Date(2014, 0, 31))
 * //=> 7
 */
function differenceInMonths(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var sign = compareAsc(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarMonths(dateLeft, dateRight));
  var result;

  // Check for the difference of less than month
  if (difference < 1) {
    result = 0;
  } else {
    if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) {
      // This will check if the date is end of Feb and assign a higher end of month date
      // to compare it with Jan
      dateLeft.setDate(30);
    }
    dateLeft.setMonth(dateLeft.getMonth() - sign * difference);

    // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastMonthNotFull = compareAsc(dateLeft, dateRight) === -sign;

    // Check for cases of one full calendar month
    if (isLastDayOfMonth(toDate(dirtyDateLeft)) && difference === 1 && compareAsc(dirtyDateLeft, dateRight) === 1) {
      isLastMonthNotFull = false;
    }
    result = sign * (difference - Number(isLastMonthNotFull));
  }

  // Prevent negative zero
  return result === 0 ? 0 : result;
}

/**
 * @name differenceInSeconds
 * @category Second Helpers
 * @summary Get the number of seconds between the given dates.
 *
 * @description
 * Get the number of seconds between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
 * @returns {Number} the number of seconds
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many seconds are between
 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
 * const result = differenceInSeconds(
 *   new Date(2014, 6, 2, 12, 30, 20, 0),
 *   new Date(2014, 6, 2, 12, 30, 7, 999)
 * )
 * //=> 12
 */
function differenceInSeconds(dateLeft, dateRight, options) {
  requiredArgs(2, arguments);
  var diff = differenceInMilliseconds(dateLeft, dateRight) / 1000;
  return getRoundingMethod(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}

var MILLISECONDS_IN_WEEK$1 = 604800000;
function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}

function startOfUTCWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var weekStartsOn = toInteger$1((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

function getUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = toInteger$1((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, options);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

function startOfUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = toInteger$1((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = getUTCWeekYear(dirtyDate, options);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, options);
  return date;
}

var MILLISECONDS_IN_WEEK = 604800000;
function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};
var formatDistance$1 = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }
  return result;
};

function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};

var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};

function buildLocalizeFn(args) {
  return function (dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
    var valuesArray;
    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
    return valuesArray[index];
  };
}

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber);

  // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';
      case 2:
        return number + 'nd';
      case 3:
        return number + 'rd';
    }
  }
  return number + 'th';
};
var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};

function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
  return undefined;
}
function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return undefined;
}

function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match$1 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale = {
  code: 'en-US',
  formatDistance: formatDistance$1,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match$1,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1
  }
};

function assign$3(target, object) {
  if (target == null) {
    throw new TypeError('assign requires that input parameter not be null or undefined');
  }
  for (var property in object) {
    if (Object.prototype.hasOwnProperty.call(object, property)) {
      target[property] = object[property];
    }
  }
  return target;
}

function cloneObject(object) {
  return assign$3({}, object);
}

var MINUTES_IN_DAY = 1440;
var MINUTES_IN_ALMOST_TWO_DAYS = 2520;
var MINUTES_IN_MONTH = 43200;
var MINUTES_IN_TWO_MONTHS = 86400;

/**
 * @name formatDistance
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words.
 *
 * | Distance between dates                                            | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance between dates | Result               |
 * |------------------------|----------------------|
 * | 0 secs ... 5 secs      | less than 5 seconds  |
 * | 5 secs ... 10 secs     | less than 10 seconds |
 * | 10 secs ... 20 secs    | less than 20 seconds |
 * | 20 secs ... 40 secs    | half a minute        |
 * | 40 secs ... 60 secs    | less than a minute   |
 * | 60 secs ... 90 secs    | 1 minute             |
 *
 * @param {Date|Number} date - the date
 * @param {Date|Number} baseDate - the date to compare with
 * @param {Object} [options] - an object with options.
 * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @returns {String} the distance in words
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `baseDate` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `formatDistance` property
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * const result = formatDistance(new Date(2014, 6, 2), new Date(2015, 0, 1))
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00, including seconds?
 * const result = formatDistance(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0),
 *   { includeSeconds: true }
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * const result = formatDistance(new Date(2015, 0, 1), new Date(2016, 0, 1), {
 *   addSuffix: true
 * })
 * //=> 'about 1 year ago'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = formatDistance(new Date(2016, 7, 1), new Date(2015, 0, 1), {
 *   locale: eoLocale
 * })
 * //=> 'pli ol 1 jaro'
 */

function formatDistance(dirtyDate, dirtyBaseDate, options) {
  var _ref, _options$locale;
  requiredArgs(2, arguments);
  var defaultOptions = getDefaultOptions();
  var locale$1 = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : locale;
  if (!locale$1.formatDistance) {
    throw new RangeError('locale must contain formatDistance property');
  }
  var comparison = compareAsc(dirtyDate, dirtyBaseDate);
  if (isNaN(comparison)) {
    throw new RangeError('Invalid time value');
  }
  var localizeOptions = assign$3(cloneObject(options), {
    addSuffix: Boolean(options === null || options === void 0 ? void 0 : options.addSuffix),
    comparison: comparison
  });
  var dateLeft;
  var dateRight;
  if (comparison > 0) {
    dateLeft = toDate(dirtyBaseDate);
    dateRight = toDate(dirtyDate);
  } else {
    dateLeft = toDate(dirtyDate);
    dateRight = toDate(dirtyBaseDate);
  }
  var seconds = differenceInSeconds(dateRight, dateLeft);
  var offsetInSeconds = (getTimezoneOffsetInMilliseconds(dateRight) - getTimezoneOffsetInMilliseconds(dateLeft)) / 1000;
  var minutes = Math.round((seconds - offsetInSeconds) / 60);
  var months;

  // 0 up to 2 mins
  if (minutes < 2) {
    if (options !== null && options !== void 0 && options.includeSeconds) {
      if (seconds < 5) {
        return locale$1.formatDistance('lessThanXSeconds', 5, localizeOptions);
      } else if (seconds < 10) {
        return locale$1.formatDistance('lessThanXSeconds', 10, localizeOptions);
      } else if (seconds < 20) {
        return locale$1.formatDistance('lessThanXSeconds', 20, localizeOptions);
      } else if (seconds < 40) {
        return locale$1.formatDistance('halfAMinute', 0, localizeOptions);
      } else if (seconds < 60) {
        return locale$1.formatDistance('lessThanXMinutes', 1, localizeOptions);
      } else {
        return locale$1.formatDistance('xMinutes', 1, localizeOptions);
      }
    } else {
      if (minutes === 0) {
        return locale$1.formatDistance('lessThanXMinutes', 1, localizeOptions);
      } else {
        return locale$1.formatDistance('xMinutes', minutes, localizeOptions);
      }
    }

    // 2 mins up to 0.75 hrs
  } else if (minutes < 45) {
    return locale$1.formatDistance('xMinutes', minutes, localizeOptions);

    // 0.75 hrs up to 1.5 hrs
  } else if (minutes < 90) {
    return locale$1.formatDistance('aboutXHours', 1, localizeOptions);

    // 1.5 hrs up to 24 hrs
  } else if (minutes < MINUTES_IN_DAY) {
    var hours = Math.round(minutes / 60);
    return locale$1.formatDistance('aboutXHours', hours, localizeOptions);

    // 1 day up to 1.75 days
  } else if (minutes < MINUTES_IN_ALMOST_TWO_DAYS) {
    return locale$1.formatDistance('xDays', 1, localizeOptions);

    // 1.75 days up to 30 days
  } else if (minutes < MINUTES_IN_MONTH) {
    var days = Math.round(minutes / MINUTES_IN_DAY);
    return locale$1.formatDistance('xDays', days, localizeOptions);

    // 1 month up to 2 months
  } else if (minutes < MINUTES_IN_TWO_MONTHS) {
    months = Math.round(minutes / MINUTES_IN_MONTH);
    return locale$1.formatDistance('aboutXMonths', months, localizeOptions);
  }
  months = differenceInMonths(dateRight, dateLeft);

  // 2 months up to 12 months
  if (months < 12) {
    var nearestMonth = Math.round(minutes / MINUTES_IN_MONTH);
    return locale$1.formatDistance('xMonths', nearestMonth, localizeOptions);

    // 1 year up to max Date
  } else {
    var monthsSinceStartOfYear = months % 12;
    var years = Math.floor(months / 12);

    // N years up to 1 years 3 months
    if (monthsSinceStartOfYear < 3) {
      return locale$1.formatDistance('aboutXYears', years, localizeOptions);

      // N years 3 months up to N years 9 months
    } else if (monthsSinceStartOfYear < 9) {
      return locale$1.formatDistance('overXYears', years, localizeOptions);

      // N years 9 months up to N year 12 months
    } else {
      return locale$1.formatDistance('almostXYears', years + 1, localizeOptions);
    }
  }
}

function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

function _setPrototypeOf$1(t, e) {
  return _setPrototypeOf$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf$1(t, e);
}

function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf$1(t, e);
}

function _getPrototypeOf$1(t) {
  return _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf$1(t);
}

function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}

function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof$5(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}

function _createSuper(t) {
  var r = _isNativeReflectConstruct();
  return function () {
    var e,
      o = _getPrototypeOf$1(t);
    if (r) {
      var s = _getPrototypeOf$1(this).constructor;
      e = Reflect.construct(o, arguments, s);
    } else e = o.apply(this, arguments);
    return _possibleConstructorReturn(this, e);
  };
}

function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, toPropertyKey$1(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}

var Setter = /*#__PURE__*/function () {
  function Setter() {
    _classCallCheck(this, Setter);
    _defineProperty$5(this, "priority", void 0);
    _defineProperty$5(this, "subPriority", 0);
  }
  _createClass(Setter, [{
    key: "validate",
    value: function validate(_utcDate, _options) {
      return true;
    }
  }]);
  return Setter;
}();
var ValueSetter = /*#__PURE__*/function (_Setter) {
  _inherits(ValueSetter, _Setter);
  var _super = _createSuper(ValueSetter);
  function ValueSetter(value, validateValue, setValue, priority, subPriority) {
    var _this;
    _classCallCheck(this, ValueSetter);
    _this = _super.call(this);
    _this.value = value;
    _this.validateValue = validateValue;
    _this.setValue = setValue;
    _this.priority = priority;
    if (subPriority) {
      _this.subPriority = subPriority;
    }
    return _this;
  }
  _createClass(ValueSetter, [{
    key: "validate",
    value: function validate(utcDate, options) {
      return this.validateValue(utcDate, this.value, options);
    }
  }, {
    key: "set",
    value: function set(utcDate, flags, options) {
      return this.setValue(utcDate, flags, this.value, options);
    }
  }]);
  return ValueSetter;
}(Setter);

var Parser = /*#__PURE__*/function () {
  function Parser() {
    _classCallCheck(this, Parser);
    _defineProperty$5(this, "incompatibleTokens", void 0);
    _defineProperty$5(this, "priority", void 0);
    _defineProperty$5(this, "subPriority", void 0);
  }
  _createClass(Parser, [{
    key: "run",
    value: function run(dateString, token, match, options) {
      var result = this.parse(dateString, token, match, options);
      if (!result) {
        return null;
      }
      return {
        setter: new ValueSetter(result.value, this.validate, this.set, this.priority, this.subPriority),
        rest: result.rest
      };
    }
  }, {
    key: "validate",
    value: function validate(_utcDate, _value, _options) {
      return true;
    }
  }]);
  return Parser;
}();

var EraParser = /*#__PURE__*/function (_Parser) {
  _inherits(EraParser, _Parser);
  var _super = _createSuper(EraParser);
  function EraParser() {
    var _this;
    _classCallCheck(this, EraParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$5(_assertThisInitialized(_this), "priority", 140);
    _defineProperty$5(_assertThisInitialized(_this), "incompatibleTokens", ['R', 'u', 't', 'T']);
    return _this;
  }
  _createClass(EraParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // AD, BC
        case 'G':
        case 'GG':
        case 'GGG':
          return match.era(dateString, {
            width: 'abbreviated'
          }) || match.era(dateString, {
            width: 'narrow'
          });
        // A, B
        case 'GGGGG':
          return match.era(dateString, {
            width: 'narrow'
          });
        // Anno Domini, Before Christ
        case 'GGGG':
        default:
          return match.era(dateString, {
            width: 'wide'
          }) || match.era(dateString, {
            width: 'abbreviated'
          }) || match.era(dateString, {
            width: 'narrow'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      flags.era = value;
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return EraParser;
}(Parser);

var numericPatterns = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59

  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999

  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

function mapValue(parseFnResult, mapFn) {
  if (!parseFnResult) {
    return parseFnResult;
  }
  return {
    value: mapFn(parseFnResult.value),
    rest: parseFnResult.rest
  };
}
function parseNumericPattern(pattern, dateString) {
  var matchResult = dateString.match(pattern);
  if (!matchResult) {
    return null;
  }
  return {
    value: parseInt(matchResult[0], 10),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseTimezonePattern(pattern, dateString) {
  var matchResult = dateString.match(pattern);
  if (!matchResult) {
    return null;
  }

  // Input is 'Z'
  if (matchResult[0] === 'Z') {
    return {
      value: 0,
      rest: dateString.slice(1)
    };
  }
  var sign = matchResult[1] === '+' ? 1 : -1;
  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
  return {
    value: sign * (hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * millisecondsInSecond),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseAnyDigitsSigned(dateString) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, dateString);
}
function parseNDigits(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, dateString);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, dateString);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, dateString);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, dateString);
    default:
      return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), dateString);
  }
}
function parseNDigitsSigned(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, dateString);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, dateString);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, dateString);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, dateString);
    default:
      return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), dateString);
  }
}
function dayPeriodEnumToHours(dayPeriod) {
  switch (dayPeriod) {
    case 'morning':
      return 4;
    case 'evening':
      return 17;
    case 'pm':
    case 'noon':
    case 'afternoon':
      return 12;
    case 'am':
    case 'midnight':
    case 'night':
    default:
      return 0;
  }
}
function normalizeTwoDigitYear(twoDigitYear, currentYear) {
  var isCommonEra = currentYear > 0;
  // Absolute number of the current year:
  // 1 -> 1 AC
  // 0 -> 1 BC
  // -1 -> 2 BC
  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
  var result;
  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    var rangeEnd = absCurrentYear + 50;
    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }
  return isCommonEra ? result : 1 - result;
}
function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

// From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
// | Year     |     y | yy |   yyy |  yyyy | yyyyy |
// |----------|-------|----|-------|-------|-------|
// | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
// | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
// | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
// | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
// | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
var YearParser = /*#__PURE__*/function (_Parser) {
  _inherits(YearParser, _Parser);
  var _super = _createSuper(YearParser);
  function YearParser() {
    var _this;
    _classCallCheck(this, YearParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$5(_assertThisInitialized(_this), "priority", 130);
    _defineProperty$5(_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'u', 'w', 'I', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(YearParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(year) {
        return {
          year: year,
          isTwoDigitYear: token === 'yy'
        };
      };
      switch (token) {
        case 'y':
          return mapValue(parseNDigits(4, dateString), valueCallback);
        case 'yo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'year'
          }), valueCallback);
        default:
          return mapValue(parseNDigits(token.length, dateString), valueCallback);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value.isTwoDigitYear || value.year > 0;
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      var currentYear = date.getUTCFullYear();
      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }
      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return YearParser;
}(Parser);

// Local week-numbering year
var LocalWeekYearParser = /*#__PURE__*/function (_Parser) {
  _inherits(LocalWeekYearParser, _Parser);
  var _super = _createSuper(LocalWeekYearParser);
  function LocalWeekYearParser() {
    var _this;
    _classCallCheck(this, LocalWeekYearParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$5(_assertThisInitialized(_this), "priority", 130);
    _defineProperty$5(_assertThisInitialized(_this), "incompatibleTokens", ['y', 'R', 'u', 'Q', 'q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']);
    return _this;
  }
  _createClass(LocalWeekYearParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(year) {
        return {
          year: year,
          isTwoDigitYear: token === 'YY'
        };
      };
      switch (token) {
        case 'Y':
          return mapValue(parseNDigits(4, dateString), valueCallback);
        case 'Yo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'year'
          }), valueCallback);
        default:
          return mapValue(parseNDigits(token.length, dateString), valueCallback);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value.isTwoDigitYear || value.year > 0;
    }
  }, {
    key: "set",
    value: function set(date, flags, value, options) {
      var currentYear = getUTCWeekYear(date, options);
      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
        date.setUTCHours(0, 0, 0, 0);
        return startOfUTCWeek(date, options);
      }
      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
      date.setUTCHours(0, 0, 0, 0);
      return startOfUTCWeek(date, options);
    }
  }]);
  return LocalWeekYearParser;
}(Parser);

var ISOWeekYearParser = /*#__PURE__*/function (_Parser) {
  _inherits(ISOWeekYearParser, _Parser);
  var _super = _createSuper(ISOWeekYearParser);
  function ISOWeekYearParser() {
    var _this;
    _classCallCheck(this, ISOWeekYearParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$5(_assertThisInitialized(_this), "priority", 130);
    _defineProperty$5(_assertThisInitialized(_this), "incompatibleTokens", ['G', 'y', 'Y', 'u', 'Q', 'q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(ISOWeekYearParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      if (token === 'R') {
        return parseNDigitsSigned(4, dateString);
      }
      return parseNDigitsSigned(token.length, dateString);
    }
  }, {
    key: "set",
    value: function set(_date, _flags, value) {
      var firstWeekOfYear = new Date(0);
      firstWeekOfYear.setUTCFullYear(value, 0, 4);
      firstWeekOfYear.setUTCHours(0, 0, 0, 0);
      return startOfUTCISOWeek(firstWeekOfYear);
    }
  }]);
  return ISOWeekYearParser;
}(Parser);

var ExtendedYearParser = /*#__PURE__*/function (_Parser) {
  _inherits(ExtendedYearParser, _Parser);
  var _super = _createSuper(ExtendedYearParser);
  function ExtendedYearParser() {
    var _this;
    _classCallCheck(this, ExtendedYearParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$5(_assertThisInitialized(_this), "priority", 130);
    _defineProperty$5(_assertThisInitialized(_this), "incompatibleTokens", ['G', 'y', 'Y', 'R', 'w', 'I', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(ExtendedYearParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      if (token === 'u') {
        return parseNDigitsSigned(4, dateString);
      }
      return parseNDigitsSigned(token.length, dateString);
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return ExtendedYearParser;
}(Parser);

var QuarterParser = /*#__PURE__*/function (_Parser) {
  _inherits(QuarterParser, _Parser);
  var _super = _createSuper(QuarterParser);
  function QuarterParser() {
    var _this;
    _classCallCheck(this, QuarterParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$5(_assertThisInitialized(_this), "priority", 120);
    _defineProperty$5(_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(QuarterParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // 1, 2, 3, 4
        case 'Q':
        case 'QQ':
          // 01, 02, 03, 04
          return parseNDigits(token.length, dateString);
        // 1st, 2nd, 3rd, 4th
        case 'Qo':
          return match.ordinalNumber(dateString, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4
        case 'QQQ':
          return match.quarter(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case 'QQQQQ':
          return match.quarter(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1st quarter, 2nd quarter, ...
        case 'QQQQ':
        default:
          return match.quarter(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.quarter(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 4;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return QuarterParser;
}(Parser);

var StandAloneQuarterParser = /*#__PURE__*/function (_Parser) {
  _inherits(StandAloneQuarterParser, _Parser);
  var _super = _createSuper(StandAloneQuarterParser);
  function StandAloneQuarterParser() {
    var _this;
    _classCallCheck(this, StandAloneQuarterParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$5(_assertThisInitialized(_this), "priority", 120);
    _defineProperty$5(_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'Q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(StandAloneQuarterParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // 1, 2, 3, 4
        case 'q':
        case 'qq':
          // 01, 02, 03, 04
          return parseNDigits(token.length, dateString);
        // 1st, 2nd, 3rd, 4th
        case 'qo':
          return match.ordinalNumber(dateString, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4
        case 'qqq':
          return match.quarter(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case 'qqqqq':
          return match.quarter(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1st quarter, 2nd quarter, ...
        case 'qqqq':
        default:
          return match.quarter(dateString, {
            width: 'wide',
            context: 'standalone'
          }) || match.quarter(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 4;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return StandAloneQuarterParser;
}(Parser);

var MonthParser = /*#__PURE__*/function (_Parser) {
  _inherits(MonthParser, _Parser);
  var _super = _createSuper(MonthParser);
  function MonthParser() {
    var _this;
    _classCallCheck(this, MonthParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$5(_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'L', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);
    _defineProperty$5(_assertThisInitialized(_this), "priority", 110);
    return _this;
  }
  _createClass(MonthParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(value) {
        return value - 1;
      };
      switch (token) {
        // 1, 2, ..., 12
        case 'M':
          return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback);
        // 01, 02, ..., 12
        case 'MM':
          return mapValue(parseNDigits(2, dateString), valueCallback);
        // 1st, 2nd, ..., 12th
        case 'Mo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'month'
          }), valueCallback);
        // Jan, Feb, ..., Dec
        case 'MMM':
          return match.month(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // J, F, ..., D
        case 'MMMMM':
          return match.month(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // January, February, ..., December
        case 'MMMM':
        default:
          return match.month(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.month(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 11;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return MonthParser;
}(Parser);

var StandAloneMonthParser = /*#__PURE__*/function (_Parser) {
  _inherits(StandAloneMonthParser, _Parser);
  var _super = _createSuper(StandAloneMonthParser);
  function StandAloneMonthParser() {
    var _this;
    _classCallCheck(this, StandAloneMonthParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$5(_assertThisInitialized(_this), "priority", 110);
    _defineProperty$5(_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'M', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(StandAloneMonthParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(value) {
        return value - 1;
      };
      switch (token) {
        // 1, 2, ..., 12
        case 'L':
          return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback);
        // 01, 02, ..., 12
        case 'LL':
          return mapValue(parseNDigits(2, dateString), valueCallback);
        // 1st, 2nd, ..., 12th
        case 'Lo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'month'
          }), valueCallback);
        // Jan, Feb, ..., Dec
        case 'LLL':
          return match.month(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // J, F, ..., D
        case 'LLLLL':
          return match.month(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // January, February, ..., December
        case 'LLLL':
        default:
          return match.month(dateString, {
            width: 'wide',
            context: 'standalone'
          }) || match.month(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 11;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return StandAloneMonthParser;
}(Parser);

function setUTCWeek(dirtyDate, dirtyWeek, options) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var week = toInteger$1(dirtyWeek);
  var diff = getUTCWeek(date, options) - week;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}

var LocalWeekParser = /*#__PURE__*/function (_Parser) {
  _inherits(LocalWeekParser, _Parser);
  var _super = _createSuper(LocalWeekParser);
  function LocalWeekParser() {
    var _this;
    _classCallCheck(this, LocalWeekParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$5(_assertThisInitialized(_this), "priority", 100);
    _defineProperty$5(_assertThisInitialized(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']);
    return _this;
  }
  _createClass(LocalWeekParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'w':
          return parseNumericPattern(numericPatterns.week, dateString);
        case 'wo':
          return match.ordinalNumber(dateString, {
            unit: 'week'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 53;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      return startOfUTCWeek(setUTCWeek(date, value, options), options);
    }
  }]);
  return LocalWeekParser;
}(Parser);

function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var isoWeek = toInteger$1(dirtyISOWeek);
  var diff = getUTCISOWeek(date) - isoWeek;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}

var ISOWeekParser = /*#__PURE__*/function (_Parser) {
  _inherits(ISOWeekParser, _Parser);
  var _super = _createSuper(ISOWeekParser);
  function ISOWeekParser() {
    var _this;
    _classCallCheck(this, ISOWeekParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$5(_assertThisInitialized(_this), "priority", 100);
    _defineProperty$5(_assertThisInitialized(_this), "incompatibleTokens", ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(ISOWeekParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'I':
          return parseNumericPattern(numericPatterns.week, dateString);
        case 'Io':
          return match.ordinalNumber(dateString, {
            unit: 'week'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 53;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      return startOfUTCISOWeek(setUTCISOWeek(date, value));
    }
  }]);
  return ISOWeekParser;
}(Parser);

var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

// Day of the month
var DateParser = /*#__PURE__*/function (_Parser) {
  _inherits(DateParser, _Parser);
  var _super = _createSuper(DateParser);
  function DateParser() {
    var _this;
    _classCallCheck(this, DateParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$5(_assertThisInitialized(_this), "priority", 90);
    _defineProperty$5(_assertThisInitialized(_this), "subPriority", 1);
    _defineProperty$5(_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(DateParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'd':
          return parseNumericPattern(numericPatterns.date, dateString);
        case 'do':
          return match.ordinalNumber(dateString, {
            unit: 'date'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(date, value) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex(year);
      var month = date.getUTCMonth();
      if (isLeapYear) {
        return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
      } else {
        return value >= 1 && value <= DAYS_IN_MONTH[month];
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCDate(value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return DateParser;
}(Parser);

var DayOfYearParser = /*#__PURE__*/function (_Parser) {
  _inherits(DayOfYearParser, _Parser);
  var _super = _createSuper(DayOfYearParser);
  function DayOfYearParser() {
    var _this;
    _classCallCheck(this, DayOfYearParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$5(_assertThisInitialized(_this), "priority", 90);
    _defineProperty$5(_assertThisInitialized(_this), "subpriority", 1);
    _defineProperty$5(_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'M', 'L', 'w', 'I', 'd', 'E', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(DayOfYearParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'D':
        case 'DD':
          return parseNumericPattern(numericPatterns.dayOfYear, dateString);
        case 'Do':
          return match.ordinalNumber(dateString, {
            unit: 'date'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(date, value) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex(year);
      if (isLeapYear) {
        return value >= 1 && value <= 366;
      } else {
        return value >= 1 && value <= 365;
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth(0, value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return DayOfYearParser;
}(Parser);

function setUTCDay(dirtyDate, dirtyDay, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(2, arguments);
  var defaultOptions = getDefaultOptions();
  var weekStartsOn = toInteger$1((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = toDate(dirtyDate);
  var day = toInteger$1(dirtyDay);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

var DayParser = /*#__PURE__*/function (_Parser) {
  _inherits(DayParser, _Parser);
  var _super = _createSuper(DayParser);
  function DayParser() {
    var _this;
    _classCallCheck(this, DayParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$5(_assertThisInitialized(_this), "priority", 90);
    _defineProperty$5(_assertThisInitialized(_this), "incompatibleTokens", ['D', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(DayParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // Tue
        case 'E':
        case 'EE':
        case 'EEE':
          return match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // T
        case 'EEEEE':
          return match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu
        case 'EEEEEE':
          return match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday
        case 'EEEE':
        default:
          return match.day(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 6;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return DayParser;
}(Parser);

var LocalDayParser = /*#__PURE__*/function (_Parser) {
  _inherits(LocalDayParser, _Parser);
  var _super = _createSuper(LocalDayParser);
  function LocalDayParser() {
    var _this;
    _classCallCheck(this, LocalDayParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$5(_assertThisInitialized(_this), "priority", 90);
    _defineProperty$5(_assertThisInitialized(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'c', 't', 'T']);
    return _this;
  }
  _createClass(LocalDayParser, [{
    key: "parse",
    value: function parse(dateString, token, match, options) {
      var valueCallback = function valueCallback(value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };
      switch (token) {
        // 3
        case 'e':
        case 'ee':
          // 03
          return mapValue(parseNDigits(token.length, dateString), valueCallback);
        // 3rd
        case 'eo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'day'
          }), valueCallback);
        // Tue
        case 'eee':
          return match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // T
        case 'eeeee':
          return match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu
        case 'eeeeee':
          return match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday
        case 'eeee':
        default:
          return match.day(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 6;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return LocalDayParser;
}(Parser);

var StandAloneLocalDayParser = /*#__PURE__*/function (_Parser) {
  _inherits(StandAloneLocalDayParser, _Parser);
  var _super = _createSuper(StandAloneLocalDayParser);
  function StandAloneLocalDayParser() {
    var _this;
    _classCallCheck(this, StandAloneLocalDayParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$5(_assertThisInitialized(_this), "priority", 90);
    _defineProperty$5(_assertThisInitialized(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'e', 't', 'T']);
    return _this;
  }
  _createClass(StandAloneLocalDayParser, [{
    key: "parse",
    value: function parse(dateString, token, match, options) {
      var valueCallback = function valueCallback(value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };
      switch (token) {
        // 3
        case 'c':
        case 'cc':
          // 03
          return mapValue(parseNDigits(token.length, dateString), valueCallback);
        // 3rd
        case 'co':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'day'
          }), valueCallback);
        // Tue
        case 'ccc':
          return match.day(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'short',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // T
        case 'ccccc':
          return match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tu
        case 'cccccc':
          return match.day(dateString, {
            width: 'short',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tuesday
        case 'cccc':
        default:
          return match.day(dateString, {
            width: 'wide',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'short',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 6;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return StandAloneLocalDayParser;
}(Parser);

function setUTCISODay(dirtyDate, dirtyDay) {
  requiredArgs(2, arguments);
  var day = toInteger$1(dirtyDay);
  if (day % 7 === 0) {
    day = day - 7;
  }
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

var ISODayParser = /*#__PURE__*/function (_Parser) {
  _inherits(ISODayParser, _Parser);
  var _super = _createSuper(ISODayParser);
  function ISODayParser() {
    var _this;
    _classCallCheck(this, ISODayParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$5(_assertThisInitialized(_this), "priority", 90);
    _defineProperty$5(_assertThisInitialized(_this), "incompatibleTokens", ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'E', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(ISODayParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(value) {
        if (value === 0) {
          return 7;
        }
        return value;
      };
      switch (token) {
        // 2
        case 'i':
        case 'ii':
          // 02
          return parseNDigits(token.length, dateString);
        // 2nd
        case 'io':
          return match.ordinalNumber(dateString, {
            unit: 'day'
          });
        // Tue
        case 'iii':
          return mapValue(match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
        // T
        case 'iiiii':
          return mapValue(match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
        // Tu
        case 'iiiiii':
          return mapValue(match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
        // Tuesday
        case 'iiii':
        default:
          return mapValue(match.day(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 7;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date = setUTCISODay(date, value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return ISODayParser;
}(Parser);

var AMPMParser = /*#__PURE__*/function (_Parser) {
  _inherits(AMPMParser, _Parser);
  var _super = _createSuper(AMPMParser);
  function AMPMParser() {
    var _this;
    _classCallCheck(this, AMPMParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$5(_assertThisInitialized(_this), "priority", 80);
    _defineProperty$5(_assertThisInitialized(_this), "incompatibleTokens", ['b', 'B', 'H', 'k', 't', 'T']);
    return _this;
  }
  _createClass(AMPMParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'a':
        case 'aa':
        case 'aaa':
          return match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'aaaaa':
          return match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'aaaa':
        default:
          return match.dayPeriod(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    }
  }]);
  return AMPMParser;
}(Parser);

var AMPMMidnightParser = /*#__PURE__*/function (_Parser) {
  _inherits(AMPMMidnightParser, _Parser);
  var _super = _createSuper(AMPMMidnightParser);
  function AMPMMidnightParser() {
    var _this;
    _classCallCheck(this, AMPMMidnightParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$5(_assertThisInitialized(_this), "priority", 80);
    _defineProperty$5(_assertThisInitialized(_this), "incompatibleTokens", ['a', 'B', 'H', 'k', 't', 'T']);
    return _this;
  }
  _createClass(AMPMMidnightParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'b':
        case 'bb':
        case 'bbb':
          return match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'bbbbb':
          return match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'bbbb':
        default:
          return match.dayPeriod(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    }
  }]);
  return AMPMMidnightParser;
}(Parser);

var DayPeriodParser = /*#__PURE__*/function (_Parser) {
  _inherits(DayPeriodParser, _Parser);
  var _super = _createSuper(DayPeriodParser);
  function DayPeriodParser() {
    var _this;
    _classCallCheck(this, DayPeriodParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$5(_assertThisInitialized(_this), "priority", 80);
    _defineProperty$5(_assertThisInitialized(_this), "incompatibleTokens", ['a', 'b', 't', 'T']);
    return _this;
  }
  _createClass(DayPeriodParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'B':
        case 'BB':
        case 'BBB':
          return match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'BBBBB':
          return match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'BBBB':
        default:
          return match.dayPeriod(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    }
  }]);
  return DayPeriodParser;
}(Parser);

var Hour1to12Parser = /*#__PURE__*/function (_Parser) {
  _inherits(Hour1to12Parser, _Parser);
  var _super = _createSuper(Hour1to12Parser);
  function Hour1to12Parser() {
    var _this;
    _classCallCheck(this, Hour1to12Parser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$5(_assertThisInitialized(_this), "priority", 70);
    _defineProperty$5(_assertThisInitialized(_this), "incompatibleTokens", ['H', 'K', 'k', 't', 'T']);
    return _this;
  }
  _createClass(Hour1to12Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'h':
          return parseNumericPattern(numericPatterns.hour12h, dateString);
        case 'ho':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 12;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      var isPM = date.getUTCHours() >= 12;
      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else if (!isPM && value === 12) {
        date.setUTCHours(0, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }
      return date;
    }
  }]);
  return Hour1to12Parser;
}(Parser);

var Hour0to23Parser = /*#__PURE__*/function (_Parser) {
  _inherits(Hour0to23Parser, _Parser);
  var _super = _createSuper(Hour0to23Parser);
  function Hour0to23Parser() {
    var _this;
    _classCallCheck(this, Hour0to23Parser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$5(_assertThisInitialized(_this), "priority", 70);
    _defineProperty$5(_assertThisInitialized(_this), "incompatibleTokens", ['a', 'b', 'h', 'K', 'k', 't', 'T']);
    return _this;
  }
  _createClass(Hour0to23Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'H':
          return parseNumericPattern(numericPatterns.hour23h, dateString);
        case 'Ho':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 23;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(value, 0, 0, 0);
      return date;
    }
  }]);
  return Hour0to23Parser;
}(Parser);

var Hour0To11Parser = /*#__PURE__*/function (_Parser) {
  _inherits(Hour0To11Parser, _Parser);
  var _super = _createSuper(Hour0To11Parser);
  function Hour0To11Parser() {
    var _this;
    _classCallCheck(this, Hour0To11Parser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$5(_assertThisInitialized(_this), "priority", 70);
    _defineProperty$5(_assertThisInitialized(_this), "incompatibleTokens", ['h', 'H', 'k', 't', 'T']);
    return _this;
  }
  _createClass(Hour0To11Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'K':
          return parseNumericPattern(numericPatterns.hour11h, dateString);
        case 'Ko':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 11;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      var isPM = date.getUTCHours() >= 12;
      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }
      return date;
    }
  }]);
  return Hour0To11Parser;
}(Parser);

var Hour1To24Parser = /*#__PURE__*/function (_Parser) {
  _inherits(Hour1To24Parser, _Parser);
  var _super = _createSuper(Hour1To24Parser);
  function Hour1To24Parser() {
    var _this;
    _classCallCheck(this, Hour1To24Parser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$5(_assertThisInitialized(_this), "priority", 70);
    _defineProperty$5(_assertThisInitialized(_this), "incompatibleTokens", ['a', 'b', 'h', 'H', 'K', 't', 'T']);
    return _this;
  }
  _createClass(Hour1To24Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'k':
          return parseNumericPattern(numericPatterns.hour24h, dateString);
        case 'ko':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 24;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      var hours = value <= 24 ? value % 24 : value;
      date.setUTCHours(hours, 0, 0, 0);
      return date;
    }
  }]);
  return Hour1To24Parser;
}(Parser);

var MinuteParser = /*#__PURE__*/function (_Parser) {
  _inherits(MinuteParser, _Parser);
  var _super = _createSuper(MinuteParser);
  function MinuteParser() {
    var _this;
    _classCallCheck(this, MinuteParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$5(_assertThisInitialized(_this), "priority", 60);
    _defineProperty$5(_assertThisInitialized(_this), "incompatibleTokens", ['t', 'T']);
    return _this;
  }
  _createClass(MinuteParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'm':
          return parseNumericPattern(numericPatterns.minute, dateString);
        case 'mo':
          return match.ordinalNumber(dateString, {
            unit: 'minute'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 59;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMinutes(value, 0, 0);
      return date;
    }
  }]);
  return MinuteParser;
}(Parser);

var SecondParser = /*#__PURE__*/function (_Parser) {
  _inherits(SecondParser, _Parser);
  var _super = _createSuper(SecondParser);
  function SecondParser() {
    var _this;
    _classCallCheck(this, SecondParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$5(_assertThisInitialized(_this), "priority", 50);
    _defineProperty$5(_assertThisInitialized(_this), "incompatibleTokens", ['t', 'T']);
    return _this;
  }
  _createClass(SecondParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 's':
          return parseNumericPattern(numericPatterns.second, dateString);
        case 'so':
          return match.ordinalNumber(dateString, {
            unit: 'second'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 59;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCSeconds(value, 0);
      return date;
    }
  }]);
  return SecondParser;
}(Parser);

var FractionOfSecondParser = /*#__PURE__*/function (_Parser) {
  _inherits(FractionOfSecondParser, _Parser);
  var _super = _createSuper(FractionOfSecondParser);
  function FractionOfSecondParser() {
    var _this;
    _classCallCheck(this, FractionOfSecondParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$5(_assertThisInitialized(_this), "priority", 30);
    _defineProperty$5(_assertThisInitialized(_this), "incompatibleTokens", ['t', 'T']);
    return _this;
  }
  _createClass(FractionOfSecondParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      var valueCallback = function valueCallback(value) {
        return Math.floor(value * Math.pow(10, -token.length + 3));
      };
      return mapValue(parseNDigits(token.length, dateString), valueCallback);
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMilliseconds(value);
      return date;
    }
  }]);
  return FractionOfSecondParser;
}(Parser);

var ISOTimezoneWithZParser = /*#__PURE__*/function (_Parser) {
  _inherits(ISOTimezoneWithZParser, _Parser);
  var _super = _createSuper(ISOTimezoneWithZParser);
  function ISOTimezoneWithZParser() {
    var _this;
    _classCallCheck(this, ISOTimezoneWithZParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$5(_assertThisInitialized(_this), "priority", 10);
    _defineProperty$5(_assertThisInitialized(_this), "incompatibleTokens", ['t', 'T', 'x']);
    return _this;
  }
  _createClass(ISOTimezoneWithZParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      switch (token) {
        case 'X':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);
        case 'XX':
          return parseTimezonePattern(timezonePatterns.basic, dateString);
        case 'XXXX':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);
        case 'XXXXX':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);
        case 'XXX':
        default:
          return parseTimezonePattern(timezonePatterns.extended, dateString);
      }
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      if (flags.timestampIsSet) {
        return date;
      }
      return new Date(date.getTime() - value);
    }
  }]);
  return ISOTimezoneWithZParser;
}(Parser);

var ISOTimezoneParser = /*#__PURE__*/function (_Parser) {
  _inherits(ISOTimezoneParser, _Parser);
  var _super = _createSuper(ISOTimezoneParser);
  function ISOTimezoneParser() {
    var _this;
    _classCallCheck(this, ISOTimezoneParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$5(_assertThisInitialized(_this), "priority", 10);
    _defineProperty$5(_assertThisInitialized(_this), "incompatibleTokens", ['t', 'T', 'X']);
    return _this;
  }
  _createClass(ISOTimezoneParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      switch (token) {
        case 'x':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);
        case 'xx':
          return parseTimezonePattern(timezonePatterns.basic, dateString);
        case 'xxxx':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);
        case 'xxxxx':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);
        case 'xxx':
        default:
          return parseTimezonePattern(timezonePatterns.extended, dateString);
      }
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      if (flags.timestampIsSet) {
        return date;
      }
      return new Date(date.getTime() - value);
    }
  }]);
  return ISOTimezoneParser;
}(Parser);

var TimestampSecondsParser = /*#__PURE__*/function (_Parser) {
  _inherits(TimestampSecondsParser, _Parser);
  var _super = _createSuper(TimestampSecondsParser);
  function TimestampSecondsParser() {
    var _this;
    _classCallCheck(this, TimestampSecondsParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$5(_assertThisInitialized(_this), "priority", 40);
    _defineProperty$5(_assertThisInitialized(_this), "incompatibleTokens", '*');
    return _this;
  }
  _createClass(TimestampSecondsParser, [{
    key: "parse",
    value: function parse(dateString) {
      return parseAnyDigitsSigned(dateString);
    }
  }, {
    key: "set",
    value: function set(_date, _flags, value) {
      return [new Date(value * 1000), {
        timestampIsSet: true
      }];
    }
  }]);
  return TimestampSecondsParser;
}(Parser);

var TimestampMillisecondsParser = /*#__PURE__*/function (_Parser) {
  _inherits(TimestampMillisecondsParser, _Parser);
  var _super = _createSuper(TimestampMillisecondsParser);
  function TimestampMillisecondsParser() {
    var _this;
    _classCallCheck(this, TimestampMillisecondsParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$5(_assertThisInitialized(_this), "priority", 20);
    _defineProperty$5(_assertThisInitialized(_this), "incompatibleTokens", '*');
    return _this;
  }
  _createClass(TimestampMillisecondsParser, [{
    key: "parse",
    value: function parse(dateString) {
      return parseAnyDigitsSigned(dateString);
    }
  }, {
    key: "set",
    value: function set(_date, _flags, value) {
      return [new Date(value), {
        timestampIsSet: true
      }];
    }
  }]);
  return TimestampMillisecondsParser;
}(Parser);

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */
({
  G: new EraParser(),
  y: new YearParser(),
  Y: new LocalWeekYearParser(),
  R: new ISOWeekYearParser(),
  u: new ExtendedYearParser(),
  Q: new QuarterParser(),
  q: new StandAloneQuarterParser(),
  M: new MonthParser(),
  L: new StandAloneMonthParser(),
  w: new LocalWeekParser(),
  I: new ISOWeekParser(),
  d: new DateParser(),
  D: new DayOfYearParser(),
  E: new DayParser(),
  e: new LocalDayParser(),
  c: new StandAloneLocalDayParser(),
  i: new ISODayParser(),
  a: new AMPMParser(),
  b: new AMPMMidnightParser(),
  B: new DayPeriodParser(),
  h: new Hour1to12Parser(),
  H: new Hour0to23Parser(),
  K: new Hour0To11Parser(),
  k: new Hour1To24Parser(),
  m: new MinuteParser(),
  s: new SecondParser(),
  S: new FractionOfSecondParser(),
  X: new ISOTimezoneWithZParser(),
  x: new ISOTimezoneParser(),
  t: new TimestampSecondsParser(),
  T: new TimestampMillisecondsParser()
});

let cachedResults = null;
async function fetchLibrarySongs(startIndex, limit, searchTerm, activeFilters, clientConfig) {
  try {
    let songsJson;

    // pgw 04-apr-2023 test with timeout of 20 seconds
    //   const response = await fetch(clientConfig.features.library.endpoint);
    const response = await fetch(clientConfig.features.library.endpoint, {
      timeout: 20000
    });
    if (response.status === 200) {
      songsJson = await response.json();
    } else {
      throw new Error('Library request failed');
    }
    let songs = Array.from(new Set(songsJson));
    songs = songs.filter(song => song.songId !== 's3fm0063_0301'); // filer out the odd duplicate in the reponse

    //temporary filter to exclude songs that dont play
    songs = songs.filter(song => !clientConfig.features.library.songsToHide.includes(song.songId));

    // songs = songs.sort((a,b)=> { 
    //   return config.WORKING_ON_IOS.indexOf(b.songId) - config.WORKING_ON_IOS.indexOf(a.songId)
    // });

    if (searchTerm) {
      songs = songs.filter(song => song.artist.toLowerCase().includes(searchTerm) || song.mix.toLowerCase().includes(searchTerm) || song.songId === searchTerm);
    }
    if (activeFilters) {
      if (activeFilters.genres.length) {
        songs = songs.filter(song => activeFilters.genres.includes(song.genre));
      }
      if (activeFilters.keySignatures.length) {
        songs = songs.filter(song => activeFilters.keySignatures.includes(song.key));
      }
      if (activeFilters.decades.length) {
        songs = songs.filter(song => activeFilters.decades.includes(song.decade));
      }
    }
    return {
      data: songs.slice(startIndex, limit)
    };
  } catch (e) {
    console.error(e);
    throw new Error(e.message);
  }
}
async function fetchLibrarySongsById(songIds, clientConfig) {
  try {
    if (!cachedResults) {
      // pgw 04-apr-2023 test with timeout of 20 seconds
      //       const response = await fetch(clientConfig.features.library.endpoint);
      const response = await fetch(clientConfig.features.library.endpoint, {
        timeout: 20000
      });
      if (response.status === 200) {
        cachedResults = await response.json();
      } else {
        throw new Error('Library request failed');
      }
    }
    let songs = Array.from(new Set(cachedResults));
    let results = [];

    //temporary filter to exclude songs that dont play
    songs = songs.filter(song => !clientConfig.features.library.songsToHide.includes(song.songId));
    for (const id of songIds) {
      const foundSong = songs.find(s => s.songId === id);
      if (foundSong) {
        results.push(foundSong);
      }
    }
    return {
      data: results
    };
  } catch (e) {
    console.error(e);
    throw new Error(e.message);
  }
}

const initialState$6 = {
  songs: [],
  status: "idle"
};

const fetchLibrarySongsAsync = createAsyncThunk('setlist/fetchLibrary', async (payload, thunkAPI) => {
  const clientConfig = thunkAPI.getState().ui.clientConfig;
  const response = await fetchLibrarySongs(payload.startIndex, payload.limit, payload.search, payload.activeFilters, clientConfig);
  return response.data;
});
const fetchLibrarySongsByIdAsync = createAsyncThunk('setlist/fetchLibraryById', async (payload, thunkAPI) => {
  const clientConfig = thunkAPI.getState().ui.clientConfig;
  const response = await fetchLibrarySongsById(payload.songIds, clientConfig);
  return response.data;
});
const librarySlice = createSlice({
  name: 'library',
  initialState: initialState$6,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchLibrarySongsAsync.pending, state => {
      state.status = 'pending';
    }).addCase(fetchLibrarySongsAsync.rejected, (state, action) => {
      state.status = 'rejected';
      state.songs = [];
    }).addCase(fetchLibrarySongsAsync.fulfilled, (state, action) => {
      state.status = 'idle';
      state.songs = action.payload;
    }).addCase(fetchLibrarySongsByIdAsync.pending, state => {
      state.status = 'pending';
    }).addCase(fetchLibrarySongsByIdAsync.rejected, (state, action) => {
      state.status = 'rejected';
      state.songs = [];
    }).addCase(fetchLibrarySongsByIdAsync.fulfilled, (state, action) => {
      state.status = 'idle';
      state.songs = action.payload;
    });
  }
});

// export const { increment, decrement, incrementByAmount } = setlistSlice.actions;

const selectLibrarySongs = state => state.library.songs;
const selectLibraryStatus = state => state.library.status;
var libraryReducer = librarySlice.reducer;

const cacheAssets = async (assetUrls, progressCallback) => {
  try {
    let cachedCount = 1;
    for (const assetUrl of assetUrls) {
      await getAsset(assetUrl, true, () => {});
      progressCallback(cachedCount / assetUrls.length);
      cachedCount++;
    }
    return true;
  } catch (e) {
    throw Error('Could not cache assets');
  }
};
const uncacheAssets = async assetUrls => {
  try {
    for (const assetUrl of assetUrls) {
      await removeAssetFromCache(assetUrl);
    }
    return true;
  } catch (e) {
    throw Error('Could not cache assets');
  }
};
const packSetlist = async sessions => {
  // create a zip of each session
  const sessionZips = {};
  for (const session of sessions) {
    sessionZips[session.id] = await packSession(session);
  }

  // Cretae new zip file
  const setListZip = await createSetlistZip(sessionZips);
  return setListZip;
};

const initialState$5 = {
  setlists: [],
  status: "idle",
  cachingProgress: null
};

const cacheSetlistAssetsAsync = createAsyncThunk("setlists/cacheSetlist", async (payload, thunkAPI) => {
  if (payload.items.length === 0) ; else {
    const setlist = {
      ...thunkAPI.getState().setlists.setlists.find(s => s.id === payload.id)
    };
    const assetUrls = [];
    for (const setlistSong of setlist.items) {
      assetUrls.push(setlistSong.pathzip);

      // Add lyrics asset if song has it
      if (setlistSong.lyricsUrl) assetUrls.push(setlistSong.lyricsUrl);
    }
    await cacheAssets(assetUrls, perentage => {
      thunkAPI.dispatch(setCacheProgress(perentage));
    });
    setlist.cached = true;
    return setlist;
  }
});
const uncacheSetlistAssetsAsync = createAsyncThunk("setlists/uncacheSetlist", async (payload, thunkAPI) => {
  const setlist = {
    ...thunkAPI.getState().setlists.setlists.find(s => s.id === payload.id)
  };
  const setlists = thunkAPI.getState().setlists.setlists;
  const setlistsWhichContainUrl = urlToCheck => {
    return setlists.filter(setlist => setlist.items.find(song => song.pathzip === urlToCheck));
  };
  const assetUrls = [];
  for (const setlistSong of setlist.items) {
    if (setlistsWhichContainUrl(setlistSong.pathzip).length < 2) {
      assetUrls.push(setlistSong.pathzip);
      // Add lyrics asset if song has it
      if (setlistSong.lyricsUrl) assetUrls.push(setlistSong.lyricsUrl);
    }
  }
  await uncacheAssets(assetUrls);
  setlist.cached = false;
  return setlist;
});
const unpackSessionAsync = createAsyncThunk("session/unpack", async (payload, thunkAPI) => {
  const sessionObject = await unpackSession(payload);
  return sessionObject;
});
const unpackSetlistAsync = createAsyncThunk("session/unpackSetlist", async (payload, thunkAPI) => {
  const setlistObject = await unpackSetlist(payload);
  const setlistSessions = [];
  for (const setlistKey of Object.getOwnPropertyNames(setlistObject)) {
    const sessionBlob = setlistObject[setlistKey];
    const sessionObject = await unpackSession(sessionBlob);
    setlistSessions.push(sessionObject);
  }
  return setlistSessions;
});
const packSetlistAsync = createAsyncThunk("session/packSetlist", async (payload, thunkAPI) => {
  // Get setlist session from state
  // Filter out all containing userAudio stems
  const sessions = thunkAPI.getState().setlist.sessions.filter(s => s.userStems.length === 0);

  // Add all session zips into one master .setlist zip file
  const setListBlob = await packSetlist(sessions);

  // Prompt download in browser 👍
  const dateNow = new Date();
  const setlistFilename = `mySetlist-${dateNow.toLocaleDateString().replaceAll("/", "")}_${dateNow.toLocaleTimeString().replaceAll(":", "")}.setlist`;
  triggerBlobDownload(setListBlob, setlistFilename);
  thunkAPI.dispatch(addNotificationAsync({
    title: "Setlist saved",
    text: `${setlistFilename} was downloaded`,
    type: "positive"
  }));
  return true;
});
const removeSessionFromSetlistAsync = createAsyncThunk("setlsit/remove", async (payload, thunkAPI) => {
  // Remove associated items from cache
  const session = thunkAPI.getState().setlist.sessions.find(s => s.id === payload);
  for (const userStem of session.userStems) {
    await removeAssetFromCache(userStem.id);
  }
  // Remove associated song zip
  await removeAssetFromCache(session.song.pathzip);
  return payload;
});
const setlistsSlice = createSlice({
  name: "setlists",
  initialState: initialState$5,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    createNewEmptySetlist: (state, action) => {
      const newSetlist = {
        id: v4().slice(0, 8),
        title: action.payload.title,
        subTitle: action.payload.subtitle,
        imageUrl: action.payload.imageUrl,
        createdAt: new Date().toISOString(),
        lastUpdatedAt: new Date().toISOString(),
        cached: false,
        items: [],
        readOnly: false
      };
      state.setlists.push(newSetlist);
    },
    createSetlistFromData: (state, action) => {
      const newSetlist = {
        id: action.payload.setlistId || v4().slice(0, 8),
        title: action.payload.title,
        subTitle: action.payload.subtitle,
        imageUrl: action.payload.imageUrl,
        createdAt: new Date().toISOString(),
        lastUpdatedAt: new Date().toISOString(),
        cached: false,
        items: action.payload.items,
        readOnly: action.payload.readOnly
      };
      state.setlists.push(newSetlist);
    },
    removeSetListFromSetlists: (state, action) => {
      state.setlists = state.setlists.filter(setlist => setlist.id !== action.payload);
    },
    setCacheProgress: (state, action) => {
      state.cachingProgress = action.payload;
    },
    createSessionFromSong: (state, action) => {
      const newSession = {
        ...initialState$9,
        id: v4().slice(0, 8),
        title: action.payload.title,
        song: action.payload.song
      };
      state.sessions.push(newSession);
    },
    addSongToSetlist: (state, action) => {
      const setlist = state.setlists.find(setlist => setlist.id === action.payload.setlistId);
      if (setlist) {
        if (!setlist.items.find(song => song.songId === action.payload.song.songId)) {
          setlist.items = [...setlist.items, action.payload.song];
        }
      }
      state.setlists = [...state.setlists];
    },
    removeSongFromSetlist: (state, action) => {
      const setlist = state.setlists.find(setlist => setlist.id === action.payload.setlistId);
      if (setlist) {
        setlist.items = [...setlist.items.filter(song => song.songId !== action.payload.song.songId)];
      }
      state.setlists = [...state.setlists];
    }
  },
  extraReducers: builder => {
    builder.addCase(removeSessionFromSetlistAsync.fulfilled, (state, action) => {
      state.sessions = state.sessions.filter(s => s.id !== action.payload);
    }).addCase(packSetlistAsync.pending, (state, action) => {}).addCase(packSetlistAsync.rejected, (state, action) => {
      state.status = "error";
      console.error(action);
    }).addCase(packSetlistAsync.fulfilled, (state, action) => {}).addCase(cacheSetlistAssetsAsync.pending, (state, action) => {
      state.status = "caching";
      state.cachingProgress = 0.01;
    }).addCase(cacheSetlistAssetsAsync.rejected, (state, action) => {
      state.status = "error";
      console.error(action);
      state.cachingProgress = null;
    }).addCase(cacheSetlistAssetsAsync.fulfilled, (state, action) => {
      let existingSetlists = [...state.setlists];
      existingSetlists.find(setlist => setlist.id === action.payload.id).cached = true;
      state.cachingProgress = null;
      state.setlists = existingSetlists;
      state.status = "idle";
    }).addCase(uncacheSetlistAssetsAsync.pending, (state, action) => {
      state.status = "uncaching";
    }).addCase(uncacheSetlistAssetsAsync.rejected, (state, action) => {
      state.status = "error";
      state.cachingProgress = null;
    }).addCase(uncacheSetlistAssetsAsync.fulfilled, (state, action) => {
      let existingSetlists = [...state.setlists];
      existingSetlists.find(setlist => setlist.id === action.payload.id).cached = false;
      state.cachingProgress = null;
      state.setlists = existingSetlists;
      state.status = "idle";
    }).addCase(unpackSessionAsync.pending, (state, action) => {
      state.status = "unpacking";
      state.loadingProgress = 7;
    }).addCase(unpackSessionAsync.rejected, (state, action) => {
      state.status = "error";
      console.error(action);
    }).addCase(unpackSessionAsync.fulfilled, (state, action) => {
      Object.getOwnPropertyNames(action.payload).forEach(propertyName => {
        state[propertyName] = action.payload[propertyName];
      });
      const newSession = {
        ...action.payload,
        id: v4().slice(0, 8),
        imported: true,
        importedAt: new Date().toISOString()
      };
      state.sessions.push(newSession);
      state.status = "ready";
      state.loadingProgress = 10;
    }).addCase(unpackSetlistAsync.fulfilled, (state, action) => {
      const sessionPack = [];
      for (const session of action.payload) {
        const importedSession = {};
        Object.getOwnPropertyNames(session).forEach(propertyName => {
          importedSession[propertyName] = session[propertyName];
        });
        const newSession = {
          ...importedSession,
          id: v4().slice(0, 8),
          imported: true,
          importedAt: new Date().toISOString()
        };
        sessionPack.push(newSession);
      }
      state.sessions = [...state.sessions, ...sessionPack];
    });
  }
});
const {
  createNewEmptySetlist,
  createSetlistFromData,
  removeSetListFromSetlists,
  addSongToSetlist,
  removeSongFromSetlist,
  setCacheProgress
} = setlistsSlice.actions;
const selectSetlistsSetlists = state => state.setlists.setlists;
const selectSetlistsCachingProgress = state => state.setlists.cachingProgress;
var setlistsReducer = setlistsSlice.reducer;

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$b = "";
styleInject(css_248z$b,{"insertAt":"top"});

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}
function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}
var runtime_1 = createCommonjsModule(function (module) {
  /**
   * Copyright (c) 2014-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var runtime = function (exports) {
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var undefined$1; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
      return obj[key];
    }
    try {
      // IE 8 has a broken Object.defineProperty that only works on DOM objects.
      define({}, "");
    } catch (err) {
      define = function (obj, key, value) {
        return obj[key] = value;
      };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
      // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
      var generator = Object.create(protoGenerator.prototype);
      var context = new Context(tryLocsList || []);

      // The ._invoke method unifies the implementations of the .next,
      // .throw, and .return methods.
      generator._invoke = makeInvokeMethod(innerFn, self, context);
      return generator;
    }
    exports.wrap = wrap;

    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
      try {
        return {
          type: "normal",
          arg: fn.call(obj, arg)
        };
      } catch (err) {
        return {
          type: "throw",
          arg: err
        };
      }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";

    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};

    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}

    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    IteratorPrototype[iteratorSymbol] = function () {
      return this;
    };
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
      // This environment has a native %IteratorPrototype%; use it instead
      // of the polyfill.
      IteratorPrototype = NativeIteratorPrototype;
    }
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
    GeneratorFunctionPrototype.constructor = GeneratorFunction;
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");

    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function (method) {
        define(prototype, method, function (arg) {
          return this._invoke(method, arg);
        });
      });
    }
    exports.isGeneratorFunction = function (genFun) {
      var ctor = typeof genFun === "function" && genFun.constructor;
      return ctor ? ctor === GeneratorFunction ||
      // For the native GeneratorFunction constructor, the best we can
      // do is to check its .name property.
      (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function (genFun) {
      if (Object.setPrototypeOf) {
        Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
      } else {
        genFun.__proto__ = GeneratorFunctionPrototype;
        define(genFun, toStringTagSymbol, "GeneratorFunction");
      }
      genFun.prototype = Object.create(Gp);
      return genFun;
    };

    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function (arg) {
      return {
        __await: arg
      };
    };
    function AsyncIterator(generator, PromiseImpl) {
      function invoke(method, arg, resolve, reject) {
        var record = tryCatch(generator[method], generator, arg);
        if (record.type === "throw") {
          reject(record.arg);
        } else {
          var result = record.arg;
          var value = result.value;
          if (value && typeof value === "object" && hasOwn.call(value, "__await")) {
            return PromiseImpl.resolve(value.__await).then(function (value) {
              invoke("next", value, resolve, reject);
            }, function (err) {
              invoke("throw", err, resolve, reject);
            });
          }
          return PromiseImpl.resolve(value).then(function (unwrapped) {
            // When a yielded Promise is resolved, its final value becomes
            // the .value of the Promise<{value,done}> result for the
            // current iteration.
            result.value = unwrapped;
            resolve(result);
          }, function (error) {
            // If a rejected Promise was yielded, throw the rejection back
            // into the async generator function so it can be handled there.
            return invoke("throw", error, resolve, reject);
          });
        }
      }
      var previousPromise;
      function enqueue(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(callInvokeWithMethodAndArg,
        // Avoid propagating failures to Promises returned by later
        // invocations of the iterator.
        callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }

      // Define the unified helper method that is used to implement .next,
      // .throw, and .return (see defineIteratorMethods).
      this._invoke = enqueue;
    }
    defineIteratorMethods(AsyncIterator.prototype);
    AsyncIterator.prototype[asyncIteratorSymbol] = function () {
      return this;
    };
    exports.AsyncIterator = AsyncIterator;

    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
      if (PromiseImpl === void 0) PromiseImpl = Promise;
      var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
      return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function (result) {
        return result.done ? result.value : iter.next();
      });
    };
    function makeInvokeMethod(innerFn, self, context) {
      var state = GenStateSuspendedStart;
      return function invoke(method, arg) {
        if (state === GenStateExecuting) {
          throw new Error("Generator is already running");
        }
        if (state === GenStateCompleted) {
          if (method === "throw") {
            throw arg;
          }

          // Be forgiving, per 25.3.3.3.3 of the spec:
          // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
          return doneResult();
        }
        context.method = method;
        context.arg = arg;
        while (true) {
          var delegate = context.delegate;
          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);
            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }
          if (context.method === "next") {
            // Setting context._sent for legacy support of Babel's
            // function.sent implementation.
            context.sent = context._sent = context.arg;
          } else if (context.method === "throw") {
            if (state === GenStateSuspendedStart) {
              state = GenStateCompleted;
              throw context.arg;
            }
            context.dispatchException(context.arg);
          } else if (context.method === "return") {
            context.abrupt("return", context.arg);
          }
          state = GenStateExecuting;
          var record = tryCatch(innerFn, self, context);
          if (record.type === "normal") {
            // If an exception is thrown from innerFn, we leave state ===
            // GenStateExecuting and loop back for another invocation.
            state = context.done ? GenStateCompleted : GenStateSuspendedYield;
            if (record.arg === ContinueSentinel) {
              continue;
            }
            return {
              value: record.arg,
              done: context.done
            };
          } else if (record.type === "throw") {
            state = GenStateCompleted;
            // Dispatch the exception by looping back around to the
            // context.dispatchException(context.arg) call above.
            context.method = "throw";
            context.arg = record.arg;
          }
        }
      };
    }

    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
      var method = delegate.iterator[context.method];
      if (method === undefined$1) {
        // A .throw or .return when the delegate iterator has no .throw
        // method always terminates the yield* loop.
        context.delegate = null;
        if (context.method === "throw") {
          // Note: ["return"] must be used for ES3 parsing compatibility.
          if (delegate.iterator["return"]) {
            // If the delegate iterator has a return method, give it a
            // chance to clean up.
            context.method = "return";
            context.arg = undefined$1;
            maybeInvokeDelegate(delegate, context);
            if (context.method === "throw") {
              // If maybeInvokeDelegate(context) changed context.method from
              // "return" to "throw", let that override the TypeError below.
              return ContinueSentinel;
            }
          }
          context.method = "throw";
          context.arg = new TypeError("The iterator does not provide a 'throw' method");
        }
        return ContinueSentinel;
      }
      var record = tryCatch(method, delegate.iterator, context.arg);
      if (record.type === "throw") {
        context.method = "throw";
        context.arg = record.arg;
        context.delegate = null;
        return ContinueSentinel;
      }
      var info = record.arg;
      if (!info) {
        context.method = "throw";
        context.arg = new TypeError("iterator result is not an object");
        context.delegate = null;
        return ContinueSentinel;
      }
      if (info.done) {
        // Assign the result of the finished delegate to the temporary
        // variable specified by delegate.resultName (see delegateYield).
        context[delegate.resultName] = info.value;

        // Resume execution at the desired location (see delegateYield).
        context.next = delegate.nextLoc;

        // If context.method was "throw" but the delegate handled the
        // exception, let the outer generator proceed normally. If
        // context.method was "next", forget context.arg since it has been
        // "consumed" by the delegate iterator. If context.method was
        // "return", allow the original .return call to continue in the
        // outer generator.
        if (context.method !== "return") {
          context.method = "next";
          context.arg = undefined$1;
        }
      } else {
        // Re-yield the result returned by the delegate method.
        return info;
      }

      // The delegate iterator is finished, so forget it and continue with
      // the outer generator.
      context.delegate = null;
      return ContinueSentinel;
    }

    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");

    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    Gp[iteratorSymbol] = function () {
      return this;
    };
    Gp.toString = function () {
      return "[object Generator]";
    };
    function pushTryEntry(locs) {
      var entry = {
        tryLoc: locs[0]
      };
      if (1 in locs) {
        entry.catchLoc = locs[1];
      }
      if (2 in locs) {
        entry.finallyLoc = locs[2];
        entry.afterLoc = locs[3];
      }
      this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal";
      delete record.arg;
      entry.completion = record;
    }
    function Context(tryLocsList) {
      // The root entry object (effectively a try statement without a catch
      // or a finally block) gives us a place to store values thrown from
      // locations where there is no enclosing try statement.
      this.tryEntries = [{
        tryLoc: "root"
      }];
      tryLocsList.forEach(pushTryEntry, this);
      this.reset(true);
    }
    exports.keys = function (object) {
      var keys = [];
      for (var key in object) {
        keys.push(key);
      }
      keys.reverse();

      // Rather than returning an object with a next method, we keep
      // things simple and return the next function itself.
      return function next() {
        while (keys.length) {
          var key = keys.pop();
          if (key in object) {
            next.value = key;
            next.done = false;
            return next;
          }
        }

        // To avoid creating an additional object, we just hang the .value
        // and .done properties off the next function object itself. This
        // also ensures that the minifier will not anonymize the function.
        next.done = true;
        return next;
      };
    };
    function values(iterable) {
      if (iterable) {
        var iteratorMethod = iterable[iteratorSymbol];
        if (iteratorMethod) {
          return iteratorMethod.call(iterable);
        }
        if (typeof iterable.next === "function") {
          return iterable;
        }
        if (!isNaN(iterable.length)) {
          var i = -1,
            next = function next() {
              while (++i < iterable.length) {
                if (hasOwn.call(iterable, i)) {
                  next.value = iterable[i];
                  next.done = false;
                  return next;
                }
              }
              next.value = undefined$1;
              next.done = true;
              return next;
            };
          return next.next = next;
        }
      }

      // Return an iterator with no values.
      return {
        next: doneResult
      };
    }
    exports.values = values;
    function doneResult() {
      return {
        value: undefined$1,
        done: true
      };
    }
    Context.prototype = {
      constructor: Context,
      reset: function (skipTempReset) {
        this.prev = 0;
        this.next = 0;
        // Resetting context._sent for legacy support of Babel's
        // function.sent implementation.
        this.sent = this._sent = undefined$1;
        this.done = false;
        this.delegate = null;
        this.method = "next";
        this.arg = undefined$1;
        this.tryEntries.forEach(resetTryEntry);
        if (!skipTempReset) {
          for (var name in this) {
            // Not sure about the optimal order of these conditions:
            if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
              this[name] = undefined$1;
            }
          }
        }
      },
      stop: function () {
        this.done = true;
        var rootEntry = this.tryEntries[0];
        var rootRecord = rootEntry.completion;
        if (rootRecord.type === "throw") {
          throw rootRecord.arg;
        }
        return this.rval;
      },
      dispatchException: function (exception) {
        if (this.done) {
          throw exception;
        }
        var context = this;
        function handle(loc, caught) {
          record.type = "throw";
          record.arg = exception;
          context.next = loc;
          if (caught) {
            // If the dispatched exception was caught by a catch block,
            // then let that catch block handle the exception normally.
            context.method = "next";
            context.arg = undefined$1;
          }
          return !!caught;
        }
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          var record = entry.completion;
          if (entry.tryLoc === "root") {
            // Exception thrown outside of any try block that could handle
            // it, so set the completion value of the entire function to
            // throw the exception.
            return handle("end");
          }
          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn.call(entry, "catchLoc");
            var hasFinally = hasOwn.call(entry, "finallyLoc");
            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              } else if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              }
            } else if (hasFinally) {
              if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else {
              throw new Error("try statement without catch or finally");
            }
          }
        }
      },
      abrupt: function (type, arg) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }
        if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
          // Ignore the finally entry if control is not jumping to a
          // location outside the try/catch block.
          finallyEntry = null;
        }
        var record = finallyEntry ? finallyEntry.completion : {};
        record.type = type;
        record.arg = arg;
        if (finallyEntry) {
          this.method = "next";
          this.next = finallyEntry.finallyLoc;
          return ContinueSentinel;
        }
        return this.complete(record);
      },
      complete: function (record, afterLoc) {
        if (record.type === "throw") {
          throw record.arg;
        }
        if (record.type === "break" || record.type === "continue") {
          this.next = record.arg;
        } else if (record.type === "return") {
          this.rval = this.arg = record.arg;
          this.method = "return";
          this.next = "end";
        } else if (record.type === "normal" && afterLoc) {
          this.next = afterLoc;
        }
        return ContinueSentinel;
      },
      finish: function (finallyLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.finallyLoc === finallyLoc) {
            this.complete(entry.completion, entry.afterLoc);
            resetTryEntry(entry);
            return ContinueSentinel;
          }
        }
      },
      "catch": function (tryLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;
            if (record.type === "throw") {
              var thrown = record.arg;
              resetTryEntry(entry);
            }
            return thrown;
          }
        }

        // The context.catch method must only be called with a location
        // argument that corresponds to a known catch block.
        throw new Error("illegal catch attempt");
      },
      delegateYield: function (iterable, resultName, nextLoc) {
        this.delegate = {
          iterator: values(iterable),
          resultName: resultName,
          nextLoc: nextLoc
        };
        if (this.method === "next") {
          // Deliberately forget the last sent value so that we don't
          // accidentally pass it on to the delegate.
          this.arg = undefined$1;
        }
        return ContinueSentinel;
      }
    };

    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
  }(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
  module.exports);
  try {
    regeneratorRuntime = runtime;
  } catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    Function("r", "regeneratorRuntime = r")(runtime);
  }
});
var BackdropContainerStyle = {
  position: "fixed",
  left: 0,
  top: 0,
  width: "100%",
  height: "100%",
  background: "rgba(0, 0, 0, 0.4)",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "flex-end",
  zIndex: 1400
};
var inEffect = ".web-share-fade{animation:simpleFade 0.5s;animation-fill-mode:both }@keyframes simpleFade{0%{opacity:0 }100%{opacity:1 }}.web-share-fade-in-up{animation:fadeInUp 0.5s;animation-fill-mode:both }@keyframes fadeInUp{0%{opacity:0;transform:translateY(20px) }100%{opacity:1;transform:translateY(0) }}";
function Backdrop(_ref) {
  var children = _ref.children,
    onClose = _ref.onClose;
  var handleOnClose = function handleOnClose(e) {
    if (e.target === e.currentTarget) {
      onClose(e);
    }
  };
  return /*#__PURE__*/React__default.createElement("div", {
    onClick: handleOnClose,
    className: "web-share-fade",
    style: BackdropContainerStyle
  }, /*#__PURE__*/React__default.createElement("style", {
    children: inEffect
  }), children);
}
var externalOpen = function externalOpen(URL) {
  return window.open(URL, "_blank", "noopener");
};
var iconList = {
  facebook: {
    path: /*#__PURE__*/React__default.createElement("path", {
      d: "M24 12a12 12 0 10-13.9 11.9v-8.4h-3V12h3V9.4c0-3 1.8-4.7 4.6-4.7l2.6.2v3h-1.5c-1.5 0-2 .9-2 1.8V12h3.4l-.5 3.5h-2.8v8.4A12 12 0 0024 12z"
    }),
    color: "#0076FB",
    e: function e(l) {
      return externalOpen("https://www.facebook.com/sharer/sharer.php?u=" + l);
    }
  },
  twitter: {
    path: /*#__PURE__*/React__default.createElement("path", {
      d: "M24 4.6a10 10 0 01-2.9.7 5 5 0 002.2-2.7c-1 .6-2 1-3.1 1.2a5 5 0 00-8.4 4.5A14 14 0 011.6 3.2 4.8 4.8 0 001 5.6a5 5 0 002.2 4.1 4.9 4.9 0 01-2.3-.6A5 5 0 005 14a5 5 0 01-2.2 0 5 5 0 004.6 3.5 9.9 9.9 0 01-6.1 2.1H0a14 14 0 007.6 2.2c9 0 14-7.5 14-14V7A10 10 0 0024 4.6z"
    }),
    color: "#1DA1F2",
    e: function e(l, t) {
      return externalOpen("https://twitter.com/intent/tweet?text=" + t + "&url=" + l);
    }
  },
  whatsapp: {
    path: /*#__PURE__*/React__default.createElement("path", {
      d: "M17.5 14.4l-2-1c-.3 0-.5-.1-.7.2l-1 1.1c-.1.2-.3.3-.6.1s-1.3-.5-2.4-1.5a9 9 0 01-1.7-2c-.1-.3 0-.5.2-.6l.4-.6c.2-.1.2-.3.3-.5v-.5L9 7c-.2-.6-.4-.5-.6-.5h-.6c-.2 0-.5 0-.8.4-.2.3-1 1-1 2.5s1 2.8 1.2 3c.2.2 2.1 3.2 5.1 4.5l1.7.6a4 4 0 001.9.2c.5-.1 1.7-.8 2-1.5.2-.6.2-1.2.1-1.4l-.5-.3M12 21.8a9.9 9.9 0 01-5-1.4l-.4-.2-3.7 1 1-3.7-.2-.3a9.9 9.9 0 01-1.5-5.3 9.9 9.9 0 0116.8-7 9.8 9.8 0 013 7 9.9 9.9 0 01-10 9.9m8.4-18.3A11.8 11.8 0 0012.1 0 12 12 0 001.8 17.8L0 24l6.4-1.6a11.9 11.9 0 005.6 1.4 12 12 0 0012-11.9 11.8 11.8 0 00-3.5-8.4z"
    }),
    color: "#25D366",
    e: function e(l, t) {
      return externalOpen("https://api.whatsapp.com/send?text=" + t + " " + l);
    }
  },
  reddit: {
    path: /*#__PURE__*/React__default.createElement("path", {
      d: "M12 0A12 12 0 000 12a12 12 0 0012 12 12 12 0 0012-12A12 12 0 0012 0zm5.01 4.74c.69 0 1.25.56 1.25 1.25a1.25 1.25 0 01-2.5.06l-2.6-.55-.8 3.75c1.83.07 3.48.63 4.68 1.49.3-.31.73-.5 1.2-.5.97 0 1.76.8 1.76 1.76 0 .72-.43 1.33-1.01 1.61a3.11 3.11 0 01.04.52c0 2.7-3.13 4.87-7 4.87-3.88 0-7-2.17-7-4.87 0-.18 0-.36.04-.53A1.75 1.75 0 014.03 12a1.75 1.75 0 012.96-1.26 8.52 8.52 0 014.74-1.5l.89-4.17a.34.34 0 01.14-.2.35.35 0 01.24-.04l2.9.62a1.21 1.21 0 011.11-.7zM9.25 12a1.25 1.25 0 101.25 1.25c0-.69-.56-1.25-1.25-1.25zm5.5 0a1.25 1.25 0 000 2.5 1.25 1.25 0 000-2.5zm-5.47 3.99a.33.33 0 00-.23.1.33.33 0 000 .46c.84.84 2.49.91 2.96.91.48 0 2.1-.06 2.96-.91a.36.36 0 00.03-.47.33.33 0 00-.46 0c-.55.54-1.68.73-2.51.73-.83 0-1.98-.2-2.51-.73a.33.33 0 00-.24-.1z"
    }),
    color: "#FF4500",
    e: function e(l, t) {
      return externalOpen("https://www.reddit.com/submit?url=" + l + "&title=" + t);
    }
  },
  telegram: {
    path: /*#__PURE__*/React__default.createElement("path", {
      d: "M23.91 3.79L20.3 20.84c-.25 1.21-.98 1.5-2 .94l-5.5-4.07-2.66 2.57c-.3.3-.55.56-1.1.56-.72 0-.6-.27-.84-.95L6.3 13.7.85 12c-1.18-.35-1.19-1.16.26-1.75l21.26-8.2c.97-.43 1.9.24 1.53 1.73z"
    }),
    color: "#0088CC",
    e: function e(l, t) {
      return externalOpen("https://telegram.me/share/msg?url=" + l + "&text=" + t);
    }
  },
  linkedin: {
    path: /*#__PURE__*/React__default.createElement("path", {
      d: "M6.5 21.5h-5v-13h5v13zM4 6.5C2.5 6.5 1.5 5.3 1.5 4s1-2.4 2.5-2.4c1.6 0 2.5 1 2.6 2.5 0 1.4-1 2.5-2.6 2.5zm11.5 6c-1 0-2 1-2 2v7h-5v-13h5V10s1.6-1.5 4-1.5c3 0 5 2.2 5 6.3v6.7h-5v-7c0-1-1-2-2-2z"
    }),
    color: "#0073b1",
    e: function e(l, t, ti) {
      return externalOpen("https://www.linkedin.com/shareArticle?mini=true&url=" + l + "&title=" + ti + "&summary=" + t);
    }
  },
  mail: {
    path: /*#__PURE__*/React__default.createElement("path", {
      d: "M20 4H4a2 2 0 00-2 2v12c0 1.1.9 2 2 2h16a2 2 0 002-2V6a2 2 0 00-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
    }),
    color: "#E53E3E",
    e: function e(l, t) {
      return externalOpen("mailto:?body=" + l + "&subject=" + t);
    }
  },
  copy: {
    path: /*#__PURE__*/React__default.createElement("path", {
      d: "M16 1H4a2 2 0 00-2 2v14h2V3h12V1zm3 4H8a2 2 0 00-2 2v14c0 1.1.9 2 2 2h11a2 2 0 002-2V7a2 2 0 00-2-2zm0 16H8V7h11v14z"
    }),
    color: "#718096",
    e: function e(l) {
      return navigator.clipboard.writeText(decodeURIComponent(l));
    }
  },
  vk: {
    path: /*#__PURE__*/React__default.createElement("path", {
      d: "M22.7 6.24c.16-.52 0-.9-.73-.9H19.5c-.62 0-.91.32-1.06.69 0 0-1.25 3.04-3.02 5.02-.57.57-.83.75-1.15.75-.15 0-.39-.18-.39-.7V6.24c0-.63-.17-.9-.69-.9H9.34c-.39 0-.62.29-.62.56 0 .59.88.72.97 2.4v3.6c0 .8-.14.95-.45.95-.84 0-2.86-3.06-4.06-6.56-.24-.68-.48-.96-1.1-.96H1.61c-.7 0-.85.33-.85.7 0 .65.84 3.88 3.88 8.14 2.03 2.92 4.9 4.5 7.5 4.5 1.55 0 1.75-.35 1.75-.96 0-2.78-.15-3.04.64-3.04.36 0 .99.18 2.44 1.58 1.67 1.67 1.95 2.42 2.88 2.42h2.45c.7 0 1.06-.35.85-1.05-.46-1.45-3.62-4.44-3.76-4.64-.36-.47-.26-.68 0-1.1 0 0 3-4.21 3.3-5.64Z"
    }),
    color: "#07f",
    e: function e(l, t, ti) {
      return externalOpen("http://vk.com/share.php?url=" + l + "&title=" + ti + "&comment=" + t);
    }
  },
  okru: {
    path: /*#__PURE__*/React__default.createElement("path", {
      d: "M13.6 16.4c1-.3 2-.7 2.8-1.2a1.5 1.5 0 0 0-1.5-2.5 6.3 6.3 0 0 1-6.7 0 1.5 1.5 0 1 0-1.5 2.5c.9.5 1.8 1 2.9 1.2L6.8 19a1.4 1.4 0 1 0 2 2l2.8-2.6 2.7 2.7a1.5 1.5 0 1 0 2-2l-2.7-2.8Zm-2-11.1a2 2 0 1 1 0 4.1 2 2 0 0 1 0-4.1Zm0 7a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z"
    }),
    color: "#e27e35",
    e: function e(l) {
      return externalOpen("https://connect.ok.ru/dk?st.cmd=WidgetSharePreview&st.shareUrl=" + l);
    }
  }
};
var PortalComponent = function PortalComponent(_ref) {
  var children = _ref.children;
  var el = document.createElement("div");
  React__default.useEffect(function () {
    document.body.appendChild(el);
    return function () {
      document.body.removeChild(el);
    };
  }, [el]);
  return /*#__PURE__*/createPortal(children, el);
};
var CloseStyle = {
  background: "#edf2f7",
  cursor: "pointer",
  padding: "0.75rem",
  display: "block",
  width: "100%",
  border: 0,
  fontSize: "1rem"
};
function CloseButton(_ref) {
  var onClose = _ref.onClose,
    closeText = _ref.closeText;
  return /*#__PURE__*/React__default.createElement("button", {
    style: CloseStyle,
    "aria-label": "Close",
    type: "button",
    onClick: onClose
  }, closeText || "Close");
}
var ShareHeader = {
  padding: "1rem 1.25rem",
  fontSize: "1.25rem",
  fontWeight: 600,
  paddingBottom: 0
};
function Header(_ref) {
  var title = _ref.title;
  return /*#__PURE__*/React__default.createElement("header", {
    style: ShareHeader
  }, title);
}
var SocialIconStyle = {
  width: "100%",
  height: "auto",
  cursor: "pointer",
  border: 0,
  background: "#1A78F6",
  padding: "0.75rem",
  borderRadius: "0.5rem",
  fontSize: 0
};
function Icon(_ref) {
  var name = _ref.name,
    data = _ref.data,
    onClose = _ref.onClose,
    onClick = _ref.onClick;
  var _iconList$name = iconList[name],
    path = _iconList$name.path,
    _iconList$name$viewBo = _iconList$name.viewBox,
    viewBox = _iconList$name$viewBo === void 0 ? "0 0 24 24" : _iconList$name$viewBo,
    color = _iconList$name.color,
    e = _iconList$name.e;
  var handleOnButtonClicked = function handleOnButtonClicked() {
    onClick && onClick(); // callback

    e(encodeURIComponent(data.url), data.text, data.title);
    onClose();
  };
  return /*#__PURE__*/React__default.createElement("button", {
    onClick: handleOnButtonClicked,
    "aria-label": name,
    style: _extends$1({}, SocialIconStyle, {
      background: color
    })
  }, /*#__PURE__*/React__default.createElement("svg", {
    fill: "white",
    viewBox: viewBox
  }, path));
}
var IconsContainer = {
  maxWidth: "24rem",
  width: "90%",
  backgroundColor: "white",
  borderRadius: "0.5rem",
  borderBottomLeftRadius: 0,
  borderBottomRightRadius: 0
};
var IconsLisStyle = {
  padding: "1.25rem",
  display: "grid",
  gridTemplateColumns: "repeat(4, 1fr)",
  gridGap: "1.25rem"
};
function SocialIcons(_ref) {
  var onClose = _ref.onClose,
    sites = _ref.sites,
    data = _ref.data,
    closeText = _ref.closeText,
    onClick = _ref.onClick;
  return /*#__PURE__*/React__default.createElement("section", {
    role: "dialog",
    "aria-modal": "true",
    className: "web-share-fade-in-up",
    style: IconsContainer
  }, /*#__PURE__*/React__default.createElement(Header, {
    title: data.title
  }), /*#__PURE__*/React__default.createElement("div", {
    style: IconsLisStyle
  }, sites.map(function (name) {
    return /*#__PURE__*/React__default.createElement(Icon, {
      name: name,
      key: name,
      data: data,
      onClose: onClose,
      onClick: onClick
    });
  })), /*#__PURE__*/React__default.createElement(CloseButton, {
    onClose: onClose,
    closeText: closeText
  }));
}
function useDisclosure(isOpenDefault) {
  if (isOpenDefault === void 0) {
    isOpenDefault = false;
  }
  var _useState = useState(isOpenDefault),
    isOpen = _useState[0],
    setIsOpen = _useState[1];
  var onOpen = useCallback(function () {
    return setIsOpen(true);
  }, []);
  var onClose = useCallback(function () {
    return setIsOpen(false);
  }, []);
  var onToggle = useCallback(function () {
    return setIsOpen(function (state) {
      return !state;
    });
  }, []);
  return {
    isOpen: isOpen,
    onOpen: onOpen,
    onClose: onClose,
    onToggle: onToggle
  };
}
var defaultSites = /*#__PURE__*/Object.keys(iconList).slice(0, 8);
var RWebShare = function RWebShare(_ref) {
  var children = _ref.children,
    closeText = _ref.closeText,
    data = _ref.data,
    onClick = _ref.onClick,
    _ref$sites = _ref.sites,
    sites = _ref$sites === void 0 ? defaultSites : _ref$sites;
  var _useDisclosure = useDisclosure(),
    onOpen = _useDisclosure.onOpen,
    onClose = _useDisclosure.onClose,
    isOpen = _useDisclosure.isOpen;
  var shareData = useMemo(function () {
    return _extends$1({}, data, {
      title: data.title || "share",
      text: data.text || "",
      url: data.url || typeof window !== "undefined" && window.location.href || ""
    });
  }, [data]);
  var handleOnClick = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee() {
      return runtime_1.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!window.navigator.share) {
                _context.next = 12;
                break;
              }
              _context.prev = 1;
              _context.next = 4;
              return window.navigator.share(shareData);
            case 4:
              onClick();
              _context.next = 10;
              break;
            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](1);
              console.warn(_context.t0);
            case 10:
              _context.next = 13;
              break;
            case 12:
              onOpen();
            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 7]]);
    }));
    return function handleOnClick() {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/cloneElement(children, _extends$1({}, children == null ? void 0 : children.props, {
    onClick: handleOnClick
  })), isOpen && /*#__PURE__*/React__default.createElement(PortalComponent, null, /*#__PURE__*/React__default.createElement(Backdrop, {
    onClose: onClose
  }, /*#__PURE__*/React__default.createElement(SocialIcons, {
    onClose: onClose,
    sites: sites,
    data: shareData,
    closeText: closeText,
    onClick: onClick
  }))));
};

const ShareSetlistModal = ({
  setlist,
  isOpen,
  onClose
}) => {
  const formUrlFromSetlist = setlist => {
    return `${process.env.PUBLIC_URL}/setlist?setlistId=${setlist.id}&title=${setlist.title}&subtitle=${setlist.subTitle}&imageUrl=${btoa(setlist.imageUrl)}&items=${setlist.items.map(s => s.songId)}`;
  };
  const renderCannotShare = () => {
    return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
      className: "text-primary flex text-center justify-center mb-4 mt-4"
    }, /*#__PURE__*/React__default.createElement(ForwardRef$9, {
      className: "h-20 w-20"
    })), /*#__PURE__*/React__default.createElement("p", {
      className: "text-center"
    }, "You cannot share this setlist yet as it has no songs in it."));
  };
  return /*#__PURE__*/React__default.createElement(Modal, {
    isOpen: isOpen,
    content: /*#__PURE__*/React__default.createElement("div", null, setlist && setlist.items.length ? /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("code", {
      style: {
        wordBreak: 'break-all'
      }
    }, formUrlFromSetlist(setlist)), /*#__PURE__*/React__default.createElement(RWebShare, {
      data: {
        text: `Listen to my ChoirPlayer ${setlist.title} setlist`,
        url: `${process.env.PUBLIC_URL}${formUrlFromSetlist(setlist)}`,
        title: `${setlist.title} setlist`
      },
      onClick: () => console.log("shared successfully!")
    }, /*#__PURE__*/React__default.createElement(Button, null, "Share  "))) : renderCannotShare()),
    closeLabel: 'Close',
    onClose: onClose,
    title: "Share setlist"
  });
};

const NotFound$1 = () => {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "flex flex-1 flex-col space-y-3 justify-start px-6 py-5 items-center text-center mt-8 dark:text-secondary-300"
  }, /*#__PURE__*/React__default.createElement(ForwardRef$7, {
    className: "w-20 h-20 "
  }), /*#__PURE__*/React__default.createElement("h2", {
    className: "mt-2 text-sm font-medium"
  }, "Oops, page not found!"), /*#__PURE__*/React__default.createElement(Link, {
    to: "/library"
  }, /*#__PURE__*/React__default.createElement(Button, null, /*#__PURE__*/React__default.createElement(ForwardRef$6, {
    className: "-ml-1 mr-2 h-5 w-5",
    "aria-hidden": "true"
  }), "Go to song library")));
};

const SetListContainer = () => {
  const setlists = useSelector(selectSetlistsSetlists);
  const setlistSessions = useSelector(selectSetlistSessions);
  const librarySongs = useSelector(selectLibrarySongs);
  const currentUser = useSelector(selectUser);
  const setlistsCachingProgress = useSelector(selectSetlistsCachingProgress);
  const libraryStatus = useSelector(selectLibraryStatus);
  const [setlistSongs, setSetlistSongs] = useState([]);
  const [currentSetlist, setCurrentSetlist] = useState(null);
  const clientConfiguration = useSelector(selectClientConfig);
  const user = useSelector(selectUser);
  const {
    id
  } = useParams();
  const [showCacheSetlistModal, setShowCacheSetlistModal] = useState(false);
  const [showUncacheSetlistModal, setShowUncacheSetlistModal] = useState(false);
  const [showConfirmRemoveSetlistModal, setShowConfirmRemoveSetlistModal] = useState(false);
  const [showShareSetlistModal, setShowShareSetlistModal] = useState(false);
  const [showConfirmRemoveSongModal, setShowConfirmRemoveSongModal] = useState(null);
  const [generatingShareLink, setGeneratingShareLink] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const locationHook = useLocation();
  const [showSubscribeModal, setShowSubscribeModal] = useState(false);
  useEffect(() => {
    const foundSetlist = setlists.find(s => s.id === id);
    if (foundSetlist) {
      setCurrentSetlist(foundSetlist);
    }
  }, [setlists]);
  useEffect(() => {
    setSetlistSongs(librarySongs);
  }, [librarySongs, locationHook]);
  const handleOpenSong = async songId => {
    // // pgw 30-may-2024 testing
    console.log('handleOpenSong, currentSetlist.readOnly = ', currentSetlist.readOnly);
    console.log('handleOpenSong, currentSetlist.cached = ', currentSetlist.cached);
    console.log('handleOpenSong, currentUser.subscribed = ', currentUser.subscribed);
    console.log('handleOpenSong, songId = ', songId);
    console.log('handleOpenSong, currentSetlist.items = ', currentSetlist.items);
    console.log('handleOpenSong, currentSetlist = ', currentSetlist);
    if (!currentUser.subscribed && !clientConfiguration.features.library.limitedLibrary.includes(songId)) {
      setShowSubscribeModal(true);
    } else {
      const song = librarySongs.find(s => s.songId === songId);
      // check if song already exists in the users setlist
      const existingSongSession = setlistSessions.find(session => session.song.songId === songId);
      if (existingSongSession) {
        await dispatch(openSession(existingSongSession));
        navigate(`/session`);
      } else {
        await dispatch(createSessionFromSong({
          song: song,
          title: song.mix
        }));
      }
    }
  };
  const deleteSong = async songId => {
    const selectedSong = setlistSongs.find(song => song.songId === showConfirmRemoveSongModal);
    dispatch(removeSongFromSetlist({
      setlistId: id,
      song: selectedSong
    }));
    dispatch(addNotificationAsync({
      title: 'Removed',
      text: `${selectedSong.mix} removed from setlist`,
      type: 'negative'
    }));
    setShowConfirmRemoveSongModal(false);
  };
  const handleUploadSession = async file => {
    const sessionZipArrayBuffer = await file.arrayBuffer();
    if (file.name.includes('.setlist')) {
      await dispatch(unpackSetlistAsync$1(sessionZipArrayBuffer));
      await dispatch(addNotificationAsync({
        type: 'positive',
        title: 'Complete',
        text: 'Songs were added to your setlist'
      }));
    }
    if (file.name.includes('.session')) {
      await dispatch(unpackSessionAsync$1(sessionZipArrayBuffer));
      await dispatch(addNotificationAsync({
        type: 'positive',
        title: 'Complete',
        text: 'Session added to your setlist'
      }));
    }
  };
  const handleCacheSetlist = () => {
    if (currentSetlist.cached) {
      setShowUncacheSetlistModal(true);
    } else {
      setShowCacheSetlistModal(true);
    }
  };
  const handleRemoveSetlist = async () => {
    await dispatch(uncacheSetlistAssetsAsync(currentSetlist));
    dispatch(removeSetListFromSetlists(id));
    navigate('/setlists');
  };
  const startSetlistCache = () => {
    setShowCacheSetlistModal(false);
    dispatch(cacheSetlistAssetsAsync(currentSetlist));
  };
  const startSetlistUncache = () => {
    setShowUncacheSetlistModal(false);
    dispatch(uncacheSetlistAssetsAsync(currentSetlist));
  };
  const handleNewSession = sessionName => {
    // dispatch(createEmptySession({
    //     title:sessionName
    // }));
  };
  const handleShareSetlist = () => {
    // setShowShareSetlistModal(true);
    ReactGA.event('share_setlist', currentSetlist);
  };
  const handleGoToLibrary = () => {
    // // pgw 30-may-2024 testing
    console.log('handleGoToLibrary, currentSetlist.readOnly = ', currentSetlist.readOnly);
    console.log('handleGoToLibrary, currentSetlist = ', currentSetlist);
    navigate(`/library`);
  };
  const isSongSupported = songId => {
    // pgw 24-mar-2024
    // For choirplayer, do not show "Not supported on this device", because all songs should work.
    return true;
  };
  const renderNotSupported = () => {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "flex items-center"
    }, /*#__PURE__*/React__default.createElement(ForwardRef$8, {
      className: "h-4 w-4 mr-2 text-primary"
    }), /*#__PURE__*/React__default.createElement("span", {
      className: "text-sm"
    }, "Not supported on this device"));
  };
  const formUrlFromSetlist = setlist => {
    return `${window.location.origin}${process.env.PUBLIC_URL}/#/setlist/create?setlistId=${setlist.id}&title=${setlist.title}&subtitle=${setlist.subTitle}&imageUrl=${btoa(setlist.imageUrl)}&items=${setlist.items.map(s => s.songId)}`;
  };
  const generateShareUrlCallback = async () => {
    const longUrl = formUrlFromSetlist(currentSetlist);
    if (clientConfiguration.features.setlist.urlShortenerUrl) {
      try {
        setGeneratingShareLink(true);
        const shortUrl = await generateShortLink(clientConfiguration.features.setlist.urlShortenerUrl, longUrl);
        setGeneratingShareLink(false);
        return shortUrl;
      } catch (e) {
        dispatch(setError({
          title: 'Could not share',
          text: 'There was an error creating the setlist share link.'
        }));
      }
    } else {
      return longUrl;
    }
  };

  // pgw 30-may-2024 testing: set showActionButton and showRemoveActionButton to true
  // They were both set to !currentSetlist.readOnly which may account for button only appearing in Chrome...

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, currentSetlist && libraryStatus == 'idle' && /*#__PURE__*/React__default.createElement(Setlist, {
    items: currentSetlist.items.map((song, idx) => {
      return {
        id: song.songId,
        title: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", null, song.mix), " ", !isSongSupported(song.songId) ? renderNotSupported() : null),
        artist: song.artist,
        genre: song.genre,
        decade: song.decade,
        key: song.key,
        time: song.len,
        state: "IN_SETLIST",
        // trackCount: stems.concat(userStems).length,
        lastSavedAt: formatDistance(new Date(), new Date(), {
          addSuffix: true
        }),
        trackIndex: idx + 1,
        showActionButton: true,
        showRemoveActionButton: true,
        removeLabel: "Remove",
        createdBy: Date.now(),
        onSelected: () => handleOpenSong(song.songId),
        onRemoveAction: () => setShowConfirmRemoveSongModal(song.songId)
      };
    }),
    sortedBy: {
      "label": "Title",
      "dir": "desc"
    },
    showDownloadButton: setlistSongs?.length > 0 && clientConfiguration.features.setlist.downloadSetlist,
    showRenameSession: clientConfiguration.features.setlist.renameSession,
    onDownloadSetlist: handleCacheSetlist,
    onShareSetlist: handleShareSetlist,
    showShare: user?.subscribed && setlistSongs?.length > 0,
    generateShareUrlCallback: currentSetlist ? async () => await generateShareUrlCallback() : null,
    onDeleteSetlist: () => setShowConfirmRemoveSetlistModal(true),
    showHeader: clientConfiguration.features.setlist.showHeader,
    cached: currentSetlist.cached,
    cacheProgress: setlistsCachingProgress,
    title: currentSetlist.title,
    subTitle: currentSetlist.subTitle,
    imageUrl: currentSetlist.imageUrl,
    onUpload: handleUploadSession,
    onNewSession: handleNewSession,
    onGoToLibrary: handleGoToLibrary,
    emptyLinkComponent: /*#__PURE__*/React__default.createElement(Link, {
      to: '/library'
    }, /*#__PURE__*/React__default.createElement(Button, null, "Go to Song library"))
  }), !currentSetlist && /*#__PURE__*/React__default.createElement("div", {
    className: "flex justify-center mt-4 mb-4"
  }, /*#__PURE__*/React__default.createElement(NotFound$1, null), " "), /*#__PURE__*/React__default.createElement(ShareSetlistModal, {
    setlist: currentSetlist,
    isOpen: showShareSetlistModal,
    onClose: () => setShowShareSetlistModal(false)
  }), /*#__PURE__*/React__default.createElement(Modal, {
    isOpen: showCacheSetlistModal ? true : false,
    title: "Download your setlist",
    text: /*#__PURE__*/React__default.createElement("p", null, "Downloading your setlist allows you to play the songs offline."),
    confirmLabel: "Download",
    onConfirm: startSetlistCache,
    onClose: () => setShowCacheSetlistModal(false),
    closeLabel: "Close"
  }), /*#__PURE__*/React__default.createElement(Modal, {
    isOpen: showUncacheSetlistModal ? true : false,
    title: "Remove setlist download",
    text: /*#__PURE__*/React__default.createElement("p", null, "Uncaching your setlist will mean you are unable to play the songs offline."),
    confirmLabel: "Delete download",
    onConfirm: startSetlistUncache,
    onClose: () => setShowUncacheSetlistModal(false),
    closeLabel: "Close"
  }), /*#__PURE__*/React__default.createElement(Modal, {
    isOpen: showConfirmRemoveSetlistModal ? true : false,
    title: "Delete setlist",
    text: /*#__PURE__*/React__default.createElement("p", null, "Are you sure you'd like to delete this setlist?"),
    confirmLabel: "Delete"
    // icon={<ExclamationIcon className="h-20 w-20 text-primary" aria-hidden="true" />}
    ,
    onConfirm: handleRemoveSetlist,
    onClose: () => setShowConfirmRemoveSetlistModal(false),
    closeLabel: "Close"
  }), /*#__PURE__*/React__default.createElement(Modal, {
    isOpen: showConfirmRemoveSongModal ? true : false,
    title: "Remove song",
    text: /*#__PURE__*/React__default.createElement("p", null, "Are you sure you'd like to remove this song from this setlist?"),
    confirmLabel: "Remove",
    icon: /*#__PURE__*/React__default.createElement(ForwardRef$8, {
      className: "h-20 w-20 text-primary",
      "aria-hidden": "true"
    }),
    onConfirm: deleteSong,
    onClose: () => setShowConfirmRemoveSongModal(null),
    closeLabel: "Close"
  }), /*#__PURE__*/React__default.createElement(Modal, {
    isOpen: generatingShareLink,
    content: /*#__PURE__*/React__default.createElement("div", {
      className: "flex flex-col justify-center text-center"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "flex justify-center mb-4"
    }, /*#__PURE__*/React__default.createElement(Spinner, null)), /*#__PURE__*/React__default.createElement("h1", {
      className: "text-lg"
    }, "Generating share link")),
    onClose: () => {}
  }), !currentUser?.subscribed && /*#__PURE__*/React__default.createElement(Modal, {
    isOpen: showSubscribeModal,
    title: clientConfiguration.features.library.subscribeConfig.libraryPromoText,
    content: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("p", null, clientConfiguration.features.library.subscribeConfig.text)),
    closeLabel: "Close",
    onConfirm: () => window.location.href = clientConfiguration.features.library.subscribeConfig.url,
    confirmLabel: "Subscribe now",
    onClose: () => {
      setShowSubscribeModal(false);
    }
  }));
};

function useQuery$1() {
  const {
    search
  } = useLocation();
  return React__default.useMemo(() => new URLSearchParams(search), [search]);
}
const CreateSetlistContainer = () => {
  const setlists = useSelector(selectSetlistsSetlists);
  useSelector(selectLibrarySongs);
  const query = useQuery$1();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentUser = useSelector(selectUser);
  useEffect(async () => {
    console.log('mounted');
    const fetchedLibrarySongsRequest = await dispatch(fetchLibrarySongsAsync({
      startIndex: 0,
      limit: 600
    }));
    if (currentUser) {
      if (!setlists.find(setlist => setlist.id === query.get('setlistId'))) {
        const itemsArray = query.get('items').split(',');
        console.log(itemsArray);
        console.log(fetchedLibrarySongsRequest.payload);
        await dispatch(createSetlistFromData({
          setlistId: query.get('setlistId'),
          title: query.get('title'),
          subtitle: query.get('subtitle'),
          imageUrl: atob(query.get('imageUrl')),
          items: fetchedLibrarySongsRequest.payload.filter(song => itemsArray.includes(song.songId)),
          readOnly: true
        }));
      }
      navigate(`/setlist/${query.get('setlistId')}`, {
        replace: true
      });
    }
  }, []);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "flex justify-center mt-4 mb-4"
  }, /*#__PURE__*/React__default.createElement(Spinner, null));
};

function useQuery() {
  const {
    search
  } = useLocation();
  return React__default.useMemo(() => new URLSearchParams(search), [search]);
}
const MySetListContainer = () => {
  const sessions = useSelector(selectSetlistSessions);
  const clientConfiguration = useSelector(selectClientConfig);
  useParams();
  const query = useQuery();
  const [sortedSessions, setSortedSessions] = useState([]);
  const [showDownloadSetlistModal, setShowDownloadSetlistModal] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    // console.log(sessions);
    const copiedSessions = [...sessions];
    setSortedSessions(copiedSessions.sort(sortSessions));
  }, [sessions]);
  const selectSession = async sessionId => {
    const selectedSession = sessions.find(session => session.id === sessionId);
    const selectedSessionSongId = selectedSession.song.songId;
    if (clientConfiguration.logic.restrictedDevices.includes(platform.product) || platform.os?.family === 'OS X' && navigator.maxTouchPoints) {
      if (!clientConfiguration.features.library.songsWorkingOnIos.includes(selectedSessionSongId)) {
        dispatch(setIOSModalVisible(true));
      } else {
        await dispatch(openSession(selectedSession));
        navigate(`/session`);
      }
    } else {
      await dispatch(openSession(selectedSession));
      navigate(`/session`);
    }
  };
  const deleteSong = async sessionId => {
    await dispatch(unmountSessionAsync());
    await dispatch(removeSessionFromSetlistAsync$1(sessionId));
    dispatch(addNotificationAsync({
      title: 'Session deleted',
      text: `Session deleted from your setlist`,
      type: 'positive'
    }));
  };
  const handleUploadSession = async file => {
    const sessionZipArrayBuffer = await file.arrayBuffer();
    if (file.name.includes('.setlist')) {
      await dispatch(unpackSetlistAsync$1(sessionZipArrayBuffer));
      await dispatch(addNotificationAsync({
        type: 'positive',
        title: 'Complete',
        text: 'Songs were added to your setlist'
      }));
    }
    if (file.name.includes('.session')) {
      await dispatch(unpackSessionAsync$1(sessionZipArrayBuffer));
      await dispatch(addNotificationAsync({
        type: 'positive',
        title: 'Complete',
        text: 'Session added to your setlist'
      }));
    }
  };
  const handleDownloadSetlist = () => {
    setShowDownloadSetlistModal(true);
  };
  const startSetlistDownload = () => {
    setShowDownloadSetlistModal(false);
    dispatch(packSetlistAsync$1());
  };
  const handleNewSession = sessionName => {
    // dispatch(createEmptySession({
    //     title:sessionName
    // }));
  };
  const handleGoToLibrary = () => {
    navigate(`/library`);
  };
  const sortSessions = (a, b) => {
    const aDate = new Date(a.createdAt);
    const bDate = new Date(b.createdAt);
    // console.log(aDate, bDate);
    return aDate < bDate ? 1 : -1;
  };
  const isSongSupported = songId => {
    if (clientConfiguration.logic.restrictedDevices.includes(platform.product) && !clientConfiguration.features.library.songsWorkingOnIos.includes(songId)) {
      return false;
    } else if (platform.os?.family === 'OS X' && navigator.maxTouchPoints) {
      // is iPad
      if (!clientConfiguration.features.library.songsWorkingOnIos.includes(songId)) {
        return false;
      }
    }
    return true;
  };
  const renderNotSupported = () => {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "flex items-center"
    }, /*#__PURE__*/React__default.createElement(ForwardRef$8, {
      className: "h-4 w-4 mr-2 text-primary"
    }), /*#__PURE__*/React__default.createElement("span", {
      className: "text-sm"
    }, "Not supported on this device"));
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Setlist, {
    items: sortedSessions.map(session => {
      return {
        id: session.id,
        title: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", null, session.song.mix), " ", !isSongSupported(session.song.songId) ? renderNotSupported() : null),
        artist: session.song.artist,
        genre: session.song.genre,
        decade: session.song.decade,
        key: session.song.key,
        time: session.song.len,
        state: "IN_SETLIST",
        trackCount: session.stems.concat(session.userStems).length,
        lastSavedAt: formatDistance(new Date(session.lastUpdatedAt), new Date(), {
          addSuffix: true
        }),
        createdBy: session.createdBy,
        onSelected: () => selectSession(session.id),
        onRemoveAction: deleteSong,
        showRemoveActionButton: true,
        removeLabel: 'Remove from setlist'
      };
    }),
    sortedBy: {
      "label": "Title",
      "dir": "desc"
    },
    showDownloadButton: sortedSessions?.length > 0 && clientConfiguration.features.setlist.downloadSetlist,
    showRenameSession: clientConfiguration.features.setlist.renameSession,
    onDownloadSetlist: handleDownloadSetlist,
    showHeader: false,
    title: query.get('title'),
    subTitle: query.get('subtitle'),
    imageUrl: atob(query.get('imageUrl'))
    // http://localhost:3000/player-application#/setlist?title=dsdfsdf&subtitle=dsfuhdsifsd&imageUrl=aHR0cHM6Ly9pbWFnZXMudW5zcGxhc2guY29tL3Bob3RvLTE1NDcwMzY5NjctMjNkMTFhYWNhZWUwP2l4aWQ9TVh3eE1qQTNmREI4TUh4d2FHOTBieTF3WVdkbGZIeDhmR1Z1ZkRCOGZIdyUzRCZpeGxpYj1yYi0xLjIuMSZhdXRvPWZvcm1hdCZmaXQ9Y3JvcCZ3PTUxMiZxPTgw
    ,
    onUpload: handleUploadSession,
    onNewSession: handleNewSession,
    onGoToLibrary: handleGoToLibrary,
    emptyLinkComponent: /*#__PURE__*/React__default.createElement(Link, {
      to: '/library'
    }, /*#__PURE__*/React__default.createElement(Button, null, "Go to Song library"))
  }), /*#__PURE__*/React__default.createElement(Modal, {
    isOpen: showDownloadSetlistModal ? true : false,
    title: "Download your setlist",
    text: /*#__PURE__*/React__default.createElement("p", null, "Downloading your setlist will create a ", /*#__PURE__*/React__default.createElement("b", null, ".setlist"), " file which you can share with other users. ", /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("br", null), "Any sessions with your own recorded audio will not be included in your download."),
    confirmLabel: "Download",
    icon: /*#__PURE__*/React__default.createElement(ForwardRef$a, {
      className: "h-6 w-6 text-primary",
      "aria-hidden": "true"
    }),
    onConfirm: startSetlistDownload,
    onClose: () => setShowDownloadSetlistModal(false),
    closeLabel: "Close"
  }));
};

const NewSetlistModal = ({
  isOpen,
  clientConfiguration,
  title,
  setTitle,
  subtitle,
  setSubtitle,
  imageUrl,
  setImageUrl,
  firstSetlist,
  setUserInputtingText
}) => {
  const [progress, setProgress] = useState(0);
  const [selectedFile, setSelectedFile] = useState(null);
  const uploadInput = useRef(null);
  useEffect(() => {
    if (!isOpen) {
      setUserInputtingText(false);
      setProgress(0);
      setSelectedFile(null);
      setImageUrl(clientConfiguration.features.setlist.defaultSetlistImageUrl);
    } else {
      setUserInputtingText(true);
    }
  }, [isOpen]);
  const handleFileInput = e => {
    setSelectedFile(e.target.files[0]);
    handleUpload(e.target.files[0]);
  };
  const handleUpload = async file => {
    const response = await fetch("https://c5lkyhqqql.execute-api.eu-west-1.amazonaws.com/default/uploadChoirPlayerImages");
    const responseParsed = await response.json();
    await fetch(responseParsed.uploadURL, {
      method: "PUT",
      body: file
    });
    setImageUrl(`https://s3.eu-west-1.amazonaws.com/uploads.choirplayer.com/${responseParsed.filename}`);
    setSelectedFile(null);
    return `https://s3.eu-west-1.amazonaws.com/uploads.choirplayer.com/${responseParsed.filename}`;
  };
  return /*#__PURE__*/React__default.createElement("form", {
    className: "space-y-8 divide-y divide-gray-200 w-full grow"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "space-y-8 divide-y divide-gray-200 sm:space-y-5"
  }, /*#__PURE__*/React__default.createElement("div", null, firstSetlist && /*#__PURE__*/React__default.createElement("p", {
    className: "mt-1 max-w-2xl text-sm text-gray-500"
  }, "You currently have no setlists, please create one below."), /*#__PURE__*/React__default.createElement("div", {
    className: "mt-6 sm:mt-5 space-y-6 sm:space-y-5"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5"
  }, /*#__PURE__*/React__default.createElement("label", {
    htmlFor: "username",
    className: "block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
  }, "Title"), /*#__PURE__*/React__default.createElement("div", {
    className: "mt-1 sm:mt-0 sm:col-span-2"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "max-w-lg flex rounded-md shadow-sm"
  }, /*#__PURE__*/React__default.createElement("input", {
    value: title,
    onChange: e => setTitle(e.target.value),
    type: "text",
    name: "title",
    id: "title",
    autoComplete: "off",
    className: "flex-1 block w-full focus:ring-indigo-500 focus:border-indigo-500 min-w-0 rounded-none rounded-md sm:text-sm border-gray-300"
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "mt-6 sm:mt-5 space-y-6 sm:space-y-5"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5"
  }, /*#__PURE__*/React__default.createElement("label", {
    htmlFor: "username",
    className: "block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
  }, "Subtitle"), /*#__PURE__*/React__default.createElement("div", {
    className: "mt-1 sm:mt-0 sm:col-span-2"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "max-w-lg flex rounded-md shadow-sm"
  }, /*#__PURE__*/React__default.createElement("input", {
    value: subtitle,
    onChange: e => setSubtitle(e.target.value),
    type: "text",
    name: "subtitle",
    id: "subtitle",
    autoComplete: "off",
    className: "flex-1 block w-full focus:ring-indigo-500 focus:border-indigo-500 min-w-0 rounded-none rounded-md sm:text-sm border-gray-300"
  }))))), /*#__PURE__*/React__default.createElement("div", {
    className: "sm:grid sm:grid-cols-3 sm:gap-4 sm:items-center sm:border-t sm:border-gray-200 sm:pt-5"
  }, /*#__PURE__*/React__default.createElement("label", {
    htmlFor: "photo",
    className: "block text-sm font-medium text-gray-700"
  }, "Thumbnail"), /*#__PURE__*/React__default.createElement("div", {
    className: "mt-1 sm:mt-0 sm:col-span-2"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "h-40 w-40 rounded-md overflow-hidden bg-gray-100"
  }, /*#__PURE__*/React__default.createElement("img", {
    alt: "Setlist thumbnail",
    className: "object-cover h-full w-full text-gray-300",
    src: imageUrl
  })), /*#__PURE__*/React__default.createElement("input", {
    type: "file",
    ref: uploadInput,
    accept: "image/png, image/gif, image/jpeg",
    onChange: handleFileInput,
    className: "hidden ml-4 bg-white py-2 px-3 border border-gray-300 rounded-md shadow-sm text-sm leading-4 font-medium text-gray-700 hover:bg-gray-50"
  }), /*#__PURE__*/React__default.createElement("button", {
    onClick: e => {
      if (!selectedFile) {
        e.preventDefault();
        uploadInput.current.click();
      }
    },
    type: "button",
    className: "ml-4 bg-white py-2 px-3 border border-gray-300 rounded-md shadow-sm text-sm leading-4 font-medium text-gray-700 hover:bg-gray-50"
  }, selectedFile ? `Uploading...` : 'Upload thumbnail'))))))));
};

const SetListsContainer = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const clientConfiguration = useSelector(selectClientConfig);
  const setlists = useSelector(selectSetlistsSetlists);
  const currentUser = useSelector(selectUser);
  const [title, setTitle] = useState("");
  const [subtitle, setSubtitle] = useState("");
  const [imageUrl, setImageUrl] = useState(clientConfiguration.features.setlist.defaultSetlistImageUrl);
  const [showCreateSetlistModal, setShowCreateSetlistModal] = useState(false);
  const handleCreateNewSetlist = () => {
    dispatch(createNewEmptySetlist({
      title,
      subtitle,
      imageUrl
    }));
    setShowCreateSetlistModal(false);
  };
  const handleOpenNewSetlistModal = () => {
    if (currentUser?.subscribed) {
      setShowCreateSetlistModal(true);
      setTitle("");
      setSubtitle("");
    } else {
      dispatch(setError({
        title: "Not subscribed",
        text: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("p", null, clientConfiguration.features.library.subscribeConfig.playlistCreationDeniedText), /*#__PURE__*/React__default.createElement("div", {
          className: "mt-4 flex justify-center"
        }, /*#__PURE__*/React__default.createElement("a", {
          target: "_blank",
          rel: "noreferrer",
          href: clientConfiguration.features.library.subscribeConfig.url
        }, /*#__PURE__*/React__default.createElement(Button, null, clientConfiguration.features.library.subscribeConfig.buttonLabel))))
      }));
    }
  };
  const handleSelectPlaylist = setlistId => {
    const selectedSetlist = setlists.find(s => s.id === setlistId);
    navigate(`/setlist/${selectedSetlist.id}`);
  };
  const handleUserInputingText = bool => {
    dispatch(setUserInputtingText(bool));
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: "p-4 pt-2"
  }, /*#__PURE__*/React__default.createElement(Setlists, {
    items: setlists,
    onCreateNewSetlist: handleOpenNewSetlistModal,
    onSelectSetlist: handleSelectPlaylist
  }), /*#__PURE__*/React__default.createElement(Modal, {
    isOpen: showCreateSetlistModal ? true : false,
    title: "New Setlist",
    content: /*#__PURE__*/React__default.createElement(NewSetlistModal, {
      isOpen: showCreateSetlistModal ? true : false,
      clientConfiguration: clientConfiguration,
      firstSetlist: false,
      title: title,
      setTitle: setTitle,
      subtitle: subtitle,
      setSubtitle: setSubtitle,
      imageUrl: imageUrl,
      setImageUrl: setImageUrl,
      setUserInputtingText: handleUserInputingText
    }),
    confirmLabel: "Create",
    onConfirm: handleCreateNewSetlist,
    onClose: () => setShowCreateSetlistModal(false),
    closeLabel: "Close",
    confirmable: title && subtitle && imageUrl
  }));
};

var config = {
  attributes: true,
  characterData: true,
  subtree: true,
  childList: true
};
/**
 *
 * useMutationObserver hook
 *
 * Returns a mutation observer for a React Ref and fires a callback
 *
 * @param {MutableRefObject<HTMLElement | null>} ref React ref on which mutations are to be observed
 * @param {MutationCallback} callback Function that needs to be fired on mutation
 * @param {MutationObserverInit} options
 */
function useMutationObserver(ref, callback, options = config) {
  useEffect(() => {
    // Create an observer instance linked to the callback function
    if (ref.current) {
      const observer = new MutationObserver(callback);
      // Start observing the target node for configured mutations
      observer.observe(ref.current, options);
      return () => {
        observer.disconnect();
      };
    }
  }, [callback, options]);
}

/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = function () {
  if (typeof Map !== 'undefined') {
    return Map;
  }
  /**
   * Returns index in provided array that matches the specified key.
   *
   * @param {Array<Array>} arr
   * @param {*} key
   * @returns {number}
   */
  function getIndex(arr, key) {
    var result = -1;
    arr.some(function (entry, index) {
      if (entry[0] === key) {
        result = index;
        return true;
      }
      return false;
    });
    return result;
  }
  return /** @class */function () {
    function class_1() {
      this.__entries__ = [];
    }
    Object.defineProperty(class_1.prototype, "size", {
      /**
       * @returns {boolean}
       */
      get: function () {
        return this.__entries__.length;
      },
      enumerable: true,
      configurable: true
    });
    /**
     * @param {*} key
     * @returns {*}
     */
    class_1.prototype.get = function (key) {
      var index = getIndex(this.__entries__, key);
      var entry = this.__entries__[index];
      return entry && entry[1];
    };
    /**
     * @param {*} key
     * @param {*} value
     * @returns {void}
     */
    class_1.prototype.set = function (key, value) {
      var index = getIndex(this.__entries__, key);
      if (~index) {
        this.__entries__[index][1] = value;
      } else {
        this.__entries__.push([key, value]);
      }
    };
    /**
     * @param {*} key
     * @returns {void}
     */
    class_1.prototype.delete = function (key) {
      var entries = this.__entries__;
      var index = getIndex(entries, key);
      if (~index) {
        entries.splice(index, 1);
      }
    };
    /**
     * @param {*} key
     * @returns {void}
     */
    class_1.prototype.has = function (key) {
      return !!~getIndex(this.__entries__, key);
    };
    /**
     * @returns {void}
     */
    class_1.prototype.clear = function () {
      this.__entries__.splice(0);
    };
    /**
     * @param {Function} callback
     * @param {*} [ctx=null]
     * @returns {void}
     */
    class_1.prototype.forEach = function (callback, ctx) {
      if (ctx === void 0) {
        ctx = null;
      }
      for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
        var entry = _a[_i];
        callback.call(ctx, entry[1], entry[0]);
      }
    };
    return class_1;
  }();
}();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser$5 = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1$1 = function () {
  if (typeof global !== 'undefined' && global.Math === Math) {
    return global;
  }
  if (typeof self !== 'undefined' && self.Math === Math) {
    return self;
  }
  if (typeof window !== 'undefined' && window.Math === Math) {
    return window;
  }
  // eslint-disable-next-line no-new-func
  return Function('return this')();
}();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = function () {
  if (typeof requestAnimationFrame === 'function') {
    // It's required to use a bounded function because IE sometimes throws
    // an "Invalid calling object" error if rAF is invoked without the global
    // object on the left hand side.
    return requestAnimationFrame.bind(global$1$1);
  }
  return function (callback) {
    return setTimeout(function () {
      return callback(Date.now());
    }, 1000 / 60);
  };
}();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle(callback, delay) {
  var leadingCall = false,
    trailingCall = false,
    lastCallTime = 0;
  /**
   * Invokes the original callback function and schedules new invocation if
   * the "proxy" was called during current request.
   *
   * @returns {void}
   */
  function resolvePending() {
    if (leadingCall) {
      leadingCall = false;
      callback();
    }
    if (trailingCall) {
      proxy();
    }
  }
  /**
   * Callback invoked after the specified delay. It will further postpone
   * invocation of the original function delegating it to the
   * requestAnimationFrame.
   *
   * @returns {void}
   */
  function timeoutCallback() {
    requestAnimationFrame$1(resolvePending);
  }
  /**
   * Schedules invocation of the original function.
   *
   * @returns {void}
   */
  function proxy() {
    var timeStamp = Date.now();
    if (leadingCall) {
      // Reject immediately following calls.
      if (timeStamp - lastCallTime < trailingTimeout) {
        return;
      }
      // Schedule new call to be in invoked when the pending one is resolved.
      // This is important for "transitions" which never actually start
      // immediately so there is a chance that we might miss one if change
      // happens amids the pending invocation.
      trailingCall = true;
    } else {
      leadingCall = true;
      trailingCall = false;
      setTimeout(timeoutCallback, delay);
    }
    lastCallTime = timeStamp;
  }
  return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */function () {
  /**
   * Creates a new instance of ResizeObserverController.
   *
   * @private
   */
  function ResizeObserverController() {
    /**
     * Indicates whether DOM listeners have been added.
     *
     * @private {boolean}
     */
    this.connected_ = false;
    /**
     * Tells that controller has subscribed for Mutation Events.
     *
     * @private {boolean}
     */
    this.mutationEventsAdded_ = false;
    /**
     * Keeps reference to the instance of MutationObserver.
     *
     * @private {MutationObserver}
     */
    this.mutationsObserver_ = null;
    /**
     * A list of connected observers.
     *
     * @private {Array<ResizeObserverSPI>}
     */
    this.observers_ = [];
    this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
    this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
  }
  /**
   * Adds observer to observers list.
   *
   * @param {ResizeObserverSPI} observer - Observer to be added.
   * @returns {void}
   */
  ResizeObserverController.prototype.addObserver = function (observer) {
    if (!~this.observers_.indexOf(observer)) {
      this.observers_.push(observer);
    }
    // Add listeners if they haven't been added yet.
    if (!this.connected_) {
      this.connect_();
    }
  };
  /**
   * Removes observer from observers list.
   *
   * @param {ResizeObserverSPI} observer - Observer to be removed.
   * @returns {void}
   */
  ResizeObserverController.prototype.removeObserver = function (observer) {
    var observers = this.observers_;
    var index = observers.indexOf(observer);
    // Remove observer if it's present in registry.
    if (~index) {
      observers.splice(index, 1);
    }
    // Remove listeners if controller has no connected observers.
    if (!observers.length && this.connected_) {
      this.disconnect_();
    }
  };
  /**
   * Invokes the update of observers. It will continue running updates insofar
   * it detects changes.
   *
   * @returns {void}
   */
  ResizeObserverController.prototype.refresh = function () {
    var changesDetected = this.updateObservers_();
    // Continue running updates if changes have been detected as there might
    // be future ones caused by CSS transitions.
    if (changesDetected) {
      this.refresh();
    }
  };
  /**
   * Updates every observer from observers list and notifies them of queued
   * entries.
   *
   * @private
   * @returns {boolean} Returns "true" if any observer has detected changes in
   *      dimensions of it's elements.
   */
  ResizeObserverController.prototype.updateObservers_ = function () {
    // Collect observers that have active observations.
    var activeObservers = this.observers_.filter(function (observer) {
      return observer.gatherActive(), observer.hasActive();
    });
    // Deliver notifications in a separate cycle in order to avoid any
    // collisions between observers, e.g. when multiple instances of
    // ResizeObserver are tracking the same element and the callback of one
    // of them changes content dimensions of the observed target. Sometimes
    // this may result in notifications being blocked for the rest of observers.
    activeObservers.forEach(function (observer) {
      return observer.broadcastActive();
    });
    return activeObservers.length > 0;
  };
  /**
   * Initializes DOM listeners.
   *
   * @private
   * @returns {void}
   */
  ResizeObserverController.prototype.connect_ = function () {
    // Do nothing if running in a non-browser environment or if listeners
    // have been already added.
    if (!isBrowser$5 || this.connected_) {
      return;
    }
    // Subscription to the "Transitionend" event is used as a workaround for
    // delayed transitions. This way it's possible to capture at least the
    // final state of an element.
    document.addEventListener('transitionend', this.onTransitionEnd_);
    window.addEventListener('resize', this.refresh);
    if (mutationObserverSupported) {
      this.mutationsObserver_ = new MutationObserver(this.refresh);
      this.mutationsObserver_.observe(document, {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true
      });
    } else {
      document.addEventListener('DOMSubtreeModified', this.refresh);
      this.mutationEventsAdded_ = true;
    }
    this.connected_ = true;
  };
  /**
   * Removes DOM listeners.
   *
   * @private
   * @returns {void}
   */
  ResizeObserverController.prototype.disconnect_ = function () {
    // Do nothing if running in a non-browser environment or if listeners
    // have been already removed.
    if (!isBrowser$5 || !this.connected_) {
      return;
    }
    document.removeEventListener('transitionend', this.onTransitionEnd_);
    window.removeEventListener('resize', this.refresh);
    if (this.mutationsObserver_) {
      this.mutationsObserver_.disconnect();
    }
    if (this.mutationEventsAdded_) {
      document.removeEventListener('DOMSubtreeModified', this.refresh);
    }
    this.mutationsObserver_ = null;
    this.mutationEventsAdded_ = false;
    this.connected_ = false;
  };
  /**
   * "Transitionend" event handler.
   *
   * @private
   * @param {TransitionEvent} event
   * @returns {void}
   */
  ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
    var _b = _a.propertyName,
      propertyName = _b === void 0 ? '' : _b;
    // Detect whether transition may affect dimensions of an element.
    var isReflowProperty = transitionKeys.some(function (key) {
      return !!~propertyName.indexOf(key);
    });
    if (isReflowProperty) {
      this.refresh();
    }
  };
  /**
   * Returns instance of the ResizeObserverController.
   *
   * @returns {ResizeObserverController}
   */
  ResizeObserverController.getInstance = function () {
    if (!this.instance_) {
      this.instance_ = new ResizeObserverController();
    }
    return this.instance_;
  };
  /**
   * Holds reference to the controller's instance.
   *
   * @private {ResizeObserverController}
   */
  ResizeObserverController.instance_ = null;
  return ResizeObserverController;
}();

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = function (target, props) {
  for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
    var key = _a[_i];
    Object.defineProperty(target, key, {
      value: props[key],
      enumerable: false,
      writable: false,
      configurable: true
    });
  }
  return target;
};

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = function (target) {
  // Assume that the element is an instance of Node, which means that it
  // has the "ownerDocument" property from which we can retrieve a
  // corresponding global object.
  var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
  // Return the local global object if it's not possible extract one from
  // provided element.
  return ownerGlobal || global$1$1;
};

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
  return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
  var positions = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    positions[_i - 1] = arguments[_i];
  }
  return positions.reduce(function (size, position) {
    var value = styles['border-' + position + '-width'];
    return size + toFloat(value);
  }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
  var positions = ['top', 'right', 'bottom', 'left'];
  var paddings = {};
  for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
    var position = positions_1[_i];
    var value = styles['padding-' + position];
    paddings[position] = toFloat(value);
  }
  return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
  var bbox = target.getBBox();
  return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
  // Client width & height properties can't be
  // used exclusively as they provide rounded values.
  var clientWidth = target.clientWidth,
    clientHeight = target.clientHeight;
  // By this condition we can catch all non-replaced inline, hidden and
  // detached elements. Though elements with width & height properties less
  // than 0.5 will be discarded as well.
  //
  // Without it we would need to implement separate methods for each of
  // those cases and it's not possible to perform a precise and performance
  // effective test for hidden elements. E.g. even jQuery's ':visible' filter
  // gives wrong results for elements with width & height less than 0.5.
  if (!clientWidth && !clientHeight) {
    return emptyRect;
  }
  var styles = getWindowOf(target).getComputedStyle(target);
  var paddings = getPaddings(styles);
  var horizPad = paddings.left + paddings.right;
  var vertPad = paddings.top + paddings.bottom;
  // Computed styles of width & height are being used because they are the
  // only dimensions available to JS that contain non-rounded values. It could
  // be possible to utilize the getBoundingClientRect if only it's data wasn't
  // affected by CSS transformations let alone paddings, borders and scroll bars.
  var width = toFloat(styles.width),
    height = toFloat(styles.height);
  // Width & height include paddings and borders when the 'border-box' box
  // model is applied (except for IE).
  if (styles.boxSizing === 'border-box') {
    // Following conditions are required to handle Internet Explorer which
    // doesn't include paddings and borders to computed CSS dimensions.
    //
    // We can say that if CSS dimensions + paddings are equal to the "client"
    // properties then it's either IE, and thus we don't need to subtract
    // anything, or an element merely doesn't have paddings/borders styles.
    if (Math.round(width + horizPad) !== clientWidth) {
      width -= getBordersSize(styles, 'left', 'right') + horizPad;
    }
    if (Math.round(height + vertPad) !== clientHeight) {
      height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
    }
  }
  // Following steps can't be applied to the document's root element as its
  // client[Width/Height] properties represent viewport area of the window.
  // Besides, it's as well not necessary as the <html> itself neither has
  // rendered scroll bars nor it can be clipped.
  if (!isDocumentElement(target)) {
    // In some browsers (only in Firefox, actually) CSS width & height
    // include scroll bars size which can be removed at this step as scroll
    // bars are the only difference between rounded dimensions + paddings
    // and "client" properties, though that is not always true in Chrome.
    var vertScrollbar = Math.round(width + horizPad) - clientWidth;
    var horizScrollbar = Math.round(height + vertPad) - clientHeight;
    // Chrome has a rather weird rounding of "client" properties.
    // E.g. for an element with content width of 314.2px it sometimes gives
    // the client width of 315px and for the width of 314.7px it may give
    // 314px. And it doesn't happen all the time. So just ignore this delta
    // as a non-relevant.
    if (Math.abs(vertScrollbar) !== 1) {
      width -= vertScrollbar;
    }
    if (Math.abs(horizScrollbar) !== 1) {
      height -= horizScrollbar;
    }
  }
  return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = function () {
  // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
  // interface.
  if (typeof SVGGraphicsElement !== 'undefined') {
    return function (target) {
      return target instanceof getWindowOf(target).SVGGraphicsElement;
    };
  }
  // If it's so, then check that element is at least an instance of the
  // SVGElement and that it has the "getBBox" method.
  // eslint-disable-next-line no-extra-parens
  return function (target) {
    return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === 'function';
  };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
  return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
  if (!isBrowser$5) {
    return emptyRect;
  }
  if (isSVGGraphicsElement(target)) {
    return getSVGContentRect(target);
  }
  return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
  var x = _a.x,
    y = _a.y,
    width = _a.width,
    height = _a.height;
  // If DOMRectReadOnly is available use it as a prototype for the rectangle.
  var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
  var rect = Object.create(Constr.prototype);
  // Rectangle's properties are not writable and non-enumerable.
  defineConfigurable(rect, {
    x: x,
    y: y,
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: height + y,
    left: x
  });
  return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
  return {
    x: x,
    y: y,
    width: width,
    height: height
  };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */function () {
  /**
   * Creates an instance of ResizeObservation.
   *
   * @param {Element} target - Element to be observed.
   */
  function ResizeObservation(target) {
    /**
     * Broadcasted width of content rectangle.
     *
     * @type {number}
     */
    this.broadcastWidth = 0;
    /**
     * Broadcasted height of content rectangle.
     *
     * @type {number}
     */
    this.broadcastHeight = 0;
    /**
     * Reference to the last observed content rectangle.
     *
     * @private {DOMRectInit}
     */
    this.contentRect_ = createRectInit(0, 0, 0, 0);
    this.target = target;
  }
  /**
   * Updates content rectangle and tells whether it's width or height properties
   * have changed since the last broadcast.
   *
   * @returns {boolean}
   */
  ResizeObservation.prototype.isActive = function () {
    var rect = getContentRect(this.target);
    this.contentRect_ = rect;
    return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
  };
  /**
   * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
   * from the corresponding properties of the last observed content rectangle.
   *
   * @returns {DOMRectInit} Last observed content rectangle.
   */
  ResizeObservation.prototype.broadcastRect = function () {
    var rect = this.contentRect_;
    this.broadcastWidth = rect.width;
    this.broadcastHeight = rect.height;
    return rect;
  };
  return ResizeObservation;
}();
var ResizeObserverEntry = /** @class */function () {
  /**
   * Creates an instance of ResizeObserverEntry.
   *
   * @param {Element} target - Element that is being observed.
   * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
   */
  function ResizeObserverEntry(target, rectInit) {
    var contentRect = createReadOnlyRect(rectInit);
    // According to the specification following properties are not writable
    // and are also not enumerable in the native implementation.
    //
    // Property accessors are not being used as they'd require to define a
    // private WeakMap storage which may cause memory leaks in browsers that
    // don't support this type of collections.
    defineConfigurable(this, {
      target: target,
      contentRect: contentRect
    });
  }
  return ResizeObserverEntry;
}();
var ResizeObserverSPI = /** @class */function () {
  /**
   * Creates a new instance of ResizeObserver.
   *
   * @param {ResizeObserverCallback} callback - Callback function that is invoked
   *      when one of the observed elements changes it's content dimensions.
   * @param {ResizeObserverController} controller - Controller instance which
   *      is responsible for the updates of observer.
   * @param {ResizeObserver} callbackCtx - Reference to the public
   *      ResizeObserver instance which will be passed to callback function.
   */
  function ResizeObserverSPI(callback, controller, callbackCtx) {
    /**
     * Collection of resize observations that have detected changes in dimensions
     * of elements.
     *
     * @private {Array<ResizeObservation>}
     */
    this.activeObservations_ = [];
    /**
     * Registry of the ResizeObservation instances.
     *
     * @private {Map<Element, ResizeObservation>}
     */
    this.observations_ = new MapShim();
    if (typeof callback !== 'function') {
      throw new TypeError('The callback provided as parameter 1 is not a function.');
    }
    this.callback_ = callback;
    this.controller_ = controller;
    this.callbackCtx_ = callbackCtx;
  }
  /**
   * Starts observing provided element.
   *
   * @param {Element} target - Element to be observed.
   * @returns {void}
   */
  ResizeObserverSPI.prototype.observe = function (target) {
    if (!arguments.length) {
      throw new TypeError('1 argument required, but only 0 present.');
    }
    // Do nothing if current environment doesn't have the Element interface.
    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
      return;
    }
    if (!(target instanceof getWindowOf(target).Element)) {
      throw new TypeError('parameter 1 is not of type "Element".');
    }
    var observations = this.observations_;
    // Do nothing if element is already being observed.
    if (observations.has(target)) {
      return;
    }
    observations.set(target, new ResizeObservation(target));
    this.controller_.addObserver(this);
    // Force the update of observations.
    this.controller_.refresh();
  };
  /**
   * Stops observing provided element.
   *
   * @param {Element} target - Element to stop observing.
   * @returns {void}
   */
  ResizeObserverSPI.prototype.unobserve = function (target) {
    if (!arguments.length) {
      throw new TypeError('1 argument required, but only 0 present.');
    }
    // Do nothing if current environment doesn't have the Element interface.
    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
      return;
    }
    if (!(target instanceof getWindowOf(target).Element)) {
      throw new TypeError('parameter 1 is not of type "Element".');
    }
    var observations = this.observations_;
    // Do nothing if element is not being observed.
    if (!observations.has(target)) {
      return;
    }
    observations.delete(target);
    if (!observations.size) {
      this.controller_.removeObserver(this);
    }
  };
  /**
   * Stops observing all elements.
   *
   * @returns {void}
   */
  ResizeObserverSPI.prototype.disconnect = function () {
    this.clearActive();
    this.observations_.clear();
    this.controller_.removeObserver(this);
  };
  /**
   * Collects observation instances the associated element of which has changed
   * it's content rectangle.
   *
   * @returns {void}
   */
  ResizeObserverSPI.prototype.gatherActive = function () {
    var _this = this;
    this.clearActive();
    this.observations_.forEach(function (observation) {
      if (observation.isActive()) {
        _this.activeObservations_.push(observation);
      }
    });
  };
  /**
   * Invokes initial callback function with a list of ResizeObserverEntry
   * instances collected from active resize observations.
   *
   * @returns {void}
   */
  ResizeObserverSPI.prototype.broadcastActive = function () {
    // Do nothing if observer doesn't have active observations.
    if (!this.hasActive()) {
      return;
    }
    var ctx = this.callbackCtx_;
    // Create ResizeObserverEntry instance for every active observation.
    var entries = this.activeObservations_.map(function (observation) {
      return new ResizeObserverEntry(observation.target, observation.broadcastRect());
    });
    this.callback_.call(ctx, entries, ctx);
    this.clearActive();
  };
  /**
   * Clears the collection of active observations.
   *
   * @returns {void}
   */
  ResizeObserverSPI.prototype.clearActive = function () {
    this.activeObservations_.splice(0);
  };
  /**
   * Tells whether observer has active observations.
   *
   * @returns {boolean}
   */
  ResizeObserverSPI.prototype.hasActive = function () {
    return this.activeObservations_.length > 0;
  };
  return ResizeObserverSPI;
}();

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver$1 = /** @class */function () {
  /**
   * Creates a new instance of ResizeObserver.
   *
   * @param {ResizeObserverCallback} callback - Callback that is invoked when
   *      dimensions of the observed elements change.
   */
  function ResizeObserver(callback) {
    if (!(this instanceof ResizeObserver)) {
      throw new TypeError('Cannot call a class as a function.');
    }
    if (!arguments.length) {
      throw new TypeError('1 argument required, but only 0 present.');
    }
    var controller = ResizeObserverController.getInstance();
    var observer = new ResizeObserverSPI(callback, controller, this);
    observers.set(this, observer);
  }
  return ResizeObserver;
}();
// Expose public methods of ResizeObserver.
['observe', 'unobserve', 'disconnect'].forEach(function (method) {
  ResizeObserver$1.prototype[method] = function () {
    var _a;
    return (_a = observers.get(this))[method].apply(_a, arguments);
  };
});
var index$1 = function () {
  // Export existing implementation if available.
  if (typeof global$1$1.ResizeObserver !== 'undefined') {
    return global$1$1.ResizeObserver;
  }
  return ResizeObserver$1;
}();

// Observables.tsx
var Observables = ({
  mutationObservables,
  resizeObservables,
  refresh
}) => {
  const [mutationsCounter, setMutationsCounter] = useState(0);
  const ref = useRef(document.documentElement || document.body);
  function refreshHighlightedRegionIfObservable(nodes) {
    const posibleNodes = Array.from(nodes);
    for (const node of posibleNodes) {
      if (mutationObservables) {
        if (!node.attributes) {
          continue;
        }
        const found = mutationObservables.find(observable => node.matches(observable));
        if (found) {
          refresh(true);
        }
      }
    }
  }
  function incrementMutationsCounterIfObservable(nodes) {
    const posibleNodes = Array.from(nodes);
    for (const node of posibleNodes) {
      if (resizeObservables) {
        if (!node.attributes) {
          continue;
        }
        const found = resizeObservables.find(observable => node.matches(observable));
        if (found) setMutationsCounter(mutationsCounter + 1);
      }
    }
  }
  useMutationObserver(ref, mutationList => {
    for (const mutation of mutationList) {
      if (mutation.addedNodes.length !== 0) {
        refreshHighlightedRegionIfObservable(mutation.addedNodes);
        incrementMutationsCounterIfObservable(mutation.addedNodes);
      }
      if (mutation.removedNodes.length !== 0) {
        refreshHighlightedRegionIfObservable(mutation.removedNodes);
        incrementMutationsCounterIfObservable(mutation.removedNodes);
      }
    }
  }, {
    childList: true,
    subtree: true
  });
  useEffect(() => {
    if (!resizeObservables) {
      return;
    }
    const resizeObserver = new index$1(() => {
      refresh();
    });
    for (const observable of resizeObservables) {
      const element = document.querySelector(observable);
      if (element) {
        resizeObserver.observe(element);
      }
    }
    return () => {
      resizeObserver.disconnect();
    };
  }, [resizeObservables, mutationsCounter]);
  return null;
};
var Observables_default = Observables;
function getRect$1(element) {
  let rect = initialState$4;
  if (element) {
    const domRect = element.getBoundingClientRect();
    rect = domRect;
  }
  return rect;
}
var initialState$4 = {
  bottom: 0,
  height: 0,
  left: 0,
  right: 0,
  top: 0,
  width: 0,
  x: 0,
  y: 0
};

// smoothScroll.tsx
function smoothScroll(elem, options) {
  return new Promise(resolve => {
    if (!(elem instanceof Element)) {
      throw new TypeError("Argument 1 must be an Element");
    }
    let same = 0;
    let lastPos = null;
    const scrollOptions = Object.assign({
      behavior: "smooth"
    }, options);
    elem.scrollIntoView(scrollOptions);
    requestAnimationFrame(check);
    function check() {
      const newPos = elem == null ? void 0 : elem.getBoundingClientRect().top;
      if (newPos === lastPos) {
        if (same++ > 2) {
          return resolve(null);
        }
      } else {
        same = 0;
        lastPos = newPos;
      }
      requestAnimationFrame(check);
    }
  });
}
function getInViewThreshold(threshold) {
  if (typeof threshold === "object" && threshold !== null) {
    return {
      thresholdX: threshold.x || 0,
      thresholdY: threshold.y || 0
    };
  }
  return {
    thresholdX: threshold || 0,
    thresholdY: threshold || 0
  };
}
function getWindow$2() {
  const w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
  const h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
  return {
    w,
    h
  };
}
function inView({
  top,
  right,
  bottom,
  left,
  threshold
}) {
  const {
    w: windowWidth,
    h: windowHeight
  } = getWindow$2();
  const {
    thresholdX,
    thresholdY
  } = getInViewThreshold(threshold);
  return top < 0 && bottom - top > windowHeight ? true : top >= 0 + thresholdY && left >= 0 + thresholdX && bottom <= windowHeight - thresholdY && right <= windowWidth - thresholdX;
}

// Observables.tsx

// helpers.tsx
function safe(sum) {
  return sum < 0 ? 0 : sum;
}
function getWindow$1() {
  const w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
  const h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
  return {
    w,
    h
  };
}
var defaultPadding$1 = 10;
function getPadding$2(padding = defaultPadding$1) {
  if (Array.isArray(padding)) {
    if (padding.length === 1) {
      return [padding[0], padding[0], padding[0], padding[0]];
    }
    if (padding.length === 2) {
      return [padding[1], padding[0], padding[1], padding[0]];
    }
    if (padding.length === 3) {
      return [padding[0], padding[1], padding[2], padding[1]];
    }
    if (padding.length > 3) {
      return [padding[0], padding[1], padding[2], padding[3]];
    }
    return [defaultPadding$1, defaultPadding$1];
  }
  return [padding, padding, padding, padding];
}

// Mask.tsx

// styles.tsx
var defaultStyles$2 = {
  maskWrapper: () => ({
    opacity: 0.7,
    left: 0,
    top: 0,
    position: "fixed",
    zIndex: 99999,
    pointerEvents: "none",
    color: "#000"
  }),
  svgWrapper: ({
    windowWidth,
    windowHeight,
    wpt,
    wpl
  }) => ({
    width: windowWidth,
    height: windowHeight,
    left: Number(wpl),
    top: Number(wpt),
    position: "fixed"
  }),
  maskArea: ({
    x,
    y,
    width,
    height
  }) => ({
    x,
    y,
    width,
    height,
    fill: "black",
    rx: 0
  }),
  maskRect: ({
    windowWidth,
    windowHeight,
    maskID
  }) => ({
    x: 0,
    y: 0,
    width: windowWidth,
    height: windowHeight,
    fill: "currentColor",
    mask: `url(#${maskID})`
  }),
  clickArea: ({
    windowWidth,
    windowHeight,
    clipID
  }) => ({
    x: 0,
    y: 0,
    width: windowWidth,
    height: windowHeight,
    fill: "currentcolor",
    pointerEvents: "auto",
    clipPath: `url(#${clipID})`
  }),
  highlightedArea: ({
    x,
    y,
    width,
    height
  }) => ({
    x,
    y,
    width,
    height,
    pointerEvents: "auto",
    fill: "transparent",
    display: "none"
  })
};
function stylesMatcher$2(styles) {
  return (key, state) => {
    const base = defaultStyles$2[key](state);
    const custom = styles[key];
    return custom ? custom(base, state) : base;
  };
}
var Mask = ({
  padding = 10,
  wrapperPadding = 0,
  onClick,
  onClickHighlighted,
  styles = {},
  sizes,
  className,
  highlightedAreaClassName,
  maskId,
  clipId
}) => {
  const maskID = maskId || uniqueId("mask__");
  const clipID = clipId || uniqueId("clip__");
  const getStyles = stylesMatcher$2(styles);
  const [pt, pr, pb, pl] = getPadding$2(padding);
  const [wpt, wpr, wpb, wpl] = getPadding$2(wrapperPadding);
  const {
    w,
    h
  } = getWindow$1();
  const width = safe((sizes == null ? void 0 : sizes.width) + pl + pr);
  const height = safe((sizes == null ? void 0 : sizes.height) + pt + pb);
  const top = safe((sizes == null ? void 0 : sizes.top) - pt - wpt);
  const left = safe((sizes == null ? void 0 : sizes.left) - pl - wpl);
  const windowWidth = w - wpl - wpr;
  const windowHeight = h - wpt - wpb;
  const maskAreaStyles = getStyles("maskArea", {
    x: left,
    y: top,
    width,
    height
  });
  const highlightedAreaStyles = getStyles("highlightedArea", {
    x: left,
    y: top,
    width,
    height
  });
  return /* @__PURE__ */React__default.createElement("div", {
    style: getStyles("maskWrapper", {}),
    onClick,
    className
  }, /* @__PURE__ */React__default.createElement("svg", {
    width: windowWidth,
    height: windowHeight,
    xmlns: "http://www.w3.org/2000/svg",
    style: getStyles("svgWrapper", {
      windowWidth,
      windowHeight,
      wpt,
      wpl
    })
  }, /* @__PURE__ */React__default.createElement("defs", null, /* @__PURE__ */React__default.createElement("mask", {
    id: maskID
  }, /* @__PURE__ */React__default.createElement("rect", {
    x: 0,
    y: 0,
    width: windowWidth,
    height: windowHeight,
    fill: "white"
  }), /* @__PURE__ */React__default.createElement("rect", {
    style: maskAreaStyles,
    rx: maskAreaStyles.rx ? 1 : void 0
  })), /* @__PURE__ */React__default.createElement("clipPath", {
    id: clipID
  }, /* @__PURE__ */React__default.createElement("polygon", {
    points: `0 0, 0 ${windowHeight}, ${left} ${windowHeight}, ${left} ${top}, ${left + width} ${top}, ${left + width} ${top + height}, ${left} ${top + height}, ${left} ${windowHeight}, ${windowWidth} ${windowHeight}, ${windowWidth} 0`
  }))), /* @__PURE__ */React__default.createElement("rect", {
    style: getStyles("maskRect", {
      windowWidth,
      windowHeight,
      maskID
    })
  }), /* @__PURE__ */React__default.createElement("rect", {
    style: getStyles("clickArea", {
      windowWidth,
      windowHeight,
      top,
      left,
      width,
      height,
      clipID
    })
  }), /* @__PURE__ */React__default.createElement("rect", {
    style: highlightedAreaStyles,
    className: highlightedAreaClassName,
    onClick: onClickHighlighted,
    rx: highlightedAreaStyles.rx ? 1 : void 0
  })));
};
var Mask_default = Mask;
function uniqueId(prefix) {
  return prefix + Math.random().toString(36).substring(2, 16);
}

// Observables.tsx
function getRect(element) {
  let rect = initialState$3;
  if (element) {
    const domRect = element.getBoundingClientRect();
    rect = domRect;
  }
  return rect;
}
function useRect(ref, refresher) {
  const [dimensions, setDimensions] = useState(initialState$3);
  const handleResize = useCallback(() => {
    if (!(ref == null ? void 0 : ref.current)) return;
    setDimensions(getRect(ref == null ? void 0 : ref.current));
  }, [ref == null ? void 0 : ref.current]);
  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [ref == null ? void 0 : ref.current, refresher]);
  return dimensions;
}
var initialState$3 = {
  bottom: 0,
  height: 0,
  left: 0,
  right: 0,
  top: 0,
  width: 0,
  x: 0,
  y: 0
};
function getWindow() {
  const w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
  const h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
  return {
    w,
    h
  };
}
var isOutsideX = (val, windowWidth) => {
  return val > windowWidth;
};
var isOutsideY = (val, windowHeight) => {
  return val > windowHeight;
};
function bestPositionOf(positions, filters = []) {
  const compareFn = (a, b) => filters.includes(a) ? 1 : filters.includes(b) ? -1 : 0;
  return Object.keys(positions).map(p => {
    return {
      position: p,
      value: positions[p]
    };
  }).sort((a, b) => b.value - a.value).sort((a, b) => compareFn(a.position, b.position)).filter(p => p.value > 0).map(p => p.position);
}
var defaultPadding = 10;
function getPadding$1(padding = defaultPadding) {
  if (Array.isArray(padding)) {
    if (padding.length === 1) {
      return [padding[0], padding[0], padding[0], padding[0]];
    }
    if (padding.length === 2) {
      return [padding[1], padding[0], padding[1], padding[0]];
    }
    if (padding.length === 3) {
      return [padding[0], padding[1], padding[2], padding[1]];
    }
    if (padding.length > 3) {
      return [padding[0], padding[1], padding[2], padding[3]];
    }
    return [defaultPadding, defaultPadding];
  }
  return [padding, padding, padding, padding];
}

var __defProp$1 = Object.defineProperty;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1) for (var prop of __getOwnPropSymbols$1(b)) {
    if (__propIsEnum$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
  }
  return a;
};
var __objRest$1 = (source, exclude) => {
  var target = {};
  for (var prop in source) if (__hasOwnProp$1.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1) for (var prop of __getOwnPropSymbols$1(source)) {
    if (exclude.indexOf(prop) < 0 && __propIsEnum$1.call(source, prop)) target[prop] = source[prop];
  }
  return target;
};

// styles.tsx
var defaultStyles$1 = {
  popover: () => ({
    position: "fixed",
    maxWidth: 353,
    backgroundColor: "#fff",
    padding: "24px 30px",
    boxShadow: "0 0.5em 3em rgba(0, 0, 0, 0.3)",
    color: "inherit",
    zIndex: 1e5,
    transition: "transform 0.3s",
    top: 0,
    left: 0
  })
};
function stylesMatcher$1(styles) {
  return (key, state) => {
    const base = defaultStyles$1[key](state);
    const custom = styles[key];
    return custom ? custom(base, state) : base;
  };
}

// Popover.tsx
var Popover = _a => {
  var _b = _a,
    {
      children,
      position: providedPosition = "bottom",
      padding = 10,
      styles = {},
      sizes,
      refresher
    } = _b,
    props = __objRest$1(_b, ["children", "position", "padding", "styles", "sizes", "refresher"]);
  const helperRef = useRef(null);
  const positionRef = useRef("");
  const verticalAlignRef = useRef("");
  const horizontalAlignRef = useRef("");
  const {
    w: windowWidth,
    h: windowHeight
  } = getWindow();
  const getStyles = stylesMatcher$1(styles);
  const helperRect = useRect(helperRef, refresher);
  const {
    width: helperWidth,
    height: helperHeight
  } = helperRect;
  const [pt, pr, pb, pl] = getPadding$1(padding);
  const targetLeft = (sizes == null ? void 0 : sizes.left) - pl;
  const targetTop = (sizes == null ? void 0 : sizes.top) - pt;
  const targetRight = (sizes == null ? void 0 : sizes.right) + pr;
  const targetBottom = (sizes == null ? void 0 : sizes.bottom) + pb;
  const position = providedPosition && typeof providedPosition === "function" ? providedPosition({
    width: helperWidth,
    height: helperHeight,
    windowWidth,
    windowHeight,
    top: targetTop,
    left: targetLeft,
    right: targetRight,
    bottom: targetBottom,
    x: sizes.x,
    y: sizes.y
  }, helperRect) : providedPosition;
  const available = {
    left: targetLeft,
    right: windowWidth - targetRight,
    top: targetTop,
    bottom: windowHeight - targetBottom
  };
  const couldPositionAt = (position2, isOutsideX2, isOutsideY2) => {
    switch (position2) {
      case "top":
        return available.top > helperHeight + pb;
      case "right":
        return isOutsideX2 ? false : available.right > helperWidth + pl;
      case "bottom":
        return isOutsideY2 ? false : available.bottom > helperHeight + pt;
      case "left":
        return available.left > helperWidth + pr;
      default:
        return false;
    }
  };
  const autoPosition = (coords, outX, outY) => {
    const positionsOrder = bestPositionOf(available, outY ? ["right", "left"] : outX ? ["top", "bottom"] : []);
    for (let j = 0; j < positionsOrder.length; j++) {
      if (couldPositionAt(positionsOrder[j], outX, outY)) {
        positionRef.current = positionsOrder[j];
        return coords[positionsOrder[j]];
      }
    }
    positionRef.current = "center";
    return coords.center;
  };
  const pos = helperPosition => {
    if (Array.isArray(helperPosition)) {
      const isOutX = isOutsideX(helperPosition[0], windowWidth);
      const isOutY = isOutsideY(helperPosition[1], windowHeight);
      positionRef.current = "custom";
      return [isOutX ? windowWidth / 2 - helperWidth / 2 : helperPosition[0], isOutY ? windowHeight / 2 - helperHeight / 2 : helperPosition[1]];
    }
    const isHelperOutsideX = isOutsideX(targetLeft + helperWidth, windowWidth);
    const isHelperOutsideY = isOutsideY(targetBottom + helperHeight, windowHeight);
    const x = isHelperOutsideX ? Math.min(targetLeft, windowWidth - helperWidth) : Math.max(targetLeft, 0);
    const y = isHelperOutsideY ? helperHeight > available.bottom ? Math.max(targetBottom - helperHeight, 0) : Math.max(targetTop, 0) : targetTop;
    if (isHelperOutsideY) {
      if (helperHeight > available.bottom) {
        verticalAlignRef.current = "bottom";
      } else {
        verticalAlignRef.current = "top";
      }
    } else {
      verticalAlignRef.current = "top";
    }
    if (isHelperOutsideX) {
      horizontalAlignRef.current = "left";
    } else {
      horizontalAlignRef.current = "right";
    }
    const coords = {
      top: [x - pl, targetTop - helperHeight - pb],
      right: [targetRight + pl, y - pt],
      bottom: [x - pl, targetBottom + pt],
      left: [targetLeft - helperWidth - pr, y - pt],
      center: [windowWidth / 2 - helperWidth / 2, windowHeight / 2 - helperHeight / 2]
    };
    if (helperPosition === "center" || couldPositionAt(helperPosition, isHelperOutsideX, isHelperOutsideY) && !isHelperOutsideX && !isHelperOutsideY) {
      positionRef.current = helperPosition;
      return coords[helperPosition];
    }
    return autoPosition(coords, isHelperOutsideX, isHelperOutsideY);
  };
  const p = pos(position);
  return /* @__PURE__ */React__default.createElement("div", __spreadValues$1({
    className: "reactour__popover",
    style: __spreadValues$1({
      transform: `translate(${Math.round(p[0])}px, ${Math.round(p[1])}px)`
    }, getStyles("popover", {
      position: positionRef.current,
      verticalAlign: verticalAlignRef.current,
      horizontalAlign: horizontalAlignRef.current,
      helperRect,
      targetRect: sizes
    })),
    ref: helperRef
  }, props), children);
};
var Popover_default = Popover;

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) {
    if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
  }
  return target;
};
var initialState$2 = {
  bottom: 0,
  height: 0,
  left: 0,
  right: 0,
  top: 0,
  width: 0,
  windowWidth: 0,
  windowHeight: 0,
  x: 0,
  y: 0
};
function useSizes(step, scrollOptions = {
  block: "center",
  behavior: "smooth",
  inViewThreshold: 0
}) {
  const [transition, setTransition] = useState(false);
  const [observing, setObserving] = useState(false);
  const [isHighlightingObserved, setIsHighlightingObserved] = useState(false);
  const [refresher, setRefresher] = useState(null);
  const [dimensions, setDimensions] = useState(initialState$2);
  const target = (step == null ? void 0 : step.selector) instanceof Element ? step == null ? void 0 : step.selector : document.querySelector(step == null ? void 0 : step.selector);
  const handleResize = useCallback(() => {
    const _a = getHighlightedRect(target, step == null ? void 0 : step.highlightedSelectors, step == null ? void 0 : step.bypassElem),
      newDimensions = __objRest(_a, ["hasHighligtedElems"]);
    if (Object.entries(dimensions).some(([key, value]) => newDimensions[key] !== value)) {
      setDimensions(newDimensions);
    }
  }, [target, step == null ? void 0 : step.highlightedSelectors, dimensions]);
  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [target, step == null ? void 0 : step.highlightedSelectors, refresher]);
  useEffect(() => {
    const isInView = inView(__spreadProps(__spreadValues({}, dimensions), {
      threshold: scrollOptions.inViewThreshold
    }));
    if (!isInView && target) {
      setTransition(true);
      smoothScroll(target, scrollOptions).then(() => {
        if (!observing) setRefresher(Date.now());
      }).finally(() => {
        setTransition(false);
      });
    }
  }, [dimensions]);
  const observableRefresher = useCallback(() => {
    setObserving(true);
    const _a = getHighlightedRect(target, step == null ? void 0 : step.highlightedSelectors, step == null ? void 0 : step.bypassElem),
      {
        hasHighligtedElems
      } = _a,
      dimesions = __objRest(_a, ["hasHighligtedElems"]);
    setIsHighlightingObserved(hasHighligtedElems);
    setDimensions(dimesions);
    setObserving(false);
  }, [target, step == null ? void 0 : step.highlightedSelectors, dimensions]);
  return {
    sizes: dimensions,
    transition,
    target,
    observableRefresher,
    isHighlightingObserved
  };
}
function getHighlightedRect(node, highlightedSelectors = [], bypassElem = true) {
  let hasHighligtedElems = false;
  const {
    w: windowWidth,
    h: windowHeight
  } = getWindow$2();
  if (!highlightedSelectors) {
    return __spreadProps(__spreadValues({}, getRect$1(node)), {
      windowWidth,
      windowHeight,
      hasHighligtedElems: false
    });
  }
  let attrs = getRect$1(node);
  let altAttrs = {
    bottom: 0,
    height: 0,
    left: windowWidth,
    right: 0,
    top: windowHeight,
    width: 0
  };
  for (const selector of highlightedSelectors) {
    const element = document.querySelector(selector);
    if (!element || element.style.display === "none" || element.style.visibility === "hidden") {
      continue;
    }
    const rect = getRect$1(element);
    hasHighligtedElems = true;
    if (bypassElem || !node) {
      if (rect.top < altAttrs.top) {
        altAttrs.top = rect.top;
      }
      if (rect.right > altAttrs.right) {
        altAttrs.right = rect.right;
      }
      if (rect.bottom > altAttrs.bottom) {
        altAttrs.bottom = rect.bottom;
      }
      if (rect.left < altAttrs.left) {
        altAttrs.left = rect.left;
      }
      altAttrs.width = altAttrs.right - altAttrs.left;
      altAttrs.height = altAttrs.bottom - altAttrs.top;
    } else {
      if (rect.top < attrs.top) {
        attrs.top = rect.top;
      }
      if (rect.right > attrs.right) {
        attrs.right = rect.right;
      }
      if (rect.bottom > attrs.bottom) {
        attrs.bottom = rect.bottom;
      }
      if (rect.left < attrs.left) {
        attrs.left = rect.left;
      }
      attrs.width = attrs.right - attrs.left;
      attrs.height = attrs.bottom - attrs.top;
    }
  }
  const bypassable = bypassElem || !node ? altAttrs.width > 0 && altAttrs.height > 0 : false;
  return {
    left: (bypassable ? altAttrs : attrs).left,
    top: (bypassable ? altAttrs : attrs).top,
    right: (bypassable ? altAttrs : attrs).right,
    bottom: (bypassable ? altAttrs : attrs).bottom,
    width: (bypassable ? altAttrs : attrs).width,
    height: (bypassable ? altAttrs : attrs).height,
    windowWidth,
    windowHeight,
    hasHighligtedElems,
    x: attrs.x,
    y: attrs.y
  };
}
var Keyboard = ({
  disableKeyboardNavigation,
  setCurrentStep,
  currentStep,
  setIsOpen,
  stepsLength,
  disable,
  rtl,
  clickProps,
  keyboardHandler
}) => {
  function keyDownHandler(e) {
    e.stopPropagation();
    if (disableKeyboardNavigation === true || disable) {
      return;
    }
    let isEscDisabled, isRightDisabled, isLeftDisabled;
    if (disableKeyboardNavigation) {
      isEscDisabled = disableKeyboardNavigation.includes("esc");
      isRightDisabled = disableKeyboardNavigation.includes("right");
      isLeftDisabled = disableKeyboardNavigation.includes("left");
    }
    function next() {
      setCurrentStep(Math.min(currentStep + 1, stepsLength - 1));
    }
    function prev() {
      setCurrentStep(Math.max(currentStep - 1, 0));
    }
    if (keyboardHandler && typeof keyboardHandler === "function") {
      keyboardHandler(e, clickProps, {
        isEscDisabled,
        isRightDisabled,
        isLeftDisabled
      });
    } else {
      if (e.keyCode === 27 && !isEscDisabled) {
        e.preventDefault();
        setIsOpen(false);
      }
      if (e.keyCode === 39 && !isRightDisabled) {
        e.preventDefault();
        if (rtl) {
          prev();
        } else {
          next();
        }
      }
      if (e.keyCode === 37 && !isLeftDisabled) {
        e.preventDefault();
        if (rtl) {
          next();
        } else {
          prev();
        }
      }
    }
  }
  useEffect(() => {
    window.addEventListener("keydown", keyDownHandler, false);
    return () => {
      window.removeEventListener("keydown", keyDownHandler);
    };
  }, [disable, setCurrentStep, currentStep]);
  return null;
};
var Keyboard_default = Keyboard;

// styles.tsx
var defaultStyles = {
  badge: () => ({
    position: "absolute",
    fontFamily: "monospace",
    background: "var(--reactour-accent,#007aff)",
    height: "1.875em",
    lineHeight: 2,
    paddingLeft: "0.8125em",
    paddingRight: "0.8125em",
    fontSize: "1em",
    borderRadius: "1.625em",
    color: "white",
    textAlign: "center",
    boxShadow: "0 0.25em 0.5em rgba(0, 0, 0, 0.3)",
    top: "-0.8125em",
    left: "-0.8125em"
  }),
  controls: () => ({
    display: "flex",
    marginTop: 24,
    alignItems: "center",
    justifyContent: "space-between"
  }),
  navigation: () => ({
    counterReset: "dot",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap"
  }),
  button: ({
    disabled
  }) => ({
    display: "block",
    padding: 0,
    border: 0,
    background: "none",
    cursor: disabled ? "not-allowed" : "pointer"
  }),
  arrow: ({
    disabled
  }) => ({
    color: disabled ? "#caccce" : "#646464",
    width: 16,
    height: 12,
    flex: "0 0 16px"
    // '&:hover': {
    //   color: disabled ? '#caccce' : '#000',
    // },
  }),
  dot: ({
    current,
    disabled,
    showNumber
  }) => ({
    counterIncrement: "dot",
    width: 8,
    height: 8,
    border: current ? "0" : "1px solid #caccce",
    borderRadius: "100%",
    padding: 0,
    display: "block",
    margin: 4,
    transition: "opacity 0.3s, transform 0.3s",
    cursor: disabled ? "not-allowed" : "pointer",
    transform: `scale(${current ? 1.25 : 1})`,
    color: current ? "var(--reactour-accent, #007aff)" : "#caccce",
    background: current ? "var(--reactour-accent, #007aff)" : "none"
    // '&:before': {
    //   content: 'counter(dot)',
    //   position: 'absolute',
    //   bottom: 'calc(100% + 0.25em)',
    //   left: '50%',
    //   opacity: 0,
    //   transform: 'translate(-50%, 1em)',
    //   transition: '0.3s',
    //   display: showNumber ? 'block' : 'none',
    // },
    // '&:hover': {
    //   backgroundColor: 'currentColor',
    //   '&:before': {
    //     opacity: 0.5,
    //     transform: 'translate(-50%, -2px)',
    //   },
    // },
  }),
  close: ({
    disabled
  }) => ({
    position: "absolute",
    top: 22,
    right: 22,
    width: 9,
    height: 9,
    "--rt-close-btn": disabled ? "#caccce" : "#5e5e5e",
    "--rt-close-btn-disabled": disabled ? "#caccce" : "#000"
  }),
  svg: () => ({
    display: "block"
  })
};
function stylesMatcher(styles) {
  return (key, state) => {
    const base = defaultStyles[key](state);
    const custom = styles[key];
    return custom ? custom(base, state) : base;
  };
}

// components/Badge.tsx
var Badge = ({
  styles = {},
  children
}) => {
  const getStyles = stylesMatcher(styles);
  return /* @__PURE__ */React__default.createElement("span", {
    style: getStyles("badge", {})
  }, children);
};
var Badge_default = Badge;
var Close = _a => {
  var _b = _a,
    {
      styles = {},
      onClick,
      disabled
    } = _b,
    props = __objRest(_b, ["styles", "onClick", "disabled"]);
  const getStyles = stylesMatcher(styles);
  return /* @__PURE__ */React__default.createElement("button", __spreadValues({
    className: "reactour__close-button",
    style: __spreadValues(__spreadValues({}, getStyles("button", {})), getStyles("close", {
      disabled
    })),
    onClick
  }, props), /* @__PURE__ */React__default.createElement("svg", {
    viewBox: "0 0 9.1 9.1",
    "aria-hidden": true,
    role: "presentation",
    style: __spreadValues({}, getStyles("svg", {}))
  }, /* @__PURE__ */React__default.createElement("path", {
    fill: "currentColor",
    d: "M5.9 4.5l2.8-2.8c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0L4.5 3.1 1.7.3C1.3-.1.7-.1.3.3c-.4.4-.4 1 0 1.4l2.8 2.8L.3 7.4c-.4.4-.4 1 0 1.4.2.2.4.3.7.3s.5-.1.7-.3L4.5 6l2.8 2.8c.3.2.5.3.8.3s.5-.1.7-.3c.4-.4.4-1 0-1.4L5.9 4.5z"
  })));
};
var Close_default = Close;

// components/Content.tsx
var Content = ({
  content,
  setCurrentStep,
  transition,
  isHighlightingObserved,
  currentStep,
  setIsOpen
}) => {
  return typeof content === "function" ? content({
    setCurrentStep,
    transition,
    isHighlightingObserved,
    currentStep,
    setIsOpen
  }) : content;
};
var Content_default = Content;
var Navigation = ({
  styles = {},
  steps,
  setCurrentStep,
  currentStep,
  setIsOpen,
  nextButton,
  prevButton,
  disableDots,
  hideDots,
  hideButtons,
  disableAll,
  rtl,
  Arrow = DefaultArrow
}) => {
  const stepsLength = steps.length;
  const getStyles = stylesMatcher(styles);
  const Button = ({
    onClick,
    kind = "next",
    children,
    hideArrow
  }) => {
    function clickHandler() {
      if (!disableAll) {
        if (onClick && typeof onClick === "function") {
          onClick();
        } else {
          if (kind === "next") {
            setCurrentStep(Math.min(currentStep + 1, stepsLength - 1));
          } else {
            setCurrentStep(Math.max(currentStep - 1, 0));
          }
        }
      }
    }
    return /* @__PURE__ */React__default.createElement("button", {
      style: getStyles("button", {
        kind,
        disabled: disableAll ? disableAll : kind === "next" ? stepsLength - 1 === currentStep : currentStep === 0
      }),
      onClick: clickHandler,
      "aria-label": `Go to ${kind} step`
    }, !hideArrow ? /* @__PURE__ */React__default.createElement(Arrow, {
      styles,
      inverted: rtl ? kind === "prev" : kind === "next",
      disabled: disableAll ? disableAll : kind === "next" ? stepsLength - 1 === currentStep : currentStep === 0
    }) : null, children);
  };
  return /* @__PURE__ */React__default.createElement("div", {
    style: getStyles("controls", {}),
    dir: rtl ? "rtl" : "ltr"
  }, !hideButtons ? prevButton && typeof prevButton === "function" ? prevButton({
    Button,
    setCurrentStep,
    currentStep,
    stepsLength,
    setIsOpen,
    steps
  }) : /* @__PURE__ */React__default.createElement(Button, {
    kind: "prev"
  }) : null, !hideDots ? /* @__PURE__ */React__default.createElement("div", {
    style: getStyles("navigation", {})
  }, Array.from({
    length: stepsLength
  }, (_, i) => i).map(index => {
    var _a;
    return /* @__PURE__ */React__default.createElement("button", {
      style: getStyles("dot", {
        current: index === currentStep,
        disabled: disableDots || disableAll
      }),
      onClick: () => {
        if (!disableDots && !disableAll) setCurrentStep(index);
      },
      key: `navigation_dot_${index}`,
      "aria-label": ((_a = steps[index]) == null ? void 0 : _a.navDotAriaLabel) || `Go to step ${index + 1}`
    });
  })) : null, !hideButtons ? nextButton && typeof nextButton === "function" ? nextButton({
    Button,
    setCurrentStep,
    currentStep,
    stepsLength,
    setIsOpen,
    steps
  }) : /* @__PURE__ */React__default.createElement(Button, null) : null);
};
var Navigation_default = Navigation;
var DefaultArrow = ({
  styles = {},
  inverted = false,
  disabled
}) => {
  const getStyles = stylesMatcher(styles);
  return /* @__PURE__ */React__default.createElement("svg", {
    viewBox: "0 0 18.4 14.4",
    style: getStyles("arrow", {
      inverted,
      disabled
    })
  }, /* @__PURE__ */React__default.createElement("path", {
    d: inverted ? "M17 7.2H1M10.8 1L17 7.2l-6.2 6.2" : "M1.4 7.2h16M7.6 1L1.4 7.2l6.2 6.2",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10"
  }));
};

// components/index.tsx
var components = {
  Badge: Badge_default,
  Close: Close_default,
  Content: Content_default,
  Navigation: Navigation_default,
  Arrow: DefaultArrow
};
var defaultComponents = comps => __spreadValues(__spreadValues({}, components), comps);

// components/PopoverContent.tsx
var PopoverContent = ({
  styles,
  components: components2 = {},
  badgeContent,
  accessibilityOptions,
  disabledActions,
  onClickClose,
  steps,
  setCurrentStep,
  currentStep,
  transition,
  isHighlightingObserved,
  setIsOpen,
  nextButton,
  prevButton,
  disableDotsNavigation,
  rtl,
  showPrevNextButtons = true,
  showCloseButton = true,
  showNavigation = true,
  showBadge = true,
  showDots = true,
  meta,
  setMeta,
  setSteps
}) => {
  const step = steps[currentStep];
  const {
    Badge: Badge2,
    Close: Close2,
    Content: Content2,
    Navigation: Navigation2,
    Arrow
  } = defaultComponents(components2);
  const badge = badgeContent && typeof badgeContent === "function" ? badgeContent({
    currentStep,
    totalSteps: steps.length,
    transition
  }) : currentStep + 1;
  function closeClickHandler() {
    if (!disabledActions) {
      if (onClickClose && typeof onClickClose === "function") {
        onClickClose({
          setCurrentStep,
          setIsOpen,
          currentStep,
          steps,
          meta,
          setMeta,
          setSteps
        });
      } else {
        setIsOpen(false);
      }
    }
  }
  return /* @__PURE__ */React__default.createElement(React__default.Fragment, null, showBadge ? /* @__PURE__ */React__default.createElement(Badge2, {
    styles
  }, badge) : null, showCloseButton ? /* @__PURE__ */React__default.createElement(Close2, {
    styles,
    "aria-label": accessibilityOptions == null ? void 0 : accessibilityOptions.closeButtonAriaLabel,
    disabled: disabledActions,
    onClick: closeClickHandler
  }) : null, /* @__PURE__ */React__default.createElement(Content2, {
    content: step == null ? void 0 : step.content,
    setCurrentStep,
    currentStep,
    transition,
    isHighlightingObserved,
    setIsOpen
  }), showNavigation ? /* @__PURE__ */React__default.createElement(Navigation2, {
    setCurrentStep,
    currentStep,
    setIsOpen,
    steps,
    styles,
    "aria-hidden": !(accessibilityOptions == null ? void 0 : accessibilityOptions.showNavigationScreenReaders),
    nextButton,
    prevButton,
    disableDots: disableDotsNavigation,
    hideButtons: !showPrevNextButtons,
    hideDots: !showDots,
    disableAll: disabledActions,
    rtl,
    Arrow
  }) : null);
};
var PopoverContent_default = PopoverContent;

// Tour.tsx
var Tour = _a => {
  var _b = _a,
    {
      currentStep,
      setCurrentStep,
      setIsOpen,
      steps = [],
      setSteps,
      styles: globalStyles = {},
      scrollSmooth,
      afterOpen,
      beforeClose,
      padding = 10,
      position,
      onClickMask,
      onClickHighlighted,
      keyboardHandler,
      className = "reactour__popover",
      maskClassName = "reactour__mask",
      highlightedMaskClassName,
      clipId,
      maskId,
      disableInteraction,
      disableKeyboardNavigation: disableKeyboardNavigation,
      inViewThreshold,
      disabledActions,
      setDisabledActions,
      disableWhenSelectorFalsy,
      rtl,
      accessibilityOptions = {
        closeButtonAriaLabel: "Close Tour",
        showNavigationScreenReaders: true
      },
      ContentComponent,
      Wrapper,
      meta,
      setMeta,
      onTransition = () => {
        return "center";
      }
    } = _b,
    popoverProps = __objRest(_b, ["currentStep", "setCurrentStep", "setIsOpen", "steps", "setSteps", "styles", "scrollSmooth", "afterOpen", "beforeClose", "padding", "position", "onClickMask", "onClickHighlighted", "keyboardHandler", "className", "maskClassName", "highlightedMaskClassName", "clipId", "maskId", "disableInteraction",
    // disableFocusLock,
    "disableKeyboardNavigation", "inViewThreshold", "disabledActions", "setDisabledActions", "disableWhenSelectorFalsy", "rtl", "accessibilityOptions", "ContentComponent", "Wrapper", "meta", "setMeta", "onTransition"]);
  var _a2;
  const step = steps[currentStep];
  const styles = __spreadValues(__spreadValues({}, globalStyles), step == null ? void 0 : step.styles);
  const {
    sizes,
    transition,
    observableRefresher,
    isHighlightingObserved,
    target
  } = useSizes(step, {
    block: "center",
    behavior: scrollSmooth ? "smooth" : "auto",
    inViewThreshold
  });
  useEffect(() => {
    if (afterOpen && typeof afterOpen === "function") {
      afterOpen(target);
    }
    return () => {
      if (beforeClose && typeof beforeClose === "function") {
        beforeClose(target);
      }
    };
  }, []);
  const {
    maskPadding,
    popoverPadding,
    wrapperPadding
  } = getPadding((_a2 = step == null ? void 0 : step.padding) != null ? _a2 : padding);
  const clickProps = {
    setCurrentStep,
    setIsOpen,
    currentStep,
    setSteps,
    steps,
    setMeta,
    meta
  };
  function maskClickHandler() {
    if (!disabledActions) {
      if (onClickMask && typeof onClickMask === "function") {
        onClickMask(clickProps);
      } else {
        setIsOpen(false);
      }
    }
  }
  const doDisableInteraction = typeof (step == null ? void 0 : step.stepInteraction) === "boolean" ? !(step == null ? void 0 : step.stepInteraction) : disableInteraction ? typeof disableInteraction === "boolean" ? disableInteraction : disableInteraction(clickProps) : false;
  useEffect(() => {
    if ((step == null ? void 0 : step.action) && typeof (step == null ? void 0 : step.action) === "function") {
      step == null ? void 0 : step.action(target);
    }
    if ((step == null ? void 0 : step.disableActions) !== void 0) {
      setDisabledActions(step == null ? void 0 : step.disableActions);
    }
    return () => {
      if ((step == null ? void 0 : step.actionAfter) && typeof (step == null ? void 0 : step.actionAfter) === "function") {
        step == null ? void 0 : step.actionAfter(target);
      }
    };
  }, [step]);
  const popoverPosition = transition ? onTransition : (step == null ? void 0 : step.position) ? step == null ? void 0 : step.position : position;
  const TourWrapper = Wrapper ? Wrapper : React__default.Fragment;
  return step ? /* @__PURE__ */React__default.createElement(TourWrapper, null, /* @__PURE__ */React__default.createElement(Observables_default, {
    mutationObservables: step == null ? void 0 : step.mutationObservables,
    resizeObservables: step == null ? void 0 : step.resizeObservables,
    refresh: observableRefresher
  }), /* @__PURE__ */React__default.createElement(Keyboard_default, {
    setCurrentStep,
    currentStep,
    setIsOpen,
    stepsLength: steps.length,
    disableKeyboardNavigation,
    disable: disabledActions,
    rtl,
    clickProps,
    keyboardHandler
  }), (!disableWhenSelectorFalsy || target) && /* @__PURE__ */React__default.createElement(Mask_default, {
    sizes: transition ? initialState2 : sizes,
    onClick: maskClickHandler,
    styles: __spreadValues({
      highlightedArea: base => __spreadProps(__spreadValues({}, base), {
        display: doDisableInteraction ? "block" : "none"
      })
    }, styles),
    padding: transition ? 0 : maskPadding,
    highlightedAreaClassName: highlightedMaskClassName,
    className: maskClassName,
    onClickHighlighted: e => {
      e.preventDefault();
      e.stopPropagation();
      if (onClickHighlighted) onClickHighlighted(e, clickProps);
    },
    wrapperPadding,
    clipId,
    maskId
  }), (!disableWhenSelectorFalsy || target) && /* @__PURE__ */React__default.createElement(Popover_default, {
    sizes,
    styles,
    position: popoverPosition,
    padding: popoverPadding,
    "aria-labelledby": accessibilityOptions == null ? void 0 : accessibilityOptions.ariaLabelledBy,
    className,
    refresher: currentStep
  }, ContentComponent ? /* @__PURE__ */React__default.createElement(ContentComponent, __spreadValues({
    styles,
    setCurrentStep,
    currentStep,
    setIsOpen,
    steps,
    accessibilityOptions,
    disabledActions,
    transition,
    isHighlightingObserved,
    rtl
  }, popoverProps)) : /* @__PURE__ */React__default.createElement(PopoverContent_default, __spreadValues({
    styles,
    setCurrentStep,
    currentStep,
    setIsOpen,
    steps,
    setSteps,
    accessibilityOptions,
    disabledActions,
    transition,
    isHighlightingObserved,
    rtl,
    meta,
    setMeta
  }, popoverProps)))) : null;
};
var Tour_default = Tour;
function getPadding(padding) {
  if (typeof padding === "object" && padding !== null) {
    return {
      maskPadding: padding.mask,
      popoverPadding: padding.popover,
      wrapperPadding: padding.wrapper
    };
  }
  return {
    maskPadding: padding,
    popoverPadding: padding,
    wrapperPadding: 0
  };
}
var initialState2 = {
  bottom: 0,
  height: 0,
  left: 0,
  right: 0,
  top: 0,
  width: 0,
  x: 0,
  y: 0
};
var defaultState = {
  isOpen: false,
  setIsOpen: () => false,
  currentStep: 0,
  setCurrentStep: () => 0,
  steps: [],
  setSteps: () => [],
  setMeta: () => "",
  disabledActions: false,
  setDisabledActions: () => false,
  components: {}
};
var TourContext = /*#__PURE__*/React__default.createContext(defaultState);
var TourProvider = _a => {
  var _b = _a,
    {
      children,
      defaultOpen = false,
      startAt = 0,
      steps: defaultSteps,
      setCurrentStep: customSetCurrentStep,
      currentStep: customCurrentStep
    } = _b,
    props = __objRest(_b, ["children", "defaultOpen", "startAt", "steps", "setCurrentStep", "currentStep"]);
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const [currentStep, setCurrentStep] = useState(startAt);
  const [steps, setSteps] = useState(defaultSteps);
  const [meta, setMeta] = useState("");
  const [disabledActions, setDisabledActions] = useState(false);
  const value = __spreadValues({
    isOpen,
    setIsOpen,
    currentStep: customCurrentStep || currentStep,
    setCurrentStep: customSetCurrentStep && typeof customSetCurrentStep === "function" ? customSetCurrentStep : setCurrentStep,
    steps,
    setSteps,
    disabledActions,
    setDisabledActions,
    meta,
    setMeta
  }, props);
  return /* @__PURE__ */React__default.createElement(TourContext.Provider, {
    value
  }, children, isOpen ? /* @__PURE__ */React__default.createElement(Tour_default, __spreadValues({}, value)) : null);
};
function useTour() {
  return useContext(TourContext);
}

const fetchLyrics = async (lyricsUrl, onFetchProgress) => {
  try {
    const response = await getAsset(lyricsUrl, false, onFetchProgress);
    const jsonResponse = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(response)));
    return jsonResponse;
  } catch (e) {
    throw new Error("Issue fetching lyrics");
  }
};

const initialState$1 = {
  songId: null,
  lyrics: [],
  status: "idle"
};

const fetchLyricsAsync = createAsyncThunk('lyrics/fetchLyrics', async payload => {
  const response = await fetchLyrics(payload, () => {});
  return {
    songId: response.songId,
    lyrics: response.lyrics
  };
});
const lyricsSlice = createSlice({
  name: 'lyrics',
  initialState: initialState$1,
  reducers: {
    resetLyrics: state => {
      state.status = 'idle';
      state.lyrics = [];
      state.songId = null;
    }
  },
  extraReducers: builder => {
    builder.addCase(fetchLyricsAsync.pending, state => {
      state.status = 'pending';
      state.lyrics = [];
      state.songId = null;
    }).addCase(fetchLyricsAsync.rejected, (state, action) => {
      state.status = 'rejected';
      state.lyrics = [];
      state.songId = null;
    }).addCase(fetchLyricsAsync.fulfilled, (state, action) => {
      state.status = 'idle';
      state.lyrics = action.payload.lyrics;
      state.songId = action.payload.songId;
    });
  }
});
const {
  resetLyrics
} = lyricsSlice.actions;
const selectLyricsLyrics = state => state.lyrics.lyrics;
const selectLyricsStatus = state => state.lyrics.status;
var lyricsReducer = lyricsSlice.reducer;

var css_248z$a = ".loadingScreenContainer{align-items:center;background:#111;color:#fff;display:flex;flex-direction:column;flex-grow:1;justify-content:center;width:100%}";
styleInject(css_248z$a,{"insertAt":"top"});

var dist$1 = {};

var _extends = {};

var assign$2 = {exports: {}};

var _global = {exports: {}};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$6 = _global.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self
// eslint-disable-next-line no-new-func
: Function('return this')();
if (typeof __g == 'number') __g = global$6; // eslint-disable-line no-undef

var _core = {exports: {}};

var core$4 = _core.exports = {
  version: '2.6.12'
};
if (typeof __e == 'number') __e = core$4; // eslint-disable-line no-undef

var _aFunction = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

// optional / simple context binding
var aFunction = _aFunction;
var _ctx = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1:
      return function (a) {
        return fn.call(that, a);
      };
    case 2:
      return function (a, b) {
        return fn.call(that, a, b);
      };
    case 3:
      return function (a, b, c) {
        return fn.call(that, a, b, c);
      };
  }
  return function /* ...args */
  () {
    return fn.apply(that, arguments);
  };
};

var _objectDp = {};

var _isObject;
var hasRequired_isObject;

function require_isObject () {
	if (hasRequired_isObject) return _isObject;
	hasRequired_isObject = 1;
	_isObject = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};
	return _isObject;
}

var _anObject;
var hasRequired_anObject;

function require_anObject () {
	if (hasRequired_anObject) return _anObject;
	hasRequired_anObject = 1;
	var isObject = require_isObject();
	_anObject = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};
	return _anObject;
}

var _fails = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

var _descriptors;
var hasRequired_descriptors;

function require_descriptors () {
	if (hasRequired_descriptors) return _descriptors;
	hasRequired_descriptors = 1;
	// Thank's IE8 for his funny defineProperty
	_descriptors = !_fails(function () {
	  return Object.defineProperty({}, 'a', {
	    get: function () {
	      return 7;
	    }
	  }).a != 7;
	});
	return _descriptors;
}

var _domCreate;
var hasRequired_domCreate;

function require_domCreate () {
	if (hasRequired_domCreate) return _domCreate;
	hasRequired_domCreate = 1;
	var isObject = require_isObject();
	var document = _global.exports.document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	_domCreate = function (it) {
	  return is ? document.createElement(it) : {};
	};
	return _domCreate;
}

var _ie8DomDefine;
var hasRequired_ie8DomDefine;

function require_ie8DomDefine () {
	if (hasRequired_ie8DomDefine) return _ie8DomDefine;
	hasRequired_ie8DomDefine = 1;
	_ie8DomDefine = !require_descriptors() && !_fails(function () {
	  return Object.defineProperty(require_domCreate()('div'), 'a', {
	    get: function () {
	      return 7;
	    }
	  }).a != 7;
	});
	return _ie8DomDefine;
}

var _toPrimitive;
var hasRequired_toPrimitive;

function require_toPrimitive () {
	if (hasRequired_toPrimitive) return _toPrimitive;
	hasRequired_toPrimitive = 1;
	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = require_isObject();
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	_toPrimitive = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};
	return _toPrimitive;
}

var hasRequired_objectDp;

function require_objectDp () {
	if (hasRequired_objectDp) return _objectDp;
	hasRequired_objectDp = 1;
	var anObject = require_anObject();
	var IE8_DOM_DEFINE = require_ie8DomDefine();
	var toPrimitive = require_toPrimitive();
	var dP = Object.defineProperty;
	_objectDp.f = require_descriptors() ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) {/* empty */}
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};
	return _objectDp;
}

var _propertyDesc = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var dP$1 = require_objectDp();
var createDesc$1 = _propertyDesc;
var _hide = require_descriptors() ? function (object, key, value) {
  return dP$1.f(object, key, createDesc$1(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var hasOwnProperty = {}.hasOwnProperty;
var _has = function (it, key) {
  return hasOwnProperty.call(it, key);
};

var global$5 = _global.exports;
var core$3 = _core.exports;
var ctx = _ctx;
var hide$2 = _hide;
var has$4 = _has;
var PROTOTYPE$1 = 'prototype';
var $export$7 = function (type, name, source) {
  var IS_FORCED = type & $export$7.F;
  var IS_GLOBAL = type & $export$7.G;
  var IS_STATIC = type & $export$7.S;
  var IS_PROTO = type & $export$7.P;
  var IS_BIND = type & $export$7.B;
  var IS_WRAP = type & $export$7.W;
  var exports = IS_GLOBAL ? core$3 : core$3[name] || (core$3[name] = {});
  var expProto = exports[PROTOTYPE$1];
  var target = IS_GLOBAL ? global$5 : IS_STATIC ? global$5[name] : (global$5[name] || {})[PROTOTYPE$1];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has$4(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global$5)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0:
              return new C();
            case 1:
              return new C(a);
            case 2:
              return new C(a, b);
          }
          return new C(a, b, c);
        }
        return C.apply(this, arguments);
      };
      F[PROTOTYPE$1] = C[PROTOTYPE$1];
      return F;
      // make static versions for prototype methods
    }(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export$7.R && expProto && !expProto[key]) hide$2(expProto, key, out);
    }
  }
};
// type bitmap
$export$7.F = 1; // forced
$export$7.G = 2; // global
$export$7.S = 4; // static
$export$7.P = 8; // proto
$export$7.B = 16; // bind
$export$7.W = 32; // wrap
$export$7.U = 64; // safe
$export$7.R = 128; // real proto method for `library`
var _export = $export$7;

var _cof;
var hasRequired_cof;

function require_cof () {
	if (hasRequired_cof) return _cof;
	hasRequired_cof = 1;
	var toString = {}.toString;
	_cof = function (it) {
	  return toString.call(it).slice(8, -1);
	};
	return _cof;
}

var _iobject;
var hasRequired_iobject;

function require_iobject () {
	if (hasRequired_iobject) return _iobject;
	hasRequired_iobject = 1;
	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = require_cof();
	// eslint-disable-next-line no-prototype-builtins
	_iobject = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};
	return _iobject;
}

// 7.2.1 RequireObjectCoercible(argument)
var _defined = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = require_iobject();
var defined$2 = _defined;
var _toIobject = function (it) {
  return IObject(defined$2(it));
};

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
var _toInteger = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

var _toLength;
var hasRequired_toLength;

function require_toLength () {
	if (hasRequired_toLength) return _toLength;
	hasRequired_toLength = 1;
	// 7.1.15 ToLength
	var toInteger = _toInteger;
	var min = Math.min;
	_toLength = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};
	return _toLength;
}

var _toAbsoluteIndex;
var hasRequired_toAbsoluteIndex;

function require_toAbsoluteIndex () {
	if (hasRequired_toAbsoluteIndex) return _toAbsoluteIndex;
	hasRequired_toAbsoluteIndex = 1;
	var toInteger = _toInteger;
	var max = Math.max;
	var min = Math.min;
	_toAbsoluteIndex = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};
	return _toAbsoluteIndex;
}

var _arrayIncludes;
var hasRequired_arrayIncludes;

function require_arrayIncludes () {
	if (hasRequired_arrayIncludes) return _arrayIncludes;
	hasRequired_arrayIncludes = 1;
	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = _toIobject;
	var toLength = require_toLength();
	var toAbsoluteIndex = require_toAbsoluteIndex();
	_arrayIncludes = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	      // Array#indexOf ignores holes, Array#includes - not
	    } else for (; length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    }
	    return !IS_INCLUDES && -1;
	  };
	};
	return _arrayIncludes;
}

var _shared = {exports: {}};

var _library;
var hasRequired_library;

function require_library () {
	if (hasRequired_library) return _library;
	hasRequired_library = 1;
	_library = true;
	return _library;
}

var core$2 = _core.exports;
var global$4 = _global.exports;
var SHARED = '__core-js_shared__';
var store$2 = global$4[SHARED] || (global$4[SHARED] = {});
(_shared.exports = function (key, value) {
  return store$2[key] || (store$2[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core$2.version,
  mode: require_library() ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});

var id$1 = 0;
var px = Math.random();
var _uid = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id$1 + px).toString(36));
};

var shared$1 = _shared.exports('keys');
var uid$2 = _uid;
var _sharedKey = function (key) {
  return shared$1[key] || (shared$1[key] = uid$2(key));
};

var _objectKeysInternal;
var hasRequired_objectKeysInternal;

function require_objectKeysInternal () {
	if (hasRequired_objectKeysInternal) return _objectKeysInternal;
	hasRequired_objectKeysInternal = 1;
	var has = _has;
	var toIObject = _toIobject;
	var arrayIndexOf = require_arrayIncludes()(false);
	var IE_PROTO = _sharedKey('IE_PROTO');
	_objectKeysInternal = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};
	return _objectKeysInternal;
}

var _enumBugKeys;
var hasRequired_enumBugKeys;

function require_enumBugKeys () {
	if (hasRequired_enumBugKeys) return _enumBugKeys;
	hasRequired_enumBugKeys = 1;
	// IE 8- don't enum bug keys
	_enumBugKeys = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');
	return _enumBugKeys;
}

var _objectKeys;
var hasRequired_objectKeys;

function require_objectKeys () {
	if (hasRequired_objectKeys) return _objectKeys;
	hasRequired_objectKeys = 1;
	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = require_objectKeysInternal();
	var enumBugKeys = require_enumBugKeys();
	_objectKeys = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};
	return _objectKeys;
}

var _objectGops = {};

var hasRequired_objectGops;

function require_objectGops () {
	if (hasRequired_objectGops) return _objectGops;
	hasRequired_objectGops = 1;
	_objectGops.f = Object.getOwnPropertySymbols;
	return _objectGops;
}

var _objectPie = {};

var hasRequired_objectPie;

function require_objectPie () {
	if (hasRequired_objectPie) return _objectPie;
	hasRequired_objectPie = 1;
	_objectPie.f = {}.propertyIsEnumerable;
	return _objectPie;
}

// 7.1.13 ToObject(argument)
var defined$1 = _defined;
var _toObject = function (it) {
  return Object(defined$1(it));
};

var _objectAssign;
var hasRequired_objectAssign;

function require_objectAssign () {
	if (hasRequired_objectAssign) return _objectAssign;
	hasRequired_objectAssign = 1;

	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = require_descriptors();
	var getKeys = require_objectKeys();
	var gOPS = require_objectGops();
	var pIE = require_objectPie();
	var toObject = _toObject;
	var IObject = require_iobject();
	var $assign = Object.assign;

	// should work with symbols and should have deterministic property order (V8 bug)
	_objectAssign = !$assign || _fails(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) {
	    B[k] = k;
	  });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) {
	  // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  }
	  return T;
	} : $assign;
	return _objectAssign;
}

// 19.1.3.1 Object.assign(target, source)
var $export$6 = _export;
$export$6($export$6.S + $export$6.F, 'Object', {
  assign: require_objectAssign()
});

var assign$1 = _core.exports.Object.assign;

(function (module) {
	module.exports = {
	  "default": assign$1,
	  __esModule: true
	};
} (assign$2));

_extends.__esModule = true;
var _assign = assign$2.exports;
var _assign2 = _interopRequireDefault$7(_assign);
function _interopRequireDefault$7(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
_extends.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};

var getPrototypeOf$2 = {exports: {}};

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has$3 = _has;
var toObject$2 = _toObject;
var IE_PROTO = _sharedKey('IE_PROTO');
var ObjectProto$1 = Object.prototype;
var _objectGpo = Object.getPrototypeOf || function (O) {
  O = toObject$2(O);
  if (has$3(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  }
  return O instanceof Object ? ObjectProto$1 : null;
};

// most Object methods by ES6 should accept primitives
var $export$5 = _export;
var core$1 = _core.exports;
var fails = _fails;
var _objectSap = function (KEY, exec) {
  var fn = (core$1.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export$5($export$5.S + $export$5.F * fails(function () {
    fn(1);
  }), 'Object', exp);
};

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject$1 = _toObject;
var $getPrototypeOf = _objectGpo;
_objectSap('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject$1(it));
  };
});

var getPrototypeOf$1 = _core.exports.Object.getPrototypeOf;

(function (module) {
	module.exports = {
	  "default": getPrototypeOf$1,
	  __esModule: true
	};
} (getPrototypeOf$2));

var classCallCheck = {};

classCallCheck.__esModule = true;
classCallCheck.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = {};

var defineProperty$2 = {exports: {}};

var $export$4 = _export;
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export$4($export$4.S + $export$4.F * !require_descriptors(), 'Object', {
  defineProperty: require_objectDp().f
});

var $Object$1 = _core.exports.Object;
var defineProperty$1 = function defineProperty(it, key, desc) {
  return $Object$1.defineProperty(it, key, desc);
};

(function (module) {
	module.exports = {
	  "default": defineProperty$1,
	  __esModule: true
	};
} (defineProperty$2));

createClass.__esModule = true;
var _defineProperty$3 = defineProperty$2.exports;
var _defineProperty2 = _interopRequireDefault$6(_defineProperty$3);
function _interopRequireDefault$6(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
createClass.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var possibleConstructorReturn = {};

var _typeof$3 = {};

var iterator$1 = {exports: {}};

var toInteger = _toInteger;
var defined = _defined;
// true  -> String#at
// false -> String#codePointAt
var _stringAt = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

var _redefine = {exports: {}};

(function (module) {
	module.exports = _hide;
} (_redefine));

var _iterators = {};

var _objectDps;
var hasRequired_objectDps;

function require_objectDps () {
	if (hasRequired_objectDps) return _objectDps;
	hasRequired_objectDps = 1;
	var dP = require_objectDp();
	var anObject = require_anObject();
	var getKeys = require_objectKeys();
	_objectDps = require_descriptors() ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};
	return _objectDps;
}

var _html;
var hasRequired_html;

function require_html () {
	if (hasRequired_html) return _html;
	hasRequired_html = 1;
	var document = _global.exports.document;
	_html = document && document.documentElement;
	return _html;
}

var _objectCreate;
var hasRequired_objectCreate;

function require_objectCreate () {
	if (hasRequired_objectCreate) return _objectCreate;
	hasRequired_objectCreate = 1;
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = require_anObject();
	var dPs = require_objectDps();
	var enumBugKeys = require_enumBugKeys();
	var IE_PROTO = _sharedKey('IE_PROTO');
	var Empty = function () {/* empty */};
	var PROTOTYPE = 'prototype';

	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = require_domCreate()('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  require_html().appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	_objectCreate = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};
	return _objectCreate;
}

var _wks = {exports: {}};

var store$1 = _shared.exports('wks');
var uid$1 = _uid;
var Symbol$1 = _global.exports.Symbol;
var USE_SYMBOL = typeof Symbol$1 == 'function';
var $exports = _wks.exports = function (name) {
  return store$1[name] || (store$1[name] = USE_SYMBOL && Symbol$1[name] || (USE_SYMBOL ? Symbol$1 : uid$1)('Symbol.' + name));
};
$exports.store = store$1;

var def = require_objectDp().f;
var has$2 = _has;
var TAG = _wks.exports('toStringTag');
var _setToStringTag = function (it, tag, stat) {
  if (it && !has$2(it = stat ? it : it.prototype, TAG)) def(it, TAG, {
    configurable: true,
    value: tag
  });
};

var create$2 = require_objectCreate();
var descriptor = _propertyDesc;
var setToStringTag$2 = _setToStringTag;
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
_hide(IteratorPrototype, _wks.exports('iterator'), function () {
  return this;
});
var _iterCreate = function (Constructor, NAME, next) {
  Constructor.prototype = create$2(IteratorPrototype, {
    next: descriptor(1, next)
  });
  setToStringTag$2(Constructor, NAME + ' Iterator');
};

var LIBRARY$1 = require_library();
var $export$3 = _export;
var redefine$1 = _redefine.exports;
var hide$1 = _hide;
var Iterators$2 = _iterators;
var $iterCreate = _iterCreate;
var setToStringTag$1 = _setToStringTag;
var getPrototypeOf = _objectGpo;
var ITERATOR = _wks.exports('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';
var returnThis = function () {
  return this;
};
var _iterDefine = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS:
        return function keys() {
          return new Constructor(this, kind);
        };
      case VALUES:
        return function values() {
          return new Constructor(this, kind);
        };
    }
    return function entries() {
      return new Constructor(this, kind);
    };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag$1(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY$1 && typeof IteratorPrototype[ITERATOR] != 'function') hide$1(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() {
      return $native.call(this);
    };
  }
  // Define iterator
  if ((!LIBRARY$1 || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide$1(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators$2[NAME] = $default;
  Iterators$2[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine$1(proto, key, methods[key]);
    } else $export$3($export$3.P + $export$3.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

var $at = _stringAt(true);

// 21.1.3.27 String.prototype[@@iterator]()
_iterDefine(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0; // next index
  // 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return {
    value: undefined,
    done: true
  };
  point = $at(O, index);
  this._i += point.length;
  return {
    value: point,
    done: false
  };
});

var _iterStep = function (done, value) {
  return {
    value: value,
    done: !!done
  };
};

var step = _iterStep;
var Iterators$1 = _iterators;
var toIObject$2 = _toIobject;

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
_iterDefine(Array, 'Array', function (iterated, kind) {
  this._t = toIObject$2(iterated); // target
  this._i = 0; // next index
  this._k = kind; // kind
  // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators$1.Arguments = Iterators$1.Array;

var global$3 = _global.exports;
var hide = _hide;
var Iterators = _iterators;
var TO_STRING_TAG = _wks.exports('toStringTag');
var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' + 'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' + 'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' + 'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' + 'TextTrackList,TouchList').split(',');
for (var i$8 = 0; i$8 < DOMIterables.length; i$8++) {
  var NAME = DOMIterables[i$8];
  var Collection = global$3[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}

var _wksExt = {};

_wksExt.f = _wks.exports;

var iterator = _wksExt.f('iterator');

(function (module) {
	module.exports = {
	  "default": iterator,
	  __esModule: true
	};
} (iterator$1));

var symbol$1 = {exports: {}};

var _meta = {exports: {}};

var META$1 = _uid('meta');
var isObject$2 = require_isObject();
var has$1 = _has;
var setDesc = require_objectDp().f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !_fails(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META$1, {
    value: {
      i: 'O' + ++id,
      // object ID
      w: {} // weak collections IDs
    }
  });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject$2(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has$1(it, META$1)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
    // return object ID
  }
  return it[META$1].i;
};
var getWeak = function (it, create) {
  if (!has$1(it, META$1)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
    // return hash weak collections IDs
  }
  return it[META$1].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has$1(it, META$1)) setMeta(it);
  return it;
};
var meta = _meta.exports = {
  KEY: META$1,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};

var global$2 = _global.exports;
var core = _core.exports;
var LIBRARY = require_library();
var wksExt$1 = _wksExt;
var defineProperty = require_objectDp().f;
var _wksDefine = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global$2.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, {
    value: wksExt$1.f(name)
  });
};

// all enumerable object keys, includes symbols
var getKeys = require_objectKeys();
var gOPS = require_objectGops();
var pIE = require_objectPie();
var _enumKeys = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  }
  return result;
};

// 7.2.2 IsArray(argument)
var cof = require_cof();
var _isArray = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};

var _objectGopnExt = {};

var _objectGopn = {};

var hasRequired_objectGopn;

function require_objectGopn () {
	if (hasRequired_objectGopn) return _objectGopn;
	hasRequired_objectGopn = 1;
	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = require_objectKeysInternal();
	var hiddenKeys = require_enumBugKeys().concat('length', 'prototype');
	_objectGopn.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};
	return _objectGopn;
}

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject$1 = _toIobject;
var gOPN$1 = require_objectGopn().f;
var toString = {}.toString;
var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var getWindowNames = function (it) {
  try {
    return gOPN$1(it);
  } catch (e) {
    return windowNames.slice();
  }
};
_objectGopnExt.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN$1(toIObject$1(it));
};

var _objectGopd = {};

var hasRequired_objectGopd;

function require_objectGopd () {
	if (hasRequired_objectGopd) return _objectGopd;
	hasRequired_objectGopd = 1;
	var pIE = require_objectPie();
	var createDesc = _propertyDesc;
	var toIObject = _toIobject;
	var toPrimitive = require_toPrimitive();
	var has = _has;
	var IE8_DOM_DEFINE = require_ie8DomDefine();
	var gOPD = Object.getOwnPropertyDescriptor;
	_objectGopd.f = require_descriptors() ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) {/* empty */}
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};
	return _objectGopd;
}

// ECMAScript 6 symbols shim
var global$1 = _global.exports;
var has = _has;
var DESCRIPTORS = require_descriptors();
var $export$2 = _export;
var redefine = _redefine.exports;
var META = _meta.exports.KEY;
var $fails = _fails;
var shared = _shared.exports;
var setToStringTag = _setToStringTag;
var uid = _uid;
var wks = _wks.exports;
var wksExt = _wksExt;
var wksDefine = _wksDefine;
var enumKeys = _enumKeys;
var isArray = _isArray;
var anObject = require_anObject();
var isObject$1 = require_isObject();
var toObject = _toObject;
var toIObject = _toIobject;
var toPrimitive = require_toPrimitive();
var createDesc = _propertyDesc;
var _create$1 = require_objectCreate();
var gOPNExt = _objectGopnExt;
var $GOPD = require_objectGopd();
var $GOPS = require_objectGops();
var $DP = require_objectDp();
var $keys = require_objectKeys();
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global$1.Symbol;
var $JSON = global$1.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global$1.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create$1(dP({}, 'a', {
    get: function () {
      return dP(this, 'a', {
        value: 7
      }).a;
    }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;
var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create$1($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};
var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};
var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create$1(D, {
        enumerable: createDesc(0, false)
      });
    }
    return setSymbolDesc(it, key, D);
  }
  return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create$1(it) : $defineProperties(_create$1(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  }
  return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  }
  return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, {
      configurable: true,
      set: $set
    });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });
  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  require_objectGopn().f = gOPNExt.f = $getOwnPropertyNames;
  require_objectPie().f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;
  if (DESCRIPTORS && !require_library()) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }
  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}
$export$2($export$2.G + $export$2.W + $export$2.F * !USE_NATIVE, {
  Symbol: $Symbol
});
for (var es6Symbols =
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), j$2 = 0; es6Symbols.length > j$2;) wks(es6Symbols[j$2++]);
for (var wellKnownSymbols = $keys(wks.store), k$2 = 0; wellKnownSymbols.length > k$2;) wksDefine(wellKnownSymbols[k$2++]);
$export$2($export$2.S + $export$2.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '') ? SymbolRegistry[key] : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () {
    setter = true;
  },
  useSimple: function () {
    setter = false;
  }
});
$export$2($export$2.S + $export$2.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () {
  $GOPS.f(1);
});
$export$2($export$2.S + $export$2.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export$2($export$2.S + $export$2.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({
    a: S
  }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject$1(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || _hide($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global$1.JSON, 'JSON', true);

_wksDefine('asyncIterator');

_wksDefine('observable');

var symbol = _core.exports.Symbol;

(function (module) {
	module.exports = {
	  "default": symbol,
	  __esModule: true
	};
} (symbol$1));

_typeof$3.__esModule = true;
var _iterator = iterator$1.exports;
var _iterator2 = _interopRequireDefault$5(_iterator);
var _symbol = symbol$1.exports;
var _symbol2 = _interopRequireDefault$5(_symbol);
var _typeof$2 = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj;
};
function _interopRequireDefault$5(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
_typeof$3.default = typeof _symbol2.default === "function" && _typeof$2(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof$2(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof$2(obj);
};

possibleConstructorReturn.__esModule = true;
var _typeof2$1 = _typeof$3;
var _typeof3$1 = _interopRequireDefault$4(_typeof2$1);
function _interopRequireDefault$4(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
possibleConstructorReturn.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3$1.default)(call)) === "object" || typeof call === "function") ? call : self;
};

var inherits = {};

var setPrototypeOf$1 = {exports: {}};

var _setProto;
var hasRequired_setProto;

function require_setProto () {
	if (hasRequired_setProto) return _setProto;
	hasRequired_setProto = 1;
	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = require_isObject();
	var anObject = require_anObject();
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	_setProto = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ?
	  // eslint-disable-line
	  function (test, buggy, set) {
	    try {
	      set = _ctx(Function.call, require_objectGopd().f(Object.prototype, '__proto__').set, 2);
	      set(test, []);
	      buggy = !(test instanceof Array);
	    } catch (e) {
	      buggy = true;
	    }
	    return function setPrototypeOf(O, proto) {
	      check(O, proto);
	      if (buggy) O.__proto__ = proto;else set(O, proto);
	      return O;
	    };
	  }({}, false) : undefined),
	  check: check
	};
	return _setProto;
}

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export$1 = _export;
$export$1($export$1.S, 'Object', {
  setPrototypeOf: require_setProto().set
});

var setPrototypeOf = _core.exports.Object.setPrototypeOf;

(function (module) {
	module.exports = {
	  "default": setPrototypeOf,
	  __esModule: true
	};
} (setPrototypeOf$1));

var create$1 = {exports: {}};

var $export = _export;
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', {
  create: require_objectCreate()
});

var $Object = _core.exports.Object;
var create = function create(P, D) {
  return $Object.create(P, D);
};

(function (module) {
	module.exports = {
	  "default": create,
	  __esModule: true
	};
} (create$1));

inherits.__esModule = true;
var _setPrototypeOf = setPrototypeOf$1.exports;
var _setPrototypeOf2 = _interopRequireDefault$3(_setPrototypeOf);
var _create = create$1.exports;
var _create2 = _interopRequireDefault$3(_create);
var _typeof2 = _typeof$3;
var _typeof3 = _interopRequireDefault$3(_typeof2);
function _interopRequireDefault$3(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
inherits.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }
  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

var lottie = {exports: {}};

(function (module, exports) {
	typeof navigator!=="undefined"&&function(global,factory){module.exports=factory();}(commonjsGlobal$1,function(){var svgNS='http://www.w3.org/2000/svg';var locationHref='';var _useWebWorker=false;var initialDefaultFrame=-999999;var setWebWorker=function setWebWorker(flag){_useWebWorker=!!flag;};var getWebWorker=function getWebWorker(){return _useWebWorker;};var setLocationHref=function setLocationHref(value){locationHref=value;};var getLocationHref=function getLocationHref(){return locationHref;};function createTag(type){// return {appendChild:function(){},setAttribute:function(){},style:{}}
	return document.createElement(type);}function extendPrototype(sources,destination){var i;var len=sources.length;var sourcePrototype;for(i=0;i<len;i+=1){sourcePrototype=sources[i].prototype;for(var attr in sourcePrototype){if(Object.prototype.hasOwnProperty.call(sourcePrototype,attr))destination.prototype[attr]=sourcePrototype[attr];}}}function getDescriptor(object,prop){return Object.getOwnPropertyDescriptor(object,prop);}function createProxyFunction(prototype){function ProxyFunction(){}ProxyFunction.prototype=prototype;return ProxyFunction;}// import Howl from '../../3rd_party/howler';
	var audioControllerFactory=function(){function AudioController(audioFactory){this.audios=[];this.audioFactory=audioFactory;this._volume=1;this._isMuted=false;}AudioController.prototype={addAudio:function addAudio(audio){this.audios.push(audio);},pause:function pause(){var i;var len=this.audios.length;for(i=0;i<len;i+=1){this.audios[i].pause();}},resume:function resume(){var i;var len=this.audios.length;for(i=0;i<len;i+=1){this.audios[i].resume();}},setRate:function setRate(rateValue){var i;var len=this.audios.length;for(i=0;i<len;i+=1){this.audios[i].setRate(rateValue);}},createAudio:function createAudio(assetPath){if(this.audioFactory){return this.audioFactory(assetPath);}if(window.Howl){return new window.Howl({src:[assetPath]});}return {isPlaying:false,play:function play(){this.isPlaying=true;},seek:function seek(){this.isPlaying=false;},playing:function playing(){},rate:function rate(){},setVolume:function setVolume(){}};},setAudioFactory:function setAudioFactory(audioFactory){this.audioFactory=audioFactory;},setVolume:function setVolume(value){this._volume=value;this._updateVolume();},mute:function mute(){this._isMuted=true;this._updateVolume();},unmute:function unmute(){this._isMuted=false;this._updateVolume();},getVolume:function getVolume(){return this._volume;},_updateVolume:function _updateVolume(){var i;var len=this.audios.length;for(i=0;i<len;i+=1){this.audios[i].volume(this._volume*(this._isMuted?0:1));}}};return function(){return new AudioController();};}();var createTypedArray=function(){function createRegularArray(type,len){var i=0;var arr=[];var value;switch(type){case'int16':case'uint8c':value=1;break;default:value=1.1;break;}for(i=0;i<len;i+=1){arr.push(value);}return arr;}function createTypedArrayFactory(type,len){if(type==='float32'){return new Float32Array(len);}if(type==='int16'){return new Int16Array(len);}if(type==='uint8c'){return new Uint8ClampedArray(len);}return createRegularArray(type,len);}if(typeof Uint8ClampedArray==='function'&&typeof Float32Array==='function'){return createTypedArrayFactory;}return createRegularArray;}();function createSizedArray(len){return Array.apply(null,{length:len});}function _typeof$6(obj){"@babel/helpers - typeof";if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){_typeof$6=function _typeof(obj){return typeof obj;};}else {_typeof$6=function _typeof(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};}return _typeof$6(obj);}var subframeEnabled=true;var expressionsPlugin=null;var expressionsInterfaces=null;var idPrefix$1='';var isSafari=/^((?!chrome|android).)*safari/i.test(navigator.userAgent);var bmPow=Math.pow;var bmSqrt=Math.sqrt;var bmFloor=Math.floor;var bmMax=Math.max;var bmMin=Math.min;var BMMath={};(function(){var propertyNames=['abs','acos','acosh','asin','asinh','atan','atanh','atan2','ceil','cbrt','expm1','clz32','cos','cosh','exp','floor','fround','hypot','imul','log','log1p','log2','log10','max','min','pow','random','round','sign','sin','sinh','sqrt','tan','tanh','trunc','E','LN10','LN2','LOG10E','LOG2E','PI','SQRT1_2','SQRT2'];var i;var len=propertyNames.length;for(i=0;i<len;i+=1){BMMath[propertyNames[i]]=Math[propertyNames[i]];}})();BMMath.random=Math.random;BMMath.abs=function(val){var tOfVal=_typeof$6(val);if(tOfVal==='object'&&val.length){var absArr=createSizedArray(val.length);var i;var len=val.length;for(i=0;i<len;i+=1){absArr[i]=Math.abs(val[i]);}return absArr;}return Math.abs(val);};var defaultCurveSegments=150;var degToRads=Math.PI/180;var roundCorner=0.5519;function styleDiv(element){element.style.position='absolute';element.style.top=0;element.style.left=0;element.style.display='block';element.style.transformOrigin='0 0';element.style.webkitTransformOrigin='0 0';element.style.backfaceVisibility='visible';element.style.webkitBackfaceVisibility='visible';element.style.transformStyle='preserve-3d';element.style.webkitTransformStyle='preserve-3d';element.style.mozTransformStyle='preserve-3d';}function BMEnterFrameEvent(type,currentTime,totalTime,frameMultiplier){this.type=type;this.currentTime=currentTime;this.totalTime=totalTime;this.direction=frameMultiplier<0?-1:1;}function BMCompleteEvent(type,frameMultiplier){this.type=type;this.direction=frameMultiplier<0?-1:1;}function BMCompleteLoopEvent(type,totalLoops,currentLoop,frameMultiplier){this.type=type;this.currentLoop=currentLoop;this.totalLoops=totalLoops;this.direction=frameMultiplier<0?-1:1;}function BMSegmentStartEvent(type,firstFrame,totalFrames){this.type=type;this.firstFrame=firstFrame;this.totalFrames=totalFrames;}function BMDestroyEvent(type,target){this.type=type;this.target=target;}function BMRenderFrameErrorEvent(nativeError,currentTime){this.type='renderFrameError';this.nativeError=nativeError;this.currentTime=currentTime;}function BMConfigErrorEvent(nativeError){this.type='configError';this.nativeError=nativeError;}var createElementID=function(){var _count=0;return function createID(){_count+=1;return idPrefix$1+'__lottie_element_'+_count;};}();function HSVtoRGB(h,s,v){var r;var g;var b;var i;var f;var p;var q;var t;i=Math.floor(h*6);f=h*6-i;p=v*(1-s);q=v*(1-f*s);t=v*(1-(1-f)*s);switch(i%6){case 0:r=v;g=t;b=p;break;case 1:r=q;g=v;b=p;break;case 2:r=p;g=v;b=t;break;case 3:r=p;g=q;b=v;break;case 4:r=t;g=p;b=v;break;case 5:r=v;g=p;b=q;break;}return [r,g,b];}function RGBtoHSV(r,g,b){var max=Math.max(r,g,b);var min=Math.min(r,g,b);var d=max-min;var h;var s=max===0?0:d/max;var v=max/255;switch(max){case min:h=0;break;case r:h=g-b+d*(g<b?6:0);h/=6*d;break;case g:h=b-r+d*2;h/=6*d;break;case b:h=r-g+d*4;h/=6*d;break;}return [h,s,v];}function addSaturationToRGB(color,offset){var hsv=RGBtoHSV(color[0]*255,color[1]*255,color[2]*255);hsv[1]+=offset;if(hsv[1]>1){hsv[1]=1;}else if(hsv[1]<=0){hsv[1]=0;}return HSVtoRGB(hsv[0],hsv[1],hsv[2]);}function addBrightnessToRGB(color,offset){var hsv=RGBtoHSV(color[0]*255,color[1]*255,color[2]*255);hsv[2]+=offset;if(hsv[2]>1){hsv[2]=1;}else if(hsv[2]<0){hsv[2]=0;}return HSVtoRGB(hsv[0],hsv[1],hsv[2]);}function addHueToRGB(color,offset){var hsv=RGBtoHSV(color[0]*255,color[1]*255,color[2]*255);hsv[0]+=offset/360;if(hsv[0]>1){hsv[0]-=1;}else if(hsv[0]<0){hsv[0]+=1;}return HSVtoRGB(hsv[0],hsv[1],hsv[2]);}var rgbToHex=function(){var colorMap=[];var i;var hex;for(i=0;i<256;i+=1){hex=i.toString(16);colorMap[i]=hex.length===1?'0'+hex:hex;}return function(r,g,b){if(r<0){r=0;}if(g<0){g=0;}if(b<0){b=0;}return '#'+colorMap[r]+colorMap[g]+colorMap[b];};}();var setSubframeEnabled=function setSubframeEnabled(flag){subframeEnabled=!!flag;};var getSubframeEnabled=function getSubframeEnabled(){return subframeEnabled;};var setExpressionsPlugin=function setExpressionsPlugin(value){expressionsPlugin=value;};var getExpressionsPlugin=function getExpressionsPlugin(){return expressionsPlugin;};var setExpressionInterfaces=function setExpressionInterfaces(value){expressionsInterfaces=value;};var getExpressionInterfaces=function getExpressionInterfaces(){return expressionsInterfaces;};var setDefaultCurveSegments=function setDefaultCurveSegments(value){defaultCurveSegments=value;};var getDefaultCurveSegments=function getDefaultCurveSegments(){return defaultCurveSegments;};var setIdPrefix=function setIdPrefix(value){idPrefix$1=value;};function createNS(type){// return {appendChild:function(){},setAttribute:function(){},style:{}}
	return document.createElementNS(svgNS,type);}function _typeof$5(obj){"@babel/helpers - typeof";if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){_typeof$5=function _typeof(obj){return typeof obj;};}else {_typeof$5=function _typeof(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};}return _typeof$5(obj);}var dataManager=function(){var _counterId=1;var processes=[];var workerFn;var workerInstance;var workerProxy={onmessage:function onmessage(){},postMessage:function postMessage(path){workerFn({data:path});}};var _workerSelf={postMessage:function postMessage(data){workerProxy.onmessage({data:data});}};function createWorker(fn){if(window.Worker&&window.Blob&&getWebWorker()){var blob=new Blob(['var _workerSelf = self; self.onmessage = ',fn.toString()],{type:'text/javascript'});// var blob = new Blob(['self.onmessage = ', fn.toString()], { type: 'text/javascript' });
	var url=URL.createObjectURL(blob);return new Worker(url);}workerFn=fn;return workerProxy;}function setupWorker(){if(!workerInstance){workerInstance=createWorker(function workerStart(e){function dataFunctionManager(){function completeLayers(layers,comps){var layerData;var i;var len=layers.length;var j;var jLen;var k;var kLen;for(i=0;i<len;i+=1){layerData=layers[i];if('ks'in layerData&&!layerData.completed){layerData.completed=true;if(layerData.hasMask){var maskProps=layerData.masksProperties;jLen=maskProps.length;for(j=0;j<jLen;j+=1){if(maskProps[j].pt.k.i){convertPathsToAbsoluteValues(maskProps[j].pt.k);}else {kLen=maskProps[j].pt.k.length;for(k=0;k<kLen;k+=1){if(maskProps[j].pt.k[k].s){convertPathsToAbsoluteValues(maskProps[j].pt.k[k].s[0]);}if(maskProps[j].pt.k[k].e){convertPathsToAbsoluteValues(maskProps[j].pt.k[k].e[0]);}}}}}if(layerData.ty===0){layerData.layers=findCompLayers(layerData.refId,comps);completeLayers(layerData.layers,comps);}else if(layerData.ty===4){completeShapes(layerData.shapes);}else if(layerData.ty===5){completeText(layerData);}}}}function completeChars(chars,assets){if(chars){var i=0;var len=chars.length;for(i=0;i<len;i+=1){if(chars[i].t===1){// var compData = findComp(chars[i].data.refId, assets);
	chars[i].data.layers=findCompLayers(chars[i].data.refId,assets);// chars[i].data.ip = 0;
	// chars[i].data.op = 99999;
	// chars[i].data.st = 0;
	// chars[i].data.sr = 1;
	// chars[i].w = compData.w;
	// chars[i].data.ks = {
	//   a: { k: [0, 0, 0], a: 0 },
	//   p: { k: [0, -compData.h, 0], a: 0 },
	//   r: { k: 0, a: 0 },
	//   s: { k: [100, 100], a: 0 },
	//   o: { k: 100, a: 0 },
	// };
	completeLayers(chars[i].data.layers,assets);}}}}function findComp(id,comps){var i=0;var len=comps.length;while(i<len){if(comps[i].id===id){return comps[i];}i+=1;}return null;}function findCompLayers(id,comps){var comp=findComp(id,comps);if(comp){if(!comp.layers.__used){comp.layers.__used=true;return comp.layers;}return JSON.parse(JSON.stringify(comp.layers));}return null;}function completeShapes(arr){var i;var len=arr.length;var j;var jLen;for(i=len-1;i>=0;i-=1){if(arr[i].ty==='sh'){if(arr[i].ks.k.i){convertPathsToAbsoluteValues(arr[i].ks.k);}else {jLen=arr[i].ks.k.length;for(j=0;j<jLen;j+=1){if(arr[i].ks.k[j].s){convertPathsToAbsoluteValues(arr[i].ks.k[j].s[0]);}if(arr[i].ks.k[j].e){convertPathsToAbsoluteValues(arr[i].ks.k[j].e[0]);}}}}else if(arr[i].ty==='gr'){completeShapes(arr[i].it);}}}function convertPathsToAbsoluteValues(path){var i;var len=path.i.length;for(i=0;i<len;i+=1){path.i[i][0]+=path.v[i][0];path.i[i][1]+=path.v[i][1];path.o[i][0]+=path.v[i][0];path.o[i][1]+=path.v[i][1];}}function checkVersion(minimum,animVersionString){var animVersion=animVersionString?animVersionString.split('.'):[100,100,100];if(minimum[0]>animVersion[0]){return true;}if(animVersion[0]>minimum[0]){return false;}if(minimum[1]>animVersion[1]){return true;}if(animVersion[1]>minimum[1]){return false;}if(minimum[2]>animVersion[2]){return true;}if(animVersion[2]>minimum[2]){return false;}return null;}var checkText=function(){var minimumVersion=[4,4,14];function updateTextLayer(textLayer){var documentData=textLayer.t.d;textLayer.t.d={k:[{s:documentData,t:0}]};}function iterateLayers(layers){var i;var len=layers.length;for(i=0;i<len;i+=1){if(layers[i].ty===5){updateTextLayer(layers[i]);}}}return function(animationData){if(checkVersion(minimumVersion,animationData.v)){iterateLayers(animationData.layers);if(animationData.assets){var i;var len=animationData.assets.length;for(i=0;i<len;i+=1){if(animationData.assets[i].layers){iterateLayers(animationData.assets[i].layers);}}}}};}();var checkChars=function(){var minimumVersion=[4,7,99];return function(animationData){if(animationData.chars&&!checkVersion(minimumVersion,animationData.v)){var i;var len=animationData.chars.length;for(i=0;i<len;i+=1){var charData=animationData.chars[i];if(charData.data&&charData.data.shapes){completeShapes(charData.data.shapes);charData.data.ip=0;charData.data.op=99999;charData.data.st=0;charData.data.sr=1;charData.data.ks={p:{k:[0,0],a:0},s:{k:[100,100],a:0},a:{k:[0,0],a:0},r:{k:0,a:0},o:{k:100,a:0}};if(!animationData.chars[i].t){charData.data.shapes.push({ty:'no'});charData.data.shapes[0].it.push({p:{k:[0,0],a:0},s:{k:[100,100],a:0},a:{k:[0,0],a:0},r:{k:0,a:0},o:{k:100,a:0},sk:{k:0,a:0},sa:{k:0,a:0},ty:'tr'});}}}}};}();var checkPathProperties=function(){var minimumVersion=[5,7,15];function updateTextLayer(textLayer){var pathData=textLayer.t.p;if(typeof pathData.a==='number'){pathData.a={a:0,k:pathData.a};}if(typeof pathData.p==='number'){pathData.p={a:0,k:pathData.p};}if(typeof pathData.r==='number'){pathData.r={a:0,k:pathData.r};}}function iterateLayers(layers){var i;var len=layers.length;for(i=0;i<len;i+=1){if(layers[i].ty===5){updateTextLayer(layers[i]);}}}return function(animationData){if(checkVersion(minimumVersion,animationData.v)){iterateLayers(animationData.layers);if(animationData.assets){var i;var len=animationData.assets.length;for(i=0;i<len;i+=1){if(animationData.assets[i].layers){iterateLayers(animationData.assets[i].layers);}}}}};}();var checkColors=function(){var minimumVersion=[4,1,9];function iterateShapes(shapes){var i;var len=shapes.length;var j;var jLen;for(i=0;i<len;i+=1){if(shapes[i].ty==='gr'){iterateShapes(shapes[i].it);}else if(shapes[i].ty==='fl'||shapes[i].ty==='st'){if(shapes[i].c.k&&shapes[i].c.k[0].i){jLen=shapes[i].c.k.length;for(j=0;j<jLen;j+=1){if(shapes[i].c.k[j].s){shapes[i].c.k[j].s[0]/=255;shapes[i].c.k[j].s[1]/=255;shapes[i].c.k[j].s[2]/=255;shapes[i].c.k[j].s[3]/=255;}if(shapes[i].c.k[j].e){shapes[i].c.k[j].e[0]/=255;shapes[i].c.k[j].e[1]/=255;shapes[i].c.k[j].e[2]/=255;shapes[i].c.k[j].e[3]/=255;}}}else {shapes[i].c.k[0]/=255;shapes[i].c.k[1]/=255;shapes[i].c.k[2]/=255;shapes[i].c.k[3]/=255;}}}}function iterateLayers(layers){var i;var len=layers.length;for(i=0;i<len;i+=1){if(layers[i].ty===4){iterateShapes(layers[i].shapes);}}}return function(animationData){if(checkVersion(minimumVersion,animationData.v)){iterateLayers(animationData.layers);if(animationData.assets){var i;var len=animationData.assets.length;for(i=0;i<len;i+=1){if(animationData.assets[i].layers){iterateLayers(animationData.assets[i].layers);}}}}};}();var checkShapes=function(){var minimumVersion=[4,4,18];function completeClosingShapes(arr){var i;var len=arr.length;var j;var jLen;for(i=len-1;i>=0;i-=1){if(arr[i].ty==='sh'){if(arr[i].ks.k.i){arr[i].ks.k.c=arr[i].closed;}else {jLen=arr[i].ks.k.length;for(j=0;j<jLen;j+=1){if(arr[i].ks.k[j].s){arr[i].ks.k[j].s[0].c=arr[i].closed;}if(arr[i].ks.k[j].e){arr[i].ks.k[j].e[0].c=arr[i].closed;}}}}else if(arr[i].ty==='gr'){completeClosingShapes(arr[i].it);}}}function iterateLayers(layers){var layerData;var i;var len=layers.length;var j;var jLen;var k;var kLen;for(i=0;i<len;i+=1){layerData=layers[i];if(layerData.hasMask){var maskProps=layerData.masksProperties;jLen=maskProps.length;for(j=0;j<jLen;j+=1){if(maskProps[j].pt.k.i){maskProps[j].pt.k.c=maskProps[j].cl;}else {kLen=maskProps[j].pt.k.length;for(k=0;k<kLen;k+=1){if(maskProps[j].pt.k[k].s){maskProps[j].pt.k[k].s[0].c=maskProps[j].cl;}if(maskProps[j].pt.k[k].e){maskProps[j].pt.k[k].e[0].c=maskProps[j].cl;}}}}}if(layerData.ty===4){completeClosingShapes(layerData.shapes);}}}return function(animationData){if(checkVersion(minimumVersion,animationData.v)){iterateLayers(animationData.layers);if(animationData.assets){var i;var len=animationData.assets.length;for(i=0;i<len;i+=1){if(animationData.assets[i].layers){iterateLayers(animationData.assets[i].layers);}}}}};}();function completeData(animationData){if(animationData.__complete){return;}checkColors(animationData);checkText(animationData);checkChars(animationData);checkPathProperties(animationData);checkShapes(animationData);completeLayers(animationData.layers,animationData.assets);completeChars(animationData.chars,animationData.assets);animationData.__complete=true;}function completeText(data){if(data.t.a.length===0&&!('m'in data.t.p));}var moduleOb={};moduleOb.completeData=completeData;moduleOb.checkColors=checkColors;moduleOb.checkChars=checkChars;moduleOb.checkPathProperties=checkPathProperties;moduleOb.checkShapes=checkShapes;moduleOb.completeLayers=completeLayers;return moduleOb;}if(!_workerSelf.dataManager){_workerSelf.dataManager=dataFunctionManager();}if(!_workerSelf.assetLoader){_workerSelf.assetLoader=function(){function formatResponse(xhr){// using typeof doubles the time of execution of this method,
	// so if available, it's better to use the header to validate the type
	var contentTypeHeader=xhr.getResponseHeader('content-type');if(contentTypeHeader&&xhr.responseType==='json'&&contentTypeHeader.indexOf('json')!==-1){return xhr.response;}if(xhr.response&&_typeof$5(xhr.response)==='object'){return xhr.response;}if(xhr.response&&typeof xhr.response==='string'){return JSON.parse(xhr.response);}if(xhr.responseText){return JSON.parse(xhr.responseText);}return null;}function loadAsset(path,fullPath,callback,errorCallback){var response;var xhr=new XMLHttpRequest();// set responseType after calling open or IE will break.
	try{// This crashes on Android WebView prior to KitKat
	xhr.responseType='json';}catch(err){}// eslint-disable-line no-empty
	xhr.onreadystatechange=function(){if(xhr.readyState===4){if(xhr.status===200){response=formatResponse(xhr);callback(response);}else {try{response=formatResponse(xhr);callback(response);}catch(err){if(errorCallback){errorCallback(err);}}}}};try{// Hack to workaround banner validation
	xhr.open(['G','E','T'].join(''),path,true);}catch(error){// Hack to workaround banner validation
	xhr.open(['G','E','T'].join(''),fullPath+'/'+path,true);}xhr.send();}return {load:loadAsset};}();}if(e.data.type==='loadAnimation'){_workerSelf.assetLoader.load(e.data.path,e.data.fullPath,function(data){_workerSelf.dataManager.completeData(data);_workerSelf.postMessage({id:e.data.id,payload:data,status:'success'});},function(){_workerSelf.postMessage({id:e.data.id,status:'error'});});}else if(e.data.type==='complete'){var animation=e.data.animation;_workerSelf.dataManager.completeData(animation);_workerSelf.postMessage({id:e.data.id,payload:animation,status:'success'});}else if(e.data.type==='loadData'){_workerSelf.assetLoader.load(e.data.path,e.data.fullPath,function(data){_workerSelf.postMessage({id:e.data.id,payload:data,status:'success'});},function(){_workerSelf.postMessage({id:e.data.id,status:'error'});});}});workerInstance.onmessage=function(event){var data=event.data;var id=data.id;var process=processes[id];processes[id]=null;if(data.status==='success'){process.onComplete(data.payload);}else if(process.onError){process.onError();}};}}function createProcess(onComplete,onError){_counterId+=1;var id='processId_'+_counterId;processes[id]={onComplete:onComplete,onError:onError};return id;}function loadAnimation(path,onComplete,onError){setupWorker();var processId=createProcess(onComplete,onError);workerInstance.postMessage({type:'loadAnimation',path:path,fullPath:window.location.origin+window.location.pathname,id:processId});}function loadData(path,onComplete,onError){setupWorker();var processId=createProcess(onComplete,onError);workerInstance.postMessage({type:'loadData',path:path,fullPath:window.location.origin+window.location.pathname,id:processId});}function completeAnimation(anim,onComplete,onError){setupWorker();var processId=createProcess(onComplete,onError);workerInstance.postMessage({type:'complete',animation:anim,id:processId});}return {loadAnimation:loadAnimation,loadData:loadData,completeAnimation:completeAnimation};}();var ImagePreloader=function(){var proxyImage=function(){var canvas=createTag('canvas');canvas.width=1;canvas.height=1;var ctx=canvas.getContext('2d');ctx.fillStyle='rgba(0,0,0,0)';ctx.fillRect(0,0,1,1);return canvas;}();function imageLoaded(){this.loadedAssets+=1;if(this.loadedAssets===this.totalImages&&this.loadedFootagesCount===this.totalFootages){if(this.imagesLoadedCb){this.imagesLoadedCb(null);}}}function footageLoaded(){this.loadedFootagesCount+=1;if(this.loadedAssets===this.totalImages&&this.loadedFootagesCount===this.totalFootages){if(this.imagesLoadedCb){this.imagesLoadedCb(null);}}}function getAssetsPath(assetData,assetsPath,originalPath){var path='';if(assetData.e){path=assetData.p;}else if(assetsPath){var imagePath=assetData.p;if(imagePath.indexOf('images/')!==-1){imagePath=imagePath.split('/')[1];}path=assetsPath+imagePath;}else {path=originalPath;path+=assetData.u?assetData.u:'';path+=assetData.p;}return path;}function testImageLoaded(img){var _count=0;var intervalId=setInterval(function(){var box=img.getBBox();if(box.width||_count>500){this._imageLoaded();clearInterval(intervalId);}_count+=1;}.bind(this),50);}function createImageData(assetData){var path=getAssetsPath(assetData,this.assetsPath,this.path);var img=createNS('image');if(isSafari){this.testImageLoaded(img);}else {img.addEventListener('load',this._imageLoaded,false);}img.addEventListener('error',function(){ob.img=proxyImage;this._imageLoaded();}.bind(this),false);img.setAttributeNS('http://www.w3.org/1999/xlink','href',path);if(this._elementHelper.append){this._elementHelper.append(img);}else {this._elementHelper.appendChild(img);}var ob={img:img,assetData:assetData};return ob;}function createImgData(assetData){var path=getAssetsPath(assetData,this.assetsPath,this.path);var img=createTag('img');img.crossOrigin='anonymous';img.addEventListener('load',this._imageLoaded,false);img.addEventListener('error',function(){ob.img=proxyImage;this._imageLoaded();}.bind(this),false);img.src=path;var ob={img:img,assetData:assetData};return ob;}function createFootageData(data){var ob={assetData:data};var path=getAssetsPath(data,this.assetsPath,this.path);dataManager.loadData(path,function(footageData){ob.img=footageData;this._footageLoaded();}.bind(this),function(){ob.img={};this._footageLoaded();}.bind(this));return ob;}function loadAssets(assets,cb){this.imagesLoadedCb=cb;var i;var len=assets.length;for(i=0;i<len;i+=1){if(!assets[i].layers){if(!assets[i].t||assets[i].t==='seq'){this.totalImages+=1;this.images.push(this._createImageData(assets[i]));}else if(assets[i].t===3){this.totalFootages+=1;this.images.push(this.createFootageData(assets[i]));}}}}function setPath(path){this.path=path||'';}function setAssetsPath(path){this.assetsPath=path||'';}function getAsset(assetData){var i=0;var len=this.images.length;while(i<len){if(this.images[i].assetData===assetData){return this.images[i].img;}i+=1;}return null;}function destroy(){this.imagesLoadedCb=null;this.images.length=0;}function loadedImages(){return this.totalImages===this.loadedAssets;}function loadedFootages(){return this.totalFootages===this.loadedFootagesCount;}function setCacheType(type,elementHelper){if(type==='svg'){this._elementHelper=elementHelper;this._createImageData=this.createImageData.bind(this);}else {this._createImageData=this.createImgData.bind(this);}}function ImagePreloaderFactory(){this._imageLoaded=imageLoaded.bind(this);this._footageLoaded=footageLoaded.bind(this);this.testImageLoaded=testImageLoaded.bind(this);this.createFootageData=createFootageData.bind(this);this.assetsPath='';this.path='';this.totalImages=0;this.totalFootages=0;this.loadedAssets=0;this.loadedFootagesCount=0;this.imagesLoadedCb=null;this.images=[];}ImagePreloaderFactory.prototype={loadAssets:loadAssets,setAssetsPath:setAssetsPath,setPath:setPath,loadedImages:loadedImages,loadedFootages:loadedFootages,destroy:destroy,getAsset:getAsset,createImgData:createImgData,createImageData:createImageData,imageLoaded:imageLoaded,footageLoaded:footageLoaded,setCacheType:setCacheType};return ImagePreloaderFactory;}();function BaseEvent(){}BaseEvent.prototype={triggerEvent:function triggerEvent(eventName,args){if(this._cbs[eventName]){var callbacks=this._cbs[eventName];for(var i=0;i<callbacks.length;i+=1){callbacks[i](args);}}},addEventListener:function addEventListener(eventName,callback){if(!this._cbs[eventName]){this._cbs[eventName]=[];}this._cbs[eventName].push(callback);return function(){this.removeEventListener(eventName,callback);}.bind(this);},removeEventListener:function removeEventListener(eventName,callback){if(!callback){this._cbs[eventName]=null;}else if(this._cbs[eventName]){var i=0;var len=this._cbs[eventName].length;while(i<len){if(this._cbs[eventName][i]===callback){this._cbs[eventName].splice(i,1);i-=1;len-=1;}i+=1;}if(!this._cbs[eventName].length){this._cbs[eventName]=null;}}}};var markerParser=function(){function parsePayloadLines(payload){var lines=payload.split('\r\n');var keys={};var line;var keysCount=0;for(var i=0;i<lines.length;i+=1){line=lines[i].split(':');if(line.length===2){keys[line[0]]=line[1].trim();keysCount+=1;}}if(keysCount===0){throw new Error();}return keys;}return function(_markers){var markers=[];for(var i=0;i<_markers.length;i+=1){var _marker=_markers[i];var markerData={time:_marker.tm,duration:_marker.dr};try{markerData.payload=JSON.parse(_markers[i].cm);}catch(_){try{markerData.payload=parsePayloadLines(_markers[i].cm);}catch(__){markerData.payload={name:_markers[i].cm};}}markers.push(markerData);}return markers;};}();var ProjectInterface=function(){function registerComposition(comp){this.compositions.push(comp);}return function(){function _thisProjectFunction(name){var i=0;var len=this.compositions.length;while(i<len){if(this.compositions[i].data&&this.compositions[i].data.nm===name){if(this.compositions[i].prepareFrame&&this.compositions[i].data.xt){this.compositions[i].prepareFrame(this.currentFrame);}return this.compositions[i].compInterface;}i+=1;}return null;}_thisProjectFunction.compositions=[];_thisProjectFunction.currentFrame=0;_thisProjectFunction.registerComposition=registerComposition;return _thisProjectFunction;};}();var renderers={};var registerRenderer=function registerRenderer(key,value){renderers[key]=value;};function getRenderer(key){return renderers[key];}function getRegisteredRenderer(){// Returns canvas by default for compatibility
	if(renderers.canvas){return 'canvas';}// Returns any renderer that is registered
	for(var key in renderers){if(renderers[key]){return key;}}return '';}function _typeof$4(obj){"@babel/helpers - typeof";if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){_typeof$4=function _typeof(obj){return typeof obj;};}else {_typeof$4=function _typeof(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};}return _typeof$4(obj);}var AnimationItem=function AnimationItem(){this._cbs=[];this.name='';this.path='';this.isLoaded=false;this.currentFrame=0;this.currentRawFrame=0;this.firstFrame=0;this.totalFrames=0;this.frameRate=0;this.frameMult=0;this.playSpeed=1;this.playDirection=1;this.playCount=0;this.animationData={};this.assets=[];this.isPaused=true;this.autoplay=false;this.loop=true;this.renderer=null;this.animationID=createElementID();this.assetsPath='';this.timeCompleted=0;this.segmentPos=0;this.isSubframeEnabled=getSubframeEnabled();this.segments=[];this._idle=true;this._completedLoop=false;this.projectInterface=ProjectInterface();this.imagePreloader=new ImagePreloader();this.audioController=audioControllerFactory();this.markers=[];this.configAnimation=this.configAnimation.bind(this);this.onSetupError=this.onSetupError.bind(this);this.onSegmentComplete=this.onSegmentComplete.bind(this);this.drawnFrameEvent=new BMEnterFrameEvent('drawnFrame',0,0,0);this.expressionsPlugin=getExpressionsPlugin();};extendPrototype([BaseEvent],AnimationItem);AnimationItem.prototype.setParams=function(params){if(params.wrapper||params.container){this.wrapper=params.wrapper||params.container;}var animType='svg';if(params.animType){animType=params.animType;}else if(params.renderer){animType=params.renderer;}var RendererClass=getRenderer(animType);this.renderer=new RendererClass(this,params.rendererSettings);this.imagePreloader.setCacheType(animType,this.renderer.globalData.defs);this.renderer.setProjectInterface(this.projectInterface);this.animType=animType;if(params.loop===''||params.loop===null||params.loop===undefined||params.loop===true){this.loop=true;}else if(params.loop===false){this.loop=false;}else {this.loop=parseInt(params.loop,10);}this.autoplay='autoplay'in params?params.autoplay:true;this.name=params.name?params.name:'';this.autoloadSegments=Object.prototype.hasOwnProperty.call(params,'autoloadSegments')?params.autoloadSegments:true;this.assetsPath=params.assetsPath;this.initialSegment=params.initialSegment;if(params.audioFactory){this.audioController.setAudioFactory(params.audioFactory);}if(params.animationData){this.setupAnimation(params.animationData);}else if(params.path){if(params.path.lastIndexOf('\\')!==-1){this.path=params.path.substr(0,params.path.lastIndexOf('\\')+1);}else {this.path=params.path.substr(0,params.path.lastIndexOf('/')+1);}this.fileName=params.path.substr(params.path.lastIndexOf('/')+1);this.fileName=this.fileName.substr(0,this.fileName.lastIndexOf('.json'));dataManager.loadAnimation(params.path,this.configAnimation,this.onSetupError);}};AnimationItem.prototype.onSetupError=function(){this.trigger('data_failed');};AnimationItem.prototype.setupAnimation=function(data){dataManager.completeAnimation(data,this.configAnimation);};AnimationItem.prototype.setData=function(wrapper,animationData){if(animationData){if(_typeof$4(animationData)!=='object'){animationData=JSON.parse(animationData);}}var params={wrapper:wrapper,animationData:animationData};var wrapperAttributes=wrapper.attributes;params.path=wrapperAttributes.getNamedItem('data-animation-path')// eslint-disable-line no-nested-ternary
	?wrapperAttributes.getNamedItem('data-animation-path').value:wrapperAttributes.getNamedItem('data-bm-path')// eslint-disable-line no-nested-ternary
	?wrapperAttributes.getNamedItem('data-bm-path').value:wrapperAttributes.getNamedItem('bm-path')?wrapperAttributes.getNamedItem('bm-path').value:'';params.animType=wrapperAttributes.getNamedItem('data-anim-type')// eslint-disable-line no-nested-ternary
	?wrapperAttributes.getNamedItem('data-anim-type').value:wrapperAttributes.getNamedItem('data-bm-type')// eslint-disable-line no-nested-ternary
	?wrapperAttributes.getNamedItem('data-bm-type').value:wrapperAttributes.getNamedItem('bm-type')// eslint-disable-line no-nested-ternary
	?wrapperAttributes.getNamedItem('bm-type').value:wrapperAttributes.getNamedItem('data-bm-renderer')// eslint-disable-line no-nested-ternary
	?wrapperAttributes.getNamedItem('data-bm-renderer').value:wrapperAttributes.getNamedItem('bm-renderer')?wrapperAttributes.getNamedItem('bm-renderer').value:getRegisteredRenderer()||'canvas';var loop=wrapperAttributes.getNamedItem('data-anim-loop')// eslint-disable-line no-nested-ternary
	?wrapperAttributes.getNamedItem('data-anim-loop').value:wrapperAttributes.getNamedItem('data-bm-loop')// eslint-disable-line no-nested-ternary
	?wrapperAttributes.getNamedItem('data-bm-loop').value:wrapperAttributes.getNamedItem('bm-loop')?wrapperAttributes.getNamedItem('bm-loop').value:'';if(loop==='false'){params.loop=false;}else if(loop==='true'){params.loop=true;}else if(loop!==''){params.loop=parseInt(loop,10);}var autoplay=wrapperAttributes.getNamedItem('data-anim-autoplay')// eslint-disable-line no-nested-ternary
	?wrapperAttributes.getNamedItem('data-anim-autoplay').value:wrapperAttributes.getNamedItem('data-bm-autoplay')// eslint-disable-line no-nested-ternary
	?wrapperAttributes.getNamedItem('data-bm-autoplay').value:wrapperAttributes.getNamedItem('bm-autoplay')?wrapperAttributes.getNamedItem('bm-autoplay').value:true;params.autoplay=autoplay!=='false';params.name=wrapperAttributes.getNamedItem('data-name')// eslint-disable-line no-nested-ternary
	?wrapperAttributes.getNamedItem('data-name').value:wrapperAttributes.getNamedItem('data-bm-name')// eslint-disable-line no-nested-ternary
	?wrapperAttributes.getNamedItem('data-bm-name').value:wrapperAttributes.getNamedItem('bm-name')?wrapperAttributes.getNamedItem('bm-name').value:'';var prerender=wrapperAttributes.getNamedItem('data-anim-prerender')// eslint-disable-line no-nested-ternary
	?wrapperAttributes.getNamedItem('data-anim-prerender').value:wrapperAttributes.getNamedItem('data-bm-prerender')// eslint-disable-line no-nested-ternary
	?wrapperAttributes.getNamedItem('data-bm-prerender').value:wrapperAttributes.getNamedItem('bm-prerender')?wrapperAttributes.getNamedItem('bm-prerender').value:'';if(prerender==='false'){params.prerender=false;}if(!params.path){this.trigger('destroy');}else {this.setParams(params);}};AnimationItem.prototype.includeLayers=function(data){if(data.op>this.animationData.op){this.animationData.op=data.op;this.totalFrames=Math.floor(data.op-this.animationData.ip);}var layers=this.animationData.layers;var i;var len=layers.length;var newLayers=data.layers;var j;var jLen=newLayers.length;for(j=0;j<jLen;j+=1){i=0;while(i<len){if(layers[i].id===newLayers[j].id){layers[i]=newLayers[j];break;}i+=1;}}if(data.chars||data.fonts){this.renderer.globalData.fontManager.addChars(data.chars);this.renderer.globalData.fontManager.addFonts(data.fonts,this.renderer.globalData.defs);}if(data.assets){len=data.assets.length;for(i=0;i<len;i+=1){this.animationData.assets.push(data.assets[i]);}}this.animationData.__complete=false;dataManager.completeAnimation(this.animationData,this.onSegmentComplete);};AnimationItem.prototype.onSegmentComplete=function(data){this.animationData=data;var expressionsPlugin=getExpressionsPlugin();if(expressionsPlugin){expressionsPlugin.initExpressions(this);}this.loadNextSegment();};AnimationItem.prototype.loadNextSegment=function(){var segments=this.animationData.segments;if(!segments||segments.length===0||!this.autoloadSegments){this.trigger('data_ready');this.timeCompleted=this.totalFrames;return;}var segment=segments.shift();this.timeCompleted=segment.time*this.frameRate;var segmentPath=this.path+this.fileName+'_'+this.segmentPos+'.json';this.segmentPos+=1;dataManager.loadData(segmentPath,this.includeLayers.bind(this),function(){this.trigger('data_failed');}.bind(this));};AnimationItem.prototype.loadSegments=function(){var segments=this.animationData.segments;if(!segments){this.timeCompleted=this.totalFrames;}this.loadNextSegment();};AnimationItem.prototype.imagesLoaded=function(){this.trigger('loaded_images');this.checkLoaded();};AnimationItem.prototype.preloadImages=function(){this.imagePreloader.setAssetsPath(this.assetsPath);this.imagePreloader.setPath(this.path);this.imagePreloader.loadAssets(this.animationData.assets,this.imagesLoaded.bind(this));};AnimationItem.prototype.configAnimation=function(animData){if(!this.renderer){return;}try{this.animationData=animData;if(this.initialSegment){this.totalFrames=Math.floor(this.initialSegment[1]-this.initialSegment[0]);this.firstFrame=Math.round(this.initialSegment[0]);}else {this.totalFrames=Math.floor(this.animationData.op-this.animationData.ip);this.firstFrame=Math.round(this.animationData.ip);}this.renderer.configAnimation(animData);if(!animData.assets){animData.assets=[];}this.assets=this.animationData.assets;this.frameRate=this.animationData.fr;this.frameMult=this.animationData.fr/1000;this.renderer.searchExtraCompositions(animData.assets);this.markers=markerParser(animData.markers||[]);this.trigger('config_ready');this.preloadImages();this.loadSegments();this.updaFrameModifier();this.waitForFontsLoaded();if(this.isPaused){this.audioController.pause();}}catch(error){this.triggerConfigError(error);}};AnimationItem.prototype.waitForFontsLoaded=function(){if(!this.renderer){return;}if(this.renderer.globalData.fontManager.isLoaded){this.checkLoaded();}else {setTimeout(this.waitForFontsLoaded.bind(this),20);}};AnimationItem.prototype.checkLoaded=function(){if(!this.isLoaded&&this.renderer.globalData.fontManager.isLoaded&&(this.imagePreloader.loadedImages()||this.renderer.rendererType!=='canvas')&&this.imagePreloader.loadedFootages()){this.isLoaded=true;var expressionsPlugin=getExpressionsPlugin();if(expressionsPlugin){expressionsPlugin.initExpressions(this);}this.renderer.initItems();setTimeout(function(){this.trigger('DOMLoaded');}.bind(this),0);this.gotoFrame();if(this.autoplay){this.play();}}};AnimationItem.prototype.resize=function(width,height){// Adding this validation for backwards compatibility in case an event object was being passed down
	var _width=typeof width==='number'?width:undefined;var _height=typeof height==='number'?height:undefined;this.renderer.updateContainerSize(_width,_height);};AnimationItem.prototype.setSubframe=function(flag){this.isSubframeEnabled=!!flag;};AnimationItem.prototype.gotoFrame=function(){this.currentFrame=this.isSubframeEnabled?this.currentRawFrame:~~this.currentRawFrame;// eslint-disable-line no-bitwise
	if(this.timeCompleted!==this.totalFrames&&this.currentFrame>this.timeCompleted){this.currentFrame=this.timeCompleted;}this.trigger('enterFrame');this.renderFrame();this.trigger('drawnFrame');};AnimationItem.prototype.renderFrame=function(){if(this.isLoaded===false||!this.renderer){return;}try{if(this.expressionsPlugin){this.expressionsPlugin.resetFrame();}this.renderer.renderFrame(this.currentFrame+this.firstFrame);}catch(error){this.triggerRenderFrameError(error);}};AnimationItem.prototype.play=function(name){if(name&&this.name!==name){return;}if(this.isPaused===true){this.isPaused=false;this.trigger('_play');this.audioController.resume();if(this._idle){this._idle=false;this.trigger('_active');}}};AnimationItem.prototype.pause=function(name){if(name&&this.name!==name){return;}if(this.isPaused===false){this.isPaused=true;this.trigger('_pause');this._idle=true;this.trigger('_idle');this.audioController.pause();}};AnimationItem.prototype.togglePause=function(name){if(name&&this.name!==name){return;}if(this.isPaused===true){this.play();}else {this.pause();}};AnimationItem.prototype.stop=function(name){if(name&&this.name!==name){return;}this.pause();this.playCount=0;this._completedLoop=false;this.setCurrentRawFrameValue(0);};AnimationItem.prototype.getMarkerData=function(markerName){var marker;for(var i=0;i<this.markers.length;i+=1){marker=this.markers[i];if(marker.payload&&marker.payload.name===markerName){return marker;}}return null;};AnimationItem.prototype.goToAndStop=function(value,isFrame,name){if(name&&this.name!==name){return;}var numValue=Number(value);if(isNaN(numValue)){var marker=this.getMarkerData(value);if(marker){this.goToAndStop(marker.time,true);}}else if(isFrame){this.setCurrentRawFrameValue(value);}else {this.setCurrentRawFrameValue(value*this.frameModifier);}this.pause();};AnimationItem.prototype.goToAndPlay=function(value,isFrame,name){if(name&&this.name!==name){return;}var numValue=Number(value);if(isNaN(numValue)){var marker=this.getMarkerData(value);if(marker){if(!marker.duration){this.goToAndStop(marker.time,true);}else {this.playSegments([marker.time,marker.time+marker.duration],true);}}}else {this.goToAndStop(numValue,isFrame,name);}this.play();};AnimationItem.prototype.advanceTime=function(value){if(this.isPaused===true||this.isLoaded===false){return;}var nextValue=this.currentRawFrame+value*this.frameModifier;var _isComplete=false;// Checking if nextValue > totalFrames - 1 for addressing non looping and looping animations.
	// If animation won't loop, it should stop at totalFrames - 1. If it will loop it should complete the last frame and then loop.
	if(nextValue>=this.totalFrames-1&&this.frameModifier>0){if(!this.loop||this.playCount===this.loop){if(!this.checkSegments(nextValue>this.totalFrames?nextValue%this.totalFrames:0)){_isComplete=true;nextValue=this.totalFrames-1;}}else if(nextValue>=this.totalFrames){this.playCount+=1;if(!this.checkSegments(nextValue%this.totalFrames)){this.setCurrentRawFrameValue(nextValue%this.totalFrames);this._completedLoop=true;this.trigger('loopComplete');}}else {this.setCurrentRawFrameValue(nextValue);}}else if(nextValue<0){if(!this.checkSegments(nextValue%this.totalFrames)){if(this.loop&&!(this.playCount--<=0&&this.loop!==true)){// eslint-disable-line no-plusplus
	this.setCurrentRawFrameValue(this.totalFrames+nextValue%this.totalFrames);if(!this._completedLoop){this._completedLoop=true;}else {this.trigger('loopComplete');}}else {_isComplete=true;nextValue=0;}}}else {this.setCurrentRawFrameValue(nextValue);}if(_isComplete){this.setCurrentRawFrameValue(nextValue);this.pause();this.trigger('complete');}};AnimationItem.prototype.adjustSegment=function(arr,offset){this.playCount=0;if(arr[1]<arr[0]){if(this.frameModifier>0){if(this.playSpeed<0){this.setSpeed(-this.playSpeed);}else {this.setDirection(-1);}}this.totalFrames=arr[0]-arr[1];this.timeCompleted=this.totalFrames;this.firstFrame=arr[1];this.setCurrentRawFrameValue(this.totalFrames-0.001-offset);}else if(arr[1]>arr[0]){if(this.frameModifier<0){if(this.playSpeed<0){this.setSpeed(-this.playSpeed);}else {this.setDirection(1);}}this.totalFrames=arr[1]-arr[0];this.timeCompleted=this.totalFrames;this.firstFrame=arr[0];this.setCurrentRawFrameValue(0.001+offset);}this.trigger('segmentStart');};AnimationItem.prototype.setSegment=function(init,end){var pendingFrame=-1;if(this.isPaused){if(this.currentRawFrame+this.firstFrame<init){pendingFrame=init;}else if(this.currentRawFrame+this.firstFrame>end){pendingFrame=end-init;}}this.firstFrame=init;this.totalFrames=end-init;this.timeCompleted=this.totalFrames;if(pendingFrame!==-1){this.goToAndStop(pendingFrame,true);}};AnimationItem.prototype.playSegments=function(arr,forceFlag){if(forceFlag){this.segments.length=0;}if(_typeof$4(arr[0])==='object'){var i;var len=arr.length;for(i=0;i<len;i+=1){this.segments.push(arr[i]);}}else {this.segments.push(arr);}if(this.segments.length&&forceFlag){this.adjustSegment(this.segments.shift(),0);}if(this.isPaused){this.play();}};AnimationItem.prototype.resetSegments=function(forceFlag){this.segments.length=0;this.segments.push([this.animationData.ip,this.animationData.op]);if(forceFlag){this.checkSegments(0);}};AnimationItem.prototype.checkSegments=function(offset){if(this.segments.length){this.adjustSegment(this.segments.shift(),offset);return true;}return false;};AnimationItem.prototype.destroy=function(name){if(name&&this.name!==name||!this.renderer){return;}this.renderer.destroy();this.imagePreloader.destroy();this.trigger('destroy');this._cbs=null;this.onEnterFrame=null;this.onLoopComplete=null;this.onComplete=null;this.onSegmentStart=null;this.onDestroy=null;this.renderer=null;this.expressionsPlugin=null;this.imagePreloader=null;this.projectInterface=null;};AnimationItem.prototype.setCurrentRawFrameValue=function(value){this.currentRawFrame=value;this.gotoFrame();};AnimationItem.prototype.setSpeed=function(val){this.playSpeed=val;this.updaFrameModifier();};AnimationItem.prototype.setDirection=function(val){this.playDirection=val<0?-1:1;this.updaFrameModifier();};AnimationItem.prototype.setLoop=function(isLooping){this.loop=isLooping;};AnimationItem.prototype.setVolume=function(val,name){if(name&&this.name!==name){return;}this.audioController.setVolume(val);};AnimationItem.prototype.getVolume=function(){return this.audioController.getVolume();};AnimationItem.prototype.mute=function(name){if(name&&this.name!==name){return;}this.audioController.mute();};AnimationItem.prototype.unmute=function(name){if(name&&this.name!==name){return;}this.audioController.unmute();};AnimationItem.prototype.updaFrameModifier=function(){this.frameModifier=this.frameMult*this.playSpeed*this.playDirection;this.audioController.setRate(this.playSpeed*this.playDirection);};AnimationItem.prototype.getPath=function(){return this.path;};AnimationItem.prototype.getAssetsPath=function(assetData){var path='';if(assetData.e){path=assetData.p;}else if(this.assetsPath){var imagePath=assetData.p;if(imagePath.indexOf('images/')!==-1){imagePath=imagePath.split('/')[1];}path=this.assetsPath+imagePath;}else {path=this.path;path+=assetData.u?assetData.u:'';path+=assetData.p;}return path;};AnimationItem.prototype.getAssetData=function(id){var i=0;var len=this.assets.length;while(i<len){if(id===this.assets[i].id){return this.assets[i];}i+=1;}return null;};AnimationItem.prototype.hide=function(){this.renderer.hide();};AnimationItem.prototype.show=function(){this.renderer.show();};AnimationItem.prototype.getDuration=function(isFrame){return isFrame?this.totalFrames:this.totalFrames/this.frameRate;};AnimationItem.prototype.updateDocumentData=function(path,documentData,index){try{var element=this.renderer.getElementByPath(path);element.updateDocumentData(documentData,index);}catch(error){// TODO: decide how to handle catch case
	}};AnimationItem.prototype.trigger=function(name){if(this._cbs&&this._cbs[name]){switch(name){case'enterFrame':this.triggerEvent(name,new BMEnterFrameEvent(name,this.currentFrame,this.totalFrames,this.frameModifier));break;case'drawnFrame':this.drawnFrameEvent.currentTime=this.currentFrame;this.drawnFrameEvent.totalTime=this.totalFrames;this.drawnFrameEvent.direction=this.frameModifier;this.triggerEvent(name,this.drawnFrameEvent);break;case'loopComplete':this.triggerEvent(name,new BMCompleteLoopEvent(name,this.loop,this.playCount,this.frameMult));break;case'complete':this.triggerEvent(name,new BMCompleteEvent(name,this.frameMult));break;case'segmentStart':this.triggerEvent(name,new BMSegmentStartEvent(name,this.firstFrame,this.totalFrames));break;case'destroy':this.triggerEvent(name,new BMDestroyEvent(name,this));break;default:this.triggerEvent(name);}}if(name==='enterFrame'&&this.onEnterFrame){this.onEnterFrame.call(this,new BMEnterFrameEvent(name,this.currentFrame,this.totalFrames,this.frameMult));}if(name==='loopComplete'&&this.onLoopComplete){this.onLoopComplete.call(this,new BMCompleteLoopEvent(name,this.loop,this.playCount,this.frameMult));}if(name==='complete'&&this.onComplete){this.onComplete.call(this,new BMCompleteEvent(name,this.frameMult));}if(name==='segmentStart'&&this.onSegmentStart){this.onSegmentStart.call(this,new BMSegmentStartEvent(name,this.firstFrame,this.totalFrames));}if(name==='destroy'&&this.onDestroy){this.onDestroy.call(this,new BMDestroyEvent(name,this));}};AnimationItem.prototype.triggerRenderFrameError=function(nativeError){var error=new BMRenderFrameErrorEvent(nativeError,this.currentFrame);this.triggerEvent('error',error);if(this.onError){this.onError.call(this,error);}};AnimationItem.prototype.triggerConfigError=function(nativeError){var error=new BMConfigErrorEvent(nativeError,this.currentFrame);this.triggerEvent('error',error);if(this.onError){this.onError.call(this,error);}};var animationManager=function(){var moduleOb={};var registeredAnimations=[];var initTime=0;var len=0;var playingAnimationsNum=0;var _stopped=true;var _isFrozen=false;function removeElement(ev){var i=0;var animItem=ev.target;while(i<len){if(registeredAnimations[i].animation===animItem){registeredAnimations.splice(i,1);i-=1;len-=1;if(!animItem.isPaused){subtractPlayingCount();}}i+=1;}}function registerAnimation(element,animationData){if(!element){return null;}var i=0;while(i<len){if(registeredAnimations[i].elem===element&&registeredAnimations[i].elem!==null){return registeredAnimations[i].animation;}i+=1;}var animItem=new AnimationItem();setupAnimation(animItem,element);animItem.setData(element,animationData);return animItem;}function getRegisteredAnimations(){var i;var lenAnims=registeredAnimations.length;var animations=[];for(i=0;i<lenAnims;i+=1){animations.push(registeredAnimations[i].animation);}return animations;}function addPlayingCount(){playingAnimationsNum+=1;activate();}function subtractPlayingCount(){playingAnimationsNum-=1;}function setupAnimation(animItem,element){animItem.addEventListener('destroy',removeElement);animItem.addEventListener('_active',addPlayingCount);animItem.addEventListener('_idle',subtractPlayingCount);registeredAnimations.push({elem:element,animation:animItem});len+=1;}function loadAnimation(params){var animItem=new AnimationItem();setupAnimation(animItem,null);animItem.setParams(params);return animItem;}function setSpeed(val,animation){var i;for(i=0;i<len;i+=1){registeredAnimations[i].animation.setSpeed(val,animation);}}function setDirection(val,animation){var i;for(i=0;i<len;i+=1){registeredAnimations[i].animation.setDirection(val,animation);}}function play(animation){var i;for(i=0;i<len;i+=1){registeredAnimations[i].animation.play(animation);}}function resume(nowTime){var elapsedTime=nowTime-initTime;var i;for(i=0;i<len;i+=1){registeredAnimations[i].animation.advanceTime(elapsedTime);}initTime=nowTime;if(playingAnimationsNum&&!_isFrozen){window.requestAnimationFrame(resume);}else {_stopped=true;}}function first(nowTime){initTime=nowTime;window.requestAnimationFrame(resume);}function pause(animation){var i;for(i=0;i<len;i+=1){registeredAnimations[i].animation.pause(animation);}}function goToAndStop(value,isFrame,animation){var i;for(i=0;i<len;i+=1){registeredAnimations[i].animation.goToAndStop(value,isFrame,animation);}}function stop(animation){var i;for(i=0;i<len;i+=1){registeredAnimations[i].animation.stop(animation);}}function togglePause(animation){var i;for(i=0;i<len;i+=1){registeredAnimations[i].animation.togglePause(animation);}}function destroy(animation){var i;for(i=len-1;i>=0;i-=1){registeredAnimations[i].animation.destroy(animation);}}function searchAnimations(animationData,standalone,renderer){var animElements=[].concat([].slice.call(document.getElementsByClassName('lottie')),[].slice.call(document.getElementsByClassName('bodymovin')));var i;var lenAnims=animElements.length;for(i=0;i<lenAnims;i+=1){if(renderer){animElements[i].setAttribute('data-bm-type',renderer);}registerAnimation(animElements[i],animationData);}if(standalone&&lenAnims===0){if(!renderer){renderer='svg';}var body=document.getElementsByTagName('body')[0];body.innerText='';var div=createTag('div');div.style.width='100%';div.style.height='100%';div.setAttribute('data-bm-type',renderer);body.appendChild(div);registerAnimation(div,animationData);}}function resize(){var i;for(i=0;i<len;i+=1){registeredAnimations[i].animation.resize();}}function activate(){if(!_isFrozen&&playingAnimationsNum){if(_stopped){window.requestAnimationFrame(first);_stopped=false;}}}function freeze(){_isFrozen=true;}function unfreeze(){_isFrozen=false;activate();}function setVolume(val,animation){var i;for(i=0;i<len;i+=1){registeredAnimations[i].animation.setVolume(val,animation);}}function mute(animation){var i;for(i=0;i<len;i+=1){registeredAnimations[i].animation.mute(animation);}}function unmute(animation){var i;for(i=0;i<len;i+=1){registeredAnimations[i].animation.unmute(animation);}}moduleOb.registerAnimation=registerAnimation;moduleOb.loadAnimation=loadAnimation;moduleOb.setSpeed=setSpeed;moduleOb.setDirection=setDirection;moduleOb.play=play;moduleOb.pause=pause;moduleOb.stop=stop;moduleOb.togglePause=togglePause;moduleOb.searchAnimations=searchAnimations;moduleOb.resize=resize;// moduleOb.start = start;
	moduleOb.goToAndStop=goToAndStop;moduleOb.destroy=destroy;moduleOb.freeze=freeze;moduleOb.unfreeze=unfreeze;moduleOb.setVolume=setVolume;moduleOb.mute=mute;moduleOb.unmute=unmute;moduleOb.getRegisteredAnimations=getRegisteredAnimations;return moduleOb;}();/* eslint-disable */var BezierFactory=function(){/**
	       * BezierEasing - use bezier curve for transition easing function
	       * by Gaëtan Renaudeau 2014 - 2015 – MIT License
	       *
	       * Credits: is based on Firefox's nsSMILKeySpline.cpp
	       * Usage:
	       * var spline = BezierEasing([ 0.25, 0.1, 0.25, 1.0 ])
	       * spline.get(x) => returns the easing value | x must be in [0, 1] range
	       *
	       */var ob={};ob.getBezierEasing=getBezierEasing;var beziers={};function getBezierEasing(a,b,c,d,nm){var str=nm||('bez_'+a+'_'+b+'_'+c+'_'+d).replace(/\./g,'p');if(beziers[str]){return beziers[str];}var bezEasing=new BezierEasing([a,b,c,d]);beziers[str]=bezEasing;return bezEasing;}// These values are established by empiricism with tests (tradeoff: performance VS precision)
	var NEWTON_ITERATIONS=4;var NEWTON_MIN_SLOPE=0.001;var SUBDIVISION_PRECISION=0.0000001;var SUBDIVISION_MAX_ITERATIONS=10;var kSplineTableSize=11;var kSampleStepSize=1.0/(kSplineTableSize-1.0);var float32ArraySupported=typeof Float32Array==='function';function A(aA1,aA2){return 1.0-3.0*aA2+3.0*aA1;}function B(aA1,aA2){return 3.0*aA2-6.0*aA1;}function C(aA1){return 3.0*aA1;}// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
	function calcBezier(aT,aA1,aA2){return ((A(aA1,aA2)*aT+B(aA1,aA2))*aT+C(aA1))*aT;}// Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
	function getSlope(aT,aA1,aA2){return 3.0*A(aA1,aA2)*aT*aT+2.0*B(aA1,aA2)*aT+C(aA1);}function binarySubdivide(aX,aA,aB,mX1,mX2){var currentX,currentT,i=0;do{currentT=aA+(aB-aA)/2.0;currentX=calcBezier(currentT,mX1,mX2)-aX;if(currentX>0.0){aB=currentT;}else {aA=currentT;}}while(Math.abs(currentX)>SUBDIVISION_PRECISION&&++i<SUBDIVISION_MAX_ITERATIONS);return currentT;}function newtonRaphsonIterate(aX,aGuessT,mX1,mX2){for(var i=0;i<NEWTON_ITERATIONS;++i){var currentSlope=getSlope(aGuessT,mX1,mX2);if(currentSlope===0.0)return aGuessT;var currentX=calcBezier(aGuessT,mX1,mX2)-aX;aGuessT-=currentX/currentSlope;}return aGuessT;}/**
	       * points is an array of [ mX1, mY1, mX2, mY2 ]
	       */function BezierEasing(points){this._p=points;this._mSampleValues=float32ArraySupported?new Float32Array(kSplineTableSize):new Array(kSplineTableSize);this._precomputed=false;this.get=this.get.bind(this);}BezierEasing.prototype={get:function get(x){var mX1=this._p[0],mY1=this._p[1],mX2=this._p[2],mY2=this._p[3];if(!this._precomputed)this._precompute();if(mX1===mY1&&mX2===mY2)return x;// linear
	// Because JavaScript number are imprecise, we should guarantee the extremes are right.
	if(x===0)return 0;if(x===1)return 1;return calcBezier(this._getTForX(x),mY1,mY2);},// Private part
	_precompute:function _precompute(){var mX1=this._p[0],mY1=this._p[1],mX2=this._p[2],mY2=this._p[3];this._precomputed=true;if(mX1!==mY1||mX2!==mY2){this._calcSampleValues();}},_calcSampleValues:function _calcSampleValues(){var mX1=this._p[0],mX2=this._p[2];for(var i=0;i<kSplineTableSize;++i){this._mSampleValues[i]=calcBezier(i*kSampleStepSize,mX1,mX2);}},/**
	           * getTForX chose the fastest heuristic to determine the percentage value precisely from a given X projection.
	           */_getTForX:function _getTForX(aX){var mX1=this._p[0],mX2=this._p[2],mSampleValues=this._mSampleValues;var intervalStart=0.0;var currentSample=1;var lastSample=kSplineTableSize-1;for(;currentSample!==lastSample&&mSampleValues[currentSample]<=aX;++currentSample){intervalStart+=kSampleStepSize;}--currentSample;// Interpolate to provide an initial guess for t
	var dist=(aX-mSampleValues[currentSample])/(mSampleValues[currentSample+1]-mSampleValues[currentSample]);var guessForT=intervalStart+dist*kSampleStepSize;var initialSlope=getSlope(guessForT,mX1,mX2);if(initialSlope>=NEWTON_MIN_SLOPE){return newtonRaphsonIterate(aX,guessForT,mX1,mX2);}if(initialSlope===0.0){return guessForT;}return binarySubdivide(aX,intervalStart,intervalStart+kSampleStepSize,mX1,mX2);}};return ob;}();var pooling=function(){function _double(arr){return arr.concat(createSizedArray(arr.length));}return {"double":_double};}();var poolFactory=function(){return function(initialLength,_create,_release){var _length=0;var _maxLength=initialLength;var pool=createSizedArray(_maxLength);var ob={newElement:newElement,release:release};function newElement(){var element;if(_length){_length-=1;element=pool[_length];}else {element=_create();}return element;}function release(element){if(_length===_maxLength){pool=pooling["double"](pool);_maxLength*=2;}if(_release){_release(element);}pool[_length]=element;_length+=1;}return ob;};}();var bezierLengthPool=function(){function create(){return {addedLength:0,percents:createTypedArray('float32',getDefaultCurveSegments()),lengths:createTypedArray('float32',getDefaultCurveSegments())};}return poolFactory(8,create);}();var segmentsLengthPool=function(){function create(){return {lengths:[],totalLength:0};}function release(element){var i;var len=element.lengths.length;for(i=0;i<len;i+=1){bezierLengthPool.release(element.lengths[i]);}element.lengths.length=0;}return poolFactory(8,create,release);}();function bezFunction(){var math=Math;function pointOnLine2D(x1,y1,x2,y2,x3,y3){var det1=x1*y2+y1*x3+x2*y3-x3*y2-y3*x1-x2*y1;return det1>-0.001&&det1<0.001;}function pointOnLine3D(x1,y1,z1,x2,y2,z2,x3,y3,z3){if(z1===0&&z2===0&&z3===0){return pointOnLine2D(x1,y1,x2,y2,x3,y3);}var dist1=math.sqrt(math.pow(x2-x1,2)+math.pow(y2-y1,2)+math.pow(z2-z1,2));var dist2=math.sqrt(math.pow(x3-x1,2)+math.pow(y3-y1,2)+math.pow(z3-z1,2));var dist3=math.sqrt(math.pow(x3-x2,2)+math.pow(y3-y2,2)+math.pow(z3-z2,2));var diffDist;if(dist1>dist2){if(dist1>dist3){diffDist=dist1-dist2-dist3;}else {diffDist=dist3-dist2-dist1;}}else if(dist3>dist2){diffDist=dist3-dist2-dist1;}else {diffDist=dist2-dist1-dist3;}return diffDist>-0.0001&&diffDist<0.0001;}var getBezierLength=function(){return function(pt1,pt2,pt3,pt4){var curveSegments=getDefaultCurveSegments();var k;var i;var len;var ptCoord;var perc;var addedLength=0;var ptDistance;var point=[];var lastPoint=[];var lengthData=bezierLengthPool.newElement();len=pt3.length;for(k=0;k<curveSegments;k+=1){perc=k/(curveSegments-1);ptDistance=0;for(i=0;i<len;i+=1){ptCoord=bmPow(1-perc,3)*pt1[i]+3*bmPow(1-perc,2)*perc*pt3[i]+3*(1-perc)*bmPow(perc,2)*pt4[i]+bmPow(perc,3)*pt2[i];point[i]=ptCoord;if(lastPoint[i]!==null){ptDistance+=bmPow(point[i]-lastPoint[i],2);}lastPoint[i]=point[i];}if(ptDistance){ptDistance=bmSqrt(ptDistance);addedLength+=ptDistance;}lengthData.percents[k]=perc;lengthData.lengths[k]=addedLength;}lengthData.addedLength=addedLength;return lengthData;};}();function getSegmentsLength(shapeData){var segmentsLength=segmentsLengthPool.newElement();var closed=shapeData.c;var pathV=shapeData.v;var pathO=shapeData.o;var pathI=shapeData.i;var i;var len=shapeData._length;var lengths=segmentsLength.lengths;var totalLength=0;for(i=0;i<len-1;i+=1){lengths[i]=getBezierLength(pathV[i],pathV[i+1],pathO[i],pathI[i+1]);totalLength+=lengths[i].addedLength;}if(closed&&len){lengths[i]=getBezierLength(pathV[i],pathV[0],pathO[i],pathI[0]);totalLength+=lengths[i].addedLength;}segmentsLength.totalLength=totalLength;return segmentsLength;}function BezierData(length){this.segmentLength=0;this.points=new Array(length);}function PointData(partial,point){this.partialLength=partial;this.point=point;}var buildBezierData=function(){var storedData={};return function(pt1,pt2,pt3,pt4){var bezierName=(pt1[0]+'_'+pt1[1]+'_'+pt2[0]+'_'+pt2[1]+'_'+pt3[0]+'_'+pt3[1]+'_'+pt4[0]+'_'+pt4[1]).replace(/\./g,'p');if(!storedData[bezierName]){var curveSegments=getDefaultCurveSegments();var k;var i;var len;var ptCoord;var perc;var addedLength=0;var ptDistance;var point;var lastPoint=null;if(pt1.length===2&&(pt1[0]!==pt2[0]||pt1[1]!==pt2[1])&&pointOnLine2D(pt1[0],pt1[1],pt2[0],pt2[1],pt1[0]+pt3[0],pt1[1]+pt3[1])&&pointOnLine2D(pt1[0],pt1[1],pt2[0],pt2[1],pt2[0]+pt4[0],pt2[1]+pt4[1])){curveSegments=2;}var bezierData=new BezierData(curveSegments);len=pt3.length;for(k=0;k<curveSegments;k+=1){point=createSizedArray(len);perc=k/(curveSegments-1);ptDistance=0;for(i=0;i<len;i+=1){ptCoord=bmPow(1-perc,3)*pt1[i]+3*bmPow(1-perc,2)*perc*(pt1[i]+pt3[i])+3*(1-perc)*bmPow(perc,2)*(pt2[i]+pt4[i])+bmPow(perc,3)*pt2[i];point[i]=ptCoord;if(lastPoint!==null){ptDistance+=bmPow(point[i]-lastPoint[i],2);}}ptDistance=bmSqrt(ptDistance);addedLength+=ptDistance;bezierData.points[k]=new PointData(ptDistance,point);lastPoint=point;}bezierData.segmentLength=addedLength;storedData[bezierName]=bezierData;}return storedData[bezierName];};}();function getDistancePerc(perc,bezierData){var percents=bezierData.percents;var lengths=bezierData.lengths;var len=percents.length;var initPos=bmFloor((len-1)*perc);var lengthPos=perc*bezierData.addedLength;var lPerc=0;if(initPos===len-1||initPos===0||lengthPos===lengths[initPos]){return percents[initPos];}var dir=lengths[initPos]>lengthPos?-1:1;var flag=true;while(flag){if(lengths[initPos]<=lengthPos&&lengths[initPos+1]>lengthPos){lPerc=(lengthPos-lengths[initPos])/(lengths[initPos+1]-lengths[initPos]);flag=false;}else {initPos+=dir;}if(initPos<0||initPos>=len-1){// FIX for TypedArrays that don't store floating point values with enough accuracy
	if(initPos===len-1){return percents[initPos];}flag=false;}}return percents[initPos]+(percents[initPos+1]-percents[initPos])*lPerc;}function getPointInSegment(pt1,pt2,pt3,pt4,percent,bezierData){var t1=getDistancePerc(percent,bezierData);var u1=1-t1;var ptX=math.round((u1*u1*u1*pt1[0]+(t1*u1*u1+u1*t1*u1+u1*u1*t1)*pt3[0]+(t1*t1*u1+u1*t1*t1+t1*u1*t1)*pt4[0]+t1*t1*t1*pt2[0])*1000)/1000;var ptY=math.round((u1*u1*u1*pt1[1]+(t1*u1*u1+u1*t1*u1+u1*u1*t1)*pt3[1]+(t1*t1*u1+u1*t1*t1+t1*u1*t1)*pt4[1]+t1*t1*t1*pt2[1])*1000)/1000;return [ptX,ptY];}var bezierSegmentPoints=createTypedArray('float32',8);function getNewSegment(pt1,pt2,pt3,pt4,startPerc,endPerc,bezierData){if(startPerc<0){startPerc=0;}else if(startPerc>1){startPerc=1;}var t0=getDistancePerc(startPerc,bezierData);endPerc=endPerc>1?1:endPerc;var t1=getDistancePerc(endPerc,bezierData);var i;var len=pt1.length;var u0=1-t0;var u1=1-t1;var u0u0u0=u0*u0*u0;var t0u0u0_3=t0*u0*u0*3;// eslint-disable-line camelcase
	var t0t0u0_3=t0*t0*u0*3;// eslint-disable-line camelcase
	var t0t0t0=t0*t0*t0;//
	var u0u0u1=u0*u0*u1;var t0u0u1_3=t0*u0*u1+u0*t0*u1+u0*u0*t1;// eslint-disable-line camelcase
	var t0t0u1_3=t0*t0*u1+u0*t0*t1+t0*u0*t1;// eslint-disable-line camelcase
	var t0t0t1=t0*t0*t1;//
	var u0u1u1=u0*u1*u1;var t0u1u1_3=t0*u1*u1+u0*t1*u1+u0*u1*t1;// eslint-disable-line camelcase
	var t0t1u1_3=t0*t1*u1+u0*t1*t1+t0*u1*t1;// eslint-disable-line camelcase
	var t0t1t1=t0*t1*t1;//
	var u1u1u1=u1*u1*u1;var t1u1u1_3=t1*u1*u1+u1*t1*u1+u1*u1*t1;// eslint-disable-line camelcase
	var t1t1u1_3=t1*t1*u1+u1*t1*t1+t1*u1*t1;// eslint-disable-line camelcase
	var t1t1t1=t1*t1*t1;for(i=0;i<len;i+=1){bezierSegmentPoints[i*4]=math.round((u0u0u0*pt1[i]+t0u0u0_3*pt3[i]+t0t0u0_3*pt4[i]+t0t0t0*pt2[i])*1000)/1000;// eslint-disable-line camelcase
	bezierSegmentPoints[i*4+1]=math.round((u0u0u1*pt1[i]+t0u0u1_3*pt3[i]+t0t0u1_3*pt4[i]+t0t0t1*pt2[i])*1000)/1000;// eslint-disable-line camelcase
	bezierSegmentPoints[i*4+2]=math.round((u0u1u1*pt1[i]+t0u1u1_3*pt3[i]+t0t1u1_3*pt4[i]+t0t1t1*pt2[i])*1000)/1000;// eslint-disable-line camelcase
	bezierSegmentPoints[i*4+3]=math.round((u1u1u1*pt1[i]+t1u1u1_3*pt3[i]+t1t1u1_3*pt4[i]+t1t1t1*pt2[i])*1000)/1000;// eslint-disable-line camelcase
	}return bezierSegmentPoints;}return {getSegmentsLength:getSegmentsLength,getNewSegment:getNewSegment,getPointInSegment:getPointInSegment,buildBezierData:buildBezierData,pointOnLine2D:pointOnLine2D,pointOnLine3D:pointOnLine3D};}var bez=bezFunction();var initFrame=initialDefaultFrame;var mathAbs=Math.abs;function interpolateValue(frameNum,caching){var offsetTime=this.offsetTime;var newValue;if(this.propType==='multidimensional'){newValue=createTypedArray('float32',this.pv.length);}var iterationIndex=caching.lastIndex;var i=iterationIndex;var len=this.keyframes.length-1;var flag=true;var keyData;var nextKeyData;var keyframeMetadata;while(flag){keyData=this.keyframes[i];nextKeyData=this.keyframes[i+1];if(i===len-1&&frameNum>=nextKeyData.t-offsetTime){if(keyData.h){keyData=nextKeyData;}iterationIndex=0;break;}if(nextKeyData.t-offsetTime>frameNum){iterationIndex=i;break;}if(i<len-1){i+=1;}else {iterationIndex=0;flag=false;}}keyframeMetadata=this.keyframesMetadata[i]||{};var k;var kLen;var perc;var jLen;var j;var fnc;var nextKeyTime=nextKeyData.t-offsetTime;var keyTime=keyData.t-offsetTime;var endValue;if(keyData.to){if(!keyframeMetadata.bezierData){keyframeMetadata.bezierData=bez.buildBezierData(keyData.s,nextKeyData.s||keyData.e,keyData.to,keyData.ti);}var bezierData=keyframeMetadata.bezierData;if(frameNum>=nextKeyTime||frameNum<keyTime){var ind=frameNum>=nextKeyTime?bezierData.points.length-1:0;kLen=bezierData.points[ind].point.length;for(k=0;k<kLen;k+=1){newValue[k]=bezierData.points[ind].point[k];}// caching._lastKeyframeIndex = -1;
	}else {if(keyframeMetadata.__fnct){fnc=keyframeMetadata.__fnct;}else {fnc=BezierFactory.getBezierEasing(keyData.o.x,keyData.o.y,keyData.i.x,keyData.i.y,keyData.n).get;keyframeMetadata.__fnct=fnc;}perc=fnc((frameNum-keyTime)/(nextKeyTime-keyTime));var distanceInLine=bezierData.segmentLength*perc;var segmentPerc;var addedLength=caching.lastFrame<frameNum&&caching._lastKeyframeIndex===i?caching._lastAddedLength:0;j=caching.lastFrame<frameNum&&caching._lastKeyframeIndex===i?caching._lastPoint:0;flag=true;jLen=bezierData.points.length;while(flag){addedLength+=bezierData.points[j].partialLength;if(distanceInLine===0||perc===0||j===bezierData.points.length-1){kLen=bezierData.points[j].point.length;for(k=0;k<kLen;k+=1){newValue[k]=bezierData.points[j].point[k];}break;}else if(distanceInLine>=addedLength&&distanceInLine<addedLength+bezierData.points[j+1].partialLength){segmentPerc=(distanceInLine-addedLength)/bezierData.points[j+1].partialLength;kLen=bezierData.points[j].point.length;for(k=0;k<kLen;k+=1){newValue[k]=bezierData.points[j].point[k]+(bezierData.points[j+1].point[k]-bezierData.points[j].point[k])*segmentPerc;}break;}if(j<jLen-1){j+=1;}else {flag=false;}}caching._lastPoint=j;caching._lastAddedLength=addedLength-bezierData.points[j].partialLength;caching._lastKeyframeIndex=i;}}else {var outX;var outY;var inX;var inY;var keyValue;len=keyData.s.length;endValue=nextKeyData.s||keyData.e;if(this.sh&&keyData.h!==1){if(frameNum>=nextKeyTime){newValue[0]=endValue[0];newValue[1]=endValue[1];newValue[2]=endValue[2];}else if(frameNum<=keyTime){newValue[0]=keyData.s[0];newValue[1]=keyData.s[1];newValue[2]=keyData.s[2];}else {var quatStart=createQuaternion(keyData.s);var quatEnd=createQuaternion(endValue);var time=(frameNum-keyTime)/(nextKeyTime-keyTime);quaternionToEuler(newValue,slerp(quatStart,quatEnd,time));}}else {for(i=0;i<len;i+=1){if(keyData.h!==1){if(frameNum>=nextKeyTime){perc=1;}else if(frameNum<keyTime){perc=0;}else {if(keyData.o.x.constructor===Array){if(!keyframeMetadata.__fnct){keyframeMetadata.__fnct=[];}if(!keyframeMetadata.__fnct[i]){outX=keyData.o.x[i]===undefined?keyData.o.x[0]:keyData.o.x[i];outY=keyData.o.y[i]===undefined?keyData.o.y[0]:keyData.o.y[i];inX=keyData.i.x[i]===undefined?keyData.i.x[0]:keyData.i.x[i];inY=keyData.i.y[i]===undefined?keyData.i.y[0]:keyData.i.y[i];fnc=BezierFactory.getBezierEasing(outX,outY,inX,inY).get;keyframeMetadata.__fnct[i]=fnc;}else {fnc=keyframeMetadata.__fnct[i];}}else if(!keyframeMetadata.__fnct){outX=keyData.o.x;outY=keyData.o.y;inX=keyData.i.x;inY=keyData.i.y;fnc=BezierFactory.getBezierEasing(outX,outY,inX,inY).get;keyData.keyframeMetadata=fnc;}else {fnc=keyframeMetadata.__fnct;}perc=fnc((frameNum-keyTime)/(nextKeyTime-keyTime));}}endValue=nextKeyData.s||keyData.e;keyValue=keyData.h===1?keyData.s[i]:keyData.s[i]+(endValue[i]-keyData.s[i])*perc;if(this.propType==='multidimensional'){newValue[i]=keyValue;}else {newValue=keyValue;}}}}caching.lastIndex=iterationIndex;return newValue;}// based on @Toji's https://github.com/toji/gl-matrix/
	function slerp(a,b,t){var out=[];var ax=a[0];var ay=a[1];var az=a[2];var aw=a[3];var bx=b[0];var by=b[1];var bz=b[2];var bw=b[3];var omega;var cosom;var sinom;var scale0;var scale1;cosom=ax*bx+ay*by+az*bz+aw*bw;if(cosom<0.0){cosom=-cosom;bx=-bx;by=-by;bz=-bz;bw=-bw;}if(1.0-cosom>0.000001){omega=Math.acos(cosom);sinom=Math.sin(omega);scale0=Math.sin((1.0-t)*omega)/sinom;scale1=Math.sin(t*omega)/sinom;}else {scale0=1.0-t;scale1=t;}out[0]=scale0*ax+scale1*bx;out[1]=scale0*ay+scale1*by;out[2]=scale0*az+scale1*bz;out[3]=scale0*aw+scale1*bw;return out;}function quaternionToEuler(out,quat){var qx=quat[0];var qy=quat[1];var qz=quat[2];var qw=quat[3];var heading=Math.atan2(2*qy*qw-2*qx*qz,1-2*qy*qy-2*qz*qz);var attitude=Math.asin(2*qx*qy+2*qz*qw);var bank=Math.atan2(2*qx*qw-2*qy*qz,1-2*qx*qx-2*qz*qz);out[0]=heading/degToRads;out[1]=attitude/degToRads;out[2]=bank/degToRads;}function createQuaternion(values){var heading=values[0]*degToRads;var attitude=values[1]*degToRads;var bank=values[2]*degToRads;var c1=Math.cos(heading/2);var c2=Math.cos(attitude/2);var c3=Math.cos(bank/2);var s1=Math.sin(heading/2);var s2=Math.sin(attitude/2);var s3=Math.sin(bank/2);var w=c1*c2*c3-s1*s2*s3;var x=s1*s2*c3+c1*c2*s3;var y=s1*c2*c3+c1*s2*s3;var z=c1*s2*c3-s1*c2*s3;return [x,y,z,w];}function getValueAtCurrentTime(){var frameNum=this.comp.renderedFrame-this.offsetTime;var initTime=this.keyframes[0].t-this.offsetTime;var endTime=this.keyframes[this.keyframes.length-1].t-this.offsetTime;if(!(frameNum===this._caching.lastFrame||this._caching.lastFrame!==initFrame&&(this._caching.lastFrame>=endTime&&frameNum>=endTime||this._caching.lastFrame<initTime&&frameNum<initTime))){if(this._caching.lastFrame>=frameNum){this._caching._lastKeyframeIndex=-1;this._caching.lastIndex=0;}var renderResult=this.interpolateValue(frameNum,this._caching);this.pv=renderResult;}this._caching.lastFrame=frameNum;return this.pv;}function setVValue(val){var multipliedValue;if(this.propType==='unidimensional'){multipliedValue=val*this.mult;if(mathAbs(this.v-multipliedValue)>0.00001){this.v=multipliedValue;this._mdf=true;}}else {var i=0;var len=this.v.length;while(i<len){multipliedValue=val[i]*this.mult;if(mathAbs(this.v[i]-multipliedValue)>0.00001){this.v[i]=multipliedValue;this._mdf=true;}i+=1;}}}function processEffectsSequence(){if(this.elem.globalData.frameId===this.frameId||!this.effectsSequence.length){return;}if(this.lock){this.setVValue(this.pv);return;}this.lock=true;this._mdf=this._isFirstFrame;var i;var len=this.effectsSequence.length;var finalValue=this.kf?this.pv:this.data.k;for(i=0;i<len;i+=1){finalValue=this.effectsSequence[i](finalValue);}this.setVValue(finalValue);this._isFirstFrame=false;this.lock=false;this.frameId=this.elem.globalData.frameId;}function addEffect(effectFunction){this.effectsSequence.push(effectFunction);this.container.addDynamicProperty(this);}function ValueProperty(elem,data,mult,container){this.propType='unidimensional';this.mult=mult||1;this.data=data;this.v=mult?data.k*mult:data.k;this.pv=data.k;this._mdf=false;this.elem=elem;this.container=container;this.comp=elem.comp;this.k=false;this.kf=false;this.vel=0;this.effectsSequence=[];this._isFirstFrame=true;this.getValue=processEffectsSequence;this.setVValue=setVValue;this.addEffect=addEffect;}function MultiDimensionalProperty(elem,data,mult,container){this.propType='multidimensional';this.mult=mult||1;this.data=data;this._mdf=false;this.elem=elem;this.container=container;this.comp=elem.comp;this.k=false;this.kf=false;this.frameId=-1;var i;var len=data.k.length;this.v=createTypedArray('float32',len);this.pv=createTypedArray('float32',len);this.vel=createTypedArray('float32',len);for(i=0;i<len;i+=1){this.v[i]=data.k[i]*this.mult;this.pv[i]=data.k[i];}this._isFirstFrame=true;this.effectsSequence=[];this.getValue=processEffectsSequence;this.setVValue=setVValue;this.addEffect=addEffect;}function KeyframedValueProperty(elem,data,mult,container){this.propType='unidimensional';this.keyframes=data.k;this.keyframesMetadata=[];this.offsetTime=elem.data.st;this.frameId=-1;this._caching={lastFrame:initFrame,lastIndex:0,value:0,_lastKeyframeIndex:-1};this.k=true;this.kf=true;this.data=data;this.mult=mult||1;this.elem=elem;this.container=container;this.comp=elem.comp;this.v=initFrame;this.pv=initFrame;this._isFirstFrame=true;this.getValue=processEffectsSequence;this.setVValue=setVValue;this.interpolateValue=interpolateValue;this.effectsSequence=[getValueAtCurrentTime.bind(this)];this.addEffect=addEffect;}function KeyframedMultidimensionalProperty(elem,data,mult,container){this.propType='multidimensional';var i;var len=data.k.length;var s;var e;var to;var ti;for(i=0;i<len-1;i+=1){if(data.k[i].to&&data.k[i].s&&data.k[i+1]&&data.k[i+1].s){s=data.k[i].s;e=data.k[i+1].s;to=data.k[i].to;ti=data.k[i].ti;if(s.length===2&&!(s[0]===e[0]&&s[1]===e[1])&&bez.pointOnLine2D(s[0],s[1],e[0],e[1],s[0]+to[0],s[1]+to[1])&&bez.pointOnLine2D(s[0],s[1],e[0],e[1],e[0]+ti[0],e[1]+ti[1])||s.length===3&&!(s[0]===e[0]&&s[1]===e[1]&&s[2]===e[2])&&bez.pointOnLine3D(s[0],s[1],s[2],e[0],e[1],e[2],s[0]+to[0],s[1]+to[1],s[2]+to[2])&&bez.pointOnLine3D(s[0],s[1],s[2],e[0],e[1],e[2],e[0]+ti[0],e[1]+ti[1],e[2]+ti[2])){data.k[i].to=null;data.k[i].ti=null;}if(s[0]===e[0]&&s[1]===e[1]&&to[0]===0&&to[1]===0&&ti[0]===0&&ti[1]===0){if(s.length===2||s[2]===e[2]&&to[2]===0&&ti[2]===0){data.k[i].to=null;data.k[i].ti=null;}}}}this.effectsSequence=[getValueAtCurrentTime.bind(this)];this.data=data;this.keyframes=data.k;this.keyframesMetadata=[];this.offsetTime=elem.data.st;this.k=true;this.kf=true;this._isFirstFrame=true;this.mult=mult||1;this.elem=elem;this.container=container;this.comp=elem.comp;this.getValue=processEffectsSequence;this.setVValue=setVValue;this.interpolateValue=interpolateValue;this.frameId=-1;var arrLen=data.k[0].s.length;this.v=createTypedArray('float32',arrLen);this.pv=createTypedArray('float32',arrLen);for(i=0;i<arrLen;i+=1){this.v[i]=initFrame;this.pv[i]=initFrame;}this._caching={lastFrame:initFrame,lastIndex:0,value:createTypedArray('float32',arrLen)};this.addEffect=addEffect;}var PropertyFactory=function(){function getProp(elem,data,type,mult,container){if(data.sid){data=elem.globalData.slotManager.getProp(data);}var p;if(!data.k.length){p=new ValueProperty(elem,data,mult,container);}else if(typeof data.k[0]==='number'){p=new MultiDimensionalProperty(elem,data,mult,container);}else {switch(type){case 0:p=new KeyframedValueProperty(elem,data,mult,container);break;case 1:p=new KeyframedMultidimensionalProperty(elem,data,mult,container);break;}}if(p.effectsSequence.length){container.addDynamicProperty(p);}return p;}var ob={getProp:getProp};return ob;}();function DynamicPropertyContainer(){}DynamicPropertyContainer.prototype={addDynamicProperty:function addDynamicProperty(prop){if(this.dynamicProperties.indexOf(prop)===-1){this.dynamicProperties.push(prop);this.container.addDynamicProperty(this);this._isAnimated=true;}},iterateDynamicProperties:function iterateDynamicProperties(){this._mdf=false;var i;var len=this.dynamicProperties.length;for(i=0;i<len;i+=1){this.dynamicProperties[i].getValue();if(this.dynamicProperties[i]._mdf){this._mdf=true;}}},initDynamicPropertyContainer:function initDynamicPropertyContainer(container){this.container=container;this.dynamicProperties=[];this._mdf=false;this._isAnimated=false;}};var pointPool=function(){function create(){return createTypedArray('float32',2);}return poolFactory(8,create);}();function ShapePath(){this.c=false;this._length=0;this._maxLength=8;this.v=createSizedArray(this._maxLength);this.o=createSizedArray(this._maxLength);this.i=createSizedArray(this._maxLength);}ShapePath.prototype.setPathData=function(closed,len){this.c=closed;this.setLength(len);var i=0;while(i<len){this.v[i]=pointPool.newElement();this.o[i]=pointPool.newElement();this.i[i]=pointPool.newElement();i+=1;}};ShapePath.prototype.setLength=function(len){while(this._maxLength<len){this.doubleArrayLength();}this._length=len;};ShapePath.prototype.doubleArrayLength=function(){this.v=this.v.concat(createSizedArray(this._maxLength));this.i=this.i.concat(createSizedArray(this._maxLength));this.o=this.o.concat(createSizedArray(this._maxLength));this._maxLength*=2;};ShapePath.prototype.setXYAt=function(x,y,type,pos,replace){var arr;this._length=Math.max(this._length,pos+1);if(this._length>=this._maxLength){this.doubleArrayLength();}switch(type){case'v':arr=this.v;break;case'i':arr=this.i;break;case'o':arr=this.o;break;default:arr=[];break;}if(!arr[pos]||arr[pos]&&!replace){arr[pos]=pointPool.newElement();}arr[pos][0]=x;arr[pos][1]=y;};ShapePath.prototype.setTripleAt=function(vX,vY,oX,oY,iX,iY,pos,replace){this.setXYAt(vX,vY,'v',pos,replace);this.setXYAt(oX,oY,'o',pos,replace);this.setXYAt(iX,iY,'i',pos,replace);};ShapePath.prototype.reverse=function(){var newPath=new ShapePath();newPath.setPathData(this.c,this._length);var vertices=this.v;var outPoints=this.o;var inPoints=this.i;var init=0;if(this.c){newPath.setTripleAt(vertices[0][0],vertices[0][1],inPoints[0][0],inPoints[0][1],outPoints[0][0],outPoints[0][1],0,false);init=1;}var cnt=this._length-1;var len=this._length;var i;for(i=init;i<len;i+=1){newPath.setTripleAt(vertices[cnt][0],vertices[cnt][1],inPoints[cnt][0],inPoints[cnt][1],outPoints[cnt][0],outPoints[cnt][1],i,false);cnt-=1;}return newPath;};ShapePath.prototype.length=function(){return this._length;};var shapePool=function(){function create(){return new ShapePath();}function release(shapePath){var len=shapePath._length;var i;for(i=0;i<len;i+=1){pointPool.release(shapePath.v[i]);pointPool.release(shapePath.i[i]);pointPool.release(shapePath.o[i]);shapePath.v[i]=null;shapePath.i[i]=null;shapePath.o[i]=null;}shapePath._length=0;shapePath.c=false;}function clone(shape){var cloned=factory.newElement();var i;var len=shape._length===undefined?shape.v.length:shape._length;cloned.setLength(len);cloned.c=shape.c;for(i=0;i<len;i+=1){cloned.setTripleAt(shape.v[i][0],shape.v[i][1],shape.o[i][0],shape.o[i][1],shape.i[i][0],shape.i[i][1],i);}return cloned;}var factory=poolFactory(4,create,release);factory.clone=clone;return factory;}();function ShapeCollection(){this._length=0;this._maxLength=4;this.shapes=createSizedArray(this._maxLength);}ShapeCollection.prototype.addShape=function(shapeData){if(this._length===this._maxLength){this.shapes=this.shapes.concat(createSizedArray(this._maxLength));this._maxLength*=2;}this.shapes[this._length]=shapeData;this._length+=1;};ShapeCollection.prototype.releaseShapes=function(){var i;for(i=0;i<this._length;i+=1){shapePool.release(this.shapes[i]);}this._length=0;};var shapeCollectionPool=function(){var ob={newShapeCollection:newShapeCollection,release:release};var _length=0;var _maxLength=4;var pool=createSizedArray(_maxLength);function newShapeCollection(){var shapeCollection;if(_length){_length-=1;shapeCollection=pool[_length];}else {shapeCollection=new ShapeCollection();}return shapeCollection;}function release(shapeCollection){var i;var len=shapeCollection._length;for(i=0;i<len;i+=1){shapePool.release(shapeCollection.shapes[i]);}shapeCollection._length=0;if(_length===_maxLength){pool=pooling["double"](pool);_maxLength*=2;}pool[_length]=shapeCollection;_length+=1;}return ob;}();var ShapePropertyFactory=function(){var initFrame=-999999;function interpolateShape(frameNum,previousValue,caching){var iterationIndex=caching.lastIndex;var keyPropS;var keyPropE;var isHold;var j;var k;var jLen;var kLen;var perc;var vertexValue;var kf=this.keyframes;if(frameNum<kf[0].t-this.offsetTime){keyPropS=kf[0].s[0];isHold=true;iterationIndex=0;}else if(frameNum>=kf[kf.length-1].t-this.offsetTime){keyPropS=kf[kf.length-1].s?kf[kf.length-1].s[0]:kf[kf.length-2].e[0];/* if(kf[kf.length - 1].s){
	                  keyPropS = kf[kf.length - 1].s[0];
	              }else{
	                  keyPropS = kf[kf.length - 2].e[0];
	              } */isHold=true;}else {var i=iterationIndex;var len=kf.length-1;var flag=true;var keyData;var nextKeyData;var keyframeMetadata;while(flag){keyData=kf[i];nextKeyData=kf[i+1];if(nextKeyData.t-this.offsetTime>frameNum){break;}if(i<len-1){i+=1;}else {flag=false;}}keyframeMetadata=this.keyframesMetadata[i]||{};isHold=keyData.h===1;iterationIndex=i;if(!isHold){if(frameNum>=nextKeyData.t-this.offsetTime){perc=1;}else if(frameNum<keyData.t-this.offsetTime){perc=0;}else {var fnc;if(keyframeMetadata.__fnct){fnc=keyframeMetadata.__fnct;}else {fnc=BezierFactory.getBezierEasing(keyData.o.x,keyData.o.y,keyData.i.x,keyData.i.y).get;keyframeMetadata.__fnct=fnc;}perc=fnc((frameNum-(keyData.t-this.offsetTime))/(nextKeyData.t-this.offsetTime-(keyData.t-this.offsetTime)));}keyPropE=nextKeyData.s?nextKeyData.s[0]:keyData.e[0];}keyPropS=keyData.s[0];}jLen=previousValue._length;kLen=keyPropS.i[0].length;caching.lastIndex=iterationIndex;for(j=0;j<jLen;j+=1){for(k=0;k<kLen;k+=1){vertexValue=isHold?keyPropS.i[j][k]:keyPropS.i[j][k]+(keyPropE.i[j][k]-keyPropS.i[j][k])*perc;previousValue.i[j][k]=vertexValue;vertexValue=isHold?keyPropS.o[j][k]:keyPropS.o[j][k]+(keyPropE.o[j][k]-keyPropS.o[j][k])*perc;previousValue.o[j][k]=vertexValue;vertexValue=isHold?keyPropS.v[j][k]:keyPropS.v[j][k]+(keyPropE.v[j][k]-keyPropS.v[j][k])*perc;previousValue.v[j][k]=vertexValue;}}}function interpolateShapeCurrentTime(){var frameNum=this.comp.renderedFrame-this.offsetTime;var initTime=this.keyframes[0].t-this.offsetTime;var endTime=this.keyframes[this.keyframes.length-1].t-this.offsetTime;var lastFrame=this._caching.lastFrame;if(!(lastFrame!==initFrame&&(lastFrame<initTime&&frameNum<initTime||lastFrame>endTime&&frameNum>endTime))){/// /
	this._caching.lastIndex=lastFrame<frameNum?this._caching.lastIndex:0;this.interpolateShape(frameNum,this.pv,this._caching);/// /
	}this._caching.lastFrame=frameNum;return this.pv;}function resetShape(){this.paths=this.localShapeCollection;}function shapesEqual(shape1,shape2){if(shape1._length!==shape2._length||shape1.c!==shape2.c){return false;}var i;var len=shape1._length;for(i=0;i<len;i+=1){if(shape1.v[i][0]!==shape2.v[i][0]||shape1.v[i][1]!==shape2.v[i][1]||shape1.o[i][0]!==shape2.o[i][0]||shape1.o[i][1]!==shape2.o[i][1]||shape1.i[i][0]!==shape2.i[i][0]||shape1.i[i][1]!==shape2.i[i][1]){return false;}}return true;}function setVValue(newPath){if(!shapesEqual(this.v,newPath)){this.v=shapePool.clone(newPath);this.localShapeCollection.releaseShapes();this.localShapeCollection.addShape(this.v);this._mdf=true;this.paths=this.localShapeCollection;}}function processEffectsSequence(){if(this.elem.globalData.frameId===this.frameId){return;}if(!this.effectsSequence.length){this._mdf=false;return;}if(this.lock){this.setVValue(this.pv);return;}this.lock=true;this._mdf=false;var finalValue;if(this.kf){finalValue=this.pv;}else if(this.data.ks){finalValue=this.data.ks.k;}else {finalValue=this.data.pt.k;}var i;var len=this.effectsSequence.length;for(i=0;i<len;i+=1){finalValue=this.effectsSequence[i](finalValue);}this.setVValue(finalValue);this.lock=false;this.frameId=this.elem.globalData.frameId;}function ShapeProperty(elem,data,type){this.propType='shape';this.comp=elem.comp;this.container=elem;this.elem=elem;this.data=data;this.k=false;this.kf=false;this._mdf=false;var pathData=type===3?data.pt.k:data.ks.k;this.v=shapePool.clone(pathData);this.pv=shapePool.clone(this.v);this.localShapeCollection=shapeCollectionPool.newShapeCollection();this.paths=this.localShapeCollection;this.paths.addShape(this.v);this.reset=resetShape;this.effectsSequence=[];}function addEffect(effectFunction){this.effectsSequence.push(effectFunction);this.container.addDynamicProperty(this);}ShapeProperty.prototype.interpolateShape=interpolateShape;ShapeProperty.prototype.getValue=processEffectsSequence;ShapeProperty.prototype.setVValue=setVValue;ShapeProperty.prototype.addEffect=addEffect;function KeyframedShapeProperty(elem,data,type){this.propType='shape';this.comp=elem.comp;this.elem=elem;this.container=elem;this.offsetTime=elem.data.st;this.keyframes=type===3?data.pt.k:data.ks.k;this.keyframesMetadata=[];this.k=true;this.kf=true;var len=this.keyframes[0].s[0].i.length;this.v=shapePool.newElement();this.v.setPathData(this.keyframes[0].s[0].c,len);this.pv=shapePool.clone(this.v);this.localShapeCollection=shapeCollectionPool.newShapeCollection();this.paths=this.localShapeCollection;this.paths.addShape(this.v);this.lastFrame=initFrame;this.reset=resetShape;this._caching={lastFrame:initFrame,lastIndex:0};this.effectsSequence=[interpolateShapeCurrentTime.bind(this)];}KeyframedShapeProperty.prototype.getValue=processEffectsSequence;KeyframedShapeProperty.prototype.interpolateShape=interpolateShape;KeyframedShapeProperty.prototype.setVValue=setVValue;KeyframedShapeProperty.prototype.addEffect=addEffect;var EllShapeProperty=function(){var cPoint=roundCorner;function EllShapePropertyFactory(elem,data){this.v=shapePool.newElement();this.v.setPathData(true,4);this.localShapeCollection=shapeCollectionPool.newShapeCollection();this.paths=this.localShapeCollection;this.localShapeCollection.addShape(this.v);this.d=data.d;this.elem=elem;this.comp=elem.comp;this.frameId=-1;this.initDynamicPropertyContainer(elem);this.p=PropertyFactory.getProp(elem,data.p,1,0,this);this.s=PropertyFactory.getProp(elem,data.s,1,0,this);if(this.dynamicProperties.length){this.k=true;}else {this.k=false;this.convertEllToPath();}}EllShapePropertyFactory.prototype={reset:resetShape,getValue:function getValue(){if(this.elem.globalData.frameId===this.frameId){return;}this.frameId=this.elem.globalData.frameId;this.iterateDynamicProperties();if(this._mdf){this.convertEllToPath();}},convertEllToPath:function convertEllToPath(){var p0=this.p.v[0];var p1=this.p.v[1];var s0=this.s.v[0]/2;var s1=this.s.v[1]/2;var _cw=this.d!==3;var _v=this.v;_v.v[0][0]=p0;_v.v[0][1]=p1-s1;_v.v[1][0]=_cw?p0+s0:p0-s0;_v.v[1][1]=p1;_v.v[2][0]=p0;_v.v[2][1]=p1+s1;_v.v[3][0]=_cw?p0-s0:p0+s0;_v.v[3][1]=p1;_v.i[0][0]=_cw?p0-s0*cPoint:p0+s0*cPoint;_v.i[0][1]=p1-s1;_v.i[1][0]=_cw?p0+s0:p0-s0;_v.i[1][1]=p1-s1*cPoint;_v.i[2][0]=_cw?p0+s0*cPoint:p0-s0*cPoint;_v.i[2][1]=p1+s1;_v.i[3][0]=_cw?p0-s0:p0+s0;_v.i[3][1]=p1+s1*cPoint;_v.o[0][0]=_cw?p0+s0*cPoint:p0-s0*cPoint;_v.o[0][1]=p1-s1;_v.o[1][0]=_cw?p0+s0:p0-s0;_v.o[1][1]=p1+s1*cPoint;_v.o[2][0]=_cw?p0-s0*cPoint:p0+s0*cPoint;_v.o[2][1]=p1+s1;_v.o[3][0]=_cw?p0-s0:p0+s0;_v.o[3][1]=p1-s1*cPoint;}};extendPrototype([DynamicPropertyContainer],EllShapePropertyFactory);return EllShapePropertyFactory;}();var StarShapeProperty=function(){function StarShapePropertyFactory(elem,data){this.v=shapePool.newElement();this.v.setPathData(true,0);this.elem=elem;this.comp=elem.comp;this.data=data;this.frameId=-1;this.d=data.d;this.initDynamicPropertyContainer(elem);if(data.sy===1){this.ir=PropertyFactory.getProp(elem,data.ir,0,0,this);this.is=PropertyFactory.getProp(elem,data.is,0,0.01,this);this.convertToPath=this.convertStarToPath;}else {this.convertToPath=this.convertPolygonToPath;}this.pt=PropertyFactory.getProp(elem,data.pt,0,0,this);this.p=PropertyFactory.getProp(elem,data.p,1,0,this);this.r=PropertyFactory.getProp(elem,data.r,0,degToRads,this);this.or=PropertyFactory.getProp(elem,data.or,0,0,this);this.os=PropertyFactory.getProp(elem,data.os,0,0.01,this);this.localShapeCollection=shapeCollectionPool.newShapeCollection();this.localShapeCollection.addShape(this.v);this.paths=this.localShapeCollection;if(this.dynamicProperties.length){this.k=true;}else {this.k=false;this.convertToPath();}}StarShapePropertyFactory.prototype={reset:resetShape,getValue:function getValue(){if(this.elem.globalData.frameId===this.frameId){return;}this.frameId=this.elem.globalData.frameId;this.iterateDynamicProperties();if(this._mdf){this.convertToPath();}},convertStarToPath:function convertStarToPath(){var numPts=Math.floor(this.pt.v)*2;var angle=Math.PI*2/numPts;/* this.v.v.length = numPts;
	                  this.v.i.length = numPts;
	                  this.v.o.length = numPts; */var longFlag=true;var longRad=this.or.v;var shortRad=this.ir.v;var longRound=this.os.v;var shortRound=this.is.v;var longPerimSegment=2*Math.PI*longRad/(numPts*2);var shortPerimSegment=2*Math.PI*shortRad/(numPts*2);var i;var rad;var roundness;var perimSegment;var currentAng=-Math.PI/2;currentAng+=this.r.v;var dir=this.data.d===3?-1:1;this.v._length=0;for(i=0;i<numPts;i+=1){rad=longFlag?longRad:shortRad;roundness=longFlag?longRound:shortRound;perimSegment=longFlag?longPerimSegment:shortPerimSegment;var x=rad*Math.cos(currentAng);var y=rad*Math.sin(currentAng);var ox=x===0&&y===0?0:y/Math.sqrt(x*x+y*y);var oy=x===0&&y===0?0:-x/Math.sqrt(x*x+y*y);x+=+this.p.v[0];y+=+this.p.v[1];this.v.setTripleAt(x,y,x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir,x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir,i,true);/* this.v.v[i] = [x,y];
	                      this.v.i[i] = [x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir];
	                      this.v.o[i] = [x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir];
	                      this.v._length = numPts; */longFlag=!longFlag;currentAng+=angle*dir;}},convertPolygonToPath:function convertPolygonToPath(){var numPts=Math.floor(this.pt.v);var angle=Math.PI*2/numPts;var rad=this.or.v;var roundness=this.os.v;var perimSegment=2*Math.PI*rad/(numPts*4);var i;var currentAng=-Math.PI*0.5;var dir=this.data.d===3?-1:1;currentAng+=this.r.v;this.v._length=0;for(i=0;i<numPts;i+=1){var x=rad*Math.cos(currentAng);var y=rad*Math.sin(currentAng);var ox=x===0&&y===0?0:y/Math.sqrt(x*x+y*y);var oy=x===0&&y===0?0:-x/Math.sqrt(x*x+y*y);x+=+this.p.v[0];y+=+this.p.v[1];this.v.setTripleAt(x,y,x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir,x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir,i,true);currentAng+=angle*dir;}this.paths.length=0;this.paths[0]=this.v;}};extendPrototype([DynamicPropertyContainer],StarShapePropertyFactory);return StarShapePropertyFactory;}();var RectShapeProperty=function(){function RectShapePropertyFactory(elem,data){this.v=shapePool.newElement();this.v.c=true;this.localShapeCollection=shapeCollectionPool.newShapeCollection();this.localShapeCollection.addShape(this.v);this.paths=this.localShapeCollection;this.elem=elem;this.comp=elem.comp;this.frameId=-1;this.d=data.d;this.initDynamicPropertyContainer(elem);this.p=PropertyFactory.getProp(elem,data.p,1,0,this);this.s=PropertyFactory.getProp(elem,data.s,1,0,this);this.r=PropertyFactory.getProp(elem,data.r,0,0,this);if(this.dynamicProperties.length){this.k=true;}else {this.k=false;this.convertRectToPath();}}RectShapePropertyFactory.prototype={convertRectToPath:function convertRectToPath(){var p0=this.p.v[0];var p1=this.p.v[1];var v0=this.s.v[0]/2;var v1=this.s.v[1]/2;var round=bmMin(v0,v1,this.r.v);var cPoint=round*(1-roundCorner);this.v._length=0;if(this.d===2||this.d===1){this.v.setTripleAt(p0+v0,p1-v1+round,p0+v0,p1-v1+round,p0+v0,p1-v1+cPoint,0,true);this.v.setTripleAt(p0+v0,p1+v1-round,p0+v0,p1+v1-cPoint,p0+v0,p1+v1-round,1,true);if(round!==0){this.v.setTripleAt(p0+v0-round,p1+v1,p0+v0-round,p1+v1,p0+v0-cPoint,p1+v1,2,true);this.v.setTripleAt(p0-v0+round,p1+v1,p0-v0+cPoint,p1+v1,p0-v0+round,p1+v1,3,true);this.v.setTripleAt(p0-v0,p1+v1-round,p0-v0,p1+v1-round,p0-v0,p1+v1-cPoint,4,true);this.v.setTripleAt(p0-v0,p1-v1+round,p0-v0,p1-v1+cPoint,p0-v0,p1-v1+round,5,true);this.v.setTripleAt(p0-v0+round,p1-v1,p0-v0+round,p1-v1,p0-v0+cPoint,p1-v1,6,true);this.v.setTripleAt(p0+v0-round,p1-v1,p0+v0-cPoint,p1-v1,p0+v0-round,p1-v1,7,true);}else {this.v.setTripleAt(p0-v0,p1+v1,p0-v0+cPoint,p1+v1,p0-v0,p1+v1,2);this.v.setTripleAt(p0-v0,p1-v1,p0-v0,p1-v1+cPoint,p0-v0,p1-v1,3);}}else {this.v.setTripleAt(p0+v0,p1-v1+round,p0+v0,p1-v1+cPoint,p0+v0,p1-v1+round,0,true);if(round!==0){this.v.setTripleAt(p0+v0-round,p1-v1,p0+v0-round,p1-v1,p0+v0-cPoint,p1-v1,1,true);this.v.setTripleAt(p0-v0+round,p1-v1,p0-v0+cPoint,p1-v1,p0-v0+round,p1-v1,2,true);this.v.setTripleAt(p0-v0,p1-v1+round,p0-v0,p1-v1+round,p0-v0,p1-v1+cPoint,3,true);this.v.setTripleAt(p0-v0,p1+v1-round,p0-v0,p1+v1-cPoint,p0-v0,p1+v1-round,4,true);this.v.setTripleAt(p0-v0+round,p1+v1,p0-v0+round,p1+v1,p0-v0+cPoint,p1+v1,5,true);this.v.setTripleAt(p0+v0-round,p1+v1,p0+v0-cPoint,p1+v1,p0+v0-round,p1+v1,6,true);this.v.setTripleAt(p0+v0,p1+v1-round,p0+v0,p1+v1-round,p0+v0,p1+v1-cPoint,7,true);}else {this.v.setTripleAt(p0-v0,p1-v1,p0-v0+cPoint,p1-v1,p0-v0,p1-v1,1,true);this.v.setTripleAt(p0-v0,p1+v1,p0-v0,p1+v1-cPoint,p0-v0,p1+v1,2,true);this.v.setTripleAt(p0+v0,p1+v1,p0+v0-cPoint,p1+v1,p0+v0,p1+v1,3,true);}}},getValue:function getValue(){if(this.elem.globalData.frameId===this.frameId){return;}this.frameId=this.elem.globalData.frameId;this.iterateDynamicProperties();if(this._mdf){this.convertRectToPath();}},reset:resetShape};extendPrototype([DynamicPropertyContainer],RectShapePropertyFactory);return RectShapePropertyFactory;}();function getShapeProp(elem,data,type){var prop;if(type===3||type===4){var dataProp=type===3?data.pt:data.ks;var keys=dataProp.k;if(keys.length){prop=new KeyframedShapeProperty(elem,data,type);}else {prop=new ShapeProperty(elem,data,type);}}else if(type===5){prop=new RectShapeProperty(elem,data);}else if(type===6){prop=new EllShapeProperty(elem,data);}else if(type===7){prop=new StarShapeProperty(elem,data);}if(prop.k){elem.addDynamicProperty(prop);}return prop;}function getConstructorFunction(){return ShapeProperty;}function getKeyframedConstructorFunction(){return KeyframedShapeProperty;}var ob={};ob.getShapeProp=getShapeProp;ob.getConstructorFunction=getConstructorFunction;ob.getKeyframedConstructorFunction=getKeyframedConstructorFunction;return ob;}();/*!
	   Transformation Matrix v2.0
	   (c) Epistemex 2014-2015
	   www.epistemex.com
	   By Ken Fyrstenberg
	   Contributions by leeoniya.
	   License: MIT, header required.
	   */ /**
	   * 2D transformation matrix object initialized with identity matrix.
	   *
	   * The matrix can synchronize a canvas context by supplying the context
	   * as an argument, or later apply current absolute transform to an
	   * existing context.
	   *
	   * All values are handled as floating point values.
	   *
	   * @param {CanvasRenderingContext2D} [context] - Optional context to sync with Matrix
	   * @prop {number} a - scale x
	   * @prop {number} b - shear y
	   * @prop {number} c - shear x
	   * @prop {number} d - scale y
	   * @prop {number} e - translate x
	   * @prop {number} f - translate y
	   * @prop {CanvasRenderingContext2D|null} [context=null] - set or get current canvas context
	   * @constructor
	   */var Matrix=function(){var _cos=Math.cos;var _sin=Math.sin;var _tan=Math.tan;var _rnd=Math.round;function reset(){this.props[0]=1;this.props[1]=0;this.props[2]=0;this.props[3]=0;this.props[4]=0;this.props[5]=1;this.props[6]=0;this.props[7]=0;this.props[8]=0;this.props[9]=0;this.props[10]=1;this.props[11]=0;this.props[12]=0;this.props[13]=0;this.props[14]=0;this.props[15]=1;return this;}function rotate(angle){if(angle===0){return this;}var mCos=_cos(angle);var mSin=_sin(angle);return this._t(mCos,-mSin,0,0,mSin,mCos,0,0,0,0,1,0,0,0,0,1);}function rotateX(angle){if(angle===0){return this;}var mCos=_cos(angle);var mSin=_sin(angle);return this._t(1,0,0,0,0,mCos,-mSin,0,0,mSin,mCos,0,0,0,0,1);}function rotateY(angle){if(angle===0){return this;}var mCos=_cos(angle);var mSin=_sin(angle);return this._t(mCos,0,mSin,0,0,1,0,0,-mSin,0,mCos,0,0,0,0,1);}function rotateZ(angle){if(angle===0){return this;}var mCos=_cos(angle);var mSin=_sin(angle);return this._t(mCos,-mSin,0,0,mSin,mCos,0,0,0,0,1,0,0,0,0,1);}function shear(sx,sy){return this._t(1,sy,sx,1,0,0);}function skew(ax,ay){return this.shear(_tan(ax),_tan(ay));}function skewFromAxis(ax,angle){var mCos=_cos(angle);var mSin=_sin(angle);return this._t(mCos,mSin,0,0,-mSin,mCos,0,0,0,0,1,0,0,0,0,1)._t(1,0,0,0,_tan(ax),1,0,0,0,0,1,0,0,0,0,1)._t(mCos,-mSin,0,0,mSin,mCos,0,0,0,0,1,0,0,0,0,1);// return this._t(mCos, mSin, -mSin, mCos, 0, 0)._t(1, 0, _tan(ax), 1, 0, 0)._t(mCos, -mSin, mSin, mCos, 0, 0);
	}function scale(sx,sy,sz){if(!sz&&sz!==0){sz=1;}if(sx===1&&sy===1&&sz===1){return this;}return this._t(sx,0,0,0,0,sy,0,0,0,0,sz,0,0,0,0,1);}function setTransform(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p){this.props[0]=a;this.props[1]=b;this.props[2]=c;this.props[3]=d;this.props[4]=e;this.props[5]=f;this.props[6]=g;this.props[7]=h;this.props[8]=i;this.props[9]=j;this.props[10]=k;this.props[11]=l;this.props[12]=m;this.props[13]=n;this.props[14]=o;this.props[15]=p;return this;}function translate(tx,ty,tz){tz=tz||0;if(tx!==0||ty!==0||tz!==0){return this._t(1,0,0,0,0,1,0,0,0,0,1,0,tx,ty,tz,1);}return this;}function transform(a2,b2,c2,d2,e2,f2,g2,h2,i2,j2,k2,l2,m2,n2,o2,p2){var _p=this.props;if(a2===1&&b2===0&&c2===0&&d2===0&&e2===0&&f2===1&&g2===0&&h2===0&&i2===0&&j2===0&&k2===1&&l2===0){// NOTE: commenting this condition because TurboFan deoptimizes code when present
	// if(m2 !== 0 || n2 !== 0 || o2 !== 0){
	_p[12]=_p[12]*a2+_p[15]*m2;_p[13]=_p[13]*f2+_p[15]*n2;_p[14]=_p[14]*k2+_p[15]*o2;_p[15]*=p2;// }
	this._identityCalculated=false;return this;}var a1=_p[0];var b1=_p[1];var c1=_p[2];var d1=_p[3];var e1=_p[4];var f1=_p[5];var g1=_p[6];var h1=_p[7];var i1=_p[8];var j1=_p[9];var k1=_p[10];var l1=_p[11];var m1=_p[12];var n1=_p[13];var o1=_p[14];var p1=_p[15];/* matrix order (canvas compatible):
	           * ace
	           * bdf
	           * 001
	           */_p[0]=a1*a2+b1*e2+c1*i2+d1*m2;_p[1]=a1*b2+b1*f2+c1*j2+d1*n2;_p[2]=a1*c2+b1*g2+c1*k2+d1*o2;_p[3]=a1*d2+b1*h2+c1*l2+d1*p2;_p[4]=e1*a2+f1*e2+g1*i2+h1*m2;_p[5]=e1*b2+f1*f2+g1*j2+h1*n2;_p[6]=e1*c2+f1*g2+g1*k2+h1*o2;_p[7]=e1*d2+f1*h2+g1*l2+h1*p2;_p[8]=i1*a2+j1*e2+k1*i2+l1*m2;_p[9]=i1*b2+j1*f2+k1*j2+l1*n2;_p[10]=i1*c2+j1*g2+k1*k2+l1*o2;_p[11]=i1*d2+j1*h2+k1*l2+l1*p2;_p[12]=m1*a2+n1*e2+o1*i2+p1*m2;_p[13]=m1*b2+n1*f2+o1*j2+p1*n2;_p[14]=m1*c2+n1*g2+o1*k2+p1*o2;_p[15]=m1*d2+n1*h2+o1*l2+p1*p2;this._identityCalculated=false;return this;}function multiply(matrix){var matrixProps=matrix.props;return this.transform(matrixProps[0],matrixProps[1],matrixProps[2],matrixProps[3],matrixProps[4],matrixProps[5],matrixProps[6],matrixProps[7],matrixProps[8],matrixProps[9],matrixProps[10],matrixProps[11],matrixProps[12],matrixProps[13],matrixProps[14],matrixProps[15]);}function isIdentity(){if(!this._identityCalculated){this._identity=!(this.props[0]!==1||this.props[1]!==0||this.props[2]!==0||this.props[3]!==0||this.props[4]!==0||this.props[5]!==1||this.props[6]!==0||this.props[7]!==0||this.props[8]!==0||this.props[9]!==0||this.props[10]!==1||this.props[11]!==0||this.props[12]!==0||this.props[13]!==0||this.props[14]!==0||this.props[15]!==1);this._identityCalculated=true;}return this._identity;}function equals(matr){var i=0;while(i<16){if(matr.props[i]!==this.props[i]){return false;}i+=1;}return true;}function clone(matr){var i;for(i=0;i<16;i+=1){matr.props[i]=this.props[i];}return matr;}function cloneFromProps(props){var i;for(i=0;i<16;i+=1){this.props[i]=props[i];}}function applyToPoint(x,y,z){return {x:x*this.props[0]+y*this.props[4]+z*this.props[8]+this.props[12],y:x*this.props[1]+y*this.props[5]+z*this.props[9]+this.props[13],z:x*this.props[2]+y*this.props[6]+z*this.props[10]+this.props[14]};/* return {
	           x: x * me.a + y * me.c + me.e,
	           y: x * me.b + y * me.d + me.f
	           }; */}function applyToX(x,y,z){return x*this.props[0]+y*this.props[4]+z*this.props[8]+this.props[12];}function applyToY(x,y,z){return x*this.props[1]+y*this.props[5]+z*this.props[9]+this.props[13];}function applyToZ(x,y,z){return x*this.props[2]+y*this.props[6]+z*this.props[10]+this.props[14];}function getInverseMatrix(){var determinant=this.props[0]*this.props[5]-this.props[1]*this.props[4];var a=this.props[5]/determinant;var b=-this.props[1]/determinant;var c=-this.props[4]/determinant;var d=this.props[0]/determinant;var e=(this.props[4]*this.props[13]-this.props[5]*this.props[12])/determinant;var f=-(this.props[0]*this.props[13]-this.props[1]*this.props[12])/determinant;var inverseMatrix=new Matrix();inverseMatrix.props[0]=a;inverseMatrix.props[1]=b;inverseMatrix.props[4]=c;inverseMatrix.props[5]=d;inverseMatrix.props[12]=e;inverseMatrix.props[13]=f;return inverseMatrix;}function inversePoint(pt){var inverseMatrix=this.getInverseMatrix();return inverseMatrix.applyToPointArray(pt[0],pt[1],pt[2]||0);}function inversePoints(pts){var i;var len=pts.length;var retPts=[];for(i=0;i<len;i+=1){retPts[i]=inversePoint(pts[i]);}return retPts;}function applyToTriplePoints(pt1,pt2,pt3){var arr=createTypedArray('float32',6);if(this.isIdentity()){arr[0]=pt1[0];arr[1]=pt1[1];arr[2]=pt2[0];arr[3]=pt2[1];arr[4]=pt3[0];arr[5]=pt3[1];}else {var p0=this.props[0];var p1=this.props[1];var p4=this.props[4];var p5=this.props[5];var p12=this.props[12];var p13=this.props[13];arr[0]=pt1[0]*p0+pt1[1]*p4+p12;arr[1]=pt1[0]*p1+pt1[1]*p5+p13;arr[2]=pt2[0]*p0+pt2[1]*p4+p12;arr[3]=pt2[0]*p1+pt2[1]*p5+p13;arr[4]=pt3[0]*p0+pt3[1]*p4+p12;arr[5]=pt3[0]*p1+pt3[1]*p5+p13;}return arr;}function applyToPointArray(x,y,z){var arr;if(this.isIdentity()){arr=[x,y,z];}else {arr=[x*this.props[0]+y*this.props[4]+z*this.props[8]+this.props[12],x*this.props[1]+y*this.props[5]+z*this.props[9]+this.props[13],x*this.props[2]+y*this.props[6]+z*this.props[10]+this.props[14]];}return arr;}function applyToPointStringified(x,y){if(this.isIdentity()){return x+','+y;}var _p=this.props;return Math.round((x*_p[0]+y*_p[4]+_p[12])*100)/100+','+Math.round((x*_p[1]+y*_p[5]+_p[13])*100)/100;}function toCSS(){// Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
	/* if(this.isIdentity()) {
	              return '';
	          } */var i=0;var props=this.props;var cssValue='matrix3d(';var v=10000;while(i<16){cssValue+=_rnd(props[i]*v)/v;cssValue+=i===15?')':',';i+=1;}return cssValue;}function roundMatrixProperty(val){var v=10000;if(val<0.000001&&val>0||val>-0.000001&&val<0){return _rnd(val*v)/v;}return val;}function to2dCSS(){// Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
	/* if(this.isIdentity()) {
	              return '';
	          } */var props=this.props;var _a=roundMatrixProperty(props[0]);var _b=roundMatrixProperty(props[1]);var _c=roundMatrixProperty(props[4]);var _d=roundMatrixProperty(props[5]);var _e=roundMatrixProperty(props[12]);var _f=roundMatrixProperty(props[13]);return 'matrix('+_a+','+_b+','+_c+','+_d+','+_e+','+_f+')';}return function(){this.reset=reset;this.rotate=rotate;this.rotateX=rotateX;this.rotateY=rotateY;this.rotateZ=rotateZ;this.skew=skew;this.skewFromAxis=skewFromAxis;this.shear=shear;this.scale=scale;this.setTransform=setTransform;this.translate=translate;this.transform=transform;this.multiply=multiply;this.applyToPoint=applyToPoint;this.applyToX=applyToX;this.applyToY=applyToY;this.applyToZ=applyToZ;this.applyToPointArray=applyToPointArray;this.applyToTriplePoints=applyToTriplePoints;this.applyToPointStringified=applyToPointStringified;this.toCSS=toCSS;this.to2dCSS=to2dCSS;this.clone=clone;this.cloneFromProps=cloneFromProps;this.equals=equals;this.inversePoints=inversePoints;this.inversePoint=inversePoint;this.getInverseMatrix=getInverseMatrix;this._t=this.transform;this.isIdentity=isIdentity;this._identity=true;this._identityCalculated=false;this.props=createTypedArray('float32',16);this.reset();};}();function _typeof$3(obj){"@babel/helpers - typeof";if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){_typeof$3=function _typeof(obj){return typeof obj;};}else {_typeof$3=function _typeof(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};}return _typeof$3(obj);}var lottie={};function setLocation(href){setLocationHref(href);}function searchAnimations(){{animationManager.searchAnimations();}}function setSubframeRendering(flag){setSubframeEnabled(flag);}function setPrefix(prefix){setIdPrefix(prefix);}function loadAnimation(params){return animationManager.loadAnimation(params);}function setQuality(value){if(typeof value==='string'){switch(value){case'high':setDefaultCurveSegments(200);break;default:case'medium':setDefaultCurveSegments(50);break;case'low':setDefaultCurveSegments(10);break;}}else if(!isNaN(value)&&value>1){setDefaultCurveSegments(value);}}function inBrowser(){return typeof navigator!=='undefined';}function installPlugin(type,plugin){if(type==='expressions'){setExpressionsPlugin(plugin);}}function getFactory(name){switch(name){case'propertyFactory':return PropertyFactory;case'shapePropertyFactory':return ShapePropertyFactory;case'matrix':return Matrix;default:return null;}}lottie.play=animationManager.play;lottie.pause=animationManager.pause;lottie.setLocationHref=setLocation;lottie.togglePause=animationManager.togglePause;lottie.setSpeed=animationManager.setSpeed;lottie.setDirection=animationManager.setDirection;lottie.stop=animationManager.stop;lottie.searchAnimations=searchAnimations;lottie.registerAnimation=animationManager.registerAnimation;lottie.loadAnimation=loadAnimation;lottie.setSubframeRendering=setSubframeRendering;lottie.resize=animationManager.resize;// lottie.start = start;
	lottie.goToAndStop=animationManager.goToAndStop;lottie.destroy=animationManager.destroy;lottie.setQuality=setQuality;lottie.inBrowser=inBrowser;lottie.installPlugin=installPlugin;lottie.freeze=animationManager.freeze;lottie.unfreeze=animationManager.unfreeze;lottie.setVolume=animationManager.setVolume;lottie.mute=animationManager.mute;lottie.unmute=animationManager.unmute;lottie.getRegisteredAnimations=animationManager.getRegisteredAnimations;lottie.useWebWorker=setWebWorker;lottie.setIDPrefix=setPrefix;lottie.__getFactory=getFactory;lottie.version='5.12.2';function checkReady(){if(document.readyState==='complete'){clearInterval(readyStateCheckInterval);searchAnimations();}}function getQueryVariable(variable){var vars=queryString.split('&');for(var i=0;i<vars.length;i+=1){var pair=vars[i].split('=');if(decodeURIComponent(pair[0])==variable){// eslint-disable-line eqeqeq
	return decodeURIComponent(pair[1]);}}return null;}var queryString='';{var scripts=document.getElementsByTagName('script');var index=scripts.length-1;var myScript=scripts[index]||{src:''};queryString=myScript.src?myScript.src.replace(/^[^\?]+\??/,''):'';// eslint-disable-line no-useless-escape
	getQueryVariable('renderer');}var readyStateCheckInterval=setInterval(checkReady,100);// this adds bodymovin to the window object for backwards compatibility
	try{if(!(('object'==="undefined"?"undefined":_typeof$3(exports))==='object'&&'object'!=='undefined')&&!(typeof undefined==='function'&&undefined.amd)// eslint-disable-line no-undef
	){window.bodymovin=lottie;}}catch(err){//
	}var ShapeModifiers=function(){var ob={};var modifiers={};ob.registerModifier=registerModifier;ob.getModifier=getModifier;function registerModifier(nm,factory){if(!modifiers[nm]){modifiers[nm]=factory;}}function getModifier(nm,elem,data){return new modifiers[nm](elem,data);}return ob;}();function ShapeModifier(){}ShapeModifier.prototype.initModifierProperties=function(){};ShapeModifier.prototype.addShapeToModifier=function(){};ShapeModifier.prototype.addShape=function(data){if(!this.closed){// Adding shape to dynamic properties. It covers the case where a shape has no effects applied, to reset it's _mdf state on every tick.
	data.sh.container.addDynamicProperty(data.sh);var shapeData={shape:data.sh,data:data,localShapeCollection:shapeCollectionPool.newShapeCollection()};this.shapes.push(shapeData);this.addShapeToModifier(shapeData);if(this._isAnimated){data.setAsAnimated();}}};ShapeModifier.prototype.init=function(elem,data){this.shapes=[];this.elem=elem;this.initDynamicPropertyContainer(elem);this.initModifierProperties(elem,data);this.frameId=initialDefaultFrame;this.closed=false;this.k=false;if(this.dynamicProperties.length){this.k=true;}else {this.getValue(true);}};ShapeModifier.prototype.processKeys=function(){if(this.elem.globalData.frameId===this.frameId){return;}this.frameId=this.elem.globalData.frameId;this.iterateDynamicProperties();};extendPrototype([DynamicPropertyContainer],ShapeModifier);function TrimModifier(){}extendPrototype([ShapeModifier],TrimModifier);TrimModifier.prototype.initModifierProperties=function(elem,data){this.s=PropertyFactory.getProp(elem,data.s,0,0.01,this);this.e=PropertyFactory.getProp(elem,data.e,0,0.01,this);this.o=PropertyFactory.getProp(elem,data.o,0,0,this);this.sValue=0;this.eValue=0;this.getValue=this.processKeys;this.m=data.m;this._isAnimated=!!this.s.effectsSequence.length||!!this.e.effectsSequence.length||!!this.o.effectsSequence.length;};TrimModifier.prototype.addShapeToModifier=function(shapeData){shapeData.pathsData=[];};TrimModifier.prototype.calculateShapeEdges=function(s,e,shapeLength,addedLength,totalModifierLength){var segments=[];if(e<=1){segments.push({s:s,e:e});}else if(s>=1){segments.push({s:s-1,e:e-1});}else {segments.push({s:s,e:1});segments.push({s:0,e:e-1});}var shapeSegments=[];var i;var len=segments.length;var segmentOb;for(i=0;i<len;i+=1){segmentOb=segments[i];if(!(segmentOb.e*totalModifierLength<addedLength||segmentOb.s*totalModifierLength>addedLength+shapeLength)){var shapeS;var shapeE;if(segmentOb.s*totalModifierLength<=addedLength){shapeS=0;}else {shapeS=(segmentOb.s*totalModifierLength-addedLength)/shapeLength;}if(segmentOb.e*totalModifierLength>=addedLength+shapeLength){shapeE=1;}else {shapeE=(segmentOb.e*totalModifierLength-addedLength)/shapeLength;}shapeSegments.push([shapeS,shapeE]);}}if(!shapeSegments.length){shapeSegments.push([0,0]);}return shapeSegments;};TrimModifier.prototype.releasePathsData=function(pathsData){var i;var len=pathsData.length;for(i=0;i<len;i+=1){segmentsLengthPool.release(pathsData[i]);}pathsData.length=0;return pathsData;};TrimModifier.prototype.processShapes=function(_isFirstFrame){var s;var e;if(this._mdf||_isFirstFrame){var o=this.o.v%360/360;if(o<0){o+=1;}if(this.s.v>1){s=1+o;}else if(this.s.v<0){s=0+o;}else {s=this.s.v+o;}if(this.e.v>1){e=1+o;}else if(this.e.v<0){e=0+o;}else {e=this.e.v+o;}if(s>e){var _s=s;s=e;e=_s;}s=Math.round(s*10000)*0.0001;e=Math.round(e*10000)*0.0001;this.sValue=s;this.eValue=e;}else {s=this.sValue;e=this.eValue;}var shapePaths;var i;var len=this.shapes.length;var j;var jLen;var pathsData;var pathData;var totalShapeLength;var totalModifierLength=0;if(e===s){for(i=0;i<len;i+=1){this.shapes[i].localShapeCollection.releaseShapes();this.shapes[i].shape._mdf=true;this.shapes[i].shape.paths=this.shapes[i].localShapeCollection;if(this._mdf){this.shapes[i].pathsData.length=0;}}}else if(!(e===1&&s===0||e===0&&s===1)){var segments=[];var shapeData;var localShapeCollection;for(i=0;i<len;i+=1){shapeData=this.shapes[i];// if shape hasn't changed and trim properties haven't changed, cached previous path can be used
	if(!shapeData.shape._mdf&&!this._mdf&&!_isFirstFrame&&this.m!==2){shapeData.shape.paths=shapeData.localShapeCollection;}else {shapePaths=shapeData.shape.paths;jLen=shapePaths._length;totalShapeLength=0;if(!shapeData.shape._mdf&&shapeData.pathsData.length){totalShapeLength=shapeData.totalShapeLength;}else {pathsData=this.releasePathsData(shapeData.pathsData);for(j=0;j<jLen;j+=1){pathData=bez.getSegmentsLength(shapePaths.shapes[j]);pathsData.push(pathData);totalShapeLength+=pathData.totalLength;}shapeData.totalShapeLength=totalShapeLength;shapeData.pathsData=pathsData;}totalModifierLength+=totalShapeLength;shapeData.shape._mdf=true;}}var shapeS=s;var shapeE=e;var addedLength=0;var edges;for(i=len-1;i>=0;i-=1){shapeData=this.shapes[i];if(shapeData.shape._mdf){localShapeCollection=shapeData.localShapeCollection;localShapeCollection.releaseShapes();// if m === 2 means paths are trimmed individually so edges need to be found for this specific shape relative to whoel group
	if(this.m===2&&len>1){edges=this.calculateShapeEdges(s,e,shapeData.totalShapeLength,addedLength,totalModifierLength);addedLength+=shapeData.totalShapeLength;}else {edges=[[shapeS,shapeE]];}jLen=edges.length;for(j=0;j<jLen;j+=1){shapeS=edges[j][0];shapeE=edges[j][1];segments.length=0;if(shapeE<=1){segments.push({s:shapeData.totalShapeLength*shapeS,e:shapeData.totalShapeLength*shapeE});}else if(shapeS>=1){segments.push({s:shapeData.totalShapeLength*(shapeS-1),e:shapeData.totalShapeLength*(shapeE-1)});}else {segments.push({s:shapeData.totalShapeLength*shapeS,e:shapeData.totalShapeLength});segments.push({s:0,e:shapeData.totalShapeLength*(shapeE-1)});}var newShapesData=this.addShapes(shapeData,segments[0]);if(segments[0].s!==segments[0].e){if(segments.length>1){var lastShapeInCollection=shapeData.shape.paths.shapes[shapeData.shape.paths._length-1];if(lastShapeInCollection.c){var lastShape=newShapesData.pop();this.addPaths(newShapesData,localShapeCollection);newShapesData=this.addShapes(shapeData,segments[1],lastShape);}else {this.addPaths(newShapesData,localShapeCollection);newShapesData=this.addShapes(shapeData,segments[1]);}}this.addPaths(newShapesData,localShapeCollection);}}shapeData.shape.paths=localShapeCollection;}}}else if(this._mdf){for(i=0;i<len;i+=1){// Releasign Trim Cached paths data when no trim applied in case shapes are modified inbetween.
	// Don't remove this even if it's losing cached info.
	this.shapes[i].pathsData.length=0;this.shapes[i].shape._mdf=true;}}};TrimModifier.prototype.addPaths=function(newPaths,localShapeCollection){var i;var len=newPaths.length;for(i=0;i<len;i+=1){localShapeCollection.addShape(newPaths[i]);}};TrimModifier.prototype.addSegment=function(pt1,pt2,pt3,pt4,shapePath,pos,newShape){shapePath.setXYAt(pt2[0],pt2[1],'o',pos);shapePath.setXYAt(pt3[0],pt3[1],'i',pos+1);if(newShape){shapePath.setXYAt(pt1[0],pt1[1],'v',pos);}shapePath.setXYAt(pt4[0],pt4[1],'v',pos+1);};TrimModifier.prototype.addSegmentFromArray=function(points,shapePath,pos,newShape){shapePath.setXYAt(points[1],points[5],'o',pos);shapePath.setXYAt(points[2],points[6],'i',pos+1);if(newShape){shapePath.setXYAt(points[0],points[4],'v',pos);}shapePath.setXYAt(points[3],points[7],'v',pos+1);};TrimModifier.prototype.addShapes=function(shapeData,shapeSegment,shapePath){var pathsData=shapeData.pathsData;var shapePaths=shapeData.shape.paths.shapes;var i;var len=shapeData.shape.paths._length;var j;var jLen;var addedLength=0;var currentLengthData;var segmentCount;var lengths;var segment;var shapes=[];var initPos;var newShape=true;if(!shapePath){shapePath=shapePool.newElement();segmentCount=0;initPos=0;}else {segmentCount=shapePath._length;initPos=shapePath._length;}shapes.push(shapePath);for(i=0;i<len;i+=1){lengths=pathsData[i].lengths;shapePath.c=shapePaths[i].c;jLen=shapePaths[i].c?lengths.length:lengths.length+1;for(j=1;j<jLen;j+=1){currentLengthData=lengths[j-1];if(addedLength+currentLengthData.addedLength<shapeSegment.s){addedLength+=currentLengthData.addedLength;shapePath.c=false;}else if(addedLength>shapeSegment.e){shapePath.c=false;break;}else {if(shapeSegment.s<=addedLength&&shapeSegment.e>=addedLength+currentLengthData.addedLength){this.addSegment(shapePaths[i].v[j-1],shapePaths[i].o[j-1],shapePaths[i].i[j],shapePaths[i].v[j],shapePath,segmentCount,newShape);newShape=false;}else {segment=bez.getNewSegment(shapePaths[i].v[j-1],shapePaths[i].v[j],shapePaths[i].o[j-1],shapePaths[i].i[j],(shapeSegment.s-addedLength)/currentLengthData.addedLength,(shapeSegment.e-addedLength)/currentLengthData.addedLength,lengths[j-1]);this.addSegmentFromArray(segment,shapePath,segmentCount,newShape);// this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
	newShape=false;shapePath.c=false;}addedLength+=currentLengthData.addedLength;segmentCount+=1;}}if(shapePaths[i].c&&lengths.length){currentLengthData=lengths[j-1];if(addedLength<=shapeSegment.e){var segmentLength=lengths[j-1].addedLength;if(shapeSegment.s<=addedLength&&shapeSegment.e>=addedLength+segmentLength){this.addSegment(shapePaths[i].v[j-1],shapePaths[i].o[j-1],shapePaths[i].i[0],shapePaths[i].v[0],shapePath,segmentCount,newShape);newShape=false;}else {segment=bez.getNewSegment(shapePaths[i].v[j-1],shapePaths[i].v[0],shapePaths[i].o[j-1],shapePaths[i].i[0],(shapeSegment.s-addedLength)/segmentLength,(shapeSegment.e-addedLength)/segmentLength,lengths[j-1]);this.addSegmentFromArray(segment,shapePath,segmentCount,newShape);// this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
	newShape=false;shapePath.c=false;}}else {shapePath.c=false;}addedLength+=currentLengthData.addedLength;segmentCount+=1;}if(shapePath._length){shapePath.setXYAt(shapePath.v[initPos][0],shapePath.v[initPos][1],'i',initPos);shapePath.setXYAt(shapePath.v[shapePath._length-1][0],shapePath.v[shapePath._length-1][1],'o',shapePath._length-1);}if(addedLength>shapeSegment.e){break;}if(i<len-1){shapePath=shapePool.newElement();newShape=true;shapes.push(shapePath);segmentCount=0;}}return shapes;};function PuckerAndBloatModifier(){}extendPrototype([ShapeModifier],PuckerAndBloatModifier);PuckerAndBloatModifier.prototype.initModifierProperties=function(elem,data){this.getValue=this.processKeys;this.amount=PropertyFactory.getProp(elem,data.a,0,null,this);this._isAnimated=!!this.amount.effectsSequence.length;};PuckerAndBloatModifier.prototype.processPath=function(path,amount){var percent=amount/100;var centerPoint=[0,0];var pathLength=path._length;var i=0;for(i=0;i<pathLength;i+=1){centerPoint[0]+=path.v[i][0];centerPoint[1]+=path.v[i][1];}centerPoint[0]/=pathLength;centerPoint[1]/=pathLength;var clonedPath=shapePool.newElement();clonedPath.c=path.c;var vX;var vY;var oX;var oY;var iX;var iY;for(i=0;i<pathLength;i+=1){vX=path.v[i][0]+(centerPoint[0]-path.v[i][0])*percent;vY=path.v[i][1]+(centerPoint[1]-path.v[i][1])*percent;oX=path.o[i][0]+(centerPoint[0]-path.o[i][0])*-percent;oY=path.o[i][1]+(centerPoint[1]-path.o[i][1])*-percent;iX=path.i[i][0]+(centerPoint[0]-path.i[i][0])*-percent;iY=path.i[i][1]+(centerPoint[1]-path.i[i][1])*-percent;clonedPath.setTripleAt(vX,vY,oX,oY,iX,iY,i);}return clonedPath;};PuckerAndBloatModifier.prototype.processShapes=function(_isFirstFrame){var shapePaths;var i;var len=this.shapes.length;var j;var jLen;var amount=this.amount.v;if(amount!==0){var shapeData;var localShapeCollection;for(i=0;i<len;i+=1){shapeData=this.shapes[i];localShapeCollection=shapeData.localShapeCollection;if(!(!shapeData.shape._mdf&&!this._mdf&&!_isFirstFrame)){localShapeCollection.releaseShapes();shapeData.shape._mdf=true;shapePaths=shapeData.shape.paths.shapes;jLen=shapeData.shape.paths._length;for(j=0;j<jLen;j+=1){localShapeCollection.addShape(this.processPath(shapePaths[j],amount));}}shapeData.shape.paths=shapeData.localShapeCollection;}}if(!this.dynamicProperties.length){this._mdf=false;}};var TransformPropertyFactory=function(){var defaultVector=[0,0];function applyToMatrix(mat){var _mdf=this._mdf;this.iterateDynamicProperties();this._mdf=this._mdf||_mdf;if(this.a){mat.translate(-this.a.v[0],-this.a.v[1],this.a.v[2]);}if(this.s){mat.scale(this.s.v[0],this.s.v[1],this.s.v[2]);}if(this.sk){mat.skewFromAxis(-this.sk.v,this.sa.v);}if(this.r){mat.rotate(-this.r.v);}else {mat.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);}if(this.data.p.s){if(this.data.p.z){mat.translate(this.px.v,this.py.v,-this.pz.v);}else {mat.translate(this.px.v,this.py.v,0);}}else {mat.translate(this.p.v[0],this.p.v[1],-this.p.v[2]);}}function processKeys(forceRender){if(this.elem.globalData.frameId===this.frameId){return;}if(this._isDirty){this.precalculateMatrix();this._isDirty=false;}this.iterateDynamicProperties();if(this._mdf||forceRender){var frameRate;this.v.cloneFromProps(this.pre.props);if(this.appliedTransformations<1){this.v.translate(-this.a.v[0],-this.a.v[1],this.a.v[2]);}if(this.appliedTransformations<2){this.v.scale(this.s.v[0],this.s.v[1],this.s.v[2]);}if(this.sk&&this.appliedTransformations<3){this.v.skewFromAxis(-this.sk.v,this.sa.v);}if(this.r&&this.appliedTransformations<4){this.v.rotate(-this.r.v);}else if(!this.r&&this.appliedTransformations<4){this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);}if(this.autoOriented){var v1;var v2;frameRate=this.elem.globalData.frameRate;if(this.p&&this.p.keyframes&&this.p.getValueAtTime){if(this.p._caching.lastFrame+this.p.offsetTime<=this.p.keyframes[0].t){v1=this.p.getValueAtTime((this.p.keyframes[0].t+0.01)/frameRate,0);v2=this.p.getValueAtTime(this.p.keyframes[0].t/frameRate,0);}else if(this.p._caching.lastFrame+this.p.offsetTime>=this.p.keyframes[this.p.keyframes.length-1].t){v1=this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length-1].t/frameRate,0);v2=this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length-1].t-0.05)/frameRate,0);}else {v1=this.p.pv;v2=this.p.getValueAtTime((this.p._caching.lastFrame+this.p.offsetTime-0.01)/frameRate,this.p.offsetTime);}}else if(this.px&&this.px.keyframes&&this.py.keyframes&&this.px.getValueAtTime&&this.py.getValueAtTime){v1=[];v2=[];var px=this.px;var py=this.py;if(px._caching.lastFrame+px.offsetTime<=px.keyframes[0].t){v1[0]=px.getValueAtTime((px.keyframes[0].t+0.01)/frameRate,0);v1[1]=py.getValueAtTime((py.keyframes[0].t+0.01)/frameRate,0);v2[0]=px.getValueAtTime(px.keyframes[0].t/frameRate,0);v2[1]=py.getValueAtTime(py.keyframes[0].t/frameRate,0);}else if(px._caching.lastFrame+px.offsetTime>=px.keyframes[px.keyframes.length-1].t){v1[0]=px.getValueAtTime(px.keyframes[px.keyframes.length-1].t/frameRate,0);v1[1]=py.getValueAtTime(py.keyframes[py.keyframes.length-1].t/frameRate,0);v2[0]=px.getValueAtTime((px.keyframes[px.keyframes.length-1].t-0.01)/frameRate,0);v2[1]=py.getValueAtTime((py.keyframes[py.keyframes.length-1].t-0.01)/frameRate,0);}else {v1=[px.pv,py.pv];v2[0]=px.getValueAtTime((px._caching.lastFrame+px.offsetTime-0.01)/frameRate,px.offsetTime);v2[1]=py.getValueAtTime((py._caching.lastFrame+py.offsetTime-0.01)/frameRate,py.offsetTime);}}else {v2=defaultVector;v1=v2;}this.v.rotate(-Math.atan2(v1[1]-v2[1],v1[0]-v2[0]));}if(this.data.p&&this.data.p.s){if(this.data.p.z){this.v.translate(this.px.v,this.py.v,-this.pz.v);}else {this.v.translate(this.px.v,this.py.v,0);}}else {this.v.translate(this.p.v[0],this.p.v[1],-this.p.v[2]);}}this.frameId=this.elem.globalData.frameId;}function precalculateMatrix(){this.appliedTransformations=0;this.pre.reset();if(!this.a.effectsSequence.length){this.pre.translate(-this.a.v[0],-this.a.v[1],this.a.v[2]);this.appliedTransformations=1;}else {return;}if(!this.s.effectsSequence.length){this.pre.scale(this.s.v[0],this.s.v[1],this.s.v[2]);this.appliedTransformations=2;}else {return;}if(this.sk){if(!this.sk.effectsSequence.length&&!this.sa.effectsSequence.length){this.pre.skewFromAxis(-this.sk.v,this.sa.v);this.appliedTransformations=3;}else {return;}}if(this.r){if(!this.r.effectsSequence.length){this.pre.rotate(-this.r.v);this.appliedTransformations=4;}}else if(!this.rz.effectsSequence.length&&!this.ry.effectsSequence.length&&!this.rx.effectsSequence.length&&!this.or.effectsSequence.length){this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);this.appliedTransformations=4;}}function autoOrient(){//
	// var prevP = this.getValueAtTime();
	}function addDynamicProperty(prop){this._addDynamicProperty(prop);this.elem.addDynamicProperty(prop);this._isDirty=true;}function TransformProperty(elem,data,container){this.elem=elem;this.frameId=-1;this.propType='transform';this.data=data;this.v=new Matrix();// Precalculated matrix with non animated properties
	this.pre=new Matrix();this.appliedTransformations=0;this.initDynamicPropertyContainer(container||elem);if(data.p&&data.p.s){this.px=PropertyFactory.getProp(elem,data.p.x,0,0,this);this.py=PropertyFactory.getProp(elem,data.p.y,0,0,this);if(data.p.z){this.pz=PropertyFactory.getProp(elem,data.p.z,0,0,this);}}else {this.p=PropertyFactory.getProp(elem,data.p||{k:[0,0,0]},1,0,this);}if(data.rx){this.rx=PropertyFactory.getProp(elem,data.rx,0,degToRads,this);this.ry=PropertyFactory.getProp(elem,data.ry,0,degToRads,this);this.rz=PropertyFactory.getProp(elem,data.rz,0,degToRads,this);if(data.or.k[0].ti){var i;var len=data.or.k.length;for(i=0;i<len;i+=1){data.or.k[i].to=null;data.or.k[i].ti=null;}}this.or=PropertyFactory.getProp(elem,data.or,1,degToRads,this);// sh Indicates it needs to be capped between -180 and 180
	this.or.sh=true;}else {this.r=PropertyFactory.getProp(elem,data.r||{k:0},0,degToRads,this);}if(data.sk){this.sk=PropertyFactory.getProp(elem,data.sk,0,degToRads,this);this.sa=PropertyFactory.getProp(elem,data.sa,0,degToRads,this);}this.a=PropertyFactory.getProp(elem,data.a||{k:[0,0,0]},1,0,this);this.s=PropertyFactory.getProp(elem,data.s||{k:[100,100,100]},1,0.01,this);// Opacity is not part of the transform properties, that's why it won't use this.dynamicProperties. That way transforms won't get updated if opacity changes.
	if(data.o){this.o=PropertyFactory.getProp(elem,data.o,0,0.01,elem);}else {this.o={_mdf:false,v:1};}this._isDirty=true;if(!this.dynamicProperties.length){this.getValue(true);}}TransformProperty.prototype={applyToMatrix:applyToMatrix,getValue:processKeys,precalculateMatrix:precalculateMatrix,autoOrient:autoOrient};extendPrototype([DynamicPropertyContainer],TransformProperty);TransformProperty.prototype.addDynamicProperty=addDynamicProperty;TransformProperty.prototype._addDynamicProperty=DynamicPropertyContainer.prototype.addDynamicProperty;function getTransformProperty(elem,data,container){return new TransformProperty(elem,data,container);}return {getTransformProperty:getTransformProperty};}();function RepeaterModifier(){}extendPrototype([ShapeModifier],RepeaterModifier);RepeaterModifier.prototype.initModifierProperties=function(elem,data){this.getValue=this.processKeys;this.c=PropertyFactory.getProp(elem,data.c,0,null,this);this.o=PropertyFactory.getProp(elem,data.o,0,null,this);this.tr=TransformPropertyFactory.getTransformProperty(elem,data.tr,this);this.so=PropertyFactory.getProp(elem,data.tr.so,0,0.01,this);this.eo=PropertyFactory.getProp(elem,data.tr.eo,0,0.01,this);this.data=data;if(!this.dynamicProperties.length){this.getValue(true);}this._isAnimated=!!this.dynamicProperties.length;this.pMatrix=new Matrix();this.rMatrix=new Matrix();this.sMatrix=new Matrix();this.tMatrix=new Matrix();this.matrix=new Matrix();};RepeaterModifier.prototype.applyTransforms=function(pMatrix,rMatrix,sMatrix,transform,perc,inv){var dir=inv?-1:1;var scaleX=transform.s.v[0]+(1-transform.s.v[0])*(1-perc);var scaleY=transform.s.v[1]+(1-transform.s.v[1])*(1-perc);pMatrix.translate(transform.p.v[0]*dir*perc,transform.p.v[1]*dir*perc,transform.p.v[2]);rMatrix.translate(-transform.a.v[0],-transform.a.v[1],transform.a.v[2]);rMatrix.rotate(-transform.r.v*dir*perc);rMatrix.translate(transform.a.v[0],transform.a.v[1],transform.a.v[2]);sMatrix.translate(-transform.a.v[0],-transform.a.v[1],transform.a.v[2]);sMatrix.scale(inv?1/scaleX:scaleX,inv?1/scaleY:scaleY);sMatrix.translate(transform.a.v[0],transform.a.v[1],transform.a.v[2]);};RepeaterModifier.prototype.init=function(elem,arr,pos,elemsData){this.elem=elem;this.arr=arr;this.pos=pos;this.elemsData=elemsData;this._currentCopies=0;this._elements=[];this._groups=[];this.frameId=-1;this.initDynamicPropertyContainer(elem);this.initModifierProperties(elem,arr[pos]);while(pos>0){pos-=1;// this._elements.unshift(arr.splice(pos,1)[0]);
	this._elements.unshift(arr[pos]);}if(this.dynamicProperties.length){this.k=true;}else {this.getValue(true);}};RepeaterModifier.prototype.resetElements=function(elements){var i;var len=elements.length;for(i=0;i<len;i+=1){elements[i]._processed=false;if(elements[i].ty==='gr'){this.resetElements(elements[i].it);}}};RepeaterModifier.prototype.cloneElements=function(elements){var newElements=JSON.parse(JSON.stringify(elements));this.resetElements(newElements);return newElements;};RepeaterModifier.prototype.changeGroupRender=function(elements,renderFlag){var i;var len=elements.length;for(i=0;i<len;i+=1){elements[i]._render=renderFlag;if(elements[i].ty==='gr'){this.changeGroupRender(elements[i].it,renderFlag);}}};RepeaterModifier.prototype.processShapes=function(_isFirstFrame){var items;var itemsTransform;var i;var dir;var cont;var hasReloaded=false;if(this._mdf||_isFirstFrame){var copies=Math.ceil(this.c.v);if(this._groups.length<copies){while(this._groups.length<copies){var group={it:this.cloneElements(this._elements),ty:'gr'};group.it.push({a:{a:0,ix:1,k:[0,0]},nm:'Transform',o:{a:0,ix:7,k:100},p:{a:0,ix:2,k:[0,0]},r:{a:1,ix:6,k:[{s:0,e:0,t:0},{s:0,e:0,t:1}]},s:{a:0,ix:3,k:[100,100]},sa:{a:0,ix:5,k:0},sk:{a:0,ix:4,k:0},ty:'tr'});this.arr.splice(0,0,group);this._groups.splice(0,0,group);this._currentCopies+=1;}this.elem.reloadShapes();hasReloaded=true;}cont=0;var renderFlag;for(i=0;i<=this._groups.length-1;i+=1){renderFlag=cont<copies;this._groups[i]._render=renderFlag;this.changeGroupRender(this._groups[i].it,renderFlag);if(!renderFlag){var elems=this.elemsData[i].it;var transformData=elems[elems.length-1];if(transformData.transform.op.v!==0){transformData.transform.op._mdf=true;transformData.transform.op.v=0;}else {transformData.transform.op._mdf=false;}}cont+=1;}this._currentCopies=copies;/// /
	var offset=this.o.v;var offsetModulo=offset%1;var roundOffset=offset>0?Math.floor(offset):Math.ceil(offset);var pProps=this.pMatrix.props;var rProps=this.rMatrix.props;var sProps=this.sMatrix.props;this.pMatrix.reset();this.rMatrix.reset();this.sMatrix.reset();this.tMatrix.reset();this.matrix.reset();var iteration=0;if(offset>0){while(iteration<roundOffset){this.applyTransforms(this.pMatrix,this.rMatrix,this.sMatrix,this.tr,1,false);iteration+=1;}if(offsetModulo){this.applyTransforms(this.pMatrix,this.rMatrix,this.sMatrix,this.tr,offsetModulo,false);iteration+=offsetModulo;}}else if(offset<0){while(iteration>roundOffset){this.applyTransforms(this.pMatrix,this.rMatrix,this.sMatrix,this.tr,1,true);iteration-=1;}if(offsetModulo){this.applyTransforms(this.pMatrix,this.rMatrix,this.sMatrix,this.tr,-offsetModulo,true);iteration-=offsetModulo;}}i=this.data.m===1?0:this._currentCopies-1;dir=this.data.m===1?1:-1;cont=this._currentCopies;var j;var jLen;while(cont){items=this.elemsData[i].it;itemsTransform=items[items.length-1].transform.mProps.v.props;jLen=itemsTransform.length;items[items.length-1].transform.mProps._mdf=true;items[items.length-1].transform.op._mdf=true;items[items.length-1].transform.op.v=this._currentCopies===1?this.so.v:this.so.v+(this.eo.v-this.so.v)*(i/(this._currentCopies-1));if(iteration!==0){if(i!==0&&dir===1||i!==this._currentCopies-1&&dir===-1){this.applyTransforms(this.pMatrix,this.rMatrix,this.sMatrix,this.tr,1,false);}this.matrix.transform(rProps[0],rProps[1],rProps[2],rProps[3],rProps[4],rProps[5],rProps[6],rProps[7],rProps[8],rProps[9],rProps[10],rProps[11],rProps[12],rProps[13],rProps[14],rProps[15]);this.matrix.transform(sProps[0],sProps[1],sProps[2],sProps[3],sProps[4],sProps[5],sProps[6],sProps[7],sProps[8],sProps[9],sProps[10],sProps[11],sProps[12],sProps[13],sProps[14],sProps[15]);this.matrix.transform(pProps[0],pProps[1],pProps[2],pProps[3],pProps[4],pProps[5],pProps[6],pProps[7],pProps[8],pProps[9],pProps[10],pProps[11],pProps[12],pProps[13],pProps[14],pProps[15]);for(j=0;j<jLen;j+=1){itemsTransform[j]=this.matrix.props[j];}this.matrix.reset();}else {this.matrix.reset();for(j=0;j<jLen;j+=1){itemsTransform[j]=this.matrix.props[j];}}iteration+=1;cont-=1;i+=dir;}}else {cont=this._currentCopies;i=0;dir=1;while(cont){items=this.elemsData[i].it;itemsTransform=items[items.length-1].transform.mProps.v.props;items[items.length-1].transform.mProps._mdf=false;items[items.length-1].transform.op._mdf=false;cont-=1;i+=dir;}}return hasReloaded;};RepeaterModifier.prototype.addShape=function(){};function RoundCornersModifier(){}extendPrototype([ShapeModifier],RoundCornersModifier);RoundCornersModifier.prototype.initModifierProperties=function(elem,data){this.getValue=this.processKeys;this.rd=PropertyFactory.getProp(elem,data.r,0,null,this);this._isAnimated=!!this.rd.effectsSequence.length;};RoundCornersModifier.prototype.processPath=function(path,round){var clonedPath=shapePool.newElement();clonedPath.c=path.c;var i;var len=path._length;var currentV;var currentI;var currentO;var closerV;var distance;var newPosPerc;var index=0;var vX;var vY;var oX;var oY;var iX;var iY;for(i=0;i<len;i+=1){currentV=path.v[i];currentO=path.o[i];currentI=path.i[i];if(currentV[0]===currentO[0]&&currentV[1]===currentO[1]&&currentV[0]===currentI[0]&&currentV[1]===currentI[1]){if((i===0||i===len-1)&&!path.c){clonedPath.setTripleAt(currentV[0],currentV[1],currentO[0],currentO[1],currentI[0],currentI[1],index);/* clonedPath.v[index] = currentV;
	                  clonedPath.o[index] = currentO;
	                  clonedPath.i[index] = currentI; */index+=1;}else {if(i===0){closerV=path.v[len-1];}else {closerV=path.v[i-1];}distance=Math.sqrt(Math.pow(currentV[0]-closerV[0],2)+Math.pow(currentV[1]-closerV[1],2));newPosPerc=distance?Math.min(distance/2,round)/distance:0;iX=currentV[0]+(closerV[0]-currentV[0])*newPosPerc;vX=iX;iY=currentV[1]-(currentV[1]-closerV[1])*newPosPerc;vY=iY;oX=vX-(vX-currentV[0])*roundCorner;oY=vY-(vY-currentV[1])*roundCorner;clonedPath.setTripleAt(vX,vY,oX,oY,iX,iY,index);index+=1;if(i===len-1){closerV=path.v[0];}else {closerV=path.v[i+1];}distance=Math.sqrt(Math.pow(currentV[0]-closerV[0],2)+Math.pow(currentV[1]-closerV[1],2));newPosPerc=distance?Math.min(distance/2,round)/distance:0;oX=currentV[0]+(closerV[0]-currentV[0])*newPosPerc;vX=oX;oY=currentV[1]+(closerV[1]-currentV[1])*newPosPerc;vY=oY;iX=vX-(vX-currentV[0])*roundCorner;iY=vY-(vY-currentV[1])*roundCorner;clonedPath.setTripleAt(vX,vY,oX,oY,iX,iY,index);index+=1;}}else {clonedPath.setTripleAt(path.v[i][0],path.v[i][1],path.o[i][0],path.o[i][1],path.i[i][0],path.i[i][1],index);index+=1;}}return clonedPath;};RoundCornersModifier.prototype.processShapes=function(_isFirstFrame){var shapePaths;var i;var len=this.shapes.length;var j;var jLen;var rd=this.rd.v;if(rd!==0){var shapeData;var localShapeCollection;for(i=0;i<len;i+=1){shapeData=this.shapes[i];localShapeCollection=shapeData.localShapeCollection;if(!(!shapeData.shape._mdf&&!this._mdf&&!_isFirstFrame)){localShapeCollection.releaseShapes();shapeData.shape._mdf=true;shapePaths=shapeData.shape.paths.shapes;jLen=shapeData.shape.paths._length;for(j=0;j<jLen;j+=1){localShapeCollection.addShape(this.processPath(shapePaths[j],rd));}}shapeData.shape.paths=shapeData.localShapeCollection;}}if(!this.dynamicProperties.length){this._mdf=false;}};function floatEqual(a,b){return Math.abs(a-b)*100000<=Math.min(Math.abs(a),Math.abs(b));}function floatZero(f){return Math.abs(f)<=0.00001;}function lerp(p0,p1,amount){return p0*(1-amount)+p1*amount;}function lerpPoint(p0,p1,amount){return [lerp(p0[0],p1[0],amount),lerp(p0[1],p1[1],amount)];}function quadRoots(a,b,c){// no root
	if(a===0)return [];var s=b*b-4*a*c;// Complex roots
	if(s<0)return [];var singleRoot=-b/(2*a);// 1 root
	if(s===0)return [singleRoot];var delta=Math.sqrt(s)/(2*a);// 2 roots
	return [singleRoot-delta,singleRoot+delta];}function polynomialCoefficients(p0,p1,p2,p3){return [-p0+3*p1-3*p2+p3,3*p0-6*p1+3*p2,-3*p0+3*p1,p0];}function singlePoint(p){return new PolynomialBezier(p,p,p,p,false);}function PolynomialBezier(p0,p1,p2,p3,linearize){if(linearize&&pointEqual(p0,p1)){p1=lerpPoint(p0,p3,1/3);}if(linearize&&pointEqual(p2,p3)){p2=lerpPoint(p0,p3,2/3);}var coeffx=polynomialCoefficients(p0[0],p1[0],p2[0],p3[0]);var coeffy=polynomialCoefficients(p0[1],p1[1],p2[1],p3[1]);this.a=[coeffx[0],coeffy[0]];this.b=[coeffx[1],coeffy[1]];this.c=[coeffx[2],coeffy[2]];this.d=[coeffx[3],coeffy[3]];this.points=[p0,p1,p2,p3];}PolynomialBezier.prototype.point=function(t){return [((this.a[0]*t+this.b[0])*t+this.c[0])*t+this.d[0],((this.a[1]*t+this.b[1])*t+this.c[1])*t+this.d[1]];};PolynomialBezier.prototype.derivative=function(t){return [(3*t*this.a[0]+2*this.b[0])*t+this.c[0],(3*t*this.a[1]+2*this.b[1])*t+this.c[1]];};PolynomialBezier.prototype.tangentAngle=function(t){var p=this.derivative(t);return Math.atan2(p[1],p[0]);};PolynomialBezier.prototype.normalAngle=function(t){var p=this.derivative(t);return Math.atan2(p[0],p[1]);};PolynomialBezier.prototype.inflectionPoints=function(){var denom=this.a[1]*this.b[0]-this.a[0]*this.b[1];if(floatZero(denom))return [];var tcusp=-0.5*(this.a[1]*this.c[0]-this.a[0]*this.c[1])/denom;var square=tcusp*tcusp-1/3*(this.b[1]*this.c[0]-this.b[0]*this.c[1])/denom;if(square<0)return [];var root=Math.sqrt(square);if(floatZero(root)){if(root>0&&root<1)return [tcusp];return [];}return [tcusp-root,tcusp+root].filter(function(r){return r>0&&r<1;});};PolynomialBezier.prototype.split=function(t){if(t<=0)return [singlePoint(this.points[0]),this];if(t>=1)return [this,singlePoint(this.points[this.points.length-1])];var p10=lerpPoint(this.points[0],this.points[1],t);var p11=lerpPoint(this.points[1],this.points[2],t);var p12=lerpPoint(this.points[2],this.points[3],t);var p20=lerpPoint(p10,p11,t);var p21=lerpPoint(p11,p12,t);var p3=lerpPoint(p20,p21,t);return [new PolynomialBezier(this.points[0],p10,p20,p3,true),new PolynomialBezier(p3,p21,p12,this.points[3],true)];};function extrema(bez,comp){var min=bez.points[0][comp];var max=bez.points[bez.points.length-1][comp];if(min>max){var e=max;max=min;min=e;}// Derivative roots to find min/max
	var f=quadRoots(3*bez.a[comp],2*bez.b[comp],bez.c[comp]);for(var i=0;i<f.length;i+=1){if(f[i]>0&&f[i]<1){var val=bez.point(f[i])[comp];if(val<min)min=val;else if(val>max)max=val;}}return {min:min,max:max};}PolynomialBezier.prototype.bounds=function(){return {x:extrema(this,0),y:extrema(this,1)};};PolynomialBezier.prototype.boundingBox=function(){var bounds=this.bounds();return {left:bounds.x.min,right:bounds.x.max,top:bounds.y.min,bottom:bounds.y.max,width:bounds.x.max-bounds.x.min,height:bounds.y.max-bounds.y.min,cx:(bounds.x.max+bounds.x.min)/2,cy:(bounds.y.max+bounds.y.min)/2};};function intersectData(bez,t1,t2){var box=bez.boundingBox();return {cx:box.cx,cy:box.cy,width:box.width,height:box.height,bez:bez,t:(t1+t2)/2,t1:t1,t2:t2};}function splitData(data){var split=data.bez.split(0.5);return [intersectData(split[0],data.t1,data.t),intersectData(split[1],data.t,data.t2)];}function boxIntersect(b1,b2){return Math.abs(b1.cx-b2.cx)*2<b1.width+b2.width&&Math.abs(b1.cy-b2.cy)*2<b1.height+b2.height;}function intersectsImpl(d1,d2,depth,tolerance,intersections,maxRecursion){if(!boxIntersect(d1,d2))return;if(depth>=maxRecursion||d1.width<=tolerance&&d1.height<=tolerance&&d2.width<=tolerance&&d2.height<=tolerance){intersections.push([d1.t,d2.t]);return;}var d1s=splitData(d1);var d2s=splitData(d2);intersectsImpl(d1s[0],d2s[0],depth+1,tolerance,intersections,maxRecursion);intersectsImpl(d1s[0],d2s[1],depth+1,tolerance,intersections,maxRecursion);intersectsImpl(d1s[1],d2s[0],depth+1,tolerance,intersections,maxRecursion);intersectsImpl(d1s[1],d2s[1],depth+1,tolerance,intersections,maxRecursion);}PolynomialBezier.prototype.intersections=function(other,tolerance,maxRecursion){if(tolerance===undefined)tolerance=2;if(maxRecursion===undefined)maxRecursion=7;var intersections=[];intersectsImpl(intersectData(this,0,1),intersectData(other,0,1),0,tolerance,intersections,maxRecursion);return intersections;};PolynomialBezier.shapeSegment=function(shapePath,index){var nextIndex=(index+1)%shapePath.length();return new PolynomialBezier(shapePath.v[index],shapePath.o[index],shapePath.i[nextIndex],shapePath.v[nextIndex],true);};PolynomialBezier.shapeSegmentInverted=function(shapePath,index){var nextIndex=(index+1)%shapePath.length();return new PolynomialBezier(shapePath.v[nextIndex],shapePath.i[nextIndex],shapePath.o[index],shapePath.v[index],true);};function crossProduct(a,b){return [a[1]*b[2]-a[2]*b[1],a[2]*b[0]-a[0]*b[2],a[0]*b[1]-a[1]*b[0]];}function lineIntersection(start1,end1,start2,end2){var v1=[start1[0],start1[1],1];var v2=[end1[0],end1[1],1];var v3=[start2[0],start2[1],1];var v4=[end2[0],end2[1],1];var r=crossProduct(crossProduct(v1,v2),crossProduct(v3,v4));if(floatZero(r[2]))return null;return [r[0]/r[2],r[1]/r[2]];}function polarOffset(p,angle,length){return [p[0]+Math.cos(angle)*length,p[1]-Math.sin(angle)*length];}function pointDistance(p1,p2){return Math.hypot(p1[0]-p2[0],p1[1]-p2[1]);}function pointEqual(p1,p2){return floatEqual(p1[0],p2[0])&&floatEqual(p1[1],p2[1]);}function ZigZagModifier(){}extendPrototype([ShapeModifier],ZigZagModifier);ZigZagModifier.prototype.initModifierProperties=function(elem,data){this.getValue=this.processKeys;this.amplitude=PropertyFactory.getProp(elem,data.s,0,null,this);this.frequency=PropertyFactory.getProp(elem,data.r,0,null,this);this.pointsType=PropertyFactory.getProp(elem,data.pt,0,null,this);this._isAnimated=this.amplitude.effectsSequence.length!==0||this.frequency.effectsSequence.length!==0||this.pointsType.effectsSequence.length!==0;};function setPoint(outputBezier,point,angle,direction,amplitude,outAmplitude,inAmplitude){var angO=angle-Math.PI/2;var angI=angle+Math.PI/2;var px=point[0]+Math.cos(angle)*direction*amplitude;var py=point[1]-Math.sin(angle)*direction*amplitude;outputBezier.setTripleAt(px,py,px+Math.cos(angO)*outAmplitude,py-Math.sin(angO)*outAmplitude,px+Math.cos(angI)*inAmplitude,py-Math.sin(angI)*inAmplitude,outputBezier.length());}function getPerpendicularVector(pt1,pt2){var vector=[pt2[0]-pt1[0],pt2[1]-pt1[1]];var rot=-Math.PI*0.5;var rotatedVector=[Math.cos(rot)*vector[0]-Math.sin(rot)*vector[1],Math.sin(rot)*vector[0]+Math.cos(rot)*vector[1]];return rotatedVector;}function getProjectingAngle(path,cur){var prevIndex=cur===0?path.length()-1:cur-1;var nextIndex=(cur+1)%path.length();var prevPoint=path.v[prevIndex];var nextPoint=path.v[nextIndex];var pVector=getPerpendicularVector(prevPoint,nextPoint);return Math.atan2(0,1)-Math.atan2(pVector[1],pVector[0]);}function zigZagCorner(outputBezier,path,cur,amplitude,frequency,pointType,direction){var angle=getProjectingAngle(path,cur);var point=path.v[cur%path._length];var prevPoint=path.v[cur===0?path._length-1:cur-1];var nextPoint=path.v[(cur+1)%path._length];var prevDist=pointType===2?Math.sqrt(Math.pow(point[0]-prevPoint[0],2)+Math.pow(point[1]-prevPoint[1],2)):0;var nextDist=pointType===2?Math.sqrt(Math.pow(point[0]-nextPoint[0],2)+Math.pow(point[1]-nextPoint[1],2)):0;setPoint(outputBezier,path.v[cur%path._length],angle,direction,amplitude,nextDist/((frequency+1)*2),prevDist/((frequency+1)*2));}function zigZagSegment(outputBezier,segment,amplitude,frequency,pointType,direction){for(var i=0;i<frequency;i+=1){var t=(i+1)/(frequency+1);var dist=pointType===2?Math.sqrt(Math.pow(segment.points[3][0]-segment.points[0][0],2)+Math.pow(segment.points[3][1]-segment.points[0][1],2)):0;var angle=segment.normalAngle(t);var point=segment.point(t);setPoint(outputBezier,point,angle,direction,amplitude,dist/((frequency+1)*2),dist/((frequency+1)*2));direction=-direction;}return direction;}ZigZagModifier.prototype.processPath=function(path,amplitude,frequency,pointType){var count=path._length;var clonedPath=shapePool.newElement();clonedPath.c=path.c;if(!path.c){count-=1;}if(count===0)return clonedPath;var direction=-1;var segment=PolynomialBezier.shapeSegment(path,0);zigZagCorner(clonedPath,path,0,amplitude,frequency,pointType,direction);for(var i=0;i<count;i+=1){direction=zigZagSegment(clonedPath,segment,amplitude,frequency,pointType,-direction);if(i===count-1&&!path.c){segment=null;}else {segment=PolynomialBezier.shapeSegment(path,(i+1)%count);}zigZagCorner(clonedPath,path,i+1,amplitude,frequency,pointType,direction);}return clonedPath;};ZigZagModifier.prototype.processShapes=function(_isFirstFrame){var shapePaths;var i;var len=this.shapes.length;var j;var jLen;var amplitude=this.amplitude.v;var frequency=Math.max(0,Math.round(this.frequency.v));var pointType=this.pointsType.v;if(amplitude!==0){var shapeData;var localShapeCollection;for(i=0;i<len;i+=1){shapeData=this.shapes[i];localShapeCollection=shapeData.localShapeCollection;if(!(!shapeData.shape._mdf&&!this._mdf&&!_isFirstFrame)){localShapeCollection.releaseShapes();shapeData.shape._mdf=true;shapePaths=shapeData.shape.paths.shapes;jLen=shapeData.shape.paths._length;for(j=0;j<jLen;j+=1){localShapeCollection.addShape(this.processPath(shapePaths[j],amplitude,frequency,pointType));}}shapeData.shape.paths=shapeData.localShapeCollection;}}if(!this.dynamicProperties.length){this._mdf=false;}};function linearOffset(p1,p2,amount){var angle=Math.atan2(p2[0]-p1[0],p2[1]-p1[1]);return [polarOffset(p1,angle,amount),polarOffset(p2,angle,amount)];}function offsetSegment(segment,amount){var p0;var p1a;var p1b;var p2b;var p2a;var p3;var e;e=linearOffset(segment.points[0],segment.points[1],amount);p0=e[0];p1a=e[1];e=linearOffset(segment.points[1],segment.points[2],amount);p1b=e[0];p2b=e[1];e=linearOffset(segment.points[2],segment.points[3],amount);p2a=e[0];p3=e[1];var p1=lineIntersection(p0,p1a,p1b,p2b);if(p1===null)p1=p1a;var p2=lineIntersection(p2a,p3,p1b,p2b);if(p2===null)p2=p2a;return new PolynomialBezier(p0,p1,p2,p3);}function joinLines(outputBezier,seg1,seg2,lineJoin,miterLimit){var p0=seg1.points[3];var p1=seg2.points[0];// Bevel
	if(lineJoin===3)return p0;// Connected, they don't need a joint
	if(pointEqual(p0,p1))return p0;// Round
	if(lineJoin===2){var angleOut=-seg1.tangentAngle(1);var angleIn=-seg2.tangentAngle(0)+Math.PI;var center=lineIntersection(p0,polarOffset(p0,angleOut+Math.PI/2,100),p1,polarOffset(p1,angleOut+Math.PI/2,100));var radius=center?pointDistance(center,p0):pointDistance(p0,p1)/2;var tan=polarOffset(p0,angleOut,2*radius*roundCorner);outputBezier.setXYAt(tan[0],tan[1],'o',outputBezier.length()-1);tan=polarOffset(p1,angleIn,2*radius*roundCorner);outputBezier.setTripleAt(p1[0],p1[1],p1[0],p1[1],tan[0],tan[1],outputBezier.length());return p1;}// Miter
	var t0=pointEqual(p0,seg1.points[2])?seg1.points[0]:seg1.points[2];var t1=pointEqual(p1,seg2.points[1])?seg2.points[3]:seg2.points[1];var intersection=lineIntersection(t0,p0,p1,t1);if(intersection&&pointDistance(intersection,p0)<miterLimit){outputBezier.setTripleAt(intersection[0],intersection[1],intersection[0],intersection[1],intersection[0],intersection[1],outputBezier.length());return intersection;}return p0;}function getIntersection(a,b){var intersect=a.intersections(b);if(intersect.length&&floatEqual(intersect[0][0],1))intersect.shift();if(intersect.length)return intersect[0];return null;}function pruneSegmentIntersection(a,b){var outa=a.slice();var outb=b.slice();var intersect=getIntersection(a[a.length-1],b[0]);if(intersect){outa[a.length-1]=a[a.length-1].split(intersect[0])[0];outb[0]=b[0].split(intersect[1])[1];}if(a.length>1&&b.length>1){intersect=getIntersection(a[0],b[b.length-1]);if(intersect){return [[a[0].split(intersect[0])[0]],[b[b.length-1].split(intersect[1])[1]]];}}return [outa,outb];}function pruneIntersections(segments){var e;for(var i=1;i<segments.length;i+=1){e=pruneSegmentIntersection(segments[i-1],segments[i]);segments[i-1]=e[0];segments[i]=e[1];}if(segments.length>1){e=pruneSegmentIntersection(segments[segments.length-1],segments[0]);segments[segments.length-1]=e[0];segments[0]=e[1];}return segments;}function offsetSegmentSplit(segment,amount){/*
	      We split each bezier segment into smaller pieces based
	      on inflection points, this ensures the control point
	      polygon is convex.
	        (A cubic bezier can have none, one, or two inflection points)
	    */var flex=segment.inflectionPoints();var left;var right;var split;var mid;if(flex.length===0){return [offsetSegment(segment,amount)];}if(flex.length===1||floatEqual(flex[1],1)){split=segment.split(flex[0]);left=split[0];right=split[1];return [offsetSegment(left,amount),offsetSegment(right,amount)];}split=segment.split(flex[0]);left=split[0];var t=(flex[1]-flex[0])/(1-flex[0]);split=split[1].split(t);mid=split[0];right=split[1];return [offsetSegment(left,amount),offsetSegment(mid,amount),offsetSegment(right,amount)];}function OffsetPathModifier(){}extendPrototype([ShapeModifier],OffsetPathModifier);OffsetPathModifier.prototype.initModifierProperties=function(elem,data){this.getValue=this.processKeys;this.amount=PropertyFactory.getProp(elem,data.a,0,null,this);this.miterLimit=PropertyFactory.getProp(elem,data.ml,0,null,this);this.lineJoin=data.lj;this._isAnimated=this.amount.effectsSequence.length!==0;};OffsetPathModifier.prototype.processPath=function(inputBezier,amount,lineJoin,miterLimit){var outputBezier=shapePool.newElement();outputBezier.c=inputBezier.c;var count=inputBezier.length();if(!inputBezier.c){count-=1;}var i;var j;var segment;var multiSegments=[];for(i=0;i<count;i+=1){segment=PolynomialBezier.shapeSegment(inputBezier,i);multiSegments.push(offsetSegmentSplit(segment,amount));}if(!inputBezier.c){for(i=count-1;i>=0;i-=1){segment=PolynomialBezier.shapeSegmentInverted(inputBezier,i);multiSegments.push(offsetSegmentSplit(segment,amount));}}multiSegments=pruneIntersections(multiSegments);// Add bezier segments to the output and apply line joints
	var lastPoint=null;var lastSeg=null;for(i=0;i<multiSegments.length;i+=1){var multiSegment=multiSegments[i];if(lastSeg)lastPoint=joinLines(outputBezier,lastSeg,multiSegment[0],lineJoin,miterLimit);lastSeg=multiSegment[multiSegment.length-1];for(j=0;j<multiSegment.length;j+=1){segment=multiSegment[j];if(lastPoint&&pointEqual(segment.points[0],lastPoint)){outputBezier.setXYAt(segment.points[1][0],segment.points[1][1],'o',outputBezier.length()-1);}else {outputBezier.setTripleAt(segment.points[0][0],segment.points[0][1],segment.points[1][0],segment.points[1][1],segment.points[0][0],segment.points[0][1],outputBezier.length());}outputBezier.setTripleAt(segment.points[3][0],segment.points[3][1],segment.points[3][0],segment.points[3][1],segment.points[2][0],segment.points[2][1],outputBezier.length());lastPoint=segment.points[3];}}if(multiSegments.length)joinLines(outputBezier,lastSeg,multiSegments[0][0],lineJoin,miterLimit);return outputBezier;};OffsetPathModifier.prototype.processShapes=function(_isFirstFrame){var shapePaths;var i;var len=this.shapes.length;var j;var jLen;var amount=this.amount.v;var miterLimit=this.miterLimit.v;var lineJoin=this.lineJoin;if(amount!==0){var shapeData;var localShapeCollection;for(i=0;i<len;i+=1){shapeData=this.shapes[i];localShapeCollection=shapeData.localShapeCollection;if(!(!shapeData.shape._mdf&&!this._mdf&&!_isFirstFrame)){localShapeCollection.releaseShapes();shapeData.shape._mdf=true;shapePaths=shapeData.shape.paths.shapes;jLen=shapeData.shape.paths._length;for(j=0;j<jLen;j+=1){localShapeCollection.addShape(this.processPath(shapePaths[j],amount,lineJoin,miterLimit));}}shapeData.shape.paths=shapeData.localShapeCollection;}}if(!this.dynamicProperties.length){this._mdf=false;}};function getFontProperties(fontData){var styles=fontData.fStyle?fontData.fStyle.split(' '):[];var fWeight='normal';var fStyle='normal';var len=styles.length;var styleName;for(var i=0;i<len;i+=1){styleName=styles[i].toLowerCase();switch(styleName){case'italic':fStyle='italic';break;case'bold':fWeight='700';break;case'black':fWeight='900';break;case'medium':fWeight='500';break;case'regular':case'normal':fWeight='400';break;case'light':case'thin':fWeight='200';break;}}return {style:fStyle,weight:fontData.fWeight||fWeight};}var FontManager=function(){var maxWaitingTime=5000;var emptyChar={w:0,size:0,shapes:[],data:{shapes:[]}};var combinedCharacters=[];// Hindi characters
	combinedCharacters=combinedCharacters.concat([2304,2305,2306,2307,2362,2363,2364,2364,2366,2367,2368,2369,2370,2371,2372,2373,2374,2375,2376,2377,2378,2379,2380,2381,2382,2383,2387,2388,2389,2390,2391,2402,2403]);var BLACK_FLAG_CODE_POINT=127988;var CANCEL_TAG_CODE_POINT=917631;var A_TAG_CODE_POINT=917601;var Z_TAG_CODE_POINT=917626;var VARIATION_SELECTOR_16_CODE_POINT=65039;var ZERO_WIDTH_JOINER_CODE_POINT=8205;var REGIONAL_CHARACTER_A_CODE_POINT=127462;var REGIONAL_CHARACTER_Z_CODE_POINT=127487;var surrogateModifiers=['d83cdffb','d83cdffc','d83cdffd','d83cdffe','d83cdfff'];function trimFontOptions(font){var familyArray=font.split(',');var i;var len=familyArray.length;var enabledFamilies=[];for(i=0;i<len;i+=1){if(familyArray[i]!=='sans-serif'&&familyArray[i]!=='monospace'){enabledFamilies.push(familyArray[i]);}}return enabledFamilies.join(',');}function setUpNode(font,family){var parentNode=createTag('span');// Node is invisible to screen readers.
	parentNode.setAttribute('aria-hidden',true);parentNode.style.fontFamily=family;var node=createTag('span');// Characters that vary significantly among different fonts
	node.innerText='giItT1WQy@!-/#';// Visible - so we can measure it - but not on the screen
	parentNode.style.position='absolute';parentNode.style.left='-10000px';parentNode.style.top='-10000px';// Large font size makes even subtle changes obvious
	parentNode.style.fontSize='300px';// Reset any font properties
	parentNode.style.fontVariant='normal';parentNode.style.fontStyle='normal';parentNode.style.fontWeight='normal';parentNode.style.letterSpacing='0';parentNode.appendChild(node);document.body.appendChild(parentNode);// Remember width with no applied web font
	var width=node.offsetWidth;node.style.fontFamily=trimFontOptions(font)+', '+family;return {node:node,w:width,parent:parentNode};}function checkLoadedFonts(){var i;var len=this.fonts.length;var node;var w;var loadedCount=len;for(i=0;i<len;i+=1){if(this.fonts[i].loaded){loadedCount-=1;}else if(this.fonts[i].fOrigin==='n'||this.fonts[i].origin===0){this.fonts[i].loaded=true;}else {node=this.fonts[i].monoCase.node;w=this.fonts[i].monoCase.w;if(node.offsetWidth!==w){loadedCount-=1;this.fonts[i].loaded=true;}else {node=this.fonts[i].sansCase.node;w=this.fonts[i].sansCase.w;if(node.offsetWidth!==w){loadedCount-=1;this.fonts[i].loaded=true;}}if(this.fonts[i].loaded){this.fonts[i].sansCase.parent.parentNode.removeChild(this.fonts[i].sansCase.parent);this.fonts[i].monoCase.parent.parentNode.removeChild(this.fonts[i].monoCase.parent);}}}if(loadedCount!==0&&Date.now()-this.initTime<maxWaitingTime){setTimeout(this.checkLoadedFontsBinded,20);}else {setTimeout(this.setIsLoadedBinded,10);}}function createHelper(fontData,def){var engine=document.body&&def?'svg':'canvas';var helper;var fontProps=getFontProperties(fontData);if(engine==='svg'){var tHelper=createNS('text');tHelper.style.fontSize='100px';// tHelper.style.fontFamily = fontData.fFamily;
	tHelper.setAttribute('font-family',fontData.fFamily);tHelper.setAttribute('font-style',fontProps.style);tHelper.setAttribute('font-weight',fontProps.weight);tHelper.textContent='1';if(fontData.fClass){tHelper.style.fontFamily='inherit';tHelper.setAttribute('class',fontData.fClass);}else {tHelper.style.fontFamily=fontData.fFamily;}def.appendChild(tHelper);helper=tHelper;}else {var tCanvasHelper=new OffscreenCanvas(500,500).getContext('2d');tCanvasHelper.font=fontProps.style+' '+fontProps.weight+' 100px '+fontData.fFamily;helper=tCanvasHelper;}function measure(text){if(engine==='svg'){helper.textContent=text;return helper.getComputedTextLength();}return helper.measureText(text).width;}return {measureText:measure};}function addFonts(fontData,defs){if(!fontData){this.isLoaded=true;return;}if(this.chars){this.isLoaded=true;this.fonts=fontData.list;return;}if(!document.body){this.isLoaded=true;fontData.list.forEach(function(data){data.helper=createHelper(data);data.cache={};});this.fonts=fontData.list;return;}var fontArr=fontData.list;var i;var len=fontArr.length;var _pendingFonts=len;for(i=0;i<len;i+=1){var shouldLoadFont=true;var loadedSelector;var j;fontArr[i].loaded=false;fontArr[i].monoCase=setUpNode(fontArr[i].fFamily,'monospace');fontArr[i].sansCase=setUpNode(fontArr[i].fFamily,'sans-serif');if(!fontArr[i].fPath){fontArr[i].loaded=true;_pendingFonts-=1;}else if(fontArr[i].fOrigin==='p'||fontArr[i].origin===3){loadedSelector=document.querySelectorAll('style[f-forigin="p"][f-family="'+fontArr[i].fFamily+'"], style[f-origin="3"][f-family="'+fontArr[i].fFamily+'"]');if(loadedSelector.length>0){shouldLoadFont=false;}if(shouldLoadFont){var s=createTag('style');s.setAttribute('f-forigin',fontArr[i].fOrigin);s.setAttribute('f-origin',fontArr[i].origin);s.setAttribute('f-family',fontArr[i].fFamily);s.type='text/css';s.innerText='@font-face {font-family: '+fontArr[i].fFamily+"; font-style: normal; src: url('"+fontArr[i].fPath+"');}";defs.appendChild(s);}}else if(fontArr[i].fOrigin==='g'||fontArr[i].origin===1){loadedSelector=document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]');for(j=0;j<loadedSelector.length;j+=1){if(loadedSelector[j].href.indexOf(fontArr[i].fPath)!==-1){// Font is already loaded
	shouldLoadFont=false;}}if(shouldLoadFont){var l=createTag('link');l.setAttribute('f-forigin',fontArr[i].fOrigin);l.setAttribute('f-origin',fontArr[i].origin);l.type='text/css';l.rel='stylesheet';l.href=fontArr[i].fPath;document.body.appendChild(l);}}else if(fontArr[i].fOrigin==='t'||fontArr[i].origin===2){loadedSelector=document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]');for(j=0;j<loadedSelector.length;j+=1){if(fontArr[i].fPath===loadedSelector[j].src){// Font is already loaded
	shouldLoadFont=false;}}if(shouldLoadFont){var sc=createTag('link');sc.setAttribute('f-forigin',fontArr[i].fOrigin);sc.setAttribute('f-origin',fontArr[i].origin);sc.setAttribute('rel','stylesheet');sc.setAttribute('href',fontArr[i].fPath);defs.appendChild(sc);}}fontArr[i].helper=createHelper(fontArr[i],defs);fontArr[i].cache={};this.fonts.push(fontArr[i]);}if(_pendingFonts===0){this.isLoaded=true;}else {// On some cases even if the font is loaded, it won't load correctly when measuring text on canvas.
	// Adding this timeout seems to fix it
	setTimeout(this.checkLoadedFonts.bind(this),100);}}function addChars(chars){if(!chars){return;}if(!this.chars){this.chars=[];}var i;var len=chars.length;var j;var jLen=this.chars.length;var found;for(i=0;i<len;i+=1){j=0;found=false;while(j<jLen){if(this.chars[j].style===chars[i].style&&this.chars[j].fFamily===chars[i].fFamily&&this.chars[j].ch===chars[i].ch){found=true;}j+=1;}if(!found){this.chars.push(chars[i]);jLen+=1;}}}function getCharData(_char,style,font){var i=0;var len=this.chars.length;while(i<len){if(this.chars[i].ch===_char&&this.chars[i].style===style&&this.chars[i].fFamily===font){return this.chars[i];}i+=1;}if((typeof _char==='string'&&_char.charCodeAt(0)!==13||!_char)&&console&&console.warn// eslint-disable-line no-console
	&&!this._warned){this._warned=true;console.warn('Missing character from exported characters list: ',_char,style,font);// eslint-disable-line no-console
	}return emptyChar;}function measureText(_char2,fontName,size){var fontData=this.getFontByName(fontName);// Using the char instead of char.charCodeAt(0)
	// to avoid collisions between equal chars
	var index=_char2;if(!fontData.cache[index]){var tHelper=fontData.helper;if(_char2===' '){var doubleSize=tHelper.measureText('|'+_char2+'|');var singleSize=tHelper.measureText('||');fontData.cache[index]=(doubleSize-singleSize)/100;}else {fontData.cache[index]=tHelper.measureText(_char2)/100;}}return fontData.cache[index]*size;}function getFontByName(name){var i=0;var len=this.fonts.length;while(i<len){if(this.fonts[i].fName===name){return this.fonts[i];}i+=1;}return this.fonts[0];}function getCodePoint(string){var codePoint=0;var first=string.charCodeAt(0);if(first>=0xD800&&first<=0xDBFF){var second=string.charCodeAt(1);if(second>=0xDC00&&second<=0xDFFF){codePoint=(first-0xD800)*0x400+second-0xDC00+0x10000;}}return codePoint;}// Skin tone modifiers
	function isModifier(firstCharCode,secondCharCode){var sum=firstCharCode.toString(16)+secondCharCode.toString(16);return surrogateModifiers.indexOf(sum)!==-1;}function isZeroWidthJoiner(charCode){return charCode===ZERO_WIDTH_JOINER_CODE_POINT;}// This codepoint may change the appearance of the preceding character.
	// If that is a symbol, dingbat or emoji, U+FE0F forces it to be rendered
	// as a colorful image as compared to a monochrome text variant.
	function isVariationSelector(charCode){return charCode===VARIATION_SELECTOR_16_CODE_POINT;}// The regional indicator symbols are a set of 26 alphabetic Unicode
	/// characters (A–Z) intended to be used to encode ISO 3166-1 alpha-2
	// two-letter country codes in a way that allows optional special treatment.
	function isRegionalCode(string){var codePoint=getCodePoint(string);if(codePoint>=REGIONAL_CHARACTER_A_CODE_POINT&&codePoint<=REGIONAL_CHARACTER_Z_CODE_POINT){return true;}return false;}// Some Emoji implementations represent combinations of
	// two “regional indicator” letters as a single flag symbol.
	function isFlagEmoji(string){return isRegionalCode(string.substr(0,2))&&isRegionalCode(string.substr(2,2));}function isCombinedCharacter(_char3){return combinedCharacters.indexOf(_char3)!==-1;}// Regional flags start with a BLACK_FLAG_CODE_POINT
	// folowed by 5 chars in the TAG range
	// and end with a CANCEL_TAG_CODE_POINT
	function isRegionalFlag(text,index){var codePoint=getCodePoint(text.substr(index,2));if(codePoint!==BLACK_FLAG_CODE_POINT){return false;}var count=0;index+=2;while(count<5){codePoint=getCodePoint(text.substr(index,2));if(codePoint<A_TAG_CODE_POINT||codePoint>Z_TAG_CODE_POINT){return false;}count+=1;index+=2;}return getCodePoint(text.substr(index,2))===CANCEL_TAG_CODE_POINT;}function setIsLoaded(){this.isLoaded=true;}var Font=function Font(){this.fonts=[];this.chars=null;this.typekitLoaded=0;this.isLoaded=false;this._warned=false;this.initTime=Date.now();this.setIsLoadedBinded=this.setIsLoaded.bind(this);this.checkLoadedFontsBinded=this.checkLoadedFonts.bind(this);};Font.isModifier=isModifier;Font.isZeroWidthJoiner=isZeroWidthJoiner;Font.isFlagEmoji=isFlagEmoji;Font.isRegionalCode=isRegionalCode;Font.isCombinedCharacter=isCombinedCharacter;Font.isRegionalFlag=isRegionalFlag;Font.isVariationSelector=isVariationSelector;Font.BLACK_FLAG_CODE_POINT=BLACK_FLAG_CODE_POINT;var fontPrototype={addChars:addChars,addFonts:addFonts,getCharData:getCharData,getFontByName:getFontByName,measureText:measureText,checkLoadedFonts:checkLoadedFonts,setIsLoaded:setIsLoaded};Font.prototype=fontPrototype;return Font;}();function SlotManager(animationData){this.animationData=animationData;}SlotManager.prototype.getProp=function(data){if(this.animationData.slots&&this.animationData.slots[data.sid]){return Object.assign(data,this.animationData.slots[data.sid].p);}return data;};function slotFactory(animationData){return new SlotManager(animationData);}function RenderableElement(){}RenderableElement.prototype={initRenderable:function initRenderable(){// layer's visibility related to inpoint and outpoint. Rename isVisible to isInRange
	this.isInRange=false;// layer's display state
	this.hidden=false;// If layer's transparency equals 0, it can be hidden
	this.isTransparent=false;// list of animated components
	this.renderableComponents=[];},addRenderableComponent:function addRenderableComponent(component){if(this.renderableComponents.indexOf(component)===-1){this.renderableComponents.push(component);}},removeRenderableComponent:function removeRenderableComponent(component){if(this.renderableComponents.indexOf(component)!==-1){this.renderableComponents.splice(this.renderableComponents.indexOf(component),1);}},prepareRenderableFrame:function prepareRenderableFrame(num){this.checkLayerLimits(num);},checkTransparency:function checkTransparency(){if(this.finalTransform.mProp.o.v<=0){if(!this.isTransparent&&this.globalData.renderConfig.hideOnTransparent){this.isTransparent=true;this.hide();}}else if(this.isTransparent){this.isTransparent=false;this.show();}},/**
	       * @function
	       * Initializes frame related properties.
	       *
	       * @param {number} num
	       * current frame number in Layer's time
	       *
	       */checkLayerLimits:function checkLayerLimits(num){if(this.data.ip-this.data.st<=num&&this.data.op-this.data.st>num){if(this.isInRange!==true){this.globalData._mdf=true;this._mdf=true;this.isInRange=true;this.show();}}else if(this.isInRange!==false){this.globalData._mdf=true;this.isInRange=false;this.hide();}},renderRenderable:function renderRenderable(){var i;var len=this.renderableComponents.length;for(i=0;i<len;i+=1){this.renderableComponents[i].renderFrame(this._isFirstFrame);}/* this.maskManager.renderFrame(this.finalTransform.mat);
	          this.renderableEffectsManager.renderFrame(this._isFirstFrame); */},sourceRectAtTime:function sourceRectAtTime(){return {top:0,left:0,width:100,height:100};},getLayerSize:function getLayerSize(){if(this.data.ty===5){return {w:this.data.textData.width,h:this.data.textData.height};}return {w:this.data.width,h:this.data.height};}};var getBlendMode=function(){var blendModeEnums={0:'source-over',1:'multiply',2:'screen',3:'overlay',4:'darken',5:'lighten',6:'color-dodge',7:'color-burn',8:'hard-light',9:'soft-light',10:'difference',11:'exclusion',12:'hue',13:'saturation',14:'color',15:'luminosity'};return function(mode){return blendModeEnums[mode]||'';};}();function SliderEffect(data,elem,container){this.p=PropertyFactory.getProp(elem,data.v,0,0,container);}function AngleEffect(data,elem,container){this.p=PropertyFactory.getProp(elem,data.v,0,0,container);}function ColorEffect(data,elem,container){this.p=PropertyFactory.getProp(elem,data.v,1,0,container);}function PointEffect(data,elem,container){this.p=PropertyFactory.getProp(elem,data.v,1,0,container);}function LayerIndexEffect(data,elem,container){this.p=PropertyFactory.getProp(elem,data.v,0,0,container);}function MaskIndexEffect(data,elem,container){this.p=PropertyFactory.getProp(elem,data.v,0,0,container);}function CheckboxEffect(data,elem,container){this.p=PropertyFactory.getProp(elem,data.v,0,0,container);}function NoValueEffect(){this.p={};}function EffectsManager(data,element){var effects=data.ef||[];this.effectElements=[];var i;var len=effects.length;var effectItem;for(i=0;i<len;i+=1){effectItem=new GroupEffect(effects[i],element);this.effectElements.push(effectItem);}}function GroupEffect(data,element){this.init(data,element);}extendPrototype([DynamicPropertyContainer],GroupEffect);GroupEffect.prototype.getValue=GroupEffect.prototype.iterateDynamicProperties;GroupEffect.prototype.init=function(data,element){this.data=data;this.effectElements=[];this.initDynamicPropertyContainer(element);var i;var len=this.data.ef.length;var eff;var effects=this.data.ef;for(i=0;i<len;i+=1){eff=null;switch(effects[i].ty){case 0:eff=new SliderEffect(effects[i],element,this);break;case 1:eff=new AngleEffect(effects[i],element,this);break;case 2:eff=new ColorEffect(effects[i],element,this);break;case 3:eff=new PointEffect(effects[i],element,this);break;case 4:case 7:eff=new CheckboxEffect(effects[i],element,this);break;case 10:eff=new LayerIndexEffect(effects[i],element,this);break;case 11:eff=new MaskIndexEffect(effects[i],element,this);break;case 5:eff=new EffectsManager(effects[i],element);break;// case 6:
	default:eff=new NoValueEffect(effects[i]);break;}if(eff){this.effectElements.push(eff);}}};function BaseElement(){}BaseElement.prototype={checkMasks:function checkMasks(){if(!this.data.hasMask){return false;}var i=0;var len=this.data.masksProperties.length;while(i<len){if(this.data.masksProperties[i].mode!=='n'&&this.data.masksProperties[i].cl!==false){return true;}i+=1;}return false;},initExpressions:function initExpressions(){var expressionsInterfaces=getExpressionInterfaces();if(!expressionsInterfaces){return;}var LayerExpressionInterface=expressionsInterfaces('layer');var EffectsExpressionInterface=expressionsInterfaces('effects');var ShapeExpressionInterface=expressionsInterfaces('shape');var TextExpressionInterface=expressionsInterfaces('text');var CompExpressionInterface=expressionsInterfaces('comp');this.layerInterface=LayerExpressionInterface(this);if(this.data.hasMask&&this.maskManager){this.layerInterface.registerMaskInterface(this.maskManager);}var effectsInterface=EffectsExpressionInterface.createEffectsInterface(this,this.layerInterface);this.layerInterface.registerEffectsInterface(effectsInterface);if(this.data.ty===0||this.data.xt){this.compInterface=CompExpressionInterface(this);}else if(this.data.ty===4){this.layerInterface.shapeInterface=ShapeExpressionInterface(this.shapesData,this.itemsData,this.layerInterface);this.layerInterface.content=this.layerInterface.shapeInterface;}else if(this.data.ty===5){this.layerInterface.textInterface=TextExpressionInterface(this);this.layerInterface.text=this.layerInterface.textInterface;}},setBlendMode:function setBlendMode(){var blendModeValue=getBlendMode(this.data.bm);var elem=this.baseElement||this.layerElement;elem.style['mix-blend-mode']=blendModeValue;},initBaseData:function initBaseData(data,globalData,comp){this.globalData=globalData;this.comp=comp;this.data=data;this.layerId=createElementID();// Stretch factor for old animations missing this property.
	if(!this.data.sr){this.data.sr=1;}// effects manager
	this.effectsManager=new EffectsManager(this.data,this,this.dynamicProperties);},getType:function getType(){return this.type;},sourceRectAtTime:function sourceRectAtTime(){}};/**
	   * @file
	   * Handles element's layer frame update.
	   * Checks layer in point and out point
	   *
	   */function FrameElement(){}FrameElement.prototype={/**
	       * @function
	       * Initializes frame related properties.
	       *
	       */initFrame:function initFrame(){// set to true when inpoint is rendered
	this._isFirstFrame=false;// list of animated properties
	this.dynamicProperties=[];// If layer has been modified in current tick this will be true
	this._mdf=false;},/**
	       * @function
	       * Calculates all dynamic values
	       *
	       * @param {number} num
	       * current frame number in Layer's time
	       * @param {boolean} isVisible
	       * if layers is currently in range
	       *
	       */prepareProperties:function prepareProperties(num,isVisible){var i;var len=this.dynamicProperties.length;for(i=0;i<len;i+=1){if(isVisible||this._isParent&&this.dynamicProperties[i].propType==='transform'){this.dynamicProperties[i].getValue();if(this.dynamicProperties[i]._mdf){this.globalData._mdf=true;this._mdf=true;}}}},addDynamicProperty:function addDynamicProperty(prop){if(this.dynamicProperties.indexOf(prop)===-1){this.dynamicProperties.push(prop);}}};function FootageElement(data,globalData,comp){this.initFrame();this.initRenderable();this.assetData=globalData.getAssetData(data.refId);this.footageData=globalData.imageLoader.getAsset(this.assetData);this.initBaseData(data,globalData,comp);}FootageElement.prototype.prepareFrame=function(){};extendPrototype([RenderableElement,BaseElement,FrameElement],FootageElement);FootageElement.prototype.getBaseElement=function(){return null;};FootageElement.prototype.renderFrame=function(){};FootageElement.prototype.destroy=function(){};FootageElement.prototype.initExpressions=function(){var expressionsInterfaces=getExpressionInterfaces();if(!expressionsInterfaces){return;}var FootageInterface=expressionsInterfaces('footage');this.layerInterface=FootageInterface(this);};FootageElement.prototype.getFootageData=function(){return this.footageData;};function AudioElement(data,globalData,comp){this.initFrame();this.initRenderable();this.assetData=globalData.getAssetData(data.refId);this.initBaseData(data,globalData,comp);this._isPlaying=false;this._canPlay=false;var assetPath=this.globalData.getAssetsPath(this.assetData);this.audio=this.globalData.audioController.createAudio(assetPath);this._currentTime=0;this.globalData.audioController.addAudio(this);this._volumeMultiplier=1;this._volume=1;this._previousVolume=null;this.tm=data.tm?PropertyFactory.getProp(this,data.tm,0,globalData.frameRate,this):{_placeholder:true};this.lv=PropertyFactory.getProp(this,data.au&&data.au.lv?data.au.lv:{k:[100]},1,0.01,this);}AudioElement.prototype.prepareFrame=function(num){this.prepareRenderableFrame(num,true);this.prepareProperties(num,true);if(!this.tm._placeholder){var timeRemapped=this.tm.v;this._currentTime=timeRemapped;}else {this._currentTime=num/this.data.sr;}this._volume=this.lv.v[0];var totalVolume=this._volume*this._volumeMultiplier;if(this._previousVolume!==totalVolume){this._previousVolume=totalVolume;this.audio.volume(totalVolume);}};extendPrototype([RenderableElement,BaseElement,FrameElement],AudioElement);AudioElement.prototype.renderFrame=function(){if(this.isInRange&&this._canPlay){if(!this._isPlaying){this.audio.play();this.audio.seek(this._currentTime/this.globalData.frameRate);this._isPlaying=true;}else if(!this.audio.playing()||Math.abs(this._currentTime/this.globalData.frameRate-this.audio.seek())>0.1){this.audio.seek(this._currentTime/this.globalData.frameRate);}}};AudioElement.prototype.show=function(){// this.audio.play()
	};AudioElement.prototype.hide=function(){this.audio.pause();this._isPlaying=false;};AudioElement.prototype.pause=function(){this.audio.pause();this._isPlaying=false;this._canPlay=false;};AudioElement.prototype.resume=function(){this._canPlay=true;};AudioElement.prototype.setRate=function(rateValue){this.audio.rate(rateValue);};AudioElement.prototype.volume=function(volumeValue){this._volumeMultiplier=volumeValue;this._previousVolume=volumeValue*this._volume;this.audio.volume(this._previousVolume);};AudioElement.prototype.getBaseElement=function(){return null;};AudioElement.prototype.destroy=function(){};AudioElement.prototype.sourceRectAtTime=function(){};AudioElement.prototype.initExpressions=function(){};function BaseRenderer(){}BaseRenderer.prototype.checkLayers=function(num){var i;var len=this.layers.length;var data;this.completeLayers=true;for(i=len-1;i>=0;i-=1){if(!this.elements[i]){data=this.layers[i];if(data.ip-data.st<=num-this.layers[i].st&&data.op-data.st>num-this.layers[i].st){this.buildItem(i);}}this.completeLayers=this.elements[i]?this.completeLayers:false;}this.checkPendingElements();};BaseRenderer.prototype.createItem=function(layer){switch(layer.ty){case 2:return this.createImage(layer);case 0:return this.createComp(layer);case 1:return this.createSolid(layer);case 3:return this.createNull(layer);case 4:return this.createShape(layer);case 5:return this.createText(layer);case 6:return this.createAudio(layer);case 13:return this.createCamera(layer);case 15:return this.createFootage(layer);default:return this.createNull(layer);}};BaseRenderer.prototype.createCamera=function(){throw new Error('You\'re using a 3d camera. Try the html renderer.');};BaseRenderer.prototype.createAudio=function(data){return new AudioElement(data,this.globalData,this);};BaseRenderer.prototype.createFootage=function(data){return new FootageElement(data,this.globalData,this);};BaseRenderer.prototype.buildAllItems=function(){var i;var len=this.layers.length;for(i=0;i<len;i+=1){this.buildItem(i);}this.checkPendingElements();};BaseRenderer.prototype.includeLayers=function(newLayers){this.completeLayers=false;var i;var len=newLayers.length;var j;var jLen=this.layers.length;for(i=0;i<len;i+=1){j=0;while(j<jLen){if(this.layers[j].id===newLayers[i].id){this.layers[j]=newLayers[i];break;}j+=1;}}};BaseRenderer.prototype.setProjectInterface=function(pInterface){this.globalData.projectInterface=pInterface;};BaseRenderer.prototype.initItems=function(){if(!this.globalData.progressiveLoad){this.buildAllItems();}};BaseRenderer.prototype.buildElementParenting=function(element,parentName,hierarchy){var elements=this.elements;var layers=this.layers;var i=0;var len=layers.length;while(i<len){if(layers[i].ind==parentName){// eslint-disable-line eqeqeq
	if(!elements[i]||elements[i]===true){this.buildItem(i);this.addPendingElement(element);}else {hierarchy.push(elements[i]);elements[i].setAsParent();if(layers[i].parent!==undefined){this.buildElementParenting(element,layers[i].parent,hierarchy);}else {element.setHierarchy(hierarchy);}}}i+=1;}};BaseRenderer.prototype.addPendingElement=function(element){this.pendingElements.push(element);};BaseRenderer.prototype.searchExtraCompositions=function(assets){var i;var len=assets.length;for(i=0;i<len;i+=1){if(assets[i].xt){var comp=this.createComp(assets[i]);comp.initExpressions();this.globalData.projectInterface.registerComposition(comp);}}};BaseRenderer.prototype.getElementById=function(ind){var i;var len=this.elements.length;for(i=0;i<len;i+=1){if(this.elements[i].data.ind===ind){return this.elements[i];}}return null;};BaseRenderer.prototype.getElementByPath=function(path){var pathValue=path.shift();var element;if(typeof pathValue==='number'){element=this.elements[pathValue];}else {var i;var len=this.elements.length;for(i=0;i<len;i+=1){if(this.elements[i].data.nm===pathValue){element=this.elements[i];break;}}}if(path.length===0){return element;}return element.getElementByPath(path);};BaseRenderer.prototype.setupGlobalData=function(animData,fontsContainer){this.globalData.fontManager=new FontManager();this.globalData.slotManager=slotFactory(animData);this.globalData.fontManager.addChars(animData.chars);this.globalData.fontManager.addFonts(animData.fonts,fontsContainer);this.globalData.getAssetData=this.animationItem.getAssetData.bind(this.animationItem);this.globalData.getAssetsPath=this.animationItem.getAssetsPath.bind(this.animationItem);this.globalData.imageLoader=this.animationItem.imagePreloader;this.globalData.audioController=this.animationItem.audioController;this.globalData.frameId=0;this.globalData.frameRate=animData.fr;this.globalData.nm=animData.nm;this.globalData.compSize={w:animData.w,h:animData.h};};var effectTypes={TRANSFORM_EFFECT:'transformEFfect'};function TransformElement(){}TransformElement.prototype={initTransform:function initTransform(){var mat=new Matrix();this.finalTransform={mProp:this.data.ks?TransformPropertyFactory.getTransformProperty(this,this.data.ks,this):{o:0},_matMdf:false,_localMatMdf:false,_opMdf:false,mat:mat,localMat:mat,localOpacity:1};if(this.data.ao){this.finalTransform.mProp.autoOriented=true;}// TODO: check TYPE 11: Guided elements
	if(this.data.ty!==11);},renderTransform:function renderTransform(){this.finalTransform._opMdf=this.finalTransform.mProp.o._mdf||this._isFirstFrame;this.finalTransform._matMdf=this.finalTransform.mProp._mdf||this._isFirstFrame;if(this.hierarchy){var mat;var finalMat=this.finalTransform.mat;var i=0;var len=this.hierarchy.length;// Checking if any of the transformation matrices in the hierarchy chain has changed.
	if(!this.finalTransform._matMdf){while(i<len){if(this.hierarchy[i].finalTransform.mProp._mdf){this.finalTransform._matMdf=true;break;}i+=1;}}if(this.finalTransform._matMdf){mat=this.finalTransform.mProp.v.props;finalMat.cloneFromProps(mat);for(i=0;i<len;i+=1){finalMat.multiply(this.hierarchy[i].finalTransform.mProp.v);}}}if(this.finalTransform._matMdf){this.finalTransform._localMatMdf=this.finalTransform._matMdf;}if(this.finalTransform._opMdf){this.finalTransform.localOpacity=this.finalTransform.mProp.o.v;}},renderLocalTransform:function renderLocalTransform(){if(this.localTransforms){var i=0;var len=this.localTransforms.length;this.finalTransform._localMatMdf=this.finalTransform._matMdf;if(!this.finalTransform._localMatMdf||!this.finalTransform._opMdf){while(i<len){if(this.localTransforms[i]._mdf){this.finalTransform._localMatMdf=true;}if(this.localTransforms[i]._opMdf&&!this.finalTransform._opMdf){this.finalTransform.localOpacity=this.finalTransform.mProp.o.v;this.finalTransform._opMdf=true;}i+=1;}}if(this.finalTransform._localMatMdf){var localMat=this.finalTransform.localMat;this.localTransforms[0].matrix.clone(localMat);for(i=1;i<len;i+=1){var lmat=this.localTransforms[i].matrix;localMat.multiply(lmat);}localMat.multiply(this.finalTransform.mat);}if(this.finalTransform._opMdf){var localOp=this.finalTransform.localOpacity;for(i=0;i<len;i+=1){localOp*=this.localTransforms[i].opacity*0.01;}this.finalTransform.localOpacity=localOp;}}},searchEffectTransforms:function searchEffectTransforms(){if(this.renderableEffectsManager){var transformEffects=this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);if(transformEffects.length){this.localTransforms=[];this.finalTransform.localMat=new Matrix();var i=0;var len=transformEffects.length;for(i=0;i<len;i+=1){this.localTransforms.push(transformEffects[i]);}}}},globalToLocal:function globalToLocal(pt){var transforms=[];transforms.push(this.finalTransform);var flag=true;var comp=this.comp;while(flag){if(comp.finalTransform){if(comp.data.hasMask){transforms.splice(0,0,comp.finalTransform);}comp=comp.comp;}else {flag=false;}}var i;var len=transforms.length;var ptNew;for(i=0;i<len;i+=1){ptNew=transforms[i].mat.applyToPointArray(0,0,0);// ptNew = transforms[i].mat.applyToPointArray(pt[0],pt[1],pt[2]);
	pt=[pt[0]-ptNew[0],pt[1]-ptNew[1],0];}return pt;},mHelper:new Matrix()};function MaskElement(data,element,globalData){this.data=data;this.element=element;this.globalData=globalData;this.storedData=[];this.masksProperties=this.data.masksProperties||[];this.maskElement=null;var defs=this.globalData.defs;var i;var len=this.masksProperties?this.masksProperties.length:0;this.viewData=createSizedArray(len);this.solidPath='';var path;var properties=this.masksProperties;var count=0;var currentMasks=[];var j;var jLen;var layerId=createElementID();var rect;var expansor;var feMorph;var x;var maskType='clipPath';var maskRef='clip-path';for(i=0;i<len;i+=1){if(properties[i].mode!=='a'&&properties[i].mode!=='n'||properties[i].inv||properties[i].o.k!==100||properties[i].o.x){maskType='mask';maskRef='mask';}if((properties[i].mode==='s'||properties[i].mode==='i')&&count===0){rect=createNS('rect');rect.setAttribute('fill','#ffffff');rect.setAttribute('width',this.element.comp.data.w||0);rect.setAttribute('height',this.element.comp.data.h||0);currentMasks.push(rect);}else {rect=null;}path=createNS('path');if(properties[i].mode==='n'){// TODO move this to a factory or to a constructor
	this.viewData[i]={op:PropertyFactory.getProp(this.element,properties[i].o,0,0.01,this.element),prop:ShapePropertyFactory.getShapeProp(this.element,properties[i],3),elem:path,lastPath:''};defs.appendChild(path);}else {count+=1;path.setAttribute('fill',properties[i].mode==='s'?'#000000':'#ffffff');path.setAttribute('clip-rule','nonzero');var filterID;if(properties[i].x.k!==0){maskType='mask';maskRef='mask';x=PropertyFactory.getProp(this.element,properties[i].x,0,null,this.element);filterID=createElementID();expansor=createNS('filter');expansor.setAttribute('id',filterID);feMorph=createNS('feMorphology');feMorph.setAttribute('operator','erode');feMorph.setAttribute('in','SourceGraphic');feMorph.setAttribute('radius','0');expansor.appendChild(feMorph);defs.appendChild(expansor);path.setAttribute('stroke',properties[i].mode==='s'?'#000000':'#ffffff');}else {feMorph=null;x=null;}// TODO move this to a factory or to a constructor
	this.storedData[i]={elem:path,x:x,expan:feMorph,lastPath:'',lastOperator:'',filterId:filterID,lastRadius:0};if(properties[i].mode==='i'){jLen=currentMasks.length;var g=createNS('g');for(j=0;j<jLen;j+=1){g.appendChild(currentMasks[j]);}var mask=createNS('mask');mask.setAttribute('mask-type','alpha');mask.setAttribute('id',layerId+'_'+count);mask.appendChild(path);defs.appendChild(mask);g.setAttribute('mask','url('+getLocationHref()+'#'+layerId+'_'+count+')');currentMasks.length=0;currentMasks.push(g);}else {currentMasks.push(path);}if(properties[i].inv&&!this.solidPath){this.solidPath=this.createLayerSolidPath();}// TODO move this to a factory or to a constructor
	this.viewData[i]={elem:path,lastPath:'',op:PropertyFactory.getProp(this.element,properties[i].o,0,0.01,this.element),prop:ShapePropertyFactory.getShapeProp(this.element,properties[i],3),invRect:rect};if(!this.viewData[i].prop.k){this.drawPath(properties[i],this.viewData[i].prop.v,this.viewData[i]);}}}this.maskElement=createNS(maskType);len=currentMasks.length;for(i=0;i<len;i+=1){this.maskElement.appendChild(currentMasks[i]);}if(count>0){this.maskElement.setAttribute('id',layerId);this.element.maskedElement.setAttribute(maskRef,'url('+getLocationHref()+'#'+layerId+')');defs.appendChild(this.maskElement);}if(this.viewData.length){this.element.addRenderableComponent(this);}}MaskElement.prototype.getMaskProperty=function(pos){return this.viewData[pos].prop;};MaskElement.prototype.renderFrame=function(isFirstFrame){var finalMat=this.element.finalTransform.mat;var i;var len=this.masksProperties.length;for(i=0;i<len;i+=1){if(this.viewData[i].prop._mdf||isFirstFrame){this.drawPath(this.masksProperties[i],this.viewData[i].prop.v,this.viewData[i]);}if(this.viewData[i].op._mdf||isFirstFrame){this.viewData[i].elem.setAttribute('fill-opacity',this.viewData[i].op.v);}if(this.masksProperties[i].mode!=='n'){if(this.viewData[i].invRect&&(this.element.finalTransform.mProp._mdf||isFirstFrame)){this.viewData[i].invRect.setAttribute('transform',finalMat.getInverseMatrix().to2dCSS());}if(this.storedData[i].x&&(this.storedData[i].x._mdf||isFirstFrame)){var feMorph=this.storedData[i].expan;if(this.storedData[i].x.v<0){if(this.storedData[i].lastOperator!=='erode'){this.storedData[i].lastOperator='erode';this.storedData[i].elem.setAttribute('filter','url('+getLocationHref()+'#'+this.storedData[i].filterId+')');}feMorph.setAttribute('radius',-this.storedData[i].x.v);}else {if(this.storedData[i].lastOperator!=='dilate'){this.storedData[i].lastOperator='dilate';this.storedData[i].elem.setAttribute('filter',null);}this.storedData[i].elem.setAttribute('stroke-width',this.storedData[i].x.v*2);}}}}};MaskElement.prototype.getMaskelement=function(){return this.maskElement;};MaskElement.prototype.createLayerSolidPath=function(){var path='M0,0 ';path+=' h'+this.globalData.compSize.w;path+=' v'+this.globalData.compSize.h;path+=' h-'+this.globalData.compSize.w;path+=' v-'+this.globalData.compSize.h+' ';return path;};MaskElement.prototype.drawPath=function(pathData,pathNodes,viewData){var pathString=' M'+pathNodes.v[0][0]+','+pathNodes.v[0][1];var i;var len;len=pathNodes._length;for(i=1;i<len;i+=1){// pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[i][0]+','+pathNodes.i[i][1] + " "+pathNodes.v[i][0]+','+pathNodes.v[i][1];
	pathString+=' C'+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1]+' '+pathNodes.i[i][0]+','+pathNodes.i[i][1]+' '+pathNodes.v[i][0]+','+pathNodes.v[i][1];}// pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[0][0]+','+pathNodes.i[0][1] + " "+pathNodes.v[0][0]+','+pathNodes.v[0][1];
	if(pathNodes.c&&len>1){pathString+=' C'+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1]+' '+pathNodes.i[0][0]+','+pathNodes.i[0][1]+' '+pathNodes.v[0][0]+','+pathNodes.v[0][1];}// pathNodes.__renderedString = pathString;
	if(viewData.lastPath!==pathString){var pathShapeValue='';if(viewData.elem){if(pathNodes.c){pathShapeValue=pathData.inv?this.solidPath+pathString:pathString;}viewData.elem.setAttribute('d',pathShapeValue);}viewData.lastPath=pathString;}};MaskElement.prototype.destroy=function(){this.element=null;this.globalData=null;this.maskElement=null;this.data=null;this.masksProperties=null;};var filtersFactory=function(){var ob={};ob.createFilter=createFilter;ob.createAlphaToLuminanceFilter=createAlphaToLuminanceFilter;function createFilter(filId,skipCoordinates){var fil=createNS('filter');fil.setAttribute('id',filId);if(skipCoordinates!==true){fil.setAttribute('filterUnits','objectBoundingBox');fil.setAttribute('x','0%');fil.setAttribute('y','0%');fil.setAttribute('width','100%');fil.setAttribute('height','100%');}return fil;}function createAlphaToLuminanceFilter(){var feColorMatrix=createNS('feColorMatrix');feColorMatrix.setAttribute('type','matrix');feColorMatrix.setAttribute('color-interpolation-filters','sRGB');feColorMatrix.setAttribute('values','0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1');return feColorMatrix;}return ob;}();var featureSupport=function(){var ob={maskType:true,svgLumaHidden:true,offscreenCanvas:typeof OffscreenCanvas!=='undefined'};if(/MSIE 10/i.test(navigator.userAgent)||/MSIE 9/i.test(navigator.userAgent)||/rv:11.0/i.test(navigator.userAgent)||/Edge\/\d./i.test(navigator.userAgent)){ob.maskType=false;}if(/firefox/i.test(navigator.userAgent)){ob.svgLumaHidden=false;}return ob;}();var registeredEffects$1={};var idPrefix='filter_result_';function SVGEffects(elem){var i;var source='SourceGraphic';var len=elem.data.ef?elem.data.ef.length:0;var filId=createElementID();var fil=filtersFactory.createFilter(filId,true);var count=0;this.filters=[];var filterManager;for(i=0;i<len;i+=1){filterManager=null;var type=elem.data.ef[i].ty;if(registeredEffects$1[type]){var Effect=registeredEffects$1[type].effect;filterManager=new Effect(fil,elem.effectsManager.effectElements[i],elem,idPrefix+count,source);source=idPrefix+count;if(registeredEffects$1[type].countsAsEffect){count+=1;}}if(filterManager){this.filters.push(filterManager);}}if(count){elem.globalData.defs.appendChild(fil);elem.layerElement.setAttribute('filter','url('+getLocationHref()+'#'+filId+')');}if(this.filters.length){elem.addRenderableComponent(this);}}SVGEffects.prototype.renderFrame=function(_isFirstFrame){var i;var len=this.filters.length;for(i=0;i<len;i+=1){this.filters[i].renderFrame(_isFirstFrame);}};SVGEffects.prototype.getEffects=function(type){var i;var len=this.filters.length;var effects=[];for(i=0;i<len;i+=1){if(this.filters[i].type===type){effects.push(this.filters[i]);}}return effects;};function registerEffect$1(id,effect,countsAsEffect){registeredEffects$1[id]={effect:effect,countsAsEffect:countsAsEffect};}function SVGBaseElement(){}SVGBaseElement.prototype={initRendererElement:function initRendererElement(){this.layerElement=createNS('g');},createContainerElements:function createContainerElements(){this.matteElement=createNS('g');this.transformedElement=this.layerElement;this.maskedElement=this.layerElement;this._sizeChanged=false;var layerElementParent=null;// If this layer acts as a mask for the following layer
	if(this.data.td){this.matteMasks={};var gg=createNS('g');gg.setAttribute('id',this.layerId);gg.appendChild(this.layerElement);layerElementParent=gg;this.globalData.defs.appendChild(gg);}else if(this.data.tt){this.matteElement.appendChild(this.layerElement);layerElementParent=this.matteElement;this.baseElement=this.matteElement;}else {this.baseElement=this.layerElement;}if(this.data.ln){this.layerElement.setAttribute('id',this.data.ln);}if(this.data.cl){this.layerElement.setAttribute('class',this.data.cl);}// Clipping compositions to hide content that exceeds boundaries. If collapsed transformations is on, component should not be clipped
	if(this.data.ty===0&&!this.data.hd){var cp=createNS('clipPath');var pt=createNS('path');pt.setAttribute('d','M0,0 L'+this.data.w+',0 L'+this.data.w+','+this.data.h+' L0,'+this.data.h+'z');var clipId=createElementID();cp.setAttribute('id',clipId);cp.appendChild(pt);this.globalData.defs.appendChild(cp);if(this.checkMasks()){var cpGroup=createNS('g');cpGroup.setAttribute('clip-path','url('+getLocationHref()+'#'+clipId+')');cpGroup.appendChild(this.layerElement);this.transformedElement=cpGroup;if(layerElementParent){layerElementParent.appendChild(this.transformedElement);}else {this.baseElement=this.transformedElement;}}else {this.layerElement.setAttribute('clip-path','url('+getLocationHref()+'#'+clipId+')');}}if(this.data.bm!==0){this.setBlendMode();}},renderElement:function renderElement(){if(this.finalTransform._localMatMdf){this.transformedElement.setAttribute('transform',this.finalTransform.localMat.to2dCSS());}if(this.finalTransform._opMdf){this.transformedElement.setAttribute('opacity',this.finalTransform.localOpacity);}},destroyBaseElement:function destroyBaseElement(){this.layerElement=null;this.matteElement=null;this.maskManager.destroy();},getBaseElement:function getBaseElement(){if(this.data.hd){return null;}return this.baseElement;},createRenderableComponents:function createRenderableComponents(){this.maskManager=new MaskElement(this.data,this,this.globalData);this.renderableEffectsManager=new SVGEffects(this);this.searchEffectTransforms();},getMatte:function getMatte(matteType){// This should not be a common case. But for backward compatibility, we'll create the matte object.
	// It solves animations that have two consecutive layers marked as matte masks.
	// Which is an undefined behavior in AE.
	if(!this.matteMasks){this.matteMasks={};}if(!this.matteMasks[matteType]){var id=this.layerId+'_'+matteType;var filId;var fil;var useElement;var gg;if(matteType===1||matteType===3){var masker=createNS('mask');masker.setAttribute('id',id);masker.setAttribute('mask-type',matteType===3?'luminance':'alpha');useElement=createNS('use');useElement.setAttributeNS('http://www.w3.org/1999/xlink','href','#'+this.layerId);masker.appendChild(useElement);this.globalData.defs.appendChild(masker);if(!featureSupport.maskType&&matteType===1){masker.setAttribute('mask-type','luminance');filId=createElementID();fil=filtersFactory.createFilter(filId);this.globalData.defs.appendChild(fil);fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());gg=createNS('g');gg.appendChild(useElement);masker.appendChild(gg);gg.setAttribute('filter','url('+getLocationHref()+'#'+filId+')');}}else if(matteType===2){var maskGroup=createNS('mask');maskGroup.setAttribute('id',id);maskGroup.setAttribute('mask-type','alpha');var maskGrouper=createNS('g');maskGroup.appendChild(maskGrouper);filId=createElementID();fil=filtersFactory.createFilter(filId);/// /
	var feCTr=createNS('feComponentTransfer');feCTr.setAttribute('in','SourceGraphic');fil.appendChild(feCTr);var feFunc=createNS('feFuncA');feFunc.setAttribute('type','table');feFunc.setAttribute('tableValues','1.0 0.0');feCTr.appendChild(feFunc);/// /
	this.globalData.defs.appendChild(fil);var alphaRect=createNS('rect');alphaRect.setAttribute('width',this.comp.data.w);alphaRect.setAttribute('height',this.comp.data.h);alphaRect.setAttribute('x','0');alphaRect.setAttribute('y','0');alphaRect.setAttribute('fill','#ffffff');alphaRect.setAttribute('opacity','0');maskGrouper.setAttribute('filter','url('+getLocationHref()+'#'+filId+')');maskGrouper.appendChild(alphaRect);useElement=createNS('use');useElement.setAttributeNS('http://www.w3.org/1999/xlink','href','#'+this.layerId);maskGrouper.appendChild(useElement);if(!featureSupport.maskType){maskGroup.setAttribute('mask-type','luminance');fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());gg=createNS('g');maskGrouper.appendChild(alphaRect);gg.appendChild(this.layerElement);maskGrouper.appendChild(gg);}this.globalData.defs.appendChild(maskGroup);}this.matteMasks[matteType]=id;}return this.matteMasks[matteType];},setMatte:function setMatte(id){if(!this.matteElement){return;}this.matteElement.setAttribute('mask','url('+getLocationHref()+'#'+id+')');}};/**
	   * @file
	   * Handles AE's layer parenting property.
	   *
	   */function HierarchyElement(){}HierarchyElement.prototype={/**
	       * @function
	       * Initializes hierarchy properties
	       *
	       */initHierarchy:function initHierarchy(){// element's parent list
	this.hierarchy=[];// if element is parent of another layer _isParent will be true
	this._isParent=false;this.checkParenting();},/**
	       * @function
	       * Sets layer's hierarchy.
	       * @param {array} hierarch
	       * layer's parent list
	       *
	       */setHierarchy:function setHierarchy(hierarchy){this.hierarchy=hierarchy;},/**
	       * @function
	       * Sets layer as parent.
	       *
	       */setAsParent:function setAsParent(){this._isParent=true;},/**
	       * @function
	       * Searches layer's parenting chain
	       *
	       */checkParenting:function checkParenting(){if(this.data.parent!==undefined){this.comp.buildElementParenting(this,this.data.parent,[]);}}};function RenderableDOMElement(){}(function(){var _prototype={initElement:function initElement(data,globalData,comp){this.initFrame();this.initBaseData(data,globalData,comp);this.initTransform(data,globalData,comp);this.initHierarchy();this.initRenderable();this.initRendererElement();this.createContainerElements();this.createRenderableComponents();this.createContent();this.hide();},hide:function hide(){// console.log('HIDE', this);
	if(!this.hidden&&(!this.isInRange||this.isTransparent)){var elem=this.baseElement||this.layerElement;elem.style.display='none';this.hidden=true;}},show:function show(){// console.log('SHOW', this);
	if(this.isInRange&&!this.isTransparent){if(!this.data.hd){var elem=this.baseElement||this.layerElement;elem.style.display='block';}this.hidden=false;this._isFirstFrame=true;}},renderFrame:function renderFrame(){// If it is exported as hidden (data.hd === true) no need to render
	// If it is not visible no need to render
	if(this.data.hd||this.hidden){return;}this.renderTransform();this.renderRenderable();this.renderLocalTransform();this.renderElement();this.renderInnerContent();if(this._isFirstFrame){this._isFirstFrame=false;}},renderInnerContent:function renderInnerContent(){},prepareFrame:function prepareFrame(num){this._mdf=false;this.prepareRenderableFrame(num);this.prepareProperties(num,this.isInRange);this.checkTransparency();},destroy:function destroy(){this.innerElem=null;this.destroyBaseElement();}};extendPrototype([RenderableElement,createProxyFunction(_prototype)],RenderableDOMElement);})();function IImageElement(data,globalData,comp){this.assetData=globalData.getAssetData(data.refId);if(this.assetData&&this.assetData.sid){this.assetData=globalData.slotManager.getProp(this.assetData);}this.initElement(data,globalData,comp);this.sourceRect={top:0,left:0,width:this.assetData.w,height:this.assetData.h};}extendPrototype([BaseElement,TransformElement,SVGBaseElement,HierarchyElement,FrameElement,RenderableDOMElement],IImageElement);IImageElement.prototype.createContent=function(){var assetPath=this.globalData.getAssetsPath(this.assetData);this.innerElem=createNS('image');this.innerElem.setAttribute('width',this.assetData.w+'px');this.innerElem.setAttribute('height',this.assetData.h+'px');this.innerElem.setAttribute('preserveAspectRatio',this.assetData.pr||this.globalData.renderConfig.imagePreserveAspectRatio);this.innerElem.setAttributeNS('http://www.w3.org/1999/xlink','href',assetPath);this.layerElement.appendChild(this.innerElem);};IImageElement.prototype.sourceRectAtTime=function(){return this.sourceRect;};function ProcessedElement(element,position){this.elem=element;this.pos=position;}function IShapeElement(){}IShapeElement.prototype={addShapeToModifiers:function addShapeToModifiers(data){var i;var len=this.shapeModifiers.length;for(i=0;i<len;i+=1){this.shapeModifiers[i].addShape(data);}},isShapeInAnimatedModifiers:function isShapeInAnimatedModifiers(data){var i=0;var len=this.shapeModifiers.length;while(i<len){if(this.shapeModifiers[i].isAnimatedWithShape(data)){return true;}}return false;},renderModifiers:function renderModifiers(){if(!this.shapeModifiers.length){return;}var i;var len=this.shapes.length;for(i=0;i<len;i+=1){this.shapes[i].sh.reset();}len=this.shapeModifiers.length;var shouldBreakProcess;for(i=len-1;i>=0;i-=1){shouldBreakProcess=this.shapeModifiers[i].processShapes(this._isFirstFrame);// workaround to fix cases where a repeater resets the shape so the following processes get called twice
	// TODO: find a better solution for this
	if(shouldBreakProcess){break;}}},searchProcessedElement:function searchProcessedElement(elem){var elements=this.processedElements;var i=0;var len=elements.length;while(i<len){if(elements[i].elem===elem){return elements[i].pos;}i+=1;}return 0;},addProcessedElement:function addProcessedElement(elem,pos){var elements=this.processedElements;var i=elements.length;while(i){i-=1;if(elements[i].elem===elem){elements[i].pos=pos;return;}}elements.push(new ProcessedElement(elem,pos));},prepareFrame:function prepareFrame(num){this.prepareRenderableFrame(num);this.prepareProperties(num,this.isInRange);}};var lineCapEnum={1:'butt',2:'round',3:'square'};var lineJoinEnum={1:'miter',2:'round',3:'bevel'};function SVGShapeData(transformers,level,shape){this.caches=[];this.styles=[];this.transformers=transformers;this.lStr='';this.sh=shape;this.lvl=level;// TODO find if there are some cases where _isAnimated can be false.
	// For now, since shapes add up with other shapes. They have to be calculated every time.
	// One way of finding out is checking if all styles associated to this shape depend only of this shape
	this._isAnimated=!!shape.k;// TODO: commenting this for now since all shapes are animated
	var i=0;var len=transformers.length;while(i<len){if(transformers[i].mProps.dynamicProperties.length){this._isAnimated=true;break;}i+=1;}}SVGShapeData.prototype.setAsAnimated=function(){this._isAnimated=true;};function SVGStyleData(data,level){this.data=data;this.type=data.ty;this.d='';this.lvl=level;this._mdf=false;this.closed=data.hd===true;this.pElem=createNS('path');this.msElem=null;}SVGStyleData.prototype.reset=function(){this.d='';this._mdf=false;};function DashProperty(elem,data,renderer,container){this.elem=elem;this.frameId=-1;this.dataProps=createSizedArray(data.length);this.renderer=renderer;this.k=false;this.dashStr='';this.dashArray=createTypedArray('float32',data.length?data.length-1:0);this.dashoffset=createTypedArray('float32',1);this.initDynamicPropertyContainer(container);var i;var len=data.length||0;var prop;for(i=0;i<len;i+=1){prop=PropertyFactory.getProp(elem,data[i].v,0,0,this);this.k=prop.k||this.k;this.dataProps[i]={n:data[i].n,p:prop};}if(!this.k){this.getValue(true);}this._isAnimated=this.k;}DashProperty.prototype.getValue=function(forceRender){if(this.elem.globalData.frameId===this.frameId&&!forceRender){return;}this.frameId=this.elem.globalData.frameId;this.iterateDynamicProperties();this._mdf=this._mdf||forceRender;if(this._mdf){var i=0;var len=this.dataProps.length;if(this.renderer==='svg'){this.dashStr='';}for(i=0;i<len;i+=1){if(this.dataProps[i].n!=='o'){if(this.renderer==='svg'){this.dashStr+=' '+this.dataProps[i].p.v;}else {this.dashArray[i]=this.dataProps[i].p.v;}}else {this.dashoffset[0]=this.dataProps[i].p.v;}}}};extendPrototype([DynamicPropertyContainer],DashProperty);function SVGStrokeStyleData(elem,data,styleOb){this.initDynamicPropertyContainer(elem);this.getValue=this.iterateDynamicProperties;this.o=PropertyFactory.getProp(elem,data.o,0,0.01,this);this.w=PropertyFactory.getProp(elem,data.w,0,null,this);this.d=new DashProperty(elem,data.d||{},'svg',this);this.c=PropertyFactory.getProp(elem,data.c,1,255,this);this.style=styleOb;this._isAnimated=!!this._isAnimated;}extendPrototype([DynamicPropertyContainer],SVGStrokeStyleData);function SVGFillStyleData(elem,data,styleOb){this.initDynamicPropertyContainer(elem);this.getValue=this.iterateDynamicProperties;this.o=PropertyFactory.getProp(elem,data.o,0,0.01,this);this.c=PropertyFactory.getProp(elem,data.c,1,255,this);this.style=styleOb;}extendPrototype([DynamicPropertyContainer],SVGFillStyleData);function SVGNoStyleData(elem,data,styleOb){this.initDynamicPropertyContainer(elem);this.getValue=this.iterateDynamicProperties;this.style=styleOb;}extendPrototype([DynamicPropertyContainer],SVGNoStyleData);function GradientProperty(elem,data,container){this.data=data;this.c=createTypedArray('uint8c',data.p*4);var cLength=data.k.k[0].s?data.k.k[0].s.length-data.p*4:data.k.k.length-data.p*4;this.o=createTypedArray('float32',cLength);this._cmdf=false;this._omdf=false;this._collapsable=this.checkCollapsable();this._hasOpacity=cLength;this.initDynamicPropertyContainer(container);this.prop=PropertyFactory.getProp(elem,data.k,1,null,this);this.k=this.prop.k;this.getValue(true);}GradientProperty.prototype.comparePoints=function(values,points){var i=0;var len=this.o.length/2;var diff;while(i<len){diff=Math.abs(values[i*4]-values[points*4+i*2]);if(diff>0.01){return false;}i+=1;}return true;};GradientProperty.prototype.checkCollapsable=function(){if(this.o.length/2!==this.c.length/4){return false;}if(this.data.k.k[0].s){var i=0;var len=this.data.k.k.length;while(i<len){if(!this.comparePoints(this.data.k.k[i].s,this.data.p)){return false;}i+=1;}}else if(!this.comparePoints(this.data.k.k,this.data.p)){return false;}return true;};GradientProperty.prototype.getValue=function(forceRender){this.prop.getValue();this._mdf=false;this._cmdf=false;this._omdf=false;if(this.prop._mdf||forceRender){var i;var len=this.data.p*4;var mult;var val;for(i=0;i<len;i+=1){mult=i%4===0?100:255;val=Math.round(this.prop.v[i]*mult);if(this.c[i]!==val){this.c[i]=val;this._cmdf=!forceRender;}}if(this.o.length){len=this.prop.v.length;for(i=this.data.p*4;i<len;i+=1){mult=i%2===0?100:1;val=i%2===0?Math.round(this.prop.v[i]*100):this.prop.v[i];if(this.o[i-this.data.p*4]!==val){this.o[i-this.data.p*4]=val;this._omdf=!forceRender;}}}this._mdf=!forceRender;}};extendPrototype([DynamicPropertyContainer],GradientProperty);function SVGGradientFillStyleData(elem,data,styleOb){this.initDynamicPropertyContainer(elem);this.getValue=this.iterateDynamicProperties;this.initGradientData(elem,data,styleOb);}SVGGradientFillStyleData.prototype.initGradientData=function(elem,data,styleOb){this.o=PropertyFactory.getProp(elem,data.o,0,0.01,this);this.s=PropertyFactory.getProp(elem,data.s,1,null,this);this.e=PropertyFactory.getProp(elem,data.e,1,null,this);this.h=PropertyFactory.getProp(elem,data.h||{k:0},0,0.01,this);this.a=PropertyFactory.getProp(elem,data.a||{k:0},0,degToRads,this);this.g=new GradientProperty(elem,data.g,this);this.style=styleOb;this.stops=[];this.setGradientData(styleOb.pElem,data);this.setGradientOpacity(data,styleOb);this._isAnimated=!!this._isAnimated;};SVGGradientFillStyleData.prototype.setGradientData=function(pathElement,data){var gradientId=createElementID();var gfill=createNS(data.t===1?'linearGradient':'radialGradient');gfill.setAttribute('id',gradientId);gfill.setAttribute('spreadMethod','pad');gfill.setAttribute('gradientUnits','userSpaceOnUse');var stops=[];var stop;var j;var jLen;jLen=data.g.p*4;for(j=0;j<jLen;j+=4){stop=createNS('stop');gfill.appendChild(stop);stops.push(stop);}pathElement.setAttribute(data.ty==='gf'?'fill':'stroke','url('+getLocationHref()+'#'+gradientId+')');this.gf=gfill;this.cst=stops;};SVGGradientFillStyleData.prototype.setGradientOpacity=function(data,styleOb){if(this.g._hasOpacity&&!this.g._collapsable){var stop;var j;var jLen;var mask=createNS('mask');var maskElement=createNS('path');mask.appendChild(maskElement);var opacityId=createElementID();var maskId=createElementID();mask.setAttribute('id',maskId);var opFill=createNS(data.t===1?'linearGradient':'radialGradient');opFill.setAttribute('id',opacityId);opFill.setAttribute('spreadMethod','pad');opFill.setAttribute('gradientUnits','userSpaceOnUse');jLen=data.g.k.k[0].s?data.g.k.k[0].s.length:data.g.k.k.length;var stops=this.stops;for(j=data.g.p*4;j<jLen;j+=2){stop=createNS('stop');stop.setAttribute('stop-color','rgb(255,255,255)');opFill.appendChild(stop);stops.push(stop);}maskElement.setAttribute(data.ty==='gf'?'fill':'stroke','url('+getLocationHref()+'#'+opacityId+')');if(data.ty==='gs'){maskElement.setAttribute('stroke-linecap',lineCapEnum[data.lc||2]);maskElement.setAttribute('stroke-linejoin',lineJoinEnum[data.lj||2]);if(data.lj===1){maskElement.setAttribute('stroke-miterlimit',data.ml);}}this.of=opFill;this.ms=mask;this.ost=stops;this.maskId=maskId;styleOb.msElem=maskElement;}};extendPrototype([DynamicPropertyContainer],SVGGradientFillStyleData);function SVGGradientStrokeStyleData(elem,data,styleOb){this.initDynamicPropertyContainer(elem);this.getValue=this.iterateDynamicProperties;this.w=PropertyFactory.getProp(elem,data.w,0,null,this);this.d=new DashProperty(elem,data.d||{},'svg',this);this.initGradientData(elem,data,styleOb);this._isAnimated=!!this._isAnimated;}extendPrototype([SVGGradientFillStyleData,DynamicPropertyContainer],SVGGradientStrokeStyleData);function ShapeGroupData(){this.it=[];this.prevViewData=[];this.gr=createNS('g');}function SVGTransformData(mProps,op,container){this.transform={mProps:mProps,op:op,container:container};this.elements=[];this._isAnimated=this.transform.mProps.dynamicProperties.length||this.transform.op.effectsSequence.length;}var buildShapeString=function buildShapeString(pathNodes,length,closed,mat){if(length===0){return '';}var _o=pathNodes.o;var _i=pathNodes.i;var _v=pathNodes.v;var i;var shapeString=' M'+mat.applyToPointStringified(_v[0][0],_v[0][1]);for(i=1;i<length;i+=1){shapeString+=' C'+mat.applyToPointStringified(_o[i-1][0],_o[i-1][1])+' '+mat.applyToPointStringified(_i[i][0],_i[i][1])+' '+mat.applyToPointStringified(_v[i][0],_v[i][1]);}if(closed&&length){shapeString+=' C'+mat.applyToPointStringified(_o[i-1][0],_o[i-1][1])+' '+mat.applyToPointStringified(_i[0][0],_i[0][1])+' '+mat.applyToPointStringified(_v[0][0],_v[0][1]);shapeString+='z';}return shapeString;};var SVGElementsRenderer=function(){var _identityMatrix=new Matrix();var _matrixHelper=new Matrix();var ob={createRenderFunction:createRenderFunction};function createRenderFunction(data){switch(data.ty){case'fl':return renderFill;case'gf':return renderGradient;case'gs':return renderGradientStroke;case'st':return renderStroke;case'sh':case'el':case'rc':case'sr':return renderPath;case'tr':return renderContentTransform;case'no':return renderNoop;default:return null;}}function renderContentTransform(styleData,itemData,isFirstFrame){if(isFirstFrame||itemData.transform.op._mdf){itemData.transform.container.setAttribute('opacity',itemData.transform.op.v);}if(isFirstFrame||itemData.transform.mProps._mdf){itemData.transform.container.setAttribute('transform',itemData.transform.mProps.v.to2dCSS());}}function renderNoop(){}function renderPath(styleData,itemData,isFirstFrame){var j;var jLen;var pathStringTransformed;var redraw;var pathNodes;var l;var lLen=itemData.styles.length;var lvl=itemData.lvl;var paths;var mat;var iterations;var k;for(l=0;l<lLen;l+=1){redraw=itemData.sh._mdf||isFirstFrame;if(itemData.styles[l].lvl<lvl){mat=_matrixHelper.reset();iterations=lvl-itemData.styles[l].lvl;k=itemData.transformers.length-1;while(!redraw&&iterations>0){redraw=itemData.transformers[k].mProps._mdf||redraw;iterations-=1;k-=1;}if(redraw){iterations=lvl-itemData.styles[l].lvl;k=itemData.transformers.length-1;while(iterations>0){mat.multiply(itemData.transformers[k].mProps.v);iterations-=1;k-=1;}}}else {mat=_identityMatrix;}paths=itemData.sh.paths;jLen=paths._length;if(redraw){pathStringTransformed='';for(j=0;j<jLen;j+=1){pathNodes=paths.shapes[j];if(pathNodes&&pathNodes._length){pathStringTransformed+=buildShapeString(pathNodes,pathNodes._length,pathNodes.c,mat);}}itemData.caches[l]=pathStringTransformed;}else {pathStringTransformed=itemData.caches[l];}itemData.styles[l].d+=styleData.hd===true?'':pathStringTransformed;itemData.styles[l]._mdf=redraw||itemData.styles[l]._mdf;}}function renderFill(styleData,itemData,isFirstFrame){var styleElem=itemData.style;if(itemData.c._mdf||isFirstFrame){styleElem.pElem.setAttribute('fill','rgb('+bmFloor(itemData.c.v[0])+','+bmFloor(itemData.c.v[1])+','+bmFloor(itemData.c.v[2])+')');}if(itemData.o._mdf||isFirstFrame){styleElem.pElem.setAttribute('fill-opacity',itemData.o.v);}}function renderGradientStroke(styleData,itemData,isFirstFrame){renderGradient(styleData,itemData,isFirstFrame);renderStroke(styleData,itemData,isFirstFrame);}function renderGradient(styleData,itemData,isFirstFrame){var gfill=itemData.gf;var hasOpacity=itemData.g._hasOpacity;var pt1=itemData.s.v;var pt2=itemData.e.v;if(itemData.o._mdf||isFirstFrame){var attr=styleData.ty==='gf'?'fill-opacity':'stroke-opacity';itemData.style.pElem.setAttribute(attr,itemData.o.v);}if(itemData.s._mdf||isFirstFrame){var attr1=styleData.t===1?'x1':'cx';var attr2=attr1==='x1'?'y1':'cy';gfill.setAttribute(attr1,pt1[0]);gfill.setAttribute(attr2,pt1[1]);if(hasOpacity&&!itemData.g._collapsable){itemData.of.setAttribute(attr1,pt1[0]);itemData.of.setAttribute(attr2,pt1[1]);}}var stops;var i;var len;var stop;if(itemData.g._cmdf||isFirstFrame){stops=itemData.cst;var cValues=itemData.g.c;len=stops.length;for(i=0;i<len;i+=1){stop=stops[i];stop.setAttribute('offset',cValues[i*4]+'%');stop.setAttribute('stop-color','rgb('+cValues[i*4+1]+','+cValues[i*4+2]+','+cValues[i*4+3]+')');}}if(hasOpacity&&(itemData.g._omdf||isFirstFrame)){var oValues=itemData.g.o;if(itemData.g._collapsable){stops=itemData.cst;}else {stops=itemData.ost;}len=stops.length;for(i=0;i<len;i+=1){stop=stops[i];if(!itemData.g._collapsable){stop.setAttribute('offset',oValues[i*2]+'%');}stop.setAttribute('stop-opacity',oValues[i*2+1]);}}if(styleData.t===1){if(itemData.e._mdf||isFirstFrame){gfill.setAttribute('x2',pt2[0]);gfill.setAttribute('y2',pt2[1]);if(hasOpacity&&!itemData.g._collapsable){itemData.of.setAttribute('x2',pt2[0]);itemData.of.setAttribute('y2',pt2[1]);}}}else {var rad;if(itemData.s._mdf||itemData.e._mdf||isFirstFrame){rad=Math.sqrt(Math.pow(pt1[0]-pt2[0],2)+Math.pow(pt1[1]-pt2[1],2));gfill.setAttribute('r',rad);if(hasOpacity&&!itemData.g._collapsable){itemData.of.setAttribute('r',rad);}}if(itemData.e._mdf||itemData.h._mdf||itemData.a._mdf||isFirstFrame){if(!rad){rad=Math.sqrt(Math.pow(pt1[0]-pt2[0],2)+Math.pow(pt1[1]-pt2[1],2));}var ang=Math.atan2(pt2[1]-pt1[1],pt2[0]-pt1[0]);var percent=itemData.h.v;if(percent>=1){percent=0.99;}else if(percent<=-1){percent=-0.99;}var dist=rad*percent;var x=Math.cos(ang+itemData.a.v)*dist+pt1[0];var y=Math.sin(ang+itemData.a.v)*dist+pt1[1];gfill.setAttribute('fx',x);gfill.setAttribute('fy',y);if(hasOpacity&&!itemData.g._collapsable){itemData.of.setAttribute('fx',x);itemData.of.setAttribute('fy',y);}}// gfill.setAttribute('fy','200');
	}}function renderStroke(styleData,itemData,isFirstFrame){var styleElem=itemData.style;var d=itemData.d;if(d&&(d._mdf||isFirstFrame)&&d.dashStr){styleElem.pElem.setAttribute('stroke-dasharray',d.dashStr);styleElem.pElem.setAttribute('stroke-dashoffset',d.dashoffset[0]);}if(itemData.c&&(itemData.c._mdf||isFirstFrame)){styleElem.pElem.setAttribute('stroke','rgb('+bmFloor(itemData.c.v[0])+','+bmFloor(itemData.c.v[1])+','+bmFloor(itemData.c.v[2])+')');}if(itemData.o._mdf||isFirstFrame){styleElem.pElem.setAttribute('stroke-opacity',itemData.o.v);}if(itemData.w._mdf||isFirstFrame){styleElem.pElem.setAttribute('stroke-width',itemData.w.v);if(styleElem.msElem){styleElem.msElem.setAttribute('stroke-width',itemData.w.v);}}}return ob;}();function SVGShapeElement(data,globalData,comp){// List of drawable elements
	this.shapes=[];// Full shape data
	this.shapesData=data.shapes;// List of styles that will be applied to shapes
	this.stylesList=[];// List of modifiers that will be applied to shapes
	this.shapeModifiers=[];// List of items in shape tree
	this.itemsData=[];// List of items in previous shape tree
	this.processedElements=[];// List of animated components
	this.animatedContents=[];this.initElement(data,globalData,comp);// Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
	// List of elements that have been created
	this.prevViewData=[];// Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
	}extendPrototype([BaseElement,TransformElement,SVGBaseElement,IShapeElement,HierarchyElement,FrameElement,RenderableDOMElement],SVGShapeElement);SVGShapeElement.prototype.initSecondaryElement=function(){};SVGShapeElement.prototype.identityMatrix=new Matrix();SVGShapeElement.prototype.buildExpressionInterface=function(){};SVGShapeElement.prototype.createContent=function(){this.searchShapes(this.shapesData,this.itemsData,this.prevViewData,this.layerElement,0,[],true);this.filterUniqueShapes();};/*
	  This method searches for multiple shapes that affect a single element and one of them is animated
	  */SVGShapeElement.prototype.filterUniqueShapes=function(){var i;var len=this.shapes.length;var shape;var j;var jLen=this.stylesList.length;var style;var tempShapes=[];var areAnimated=false;for(j=0;j<jLen;j+=1){style=this.stylesList[j];areAnimated=false;tempShapes.length=0;for(i=0;i<len;i+=1){shape=this.shapes[i];if(shape.styles.indexOf(style)!==-1){tempShapes.push(shape);areAnimated=shape._isAnimated||areAnimated;}}if(tempShapes.length>1&&areAnimated){this.setShapesAsAnimated(tempShapes);}}};SVGShapeElement.prototype.setShapesAsAnimated=function(shapes){var i;var len=shapes.length;for(i=0;i<len;i+=1){shapes[i].setAsAnimated();}};SVGShapeElement.prototype.createStyleElement=function(data,level){// TODO: prevent drawing of hidden styles
	var elementData;var styleOb=new SVGStyleData(data,level);var pathElement=styleOb.pElem;if(data.ty==='st'){elementData=new SVGStrokeStyleData(this,data,styleOb);}else if(data.ty==='fl'){elementData=new SVGFillStyleData(this,data,styleOb);}else if(data.ty==='gf'||data.ty==='gs'){var GradientConstructor=data.ty==='gf'?SVGGradientFillStyleData:SVGGradientStrokeStyleData;elementData=new GradientConstructor(this,data,styleOb);this.globalData.defs.appendChild(elementData.gf);if(elementData.maskId){this.globalData.defs.appendChild(elementData.ms);this.globalData.defs.appendChild(elementData.of);pathElement.setAttribute('mask','url('+getLocationHref()+'#'+elementData.maskId+')');}}else if(data.ty==='no'){elementData=new SVGNoStyleData(this,data,styleOb);}if(data.ty==='st'||data.ty==='gs'){pathElement.setAttribute('stroke-linecap',lineCapEnum[data.lc||2]);pathElement.setAttribute('stroke-linejoin',lineJoinEnum[data.lj||2]);pathElement.setAttribute('fill-opacity','0');if(data.lj===1){pathElement.setAttribute('stroke-miterlimit',data.ml);}}if(data.r===2){pathElement.setAttribute('fill-rule','evenodd');}if(data.ln){pathElement.setAttribute('id',data.ln);}if(data.cl){pathElement.setAttribute('class',data.cl);}if(data.bm){pathElement.style['mix-blend-mode']=getBlendMode(data.bm);}this.stylesList.push(styleOb);this.addToAnimatedContents(data,elementData);return elementData;};SVGShapeElement.prototype.createGroupElement=function(data){var elementData=new ShapeGroupData();if(data.ln){elementData.gr.setAttribute('id',data.ln);}if(data.cl){elementData.gr.setAttribute('class',data.cl);}if(data.bm){elementData.gr.style['mix-blend-mode']=getBlendMode(data.bm);}return elementData;};SVGShapeElement.prototype.createTransformElement=function(data,container){var transformProperty=TransformPropertyFactory.getTransformProperty(this,data,this);var elementData=new SVGTransformData(transformProperty,transformProperty.o,container);this.addToAnimatedContents(data,elementData);return elementData;};SVGShapeElement.prototype.createShapeElement=function(data,ownTransformers,level){var ty=4;if(data.ty==='rc'){ty=5;}else if(data.ty==='el'){ty=6;}else if(data.ty==='sr'){ty=7;}var shapeProperty=ShapePropertyFactory.getShapeProp(this,data,ty,this);var elementData=new SVGShapeData(ownTransformers,level,shapeProperty);this.shapes.push(elementData);this.addShapeToModifiers(elementData);this.addToAnimatedContents(data,elementData);return elementData;};SVGShapeElement.prototype.addToAnimatedContents=function(data,element){var i=0;var len=this.animatedContents.length;while(i<len){if(this.animatedContents[i].element===element){return;}i+=1;}this.animatedContents.push({fn:SVGElementsRenderer.createRenderFunction(data),element:element,data:data});};SVGShapeElement.prototype.setElementStyles=function(elementData){var arr=elementData.styles;var j;var jLen=this.stylesList.length;for(j=0;j<jLen;j+=1){if(!this.stylesList[j].closed){arr.push(this.stylesList[j]);}}};SVGShapeElement.prototype.reloadShapes=function(){this._isFirstFrame=true;var i;var len=this.itemsData.length;for(i=0;i<len;i+=1){this.prevViewData[i]=this.itemsData[i];}this.searchShapes(this.shapesData,this.itemsData,this.prevViewData,this.layerElement,0,[],true);this.filterUniqueShapes();len=this.dynamicProperties.length;for(i=0;i<len;i+=1){this.dynamicProperties[i].getValue();}this.renderModifiers();};SVGShapeElement.prototype.searchShapes=function(arr,itemsData,prevViewData,container,level,transformers,render){var ownTransformers=[].concat(transformers);var i;var len=arr.length-1;var j;var jLen;var ownStyles=[];var ownModifiers=[];var currentTransform;var modifier;var processedPos;for(i=len;i>=0;i-=1){processedPos=this.searchProcessedElement(arr[i]);if(!processedPos){arr[i]._render=render;}else {itemsData[i]=prevViewData[processedPos-1];}if(arr[i].ty==='fl'||arr[i].ty==='st'||arr[i].ty==='gf'||arr[i].ty==='gs'||arr[i].ty==='no'){if(!processedPos){itemsData[i]=this.createStyleElement(arr[i],level);}else {itemsData[i].style.closed=false;}if(arr[i]._render){if(itemsData[i].style.pElem.parentNode!==container){container.appendChild(itemsData[i].style.pElem);}}ownStyles.push(itemsData[i].style);}else if(arr[i].ty==='gr'){if(!processedPos){itemsData[i]=this.createGroupElement(arr[i]);}else {jLen=itemsData[i].it.length;for(j=0;j<jLen;j+=1){itemsData[i].prevViewData[j]=itemsData[i].it[j];}}this.searchShapes(arr[i].it,itemsData[i].it,itemsData[i].prevViewData,itemsData[i].gr,level+1,ownTransformers,render);if(arr[i]._render){if(itemsData[i].gr.parentNode!==container){container.appendChild(itemsData[i].gr);}}}else if(arr[i].ty==='tr'){if(!processedPos){itemsData[i]=this.createTransformElement(arr[i],container);}currentTransform=itemsData[i].transform;ownTransformers.push(currentTransform);}else if(arr[i].ty==='sh'||arr[i].ty==='rc'||arr[i].ty==='el'||arr[i].ty==='sr'){if(!processedPos){itemsData[i]=this.createShapeElement(arr[i],ownTransformers,level);}this.setElementStyles(itemsData[i]);}else if(arr[i].ty==='tm'||arr[i].ty==='rd'||arr[i].ty==='ms'||arr[i].ty==='pb'||arr[i].ty==='zz'||arr[i].ty==='op'){if(!processedPos){modifier=ShapeModifiers.getModifier(arr[i].ty);modifier.init(this,arr[i]);itemsData[i]=modifier;this.shapeModifiers.push(modifier);}else {modifier=itemsData[i];modifier.closed=false;}ownModifiers.push(modifier);}else if(arr[i].ty==='rp'){if(!processedPos){modifier=ShapeModifiers.getModifier(arr[i].ty);itemsData[i]=modifier;modifier.init(this,arr,i,itemsData);this.shapeModifiers.push(modifier);render=false;}else {modifier=itemsData[i];modifier.closed=true;}ownModifiers.push(modifier);}this.addProcessedElement(arr[i],i+1);}len=ownStyles.length;for(i=0;i<len;i+=1){ownStyles[i].closed=true;}len=ownModifiers.length;for(i=0;i<len;i+=1){ownModifiers[i].closed=true;}};SVGShapeElement.prototype.renderInnerContent=function(){this.renderModifiers();var i;var len=this.stylesList.length;for(i=0;i<len;i+=1){this.stylesList[i].reset();}this.renderShape();for(i=0;i<len;i+=1){if(this.stylesList[i]._mdf||this._isFirstFrame){if(this.stylesList[i].msElem){this.stylesList[i].msElem.setAttribute('d',this.stylesList[i].d);// Adding M0 0 fixes same mask bug on all browsers
	this.stylesList[i].d='M0 0'+this.stylesList[i].d;}this.stylesList[i].pElem.setAttribute('d',this.stylesList[i].d||'M0 0');}}};SVGShapeElement.prototype.renderShape=function(){var i;var len=this.animatedContents.length;var animatedContent;for(i=0;i<len;i+=1){animatedContent=this.animatedContents[i];if((this._isFirstFrame||animatedContent.element._isAnimated)&&animatedContent.data!==true){animatedContent.fn(animatedContent.data,animatedContent.element,this._isFirstFrame);}}};SVGShapeElement.prototype.destroy=function(){this.destroyBaseElement();this.shapesData=null;this.itemsData=null;};function LetterProps(o,sw,sc,fc,m,p){this.o=o;this.sw=sw;this.sc=sc;this.fc=fc;this.m=m;this.p=p;this._mdf={o:true,sw:!!sw,sc:!!sc,fc:!!fc,m:true,p:true};}LetterProps.prototype.update=function(o,sw,sc,fc,m,p){this._mdf.o=false;this._mdf.sw=false;this._mdf.sc=false;this._mdf.fc=false;this._mdf.m=false;this._mdf.p=false;var updated=false;if(this.o!==o){this.o=o;this._mdf.o=true;updated=true;}if(this.sw!==sw){this.sw=sw;this._mdf.sw=true;updated=true;}if(this.sc!==sc){this.sc=sc;this._mdf.sc=true;updated=true;}if(this.fc!==fc){this.fc=fc;this._mdf.fc=true;updated=true;}if(this.m!==m){this.m=m;this._mdf.m=true;updated=true;}if(p.length&&(this.p[0]!==p[0]||this.p[1]!==p[1]||this.p[4]!==p[4]||this.p[5]!==p[5]||this.p[12]!==p[12]||this.p[13]!==p[13])){this.p=p;this._mdf.p=true;updated=true;}return updated;};function TextProperty(elem,data){this._frameId=initialDefaultFrame;this.pv='';this.v='';this.kf=false;this._isFirstFrame=true;this._mdf=false;if(data.d&&data.d.sid){data.d=elem.globalData.slotManager.getProp(data.d);}this.data=data;this.elem=elem;this.comp=this.elem.comp;this.keysIndex=0;this.canResize=false;this.minimumFontSize=1;this.effectsSequence=[];this.currentData={ascent:0,boxWidth:this.defaultBoxWidth,f:'',fStyle:'',fWeight:'',fc:'',j:'',justifyOffset:'',l:[],lh:0,lineWidths:[],ls:'',of:'',s:'',sc:'',sw:0,t:0,tr:0,sz:0,ps:null,fillColorAnim:false,strokeColorAnim:false,strokeWidthAnim:false,yOffset:0,finalSize:0,finalText:[],finalLineHeight:0,__complete:false};this.copyData(this.currentData,this.data.d.k[0].s);if(!this.searchProperty()){this.completeTextData(this.currentData);}}TextProperty.prototype.defaultBoxWidth=[0,0];TextProperty.prototype.copyData=function(obj,data){for(var s in data){if(Object.prototype.hasOwnProperty.call(data,s)){obj[s]=data[s];}}return obj;};TextProperty.prototype.setCurrentData=function(data){if(!data.__complete){this.completeTextData(data);}this.currentData=data;this.currentData.boxWidth=this.currentData.boxWidth||this.defaultBoxWidth;this._mdf=true;};TextProperty.prototype.searchProperty=function(){return this.searchKeyframes();};TextProperty.prototype.searchKeyframes=function(){this.kf=this.data.d.k.length>1;if(this.kf){this.addEffect(this.getKeyframeValue.bind(this));}return this.kf;};TextProperty.prototype.addEffect=function(effectFunction){this.effectsSequence.push(effectFunction);this.elem.addDynamicProperty(this);};TextProperty.prototype.getValue=function(_finalValue){if((this.elem.globalData.frameId===this.frameId||!this.effectsSequence.length)&&!_finalValue){return;}this.currentData.t=this.data.d.k[this.keysIndex].s.t;var currentValue=this.currentData;var currentIndex=this.keysIndex;if(this.lock){this.setCurrentData(this.currentData);return;}this.lock=true;this._mdf=false;var i;var len=this.effectsSequence.length;var finalValue=_finalValue||this.data.d.k[this.keysIndex].s;for(i=0;i<len;i+=1){// Checking if index changed to prevent creating a new object every time the expression updates.
	if(currentIndex!==this.keysIndex){finalValue=this.effectsSequence[i](finalValue,finalValue.t);}else {finalValue=this.effectsSequence[i](this.currentData,finalValue.t);}}if(currentValue!==finalValue){this.setCurrentData(finalValue);}this.v=this.currentData;this.pv=this.v;this.lock=false;this.frameId=this.elem.globalData.frameId;};TextProperty.prototype.getKeyframeValue=function(){var textKeys=this.data.d.k;var frameNum=this.elem.comp.renderedFrame;var i=0;var len=textKeys.length;while(i<=len-1){if(i===len-1||textKeys[i+1].t>frameNum){break;}i+=1;}if(this.keysIndex!==i){this.keysIndex=i;}return this.data.d.k[this.keysIndex].s;};TextProperty.prototype.buildFinalText=function(text){var charactersArray=[];var i=0;var len=text.length;var charCode;var secondCharCode;var shouldCombine=false;var shouldCombineNext=false;var currentChars='';while(i<len){shouldCombine=shouldCombineNext;shouldCombineNext=false;charCode=text.charCodeAt(i);currentChars=text.charAt(i);if(FontManager.isCombinedCharacter(charCode)){shouldCombine=true;// It's a potential surrogate pair (this is the High surrogate)
	}else if(charCode>=0xD800&&charCode<=0xDBFF){if(FontManager.isRegionalFlag(text,i)){currentChars=text.substr(i,14);}else {secondCharCode=text.charCodeAt(i+1);// It's a surrogate pair (this is the Low surrogate)
	if(secondCharCode>=0xDC00&&secondCharCode<=0xDFFF){if(FontManager.isModifier(charCode,secondCharCode)){currentChars=text.substr(i,2);shouldCombine=true;}else if(FontManager.isFlagEmoji(text.substr(i,4))){currentChars=text.substr(i,4);}else {currentChars=text.substr(i,2);}}}}else if(charCode>0xDBFF){secondCharCode=text.charCodeAt(i+1);if(FontManager.isVariationSelector(charCode)){shouldCombine=true;}}else if(FontManager.isZeroWidthJoiner(charCode)){shouldCombine=true;shouldCombineNext=true;}if(shouldCombine){charactersArray[charactersArray.length-1]+=currentChars;shouldCombine=false;}else {charactersArray.push(currentChars);}i+=currentChars.length;}return charactersArray;};TextProperty.prototype.completeTextData=function(documentData){documentData.__complete=true;var fontManager=this.elem.globalData.fontManager;var data=this.data;var letters=[];var i;var len;var newLineFlag;var index=0;var val;var anchorGrouping=data.m.g;var currentSize=0;var currentPos=0;var currentLine=0;var lineWidths=[];var lineWidth=0;var maxLineWidth=0;var j;var jLen;var fontData=fontManager.getFontByName(documentData.f);var charData;var cLength=0;var fontProps=getFontProperties(fontData);documentData.fWeight=fontProps.weight;documentData.fStyle=fontProps.style;documentData.finalSize=documentData.s;documentData.finalText=this.buildFinalText(documentData.t);len=documentData.finalText.length;documentData.finalLineHeight=documentData.lh;var trackingOffset=documentData.tr/1000*documentData.finalSize;var charCode;if(documentData.sz){var flag=true;var boxWidth=documentData.sz[0];var boxHeight=documentData.sz[1];var currentHeight;var finalText;while(flag){finalText=this.buildFinalText(documentData.t);currentHeight=0;lineWidth=0;len=finalText.length;trackingOffset=documentData.tr/1000*documentData.finalSize;var lastSpaceIndex=-1;for(i=0;i<len;i+=1){charCode=finalText[i].charCodeAt(0);newLineFlag=false;if(finalText[i]===' '){lastSpaceIndex=i;}else if(charCode===13||charCode===3){lineWidth=0;newLineFlag=true;currentHeight+=documentData.finalLineHeight||documentData.finalSize*1.2;}if(fontManager.chars){charData=fontManager.getCharData(finalText[i],fontData.fStyle,fontData.fFamily);cLength=newLineFlag?0:charData.w*documentData.finalSize/100;}else {// tCanvasHelper.font = documentData.s + 'px '+ fontData.fFamily;
	cLength=fontManager.measureText(finalText[i],documentData.f,documentData.finalSize);}if(lineWidth+cLength>boxWidth&&finalText[i]!==' '){if(lastSpaceIndex===-1){len+=1;}else {i=lastSpaceIndex;}currentHeight+=documentData.finalLineHeight||documentData.finalSize*1.2;finalText.splice(i,lastSpaceIndex===i?1:0,'\r');// finalText = finalText.substr(0,i) + "\r" + finalText.substr(i === lastSpaceIndex ? i + 1 : i);
	lastSpaceIndex=-1;lineWidth=0;}else {lineWidth+=cLength;lineWidth+=trackingOffset;}}currentHeight+=fontData.ascent*documentData.finalSize/100;if(this.canResize&&documentData.finalSize>this.minimumFontSize&&boxHeight<currentHeight){documentData.finalSize-=1;documentData.finalLineHeight=documentData.finalSize*documentData.lh/documentData.s;}else {documentData.finalText=finalText;len=documentData.finalText.length;flag=false;}}}lineWidth=-trackingOffset;cLength=0;var uncollapsedSpaces=0;var currentChar;for(i=0;i<len;i+=1){newLineFlag=false;currentChar=documentData.finalText[i];charCode=currentChar.charCodeAt(0);if(charCode===13||charCode===3){uncollapsedSpaces=0;lineWidths.push(lineWidth);maxLineWidth=lineWidth>maxLineWidth?lineWidth:maxLineWidth;lineWidth=-2*trackingOffset;val='';newLineFlag=true;currentLine+=1;}else {val=currentChar;}if(fontManager.chars){charData=fontManager.getCharData(currentChar,fontData.fStyle,fontManager.getFontByName(documentData.f).fFamily);cLength=newLineFlag?0:charData.w*documentData.finalSize/100;}else {// var charWidth = fontManager.measureText(val, documentData.f, documentData.finalSize);
	// tCanvasHelper.font = documentData.finalSize + 'px '+ fontManager.getFontByName(documentData.f).fFamily;
	cLength=fontManager.measureText(val,documentData.f,documentData.finalSize);}//
	if(currentChar===' '){uncollapsedSpaces+=cLength+trackingOffset;}else {lineWidth+=cLength+trackingOffset+uncollapsedSpaces;uncollapsedSpaces=0;}letters.push({l:cLength,an:cLength,add:currentSize,n:newLineFlag,anIndexes:[],val:val,line:currentLine,animatorJustifyOffset:0});if(anchorGrouping==2){// eslint-disable-line eqeqeq
	currentSize+=cLength;if(val===''||val===' '||i===len-1){if(val===''||val===' '){currentSize-=cLength;}while(currentPos<=i){letters[currentPos].an=currentSize;letters[currentPos].ind=index;letters[currentPos].extra=cLength;currentPos+=1;}index+=1;currentSize=0;}}else if(anchorGrouping==3){// eslint-disable-line eqeqeq
	currentSize+=cLength;if(val===''||i===len-1){if(val===''){currentSize-=cLength;}while(currentPos<=i){letters[currentPos].an=currentSize;letters[currentPos].ind=index;letters[currentPos].extra=cLength;currentPos+=1;}currentSize=0;index+=1;}}else {letters[index].ind=index;letters[index].extra=0;index+=1;}}documentData.l=letters;maxLineWidth=lineWidth>maxLineWidth?lineWidth:maxLineWidth;lineWidths.push(lineWidth);if(documentData.sz){documentData.boxWidth=documentData.sz[0];documentData.justifyOffset=0;}else {documentData.boxWidth=maxLineWidth;switch(documentData.j){case 1:documentData.justifyOffset=-documentData.boxWidth;break;case 2:documentData.justifyOffset=-documentData.boxWidth/2;break;default:documentData.justifyOffset=0;}}documentData.lineWidths=lineWidths;var animators=data.a;var animatorData;var letterData;jLen=animators.length;var based;var ind;var indexes=[];for(j=0;j<jLen;j+=1){animatorData=animators[j];if(animatorData.a.sc){documentData.strokeColorAnim=true;}if(animatorData.a.sw){documentData.strokeWidthAnim=true;}if(animatorData.a.fc||animatorData.a.fh||animatorData.a.fs||animatorData.a.fb){documentData.fillColorAnim=true;}ind=0;based=animatorData.s.b;for(i=0;i<len;i+=1){letterData=letters[i];letterData.anIndexes[j]=ind;if(based==1&&letterData.val!==''||based==2&&letterData.val!==''&&letterData.val!==' '||based==3&&(letterData.n||letterData.val==' '||i==len-1)||based==4&&(letterData.n||i==len-1)){// eslint-disable-line eqeqeq
	if(animatorData.s.rn===1){indexes.push(ind);}ind+=1;}}data.a[j].s.totalChars=ind;var currentInd=-1;var newInd;if(animatorData.s.rn===1){for(i=0;i<len;i+=1){letterData=letters[i];if(currentInd!=letterData.anIndexes[j]){// eslint-disable-line eqeqeq
	currentInd=letterData.anIndexes[j];newInd=indexes.splice(Math.floor(Math.random()*indexes.length),1)[0];}letterData.anIndexes[j]=newInd;}}}documentData.yOffset=documentData.finalLineHeight||documentData.finalSize*1.2;documentData.ls=documentData.ls||0;documentData.ascent=fontData.ascent*documentData.finalSize/100;};TextProperty.prototype.updateDocumentData=function(newData,index){index=index===undefined?this.keysIndex:index;var dData=this.copyData({},this.data.d.k[index].s);dData=this.copyData(dData,newData);this.data.d.k[index].s=dData;this.recalculate(index);this.setCurrentData(dData);this.elem.addDynamicProperty(this);};TextProperty.prototype.recalculate=function(index){var dData=this.data.d.k[index].s;dData.__complete=false;this.keysIndex=0;this._isFirstFrame=true;this.getValue(dData);};TextProperty.prototype.canResizeFont=function(_canResize){this.canResize=_canResize;this.recalculate(this.keysIndex);this.elem.addDynamicProperty(this);};TextProperty.prototype.setMinimumFontSize=function(_fontValue){this.minimumFontSize=Math.floor(_fontValue)||1;this.recalculate(this.keysIndex);this.elem.addDynamicProperty(this);};var TextSelectorProp=function(){var max=Math.max;var min=Math.min;var floor=Math.floor;function TextSelectorPropFactory(elem,data){this._currentTextLength=-1;this.k=false;this.data=data;this.elem=elem;this.comp=elem.comp;this.finalS=0;this.finalE=0;this.initDynamicPropertyContainer(elem);this.s=PropertyFactory.getProp(elem,data.s||{k:0},0,0,this);if('e'in data){this.e=PropertyFactory.getProp(elem,data.e,0,0,this);}else {this.e={v:100};}this.o=PropertyFactory.getProp(elem,data.o||{k:0},0,0,this);this.xe=PropertyFactory.getProp(elem,data.xe||{k:0},0,0,this);this.ne=PropertyFactory.getProp(elem,data.ne||{k:0},0,0,this);this.sm=PropertyFactory.getProp(elem,data.sm||{k:100},0,0,this);this.a=PropertyFactory.getProp(elem,data.a,0,0.01,this);if(!this.dynamicProperties.length){this.getValue();}}TextSelectorPropFactory.prototype={getMult:function getMult(ind){if(this._currentTextLength!==this.elem.textProperty.currentData.l.length){this.getValue();}var x1=0;var y1=0;var x2=1;var y2=1;if(this.ne.v>0){x1=this.ne.v/100.0;}else {y1=-this.ne.v/100.0;}if(this.xe.v>0){x2=1.0-this.xe.v/100.0;}else {y2=1.0+this.xe.v/100.0;}var easer=BezierFactory.getBezierEasing(x1,y1,x2,y2).get;var mult=0;var s=this.finalS;var e=this.finalE;var type=this.data.sh;if(type===2){if(e===s){mult=ind>=e?1:0;}else {mult=max(0,min(0.5/(e-s)+(ind-s)/(e-s),1));}mult=easer(mult);}else if(type===3){if(e===s){mult=ind>=e?0:1;}else {mult=1-max(0,min(0.5/(e-s)+(ind-s)/(e-s),1));}mult=easer(mult);}else if(type===4){if(e===s){mult=0;}else {mult=max(0,min(0.5/(e-s)+(ind-s)/(e-s),1));if(mult<0.5){mult*=2;}else {mult=1-2*(mult-0.5);}}mult=easer(mult);}else if(type===5){if(e===s){mult=0;}else {var tot=e-s;/* ind += 0.5;
	                      mult = -4/(tot*tot)*(ind*ind)+(4/tot)*ind; */ind=min(max(0,ind+0.5-s),e-s);var x=-tot/2+ind;var a=tot/2;mult=Math.sqrt(1-x*x/(a*a));}mult=easer(mult);}else if(type===6){if(e===s){mult=0;}else {ind=min(max(0,ind+0.5-s),e-s);mult=(1+Math.cos(Math.PI+Math.PI*2*ind/(e-s)))/2;// eslint-disable-line
	}mult=easer(mult);}else {if(ind>=floor(s)){if(ind-s<0){mult=max(0,min(min(e,1)-(s-ind),1));}else {mult=max(0,min(e-ind,1));}}mult=easer(mult);}// Smoothness implementation.
	// The smoothness represents a reduced range of the original [0; 1] range.
	// if smoothness is 25%, the new range will be [0.375; 0.625]
	// Steps are:
	// - find the lower value of the new range (threshold)
	// - if multiplier is smaller than that value, floor it to 0
	// - if it is larger,
	//     - subtract the threshold
	//     - divide it by the smoothness (this will return the range to [0; 1])
	// Note: If it doesn't work on some scenarios, consider applying it before the easer.
	if(this.sm.v!==100){var smoothness=this.sm.v*0.01;if(smoothness===0){smoothness=0.00000001;}var threshold=0.5-smoothness*0.5;if(mult<threshold){mult=0;}else {mult=(mult-threshold)/smoothness;if(mult>1){mult=1;}}}return mult*this.a.v;},getValue:function getValue(newCharsFlag){this.iterateDynamicProperties();this._mdf=newCharsFlag||this._mdf;this._currentTextLength=this.elem.textProperty.currentData.l.length||0;if(newCharsFlag&&this.data.r===2){this.e.v=this._currentTextLength;}var divisor=this.data.r===2?1:100/this.data.totalChars;var o=this.o.v/divisor;var s=this.s.v/divisor+o;var e=this.e.v/divisor+o;if(s>e){var _s=s;s=e;e=_s;}this.finalS=s;this.finalE=e;}};extendPrototype([DynamicPropertyContainer],TextSelectorPropFactory);function getTextSelectorProp(elem,data,arr){return new TextSelectorPropFactory(elem,data);}return {getTextSelectorProp:getTextSelectorProp};}();function TextAnimatorDataProperty(elem,animatorProps,container){var defaultData={propType:false};var getProp=PropertyFactory.getProp;var textAnimatorAnimatables=animatorProps.a;this.a={r:textAnimatorAnimatables.r?getProp(elem,textAnimatorAnimatables.r,0,degToRads,container):defaultData,rx:textAnimatorAnimatables.rx?getProp(elem,textAnimatorAnimatables.rx,0,degToRads,container):defaultData,ry:textAnimatorAnimatables.ry?getProp(elem,textAnimatorAnimatables.ry,0,degToRads,container):defaultData,sk:textAnimatorAnimatables.sk?getProp(elem,textAnimatorAnimatables.sk,0,degToRads,container):defaultData,sa:textAnimatorAnimatables.sa?getProp(elem,textAnimatorAnimatables.sa,0,degToRads,container):defaultData,s:textAnimatorAnimatables.s?getProp(elem,textAnimatorAnimatables.s,1,0.01,container):defaultData,a:textAnimatorAnimatables.a?getProp(elem,textAnimatorAnimatables.a,1,0,container):defaultData,o:textAnimatorAnimatables.o?getProp(elem,textAnimatorAnimatables.o,0,0.01,container):defaultData,p:textAnimatorAnimatables.p?getProp(elem,textAnimatorAnimatables.p,1,0,container):defaultData,sw:textAnimatorAnimatables.sw?getProp(elem,textAnimatorAnimatables.sw,0,0,container):defaultData,sc:textAnimatorAnimatables.sc?getProp(elem,textAnimatorAnimatables.sc,1,0,container):defaultData,fc:textAnimatorAnimatables.fc?getProp(elem,textAnimatorAnimatables.fc,1,0,container):defaultData,fh:textAnimatorAnimatables.fh?getProp(elem,textAnimatorAnimatables.fh,0,0,container):defaultData,fs:textAnimatorAnimatables.fs?getProp(elem,textAnimatorAnimatables.fs,0,0.01,container):defaultData,fb:textAnimatorAnimatables.fb?getProp(elem,textAnimatorAnimatables.fb,0,0.01,container):defaultData,t:textAnimatorAnimatables.t?getProp(elem,textAnimatorAnimatables.t,0,0,container):defaultData};this.s=TextSelectorProp.getTextSelectorProp(elem,animatorProps.s,container);this.s.t=animatorProps.s.t;}function TextAnimatorProperty(textData,renderType,elem){this._isFirstFrame=true;this._hasMaskedPath=false;this._frameId=-1;this._textData=textData;this._renderType=renderType;this._elem=elem;this._animatorsData=createSizedArray(this._textData.a.length);this._pathData={};this._moreOptions={alignment:{}};this.renderedLetters=[];this.lettersChangedFlag=false;this.initDynamicPropertyContainer(elem);}TextAnimatorProperty.prototype.searchProperties=function(){var i;var len=this._textData.a.length;var animatorProps;var getProp=PropertyFactory.getProp;for(i=0;i<len;i+=1){animatorProps=this._textData.a[i];this._animatorsData[i]=new TextAnimatorDataProperty(this._elem,animatorProps,this);}if(this._textData.p&&'m'in this._textData.p){this._pathData={a:getProp(this._elem,this._textData.p.a,0,0,this),f:getProp(this._elem,this._textData.p.f,0,0,this),l:getProp(this._elem,this._textData.p.l,0,0,this),r:getProp(this._elem,this._textData.p.r,0,0,this),p:getProp(this._elem,this._textData.p.p,0,0,this),m:this._elem.maskManager.getMaskProperty(this._textData.p.m)};this._hasMaskedPath=true;}else {this._hasMaskedPath=false;}this._moreOptions.alignment=getProp(this._elem,this._textData.m.a,1,0,this);};TextAnimatorProperty.prototype.getMeasures=function(documentData,lettersChangedFlag){this.lettersChangedFlag=lettersChangedFlag;if(!this._mdf&&!this._isFirstFrame&&!lettersChangedFlag&&(!this._hasMaskedPath||!this._pathData.m._mdf)){return;}this._isFirstFrame=false;var alignment=this._moreOptions.alignment.v;var animators=this._animatorsData;var textData=this._textData;var matrixHelper=this.mHelper;var renderType=this._renderType;var renderedLettersCount=this.renderedLetters.length;var xPos;var yPos;var i;var len;var letters=documentData.l;var pathInfo;var currentLength;var currentPoint;var segmentLength;var flag;var pointInd;var segmentInd;var prevPoint;var points;var segments;var partialLength;var totalLength;var perc;var tanAngle;var mask;if(this._hasMaskedPath){mask=this._pathData.m;if(!this._pathData.n||this._pathData._mdf){var paths=mask.v;if(this._pathData.r.v){paths=paths.reverse();}// TODO: release bezier data cached from previous pathInfo: this._pathData.pi
	pathInfo={tLength:0,segments:[]};len=paths._length-1;var bezierData;totalLength=0;for(i=0;i<len;i+=1){bezierData=bez.buildBezierData(paths.v[i],paths.v[i+1],[paths.o[i][0]-paths.v[i][0],paths.o[i][1]-paths.v[i][1]],[paths.i[i+1][0]-paths.v[i+1][0],paths.i[i+1][1]-paths.v[i+1][1]]);pathInfo.tLength+=bezierData.segmentLength;pathInfo.segments.push(bezierData);totalLength+=bezierData.segmentLength;}i=len;if(mask.v.c){bezierData=bez.buildBezierData(paths.v[i],paths.v[0],[paths.o[i][0]-paths.v[i][0],paths.o[i][1]-paths.v[i][1]],[paths.i[0][0]-paths.v[0][0],paths.i[0][1]-paths.v[0][1]]);pathInfo.tLength+=bezierData.segmentLength;pathInfo.segments.push(bezierData);totalLength+=bezierData.segmentLength;}this._pathData.pi=pathInfo;}pathInfo=this._pathData.pi;currentLength=this._pathData.f.v;segmentInd=0;pointInd=1;segmentLength=0;flag=true;segments=pathInfo.segments;if(currentLength<0&&mask.v.c){if(pathInfo.tLength<Math.abs(currentLength)){currentLength=-Math.abs(currentLength)%pathInfo.tLength;}segmentInd=segments.length-1;points=segments[segmentInd].points;pointInd=points.length-1;while(currentLength<0){currentLength+=points[pointInd].partialLength;pointInd-=1;if(pointInd<0){segmentInd-=1;points=segments[segmentInd].points;pointInd=points.length-1;}}}points=segments[segmentInd].points;prevPoint=points[pointInd-1];currentPoint=points[pointInd];partialLength=currentPoint.partialLength;}len=letters.length;xPos=0;yPos=0;var yOff=documentData.finalSize*1.2*0.714;var firstLine=true;var animatorProps;var animatorSelector;var j;var jLen;var letterValue;jLen=animators.length;var mult;var ind=-1;var offf;var xPathPos;var yPathPos;var initPathPos=currentLength;var initSegmentInd=segmentInd;var initPointInd=pointInd;var currentLine=-1;var elemOpacity;var sc;var sw;var fc;var k;var letterSw;var letterSc;var letterFc;var letterM='';var letterP=this.defaultPropsArray;var letterO;//
	if(documentData.j===2||documentData.j===1){var animatorJustifyOffset=0;var animatorFirstCharOffset=0;var justifyOffsetMult=documentData.j===2?-0.5:-1;var lastIndex=0;var isNewLine=true;for(i=0;i<len;i+=1){if(letters[i].n){if(animatorJustifyOffset){animatorJustifyOffset+=animatorFirstCharOffset;}while(lastIndex<i){letters[lastIndex].animatorJustifyOffset=animatorJustifyOffset;lastIndex+=1;}animatorJustifyOffset=0;isNewLine=true;}else {for(j=0;j<jLen;j+=1){animatorProps=animators[j].a;if(animatorProps.t.propType){if(isNewLine&&documentData.j===2){animatorFirstCharOffset+=animatorProps.t.v*justifyOffsetMult;}animatorSelector=animators[j].s;mult=animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);if(mult.length){animatorJustifyOffset+=animatorProps.t.v*mult[0]*justifyOffsetMult;}else {animatorJustifyOffset+=animatorProps.t.v*mult*justifyOffsetMult;}}}isNewLine=false;}}if(animatorJustifyOffset){animatorJustifyOffset+=animatorFirstCharOffset;}while(lastIndex<i){letters[lastIndex].animatorJustifyOffset=animatorJustifyOffset;lastIndex+=1;}}//
	for(i=0;i<len;i+=1){matrixHelper.reset();elemOpacity=1;if(letters[i].n){xPos=0;yPos+=documentData.yOffset;yPos+=firstLine?1:0;currentLength=initPathPos;firstLine=false;if(this._hasMaskedPath){segmentInd=initSegmentInd;pointInd=initPointInd;points=segments[segmentInd].points;prevPoint=points[pointInd-1];currentPoint=points[pointInd];partialLength=currentPoint.partialLength;segmentLength=0;}letterM='';letterFc='';letterSw='';letterO='';letterP=this.defaultPropsArray;}else {if(this._hasMaskedPath){if(currentLine!==letters[i].line){switch(documentData.j){case 1:currentLength+=totalLength-documentData.lineWidths[letters[i].line];break;case 2:currentLength+=(totalLength-documentData.lineWidths[letters[i].line])/2;break;}currentLine=letters[i].line;}if(ind!==letters[i].ind){if(letters[ind]){currentLength+=letters[ind].extra;}currentLength+=letters[i].an/2;ind=letters[i].ind;}currentLength+=alignment[0]*letters[i].an*0.005;var animatorOffset=0;for(j=0;j<jLen;j+=1){animatorProps=animators[j].a;if(animatorProps.p.propType){animatorSelector=animators[j].s;mult=animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);if(mult.length){animatorOffset+=animatorProps.p.v[0]*mult[0];}else {animatorOffset+=animatorProps.p.v[0]*mult;}}if(animatorProps.a.propType){animatorSelector=animators[j].s;mult=animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);if(mult.length){animatorOffset+=animatorProps.a.v[0]*mult[0];}else {animatorOffset+=animatorProps.a.v[0]*mult;}}}flag=true;// Force alignment only works with a single line for now
	if(this._pathData.a.v){currentLength=letters[0].an*0.5+(totalLength-this._pathData.f.v-letters[0].an*0.5-letters[letters.length-1].an*0.5)*ind/(len-1);currentLength+=this._pathData.f.v;}while(flag){if(segmentLength+partialLength>=currentLength+animatorOffset||!points){perc=(currentLength+animatorOffset-segmentLength)/currentPoint.partialLength;xPathPos=prevPoint.point[0]+(currentPoint.point[0]-prevPoint.point[0])*perc;yPathPos=prevPoint.point[1]+(currentPoint.point[1]-prevPoint.point[1])*perc;matrixHelper.translate(-alignment[0]*letters[i].an*0.005,-(alignment[1]*yOff)*0.01);flag=false;}else if(points){segmentLength+=currentPoint.partialLength;pointInd+=1;if(pointInd>=points.length){pointInd=0;segmentInd+=1;if(!segments[segmentInd]){if(mask.v.c){pointInd=0;segmentInd=0;points=segments[segmentInd].points;}else {segmentLength-=currentPoint.partialLength;points=null;}}else {points=segments[segmentInd].points;}}if(points){prevPoint=currentPoint;currentPoint=points[pointInd];partialLength=currentPoint.partialLength;}}}offf=letters[i].an/2-letters[i].add;matrixHelper.translate(-offf,0,0);}else {offf=letters[i].an/2-letters[i].add;matrixHelper.translate(-offf,0,0);// Grouping alignment
	matrixHelper.translate(-alignment[0]*letters[i].an*0.005,-alignment[1]*yOff*0.01,0);}for(j=0;j<jLen;j+=1){animatorProps=animators[j].a;if(animatorProps.t.propType){animatorSelector=animators[j].s;mult=animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);// This condition is to prevent applying tracking to first character in each line. Might be better to use a boolean "isNewLine"
	if(xPos!==0||documentData.j!==0){if(this._hasMaskedPath){if(mult.length){currentLength+=animatorProps.t.v*mult[0];}else {currentLength+=animatorProps.t.v*mult;}}else if(mult.length){xPos+=animatorProps.t.v*mult[0];}else {xPos+=animatorProps.t.v*mult;}}}}if(documentData.strokeWidthAnim){sw=documentData.sw||0;}if(documentData.strokeColorAnim){if(documentData.sc){sc=[documentData.sc[0],documentData.sc[1],documentData.sc[2]];}else {sc=[0,0,0];}}if(documentData.fillColorAnim&&documentData.fc){fc=[documentData.fc[0],documentData.fc[1],documentData.fc[2]];}for(j=0;j<jLen;j+=1){animatorProps=animators[j].a;if(animatorProps.a.propType){animatorSelector=animators[j].s;mult=animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);if(mult.length){matrixHelper.translate(-animatorProps.a.v[0]*mult[0],-animatorProps.a.v[1]*mult[1],animatorProps.a.v[2]*mult[2]);}else {matrixHelper.translate(-animatorProps.a.v[0]*mult,-animatorProps.a.v[1]*mult,animatorProps.a.v[2]*mult);}}}for(j=0;j<jLen;j+=1){animatorProps=animators[j].a;if(animatorProps.s.propType){animatorSelector=animators[j].s;mult=animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);if(mult.length){matrixHelper.scale(1+(animatorProps.s.v[0]-1)*mult[0],1+(animatorProps.s.v[1]-1)*mult[1],1);}else {matrixHelper.scale(1+(animatorProps.s.v[0]-1)*mult,1+(animatorProps.s.v[1]-1)*mult,1);}}}for(j=0;j<jLen;j+=1){animatorProps=animators[j].a;animatorSelector=animators[j].s;mult=animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);if(animatorProps.sk.propType){if(mult.length){matrixHelper.skewFromAxis(-animatorProps.sk.v*mult[0],animatorProps.sa.v*mult[1]);}else {matrixHelper.skewFromAxis(-animatorProps.sk.v*mult,animatorProps.sa.v*mult);}}if(animatorProps.r.propType){if(mult.length){matrixHelper.rotateZ(-animatorProps.r.v*mult[2]);}else {matrixHelper.rotateZ(-animatorProps.r.v*mult);}}if(animatorProps.ry.propType){if(mult.length){matrixHelper.rotateY(animatorProps.ry.v*mult[1]);}else {matrixHelper.rotateY(animatorProps.ry.v*mult);}}if(animatorProps.rx.propType){if(mult.length){matrixHelper.rotateX(animatorProps.rx.v*mult[0]);}else {matrixHelper.rotateX(animatorProps.rx.v*mult);}}if(animatorProps.o.propType){if(mult.length){elemOpacity+=(animatorProps.o.v*mult[0]-elemOpacity)*mult[0];}else {elemOpacity+=(animatorProps.o.v*mult-elemOpacity)*mult;}}if(documentData.strokeWidthAnim&&animatorProps.sw.propType){if(mult.length){sw+=animatorProps.sw.v*mult[0];}else {sw+=animatorProps.sw.v*mult;}}if(documentData.strokeColorAnim&&animatorProps.sc.propType){for(k=0;k<3;k+=1){if(mult.length){sc[k]+=(animatorProps.sc.v[k]-sc[k])*mult[0];}else {sc[k]+=(animatorProps.sc.v[k]-sc[k])*mult;}}}if(documentData.fillColorAnim&&documentData.fc){if(animatorProps.fc.propType){for(k=0;k<3;k+=1){if(mult.length){fc[k]+=(animatorProps.fc.v[k]-fc[k])*mult[0];}else {fc[k]+=(animatorProps.fc.v[k]-fc[k])*mult;}}}if(animatorProps.fh.propType){if(mult.length){fc=addHueToRGB(fc,animatorProps.fh.v*mult[0]);}else {fc=addHueToRGB(fc,animatorProps.fh.v*mult);}}if(animatorProps.fs.propType){if(mult.length){fc=addSaturationToRGB(fc,animatorProps.fs.v*mult[0]);}else {fc=addSaturationToRGB(fc,animatorProps.fs.v*mult);}}if(animatorProps.fb.propType){if(mult.length){fc=addBrightnessToRGB(fc,animatorProps.fb.v*mult[0]);}else {fc=addBrightnessToRGB(fc,animatorProps.fb.v*mult);}}}}for(j=0;j<jLen;j+=1){animatorProps=animators[j].a;if(animatorProps.p.propType){animatorSelector=animators[j].s;mult=animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);if(this._hasMaskedPath){if(mult.length){matrixHelper.translate(0,animatorProps.p.v[1]*mult[0],-animatorProps.p.v[2]*mult[1]);}else {matrixHelper.translate(0,animatorProps.p.v[1]*mult,-animatorProps.p.v[2]*mult);}}else if(mult.length){matrixHelper.translate(animatorProps.p.v[0]*mult[0],animatorProps.p.v[1]*mult[1],-animatorProps.p.v[2]*mult[2]);}else {matrixHelper.translate(animatorProps.p.v[0]*mult,animatorProps.p.v[1]*mult,-animatorProps.p.v[2]*mult);}}}if(documentData.strokeWidthAnim){letterSw=sw<0?0:sw;}if(documentData.strokeColorAnim){letterSc='rgb('+Math.round(sc[0]*255)+','+Math.round(sc[1]*255)+','+Math.round(sc[2]*255)+')';}if(documentData.fillColorAnim&&documentData.fc){letterFc='rgb('+Math.round(fc[0]*255)+','+Math.round(fc[1]*255)+','+Math.round(fc[2]*255)+')';}if(this._hasMaskedPath){matrixHelper.translate(0,-documentData.ls);matrixHelper.translate(0,alignment[1]*yOff*0.01+yPos,0);if(this._pathData.p.v){tanAngle=(currentPoint.point[1]-prevPoint.point[1])/(currentPoint.point[0]-prevPoint.point[0]);var rot=Math.atan(tanAngle)*180/Math.PI;if(currentPoint.point[0]<prevPoint.point[0]){rot+=180;}matrixHelper.rotate(-rot*Math.PI/180);}matrixHelper.translate(xPathPos,yPathPos,0);currentLength-=alignment[0]*letters[i].an*0.005;if(letters[i+1]&&ind!==letters[i+1].ind){currentLength+=letters[i].an/2;currentLength+=documentData.tr*0.001*documentData.finalSize;}}else {matrixHelper.translate(xPos,yPos,0);if(documentData.ps){// matrixHelper.translate(documentData.ps[0],documentData.ps[1],0);
	matrixHelper.translate(documentData.ps[0],documentData.ps[1]+documentData.ascent,0);}switch(documentData.j){case 1:matrixHelper.translate(letters[i].animatorJustifyOffset+documentData.justifyOffset+(documentData.boxWidth-documentData.lineWidths[letters[i].line]),0,0);break;case 2:matrixHelper.translate(letters[i].animatorJustifyOffset+documentData.justifyOffset+(documentData.boxWidth-documentData.lineWidths[letters[i].line])/2,0,0);break;}matrixHelper.translate(0,-documentData.ls);matrixHelper.translate(offf,0,0);matrixHelper.translate(alignment[0]*letters[i].an*0.005,alignment[1]*yOff*0.01,0);xPos+=letters[i].l+documentData.tr*0.001*documentData.finalSize;}if(renderType==='html'){letterM=matrixHelper.toCSS();}else if(renderType==='svg'){letterM=matrixHelper.to2dCSS();}else {letterP=[matrixHelper.props[0],matrixHelper.props[1],matrixHelper.props[2],matrixHelper.props[3],matrixHelper.props[4],matrixHelper.props[5],matrixHelper.props[6],matrixHelper.props[7],matrixHelper.props[8],matrixHelper.props[9],matrixHelper.props[10],matrixHelper.props[11],matrixHelper.props[12],matrixHelper.props[13],matrixHelper.props[14],matrixHelper.props[15]];}letterO=elemOpacity;}if(renderedLettersCount<=i){letterValue=new LetterProps(letterO,letterSw,letterSc,letterFc,letterM,letterP);this.renderedLetters.push(letterValue);renderedLettersCount+=1;this.lettersChangedFlag=true;}else {letterValue=this.renderedLetters[i];this.lettersChangedFlag=letterValue.update(letterO,letterSw,letterSc,letterFc,letterM,letterP)||this.lettersChangedFlag;}}};TextAnimatorProperty.prototype.getValue=function(){if(this._elem.globalData.frameId===this._frameId){return;}this._frameId=this._elem.globalData.frameId;this.iterateDynamicProperties();};TextAnimatorProperty.prototype.mHelper=new Matrix();TextAnimatorProperty.prototype.defaultPropsArray=[];extendPrototype([DynamicPropertyContainer],TextAnimatorProperty);function ITextElement(){}ITextElement.prototype.initElement=function(data,globalData,comp){this.lettersChangedFlag=true;this.initFrame();this.initBaseData(data,globalData,comp);this.textProperty=new TextProperty(this,data.t,this.dynamicProperties);this.textAnimator=new TextAnimatorProperty(data.t,this.renderType,this);this.initTransform(data,globalData,comp);this.initHierarchy();this.initRenderable();this.initRendererElement();this.createContainerElements();this.createRenderableComponents();this.createContent();this.hide();this.textAnimator.searchProperties(this.dynamicProperties);};ITextElement.prototype.prepareFrame=function(num){this._mdf=false;this.prepareRenderableFrame(num);this.prepareProperties(num,this.isInRange);};ITextElement.prototype.createPathShape=function(matrixHelper,shapes){var j;var jLen=shapes.length;var pathNodes;var shapeStr='';for(j=0;j<jLen;j+=1){if(shapes[j].ty==='sh'){pathNodes=shapes[j].ks.k;shapeStr+=buildShapeString(pathNodes,pathNodes.i.length,true,matrixHelper);}}return shapeStr;};ITextElement.prototype.updateDocumentData=function(newData,index){this.textProperty.updateDocumentData(newData,index);};ITextElement.prototype.canResizeFont=function(_canResize){this.textProperty.canResizeFont(_canResize);};ITextElement.prototype.setMinimumFontSize=function(_fontSize){this.textProperty.setMinimumFontSize(_fontSize);};ITextElement.prototype.applyTextPropertiesToMatrix=function(documentData,matrixHelper,lineNumber,xPos,yPos){if(documentData.ps){matrixHelper.translate(documentData.ps[0],documentData.ps[1]+documentData.ascent,0);}matrixHelper.translate(0,-documentData.ls,0);switch(documentData.j){case 1:matrixHelper.translate(documentData.justifyOffset+(documentData.boxWidth-documentData.lineWidths[lineNumber]),0,0);break;case 2:matrixHelper.translate(documentData.justifyOffset+(documentData.boxWidth-documentData.lineWidths[lineNumber])/2,0,0);break;}matrixHelper.translate(xPos,yPos,0);};ITextElement.prototype.buildColor=function(colorData){return 'rgb('+Math.round(colorData[0]*255)+','+Math.round(colorData[1]*255)+','+Math.round(colorData[2]*255)+')';};ITextElement.prototype.emptyProp=new LetterProps();ITextElement.prototype.destroy=function(){};ITextElement.prototype.validateText=function(){if(this.textProperty._mdf||this.textProperty._isFirstFrame){this.buildNewText();this.textProperty._isFirstFrame=false;this.textProperty._mdf=false;}};var emptyShapeData={shapes:[]};function SVGTextLottieElement(data,globalData,comp){this.textSpans=[];this.renderType='svg';this.initElement(data,globalData,comp);}extendPrototype([BaseElement,TransformElement,SVGBaseElement,HierarchyElement,FrameElement,RenderableDOMElement,ITextElement],SVGTextLottieElement);SVGTextLottieElement.prototype.createContent=function(){if(this.data.singleShape&&!this.globalData.fontManager.chars){this.textContainer=createNS('text');}};SVGTextLottieElement.prototype.buildTextContents=function(textArray){var i=0;var len=textArray.length;var textContents=[];var currentTextContent='';while(i<len){if(textArray[i]===String.fromCharCode(13)||textArray[i]===String.fromCharCode(3)){textContents.push(currentTextContent);currentTextContent='';}else {currentTextContent+=textArray[i];}i+=1;}textContents.push(currentTextContent);return textContents;};SVGTextLottieElement.prototype.buildShapeData=function(data,scale){// data should probably be cloned to apply scale separately to each instance of a text on different layers
	// but since text internal content gets only rendered once and then it's never rerendered,
	// it's probably safe not to clone data and reuse always the same instance even if the object is mutated.
	// Avoiding cloning is preferred since cloning each character shape data is expensive
	if(data.shapes&&data.shapes.length){var shape=data.shapes[0];if(shape.it){var shapeItem=shape.it[shape.it.length-1];if(shapeItem.s){shapeItem.s.k[0]=scale;shapeItem.s.k[1]=scale;}}}return data;};SVGTextLottieElement.prototype.buildNewText=function(){this.addDynamicProperty(this);var i;var len;var documentData=this.textProperty.currentData;this.renderedLetters=createSizedArray(documentData?documentData.l.length:0);if(documentData.fc){this.layerElement.setAttribute('fill',this.buildColor(documentData.fc));}else {this.layerElement.setAttribute('fill','rgba(0,0,0,0)');}if(documentData.sc){this.layerElement.setAttribute('stroke',this.buildColor(documentData.sc));this.layerElement.setAttribute('stroke-width',documentData.sw);}this.layerElement.setAttribute('font-size',documentData.finalSize);var fontData=this.globalData.fontManager.getFontByName(documentData.f);if(fontData.fClass){this.layerElement.setAttribute('class',fontData.fClass);}else {this.layerElement.setAttribute('font-family',fontData.fFamily);var fWeight=documentData.fWeight;var fStyle=documentData.fStyle;this.layerElement.setAttribute('font-style',fStyle);this.layerElement.setAttribute('font-weight',fWeight);}this.layerElement.setAttribute('aria-label',documentData.t);var letters=documentData.l||[];var usesGlyphs=!!this.globalData.fontManager.chars;len=letters.length;var tSpan;var matrixHelper=this.mHelper;var shapeStr='';var singleShape=this.data.singleShape;var xPos=0;var yPos=0;var firstLine=true;var trackingOffset=documentData.tr*0.001*documentData.finalSize;if(singleShape&&!usesGlyphs&&!documentData.sz){var tElement=this.textContainer;var justify='start';switch(documentData.j){case 1:justify='end';break;case 2:justify='middle';break;default:justify='start';break;}tElement.setAttribute('text-anchor',justify);tElement.setAttribute('letter-spacing',trackingOffset);var textContent=this.buildTextContents(documentData.finalText);len=textContent.length;yPos=documentData.ps?documentData.ps[1]+documentData.ascent:0;for(i=0;i<len;i+=1){tSpan=this.textSpans[i].span||createNS('tspan');tSpan.textContent=textContent[i];tSpan.setAttribute('x',0);tSpan.setAttribute('y',yPos);tSpan.style.display='inherit';tElement.appendChild(tSpan);if(!this.textSpans[i]){this.textSpans[i]={span:null,glyph:null};}this.textSpans[i].span=tSpan;yPos+=documentData.finalLineHeight;}this.layerElement.appendChild(tElement);}else {var cachedSpansLength=this.textSpans.length;var charData;for(i=0;i<len;i+=1){if(!this.textSpans[i]){this.textSpans[i]={span:null,childSpan:null,glyph:null};}if(!usesGlyphs||!singleShape||i===0){tSpan=cachedSpansLength>i?this.textSpans[i].span:createNS(usesGlyphs?'g':'text');if(cachedSpansLength<=i){tSpan.setAttribute('stroke-linecap','butt');tSpan.setAttribute('stroke-linejoin','round');tSpan.setAttribute('stroke-miterlimit','4');this.textSpans[i].span=tSpan;if(usesGlyphs){var childSpan=createNS('g');tSpan.appendChild(childSpan);this.textSpans[i].childSpan=childSpan;}this.textSpans[i].span=tSpan;this.layerElement.appendChild(tSpan);}tSpan.style.display='inherit';}matrixHelper.reset();if(singleShape){if(letters[i].n){xPos=-trackingOffset;yPos+=documentData.yOffset;yPos+=firstLine?1:0;firstLine=false;}this.applyTextPropertiesToMatrix(documentData,matrixHelper,letters[i].line,xPos,yPos);xPos+=letters[i].l||0;// xPos += letters[i].val === ' ' ? 0 : trackingOffset;
	xPos+=trackingOffset;}if(usesGlyphs){charData=this.globalData.fontManager.getCharData(documentData.finalText[i],fontData.fStyle,this.globalData.fontManager.getFontByName(documentData.f).fFamily);var glyphElement;// t === 1 means the character has been replaced with an animated shaped
	if(charData.t===1){glyphElement=new SVGCompElement(charData.data,this.globalData,this);}else {var data=emptyShapeData;if(charData.data&&charData.data.shapes){data=this.buildShapeData(charData.data,documentData.finalSize);}glyphElement=new SVGShapeElement(data,this.globalData,this);}if(this.textSpans[i].glyph){var glyph=this.textSpans[i].glyph;this.textSpans[i].childSpan.removeChild(glyph.layerElement);glyph.destroy();}this.textSpans[i].glyph=glyphElement;glyphElement._debug=true;glyphElement.prepareFrame(0);glyphElement.renderFrame();this.textSpans[i].childSpan.appendChild(glyphElement.layerElement);// when using animated shapes, the layer will be scaled instead of replacing the internal scale
	// this might have issues with strokes and might need a different solution
	if(charData.t===1){this.textSpans[i].childSpan.setAttribute('transform','scale('+documentData.finalSize/100+','+documentData.finalSize/100+')');}}else {if(singleShape){tSpan.setAttribute('transform','translate('+matrixHelper.props[12]+','+matrixHelper.props[13]+')');}tSpan.textContent=letters[i].val;tSpan.setAttributeNS('http://www.w3.org/XML/1998/namespace','xml:space','preserve');}//
	}if(singleShape&&tSpan){tSpan.setAttribute('d',shapeStr);}}while(i<this.textSpans.length){this.textSpans[i].span.style.display='none';i+=1;}this._sizeChanged=true;};SVGTextLottieElement.prototype.sourceRectAtTime=function(){this.prepareFrame(this.comp.renderedFrame-this.data.st);this.renderInnerContent();if(this._sizeChanged){this._sizeChanged=false;var textBox=this.layerElement.getBBox();this.bbox={top:textBox.y,left:textBox.x,width:textBox.width,height:textBox.height};}return this.bbox;};SVGTextLottieElement.prototype.getValue=function(){var i;var len=this.textSpans.length;var glyphElement;this.renderedFrame=this.comp.renderedFrame;for(i=0;i<len;i+=1){glyphElement=this.textSpans[i].glyph;if(glyphElement){glyphElement.prepareFrame(this.comp.renderedFrame-this.data.st);if(glyphElement._mdf){this._mdf=true;}}}};SVGTextLottieElement.prototype.renderInnerContent=function(){this.validateText();if(!this.data.singleShape||this._mdf){this.textAnimator.getMeasures(this.textProperty.currentData,this.lettersChangedFlag);if(this.lettersChangedFlag||this.textAnimator.lettersChangedFlag){this._sizeChanged=true;var i;var len;var renderedLetters=this.textAnimator.renderedLetters;var letters=this.textProperty.currentData.l;len=letters.length;var renderedLetter;var textSpan;var glyphElement;for(i=0;i<len;i+=1){if(!letters[i].n){renderedLetter=renderedLetters[i];textSpan=this.textSpans[i].span;glyphElement=this.textSpans[i].glyph;if(glyphElement){glyphElement.renderFrame();}if(renderedLetter._mdf.m){textSpan.setAttribute('transform',renderedLetter.m);}if(renderedLetter._mdf.o){textSpan.setAttribute('opacity',renderedLetter.o);}if(renderedLetter._mdf.sw){textSpan.setAttribute('stroke-width',renderedLetter.sw);}if(renderedLetter._mdf.sc){textSpan.setAttribute('stroke',renderedLetter.sc);}if(renderedLetter._mdf.fc){textSpan.setAttribute('fill',renderedLetter.fc);}}}}}};function ISolidElement(data,globalData,comp){this.initElement(data,globalData,comp);}extendPrototype([IImageElement],ISolidElement);ISolidElement.prototype.createContent=function(){var rect=createNS('rect');/// /rect.style.width = this.data.sw;
	/// /rect.style.height = this.data.sh;
	/// /rect.style.fill = this.data.sc;
	rect.setAttribute('width',this.data.sw);rect.setAttribute('height',this.data.sh);rect.setAttribute('fill',this.data.sc);this.layerElement.appendChild(rect);};function NullElement(data,globalData,comp){this.initFrame();this.initBaseData(data,globalData,comp);this.initFrame();this.initTransform(data,globalData,comp);this.initHierarchy();}NullElement.prototype.prepareFrame=function(num){this.prepareProperties(num,true);};NullElement.prototype.renderFrame=function(){};NullElement.prototype.getBaseElement=function(){return null;};NullElement.prototype.destroy=function(){};NullElement.prototype.sourceRectAtTime=function(){};NullElement.prototype.hide=function(){};extendPrototype([BaseElement,TransformElement,HierarchyElement,FrameElement],NullElement);function SVGRendererBase(){}extendPrototype([BaseRenderer],SVGRendererBase);SVGRendererBase.prototype.createNull=function(data){return new NullElement(data,this.globalData,this);};SVGRendererBase.prototype.createShape=function(data){return new SVGShapeElement(data,this.globalData,this);};SVGRendererBase.prototype.createText=function(data){return new SVGTextLottieElement(data,this.globalData,this);};SVGRendererBase.prototype.createImage=function(data){return new IImageElement(data,this.globalData,this);};SVGRendererBase.prototype.createSolid=function(data){return new ISolidElement(data,this.globalData,this);};SVGRendererBase.prototype.configAnimation=function(animData){this.svgElement.setAttribute('xmlns','http://www.w3.org/2000/svg');this.svgElement.setAttribute('xmlns:xlink','http://www.w3.org/1999/xlink');if(this.renderConfig.viewBoxSize){this.svgElement.setAttribute('viewBox',this.renderConfig.viewBoxSize);}else {this.svgElement.setAttribute('viewBox','0 0 '+animData.w+' '+animData.h);}if(!this.renderConfig.viewBoxOnly){this.svgElement.setAttribute('width',animData.w);this.svgElement.setAttribute('height',animData.h);this.svgElement.style.width='100%';this.svgElement.style.height='100%';this.svgElement.style.transform='translate3d(0,0,0)';this.svgElement.style.contentVisibility=this.renderConfig.contentVisibility;}if(this.renderConfig.width){this.svgElement.setAttribute('width',this.renderConfig.width);}if(this.renderConfig.height){this.svgElement.setAttribute('height',this.renderConfig.height);}if(this.renderConfig.className){this.svgElement.setAttribute('class',this.renderConfig.className);}if(this.renderConfig.id){this.svgElement.setAttribute('id',this.renderConfig.id);}if(this.renderConfig.focusable!==undefined){this.svgElement.setAttribute('focusable',this.renderConfig.focusable);}this.svgElement.setAttribute('preserveAspectRatio',this.renderConfig.preserveAspectRatio);// this.layerElement.style.transform = 'translate3d(0,0,0)';
	// this.layerElement.style.transformOrigin = this.layerElement.style.mozTransformOrigin = this.layerElement.style.webkitTransformOrigin = this.layerElement.style['-webkit-transform'] = "0px 0px 0px";
	this.animationItem.wrapper.appendChild(this.svgElement);// Mask animation
	var defs=this.globalData.defs;this.setupGlobalData(animData,defs);this.globalData.progressiveLoad=this.renderConfig.progressiveLoad;this.data=animData;var maskElement=createNS('clipPath');var rect=createNS('rect');rect.setAttribute('width',animData.w);rect.setAttribute('height',animData.h);rect.setAttribute('x',0);rect.setAttribute('y',0);var maskId=createElementID();maskElement.setAttribute('id',maskId);maskElement.appendChild(rect);this.layerElement.setAttribute('clip-path','url('+getLocationHref()+'#'+maskId+')');defs.appendChild(maskElement);this.layers=animData.layers;this.elements=createSizedArray(animData.layers.length);};SVGRendererBase.prototype.destroy=function(){if(this.animationItem.wrapper){this.animationItem.wrapper.innerText='';}this.layerElement=null;this.globalData.defs=null;var i;var len=this.layers?this.layers.length:0;for(i=0;i<len;i+=1){if(this.elements[i]&&this.elements[i].destroy){this.elements[i].destroy();}}this.elements.length=0;this.destroyed=true;this.animationItem=null;};SVGRendererBase.prototype.updateContainerSize=function(){};SVGRendererBase.prototype.findIndexByInd=function(ind){var i=0;var len=this.layers.length;for(i=0;i<len;i+=1){if(this.layers[i].ind===ind){return i;}}return -1;};SVGRendererBase.prototype.buildItem=function(pos){var elements=this.elements;if(elements[pos]||this.layers[pos].ty===99){return;}elements[pos]=true;var element=this.createItem(this.layers[pos]);elements[pos]=element;if(getExpressionsPlugin()){if(this.layers[pos].ty===0){this.globalData.projectInterface.registerComposition(element);}element.initExpressions();}this.appendElementInPos(element,pos);if(this.layers[pos].tt){var elementIndex='tp'in this.layers[pos]?this.findIndexByInd(this.layers[pos].tp):pos-1;if(elementIndex===-1){return;}if(!this.elements[elementIndex]||this.elements[elementIndex]===true){this.buildItem(elementIndex);this.addPendingElement(element);}else {var matteElement=elements[elementIndex];var matteMask=matteElement.getMatte(this.layers[pos].tt);element.setMatte(matteMask);}}};SVGRendererBase.prototype.checkPendingElements=function(){while(this.pendingElements.length){var element=this.pendingElements.pop();element.checkParenting();if(element.data.tt){var i=0;var len=this.elements.length;while(i<len){if(this.elements[i]===element){var elementIndex='tp'in element.data?this.findIndexByInd(element.data.tp):i-1;var matteElement=this.elements[elementIndex];var matteMask=matteElement.getMatte(this.layers[i].tt);element.setMatte(matteMask);break;}i+=1;}}}};SVGRendererBase.prototype.renderFrame=function(num){if(this.renderedFrame===num||this.destroyed){return;}if(num===null){num=this.renderedFrame;}else {this.renderedFrame=num;}// console.log('-------');
	// console.log('FRAME ',num);
	this.globalData.frameNum=num;this.globalData.frameId+=1;this.globalData.projectInterface.currentFrame=num;this.globalData._mdf=false;var i;var len=this.layers.length;if(!this.completeLayers){this.checkLayers(num);}for(i=len-1;i>=0;i-=1){if(this.completeLayers||this.elements[i]){this.elements[i].prepareFrame(num-this.layers[i].st);}}if(this.globalData._mdf){for(i=0;i<len;i+=1){if(this.completeLayers||this.elements[i]){this.elements[i].renderFrame();}}}};SVGRendererBase.prototype.appendElementInPos=function(element,pos){var newElement=element.getBaseElement();if(!newElement){return;}var i=0;var nextElement;while(i<pos){if(this.elements[i]&&this.elements[i]!==true&&this.elements[i].getBaseElement()){nextElement=this.elements[i].getBaseElement();}i+=1;}if(nextElement){this.layerElement.insertBefore(newElement,nextElement);}else {this.layerElement.appendChild(newElement);}};SVGRendererBase.prototype.hide=function(){this.layerElement.style.display='none';};SVGRendererBase.prototype.show=function(){this.layerElement.style.display='block';};function ICompElement(){}extendPrototype([BaseElement,TransformElement,HierarchyElement,FrameElement,RenderableDOMElement],ICompElement);ICompElement.prototype.initElement=function(data,globalData,comp){this.initFrame();this.initBaseData(data,globalData,comp);this.initTransform(data,globalData,comp);this.initRenderable();this.initHierarchy();this.initRendererElement();this.createContainerElements();this.createRenderableComponents();if(this.data.xt||!globalData.progressiveLoad){this.buildAllItems();}this.hide();};/* ICompElement.prototype.hide = function(){
	      if(!this.hidden){
	          this.hideElement();
	          var i,len = this.elements.length;
	          for( i = 0; i < len; i+=1 ){
	              if(this.elements[i]){
	                  this.elements[i].hide();
	              }
	          }
	      }
	  }; */ICompElement.prototype.prepareFrame=function(num){this._mdf=false;this.prepareRenderableFrame(num);this.prepareProperties(num,this.isInRange);if(!this.isInRange&&!this.data.xt){return;}if(!this.tm._placeholder){var timeRemapped=this.tm.v;if(timeRemapped===this.data.op){timeRemapped=this.data.op-1;}this.renderedFrame=timeRemapped;}else {this.renderedFrame=num/this.data.sr;}var i;var len=this.elements.length;if(!this.completeLayers){this.checkLayers(this.renderedFrame);}// This iteration needs to be backwards because of how expressions connect between each other
	for(i=len-1;i>=0;i-=1){if(this.completeLayers||this.elements[i]){this.elements[i].prepareFrame(this.renderedFrame-this.layers[i].st);if(this.elements[i]._mdf){this._mdf=true;}}}};ICompElement.prototype.renderInnerContent=function(){var i;var len=this.layers.length;for(i=0;i<len;i+=1){if(this.completeLayers||this.elements[i]){this.elements[i].renderFrame();}}};ICompElement.prototype.setElements=function(elems){this.elements=elems;};ICompElement.prototype.getElements=function(){return this.elements;};ICompElement.prototype.destroyElements=function(){var i;var len=this.layers.length;for(i=0;i<len;i+=1){if(this.elements[i]){this.elements[i].destroy();}}};ICompElement.prototype.destroy=function(){this.destroyElements();this.destroyBaseElement();};function SVGCompElement(data,globalData,comp){this.layers=data.layers;this.supports3d=true;this.completeLayers=false;this.pendingElements=[];this.elements=this.layers?createSizedArray(this.layers.length):[];this.initElement(data,globalData,comp);this.tm=data.tm?PropertyFactory.getProp(this,data.tm,0,globalData.frameRate,this):{_placeholder:true};}extendPrototype([SVGRendererBase,ICompElement,SVGBaseElement],SVGCompElement);SVGCompElement.prototype.createComp=function(data){return new SVGCompElement(data,this.globalData,this);};function SVGRenderer(animationItem,config){this.animationItem=animationItem;this.layers=null;this.renderedFrame=-1;this.svgElement=createNS('svg');var ariaLabel='';if(config&&config.title){var titleElement=createNS('title');var titleId=createElementID();titleElement.setAttribute('id',titleId);titleElement.textContent=config.title;this.svgElement.appendChild(titleElement);ariaLabel+=titleId;}if(config&&config.description){var descElement=createNS('desc');var descId=createElementID();descElement.setAttribute('id',descId);descElement.textContent=config.description;this.svgElement.appendChild(descElement);ariaLabel+=' '+descId;}if(ariaLabel){this.svgElement.setAttribute('aria-labelledby',ariaLabel);}var defs=createNS('defs');this.svgElement.appendChild(defs);var maskElement=createNS('g');this.svgElement.appendChild(maskElement);this.layerElement=maskElement;this.renderConfig={preserveAspectRatio:config&&config.preserveAspectRatio||'xMidYMid meet',imagePreserveAspectRatio:config&&config.imagePreserveAspectRatio||'xMidYMid slice',contentVisibility:config&&config.contentVisibility||'visible',progressiveLoad:config&&config.progressiveLoad||false,hideOnTransparent:!(config&&config.hideOnTransparent===false),viewBoxOnly:config&&config.viewBoxOnly||false,viewBoxSize:config&&config.viewBoxSize||false,className:config&&config.className||'',id:config&&config.id||'',focusable:config&&config.focusable,filterSize:{width:config&&config.filterSize&&config.filterSize.width||'100%',height:config&&config.filterSize&&config.filterSize.height||'100%',x:config&&config.filterSize&&config.filterSize.x||'0%',y:config&&config.filterSize&&config.filterSize.y||'0%'},width:config&&config.width,height:config&&config.height,runExpressions:!config||config.runExpressions===undefined||config.runExpressions};this.globalData={_mdf:false,frameNum:-1,defs:defs,renderConfig:this.renderConfig};this.elements=[];this.pendingElements=[];this.destroyed=false;this.rendererType='svg';}extendPrototype([SVGRendererBase],SVGRenderer);SVGRenderer.prototype.createComp=function(data){return new SVGCompElement(data,this.globalData,this);};function ShapeTransformManager(){this.sequences={};this.sequenceList=[];this.transform_key_count=0;}ShapeTransformManager.prototype={addTransformSequence:function addTransformSequence(transforms){var i;var len=transforms.length;var key='_';for(i=0;i<len;i+=1){key+=transforms[i].transform.key+'_';}var sequence=this.sequences[key];if(!sequence){sequence={transforms:[].concat(transforms),finalTransform:new Matrix(),_mdf:false};this.sequences[key]=sequence;this.sequenceList.push(sequence);}return sequence;},processSequence:function processSequence(sequence,isFirstFrame){var i=0;var len=sequence.transforms.length;var _mdf=isFirstFrame;while(i<len&&!isFirstFrame){if(sequence.transforms[i].transform.mProps._mdf){_mdf=true;break;}i+=1;}if(_mdf){sequence.finalTransform.reset();for(i=len-1;i>=0;i-=1){sequence.finalTransform.multiply(sequence.transforms[i].transform.mProps.v);}}sequence._mdf=_mdf;},processSequences:function processSequences(isFirstFrame){var i;var len=this.sequenceList.length;for(i=0;i<len;i+=1){this.processSequence(this.sequenceList[i],isFirstFrame);}},getNewKey:function getNewKey(){this.transform_key_count+=1;return '_'+this.transform_key_count;}};var lumaLoader=function lumaLoader(){var id='__lottie_element_luma_buffer';var lumaBuffer=null;var lumaBufferCtx=null;var svg=null;// This alternate solution has a slight delay before the filter is applied, resulting in a flicker on the first frame.
	// Keeping this here for reference, and in the future, if offscreen canvas supports url filters, this can be used.
	// For now, neither of them work for offscreen canvas, so canvas workers can't support the luma track matte mask.
	// Naming it solution 2 to mark the extra comment lines.
	/*
	    var svgString = [
	      '<svg xmlns="http://www.w3.org/2000/svg">',
	      '<filter id="' + id + '">',
	      '<feColorMatrix type="matrix" color-interpolation-filters="sRGB" values="',
	      '0.3, 0.3, 0.3, 0, 0, ',
	      '0.3, 0.3, 0.3, 0, 0, ',
	      '0.3, 0.3, 0.3, 0, 0, ',
	      '0.3, 0.3, 0.3, 0, 0',
	      '"/>',
	      '</filter>',
	      '</svg>',
	    ].join('');
	    var blob = new Blob([svgString], { type: 'image/svg+xml' });
	    var url = URL.createObjectURL(blob);
	    */function createLumaSvgFilter(){var _svg=createNS('svg');var fil=createNS('filter');var matrix=createNS('feColorMatrix');fil.setAttribute('id',id);matrix.setAttribute('type','matrix');matrix.setAttribute('color-interpolation-filters','sRGB');matrix.setAttribute('values','0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0');fil.appendChild(matrix);_svg.appendChild(fil);_svg.setAttribute('id',id+'_svg');if(featureSupport.svgLumaHidden){_svg.style.display='none';}return _svg;}function loadLuma(){if(!lumaBuffer){svg=createLumaSvgFilter();document.body.appendChild(svg);lumaBuffer=createTag('canvas');lumaBufferCtx=lumaBuffer.getContext('2d');// lumaBufferCtx.filter = `url('${url}#__lottie_element_luma_buffer')`; // part of solution 2
	lumaBufferCtx.filter='url(#'+id+')';lumaBufferCtx.fillStyle='rgba(0,0,0,0)';lumaBufferCtx.fillRect(0,0,1,1);}}function getLuma(canvas){if(!lumaBuffer){loadLuma();}lumaBuffer.width=canvas.width;lumaBuffer.height=canvas.height;// lumaBufferCtx.filter = `url('${url}#__lottie_element_luma_buffer')`; // part of solution 2
	lumaBufferCtx.filter='url(#'+id+')';return lumaBuffer;}return {load:loadLuma,get:getLuma};};function createCanvas(width,height){if(featureSupport.offscreenCanvas){return new OffscreenCanvas(width,height);}var canvas=createTag('canvas');canvas.width=width;canvas.height=height;return canvas;}var assetLoader=function(){return {loadLumaCanvas:lumaLoader.load,getLumaCanvas:lumaLoader.get,createCanvas:createCanvas};}();var registeredEffects={};function CVEffects(elem){var i;var len=elem.data.ef?elem.data.ef.length:0;this.filters=[];var filterManager;for(i=0;i<len;i+=1){filterManager=null;var type=elem.data.ef[i].ty;if(registeredEffects[type]){var Effect=registeredEffects[type].effect;filterManager=new Effect(elem.effectsManager.effectElements[i],elem);}if(filterManager){this.filters.push(filterManager);}}if(this.filters.length){elem.addRenderableComponent(this);}}CVEffects.prototype.renderFrame=function(_isFirstFrame){var i;var len=this.filters.length;for(i=0;i<len;i+=1){this.filters[i].renderFrame(_isFirstFrame);}};CVEffects.prototype.getEffects=function(type){var i;var len=this.filters.length;var effects=[];for(i=0;i<len;i+=1){if(this.filters[i].type===type){effects.push(this.filters[i]);}}return effects;};function registerEffect(id,effect){registeredEffects[id]={effect:effect};}function CVMaskElement(data,element){this.data=data;this.element=element;this.masksProperties=this.data.masksProperties||[];this.viewData=createSizedArray(this.masksProperties.length);var i;var len=this.masksProperties.length;var hasMasks=false;for(i=0;i<len;i+=1){if(this.masksProperties[i].mode!=='n'){hasMasks=true;}this.viewData[i]=ShapePropertyFactory.getShapeProp(this.element,this.masksProperties[i],3);}this.hasMasks=hasMasks;if(hasMasks){this.element.addRenderableComponent(this);}}CVMaskElement.prototype.renderFrame=function(){if(!this.hasMasks){return;}var transform=this.element.finalTransform.mat;var ctx=this.element.canvasContext;var i;var len=this.masksProperties.length;var pt;var pts;var data;ctx.beginPath();for(i=0;i<len;i+=1){if(this.masksProperties[i].mode!=='n'){if(this.masksProperties[i].inv){ctx.moveTo(0,0);ctx.lineTo(this.element.globalData.compSize.w,0);ctx.lineTo(this.element.globalData.compSize.w,this.element.globalData.compSize.h);ctx.lineTo(0,this.element.globalData.compSize.h);ctx.lineTo(0,0);}data=this.viewData[i].v;pt=transform.applyToPointArray(data.v[0][0],data.v[0][1],0);ctx.moveTo(pt[0],pt[1]);var j;var jLen=data._length;for(j=1;j<jLen;j+=1){pts=transform.applyToTriplePoints(data.o[j-1],data.i[j],data.v[j]);ctx.bezierCurveTo(pts[0],pts[1],pts[2],pts[3],pts[4],pts[5]);}pts=transform.applyToTriplePoints(data.o[j-1],data.i[0],data.v[0]);ctx.bezierCurveTo(pts[0],pts[1],pts[2],pts[3],pts[4],pts[5]);}}this.element.globalData.renderer.save(true);ctx.clip();};CVMaskElement.prototype.getMaskProperty=MaskElement.prototype.getMaskProperty;CVMaskElement.prototype.destroy=function(){this.element=null;};function CVBaseElement(){}var operationsMap={1:'source-in',2:'source-out',3:'source-in',4:'source-out'};CVBaseElement.prototype={createElements:function createElements(){},initRendererElement:function initRendererElement(){},createContainerElements:function createContainerElements(){// If the layer is masked we will use two buffers to store each different states of the drawing
	// This solution is not ideal for several reason. But unfortunately, because of the recursive
	// nature of the render tree, it's the only simple way to make sure one inner mask doesn't override an outer mask.
	// TODO: try to reduce the size of these buffers to the size of the composition contaning the layer
	// It might be challenging because the layer most likely is transformed in some way
	if(this.data.tt>=1){this.buffers=[];var canvasContext=this.globalData.canvasContext;var bufferCanvas=assetLoader.createCanvas(canvasContext.canvas.width,canvasContext.canvas.height);this.buffers.push(bufferCanvas);var bufferCanvas2=assetLoader.createCanvas(canvasContext.canvas.width,canvasContext.canvas.height);this.buffers.push(bufferCanvas2);if(this.data.tt>=3&&!document._isProxy){assetLoader.loadLumaCanvas();}}this.canvasContext=this.globalData.canvasContext;this.transformCanvas=this.globalData.transformCanvas;this.renderableEffectsManager=new CVEffects(this);this.searchEffectTransforms();},createContent:function createContent(){},setBlendMode:function setBlendMode(){var globalData=this.globalData;if(globalData.blendMode!==this.data.bm){globalData.blendMode=this.data.bm;var blendModeValue=getBlendMode(this.data.bm);globalData.canvasContext.globalCompositeOperation=blendModeValue;}},createRenderableComponents:function createRenderableComponents(){this.maskManager=new CVMaskElement(this.data,this);this.transformEffects=this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);},hideElement:function hideElement(){if(!this.hidden&&(!this.isInRange||this.isTransparent)){this.hidden=true;}},showElement:function showElement(){if(this.isInRange&&!this.isTransparent){this.hidden=false;this._isFirstFrame=true;this.maskManager._isFirstFrame=true;}},clearCanvas:function clearCanvas(canvasContext){canvasContext.clearRect(this.transformCanvas.tx,this.transformCanvas.ty,this.transformCanvas.w*this.transformCanvas.sx,this.transformCanvas.h*this.transformCanvas.sy);},prepareLayer:function prepareLayer(){if(this.data.tt>=1){var buffer=this.buffers[0];var bufferCtx=buffer.getContext('2d');this.clearCanvas(bufferCtx);// on the first buffer we store the current state of the global drawing
	bufferCtx.drawImage(this.canvasContext.canvas,0,0);// The next four lines are to clear the canvas
	// TODO: Check if there is a way to clear the canvas without resetting the transform
	this.currentTransform=this.canvasContext.getTransform();this.canvasContext.setTransform(1,0,0,1,0,0);this.clearCanvas(this.canvasContext);this.canvasContext.setTransform(this.currentTransform);}},exitLayer:function exitLayer(){if(this.data.tt>=1){var buffer=this.buffers[1];// On the second buffer we store the current state of the global drawing
	// that only contains the content of this layer
	// (if it is a composition, it also includes the nested layers)
	var bufferCtx=buffer.getContext('2d');this.clearCanvas(bufferCtx);bufferCtx.drawImage(this.canvasContext.canvas,0,0);// We clear the canvas again
	this.canvasContext.setTransform(1,0,0,1,0,0);this.clearCanvas(this.canvasContext);this.canvasContext.setTransform(this.currentTransform);// We draw the mask
	var mask=this.comp.getElementById('tp'in this.data?this.data.tp:this.data.ind-1);mask.renderFrame(true);// We draw the second buffer (that contains the content of this layer)
	this.canvasContext.setTransform(1,0,0,1,0,0);// If the mask is a Luma matte, we need to do two extra painting operations
	// the _isProxy check is to avoid drawing a fake canvas in workers that will throw an error
	if(this.data.tt>=3&&!document._isProxy){// We copy the painted mask to a buffer that has a color matrix filter applied to it
	// that applies the rgb values to the alpha channel
	var lumaBuffer=assetLoader.getLumaCanvas(this.canvasContext.canvas);var lumaBufferCtx=lumaBuffer.getContext('2d');lumaBufferCtx.drawImage(this.canvasContext.canvas,0,0);this.clearCanvas(this.canvasContext);// we repaint the context with the mask applied to it
	this.canvasContext.drawImage(lumaBuffer,0,0);}this.canvasContext.globalCompositeOperation=operationsMap[this.data.tt];this.canvasContext.drawImage(buffer,0,0);// We finally draw the first buffer (that contains the content of the global drawing)
	// We use destination-over to draw the global drawing below the current layer
	this.canvasContext.globalCompositeOperation='destination-over';this.canvasContext.drawImage(this.buffers[0],0,0);this.canvasContext.setTransform(this.currentTransform);// We reset the globalCompositeOperation to source-over, the standard type of operation
	this.canvasContext.globalCompositeOperation='source-over';}},renderFrame:function renderFrame(forceRender){if(this.hidden||this.data.hd){return;}if(this.data.td===1&&!forceRender){return;}this.renderTransform();this.renderRenderable();this.renderLocalTransform();this.setBlendMode();var forceRealStack=this.data.ty===0;this.prepareLayer();this.globalData.renderer.save(forceRealStack);this.globalData.renderer.ctxTransform(this.finalTransform.localMat.props);this.globalData.renderer.ctxOpacity(this.finalTransform.localOpacity);this.renderInnerContent();this.globalData.renderer.restore(forceRealStack);this.exitLayer();if(this.maskManager.hasMasks){this.globalData.renderer.restore(true);}if(this._isFirstFrame){this._isFirstFrame=false;}},destroy:function destroy(){this.canvasContext=null;this.data=null;this.globalData=null;this.maskManager.destroy();},mHelper:new Matrix()};CVBaseElement.prototype.hide=CVBaseElement.prototype.hideElement;CVBaseElement.prototype.show=CVBaseElement.prototype.showElement;function CVShapeData(element,data,styles,transformsManager){this.styledShapes=[];this.tr=[0,0,0,0,0,0];var ty=4;if(data.ty==='rc'){ty=5;}else if(data.ty==='el'){ty=6;}else if(data.ty==='sr'){ty=7;}this.sh=ShapePropertyFactory.getShapeProp(element,data,ty,element);var i;var len=styles.length;var styledShape;for(i=0;i<len;i+=1){if(!styles[i].closed){styledShape={transforms:transformsManager.addTransformSequence(styles[i].transforms),trNodes:[]};this.styledShapes.push(styledShape);styles[i].elements.push(styledShape);}}}CVShapeData.prototype.setAsAnimated=SVGShapeData.prototype.setAsAnimated;function CVShapeElement(data,globalData,comp){this.shapes=[];this.shapesData=data.shapes;this.stylesList=[];this.itemsData=[];this.prevViewData=[];this.shapeModifiers=[];this.processedElements=[];this.transformsManager=new ShapeTransformManager();this.initElement(data,globalData,comp);}extendPrototype([BaseElement,TransformElement,CVBaseElement,IShapeElement,HierarchyElement,FrameElement,RenderableElement],CVShapeElement);CVShapeElement.prototype.initElement=RenderableDOMElement.prototype.initElement;CVShapeElement.prototype.transformHelper={opacity:1,_opMdf:false};CVShapeElement.prototype.dashResetter=[];CVShapeElement.prototype.createContent=function(){this.searchShapes(this.shapesData,this.itemsData,this.prevViewData,true,[]);};CVShapeElement.prototype.createStyleElement=function(data,transforms){var styleElem={data:data,type:data.ty,preTransforms:this.transformsManager.addTransformSequence(transforms),transforms:[],elements:[],closed:data.hd===true};var elementData={};if(data.ty==='fl'||data.ty==='st'){elementData.c=PropertyFactory.getProp(this,data.c,1,255,this);if(!elementData.c.k){styleElem.co='rgb('+bmFloor(elementData.c.v[0])+','+bmFloor(elementData.c.v[1])+','+bmFloor(elementData.c.v[2])+')';}}else if(data.ty==='gf'||data.ty==='gs'){elementData.s=PropertyFactory.getProp(this,data.s,1,null,this);elementData.e=PropertyFactory.getProp(this,data.e,1,null,this);elementData.h=PropertyFactory.getProp(this,data.h||{k:0},0,0.01,this);elementData.a=PropertyFactory.getProp(this,data.a||{k:0},0,degToRads,this);elementData.g=new GradientProperty(this,data.g,this);}elementData.o=PropertyFactory.getProp(this,data.o,0,0.01,this);if(data.ty==='st'||data.ty==='gs'){styleElem.lc=lineCapEnum[data.lc||2];styleElem.lj=lineJoinEnum[data.lj||2];if(data.lj==1){// eslint-disable-line eqeqeq
	styleElem.ml=data.ml;}elementData.w=PropertyFactory.getProp(this,data.w,0,null,this);if(!elementData.w.k){styleElem.wi=elementData.w.v;}if(data.d){var d=new DashProperty(this,data.d,'canvas',this);elementData.d=d;if(!elementData.d.k){styleElem.da=elementData.d.dashArray;styleElem["do"]=elementData.d.dashoffset[0];}}}else {styleElem.r=data.r===2?'evenodd':'nonzero';}this.stylesList.push(styleElem);elementData.style=styleElem;return elementData;};CVShapeElement.prototype.createGroupElement=function(){var elementData={it:[],prevViewData:[]};return elementData;};CVShapeElement.prototype.createTransformElement=function(data){var elementData={transform:{opacity:1,_opMdf:false,key:this.transformsManager.getNewKey(),op:PropertyFactory.getProp(this,data.o,0,0.01,this),mProps:TransformPropertyFactory.getTransformProperty(this,data,this)}};return elementData;};CVShapeElement.prototype.createShapeElement=function(data){var elementData=new CVShapeData(this,data,this.stylesList,this.transformsManager);this.shapes.push(elementData);this.addShapeToModifiers(elementData);return elementData;};CVShapeElement.prototype.reloadShapes=function(){this._isFirstFrame=true;var i;var len=this.itemsData.length;for(i=0;i<len;i+=1){this.prevViewData[i]=this.itemsData[i];}this.searchShapes(this.shapesData,this.itemsData,this.prevViewData,true,[]);len=this.dynamicProperties.length;for(i=0;i<len;i+=1){this.dynamicProperties[i].getValue();}this.renderModifiers();this.transformsManager.processSequences(this._isFirstFrame);};CVShapeElement.prototype.addTransformToStyleList=function(transform){var i;var len=this.stylesList.length;for(i=0;i<len;i+=1){if(!this.stylesList[i].closed){this.stylesList[i].transforms.push(transform);}}};CVShapeElement.prototype.removeTransformFromStyleList=function(){var i;var len=this.stylesList.length;for(i=0;i<len;i+=1){if(!this.stylesList[i].closed){this.stylesList[i].transforms.pop();}}};CVShapeElement.prototype.closeStyles=function(styles){var i;var len=styles.length;for(i=0;i<len;i+=1){styles[i].closed=true;}};CVShapeElement.prototype.searchShapes=function(arr,itemsData,prevViewData,shouldRender,transforms){var i;var len=arr.length-1;var j;var jLen;var ownStyles=[];var ownModifiers=[];var processedPos;var modifier;var currentTransform;var ownTransforms=[].concat(transforms);for(i=len;i>=0;i-=1){processedPos=this.searchProcessedElement(arr[i]);if(!processedPos){arr[i]._shouldRender=shouldRender;}else {itemsData[i]=prevViewData[processedPos-1];}if(arr[i].ty==='fl'||arr[i].ty==='st'||arr[i].ty==='gf'||arr[i].ty==='gs'){if(!processedPos){itemsData[i]=this.createStyleElement(arr[i],ownTransforms);}else {itemsData[i].style.closed=false;}ownStyles.push(itemsData[i].style);}else if(arr[i].ty==='gr'){if(!processedPos){itemsData[i]=this.createGroupElement(arr[i]);}else {jLen=itemsData[i].it.length;for(j=0;j<jLen;j+=1){itemsData[i].prevViewData[j]=itemsData[i].it[j];}}this.searchShapes(arr[i].it,itemsData[i].it,itemsData[i].prevViewData,shouldRender,ownTransforms);}else if(arr[i].ty==='tr'){if(!processedPos){currentTransform=this.createTransformElement(arr[i]);itemsData[i]=currentTransform;}ownTransforms.push(itemsData[i]);this.addTransformToStyleList(itemsData[i]);}else if(arr[i].ty==='sh'||arr[i].ty==='rc'||arr[i].ty==='el'||arr[i].ty==='sr'){if(!processedPos){itemsData[i]=this.createShapeElement(arr[i]);}}else if(arr[i].ty==='tm'||arr[i].ty==='rd'||arr[i].ty==='pb'||arr[i].ty==='zz'||arr[i].ty==='op'){if(!processedPos){modifier=ShapeModifiers.getModifier(arr[i].ty);modifier.init(this,arr[i]);itemsData[i]=modifier;this.shapeModifiers.push(modifier);}else {modifier=itemsData[i];modifier.closed=false;}ownModifiers.push(modifier);}else if(arr[i].ty==='rp'){if(!processedPos){modifier=ShapeModifiers.getModifier(arr[i].ty);itemsData[i]=modifier;modifier.init(this,arr,i,itemsData);this.shapeModifiers.push(modifier);shouldRender=false;}else {modifier=itemsData[i];modifier.closed=true;}ownModifiers.push(modifier);}this.addProcessedElement(arr[i],i+1);}this.removeTransformFromStyleList();this.closeStyles(ownStyles);len=ownModifiers.length;for(i=0;i<len;i+=1){ownModifiers[i].closed=true;}};CVShapeElement.prototype.renderInnerContent=function(){this.transformHelper.opacity=1;this.transformHelper._opMdf=false;this.renderModifiers();this.transformsManager.processSequences(this._isFirstFrame);this.renderShape(this.transformHelper,this.shapesData,this.itemsData,true);};CVShapeElement.prototype.renderShapeTransform=function(parentTransform,groupTransform){if(parentTransform._opMdf||groupTransform.op._mdf||this._isFirstFrame){groupTransform.opacity=parentTransform.opacity;groupTransform.opacity*=groupTransform.op.v;groupTransform._opMdf=true;}};CVShapeElement.prototype.drawLayer=function(){var i;var len=this.stylesList.length;var j;var jLen;var k;var kLen;var elems;var nodes;var renderer=this.globalData.renderer;var ctx=this.globalData.canvasContext;var type;var currentStyle;for(i=0;i<len;i+=1){currentStyle=this.stylesList[i];type=currentStyle.type;// Skipping style when
	// Stroke width equals 0
	// style should not be rendered (extra unused repeaters)
	// current opacity equals 0
	// global opacity equals 0
	if(!((type==='st'||type==='gs')&&currentStyle.wi===0||!currentStyle.data._shouldRender||currentStyle.coOp===0||this.globalData.currentGlobalAlpha===0)){renderer.save();elems=currentStyle.elements;if(type==='st'||type==='gs'){renderer.ctxStrokeStyle(type==='st'?currentStyle.co:currentStyle.grd);// ctx.strokeStyle = type === 'st' ? currentStyle.co : currentStyle.grd;
	renderer.ctxLineWidth(currentStyle.wi);// ctx.lineWidth = currentStyle.wi;
	renderer.ctxLineCap(currentStyle.lc);// ctx.lineCap = currentStyle.lc;
	renderer.ctxLineJoin(currentStyle.lj);// ctx.lineJoin = currentStyle.lj;
	renderer.ctxMiterLimit(currentStyle.ml||0);// ctx.miterLimit = currentStyle.ml || 0;
	}else {renderer.ctxFillStyle(type==='fl'?currentStyle.co:currentStyle.grd);// ctx.fillStyle = type === 'fl' ? currentStyle.co : currentStyle.grd;
	}renderer.ctxOpacity(currentStyle.coOp);if(type!=='st'&&type!=='gs'){ctx.beginPath();}renderer.ctxTransform(currentStyle.preTransforms.finalTransform.props);jLen=elems.length;for(j=0;j<jLen;j+=1){if(type==='st'||type==='gs'){ctx.beginPath();if(currentStyle.da){ctx.setLineDash(currentStyle.da);ctx.lineDashOffset=currentStyle["do"];}}nodes=elems[j].trNodes;kLen=nodes.length;for(k=0;k<kLen;k+=1){if(nodes[k].t==='m'){ctx.moveTo(nodes[k].p[0],nodes[k].p[1]);}else if(nodes[k].t==='c'){ctx.bezierCurveTo(nodes[k].pts[0],nodes[k].pts[1],nodes[k].pts[2],nodes[k].pts[3],nodes[k].pts[4],nodes[k].pts[5]);}else {ctx.closePath();}}if(type==='st'||type==='gs'){// ctx.stroke();
	renderer.ctxStroke();if(currentStyle.da){ctx.setLineDash(this.dashResetter);}}}if(type!=='st'&&type!=='gs'){// ctx.fill(currentStyle.r);
	this.globalData.renderer.ctxFill(currentStyle.r);}renderer.restore();}}};CVShapeElement.prototype.renderShape=function(parentTransform,items,data,isMain){var i;var len=items.length-1;var groupTransform;groupTransform=parentTransform;for(i=len;i>=0;i-=1){if(items[i].ty==='tr'){groupTransform=data[i].transform;this.renderShapeTransform(parentTransform,groupTransform);}else if(items[i].ty==='sh'||items[i].ty==='el'||items[i].ty==='rc'||items[i].ty==='sr'){this.renderPath(items[i],data[i]);}else if(items[i].ty==='fl'){this.renderFill(items[i],data[i],groupTransform);}else if(items[i].ty==='st'){this.renderStroke(items[i],data[i],groupTransform);}else if(items[i].ty==='gf'||items[i].ty==='gs'){this.renderGradientFill(items[i],data[i],groupTransform);}else if(items[i].ty==='gr'){this.renderShape(groupTransform,items[i].it,data[i].it);}else if(items[i].ty==='tm');}if(isMain){this.drawLayer();}};CVShapeElement.prototype.renderStyledShape=function(styledShape,shape){if(this._isFirstFrame||shape._mdf||styledShape.transforms._mdf){var shapeNodes=styledShape.trNodes;var paths=shape.paths;var i;var len;var j;var jLen=paths._length;shapeNodes.length=0;var groupTransformMat=styledShape.transforms.finalTransform;for(j=0;j<jLen;j+=1){var pathNodes=paths.shapes[j];if(pathNodes&&pathNodes.v){len=pathNodes._length;for(i=1;i<len;i+=1){if(i===1){shapeNodes.push({t:'m',p:groupTransformMat.applyToPointArray(pathNodes.v[0][0],pathNodes.v[0][1],0)});}shapeNodes.push({t:'c',pts:groupTransformMat.applyToTriplePoints(pathNodes.o[i-1],pathNodes.i[i],pathNodes.v[i])});}if(len===1){shapeNodes.push({t:'m',p:groupTransformMat.applyToPointArray(pathNodes.v[0][0],pathNodes.v[0][1],0)});}if(pathNodes.c&&len){shapeNodes.push({t:'c',pts:groupTransformMat.applyToTriplePoints(pathNodes.o[i-1],pathNodes.i[0],pathNodes.v[0])});shapeNodes.push({t:'z'});}}}styledShape.trNodes=shapeNodes;}};CVShapeElement.prototype.renderPath=function(pathData,itemData){if(pathData.hd!==true&&pathData._shouldRender){var i;var len=itemData.styledShapes.length;for(i=0;i<len;i+=1){this.renderStyledShape(itemData.styledShapes[i],itemData.sh);}}};CVShapeElement.prototype.renderFill=function(styleData,itemData,groupTransform){var styleElem=itemData.style;if(itemData.c._mdf||this._isFirstFrame){styleElem.co='rgb('+bmFloor(itemData.c.v[0])+','+bmFloor(itemData.c.v[1])+','+bmFloor(itemData.c.v[2])+')';}if(itemData.o._mdf||groupTransform._opMdf||this._isFirstFrame){styleElem.coOp=itemData.o.v*groupTransform.opacity;}};CVShapeElement.prototype.renderGradientFill=function(styleData,itemData,groupTransform){var styleElem=itemData.style;var grd;if(!styleElem.grd||itemData.g._mdf||itemData.s._mdf||itemData.e._mdf||styleData.t!==1&&(itemData.h._mdf||itemData.a._mdf)){var ctx=this.globalData.canvasContext;var pt1=itemData.s.v;var pt2=itemData.e.v;if(styleData.t===1){grd=ctx.createLinearGradient(pt1[0],pt1[1],pt2[0],pt2[1]);}else {var rad=Math.sqrt(Math.pow(pt1[0]-pt2[0],2)+Math.pow(pt1[1]-pt2[1],2));var ang=Math.atan2(pt2[1]-pt1[1],pt2[0]-pt1[0]);var percent=itemData.h.v;if(percent>=1){percent=0.99;}else if(percent<=-1){percent=-0.99;}var dist=rad*percent;var x=Math.cos(ang+itemData.a.v)*dist+pt1[0];var y=Math.sin(ang+itemData.a.v)*dist+pt1[1];grd=ctx.createRadialGradient(x,y,0,pt1[0],pt1[1],rad);}var i;var len=styleData.g.p;var cValues=itemData.g.c;var opacity=1;for(i=0;i<len;i+=1){if(itemData.g._hasOpacity&&itemData.g._collapsable){opacity=itemData.g.o[i*2+1];}grd.addColorStop(cValues[i*4]/100,'rgba('+cValues[i*4+1]+','+cValues[i*4+2]+','+cValues[i*4+3]+','+opacity+')');}styleElem.grd=grd;}styleElem.coOp=itemData.o.v*groupTransform.opacity;};CVShapeElement.prototype.renderStroke=function(styleData,itemData,groupTransform){var styleElem=itemData.style;var d=itemData.d;if(d&&(d._mdf||this._isFirstFrame)){styleElem.da=d.dashArray;styleElem["do"]=d.dashoffset[0];}if(itemData.c._mdf||this._isFirstFrame){styleElem.co='rgb('+bmFloor(itemData.c.v[0])+','+bmFloor(itemData.c.v[1])+','+bmFloor(itemData.c.v[2])+')';}if(itemData.o._mdf||groupTransform._opMdf||this._isFirstFrame){styleElem.coOp=itemData.o.v*groupTransform.opacity;}if(itemData.w._mdf||this._isFirstFrame){styleElem.wi=itemData.w.v;}};CVShapeElement.prototype.destroy=function(){this.shapesData=null;this.globalData=null;this.canvasContext=null;this.stylesList.length=0;this.itemsData.length=0;};function CVTextElement(data,globalData,comp){this.textSpans=[];this.yOffset=0;this.fillColorAnim=false;this.strokeColorAnim=false;this.strokeWidthAnim=false;this.stroke=false;this.fill=false;this.justifyOffset=0;this.currentRender=null;this.renderType='canvas';this.values={fill:'rgba(0,0,0,0)',stroke:'rgba(0,0,0,0)',sWidth:0,fValue:''};this.initElement(data,globalData,comp);}extendPrototype([BaseElement,TransformElement,CVBaseElement,HierarchyElement,FrameElement,RenderableElement,ITextElement],CVTextElement);CVTextElement.prototype.tHelper=createTag('canvas').getContext('2d');CVTextElement.prototype.buildNewText=function(){var documentData=this.textProperty.currentData;this.renderedLetters=createSizedArray(documentData.l?documentData.l.length:0);var hasFill=false;if(documentData.fc){hasFill=true;this.values.fill=this.buildColor(documentData.fc);}else {this.values.fill='rgba(0,0,0,0)';}this.fill=hasFill;var hasStroke=false;if(documentData.sc){hasStroke=true;this.values.stroke=this.buildColor(documentData.sc);this.values.sWidth=documentData.sw;}var fontData=this.globalData.fontManager.getFontByName(documentData.f);var i;var len;var letters=documentData.l;var matrixHelper=this.mHelper;this.stroke=hasStroke;this.values.fValue=documentData.finalSize+'px '+this.globalData.fontManager.getFontByName(documentData.f).fFamily;len=documentData.finalText.length;// this.tHelper.font = this.values.fValue;
	var charData;var shapeData;var k;var kLen;var shapes;var j;var jLen;var pathNodes;var commands;var pathArr;var singleShape=this.data.singleShape;var trackingOffset=documentData.tr*0.001*documentData.finalSize;var xPos=0;var yPos=0;var firstLine=true;var cnt=0;for(i=0;i<len;i+=1){charData=this.globalData.fontManager.getCharData(documentData.finalText[i],fontData.fStyle,this.globalData.fontManager.getFontByName(documentData.f).fFamily);shapeData=charData&&charData.data||{};matrixHelper.reset();if(singleShape&&letters[i].n){xPos=-trackingOffset;yPos+=documentData.yOffset;yPos+=firstLine?1:0;firstLine=false;}shapes=shapeData.shapes?shapeData.shapes[0].it:[];jLen=shapes.length;matrixHelper.scale(documentData.finalSize/100,documentData.finalSize/100);if(singleShape){this.applyTextPropertiesToMatrix(documentData,matrixHelper,letters[i].line,xPos,yPos);}commands=createSizedArray(jLen-1);var commandsCounter=0;for(j=0;j<jLen;j+=1){if(shapes[j].ty==='sh'){kLen=shapes[j].ks.k.i.length;pathNodes=shapes[j].ks.k;pathArr=[];for(k=1;k<kLen;k+=1){if(k===1){pathArr.push(matrixHelper.applyToX(pathNodes.v[0][0],pathNodes.v[0][1],0),matrixHelper.applyToY(pathNodes.v[0][0],pathNodes.v[0][1],0));}pathArr.push(matrixHelper.applyToX(pathNodes.o[k-1][0],pathNodes.o[k-1][1],0),matrixHelper.applyToY(pathNodes.o[k-1][0],pathNodes.o[k-1][1],0),matrixHelper.applyToX(pathNodes.i[k][0],pathNodes.i[k][1],0),matrixHelper.applyToY(pathNodes.i[k][0],pathNodes.i[k][1],0),matrixHelper.applyToX(pathNodes.v[k][0],pathNodes.v[k][1],0),matrixHelper.applyToY(pathNodes.v[k][0],pathNodes.v[k][1],0));}pathArr.push(matrixHelper.applyToX(pathNodes.o[k-1][0],pathNodes.o[k-1][1],0),matrixHelper.applyToY(pathNodes.o[k-1][0],pathNodes.o[k-1][1],0),matrixHelper.applyToX(pathNodes.i[0][0],pathNodes.i[0][1],0),matrixHelper.applyToY(pathNodes.i[0][0],pathNodes.i[0][1],0),matrixHelper.applyToX(pathNodes.v[0][0],pathNodes.v[0][1],0),matrixHelper.applyToY(pathNodes.v[0][0],pathNodes.v[0][1],0));commands[commandsCounter]=pathArr;commandsCounter+=1;}}if(singleShape){xPos+=letters[i].l;xPos+=trackingOffset;}if(this.textSpans[cnt]){this.textSpans[cnt].elem=commands;}else {this.textSpans[cnt]={elem:commands};}cnt+=1;}};CVTextElement.prototype.renderInnerContent=function(){this.validateText();var ctx=this.canvasContext;ctx.font=this.values.fValue;this.globalData.renderer.ctxLineCap('butt');// ctx.lineCap = 'butt';
	this.globalData.renderer.ctxLineJoin('miter');// ctx.lineJoin = 'miter';
	this.globalData.renderer.ctxMiterLimit(4);// ctx.miterLimit = 4;
	if(!this.data.singleShape){this.textAnimator.getMeasures(this.textProperty.currentData,this.lettersChangedFlag);}var i;var len;var j;var jLen;var k;var kLen;var renderedLetters=this.textAnimator.renderedLetters;var letters=this.textProperty.currentData.l;len=letters.length;var renderedLetter;var lastFill=null;var lastStroke=null;var lastStrokeW=null;var commands;var pathArr;var renderer=this.globalData.renderer;for(i=0;i<len;i+=1){if(!letters[i].n){renderedLetter=renderedLetters[i];if(renderedLetter){renderer.save();renderer.ctxTransform(renderedLetter.p);renderer.ctxOpacity(renderedLetter.o);}if(this.fill){if(renderedLetter&&renderedLetter.fc){if(lastFill!==renderedLetter.fc){renderer.ctxFillStyle(renderedLetter.fc);lastFill=renderedLetter.fc;// ctx.fillStyle = renderedLetter.fc;
	}}else if(lastFill!==this.values.fill){lastFill=this.values.fill;renderer.ctxFillStyle(this.values.fill);// ctx.fillStyle = this.values.fill;
	}commands=this.textSpans[i].elem;jLen=commands.length;this.globalData.canvasContext.beginPath();for(j=0;j<jLen;j+=1){pathArr=commands[j];kLen=pathArr.length;this.globalData.canvasContext.moveTo(pathArr[0],pathArr[1]);for(k=2;k<kLen;k+=6){this.globalData.canvasContext.bezierCurveTo(pathArr[k],pathArr[k+1],pathArr[k+2],pathArr[k+3],pathArr[k+4],pathArr[k+5]);}}this.globalData.canvasContext.closePath();renderer.ctxFill();// this.globalData.canvasContext.fill();
	/// ctx.fillText(this.textSpans[i].val,0,0);
	}if(this.stroke){if(renderedLetter&&renderedLetter.sw){if(lastStrokeW!==renderedLetter.sw){lastStrokeW=renderedLetter.sw;renderer.ctxLineWidth(renderedLetter.sw);// ctx.lineWidth = renderedLetter.sw;
	}}else if(lastStrokeW!==this.values.sWidth){lastStrokeW=this.values.sWidth;renderer.ctxLineWidth(this.values.sWidth);// ctx.lineWidth = this.values.sWidth;
	}if(renderedLetter&&renderedLetter.sc){if(lastStroke!==renderedLetter.sc){lastStroke=renderedLetter.sc;renderer.ctxStrokeStyle(renderedLetter.sc);// ctx.strokeStyle = renderedLetter.sc;
	}}else if(lastStroke!==this.values.stroke){lastStroke=this.values.stroke;renderer.ctxStrokeStyle(this.values.stroke);// ctx.strokeStyle = this.values.stroke;
	}commands=this.textSpans[i].elem;jLen=commands.length;this.globalData.canvasContext.beginPath();for(j=0;j<jLen;j+=1){pathArr=commands[j];kLen=pathArr.length;this.globalData.canvasContext.moveTo(pathArr[0],pathArr[1]);for(k=2;k<kLen;k+=6){this.globalData.canvasContext.bezierCurveTo(pathArr[k],pathArr[k+1],pathArr[k+2],pathArr[k+3],pathArr[k+4],pathArr[k+5]);}}this.globalData.canvasContext.closePath();renderer.ctxStroke();// this.globalData.canvasContext.stroke();
	/// ctx.strokeText(letters[i].val,0,0);
	}if(renderedLetter){this.globalData.renderer.restore();}}}};function CVImageElement(data,globalData,comp){this.assetData=globalData.getAssetData(data.refId);this.img=globalData.imageLoader.getAsset(this.assetData);this.initElement(data,globalData,comp);}extendPrototype([BaseElement,TransformElement,CVBaseElement,HierarchyElement,FrameElement,RenderableElement],CVImageElement);CVImageElement.prototype.initElement=SVGShapeElement.prototype.initElement;CVImageElement.prototype.prepareFrame=IImageElement.prototype.prepareFrame;CVImageElement.prototype.createContent=function(){if(this.img.width&&(this.assetData.w!==this.img.width||this.assetData.h!==this.img.height)){var canvas=createTag('canvas');canvas.width=this.assetData.w;canvas.height=this.assetData.h;var ctx=canvas.getContext('2d');var imgW=this.img.width;var imgH=this.img.height;var imgRel=imgW/imgH;var canvasRel=this.assetData.w/this.assetData.h;var widthCrop;var heightCrop;var par=this.assetData.pr||this.globalData.renderConfig.imagePreserveAspectRatio;if(imgRel>canvasRel&&par==='xMidYMid slice'||imgRel<canvasRel&&par!=='xMidYMid slice'){heightCrop=imgH;widthCrop=heightCrop*canvasRel;}else {widthCrop=imgW;heightCrop=widthCrop/canvasRel;}ctx.drawImage(this.img,(imgW-widthCrop)/2,(imgH-heightCrop)/2,widthCrop,heightCrop,0,0,this.assetData.w,this.assetData.h);this.img=canvas;}};CVImageElement.prototype.renderInnerContent=function(){this.canvasContext.drawImage(this.img,0,0);};CVImageElement.prototype.destroy=function(){this.img=null;};function CVSolidElement(data,globalData,comp){this.initElement(data,globalData,comp);}extendPrototype([BaseElement,TransformElement,CVBaseElement,HierarchyElement,FrameElement,RenderableElement],CVSolidElement);CVSolidElement.prototype.initElement=SVGShapeElement.prototype.initElement;CVSolidElement.prototype.prepareFrame=IImageElement.prototype.prepareFrame;CVSolidElement.prototype.renderInnerContent=function(){// var ctx = this.canvasContext;
	this.globalData.renderer.ctxFillStyle(this.data.sc);// ctx.fillStyle = this.data.sc;
	this.globalData.renderer.ctxFillRect(0,0,this.data.sw,this.data.sh);// ctx.fillRect(0, 0, this.data.sw, this.data.sh);
	//
	};function CanvasRendererBase(){}extendPrototype([BaseRenderer],CanvasRendererBase);CanvasRendererBase.prototype.createShape=function(data){return new CVShapeElement(data,this.globalData,this);};CanvasRendererBase.prototype.createText=function(data){return new CVTextElement(data,this.globalData,this);};CanvasRendererBase.prototype.createImage=function(data){return new CVImageElement(data,this.globalData,this);};CanvasRendererBase.prototype.createSolid=function(data){return new CVSolidElement(data,this.globalData,this);};CanvasRendererBase.prototype.createNull=SVGRenderer.prototype.createNull;CanvasRendererBase.prototype.ctxTransform=function(props){if(props[0]===1&&props[1]===0&&props[4]===0&&props[5]===1&&props[12]===0&&props[13]===0){return;}this.canvasContext.transform(props[0],props[1],props[4],props[5],props[12],props[13]);};CanvasRendererBase.prototype.ctxOpacity=function(op){this.canvasContext.globalAlpha*=op<0?0:op;};CanvasRendererBase.prototype.ctxFillStyle=function(value){this.canvasContext.fillStyle=value;};CanvasRendererBase.prototype.ctxStrokeStyle=function(value){this.canvasContext.strokeStyle=value;};CanvasRendererBase.prototype.ctxLineWidth=function(value){this.canvasContext.lineWidth=value;};CanvasRendererBase.prototype.ctxLineCap=function(value){this.canvasContext.lineCap=value;};CanvasRendererBase.prototype.ctxLineJoin=function(value){this.canvasContext.lineJoin=value;};CanvasRendererBase.prototype.ctxMiterLimit=function(value){this.canvasContext.miterLimit=value;};CanvasRendererBase.prototype.ctxFill=function(rule){this.canvasContext.fill(rule);};CanvasRendererBase.prototype.ctxFillRect=function(x,y,w,h){this.canvasContext.fillRect(x,y,w,h);};CanvasRendererBase.prototype.ctxStroke=function(){this.canvasContext.stroke();};CanvasRendererBase.prototype.reset=function(){if(!this.renderConfig.clearCanvas){this.canvasContext.restore();return;}this.contextData.reset();};CanvasRendererBase.prototype.save=function(){this.canvasContext.save();};CanvasRendererBase.prototype.restore=function(actionFlag){if(!this.renderConfig.clearCanvas){this.canvasContext.restore();return;}if(actionFlag){this.globalData.blendMode='source-over';}this.contextData.restore(actionFlag);};CanvasRendererBase.prototype.configAnimation=function(animData){if(this.animationItem.wrapper){this.animationItem.container=createTag('canvas');var containerStyle=this.animationItem.container.style;containerStyle.width='100%';containerStyle.height='100%';var origin='0px 0px 0px';containerStyle.transformOrigin=origin;containerStyle.mozTransformOrigin=origin;containerStyle.webkitTransformOrigin=origin;containerStyle['-webkit-transform']=origin;containerStyle.contentVisibility=this.renderConfig.contentVisibility;this.animationItem.wrapper.appendChild(this.animationItem.container);this.canvasContext=this.animationItem.container.getContext('2d');if(this.renderConfig.className){this.animationItem.container.setAttribute('class',this.renderConfig.className);}if(this.renderConfig.id){this.animationItem.container.setAttribute('id',this.renderConfig.id);}}else {this.canvasContext=this.renderConfig.context;}this.contextData.setContext(this.canvasContext);this.data=animData;this.layers=animData.layers;this.transformCanvas={w:animData.w,h:animData.h,sx:0,sy:0,tx:0,ty:0};this.setupGlobalData(animData,document.body);this.globalData.canvasContext=this.canvasContext;this.globalData.renderer=this;this.globalData.isDashed=false;this.globalData.progressiveLoad=this.renderConfig.progressiveLoad;this.globalData.transformCanvas=this.transformCanvas;this.elements=createSizedArray(animData.layers.length);this.updateContainerSize();};CanvasRendererBase.prototype.updateContainerSize=function(width,height){this.reset();var elementWidth;var elementHeight;if(width){elementWidth=width;elementHeight=height;this.canvasContext.canvas.width=elementWidth;this.canvasContext.canvas.height=elementHeight;}else {if(this.animationItem.wrapper&&this.animationItem.container){elementWidth=this.animationItem.wrapper.offsetWidth;elementHeight=this.animationItem.wrapper.offsetHeight;}else {elementWidth=this.canvasContext.canvas.width;elementHeight=this.canvasContext.canvas.height;}this.canvasContext.canvas.width=elementWidth*this.renderConfig.dpr;this.canvasContext.canvas.height=elementHeight*this.renderConfig.dpr;}var elementRel;var animationRel;if(this.renderConfig.preserveAspectRatio.indexOf('meet')!==-1||this.renderConfig.preserveAspectRatio.indexOf('slice')!==-1){var par=this.renderConfig.preserveAspectRatio.split(' ');var fillType=par[1]||'meet';var pos=par[0]||'xMidYMid';var xPos=pos.substr(0,4);var yPos=pos.substr(4);elementRel=elementWidth/elementHeight;animationRel=this.transformCanvas.w/this.transformCanvas.h;if(animationRel>elementRel&&fillType==='meet'||animationRel<elementRel&&fillType==='slice'){this.transformCanvas.sx=elementWidth/(this.transformCanvas.w/this.renderConfig.dpr);this.transformCanvas.sy=elementWidth/(this.transformCanvas.w/this.renderConfig.dpr);}else {this.transformCanvas.sx=elementHeight/(this.transformCanvas.h/this.renderConfig.dpr);this.transformCanvas.sy=elementHeight/(this.transformCanvas.h/this.renderConfig.dpr);}if(xPos==='xMid'&&(animationRel<elementRel&&fillType==='meet'||animationRel>elementRel&&fillType==='slice')){this.transformCanvas.tx=(elementWidth-this.transformCanvas.w*(elementHeight/this.transformCanvas.h))/2*this.renderConfig.dpr;}else if(xPos==='xMax'&&(animationRel<elementRel&&fillType==='meet'||animationRel>elementRel&&fillType==='slice')){this.transformCanvas.tx=(elementWidth-this.transformCanvas.w*(elementHeight/this.transformCanvas.h))*this.renderConfig.dpr;}else {this.transformCanvas.tx=0;}if(yPos==='YMid'&&(animationRel>elementRel&&fillType==='meet'||animationRel<elementRel&&fillType==='slice')){this.transformCanvas.ty=(elementHeight-this.transformCanvas.h*(elementWidth/this.transformCanvas.w))/2*this.renderConfig.dpr;}else if(yPos==='YMax'&&(animationRel>elementRel&&fillType==='meet'||animationRel<elementRel&&fillType==='slice')){this.transformCanvas.ty=(elementHeight-this.transformCanvas.h*(elementWidth/this.transformCanvas.w))*this.renderConfig.dpr;}else {this.transformCanvas.ty=0;}}else if(this.renderConfig.preserveAspectRatio==='none'){this.transformCanvas.sx=elementWidth/(this.transformCanvas.w/this.renderConfig.dpr);this.transformCanvas.sy=elementHeight/(this.transformCanvas.h/this.renderConfig.dpr);this.transformCanvas.tx=0;this.transformCanvas.ty=0;}else {this.transformCanvas.sx=this.renderConfig.dpr;this.transformCanvas.sy=this.renderConfig.dpr;this.transformCanvas.tx=0;this.transformCanvas.ty=0;}this.transformCanvas.props=[this.transformCanvas.sx,0,0,0,0,this.transformCanvas.sy,0,0,0,0,1,0,this.transformCanvas.tx,this.transformCanvas.ty,0,1];/* var i, len = this.elements.length;
	      for(i=0;i<len;i+=1){
	          if(this.elements[i] && this.elements[i].data.ty === 0){
	              this.elements[i].resize(this.globalData.transformCanvas);
	          }
	      } */this.ctxTransform(this.transformCanvas.props);this.canvasContext.beginPath();this.canvasContext.rect(0,0,this.transformCanvas.w,this.transformCanvas.h);this.canvasContext.closePath();this.canvasContext.clip();this.renderFrame(this.renderedFrame,true);};CanvasRendererBase.prototype.destroy=function(){if(this.renderConfig.clearCanvas&&this.animationItem.wrapper){this.animationItem.wrapper.innerText='';}var i;var len=this.layers?this.layers.length:0;for(i=len-1;i>=0;i-=1){if(this.elements[i]&&this.elements[i].destroy){this.elements[i].destroy();}}this.elements.length=0;this.globalData.canvasContext=null;this.animationItem.container=null;this.destroyed=true;};CanvasRendererBase.prototype.renderFrame=function(num,forceRender){if(this.renderedFrame===num&&this.renderConfig.clearCanvas===true&&!forceRender||this.destroyed||num===-1){return;}this.renderedFrame=num;this.globalData.frameNum=num-this.animationItem._isFirstFrame;this.globalData.frameId+=1;this.globalData._mdf=!this.renderConfig.clearCanvas||forceRender;this.globalData.projectInterface.currentFrame=num;// console.log('--------');
	// console.log('NEW: ',num);
	var i;var len=this.layers.length;if(!this.completeLayers){this.checkLayers(num);}for(i=len-1;i>=0;i-=1){if(this.completeLayers||this.elements[i]){this.elements[i].prepareFrame(num-this.layers[i].st);}}if(this.globalData._mdf){if(this.renderConfig.clearCanvas===true){this.canvasContext.clearRect(0,0,this.transformCanvas.w,this.transformCanvas.h);}else {this.save();}for(i=len-1;i>=0;i-=1){if(this.completeLayers||this.elements[i]){this.elements[i].renderFrame();}}if(this.renderConfig.clearCanvas!==true){this.restore();}}};CanvasRendererBase.prototype.buildItem=function(pos){var elements=this.elements;if(elements[pos]||this.layers[pos].ty===99){return;}var element=this.createItem(this.layers[pos],this,this.globalData);elements[pos]=element;element.initExpressions();/* if(this.layers[pos].ty === 0){
	          element.resize(this.globalData.transformCanvas);
	      } */};CanvasRendererBase.prototype.checkPendingElements=function(){while(this.pendingElements.length){var element=this.pendingElements.pop();element.checkParenting();}};CanvasRendererBase.prototype.hide=function(){this.animationItem.container.style.display='none';};CanvasRendererBase.prototype.show=function(){this.animationItem.container.style.display='block';};function CanvasContext(){this.opacity=-1;this.transform=createTypedArray('float32',16);this.fillStyle='';this.strokeStyle='';this.lineWidth='';this.lineCap='';this.lineJoin='';this.miterLimit='';this.id=Math.random();}function CVContextData(){this.stack=[];this.cArrPos=0;this.cTr=new Matrix();var i;var len=15;for(i=0;i<len;i+=1){var canvasContext=new CanvasContext();this.stack[i]=canvasContext;}this._length=len;this.nativeContext=null;this.transformMat=new Matrix();this.currentOpacity=1;//
	this.currentFillStyle='';this.appliedFillStyle='';//
	this.currentStrokeStyle='';this.appliedStrokeStyle='';//
	this.currentLineWidth='';this.appliedLineWidth='';//
	this.currentLineCap='';this.appliedLineCap='';//
	this.currentLineJoin='';this.appliedLineJoin='';//
	this.appliedMiterLimit='';this.currentMiterLimit='';}CVContextData.prototype.duplicate=function(){var newLength=this._length*2;var i=0;for(i=this._length;i<newLength;i+=1){this.stack[i]=new CanvasContext();}this._length=newLength;};CVContextData.prototype.reset=function(){this.cArrPos=0;this.cTr.reset();this.stack[this.cArrPos].opacity=1;};CVContextData.prototype.restore=function(forceRestore){this.cArrPos-=1;var currentContext=this.stack[this.cArrPos];var transform=currentContext.transform;var i;var arr=this.cTr.props;for(i=0;i<16;i+=1){arr[i]=transform[i];}if(forceRestore){this.nativeContext.restore();var prevStack=this.stack[this.cArrPos+1];this.appliedFillStyle=prevStack.fillStyle;this.appliedStrokeStyle=prevStack.strokeStyle;this.appliedLineWidth=prevStack.lineWidth;this.appliedLineCap=prevStack.lineCap;this.appliedLineJoin=prevStack.lineJoin;this.appliedMiterLimit=prevStack.miterLimit;}this.nativeContext.setTransform(transform[0],transform[1],transform[4],transform[5],transform[12],transform[13]);if(forceRestore||currentContext.opacity!==-1&&this.currentOpacity!==currentContext.opacity){this.nativeContext.globalAlpha=currentContext.opacity;this.currentOpacity=currentContext.opacity;}this.currentFillStyle=currentContext.fillStyle;this.currentStrokeStyle=currentContext.strokeStyle;this.currentLineWidth=currentContext.lineWidth;this.currentLineCap=currentContext.lineCap;this.currentLineJoin=currentContext.lineJoin;this.currentMiterLimit=currentContext.miterLimit;};CVContextData.prototype.save=function(saveOnNativeFlag){if(saveOnNativeFlag){this.nativeContext.save();}var props=this.cTr.props;if(this._length<=this.cArrPos){this.duplicate();}var currentStack=this.stack[this.cArrPos];var i;for(i=0;i<16;i+=1){currentStack.transform[i]=props[i];}this.cArrPos+=1;var newStack=this.stack[this.cArrPos];newStack.opacity=currentStack.opacity;newStack.fillStyle=currentStack.fillStyle;newStack.strokeStyle=currentStack.strokeStyle;newStack.lineWidth=currentStack.lineWidth;newStack.lineCap=currentStack.lineCap;newStack.lineJoin=currentStack.lineJoin;newStack.miterLimit=currentStack.miterLimit;};CVContextData.prototype.setOpacity=function(value){this.stack[this.cArrPos].opacity=value;};CVContextData.prototype.setContext=function(value){this.nativeContext=value;};CVContextData.prototype.fillStyle=function(value){if(this.stack[this.cArrPos].fillStyle!==value){this.currentFillStyle=value;this.stack[this.cArrPos].fillStyle=value;}};CVContextData.prototype.strokeStyle=function(value){if(this.stack[this.cArrPos].strokeStyle!==value){this.currentStrokeStyle=value;this.stack[this.cArrPos].strokeStyle=value;}};CVContextData.prototype.lineWidth=function(value){if(this.stack[this.cArrPos].lineWidth!==value){this.currentLineWidth=value;this.stack[this.cArrPos].lineWidth=value;}};CVContextData.prototype.lineCap=function(value){if(this.stack[this.cArrPos].lineCap!==value){this.currentLineCap=value;this.stack[this.cArrPos].lineCap=value;}};CVContextData.prototype.lineJoin=function(value){if(this.stack[this.cArrPos].lineJoin!==value){this.currentLineJoin=value;this.stack[this.cArrPos].lineJoin=value;}};CVContextData.prototype.miterLimit=function(value){if(this.stack[this.cArrPos].miterLimit!==value){this.currentMiterLimit=value;this.stack[this.cArrPos].miterLimit=value;}};CVContextData.prototype.transform=function(props){this.transformMat.cloneFromProps(props);// Taking the last transform value from the stored stack of transforms
	var currentTransform=this.cTr;// Applying the last transform value after the new transform to respect the order of transformations
	this.transformMat.multiply(currentTransform);// Storing the new transformed value in the stored transform
	currentTransform.cloneFromProps(this.transformMat.props);var trProps=currentTransform.props;// Applying the new transform to the canvas
	this.nativeContext.setTransform(trProps[0],trProps[1],trProps[4],trProps[5],trProps[12],trProps[13]);};CVContextData.prototype.opacity=function(op){var currentOpacity=this.stack[this.cArrPos].opacity;currentOpacity*=op<0?0:op;if(this.stack[this.cArrPos].opacity!==currentOpacity){if(this.currentOpacity!==op){this.nativeContext.globalAlpha=op;this.currentOpacity=op;}this.stack[this.cArrPos].opacity=currentOpacity;}};CVContextData.prototype.fill=function(rule){if(this.appliedFillStyle!==this.currentFillStyle){this.appliedFillStyle=this.currentFillStyle;this.nativeContext.fillStyle=this.appliedFillStyle;}this.nativeContext.fill(rule);};CVContextData.prototype.fillRect=function(x,y,w,h){if(this.appliedFillStyle!==this.currentFillStyle){this.appliedFillStyle=this.currentFillStyle;this.nativeContext.fillStyle=this.appliedFillStyle;}this.nativeContext.fillRect(x,y,w,h);};CVContextData.prototype.stroke=function(){if(this.appliedStrokeStyle!==this.currentStrokeStyle){this.appliedStrokeStyle=this.currentStrokeStyle;this.nativeContext.strokeStyle=this.appliedStrokeStyle;}if(this.appliedLineWidth!==this.currentLineWidth){this.appliedLineWidth=this.currentLineWidth;this.nativeContext.lineWidth=this.appliedLineWidth;}if(this.appliedLineCap!==this.currentLineCap){this.appliedLineCap=this.currentLineCap;this.nativeContext.lineCap=this.appliedLineCap;}if(this.appliedLineJoin!==this.currentLineJoin){this.appliedLineJoin=this.currentLineJoin;this.nativeContext.lineJoin=this.appliedLineJoin;}if(this.appliedMiterLimit!==this.currentMiterLimit){this.appliedMiterLimit=this.currentMiterLimit;this.nativeContext.miterLimit=this.appliedMiterLimit;}this.nativeContext.stroke();};function CVCompElement(data,globalData,comp){this.completeLayers=false;this.layers=data.layers;this.pendingElements=[];this.elements=createSizedArray(this.layers.length);this.initElement(data,globalData,comp);this.tm=data.tm?PropertyFactory.getProp(this,data.tm,0,globalData.frameRate,this):{_placeholder:true};}extendPrototype([CanvasRendererBase,ICompElement,CVBaseElement],CVCompElement);CVCompElement.prototype.renderInnerContent=function(){var ctx=this.canvasContext;ctx.beginPath();ctx.moveTo(0,0);ctx.lineTo(this.data.w,0);ctx.lineTo(this.data.w,this.data.h);ctx.lineTo(0,this.data.h);ctx.lineTo(0,0);ctx.clip();var i;var len=this.layers.length;for(i=len-1;i>=0;i-=1){if(this.completeLayers||this.elements[i]){this.elements[i].renderFrame();}}};CVCompElement.prototype.destroy=function(){var i;var len=this.layers.length;for(i=len-1;i>=0;i-=1){if(this.elements[i]){this.elements[i].destroy();}}this.layers=null;this.elements=null;};CVCompElement.prototype.createComp=function(data){return new CVCompElement(data,this.globalData,this);};function CanvasRenderer(animationItem,config){this.animationItem=animationItem;this.renderConfig={clearCanvas:config&&config.clearCanvas!==undefined?config.clearCanvas:true,context:config&&config.context||null,progressiveLoad:config&&config.progressiveLoad||false,preserveAspectRatio:config&&config.preserveAspectRatio||'xMidYMid meet',imagePreserveAspectRatio:config&&config.imagePreserveAspectRatio||'xMidYMid slice',contentVisibility:config&&config.contentVisibility||'visible',className:config&&config.className||'',id:config&&config.id||'',runExpressions:!config||config.runExpressions===undefined||config.runExpressions};this.renderConfig.dpr=config&&config.dpr||1;if(this.animationItem.wrapper){this.renderConfig.dpr=config&&config.dpr||window.devicePixelRatio||1;}this.renderedFrame=-1;this.globalData={frameNum:-1,_mdf:false,renderConfig:this.renderConfig,currentGlobalAlpha:-1};this.contextData=new CVContextData();this.elements=[];this.pendingElements=[];this.transformMat=new Matrix();this.completeLayers=false;this.rendererType='canvas';if(this.renderConfig.clearCanvas){this.ctxTransform=this.contextData.transform.bind(this.contextData);this.ctxOpacity=this.contextData.opacity.bind(this.contextData);this.ctxFillStyle=this.contextData.fillStyle.bind(this.contextData);this.ctxStrokeStyle=this.contextData.strokeStyle.bind(this.contextData);this.ctxLineWidth=this.contextData.lineWidth.bind(this.contextData);this.ctxLineCap=this.contextData.lineCap.bind(this.contextData);this.ctxLineJoin=this.contextData.lineJoin.bind(this.contextData);this.ctxMiterLimit=this.contextData.miterLimit.bind(this.contextData);this.ctxFill=this.contextData.fill.bind(this.contextData);this.ctxFillRect=this.contextData.fillRect.bind(this.contextData);this.ctxStroke=this.contextData.stroke.bind(this.contextData);this.save=this.contextData.save.bind(this.contextData);}}extendPrototype([CanvasRendererBase],CanvasRenderer);CanvasRenderer.prototype.createComp=function(data){return new CVCompElement(data,this.globalData,this);};function HBaseElement(){}HBaseElement.prototype={checkBlendMode:function checkBlendMode(){},initRendererElement:function initRendererElement(){this.baseElement=createTag(this.data.tg||'div');if(this.data.hasMask){this.svgElement=createNS('svg');this.layerElement=createNS('g');this.maskedElement=this.layerElement;this.svgElement.appendChild(this.layerElement);this.baseElement.appendChild(this.svgElement);}else {this.layerElement=this.baseElement;}styleDiv(this.baseElement);},createContainerElements:function createContainerElements(){this.renderableEffectsManager=new CVEffects(this);this.transformedElement=this.baseElement;this.maskedElement=this.layerElement;if(this.data.ln){this.layerElement.setAttribute('id',this.data.ln);}if(this.data.cl){this.layerElement.setAttribute('class',this.data.cl);}if(this.data.bm!==0){this.setBlendMode();}},renderElement:function renderElement(){var transformedElementStyle=this.transformedElement?this.transformedElement.style:{};if(this.finalTransform._matMdf){var matrixValue=this.finalTransform.mat.toCSS();transformedElementStyle.transform=matrixValue;transformedElementStyle.webkitTransform=matrixValue;}if(this.finalTransform._opMdf){transformedElementStyle.opacity=this.finalTransform.mProp.o.v;}},renderFrame:function renderFrame(){// If it is exported as hidden (data.hd === true) no need to render
	// If it is not visible no need to render
	if(this.data.hd||this.hidden){return;}this.renderTransform();this.renderRenderable();this.renderElement();this.renderInnerContent();if(this._isFirstFrame){this._isFirstFrame=false;}},destroy:function destroy(){this.layerElement=null;this.transformedElement=null;if(this.matteElement){this.matteElement=null;}if(this.maskManager){this.maskManager.destroy();this.maskManager=null;}},createRenderableComponents:function createRenderableComponents(){this.maskManager=new MaskElement(this.data,this,this.globalData);},addEffects:function addEffects(){},setMatte:function setMatte(){}};HBaseElement.prototype.getBaseElement=SVGBaseElement.prototype.getBaseElement;HBaseElement.prototype.destroyBaseElement=HBaseElement.prototype.destroy;HBaseElement.prototype.buildElementParenting=BaseRenderer.prototype.buildElementParenting;function HSolidElement(data,globalData,comp){this.initElement(data,globalData,comp);}extendPrototype([BaseElement,TransformElement,HBaseElement,HierarchyElement,FrameElement,RenderableDOMElement],HSolidElement);HSolidElement.prototype.createContent=function(){var rect;if(this.data.hasMask){rect=createNS('rect');rect.setAttribute('width',this.data.sw);rect.setAttribute('height',this.data.sh);rect.setAttribute('fill',this.data.sc);this.svgElement.setAttribute('width',this.data.sw);this.svgElement.setAttribute('height',this.data.sh);}else {rect=createTag('div');rect.style.width=this.data.sw+'px';rect.style.height=this.data.sh+'px';rect.style.backgroundColor=this.data.sc;}this.layerElement.appendChild(rect);};function HShapeElement(data,globalData,comp){// List of drawable elements
	this.shapes=[];// Full shape data
	this.shapesData=data.shapes;// List of styles that will be applied to shapes
	this.stylesList=[];// List of modifiers that will be applied to shapes
	this.shapeModifiers=[];// List of items in shape tree
	this.itemsData=[];// List of items in previous shape tree
	this.processedElements=[];// List of animated components
	this.animatedContents=[];this.shapesContainer=createNS('g');this.initElement(data,globalData,comp);// Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
	// List of elements that have been created
	this.prevViewData=[];this.currentBBox={x:999999,y:-999999,h:0,w:0};}extendPrototype([BaseElement,TransformElement,HSolidElement,SVGShapeElement,HBaseElement,HierarchyElement,FrameElement,RenderableElement],HShapeElement);HShapeElement.prototype._renderShapeFrame=HShapeElement.prototype.renderInnerContent;HShapeElement.prototype.createContent=function(){var cont;this.baseElement.style.fontSize=0;if(this.data.hasMask){this.layerElement.appendChild(this.shapesContainer);cont=this.svgElement;}else {cont=createNS('svg');var size=this.comp.data?this.comp.data:this.globalData.compSize;cont.setAttribute('width',size.w);cont.setAttribute('height',size.h);cont.appendChild(this.shapesContainer);this.layerElement.appendChild(cont);}this.searchShapes(this.shapesData,this.itemsData,this.prevViewData,this.shapesContainer,0,[],true);this.filterUniqueShapes();this.shapeCont=cont;};HShapeElement.prototype.getTransformedPoint=function(transformers,point){var i;var len=transformers.length;for(i=0;i<len;i+=1){point=transformers[i].mProps.v.applyToPointArray(point[0],point[1],0);}return point;};HShapeElement.prototype.calculateShapeBoundingBox=function(item,boundingBox){var shape=item.sh.v;var transformers=item.transformers;var i;var len=shape._length;var vPoint;var oPoint;var nextIPoint;var nextVPoint;if(len<=1){return;}for(i=0;i<len-1;i+=1){vPoint=this.getTransformedPoint(transformers,shape.v[i]);oPoint=this.getTransformedPoint(transformers,shape.o[i]);nextIPoint=this.getTransformedPoint(transformers,shape.i[i+1]);nextVPoint=this.getTransformedPoint(transformers,shape.v[i+1]);this.checkBounds(vPoint,oPoint,nextIPoint,nextVPoint,boundingBox);}if(shape.c){vPoint=this.getTransformedPoint(transformers,shape.v[i]);oPoint=this.getTransformedPoint(transformers,shape.o[i]);nextIPoint=this.getTransformedPoint(transformers,shape.i[0]);nextVPoint=this.getTransformedPoint(transformers,shape.v[0]);this.checkBounds(vPoint,oPoint,nextIPoint,nextVPoint,boundingBox);}};HShapeElement.prototype.checkBounds=function(vPoint,oPoint,nextIPoint,nextVPoint,boundingBox){this.getBoundsOfCurve(vPoint,oPoint,nextIPoint,nextVPoint);var bounds=this.shapeBoundingBox;boundingBox.x=bmMin(bounds.left,boundingBox.x);boundingBox.xMax=bmMax(bounds.right,boundingBox.xMax);boundingBox.y=bmMin(bounds.top,boundingBox.y);boundingBox.yMax=bmMax(bounds.bottom,boundingBox.yMax);};HShapeElement.prototype.shapeBoundingBox={left:0,right:0,top:0,bottom:0};HShapeElement.prototype.tempBoundingBox={x:0,xMax:0,y:0,yMax:0,width:0,height:0};HShapeElement.prototype.getBoundsOfCurve=function(p0,p1,p2,p3){var bounds=[[p0[0],p3[0]],[p0[1],p3[1]]];for(var a,b,c,t,b2ac,t1,t2,i=0;i<2;++i){// eslint-disable-line no-plusplus
	b=6*p0[i]-12*p1[i]+6*p2[i];a=-3*p0[i]+9*p1[i]-9*p2[i]+3*p3[i];c=3*p1[i]-3*p0[i];b|=0;// eslint-disable-line no-bitwise
	a|=0;// eslint-disable-line no-bitwise
	c|=0;// eslint-disable-line no-bitwise
	if(a===0&&b===0);else if(a===0){t=-c/b;if(t>0&&t<1){bounds[i].push(this.calculateF(t,p0,p1,p2,p3,i));}}else {b2ac=b*b-4*c*a;if(b2ac>=0){t1=(-b+bmSqrt(b2ac))/(2*a);if(t1>0&&t1<1)bounds[i].push(this.calculateF(t1,p0,p1,p2,p3,i));t2=(-b-bmSqrt(b2ac))/(2*a);if(t2>0&&t2<1)bounds[i].push(this.calculateF(t2,p0,p1,p2,p3,i));}}}this.shapeBoundingBox.left=bmMin.apply(null,bounds[0]);this.shapeBoundingBox.top=bmMin.apply(null,bounds[1]);this.shapeBoundingBox.right=bmMax.apply(null,bounds[0]);this.shapeBoundingBox.bottom=bmMax.apply(null,bounds[1]);};HShapeElement.prototype.calculateF=function(t,p0,p1,p2,p3,i){return bmPow(1-t,3)*p0[i]+3*bmPow(1-t,2)*t*p1[i]+3*(1-t)*bmPow(t,2)*p2[i]+bmPow(t,3)*p3[i];};HShapeElement.prototype.calculateBoundingBox=function(itemsData,boundingBox){var i;var len=itemsData.length;for(i=0;i<len;i+=1){if(itemsData[i]&&itemsData[i].sh){this.calculateShapeBoundingBox(itemsData[i],boundingBox);}else if(itemsData[i]&&itemsData[i].it){this.calculateBoundingBox(itemsData[i].it,boundingBox);}else if(itemsData[i]&&itemsData[i].style&&itemsData[i].w){this.expandStrokeBoundingBox(itemsData[i].w,boundingBox);}}};HShapeElement.prototype.expandStrokeBoundingBox=function(widthProperty,boundingBox){var width=0;if(widthProperty.keyframes){for(var i=0;i<widthProperty.keyframes.length;i+=1){var kfw=widthProperty.keyframes[i].s;if(kfw>width){width=kfw;}}width*=widthProperty.mult;}else {width=widthProperty.v*widthProperty.mult;}boundingBox.x-=width;boundingBox.xMax+=width;boundingBox.y-=width;boundingBox.yMax+=width;};HShapeElement.prototype.currentBoxContains=function(box){return this.currentBBox.x<=box.x&&this.currentBBox.y<=box.y&&this.currentBBox.width+this.currentBBox.x>=box.x+box.width&&this.currentBBox.height+this.currentBBox.y>=box.y+box.height;};HShapeElement.prototype.renderInnerContent=function(){this._renderShapeFrame();if(!this.hidden&&(this._isFirstFrame||this._mdf)){var tempBoundingBox=this.tempBoundingBox;var max=999999;tempBoundingBox.x=max;tempBoundingBox.xMax=-max;tempBoundingBox.y=max;tempBoundingBox.yMax=-max;this.calculateBoundingBox(this.itemsData,tempBoundingBox);tempBoundingBox.width=tempBoundingBox.xMax<tempBoundingBox.x?0:tempBoundingBox.xMax-tempBoundingBox.x;tempBoundingBox.height=tempBoundingBox.yMax<tempBoundingBox.y?0:tempBoundingBox.yMax-tempBoundingBox.y;// var tempBoundingBox = this.shapeCont.getBBox();
	if(this.currentBoxContains(tempBoundingBox)){return;}var changed=false;if(this.currentBBox.w!==tempBoundingBox.width){this.currentBBox.w=tempBoundingBox.width;this.shapeCont.setAttribute('width',tempBoundingBox.width);changed=true;}if(this.currentBBox.h!==tempBoundingBox.height){this.currentBBox.h=tempBoundingBox.height;this.shapeCont.setAttribute('height',tempBoundingBox.height);changed=true;}if(changed||this.currentBBox.x!==tempBoundingBox.x||this.currentBBox.y!==tempBoundingBox.y){this.currentBBox.w=tempBoundingBox.width;this.currentBBox.h=tempBoundingBox.height;this.currentBBox.x=tempBoundingBox.x;this.currentBBox.y=tempBoundingBox.y;this.shapeCont.setAttribute('viewBox',this.currentBBox.x+' '+this.currentBBox.y+' '+this.currentBBox.w+' '+this.currentBBox.h);var shapeStyle=this.shapeCont.style;var shapeTransform='translate('+this.currentBBox.x+'px,'+this.currentBBox.y+'px)';shapeStyle.transform=shapeTransform;shapeStyle.webkitTransform=shapeTransform;}}};function HTextElement(data,globalData,comp){this.textSpans=[];this.textPaths=[];this.currentBBox={x:999999,y:-999999,h:0,w:0};this.renderType='svg';this.isMasked=false;this.initElement(data,globalData,comp);}extendPrototype([BaseElement,TransformElement,HBaseElement,HierarchyElement,FrameElement,RenderableDOMElement,ITextElement],HTextElement);HTextElement.prototype.createContent=function(){this.isMasked=this.checkMasks();if(this.isMasked){this.renderType='svg';this.compW=this.comp.data.w;this.compH=this.comp.data.h;this.svgElement.setAttribute('width',this.compW);this.svgElement.setAttribute('height',this.compH);var g=createNS('g');this.maskedElement.appendChild(g);this.innerElem=g;}else {this.renderType='html';this.innerElem=this.layerElement;}this.checkParenting();};HTextElement.prototype.buildNewText=function(){var documentData=this.textProperty.currentData;this.renderedLetters=createSizedArray(documentData.l?documentData.l.length:0);var innerElemStyle=this.innerElem.style;var textColor=documentData.fc?this.buildColor(documentData.fc):'rgba(0,0,0,0)';innerElemStyle.fill=textColor;innerElemStyle.color=textColor;if(documentData.sc){innerElemStyle.stroke=this.buildColor(documentData.sc);innerElemStyle.strokeWidth=documentData.sw+'px';}var fontData=this.globalData.fontManager.getFontByName(documentData.f);if(!this.globalData.fontManager.chars){innerElemStyle.fontSize=documentData.finalSize+'px';innerElemStyle.lineHeight=documentData.finalSize+'px';if(fontData.fClass){this.innerElem.className=fontData.fClass;}else {innerElemStyle.fontFamily=fontData.fFamily;var fWeight=documentData.fWeight;var fStyle=documentData.fStyle;innerElemStyle.fontStyle=fStyle;innerElemStyle.fontWeight=fWeight;}}var i;var len;var letters=documentData.l;len=letters.length;var tSpan;var tParent;var tCont;var matrixHelper=this.mHelper;var shapes;var shapeStr='';var cnt=0;for(i=0;i<len;i+=1){if(this.globalData.fontManager.chars){if(!this.textPaths[cnt]){tSpan=createNS('path');tSpan.setAttribute('stroke-linecap',lineCapEnum[1]);tSpan.setAttribute('stroke-linejoin',lineJoinEnum[2]);tSpan.setAttribute('stroke-miterlimit','4');}else {tSpan=this.textPaths[cnt];}if(!this.isMasked){if(this.textSpans[cnt]){tParent=this.textSpans[cnt];tCont=tParent.children[0];}else {tParent=createTag('div');tParent.style.lineHeight=0;tCont=createNS('svg');tCont.appendChild(tSpan);styleDiv(tParent);}}}else if(!this.isMasked){if(this.textSpans[cnt]){tParent=this.textSpans[cnt];tSpan=this.textPaths[cnt];}else {tParent=createTag('span');styleDiv(tParent);tSpan=createTag('span');styleDiv(tSpan);tParent.appendChild(tSpan);}}else {tSpan=this.textPaths[cnt]?this.textPaths[cnt]:createNS('text');}// tSpan.setAttribute('visibility', 'hidden');
	if(this.globalData.fontManager.chars){var charData=this.globalData.fontManager.getCharData(documentData.finalText[i],fontData.fStyle,this.globalData.fontManager.getFontByName(documentData.f).fFamily);var shapeData;if(charData){shapeData=charData.data;}else {shapeData=null;}matrixHelper.reset();if(shapeData&&shapeData.shapes&&shapeData.shapes.length){shapes=shapeData.shapes[0].it;matrixHelper.scale(documentData.finalSize/100,documentData.finalSize/100);shapeStr=this.createPathShape(matrixHelper,shapes);tSpan.setAttribute('d',shapeStr);}if(!this.isMasked){this.innerElem.appendChild(tParent);if(shapeData&&shapeData.shapes){// document.body.appendChild is needed to get exact measure of shape
	document.body.appendChild(tCont);var boundingBox=tCont.getBBox();tCont.setAttribute('width',boundingBox.width+2);tCont.setAttribute('height',boundingBox.height+2);tCont.setAttribute('viewBox',boundingBox.x-1+' '+(boundingBox.y-1)+' '+(boundingBox.width+2)+' '+(boundingBox.height+2));var tContStyle=tCont.style;var tContTranslation='translate('+(boundingBox.x-1)+'px,'+(boundingBox.y-1)+'px)';tContStyle.transform=tContTranslation;tContStyle.webkitTransform=tContTranslation;letters[i].yOffset=boundingBox.y-1;}else {tCont.setAttribute('width',1);tCont.setAttribute('height',1);}tParent.appendChild(tCont);}else {this.innerElem.appendChild(tSpan);}}else {tSpan.textContent=letters[i].val;tSpan.setAttributeNS('http://www.w3.org/XML/1998/namespace','xml:space','preserve');if(!this.isMasked){this.innerElem.appendChild(tParent);//
	var tStyle=tSpan.style;var tSpanTranslation='translate3d(0,'+-documentData.finalSize/1.2+'px,0)';tStyle.transform=tSpanTranslation;tStyle.webkitTransform=tSpanTranslation;}else {this.innerElem.appendChild(tSpan);}}//
	if(!this.isMasked){this.textSpans[cnt]=tParent;}else {this.textSpans[cnt]=tSpan;}this.textSpans[cnt].style.display='block';this.textPaths[cnt]=tSpan;cnt+=1;}while(cnt<this.textSpans.length){this.textSpans[cnt].style.display='none';cnt+=1;}};HTextElement.prototype.renderInnerContent=function(){this.validateText();var svgStyle;if(this.data.singleShape){if(!this._isFirstFrame&&!this.lettersChangedFlag){return;}if(this.isMasked&&this.finalTransform._matMdf){// Todo Benchmark if using this is better than getBBox
	this.svgElement.setAttribute('viewBox',-this.finalTransform.mProp.p.v[0]+' '+-this.finalTransform.mProp.p.v[1]+' '+this.compW+' '+this.compH);svgStyle=this.svgElement.style;var translation='translate('+-this.finalTransform.mProp.p.v[0]+'px,'+-this.finalTransform.mProp.p.v[1]+'px)';svgStyle.transform=translation;svgStyle.webkitTransform=translation;}}this.textAnimator.getMeasures(this.textProperty.currentData,this.lettersChangedFlag);if(!this.lettersChangedFlag&&!this.textAnimator.lettersChangedFlag){return;}var i;var len;var count=0;var renderedLetters=this.textAnimator.renderedLetters;var letters=this.textProperty.currentData.l;len=letters.length;var renderedLetter;var textSpan;var textPath;for(i=0;i<len;i+=1){if(letters[i].n){count+=1;}else {textSpan=this.textSpans[i];textPath=this.textPaths[i];renderedLetter=renderedLetters[count];count+=1;if(renderedLetter._mdf.m){if(!this.isMasked){textSpan.style.webkitTransform=renderedLetter.m;textSpan.style.transform=renderedLetter.m;}else {textSpan.setAttribute('transform',renderedLetter.m);}}/// /textSpan.setAttribute('opacity',renderedLetter.o);
	textSpan.style.opacity=renderedLetter.o;if(renderedLetter.sw&&renderedLetter._mdf.sw){textPath.setAttribute('stroke-width',renderedLetter.sw);}if(renderedLetter.sc&&renderedLetter._mdf.sc){textPath.setAttribute('stroke',renderedLetter.sc);}if(renderedLetter.fc&&renderedLetter._mdf.fc){textPath.setAttribute('fill',renderedLetter.fc);textPath.style.color=renderedLetter.fc;}}}if(this.innerElem.getBBox&&!this.hidden&&(this._isFirstFrame||this._mdf)){var boundingBox=this.innerElem.getBBox();if(this.currentBBox.w!==boundingBox.width){this.currentBBox.w=boundingBox.width;this.svgElement.setAttribute('width',boundingBox.width);}if(this.currentBBox.h!==boundingBox.height){this.currentBBox.h=boundingBox.height;this.svgElement.setAttribute('height',boundingBox.height);}var margin=1;if(this.currentBBox.w!==boundingBox.width+margin*2||this.currentBBox.h!==boundingBox.height+margin*2||this.currentBBox.x!==boundingBox.x-margin||this.currentBBox.y!==boundingBox.y-margin){this.currentBBox.w=boundingBox.width+margin*2;this.currentBBox.h=boundingBox.height+margin*2;this.currentBBox.x=boundingBox.x-margin;this.currentBBox.y=boundingBox.y-margin;this.svgElement.setAttribute('viewBox',this.currentBBox.x+' '+this.currentBBox.y+' '+this.currentBBox.w+' '+this.currentBBox.h);svgStyle=this.svgElement.style;var svgTransform='translate('+this.currentBBox.x+'px,'+this.currentBBox.y+'px)';svgStyle.transform=svgTransform;svgStyle.webkitTransform=svgTransform;}}};function HCameraElement(data,globalData,comp){this.initFrame();this.initBaseData(data,globalData,comp);this.initHierarchy();var getProp=PropertyFactory.getProp;this.pe=getProp(this,data.pe,0,0,this);if(data.ks.p.s){this.px=getProp(this,data.ks.p.x,1,0,this);this.py=getProp(this,data.ks.p.y,1,0,this);this.pz=getProp(this,data.ks.p.z,1,0,this);}else {this.p=getProp(this,data.ks.p,1,0,this);}if(data.ks.a){this.a=getProp(this,data.ks.a,1,0,this);}if(data.ks.or.k.length&&data.ks.or.k[0].to){var i;var len=data.ks.or.k.length;for(i=0;i<len;i+=1){data.ks.or.k[i].to=null;data.ks.or.k[i].ti=null;}}this.or=getProp(this,data.ks.or,1,degToRads,this);this.or.sh=true;this.rx=getProp(this,data.ks.rx,0,degToRads,this);this.ry=getProp(this,data.ks.ry,0,degToRads,this);this.rz=getProp(this,data.ks.rz,0,degToRads,this);this.mat=new Matrix();this._prevMat=new Matrix();this._isFirstFrame=true;// TODO: find a better way to make the HCamera element to be compatible with the LayerInterface and TransformInterface.
	this.finalTransform={mProp:this};}extendPrototype([BaseElement,FrameElement,HierarchyElement],HCameraElement);HCameraElement.prototype.setup=function(){var i;var len=this.comp.threeDElements.length;var comp;var perspectiveStyle;var containerStyle;for(i=0;i<len;i+=1){// [perspectiveElem,container]
	comp=this.comp.threeDElements[i];if(comp.type==='3d'){perspectiveStyle=comp.perspectiveElem.style;containerStyle=comp.container.style;var perspective=this.pe.v+'px';var origin='0px 0px 0px';var matrix='matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';perspectiveStyle.perspective=perspective;perspectiveStyle.webkitPerspective=perspective;containerStyle.transformOrigin=origin;containerStyle.mozTransformOrigin=origin;containerStyle.webkitTransformOrigin=origin;perspectiveStyle.transform=matrix;perspectiveStyle.webkitTransform=matrix;}}};HCameraElement.prototype.createElements=function(){};HCameraElement.prototype.hide=function(){};HCameraElement.prototype.renderFrame=function(){var _mdf=this._isFirstFrame;var i;var len;if(this.hierarchy){len=this.hierarchy.length;for(i=0;i<len;i+=1){_mdf=this.hierarchy[i].finalTransform.mProp._mdf||_mdf;}}if(_mdf||this.pe._mdf||this.p&&this.p._mdf||this.px&&(this.px._mdf||this.py._mdf||this.pz._mdf)||this.rx._mdf||this.ry._mdf||this.rz._mdf||this.or._mdf||this.a&&this.a._mdf){this.mat.reset();if(this.hierarchy){len=this.hierarchy.length-1;for(i=len;i>=0;i-=1){var mTransf=this.hierarchy[i].finalTransform.mProp;this.mat.translate(-mTransf.p.v[0],-mTransf.p.v[1],mTransf.p.v[2]);this.mat.rotateX(-mTransf.or.v[0]).rotateY(-mTransf.or.v[1]).rotateZ(mTransf.or.v[2]);this.mat.rotateX(-mTransf.rx.v).rotateY(-mTransf.ry.v).rotateZ(mTransf.rz.v);this.mat.scale(1/mTransf.s.v[0],1/mTransf.s.v[1],1/mTransf.s.v[2]);this.mat.translate(mTransf.a.v[0],mTransf.a.v[1],mTransf.a.v[2]);}}if(this.p){this.mat.translate(-this.p.v[0],-this.p.v[1],this.p.v[2]);}else {this.mat.translate(-this.px.v,-this.py.v,this.pz.v);}if(this.a){var diffVector;if(this.p){diffVector=[this.p.v[0]-this.a.v[0],this.p.v[1]-this.a.v[1],this.p.v[2]-this.a.v[2]];}else {diffVector=[this.px.v-this.a.v[0],this.py.v-this.a.v[1],this.pz.v-this.a.v[2]];}var mag=Math.sqrt(Math.pow(diffVector[0],2)+Math.pow(diffVector[1],2)+Math.pow(diffVector[2],2));// var lookDir = getNormalizedPoint(getDiffVector(this.a.v,this.p.v));
	var lookDir=[diffVector[0]/mag,diffVector[1]/mag,diffVector[2]/mag];var lookLengthOnXZ=Math.sqrt(lookDir[2]*lookDir[2]+lookDir[0]*lookDir[0]);var mRotationX=Math.atan2(lookDir[1],lookLengthOnXZ);var mRotationY=Math.atan2(lookDir[0],-lookDir[2]);this.mat.rotateY(mRotationY).rotateX(-mRotationX);}this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v);this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]);this.mat.translate(this.globalData.compSize.w/2,this.globalData.compSize.h/2,0);this.mat.translate(0,0,this.pe.v);var hasMatrixChanged=!this._prevMat.equals(this.mat);if((hasMatrixChanged||this.pe._mdf)&&this.comp.threeDElements){len=this.comp.threeDElements.length;var comp;var perspectiveStyle;var containerStyle;for(i=0;i<len;i+=1){comp=this.comp.threeDElements[i];if(comp.type==='3d'){if(hasMatrixChanged){var matValue=this.mat.toCSS();containerStyle=comp.container.style;containerStyle.transform=matValue;containerStyle.webkitTransform=matValue;}if(this.pe._mdf){perspectiveStyle=comp.perspectiveElem.style;perspectiveStyle.perspective=this.pe.v+'px';perspectiveStyle.webkitPerspective=this.pe.v+'px';}}}this.mat.clone(this._prevMat);}}this._isFirstFrame=false;};HCameraElement.prototype.prepareFrame=function(num){this.prepareProperties(num,true);};HCameraElement.prototype.destroy=function(){};HCameraElement.prototype.getBaseElement=function(){return null;};function HImageElement(data,globalData,comp){this.assetData=globalData.getAssetData(data.refId);this.initElement(data,globalData,comp);}extendPrototype([BaseElement,TransformElement,HBaseElement,HSolidElement,HierarchyElement,FrameElement,RenderableElement],HImageElement);HImageElement.prototype.createContent=function(){var assetPath=this.globalData.getAssetsPath(this.assetData);var img=new Image();if(this.data.hasMask){this.imageElem=createNS('image');this.imageElem.setAttribute('width',this.assetData.w+'px');this.imageElem.setAttribute('height',this.assetData.h+'px');this.imageElem.setAttributeNS('http://www.w3.org/1999/xlink','href',assetPath);this.layerElement.appendChild(this.imageElem);this.baseElement.setAttribute('width',this.assetData.w);this.baseElement.setAttribute('height',this.assetData.h);}else {this.layerElement.appendChild(img);}img.crossOrigin='anonymous';img.src=assetPath;if(this.data.ln){this.baseElement.setAttribute('id',this.data.ln);}};function HybridRendererBase(animationItem,config){this.animationItem=animationItem;this.layers=null;this.renderedFrame=-1;this.renderConfig={className:config&&config.className||'',imagePreserveAspectRatio:config&&config.imagePreserveAspectRatio||'xMidYMid slice',hideOnTransparent:!(config&&config.hideOnTransparent===false),filterSize:{width:config&&config.filterSize&&config.filterSize.width||'400%',height:config&&config.filterSize&&config.filterSize.height||'400%',x:config&&config.filterSize&&config.filterSize.x||'-100%',y:config&&config.filterSize&&config.filterSize.y||'-100%'}};this.globalData={_mdf:false,frameNum:-1,renderConfig:this.renderConfig};this.pendingElements=[];this.elements=[];this.threeDElements=[];this.destroyed=false;this.camera=null;this.supports3d=true;this.rendererType='html';}extendPrototype([BaseRenderer],HybridRendererBase);HybridRendererBase.prototype.buildItem=SVGRenderer.prototype.buildItem;HybridRendererBase.prototype.checkPendingElements=function(){while(this.pendingElements.length){var element=this.pendingElements.pop();element.checkParenting();}};HybridRendererBase.prototype.appendElementInPos=function(element,pos){var newDOMElement=element.getBaseElement();if(!newDOMElement){return;}var layer=this.layers[pos];if(!layer.ddd||!this.supports3d){if(this.threeDElements){this.addTo3dContainer(newDOMElement,pos);}else {var i=0;var nextDOMElement;var nextLayer;var tmpDOMElement;while(i<pos){if(this.elements[i]&&this.elements[i]!==true&&this.elements[i].getBaseElement){nextLayer=this.elements[i];tmpDOMElement=this.layers[i].ddd?this.getThreeDContainerByPos(i):nextLayer.getBaseElement();nextDOMElement=tmpDOMElement||nextDOMElement;}i+=1;}if(nextDOMElement){if(!layer.ddd||!this.supports3d){this.layerElement.insertBefore(newDOMElement,nextDOMElement);}}else if(!layer.ddd||!this.supports3d){this.layerElement.appendChild(newDOMElement);}}}else {this.addTo3dContainer(newDOMElement,pos);}};HybridRendererBase.prototype.createShape=function(data){if(!this.supports3d){return new SVGShapeElement(data,this.globalData,this);}return new HShapeElement(data,this.globalData,this);};HybridRendererBase.prototype.createText=function(data){if(!this.supports3d){return new SVGTextLottieElement(data,this.globalData,this);}return new HTextElement(data,this.globalData,this);};HybridRendererBase.prototype.createCamera=function(data){this.camera=new HCameraElement(data,this.globalData,this);return this.camera;};HybridRendererBase.prototype.createImage=function(data){if(!this.supports3d){return new IImageElement(data,this.globalData,this);}return new HImageElement(data,this.globalData,this);};HybridRendererBase.prototype.createSolid=function(data){if(!this.supports3d){return new ISolidElement(data,this.globalData,this);}return new HSolidElement(data,this.globalData,this);};HybridRendererBase.prototype.createNull=SVGRenderer.prototype.createNull;HybridRendererBase.prototype.getThreeDContainerByPos=function(pos){var i=0;var len=this.threeDElements.length;while(i<len){if(this.threeDElements[i].startPos<=pos&&this.threeDElements[i].endPos>=pos){return this.threeDElements[i].perspectiveElem;}i+=1;}return null;};HybridRendererBase.prototype.createThreeDContainer=function(pos,type){var perspectiveElem=createTag('div');var style;var containerStyle;styleDiv(perspectiveElem);var container=createTag('div');styleDiv(container);if(type==='3d'){style=perspectiveElem.style;style.width=this.globalData.compSize.w+'px';style.height=this.globalData.compSize.h+'px';var center='50% 50%';style.webkitTransformOrigin=center;style.mozTransformOrigin=center;style.transformOrigin=center;containerStyle=container.style;var matrix='matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';containerStyle.transform=matrix;containerStyle.webkitTransform=matrix;}perspectiveElem.appendChild(container);// this.resizerElem.appendChild(perspectiveElem);
	var threeDContainerData={container:container,perspectiveElem:perspectiveElem,startPos:pos,endPos:pos,type:type};this.threeDElements.push(threeDContainerData);return threeDContainerData;};HybridRendererBase.prototype.build3dContainers=function(){var i;var len=this.layers.length;var lastThreeDContainerData;var currentContainer='';for(i=0;i<len;i+=1){if(this.layers[i].ddd&&this.layers[i].ty!==3){if(currentContainer!=='3d'){currentContainer='3d';lastThreeDContainerData=this.createThreeDContainer(i,'3d');}lastThreeDContainerData.endPos=Math.max(lastThreeDContainerData.endPos,i);}else {if(currentContainer!=='2d'){currentContainer='2d';lastThreeDContainerData=this.createThreeDContainer(i,'2d');}lastThreeDContainerData.endPos=Math.max(lastThreeDContainerData.endPos,i);}}len=this.threeDElements.length;for(i=len-1;i>=0;i-=1){this.resizerElem.appendChild(this.threeDElements[i].perspectiveElem);}};HybridRendererBase.prototype.addTo3dContainer=function(elem,pos){var i=0;var len=this.threeDElements.length;while(i<len){if(pos<=this.threeDElements[i].endPos){var j=this.threeDElements[i].startPos;var nextElement;while(j<pos){if(this.elements[j]&&this.elements[j].getBaseElement){nextElement=this.elements[j].getBaseElement();}j+=1;}if(nextElement){this.threeDElements[i].container.insertBefore(elem,nextElement);}else {this.threeDElements[i].container.appendChild(elem);}break;}i+=1;}};HybridRendererBase.prototype.configAnimation=function(animData){var resizerElem=createTag('div');var wrapper=this.animationItem.wrapper;var style=resizerElem.style;style.width=animData.w+'px';style.height=animData.h+'px';this.resizerElem=resizerElem;styleDiv(resizerElem);style.transformStyle='flat';style.mozTransformStyle='flat';style.webkitTransformStyle='flat';if(this.renderConfig.className){resizerElem.setAttribute('class',this.renderConfig.className);}wrapper.appendChild(resizerElem);style.overflow='hidden';var svg=createNS('svg');svg.setAttribute('width','1');svg.setAttribute('height','1');styleDiv(svg);this.resizerElem.appendChild(svg);var defs=createNS('defs');svg.appendChild(defs);this.data=animData;// Mask animation
	this.setupGlobalData(animData,svg);this.globalData.defs=defs;this.layers=animData.layers;this.layerElement=this.resizerElem;this.build3dContainers();this.updateContainerSize();};HybridRendererBase.prototype.destroy=function(){if(this.animationItem.wrapper){this.animationItem.wrapper.innerText='';}this.animationItem.container=null;this.globalData.defs=null;var i;var len=this.layers?this.layers.length:0;for(i=0;i<len;i+=1){if(this.elements[i]&&this.elements[i].destroy){this.elements[i].destroy();}}this.elements.length=0;this.destroyed=true;this.animationItem=null;};HybridRendererBase.prototype.updateContainerSize=function(){var elementWidth=this.animationItem.wrapper.offsetWidth;var elementHeight=this.animationItem.wrapper.offsetHeight;var elementRel=elementWidth/elementHeight;var animationRel=this.globalData.compSize.w/this.globalData.compSize.h;var sx;var sy;var tx;var ty;if(animationRel>elementRel){sx=elementWidth/this.globalData.compSize.w;sy=elementWidth/this.globalData.compSize.w;tx=0;ty=(elementHeight-this.globalData.compSize.h*(elementWidth/this.globalData.compSize.w))/2;}else {sx=elementHeight/this.globalData.compSize.h;sy=elementHeight/this.globalData.compSize.h;tx=(elementWidth-this.globalData.compSize.w*(elementHeight/this.globalData.compSize.h))/2;ty=0;}var style=this.resizerElem.style;style.webkitTransform='matrix3d('+sx+',0,0,0,0,'+sy+',0,0,0,0,1,0,'+tx+','+ty+',0,1)';style.transform=style.webkitTransform;};HybridRendererBase.prototype.renderFrame=SVGRenderer.prototype.renderFrame;HybridRendererBase.prototype.hide=function(){this.resizerElem.style.display='none';};HybridRendererBase.prototype.show=function(){this.resizerElem.style.display='block';};HybridRendererBase.prototype.initItems=function(){this.buildAllItems();if(this.camera){this.camera.setup();}else {var cWidth=this.globalData.compSize.w;var cHeight=this.globalData.compSize.h;var i;var len=this.threeDElements.length;for(i=0;i<len;i+=1){var style=this.threeDElements[i].perspectiveElem.style;style.webkitPerspective=Math.sqrt(Math.pow(cWidth,2)+Math.pow(cHeight,2))+'px';style.perspective=style.webkitPerspective;}}};HybridRendererBase.prototype.searchExtraCompositions=function(assets){var i;var len=assets.length;var floatingContainer=createTag('div');for(i=0;i<len;i+=1){if(assets[i].xt){var comp=this.createComp(assets[i],floatingContainer,this.globalData.comp,null);comp.initExpressions();this.globalData.projectInterface.registerComposition(comp);}}};function HCompElement(data,globalData,comp){this.layers=data.layers;this.supports3d=!data.hasMask;this.completeLayers=false;this.pendingElements=[];this.elements=this.layers?createSizedArray(this.layers.length):[];this.initElement(data,globalData,comp);this.tm=data.tm?PropertyFactory.getProp(this,data.tm,0,globalData.frameRate,this):{_placeholder:true};}extendPrototype([HybridRendererBase,ICompElement,HBaseElement],HCompElement);HCompElement.prototype._createBaseContainerElements=HCompElement.prototype.createContainerElements;HCompElement.prototype.createContainerElements=function(){this._createBaseContainerElements();// divElement.style.clip = 'rect(0px, '+this.data.w+'px, '+this.data.h+'px, 0px)';
	if(this.data.hasMask){this.svgElement.setAttribute('width',this.data.w);this.svgElement.setAttribute('height',this.data.h);this.transformedElement=this.baseElement;}else {this.transformedElement=this.layerElement;}};HCompElement.prototype.addTo3dContainer=function(elem,pos){var j=0;var nextElement;while(j<pos){if(this.elements[j]&&this.elements[j].getBaseElement){nextElement=this.elements[j].getBaseElement();}j+=1;}if(nextElement){this.layerElement.insertBefore(elem,nextElement);}else {this.layerElement.appendChild(elem);}};HCompElement.prototype.createComp=function(data){if(!this.supports3d){return new SVGCompElement(data,this.globalData,this);}return new HCompElement(data,this.globalData,this);};function HybridRenderer(animationItem,config){this.animationItem=animationItem;this.layers=null;this.renderedFrame=-1;this.renderConfig={className:config&&config.className||'',imagePreserveAspectRatio:config&&config.imagePreserveAspectRatio||'xMidYMid slice',hideOnTransparent:!(config&&config.hideOnTransparent===false),filterSize:{width:config&&config.filterSize&&config.filterSize.width||'400%',height:config&&config.filterSize&&config.filterSize.height||'400%',x:config&&config.filterSize&&config.filterSize.x||'-100%',y:config&&config.filterSize&&config.filterSize.y||'-100%'},runExpressions:!config||config.runExpressions===undefined||config.runExpressions};this.globalData={_mdf:false,frameNum:-1,renderConfig:this.renderConfig};this.pendingElements=[];this.elements=[];this.threeDElements=[];this.destroyed=false;this.camera=null;this.supports3d=true;this.rendererType='html';}extendPrototype([HybridRendererBase],HybridRenderer);HybridRenderer.prototype.createComp=function(data){if(!this.supports3d){return new SVGCompElement(data,this.globalData,this);}return new HCompElement(data,this.globalData,this);};var CompExpressionInterface=function(){return function(comp){function _thisLayerFunction(name){var i=0;var len=comp.layers.length;while(i<len){if(comp.layers[i].nm===name||comp.layers[i].ind===name){return comp.elements[i].layerInterface;}i+=1;}return null;// return {active:false};
	}Object.defineProperty(_thisLayerFunction,'_name',{value:comp.data.nm});_thisLayerFunction.layer=_thisLayerFunction;_thisLayerFunction.pixelAspect=1;_thisLayerFunction.height=comp.data.h||comp.globalData.compSize.h;_thisLayerFunction.width=comp.data.w||comp.globalData.compSize.w;_thisLayerFunction.pixelAspect=1;_thisLayerFunction.frameDuration=1/comp.globalData.frameRate;_thisLayerFunction.displayStartTime=0;_thisLayerFunction.numLayers=comp.layers.length;return _thisLayerFunction;};}();function _typeof$2(obj){"@babel/helpers - typeof";if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){_typeof$2=function _typeof(obj){return typeof obj;};}else {_typeof$2=function _typeof(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};}return _typeof$2(obj);}/* eslint-disable */ /*
	   Copyright 2014 David Bau.

	   Permission is hereby granted, free of charge, to any person obtaining
	   a copy of this software and associated documentation files (the
	   "Software"), to deal in the Software without restriction, including
	   without limitation the rights to use, copy, modify, merge, publish,
	   distribute, sublicense, and/or sell copies of the Software, and to
	   permit persons to whom the Software is furnished to do so, subject to
	   the following conditions:

	   The above copyright notice and this permission notice shall be
	   included in all copies or substantial portions of the Software.

	   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	   EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	   MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	   IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	   CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	   TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	   SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

	   */function seedRandom(pool,math){//
	// The following constants are related to IEEE 754 limits.
	//
	var global=this,width=256,// each RC4 output is 0 <= x < 256
	chunks=6,// at least six RC4 outputs for each double
	digits=52,// there are 52 significant digits in a double
	rngname='random',// rngname: name for Math.random and Math.seedrandom
	startdenom=math.pow(width,chunks),significance=math.pow(2,digits),overflow=significance*2,mask=width-1,nodecrypto;// node.js crypto module, initialized at the bottom.
	//
	// seedrandom()
	// This is the seedrandom function described above.
	//
	function seedrandom(seed,options,callback){var key=[];options=options===true?{entropy:true}:options||{};// Flatten the seed string or build one from local entropy if needed.
	var shortseed=mixkey(flatten(options.entropy?[seed,tostring(pool)]:seed===null?autoseed():seed,3),key);// Use the seed to initialize an ARC4 generator.
	var arc4=new ARC4(key);// This function returns a random double in [0, 1) that contains
	// randomness in every bit of the mantissa of the IEEE 754 value.
	var prng=function prng(){var n=arc4.g(chunks),// Start with a numerator n < 2 ^ 48
	d=startdenom,//   and denominator d = 2 ^ 48.
	x=0;//   and no 'extra last byte'.
	while(n<significance){// Fill up all significant digits by
	n=(n+x)*width;//   shifting numerator and
	d*=width;//   denominator and generating a
	x=arc4.g(1);//   new least-significant-byte.
	}while(n>=overflow){// To avoid rounding up, before adding
	n/=2;//   last byte, shift everything
	d/=2;//   right using integer math until
	x>>>=1;//   we have exactly the desired bits.
	}return (n+x)/d;// Form the number within [0, 1).
	};prng.int32=function(){return arc4.g(4)|0;};prng.quick=function(){return arc4.g(4)/0x100000000;};prng["double"]=prng;// Mix the randomness into accumulated entropy.
	mixkey(tostring(arc4.S),pool);// Calling convention: what to return as a function of prng, seed, is_math.
	return (options.pass||callback||function(prng,seed,is_math_call,state){if(state){// Load the arc4 state from the given state if it has an S array.
	if(state.S){copy(state,arc4);}// Only provide the .state method if requested via options.state.
	prng.state=function(){return copy(arc4,{});};}// If called as a method of Math (Math.seedrandom()), mutate
	// Math.random because that is how seedrandom.js has worked since v1.0.
	if(is_math_call){math[rngname]=prng;return seed;}// Otherwise, it is a newer calling convention, so return the
	// prng directly.
	else return prng;})(prng,shortseed,'global'in options?options.global:this==math,options.state);}math['seed'+rngname]=seedrandom;//
	// ARC4
	//
	// An ARC4 implementation.  The constructor takes a key in the form of
	// an array of at most (width) integers that should be 0 <= x < (width).
	//
	// The g(count) method returns a pseudorandom integer that concatenates
	// the next (count) outputs from ARC4.  Its return value is a number x
	// that is in the range 0 <= x < (width ^ count).
	//
	function ARC4(key){var t,keylen=key.length,me=this,i=0,j=me.i=me.j=0,s=me.S=[];// The empty key [] is treated as [0].
	if(!keylen){key=[keylen++];}// Set up S using the standard key scheduling algorithm.
	while(i<width){s[i]=i++;}for(i=0;i<width;i++){s[i]=s[j=mask&j+key[i%keylen]+(t=s[i])];s[j]=t;}// The "g" method returns the next (count) outputs as one number.
	me.g=function(count){// Using instance members instead of closure state nearly doubles speed.
	var t,r=0,i=me.i,j=me.j,s=me.S;while(count--){t=s[i=mask&i+1];r=r*width+s[mask&(s[i]=s[j=mask&j+t])+(s[j]=t)];}me.i=i;me.j=j;return r;// For robust unpredictability, the function call below automatically
	// discards an initial batch of values.  This is called RC4-drop[256].
	// See http://google.com/search?q=rsa+fluhrer+response&btnI
	};}//
	// copy()
	// Copies internal state of ARC4 to or from a plain object.
	//
	function copy(f,t){t.i=f.i;t.j=f.j;t.S=f.S.slice();return t;}//
	// flatten()
	// Converts an object tree to nested arrays of strings.
	//
	function flatten(obj,depth){var result=[],typ=_typeof$2(obj),prop;if(depth&&typ=='object'){for(prop in obj){try{result.push(flatten(obj[prop],depth-1));}catch(e){}}}return result.length?result:typ=='string'?obj:obj+'\0';}//
	// mixkey()
	// Mixes a string seed into a key that is an array of integers, and
	// returns a shortened string seed that is equivalent to the result key.
	//
	function mixkey(seed,key){var stringseed=seed+'',smear,j=0;while(j<stringseed.length){key[mask&j]=mask&(smear^=key[mask&j]*19)+stringseed.charCodeAt(j++);}return tostring(key);}//
	// autoseed()
	// Returns an object for autoseeding, using window.crypto and Node crypto
	// module if available.
	//
	function autoseed(){try{if(nodecrypto);var out=new Uint8Array(width);(global.crypto||global.msCrypto).getRandomValues(out);return tostring(out);}catch(e){var browser=global.navigator,plugins=browser&&browser.plugins;return [+new Date(),global,plugins,global.screen,tostring(pool)];}}//
	// tostring()
	// Converts an array of charcodes to a string
	//
	function tostring(a){return String.fromCharCode.apply(0,a);}//
	// When seedrandom.js is loaded, we immediately mix a few bits
	// from the built-in RNG into the entropy pool.  Because we do
	// not want to interfere with deterministic PRNG state later,
	// seedrandom will not call math.random on its own again after
	// initialization.
	//
	mixkey(math.random(),pool);//
	// Nodejs and AMD support: export the implementation as a module using
	// either convention.
	//
	// End anonymous scope, and pass initial values.
	}function initialize$2(BMMath){seedRandom([],BMMath);}var propTypes={SHAPE:'shape'};function _typeof$1(obj){"@babel/helpers - typeof";if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){_typeof$1=function _typeof(obj){return typeof obj;};}else {_typeof$1=function _typeof(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};}return _typeof$1(obj);}var ExpressionManager=function(){var ob={};var Math=BMMath;var window=null;var document=null;var XMLHttpRequest=null;var fetch=null;var frames=null;var _lottieGlobal={};initialize$2(BMMath);function resetFrame(){_lottieGlobal={};}function $bm_isInstanceOfArray(arr){return arr.constructor===Array||arr.constructor===Float32Array;}function isNumerable(tOfV,v){return tOfV==='number'||v instanceof Number||tOfV==='boolean'||tOfV==='string';}function $bm_neg(a){var tOfA=_typeof$1(a);if(tOfA==='number'||a instanceof Number||tOfA==='boolean'){return -a;}if($bm_isInstanceOfArray(a)){var i;var lenA=a.length;var retArr=[];for(i=0;i<lenA;i+=1){retArr[i]=-a[i];}return retArr;}if(a.propType){return a.v;}return -a;}var easeInBez=BezierFactory.getBezierEasing(0.333,0,0.833,0.833,'easeIn').get;var easeOutBez=BezierFactory.getBezierEasing(0.167,0.167,0.667,1,'easeOut').get;var easeInOutBez=BezierFactory.getBezierEasing(0.33,0,0.667,1,'easeInOut').get;function sum(a,b){var tOfA=_typeof$1(a);var tOfB=_typeof$1(b);if(isNumerable(tOfA,a)&&isNumerable(tOfB,b)||tOfA==='string'||tOfB==='string'){return a+b;}if($bm_isInstanceOfArray(a)&&isNumerable(tOfB,b)){a=a.slice(0);a[0]+=b;return a;}if(isNumerable(tOfA,a)&&$bm_isInstanceOfArray(b)){b=b.slice(0);b[0]=a+b[0];return b;}if($bm_isInstanceOfArray(a)&&$bm_isInstanceOfArray(b)){var i=0;var lenA=a.length;var lenB=b.length;var retArr=[];while(i<lenA||i<lenB){if((typeof a[i]==='number'||a[i]instanceof Number)&&(typeof b[i]==='number'||b[i]instanceof Number)){retArr[i]=a[i]+b[i];}else {retArr[i]=b[i]===undefined?a[i]:a[i]||b[i];}i+=1;}return retArr;}return 0;}var add=sum;function sub(a,b){var tOfA=_typeof$1(a);var tOfB=_typeof$1(b);if(isNumerable(tOfA,a)&&isNumerable(tOfB,b)){if(tOfA==='string'){a=parseInt(a,10);}if(tOfB==='string'){b=parseInt(b,10);}return a-b;}if($bm_isInstanceOfArray(a)&&isNumerable(tOfB,b)){a=a.slice(0);a[0]-=b;return a;}if(isNumerable(tOfA,a)&&$bm_isInstanceOfArray(b)){b=b.slice(0);b[0]=a-b[0];return b;}if($bm_isInstanceOfArray(a)&&$bm_isInstanceOfArray(b)){var i=0;var lenA=a.length;var lenB=b.length;var retArr=[];while(i<lenA||i<lenB){if((typeof a[i]==='number'||a[i]instanceof Number)&&(typeof b[i]==='number'||b[i]instanceof Number)){retArr[i]=a[i]-b[i];}else {retArr[i]=b[i]===undefined?a[i]:a[i]||b[i];}i+=1;}return retArr;}return 0;}function mul(a,b){var tOfA=_typeof$1(a);var tOfB=_typeof$1(b);var arr;if(isNumerable(tOfA,a)&&isNumerable(tOfB,b)){return a*b;}var i;var len;if($bm_isInstanceOfArray(a)&&isNumerable(tOfB,b)){len=a.length;arr=createTypedArray('float32',len);for(i=0;i<len;i+=1){arr[i]=a[i]*b;}return arr;}if(isNumerable(tOfA,a)&&$bm_isInstanceOfArray(b)){len=b.length;arr=createTypedArray('float32',len);for(i=0;i<len;i+=1){arr[i]=a*b[i];}return arr;}return 0;}function div(a,b){var tOfA=_typeof$1(a);var tOfB=_typeof$1(b);var arr;if(isNumerable(tOfA,a)&&isNumerable(tOfB,b)){return a/b;}var i;var len;if($bm_isInstanceOfArray(a)&&isNumerable(tOfB,b)){len=a.length;arr=createTypedArray('float32',len);for(i=0;i<len;i+=1){arr[i]=a[i]/b;}return arr;}if(isNumerable(tOfA,a)&&$bm_isInstanceOfArray(b)){len=b.length;arr=createTypedArray('float32',len);for(i=0;i<len;i+=1){arr[i]=a/b[i];}return arr;}return 0;}function mod(a,b){if(typeof a==='string'){a=parseInt(a,10);}if(typeof b==='string'){b=parseInt(b,10);}return a%b;}var $bm_sum=sum;var $bm_sub=sub;var $bm_mul=mul;var $bm_div=div;var $bm_mod=mod;function clamp(num,min,max){if(min>max){var mm=max;max=min;min=mm;}return Math.min(Math.max(num,min),max);}function radiansToDegrees(val){return val/degToRads;}var radians_to_degrees=radiansToDegrees;function degreesToRadians(val){return val*degToRads;}var degrees_to_radians=radiansToDegrees;var helperLengthArray=[0,0,0,0,0,0];function length(arr1,arr2){if(typeof arr1==='number'||arr1 instanceof Number){arr2=arr2||0;return Math.abs(arr1-arr2);}if(!arr2){arr2=helperLengthArray;}var i;var len=Math.min(arr1.length,arr2.length);var addedLength=0;for(i=0;i<len;i+=1){addedLength+=Math.pow(arr2[i]-arr1[i],2);}return Math.sqrt(addedLength);}function normalize(vec){return div(vec,length(vec));}function rgbToHsl(val){var r=val[0];var g=val[1];var b=val[2];var max=Math.max(r,g,b);var min=Math.min(r,g,b);var h;var s;var l=(max+min)/2;if(max===min){h=0;// achromatic
	s=0;// achromatic
	}else {var d=max-min;s=l>0.5?d/(2-max-min):d/(max+min);switch(max){case r:h=(g-b)/d+(g<b?6:0);break;case g:h=(b-r)/d+2;break;case b:h=(r-g)/d+4;break;}h/=6;}return [h,s,l,val[3]];}function hue2rgb(p,q,t){if(t<0)t+=1;if(t>1)t-=1;if(t<1/6)return p+(q-p)*6*t;if(t<1/2)return q;if(t<2/3)return p+(q-p)*(2/3-t)*6;return p;}function hslToRgb(val){var h=val[0];var s=val[1];var l=val[2];var r;var g;var b;if(s===0){r=l;// achromatic
	b=l;// achromatic
	g=l;// achromatic
	}else {var q=l<0.5?l*(1+s):l+s-l*s;var p=2*l-q;r=hue2rgb(p,q,h+1/3);g=hue2rgb(p,q,h);b=hue2rgb(p,q,h-1/3);}return [r,g,b,val[3]];}function linear(t,tMin,tMax,value1,value2){if(value1===undefined||value2===undefined){value1=tMin;value2=tMax;tMin=0;tMax=1;}if(tMax<tMin){var _tMin=tMax;tMax=tMin;tMin=_tMin;}if(t<=tMin){return value1;}if(t>=tMax){return value2;}var perc=tMax===tMin?0:(t-tMin)/(tMax-tMin);if(!value1.length){return value1+(value2-value1)*perc;}var i;var len=value1.length;var arr=createTypedArray('float32',len);for(i=0;i<len;i+=1){arr[i]=value1[i]+(value2[i]-value1[i])*perc;}return arr;}function random(min,max){if(max===undefined){if(min===undefined){min=0;max=1;}else {max=min;min=undefined;}}if(max.length){var i;var len=max.length;if(!min){min=createTypedArray('float32',len);}var arr=createTypedArray('float32',len);var rnd=BMMath.random();for(i=0;i<len;i+=1){arr[i]=min[i]+rnd*(max[i]-min[i]);}return arr;}if(min===undefined){min=0;}var rndm=BMMath.random();return min+rndm*(max-min);}function createPath(points,inTangents,outTangents,closed){var i;var len=points.length;var path=shapePool.newElement();path.setPathData(!!closed,len);var arrPlaceholder=[0,0];var inVertexPoint;var outVertexPoint;for(i=0;i<len;i+=1){inVertexPoint=inTangents&&inTangents[i]?inTangents[i]:arrPlaceholder;outVertexPoint=outTangents&&outTangents[i]?outTangents[i]:arrPlaceholder;path.setTripleAt(points[i][0],points[i][1],outVertexPoint[0]+points[i][0],outVertexPoint[1]+points[i][1],inVertexPoint[0]+points[i][0],inVertexPoint[1]+points[i][1],i,true);}return path;}function initiateExpression(elem,data,property){// Bail out if we don't want expressions
	function noOp(_value){return _value;}if(!elem.globalData.renderConfig.runExpressions){return noOp;}var val=data.x;var needsVelocity=/velocity(?![\w\d])/.test(val);var _needsRandom=val.indexOf('random')!==-1;var elemType=elem.data.ty;var transform;var $bm_transform;var content;var effect;var thisProperty=property;thisProperty.valueAtTime=thisProperty.getValueAtTime;Object.defineProperty(thisProperty,'value',{get:function get(){return thisProperty.v;}});elem.comp.frameDuration=1/elem.comp.globalData.frameRate;elem.comp.displayStartTime=0;var inPoint=elem.data.ip/elem.comp.globalData.frameRate;var outPoint=elem.data.op/elem.comp.globalData.frameRate;var width=elem.data.sw?elem.data.sw:0;var height=elem.data.sh?elem.data.sh:0;var name=elem.data.nm;var loopIn;var loop_in;var loopOut;var loop_out;var smooth;var toWorld;var fromWorld;var fromComp;var toComp;var fromCompToSurface;var position;var rotation;var anchorPoint;var scale;var thisLayer;var thisComp;var mask;var valueAtTime;var velocityAtTime;var scoped_bm_rt;// val = val.replace(/(\\?"|')((http)(s)?(:\/))?\/.*?(\\?"|')/g, "\"\""); // deter potential network calls
	var expression_function=eval('[function _expression_function(){'+val+';scoped_bm_rt=$bm_rt}]')[0];// eslint-disable-line no-eval
	var numKeys=property.kf?data.k.length:0;var active=!this.data||this.data.hd!==true;var wiggle=function wiggle(freq,amp){var iWiggle;var j;var lenWiggle=this.pv.length?this.pv.length:1;var addedAmps=createTypedArray('float32',lenWiggle);freq=5;var iterations=Math.floor(time*freq);iWiggle=0;j=0;while(iWiggle<iterations){// var rnd = BMMath.random();
	for(j=0;j<lenWiggle;j+=1){addedAmps[j]+=-amp+amp*2*BMMath.random();// addedAmps[j] += -amp + amp*2*rnd;
	}iWiggle+=1;}// var rnd2 = BMMath.random();
	var periods=time*freq;var perc=periods-Math.floor(periods);var arr=createTypedArray('float32',lenWiggle);if(lenWiggle>1){for(j=0;j<lenWiggle;j+=1){arr[j]=this.pv[j]+addedAmps[j]+(-amp+amp*2*BMMath.random())*perc;// arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp*2*rnd)*perc;
	// arr[i] = this.pv[i] + addedAmp + amp1*perc + amp2*(1-perc);
	}return arr;}return this.pv+addedAmps[0]+(-amp+amp*2*BMMath.random())*perc;}.bind(this);if(thisProperty.loopIn){loopIn=thisProperty.loopIn.bind(thisProperty);loop_in=loopIn;}if(thisProperty.loopOut){loopOut=thisProperty.loopOut.bind(thisProperty);loop_out=loopOut;}if(thisProperty.smooth){smooth=thisProperty.smooth.bind(thisProperty);}function loopInDuration(type,duration){return loopIn(type,duration,true);}function loopOutDuration(type,duration){return loopOut(type,duration,true);}if(this.getValueAtTime){valueAtTime=this.getValueAtTime.bind(this);}if(this.getVelocityAtTime){velocityAtTime=this.getVelocityAtTime.bind(this);}var comp=elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface);function lookAt(elem1,elem2){var fVec=[elem2[0]-elem1[0],elem2[1]-elem1[1],elem2[2]-elem1[2]];var pitch=Math.atan2(fVec[0],Math.sqrt(fVec[1]*fVec[1]+fVec[2]*fVec[2]))/degToRads;var yaw=-Math.atan2(fVec[1],fVec[2])/degToRads;return [yaw,pitch,0];}function easeOut(t,tMin,tMax,val1,val2){return applyEase(easeOutBez,t,tMin,tMax,val1,val2);}function easeIn(t,tMin,tMax,val1,val2){return applyEase(easeInBez,t,tMin,tMax,val1,val2);}function ease(t,tMin,tMax,val1,val2){return applyEase(easeInOutBez,t,tMin,tMax,val1,val2);}function applyEase(fn,t,tMin,tMax,val1,val2){if(val1===undefined){val1=tMin;val2=tMax;}else {t=(t-tMin)/(tMax-tMin);}if(t>1){t=1;}else if(t<0){t=0;}var mult=fn(t);if($bm_isInstanceOfArray(val1)){var iKey;var lenKey=val1.length;var arr=createTypedArray('float32',lenKey);for(iKey=0;iKey<lenKey;iKey+=1){arr[iKey]=(val2[iKey]-val1[iKey])*mult+val1[iKey];}return arr;}return (val2-val1)*mult+val1;}function nearestKey(time){var iKey;var lenKey=data.k.length;var index;var keyTime;if(!data.k.length||typeof data.k[0]==='number'){index=0;keyTime=0;}else {index=-1;time*=elem.comp.globalData.frameRate;if(time<data.k[0].t){index=1;keyTime=data.k[0].t;}else {for(iKey=0;iKey<lenKey-1;iKey+=1){if(time===data.k[iKey].t){index=iKey+1;keyTime=data.k[iKey].t;break;}else if(time>data.k[iKey].t&&time<data.k[iKey+1].t){if(time-data.k[iKey].t>data.k[iKey+1].t-time){index=iKey+2;keyTime=data.k[iKey+1].t;}else {index=iKey+1;keyTime=data.k[iKey].t;}break;}}if(index===-1){index=iKey+1;keyTime=data.k[iKey].t;}}}var obKey={};obKey.index=index;obKey.time=keyTime/elem.comp.globalData.frameRate;return obKey;}function key(ind){var obKey;var iKey;var lenKey;if(!data.k.length||typeof data.k[0]==='number'){throw new Error('The property has no keyframe at index '+ind);}ind-=1;obKey={time:data.k[ind].t/elem.comp.globalData.frameRate,value:[]};var arr=Object.prototype.hasOwnProperty.call(data.k[ind],'s')?data.k[ind].s:data.k[ind-1].e;lenKey=arr.length;for(iKey=0;iKey<lenKey;iKey+=1){obKey[iKey]=arr[iKey];obKey.value[iKey]=arr[iKey];}return obKey;}function framesToTime(fr,fps){if(!fps){fps=elem.comp.globalData.frameRate;}return fr/fps;}function timeToFrames(t,fps){if(!t&&t!==0){t=time;}if(!fps){fps=elem.comp.globalData.frameRate;}return t*fps;}function seedRandom(seed){BMMath.seedrandom(randSeed+seed);}function sourceRectAtTime(){return elem.sourceRectAtTime();}function substring(init,end){if(typeof value==='string'){if(end===undefined){return value.substring(init);}return value.substring(init,end);}return '';}function substr(init,end){if(typeof value==='string'){if(end===undefined){return value.substr(init);}return value.substr(init,end);}return '';}function posterizeTime(framesPerSecond){time=framesPerSecond===0?0:Math.floor(time*framesPerSecond)/framesPerSecond;value=valueAtTime(time);}var time;var velocity;var value;var text;var textIndex;var textTotal;var selectorValue;var index=elem.data.ind;var hasParent=!!(elem.hierarchy&&elem.hierarchy.length);var parent;var randSeed=Math.floor(Math.random()*1000000);var globalData=elem.globalData;function executeExpression(_value){// globalData.pushExpression();
	value=_value;if(this.frameExpressionId===elem.globalData.frameId&&this.propType!=='textSelector'){return value;}if(this.propType==='textSelector'){textIndex=this.textIndex;textTotal=this.textTotal;selectorValue=this.selectorValue;}if(!thisLayer){text=elem.layerInterface.text;thisLayer=elem.layerInterface;thisComp=elem.comp.compInterface;toWorld=thisLayer.toWorld.bind(thisLayer);fromWorld=thisLayer.fromWorld.bind(thisLayer);fromComp=thisLayer.fromComp.bind(thisLayer);toComp=thisLayer.toComp.bind(thisLayer);mask=thisLayer.mask?thisLayer.mask.bind(thisLayer):null;fromCompToSurface=fromComp;}if(!transform){transform=elem.layerInterface('ADBE Transform Group');$bm_transform=transform;if(transform){anchorPoint=transform.anchorPoint;/* position = transform.position;
	                      rotation = transform.rotation;
	                      scale = transform.scale; */}}if(elemType===4&&!content){content=thisLayer('ADBE Root Vectors Group');}if(!effect){effect=thisLayer(4);}hasParent=!!(elem.hierarchy&&elem.hierarchy.length);if(hasParent&&!parent){parent=elem.hierarchy[0].layerInterface;}time=this.comp.renderedFrame/this.comp.globalData.frameRate;if(_needsRandom){seedRandom(randSeed+time);}if(needsVelocity){velocity=velocityAtTime(time);}expression_function();this.frameExpressionId=elem.globalData.frameId;// TODO: Check if it's possible to return on ShapeInterface the .v value
	// Changed this to a ternary operation because Rollup failed compiling it correctly
	scoped_bm_rt=scoped_bm_rt.propType===propTypes.SHAPE?scoped_bm_rt.v:scoped_bm_rt;return scoped_bm_rt;}// Bundlers will see these as dead code and unless we reference them
	executeExpression.__preventDeadCodeRemoval=[$bm_transform,anchorPoint,time,velocity,inPoint,outPoint,width,height,name,loop_in,loop_out,smooth,toComp,fromCompToSurface,toWorld,fromWorld,mask,position,rotation,scale,thisComp,numKeys,active,wiggle,loopInDuration,loopOutDuration,comp,lookAt,easeOut,easeIn,ease,nearestKey,key,text,textIndex,textTotal,selectorValue,framesToTime,timeToFrames,sourceRectAtTime,substring,substr,posterizeTime,index,globalData];return executeExpression;}ob.initiateExpression=initiateExpression;ob.__preventDeadCodeRemoval=[window,document,XMLHttpRequest,fetch,frames,$bm_neg,add,$bm_sum,$bm_sub,$bm_mul,$bm_div,$bm_mod,clamp,radians_to_degrees,degreesToRadians,degrees_to_radians,normalize,rgbToHsl,hslToRgb,linear,random,createPath,_lottieGlobal];ob.resetFrame=resetFrame;return ob;}();var Expressions=function(){var ob={};ob.initExpressions=initExpressions;ob.resetFrame=ExpressionManager.resetFrame;function initExpressions(animation){var stackCount=0;var registers=[];function pushExpression(){stackCount+=1;}function popExpression(){stackCount-=1;if(stackCount===0){releaseInstances();}}function registerExpressionProperty(expression){if(registers.indexOf(expression)===-1){registers.push(expression);}}function releaseInstances(){var i;var len=registers.length;for(i=0;i<len;i+=1){registers[i].release();}registers.length=0;}animation.renderer.compInterface=CompExpressionInterface(animation.renderer);animation.renderer.globalData.projectInterface.registerComposition(animation.renderer);animation.renderer.globalData.pushExpression=pushExpression;animation.renderer.globalData.popExpression=popExpression;animation.renderer.globalData.registerExpressionProperty=registerExpressionProperty;}return ob;}();var MaskManagerInterface=function(){function MaskInterface(mask,data){this._mask=mask;this._data=data;}Object.defineProperty(MaskInterface.prototype,'maskPath',{get:function get(){if(this._mask.prop.k){this._mask.prop.getValue();}return this._mask.prop;}});Object.defineProperty(MaskInterface.prototype,'maskOpacity',{get:function get(){if(this._mask.op.k){this._mask.op.getValue();}return this._mask.op.v*100;}});var MaskManager=function MaskManager(maskManager){var _masksInterfaces=createSizedArray(maskManager.viewData.length);var i;var len=maskManager.viewData.length;for(i=0;i<len;i+=1){_masksInterfaces[i]=new MaskInterface(maskManager.viewData[i],maskManager.masksProperties[i]);}var maskFunction=function maskFunction(name){i=0;while(i<len){if(maskManager.masksProperties[i].nm===name){return _masksInterfaces[i];}i+=1;}return null;};return maskFunction;};return MaskManager;}();var ExpressionPropertyInterface=function(){var defaultUnidimensionalValue={pv:0,v:0,mult:1};var defaultMultidimensionalValue={pv:[0,0,0],v:[0,0,0],mult:1};function completeProperty(expressionValue,property,type){Object.defineProperty(expressionValue,'velocity',{get:function get(){return property.getVelocityAtTime(property.comp.currentFrame);}});expressionValue.numKeys=property.keyframes?property.keyframes.length:0;expressionValue.key=function(pos){if(!expressionValue.numKeys){return 0;}var value='';if('s'in property.keyframes[pos-1]){value=property.keyframes[pos-1].s;}else if('e'in property.keyframes[pos-2]){value=property.keyframes[pos-2].e;}else {value=property.keyframes[pos-2].s;}var valueProp=type==='unidimensional'?new Number(value):Object.assign({},value);// eslint-disable-line no-new-wrappers
	valueProp.time=property.keyframes[pos-1].t/property.elem.comp.globalData.frameRate;valueProp.value=type==='unidimensional'?value[0]:value;return valueProp;};expressionValue.valueAtTime=property.getValueAtTime;expressionValue.speedAtTime=property.getSpeedAtTime;expressionValue.velocityAtTime=property.getVelocityAtTime;expressionValue.propertyGroup=property.propertyGroup;}function UnidimensionalPropertyInterface(property){if(!property||!('pv'in property)){property=defaultUnidimensionalValue;}var mult=1/property.mult;var val=property.pv*mult;var expressionValue=new Number(val);// eslint-disable-line no-new-wrappers
	expressionValue.value=val;completeProperty(expressionValue,property,'unidimensional');return function(){if(property.k){property.getValue();}val=property.v*mult;if(expressionValue.value!==val){expressionValue=new Number(val);// eslint-disable-line no-new-wrappers
	expressionValue.value=val;completeProperty(expressionValue,property,'unidimensional');}return expressionValue;};}function MultidimensionalPropertyInterface(property){if(!property||!('pv'in property)){property=defaultMultidimensionalValue;}var mult=1/property.mult;var len=property.data&&property.data.l||property.pv.length;var expressionValue=createTypedArray('float32',len);var arrValue=createTypedArray('float32',len);expressionValue.value=arrValue;completeProperty(expressionValue,property,'multidimensional');return function(){if(property.k){property.getValue();}for(var i=0;i<len;i+=1){arrValue[i]=property.v[i]*mult;expressionValue[i]=arrValue[i];}return expressionValue;};}// TODO: try to avoid using this getter
	function defaultGetter(){return defaultUnidimensionalValue;}return function(property){if(!property){return defaultGetter;}if(property.propType==='unidimensional'){return UnidimensionalPropertyInterface(property);}return MultidimensionalPropertyInterface(property);};}();var TransformExpressionInterface=function(){return function(transform){function _thisFunction(name){switch(name){case'scale':case'Scale':case'ADBE Scale':case 6:return _thisFunction.scale;case'rotation':case'Rotation':case'ADBE Rotation':case'ADBE Rotate Z':case 10:return _thisFunction.rotation;case'ADBE Rotate X':return _thisFunction.xRotation;case'ADBE Rotate Y':return _thisFunction.yRotation;case'position':case'Position':case'ADBE Position':case 2:return _thisFunction.position;case'ADBE Position_0':return _thisFunction.xPosition;case'ADBE Position_1':return _thisFunction.yPosition;case'ADBE Position_2':return _thisFunction.zPosition;case'anchorPoint':case'AnchorPoint':case'Anchor Point':case'ADBE AnchorPoint':case 1:return _thisFunction.anchorPoint;case'opacity':case'Opacity':case 11:return _thisFunction.opacity;default:return null;}}Object.defineProperty(_thisFunction,'rotation',{get:ExpressionPropertyInterface(transform.r||transform.rz)});Object.defineProperty(_thisFunction,'zRotation',{get:ExpressionPropertyInterface(transform.rz||transform.r)});Object.defineProperty(_thisFunction,'xRotation',{get:ExpressionPropertyInterface(transform.rx)});Object.defineProperty(_thisFunction,'yRotation',{get:ExpressionPropertyInterface(transform.ry)});Object.defineProperty(_thisFunction,'scale',{get:ExpressionPropertyInterface(transform.s)});var _px;var _py;var _pz;var _transformFactory;if(transform.p){_transformFactory=ExpressionPropertyInterface(transform.p);}else {_px=ExpressionPropertyInterface(transform.px);_py=ExpressionPropertyInterface(transform.py);if(transform.pz){_pz=ExpressionPropertyInterface(transform.pz);}}Object.defineProperty(_thisFunction,'position',{get:function get(){if(transform.p){return _transformFactory();}return [_px(),_py(),_pz?_pz():0];}});Object.defineProperty(_thisFunction,'xPosition',{get:ExpressionPropertyInterface(transform.px)});Object.defineProperty(_thisFunction,'yPosition',{get:ExpressionPropertyInterface(transform.py)});Object.defineProperty(_thisFunction,'zPosition',{get:ExpressionPropertyInterface(transform.pz)});Object.defineProperty(_thisFunction,'anchorPoint',{get:ExpressionPropertyInterface(transform.a)});Object.defineProperty(_thisFunction,'opacity',{get:ExpressionPropertyInterface(transform.o)});Object.defineProperty(_thisFunction,'skew',{get:ExpressionPropertyInterface(transform.sk)});Object.defineProperty(_thisFunction,'skewAxis',{get:ExpressionPropertyInterface(transform.sa)});Object.defineProperty(_thisFunction,'orientation',{get:ExpressionPropertyInterface(transform.or)});return _thisFunction;};}();var LayerExpressionInterface=function(){function getMatrix(time){var toWorldMat=new Matrix();if(time!==undefined){var propMatrix=this._elem.finalTransform.mProp.getValueAtTime(time);propMatrix.clone(toWorldMat);}else {var transformMat=this._elem.finalTransform.mProp;transformMat.applyToMatrix(toWorldMat);}return toWorldMat;}function toWorldVec(arr,time){var toWorldMat=this.getMatrix(time);toWorldMat.props[12]=0;toWorldMat.props[13]=0;toWorldMat.props[14]=0;return this.applyPoint(toWorldMat,arr);}function toWorld(arr,time){var toWorldMat=this.getMatrix(time);return this.applyPoint(toWorldMat,arr);}function fromWorldVec(arr,time){var toWorldMat=this.getMatrix(time);toWorldMat.props[12]=0;toWorldMat.props[13]=0;toWorldMat.props[14]=0;return this.invertPoint(toWorldMat,arr);}function fromWorld(arr,time){var toWorldMat=this.getMatrix(time);return this.invertPoint(toWorldMat,arr);}function applyPoint(matrix,arr){if(this._elem.hierarchy&&this._elem.hierarchy.length){var i;var len=this._elem.hierarchy.length;for(i=0;i<len;i+=1){this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(matrix);}}return matrix.applyToPointArray(arr[0],arr[1],arr[2]||0);}function invertPoint(matrix,arr){if(this._elem.hierarchy&&this._elem.hierarchy.length){var i;var len=this._elem.hierarchy.length;for(i=0;i<len;i+=1){this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(matrix);}}return matrix.inversePoint(arr);}function fromComp(arr){var toWorldMat=new Matrix();toWorldMat.reset();this._elem.finalTransform.mProp.applyToMatrix(toWorldMat);if(this._elem.hierarchy&&this._elem.hierarchy.length){var i;var len=this._elem.hierarchy.length;for(i=0;i<len;i+=1){this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(toWorldMat);}return toWorldMat.inversePoint(arr);}return toWorldMat.inversePoint(arr);}function sampleImage(){return [1,1,1,1];}return function(elem){var transformInterface;function _registerMaskInterface(maskManager){_thisLayerFunction.mask=new MaskManagerInterface(maskManager,elem);}function _registerEffectsInterface(effects){_thisLayerFunction.effect=effects;}function _thisLayerFunction(name){switch(name){case'ADBE Root Vectors Group':case'Contents':case 2:return _thisLayerFunction.shapeInterface;case 1:case 6:case'Transform':case'transform':case'ADBE Transform Group':return transformInterface;case 4:case'ADBE Effect Parade':case'effects':case'Effects':return _thisLayerFunction.effect;case'ADBE Text Properties':return _thisLayerFunction.textInterface;default:return null;}}_thisLayerFunction.getMatrix=getMatrix;_thisLayerFunction.invertPoint=invertPoint;_thisLayerFunction.applyPoint=applyPoint;_thisLayerFunction.toWorld=toWorld;_thisLayerFunction.toWorldVec=toWorldVec;_thisLayerFunction.fromWorld=fromWorld;_thisLayerFunction.fromWorldVec=fromWorldVec;_thisLayerFunction.toComp=toWorld;_thisLayerFunction.fromComp=fromComp;_thisLayerFunction.sampleImage=sampleImage;_thisLayerFunction.sourceRectAtTime=elem.sourceRectAtTime.bind(elem);_thisLayerFunction._elem=elem;transformInterface=TransformExpressionInterface(elem.finalTransform.mProp);var anchorPointDescriptor=getDescriptor(transformInterface,'anchorPoint');Object.defineProperties(_thisLayerFunction,{hasParent:{get:function get(){return elem.hierarchy.length;}},parent:{get:function get(){return elem.hierarchy[0].layerInterface;}},rotation:getDescriptor(transformInterface,'rotation'),scale:getDescriptor(transformInterface,'scale'),position:getDescriptor(transformInterface,'position'),opacity:getDescriptor(transformInterface,'opacity'),anchorPoint:anchorPointDescriptor,anchor_point:anchorPointDescriptor,transform:{get:function get(){return transformInterface;}},active:{get:function get(){return elem.isInRange;}}});_thisLayerFunction.startTime=elem.data.st;_thisLayerFunction.index=elem.data.ind;_thisLayerFunction.source=elem.data.refId;_thisLayerFunction.height=elem.data.ty===0?elem.data.h:100;_thisLayerFunction.width=elem.data.ty===0?elem.data.w:100;_thisLayerFunction.inPoint=elem.data.ip/elem.comp.globalData.frameRate;_thisLayerFunction.outPoint=elem.data.op/elem.comp.globalData.frameRate;_thisLayerFunction._name=elem.data.nm;_thisLayerFunction.registerMaskInterface=_registerMaskInterface;_thisLayerFunction.registerEffectsInterface=_registerEffectsInterface;return _thisLayerFunction;};}();var propertyGroupFactory=function(){return function(interfaceFunction,parentPropertyGroup){return function(val){val=val===undefined?1:val;if(val<=0){return interfaceFunction;}return parentPropertyGroup(val-1);};};}();var PropertyInterface=function(){return function(propertyName,propertyGroup){var interfaceFunction={_name:propertyName};function _propertyGroup(val){val=val===undefined?1:val;if(val<=0){return interfaceFunction;}return propertyGroup(val-1);}return _propertyGroup;};}();var EffectsExpressionInterface=function(){var ob={createEffectsInterface:createEffectsInterface};function createEffectsInterface(elem,propertyGroup){if(elem.effectsManager){var effectElements=[];var effectsData=elem.data.ef;var i;var len=elem.effectsManager.effectElements.length;for(i=0;i<len;i+=1){effectElements.push(createGroupInterface(effectsData[i],elem.effectsManager.effectElements[i],propertyGroup,elem));}var effects=elem.data.ef||[];var groupInterface=function groupInterface(name){i=0;len=effects.length;while(i<len){if(name===effects[i].nm||name===effects[i].mn||name===effects[i].ix){return effectElements[i];}i+=1;}return null;};Object.defineProperty(groupInterface,'numProperties',{get:function get(){return effects.length;}});return groupInterface;}return null;}function createGroupInterface(data,elements,propertyGroup,elem){function groupInterface(name){var effects=data.ef;var i=0;var len=effects.length;while(i<len){if(name===effects[i].nm||name===effects[i].mn||name===effects[i].ix){if(effects[i].ty===5){return effectElements[i];}return effectElements[i]();}i+=1;}throw new Error();}var _propertyGroup=propertyGroupFactory(groupInterface,propertyGroup);var effectElements=[];var i;var len=data.ef.length;for(i=0;i<len;i+=1){if(data.ef[i].ty===5){effectElements.push(createGroupInterface(data.ef[i],elements.effectElements[i],elements.effectElements[i].propertyGroup,elem));}else {effectElements.push(createValueInterface(elements.effectElements[i],data.ef[i].ty,elem,_propertyGroup));}}if(data.mn==='ADBE Color Control'){Object.defineProperty(groupInterface,'color',{get:function get(){return effectElements[0]();}});}Object.defineProperties(groupInterface,{numProperties:{get:function get(){return data.np;}},_name:{value:data.nm},propertyGroup:{value:_propertyGroup}});groupInterface.enabled=data.en!==0;groupInterface.active=groupInterface.enabled;return groupInterface;}function createValueInterface(element,type,elem,propertyGroup){var expressionProperty=ExpressionPropertyInterface(element.p);function interfaceFunction(){if(type===10){return elem.comp.compInterface(element.p.v);}return expressionProperty();}if(element.p.setGroupProperty){element.p.setGroupProperty(PropertyInterface('',propertyGroup));}return interfaceFunction;}return ob;}();var ShapePathInterface=function(){return function pathInterfaceFactory(shape,view,propertyGroup){var prop=view.sh;function interfaceFunction(val){if(val==='Shape'||val==='shape'||val==='Path'||val==='path'||val==='ADBE Vector Shape'||val===2){return interfaceFunction.path;}return null;}var _propertyGroup=propertyGroupFactory(interfaceFunction,propertyGroup);prop.setGroupProperty(PropertyInterface('Path',_propertyGroup));Object.defineProperties(interfaceFunction,{path:{get:function get(){if(prop.k){prop.getValue();}return prop;}},shape:{get:function get(){if(prop.k){prop.getValue();}return prop;}},_name:{value:shape.nm},ix:{value:shape.ix},propertyIndex:{value:shape.ix},mn:{value:shape.mn},propertyGroup:{value:propertyGroup}});return interfaceFunction;};}();var ShapeExpressionInterface=function(){function iterateElements(shapes,view,propertyGroup){var arr=[];var i;var len=shapes?shapes.length:0;for(i=0;i<len;i+=1){if(shapes[i].ty==='gr'){arr.push(groupInterfaceFactory(shapes[i],view[i],propertyGroup));}else if(shapes[i].ty==='fl'){arr.push(fillInterfaceFactory(shapes[i],view[i],propertyGroup));}else if(shapes[i].ty==='st'){arr.push(strokeInterfaceFactory(shapes[i],view[i],propertyGroup));}else if(shapes[i].ty==='tm'){arr.push(trimInterfaceFactory(shapes[i],view[i],propertyGroup));}else if(shapes[i].ty==='tr');else if(shapes[i].ty==='el'){arr.push(ellipseInterfaceFactory(shapes[i],view[i],propertyGroup));}else if(shapes[i].ty==='sr'){arr.push(starInterfaceFactory(shapes[i],view[i],propertyGroup));}else if(shapes[i].ty==='sh'){arr.push(ShapePathInterface(shapes[i],view[i],propertyGroup));}else if(shapes[i].ty==='rc'){arr.push(rectInterfaceFactory(shapes[i],view[i],propertyGroup));}else if(shapes[i].ty==='rd'){arr.push(roundedInterfaceFactory(shapes[i],view[i],propertyGroup));}else if(shapes[i].ty==='rp'){arr.push(repeaterInterfaceFactory(shapes[i],view[i],propertyGroup));}else if(shapes[i].ty==='gf'){arr.push(gradientFillInterfaceFactory(shapes[i],view[i],propertyGroup));}else {arr.push(defaultInterfaceFactory(shapes[i],view[i]));}}return arr;}function contentsInterfaceFactory(shape,view,propertyGroup){var interfaces;var interfaceFunction=function _interfaceFunction(value){var i=0;var len=interfaces.length;while(i<len){if(interfaces[i]._name===value||interfaces[i].mn===value||interfaces[i].propertyIndex===value||interfaces[i].ix===value||interfaces[i].ind===value){return interfaces[i];}i+=1;}if(typeof value==='number'){return interfaces[value-1];}return null;};interfaceFunction.propertyGroup=propertyGroupFactory(interfaceFunction,propertyGroup);interfaces=iterateElements(shape.it,view.it,interfaceFunction.propertyGroup);interfaceFunction.numProperties=interfaces.length;var transformInterface=transformInterfaceFactory(shape.it[shape.it.length-1],view.it[view.it.length-1],interfaceFunction.propertyGroup);interfaceFunction.transform=transformInterface;interfaceFunction.propertyIndex=shape.cix;interfaceFunction._name=shape.nm;return interfaceFunction;}function groupInterfaceFactory(shape,view,propertyGroup){var interfaceFunction=function _interfaceFunction(value){switch(value){case'ADBE Vectors Group':case'Contents':case 2:return interfaceFunction.content;// Not necessary for now. Keeping them here in case a new case appears
	// case 'ADBE Vector Transform Group':
	// case 3:
	default:return interfaceFunction.transform;}};interfaceFunction.propertyGroup=propertyGroupFactory(interfaceFunction,propertyGroup);var content=contentsInterfaceFactory(shape,view,interfaceFunction.propertyGroup);var transformInterface=transformInterfaceFactory(shape.it[shape.it.length-1],view.it[view.it.length-1],interfaceFunction.propertyGroup);interfaceFunction.content=content;interfaceFunction.transform=transformInterface;Object.defineProperty(interfaceFunction,'_name',{get:function get(){return shape.nm;}});// interfaceFunction.content = interfaceFunction;
	interfaceFunction.numProperties=shape.np;interfaceFunction.propertyIndex=shape.ix;interfaceFunction.nm=shape.nm;interfaceFunction.mn=shape.mn;return interfaceFunction;}function fillInterfaceFactory(shape,view,propertyGroup){function interfaceFunction(val){if(val==='Color'||val==='color'){return interfaceFunction.color;}if(val==='Opacity'||val==='opacity'){return interfaceFunction.opacity;}return null;}Object.defineProperties(interfaceFunction,{color:{get:ExpressionPropertyInterface(view.c)},opacity:{get:ExpressionPropertyInterface(view.o)},_name:{value:shape.nm},mn:{value:shape.mn}});view.c.setGroupProperty(PropertyInterface('Color',propertyGroup));view.o.setGroupProperty(PropertyInterface('Opacity',propertyGroup));return interfaceFunction;}function gradientFillInterfaceFactory(shape,view,propertyGroup){function interfaceFunction(val){if(val==='Start Point'||val==='start point'){return interfaceFunction.startPoint;}if(val==='End Point'||val==='end point'){return interfaceFunction.endPoint;}if(val==='Opacity'||val==='opacity'){return interfaceFunction.opacity;}return null;}Object.defineProperties(interfaceFunction,{startPoint:{get:ExpressionPropertyInterface(view.s)},endPoint:{get:ExpressionPropertyInterface(view.e)},opacity:{get:ExpressionPropertyInterface(view.o)},type:{get:function get(){return 'a';}},_name:{value:shape.nm},mn:{value:shape.mn}});view.s.setGroupProperty(PropertyInterface('Start Point',propertyGroup));view.e.setGroupProperty(PropertyInterface('End Point',propertyGroup));view.o.setGroupProperty(PropertyInterface('Opacity',propertyGroup));return interfaceFunction;}function defaultInterfaceFactory(){function interfaceFunction(){return null;}return interfaceFunction;}function strokeInterfaceFactory(shape,view,propertyGroup){var _propertyGroup=propertyGroupFactory(interfaceFunction,propertyGroup);var _dashPropertyGroup=propertyGroupFactory(dashOb,_propertyGroup);function addPropertyToDashOb(i){Object.defineProperty(dashOb,shape.d[i].nm,{get:ExpressionPropertyInterface(view.d.dataProps[i].p)});}var i;var len=shape.d?shape.d.length:0;var dashOb={};for(i=0;i<len;i+=1){addPropertyToDashOb(i);view.d.dataProps[i].p.setGroupProperty(_dashPropertyGroup);}function interfaceFunction(val){if(val==='Color'||val==='color'){return interfaceFunction.color;}if(val==='Opacity'||val==='opacity'){return interfaceFunction.opacity;}if(val==='Stroke Width'||val==='stroke width'){return interfaceFunction.strokeWidth;}return null;}Object.defineProperties(interfaceFunction,{color:{get:ExpressionPropertyInterface(view.c)},opacity:{get:ExpressionPropertyInterface(view.o)},strokeWidth:{get:ExpressionPropertyInterface(view.w)},dash:{get:function get(){return dashOb;}},_name:{value:shape.nm},mn:{value:shape.mn}});view.c.setGroupProperty(PropertyInterface('Color',_propertyGroup));view.o.setGroupProperty(PropertyInterface('Opacity',_propertyGroup));view.w.setGroupProperty(PropertyInterface('Stroke Width',_propertyGroup));return interfaceFunction;}function trimInterfaceFactory(shape,view,propertyGroup){function interfaceFunction(val){if(val===shape.e.ix||val==='End'||val==='end'){return interfaceFunction.end;}if(val===shape.s.ix){return interfaceFunction.start;}if(val===shape.o.ix){return interfaceFunction.offset;}return null;}var _propertyGroup=propertyGroupFactory(interfaceFunction,propertyGroup);interfaceFunction.propertyIndex=shape.ix;view.s.setGroupProperty(PropertyInterface('Start',_propertyGroup));view.e.setGroupProperty(PropertyInterface('End',_propertyGroup));view.o.setGroupProperty(PropertyInterface('Offset',_propertyGroup));interfaceFunction.propertyIndex=shape.ix;interfaceFunction.propertyGroup=propertyGroup;Object.defineProperties(interfaceFunction,{start:{get:ExpressionPropertyInterface(view.s)},end:{get:ExpressionPropertyInterface(view.e)},offset:{get:ExpressionPropertyInterface(view.o)},_name:{value:shape.nm}});interfaceFunction.mn=shape.mn;return interfaceFunction;}function transformInterfaceFactory(shape,view,propertyGroup){function interfaceFunction(value){if(shape.a.ix===value||value==='Anchor Point'){return interfaceFunction.anchorPoint;}if(shape.o.ix===value||value==='Opacity'){return interfaceFunction.opacity;}if(shape.p.ix===value||value==='Position'){return interfaceFunction.position;}if(shape.r.ix===value||value==='Rotation'||value==='ADBE Vector Rotation'){return interfaceFunction.rotation;}if(shape.s.ix===value||value==='Scale'){return interfaceFunction.scale;}if(shape.sk&&shape.sk.ix===value||value==='Skew'){return interfaceFunction.skew;}if(shape.sa&&shape.sa.ix===value||value==='Skew Axis'){return interfaceFunction.skewAxis;}return null;}var _propertyGroup=propertyGroupFactory(interfaceFunction,propertyGroup);view.transform.mProps.o.setGroupProperty(PropertyInterface('Opacity',_propertyGroup));view.transform.mProps.p.setGroupProperty(PropertyInterface('Position',_propertyGroup));view.transform.mProps.a.setGroupProperty(PropertyInterface('Anchor Point',_propertyGroup));view.transform.mProps.s.setGroupProperty(PropertyInterface('Scale',_propertyGroup));view.transform.mProps.r.setGroupProperty(PropertyInterface('Rotation',_propertyGroup));if(view.transform.mProps.sk){view.transform.mProps.sk.setGroupProperty(PropertyInterface('Skew',_propertyGroup));view.transform.mProps.sa.setGroupProperty(PropertyInterface('Skew Angle',_propertyGroup));}view.transform.op.setGroupProperty(PropertyInterface('Opacity',_propertyGroup));Object.defineProperties(interfaceFunction,{opacity:{get:ExpressionPropertyInterface(view.transform.mProps.o)},position:{get:ExpressionPropertyInterface(view.transform.mProps.p)},anchorPoint:{get:ExpressionPropertyInterface(view.transform.mProps.a)},scale:{get:ExpressionPropertyInterface(view.transform.mProps.s)},rotation:{get:ExpressionPropertyInterface(view.transform.mProps.r)},skew:{get:ExpressionPropertyInterface(view.transform.mProps.sk)},skewAxis:{get:ExpressionPropertyInterface(view.transform.mProps.sa)},_name:{value:shape.nm}});interfaceFunction.ty='tr';interfaceFunction.mn=shape.mn;interfaceFunction.propertyGroup=propertyGroup;return interfaceFunction;}function ellipseInterfaceFactory(shape,view,propertyGroup){function interfaceFunction(value){if(shape.p.ix===value){return interfaceFunction.position;}if(shape.s.ix===value){return interfaceFunction.size;}return null;}var _propertyGroup=propertyGroupFactory(interfaceFunction,propertyGroup);interfaceFunction.propertyIndex=shape.ix;var prop=view.sh.ty==='tm'?view.sh.prop:view.sh;prop.s.setGroupProperty(PropertyInterface('Size',_propertyGroup));prop.p.setGroupProperty(PropertyInterface('Position',_propertyGroup));Object.defineProperties(interfaceFunction,{size:{get:ExpressionPropertyInterface(prop.s)},position:{get:ExpressionPropertyInterface(prop.p)},_name:{value:shape.nm}});interfaceFunction.mn=shape.mn;return interfaceFunction;}function starInterfaceFactory(shape,view,propertyGroup){function interfaceFunction(value){if(shape.p.ix===value){return interfaceFunction.position;}if(shape.r.ix===value){return interfaceFunction.rotation;}if(shape.pt.ix===value){return interfaceFunction.points;}if(shape.or.ix===value||value==='ADBE Vector Star Outer Radius'){return interfaceFunction.outerRadius;}if(shape.os.ix===value){return interfaceFunction.outerRoundness;}if(shape.ir&&(shape.ir.ix===value||value==='ADBE Vector Star Inner Radius')){return interfaceFunction.innerRadius;}if(shape.is&&shape.is.ix===value){return interfaceFunction.innerRoundness;}return null;}var _propertyGroup=propertyGroupFactory(interfaceFunction,propertyGroup);var prop=view.sh.ty==='tm'?view.sh.prop:view.sh;interfaceFunction.propertyIndex=shape.ix;prop.or.setGroupProperty(PropertyInterface('Outer Radius',_propertyGroup));prop.os.setGroupProperty(PropertyInterface('Outer Roundness',_propertyGroup));prop.pt.setGroupProperty(PropertyInterface('Points',_propertyGroup));prop.p.setGroupProperty(PropertyInterface('Position',_propertyGroup));prop.r.setGroupProperty(PropertyInterface('Rotation',_propertyGroup));if(shape.ir){prop.ir.setGroupProperty(PropertyInterface('Inner Radius',_propertyGroup));prop.is.setGroupProperty(PropertyInterface('Inner Roundness',_propertyGroup));}Object.defineProperties(interfaceFunction,{position:{get:ExpressionPropertyInterface(prop.p)},rotation:{get:ExpressionPropertyInterface(prop.r)},points:{get:ExpressionPropertyInterface(prop.pt)},outerRadius:{get:ExpressionPropertyInterface(prop.or)},outerRoundness:{get:ExpressionPropertyInterface(prop.os)},innerRadius:{get:ExpressionPropertyInterface(prop.ir)},innerRoundness:{get:ExpressionPropertyInterface(prop.is)},_name:{value:shape.nm}});interfaceFunction.mn=shape.mn;return interfaceFunction;}function rectInterfaceFactory(shape,view,propertyGroup){function interfaceFunction(value){if(shape.p.ix===value){return interfaceFunction.position;}if(shape.r.ix===value){return interfaceFunction.roundness;}if(shape.s.ix===value||value==='Size'||value==='ADBE Vector Rect Size'){return interfaceFunction.size;}return null;}var _propertyGroup=propertyGroupFactory(interfaceFunction,propertyGroup);var prop=view.sh.ty==='tm'?view.sh.prop:view.sh;interfaceFunction.propertyIndex=shape.ix;prop.p.setGroupProperty(PropertyInterface('Position',_propertyGroup));prop.s.setGroupProperty(PropertyInterface('Size',_propertyGroup));prop.r.setGroupProperty(PropertyInterface('Rotation',_propertyGroup));Object.defineProperties(interfaceFunction,{position:{get:ExpressionPropertyInterface(prop.p)},roundness:{get:ExpressionPropertyInterface(prop.r)},size:{get:ExpressionPropertyInterface(prop.s)},_name:{value:shape.nm}});interfaceFunction.mn=shape.mn;return interfaceFunction;}function roundedInterfaceFactory(shape,view,propertyGroup){function interfaceFunction(value){if(shape.r.ix===value||value==='Round Corners 1'){return interfaceFunction.radius;}return null;}var _propertyGroup=propertyGroupFactory(interfaceFunction,propertyGroup);var prop=view;interfaceFunction.propertyIndex=shape.ix;prop.rd.setGroupProperty(PropertyInterface('Radius',_propertyGroup));Object.defineProperties(interfaceFunction,{radius:{get:ExpressionPropertyInterface(prop.rd)},_name:{value:shape.nm}});interfaceFunction.mn=shape.mn;return interfaceFunction;}function repeaterInterfaceFactory(shape,view,propertyGroup){function interfaceFunction(value){if(shape.c.ix===value||value==='Copies'){return interfaceFunction.copies;}if(shape.o.ix===value||value==='Offset'){return interfaceFunction.offset;}return null;}var _propertyGroup=propertyGroupFactory(interfaceFunction,propertyGroup);var prop=view;interfaceFunction.propertyIndex=shape.ix;prop.c.setGroupProperty(PropertyInterface('Copies',_propertyGroup));prop.o.setGroupProperty(PropertyInterface('Offset',_propertyGroup));Object.defineProperties(interfaceFunction,{copies:{get:ExpressionPropertyInterface(prop.c)},offset:{get:ExpressionPropertyInterface(prop.o)},_name:{value:shape.nm}});interfaceFunction.mn=shape.mn;return interfaceFunction;}return function(shapes,view,propertyGroup){var interfaces;function _interfaceFunction(value){if(typeof value==='number'){value=value===undefined?1:value;if(value===0){return propertyGroup;}return interfaces[value-1];}var i=0;var len=interfaces.length;while(i<len){if(interfaces[i]._name===value){return interfaces[i];}i+=1;}return null;}function parentGroupWrapper(){return propertyGroup;}_interfaceFunction.propertyGroup=propertyGroupFactory(_interfaceFunction,parentGroupWrapper);interfaces=iterateElements(shapes,view,_interfaceFunction.propertyGroup);_interfaceFunction.numProperties=interfaces.length;_interfaceFunction._name='Contents';return _interfaceFunction;};}();var TextExpressionInterface=function(){return function(elem){var _sourceText;function _thisLayerFunction(name){switch(name){case'ADBE Text Document':return _thisLayerFunction.sourceText;default:return null;}}Object.defineProperty(_thisLayerFunction,'sourceText',{get:function get(){elem.textProperty.getValue();var stringValue=elem.textProperty.currentData.t;if(!_sourceText||stringValue!==_sourceText.value){_sourceText=new String(stringValue);// eslint-disable-line no-new-wrappers
	// If stringValue is an empty string, eval returns undefined, so it has to be returned as a String primitive
	_sourceText.value=stringValue||new String(stringValue);// eslint-disable-line no-new-wrappers
	Object.defineProperty(_sourceText,'style',{get:function get(){return {fillColor:elem.textProperty.currentData.fc};}});}return _sourceText;}});return _thisLayerFunction;};}();function _typeof(obj){"@babel/helpers - typeof";if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){_typeof=function _typeof(obj){return typeof obj;};}else {_typeof=function _typeof(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};}return _typeof(obj);}var FootageInterface=function(){var outlineInterfaceFactory=function outlineInterfaceFactory(elem){var currentPropertyName='';var currentProperty=elem.getFootageData();function init(){currentPropertyName='';currentProperty=elem.getFootageData();return searchProperty;}function searchProperty(value){if(currentProperty[value]){currentPropertyName=value;currentProperty=currentProperty[value];if(_typeof(currentProperty)==='object'){return searchProperty;}return currentProperty;}var propertyNameIndex=value.indexOf(currentPropertyName);if(propertyNameIndex!==-1){var index=parseInt(value.substr(propertyNameIndex+currentPropertyName.length),10);currentProperty=currentProperty[index];if(_typeof(currentProperty)==='object'){return searchProperty;}return currentProperty;}return '';}return init;};var dataInterfaceFactory=function dataInterfaceFactory(elem){function interfaceFunction(value){if(value==='Outline'){return interfaceFunction.outlineInterface();}return null;}interfaceFunction._name='Outline';interfaceFunction.outlineInterface=outlineInterfaceFactory(elem);return interfaceFunction;};return function(elem){function _interfaceFunction(value){if(value==='Data'){return _interfaceFunction.dataInterface;}return null;}_interfaceFunction._name='Data';_interfaceFunction.dataInterface=dataInterfaceFactory(elem);return _interfaceFunction;};}();var interfaces={layer:LayerExpressionInterface,effects:EffectsExpressionInterface,comp:CompExpressionInterface,shape:ShapeExpressionInterface,text:TextExpressionInterface,footage:FootageInterface};function getInterface(type){return interfaces[type]||null;}var expressionHelpers=function(){function searchExpressions(elem,data,prop){if(data.x){prop.k=true;prop.x=true;prop.initiateExpression=ExpressionManager.initiateExpression;prop.effectsSequence.push(prop.initiateExpression(elem,data,prop).bind(prop));}}function getValueAtTime(frameNum){frameNum*=this.elem.globalData.frameRate;frameNum-=this.offsetTime;if(frameNum!==this._cachingAtTime.lastFrame){this._cachingAtTime.lastIndex=this._cachingAtTime.lastFrame<frameNum?this._cachingAtTime.lastIndex:0;this._cachingAtTime.value=this.interpolateValue(frameNum,this._cachingAtTime);this._cachingAtTime.lastFrame=frameNum;}return this._cachingAtTime.value;}function getSpeedAtTime(frameNum){var delta=-0.01;var v1=this.getValueAtTime(frameNum);var v2=this.getValueAtTime(frameNum+delta);var speed=0;if(v1.length){var i;for(i=0;i<v1.length;i+=1){speed+=Math.pow(v2[i]-v1[i],2);}speed=Math.sqrt(speed)*100;}else {speed=0;}return speed;}function getVelocityAtTime(frameNum){if(this.vel!==undefined){return this.vel;}var delta=-0.001;// frameNum += this.elem.data.st;
	var v1=this.getValueAtTime(frameNum);var v2=this.getValueAtTime(frameNum+delta);var velocity;if(v1.length){velocity=createTypedArray('float32',v1.length);var i;for(i=0;i<v1.length;i+=1){// removing frameRate
	// if needed, don't add it here
	// velocity[i] = this.elem.globalData.frameRate*((v2[i] - v1[i])/delta);
	velocity[i]=(v2[i]-v1[i])/delta;}}else {velocity=(v2-v1)/delta;}return velocity;}function getStaticValueAtTime(){return this.pv;}function setGroupProperty(propertyGroup){this.propertyGroup=propertyGroup;}return {searchExpressions:searchExpressions,getSpeedAtTime:getSpeedAtTime,getVelocityAtTime:getVelocityAtTime,getValueAtTime:getValueAtTime,getStaticValueAtTime:getStaticValueAtTime,setGroupProperty:setGroupProperty};}();function addPropertyDecorator(){function loopOut(type,duration,durationFlag){if(!this.k||!this.keyframes){return this.pv;}type=type?type.toLowerCase():'';var currentFrame=this.comp.renderedFrame;var keyframes=this.keyframes;var lastKeyFrame=keyframes[keyframes.length-1].t;if(currentFrame<=lastKeyFrame){return this.pv;}var cycleDuration;var firstKeyFrame;if(!durationFlag){if(!duration||duration>keyframes.length-1){duration=keyframes.length-1;}firstKeyFrame=keyframes[keyframes.length-1-duration].t;cycleDuration=lastKeyFrame-firstKeyFrame;}else {if(!duration){cycleDuration=Math.max(0,lastKeyFrame-this.elem.data.ip);}else {cycleDuration=Math.abs(lastKeyFrame-this.elem.comp.globalData.frameRate*duration);}firstKeyFrame=lastKeyFrame-cycleDuration;}var i;var len;var ret;if(type==='pingpong'){var iterations=Math.floor((currentFrame-firstKeyFrame)/cycleDuration);if(iterations%2!==0){return this.getValueAtTime((cycleDuration-(currentFrame-firstKeyFrame)%cycleDuration+firstKeyFrame)/this.comp.globalData.frameRate,0);// eslint-disable-line
	}}else if(type==='offset'){var initV=this.getValueAtTime(firstKeyFrame/this.comp.globalData.frameRate,0);var endV=this.getValueAtTime(lastKeyFrame/this.comp.globalData.frameRate,0);var current=this.getValueAtTime(((currentFrame-firstKeyFrame)%cycleDuration+firstKeyFrame)/this.comp.globalData.frameRate,0);// eslint-disable-line
	var repeats=Math.floor((currentFrame-firstKeyFrame)/cycleDuration);if(this.pv.length){ret=new Array(initV.length);len=ret.length;for(i=0;i<len;i+=1){ret[i]=(endV[i]-initV[i])*repeats+current[i];}return ret;}return (endV-initV)*repeats+current;}else if(type==='continue'){var lastValue=this.getValueAtTime(lastKeyFrame/this.comp.globalData.frameRate,0);var nextLastValue=this.getValueAtTime((lastKeyFrame-0.001)/this.comp.globalData.frameRate,0);if(this.pv.length){ret=new Array(lastValue.length);len=ret.length;for(i=0;i<len;i+=1){ret[i]=lastValue[i]+(lastValue[i]-nextLastValue[i])*((currentFrame-lastKeyFrame)/this.comp.globalData.frameRate)/0.0005;// eslint-disable-line
	}return ret;}return lastValue+(lastValue-nextLastValue)*((currentFrame-lastKeyFrame)/0.001);}return this.getValueAtTime(((currentFrame-firstKeyFrame)%cycleDuration+firstKeyFrame)/this.comp.globalData.frameRate,0);// eslint-disable-line
	}function loopIn(type,duration,durationFlag){if(!this.k){return this.pv;}type=type?type.toLowerCase():'';var currentFrame=this.comp.renderedFrame;var keyframes=this.keyframes;var firstKeyFrame=keyframes[0].t;if(currentFrame>=firstKeyFrame){return this.pv;}var cycleDuration;var lastKeyFrame;if(!durationFlag){if(!duration||duration>keyframes.length-1){duration=keyframes.length-1;}lastKeyFrame=keyframes[duration].t;cycleDuration=lastKeyFrame-firstKeyFrame;}else {if(!duration){cycleDuration=Math.max(0,this.elem.data.op-firstKeyFrame);}else {cycleDuration=Math.abs(this.elem.comp.globalData.frameRate*duration);}lastKeyFrame=firstKeyFrame+cycleDuration;}var i;var len;var ret;if(type==='pingpong'){var iterations=Math.floor((firstKeyFrame-currentFrame)/cycleDuration);if(iterations%2===0){return this.getValueAtTime(((firstKeyFrame-currentFrame)%cycleDuration+firstKeyFrame)/this.comp.globalData.frameRate,0);// eslint-disable-line
	}}else if(type==='offset'){var initV=this.getValueAtTime(firstKeyFrame/this.comp.globalData.frameRate,0);var endV=this.getValueAtTime(lastKeyFrame/this.comp.globalData.frameRate,0);var current=this.getValueAtTime((cycleDuration-(firstKeyFrame-currentFrame)%cycleDuration+firstKeyFrame)/this.comp.globalData.frameRate,0);var repeats=Math.floor((firstKeyFrame-currentFrame)/cycleDuration)+1;if(this.pv.length){ret=new Array(initV.length);len=ret.length;for(i=0;i<len;i+=1){ret[i]=current[i]-(endV[i]-initV[i])*repeats;}return ret;}return current-(endV-initV)*repeats;}else if(type==='continue'){var firstValue=this.getValueAtTime(firstKeyFrame/this.comp.globalData.frameRate,0);var nextFirstValue=this.getValueAtTime((firstKeyFrame+0.001)/this.comp.globalData.frameRate,0);if(this.pv.length){ret=new Array(firstValue.length);len=ret.length;for(i=0;i<len;i+=1){ret[i]=firstValue[i]+(firstValue[i]-nextFirstValue[i])*(firstKeyFrame-currentFrame)/0.001;}return ret;}return firstValue+(firstValue-nextFirstValue)*(firstKeyFrame-currentFrame)/0.001;}return this.getValueAtTime((cycleDuration-((firstKeyFrame-currentFrame)%cycleDuration+firstKeyFrame))/this.comp.globalData.frameRate,0);// eslint-disable-line
	}function smooth(width,samples){if(!this.k){return this.pv;}width=(width||0.4)*0.5;samples=Math.floor(samples||5);if(samples<=1){return this.pv;}var currentTime=this.comp.renderedFrame/this.comp.globalData.frameRate;var initFrame=currentTime-width;var endFrame=currentTime+width;var sampleFrequency=samples>1?(endFrame-initFrame)/(samples-1):1;var i=0;var j=0;var value;if(this.pv.length){value=createTypedArray('float32',this.pv.length);}else {value=0;}var sampleValue;while(i<samples){sampleValue=this.getValueAtTime(initFrame+i*sampleFrequency);if(this.pv.length){for(j=0;j<this.pv.length;j+=1){value[j]+=sampleValue[j];}}else {value+=sampleValue;}i+=1;}if(this.pv.length){for(j=0;j<this.pv.length;j+=1){value[j]/=samples;}}else {value/=samples;}return value;}function getTransformValueAtTime(time){if(!this._transformCachingAtTime){this._transformCachingAtTime={v:new Matrix()};}/// /
	var matrix=this._transformCachingAtTime.v;matrix.cloneFromProps(this.pre.props);if(this.appliedTransformations<1){var anchor=this.a.getValueAtTime(time);matrix.translate(-anchor[0]*this.a.mult,-anchor[1]*this.a.mult,anchor[2]*this.a.mult);}if(this.appliedTransformations<2){var scale=this.s.getValueAtTime(time);matrix.scale(scale[0]*this.s.mult,scale[1]*this.s.mult,scale[2]*this.s.mult);}if(this.sk&&this.appliedTransformations<3){var skew=this.sk.getValueAtTime(time);var skewAxis=this.sa.getValueAtTime(time);matrix.skewFromAxis(-skew*this.sk.mult,skewAxis*this.sa.mult);}if(this.r&&this.appliedTransformations<4){var rotation=this.r.getValueAtTime(time);matrix.rotate(-rotation*this.r.mult);}else if(!this.r&&this.appliedTransformations<4){var rotationZ=this.rz.getValueAtTime(time);var rotationY=this.ry.getValueAtTime(time);var rotationX=this.rx.getValueAtTime(time);var orientation=this.or.getValueAtTime(time);matrix.rotateZ(-rotationZ*this.rz.mult).rotateY(rotationY*this.ry.mult).rotateX(rotationX*this.rx.mult).rotateZ(-orientation[2]*this.or.mult).rotateY(orientation[1]*this.or.mult).rotateX(orientation[0]*this.or.mult);}if(this.data.p&&this.data.p.s){var positionX=this.px.getValueAtTime(time);var positionY=this.py.getValueAtTime(time);if(this.data.p.z){var positionZ=this.pz.getValueAtTime(time);matrix.translate(positionX*this.px.mult,positionY*this.py.mult,-positionZ*this.pz.mult);}else {matrix.translate(positionX*this.px.mult,positionY*this.py.mult,0);}}else {var position=this.p.getValueAtTime(time);matrix.translate(position[0]*this.p.mult,position[1]*this.p.mult,-position[2]*this.p.mult);}return matrix;/// /
	}function getTransformStaticValueAtTime(){return this.v.clone(new Matrix());}var getTransformProperty=TransformPropertyFactory.getTransformProperty;TransformPropertyFactory.getTransformProperty=function(elem,data,container){var prop=getTransformProperty(elem,data,container);if(prop.dynamicProperties.length){prop.getValueAtTime=getTransformValueAtTime.bind(prop);}else {prop.getValueAtTime=getTransformStaticValueAtTime.bind(prop);}prop.setGroupProperty=expressionHelpers.setGroupProperty;return prop;};var propertyGetProp=PropertyFactory.getProp;PropertyFactory.getProp=function(elem,data,type,mult,container){var prop=propertyGetProp(elem,data,type,mult,container);// prop.getVelocityAtTime = getVelocityAtTime;
	// prop.loopOut = loopOut;
	// prop.loopIn = loopIn;
	if(prop.kf){prop.getValueAtTime=expressionHelpers.getValueAtTime.bind(prop);}else {prop.getValueAtTime=expressionHelpers.getStaticValueAtTime.bind(prop);}prop.setGroupProperty=expressionHelpers.setGroupProperty;prop.loopOut=loopOut;prop.loopIn=loopIn;prop.smooth=smooth;prop.getVelocityAtTime=expressionHelpers.getVelocityAtTime.bind(prop);prop.getSpeedAtTime=expressionHelpers.getSpeedAtTime.bind(prop);prop.numKeys=data.a===1?data.k.length:0;prop.propertyIndex=data.ix;var value=0;if(type!==0){value=createTypedArray('float32',data.a===1?data.k[0].s.length:data.k.length);}prop._cachingAtTime={lastFrame:initialDefaultFrame,lastIndex:0,value:value};expressionHelpers.searchExpressions(elem,data,prop);if(prop.k){container.addDynamicProperty(prop);}return prop;};function getShapeValueAtTime(frameNum){// For now this caching object is created only when needed instead of creating it when the shape is initialized.
	if(!this._cachingAtTime){this._cachingAtTime={shapeValue:shapePool.clone(this.pv),lastIndex:0,lastTime:initialDefaultFrame};}frameNum*=this.elem.globalData.frameRate;frameNum-=this.offsetTime;if(frameNum!==this._cachingAtTime.lastTime){this._cachingAtTime.lastIndex=this._cachingAtTime.lastTime<frameNum?this._caching.lastIndex:0;this._cachingAtTime.lastTime=frameNum;this.interpolateShape(frameNum,this._cachingAtTime.shapeValue,this._cachingAtTime);}return this._cachingAtTime.shapeValue;}var ShapePropertyConstructorFunction=ShapePropertyFactory.getConstructorFunction();var KeyframedShapePropertyConstructorFunction=ShapePropertyFactory.getKeyframedConstructorFunction();function ShapeExpressions(){}ShapeExpressions.prototype={vertices:function vertices(prop,time){if(this.k){this.getValue();}var shapePath=this.v;if(time!==undefined){shapePath=this.getValueAtTime(time,0);}var i;var len=shapePath._length;var vertices=shapePath[prop];var points=shapePath.v;var arr=createSizedArray(len);for(i=0;i<len;i+=1){if(prop==='i'||prop==='o'){arr[i]=[vertices[i][0]-points[i][0],vertices[i][1]-points[i][1]];}else {arr[i]=[vertices[i][0],vertices[i][1]];}}return arr;},points:function points(time){return this.vertices('v',time);},inTangents:function inTangents(time){return this.vertices('i',time);},outTangents:function outTangents(time){return this.vertices('o',time);},isClosed:function isClosed(){return this.v.c;},pointOnPath:function pointOnPath(perc,time){var shapePath=this.v;if(time!==undefined){shapePath=this.getValueAtTime(time,0);}if(!this._segmentsLength){this._segmentsLength=bez.getSegmentsLength(shapePath);}var segmentsLength=this._segmentsLength;var lengths=segmentsLength.lengths;var lengthPos=segmentsLength.totalLength*perc;var i=0;var len=lengths.length;var accumulatedLength=0;var pt;while(i<len){if(accumulatedLength+lengths[i].addedLength>lengthPos){var initIndex=i;var endIndex=shapePath.c&&i===len-1?0:i+1;var segmentPerc=(lengthPos-accumulatedLength)/lengths[i].addedLength;pt=bez.getPointInSegment(shapePath.v[initIndex],shapePath.v[endIndex],shapePath.o[initIndex],shapePath.i[endIndex],segmentPerc,lengths[i]);break;}else {accumulatedLength+=lengths[i].addedLength;}i+=1;}if(!pt){pt=shapePath.c?[shapePath.v[0][0],shapePath.v[0][1]]:[shapePath.v[shapePath._length-1][0],shapePath.v[shapePath._length-1][1]];}return pt;},vectorOnPath:function vectorOnPath(perc,time,vectorType){// perc doesn't use triple equality because it can be a Number object as well as a primitive.
	if(perc==1){// eslint-disable-line eqeqeq
	perc=this.v.c;}else if(perc==0){// eslint-disable-line eqeqeq
	perc=0.999;}var pt1=this.pointOnPath(perc,time);var pt2=this.pointOnPath(perc+0.001,time);var xLength=pt2[0]-pt1[0];var yLength=pt2[1]-pt1[1];var magnitude=Math.sqrt(Math.pow(xLength,2)+Math.pow(yLength,2));if(magnitude===0){return [0,0];}var unitVector=vectorType==='tangent'?[xLength/magnitude,yLength/magnitude]:[-yLength/magnitude,xLength/magnitude];return unitVector;},tangentOnPath:function tangentOnPath(perc,time){return this.vectorOnPath(perc,time,'tangent');},normalOnPath:function normalOnPath(perc,time){return this.vectorOnPath(perc,time,'normal');},setGroupProperty:expressionHelpers.setGroupProperty,getValueAtTime:expressionHelpers.getStaticValueAtTime};extendPrototype([ShapeExpressions],ShapePropertyConstructorFunction);extendPrototype([ShapeExpressions],KeyframedShapePropertyConstructorFunction);KeyframedShapePropertyConstructorFunction.prototype.getValueAtTime=getShapeValueAtTime;KeyframedShapePropertyConstructorFunction.prototype.initiateExpression=ExpressionManager.initiateExpression;var propertyGetShapeProp=ShapePropertyFactory.getShapeProp;ShapePropertyFactory.getShapeProp=function(elem,data,type,arr,trims){var prop=propertyGetShapeProp(elem,data,type,arr,trims);prop.propertyIndex=data.ix;prop.lock=false;if(type===3){expressionHelpers.searchExpressions(elem,data.pt,prop);}else if(type===4){expressionHelpers.searchExpressions(elem,data.ks,prop);}if(prop.k){elem.addDynamicProperty(prop);}return prop;};}function initialize$1(){addPropertyDecorator();}function addDecorator(){function searchExpressions(){if(this.data.d.x){this.calculateExpression=ExpressionManager.initiateExpression.bind(this)(this.elem,this.data.d,this);this.addEffect(this.getExpressionValue.bind(this));return true;}return null;}TextProperty.prototype.getExpressionValue=function(currentValue,text){var newValue=this.calculateExpression(text);if(currentValue.t!==newValue){var newData={};this.copyData(newData,currentValue);newData.t=newValue.toString();newData.__complete=false;return newData;}return currentValue;};TextProperty.prototype.searchProperty=function(){var isKeyframed=this.searchKeyframes();var hasExpressions=this.searchExpressions();this.kf=isKeyframed||hasExpressions;return this.kf;};TextProperty.prototype.searchExpressions=searchExpressions;}function initialize(){addDecorator();}function SVGComposableEffect(){}SVGComposableEffect.prototype={createMergeNode:function createMergeNode(resultId,ins){var feMerge=createNS('feMerge');feMerge.setAttribute('result',resultId);var feMergeNode;var i;for(i=0;i<ins.length;i+=1){feMergeNode=createNS('feMergeNode');feMergeNode.setAttribute('in',ins[i]);feMerge.appendChild(feMergeNode);feMerge.appendChild(feMergeNode);}return feMerge;}};var linearFilterValue='0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0';function SVGTintFilter(filter,filterManager,elem,id,source){this.filterManager=filterManager;var feColorMatrix=createNS('feColorMatrix');feColorMatrix.setAttribute('type','matrix');feColorMatrix.setAttribute('color-interpolation-filters','linearRGB');feColorMatrix.setAttribute('values',linearFilterValue+' 1 0');this.linearFilter=feColorMatrix;feColorMatrix.setAttribute('result',id+'_tint_1');filter.appendChild(feColorMatrix);feColorMatrix=createNS('feColorMatrix');feColorMatrix.setAttribute('type','matrix');feColorMatrix.setAttribute('color-interpolation-filters','sRGB');feColorMatrix.setAttribute('values','1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');feColorMatrix.setAttribute('result',id+'_tint_2');filter.appendChild(feColorMatrix);this.matrixFilter=feColorMatrix;var feMerge=this.createMergeNode(id,[source,id+'_tint_1',id+'_tint_2']);filter.appendChild(feMerge);}extendPrototype([SVGComposableEffect],SVGTintFilter);SVGTintFilter.prototype.renderFrame=function(forceRender){if(forceRender||this.filterManager._mdf){var colorBlack=this.filterManager.effectElements[0].p.v;var colorWhite=this.filterManager.effectElements[1].p.v;var opacity=this.filterManager.effectElements[2].p.v/100;this.linearFilter.setAttribute('values',linearFilterValue+' '+opacity+' 0');this.matrixFilter.setAttribute('values',colorWhite[0]-colorBlack[0]+' 0 0 0 '+colorBlack[0]+' '+(colorWhite[1]-colorBlack[1])+' 0 0 0 '+colorBlack[1]+' '+(colorWhite[2]-colorBlack[2])+' 0 0 0 '+colorBlack[2]+' 0 0 0 1 0');}};function SVGFillFilter(filter,filterManager,elem,id){this.filterManager=filterManager;var feColorMatrix=createNS('feColorMatrix');feColorMatrix.setAttribute('type','matrix');feColorMatrix.setAttribute('color-interpolation-filters','sRGB');feColorMatrix.setAttribute('values','1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');feColorMatrix.setAttribute('result',id);filter.appendChild(feColorMatrix);this.matrixFilter=feColorMatrix;}SVGFillFilter.prototype.renderFrame=function(forceRender){if(forceRender||this.filterManager._mdf){var color=this.filterManager.effectElements[2].p.v;var opacity=this.filterManager.effectElements[6].p.v;this.matrixFilter.setAttribute('values','0 0 0 0 '+color[0]+' 0 0 0 0 '+color[1]+' 0 0 0 0 '+color[2]+' 0 0 0 '+opacity+' 0');}};function SVGStrokeEffect(fil,filterManager,elem){this.initialized=false;this.filterManager=filterManager;this.elem=elem;this.paths=[];}SVGStrokeEffect.prototype.initialize=function(){var elemChildren=this.elem.layerElement.children||this.elem.layerElement.childNodes;var path;var groupPath;var i;var len;if(this.filterManager.effectElements[1].p.v===1){len=this.elem.maskManager.masksProperties.length;i=0;}else {i=this.filterManager.effectElements[0].p.v-1;len=i+1;}groupPath=createNS('g');groupPath.setAttribute('fill','none');groupPath.setAttribute('stroke-linecap','round');groupPath.setAttribute('stroke-dashoffset',1);for(i;i<len;i+=1){path=createNS('path');groupPath.appendChild(path);this.paths.push({p:path,m:i});}if(this.filterManager.effectElements[10].p.v===3){var mask=createNS('mask');var id=createElementID();mask.setAttribute('id',id);mask.setAttribute('mask-type','alpha');mask.appendChild(groupPath);this.elem.globalData.defs.appendChild(mask);var g=createNS('g');g.setAttribute('mask','url('+getLocationHref()+'#'+id+')');while(elemChildren[0]){g.appendChild(elemChildren[0]);}this.elem.layerElement.appendChild(g);this.masker=mask;groupPath.setAttribute('stroke','#fff');}else if(this.filterManager.effectElements[10].p.v===1||this.filterManager.effectElements[10].p.v===2){if(this.filterManager.effectElements[10].p.v===2){elemChildren=this.elem.layerElement.children||this.elem.layerElement.childNodes;while(elemChildren.length){this.elem.layerElement.removeChild(elemChildren[0]);}}this.elem.layerElement.appendChild(groupPath);this.elem.layerElement.removeAttribute('mask');groupPath.setAttribute('stroke','#fff');}this.initialized=true;this.pathMasker=groupPath;};SVGStrokeEffect.prototype.renderFrame=function(forceRender){if(!this.initialized){this.initialize();}var i;var len=this.paths.length;var mask;var path;for(i=0;i<len;i+=1){if(this.paths[i].m!==-1){mask=this.elem.maskManager.viewData[this.paths[i].m];path=this.paths[i].p;if(forceRender||this.filterManager._mdf||mask.prop._mdf){path.setAttribute('d',mask.lastPath);}if(forceRender||this.filterManager.effectElements[9].p._mdf||this.filterManager.effectElements[4].p._mdf||this.filterManager.effectElements[7].p._mdf||this.filterManager.effectElements[8].p._mdf||mask.prop._mdf){var dasharrayValue;if(this.filterManager.effectElements[7].p.v!==0||this.filterManager.effectElements[8].p.v!==100){var s=Math.min(this.filterManager.effectElements[7].p.v,this.filterManager.effectElements[8].p.v)*0.01;var e=Math.max(this.filterManager.effectElements[7].p.v,this.filterManager.effectElements[8].p.v)*0.01;var l=path.getTotalLength();dasharrayValue='0 0 0 '+l*s+' ';var lineLength=l*(e-s);var segment=1+this.filterManager.effectElements[4].p.v*2*this.filterManager.effectElements[9].p.v*0.01;var units=Math.floor(lineLength/segment);var j;for(j=0;j<units;j+=1){dasharrayValue+='1 '+this.filterManager.effectElements[4].p.v*2*this.filterManager.effectElements[9].p.v*0.01+' ';}dasharrayValue+='0 '+l*10+' 0 0';}else {dasharrayValue='1 '+this.filterManager.effectElements[4].p.v*2*this.filterManager.effectElements[9].p.v*0.01;}path.setAttribute('stroke-dasharray',dasharrayValue);}}}if(forceRender||this.filterManager.effectElements[4].p._mdf){this.pathMasker.setAttribute('stroke-width',this.filterManager.effectElements[4].p.v*2);}if(forceRender||this.filterManager.effectElements[6].p._mdf){this.pathMasker.setAttribute('opacity',this.filterManager.effectElements[6].p.v);}if(this.filterManager.effectElements[10].p.v===1||this.filterManager.effectElements[10].p.v===2){if(forceRender||this.filterManager.effectElements[3].p._mdf){var color=this.filterManager.effectElements[3].p.v;this.pathMasker.setAttribute('stroke','rgb('+bmFloor(color[0]*255)+','+bmFloor(color[1]*255)+','+bmFloor(color[2]*255)+')');}}};function SVGTritoneFilter(filter,filterManager,elem,id){this.filterManager=filterManager;var feColorMatrix=createNS('feColorMatrix');feColorMatrix.setAttribute('type','matrix');feColorMatrix.setAttribute('color-interpolation-filters','linearRGB');feColorMatrix.setAttribute('values','0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0');filter.appendChild(feColorMatrix);var feComponentTransfer=createNS('feComponentTransfer');feComponentTransfer.setAttribute('color-interpolation-filters','sRGB');feComponentTransfer.setAttribute('result',id);this.matrixFilter=feComponentTransfer;var feFuncR=createNS('feFuncR');feFuncR.setAttribute('type','table');feComponentTransfer.appendChild(feFuncR);this.feFuncR=feFuncR;var feFuncG=createNS('feFuncG');feFuncG.setAttribute('type','table');feComponentTransfer.appendChild(feFuncG);this.feFuncG=feFuncG;var feFuncB=createNS('feFuncB');feFuncB.setAttribute('type','table');feComponentTransfer.appendChild(feFuncB);this.feFuncB=feFuncB;filter.appendChild(feComponentTransfer);}SVGTritoneFilter.prototype.renderFrame=function(forceRender){if(forceRender||this.filterManager._mdf){var color1=this.filterManager.effectElements[0].p.v;var color2=this.filterManager.effectElements[1].p.v;var color3=this.filterManager.effectElements[2].p.v;var tableR=color3[0]+' '+color2[0]+' '+color1[0];var tableG=color3[1]+' '+color2[1]+' '+color1[1];var tableB=color3[2]+' '+color2[2]+' '+color1[2];this.feFuncR.setAttribute('tableValues',tableR);this.feFuncG.setAttribute('tableValues',tableG);this.feFuncB.setAttribute('tableValues',tableB);}};function SVGProLevelsFilter(filter,filterManager,elem,id){this.filterManager=filterManager;var effectElements=this.filterManager.effectElements;var feComponentTransfer=createNS('feComponentTransfer');// Red
	if(effectElements[10].p.k||effectElements[10].p.v!==0||effectElements[11].p.k||effectElements[11].p.v!==1||effectElements[12].p.k||effectElements[12].p.v!==1||effectElements[13].p.k||effectElements[13].p.v!==0||effectElements[14].p.k||effectElements[14].p.v!==1){this.feFuncR=this.createFeFunc('feFuncR',feComponentTransfer);}// Green
	if(effectElements[17].p.k||effectElements[17].p.v!==0||effectElements[18].p.k||effectElements[18].p.v!==1||effectElements[19].p.k||effectElements[19].p.v!==1||effectElements[20].p.k||effectElements[20].p.v!==0||effectElements[21].p.k||effectElements[21].p.v!==1){this.feFuncG=this.createFeFunc('feFuncG',feComponentTransfer);}// Blue
	if(effectElements[24].p.k||effectElements[24].p.v!==0||effectElements[25].p.k||effectElements[25].p.v!==1||effectElements[26].p.k||effectElements[26].p.v!==1||effectElements[27].p.k||effectElements[27].p.v!==0||effectElements[28].p.k||effectElements[28].p.v!==1){this.feFuncB=this.createFeFunc('feFuncB',feComponentTransfer);}// Alpha
	if(effectElements[31].p.k||effectElements[31].p.v!==0||effectElements[32].p.k||effectElements[32].p.v!==1||effectElements[33].p.k||effectElements[33].p.v!==1||effectElements[34].p.k||effectElements[34].p.v!==0||effectElements[35].p.k||effectElements[35].p.v!==1){this.feFuncA=this.createFeFunc('feFuncA',feComponentTransfer);}// RGB
	if(this.feFuncR||this.feFuncG||this.feFuncB||this.feFuncA){feComponentTransfer.setAttribute('color-interpolation-filters','sRGB');filter.appendChild(feComponentTransfer);}if(effectElements[3].p.k||effectElements[3].p.v!==0||effectElements[4].p.k||effectElements[4].p.v!==1||effectElements[5].p.k||effectElements[5].p.v!==1||effectElements[6].p.k||effectElements[6].p.v!==0||effectElements[7].p.k||effectElements[7].p.v!==1){feComponentTransfer=createNS('feComponentTransfer');feComponentTransfer.setAttribute('color-interpolation-filters','sRGB');feComponentTransfer.setAttribute('result',id);filter.appendChild(feComponentTransfer);this.feFuncRComposed=this.createFeFunc('feFuncR',feComponentTransfer);this.feFuncGComposed=this.createFeFunc('feFuncG',feComponentTransfer);this.feFuncBComposed=this.createFeFunc('feFuncB',feComponentTransfer);}}SVGProLevelsFilter.prototype.createFeFunc=function(type,feComponentTransfer){var feFunc=createNS(type);feFunc.setAttribute('type','table');feComponentTransfer.appendChild(feFunc);return feFunc;};SVGProLevelsFilter.prototype.getTableValue=function(inputBlack,inputWhite,gamma,outputBlack,outputWhite){var cnt=0;var segments=256;var perc;var min=Math.min(inputBlack,inputWhite);var max=Math.max(inputBlack,inputWhite);var table=Array.call(null,{length:segments});var colorValue;var pos=0;var outputDelta=outputWhite-outputBlack;var inputDelta=inputWhite-inputBlack;while(cnt<=256){perc=cnt/256;if(perc<=min){colorValue=inputDelta<0?outputWhite:outputBlack;}else if(perc>=max){colorValue=inputDelta<0?outputBlack:outputWhite;}else {colorValue=outputBlack+outputDelta*Math.pow((perc-inputBlack)/inputDelta,1/gamma);}table[pos]=colorValue;pos+=1;cnt+=256/(segments-1);}return table.join(' ');};SVGProLevelsFilter.prototype.renderFrame=function(forceRender){if(forceRender||this.filterManager._mdf){var val;var effectElements=this.filterManager.effectElements;if(this.feFuncRComposed&&(forceRender||effectElements[3].p._mdf||effectElements[4].p._mdf||effectElements[5].p._mdf||effectElements[6].p._mdf||effectElements[7].p._mdf)){val=this.getTableValue(effectElements[3].p.v,effectElements[4].p.v,effectElements[5].p.v,effectElements[6].p.v,effectElements[7].p.v);this.feFuncRComposed.setAttribute('tableValues',val);this.feFuncGComposed.setAttribute('tableValues',val);this.feFuncBComposed.setAttribute('tableValues',val);}if(this.feFuncR&&(forceRender||effectElements[10].p._mdf||effectElements[11].p._mdf||effectElements[12].p._mdf||effectElements[13].p._mdf||effectElements[14].p._mdf)){val=this.getTableValue(effectElements[10].p.v,effectElements[11].p.v,effectElements[12].p.v,effectElements[13].p.v,effectElements[14].p.v);this.feFuncR.setAttribute('tableValues',val);}if(this.feFuncG&&(forceRender||effectElements[17].p._mdf||effectElements[18].p._mdf||effectElements[19].p._mdf||effectElements[20].p._mdf||effectElements[21].p._mdf)){val=this.getTableValue(effectElements[17].p.v,effectElements[18].p.v,effectElements[19].p.v,effectElements[20].p.v,effectElements[21].p.v);this.feFuncG.setAttribute('tableValues',val);}if(this.feFuncB&&(forceRender||effectElements[24].p._mdf||effectElements[25].p._mdf||effectElements[26].p._mdf||effectElements[27].p._mdf||effectElements[28].p._mdf)){val=this.getTableValue(effectElements[24].p.v,effectElements[25].p.v,effectElements[26].p.v,effectElements[27].p.v,effectElements[28].p.v);this.feFuncB.setAttribute('tableValues',val);}if(this.feFuncA&&(forceRender||effectElements[31].p._mdf||effectElements[32].p._mdf||effectElements[33].p._mdf||effectElements[34].p._mdf||effectElements[35].p._mdf)){val=this.getTableValue(effectElements[31].p.v,effectElements[32].p.v,effectElements[33].p.v,effectElements[34].p.v,effectElements[35].p.v);this.feFuncA.setAttribute('tableValues',val);}}};function SVGDropShadowEffect(filter,filterManager,elem,id,source){var globalFilterSize=filterManager.container.globalData.renderConfig.filterSize;var filterSize=filterManager.data.fs||globalFilterSize;filter.setAttribute('x',filterSize.x||globalFilterSize.x);filter.setAttribute('y',filterSize.y||globalFilterSize.y);filter.setAttribute('width',filterSize.width||globalFilterSize.width);filter.setAttribute('height',filterSize.height||globalFilterSize.height);this.filterManager=filterManager;var feGaussianBlur=createNS('feGaussianBlur');feGaussianBlur.setAttribute('in','SourceAlpha');feGaussianBlur.setAttribute('result',id+'_drop_shadow_1');feGaussianBlur.setAttribute('stdDeviation','0');this.feGaussianBlur=feGaussianBlur;filter.appendChild(feGaussianBlur);var feOffset=createNS('feOffset');feOffset.setAttribute('dx','25');feOffset.setAttribute('dy','0');feOffset.setAttribute('in',id+'_drop_shadow_1');feOffset.setAttribute('result',id+'_drop_shadow_2');this.feOffset=feOffset;filter.appendChild(feOffset);var feFlood=createNS('feFlood');feFlood.setAttribute('flood-color','#00ff00');feFlood.setAttribute('flood-opacity','1');feFlood.setAttribute('result',id+'_drop_shadow_3');this.feFlood=feFlood;filter.appendChild(feFlood);var feComposite=createNS('feComposite');feComposite.setAttribute('in',id+'_drop_shadow_3');feComposite.setAttribute('in2',id+'_drop_shadow_2');feComposite.setAttribute('operator','in');feComposite.setAttribute('result',id+'_drop_shadow_4');filter.appendChild(feComposite);var feMerge=this.createMergeNode(id,[id+'_drop_shadow_4',source]);filter.appendChild(feMerge);//
	}extendPrototype([SVGComposableEffect],SVGDropShadowEffect);SVGDropShadowEffect.prototype.renderFrame=function(forceRender){if(forceRender||this.filterManager._mdf){if(forceRender||this.filterManager.effectElements[4].p._mdf){this.feGaussianBlur.setAttribute('stdDeviation',this.filterManager.effectElements[4].p.v/4);}if(forceRender||this.filterManager.effectElements[0].p._mdf){var col=this.filterManager.effectElements[0].p.v;this.feFlood.setAttribute('flood-color',rgbToHex(Math.round(col[0]*255),Math.round(col[1]*255),Math.round(col[2]*255)));}if(forceRender||this.filterManager.effectElements[1].p._mdf){this.feFlood.setAttribute('flood-opacity',this.filterManager.effectElements[1].p.v/255);}if(forceRender||this.filterManager.effectElements[2].p._mdf||this.filterManager.effectElements[3].p._mdf){var distance=this.filterManager.effectElements[3].p.v;var angle=(this.filterManager.effectElements[2].p.v-90)*degToRads;var x=distance*Math.cos(angle);var y=distance*Math.sin(angle);this.feOffset.setAttribute('dx',x);this.feOffset.setAttribute('dy',y);}}};var _svgMatteSymbols=[];function SVGMatte3Effect(filterElem,filterManager,elem){this.initialized=false;this.filterManager=filterManager;this.filterElem=filterElem;this.elem=elem;elem.matteElement=createNS('g');elem.matteElement.appendChild(elem.layerElement);elem.matteElement.appendChild(elem.transformedElement);elem.baseElement=elem.matteElement;}SVGMatte3Effect.prototype.findSymbol=function(mask){var i=0;var len=_svgMatteSymbols.length;while(i<len){if(_svgMatteSymbols[i]===mask){return _svgMatteSymbols[i];}i+=1;}return null;};SVGMatte3Effect.prototype.replaceInParent=function(mask,symbolId){var parentNode=mask.layerElement.parentNode;if(!parentNode){return;}var children=parentNode.children;var i=0;var len=children.length;while(i<len){if(children[i]===mask.layerElement){break;}i+=1;}var nextChild;if(i<=len-2){nextChild=children[i+1];}var useElem=createNS('use');useElem.setAttribute('href','#'+symbolId);if(nextChild){parentNode.insertBefore(useElem,nextChild);}else {parentNode.appendChild(useElem);}};SVGMatte3Effect.prototype.setElementAsMask=function(elem,mask){if(!this.findSymbol(mask)){var symbolId=createElementID();var masker=createNS('mask');masker.setAttribute('id',mask.layerId);masker.setAttribute('mask-type','alpha');_svgMatteSymbols.push(mask);var defs=elem.globalData.defs;defs.appendChild(masker);var symbol=createNS('symbol');symbol.setAttribute('id',symbolId);this.replaceInParent(mask,symbolId);symbol.appendChild(mask.layerElement);defs.appendChild(symbol);var useElem=createNS('use');useElem.setAttribute('href','#'+symbolId);masker.appendChild(useElem);mask.data.hd=false;mask.show();}elem.setMatte(mask.layerId);};SVGMatte3Effect.prototype.initialize=function(){var ind=this.filterManager.effectElements[0].p.v;var elements=this.elem.comp.elements;var i=0;var len=elements.length;while(i<len){if(elements[i]&&elements[i].data.ind===ind){this.setElementAsMask(this.elem,elements[i]);}i+=1;}this.initialized=true;};SVGMatte3Effect.prototype.renderFrame=function(){if(!this.initialized){this.initialize();}};function SVGGaussianBlurEffect(filter,filterManager,elem,id){// Outset the filter region by 100% on all sides to accommodate blur expansion.
	filter.setAttribute('x','-100%');filter.setAttribute('y','-100%');filter.setAttribute('width','300%');filter.setAttribute('height','300%');this.filterManager=filterManager;var feGaussianBlur=createNS('feGaussianBlur');feGaussianBlur.setAttribute('result',id);filter.appendChild(feGaussianBlur);this.feGaussianBlur=feGaussianBlur;}SVGGaussianBlurEffect.prototype.renderFrame=function(forceRender){if(forceRender||this.filterManager._mdf){// Empirical value, matching AE's blur appearance.
	var kBlurrinessToSigma=0.3;var sigma=this.filterManager.effectElements[0].p.v*kBlurrinessToSigma;// Dimensions mapping:
	//
	//   1 -> horizontal & vertical
	//   2 -> horizontal only
	//   3 -> vertical only
	//
	var dimensions=this.filterManager.effectElements[1].p.v;var sigmaX=dimensions==3?0:sigma;// eslint-disable-line eqeqeq
	var sigmaY=dimensions==2?0:sigma;// eslint-disable-line eqeqeq
	this.feGaussianBlur.setAttribute('stdDeviation',sigmaX+' '+sigmaY);// Repeat edges mapping:
	//
	//   0 -> off -> duplicate
	//   1 -> on  -> wrap
	var edgeMode=this.filterManager.effectElements[2].p.v==1?'wrap':'duplicate';// eslint-disable-line eqeqeq
	this.feGaussianBlur.setAttribute('edgeMode',edgeMode);}};function TransformEffect(){}TransformEffect.prototype.init=function(effectsManager){this.effectsManager=effectsManager;this.type=effectTypes.TRANSFORM_EFFECT;this.matrix=new Matrix();this.opacity=-1;this._mdf=false;this._opMdf=false;};TransformEffect.prototype.renderFrame=function(forceFrame){this._opMdf=false;this._mdf=false;if(forceFrame||this.effectsManager._mdf){var effectElements=this.effectsManager.effectElements;var anchor=effectElements[0].p.v;var position=effectElements[1].p.v;var isUniformScale=effectElements[2].p.v===1;var scaleHeight=effectElements[3].p.v;var scaleWidth=isUniformScale?scaleHeight:effectElements[4].p.v;var skew=effectElements[5].p.v;var skewAxis=effectElements[6].p.v;var rotation=effectElements[7].p.v;this.matrix.reset();this.matrix.translate(-anchor[0],-anchor[1],anchor[2]);this.matrix.scale(scaleWidth*0.01,scaleHeight*0.01,1);this.matrix.rotate(-rotation*degToRads);this.matrix.skewFromAxis(-skew*degToRads,(skewAxis+90)*degToRads);this.matrix.translate(position[0],position[1],0);this._mdf=true;if(this.opacity!==effectElements[8].p.v){this.opacity=effectElements[8].p.v;this._opMdf=true;}}};function SVGTransformEffect(_,filterManager){this.init(filterManager);}extendPrototype([TransformEffect],SVGTransformEffect);function CVTransformEffect(effectsManager){this.init(effectsManager);}extendPrototype([TransformEffect],CVTransformEffect);registerRenderer('canvas',CanvasRenderer);registerRenderer('html',HybridRenderer);registerRenderer('svg',SVGRenderer);// Registering shape modifiers
	ShapeModifiers.registerModifier('tm',TrimModifier);ShapeModifiers.registerModifier('pb',PuckerAndBloatModifier);ShapeModifiers.registerModifier('rp',RepeaterModifier);ShapeModifiers.registerModifier('rd',RoundCornersModifier);ShapeModifiers.registerModifier('zz',ZigZagModifier);ShapeModifiers.registerModifier('op',OffsetPathModifier);// Registering expression plugin
	setExpressionsPlugin(Expressions);setExpressionInterfaces(getInterface);initialize$1();initialize();// Registering svg effects
	registerEffect$1(20,SVGTintFilter,true);registerEffect$1(21,SVGFillFilter,true);registerEffect$1(22,SVGStrokeEffect,false);registerEffect$1(23,SVGTritoneFilter,true);registerEffect$1(24,SVGProLevelsFilter,true);registerEffect$1(25,SVGDropShadowEffect,true);registerEffect$1(28,SVGMatte3Effect,false);registerEffect$1(29,SVGGaussianBlurEffect,true);registerEffect$1(35,SVGTransformEffect,false);registerEffect(35,CVTransformEffect);return lottie;});
} (lottie, lottie.exports));

Object.defineProperty(dist$1, "__esModule", {
  value: true
});
var _extends2 = _extends;
var _extends3 = _interopRequireDefault$2(_extends2);
var _getPrototypeOf = getPrototypeOf$2.exports;
var _getPrototypeOf2 = _interopRequireDefault$2(_getPrototypeOf);
var _classCallCheck2 = classCallCheck;
var _classCallCheck3 = _interopRequireDefault$2(_classCallCheck2);
var _createClass2 = createClass;
var _createClass3 = _interopRequireDefault$2(_createClass2);
var _possibleConstructorReturn2 = possibleConstructorReturn;
var _possibleConstructorReturn3 = _interopRequireDefault$2(_possibleConstructorReturn2);
var _inherits2 = inherits;
var _inherits3 = _interopRequireDefault$2(_inherits2);
var _react = React__default;
var _react2 = _interopRequireDefault$2(_react);
var _propTypes = PropTypes;
var _propTypes2 = _interopRequireDefault$2(_propTypes);
var _lottieWeb = lottie.exports;
var _lottieWeb2 = _interopRequireDefault$2(_lottieWeb);
function _interopRequireDefault$2(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Lottie = function (_React$Component) {
  (0, _inherits3.default)(Lottie, _React$Component);
  function Lottie() {
    var _ref;
    var _temp, _this, _ret;
    (0, _classCallCheck3.default)(this, Lottie);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Lottie.__proto__ || (0, _getPrototypeOf2.default)(Lottie)).call.apply(_ref, [this].concat(args))), _this), _this.handleClickToPause = function () {
      // The pause() method is for handling pausing by passing a prop isPaused
      // This method is for handling the ability to pause by clicking on the animation
      if (_this.anim.isPaused) {
        _this.anim.play();
      } else {
        _this.anim.pause();
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }
  (0, _createClass3.default)(Lottie, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
        options = _props.options,
        eventListeners = _props.eventListeners;
      var loop = options.loop,
        autoplay = options.autoplay,
        animationData = options.animationData,
        rendererSettings = options.rendererSettings,
        segments = options.segments;
      this.options = {
        container: this.el,
        renderer: 'svg',
        loop: loop !== false,
        autoplay: autoplay !== false,
        segments: segments !== false,
        animationData: animationData,
        rendererSettings: rendererSettings
      };
      this.options = (0, _extends3.default)({}, this.options, options);
      this.anim = _lottieWeb2.default.loadAnimation(this.options);
      this.registerEvents(eventListeners);
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps /* , nextState */) {
      /* Recreate the animation handle if the data is changed */
      if (this.options.animationData !== nextProps.options.animationData) {
        this.deRegisterEvents(this.props.eventListeners);
        this.destroy();
        this.options = (0, _extends3.default)({}, this.options, nextProps.options);
        this.anim = _lottieWeb2.default.loadAnimation(this.options);
        this.registerEvents(nextProps.eventListeners);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.isStopped) {
        this.stop();
      } else if (this.props.segments) {
        this.playSegments();
      } else {
        this.play();
      }
      this.pause();
      this.setSpeed();
      this.setDirection();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.deRegisterEvents(this.props.eventListeners);
      this.destroy();
      this.options.animationData = null;
      this.anim = null;
    }
  }, {
    key: 'setSpeed',
    value: function setSpeed() {
      this.anim.setSpeed(this.props.speed);
    }
  }, {
    key: 'setDirection',
    value: function setDirection() {
      this.anim.setDirection(this.props.direction);
    }
  }, {
    key: 'play',
    value: function play() {
      this.anim.play();
    }
  }, {
    key: 'playSegments',
    value: function playSegments() {
      this.anim.playSegments(this.props.segments);
    }
  }, {
    key: 'stop',
    value: function stop() {
      this.anim.stop();
    }
  }, {
    key: 'pause',
    value: function pause() {
      if (this.props.isPaused && !this.anim.isPaused) {
        this.anim.pause();
      } else if (!this.props.isPaused && this.anim.isPaused) {
        this.anim.pause();
      }
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.anim.destroy();
    }
  }, {
    key: 'registerEvents',
    value: function registerEvents(eventListeners) {
      var _this2 = this;
      eventListeners.forEach(function (eventListener) {
        _this2.anim.addEventListener(eventListener.eventName, eventListener.callback);
      });
    }
  }, {
    key: 'deRegisterEvents',
    value: function deRegisterEvents(eventListeners) {
      var _this3 = this;
      eventListeners.forEach(function (eventListener) {
        _this3.anim.removeEventListener(eventListener.eventName, eventListener.callback);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;
      var _props2 = this.props,
        width = _props2.width,
        height = _props2.height,
        ariaRole = _props2.ariaRole,
        ariaLabel = _props2.ariaLabel,
        isClickToPauseDisabled = _props2.isClickToPauseDisabled,
        title = _props2.title;
      var getSize = function getSize(initial) {
        var size = void 0;
        if (typeof initial === 'number') {
          size = initial + 'px';
        } else {
          size = initial || '100%';
        }
        return size;
      };
      var lottieStyles = (0, _extends3.default)({
        width: getSize(width),
        height: getSize(height),
        overflow: 'hidden',
        margin: '0 auto',
        outline: 'none'
      }, this.props.style);
      var onClickHandler = isClickToPauseDisabled ? function () {
        return null;
      } : this.handleClickToPause;
      return (
        // Bug with eslint rules https://github.com/airbnb/javascript/issues/1374
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions
        _react2.default.createElement('div', {
          ref: function ref(c) {
            _this4.el = c;
          },
          style: lottieStyles,
          onClick: onClickHandler,
          title: title,
          role: ariaRole,
          'aria-label': ariaLabel,
          tabIndex: '0'
        })
      );
    }
  }]);
  return Lottie;
}(_react2.default.Component);
var _default$1 = dist$1.default = Lottie;
Lottie.propTypes = {
  eventListeners: _propTypes2.default.arrayOf(_propTypes2.default.object),
  options: _propTypes2.default.object.isRequired,
  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  isStopped: _propTypes2.default.bool,
  isPaused: _propTypes2.default.bool,
  speed: _propTypes2.default.number,
  segments: _propTypes2.default.arrayOf(_propTypes2.default.number),
  direction: _propTypes2.default.number,
  ariaRole: _propTypes2.default.string,
  ariaLabel: _propTypes2.default.string,
  isClickToPauseDisabled: _propTypes2.default.bool,
  title: _propTypes2.default.string,
  style: _propTypes2.default.string
};
Lottie.defaultProps = {
  eventListeners: [],
  isStopped: false,
  isPaused: false,
  speed: 1,
  ariaRole: 'button',
  ariaLabel: 'animation',
  isClickToPauseDisabled: false,
  title: ''
};

var v$7 = "5.7.8";
var fr$2 = 25;
var ip$2 = 0;
var op$2 = 200;
var w$6 = 800;
var h$7 = 800;
var nm$2 = "Ani_0020";
var ddd$2 = 0;
var assets$2 = [
	{
		id: "comp_0",
		layers: [
			{
				ddd: 0,
				ind: 1,
				ty: 4,
				nm: "sound mic 3",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.436,
									y: 1
								},
								o: {
									x: 0.506,
									y: 0
								},
								t: 58,
								s: [
									400,
									391,
									0
								],
								to: [
									0,
									-2.667,
									0
								],
								ti: [
									0,
									2.667,
									0
								]
							},
							{
								t: 68,
								s: [
									400,
									375,
									0
								]
							}
						],
						ix: 2,
						l: 2
					},
					a: {
						a: 0,
						k: [
							8,
							-36,
							0
						],
						ix: 1,
						l: 2
					},
					s: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.436,
										0.436,
										0.667
									],
									y: [
										1,
										1,
										1
									]
								},
								o: {
									x: [
										0.506,
										0.506,
										0.333
									],
									y: [
										0,
										0,
										0
									]
								},
								t: 58,
								s: [
									73.377,
									73.377,
									100
								]
							},
							{
								t: 68,
								s: [
									41.377,
									41.377,
									100
								]
							}
						],
						ix: 6,
						l: 2
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								d: 1,
								ty: "el",
								s: {
									a: 0,
									k: [
										616,
										616
									],
									ix: 2
								},
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 3
								},
								nm: "Ellipse Path 1",
								mn: "ADBE Vector Shape - Ellipse",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.149019996793,
										0.345097979377,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 1,
									k: [
										{
											i: {
												x: [
													0.667
												],
												y: [
													1
												]
											},
											o: {
												x: [
													0.679
												],
												y: [
													0
												]
											},
											t: 58,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.206
												],
												y: [
													1
												]
											},
											o: {
												x: [
													0.333
												],
												y: [
													0
												]
											},
											t: 64,
											s: [
												47.2
											]
										},
										{
											t: 68,
											s: [
												0
											]
										}
									],
									ix: 5
								},
								lc: 2,
								lj: 1,
								ml: 4,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										8,
										-105
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										62,
										62
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Ellipse 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 0,
							k: 25,
							ix: 1
						},
						e: {
							a: 0,
							k: 75,
							ix: 2
						},
						o: {
							a: 0,
							k: 180,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					}
				],
				ip: 0,
				op: 200,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 2,
				ty: 4,
				nm: "sound mic 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.436,
									y: 1
								},
								o: {
									x: 0.506,
									y: 0
								},
								t: 52,
								s: [
									400,
									391,
									0
								],
								to: [
									0,
									-2.667,
									0
								],
								ti: [
									0,
									2.667,
									0
								]
							},
							{
								t: 62,
								s: [
									400,
									375,
									0
								]
							}
						],
						ix: 2,
						l: 2
					},
					a: {
						a: 0,
						k: [
							8,
							-36,
							0
						],
						ix: 1,
						l: 2
					},
					s: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.436,
										0.436,
										0.667
									],
									y: [
										1,
										1,
										1
									]
								},
								o: {
									x: [
										0.506,
										0.506,
										0.333
									],
									y: [
										0,
										0,
										0
									]
								},
								t: 52,
								s: [
									73.377,
									73.377,
									100
								]
							},
							{
								t: 62,
								s: [
									41.377,
									41.377,
									100
								]
							}
						],
						ix: 6,
						l: 2
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								d: 1,
								ty: "el",
								s: {
									a: 0,
									k: [
										616,
										616
									],
									ix: 2
								},
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 3
								},
								nm: "Ellipse Path 1",
								mn: "ADBE Vector Shape - Ellipse",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.149019996793,
										0.345097979377,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 1,
									k: [
										{
											i: {
												x: [
													0.667
												],
												y: [
													1
												]
											},
											o: {
												x: [
													0.679
												],
												y: [
													0
												]
											},
											t: 52,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.206
												],
												y: [
													1
												]
											},
											o: {
												x: [
													0.333
												],
												y: [
													0
												]
											},
											t: 56,
											s: [
												47.2
											]
										},
										{
											t: 62,
											s: [
												0
											]
										}
									],
									ix: 5
								},
								lc: 2,
								lj: 1,
								ml: 4,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										8,
										-105
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										62,
										62
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Ellipse 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 0,
							k: 25,
							ix: 1
						},
						e: {
							a: 0,
							k: 75,
							ix: 2
						},
						o: {
							a: 0,
							k: 180,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					}
				],
				ip: 0,
				op: 200,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 3,
				ty: 4,
				nm: "sound mic",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.436,
									y: 1
								},
								o: {
									x: 0.506,
									y: 0
								},
								t: 50,
								s: [
									400,
									391,
									0
								],
								to: [
									0,
									-2.667,
									0
								],
								ti: [
									0,
									2.667,
									0
								]
							},
							{
								t: 58,
								s: [
									400,
									375,
									0
								]
							}
						],
						ix: 2,
						l: 2
					},
					a: {
						a: 0,
						k: [
							8,
							-36,
							0
						],
						ix: 1,
						l: 2
					},
					s: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.436,
										0.436,
										0.667
									],
									y: [
										1,
										1,
										1
									]
								},
								o: {
									x: [
										0.506,
										0.506,
										0.333
									],
									y: [
										0,
										0,
										0
									]
								},
								t: 50,
								s: [
									73.377,
									73.377,
									100
								]
							},
							{
								t: 58,
								s: [
									41.377,
									41.377,
									100
								]
							}
						],
						ix: 6,
						l: 2
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								d: 1,
								ty: "el",
								s: {
									a: 0,
									k: [
										616,
										616
									],
									ix: 2
								},
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 3
								},
								nm: "Ellipse Path 1",
								mn: "ADBE Vector Shape - Ellipse",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.149019996793,
										0.345097979377,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 1,
									k: [
										{
											i: {
												x: [
													0.667
												],
												y: [
													1
												]
											},
											o: {
												x: [
													0.679
												],
												y: [
													0
												]
											},
											t: 50,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.206
												],
												y: [
													1
												]
											},
											o: {
												x: [
													0.333
												],
												y: [
													0
												]
											},
											t: 54,
											s: [
												47.2
											]
										},
										{
											t: 58,
											s: [
												0
											]
										}
									],
									ix: 5
								},
								lc: 2,
								lj: 1,
								ml: 4,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										8,
										-105
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										62,
										62
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Ellipse 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 0,
							k: 25,
							ix: 1
						},
						e: {
							a: 0,
							k: 75,
							ix: 2
						},
						o: {
							a: 0,
							k: 180,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					}
				],
				ip: 0,
				op: 200,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 4,
				ty: 4,
				nm: "headband Outlines",
				sr: 1,
				ks: {
					o: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.833
									],
									y: [
										0.833
									]
								},
								o: {
									x: [
										0.167
									],
									y: [
										0.167
									]
								},
								t: 148,
								s: [
									0
								]
							},
							{
								t: 149,
								s: [
									100
								]
							}
						],
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							400,
							352.54,
							0
						],
						ix: 2,
						l: 2
					},
					a: {
						a: 0,
						k: [
							159.084,
							111.624,
							0
						],
						ix: 1,
						l: 2
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6,
						l: 2
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-80.923,
												0
											],
											[
												0,
												-80.924
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												-80.924
											],
											[
												80.924,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-146.524,
												99.065
											],
											[
												-146.524,
												47.46
											],
											[
												0.001,
												-99.065
											],
											[
												146.525,
												47.46
											],
											[
												146.525,
												99.065
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.682352941176,
										0.607843137255,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 1,
									k: [
										{
											i: {
												x: [
													0.667
												],
												y: [
													1
												]
											},
											o: {
												x: [
													1
												],
												y: [
													0
												]
											},
											t: 183,
											s: [
												19.226
											]
										},
										{
											t: 197,
											s: [
												0
											]
										}
									],
									ix: 5
								},
								lc: 2,
								lj: 1,
								ml: 2.61,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										159.084,
										111.624
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 200,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 5,
				ty: 4,
				nm: "left speaker Outlines",
				sr: 1,
				ks: {
					o: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.833
									],
									y: [
										0.833
									]
								},
								o: {
									x: [
										0.167
									],
									y: [
										0.167
									]
								},
								t: 148,
								s: [
									0
								]
							},
							{
								t: 149,
								s: [
									100
								]
							}
						],
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							295.544,
							448.944,
							0
						],
						ix: 2,
						l: 2
					},
					a: {
						a: 0,
						k: [
							29.714,
							59.292,
							0
						],
						ix: 1,
						l: 2
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6,
						l: 2
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												-9.436,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-9.434
											],
											[
												0,
												0
											],
											[
												9.436,
												0
											],
											[
												0,
												9.435
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												9.436,
												0
											],
											[
												0,
												0
											],
											[
												0,
												9.435
											],
											[
												-9.436,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-9.434
											]
										],
										v: [
											[
												0,
												-46.733
											],
											[
												0,
												-46.733
											],
											[
												17.155,
												-29.579
											],
											[
												17.155,
												29.578
											],
											[
												0,
												46.733
											],
											[
												-17.155,
												29.578
											],
											[
												-17.155,
												-29.579
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.682352941176,
										0.607843137255,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 1,
									k: [
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 151,
											s: [
												19.226
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 152,
											s: [
												26
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 153,
											s: [
												19.226
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 165,
											s: [
												19.226
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 166,
											s: [
												26
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 167,
											s: [
												19.226
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 179,
											s: [
												19.226
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 180,
											s: [
												26
											]
										},
										{
											t: 181,
											s: [
												19.226
											]
										}
									],
									ix: 5
								},
								lc: 2,
								lj: 1,
								ml: 2.61,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										29.714,
										59.292
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.667
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.333
										],
										y: [
											0
										]
									},
									t: 183,
									s: [
										0
									]
								},
								{
									t: 193,
									s: [
										100
									]
								}
							],
							ix: 1
						},
						e: {
							a: 0,
							k: 100,
							ix: 2
						},
						o: {
							a: 0,
							k: 0,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					}
				],
				ip: 0,
				op: 200,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 6,
				ty: 4,
				nm: "right speaker Outlines",
				sr: 1,
				ks: {
					o: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.833
									],
									y: [
										0.833
									]
								},
								o: {
									x: [
										0.167
									],
									y: [
										0.167
									]
								},
								t: 148,
								s: [
									0
								]
							},
							{
								t: 149,
								s: [
									100
								]
							}
						],
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							504.457,
							448.944,
							0
						],
						ix: 2,
						l: 2
					},
					a: {
						a: 0,
						k: [
							29.714,
							59.292,
							0
						],
						ix: 1,
						l: 2
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6,
						l: 2
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												-9.435,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-9.434
											],
											[
												0,
												0
											],
											[
												9.435,
												0
											],
											[
												0,
												0
											],
											[
												0,
												9.435
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												9.435,
												0
											],
											[
												0,
												0
											],
											[
												0,
												9.435
											],
											[
												0,
												0
											],
											[
												-9.435,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-9.434
											]
										],
										v: [
											[
												0,
												-46.733
											],
											[
												0,
												-46.733
											],
											[
												17.155,
												-29.579
											],
											[
												17.155,
												29.578
											],
											[
												0,
												46.733
											],
											[
												0,
												46.733
											],
											[
												-17.155,
												29.578
											],
											[
												-17.155,
												-29.579
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.682352941176,
										0.607843137255,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 1,
									k: [
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 151,
											s: [
												19.226
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 152,
											s: [
												26
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 153,
											s: [
												19.226
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 165,
											s: [
												19.226
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 166,
											s: [
												26
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 167,
											s: [
												19.226
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 179,
											s: [
												19.226
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 180,
											s: [
												26
											]
										},
										{
											t: 181,
											s: [
												19.226
											]
										}
									],
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										29.714,
										59.292
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 0,
							k: 0,
							ix: 1
						},
						e: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.667
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.333
										],
										y: [
											0
										]
									},
									t: 183,
									s: [
										100
									]
								},
								{
									t: 193,
									s: [
										0
									]
								}
							],
							ix: 2
						},
						o: {
							a: 0,
							k: 0,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					}
				],
				ip: 0,
				op: 200,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 7,
				ty: 4,
				nm: "circle thin Outlines",
				parent: 18,
				sr: 1,
				ks: {
					o: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.833
									],
									y: [
										0.833
									]
								},
								o: {
									x: [
										0.167
									],
									y: [
										0.167
									]
								},
								t: 89.117,
								s: [
									0
								]
							},
							{
								i: {
									x: [
										0.833
									],
									y: [
										0.833
									]
								},
								o: {
									x: [
										0.167
									],
									y: [
										0.167
									]
								},
								t: 90,
								s: [
									100
								]
							},
							{
								i: {
									x: [
										0.833
									],
									y: [
										0.833
									]
								},
								o: {
									x: [
										0.167
									],
									y: [
										0.167
									]
								},
								t: 148,
								s: [
									100
								]
							},
							{
								t: 149,
								s: [
									0
								]
							}
						],
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							83.606,
							90.313,
							0
						],
						ix: 2,
						l: 2
					},
					a: {
						a: 0,
						k: [
							27.675,
							27.674,
							0
						],
						ix: 1,
						l: 2
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6,
						l: 2
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 1,
									k: [
										{
											i: {
												x: 0,
												y: 1
											},
											o: {
												x: 0.831,
												y: 0
											},
											t: 125,
											s: [
												{
													i: [
														[
															-11.562,
															0
														],
														[
															0,
															-11.561
														],
														[
															0.018,
															-0.358
														],
														[
															11.198,
															0
														],
														[
															0.594,
															11.029
														],
														[
															0,
															0.384
														]
													],
													o: [
														[
															11.561,
															0
														],
														[
															0,
															0.363
														],
														[
															-0.563,
															11.06
														],
														[
															-11.178,
															0
														],
														[
															-0.02,
															-0.379
														],
														[
															0,
															-11.561
														]
													],
													v: [
														[
															0,
															-20.934
														],
														[
															20.934,
															0
														],
														[
															20.907,
															1.081
														],
														[
															0,
															20.934
														],
														[
															-20.903,
															1.145
														],
														[
															-20.934,
															0
														]
													],
													c: true
												}
											]
										},
										{
											t: 144,
											s: [
												{
													i: [
														[
															-11.562,
															0
														],
														[
															0,
															-11.561
														],
														[
															0.018,
															-0.358
														],
														[
															11.198,
															0
														],
														[
															0.594,
															11.029
														],
														[
															0,
															0.384
														]
													],
													o: [
														[
															11.561,
															0
														],
														[
															0,
															0.363
														],
														[
															-0.563,
															11.06
														],
														[
															-11.178,
															0
														],
														[
															-0.02,
															-0.379
														],
														[
															0,
															-11.561
														]
													],
													v: [
														[
															-57.628,
															-5.684
														],
														[
															-40.194,
															15.263
														],
														[
															-40.346,
															67.219
														],
														[
															-57.753,
															87.059
														],
														[
															-74.406,
															67.327
														],
														[
															-74.312,
															15.307
														]
													],
													c: true
												}
											]
										}
									],
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 1,
									k: [
										{
											i: {
												x: [
													0
												],
												y: [
													1
												]
											},
											o: {
												x: [
													0.831
												],
												y: [
													0
												]
											},
											t: 125,
											s: [
												10.319
											]
										},
										{
											t: 144,
											s: [
												19.1
											]
										}
									],
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 2.61,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										27.675,
										27.674
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 200,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 8,
				ty: 4,
				nm: "circle thick Outlines",
				parent: 18,
				sr: 1,
				ks: {
					o: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.833
									],
									y: [
										0.833
									]
								},
								o: {
									x: [
										0.167
									],
									y: [
										0.167
									]
								},
								t: 89.117,
								s: [
									0
								]
							},
							{
								i: {
									x: [
										0.833
									],
									y: [
										0.833
									]
								},
								o: {
									x: [
										0.167
									],
									y: [
										0.167
									]
								},
								t: 90,
								s: [
									100
								]
							},
							{
								i: {
									x: [
										0.833
									],
									y: [
										0.833
									]
								},
								o: {
									x: [
										0.167
									],
									y: [
										0.167
									]
								},
								t: 148,
								s: [
									100
								]
							},
							{
								t: 149,
								s: [
									0
								]
							}
						],
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							177.012,
							90.312,
							0
						],
						ix: 2,
						l: 2
					},
					a: {
						a: 0,
						k: [
							37.876,
							37.876,
							0
						],
						ix: 1,
						l: 2
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6,
						l: 2
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 1,
									k: [
										{
											i: {
												x: 0,
												y: 1
											},
											o: {
												x: 0.831,
												y: 0
											},
											t: 125,
											s: [
												{
													i: [
														[
															-14.004,
															0
														],
														[
															0,
															-14.003
														],
														[
															0.017,
															-0.38
														],
														[
															13.62,
															0
														],
														[
															0.535,
															13.531
														],
														[
															0,
															0.342
														]
													],
													o: [
														[
															14.004,
															0
														],
														[
															0,
															0.384
														],
														[
															-0.6,
															13.472
														],
														[
															-13.662,
															0
														],
														[
															-0.013,
															-0.338
														],
														[
															0,
															-14.003
														]
													],
													v: [
														[
															0,
															-25.356
														],
														[
															25.356,
															0
														],
														[
															25.331,
															1.147
														],
														[
															0,
															25.356
														],
														[
															-25.336,
															1.02
														],
														[
															-25.356,
															0
														]
													],
													c: true
												}
											]
										},
										{
											t: 144,
											s: [
												{
													i: [
														[
															-14.004,
															0
														],
														[
															0,
															-14.003
														],
														[
															0.012,
															-0.38
														],
														[
															13.62,
															0
														],
														[
															-0.117,
															12.37
														],
														[
															0,
															0.342
														]
													],
													o: [
														[
															14.004,
															0
														],
														[
															0,
															0.384
														],
														[
															-0.409,
															12.492
														],
														[
															-13.662,
															0
														],
														[
															0.003,
															-0.339
														],
														[
															0,
															-14.003
														]
													],
													v: [
														[
															57.875,
															-5.981
														],
														[
															75.106,
															19.379
														],
														[
															74.831,
															62.276
														],
														[
															57.625,
															86.481
														],
														[
															40.039,
															62.148
														],
														[
															40.269,
															19.357
														]
													],
													c: true
												}
											]
										}
									],
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 19.165,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 2.61,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										37.876,
										37.876
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 200,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 9,
				ty: 0,
				nm: "sound 1",
				refId: "comp_1",
				sr: 1,
				ks: {
					o: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.833
									],
									y: [
										0.833
									]
								},
								o: {
									x: [
										0.167
									],
									y: [
										0.167
									]
								},
								t: 161,
								s: [
									0
								]
							},
							{
								i: {
									x: [
										0.833
									],
									y: [
										0.833
									]
								},
								o: {
									x: [
										0.167
									],
									y: [
										0.167
									]
								},
								t: 162,
								s: [
									100
								]
							},
							{
								i: {
									x: [
										0.833
									],
									y: [
										0.833
									]
								},
								o: {
									x: [
										0.167
									],
									y: [
										0.167
									]
								},
								t: 196,
								s: [
									100
								]
							},
							{
								t: 197,
								s: [
									0
								]
							}
						],
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.667,
									y: 1
								},
								o: {
									x: 1,
									y: 0
								},
								t: 183,
								s: [
									400,
									449.5,
									0
								],
								to: [
									0,
									-8,
									0
								],
								ti: [
									0,
									8,
									0
								]
							},
							{
								t: 197,
								s: [
									400,
									401.5,
									0
								]
							}
						],
						ix: 2,
						l: 2
					},
					a: {
						a: 0,
						k: [
							400,
							400,
							0
						],
						ix: 1,
						l: 2
					},
					s: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.667,
										0.667,
										0.667
									],
									y: [
										1,
										1,
										1
									]
								},
								o: {
									x: [
										1,
										1,
										0.333
									],
									y: [
										0,
										0,
										0
									]
								},
								t: 183,
								s: [
									50,
									50,
									100
								]
							},
							{
								t: 197,
								s: [
									100,
									100,
									100
								]
							}
						],
						ix: 6,
						l: 2
					}
				},
				ao: 0,
				w: 800,
				h: 800,
				ip: 0,
				op: 200,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 10,
				ty: 4,
				nm: "line up 3",
				sr: 1,
				ks: {
					o: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.833
									],
									y: [
										0.833
									]
								},
								o: {
									x: [
										0.167
									],
									y: [
										0.167
									]
								},
								t: 138,
								s: [
									0
								]
							},
							{
								i: {
									x: [
										0.833
									],
									y: [
										0.833
									]
								},
								o: {
									x: [
										0.167
									],
									y: [
										0.167
									]
								},
								t: 139,
								s: [
									100
								]
							},
							{
								i: {
									x: [
										0.833
									],
									y: [
										0.833
									]
								},
								o: {
									x: [
										0.167
									],
									y: [
										0.167
									]
								},
								t: 161,
								s: [
									100
								]
							},
							{
								t: 162,
								s: [
									0
								]
							}
						],
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0,
									y: 1
								},
								o: {
									x: 0.333,
									y: 0
								},
								t: 139,
								s: [
									400.5,
									400.5,
									0
								],
								to: [
									-10.083,
									8.417,
									0
								],
								ti: [
									10.083,
									-8.417,
									0
								]
							},
							{
								t: 161,
								s: [
									340,
									451,
									0
								]
							}
						],
						ix: 2,
						l: 2
					},
					a: {
						a: 0,
						k: [
							0.5,
							0.5,
							0
						],
						ix: 1,
						l: 2
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6,
						l: 2
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												36.5,
												96.5
											],
											[
												36.5,
												-95.5
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 1,
									k: [
										{
											i: {
												x: [
													0
												],
												y: [
													1
												]
											},
											o: {
												x: [
													0.333
												],
												y: [
													0
												]
											},
											t: 139,
											s: [
												19.2
											]
										},
										{
											t: 161,
											s: [
												9
											]
										}
									],
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										-36,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Shape 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.333
										],
										y: [
											0
										]
									},
									t: 139,
									s: [
										0
									]
								},
								{
									t: 161,
									s: [
										41
									]
								}
							],
							ix: 1
						},
						e: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.333
										],
										y: [
											0
										]
									},
									t: 139,
									s: [
										100
									]
								},
								{
									t: 161,
									s: [
										61
									]
								}
							],
							ix: 2
						},
						o: {
							a: 0,
							k: 0,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					}
				],
				ip: 0,
				op: 200,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 11,
				ty: 4,
				nm: "line up 2",
				sr: 1,
				ks: {
					o: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.833
									],
									y: [
										0.833
									]
								},
								o: {
									x: [
										0.167
									],
									y: [
										0.167
									]
								},
								t: 138,
								s: [
									0
								]
							},
							{
								i: {
									x: [
										0.833
									],
									y: [
										0.833
									]
								},
								o: {
									x: [
										0.167
									],
									y: [
										0.167
									]
								},
								t: 139,
								s: [
									100
								]
							},
							{
								i: {
									x: [
										0.833
									],
									y: [
										0.833
									]
								},
								o: {
									x: [
										0.167
									],
									y: [
										0.167
									]
								},
								t: 161,
								s: [
									100
								]
							},
							{
								t: 162,
								s: [
									0
								]
							}
						],
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0,
									y: 1
								},
								o: {
									x: 0.333,
									y: 0
								},
								t: 139,
								s: [
									400.5,
									400.5,
									0
								],
								to: [
									-4.667,
									8.042,
									0
								],
								ti: [
									4.667,
									-8.042,
									0
								]
							},
							{
								t: 161,
								s: [
									372.5,
									448.75,
									0
								]
							}
						],
						ix: 2,
						l: 2
					},
					a: {
						a: 0,
						k: [
							0.5,
							0.5,
							0
						],
						ix: 1,
						l: 2
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6,
						l: 2
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												36.5,
												96.5
											],
											[
												36.5,
												-95.5
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 1,
									k: [
										{
											i: {
												x: [
													0
												],
												y: [
													1
												]
											},
											o: {
												x: [
													0.333
												],
												y: [
													0
												]
											},
											t: 139,
											s: [
												19.2
											]
										},
										{
											t: 161,
											s: [
												9
											]
										}
									],
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										-36,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Shape 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.333
										],
										y: [
											0
										]
									},
									t: 139,
									s: [
										0
									]
								},
								{
									t: 161,
									s: [
										41
									]
								}
							],
							ix: 1
						},
						e: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.333
										],
										y: [
											0
										]
									},
									t: 139,
									s: [
										100
									]
								},
								{
									t: 161,
									s: [
										61
									]
								}
							],
							ix: 2
						},
						o: {
							a: 0,
							k: 0,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					}
				],
				ip: 0,
				op: 200,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 12,
				ty: 4,
				nm: "line up",
				sr: 1,
				ks: {
					o: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.833
									],
									y: [
										0.833
									]
								},
								o: {
									x: [
										0.167
									],
									y: [
										0.167
									]
								},
								t: 138,
								s: [
									0
								]
							},
							{
								i: {
									x: [
										0.833
									],
									y: [
										0.833
									]
								},
								o: {
									x: [
										0.167
									],
									y: [
										0.167
									]
								},
								t: 139,
								s: [
									100
								]
							},
							{
								i: {
									x: [
										0.833
									],
									y: [
										0.833
									]
								},
								o: {
									x: [
										0.167
									],
									y: [
										0.167
									]
								},
								t: 161,
								s: [
									100
								]
							},
							{
								t: 162,
								s: [
									0
								]
							}
						],
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0,
									y: 1
								},
								o: {
									x: 0.333,
									y: 0
								},
								t: 139,
								s: [
									400.5,
									400.5,
									0
								],
								to: [
									-0.083,
									8.917,
									0
								],
								ti: [
									0.083,
									-8.917,
									0
								]
							},
							{
								t: 161,
								s: [
									400,
									454,
									0
								]
							}
						],
						ix: 2,
						l: 2
					},
					a: {
						a: 0,
						k: [
							0.5,
							0.5,
							0
						],
						ix: 1,
						l: 2
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6,
						l: 2
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												36.5,
												96.5
											],
											[
												36.5,
												-95.5
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 1,
									k: [
										{
											i: {
												x: [
													0
												],
												y: [
													1
												]
											},
											o: {
												x: [
													0.333
												],
												y: [
													0
												]
											},
											t: 139,
											s: [
												19.2
											]
										},
										{
											t: 161,
											s: [
												9
											]
										}
									],
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										-36,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Shape 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.333
										],
										y: [
											0
										]
									},
									t: 139,
									s: [
										0
									]
								},
								{
									t: 161,
									s: [
										42
									]
								}
							],
							ix: 1
						},
						e: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.333
										],
										y: [
											0
										]
									},
									t: 139,
									s: [
										100
									]
								},
								{
									t: 161,
									s: [
										59
									]
								}
							],
							ix: 2
						},
						o: {
							a: 0,
							k: 0,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					}
				],
				ip: 0,
				op: 200,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 13,
				ty: 4,
				nm: "line up 4",
				sr: 1,
				ks: {
					o: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.833
									],
									y: [
										0.833
									]
								},
								o: {
									x: [
										0.167
									],
									y: [
										0.167
									]
								},
								t: 138,
								s: [
									0
								]
							},
							{
								i: {
									x: [
										0.833
									],
									y: [
										0.833
									]
								},
								o: {
									x: [
										0.167
									],
									y: [
										0.167
									]
								},
								t: 139,
								s: [
									100
								]
							},
							{
								i: {
									x: [
										0.833
									],
									y: [
										0.833
									]
								},
								o: {
									x: [
										0.167
									],
									y: [
										0.167
									]
								},
								t: 161,
								s: [
									100
								]
							},
							{
								t: 162,
								s: [
									0
								]
							}
						],
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0,
									y: 1
								},
								o: {
									x: 0.333,
									y: 0
								},
								t: 139,
								s: [
									400.5,
									400.5,
									0
								],
								to: [
									4.417,
									8.125,
									0
								],
								ti: [
									-4.417,
									-8.125,
									0
								]
							},
							{
								t: 161,
								s: [
									427,
									449.25,
									0
								]
							}
						],
						ix: 2,
						l: 2
					},
					a: {
						a: 0,
						k: [
							0.5,
							0.5,
							0
						],
						ix: 1,
						l: 2
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6,
						l: 2
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												36.5,
												96.5
											],
											[
												36.5,
												-95.5
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 1,
									k: [
										{
											i: {
												x: [
													0
												],
												y: [
													1
												]
											},
											o: {
												x: [
													0.333
												],
												y: [
													0
												]
											},
											t: 139,
											s: [
												19.2
											]
										},
										{
											t: 161,
											s: [
												9
											]
										}
									],
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										-36,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Shape 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.333
										],
										y: [
											0
										]
									},
									t: 139,
									s: [
										0
									]
								},
								{
									t: 161,
									s: [
										42
									]
								}
							],
							ix: 1
						},
						e: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.333
										],
										y: [
											0
										]
									},
									t: 139,
									s: [
										100
									]
								},
								{
									t: 161,
									s: [
										60
									]
								}
							],
							ix: 2
						},
						o: {
							a: 0,
							k: 0,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					}
				],
				ip: 0,
				op: 200,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 14,
				ty: 4,
				nm: "line up 5",
				sr: 1,
				ks: {
					o: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.833
									],
									y: [
										0.833
									]
								},
								o: {
									x: [
										0.167
									],
									y: [
										0.167
									]
								},
								t: 138,
								s: [
									0
								]
							},
							{
								i: {
									x: [
										0.833
									],
									y: [
										0.833
									]
								},
								o: {
									x: [
										0.167
									],
									y: [
										0.167
									]
								},
								t: 139,
								s: [
									100
								]
							},
							{
								i: {
									x: [
										0.833
									],
									y: [
										0.833
									]
								},
								o: {
									x: [
										0.167
									],
									y: [
										0.167
									]
								},
								t: 161,
								s: [
									100
								]
							},
							{
								t: 162,
								s: [
									0
								]
							}
						],
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0,
									y: 1
								},
								o: {
									x: 0.333,
									y: 0
								},
								t: 139,
								s: [
									400.5,
									400.5,
									0
								],
								to: [
									9.917,
									8.75,
									0
								],
								ti: [
									-9.917,
									-8.75,
									0
								]
							},
							{
								t: 161,
								s: [
									460,
									453,
									0
								]
							}
						],
						ix: 2,
						l: 2
					},
					a: {
						a: 0,
						k: [
							0.5,
							0.5,
							0
						],
						ix: 1,
						l: 2
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6,
						l: 2
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												36.5,
												96.5
											],
											[
												36.5,
												-95.5
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 1,
									k: [
										{
											i: {
												x: [
													0
												],
												y: [
													1
												]
											},
											o: {
												x: [
													0.333
												],
												y: [
													0
												]
											},
											t: 139,
											s: [
												19.2
											]
										},
										{
											t: 161,
											s: [
												9
											]
										}
									],
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										-36,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Shape 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.333
										],
										y: [
											0
										]
									},
									t: 139,
									s: [
										0
									]
								},
								{
									t: 161,
									s: [
										42
									]
								}
							],
							ix: 1
						},
						e: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.333
										],
										y: [
											0
										]
									},
									t: 139,
									s: [
										100
									]
								},
								{
									t: 161,
									s: [
										61
									]
								}
							],
							ix: 2
						},
						o: {
							a: 0,
							k: 0,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					}
				],
				ip: 0,
				op: 200,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 15,
				ty: 4,
				nm: "casette 2 Outlines",
				parent: 18,
				sr: 1,
				ks: {
					o: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.833
									],
									y: [
										0.833
									]
								},
								o: {
									x: [
										0.167
									],
									y: [
										0.167
									]
								},
								t: 90,
								s: [
									0
								]
							},
							{
								i: {
									x: [
										0.833
									],
									y: [
										0.833
									]
								},
								o: {
									x: [
										0.167
									],
									y: [
										0.167
									]
								},
								t: 90.883,
								s: [
									100
								]
							},
							{
								i: {
									x: [
										0.833
									],
									y: [
										0.833
									]
								},
								o: {
									x: [
										0.167
									],
									y: [
										0.167
									]
								},
								t: 138,
								s: [
									100
								]
							},
							{
								t: 139,
								s: [
									0
								]
							}
						],
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							130.658,
							28.073,
							0
						],
						ix: 2,
						l: 2
					},
					a: {
						a: 0,
						k: [
							99.797,
							21.262,
							0
						],
						ix: 1,
						l: 2
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6,
						l: 2
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 1,
									k: [
										{
											i: {
												x: 0,
												y: 1
											},
											o: {
												x: 0.333,
												y: 0
											},
											t: 128,
											s: [
												{
													i: [
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													o: [
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													v: [
														[
															-93.056,
															-14.521
														],
														[
															-70.403,
															14.521
														],
														[
															69.706,
															14.521
														],
														[
															93.056,
															-14.521
														]
													],
													c: false
												}
											]
										},
										{
											t: 138,
											s: [
												{
													i: [
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													o: [
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													v: [
														[
															-0.4,
															-14.52
														],
														[
															-0.403,
															14.521
														],
														[
															-0.294,
															14.521
														],
														[
															-0.319,
															-14.52
														]
													],
													c: false
												}
											]
										}
									],
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 10.319,
									ix: 5
								},
								lc: 2,
								lj: 1,
								ml: 2.61,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										99.797,
										21.262
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 200,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 16,
				ty: 4,
				nm: "walkman Outlines",
				sr: 1,
				ks: {
					o: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.833
									],
									y: [
										0.833
									]
								},
								o: {
									x: [
										0.167
									],
									y: [
										0.167
									]
								},
								t: 138,
								s: [
									100
								]
							},
							{
								t: 139,
								s: [
									0
								]
							}
						],
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							400,
							400,
							0
						],
						ix: 2,
						l: 2
					},
					a: {
						a: 0,
						k: [
							158.466,
							108.933,
							0
						],
						ix: 1,
						l: 2
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6,
						l: 2
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 1,
									k: [
										{
											i: {
												x: 0,
												y: 1
											},
											o: {
												x: 0.333,
												y: 0
											},
											t: 128,
											s: [
												{
													i: [
														[
															-13.36,
															0
														],
														[
															0,
															0
														],
														[
															0,
															-13.359
														],
														[
															0,
															0
														],
														[
															13.36,
															0
														],
														[
															0,
															0
														],
														[
															0,
															13.36
														],
														[
															0,
															0
														]
													],
													o: [
														[
															0,
															0
														],
														[
															13.36,
															0
														],
														[
															0,
															0
														],
														[
															0,
															13.36
														],
														[
															0,
															0
														],
														[
															-13.36,
															0
														],
														[
															0,
															0
														],
														[
															0,
															-13.359
														]
													],
													v: [
														[
															-121.656,
															-96.413
														],
														[
															121.655,
															-96.413
														],
														[
															145.946,
															-72.123
														],
														[
															145.946,
															72.123
														],
														[
															121.655,
															96.413
														],
														[
															-121.656,
															96.413
														],
														[
															-145.946,
															72.123
														],
														[
															-145.946,
															-72.123
														]
													],
													c: true
												}
											]
										},
										{
											t: 138,
											s: [
												{
													i: [
														[
															-0.469,
															-0.088
														],
														[
															0,
															0
														],
														[
															0,
															-13.359
														],
														[
															0,
															0
														],
														[
															-0.562,
															-0.072
														],
														[
															0,
															0
														],
														[
															0,
															13.36
														],
														[
															0,
															0
														]
													],
													o: [
														[
															0,
															0
														],
														[
															-0.406,
															0.16
														],
														[
															0,
															0
														],
														[
															0,
															13.36
														],
														[
															0,
															0
														],
														[
															-0.594,
															-0.164
														],
														[
															0,
															0
														],
														[
															0,
															-13.359
														]
													],
													v: [
														[
															0.594,
															-96.412
														],
														[
															0.655,
															-96.223
														],
														[
															0.165,
															-71.922
														],
														[
															0.165,
															72.324
														],
														[
															0.655,
															96.603
														],
														[
															0.594,
															96.414
														],
														[
															0.194,
															72.125
														],
														[
															0.194,
															-72.121
														]
													],
													c: true
												}
											]
										}
									],
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 19.165,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										158.466,
										108.933
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.44
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.614
										],
										y: [
											0
										]
									},
									t: 97.059,
									s: [
										50
									]
								},
								{
									t: 112.94140625,
									s: [
										0
									]
								}
							],
							ix: 1
						},
						e: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.44
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.614
										],
										y: [
											0
										]
									},
									t: 97.059,
									s: [
										50
									]
								},
								{
									t: 112.94140625,
									s: [
										100
									]
								}
							],
							ix: 2
						},
						o: {
							a: 0,
							k: 228,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					}
				],
				ip: 0,
				op: 200,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 17,
				ty: 4,
				nm: "walkman button Outlines",
				sr: 1,
				ks: {
					o: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.833
									],
									y: [
										0.833
									]
								},
								o: {
									x: [
										0.167
									],
									y: [
										0.167
									]
								},
								t: 148,
								s: [
									100
								]
							},
							{
								t: 149,
								s: [
									0
								]
							}
						],
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							400,
							294.884,
							0
						],
						ix: 2,
						l: 2
					},
					a: {
						a: 0,
						k: [
							56.757,
							9.582,
							0
						],
						ix: 1,
						l: 2
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6,
						l: 2
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 1,
									k: [
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 0.333,
												y: 0
											},
											t: 124,
											s: [
												{
													i: [
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													o: [
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													v: [
														[
															9.582,
															9.582
														],
														[
															14.138,
															9.582
														],
														[
															57.507,
															9.582
														],
														[
															98.51,
															9.582
														],
														[
															103.932,
															9.582
														]
													],
													c: false
												}
											]
										},
										{
											i: {
												x: 0.667,
												y: 1
											},
											o: {
												x: 1,
												y: 0
											},
											t: 129,
											s: [
												{
													i: [
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													o: [
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													v: [
														[
															9.582,
															17.707
														],
														[
															14.138,
															17.707
														],
														[
															57.507,
															17.707
														],
														[
															98.51,
															17.707
														],
														[
															103.932,
															17.707
														]
													],
													c: false
												}
											]
										},
										{
											t: 142,
											s: [
												{
													i: [
														[
															0.5,
															20.134
														],
														[
															0.311,
															9.768
														],
														[
															-129,
															3.866
														],
														[
															1.768,
															-19.99
														],
														[
															0,
															0
														]
													],
													o: [
														[
															-0.5,
															-20.134
														],
														[
															-0.5,
															-15.68
														],
														[
															125.5,
															6.366
														],
														[
															0,
															31.01
														],
														[
															0,
															0
														]
													],
													v: [
														[
															-89.918,
															165.332
														],
														[
															-90.335,
															106.879
														],
														[
															57.257,
															-32.168
														],
														[
															201.99,
															106.689
														],
														[
															202.682,
															165.332
														]
													],
													c: false
												}
											]
										}
									],
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.725490196078,
										0.078431372549,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 19.165,
									ix: 5
								},
								lc: 2,
								lj: 1,
								ml: 2.61,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0.5,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.321
										],
										y: [
											0
										]
									},
									t: 111.177,
									s: [
										50
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0
										]
									},
									t: 120,
									s: [
										0
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0
										]
									},
									t: 124,
									s: [
										0
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.77
										],
										y: [
											0
										]
									},
									t: 129,
									s: [
										47
									]
								},
								{
									t: 148,
									s: [
										0
									]
								}
							],
							ix: 1
						},
						e: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.321
										],
										y: [
											0
										]
									},
									t: 111.177,
									s: [
										50
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0
										]
									},
									t: 120,
									s: [
										100
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0
										]
									},
									t: 124,
									s: [
										100
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.77
										],
										y: [
											0
										]
									},
									t: 129,
									s: [
										53
									]
								},
								{
									t: 148,
									s: [
										100
									]
								}
							],
							ix: 2
						},
						o: {
							a: 0,
							k: 0,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					}
				],
				ip: 0,
				op: 200,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 18,
				ty: 4,
				nm: "castette 1 Outlines",
				sr: 1,
				ks: {
					o: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.833
									],
									y: [
										0.833
									]
								},
								o: {
									x: [
										0.167
									],
									y: [
										0.167
									]
								},
								t: 97.941,
								s: [
									0
								]
							},
							{
								i: {
									x: [
										0.833
									],
									y: [
										0.833
									]
								},
								o: {
									x: [
										0.167
									],
									y: [
										0.167
									]
								},
								t: 98.823,
								s: [
									100
								]
							},
							{
								i: {
									x: [
										0.833
									],
									y: [
										0.833
									]
								},
								o: {
									x: [
										0.167
									],
									y: [
										0.167
									]
								},
								t: 138,
								s: [
									100
								]
							},
							{
								t: 139,
								s: [
									0
								]
							}
						],
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0,
									y: 1
								},
								o: {
									x: 0.333,
									y: 0
								},
								t: 97.059,
								s: [
									400,
									400,
									0
								],
								to: [
									0,
									-16.667,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.667,
									y: 1
								},
								o: {
									x: 1,
									y: 0
								},
								t: 107.647,
								s: [
									400,
									300,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									-16.667,
									0
								]
							},
							{
								t: 118.2353515625,
								s: [
									400,
									400,
									0
								]
							}
						],
						ix: 2,
						l: 2
					},
					a: {
						a: 0,
						k: [
							130.309,
							81.955,
							0
						],
						ix: 1,
						l: 2
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6,
						l: 2
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 1,
									k: [
										{
											i: {
												x: 0,
												y: 1
											},
											o: {
												x: 0.333,
												y: 0
											},
											t: 128,
											s: [
												{
													i: [
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													o: [
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													v: [
														[
															-116.757,
															-68.404
														],
														[
															116.757,
															-68.404
														],
														[
															116.757,
															68.404
														],
														[
															-116.757,
															68.404
														]
													],
													c: true
												}
											]
										},
										{
											t: 138,
											s: [
												{
													i: [
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													o: [
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													v: [
														[
															0.243,
															-68.512
														],
														[
															0.757,
															-68.455
														],
														[
															0.757,
															68.352
														],
														[
															0.243,
															68.295
														]
													],
													c: true
												}
											]
										}
									],
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 19.165,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										130.309,
										81.955
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 200,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 19,
				ty: 4,
				nm: "mic 1 Outlines",
				sr: 1,
				ks: {
					o: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.833
									],
									y: [
										0.833
									]
								},
								o: {
									x: [
										0.167
									],
									y: [
										0.167
									]
								},
								t: 80.294,
								s: [
									100
								]
							},
							{
								t: 82.05859375,
								s: [
									0
								]
							}
						],
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							400,
							452.857,
							0
						],
						ix: 2,
						l: 2
					},
					a: {
						a: 0,
						k: [
							69.382,
							5.192,
							0
						],
						ix: 1,
						l: 2
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6,
						l: 2
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 1,
									k: [
										{
											i: {
												x: 0,
												y: 1
											},
											o: {
												x: 0.333,
												y: 0
											},
											t: 67.941,
											s: [
												{
													i: [
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													o: [
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													v: [
														[
															5.192,
															5.192
														],
														[
															67.507,
															5.192
														],
														[
															133.571,
															5.192
														]
													],
													c: false
												}
											]
										},
										{
											t: 81.1767578125,
											s: [
												{
													i: [
														[
															0,
															0
														],
														[
															-52.5,
															0
														],
														[
															0,
															9.893
														]
													],
													o: [
														[
															-1.31,
															13.393
														],
														[
															60.25,
															0
														],
														[
															0,
															-11.857
														]
													],
													v: [
														[
															5.192,
															5.192
														],
														[
															68.132,
															69.88
														],
														[
															133.571,
															5.192
														]
													],
													c: false
												}
											]
										}
									],
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 10.385,
									ix: 5
								},
								lc: 2,
								lj: 1,
								ml: 2.61,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.231
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.807
										],
										y: [
											0
										]
									},
									t: 38.823,
									s: [
										100
									]
								},
								{
									t: 60,
									s: [
										0
									]
								}
							],
							ix: 1
						},
						e: {
							a: 0,
							k: 100,
							ix: 2
						},
						o: {
							a: 0,
							k: 0,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					}
				],
				ip: 0,
				op: 200,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 20,
				ty: 4,
				nm: "mic outline Outlines",
				sr: 1,
				ks: {
					o: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.833
									],
									y: [
										0.833
									]
								},
								o: {
									x: [
										0.167
									],
									y: [
										0.167
									]
								},
								t: 97.941,
								s: [
									100
								]
							},
							{
								t: 98.8232421875,
								s: [
									0
								]
							}
						],
						ix: 11
					},
					r: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.667
									],
									y: [
										1
									]
								},
								o: {
									x: [
										0.333
									],
									y: [
										0
									]
								},
								t: 80.294,
								s: [
									0
								]
							},
							{
								i: {
									x: [
										0
									],
									y: [
										1
									]
								},
								o: {
									x: [
										0.333
									],
									y: [
										0
									]
								},
								t: 84.706,
								s: [
									5
								]
							},
							{
								t: 97.94140625,
								s: [
									-90
								]
							}
						],
						ix: 10
					},
					p: {
						a: 0,
						k: [
							400,
							399.916,
							0
						],
						ix: 2,
						l: 2
					},
					a: {
						a: 0,
						k: [
							76.788,
							129.729,
							0
						],
						ix: 1,
						l: 2
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6,
						l: 2
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 1,
									k: [
										{
											i: {
												x: 0,
												y: 1
											},
											o: {
												x: 0.333,
												y: 0
											},
											t: 84.706,
											s: [
												{
													i: [
														[
															-35.304,
															0
														],
														[
															-0.911,
															-0.039
														],
														[
															0,
															-34.383
														],
														[
															0,
															0
														],
														[
															35.305,
															0
														],
														[
															0.912,
															0.039
														],
														[
															0,
															34.382
														],
														[
															0,
															0
														]
													],
													o: [
														[
															0.92,
															0
														],
														[
															34.044,
															1.451
														],
														[
															0,
															0
														],
														[
															0,
															35.303
														],
														[
															-0.921,
															0
														],
														[
															-34.042,
															-1.453
														],
														[
															0,
															0
														],
														[
															0,
															-35.304
														]
													],
													v: [
														[
															0,
															-117.131
														],
														[
															2.746,
															-117.072
														],
														[
															64.189,
															-52.941
														],
														[
															64.189,
															52.942
														],
														[
															0,
															117.131
														],
														[
															-2.749,
															117.072
														],
														[
															-64.189,
															52.942
														],
														[
															-64.189,
															-52.941
														]
													],
													c: true
												}
											]
										},
										{
											t: 97.94140625,
											s: [
												{
													i: [
														[
															-10.334,
															-0.041
														],
														[
															-0.912,
															0.003
														],
														[
															-0.104,
															-9.434
														],
														[
															0,
															0
														],
														[
															9.166,
															-0.085
														],
														[
															0.913,
															-0.003
														],
														[
															-0.216,
															10.559
														],
														[
															0,
															0
														]
													],
													o: [
														[
															0.92,
															0.004
														],
														[
															8.295,
															-0.024
														],
														[
															0,
															0
														],
														[
															0.117,
															11.434
														],
														[
															-0.921,
															0.009
														],
														[
															-8.584,
															0.028
														],
														[
															0,
															0
														],
														[
															-0.341,
															-7.809
														]
													],
													v: [
														[
															-60.125,
															-117.209
														],
														[
															61.996,
															-117.055
														],
														[
															68.145,
															-108.191
														],
														[
															68.145,
															108.066
														],
														[
															59.875,
															117.065
														],
														[
															-60.25,
															117.222
														],
														[
															-68.618,
															106.941
														],
														[
															-68.618,
															-109.316
														]
													],
													c: true
												}
											]
										}
									],
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 19.286,
									ix: 5
								},
								lc: 2,
								lj: 1,
								ml: 2.61,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										76.788,
										129.729
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.667
										],
										y: [
											1
										]
									},
									o: {
										x: [
											1
										],
										y: [
											0
										]
									},
									t: 36.177,
									s: [
										100
									]
								},
								{
									t: 53.8232421875,
									s: [
										0
									]
								}
							],
							ix: 1
						},
						e: {
							a: 0,
							k: 100,
							ix: 2
						},
						o: {
							a: 0,
							k: 64,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					}
				],
				ip: 0,
				op: 200,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 21,
				ty: 4,
				nm: "base 3 Outlines",
				sr: 1,
				ks: {
					o: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.833
									],
									y: [
										0.833
									]
								},
								o: {
									x: [
										0.167
									],
									y: [
										0.167
									]
								},
								t: 80.294,
								s: [
									100
								]
							},
							{
								t: 82.05859375,
								s: [
									0
								]
							}
						],
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0,
									y: 1
								},
								o: {
									x: 0.333,
									y: 0
								},
								t: 67.941,
								s: [
									400,
									476.263,
									0
								],
								to: [
									0,
									-0.917,
									0
								],
								ti: [
									0,
									0.917,
									0
								]
							},
							{
								t: 81.1767578125,
								s: [
									400,
									470.763,
									0
								]
							}
						],
						ix: 2,
						l: 2
					},
					a: {
						a: 0,
						k: [
							104.993,
							82.008,
							0
						],
						ix: 1,
						l: 2
					},
					s: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0,
										0,
										0.667
									],
									y: [
										1,
										1,
										1
									]
								},
								o: {
									x: [
										0.333,
										0.333,
										0.333
									],
									y: [
										0,
										0,
										0
									]
								},
								t: 67.941,
								s: [
									100,
									100,
									100
								]
							},
							{
								t: 81.1767578125,
								s: [
									68,
									68,
									100
								]
							}
						],
						ix: 6,
						l: 2
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-50.816,
												0
											],
											[
												0,
												46.972
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												46.975
											],
											[
												50.817,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-92.394,
												-69.409
											],
											[
												-92.394,
												-15.999
											],
											[
												0,
												69.409
											],
											[
												92.394,
												-15.999
											],
											[
												92.394,
												-69.409
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 19.287,
									ix: 5
								},
								lc: 2,
								lj: 1,
								ml: 2.61,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										104.993,
										82.008
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.333
										],
										y: [
											0
										]
									},
									t: 38.823,
									s: [
										100
									]
								},
								{
									t: 60,
									s: [
										0
									]
								}
							],
							ix: 1
						},
						e: {
							a: 0,
							k: 100,
							ix: 2
						},
						o: {
							a: 0,
							k: 0,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					}
				],
				ip: 0,
				op: 200,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 22,
				ty: 4,
				nm: "base 2 Outlines",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							400,
							585.312,
							0
						],
						ix: 2,
						l: 2
					},
					a: {
						a: 0,
						k: [
							9.643,
							48.195,
							0
						],
						ix: 1,
						l: 2
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6,
						l: 2
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												9.643,
												86.747
											],
											[
												9.643,
												9.643
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 19.286,
									ix: 5
								},
								lc: 2,
								lj: 1,
								ml: 2.61,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.158
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.963
										],
										y: [
											0
										]
									},
									t: 44.117,
									s: [
										100
									]
								},
								{
									t: 51.1767578125,
									s: [
										0
									]
								}
							],
							ix: 1
						},
						e: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.333
										],
										y: [
											0
										]
									},
									t: 72.353,
									s: [
										100
									]
								},
								{
									t: 80.2939453125,
									s: [
										0
									]
								}
							],
							ix: 2
						},
						o: {
							a: 0,
							k: 0,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					}
				],
				ip: 0,
				op: 200,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 23,
				ty: 4,
				nm: "base 1 Outlines",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.667
									],
									y: [
										1
									]
								},
								o: {
									x: [
										0.333
									],
									y: [
										0
									]
								},
								t: 74.117,
								s: [
									0
								]
							},
							{
								i: {
									x: [
										0
									],
									y: [
										1
									]
								},
								o: {
									x: [
										0.333
									],
									y: [
										0
									]
								},
								t: 80.294,
								s: [
									15
								]
							},
							{
								t: 104.1171875,
								s: [
									-360
								]
							}
						],
						ix: 10
					},
					p: {
						a: 0,
						k: [
							400,
							399.944,
							0
						],
						ix: 2,
						l: 2
					},
					a: {
						a: 0,
						k: [
							103.054,
							-194.961,
							0
						],
						ix: 1,
						l: 2
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6,
						l: 2
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												32.926,
												0
											],
											[
												28.195,
												12.691
											]
										],
										o: [
											[
												-28.194,
												12.691
											],
											[
												-32.925,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												92.394,
												-9.879
											],
											[
												0,
												9.879
											],
											[
												-92.394,
												-9.879
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 16.319,
									ix: 5
								},
								lc: 2,
								lj: 1,
								ml: 2.61,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										103.054,
										20.539
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.333
										],
										y: [
											0
										]
									},
									t: 48.529,
									s: [
										50
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.333
										],
										y: [
											0
										]
									},
									t: 59.117,
									s: [
										0
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0
										]
									},
									t: 80.294,
									s: [
										0
									]
								},
								{
									t: 104.1171875,
									s: [
										100
									]
								}
							],
							ix: 1
						},
						e: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.333
										],
										y: [
											0
										]
									},
									t: 48.529,
									s: [
										50
									]
								},
								{
									t: 59.1171875,
									s: [
										100
									]
								}
							],
							ix: 2
						},
						o: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0
										],
										y: [
											0.977
										]
									},
									o: {
										x: [
											0.333
										],
										y: [
											0
										]
									},
									t: 80.294,
									s: [
										0
									]
								},
								{
									t: 104.1171875,
									s: [
										-177
									]
								}
							],
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					}
				],
				ip: 0,
				op: 200,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 24,
				ty: 4,
				nm: "line 3 Outlines 10",
				sr: 1,
				ks: {
					o: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.833
									],
									y: [
										0.833
									]
								},
								o: {
									x: [
										0.167
									],
									y: [
										0.167
									]
								},
								t: 195,
								s: [
									0
								]
							},
							{
								t: 196,
								s: [
									100
								]
							}
						],
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							520,
							400,
							0
						],
						ix: 2,
						l: 2
					},
					a: {
						a: 0,
						k: [
							9.605,
							108.598,
							0
						],
						ix: 1,
						l: 2
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6,
						l: 2
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												9.605,
												9.605
											],
											[
												9.605,
												207.591
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 19.21,
									ix: 5
								},
								lc: 2,
								lj: 1,
								ml: 2.61,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 0,
							k: 28,
							ix: 1
						},
						e: {
							a: 0,
							k: 70,
							ix: 2
						},
						o: {
							a: 0,
							k: 0,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					}
				],
				ip: 195,
				op: 395,
				st: 195,
				bm: 0
			},
			{
				ddd: 0,
				ind: 25,
				ty: 4,
				nm: "line 3 Outlines 9",
				sr: 1,
				ks: {
					o: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.833
									],
									y: [
										0.833
									]
								},
								o: {
									x: [
										0.167
									],
									y: [
										0.167
									]
								},
								t: 195,
								s: [
									0
								]
							},
							{
								t: 196,
								s: [
									100
								]
							}
						],
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							460,
							400,
							0
						],
						ix: 2,
						l: 2
					},
					a: {
						a: 0,
						k: [
							9.605,
							108.598,
							0
						],
						ix: 1,
						l: 2
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6,
						l: 2
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												9.605,
												9.605
											],
											[
												9.605,
												117.098
											],
											[
												9.605,
												207.591
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 19.21,
									ix: 5
								},
								lc: 2,
								lj: 1,
								ml: 2.61,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 0,
							k: 16,
							ix: 1
						},
						e: {
							a: 0,
							k: 83,
							ix: 2
						},
						o: {
							a: 0,
							k: 0,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					}
				],
				ip: 195,
				op: 395,
				st: 195,
				bm: 0
			},
			{
				ddd: 0,
				ind: 26,
				ty: 4,
				nm: "line 3 Outlines 8",
				sr: 1,
				ks: {
					o: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.833
									],
									y: [
										0.833
									]
								},
								o: {
									x: [
										0.167
									],
									y: [
										0.167
									]
								},
								t: 195,
								s: [
									0
								]
							},
							{
								t: 196,
								s: [
									100
								]
							}
						],
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							400,
							400,
							0
						],
						ix: 2,
						l: 2
					},
					a: {
						a: 0,
						k: [
							9.605,
							108.598,
							0
						],
						ix: 1,
						l: 2
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6,
						l: 2
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												9.605,
												9.605
											],
											[
												9.605,
												25.944
											],
											[
												9.605,
												177.914
											],
											[
												9.605,
												207.591
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 19.21,
									ix: 5
								},
								lc: 2,
								lj: 1,
								ml: 2.61,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 0,
							k: 0,
							ix: 1
						},
						e: {
							a: 0,
							k: 100,
							ix: 2
						},
						o: {
							a: 0,
							k: 0,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					}
				],
				ip: 195,
				op: 395,
				st: 195,
				bm: 0
			},
			{
				ddd: 0,
				ind: 27,
				ty: 4,
				nm: "line 3 Outlines 7",
				sr: 1,
				ks: {
					o: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.833
									],
									y: [
										0.833
									]
								},
								o: {
									x: [
										0.167
									],
									y: [
										0.167
									]
								},
								t: 195,
								s: [
									0
								]
							},
							{
								t: 196,
								s: [
									100
								]
							}
						],
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							339.5,
							400,
							0
						],
						ix: 2,
						l: 2
					},
					a: {
						a: 0,
						k: [
							9.605,
							108.598,
							0
						],
						ix: 1,
						l: 2
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6,
						l: 2
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												9.605,
												9.605
											],
											[
												9.605,
												121.316
											],
											[
												9.605,
												207.591
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 19.21,
									ix: 5
								},
								lc: 2,
								lj: 1,
								ml: 2.61,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 0,
							k: 16,
							ix: 1
						},
						e: {
							a: 0,
							k: 83,
							ix: 2
						},
						o: {
							a: 0,
							k: 0,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					}
				],
				ip: 195,
				op: 395,
				st: 195,
				bm: 0
			},
			{
				ddd: 0,
				ind: 28,
				ty: 4,
				nm: "line 3 Outlines 6",
				sr: 1,
				ks: {
					o: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.833
									],
									y: [
										0.833
									]
								},
								o: {
									x: [
										0.167
									],
									y: [
										0.167
									]
								},
								t: 195,
								s: [
									0
								]
							},
							{
								t: 196,
								s: [
									100
								]
							}
						],
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							279.5,
							400,
							0
						],
						ix: 2,
						l: 2
					},
					a: {
						a: 0,
						k: [
							9.605,
							108.598,
							0
						],
						ix: 1,
						l: 2
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6,
						l: 2
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												9.605,
												9.605
											],
											[
												9.605,
												207.591
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 19.21,
									ix: 5
								},
								lc: 2,
								lj: 1,
								ml: 2.61,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 0,
							k: 28,
							ix: 1
						},
						e: {
							a: 0,
							k: 70,
							ix: 2
						},
						o: {
							a: 0,
							k: 0,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					}
				],
				ip: 195,
				op: 395,
				st: 195,
				bm: 0
			},
			{
				ddd: 0,
				ind: 29,
				ty: 4,
				nm: "line 3 Outlines 3",
				sr: 1,
				ks: {
					o: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.833
									],
									y: [
										0.833
									]
								},
								o: {
									x: [
										0.167
									],
									y: [
										0.167
									]
								},
								t: 67.941,
								s: [
									100
								]
							},
							{
								t: 68.8232421875,
								s: [
									0
								]
							}
						],
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.191,
									y: 1
								},
								o: {
									x: 0.947,
									y: 0
								},
								t: 24.706,
								s: [
									520,
									400,
									0
								],
								to: [
									-9.292,
									0,
									0
								],
								ti: [
									9.292,
									0,
									0
								]
							},
							{
								t: 37.94140625,
								s: [
									464.25,
									400,
									0
								]
							}
						],
						ix: 2,
						l: 2
					},
					a: {
						a: 0,
						k: [
							9.605,
							108.598,
							0
						],
						ix: 1,
						l: 2
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6,
						l: 2
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												9.605,
												9.605
											],
											[
												9.605,
												207.591
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 19.21,
									ix: 5
								},
								lc: 2,
								lj: 1,
								ml: 2.61,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.235
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.679
										],
										y: [
											0
										]
									},
									t: 0,
									s: [
										28
									]
								},
								{
									i: {
										x: [
											0.252
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.743
										],
										y: [
											0
										]
									},
									t: 10.588,
									s: [
										33
									]
								},
								{
									i: {
										x: [
											0.259
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.703
										],
										y: [
											0
										]
									},
									t: 22.059,
									s: [
										28
									]
								},
								{
									i: {
										x: [
											0.257
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.73
										],
										y: [
											0
										]
									},
									t: 27.353,
									s: [
										33
									]
								},
								{
									t: 37.94140625,
									s: [
										28
									]
								}
							],
							ix: 1
						},
						e: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.235
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.679
										],
										y: [
											0
										]
									},
									t: 0,
									s: [
										70
									]
								},
								{
									i: {
										x: [
											0.252
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.743
										],
										y: [
											0
										]
									},
									t: 10.588,
									s: [
										69
									]
								},
								{
									i: {
										x: [
											0.259
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.703
										],
										y: [
											0
										]
									},
									t: 22.059,
									s: [
										70
									]
								},
								{
									i: {
										x: [
											0.257
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.73
										],
										y: [
											0
										]
									},
									t: 27.353,
									s: [
										69
									]
								},
								{
									t: 33.529296875,
									s: [
										70
									]
								}
							],
							ix: 2
						},
						o: {
							a: 0,
							k: 0,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					}
				],
				ip: 0,
				op: 200,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 30,
				ty: 4,
				nm: "line 3 Outlines 2",
				sr: 1,
				ks: {
					o: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.833
									],
									y: [
										0.833
									]
								},
								o: {
									x: [
										0.167
									],
									y: [
										0.167
									]
								},
								t: 90,
								s: [
									100
								]
							},
							{
								t: 91.7646484375,
								s: [
									0
								]
							}
						],
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.147,
									y: 1
								},
								o: {
									x: 0.947,
									y: 0
								},
								t: 21.177,
								s: [
									460,
									400,
									0
								],
								to: [
									-4.833,
									-5.333,
									0
								],
								ti: [
									4.833,
									5.333,
									0
								]
							},
							{
								t: 33.529296875,
								s: [
									431,
									368,
									0
								]
							}
						],
						ix: 2,
						l: 2
					},
					a: {
						a: 0,
						k: [
							9.605,
							108.598,
							0
						],
						ix: 1,
						l: 2
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6,
						l: 2
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 1,
									k: [
										{
											i: {
												x: 0.286,
												y: 1
											},
											o: {
												x: 0.786,
												y: 0
											},
											t: 81.177,
											s: [
												{
													i: [
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													o: [
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													v: [
														[
															9.605,
															9.605
														],
														[
															9.605,
															117.098
														],
														[
															9.605,
															207.591
														]
													],
													c: false
												}
											]
										},
										{
											t: 90.8828125,
											s: [
												{
													i: [
														[
															0.442,
															17.616
														],
														[
															0.663,
															-35.396
														],
														[
															1.5,
															31.507
														]
													],
													o: [
														[
															-0.75,
															-29.882
														],
														[
															-0.625,
															33.375
														],
														[
															-1.474,
															-30.962
														]
													],
													v: [
														[
															51.855,
															148.73
														],
														[
															0.23,
															148.723
														],
														[
															51.855,
															149.591
														]
													],
													c: false
												}
											]
										}
									],
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 1,
									k: [
										{
											i: {
												x: [
													0.147
												],
												y: [
													1
												]
											},
											o: {
												x: [
													0.947
												],
												y: [
													0
												]
											},
											t: 21.177,
											s: [
												19.21
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													1
												]
											},
											o: {
												x: [
													0.333
												],
												y: [
													0
												]
											},
											t: 33.529,
											s: [
												9.5
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													1
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0
												]
											},
											t: 81.177,
											s: [
												9.5
											]
										},
										{
											t: 90.8828125,
											s: [
												19.2
											]
										}
									],
									ix: 5
								},
								lc: 2,
								lj: 1,
								ml: 2.61,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.235
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.679
										],
										y: [
											0
										]
									},
									t: 0,
									s: [
										16
									]
								},
								{
									i: {
										x: [
											0.252
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.743
										],
										y: [
											0
										]
									},
									t: 8.823,
									s: [
										33
									]
								},
								{
									i: {
										x: [
											0.259
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.703
										],
										y: [
											0
										]
									},
									t: 20.294,
									s: [
										16
									]
								},
								{
									i: {
										x: [
											0.257
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.73
										],
										y: [
											0
										]
									},
									t: 25.588,
									s: [
										33
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 33.529,
									s: [
										13
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 85.588,
									s: [
										13
									]
								},
								{
									t: 90.8828125,
									s: [
										0
									]
								}
							],
							ix: 1
						},
						e: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.235
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.679
										],
										y: [
											0
										]
									},
									t: 0,
									s: [
										83
									]
								},
								{
									i: {
										x: [
											0.252
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.743
										],
										y: [
											0
										]
									},
									t: 8.823,
									s: [
										69
									]
								},
								{
									i: {
										x: [
											0.259
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.703
										],
										y: [
											0
										]
									},
									t: 20.294,
									s: [
										83
									]
								},
								{
									i: {
										x: [
											0.257
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.73
										],
										y: [
											0
										]
									},
									t: 25.588,
									s: [
										69
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 33.529,
									s: [
										90
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 85.588,
									s: [
										90
									]
								},
								{
									t: 90.8828125,
									s: [
										100
									]
								}
							],
							ix: 2
						},
						o: {
							a: 0,
							k: 0,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					}
				],
				ip: 0,
				op: 200,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 31,
				ty: 4,
				nm: "line 3 Outlines",
				sr: 1,
				ks: {
					o: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.833
									],
									y: [
										0.833
									]
								},
								o: {
									x: [
										0.167
									],
									y: [
										0.167
									]
								},
								t: 90,
								s: [
									100
								]
							},
							{
								t: 90.8828125,
								s: [
									0
								]
							}
						],
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.147,
									y: 1
								},
								o: {
									x: 0.947,
									y: 0
								},
								t: 18.529,
								s: [
									400,
									400,
									0
								],
								to: [
									0,
									-0.167,
									0
								],
								ti: [
									0,
									0.167,
									0
								]
							},
							{
								t: 33.529296875,
								s: [
									400,
									399,
									0
								]
							}
						],
						ix: 2,
						l: 2
					},
					a: {
						a: 0,
						k: [
							9.605,
							108.598,
							0
						],
						ix: 1,
						l: 2
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6,
						l: 2
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 1,
									k: [
										{
											i: {
												x: 0.29,
												y: 1
											},
											o: {
												x: 0.695,
												y: 0
											},
											t: 18.529,
											s: [
												{
													i: [
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													o: [
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													v: [
														[
															9.605,
															9.605
														],
														[
															9.605,
															25.944
														],
														[
															9.605,
															177.914
														],
														[
															9.605,
															207.591
														]
													],
													c: false
												}
											]
										},
										{
											i: {
												x: 0.833,
												y: 1
											},
											o: {
												x: 0.333,
												y: 0
											},
											t: 33.529,
											s: [
												{
													i: [
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													o: [
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													v: [
														[
															9.605,
															-4.77
														],
														[
															9.605,
															14.097
														],
														[
															9.605,
															189.574
														],
														[
															9.605,
															223.841
														]
													],
													c: false
												}
											]
										},
										{
											i: {
												x: 0.227,
												y: 1
											},
											o: {
												x: 0.826,
												y: 0
											},
											t: 77.647,
											s: [
												{
													i: [
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													o: [
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													v: [
														[
															9.605,
															-4.77
														],
														[
															9.605,
															14.097
														],
														[
															9.605,
															189.574
														],
														[
															9.605,
															223.841
														]
													],
													c: false
												}
											]
										},
										{
											t: 90,
											s: [
												{
													i: [
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													o: [
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													v: [
														[
															-83.395,
															41.23
														],
														[
															-58.895,
															70.598
														],
														[
															78.98,
															70.973
														],
														[
															102.73,
															41.341
														]
													],
													c: false
												}
											]
										}
									],
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 1,
									k: [
										{
											i: {
												x: [
													0.147
												],
												y: [
													1
												]
											},
											o: {
												x: [
													0.947
												],
												y: [
													0
												]
											},
											t: 18.529,
											s: [
												19.21
											]
										},
										{
											t: 33.529296875,
											s: [
												9.5
											]
										}
									],
									ix: 5
								},
								lc: 2,
								lj: 1,
								ml: 2.61,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.235
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.679
										],
										y: [
											0
										]
									},
									t: 0,
									s: [
										0
									]
								},
								{
									i: {
										x: [
											0.252
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.743
										],
										y: [
											0
										]
									},
									t: 7.059,
									s: [
										33
									]
								},
								{
									i: {
										x: [
											0.259
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.703
										],
										y: [
											0
										]
									},
									t: 18.529,
									s: [
										0
									]
								},
								{
									i: {
										x: [
											0.257
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.73
										],
										y: [
											0
										]
									},
									t: 23.823,
									s: [
										33
									]
								},
								{
									t: 33.529296875,
									s: [
										0
									]
								}
							],
							ix: 1
						},
						e: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.235
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.679
										],
										y: [
											0
										]
									},
									t: 0,
									s: [
										100
									]
								},
								{
									i: {
										x: [
											0.252
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.743
										],
										y: [
											0
										]
									},
									t: 7.059,
									s: [
										69
									]
								},
								{
									i: {
										x: [
											0.259
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.703
										],
										y: [
											0
										]
									},
									t: 18.529,
									s: [
										100
									]
								},
								{
									i: {
										x: [
											0.257
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.73
										],
										y: [
											0
										]
									},
									t: 23.823,
									s: [
										69
									]
								},
								{
									t: 33.529296875,
									s: [
										100
									]
								}
							],
							ix: 2
						},
						o: {
							a: 0,
							k: 0,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					}
				],
				ip: 0,
				op: 200,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 32,
				ty: 4,
				nm: "line 3 Outlines 4",
				sr: 1,
				ks: {
					o: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.833
									],
									y: [
										0.833
									]
								},
								o: {
									x: [
										0.167
									],
									y: [
										0.167
									]
								},
								t: 90,
								s: [
									100
								]
							},
							{
								t: 90.8828125,
								s: [
									0
								]
							}
						],
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.147,
									y: 1
								},
								o: {
									x: 0.947,
									y: 0
								},
								t: 21.177,
								s: [
									339.5,
									400,
									0
								],
								to: [
									4.917,
									-5.417,
									0
								],
								ti: [
									-4.917,
									5.417,
									0
								]
							},
							{
								t: 33.529296875,
								s: [
									369,
									367.5,
									0
								]
							}
						],
						ix: 2,
						l: 2
					},
					a: {
						a: 0,
						k: [
							9.605,
							108.598,
							0
						],
						ix: 1,
						l: 2
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6,
						l: 2
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 1,
									k: [
										{
											i: {
												x: 0.301,
												y: 1
											},
											o: {
												x: 0.775,
												y: 0
											},
											t: 77.647,
											s: [
												{
													i: [
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													o: [
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													v: [
														[
															9.605,
															9.605
														],
														[
															9.605,
															121.316
														],
														[
															9.605,
															207.591
														]
													],
													c: false
												}
											]
										},
										{
											t: 90,
											s: [
												{
													i: [
														[
															0,
															16.395
														],
														[
															0,
															-27.625
														],
														[
															0,
															31.007
														]
													],
													o: [
														[
															0,
															-27.632
														],
														[
															0,
															24.625
														],
														[
															0,
															-23.245
														]
													],
													v: [
														[
															-27.395,
															148.605
														],
														[
															14.605,
															150.098
														],
														[
															-27.395,
															148.716
														]
													],
													c: false
												}
											]
										}
									],
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 1,
									k: [
										{
											i: {
												x: [
													0.147
												],
												y: [
													1
												]
											},
											o: {
												x: [
													0.947
												],
												y: [
													0
												]
											},
											t: 21.177,
											s: [
												19.21
											]
										},
										{
											t: 33.529296875,
											s: [
												9.5
											]
										}
									],
									ix: 5
								},
								lc: 2,
								lj: 1,
								ml: 2.61,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.235
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.679
										],
										y: [
											0
										]
									},
									t: 0,
									s: [
										16
									]
								},
								{
									i: {
										x: [
											0.252
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.743
										],
										y: [
											0
										]
									},
									t: 5.294,
									s: [
										33
									]
								},
								{
									i: {
										x: [
											0.259
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.703
										],
										y: [
											0
										]
									},
									t: 16.765,
									s: [
										16
									]
								},
								{
									i: {
										x: [
											0.257
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.73
										],
										y: [
											0
										]
									},
									t: 22.059,
									s: [
										33
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 33.529,
									s: [
										13
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 83.823,
									s: [
										13
									]
								},
								{
									t: 90,
									s: [
										0
									]
								}
							],
							ix: 1
						},
						e: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.235
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.679
										],
										y: [
											0
										]
									},
									t: 0,
									s: [
										83
									]
								},
								{
									i: {
										x: [
											0.252
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.743
										],
										y: [
											0
										]
									},
									t: 5.294,
									s: [
										69
									]
								},
								{
									i: {
										x: [
											0.259
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.703
										],
										y: [
											0
										]
									},
									t: 16.765,
									s: [
										83
									]
								},
								{
									i: {
										x: [
											0.257
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.73
										],
										y: [
											0
										]
									},
									t: 22.059,
									s: [
										69
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 33.529,
									s: [
										90
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 83.823,
									s: [
										90
									]
								},
								{
									t: 90,
									s: [
										100
									]
								}
							],
							ix: 2
						},
						o: {
							a: 0,
							k: 0,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					}
				],
				ip: 0,
				op: 200,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 33,
				ty: 4,
				nm: "line 3 Outlines 5",
				sr: 1,
				ks: {
					o: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.833
									],
									y: [
										0.833
									]
								},
								o: {
									x: [
										0.167
									],
									y: [
										0.167
									]
								},
								t: 67.941,
								s: [
									100
								]
							},
							{
								t: 68.8232421875,
								s: [
									0
								]
							}
						],
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.125,
									y: 1
								},
								o: {
									x: 0.947,
									y: 0
								},
								t: 24.706,
								s: [
									279.5,
									400,
									0
								],
								to: [
									9.375,
									0,
									0
								],
								ti: [
									-9.375,
									0,
									0
								]
							},
							{
								t: 37.94140625,
								s: [
									335.75,
									400,
									0
								]
							}
						],
						ix: 2,
						l: 2
					},
					a: {
						a: 0,
						k: [
							9.605,
							108.598,
							0
						],
						ix: 1,
						l: 2
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6,
						l: 2
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												9.605,
												9.605
											],
											[
												9.605,
												207.591
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 19.21,
									ix: 5
								},
								lc: 2,
								lj: 1,
								ml: 2.61,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.235
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.679
										],
										y: [
											0
										]
									},
									t: 0,
									s: [
										28
									]
								},
								{
									i: {
										x: [
											0.252
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.743
										],
										y: [
											0
										]
									},
									t: 3.529,
									s: [
										33
									]
								},
								{
									i: {
										x: [
											0.259
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.703
										],
										y: [
											0
										]
									},
									t: 15,
									s: [
										28
									]
								},
								{
									i: {
										x: [
											0.257
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.73
										],
										y: [
											0
										]
									},
									t: 20.294,
									s: [
										33
									]
								},
								{
									t: 37.94140625,
									s: [
										28
									]
								}
							],
							ix: 1
						},
						e: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.235
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.679
										],
										y: [
											0
										]
									},
									t: 0,
									s: [
										70
									]
								},
								{
									i: {
										x: [
											0.252
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.743
										],
										y: [
											0
										]
									},
									t: 3.529,
									s: [
										69
									]
								},
								{
									i: {
										x: [
											0.259
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.703
										],
										y: [
											0
										]
									},
									t: 15,
									s: [
										70
									]
								},
								{
									i: {
										x: [
											0.257
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.73
										],
										y: [
											0
										]
									},
									t: 20.294,
									s: [
										69
									]
								},
								{
									t: 33.529296875,
									s: [
										70
									]
								}
							],
							ix: 2
						},
						o: {
							a: 0,
							k: 0,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					}
				],
				ip: 0,
				op: 200,
				st: 0,
				bm: 0
			}
		]
	},
	{
		id: "comp_1",
		layers: [
			{
				ddd: 0,
				ind: 1,
				ty: 4,
				nm: "line 3 Outlines 15",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.833,
									y: 0.833
								},
								o: {
									x: 0.167,
									y: 0.167
								},
								t: 184,
								s: [
									520,
									400,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 197,
								s: [
									520,
									400,
									0
								]
							}
						],
						ix: 2,
						l: 2
					},
					a: {
						a: 0,
						k: [
							9.605,
							108.598,
							0
						],
						ix: 1,
						l: 2
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6,
						l: 2
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												9.605,
												9.605
											],
											[
												9.605,
												207.591
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.564705882353,
										0.494117647059,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 19.21,
									ix: 5
								},
								lc: 2,
								lj: 1,
								ml: 2.61,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.235
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.679
										],
										y: [
											0
										]
									},
									t: 148.059,
									s: [
										28
									]
								},
								{
									i: {
										x: [
											0.252
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.743
										],
										y: [
											0
										]
									},
									t: 163,
									s: [
										33
									]
								},
								{
									i: {
										x: [
											0.259
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.703
										],
										y: [
											0
										]
									},
									t: 173.529,
									s: [
										28
									]
								},
								{
									i: {
										x: [
											0.257
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.73
										],
										y: [
											0
										]
									},
									t: 183.235,
									s: [
										33
									]
								},
								{
									t: 198,
									s: [
										28
									]
								}
							],
							ix: 1
						},
						e: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.235
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.679
										],
										y: [
											0
										]
									},
									t: 148.059,
									s: [
										70
									]
								},
								{
									i: {
										x: [
											0.252
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.743
										],
										y: [
											0
										]
									},
									t: 163,
									s: [
										69
									]
								},
								{
									i: {
										x: [
											0.259
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.703
										],
										y: [
											0
										]
									},
									t: 173.529,
									s: [
										70
									]
								},
								{
									i: {
										x: [
											0.257
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.73
										],
										y: [
											0
										]
									},
									t: 183.235,
									s: [
										69
									]
								},
								{
									t: 197.412109375,
									s: [
										70
									]
								}
							],
							ix: 2
						},
						o: {
							a: 0,
							k: 0,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					}
				],
				ip: 0,
				op: 200,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 2,
				ty: 4,
				nm: "line 3 Outlines 14",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.833,
									y: 0.833
								},
								o: {
									x: 0.167,
									y: 0.167
								},
								t: 184,
								s: [
									454.067,
									393.454,
									0
								],
								to: [
									0.917,
									0.833,
									0
								],
								ti: [
									-0.917,
									-0.833,
									0
								]
							},
							{
								t: 197,
								s: [
									459.567,
									398.454,
									0
								]
							}
						],
						ix: 2,
						l: 2
					},
					a: {
						a: 0,
						k: [
							9.605,
							108.598,
							0
						],
						ix: 1,
						l: 2
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6,
						l: 2
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												9.605,
												9.605
											],
											[
												9.605,
												117.098
											],
											[
												9.605,
												207.591
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.564705882353,
										0.494117647059,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 19.21,
									ix: 5
								},
								lc: 2,
								lj: 1,
								ml: 2.61,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.235
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.679
										],
										y: [
											0
										]
									},
									t: 148.059,
									s: [
										16
									]
								},
								{
									i: {
										x: [
											0.252
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.743
										],
										y: [
											0
										]
									},
									t: 161,
									s: [
										33
									]
								},
								{
									i: {
										x: [
											0.259
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.703
										],
										y: [
											0
										]
									},
									t: 171.765,
									s: [
										16
									]
								},
								{
									i: {
										x: [
											0.257
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.73
										],
										y: [
											0
										]
									},
									t: 181.471,
									s: [
										33
									]
								},
								{
									t: 197.412109375,
									s: [
										16
									]
								}
							],
							ix: 1
						},
						e: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.235
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.679
										],
										y: [
											0
										]
									},
									t: 148.059,
									s: [
										83
									]
								},
								{
									i: {
										x: [
											0.252
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.743
										],
										y: [
											0
										]
									},
									t: 161,
									s: [
										69
									]
								},
								{
									i: {
										x: [
											0.259
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.703
										],
										y: [
											0
										]
									},
									t: 171.765,
									s: [
										83
									]
								},
								{
									i: {
										x: [
											0.257
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.73
										],
										y: [
											0
										]
									},
									t: 181.471,
									s: [
										69
									]
								},
								{
									t: 197,
									s: [
										83
									]
								}
							],
							ix: 2
						},
						o: {
							a: 0,
							k: 0,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					}
				],
				ip: 0,
				op: 200,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 3,
				ty: 4,
				nm: "line 3 Outlines 13",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.833,
									y: 0.833
								},
								o: {
									x: 0.167,
									y: 0.167
								},
								t: 184,
								s: [
									400,
									399.305,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 197,
								s: [
									400,
									399.305,
									0
								]
							}
						],
						ix: 2,
						l: 2
					},
					a: {
						a: 0,
						k: [
							9.605,
							108.598,
							0
						],
						ix: 1,
						l: 2
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6,
						l: 2
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 1,
									k: [
										{
											i: {
												x: 0.29,
												y: 1
											},
											o: {
												x: 0.695,
												y: 0
											},
											t: 170,
											s: [
												{
													i: [
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													o: [
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													v: [
														[
															9.605,
															9.605
														],
														[
															9.605,
															25.944
														],
														[
															9.605,
															177.914
														],
														[
															9.605,
															207.591
														]
													],
													c: false
												}
											]
										},
										{
											t: 197.412109375,
											s: [
												{
													i: [
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													o: [
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													v: [
														[
															9.605,
															-4.77
														],
														[
															9.605,
															14.097
														],
														[
															9.605,
															189.574
														],
														[
															9.605,
															223.841
														]
													],
													c: false
												}
											]
										}
									],
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.564705882353,
										0.494117647059,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 19.097,
									ix: 5
								},
								lc: 2,
								lj: 1,
								ml: 2.61,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.235
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.679
										],
										y: [
											0
										]
									},
									t: 148.059,
									s: [
										6
									]
								},
								{
									i: {
										x: [
											0.252
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.743
										],
										y: [
											0
										]
									},
									t: 159,
									s: [
										39
									]
								},
								{
									i: {
										x: [
											0.259
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.703
										],
										y: [
											0
										]
									},
									t: 170,
									s: [
										6
									]
								},
								{
									i: {
										x: [
											0.257
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.73
										],
										y: [
											0
										]
									},
									t: 179.706,
									s: [
										39
									]
								},
								{
									t: 197.412109375,
									s: [
										6
									]
								}
							],
							ix: 1
						},
						e: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.235
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.679
										],
										y: [
											0
										]
									},
									t: 148.059,
									s: [
										100
									]
								},
								{
									i: {
										x: [
											0.252
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.743
										],
										y: [
											0
										]
									},
									t: 159,
									s: [
										69
									]
								},
								{
									i: {
										x: [
											0.259
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.703
										],
										y: [
											0
										]
									},
									t: 170,
									s: [
										100
									]
								},
								{
									i: {
										x: [
											0.257
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.73
										],
										y: [
											0
										]
									},
									t: 179.706,
									s: [
										69
									]
								},
								{
									t: 197,
									s: [
										93
									]
								}
							],
							ix: 2
						},
						o: {
							a: 0,
							k: 0,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					}
				],
				ip: 0,
				op: 200,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 4,
				ty: 4,
				nm: "line 3 Outlines 12",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.833,
									y: 0.833
								},
								o: {
									x: 0.167,
									y: 0.167
								},
								t: 184,
								s: [
									345.535,
									393.352,
									0
								],
								to: [
									-0.917,
									0.833,
									0
								],
								ti: [
									0.917,
									-0.833,
									0
								]
							},
							{
								t: 197,
								s: [
									340.035,
									398.352,
									0
								]
							}
						],
						ix: 2,
						l: 2
					},
					a: {
						a: 0,
						k: [
							9.605,
							108.598,
							0
						],
						ix: 1,
						l: 2
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6,
						l: 2
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												9.605,
												9.605
											],
											[
												9.605,
												121.316
											],
											[
												9.605,
												207.591
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.564705882353,
										0.494117647059,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 19.21,
									ix: 5
								},
								lc: 2,
								lj: 1,
								ml: 2.61,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.235
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.679
										],
										y: [
											0
										]
									},
									t: 148.059,
									s: [
										16
									]
								},
								{
									i: {
										x: [
											0.252
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.743
										],
										y: [
											0
										]
									},
									t: 157,
									s: [
										33
									]
								},
								{
									i: {
										x: [
											0.259
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.703
										],
										y: [
											0
										]
									},
									t: 168.235,
									s: [
										16
									]
								},
								{
									i: {
										x: [
											0.257
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.73
										],
										y: [
											0
										]
									},
									t: 177.941,
									s: [
										33
									]
								},
								{
									t: 197.412109375,
									s: [
										16
									]
								}
							],
							ix: 1
						},
						e: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.235
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.679
										],
										y: [
											0
										]
									},
									t: 148.059,
									s: [
										83
									]
								},
								{
									i: {
										x: [
											0.252
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.743
										],
										y: [
											0
										]
									},
									t: 157,
									s: [
										69
									]
								},
								{
									i: {
										x: [
											0.259
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.703
										],
										y: [
											0
										]
									},
									t: 168.235,
									s: [
										83
									]
								},
								{
									i: {
										x: [
											0.257
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.73
										],
										y: [
											0
										]
									},
									t: 177.941,
									s: [
										69
									]
								},
								{
									t: 197,
									s: [
										83
									]
								}
							],
							ix: 2
						},
						o: {
							a: 0,
							k: 0,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					}
				],
				ip: 0,
				op: 200,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 5,
				ty: 4,
				nm: "line 3 Outlines 11",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.833,
									y: 0.833
								},
								o: {
									x: 0.167,
									y: 0.167
								},
								t: 184,
								s: [
									280.226,
									400,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 197,
								s: [
									280.226,
									400,
									0
								]
							}
						],
						ix: 2,
						l: 2
					},
					a: {
						a: 0,
						k: [
							9.605,
							108.598,
							0
						],
						ix: 1,
						l: 2
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6,
						l: 2
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												9.605,
												9.605
											],
											[
												9.605,
												207.591
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.564705882353,
										0.494117647059,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 19.21,
									ix: 5
								},
								lc: 2,
								lj: 1,
								ml: 2.61,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.235
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.679
										],
										y: [
											0
										]
									},
									t: 148.059,
									s: [
										28
									]
								},
								{
									i: {
										x: [
											0.252
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.743
										],
										y: [
											0
										]
									},
									t: 155,
									s: [
										33
									]
								},
								{
									i: {
										x: [
											0.259
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.703
										],
										y: [
											0
										]
									},
									t: 166.471,
									s: [
										28
									]
								},
								{
									i: {
										x: [
											0.257
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.73
										],
										y: [
											0
										]
									},
									t: 176.177,
									s: [
										33
									]
								},
								{
									t: 197.82421875,
									s: [
										28
									]
								}
							],
							ix: 1
						},
						e: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.235
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.679
										],
										y: [
											0
										]
									},
									t: 148.059,
									s: [
										70
									]
								},
								{
									i: {
										x: [
											0.252
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.743
										],
										y: [
											0
										]
									},
									t: 155,
									s: [
										69
									]
								},
								{
									i: {
										x: [
											0.259
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.703
										],
										y: [
											0
										]
									},
									t: 166.471,
									s: [
										70
									]
								},
								{
									i: {
										x: [
											0.257
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.73
										],
										y: [
											0
										]
									},
									t: 176.177,
									s: [
										69
									]
								},
								{
									t: 197.412109375,
									s: [
										70
									]
								}
							],
							ix: 2
						},
						o: {
							a: 0,
							k: 0,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					}
				],
				ip: 0,
				op: 200,
				st: 0,
				bm: 0
			}
		]
	}
];
var layers$2 = [
	{
		ddd: 0,
		ind: 1,
		ty: 0,
		nm: "mask",
		td: 1,
		refId: "comp_0",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					400,
					400,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					400,
					400,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		w: 800,
		h: 800,
		ip: 0,
		op: 200,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 2,
		ty: 4,
		nm: "bg circle Outlines",
		tt: 2,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					400,
					400,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					249.689,
					249.689,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-137.762,
										0
									],
									[
										0,
										-137.761
									],
									[
										137.762,
										0
									],
									[
										0,
										137.762
									]
								],
								o: [
									[
										137.762,
										0
									],
									[
										0,
										137.762
									],
									[
										-137.762,
										0
									],
									[
										0,
										-137.761
									]
								],
								v: [
									[
										0,
										-249.439
									],
									[
										249.439,
										-0.001
									],
									[
										0,
										249.439
									],
									[
										-249.439,
										-0.001
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "gf",
						o: {
							a: 0,
							k: 100,
							ix: 10
						},
						r: 1,
						bm: 0,
						g: {
							p: 3,
							k: {
								a: 0,
								k: [
									0,
									0.44313725490196076,
									0,
									1,
									0.385,
									0.44313725490196076,
									0,
									1,
									1,
									0.44313725490196076,
									0,
									1
								],
								ix: 9
							}
						},
						s: {
							a: 0,
							k: [
								-188,
								177
							],
							ix: 5
						},
						e: {
							a: 0,
							k: [
								169,
								-195
							],
							ix: 6
						},
						t: 1,
						nm: "Gradient Fill 1",
						mn: "ADBE Vector Graphic - G-Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								249.689,
								249.689
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 200,
		st: 0,
		bm: 0
	}
];
var markers$2 = [
];
var studioAnimationData = {
	v: v$7,
	fr: fr$2,
	ip: ip$2,
	op: op$2,
	w: w$6,
	h: h$7,
	nm: nm$2,
	ddd: ddd$2,
	assets: assets$2,
	layers: layers$2,
	markers: markers$2
};

var v$6 = "5.7.1";
var fr$1 = 30;
var ip$1 = 15.0000006109625;
var op$1 = 60;
var w$5 = 50;
var h$6 = 50;
var nm$1 = "Comp 2";
var ddd$1 = 0;
var assets$1 = [
];
var layers$1 = [
	{
		ddd: 0,
		ind: 1,
		ty: 4,
		nm: "music icon for micro interaction Outlines",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					24,
					25,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					6,
					7,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								1,
								1,
								-0.644
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								1.406
							]
						},
						t: 13,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								1,
								1,
								1.729
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0,
								0,
								1.77
							]
						},
						t: 26,
						s: [
							90,
							90,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								1,
								1,
								2.585
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0,
								0,
								-0.677
							]
						},
						t: 40,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								1
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0,
								0,
								-1.829
							]
						},
						t: 53,
						s: [
							90,
							90,
							100
						]
					},
					{
						t: 68.0000027696968,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6,
				x: "var $bm_rt;\nvar amp, freq, decay, n, time_max, n, t, t, v;\namp = 0.1;\nfreq = 2;\ndecay = 5;\nn = 0;\n$bm_rt = time_max = 4;\nif (numKeys > 0) {\n    $bm_rt = n = nearestKey(time).index;\n    if (key(n).time > time) {\n        n--;\n    }\n}\nif (n == 0) {\n    $bm_rt = t = 0;\n} else {\n    $bm_rt = t = $bm_sub(time, key(n).time);\n}\nif (n > 0 && t < time_max) {\n    v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10)));\n    $bm_rt = $bm_sum(value, $bm_div($bm_mul($bm_mul(v, amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))));\n} else {\n    $bm_rt = value;\n}"
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 13,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0.107,
													0.077
												],
												[
													0.137,
													-0.046
												],
												[
													0,
													0
												],
												[
													0,
													-0.185
												],
												[
													0,
													0
												],
												[
													0.516,
													0
												],
												[
													0,
													-1.28
												],
												[
													-1.262,
													0
												],
												[
													-0.045,
													1.233
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0.516,
													0
												],
												[
													0,
													-1.28
												],
												[
													-1.262,
													0
												],
												[
													-0.045,
													1.233
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													-0.154
												],
												[
													-0.121,
													-0.092
												],
												[
													0,
													0
												],
												[
													-0.183,
													0.061
												],
												[
													0,
													0
												],
												[
													-0.379,
													-0.293
												],
												[
													-1.262,
													0
												],
												[
													0,
													1.28
												],
												[
													1.216,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-0.38,
													-0.293
												],
												[
													-1.262,
													0
												],
												[
													0,
													1.28
												],
												[
													1.216,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													6,
													-6.175
												],
												[
													5.817,
													-6.545
												],
												[
													5.407,
													-6.607
												],
												[
													-2.048,
													-4.924
												],
												[
													-2.353,
													-4.492
												],
												[
													-2.353,
													2.466
												],
												[
													-3.72,
													2.003
												],
												[
													-6,
													4.317
												],
												[
													-3.72,
													6.632
												],
												[
													-1.456,
													4.41
												],
												[
													-1.456,
													4.347
												],
												[
													-1.456,
													-2.733
												],
												[
													5.088,
													-4.107
												],
												[
													5.088,
													1.014
												],
												[
													3.721,
													0.552
												],
												[
													1.44,
													2.866
												],
												[
													3.721,
													5.18
												],
												[
													5.984,
													2.959
												],
												[
													5.984,
													2.896
												],
												[
													5.984,
													-6.175
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 26,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0.107,
													0.077
												],
												[
													0.137,
													-0.046
												],
												[
													0,
													0
												],
												[
													0,
													-0.185
												],
												[
													0,
													0
												],
												[
													0.516,
													0
												],
												[
													0,
													-1.28
												],
												[
													-1.262,
													0
												],
												[
													-0.045,
													1.233
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0.516,
													0
												],
												[
													0,
													-1.28
												],
												[
													-1.262,
													0
												],
												[
													-0.045,
													1.233
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													-0.154
												],
												[
													-0.121,
													-0.092
												],
												[
													0,
													0
												],
												[
													-0.183,
													0.061
												],
												[
													0,
													0
												],
												[
													-0.379,
													-0.293
												],
												[
													-1.262,
													0
												],
												[
													0,
													1.28
												],
												[
													1.216,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-0.38,
													-0.293
												],
												[
													-1.262,
													0
												],
												[
													0,
													1.28
												],
												[
													1.216,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													6,
													-6.175
												],
												[
													5.817,
													-6.545
												],
												[
													5.407,
													-6.607
												],
												[
													-2.048,
													-4.924
												],
												[
													-2.353,
													-4.492
												],
												[
													-2.353,
													0.134
												],
												[
													-3.72,
													-0.329
												],
												[
													-6,
													1.985
												],
												[
													-3.72,
													4.3
												],
												[
													-1.456,
													2.078
												],
												[
													-1.456,
													2.015
												],
												[
													-1.456,
													-2.733
												],
												[
													5.088,
													-4.107
												],
												[
													5.088,
													3.983
												],
												[
													3.721,
													3.521
												],
												[
													1.44,
													5.835
												],
												[
													3.721,
													8.149
												],
												[
													5.984,
													5.928
												],
												[
													5.984,
													5.865
												],
												[
													5.984,
													-6.175
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 40,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0.107,
													0.077
												],
												[
													0.137,
													-0.046
												],
												[
													0,
													0
												],
												[
													0,
													-0.185
												],
												[
													0,
													0
												],
												[
													0.516,
													0
												],
												[
													0,
													-1.28
												],
												[
													-1.262,
													0
												],
												[
													-0.045,
													1.233
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0.516,
													0
												],
												[
													0,
													-1.28
												],
												[
													-1.262,
													0
												],
												[
													-0.045,
													1.233
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													-0.154
												],
												[
													-0.121,
													-0.092
												],
												[
													0,
													0
												],
												[
													-0.183,
													0.061
												],
												[
													0,
													0
												],
												[
													-0.379,
													-0.293
												],
												[
													-1.262,
													0
												],
												[
													0,
													1.28
												],
												[
													1.216,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-0.38,
													-0.293
												],
												[
													-1.262,
													0
												],
												[
													0,
													1.28
												],
												[
													1.216,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													6,
													-6.175
												],
												[
													5.817,
													-6.545
												],
												[
													5.407,
													-6.607
												],
												[
													-2.048,
													-4.924
												],
												[
													-2.353,
													-4.492
												],
												[
													-2.353,
													2.466
												],
												[
													-3.72,
													2.003
												],
												[
													-6,
													4.317
												],
												[
													-3.72,
													6.632
												],
												[
													-1.456,
													4.41
												],
												[
													-1.456,
													4.347
												],
												[
													-1.456,
													-2.733
												],
												[
													5.088,
													-4.107
												],
												[
													5.088,
													1.014
												],
												[
													3.721,
													0.552
												],
												[
													1.44,
													2.866
												],
												[
													3.721,
													5.18
												],
												[
													5.984,
													2.959
												],
												[
													5.984,
													2.896
												],
												[
													5.984,
													-6.175
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 53,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0.107,
													0.077
												],
												[
													0.137,
													-0.046
												],
												[
													0,
													0
												],
												[
													0,
													-0.185
												],
												[
													0,
													0
												],
												[
													0.516,
													0
												],
												[
													0,
													-1.28
												],
												[
													-1.262,
													0
												],
												[
													-0.045,
													1.233
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0.516,
													0
												],
												[
													0,
													-1.28
												],
												[
													-1.262,
													0
												],
												[
													-0.045,
													1.233
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													-0.154
												],
												[
													-0.121,
													-0.092
												],
												[
													0,
													0
												],
												[
													-0.183,
													0.061
												],
												[
													0,
													0
												],
												[
													-0.379,
													-0.293
												],
												[
													-1.262,
													0
												],
												[
													0,
													1.28
												],
												[
													1.216,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-0.38,
													-0.293
												],
												[
													-1.262,
													0
												],
												[
													0,
													1.28
												],
												[
													1.216,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													6,
													-6.175
												],
												[
													5.817,
													-6.545
												],
												[
													5.407,
													-6.607
												],
												[
													-2.048,
													-4.924
												],
												[
													-2.353,
													-4.492
												],
												[
													-2.353,
													0.134
												],
												[
													-3.72,
													-0.329
												],
												[
													-6,
													1.985
												],
												[
													-3.72,
													4.3
												],
												[
													-1.456,
													2.078
												],
												[
													-1.456,
													2.015
												],
												[
													-1.456,
													-2.733
												],
												[
													5.088,
													-4.107
												],
												[
													5.088,
													3.983
												],
												[
													3.721,
													3.521
												],
												[
													1.44,
													5.835
												],
												[
													3.721,
													8.149
												],
												[
													5.984,
													5.928
												],
												[
													5.984,
													5.865
												],
												[
													5.984,
													-6.175
												]
											],
											c: true
										}
									]
								},
								{
									t: 68.0000027696968,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0.107,
													0.077
												],
												[
													0.137,
													-0.046
												],
												[
													0,
													0
												],
												[
													0,
													-0.185
												],
												[
													0,
													0
												],
												[
													0.516,
													0
												],
												[
													0,
													-1.28
												],
												[
													-1.262,
													0
												],
												[
													-0.045,
													1.233
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0.516,
													0
												],
												[
													0,
													-1.28
												],
												[
													-1.262,
													0
												],
												[
													-0.045,
													1.233
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													-0.154
												],
												[
													-0.121,
													-0.092
												],
												[
													0,
													0
												],
												[
													-0.183,
													0.061
												],
												[
													0,
													0
												],
												[
													-0.379,
													-0.293
												],
												[
													-1.262,
													0
												],
												[
													0,
													1.28
												],
												[
													1.216,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-0.38,
													-0.293
												],
												[
													-1.262,
													0
												],
												[
													0,
													1.28
												],
												[
													1.216,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													6,
													-6.175
												],
												[
													5.817,
													-6.545
												],
												[
													5.407,
													-6.607
												],
												[
													-2.048,
													-4.924
												],
												[
													-2.353,
													-4.492
												],
												[
													-2.353,
													2.466
												],
												[
													-3.72,
													2.003
												],
												[
													-6,
													4.317
												],
												[
													-3.72,
													6.632
												],
												[
													-1.456,
													4.41
												],
												[
													-1.456,
													4.347
												],
												[
													-1.456,
													-2.733
												],
												[
													5.088,
													-4.107
												],
												[
													5.088,
													1.014
												],
												[
													3.721,
													0.552
												],
												[
													1.44,
													2.866
												],
												[
													3.721,
													5.18
												],
												[
													5.984,
													2.959
												],
												[
													5.984,
													2.896
												],
												[
													5.984,
													-6.175
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "mm",
						mm: 4,
						nm: "Merge Paths 1",
						mn: "ADBE Vector Filter - Merge",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.807843137254902,
								0.09411764705882353,
								0.4549019607843137,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								6,
								6.632
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 900.000036657751,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 2,
		ty: 4,
		nm: "Shape Layer 1",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 20,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					25.281,
					24.594,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-76.969,
					235.031,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								30,
								30
							],
							ix: 2
						},
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								-76.969,
								235.031
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 900.000036657751,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 3,
		ty: 4,
		nm: "Shape Layer 3",
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					25.281,
					24.594,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-76.969,
					235.031,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								30,
								30
							],
							ix: 2
						},
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								-76.969,
								235.031
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 900.000036657751,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 4,
		ty: 4,
		nm: "Shape Layer 2",
		tt: 2,
		sr: 1,
		ks: {
			o: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.173
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 4,
						s: [
							100
						]
					},
					{
						t: 45.0000018328876,
						s: [
							0
						]
					}
				],
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					24.989,
					24.739,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-76.011,
					241.239,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.253,
								0.253,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: -10,
						s: [
							0,
							0,
							100
						]
					},
					{
						t: 59.0000024031193,
						s: [
							134,
							134,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								37.478,
								37.478
							],
							ix: 2
						},
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								-76.011,
								241.239
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 900.000036657751,
		st: 0,
		bm: 0
	}
];
var markers$1 = [
];
var notesAnimationData = {
	v: v$6,
	fr: fr$1,
	ip: ip$1,
	op: op$1,
	w: w$5,
	h: h$6,
	nm: nm$1,
	ddd: ddd$1,
	assets: assets$1,
	layers: layers$1,
	markers: markers$1
};

var v$5 = "5.7.1";
var fr = 30;
var ip = 0;
var op = 41;
var w$4 = 800;
var h$5 = 800;
var nm = "Comp 3";
var ddd = 0;
var assets = [
];
var layers = [
	{
		ddd: 0,
		ind: 1,
		ty: 4,
		nm: "Shape Layer 5",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					408.24999999999994,
					398.75,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					8.25,
					-1.25,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-76.5,
										-1
									],
									[
										93,
										-1.5
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.667
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.333
										],
										y: [
											0
										]
									},
									t: 6,
									s: [
										0
									]
								},
								{
									i: {
										x: [
											0.667
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.333
										],
										y: [
											0
										]
									},
									t: 18,
									s: [
										66
									]
								},
								{
									t: 38.0000015477717,
									s: [
										0
									]
								}
							],
							ix: 1
						},
						e: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.667
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.333
										],
										y: [
											0
										]
									},
									t: 0,
									s: [
										0
									]
								},
								{
									i: {
										x: [
											0.667
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.333
										],
										y: [
											0
										]
									},
									t: 18,
									s: [
										100
									]
								},
								{
									t: 38.0000015477717,
									s: [
										0
									]
								}
							],
							ix: 2
						},
						o: {
							a: 0,
							k: 0,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 7,
							ix: 5
						},
						lc: 2,
						lj: 2,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.5,
								0.5,
								0.5,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Shape 1",
				np: 4,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 1798.00007323404,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 2,
		ty: 4,
		nm: "Shape Layer 4",
		sr: 1,
		ks: {
			o: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 20,
						s: [
							0
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 26,
						s: [
							100
						]
					},
					{
						t: 38.0000015477717,
						s: [
							0
						]
					}
				],
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					478,
					400.5,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-4.25,
					-0.5,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 20,
						s: [
							100,
							0,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 26,
						s: [
							100,
							103,
							100
						]
					},
					{
						t: 38.0000015477717,
						s: [
							100,
							0,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-4.5,
										-81
									],
									[
										-4,
										80
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 27,
							ix: 5
						},
						lc: 2,
						lj: 2,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.5,
								0.5,
								0.5,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Shape 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 20.0000008146167,
		op: 1818.00007404866,
		st: 20.0000008146167,
		bm: 0
	},
	{
		ddd: 0,
		ind: 3,
		ty: 4,
		nm: "Shape Layer 3",
		sr: 1,
		ks: {
			o: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 15,
						s: [
							0
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 21,
						s: [
							100
						]
					},
					{
						t: 31.0000012626559,
						s: [
							0
						]
					}
				],
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					430,
					401,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-4.25,
					-0.5,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 15,
						s: [
							100,
							0,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 21,
						s: [
							100,
							74,
							100
						]
					},
					{
						t: 31.0000012626559,
						s: [
							100,
							0,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-4.5,
										-81
									],
									[
										-4,
										80
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 27,
							ix: 5
						},
						lc: 2,
						lj: 2,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.5,
								0.5,
								0.5,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Shape 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 15.0000006109625,
		op: 1813.000073845,
		st: 15.0000006109625,
		bm: 0
	},
	{
		ddd: 0,
		ind: 4,
		ty: 4,
		nm: "Shape Layer 2",
		sr: 1,
		ks: {
			o: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 7,
						s: [
							0
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 13,
						s: [
							100
						]
					},
					{
						t: 24.00000097754,
						s: [
							0
						]
					}
				],
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					385,
					399.5,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-4.25,
					-0.5,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 7,
						s: [
							100,
							0,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 13,
						s: [
							100,
							103,
							100
						]
					},
					{
						t: 24.00000097754,
						s: [
							100,
							0,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-4.5,
										-81
									],
									[
										-4,
										80
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 27,
							ix: 5
						},
						lc: 2,
						lj: 2,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.5,
								0.5,
								0.5,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Shape 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 7.00000028511585,
		op: 1805.00007351916,
		st: 7.00000028511585,
		bm: 0
	},
	{
		ddd: 0,
		ind: 5,
		ty: 4,
		nm: "Shape Layer 1",
		sr: 1,
		ks: {
			o: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 0,
						s: [
							0
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 6,
						s: [
							100
						]
					},
					{
						t: 19.0000007738859,
						s: [
							0
						]
					}
				],
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					337.5,
					399.5,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-4.25,
					-0.5,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 0,
						s: [
							100,
							0,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 6,
						s: [
							100,
							82,
							100
						]
					},
					{
						t: 19.0000007738859,
						s: [
							100,
							0,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-4.5,
										-81
									],
									[
										-4,
										80
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 27,
							ix: 5
						},
						lc: 2,
						lj: 2,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.5,
								0.5,
								0.5,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Shape 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 1798.00007323404,
		st: 0,
		bm: 0
	}
];
var markers = [
];
var genericAnimationData = {
	v: v$5,
	fr: fr,
	ip: ip,
	op: op,
	w: w$4,
	h: h$5,
	nm: nm,
	ddd: ddd,
	assets: assets,
	layers: layers,
	markers: markers
};

const LoadingScreen = ({
  animationFile,
  title,
  text,
  loadingProgress,
  totalSteps,
  onCancel
}) => {
  const getAnimationFile = () => {
    switch (animationFile) {
      case 'studio':
        return studioAnimationData;
      case 'notes':
        return notesAnimationData;
      case 'generic':
        return genericAnimationData;
      default:
        return studioAnimationData;
    }
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: "loadingScreenContainer"
  }, /*#__PURE__*/React__default.createElement("h4", {
    className: "sr-only"
  }, "Status"), /*#__PURE__*/React__default.createElement(_default$1, {
    options: {
      loop: true,
      autoplay: true,
      animationData: getAnimationFile(),
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice"
      }
    },
    height: 200,
    width: 200
  }), /*#__PURE__*/React__default.createElement("p", {
    className: "text-sm font-medium dark:text-white "
  }, text), /*#__PURE__*/React__default.createElement("div", {
    className: "mt-4 w-40 mb-4",
    "aria-hidden": "true"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "bg-transparent rounded-full border border-primary overflow-hidden h-4"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "bg-primary rounded-full h-full",
    style: {
      width: `${Number(loadingProgress.downloadPercentage) * 0.9}%`
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "text-sm font-medium text-center"
  }, /*#__PURE__*/React__default.createElement("span", null, (loadingProgress.downloadPercentage * 0.9).toFixed(0), "%"))), /*#__PURE__*/React__default.createElement(Button, {
    type: "primary",
    onClick: onCancel
  }, "Cancel"));
};

const NoSessionLoaded = ({
  setlistSessions,
  setlistEnabled
}) => {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "flex flex-1 flex-col space-y-3 justify-start px-6 py-5 items-center text-center mt-8 dark:text-secondary-300"
  }, /*#__PURE__*/React__default.createElement(ForwardRef$f, {
    className: "w-20 h-20 "
  }), !setlistEnabled && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("h3", {
    className: "mt-2 text-sm font-medium"
  }, "No session loaded"), /*#__PURE__*/React__default.createElement(Link, {
    to: "/library"
  }, /*#__PURE__*/React__default.createElement(Button, null, "Go to Song library"))), setlistEnabled && setlistSessions.length === 0 && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("p", null, "Add a song to you setlist before to start a new session."), /*#__PURE__*/React__default.createElement(Link, {
    to: "/library"
  }, /*#__PURE__*/React__default.createElement(Button, null, "Go to Song library"))), setlistEnabled && setlistSessions.length > 0 && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("p", null, "Choose a song from your setlist to start a session"), /*#__PURE__*/React__default.createElement(Link, {
    to: "/setlist"
  }, /*#__PURE__*/React__default.createElement(Button, null, "Go to Your setlist"))));
};

function BellIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
  }));
}
const ForwardRef$2 = /*#__PURE__*/React.forwardRef(BellIcon);

function ExclamationIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
  }));
}
const ForwardRef$1 = /*#__PURE__*/React.forwardRef(ExclamationIcon);

function MicrophoneIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(MicrophoneIcon);

let mountedOnce = false;
const TourGuideContainer = ({
  title,
  text
}) => {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "flex flex-col justify-center align-middle"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "text-lg font-bold mb-2 text-primary"
  }, title), /*#__PURE__*/React__default.createElement("p", null, text));
};
const steps = [{
  selector: ".stem",
  content: /*#__PURE__*/React__default.createElement(TourGuideContainer, {
    title: "Song stem",
    text: "This is the stem content. You can change the volume of each part by tapping the group. As you turn down the stem, it will fade out to grey."
  })
}, {
  selector: "#transport",
  content: /*#__PURE__*/React__default.createElement(TourGuideContainer, {
    title: "Playback controls",
    text: "Use these to control playback of the song"
  })
}, {
  selector: "#section-button",
  content: /*#__PURE__*/React__default.createElement(TourGuideContainer, {
    title: "Song sections",
    text: "Skip between different song sectios with this button"
  })
}, {
  selector: "#solo-button",
  content: /*#__PURE__*/React__default.createElement(TourGuideContainer, {
    title: "Playback controls",
    text: "Clicking this will enable solo mode, which allows you to listen to just one part at a time. Click the section you'd like to solo"
  })
}, {
  selector: "#lyrics-button",
  content: /*#__PURE__*/React__default.createElement(TourGuideContainer, {
    title: "Show/Hide Lyrics",
    text: "View the songs lyrics while you listen to the song."
  })
}, {
  selector: "#pitch-speed-button",
  content: /*#__PURE__*/React__default.createElement(TourGuideContainer, {
    title: "Speed/Pitch",
    text: "You can change the speed and pitch of the playback independently"
  })
}, {
  selector: "#reset-button",
  content: /*#__PURE__*/React__default.createElement(TourGuideContainer, {
    title: "Reset mix",
    text: "If you'd like to reset everything back to the original settings, then tap reset!"
  })
}];
const Session = () => {
  const dispatch = useDispatch();
  const {
    setSteps,
    setIsOpen
  } = useTour();
  const session = useSelector(selectSession);
  useSelector(selectSession);
  const status = useSelector(selectStatus);
  const stems = useSelector(selectStems);
  const userStems = useSelector(selectUserStems);
  useSelector(selectDuration);
  const loadingProgress = useSelector(selectLoadingProgress);
  const soloMode = useSelector(selectSoloMode);
  const introLevel = useSelector(selectIntroLevel);
  const click1Level = useSelector(selectClick1Level);
  const click2Level = useSelector(selectClick2Level);
  const cueLevel = useSelector(selectCueLevel);
  const setlistSessions = useSelector(selectSetlistSessions);
  const newTrackModalVisible = useSelector(selectNewTrackModalVisible);
  const clientConfiguration = useSelector(selectClientConfig);
  const currentLyrics = useSelector(selectLyricsLyrics);
  const showLyrics = useSelector(selectShowLyrics);
  const lyricsStatus = useSelector(selectLyricsStatus);
  useState(false);
  const [lrcLyrics, setLrcLyrics] = useState(null);
  const [pendingNewChannelName, setPendingNewChannelName] = useState("");
  const [pendingDeleteChannel, setPendingDeleteChannel] = useState(false);
  const [showHeadphoneWarning, setShowHeadphoneWarning] = useState(false);
  const [showRecordArmWarning, setShowRecordArmWarning] = useState(false);
  const [currentTimeState, setCurrentTimeState] = useState(0);
  const navigate = useNavigate();
  useEffect(() => {
    if (session.song?.lyricsUrl && !lrcLyrics && lyricsStatus !== 'pending') dispatch(fetchLyricsAsync(session.song.lyricsUrl));
  }, [dispatch, lrcLyrics, session]);
  useEffect(() => {
    console.log(status);
    if (status === 'ready') {
      if (localStorage) {
        if (!localStorage.getItem('show_session_tour_guide')) {
          localStorage.setItem('show_session_tour_guide', 'true');
          setIsOpen(true);
        }
      }
    }
    if (status === "unmounted" || status !== "empty" && !mountedOnce) {
      dispatch(stopSong());
      dispatch(mountSessionAsync({
        cache: clientConfiguration.features.session.cacheOnMount
      }));
      dispatch(setSoloMode(false));
      turnUpAllStems();
    }
    if (status === "error") {
      console.trace("error");
      dispatch(setOfflineModalVisible(true));
    }
    mountedOnce = true;
  }, [status]);
  useEffect(() => {
    setShowLyrics(false);
    dispatch(resetLastCreated());
    setLrcLyrics(null);
    // if (soloMode) {
    //   turnUpAllStems();
    //   dispatch(setSoloMode(false));
    // }

    setSteps(steps);
    return () => {
      setSteps([]);
      setIsOpen(false);
      dispatch(setShowLyrics(false));
      dispatch(stopSong());
      if (session.song?.mix) dispatch(saveExistingSession(session));
    };
  }, []);
  const updateChannelGain = (channelId, value) => {
    const channel = stems.concat(userStems).find(channel => channelId === channel.id);
    dispatch(changeChannelGain({
      index: channel.index,
      value,
      userStem: channel.isInputChannel
    }));
  };
  const updateChannelPan = (channelId, value) => {
    const channel = stems.concat(userStems).find(channel => channelId === channel.id);
    dispatch(changeChannelPan({
      index: channel.index,
      value,
      userStem: channel.isInputChannel
    }));
  };
  const updateChannelMute = channelId => {
    const channel = stems.concat(userStems).find(channel => channelId === channel.id);
    dispatch(channel.muted ? unmuteChannel({
      index: channel.index,
      userStem: channel.isInputChannel
    }) : muteChannel({
      index: channel.index,
      userStem: channel.isInputChannel
    }));
  };
  const updateChannelSolo = (channelId, solo) => {
    if (soloMode) {
      const channel = stems.concat(userStems).find(channel => channelId === channel.id);
      dispatch(changeChannelGain({
        index: channel.index,
        value: 1,
        userStem: channel.isInputChannel
      }));
      const otherChannels = stems.concat(userStems).filter(channel => channelId !== channel.id);
      for (const otherChannel of otherChannels) {
        dispatch(changeChannelGain({
          index: otherChannel.index,
          value: 0,
          userStem: otherChannel.isInputChannel
        }));
      }
    } else {
      const channel = stems.concat(userStems).find(channel => channelId === channel.id);
      dispatch(channel.soloed ? unsoloChannel({
        index: channel.index,
        userStem: channel.isInputChannel
      }) : soloChannel({
        index: channel.index,
        userStem: channel.isInputChannel
      }));
    }
  };
  const updateChannelArm = async channelId => {
    await dispatch(attachUserMicrophoneAsync());
    const channel = stems.concat(userStems).find(channel => channelId === channel.id);
    dispatch(channel.armed ? disarmChannel({
      index: channel.index,
      userStem: channel.isInputChannel
    }) : armChannel({
      index: channel.index,
      userStem: channel.isInputChannel
    }));
  };
  const addStem = async () => {
    dispatch(setNewTrackModalVisible(true));
    dispatch(setNewTrackModalVisible(true));
  };
  const confirmAddStem = async () => {
    if (pendingNewChannelName) {
      await dispatch(attachUserMicrophoneAsync());
      dispatch(addNewStem({
        name: pendingNewChannelName
      }));
      setPendingNewChannelName("");
      dispatch(setNewTrackModalVisible(false));
      dispatch(addNotificationAsync({
        title: "Track added to session",
        text: `${pendingNewChannelName} added to the session
        `,
        type: "positive"
      }));
    }
  };
  const shareSession = async () => {
    await dispatch(packSessionAsync());
    dispatch(addNotificationAsync({
      title: "Session downloaded",
      text: `The session was packed up into a .session file and downloaded`,
      type: "positive"
    }));
  };
  const downloadSession = async () => {
    await dispatch(saveExistingSession(session));
    await dispatch(mountSessionAndRenderOfflineAsync({
      cache: clientConfiguration.features.session.cacheOnMount
    }));
    dispatch(addNotificationAsync({
      title: "Session downloaded",
      text: `The session mix was bounced down and downloaded.`,
      type: "positive"
    }));
  };
  const resetSession = async () => {
    await dispatch(resetSessionMixerSettings());
    dispatch(addNotificationAsync({
      title: "Session reset",
      text: `All the mixer settings for the session were reset.`,
      type: "positive"
    }));
  };
  const deleteStem = async channelId => {
    const channel = stems.concat(userStems).find(channel => channelId === channel.id);
    if (channel.isInputChannel) {
      setPendingDeleteChannel(channel);
    }
  };
  const confirmDeleteTrack = async () => {
    await dispatch(removeChannelAsync(pendingDeleteChannel));
    setPendingDeleteChannel(false);
  };
  const handleCancel = async () => {
    await dispatch(unmountSessionAsync());
    navigate('/library');
    setTimeout(() => window.location.reload(), 100);
  };
  const formLrcLyrics = lyricsArray => {
    let lrcString = '';
    for (const line of lyricsArray) {
      lrcString = lrcString + `[${new Date(1000 * line.time).toISOString().substr(14, 8)}] ${line.text}\n`;
    }
    return lrcString;
  };
  useEffect(() => {
    if (currentLyrics) {
      setLrcLyrics(formLrcLyrics(currentLyrics));
    } else {
      setLrcLyrics(null);
    }
  }, [currentLyrics]);
  useEffect(() => {
    const currentTimeInterval = setInterval(() => {
      setCurrentTimeState(audioEngine.currentPosition);
    }, 100);
    return () => {
      dispatch(setSoloMode(false));
      // turnUpAllStems()
      clearInterval(currentTimeInterval);
    };
  }, []);
  const turnUpAllStems = () => {
    for (const stem of stems.concat(userStems)) {
      dispatch(changeChannelGain({
        index: stem.index,
        value: 1,
        userStem: stem.isInputChannel
      }));
    }
  };
  useEffect(() => {
    if (soloMode) {
      //turn down level of all channels
      // turnDownAllStems()
      turnUpAllStems();
    }
  }, [soloMode]);
  const renderMixer = () => {
    switch (clientConfiguration.features.session.mixerTemplate) {
      case 'choir':
        return /*#__PURE__*/React__default.createElement(ChoirConductor, {
          showMixRecord: clientConfiguration.features.session.showMixRecord,
          showMixControls: clientConfiguration.features.session.showMixControls,
          stems: stems.concat(userStems),
          getVuLevel: audioEngine.getChannelPeak,
          onFaderChange: updateChannelGain,
          onPanChange: updateChannelPan,
          onMuteStem: updateChannelMute,
          onSoloStem: updateChannelSolo,
          onArmStem: updateChannelArm,
          onDeleteStem: deleteStem,
          onSave: (a, b, c) => {
            // console.log(a, b, c);
          },
          onAddStem: addStem,
          onDownload: downloadSession,
          onShare: shareSession,
          onReset: resetSession,
          onChangeIntroLevel: newValue => dispatch(setIntroLevel(newValue)),
          onChangeClick1Level: newValue => dispatch(setClick1Level(newValue)),
          onChangeClick2Level: newValue => dispatch(setClick2Level(newValue)),
          onChangeCueLevel: newValue => dispatch(setCueLevel(newValue))
          // onSoloModeToggle={handleSoloModeToggle}
          ,
          step: 0.5,
          showGuideChannelButtons: false,
          introLevel: introLevel,
          click1Level: click1Level,
          click2Level: click2Level,
          cueLevel: cueLevel,
          lyrics: lrcLyrics,
          currentTimeMilliseconds: currentTimeState,
          showLyricsButton: true,
          lyricsActive: showLyrics,
          onClickLyricsButton: () => dispatch(setShowLyrics(!showLyrics)),
          soloMode: soloMode
        });
      case 'band':
        return /*#__PURE__*/React__default.createElement(MixBoard, {
          stems: stems.concat(userStems),
          getVuLevel: audioEngine.getChannelPeak,
          onFaderChange: updateChannelGain,
          onPanChange: updateChannelPan,
          onMuteStem: updateChannelMute,
          onSoloStem: updateChannelSolo,
          onArmStem: updateChannelArm,
          onDeleteStem: deleteStem,
          onSave: (a, b, c) => {
            // console.log(a, b, c);
          },
          onAddStem: addStem,
          onDownload: downloadSession,
          onShare: shareSession,
          onReset: resetSession,
          onChangeIntroLevel: newValue => dispatch(setIntroLevel(newValue)),
          onChangeClick1Level: newValue => dispatch(setClick1Level(newValue)),
          onChangeClick2Level: newValue => dispatch(setClick2Level(newValue)),
          onChangeCueLevel: newValue => dispatch(setCueLevel(newValue)),
          step: 0.5,
          showGuideChannelButtons: false,
          introLevel: introLevel,
          click1Level: click1Level,
          click2Level: click2Level,
          cueLevel: cueLevel
        });
      default:
        return /*#__PURE__*/React__default.createElement("div", null, "No template provided");
    }
  };
  const getLoadingText = () => {
    switch (loadingProgress.step) {
      case 0:
        return "Booting session...";
      case 1:
        return "Downloading song";
      case 2:
        return "Downloading song";
      case 3:
        return "Loading song into memory";
      case 4:
        return "Starting engine...";
      case 5:
        return "Ready to roll...";
      case 6:
        return "Packing up session...";
      case 7:
        return "Loading offline render...";
      case 8:
        return "Rendering bounce...";
      case 9:
        return "Creating download...";
    }
  };
  // console.log(stems);
  return status === "ready" && mountedOnce ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, renderMixer(), /*#__PURE__*/React__default.createElement(Modal, {
    isOpen: pendingDeleteChannel ? true : false,
    title: "Delete channel?",
    text: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", null, "Are you sure you'd like to remove", " ", /*#__PURE__*/React__default.createElement("b", null, pendingDeleteChannel.label), " from the session and all associated recordings that have been made on it?")),
    confirmLabel: "Yes, delete it",
    icon: /*#__PURE__*/React__default.createElement(ForwardRef$1, {
      className: "h-6 w-6 text-primary",
      "aria-hidden": "true"
    }),
    closeLabel: "Cancel",
    onClose: () => {
      setPendingDeleteChannel(false);
    },
    onConfirm: confirmDeleteTrack
  }), /*#__PURE__*/React__default.createElement(Modal, {
    isOpen: newTrackModalVisible,
    title: "New channel",
    content: /*#__PURE__*/React__default.createElement("div", {
      className: "w-full"
    }, /*#__PURE__*/React__default.createElement("p", null, "Please provide a name for the new channel"), /*#__PURE__*/React__default.createElement(Input, {
      onChange: e => setPendingNewChannelName(e.target.value),
      placeholder: "eg Vocals",
      autofocus: true,
      label: "Name",
      size: "md",
      type: "text",
      className: "w-full border rounded-md my-4 p-2",
      autocomplete: "off"
    })),
    confirmLabel: "Add",
    icon: /*#__PURE__*/React__default.createElement(ForwardRef, {
      className: "h-6 w-6 text-primary",
      "aria-hidden": "true"
    }),
    closeLabel: "Cancel",
    onClose: () => {
      dispatch(setUserInputtingText(false));
    },
    onConfirm: confirmAddStem
  }), /*#__PURE__*/React__default.createElement(Modal, {
    isOpen: showHeadphoneWarning ? true : false,
    title: "Have you got headphones plugged in?",
    text: "You'll want to use headphones while recording to prevent feedback from the speakers",
    confirmLabel: "Okay",
    icon: /*#__PURE__*/React__default.createElement(ForwardRef, {
      className: "h-6 w-6 text-primary",
      "aria-hidden": "true"
    }),
    onConfirm: () => setShowHeadphoneWarning(false)
  }), /*#__PURE__*/React__default.createElement(Modal, {
    isOpen: showRecordArmWarning ? true : false,
    title: "No armed tracks",
    text: "You'll need to add a track and record arm it to record into this session",
    confirmLabel: "Okay",
    icon: /*#__PURE__*/React__default.createElement(ForwardRef, {
      className: "h-6 w-6 text-primary",
      "aria-hidden": "true"
    }),
    onConfirm: () => setShowRecordArmWarning(false)
  })) : status === "empty" ? /*#__PURE__*/React__default.createElement(NoSessionLoaded, {
    setlistEnabled: clientConfiguration.features.setlist.enabled,
    setlistSessions: setlistSessions
  }) : /*#__PURE__*/React__default.createElement(LoadingScreen, {
    animationFile: clientConfiguration.features.session.loadingAnimationFile,
    title: "Loading session",
    text: getLoadingText(),
    loadingProgress: loadingProgress,
    totalSteps: 9,
    onCancel: handleCancel
  });
};

function memo(getDeps, fn, opts) {
  let deps = opts.initialDeps ?? [];
  let result;
  return () => {
    var _a, _b, _c, _d;
    let depTime;
    if (opts.key && ((_a = opts.debug) == null ? void 0 : _a.call(opts))) depTime = Date.now();
    const newDeps = getDeps();
    const depsChanged = newDeps.length !== deps.length || newDeps.some((dep, index) => deps[index] !== dep);
    if (!depsChanged) {
      return result;
    }
    deps = newDeps;
    let resultTime;
    if (opts.key && ((_b = opts.debug) == null ? void 0 : _b.call(opts))) resultTime = Date.now();
    result = fn(...newDeps);
    if (opts.key && ((_c = opts.debug) == null ? void 0 : _c.call(opts))) {
      const depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
      const resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
      const resultFpsPercentage = resultEndTime / 16;
      const pad = (str, num) => {
        str = String(str);
        while (str.length < num) {
          str = " " + str;
        }
        return str;
      };
      console.info(`%c⏱ ${pad(resultEndTime, 5)} /${pad(depEndTime, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * resultFpsPercentage, 120))}deg 100% 31%);`, opts == null ? void 0 : opts.key);
    }
    (_d = opts == null ? void 0 : opts.onChange) == null ? void 0 : _d.call(opts, result);
    return result;
  };
}
function notUndefined(value, msg) {
  if (value === void 0) {
    throw new Error(`Unexpected undefined${msg ? `: ${msg}` : ""}`);
  } else {
    return value;
  }
}
const approxEqual = (a, b) => Math.abs(a - b) < 1;
const debounce = (targetWindow, fn, ms) => {
  let timeoutId;
  return function (...args) {
    targetWindow.clearTimeout(timeoutId);
    timeoutId = targetWindow.setTimeout(() => fn.apply(this, args), ms);
  };
};

const defaultKeyExtractor = index => index;
const defaultRangeExtractor = range => {
  const start = Math.max(range.startIndex - range.overscan, 0);
  const end = Math.min(range.endIndex + range.overscan, range.count - 1);
  const arr = [];
  for (let i = start; i <= end; i++) {
    arr.push(i);
  }
  return arr;
};
const observeElementRect = (instance, cb) => {
  const element = instance.scrollElement;
  if (!element) {
    return;
  }
  const targetWindow = instance.targetWindow;
  if (!targetWindow) {
    return;
  }
  const handler = rect => {
    const {
      width,
      height
    } = rect;
    cb({
      width: Math.round(width),
      height: Math.round(height)
    });
  };
  handler(element.getBoundingClientRect());
  if (!targetWindow.ResizeObserver) {
    return () => {};
  }
  const observer = new targetWindow.ResizeObserver(entries => {
    const entry = entries[0];
    if (entry == null ? void 0 : entry.borderBoxSize) {
      const box = entry.borderBoxSize[0];
      if (box) {
        handler({
          width: box.inlineSize,
          height: box.blockSize
        });
        return;
      }
    }
    handler(element.getBoundingClientRect());
  });
  observer.observe(element, {
    box: "border-box"
  });
  return () => {
    observer.unobserve(element);
  };
};
const addEventListenerOptions = {
  passive: true
};
const supportsScrollend = typeof window == "undefined" ? true : "onscrollend" in window;
const observeElementOffset = (instance, cb) => {
  const element = instance.scrollElement;
  if (!element) {
    return;
  }
  const targetWindow = instance.targetWindow;
  if (!targetWindow) {
    return;
  }
  let offset = 0;
  const fallback = supportsScrollend ? () => void 0 : debounce(targetWindow, () => {
    cb(offset, false);
  }, instance.options.isScrollingResetDelay);
  const createHandler = isScrolling => () => {
    offset = element[instance.options.horizontal ? "scrollLeft" : "scrollTop"];
    fallback();
    cb(offset, isScrolling);
  };
  const handler = createHandler(true);
  const endHandler = createHandler(false);
  endHandler();
  element.addEventListener("scroll", handler, addEventListenerOptions);
  element.addEventListener("scrollend", endHandler, addEventListenerOptions);
  return () => {
    element.removeEventListener("scroll", handler);
    element.removeEventListener("scrollend", endHandler);
  };
};
const measureElement = (element, entry, instance) => {
  if (entry == null ? void 0 : entry.borderBoxSize) {
    const box = entry.borderBoxSize[0];
    if (box) {
      const size = Math.round(box[instance.options.horizontal ? "inlineSize" : "blockSize"]);
      return size;
    }
  }
  return Math.round(element.getBoundingClientRect()[instance.options.horizontal ? "width" : "height"]);
};
const elementScroll = (offset, {
  adjustments = 0,
  behavior
}, instance) => {
  var _a, _b;
  const toOffset = offset + adjustments;
  (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null ? void 0 : _b.call(_a, {
    [instance.options.horizontal ? "left" : "top"]: toOffset,
    behavior
  });
};
class Virtualizer {
  constructor(opts) {
    this.unsubs = [];
    this.scrollElement = null;
    this.targetWindow = null;
    this.isScrolling = false;
    this.scrollToIndexTimeoutId = null;
    this.measurementsCache = [];
    this.itemSizeCache = /* @__PURE__ */new Map();
    this.pendingMeasuredCacheIndexes = [];
    this.scrollRect = null;
    this.scrollOffset = null;
    this.scrollDirection = null;
    this.scrollAdjustments = 0;
    this.elementsCache = /* @__PURE__ */new Map();
    this.observer = /* @__PURE__ */(() => {
      let _ro = null;
      const get = () => {
        if (_ro) {
          return _ro;
        }
        if (!this.targetWindow || !this.targetWindow.ResizeObserver) {
          return null;
        }
        return _ro = new this.targetWindow.ResizeObserver(entries => {
          entries.forEach(entry => {
            this._measureElement(entry.target, entry);
          });
        });
      };
      return {
        disconnect: () => {
          var _a;
          return (_a = get()) == null ? void 0 : _a.disconnect();
        },
        observe: target => {
          var _a;
          return (_a = get()) == null ? void 0 : _a.observe(target, {
            box: "border-box"
          });
        },
        unobserve: target => {
          var _a;
          return (_a = get()) == null ? void 0 : _a.unobserve(target);
        }
      };
    })();
    this.range = null;
    this.setOptions = opts2 => {
      Object.entries(opts2).forEach(([key, value]) => {
        if (typeof value === "undefined") delete opts2[key];
      });
      this.options = {
        debug: false,
        initialOffset: 0,
        overscan: 1,
        paddingStart: 0,
        paddingEnd: 0,
        scrollPaddingStart: 0,
        scrollPaddingEnd: 0,
        horizontal: false,
        getItemKey: defaultKeyExtractor,
        rangeExtractor: defaultRangeExtractor,
        onChange: () => {},
        measureElement,
        initialRect: {
          width: 0,
          height: 0
        },
        scrollMargin: 0,
        gap: 0,
        indexAttribute: "data-index",
        initialMeasurementsCache: [],
        lanes: 1,
        isScrollingResetDelay: 150,
        enabled: true,
        ...opts2
      };
    };
    this.notify = (force, sync) => {
      var _a, _b;
      const {
        startIndex,
        endIndex
      } = this.range ?? {
        startIndex: void 0,
        endIndex: void 0
      };
      const range = this.calculateRange();
      if (force || startIndex !== (range == null ? void 0 : range.startIndex) || endIndex !== (range == null ? void 0 : range.endIndex)) {
        (_b = (_a = this.options).onChange) == null ? void 0 : _b.call(_a, this, sync);
      }
    };
    this.cleanup = () => {
      this.unsubs.filter(Boolean).forEach(d => d());
      this.unsubs = [];
      this.scrollElement = null;
      this.targetWindow = null;
      this.observer.disconnect();
      this.elementsCache.clear();
    };
    this._didMount = () => {
      return () => {
        this.cleanup();
      };
    };
    this._willUpdate = () => {
      var _a;
      const scrollElement = this.options.enabled ? this.options.getScrollElement() : null;
      if (this.scrollElement !== scrollElement) {
        this.cleanup();
        if (!scrollElement) {
          this.notify(false, false);
          return;
        }
        this.scrollElement = scrollElement;
        if (this.scrollElement && "ownerDocument" in this.scrollElement) {
          this.targetWindow = this.scrollElement.ownerDocument.defaultView;
        } else {
          this.targetWindow = ((_a = this.scrollElement) == null ? void 0 : _a.window) ?? null;
        }
        this._scrollToOffset(this.getScrollOffset(), {
          adjustments: void 0,
          behavior: void 0
        });
        this.unsubs.push(this.options.observeElementRect(this, rect => {
          this.scrollRect = rect;
          this.notify(false, false);
        }));
        this.unsubs.push(this.options.observeElementOffset(this, (offset, isScrolling) => {
          this.scrollAdjustments = 0;
          this.scrollDirection = isScrolling ? this.getScrollOffset() < offset ? "forward" : "backward" : null;
          this.scrollOffset = offset;
          const prevIsScrolling = this.isScrolling;
          this.isScrolling = isScrolling;
          this.notify(prevIsScrolling !== isScrolling, isScrolling);
        }));
      }
    };
    this.getSize = () => {
      if (!this.options.enabled) {
        this.scrollRect = null;
        return 0;
      }
      this.scrollRect = this.scrollRect ?? this.options.initialRect;
      return this.scrollRect[this.options.horizontal ? "width" : "height"];
    };
    this.getScrollOffset = () => {
      if (!this.options.enabled) {
        this.scrollOffset = null;
        return 0;
      }
      this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset === "function" ? this.options.initialOffset() : this.options.initialOffset);
      return this.scrollOffset;
    };
    this.getFurthestMeasurement = (measurements, index) => {
      const furthestMeasurementsFound = /* @__PURE__ */new Map();
      const furthestMeasurements = /* @__PURE__ */new Map();
      for (let m = index - 1; m >= 0; m--) {
        const measurement = measurements[m];
        if (furthestMeasurementsFound.has(measurement.lane)) {
          continue;
        }
        const previousFurthestMeasurement = furthestMeasurements.get(measurement.lane);
        if (previousFurthestMeasurement == null || measurement.end > previousFurthestMeasurement.end) {
          furthestMeasurements.set(measurement.lane, measurement);
        } else if (measurement.end < previousFurthestMeasurement.end) {
          furthestMeasurementsFound.set(measurement.lane, true);
        }
        if (furthestMeasurementsFound.size === this.options.lanes) {
          break;
        }
      }
      return furthestMeasurements.size === this.options.lanes ? Array.from(furthestMeasurements.values()).sort((a, b) => {
        if (a.end === b.end) {
          return a.index - b.index;
        }
        return a.end - b.end;
      })[0] : void 0;
    };
    this.getMeasurementOptions = memo(() => [this.options.count, this.options.paddingStart, this.options.scrollMargin, this.options.getItemKey, this.options.enabled], (count, paddingStart, scrollMargin, getItemKey, enabled) => {
      this.pendingMeasuredCacheIndexes = [];
      return {
        count,
        paddingStart,
        scrollMargin,
        getItemKey,
        enabled
      };
    }, {
      key: false
    });
    this.getMeasurements = memo(() => [this.getMeasurementOptions(), this.itemSizeCache], ({
      count,
      paddingStart,
      scrollMargin,
      getItemKey,
      enabled
    }, itemSizeCache) => {
      var _a;
      if (!enabled) {
        this.measurementsCache = [];
        this.itemSizeCache.clear();
        return [];
      }
      if (this.measurementsCache.length === 0) {
        this.measurementsCache = this.options.initialMeasurementsCache;
        this.measurementsCache.forEach(item => {
          this.itemSizeCache.set(item.key, item.size);
        });
      }
      const min = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
      this.pendingMeasuredCacheIndexes = [];
      const measurements = this.measurementsCache.slice(0, min);
      for (let i = min; i < count; i++) {
        let measureElement2 = (_a = this.measurementsCache[i]) == null ? void 0 : _a.measureElement;
        if (!measureElement2) {
          measureElement2 = node => {
            const key2 = getItemKey(i);
            const prevNode = this.elementsCache.get(key2);
            if (!node) {
              if (prevNode) {
                this.observer.unobserve(prevNode);
                this.elementsCache.delete(key2);
              }
              return;
            }
            if (prevNode !== node) {
              if (prevNode) {
                this.observer.unobserve(prevNode);
              }
              this.observer.observe(node);
              this.elementsCache.set(key2, node);
            }
            if (node.isConnected) {
              this.resizeItem(i, this.options.measureElement(node, void 0, this));
            }
          };
        }
        const key = getItemKey(i);
        const furthestMeasurement = this.options.lanes === 1 ? measurements[i - 1] : this.getFurthestMeasurement(measurements, i);
        const start = furthestMeasurement ? furthestMeasurement.end + this.options.gap : paddingStart + scrollMargin;
        const measuredSize = itemSizeCache.get(key);
        const size = typeof measuredSize === "number" ? measuredSize : this.options.estimateSize(i);
        const end = start + size;
        const lane = furthestMeasurement ? furthestMeasurement.lane : i % this.options.lanes;
        measurements[i] = {
          index: i,
          start,
          size,
          end,
          key,
          lane,
          measureElement: measureElement2
        };
      }
      this.measurementsCache = measurements;
      return measurements;
    }, {
      key: process.env.NODE_ENV !== "production" && "getMeasurements",
      debug: () => this.options.debug
    });
    this.calculateRange = memo(() => [this.getMeasurements(), this.getSize(), this.getScrollOffset()], (measurements, outerSize, scrollOffset) => {
      return this.range = measurements.length > 0 && outerSize > 0 ? calculateRange({
        measurements,
        outerSize,
        scrollOffset
      }) : null;
    }, {
      key: process.env.NODE_ENV !== "production" && "calculateRange",
      debug: () => this.options.debug
    });
    this.getIndexes = memo(() => [this.options.rangeExtractor, this.calculateRange(), this.options.overscan, this.options.count], (rangeExtractor, range, overscan, count) => {
      return range === null ? [] : rangeExtractor({
        startIndex: range.startIndex,
        endIndex: range.endIndex,
        overscan,
        count
      });
    }, {
      key: process.env.NODE_ENV !== "production" && "getIndexes",
      debug: () => this.options.debug
    });
    this.indexFromElement = node => {
      const attributeName = this.options.indexAttribute;
      const indexStr = node.getAttribute(attributeName);
      if (!indexStr) {
        console.warn(`Missing attribute name '${attributeName}={index}' on measured element.`);
        return -1;
      }
      return parseInt(indexStr, 10);
    };
    this._measureElement = (node, entry) => {
      const i = this.indexFromElement(node);
      const item = this.getMeasurements()[i];
      if (!item || !node.isConnected) {
        this.elementsCache.forEach((cached, key) => {
          if (cached === node) {
            this.observer.unobserve(node);
            this.elementsCache.delete(key);
          }
        });
        return;
      }
      const prevNode = this.elementsCache.get(item.key);
      if (prevNode !== node) {
        if (prevNode) {
          this.observer.unobserve(prevNode);
        }
        this.observer.observe(node);
        this.elementsCache.set(item.key, node);
      }
      this.resizeItem(i, this.options.measureElement(node, entry, this));
    };
    this.resizeItem = (index, size) => {
      const item = this.getMeasurements()[index];
      if (!item) {
        return;
      }
      const itemSize = this.itemSizeCache.get(item.key) ?? item.size;
      const delta = size - itemSize;
      if (delta !== 0) {
        if (this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(item, delta, this) : item.start < this.getScrollOffset() + this.scrollAdjustments) {
          if (process.env.NODE_ENV !== "production" && this.options.debug) {
            console.info("correction", delta);
          }
          this._scrollToOffset(this.getScrollOffset(), {
            adjustments: this.scrollAdjustments += delta,
            behavior: void 0
          });
        }
        this.pendingMeasuredCacheIndexes.push(item.index);
        this.itemSizeCache = new Map(this.itemSizeCache.set(item.key, size));
        this.notify(true, false);
      }
    };
    this.measureElement = node => {
      if (!node) {
        return;
      }
      this._measureElement(node, void 0);
    };
    this.getVirtualItems = memo(() => [this.getIndexes(), this.getMeasurements()], (indexes, measurements) => {
      const virtualItems = [];
      for (let k = 0, len = indexes.length; k < len; k++) {
        const i = indexes[k];
        const measurement = measurements[i];
        virtualItems.push(measurement);
      }
      return virtualItems;
    }, {
      key: process.env.NODE_ENV !== "production" && "getIndexes",
      debug: () => this.options.debug
    });
    this.getVirtualItemForOffset = offset => {
      const measurements = this.getMeasurements();
      if (measurements.length === 0) {
        return void 0;
      }
      return notUndefined(measurements[findNearestBinarySearch(0, measurements.length - 1, index => notUndefined(measurements[index]).start, offset)]);
    };
    this.getOffsetForAlignment = (toOffset, align) => {
      const size = this.getSize();
      const scrollOffset = this.getScrollOffset();
      if (align === "auto") {
        if (toOffset <= scrollOffset) {
          align = "start";
        } else if (toOffset >= scrollOffset + size) {
          align = "end";
        } else {
          align = "start";
        }
      }
      if (align === "start") {
        toOffset = toOffset;
      } else if (align === "end") {
        toOffset = toOffset - size;
      } else if (align === "center") {
        toOffset = toOffset - size / 2;
      }
      const scrollSizeProp = this.options.horizontal ? "scrollWidth" : "scrollHeight";
      const scrollSize = this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[scrollSizeProp] : this.scrollElement[scrollSizeProp] : 0;
      const maxOffset = scrollSize - size;
      return Math.max(Math.min(maxOffset, toOffset), 0);
    };
    this.getOffsetForIndex = (index, align = "auto") => {
      index = Math.max(0, Math.min(index, this.options.count - 1));
      const item = this.getMeasurements()[index];
      if (!item) {
        return void 0;
      }
      const size = this.getSize();
      const scrollOffset = this.getScrollOffset();
      if (align === "auto") {
        if (item.end >= scrollOffset + size - this.options.scrollPaddingEnd) {
          align = "end";
        } else if (item.start <= scrollOffset + this.options.scrollPaddingStart) {
          align = "start";
        } else {
          return [scrollOffset, align];
        }
      }
      const toOffset = align === "end" ? item.end + this.options.scrollPaddingEnd : item.start - this.options.scrollPaddingStart;
      return [this.getOffsetForAlignment(toOffset, align), align];
    };
    this.isDynamicMode = () => this.elementsCache.size > 0;
    this.cancelScrollToIndex = () => {
      if (this.scrollToIndexTimeoutId !== null && this.targetWindow) {
        this.targetWindow.clearTimeout(this.scrollToIndexTimeoutId);
        this.scrollToIndexTimeoutId = null;
      }
    };
    this.scrollToOffset = (toOffset, {
      align = "start",
      behavior
    } = {}) => {
      this.cancelScrollToIndex();
      if (behavior === "smooth" && this.isDynamicMode()) {
        console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
      }
      this._scrollToOffset(this.getOffsetForAlignment(toOffset, align), {
        adjustments: void 0,
        behavior
      });
    };
    this.scrollToIndex = (index, {
      align: initialAlign = "auto",
      behavior
    } = {}) => {
      index = Math.max(0, Math.min(index, this.options.count - 1));
      this.cancelScrollToIndex();
      if (behavior === "smooth" && this.isDynamicMode()) {
        console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
      }
      const offsetAndAlign = this.getOffsetForIndex(index, initialAlign);
      if (!offsetAndAlign) return;
      const [offset, align] = offsetAndAlign;
      this._scrollToOffset(offset, {
        adjustments: void 0,
        behavior
      });
      if (behavior !== "smooth" && this.isDynamicMode() && this.targetWindow) {
        this.scrollToIndexTimeoutId = this.targetWindow.setTimeout(() => {
          this.scrollToIndexTimeoutId = null;
          const elementInDOM = this.elementsCache.has(this.options.getItemKey(index));
          if (elementInDOM) {
            const [latestOffset] = notUndefined(this.getOffsetForIndex(index, align));
            if (!approxEqual(latestOffset, this.getScrollOffset())) {
              this.scrollToIndex(index, {
                align,
                behavior
              });
            }
          } else {
            this.scrollToIndex(index, {
              align,
              behavior
            });
          }
        });
      }
    };
    this.scrollBy = (delta, {
      behavior
    } = {}) => {
      this.cancelScrollToIndex();
      if (behavior === "smooth" && this.isDynamicMode()) {
        console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
      }
      this._scrollToOffset(this.getScrollOffset() + delta, {
        adjustments: void 0,
        behavior
      });
    };
    this.getTotalSize = () => {
      var _a;
      const measurements = this.getMeasurements();
      let end;
      if (measurements.length === 0) {
        end = this.options.paddingStart;
      } else {
        end = this.options.lanes === 1 ? ((_a = measurements[measurements.length - 1]) == null ? void 0 : _a.end) ?? 0 : Math.max(...measurements.slice(-this.options.lanes).map(m => m.end));
      }
      return end - this.options.scrollMargin + this.options.paddingEnd;
    };
    this._scrollToOffset = (offset, {
      adjustments,
      behavior
    }) => {
      this.options.scrollToFn(offset, {
        behavior,
        adjustments
      }, this);
    };
    this.measure = () => {
      var _a, _b;
      this.itemSizeCache = /* @__PURE__ */new Map();
      (_b = (_a = this.options).onChange) == null ? void 0 : _b.call(_a, this, false);
    };
    this.setOptions(opts);
  }
}
const findNearestBinarySearch = (low, high, getCurrentValue, value) => {
  while (low <= high) {
    const middle = (low + high) / 2 | 0;
    const currentValue = getCurrentValue(middle);
    if (currentValue < value) {
      low = middle + 1;
    } else if (currentValue > value) {
      high = middle - 1;
    } else {
      return middle;
    }
  }
  if (low > 0) {
    return low - 1;
  } else {
    return 0;
  }
};
function calculateRange({
  measurements,
  outerSize,
  scrollOffset
}) {
  const count = measurements.length - 1;
  const getOffset = index => measurements[index].start;
  const startIndex = findNearestBinarySearch(0, count, getOffset, scrollOffset);
  let endIndex = startIndex;
  while (endIndex < count && measurements[endIndex].end < scrollOffset + outerSize) {
    endIndex++;
  }
  return {
    startIndex,
    endIndex
  };
}

const useIsomorphicLayoutEffect = typeof document !== "undefined" ? React.useLayoutEffect : React.useEffect;
function useVirtualizerBase(options) {
  const rerender = React.useReducer(() => ({}), {})[1];
  const resolvedOptions = {
    ...options,
    onChange: (instance2, sync) => {
      var _a;
      if (sync) {
        flushSync(rerender);
      } else {
        rerender();
      }
      (_a = options.onChange) == null ? void 0 : _a.call(options, instance2, sync);
    }
  };
  const [instance] = React.useState(() => new Virtualizer(resolvedOptions));
  instance.setOptions(resolvedOptions);
  React.useEffect(() => {
    return instance._didMount();
  }, []);
  useIsomorphicLayoutEffect(() => {
    return instance._willUpdate();
  });
  return instance;
}
function useVirtualizer(options) {
  return useVirtualizerBase({
    observeElementRect,
    observeElementOffset,
    scrollToFn: elementScroll,
    ...options
  });
}

var i$7 = Object.defineProperty;
var d$9 = (t, e, n) => e in t ? i$7(t, e, {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: n
}) : t[e] = n;
var r$5 = (t, e, n) => (d$9(t, typeof e != "symbol" ? e + "" : e, n), n);
class o$9 {
  constructor() {
    r$5(this, "current", this.detect());
    r$5(this, "handoffState", "pending");
    r$5(this, "currentId", 0);
  }
  set(e) {
    this.current !== e && (this.handoffState = "pending", this.currentId = 0, this.current = e);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window == "undefined" || typeof document == "undefined" ? "server" : "client";
  }
  handoff() {
    this.handoffState === "pending" && (this.handoffState = "complete");
  }
  get isHandoffComplete() {
    return this.handoffState === "complete";
  }
}
let s$c = new o$9();

let l$7 = (e, f) => {
  s$c.isServer ? useEffect(e, f) : useLayoutEffect$1(e, f);
};

function s$b(e) {
  let r = useRef(e);
  return l$7(() => {
    r.current = e;
  }, [e]), r;
}

function i$6(e, o) {
  let [u, t] = useState(e),
    r = s$b(e);
  return l$7(() => t(r.current), [r, t, ...o]), u;
}

let o$8 = function (t) {
  let e = s$b(t);
  return React__default.useCallback((...r) => e.current(...r), [e]);
};

function T$3(l, r, c) {
  let [i, s] = useState(c),
    e = l !== void 0,
    t = useRef(e),
    u = useRef(!1),
    d = useRef(!1);
  return e && !t.current && !u.current ? (u.current = !0, t.current = e, console.error("A component is changing from uncontrolled to controlled. This may be caused by the value changing from undefined to a defined value, which should not happen.")) : !e && t.current && !d.current && (d.current = !0, t.current = e, console.error("A component is changing from controlled to uncontrolled. This may be caused by the value changing from a defined value to undefined, which should not happen.")), [e ? l : i, o$8(n => (e || s(n), r == null ? void 0 : r(n)))];
}

function t$a(e) {
  typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch(o => setTimeout(() => {
    throw o;
  }));
}

function o$7() {
  let n = [],
    r = {
      addEventListener(e, t, s, a) {
        return e.addEventListener(t, s, a), r.add(() => e.removeEventListener(t, s, a));
      },
      requestAnimationFrame(...e) {
        let t = requestAnimationFrame(...e);
        return r.add(() => cancelAnimationFrame(t));
      },
      nextFrame(...e) {
        return r.requestAnimationFrame(() => r.requestAnimationFrame(...e));
      },
      setTimeout(...e) {
        let t = setTimeout(...e);
        return r.add(() => clearTimeout(t));
      },
      microTask(...e) {
        let t = {
          current: !0
        };
        return t$a(() => {
          t.current && e[0]();
        }), r.add(() => {
          t.current = !1;
        });
      },
      style(e, t, s) {
        let a = e.style.getPropertyValue(t);
        return Object.assign(e.style, {
          [t]: s
        }), this.add(() => {
          Object.assign(e.style, {
            [t]: a
          });
        });
      },
      group(e) {
        let t = o$7();
        return e(t), this.add(() => t.dispose());
      },
      add(e) {
        return n.push(e), () => {
          let t = n.indexOf(e);
          if (t >= 0) for (let s of n.splice(t, 1)) s();
        };
      },
      dispose() {
        for (let e of n.splice(0)) e();
      }
    };
  return r;
}

function p$5() {
  let [e] = useState(o$7);
  return useEffect(() => () => e.dispose(), [e]), e;
}

function s$a() {
  let r = typeof document == "undefined";
  return "useSyncExternalStore" in React ? (o => o.useSyncExternalStore)(React)(() => () => {}, () => !1, () => !r) : !1;
}
function l$6() {
  let r = s$a(),
    [e, n] = React.useState(s$c.isHandoffComplete);
  return e && s$c.isHandoffComplete === !1 && n(!1), React.useEffect(() => {
    e !== !0 && n(!0);
  }, [e]), React.useEffect(() => s$c.handoff(), []), r ? !1 : e;
}

var o$6;
let I$6 = (o$6 = React__default.useId) != null ? o$6 : function () {
  let n = l$6(),
    [e, u] = React__default.useState(n ? () => s$c.nextId() : null);
  return l$7(() => {
    e === null && u(s$c.nextId());
  }, [e]), e != null ? "" + e : void 0;
};

function u$9(r, n, ...a) {
  if (r in n) {
    let e = n[r];
    return typeof e == "function" ? e(...a) : e;
  }
  let t = new Error(`Tried to handle "${r}" but there is no handler defined. Only defined handlers are: ${Object.keys(n).map(e => `"${e}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(t, u$9), t;
}

function o$5(r) {
  return s$c.isServer ? null : r instanceof Node ? r.ownerDocument : r != null && r.hasOwnProperty("current") && r.current instanceof Node ? r.current.ownerDocument : document;
}

let c$7 = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map(e => `${e}:not([tabindex='-1'])`).join(",");
var M$3 = (n => (n[n.First = 1] = "First", n[n.Previous = 2] = "Previous", n[n.Next = 4] = "Next", n[n.Last = 8] = "Last", n[n.WrapAround = 16] = "WrapAround", n[n.NoScroll = 32] = "NoScroll", n))(M$3 || {}),
  N$2 = (o => (o[o.Error = 0] = "Error", o[o.Overflow = 1] = "Overflow", o[o.Success = 2] = "Success", o[o.Underflow = 3] = "Underflow", o))(N$2 || {}),
  F$6 = (t => (t[t.Previous = -1] = "Previous", t[t.Next = 1] = "Next", t))(F$6 || {});
function f$8(e = document.body) {
  return e == null ? [] : Array.from(e.querySelectorAll(c$7)).sort((r, t) => Math.sign((r.tabIndex || Number.MAX_SAFE_INTEGER) - (t.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var T$2 = (t => (t[t.Strict = 0] = "Strict", t[t.Loose = 1] = "Loose", t))(T$2 || {});
function h$4(e, r = 0) {
  var t;
  return e === ((t = o$5(e)) == null ? void 0 : t.body) ? !1 : u$9(r, {
    [0]() {
      return e.matches(c$7);
    },
    [1]() {
      let l = e;
      for (; l !== null;) {
        if (l.matches(c$7)) return !0;
        l = l.parentElement;
      }
      return !1;
    }
  });
}
function D$3(e) {
  let r = o$5(e);
  o$7().nextFrame(() => {
    r && !h$4(r.activeElement, 0) && y$4(e);
  });
}
var w$3 = (t => (t[t.Keyboard = 0] = "Keyboard", t[t.Mouse = 1] = "Mouse", t))(w$3 || {});
typeof window != "undefined" && typeof document != "undefined" && (document.addEventListener("keydown", e => {
  e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", e => {
  e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function y$4(e) {
  e == null || e.focus({
    preventScroll: !0
  });
}
let S$6 = ["textarea", "input"].join(",");
function H(e) {
  var r, t;
  return (t = (r = e == null ? void 0 : e.matches) == null ? void 0 : r.call(e, S$6)) != null ? t : !1;
}
function I$5(e, r = t => t) {
  return e.slice().sort((t, l) => {
    let o = r(t),
      i = r(l);
    if (o === null || i === null) return 0;
    let n = o.compareDocumentPosition(i);
    return n & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : n & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function _$3(e, r) {
  return O$1(f$8(), r, {
    relativeTo: e
  });
}
function O$1(e, r, {
  sorted: t = !0,
  relativeTo: l = null,
  skipElements: o = []
} = {}) {
  let i = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e.ownerDocument,
    n = Array.isArray(e) ? t ? I$5(e) : e : f$8(e);
  o.length > 0 && n.length > 1 && (n = n.filter(s => !o.includes(s))), l = l != null ? l : i.activeElement;
  let E = (() => {
      if (r & 5) return 1;
      if (r & 10) return -1;
      throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
    })(),
    x = (() => {
      if (r & 1) return 0;
      if (r & 2) return Math.max(0, n.indexOf(l)) - 1;
      if (r & 4) return Math.max(0, n.indexOf(l)) + 1;
      if (r & 8) return n.length - 1;
      throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
    })(),
    p = r & 32 ? {
      preventScroll: !0
    } : {},
    d = 0,
    a = n.length,
    u;
  do {
    if (d >= a || d + a <= 0) return 0;
    let s = x + d;
    if (r & 16) s = (s + a) % a;else {
      if (s < 0) return 3;
      if (s >= a) return 1;
    }
    u = n[s], u == null || u.focus(p), d += E;
  } while (u !== i.activeElement);
  return r & 6 && H(u) && u.select(), 2;
}

function t$9() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function i$5() {
  return /Android/gi.test(window.navigator.userAgent);
}
function n$5() {
  return t$9() || i$5();
}

function d$8(e, r, n) {
  let o = s$b(r);
  useEffect(() => {
    function t(u) {
      o.current(u);
    }
    return document.addEventListener(e, t, n), () => document.removeEventListener(e, t, n);
  }, [e, n]);
}

function s$9(e, r, n) {
  let o = s$b(r);
  useEffect(() => {
    function t(i) {
      o.current(i);
    }
    return window.addEventListener(e, t, n), () => window.removeEventListener(e, t, n);
  }, [e, n]);
}

function y$3(s, m, a = !0) {
  let i = useRef(!1);
  useEffect(() => {
    requestAnimationFrame(() => {
      i.current = a;
    });
  }, [a]);
  function c(e, r) {
    if (!i.current || e.defaultPrevented) return;
    let t = r(e);
    if (t === null || !t.getRootNode().contains(t) || !t.isConnected) return;
    let E = function u(n) {
      return typeof n == "function" ? u(n()) : Array.isArray(n) || n instanceof Set ? n : [n];
    }(s);
    for (let u of E) {
      if (u === null) continue;
      let n = u instanceof HTMLElement ? u : u.current;
      if (n != null && n.contains(t) || e.composed && e.composedPath().includes(n)) return;
    }
    return !h$4(t, T$2.Loose) && t.tabIndex !== -1 && e.preventDefault(), m(e, t);
  }
  let o = useRef(null);
  d$8("pointerdown", e => {
    var r, t;
    i.current && (o.current = ((t = (r = e.composedPath) == null ? void 0 : r.call(e)) == null ? void 0 : t[0]) || e.target);
  }, !0), d$8("mousedown", e => {
    var r, t;
    i.current && (o.current = ((t = (r = e.composedPath) == null ? void 0 : r.call(e)) == null ? void 0 : t[0]) || e.target);
  }, !0), d$8("click", e => {
    n$5() || o.current && (c(e, () => o.current), o.current = null);
  }, !0), d$8("touchend", e => c(e, () => e.target instanceof HTMLElement ? e.target : null), !0), s$9("blur", e => c(e, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}

function n$4(...e) {
  return useMemo(() => o$5(...e), [...e]);
}

function i$4(t) {
  var n;
  if (t.type) return t.type;
  let e = (n = t.as) != null ? n : "button";
  if (typeof e == "string" && e.toLowerCase() === "button") return "button";
}
function T$1(t, e) {
  let [n, u] = useState(() => i$4(t));
  return l$7(() => {
    u(i$4(t));
  }, [t.type, t.as]), l$7(() => {
    n || e.current && e.current instanceof HTMLButtonElement && !e.current.hasAttribute("type") && u("button");
  }, [n, e]), n;
}

let u$8 = Symbol();
function T(t, n = !0) {
  return Object.assign(t, {
    [u$8]: n
  });
}
function y$2(...t) {
  let n = useRef(t);
  useEffect(() => {
    n.current = t;
  }, [t]);
  let c = o$8(e => {
    for (let o of n.current) o != null && (typeof o == "function" ? o(e) : o.current = e);
  });
  return t.every(e => e == null || (e == null ? void 0 : e[u$8])) ? void 0 : c;
}

function t$8(e) {
  return [e.screenX, e.screenY];
}
function u$7() {
  let e = useRef([-1, -1]);
  return {
    wasMoved(r) {
      let n = t$8(r);
      return e.current[0] === n[0] && e.current[1] === n[1] ? !1 : (e.current = n, !0);
    },
    update(r) {
      e.current = t$8(r);
    }
  };
}

function F$5({
  container: e,
  accept: t,
  walk: r,
  enabled: c = !0
}) {
  let o = useRef(t),
    l = useRef(r);
  useEffect(() => {
    o.current = t, l.current = r;
  }, [t, r]), l$7(() => {
    if (!e || !c) return;
    let n = o$5(e);
    if (!n) return;
    let f = o.current,
      p = l.current,
      d = Object.assign(i => f(i), {
        acceptNode: f
      }),
      u = n.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, d, !1);
    for (; u.nextNode();) p(u.currentNode);
  }, [e, c, o, l]);
}

function m$3(u, t) {
  let e = useRef([]),
    r = o$8(u);
  useEffect(() => {
    let o = [...e.current];
    for (let [n, a] of t.entries()) if (e.current[n] !== a) {
      let l = r(t, o);
      return e.current = t, l;
    }
  }, [r, ...t]);
}

function t$7(...r) {
  return Array.from(new Set(r.flatMap(n => typeof n == "string" ? n.split(" ") : []))).filter(Boolean).join(" ");
}

var O = (n => (n[n.None = 0] = "None", n[n.RenderStrategy = 1] = "RenderStrategy", n[n.Static = 2] = "Static", n))(O || {}),
  v$4 = (e => (e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))(v$4 || {});
function C$2({
  ourProps: r,
  theirProps: t,
  slot: e,
  defaultTag: n,
  features: o,
  visible: a = !0,
  name: f,
  mergeRefs: l
}) {
  l = l != null ? l : k$1;
  let s = R(t, r);
  if (a) return m$2(s, e, n, f, l);
  let y = o != null ? o : 0;
  if (y & 2) {
    let {
      static: u = !1,
      ...d
    } = s;
    if (u) return m$2(d, e, n, f, l);
  }
  if (y & 1) {
    let {
      unmount: u = !0,
      ...d
    } = s;
    return u$9(u ? 0 : 1, {
      [0]() {
        return null;
      },
      [1]() {
        return m$2({
          ...d,
          hidden: !0,
          style: {
            display: "none"
          }
        }, e, n, f, l);
      }
    });
  }
  return m$2(s, e, n, f, l);
}
function m$2(r, t = {}, e, n, o) {
  let {
      as: a = e,
      children: f,
      refName: l = "ref",
      ...s
    } = F$4(r, ["unmount", "static"]),
    y = r.ref !== void 0 ? {
      [l]: r.ref
    } : {},
    u = typeof f == "function" ? f(t) : f;
  "className" in s && s.className && typeof s.className == "function" && (s.className = s.className(t));
  let d = {};
  if (t) {
    let i = !1,
      c = [];
    for (let [T, p] of Object.entries(t)) typeof p == "boolean" && (i = !0), p === !0 && c.push(T);
    i && (d["data-headlessui-state"] = c.join(" "));
  }
  if (a === Fragment && Object.keys(x$1(s)).length > 0) {
    if (! /*#__PURE__*/isValidElement(u) || Array.isArray(u) && u.length > 1) throw new Error(['Passing props on "Fragment"!', "", `The current component <${n} /> is rendering a "Fragment".`, "However we need to passthrough the following props:", Object.keys(s).map(p => `  - ${p}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".', "Render a single element as the child so that we can forward the props onto that element."].map(p => `  - ${p}`).join(`
`)].join(`
`));
    let i = u.props,
      c = typeof (i == null ? void 0 : i.className) == "function" ? (...p) => t$7(i == null ? void 0 : i.className(...p), s.className) : t$7(i == null ? void 0 : i.className, s.className),
      T = c ? {
        className: c
      } : {};
    return /*#__PURE__*/cloneElement(u, Object.assign({}, R(u.props, x$1(F$4(s, ["ref"]))), d, y, {
      ref: o(u.ref, y.ref)
    }, T));
  }
  return /*#__PURE__*/createElement(a, Object.assign({}, F$4(s, ["ref"]), a !== Fragment && y, a !== Fragment && d), u);
}
function I$4() {
  let r = useRef([]),
    t = useCallback(e => {
      for (let n of r.current) n != null && (typeof n == "function" ? n(e) : n.current = e);
    }, []);
  return (...e) => {
    if (!e.every(n => n == null)) return r.current = e, t;
  };
}
function k$1(...r) {
  return r.every(t => t == null) ? void 0 : t => {
    for (let e of r) e != null && (typeof e == "function" ? e(t) : e.current = t);
  };
}
function R(...r) {
  if (r.length === 0) return {};
  if (r.length === 1) return r[0];
  let t = {},
    e = {};
  for (let o of r) for (let a in o) a.startsWith("on") && typeof o[a] == "function" ? ((e[a]) != null || (e[a] = []), e[a].push(o[a])) : t[a] = o[a];
  if (t.disabled || t["aria-disabled"]) return Object.assign(t, Object.fromEntries(Object.keys(e).map(o => [o, void 0])));
  for (let o in e) Object.assign(t, {
    [o](a, ...f) {
      let l = e[o];
      for (let s of l) {
        if ((a instanceof Event || (a == null ? void 0 : a.nativeEvent) instanceof Event) && a.defaultPrevented) return;
        s(a, ...f);
      }
    }
  });
  return t;
}
function U$3(r) {
  var t;
  return Object.assign( /*#__PURE__*/forwardRef(r), {
    displayName: (t = r.displayName) != null ? t : r.name
  });
}
function x$1(r) {
  let t = Object.assign({}, r);
  for (let e in t) t[e] === void 0 && delete t[e];
  return t;
}
function F$4(r, t = []) {
  let e = Object.assign({}, r);
  for (let n of t) n in e && delete e[n];
  return e;
}

let p$4 = "div";
var s$8 = (e => (e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))(s$8 || {});
function l$5(d, o) {
  var n;
  let {
      features: t = 1,
      ...e
    } = d,
    r = {
      ref: o,
      "aria-hidden": (t & 2) === 2 ? !0 : (n = e["aria-hidden"]) != null ? n : void 0,
      hidden: (t & 4) === 4 ? !0 : void 0,
      style: {
        position: "fixed",
        top: 1,
        left: 1,
        width: 1,
        height: 0,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        borderWidth: "0",
        ...((t & 4) === 4 && (t & 2) !== 2 && {
          display: "none"
        })
      }
    };
  return C$2({
    ourProps: r,
    theirProps: e,
    slot: {},
    defaultTag: p$4,
    name: "Hidden"
  });
}
let u$6 = U$3(l$5);

let n$3 = /*#__PURE__*/createContext(null);
n$3.displayName = "OpenClosedContext";
var d$7 = (e => (e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))(d$7 || {});
function u$5() {
  return useContext(n$3);
}
function s$7({
  value: o,
  children: r
}) {
  return /*#__PURE__*/React__default.createElement(n$3.Provider, {
    value: o
  }, r);
}

function t$6(n) {
  function e() {
    document.readyState !== "loading" && (n(), document.removeEventListener("DOMContentLoaded", e));
  }
  typeof window != "undefined" && typeof document != "undefined" && (document.addEventListener("DOMContentLoaded", e), e());
}

let t$5 = [];
t$6(() => {
  function e(n) {
    n.target instanceof HTMLElement && n.target !== document.body && t$5[0] !== n.target && (t$5.unshift(n.target), t$5 = t$5.filter(r => r != null && r.isConnected), t$5.splice(10));
  }
  window.addEventListener("click", e, {
    capture: !0
  }), window.addEventListener("mousedown", e, {
    capture: !0
  }), window.addEventListener("focus", e, {
    capture: !0
  }), document.body.addEventListener("click", e, {
    capture: !0
  }), document.body.addEventListener("mousedown", e, {
    capture: !0
  }), document.body.addEventListener("focus", e, {
    capture: !0
  });
});

function r$4(n) {
  let e = n.parentElement,
    l = null;
  for (; e && !(e instanceof HTMLFieldSetElement);) e instanceof HTMLLegendElement && (l = e), e = e.parentElement;
  let t = (e == null ? void 0 : e.getAttribute("disabled")) === "";
  return t && i$3(l) ? !1 : t;
}
function i$3(n) {
  if (!n) return !1;
  let e = n.previousElementSibling;
  for (; e !== null;) {
    if (e instanceof HTMLLegendElement) return !1;
    e = e.previousElementSibling;
  }
  return !0;
}

function u$4(l) {
  throw new Error("Unexpected object: " + l);
}
var c$6 = (i => (i[i.First = 0] = "First", i[i.Previous = 1] = "Previous", i[i.Next = 2] = "Next", i[i.Last = 3] = "Last", i[i.Specific = 4] = "Specific", i[i.Nothing = 5] = "Nothing", i))(c$6 || {});
function f$7(l, n) {
  let t = n.resolveItems();
  if (t.length <= 0) return null;
  let r = n.resolveActiveIndex(),
    s = r != null ? r : -1;
  switch (l.focus) {
    case 0:
      {
        for (let e = 0; e < t.length; ++e) if (!n.resolveDisabled(t[e], e, t)) return e;
        return r;
      }
    case 1:
      {
        for (let e = s - 1; e >= 0; --e) if (!n.resolveDisabled(t[e], e, t)) return e;
        return r;
      }
    case 2:
      {
        for (let e = s + 1; e < t.length; ++e) if (!n.resolveDisabled(t[e], e, t)) return e;
        return r;
      }
    case 3:
      {
        for (let e = t.length - 1; e >= 0; --e) if (!n.resolveDisabled(t[e], e, t)) return e;
        return r;
      }
    case 4:
      {
        for (let e = 0; e < t.length; ++e) if (n.resolveId(t[e], e, t) === l.id) return e;
        return r;
      }
    case 5:
      return null;
    default:
      u$4(l);
  }
}

function e$3(i = {}, s = null, t = []) {
  for (let [r, n] of Object.entries(i)) o$4(t, f$6(s, r), n);
  return t;
}
function f$6(i, s) {
  return i ? i + "[" + s + "]" : s;
}
function o$4(i, s, t) {
  if (Array.isArray(t)) for (let [r, n] of t.entries()) o$4(i, f$6(s, r.toString()), n);else t instanceof Date ? i.push([s, t.toISOString()]) : typeof t == "boolean" ? i.push([s, t ? "1" : "0"]) : typeof t == "string" ? i.push([s, t]) : typeof t == "number" ? i.push([s, `${t}`]) : t == null ? i.push([s, ""]) : e$3(t, s, i);
}
function p$3(i) {
  var t, r;
  let s = (t = i == null ? void 0 : i.form) != null ? t : i.closest("form");
  if (s) {
    for (let n of s.elements) if (n !== i && (n.tagName === "INPUT" && n.type === "submit" || n.tagName === "BUTTON" && n.type === "submit" || n.nodeName === "INPUT" && n.type === "image")) {
      n.click();
      return;
    }
    (r = s.requestSubmit) == null || r.call(s);
  }
}

var o$3 = (r => (r.Space = " ", r.Enter = "Enter", r.Escape = "Escape", r.Backspace = "Backspace", r.Delete = "Delete", r.ArrowLeft = "ArrowLeft", r.ArrowUp = "ArrowUp", r.ArrowRight = "ArrowRight", r.ArrowDown = "ArrowDown", r.Home = "Home", r.End = "End", r.PageUp = "PageUp", r.PageDown = "PageDown", r.Tab = "Tab", r))(o$3 || {});

var $e$3 = (o => (o[o.Open = 0] = "Open", o[o.Closed = 1] = "Closed", o))($e$3 || {}),
  qe$3 = (o => (o[o.Single = 0] = "Single", o[o.Multi = 1] = "Multi", o))(qe$3 || {}),
  ze$3 = (a => (a[a.Pointer = 0] = "Pointer", a[a.Focus = 1] = "Focus", a[a.Other = 2] = "Other", a))(ze$3 || {}),
  Ye$3 = (e => (e[e.OpenCombobox = 0] = "OpenCombobox", e[e.CloseCombobox = 1] = "CloseCombobox", e[e.GoToOption = 2] = "GoToOption", e[e.RegisterOption = 3] = "RegisterOption", e[e.UnregisterOption = 4] = "UnregisterOption", e[e.RegisterLabel = 5] = "RegisterLabel", e[e.SetActivationTrigger = 6] = "SetActivationTrigger", e[e.UpdateVirtualOptions = 7] = "UpdateVirtualOptions", e))(Ye$3 || {});
function de$3(t, r = o => o) {
  let o = t.activeOptionIndex !== null ? t.options[t.activeOptionIndex] : null,
    a = r(t.options.slice()),
    i = a.length > 0 && a[0].dataRef.current.order !== null ? a.sort((p, c) => p.dataRef.current.order - c.dataRef.current.order) : I$5(a, p => p.dataRef.current.domRef.current),
    u = o ? i.indexOf(o) : null;
  return u === -1 && (u = null), {
    options: i,
    activeOptionIndex: u
  };
}
let Qe$3 = {
    [1](t) {
      var r;
      return (r = t.dataRef.current) != null && r.disabled || t.comboboxState === 1 ? t : {
        ...t,
        activeOptionIndex: null,
        comboboxState: 1
      };
    },
    [0](t) {
      var r, o;
      if ((r = t.dataRef.current) != null && r.disabled || t.comboboxState === 0) return t;
      if ((o = t.dataRef.current) != null && o.value) {
        let a = t.dataRef.current.calculateIndex(t.dataRef.current.value);
        if (a !== -1) return {
          ...t,
          activeOptionIndex: a,
          comboboxState: 0
        };
      }
      return {
        ...t,
        comboboxState: 0
      };
    },
    [2](t, r) {
      var u, p, c, e, l;
      if ((u = t.dataRef.current) != null && u.disabled || (p = t.dataRef.current) != null && p.optionsRef.current && !((c = t.dataRef.current) != null && c.optionsPropsRef.current.static) && t.comboboxState === 1) return t;
      if (t.virtual) {
        let T = r.focus === c$6.Specific ? r.idx : f$7(r, {
            resolveItems: () => t.virtual.options,
            resolveActiveIndex: () => {
              var f, v;
              return (v = (f = t.activeOptionIndex) != null ? f : t.virtual.options.findIndex(S => !t.virtual.disabled(S))) != null ? v : null;
            },
            resolveDisabled: t.virtual.disabled,
            resolveId() {
              throw new Error("Function not implemented.");
            }
          }),
          g = (e = r.trigger) != null ? e : 2;
        return t.activeOptionIndex === T && t.activationTrigger === g ? t : {
          ...t,
          activeOptionIndex: T,
          activationTrigger: g
        };
      }
      let o = de$3(t);
      if (o.activeOptionIndex === null) {
        let T = o.options.findIndex(g => !g.dataRef.current.disabled);
        T !== -1 && (o.activeOptionIndex = T);
      }
      let a = r.focus === c$6.Specific ? r.idx : f$7(r, {
          resolveItems: () => o.options,
          resolveActiveIndex: () => o.activeOptionIndex,
          resolveId: T => T.id,
          resolveDisabled: T => T.dataRef.current.disabled
        }),
        i = (l = r.trigger) != null ? l : 2;
      return t.activeOptionIndex === a && t.activationTrigger === i ? t : {
        ...t,
        ...o,
        activeOptionIndex: a,
        activationTrigger: i
      };
    },
    [3]: (t, r) => {
      var u, p, c;
      if ((u = t.dataRef.current) != null && u.virtual) return {
        ...t,
        options: [...t.options, r.payload]
      };
      let o = r.payload,
        a = de$3(t, e => (e.push(o), e));
      t.activeOptionIndex === null && (p = t.dataRef.current) != null && p.isSelected(r.payload.dataRef.current.value) && (a.activeOptionIndex = a.options.indexOf(o));
      let i = {
        ...t,
        ...a,
        activationTrigger: 2
      };
      return (c = t.dataRef.current) != null && c.__demoMode && t.dataRef.current.value === void 0 && (i.activeOptionIndex = 0), i;
    },
    [4]: (t, r) => {
      var a;
      if ((a = t.dataRef.current) != null && a.virtual) return {
        ...t,
        options: t.options.filter(i => i.id !== r.id)
      };
      let o = de$3(t, i => {
        let u = i.findIndex(p => p.id === r.id);
        return u !== -1 && i.splice(u, 1), i;
      });
      return {
        ...t,
        ...o,
        activationTrigger: 2
      };
    },
    [5]: (t, r) => t.labelId === r.id ? t : {
      ...t,
      labelId: r.id
    },
    [6]: (t, r) => t.activationTrigger === r.trigger ? t : {
      ...t,
      activationTrigger: r.trigger
    },
    [7]: (t, r) => {
      var a;
      if (((a = t.virtual) == null ? void 0 : a.options) === r.options) return t;
      let o = t.activeOptionIndex;
      if (t.activeOptionIndex !== null) {
        let i = r.options.indexOf(t.virtual.options[t.activeOptionIndex]);
        i !== -1 ? o = i : o = null;
      }
      return {
        ...t,
        activeOptionIndex: o,
        virtual: Object.assign({}, t.virtual, {
          options: r.options
        })
      };
    }
  },
  be$2 = /*#__PURE__*/createContext(null);
be$2.displayName = "ComboboxActionsContext";
function ee$3(t) {
  let r = useContext(be$2);
  if (r === null) {
    let o = new Error(`<${t} /> is missing a parent <Combobox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(o, ee$3), o;
  }
  return r;
}
let Ce$1 = /*#__PURE__*/createContext(null);
function Ze$3(t) {
  var c;
  let r = j$1("VirtualProvider"),
    [o, a] = useMemo(() => {
      let e = r.optionsRef.current;
      if (!e) return [0, 0];
      let l = window.getComputedStyle(e);
      return [parseFloat(l.paddingBlockStart || l.paddingTop), parseFloat(l.paddingBlockEnd || l.paddingBottom)];
    }, [r.optionsRef.current]),
    i = useVirtualizer({
      scrollPaddingStart: o,
      scrollPaddingEnd: a,
      count: r.virtual.options.length,
      estimateSize() {
        return 40;
      },
      getScrollElement() {
        var e;
        return (e = r.optionsRef.current) != null ? e : null;
      },
      overscan: 12
    }),
    [u, p] = useState(0);
  return l$7(() => {
    p(e => e + 1);
  }, [(c = r.virtual) == null ? void 0 : c.options]), /*#__PURE__*/React__default.createElement(Ce$1.Provider, {
    value: i
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: "relative",
      width: "100%",
      height: `${i.getTotalSize()}px`
    },
    ref: e => {
      if (e) {
        if (typeof process != "undefined" && process.env.JEST_WORKER_ID !== void 0 || r.activationTrigger === 0) return;
        r.activeOptionIndex !== null && r.virtual.options.length > r.activeOptionIndex && i.scrollToIndex(r.activeOptionIndex);
      }
    }
  }, i.getVirtualItems().map(e => {
    var l;
    return /*#__PURE__*/React__default.createElement(Fragment, {
      key: e.key
    }, /*#__PURE__*/React__default.cloneElement((l = t.children) == null ? void 0 : l.call(t, {
      option: r.virtual.options[e.index],
      open: r.comboboxState === 0
    }), {
      key: `${u}-${e.key}`,
      "data-index": e.index,
      "aria-setsize": r.virtual.options.length,
      "aria-posinset": e.index + 1,
      style: {
        position: "absolute",
        top: 0,
        left: 0,
        transform: `translateY(${e.start}px)`,
        overflowAnchor: "none"
      }
    }));
  })));
}
let ce$1 = /*#__PURE__*/createContext(null);
ce$1.displayName = "ComboboxDataContext";
function j$1(t) {
  let r = useContext(ce$1);
  if (r === null) {
    let o = new Error(`<${t} /> is missing a parent <Combobox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(o, j$1), o;
  }
  return r;
}
function et$3(t, r) {
  return u$9(r.type, Qe$3, t, r);
}
let tt$3 = Fragment;
function ot$2(t, r) {
  let {
      value: o,
      defaultValue: a,
      onChange: i,
      form: u,
      name: p,
      by: c = null,
      disabled: e = !1,
      __demoMode: l = !1,
      nullable: T = !1,
      multiple: g = !1,
      immediate: f = !1,
      virtual: v = null,
      ...S
    } = t,
    R = !1,
    s = null,
    [I = g ? [] : void 0, V] = T$3(o, i, a),
    [_, E] = useReducer(et$3, {
      dataRef: /*#__PURE__*/createRef(),
      comboboxState: l ? 0 : 1,
      options: [],
      virtual: null,
      activeOptionIndex: null,
      activationTrigger: 2,
      labelId: null
    }),
    k = useRef(!1),
    J = useRef({
      static: !1,
      hold: !1
    }),
    K = useRef(null),
    z = useRef(null),
    te = useRef(null),
    X = useRef(null),
    x = o$8(typeof c == "string" ? (d, b) => {
      let P = c;
      return (d == null ? void 0 : d[P]) === (b == null ? void 0 : b[P]);
    } : c != null ? c : (d, b) => d === b),
    O = o$8(d => _.options.findIndex(b => x(b.dataRef.current.value, d))),
    L = useCallback(d => u$9(n.mode, {
      [1]: () => I.some(b => x(b, d)),
      [0]: () => x(I, d)
    }), [I]),
    oe = o$8(d => _.activeOptionIndex === O(d)),
    n = useMemo(() => ({
      ..._,
      immediate: R,
      optionsPropsRef: J,
      labelRef: K,
      inputRef: z,
      buttonRef: te,
      optionsRef: X,
      value: I,
      defaultValue: a,
      disabled: e,
      mode: g ? 1 : 0,
      virtual: _.virtual,
      get activeOptionIndex() {
        if (k.current && _.activeOptionIndex === null && (_.options.length > 0)) {
          let d = _.options.findIndex(b => !b.dataRef.current.disabled);
          if (d !== -1) return d;
        }
        return _.activeOptionIndex;
      },
      calculateIndex: O,
      compare: x,
      isSelected: L,
      isActive: oe,
      nullable: T,
      __demoMode: l
    }), [I, a, e, g, T, l, _, s]);
  l$7(() => {
  }, [s, void 0 ]), l$7(() => {
    _.dataRef.current = n;
  }, [n]), y$3([n.buttonRef, n.inputRef, n.optionsRef], () => le.closeCombobox(), n.comboboxState === 0);
  let F = useMemo(() => {
      var d, b, P;
      return {
        open: n.comboboxState === 0,
        disabled: e,
        activeIndex: n.activeOptionIndex,
        activeOption: n.activeOptionIndex === null ? null : n.virtual ? n.virtual.options[(d = n.activeOptionIndex) != null ? d : 0] : (P = (b = n.options[n.activeOptionIndex]) == null ? void 0 : b.dataRef.current.value) != null ? P : null,
        value: I
      };
    }, [n, e, I]),
    A = o$8(() => {
      if (n.activeOptionIndex !== null) {
        if (n.virtual) ae(n.virtual.options[n.activeOptionIndex]);else {
          let {
            dataRef: d
          } = n.options[n.activeOptionIndex];
          ae(d.current.value);
        }
        le.goToOption(c$6.Specific, n.activeOptionIndex);
      }
    }),
    h = o$8(() => {
      E({
        type: 0
      }), k.current = !0;
    }),
    C = o$8(() => {
      E({
        type: 1
      }), k.current = !1;
    }),
    D = o$8((d, b, P) => (k.current = !1, d === c$6.Specific ? E({
      type: 2,
      focus: c$6.Specific,
      idx: b,
      trigger: P
    }) : E({
      type: 2,
      focus: d,
      trigger: P
    }))),
    N = o$8((d, b) => (E({
      type: 3,
      payload: {
        id: d,
        dataRef: b
      }
    }), () => {
      n.isActive(b.current.value) && (k.current = !0), E({
        type: 4,
        id: d
      });
    })),
    ye = o$8(d => (E({
      type: 5,
      id: d
    }), () => E({
      type: 5,
      id: null
    }))),
    ae = o$8(d => u$9(n.mode, {
      [0]() {
        return V == null ? void 0 : V(d);
      },
      [1]() {
        let b = n.value.slice(),
          P = b.findIndex(G => x(G, d));
        return P === -1 ? b.push(d) : b.splice(P, 1), V == null ? void 0 : V(b);
      }
    })),
    Re = o$8(d => {
      E({
        type: 6,
        trigger: d
      });
    }),
    le = useMemo(() => ({
      onChange: ae,
      registerOption: N,
      registerLabel: ye,
      goToOption: D,
      closeCombobox: C,
      openCombobox: h,
      setActivationTrigger: Re,
      selectActiveOption: A
    }), []),
    Ae = r === null ? {} : {
      ref: r
    },
    ne = useRef(null),
    Se = p$5();
  return useEffect(() => {
    ne.current && a !== void 0 && Se.addEventListener(ne.current, "reset", () => {
      V == null || V(a);
    });
  }, [ne, V]), /*#__PURE__*/React__default.createElement(be$2.Provider, {
    value: le
  }, /*#__PURE__*/React__default.createElement(ce$1.Provider, {
    value: n
  }, /*#__PURE__*/React__default.createElement(s$7, {
    value: u$9(n.comboboxState, {
      [0]: d$7.Open,
      [1]: d$7.Closed
    })
  }, p != null && I != null && e$3({
    [p]: I
  }).map(([d, b], P) => /*#__PURE__*/React__default.createElement(u$6, {
    features: s$8.Hidden,
    ref: P === 0 ? G => {
      var Y;
      ne.current = (Y = G == null ? void 0 : G.closest("form")) != null ? Y : null;
    } : void 0,
    ...x$1({
      key: d,
      as: "input",
      type: "hidden",
      hidden: !0,
      readOnly: !0,
      form: u,
      disabled: e,
      name: d,
      value: b
    })
  })), C$2({
    ourProps: Ae,
    theirProps: S,
    slot: F,
    defaultTag: tt$3,
    name: "Combobox"
  }))));
}
let nt$1 = "input";
function rt$1(t, r) {
  var X, x, O, L, oe;
  let o = I$6(),
    {
      id: a = `headlessui-combobox-input-${o}`,
      onChange: i,
      displayValue: u,
      type: p = "text",
      ...c
    } = t,
    e = j$1("Combobox.Input"),
    l = ee$3("Combobox.Input"),
    T = y$2(e.inputRef, r),
    g = n$4(e.inputRef),
    f = useRef(!1),
    v = p$5(),
    S = o$8(() => {
      l.onChange(null), e.optionsRef.current && (e.optionsRef.current.scrollTop = 0), l.goToOption(c$6.Nothing);
    }),
    R = function () {
      var n;
      return typeof u == "function" && e.value !== void 0 ? (n = u(e.value)) != null ? n : "" : typeof e.value == "string" ? e.value : "";
    }();
  m$3(([n, F], [A, h]) => {
    if (f.current) return;
    let C = e.inputRef.current;
    C && ((h === 0 && F === 1 || n !== A) && (C.value = n), requestAnimationFrame(() => {
      if (f.current || !C || (g == null ? void 0 : g.activeElement) !== C) return;
      let {
        selectionStart: D,
        selectionEnd: N
      } = C;
      Math.abs((N != null ? N : 0) - (D != null ? D : 0)) === 0 && D === 0 && C.setSelectionRange(C.value.length, C.value.length);
    }));
  }, [R, e.comboboxState, g]), m$3(([n], [F]) => {
    if (n === 0 && F === 1) {
      if (f.current) return;
      let A = e.inputRef.current;
      if (!A) return;
      let h = A.value,
        {
          selectionStart: C,
          selectionEnd: D,
          selectionDirection: N
        } = A;
      A.value = "", A.value = h, N !== null ? A.setSelectionRange(C, D, N) : A.setSelectionRange(C, D);
    }
  }, [e.comboboxState]);
  let s = useRef(!1),
    I = o$8(() => {
      s.current = !0;
    }),
    V = o$8(() => {
      v.nextFrame(() => {
        s.current = !1;
      });
    }),
    _ = o$8(n => {
      switch (f.current = !0, n.key) {
        case o$3.Enter:
          if (f.current = !1, e.comboboxState !== 0 || s.current) return;
          if (n.preventDefault(), n.stopPropagation(), e.activeOptionIndex === null) {
            l.closeCombobox();
            return;
          }
          l.selectActiveOption(), e.mode === 0 && l.closeCombobox();
          break;
        case o$3.ArrowDown:
          return f.current = !1, n.preventDefault(), n.stopPropagation(), u$9(e.comboboxState, {
            [0]: () => l.goToOption(c$6.Next),
            [1]: () => l.openCombobox()
          });
        case o$3.ArrowUp:
          return f.current = !1, n.preventDefault(), n.stopPropagation(), u$9(e.comboboxState, {
            [0]: () => l.goToOption(c$6.Previous),
            [1]: () => {
              l.openCombobox(), v.nextFrame(() => {
                e.value || l.goToOption(c$6.Last);
              });
            }
          });
        case o$3.Home:
          if (n.shiftKey) break;
          return f.current = !1, n.preventDefault(), n.stopPropagation(), l.goToOption(c$6.First);
        case o$3.PageUp:
          return f.current = !1, n.preventDefault(), n.stopPropagation(), l.goToOption(c$6.First);
        case o$3.End:
          if (n.shiftKey) break;
          return f.current = !1, n.preventDefault(), n.stopPropagation(), l.goToOption(c$6.Last);
        case o$3.PageDown:
          return f.current = !1, n.preventDefault(), n.stopPropagation(), l.goToOption(c$6.Last);
        case o$3.Escape:
          return f.current = !1, e.comboboxState !== 0 ? void 0 : (n.preventDefault(), e.optionsRef.current && !e.optionsPropsRef.current.static && n.stopPropagation(), e.nullable && e.mode === 0 && e.value === null && S(), l.closeCombobox());
        case o$3.Tab:
          if (f.current = !1, e.comboboxState !== 0) return;
          e.mode === 0 && e.activationTrigger !== 1 && l.selectActiveOption(), l.closeCombobox();
          break;
      }
    }),
    E = o$8(n => {
      i == null || i(n), e.nullable && e.mode === 0 && n.target.value === "" && S(), l.openCombobox();
    }),
    k = o$8(n => {
      var A, h, C;
      let F = (A = n.relatedTarget) != null ? A : t$5.find(D => D !== n.currentTarget);
      if (f.current = !1, !((h = e.optionsRef.current) != null && h.contains(F)) && !((C = e.buttonRef.current) != null && C.contains(F)) && e.comboboxState === 0) return n.preventDefault(), e.mode === 0 && (e.nullable && e.value === null ? S() : e.activationTrigger !== 1 && l.selectActiveOption()), l.closeCombobox();
    }),
    J = o$8(n => {
      var A, h, C;
      let F = (A = n.relatedTarget) != null ? A : t$5.find(D => D !== n.currentTarget);
      (h = e.buttonRef.current) != null && h.contains(F) || (C = e.optionsRef.current) != null && C.contains(F) || e.disabled || e.immediate && e.comboboxState !== 0 && (l.openCombobox(), v.nextFrame(() => {
        l.setActivationTrigger(1);
      }));
    }),
    K = i$6(() => {
      if (e.labelId) return [e.labelId].join(" ");
    }, [e.labelId]),
    z = useMemo(() => ({
      open: e.comboboxState === 0,
      disabled: e.disabled
    }), [e]),
    te = {
      ref: T,
      id: a,
      role: "combobox",
      type: p,
      "aria-controls": (X = e.optionsRef.current) == null ? void 0 : X.id,
      "aria-expanded": e.comboboxState === 0,
      "aria-activedescendant": e.activeOptionIndex === null ? void 0 : e.virtual ? (x = e.options.find(n => {
        var F;
        return !((F = e.virtual) != null && F.disabled(n.dataRef.current.value)) && e.compare(n.dataRef.current.value, e.virtual.options[e.activeOptionIndex]);
      })) == null ? void 0 : x.id : (O = e.options[e.activeOptionIndex]) == null ? void 0 : O.id,
      "aria-labelledby": K,
      "aria-autocomplete": "list",
      defaultValue: (oe = (L = t.defaultValue) != null ? L : e.defaultValue !== void 0 ? u == null ? void 0 : u(e.defaultValue) : null) != null ? oe : e.defaultValue,
      disabled: e.disabled,
      onCompositionStart: I,
      onCompositionEnd: V,
      onKeyDown: _,
      onChange: E,
      onFocus: J,
      onBlur: k
    };
  return C$2({
    ourProps: te,
    theirProps: c,
    slot: z,
    defaultTag: nt$1,
    name: "Combobox.Input"
  });
}
let at = "button";
function lt(t, r) {
  var S;
  let o = j$1("Combobox.Button"),
    a = ee$3("Combobox.Button"),
    i = y$2(o.buttonRef, r),
    u = I$6(),
    {
      id: p = `headlessui-combobox-button-${u}`,
      ...c
    } = t,
    e = p$5(),
    l = o$8(R => {
      switch (R.key) {
        case o$3.ArrowDown:
          return R.preventDefault(), R.stopPropagation(), o.comboboxState === 1 && a.openCombobox(), e.nextFrame(() => {
            var s;
            return (s = o.inputRef.current) == null ? void 0 : s.focus({
              preventScroll: !0
            });
          });
        case o$3.ArrowUp:
          return R.preventDefault(), R.stopPropagation(), o.comboboxState === 1 && (a.openCombobox(), e.nextFrame(() => {
            o.value || a.goToOption(c$6.Last);
          })), e.nextFrame(() => {
            var s;
            return (s = o.inputRef.current) == null ? void 0 : s.focus({
              preventScroll: !0
            });
          });
        case o$3.Escape:
          return o.comboboxState !== 0 ? void 0 : (R.preventDefault(), o.optionsRef.current && !o.optionsPropsRef.current.static && R.stopPropagation(), a.closeCombobox(), e.nextFrame(() => {
            var s;
            return (s = o.inputRef.current) == null ? void 0 : s.focus({
              preventScroll: !0
            });
          }));
        default:
          return;
      }
    }),
    T = o$8(R => {
      if (r$4(R.currentTarget)) return R.preventDefault();
      o.comboboxState === 0 ? a.closeCombobox() : (R.preventDefault(), a.openCombobox()), e.nextFrame(() => {
        var s;
        return (s = o.inputRef.current) == null ? void 0 : s.focus({
          preventScroll: !0
        });
      });
    }),
    g = i$6(() => {
      if (o.labelId) return [o.labelId, p].join(" ");
    }, [o.labelId, p]),
    f = useMemo(() => ({
      open: o.comboboxState === 0,
      disabled: o.disabled,
      value: o.value
    }), [o]),
    v = {
      ref: i,
      id: p,
      type: T$1(t, o.buttonRef),
      tabIndex: -1,
      "aria-haspopup": "listbox",
      "aria-controls": (S = o.optionsRef.current) == null ? void 0 : S.id,
      "aria-expanded": o.comboboxState === 0,
      "aria-labelledby": g,
      disabled: o.disabled,
      onClick: T,
      onKeyDown: l
    };
  return C$2({
    ourProps: v,
    theirProps: c,
    slot: f,
    defaultTag: at,
    name: "Combobox.Button"
  });
}
let it$1 = "label";
function ut(t, r) {
  let o = I$6(),
    {
      id: a = `headlessui-combobox-label-${o}`,
      ...i
    } = t,
    u = j$1("Combobox.Label"),
    p = ee$3("Combobox.Label"),
    c = y$2(u.labelRef, r);
  l$7(() => p.registerLabel(a), [a]);
  let e = o$8(() => {
      var g;
      return (g = u.inputRef.current) == null ? void 0 : g.focus({
        preventScroll: !0
      });
    }),
    l = useMemo(() => ({
      open: u.comboboxState === 0,
      disabled: u.disabled
    }), [u]);
  return C$2({
    ourProps: {
      ref: c,
      id: a,
      onClick: e
    },
    theirProps: i,
    slot: l,
    defaultTag: it$1,
    name: "Combobox.Label"
  });
}
let pt = "ul",
  st = O.RenderStrategy | O.Static;
function dt(t, r) {
  let o = I$6(),
    {
      id: a = `headlessui-combobox-options-${o}`,
      hold: i = !1,
      ...u
    } = t,
    p = j$1("Combobox.Options"),
    c = y$2(p.optionsRef, r),
    e = u$5(),
    l = (() => e !== null ? (e & d$7.Open) === d$7.Open : p.comboboxState === 0)();
  l$7(() => {
    var v;
    p.optionsPropsRef.current.static = (v = t.static) != null ? v : !1;
  }, [p.optionsPropsRef, t.static]), l$7(() => {
    p.optionsPropsRef.current.hold = i;
  }, [p.optionsPropsRef, i]), F$5({
    container: p.optionsRef.current,
    enabled: p.comboboxState === 0,
    accept(v) {
      return v.getAttribute("role") === "option" ? NodeFilter.FILTER_REJECT : v.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
    },
    walk(v) {
      v.setAttribute("role", "none");
    }
  });
  let T = i$6(() => {
      var v, S;
      return (S = p.labelId) != null ? S : (v = p.buttonRef.current) == null ? void 0 : v.id;
    }, [p.labelId, p.buttonRef.current]),
    g = useMemo(() => ({
      open: p.comboboxState === 0,
      option: void 0
    }), [p]),
    f = {
      "aria-labelledby": T,
      role: "listbox",
      "aria-multiselectable": p.mode === 1 ? !0 : void 0,
      id: a,
      ref: c
    };
  return p.virtual && p.comboboxState === 0 && Object.assign(u, {
    children: /*#__PURE__*/React__default.createElement(Ze$3, null, u.children)
  }), C$2({
    ourProps: f,
    theirProps: u,
    slot: g,
    defaultTag: pt,
    features: st,
    visible: l,
    name: "Combobox.Options"
  });
}
let bt = "li";
function ct(t, r) {
  var X;
  let o = I$6(),
    {
      id: a = `headlessui-combobox-option-${o}`,
      disabled: i = !1,
      value: u,
      order: p = null,
      ...c
    } = t,
    e = j$1("Combobox.Option"),
    l = ee$3("Combobox.Option"),
    T = e.virtual ? e.activeOptionIndex === e.calculateIndex(u) : e.activeOptionIndex === null ? !1 : ((X = e.options[e.activeOptionIndex]) == null ? void 0 : X.id) === a,
    g = e.isSelected(u),
    f = useRef(null),
    v = s$b({
      disabled: i,
      value: u,
      domRef: f,
      order: p
    }),
    S = useContext(Ce$1),
    R = y$2(r, f, S ? S.measureElement : null),
    s = o$8(() => l.onChange(u));
  l$7(() => l.registerOption(a, v), [v, a]);
  let I = useRef(!(e.virtual || e.__demoMode));
  l$7(() => {
    if (!e.virtual || !e.__demoMode) return;
    let x = o$7();
    return x.requestAnimationFrame(() => {
      I.current = !0;
    }), x.dispose;
  }, [e.virtual, e.__demoMode]), l$7(() => {
    if (!I.current || e.comboboxState !== 0 || !T || e.activationTrigger === 0) return;
    let x = o$7();
    return x.requestAnimationFrame(() => {
      var O, L;
      (L = (O = f.current) == null ? void 0 : O.scrollIntoView) == null || L.call(O, {
        block: "nearest"
      });
    }), x.dispose;
  }, [f, T, e.comboboxState, e.activationTrigger, e.activeOptionIndex]);
  let V = o$8(x => {
      var O;
      if (i || (O = e.virtual) != null && O.disabled(u)) return x.preventDefault();
      s(), n$5() || requestAnimationFrame(() => {
        var L;
        return (L = e.inputRef.current) == null ? void 0 : L.focus({
          preventScroll: !0
        });
      }), e.mode === 0 && requestAnimationFrame(() => l.closeCombobox());
    }),
    _ = o$8(() => {
      var O;
      if (i || (O = e.virtual) != null && O.disabled(u)) return l.goToOption(c$6.Nothing);
      let x = e.calculateIndex(u);
      l.goToOption(c$6.Specific, x);
    }),
    E = u$7(),
    k = o$8(x => E.update(x)),
    J = o$8(x => {
      var L;
      if (!E.wasMoved(x) || i || (L = e.virtual) != null && L.disabled(u) || T) return;
      let O = e.calculateIndex(u);
      l.goToOption(c$6.Specific, O, 0);
    }),
    K = o$8(x => {
      var O;
      E.wasMoved(x) && (i || (O = e.virtual) != null && O.disabled(u) || T && (e.optionsPropsRef.current.hold || l.goToOption(c$6.Nothing)));
    }),
    z = useMemo(() => ({
      active: T,
      selected: g,
      disabled: i
    }), [T, g, i]);
  return C$2({
    ourProps: {
      id: a,
      ref: R,
      role: "option",
      tabIndex: i === !0 ? void 0 : -1,
      "aria-disabled": i === !0 ? !0 : void 0,
      "aria-selected": g,
      disabled: void 0,
      onClick: V,
      onFocus: _,
      onPointerEnter: k,
      onMouseEnter: k,
      onPointerMove: J,
      onMouseMove: J,
      onPointerLeave: K,
      onMouseLeave: K
    },
    theirProps: c,
    slot: z,
    defaultTag: bt,
    name: "Combobox.Option"
  });
}
let ft = U$3(ot$2),
  mt = U$3(lt),
  Tt = U$3(rt$1),
  xt = U$3(ut),
  gt = U$3(dt),
  vt = U$3(ct);
  Object.assign(ft, {
    Input: Tt,
    Button: mt,
    Label: xt,
    Options: gt,
    Option: vt
  });

function E(n, e, a, t) {
  let i = s$b(a);
  useEffect(() => {
    n = n != null ? n : window;
    function r(o) {
      i.current(o);
    }
    return n.addEventListener(e, r, t), () => n.removeEventListener(e, r, t);
  }, [n, e, t]);
}

function f$5() {
  let e = useRef(!1);
  return l$7(() => (e.current = !0, () => {
    e.current = !1;
  }), []), e;
}

function c$5(t) {
  let r = o$8(t),
    e = useRef(!1);
  useEffect(() => (e.current = !1, () => {
    e.current = !0, t$a(() => {
      e.current && r();
    });
  }), [r]);
}

var s$6 = (r => (r[r.Forwards = 0] = "Forwards", r[r.Backwards = 1] = "Backwards", r))(s$6 || {});
function n$2() {
  let e = useRef(0);
  return s$9("keydown", o => {
    o.key === "Tab" && (e.current = o.shiftKey ? 1 : 0);
  }, !0), e;
}

function P(t) {
  if (!t) return new Set();
  if (typeof t == "function") return new Set(t());
  let n = new Set();
  for (let e of t.current) e.current instanceof HTMLElement && n.add(e.current);
  return n;
}
let X$1 = "div";
var _$2 = (r => (r[r.None = 1] = "None", r[r.InitialFocus = 2] = "InitialFocus", r[r.TabLock = 4] = "TabLock", r[r.FocusLock = 8] = "FocusLock", r[r.RestoreFocus = 16] = "RestoreFocus", r[r.All = 30] = "All", r))(_$2 || {});
function z$1(t, n) {
  let e = useRef(null),
    o = y$2(e, n),
    {
      initialFocus: l,
      containers: c,
      features: r = 30,
      ...s
    } = t;
  l$6() || (r = 1);
  let i = n$4(e);
  Y$1({
    ownerDocument: i
  }, Boolean(r & 16));
  let u = Z$1({
    ownerDocument: i,
    container: e,
    initialFocus: l
  }, Boolean(r & 2));
  $$2({
    ownerDocument: i,
    container: e,
    containers: c,
    previousActiveElement: u
  }, Boolean(r & 8));
  let y = n$2(),
    R = o$8(a => {
      let m = e.current;
      if (!m) return;
      (B => B())(() => {
        u$9(y.current, {
          [s$6.Forwards]: () => {
            O$1(m, M$3.First, {
              skipElements: [a.relatedTarget]
            });
          },
          [s$6.Backwards]: () => {
            O$1(m, M$3.Last, {
              skipElements: [a.relatedTarget]
            });
          }
        });
      });
    }),
    h = p$5(),
    H = useRef(!1),
    j = {
      ref: o,
      onKeyDown(a) {
        a.key == "Tab" && (H.current = !0, h.requestAnimationFrame(() => {
          H.current = !1;
        }));
      },
      onBlur(a) {
        let m = P(c);
        e.current instanceof HTMLElement && m.add(e.current);
        let T = a.relatedTarget;
        T instanceof HTMLElement && T.dataset.headlessuiFocusGuard !== "true" && (S$5(m, T) || (H.current ? O$1(e.current, u$9(y.current, {
          [s$6.Forwards]: () => M$3.Next,
          [s$6.Backwards]: () => M$3.Previous
        }) | M$3.WrapAround, {
          relativeTo: a.target
        }) : a.target instanceof HTMLElement && y$4(a.target)));
      }
    };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, Boolean(r & 4) && /*#__PURE__*/React__default.createElement(u$6, {
    as: "button",
    type: "button",
    "data-headlessui-focus-guard": !0,
    onFocus: R,
    features: s$8.Focusable
  }), C$2({
    ourProps: j,
    theirProps: s,
    defaultTag: X$1,
    name: "FocusTrap"
  }), Boolean(r & 4) && /*#__PURE__*/React__default.createElement(u$6, {
    as: "button",
    type: "button",
    "data-headlessui-focus-guard": !0,
    onFocus: R,
    features: s$8.Focusable
  }));
}
let D$2 = U$3(z$1),
  de$2 = Object.assign(D$2, {
    features: _$2
  });
function Q$1(t = !0) {
  let n = useRef(t$5.slice());
  return m$3(([e], [o]) => {
    o === !0 && e === !1 && t$a(() => {
      n.current.splice(0);
    }), o === !1 && e === !0 && (n.current = t$5.slice());
  }, [t, t$5, n]), o$8(() => {
    var e;
    return (e = n.current.find(o => o != null && o.isConnected)) != null ? e : null;
  });
}
function Y$1({
  ownerDocument: t
}, n) {
  let e = Q$1(n);
  m$3(() => {
    n || (t == null ? void 0 : t.activeElement) === (t == null ? void 0 : t.body) && y$4(e());
  }, [n]), c$5(() => {
    n && y$4(e());
  });
}
function Z$1({
  ownerDocument: t,
  container: n,
  initialFocus: e
}, o) {
  let l = useRef(null),
    c = f$5();
  return m$3(() => {
    if (!o) return;
    let r = n.current;
    r && t$a(() => {
      if (!c.current) return;
      let s = t == null ? void 0 : t.activeElement;
      if (e != null && e.current) {
        if ((e == null ? void 0 : e.current) === s) {
          l.current = s;
          return;
        }
      } else if (r.contains(s)) {
        l.current = s;
        return;
      }
      e != null && e.current ? y$4(e.current) : O$1(r, M$3.First) === N$2.Error && console.warn("There are no focusable elements inside the <FocusTrap />"), l.current = t == null ? void 0 : t.activeElement;
    });
  }, [o]), l;
}
function $$2({
  ownerDocument: t,
  container: n,
  containers: e,
  previousActiveElement: o
}, l) {
  let c = f$5();
  E(t == null ? void 0 : t.defaultView, "focus", r => {
    if (!l || !c.current) return;
    let s = P(e);
    n.current instanceof HTMLElement && s.add(n.current);
    let i = o.current;
    if (!i) return;
    let u = r.target;
    u && u instanceof HTMLElement ? S$5(s, u) ? (o.current = u, y$4(u)) : (r.preventDefault(), r.stopPropagation(), y$4(i)) : y$4(o.current);
  }, !0);
}
function S$5(t, n) {
  for (let e of t) if (e.contains(n)) return !0;
  return !1;
}

let e$2 = /*#__PURE__*/createContext(!1);
function a$9() {
  return useContext(e$2);
}
function l$4(o) {
  return /*#__PURE__*/React__default.createElement(e$2.Provider, {
    value: o.force
  }, o.children);
}

function F$3(p) {
  let n = a$9(),
    l = useContext(_$1),
    e = n$4(p),
    [a, o] = useState(() => {
      if (!n && l !== null || s$c.isServer) return null;
      let t = e == null ? void 0 : e.getElementById("headlessui-portal-root");
      if (t) return t;
      if (e === null) return null;
      let r = e.createElement("div");
      return r.setAttribute("id", "headlessui-portal-root"), e.body.appendChild(r);
    });
  return useEffect(() => {
    a !== null && (e != null && e.body.contains(a) || e == null || e.body.appendChild(a));
  }, [a, e]), useEffect(() => {
    n || l !== null && o(l.current);
  }, [l, o, n]), a;
}
let U$2 = Fragment;
function N$1(p, n) {
  let l = p,
    e = useRef(null),
    a = y$2(T(u => {
      e.current = u;
    }), n),
    o = n$4(e),
    t = F$3(e),
    [r] = useState(() => {
      var u;
      return s$c.isServer ? null : (u = o == null ? void 0 : o.createElement("div")) != null ? u : null;
    }),
    i = useContext(f$4),
    v = l$6();
  return l$7(() => {
    !t || !r || t.contains(r) || (r.setAttribute("data-headlessui-portal", ""), t.appendChild(r));
  }, [t, r]), l$7(() => {
    if (r && i) return i.register(r);
  }, [i, r]), c$5(() => {
    var u;
    !t || !r || (r instanceof Node && t.contains(r) && t.removeChild(r), t.childNodes.length <= 0 && ((u = t.parentElement) == null || u.removeChild(t)));
  }), v ? !t || !r ? null : /*#__PURE__*/createPortal(C$2({
    ourProps: {
      ref: a
    },
    theirProps: l,
    defaultTag: U$2,
    name: "Portal"
  }), r) : null;
}
let S$4 = Fragment,
  _$1 = /*#__PURE__*/createContext(null);
function j(p, n) {
  let {
      target: l,
      ...e
    } = p,
    o = {
      ref: y$2(n)
    };
  return /*#__PURE__*/React__default.createElement(_$1.Provider, {
    value: l
  }, C$2({
    ourProps: o,
    theirProps: e,
    defaultTag: S$4,
    name: "Popover.Group"
  }));
}
let f$4 = /*#__PURE__*/createContext(null);
function ee$2() {
  let p = useContext(f$4),
    n = useRef([]),
    l = o$8(o => (n.current.push(o), p && p.register(o), () => e(o))),
    e = o$8(o => {
      let t = n.current.indexOf(o);
      t !== -1 && n.current.splice(t, 1), p && p.unregister(o);
    }),
    a = useMemo(() => ({
      register: l,
      unregister: e,
      portals: n
    }), [l, e, n]);
  return [n, useMemo(() => function ({
    children: t
  }) {
    return /*#__PURE__*/React__default.createElement(f$4.Provider, {
      value: a
    }, t);
  }, [a])];
}
let D$1 = U$3(N$1),
  I$3 = U$3(j),
  te$2 = Object.assign(D$1, {
    Group: I$3
  });

function i$2(e, t) {
  return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
}
const d$6 = typeof Object.is == "function" ? Object.is : i$2,
  {
    useState: u$3,
    useEffect: h$3,
    useLayoutEffect: f$3,
    useDebugValue: p$2
  } = React;
function y$1(e, t, c) {
  const a = t(),
    [{
      inst: n
    }, o] = u$3({
      inst: {
        value: a,
        getSnapshot: t
      }
    });
  return f$3(() => {
    n.value = a, n.getSnapshot = t, r$3(n) && o({
      inst: n
    });
  }, [e, a, t]), h$3(() => (r$3(n) && o({
    inst: n
  }), e(() => {
    r$3(n) && o({
      inst: n
    });
  })), [e]), p$2(a), a;
}
function r$3(e) {
  const t = e.getSnapshot,
    c = e.value;
  try {
    const a = t();
    return !d$6(c, a);
  } catch {
    return !0;
  }
}

function t$4(r, e, n) {
  return e();
}

const r$2 = typeof window != "undefined" && typeof window.document != "undefined" && typeof window.document.createElement != "undefined",
  s$5 = !r$2,
  c$4 = s$5 ? t$4 : y$1,
  a$8 = "useSyncExternalStore" in React ? (n => n.useSyncExternalStore)(React) : c$4;

function S$3(t) {
  return a$8(t.subscribe, t.getSnapshot, t.getSnapshot);
}

function a$7(o, r) {
  let t = o(),
    n = new Set();
  return {
    getSnapshot() {
      return t;
    },
    subscribe(e) {
      return n.add(e), () => n.delete(e);
    },
    dispatch(e, ...s) {
      let i = r[e].call(t, ...s);
      i && (t = i, n.forEach(c => c()));
    }
  };
}

function c$3() {
  let o;
  return {
    before({
      doc: e
    }) {
      var l;
      let n = e.documentElement;
      o = ((l = e.defaultView) != null ? l : window).innerWidth - n.clientWidth;
    },
    after({
      doc: e,
      d: n
    }) {
      let t = e.documentElement,
        l = t.clientWidth - t.offsetWidth,
        r = o - l;
      n.style(t, "paddingRight", `${r}px`);
    }
  };
}

function d$5() {
  return t$9() ? {
    before({
      doc: r,
      d: l,
      meta: c
    }) {
      function o(a) {
        return c.containers.flatMap(n => n()).some(n => n.contains(a));
      }
      l.microTask(() => {
        var s;
        if (window.getComputedStyle(r.documentElement).scrollBehavior !== "auto") {
          let t = o$7();
          t.style(r.documentElement, "scrollBehavior", "auto"), l.add(() => l.microTask(() => t.dispose()));
        }
        let a = (s = window.scrollY) != null ? s : window.pageYOffset,
          n = null;
        l.addEventListener(r, "click", t => {
          if (t.target instanceof HTMLElement) try {
            let e = t.target.closest("a");
            if (!e) return;
            let {
                hash: f
              } = new URL(e.href),
              i = r.querySelector(f);
            i && !o(i) && (n = i);
          } catch {}
        }, !0), l.addEventListener(r, "touchstart", t => {
          if (t.target instanceof HTMLElement) if (o(t.target)) {
            let e = t.target;
            for (; e.parentElement && o(e.parentElement);) e = e.parentElement;
            l.style(e, "overscrollBehavior", "contain");
          } else l.style(t.target, "touchAction", "none");
        }), l.addEventListener(r, "touchmove", t => {
          if (t.target instanceof HTMLElement) if (o(t.target)) {
            let e = t.target;
            for (; e.parentElement && e.dataset.headlessuiPortal !== "" && !(e.scrollHeight > e.clientHeight || e.scrollWidth > e.clientWidth);) e = e.parentElement;
            e.dataset.headlessuiPortal === "" && t.preventDefault();
          } else t.preventDefault();
        }, {
          passive: !1
        }), l.add(() => {
          var e;
          let t = (e = window.scrollY) != null ? e : window.pageYOffset;
          a !== t && window.scrollTo(0, a), n && n.isConnected && (n.scrollIntoView({
            block: "nearest"
          }), n = null);
        });
      });
    }
  } : {};
}

function l$3() {
  return {
    before({
      doc: e,
      d: o
    }) {
      o.style(e.documentElement, "overflow", "hidden");
    }
  };
}

function m$1(e) {
  let n = {};
  for (let t of e) Object.assign(n, t(n));
  return n;
}
let a$6 = a$7(() => new Map(), {
  PUSH(e, n) {
    var o;
    let t = (o = this.get(e)) != null ? o : {
      doc: e,
      count: 0,
      d: o$7(),
      meta: new Set()
    };
    return t.count++, t.meta.add(n), this.set(e, t), this;
  },
  POP(e, n) {
    let t = this.get(e);
    return t && (t.count--, t.meta.delete(n)), this;
  },
  SCROLL_PREVENT({
    doc: e,
    d: n,
    meta: t
  }) {
    let o = {
        doc: e,
        d: n,
        meta: m$1(t)
      },
      c = [d$5(), c$3(), l$3()];
    c.forEach(({
      before: r
    }) => r == null ? void 0 : r(o)), c.forEach(({
      after: r
    }) => r == null ? void 0 : r(o));
  },
  SCROLL_ALLOW({
    d: e
  }) {
    e.dispose();
  },
  TEARDOWN({
    doc: e
  }) {
    this.delete(e);
  }
});
a$6.subscribe(() => {
  let e = a$6.getSnapshot(),
    n = new Map();
  for (let [t] of e) n.set(t, t.documentElement.style.overflow);
  for (let t of e.values()) {
    let o = n.get(t.doc) === "hidden",
      c = t.count !== 0;
    (c && !o || !c && o) && a$6.dispatch(t.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", t), t.count === 0 && a$6.dispatch("TEARDOWN", t);
  }
});

function p$1(e, r, n) {
  let f = S$3(a$6),
    o = e ? f.get(e) : void 0,
    i = o ? o.count > 0 : !1;
  return l$7(() => {
    if (!(!e || !r)) return a$6.dispatch("PUSH", e, n), () => a$6.dispatch("POP", e, n);
  }, [r, e]), i;
}

let u$2 = new Map(),
  t$3 = new Map();
function b$4(r, l = !0) {
  l$7(() => {
    var o;
    if (!l) return;
    let e = typeof r == "function" ? r() : r.current;
    if (!e) return;
    function a() {
      var d;
      if (!e) return;
      let i = (d = t$3.get(e)) != null ? d : 1;
      if (i === 1 ? t$3.delete(e) : t$3.set(e, i - 1), i !== 1) return;
      let n = u$2.get(e);
      n && (n["aria-hidden"] === null ? e.removeAttribute("aria-hidden") : e.setAttribute("aria-hidden", n["aria-hidden"]), e.inert = n.inert, u$2.delete(e));
    }
    let f = (o = t$3.get(e)) != null ? o : 0;
    return t$3.set(e, f + 1), f !== 0 || (u$2.set(e, {
      "aria-hidden": e.getAttribute("aria-hidden"),
      inert: e.inert
    }), e.setAttribute("aria-hidden", "true"), e.inert = !0), a;
  }, [r, l]);
}

function N({
  defaultContainers: o = [],
  portals: r,
  mainTreeNodeRef: u
} = {}) {
  var f;
  let t = useRef((f = u == null ? void 0 : u.current) != null ? f : null),
    l = n$4(t),
    c = o$8(() => {
      var i, s, a;
      let n = [];
      for (let e of o) e !== null && (e instanceof HTMLElement ? n.push(e) : "current" in e && e.current instanceof HTMLElement && n.push(e.current));
      if (r != null && r.current) for (let e of r.current) n.push(e);
      for (let e of (i = l == null ? void 0 : l.querySelectorAll("html > *, body > *")) != null ? i : []) e !== document.body && e !== document.head && e instanceof HTMLElement && e.id !== "headlessui-portal-root" && (e.contains(t.current) || e.contains((a = (s = t.current) == null ? void 0 : s.getRootNode()) == null ? void 0 : a.host) || n.some(L => e.contains(L)) || n.push(e));
      return n;
    });
  return {
    resolveContainers: c,
    contains: o$8(n => c().some(i => i.contains(n))),
    mainTreeNodeRef: t,
    MainTreeNode: useMemo(() => function () {
      return u != null ? null : /*#__PURE__*/React__default.createElement(u$6, {
        features: s$8.Hidden,
        ref: t
      });
    }, [t, u])
  };
}
function y() {
  let o = useRef(null);
  return {
    mainTreeNodeRef: o,
    MainTreeNode: useMemo(() => function () {
      return /*#__PURE__*/React__default.createElement(u$6, {
        features: s$8.Hidden,
        ref: o
      });
    }, [o])
  };
}

let a$5 = /*#__PURE__*/createContext(() => {});
a$5.displayName = "StackContext";
var s$4 = (e => (e[e.Add = 0] = "Add", e[e.Remove = 1] = "Remove", e))(s$4 || {});
function x() {
  return useContext(a$5);
}
function b$3({
  children: i,
  onUpdate: r,
  type: e,
  element: n,
  enabled: u
}) {
  let l = x(),
    o = o$8((...t) => {
      r == null || r(...t), l(...t);
    });
  return l$7(() => {
    let t = u === void 0 || u === !0;
    return t && o(0, e, n), () => {
      t && o(1, e, n);
    };
  }, [o, e, n, u]), /*#__PURE__*/React__default.createElement(a$5.Provider, {
    value: o
  }, i);
}

let d$4 = /*#__PURE__*/createContext(null);
function f$2() {
  let r = useContext(d$4);
  if (r === null) {
    let t = new Error("You used a <Description /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(t, f$2), t;
  }
  return r;
}
function w$2() {
  let [r, t] = useState([]);
  return [r.length > 0 ? r.join(" ") : void 0, useMemo(() => function (e) {
    let i = o$8(s => (t(o => [...o, s]), () => t(o => {
        let p = o.slice(),
          c = p.indexOf(s);
        return c !== -1 && p.splice(c, 1), p;
      }))),
      n = useMemo(() => ({
        register: i,
        slot: e.slot,
        name: e.name,
        props: e.props
      }), [i, e.slot, e.name, e.props]);
    return /*#__PURE__*/React__default.createElement(d$4.Provider, {
      value: n
    }, e.children);
  }, [t])];
}
let I$2 = "p";
function S$2(r, t) {
  let a = I$6(),
    {
      id: e = `headlessui-description-${a}`,
      ...i
    } = r,
    n = f$2(),
    s = y$2(t);
  l$7(() => n.register(e), [e, n.register]);
  let o = {
    ref: s,
    ...n.props,
    id: e
  };
  return C$2({
    ourProps: o,
    theirProps: i,
    slot: n.slot || {},
    defaultTag: I$2,
    name: n.name || "Description"
  });
}
let h$2 = U$3(S$2),
  G = Object.assign(h$2, {});

var Me$1 = (r => (r[r.Open = 0] = "Open", r[r.Closed = 1] = "Closed", r))(Me$1 || {}),
  we$2 = (e => (e[e.SetTitleId = 0] = "SetTitleId", e))(we$2 || {});
let He$3 = {
    [0](o, e) {
      return o.titleId === e.id ? o : {
        ...o,
        titleId: e.id
      };
    }
  },
  I$1 = /*#__PURE__*/createContext(null);
I$1.displayName = "DialogContext";
function b$2(o) {
  let e = useContext(I$1);
  if (e === null) {
    let r = new Error(`<${o} /> is missing a parent <Dialog /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, b$2), r;
  }
  return e;
}
function Be$1(o, e, r = () => [document.body]) {
  p$1(o, e, i => {
    var n;
    return {
      containers: [...((n = i.containers) != null ? n : []), r]
    };
  });
}
function Ge$3(o, e) {
  return u$9(e.type, He$3, o, e);
}
let Ne$3 = "div",
  Ue$1 = O.RenderStrategy | O.Static;
function We$2(o, e) {
  let r = I$6(),
    {
      id: i = `headlessui-dialog-${r}`,
      open: n,
      onClose: l,
      initialFocus: s,
      role: a = "dialog",
      __demoMode: T = !1,
      ...m
    } = o,
    [M, f] = useState(0),
    U = useRef(!1);
  a = function () {
    return a === "dialog" || a === "alertdialog" ? a : (U.current || (U.current = !0, console.warn(`Invalid role [${a}] passed to <Dialog />. Only \`dialog\` and and \`alertdialog\` are supported. Using \`dialog\` instead.`)), "dialog");
  }();
  let E$1 = u$5();
  n === void 0 && E$1 !== null && (n = (E$1 & d$7.Open) === d$7.Open);
  let D = useRef(null),
    ee = y$2(D, e),
    g = n$4(D),
    W = o.hasOwnProperty("open") || E$1 !== null,
    $ = o.hasOwnProperty("onClose");
  if (!W && !$) throw new Error("You have to provide an `open` and an `onClose` prop to the `Dialog` component.");
  if (!W) throw new Error("You provided an `onClose` prop to the `Dialog`, but forgot an `open` prop.");
  if (!$) throw new Error("You provided an `open` prop to the `Dialog`, but forgot an `onClose` prop.");
  if (typeof n != "boolean") throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${n}`);
  if (typeof l != "function") throw new Error(`You provided an \`onClose\` prop to the \`Dialog\`, but the value is not a function. Received: ${l}`);
  let p = n ? 0 : 1,
    [h, te] = useReducer(Ge$3, {
      titleId: null,
      descriptionId: null,
      panelRef: /*#__PURE__*/createRef()
    }),
    P = o$8(() => l(!1)),
    Y = o$8(t => te({
      type: 0,
      id: t
    })),
    S = l$6() ? T ? !1 : p === 0 : !1,
    x = M > 1,
    j = useContext(I$1) !== null,
    [oe, re] = ee$2(),
    ne = {
      get current() {
        var t;
        return (t = h.panelRef.current) != null ? t : D.current;
      }
    },
    {
      resolveContainers: w,
      mainTreeNodeRef: L,
      MainTreeNode: le
    } = N({
      portals: oe,
      defaultContainers: [ne]
    }),
    ae = x ? "parent" : "leaf",
    J = E$1 !== null ? (E$1 & d$7.Closing) === d$7.Closing : !1,
    ie = (() => j || J ? !1 : S)(),
    se = useCallback(() => {
      var t, c;
      return (c = Array.from((t = g == null ? void 0 : g.querySelectorAll("body > *")) != null ? t : []).find(d => d.id === "headlessui-portal-root" ? !1 : d.contains(L.current) && d instanceof HTMLElement)) != null ? c : null;
    }, [L]);
  b$4(se, ie);
  let pe = (() => x ? !0 : S)(),
    de = useCallback(() => {
      var t, c;
      return (c = Array.from((t = g == null ? void 0 : g.querySelectorAll("[data-headlessui-portal]")) != null ? t : []).find(d => d.contains(L.current) && d instanceof HTMLElement)) != null ? c : null;
    }, [L]);
  b$4(de, pe);
  let ue = (() => !(!S || x))();
  y$3(w, t => {
    t.preventDefault(), P();
  }, ue);
  let fe = (() => !(x || p !== 0))();
  E(g == null ? void 0 : g.defaultView, "keydown", t => {
    fe && (t.defaultPrevented || t.key === o$3.Escape && (t.preventDefault(), t.stopPropagation(), P()));
  });
  let ge = (() => !(J || p !== 0 || j))();
  Be$1(g, ge, w), useEffect(() => {
    if (p !== 0 || !D.current) return;
    let t = new ResizeObserver(c => {
      for (let d of c) {
        let F = d.target.getBoundingClientRect();
        F.x === 0 && F.y === 0 && F.width === 0 && F.height === 0 && P();
      }
    });
    return t.observe(D.current), () => t.disconnect();
  }, [p, D, P]);
  let [Te, ce] = w$2(),
    De = useMemo(() => [{
      dialogState: p,
      close: P,
      setTitleId: Y
    }, h], [p, h, P, Y]),
    X = useMemo(() => ({
      open: p === 0
    }), [p]),
    me = {
      ref: ee,
      id: i,
      role: a,
      "aria-modal": p === 0 ? !0 : void 0,
      "aria-labelledby": h.titleId,
      "aria-describedby": Te
    };
  return /*#__PURE__*/React__default.createElement(b$3, {
    type: "Dialog",
    enabled: p === 0,
    element: D,
    onUpdate: o$8((t, c) => {
      c === "Dialog" && u$9(t, {
        [s$4.Add]: () => f(d => d + 1),
        [s$4.Remove]: () => f(d => d - 1)
      });
    })
  }, /*#__PURE__*/React__default.createElement(l$4, {
    force: !0
  }, /*#__PURE__*/React__default.createElement(te$2, null, /*#__PURE__*/React__default.createElement(I$1.Provider, {
    value: De
  }, /*#__PURE__*/React__default.createElement(te$2.Group, {
    target: D
  }, /*#__PURE__*/React__default.createElement(l$4, {
    force: !1
  }, /*#__PURE__*/React__default.createElement(ce, {
    slot: X,
    name: "Dialog.Description"
  }, /*#__PURE__*/React__default.createElement(de$2, {
    initialFocus: s,
    containers: w,
    features: S ? u$9(ae, {
      parent: de$2.features.RestoreFocus,
      leaf: de$2.features.All & ~de$2.features.FocusLock
    }) : de$2.features.None
  }, /*#__PURE__*/React__default.createElement(re, null, C$2({
    ourProps: me,
    theirProps: m,
    slot: X,
    defaultTag: Ne$3,
    features: Ue$1,
    visible: p === 0,
    name: "Dialog"
  }))))))))), /*#__PURE__*/React__default.createElement(le, null));
}
let $e$2 = "div";
function Ye$2(o, e) {
  let r = I$6(),
    {
      id: i = `headlessui-dialog-overlay-${r}`,
      ...n
    } = o,
    [{
      dialogState: l,
      close: s
    }] = b$2("Dialog.Overlay"),
    a = y$2(e),
    T = o$8(f => {
      if (f.target === f.currentTarget) {
        if (r$4(f.currentTarget)) return f.preventDefault();
        f.preventDefault(), f.stopPropagation(), s();
      }
    }),
    m = useMemo(() => ({
      open: l === 0
    }), [l]);
  return C$2({
    ourProps: {
      ref: a,
      id: i,
      "aria-hidden": !0,
      onClick: T
    },
    theirProps: n,
    slot: m,
    defaultTag: $e$2,
    name: "Dialog.Overlay"
  });
}
let je$2 = "div";
function Je$2(o, e) {
  let r = I$6(),
    {
      id: i = `headlessui-dialog-backdrop-${r}`,
      ...n
    } = o,
    [{
      dialogState: l
    }, s] = b$2("Dialog.Backdrop"),
    a = y$2(e);
  useEffect(() => {
    if (s.panelRef.current === null) throw new Error("A <Dialog.Backdrop /> component is being used, but a <Dialog.Panel /> component is missing.");
  }, [s.panelRef]);
  let T = useMemo(() => ({
    open: l === 0
  }), [l]);
  return /*#__PURE__*/React__default.createElement(l$4, {
    force: !0
  }, /*#__PURE__*/React__default.createElement(te$2, null, C$2({
    ourProps: {
      ref: a,
      id: i,
      "aria-hidden": !0
    },
    theirProps: n,
    slot: T,
    defaultTag: je$2,
    name: "Dialog.Backdrop"
  })));
}
let Xe$2 = "div";
function Ke$2(o, e) {
  let r = I$6(),
    {
      id: i = `headlessui-dialog-panel-${r}`,
      ...n
    } = o,
    [{
      dialogState: l
    }, s] = b$2("Dialog.Panel"),
    a = y$2(e, s.panelRef),
    T = useMemo(() => ({
      open: l === 0
    }), [l]),
    m = o$8(f => {
      f.stopPropagation();
    });
  return C$2({
    ourProps: {
      ref: a,
      id: i,
      onClick: m
    },
    theirProps: n,
    slot: T,
    defaultTag: Xe$2,
    name: "Dialog.Panel"
  });
}
let Ve$2 = "h2";
function qe$2(o, e) {
  let r = I$6(),
    {
      id: i = `headlessui-dialog-title-${r}`,
      ...n
    } = o,
    [{
      dialogState: l,
      setTitleId: s
    }] = b$2("Dialog.Title"),
    a = y$2(e);
  useEffect(() => (s(i), () => s(null)), [i, s]);
  let T = useMemo(() => ({
    open: l === 0
  }), [l]);
  return C$2({
    ourProps: {
      ref: a,
      id: i
    },
    theirProps: n,
    slot: T,
    defaultTag: Ve$2,
    name: "Dialog.Title"
  });
}
let ze$2 = U$3(We$2),
  Qe$2 = U$3(Je$2),
  Ze$2 = U$3(Ke$2),
  et$2 = U$3(Ye$2),
  tt$2 = U$3(qe$2);
  Object.assign(ze$2, {
    Backdrop: Qe$2,
    Panel: Ze$2,
    Overlay: et$2,
    Title: tt$2,
    Description: G
  });

var t$2;
let a$4 = (t$2 = React__default.startTransition) != null ? t$2 : function (i) {
  i();
};

var Q = (o => (o[o.Open = 0] = "Open", o[o.Closed = 1] = "Closed", o))(Q || {}),
  V = (t => (t[t.ToggleDisclosure = 0] = "ToggleDisclosure", t[t.CloseDisclosure = 1] = "CloseDisclosure", t[t.SetButtonId = 2] = "SetButtonId", t[t.SetPanelId = 3] = "SetPanelId", t[t.LinkPanel = 4] = "LinkPanel", t[t.UnlinkPanel = 5] = "UnlinkPanel", t))(V || {});
let Y = {
    [0]: e => ({
      ...e,
      disclosureState: u$9(e.disclosureState, {
        [0]: 1,
        [1]: 0
      })
    }),
    [1]: e => e.disclosureState === 1 ? e : {
      ...e,
      disclosureState: 1
    },
    [4](e) {
      return e.linkedPanel === !0 ? e : {
        ...e,
        linkedPanel: !0
      };
    },
    [5](e) {
      return e.linkedPanel === !1 ? e : {
        ...e,
        linkedPanel: !1
      };
    },
    [2](e, n) {
      return e.buttonId === n.buttonId ? e : {
        ...e,
        buttonId: n.buttonId
      };
    },
    [3](e, n) {
      return e.panelId === n.panelId ? e : {
        ...e,
        panelId: n.panelId
      };
    }
  },
  M$2 = /*#__PURE__*/createContext(null);
M$2.displayName = "DisclosureContext";
function _(e) {
  let n = useContext(M$2);
  if (n === null) {
    let o = new Error(`<${e} /> is missing a parent <Disclosure /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(o, _), o;
  }
  return n;
}
let v$3 = /*#__PURE__*/createContext(null);
v$3.displayName = "DisclosureAPIContext";
function K(e) {
  let n = useContext(v$3);
  if (n === null) {
    let o = new Error(`<${e} /> is missing a parent <Disclosure /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(o, K), o;
  }
  return n;
}
let F$2 = /*#__PURE__*/createContext(null);
F$2.displayName = "DisclosurePanelContext";
function Z() {
  return useContext(F$2);
}
function ee$1(e, n) {
  return u$9(n.type, Y, e, n);
}
let te$1 = Fragment;
function ne$2(e, n) {
  let {
      defaultOpen: o = !1,
      ...i
    } = e,
    f = useRef(null),
    l = y$2(n, T(u => {
      f.current = u;
    }, e.as === void 0 || e.as === Fragment)),
    t = useRef(null),
    d = useRef(null),
    s = useReducer(ee$1, {
      disclosureState: o ? 0 : 1,
      linkedPanel: !1,
      buttonRef: d,
      panelRef: t,
      buttonId: null,
      panelId: null
    }),
    [{
      disclosureState: c,
      buttonId: a
    }, D] = s,
    p = o$8(u => {
      D({
        type: 1
      });
      let y = o$5(f);
      if (!y || !a) return;
      let r = (() => u ? u instanceof HTMLElement ? u : u.current instanceof HTMLElement ? u.current : y.getElementById(a) : y.getElementById(a))();
      r == null || r.focus();
    }),
    P = useMemo(() => ({
      close: p
    }), [p]),
    T$1 = useMemo(() => ({
      open: c === 0,
      close: p
    }), [c, p]),
    C = {
      ref: l
    };
  return /*#__PURE__*/React__default.createElement(M$2.Provider, {
    value: s
  }, /*#__PURE__*/React__default.createElement(v$3.Provider, {
    value: P
  }, /*#__PURE__*/React__default.createElement(s$7, {
    value: u$9(c, {
      [0]: d$7.Open,
      [1]: d$7.Closed
    })
  }, C$2({
    ourProps: C,
    theirProps: i,
    slot: T$1,
    defaultTag: te$1,
    name: "Disclosure"
  }))));
}
let le$1 = "button";
function oe$3(e, n) {
  let o = I$6(),
    {
      id: i = `headlessui-disclosure-button-${o}`,
      ...f
    } = e,
    [l, t] = _("Disclosure.Button"),
    d = Z(),
    s = d === null ? !1 : d === l.panelId,
    c = useRef(null),
    a = y$2(c, n, s ? null : l.buttonRef),
    D = I$4();
  useEffect(() => {
    if (!s) return t({
      type: 2,
      buttonId: i
    }), () => {
      t({
        type: 2,
        buttonId: null
      });
    };
  }, [i, t, s]);
  let p = o$8(r => {
      var m;
      if (s) {
        if (l.disclosureState === 1) return;
        switch (r.key) {
          case o$3.Space:
          case o$3.Enter:
            r.preventDefault(), r.stopPropagation(), t({
              type: 0
            }), (m = l.buttonRef.current) == null || m.focus();
            break;
        }
      } else switch (r.key) {
        case o$3.Space:
        case o$3.Enter:
          r.preventDefault(), r.stopPropagation(), t({
            type: 0
          });
          break;
      }
    }),
    P = o$8(r => {
      switch (r.key) {
        case o$3.Space:
          r.preventDefault();
          break;
      }
    }),
    T = o$8(r => {
      var m;
      r$4(r.currentTarget) || e.disabled || (s ? (t({
        type: 0
      }), (m = l.buttonRef.current) == null || m.focus()) : t({
        type: 0
      }));
    }),
    C = useMemo(() => ({
      open: l.disclosureState === 0
    }), [l]),
    u = T$1(e, c),
    y = s ? {
      ref: a,
      type: u,
      onKeyDown: p,
      onClick: T
    } : {
      ref: a,
      id: i,
      type: u,
      "aria-expanded": l.disclosureState === 0,
      "aria-controls": l.linkedPanel ? l.panelId : void 0,
      onKeyDown: p,
      onKeyUp: P,
      onClick: T
    };
  return C$2({
    mergeRefs: D,
    ourProps: y,
    theirProps: f,
    slot: C,
    defaultTag: le$1,
    name: "Disclosure.Button"
  });
}
let re$2 = "div",
  se$1 = O.RenderStrategy | O.Static;
function ue$3(e, n) {
  let o = I$6(),
    {
      id: i = `headlessui-disclosure-panel-${o}`,
      ...f
    } = e,
    [l, t] = _("Disclosure.Panel"),
    {
      close: d
    } = K("Disclosure.Panel"),
    s = I$4(),
    c = y$2(n, l.panelRef, T => {
      a$4(() => t({
        type: T ? 4 : 5
      }));
    });
  useEffect(() => (t({
    type: 3,
    panelId: i
  }), () => {
    t({
      type: 3,
      panelId: null
    });
  }), [i, t]);
  let a = u$5(),
    D = (() => a !== null ? (a & d$7.Open) === d$7.Open : l.disclosureState === 0)(),
    p = useMemo(() => ({
      open: l.disclosureState === 0,
      close: d
    }), [l, d]),
    P = {
      ref: c,
      id: i
    };
  return /*#__PURE__*/React__default.createElement(F$2.Provider, {
    value: l.panelId
  }, C$2({
    mergeRefs: s,
    ourProps: P,
    theirProps: f,
    slot: p,
    defaultTag: re$2,
    features: se$1,
    visible: D,
    name: "Disclosure.Panel"
  }));
}
let ie$2 = U$3(ne$2),
  ae$1 = U$3(oe$3),
  pe = U$3(ue$3);
  Object.assign(ie$2, {
    Button: ae$1,
    Panel: pe
  });

let a$3 = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
function o$2(e) {
  var r, i;
  let n = (r = e.innerText) != null ? r : "",
    t = e.cloneNode(!0);
  if (!(t instanceof HTMLElement)) return n;
  let u = !1;
  for (let f of t.querySelectorAll('[hidden],[aria-hidden],[role="img"]')) f.remove(), u = !0;
  let l = u ? (i = t.innerText) != null ? i : "" : n;
  return a$3.test(l) && (l = l.replace(a$3, "")), l;
}
function g$2(e) {
  let n = e.getAttribute("aria-label");
  if (typeof n == "string") return n.trim();
  let t = e.getAttribute("aria-labelledby");
  if (t) {
    let u = t.split(" ").map(l => {
      let r = document.getElementById(l);
      if (r) {
        let i = r.getAttribute("aria-label");
        return typeof i == "string" ? i.trim() : o$2(r).trim();
      }
      return null;
    }).filter(Boolean);
    if (u.length > 0) return u.join(", ");
  }
  return o$2(e).trim();
}

function s$3(c) {
  let t = useRef(""),
    r = useRef("");
  return o$8(() => {
    let e = c.current;
    if (!e) return "";
    let u = e.innerText;
    if (t.current === u) return r.current;
    let n = g$2(e).trim().toLowerCase();
    return t.current = u, r.current = n, n;
  });
}

var Be = (n => (n[n.Open = 0] = "Open", n[n.Closed = 1] = "Closed", n))(Be || {}),
  He$2 = (n => (n[n.Single = 0] = "Single", n[n.Multi = 1] = "Multi", n))(He$2 || {}),
  Ge$2 = (n => (n[n.Pointer = 0] = "Pointer", n[n.Other = 1] = "Other", n))(Ge$2 || {}),
  Ne$2 = (i => (i[i.OpenListbox = 0] = "OpenListbox", i[i.CloseListbox = 1] = "CloseListbox", i[i.GoToOption = 2] = "GoToOption", i[i.Search = 3] = "Search", i[i.ClearSearch = 4] = "ClearSearch", i[i.RegisterOption = 5] = "RegisterOption", i[i.UnregisterOption = 6] = "UnregisterOption", i[i.RegisterLabel = 7] = "RegisterLabel", i))(Ne$2 || {});
function z(e, a = n => n) {
  let n = e.activeOptionIndex !== null ? e.options[e.activeOptionIndex] : null,
    r = I$5(a(e.options.slice()), t => t.dataRef.current.domRef.current),
    l = n ? r.indexOf(n) : null;
  return l === -1 && (l = null), {
    options: r,
    activeOptionIndex: l
  };
}
let je$1 = {
    [1](e) {
      return e.dataRef.current.disabled || e.listboxState === 1 ? e : {
        ...e,
        activeOptionIndex: null,
        listboxState: 1
      };
    },
    [0](e) {
      if (e.dataRef.current.disabled || e.listboxState === 0) return e;
      let a = e.activeOptionIndex,
        {
          isSelected: n
        } = e.dataRef.current,
        r = e.options.findIndex(l => n(l.dataRef.current.value));
      return r !== -1 && (a = r), {
        ...e,
        listboxState: 0,
        activeOptionIndex: a
      };
    },
    [2](e, a) {
      var l;
      if (e.dataRef.current.disabled || e.listboxState === 1) return e;
      let n = z(e),
        r = f$7(a, {
          resolveItems: () => n.options,
          resolveActiveIndex: () => n.activeOptionIndex,
          resolveId: t => t.id,
          resolveDisabled: t => t.dataRef.current.disabled
        });
      return {
        ...e,
        ...n,
        searchQuery: "",
        activeOptionIndex: r,
        activationTrigger: (l = a.trigger) != null ? l : 1
      };
    },
    [3]: (e, a) => {
      if (e.dataRef.current.disabled || e.listboxState === 1) return e;
      let r = e.searchQuery !== "" ? 0 : 1,
        l = e.searchQuery + a.value.toLowerCase(),
        p = (e.activeOptionIndex !== null ? e.options.slice(e.activeOptionIndex + r).concat(e.options.slice(0, e.activeOptionIndex + r)) : e.options).find(i => {
          var b;
          return !i.dataRef.current.disabled && ((b = i.dataRef.current.textValue) == null ? void 0 : b.startsWith(l));
        }),
        u = p ? e.options.indexOf(p) : -1;
      return u === -1 || u === e.activeOptionIndex ? {
        ...e,
        searchQuery: l
      } : {
        ...e,
        searchQuery: l,
        activeOptionIndex: u,
        activationTrigger: 1
      };
    },
    [4](e) {
      return e.dataRef.current.disabled || e.listboxState === 1 || e.searchQuery === "" ? e : {
        ...e,
        searchQuery: ""
      };
    },
    [5]: (e, a) => {
      let n = {
          id: a.id,
          dataRef: a.dataRef
        },
        r = z(e, l => [...l, n]);
      return e.activeOptionIndex === null && e.dataRef.current.isSelected(a.dataRef.current.value) && (r.activeOptionIndex = r.options.indexOf(n)), {
        ...e,
        ...r
      };
    },
    [6]: (e, a) => {
      let n = z(e, r => {
        let l = r.findIndex(t => t.id === a.id);
        return l !== -1 && r.splice(l, 1), r;
      });
      return {
        ...e,
        ...n,
        activationTrigger: 1
      };
    },
    [7]: (e, a) => ({
      ...e,
      labelId: a.id
    })
  },
  J = /*#__PURE__*/createContext(null);
J.displayName = "ListboxActionsContext";
function k(e) {
  let a = useContext(J);
  if (a === null) {
    let n = new Error(`<${e} /> is missing a parent <Listbox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, k), n;
  }
  return a;
}
let q$2 = /*#__PURE__*/createContext(null);
q$2.displayName = "ListboxDataContext";
function w$1(e) {
  let a = useContext(q$2);
  if (a === null) {
    let n = new Error(`<${e} /> is missing a parent <Listbox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, w$1), n;
  }
  return a;
}
function Ve$1(e, a) {
  return u$9(a.type, je$1, e, a);
}
let Ke$1 = Fragment;
function Qe$1(e, a) {
  let {
    value: n,
    defaultValue: r,
    form: l,
    name: t,
    onChange: p,
    by: u = (s, c) => s === c,
    disabled: i = !1,
    horizontal: b = !1,
    multiple: R = !1,
    ...m
  } = e;
  const P = b ? "horizontal" : "vertical";
  let S = y$2(a),
    [g = R ? [] : void 0, x] = T$3(n, p, r),
    [T, o] = useReducer(Ve$1, {
      dataRef: /*#__PURE__*/createRef(),
      listboxState: 1,
      options: [],
      searchQuery: "",
      labelId: null,
      activeOptionIndex: null,
      activationTrigger: 1
    }),
    L = useRef({
      static: !1,
      hold: !1
    }),
    U = useRef(null),
    B = useRef(null),
    W = useRef(null),
    I = o$8(typeof u == "string" ? (s, c) => {
      let O = u;
      return (s == null ? void 0 : s[O]) === (c == null ? void 0 : c[O]);
    } : u),
    A = useCallback(s => u$9(d.mode, {
      [1]: () => g.some(c => I(c, s)),
      [0]: () => I(g, s)
    }), [g]),
    d = useMemo(() => ({
      ...T,
      value: g,
      disabled: i,
      mode: R ? 1 : 0,
      orientation: P,
      compare: I,
      isSelected: A,
      optionsPropsRef: L,
      labelRef: U,
      buttonRef: B,
      optionsRef: W
    }), [g, i, R, T]);
  l$7(() => {
    T.dataRef.current = d;
  }, [d]), y$3([d.buttonRef, d.optionsRef], (s, c) => {
    var O;
    o({
      type: 1
    }), h$4(c, T$2.Loose) || (s.preventDefault(), (O = d.buttonRef.current) == null || O.focus());
  }, d.listboxState === 0);
  let H = useMemo(() => ({
      open: d.listboxState === 0,
      disabled: i,
      value: g
    }), [d, i, g]),
    ie = o$8(s => {
      let c = d.options.find(O => O.id === s);
      c && X(c.dataRef.current.value);
    }),
    re = o$8(() => {
      if (d.activeOptionIndex !== null) {
        let {
          dataRef: s,
          id: c
        } = d.options[d.activeOptionIndex];
        X(s.current.value), o({
          type: 2,
          focus: c$6.Specific,
          id: c
        });
      }
    }),
    ae = o$8(() => o({
      type: 0
    })),
    le = o$8(() => o({
      type: 1
    })),
    se = o$8((s, c, O) => s === c$6.Specific ? o({
      type: 2,
      focus: c$6.Specific,
      id: c,
      trigger: O
    }) : o({
      type: 2,
      focus: s,
      trigger: O
    })),
    pe = o$8((s, c) => (o({
      type: 5,
      id: s,
      dataRef: c
    }), () => o({
      type: 6,
      id: s
    }))),
    ue = o$8(s => (o({
      type: 7,
      id: s
    }), () => o({
      type: 7,
      id: null
    }))),
    X = o$8(s => u$9(d.mode, {
      [0]() {
        return x == null ? void 0 : x(s);
      },
      [1]() {
        let c = d.value.slice(),
          O = c.findIndex(C => I(C, s));
        return O === -1 ? c.push(s) : c.splice(O, 1), x == null ? void 0 : x(c);
      }
    })),
    de = o$8(s => o({
      type: 3,
      value: s
    })),
    ce = o$8(() => o({
      type: 4
    })),
    fe = useMemo(() => ({
      onChange: X,
      registerOption: pe,
      registerLabel: ue,
      goToOption: se,
      closeListbox: le,
      openListbox: ae,
      selectActiveOption: re,
      selectOption: ie,
      search: de,
      clearSearch: ce
    }), []),
    Te = {
      ref: S
    },
    G = useRef(null),
    be = p$5();
  return useEffect(() => {
    G.current && r !== void 0 && be.addEventListener(G.current, "reset", () => {
      x == null || x(r);
    });
  }, [G, x]), /*#__PURE__*/React__default.createElement(J.Provider, {
    value: fe
  }, /*#__PURE__*/React__default.createElement(q$2.Provider, {
    value: d
  }, /*#__PURE__*/React__default.createElement(s$7, {
    value: u$9(d.listboxState, {
      [0]: d$7.Open,
      [1]: d$7.Closed
    })
  }, t != null && g != null && e$3({
    [t]: g
  }).map(([s, c], O) => /*#__PURE__*/React__default.createElement(u$6, {
    features: s$8.Hidden,
    ref: O === 0 ? C => {
      var Y;
      G.current = (Y = C == null ? void 0 : C.closest("form")) != null ? Y : null;
    } : void 0,
    ...x$1({
      key: s,
      as: "input",
      type: "hidden",
      hidden: !0,
      readOnly: !0,
      form: l,
      disabled: i,
      name: s,
      value: c
    })
  })), C$2({
    ourProps: Te,
    theirProps: m,
    slot: H,
    defaultTag: Ke$1,
    name: "Listbox"
  }))));
}
let We$1 = "button";
function Xe$1(e, a) {
  var x;
  let n = I$6(),
    {
      id: r = `headlessui-listbox-button-${n}`,
      ...l
    } = e,
    t = w$1("Listbox.Button"),
    p = k("Listbox.Button"),
    u = y$2(t.buttonRef, a),
    i = p$5(),
    b = o$8(T => {
      switch (T.key) {
        case o$3.Space:
        case o$3.Enter:
        case o$3.ArrowDown:
          T.preventDefault(), p.openListbox(), i.nextFrame(() => {
            t.value || p.goToOption(c$6.First);
          });
          break;
        case o$3.ArrowUp:
          T.preventDefault(), p.openListbox(), i.nextFrame(() => {
            t.value || p.goToOption(c$6.Last);
          });
          break;
      }
    }),
    R = o$8(T => {
      switch (T.key) {
        case o$3.Space:
          T.preventDefault();
          break;
      }
    }),
    m = o$8(T => {
      if (r$4(T.currentTarget)) return T.preventDefault();
      t.listboxState === 0 ? (p.closeListbox(), i.nextFrame(() => {
        var o;
        return (o = t.buttonRef.current) == null ? void 0 : o.focus({
          preventScroll: !0
        });
      })) : (T.preventDefault(), p.openListbox());
    }),
    P = i$6(() => {
      if (t.labelId) return [t.labelId, r].join(" ");
    }, [t.labelId, r]),
    S = useMemo(() => ({
      open: t.listboxState === 0,
      disabled: t.disabled,
      value: t.value
    }), [t]),
    g = {
      ref: u,
      id: r,
      type: T$1(e, t.buttonRef),
      "aria-haspopup": "listbox",
      "aria-controls": (x = t.optionsRef.current) == null ? void 0 : x.id,
      "aria-expanded": t.listboxState === 0,
      "aria-labelledby": P,
      disabled: t.disabled,
      onKeyDown: b,
      onKeyUp: R,
      onClick: m
    };
  return C$2({
    ourProps: g,
    theirProps: l,
    slot: S,
    defaultTag: We$1,
    name: "Listbox.Button"
  });
}
let $e$1 = "label";
function ze$1(e, a) {
  let n = I$6(),
    {
      id: r = `headlessui-listbox-label-${n}`,
      ...l
    } = e,
    t = w$1("Listbox.Label"),
    p = k("Listbox.Label"),
    u = y$2(t.labelRef, a);
  l$7(() => p.registerLabel(r), [r]);
  let i = o$8(() => {
      var m;
      return (m = t.buttonRef.current) == null ? void 0 : m.focus({
        preventScroll: !0
      });
    }),
    b = useMemo(() => ({
      open: t.listboxState === 0,
      disabled: t.disabled
    }), [t]);
  return C$2({
    ourProps: {
      ref: u,
      id: r,
      onClick: i
    },
    theirProps: l,
    slot: b,
    defaultTag: $e$1,
    name: "Listbox.Label"
  });
}
let Je$1 = "ul",
  qe$1 = O.RenderStrategy | O.Static;
function Ye$1(e, a) {
  var T;
  let n = I$6(),
    {
      id: r = `headlessui-listbox-options-${n}`,
      ...l
    } = e,
    t = w$1("Listbox.Options"),
    p = k("Listbox.Options"),
    u = y$2(t.optionsRef, a),
    i = p$5(),
    b = p$5(),
    R = u$5(),
    m = (() => R !== null ? (R & d$7.Open) === d$7.Open : t.listboxState === 0)();
  useEffect(() => {
    var L;
    let o = t.optionsRef.current;
    o && t.listboxState === 0 && o !== ((L = o$5(o)) == null ? void 0 : L.activeElement) && o.focus({
      preventScroll: !0
    });
  }, [t.listboxState, t.optionsRef]);
  let P = o$8(o => {
      switch (b.dispose(), o.key) {
        case o$3.Space:
          if (t.searchQuery !== "") return o.preventDefault(), o.stopPropagation(), p.search(o.key);
        case o$3.Enter:
          if (o.preventDefault(), o.stopPropagation(), t.activeOptionIndex !== null) {
            let {
              dataRef: L
            } = t.options[t.activeOptionIndex];
            p.onChange(L.current.value);
          }
          t.mode === 0 && (p.closeListbox(), o$7().nextFrame(() => {
            var L;
            return (L = t.buttonRef.current) == null ? void 0 : L.focus({
              preventScroll: !0
            });
          }));
          break;
        case u$9(t.orientation, {
          vertical: o$3.ArrowDown,
          horizontal: o$3.ArrowRight
        }):
          return o.preventDefault(), o.stopPropagation(), p.goToOption(c$6.Next);
        case u$9(t.orientation, {
          vertical: o$3.ArrowUp,
          horizontal: o$3.ArrowLeft
        }):
          return o.preventDefault(), o.stopPropagation(), p.goToOption(c$6.Previous);
        case o$3.Home:
        case o$3.PageUp:
          return o.preventDefault(), o.stopPropagation(), p.goToOption(c$6.First);
        case o$3.End:
        case o$3.PageDown:
          return o.preventDefault(), o.stopPropagation(), p.goToOption(c$6.Last);
        case o$3.Escape:
          return o.preventDefault(), o.stopPropagation(), p.closeListbox(), i.nextFrame(() => {
            var L;
            return (L = t.buttonRef.current) == null ? void 0 : L.focus({
              preventScroll: !0
            });
          });
        case o$3.Tab:
          o.preventDefault(), o.stopPropagation();
          break;
        default:
          o.key.length === 1 && (p.search(o.key), b.setTimeout(() => p.clearSearch(), 350));
          break;
      }
    }),
    S = i$6(() => {
      var o;
      return (o = t.buttonRef.current) == null ? void 0 : o.id;
    }, [t.buttonRef.current]),
    g = useMemo(() => ({
      open: t.listboxState === 0
    }), [t]),
    x = {
      "aria-activedescendant": t.activeOptionIndex === null || (T = t.options[t.activeOptionIndex]) == null ? void 0 : T.id,
      "aria-multiselectable": t.mode === 1 ? !0 : void 0,
      "aria-labelledby": S,
      "aria-orientation": t.orientation,
      id: r,
      onKeyDown: P,
      role: "listbox",
      tabIndex: 0,
      ref: u
    };
  return C$2({
    ourProps: x,
    theirProps: l,
    slot: g,
    defaultTag: Je$1,
    features: qe$1,
    visible: m,
    name: "Listbox.Options"
  });
}
let Ze$1 = "li";
function et$1(e, a) {
  let n = I$6(),
    {
      id: r = `headlessui-listbox-option-${n}`,
      disabled: l = !1,
      value: t,
      ...p
    } = e,
    u = w$1("Listbox.Option"),
    i = k("Listbox.Option"),
    b = u.activeOptionIndex !== null ? u.options[u.activeOptionIndex].id === r : !1,
    R = u.isSelected(t),
    m = useRef(null),
    P = s$3(m),
    S = s$b({
      disabled: l,
      value: t,
      domRef: m,
      get textValue() {
        return P();
      }
    }),
    g = y$2(a, m);
  l$7(() => {
    if (u.listboxState !== 0 || !b || u.activationTrigger === 0) return;
    let A = o$7();
    return A.requestAnimationFrame(() => {
      var d, H;
      (H = (d = m.current) == null ? void 0 : d.scrollIntoView) == null || H.call(d, {
        block: "nearest"
      });
    }), A.dispose;
  }, [m, b, u.listboxState, u.activationTrigger, u.activeOptionIndex]), l$7(() => i.registerOption(r, S), [S, r]);
  let x = o$8(A => {
      if (l) return A.preventDefault();
      i.onChange(t), u.mode === 0 && (i.closeListbox(), o$7().nextFrame(() => {
        var d;
        return (d = u.buttonRef.current) == null ? void 0 : d.focus({
          preventScroll: !0
        });
      }));
    }),
    T = o$8(() => {
      if (l) return i.goToOption(c$6.Nothing);
      i.goToOption(c$6.Specific, r);
    }),
    o = u$7(),
    L = o$8(A => o.update(A)),
    U = o$8(A => {
      o.wasMoved(A) && (l || b || i.goToOption(c$6.Specific, r, 0));
    }),
    B = o$8(A => {
      o.wasMoved(A) && (l || b && i.goToOption(c$6.Nothing));
    }),
    W = useMemo(() => ({
      active: b,
      selected: R,
      disabled: l
    }), [b, R, l]);
  return C$2({
    ourProps: {
      id: r,
      ref: g,
      role: "option",
      tabIndex: l === !0 ? void 0 : -1,
      "aria-disabled": l === !0 ? !0 : void 0,
      "aria-selected": R,
      disabled: void 0,
      onClick: x,
      onFocus: T,
      onPointerEnter: L,
      onMouseEnter: L,
      onPointerMove: U,
      onMouseMove: U,
      onPointerLeave: B,
      onMouseLeave: B
    },
    theirProps: p,
    slot: W,
    defaultTag: Ze$1,
    name: "Listbox.Option"
  });
}
let tt$1 = U$3(Qe$1),
  ot$1 = U$3(Xe$1),
  nt = U$3(ze$1),
  it = U$3(Ye$1),
  rt = U$3(et$1);
  Object.assign(tt$1, {
    Button: ot$1,
    Label: nt,
    Options: it,
    Option: rt
  });

var me$1 = (r => (r[r.Open = 0] = "Open", r[r.Closed = 1] = "Closed", r))(me$1 || {}),
  de$1 = (r => (r[r.Pointer = 0] = "Pointer", r[r.Other = 1] = "Other", r))(de$1 || {}),
  fe$2 = (a => (a[a.OpenMenu = 0] = "OpenMenu", a[a.CloseMenu = 1] = "CloseMenu", a[a.GoToItem = 2] = "GoToItem", a[a.Search = 3] = "Search", a[a.ClearSearch = 4] = "ClearSearch", a[a.RegisterItem = 5] = "RegisterItem", a[a.UnregisterItem = 6] = "UnregisterItem", a))(fe$2 || {});
function w(e, u = r => r) {
  let r = e.activeItemIndex !== null ? e.items[e.activeItemIndex] : null,
    s = I$5(u(e.items.slice()), t => t.dataRef.current.domRef.current),
    i = r ? s.indexOf(r) : null;
  return i === -1 && (i = null), {
    items: s,
    activeItemIndex: i
  };
}
let Te$1 = {
    [1](e) {
      return e.menuState === 1 ? e : {
        ...e,
        activeItemIndex: null,
        menuState: 1
      };
    },
    [0](e) {
      return e.menuState === 0 ? e : {
        ...e,
        __demoMode: !1,
        menuState: 0
      };
    },
    [2]: (e, u) => {
      var i;
      let r = w(e),
        s = f$7(u, {
          resolveItems: () => r.items,
          resolveActiveIndex: () => r.activeItemIndex,
          resolveId: t => t.id,
          resolveDisabled: t => t.dataRef.current.disabled
        });
      return {
        ...e,
        ...r,
        searchQuery: "",
        activeItemIndex: s,
        activationTrigger: (i = u.trigger) != null ? i : 1
      };
    },
    [3]: (e, u) => {
      let s = e.searchQuery !== "" ? 0 : 1,
        i = e.searchQuery + u.value.toLowerCase(),
        o = (e.activeItemIndex !== null ? e.items.slice(e.activeItemIndex + s).concat(e.items.slice(0, e.activeItemIndex + s)) : e.items).find(l => {
          var m;
          return ((m = l.dataRef.current.textValue) == null ? void 0 : m.startsWith(i)) && !l.dataRef.current.disabled;
        }),
        a = o ? e.items.indexOf(o) : -1;
      return a === -1 || a === e.activeItemIndex ? {
        ...e,
        searchQuery: i
      } : {
        ...e,
        searchQuery: i,
        activeItemIndex: a,
        activationTrigger: 1
      };
    },
    [4](e) {
      return e.searchQuery === "" ? e : {
        ...e,
        searchQuery: "",
        searchActiveItemIndex: null
      };
    },
    [5]: (e, u) => {
      let r = w(e, s => [...s, {
        id: u.id,
        dataRef: u.dataRef
      }]);
      return {
        ...e,
        ...r
      };
    },
    [6]: (e, u) => {
      let r = w(e, s => {
        let i = s.findIndex(t => t.id === u.id);
        return i !== -1 && s.splice(i, 1), s;
      });
      return {
        ...e,
        ...r,
        activationTrigger: 1
      };
    }
  },
  U$1 = /*#__PURE__*/createContext(null);
U$1.displayName = "MenuContext";
function C$1(e) {
  let u = useContext(U$1);
  if (u === null) {
    let r = new Error(`<${e} /> is missing a parent <Menu /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, C$1), r;
  }
  return u;
}
function ye$2(e, u) {
  return u$9(u.type, Te$1, e, u);
}
let Ie$2 = Fragment;
function Me(e, u) {
  let {
      __demoMode: r = !1,
      ...s
    } = e,
    i = useReducer(ye$2, {
      __demoMode: r,
      menuState: r ? 0 : 1,
      buttonRef: /*#__PURE__*/createRef(),
      itemsRef: /*#__PURE__*/createRef(),
      items: [],
      searchQuery: "",
      activeItemIndex: null,
      activationTrigger: 1
    }),
    [{
      menuState: t,
      itemsRef: o,
      buttonRef: a
    }, l] = i,
    m = y$2(u);
  y$3([a, o], (g, R) => {
    var p;
    l({
      type: 1
    }), h$4(R, T$2.Loose) || (g.preventDefault(), (p = a.current) == null || p.focus());
  }, t === 0);
  let I = o$8(() => {
      l({
        type: 1
      });
    }),
    A = useMemo(() => ({
      open: t === 0,
      close: I
    }), [t, I]),
    f = {
      ref: m
    };
  return /*#__PURE__*/React__default.createElement(U$1.Provider, {
    value: i
  }, /*#__PURE__*/React__default.createElement(s$7, {
    value: u$9(t, {
      [0]: d$7.Open,
      [1]: d$7.Closed
    })
  }, C$2({
    ourProps: f,
    theirProps: s,
    slot: A,
    defaultTag: Ie$2,
    name: "Menu"
  })));
}
let ge$1 = "button";
function Re$2(e, u) {
  var R;
  let r = I$6(),
    {
      id: s = `headlessui-menu-button-${r}`,
      ...i
    } = e,
    [t, o] = C$1("Menu.Button"),
    a = y$2(t.buttonRef, u),
    l = p$5(),
    m = o$8(p => {
      switch (p.key) {
        case o$3.Space:
        case o$3.Enter:
        case o$3.ArrowDown:
          p.preventDefault(), p.stopPropagation(), o({
            type: 0
          }), l.nextFrame(() => o({
            type: 2,
            focus: c$6.First
          }));
          break;
        case o$3.ArrowUp:
          p.preventDefault(), p.stopPropagation(), o({
            type: 0
          }), l.nextFrame(() => o({
            type: 2,
            focus: c$6.Last
          }));
          break;
      }
    }),
    I = o$8(p => {
      switch (p.key) {
        case o$3.Space:
          p.preventDefault();
          break;
      }
    }),
    A = o$8(p => {
      if (r$4(p.currentTarget)) return p.preventDefault();
      e.disabled || (t.menuState === 0 ? (o({
        type: 1
      }), l.nextFrame(() => {
        var M;
        return (M = t.buttonRef.current) == null ? void 0 : M.focus({
          preventScroll: !0
        });
      })) : (p.preventDefault(), o({
        type: 0
      })));
    }),
    f = useMemo(() => ({
      open: t.menuState === 0
    }), [t]),
    g = {
      ref: a,
      id: s,
      type: T$1(e, t.buttonRef),
      "aria-haspopup": "menu",
      "aria-controls": (R = t.itemsRef.current) == null ? void 0 : R.id,
      "aria-expanded": t.menuState === 0,
      onKeyDown: m,
      onKeyUp: I,
      onClick: A
    };
  return C$2({
    ourProps: g,
    theirProps: i,
    slot: f,
    defaultTag: ge$1,
    name: "Menu.Button"
  });
}
let Ae$1 = "div",
  be$1 = O.RenderStrategy | O.Static;
function Ee$2(e, u) {
  var M, b;
  let r = I$6(),
    {
      id: s = `headlessui-menu-items-${r}`,
      ...i
    } = e,
    [t, o] = C$1("Menu.Items"),
    a = y$2(t.itemsRef, u),
    l = n$4(t.itemsRef),
    m = p$5(),
    I = u$5(),
    A = (() => I !== null ? (I & d$7.Open) === d$7.Open : t.menuState === 0)();
  useEffect(() => {
    let n = t.itemsRef.current;
    n && t.menuState === 0 && n !== (l == null ? void 0 : l.activeElement) && n.focus({
      preventScroll: !0
    });
  }, [t.menuState, t.itemsRef, l]), F$5({
    container: t.itemsRef.current,
    enabled: t.menuState === 0,
    accept(n) {
      return n.getAttribute("role") === "menuitem" ? NodeFilter.FILTER_REJECT : n.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
    },
    walk(n) {
      n.setAttribute("role", "none");
    }
  });
  let f = o$8(n => {
      var E, x;
      switch (m.dispose(), n.key) {
        case o$3.Space:
          if (t.searchQuery !== "") return n.preventDefault(), n.stopPropagation(), o({
            type: 3,
            value: n.key
          });
        case o$3.Enter:
          if (n.preventDefault(), n.stopPropagation(), o({
            type: 1
          }), t.activeItemIndex !== null) {
            let {
              dataRef: S
            } = t.items[t.activeItemIndex];
            (x = (E = S.current) == null ? void 0 : E.domRef.current) == null || x.click();
          }
          D$3(t.buttonRef.current);
          break;
        case o$3.ArrowDown:
          return n.preventDefault(), n.stopPropagation(), o({
            type: 2,
            focus: c$6.Next
          });
        case o$3.ArrowUp:
          return n.preventDefault(), n.stopPropagation(), o({
            type: 2,
            focus: c$6.Previous
          });
        case o$3.Home:
        case o$3.PageUp:
          return n.preventDefault(), n.stopPropagation(), o({
            type: 2,
            focus: c$6.First
          });
        case o$3.End:
        case o$3.PageDown:
          return n.preventDefault(), n.stopPropagation(), o({
            type: 2,
            focus: c$6.Last
          });
        case o$3.Escape:
          n.preventDefault(), n.stopPropagation(), o({
            type: 1
          }), o$7().nextFrame(() => {
            var S;
            return (S = t.buttonRef.current) == null ? void 0 : S.focus({
              preventScroll: !0
            });
          });
          break;
        case o$3.Tab:
          n.preventDefault(), n.stopPropagation(), o({
            type: 1
          }), o$7().nextFrame(() => {
            _$3(t.buttonRef.current, n.shiftKey ? M$3.Previous : M$3.Next);
          });
          break;
        default:
          n.key.length === 1 && (o({
            type: 3,
            value: n.key
          }), m.setTimeout(() => o({
            type: 4
          }), 350));
          break;
      }
    }),
    g = o$8(n => {
      switch (n.key) {
        case o$3.Space:
          n.preventDefault();
          break;
      }
    }),
    R = useMemo(() => ({
      open: t.menuState === 0
    }), [t]),
    p = {
      "aria-activedescendant": t.activeItemIndex === null || (M = t.items[t.activeItemIndex]) == null ? void 0 : M.id,
      "aria-labelledby": (b = t.buttonRef.current) == null ? void 0 : b.id,
      id: s,
      onKeyDown: f,
      onKeyUp: g,
      role: "menu",
      tabIndex: 0,
      ref: a
    };
  return C$2({
    ourProps: p,
    theirProps: i,
    slot: R,
    defaultTag: Ae$1,
    features: be$1,
    visible: A,
    name: "Menu.Items"
  });
}
let Se$3 = Fragment;
function xe$3(e, u) {
  let r = I$6(),
    {
      id: s = `headlessui-menu-item-${r}`,
      disabled: i = !1,
      ...t
    } = e,
    [o, a] = C$1("Menu.Item"),
    l = o.activeItemIndex !== null ? o.items[o.activeItemIndex].id === s : !1,
    m = useRef(null),
    I = y$2(u, m);
  l$7(() => {
    if (o.__demoMode || o.menuState !== 0 || !l || o.activationTrigger === 0) return;
    let T = o$7();
    return T.requestAnimationFrame(() => {
      var P, B;
      (B = (P = m.current) == null ? void 0 : P.scrollIntoView) == null || B.call(P, {
        block: "nearest"
      });
    }), T.dispose;
  }, [o.__demoMode, m, l, o.menuState, o.activationTrigger, o.activeItemIndex]);
  let A = s$3(m),
    f = useRef({
      disabled: i,
      domRef: m,
      get textValue() {
        return A();
      }
    });
  l$7(() => {
    f.current.disabled = i;
  }, [f, i]), l$7(() => (a({
    type: 5,
    id: s,
    dataRef: f
  }), () => a({
    type: 6,
    id: s
  })), [f, s]);
  let g = o$8(() => {
      a({
        type: 1
      });
    }),
    R = o$8(T => {
      if (i) return T.preventDefault();
      a({
        type: 1
      }), D$3(o.buttonRef.current);
    }),
    p = o$8(() => {
      if (i) return a({
        type: 2,
        focus: c$6.Nothing
      });
      a({
        type: 2,
        focus: c$6.Specific,
        id: s
      });
    }),
    M = u$7(),
    b = o$8(T => M.update(T)),
    n = o$8(T => {
      M.wasMoved(T) && (i || l || a({
        type: 2,
        focus: c$6.Specific,
        id: s,
        trigger: 0
      }));
    }),
    E = o$8(T => {
      M.wasMoved(T) && (i || l && a({
        type: 2,
        focus: c$6.Nothing
      }));
    }),
    x = useMemo(() => ({
      active: l,
      disabled: i,
      close: g
    }), [l, i, g]);
  return C$2({
    ourProps: {
      id: s,
      ref: I,
      role: "menuitem",
      tabIndex: i === !0 ? void 0 : -1,
      "aria-disabled": i === !0 ? !0 : void 0,
      disabled: void 0,
      onClick: R,
      onFocus: p,
      onPointerEnter: b,
      onMouseEnter: b,
      onPointerMove: n,
      onMouseMove: n,
      onPointerLeave: E,
      onMouseLeave: E
    },
    theirProps: t,
    slot: x,
    defaultTag: Se$3,
    name: "Menu.Item"
  });
}
let Pe$3 = U$3(Me),
  ve = U$3(Re$2),
  he$3 = U$3(Ee$2),
  De$2 = U$3(xe$3);
  Object.assign(Pe$3, {
    Button: ve,
    Items: he$3,
    Item: De$2
  });

var he$2 = (u => (u[u.Open = 0] = "Open", u[u.Closed = 1] = "Closed", u))(he$2 || {}),
  He$1 = (e => (e[e.TogglePopover = 0] = "TogglePopover", e[e.ClosePopover = 1] = "ClosePopover", e[e.SetButton = 2] = "SetButton", e[e.SetButtonId = 3] = "SetButtonId", e[e.SetPanel = 4] = "SetPanel", e[e.SetPanelId = 5] = "SetPanelId", e))(He$1 || {});
let Ge$1 = {
    [0]: t => {
      let o = {
        ...t,
        popoverState: u$9(t.popoverState, {
          [0]: 1,
          [1]: 0
        })
      };
      return o.popoverState === 0 && (o.__demoMode = !1), o;
    },
    [1](t) {
      return t.popoverState === 1 ? t : {
        ...t,
        popoverState: 1
      };
    },
    [2](t, o) {
      return t.button === o.button ? t : {
        ...t,
        button: o.button
      };
    },
    [3](t, o) {
      return t.buttonId === o.buttonId ? t : {
        ...t,
        buttonId: o.buttonId
      };
    },
    [4](t, o) {
      return t.panel === o.panel ? t : {
        ...t,
        panel: o.panel
      };
    },
    [5](t, o) {
      return t.panelId === o.panelId ? t : {
        ...t,
        panelId: o.panelId
      };
    }
  },
  ue$2 = /*#__PURE__*/createContext(null);
ue$2.displayName = "PopoverContext";
function oe$2(t) {
  let o = useContext(ue$2);
  if (o === null) {
    let u = new Error(`<${t} /> is missing a parent <Popover /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(u, oe$2), u;
  }
  return o;
}
let ie$1 = /*#__PURE__*/createContext(null);
ie$1.displayName = "PopoverAPIContext";
function fe$1(t) {
  let o = useContext(ie$1);
  if (o === null) {
    let u = new Error(`<${t} /> is missing a parent <Popover /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(u, fe$1), u;
  }
  return o;
}
let Pe$2 = /*#__PURE__*/createContext(null);
Pe$2.displayName = "PopoverGroupContext";
function Ee$1() {
  return useContext(Pe$2);
}
let re$1 = /*#__PURE__*/createContext(null);
re$1.displayName = "PopoverPanelContext";
function Ne$1() {
  return useContext(re$1);
}
function ke$1(t, o) {
  return u$9(o.type, Ge$1, t, o);
}
let we$1 = "div";
function Ue(t, o) {
  var B;
  let {
      __demoMode: u = !1,
      ...M
    } = t,
    x = useRef(null),
    n = y$2(o, T(l => {
      x.current = l;
    })),
    e = useRef([]),
    c = useReducer(ke$1, {
      __demoMode: u,
      popoverState: u ? 0 : 1,
      buttons: e,
      button: null,
      buttonId: null,
      panel: null,
      panelId: null,
      beforePanelSentinel: /*#__PURE__*/createRef(),
      afterPanelSentinel: /*#__PURE__*/createRef()
    }),
    [{
      popoverState: f,
      button: s,
      buttonId: I,
      panel: a,
      panelId: v,
      beforePanelSentinel: y,
      afterPanelSentinel: A
    }, P] = c,
    p = n$4((B = x.current) != null ? B : s),
    E$1 = useMemo(() => {
      if (!s || !a) return !1;
      for (let W of document.querySelectorAll("body > *")) if (Number(W == null ? void 0 : W.contains(s)) ^ Number(W == null ? void 0 : W.contains(a))) return !0;
      let l = f$8(),
        S = l.indexOf(s),
        q = (S + l.length - 1) % l.length,
        U = (S + 1) % l.length,
        z = l[q],
        be = l[U];
      return !a.contains(z) && !a.contains(be);
    }, [s, a]),
    F = s$b(I),
    D = s$b(v),
    _ = useMemo(() => ({
      buttonId: F,
      panelId: D,
      close: () => P({
        type: 1
      })
    }), [F, D, P]),
    O = Ee$1(),
    L = O == null ? void 0 : O.registerPopover,
    $ = o$8(() => {
      var l;
      return (l = O == null ? void 0 : O.isFocusWithinPopoverGroup()) != null ? l : (p == null ? void 0 : p.activeElement) && ((s == null ? void 0 : s.contains(p.activeElement)) || (a == null ? void 0 : a.contains(p.activeElement)));
    });
  useEffect(() => L == null ? void 0 : L(_), [L, _]);
  let [i, b] = ee$2(),
    T$1 = N({
      mainTreeNodeRef: O == null ? void 0 : O.mainTreeNodeRef,
      portals: i,
      defaultContainers: [s, a]
    });
  E(p == null ? void 0 : p.defaultView, "focus", l => {
    var S, q, U, z;
    l.target !== window && l.target instanceof HTMLElement && f === 0 && ($() || s && a && (T$1.contains(l.target) || (q = (S = y.current) == null ? void 0 : S.contains) != null && q.call(S, l.target) || (z = (U = A.current) == null ? void 0 : U.contains) != null && z.call(U, l.target) || P({
      type: 1
    })));
  }, !0), y$3(T$1.resolveContainers, (l, S) => {
    P({
      type: 1
    }), h$4(S, T$2.Loose) || (l.preventDefault(), s == null || s.focus());
  }, f === 0);
  let d = o$8(l => {
      P({
        type: 1
      });
      let S = (() => l ? l instanceof HTMLElement ? l : "current" in l && l.current instanceof HTMLElement ? l.current : s : s)();
      S == null || S.focus();
    }),
    r = useMemo(() => ({
      close: d,
      isPortalled: E$1
    }), [d, E$1]),
    m = useMemo(() => ({
      open: f === 0,
      close: d
    }), [f, d]),
    g = {
      ref: n
    };
  return /*#__PURE__*/React__default.createElement(re$1.Provider, {
    value: null
  }, /*#__PURE__*/React__default.createElement(ue$2.Provider, {
    value: c
  }, /*#__PURE__*/React__default.createElement(ie$1.Provider, {
    value: r
  }, /*#__PURE__*/React__default.createElement(s$7, {
    value: u$9(f, {
      [0]: d$7.Open,
      [1]: d$7.Closed
    })
  }, /*#__PURE__*/React__default.createElement(b, null, C$2({
    ourProps: g,
    theirProps: M,
    slot: m,
    defaultTag: we$1,
    name: "Popover"
  }), /*#__PURE__*/React__default.createElement(T$1.MainTreeNode, null))))));
}
let We = "button";
function Ke(t, o) {
  let u = I$6(),
    {
      id: M = `headlessui-popover-button-${u}`,
      ...x
    } = t,
    [n, e] = oe$2("Popover.Button"),
    {
      isPortalled: c
    } = fe$1("Popover.Button"),
    f = useRef(null),
    s = `headlessui-focus-sentinel-${I$6()}`,
    I = Ee$1(),
    a = I == null ? void 0 : I.closeOthers,
    y = Ne$1() !== null;
  useEffect(() => {
    if (!y) return e({
      type: 3,
      buttonId: M
    }), () => {
      e({
        type: 3,
        buttonId: null
      });
    };
  }, [y, M, e]);
  let [A] = useState(() => Symbol()),
    P = y$2(f, o, y ? null : r => {
      if (r) n.buttons.current.push(A);else {
        let m = n.buttons.current.indexOf(A);
        m !== -1 && n.buttons.current.splice(m, 1);
      }
      n.buttons.current.length > 1 && console.warn("You are already using a <Popover.Button /> but only 1 <Popover.Button /> is supported."), r && e({
        type: 2,
        button: r
      });
    }),
    p = y$2(f, o),
    E = n$4(f),
    F = o$8(r => {
      var m, g, B;
      if (y) {
        if (n.popoverState === 1) return;
        switch (r.key) {
          case o$3.Space:
          case o$3.Enter:
            r.preventDefault(), (g = (m = r.target).click) == null || g.call(m), e({
              type: 1
            }), (B = n.button) == null || B.focus();
            break;
        }
      } else switch (r.key) {
        case o$3.Space:
        case o$3.Enter:
          r.preventDefault(), r.stopPropagation(), n.popoverState === 1 && (a == null || a(n.buttonId)), e({
            type: 0
          });
          break;
        case o$3.Escape:
          if (n.popoverState !== 0) return a == null ? void 0 : a(n.buttonId);
          if (!f.current || E != null && E.activeElement && !f.current.contains(E.activeElement)) return;
          r.preventDefault(), r.stopPropagation(), e({
            type: 1
          });
          break;
      }
    }),
    D = o$8(r => {
      y || r.key === o$3.Space && r.preventDefault();
    }),
    _ = o$8(r => {
      var m, g;
      r$4(r.currentTarget) || t.disabled || (y ? (e({
        type: 1
      }), (m = n.button) == null || m.focus()) : (r.preventDefault(), r.stopPropagation(), n.popoverState === 1 && (a == null || a(n.buttonId)), e({
        type: 0
      }), (g = n.button) == null || g.focus()));
    }),
    O = o$8(r => {
      r.preventDefault(), r.stopPropagation();
    }),
    L = n.popoverState === 0,
    $ = useMemo(() => ({
      open: L
    }), [L]),
    i = T$1(t, f),
    b = y ? {
      ref: p,
      type: i,
      onKeyDown: F,
      onClick: _
    } : {
      ref: P,
      id: n.buttonId,
      type: i,
      "aria-expanded": n.popoverState === 0,
      "aria-controls": n.panel ? n.panelId : void 0,
      onKeyDown: F,
      onKeyUp: D,
      onClick: _,
      onMouseDown: O
    },
    T = n$2(),
    d = o$8(() => {
      let r = n.panel;
      if (!r) return;
      function m() {
        u$9(T.current, {
          [s$6.Forwards]: () => O$1(r, M$3.First),
          [s$6.Backwards]: () => O$1(r, M$3.Last)
        }) === N$2.Error && O$1(f$8().filter(B => B.dataset.headlessuiFocusGuard !== "true"), u$9(T.current, {
          [s$6.Forwards]: M$3.Next,
          [s$6.Backwards]: M$3.Previous
        }), {
          relativeTo: n.button
        });
      }
      m();
    });
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, C$2({
    ourProps: b,
    theirProps: x,
    slot: $,
    defaultTag: We,
    name: "Popover.Button"
  }), L && !y && c && /*#__PURE__*/React__default.createElement(u$6, {
    id: s,
    features: s$8.Focusable,
    "data-headlessui-focus-guard": !0,
    as: "button",
    type: "button",
    onFocus: d
  }));
}
let je = "div",
  Ve = O.RenderStrategy | O.Static;
function $e(t, o) {
  let u = I$6(),
    {
      id: M = `headlessui-popover-overlay-${u}`,
      ...x
    } = t,
    [{
      popoverState: n
    }, e] = oe$2("Popover.Overlay"),
    c = y$2(o),
    f = u$5(),
    s = (() => f !== null ? (f & d$7.Open) === d$7.Open : n === 0)(),
    I = o$8(y => {
      if (r$4(y.currentTarget)) return y.preventDefault();
      e({
        type: 1
      });
    }),
    a = useMemo(() => ({
      open: n === 0
    }), [n]);
  return C$2({
    ourProps: {
      ref: c,
      id: M,
      "aria-hidden": !0,
      onClick: I
    },
    theirProps: x,
    slot: a,
    defaultTag: je,
    features: Ve,
    visible: s,
    name: "Popover.Overlay"
  });
}
let Je = "div",
  Xe = O.RenderStrategy | O.Static;
function Ye(t, o) {
  let u = I$6(),
    {
      id: M = `headlessui-popover-panel-${u}`,
      focus: x = !1,
      ...n
    } = t,
    [e, c] = oe$2("Popover.Panel"),
    {
      close: f,
      isPortalled: s
    } = fe$1("Popover.Panel"),
    I = `headlessui-focus-sentinel-before-${I$6()}`,
    a = `headlessui-focus-sentinel-after-${I$6()}`,
    v = useRef(null),
    y = y$2(v, o, i => {
      c({
        type: 4,
        panel: i
      });
    }),
    A = n$4(v),
    P = I$4();
  l$7(() => (c({
    type: 5,
    panelId: M
  }), () => {
    c({
      type: 5,
      panelId: null
    });
  }), [M, c]);
  let p = u$5(),
    E = (() => p !== null ? (p & d$7.Open) === d$7.Open : e.popoverState === 0)(),
    F = o$8(i => {
      var b;
      switch (i.key) {
        case o$3.Escape:
          if (e.popoverState !== 0 || !v.current || A != null && A.activeElement && !v.current.contains(A.activeElement)) return;
          i.preventDefault(), i.stopPropagation(), c({
            type: 1
          }), (b = e.button) == null || b.focus();
          break;
      }
    });
  useEffect(() => {
    var i;
    t.static || e.popoverState === 1 && ((i = t.unmount) == null || i) && c({
      type: 4,
      panel: null
    });
  }, [e.popoverState, t.unmount, t.static, c]), useEffect(() => {
    if (e.__demoMode || !x || e.popoverState !== 0 || !v.current) return;
    let i = A == null ? void 0 : A.activeElement;
    v.current.contains(i) || O$1(v.current, M$3.First);
  }, [e.__demoMode, x, v, e.popoverState]);
  let D = useMemo(() => ({
      open: e.popoverState === 0,
      close: f
    }), [e, f]),
    _ = {
      ref: y,
      id: M,
      onKeyDown: F,
      onBlur: x && e.popoverState === 0 ? i => {
        var T, d, r, m, g;
        let b = i.relatedTarget;
        b && v.current && ((T = v.current) != null && T.contains(b) || (c({
          type: 1
        }), ((r = (d = e.beforePanelSentinel.current) == null ? void 0 : d.contains) != null && r.call(d, b) || (g = (m = e.afterPanelSentinel.current) == null ? void 0 : m.contains) != null && g.call(m, b)) && b.focus({
          preventScroll: !0
        })));
      } : void 0,
      tabIndex: -1
    },
    O = n$2(),
    L = o$8(() => {
      let i = v.current;
      if (!i) return;
      function b() {
        u$9(O.current, {
          [s$6.Forwards]: () => {
            var d;
            O$1(i, M$3.First) === N$2.Error && ((d = e.afterPanelSentinel.current) == null || d.focus());
          },
          [s$6.Backwards]: () => {
            var T;
            (T = e.button) == null || T.focus({
              preventScroll: !0
            });
          }
        });
      }
      b();
    }),
    $ = o$8(() => {
      let i = v.current;
      if (!i) return;
      function b() {
        u$9(O.current, {
          [s$6.Forwards]: () => {
            var B;
            if (!e.button) return;
            let T = f$8(),
              d = T.indexOf(e.button),
              r = T.slice(0, d + 1),
              g = [...T.slice(d + 1), ...r];
            for (let l of g.slice()) if (l.dataset.headlessuiFocusGuard === "true" || (B = e.panel) != null && B.contains(l)) {
              let S = g.indexOf(l);
              S !== -1 && g.splice(S, 1);
            }
            O$1(g, M$3.First, {
              sorted: !1
            });
          },
          [s$6.Backwards]: () => {
            var d;
            O$1(i, M$3.Previous) === N$2.Error && ((d = e.button) == null || d.focus());
          }
        });
      }
      b();
    });
  return /*#__PURE__*/React__default.createElement(re$1.Provider, {
    value: M
  }, E && s && /*#__PURE__*/React__default.createElement(u$6, {
    id: I,
    ref: e.beforePanelSentinel,
    features: s$8.Focusable,
    "data-headlessui-focus-guard": !0,
    as: "button",
    type: "button",
    onFocus: L
  }), C$2({
    mergeRefs: P,
    ourProps: _,
    theirProps: n,
    slot: D,
    defaultTag: Je,
    features: Xe,
    visible: E,
    name: "Popover.Panel"
  }), E && s && /*#__PURE__*/React__default.createElement(u$6, {
    id: a,
    ref: e.afterPanelSentinel,
    features: s$8.Focusable,
    "data-headlessui-focus-guard": !0,
    as: "button",
    type: "button",
    onFocus: $
  }));
}
let qe = "div";
function ze(t, o) {
  let u = useRef(null),
    M = y$2(u, o),
    [x, n] = useState([]),
    e = y(),
    c = o$8(P => {
      n(p => {
        let E = p.indexOf(P);
        if (E !== -1) {
          let F = p.slice();
          return F.splice(E, 1), F;
        }
        return p;
      });
    }),
    f = o$8(P => (n(p => [...p, P]), () => c(P))),
    s = o$8(() => {
      var E;
      let P = o$5(u);
      if (!P) return !1;
      let p = P.activeElement;
      return (E = u.current) != null && E.contains(p) ? !0 : x.some(F => {
        var D, _;
        return ((D = P.getElementById(F.buttonId.current)) == null ? void 0 : D.contains(p)) || ((_ = P.getElementById(F.panelId.current)) == null ? void 0 : _.contains(p));
      });
    }),
    I = o$8(P => {
      for (let p of x) p.buttonId.current !== P && p.close();
    }),
    a = useMemo(() => ({
      registerPopover: f,
      unregisterPopover: c,
      isFocusWithinPopoverGroup: s,
      closeOthers: I,
      mainTreeNodeRef: e.mainTreeNodeRef
    }), [f, c, s, I, e.mainTreeNodeRef]),
    v = useMemo(() => ({}), []),
    y$1 = t,
    A = {
      ref: M
    };
  return /*#__PURE__*/React__default.createElement(Pe$2.Provider, {
    value: a
  }, C$2({
    ourProps: A,
    theirProps: y$1,
    slot: v,
    defaultTag: qe,
    name: "Popover.Group"
  }), /*#__PURE__*/React__default.createElement(e.MainTreeNode, null));
}
let Qe = U$3(Ue),
  Ze = U$3(Ke),
  et = U$3($e),
  tt = U$3(Ye),
  ot = U$3(ze);
  Object.assign(Qe, {
    Button: Ze,
    Overlay: et,
    Panel: tt,
    Group: ot
  });

let d$3 = /*#__PURE__*/createContext(null);
function u$1() {
  let a = useContext(d$3);
  if (a === null) {
    let t = new Error("You used a <Label /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(t, u$1), t;
  }
  return a;
}
function F$1() {
  let [a, t] = useState([]);
  return [a.length > 0 ? a.join(" ") : void 0, useMemo(() => function (e) {
    let s = o$8(r => (t(l => [...l, r]), () => t(l => {
        let n = l.slice(),
          p = n.indexOf(r);
        return p !== -1 && n.splice(p, 1), n;
      }))),
      o = useMemo(() => ({
        register: s,
        slot: e.slot,
        name: e.name,
        props: e.props
      }), [s, e.slot, e.name, e.props]);
    return /*#__PURE__*/React__default.createElement(d$3.Provider, {
      value: o
    }, e.children);
  }, [t])];
}
let A = "label";
function h$1(a, t) {
  let i = I$6(),
    {
      id: e = `headlessui-label-${i}`,
      passive: s = !1,
      ...o
    } = a,
    r = u$1(),
    l = y$2(t);
  l$7(() => r.register(e), [e, r.register]);
  let n = {
    ref: l,
    ...r.props,
    id: e
  };
  return s && ("onClick" in n && (delete n.htmlFor, delete n.onClick), "onClick" in o && delete o.onClick), C$2({
    ourProps: n,
    theirProps: o,
    slot: r.slot || {},
    defaultTag: A,
    name: r.name || "Label"
  });
}
let v$2 = U$3(h$1),
  B$1 = Object.assign(v$2, {});

function c$2(a = 0) {
  let [l, r] = useState(a),
    t = f$5(),
    o = useCallback(e => {
      t.current && r(u => u | e);
    }, [l, t]),
    m = useCallback(e => Boolean(l & e), [l]),
    s = useCallback(e => {
      t.current && r(u => u & ~e);
    }, [r, t]),
    g = useCallback(e => {
      t.current && r(u => u ^ e);
    }, [r]);
  return {
    flags: l,
    addFlag: o,
    hasFlag: m,
    removeFlag: s,
    toggleFlag: g
  };
}

var Ge = (t => (t[t.RegisterOption = 0] = "RegisterOption", t[t.UnregisterOption = 1] = "UnregisterOption", t))(Ge || {});
let Ce = {
    [0](o, r) {
      let t = [...o.options, {
        id: r.id,
        element: r.element,
        propsRef: r.propsRef
      }];
      return {
        ...o,
        options: I$5(t, p => p.element.current)
      };
    },
    [1](o, r) {
      let t = o.options.slice(),
        p = o.options.findIndex(T => T.id === r.id);
      return p === -1 ? o : (t.splice(p, 1), {
        ...o,
        options: t
      });
    }
  },
  B = /*#__PURE__*/createContext(null);
B.displayName = "RadioGroupDataContext";
function oe$1(o) {
  let r = useContext(B);
  if (r === null) {
    let t = new Error(`<${o} /> is missing a parent <RadioGroup /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(t, oe$1), t;
  }
  return r;
}
let $$1 = /*#__PURE__*/createContext(null);
$$1.displayName = "RadioGroupActionsContext";
function ne$1(o) {
  let r = useContext($$1);
  if (r === null) {
    let t = new Error(`<${o} /> is missing a parent <RadioGroup /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(t, ne$1), t;
  }
  return r;
}
function ke(o, r) {
  return u$9(r.type, Ce, o, r);
}
let Le$2 = "div";
function he$1(o, r) {
  let t = I$6(),
    {
      id: p = `headlessui-radiogroup-${t}`,
      value: T,
      defaultValue: v,
      form: M,
      name: m,
      onChange: H,
      by: G = (e, i) => e === i,
      disabled: P = !1,
      ...N
    } = o,
    y = o$8(typeof G == "string" ? (e, i) => {
      let n = G;
      return (e == null ? void 0 : e[n]) === (i == null ? void 0 : i[n]);
    } : G),
    [A, L] = useReducer(ke, {
      options: []
    }),
    a = A.options,
    [h, R] = F$1(),
    [C, U] = w$2(),
    k = useRef(null),
    W = y$2(k, r),
    [l, s] = T$3(T, H, v),
    b = useMemo(() => a.find(e => !e.propsRef.current.disabled), [a]),
    x = useMemo(() => a.some(e => y(e.propsRef.current.value, l)), [a, l]),
    d = o$8(e => {
      var n;
      if (P || y(e, l)) return !1;
      let i = (n = a.find(f => y(f.propsRef.current.value, e))) == null ? void 0 : n.propsRef.current;
      return i != null && i.disabled ? !1 : (s == null || s(e), !0);
    });
  F$5({
    container: k.current,
    accept(e) {
      return e.getAttribute("role") === "radio" ? NodeFilter.FILTER_REJECT : e.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
    },
    walk(e) {
      e.setAttribute("role", "none");
    }
  });
  let F = o$8(e => {
      let i = k.current;
      if (!i) return;
      let n = o$5(i),
        f = a.filter(u => u.propsRef.current.disabled === !1).map(u => u.element.current);
      switch (e.key) {
        case o$3.Enter:
          p$3(e.currentTarget);
          break;
        case o$3.ArrowLeft:
        case o$3.ArrowUp:
          if (e.preventDefault(), e.stopPropagation(), O$1(f, M$3.Previous | M$3.WrapAround) === N$2.Success) {
            let g = a.find(K => K.element.current === (n == null ? void 0 : n.activeElement));
            g && d(g.propsRef.current.value);
          }
          break;
        case o$3.ArrowRight:
        case o$3.ArrowDown:
          if (e.preventDefault(), e.stopPropagation(), O$1(f, M$3.Next | M$3.WrapAround) === N$2.Success) {
            let g = a.find(K => K.element.current === (n == null ? void 0 : n.activeElement));
            g && d(g.propsRef.current.value);
          }
          break;
        case o$3.Space:
          {
            e.preventDefault(), e.stopPropagation();
            let u = a.find(g => g.element.current === (n == null ? void 0 : n.activeElement));
            u && d(u.propsRef.current.value);
          }
          break;
      }
    }),
    c = o$8(e => (L({
      type: 0,
      ...e
    }), () => L({
      type: 1,
      id: e.id
    }))),
    w = useMemo(() => ({
      value: l,
      firstOption: b,
      containsCheckedOption: x,
      disabled: P,
      compare: y,
      ...A
    }), [l, b, x, P, y, A]),
    ie = useMemo(() => ({
      registerOption: c,
      change: d
    }), [c, d]),
    ae = {
      ref: W,
      id: p,
      role: "radiogroup",
      "aria-labelledby": h,
      "aria-describedby": C,
      onKeyDown: F
    },
    pe = useMemo(() => ({
      value: l
    }), [l]),
    I = useRef(null),
    le = p$5();
  return useEffect(() => {
    I.current && v !== void 0 && le.addEventListener(I.current, "reset", () => {
      d(v);
    });
  }, [I, d]), /*#__PURE__*/React__default.createElement(U, {
    name: "RadioGroup.Description"
  }, /*#__PURE__*/React__default.createElement(R, {
    name: "RadioGroup.Label"
  }, /*#__PURE__*/React__default.createElement($$1.Provider, {
    value: ie
  }, /*#__PURE__*/React__default.createElement(B.Provider, {
    value: w
  }, m != null && l != null && e$3({
    [m]: l
  }).map(([e, i], n) => /*#__PURE__*/React__default.createElement(u$6, {
    features: s$8.Hidden,
    ref: n === 0 ? f => {
      var u;
      I.current = (u = f == null ? void 0 : f.closest("form")) != null ? u : null;
    } : void 0,
    ...x$1({
      key: e,
      as: "input",
      type: "radio",
      checked: i != null,
      hidden: !0,
      readOnly: !0,
      form: M,
      disabled: P,
      name: e,
      value: i
    })
  })), C$2({
    ourProps: ae,
    theirProps: N,
    slot: pe,
    defaultTag: Le$2,
    name: "RadioGroup"
  })))));
}
var xe$2 = (t => (t[t.Empty = 1] = "Empty", t[t.Active = 2] = "Active", t))(xe$2 || {});
let Fe$2 = "div";
function we(o, r) {
  var F;
  let t = I$6(),
    {
      id: p = `headlessui-radiogroup-option-${t}`,
      value: T,
      disabled: v = !1,
      ...M
    } = o,
    m = useRef(null),
    H = y$2(m, r),
    [G, P] = F$1(),
    [N, y] = w$2(),
    {
      addFlag: A,
      removeFlag: L,
      hasFlag: a
    } = c$2(1),
    h = s$b({
      value: T,
      disabled: v
    }),
    R = oe$1("RadioGroup.Option"),
    C = ne$1("RadioGroup.Option");
  l$7(() => C.registerOption({
    id: p,
    element: m,
    propsRef: h
  }), [p, C, m, h]);
  let U = o$8(c => {
      var w;
      if (r$4(c.currentTarget)) return c.preventDefault();
      C.change(T) && (A(2), (w = m.current) == null || w.focus());
    }),
    k = o$8(c => {
      if (r$4(c.currentTarget)) return c.preventDefault();
      A(2);
    }),
    W = o$8(() => L(2)),
    l = ((F = R.firstOption) == null ? void 0 : F.id) === p,
    s = R.disabled || v,
    b = R.compare(R.value, T),
    x = {
      ref: H,
      id: p,
      role: "radio",
      "aria-checked": b ? "true" : "false",
      "aria-labelledby": G,
      "aria-describedby": N,
      "aria-disabled": s ? !0 : void 0,
      tabIndex: (() => s ? -1 : b || !R.containsCheckedOption && l ? 0 : -1)(),
      onClick: s ? void 0 : U,
      onFocus: s ? void 0 : k,
      onBlur: s ? void 0 : W
    },
    d = useMemo(() => ({
      checked: b,
      disabled: s,
      active: a(2)
    }), [b, s, a]);
  return /*#__PURE__*/React__default.createElement(y, {
    name: "RadioGroup.Description"
  }, /*#__PURE__*/React__default.createElement(P, {
    name: "RadioGroup.Label"
  }, C$2({
    ourProps: x,
    theirProps: M,
    slot: d,
    defaultTag: Fe$2,
    name: "RadioGroup.Option"
  })));
}
let Ie$1 = U$3(he$1),
  Se$2 = U$3(we);
  Object.assign(Ie$1, {
    Option: Se$2,
    Label: B$1,
    Description: G
  });

let S$1 = /*#__PURE__*/createContext(null);
S$1.displayName = "GroupContext";
let ee = Fragment;
function te(r) {
  var u;
  let [n, p] = useState(null),
    [c, T] = F$1(),
    [o, b] = w$2(),
    a = useMemo(() => ({
      switch: n,
      setSwitch: p,
      labelledby: c,
      describedby: o
    }), [n, p, c, o]),
    d = {},
    y = r;
  return /*#__PURE__*/React__default.createElement(b, {
    name: "Switch.Description"
  }, /*#__PURE__*/React__default.createElement(T, {
    name: "Switch.Label",
    props: {
      htmlFor: (u = a.switch) == null ? void 0 : u.id,
      onClick(m) {
        n && (m.currentTarget.tagName === "LABEL" && m.preventDefault(), n.click(), n.focus({
          preventScroll: !0
        }));
      }
    }
  }, /*#__PURE__*/React__default.createElement(S$1.Provider, {
    value: a
  }, C$2({
    ourProps: d,
    theirProps: y,
    defaultTag: ee,
    name: "Switch.Group"
  }))));
}
let ne = "button";
function re(r, n) {
  var E;
  let p = I$6(),
    {
      id: c = `headlessui-switch-${p}`,
      checked: T,
      defaultChecked: o = !1,
      onChange: b,
      disabled: a = !1,
      name: d,
      value: y,
      form: u,
      ...m
    } = r,
    t = useContext(S$1),
    f = useRef(null),
    C = y$2(f, n, t === null ? null : t.setSwitch),
    [i, s] = T$3(T, b, o),
    w = o$8(() => s == null ? void 0 : s(!i)),
    L = o$8(e => {
      if (r$4(e.currentTarget)) return e.preventDefault();
      e.preventDefault(), w();
    }),
    x = o$8(e => {
      e.key === o$3.Space ? (e.preventDefault(), w()) : e.key === o$3.Enter && p$3(e.currentTarget);
    }),
    v = o$8(e => e.preventDefault()),
    G = useMemo(() => ({
      checked: i
    }), [i]),
    R = {
      id: c,
      ref: C,
      role: "switch",
      type: T$1(r, f),
      tabIndex: r.tabIndex === -1 ? 0 : (E = r.tabIndex) != null ? E : 0,
      "aria-checked": i,
      "aria-labelledby": t == null ? void 0 : t.labelledby,
      "aria-describedby": t == null ? void 0 : t.describedby,
      disabled: a,
      onClick: L,
      onKeyUp: x,
      onKeyPress: v
    },
    k = p$5();
  return useEffect(() => {
    var _;
    let e = (_ = f.current) == null ? void 0 : _.closest("form");
    e && o !== void 0 && k.addEventListener(e, "reset", () => {
      s(o);
    });
  }, [f, s]), /*#__PURE__*/React__default.createElement(React__default.Fragment, null, d != null && i && /*#__PURE__*/React__default.createElement(u$6, {
    features: s$8.Hidden,
    ...x$1({
      as: "input",
      type: "checkbox",
      hidden: !0,
      readOnly: !0,
      disabled: a,
      form: u,
      checked: i,
      name: d,
      value: y
    })
  }), C$2({
    ourProps: R,
    theirProps: m,
    slot: G,
    defaultTag: ne,
    name: "Switch"
  }));
}
let oe = U$3(re),
  ie = te,
  _e$2 = Object.assign(oe, {
    Group: ie,
    Label: B$1,
    Description: G
  });

function b$1({
  onFocus: n
}) {
  let [r, o] = useState(!0),
    u = f$5();
  return r ? /*#__PURE__*/React__default.createElement(u$6, {
    as: "button",
    type: "button",
    features: s$8.Focusable,
    onFocus: a => {
      a.preventDefault();
      let e,
        i = 50;
      function t() {
        if (i-- <= 0) {
          e && cancelAnimationFrame(e);
          return;
        }
        if (n()) {
          if (cancelAnimationFrame(e), !u.current) return;
          o(!1);
          return;
        }
        e = requestAnimationFrame(t);
      }
      e = requestAnimationFrame(t);
    }
  }) : null;
}

const s$2 = /*#__PURE__*/React.createContext(null);
function a$2() {
  return {
    groups: new Map(),
    get(n, t) {
      var c;
      let e = this.groups.get(n);
      e || (e = new Map(), this.groups.set(n, e));
      let l = (c = e.get(t)) != null ? c : 0;
      e.set(t, l + 1);
      let o = Array.from(e.keys()).indexOf(t);
      function i() {
        let u = e.get(t);
        u > 1 ? e.set(t, u - 1) : e.delete(t);
      }
      return [o, i];
    }
  };
}
function C({
  children: n
}) {
  let t = React.useRef(a$2());
  return /*#__PURE__*/React.createElement(s$2.Provider, {
    value: t
  }, n);
}
function d$2(n) {
  let t = React.useContext(s$2);
  if (!t) throw new Error("You must wrap your component in a <StableCollection>");
  let e = f$1(),
    [l, o] = t.current.get(n, e);
  return React.useEffect(() => o, []), l;
}
function f$1() {
  var l, o, i;
  let n = (i = (o = (l = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) == null ? void 0 : l.ReactCurrentOwner) == null ? void 0 : o.current) != null ? i : null;
  if (!n) return Symbol();
  let t = [],
    e = n;
  for (; e;) t.push(e.index), e = e.return;
  return "$." + t.join(".");
}

var ue$1 = (t => (t[t.Forwards = 0] = "Forwards", t[t.Backwards = 1] = "Backwards", t))(ue$1 || {}),
  Te = (l => (l[l.Less = -1] = "Less", l[l.Equal = 0] = "Equal", l[l.Greater = 1] = "Greater", l))(Te || {}),
  de = (a => (a[a.SetSelectedIndex = 0] = "SetSelectedIndex", a[a.RegisterTab = 1] = "RegisterTab", a[a.UnregisterTab = 2] = "UnregisterTab", a[a.RegisterPanel = 3] = "RegisterPanel", a[a.UnregisterPanel = 4] = "UnregisterPanel", a))(de || {});
let ce = {
    [0](e, n) {
      var i;
      let t = I$5(e.tabs, c => c.current),
        l = I$5(e.panels, c => c.current),
        o = t.filter(c => {
          var p;
          return !((p = c.current) != null && p.hasAttribute("disabled"));
        }),
        a = {
          ...e,
          tabs: t,
          panels: l
        };
      if (n.index < 0 || n.index > t.length - 1) {
        let c = u$9(Math.sign(n.index - e.selectedIndex), {
          [-1]: () => 1,
          [0]: () => u$9(Math.sign(n.index), {
            [-1]: () => 0,
            [0]: () => 0,
            [1]: () => 1
          }),
          [1]: () => 0
        });
        if (o.length === 0) return a;
        let p = u$9(c, {
          [0]: () => t.indexOf(o[0]),
          [1]: () => t.indexOf(o[o.length - 1])
        });
        return {
          ...a,
          selectedIndex: p === -1 ? e.selectedIndex : p
        };
      }
      let T = t.slice(0, n.index),
        m = [...t.slice(n.index), ...T].find(c => o.includes(c));
      if (!m) return a;
      let b = (i = t.indexOf(m)) != null ? i : e.selectedIndex;
      return b === -1 && (b = e.selectedIndex), {
        ...a,
        selectedIndex: b
      };
    },
    [1](e, n) {
      if (e.tabs.includes(n.tab)) return e;
      let t = e.tabs[e.selectedIndex],
        l = I$5([...e.tabs, n.tab], a => a.current),
        o = e.selectedIndex;
      return e.info.current.isControlled || (o = l.indexOf(t), o === -1 && (o = e.selectedIndex)), {
        ...e,
        tabs: l,
        selectedIndex: o
      };
    },
    [2](e, n) {
      return {
        ...e,
        tabs: e.tabs.filter(t => t !== n.tab)
      };
    },
    [3](e, n) {
      return e.panels.includes(n.panel) ? e : {
        ...e,
        panels: I$5([...e.panels, n.panel], t => t.current)
      };
    },
    [4](e, n) {
      return {
        ...e,
        panels: e.panels.filter(t => t !== n.panel)
      };
    }
  },
  X = /*#__PURE__*/createContext(null);
X.displayName = "TabsDataContext";
function F(e) {
  let n = useContext(X);
  if (n === null) {
    let t = new Error(`<${e} /> is missing a parent <Tab.Group /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(t, F), t;
  }
  return n;
}
let $ = /*#__PURE__*/createContext(null);
$.displayName = "TabsActionsContext";
function q$1(e) {
  let n = useContext($);
  if (n === null) {
    let t = new Error(`<${e} /> is missing a parent <Tab.Group /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(t, q$1), t;
  }
  return n;
}
function fe(e, n) {
  return u$9(n.type, ce, e, n);
}
let be = Fragment;
function me(e, n) {
  let {
    defaultIndex: t = 0,
    vertical: l = !1,
    manual: o = !1,
    onChange: a,
    selectedIndex: T = null,
    ...R
  } = e;
  const m = l ? "vertical" : "horizontal",
    b = o ? "manual" : "auto";
  let i = T !== null,
    c = s$b({
      isControlled: i
    }),
    p = y$2(n),
    [u, f] = useReducer(fe, {
      info: c,
      selectedIndex: T != null ? T : t,
      tabs: [],
      panels: []
    }),
    P = useMemo(() => ({
      selectedIndex: u.selectedIndex
    }), [u.selectedIndex]),
    g = s$b(a || (() => {})),
    E = s$b(u.tabs),
    L = useMemo(() => ({
      orientation: m,
      activation: b,
      ...u
    }), [m, b, u]),
    A = o$8(s => (f({
      type: 1,
      tab: s
    }), () => f({
      type: 2,
      tab: s
    }))),
    S = o$8(s => (f({
      type: 3,
      panel: s
    }), () => f({
      type: 4,
      panel: s
    }))),
    k = o$8(s => {
      h.current !== s && g.current(s), i || f({
        type: 0,
        index: s
      });
    }),
    h = s$b(i ? e.selectedIndex : u.selectedIndex),
    W = useMemo(() => ({
      registerTab: A,
      registerPanel: S,
      change: k
    }), []);
  l$7(() => {
    f({
      type: 0,
      index: T != null ? T : t
    });
  }, [T]), l$7(() => {
    if (h.current === void 0 || u.tabs.length <= 0) return;
    let s = I$5(u.tabs, d => d.current);
    s.some((d, M) => u.tabs[M] !== d) && k(s.indexOf(u.tabs[h.current]));
  });
  let O = {
    ref: p
  };
  return /*#__PURE__*/React__default.createElement(C, null, /*#__PURE__*/React__default.createElement($.Provider, {
    value: W
  }, /*#__PURE__*/React__default.createElement(X.Provider, {
    value: L
  }, L.tabs.length <= 0 && /*#__PURE__*/React__default.createElement(b$1, {
    onFocus: () => {
      var s, r;
      for (let d of E.current) if (((s = d.current) == null ? void 0 : s.tabIndex) === 0) return (r = d.current) == null || r.focus(), !0;
      return !1;
    }
  }), C$2({
    ourProps: O,
    theirProps: R,
    slot: P,
    defaultTag: be,
    name: "Tabs"
  }))));
}
let Pe$1 = "div";
function ye$1(e, n) {
  let {
      orientation: t,
      selectedIndex: l
    } = F("Tab.List"),
    o = y$2(n);
  return C$2({
    ourProps: {
      ref: o,
      role: "tablist",
      "aria-orientation": t
    },
    theirProps: e,
    slot: {
      selectedIndex: l
    },
    defaultTag: Pe$1,
    name: "Tabs.List"
  });
}
let xe$1 = "button";
function ge(e, n) {
  var O, s;
  let t = I$6(),
    {
      id: l = `headlessui-tabs-tab-${t}`,
      ...o
    } = e,
    {
      orientation: a,
      activation: T,
      selectedIndex: R,
      tabs: m,
      panels: b
    } = F("Tab"),
    i = q$1("Tab"),
    c = F("Tab"),
    p = useRef(null),
    u = y$2(p, n);
  l$7(() => i.registerTab(p), [i, p]);
  let f = d$2("tabs"),
    P = m.indexOf(p);
  P === -1 && (P = f);
  let g = P === R,
    E = o$8(r => {
      var M;
      let d = r();
      if (d === N$2.Success && T === "auto") {
        let K = (M = o$5(p)) == null ? void 0 : M.activeElement,
          z = c.tabs.findIndex(te => te.current === K);
        z !== -1 && i.change(z);
      }
      return d;
    }),
    L = o$8(r => {
      let d = m.map(K => K.current).filter(Boolean);
      if (r.key === o$3.Space || r.key === o$3.Enter) {
        r.preventDefault(), r.stopPropagation(), i.change(P);
        return;
      }
      switch (r.key) {
        case o$3.Home:
        case o$3.PageUp:
          return r.preventDefault(), r.stopPropagation(), E(() => O$1(d, M$3.First));
        case o$3.End:
        case o$3.PageDown:
          return r.preventDefault(), r.stopPropagation(), E(() => O$1(d, M$3.Last));
      }
      if (E(() => u$9(a, {
        vertical() {
          return r.key === o$3.ArrowUp ? O$1(d, M$3.Previous | M$3.WrapAround) : r.key === o$3.ArrowDown ? O$1(d, M$3.Next | M$3.WrapAround) : N$2.Error;
        },
        horizontal() {
          return r.key === o$3.ArrowLeft ? O$1(d, M$3.Previous | M$3.WrapAround) : r.key === o$3.ArrowRight ? O$1(d, M$3.Next | M$3.WrapAround) : N$2.Error;
        }
      })) === N$2.Success) return r.preventDefault();
    }),
    A = useRef(!1),
    S = o$8(() => {
      var r;
      A.current || (A.current = !0, (r = p.current) == null || r.focus({
        preventScroll: !0
      }), i.change(P), t$a(() => {
        A.current = !1;
      }));
    }),
    k = o$8(r => {
      r.preventDefault();
    }),
    h = useMemo(() => {
      var r;
      return {
        selected: g,
        disabled: (r = e.disabled) != null ? r : !1
      };
    }, [g, e.disabled]),
    W = {
      ref: u,
      onKeyDown: L,
      onMouseDown: k,
      onClick: S,
      id: l,
      role: "tab",
      type: T$1(e, p),
      "aria-controls": (s = (O = b[P]) == null ? void 0 : O.current) == null ? void 0 : s.id,
      "aria-selected": g,
      tabIndex: g ? 0 : -1
    };
  return C$2({
    ourProps: W,
    theirProps: o,
    slot: h,
    defaultTag: xe$1,
    name: "Tabs.Tab"
  });
}
let Ee = "div";
function Ae(e, n) {
  let {
      selectedIndex: t
    } = F("Tab.Panels"),
    l = y$2(n),
    o = useMemo(() => ({
      selectedIndex: t
    }), [t]);
  return C$2({
    ourProps: {
      ref: l
    },
    theirProps: e,
    slot: o,
    defaultTag: Ee,
    name: "Tabs.Panels"
  });
}
let Re$1 = "div",
  Le$1 = O.RenderStrategy | O.Static;
function _e$1(e, n) {
  var E, L, A, S;
  let t = I$6(),
    {
      id: l = `headlessui-tabs-panel-${t}`,
      tabIndex: o = 0,
      ...a
    } = e,
    {
      selectedIndex: T,
      tabs: R,
      panels: m
    } = F("Tab.Panel"),
    b = q$1("Tab.Panel"),
    i = useRef(null),
    c = y$2(i, n);
  l$7(() => b.registerPanel(i), [b, i, l]);
  let p = d$2("panels"),
    u = m.indexOf(i);
  u === -1 && (u = p);
  let f = u === T,
    P = useMemo(() => ({
      selected: f
    }), [f]),
    g = {
      ref: c,
      id: l,
      role: "tabpanel",
      "aria-labelledby": (L = (E = R[u]) == null ? void 0 : E.current) == null ? void 0 : L.id,
      tabIndex: f ? o : -1
    };
  return !f && ((A = a.unmount) == null || A) && !((S = a.static) != null && S) ? /*#__PURE__*/React__default.createElement(u$6, {
    as: "span",
    "aria-hidden": "true",
    ...g
  }) : C$2({
    ourProps: g,
    theirProps: a,
    slot: P,
    defaultTag: Re$1,
    features: Le$1,
    visible: f,
    name: "Tabs.Panel"
  });
}
let Se$1 = U$3(ge),
  Ie = U$3(me),
  De$1 = U$3(ye$1),
  Fe$1 = U$3(Ae),
  he = U$3(_e$1);
  Object.assign(Se$1, {
    Group: Ie,
    List: De$1,
    Panels: Fe$1,
    Panel: he
  });

function l$2(r) {
  let e = {
    called: !1
  };
  return (...t) => {
    if (!e.called) return e.called = !0, r(...t);
  };
}

function g$1(t, ...e) {
  t && e.length > 0 && t.classList.add(...e);
}
function v$1(t, ...e) {
  t && e.length > 0 && t.classList.remove(...e);
}
function b(t, e) {
  let n = o$7();
  if (!t) return n.dispose;
  let {
      transitionDuration: m,
      transitionDelay: a
    } = getComputedStyle(t),
    [u, p] = [m, a].map(l => {
      let [r = 0] = l.split(",").filter(Boolean).map(i => i.includes("ms") ? parseFloat(i) : parseFloat(i) * 1e3).sort((i, T) => T - i);
      return r;
    }),
    o = u + p;
  if (o !== 0) {
    n.group(r => {
      r.setTimeout(() => {
        e(), r.dispose();
      }, o), r.addEventListener(t, "transitionrun", i => {
        i.target === i.currentTarget && r.dispose();
      });
    });
    let l = n.addEventListener(t, "transitionend", r => {
      r.target === r.currentTarget && (e(), l());
    });
  } else e();
  return n.add(() => e()), n.dispose;
}
function M$1(t, e, n, m) {
  let a = n ? "enter" : "leave",
    u = o$7(),
    p = m !== void 0 ? l$2(m) : () => {};
  a === "enter" && (t.removeAttribute("hidden"), t.style.display = "");
  let o = u$9(a, {
      enter: () => e.enter,
      leave: () => e.leave
    }),
    l = u$9(a, {
      enter: () => e.enterTo,
      leave: () => e.leaveTo
    }),
    r = u$9(a, {
      enter: () => e.enterFrom,
      leave: () => e.leaveFrom
    });
  return v$1(t, ...e.base, ...e.enter, ...e.enterTo, ...e.enterFrom, ...e.leave, ...e.leaveFrom, ...e.leaveTo, ...e.entered), g$1(t, ...e.base, ...o, ...r), u.nextFrame(() => {
    v$1(t, ...e.base, ...o, ...r), g$1(t, ...e.base, ...o, ...l), b(t, () => (v$1(t, ...e.base, ...o), g$1(t, ...e.base, ...e.entered), p()));
  }), u.dispose;
}

function D({
  immediate: t,
  container: s,
  direction: n,
  classes: u,
  onStart: a,
  onStop: c
}) {
  let l = f$5(),
    d = p$5(),
    e = s$b(n);
  l$7(() => {
    t && (e.current = "enter");
  }, [t]), l$7(() => {
    let r = o$7();
    d.add(r.dispose);
    let i = s.current;
    if (i && e.current !== "idle" && l.current) return r.dispose(), a.current(e.current), r.add(M$1(i, u.current, e.current === "enter", () => {
      r.dispose(), c.current(e.current);
    })), r.dispose;
  }, [n]);
}

function S(t = "") {
  return t.split(/\s+/).filter(n => n.length > 1);
}
let I = /*#__PURE__*/createContext(null);
I.displayName = "TransitionContext";
var Se = (r => (r.Visible = "visible", r.Hidden = "hidden", r))(Se || {});
function ye() {
  let t = useContext(I);
  if (t === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return t;
}
function xe() {
  let t = useContext(M);
  if (t === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return t;
}
let M = /*#__PURE__*/createContext(null);
M.displayName = "NestingContext";
function U(t) {
  return "children" in t ? U(t.children) : t.current.filter(({
    el: n
  }) => n.current !== null).filter(({
    state: n
  }) => n === "visible").length > 0;
}
function se(t, n) {
  let r = s$b(t),
    s = useRef([]),
    R = f$5(),
    D = p$5(),
    p = o$8((i, e = v$4.Hidden) => {
      let a = s.current.findIndex(({
        el: o
      }) => o === i);
      a !== -1 && (u$9(e, {
        [v$4.Unmount]() {
          s.current.splice(a, 1);
        },
        [v$4.Hidden]() {
          s.current[a].state = "hidden";
        }
      }), D.microTask(() => {
        var o;
        !U(s) && R.current && ((o = r.current) == null || o.call(r));
      }));
    }),
    x = o$8(i => {
      let e = s.current.find(({
        el: a
      }) => a === i);
      return e ? e.state !== "visible" && (e.state = "visible") : s.current.push({
        el: i,
        state: "visible"
      }), () => p(i, v$4.Unmount);
    }),
    h = useRef([]),
    v = useRef(Promise.resolve()),
    u = useRef({
      enter: [],
      leave: [],
      idle: []
    }),
    g = o$8((i, e, a) => {
      h.current.splice(0), n && (n.chains.current[e] = n.chains.current[e].filter(([o]) => o !== i)), n == null || n.chains.current[e].push([i, new Promise(o => {
        h.current.push(o);
      })]), n == null || n.chains.current[e].push([i, new Promise(o => {
        Promise.all(u.current[e].map(([f, N]) => N)).then(() => o());
      })]), e === "enter" ? v.current = v.current.then(() => n == null ? void 0 : n.wait.current).then(() => a(e)) : a(e);
    }),
    d = o$8((i, e, a) => {
      Promise.all(u.current[e].splice(0).map(([o, f]) => f)).then(() => {
        var o;
        (o = h.current.shift()) == null || o();
      }).then(() => a(e));
    });
  return useMemo(() => ({
    children: s,
    register: x,
    unregister: p,
    onStart: g,
    onStop: d,
    wait: v,
    chains: u
  }), [x, p, s, g, d, u, v]);
}
function Ne() {}
let Pe = ["beforeEnter", "afterEnter", "beforeLeave", "afterLeave"];
function ae(t) {
  var r;
  let n = {};
  for (let s of Pe) n[s] = (r = t[s]) != null ? r : Ne;
  return n;
}
function Re(t) {
  let n = useRef(ae(t));
  return useEffect(() => {
    n.current = ae(t);
  }, [t]), n;
}
let De = "div",
  le = O.RenderStrategy;
function He(t, n) {
  var Q, Y;
  let {
      beforeEnter: r,
      afterEnter: s,
      beforeLeave: R,
      afterLeave: D$1,
      enter: p,
      enterFrom: x,
      enterTo: h,
      entered: v,
      leave: u,
      leaveFrom: g,
      leaveTo: d,
      ...i
    } = t,
    e = useRef(null),
    a = y$2(e, n),
    o = (Q = i.unmount) == null || Q ? v$4.Unmount : v$4.Hidden,
    {
      show: f,
      appear: N,
      initial: T
    } = ye(),
    [l, j] = useState(f ? "visible" : "hidden"),
    z = xe(),
    {
      register: L,
      unregister: O
    } = z;
  useEffect(() => L(e), [L, e]), useEffect(() => {
    if (o === v$4.Hidden && e.current) {
      if (f && l !== "visible") {
        j("visible");
        return;
      }
      return u$9(l, {
        ["hidden"]: () => O(e),
        ["visible"]: () => L(e)
      });
    }
  }, [l, e, L, O, f, o]);
  let k = s$b({
      base: S(i.className),
      enter: S(p),
      enterFrom: S(x),
      enterTo: S(h),
      entered: S(v),
      leave: S(u),
      leaveFrom: S(g),
      leaveTo: S(d)
    }),
    V = Re({
      beforeEnter: r,
      afterEnter: s,
      beforeLeave: R,
      afterLeave: D$1
    }),
    G = l$6();
  useEffect(() => {
    if (G && l === "visible" && e.current === null) throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
  }, [e, l, G]);
  let Te = T && !N,
    K = N && f && T,
    de = (() => !G || Te ? "idle" : f ? "enter" : "leave")(),
    H = c$2(0),
    fe = o$8(C => u$9(C, {
      enter: () => {
        H.addFlag(d$7.Opening), V.current.beforeEnter();
      },
      leave: () => {
        H.addFlag(d$7.Closing), V.current.beforeLeave();
      },
      idle: () => {}
    })),
    me = o$8(C => u$9(C, {
      enter: () => {
        H.removeFlag(d$7.Opening), V.current.afterEnter();
      },
      leave: () => {
        H.removeFlag(d$7.Closing), V.current.afterLeave();
      },
      idle: () => {}
    })),
    w = se(() => {
      j("hidden"), O(e);
    }, z),
    B = useRef(!1);
  D({
    immediate: K,
    container: e,
    classes: k,
    direction: de,
    onStart: s$b(C => {
      B.current = !0, w.onStart(e, C, fe);
    }),
    onStop: s$b(C => {
      B.current = !1, w.onStop(e, C, me), C === "leave" && !U(w) && (j("hidden"), O(e));
    })
  });
  let P = i,
    ce = {
      ref: a
    };
  return K ? P = {
    ...P,
    className: t$7(i.className, ...k.current.enter, ...k.current.enterFrom)
  } : B.current && (P.className = t$7(i.className, (Y = e.current) == null ? void 0 : Y.className), P.className === "" && delete P.className), /*#__PURE__*/React__default.createElement(M.Provider, {
    value: w
  }, /*#__PURE__*/React__default.createElement(s$7, {
    value: u$9(l, {
      ["visible"]: d$7.Open,
      ["hidden"]: d$7.Closed
    }) | H.flags
  }, C$2({
    ourProps: ce,
    theirProps: P,
    defaultTag: De,
    features: le,
    visible: l === "visible",
    name: "Transition.Child"
  })));
}
function Fe(t, n) {
  let {
      show: r,
      appear: s = !1,
      unmount: R = !0,
      ...D
    } = t,
    p = useRef(null),
    x = y$2(p, n);
  l$6();
  let h = u$5();
  if (r === void 0 && h !== null && (r = (h & d$7.Open) === d$7.Open), ![!0, !1].includes(r)) throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");
  let [v, u] = useState(r ? "visible" : "hidden"),
    g = se(() => {
      u("hidden");
    }),
    [d, i] = useState(!0),
    e = useRef([r]);
  l$7(() => {
    d !== !1 && e.current[e.current.length - 1] !== r && (e.current.push(r), i(!1));
  }, [e, r]);
  let a = useMemo(() => ({
    show: r,
    appear: s,
    initial: d
  }), [r, s, d]);
  useEffect(() => {
    if (r) u("visible");else if (!U(g)) u("hidden");else {
      let T = p.current;
      if (!T) return;
      let l = T.getBoundingClientRect();
      l.x === 0 && l.y === 0 && l.width === 0 && l.height === 0 && u("hidden");
    }
  }, [r, g]);
  let o = {
      unmount: R
    },
    f = o$8(() => {
      var T;
      d && i(!1), (T = t.beforeEnter) == null || T.call(t);
    }),
    N = o$8(() => {
      var T;
      d && i(!1), (T = t.beforeLeave) == null || T.call(t);
    });
  return /*#__PURE__*/React__default.createElement(M.Provider, {
    value: g
  }, /*#__PURE__*/React__default.createElement(I.Provider, {
    value: a
  }, C$2({
    ourProps: {
      ...o,
      as: Fragment,
      children: /*#__PURE__*/React__default.createElement(ue, {
        ref: x,
        ...o,
        ...D,
        beforeEnter: f,
        beforeLeave: N
      })
    },
    theirProps: {},
    defaultTag: Fragment,
    features: le,
    visible: v === "visible",
    name: "Transition"
  })));
}
function _e(t, n) {
  let r = useContext(I) !== null,
    s = u$5() !== null;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !r && s ? /*#__PURE__*/React__default.createElement(q, {
    ref: n,
    ...t
  }) : /*#__PURE__*/React__default.createElement(ue, {
    ref: n,
    ...t
  }));
}
let q = U$3(Fe),
  ue = U$3(He),
  Le = U$3(_e);
  Object.assign(q, {
    Child: Le,
    Root: q
  });

const AddToNewSetlistModal = ({
  song,
  firstSetlist,
  isOpen,
  onClose,
  onConfirm
}) => {
  const clientConfiguration = useSelector(selectClientConfig);
  const [title, setTitle] = useState(null);
  const dispatch = useDispatch();
  const [subtitle, setSubtitle] = useState(null);
  const [imageUrl, setImageUrl] = useState(clientConfiguration.features.setlist.defaultSetlistImageUrl);
  const handleUserInputingText = bool => {
    dispatch(setUserInputtingText(bool));
  };
  return /*#__PURE__*/React__default.createElement(Modal, {
    title: "Add song to new setlist",
    isOpen: isOpen,
    content: /*#__PURE__*/React__default.createElement("div", {
      style: {
        minHeight: 300
      }
    }, /*#__PURE__*/React__default.createElement(NewSetlistModal, {
      isOpen: isOpen,
      clientConfiguration: clientConfiguration,
      firstSetlist: firstSetlist,
      title: title,
      setTitle: setTitle,
      subtitle: subtitle,
      setSubtitle: setSubtitle,
      imageUrl: imageUrl,
      setImageUrl: setImageUrl,
      setUserInputtingText: handleUserInputingText
    })),
    closeLabel: 'Close',
    onClose: onClose,
    onConfirm: () => onConfirm({
      title,
      subtitle,
      imageUrl
    }),
    confirmLabel: "Add song to new setlist",
    confirmable: title && subtitle
  });
};

var css_248z$9 = ".addToNew,.addToSetlistModal-container{display:flex;flex-direction:column}.addToNew{align-items:center;margin-top:30px}.addToNew button{margin-top:10px}.addToNew button svg{height:20px;margin-right:10px}";
styleInject(css_248z$9,{"insertAt":"top"});

const AddToSetlistModal = ({
  setlists,
  isOpen,
  onClose,
  onSelectNewPlaylist,
  onConfirm
}) => {
  const [selectedSetlist, setSelectedSetlist] = useState(setlists[0]);
  const renderSetlists = () => {
    setlists.map(setlist => ({
      id: setlist.id,
      name: setlist.title,
      avatar: setlist.imageUrl
    }));
    return /*#__PURE__*/React__default.createElement("div", {
      className: 'addToSetlistModal-container'
    }, /*#__PURE__*/React__default.createElement("p", null, "Please select a setlist to add the song to"), /*#__PURE__*/React__default.createElement(SelectionInput, {
      items: setlists,
      itemSelected: selectedSetlist,
      onChange: setSelectedSetlist
    }));
  };
  const renderAddToNew = () => {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "addToNew"
    }, /*#__PURE__*/React__default.createElement("span", null, "or"), /*#__PURE__*/React__default.createElement(Button, {
      onClick: onSelectNewPlaylist
    }, /*#__PURE__*/React__default.createElement(ForwardRef$5, null), "Create new playlist"));
  };
  useEffect(() => {
    if (setlists?.length && isOpen) setSelectedSetlist(setlists[0]);
  }, [isOpen, setlists]);
  return /*#__PURE__*/React__default.createElement(Modal, {
    isOpen: isOpen,
    content: /*#__PURE__*/React__default.createElement("div", {
      style: {
        minHeight: 300
      }
    }, /*#__PURE__*/React__default.createElement("p", {
      className: "mb-4"
    }), renderSetlists(), renderAddToNew()),
    closeLabel: 'Close',
    onClose: onClose,
    onConfirm: () => onConfirm(selectedSetlist),
    confirmLabel: selectedSetlist ? "Add song to setlist" : null,
    confirmable: selectedSetlist
  });
};

var css_248z$8 = ".lyricPreview{border-radius:8px;margin-top:10px;width:100%}.audioPreview{width:100%}";
styleInject(css_248z$8,{"insertAt":"top"});

const SongDetailsModal = ({
  song,
  lyrics,
  lyricsStatus,
  restricted,
  isOpen,
  onClose,
  onOpen,
  onAddToSetlist,
  onLyricsPreview,
  onOpenSheetMusic,
  onSubscribe,
  subscribeConfig,
  autoPlayPreview = false
}) => {
  const renderSongPreview = () => {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "bg-white  overflow-y-scroll sm:rounded-lg"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "pb-4 "
    }, /*#__PURE__*/React__default.createElement("h3", {
      className: "text-lg leading-6 font-medium text-gray-900 flex"
    }, /*#__PURE__*/React__default.createElement(ForwardRef$6, {
      className: "w-6 h-6 mr-2"
    }), song.mix), /*#__PURE__*/React__default.createElement("p", {
      className: "mt-1 max-w-2xl text-sm text-gray-500"
    }, song.artist)), /*#__PURE__*/React__default.createElement("div", {
      className: "sm:p-0"
    }, /*#__PURE__*/React__default.createElement("dl", {
      className: "sm:divide-y"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 "
    }, /*#__PURE__*/React__default.createElement("dd", {
      className: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2",
      dangerouslySetInnerHTML: {
        __html: song.desc
      }
    })), /*#__PURE__*/React__default.createElement("div", {
      className: "sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4"
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "flex space-x-2 text-xs text-secondary-50 items-center"
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "text-secondary-900 dark:text-secondary-300"
    }, "Genre:"), /*#__PURE__*/React__default.createElement("span", {
      className: "bg-primaryAlt rounded px-1 py-0.5"
    }, song.genre), /*#__PURE__*/React__default.createElement("span", {
      className: "text-secondary-900 dark:text-secondary-300"
    }, "Year:", " "), /*#__PURE__*/React__default.createElement("span", {
      className: "bg-primaryAlt rounded px-1 py-0.5"
    }, song.decade), /*#__PURE__*/React__default.createElement("span", {
      className: "text-secondary-900 dark:text-secondary-300"
    }, "Key:"), /*#__PURE__*/React__default.createElement("span", {
      className: "bg-primaryAlt rounded px-1 py-0.5"
    }, song.key), song.level && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", null, "Level:"), /*#__PURE__*/React__default.createElement("span", {
      className: "bg-primaryAlt rounded px-1 py-0.5"
    }, song.level)))), /*#__PURE__*/React__default.createElement("div", {
      className: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4"
    }, /*#__PURE__*/React__default.createElement("dt", {
      className: "text-sm font-medium text-gray-500"
    }, "Preview"), /*#__PURE__*/React__default.createElement("dd", {
      className: "mt-4 text-sm text-gray-900 sm:col-span-2"
    }, /*#__PURE__*/React__default.createElement("audio", {
      controlsList: "nodownload",
      className: "audioPreview",
      autoPlay: autoPlayPreview,
      controls: true,
      src: song.sampleUrl
    }))), /*#__PURE__*/React__default.createElement("div", {
      className: "pt-4 flex items-center"
    }, !restricted && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", {
      className: "relative z-0 grow inline-flex shadow-sm rounded-md "
    }, /*#__PURE__*/React__default.createElement("button", {
      onClick: () => onOpen(song.songId),
      type: "button",
      className: "-ml-px relative inline-flex flex-col grow items-center px-4 py-2 border rounded-l-md border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
    }, /*#__PURE__*/React__default.createElement(ForwardRef$f, {
      className: "h-6 w-6"
    }), /*#__PURE__*/React__default.createElement("span", null, "Open song")), /*#__PURE__*/React__default.createElement("button", {
      onClick: onAddToSetlist,
      type: "button",
      className: "-ml-px relative inline-flex flex-col grow items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
    }, /*#__PURE__*/React__default.createElement(ForwardRef$c, {
      className: "h-6 w-6"
    }), /*#__PURE__*/React__default.createElement("span", null, "Add to setlist")), /*#__PURE__*/React__default.createElement("button", {
      onClick: onLyricsPreview,
      type: "button",
      className: "relative inline-flex flex-col grow items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
    }, /*#__PURE__*/React__default.createElement(ForwardRef$e, {
      className: "h-6 w-6"
    }), /*#__PURE__*/React__default.createElement("span", null, "View lyrics")), /*#__PURE__*/React__default.createElement("button", {
      disabled: !song.sheetUrl ? true : false,
      onClick: () => onOpenSheetMusic(song.sheetUrl),
      type: "button",
      className: `${song.sheetUrl ? '' : 'opacity-50'} -ml-px relative inline-flex flex-col grow items-center px-4 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500`
    }, /*#__PURE__*/React__default.createElement(ForwardRef$b, {
      className: "h-6 w-6"
    }), /*#__PURE__*/React__default.createElement("span", null, "Sheet music")))), restricted && /*#__PURE__*/React__default.createElement("div", {
      className: "flex flex-col justify-center"
    }, /*#__PURE__*/React__default.createElement("p", {
      className: "mb-4"
    }, subscribeConfig.text), /*#__PURE__*/React__default.createElement(Button, {
      onClick: onSubscribe
    }, subscribeConfig.buttonLabel))))));
  };
  return /*#__PURE__*/React__default.createElement(Modal, {
    isOpen: isOpen,
    content: /*#__PURE__*/React__default.createElement("div", {
      style: {
        minHeight: 300
      }
    }, song && renderSongPreview()),
    closeLabel: "Close",
    onClose: onClose
  });
};

var css_248z$7 = ".lyricPreview{border-radius:8px;margin-top:10px;min-height:250px;-webkit-user-select:text;user-select:text;width:100%}.audioPreview{width:100%}";
styleInject(css_248z$7,{"insertAt":"top"});

const LyricsModal = ({
  song,
  lyrics,
  isOpen,
  lyricsStatus,
  onClose
}) => {
  const formLyricsString = lyrics => {
    let output = "";
    for (const lyric of lyrics) {
      output = output + `${lyric.text}\n\n`;
    }
    return output;
  };
  const renderLyrics = () => {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "flex flex-col justify-center align-center text-center"
    }, /*#__PURE__*/React__default.createElement("h2", {
      className: "text-primary text-lg font-bold flex"
    }, /*#__PURE__*/React__default.createElement(ForwardRef$e, {
      className: "w-6 h-6 mr-2"
    }), "Lyrics"), lyrics.length > 0 && /*#__PURE__*/React__default.createElement("textarea", {
      readOnly: true,
      className: "lyricPreview",
      value: formLyricsString(lyrics)
    }));
  };
  return /*#__PURE__*/React__default.createElement(Modal, {
    isOpen: isOpen,
    content: renderLyrics(),
    closeLabel: 'Close',
    onClose: onClose
  });
};

function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

// eslint-disable-next-line no-undef
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */memoize(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */ && prop.charCodeAt(1) === 110
  /* n */ && prop.charCodeAt(2) < 91;
}
/* Z+1 */);

var isDevelopment$2 = false;

/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/

function sheetForTag(tag) {
  if (tag.sheet) {
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */

  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      return document.styleSheets[i];
    }
  } // this function should always return with a value
  // TS can't understand it though so we make it stop complaining here

  return undefined;
}
function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);
  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }
  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}
var StyleSheet = /*#__PURE__*/function () {
  // Using Node instead of HTMLElement since container may be a ShadowRoot
  function StyleSheet(options) {
    var _this = this;
    this._insertTag = function (tag) {
      var before;
      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }
      _this.container.insertBefore(tag, before);
      _this.tags.push(tag);
    };
    this.isSpeedy = options.speedy === undefined ? !isDevelopment$2 : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }
  var _proto = StyleSheet.prototype;
  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };
  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }
    var tag = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);
      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {}
    } else {
      tag.appendChild(document.createTextNode(rule));
    }
    this.ctr++;
  };
  _proto.flush = function flush() {
    this.tags.forEach(function (tag) {
      var _tag$parentNode;
      return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };
  return StyleSheet;
}();

var MS = '-ms-';
var MOZ = '-moz-';
var WEBKIT = '-webkit-';
var COMMENT = 'comm';
var RULESET = 'rule';
var DECLARATION = 'decl';
var IMPORT = '@import';
var KEYFRAMES = '@keyframes';
var LAYER = '@layer';

/**
 * @param {number}
 * @return {number}
 */
var abs = Math.abs;

/**
 * @param {number}
 * @return {string}
 */
var from = String.fromCharCode;

/**
 * @param {object}
 * @return {object}
 */
var assign = Object.assign;

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash(value, length) {
  return charat(value, 0) ^ 45 ? (((length << 2 ^ charat(value, 0)) << 2 ^ charat(value, 1)) << 2 ^ charat(value, 2)) << 2 ^ charat(value, 3) : 0;
}

/**
 * @param {string} value
 * @return {string}
 */
function trim(value) {
  return value.trim();
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function match(value, pattern) {
  return (value = pattern.exec(value)) ? value[0] : value;
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function replace(value, pattern, replacement) {
  return value.replace(pattern, replacement);
}

/**
 * @param {string} value
 * @param {string} search
 * @return {number}
 */
function indexof(value, search) {
  return value.indexOf(search);
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function charat(value, index) {
  return value.charCodeAt(index) | 0;
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function substr(value, begin, end) {
  return value.slice(begin, end);
}

/**
 * @param {string} value
 * @return {number}
 */
function strlen(value) {
  return value.length;
}

/**
 * @param {any[]} value
 * @return {number}
 */
function sizeof(value) {
  return value.length;
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function append(value, array) {
  return array.push(value), value;
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function combine(array, callback) {
  return array.map(callback).join('');
}

var line = 1;
var column = 1;
var length = 0;
var position = 0;
var character = 0;
var characters = '';

/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {number} length
 */
function node(value, root, parent, type, props, children, length) {
  return {
    value: value,
    root: root,
    parent: parent,
    type: type,
    props: props,
    children: children,
    line: line,
    column: column,
    length: length,
    return: ''
  };
}

/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */
function copy(root, props) {
  return assign(node('', null, null, '', null, null, 0), root, {
    length: -root.length
  }, props);
}

/**
 * @return {number}
 */
function char() {
  return character;
}

/**
 * @return {number}
 */
function prev() {
  character = position > 0 ? charat(characters, --position) : 0;
  if (column--, character === 10) column = 1, line--;
  return character;
}

/**
 * @return {number}
 */
function next() {
  character = position < length ? charat(characters, position++) : 0;
  if (column++, character === 10) column = 1, line++;
  return character;
}

/**
 * @return {number}
 */
function peek() {
  return charat(characters, position);
}

/**
 * @return {number}
 */
function caret() {
  return position;
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice(begin, end) {
  return substr(characters, begin, end);
}

/**
 * @param {number} type
 * @return {number}
 */
function token(type) {
  switch (type) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc(value) {
  return line = column = 1, length = strlen(characters = value), position = 0, [];
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc(value) {
  return characters = '', value;
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit(type) {
  return trim(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace(type) {
  while (character = peek()) if (character < 33) next();else break;
  return token(type) > 2 || token(character) > 3 ? '' : ' ';
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping(index, count) {
  while (--count && next())
  // not 0-9 A-F a-f
  if (character < 48 || character > 102 || character > 57 && character < 65 || character > 70 && character < 97) break;
  return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32));
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter(type) {
  while (next()) switch (character) {
    // ] ) " '
    case type:
      return position;
    // " '
    case 34:
    case 39:
      if (type !== 34 && type !== 39) delimiter(character);
      break;
    // (
    case 40:
      if (type === 41) delimiter(type);
      break;
    // \
    case 92:
      next();
      break;
  }
  return position;
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter(type, index) {
  while (next())
  // //
  if (type + character === 47 + 10) break;
  // /*
  else if (type + character === 42 + 42 && peek() === 47) break;
  return '/*' + slice(index, position - 1) + '*' + from(type === 47 ? type : next());
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier(index) {
  while (!token(peek())) next();
  return slice(index, position);
}

/**
 * @param {string} value
 * @return {object[]}
 */
function compile(value) {
  return dealloc(parse('', null, null, null, [''], value = alloc(value), 0, [0], value));
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
  var index = 0;
  var offset = 0;
  var length = pseudo;
  var atrule = 0;
  var property = 0;
  var previous = 0;
  var variable = 1;
  var scanning = 1;
  var ampersand = 1;
  var character = 0;
  var type = '';
  var props = rules;
  var children = rulesets;
  var reference = rule;
  var characters = type;
  while (scanning) switch (previous = character, character = next()) {
    // (
    case 40:
      if (previous != 108 && charat(characters, length - 1) == 58) {
        if (indexof(characters += replace(delimit(character), '&', '&\f'), '&\f') != -1) ampersand = -1;
        break;
      }
    // " ' [
    case 34:
    case 39:
    case 91:
      characters += delimit(character);
      break;
    // \t \n \r \s
    case 9:
    case 10:
    case 13:
    case 32:
      characters += whitespace(previous);
      break;
    // \
    case 92:
      characters += escaping(caret() - 1, 7);
      continue;
    // /
    case 47:
      switch (peek()) {
        case 42:
        case 47:
          append(comment(commenter(next(), caret()), root, parent), declarations);
          break;
        default:
          characters += '/';
      }
      break;
    // {
    case 123 * variable:
      points[index++] = strlen(characters) * ampersand;
    // } ; \0
    case 125 * variable:
    case 59:
    case 0:
      switch (character) {
        // \0 }
        case 0:
        case 125:
          scanning = 0;
        // ;
        case 59 + offset:
          if (ampersand == -1) characters = replace(characters, /\f/g, '');
          if (property > 0 && strlen(characters) - length) append(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration(replace(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
          break;
        // @ ;
        case 59:
          characters += ';';
        // { rule/at-rule
        default:
          append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);
          if (character === 123) if (offset === 0) parse(characters, root, reference, reference, props, rulesets, length, points, children);else switch (atrule === 99 && charat(characters, 3) === 110 ? 100 : atrule) {
            // d l m s
            case 100:
            case 108:
            case 109:
            case 115:
              parse(value, reference, reference, rule && append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
              break;
            default:
              parse(characters, reference, reference, reference, [''], children, 0, points, children);
          }
      }
      index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
      break;
    // :
    case 58:
      length = 1 + strlen(characters), property = previous;
    default:
      if (variable < 1) if (character == 123) --variable;else if (character == 125 && variable++ == 0 && prev() == 125) continue;
      switch (characters += from(character), character * variable) {
        // &
        case 38:
          ampersand = offset > 0 ? 1 : (characters += '\f', -1);
          break;
        // ,
        case 44:
          points[index++] = (strlen(characters) - 1) * ampersand, ampersand = 1;
          break;
        // @
        case 64:
          // -
          if (peek() === 45) characters += delimit(next());
          atrule = peek(), offset = length = strlen(type = characters += identifier(caret())), character++;
          break;
        // -
        case 45:
          if (previous === 45 && strlen(characters) == 2) variable = 0;
      }
  }
  return rulesets;
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @return {object}
 */
function ruleset(value, root, parent, index, offset, rules, points, type, props, children, length) {
  var post = offset - 1;
  var rule = offset === 0 ? rules : [''];
  var size = sizeof(rule);
  for (var i = 0, j = 0, k = 0; i < index; ++i) for (var x = 0, y = substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x) if (z = trim(j > 0 ? rule[x] + ' ' + y : replace(y, /&\f/g, rule[x]))) props[k++] = z;
  return node(value, root, parent, offset === 0 ? RULESET : type, props, children, length);
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @return {object}
 */
function comment(value, root, parent) {
  return node(value, root, parent, COMMENT, from(char()), substr(value, 2, -2), 0);
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @return {object}
 */
function declaration(value, root, parent, length) {
  return node(value, root, parent, DECLARATION, substr(value, 0, length), substr(value, length + 1, -1), length);
}

/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function serialize(children, callback) {
  var output = '';
  var length = sizeof(children);
  for (var i = 0; i < length; i++) output += callback(children[i], i, children, callback) || '';
  return output;
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify(element, index, children, callback) {
  switch (element.type) {
    case LAYER:
      if (element.children.length) break;
    case IMPORT:
    case DECLARATION:
      return element.return = element.return || element.value;
    case COMMENT:
      return '';
    case KEYFRAMES:
      return element.return = element.value + '{' + serialize(element.children, callback) + '}';
    case RULESET:
      element.value = element.props.join(',');
  }
  return strlen(children = serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : '';
}

/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware(collection) {
  var length = sizeof(collection);
  return function (element, index, children, callback) {
    var output = '';
    for (var i = 0; i < length; i++) output += collection[i](element, index, children, callback) || '';
    return output;
  };
}

/**
 * @param {function} callback
 * @return {function}
 */
function rulesheet(callback) {
  return function (element) {
    if (!element.root) if (element = element.return) callback(element);
  };
}

var weakMemoize = function weakMemoize(func) {
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // Use non-null assertion because we just checked that the cache `has` it
      // This allows us to remove `undefined` from the return value
      return cache.get(arg);
    }
    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

var isBrowser$4 = typeof document !== 'undefined';
var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;
  while (true) {
    previous = character;
    character = peek(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }
    if (token(character)) {
      break;
    }
    next();
  }
  return slice(begin, position);
};
var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;
  do {
    switch (token(character)) {
      case 0:
        // &\f
        if (character === 38 && peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }
        parsed[index] += identifierWithPointTracking(position - 1, points, index);
        break;
      case 2:
        parsed[index] += delimit(character);
        break;
      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += from(character);
    }
  } while (character = next());
  return parsed;
};
var getRules = function getRules(value, points) {
  return dealloc(toRules(alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11

var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent ||
  // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }
  var value = element.value,
    parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;
  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case

  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */ && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"

  if (isImplicitRule) {
    return;
  }
  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;
  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;
    if (
    // charcode for l
    value.charCodeAt(0) === 108 &&
    // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};

/* eslint-disable no-fallthrough */

function prefix(value, length) {
  switch (hash(value, length)) {
    // color-adjust
    case 5103:
      return WEBKIT + 'print-' + value + value;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)

    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921: // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break

    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005: // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,

    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855: // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)

    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + value + value;
    // appearance, user-select, transform, hyphens, text-size-adjust

    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + value + MOZ + value + MS + value + value;
    // flex, flex-direction

    case 6828:
    case 4268:
      return WEBKIT + value + MS + value + value;
    // order

    case 6165:
      return WEBKIT + value + MS + 'flex-' + value + value;
    // align-items

    case 5187:
      return WEBKIT + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT + 'box-$1$2' + MS + 'flex-$1$2') + value;
    // align-self

    case 5443:
      return WEBKIT + value + MS + 'flex-item-' + replace(value, /flex-|-self/, '') + value;
    // align-content

    case 4675:
      return WEBKIT + value + MS + 'flex-line-pack' + replace(value, /align-content|flex-|-self/, '') + value;
    // flex-shrink

    case 5548:
      return WEBKIT + value + MS + replace(value, 'shrink', 'negative') + value;
    // flex-basis

    case 5292:
      return WEBKIT + value + MS + replace(value, 'basis', 'preferred-size') + value;
    // flex-grow

    case 6060:
      return WEBKIT + 'box-' + replace(value, '-grow', '') + WEBKIT + value + MS + replace(value, 'grow', 'positive') + value;
    // transition

    case 4554:
      return WEBKIT + replace(value, /([^-])(transform)/g, '$1' + WEBKIT + '$2') + value;
    // cursor

    case 6187:
      return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT + '$1'), /(image-set)/, WEBKIT + '$1'), value, '') + value;
    // background, background-image

    case 5495:
    case 3959:
      return replace(value, /(image-set\([^]*)/, WEBKIT + '$1' + '$`$1');
    // justify-content

    case 4968:
      return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT + 'box-pack:$3' + MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + WEBKIT + value + value;
    // (margin|padding)-inline-(start|end)

    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace(value, /(.+)-inline(.+)/, WEBKIT + '$1$2') + value;
    // (min|max)?(width|height|inline-size|block-size)

    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      // stretch, max-content, min-content, fill-available
      if (strlen(value) - 1 - length > 6) switch (charat(value, length + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          // -
          if (charat(value, length + 4) !== 45) break;
        // (f)ill-available, (f)it-content

        case 102:
          return replace(value, /(.+:)(.+)-([^]+)/, '$1' + WEBKIT + '$2-$3' + '$1' + MOZ + (charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
        // (s)tretch

        case 115:
          return ~indexof(value, 'stretch') ? prefix(replace(value, 'stretch', 'fill-available'), length) + value : value;
      }
      break;
    // position: sticky

    case 4949:
      // (s)ticky?
      if (charat(value, length + 1) !== 115) break;
    // display: (flex|inline-flex)

    case 6444:
      switch (charat(value, strlen(value) - 3 - (~indexof(value, '!important') && 10))) {
        // stic(k)y
        case 107:
          return replace(value, ':', ':' + WEBKIT) + value;
        // (inline-)?fl(e)x

        case 101:
          return replace(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + WEBKIT + (charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + WEBKIT + '$2$3' + '$1' + MS + '$2box$3') + value;
      }
      break;
    // writing-mode

    case 5936:
      switch (charat(value, length + 11)) {
        // vertical-l(r)
        case 114:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
        // vertical-r(l)

        case 108:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
        // horizontal(-)tb

        case 45:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
      }
      return WEBKIT + value + MS + value + value;
  }
  return value;
}
var prefixer = function prefixer(element, index, children, callback) {
  if (element.length > -1) if (!element["return"]) switch (element.type) {
    case DECLARATION:
      element["return"] = prefix(element.value, element.length);
      break;
    case KEYFRAMES:
      return serialize([copy(element, {
        value: replace(element.value, '@', '@' + WEBKIT)
      })], callback);
    case RULESET:
      if (element.length) return combine(element.props, function (value) {
        switch (match(value, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ':read-only':
          case ':read-write':
            return serialize([copy(element, {
              props: [replace(value, /:(read-\w+)/, ':' + MOZ + '$1')]
            })], callback);
          // :placeholder

          case '::placeholder':
            return serialize([copy(element, {
              props: [replace(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1')]
            }), copy(element, {
              props: [replace(value, /:(plac\w+)/, ':' + MOZ + '$1')]
            }), copy(element, {
              props: [replace(value, /:(plac\w+)/, MS + 'input-$1')]
            })], callback);
        }
        return '';
      });
  }
};

/* import type { StylisPlugin } from './types' */

/*
export type Options = {
  nonce?: string,
  stylisPlugins?: StylisPlugin[],
  key: string,
  container?: HTMLElement,
  speedy?: boolean,
  prepend?: boolean,
  insertionPoint?: HTMLElement
}
*/

var getServerStylisCache = isBrowser$4 ? undefined : weakMemoize(function () {
  return memoize(function () {
    var cache = {};
    return function (name) {
      return cache[name];
    };
  });
});
var defaultStylisPlugins = [prefixer];
var createCache = function /*: EmotionCache */
createCache(options
/*: Options */) {
  var key = options.key;
  if (isBrowser$4 && key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node
    /*: HTMLStyleElement */) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');
      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }
      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }
  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;
  var inserted = {};
  var container;
  /* : Node */

  var nodesToHydrate = [];
  if (isBrowser$4) {
    container = options.container || document.head;
    Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node
    /*: HTMLStyleElement */) {
      var attrib = node.getAttribute("data-emotion").split(' ');
      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }
      nodesToHydrate.push(node);
    });
  }
  var _insert;
  /*: (
  selector: string,
  serialized: SerializedStyles,
  sheet: StyleSheet,
  shouldCache: boolean
  ) => string | void */

  var omnipresentPlugins = [compat, removeLabel];
  if (isBrowser$4) {
    var currentSheet;
    var finalizingPlugins = [stringify, rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
      return serialize(compile(styles), serializer);
    };
    _insert = function /*: void */
    insert(selector
    /*: string */, serialized
    /*: SerializedStyles */, sheet
    /*: StyleSheet */, shouldCache
    /*: boolean */) {
      currentSheet = sheet;
      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  } else {
    var _finalizingPlugins = [stringify];
    var _serializer = middleware(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
    var _stylis = function _stylis(styles) {
      return serialize(compile(styles), _serializer);
    };
    var serverStylisCache = getServerStylisCache(stylisPlugins)(key);
    var getRules = function /*: string */
    getRules(selector
    /*: string */, serialized
    /*: SerializedStyles */) {
      var name = serialized.name;
      if (serverStylisCache[name] === undefined) {
        serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      }
      return serverStylisCache[name];
    };
    _insert = function /*: string | void */
    _insert(selector
    /*: string */, serialized
    /*: SerializedStyles */, sheet
    /*: StyleSheet */, shouldCache
    /*: boolean */) {
      var name = serialized.name;
      var rules = getRules(selector, serialized);
      if (cache.compat === undefined) {
        // in regular mode, we don't set the styles on the inserted cache
        // since we don't need to and that would be wasting memory
        // we return them so that they are rendered in a style tag
        if (shouldCache) {
          cache.inserted[name] = true;
        }
        return rules;
      } else {
        // in compat mode, we put the styles on the inserted cache so
        // that emotion-server can pull out the styles
        // except when we don't want to cache it which was in Global but now
        // is nowhere but we don't want to do a major right now
        // and just in case we're going to leave the case here
        // it's also not affecting client side bundle size
        // so it's really not a big deal
        if (shouldCache) {
          cache.inserted[name] = rules;
        } else {
          return rules;
        }
      }
    };
  }
  var cache
  /*: EmotionCache */ = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};

var isBrowser$3 = typeof document !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;
  if (
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false ||
  // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser$3 === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;
  if (cache.inserted[serialized.name] === undefined) {
    var stylesForSSR = '';
    var current = serialized;
    do {
      var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
      if (!isBrowser$3 && maybeStyles !== undefined) {
        stylesForSSR += maybeStyles;
      }
      current = current.next;
    } while (current !== undefined);
    if (!isBrowser$3 && stylesForSSR.length !== 0) {
      return stylesForSSR;
    }
  }
};

/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
    i = 0,
    len = str.length;
  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k = /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^= /* k >>> r: */
    k >>> 24;
    h = /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array

  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.

  h ^= h >>> 13;
  h = /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

var isDevelopment$1 = false;
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};
var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};
var processStyleName = /* #__PURE__ */memoize(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});
var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }
  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }
  return value;
};
var noComponentSelectorMessage = 'Component selectors can only be used in conjunction with ' + '@emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware ' + 'compiler transform.';
function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }
  var componentSelector = interpolation;
  if (componentSelector.__emotion_styles !== undefined) {
    return componentSelector;
  }
  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }
    case 'object':
      {
        var keyframes = interpolation;
        if (keyframes.anim === 1) {
          cursor = {
            name: keyframes.name,
            styles: keyframes.styles,
            next: cursor
          };
          return keyframes.name;
        }
        var serializedStyles = interpolation;
        if (serializedStyles.styles !== undefined) {
          var next = serializedStyles.next;
          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }
          var styles = serializedStyles.styles + ";";
          return styles;
        }
        return createStringFromObject(mergedProps, registered, interpolation);
      }
    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        }
        break;
      }
  } // finalize string values (regular strings and functions interpolated into css calls)

  var asString = interpolation;
  if (registered == null) {
    return asString;
  }
  var cached = registered[asString];
  return cached !== undefined ? cached : asString;
}
function createStringFromObject(mergedProps, registered, obj) {
  var string = '';
  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var key in obj) {
      var value = obj[key];
      if (typeof value !== 'object') {
        var asString = value;
        if (registered != null && registered[asString] !== undefined) {
          string += key + "{" + registered[asString] + "}";
        } else if (isProcessableValue(asString)) {
          string += processStyleName(key) + ":" + processStyleValue(key, asString) + ";";
        }
      } else {
        if (key === 'NO_COMPONENT_SELECTOR' && isDevelopment$1) {
          throw new Error(noComponentSelectorMessage);
        }
        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(key) + ":" + processStyleValue(key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);
          switch (key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(key) + ":" + interpolated + ";";
                break;
              }
            default:
              {
                string += key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }
  return string;
}
var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
// keyframes are stored on the SerializedStyles object as a linked list

var cursor;
function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }
  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];
  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    var asTemplateStringsArr = strings;
    styles += asTemplateStringsArr[0];
  } // we start at 1 since we've already handled the first arg

  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);
    if (stringMode) {
      var templateStringsArr = strings;
      styles += templateStringsArr[i];
    }
  }
  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + match[1];
  }
  var name = murmur2(styles) + identifierName;
  return {
    name: name,
    styles: styles,
    next: cursor
  };
}

var isBrowser$2 = typeof document !== 'undefined';
var syncFallback = function syncFallback(create) {
  return create();
};
var useInsertionEffect = React['useInsertion' + 'Effect'] ? React['useInsertion' + 'Effect'] : false;
var useInsertionEffectAlwaysWithSyncFallback = !isBrowser$2 ? syncFallback : useInsertionEffect || syncFallback;

var isBrowser$1 = typeof document !== 'undefined';

/* import { type EmotionCache } from '@emotion/utils' */
var EmotionCacheContext
/*: React.Context<EmotionCache | null> */ = /* #__PURE__ */React.createContext(
// we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */createCache({
  key: 'css'
}) : null);
EmotionCacheContext.Provider;
var withEmotionCache = function withEmotionCache
/* <Props, Ref: React.Ref<*>> */(func
/*: (props: Props, cache: EmotionCache, ref: Ref) => React.Node */) /*: React.AbstractComponent<Props> */
{
  return /*#__PURE__*/forwardRef(function (props
  /*: Props */, ref
  /*: Ref */) {
    // the cache will never be null in the browser
    var cache = useContext(EmotionCacheContext);
    return func(props, cache, ref);
  });
};
if (!isBrowser$1) {
  withEmotionCache = function withEmotionCache
  /* <Props> */(func
  /*: (props: Props, cache: EmotionCache) => React.Node */) /*: React.StatelessFunctionalComponent<Props> */
  {
    return function (props
    /*: Props */) {
      var cache = useContext(EmotionCacheContext);
      if (cache === null) {
        // yes, we're potentially creating this on every render
        // it doesn't actually matter though since it's only on the server
        // so there will only every be a single render
        // that could change in the future because of suspense and etc. but for now,
        // this works and i don't want to optimise for a future thing that we aren't sure about
        cache = createCache({
          key: 'css'
        });
        return /*#__PURE__*/React.createElement(EmotionCacheContext.Provider, {
          value: cache
        }, func(props, cache));
      } else {
        return func(props, cache);
      }
    };
  };
}
var ThemeContext = /* #__PURE__ */React.createContext({});

/* import type {
  ElementType,
  StatelessFunctionalComponent,
  AbstractComponent
} from 'react' */
/*
export type Interpolations = Array<any>

export type StyledElementType<Props> =
  | string
  | AbstractComponent<{ ...Props, className: string }, mixed>

export type StyledOptions = {
  label?: string,
  shouldForwardProp?: string => boolean,
  target?: string
}

export type StyledComponent<Props> = StatelessFunctionalComponent<Props> & {
  defaultProps: any,
  toString: () => string,
  withComponent: (
    nextTag: StyledElementType<Props>,
    nextOptions?: StyledOptions
  ) => StyledComponent<Props>
}

export type PrivateStyledComponent<Props> = StyledComponent<Props> & {
  __emotion_real: StyledComponent<Props>,
  __emotion_base: any,
  __emotion_styles: any,
  __emotion_forwardProp: any
}
*/

var testOmitPropsOnStringTag = isPropValid;
var testOmitPropsOnComponent = function testOmitPropsOnComponent(key
/*: string */) {
  return key !== 'theme';
};
var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag
/*: ElementType */) {
  return typeof tag === 'string' &&
  // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};
var composeShouldForwardProps = function composeShouldForwardProps(tag
/*: PrivateStyledComponent<any> */, options
/*: StyledOptions | void */, isReal
/*: boolean */) {
  var shouldForwardProp;
  if (options) {
    var optionsShouldForwardProp = options.shouldForwardProp;
    shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function (propName
    /*: string */) {
      return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
    } : optionsShouldForwardProp;
  }
  if (typeof shouldForwardProp !== 'function' && isReal) {
    shouldForwardProp = tag.__emotion_forwardProp;
  }
  return shouldForwardProp;
};
/*
export type CreateStyledComponent = <Props>(
  ...args: Interpolations
) => StyledComponent<Props>

export type CreateStyled = {
  <Props>(
    tag: StyledElementType<Props>,
    options?: StyledOptions
  ): (...args: Interpolations) => StyledComponent<Props>,
  [key: string]: CreateStyledComponent,
  bind: () => CreateStyled
}
*/

var isDevelopment = false;
var isBrowser = typeof document !== 'undefined';
var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
    serialized = _ref.serialized,
    isStringTag = _ref.isStringTag;
  registerStyles(cache, serialized, isStringTag);
  var rules = useInsertionEffectAlwaysWithSyncFallback(function () {
    return insertStyles(cache, serialized, isStringTag);
  });
  if (!isBrowser && rules !== undefined) {
    var _ref2;
    var serializedNames = serialized.name;
    var next = serialized.next;
    while (next !== undefined) {
      serializedNames += ' ' + next.name;
      next = next.next;
    }
    return /*#__PURE__*/React.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref2.nonce = cache.sheet.nonce, _ref2));
  }
  return null;
};
var createStyled
/*: CreateStyled */ = function createStyled
/*: CreateStyled */(tag
/*: any */, options
/* ?: StyledOptions */) {
  var isReal = tag.__emotion_real === tag;
  var baseTag = isReal && tag.__emotion_base || tag;
  var identifierName;
  var targetClassName;
  if (options !== undefined) {
    identifierName = options.label;
    targetClassName = options.target;
  }
  var shouldForwardProp = composeShouldForwardProps(tag, options, isReal);
  var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
  var shouldUseAs = !defaultShouldForwardProp('as');
  /* return function<Props>(): PrivateStyledComponent<Props> { */

  return function () {
    var args = arguments;
    var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
    if (identifierName !== undefined) {
      styles.push("label:" + identifierName + ";");
    }
    if (args[0] == null || args[0].raw === undefined) {
      styles.push.apply(styles, args);
    } else {
      styles.push(args[0][0]);
      var len = args.length;
      var i = 1;
      for (; i < len; i++) {
        styles.push(args[i], args[0][i]);
      }
    }
    var Styled
    /*: PrivateStyledComponent<Props> */ = withEmotionCache(function (props, cache, ref) {
      var FinalTag = shouldUseAs && props.as || baseTag;
      var className = '';
      var classInterpolations = [];
      var mergedProps = props;
      if (props.theme == null) {
        mergedProps = {};
        for (var key in props) {
          mergedProps[key] = props[key];
        }
        mergedProps.theme = React.useContext(ThemeContext);
      }
      if (typeof props.className === 'string') {
        className = getRegisteredStyles(cache.registered, classInterpolations, props.className);
      } else if (props.className != null) {
        className = props.className + " ";
      }
      var serialized = serializeStyles(styles.concat(classInterpolations), cache.registered, mergedProps);
      className += cache.key + "-" + serialized.name;
      if (targetClassName !== undefined) {
        className += " " + targetClassName;
      }
      var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
      var newProps = {};
      for (var _key in props) {
        if (shouldUseAs && _key === 'as') continue;
        if (finalShouldForwardProp(_key)) {
          newProps[_key] = props[_key];
        }
      }
      newProps.className = className;
      if (ref) {
        newProps.ref = ref;
      }
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof FinalTag === 'string'
      }), /*#__PURE__*/React.createElement(FinalTag, newProps));
    });
    Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
    Styled.defaultProps = tag.defaultProps;
    Styled.__emotion_real = Styled;
    Styled.__emotion_base = baseTag;
    Styled.__emotion_styles = styles;
    Styled.__emotion_forwardProp = shouldForwardProp;
    Object.defineProperty(Styled, 'toString', {
      value: function value() {
        if (targetClassName === undefined && isDevelopment) {
          return 'NO_COMPONENT_SELECTOR';
        }
        return "." + targetClassName;
      }
    });
    Styled.withComponent = function (nextTag
    /*: StyledElementType<Props> */, nextOptions
    /* ?: StyledOptions */) {
      return createStyled(nextTag, _extends$8({}, options, nextOptions, {
        shouldForwardProp: composeShouldForwardProps(Styled, nextOptions, true)
      })).apply(void 0, styles);
    };
    return Styled;
  };
};

var tags = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',
// SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];
var newStyled = createStyled.bind();
tags.forEach(function (tagName) {
  newStyled[tagName] = newStyled(tagName);
});

const OffLineContainer = newStyled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    svg {
        height: 40px;
    }
    p {
        margin-top: 30px;
    }
    button {
        margin-top: 30px;
        svg {
            height: 20px;
            margin-right: 10px;
        }
    }
`;
const OfflineModal = ({
  isOpen,
  onClose
}) => {
  return /*#__PURE__*/React__default.createElement(Modal, {
    title: "You are offline!",
    isOpen: isOpen,
    content: /*#__PURE__*/React__default.createElement(OffLineContainer, null, /*#__PURE__*/React__default.createElement(ForwardRef$3, null), /*#__PURE__*/React__default.createElement("p", null, "While using this app without an internet connection, you can only play setlists that you have been set to be available offline.")),
    onClose: onClose,
    onConfirm: onClose,
    confirmLabel: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, " Go to setlists"),
    confirmable: true
  });
};

function isObject(object) {
  return object != null && typeof object === 'object';
}
function deepEqual(object1, object2) {
  const keys1 = Object.keys(object1);
  const keys2 = Object.keys(object2);
  if (keys1.length !== keys2.length) {
    return false;
  }
  for (const key of keys1) {
    const val1 = object1[key];
    const val2 = object2[key];
    const areObjects = isObject(val1) && isObject(val2);
    if (areObjects && !deepEqual(val1, val2) || !areObjects && val1 !== val2) {
      return false;
    }
  }
  return true;
}
const songShowLimit = 600;
const LibraryContainer = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const librarySongs = useSelector(selectLibrarySongs);
  const libraryStatus = useSelector(selectLibraryStatus);
  const sessions = useSelector(selectSetlistSessions);
  const setlistSessions = useSelector(selectSetlistSessions);
  const lastCreatedSessionInSetlist = useSelector(selectLastCreatedSession);
  const clientConfiguration = useSelector(selectClientConfig);
  const currentLyrics = useSelector(selectLyricsLyrics);
  const lyricsStatus = useSelector(selectLyricsStatus);
  const currentUser = useSelector(selectUser);
  useSelector(selectOfflineModalVisible);
  const setlists = useSelector(selectSetlistsSetlists);
  const [genres, setGenres] = useState([]);
  const [keySignatures, setKeySignatures] = useState([]);
  const [decades, setDecades] = useState([]);
  const [search, setSearch] = useState('');
  const [pendingSongSelection, setPendingSongSelection] = useState(null);
  const [pendingNewSetlist, setPendingNewSetlist] = useState(false);
  const [pendingAddToPlaylist, setPendingAddToPlaylist] = useState(false);
  const [lyricsPreview, setLyricsPreview] = useState(null);
  const lastRequestConfig = useRef({});
  const [activeFilters, setActiveFilters] = useState({
    genres: [],
    decades: [],
    keySignatures: []
  });
  useEffect(() => {
    console.log('aaa');
    dispatch(resetLastCreated());
    const requestConfig = {
      startIndex: 0,
      limit: songShowLimit
    };
    // if (!deepEqual(requestConfig, lastRequestConfig.current)) dispatch(fetchLibrarySongsAsync(requestConfig)); 
    lastRequestConfig.current = requestConfig;
  }, []);
  useEffect(() => {
    dispatch(resetLyrics());
    if (pendingSongSelection?.lyricsUrl) dispatch(fetchLyricsAsync(pendingSongSelection.lyricsUrl));
  }, [pendingSongSelection, dispatch]);
  useEffect(() => {
    setGenres([...new Set(librarySongs.map(song => song.genre))]);
    setKeySignatures([...new Set(librarySongs.map(song => song.key))]);
    setDecades([...new Set(librarySongs.map(song => song.decade))]);
  }, [librarySongs]);
  const selectSong = songId => {
    const song = librarySongs.find(s => s.songId === songId);
    if (!currentUser?.subscribed && clientConfiguration.features.library.limitedLibrary.includes(songId)) {
      handleOpenSong(songId);
    } else {
      if (clientConfiguration.features.library.alwaysAddSongToMyPlaylist) {
        dispatch(createSessionFromSong({
          song: song,
          title: song.mix
        }));
        dispatch(addNotificationAsync({
          title: 'Song added',
          text: `${song.mix} by ${song.artist} added to your setlist`,
          type: 'positive'
        }));
        navigate(`/setlist`);
      } else {
        setPendingSongSelection(song);
      }
    }
  };
  const handleAddToSetlist = setlist => {
    dispatch(addSongToSetlist({
      setlistId: setlist.id,
      song: pendingSongSelection
    }));
    dispatch(addNotificationAsync({
      title: null,
      text: /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement("b", null, pendingSongSelection.mix), " added to ", /*#__PURE__*/React__default.createElement("b", null, setlist.name), "."),
      type: "positive"
    }));
    setPendingSongSelection(null);
    setPendingAddToPlaylist(false);
  };
  const renderEmptySetlistInfo = () => {
    if (clientConfiguration.features.setlist.enabled) {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "p-2"
      }, /*#__PURE__*/React__default.createElement(Alert, {
        alertType: "info",
        dismissible: false
      }, /*#__PURE__*/React__default.createElement("span", null, "Get started by adding songs to ", /*#__PURE__*/React__default.createElement(Link, {
        className: "text-primary",
        to: "/setlist"
      }, "Your Setlist"), " below.")));
    }
    return null;
  };
  const renderLoading = () => {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "p-2 flex justify-center"
    }, /*#__PURE__*/React__default.createElement(Spinner, null));
  };
  const fetchSongs = async (limit, search) => {
    console.log('fetchsongs');
    let result;
    if (search) {
      const requestConfig = {
        startIndex: 0,
        limit,
        search
      };
      if (!deepEqual(requestConfig, lastRequestConfig.current)) result = await dispatch(fetchLibrarySongsAsync(requestConfig));
      lastRequestConfig.current = requestConfig;
    } else {
      const requestConfig = {
        startIndex: 0,
        limit
      };
      if (!deepEqual(requestConfig, lastRequestConfig.current)) result = await dispatch(fetchLibrarySongsAsync(requestConfig));
      lastRequestConfig.current = requestConfig;
    }
    console.log(result?.error);
    if (result?.error) {
      console.log('fetchSongs error');
      console.trace('fetchSongs error');
      dispatch(setOfflineModalVisible(true));
    }
  };
  useEffect(() => {
    if (search) {
      fetchSongs(songShowLimit, search.toLowerCase());
    } else {
      fetchSongs(songShowLimit);
    }
  }, [dispatch, search]);
  useEffect(() => {
    console.log('active filters');
    const requestConfig = {
      startIndex: 0,
      limit: songShowLimit,
      activeFilters
    };
    if (!deepEqual(requestConfig, lastRequestConfig.current)) dispatch(fetchLibrarySongsAsync(requestConfig));
    lastRequestConfig.current = requestConfig;
  }, [activeFilters]);
  const shouldEnableSong = songId => {
    if (currentUser?.subscribed) return true;
    if (clientConfiguration.features.library.limitedLibrary.includes(songId)) return true;
    return false;
  };
  useEffect(async () => {
    if (lastCreatedSessionInSetlist) {
      const selectedSession = sessions.find(session => session.id === lastCreatedSessionInSetlist);
      await dispatch(openSession(selectedSession));
      navigate(`/session`);
    }
  }, [lastCreatedSessionInSetlist]);
  const handleOpenSong = async songId => {
    const song = librarySongs.find(s => s.songId === songId);
    // check if song already exists in the users setlist
    const existingSongSession = setlistSessions.find(session => session.song.songId === songId);
    if (existingSongSession) {
      await dispatch(openSession(existingSongSession));
      navigate(`/session`);
    } else {
      await dispatch(createSessionFromSong({
        song: song,
        title: song.mix
      }));
    }
  };
  const handleSubscribe = () => {
    window.open(clientConfiguration.features.library.subscribeConfig.url);
  };
  const handleViewLyrics = () => {
    setLyricsPreview(true);
  };
  const handleAddSongToSetlist = () => {
    setPendingAddToPlaylist(true);
    if (setlists.length === 0) setPendingNewSetlist(true);
  };
  const handleAddToNewSetlist = ({
    title,
    subtitle,
    imageUrl
  }) => {
    dispatch(createSetlistFromData({
      title,
      subtitle,
      imageUrl,
      items: [pendingSongSelection]
    }));
    dispatch(addNotificationAsync({
      title: null,
      text: /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement("b", null, pendingSongSelection.mix), " added to new ", /*#__PURE__*/React__default.createElement("b", null, title), " setlist."),
      type: "positive"
    }));
    setPendingNewSetlist(false);
    setPendingAddToPlaylist(false);
    setPendingSongSelection(null);
  };
  const mapSongToSongItem = song => {
    return {
      id: song.songId,
      // title: <>  <span>{song.mix}</span> {!isSongSupported(song.songId) ? renderNotSupported() : null} </>,
      title: song.mix,
      artist: song.artist,
      genre: song.genre,
      decade: song.decade,
      key: song.key,
      time: song.len,
      state: setlistSessions.find(s => s.song.mix === song.mix) ? "IN_SETLIST" : "NOT_IN_SETLIST",
      onSelected: () => selectSong(song.songId),
      showActionButton: false,
      actionLabel: /*#__PURE__*/React__default.createElement(React__default.Fragment, null)
    };
  };
  const formSongsList = () => {
    const songs = librarySongs.map(song => mapSongToSongItem(song)).sort((a, b) => a.title.localeCompare(b.title));
    if (currentUser?.subscribed) {
      return songs;
    } else {
      return songs.filter(song => !shouldEnableSong(song.songId));
    }
  };
  const handleOpenSheetMusic = url => {
    window.open(url, "_blank");
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, libraryStatus === 'idle' && setlistSessions.length === 0 && renderEmptySetlistInfo(), !search && libraryStatus === 'pending' && renderLoading(), /*#__PURE__*/React__default.createElement(Library, {
    genres: genres,
    keySignatures: keySignatures,
    decades: decades,
    onFilterChanged: setActiveFilters,
    searchValue: search,
    onSearchChanged: e => setSearch(e.target.value),
    items: formSongsList().filter(song => currentUser?.subscribed ? true : !clientConfiguration.features.library.limitedLibrary.includes(song.id)),
    promotionalItems: currentUser?.subscribed ? [] : formSongsList().filter(song => clientConfiguration.features.library.limitedLibrary.includes(song.id)),
    promotionalImageUrl: `${process.env.PUBLIC_URL}${clientConfiguration.images.registrationPromo}`,
    promotionalLinkText: clientConfiguration.features.library.subscribeConfig.libraryPromoText,
    promotionalLinkButtonText: clientConfiguration.features.library.subscribeConfig.libraryPromoButtonText,
    promotionalLinkUrl: clientConfiguration.features.library.subscribeConfig.url,
    promotionalText: clientConfiguration.features.library.subscribeConfig.libraryText,
    promotionalTitle: clientConfiguration.features.library.subscribeConfig.libraryTitle,
    sortedBy: {
      "label": "Title",
      "dir": "desc"
    }
  }), /*#__PURE__*/React__default.createElement(SongDetailsModal, {
    onOpenSheetMusic: handleOpenSheetMusic,
    song: pendingSongSelection,
    lyrics: currentLyrics,
    lyricsStatus: lyricsStatus,
    subscribeConfig: clientConfiguration.features.library.subscribeConfig,
    restricted: pendingSongSelection && !shouldEnableSong(pendingSongSelection.songId),
    isOpen: !!pendingSongSelection && !pendingAddToPlaylist && !lyricsPreview,
    onClose: () => setPendingSongSelection(null),
    onOpen: handleOpenSong,
    onSubscribe: handleSubscribe,
    onAddToSetlist: handleAddSongToSetlist,
    onLyricsPreview: handleViewLyrics,
    autoPlayPreview: false
  }), /*#__PURE__*/React__default.createElement(LyricsModal, {
    song: pendingSongSelection,
    lyrics: currentLyrics,
    isOpen: !!lyricsPreview,
    onClose: () => setLyricsPreview(false)
  }), /*#__PURE__*/React__default.createElement(AddToSetlistModal, {
    setlists: setlists.map(setlist => ({
      id: setlist.id,
      name: setlist.title,
      avatar: setlist.imageUrl
    })),
    onClose: () => {
      setPendingSongSelection(null);
      setPendingAddToPlaylist(false);
    },
    isOpen: !!pendingAddToPlaylist && !pendingNewSetlist,
    onSelectNewPlaylist: () => setPendingNewSetlist(true),
    onConfirm: handleAddToSetlist
  }), /*#__PURE__*/React__default.createElement(AddToNewSetlistModal, {
    onClose: () => {
      setPendingAddToPlaylist(false);
      setPendingNewSetlist(false);
      setPendingSongSelection(null);
    },
    firstSetlist: setlists.length === 0,
    isOpen: !!pendingAddToPlaylist && pendingNewSetlist,
    onConfirm: handleAddToNewSetlist
  }));
};

const HelpPage = () => {
  // pgw testing
  // const clientConfiguration = useSelector(selectClientConfig);

  // pgw testing 13-may-2024
  console.log('HelpPage p1');
  // alert('help')

  return /*#__PURE__*/React__default.createElement("div", {
    className: "overflow-auto "
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "relative py-16 pb-4 bg-white overflow-hidden"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "relative px-4 sm:px-6 lg:px-8"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "text-lg max-w-prose mx-auto"
  }, /*#__PURE__*/React__default.createElement("h1", null, /*#__PURE__*/React__default.createElement("span", {
    className: "mt-2 block text-3xl text-center leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl"
  }, "Choir Player features list"))), /*#__PURE__*/React__default.createElement("div", {
    className: "mt-6 prose prose-indigo prose-lg text-gray-500 mx-auto"
  }, /*#__PURE__*/React__default.createElement("ul", {
    role: "list"
  }, /*#__PURE__*/React__default.createElement("li", null, "SEPARATE VOLUME CONTROL of Soprano, Alto, Tenor, Bass and Backing track: The volume level of all 5 parts can be set exactly how you want them including turning any of the parts off completely."), /*#__PURE__*/React__default.createElement("li", null, "SOLO: A shortcut to isolating any 1 part (same as muting the other 4)."), /*#__PURE__*/React__default.createElement("li", null, "RESET LEVELS: Instantly reset all 5 parts to full volume"), /*#__PURE__*/React__default.createElement("li", null, "LYRICS: Scroll on screen as the song progresses. You can see which vocal part is singing which lines. The lyric feature can be switched on and off."), /*#__PURE__*/React__default.createElement("li", null, "GO TO SECTION: Instantly jump to any song section (verse, bridge, chorus etc.)"), /*#__PURE__*/React__default.createElement("li", null, "LOOP: Tap the Loop button at any point in the song and the section which is playing will repeat until Loop is tapped again."), /*#__PURE__*/React__default.createElement("li", null, "SPEED: Slow down or speed up the tempo without changing pitch."), /*#__PURE__*/React__default.createElement("li", null, "PITCH: Change key"), /*#__PURE__*/React__default.createElement("li", null, "RESET SPEED/PITCH: Instantly return the tempo and key to the original settings")), /*#__PURE__*/React__default.createElement("strong", null, "Here is a link to a detailed user guide: "), /*#__PURE__*/React__default.createElement("a", {
    href: "https://choirplayer.com/user-guide/"
  }, "Choir Player user guide"), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("strong", null, "Please go here to see your Choir Page account details: "), /*#__PURE__*/React__default.createElement("a", {
    href: "https://choirplayer.com/my-account/"
  }, "Choir Player account"), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("br", null)))));
};

var main$2 = {exports: {}};

(function (module, exports) {
	!function (e, t) {
	  module.exports = t(React__default) ;
	}(commonjsGlobal$1, function (e) {
	  return function (e) {
	    var t = {};
	    function n(a) {
	      if (t[a]) return t[a].exports;
	      var r = t[a] = {
	        i: a,
	        l: !1,
	        exports: {}
	      };
	      return e[a].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
	    }
	    return n.m = e, n.c = t, n.d = function (e, t, a) {
	      n.o(e, t) || Object.defineProperty(e, t, {
	        enumerable: !0,
	        get: a
	      });
	    }, n.r = function (e) {
	      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
	        value: "Module"
	      }), Object.defineProperty(e, "__esModule", {
	        value: !0
	      });
	    }, n.t = function (e, t) {
	      if (1 & t && (e = n(e)), 8 & t) return e;
	      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
	      var a = Object.create(null);
	      if (n.r(a), Object.defineProperty(a, "default", {
	        enumerable: !0,
	        value: e
	      }), 2 & t && "string" != typeof e) for (var r in e) n.d(a, r, function (t) {
	        return e[t];
	      }.bind(null, r));
	      return a;
	    }, n.n = function (e) {
	      var t = e && e.__esModule ? function () {
	        return e.default;
	      } : function () {
	        return e;
	      };
	      return n.d(t, "a", t), t;
	    }, n.o = function (e, t) {
	      return Object.prototype.hasOwnProperty.call(e, t);
	    }, n.p = "", n(n.s = 48);
	  }([function (t, n) {
	    t.exports = e;
	  }, function (e, t) {
	    var n = e.exports = {
	      version: "2.6.12"
	    };
	    "number" == typeof __e && (__e = n);
	  }, function (e, t, n) {
	    var a = n(26)("wks"),
	      r = n(17),
	      o = n(3).Symbol,
	      i = "function" == typeof o;
	    (e.exports = function (e) {
	      return a[e] || (a[e] = i && o[e] || (i ? o : r)("Symbol." + e));
	    }).store = a;
	  }, function (e, t) {
	    var n = e.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
	    "number" == typeof __g && (__g = n);
	  }, function (e, t, n) {
	    e.exports = !n(8)(function () {
	      return 7 != Object.defineProperty({}, "a", {
	        get: function () {
	          return 7;
	        }
	      }).a;
	    });
	  }, function (e, t) {
	    var n = {}.hasOwnProperty;
	    e.exports = function (e, t) {
	      return n.call(e, t);
	    };
	  }, function (e, t, n) {
	    var a = n(7),
	      r = n(16);
	    e.exports = n(4) ? function (e, t, n) {
	      return a.f(e, t, r(1, n));
	    } : function (e, t, n) {
	      return e[t] = n, e;
	    };
	  }, function (e, t, n) {
	    var a = n(10),
	      r = n(35),
	      o = n(23),
	      i = Object.defineProperty;
	    t.f = n(4) ? Object.defineProperty : function (e, t, n) {
	      if (a(e), t = o(t, !0), a(n), r) try {
	        return i(e, t, n);
	      } catch (e) {}
	      if ("get" in n || "set" in n) throw TypeError("Accessors not supported!");
	      return "value" in n && (e[t] = n.value), e;
	    };
	  }, function (e, t) {
	    e.exports = function (e) {
	      try {
	        return !!e();
	      } catch (e) {
	        return !0;
	      }
	    };
	  }, function (e, t, n) {
	    var a = n(40),
	      r = n(22);
	    e.exports = function (e) {
	      return a(r(e));
	    };
	  }, function (e, t, n) {
	    var a = n(11);
	    e.exports = function (e) {
	      if (!a(e)) throw TypeError(e + " is not an object!");
	      return e;
	    };
	  }, function (e, t) {
	    e.exports = function (e) {
	      return "object" == typeof e ? null !== e : "function" == typeof e;
	    };
	  }, function (e, t) {
	    e.exports = {};
	  }, function (e, t, n) {
	    var a = n(39),
	      r = n(27);
	    e.exports = Object.keys || function (e) {
	      return a(e, r);
	    };
	  }, function (e, t) {
	    e.exports = !0;
	  }, function (e, t, n) {
	    var a = n(3),
	      r = n(1),
	      o = n(53),
	      i = n(6),
	      s = n(5),
	      c = function (e, t, n) {
	        var l,
	          u,
	          f,
	          p = e & c.F,
	          d = e & c.G,
	          b = e & c.S,
	          h = e & c.P,
	          v = e & c.B,
	          m = e & c.W,
	          y = d ? r : r[t] || (r[t] = {}),
	          g = y.prototype,
	          E = d ? a : b ? a[t] : (a[t] || {}).prototype;
	        for (l in d && (n = t), n) (u = !p && E && void 0 !== E[l]) && s(y, l) || (f = u ? E[l] : n[l], y[l] = d && "function" != typeof E[l] ? n[l] : v && u ? o(f, a) : m && E[l] == f ? function (e) {
	          var t = function (t, n, a) {
	            if (this instanceof e) {
	              switch (arguments.length) {
	                case 0:
	                  return new e();
	                case 1:
	                  return new e(t);
	                case 2:
	                  return new e(t, n);
	              }
	              return new e(t, n, a);
	            }
	            return e.apply(this, arguments);
	          };
	          return t.prototype = e.prototype, t;
	        }(f) : h && "function" == typeof f ? o(Function.call, f) : f, h && ((y.virtual || (y.virtual = {}))[l] = f, e & c.R && g && !g[l] && i(g, l, f)));
	      };
	    c.F = 1, c.G = 2, c.S = 4, c.P = 8, c.B = 16, c.W = 32, c.U = 64, c.R = 128, e.exports = c;
	  }, function (e, t) {
	    e.exports = function (e, t) {
	      return {
	        enumerable: !(1 & e),
	        configurable: !(2 & e),
	        writable: !(4 & e),
	        value: t
	      };
	    };
	  }, function (e, t) {
	    var n = 0,
	      a = Math.random();
	    e.exports = function (e) {
	      return "Symbol(".concat(void 0 === e ? "" : e, ")_", (++n + a).toString(36));
	    };
	  }, function (e, t, n) {
	    var a = n(22);
	    e.exports = function (e) {
	      return Object(a(e));
	    };
	  }, function (e, t) {
	    t.f = {}.propertyIsEnumerable;
	  }, function (e, t, n) {

	    var a = n(52)(!0);
	    n(34)(String, "String", function (e) {
	      this._t = String(e), this._i = 0;
	    }, function () {
	      var e,
	        t = this._t,
	        n = this._i;
	      return n >= t.length ? {
	        value: void 0,
	        done: !0
	      } : (e = a(t, n), this._i += e.length, {
	        value: e,
	        done: !1
	      });
	    });
	  }, function (e, t) {
	    var n = Math.ceil,
	      a = Math.floor;
	    e.exports = function (e) {
	      return isNaN(e = +e) ? 0 : (e > 0 ? a : n)(e);
	    };
	  }, function (e, t) {
	    e.exports = function (e) {
	      if (null == e) throw TypeError("Can't call method on  " + e);
	      return e;
	    };
	  }, function (e, t, n) {
	    var a = n(11);
	    e.exports = function (e, t) {
	      if (!a(e)) return e;
	      var n, r;
	      if (t && "function" == typeof (n = e.toString) && !a(r = n.call(e))) return r;
	      if ("function" == typeof (n = e.valueOf) && !a(r = n.call(e))) return r;
	      if (!t && "function" == typeof (n = e.toString) && !a(r = n.call(e))) return r;
	      throw TypeError("Can't convert object to primitive value");
	    };
	  }, function (e, t) {
	    var n = {}.toString;
	    e.exports = function (e) {
	      return n.call(e).slice(8, -1);
	    };
	  }, function (e, t, n) {
	    var a = n(26)("keys"),
	      r = n(17);
	    e.exports = function (e) {
	      return a[e] || (a[e] = r(e));
	    };
	  }, function (e, t, n) {
	    var a = n(1),
	      r = n(3),
	      o = r["__core-js_shared__"] || (r["__core-js_shared__"] = {});
	    (e.exports = function (e, t) {
	      return o[e] || (o[e] = void 0 !== t ? t : {});
	    })("versions", []).push({
	      version: a.version,
	      mode: n(14) ? "pure" : "global",
	      copyright: "© 2020 Denis Pushkarev (zloirock.ru)"
	    });
	  }, function (e, t) {
	    e.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
	  }, function (e, t, n) {
	    var a = n(7).f,
	      r = n(5),
	      o = n(2)("toStringTag");
	    e.exports = function (e, t, n) {
	      e && !r(e = n ? e : e.prototype, o) && a(e, o, {
	        configurable: !0,
	        value: t
	      });
	    };
	  }, function (e, t, n) {
	    n(62);
	    for (var a = n(3), r = n(6), o = n(12), i = n(2)("toStringTag"), s = "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(","), c = 0; c < s.length; c++) {
	      var l = s[c],
	        u = a[l],
	        f = u && u.prototype;
	      f && !f[i] && r(f, i, l), o[l] = o.Array;
	    }
	  }, function (e, t, n) {
	    t.f = n(2);
	  }, function (e, t, n) {
	    var a = n(3),
	      r = n(1),
	      o = n(14),
	      i = n(30),
	      s = n(7).f;
	    e.exports = function (e) {
	      var t = r.Symbol || (r.Symbol = o ? {} : a.Symbol || {});
	      "_" == e.charAt(0) || e in t || s(t, e, {
	        value: i.f(e)
	      });
	    };
	  }, function (e, t) {
	    t.f = Object.getOwnPropertySymbols;
	  }, function (e, t) {
	    e.exports = function (e, t, n) {
	      return Math.min(Math.max(e, t), n);
	    };
	  }, function (e, t, n) {

	    var a = n(14),
	      r = n(15),
	      o = n(37),
	      i = n(6),
	      s = n(12),
	      c = n(55),
	      l = n(28),
	      u = n(61),
	      f = n(2)("iterator"),
	      p = !([].keys && "next" in [].keys()),
	      d = function () {
	        return this;
	      };
	    e.exports = function (e, t, n, b, h, v, m) {
	      c(n, t, b);
	      var y,
	        g,
	        E,
	        j = function (e) {
	          if (!p && e in O) return O[e];
	          switch (e) {
	            case "keys":
	            case "values":
	              return function () {
	                return new n(this, e);
	              };
	          }
	          return function () {
	            return new n(this, e);
	          };
	        },
	        x = t + " Iterator",
	        _ = "values" == h,
	        k = !1,
	        O = e.prototype,
	        C = O[f] || O["@@iterator"] || h && O[h],
	        S = C || j(h),
	        w = h ? _ ? j("entries") : S : void 0,
	        A = "Array" == t && O.entries || C;
	      if (A && (E = u(A.call(new e()))) !== Object.prototype && E.next && (l(E, x, !0), a || "function" == typeof E[f] || i(E, f, d)), _ && C && "values" !== C.name && (k = !0, S = function () {
	        return C.call(this);
	      }), a && !m || !p && !k && O[f] || i(O, f, S), s[t] = S, s[x] = d, h) if (y = {
	        values: _ ? S : j("values"),
	        keys: v ? S : j("keys"),
	        entries: w
	      }, m) for (g in y) g in O || o(O, g, y[g]);else r(r.P + r.F * (p || k), t, y);
	      return y;
	    };
	  }, function (e, t, n) {
	    e.exports = !n(4) && !n(8)(function () {
	      return 7 != Object.defineProperty(n(36)("div"), "a", {
	        get: function () {
	          return 7;
	        }
	      }).a;
	    });
	  }, function (e, t, n) {
	    var a = n(11),
	      r = n(3).document,
	      o = a(r) && a(r.createElement);
	    e.exports = function (e) {
	      return o ? r.createElement(e) : {};
	    };
	  }, function (e, t, n) {
	    e.exports = n(6);
	  }, function (e, t, n) {
	    var a = n(10),
	      r = n(56),
	      o = n(27),
	      i = n(25)("IE_PROTO"),
	      s = function () {},
	      c = function () {
	        var e,
	          t = n(36)("iframe"),
	          a = o.length;
	        for (t.style.display = "none", n(60).appendChild(t), t.src = "javascript:", (e = t.contentWindow.document).open(), e.write("<script>document.F=Object<\/script>"), e.close(), c = e.F; a--;) delete c.prototype[o[a]];
	        return c();
	      };
	    e.exports = Object.create || function (e, t) {
	      var n;
	      return null !== e ? (s.prototype = a(e), n = new s(), s.prototype = null, n[i] = e) : n = c(), void 0 === t ? n : r(n, t);
	    };
	  }, function (e, t, n) {
	    var a = n(5),
	      r = n(9),
	      o = n(57)(!1),
	      i = n(25)("IE_PROTO");
	    e.exports = function (e, t) {
	      var n,
	        s = r(e),
	        c = 0,
	        l = [];
	      for (n in s) n != i && a(s, n) && l.push(n);
	      for (; t.length > c;) a(s, n = t[c++]) && (~o(l, n) || l.push(n));
	      return l;
	    };
	  }, function (e, t, n) {
	    var a = n(24);
	    e.exports = Object("z").propertyIsEnumerable(0) ? Object : function (e) {
	      return "String" == a(e) ? e.split("") : Object(e);
	    };
	  }, function (e, t, n) {
	    var a = n(39),
	      r = n(27).concat("length", "prototype");
	    t.f = Object.getOwnPropertyNames || function (e) {
	      return a(e, r);
	    };
	  }, function (e, t, n) {
	    var a = n(24),
	      r = n(2)("toStringTag"),
	      o = "Arguments" == a(function () {
	        return arguments;
	      }());
	    e.exports = function (e) {
	      var t, n, i;
	      return void 0 === e ? "Undefined" : null === e ? "Null" : "string" == typeof (n = function (e, t) {
	        try {
	          return e[t];
	        } catch (e) {}
	      }(t = Object(e), r)) ? n : o ? a(t) : "Object" == (i = a(t)) && "function" == typeof t.callee ? "Arguments" : i;
	    };
	  }, function (e, t) {
	    var n;
	    n = function () {
	      return this;
	    }();
	    try {
	      n = n || new Function("return this")();
	    } catch (e) {
	      "object" == typeof window && (n = window);
	    }
	    e.exports = n;
	  }, function (e, t) {
	    var n = /-?\d+(\.\d+)?%?/g;
	    e.exports = function (e) {
	      return e.match(n);
	    };
	  }, function (e, t, n) {

	    Object.defineProperty(t, "__esModule", {
	      value: !0
	    }), t.getBase16Theme = t.createStyling = t.invertTheme = void 0;
	    var a = d(n(49)),
	      r = d(n(76)),
	      o = d(n(81)),
	      i = d(n(89)),
	      s = d(n(93)),
	      c = function (e) {
	        if (e && e.__esModule) return e;
	        var t = {};
	        if (null != e) for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
	        return t.default = e, t;
	      }(n(94)),
	      l = d(n(132)),
	      u = d(n(133)),
	      f = d(n(138)),
	      p = n(139);
	    function d(e) {
	      return e && e.__esModule ? e : {
	        default: e
	      };
	    }
	    var b = c.default,
	      h = (0, i.default)(b),
	      v = (0, f.default)(u.default, p.rgb2yuv, function (e) {
	        var t,
	          n = (0, o.default)(e, 3),
	          a = n[0],
	          r = n[1],
	          i = n[2];
	        return [(t = a, t < .25 ? 1 : t < .5 ? .9 - t : 1.1 - t), r, i];
	      }, p.yuv2rgb, l.default),
	      m = function (e) {
	        return function (t) {
	          return {
	            className: [t.className, e.className].filter(Boolean).join(" "),
	            style: (0, r.default)({}, t.style || {}, e.style || {})
	          };
	        };
	      },
	      y = function (e, t) {
	        var n = (0, i.default)(t);
	        for (var o in e) -1 === n.indexOf(o) && n.push(o);
	        return n.reduce(function (n, o) {
	          return n[o] = function (e, t) {
	            if (void 0 === e) return t;
	            if (void 0 === t) return e;
	            var n = void 0 === e ? "undefined" : (0, a.default)(e),
	              o = void 0 === t ? "undefined" : (0, a.default)(t);
	            switch (n) {
	              case "string":
	                switch (o) {
	                  case "string":
	                    return [t, e].filter(Boolean).join(" ");
	                  case "object":
	                    return m({
	                      className: e,
	                      style: t
	                    });
	                  case "function":
	                    return function (n) {
	                      for (var a = arguments.length, r = Array(a > 1 ? a - 1 : 0), o = 1; o < a; o++) r[o - 1] = arguments[o];
	                      return m({
	                        className: e
	                      })(t.apply(void 0, [n].concat(r)));
	                    };
	                }
	              case "object":
	                switch (o) {
	                  case "string":
	                    return m({
	                      className: t,
	                      style: e
	                    });
	                  case "object":
	                    return (0, r.default)({}, t, e);
	                  case "function":
	                    return function (n) {
	                      for (var a = arguments.length, r = Array(a > 1 ? a - 1 : 0), o = 1; o < a; o++) r[o - 1] = arguments[o];
	                      return m({
	                        style: e
	                      })(t.apply(void 0, [n].concat(r)));
	                    };
	                }
	              case "function":
	                switch (o) {
	                  case "string":
	                    return function (n) {
	                      for (var a = arguments.length, r = Array(a > 1 ? a - 1 : 0), o = 1; o < a; o++) r[o - 1] = arguments[o];
	                      return e.apply(void 0, [m(n)({
	                        className: t
	                      })].concat(r));
	                    };
	                  case "object":
	                    return function (n) {
	                      for (var a = arguments.length, r = Array(a > 1 ? a - 1 : 0), o = 1; o < a; o++) r[o - 1] = arguments[o];
	                      return e.apply(void 0, [m(n)({
	                        style: t
	                      })].concat(r));
	                    };
	                  case "function":
	                    return function (n) {
	                      for (var a = arguments.length, r = Array(a > 1 ? a - 1 : 0), o = 1; o < a; o++) r[o - 1] = arguments[o];
	                      return e.apply(void 0, [t.apply(void 0, [n].concat(r))].concat(r));
	                    };
	                }
	            }
	          }(e[o], t[o]), n;
	        }, {});
	      },
	      g = function (e, t) {
	        for (var n = arguments.length, o = Array(n > 2 ? n - 2 : 0), s = 2; s < n; s++) o[s - 2] = arguments[s];
	        if (null === t) return e;
	        Array.isArray(t) || (t = [t]);
	        var c = t.map(function (t) {
	            return e[t];
	          }).filter(Boolean),
	          l = c.reduce(function (e, t) {
	            return "string" == typeof t ? e.className = [e.className, t].filter(Boolean).join(" ") : "object" === (void 0 === t ? "undefined" : (0, a.default)(t)) ? e.style = (0, r.default)({}, e.style, t) : "function" == typeof t && (e = (0, r.default)({}, e, t.apply(void 0, [e].concat(o)))), e;
	          }, {
	            className: "",
	            style: {}
	          });
	        return l.className || delete l.className, 0 === (0, i.default)(l.style).length && delete l.style, l;
	      },
	      E = t.invertTheme = function (e) {
	        return (0, i.default)(e).reduce(function (t, n) {
	          return t[n] = /^base/.test(n) ? v(e[n]) : "scheme" === n ? e[n] + ":inverted" : e[n], t;
	        }, {});
	      },
	      j = (t.createStyling = (0, s.default)(function (e) {
	        for (var t = arguments.length, n = Array(t > 3 ? t - 3 : 0), a = 3; a < t; a++) n[a - 3] = arguments[a];
	        var o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
	          c = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
	          l = o.defaultBase16,
	          u = void 0 === l ? b : l,
	          f = o.base16Themes,
	          p = void 0 === f ? null : f,
	          d = j(c, p);
	        d && (c = (0, r.default)({}, d, c));
	        var v = h.reduce(function (e, t) {
	            return e[t] = c[t] || u[t], e;
	          }, {}),
	          m = (0, i.default)(c).reduce(function (e, t) {
	            return -1 === h.indexOf(t) ? (e[t] = c[t], e) : e;
	          }, {}),
	          E = e(v),
	          x = y(m, E);
	        return (0, s.default)(g, 2).apply(void 0, [x].concat(n));
	      }, 3), t.getBase16Theme = function (e, t) {
	        if (e && e.extend && (e = e.extend), "string" == typeof e) {
	          var n = e.split(":"),
	            a = (0, o.default)(n, 2),
	            r = a[0],
	            i = a[1];
	          e = (t || {})[r] || c[r], "inverted" === i && (e = E(e));
	        }
	        return e && e.hasOwnProperty("base00") ? e : void 0;
	      });
	  }, function (e, t, n) {

	    var a,
	      r = "object" == typeof Reflect ? Reflect : null,
	      o = r && "function" == typeof r.apply ? r.apply : function (e, t, n) {
	        return Function.prototype.apply.call(e, t, n);
	      };
	    a = r && "function" == typeof r.ownKeys ? r.ownKeys : Object.getOwnPropertySymbols ? function (e) {
	      return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
	    } : function (e) {
	      return Object.getOwnPropertyNames(e);
	    };
	    var i = Number.isNaN || function (e) {
	      return e != e;
	    };
	    function s() {
	      s.init.call(this);
	    }
	    e.exports = s, e.exports.once = function (e, t) {
	      return new Promise(function (n, a) {
	        function r() {
	          void 0 !== o && e.removeListener("error", o), n([].slice.call(arguments));
	        }
	        var o;
	        "error" !== t && (o = function (n) {
	          e.removeListener(t, r), a(n);
	        }, e.once("error", o)), e.once(t, r);
	      });
	    }, s.EventEmitter = s, s.prototype._events = void 0, s.prototype._eventsCount = 0, s.prototype._maxListeners = void 0;
	    var c = 10;
	    function l(e) {
	      if ("function" != typeof e) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
	    }
	    function u(e) {
	      return void 0 === e._maxListeners ? s.defaultMaxListeners : e._maxListeners;
	    }
	    function f(e, t, n, a) {
	      var r, o, i, s;
	      if (l(n), void 0 === (o = e._events) ? (o = e._events = Object.create(null), e._eventsCount = 0) : (void 0 !== o.newListener && (e.emit("newListener", t, n.listener ? n.listener : n), o = e._events), i = o[t]), void 0 === i) i = o[t] = n, ++e._eventsCount;else if ("function" == typeof i ? i = o[t] = a ? [n, i] : [i, n] : a ? i.unshift(n) : i.push(n), (r = u(e)) > 0 && i.length > r && !i.warned) {
	        i.warned = !0;
	        var c = new Error("Possible EventEmitter memory leak detected. " + i.length + " " + String(t) + " listeners added. Use emitter.setMaxListeners() to increase limit");
	        c.name = "MaxListenersExceededWarning", c.emitter = e, c.type = t, c.count = i.length, s = c, console && console.warn && console.warn(s);
	      }
	      return e;
	    }
	    function p() {
	      if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, 0 === arguments.length ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
	    }
	    function d(e, t, n) {
	      var a = {
	          fired: !1,
	          wrapFn: void 0,
	          target: e,
	          type: t,
	          listener: n
	        },
	        r = p.bind(a);
	      return r.listener = n, a.wrapFn = r, r;
	    }
	    function b(e, t, n) {
	      var a = e._events;
	      if (void 0 === a) return [];
	      var r = a[t];
	      return void 0 === r ? [] : "function" == typeof r ? n ? [r.listener || r] : [r] : n ? function (e) {
	        for (var t = new Array(e.length), n = 0; n < t.length; ++n) t[n] = e[n].listener || e[n];
	        return t;
	      }(r) : v(r, r.length);
	    }
	    function h(e) {
	      var t = this._events;
	      if (void 0 !== t) {
	        var n = t[e];
	        if ("function" == typeof n) return 1;
	        if (void 0 !== n) return n.length;
	      }
	      return 0;
	    }
	    function v(e, t) {
	      for (var n = new Array(t), a = 0; a < t; ++a) n[a] = e[a];
	      return n;
	    }
	    Object.defineProperty(s, "defaultMaxListeners", {
	      enumerable: !0,
	      get: function () {
	        return c;
	      },
	      set: function (e) {
	        if ("number" != typeof e || e < 0 || i(e)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + e + ".");
	        c = e;
	      }
	    }), s.init = function () {
	      void 0 !== this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
	    }, s.prototype.setMaxListeners = function (e) {
	      if ("number" != typeof e || e < 0 || i(e)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + e + ".");
	      return this._maxListeners = e, this;
	    }, s.prototype.getMaxListeners = function () {
	      return u(this);
	    }, s.prototype.emit = function (e) {
	      for (var t = [], n = 1; n < arguments.length; n++) t.push(arguments[n]);
	      var a = "error" === e,
	        r = this._events;
	      if (void 0 !== r) a = a && void 0 === r.error;else if (!a) return !1;
	      if (a) {
	        var i;
	        if (t.length > 0 && (i = t[0]), i instanceof Error) throw i;
	        var s = new Error("Unhandled error." + (i ? " (" + i.message + ")" : ""));
	        throw s.context = i, s;
	      }
	      var c = r[e];
	      if (void 0 === c) return !1;
	      if ("function" == typeof c) o(c, this, t);else {
	        var l = c.length,
	          u = v(c, l);
	        for (n = 0; n < l; ++n) o(u[n], this, t);
	      }
	      return !0;
	    }, s.prototype.addListener = function (e, t) {
	      return f(this, e, t, !1);
	    }, s.prototype.on = s.prototype.addListener, s.prototype.prependListener = function (e, t) {
	      return f(this, e, t, !0);
	    }, s.prototype.once = function (e, t) {
	      return l(t), this.on(e, d(this, e, t)), this;
	    }, s.prototype.prependOnceListener = function (e, t) {
	      return l(t), this.prependListener(e, d(this, e, t)), this;
	    }, s.prototype.removeListener = function (e, t) {
	      var n, a, r, o, i;
	      if (l(t), void 0 === (a = this._events)) return this;
	      if (void 0 === (n = a[e])) return this;
	      if (n === t || n.listener === t) 0 == --this._eventsCount ? this._events = Object.create(null) : (delete a[e], a.removeListener && this.emit("removeListener", e, n.listener || t));else if ("function" != typeof n) {
	        for (r = -1, o = n.length - 1; o >= 0; o--) if (n[o] === t || n[o].listener === t) {
	          i = n[o].listener, r = o;
	          break;
	        }
	        if (r < 0) return this;
	        0 === r ? n.shift() : function (e, t) {
	          for (; t + 1 < e.length; t++) e[t] = e[t + 1];
	          e.pop();
	        }(n, r), 1 === n.length && (a[e] = n[0]), void 0 !== a.removeListener && this.emit("removeListener", e, i || t);
	      }
	      return this;
	    }, s.prototype.off = s.prototype.removeListener, s.prototype.removeAllListeners = function (e) {
	      var t, n, a;
	      if (void 0 === (n = this._events)) return this;
	      if (void 0 === n.removeListener) return 0 === arguments.length ? (this._events = Object.create(null), this._eventsCount = 0) : void 0 !== n[e] && (0 == --this._eventsCount ? this._events = Object.create(null) : delete n[e]), this;
	      if (0 === arguments.length) {
	        var r,
	          o = Object.keys(n);
	        for (a = 0; a < o.length; ++a) "removeListener" !== (r = o[a]) && this.removeAllListeners(r);
	        return this.removeAllListeners("removeListener"), this._events = Object.create(null), this._eventsCount = 0, this;
	      }
	      if ("function" == typeof (t = n[e])) this.removeListener(e, t);else if (void 0 !== t) for (a = t.length - 1; a >= 0; a--) this.removeListener(e, t[a]);
	      return this;
	    }, s.prototype.listeners = function (e) {
	      return b(this, e, !0);
	    }, s.prototype.rawListeners = function (e) {
	      return b(this, e, !1);
	    }, s.listenerCount = function (e, t) {
	      return "function" == typeof e.listenerCount ? e.listenerCount(t) : h.call(e, t);
	    }, s.prototype.listenerCount = h, s.prototype.eventNames = function () {
	      return this._eventsCount > 0 ? a(this._events) : [];
	    };
	  }, function (e, t, n) {
	    e.exports.Dispatcher = n(140);
	  }, function (e, t, n) {
	    e.exports = n(142);
	  }, function (e, t, n) {

	    t.__esModule = !0;
	    var a = i(n(50)),
	      r = i(n(65)),
	      o = "function" == typeof r.default && "symbol" == typeof a.default ? function (e) {
	        return typeof e;
	      } : function (e) {
	        return e && "function" == typeof r.default && e.constructor === r.default && e !== r.default.prototype ? "symbol" : typeof e;
	      };
	    function i(e) {
	      return e && e.__esModule ? e : {
	        default: e
	      };
	    }
	    t.default = "function" == typeof r.default && "symbol" === o(a.default) ? function (e) {
	      return void 0 === e ? "undefined" : o(e);
	    } : function (e) {
	      return e && "function" == typeof r.default && e.constructor === r.default && e !== r.default.prototype ? "symbol" : void 0 === e ? "undefined" : o(e);
	    };
	  }, function (e, t, n) {
	    e.exports = {
	      default: n(51),
	      __esModule: !0
	    };
	  }, function (e, t, n) {
	    n(20), n(29), e.exports = n(30).f("iterator");
	  }, function (e, t, n) {
	    var a = n(21),
	      r = n(22);
	    e.exports = function (e) {
	      return function (t, n) {
	        var o,
	          i,
	          s = String(r(t)),
	          c = a(n),
	          l = s.length;
	        return c < 0 || c >= l ? e ? "" : void 0 : (o = s.charCodeAt(c)) < 55296 || o > 56319 || c + 1 === l || (i = s.charCodeAt(c + 1)) < 56320 || i > 57343 ? e ? s.charAt(c) : o : e ? s.slice(c, c + 2) : i - 56320 + (o - 55296 << 10) + 65536;
	      };
	    };
	  }, function (e, t, n) {
	    var a = n(54);
	    e.exports = function (e, t, n) {
	      if (a(e), void 0 === t) return e;
	      switch (n) {
	        case 1:
	          return function (n) {
	            return e.call(t, n);
	          };
	        case 2:
	          return function (n, a) {
	            return e.call(t, n, a);
	          };
	        case 3:
	          return function (n, a, r) {
	            return e.call(t, n, a, r);
	          };
	      }
	      return function () {
	        return e.apply(t, arguments);
	      };
	    };
	  }, function (e, t) {
	    e.exports = function (e) {
	      if ("function" != typeof e) throw TypeError(e + " is not a function!");
	      return e;
	    };
	  }, function (e, t, n) {

	    var a = n(38),
	      r = n(16),
	      o = n(28),
	      i = {};
	    n(6)(i, n(2)("iterator"), function () {
	      return this;
	    }), e.exports = function (e, t, n) {
	      e.prototype = a(i, {
	        next: r(1, n)
	      }), o(e, t + " Iterator");
	    };
	  }, function (e, t, n) {
	    var a = n(7),
	      r = n(10),
	      o = n(13);
	    e.exports = n(4) ? Object.defineProperties : function (e, t) {
	      r(e);
	      for (var n, i = o(t), s = i.length, c = 0; s > c;) a.f(e, n = i[c++], t[n]);
	      return e;
	    };
	  }, function (e, t, n) {
	    var a = n(9),
	      r = n(58),
	      o = n(59);
	    e.exports = function (e) {
	      return function (t, n, i) {
	        var s,
	          c = a(t),
	          l = r(c.length),
	          u = o(i, l);
	        if (e && n != n) {
	          for (; l > u;) if ((s = c[u++]) != s) return !0;
	        } else for (; l > u; u++) if ((e || u in c) && c[u] === n) return e || u || 0;
	        return !e && -1;
	      };
	    };
	  }, function (e, t, n) {
	    var a = n(21),
	      r = Math.min;
	    e.exports = function (e) {
	      return e > 0 ? r(a(e), 9007199254740991) : 0;
	    };
	  }, function (e, t, n) {
	    var a = n(21),
	      r = Math.max,
	      o = Math.min;
	    e.exports = function (e, t) {
	      return (e = a(e)) < 0 ? r(e + t, 0) : o(e, t);
	    };
	  }, function (e, t, n) {
	    var a = n(3).document;
	    e.exports = a && a.documentElement;
	  }, function (e, t, n) {
	    var a = n(5),
	      r = n(18),
	      o = n(25)("IE_PROTO"),
	      i = Object.prototype;
	    e.exports = Object.getPrototypeOf || function (e) {
	      return e = r(e), a(e, o) ? e[o] : "function" == typeof e.constructor && e instanceof e.constructor ? e.constructor.prototype : e instanceof Object ? i : null;
	    };
	  }, function (e, t, n) {

	    var a = n(63),
	      r = n(64),
	      o = n(12),
	      i = n(9);
	    e.exports = n(34)(Array, "Array", function (e, t) {
	      this._t = i(e), this._i = 0, this._k = t;
	    }, function () {
	      var e = this._t,
	        t = this._k,
	        n = this._i++;
	      return !e || n >= e.length ? (this._t = void 0, r(1)) : r(0, "keys" == t ? n : "values" == t ? e[n] : [n, e[n]]);
	    }, "values"), o.Arguments = o.Array, a("keys"), a("values"), a("entries");
	  }, function (e, t) {
	    e.exports = function () {};
	  }, function (e, t) {
	    e.exports = function (e, t) {
	      return {
	        value: t,
	        done: !!e
	      };
	    };
	  }, function (e, t, n) {
	    e.exports = {
	      default: n(66),
	      __esModule: !0
	    };
	  }, function (e, t, n) {
	    n(67), n(73), n(74), n(75), e.exports = n(1).Symbol;
	  }, function (e, t, n) {

	    var a = n(3),
	      r = n(5),
	      o = n(4),
	      i = n(15),
	      s = n(37),
	      c = n(68).KEY,
	      l = n(8),
	      u = n(26),
	      f = n(28),
	      p = n(17),
	      d = n(2),
	      b = n(30),
	      h = n(31),
	      v = n(69),
	      m = n(70),
	      y = n(10),
	      g = n(11),
	      E = n(18),
	      j = n(9),
	      x = n(23),
	      _ = n(16),
	      k = n(38),
	      O = n(71),
	      C = n(72),
	      S = n(32),
	      w = n(7),
	      A = n(13),
	      M = C.f,
	      P = w.f,
	      F = O.f,
	      D = a.Symbol,
	      I = a.JSON,
	      R = I && I.stringify,
	      L = d("_hidden"),
	      B = d("toPrimitive"),
	      N = {}.propertyIsEnumerable,
	      z = u("symbol-registry"),
	      T = u("symbols"),
	      q = u("op-symbols"),
	      V = Object.prototype,
	      K = "function" == typeof D && !!S.f,
	      W = a.QObject,
	      H = !W || !W.prototype || !W.prototype.findChild,
	      U = o && l(function () {
	        return 7 != k(P({}, "a", {
	          get: function () {
	            return P(this, "a", {
	              value: 7
	            }).a;
	          }
	        })).a;
	      }) ? function (e, t, n) {
	        var a = M(V, t);
	        a && delete V[t], P(e, t, n), a && e !== V && P(V, t, a);
	      } : P,
	      G = function (e) {
	        var t = T[e] = k(D.prototype);
	        return t._k = e, t;
	      },
	      J = K && "symbol" == typeof D.iterator ? function (e) {
	        return "symbol" == typeof e;
	      } : function (e) {
	        return e instanceof D;
	      },
	      Y = function (e, t, n) {
	        return e === V && Y(q, t, n), y(e), t = x(t, !0), y(n), r(T, t) ? (n.enumerable ? (r(e, L) && e[L][t] && (e[L][t] = !1), n = k(n, {
	          enumerable: _(0, !1)
	        })) : (r(e, L) || P(e, L, _(1, {})), e[L][t] = !0), U(e, t, n)) : P(e, t, n);
	      },
	      $ = function (e, t) {
	        y(e);
	        for (var n, a = v(t = j(t)), r = 0, o = a.length; o > r;) Y(e, n = a[r++], t[n]);
	        return e;
	      },
	      Q = function (e) {
	        var t = N.call(this, e = x(e, !0));
	        return !(this === V && r(T, e) && !r(q, e)) && (!(t || !r(this, e) || !r(T, e) || r(this, L) && this[L][e]) || t);
	      },
	      Z = function (e, t) {
	        if (e = j(e), t = x(t, !0), e !== V || !r(T, t) || r(q, t)) {
	          var n = M(e, t);
	          return !n || !r(T, t) || r(e, L) && e[L][t] || (n.enumerable = !0), n;
	        }
	      },
	      X = function (e) {
	        for (var t, n = F(j(e)), a = [], o = 0; n.length > o;) r(T, t = n[o++]) || t == L || t == c || a.push(t);
	        return a;
	      },
	      ee = function (e) {
	        for (var t, n = e === V, a = F(n ? q : j(e)), o = [], i = 0; a.length > i;) !r(T, t = a[i++]) || n && !r(V, t) || o.push(T[t]);
	        return o;
	      };
	    K || (s((D = function () {
	      if (this instanceof D) throw TypeError("Symbol is not a constructor!");
	      var e = p(arguments.length > 0 ? arguments[0] : void 0),
	        t = function (n) {
	          this === V && t.call(q, n), r(this, L) && r(this[L], e) && (this[L][e] = !1), U(this, e, _(1, n));
	        };
	      return o && H && U(V, e, {
	        configurable: !0,
	        set: t
	      }), G(e);
	    }).prototype, "toString", function () {
	      return this._k;
	    }), C.f = Z, w.f = Y, n(41).f = O.f = X, n(19).f = Q, S.f = ee, o && !n(14) && s(V, "propertyIsEnumerable", Q, !0), b.f = function (e) {
	      return G(d(e));
	    }), i(i.G + i.W + i.F * !K, {
	      Symbol: D
	    });
	    for (var te = "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","), ne = 0; te.length > ne;) d(te[ne++]);
	    for (var ae = A(d.store), re = 0; ae.length > re;) h(ae[re++]);
	    i(i.S + i.F * !K, "Symbol", {
	      for: function (e) {
	        return r(z, e += "") ? z[e] : z[e] = D(e);
	      },
	      keyFor: function (e) {
	        if (!J(e)) throw TypeError(e + " is not a symbol!");
	        for (var t in z) if (z[t] === e) return t;
	      },
	      useSetter: function () {
	        H = !0;
	      },
	      useSimple: function () {
	        H = !1;
	      }
	    }), i(i.S + i.F * !K, "Object", {
	      create: function (e, t) {
	        return void 0 === t ? k(e) : $(k(e), t);
	      },
	      defineProperty: Y,
	      defineProperties: $,
	      getOwnPropertyDescriptor: Z,
	      getOwnPropertyNames: X,
	      getOwnPropertySymbols: ee
	    });
	    var oe = l(function () {
	      S.f(1);
	    });
	    i(i.S + i.F * oe, "Object", {
	      getOwnPropertySymbols: function (e) {
	        return S.f(E(e));
	      }
	    }), I && i(i.S + i.F * (!K || l(function () {
	      var e = D();
	      return "[null]" != R([e]) || "{}" != R({
	        a: e
	      }) || "{}" != R(Object(e));
	    })), "JSON", {
	      stringify: function (e) {
	        for (var t, n, a = [e], r = 1; arguments.length > r;) a.push(arguments[r++]);
	        if (n = t = a[1], (g(t) || void 0 !== e) && !J(e)) return m(t) || (t = function (e, t) {
	          if ("function" == typeof n && (t = n.call(this, e, t)), !J(t)) return t;
	        }), a[1] = t, R.apply(I, a);
	      }
	    }), D.prototype[B] || n(6)(D.prototype, B, D.prototype.valueOf), f(D, "Symbol"), f(Math, "Math", !0), f(a.JSON, "JSON", !0);
	  }, function (e, t, n) {
	    var a = n(17)("meta"),
	      r = n(11),
	      o = n(5),
	      i = n(7).f,
	      s = 0,
	      c = Object.isExtensible || function () {
	        return !0;
	      },
	      l = !n(8)(function () {
	        return c(Object.preventExtensions({}));
	      }),
	      u = function (e) {
	        i(e, a, {
	          value: {
	            i: "O" + ++s,
	            w: {}
	          }
	        });
	      },
	      f = e.exports = {
	        KEY: a,
	        NEED: !1,
	        fastKey: function (e, t) {
	          if (!r(e)) return "symbol" == typeof e ? e : ("string" == typeof e ? "S" : "P") + e;
	          if (!o(e, a)) {
	            if (!c(e)) return "F";
	            if (!t) return "E";
	            u(e);
	          }
	          return e[a].i;
	        },
	        getWeak: function (e, t) {
	          if (!o(e, a)) {
	            if (!c(e)) return !0;
	            if (!t) return !1;
	            u(e);
	          }
	          return e[a].w;
	        },
	        onFreeze: function (e) {
	          return l && f.NEED && c(e) && !o(e, a) && u(e), e;
	        }
	      };
	  }, function (e, t, n) {
	    var a = n(13),
	      r = n(32),
	      o = n(19);
	    e.exports = function (e) {
	      var t = a(e),
	        n = r.f;
	      if (n) for (var i, s = n(e), c = o.f, l = 0; s.length > l;) c.call(e, i = s[l++]) && t.push(i);
	      return t;
	    };
	  }, function (e, t, n) {
	    var a = n(24);
	    e.exports = Array.isArray || function (e) {
	      return "Array" == a(e);
	    };
	  }, function (e, t, n) {
	    var a = n(9),
	      r = n(41).f,
	      o = {}.toString,
	      i = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
	    e.exports.f = function (e) {
	      return i && "[object Window]" == o.call(e) ? function (e) {
	        try {
	          return r(e);
	        } catch (e) {
	          return i.slice();
	        }
	      }(e) : r(a(e));
	    };
	  }, function (e, t, n) {
	    var a = n(19),
	      r = n(16),
	      o = n(9),
	      i = n(23),
	      s = n(5),
	      c = n(35),
	      l = Object.getOwnPropertyDescriptor;
	    t.f = n(4) ? l : function (e, t) {
	      if (e = o(e), t = i(t, !0), c) try {
	        return l(e, t);
	      } catch (e) {}
	      if (s(e, t)) return r(!a.f.call(e, t), e[t]);
	    };
	  }, function (e, t) {}, function (e, t, n) {
	    n(31)("asyncIterator");
	  }, function (e, t, n) {
	    n(31)("observable");
	  }, function (e, t, n) {

	    t.__esModule = !0;
	    var a,
	      r = n(77),
	      o = (a = r) && a.__esModule ? a : {
	        default: a
	      };
	    t.default = o.default || function (e) {
	      for (var t = 1; t < arguments.length; t++) {
	        var n = arguments[t];
	        for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
	      }
	      return e;
	    };
	  }, function (e, t, n) {
	    e.exports = {
	      default: n(78),
	      __esModule: !0
	    };
	  }, function (e, t, n) {
	    n(79), e.exports = n(1).Object.assign;
	  }, function (e, t, n) {
	    var a = n(15);
	    a(a.S + a.F, "Object", {
	      assign: n(80)
	    });
	  }, function (e, t, n) {

	    var a = n(4),
	      r = n(13),
	      o = n(32),
	      i = n(19),
	      s = n(18),
	      c = n(40),
	      l = Object.assign;
	    e.exports = !l || n(8)(function () {
	      var e = {},
	        t = {},
	        n = Symbol(),
	        a = "abcdefghijklmnopqrst";
	      return e[n] = 7, a.split("").forEach(function (e) {
	        t[e] = e;
	      }), 7 != l({}, e)[n] || Object.keys(l({}, t)).join("") != a;
	    }) ? function (e, t) {
	      for (var n = s(e), l = arguments.length, u = 1, f = o.f, p = i.f; l > u;) for (var d, b = c(arguments[u++]), h = f ? r(b).concat(f(b)) : r(b), v = h.length, m = 0; v > m;) d = h[m++], a && !p.call(b, d) || (n[d] = b[d]);
	      return n;
	    } : l;
	  }, function (e, t, n) {

	    t.__esModule = !0;
	    var a = o(n(82)),
	      r = o(n(85));
	    function o(e) {
	      return e && e.__esModule ? e : {
	        default: e
	      };
	    }
	    t.default = function (e, t) {
	      if (Array.isArray(e)) return e;
	      if ((0, a.default)(Object(e))) return function (e, t) {
	        var n = [],
	          a = !0,
	          o = !1,
	          i = void 0;
	        try {
	          for (var s, c = (0, r.default)(e); !(a = (s = c.next()).done) && (n.push(s.value), !t || n.length !== t); a = !0);
	        } catch (e) {
	          o = !0, i = e;
	        } finally {
	          try {
	            !a && c.return && c.return();
	          } finally {
	            if (o) throw i;
	          }
	        }
	        return n;
	      }(e, t);
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    };
	  }, function (e, t, n) {
	    e.exports = {
	      default: n(83),
	      __esModule: !0
	    };
	  }, function (e, t, n) {
	    n(29), n(20), e.exports = n(84);
	  }, function (e, t, n) {
	    var a = n(42),
	      r = n(2)("iterator"),
	      o = n(12);
	    e.exports = n(1).isIterable = function (e) {
	      var t = Object(e);
	      return void 0 !== t[r] || "@@iterator" in t || o.hasOwnProperty(a(t));
	    };
	  }, function (e, t, n) {
	    e.exports = {
	      default: n(86),
	      __esModule: !0
	    };
	  }, function (e, t, n) {
	    n(29), n(20), e.exports = n(87);
	  }, function (e, t, n) {
	    var a = n(10),
	      r = n(88);
	    e.exports = n(1).getIterator = function (e) {
	      var t = r(e);
	      if ("function" != typeof t) throw TypeError(e + " is not iterable!");
	      return a(t.call(e));
	    };
	  }, function (e, t, n) {
	    var a = n(42),
	      r = n(2)("iterator"),
	      o = n(12);
	    e.exports = n(1).getIteratorMethod = function (e) {
	      if (null != e) return e[r] || e["@@iterator"] || o[a(e)];
	    };
	  }, function (e, t, n) {
	    e.exports = {
	      default: n(90),
	      __esModule: !0
	    };
	  }, function (e, t, n) {
	    n(91), e.exports = n(1).Object.keys;
	  }, function (e, t, n) {
	    var a = n(18),
	      r = n(13);
	    n(92)("keys", function () {
	      return function (e) {
	        return r(a(e));
	      };
	    });
	  }, function (e, t, n) {
	    var a = n(15),
	      r = n(1),
	      o = n(8);
	    e.exports = function (e, t) {
	      var n = (r.Object || {})[e] || Object[e],
	        i = {};
	      i[e] = t(n), a(a.S + a.F * o(function () {
	        n(1);
	      }), "Object", i);
	    };
	  }, function (e, t, n) {
	    (function (t) {
	      var n = [["ary", 128], ["bind", 1], ["bindKey", 2], ["curry", 8], ["curryRight", 16], ["flip", 512], ["partial", 32], ["partialRight", 64], ["rearg", 256]],
	        a = /^\s+|\s+$/g,
	        r = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	        o = /\{\n\/\* \[wrapped with (.+)\] \*/,
	        i = /,? & /,
	        s = /^[-+]0x[0-9a-f]+$/i,
	        c = /^0b[01]+$/i,
	        l = /^\[object .+?Constructor\]$/,
	        u = /^0o[0-7]+$/i,
	        f = /^(?:0|[1-9]\d*)$/,
	        p = parseInt,
	        d = "object" == typeof t && t && t.Object === Object && t,
	        b = "object" == typeof self && self && self.Object === Object && self,
	        h = d || b || Function("return this")();
	      function v(e, t, n) {
	        switch (n.length) {
	          case 0:
	            return e.call(t);
	          case 1:
	            return e.call(t, n[0]);
	          case 2:
	            return e.call(t, n[0], n[1]);
	          case 3:
	            return e.call(t, n[0], n[1], n[2]);
	        }
	        return e.apply(t, n);
	      }
	      function m(e, t) {
	        return !!(e ? e.length : 0) && function (e, t, n) {
	          if (t != t) return function (e, t, n, a) {
	            var r = e.length,
	              o = n + (a ? 1 : -1);
	            for (; a ? o-- : ++o < r;) if (t(e[o], o, e)) return o;
	            return -1;
	          }(e, y, n);
	          var a = n - 1,
	            r = e.length;
	          for (; ++a < r;) if (e[a] === t) return a;
	          return -1;
	        }(e, t, 0) > -1;
	      }
	      function y(e) {
	        return e != e;
	      }
	      function g(e, t) {
	        for (var n = e.length, a = 0; n--;) e[n] === t && a++;
	        return a;
	      }
	      function E(e, t) {
	        for (var n = -1, a = e.length, r = 0, o = []; ++n < a;) {
	          var i = e[n];
	          i !== t && "__lodash_placeholder__" !== i || (e[n] = "__lodash_placeholder__", o[r++] = n);
	        }
	        return o;
	      }
	      var j,
	        x,
	        _,
	        k = Function.prototype,
	        O = Object.prototype,
	        C = h["__core-js_shared__"],
	        S = (j = /[^.]+$/.exec(C && C.keys && C.keys.IE_PROTO || "")) ? "Symbol(src)_1." + j : "",
	        w = k.toString,
	        A = O.hasOwnProperty,
	        M = O.toString,
	        P = RegExp("^" + w.call(A).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
	        F = Object.create,
	        D = Math.max,
	        I = Math.min,
	        R = (x = H(Object, "defineProperty"), (_ = H.name) && _.length > 2 ? x : void 0);
	      function L(e) {
	        return X(e) ? F(e) : {};
	      }
	      function B(e) {
	        return !(!X(e) || function (e) {
	          return !!S && S in e;
	        }(e)) && (function (e) {
	          var t = X(e) ? M.call(e) : "";
	          return "[object Function]" == t || "[object GeneratorFunction]" == t;
	        }(e) || function (e) {
	          var t = !1;
	          if (null != e && "function" != typeof e.toString) try {
	            t = !!(e + "");
	          } catch (e) {}
	          return t;
	        }(e) ? P : l).test(function (e) {
	          if (null != e) {
	            try {
	              return w.call(e);
	            } catch (e) {}
	            try {
	              return e + "";
	            } catch (e) {}
	          }
	          return "";
	        }(e));
	      }
	      function N(e, t, n, a) {
	        for (var r = -1, o = e.length, i = n.length, s = -1, c = t.length, l = D(o - i, 0), u = Array(c + l), f = !a; ++s < c;) u[s] = t[s];
	        for (; ++r < i;) (f || r < o) && (u[n[r]] = e[r]);
	        for (; l--;) u[s++] = e[r++];
	        return u;
	      }
	      function z(e, t, n, a) {
	        for (var r = -1, o = e.length, i = -1, s = n.length, c = -1, l = t.length, u = D(o - s, 0), f = Array(u + l), p = !a; ++r < u;) f[r] = e[r];
	        for (var d = r; ++c < l;) f[d + c] = t[c];
	        for (; ++i < s;) (p || r < o) && (f[d + n[i]] = e[r++]);
	        return f;
	      }
	      function T(e) {
	        return function () {
	          var t = arguments;
	          switch (t.length) {
	            case 0:
	              return new e();
	            case 1:
	              return new e(t[0]);
	            case 2:
	              return new e(t[0], t[1]);
	            case 3:
	              return new e(t[0], t[1], t[2]);
	            case 4:
	              return new e(t[0], t[1], t[2], t[3]);
	            case 5:
	              return new e(t[0], t[1], t[2], t[3], t[4]);
	            case 6:
	              return new e(t[0], t[1], t[2], t[3], t[4], t[5]);
	            case 7:
	              return new e(t[0], t[1], t[2], t[3], t[4], t[5], t[6]);
	          }
	          var n = L(e.prototype),
	            a = e.apply(n, t);
	          return X(a) ? a : n;
	        };
	      }
	      function q(e, t, n, a, r, o, i, s, c, l) {
	        var u = 128 & t,
	          f = 1 & t,
	          p = 2 & t,
	          d = 24 & t,
	          b = 512 & t,
	          v = p ? void 0 : T(e);
	        return function m() {
	          for (var y = arguments.length, j = Array(y), x = y; x--;) j[x] = arguments[x];
	          if (d) var _ = W(m),
	            k = g(j, _);
	          if (a && (j = N(j, a, r, d)), o && (j = z(j, o, i, d)), y -= k, d && y < l) {
	            var O = E(j, _);
	            return V(e, t, q, m.placeholder, n, j, O, s, c, l - y);
	          }
	          var C = f ? n : this,
	            S = p ? C[e] : e;
	          return y = j.length, s ? j = Y(j, s) : b && y > 1 && j.reverse(), u && c < y && (j.length = c), this && this !== h && this instanceof m && (S = v || T(S)), S.apply(C, j);
	        };
	      }
	      function V(e, t, n, a, r, o, i, s, c, l) {
	        var u = 8 & t;
	        t |= u ? 32 : 64, 4 & (t &= ~(u ? 64 : 32)) || (t &= -4);
	        var f = n(e, t, r, u ? o : void 0, u ? i : void 0, u ? void 0 : o, u ? void 0 : i, s, c, l);
	        return f.placeholder = a, $(f, e, t);
	      }
	      function K(e, t, n, a, r, o, i, s) {
	        var c = 2 & t;
	        if (!c && "function" != typeof e) throw new TypeError("Expected a function");
	        var l = a ? a.length : 0;
	        if (l || (t &= -97, a = r = void 0), i = void 0 === i ? i : D(te(i), 0), s = void 0 === s ? s : te(s), l -= r ? r.length : 0, 64 & t) {
	          var u = a,
	            f = r;
	          a = r = void 0;
	        }
	        var p = [e, t, n, a, r, u, f, o, i, s];
	        if (e = p[0], t = p[1], n = p[2], a = p[3], r = p[4], !(s = p[9] = null == p[9] ? c ? 0 : e.length : D(p[9] - l, 0)) && 24 & t && (t &= -25), t && 1 != t) d = 8 == t || 16 == t ? function (e, t, n) {
	          var a = T(e);
	          return function r() {
	            for (var o = arguments.length, i = Array(o), s = o, c = W(r); s--;) i[s] = arguments[s];
	            var l = o < 3 && i[0] !== c && i[o - 1] !== c ? [] : E(i, c);
	            if ((o -= l.length) < n) return V(e, t, q, r.placeholder, void 0, i, l, void 0, void 0, n - o);
	            var u = this && this !== h && this instanceof r ? a : e;
	            return v(u, this, i);
	          };
	        }(e, t, s) : 32 != t && 33 != t || r.length ? q.apply(void 0, p) : function (e, t, n, a) {
	          var r = 1 & t,
	            o = T(e);
	          return function t() {
	            for (var i = -1, s = arguments.length, c = -1, l = a.length, u = Array(l + s), f = this && this !== h && this instanceof t ? o : e; ++c < l;) u[c] = a[c];
	            for (; s--;) u[c++] = arguments[++i];
	            return v(f, r ? n : this, u);
	          };
	        }(e, t, n, a);else var d = function (e, t, n) {
	          var a = 1 & t,
	            r = T(e);
	          return function t() {
	            var o = this && this !== h && this instanceof t ? r : e;
	            return o.apply(a ? n : this, arguments);
	          };
	        }(e, t, n);
	        return $(d, e, t);
	      }
	      function W(e) {
	        return e.placeholder;
	      }
	      function H(e, t) {
	        var n = function (e, t) {
	          return null == e ? void 0 : e[t];
	        }(e, t);
	        return B(n) ? n : void 0;
	      }
	      function U(e) {
	        var t = e.match(o);
	        return t ? t[1].split(i) : [];
	      }
	      function G(e, t) {
	        var n = t.length,
	          a = n - 1;
	        return t[a] = (n > 1 ? "& " : "") + t[a], t = t.join(n > 2 ? ", " : " "), e.replace(r, "{\n/* [wrapped with " + t + "] */\n");
	      }
	      function J(e, t) {
	        return !!(t = null == t ? 9007199254740991 : t) && ("number" == typeof e || f.test(e)) && e > -1 && e % 1 == 0 && e < t;
	      }
	      function Y(e, t) {
	        for (var n = e.length, a = I(t.length, n), r = function (e, t) {
	            var n = -1,
	              a = e.length;
	            for (t || (t = Array(a)); ++n < a;) t[n] = e[n];
	            return t;
	          }(e); a--;) {
	          var o = t[a];
	          e[a] = J(o, n) ? r[o] : void 0;
	        }
	        return e;
	      }
	      var $ = R ? function (e, t, n) {
	        var a,
	          r = t + "";
	        return R(e, "toString", {
	          configurable: !0,
	          enumerable: !1,
	          value: (a = G(r, Q(U(r), n)), function () {
	            return a;
	          })
	        });
	      } : function (e) {
	        return e;
	      };
	      function Q(e, t) {
	        return function (e, t) {
	          for (var n = -1, a = e ? e.length : 0; ++n < a && !1 !== t(e[n], n, e););
	        }(n, function (n) {
	          var a = "_." + n[0];
	          t & n[1] && !m(e, a) && e.push(a);
	        }), e.sort();
	      }
	      function Z(e, t, n) {
	        var a = K(e, 8, void 0, void 0, void 0, void 0, void 0, t = n ? void 0 : t);
	        return a.placeholder = Z.placeholder, a;
	      }
	      function X(e) {
	        var t = typeof e;
	        return !!e && ("object" == t || "function" == t);
	      }
	      function ee(e) {
	        return e ? (e = function (e) {
	          if ("number" == typeof e) return e;
	          if (function (e) {
	            return "symbol" == typeof e || function (e) {
	              return !!e && "object" == typeof e;
	            }(e) && "[object Symbol]" == M.call(e);
	          }(e)) return NaN;
	          if (X(e)) {
	            var t = "function" == typeof e.valueOf ? e.valueOf() : e;
	            e = X(t) ? t + "" : t;
	          }
	          if ("string" != typeof e) return 0 === e ? e : +e;
	          e = e.replace(a, "");
	          var n = c.test(e);
	          return n || u.test(e) ? p(e.slice(2), n ? 2 : 8) : s.test(e) ? NaN : +e;
	        }(e)) === 1 / 0 || e === -1 / 0 ? 17976931348623157e292 * (e < 0 ? -1 : 1) : e == e ? e : 0 : 0 === e ? e : 0;
	      }
	      function te(e) {
	        var t = ee(e),
	          n = t % 1;
	        return t == t ? n ? t - n : t : 0;
	      }
	      Z.placeholder = {}, e.exports = Z;
	    }).call(this, n(43));
	  }, function (e, t, n) {

	    function a(e) {
	      return e && e.__esModule ? e.default : e;
	    }
	    t.__esModule = !0;
	    var r = n(95);
	    t.threezerotwofour = a(r);
	    var o = n(96);
	    t.apathy = a(o);
	    var i = n(97);
	    t.ashes = a(i);
	    var s = n(98);
	    t.atelierDune = a(s);
	    var c = n(99);
	    t.atelierForest = a(c);
	    var l = n(100);
	    t.atelierHeath = a(l);
	    var u = n(101);
	    t.atelierLakeside = a(u);
	    var f = n(102);
	    t.atelierSeaside = a(f);
	    var p = n(103);
	    t.bespin = a(p);
	    var d = n(104);
	    t.brewer = a(d);
	    var b = n(105);
	    t.bright = a(b);
	    var h = n(106);
	    t.chalk = a(h);
	    var v = n(107);
	    t.codeschool = a(v);
	    var m = n(108);
	    t.colors = a(m);
	    var y = n(109);
	    t.default = a(y);
	    var g = n(110);
	    t.eighties = a(g);
	    var E = n(111);
	    t.embers = a(E);
	    var j = n(112);
	    t.flat = a(j);
	    var x = n(113);
	    t.google = a(x);
	    var _ = n(114);
	    t.grayscale = a(_);
	    var k = n(115);
	    t.greenscreen = a(k);
	    var O = n(116);
	    t.harmonic = a(O);
	    var C = n(117);
	    t.hopscotch = a(C);
	    var S = n(118);
	    t.isotope = a(S);
	    var w = n(119);
	    t.marrakesh = a(w);
	    var A = n(120);
	    t.mocha = a(A);
	    var M = n(121);
	    t.monokai = a(M);
	    var P = n(122);
	    t.ocean = a(P);
	    var F = n(123);
	    t.paraiso = a(F);
	    var D = n(124);
	    t.pop = a(D);
	    var I = n(125);
	    t.railscasts = a(I);
	    var R = n(126);
	    t.shapeshifter = a(R);
	    var L = n(127);
	    t.solarized = a(L);
	    var B = n(128);
	    t.summerfruit = a(B);
	    var N = n(129);
	    t.tomorrow = a(N);
	    var z = n(130);
	    t.tube = a(z);
	    var T = n(131);
	    t.twilight = a(T);
	  }, function (e, t, n) {

	    t.__esModule = !0, t.default = {
	      scheme: "threezerotwofour",
	      author: "jan t. sott (http://github.com/idleberg)",
	      base00: "#090300",
	      base01: "#3a3432",
	      base02: "#4a4543",
	      base03: "#5c5855",
	      base04: "#807d7c",
	      base05: "#a5a2a2",
	      base06: "#d6d5d4",
	      base07: "#f7f7f7",
	      base08: "#db2d20",
	      base09: "#e8bbd0",
	      base0A: "#fded02",
	      base0B: "#01a252",
	      base0C: "#b5e4f4",
	      base0D: "#01a0e4",
	      base0E: "#a16a94",
	      base0F: "#cdab53"
	    }, e.exports = t.default;
	  }, function (e, t, n) {

	    t.__esModule = !0, t.default = {
	      scheme: "apathy",
	      author: "jannik siebert (https://github.com/janniks)",
	      base00: "#031A16",
	      base01: "#0B342D",
	      base02: "#184E45",
	      base03: "#2B685E",
	      base04: "#5F9C92",
	      base05: "#81B5AC",
	      base06: "#A7CEC8",
	      base07: "#D2E7E4",
	      base08: "#3E9688",
	      base09: "#3E7996",
	      base0A: "#3E4C96",
	      base0B: "#883E96",
	      base0C: "#963E4C",
	      base0D: "#96883E",
	      base0E: "#4C963E",
	      base0F: "#3E965B"
	    }, e.exports = t.default;
	  }, function (e, t, n) {

	    t.__esModule = !0, t.default = {
	      scheme: "ashes",
	      author: "jannik siebert (https://github.com/janniks)",
	      base00: "#1C2023",
	      base01: "#393F45",
	      base02: "#565E65",
	      base03: "#747C84",
	      base04: "#ADB3BA",
	      base05: "#C7CCD1",
	      base06: "#DFE2E5",
	      base07: "#F3F4F5",
	      base08: "#C7AE95",
	      base09: "#C7C795",
	      base0A: "#AEC795",
	      base0B: "#95C7AE",
	      base0C: "#95AEC7",
	      base0D: "#AE95C7",
	      base0E: "#C795AE",
	      base0F: "#C79595"
	    }, e.exports = t.default;
	  }, function (e, t, n) {

	    t.__esModule = !0, t.default = {
	      scheme: "atelier dune",
	      author: "bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/dune)",
	      base00: "#20201d",
	      base01: "#292824",
	      base02: "#6e6b5e",
	      base03: "#7d7a68",
	      base04: "#999580",
	      base05: "#a6a28c",
	      base06: "#e8e4cf",
	      base07: "#fefbec",
	      base08: "#d73737",
	      base09: "#b65611",
	      base0A: "#cfb017",
	      base0B: "#60ac39",
	      base0C: "#1fad83",
	      base0D: "#6684e1",
	      base0E: "#b854d4",
	      base0F: "#d43552"
	    }, e.exports = t.default;
	  }, function (e, t, n) {

	    t.__esModule = !0, t.default = {
	      scheme: "atelier forest",
	      author: "bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/forest)",
	      base00: "#1b1918",
	      base01: "#2c2421",
	      base02: "#68615e",
	      base03: "#766e6b",
	      base04: "#9c9491",
	      base05: "#a8a19f",
	      base06: "#e6e2e0",
	      base07: "#f1efee",
	      base08: "#f22c40",
	      base09: "#df5320",
	      base0A: "#d5911a",
	      base0B: "#5ab738",
	      base0C: "#00ad9c",
	      base0D: "#407ee7",
	      base0E: "#6666ea",
	      base0F: "#c33ff3"
	    }, e.exports = t.default;
	  }, function (e, t, n) {

	    t.__esModule = !0, t.default = {
	      scheme: "atelier heath",
	      author: "bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/heath)",
	      base00: "#1b181b",
	      base01: "#292329",
	      base02: "#695d69",
	      base03: "#776977",
	      base04: "#9e8f9e",
	      base05: "#ab9bab",
	      base06: "#d8cad8",
	      base07: "#f7f3f7",
	      base08: "#ca402b",
	      base09: "#a65926",
	      base0A: "#bb8a35",
	      base0B: "#379a37",
	      base0C: "#159393",
	      base0D: "#516aec",
	      base0E: "#7b59c0",
	      base0F: "#cc33cc"
	    }, e.exports = t.default;
	  }, function (e, t, n) {

	    t.__esModule = !0, t.default = {
	      scheme: "atelier lakeside",
	      author: "bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/lakeside/)",
	      base00: "#161b1d",
	      base01: "#1f292e",
	      base02: "#516d7b",
	      base03: "#5a7b8c",
	      base04: "#7195a8",
	      base05: "#7ea2b4",
	      base06: "#c1e4f6",
	      base07: "#ebf8ff",
	      base08: "#d22d72",
	      base09: "#935c25",
	      base0A: "#8a8a0f",
	      base0B: "#568c3b",
	      base0C: "#2d8f6f",
	      base0D: "#257fad",
	      base0E: "#5d5db1",
	      base0F: "#b72dd2"
	    }, e.exports = t.default;
	  }, function (e, t, n) {

	    t.__esModule = !0, t.default = {
	      scheme: "atelier seaside",
	      author: "bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/seaside/)",
	      base00: "#131513",
	      base01: "#242924",
	      base02: "#5e6e5e",
	      base03: "#687d68",
	      base04: "#809980",
	      base05: "#8ca68c",
	      base06: "#cfe8cf",
	      base07: "#f0fff0",
	      base08: "#e6193c",
	      base09: "#87711d",
	      base0A: "#c3c322",
	      base0B: "#29a329",
	      base0C: "#1999b3",
	      base0D: "#3d62f5",
	      base0E: "#ad2bee",
	      base0F: "#e619c3"
	    }, e.exports = t.default;
	  }, function (e, t, n) {

	    t.__esModule = !0, t.default = {
	      scheme: "bespin",
	      author: "jan t. sott",
	      base00: "#28211c",
	      base01: "#36312e",
	      base02: "#5e5d5c",
	      base03: "#666666",
	      base04: "#797977",
	      base05: "#8a8986",
	      base06: "#9d9b97",
	      base07: "#baae9e",
	      base08: "#cf6a4c",
	      base09: "#cf7d34",
	      base0A: "#f9ee98",
	      base0B: "#54be0d",
	      base0C: "#afc4db",
	      base0D: "#5ea6ea",
	      base0E: "#9b859d",
	      base0F: "#937121"
	    }, e.exports = t.default;
	  }, function (e, t, n) {

	    t.__esModule = !0, t.default = {
	      scheme: "brewer",
	      author: "timothée poisot (http://github.com/tpoisot)",
	      base00: "#0c0d0e",
	      base01: "#2e2f30",
	      base02: "#515253",
	      base03: "#737475",
	      base04: "#959697",
	      base05: "#b7b8b9",
	      base06: "#dadbdc",
	      base07: "#fcfdfe",
	      base08: "#e31a1c",
	      base09: "#e6550d",
	      base0A: "#dca060",
	      base0B: "#31a354",
	      base0C: "#80b1d3",
	      base0D: "#3182bd",
	      base0E: "#756bb1",
	      base0F: "#b15928"
	    }, e.exports = t.default;
	  }, function (e, t, n) {

	    t.__esModule = !0, t.default = {
	      scheme: "bright",
	      author: "chris kempson (http://chriskempson.com)",
	      base00: "#000000",
	      base01: "#303030",
	      base02: "#505050",
	      base03: "#b0b0b0",
	      base04: "#d0d0d0",
	      base05: "#e0e0e0",
	      base06: "#f5f5f5",
	      base07: "#ffffff",
	      base08: "#fb0120",
	      base09: "#fc6d24",
	      base0A: "#fda331",
	      base0B: "#a1c659",
	      base0C: "#76c7b7",
	      base0D: "#6fb3d2",
	      base0E: "#d381c3",
	      base0F: "#be643c"
	    }, e.exports = t.default;
	  }, function (e, t, n) {

	    t.__esModule = !0, t.default = {
	      scheme: "chalk",
	      author: "chris kempson (http://chriskempson.com)",
	      base00: "#151515",
	      base01: "#202020",
	      base02: "#303030",
	      base03: "#505050",
	      base04: "#b0b0b0",
	      base05: "#d0d0d0",
	      base06: "#e0e0e0",
	      base07: "#f5f5f5",
	      base08: "#fb9fb1",
	      base09: "#eda987",
	      base0A: "#ddb26f",
	      base0B: "#acc267",
	      base0C: "#12cfc0",
	      base0D: "#6fc2ef",
	      base0E: "#e1a3ee",
	      base0F: "#deaf8f"
	    }, e.exports = t.default;
	  }, function (e, t, n) {

	    t.__esModule = !0, t.default = {
	      scheme: "codeschool",
	      author: "brettof86",
	      base00: "#232c31",
	      base01: "#1c3657",
	      base02: "#2a343a",
	      base03: "#3f4944",
	      base04: "#84898c",
	      base05: "#9ea7a6",
	      base06: "#a7cfa3",
	      base07: "#b5d8f6",
	      base08: "#2a5491",
	      base09: "#43820d",
	      base0A: "#a03b1e",
	      base0B: "#237986",
	      base0C: "#b02f30",
	      base0D: "#484d79",
	      base0E: "#c59820",
	      base0F: "#c98344"
	    }, e.exports = t.default;
	  }, function (e, t, n) {

	    t.__esModule = !0, t.default = {
	      scheme: "colors",
	      author: "mrmrs (http://clrs.cc)",
	      base00: "#111111",
	      base01: "#333333",
	      base02: "#555555",
	      base03: "#777777",
	      base04: "#999999",
	      base05: "#bbbbbb",
	      base06: "#dddddd",
	      base07: "#ffffff",
	      base08: "#ff4136",
	      base09: "#ff851b",
	      base0A: "#ffdc00",
	      base0B: "#2ecc40",
	      base0C: "#7fdbff",
	      base0D: "#0074d9",
	      base0E: "#b10dc9",
	      base0F: "#85144b"
	    }, e.exports = t.default;
	  }, function (e, t, n) {

	    t.__esModule = !0, t.default = {
	      scheme: "default",
	      author: "chris kempson (http://chriskempson.com)",
	      base00: "#181818",
	      base01: "#282828",
	      base02: "#383838",
	      base03: "#585858",
	      base04: "#b8b8b8",
	      base05: "#d8d8d8",
	      base06: "#e8e8e8",
	      base07: "#f8f8f8",
	      base08: "#ab4642",
	      base09: "#dc9656",
	      base0A: "#f7ca88",
	      base0B: "#a1b56c",
	      base0C: "#86c1b9",
	      base0D: "#7cafc2",
	      base0E: "#ba8baf",
	      base0F: "#a16946"
	    }, e.exports = t.default;
	  }, function (e, t, n) {

	    t.__esModule = !0, t.default = {
	      scheme: "eighties",
	      author: "chris kempson (http://chriskempson.com)",
	      base00: "#2d2d2d",
	      base01: "#393939",
	      base02: "#515151",
	      base03: "#747369",
	      base04: "#a09f93",
	      base05: "#d3d0c8",
	      base06: "#e8e6df",
	      base07: "#f2f0ec",
	      base08: "#f2777a",
	      base09: "#f99157",
	      base0A: "#ffcc66",
	      base0B: "#99cc99",
	      base0C: "#66cccc",
	      base0D: "#6699cc",
	      base0E: "#cc99cc",
	      base0F: "#d27b53"
	    }, e.exports = t.default;
	  }, function (e, t, n) {

	    t.__esModule = !0, t.default = {
	      scheme: "embers",
	      author: "jannik siebert (https://github.com/janniks)",
	      base00: "#16130F",
	      base01: "#2C2620",
	      base02: "#433B32",
	      base03: "#5A5047",
	      base04: "#8A8075",
	      base05: "#A39A90",
	      base06: "#BEB6AE",
	      base07: "#DBD6D1",
	      base08: "#826D57",
	      base09: "#828257",
	      base0A: "#6D8257",
	      base0B: "#57826D",
	      base0C: "#576D82",
	      base0D: "#6D5782",
	      base0E: "#82576D",
	      base0F: "#825757"
	    }, e.exports = t.default;
	  }, function (e, t, n) {

	    t.__esModule = !0, t.default = {
	      scheme: "flat",
	      author: "chris kempson (http://chriskempson.com)",
	      base00: "#2C3E50",
	      base01: "#34495E",
	      base02: "#7F8C8D",
	      base03: "#95A5A6",
	      base04: "#BDC3C7",
	      base05: "#e0e0e0",
	      base06: "#f5f5f5",
	      base07: "#ECF0F1",
	      base08: "#E74C3C",
	      base09: "#E67E22",
	      base0A: "#F1C40F",
	      base0B: "#2ECC71",
	      base0C: "#1ABC9C",
	      base0D: "#3498DB",
	      base0E: "#9B59B6",
	      base0F: "#be643c"
	    }, e.exports = t.default;
	  }, function (e, t, n) {

	    t.__esModule = !0, t.default = {
	      scheme: "google",
	      author: "seth wright (http://sethawright.com)",
	      base00: "#1d1f21",
	      base01: "#282a2e",
	      base02: "#373b41",
	      base03: "#969896",
	      base04: "#b4b7b4",
	      base05: "#c5c8c6",
	      base06: "#e0e0e0",
	      base07: "#ffffff",
	      base08: "#CC342B",
	      base09: "#F96A38",
	      base0A: "#FBA922",
	      base0B: "#198844",
	      base0C: "#3971ED",
	      base0D: "#3971ED",
	      base0E: "#A36AC7",
	      base0F: "#3971ED"
	    }, e.exports = t.default;
	  }, function (e, t, n) {

	    t.__esModule = !0, t.default = {
	      scheme: "grayscale",
	      author: "alexandre gavioli (https://github.com/alexx2/)",
	      base00: "#101010",
	      base01: "#252525",
	      base02: "#464646",
	      base03: "#525252",
	      base04: "#ababab",
	      base05: "#b9b9b9",
	      base06: "#e3e3e3",
	      base07: "#f7f7f7",
	      base08: "#7c7c7c",
	      base09: "#999999",
	      base0A: "#a0a0a0",
	      base0B: "#8e8e8e",
	      base0C: "#868686",
	      base0D: "#686868",
	      base0E: "#747474",
	      base0F: "#5e5e5e"
	    }, e.exports = t.default;
	  }, function (e, t, n) {

	    t.__esModule = !0, t.default = {
	      scheme: "green screen",
	      author: "chris kempson (http://chriskempson.com)",
	      base00: "#001100",
	      base01: "#003300",
	      base02: "#005500",
	      base03: "#007700",
	      base04: "#009900",
	      base05: "#00bb00",
	      base06: "#00dd00",
	      base07: "#00ff00",
	      base08: "#007700",
	      base09: "#009900",
	      base0A: "#007700",
	      base0B: "#00bb00",
	      base0C: "#005500",
	      base0D: "#009900",
	      base0E: "#00bb00",
	      base0F: "#005500"
	    }, e.exports = t.default;
	  }, function (e, t, n) {

	    t.__esModule = !0, t.default = {
	      scheme: "harmonic16",
	      author: "jannik siebert (https://github.com/janniks)",
	      base00: "#0b1c2c",
	      base01: "#223b54",
	      base02: "#405c79",
	      base03: "#627e99",
	      base04: "#aabcce",
	      base05: "#cbd6e2",
	      base06: "#e5ebf1",
	      base07: "#f7f9fb",
	      base08: "#bf8b56",
	      base09: "#bfbf56",
	      base0A: "#8bbf56",
	      base0B: "#56bf8b",
	      base0C: "#568bbf",
	      base0D: "#8b56bf",
	      base0E: "#bf568b",
	      base0F: "#bf5656"
	    }, e.exports = t.default;
	  }, function (e, t, n) {

	    t.__esModule = !0, t.default = {
	      scheme: "hopscotch",
	      author: "jan t. sott",
	      base00: "#322931",
	      base01: "#433b42",
	      base02: "#5c545b",
	      base03: "#797379",
	      base04: "#989498",
	      base05: "#b9b5b8",
	      base06: "#d5d3d5",
	      base07: "#ffffff",
	      base08: "#dd464c",
	      base09: "#fd8b19",
	      base0A: "#fdcc59",
	      base0B: "#8fc13e",
	      base0C: "#149b93",
	      base0D: "#1290bf",
	      base0E: "#c85e7c",
	      base0F: "#b33508"
	    }, e.exports = t.default;
	  }, function (e, t, n) {

	    t.__esModule = !0, t.default = {
	      scheme: "isotope",
	      author: "jan t. sott",
	      base00: "#000000",
	      base01: "#404040",
	      base02: "#606060",
	      base03: "#808080",
	      base04: "#c0c0c0",
	      base05: "#d0d0d0",
	      base06: "#e0e0e0",
	      base07: "#ffffff",
	      base08: "#ff0000",
	      base09: "#ff9900",
	      base0A: "#ff0099",
	      base0B: "#33ff00",
	      base0C: "#00ffff",
	      base0D: "#0066ff",
	      base0E: "#cc00ff",
	      base0F: "#3300ff"
	    }, e.exports = t.default;
	  }, function (e, t, n) {

	    t.__esModule = !0, t.default = {
	      scheme: "marrakesh",
	      author: "alexandre gavioli (http://github.com/alexx2/)",
	      base00: "#201602",
	      base01: "#302e00",
	      base02: "#5f5b17",
	      base03: "#6c6823",
	      base04: "#86813b",
	      base05: "#948e48",
	      base06: "#ccc37a",
	      base07: "#faf0a5",
	      base08: "#c35359",
	      base09: "#b36144",
	      base0A: "#a88339",
	      base0B: "#18974e",
	      base0C: "#75a738",
	      base0D: "#477ca1",
	      base0E: "#8868b3",
	      base0F: "#b3588e"
	    }, e.exports = t.default;
	  }, function (e, t, n) {

	    t.__esModule = !0, t.default = {
	      scheme: "mocha",
	      author: "chris kempson (http://chriskempson.com)",
	      base00: "#3B3228",
	      base01: "#534636",
	      base02: "#645240",
	      base03: "#7e705a",
	      base04: "#b8afad",
	      base05: "#d0c8c6",
	      base06: "#e9e1dd",
	      base07: "#f5eeeb",
	      base08: "#cb6077",
	      base09: "#d28b71",
	      base0A: "#f4bc87",
	      base0B: "#beb55b",
	      base0C: "#7bbda4",
	      base0D: "#8ab3b5",
	      base0E: "#a89bb9",
	      base0F: "#bb9584"
	    }, e.exports = t.default;
	  }, function (e, t, n) {

	    t.__esModule = !0, t.default = {
	      scheme: "monokai",
	      author: "wimer hazenberg (http://www.monokai.nl)",
	      base00: "#272822",
	      base01: "#383830",
	      base02: "#49483e",
	      base03: "#75715e",
	      base04: "#a59f85",
	      base05: "#f8f8f2",
	      base06: "#f5f4f1",
	      base07: "#f9f8f5",
	      base08: "#f92672",
	      base09: "#fd971f",
	      base0A: "#f4bf75",
	      base0B: "#a6e22e",
	      base0C: "#a1efe4",
	      base0D: "#66d9ef",
	      base0E: "#ae81ff",
	      base0F: "#cc6633"
	    }, e.exports = t.default;
	  }, function (e, t, n) {

	    t.__esModule = !0, t.default = {
	      scheme: "ocean",
	      author: "chris kempson (http://chriskempson.com)",
	      base00: "#2b303b",
	      base01: "#343d46",
	      base02: "#4f5b66",
	      base03: "#65737e",
	      base04: "#a7adba",
	      base05: "#c0c5ce",
	      base06: "#dfe1e8",
	      base07: "#eff1f5",
	      base08: "#bf616a",
	      base09: "#d08770",
	      base0A: "#ebcb8b",
	      base0B: "#a3be8c",
	      base0C: "#96b5b4",
	      base0D: "#8fa1b3",
	      base0E: "#b48ead",
	      base0F: "#ab7967"
	    }, e.exports = t.default;
	  }, function (e, t, n) {

	    t.__esModule = !0, t.default = {
	      scheme: "paraiso",
	      author: "jan t. sott",
	      base00: "#2f1e2e",
	      base01: "#41323f",
	      base02: "#4f424c",
	      base03: "#776e71",
	      base04: "#8d8687",
	      base05: "#a39e9b",
	      base06: "#b9b6b0",
	      base07: "#e7e9db",
	      base08: "#ef6155",
	      base09: "#f99b15",
	      base0A: "#fec418",
	      base0B: "#48b685",
	      base0C: "#5bc4bf",
	      base0D: "#06b6ef",
	      base0E: "#815ba4",
	      base0F: "#e96ba8"
	    }, e.exports = t.default;
	  }, function (e, t, n) {

	    t.__esModule = !0, t.default = {
	      scheme: "pop",
	      author: "chris kempson (http://chriskempson.com)",
	      base00: "#000000",
	      base01: "#202020",
	      base02: "#303030",
	      base03: "#505050",
	      base04: "#b0b0b0",
	      base05: "#d0d0d0",
	      base06: "#e0e0e0",
	      base07: "#ffffff",
	      base08: "#eb008a",
	      base09: "#f29333",
	      base0A: "#f8ca12",
	      base0B: "#37b349",
	      base0C: "#00aabb",
	      base0D: "#0e5a94",
	      base0E: "#b31e8d",
	      base0F: "#7a2d00"
	    }, e.exports = t.default;
	  }, function (e, t, n) {

	    t.__esModule = !0, t.default = {
	      scheme: "railscasts",
	      author: "ryan bates (http://railscasts.com)",
	      base00: "#2b2b2b",
	      base01: "#272935",
	      base02: "#3a4055",
	      base03: "#5a647e",
	      base04: "#d4cfc9",
	      base05: "#e6e1dc",
	      base06: "#f4f1ed",
	      base07: "#f9f7f3",
	      base08: "#da4939",
	      base09: "#cc7833",
	      base0A: "#ffc66d",
	      base0B: "#a5c261",
	      base0C: "#519f50",
	      base0D: "#6d9cbe",
	      base0E: "#b6b3eb",
	      base0F: "#bc9458"
	    }, e.exports = t.default;
	  }, function (e, t, n) {

	    t.__esModule = !0, t.default = {
	      scheme: "shapeshifter",
	      author: "tyler benziger (http://tybenz.com)",
	      base00: "#000000",
	      base01: "#040404",
	      base02: "#102015",
	      base03: "#343434",
	      base04: "#555555",
	      base05: "#ababab",
	      base06: "#e0e0e0",
	      base07: "#f9f9f9",
	      base08: "#e92f2f",
	      base09: "#e09448",
	      base0A: "#dddd13",
	      base0B: "#0ed839",
	      base0C: "#23edda",
	      base0D: "#3b48e3",
	      base0E: "#f996e2",
	      base0F: "#69542d"
	    }, e.exports = t.default;
	  }, function (e, t, n) {

	    t.__esModule = !0, t.default = {
	      scheme: "solarized",
	      author: "ethan schoonover (http://ethanschoonover.com/solarized)",
	      base00: "#002b36",
	      base01: "#073642",
	      base02: "#586e75",
	      base03: "#657b83",
	      base04: "#839496",
	      base05: "#93a1a1",
	      base06: "#eee8d5",
	      base07: "#fdf6e3",
	      base08: "#dc322f",
	      base09: "#cb4b16",
	      base0A: "#b58900",
	      base0B: "#859900",
	      base0C: "#2aa198",
	      base0D: "#268bd2",
	      base0E: "#6c71c4",
	      base0F: "#d33682"
	    }, e.exports = t.default;
	  }, function (e, t, n) {

	    t.__esModule = !0, t.default = {
	      scheme: "summerfruit",
	      author: "christopher corley (http://cscorley.github.io/)",
	      base00: "#151515",
	      base01: "#202020",
	      base02: "#303030",
	      base03: "#505050",
	      base04: "#B0B0B0",
	      base05: "#D0D0D0",
	      base06: "#E0E0E0",
	      base07: "#FFFFFF",
	      base08: "#FF0086",
	      base09: "#FD8900",
	      base0A: "#ABA800",
	      base0B: "#00C918",
	      base0C: "#1faaaa",
	      base0D: "#3777E6",
	      base0E: "#AD00A1",
	      base0F: "#cc6633"
	    }, e.exports = t.default;
	  }, function (e, t, n) {

	    t.__esModule = !0, t.default = {
	      scheme: "tomorrow",
	      author: "chris kempson (http://chriskempson.com)",
	      base00: "#1d1f21",
	      base01: "#282a2e",
	      base02: "#373b41",
	      base03: "#969896",
	      base04: "#b4b7b4",
	      base05: "#c5c8c6",
	      base06: "#e0e0e0",
	      base07: "#ffffff",
	      base08: "#cc6666",
	      base09: "#de935f",
	      base0A: "#f0c674",
	      base0B: "#b5bd68",
	      base0C: "#8abeb7",
	      base0D: "#81a2be",
	      base0E: "#b294bb",
	      base0F: "#a3685a"
	    }, e.exports = t.default;
	  }, function (e, t, n) {

	    t.__esModule = !0, t.default = {
	      scheme: "london tube",
	      author: "jan t. sott",
	      base00: "#231f20",
	      base01: "#1c3f95",
	      base02: "#5a5758",
	      base03: "#737171",
	      base04: "#959ca1",
	      base05: "#d9d8d8",
	      base06: "#e7e7e8",
	      base07: "#ffffff",
	      base08: "#ee2e24",
	      base09: "#f386a1",
	      base0A: "#ffd204",
	      base0B: "#00853e",
	      base0C: "#85cebc",
	      base0D: "#009ddc",
	      base0E: "#98005d",
	      base0F: "#b06110"
	    }, e.exports = t.default;
	  }, function (e, t, n) {

	    t.__esModule = !0, t.default = {
	      scheme: "twilight",
	      author: "david hart (http://hart-dev.com)",
	      base00: "#1e1e1e",
	      base01: "#323537",
	      base02: "#464b50",
	      base03: "#5f5a60",
	      base04: "#838184",
	      base05: "#a7a7a7",
	      base06: "#c3c3c3",
	      base07: "#ffffff",
	      base08: "#cf6a4c",
	      base09: "#cda869",
	      base0A: "#f9ee98",
	      base0B: "#8f9d6a",
	      base0C: "#afc4db",
	      base0D: "#7587a6",
	      base0E: "#9b859d",
	      base0F: "#9b703f"
	    }, e.exports = t.default;
	  }, function (e, t, n) {
	    var a = n(33);
	    function r(e) {
	      var t = Math.round(a(e, 0, 255)).toString(16);
	      return 1 == t.length ? "0" + t : t;
	    }
	    e.exports = function (e) {
	      var t = 4 === e.length ? r(255 * e[3]) : "";
	      return "#" + r(e[0]) + r(e[1]) + r(e[2]) + t;
	    };
	  }, function (e, t, n) {
	    var a = n(134),
	      r = n(135),
	      o = n(136),
	      i = n(137);
	    var s = {
	      "#": r,
	      hsl: function (e) {
	        var t = a(e),
	          n = i(t);
	        return 4 === t.length && n.push(t[3]), n;
	      },
	      rgb: o
	    };
	    function c(e) {
	      for (var t in s) if (0 === e.indexOf(t)) return s[t](e);
	    }
	    c.rgb = o, c.hsl = a, c.hex = r, e.exports = c;
	  }, function (e, t, n) {
	    var a = n(44),
	      r = n(33);
	    function o(e, t) {
	      switch (e = parseFloat(e), t) {
	        case 0:
	          return r(e, 0, 360);
	        case 1:
	        case 2:
	          return r(e, 0, 100);
	        case 3:
	          return r(e, 0, 1);
	      }
	    }
	    e.exports = function (e) {
	      return a(e).map(o);
	    };
	  }, function (e, t) {
	    e.exports = function (e) {
	      4 !== e.length && 5 !== e.length || (e = function (e) {
	        for (var t = "#", n = 1; n < e.length; n++) {
	          var a = e.charAt(n);
	          t += a + a;
	        }
	        return t;
	      }(e));
	      var t = [parseInt(e.substring(1, 3), 16), parseInt(e.substring(3, 5), 16), parseInt(e.substring(5, 7), 16)];
	      if (9 === e.length) {
	        var n = parseFloat((parseInt(e.substring(7, 9), 16) / 255).toFixed(2));
	        t.push(n);
	      }
	      return t;
	    };
	  }, function (e, t, n) {
	    var a = n(44),
	      r = n(33);
	    function o(e, t) {
	      return t < 3 ? -1 != e.indexOf("%") ? Math.round(255 * r(parseInt(e, 10), 0, 100) / 100) : r(parseInt(e, 10), 0, 255) : r(parseFloat(e), 0, 1);
	    }
	    e.exports = function (e) {
	      return a(e).map(o);
	    };
	  }, function (e, t) {
	    e.exports = function (e) {
	      var t,
	        n,
	        a,
	        r,
	        o,
	        i = e[0] / 360,
	        s = e[1] / 100,
	        c = e[2] / 100;
	      if (0 == s) return [o = 255 * c, o, o];
	      t = 2 * c - (n = c < .5 ? c * (1 + s) : c + s - c * s), r = [0, 0, 0];
	      for (var l = 0; l < 3; l++) (a = i + 1 / 3 * -(l - 1)) < 0 && a++, a > 1 && a--, o = 6 * a < 1 ? t + 6 * (n - t) * a : 2 * a < 1 ? n : 3 * a < 2 ? t + (n - t) * (2 / 3 - a) * 6 : t, r[l] = 255 * o;
	      return r;
	    };
	  }, function (e, t, n) {
	    (function (t) {
	      var n = "object" == typeof t && t && t.Object === Object && t,
	        a = "object" == typeof self && self && self.Object === Object && self,
	        r = n || a || Function("return this")();
	      function o(e, t, n) {
	        switch (n.length) {
	          case 0:
	            return e.call(t);
	          case 1:
	            return e.call(t, n[0]);
	          case 2:
	            return e.call(t, n[0], n[1]);
	          case 3:
	            return e.call(t, n[0], n[1], n[2]);
	        }
	        return e.apply(t, n);
	      }
	      function i(e, t) {
	        for (var n = -1, a = t.length, r = e.length; ++n < a;) e[r + n] = t[n];
	        return e;
	      }
	      var s = Object.prototype,
	        c = s.hasOwnProperty,
	        l = s.toString,
	        u = r.Symbol,
	        f = s.propertyIsEnumerable,
	        p = u ? u.isConcatSpreadable : void 0,
	        d = Math.max;
	      function b(e) {
	        return h(e) || function (e) {
	          return function (e) {
	            return function (e) {
	              return !!e && "object" == typeof e;
	            }(e) && function (e) {
	              return null != e && function (e) {
	                return "number" == typeof e && e > -1 && e % 1 == 0 && e <= 9007199254740991;
	              }(e.length) && !function (e) {
	                var t = function (e) {
	                  var t = typeof e;
	                  return !!e && ("object" == t || "function" == t);
	                }(e) ? l.call(e) : "";
	                return "[object Function]" == t || "[object GeneratorFunction]" == t;
	              }(e);
	            }(e);
	          }(e) && c.call(e, "callee") && (!f.call(e, "callee") || "[object Arguments]" == l.call(e));
	        }(e) || !!(p && e && e[p]);
	      }
	      var h = Array.isArray;
	      var v,
	        m,
	        y,
	        g = (m = function (e) {
	          var t = (e = function e(t, n, a, r, o) {
	              var s = -1,
	                c = t.length;
	              for (a || (a = b), o || (o = []); ++s < c;) {
	                var l = t[s];
	                n > 0 && a(l) ? n > 1 ? e(l, n - 1, a, r, o) : i(o, l) : r || (o[o.length] = l);
	              }
	              return o;
	            }(e, 1)).length,
	            n = t;
	          for (v ; n--;) if ("function" != typeof e[n]) throw new TypeError("Expected a function");
	          return function () {
	            for (var n = 0, a = t ? e[n].apply(this, arguments) : arguments[0]; ++n < t;) a = e[n].call(this, a);
	            return a;
	          };
	        }, y = d(void 0 === y ? m.length - 1 : y, 0), function () {
	          for (var e = arguments, t = -1, n = d(e.length - y, 0), a = Array(n); ++t < n;) a[t] = e[y + t];
	          t = -1;
	          for (var r = Array(y + 1); ++t < y;) r[t] = e[t];
	          return r[y] = a, o(m, this, r);
	        });
	      e.exports = g;
	    }).call(this, n(43));
	  }, function (e, t, n) {

	    Object.defineProperty(t, "__esModule", {
	      value: !0
	    }), t.yuv2rgb = function (e) {
	      var t,
	        n,
	        a,
	        r = e[0],
	        o = e[1],
	        i = e[2];
	      return t = 1 * r + 0 * o + 1.13983 * i, n = 1 * r + -.39465 * o + -.5806 * i, a = 1 * r + 2.02311 * o + 0 * i, t = Math.min(Math.max(0, t), 1), n = Math.min(Math.max(0, n), 1), a = Math.min(Math.max(0, a), 1), [255 * t, 255 * n, 255 * a];
	    }, t.rgb2yuv = function (e) {
	      var t = e[0] / 255,
	        n = e[1] / 255,
	        a = e[2] / 255;
	      return [.299 * t + .587 * n + .114 * a, -.14713 * t + -.28886 * n + .436 * a, .615 * t + -.51499 * n + -.10001 * a];
	    };
	  }, function (e, t, n) {

	    function a(e, t, n) {
	      return t in e ? Object.defineProperty(e, t, {
	        value: n,
	        enumerable: !0,
	        configurable: !0,
	        writable: !0
	      }) : e[t] = n, e;
	    }
	    var r = n(141),
	      o = function () {
	        function e() {
	          a(this, "_callbacks", void 0), a(this, "_isDispatching", void 0), a(this, "_isHandled", void 0), a(this, "_isPending", void 0), a(this, "_lastID", void 0), a(this, "_pendingPayload", void 0), this._callbacks = {}, this._isDispatching = !1, this._isHandled = {}, this._isPending = {}, this._lastID = 1;
	        }
	        var t = e.prototype;
	        return t.register = function (e) {
	          var t = "ID_" + this._lastID++;
	          return this._callbacks[t] = e, t;
	        }, t.unregister = function (e) {
	          this._callbacks[e] || r(!1), delete this._callbacks[e];
	        }, t.waitFor = function (e) {
	          this._isDispatching || r(!1);
	          for (var t = 0; t < e.length; t++) {
	            var n = e[t];
	            this._isPending[n] ? this._isHandled[n] || r(!1) : (this._callbacks[n] || r(!1), this._invokeCallback(n));
	          }
	        }, t.dispatch = function (e) {
	          this._isDispatching && r(!1), this._startDispatching(e);
	          try {
	            for (var t in this._callbacks) this._isPending[t] || this._invokeCallback(t);
	          } finally {
	            this._stopDispatching();
	          }
	        }, t.isDispatching = function () {
	          return this._isDispatching;
	        }, t._invokeCallback = function (e) {
	          this._isPending[e] = !0, this._callbacks[e](this._pendingPayload), this._isHandled[e] = !0;
	        }, t._startDispatching = function (e) {
	          for (var t in this._callbacks) this._isPending[t] = !1, this._isHandled[t] = !1;
	          this._pendingPayload = e, this._isDispatching = !0;
	        }, t._stopDispatching = function () {
	          delete this._pendingPayload, this._isDispatching = !1;
	        }, e;
	      }();
	    e.exports = o;
	  }, function (e, t, n) {
	    e.exports = function (e, t) {
	      for (var n = arguments.length, r = new Array(n > 2 ? n - 2 : 0), o = 2; o < n; o++) r[o - 2] = arguments[o];
	      if (!e) {
	        var i;
	        if (void 0 === t) i = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
	          var s = 0;
	          (i = new Error(t.replace(/%s/g, function () {
	            return String(r[s++]);
	          }))).name = "Invariant Violation";
	        }
	        throw i.framesToPop = 1, i;
	      }
	    };
	  }, function (e, t, n) {

	    function a(e, t, n) {
	      return t in e ? Object.defineProperty(e, t, {
	        value: n,
	        enumerable: !0,
	        configurable: !0,
	        writable: !0
	      }) : e[t] = n, e;
	    }
	    function r(e, t) {
	      var n = Object.keys(e);
	      if (Object.getOwnPropertySymbols) {
	        var a = Object.getOwnPropertySymbols(e);
	        t && (a = a.filter(function (t) {
	          return Object.getOwnPropertyDescriptor(e, t).enumerable;
	        })), n.push.apply(n, a);
	      }
	      return n;
	    }
	    function o(e) {
	      for (var t = 1; t < arguments.length; t++) {
	        var n = null != arguments[t] ? arguments[t] : {};
	        t % 2 ? r(Object(n), !0).forEach(function (t) {
	          a(e, t, n[t]);
	        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : r(Object(n)).forEach(function (t) {
	          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
	        });
	      }
	      return e;
	    }
	    function i(e, t) {
	      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
	    }
	    function s(e, t) {
	      for (var n = 0; n < t.length; n++) {
	        var a = t[n];
	        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
	      }
	    }
	    function c(e, t, n) {
	      return t && s(e.prototype, t), n && s(e, n), e;
	    }
	    function l(e, t) {
	      return (l = Object.setPrototypeOf || function (e, t) {
	        return e.__proto__ = t, e;
	      })(e, t);
	    }
	    function u(e, t) {
	      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
	      e.prototype = Object.create(t && t.prototype, {
	        constructor: {
	          value: e,
	          writable: !0,
	          configurable: !0
	        }
	      }), t && l(e, t);
	    }
	    function f(e) {
	      return (f = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
	        return e.__proto__ || Object.getPrototypeOf(e);
	      })(e);
	    }
	    function p(e) {
	      return (p = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
	        return typeof e;
	      } : function (e) {
	        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
	      })(e);
	    }
	    function d(e) {
	      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	      return e;
	    }
	    function b(e, t) {
	      return !t || "object" !== p(t) && "function" != typeof t ? d(e) : t;
	    }
	    function h(e) {
	      var t = function () {
	        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
	        if (Reflect.construct.sham) return !1;
	        if ("function" == typeof Proxy) return !0;
	        try {
	          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
	        } catch (e) {
	          return !1;
	        }
	      }();
	      return function () {
	        var n,
	          a = f(e);
	        if (t) {
	          var r = f(this).constructor;
	          n = Reflect.construct(a, arguments, r);
	        } else n = a.apply(this, arguments);
	        return b(this, n);
	      };
	    }
	    n.r(t);
	    var v = n(0),
	      m = n.n(v);
	    function y() {
	      var e = this.constructor.getDerivedStateFromProps(this.props, this.state);
	      null != e && this.setState(e);
	    }
	    function g(e) {
	      this.setState(function (t) {
	        var n = this.constructor.getDerivedStateFromProps(e, t);
	        return null != n ? n : null;
	      }.bind(this));
	    }
	    function E(e, t) {
	      try {
	        var n = this.props,
	          a = this.state;
	        this.props = e, this.state = t, this.__reactInternalSnapshotFlag = !0, this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(n, a);
	      } finally {
	        this.props = n, this.state = a;
	      }
	    }
	    function j(e) {
	      var t = e.prototype;
	      if (!t || !t.isReactComponent) throw new Error("Can only polyfill class components");
	      if ("function" != typeof e.getDerivedStateFromProps && "function" != typeof t.getSnapshotBeforeUpdate) return e;
	      var n = null,
	        a = null,
	        r = null;
	      if ("function" == typeof t.componentWillMount ? n = "componentWillMount" : "function" == typeof t.UNSAFE_componentWillMount && (n = "UNSAFE_componentWillMount"), "function" == typeof t.componentWillReceiveProps ? a = "componentWillReceiveProps" : "function" == typeof t.UNSAFE_componentWillReceiveProps && (a = "UNSAFE_componentWillReceiveProps"), "function" == typeof t.componentWillUpdate ? r = "componentWillUpdate" : "function" == typeof t.UNSAFE_componentWillUpdate && (r = "UNSAFE_componentWillUpdate"), null !== n || null !== a || null !== r) {
	        var o = e.displayName || e.name,
	          i = "function" == typeof e.getDerivedStateFromProps ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
	        throw Error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n" + o + " uses " + i + " but also contains the following legacy lifecycles:" + (null !== n ? "\n  " + n : "") + (null !== a ? "\n  " + a : "") + (null !== r ? "\n  " + r : "") + "\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://fb.me/react-async-component-lifecycle-hooks");
	      }
	      if ("function" == typeof e.getDerivedStateFromProps && (t.componentWillMount = y, t.componentWillReceiveProps = g), "function" == typeof t.getSnapshotBeforeUpdate) {
	        if ("function" != typeof t.componentDidUpdate) throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");
	        t.componentWillUpdate = E;
	        var s = t.componentDidUpdate;
	        t.componentDidUpdate = function (e, t, n) {
	          var a = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : n;
	          s.call(this, e, t, a);
	        };
	      }
	      return e;
	    }
	    function x(e, t) {
	      if (null == e) return {};
	      var n,
	        a,
	        r = function (e, t) {
	          if (null == e) return {};
	          var n,
	            a,
	            r = {},
	            o = Object.keys(e);
	          for (a = 0; a < o.length; a++) n = o[a], t.indexOf(n) >= 0 || (r[n] = e[n]);
	          return r;
	        }(e, t);
	      if (Object.getOwnPropertySymbols) {
	        var o = Object.getOwnPropertySymbols(e);
	        for (a = 0; a < o.length; a++) n = o[a], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
	      }
	      return r;
	    }
	    function _(e) {
	      var t = function (e) {
	        return {}.toString.call(e).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
	      }(e);
	      return "number" === t && (t = isNaN(e) ? "nan" : (0 | e) != e ? "float" : "integer"), t;
	    }
	    y.__suppressDeprecationWarning = !0, g.__suppressDeprecationWarning = !0, E.__suppressDeprecationWarning = !0;
	    var k = {
	        scheme: "rjv-default",
	        author: "mac gainor",
	        base00: "rgba(0, 0, 0, 0)",
	        base01: "rgb(245, 245, 245)",
	        base02: "rgb(235, 235, 235)",
	        base03: "#93a1a1",
	        base04: "rgba(0, 0, 0, 0.3)",
	        base05: "#586e75",
	        base06: "#073642",
	        base07: "#002b36",
	        base08: "#d33682",
	        base09: "#cb4b16",
	        base0A: "#dc322f",
	        base0B: "#859900",
	        base0C: "#6c71c4",
	        base0D: "#586e75",
	        base0E: "#2aa198",
	        base0F: "#268bd2"
	      },
	      O = {
	        scheme: "rjv-grey",
	        author: "mac gainor",
	        base00: "rgba(1, 1, 1, 0)",
	        base01: "rgba(1, 1, 1, 0.1)",
	        base02: "rgba(0, 0, 0, 0.2)",
	        base03: "rgba(1, 1, 1, 0.3)",
	        base04: "rgba(0, 0, 0, 0.4)",
	        base05: "rgba(1, 1, 1, 0.5)",
	        base06: "rgba(1, 1, 1, 0.6)",
	        base07: "rgba(1, 1, 1, 0.7)",
	        base08: "rgba(1, 1, 1, 0.8)",
	        base09: "rgba(1, 1, 1, 0.8)",
	        base0A: "rgba(1, 1, 1, 0.8)",
	        base0B: "rgba(1, 1, 1, 0.8)",
	        base0C: "rgba(1, 1, 1, 0.8)",
	        base0D: "rgba(1, 1, 1, 0.8)",
	        base0E: "rgba(1, 1, 1, 0.8)",
	        base0F: "rgba(1, 1, 1, 0.8)"
	      },
	      C = {
	        white: "#fff",
	        black: "#000",
	        transparent: "rgba(1, 1, 1, 0)",
	        globalFontFamily: "monospace",
	        globalCursor: "default",
	        indentBlockWidth: "5px",
	        braceFontWeight: "bold",
	        braceCursor: "pointer",
	        ellipsisFontSize: "18px",
	        ellipsisLineHeight: "10px",
	        ellipsisCursor: "pointer",
	        keyMargin: "0px 5px",
	        keyLetterSpacing: "0.5px",
	        keyFontStyle: "none",
	        keyBorderRadius: "3px",
	        keyColonWeight: "bold",
	        keyVerticalAlign: "top",
	        keyOpacity: "0.85",
	        keyOpacityHover: "1",
	        keyValPaddingTop: "3px",
	        keyValPaddingBottom: "3px",
	        keyValPaddingRight: "5px",
	        keyValBorderLeft: "1px solid",
	        keyValBorderHover: "2px solid",
	        keyValPaddingHover: "3px 5px 3px 4px",
	        pushedContentMarginLeft: "6px",
	        variableValuePaddingRight: "6px",
	        nullFontSize: "11px",
	        nullFontWeight: "bold",
	        nullPadding: "1px 2px",
	        nullBorderRadius: "3px",
	        nanFontSize: "11px",
	        nanFontWeight: "bold",
	        nanPadding: "1px 2px",
	        nanBorderRadius: "3px",
	        undefinedFontSize: "11px",
	        undefinedFontWeight: "bold",
	        undefinedPadding: "1px 2px",
	        undefinedBorderRadius: "3px",
	        dataTypeFontSize: "11px",
	        dataTypeMarginRight: "4px",
	        datatypeOpacity: "0.8",
	        objectSizeBorderRadius: "3px",
	        objectSizeFontStyle: "italic",
	        objectSizeMargin: "0px 6px 0px 0px",
	        clipboardCursor: "pointer",
	        clipboardCheckMarginLeft: "-12px",
	        metaDataPadding: "0px 0px 0px 10px",
	        arrayGroupMetaPadding: "0px 0px 0px 4px",
	        iconContainerWidth: "17px",
	        tooltipPadding: "4px",
	        editInputMinWidth: "130px",
	        editInputBorderRadius: "2px",
	        editInputPadding: "5px",
	        editInputMarginRight: "4px",
	        editInputFontFamily: "monospace",
	        iconCursor: "pointer",
	        iconFontSize: "15px",
	        iconPaddingRight: "1px",
	        dateValueMarginLeft: "2px",
	        iconMarginRight: "3px",
	        detectedRowPaddingTop: "3px",
	        addKeyCoverBackground: "rgba(255, 255, 255, 0.3)",
	        addKeyCoverPosition: "absolute",
	        addKeyCoverPositionPx: "0px",
	        addKeyModalWidth: "200px",
	        addKeyModalMargin: "auto",
	        addKeyModalPadding: "10px",
	        addKeyModalRadius: "3px"
	      },
	      S = n(45),
	      w = function (e) {
	        var t = function (e) {
	          return {
	            backgroundColor: e.base00,
	            ellipsisColor: e.base09,
	            braceColor: e.base07,
	            expandedIcon: e.base0D,
	            collapsedIcon: e.base0E,
	            keyColor: e.base07,
	            arrayKeyColor: e.base0C,
	            objectSize: e.base04,
	            copyToClipboard: e.base0F,
	            copyToClipboardCheck: e.base0D,
	            objectBorder: e.base02,
	            dataTypes: {
	              boolean: e.base0E,
	              date: e.base0D,
	              float: e.base0B,
	              function: e.base0D,
	              integer: e.base0F,
	              string: e.base09,
	              nan: e.base08,
	              null: e.base0A,
	              undefined: e.base05,
	              regexp: e.base0A,
	              background: e.base02
	            },
	            editVariable: {
	              editIcon: e.base0E,
	              cancelIcon: e.base09,
	              removeIcon: e.base09,
	              addIcon: e.base0E,
	              checkIcon: e.base0E,
	              background: e.base01,
	              color: e.base0A,
	              border: e.base07
	            },
	            addKeyModal: {
	              background: e.base05,
	              border: e.base04,
	              color: e.base0A,
	              labelColor: e.base01
	            },
	            validationFailure: {
	              background: e.base09,
	              iconColor: e.base01,
	              fontColor: e.base01
	            }
	          };
	        }(e);
	        return {
	          "app-container": {
	            fontFamily: C.globalFontFamily,
	            cursor: C.globalCursor,
	            backgroundColor: t.backgroundColor,
	            position: "relative"
	          },
	          ellipsis: {
	            display: "inline-block",
	            color: t.ellipsisColor,
	            fontSize: C.ellipsisFontSize,
	            lineHeight: C.ellipsisLineHeight,
	            cursor: C.ellipsisCursor
	          },
	          "brace-row": {
	            display: "inline-block",
	            cursor: "pointer"
	          },
	          brace: {
	            display: "inline-block",
	            cursor: C.braceCursor,
	            fontWeight: C.braceFontWeight,
	            color: t.braceColor
	          },
	          "expanded-icon": {
	            color: t.expandedIcon
	          },
	          "collapsed-icon": {
	            color: t.collapsedIcon
	          },
	          colon: {
	            display: "inline-block",
	            margin: C.keyMargin,
	            color: t.keyColor,
	            verticalAlign: "top"
	          },
	          objectKeyVal: function (e, n) {
	            return {
	              style: o({
	                paddingTop: C.keyValPaddingTop,
	                paddingRight: C.keyValPaddingRight,
	                paddingBottom: C.keyValPaddingBottom,
	                borderLeft: C.keyValBorderLeft + " " + t.objectBorder,
	                ":hover": {
	                  paddingLeft: n.paddingLeft - 1 + "px",
	                  borderLeft: C.keyValBorderHover + " " + t.objectBorder
	                }
	              }, n)
	            };
	          },
	          "object-key-val-no-border": {
	            padding: C.keyValPadding
	          },
	          "pushed-content": {
	            marginLeft: C.pushedContentMarginLeft
	          },
	          variableValue: function (e, t) {
	            return {
	              style: o({
	                display: "inline-block",
	                paddingRight: C.variableValuePaddingRight,
	                position: "relative"
	              }, t)
	            };
	          },
	          "object-name": {
	            display: "inline-block",
	            color: t.keyColor,
	            letterSpacing: C.keyLetterSpacing,
	            fontStyle: C.keyFontStyle,
	            verticalAlign: C.keyVerticalAlign,
	            opacity: C.keyOpacity,
	            ":hover": {
	              opacity: C.keyOpacityHover
	            }
	          },
	          "array-key": {
	            display: "inline-block",
	            color: t.arrayKeyColor,
	            letterSpacing: C.keyLetterSpacing,
	            fontStyle: C.keyFontStyle,
	            verticalAlign: C.keyVerticalAlign,
	            opacity: C.keyOpacity,
	            ":hover": {
	              opacity: C.keyOpacityHover
	            }
	          },
	          "object-size": {
	            color: t.objectSize,
	            borderRadius: C.objectSizeBorderRadius,
	            fontStyle: C.objectSizeFontStyle,
	            margin: C.objectSizeMargin,
	            cursor: "default"
	          },
	          "data-type-label": {
	            fontSize: C.dataTypeFontSize,
	            marginRight: C.dataTypeMarginRight,
	            opacity: C.datatypeOpacity
	          },
	          boolean: {
	            display: "inline-block",
	            color: t.dataTypes.boolean
	          },
	          date: {
	            display: "inline-block",
	            color: t.dataTypes.date
	          },
	          "date-value": {
	            marginLeft: C.dateValueMarginLeft
	          },
	          float: {
	            display: "inline-block",
	            color: t.dataTypes.float
	          },
	          function: {
	            display: "inline-block",
	            color: t.dataTypes.function,
	            cursor: "pointer",
	            whiteSpace: "pre-line"
	          },
	          "function-value": {
	            fontStyle: "italic"
	          },
	          integer: {
	            display: "inline-block",
	            color: t.dataTypes.integer
	          },
	          string: {
	            display: "inline-block",
	            color: t.dataTypes.string
	          },
	          nan: {
	            display: "inline-block",
	            color: t.dataTypes.nan,
	            fontSize: C.nanFontSize,
	            fontWeight: C.nanFontWeight,
	            backgroundColor: t.dataTypes.background,
	            padding: C.nanPadding,
	            borderRadius: C.nanBorderRadius
	          },
	          null: {
	            display: "inline-block",
	            color: t.dataTypes.null,
	            fontSize: C.nullFontSize,
	            fontWeight: C.nullFontWeight,
	            backgroundColor: t.dataTypes.background,
	            padding: C.nullPadding,
	            borderRadius: C.nullBorderRadius
	          },
	          undefined: {
	            display: "inline-block",
	            color: t.dataTypes.undefined,
	            fontSize: C.undefinedFontSize,
	            padding: C.undefinedPadding,
	            borderRadius: C.undefinedBorderRadius,
	            backgroundColor: t.dataTypes.background
	          },
	          regexp: {
	            display: "inline-block",
	            color: t.dataTypes.regexp
	          },
	          "copy-to-clipboard": {
	            cursor: C.clipboardCursor
	          },
	          "copy-icon": {
	            color: t.copyToClipboard,
	            fontSize: C.iconFontSize,
	            marginRight: C.iconMarginRight,
	            verticalAlign: "top"
	          },
	          "copy-icon-copied": {
	            color: t.copyToClipboardCheck,
	            marginLeft: C.clipboardCheckMarginLeft
	          },
	          "array-group-meta-data": {
	            display: "inline-block",
	            padding: C.arrayGroupMetaPadding
	          },
	          "object-meta-data": {
	            display: "inline-block",
	            padding: C.metaDataPadding
	          },
	          "icon-container": {
	            display: "inline-block",
	            width: C.iconContainerWidth
	          },
	          tooltip: {
	            padding: C.tooltipPadding
	          },
	          removeVarIcon: {
	            verticalAlign: "top",
	            display: "inline-block",
	            color: t.editVariable.removeIcon,
	            cursor: C.iconCursor,
	            fontSize: C.iconFontSize,
	            marginRight: C.iconMarginRight
	          },
	          addVarIcon: {
	            verticalAlign: "top",
	            display: "inline-block",
	            color: t.editVariable.addIcon,
	            cursor: C.iconCursor,
	            fontSize: C.iconFontSize,
	            marginRight: C.iconMarginRight
	          },
	          editVarIcon: {
	            verticalAlign: "top",
	            display: "inline-block",
	            color: t.editVariable.editIcon,
	            cursor: C.iconCursor,
	            fontSize: C.iconFontSize,
	            marginRight: C.iconMarginRight
	          },
	          "edit-icon-container": {
	            display: "inline-block",
	            verticalAlign: "top"
	          },
	          "check-icon": {
	            display: "inline-block",
	            cursor: C.iconCursor,
	            color: t.editVariable.checkIcon,
	            fontSize: C.iconFontSize,
	            paddingRight: C.iconPaddingRight
	          },
	          "cancel-icon": {
	            display: "inline-block",
	            cursor: C.iconCursor,
	            color: t.editVariable.cancelIcon,
	            fontSize: C.iconFontSize,
	            paddingRight: C.iconPaddingRight
	          },
	          "edit-input": {
	            display: "inline-block",
	            minWidth: C.editInputMinWidth,
	            borderRadius: C.editInputBorderRadius,
	            backgroundColor: t.editVariable.background,
	            color: t.editVariable.color,
	            padding: C.editInputPadding,
	            marginRight: C.editInputMarginRight,
	            fontFamily: C.editInputFontFamily
	          },
	          "detected-row": {
	            paddingTop: C.detectedRowPaddingTop
	          },
	          "key-modal-request": {
	            position: C.addKeyCoverPosition,
	            top: C.addKeyCoverPositionPx,
	            left: C.addKeyCoverPositionPx,
	            right: C.addKeyCoverPositionPx,
	            bottom: C.addKeyCoverPositionPx,
	            backgroundColor: C.addKeyCoverBackground
	          },
	          "key-modal": {
	            width: C.addKeyModalWidth,
	            backgroundColor: t.addKeyModal.background,
	            marginLeft: C.addKeyModalMargin,
	            marginRight: C.addKeyModalMargin,
	            padding: C.addKeyModalPadding,
	            borderRadius: C.addKeyModalRadius,
	            marginTop: "15px",
	            position: "relative"
	          },
	          "key-modal-label": {
	            color: t.addKeyModal.labelColor,
	            marginLeft: "2px",
	            marginBottom: "5px",
	            fontSize: "11px"
	          },
	          "key-modal-input-container": {
	            overflow: "hidden"
	          },
	          "key-modal-input": {
	            width: "100%",
	            padding: "3px 6px",
	            fontFamily: "monospace",
	            color: t.addKeyModal.color,
	            border: "none",
	            boxSizing: "border-box",
	            borderRadius: "2px"
	          },
	          "key-modal-cancel": {
	            backgroundColor: t.editVariable.removeIcon,
	            position: "absolute",
	            top: "0px",
	            right: "0px",
	            borderRadius: "0px 3px 0px 3px",
	            cursor: "pointer"
	          },
	          "key-modal-cancel-icon": {
	            color: t.addKeyModal.labelColor,
	            fontSize: C.iconFontSize,
	            transform: "rotate(45deg)"
	          },
	          "key-modal-submit": {
	            color: t.editVariable.addIcon,
	            fontSize: C.iconFontSize,
	            position: "absolute",
	            right: "2px",
	            top: "3px",
	            cursor: "pointer"
	          },
	          "function-ellipsis": {
	            display: "inline-block",
	            color: t.ellipsisColor,
	            fontSize: C.ellipsisFontSize,
	            lineHeight: C.ellipsisLineHeight,
	            cursor: C.ellipsisCursor
	          },
	          "validation-failure": {
	            float: "right",
	            padding: "3px 6px",
	            borderRadius: "2px",
	            cursor: "pointer",
	            color: t.validationFailure.fontColor,
	            backgroundColor: t.validationFailure.background
	          },
	          "validation-failure-label": {
	            marginRight: "6px"
	          },
	          "validation-failure-clear": {
	            position: "relative",
	            verticalAlign: "top",
	            cursor: "pointer",
	            color: t.validationFailure.iconColor,
	            fontSize: C.iconFontSize,
	            transform: "rotate(45deg)"
	          }
	        };
	      };
	    function A(e, t, n) {
	      return e || console.error("theme has not been set"), function (e) {
	        var t = k;
	        return !1 !== e && "none" !== e || (t = O), Object(S.createStyling)(w, {
	          defaultBase16: t
	        })(e);
	      }(e)(t, n);
	    }
	    var M = function (e) {
	        u(n, e);
	        var t = h(n);
	        function n() {
	          return i(this, n), t.apply(this, arguments);
	        }
	        return c(n, [{
	          key: "render",
	          value: function () {
	            var e = this.props,
	              t = (e.rjvId, e.type_name),
	              n = e.displayDataTypes,
	              a = e.theme;
	            return n ? m.a.createElement("span", Object.assign({
	              className: "data-type-label"
	            }, A(a, "data-type-label")), t) : null;
	          }
	        }]), n;
	      }(m.a.PureComponent),
	      P = function (e) {
	        u(n, e);
	        var t = h(n);
	        function n() {
	          return i(this, n), t.apply(this, arguments);
	        }
	        return c(n, [{
	          key: "render",
	          value: function () {
	            var e = this.props;
	            return m.a.createElement("div", A(e.theme, "boolean"), m.a.createElement(M, Object.assign({
	              type_name: "bool"
	            }, e)), e.value ? "true" : "false");
	          }
	        }]), n;
	      }(m.a.PureComponent),
	      F = function (e) {
	        u(n, e);
	        var t = h(n);
	        function n() {
	          return i(this, n), t.apply(this, arguments);
	        }
	        return c(n, [{
	          key: "render",
	          value: function () {
	            var e = this.props;
	            return m.a.createElement("div", A(e.theme, "date"), m.a.createElement(M, Object.assign({
	              type_name: "date"
	            }, e)), m.a.createElement("span", Object.assign({
	              className: "date-value"
	            }, A(e.theme, "date-value")), e.value.toLocaleTimeString("en-us", {
	              weekday: "short",
	              year: "numeric",
	              month: "short",
	              day: "numeric",
	              hour: "2-digit",
	              minute: "2-digit"
	            })));
	          }
	        }]), n;
	      }(m.a.PureComponent),
	      D = function (e) {
	        u(n, e);
	        var t = h(n);
	        function n() {
	          return i(this, n), t.apply(this, arguments);
	        }
	        return c(n, [{
	          key: "render",
	          value: function () {
	            var e = this.props;
	            return m.a.createElement("div", A(e.theme, "float"), m.a.createElement(M, Object.assign({
	              type_name: "float"
	            }, e)), this.props.value);
	          }
	        }]), n;
	      }(m.a.PureComponent);
	    function I(e, t) {
	      (null == t || t > e.length) && (t = e.length);
	      for (var n = 0, a = new Array(t); n < t; n++) a[n] = e[n];
	      return a;
	    }
	    function R(e, t) {
	      if (e) {
	        if ("string" == typeof e) return I(e, t);
	        var n = Object.prototype.toString.call(e).slice(8, -1);
	        return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? I(e, t) : void 0;
	      }
	    }
	    function L(e, t) {
	      var n;
	      if ("undefined" == typeof Symbol || null == e[Symbol.iterator]) {
	        if (Array.isArray(e) || (n = R(e)) || t && e && "number" == typeof e.length) {
	          n && (e = n);
	          var a = 0,
	            r = function () {};
	          return {
	            s: r,
	            n: function () {
	              return a >= e.length ? {
	                done: !0
	              } : {
	                done: !1,
	                value: e[a++]
	              };
	            },
	            e: function (e) {
	              throw e;
	            },
	            f: r
	          };
	        }
	        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	      }
	      var o,
	        i = !0,
	        s = !1;
	      return {
	        s: function () {
	          n = e[Symbol.iterator]();
	        },
	        n: function () {
	          var e = n.next();
	          return i = e.done, e;
	        },
	        e: function (e) {
	          s = !0, o = e;
	        },
	        f: function () {
	          try {
	            i || null == n.return || n.return();
	          } finally {
	            if (s) throw o;
	          }
	        }
	      };
	    }
	    function B(e) {
	      return function (e) {
	        if (Array.isArray(e)) return I(e);
	      }(e) || function (e) {
	        if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
	      }(e) || R(e) || function () {
	        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	      }();
	    }
	    var N = n(46),
	      z = new (n(47).Dispatcher)(),
	      T = new (function (e) {
	        u(n, e);
	        var t = h(n);
	        function n() {
	          var e;
	          i(this, n);
	          for (var a = arguments.length, r = new Array(a), s = 0; s < a; s++) r[s] = arguments[s];
	          return (e = t.call.apply(t, [this].concat(r))).objects = {}, e.set = function (t, n, a, r) {
	            void 0 === e.objects[t] && (e.objects[t] = {}), void 0 === e.objects[t][n] && (e.objects[t][n] = {}), e.objects[t][n][a] = r;
	          }, e.get = function (t, n, a, r) {
	            return void 0 === e.objects[t] || void 0 === e.objects[t][n] || null == e.objects[t][n][a] ? r : e.objects[t][n][a];
	          }, e.handleAction = function (t) {
	            var n = t.rjvId,
	              a = t.data;
	            switch (t.name) {
	              case "RESET":
	                e.emit("reset-" + n);
	                break;
	              case "VARIABLE_UPDATED":
	                t.data.updated_src = e.updateSrc(n, a), e.set(n, "action", "variable-update", o(o({}, a), {}, {
	                  type: "variable-edited"
	                })), e.emit("variable-update-" + n);
	                break;
	              case "VARIABLE_REMOVED":
	                t.data.updated_src = e.updateSrc(n, a), e.set(n, "action", "variable-update", o(o({}, a), {}, {
	                  type: "variable-removed"
	                })), e.emit("variable-update-" + n);
	                break;
	              case "VARIABLE_ADDED":
	                t.data.updated_src = e.updateSrc(n, a), e.set(n, "action", "variable-update", o(o({}, a), {}, {
	                  type: "variable-added"
	                })), e.emit("variable-update-" + n);
	                break;
	              case "ADD_VARIABLE_KEY_REQUEST":
	                e.set(n, "action", "new-key-request", a), e.emit("add-key-request-" + n);
	            }
	          }, e.updateSrc = function (t, n) {
	            var a = n.name,
	              r = n.namespace,
	              o = n.new_value,
	              i = (n.existing_value, n.variable_removed);
	            r.shift();
	            var s,
	              c = e.get(t, "global", "src"),
	              l = e.deepCopy(c, B(r)),
	              u = l,
	              f = L(r);
	            try {
	              for (f.s(); !(s = f.n()).done;) {
	                u = u[s.value];
	              }
	            } catch (e) {
	              f.e(e);
	            } finally {
	              f.f();
	            }
	            return i ? "array" == _(u) ? u.splice(a, 1) : delete u[a] : null !== a ? u[a] = o : l = o, e.set(t, "global", "src", l), l;
	          }, e.deepCopy = function (t, n) {
	            var a,
	              r = _(t),
	              i = n.shift();
	            return "array" == r ? a = B(t) : "object" == r && (a = o({}, t)), void 0 !== i && (a[i] = e.deepCopy(t[i], n)), a;
	          }, e;
	        }
	        return n;
	      }(N.EventEmitter))();
	    z.register(T.handleAction.bind(T));
	    var q = T,
	      V = function (e) {
	        u(n, e);
	        var t = h(n);
	        function n(e) {
	          var a;
	          return i(this, n), (a = t.call(this, e)).toggleCollapsed = function () {
	            a.setState({
	              collapsed: !a.state.collapsed
	            }, function () {
	              q.set(a.props.rjvId, a.props.namespace, "collapsed", a.state.collapsed);
	            });
	          }, a.getFunctionDisplay = function (e) {
	            var t = d(a).props;
	            return e ? m.a.createElement("span", null, a.props.value.toString().slice(9, -1).replace(/\{[\s\S]+/, ""), m.a.createElement("span", {
	              className: "function-collapsed",
	              style: {
	                fontWeight: "bold"
	              }
	            }, m.a.createElement("span", null, "{"), m.a.createElement("span", A(t.theme, "ellipsis"), "..."), m.a.createElement("span", null, "}"))) : a.props.value.toString().slice(9, -1);
	          }, a.state = {
	            collapsed: q.get(e.rjvId, e.namespace, "collapsed", !0)
	          }, a;
	        }
	        return c(n, [{
	          key: "render",
	          value: function () {
	            var e = this.props,
	              t = this.state.collapsed;
	            return m.a.createElement("div", A(e.theme, "function"), m.a.createElement(M, Object.assign({
	              type_name: "function"
	            }, e)), m.a.createElement("span", Object.assign({}, A(e.theme, "function-value"), {
	              className: "rjv-function-container",
	              onClick: this.toggleCollapsed
	            }), this.getFunctionDisplay(t)));
	          }
	        }]), n;
	      }(m.a.PureComponent),
	      K = function (e) {
	        u(n, e);
	        var t = h(n);
	        function n() {
	          return i(this, n), t.apply(this, arguments);
	        }
	        return c(n, [{
	          key: "render",
	          value: function () {
	            return m.a.createElement("div", A(this.props.theme, "nan"), "NaN");
	          }
	        }]), n;
	      }(m.a.PureComponent),
	      W = function (e) {
	        u(n, e);
	        var t = h(n);
	        function n() {
	          return i(this, n), t.apply(this, arguments);
	        }
	        return c(n, [{
	          key: "render",
	          value: function () {
	            return m.a.createElement("div", A(this.props.theme, "null"), "NULL");
	          }
	        }]), n;
	      }(m.a.PureComponent),
	      H = function (e) {
	        u(n, e);
	        var t = h(n);
	        function n() {
	          return i(this, n), t.apply(this, arguments);
	        }
	        return c(n, [{
	          key: "render",
	          value: function () {
	            var e = this.props;
	            return m.a.createElement("div", A(e.theme, "integer"), m.a.createElement(M, Object.assign({
	              type_name: "int"
	            }, e)), this.props.value);
	          }
	        }]), n;
	      }(m.a.PureComponent),
	      U = function (e) {
	        u(n, e);
	        var t = h(n);
	        function n() {
	          return i(this, n), t.apply(this, arguments);
	        }
	        return c(n, [{
	          key: "render",
	          value: function () {
	            var e = this.props;
	            return m.a.createElement("div", A(e.theme, "regexp"), m.a.createElement(M, Object.assign({
	              type_name: "regexp"
	            }, e)), this.props.value.toString());
	          }
	        }]), n;
	      }(m.a.PureComponent),
	      G = function (e) {
	        u(n, e);
	        var t = h(n);
	        function n(e) {
	          var a;
	          return i(this, n), (a = t.call(this, e)).toggleCollapsed = function () {
	            a.setState({
	              collapsed: !a.state.collapsed
	            }, function () {
	              q.set(a.props.rjvId, a.props.namespace, "collapsed", a.state.collapsed);
	            });
	          }, a.state = {
	            collapsed: q.get(e.rjvId, e.namespace, "collapsed", !0)
	          }, a;
	        }
	        return c(n, [{
	          key: "render",
	          value: function () {
	            this.state.collapsed;
	            var e = this.props,
	              t = e.collapseStringsAfterLength,
	              n = e.theme,
	              a = e.value,
	              r = {
	                style: {
	                  cursor: "default"
	                }
	              };
	            return "integer" === _(t) && a.length > t && (r.style.cursor = "pointer", this.state.collapsed && (a = m.a.createElement("span", null, a.substring(0, t), m.a.createElement("span", A(n, "ellipsis"), " ...")))), m.a.createElement("div", A(n, "string"), m.a.createElement(M, Object.assign({
	              type_name: "string"
	            }, e)), m.a.createElement("span", Object.assign({
	              className: "string-value"
	            }, r, {
	              onClick: this.toggleCollapsed
	            }), '"', a, '"'));
	          }
	        }]), n;
	      }(m.a.PureComponent),
	      J = function (e) {
	        u(n, e);
	        var t = h(n);
	        function n() {
	          return i(this, n), t.apply(this, arguments);
	        }
	        return c(n, [{
	          key: "render",
	          value: function () {
	            return m.a.createElement("div", A(this.props.theme, "undefined"), "undefined");
	          }
	        }]), n;
	      }(m.a.PureComponent);
	    function Y() {
	      return (Y = Object.assign || function (e) {
	        for (var t = 1; t < arguments.length; t++) {
	          var n = arguments[t];
	          for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
	        }
	        return e;
	      }).apply(this, arguments);
	    }
	    var $ = v.useLayoutEffect,
	      Q = function (e) {
	        var t = Object(v.useRef)(e);
	        return $(function () {
	          t.current = e;
	        }), t;
	      },
	      Z = function (e, t) {
	        "function" != typeof e ? e.current = t : e(t);
	      },
	      X = function (e, t) {
	        var n = Object(v.useRef)();
	        return Object(v.useCallback)(function (a) {
	          e.current = a, n.current && Z(n.current, null), n.current = t, t && Z(t, a);
	        }, [t]);
	      },
	      ee = {
	        "min-height": "0",
	        "max-height": "none",
	        height: "0",
	        visibility: "hidden",
	        overflow: "hidden",
	        position: "absolute",
	        "z-index": "-1000",
	        top: "0",
	        right: "0"
	      },
	      te = function (e) {
	        Object.keys(ee).forEach(function (t) {
	          e.style.setProperty(t, ee[t], "important");
	        });
	      },
	      ne = null;
	    var ae = function () {},
	      re = ["borderBottomWidth", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "boxSizing", "fontFamily", "fontSize", "fontStyle", "fontWeight", "letterSpacing", "lineHeight", "paddingBottom", "paddingLeft", "paddingRight", "paddingTop", "tabSize", "textIndent", "textRendering", "textTransform", "width"],
	      oe = !!document.documentElement.currentStyle,
	      ie = function (e, t) {
	        var n = e.cacheMeasurements,
	          a = e.maxRows,
	          r = e.minRows,
	          o = e.onChange,
	          i = void 0 === o ? ae : o,
	          s = e.onHeightChange,
	          c = void 0 === s ? ae : s,
	          l = function (e, t) {
	            if (null == e) return {};
	            var n,
	              a,
	              r = {},
	              o = Object.keys(e);
	            for (a = 0; a < o.length; a++) n = o[a], t.indexOf(n) >= 0 || (r[n] = e[n]);
	            return r;
	          }(e, ["cacheMeasurements", "maxRows", "minRows", "onChange", "onHeightChange"]);
	        var u,
	          f = void 0 !== l.value,
	          p = Object(v.useRef)(null),
	          d = X(p, t),
	          b = Object(v.useRef)(0),
	          h = Object(v.useRef)(),
	          m = function () {
	            var e = p.current,
	              t = n && h.current ? h.current : function (e) {
	                var t = window.getComputedStyle(e);
	                if (null === t) return null;
	                var n,
	                  a = (n = t, re.reduce(function (e, t) {
	                    return e[t] = n[t], e;
	                  }, {})),
	                  r = a.boxSizing;
	                return "" === r ? null : (oe && "border-box" === r && (a.width = parseFloat(a.width) + parseFloat(a.borderRightWidth) + parseFloat(a.borderLeftWidth) + parseFloat(a.paddingRight) + parseFloat(a.paddingLeft) + "px"), {
	                  sizingStyle: a,
	                  paddingSize: parseFloat(a.paddingBottom) + parseFloat(a.paddingTop),
	                  borderSize: parseFloat(a.borderBottomWidth) + parseFloat(a.borderTopWidth)
	                });
	              }(e);
	            if (t) {
	              h.current = t;
	              var o = function (e, t, n, a) {
	                  void 0 === n && (n = 1), void 0 === a && (a = 1 / 0), ne || ((ne = document.createElement("textarea")).setAttribute("tab-index", "-1"), ne.setAttribute("aria-hidden", "true"), te(ne)), null === ne.parentNode && document.body.appendChild(ne);
	                  var r = e.paddingSize,
	                    o = e.borderSize,
	                    i = e.sizingStyle,
	                    s = i.boxSizing;
	                  Object.keys(i).forEach(function (e) {
	                    var t = e;
	                    ne.style[t] = i[t];
	                  }), te(ne), ne.value = t;
	                  var c = function (e, t) {
	                    var n = e.scrollHeight;
	                    return "border-box" === t.sizingStyle.boxSizing ? n + t.borderSize : n - t.paddingSize;
	                  }(ne, e);
	                  ne.value = "x";
	                  var l = ne.scrollHeight - r,
	                    u = l * n;
	                  "border-box" === s && (u = u + r + o), c = Math.max(u, c);
	                  var f = l * a;
	                  return "border-box" === s && (f = f + r + o), [c = Math.min(f, c), l];
	                }(t, e.value || e.placeholder || "x", r, a),
	                i = o[0],
	                s = o[1];
	              b.current !== i && (b.current = i, e.style.setProperty("height", i + "px", "important"), c(i, {
	                rowHeight: s
	              }));
	            }
	          };
	        return Object(v.useLayoutEffect)(m), u = Q(m), Object(v.useLayoutEffect)(function () {
	          var e = function (e) {
	            u.current(e);
	          };
	          return window.addEventListener("resize", e), function () {
	            window.removeEventListener("resize", e);
	          };
	        }, []), Object(v.createElement)("textarea", Y({}, l, {
	          onChange: function (e) {
	            f || m(), i(e);
	          },
	          ref: d
	        }));
	      },
	      se = Object(v.forwardRef)(ie);
	    function ce(e) {
	      e = e.trim();
	      try {
	        if ("[" === (e = JSON.stringify(JSON.parse(e)))[0]) return le("array", JSON.parse(e));
	        if ("{" === e[0]) return le("object", JSON.parse(e));
	        if (e.match(/\-?\d+\.\d+/) && e.match(/\-?\d+\.\d+/)[0] === e) return le("float", parseFloat(e));
	        if (e.match(/\-?\d+e-\d+/) && e.match(/\-?\d+e-\d+/)[0] === e) return le("float", Number(e));
	        if (e.match(/\-?\d+/) && e.match(/\-?\d+/)[0] === e) return le("integer", parseInt(e));
	        if (e.match(/\-?\d+e\+\d+/) && e.match(/\-?\d+e\+\d+/)[0] === e) return le("integer", Number(e));
	      } catch (e) {}
	      switch (e = e.toLowerCase()) {
	        case "undefined":
	          return le("undefined", void 0);
	        case "nan":
	          return le("nan", NaN);
	        case "null":
	          return le("null", null);
	        case "true":
	          return le("boolean", !0);
	        case "false":
	          return le("boolean", !1);
	        default:
	          if (e = Date.parse(e)) return le("date", new Date(e));
	      }
	      return le(!1, null);
	    }
	    function le(e, t) {
	      return {
	        type: e,
	        value: t
	      };
	    }
	    var ue = function (e) {
	        u(n, e);
	        var t = h(n);
	        function n() {
	          return i(this, n), t.apply(this, arguments);
	        }
	        return c(n, [{
	          key: "render",
	          value: function () {
	            var e = this.props,
	              t = e.style,
	              n = x(e, ["style"]);
	            return m.a.createElement("span", n, m.a.createElement("svg", Object.assign({}, xe(t), {
	              viewBox: "0 0 24 24",
	              fill: "currentColor",
	              preserveAspectRatio: "xMidYMid meet"
	            }), m.a.createElement("path", {
	              d: "M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M7,13H17V11H7"
	            })));
	          }
	        }]), n;
	      }(m.a.PureComponent),
	      fe = function (e) {
	        u(n, e);
	        var t = h(n);
	        function n() {
	          return i(this, n), t.apply(this, arguments);
	        }
	        return c(n, [{
	          key: "render",
	          value: function () {
	            var e = this.props,
	              t = e.style,
	              n = x(e, ["style"]);
	            return m.a.createElement("span", n, m.a.createElement("svg", Object.assign({}, xe(t), {
	              viewBox: "0 0 24 24",
	              fill: "currentColor",
	              preserveAspectRatio: "xMidYMid meet"
	            }), m.a.createElement("path", {
	              d: "M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M13,7H11V11H7V13H11V17H13V13H17V11H13V7Z"
	            })));
	          }
	        }]), n;
	      }(m.a.PureComponent),
	      pe = function (e) {
	        u(n, e);
	        var t = h(n);
	        function n() {
	          return i(this, n), t.apply(this, arguments);
	        }
	        return c(n, [{
	          key: "render",
	          value: function () {
	            var e = this.props,
	              t = e.style,
	              n = x(e, ["style"]),
	              a = xe(t).style;
	            return m.a.createElement("span", n, m.a.createElement("svg", {
	              fill: a.color,
	              width: a.height,
	              height: a.width,
	              style: a,
	              viewBox: "0 0 1792 1792"
	            }, m.a.createElement("path", {
	              d: "M1344 800v64q0 14-9 23t-23 9h-832q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h832q14 0 23 9t9 23zm128 448v-832q0-66-47-113t-113-47h-832q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113zm128-832v832q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h832q119 0 203.5 84.5t84.5 203.5z"
	            })));
	          }
	        }]), n;
	      }(m.a.PureComponent),
	      de = function (e) {
	        u(n, e);
	        var t = h(n);
	        function n() {
	          return i(this, n), t.apply(this, arguments);
	        }
	        return c(n, [{
	          key: "render",
	          value: function () {
	            var e = this.props,
	              t = e.style,
	              n = x(e, ["style"]),
	              a = xe(t).style;
	            return m.a.createElement("span", n, m.a.createElement("svg", {
	              fill: a.color,
	              width: a.height,
	              height: a.width,
	              style: a,
	              viewBox: "0 0 1792 1792"
	            }, m.a.createElement("path", {
	              d: "M1344 800v64q0 14-9 23t-23 9h-352v352q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-352h-352q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h352v-352q0-14 9-23t23-9h64q14 0 23 9t9 23v352h352q14 0 23 9t9 23zm128 448v-832q0-66-47-113t-113-47h-832q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113zm128-832v832q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h832q119 0 203.5 84.5t84.5 203.5z"
	            })));
	          }
	        }]), n;
	      }(m.a.PureComponent),
	      be = function (e) {
	        u(n, e);
	        var t = h(n);
	        function n() {
	          return i(this, n), t.apply(this, arguments);
	        }
	        return c(n, [{
	          key: "render",
	          value: function () {
	            var e = this.props,
	              t = e.style,
	              n = x(e, ["style"]);
	            return m.a.createElement("span", n, m.a.createElement("svg", {
	              style: o(o({}, xe(t).style), {}, {
	                paddingLeft: "2px",
	                verticalAlign: "top"
	              }),
	              viewBox: "0 0 15 15",
	              fill: "currentColor"
	            }, m.a.createElement("path", {
	              d: "M0 14l6-6-6-6z"
	            })));
	          }
	        }]), n;
	      }(m.a.PureComponent),
	      he = function (e) {
	        u(n, e);
	        var t = h(n);
	        function n() {
	          return i(this, n), t.apply(this, arguments);
	        }
	        return c(n, [{
	          key: "render",
	          value: function () {
	            var e = this.props,
	              t = e.style,
	              n = x(e, ["style"]);
	            return m.a.createElement("span", n, m.a.createElement("svg", {
	              style: o(o({}, xe(t).style), {}, {
	                paddingLeft: "2px",
	                verticalAlign: "top"
	              }),
	              viewBox: "0 0 15 15",
	              fill: "currentColor"
	            }, m.a.createElement("path", {
	              d: "M0 5l6 6 6-6z"
	            })));
	          }
	        }]), n;
	      }(m.a.PureComponent),
	      ve = function (e) {
	        u(n, e);
	        var t = h(n);
	        function n() {
	          return i(this, n), t.apply(this, arguments);
	        }
	        return c(n, [{
	          key: "render",
	          value: function () {
	            var e = this.props,
	              t = e.style,
	              n = x(e, ["style"]);
	            return m.a.createElement("span", n, m.a.createElement("svg", Object.assign({}, xe(t), {
	              viewBox: "0 0 40 40",
	              fill: "currentColor",
	              preserveAspectRatio: "xMidYMid meet"
	            }), m.a.createElement("g", null, m.a.createElement("path", {
	              d: "m30 35h-25v-22.5h25v7.5h2.5v-12.5c0-1.4-1.1-2.5-2.5-2.5h-7.5c0-2.8-2.2-5-5-5s-5 2.2-5 5h-7.5c-1.4 0-2.5 1.1-2.5 2.5v27.5c0 1.4 1.1 2.5 2.5 2.5h25c1.4 0 2.5-1.1 2.5-2.5v-5h-2.5v5z m-20-27.5h2.5s2.5-1.1 2.5-2.5 1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5 1.3 2.5 2.5 2.5h2.5s2.5 1.1 2.5 2.5h-20c0-1.5 1.1-2.5 2.5-2.5z m-2.5 20h5v-2.5h-5v2.5z m17.5-5v-5l-10 7.5 10 7.5v-5h12.5v-5h-12.5z m-17.5 10h7.5v-2.5h-7.5v2.5z m12.5-17.5h-12.5v2.5h12.5v-2.5z m-7.5 5h-5v2.5h5v-2.5z"
	            }))));
	          }
	        }]), n;
	      }(m.a.PureComponent),
	      me = function (e) {
	        u(n, e);
	        var t = h(n);
	        function n() {
	          return i(this, n), t.apply(this, arguments);
	        }
	        return c(n, [{
	          key: "render",
	          value: function () {
	            var e = this.props,
	              t = e.style,
	              n = x(e, ["style"]);
	            return m.a.createElement("span", n, m.a.createElement("svg", Object.assign({}, xe(t), {
	              viewBox: "0 0 40 40",
	              fill: "currentColor",
	              preserveAspectRatio: "xMidYMid meet"
	            }), m.a.createElement("g", null, m.a.createElement("path", {
	              d: "m28.6 25q0-0.5-0.4-1l-4-4 4-4q0.4-0.5 0.4-1 0-0.6-0.4-1.1l-2-2q-0.4-0.4-1-0.4-0.6 0-1 0.4l-4.1 4.1-4-4.1q-0.4-0.4-1-0.4-0.6 0-1 0.4l-2 2q-0.5 0.5-0.5 1.1 0 0.5 0.5 1l4 4-4 4q-0.5 0.5-0.5 1 0 0.7 0.5 1.1l2 2q0.4 0.4 1 0.4 0.6 0 1-0.4l4-4.1 4.1 4.1q0.4 0.4 1 0.4 0.6 0 1-0.4l2-2q0.4-0.4 0.4-1z m8.7-5q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z"
	            }))));
	          }
	        }]), n;
	      }(m.a.PureComponent),
	      ye = function (e) {
	        u(n, e);
	        var t = h(n);
	        function n() {
	          return i(this, n), t.apply(this, arguments);
	        }
	        return c(n, [{
	          key: "render",
	          value: function () {
	            var e = this.props,
	              t = e.style,
	              n = x(e, ["style"]);
	            return m.a.createElement("span", n, m.a.createElement("svg", Object.assign({}, xe(t), {
	              viewBox: "0 0 40 40",
	              fill: "currentColor",
	              preserveAspectRatio: "xMidYMid meet"
	            }), m.a.createElement("g", null, m.a.createElement("path", {
	              d: "m30.1 21.4v-2.8q0-0.6-0.4-1t-1-0.5h-5.7v-5.7q0-0.6-0.4-1t-1-0.4h-2.9q-0.6 0-1 0.4t-0.4 1v5.7h-5.7q-0.6 0-1 0.5t-0.5 1v2.8q0 0.6 0.5 1t1 0.5h5.7v5.7q0 0.5 0.4 1t1 0.4h2.9q0.6 0 1-0.4t0.4-1v-5.7h5.7q0.6 0 1-0.5t0.4-1z m7.2-1.4q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z"
	            }))));
	          }
	        }]), n;
	      }(m.a.PureComponent),
	      ge = function (e) {
	        u(n, e);
	        var t = h(n);
	        function n() {
	          return i(this, n), t.apply(this, arguments);
	        }
	        return c(n, [{
	          key: "render",
	          value: function () {
	            var e = this.props,
	              t = e.style,
	              n = x(e, ["style"]);
	            return m.a.createElement("span", n, m.a.createElement("svg", Object.assign({}, xe(t), {
	              viewBox: "0 0 40 40",
	              fill: "currentColor",
	              preserveAspectRatio: "xMidYMid meet"
	            }), m.a.createElement("g", null, m.a.createElement("path", {
	              d: "m31.6 21.6h-10v10h-3.2v-10h-10v-3.2h10v-10h3.2v10h10v3.2z"
	            }))));
	          }
	        }]), n;
	      }(m.a.PureComponent),
	      Ee = function (e) {
	        u(n, e);
	        var t = h(n);
	        function n() {
	          return i(this, n), t.apply(this, arguments);
	        }
	        return c(n, [{
	          key: "render",
	          value: function () {
	            var e = this.props,
	              t = e.style,
	              n = x(e, ["style"]);
	            return m.a.createElement("span", n, m.a.createElement("svg", Object.assign({}, xe(t), {
	              viewBox: "0 0 40 40",
	              fill: "currentColor",
	              preserveAspectRatio: "xMidYMid meet"
	            }), m.a.createElement("g", null, m.a.createElement("path", {
	              d: "m19.8 26.4l2.6-2.6-3.4-3.4-2.6 2.6v1.3h2.2v2.1h1.2z m9.8-16q-0.3-0.4-0.7 0l-7.8 7.8q-0.4 0.4 0 0.7t0.7 0l7.8-7.8q0.4-0.4 0-0.7z m1.8 13.2v4.3q0 2.6-1.9 4.5t-4.5 1.9h-18.6q-2.6 0-4.5-1.9t-1.9-4.5v-18.6q0-2.7 1.9-4.6t4.5-1.8h18.6q1.4 0 2.6 0.5 0.3 0.2 0.4 0.5 0.1 0.4-0.2 0.7l-1.1 1.1q-0.3 0.3-0.7 0.1-0.5-0.1-1-0.1h-18.6q-1.4 0-2.5 1.1t-1 2.5v18.6q0 1.4 1 2.5t2.5 1h18.6q1.5 0 2.5-1t1.1-2.5v-2.9q0-0.2 0.2-0.4l1.4-1.5q0.3-0.3 0.8-0.1t0.4 0.6z m-2.1-16.5l6.4 6.5-15 15h-6.4v-6.5z m9.9 3l-2.1 2-6.4-6.4 2.1-2q0.6-0.7 1.5-0.7t1.5 0.7l3.4 3.4q0.6 0.6 0.6 1.5t-0.6 1.5z"
	            }))));
	          }
	        }]), n;
	      }(m.a.PureComponent),
	      je = function (e) {
	        u(n, e);
	        var t = h(n);
	        function n() {
	          return i(this, n), t.apply(this, arguments);
	        }
	        return c(n, [{
	          key: "render",
	          value: function () {
	            var e = this.props,
	              t = e.style,
	              n = x(e, ["style"]);
	            return m.a.createElement("span", n, m.a.createElement("svg", Object.assign({}, xe(t), {
	              viewBox: "0 0 40 40",
	              fill: "currentColor",
	              preserveAspectRatio: "xMidYMid meet"
	            }), m.a.createElement("g", null, m.a.createElement("path", {
	              d: "m31.7 16.4q0-0.6-0.4-1l-2.1-2.1q-0.4-0.4-1-0.4t-1 0.4l-9.1 9.1-5-5q-0.5-0.4-1-0.4t-1 0.4l-2.1 2q-0.4 0.4-0.4 1 0 0.6 0.4 1l8.1 8.1q0.4 0.4 1 0.4 0.6 0 1-0.4l12.2-12.1q0.4-0.4 0.4-1z m5.6 3.6q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z"
	            }))));
	          }
	        }]), n;
	      }(m.a.PureComponent);
	    function xe(e) {
	      return e || (e = {}), {
	        style: o(o({
	          verticalAlign: "middle"
	        }, e), {}, {
	          color: e.color ? e.color : "#000000",
	          height: "1em",
	          width: "1em"
	        })
	      };
	    }
	    var _e = function (e) {
	        u(n, e);
	        var t = h(n);
	        function n(e) {
	          var a;
	          return i(this, n), (a = t.call(this, e)).copiedTimer = null, a.handleCopy = function () {
	            var e = document.createElement("textarea"),
	              t = a.props,
	              n = t.clickCallback,
	              r = t.src,
	              o = t.namespace;
	            e.innerHTML = JSON.stringify(a.clipboardValue(r), null, "  "), document.body.appendChild(e), e.select(), document.execCommand("copy"), document.body.removeChild(e), a.copiedTimer = setTimeout(function () {
	              a.setState({
	                copied: !1
	              });
	            }, 5500), a.setState({
	              copied: !0
	            }, function () {
	              "function" == typeof n && n({
	                src: r,
	                namespace: o,
	                name: o[o.length - 1]
	              });
	            });
	          }, a.getClippyIcon = function () {
	            var e = a.props.theme;
	            return a.state.copied ? m.a.createElement("span", null, m.a.createElement(ve, Object.assign({
	              className: "copy-icon"
	            }, A(e, "copy-icon"))), m.a.createElement("span", A(e, "copy-icon-copied"), "✔")) : m.a.createElement(ve, Object.assign({
	              className: "copy-icon"
	            }, A(e, "copy-icon")));
	          }, a.clipboardValue = function (e) {
	            switch (_(e)) {
	              case "function":
	              case "regexp":
	                return e.toString();
	              default:
	                return e;
	            }
	          }, a.state = {
	            copied: !1
	          }, a;
	        }
	        return c(n, [{
	          key: "componentWillUnmount",
	          value: function () {
	            this.copiedTimer && (clearTimeout(this.copiedTimer), this.copiedTimer = null);
	          }
	        }, {
	          key: "render",
	          value: function () {
	            var e = this.props,
	              t = (e.src, e.theme),
	              n = e.hidden,
	              a = e.rowHovered,
	              r = A(t, "copy-to-clipboard").style,
	              i = "inline";
	            return n && (i = "none"), m.a.createElement("span", {
	              className: "copy-to-clipboard-container",
	              title: "Copy to clipboard",
	              style: {
	                verticalAlign: "top",
	                display: a ? "inline-block" : "none"
	              }
	            }, m.a.createElement("span", {
	              style: o(o({}, r), {}, {
	                display: i
	              }),
	              onClick: this.handleCopy
	            }, this.getClippyIcon()));
	          }
	        }]), n;
	      }(m.a.PureComponent),
	      ke = function (e) {
	        u(n, e);
	        var t = h(n);
	        function n(e) {
	          var a;
	          return i(this, n), (a = t.call(this, e)).getEditIcon = function () {
	            var e = a.props,
	              t = e.variable,
	              n = e.theme;
	            return m.a.createElement("div", {
	              className: "click-to-edit",
	              style: {
	                verticalAlign: "top",
	                display: a.state.hovered ? "inline-block" : "none"
	              }
	            }, m.a.createElement(Ee, Object.assign({
	              className: "click-to-edit-icon"
	            }, A(n, "editVarIcon"), {
	              onClick: function () {
	                a.prepopInput(t);
	              }
	            })));
	          }, a.prepopInput = function (e) {
	            if (!1 !== a.props.onEdit) {
	              var t = function (e) {
	                  var t;
	                  switch (_(e)) {
	                    case "undefined":
	                      t = "undefined";
	                      break;
	                    case "nan":
	                      t = "NaN";
	                      break;
	                    case "string":
	                      t = e;
	                      break;
	                    case "date":
	                    case "function":
	                    case "regexp":
	                      t = e.toString();
	                      break;
	                    default:
	                      try {
	                        t = JSON.stringify(e, null, "  ");
	                      } catch (e) {
	                        t = "";
	                      }
	                  }
	                  return t;
	                }(e.value),
	                n = ce(t);
	              a.setState({
	                editMode: !0,
	                editValue: t,
	                parsedInput: {
	                  type: n.type,
	                  value: n.value
	                }
	              });
	            }
	          }, a.getRemoveIcon = function () {
	            var e = a.props,
	              t = e.variable,
	              n = e.namespace,
	              r = e.theme,
	              o = e.rjvId;
	            return m.a.createElement("div", {
	              className: "click-to-remove",
	              style: {
	                verticalAlign: "top",
	                display: a.state.hovered ? "inline-block" : "none"
	              }
	            }, m.a.createElement(me, Object.assign({
	              className: "click-to-remove-icon"
	            }, A(r, "removeVarIcon"), {
	              onClick: function () {
	                z.dispatch({
	                  name: "VARIABLE_REMOVED",
	                  rjvId: o,
	                  data: {
	                    name: t.name,
	                    namespace: n,
	                    existing_value: t.value,
	                    variable_removed: !0
	                  }
	                });
	              }
	            })));
	          }, a.getValue = function (e, t) {
	            var n = !t && e.type,
	              r = d(a).props;
	            switch (n) {
	              case !1:
	                return a.getEditInput();
	              case "string":
	                return m.a.createElement(G, Object.assign({
	                  value: e.value
	                }, r));
	              case "integer":
	                return m.a.createElement(H, Object.assign({
	                  value: e.value
	                }, r));
	              case "float":
	                return m.a.createElement(D, Object.assign({
	                  value: e.value
	                }, r));
	              case "boolean":
	                return m.a.createElement(P, Object.assign({
	                  value: e.value
	                }, r));
	              case "function":
	                return m.a.createElement(V, Object.assign({
	                  value: e.value
	                }, r));
	              case "null":
	                return m.a.createElement(W, r);
	              case "nan":
	                return m.a.createElement(K, r);
	              case "undefined":
	                return m.a.createElement(J, r);
	              case "date":
	                return m.a.createElement(F, Object.assign({
	                  value: e.value
	                }, r));
	              case "regexp":
	                return m.a.createElement(U, Object.assign({
	                  value: e.value
	                }, r));
	              default:
	                return m.a.createElement("div", {
	                  className: "object-value"
	                }, JSON.stringify(e.value));
	            }
	          }, a.getEditInput = function () {
	            var e = a.props.theme,
	              t = a.state.editValue;
	            return m.a.createElement("div", null, m.a.createElement(se, Object.assign({
	              type: "text",
	              inputRef: function (e) {
	                return e && e.focus();
	              },
	              value: t,
	              className: "variable-editor",
	              onChange: function (e) {
	                var t = e.target.value,
	                  n = ce(t);
	                a.setState({
	                  editValue: t,
	                  parsedInput: {
	                    type: n.type,
	                    value: n.value
	                  }
	                });
	              },
	              onKeyDown: function (e) {
	                switch (e.key) {
	                  case "Escape":
	                    a.setState({
	                      editMode: !1,
	                      editValue: ""
	                    });
	                    break;
	                  case "Enter":
	                    (e.ctrlKey || e.metaKey) && a.submitEdit(!0);
	                }
	                e.stopPropagation();
	              },
	              placeholder: "update this value",
	              minRows: 2
	            }, A(e, "edit-input"))), m.a.createElement("div", A(e, "edit-icon-container"), m.a.createElement(me, Object.assign({
	              className: "edit-cancel"
	            }, A(e, "cancel-icon"), {
	              onClick: function () {
	                a.setState({
	                  editMode: !1,
	                  editValue: ""
	                });
	              }
	            })), m.a.createElement(je, Object.assign({
	              className: "edit-check string-value"
	            }, A(e, "check-icon"), {
	              onClick: function () {
	                a.submitEdit();
	              }
	            })), m.a.createElement("div", null, a.showDetected())));
	          }, a.submitEdit = function (e) {
	            var t = a.props,
	              n = t.variable,
	              r = t.namespace,
	              o = t.rjvId,
	              i = a.state,
	              s = i.editValue,
	              c = i.parsedInput,
	              l = s;
	            e && c.type && (l = c.value), a.setState({
	              editMode: !1
	            }), z.dispatch({
	              name: "VARIABLE_UPDATED",
	              rjvId: o,
	              data: {
	                name: n.name,
	                namespace: r,
	                existing_value: n.value,
	                new_value: l,
	                variable_removed: !1
	              }
	            });
	          }, a.showDetected = function () {
	            var e = a.props,
	              t = e.theme,
	              n = (e.variable, e.namespace, e.rjvId, a.state.parsedInput),
	              r = (n.type, n.value, a.getDetectedInput());
	            if (r) return m.a.createElement("div", null, m.a.createElement("div", A(t, "detected-row"), r, m.a.createElement(je, {
	              className: "edit-check detected",
	              style: o({
	                verticalAlign: "top",
	                paddingLeft: "3px"
	              }, A(t, "check-icon").style),
	              onClick: function () {
	                a.submitEdit(!0);
	              }
	            })));
	          }, a.getDetectedInput = function () {
	            var e = a.state.parsedInput,
	              t = e.type,
	              n = e.value,
	              r = d(a).props,
	              i = r.theme;
	            if (!1 !== t) switch (t.toLowerCase()) {
	              case "object":
	                return m.a.createElement("span", null, m.a.createElement("span", {
	                  style: o(o({}, A(i, "brace").style), {}, {
	                    cursor: "default"
	                  })
	                }, "{"), m.a.createElement("span", {
	                  style: o(o({}, A(i, "ellipsis").style), {}, {
	                    cursor: "default"
	                  })
	                }, "..."), m.a.createElement("span", {
	                  style: o(o({}, A(i, "brace").style), {}, {
	                    cursor: "default"
	                  })
	                }, "}"));
	              case "array":
	                return m.a.createElement("span", null, m.a.createElement("span", {
	                  style: o(o({}, A(i, "brace").style), {}, {
	                    cursor: "default"
	                  })
	                }, "["), m.a.createElement("span", {
	                  style: o(o({}, A(i, "ellipsis").style), {}, {
	                    cursor: "default"
	                  })
	                }, "..."), m.a.createElement("span", {
	                  style: o(o({}, A(i, "brace").style), {}, {
	                    cursor: "default"
	                  })
	                }, "]"));
	              case "string":
	                return m.a.createElement(G, Object.assign({
	                  value: n
	                }, r));
	              case "integer":
	                return m.a.createElement(H, Object.assign({
	                  value: n
	                }, r));
	              case "float":
	                return m.a.createElement(D, Object.assign({
	                  value: n
	                }, r));
	              case "boolean":
	                return m.a.createElement(P, Object.assign({
	                  value: n
	                }, r));
	              case "function":
	                return m.a.createElement(V, Object.assign({
	                  value: n
	                }, r));
	              case "null":
	                return m.a.createElement(W, r);
	              case "nan":
	                return m.a.createElement(K, r);
	              case "undefined":
	                return m.a.createElement(J, r);
	              case "date":
	                return m.a.createElement(F, Object.assign({
	                  value: new Date(n)
	                }, r));
	            }
	          }, a.state = {
	            editMode: !1,
	            editValue: "",
	            hovered: !1,
	            renameKey: !1,
	            parsedInput: {
	              type: !1,
	              value: null
	            }
	          }, a;
	        }
	        return c(n, [{
	          key: "render",
	          value: function () {
	            var e = this,
	              t = this.props,
	              n = t.variable,
	              a = t.singleIndent,
	              r = t.type,
	              i = t.theme,
	              s = t.namespace,
	              c = t.indentWidth,
	              l = t.enableClipboard,
	              u = t.onEdit,
	              f = t.onDelete,
	              p = t.onSelect,
	              d = t.displayArrayKey,
	              b = t.quotesOnKeys,
	              h = this.state.editMode;
	            return m.a.createElement("div", Object.assign({}, A(i, "objectKeyVal", {
	              paddingLeft: c * a
	            }), {
	              onMouseEnter: function () {
	                return e.setState(o(o({}, e.state), {}, {
	                  hovered: !0
	                }));
	              },
	              onMouseLeave: function () {
	                return e.setState(o(o({}, e.state), {}, {
	                  hovered: !1
	                }));
	              },
	              className: "variable-row",
	              key: n.name
	            }), "array" == r ? d ? m.a.createElement("span", Object.assign({}, A(i, "array-key"), {
	              key: n.name + "_" + s
	            }), n.name, m.a.createElement("div", A(i, "colon"), ":")) : null : m.a.createElement("span", null, m.a.createElement("span", Object.assign({}, A(i, "object-name"), {
	              className: "object-key",
	              key: n.name + "_" + s
	            }), !!b && m.a.createElement("span", {
	              style: {
	                verticalAlign: "top"
	              }
	            }, '"'), m.a.createElement("span", {
	              style: {
	                display: "inline-block"
	              }
	            }, n.name), !!b && m.a.createElement("span", {
	              style: {
	                verticalAlign: "top"
	              }
	            }, '"')), m.a.createElement("span", A(i, "colon"), ":")), m.a.createElement("div", Object.assign({
	              className: "variable-value",
	              onClick: !1 === p && !1 === u ? null : function (t) {
	                var a = B(s);
	                (t.ctrlKey || t.metaKey) && !1 !== u ? e.prepopInput(n) : !1 !== p && (a.shift(), p(o(o({}, n), {}, {
	                  namespace: a
	                })));
	              }
	            }, A(i, "variableValue", {
	              cursor: !1 === p ? "default" : "pointer"
	            })), this.getValue(n, h)), l ? m.a.createElement(_e, {
	              rowHovered: this.state.hovered,
	              hidden: h,
	              src: n.value,
	              clickCallback: l,
	              theme: i,
	              namespace: [].concat(B(s), [n.name])
	            }) : null, !1 !== u && 0 == h ? this.getEditIcon() : null, !1 !== f && 0 == h ? this.getRemoveIcon() : null);
	          }
	        }]), n;
	      }(m.a.PureComponent),
	      Oe = function (e) {
	        u(n, e);
	        var t = h(n);
	        function n() {
	          var e;
	          i(this, n);
	          for (var a = arguments.length, r = new Array(a), s = 0; s < a; s++) r[s] = arguments[s];
	          return (e = t.call.apply(t, [this].concat(r))).getObjectSize = function () {
	            var t = e.props,
	              n = t.size,
	              a = t.theme;
	            if (t.displayObjectSize) return m.a.createElement("span", Object.assign({
	              className: "object-size"
	            }, A(a, "object-size")), n, " item", 1 === n ? "" : "s");
	          }, e.getAddAttribute = function (t) {
	            var n = e.props,
	              a = n.theme,
	              r = n.namespace,
	              i = n.name,
	              s = n.src,
	              c = n.rjvId,
	              l = n.depth;
	            return m.a.createElement("span", {
	              className: "click-to-add",
	              style: {
	                verticalAlign: "top",
	                display: t ? "inline-block" : "none"
	              }
	            }, m.a.createElement(ye, Object.assign({
	              className: "click-to-add-icon"
	            }, A(a, "addVarIcon"), {
	              onClick: function () {
	                var e = {
	                  name: l > 0 ? i : null,
	                  namespace: r.splice(0, r.length - 1),
	                  existing_value: s,
	                  variable_removed: !1,
	                  key_name: null
	                };
	                "object" === _(s) ? z.dispatch({
	                  name: "ADD_VARIABLE_KEY_REQUEST",
	                  rjvId: c,
	                  data: e
	                }) : z.dispatch({
	                  name: "VARIABLE_ADDED",
	                  rjvId: c,
	                  data: o(o({}, e), {}, {
	                    new_value: [].concat(B(s), [null])
	                  })
	                });
	              }
	            })));
	          }, e.getRemoveObject = function (t) {
	            var n = e.props,
	              a = n.theme,
	              r = (n.hover, n.namespace),
	              o = n.name,
	              i = n.src,
	              s = n.rjvId;
	            if (1 !== r.length) return m.a.createElement("span", {
	              className: "click-to-remove",
	              style: {
	                display: t ? "inline-block" : "none"
	              }
	            }, m.a.createElement(me, Object.assign({
	              className: "click-to-remove-icon"
	            }, A(a, "removeVarIcon"), {
	              onClick: function () {
	                z.dispatch({
	                  name: "VARIABLE_REMOVED",
	                  rjvId: s,
	                  data: {
	                    name: o,
	                    namespace: r.splice(0, r.length - 1),
	                    existing_value: i,
	                    variable_removed: !0
	                  }
	                });
	              }
	            })));
	          }, e.render = function () {
	            var t = e.props,
	              n = t.theme,
	              a = t.onDelete,
	              r = t.onAdd,
	              o = t.enableClipboard,
	              i = t.src,
	              s = t.namespace,
	              c = t.rowHovered;
	            return m.a.createElement("div", Object.assign({}, A(n, "object-meta-data"), {
	              className: "object-meta-data",
	              onClick: function (e) {
	                e.stopPropagation();
	              }
	            }), e.getObjectSize(), o ? m.a.createElement(_e, {
	              rowHovered: c,
	              clickCallback: o,
	              src: i,
	              theme: n,
	              namespace: s
	            }) : null, !1 !== r ? e.getAddAttribute(c) : null, !1 !== a ? e.getRemoveObject(c) : null);
	          }, e;
	        }
	        return n;
	      }(m.a.PureComponent);
	    function Ce(e) {
	      var t = e.parent_type,
	        n = e.namespace,
	        a = e.quotesOnKeys,
	        r = e.theme,
	        o = e.jsvRoot,
	        i = e.name,
	        s = e.displayArrayKey,
	        c = e.name ? e.name : "";
	      return !o || !1 !== i && null !== i ? "array" == t ? s ? m.a.createElement("span", Object.assign({}, A(r, "array-key"), {
	        key: n
	      }), m.a.createElement("span", {
	        className: "array-key"
	      }, c), m.a.createElement("span", A(r, "colon"), ":")) : m.a.createElement("span", null) : m.a.createElement("span", Object.assign({}, A(r, "object-name"), {
	        key: n
	      }), m.a.createElement("span", {
	        className: "object-key"
	      }, a && m.a.createElement("span", {
	        style: {
	          verticalAlign: "top"
	        }
	      }, '"'), m.a.createElement("span", null, c), a && m.a.createElement("span", {
	        style: {
	          verticalAlign: "top"
	        }
	      }, '"')), m.a.createElement("span", A(r, "colon"), ":")) : m.a.createElement("span", null);
	    }
	    function Se(e) {
	      var t = e.theme;
	      switch (e.iconStyle) {
	        case "triangle":
	          return m.a.createElement(he, Object.assign({}, A(t, "expanded-icon"), {
	            className: "expanded-icon"
	          }));
	        case "square":
	          return m.a.createElement(pe, Object.assign({}, A(t, "expanded-icon"), {
	            className: "expanded-icon"
	          }));
	        default:
	          return m.a.createElement(ue, Object.assign({}, A(t, "expanded-icon"), {
	            className: "expanded-icon"
	          }));
	      }
	    }
	    function we(e) {
	      var t = e.theme;
	      switch (e.iconStyle) {
	        case "triangle":
	          return m.a.createElement(be, Object.assign({}, A(t, "collapsed-icon"), {
	            className: "collapsed-icon"
	          }));
	        case "square":
	          return m.a.createElement(de, Object.assign({}, A(t, "collapsed-icon"), {
	            className: "collapsed-icon"
	          }));
	        default:
	          return m.a.createElement(fe, Object.assign({}, A(t, "collapsed-icon"), {
	            className: "collapsed-icon"
	          }));
	      }
	    }
	    var Ae = function (e) {
	        u(n, e);
	        var t = h(n);
	        function n(e) {
	          var a;
	          return i(this, n), (a = t.call(this, e)).toggleCollapsed = function (e) {
	            var t = [];
	            for (var n in a.state.expanded) t.push(a.state.expanded[n]);
	            t[e] = !t[e], a.setState({
	              expanded: t
	            });
	          }, a.state = {
	            expanded: []
	          }, a;
	        }
	        return c(n, [{
	          key: "getExpandedIcon",
	          value: function (e) {
	            var t = this.props,
	              n = t.theme,
	              a = t.iconStyle;
	            return this.state.expanded[e] ? m.a.createElement(Se, {
	              theme: n,
	              iconStyle: a
	            }) : m.a.createElement(we, {
	              theme: n,
	              iconStyle: a
	            });
	          }
	        }, {
	          key: "render",
	          value: function () {
	            var e = this,
	              t = this.props,
	              n = t.src,
	              a = t.groupArraysAfterLength,
	              r = (t.depth, t.name),
	              o = t.theme,
	              i = t.jsvRoot,
	              s = t.namespace,
	              c = (t.parent_type, x(t, ["src", "groupArraysAfterLength", "depth", "name", "theme", "jsvRoot", "namespace", "parent_type"])),
	              l = 0,
	              u = 5 * this.props.indentWidth;
	            i || (l = 5 * this.props.indentWidth);
	            var f = a,
	              p = Math.ceil(n.length / f);
	            return m.a.createElement("div", Object.assign({
	              className: "object-key-val"
	            }, A(o, i ? "jsv-root" : "objectKeyVal", {
	              paddingLeft: l
	            })), m.a.createElement(Ce, this.props), m.a.createElement("span", null, m.a.createElement(Oe, Object.assign({
	              size: n.length
	            }, this.props))), B(Array(p)).map(function (t, a) {
	              return m.a.createElement("div", Object.assign({
	                key: a,
	                className: "object-key-val array-group"
	              }, A(o, "objectKeyVal", {
	                marginLeft: 6,
	                paddingLeft: u
	              })), m.a.createElement("span", A(o, "brace-row"), m.a.createElement("div", Object.assign({
	                className: "icon-container"
	              }, A(o, "icon-container"), {
	                onClick: function (t) {
	                  e.toggleCollapsed(a);
	                }
	              }), e.getExpandedIcon(a)), e.state.expanded[a] ? m.a.createElement(Fe, Object.assign({
	                key: r + a,
	                depth: 0,
	                name: !1,
	                collapsed: !1,
	                groupArraysAfterLength: f,
	                index_offset: a * f,
	                src: n.slice(a * f, a * f + f),
	                namespace: s,
	                type: "array",
	                parent_type: "array_group",
	                theme: o
	              }, c)) : m.a.createElement("span", Object.assign({}, A(o, "brace"), {
	                onClick: function (t) {
	                  e.toggleCollapsed(a);
	                },
	                className: "array-group-brace"
	              }), "[", m.a.createElement("div", Object.assign({}, A(o, "array-group-meta-data"), {
	                className: "array-group-meta-data"
	              }), m.a.createElement("span", Object.assign({
	                className: "object-size"
	              }, A(o, "object-size")), a * f, " - ", a * f + f > n.length ? n.length : a * f + f)), "]")));
	            }));
	          }
	        }]), n;
	      }(m.a.PureComponent),
	      Me = function (e) {
	        u(n, e);
	        var t = h(n);
	        function n(e) {
	          var a;
	          i(this, n), (a = t.call(this, e)).toggleCollapsed = function () {
	            a.setState({
	              expanded: !a.state.expanded
	            }, function () {
	              q.set(a.props.rjvId, a.props.namespace, "expanded", a.state.expanded);
	            });
	          }, a.getObjectContent = function (e, t, n) {
	            return m.a.createElement("div", {
	              className: "pushed-content object-container"
	            }, m.a.createElement("div", Object.assign({
	              className: "object-content"
	            }, A(a.props.theme, "pushed-content")), a.renderObjectContents(t, n)));
	          }, a.getEllipsis = function () {
	            return 0 === a.state.size ? null : m.a.createElement("div", Object.assign({}, A(a.props.theme, "ellipsis"), {
	              className: "node-ellipsis",
	              onClick: a.toggleCollapsed
	            }), "...");
	          }, a.getObjectMetaData = function (e) {
	            var t = a.props,
	              n = (t.rjvId, t.theme, a.state),
	              r = n.size,
	              o = n.hovered;
	            return m.a.createElement(Oe, Object.assign({
	              rowHovered: o,
	              size: r
	            }, a.props));
	          }, a.renderObjectContents = function (e, t) {
	            var n,
	              r = a.props,
	              o = r.depth,
	              i = r.parent_type,
	              s = r.index_offset,
	              c = r.groupArraysAfterLength,
	              l = r.namespace,
	              u = a.state.object_type,
	              f = [],
	              p = Object.keys(e || {});
	            return a.props.sortKeys && "array" !== u && (p = p.sort()), p.forEach(function (r) {
	              if (n = new Pe(r, e[r]), "array_group" === i && s && (n.name = parseInt(n.name) + s), e.hasOwnProperty(r)) if ("object" === n.type) f.push(m.a.createElement(Fe, Object.assign({
	                key: n.name,
	                depth: o + 1,
	                name: n.name,
	                src: n.value,
	                namespace: l.concat(n.name),
	                parent_type: u
	              }, t)));else if ("array" === n.type) {
	                var p = Fe;
	                c && n.value.length > c && (p = Ae), f.push(m.a.createElement(p, Object.assign({
	                  key: n.name,
	                  depth: o + 1,
	                  name: n.name,
	                  src: n.value,
	                  namespace: l.concat(n.name),
	                  type: "array",
	                  parent_type: u
	                }, t)));
	              } else f.push(m.a.createElement(ke, Object.assign({
	                key: n.name + "_" + l,
	                variable: n,
	                singleIndent: 5,
	                namespace: l,
	                type: a.props.type
	              }, t)));
	            }), f;
	          };
	          var r = n.getState(e);
	          return a.state = o(o({}, r), {}, {
	            prevProps: {}
	          }), a;
	        }
	        return c(n, [{
	          key: "getBraceStart",
	          value: function (e, t) {
	            var n = this,
	              a = this.props,
	              r = a.src,
	              o = a.theme,
	              i = a.iconStyle;
	            if ("array_group" === a.parent_type) return m.a.createElement("span", null, m.a.createElement("span", A(o, "brace"), "array" === e ? "[" : "{"), t ? this.getObjectMetaData(r) : null);
	            var s = t ? Se : we;
	            return m.a.createElement("span", null, m.a.createElement("span", Object.assign({
	              onClick: function (e) {
	                n.toggleCollapsed();
	              }
	            }, A(o, "brace-row")), m.a.createElement("div", Object.assign({
	              className: "icon-container"
	            }, A(o, "icon-container")), m.a.createElement(s, {
	              theme: o,
	              iconStyle: i
	            })), m.a.createElement(Ce, this.props), m.a.createElement("span", A(o, "brace"), "array" === e ? "[" : "{")), t ? this.getObjectMetaData(r) : null);
	          }
	        }, {
	          key: "render",
	          value: function () {
	            var e = this,
	              t = this.props,
	              n = t.depth,
	              a = t.src,
	              r = (t.namespace, t.name, t.type, t.parent_type),
	              i = t.theme,
	              s = t.jsvRoot,
	              c = t.iconStyle,
	              l = x(t, ["depth", "src", "namespace", "name", "type", "parent_type", "theme", "jsvRoot", "iconStyle"]),
	              u = this.state,
	              f = u.object_type,
	              p = u.expanded,
	              d = {};
	            return s || "array_group" === r ? "array_group" === r && (d.borderLeft = 0, d.display = "inline") : d.paddingLeft = 5 * this.props.indentWidth, m.a.createElement("div", Object.assign({
	              className: "object-key-val",
	              onMouseEnter: function () {
	                return e.setState(o(o({}, e.state), {}, {
	                  hovered: !0
	                }));
	              },
	              onMouseLeave: function () {
	                return e.setState(o(o({}, e.state), {}, {
	                  hovered: !1
	                }));
	              }
	            }, A(i, s ? "jsv-root" : "objectKeyVal", d)), this.getBraceStart(f, p), p ? this.getObjectContent(n, a, o({
	              theme: i,
	              iconStyle: c
	            }, l)) : this.getEllipsis(), m.a.createElement("span", {
	              className: "brace-row"
	            }, m.a.createElement("span", {
	              style: o(o({}, A(i, "brace").style), {}, {
	                paddingLeft: p ? "3px" : "0px"
	              })
	            }, "array" === f ? "]" : "}"), p ? null : this.getObjectMetaData(a)));
	          }
	        }], [{
	          key: "getDerivedStateFromProps",
	          value: function (e, t) {
	            var a = t.prevProps;
	            return e.src !== a.src || e.collapsed !== a.collapsed || e.name !== a.name || e.namespace !== a.namespace || e.rjvId !== a.rjvId ? o(o({}, n.getState(e)), {}, {
	              prevProps: e
	            }) : null;
	          }
	        }]), n;
	      }(m.a.PureComponent);
	    Me.getState = function (e) {
	      var t = Object.keys(e.src).length,
	        n = (!1 === e.collapsed || !0 !== e.collapsed && e.collapsed > e.depth) && (!e.shouldCollapse || !1 === e.shouldCollapse({
	          name: e.name,
	          src: e.src,
	          type: _(e.src),
	          namespace: e.namespace
	        })) && 0 !== t;
	      return {
	        expanded: q.get(e.rjvId, e.namespace, "expanded", n),
	        object_type: "array" === e.type ? "array" : "object",
	        parent_type: "array" === e.type ? "array" : "object",
	        size: t,
	        hovered: !1
	      };
	    };
	    var Pe = function e(t, n) {
	      i(this, e), this.name = t, this.value = n, this.type = _(n);
	    };
	    j(Me);
	    var Fe = Me,
	      De = function (e) {
	        u(n, e);
	        var t = h(n);
	        function n() {
	          var e;
	          i(this, n);
	          for (var a = arguments.length, r = new Array(a), o = 0; o < a; o++) r[o] = arguments[o];
	          return (e = t.call.apply(t, [this].concat(r))).render = function () {
	            var t = d(e).props,
	              n = [t.name],
	              a = Fe;
	            return Array.isArray(t.src) && t.groupArraysAfterLength && t.src.length > t.groupArraysAfterLength && (a = Ae), m.a.createElement("div", {
	              className: "pretty-json-container object-container"
	            }, m.a.createElement("div", {
	              className: "object-content"
	            }, m.a.createElement(a, Object.assign({
	              namespace: n,
	              depth: 0,
	              jsvRoot: !0
	            }, t))));
	          }, e;
	        }
	        return n;
	      }(m.a.PureComponent),
	      Ie = function (e) {
	        u(n, e);
	        var t = h(n);
	        function n(e) {
	          var a;
	          return i(this, n), (a = t.call(this, e)).closeModal = function () {
	            z.dispatch({
	              rjvId: a.props.rjvId,
	              name: "RESET"
	            });
	          }, a.submit = function () {
	            a.props.submit(a.state.input);
	          }, a.state = {
	            input: e.input ? e.input : ""
	          }, a;
	        }
	        return c(n, [{
	          key: "render",
	          value: function () {
	            var e = this,
	              t = this.props,
	              n = t.theme,
	              a = t.rjvId,
	              r = t.isValid,
	              o = this.state.input,
	              i = r(o);
	            return m.a.createElement("div", Object.assign({
	              className: "key-modal-request"
	            }, A(n, "key-modal-request"), {
	              onClick: this.closeModal
	            }), m.a.createElement("div", Object.assign({}, A(n, "key-modal"), {
	              onClick: function (e) {
	                e.stopPropagation();
	              }
	            }), m.a.createElement("div", A(n, "key-modal-label"), "Key Name:"), m.a.createElement("div", {
	              style: {
	                position: "relative"
	              }
	            }, m.a.createElement("input", Object.assign({}, A(n, "key-modal-input"), {
	              className: "key-modal-input",
	              ref: function (e) {
	                return e && e.focus();
	              },
	              spellCheck: !1,
	              value: o,
	              placeholder: "...",
	              onChange: function (t) {
	                e.setState({
	                  input: t.target.value
	                });
	              },
	              onKeyPress: function (t) {
	                i && "Enter" === t.key ? e.submit() : "Escape" === t.key && e.closeModal();
	              }
	            })), i ? m.a.createElement(je, Object.assign({}, A(n, "key-modal-submit"), {
	              className: "key-modal-submit",
	              onClick: function (t) {
	                return e.submit();
	              }
	            })) : null), m.a.createElement("span", A(n, "key-modal-cancel"), m.a.createElement(ge, Object.assign({}, A(n, "key-modal-cancel-icon"), {
	              className: "key-modal-cancel",
	              onClick: function () {
	                z.dispatch({
	                  rjvId: a,
	                  name: "RESET"
	                });
	              }
	            })))));
	          }
	        }]), n;
	      }(m.a.PureComponent),
	      Re = function (e) {
	        u(n, e);
	        var t = h(n);
	        function n() {
	          var e;
	          i(this, n);
	          for (var a = arguments.length, r = new Array(a), s = 0; s < a; s++) r[s] = arguments[s];
	          return (e = t.call.apply(t, [this].concat(r))).isValid = function (t) {
	            var n = e.props.rjvId,
	              a = q.get(n, "action", "new-key-request");
	            return "" != t && -1 === Object.keys(a.existing_value).indexOf(t);
	          }, e.submit = function (t) {
	            var n = e.props.rjvId,
	              a = q.get(n, "action", "new-key-request");
	            a.new_value = o({}, a.existing_value), a.new_value[t] = e.props.defaultValue, z.dispatch({
	              name: "VARIABLE_ADDED",
	              rjvId: n,
	              data: a
	            });
	          }, e;
	        }
	        return c(n, [{
	          key: "render",
	          value: function () {
	            var e = this.props,
	              t = e.active,
	              n = e.theme,
	              a = e.rjvId;
	            return t ? m.a.createElement(Ie, {
	              rjvId: a,
	              theme: n,
	              isValid: this.isValid,
	              submit: this.submit
	            }) : null;
	          }
	        }]), n;
	      }(m.a.PureComponent),
	      Le = function (e) {
	        u(n, e);
	        var t = h(n);
	        function n() {
	          return i(this, n), t.apply(this, arguments);
	        }
	        return c(n, [{
	          key: "render",
	          value: function () {
	            var e = this.props,
	              t = e.message,
	              n = e.active,
	              a = e.theme,
	              r = e.rjvId;
	            return n ? m.a.createElement("div", Object.assign({
	              className: "validation-failure"
	            }, A(a, "validation-failure"), {
	              onClick: function () {
	                z.dispatch({
	                  rjvId: r,
	                  name: "RESET"
	                });
	              }
	            }), m.a.createElement("span", A(a, "validation-failure-label"), t), m.a.createElement(ge, A(a, "validation-failure-clear"))) : null;
	          }
	        }]), n;
	      }(m.a.PureComponent),
	      Be = function (e) {
	        u(n, e);
	        var t = h(n);
	        function n(e) {
	          var a;
	          return i(this, n), (a = t.call(this, e)).rjvId = Date.now().toString(), a.getListeners = function () {
	            return {
	              reset: a.resetState,
	              "variable-update": a.updateSrc,
	              "add-key-request": a.addKeyRequest
	            };
	          }, a.updateSrc = function () {
	            var e,
	              t = q.get(a.rjvId, "action", "variable-update"),
	              n = t.name,
	              r = t.namespace,
	              o = t.new_value,
	              i = t.existing_value,
	              s = (t.variable_removed, t.updated_src),
	              c = t.type,
	              l = a.props,
	              u = l.onEdit,
	              f = l.onDelete,
	              p = l.onAdd,
	              d = {
	                existing_src: a.state.src,
	                new_value: o,
	                updated_src: s,
	                name: n,
	                namespace: r,
	                existing_value: i
	              };
	            switch (c) {
	              case "variable-added":
	                e = p(d);
	                break;
	              case "variable-edited":
	                e = u(d);
	                break;
	              case "variable-removed":
	                e = f(d);
	            }
	            !1 !== e ? (q.set(a.rjvId, "global", "src", s), a.setState({
	              src: s
	            })) : a.setState({
	              validationFailure: !0
	            });
	          }, a.addKeyRequest = function () {
	            a.setState({
	              addKeyRequest: !0
	            });
	          }, a.resetState = function () {
	            a.setState({
	              validationFailure: !1,
	              addKeyRequest: !1
	            });
	          }, a.state = {
	            addKeyRequest: !1,
	            editKeyRequest: !1,
	            validationFailure: !1,
	            src: n.defaultProps.src,
	            name: n.defaultProps.name,
	            theme: n.defaultProps.theme,
	            validationMessage: n.defaultProps.validationMessage,
	            prevSrc: n.defaultProps.src,
	            prevName: n.defaultProps.name,
	            prevTheme: n.defaultProps.theme
	          }, a;
	        }
	        return c(n, [{
	          key: "componentDidMount",
	          value: function () {
	            q.set(this.rjvId, "global", "src", this.state.src);
	            var e = this.getListeners();
	            for (var t in e) q.on(t + "-" + this.rjvId, e[t]);
	            this.setState({
	              addKeyRequest: !1,
	              editKeyRequest: !1
	            });
	          }
	        }, {
	          key: "componentDidUpdate",
	          value: function (e, t) {
	            !1 !== t.addKeyRequest && this.setState({
	              addKeyRequest: !1
	            }), !1 !== t.editKeyRequest && this.setState({
	              editKeyRequest: !1
	            }), e.src !== this.state.src && q.set(this.rjvId, "global", "src", this.state.src);
	          }
	        }, {
	          key: "componentWillUnmount",
	          value: function () {
	            var e = this.getListeners();
	            for (var t in e) q.removeListener(t + "-" + this.rjvId, e[t]);
	          }
	        }, {
	          key: "render",
	          value: function () {
	            var e = this.state,
	              t = e.validationFailure,
	              n = e.validationMessage,
	              a = e.addKeyRequest,
	              r = e.theme,
	              i = e.src,
	              s = e.name,
	              c = this.props,
	              l = c.style,
	              u = c.defaultValue;
	            return m.a.createElement("div", {
	              className: "react-json-view",
	              style: o(o({}, A(r, "app-container").style), l)
	            }, m.a.createElement(Le, {
	              message: n,
	              active: t,
	              theme: r,
	              rjvId: this.rjvId
	            }), m.a.createElement(De, Object.assign({}, this.props, {
	              src: i,
	              name: s,
	              theme: r,
	              type: _(i),
	              rjvId: this.rjvId
	            })), m.a.createElement(Re, {
	              active: a,
	              theme: r,
	              rjvId: this.rjvId,
	              defaultValue: u
	            }));
	          }
	        }], [{
	          key: "getDerivedStateFromProps",
	          value: function (e, t) {
	            if (e.src !== t.prevSrc || e.name !== t.prevName || e.theme !== t.prevTheme) {
	              var a = {
	                src: e.src,
	                name: e.name,
	                theme: e.theme,
	                validationMessage: e.validationMessage,
	                prevSrc: e.src,
	                prevName: e.name,
	                prevTheme: e.theme
	              };
	              return n.validateState(a);
	            }
	            return null;
	          }
	        }]), n;
	      }(m.a.PureComponent);
	    Be.defaultProps = {
	      src: {},
	      name: "root",
	      theme: "rjv-default",
	      collapsed: !1,
	      collapseStringsAfterLength: !1,
	      shouldCollapse: !1,
	      sortKeys: !1,
	      quotesOnKeys: !0,
	      groupArraysAfterLength: 100,
	      indentWidth: 4,
	      enableClipboard: !0,
	      displayObjectSize: !0,
	      displayDataTypes: !0,
	      onEdit: !1,
	      onDelete: !1,
	      onAdd: !1,
	      onSelect: !1,
	      iconStyle: "triangle",
	      style: {},
	      validationMessage: "Validation Error",
	      defaultValue: null,
	      displayArrayKey: !0
	    }, Be.validateState = function (e) {
	      var t = {};
	      return "object" !== _(e.theme) || function (e) {
	        var t = ["base00", "base01", "base02", "base03", "base04", "base05", "base06", "base07", "base08", "base09", "base0A", "base0B", "base0C", "base0D", "base0E", "base0F"];
	        if ("object" === _(e)) {
	          for (var n = 0; n < t.length; n++) if (!(t[n] in e)) return !1;
	          return !0;
	        }
	        return !1;
	      }(e.theme) || (console.error("react-json-view error:", "theme prop must be a theme name or valid base-16 theme object.", 'defaulting to "rjv-default" theme'), t.theme = "rjv-default"), "object" !== _(e.src) && "array" !== _(e.src) && (console.error("react-json-view error:", "src property must be a valid json object"), t.name = "ERROR", t.src = {
	        message: "src property must be a valid json object"
	      }), o(o({}, e), t);
	    }, j(Be);
	    t.default = Be;
	  }]);
	});
} (main$2));

var ReactJson = /*@__PURE__*/getDefaultExportFromCjs(main$2.exports);

var KEY_PREFIX = 'persist:';
var FLUSH = 'persist/FLUSH';
var REHYDRATE = 'persist/REHYDRATE';
var PAUSE = 'persist/PAUSE';
var PERSIST = 'persist/PERSIST';
var PURGE = 'persist/PURGE';
var REGISTER = 'persist/REGISTER';
var DEFAULT_VERSION = -1;

function _typeof$1(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$1 = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$1 = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof$1(obj);
}
function ownKeys$2(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$2(source, true).forEach(function (key) {
        _defineProperty$2(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$2(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _defineProperty$2(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/*
  autoMergeLevel1: 
    - merges 1 level of substate
    - skips substate if already modified
*/
function autoMergeLevel1(inboundState, originalState, reducedState, _ref) {
  var debug = _ref.debug;
  var newState = _objectSpread$2({}, reducedState); // only rehydrate if inboundState exists and is an object

  if (inboundState && _typeof$1(inboundState) === 'object') {
    Object.keys(inboundState).forEach(function (key) {
      // ignore _persist data
      if (key === '_persist') return; // if reducer modifies substate, skip auto rehydration

      if (originalState[key] !== reducedState[key]) {
        if (process.env.NODE_ENV !== 'production' && debug) console.log('redux-persist/stateReconciler: sub state for key `%s` modified, skipping.', key);
        return;
      } // otherwise hard set the new value

      newState[key] = inboundState[key];
    });
  }
  if (process.env.NODE_ENV !== 'production' && debug && inboundState && _typeof$1(inboundState) === 'object') console.log("redux-persist/stateReconciler: rehydrated keys '".concat(Object.keys(inboundState).join(', '), "'"));
  return newState;
}

// @TODO remove once flow < 0.63 support is no longer required.
function createPersistoid(config) {
  // defaults
  var blacklist = config.blacklist || null;
  var whitelist = config.whitelist || null;
  var transforms = config.transforms || [];
  var throttle = config.throttle || 0;
  var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : KEY_PREFIX).concat(config.key);
  var storage = config.storage;
  var serialize;
  if (config.serialize === false) {
    serialize = function serialize(x) {
      return x;
    };
  } else if (typeof config.serialize === 'function') {
    serialize = config.serialize;
  } else {
    serialize = defaultSerialize;
  }
  var writeFailHandler = config.writeFailHandler || null; // initialize stateful values

  var lastState = {};
  var stagedState = {};
  var keysToProcess = [];
  var timeIterator = null;
  var writePromise = null;
  var update = function update(state) {
    // add any changed keys to the queue
    Object.keys(state).forEach(function (key) {
      if (!passWhitelistBlacklist(key)) return; // is keyspace ignored? noop

      if (lastState[key] === state[key]) return; // value unchanged? noop

      if (keysToProcess.indexOf(key) !== -1) return; // is key already queued? noop

      keysToProcess.push(key); // add key to queue
    }); //if any key is missing in the new state which was present in the lastState,
    //add it for processing too

    Object.keys(lastState).forEach(function (key) {
      if (state[key] === undefined && passWhitelistBlacklist(key) && keysToProcess.indexOf(key) === -1 && lastState[key] !== undefined) {
        keysToProcess.push(key);
      }
    }); // start the time iterator if not running (read: throttle)

    if (timeIterator === null) {
      timeIterator = setInterval(processNextKey, throttle);
    }
    lastState = state;
  };
  function processNextKey() {
    if (keysToProcess.length === 0) {
      if (timeIterator) clearInterval(timeIterator);
      timeIterator = null;
      return;
    }
    var key = keysToProcess.shift();
    var endState = transforms.reduce(function (subState, transformer) {
      return transformer.in(subState, key, lastState);
    }, lastState[key]);
    if (endState !== undefined) {
      try {
        stagedState[key] = serialize(endState);
      } catch (err) {
        console.error('redux-persist/createPersistoid: error serializing state', err);
      }
    } else {
      //if the endState is undefined, no need to persist the existing serialized content
      delete stagedState[key];
    }
    if (keysToProcess.length === 0) {
      writeStagedState();
    }
  }
  function writeStagedState() {
    // cleanup any removed keys just before write.
    Object.keys(stagedState).forEach(function (key) {
      if (lastState[key] === undefined) {
        delete stagedState[key];
      }
    });
    writePromise = storage.setItem(storageKey, serialize(stagedState)).catch(onWriteFail);
  }
  function passWhitelistBlacklist(key) {
    if (whitelist && whitelist.indexOf(key) === -1 && key !== '_persist') return false;
    if (blacklist && blacklist.indexOf(key) !== -1) return false;
    return true;
  }
  function onWriteFail(err) {
    // @TODO add fail handlers (typically storage full)
    if (writeFailHandler) writeFailHandler(err);
    if (err && process.env.NODE_ENV !== 'production') {
      console.error('Error storing data', err);
    }
  }
  var flush = function flush() {
    while (keysToProcess.length !== 0) {
      processNextKey();
    }
    return writePromise || Promise.resolve();
  }; // return `persistoid`

  return {
    update: update,
    flush: flush
  };
} // @NOTE in the future this may be exposed via config

function defaultSerialize(data) {
  return JSON.stringify(data);
}

function getStoredState(config) {
  var transforms = config.transforms || [];
  var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : KEY_PREFIX).concat(config.key);
  var storage = config.storage;
  var debug = config.debug;
  var deserialize;
  if (config.deserialize === false) {
    deserialize = function deserialize(x) {
      return x;
    };
  } else if (typeof config.deserialize === 'function') {
    deserialize = config.deserialize;
  } else {
    deserialize = defaultDeserialize;
  }
  return storage.getItem(storageKey).then(function (serialized) {
    if (!serialized) return undefined;else {
      try {
        var state = {};
        var rawState = deserialize(serialized);
        Object.keys(rawState).forEach(function (key) {
          state[key] = transforms.reduceRight(function (subState, transformer) {
            return transformer.out(subState, key, rawState);
          }, deserialize(rawState[key]));
        });
        return state;
      } catch (err) {
        if (process.env.NODE_ENV !== 'production' && debug) console.log("redux-persist/getStoredState: Error restoring data ".concat(serialized), err);
        throw err;
      }
    }
  });
}
function defaultDeserialize(serial) {
  return JSON.parse(serial);
}

function purgeStoredState(config) {
  var storage = config.storage;
  var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : KEY_PREFIX).concat(config.key);
  return storage.removeItem(storageKey, warnIfRemoveError);
}
function warnIfRemoveError(err) {
  if (err && process.env.NODE_ENV !== 'production') {
    console.error('redux-persist/purgeStoredState: Error purging data stored state', err);
  }
}

function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$1(source, true).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var DEFAULT_TIMEOUT = 5000;
/*
  @TODO add validation / handling for:
  - persisting a reducer which has nested _persist
  - handling actions that fire before reydrate is called
*/

function persistReducer(config, baseReducer) {
  if (process.env.NODE_ENV !== 'production') {
    if (!config) throw new Error('config is required for persistReducer');
    if (!config.key) throw new Error('key is required in persistor config');
    if (!config.storage) throw new Error("redux-persist: config.storage is required. Try using one of the provided storage engines `import storage from 'redux-persist/lib/storage'`");
  }
  var version = config.version !== undefined ? config.version : DEFAULT_VERSION;
  config.debug || false;
  var stateReconciler = config.stateReconciler === undefined ? autoMergeLevel1 : config.stateReconciler;
  var getStoredState$1 = config.getStoredState || getStoredState;
  var timeout = config.timeout !== undefined ? config.timeout : DEFAULT_TIMEOUT;
  var _persistoid = null;
  var _purge = false;
  var _paused = true;
  var conditionalUpdate = function conditionalUpdate(state) {
    // update the persistoid only if we are rehydrated and not paused
    state._persist.rehydrated && _persistoid && !_paused && _persistoid.update(state);
    return state;
  };
  return function (state, action) {
    var _ref = state || {},
      _persist = _ref._persist,
      rest = _objectWithoutProperties(_ref, ["_persist"]); // $FlowIgnore need to update State type

    var restState = rest;
    if (action.type === PERSIST) {
      var _sealed = false;
      var _rehydrate = function _rehydrate(payload, err) {
        // dev warning if we are already sealed
        if (process.env.NODE_ENV !== 'production' && _sealed) console.error("redux-persist: rehydrate for \"".concat(config.key, "\" called after timeout."), payload, err); // only rehydrate if we are not already sealed

        if (!_sealed) {
          action.rehydrate(config.key, payload, err);
          _sealed = true;
        }
      };
      timeout && setTimeout(function () {
        !_sealed && _rehydrate(undefined, new Error("redux-persist: persist timed out for persist key \"".concat(config.key, "\"")));
      }, timeout); // @NOTE PERSIST resumes if paused.

      _paused = false; // @NOTE only ever create persistoid once, ensure we call it at least once, even if _persist has already been set

      if (!_persistoid) _persistoid = createPersistoid(config); // @NOTE PERSIST can be called multiple times, noop after the first

      if (_persist) {
        // We still need to call the base reducer because there might be nested
        // uses of persistReducer which need to be aware of the PERSIST action
        return _objectSpread$1({}, baseReducer(restState, action), {
          _persist: _persist
        });
      }
      if (typeof action.rehydrate !== 'function' || typeof action.register !== 'function') throw new Error('redux-persist: either rehydrate or register is not a function on the PERSIST action. This can happen if the action is being replayed. This is an unexplored use case, please open an issue and we will figure out a resolution.');
      action.register(config.key);
      getStoredState$1(config).then(function (restoredState) {
        var migrate = config.migrate || function (s, v) {
          return Promise.resolve(s);
        };
        migrate(restoredState, version).then(function (migratedState) {
          _rehydrate(migratedState);
        }, function (migrateErr) {
          if (process.env.NODE_ENV !== 'production' && migrateErr) console.error('redux-persist: migration error', migrateErr);
          _rehydrate(undefined, migrateErr);
        });
      }, function (err) {
        _rehydrate(undefined, err);
      });
      return _objectSpread$1({}, baseReducer(restState, action), {
        _persist: {
          version: version,
          rehydrated: false
        }
      });
    } else if (action.type === PURGE) {
      _purge = true;
      action.result(purgeStoredState(config));
      return _objectSpread$1({}, baseReducer(restState, action), {
        _persist: _persist
      });
    } else if (action.type === FLUSH) {
      action.result(_persistoid && _persistoid.flush());
      return _objectSpread$1({}, baseReducer(restState, action), {
        _persist: _persist
      });
    } else if (action.type === PAUSE) {
      _paused = true;
    } else if (action.type === REHYDRATE) {
      // noop on restState if purging
      if (_purge) return _objectSpread$1({}, restState, {
        _persist: _objectSpread$1({}, _persist, {
          rehydrated: true
        }) // @NOTE if key does not match, will continue to default else below
      });
      if (action.key === config.key) {
        var reducedState = baseReducer(restState, action);
        var inboundState = action.payload; // only reconcile state if stateReconciler and inboundState are both defined

        var reconciledRest = stateReconciler !== false && inboundState !== undefined ? stateReconciler(inboundState, state, reducedState, config) : reducedState;
        var _newState = _objectSpread$1({}, reconciledRest, {
          _persist: _objectSpread$1({}, _persist, {
            rehydrated: true
          })
        });
        return conditionalUpdate(_newState);
      }
    } // if we have not already handled PERSIST, straight passthrough

    if (!_persist) return baseReducer(state, action); // run base reducer:
    // is state modified ? return original : return updated

    var newState = baseReducer(restState, action);
    if (newState === restState) return state;
    return conditionalUpdate(_objectSpread$1({}, newState, {
      _persist: _persist
    }));
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  }
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var initialState = {
  registry: [],
  bootstrapped: false
};
var persistorReducer = function persistorReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case REGISTER:
      return _objectSpread({}, state, {
        registry: [].concat(_toConsumableArray(state.registry), [action.key])
      });
    case REHYDRATE:
      var firstIndex = state.registry.indexOf(action.key);
      var registry = _toConsumableArray(state.registry);
      registry.splice(firstIndex, 1);
      return _objectSpread({}, state, {
        registry: registry,
        bootstrapped: registry.length === 0
      });
    default:
      return state;
  }
};
function persistStore(store, options, cb) {
  // help catch incorrect usage of passing PersistConfig in as PersistorOptions
  if (process.env.NODE_ENV !== 'production') {
    var optionsToTest = options || {};
    var bannedKeys = ['blacklist', 'whitelist', 'transforms', 'storage', 'keyPrefix', 'migrate'];
    bannedKeys.forEach(function (k) {
      if (!!optionsToTest[k]) console.error("redux-persist: invalid option passed to persistStore: \"".concat(k, "\". You may be incorrectly passing persistConfig into persistStore, whereas it should be passed into persistReducer."));
    });
  }
  var boostrappedCb = cb || false;
  var _pStore = createStore(persistorReducer, initialState, options && options.enhancer ? options.enhancer : undefined);
  var register = function register(key) {
    _pStore.dispatch({
      type: REGISTER,
      key: key
    });
  };
  var rehydrate = function rehydrate(key, payload, err) {
    var rehydrateAction = {
      type: REHYDRATE,
      payload: payload,
      err: err,
      key: key // dispatch to `store` to rehydrate and `persistor` to track result
    };
    store.dispatch(rehydrateAction);
    _pStore.dispatch(rehydrateAction);
    if (boostrappedCb && persistor.getState().bootstrapped) {
      boostrappedCb();
      boostrappedCb = false;
    }
  };
  var persistor = _objectSpread({}, _pStore, {
    purge: function purge() {
      var results = [];
      store.dispatch({
        type: PURGE,
        result: function result(purgeResult) {
          results.push(purgeResult);
        }
      });
      return Promise.all(results);
    },
    flush: function flush() {
      var results = [];
      store.dispatch({
        type: FLUSH,
        result: function result(flushResult) {
          results.push(flushResult);
        }
      });
      return Promise.all(results);
    },
    pause: function pause() {
      store.dispatch({
        type: PAUSE
      });
    },
    persist: function persist() {
      store.dispatch({
        type: PERSIST,
        register: register,
        rehydrate: rehydrate
      });
    }
  });
  if (!(options && options.manualPersist)) {
    persistor.persist();
  }
  return persistor;
}

var createWebStorage$1 = {};

var getStorage$1 = {};

getStorage$1.__esModule = true;
getStorage$1.default = getStorage;
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function noop() {}
var noopStorage = {
  getItem: noop,
  setItem: noop,
  removeItem: noop
};
function hasStorage(storageType) {
  if ((typeof self === "undefined" ? "undefined" : _typeof(self)) !== 'object' || !(storageType in self)) {
    return false;
  }
  try {
    var storage = self[storageType];
    var testKey = "redux-persist ".concat(storageType, " test");
    storage.setItem(testKey, 'test');
    storage.getItem(testKey);
    storage.removeItem(testKey);
  } catch (e) {
    if (process.env.NODE_ENV !== 'production') console.warn("redux-persist ".concat(storageType, " test failed, persistence will be disabled."));
    return false;
  }
  return true;
}
function getStorage(type) {
  var storageType = "".concat(type, "Storage");
  if (hasStorage(storageType)) return self[storageType];else {
    if (process.env.NODE_ENV !== 'production') {
      console.error("redux-persist failed to create sync storage. falling back to noop storage.");
    }
    return noopStorage;
  }
}

createWebStorage$1.__esModule = true;
createWebStorage$1.default = createWebStorage;
var _getStorage = _interopRequireDefault$1(getStorage$1);
function _interopRequireDefault$1(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function createWebStorage(type) {
  var storage = (0, _getStorage.default)(type);
  return {
    getItem: function getItem(key) {
      return new Promise(function (resolve, reject) {
        resolve(storage.getItem(key));
      });
    },
    setItem: function setItem(key, item) {
      return new Promise(function (resolve, reject) {
        resolve(storage.setItem(key, item));
      });
    },
    removeItem: function removeItem(key) {
      return new Promise(function (resolve, reject) {
        resolve(storage.removeItem(key));
      });
    }
  };
}

var default_1 = void 0;
var _createWebStorage = _interopRequireDefault(createWebStorage$1);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var _default = (0, _createWebStorage.default)('local');
default_1 = _default;

const persistConfig = {
  key: 'root',
  version: 1,
  storage: default_1
};
const combinedReducer = combineReducers({
  setlist: setlistReducer,
  session: sessionReducer,
  auth: authReducer,
  library: libraryReducer,
  ui: uiReducer,
  offline: offlineReducer,
  setlists: setlistsReducer,
  lyrics: lyricsReducer
});
const persistedReducer = persistReducer(persistConfig, combinedReducer);
const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware => getDefaultMiddleware({
    serializableCheck: {
      ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
    }
  })
});
const persistor = persistStore(store);

var name$1 = "player-application";
var version$1 = "0.14.25";
var main$1 = "output.js";
var dependencies$1 = {
	"@emotion/react": "^11.9.0",
	"@emotion/styled": "^11.8.1",
	"@headlessui/react": "^1.6.4",
	"@heroicons/react": "^1.0.6",
	"@mui/material": "^5.5.2",
	"@reactour/tour": "^3.1.10",
	"@reactour/utils": "^0.3.0",
	"@reduxjs/toolkit": "^1.7.1",
	"@tailwindcss/forms": "^0.4.0",
	"@tailwindcss/typography": "^0.5.0",
	"@testing-library/jest-dom": "^5.16.4",
	"@testing-library/react": "^11.2.7",
	"@testing-library/user-event": "^12.8.3",
	"@zip.js/zip.js": "^2.4.1",
	"audio-encoder": "^1.0.4",
	"convert-audio": "^1.0.1",
	"date-fns": "^2.28.0",
	"gh-pages": "^3.2.3",
	"js-cookie": "^3.0.1",
	ky: "0.31.1",
	lamejs: "git+https://github.com/zhuker/lamejs.git",
	localforage: "^1.10.0",
	platform: "^1.3.6",
	"player-components": "file:/Users/peterwoods/3fire_browser_player/the_base_choirplayer/player-components/player-components-v0.4.21.tgz",
	"rc-slider": "^10.0.0-alpha.5",
	react: "17.0.2",
	"react-dnd": "^15.1.1",
	"react-dnd-html5-backend": "^15.1.2",
	"react-dom": "17.0.2",
	"react-ga4": "^1.4.1",
	"react-hook-screen-orientation": "^1.0.4",
	"react-ios-pwa-prompt": "^1.8.4",
	"react-json-view": "^1.21.3",
	"react-lottie": "^1.2.3",
	"react-redux": "^7.2.6",
	"react-router-dom": "6",
	"react-scripts": "5.0.1",
	"react-simple-star-rating": "^4.0.5",
	"react-web-share": "^1.1.6",
	"redux-persist": "^6.0.0",
	tailwindcss: "^3.1.2",
	uuid: "^8.3.2",
	"web-vitals": "^0.2.4",
	"workbox-background-sync": "^5.1.4",
	"workbox-broadcast-update": "^5.1.4",
	"workbox-cacheable-response": "^5.1.4",
	"workbox-core": "^5.1.4",
	"workbox-expiration": "^5.1.4",
	"workbox-google-analytics": "^5.1.4",
	"workbox-navigation-preload": "^5.1.4",
	"workbox-precaching": "^5.1.4",
	"workbox-range-requests": "^5.1.4",
	"workbox-routing": "^5.1.4",
	"workbox-strategies": "^5.1.4",
	"workbox-streams": "^5.1.4"
};
var scripts$1 = {
	predeploy: "npm run build",
	deploy: "gh-pages -d build",
	start: "react-scripts start",
	build: "react-scripts build",
	"build:lib": "NODE_ENV=production rollup -c",
	"build:tailwind": "npx tailwindcss -i ./src/tailwindInput.css -o ./public/tailwindOutput.css",
	"build:tailwind:watch": "npx tailwindcss -i ./src/tailwindInput.css -o ./public/tailwindOutput.css --watch",
	test: "react-scripts test",
	eject: "react-scripts eject"
};
var eslintConfig$1 = {
	"extends": [
		"react-app",
		"react-app/jest"
	]
};
var browserslist$1 = {
	production: [
		">0.2%",
		"not dead",
		"not op_mini all"
	],
	development: [
		"last 1 chrome version",
		"last 1 firefox version",
		"last 1 safari version"
	]
};
var devDependencies$1 = {
	"@babel/preset-env": "^7.18.2",
	"@babel/preset-react": "^7.17.12",
	"@rollup/plugin-babel": "^5.3.1",
	"@rollup/plugin-commonjs": "^22.0.0",
	"@rollup/plugin-json": "^4.1.0",
	"@rollup/plugin-node-resolve": "^13.3.0",
	autoprefixer: "^10.4.2",
	"babel-loader": "^8.2.5",
	postcss: "^8.4.6",
	rollup: "^2.75.6",
	"rollup-plugin-postcss": "^4.0.2",
	"rollup-plugin-svg": "^2.0.0"
};
var peerDependencies$1 = {
	react: "17.0.2",
	"react-dom": "17.0.2"
};
var PackageJSON = {
	name: name$1,
	version: version$1,
	main: main$1,
	"private": true,
	dependencies: dependencies$1,
	scripts: scripts$1,
	eslintConfig: eslintConfig$1,
	browserslist: browserslist$1,
	devDependencies: devDependencies$1,
	peerDependencies: peerDependencies$1
};

var name = "player-components";
var version = "0.4.21";
var main = "output.js";
var dependencies = {
	"@babel/core": "^7.16.12",
	"@babel/preset-env": "^7.16.11",
	"@babel/preset-react": "^7.16.7",
	"@emotion/react": "^11.8.2",
	"@emotion/styled": "^11.8.1",
	"@headlessui/react": "^1.6.4",
	"@heroicons/react": "^2.0.10",
	"@ljcl/storybook-addon-cssprops": "^2.3.2",
	"@mui/material": "^5.10.1",
	"@reduxjs/toolkit": "^1.7.1",
	"@rollup/plugin-babel": "^5.3.0",
	"@rollup/plugin-node-resolve": "^13.1.3",
	"@tailwindcss/aspect-ratio": "^0.4.0",
	"@tailwindcss/forms": "^0.4.0",
	"@testing-library/jest-dom": "^5.14.1",
	"@testing-library/react": "^12.0.0",
	"@testing-library/user-event": "^13.2.1",
	"@use-gesture/react": "^10.2.19",
	"babel-loader": "^8.2.3",
	"rc-slider": "^10.0.0-alpha.5",
	"react-lrc": "^2.1.5",
	"react-redux": "^7.2.6",
	"react-rotary-knob": "^1.1.8",
	"react-rotary-knob-skin-pack": "^1.0.2",
	"react-scripts": "5.0.0",
	"react-slider": "^2.0.0",
	"react-web-share": "^1.1.6",
	rollup: "^2.66.1",
	"rollup-plugin-postcss": "^4.0.2",
	underscore: "^1.13.2",
	"web-vitals": "^2.1.0"
};
var scripts = {
	start: "react-scripts start",
	build: "NODE_ENV=production rollup -c",
	test: "react-scripts test",
	eject: "react-scripts eject",
	storybook: "start-storybook -p 6006 -s public",
	"build-storybook": "build-storybook -s public",
	"build:tailwind": "npx tailwindcss -i ./src/input.css -o ./dist/output.css"
};
var eslintConfig = {
	"extends": [
		"react-app",
		"react-app/jest"
	],
	overrides: [
		{
			files: [
				"**/*.stories.*"
			],
			rules: {
				"import/no-anonymous-default-export": "off"
			}
		}
	]
};
var browserslist = {
	production: [
		">0.2%",
		"not dead",
		"not op_mini all"
	],
	development: [
		"last 1 chrome version",
		"last 1 firefox version",
		"last 1 safari version"
	]
};
var devDependencies = {
	"@rollup/plugin-commonjs": "^21.0.2",
	"@storybook/addon-actions": "^6.4.10",
	"@storybook/addon-console": "^1.2.3",
	"@storybook/addon-essentials": "^6.4.9",
	"@storybook/addon-interactions": "^6.4.9",
	"@storybook/addon-links": "^6.4.9",
	"@storybook/addon-storyshots": "^6.4.9",
	"@storybook/builder-webpack5": "^6.4.9",
	"@storybook/jest": "^0.0.5",
	"@storybook/manager-webpack5": "^6.4.9",
	"@storybook/node-logger": "^6.4.9",
	"@storybook/preset-create-react-app": "^4.0.0",
	"@storybook/react": "^6.4.9",
	"@storybook/testing-library": "^0.0.7",
	"@tailwindcss/typography": "^0.5.0",
	autoprefixer: "^10.4.1",
	postcss: "^8.4.5",
	prettier: "2.5.1",
	react: "17.0.2",
	"react-dom": "17.0.2",
	"react-test-renderer": "^17.0.2",
	"rollup-plugin-svg": "^2.0.0",
	"storybook-tailwind-dark-mode": "^1.0.11",
	tailwindcss: "^3.1.2",
	webpack: "^5.65.0"
};
var peerDependencies = {
	react: "17.0.2",
	"react-dom": "17.0.2"
};
var ComponentPackageJson = {
	name: name,
	version: version,
	main: main,
	"private": true,
	dependencies: dependencies,
	scripts: scripts,
	eslintConfig: eslintConfig,
	browserslist: browserslist,
	devDependencies: devDependencies,
	peerDependencies: peerDependencies
};

const Experiments = () => {
  const dispatch = useDispatch();
  const [storageConsumption, setStorageConsumption] = useState(0);
  const clearLocalStorage = async () => {
    await persistor.purge();
    await clearAudioStorage();
    localStorage.clear();
    window.location.reload();
  };
  useEffect(async () => {
    const usage = await navigator.storage.estimate();
    setStorageConsumption(usage);
  }, []);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "flex flex-col space-y-3 dark:text-white px-3 py-3 overflow-y-auto"
  }, /*#__PURE__*/React__default.createElement("p", null, "Below are various tools used while developing the application"), /*#__PURE__*/React__default.createElement(Button, {
    type: "primary",
    onClick: () => {
      dispatch(addNotificationAsync({
        title: Date.now(),
        text: "Test content",
        type: "positive"
      }));
    }
  }, "Add notification"), /*#__PURE__*/React__default.createElement(Button, {
    onClick: clearLocalStorage,
    type: "primary"
  }, "Wipe local application state"), /*#__PURE__*/React__default.createElement(Button, {
    onClick: () => {
      dispatch(setFeedbackModalVisible(true));
    },
    type: "primary"
  }, "Show feedback Modal"), /*#__PURE__*/React__default.createElement("p", null, "player-application version: v", PackageJSON.version), /*#__PURE__*/React__default.createElement("p", null, "player-components version: v", ComponentPackageJson.version), storageConsumption && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("p", null, "IndexedDB Available: ", (storageConsumption.quota / 1000000).toFixed(2), "MB"), /*#__PURE__*/React__default.createElement("p", null, "IndexedDB Usage: ", (storageConsumption.usage / 1000000).toFixed(2), "MB")), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("h4", null, "Application state:"), /*#__PURE__*/React__default.createElement(ReactJson, {
    collapsed: true,
    theme: "monokai",
    src: store.getState()
  }), /*#__PURE__*/React__default.createElement("h4", {
    className: "mt-4"
  }, "Platform:"), /*#__PURE__*/React__default.createElement(ReactJson, {
    collapsed: false,
    theme: "monokai",
    src: platform
  }), /*#__PURE__*/React__default.createElement("h4", {
    className: "mt-4"
  }, "Session error:"), /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: 'red'
    }
  }, store.getState().session?.error)), /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("br", null)));
};

const NotFound = () => {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "flex justify-center dark: text-white"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "mt-4 text-lg"
  }, "Page not found"));
};

var dist = {};

var jsxRuntime = {exports: {}};

var reactJsxRuntime_production_min = {};

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

var objectAssign;
var hasRequiredObjectAssign;

function requireObjectAssign () {
	if (hasRequiredObjectAssign) return objectAssign;
	hasRequiredObjectAssign = 1;

	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	function toObject(val) {
	  if (val === null || val === undefined) {
	    throw new TypeError('Object.assign cannot be called with null or undefined');
	  }
	  return Object(val);
	}
	function shouldUseNative() {
	  try {
	    if (!Object.assign) {
	      return false;
	    }

	    // Detect buggy property enumeration order in older V8 versions.

	    // https://bugs.chromium.org/p/v8/issues/detail?id=4118
	    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
	    test1[5] = 'de';
	    if (Object.getOwnPropertyNames(test1)[0] === '5') {
	      return false;
	    }

	    // https://bugs.chromium.org/p/v8/issues/detail?id=3056
	    var test2 = {};
	    for (var i = 0; i < 10; i++) {
	      test2['_' + String.fromCharCode(i)] = i;
	    }
	    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
	      return test2[n];
	    });
	    if (order2.join('') !== '0123456789') {
	      return false;
	    }

	    // https://bugs.chromium.org/p/v8/issues/detail?id=3056
	    var test3 = {};
	    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
	      test3[letter] = letter;
	    });
	    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
	      return false;
	    }
	    return true;
	  } catch (err) {
	    // We don't expect any of the above to throw, but better to be safe.
	    return false;
	  }
	}
	objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	  var from;
	  var to = toObject(target);
	  var symbols;
	  for (var s = 1; s < arguments.length; s++) {
	    from = Object(arguments[s]);
	    for (var key in from) {
	      if (hasOwnProperty.call(from, key)) {
	        to[key] = from[key];
	      }
	    }
	    if (getOwnPropertySymbols) {
	      symbols = getOwnPropertySymbols(from);
	      for (var i = 0; i < symbols.length; i++) {
	        if (propIsEnumerable.call(from, symbols[i])) {
	          to[symbols[i]] = from[symbols[i]];
	        }
	      }
	    }
	  }
	  return to;
	};
	return objectAssign;
}

/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactJsxRuntime_production_min;

function requireReactJsxRuntime_production_min () {
	if (hasRequiredReactJsxRuntime_production_min) return reactJsxRuntime_production_min;
	hasRequiredReactJsxRuntime_production_min = 1;

	requireObjectAssign();
	var f = React__default,
	  g = 60103;
	reactJsxRuntime_production_min.Fragment = 60107;
	if ("function" === typeof Symbol && Symbol.for) {
	  var h = Symbol.for;
	  g = h("react.element");
	  reactJsxRuntime_production_min.Fragment = h("react.fragment");
	}
	var m = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
	  n = Object.prototype.hasOwnProperty,
	  p = {
	    key: !0,
	    ref: !0,
	    __self: !0,
	    __source: !0
	  };
	function q(c, a, k) {
	  var b,
	    d = {},
	    e = null,
	    l = null;
	  void 0 !== k && (e = "" + k);
	  void 0 !== a.key && (e = "" + a.key);
	  void 0 !== a.ref && (l = a.ref);
	  for (b in a) n.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
	  if (c && c.defaultProps) for (b in a = c.defaultProps, a) void 0 === d[b] && (d[b] = a[b]);
	  return {
	    $$typeof: g,
	    type: c,
	    key: e,
	    ref: l,
	    props: d,
	    _owner: m.current
	  };
	}
	reactJsxRuntime_production_min.jsx = q;
	reactJsxRuntime_production_min.jsxs = q;
	return reactJsxRuntime_production_min;
}

var reactJsxRuntime_development = {};

/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactJsxRuntime_development;

function requireReactJsxRuntime_development () {
	if (hasRequiredReactJsxRuntime_development) return reactJsxRuntime_development;
	hasRequiredReactJsxRuntime_development = 1;
	(function (exports) {

		if (process.env.NODE_ENV !== "production") {
		  (function () {

		    var React = React__default;
		    var _assign = requireObjectAssign();

		    // ATTENTION
		    // When adding new symbols to this file,
		    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
		    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
		    // nor polyfill, then a plain number is used for performance.
		    var REACT_ELEMENT_TYPE = 0xeac7;
		    var REACT_PORTAL_TYPE = 0xeaca;
		    exports.Fragment = 0xeacb;
		    var REACT_STRICT_MODE_TYPE = 0xeacc;
		    var REACT_PROFILER_TYPE = 0xead2;
		    var REACT_PROVIDER_TYPE = 0xeacd;
		    var REACT_CONTEXT_TYPE = 0xeace;
		    var REACT_FORWARD_REF_TYPE = 0xead0;
		    var REACT_SUSPENSE_TYPE = 0xead1;
		    var REACT_SUSPENSE_LIST_TYPE = 0xead8;
		    var REACT_MEMO_TYPE = 0xead3;
		    var REACT_LAZY_TYPE = 0xead4;
		    var REACT_BLOCK_TYPE = 0xead9;
		    var REACT_SERVER_BLOCK_TYPE = 0xeada;
		    var REACT_FUNDAMENTAL_TYPE = 0xead5;
		    var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
		    var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;
		    if (typeof Symbol === 'function' && Symbol.for) {
		      var symbolFor = Symbol.for;
		      REACT_ELEMENT_TYPE = symbolFor('react.element');
		      REACT_PORTAL_TYPE = symbolFor('react.portal');
		      exports.Fragment = symbolFor('react.fragment');
		      REACT_STRICT_MODE_TYPE = symbolFor('react.strict_mode');
		      REACT_PROFILER_TYPE = symbolFor('react.profiler');
		      REACT_PROVIDER_TYPE = symbolFor('react.provider');
		      REACT_CONTEXT_TYPE = symbolFor('react.context');
		      REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
		      REACT_SUSPENSE_TYPE = symbolFor('react.suspense');
		      REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
		      REACT_MEMO_TYPE = symbolFor('react.memo');
		      REACT_LAZY_TYPE = symbolFor('react.lazy');
		      REACT_BLOCK_TYPE = symbolFor('react.block');
		      REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
		      REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
		      symbolFor('react.scope');
		      symbolFor('react.opaque.id');
		      REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
		      symbolFor('react.offscreen');
		      REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
		    }
		    var MAYBE_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
		    var FAUX_ITERATOR_SYMBOL = '@@iterator';
		    function getIteratorFn(maybeIterable) {
		      if (maybeIterable === null || typeof maybeIterable !== 'object') {
		        return null;
		      }
		      var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
		      if (typeof maybeIterator === 'function') {
		        return maybeIterator;
		      }
		      return null;
		    }
		    var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
		    function error(format) {
		      {
		        for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
		          args[_key2 - 1] = arguments[_key2];
		        }
		        printWarning('error', format, args);
		      }
		    }
		    function printWarning(level, format, args) {
		      // When changing this logic, you might want to also
		      // update consoleWithStackDev.www.js as well.
		      {
		        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
		        var stack = ReactDebugCurrentFrame.getStackAddendum();
		        if (stack !== '') {
		          format += '%s';
		          args = args.concat([stack]);
		        }
		        var argsWithFormat = args.map(function (item) {
		          return '' + item;
		        }); // Careful: RN currently depends on this prefix

		        argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
		        // breaks IE9: https://github.com/facebook/react/issues/13610
		        // eslint-disable-next-line react-internal/no-production-logging

		        Function.prototype.apply.call(console[level], console, argsWithFormat);
		      }
		    }

		    // Filter certain DOM attributes (e.g. src, href) if their values are empty strings.

		    var enableScopeAPI = false; // Experimental Create Event Handle API.

		    function isValidElementType(type) {
		      if (typeof type === 'string' || typeof type === 'function') {
		        return true;
		      } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).

		      if (type === exports.Fragment || type === REACT_PROFILER_TYPE || type === REACT_DEBUG_TRACING_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI) {
		        return true;
		      }
		      if (typeof type === 'object' && type !== null) {
		        if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) {
		          return true;
		        }
		      }
		      return false;
		    }
		    function getWrappedName(outerType, innerType, wrapperName) {
		      var functionName = innerType.displayName || innerType.name || '';
		      return outerType.displayName || (functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName);
		    }
		    function getContextName(type) {
		      return type.displayName || 'Context';
		    }
		    function getComponentName(type) {
		      if (type == null) {
		        // Host root, text node or just invalid type.
		        return null;
		      }
		      {
		        if (typeof type.tag === 'number') {
		          error('Received an unexpected object in getComponentName(). ' + 'This is likely a bug in React. Please file an issue.');
		        }
		      }
		      if (typeof type === 'function') {
		        return type.displayName || type.name || null;
		      }
		      if (typeof type === 'string') {
		        return type;
		      }
		      switch (type) {
		        case exports.Fragment:
		          return 'Fragment';
		        case REACT_PORTAL_TYPE:
		          return 'Portal';
		        case REACT_PROFILER_TYPE:
		          return 'Profiler';
		        case REACT_STRICT_MODE_TYPE:
		          return 'StrictMode';
		        case REACT_SUSPENSE_TYPE:
		          return 'Suspense';
		        case REACT_SUSPENSE_LIST_TYPE:
		          return 'SuspenseList';
		      }
		      if (typeof type === 'object') {
		        switch (type.$$typeof) {
		          case REACT_CONTEXT_TYPE:
		            var context = type;
		            return getContextName(context) + '.Consumer';
		          case REACT_PROVIDER_TYPE:
		            var provider = type;
		            return getContextName(provider._context) + '.Provider';
		          case REACT_FORWARD_REF_TYPE:
		            return getWrappedName(type, type.render, 'ForwardRef');
		          case REACT_MEMO_TYPE:
		            return getComponentName(type.type);
		          case REACT_BLOCK_TYPE:
		            return getComponentName(type._render);
		          case REACT_LAZY_TYPE:
		            {
		              var lazyComponent = type;
		              var payload = lazyComponent._payload;
		              var init = lazyComponent._init;
		              try {
		                return getComponentName(init(payload));
		              } catch (x) {
		                return null;
		              }
		            }
		        }
		      }
		      return null;
		    }

		    // Helpers to patch console.logs to avoid logging during side-effect free
		    // replaying on render function. This currently only patches the object
		    // lazily which won't cover if the log function was extracted eagerly.
		    // We could also eagerly patch the method.
		    var disabledDepth = 0;
		    var prevLog;
		    var prevInfo;
		    var prevWarn;
		    var prevError;
		    var prevGroup;
		    var prevGroupCollapsed;
		    var prevGroupEnd;
		    function disabledLog() {}
		    disabledLog.__reactDisabledLog = true;
		    function disableLogs() {
		      {
		        if (disabledDepth === 0) {
		          /* eslint-disable react-internal/no-production-logging */
		          prevLog = console.log;
		          prevInfo = console.info;
		          prevWarn = console.warn;
		          prevError = console.error;
		          prevGroup = console.group;
		          prevGroupCollapsed = console.groupCollapsed;
		          prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099

		          var props = {
		            configurable: true,
		            enumerable: true,
		            value: disabledLog,
		            writable: true
		          }; // $FlowFixMe Flow thinks console is immutable.

		          Object.defineProperties(console, {
		            info: props,
		            log: props,
		            warn: props,
		            error: props,
		            group: props,
		            groupCollapsed: props,
		            groupEnd: props
		          });
		          /* eslint-enable react-internal/no-production-logging */
		        }
		        disabledDepth++;
		      }
		    }
		    function reenableLogs() {
		      {
		        disabledDepth--;
		        if (disabledDepth === 0) {
		          /* eslint-disable react-internal/no-production-logging */
		          var props = {
		            configurable: true,
		            enumerable: true,
		            writable: true
		          }; // $FlowFixMe Flow thinks console is immutable.

		          Object.defineProperties(console, {
		            log: _assign({}, props, {
		              value: prevLog
		            }),
		            info: _assign({}, props, {
		              value: prevInfo
		            }),
		            warn: _assign({}, props, {
		              value: prevWarn
		            }),
		            error: _assign({}, props, {
		              value: prevError
		            }),
		            group: _assign({}, props, {
		              value: prevGroup
		            }),
		            groupCollapsed: _assign({}, props, {
		              value: prevGroupCollapsed
		            }),
		            groupEnd: _assign({}, props, {
		              value: prevGroupEnd
		            })
		          });
		          /* eslint-enable react-internal/no-production-logging */
		        }
		        if (disabledDepth < 0) {
		          error('disabledDepth fell below zero. ' + 'This is a bug in React. Please file an issue.');
		        }
		      }
		    }
		    var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
		    var prefix;
		    function describeBuiltInComponentFrame(name, source, ownerFn) {
		      {
		        if (prefix === undefined) {
		          // Extract the VM specific prefix used by each line.
		          try {
		            throw Error();
		          } catch (x) {
		            var match = x.stack.trim().match(/\n( *(at )?)/);
		            prefix = match && match[1] || '';
		          }
		        } // We use the prefix to ensure our stacks line up with native stack frames.

		        return '\n' + prefix + name;
		      }
		    }
		    var reentry = false;
		    var componentFrameCache;
		    {
		      var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
		      componentFrameCache = new PossiblyWeakMap();
		    }
		    function describeNativeComponentFrame(fn, construct) {
		      // If something asked for a stack inside a fake render, it should get ignored.
		      if (!fn || reentry) {
		        return '';
		      }
		      {
		        var frame = componentFrameCache.get(fn);
		        if (frame !== undefined) {
		          return frame;
		        }
		      }
		      var control;
		      reentry = true;
		      var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.

		      Error.prepareStackTrace = undefined;
		      var previousDispatcher;
		      {
		        previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
		        // for warnings.

		        ReactCurrentDispatcher.current = null;
		        disableLogs();
		      }
		      try {
		        // This should throw.
		        if (construct) {
		          // Something should be setting the props in the constructor.
		          var Fake = function () {
		            throw Error();
		          }; // $FlowFixMe

		          Object.defineProperty(Fake.prototype, 'props', {
		            set: function () {
		              // We use a throwing setter instead of frozen or non-writable props
		              // because that won't throw in a non-strict mode function.
		              throw Error();
		            }
		          });
		          if (typeof Reflect === 'object' && Reflect.construct) {
		            // We construct a different control for this case to include any extra
		            // frames added by the construct call.
		            try {
		              Reflect.construct(Fake, []);
		            } catch (x) {
		              control = x;
		            }
		            Reflect.construct(fn, [], Fake);
		          } else {
		            try {
		              Fake.call();
		            } catch (x) {
		              control = x;
		            }
		            fn.call(Fake.prototype);
		          }
		        } else {
		          try {
		            throw Error();
		          } catch (x) {
		            control = x;
		          }
		          fn();
		        }
		      } catch (sample) {
		        // This is inlined manually because closure doesn't do it for us.
		        if (sample && control && typeof sample.stack === 'string') {
		          // This extracts the first frame from the sample that isn't also in the control.
		          // Skipping one frame that we assume is the frame that calls the two.
		          var sampleLines = sample.stack.split('\n');
		          var controlLines = control.stack.split('\n');
		          var s = sampleLines.length - 1;
		          var c = controlLines.length - 1;
		          while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
		            // We expect at least one stack frame to be shared.
		            // Typically this will be the root most one. However, stack frames may be
		            // cut off due to maximum stack limits. In this case, one maybe cut off
		            // earlier than the other. We assume that the sample is longer or the same
		            // and there for cut off earlier. So we should find the root most frame in
		            // the sample somewhere in the control.
		            c--;
		          }
		          for (; s >= 1 && c >= 0; s--, c--) {
		            // Next we find the first one that isn't the same which should be the
		            // frame that called our sample function and the control.
		            if (sampleLines[s] !== controlLines[c]) {
		              // In V8, the first line is describing the message but other VMs don't.
		              // If we're about to return the first line, and the control is also on the same
		              // line, that's a pretty good indicator that our sample threw at same line as
		              // the control. I.e. before we entered the sample frame. So we ignore this result.
		              // This can happen if you passed a class to function component, or non-function.
		              if (s !== 1 || c !== 1) {
		                do {
		                  s--;
		                  c--; // We may still have similar intermediate frames from the construct call.
		                  // The next one that isn't the same should be our match though.

		                  if (c < 0 || sampleLines[s] !== controlLines[c]) {
		                    // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
		                    var _frame = '\n' + sampleLines[s].replace(' at new ', ' at ');
		                    {
		                      if (typeof fn === 'function') {
		                        componentFrameCache.set(fn, _frame);
		                      }
		                    } // Return the line we found.

		                    return _frame;
		                  }
		                } while (s >= 1 && c >= 0);
		              }
		              break;
		            }
		          }
		        }
		      } finally {
		        reentry = false;
		        {
		          ReactCurrentDispatcher.current = previousDispatcher;
		          reenableLogs();
		        }
		        Error.prepareStackTrace = previousPrepareStackTrace;
		      } // Fallback to just using the name if we couldn't make it throw.

		      var name = fn ? fn.displayName || fn.name : '';
		      var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';
		      {
		        if (typeof fn === 'function') {
		          componentFrameCache.set(fn, syntheticFrame);
		        }
		      }
		      return syntheticFrame;
		    }
		    function describeFunctionComponentFrame(fn, source, ownerFn) {
		      {
		        return describeNativeComponentFrame(fn, false);
		      }
		    }
		    function shouldConstruct(Component) {
		      var prototype = Component.prototype;
		      return !!(prototype && prototype.isReactComponent);
		    }
		    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
		      if (type == null) {
		        return '';
		      }
		      if (typeof type === 'function') {
		        {
		          return describeNativeComponentFrame(type, shouldConstruct(type));
		        }
		      }
		      if (typeof type === 'string') {
		        return describeBuiltInComponentFrame(type);
		      }
		      switch (type) {
		        case REACT_SUSPENSE_TYPE:
		          return describeBuiltInComponentFrame('Suspense');
		        case REACT_SUSPENSE_LIST_TYPE:
		          return describeBuiltInComponentFrame('SuspenseList');
		      }
		      if (typeof type === 'object') {
		        switch (type.$$typeof) {
		          case REACT_FORWARD_REF_TYPE:
		            return describeFunctionComponentFrame(type.render);
		          case REACT_MEMO_TYPE:
		            // Memo may contain any component type so we recursively resolve it.
		            return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
		          case REACT_BLOCK_TYPE:
		            return describeFunctionComponentFrame(type._render);
		          case REACT_LAZY_TYPE:
		            {
		              var lazyComponent = type;
		              var payload = lazyComponent._payload;
		              var init = lazyComponent._init;
		              try {
		                // Lazy may contain any component type so we recursively resolve it.
		                return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
		              } catch (x) {}
		            }
		        }
		      }
		      return '';
		    }
		    var loggedTypeFailures = {};
		    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
		    function setCurrentlyValidatingElement(element) {
		      {
		        if (element) {
		          var owner = element._owner;
		          var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
		          ReactDebugCurrentFrame.setExtraStackFrame(stack);
		        } else {
		          ReactDebugCurrentFrame.setExtraStackFrame(null);
		        }
		      }
		    }
		    function checkPropTypes(typeSpecs, values, location, componentName, element) {
		      {
		        // $FlowFixMe This is okay but Flow doesn't know it.
		        var has = Function.call.bind(Object.prototype.hasOwnProperty);
		        for (var typeSpecName in typeSpecs) {
		          if (has(typeSpecs, typeSpecName)) {
		            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
		            // fail the render phase where it didn't fail before. So we log it.
		            // After these have been cleaned up, we'll let them throw.

		            try {
		              // This is intentionally an invariant that gets caught. It's the same
		              // behavior as without this statement except with a better message.
		              if (typeof typeSpecs[typeSpecName] !== 'function') {
		                var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
		                err.name = 'Invariant Violation';
		                throw err;
		              }
		              error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
		            } catch (ex) {
		              error$1 = ex;
		            }
		            if (error$1 && !(error$1 instanceof Error)) {
		              setCurrentlyValidatingElement(element);
		              error('%s: type specification of %s' + ' `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error$1);
		              setCurrentlyValidatingElement(null);
		            }
		            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
		              // Only monitor this failure once because there tends to be a lot of the
		              // same error.
		              loggedTypeFailures[error$1.message] = true;
		              setCurrentlyValidatingElement(element);
		              error('Failed %s type: %s', location, error$1.message);
		              setCurrentlyValidatingElement(null);
		            }
		          }
		        }
		      }
		    }
		    var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
		    var hasOwnProperty = Object.prototype.hasOwnProperty;
		    var RESERVED_PROPS = {
		      key: true,
		      ref: true,
		      __self: true,
		      __source: true
		    };
		    var specialPropKeyWarningShown;
		    var specialPropRefWarningShown;
		    var didWarnAboutStringRefs;
		    {
		      didWarnAboutStringRefs = {};
		    }
		    function hasValidRef(config) {
		      {
		        if (hasOwnProperty.call(config, 'ref')) {
		          var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
		          if (getter && getter.isReactWarning) {
		            return false;
		          }
		        }
		      }
		      return config.ref !== undefined;
		    }
		    function hasValidKey(config) {
		      {
		        if (hasOwnProperty.call(config, 'key')) {
		          var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
		          if (getter && getter.isReactWarning) {
		            return false;
		          }
		        }
		      }
		      return config.key !== undefined;
		    }
		    function warnIfStringRefCannotBeAutoConverted(config, self) {
		      {
		        if (typeof config.ref === 'string' && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
		          var componentName = getComponentName(ReactCurrentOwner.current.type);
		          if (!didWarnAboutStringRefs[componentName]) {
		            error('Component "%s" contains the string ref "%s". ' + 'Support for string refs will be removed in a future major release. ' + 'This case cannot be automatically converted to an arrow function. ' + 'We ask you to manually fix this case by using useRef() or createRef() instead. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-string-ref', getComponentName(ReactCurrentOwner.current.type), config.ref);
		            didWarnAboutStringRefs[componentName] = true;
		          }
		        }
		      }
		    }
		    function defineKeyPropWarningGetter(props, displayName) {
		      {
		        var warnAboutAccessingKey = function () {
		          if (!specialPropKeyWarningShown) {
		            specialPropKeyWarningShown = true;
		            error('%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
		          }
		        };
		        warnAboutAccessingKey.isReactWarning = true;
		        Object.defineProperty(props, 'key', {
		          get: warnAboutAccessingKey,
		          configurable: true
		        });
		      }
		    }
		    function defineRefPropWarningGetter(props, displayName) {
		      {
		        var warnAboutAccessingRef = function () {
		          if (!specialPropRefWarningShown) {
		            specialPropRefWarningShown = true;
		            error('%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
		          }
		        };
		        warnAboutAccessingRef.isReactWarning = true;
		        Object.defineProperty(props, 'ref', {
		          get: warnAboutAccessingRef,
		          configurable: true
		        });
		      }
		    }
		    /**
		     * Factory method to create a new React element. This no longer adheres to
		     * the class pattern, so do not use new to call it. Also, instanceof check
		     * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
		     * if something is a React Element.
		     *
		     * @param {*} type
		     * @param {*} props
		     * @param {*} key
		     * @param {string|object} ref
		     * @param {*} owner
		     * @param {*} self A *temporary* helper to detect places where `this` is
		     * different from the `owner` when React.createElement is called, so that we
		     * can warn. We want to get rid of owner and replace string `ref`s with arrow
		     * functions, and as long as `this` and owner are the same, there will be no
		     * change in behavior.
		     * @param {*} source An annotation object (added by a transpiler or otherwise)
		     * indicating filename, line number, and/or other information.
		     * @internal
		     */

		    var ReactElement = function (type, key, ref, self, source, owner, props) {
		      var element = {
		        // This tag allows us to uniquely identify this as a React Element
		        $$typeof: REACT_ELEMENT_TYPE,
		        // Built-in properties that belong on the element
		        type: type,
		        key: key,
		        ref: ref,
		        props: props,
		        // Record the component responsible for creating this element.
		        _owner: owner
		      };
		      {
		        // The validation flag is currently mutative. We put it on
		        // an external backing store so that we can freeze the whole object.
		        // This can be replaced with a WeakMap once they are implemented in
		        // commonly used development environments.
		        element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
		        // the validation flag non-enumerable (where possible, which should
		        // include every environment we run tests in), so the test framework
		        // ignores it.

		        Object.defineProperty(element._store, 'validated', {
		          configurable: false,
		          enumerable: false,
		          writable: true,
		          value: false
		        }); // self and source are DEV only properties.

		        Object.defineProperty(element, '_self', {
		          configurable: false,
		          enumerable: false,
		          writable: false,
		          value: self
		        }); // Two elements created in two different places should be considered
		        // equal for testing purposes and therefore we hide it from enumeration.

		        Object.defineProperty(element, '_source', {
		          configurable: false,
		          enumerable: false,
		          writable: false,
		          value: source
		        });
		        if (Object.freeze) {
		          Object.freeze(element.props);
		          Object.freeze(element);
		        }
		      }
		      return element;
		    };
		    /**
		     * https://github.com/reactjs/rfcs/pull/107
		     * @param {*} type
		     * @param {object} props
		     * @param {string} key
		     */

		    function jsxDEV(type, config, maybeKey, source, self) {
		      {
		        var propName; // Reserved names are extracted

		        var props = {};
		        var key = null;
		        var ref = null; // Currently, key can be spread in as a prop. This causes a potential
		        // issue if key is also explicitly declared (ie. <div {...props} key="Hi" />
		        // or <div key="Hi" {...props} /> ). We want to deprecate key spread,
		        // but as an intermediary step, we will use jsxDEV for everything except
		        // <div {...props} key="Hi" />, because we aren't currently able to tell if
		        // key is explicitly declared to be undefined or not.

		        if (maybeKey !== undefined) {
		          key = '' + maybeKey;
		        }
		        if (hasValidKey(config)) {
		          key = '' + config.key;
		        }
		        if (hasValidRef(config)) {
		          ref = config.ref;
		          warnIfStringRefCannotBeAutoConverted(config, self);
		        } // Remaining properties are added to a new props object

		        for (propName in config) {
		          if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
		            props[propName] = config[propName];
		          }
		        } // Resolve default props

		        if (type && type.defaultProps) {
		          var defaultProps = type.defaultProps;
		          for (propName in defaultProps) {
		            if (props[propName] === undefined) {
		              props[propName] = defaultProps[propName];
		            }
		          }
		        }
		        if (key || ref) {
		          var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
		          if (key) {
		            defineKeyPropWarningGetter(props, displayName);
		          }
		          if (ref) {
		            defineRefPropWarningGetter(props, displayName);
		          }
		        }
		        return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
		      }
		    }
		    var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
		    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
		    function setCurrentlyValidatingElement$1(element) {
		      {
		        if (element) {
		          var owner = element._owner;
		          var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
		          ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
		        } else {
		          ReactDebugCurrentFrame$1.setExtraStackFrame(null);
		        }
		      }
		    }
		    var propTypesMisspellWarningShown;
		    {
		      propTypesMisspellWarningShown = false;
		    }
		    /**
		     * Verifies the object is a ReactElement.
		     * See https://reactjs.org/docs/react-api.html#isvalidelement
		     * @param {?object} object
		     * @return {boolean} True if `object` is a ReactElement.
		     * @final
		     */

		    function isValidElement(object) {
		      {
		        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
		      }
		    }
		    function getDeclarationErrorAddendum() {
		      {
		        if (ReactCurrentOwner$1.current) {
		          var name = getComponentName(ReactCurrentOwner$1.current.type);
		          if (name) {
		            return '\n\nCheck the render method of `' + name + '`.';
		          }
		        }
		        return '';
		      }
		    }
		    function getSourceInfoErrorAddendum(source) {
		      {
		        if (source !== undefined) {
		          var fileName = source.fileName.replace(/^.*[\\\/]/, '');
		          var lineNumber = source.lineNumber;
		          return '\n\nCheck your code at ' + fileName + ':' + lineNumber + '.';
		        }
		        return '';
		      }
		    }
		    /**
		     * Warn if there's no key explicitly set on dynamic arrays of children or
		     * object keys are not valid. This allows us to keep track of children between
		     * updates.
		     */

		    var ownerHasKeyUseWarning = {};
		    function getCurrentComponentErrorInfo(parentType) {
		      {
		        var info = getDeclarationErrorAddendum();
		        if (!info) {
		          var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;
		          if (parentName) {
		            info = "\n\nCheck the top-level render call using <" + parentName + ">.";
		          }
		        }
		        return info;
		      }
		    }
		    /**
		     * Warn if the element doesn't have an explicit key assigned to it.
		     * This element is in an array. The array could grow and shrink or be
		     * reordered. All children that haven't already been validated are required to
		     * have a "key" property assigned to it. Error statuses are cached so a warning
		     * will only be shown once.
		     *
		     * @internal
		     * @param {ReactElement} element Element that requires a key.
		     * @param {*} parentType element's parent's type.
		     */

		    function validateExplicitKey(element, parentType) {
		      {
		        if (!element._store || element._store.validated || element.key != null) {
		          return;
		        }
		        element._store.validated = true;
		        var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
		        if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
		          return;
		        }
		        ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
		        // property, it may be the creator of the child that's responsible for
		        // assigning it a key.

		        var childOwner = '';
		        if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
		          // Give the component that originally created this child.
		          childOwner = " It was passed a child from " + getComponentName(element._owner.type) + ".";
		        }
		        setCurrentlyValidatingElement$1(element);
		        error('Each child in a list should have a unique "key" prop.' + '%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
		        setCurrentlyValidatingElement$1(null);
		      }
		    }
		    /**
		     * Ensure that every element either is passed in a static location, in an
		     * array with an explicit keys property defined, or in an object literal
		     * with valid key property.
		     *
		     * @internal
		     * @param {ReactNode} node Statically passed child of any type.
		     * @param {*} parentType node's parent's type.
		     */

		    function validateChildKeys(node, parentType) {
		      {
		        if (typeof node !== 'object') {
		          return;
		        }
		        if (Array.isArray(node)) {
		          for (var i = 0; i < node.length; i++) {
		            var child = node[i];
		            if (isValidElement(child)) {
		              validateExplicitKey(child, parentType);
		            }
		          }
		        } else if (isValidElement(node)) {
		          // This element was passed in a valid location.
		          if (node._store) {
		            node._store.validated = true;
		          }
		        } else if (node) {
		          var iteratorFn = getIteratorFn(node);
		          if (typeof iteratorFn === 'function') {
		            // Entry iterators used to provide implicit keys,
		            // but now we print a separate warning for them later.
		            if (iteratorFn !== node.entries) {
		              var iterator = iteratorFn.call(node);
		              var step;
		              while (!(step = iterator.next()).done) {
		                if (isValidElement(step.value)) {
		                  validateExplicitKey(step.value, parentType);
		                }
		              }
		            }
		          }
		        }
		      }
		    }
		    /**
		     * Given an element, validate that its props follow the propTypes definition,
		     * provided by the type.
		     *
		     * @param {ReactElement} element
		     */

		    function validatePropTypes(element) {
		      {
		        var type = element.type;
		        if (type === null || type === undefined || typeof type === 'string') {
		          return;
		        }
		        var propTypes;
		        if (typeof type === 'function') {
		          propTypes = type.propTypes;
		        } else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE ||
		        // Note: Memo only checks outer props here.
		        // Inner props are checked in the reconciler.
		        type.$$typeof === REACT_MEMO_TYPE)) {
		          propTypes = type.propTypes;
		        } else {
		          return;
		        }
		        if (propTypes) {
		          // Intentionally inside to avoid triggering lazy initializers:
		          var name = getComponentName(type);
		          checkPropTypes(propTypes, element.props, 'prop', name, element);
		        } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
		          propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:

		          var _name = getComponentName(type);
		          error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', _name || 'Unknown');
		        }
		        if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) {
		          error('getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.');
		        }
		      }
		    }
		    /**
		     * Given a fragment, validate that it can only be provided with fragment props
		     * @param {ReactElement} fragment
		     */

		    function validateFragmentProps(fragment) {
		      {
		        var keys = Object.keys(fragment.props);
		        for (var i = 0; i < keys.length; i++) {
		          var key = keys[i];
		          if (key !== 'children' && key !== 'key') {
		            setCurrentlyValidatingElement$1(fragment);
		            error('Invalid prop `%s` supplied to `React.Fragment`. ' + 'React.Fragment can only have `key` and `children` props.', key);
		            setCurrentlyValidatingElement$1(null);
		            break;
		          }
		        }
		        if (fragment.ref !== null) {
		          setCurrentlyValidatingElement$1(fragment);
		          error('Invalid attribute `ref` supplied to `React.Fragment`.');
		          setCurrentlyValidatingElement$1(null);
		        }
		      }
		    }
		    function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
		      {
		        var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
		        // succeed and there will likely be errors in render.

		        if (!validType) {
		          var info = '';
		          if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
		            info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and named imports.";
		          }
		          var sourceInfo = getSourceInfoErrorAddendum(source);
		          if (sourceInfo) {
		            info += sourceInfo;
		          } else {
		            info += getDeclarationErrorAddendum();
		          }
		          var typeString;
		          if (type === null) {
		            typeString = 'null';
		          } else if (Array.isArray(type)) {
		            typeString = 'array';
		          } else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
		            typeString = "<" + (getComponentName(type.type) || 'Unknown') + " />";
		            info = ' Did you accidentally export a JSX literal instead of a component?';
		          } else {
		            typeString = typeof type;
		          }
		          error('React.jsx: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', typeString, info);
		        }
		        var element = jsxDEV(type, props, key, source, self); // The result can be nullish if a mock or a custom function is used.
		        // TODO: Drop this when these are no longer allowed as the type argument.

		        if (element == null) {
		          return element;
		        } // Skip key warning if the type isn't valid since our key validation logic
		        // doesn't expect a non-string/function type and can throw confusing errors.
		        // We don't want exception behavior to differ between dev and prod.
		        // (Rendering will throw with a helpful message and as soon as the type is
		        // fixed, the key warnings will appear.)

		        if (validType) {
		          var children = props.children;
		          if (children !== undefined) {
		            if (isStaticChildren) {
		              if (Array.isArray(children)) {
		                for (var i = 0; i < children.length; i++) {
		                  validateChildKeys(children[i], type);
		                }
		                if (Object.freeze) {
		                  Object.freeze(children);
		                }
		              } else {
		                error('React.jsx: Static children should always be an array. ' + 'You are likely explicitly calling React.jsxs or React.jsxDEV. ' + 'Use the Babel transform instead.');
		              }
		            } else {
		              validateChildKeys(children, type);
		            }
		          }
		        }
		        if (type === exports.Fragment) {
		          validateFragmentProps(element);
		        } else {
		          validatePropTypes(element);
		        }
		        return element;
		      }
		    } // These two functions exist to still get child warnings in dev
		    // even with the prod transform. This means that jsxDEV is purely
		    // opt-in behavior for better messages but that we won't stop
		    // giving you warnings if you use production apis.

		    function jsxWithValidationStatic(type, props, key) {
		      {
		        return jsxWithValidation(type, props, key, true);
		      }
		    }
		    function jsxWithValidationDynamic(type, props, key) {
		      {
		        return jsxWithValidation(type, props, key, false);
		      }
		    }
		    var jsx = jsxWithValidationDynamic; // we may want to special case jsxs internally to take advantage of static children.
		    // for now we can ship identical prod functions

		    var jsxs = jsxWithValidationStatic;
		    exports.jsx = jsx;
		    exports.jsxs = jsxs;
		  })();
		}
} (reactJsxRuntime_development));
	return reactJsxRuntime_development;
}

(function (module) {

	if (process.env.NODE_ENV === 'production') {
	  module.exports = requireReactJsxRuntime_production_min();
	} else {
	  module.exports = requireReactJsxRuntime_development();
	}
} (jsxRuntime));

var Rating;

Object.defineProperty(dist, "__esModule", {
  value: !0
});
var e$1 = jsxRuntime.exports,
  t$1 = React__default,
  o$1 = function () {
    return o$1 = Object.assign || function (e) {
      for (var t, o = 1, n = arguments.length; o < n; o++) for (var i in t = arguments[o]) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
      return e;
    }, o$1.apply(this, arguments);
  };
function n$1(e, t, o) {
  if (o || 2 === arguments.length) for (var n, i = 0, r = t.length; i < r; i++) !n && i in t || (n || (n = Array.prototype.slice.call(t, 0, i)), n[i] = t[i]);
  return e.concat(n || Array.prototype.slice.call(t));
}
function i$1(t) {
  var n = t.size,
    i = void 0 === n ? 25 : n,
    r = t.SVGstrokeColor,
    l = void 0 === r ? "currentColor" : r,
    a = t.SVGstorkeWidth,
    s = void 0 === a ? 0 : a,
    c = t.SVGclassName,
    d = void 0 === c ? "star-svg" : c,
    u = t.SVGstyle;
  return e$1.jsx("svg", o$1({
    className: d,
    style: u,
    stroke: l,
    fill: "currentColor",
    strokeWidth: s,
    viewBox: "0 0 24 24",
    width: i,
    height: i,
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: e$1.jsx("path", {
      d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
    })
  }));
}
function r$1(e, t) {
  switch (t.type) {
    case "PointerMove":
      return o$1(o$1({}, e), {
        hoverValue: t.payload,
        hoverIndex: t.index
      });
    case "PointerLeave":
      return o$1(o$1({}, e), {
        ratingValue: e.ratingValue,
        hoverIndex: 0,
        hoverValue: null
      });
    case "MouseClick":
      return o$1(o$1({}, e), {
        valueIndex: e.hoverIndex,
        ratingValue: t.payload
      });
    default:
      return e;
  }
}
var l$1 = "style-module_starRatingWrap__q-lJC",
  a$1 = "style-module_simpleStarRating__nWUxf",
  s$1 = "style-module_fillIcons__6---A",
  c$1 = "style-module_emptyIcons__Bg-FZ",
  d$1 = "style-module_tooltip__tKc3i";
!function (e, t) {
  void 0 === t && (t = {});
  var o = t.insertAt;
  if (e && "undefined" != typeof document) {
    var n = document.head || document.getElementsByTagName("head")[0],
      i = document.createElement("style");
    i.type = "text/css", "top" === o && n.firstChild ? n.insertBefore(i, n.firstChild) : n.appendChild(i), i.styleSheet ? i.styleSheet.cssText = e : i.appendChild(document.createTextNode(e));
  }
}("body,html{font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji;margin:0;padding:0}.style-module_starRatingWrap__q-lJC{display:inline-block;touch-action:none}.style-module_simpleStarRating__nWUxf{display:inline-block;overflow:hidden;position:relative;touch-action:none;-webkit-user-select:none;-moz-user-select:none;user-select:none;vertical-align:middle;white-space:nowrap}.style-module_fillIcons__6---A{display:inline-block;overflow:hidden;position:absolute;top:0;white-space:nowrap}.style-module_emptyIcons__Bg-FZ{display:inline-block}.style-module_tooltip__tKc3i{background-color:#333;border-radius:5px;color:#fff;display:inline-block;padding:5px 15px;vertical-align:middle}"), Rating = dist.Rating = function (u) {
  var v,
    p,
    h = u.onClick,
    m = u.onPointerMove,
    y = u.onPointerEnter,
    f = u.onPointerLeave,
    g = u.initialValue,
    x = void 0 === g ? 0 : g,
    _ = u.iconsCount,
    C = void 0 === _ ? 5 : _,
    S = u.size,
    V = void 0 === S ? 40 : S,
    k = u.readonly,
    w = void 0 !== k && k,
    b = u.rtl,
    M = void 0 !== b && b,
    I = u.customIcons,
    j = void 0 === I ? [] : I,
    G = u.allowFraction,
    N = void 0 !== G && G,
    A = u.style,
    P = u.className,
    L = void 0 === P ? "react-simple-star-rating" : P,
    R = u.transition,
    W = void 0 !== R && R,
    B = u.allowHover,
    E = void 0 === B || B,
    F = u.disableFillHover,
    T = void 0 !== F && F,
    z = u.fillIcon,
    q = void 0 === z ? null : z,
    O = u.fillColor,
    U = void 0 === O ? "#ffbc0b" : O,
    H = u.fillColorArray,
    J = void 0 === H ? [] : H,
    K = u.fillStyle,
    Z = u.fillClassName,
    D = void 0 === Z ? "filled-icons" : Z,
    X = u.emptyIcon,
    Y = void 0 === X ? null : X,
    Q = u.emptyColor,
    $ = void 0 === Q ? "#cccccc" : Q,
    ee = u.emptyStyle,
    te = u.emptyClassName,
    oe = void 0 === te ? "empty-icons" : te,
    ne = u.showTooltip,
    ie = void 0 !== ne && ne,
    re = u.tooltipDefaultText,
    le = void 0 === re ? "Your Rate" : re,
    ae = u.tooltipArray,
    se = void 0 === ae ? [] : ae,
    ce = u.tooltipStyle,
    de = u.tooltipClassName,
    ue = void 0 === de ? "react-simple-star-rating-tooltip" : de,
    ve = u.SVGclassName,
    pe = void 0 === ve ? "star-svg" : ve,
    he = u.titleSeparator,
    me = void 0 === he ? "out of" : he,
    ye = u.SVGstyle,
    fe = u.SVGstorkeWidth,
    ge = void 0 === fe ? 0 : fe,
    xe = u.SVGstrokeColor,
    _e = void 0 === xe ? "currentColor" : xe,
    Ce = t$1.useReducer(r$1, {
      hoverIndex: 0,
      valueIndex: 0,
      ratingValue: 0,
      hoverValue: null
    }),
    Se = Ce[0],
    Ve = Se.ratingValue,
    ke = Se.hoverValue,
    we = Se.hoverIndex,
    be = Se.valueIndex,
    Me = Ce[1],
    Ie = t$1.useMemo(function () {
      return "ontouchstart" in window || navigator.maxTouchPoints > 0;
    }, []),
    je = t$1.useMemo(function () {
      return N ? 2 * C : C;
    }, [N, C]),
    Ge = t$1.useMemo(function () {
      return x > je ? 0 : N || Math.floor(x) === x ? Math.round(x / C * 100) : 2 * Math.ceil(x) * 10;
    }, [N, x, C, je]),
    Ne = t$1.useMemo(function () {
      return (N ? 2 * x - 1 : x - 1) || 0;
    }, [N, x]),
    Ae = t$1.useCallback(function (e) {
      return C % 2 != 0 ? e / 2 / 10 : e / C;
    }, [C]),
    Pe = function (e) {
      for (var t = e.clientX, o = e.currentTarget.children[0].getBoundingClientRect(), n = o.left, i = o.right, r = o.width, l = M ? i - t : t - n, a = je, s = Math.round(r / je), c = 0; c <= je; c += 1) if (l <= s * c) {
        a = 0 === c && l < s ? 0 : c;
        break;
      }
      var d = a - 1;
      a > 0 && (Me({
        type: "PointerMove",
        payload: 100 * a / je,
        index: d
      }), m && ke && m(Ae(ke), d, e));
    },
    Le = function (e) {
      ke && (Me({
        type: "MouseClick",
        payload: ke
      }), h && h(Ae(ke), we, e));
    },
    Re = t$1.useMemo(function () {
      if (E) {
        if (T) {
          var e = Ve && Ve || Ge;
          return ke && ke > e ? ke : e;
        }
        return ke && ke || Ve && Ve || Ge;
      }
      return Ve && Ve || Ge;
    }, [E, T, ke, Ve, Ge]);
  t$1.useEffect(function () {
    se.length > je && console.error("tooltipArray Array length is bigger then Icons Count length.");
  }, [se.length, je]);
  var We = t$1.useCallback(function (e) {
      return ke && e[we] || Ve && e[be] || x && e[Ne];
    }, [ke, we, Ve, be, x, Ne]),
    Be = t$1.useMemo(function () {
      return ke && Ae(ke) || Ve && Ae(Ve) || x && Ae(Ge);
    }, [ke, Ae, Ve, x, Ge]);
  return e$1.jsxs("span", o$1({
    className: l$1,
    style: {
      direction: "".concat(M ? "rtl" : "ltr")
    }
  }, {
    children: [e$1.jsxs("span", o$1({
      className: "".concat(a$1, " ").concat(L),
      style: o$1({
        cursor: w ? "" : "pointer"
      }, A),
      onPointerMove: w ? void 0 : Pe,
      onPointerEnter: w ? void 0 : function (e) {
        y && y(e), Ie && Pe(e);
      },
      onPointerLeave: w ? void 0 : function (e) {
        Ie && Le(), Me({
          type: "PointerLeave"
        }), f && f(e);
      },
      onClick: w ? void 0 : Le,
      "aria-hidden": "true"
    }, {
      children: [e$1.jsx("span", o$1({
        className: "".concat(c$1, " ").concat(oe),
        style: o$1({
          color: $
        }, ee)
      }, {
        children: n$1([], Array(C), !0).map(function (o, n) {
          var r;
          return e$1.jsx(t$1.Fragment, {
            children: (null === (r = j[n]) || void 0 === r ? void 0 : r.icon) || Y || e$1.jsx(i$1, {
              SVGclassName: pe,
              SVGstyle: ye,
              SVGstorkeWidth: ge,
              SVGstrokeColor: _e,
              size: V
            })
          }, n);
        })
      })), e$1.jsx("span", o$1({
        className: "".concat(s$1, " ").concat(D),
        style: o$1((v = {}, v[M ? "right" : "left"] = 0, v.color = We(J) || U, v.transition = W ? "width .2s ease, color .2s ease" : "", v.width = "".concat(Re, "%"), v), K),
        title: "".concat(ke && Ae(ke) || Ae(Ge), " ").concat(me, " ").concat(C)
      }, {
        children: n$1([], Array(C), !0).map(function (o, n) {
          var r;
          return e$1.jsx(t$1.Fragment, {
            children: (null === (r = j[n]) || void 0 === r ? void 0 : r.icon) || q || e$1.jsx(i$1, {
              SVGclassName: pe,
              SVGstyle: ye,
              SVGstorkeWidth: ge,
              SVGstrokeColor: _e,
              size: V
            })
          }, n);
        })
      }))]
    })), ie && e$1.jsx("span", o$1({
      className: "".concat(d$1, " ").concat(ue),
      style: o$1((p = {}, p[M ? "marginRight" : "marginLeft"] = 20, p), ce)
    }, {
      children: (se.length > 0 ? We(se) : Be) || le
    }))]
  }));
};

var css_248z$6 = "svg.star-svg{display:inline}.ratingTable{margin:20px 0}.rating{align-items:center;display:flex;font-weight:700;justify-content:space-between;margin:10px 0}.textAreaInput{border:1px solid #999;border-radius:8px;margin:10px 0;width:100%}";
styleInject(css_248z$6,{"insertAt":"top"});

const FeedbackModal = ({
  onClose,
  onSubmit
}) => {
  const [feedbackText, setFeedbackText] = useState('');
  const [usabilityRating, setUsabilityRating] = useState(null);
  const [audioRating, setAudioRating] = useState(null);
  const [designRating, setDesignRating] = useState(null);
  const renderContent = () => {
    return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
      className: "ratingTable"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "rating"
    }, /*#__PURE__*/React__default.createElement("label", null, "Usability"), /*#__PURE__*/React__default.createElement(Rating, {
      onClick: setUsabilityRating,
      ratingValue: usabilityRating
    })), /*#__PURE__*/React__default.createElement("div", {
      className: "rating"
    }, /*#__PURE__*/React__default.createElement("label", null, "Audio quality"), /*#__PURE__*/React__default.createElement(Rating, {
      onClick: setAudioRating,
      ratingValue: audioRating
    })), /*#__PURE__*/React__default.createElement("div", {
      className: "rating"
    }, /*#__PURE__*/React__default.createElement("label", null, "Design"), /*#__PURE__*/React__default.createElement(Rating, {
      onClick: setDesignRating,
      ratingValue: designRating
    })), /*#__PURE__*/React__default.createElement("textarea", {
      autoFocus: false,
      placeholder: "Any other comments or suggestions?",
      onChange: e => setFeedbackText(e.target.value),
      className: "textAreaInput"
    })));
  };
  const handleClose = () => {
    onClose();
  };
  const handleSubmit = () => {
    onSubmit({
      feedbackText,
      usabilityRating,
      audioRating,
      designRating
    });
  };
  return /*#__PURE__*/React__default.createElement(Modal, {
    isOpen: true,
    title: "We'd love to you know what you think",
    content: renderContent(),
    confirmLabel: "Submit",
    closeLabel: "No thanks",
    onClose: handleClose,
    onConfirm: handleSubmit,
    autoFocus: false
  });
};

var css_248z$5 = "";
styleInject(css_248z$5,{"insertAt":"top"});

const IOSModal = ({
  onClose,
  onSubmit
}) => {
  const renderContent = () => {
    return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("p", null, "To play this song, you currently need to download our iOS native app."), /*#__PURE__*/React__default.createElement("a", {
      href: "https://apps.apple.com/gb/app/bimmplayer/id1109502471"
    }, /*#__PURE__*/React__default.createElement("img", {
      className: "chromeIcon",
      align: "center",
      alt: "Update iOS",
      src: `${process.env.PUBLIC_URL}/images/appstore.svg`
    })), /*#__PURE__*/React__default.createElement("p", null, "We will be adding full iOS web support soon."));
  };
  const handleClose = () => {
    onClose();
  };
  return /*#__PURE__*/React__default.createElement(Modal, {
    isOpen: true,
    title: "Download app",
    content: renderContent()
    // icon={<AnnotationIcon className="h-6 w-6 text-primary" aria-hidden="true" />}
    ,
    onClose: handleClose,
    confirmLabel: "Okay",
    onConfirm: handleClose,
    autoFocus: false
  });
};

const Settings = () => {
  const dispatch = useDispatch();
  const showDeveloperTools = useSelector(selectShowDeveloperTools);
  const clientConfiguration = useSelector(selectClientConfig);
  const parentVersion = useSelector(selectParentVersion);
  const currentUser = useSelector(selectUser);
  const [storageConsumption, setStorageConsumption] = useState(0);
  const sessionError = useSelector(selectError$1);
  const clearLocalStorage = async () => {
    // pgw testing 13-may-2024
    console.log('clearLocalStorage p1');
    // alert('clearLocalStorage')

    await persistor.purge();
    await clearAudioStorage();
    localStorage.clear();
    window.location.reload();
  };
  const handleToggleDeveloperTools = () => {
    dispatch(setShowDeveloperTools(!showDeveloperTools));
  };
  const handleDownloadState = () => {
    var json = JSON.stringify(store.getState());
    var blob = new Blob([json], {
      type: "application/json"
    });
    triggerBlobDownload(blob, `${clientConfiguration.labels.appTitle}-debug-${Date.now()}.debug`);
  };
  useEffect(async () => {
    const usage = await navigator.storage.estimate();
    setStorageConsumption(usage);
  }, []);
  const resetTourGuide = () => {
    // pgw testing 13-may-2024
    console.log('resetTourGuide p1');
    // alert('resetTourGuide')

    if (localStorage) localStorage.removeItem("show_session_tour_guide");
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: " space-y-1 dark:text-white px-3 py-3 overflow-y-auto"
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("span", {
    className: "text-sm font-medium text-secondary-900 dark:text-white"
  }, "Current User")), /*#__PURE__*/React__default.createElement("td", {
    align: "right"
  }, currentUser?.displayName)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("span", {
    className: "text-sm font-medium text-secondary-900 dark:text-white"
  }, "Active subscription")), /*#__PURE__*/React__default.createElement("td", {
    align: "right"
  }, currentUser?.subscribed ? "Yes" : "No")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("span", {
    className: "text-sm font-medium text-secondary-900 dark:text-white"
  }, "Cache")), /*#__PURE__*/React__default.createElement("td", {
    align: "right"
  }, " ", /*#__PURE__*/React__default.createElement(Button, {
    size: "sm",
    onClick: clearLocalStorage,
    type: "primary"
  }, "Clear cache"))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("span", {
    className: "text-sm font-medium text-secondary-900 dark:text-white"
  }, "Tour guide")), /*#__PURE__*/React__default.createElement("td", {
    align: "right"
  }, " ", /*#__PURE__*/React__default.createElement(Button, {
    size: "sm",
    onClick: resetTourGuide,
    type: "primary"
  }, "Reset tour guide"))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("span", {
    className: "text-sm font-medium text-secondary-900 dark:text-white"
  }, "Base player version")), /*#__PURE__*/React__default.createElement("td", {
    align: "right"
  }, "v", PackageJSON.version)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("span", {
    className: "text-sm font-medium text-secondary-900 dark:text-white"
  }, "UI components version")), /*#__PURE__*/React__default.createElement("td", {
    align: "right"
  }, "v", ComponentPackageJson.version)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("span", {
    className: "text-sm font-medium text-secondary-900 dark:text-white"
  }, "App version")), /*#__PURE__*/React__default.createElement("td", {
    align: "right"
  }, parentVersion ? `v${parentVersion}` : "Running as player-application")))), /*#__PURE__*/React__default.createElement(_e$2.Group, {
    as: "div",
    className: `flex items-center justify-between`,
    onClick: handleToggleDeveloperTools
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "flex-grow flex flex-col"
  }, /*#__PURE__*/React__default.createElement(_e$2.Label, {
    as: "span",
    className: "text-sm font-medium text-secondary-900 dark:text-white mr-2",
    passive: true
  }, "Show developer tools")), /*#__PURE__*/React__default.createElement(_e$2, {
    checked: showDeveloperTools,
    onChange: handleToggleDeveloperTools,
    className: `${showDeveloperTools ? "bg-primary" : "bg-gray-200"} relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200`
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "sr-only"
  }, "Download setlist"), /*#__PURE__*/React__default.createElement("span", {
    className: `${showDeveloperTools ? "translate-x-5" : "translate-x-0"} pointer-events-none relative inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200`
  }, /*#__PURE__*/React__default.createElement("span", {
    className: `${showDeveloperTools ? "opacity-0 ease-out duration-100" : "opacity-100 ease-in duration-200"} absolute inset-0 h-full w-full flex items-center justify-center transition-opacity`,
    "aria-hidden": "true"
  }, /*#__PURE__*/React__default.createElement("svg", {
    className: "h-3 w-3 text-gray-400",
    fill: "none",
    viewBox: "0 0 12 12"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React__default.createElement("span", {
    className: `${showDeveloperTools ? "opacity-100 ease-in duration-200" : "opacity-0 ease-out duration-100"} absolute inset-0 h-full w-full flex items-center justify-center transition-opacity`,
    "aria-hidden": "true"
  }, /*#__PURE__*/React__default.createElement("svg", {
    className: "h-3 w-3 text-primary",
    fill: "currentColor",
    viewBox: "0 0 12 12"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z"
  })))))), showDeveloperTools && /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("span", {
    className: "text-sm font-medium text-secondary-900 dark:text-white"
  }, "Application debug")), /*#__PURE__*/React__default.createElement("td", {
    align: "right"
  }, /*#__PURE__*/React__default.createElement(Button, {
    size: "sm",
    onClick: handleDownloadState,
    type: "primary"
  }, "Download debug"))), sessionError && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("span", {
    className: "text-sm font-medium text-secondary-900 dark:text-white"
  }, "Session error")), /*#__PURE__*/React__default.createElement("td", {
    align: "right"
  }, store.getState().session?.error)))), /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("br", null)));
};

const Authenticated = ({
  parentVersion,
  context,
  config
}) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    setIsOpen
  } = useTour();
  const pitch = useSelector(selectPitch);
  const speed = useSelector(selectSpeed);
  const playbackState = useSelector(selectPlaybackState);
  const isLooping = useSelector(selectIsLooping);
  const loopStart = useSelector(selectLoopStart);
  const loopEnd = useSelector(selectLoopEnd);
  const duration = useSelector(selectDuration);
  const sections = useSelector(selectSections);
  const isMasterMuted = useSelector(selectIsMasterMuted);
  const title = useSelector(selectTitle);
  const artist = useSelector(selectArtist);
  const currentUser = useSelector(selectUser);
  const sidebarOpen = useSelector(selectSidebarOpen);
  const currentPositionInterval = useRef(null);
  const status = useSelector(selectStatus);
  const session = useSelector(selectSession);
  const feedbackModalVisible = useSelector(selectFeedbackModalVisible);
  const iOSModalVisible = useSelector(selectiOSModalVisible);
  const clientConfiguration = useSelector(selectClientConfig);
  const showLyrics = useSelector(selectShowLyrics);
  const songLyricsLyrics = useSelector(selectLyricsLyrics);
  const soloMode = useSelector(selectSoloMode);
  const showDeveloperTools = useSelector(selectShowDeveloperTools);
  const handleLoginLogout = () => {
    console.log("handleLoginLogout p21");

    // pgw 24-may-2024 testing
    console.log("handleLoginLogout clientConfiguration.features.auth.mode = ", clientConfiguration.features.auth.mode);
    if (clientConfiguration.features.auth.mode === "domainCookie") {
      const session_id = api.get(clientConfiguration.features.auth.domainCookie.cookieId);
      console.log("handleLoginLogout clientConfiguration.features.auth.domainCookie.cookieId = ", clientConfiguration.features.auth.domainCookie.cookieId);
      console.log("handleLoginLogout session_id = ", session_id);
      console.log("handleLoginLogout currentUser = ", currentUser);
      console.log("handleLoginLogout currentUser?.guest = ", currentUser?.guest);
      console.log("handleLoginLogout clientConfiguration.features.auth.domainCookie.logoutUrl = ", clientConfiguration.features.auth.domainCookie.logoutUrl);
      console.log("handleLoginLogout clientConfiguration.features.auth.domainCookie.loginUrl = ", clientConfiguration.features.auth.domainCookie.loginUrl);

      // pgw 04-jun-2024
      // Fix bug where logout request is never made because browser caches it

      if (!currentUser?.guest) {
        console.log("handleLoginLogout p2");
        var newlocNoCache = clientConfiguration.features.auth.domainCookie.logoutUrl + "?c=" + new Date().valueOf();
        console.log("handleLoginLogout p2a newlocNoCache = ", newlocNoCache);
        window.location.href = newlocNoCache;
        // window.location.href = clientConfiguration.features.auth.domainCookie.logoutUrl;
      } else {
        console.log("handleLoginLogout p3");
        if (session_id) {
          console.log("handleLoginLogout p4");
          dispatch(setSubscribedAsync(session_id));
        } else {
          console.log("handleLoginLogout p5");
          window.location.href = clientConfiguration.features.auth.domainCookie.loginUrl;
        }
      }
    }
    console.log("handleLoginLogout p6");
    dispatch(unmountSessionAsync());
  };
  const handleToggleSidebar = () => {
    dispatch(toggleSidebar(!sidebarOpen));
  };

  // redirect users to library if no login required
  useEffect(() => {
    if (clientConfiguration.features.auth.mode === "domainCookie") {
      if (location.pathname === "/") {
        navigate("/library");
      }
    }
  }, [location, navigate, clientConfiguration.features.auth.mode]);
  useEffect(() => {
    currentPositionInterval.current = 0;
  }, []);
  const shareSession = async () => {
    await dispatch(packSessionAsync());
  };
  const downloadSession = async () => {
    await dispatch(mountSessionAndRenderOfflineAsync({
      cache: clientConfiguration.features.session.cacheOnMount
    }));
  };
  const resetSession = async () => {
    await dispatch(resetSessionMixerSettings());
  };
  const MenuLink = ({
    to,
    label,
    icon,
    active,
    newWindow = false
  }) => {
    return /*#__PURE__*/React__default.createElement(Link, {
      target: newWindow ? '_blank' : '',
      className: `text-white ${active ? "bg-primary  hover:text-white" : ""} hover:text-primary group flex items-center px-2 py-2 text-sm font-medium rounded-md`,
      to: to,
      onClick: () => dispatch(toggleSidebar(false))
    }, icon, /*#__PURE__*/React__default.createElement("span", {
      className: "ml-1 text-white"
    }, label));
  };
  const VersionNumber = ({
    children
  }) => {
    return /*#__PURE__*/React__default.createElement("div", {
      className: `mt-4 text-white px-2 py-2 text-sm font-medium`
    }, /*#__PURE__*/React__default.createElement("small", null, children));
  };
  const handleSelectSection = section => {};
  const handleUpdatePosition = position => {
    dispatch(playSong());
    dispatch(seek(position * 1000));
  };
  const handleOnLoop = () => {
    let startMs = null;
    let endMs = null;
    if (!isLooping) {
      const currentPosition = audioEngine.currentPosition / 1000;
      if (sections?.length) {
        for (const section of sections) {
          if (currentPosition >= section.start && currentPosition < section.end) {
            startMs = section.start * 1000;
            endMs = section.end * 1000;
          }
        }
      }
    }
    dispatch(setIsLooping({
      startMs,
      endMs
    }));
  };
  const handleFeedbackModalClose = () => {
    dispatch(setFeedbackModalVisible(false));
  };
  const handleFeedbackModalSubmit = feedback => {
    dispatch(submitFeedback(feedback));
    dispatch(setFeedbackModalVisible(false));
  };
  const handleIOSModalClose = feedback => {
    dispatch(setIOSModalVisible(false));
  };
  const handleSoloModeToggle = () => {
    setIsOpen(false);
    if (soloMode) {
      dispatch(setSoloMode(false));
    } else {
      dispatch(setSoloMode(true));
    }
  };
  const handleMixReset = () => {
    // pgw 21-apr-2023
    //     console.log('show tourguide');
    //     setIsOpen(true);
    dispatch(setSoloMode(false));
    //set all track volume to  1;
    dispatch(resetSessionMixerSettings());
  };
  const getShouldShowPitchSpeedControls = () => {
    return true;
  };
  const getRouteTitle = () => {
    switch (location.pathname) {
      case "/session":
        return session.status === "ready" ? title : "Session";
      case "/setlist/create":
        return "Create setlist";
      case "/setlists":
        return "Setlists";
      case "/library":
        return "Song library";
      case "/settings":
        return "Settings";
      case "/help":
        return "Help";
      case "/experiments":
        return "Experiments";
      default:
        if (location.pathname.includes("/setlist/")) return "Setlist";
        return "";
    }
  };
  const formNavigationItems = () => {
    let navItems = [];
    navItems.push({
      element: /*#__PURE__*/React__default.createElement(MenuLink, {
        to: "/session",
        label: "Session",
        icon: /*#__PURE__*/React__default.createElement(ForwardRef$f, {
          className: "h-6 w-6'"
        }),
        active: location.pathname === "/session"
      })
    });
    if (clientConfiguration.features.setlist.enabled) {
      navItems.push({
        element: /*#__PURE__*/React__default.createElement(MenuLink, {
          to: "/my-setlist",
          label: clientConfiguration.labels.setlist,
          icon: /*#__PURE__*/React__default.createElement(ForwardRef$c, {
            className: "h-6 w-6'"
          }),
          active: location.pathname === "/my-setlist"
        })
      });
    }
    navItems.push({
      element: /*#__PURE__*/React__default.createElement(MenuLink, {
        to: "/library",
        label: clientConfiguration.labels.library,
        icon: /*#__PURE__*/React__default.createElement(ForwardRef$6, {
          className: "h-6 w-6'"
        }),
        active: location.pathname === "/library"
      })
    });
    if (clientConfiguration.features.setlists.enabled) {
      navItems.push({
        element: /*#__PURE__*/React__default.createElement(MenuLink, {
          to: "/setlists",
          label: clientConfiguration.labels.setlists,
          icon: /*#__PURE__*/React__default.createElement(ForwardRef$c, {
            className: "h-6 w-6'"
          }),
          active: location.pathname === "/setlists" || location.pathname.includes("/setlist/")
        })
      });
    }
    navItems.push({
      element: /*#__PURE__*/React__default.createElement(MenuLink
      // newWindow={location.pathname !== '/help' ? true: false}
      , {
        to: "/help",
        label: "Help",
        icon: /*#__PURE__*/React__default.createElement(ForwardRef$4, {
          className: "h-6 w-6'"
        }),
        active: location.pathname === "/help"
      })
    });
    navItems.push({
      element: /*#__PURE__*/React__default.createElement(MenuLink, {
        to: "/settings",
        label: /*#__PURE__*/React__default.createElement("div", {
          id: "ram-display"
        }, "Settings"),
        icon: /*#__PURE__*/React__default.createElement(ForwardRef$d, {
          className: "h-6 w-6'"
        }),
        active: location.pathname === "/settings"
      })
    });
    if (showDeveloperTools) {
      navItems.push({
        element: /*#__PURE__*/React__default.createElement(MenuLink, {
          to: "/settings",
          label: /*#__PURE__*/React__default.createElement("div", {
            id: "ram-display"
          }, window.ramUsage.toUpperCase(), " used"),
          icon: null,
          active: false
        })
      });
    }
    navItems.push({
      element: /*#__PURE__*/React__default.createElement(VersionNumber, null, "v", parentVersion)
    });
    return navItems;
  };
  return clientConfiguration ? /*#__PURE__*/React__default.createElement(Main, {
    logoUrl: `${process.env.PUBLIC_URL}${clientConfiguration.images.menuLogo}`,
    logoLink: `${clientConfiguration.images.menuLogoLink}`,
    backgroundUrl: `${process.env.PUBLIC_URL}${clientConfiguration.images.menuBackground}`,
    navigationItems: formNavigationItems(),
    user: currentUser,
    navigation: [],
    loginLogoutLabel: !currentUser.guest ? clientConfiguration.features.auth[clientConfiguration.features.auth.mode].logoutLabel : clientConfiguration.features.auth[clientConfiguration.features.auth.mode].loginLabel,
    onLoginLogout: handleLoginLogout,
    headerContext: {
      currentSong: {
        title: getRouteTitle(),
        artist: artist
      },
      onShare: shareSession,
      onAddStem: () => dispatch(setNewTrackModalVisible(true)),
      onDownload: downloadSession,
      onReset: resetSession,
      showExtraMenu: false,
      showActionButton: songLyricsLyrics && location.pathname === "/session" && status === "ready",
      actionButtonActive: showLyrics,
      onClickedActionButon: () => dispatch(setShowLyrics(!showLyrics))
    },
    sidebarOpen: sidebarOpen,
    onToggleSidebar: handleToggleSidebar
  }, /*#__PURE__*/React__default.createElement(PlayerContainer, {
    showPitchSpeedControls: getShouldShowPitchSpeedControls(),
    showMixRecord: clientConfiguration.features.session.showMixRecord,
    pitch: pitch,
    speed: speed,
    onChangeSpeed: v => dispatch(changeGlobalPlaybackRate(v)),
    onSpeedMinus: () => dispatch(decreaseGlobalPlaybackRate()),
    onSpeedPlus: () => dispatch(increaseGlobalPlaybackRate()),
    onChangePitch: v => dispatch(changeGlobalPitch(v)),
    onPitchMinus: () => dispatch(decreaseGlobalPitchRate()),
    onPitchPlus: () => dispatch(increaseGlobalPitchRate()),
    getCurrentPosition: () => audioEngine.currentPosition / 1000,
    onChangePosition: handleUpdatePosition,
    onSelectSection: handleSelectSection,
    onSoloModeToggle: handleSoloModeToggle,
    soloMode: soloMode,
    onReset: handleMixReset,
    onMute: v => dispatch(toggleMasterMute()),
    song: {
      title: title,
      artist: artist,
      length: duration,
      sections: sections
    },
    onPlayPause: () => {
      if (playbackState === "playing") {
        dispatch(pauseSong());
      } else {
        dispatch(playSong());
      }
    },
    onStop: () => dispatch(stopSong()),
    onRecord: () => dispatch(recordSong()),
    onLoop: handleOnLoop,
    isRecording: playbackState === "recording",
    isPlaying: playbackState === "recording" || playbackState === "playing",
    isMuted: isMasterMuted,
    isLooping: isLooping,
    loopStart: loopStart / 1000,
    loopEnd: loopEnd / 1000,
    showTransportControls: location.pathname === "/session" && status === "ready"
  }, /*#__PURE__*/React__default.createElement(Routes, null, /*#__PURE__*/React__default.createElement(Route, {
    path: `/session`,
    element: /*#__PURE__*/React__default.createElement(Session, null)
  }), clientConfiguration.features.setlist.enabled && /*#__PURE__*/React__default.createElement(Route, {
    path: `/my-setlist`,
    element: /*#__PURE__*/React__default.createElement(MySetListContainer, null)
  }), clientConfiguration.features.setlists.enabled && /*#__PURE__*/React__default.createElement(Route, {
    path: `/setlist/:id`,
    element: /*#__PURE__*/React__default.createElement(SetListContainer, null)
  }), clientConfiguration.features.setlists.enabled && /*#__PURE__*/React__default.createElement(Route, {
    path: `/setlist/create`,
    element: /*#__PURE__*/React__default.createElement(CreateSetlistContainer, null)
  }), clientConfiguration.features.setlists.enabled && /*#__PURE__*/React__default.createElement(Route, {
    path: `/setlists`,
    element: /*#__PURE__*/React__default.createElement(SetListsContainer, null)
  }), /*#__PURE__*/React__default.createElement(Route, {
    path: `/library`,
    element: /*#__PURE__*/React__default.createElement(LibraryContainer, null)
  }), /*#__PURE__*/React__default.createElement(Route, {
    path: `/help`,
    element: /*#__PURE__*/React__default.createElement(HelpPage, null)
  }), /*#__PURE__*/React__default.createElement(Route, {
    path: `/settings`,
    element: /*#__PURE__*/React__default.createElement(Settings, null)
  }), /*#__PURE__*/React__default.createElement(Route, {
    path: `/experiments`,
    element: /*#__PURE__*/React__default.createElement(Experiments, null)
  }), /*#__PURE__*/React__default.createElement(Route, {
    path: "*",
    element: /*#__PURE__*/React__default.createElement(NotFound, null)
  }))), feedbackModalVisible && /*#__PURE__*/React__default.createElement(FeedbackModal, {
    onClose: handleFeedbackModalClose,
    onSubmit: handleFeedbackModalSubmit
  }), iOSModalVisible && /*#__PURE__*/React__default.createElement(IOSModal, {
    onClose: handleIOSModalClose
  })) : /*#__PURE__*/React__default.createElement(Navigate, {
    to: "/"
  });
};

var css_248z$4 = ".chromeIcon{margin:0 auto;max-width:200px}.storeLink{margin:40px 0}";
styleInject(css_248z$4,{"insertAt":"top"});

const products = ['iPhone', 'iPad'];
const NotSupportedSplash = ({
  platform,
  logoUrl
}) => {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "flex flex-1 flex-col space-y-3 justify-start px-6 py-5 items-center text-center mt-8 dark:text-secondary-300"
  }, /*#__PURE__*/React__default.createElement("img", {
    className: "chromeIcon mb-4",
    alt: "Get Google chrome",
    src: logoUrl
  }), products.includes(platform) && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("h3", {
    classsname: "mt-4 text-lg"
  }, "You currently need ", /*#__PURE__*/React__default.createElement("b", null, "iOS 15"), " installed on your device to run this website."), /*#__PURE__*/React__default.createElement("a", {
    href: "https://support.apple.com/en-gb/guide/iphone/iph3e504502/ios"
  }, /*#__PURE__*/React__default.createElement("img", {
    className: "chromeIcon",
    align: "center",
    alt: "Update iOS",
    src: `${process.env.PUBLIC_URL}/images/appstore.svg`
  }))), !products.includes(platform) && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("img", {
    className: "chromeIcon",
    alt: "Get Google chrome",
    src: `${process.env.PUBLIC_URL}/images/chromeLogo.svg`
  }), /*#__PURE__*/React__default.createElement("h1", {
    className: "mt-2 text-lg font-medium"
  }, "Google Chrome"), /*#__PURE__*/React__default.createElement("div", {
    className: "storeLink"
  }, /*#__PURE__*/React__default.createElement("a", {
    href: "https://play.google.com/store/apps/details?id=com.android.chrome"
  }, /*#__PURE__*/React__default.createElement("img", {
    alt: "Google Play Store link",
    src: `${process.env.PUBLIC_URL}/images/google-play-badge.svg`
  }))), /*#__PURE__*/React__default.createElement("h2", {
    className: "mt-2 text-lg font-medium"
  }, "You cannot use this application with the built-in browser on Samsung phones."), /*#__PURE__*/React__default.createElement("h2", {
    className: "mt-2 text-md font-medium"
  }, "Please download Google Chrome and revisit the application.")));
};

var reactIosPwaPrompt = {exports: {}};

(function (module, exports) {
	!function (e, t) {
	  module.exports = t(React__default) ;
	}(commonjsGlobal$1, function (e) {
	  return function (e) {
	    var t = {};
	    function r(o) {
	      if (t[o]) return t[o].exports;
	      var n = t[o] = {
	        i: o,
	        l: !1,
	        exports: {}
	      };
	      return e[o].call(n.exports, n, n.exports, r), n.l = !0, n.exports;
	    }
	    return r.m = e, r.c = t, r.d = function (e, t, o) {
	      r.o(e, t) || Object.defineProperty(e, t, {
	        enumerable: !0,
	        get: o
	      });
	    }, r.r = function (e) {
	      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
	        value: "Module"
	      }), Object.defineProperty(e, "__esModule", {
	        value: !0
	      });
	    }, r.t = function (e, t) {
	      if (1 & t && (e = r(e)), 8 & t) return e;
	      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
	      var o = Object.create(null);
	      if (r.r(o), Object.defineProperty(o, "default", {
	        enumerable: !0,
	        value: e
	      }), 2 & t && "string" != typeof e) for (var n in e) r.d(o, n, function (t) {
	        return e[t];
	      }.bind(null, n));
	      return o;
	    }, r.n = function (e) {
	      var t = e && e.__esModule ? function () {
	        return e.default;
	      } : function () {
	        return e;
	      };
	      return r.d(t, "a", t), t;
	    }, r.o = function (e, t) {
	      return Object.prototype.hasOwnProperty.call(e, t);
	    }, r.p = "/dist/", r(r.s = 5);
	  }([function (t, r) {
	    t.exports = e;
	  }, function (e, t, r) {
	    var o = r(2),
	      n = r(3);
	    "string" == typeof (n = n.__esModule ? n.default : n) && (n = [[e.i, n, ""]]);
	    var a = {
	        insert: "head",
	        singleton: !1
	      },
	      c = (o(n, a), n.locals ? n.locals : {});
	    e.exports = c;
	  }, function (e, t, r) {

	    var o,
	      n = function () {
	        return void 0 === o && (o = Boolean(window && document && document.all && !window.atob)), o;
	      },
	      a = function () {
	        var e = {};
	        return function (t) {
	          if (void 0 === e[t]) {
	            var r = document.querySelector(t);
	            if (window.HTMLIFrameElement && r instanceof window.HTMLIFrameElement) try {
	              r = r.contentDocument.head;
	            } catch (e) {
	              r = null;
	            }
	            e[t] = r;
	          }
	          return e[t];
	        };
	      }(),
	      c = [];
	    function i(e) {
	      for (var t = -1, r = 0; r < c.length; r++) if (c[r].identifier === e) {
	        t = r;
	        break;
	      }
	      return t;
	    }
	    function l(e, t) {
	      for (var r = {}, o = [], n = 0; n < e.length; n++) {
	        var a = e[n],
	          l = t.base ? a[0] + t.base : a[0],
	          s = r[l] || 0,
	          p = "".concat(l, " ").concat(s);
	        r[l] = s + 1;
	        var d = i(p),
	          f = {
	            css: a[1],
	            media: a[2],
	            sourceMap: a[3]
	          };
	        -1 !== d ? (c[d].references++, c[d].updater(f)) : c.push({
	          identifier: p,
	          updater: v(f, t),
	          references: 1
	        }), o.push(p);
	      }
	      return o;
	    }
	    function s(e) {
	      var t = document.createElement("style"),
	        o = e.attributes || {};
	      if (void 0 === o.nonce) {
	        var n = r.nc;
	        n && (o.nonce = n);
	      }
	      if (Object.keys(o).forEach(function (e) {
	        t.setAttribute(e, o[e]);
	      }), "function" == typeof e.insert) e.insert(t);else {
	        var c = a(e.insert || "head");
	        if (!c) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
	        c.appendChild(t);
	      }
	      return t;
	    }
	    var p,
	      d = (p = [], function (e, t) {
	        return p[e] = t, p.filter(Boolean).join("\n");
	      });
	    function f(e, t, r, o) {
	      var n = r ? "" : o.media ? "@media ".concat(o.media, " {").concat(o.css, "}") : o.css;
	      if (e.styleSheet) e.styleSheet.cssText = d(t, n);else {
	        var a = document.createTextNode(n),
	          c = e.childNodes;
	        c[t] && e.removeChild(c[t]), c.length ? e.insertBefore(a, c[t]) : e.appendChild(a);
	      }
	    }
	    function u(e, t, r) {
	      var o = r.css,
	        n = r.media,
	        a = r.sourceMap;
	      if (n ? e.setAttribute("media", n) : e.removeAttribute("media"), a && btoa && (o += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(a)))), " */")), e.styleSheet) e.styleSheet.cssText = o;else {
	        for (; e.firstChild;) e.removeChild(e.firstChild);
	        e.appendChild(document.createTextNode(o));
	      }
	    }
	    var m = null,
	      b = 0;
	    function v(e, t) {
	      var r, o, n;
	      if (t.singleton) {
	        var a = b++;
	        r = m || (m = s(t)), o = f.bind(null, r, a, !1), n = f.bind(null, r, a, !0);
	      } else r = s(t), o = u.bind(null, r, t), n = function () {
	        !function (e) {
	          if (null === e.parentNode) return !1;
	          e.parentNode.removeChild(e);
	        }(r);
	      };
	      return o(e), function (t) {
	        if (t) {
	          if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
	          o(e = t);
	        } else n();
	      };
	    }
	    e.exports = function (e, t) {
	      (t = t || {}).singleton || "boolean" == typeof t.singleton || (t.singleton = n());
	      var r = l(e = e || [], t);
	      return function (e) {
	        if (e = e || [], "[object Array]" === Object.prototype.toString.call(e)) {
	          for (var o = 0; o < r.length; o++) {
	            var n = i(r[o]);
	            c[n].references--;
	          }
	          for (var a = l(e, t), s = 0; s < r.length; s++) {
	            var p = i(r[s]);
	            0 === c[p].references && (c[p].updater(), c.splice(p, 1));
	          }
	          r = a;
	        }
	      };
	    };
	  }, function (e, t, r) {
	    (t = r(4)(!1)).push([e.i, '._4e96{overflow:hidden}._132a{background-color:rgba(0,0,0,0.8);left:0;min-height:100vh;min-height:-webkit-fill-available;opacity:0;position:fixed;top:0;transition:opacity 0.2s ease-in;width:100vw;z-index:999999}._132a._7c0e{opacity:1;display:block}._132a.efc7{pointer-events:none;touch-action:none}@media (prefers-color-scheme: dark){._132a._20ef{background:rgba(10,10,10,0.5);color:rgba(235,235,245,0.6)}}._6733{-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px);background-color:rgba(250,250,250,0.8);border-radius:10px;bottom:0;color:black;filter:brightness(1.1);left:0;margin:0 8px 10px;overflow:hidden;position:fixed;transform:translateY(calc(100% + 10px));transition:transform 0.4s cubic-bezier(0.4, 0.24, 0.3, 1);width:calc(100vw - 16px);z-index:999999}._6733._7c0e{transform:translateY(0);display:block}._6733.efc7{pointer-events:none;touch-action:none}._6733._20ef{background:rgba(255,255,255,0.6);filter:brightness(1.6)}@media (prefers-color-scheme: dark){._6733._20ef{background:rgba(65,65,65,0.7);filter:brightness(1.1)}}._199d{align-items:center;border-bottom:1px solid rgba(0,0,0,0.1);border-top:0px;border-left:0px;border-right:0px;border-width:0.5px;display:flex;flex-flow:row nowrap;justify-content:space-between;padding:13px 16px}._20ef ._199d{border-color:rgba(60,60,67,0.29)}@media (prefers-color-scheme: dark){._20ef ._199d{border-color:rgba(140,140,140,0.7)}}._199d .ab5d{color:#333;font-family:-apple-system,system-ui,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif;font-size:18px;font-weight:500;line-height:1.125;margin:0;padding:0}._20ef ._199d .ab5d{color:#000}@media (prefers-color-scheme: dark){._20ef ._199d .ab5d{color:#fff}}._199d ._6a7e{color:#2d7cf6;font-size:16px;padding:0;margin:0;border:0;background:transparent}._20ef ._199d ._6a7e{color:#0055b3}@media (prefers-color-scheme: dark){._20ef ._199d ._6a7e{color:#0984ff}}.ebda{display:flex;width:100%}.ebda .a91e{border-bottom:1px solid rgba(0,0,0,0.1);border-top:0px;border-left:0px;border-right:0px;border-width:0.5px;color:inherit;margin:0 16px;padding:16px;width:100%}._20ef .ebda .a91e{border-color:rgba(60,60,67,0.29)}@media (prefers-color-scheme: dark){._20ef .ebda .a91e{border-color:rgba(140,140,140,0.7)}}._7d3c{color:#7b7b7a;font-family:-apple-system,system-ui,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif;font-size:13px;line-height:17px;margin:0;padding:0}._7d3c.e161{font-weight:600}._20ef ._7d3c{color:rgba(60,60,67,0.6)}@media (prefers-color-scheme: dark){._20ef ._7d3c{border-color:rgba(235,235,245,0.6);color:rgba(235,235,245,0.6)}}.e6cc{color:inherit;margin:0 16px;padding:16px}.e6cc ._3183{align-items:center;display:flex;flex-flow:row nowrap;justify-content:flex-start;text-align:left;margin-bottom:16px}.e6cc ._3183:last-of-type{margin-bottom:0}.e6cc ._4408,.e6cc ._4b98{flex:0 0 auto;height:30px;margin-right:32px;width:25px}.e6cc ._4b98{color:#2d7cf6}._20ef .e6cc ._4b98{color:black;fill:black}@media (prefers-color-scheme: dark){._20ef .e6cc ._4b98{color:white;fill:white}}.e6cc ._4408{color:#2d7cf6;fill:#2d7cf6}._20ef .e6cc ._4408{color:#0055b3;fill:#0055b3}@media (prefers-color-scheme: dark){._20ef .e6cc ._4408{color:#0984ff;fill:#0984ff}}\n', ""]), t.locals = {
	      noScroll: "_4e96",
	      pwaPromptOverlay: "_132a",
	      visible: "_7c0e",
	      hidden: "efc7",
	      modern: "_20ef",
	      pwaPrompt: "_6733",
	      pwaPromptHeader: "_199d",
	      pwaPromptTitle: "ab5d",
	      pwaPromptCancel: "_6a7e",
	      pwaPromptBody: "ebda",
	      pwaPromptDescription: "a91e",
	      pwaPromptCopy: "_7d3c",
	      bold: "e161",
	      pwaPromptInstruction: "e6cc",
	      pwaPromptInstructionStep: "_3183",
	      pwaPromptShareIcon: "_4408",
	      pwaPromptHomeIcon: "_4b98"
	    }, e.exports = t;
	  }, function (e, t, r) {

	    e.exports = function (e) {
	      var t = [];
	      return t.toString = function () {
	        return this.map(function (t) {
	          var r = function (e, t) {
	            var r = e[1] || "",
	              o = e[3];
	            if (!o) return r;
	            if (t && "function" == typeof btoa) {
	              var n = (c = o, i = btoa(unescape(encodeURIComponent(JSON.stringify(c)))), l = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(i), "/*# ".concat(l, " */")),
	                a = o.sources.map(function (e) {
	                  return "/*# sourceURL=".concat(o.sourceRoot || "").concat(e, " */");
	                });
	              return [r].concat(a).concat([n]).join("\n");
	            }
	            var c, i, l;
	            return [r].join("\n");
	          }(t, e);
	          return t[2] ? "@media ".concat(t[2], " {").concat(r, "}") : r;
	        }).join("");
	      }, t.i = function (e, r, o) {
	        "string" == typeof e && (e = [[null, e, ""]]);
	        var n = {};
	        if (o) for (var a = 0; a < this.length; a++) {
	          var c = this[a][0];
	          null != c && (n[c] = !0);
	        }
	        for (var i = 0; i < e.length; i++) {
	          var l = [].concat(e[i]);
	          o && n[l[0]] || (r && (l[2] ? l[2] = "".concat(r, " and ").concat(l[2]) : l[2] = r), t.push(l));
	        }
	      }, t;
	    };
	  }, function (e, t, r) {

	    r.r(t);
	    var o = r(0),
	      n = r.n(o),
	      a = function (e) {
	        var t = e.className,
	          r = e.modern;
	        return void 0 !== r && r ? n.a.createElement("svg", {
	          xmlns: "http://www.w3.org/2000/svg",
	          className: t,
	          viewBox: "0 0 566 670"
	        }, n.a.createElement("path", {
	          d: "M255 12c4-4 10-8 16-8s12 3 16 8l94 89c3 4 6 7 8 12 2 6 0 14-5 19-7 8-20 9-28 2l-7-7-57-60 2 54v276c0 12-10 22-22 22-12 1-24-10-23-22V110l1-43-60 65c-5 5-13 8-21 6a19 19 0 0 1-16-17c-1-7 2-13 7-18l95-91z"
	        }), n.a.createElement("path", {
	          d: "M43 207c16-17 40-23 63-23h83v46h-79c-12 0-25 3-33 13-8 9-10 21-10 33v260c0 13 0 27 6 38 5 12 18 18 30 19l14 1h302c14 0 28 0 40-8 11-7 16-21 16-34V276c0-11-2-24-9-33-8-10-22-13-34-13h-78v-46h75c13 0 25 1 37 4 16 4 31 13 41 27 11 17 14 37 14 57v280c0 20-3 41-15 58a71 71 0 0 1-45 27c-11 2-23 3-34 3H109c-19-1-40-4-56-15-14-9-23-23-27-38-4-12-5-25-5-38V270c1-22 6-47 22-63z"
	        })) : n.a.createElement("svg", {
	          xmlns: "http://www.w3.org/2000/svg",
	          className: t,
	          viewBox: "0 0 120 169"
	        }, n.a.createElement("g", {
	          fill: "currentColor"
	        }, n.a.createElement("path", {
	          d: "M60 0l28 28-2 2a586 586 0 0 0-4 4L64 15v90h-8V15L38 34l-4-4-2-2L60 0z"
	        }), n.a.createElement("path", {
	          d: "M0 49h44v8H8v104h104V57H76v-8h44v120H0V49z"
	        })));
	      },
	      c = function (e) {
	        var t = e.className,
	          r = e.modern;
	        return void 0 !== r && r ? n.a.createElement("svg", {
	          xmlns: "http://www.w3.org/2000/svg",
	          className: t,
	          viewBox: "0 0 578 584"
	        }, n.a.createElement("path", {
	          d: "M101 35l19-1h333c12 0 23 0 35 3 17 3 34 12 44 27 13 16 16 38 16 58v329c0 19 0 39-8 57a65 65 0 0 1-37 37c-18 7-38 7-57 7H130c-21 1-44 0-63-10-14-7-25-20-30-34-6-15-8-30-8-45V121c1-21 5-44 19-61 13-16 33-23 53-25m7 46c-10 1-19 6-24 14-7 8-9 20-9 31v334c0 12 2 25 10 34 9 10 23 12 35 12h336c14 1 30-3 38-15 6-9 8-20 8-31V125c0-12-2-24-10-33-9-9-22-12-35-12H121l-13 1z"
	        }), n.a.createElement("path", {
	          d: "M271 161c9-11 31-10 38 4 3 5 3 11 3 17v87h88c7 0 16 1 21 7 6 6 7 14 6 22a21 21 0 0 1-10 14c-5 4-11 5-17 5h-88v82c0 7-1 15-6 20-10 10-29 10-37-2-3-6-4-13-4-19v-81h-87c-8-1-17-3-23-9-5-6-6-15-4-22a21 21 0 0 1 11-14c6-3 13-3 19-3h84v-88c0-7 1-14 6-20z"
	        })) : n.a.createElement("svg", {
	          xmlns: "http://www.w3.org/2000/svg",
	          className: t,
	          viewBox: "55.99425507 31.98999977 157.76574707 157.76371765"
	        }, n.a.createElement("path", {
	          fill: "#58595b",
	          d: "M90.49 32.83a54.6 54.6 0 019.55-.84c23.98.03 47.96 0 71.94.01 8.5.07 17.3 1.74 24.4 6.65 10.94 7.28 16.52 20.54 17.35 33.3.06 26.03 0 52.06.03 78.08 0 10.16-3.59 20.56-10.95 27.73-7.93 7.61-18.94 11.43-29.79 11.98-25.71.03-51.42 0-77.12.01-10.37-.11-21.01-3.77-28.17-11.48-8.22-8.9-11.72-21.29-11.73-33.21.01-23.03-.03-46.05.02-69.07-.01-9.14 1.33-18.71 6.65-26.4 6.21-9.4 16.97-14.79 27.82-16.76m38.18 41.09c-.05 10.25.01 20.5 0 30.75-9.58-.03-19.16.02-28.75-.04-2.27.08-4.98-.25-6.68 1.61-2.84 2.34-2.75 7.12.01 9.48 1.8 1.69 4.46 1.57 6.75 1.64 9.56-.04 19.12-.01 28.67-.03.02 10.24-.06 20.48.01 30.72-.14 2.66 1.36 5.4 3.95 6.3 3.66 1.66 8.52-1.13 8.61-5.23.26-10.59.02-21.2.09-31.79 9.88 0 19.76.02 29.64.01 2.74.12 5.85-.67 7.14-3.34 2.23-3.75-.61-9.34-5.08-9.29-10.57-.14-21.14-.01-31.7-.04-.01-10.25.04-20.49 0-30.74.3-3.5-2.66-7.09-6.3-6.79-3.65-.33-6.66 3.26-6.36 6.78z"
	        }), n.a.createElement("path", {
	          fill: "transparent",
	          d: "M128.67 73.92c-.3-3.52 2.71-7.11 6.36-6.78 3.64-.3 6.6 3.29 6.3 6.79.04 10.25-.01 20.49 0 30.74 10.56.03 21.13-.1 31.7.04 4.47-.05 7.31 5.54 5.08 9.29-1.29 2.67-4.4 3.46-7.14 3.34-9.88.01-19.76-.01-29.64-.01-.07 10.59.17 21.2-.09 31.79-.09 4.1-4.95 6.89-8.61 5.23-2.59-.9-4.09-3.64-3.95-6.3-.07-10.24.01-20.48-.01-30.72-9.55.02-19.11-.01-28.67.03-2.29-.07-4.95.05-6.75-1.64-2.76-2.36-2.85-7.14-.01-9.48 1.7-1.86 4.41-1.53 6.68-1.61 9.59.06 19.17.01 28.75.04.01-10.25-.05-20.5 0-30.75z"
	        }));
	      },
	      i = r(1),
	      l = r.n(i);
	    function s(e, t) {
	      var r = Object.keys(e);
	      if (Object.getOwnPropertySymbols) {
	        var o = Object.getOwnPropertySymbols(e);
	        t && (o = o.filter(function (t) {
	          return Object.getOwnPropertyDescriptor(e, t).enumerable;
	        })), r.push.apply(r, o);
	      }
	      return r;
	    }
	    function p(e, t, r) {
	      return t in e ? Object.defineProperty(e, t, {
	        value: r,
	        enumerable: !0,
	        configurable: !0,
	        writable: !0
	      }) : e[t] = r, e;
	    }
	    function d(e, t) {
	      return function (e) {
	        if (Array.isArray(e)) return e;
	      }(e) || function (e, t) {
	        if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
	        var r = [],
	          o = !0,
	          n = !1,
	          a = void 0;
	        try {
	          for (var c, i = e[Symbol.iterator](); !(o = (c = i.next()).done) && (r.push(c.value), !t || r.length !== t); o = !0);
	        } catch (e) {
	          n = !0, a = e;
	        } finally {
	          try {
	            o || null == i.return || i.return();
	          } finally {
	            if (n) throw a;
	          }
	        }
	        return r;
	      }(e, t) || function (e, t) {
	        if (!e) return;
	        if ("string" == typeof e) return f(e, t);
	        var r = Object.prototype.toString.call(e).slice(8, -1);
	        "Object" === r && e.constructor && (r = e.constructor.name);
	        if ("Map" === r || "Set" === r) return Array.from(r);
	        if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return f(e, t);
	      }(e, t) || function () {
	        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	      }();
	    }
	    function f(e, t) {
	      (null == t || t > e.length) && (t = e.length);
	      for (var r = 0, o = new Array(t); r < t; r++) o[r] = e[r];
	      return o;
	    }
	    var u = function (e) {
	      var t = e.delay,
	        r = e.copyTitle,
	        i = e.copyBody,
	        f = e.copyAddHomeButtonLabel,
	        u = e.copyShareButtonLabel,
	        m = e.copyClosePrompt,
	        b = e.permanentlyHideOnDismiss,
	        v = e.promptData,
	        y = e.maxVisits,
	        h = e.onClose,
	        g = d(Object(o.useState)(!Boolean(t)), 2),
	        w = g[0],
	        O = g[1];
	      Object(o.useEffect)(function () {
	        t && setTimeout(function () {
	          document.activeElement && document.activeElement.blur(), O(!0);
	        }, t);
	      }, []), Object(o.useEffect)(function () {
	        w && document.body.classList.add(l.a.noScroll);
	      }, [w]);
	      var P = /OS (13|14)/.test(window.navigator.userAgent),
	        _ = w ? l.a.visible : l.a.hidden,
	        x = P ? l.a.modern : "legacy",
	        S = function (e) {
	          document.body.classList.remove(l.a.noScroll), O(!1), b && localStorage.setItem("iosPwaPrompt", JSON.stringify(function (e) {
	            for (var t = 1; t < arguments.length; t++) {
	              var r = null != arguments[t] ? arguments[t] : {};
	              t % 2 ? s(Object(r), !0).forEach(function (t) {
	                p(e, t, r[t]);
	              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : s(Object(r)).forEach(function (t) {
	                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
	              });
	            }
	            return e;
	          }({}, v, {
	            visits: y
	          }))), "function" == typeof h && h(e);
	        },
	        j = function (e) {
	          w || (e.currentTarget.style.display = "none");
	        };
	      return n.a.createElement(o.Fragment, null, n.a.createElement("div", {
	        className: "".concat(l.a.pwaPromptOverlay, " ").concat(_, " ").concat(x, " iOSPWA-overlay"),
	        "aria-label": "Close",
	        role: "button",
	        onClick: S,
	        onTransitionEnd: j
	      }), n.a.createElement("div", {
	        className: "".concat(l.a.pwaPrompt, " ").concat(_, " ").concat(x, " iOSPWA-container"),
	        "aria-describedby": "pwa-prompt-description",
	        "aria-labelledby": "pwa-prompt-title",
	        role: "dialog",
	        onTransitionEnd: j
	      }, n.a.createElement("div", {
	        className: "".concat(l.a.pwaPromptHeader, " iOSPWA-header")
	      }, n.a.createElement("p", {
	        id: "pwa-prompt-title",
	        className: "".concat(l.a.pwaPromptTitle, " iOSPWA-title")
	      }, r), n.a.createElement("button", {
	        className: "".concat(l.a.pwaPromptCancel, " iOSPWA-cancel"),
	        onClick: S
	      }, m)), n.a.createElement("div", {
	        className: "".concat(l.a.pwaPromptBody, " iOSPWA-body")
	      }, n.a.createElement("div", {
	        className: "".concat(l.a.pwaPromptDescription, " iOSPWA-description")
	      }, n.a.createElement("p", {
	        id: "pwa-prompt-description",
	        className: "".concat(l.a.pwaPromptCopy, " iOSPWA-description-copy")
	      }, i))), n.a.createElement("div", {
	        className: "".concat(l.a.pwaPromptInstruction, " iOSPWA-steps")
	      }, n.a.createElement("div", {
	        className: "".concat(l.a.pwaPromptInstructionStep, " iOSPWA-step1")
	      }, n.a.createElement(a, {
	        className: "".concat(l.a.pwaPromptShareIcon, " iOSPWA-step1-icon"),
	        modern: P
	      }), n.a.createElement("p", {
	        className: "".concat(l.a.pwaPromptCopy, " ").concat(l.a.bold, " iOSPWA-step1-copy")
	      }, u)), n.a.createElement("div", {
	        className: "".concat(l.a.pwaPromptInstructionStep, " iOSPWA-step2")
	      }, n.a.createElement(c, {
	        className: "".concat(l.a.pwaPromptHomeIcon, " iOSPWA-step2-icon"),
	        modern: P
	      }), n.a.createElement("p", {
	        className: "".concat(l.a.pwaPromptCopy, " ").concat(l.a.bold, " iOSPWA-step2-copy")
	      }, f)))));
	    };
	    function m(e, t) {
	      var r = Object.keys(e);
	      if (Object.getOwnPropertySymbols) {
	        var o = Object.getOwnPropertySymbols(e);
	        t && (o = o.filter(function (t) {
	          return Object.getOwnPropertyDescriptor(e, t).enumerable;
	        })), r.push.apply(r, o);
	      }
	      return r;
	    }
	    function b(e, t, r) {
	      return t in e ? Object.defineProperty(e, t, {
	        value: r,
	        enumerable: !0,
	        configurable: !0,
	        writable: !0
	      }) : e[t] = r, e;
	    }
	    t.default = function (e) {
	      var t,
	        r,
	        o,
	        a = e.timesToShow,
	        c = void 0 === a ? 1 : a,
	        i = e.promptOnVisit,
	        l = void 0 === i ? 1 : i,
	        s = e.permanentlyHideOnDismiss,
	        p = void 0 === s || s,
	        d = e.copyTitle,
	        f = void 0 === d ? "Add to Home Screen" : d,
	        v = e.copyBody,
	        y = void 0 === v ? "This website has app functionality. Add it to your home screen to use it in fullscreen and while offline." : v,
	        h = e.copyShareButtonLabel,
	        g = void 0 === h ? "1) Press the 'Share' button on the menu bar below." : h,
	        w = e.copyAddHomeButtonLabel,
	        O = void 0 === w ? "2) Press 'Add to Home Screen'." : w,
	        P = e.copyClosePrompt,
	        _ = void 0 === P ? "Cancel" : P,
	        x = e.delay,
	        S = void 0 === x ? 1e3 : x,
	        j = e.debug,
	        E = void 0 !== j && j,
	        A = e.onClose,
	        N = void 0 === A ? function () {} : A,
	        k = JSON.parse(localStorage.getItem("iosPwaPrompt"));
	      if (null === k && (k = {
	        isiOS: (t = /iphone|ipad|ipod/.test(window.navigator.userAgent.toLowerCase()), r = "MacIntel" === navigator.platform && navigator.maxTouchPoints > 1, o = "standalone" in window.navigator && window.navigator.standalone, (t || r) && !o),
	        visits: 0
	      }, localStorage.setItem("iosPwaPrompt", JSON.stringify(k))), k.isiOS || E) {
	        var C = k.visits + 1 >= l;
	        if ((k.visits + 1 < l + c || E) && (localStorage.setItem("iosPwaPrompt", JSON.stringify(function (e) {
	          for (var t = 1; t < arguments.length; t++) {
	            var r = null != arguments[t] ? arguments[t] : {};
	            t % 2 ? m(Object(r), !0).forEach(function (t) {
	              b(e, t, r[t]);
	            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : m(Object(r)).forEach(function (t) {
	              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
	            });
	          }
	          return e;
	        }({}, k, {
	          visits: k.visits + 1
	        }))), C || E)) return n.a.createElement(u, {
	          delay: S,
	          copyTitle: f,
	          copyBody: y,
	          copyAddHomeButtonLabel: O,
	          copyShareButtonLabel: g,
	          copyClosePrompt: _,
	          permanentlyHideOnDismiss: p,
	          promptData: k,
	          maxVisits: c + l,
	          onClose: N
	        });
	      }
	      return null;
	    };
	  }]);
	});
} (reactIosPwaPrompt));

var PWAPrompt = /*@__PURE__*/getDefaultExportFromCjs(reactIosPwaPrompt.exports);

const OfflineVersioning = () => {
  const dispatch = useDispatch();
  useSelector(selectServiceWorkerRegistration);
  const serviceWorkerInitialized = useSelector(selectServiceWorkerInitialized);
  useSelector(selectServiceWorkerUpdated);
  const dismissedOfflineNotification = useSelector(selectDismissedOfflineNotification);
  const os = useRef(platform.os);
  const dismissOfflineNotification = () => {
    dispatch(setDismissedOfflineNotification(true));
  };

  // console.log(os.current.family, serviceWorkerRegistration);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(PWAPrompt, null), os.current.family?.includes('iOS') ? /*#__PURE__*/React__default.createElement(PWAPrompt, null) : /*#__PURE__*/React__default.createElement(Modal, {
    isOpen: !!(serviceWorkerInitialized && !dismissedOfflineNotification),
    title: "Did you know?",
    content: /*#__PURE__*/React__default.createElement("div", {
      className: "w-full"
    }, /*#__PURE__*/React__default.createElement("p", null, "You can visit this site and play back music even when you are offline!")),
    confirmLabel: "Okay",
    icon: /*#__PURE__*/React__default.createElement(ForwardRef$2, {
      className: "h-6 w-6 text-primary",
      "aria-hidden": "true"
    }),
    onConfirm: dismissOfflineNotification,
    onClose: () => {}
  }));
};

// Hook
function useWindowSize() {
  // Initialize state with undefined width/height so server and client renders match
  // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined
  });
  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    // Add event listener
    window.addEventListener("resize", handleResize);
    // Call handler right away so state gets updated with initial window size
    handleResize();
    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount
  return windowSize;
}

var css_248z$3 = ".screenWarning{align-items:center;background:#fff;bottom:0;display:flex;flex-direction:column;font-weight:700;justify-content:center;left:0;position:fixed;right:0;top:0;z-index:2000}.logo{margin:20px;width:150px}";
styleInject(css_248z$3,{"insertAt":"top"});

const ScreenRotationWarning = ({
  userInputtingText,
  logoImageUrl
}) => {
  const screenSize = useWindowSize();
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !userInputtingText && screenSize.height < 300 && /*#__PURE__*/React__default.createElement("div", {
    className: "screenWarning"
  }, /*#__PURE__*/React__default.createElement("img", {
    className: "logo",
    src: logoImageUrl,
    alt: "Logo"
  }), /*#__PURE__*/React__default.createElement("h3", null, "Please rotate your screen to portrait")));
};

const ErrorModalContainer = () => {
  const error = useSelector(selectError);
  const dispatch = useDispatch();
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Modal, {
    isOpen: error?.text ? true : false,
    title: error ? error.title : '',
    text: /*#__PURE__*/React__default.createElement("p", null, error ? error.text : '')
    // confirmLabel="Okay"
    // icon={<ExclamationIcon className="h-20 w-20 text-primary" aria-hidden="true" />}
    ,
    onConfirm: () => dispatch(setError(null)),
    onClose: () => dispatch(setError(null)),
    closeLabel: "Close"
  }));
};

const MediaSession = () => {
  const dispatch = useDispatch();
  const playbackState = useSelector(selectPlaybackState);
  const session = useSelector(selectSession);
  const mediaSessionStarted = useSelector(selectMediaSessionStarted);
  const clientConfig = useSelector(selectClientConfig);
  const play = () => {};
  const pause = () => {};
  const stop = () => {};
  const startMediaSession = () => {
    navigator.mediaSession.setActionHandler('play', play);
    navigator.mediaSession.setActionHandler('pause', pause);
    navigator.mediaSession.setActionHandler('stop', stop);
    dispatch(setMediaSessionStarted(true));
  };
  useEffect(() => {
    if (session?.song) {
      if ('mediaSession' in navigator) {
        if (!mediaSessionStarted) startMediaSession();

        // pgw 22-apr-2023
        // Remove redundant artwork
        navigator.mediaSession.metadata = new MediaMetadata({
          title: session.song.mix,
          artist: session.song.artist,
          album: clientConfig.labels.appTitle
          /*
                              album: clientConfig.labels.appTitle,
                              artwork: [
                                { src: clientConfig.images.albumArt, sizes: '512x512', type: 'image/png' },
                              ]
          */
        });
      }
    }
  }, [session]);
  useEffect(() => {
    if ('mediaSession' in navigator) {
      if (playbackState === 'playing') {
        navigator.mediaSession.playbackState = "playing";
      } else {
        navigator.mediaSession.playbackState = "paused";
      }
    }
  }, [playbackState]);
  return null;
};

var css_248z$2 = ".App{-ms-overflow-style:auto;height:var(--window-inner-height);overflow:hidden;scrollbar-color:var(--theme-primary-color) #27272a;scrollbar-width:thin;touch-action:none;-webkit-user-select:none;user-select:none}.dark{background:#1a1a1a}:not(input){-webkit-user-select:none;user-select:none}:focus-visible{outline:none}";
styleInject(css_248z$2,{"insertAt":"top"});

var css_248z$1 = "html{background:#fff;margin:0}body{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;display:flex;flex-direction:column;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif;height:100vh;height:-webkit-fill-available;margin:0;overflow:hidden;touch-action:none}*{-webkit-tap-highlight-color:rgba(0,0,0,0)}img{pointer-events:none!important}code{font-family:source-code-pro,Menlo,Monaco,Consolas,Courier New,monospace}";
styleInject(css_248z$1,{"insertAt":"top"});

var css_248z = "";
styleInject(css_248z,{"insertAt":"top"});

const LoggingInModal = ({
  loginLogo
}) => {
  const renderContent = () => {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "flex flex-col align-center justify-center text-center"
    }, /*#__PURE__*/React__default.createElement("img", {
      src: loginLogo,
      alt: "Choir Player",
      className: "h-20"
    }), /*#__PURE__*/React__default.createElement("h1", {
      className: "text-xl font-bold m-4"
    }, "Logging in..."), /*#__PURE__*/React__default.createElement("div", {
      className: "flex justify-center mt-4"
    }, /*#__PURE__*/React__default.createElement(Spinner, null)));
  };
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: 0,
      top: 0,
      background: 'white'
    }
  }, /*#__PURE__*/React__default.createElement(Modal, {
    isOpen: true,
    content: renderContent(),
    onClose: () => {}
  }));
};

var noSleep = {exports: {}};

/*! NoSleep.js v0.12.0 - git.io/vfn01 - Rich Tibbett - MIT license */

(function (module, exports) {
	(function webpackUniversalModuleDefinition(root, factory) {
	  module.exports = factory();
	})(commonjsGlobal$1, function () {
	  return /******/function (modules) {
	    // webpackBootstrap
	    /******/ // The module cache
	    /******/
	    var installedModules = {};
	    /******/
	    /******/ // The require function
	    /******/
	    function __webpack_require__(moduleId) {
	      /******/
	      /******/ // Check if module is in cache
	      /******/if (installedModules[moduleId]) {
	        /******/return installedModules[moduleId].exports;
	        /******/
	      }
	      /******/ // Create a new module (and put it into the cache)
	      /******/
	      var module = installedModules[moduleId] = {
	        /******/i: moduleId,
	        /******/l: false,
	        /******/exports: {}
	        /******/
	      };
	      /******/
	      /******/ // Execute the module function
	      /******/
	      modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	      /******/
	      /******/ // Flag the module as loaded
	      /******/
	      module.l = true;
	      /******/
	      /******/ // Return the exports of the module
	      /******/
	      return module.exports;
	      /******/
	    }
	    /******/
	    /******/
	    /******/ // expose the modules object (__webpack_modules__)
	    /******/
	    __webpack_require__.m = modules;
	    /******/
	    /******/ // expose the module cache
	    /******/
	    __webpack_require__.c = installedModules;
	    /******/
	    /******/ // define getter function for harmony exports
	    /******/
	    __webpack_require__.d = function (exports, name, getter) {
	      /******/if (!__webpack_require__.o(exports, name)) {
	        /******/Object.defineProperty(exports, name, {
	          enumerable: true,
	          get: getter
	        });
	        /******/
	      }
	      /******/
	    };
	    /******/
	    /******/ // define __esModule on exports
	    /******/
	    __webpack_require__.r = function (exports) {
	      /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	        /******/Object.defineProperty(exports, Symbol.toStringTag, {
	          value: 'Module'
	        });
	        /******/
	      }
	      /******/
	      Object.defineProperty(exports, '__esModule', {
	        value: true
	      });
	      /******/
	    };
	    /******/
	    /******/ // create a fake namespace object
	    /******/ // mode & 1: value is a module id, require it
	    /******/ // mode & 2: merge all properties of value into the ns
	    /******/ // mode & 4: return value when already ns object
	    /******/ // mode & 8|1: behave like require
	    /******/
	    __webpack_require__.t = function (value, mode) {
	      /******/if (mode & 1) value = __webpack_require__(value);
	      /******/
	      if (mode & 8) return value;
	      /******/
	      if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
	      /******/
	      var ns = Object.create(null);
	      /******/
	      __webpack_require__.r(ns);
	      /******/
	      Object.defineProperty(ns, 'default', {
	        enumerable: true,
	        value: value
	      });
	      /******/
	      if (mode & 2 && typeof value != 'string') for (var key in value) __webpack_require__.d(ns, key, function (key) {
	        return value[key];
	      }.bind(null, key));
	      /******/
	      return ns;
	      /******/
	    };
	    /******/
	    /******/ // getDefaultExport function for compatibility with non-harmony modules
	    /******/
	    __webpack_require__.n = function (module) {
	      /******/var getter = module && module.__esModule ? /******/function getDefault() {
	        return module['default'];
	      } : /******/function getModuleExports() {
	        return module;
	      };
	      /******/
	      __webpack_require__.d(getter, 'a', getter);
	      /******/
	      return getter;
	      /******/
	    };
	    /******/
	    /******/ // Object.prototype.hasOwnProperty.call
	    /******/
	    __webpack_require__.o = function (object, property) {
	      return Object.prototype.hasOwnProperty.call(object, property);
	    };
	    /******/
	    /******/ // __webpack_public_path__
	    /******/
	    __webpack_require__.p = "";
	    /******/
	    /******/
	    /******/ // Load entry module and return exports
	    /******/
	    return __webpack_require__(__webpack_require__.s = 0);
	    /******/
	  }
	  /************************************************************************/
	  /******/([( /* 0 */
	  /***/function (module, exports, __webpack_require__) {

	    var _createClass = function () {
	      function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	          var descriptor = props[i];
	          descriptor.enumerable = descriptor.enumerable || false;
	          descriptor.configurable = true;
	          if ("value" in descriptor) descriptor.writable = true;
	          Object.defineProperty(target, descriptor.key, descriptor);
	        }
	      }
	      return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);
	        if (staticProps) defineProperties(Constructor, staticProps);
	        return Constructor;
	      };
	    }();
	    function _classCallCheck(instance, Constructor) {
	      if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	      }
	    }
	    var _require = __webpack_require__(1),
	      webm = _require.webm,
	      mp4 = _require.mp4;

	    // Detect iOS browsers < version 10

	    var oldIOS = function oldIOS() {
	      return typeof navigator !== "undefined" && parseFloat(("" + (/CPU.*OS ([0-9_]{3,4})[0-9_]{0,1}|(CPU like).*AppleWebKit.*Mobile/i.exec(navigator.userAgent) || [0, ""])[1]).replace("undefined", "3_2").replace("_", ".").replace("_", "")) < 10 && !window.MSStream;
	    };

	    // Detect native Wake Lock API support
	    var nativeWakeLock = function nativeWakeLock() {
	      return "wakeLock" in navigator;
	    };
	    var NoSleep = function () {
	      function NoSleep() {
	        var _this = this;
	        _classCallCheck(this, NoSleep);
	        this.enabled = false;
	        if (nativeWakeLock()) {
	          this._wakeLock = null;
	          var handleVisibilityChange = function handleVisibilityChange() {
	            if (_this._wakeLock !== null && document.visibilityState === "visible") {
	              _this.enable();
	            }
	          };
	          document.addEventListener("visibilitychange", handleVisibilityChange);
	          document.addEventListener("fullscreenchange", handleVisibilityChange);
	        } else if (oldIOS()) {
	          this.noSleepTimer = null;
	        } else {
	          // Set up no sleep video element
	          this.noSleepVideo = document.createElement("video");
	          this.noSleepVideo.setAttribute("title", "No Sleep");
	          this.noSleepVideo.setAttribute("playsinline", "");
	          this._addSourceToVideo(this.noSleepVideo, "webm", webm);
	          this._addSourceToVideo(this.noSleepVideo, "mp4", mp4);
	          this.noSleepVideo.addEventListener("loadedmetadata", function () {
	            if (_this.noSleepVideo.duration <= 1) {
	              // webm source
	              _this.noSleepVideo.setAttribute("loop", "");
	            } else {
	              // mp4 source
	              _this.noSleepVideo.addEventListener("timeupdate", function () {
	                if (_this.noSleepVideo.currentTime > 0.5) {
	                  _this.noSleepVideo.currentTime = Math.random();
	                }
	              });
	            }
	          });
	        }
	      }
	      _createClass(NoSleep, [{
	        key: "_addSourceToVideo",
	        value: function _addSourceToVideo(element, type, dataURI) {
	          var source = document.createElement("source");
	          source.src = dataURI;
	          source.type = "video/" + type;
	          element.appendChild(source);
	        }
	      }, {
	        key: "enable",
	        value: function enable() {
	          var _this2 = this;
	          if (nativeWakeLock()) {
	            return navigator.wakeLock.request("screen").then(function (wakeLock) {
	              _this2._wakeLock = wakeLock;
	              _this2.enabled = true;
	              // console.log("Wake Lock active.");
	              _this2._wakeLock.addEventListener("release", function () {
	                // ToDo: Potentially emit an event for the page to observe since
	                // Wake Lock releases happen when page visibility changes.
	                // (https://web.dev/wakelock/#wake-lock-lifecycle)
	                // console.log("Wake Lock released.");
	              });
	            }).catch(function (err) {
	              _this2.enabled = false;
	              console.error(err.name + ", " + err.message);
	              throw err;
	            });
	          } else if (oldIOS()) {
	            this.disable();
	            console.warn("\n        NoSleep enabled for older iOS devices. This can interrupt\n        active or long-running network requests from completing successfully.\n        See https://github.com/richtr/NoSleep.js/issues/15 for more details.\n      ");
	            this.noSleepTimer = window.setInterval(function () {
	              if (!document.hidden) {
	                window.location.href = window.location.href.split("#")[0];
	                window.setTimeout(window.stop, 0);
	              }
	            }, 15000);
	            this.enabled = true;
	            return Promise.resolve();
	          } else {
	            var playPromise = this.noSleepVideo.play();
	            return playPromise.then(function (res) {
	              _this2.enabled = true;
	              return res;
	            }).catch(function (err) {
	              _this2.enabled = false;
	              throw err;
	            });
	          }
	        }
	      }, {
	        key: "disable",
	        value: function disable() {
	          if (nativeWakeLock()) {
	            if (this._wakeLock) {
	              this._wakeLock.release();
	            }
	            this._wakeLock = null;
	          } else if (oldIOS()) {
	            if (this.noSleepTimer) {
	              console.warn("\n          NoSleep now disabled for older iOS devices.\n        ");
	              window.clearInterval(this.noSleepTimer);
	              this.noSleepTimer = null;
	            }
	          } else {
	            this.noSleepVideo.pause();
	          }
	          this.enabled = false;
	        }
	      }, {
	        key: "isEnabled",
	        get: function get() {
	          return this.enabled;
	        }
	      }]);
	      return NoSleep;
	    }();
	    module.exports = NoSleep;

	    /***/
	  }), ( /* 1 */
	  /***/function (module, exports, __webpack_require__) {

	    module.exports = {
	      webm: "data:video/webm;base64,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",
	      mp4: "data:video/mp4;base64,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"
	    };

	    /***/
	  }
	  /******/)]);
	});
} (noSleep));

var NoSleep = /*@__PURE__*/getDefaultExportFromCjs(noSleep.exports);

const NoSleepContainer = () => {
  const noSleep = useRef();
  useEffect(() => {
    noSleep.current = new NoSleep();
    document.addEventListener('click', function enableNoSleep() {
      document.removeEventListener('click', enableNoSleep, false);
      noSleep.current.enable();
    }, false);
    return () => {
      noSleep.current.disable();
      noSleep.current = null;
    };
  }, []);
  return null;
};

function App({
  parentVersion,
  clientConfig
}) {
  const platformName = useRef(platform.name);
  const notifications = useSelector(selectNotifications);
  const clientConfiguration = useSelector(selectClientConfig);
  const authStatus = useSelector(selectStatus$1);
  useSelector(selectUser);
  const userInputtingText = useSelector(selectUserInputtingText);
  const appStarted = useSelector(selectAppStarted);
  const offlineModalVisible = useSelector(selectOfflineModalVisible);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(setAppStarted(false));
    dispatch(setOfflineModalVisible(false));
    ReactGA.initialize(clientConfig.features.analytics.token);
    document.documentElement.style.setProperty('--theme-primary-color', clientConfig.theme.colours.primary);
    document.documentElement.style.setProperty('--theme-primary-alt-color', clientConfig.theme.colours.primaryAlt);
    window.addEventListener('resize', syncHeight);
    document.body.addEventListener('resize', syncHeight);
    syncHeight();
    dispatch(resetNotifications());
    ReactGA.send("pageview");
    dispatch(setClientConfig(clientConfig));
    dispatch(setUserInputtingText(false));
    dispatch(setParentVersion(parentVersion));
    setTimeout(() => dispatch(setAppStarted(true)), 1000);
  }, []);
  useEffect(() => {
    if (clientConfig) {
      if (clientConfig.features.auth.mode === "domainCookie") {
        const session_id = api.get(clientConfig.features.auth.domainCookie.cookieId);
        if (session_id) {
          // check endpoint to see if logged in AND subscription status
          dispatch(setSubscribedAsync(session_id));
        } else {
          // console.log('Nobody is logged in , so setting to default guest')
          dispatch(setAuth(clientConfig.features.auth.domainCookie.loggedOutState));
        }
      }
    }
  }, [clientConfig]);
  const isValidApple = () => {
    const products = ['iPhone', 'iPad'];
    try {
      if (products.includes(platform.product) && platform.version) {
        if (Number(platform.version?.split('.')[0]) < 15) {
          return false;
        }
      } else if (platform.os?.family === 'OS X' && navigator.maxTouchPoints) {
        // is iPad
        if (Number(platform.version?.split('.')[0]) < 15) {
          return false;
        }
      }
    } catch (e) {}
    return true;
  };
  const renderApp = () => {
    switch (authStatus) {
      case 'pending':
        return /*#__PURE__*/React__default.createElement(LoggingInModal, {
          loginLogo: `${process.env.PUBLIC_URL}${clientConfiguration.images.loginLogo}`
        });
      case 'fulfilled':
      case 'initial':
        if (!clientConfiguration?.logic?.deniedBrowsers?.includes(platformName.current) && isValidApple()) {
          return /*#__PURE__*/React__default.createElement(Routes, null, clientConfiguration.features.auth.mode === 'postSubmission' && /*#__PURE__*/React__default.createElement(Route, {
            path: "/",
            element: /*#__PURE__*/React__default.createElement(LoginPage, null)
          }), /*#__PURE__*/React__default.createElement(Route, {
            path: "*",
            element: /*#__PURE__*/React__default.createElement(Authenticated, {
              parentVersion: parentVersion || PackageJSON.version
            })
          }));
        } else {
          return /*#__PURE__*/React__default.createElement(NotSupportedSplash, {
            platform: platform.product,
            logoUrl: clientConfiguration.images.loginLogo
          });
        }
    }
  };
  return clientConfiguration ? /*#__PURE__*/React__default.createElement("div", {
    className: `App ${clientConfiguration.theme.darkMode ? 'dark' : ''}`
  }, appStarted ? renderApp() : /*#__PURE__*/React__default.createElement(Modal, {
    onClose: () => {},
    content: /*#__PURE__*/React__default.createElement("p", {
      className: "flex justify-center text-center"
    }, /*#__PURE__*/React__default.createElement(Spinner, null)),
    isOpen: true
  }), notifications.map(n => /*#__PURE__*/React__default.createElement(Notification, {
    key: n.id,
    type: n.type,
    title: n.title,
    text: n.text
  })), /*#__PURE__*/React__default.createElement(ScreenRotationWarning, {
    logoImageUrl: `${process.env.PUBLIC_URL}${clientConfiguration.images.loginLogo}`,
    userInputtingText: userInputtingText
  }), /*#__PURE__*/React__default.createElement(OfflineVersioning, null), /*#__PURE__*/React__default.createElement(ErrorModalContainer, null), /*#__PURE__*/React__default.createElement(NoSleepContainer, null), /*#__PURE__*/React__default.createElement(MediaSession, null), /*#__PURE__*/React__default.createElement(OfflineModal, {
    onClose: () => {
      navigate('/setlists');
      dispatch(setOfflineModalVisible(false));
    },
    isOpen: offlineModalVisible
  })) : /*#__PURE__*/React__default.createElement("div", null);
}

const Player = ({
  parentVersion,
  clientConfig
}) => {
  const styles = {
    maskWrapper: base => ({
      ...base,
      color: 'black',
      opacity: 0.8
    }),
    popover: base => ({
      ...base,
      borderRadius: 5,
      margin: 5
    }),
    dot: base => ({
      ...base,
      background: clientConfig.theme.colours.primary
    }),
    badge: base => ({
      ...base,
      background: clientConfig.theme.colours.primary
    })
  };
  return /*#__PURE__*/React__default.createElement(Provider, {
    store: store
  }, /*#__PURE__*/React__default.createElement(PersistGate, {
    loading: null,
    persistor: persistor
  }, /*#__PURE__*/React__default.createElement(HashRouter, null, /*#__PURE__*/React__default.createElement(TourProvider, {
    showBadge: false,
    showCloseButton: true,
    padding: 0,
    wrapperPadding: 0,
    styles: styles
  }, /*#__PURE__*/React__default.createElement(App, {
    parentVersion: parentVersion,
    clientConfig: clientConfig
  })))));
};

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
register({
  onSuccess: () => store.dispatch(setServiceWorkerInitialized(true)),
  onUpdate: reg => store.dispatch(updateServiceWorker(reg))
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

// todo - replace with react-ga4 call and pass into reportWebVitals
// function sendToAnalytics({ id, name, value }) {
//   ga('send', 'event', {
//     eventCategory: 'Web Vitals',
//     eventAction: name,
//     eventValue: Math.round(name === 'CLS' ? value * 1000 : value), // values must be integers
//     eventLabel: id, // id unique to current page load
//     nonInteraction: true, // avoids affecting bounce rate
//   });
// }

reportWebVitals();

var t,
  n,
  e = function () {
    return "".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12);
  },
  i = function (t) {
    var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : -1;
    return {
      name: t,
      value: n,
      delta: 0,
      entries: [],
      id: e(),
      isFinal: !1
    };
  },
  a = function (t, n) {
    try {
      if (PerformanceObserver.supportedEntryTypes.includes(t)) {
        var e = new PerformanceObserver(function (t) {
          return t.getEntries().map(n);
        });
        return e.observe({
          type: t,
          buffered: !0
        }), e;
      }
    } catch (t) {}
  },
  r = !1,
  o = !1,
  s = function (t) {
    r = !t.persisted;
  },
  u = function () {
    addEventListener("pagehide", s), addEventListener("beforeunload", function () {});
  },
  c = function (t) {
    var n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
    o || (u(), o = !0), addEventListener("visibilitychange", function (n) {
      var e = n.timeStamp;
      "hidden" === document.visibilityState && t({
        timeStamp: e,
        isUnloading: r
      });
    }, {
      capture: !0,
      once: n
    });
  },
  l = function (t, n, e, i) {
    var a;
    return function () {
      e && n.isFinal && e.disconnect(), n.value >= 0 && (i || n.isFinal || "hidden" === document.visibilityState) && (n.delta = n.value - (a || 0), (n.delta || n.isFinal || void 0 === a) && (t(n), a = n.value));
    };
  },
  p = function (t) {
    var n,
      e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
      r = i("CLS", 0),
      o = function (t) {
        t.hadRecentInput || (r.value += t.value, r.entries.push(t), n());
      },
      s = a("layout-shift", o);
    s && (n = l(t, r, s, e), c(function (t) {
      var e = t.isUnloading;
      s.takeRecords().map(o), e && (r.isFinal = !0), n();
    }));
  },
  d = function () {
    return void 0 === t && (t = "hidden" === document.visibilityState ? 0 : 1 / 0, c(function (n) {
      var e = n.timeStamp;
      return t = e;
    }, !0)), {
      get timeStamp() {
        return t;
      }
    };
  },
  v = function (t) {
    var n,
      e = i("FCP"),
      r = d(),
      o = a("paint", function (t) {
        "first-contentful-paint" === t.name && t.startTime < r.timeStamp && (e.value = t.startTime, e.isFinal = !0, e.entries.push(t), n());
      });
    o && (n = l(t, e, o));
  },
  f = function (t) {
    var n = i("FID"),
      e = d(),
      r = function (t) {
        t.startTime < e.timeStamp && (n.value = t.processingStart - t.startTime, n.entries.push(t), n.isFinal = !0, s());
      },
      o = a("first-input", r),
      s = l(t, n, o);
    o ? c(function () {
      o.takeRecords().map(r), o.disconnect();
    }, !0) : window.perfMetrics && window.perfMetrics.onFirstInputDelay && window.perfMetrics.onFirstInputDelay(function (t, i) {
      i.timeStamp < e.timeStamp && (n.value = t, n.isFinal = !0, n.entries = [{
        entryType: "first-input",
        name: i.type,
        target: i.target,
        cancelable: i.cancelable,
        startTime: i.timeStamp,
        processingStart: i.timeStamp + t
      }], s());
    });
  },
  m = function () {
    return n || (n = new Promise(function (t) {
      return ["scroll", "keydown", "pointerdown"].map(function (n) {
        addEventListener(n, t, {
          once: !0,
          passive: !0,
          capture: !0
        });
      });
    })), n;
  },
  g = function (t) {
    var n,
      e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
      r = i("LCP"),
      o = d(),
      s = function (t) {
        var e = t.startTime;
        e < o.timeStamp ? (r.value = e, r.entries.push(t)) : r.isFinal = !0, n();
      },
      u = a("largest-contentful-paint", s);
    if (u) {
      n = l(t, r, u, e);
      var p = function () {
        r.isFinal || (u.takeRecords().map(s), r.isFinal = !0, n());
      };
      m().then(p), c(p, !0);
    }
  },
  h = function (t) {
    var n,
      e = i("TTFB");
    n = function () {
      try {
        var n = performance.getEntriesByType("navigation")[0] || function () {
          var t = performance.timing,
            n = {
              entryType: "navigation",
              startTime: 0
            };
          for (var e in t) "navigationStart" !== e && "toJSON" !== e && (n[e] = Math.max(t[e] - t.navigationStart, 0));
          return n;
        }();
        e.value = e.delta = n.responseStart, e.entries = [n], e.isFinal = !0, t(e);
      } catch (t) {}
    }, "complete" === document.readyState ? setTimeout(n, 0) : addEventListener("pageshow", n);
  };

var webVitals_es5_min = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getCLS: p,
  getFCP: v,
  getFID: f,
  getLCP: g,
  getTTFB: h
});

export { Player as default };
